/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lieutenant/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 739);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(746);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(757)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoControlledComponent__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoControlledComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModernAutoControlledComponent__ = __webpack_require__(913);
/* unused harmony reexport ModernAutoControlledComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__childMapping__ = __webpack_require__(914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__childMapping__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__childMapping__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__childrenUtils__ = __webpack_require__(922);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__childrenUtils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__ = __webpack_require__(925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_4__classNameBuilders__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customPropTypes__ = __webpack_require__(926);
/* unused harmony reexport customPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventStack__ = __webpack_require__(1002);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__eventStack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__factories__ = __webpack_require__(1005);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getUnhandledProps__ = __webpack_require__(1009);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__getUnhandledProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getElementType__ = __webpack_require__(1010);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_9__getElementType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__ = __webpack_require__(1011);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__["b"]; });
/* unused harmony reexport htmlInputEvents */
/* unused harmony reexport htmlInputProps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isBrowser__ = __webpack_require__(1013);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_11__isBrowser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__doesNodeContainClick__ = __webpack_require__(1014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__doesNodeContainClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__leven__ = __webpack_require__(440);
/* unused harmony reexport leven */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__createPaginationItems__ = __webpack_require__(1018);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_14__createPaginationItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SUI__ = __webpack_require__(1026);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__SUI__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__numberToWord__ = __webpack_require__(260);
/* unused harmony reexport numberToWordMap */
/* unused harmony reexport numberToWord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__normalizeOffset__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_17__normalizeOffset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__normalizeTransitionDuration__ = __webpack_require__(1028);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_18__normalizeTransitionDuration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__objectDiff__ = __webpack_require__(1029);
/* unused harmony reexport objectDiff */


































 // Heads up! We import/export for this module to safely remove it with "babel-plugin-filter-imports"

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(9);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(145);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["g" /* withStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(321);
/* unused harmony reexport chainPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(1268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__deepmerge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(1269);
/* unused harmony reexport elementAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(1270);
/* unused harmony reexport elementTypeAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(1271);
/* unused harmony reexport exactProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__ = __webpack_require__(1272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getDisplayName__ = __webpack_require__(1273);
/* unused harmony reexport getDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HTMLElementType__ = __webpack_require__(1274);
/* unused harmony reexport HTMLElementType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ponyfillGlobal__ = __webpack_require__(1275);
/* unused harmony reexport ponyfillGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__refType__ = __webpack_require__(1276);
/* unused harmony reexport refType */
/** @license Material-UI v4.10.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useBootstrapPrefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBootstrapComponent; });
/* unused harmony export ThemeConsumer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__restart_context_forwardRef__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__restart_context_forwardRef___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__restart_context_forwardRef__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




var ThemeContext = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createContext(new Map());
var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;

var ThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ThemeProvider, _React$Component);

  function ThemeProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.prefixes = new Map();
    Object.keys(_this.props.prefixes).forEach(function (key) {
      _this.prefixes.set(key, _this.props.prefixes[key]);
    });
    return _this;
  }

  var _proto = ThemeProvider.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Provider, {
      value: this.prefixes
    }, this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

function useBootstrapPrefix(prefix, defaultPrefix) {
  var prefixes = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ThemeContext);
  return prefix || prefixes.get(defaultPrefix) || defaultPrefix;
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  return __WEBPACK_IMPORTED_MODULE_2__restart_context_forwardRef___default()(function (_ref, ref) {
    var props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _ref);

    props[forwardRefAs] = ref;
    var prefixes = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ThemeContext);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      // eslint-disable-next-line react/prop-types
      bsPrefix: props.bsPrefix || prefixes.get(prefix) || prefix
    }));
  }, {
    displayName: "Bootstrap(" + (Component.displayName || Component.name) + ")"
  });
}


/* unused harmony default export */ var _unused_webpack_default_export = (ThemeProvider);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(121);

var assertThisInitialized = __webpack_require__(12);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(853);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var baseInvoke = __webpack_require__(880),
    baseRest = __webpack_require__(80);

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

module.exports = invoke;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(10);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(747);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(433),
    baseRest = __webpack_require__(80),
    isArrayLikeObject = __webpack_require__(130);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(11);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(931),
    util = __webpack_require__(933);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71),
    baseIteratee = __webpack_require__(49),
    baseMap = __webpack_require__(437),
    isArray = __webpack_require__(26);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useForkRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setRef__ = __webpack_require__(96);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refA, refValue);
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.useBootstrapPrefix = useBootstrapPrefix;
exports.createBootstrapComponent = createBootstrapComponent;
exports.default = exports.ThemeConsumer = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));

var _forwardRef = _interopRequireDefault(__webpack_require__(233));

var _react = _interopRequireWildcard(__webpack_require__(0));

var ThemeContext = _react.default.createContext(new Map());

var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;
exports.ThemeConsumer = Consumer;

var ThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(ThemeProvider, _React$Component);

  function ThemeProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.prefixes = new Map();
    Object.keys(_this.props.prefixes).forEach(function (key) {
      _this.prefixes.set(key, _this.props.prefixes[key]);
    });
    return _this;
  }

  var _proto = ThemeProvider.prototype;

  _proto.render = function render() {
    return _react.default.createElement(Provider, {
      value: this.prefixes
    }, this.props.children);
  };

  return ThemeProvider;
}(_react.default.Component);

function useBootstrapPrefix(prefix, defaultPrefix) {
  var prefixes = (0, _react.useContext)(ThemeContext);
  return prefix || prefixes.get(defaultPrefix) || defaultPrefix;
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  return (0, _forwardRef.default)(function (_ref, ref) {
    var props = (0, _extends2.default)({}, _ref);
    props[forwardRefAs] = ref;
    var prefixes = (0, _react.useContext)(ThemeContext);
    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      // eslint-disable-next-line react/prop-types
      bsPrefix: props.bsPrefix || prefixes.get(prefix) || prefix
    }));
  }, {
    displayName: "Bootstrap(" + (Component.displayName || Component.name) + ")"
  });
}

var _default = ThemeProvider;
exports.default = _default;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWithBsPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_util_camelize__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_util_camelize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_util_camelize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);







var pascalCase = function pascalCase(str) {
  return str[0].toUpperCase() + __WEBPACK_IMPORTED_MODULE_4_dom_helpers_util_camelize___default()(str).slice(1);
};

function createWithBsPrefix(prefix, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? 'div' : _ref$Component,
      defaultProps = _ref.defaultProps;

  var BsComponent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // eslint-disable-next-line react/prop-types
  function (_ref2, ref) {
    var className = _ref2.className,
        bsPrefix = _ref2.bsPrefix,
        _ref2$as = _ref2.as,
        Tag = _ref2$as === void 0 ? Component : _ref2$as,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["className", "bsPrefix", "as"]);

    var resolvedPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, prefix);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, resolvedPrefix)
    }, props));
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(145);



function useTheme() {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["f" /* useTheme */])() || __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */];

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hexToRgb */
/* unused harmony export rgbToHex */
/* unused harmony export hslToRgb */
/* unused harmony export decomposeColor */
/* unused harmony export recomposeColor */
/* harmony export (immutable) */ __webpack_exports__["d"] = getContrastRatio;
/* unused harmony export getLuminance */
/* harmony export (immutable) */ __webpack_exports__["b"] = emphasize;
/* harmony export (immutable) */ __webpack_exports__["c"] = fade;
/* harmony export (immutable) */ __webpack_exports__["a"] = darken;
/* harmony export (immutable) */ __webpack_exports__["e"] = lighten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(10);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handleRef__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__handleRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isRefObject__ = __webpack_require__(846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__isRefObject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toRefObject__ = __webpack_require__(847);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__toRefObject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ref__ = __webpack_require__(848);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Ref__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RefFindNode__ = __webpack_require__(380);
/* unused harmony reexport RefFindNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RefForward__ = __webpack_require__(381);
/* unused harmony reexport RefForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(160);
/* unused harmony namespace reexport */








/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(849);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });



/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonBase__ = __webpack_require__(1355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ButtonBase__["a"]; });


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(383);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSvgIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgIcon__ = __webpack_require__(213);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref
    }, props), path);
  };

  if (false) {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */].muiName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(Component));
}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(395),
    baseKeys = __webpack_require__(172),
    isArrayLike = __webpack_require__(58);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(890),
    baseMatchesProperty = __webpack_require__(905),
    identity = __webpack_require__(65),
    isArray = __webpack_require__(26),
    property = __webpack_require__(907);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__ = __webpack_require__(210);
/* unused harmony reexport createGenerateClassName */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__createStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getThemeProps__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__getThemeProps__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jssPreset__ = __webpack_require__(325);
/* unused harmony reexport jssPreset */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__makeStyles__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__makeStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeClasses__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__mergeClasses__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__ = __webpack_require__(632);
/* unused harmony reexport ServerStyleSheets */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__styled__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StylesProvider__ = __webpack_require__(212);
/* unused harmony reexport StylesProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(634);
/* unused harmony reexport ThemeProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useTheme__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__useTheme__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withStyles__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__withStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withTheme__ = __webpack_require__(636);
/* unused harmony reexport withTheme */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_13__withTheme__["a"]; });
/** @license Material-UI v4.10.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */

/* Warning if there are several instances of @material-ui/styles */

if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}




























/***/ }),
/* 51 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(373);
var isBuffer = __webpack_require__(816);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(622);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paper__ = __webpack_require__(1351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paper__["a"]; });


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Typography__ = __webpack_require__(1369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Typography__["a"]; });


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    getRawTag = __webpack_require__(855),
    objectToString = __webpack_require__(856);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(79),
    isLength = __webpack_require__(250);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(167);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useCommittedRef__ = __webpack_require__(784);


function useEventCallback(fn) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1__useCommittedRef__["a" /* default */])(fn);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(165);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(927);

var iterableToArray = __webpack_require__(928);

var nonIterableSpread = __webpack_require__(929);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeEventKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SelectableContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
var makeEventKey = function makeEventKey(eventKey, href) {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ __webpack_exports__["a"] = (SelectableContext);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(323);




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, value);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export easing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["duration", "easing", "delay"]);

    if (false) {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(756);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(361);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(763);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(765);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(767);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(228);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(771);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(773);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(775);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(776);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(252);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Label__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_Checkbox__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addons_Radio__ = __webpack_require__(276);











/**
 * A field is a form element containing a label and an input.
 * @see Form
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Radio
 * @see Select
 * @see Visibility
 */

function FormField(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      control = props.control,
      disabled = props.disabled,
      error = props.error,
      inline = props.inline,
      label = props.label,
      required = props.required,
      type = props.type,
      width = props.width,
      id = props.id;
  var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_7__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_7__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_7__lib__["y" /* useKeyOnly */])(inline, 'inline'), Object(__WEBPACK_IMPORTED_MODULE_7__lib__["y" /* useKeyOnly */])(required, 'required'), Object(__WEBPACK_IMPORTED_MODULE_7__lib__["E" /* useWidthProp */])(width, 'wide'), 'field', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["q" /* getUnhandledProps */])(FormField, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["p" /* getElementType */])(FormField, props);

  var errorPointing = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, 'pointing', 'above');

  var errorLabel = __WEBPACK_IMPORTED_MODULE_8__elements_Label__["a" /* default */].create(error, {
    autoGenerateKey: false,
    defaultProps: {
      prompt: true,
      pointing: errorPointing,
      id: id ? "".concat(id, "-error-message") : undefined,
      role: 'alert',
      'aria-atomic': true
    }
  });
  var errorLabelBefore = (errorPointing === 'below' || errorPointing === 'right') && errorLabel;
  var errorLabelAfter = (errorPointing === 'above' || errorPointing === 'left') && errorLabel; // ----------------------------------------
  // No Control
  // ----------------------------------------

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(control)) {
    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(label)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_7__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), errorLabelBefore, Object(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* createHTMLLabel */])(label, {
      autoGenerateKey: false
    }), errorLabelAfter);
  } // ----------------------------------------
  // Checkbox/Radio Control
  // ----------------------------------------


  var ariaDescribedBy = id && error ? "".concat(id, "-error-message") : null;
  var ariaAttrs = {
    'aria-describedby': ariaDescribedBy,
    'aria-invalid': error !== undefined ? true : undefined
  };

  var controlProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, rest, {
    content: content,
    children: children,
    disabled: disabled,
    required: required,
    type: type,
    id: id // wrap HTML checkboxes/radios in the label

  });

  if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, {
      className: classes
    }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("label", null, errorLabelBefore, Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(control, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, ariaAttrs, controlProps)), " ", label, errorLabelAfter));
  } // pass label prop to controls that support it


  if (control === __WEBPACK_IMPORTED_MODULE_9__modules_Checkbox__["a" /* default */] || control === __WEBPACK_IMPORTED_MODULE_10__addons_Radio__["a" /* default */]) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, {
      className: classes
    }, errorLabelBefore, Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(control, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, ariaAttrs, controlProps, {
      label: label
    })), errorLabelAfter);
  } // ----------------------------------------
  // Other Control
  // ----------------------------------------


  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, {
    className: classes
  }, Object(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* createHTMLLabel */])(label, {
    defaultProps: {
      htmlFor: id
    },
    autoGenerateKey: false
  }), errorLabelBefore, Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(control, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, ariaAttrs, controlProps)), errorLabelAfter);
}

FormField.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "id", "inline", "label", "required", "type", "width"];
FormField.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
   * Extra FormField props are passed to the control component.
   * Mutually exclusive with children.
   */
  control: customPropTypes.some([PropTypes.func, PropTypes.oneOf(['button', 'input', 'select', 'textarea'])]),

  /** Individual fields may be disabled. */
  disabled: PropTypes.bool,

  /** Individual fields may display an error state along with a message. */
  error: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** The id of the control */
  id: PropTypes.string,

  /** A field can have its label next to instead of above it. */
  inline: PropTypes.bool,
  // Heads Up!
  // Do not disallow children with `label` shorthand
  // The `control` might accept a `label` prop and `children`

  /** Mutually exclusive with children. */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A field can show that input is mandatory. */
  required: PropTypes.bool,

  /** Passed to the control component (i.e. <input type='password' />) */
  type: customPropTypes.every([customPropTypes.demand(['control'])]),

  /** A field can specify its width in grid columns */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__merge__ = __webpack_require__(209);



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__merge__["a" /* default */])(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (compose);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["uncontrollable"] = uncontrollable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hook_js__ = __webpack_require__(807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useUncontrolled", function() { return __WEBPACK_IMPORTED_MODULE_6__hook_js__["a"]; });







function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* canAcceptRef */](Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* defaultKey */]);
  !(canAcceptRef || !methods.length) ?  false ? invariant(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : __WEBPACK_IMPORTED_MODULE_4_invariant___default()(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* defaultKey */](key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* isProp */](nextProps, key) && __WEBPACK_IMPORTED_MODULE_5__utils__["c" /* isProp */](props, key)) {
          _this3._values[key] = nextProps[__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* defaultKey */](key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    innerRef: function innerRef() {}
  }, __WEBPACK_IMPORTED_MODULE_5__utils__["d" /* uncontrolledPropTypes */](controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef) {
    WrappedComponent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(UncontrolledComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        innerRef: ref
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
/* harmony default export */ __webpack_exports__["default"] = (uncontrollable);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObject = __webpack_require__(47);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(65),
    overRest = __webpack_require__(386),
    setToString = __webpack_require__(251);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(902),
    Map = __webpack_require__(249),
    Promise = __webpack_require__(903),
    Set = __webpack_require__(405),
    WeakMap = __webpack_require__(406),
    baseGetTag = __webpack_require__(57),
    toSource = __webpack_require__(385);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(915);

var iterableToArrayLimit = __webpack_require__(916);

var nonIterableRest = __webpack_require__(917);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(179),
    isArrayLike = __webpack_require__(58),
    isString = __webpack_require__(189),
    toInteger = __webpack_require__(72),
    values = __webpack_require__(137);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createChainedFunction__ = __webpack_require__(307);







function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$as = _this$props2.as,
        Component = _this$props2$as === void 0 ? 'a' : _this$props2$as,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        innerRef = _this$props2.innerRef,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["as", "disabled", "onKeyDown", "innerRef"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }

    if (innerRef) props.ref = innerRef;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_5__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(1284);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useControlled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(854),
    hasPath = __webpack_require__(382);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(44);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(861),
    getValue = __webpack_require__(864);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(88);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(170),
    createBaseEach = __webpack_require__(889);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleList; });
/* unused harmony export SheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SheetsRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return create; });
/* unused harmony export createGenerateId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDynamicStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasCSSTOMSupport; });
/* unused harmony export sheets */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toCssValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown';
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);
    if (!rule) return false;
    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}
/**
 * Set a style property.
 */


function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
}
/**
 * Remove a style property.
 */


function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
}
/**
 * Set the selector.
 */


function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
}
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    index = maxIndex;
  }

  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element);
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        // We need to render the container without children first.
        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), index);

        if (latestNativeParent === false) {
          return false;
        }
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    } // IE keeps the CSSStyleSheet after style node has been reattached,
    // so we need to check if the `renderable` reference the right style sheet and not
    // rerender those rules.


    if (rule.renderable && rule.renderable.parentStyleSheet === this.element.sheet) {
      return rule.renderable;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;

    var nativeRule = _insertRule(nativeParent, ruleStr, index);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    rule.renderable = nativeRule;
    return nativeRule;
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    var cssRules = this.element.sheet.cssRules;

    for (var index = 0; index < cssRules.length; index++) {
      if (cssRule === cssRules[index]) return index;
    }

    return -1;
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.4.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["a" /* default */] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowIgnore
      return this.createRule(undefined, name, style);
    } // $FlowIgnore


    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS !== 'undefined' && CSS && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

var index = create();

/* unused harmony default export */ var _unused_webpack_default_export = (index);



/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRef;
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormControlContext__ = __webpack_require__(220);


function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__FormControlContext__["a" /* default */]);
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(761);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = useUncontrolled;

var _extends3 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _react = __webpack_require__(0);

var Utils = _interopRequireWildcard(__webpack_require__(783));

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var defaultValue = result[Utils.defaultKey(fieldName)],
        propsValue = result[fieldName],
        rest = (0, _objectWithoutPropertiesLoose2.default)(result, [Utils.defaultKey(fieldName), fieldName].map(_toPropertyKey));
    var handlerName = config[fieldName];
    var prevProps = (0, _react.useRef)({});

    var _useState = (0, _react.useState)(defaultValue),
        stateValue = _useState[0],
        setState = _useState[1];

    var isProp = Utils.isProp(props, fieldName);
    var wasProp = Utils.isProp(prevProps.current, fieldName);
    prevProps.current = props;
    /**
     * If a prop switches from controlled to Uncontrolled
     * reset its value to the defaultValue
     */

    if (!isProp && wasProp) {
      setState(defaultValue);
    }

    var propsHandler = props[handlerName];
    var handler = (0, _react.useCallback)(function (value) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (propsHandler) propsHandler.apply(void 0, [value].concat(args));
      setState(value);
    }, [setState, propsHandler]);
    return (0, _extends3.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = isProp ? propsValue : stateValue, _extends2[handlerName] = handler, _extends2));
  }, props);
}

module.exports = exports["default"];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(366));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(790));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(792));

var _removeStyle = _interopRequireDefault(__webpack_require__(793));

var _properties = __webpack_require__(234);

var _isTransform = _interopRequireDefault(__webpack_require__(794));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var FormContext = _react.default.createContext({
  controlId: undefined
});

var _default = FormContext;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(44),
    stubFalse = __webpack_require__(886);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253)(module)))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(131),
    baseEach = __webpack_require__(92),
    castFunction = __webpack_require__(413),
    isArray = __webpack_require__(26);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(123),
    isArrayLike = __webpack_require__(58),
    isIndex = __webpack_require__(125),
    isObject = __webpack_require__(47);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Image__["a"]; });



/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_triggerBrowserReflow__ = __webpack_require__(306);




var _fadeStyles;






var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__["ENTERING"]] = 'show', _fadeStyles[__WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__["ENTERED"]] = 'show', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Fade, _React$Component);

  function Fade() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils_triggerBrowserReflow__["a" /* default */])(node);
      if (_this.props.onEnter) _this.props.onEnter(node);
    };

    return _this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      addEndListener: __WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end___default.a
    }, props, {
      onEnter: this.handleEnter
    }), function (status, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var FormContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({
  controlId: undefined
});
/* harmony default export */ __webpack_exports__["a"] = (FormContext);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useTheme__ = __webpack_require__(1313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useTheme__["a"]; });


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(1343);
/* unused harmony reexport CSSTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(1347);
/* unused harmony reexport ReplaceTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(1350);
/* unused harmony reexport SwitchTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(644);
/* unused harmony reexport config */







/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reflow; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionProps;
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconButton__ = __webpack_require__(1358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconButton__["a"]; });


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputBase__ = __webpack_require__(1407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputBase__["a"]; });


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formControlState;
function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(234));

var _style = _interopRequireDefault(__webpack_require__(100));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isKey = __webpack_require__(246),
    stringToPath = __webpack_require__(384),
    toString = __webpack_require__(64);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(879),
    isObjectLike = __webpack_require__(41);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(393),
    baseFilter = __webpack_require__(884),
    baseIteratee = __webpack_require__(49),
    isArray = __webpack_require__(26);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(887),
    baseUnary = __webpack_require__(93),
    nodeUtil = __webpack_require__(171);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(172),
    getTag = __webpack_require__(81),
    isArguments = __webpack_require__(124),
    isArray = __webpack_require__(26),
    isArrayLike = __webpack_require__(58),
    isBuffer = __webpack_require__(104),
    isPrototype = __webpack_require__(173),
    isTypedArray = __webpack_require__(128);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(58),
    isObjectLike = __webpack_require__(41);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(388);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(267),
    baseAssignValue = __webpack_require__(132);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    getPrototype = __webpack_require__(184),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(255),
    isFlattenable = __webpack_require__(968);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1012),
    keys = __webpack_require__(48);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(1032);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });



/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = function isObject(val) {
  return val !== null && !Array.isArray(val) && typeof val === 'object'
}

var codes = {
  // ----------------------------------------
  // By Code
  // ----------------------------------------
  3: 'Cancel',
  6: 'Help',
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  28: 'Convert',
  29: 'NonConvert',
  30: 'Accept',
  31: 'ModeChange',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  41: 'Select',
  42: 'Print',
  43: 'Execute',
  44: 'PrintScreen',
  45: 'Insert',
  46: 'Delete',
  48: ['0', ')'],
  49: ['1', '!'],
  50: ['2', '@'],
  51: ['3', '#'],
  52: ['4', '$'],
  53: ['5', '%'],
  54: ['6', '^'],
  55: ['7', '&'],
  56: ['8', '*'],
  57: ['9', '('],
  91: 'OS',
  93: 'ContextMenu',
  144: 'NumLock',
  145: 'ScrollLock',
  181: 'VolumeMute',
  182: 'VolumeDown',
  183: 'VolumeUp',
  186: [';', ':'],
  187: ['=', '+'],
  188: [',', '<'],
  189: ['-', '_'],
  190: ['.', '>'],
  191: ['/', '?'],
  192: ['`', '~'],
  219: ['[', '{'],
  220: ['\\', '|'],
  221: [']', '}'],
  222: ["'", '"'],
  224: 'Meta',
  225: 'AltGraph',
  246: 'Attn',
  247: 'CrSel',
  248: 'ExSel',
  249: 'EraseEof',
  250: 'Play',
  251: 'ZoomOut',
}

// Function Keys (F1-24)
for (var i = 0; i < 24; i += 1) {
  codes[112 + i] = 'F' + (i + 1)
}

// Alphabet (a-Z)
for (var j = 0; j < 26; j += 1) {
  var n = j + 65
  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)]
}

var keyboardKey = {
  codes: codes,

  /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
   * @returns {number|undefined}
   */
  getCode: function getCode(eventOrKey) {
    if (isObject(eventOrKey)) {
      return eventOrKey.keyCode || eventOrKey.which || this[eventOrKey.key]
    }
    return this[eventOrKey]
  },

  /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} eventOrCode A keyboard event-like object or key code.
   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
   * @returns {string|undefined}
   */
  getKey: function getKey(eventOrCode) {
    var isEvent = isObject(eventOrCode)

    // handle events with a `key` already defined
    if (isEvent && eventOrCode.key) {
      return eventOrCode.key
    }

    var name = codes[isEvent ? eventOrCode.keyCode || eventOrCode.which : eventOrCode]

    if (Array.isArray(name)) {
      if (isEvent) {
        name = name[eventOrCode.shiftKey ? 1 : 0]
      } else {
        name = name[0]
      }
    }

    return name
  },

  // ----------------------------------------
  // By Name
  // ----------------------------------------
  // declare these manually for static analysis
  Cancel: 3,
  Help: 6,
  Backspace: 8,
  Tab: 9,
  Clear: 12,
  Enter: 13,
  Shift: 16,
  Control: 17,
  Alt: 18,
  Pause: 19,
  CapsLock: 20,
  Escape: 27,
  Convert: 28,
  NonConvert: 29,
  Accept: 30,
  ModeChange: 31,
  ' ': 32,
  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
  Select: 41,
  Print: 42,
  Execute: 43,
  PrintScreen: 44,
  Insert: 45,
  Delete: 46,
  0: 48,
  ')': 48,
  1: 49,
  '!': 49,
  2: 50,
  '@': 50,
  3: 51,
  '#': 51,
  4: 52,
  $: 52,
  5: 53,
  '%': 53,
  6: 54,
  '^': 54,
  7: 55,
  '&': 55,
  8: 56,
  '*': 56,
  9: 57,
  '(': 57,
  a: 65,
  A: 65,
  b: 66,
  B: 66,
  c: 67,
  C: 67,
  d: 68,
  D: 68,
  e: 69,
  E: 69,
  f: 70,
  F: 70,
  g: 71,
  G: 71,
  h: 72,
  H: 72,
  i: 73,
  I: 73,
  j: 74,
  J: 74,
  k: 75,
  K: 75,
  l: 76,
  L: 76,
  m: 77,
  M: 77,
  n: 78,
  N: 78,
  o: 79,
  O: 79,
  p: 80,
  P: 80,
  q: 81,
  Q: 81,
  r: 82,
  R: 82,
  s: 83,
  S: 83,
  t: 84,
  T: 84,
  u: 85,
  U: 85,
  v: 86,
  V: 86,
  w: 87,
  W: 87,
  x: 88,
  X: 88,
  y: 89,
  Y: 89,
  z: 90,
  Z: 90,
  OS: 91,
  ContextMenu: 93,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NumLock: 144,
  ScrollLock: 145,
  VolumeMute: 181,
  VolumeDown: 182,
  VolumeUp: 183,
  ';': 186,
  ':': 186,
  '=': 187,
  '+': 187,
  ',': 188,
  '<': 188,
  '-': 189,
  _: 189,
  '.': 190,
  '>': 190,
  '/': 191,
  '?': 191,
  '`': 192,
  '~': 192,
  '[': 219,
  '{': 219,
  '\\': 220,
  '|': 220,
  ']': 221,
  '}': 221,
  "'": 222,
  '"': 222,
  Meta: 224,
  AltGraph: 225,
  Attn: 246,
  CrSel: 247,
  ExSel: 248,
  EraseEof: 249,
  Play: 250,
  ZoomOut: 251,
}

// ----------------------------------------
// By Alias
// ----------------------------------------
// provide dot-notation accessible keys for all key names
keyboardKey.Spacebar = keyboardKey[' ']
keyboardKey.Digit0 = keyboardKey['0']
keyboardKey.Digit1 = keyboardKey['1']
keyboardKey.Digit2 = keyboardKey['2']
keyboardKey.Digit3 = keyboardKey['3']
keyboardKey.Digit4 = keyboardKey['4']
keyboardKey.Digit5 = keyboardKey['5']
keyboardKey.Digit6 = keyboardKey['6']
keyboardKey.Digit7 = keyboardKey['7']
keyboardKey.Digit8 = keyboardKey['8']
keyboardKey.Digit9 = keyboardKey['9']
keyboardKey.Tilde = keyboardKey['~']
keyboardKey.GraveAccent = keyboardKey['`']
keyboardKey.ExclamationPoint = keyboardKey['!']
keyboardKey.AtSign = keyboardKey['@']
keyboardKey.PoundSign = keyboardKey['#']
keyboardKey.PercentSign = keyboardKey['%']
keyboardKey.Caret = keyboardKey['^']
keyboardKey.Ampersand = keyboardKey['&']
keyboardKey.PlusSign = keyboardKey['+']
keyboardKey.MinusSign = keyboardKey['-']
keyboardKey.EqualsSign = keyboardKey['=']
keyboardKey.DivisionSign = keyboardKey['/']
keyboardKey.MultiplicationSign = keyboardKey['*']
keyboardKey.Comma = keyboardKey[',']
keyboardKey.Decimal = keyboardKey['.']
keyboardKey.Colon = keyboardKey[':']
keyboardKey.Semicolon = keyboardKey[';']
keyboardKey.Pipe = keyboardKey['|']
keyboardKey.BackSlash = keyboardKey['\\']
keyboardKey.QuestionMark = keyboardKey['?']
keyboardKey.SingleQuote = keyboardKey["'"]
keyboardKey.DoubleQuote = keyboardKey['"']
keyboardKey.LeftCurlyBrace = keyboardKey['{']
keyboardKey.RightCurlyBrace = keyboardKey['}']
keyboardKey.LeftParenthesis = keyboardKey['(']
keyboardKey.RightParenthesis = keyboardKey[')']
keyboardKey.LeftAngleBracket = keyboardKey['<']
keyboardKey.RightAngleBracket = keyboardKey['>']
keyboardKey.LeftSquareBracket = keyboardKey['[']
keyboardKey.RightSquareBracket = keyboardKey[']']

module.exports = keyboardKey


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Label__["a"]; });



/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(519);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1138);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMuiTheme__ = __webpack_require__(322);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createMuiTheme__["a" /* default */])();
/* harmony default export */ __webpack_exports__["a"] = (defaultTheme);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMuiElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export teardown */
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsFocusVisible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    var node = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__(1342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collapse__["a"]; });


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalManager__ = __webpack_require__(671);
/* unused harmony reexport ModalManager */



/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grow__ = __webpack_require__(1418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grow__["a"]; });


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(1425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var ListContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ListContext.displayName = 'ListContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ListContext);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

/* harmony default export */ __webpack_exports__["a"] = (Tablelvl2Context);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["a"] = (warning);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNMOUNTED", function() { return UNMOUNTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXITED", function() { return EXITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTERING", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTERED", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXITING", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(789);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    return (// allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
/* harmony default export */ __webpack_exports__["default"] = (Transition);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = _react.default.createContext(null);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return signUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return signIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return signOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiConfig__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
var signUp=function signUp(credentials){return __WEBPACK_IMPORTED_MODULE_1_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */]+'/sign-up',data:{credentials:{email:credentials.email,password:credentials.password,password_confirmation:credentials.passwordConfirmation}}});};var signIn=function signIn(credentials){return __WEBPACK_IMPORTED_MODULE_1_axios___default()({url:__WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */]+'/sign-in',method:'POST',data:{credentials:{email:credentials.email,password:credentials.password}}});};var signOut=function signOut(user){return __WEBPACK_IMPORTED_MODULE_1_axios___default()({url:__WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */]+'/sign-out',method:'DELETE',headers:{'Authorization':'Token token='+user.token}});};var changePassword=function changePassword(passwords,user){return __WEBPACK_IMPORTED_MODULE_1_axios___default()({url:__WEBPACK_IMPORTED_MODULE_0__apiConfig__["a" /* default */]+'/change-password',method:'PATCH',headers:{'Authorization':'Token token='+user.token},data:{passwords:{old:passwords.oldPassword,new:passwords.newPassword}}});};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({signUpSuccess:'Succesfully registered! You\'ve been signed in as well.',signUpFailure:'Registration failed. Email may be taken, or passwords don\'t match.',signInSuccess:'Welcome!',signInFailure:'Failed to sign in. Check your email and password and try again.',signOutSuccess:'Come back soon!',changePasswordSuccess:'Password changed successfully!',changePasswordFailure:'Failed to change passwords. Check your old password and try again.'});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export refPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


/** A checker that matches the React.Ref type. */
var refPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(869),
    listCacheDelete = __webpack_require__(870),
    listCacheGet = __webpack_require__(871),
    listCacheHas = __webpack_require__(872),
    listCacheSet = __webpack_require__(873);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(123);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(875);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    arrayMap = __webpack_require__(71),
    isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(88);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(122),
    toKey = __webpack_require__(91);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47),
    isSymbol = __webpack_require__(88);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(394),
    keys = __webpack_require__(48);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(383);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253)(module)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(173),
    nativeKeys = __webpack_require__(888);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(162),
    stackClear = __webpack_require__(892),
    stackDelete = __webpack_require__(893),
    stackGet = __webpack_require__(894),
    stackHas = __webpack_require__(895),
    stackSet = __webpack_require__(896);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(248),
    setCacheAdd = __webpack_require__(898),
    setCacheHas = __webpack_require__(899);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(179);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(412),
    baseIsNaN = __webpack_require__(910),
    strictIndexOf = __webpack_require__(911);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(416),
    createBind = __webpack_require__(935),
    createCurry = __webpack_require__(936),
    createHybrid = __webpack_require__(418),
    createPartial = __webpack_require__(945),
    getData = __webpack_require__(263),
    mergeData = __webpack_require__(946),
    setData = __webpack_require__(424),
    setWrapToString = __webpack_require__(425),
    toInteger = __webpack_require__(72);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(133),
    isObject = __webpack_require__(47);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(395),
    baseKeysIn = __webpack_require__(949),
    isArrayLike = __webpack_require__(58);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(397);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(974),
    hasUnicode = __webpack_require__(186),
    unicodeToArray = __webpack_require__(975);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(978),
    flatRest = __webpack_require__(269);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var stack;

if (true) {
  stack = __webpack_require__(1003);
} else {
  stack = require('./cjs/event-stack.development.js');
}

module.exports = stack.default;
module.exports.instance = stack.instance;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isArray = __webpack_require__(26),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });



/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IconGroup__ = __webpack_require__(445);
















/**
 * An icon is a glyph used to represent something else.
 * @see Image
 */

var Icon =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Icon, _PureComponent);

  function Icon() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Icon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Icon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Icon, [{
    key: "getIconAriaOptions",
    value: function getIconAriaOptions() {
      var ariaOptions = {};
      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          ariaHidden = _this$props['aria-hidden'];

      if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(ariaLabel)) {
        ariaOptions['aria-hidden'] = 'true';
      } else {
        ariaOptions['aria-label'] = ariaLabel;
      }

      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(ariaHidden)) {
        ariaOptions['aria-hidden'] = ariaHidden;
      }

      return ariaOptions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bordered = _this$props2.bordered,
          circular = _this$props2.circular,
          className = _this$props2.className,
          color = _this$props2.color,
          corner = _this$props2.corner,
          disabled = _this$props2.disabled,
          fitted = _this$props2.fitted,
          flipped = _this$props2.flipped,
          inverted = _this$props2.inverted,
          link = _this$props2.link,
          loading = _this$props2.loading,
          name = _this$props2.name,
          rotated = _this$props2.rotated,
          size = _this$props2.size;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(color, name, size, Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(bordered, 'bordered'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(fitted, 'fitted'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["z" /* useKeyOrValueAndKey */])(corner, 'corner'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["C" /* useValueAndKey */])(flipped, 'flipped'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["C" /* useValueAndKey */])(rotated, 'rotated'), 'icon', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(Icon, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["p" /* getElementType */])(Icon, this.props);
      var ariaOptions = this.getIconAriaOptions();
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
        className: classes,
        onClick: this.handleClick
      }));
    }
  }]);

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_13_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Icon, "defaultProps", {
  as: 'i'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Icon, "Group", __WEBPACK_IMPORTED_MODULE_15__IconGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Icon, "handledProps", ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"]);

Icon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Formatted to appear bordered. */
  bordered: PropTypes.bool,

  /** Icon can formatted to appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the icon. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Icons can display a smaller corner icon. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top left', 'top right', 'bottom left', 'bottom right'])]),

  /** Show that the icon is inactive. */
  disabled: PropTypes.bool,

  /** Fitted, without space to left or right of Icon. */
  fitted: PropTypes.bool,

  /** Icon can be flipped. */
  flipped: PropTypes.oneOf(['horizontally', 'vertically']),

  /** Formatted to have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** Icon can be formatted as a link. */
  link: PropTypes.bool,

  /** Icon can be used as a simple loader. */
  loading: PropTypes.bool,

  /** Name of the icon. */
  name: customPropTypes.suggest(SUI.ALL_ICONS_IN_ALL_CONTEXTS),

  /** Icon can rotated. */
  rotated: PropTypes.oneOf(['clockwise', 'counterclockwise']),

  /** Size of the icon. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Icon can have an aria label. */
  'aria-hidden': PropTypes.string,

  /** Icon can have an aria label. */
  'aria-label': PropTypes.string
} : {};
Icon.create = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["l" /* createShorthandFactory */])(Icon, function (value) {
  return {
    name: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(458),
    baseEach = __webpack_require__(92),
    baseIteratee = __webpack_require__(49),
    baseReduce = __webpack_require__(1034),
    isArray = __webpack_require__(26);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1067);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });



/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1073);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(42);







/**
 * A table row can have cells.
 */

function TableCell(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      content = props.content,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      negative = props.negative,
      positive = props.positive,
      selectable = props.selectable,
      singleLine = props.singleLine,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning,
      width = props.width;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(collapsing, 'collapsing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(selectable, 'selectable'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(singleLine, 'single line'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["D" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useWidthProp */])(width, 'wide'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(TableCell, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(TableCell, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon), content);
}

TableCell.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"];
TableCell.defaultProps = {
  as: 'td'
};
TableCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A cell can be active or selected by a user. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A cell can be collapsing so that it only uses as much space as required. */
  collapsing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A cell can be disabled. */
  disabled: PropTypes.bool,

  /** A cell may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon /> */
  icon: customPropTypes.itemShorthand,

  /** A cell may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A cell may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A cell can be selectable. */
  selectable: PropTypes.bool,

  /** A cell can specify that its contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table cell can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table cell can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A cell may warn a user. */
  warning: PropTypes.bool,

  /** A table can specify the width of individual columns independently. */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};
TableCell.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* createShorthandFactory */])(TableCell, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A list item can contain a description.
 */

function ListDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'description');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ListDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ListDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ListDescription.handledProps = ["as", "children", "className", "content"];
ListDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ListDescription.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ListDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListDescription);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A list item can contain a header.
 */

function ListHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ListHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ListHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ListHeader.handledProps = ["as", "children", "className", "content"];
ListHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ListHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ListHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListHeader);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(24);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * An event or an event summary can contain a date.
 */

function FeedDate(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('date', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedDate, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedDate, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

FeedDate.handledProps = ["as", "children", "className", "content"];
FeedDate.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedDate);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);





var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var defaultProps = {
  label: 'Close'
};
var CloseButton = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["label", "onClick", "className"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("button", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('close', className),
    onClick: onClick
  }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: "sr-only"
  }, label));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SafeAnchor__ = __webpack_require__(84);






var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false,
  type: 'button'
};
var Button = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      block = _ref.block,
      type = _ref.type,
      as = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'btn');
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, active && 'active', prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);

  if (props.href) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      as: as,
      innerRef: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, props.disabled && 'disabled')
    }));
  }

  var Component = as || 'button';
  if (ref) props.ref = ref;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    type: type,
    className: classes
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forEach; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */

function map(children, func) {
  var index = 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child) ? func(child, index++) : child;
  });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */


function forEach(children, func) {
  var index = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) func(child, index++);
  });
}



/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_overlays_Dropdown__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_overlays_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_overlays_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DropdownMenu__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DropdownToggle__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DropdownItem__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createWithBsPrefix__ = __webpack_require__(35);













var defaultProps = {
  navbar: false
};
var Dropdown = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (uncontrolledProps, ref) {
  var _useUncontrolled = __WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook___default()(uncontrolledProps, {
    show: 'onToggle'
  }),
      bsPrefix = _useUncontrolled.bsPrefix,
      drop = _useUncontrolled.drop,
      show = _useUncontrolled.show,
      className = _useUncontrolled.className,
      alignRight = _useUncontrolled.alignRight,
      onSelect = _useUncontrolled.onSelect,
      onToggle = _useUncontrolled.onToggle,
      focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow,
      _useUncontrolled$as = _useUncontrolled.as,
      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      _4 = _useUncontrolled.navbar,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useUncontrolled, ["bsPrefix", "drop", "show", "className", "alignRight", "onSelect", "onToggle", "focusFirstItemOnShow", "as", "navbar"]);

  var onSelectCtx = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__SelectableContext__["a" /* default */]);
  var prefix = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'dropdown');
  var handleToggle = Object(__WEBPACK_IMPORTED_MODULE_6__restart_hooks_useEventCallback__["default"])(function (nextShow, event, source) {
    if (source === void 0) {
      source = event.type;
    }

    if (event.currentTarget === document) source = 'rootClose';
    onToggle(nextShow, event, {
      source: source
    });
  });
  var handleSelect = Object(__WEBPACK_IMPORTED_MODULE_6__restart_hooks_useEventCallback__["default"])(function (key, event) {
    if (onSelectCtx) onSelectCtx(key, event);
    if (onSelect) onSelect(key, event);
    handleToggle(false, event, 'select');
  });
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SelectableContext__["a" /* default */].Provider, {
    value: handleSelect
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_overlays_Dropdown___default.a.ControlledComponent, {
    drop: drop,
    show: show,
    alignEnd: alignRight,
    onToggle: handleToggle,
    focusFirstItemOnShow: focusFirstItemOnShow,
    itemSelector: "." + prefix + "-item:not(.disabled):not(:disabled)"
  }, function (_ref) {
    var dropdownProps = _ref.props;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, dropdownProps, {
      ref: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, show && 'show', (!drop || drop === 'down') && prefix, drop === 'up' && 'dropup', drop === 'right' && 'dropright', drop === 'left' && 'dropleft')
    }));
  }));
});
Dropdown.displayName = 'Dropdown';
Dropdown.defaultProps = defaultProps;
Dropdown.Toggle = __WEBPACK_IMPORTED_MODULE_9__DropdownToggle__["a" /* default */];
Dropdown.Menu = __WEBPACK_IMPORTED_MODULE_8__DropdownMenu__["a" /* default */];
Dropdown.Item = __WEBPACK_IMPORTED_MODULE_10__DropdownItem__["a" /* default */];
Dropdown.Header = Object(__WEBPACK_IMPORTED_MODULE_12__utils_createWithBsPrefix__["a" /* default */])('dropdown-header', {
  defaultProps: {
    role: 'heading'
  }
});
Dropdown.Divider = Object(__WEBPACK_IMPORTED_MODULE_12__utils_createWithBsPrefix__["a" /* default */])('dropdown-divider', {
  defaultProps: {
    role: 'separator'
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(236);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var NavItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'nav-item');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }), children);
});
NavItem.displayName = 'NavItem';
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(10);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["a"] = (merge);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__ = __webpack_require__(1292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__["a"]; });


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyles__ = __webpack_require__(1310);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__makeStyles__["a"]; });


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StylesProvider__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["a"]; });



/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgIcon__ = __webpack_require__(1339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SvgIcon__["a"]; });


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(61);

function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" /* default */])(node);
  return doc.defaultView || window;
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Backdrop__ = __webpack_require__(1362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Backdrop__["a"]; });


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fade__ = __webpack_require__(1363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fade__["a"]; });


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var FormControlContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](FormControlContext);
}
/* harmony default export */ __webpack_exports__["a"] = (FormControlContext);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(1392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilledInput__ = __webpack_require__(1406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilledInput__["a"]; });


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormControl__ = __webpack_require__(1409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useFormControl__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__useFormControl__["a"]; });



/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withWidth__ = __webpack_require__(691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["c"]; });



/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__ = __webpack_require__(1442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__["a"]; });


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(229);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = createWithBsPrefix;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _camelize = _interopRequireDefault(__webpack_require__(232));

var _ThemeProvider = __webpack_require__(33);

var pascalCase = function pascalCase(str) {
  return str[0].toUpperCase() + (0, _camelize.default)(str).slice(1);
};

function createWithBsPrefix(prefix, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? 'div' : _ref$Component,
      defaultProps = _ref.defaultProps;

  var BsComponent = _react.default.forwardRef( // eslint-disable-next-line react/prop-types
  function (_ref2, ref) {
    var className = _ref2.className,
        bsPrefix = _ref2.bsPrefix,
        _ref2$as = _ref2.as,
        Tag = _ref2$as === void 0 ? Component : _ref2$as,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["className", "bsPrefix", "as"]);
    var resolvedPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, prefix);
    return _react.default.createElement(Tag, (0, _extends2.default)({
      ref: ref,
      className: (0, _classnames.default)(className, resolvedPrefix)
    }, props));
  });

  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

module.exports = exports["default"];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = forwardRef;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function forwardRef(renderFn, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps,
      _ref$allowFallback = _ref.allowFallback,
      allowFallback = _ref$allowFallback === void 0 ? false : _ref$allowFallback,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? renderFn.name || renderFn.displayName : _ref$displayName;

  var render = function render(props, ref) {
    return renderFn(props, ref);
  };

  return Object.assign(_react.default.forwardRef || !allowFallback ? _react.default.forwardRef(render) : function (props) {
    return render(props, null);
  }, {
    displayName: displayName,
    propTypes: propTypes,
    defaultProps: defaultProps
  });
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(12));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));

var _react = _interopRequireDefault(__webpack_require__(0));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(368));

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$as = _this$props2.as,
        Component = _this$props2$as === void 0 ? 'a' : _this$props2$as,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        innerRef = _this$props2.innerRef,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["as", "disabled", "onKeyDown", "innerRef"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }

    if (innerRef) props.ref = innerRef;
    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      onClick: this.handleClick,
      onKeyDown: (0, _createChainedFunction.default)(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(_react.default.Component);

var _default = SafeAnchor;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = exports.makeEventKey = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var SelectableContext = _react.default.createContext();

var makeEventKey = function makeEventKey(eventKey, href) {
  if (eventKey != null) return String(eventKey);
  return href || null;
};

exports.makeEventKey = makeEventKey;
var _default = SelectableContext;
exports.default = _default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(815);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(52);
var normalizeHeaderName = __webpack_require__(819);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(374);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(374);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(818)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(231));

var _ThemeProvider = __webpack_require__(33);

var _FormGroup = _interopRequireDefault(__webpack_require__(833));

var _FormControl = _interopRequireDefault(__webpack_require__(834));

var _FormCheck = _interopRequireDefault(__webpack_require__(835));

var _FormLabel = _interopRequireDefault(__webpack_require__(838));

var _FormText = _interopRequireDefault(__webpack_require__(840));

var defaultProps = {
  inline: false
};

var Form = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      className = _ref.className,
      validated = _ref.validated,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'form' : _ref$as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "inline", "className", "validated", "as"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form');
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: (0, _classnames.default)(className, validated && 'was-validated', inline && bsPrefix + "-inline")
  }));
});

Form.displayName = 'Form';
Form.defaultProps = defaultProps;
Form.Row = (0, _createWithBsPrefix.default)('form-row');
Form.Group = _FormGroup.default;
Form.Control = _FormControl.default;
Form.Check = _FormCheck.default;
Form.Label = _FormLabel.default;
Form.Text = _FormText.default;
var _default = Form;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var _SafeAnchor = _interopRequireDefault(__webpack_require__(235));

var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false,
  type: 'button'
};

var Button = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      block = _ref.block,
      type = _ref.type,
      as = _ref.as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]);
  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'btn');
  var classes = (0, _classnames.default)(className, prefix, active && 'active', prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);

  if (props.href) {
    return _react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
      as: as,
      innerRef: ref,
      className: (0, _classnames.default)(classes, props.disabled && 'disabled')
    }));
  }

  var Component = as || 'button';
  if (ref) props.ref = ref;
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    type: type,
    className: classes
  }));
});

Button.displayName = 'Button';
Button.defaultProps = defaultProps;
var _default = Button;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);


/**
 * The function that correctly handles passing refs.
 *
 * @param ref An ref object or function
 * @param node A node that should be passed by ref
 */
var handleRef = function handleRef(ref, node) {
  if (false) {
    if (typeof ref === 'string') {
      throw new Error('We do not support refs as string, this is a legacy API and will be likely to be removed in one of the future releases of React.');
    }
  }

  if (typeof ref === 'function') {
    ref(node);
    return;
  }

  if (ref !== null && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(ref) === 'object') {
    // The `current` property is defined as readonly, however it's a valid way because
    // `ref` is a mutable object
    ;
    ref.current = node;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleRef);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(120);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(850);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(88);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(248);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(858),
    mapCacheDelete = __webpack_require__(874),
    mapCacheGet = __webpack_require__(876),
    mapCacheHas = __webpack_require__(877),
    mapCacheSet = __webpack_require__(878);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90),
    root = __webpack_require__(44);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(883),
    shortOut = __webpack_require__(389);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(169);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(897),
    isObjectLike = __webpack_require__(41);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(393),
    stubArray = __webpack_require__(404);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(105);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(399),
    baseIteratee = __webpack_require__(49),
    baseSome = __webpack_require__(924),
    isArray = __webpack_require__(26),
    isIterateeCall = __webpack_require__(106);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numberToWordMap; });
/* harmony export (immutable) */ __webpack_exports__["a"] = numberToWord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);

var numberToWordMap = {
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight',
  9: 'nine',
  10: 'ten',
  11: 'eleven',
  12: 'twelve',
  13: 'thirteen',
  14: 'fourteen',
  15: 'fifteen',
  16: 'sixteen'
  /**
   * Return the number word for numbers 1-16.
   * Returns strings or numbers as is if there is no corresponding word.
   * Returns an empty string if value is not a string or number.
   * @param {string|number} value The value to convert to a word.
   * @returns {string}
   */

};
function numberToWord(value) {
  var type = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value);

  if (type === 'string' || type === 'number') {
    return numberToWordMap[value] || value;
  }

  return '';
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(133),
    baseLodash = __webpack_require__(262);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(417),
    noop = __webpack_require__(264);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(133),
    baseLodash = __webpack_require__(262);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(132),
    eq = __webpack_require__(123);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(400);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(967),
    overRest = __webpack_require__(386),
    setToString = __webpack_require__(251);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(433),
    baseFlatten = __webpack_require__(136),
    baseRest = __webpack_require__(80),
    isArrayLikeObject = __webpack_require__(130);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(168);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(441);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon_Icon__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Label_Label__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ButtonContent__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ButtonGroup__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ButtonOr__ = __webpack_require__(456);





















/**
 * A Button indicates a possible user action.
 * @see Form
 * @see Icon
 * @see Label
 */

var Button =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Button, _Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", Object(__WEBPACK_IMPORTED_MODULE_14_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeElementType", function () {
      var _this$props = _this.props,
          attached = _this$props.attached,
          label = _this$props.label;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(attached) || !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(label)) return 'div';
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function (ElementType) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(tabIndex)) return tabIndex;
      if (disabled) return -1;
      if (ElementType === 'div') return 0;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.ref.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "hasIconClass", function () {
      var _this$props3 = _this.props,
          labelPosition = _this$props3.labelPosition,
          children = _this$props3.children,
          content = _this$props3.content,
          icon = _this$props3.icon;
      if (icon === true) return true;
      return icon && (labelPosition || __WEBPACK_IMPORTED_MODULE_15__lib__["c" /* childrenUtils */].isNil(children) && __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(content));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Button, [{
    key: "computeButtonAriaRole",
    value: function computeButtonAriaRole(ElementType) {
      var role = this.props.role;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(role)) return role;
      if (ElementType !== 'button') return 'button';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          active = _this$props4.active,
          animated = _this$props4.animated,
          attached = _this$props4.attached,
          basic = _this$props4.basic,
          children = _this$props4.children,
          circular = _this$props4.circular,
          className = _this$props4.className,
          color = _this$props4.color,
          compact = _this$props4.compact,
          content = _this$props4.content,
          disabled = _this$props4.disabled,
          floated = _this$props4.floated,
          fluid = _this$props4.fluid,
          icon = _this$props4.icon,
          inverted = _this$props4.inverted,
          label = _this$props4.label,
          labelPosition = _this$props4.labelPosition,
          loading = _this$props4.loading,
          negative = _this$props4.negative,
          positive = _this$props4.positive,
          primary = _this$props4.primary,
          secondary = _this$props4.secondary,
          size = _this$props4.size,
          toggle = _this$props4.toggle;
      var baseClasses = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(color, size, Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(this.hasIconClass(), 'icon'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(primary, 'primary'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(toggle, 'toggle'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["z" /* useKeyOrValueAndKey */])(animated, 'animated'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'));
      var labeledClasses = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_15__lib__["z" /* useKeyOrValueAndKey */])(labelPosition || !!label, 'labeled'));
      var wrapperClasses = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["C" /* useValueAndKey */])(floated, 'floated'));
      var rest = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* getUnhandledProps */])(Button, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["p" /* getElementType */])(Button, this.props, this.computeElementType);
      var tabIndex = this.computeTabIndex(ElementType);

      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(label)) {
        var buttonClasses = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', baseClasses, 'button', className);
        var containerClasses = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', labeledClasses, 'button', className, wrapperClasses);
        var labelElement = __WEBPACK_IMPORTED_MODULE_17__Label_Label__["a" /* default */].create(label, {
          defaultProps: {
            basic: true,
            pointing: labelPosition === 'left' ? 'right' : 'left'
          },
          autoGenerateKey: false
        });
        return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
          className: containerClasses,
          onClick: this.handleClick
        }), labelPosition === 'left' && labelElement, __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__["a" /* Ref */], {
          innerRef: this.ref
        }, __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("button", {
          className: buttonClasses,
          "aria-pressed": toggle ? !!active : undefined,
          disabled: disabled,
          tabIndex: tabIndex
        }, __WEBPACK_IMPORTED_MODULE_16__Icon_Icon__["a" /* default */].create(icon, {
          autoGenerateKey: false
        }), " ", content)), (labelPosition === 'right' || !labelPosition) && labelElement);
      }

      var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
      var hasChildren = !__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* childrenUtils */].isNil(children);
      var role = this.computeButtonAriaRole(ElementType);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        "aria-pressed": toggle ? !!active : undefined,
        disabled: disabled && ElementType === 'button' || undefined,
        onClick: this.handleClick,
        role: role,
        tabIndex: tabIndex
      }), hasChildren && children, !hasChildren && __WEBPACK_IMPORTED_MODULE_16__Icon_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), !hasChildren && content));
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "defaultProps", {
  as: 'button'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "Content", __WEBPACK_IMPORTED_MODULE_18__ButtonContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "Group", __WEBPACK_IMPORTED_MODULE_19__ButtonGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "Or", __WEBPACK_IMPORTED_MODULE_20__ButtonOr__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "handledProps", ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle"]);

Button.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A button can show it is currently the active user selection. */
  active: PropTypes.bool,

  /** A button can animate to show hidden content. */
  animated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['fade', 'vertical'])]),

  /** A button can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** A basic button is less pronounced. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([PropTypes.node, customPropTypes.disallow(['label']), customPropTypes.givenProps({
    icon: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired, PropTypes.element.isRequired])
  }, customPropTypes.disallow(['icon']))]),

  /** A button can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A button can have different colors */
  color: PropTypes.oneOf([].concat(_toConsumableArray(SUI.COLORS), ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),

  /** A button can reduce its padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A button can show it is currently unable to be interacted with. */
  disabled: PropTypes.bool,

  /** A button can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A button can take the width of its container. */
  fluid: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon />. */
  icon: customPropTypes.some([PropTypes.bool, PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A button can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Add a Label by text, props object, or pass a <Label />. */
  label: customPropTypes.some([PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A labeled button can format a Label or Icon to appear on the left or right. */
  labelPosition: PropTypes.oneOf(['right', 'left']),

  /** A button can show a loading indicator. */
  loading: PropTypes.bool,

  /** A button can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /**
   * Called after user's click.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A button can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** A button can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** The role of the HTML element. */
  role: PropTypes.string,

  /** A button can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** A button can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A button can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A button can be formatted to toggle on and off. */
  toggle: PropTypes.bool
} : {};
Button.create = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["l" /* createShorthandFactory */])(Button, function (value) {
  return {
    content: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icon_Icon__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Image_Image__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LabelDetail__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LabelGroup__ = __webpack_require__(453);


















/**
 * A label displays content classification.
 */

var Label =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Label, _Component);

  function Label() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Label);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Label)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onRemove', e, _this.props);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Label, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          attached = _this$props.attached,
          basic = _this$props.basic,
          children = _this$props.children,
          circular = _this$props.circular,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          corner = _this$props.corner,
          detail = _this$props.detail,
          empty = _this$props.empty,
          floating = _this$props.floating,
          horizontal = _this$props.horizontal,
          icon = _this$props.icon,
          image = _this$props.image,
          onRemove = _this$props.onRemove,
          pointing = _this$props.pointing,
          prompt = _this$props.prompt,
          removeIcon = _this$props.removeIcon,
          ribbon = _this$props.ribbon,
          size = _this$props.size,
          tag = _this$props.tag;
      var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && "".concat(pointing, " pointing") || (pointing === 'above' || pointing === 'below') && "pointing ".concat(pointing);
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', color, pointingClass, size, Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(empty, 'empty'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(floating, 'floating'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(image === true, 'image'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(prompt, 'prompt'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(tag, 'tag'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["z" /* useKeyOrValueAndKey */])(corner, 'corner'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["z" /* useKeyOrValueAndKey */])(ribbon, 'ribbon'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["C" /* useValueAndKey */])(attached, 'attached'), 'label', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(Label, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(Label, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      var removeIconShorthand = __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default()(removeIcon) ? 'delete' : removeIcon;
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        className: classes,
        onClick: this.handleClick
      }, rest), __WEBPACK_IMPORTED_MODULE_14__Icon_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), typeof image !== 'boolean' && __WEBPACK_IMPORTED_MODULE_15__Image_Image__["a" /* default */].create(image, {
        autoGenerateKey: false
      }), content, __WEBPACK_IMPORTED_MODULE_16__LabelDetail__["a" /* default */].create(detail, {
        autoGenerateKey: false
      }), onRemove && __WEBPACK_IMPORTED_MODULE_14__Icon_Icon__["a" /* default */].create(removeIconShorthand, {
        autoGenerateKey: false,
        overrideProps: this.handleIconOverrides
      }));
    }
  }]);

  return Label;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Label, "Detail", __WEBPACK_IMPORTED_MODULE_16__LabelDetail__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Label, "Group", __WEBPACK_IMPORTED_MODULE_17__LabelGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Label, "handledProps", ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"]);


Label.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A label can be active. */
  active: PropTypes.bool,

  /** A label can attach to a content segment. */
  attached: PropTypes.oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),

  /** A label can reduce its complexity. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A label can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the label. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A label can position itself in the corner of an element. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Shorthand for LabelDetail. */
  detail: customPropTypes.itemShorthand,

  /** Formats the label as a dot. */
  empty: customPropTypes.every([PropTypes.bool, customPropTypes.demand(['circular'])]),

  /** Float above another element in the upper right corner. */
  floating: PropTypes.bool,

  /** A horizontal label is formatted to label content along-side it horizontally. */
  horizontal: PropTypes.bool,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
  image: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Adds an "x" icon, called when "x" is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onRemove: PropTypes.func,

  /** A label can point to content next to it. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['above', 'below', 'left', 'right'])]),

  /** A label can prompt for an error in your forms. */
  prompt: PropTypes.bool,

  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
  removeIcon: customPropTypes.itemShorthand,

  /** A label can appear as a ribbon attaching itself to an element. */
  ribbon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A label can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A label can appear as a tag. */
  tag: PropTypes.bool
} : {};
Label.create = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["l" /* createShorthandFactory */])(Label, function (value) {
  return {
    content: value
  };
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_startCase__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(42);















/**
 * A menu can contain an item.
 */

var MenuItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(MenuItem, _Component);

  function MenuItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(MenuItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          disabled = _this$props.disabled,
          fitted = _this$props.fitted,
          header = _this$props.header,
          icon = _this$props.icon,
          link = _this$props.link,
          name = _this$props.name,
          onClick = _this$props.onClick,
          position = _this$props.position;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(color, position, Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(icon === true || icon && !(name || content), 'icon'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(header, 'header'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["z" /* useKeyOrValueAndKey */])(fitted, 'fitted'), 'item', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(MenuItem, this.props, function () {
        if (onClick) return 'a';
      });
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(MenuItem, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(content) ? __WEBPACK_IMPORTED_MODULE_8_lodash_startCase___default()(name) : content);
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(MenuItem, "handledProps", ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"]);


MenuItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A menu item can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A menu item can be disabled. */
  disabled: PropTypes.bool,

  /** A menu item or menu can remove element padding, vertically or horizontally. */
  fitted: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A menu item may include a header or may itself be a header. */
  header: PropTypes.bool,

  /** MenuItem can be only icon. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** MenuItem index inside Menu. */
  index: PropTypes.number,

  /** A menu item can be link. */
  link: PropTypes.bool,

  /** Internal name of the MenuItem. */
  name: PropTypes.string,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A menu item can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};
MenuItem.create = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["l" /* createShorthandFactory */])(MenuItem, function (val) {
  return {
    content: val,
    name: val
  };
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(1066);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Radio__["a"]; });



/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(1096);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });



/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A column sub-component for Grid.
 */

function GridColumn(props) {
  var children = props.children,
      className = props.className,
      computer = props.computer,
      color = props.color,
      floated = props.floated,
      largeScreen = props.largeScreen,
      mobile = props.mobile,
      only = props.only,
      stretched = props.stretched,
      tablet = props.tablet,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      widescreen = props.widescreen,
      width = props.width;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(color, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(stretched, 'stretched'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["A" /* useMultipleProp */])(only, 'only'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["D" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useWidthProp */])(computer, 'wide computer'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useWidthProp */])(largeScreen, 'wide large screen'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useWidthProp */])(mobile, 'wide mobile'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useWidthProp */])(tablet, 'wide tablet'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useWidthProp */])(widescreen, 'wide widescreen'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useWidthProp */])(width, 'wide'), 'column', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(GridColumn, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(GridColumn, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

GridColumn.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"];
GridColumn.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid column can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A column can specify a width for a computer. */
  computer: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can sit flush against the left or right edge of a row. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A column can specify a width for a large screen device. */
  largeScreen: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can specify a width for a mobile device. */
  mobile: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A column can stretch its contents to take up the entire grid or row height. */
  stretched: PropTypes.bool,

  /** A column can specify a width for a tablet device. */
  tablet: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A column can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A column can specify a width for a wide screen device. */
  widescreen: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** Represents width of column. */
  width: customPropTypes.every([customPropTypes.disallow(['computer', 'largeScreen', 'mobile', 'tablet', 'widescreen']), PropTypes.oneOf(SUI.WIDTHS)])
} : {};
GridColumn.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(GridColumn, function (children) {
  return {
    children: children
  };
});
/* harmony default export */ __webpack_exports__["a"] = (GridColumn);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A message list can contain an item.
 */

function MessageItem(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(MessageItem, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(MessageItem, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

MessageItem.handledProps = ["as", "children", "className", "content"];
MessageItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
MessageItem.defaultProps = {
  as: 'li'
};
MessageItem.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(MessageItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageItem);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A table can have a header.
 */

function TableHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fullWidth = props.fullWidth;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(fullWidth, 'full-width'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(TableHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(TableHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

TableHeader.handledProps = ["as", "children", "className", "content", "fullWidth"];
TableHeader.defaultProps = {
  as: 'thead'
};
TableHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
  fullWidth: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TableHeader);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListDescription__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListHeader__ = __webpack_require__(198);







/**
 * A list item can contain a content.
 */

function ListContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      floated = props.floated,
      header = props.header,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["D" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ListContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ListContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__ListHeader__["a" /* default */].create(header), __WEBPACK_IMPORTED_MODULE_5__ListDescription__["a" /* default */].create(description), content);
}

ListContent.handledProps = ["as", "children", "className", "content", "description", "floated", "header", "verticalAlign"];
ListContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** An list content can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
ListContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ListContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListContent);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_Icon__ = __webpack_require__(191);






/**
 * A list item can contain an icon.
 */

function ListIcon(props) {
  var className = props.className,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["D" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ListIcon, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon_Icon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

ListIcon.handledProps = ["className", "verticalAlign"];
ListIcon.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
ListIcon.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ListIcon, function (name) {
  return {
    name: name
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListIcon);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);






function StepDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(StepDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(StepDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

StepDescription.handledProps = ["as", "children", "className", "content"];
StepDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StepDescription.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(StepDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepDescription);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A step can contain a title.
 */

function StepTitle(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('title', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(StepTitle, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(StepTitle, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

StepTitle.handledProps = ["as", "children", "className", "content"];
StepTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StepTitle.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(StepTitle, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepTitle);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccordionTitle__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccordionContent__ = __webpack_require__(287);













/**
 * A panel sub-component for Accordion component.
 */

var AccordionPanel =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AccordionPanel, _Component);

  function AccordionPanel() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AccordionPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AccordionPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTitleOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, titleProps) {
          __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(predefinedProps, 'onClick', e, titleProps);

          __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onTitleClick', e, titleProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AccordionPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          content = _this$props.content,
          index = _this$props.index,
          title = _this$props.title;
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_11__AccordionTitle__["a" /* default */].create(title, {
        autoGenerateKey: false,
        defaultProps: {
          active: active,
          index: index
        },
        overrideProps: this.handleTitleOverrides
      }), __WEBPACK_IMPORTED_MODULE_12__AccordionContent__["a" /* default */].create(content, {
        autoGenerateKey: false,
        defaultProps: {
          active: active
        }
      }));
    }
  }]);

  return AccordionPanel;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AccordionPanel, "handledProps", ["active", "content", "index", "onTitleClick", "title"]);

AccordionPanel.propTypes =  false ? {
  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** A shorthand for Accordion.Content. */
  content: customPropTypes.itemShorthand,

  /** A panel index. */
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: PropTypes.func,

  /** A shorthand for Accordion.Title. */
  title: customPropTypes.itemShorthand
} : {};
AccordionPanel.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["l" /* createShorthandFactory */])(AccordionPanel, null);
/* harmony default export */ __webpack_exports__["a"] = (AccordionPanel);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(42);















/**
 * A title sub-component for Accordion component.
 */

var AccordionTitle =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AccordionTitle, _Component);

  function AccordionTitle() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AccordionTitle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AccordionTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      return __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AccordionTitle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          icon = _this$props.icon;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active'), 'title', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(AccordionTitle, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(AccordionTitle, this.props);
      var iconValue = __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(icon) ? 'dropdown' : icon;

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(iconValue, {
        autoGenerateKey: false
      }), content);
    }
  }]);

  return AccordionTitle;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AccordionTitle, "handledProps", ["active", "as", "children", "className", "content", "icon", "index", "onClick"]);


AccordionTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** AccordionTitle index inside Accordion. */
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};
AccordionTitle.create = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["l" /* createShorthandFactory */])(AccordionTitle, function (content) {
  return {
    content: content
  };
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A content sub-component for Accordion component.
 */

function AccordionContent(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(active, 'active'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(AccordionContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(AccordionContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

AccordionContent.handledProps = ["active", "as", "children", "className", "content"];
AccordionContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Whether or not the content is visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
AccordionContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(AccordionContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (AccordionContent);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A card can contain a description with one or more paragraphs.
 */

function CardDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), 'description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(CardDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(CardDescription, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CardDescription.handledProps = ["as", "children", "className", "content", "textAlign"];
CardDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardDescription);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A card can contain a header.
 */

function CardHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(CardHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(CardHeader, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CardHeader.handledProps = ["as", "children", "className", "content", "textAlign"];
CardHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card header can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardHeader);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A card can contain content metadata.
 */

function CardMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), 'meta', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(CardMeta, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(CardMeta, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CardMeta.handledProps = ["as", "children", "className", "content", "textAlign"];
CardMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card meta can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardMeta);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedExtra__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeedMeta__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedSummary__ = __webpack_require__(296);










function FeedContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      extraImages = props.extraImages,
      extraText = props.extraText,
      date = props.date,
      meta = props.meta,
      summary = props.summary;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, date, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__FeedSummary__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, summary, {
    autoGenerateKey: false
  }), content, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
    return {
      text: true,
      content: val
    };
  }, extraText, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
    return {
      images: val
    };
  }, extraImages, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__FeedMeta__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, meta, {
    autoGenerateKey: false
  }));
}

FeedContent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "meta", "summary"];
FeedContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain a date. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: FeedExtra.propTypes.images,

  /** Shorthand for FeedExtra with text. */
  extraText: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedContent);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A feed can contain an extra content.
 */

function FeedExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      images = props.images,
      text = props.text;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(images, 'images'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(content || text, 'text'), 'extra', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(FeedExtra, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(FeedExtra, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  } // TODO need a "collection factory" to handle creating multiple image elements and their keys


  var imageElements = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images, function (image, index) {
    var key = [index, image].join('-');
    return Object(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* createHTMLImage */])(image, {
      key: key
    });
  });

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), content, imageElements);
}

FeedExtra.handledProps = ["as", "children", "className", "content", "images", "text"];
FeedExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain additional information like a set of images. */
  images: customPropTypes.every([customPropTypes.disallow(['text']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.collectionShorthand])]),

  /** An event can contain additional text information. */
  text: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedExtra);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedLike__ = __webpack_require__(295);






/**
 * A feed can contain a meta.
 */

function FeedMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      like = props.like;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('meta', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedMeta, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedMeta, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedLike__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, like, {
    autoGenerateKey: false
  }), content);
}

FeedMeta.handledProps = ["as", "children", "className", "content", "like"];
FeedMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedLike. */
  like: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedMeta);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(42);






/**
 * A feed can contain a like element.
 */

function FeedLike(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('like', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedLike, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedLike, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), content);
}

FeedLike.handledProps = ["as", "children", "className", "content", "icon"];
FeedLike.defaultProps = {
  as: 'a'
};
FeedLike.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for icon. Mutually exclusive with children. */
  icon: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedLike);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedUser__ = __webpack_require__(297);







/**
 * A feed can contain a summary.
 */

function FeedSummary(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      date = props.date,
      user = props.user;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('summary', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedSummary, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedSummary, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedUser__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, user, {
    autoGenerateKey: false
  }), content && ' ', content, content && ' ', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, date, {
    autoGenerateKey: false
  }));
}

FeedSummary.handledProps = ["as", "children", "className", "content", "date", "user"];
FeedSummary.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedUser. */
  user: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedSummary);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A feed can contain a user element.
 */

function FeedUser(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('user', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedUser, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedUser, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

FeedUser.handledProps = ["as", "children", "className", "content"];
FeedUser.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
FeedUser.defaultProps = {
  as: 'a'
};
/* harmony default export */ __webpack_exports__["a"] = (FeedUser);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(42);






/**
 * An event can contain an image or icon label.
 */

function FeedLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon,
      image = props.image;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('label', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedLabel, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedLabel, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), content, __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* createHTMLImage */])(image));
}

FeedLabel.handledProps = ["as", "children", "className", "content", "icon", "image"];
FeedLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedLabel);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * An item can contain a header.
 */

function ItemHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ItemHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ItemHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ItemHeader.handledProps = ["as", "children", "className", "content"];
ItemHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ItemHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemHeader);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * An item can contain a description with a single or multiple paragraphs.
 */

function ItemDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ItemDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ItemDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ItemDescription.handledProps = ["as", "children", "className", "content"];
ItemDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemDescription.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ItemDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemDescription);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * An item can contain extra content meant to be formatted separately from the main content.
 */

function ItemExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('extra', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ItemExtra, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ItemExtra, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ItemExtra.handledProps = ["as", "children", "className", "content"];
ItemExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemExtra.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ItemExtra, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemExtra);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * An item can contain content metadata.
 */

function ItemMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('meta', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ItemMeta, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ItemMeta, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ItemMeta.handledProps = ["as", "children", "className", "content"];
ItemMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemMeta.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ItemMeta, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemMeta);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1190);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(1193);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1194);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1195);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(558);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(202);
/* unused harmony reexport Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(309);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(1196);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Card__ = __webpack_require__(1197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CardColumns__ = __webpack_require__(1198);
/* unused harmony reexport CardColumns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CardDeck__ = __webpack_require__(1199);
/* unused harmony reexport CardDeck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardImg__ = __webpack_require__(560);
/* unused harmony reexport CardImg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardGroup__ = __webpack_require__(1200);
/* unused harmony reexport CardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Carousel__ = __webpack_require__(1201);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CarouselItem__ = __webpack_require__(561);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CloseButton__ = __webpack_require__(201);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Col__ = __webpack_require__(562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_16__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Collapse__ = __webpack_require__(305);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Dropdown__ = __webpack_require__(204);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownButton__ = __webpack_require__(1215);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DropdownItem__ = __webpack_require__(571);
/* unused harmony reexport DropdownItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Fade__ = __webpack_require__(109);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Form__ = __webpack_require__(1216);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FormControl__ = __webpack_require__(573);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FormCheck__ = __webpack_require__(575);
/* unused harmony reexport FormCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FormGroup__ = __webpack_require__(572);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FormLabel__ = __webpack_require__(576);
/* unused harmony reexport FormLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__FormText__ = __webpack_require__(577);
/* unused harmony reexport FormText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Container__ = __webpack_require__(1219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_28__Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Image__ = __webpack_require__(578);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Figure__ = __webpack_require__(1220);
/* unused harmony reexport Figure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__InputGroup__ = __webpack_require__(1223);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Jumbotron__ = __webpack_require__(1224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_32__Jumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ListGroup__ = __webpack_require__(1225);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ListGroupItem__ = __webpack_require__(580);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Media__ = __webpack_require__(1226);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Modal__ = __webpack_require__(1227);
/* unused harmony reexport Modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalBody__ = __webpack_require__(588);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ModalDialog__ = __webpack_require__(589);
/* unused harmony reexport ModalDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ModalFooter__ = __webpack_require__(590);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ModalTitle__ = __webpack_require__(592);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Nav__ = __webpack_require__(593);
/* unused harmony reexport Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Navbar__ = __webpack_require__(1240);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__NavbarBrand__ = __webpack_require__(594);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__NavDropdown__ = __webpack_require__(1243);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__NavItem__ = __webpack_require__(208);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Overlay__ = __webpack_require__(595);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__OverlayTrigger__ = __webpack_require__(1245);
/* unused harmony reexport OverlayTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__PageItem__ = __webpack_require__(596);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Pagination__ = __webpack_require__(1246);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Popover__ = __webpack_require__(1247);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ProgressBar__ = __webpack_require__(1248);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ResponsiveEmbed__ = __webpack_require__(1249);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Row__ = __webpack_require__(1250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_53__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__SafeAnchor__ = __webpack_require__(84);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Spinner__ = __webpack_require__(1251);
/* unused harmony reexport Spinner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__SplitButton__ = __webpack_require__(1252);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Tab__ = __webpack_require__(1253);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__TabContainer__ = __webpack_require__(318);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__TabContent__ = __webpack_require__(319);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Table__ = __webpack_require__(1254);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabPane__ = __webpack_require__(320);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Tabs__ = __webpack_require__(1255);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__ThemeProvider__ = __webpack_require__(13);
/* unused harmony reexport ThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__ToggleButton__ = __webpack_require__(597);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ToggleButtonGroup__ = __webpack_require__(1256);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Tooltip__ = __webpack_require__(1257);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Toast__ = __webpack_require__(1258);
/* unused harmony reexport Toast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ToastBody__ = __webpack_require__(600);
/* unused harmony reexport ToastBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ToastHeader__ = __webpack_require__(598);
/* unused harmony reexport ToastHeader */













































































































































/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_triggerBrowserReflow__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(307);




var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDimensionValue(dimension, elem) {
  var offset = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
  var value = elem[offset];
  var margins = MARGINS[dimension];
  return value + parseInt(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["ENTERED"]] = 'collapse show', _collapseStyles);
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_triggerBrowserReflow__["a" /* default */])(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }
  /* -- Expanding -- */
  ;

  // for testing
  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    var scroll = "scroll" + dimension[0].toUpperCase() + dimension.slice(1);
    return elem[scroll] + "px";
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      addEndListener: __WEBPACK_IMPORTED_MODULE_6_dom_helpers_transition_end___default.a
    }, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = triggerBrowserReflow;
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



/* harmony default export */ __webpack_exports__["a"] = (function (className) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (p, ref) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, p, {
      ref: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(p.className, className)
    }));
  });
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var defaultProps = {
  vertical: false,
  toggle: false,
  role: 'group'
};
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
  var bsPrefix = props.bsPrefix,
      size = props.size,
      toggle = props.toggle,
      vertical = props.vertical,
      className = props.className,
      _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["bsPrefix", "size", "toggle", "vertical", "className", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'btn-group');
  var baseClass = prefix;
  if (vertical) baseClass = prefix + "-vertical";
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, size && prefix + "-" + size, toggle && prefix + "-toggle")
  }));
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_context__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_context__);






var ManagerContext = __WEBPACK_IMPORTED_MODULE_5_create_react_context___default()({
  setReferenceNode: undefined,
  referenceNode: undefined
});

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    _this = _React$Component.call(this) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setReferenceNode", function (referenceNode) {
      if (!referenceNode || _this.state.context.referenceNode === referenceNode) {
        return;
      }

      _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, context, {
            referenceNode: referenceNode
          })
        };
      });
    });

    _this.state = {
      context: {
        setReferenceNode: _this.setReferenceNode,
        referenceNode: undefined
      }
    };
    return _this;
  }

  var _proto = Manager.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](ManagerContext.Provider, {
      value: this.state.context
    }, this.props.children);
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);



/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownContext = _react.default.createContext({
  menuRef: function menuRef() {},
  toggleRef: function toggleRef() {},
  onToggle: function onToggle() {},
  toggleNode: undefined,
  alignEnd: null,
  show: null,
  drop: null
});

var _default = DropdownContext;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var _on = _interopRequireDefault(__webpack_require__(566));

var _off = _interopRequireDefault(__webpack_require__(567));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var NavContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* harmony default export */ __webpack_exports__["a"] = (NavContext);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TabContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* harmony default export */ __webpack_exports__["a"] = (TabContext);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SafeAnchor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AbstractNavItem__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(13);







var defaultProps = {
  disabled: false,
  as: __WEBPACK_IMPORTED_MODULE_4__SafeAnchor__["a" /* default */]
};
var NavLink = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      disabled = _ref.disabled,
      className = _ref.className,
      href = _ref.href,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      as = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "disabled", "className", "href", "eventKey", "onSelect", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'nav-link');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AbstractNavItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    href: href,
    ref: ref,
    eventKey: eventKey,
    as: as,
    disabled: disabled,
    onSelect: onSelect,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, disabled && 'disabled')
  }));
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uncontrollable__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabContext__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectableContext__ = __webpack_require__(67);







var TabContainer =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TabContainer, _React$Component);

  function TabContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.getControlledId = function (key) {
      return _this.getKey(key, 'tabpane');
    };

    _this.getControllerId = function (key) {
      return _this.getKey(key, 'tab');
    };

    _this.state = {
      tabContext: {
        onSelect: _this.props.onSelect,
        activeKey: _this.props.activeKey,
        transition: _this.props.transition,
        mountOnEnter: _this.props.mountOnEnter,
        unmountOnExit: _this.props.unmountOnExit,
        getControlledId: _this.getControlledId,
        getControllerId: _this.getControllerId
      }
    };
    return _this;
  }

  TabContainer.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var activeKey = _ref.activeKey,
        mountOnEnter = _ref.mountOnEnter,
        unmountOnExit = _ref.unmountOnExit,
        transition = _ref.transition;
    return {
      tabContext: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevState.tabContext, {
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        transition: transition
      })
    };
  };

  var _proto = TabContainer.prototype;

  _proto.getKey = function getKey(key, type) {
    var _this$props = this.props,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    if (generateChildId) return generateChildId(key, type);
    return id ? id + "-" + type + "-" + key : null;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        onSelect = _this$props2.onSelect;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TabContext__["a" /* default */].Provider, {
      value: this.state.tabContext
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SelectableContext__["a" /* default */].Provider, {
      value: onSelect
    }, children));
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_uncontrollable__["default"])(TabContainer, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);







var TabContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TabContent, _React$Component);

  function TabContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContent.prototype;

  _proto.render = function render() {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        _this$props$as = _this$props.as,
        Component = _this$props$as === void 0 ? 'div' : _this$props$as,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "as", "className"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix)
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(TabContent, 'tab-content'));

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabContext__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Fade__ = __webpack_require__(109);









function useTabContext(props) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__TabContext__["a" /* default */]);
  if (!context) return props;

  var activeKey = context.activeKey,
      getControlledId = context.getControlledId,
      getControllerId = context.getControllerId,
      rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(context, ["activeKey", "getControlledId", "getControllerId"]);

  var shouldTransition = props.transition !== false && rest.transition !== false;
  var key = Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(props.eventKey);
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    active: props.active == null && key != null ? Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(activeKey) === key : props.active,
    id: getControlledId(props.eventKey),
    'aria-labelledby': getControllerId(props.eventKey),
    transition: shouldTransition && (props.transition || rest.transition || __WEBPACK_IMPORTED_MODULE_7__Fade__["a" /* default */]),
    mountOnEnter: props.mountOnEnter != null ? props.mountOnEnter : rest.mountOnEnter,
    unmountOnExit: props.unmountOnExit != null ? props.unmountOnExit : rest.unmountOnExit
  });
}

var TabPane = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
  var _useTabContext = useTabContext(props),
      bsPrefix = _useTabContext.bsPrefix,
      className = _useTabContext.className,
      active = _useTabContext.active,
      onEnter = _useTabContext.onEnter,
      onEntering = _useTabContext.onEntering,
      onEntered = _useTabContext.onEntered,
      onExit = _useTabContext.onExit,
      onExiting = _useTabContext.onExiting,
      onExited = _useTabContext.onExited,
      mountOnEnter = _useTabContext.mountOnEnter,
      unmountOnExit = _useTabContext.unmountOnExit,
      Transition = _useTabContext.transition,
      _useTabContext$as = _useTabContext.as,
      Component = _useTabContext$as === void 0 ? 'div' : _useTabContext$as,
      _ = _useTabContext.eventKey,
      rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useTabContext, ["bsPrefix", "className", "active", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit", "transition", "as", "eventKey"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'tab-pane');
  if (!active && unmountOnExit) return null;
  var pane = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    ref: ref,
    role: "tabpanel",
    "aria-hidden": !active,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, {
      active: active
    })
  }));
  if (Transition) pane = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Transition, {
    in: active,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    mountOnEnter: mountOnEnter,
    unmountOnExit: mountOnEnter
  }, pane); // We provide an empty the TabContext so `<Nav>`s in `<TabPane>`s don't
  // conflict with the top level one.

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TabContext__["a" /* default */].Provider, {
    value: null
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["a" /* default */].Provider, {
    value: null
  }, pane));
});
TabPane.displayName = 'TabPane';
/* harmony default export */ __webpack_exports__["a"] = (TabPane);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createBreakpoints__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createMixins__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createPalette__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createTypography__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shadows__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__createSpacing__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zIndex__ = __webpack_require__(624);













function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = Object(__WEBPACK_IMPORTED_MODULE_5__createPalette__["a" /* default */])(paletteInput);
  var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_3__createBreakpoints__["a" /* default */])(breakpointsInput);
  var spacing = Object(__WEBPACK_IMPORTED_MODULE_9__createSpacing__["a" /* default */])(spacingInput);
  var muiTheme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: Object(__WEBPACK_IMPORTED_MODULE_4__createMixins__["a" /* default */])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: __WEBPACK_IMPORTED_MODULE_7__shadows__["a" /* default */],
    typography: Object(__WEBPACK_IMPORTED_MODULE_6__createTypography__["a" /* default */])(palette, typographyInput),
    spacing: spacing,
    shape: __WEBPACK_IMPORTED_MODULE_8__shape__["a" /* default */],
    transitions: __WEBPACK_IMPORTED_MODULE_10__transitions__["a" /* default */],
    zIndex: __WEBPACK_IMPORTED_MODULE_11__zIndex__["a" /* default */]
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(acc, argument);
  }, muiTheme);

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

/* harmony default export */ __webpack_exports__["a"] = (createMuiTheme);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(209);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends(_extends({}, styleFunction.propTypes), {}, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var _unused_webpack_default_export = (breakpoints);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getThemeProps__ = __webpack_require__(1294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getThemeProps__["a"]; });


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jssPreset__ = __webpack_require__(1295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__jssPreset__["a"]; });


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeClasses__ = __webpack_require__(1311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeClasses__["a"]; });


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(40);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* unused harmony export EXITED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(329);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["d"] = (Transition);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(1372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useControlled__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormControl_useFormControl__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IconButton__ = __webpack_require__(115);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useControlled__["a" /* default */])({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_8__FormControl_useFormControl__["a" /* default */])();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /*
   * @ignore
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClickAwayListener__ = __webpack_require__(1387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClickAwayListener__["a"]; });


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__ = __webpack_require__(1393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__["a"]; });


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony export (immutable) */ __webpack_exports__["c"] = isHorizontal;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAnchor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Backdrop__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Slide__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(36);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

var Drawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Drawer(props, ref) {
  var _props$anchor = props.anchor,
      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
      BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropPropsProp = _props$ModalProps.BackdropProps,
      ModalProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SlideProps = props.SlideProps,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_8__Slide__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  var mounted = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    mounted.current = true;
  }, []);
  var anchor = getAnchor(theme, anchorProp);
  var drawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.paper, classes["paperAnchor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(anchor))])
  }), children);

  if (variant === 'permanent') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), drawer);
  }

  var slidingDrawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);

  if (variant === 'persistent') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), slidingDrawer);
  } // variant === temporary


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, BackdropProps, BackdropPropsProp, {
      transitionDuration: transitionDuration
    }),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_6__Backdrop__["a" /* default */],
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.modal, className),
    open: open,
    onClose: onClose,
    ref: ref
  }, other, ModalProps), slidingDrawer);
});
 false ? Drawer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Side from which the drawer will appear.
   */
  anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * The contents of the drawer.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The elevation of the drawer.
   */
  elevation: PropTypes.number,

  /**
   * Props applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Props applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDrawer',
  flip: false
})(Drawer));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slide__ = __webpack_require__(1400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Slide__["a"]; });


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__ = __webpack_require__(1408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__["a"]; });


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = isFilled;
/* harmony export (immutable) */ __webpack_exports__["a"] = isAdornedStart;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup__ = __webpack_require__(1411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormGroup__["a"]; });


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormHelperText__ = __webpack_require__(1412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormHelperText__["a"]; });


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormLabel__ = __webpack_require__(1413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormLabel__["a"]; });


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(1422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__["a"]; });


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputLabel__ = __webpack_require__(1427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputLabel__["a"]; });


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinearProgress__ = __webpack_require__(1428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LinearProgress__["a"]; });


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItem__ = __webpack_require__(1431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItem__["a"]; });


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(1437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["a"]; });


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuList__ = __webpack_require__(1438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuList__["a"]; });


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuItem__ = __webpack_require__(1439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuItem__["a"]; });


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoSsr__ = __webpack_require__(1441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NoSsr__["a"]; });


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SnackbarContent__ = __webpack_require__(1457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SnackbarContent__["a"]; });


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepLabel__ = __webpack_require__(1460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepLabel__["a"]; });


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepIcon__ = __webpack_require__(1461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepIcon__["a"]; });


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepConnector__ = __webpack_require__(1464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepConnector__["a"]; });


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableCell__ = __webpack_require__(1473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableCell__["a"]; });


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(1478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabScrollButton__ = __webpack_require__(1488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TabScrollButton__["a"]; });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(742);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(752);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(363);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(766)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(232));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = triggerBrowserReflow;

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

module.exports = exports["default"];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

var _default = createChainedFunction;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(236);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapContextToProps;

var _react = _interopRequireDefault(__webpack_require__(0));

var _forwardRef = _interopRequireDefault(__webpack_require__(233));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getDisplayName = function getDisplayName(Component) {
  var name = typeof Component === 'string' ? Component : Component.name || Component.displayName;
  return name ? "ContextTransform(" + name + ")" : 'ContextTransform';
};

var ensureConsumer = function ensureConsumer(c) {
  return c.Consumer || c;
};

function $mapContextToProps(_ref, Component) {
  var maybeArrayOfConsumers = _ref.consumers,
      mapToProps = _ref.mapToProps,
      displayName = _ref.displayName,
      _ref$forwardRefAs = _ref.forwardRefAs,
      forwardRefAs = _ref$forwardRefAs === void 0 ? 'ref' : _ref$forwardRefAs;
  var consumers = maybeArrayOfConsumers;

  if (!Array.isArray(maybeArrayOfConsumers)) {
    consumers = [maybeArrayOfConsumers];
  }

  var SingleConsumer = ensureConsumer(consumers[0]);

  function singleRender(props, ref) {
    var _extends2;

    var propsWithRef = _extends((_extends2 = {}, _extends2[forwardRefAs] = ref, _extends2), props);

    return _react.default.createElement(SingleConsumer, null, function (value) {
      return _react.default.createElement(Component, _extends({}, propsWithRef, mapToProps(value, props)));
    });
  }

  function multiRender(props, ref) {
    var _extends3;

    var propsWithRef = _extends((_extends3 = {}, _extends3[forwardRefAs] = ref, _extends3), props);

    return consumers.reduceRight(function (inner, Context) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var Consumer = ensureConsumer(Context);
        return _react.default.createElement(Consumer, null, function (value) {
          return inner.apply(void 0, args.concat([value]));
        });
      };
    }, function () {
      for (var _len2 = arguments.length, contexts = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        contexts[_key2] = arguments[_key2];
      }

      return _react.default.createElement(Component, _extends({}, propsWithRef, mapToProps.apply(void 0, contexts.concat([props]))));
    })();
  }

  var contextTransform = consumers.length === 1 ? singleRender : multiRender;
  return (0, _forwardRef.default)(contextTransform, {
    displayName: displayName || getDisplayName(Component)
  });
}

function mapContextToProps(maybeOpts, mapToProps, Component) {
  if (arguments.length === 2) return $mapContextToProps(maybeOpts, mapToProps);
  return $mapContextToProps({
    consumers: maybeOpts,
    mapToProps: mapToProps
  }, Component);
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var NavContext = _react.default.createContext(null);

var _default = NavContext;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = uncontrolledPropTypes;
/* harmony export (immutable) */ __webpack_exports__["c"] = isProp;
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = canAcceptRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);
var settle = __webpack_require__(820);
var buildURL = __webpack_require__(822);
var parseHeaders = __webpack_require__(823);
var isURLSameOrigin = __webpack_require__(824);
var createError = __webpack_require__(375);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(825);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(821);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: _propTypes.default.string.isRequired,
  as: _propTypes.default.elementType
};
var defaultProps = {
  type: 'valid'
};

var Feedback = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      type = _ref.type,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["as", "className", "type"]);
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: (0, _classnames.default)(className, type && type + "-feedback")
  }));
});

Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
Feedback.defaultProps = defaultProps;
var _default = Feedback;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* unused harmony reexport Ref */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addons_Confirm__ = __webpack_require__(851);
/* unused harmony reexport Confirm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addons_MountNode__ = __webpack_require__(459);
/* unused harmony reexport MountNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Pagination__ = __webpack_require__(1054);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Pagination_PaginationItem__ = __webpack_require__(469);
/* unused harmony reexport PaginationItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addons_Portal__ = __webpack_require__(138);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addons_Portal_PortalInner__ = __webpack_require__(448);
/* unused harmony reexport PortalInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addons_Radio__ = __webpack_require__(276);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addons_Responsive__ = __webpack_require__(1069);
/* unused harmony reexport Responsive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_Select__ = __webpack_require__(470);
/* unused harmony reexport Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addons_TextArea__ = __webpack_require__(478);
/* unused harmony reexport TextArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addons_TransitionablePortal__ = __webpack_require__(1087);
/* unused harmony reexport TransitionablePortal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__behaviors_Visibility__ = __webpack_require__(1090);
/* unused harmony reexport Visibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__collections_Breadcrumb__ = __webpack_require__(1092);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__collections_Breadcrumb_BreadcrumbDivider__ = __webpack_require__(482);
/* unused harmony reexport BreadcrumbDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Breadcrumb_BreadcrumbSection__ = __webpack_require__(483);
/* unused harmony reexport BreadcrumbSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__collections_Form__ = __webpack_require__(1094);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__collections_Form_FormButton__ = __webpack_require__(484);
/* unused harmony reexport FormButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__collections_Form_FormCheckbox__ = __webpack_require__(485);
/* unused harmony reexport FormCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__collections_Form_FormDropdown__ = __webpack_require__(486);
/* unused harmony reexport FormDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__collections_Form_FormField__ = __webpack_require__(73);
/* unused harmony reexport FormField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__collections_Form_FormGroup__ = __webpack_require__(487);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__collections_Form_FormInput__ = __webpack_require__(488);
/* unused harmony reexport FormInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__collections_Form_FormRadio__ = __webpack_require__(489);
/* unused harmony reexport FormRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__collections_Form_FormSelect__ = __webpack_require__(490);
/* unused harmony reexport FormSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__collections_Form_FormTextArea__ = __webpack_require__(491);
/* unused harmony reexport FormTextArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__collections_Grid__ = __webpack_require__(1097);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__collections_Grid_GridColumn__ = __webpack_require__(278);
/* unused harmony reexport GridColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__collections_Grid_GridRow__ = __webpack_require__(493);
/* unused harmony reexport GridRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__collections_Menu__ = __webpack_require__(464);
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__collections_Menu_MenuHeader__ = __webpack_require__(466);
/* unused harmony reexport MenuHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__collections_Menu_MenuItem__ = __webpack_require__(275);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__collections_Menu_MenuMenu__ = __webpack_require__(468);
/* unused harmony reexport MenuMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__collections_Message__ = __webpack_require__(1098);
/* unused harmony reexport Message */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__collections_Message_MessageContent__ = __webpack_require__(494);
/* unused harmony reexport MessageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__collections_Message_MessageHeader__ = __webpack_require__(495);
/* unused harmony reexport MessageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__collections_Message_MessageItem__ = __webpack_require__(279);
/* unused harmony reexport MessageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__collections_Message_MessageList__ = __webpack_require__(496);
/* unused harmony reexport MessageList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__collections_Table__ = __webpack_require__(1100);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__collections_Table_TableBody__ = __webpack_require__(497);
/* unused harmony reexport TableBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__collections_Table_TableCell__ = __webpack_require__(196);
/* unused harmony reexport TableCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__collections_Table_TableFooter__ = __webpack_require__(498);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__collections_Table_TableHeader__ = __webpack_require__(280);
/* unused harmony reexport TableHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__collections_Table_TableHeaderCell__ = __webpack_require__(499);
/* unused harmony reexport TableHeaderCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__collections_Table_TableRow__ = __webpack_require__(500);
/* unused harmony reexport TableRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__elements_Button_Button__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_45__elements_Button_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__elements_Button_ButtonContent__ = __webpack_require__(454);
/* unused harmony reexport ButtonContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__elements_Button_ButtonGroup__ = __webpack_require__(455);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__elements_Button_ButtonOr__ = __webpack_require__(456);
/* unused harmony reexport ButtonOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__elements_Container__ = __webpack_require__(1102);
/* unused harmony reexport Container */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__elements_Divider__ = __webpack_require__(1104);
/* unused harmony reexport Divider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__elements_Flag__ = __webpack_require__(474);
/* unused harmony reexport Flag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__elements_Header__ = __webpack_require__(1106);
/* unused harmony reexport Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__elements_Header_HeaderContent__ = __webpack_require__(502);
/* unused harmony reexport HeaderContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__elements_Header_HeaderSubheader__ = __webpack_require__(501);
/* unused harmony reexport HeaderSubheader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__elements_Icon__ = __webpack_require__(42);
/* unused harmony reexport Icon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__elements_Icon_IconGroup__ = __webpack_require__(445);
/* unused harmony reexport IconGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__elements_Image__ = __webpack_require__(108);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__elements_Image_ImageGroup__ = __webpack_require__(451);
/* unused harmony reexport ImageGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__elements_Input__ = __webpack_require__(277);
/* unused harmony reexport Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__elements_Label__ = __webpack_require__(140);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__elements_Label_LabelDetail__ = __webpack_require__(452);
/* unused harmony reexport LabelDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__elements_Label_LabelGroup__ = __webpack_require__(453);
/* unused harmony reexport LabelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__elements_List__ = __webpack_require__(1108);
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__elements_List_ListContent__ = __webpack_require__(281);
/* unused harmony reexport ListContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__elements_List_ListDescription__ = __webpack_require__(197);
/* unused harmony reexport ListDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__elements_List_ListHeader__ = __webpack_require__(198);
/* unused harmony reexport ListHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__elements_List_ListIcon__ = __webpack_require__(282);
/* unused harmony reexport ListIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__elements_List_ListItem__ = __webpack_require__(503);
/* unused harmony reexport ListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__elements_List_ListList__ = __webpack_require__(504);
/* unused harmony reexport ListList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__elements_Loader__ = __webpack_require__(1110);
/* unused harmony reexport Loader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__elements_Placeholder__ = __webpack_require__(1112);
/* unused harmony reexport Placeholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__elements_Placeholder_PlaceholderHeader__ = __webpack_require__(505);
/* unused harmony reexport PlaceholderHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__elements_Placeholder_PlaceholderImage__ = __webpack_require__(506);
/* unused harmony reexport PlaceholderImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__elements_Placeholder_PlaceholderLine__ = __webpack_require__(507);
/* unused harmony reexport PlaceholderLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__elements_Placeholder_PlaceholderParagraph__ = __webpack_require__(508);
/* unused harmony reexport PlaceholderParagraph */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__elements_Rail__ = __webpack_require__(1114);
/* unused harmony reexport Rail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__elements_Reveal__ = __webpack_require__(1116);
/* unused harmony reexport Reveal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__elements_Reveal_RevealContent__ = __webpack_require__(509);
/* unused harmony reexport RevealContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__elements_Segment__ = __webpack_require__(1118);
/* unused harmony reexport Segment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__elements_Segment_SegmentGroup__ = __webpack_require__(511);
/* unused harmony reexport SegmentGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__elements_Segment_SegmentInline__ = __webpack_require__(512);
/* unused harmony reexport SegmentInline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__elements_Step__ = __webpack_require__(1119);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__elements_Step_StepContent__ = __webpack_require__(514);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__elements_Step_StepDescription__ = __webpack_require__(283);
/* unused harmony reexport StepDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__elements_Step_StepGroup__ = __webpack_require__(515);
/* unused harmony reexport StepGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__elements_Step_StepTitle__ = __webpack_require__(284);
/* unused harmony reexport StepTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__modules_Accordion_Accordion__ = __webpack_require__(1121);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__modules_Accordion_AccordionAccordion__ = __webpack_require__(516);
/* unused harmony reexport AccordionAccordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__modules_Accordion_AccordionContent__ = __webpack_require__(287);
/* unused harmony reexport AccordionContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__modules_Accordion_AccordionPanel__ = __webpack_require__(285);
/* unused harmony reexport AccordionPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__modules_Accordion_AccordionTitle__ = __webpack_require__(286);
/* unused harmony reexport AccordionTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__modules_Checkbox__ = __webpack_require__(194);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__modules_Dimmer__ = __webpack_require__(447);
/* unused harmony reexport Dimmer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__modules_Dimmer_DimmerDimmable__ = __webpack_require__(449);
/* unused harmony reexport DimmerDimmable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__modules_Dimmer_DimmerInner__ = __webpack_require__(450);
/* unused harmony reexport DimmerInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__modules_Dropdown__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_96__modules_Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__modules_Dropdown_DropdownDivider__ = __webpack_require__(472);
/* unused harmony reexport DropdownDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__modules_Dropdown_DropdownHeader__ = __webpack_require__(475);
/* unused harmony reexport DropdownHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__modules_Dropdown_DropdownItem__ = __webpack_require__(473);
/* unused harmony reexport DropdownItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__modules_Dropdown_DropdownMenu__ = __webpack_require__(476);
/* unused harmony reexport DropdownMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__modules_Dropdown_DropdownSearchInput__ = __webpack_require__(477);
/* unused harmony reexport DropdownSearchInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__modules_Embed__ = __webpack_require__(1122);
/* unused harmony reexport Embed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__modules_Modal__ = __webpack_require__(457);
/* unused harmony reexport Modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__modules_Modal_ModalActions__ = __webpack_require__(462);
/* unused harmony reexport ModalActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__modules_Modal_ModalContent__ = __webpack_require__(461);
/* unused harmony reexport ModalContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__modules_Modal_ModalDescription__ = __webpack_require__(463);
/* unused harmony reexport ModalDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__modules_Modal_ModalHeader__ = __webpack_require__(460);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__modules_Popup__ = __webpack_require__(1124);
/* unused harmony reexport Popup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__modules_Popup_PopupContent__ = __webpack_require__(528);
/* unused harmony reexport PopupContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__modules_Popup_PopupHeader__ = __webpack_require__(529);
/* unused harmony reexport PopupHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__modules_Progress__ = __webpack_require__(1160);
/* unused harmony reexport Progress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__modules_Rating__ = __webpack_require__(1165);
/* unused harmony reexport Rating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__modules_Rating_RatingIcon__ = __webpack_require__(530);
/* unused harmony reexport RatingIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__modules_Search__ = __webpack_require__(1168);
/* unused harmony reexport Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__modules_Search_SearchCategory__ = __webpack_require__(531);
/* unused harmony reexport SearchCategory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__modules_Search_SearchResult__ = __webpack_require__(532);
/* unused harmony reexport SearchResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__modules_Search_SearchResults__ = __webpack_require__(533);
/* unused harmony reexport SearchResults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__modules_Sidebar__ = __webpack_require__(1172);
/* unused harmony reexport Sidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__modules_Sidebar_SidebarPushable__ = __webpack_require__(535);
/* unused harmony reexport SidebarPushable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__modules_Sidebar_SidebarPusher__ = __webpack_require__(536);
/* unused harmony reexport SidebarPusher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__modules_Sticky__ = __webpack_require__(1177);
/* unused harmony reexport Sticky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__modules_Tab__ = __webpack_require__(1179);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__modules_Tab_TabPane__ = __webpack_require__(537);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__modules_Transition__ = __webpack_require__(479);
/* unused harmony reexport Transition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__modules_Transition_TransitionGroup__ = __webpack_require__(481);
/* unused harmony reexport TransitionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_Advertisement__ = __webpack_require__(1181);
/* unused harmony reexport Advertisement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_Card_Card__ = __webpack_require__(538);
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_Card_CardContent__ = __webpack_require__(539);
/* unused harmony reexport CardContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_Card_CardDescription__ = __webpack_require__(289);
/* unused harmony reexport CardDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_Card_CardGroup__ = __webpack_require__(540);
/* unused harmony reexport CardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_Card_CardHeader__ = __webpack_require__(290);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_Card_CardMeta__ = __webpack_require__(291);
/* unused harmony reexport CardMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_Comment__ = __webpack_require__(1183);
/* unused harmony reexport Comment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_Comment_CommentAction__ = __webpack_require__(541);
/* unused harmony reexport CommentAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_Comment_CommentActions__ = __webpack_require__(542);
/* unused harmony reexport CommentActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_Comment_CommentAuthor__ = __webpack_require__(543);
/* unused harmony reexport CommentAuthor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_Comment_CommentAvatar__ = __webpack_require__(544);
/* unused harmony reexport CommentAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_Comment_CommentContent__ = __webpack_require__(545);
/* unused harmony reexport CommentContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_Comment_CommentGroup__ = __webpack_require__(546);
/* unused harmony reexport CommentGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_Comment_CommentMetadata__ = __webpack_require__(547);
/* unused harmony reexport CommentMetadata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__views_Comment_CommentText__ = __webpack_require__(548);
/* unused harmony reexport CommentText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__views_Feed__ = __webpack_require__(1185);
/* unused harmony reexport Feed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__views_Feed_FeedContent__ = __webpack_require__(292);
/* unused harmony reexport FeedContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__views_Feed_FeedDate__ = __webpack_require__(200);
/* unused harmony reexport FeedDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__views_Feed_FeedEvent__ = __webpack_require__(549);
/* unused harmony reexport FeedEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__views_Feed_FeedExtra__ = __webpack_require__(293);
/* unused harmony reexport FeedExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__views_Feed_FeedLabel__ = __webpack_require__(298);
/* unused harmony reexport FeedLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__views_Feed_FeedLike__ = __webpack_require__(295);
/* unused harmony reexport FeedLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__views_Feed_FeedMeta__ = __webpack_require__(294);
/* unused harmony reexport FeedMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__views_Feed_FeedSummary__ = __webpack_require__(296);
/* unused harmony reexport FeedSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__views_Feed_FeedUser__ = __webpack_require__(297);
/* unused harmony reexport FeedUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__views_Item__ = __webpack_require__(1187);
/* unused harmony reexport Item */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__views_Item_ItemContent__ = __webpack_require__(551);
/* unused harmony reexport ItemContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__views_Item_ItemDescription__ = __webpack_require__(300);
/* unused harmony reexport ItemDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__views_Item_ItemExtra__ = __webpack_require__(301);
/* unused harmony reexport ItemExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__views_Item_ItemGroup__ = __webpack_require__(552);
/* unused harmony reexport ItemGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__views_Item_ItemHeader__ = __webpack_require__(299);
/* unused harmony reexport ItemHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__views_Item_ItemImage__ = __webpack_require__(553);
/* unused harmony reexport ItemImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__views_Item_ItemMeta__ = __webpack_require__(302);
/* unused harmony reexport ItemMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__views_Statistic__ = __webpack_require__(1188);
/* unused harmony reexport Statistic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__views_Statistic_StatisticGroup__ = __webpack_require__(555);
/* unused harmony reexport StatisticGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__views_Statistic_StatisticLabel__ = __webpack_require__(556);
/* unused harmony reexport StatisticLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__views_Statistic_StatisticValue__ = __webpack_require__(557);
/* unused harmony reexport StatisticValue */
// Third party
 // Addons






















 // Behaviors


 // Collections
































































 // Elements




















































































 // Modules














































































 // Views














































































/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefFindNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handleRef__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(160);













var RefFindNode =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(RefFindNode, _React$Component);

  function RefFindNode() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, RefFindNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(RefFindNode)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "prevNode", null);

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RefFindNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.prevNode = __WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"](this);
      Object(__WEBPACK_IMPORTED_MODULE_10__handleRef__["a" /* default */])(this.props.innerRef, this.prevNode);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var currentNode = __WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"](this);

      if (this.prevNode !== currentNode) {
        this.prevNode = currentNode;
        Object(__WEBPACK_IMPORTED_MODULE_10__handleRef__["a" /* default */])(this.props.innerRef, currentNode);
      }

      if (prevProps.innerRef !== this.props.innerRef) {
        Object(__WEBPACK_IMPORTED_MODULE_10__handleRef__["a" /* default */])(this.props.innerRef, currentNode);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object(__WEBPACK_IMPORTED_MODULE_10__handleRef__["a" /* default */])(this.props.innerRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return RefFindNode;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(RefFindNode, "displayName", 'RefFindNode');

Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(RefFindNode, "propTypes",  false ? {
  children: PropTypes.element.isRequired,
  innerRef: refPropType.isRequired
} : {});



/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefForward; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handleRef__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(160);












var RefForward =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(RefForward, _React$Component);

  function RefForward() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, RefForward);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(RefForward)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "handleRefOverride", function (node) {
      var _this$props = _this.props,
          children = _this$props.children,
          innerRef = _this$props.innerRef;
      Object(__WEBPACK_IMPORTED_MODULE_9__handleRef__["a" /* default */])(children.ref, node);
      Object(__WEBPACK_IMPORTED_MODULE_9__handleRef__["a" /* default */])(innerRef, node);
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RefForward, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return __WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"](children, {
        ref: this.handleRefOverride
      });
    }
  }]);

  return RefForward;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(RefForward, "displayName", 'RefForward');

Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(RefForward, "propTypes",  false ? {
  children: PropTypes.element.isRequired,
  innerRef: refPropType.isRequired
} : {});



/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(122),
    isArguments = __webpack_require__(124),
    isArray = __webpack_require__(26),
    isIndex = __webpack_require__(125),
    isLength = __webpack_require__(250),
    toKey = __webpack_require__(91);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(857);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(166);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDefaultPropName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAutoControlledStateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoControlledComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_startsWith__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_intersection__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_each__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);


















var getDefaultPropName = function getDefaultPropName(prop) {
  return "default".concat(prop[0].toUpperCase() + prop.slice(1));
};
/**
 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
 *  - regular props
 *  - then, default props
 *  - then, initial state
 *  - then, `checked` defaults to false
 *  - then, `value` defaults to '' or [] if props.multiple
 *  - else, undefined
 *
 *  @param {string} propName A prop name
 *  @param {object} [props] A props object
 *  @param {object} [state] A state object
 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
 */

var getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
  var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // regular props
  var propValue = props[propName];
  if (propValue !== undefined) return propValue;

  if (includeDefaults) {
    // defaultProps
    var defaultProp = props[getDefaultPropName(propName)];
    if (defaultProp !== undefined) return defaultProp; // initial state - state may be null or undefined

    if (state) {
      var initialState = state[propName];
      if (initialState !== undefined) return initialState;
    }
  } // React doesn't allow changing from uncontrolled to controlled components,
  // default checked/value if they were not present.


  if (propName === 'checked') return false;
  if (propName === 'value') return props.multiple ? [] : ''; // otherwise, undefined
};

var AutoControlledComponent =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AutoControlledComponent, _Component);

  function AutoControlledComponent() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AutoControlledComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AutoControlledComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "trySetState", function (state, callback) {
      var newState = Object.keys(state).reduce(function (acc, prop) {
        // ignore props defined by the parent
        if (_this.props[prop] !== undefined) return acc;
        acc[prop] = state[prop];
        return acc;
      }, {});
      if (Object.keys(newState).length > 0) _this.setState(newState, callback);
    });

    var autoControlledProps = _this.constructor.autoControlledProps;

    var _state = __WEBPACK_IMPORTED_MODULE_16_lodash_invoke___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), 'getInitialAutoControlledState', _this.props) || {};

    if (false) {
      var _this$constructor = _this.constructor,
          defaultProps = _this$constructor.defaultProps,
          name = _this$constructor.name,
          propTypes = _this$constructor.propTypes; // require static autoControlledProps

      if (!autoControlledProps) {
        console.error("Auto controlled ".concat(name, " must specify a static autoControlledProps array."));
      } // require propTypes


      _each(autoControlledProps, function (prop) {
        var defaultProp = getDefaultPropName(prop); // regular prop

        if (!_has(propTypes, defaultProp)) {
          console.error("".concat(name, " is missing \"").concat(defaultProp, "\" propTypes validation for auto controlled prop \"").concat(prop, "\"."));
        } // its default prop


        if (!_has(propTypes, prop)) {
          console.error("".concat(name, " is missing propTypes validation for auto controlled prop \"").concat(prop, "\"."));
        }
      }); // prevent autoControlledProps in defaultProps
      //
      // When setting state, auto controlled props values always win (so the parent can manage them).
      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
      // Auto controlled props also listed in defaultProps can never be updated.
      //
      // To set defaults for an AutoControlled prop, you can set the initial state in the
      // constructor or by using an ES7 property initializer:
      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers


      var illegalDefaults = _intersection(autoControlledProps, _keys(defaultProps));

      if (!_isEmpty(illegalDefaults)) {
        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', "See ".concat(name, " props: \"").concat(illegalDefaults, "\".")].join(' '));
      } // prevent listing defaultProps in autoControlledProps
      //
      // Default props are automatically handled.
      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.


      var illegalAutoControlled = _filter(autoControlledProps, function (prop) {
        return _startsWith(prop, 'default');
      });

      if (!_isEmpty(illegalAutoControlled)) {
        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', "See ".concat(name, " autoControlledProps: \"").concat(illegalAutoControlled, "\".")].join(' '));
      }
    } // Auto controlled props are copied to state.
    // Set initial state by copying auto controlled props to state.
    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
    // so we can set initial values from defaults.


    var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
      acc[prop] = getAutoControlledStateValue(prop, _this.props, _state, true);

      if (false) {
        var defaultPropName = getDefaultPropName(prop);
        var _name = _this.constructor.name; // prevent defaultFoo={} along side foo={}

        if (!_isUndefined(_this.props[defaultPropName]) && !_isUndefined(_this.props[prop])) {
          console.error("".concat(_name, " prop \"").concat(prop, "\" is auto controlled. Specify either ").concat(defaultPropName, " or ").concat(prop, ", but not both."));
        }
      }

      return acc;
    }, {});
    _this.state = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _state, initialAutoControlledState);
    return _this;
  } // eslint-disable-next-line camelcase


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AutoControlledComponent, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var autoControlledProps = this.constructor.autoControlledProps; // Solve the next state for autoControlledProps

      var newState = autoControlledProps.reduce(function (acc, prop) {
        var isNextDefined = !__WEBPACK_IMPORTED_MODULE_8_lodash_isUndefined___default()(nextProps[prop]); // if next is defined then use its value

        if (isNextDefined) acc[prop] = nextProps[prop];
        return acc;
      }, {});
      if (Object.keys(newState).length > 0) this.setState(newState);
    }
    /**
     * Safely attempt to set state for props that might be controlled by the user.
     * Second argument is a state object that is always passed to setState.
     * @param {object} state State that corresponds to controlled props.
     * @param {function} [callback] Callback which is called after setState applied.
     */

  }]);

  return AutoControlledComponent;
}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);



/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(392),
    baseToString = __webpack_require__(165),
    toInteger = __webpack_require__(72),
    toString = __webpack_require__(64);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(885);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(396),
    isArguments = __webpack_require__(124),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(104),
    isIndex = __webpack_require__(125),
    isTypedArray = __webpack_require__(128);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(175),
    arraySome = __webpack_require__(399),
    cacheHas = __webpack_require__(176);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(44);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(403),
    getSymbols = __webpack_require__(256),
    keys = __webpack_require__(48);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(255),
    isArray = __webpack_require__(26);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90),
    root = __webpack_require__(44);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90),
    root = __webpack_require__(44);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(906),
    hasPath = __webpack_require__(382);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71),
    baseIntersection = __webpack_require__(909),
    baseRest = __webpack_require__(80),
    castArrayLikeObject = __webpack_require__(912);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(65);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(923),
    findIndex = __webpack_require__(415);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(412),
    baseIteratee = __webpack_require__(49),
    toInteger = __webpack_require__(72);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(65),
    metaMap = __webpack_require__(417);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(406);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(419),
    composeArgsRight = __webpack_require__(420),
    countHolders = __webpack_require__(937),
    createCtor = __webpack_require__(181),
    createRecurry = __webpack_require__(421),
    getHolder = __webpack_require__(266),
    reorder = __webpack_require__(944),
    replaceHolders = __webpack_require__(182),
    root = __webpack_require__(44);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(422),
    setData = __webpack_require__(424),
    setWrapToString = __webpack_require__(425);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(261),
    getData = __webpack_require__(263),
    getFuncName = __webpack_require__(423),
    lodash = __webpack_require__(939);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(938);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(416),
    shortOut = __webpack_require__(389);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(941),
    insertWrapDetails = __webpack_require__(942),
    setToString = __webpack_require__(251),
    updateWrapDetails = __webpack_require__(943);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(134),
    keys = __webpack_require__(48);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(174),
    arrayEach = __webpack_require__(131),
    assignValue = __webpack_require__(267),
    baseAssign = __webpack_require__(426),
    baseAssignIn = __webpack_require__(948),
    cloneBuffer = __webpack_require__(428),
    copyArray = __webpack_require__(107),
    copySymbols = __webpack_require__(951),
    copySymbolsIn = __webpack_require__(952),
    getAllKeys = __webpack_require__(402),
    getAllKeysIn = __webpack_require__(430),
    getTag = __webpack_require__(81),
    initCloneArray = __webpack_require__(953),
    initCloneByTag = __webpack_require__(954),
    initCloneObject = __webpack_require__(432),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(104),
    isMap = __webpack_require__(958),
    isObject = __webpack_require__(47),
    isSet = __webpack_require__(960),
    keys = __webpack_require__(48);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(44);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253)(module)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(255),
    getPrototype = __webpack_require__(184),
    getSymbols = __webpack_require__(256),
    stubArray = __webpack_require__(404);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(403),
    getSymbolsIn = __webpack_require__(429),
    keysIn = __webpack_require__(183);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(268);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(133),
    getPrototype = __webpack_require__(184),
    isPrototype = __webpack_require__(173);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(175),
    arrayIncludes = __webpack_require__(178),
    arrayIncludesWith = __webpack_require__(257),
    arrayMap = __webpack_require__(71),
    baseUnary = __webpack_require__(93),
    cacheHas = __webpack_require__(176);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(167),
    baseSet = __webpack_require__(435),
    castPath = __webpack_require__(122);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(267),
    castPath = __webpack_require__(122),
    isIndex = __webpack_require__(125),
    isObject = __webpack_require__(47),
    toKey = __webpack_require__(91);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(92),
    isArrayLike = __webpack_require__(58);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('map', __webpack_require__(30));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('flow', __webpack_require__(999));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy of sindre's leven, wrapped in dead code elimination for production
// https://github.com/sindresorhus/leven/blob/master/index.js

/* eslint-disable complexity, import/no-mutable-exports, no-multi-assign, no-nested-ternary, no-plusplus */
var leven = function leven() {
  return 0;
};

if (false) {
  var arr = [];
  var charCodeCache = [];

  leven = function leven(a, b) {
    if (a === b) return 0;
    var aLen = a.length;
    var bLen = b.length;
    if (aLen === 0) return bLen;
    if (bLen === 0) return aLen;
    var bCharCode;
    var ret;
    var tmp;
    var tmp2;
    var i = 0;
    var j = 0;

    while (i < aLen) {
      charCodeCache[i] = a.charCodeAt(i);
      arr[i] = ++i;
    }

    while (j < bLen) {
      bCharCode = b.charCodeAt(j);
      tmp = j++;
      ret = j;

      for (i = 0; i < aLen; i++) {
        tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
        tmp = arr[i];
        ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
      }
    }

    return ret;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (leven);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(175),
    arrayIncludes = __webpack_require__(178),
    arrayIncludesWith = __webpack_require__(257),
    cacheHas = __webpack_require__(176),
    createSet = __webpack_require__(1006),
    setToArray = __webpack_require__(177);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var baseInRange = __webpack_require__(1015),
    toFinite = __webpack_require__(252),
    toNumber = __webpack_require__(169);

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

module.exports = inRange;


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createEllipsisItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createPrevItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPageFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createNextItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLastItem; });
/**
 * @param {number} pageNumber
 * @return {Object}
 */
var createEllipsisItem = function createEllipsisItem(pageNumber) {
  return {
    active: false,
    type: 'ellipsisItem',
    value: pageNumber
  };
};
/**
 * @return {Object}
 */

var createFirstPage = function createFirstPage() {
  return {
    active: false,
    type: 'firstItem',
    value: 1
  };
};
/**
 * @param {number} activePage
 * @return {Object}
 */

var createPrevItem = function createPrevItem(activePage) {
  return {
    active: false,
    type: 'prevItem',
    value: Math.max(1, activePage - 1)
  };
};
/**
 * @param {number} activePage
 * @return {function}
 */

var createPageFactory = function createPageFactory(activePage) {
  return function (pageNumber) {
    return {
      active: activePage === pageNumber,
      type: 'pageItem',
      value: pageNumber
    };
  };
};
/**
 * @param {number} activePage
 * @param {number} totalPages
 * @return {Object}
 */

var createNextItem = function createNextItem(activePage, totalPages) {
  return {
    active: false,
    type: 'nextItem',
    value: Math.min(activePage + 1, totalPages)
  };
};
/**
 * @param {number} totalPages
 * @return {Object}
 */

var createLastItem = function createLastItem(totalPages) {
  return {
    active: false,
    type: 'lastItem',
    value: totalPages
  };
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(254);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * Several icons can be used together as a group.
 */

function IconGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(size, 'icons', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(IconGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(IconGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

IconGroup.handledProps = ["as", "children", "className", "content", "size"];
IconGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Size of the icon group. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
IconGroup.defaultProps = {
  as: 'i'
};
/* harmony default export */ __webpack_exports__["a"] = (IconGroup);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Dimmer__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Label_Label__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImageGroup__ = __webpack_require__(451);










/**
 * An image is a graphic representation of something.
 * @see Icon
 */

function Image(props) {
  var avatar = props.avatar,
      bordered = props.bordered,
      centered = props.centered,
      children = props.children,
      circular = props.circular,
      className = props.className,
      content = props.content,
      dimmer = props.dimmer,
      disabled = props.disabled,
      floated = props.floated,
      fluid = props.fluid,
      hidden = props.hidden,
      href = props.href,
      inline = props.inline,
      label = props.label,
      rounded = props.rounded,
      size = props.size,
      spaced = props.spaced,
      verticalAlign = props.verticalAlign,
      wrapped = props.wrapped,
      ui = props.ui;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(ui, 'ui'), size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(avatar, 'avatar'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(bordered, 'bordered'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(inline, 'inline'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(rounded, 'rounded'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(spaced, 'spaced'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["D" /* useVerticalAlignProp */])(verticalAlign, 'aligned'), 'image', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(Image, props);

  var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["x" /* partitionHTMLProps */])(rest, {
    htmlProps: __WEBPACK_IMPORTED_MODULE_6__lib__["r" /* htmlImageProps */]
  }),
      _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
      imgTagProps = _partitionHTMLProps2[0],
      rootProps = _partitionHTMLProps2[1];

  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(Image, props, function () {
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(dimmer) || !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(label) || !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(wrapped) || !__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
      return 'div';
    }
  });

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  if (ElementType === 'img') {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rootProps, imgTagProps, {
      className: classes
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rootProps, {
    className: classes,
    href: href
  }), __WEBPACK_IMPORTED_MODULE_7__modules_Dimmer__["a" /* default */].create(dimmer, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_8__Label_Label__["a" /* default */].create(label, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img", imgTagProps));
}

Image.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"];
Image.Group = __WEBPACK_IMPORTED_MODULE_9__ImageGroup__["a" /* default */];
Image.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An image may be formatted to appear inline with text as an avatar. */
  avatar: PropTypes.bool,

  /** An image may include a border to emphasize the edges of white or transparent content. */
  bordered: PropTypes.bool,

  /** An image can appear centered in a content block. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** An image may appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An image can show that it is disabled and cannot be selected. */
  disabled: PropTypes.bool,

  /** Shorthand for Dimmer. */
  dimmer: customPropTypes.itemShorthand,

  /** An image can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** An image can take up the width of its container. */
  fluid: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['size'])]),

  /** An image can be hidden. */
  hidden: PropTypes.bool,

  /** Renders the Image as an <a> tag with this href. */
  href: PropTypes.string,

  /** An image may appear inline. */
  inline: PropTypes.bool,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /** An image may appear rounded. */
  rounded: PropTypes.bool,

  /** An image may appear at different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
  spaced: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Whether or not to add the ui className. */
  ui: PropTypes.bool,

  /** An image can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
  wrapped: PropTypes.bool
} : {};
Image.defaultProps = {
  as: 'img',
  ui: true
};
Image.create = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["l" /* createShorthandFactory */])(Image, function (value) {
  return {
    src: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dimmer__ = __webpack_require__(1031);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dimmer__["a"]; });



/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(5);














/**
 * An inner component that allows you to render children outside their parent.
 */
var PortalInner =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PortalInner, _Component);

  function PortalInner() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PortalInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PortalInner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleRef", function (c) {
      Object(__WEBPACK_IMPORTED_MODULE_8__stardust_ui_react_component_ref__["b" /* handleRef */])(_this.props.innerRef, c);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PortalInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(this.props, 'onMount', null, this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(this.props, 'onUnmount', null, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_12__lib__["t" /* isBrowser */])()) return null;
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$mountNode = _this$props.mountNode,
          mountNode = _this$props$mountNode === void 0 ? document.body : _this$props$mountNode;
      return Object(__WEBPACK_IMPORTED_MODULE_11_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.handleRef
      }, children), mountNode);
    }
  }]);

  return PortalInner;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PortalInner, "handledProps", ["children", "innerRef", "mountNode", "onMount", "onUnmount"]);

PortalInner.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Called with a ref to the inner node. */
  innerRef: customPropTypes.ref,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /**
   * Called when the portal is mounted on the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PortalInner);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A dimmable sub-component for Dimmer.
 */

function DimmerDimmable(props) {
  var blurring = props.blurring,
      className = props.className,
      children = props.children,
      content = props.content,
      dimmed = props.dimmed;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(blurring, 'blurring'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(dimmed, 'dimmed'), 'dimmable', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(DimmerDimmable, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(DimmerDimmable, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

DimmerDimmable.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"];
DimmerDimmable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A dimmable element can blur its contents. */
  blurring: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DimmerDimmable);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DimmerInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);














/**
 * An inner element for a Dimmer.
 */

var DimmerInner =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DimmerInner, _Component);

  function DimmerInner() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DimmerInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DimmerInner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "containerRef", Object(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "contentRef", Object(__WEBPACK_IMPORTED_MODULE_12_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var contentRef = _this.contentRef.current;

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);

      if (contentRef && contentRef !== e.target && Object(__WEBPACK_IMPORTED_MODULE_13__lib__["m" /* doesNodeContainClick */])(contentRef, e)) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClickOutside', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DimmerInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var active = this.props.active;
      this.toggleStyles(active);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var currentActive = this.props.active;
      var prevActive = prevProps.active;
      if (prevActive !== currentActive) this.toggleStyles(currentActive);
    }
  }, {
    key: "toggleStyles",
    value: function toggleStyles(active) {
      var containerRef = this.containerRef.current;
      if (!containerRef || !containerRef.style) return;

      if (active) {
        containerRef.style.setProperty('display', 'flex', 'important');
      } else {
        containerRef.style.removeProperty('display');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          disabled = _this$props.disabled,
          inverted = _this$props.inverted,
          page = _this$props.page,
          simple = _this$props.simple,
          verticalAlign = _this$props.verticalAlign;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active transition visible'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(page, 'page'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(simple, 'simple'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["D" /* useVerticalAlignProp */])(verticalAlign), 'dimmer', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(DimmerInner, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(DimmerInner, this.props);
      var childrenContent = __WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children) ? content : children;
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.containerRef
      }, __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), childrenContent && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", {
        className: "content",
        ref: this.contentRef
      }, childrenContent)));
    }
  }]);

  return DimmerInner;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DimmerInner, "handledProps", ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"]);


DimmerInner.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled dimmer cannot be activated */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Handles click outside Dimmer's content, but inside Dimmer area.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClickOutside: PropTypes.func,

  /** A dimmer can be formatted to have its colors inverted. */
  inverted: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool,

  /** A dimmer can be controlled with simple prop. */
  simple: PropTypes.bool,

  /** A dimmer can have its content top or bottom aligned. */
  verticalAlign: PropTypes.oneOf(['bottom', 'top'])
} : {};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A group of images.
 */

function ImageGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', size, className, 'images');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ImageGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ImageGroup, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ImageGroup.handledProps = ["as", "children", "className", "content", "size"];
ImageGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of images can be formatted to have the same size. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ImageGroup);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);






function LabelDetail(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('detail', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(LabelDetail, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(LabelDetail, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

LabelDetail.handledProps = ["as", "children", "className", "content"];
LabelDetail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
LabelDetail.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(LabelDetail, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (LabelDetail);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A label can be grouped.
 */

function LabelGroup(props) {
  var children = props.children,
      circular = props.circular,
      className = props.className,
      color = props.color,
      content = props.content,
      size = props.size,
      tag = props.tag;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(tag, 'tag'), 'labels', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(LabelGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(LabelGroup, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

LabelGroup.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"];
LabelGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Labels can share shapes. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Label group can share colors together. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Label group can share sizes together. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Label group can share tag formatting. */
  tag: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (LabelGroup);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * Used in some Button types, such as `animated`.
 */

function ButtonContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(visible, 'visible'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(hidden, 'hidden'), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ButtonContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ButtonContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ButtonContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
ButtonContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initially hidden, visible on hover. */
  hidden: PropTypes.bool,

  /** Initially visible, hidden on hover. */
  visible: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(273);








/**
 * Buttons can be grouped.
 */

function ButtonGroup(props) {
  var attached = props.attached,
      basic = props.basic,
      buttons = props.buttons,
      children = props.children,
      className = props.className,
      color = props.color,
      compact = props.compact,
      content = props.content,
      floated = props.floated,
      fluid = props.fluid,
      icon = props.icon,
      inverted = props.inverted,
      labeled = props.labeled,
      negative = props.negative,
      positive = props.positive,
      primary = props.primary,
      secondary = props.secondary,
      size = props.size,
      toggle = props.toggle,
      vertical = props.vertical,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(icon, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(labeled, 'labeled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(primary, 'primary'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(toggle, 'toggle'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useWidthProp */])(widths), 'buttons', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(ButtonGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(ButtonGroup, props);

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(buttons)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(buttons, function (button) {
    return __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].create(button);
  }));
}

ButtonGroup.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"];
ButtonGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Groups can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** Groups can be less pronounced. */
  basic: PropTypes.bool,

  /** Array of shorthand Button values. */
  buttons: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Groups can have a shared color. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Groups can reduce their padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Groups can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Groups can take the width of their container. */
  fluid: PropTypes.bool,

  /** Groups can be formatted as icons. */
  icon: PropTypes.bool,

  /** Groups can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Groups can be formatted as labeled icon buttons. */
  labeled: PropTypes.bool,

  /** Groups can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /** Groups can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** Groups can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Groups can be formatted to toggle on and off. */
  toggle: PropTypes.bool,

  /** Groups can be formatted to appear vertically. */
  vertical: PropTypes.bool,

  /** Groups can have their widths divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * Button groups can contain conditionals.
 */

function ButtonOr(props) {
  var className = props.className,
      text = props.text;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('or', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ButtonOr, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ButtonOr, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes,
    "data-text": text
  }));
}

ButtonOr.handledProps = ["as", "className", "text"];
ButtonOr.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** Or buttons can have their text localized, or adjusted by using the text prop. */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonOr);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1033);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 458 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MountNode__ = __webpack_require__(1035);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MountNode__["a"]; });



/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A modal can have a header.
 */

function ModalHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'header');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ModalHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ModalHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ModalHeader.handledProps = ["as", "children", "className", "content"];
ModalHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ModalHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ModalHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A modal can contain content.
 */

function ModalContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image,
      scrolling = props.scrolling;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(image, 'image'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(scrolling, 'scrolling'), 'content');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ModalContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ModalContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ModalContent.handledProps = ["as", "children", "className", "content", "image", "scrolling"];
ModalContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A modal can contain image content. */
  image: PropTypes.bool,

  /** A modal can use the entire size of the screen. */
  scrolling: PropTypes.bool
} : {};
ModalContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(ModalContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalContent);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Button__ = __webpack_require__(190);















/**
 * A modal can contain a row of actions.
 */

var ModalActions =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ModalActions, _Component);

  function ModalActions() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ModalActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ModalActions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleButtonOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onActionClick', e, buttonProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ModalActions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          actions = _this$props.actions,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('actions', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(ModalActions, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(ModalActions, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), content);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(actions, function (action) {
        return __WEBPACK_IMPORTED_MODULE_14__elements_Button__["a" /* default */].create(action, {
          overrideProps: _this2.handleButtonOverrides
        });
      }));
    }
  }]);

  return ModalActions;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ModalActions, "handledProps", ["actions", "as", "children", "className", "content", "onActionClick"]);


ModalActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Array of shorthand buttons. */
  actions: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props from the clicked action.
   */
  onActionClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func])
} : {};
ModalActions.create = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["l" /* createShorthandFactory */])(ModalActions, function (actions) {
  return {
    actions: actions
  };
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A modal can contain a description with one or more paragraphs.
 */

function ModalDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ModalDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ModalDescription, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ModalDescription.handledProps = ["as", "children", "className", "content"];
ModalDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ModalDescription);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });



/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MenuHeader__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MenuItem__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MenuMenu__ = __webpack_require__(468);


















/**
 * A menu displays grouped navigation actions.
 * @see Dropdown
 */

var Menu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Menu, _Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          var index = itemProps.index;

          _this.trySetState({
            activeIndex: index
          });

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onItemClick', e, itemProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Menu, [{
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var items = this.props.items;
      var activeIndex = this.state.activeIndex;
      return __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(items, function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_16__MenuItem__["a" /* default */].create(item, {
          defaultProps: {
            active: parseInt(activeIndex, 10) === index,
            index: index
          },
          overrideProps: _this2.handleItemOverrides
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attached = _this$props.attached,
          borderless = _this$props.borderless,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          compact = _this$props.compact,
          fixed = _this$props.fixed,
          floated = _this$props.floated,
          fluid = _this$props.fluid,
          icon = _this$props.icon,
          inverted = _this$props.inverted,
          pagination = _this$props.pagination,
          pointing = _this$props.pointing,
          secondary = _this$props.secondary,
          size = _this$props.size,
          stackable = _this$props.stackable,
          tabular = _this$props.tabular,
          text = _this$props.text,
          vertical = _this$props.vertical,
          widths = _this$props.widths;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(borderless, 'borderless'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(pagination, 'pagination'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(pointing, 'pointing'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(text, 'text'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["y" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["z" /* useKeyOrValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["z" /* useKeyOrValueAndKey */])(icon, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["z" /* useKeyOrValueAndKey */])(tabular, 'tabular'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["C" /* useValueAndKey */])(fixed, 'fixed'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["E" /* useWidthProp */])(widths, 'item'), className, 'menu');
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(Menu, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["p" /* getElementType */])(Menu, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_14__lib__["c" /* childrenUtils */].isNil(children) ? this.renderItems() : children);
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "autoControlledProps", ['activeIndex']);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "Header", __WEBPACK_IMPORTED_MODULE_15__MenuHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "Item", __WEBPACK_IMPORTED_MODULE_16__MenuItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "Menu", __WEBPACK_IMPORTED_MODULE_17__MenuMenu__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Menu, "handledProps", ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"]);

Menu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Index of the currently active item. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu may be attached to other content segments. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A menu item or menu can have no borders. */
  borderless: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A menu can take up only the space necessary to fit its content. */
  compact: PropTypes.bool,

  /** Initial activeIndex value. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu can be fixed to a side of its context. */
  fixed: PropTypes.oneOf(['left', 'right', 'bottom', 'top']),

  /** A menu can be floated. */
  floated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A vertical menu may take the size of its container. */
  fluid: PropTypes.bool,

  /** A menu may have just icons (bool) or labeled icons. */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['labeled'])]),

  /** A menu may have its colors inverted to show greater contrast. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for Menu. */
  items: customPropTypes.collectionShorthand,

  /**
   * onClick handler for MenuItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A pagination menu is specially formatted to present links to pages of content. */
  pagination: PropTypes.bool,

  /** A menu can point to show its relationship to nearby content. */
  pointing: PropTypes.bool,

  /** A menu can adjust its appearance to de-emphasize its contents. */
  secondary: PropTypes.bool,

  /** A menu can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big')),

  /** A menu can stack at mobile resolutions. */
  stackable: PropTypes.bool,

  /** A menu can be formatted to show tabs of information. */
  tabular: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A menu can be formatted for text content. */
  text: PropTypes.bool,

  /** A vertical menu displays elements vertically. */
  vertical: PropTypes.bool,

  /** A menu can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
Menu.create = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["l" /* createShorthandFactory */])(Menu, function (items) {
  return {
    items: items
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A menu item may include a header or may itself be a header.
 */

function MenuHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(MenuHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(MenuHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

MenuHeader.handledProps = ["as", "children", "className", "content"];
MenuHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MenuHeader);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(1058),
    toString = __webpack_require__(64);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A menu can contain a sub menu.
 */

function MenuMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      position = props.position;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(position, 'menu', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(MenuMenu, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(MenuMenu, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

MenuMenu.handledProps = ["as", "children", "className", "content", "position"];
MenuMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A sub menu can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MenuMenu);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keyboard_key__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collections_Menu_MenuItem__ = __webpack_require__(275);













/**
 * An item of a pagination.
 */

var PaginationItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PaginationItem, _Component);

  function PaginationItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PaginationItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PaginationItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleKeyDown", function (e) {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onKeyDown', e, _this.props);

      if (__WEBPACK_IMPORTED_MODULE_8_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_8_keyboard_key___default.a.Enter) __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOverrides", function () {
      return {
        onClick: _this.handleClick,
        onKeyDown: _this.handleKeyDown
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PaginationItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          type = _this$props.type;
      var disabled = this.props.disabled || type === 'ellipsisItem';
      return __WEBPACK_IMPORTED_MODULE_12__collections_Menu_MenuItem__["a" /* default */].create(this.props, {
        defaultProps: {
          active: active,
          'aria-current': active,
          'aria-disabled': disabled,
          disabled: disabled,
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          tabIndex: disabled ? -1 : 0
        },
        overrideProps: this.handleOverrides
      });
    }
  }]);

  return PaginationItem;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PaginationItem, "handledProps", ["active", "disabled", "onClick", "onKeyDown", "type"]);

PaginationItem.propTypes =  false ? {
  /** A pagination item can be active. */
  active: PropTypes.bool,

  /** A pagination item can be disabled. */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on key down.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyDown: PropTypes.func,

  /** A pagination should have a type. */
  type: PropTypes.oneOf(['ellipsisItem', 'firstItem', 'prevItem', 'pageItem', 'nextItem', 'lastItem'])
} : {};
PaginationItem.create = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["l" /* createShorthandFactory */])(PaginationItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1072);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });



/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(16);

var superPropBase = __webpack_require__(1074);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A dropdown menu can contain dividers to separate related content.
 */

function DropdownDivider(props) {
  var className = props.className;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('divider', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(DropdownDivider, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(DropdownDivider, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

DropdownDivider.handledProps = ["as", "className"];
DropdownDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DropdownDivider);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Flag__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__elements_Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_Image__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__elements_Label__ = __webpack_require__(140);


















/**
 * An item sub-component for Dropdown component.
 */

var DropdownItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DropdownItem, _Component);

  function DropdownItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DropdownItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DropdownItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DropdownItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          disabled = _this$props.disabled,
          description = _this$props.description,
          flag = _this$props.flag,
          icon = _this$props.icon,
          image = _this$props.image,
          label = _this$props.label,
          selected = _this$props.selected,
          text = _this$props.text;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(selected, 'selected'), 'item', className); // add default dropdown icon if item contains another menu

      var iconName = __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(icon) ? __WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].someByType(children, 'DropdownMenu') && 'dropdown' : icon;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(DropdownItem, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(DropdownItem, this.props);
      var ariaOptions = {
        role: 'option',
        'aria-disabled': disabled,
        'aria-checked': active,
        'aria-selected': selected
      };

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
          className: classes,
          onClick: this.handleClick
        }), children);
      }

      var flagElement = __WEBPACK_IMPORTED_MODULE_14__elements_Flag__["a" /* default */].create(flag, {
        autoGenerateKey: false
      });
      var iconElement = __WEBPACK_IMPORTED_MODULE_15__elements_Icon__["a" /* default */].create(iconName, {
        autoGenerateKey: false
      });
      var imageElement = __WEBPACK_IMPORTED_MODULE_16__elements_Image__["a" /* default */].create(image, {
        autoGenerateKey: false
      });
      var labelElement = __WEBPACK_IMPORTED_MODULE_17__elements_Label__["a" /* default */].create(label, {
        autoGenerateKey: false
      });
      var descriptionElement = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["k" /* createShorthand */])('span', function (val) {
        return {
          children: val
        };
      }, description, {
        defaultProps: {
          className: 'description'
        },
        autoGenerateKey: false
      });
      var textElement = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["k" /* createShorthand */])('span', function (val) {
        return {
          children: val
        };
      }, __WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(content) ? text : content, {
        defaultProps: {
          className: 'text'
        },
        autoGenerateKey: false
      });
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
        className: classes,
        onClick: this.handleClick
      }), imageElement, iconElement, flagElement, labelElement, descriptionElement, textElement);
    }
  }]);

  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DropdownItem, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"]);

DropdownItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Style as the currently chosen item. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: customPropTypes.itemShorthand,

  /** A dropdown item can be disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for Flag. */
  flag: customPropTypes.itemShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** Shorthand for Image. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * The item currently selected by keyboard shortcut.
   * This is not the active item.
   */
  selected: PropTypes.bool,

  /** Display text. */
  text: customPropTypes.contentShorthand,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
} : {};
DropdownItem.create = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["l" /* createShorthandFactory */])(DropdownItem, function (opts) {
  return opts;
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag__ = __webpack_require__(1085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flag__["a"]; });



/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(42);






/**
 * A dropdown menu can contain a header.
 */

function DropdownHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(DropdownHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(DropdownHeader, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), content);
}

DropdownHeader.handledProps = ["as", "children", "className", "content", "icon"];
DropdownHeader.propTypes =  false ? {
  /** An element type to render as (string or function) */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand
} : {};
DropdownHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(DropdownHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownHeader);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A dropdown menu can contain a menu.
 */

function DropdownMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      direction = props.direction,
      open = props.open,
      scrolling = props.scrolling;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(direction, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(open, 'visible'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(scrolling, 'scrolling'), 'menu transition', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(DropdownMenu, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(DropdownMenu, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

DropdownMenu.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"];
DropdownMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** Whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** A dropdown menu can scroll. */
  scrolling: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);















/**
 * A search item sub-component for Dropdown component.
 */

var DropdownSearchInput =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(DropdownSearchInput, _Component);

  function DropdownSearchInput() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, DropdownSearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DropdownSearchInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(DropdownSearchInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          className = _this$props.className,
          tabIndex = _this$props.tabIndex,
          type = _this$props.type,
          value = _this$props.value;
      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('search', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(DropdownSearchInput, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("input", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        "aria-autocomplete": "list",
        autoComplete: autoComplete,
        className: classes,
        onChange: this.handleChange,
        tabIndex: tabIndex,
        type: type,
        value: value
      }));
    }
  }]);

  return DropdownSearchInput;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(DropdownSearchInput, "defaultProps", {
  autoComplete: 'off',
  type: 'text'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(DropdownSearchInput, "handledProps", ["as", "autoComplete", "className", "tabIndex", "type", "value"]);

DropdownSearchInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An input can have the auto complete. */
  autoComplete: PropTypes.string,

  /** Additional classes. */
  className: PropTypes.string,

  /** An input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The HTML input type. */
  type: PropTypes.string,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
DropdownSearchInput.create = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["l" /* createShorthandFactory */])(DropdownSearchInput, function (type) {
  return {
    type: type
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownSearchInput);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextArea__ = __webpack_require__(1086);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextArea__["a"]; });



/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transition__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Transition__["a"]; });



/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TransitionGroup__ = __webpack_require__(481);

















var TRANSITION_TYPE = {
  ENTERING: 'show',
  EXITING: 'hide'
  /**
   * A transition is an animation usually used to move content in or out of view.
   */

};

var Transition =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Transition, _Component);

  function Transition() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Transition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Transition)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleStart", function () {
      var duration = _this.props.duration;
      var status = _this.nextStatus;
      _this.nextStatus = null;

      _this.setState({
        status: status,
        animating: true
      }, function () {
        var durationType = TRANSITION_TYPE[status];
        var durationValue = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["w" /* normalizeTransitionDuration */])(duration, durationType);

        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onStart', null, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          status: status
        }));

        _this.timeoutId = setTimeout(_this.handleComplete, durationValue);
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleComplete", function () {
      var current = _this.state.status;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onComplete', null, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        status: current
      }));

      if (_this.nextStatus) {
        _this.handleStart();

        return;
      }

      var status = _this.computeCompletedStatus();

      var callback = current === Transition.ENTERING ? 'onShow' : 'onHide';

      _this.setState({
        status: status,
        animating: false
      }, function () {
        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, callback, null, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          status: status
        }));
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStatus", function () {
      var animating = _this.state.animating;

      if (_this.nextStatus) {
        _this.nextStatus = _this.computeNextStatus();
        if (!animating) _this.handleStart();
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeClasses", function () {
      var _this$props = _this.props,
          animation = _this$props.animation,
          directional = _this$props.directional,
          children = _this$props.children;
      var _this$state = _this.state,
          animating = _this$state.animating,
          status = _this$state.status;

      var childClasses = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(children, 'props.className');

      var isDirectional = __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(directional) ? __WEBPACK_IMPORTED_MODULE_8_lodash_includes___default()(__WEBPACK_IMPORTED_MODULE_15__lib__["b" /* SUI */].DIRECTIONAL_TRANSITIONS, animation) : directional;

      if (isDirectional) {
        return __WEBPACK_IMPORTED_MODULE_12_classnames___default()(animation, childClasses, Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(animating, 'animating'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(status === Transition.ENTERING, 'in'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(status === Transition.EXITING, 'out'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(status === Transition.EXITED, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(status !== Transition.EXITED, 'visible'), 'transition');
      }

      return __WEBPACK_IMPORTED_MODULE_12_classnames___default()(animation, childClasses, Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(animating, 'animating transition'));
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeCompletedStatus", function () {
      var unmountOnHide = _this.props.unmountOnHide;
      var status = _this.state.status;
      if (status === Transition.ENTERING) return Transition.ENTERED;
      return unmountOnHide ? Transition.UNMOUNTED : Transition.EXITED;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeInitialStatuses", function () {
      var _this$props2 = _this.props,
          visible = _this$props2.visible,
          mountOnShow = _this$props2.mountOnShow,
          transitionOnMount = _this$props2.transitionOnMount,
          unmountOnHide = _this$props2.unmountOnHide;

      if (visible) {
        if (transitionOnMount) {
          return {
            initial: Transition.EXITED,
            next: Transition.ENTERING
          };
        }

        return {
          initial: Transition.ENTERED
        };
      }

      if (mountOnShow || unmountOnHide) return {
        initial: Transition.UNMOUNTED
      };
      return {
        initial: Transition.EXITED
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeNextStatus", function () {
      var _this$state2 = _this.state,
          animating = _this$state2.animating,
          status = _this$state2.status;
      if (animating) return status === Transition.ENTERING ? Transition.EXITING : Transition.ENTERING;
      return status === Transition.ENTERED ? Transition.EXITING : Transition.ENTERING;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeStatuses", function (props) {
      var status = _this.state.status;
      var visible = props.visible;

      if (visible) {
        return {
          current: status === Transition.UNMOUNTED && Transition.EXITED,
          next: status !== Transition.ENTERING && status !== Transition.ENTERED && Transition.ENTERING
        };
      }

      return {
        next: (status === Transition.ENTERING || status === Transition.ENTERED) && Transition.EXITING
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeStyle", function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          duration = _this$props3.duration;
      var status = _this.state.status;

      var childStyle = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(children, 'props.style');

      var type = TRANSITION_TYPE[status];
      var animationDuration = type && "".concat(Object(__WEBPACK_IMPORTED_MODULE_15__lib__["w" /* normalizeTransitionDuration */])(duration, type), "ms");
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, childStyle, {
        animationDuration: animationDuration
      });
    });

    var _this$computeInitialS = _this.computeInitialStatuses(),
        _status = _this$computeInitialS.initial,
        next = _this$computeInitialS.next;

    _this.nextStatus = next;
    _this.state = {
      status: _status
    };
    return _this;
  } // ----------------------------------------
  // Lifecycle
  // ----------------------------------------


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Transition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateStatus();
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$computeStatuses = this.computeStatuses(nextProps),
          status = _this$computeStatuses.current,
          next = _this$computeStatuses.next;

      this.nextStatus = next;
      if (status) this.setState({
        status: status
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateStatus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    } // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var children = this.props.children;
      var status = this.state.status;
      if (status === Transition.UNMOUNTED) return null;
      return Object(__WEBPACK_IMPORTED_MODULE_14_react__["cloneElement"])(children, {
        className: this.computeClasses(),
        style: this.computeStyle()
      });
    }
  }]);

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "defaultProps", {
  animation: 'fade',
  duration: 500,
  visible: true,
  mountOnShow: true,
  transitionOnMount: false,
  unmountOnHide: false
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "ENTERED", 'ENTERED');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "ENTERING", 'ENTERING');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "EXITED", 'EXITED');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "EXITING", 'EXITING');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "UNMOUNTED", 'UNMOUNTED');

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "Group", __WEBPACK_IMPORTED_MODULE_16__TransitionGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Transition, "handledProps", ["animation", "children", "directional", "duration", "mountOnShow", "onComplete", "onHide", "onShow", "onStart", "reactKey", "transitionOnMount", "unmountOnHide", "visible"]);


Transition.propTypes =  false ? {
  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOfType([PropTypes.oneOf(SUI.TRANSITIONS), PropTypes.string]),

  /** Primary content. */
  children: PropTypes.element.isRequired,

  /** Whether it is directional animation event or not. Use it only for custom transitions. */
  directional: PropTypes.bool,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number,
    show: PropTypes.number
  }), PropTypes.string]),

  /** Show the component; triggers the enter or exit animation. */
  visible: PropTypes.bool,

  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
  mountOnShow: PropTypes.bool,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onComplete: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onHide: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onShow: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onStart: PropTypes.func,

  /** React's key of the element. */
  reactKey: PropTypes.string,

  /** Run the enter animation when the component mounts, if it is initially shown. */
  transitionOnMount: PropTypes.bool,

  /** Unmount the component (remove it from the DOM) when it is not shown. */
  unmountOnHide: PropTypes.bool
} : {};

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransitionGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_values__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Transition__ = __webpack_require__(480);


















/**
 * A Transition.Group animates children as they mount and unmount.
 */
var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(TransitionGroup, _React$Component);

  function TransitionGroup() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, TransitionGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(TransitionGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOnHide", function (nothing, childProps) {
      var reactKey = childProps.reactKey;

      _this.setState(function (state) {
        var children = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, state.children);

        delete children[reactKey];
        return {
          children: children
        };
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "wrapChild", function (child) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
          animation = _this$props.animation,
          directional = _this$props.directional,
          duration = _this$props.duration;
      var key = child.key;
      var _options$visible = options.visible,
          visible = _options$visible === void 0 ? true : _options$visible,
          _options$transitionOn = options.transitionOnMount,
          transitionOnMount = _options$transitionOn === void 0 ? false : _options$transitionOn;
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Transition__["a" /* default */], {
        animation: animation,
        directional: directional,
        duration: duration,
        key: key,
        onHide: _this.handleOnHide,
        reactKey: key,
        transitionOnMount: transitionOnMount,
        visible: visible
      }, child);
    });

    var _children = _this.props.children;
    _this.state = {
      children: __WEBPACK_IMPORTED_MODULE_12_lodash_mapValues___default()(Object(__WEBPACK_IMPORTED_MODULE_15__lib__["o" /* getChildMapping */])(_children), function (child) {
        return _this.wrapChild(child);
      })
    };
    return _this;
  } // eslint-disable-next-line camelcase


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(TransitionGroup, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var prevMapping = this.state.children;
      var nextMapping = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["o" /* getChildMapping */])(nextProps.children);
      var children = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["u" /* mergeChildMappings */])(prevMapping, nextMapping);

      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(children, function (child, key) {
        var hasPrev = __WEBPACK_IMPORTED_MODULE_10_lodash_has___default()(prevMapping, key);

        var hasNext = __WEBPACK_IMPORTED_MODULE_10_lodash_has___default()(nextMapping, key);

        var prevChild = prevMapping[key];
        var isLeaving = !__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(prevChild, 'props.visible'); // Heads up!
        // An item is new (entering), it will be picked from `nextChildren`, so it should be wrapped

        if (hasNext && (!hasPrev || isLeaving)) {
          children[key] = _this2.wrapChild(child, {
            transitionOnMount: true
          });
          return;
        } // Heads up!
        // An item is old (exiting), it will be picked from `prevChildren`, so it has been already
        // wrapped, so should be only updated


        if (!hasNext && hasPrev && !isLeaving) {
          children[key] = Object(__WEBPACK_IMPORTED_MODULE_14_react__["cloneElement"])(prevChild, {
            visible: false
          });
          return;
        } // Heads up!
        // An item item hasn't changed transition states, but it will be picked from `nextChildren`,
        // so we should wrap it again


        var _prevChild$props = prevChild.props,
            visible = _prevChild$props.visible,
            transitionOnMount = _prevChild$props.transitionOnMount;
        children[key] = _this2.wrapChild(child, {
          transitionOnMount: transitionOnMount,
          visible: visible
        });
      });

      this.setState({
        children: children
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.state.children;
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["p" /* getElementType */])(TransitionGroup, this.props);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* getUnhandledProps */])(TransitionGroup, this.props);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, rest, __WEBPACK_IMPORTED_MODULE_8_lodash_values___default()(children));
    }
  }]);

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(TransitionGroup, "defaultProps", {
  as: __WEBPACK_IMPORTED_MODULE_14_react__["Fragment"],
  animation: 'fade',
  duration: 500
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(TransitionGroup, "handledProps", ["animation", "as", "children", "directional", "duration"]);


TransitionGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOfType([PropTypes.oneOf(SUI.TRANSITIONS), PropTypes.string]),

  /** Primary content. */
  children: PropTypes.node,

  /** Whether it is directional animation event or not. Use it only for custom transitions. */
  directional: PropTypes.bool,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number.isRequired,
    show: PropTypes.number.isRequired
  }), PropTypes.string])
} : {};

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_Icon__ = __webpack_require__(42);








/**
 * A divider sub-component for Breadcrumb component.
 */

function BreadcrumbDivider(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('divider', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(BreadcrumbDivider, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(BreadcrumbDivider, props);

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(icon)) {
    return __WEBPACK_IMPORTED_MODULE_7__elements_Icon__["a" /* default */].create(icon, {
      defaultProps: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, rest, {
        className: classes
      }),
      autoGenerateKey: false
    });
  }

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children) ? '/' : children);
}

BreadcrumbDivider.handledProps = ["as", "children", "className", "content", "icon"];
BreadcrumbDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `Icon` component with `divider` class instead of a `div`. */
  icon: customPropTypes.itemShorthand
} : {};
BreadcrumbDivider.create = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["l" /* createShorthandFactory */])(BreadcrumbDivider, function (icon) {
  return {
    icon: icon
  };
});
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbDivider);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(5);













/**
 * A section sub-component for Breadcrumb component.
 */

var BreadcrumbSection =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BreadcrumbSection, _Component);

  function BreadcrumbSection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BreadcrumbSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeElementType", function () {
      var _this$props = _this.props,
          link = _this$props.link,
          onClick = _this$props.onClick;
      if (link || onClick) return 'a';
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BreadcrumbSection, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          children = _this$props2.children,
          className = _this$props2.className,
          content = _this$props2.content,
          href = _this$props2.href;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_12__lib__["y" /* useKeyOnly */])(active, 'active'), 'section', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getUnhandledProps */])(BreadcrumbSection, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["p" /* getElementType */])(BreadcrumbSection, this.props, this.computeElementType);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_12__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
    }
  }]);

  return BreadcrumbSection;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(BreadcrumbSection, "handledProps", ["active", "as", "children", "className", "content", "href", "link", "onClick"]);


BreadcrumbSection.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Style as the currently active section. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: customPropTypes.every([customPropTypes.disallow(['link']), PropTypes.string]),

  /** Render as an `a` tag instead of a `div`. */
  link: customPropTypes.every([customPropTypes.disallow(['href']), PropTypes.bool]),

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};
BreadcrumbSection.create = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["l" /* createShorthandFactory */])(BreadcrumbSection, function (content) {
  return {
    content: content,
    link: true
  };
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Button__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(73);






/**
 * Sugar for <Form.Field control={Button} />.
 * @see Button
 * @see Form
 */

function FormButton(props) {
  var control = props.control;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormButton, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormButton, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormButton.handledProps = ["as", "control"];
FormButton.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormButton.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__elements_Button__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormButton);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Checkbox__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(73);






/**
 * Sugar for <Form.Field control={Checkbox} />.
 * @see Checkbox
 * @see Form
 */

function FormCheckbox(props) {
  var control = props.control;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormCheckbox, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormCheckbox, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormCheckbox.handledProps = ["as", "control"];
FormCheckbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormCheckbox.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__modules_Checkbox__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormCheckbox);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Dropdown__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(73);






/**
 * Sugar for <Form.Field control={Dropdown} />.
 * @see Dropdown
 * @see Form
 */

function FormDropdown(props) {
  var control = props.control;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormDropdown, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormDropdown, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormDropdown.handledProps = ["as", "control"];
FormDropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormDropdown.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__modules_Dropdown__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormDropdown);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A set of fields can appear grouped together.
 * @see Form
 */

function FormGroup(props) {
  var children = props.children,
      className = props.className,
      grouped = props.grouped,
      inline = props.inline,
      unstackable = props.unstackable,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(grouped, 'grouped'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(inline, 'inline'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useWidthProp */])(widths, null, true), 'fields', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(FormGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(FormGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

FormGroup.handledProps = ["as", "children", "className", "grouped", "inline", "unstackable", "widths"];
FormGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Fields can show related choices. */
  grouped: customPropTypes.every([customPropTypes.disallow(['inline']), PropTypes.bool]),

  /** Multiple fields may be inline in a row. */
  inline: customPropTypes.every([customPropTypes.disallow(['grouped']), PropTypes.bool]),

  /** A form group can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
  widths: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal']))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Input__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(73);






/**
 * Sugar for <Form.Field control={Input} />.
 * @see Form
 * @see Input
 */

function FormInput(props) {
  var control = props.control;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormInput, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormInput, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormInput.handledProps = ["as", "control"];
FormInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormInput.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__elements_Input__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormInput);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Radio__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(73);






/**
 * Sugar for <Form.Field control={Radio} />.
 * @see Form
 * @see Radio
 */

function FormRadio(props) {
  var control = props.control;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormRadio, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormRadio, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormRadio.handledProps = ["as", "control"];
FormRadio.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormRadio.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_Radio__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormRadio);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Select__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Dropdown__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormField__ = __webpack_require__(73);







/**
 * Sugar for <Form.Field control={Select} />.
 * @see Form
 * @see Select
 */

function FormSelect(props) {
  var control = props.control,
      options = props.options;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormSelect, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormSelect, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control,
    options: options
  }));
}

FormSelect.handledProps = ["as", "control", "options"];
FormSelect.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: PropTypes.arrayOf(PropTypes.shape(Dropdown.Item.propTypes)).isRequired
} : {};
FormSelect.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_6__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_Select__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormSelect);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_TextArea__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(73);






/**
 * Sugar for <Form.Field control={TextArea} />.
 * @see Form
 * @see TextArea
 */

function FormTextArea(props) {
  var control = props.control;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(FormTextArea, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* getElementType */])(FormTextArea, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    control: control
  }));
}

FormTextArea.handledProps = ["as", "control"];
FormTextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormTextArea.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_TextArea__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormTextArea);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GridColumn__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GridRow__ = __webpack_require__(493);








/**
 * A grid is used to harmonize negative space in a layout.
 */

function Grid(props) {
  var celled = props.celled,
      centered = props.centered,
      children = props.children,
      className = props.className,
      columns = props.columns,
      container = props.container,
      divided = props.divided,
      doubling = props.doubling,
      inverted = props.inverted,
      padded = props.padded,
      relaxed = props.relaxed,
      reversed = props.reversed,
      stackable = props.stackable,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(container, 'container'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(doubling, 'doubling'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(stretched, 'stretched'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(celled, 'celled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(padded, 'padded'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["A" /* useMultipleProp */])(reversed, 'reversed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["D" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useWidthProp */])(columns, 'column', true), 'grid', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(Grid, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(Grid, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

Grid.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"];
Grid.Column = __WEBPACK_IMPORTED_MODULE_6__GridColumn__["a" /* default */];
Grid.Row = __WEBPACK_IMPORTED_MODULE_7__GridRow__["a" /* default */];
Grid.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A grid can have rows divided into cells. */
  celled: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['internally'])]),

  /** A grid can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Represents column count per row in Grid. */
  columns: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal'])),

  /** A grid can be combined with a container to use the available layout and alignment. */
  container: PropTypes.bool,

  /** A grid can have dividers between its columns. */
  divided: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['vertically'])]),

  /** A grid can double its column width on tablet and mobile sizes. */
  doubling: PropTypes.bool,

  /** A grid's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A grid can increase its gutters to allow for more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A grid can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
  stackable: PropTypes.bool,

  /** A grid can stretch its contents to take up the entire grid height. */
  stretched: PropTypes.bool,

  /** A grid can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A row sub-component for Grid.
 */

function GridRow(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      color = props.color,
      columns = props.columns,
      divided = props.divided,
      only = props.only,
      reversed = props.reversed,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(color, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(stretched, 'stretched'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["A" /* useMultipleProp */])(only, 'only'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["A" /* useMultipleProp */])(reversed, 'reversed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["D" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useWidthProp */])(columns, 'column', true), 'row', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(GridRow, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(GridRow, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

GridRow.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"];
GridRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A row can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid row can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Represents column count per line in Row. */
  columns: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal'])),

  /** A row can have dividers between its columns. */
  divided: PropTypes.bool,

  /** A row can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A row can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A row can stretch its contents to take up the entire column height. */
  stretched: PropTypes.bool,

  /** A row can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A row can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (GridRow);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A message can contain a content.
 */

function MessageContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(MessageContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(MessageContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

MessageContent.handledProps = ["as", "children", "className", "content"];
MessageContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MessageContent);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A message can contain a header.
 */

function MessageHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(MessageHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(MessageHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

MessageHeader.handledProps = ["as", "children", "className", "content"];
MessageHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
MessageHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(MessageHeader, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageHeader);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MessageItem__ = __webpack_require__(279);







/**
 * A message can contain a list of items.
 */

function MessageList(props) {
  var children = props.children,
      className = props.className,
      items = props.items;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(MessageList, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(MessageList, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(items, __WEBPACK_IMPORTED_MODULE_6__MessageItem__["a" /* default */].create) : children);
}

MessageList.handledProps = ["as", "children", "className", "items"];
MessageList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand Message.Items. */
  items: customPropTypes.collectionShorthand
} : {};
MessageList.defaultProps = {
  as: 'ul'
};
MessageList.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* createShorthandFactory */])(MessageList, function (val) {
  return {
    items: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageList);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);






function TableBody(props) {
  var children = props.children,
      className = props.className;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(TableBody, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(TableBody, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), children);
}

TableBody.handledProps = ["as", "children", "className"];
TableBody.defaultProps = {
  as: 'tbody'
};
TableBody.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TableBody);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TableHeader__ = __webpack_require__(280);





/**
 * A table can have a footer.
 */

function TableFooter(props) {
  var as = props.as;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getUnhandledProps */])(TableFooter, props);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TableHeader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    as: as
  }));
}

TableFooter.handledProps = ["as"];
TableFooter.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType
} : {};
TableFooter.defaultProps = {
  as: 'tfoot'
};
/* harmony default export */ __webpack_exports__["a"] = (TableFooter);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableCell__ = __webpack_require__(196);






/**
 * A table can have a header cell.
 */

function TableHeaderCell(props) {
  var as = props.as,
      className = props.className,
      sorted = props.sorted;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["C" /* useValueAndKey */])(sorted, 'sorted'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(TableHeaderCell, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableCell__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    as: as,
    className: classes
  }));
}

TableHeaderCell.handledProps = ["as", "className", "sorted"];
TableHeaderCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** A header cell can be sorted in ascending or descending order. */
  sorted: PropTypes.oneOf(['ascending', 'descending'])
} : {};
TableHeaderCell.defaultProps = {
  as: 'th'
};
/* harmony default export */ __webpack_exports__["a"] = (TableHeaderCell);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableCell__ = __webpack_require__(196);








/**
 * A table can have rows.
 */

function TableRow(props) {
  var active = props.active,
      cellAs = props.cellAs,
      cells = props.cells,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      error = props.error,
      negative = props.negative,
      positive = props.positive,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["D" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(TableRow, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(TableRow, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(cells, function (cell) {
    return __WEBPACK_IMPORTED_MODULE_7__TableCell__["a" /* default */].create(cell, {
      defaultProps: {
        as: cellAs
      }
    });
  }));
}

TableRow.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"];
TableRow.defaultProps = {
  as: 'tr',
  cellAs: 'td'
};
TableRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A row can be active or selected by a user. */
  active: PropTypes.bool,

  /** An element type to render as (string or function). */
  cellAs: PropTypes.elementType,

  /** Shorthand array of props for TableCell. */
  cells: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A row can be disabled. */
  disabled: PropTypes.bool,

  /** A row may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** A row may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A row may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A table row can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table row can adjust its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A row may warn a user. */
  warning: PropTypes.bool
} : {};
TableRow.create = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["l" /* createShorthandFactory */])(TableRow, function (cells) {
  return {
    cells: cells
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * Headers may contain subheaders.
 */

function HeaderSubheader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('sub header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(HeaderSubheader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(HeaderSubheader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

HeaderSubheader.handledProps = ["as", "children", "className", "content"];
HeaderSubheader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
HeaderSubheader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(HeaderSubheader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (HeaderSubheader);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * Header content wraps the main content when there is an adjacent Icon or Image.
 */

function HeaderContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(HeaderContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(HeaderContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

HeaderContent.handledProps = ["as", "children", "className", "content"];
HeaderContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (HeaderContent);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Image__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ListContent__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ListDescription__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ListHeader__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ListIcon__ = __webpack_require__(282);



















/**
 * A list item can contain a set of items.
 */

var ListItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ListItem, _Component);

  function ListItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          description = _this$props.description,
          disabled = _this$props.disabled,
          header = _this$props.header,
          icon = _this$props.icon,
          image = _this$props.image,
          value = _this$props.value;
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(ListItem, this.props);
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(ElementType !== 'li', 'item'), className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(ListItem, this.props);
      var valueProp = ElementType === 'li' ? {
        value: value
      } : {
        'data-value': value
      };

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
          role: "listitem",
          className: classes,
          onClick: this.handleClick
        }, rest), children);
      }

      var iconElement = __WEBPACK_IMPORTED_MODULE_18__ListIcon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      });
      var imageElement = __WEBPACK_IMPORTED_MODULE_14__Image__["a" /* default */].create(image, {
        autoGenerateKey: false
      }); // See description of `content` prop for explanation about why this is necessary.

      if (!Object(__WEBPACK_IMPORTED_MODULE_12_react__["isValidElement"])(content) && __WEBPACK_IMPORTED_MODULE_8_lodash_isPlainObject___default()(content)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
          role: "listitem",
          className: classes,
          onClick: this.handleClick
        }, rest), iconElement || imageElement, __WEBPACK_IMPORTED_MODULE_15__ListContent__["a" /* default */].create(content, {
          autoGenerateKey: false,
          defaultProps: {
            header: header,
            description: description
          }
        }));
      }

      var headerElement = __WEBPACK_IMPORTED_MODULE_17__ListHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      });
      var descriptionElement = __WEBPACK_IMPORTED_MODULE_16__ListDescription__["a" /* default */].create(description, {
        autoGenerateKey: false
      });

      if (iconElement || imageElement) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
          role: "listitem",
          className: classes,
          onClick: this.handleClick
        }, rest), iconElement || imageElement, (content || headerElement || descriptionElement) && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ListContent__["a" /* default */], null, headerElement, descriptionElement, content));
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, valueProp, {
        role: "listitem",
        className: classes,
        onClick: this.handleClick
      }, rest), headerElement, descriptionElement, content);
    }
  }]);

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ListItem, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "header", "icon", "image", "onClick", "value"]);

ListItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A list item can active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * Shorthand for primary content.
   *
   * Heads up!
   *
   * This is handled slightly differently than the typical `content` prop since
   * the wrapping ListContent is not used when there's no icon or image.
   *
   * If you pass content as:
   * - an element/literal, it's treated as the sibling node to
   * header/description (whether wrapped in Item.Content or not).
   * - a props object, it forces the presence of Item.Content and passes those
   * props to it. If you pass a content prop within that props object, it
   * will be treated as the sibling node to header/description.
   */
  content: customPropTypes.itemShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** A list item can disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ListIcon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), customPropTypes.itemShorthand]),

  /** Shorthand for Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.itemShorthand]),

  /** A ListItem can be clicked */
  onClick: PropTypes.func,

  /** A value for an ordered list. */
  value: PropTypes.string
} : {};
ListItem.create = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["l" /* createShorthandFactory */])(ListItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A list can contain a sub list.
 */

function ListList(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ListList, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ListList, props);
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

ListList.handledProps = ["as", "children", "className", "content"];
ListList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ListList);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A placeholder can contain a header.
 */

function PlaceholderHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(image, 'image'), 'header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(PlaceholderHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(PlaceholderHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

PlaceholderHeader.handledProps = ["as", "children", "className", "content", "image"];
PlaceholderHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A placeholder can contain an image. */
  image: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderHeader);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A placeholder can contain an image.
 */

function PlaceholderImage(props) {
  var className = props.className,
      square = props.square,
      rectangular = props.rectangular;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(square, 'square'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(rectangular, 'rectangular'), 'image', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(PlaceholderImage, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(PlaceholderImage, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

PlaceholderImage.handledProps = ["as", "className", "rectangular", "square"];
PlaceholderImage.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** An image can modify size correctly with responsive styles. */
  square: customPropTypes.every([customPropTypes.disallow(['rectangular']), PropTypes.bool]),

  /** An image can modify size correctly with responsive styles. */
  rectangular: customPropTypes.every([customPropTypes.disallow(['square']), PropTypes.bool])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderImage);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A placeholder can contain have lines of text.
 */

function PlaceholderLine(props) {
  var className = props.className,
      length = props.length;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('line', length, className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(PlaceholderLine, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(PlaceholderLine, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

PlaceholderLine.handledProps = ["as", "className", "length"];
PlaceholderLine.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** A line can specify how long its contents should appear. */
  length: PropTypes.oneOf(['full', 'very long', 'long', 'medium', 'short', 'very short'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderLine);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A placeholder can contain a paragraph.
 */

function PlaceholderParagraph(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('paragraph', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(PlaceholderParagraph, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(PlaceholderParagraph, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

PlaceholderParagraph.handledProps = ["as", "children", "className", "content"];
PlaceholderParagraph.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderParagraph);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A content sub-component for the Reveal.
 */

function RevealContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(visible, 'visible'), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(RevealContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(RevealContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

RevealContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
RevealContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A reveal may contain content that is visible before interaction. */
  hidden: PropTypes.bool,

  /** A reveal may contain content that is hidden before user interaction. */
  visible: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (RevealContent);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SegmentInline__ = __webpack_require__(512);








/**
 * A segment is used to create a grouping of related content.
 */

function Segment(props) {
  var attached = props.attached,
      basic = props.basic,
      children = props.children,
      circular = props.circular,
      className = props.className,
      clearing = props.clearing,
      color = props.color,
      compact = props.compact,
      content = props.content,
      disabled = props.disabled,
      floated = props.floated,
      inverted = props.inverted,
      loading = props.loading,
      placeholder = props.placeholder,
      padded = props.padded,
      piled = props.piled,
      raised = props.raised,
      secondary = props.secondary,
      size = props.size,
      stacked = props.stacked,
      tertiary = props.tertiary,
      textAlign = props.textAlign,
      vertical = props.vertical;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(clearing, 'clearing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(placeholder, 'placeholder'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(piled, 'piled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(raised, 'raised'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(stacked, 'stacked'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(tertiary, 'tertiary'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(padded, 'padded'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useValueAndKey */])(floated, 'floated'), 'segment', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(Segment, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(Segment, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Segment.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"];
Segment.Group = __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__["a" /* default */];
Segment.Inline = __WEBPACK_IMPORTED_MODULE_7__SegmentInline__["a" /* default */];
Segment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Attach segment to other content, like a header. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A basic segment has no special formatting. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A segment can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment can clear floated content. */
  clearing: PropTypes.bool,

  /** Segment can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A segment may show its content is disabled. */
  disabled: PropTypes.bool,

  /** Segment content can be floated to the left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A segment can have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** A segment may show its content is being loaded. */
  loading: PropTypes.bool,

  /** A segment can increase its padding. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A segment can be used to reserve space for conditionally displayed content. */
  placeholder: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment can be formatted to appear less noticeable. */
  secondary: PropTypes.bool,

  /** A segment can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool,

  /** A segment can be formatted to appear even less noticeable. */
  tertiary: PropTypes.bool,

  /** Formats content to be aligned as part of a vertical group. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** Formats content to be aligned vertically. */
  vertical: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Segment);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A group of segments can be formatted to appear together.
 */

function SegmentGroup(props) {
  var children = props.children,
      className = props.className,
      compact = props.compact,
      content = props.content,
      horizontal = props.horizontal,
      piled = props.piled,
      raised = props.raised,
      size = props.size,
      stacked = props.stacked;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(piled, 'piled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(raised, 'raised'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(stacked, 'stacked'), 'segments', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(SegmentGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(SegmentGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

SegmentGroup.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"];
SegmentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Formats content to be aligned horizontally. */
  horizontal: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment group may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment group can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SegmentGroup);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A placeholder segment can be inline.
 */

function SegmentInline(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('inline', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(SegmentInline, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(SegmentInline, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

SegmentInline.handledProps = ["as", "children", "className", "content"];
SegmentInline.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SegmentInline);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StepContent__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StepDescription__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__StepGroup__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__StepTitle__ = __webpack_require__(284);


















/**
 * A step shows the completion status of an activity in a series of activities.
 */

var Step =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Step, _Component);

  function Step() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Step);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Step)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeElementType", function () {
      var onClick = _this.props.onClick;
      if (onClick) return 'a';
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Step, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          completed = _this$props.completed,
          content = _this$props.content,
          description = _this$props.description,
          disabled = _this$props.disabled,
          href = _this$props.href,
          icon = _this$props.icon,
          link = _this$props.link,
          title = _this$props.title;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_12__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["y" /* useKeyOnly */])(completed, 'completed'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["y" /* useKeyOnly */])(link, 'link'), 'step', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getUnhandledProps */])(Step, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["p" /* getElementType */])(Step, this.props, this.computeElementType);

      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), content);
      }

      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_13__Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_14__StepContent__["a" /* default */].create({
        description: description,
        title: title
      }, {
        autoGenerateKey: false
      }));
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Content", __WEBPACK_IMPORTED_MODULE_14__StepContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Description", __WEBPACK_IMPORTED_MODULE_15__StepDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Group", __WEBPACK_IMPORTED_MODULE_16__StepGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "Title", __WEBPACK_IMPORTED_MODULE_17__StepTitle__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Step, "handledProps", ["active", "as", "children", "className", "completed", "content", "description", "disabled", "href", "icon", "link", "onClick", "ordered", "title"]);

Step.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A step can be highlighted as active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A step can show that a user has completed it. */
  completed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Show that the Loader is inactive. */
  disabled: PropTypes.bool,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A step can be link. */
  link: PropTypes.bool,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
  ordered: PropTypes.bool,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};
Step.create = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["l" /* createShorthandFactory */])(Step, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Step);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepDescription__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepTitle__ = __webpack_require__(284);







/**
 * A step can contain a content.
 */

function StepContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      title = props.title;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(StepContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(StepContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__StepTitle__["a" /* default */].create(title, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_5__StepDescription__["a" /* default */].create(description, {
    autoGenerateKey: false
  }));
}

StepContent.handledProps = ["as", "children", "className", "content", "description", "title"];
StepContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};
StepContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(StepContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepContent);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Step__ = __webpack_require__(513);












var numberMap =  false ? _pickBy(numberToWordMap, function (val, key) {
  return key <= 8;
}) : {};
/**
 * A set of steps.
 */

function StepGroup(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      items = props.items,
      ordered = props.ordered,
      size = props.size,
      stackable = props.stackable,
      unstackable = props.unstackable,
      vertical = props.vertical,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["y" /* useKeyOnly */])(ordered, 'ordered'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["y" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["y" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useValueAndKey */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["E" /* useWidthProp */])(widths), 'steps', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getUnhandledProps */])(StepGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["p" /* getElementType */])(StepGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_10__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_10__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(items, function (item) {
    return __WEBPACK_IMPORTED_MODULE_11__Step__["a" /* default */].create(item);
  }));
}

StepGroup.handledProps = ["as", "attached", "children", "className", "content", "fluid", "items", "ordered", "size", "stackable", "unstackable", "vertical", "widths"];
StepGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Steps can be attached to other elements. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid step takes up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand array of props for Step. */
  items: customPropTypes.collectionShorthand,

  /** A step can show a ordered sequence of steps. */
  ordered: PropTypes.bool,

  /** Steps can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A step can stack vertically only on smaller screens. */
  stackable: PropTypes.oneOf(['tablet']),

  /** A step can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** A step can be displayed stacked vertically. */
  vertical: PropTypes.bool,

  /** Steps can be divided evenly inside their parent. */
  widths: PropTypes.oneOf([].concat(_toConsumableArray(_keys(numberMap)), _toConsumableArray(_keys(numberMap).map(Number)), _toConsumableArray(_values(numberMap))))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (StepGroup);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AccordionPanel__ = __webpack_require__(285);




















var warnIfPropsAreInvalid = function warnIfPropsAreInvalid(props, state) {
  var exclusive = props.exclusive;
  var activeIndex = state.activeIndex;
  /* eslint-disable no-console */

  if (exclusive && typeof activeIndex !== 'number') {
    console.error('`activeIndex` must be a number if `exclusive` is true');
  } else if (!exclusive && !__WEBPACK_IMPORTED_MODULE_13_lodash_isArray___default()(activeIndex)) {
    console.error('`activeIndex` must be an array if `exclusive` is false');
  }
  /* eslint-enable no-console */

};
/**
 * An Accordion can contain sub-accordions.
 */


var AccordionAccordion =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AccordionAccordion, _Component);

  function AccordionAccordion() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AccordionAccordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AccordionAccordion)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeNewIndex", function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;
      if (exclusive) return index === activeIndex ? -1 : index; // check to see if index is in array, and remove it, if not then add it

      return __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(activeIndex, index) ? __WEBPACK_IMPORTED_MODULE_11_lodash_without___default()(activeIndex, index) : [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(activeIndex), [index]);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTitleClick", function (e, titleProps) {
      var index = titleProps.index;

      _this.trySetState({
        activeIndex: _this.computeNewIndex(index)
      });

      __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default()(_this.props, 'onTitleClick', e, titleProps);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "isIndexActive", function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;
      return exclusive ? activeIndex === index : __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(activeIndex, index);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AccordionAccordion, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState(_ref) {
      var exclusive = _ref.exclusive;
      return {
        activeIndex: exclusive ? -1 : []
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (false) {
        warnIfPropsAreInvalid(this.props, this.state);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (false) {
        warnIfPropsAreInvalid(this.props, this.state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          panels = _this$props.panels;
      var classes = __WEBPACK_IMPORTED_MODULE_14_classnames___default()('accordion', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_17__lib__["q" /* getUnhandledProps */])(AccordionAccordion, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_17__lib__["p" /* getElementType */])(AccordionAccordion, this.props);
      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_17__lib__["c" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(panels, function (panel, index) {
        return __WEBPACK_IMPORTED_MODULE_18__AccordionPanel__["a" /* default */].create(panel, {
          defaultProps: {
            active: _this2.isIndexActive(index),
            index: index,
            onTitleClick: _this2.handleTitleClick
          }
        });
      }) : children);
    }
  }]);

  return AccordionAccordion;
}(__WEBPACK_IMPORTED_MODULE_17__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AccordionAccordion, "defaultProps", {
  exclusive: true
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AccordionAccordion, "autoControlledProps", ['activeIndex']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AccordionAccordion, "handledProps", ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"]);


AccordionAccordion.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Index of the currently active panel. */
  activeIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Initial activeIndex value. */
  defaultActiveIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Only allow one panel open at a time. */
  exclusive: PropTypes.bool,

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** Shorthand array of props for Accordion. */
  panels: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape({
    content: customPropTypes.itemShorthand,
    title: customPropTypes.itemShorthand
  }))])
} : {};
AccordionAccordion.create = Object(__WEBPACK_IMPORTED_MODULE_17__lib__["l" /* createShorthandFactory */])(AccordionAccordion, function (content) {
  return {
    content: content
  };
});

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(132),
    eq = __webpack_require__(123);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(520);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1134);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(521);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(523);

var supportsDescriptors = __webpack_require__(141).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if ((/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(76)))

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A PopupContent displays the content body of a Popover.
 */

function PopupContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(PopupContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(PopupContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}
PopupContent.handledProps = ["as", "children", "className", "content"];
PopupContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The content of the Popup */
  children: PropTypes.node,

  /** Classes to add to the Popup content className. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
PopupContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(PopupContent, function (children) {
  return {
    children: children
  };
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A PopupHeader displays a header in a Popover.
 */

function PopupHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(PopupHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(PopupHeader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}
PopupHeader.handledProps = ["as", "children", "className", "content"];
PopupHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
PopupHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(PopupHeader, function (children) {
  return {
    children: children
  };
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_keyboard_key__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);














/**
 * An internal icon sub-component for Rating component
 */

var RatingIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(RatingIcon, _Component);

  function RatingIcon() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RatingIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(RatingIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleKeyUp", function (e) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onKeyUp', e, _this.props);

      switch (__WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.Enter:
        case __WEBPACK_IMPORTED_MODULE_10_keyboard_key___default.a.Spacebar:
          e.preventDefault();

          __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);

          break;

        default:
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseEnter", function (e) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onMouseEnter', e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(RatingIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          className = _this$props.className,
          selected = _this$props.selected;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(selected, 'selected'), 'icon', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(RatingIcon, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(RatingIcon, this.props);
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick,
        onKeyUp: this.handleKeyUp,
        onMouseEnter: this.handleMouseEnter,
        role: "radio"
      }));
    }
  }]);

  return RatingIcon;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(RatingIcon, "defaultProps", {
  as: 'i'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(RatingIcon, "handledProps", ["active", "as", "className", "index", "onClick", "onKeyUp", "onMouseEnter", "selected"]);


RatingIcon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Indicates activity of an icon. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** An index of icon inside Rating. */
  index: PropTypes.number,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on keyup.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyUp: PropTypes.func,

  /**
   * Called on mouseenter.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseEnter: PropTypes.func,

  /** Indicates selection of an icon. */
  selected: PropTypes.bool
} : {};

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchCategoryLayout__ = __webpack_require__(1171);







function SearchCategory(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      layoutRenderer = props.layoutRenderer,
      renderer = props.renderer;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(active, 'active'), 'category', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(SearchCategory, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(SearchCategory, props);
  var categoryContent = renderer(props);
  var resultsContent = __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), layoutRenderer({
    categoryContent: categoryContent,
    resultsContent: resultsContent
  }));
}

SearchCategory.handledProps = ["active", "as", "children", "className", "content", "layoutRenderer", "name", "renderer", "results"];
SearchCategory.defaultProps = {
  layoutRenderer: __WEBPACK_IMPORTED_MODULE_5__SearchCategoryLayout__["a" /* default */],
  renderer: function renderer(_ref) {
    var name = _ref.name;
    return name;
  }
};
SearchCategory.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Display name. */
  name: PropTypes.string,

  /**
   * Renders the category layout contents.
   *
   * @param {object} props - The SearchCategoryLayout props object.
   * @returns {*} - Renderable category layout contents.
   */
  layoutRenderer: PropTypes.func,

  /**
   * Renders the category contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable category contents.
   */
  renderer: PropTypes.func,

  /** Array of Search.Result props. */
  results: PropTypes.array
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchCategory);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(5);











 // Note: You technically only need the 'content' wrapper when there's an
// image. However, optionally wrapping it makes this function a lot more
// complicated and harder to read. Since always wrapping it doesn't affect
// the style in any way let's just do that.
//
// Note: To avoid requiring a wrapping div, we return an array here so to
// prevent rendering issues each node needs a unique key.

var defaultRenderer = function defaultRenderer(_ref) {
  var image = _ref.image,
      price = _ref.price,
      title = _ref.title,
      description = _ref.description;
  return [image && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    key: "image",
    className: "image"
  }, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["f" /* createHTMLImage */])(image, {
    autoGenerateKey: false
  })), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    key: "content",
    className: "content"
  }, price && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    className: "price"
  }, price), title && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    className: "title"
  }, title), description && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
    className: "description"
  }, description))];
};

defaultRenderer.handledProps = [];

var SearchResult =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(SearchResult, _Component);

  function SearchResult() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchResult);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchResult)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchResult, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          className = _this$props.className,
          renderer = _this$props.renderer;
      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_11__lib__["y" /* useKeyOnly */])(active, 'active'), 'result', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getUnhandledProps */])(SearchResult, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["p" /* getElementType */])(SearchResult, this.props); // Note: You technically only need the 'content' wrapper when there's an
      // image. However, optionally wrapping it makes this function a lot more
      // complicated and harder to read. Since always wrapping it doesn't affect
      // the style in any way let's just do that.

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), renderer(this.props));
    }
  }]);

  return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(SearchResult, "defaultProps", {
  renderer: defaultRenderer
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(SearchResult, "handledProps", ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"]);


SearchResult.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: PropTypes.string,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Add an image to the item. */
  image: PropTypes.string,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** Customized text for price. */
  price: PropTypes.string,

  /**
   * Renders the result contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable result contents.
   */
  renderer: PropTypes.func,

  /** Display title. */
  title: PropTypes.string.isRequired
} : {};

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);






function SearchResults(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('results transition', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(SearchResults, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(SearchResults, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

SearchResults.handledProps = ["as", "children", "className", "content"];
SearchResults.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchResults);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var isActionSupported = function isActionSupported(targetRef, method) {
  return targetRef && !!targetRef.current && !!targetRef.current[method];
};

var useEventListener = function useEventListener(options) {
  var capture = options.capture,
      listener = options.listener,
      type = options.type,
      targetRef = options.targetRef;
  var latestListener = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](listener);
  latestListener.current = listener;
  var eventHandler = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    return latestListener.current(event);
  }, []);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (isActionSupported(targetRef, 'addEventListener')) {
      ;
      targetRef.current.addEventListener(type, eventHandler, capture);
    } else if (false) {
      throw new Error('@stardust-ui/react-component-event-listener: Passed `targetRef` is not valid or does not support `addEventListener()` method.');
    }

    return function () {
      if (isActionSupported(targetRef, 'removeEventListener')) {
        ;
        targetRef.current.removeEventListener(type, eventHandler, capture);
      } else if (false) {
        throw new Error('@stardust-ui/react-component-event-listener: Passed `targetRef` is not valid or does not support `removeEventListener()` method.');
      }
    };
  }, [capture, targetRef, type]);
};

/* harmony default export */ __webpack_exports__["a"] = (useEventListener);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A pushable sub-component for Sidebar.
 */

function SidebarPushable(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pushable', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(SidebarPushable, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(SidebarPushable, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

SidebarPushable.handledProps = ["as", "children", "className", "content"];
SidebarPushable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SidebarPushable);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A pushable sub-component for Sidebar.
 */

function SidebarPusher(props) {
  var className = props.className,
      dimmed = props.dimmed,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pusher', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(dimmed, 'dimmed'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(SidebarPusher, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(SidebarPusher, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

SidebarPusher.handledProps = ["as", "children", "className", "content", "dimmed"];
SidebarPusher.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SidebarPusher);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__ = __webpack_require__(510);






/**
 * A tab pane holds the content of a tab.
 */

function TabPane(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      loading = props.loading;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(loading, 'loading'), 'tab', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(TabPane, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(TabPane, props);
  var calculatedDefaultProps = {};

  if (ElementType === __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */]) {
    calculatedDefaultProps.attached = 'bottom';
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, calculatedDefaultProps, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

TabPane.handledProps = ["active", "as", "children", "className", "content", "loading"];
TabPane.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */],
  active: true
};
TabPane.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A tab pane can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A Tab.Pane can display a loading indicator. */
  loading: PropTypes.bool
} : {};
TabPane.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(TabPane, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TabPane);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_Image__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardContent__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardDescription__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CardGroup__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CardHeader__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CardMeta__ = __webpack_require__(291);


















/**
 * A card displays site content in a manner similar to a playing card.
 */

var Card =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Card, _Component);

  function Card() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          centered = _this$props.centered,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          description = _this$props.description,
          extra = _this$props.extra,
          fluid = _this$props.fluid,
          header = _this$props.header,
          href = _this$props.href,
          image = _this$props.image,
          link = _this$props.link,
          meta = _this$props.meta,
          onClick = _this$props.onClick,
          raised = _this$props.raised;
      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', color, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["y" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["y" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["y" /* useKeyOnly */])(raised, 'raised'), 'card', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getUnhandledProps */])(Card, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["p" /* getElementType */])(Card, this.props, function () {
        if (onClick) return 'a';
      });

      if (!__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          href: href,
          onClick: this.handleClick
        }), content);
      }

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_12__elements_Image__["a" /* default */].create(image, {
        autoGenerateKey: false,
        defaultProps: {
          ui: false,
          wrapped: true
        }
      }), (description || header || meta) && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CardContent__["a" /* default */], {
        description: description,
        header: header,
        meta: meta
      }), extra && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CardContent__["a" /* default */], {
        extra: true
      }, extra));
    }
  }]);

  return Card;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Content", __WEBPACK_IMPORTED_MODULE_13__CardContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Description", __WEBPACK_IMPORTED_MODULE_14__CardDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Group", __WEBPACK_IMPORTED_MODULE_15__CardGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Header", __WEBPACK_IMPORTED_MODULE_16__CardHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "Meta", __WEBPACK_IMPORTED_MODULE_17__CardMeta__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Card, "handledProps", ["as", "centered", "children", "className", "color", "content", "description", "extra", "fluid", "header", "href", "image", "link", "meta", "onClick", "raised"]);


Card.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A Card can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A Card can be formatted to display different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for primary content of CardContent. */
  extra: customPropTypes.contentShorthand,

  /** A Card can be formatted to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** A card can contain an Image component. */
  image: customPropTypes.itemShorthand,

  /** A card can be formatted to link to other content. */
  link: PropTypes.bool,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /**
   * Called on click. When passed, the component renders as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A Card can be formatted to raise above the page. */
  raised: PropTypes.bool
} : {};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDescription__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardHeader__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardMeta__ = __webpack_require__(291);









/**
 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
 */

function CardContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(extra, 'extra'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(CardContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(CardContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__CardHeader__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, header, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__CardMeta__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, meta, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__CardDescription__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, description, {
    autoGenerateKey: false
  }));
}

CardContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "textAlign"];
CardContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** A card can contain extra content meant to be formatted separately from the main content. */
  extra: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardContent);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Card__ = __webpack_require__(538);








/**
 * A group of cards.
 */

function CardGroup(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      doubling = props.doubling,
      items = props.items,
      itemsPerRow = props.itemsPerRow,
      stackable = props.stackable,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(doubling, 'doubling'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useWidthProp */])(itemsPerRow), 'cards', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(CardGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(CardGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  var itemsJSX = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    var key = item.key || [item.header, item.description].join('-');
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Card__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      key: key
    }, item));
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), itemsJSX);
}

CardGroup.handledProps = ["as", "centered", "children", "className", "content", "doubling", "items", "itemsPerRow", "stackable", "textAlign"];
CardGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A group of cards can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of cards can double its column width for mobile. */
  doubling: PropTypes.bool,

  /** Shorthand array of props for Card. */
  items: customPropTypes.collectionShorthand,

  /** A group of cards can set how many cards should exist in a row. */
  itemsPerRow: PropTypes.oneOf(SUI.WIDTHS),

  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
  stackable: PropTypes.bool,

  /** A card group can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardGroup);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A comment can contain an action.
 */

function CommentAction(props) {
  var active = props.active,
      className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(active, 'active'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(CommentAction, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(CommentAction, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentAction.handledProps = ["active", "as", "children", "className", "content"];
CommentAction.defaultProps = {
  as: 'a'
};
CommentAction.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Style as the currently active action. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAction);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A comment can contain an list of actions a user may perform related to this comment.
 */

function CommentActions(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('actions', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(CommentActions, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(CommentActions, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentActions.handledProps = ["as", "children", "className", "content"];
CommentActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentActions);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A comment can contain an author.
 */

function CommentAuthor(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('author', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(CommentAuthor, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(CommentAuthor, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentAuthor.handledProps = ["as", "children", "className", "content"];
CommentAuthor.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAuthor);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A comment can contain an image or avatar.
 */

function CommentAvatar(props) {
  var className = props.className,
      src = props.src;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('avatar', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(CommentAvatar, props);

  var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["x" /* partitionHTMLProps */])(rest, {
    htmlProps: __WEBPACK_IMPORTED_MODULE_5__lib__["r" /* htmlImageProps */]
  }),
      _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
      imageProps = _partitionHTMLProps2[0],
      rootProps = _partitionHTMLProps2[1];

  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(CommentAvatar, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rootProps, {
    className: classes
  }), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* createHTMLImage */])(src, {
    autoGenerateKey: false,
    defaultProps: imageProps
  }));
}

CommentAvatar.handledProps = ["as", "className", "src"];
CommentAvatar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies the URL of the image. */
  src: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAvatar);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A comment can contain content.
 */

function CommentContent(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'content');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(CommentContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(CommentContent, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentContent.handledProps = ["as", "children", "className", "content"];
CommentContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentContent);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * Comments can be grouped.
 */

function CommentGroup(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content,
      minimal = props.minimal,
      size = props.size,
      threaded = props.threaded;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(collapsed, 'collapsed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(minimal, 'minimal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(threaded, 'threaded'), 'comments', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(CommentGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(CommentGroup, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentGroup.handledProps = ["as", "children", "className", "collapsed", "content", "minimal", "size", "threaded"];
CommentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comments can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
  minimal: PropTypes.bool,

  /** Comments can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A comment list can be threaded to showing the relationship between conversations. */
  threaded: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentGroup);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
 */

function CommentMetadata(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('metadata', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(CommentMetadata, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(CommentMetadata, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentMetadata.handledProps = ["as", "children", "className", "content"];
CommentMetadata.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentMetadata);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A comment can contain text.
 */

function CommentText(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'text');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(CommentText, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(CommentText, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

CommentText.handledProps = ["as", "children", "className", "content"];
CommentText.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentText);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedContent__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedLabel__ = __webpack_require__(298);







/**
 * A feed contains an event.
 */

function FeedEvent(props) {
  var content = props.content,
      children = props.children,
      className = props.className,
      date = props.date,
      extraImages = props.extraImages,
      extraText = props.extraText,
      image = props.image,
      icon = props.icon,
      meta = props.meta,
      summary = props.summary;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('event', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(FeedEvent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(FeedEvent, props);
  var hasContentProp = content || date || extraImages || extraText || meta || summary;
  var contentProps = {
    content: content,
    date: date,
    extraImages: extraImages,
    extraText: extraText,
    meta: meta,
    summary: summary
  };
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
    return {
      icon: val
    };
  }, icon, {
    autoGenerateKey: false
  }), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
    return {
      image: val
    };
  }, image, {
    autoGenerateKey: false
  }), hasContentProp && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FeedContent__["a" /* default */], contentProps), children);
}

FeedEvent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "icon", "image", "meta", "summary"];
FeedEvent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for FeedContent. */
  content: customPropTypes.itemShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with content. */
  extraText: customPropTypes.itemShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedEvent);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemContent__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemGroup__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ItemHeader__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ItemImage__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemMeta__ = __webpack_require__(302);












/**
 * An item view presents large collections of site content for display.
 */

function Item(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      image = props.image,
      meta = props.meta;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('item', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Item, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Item, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */].create(image, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */], {
    content: content,
    description: description,
    extra: extra,
    header: header,
    meta: meta
  }));
}

Item.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "image", "meta"];
Item.Content = __WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */];
Item.Description = __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */];
Item.Extra = __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */];
Item.Group = __WEBPACK_IMPORTED_MODULE_8__ItemGroup__["a" /* default */];
Item.Header = __WEBPACK_IMPORTED_MODULE_9__ItemHeader__["a" /* default */];
Item.Image = __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */];
Item.Meta = __WEBPACK_IMPORTED_MODULE_11__ItemMeta__["a" /* default */];
Item.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for ItemContent component. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemImage component. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemHeader__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemMeta__ = __webpack_require__(302);









/**
 * An item can contain content.
 */

function ItemContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["D" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(ItemContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(ItemContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__ItemHeader__["a" /* default */].create(header, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_8__ItemMeta__["a" /* default */].create(meta, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */].create(description, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */].create(extra, {
    autoGenerateKey: false
  }), content);
}

ItemContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "verticalAlign"];
ItemContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand,

  /** Content can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ItemContent);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(550);








/**
 * A group of items.
 */

function ItemGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      divided = props.divided,
      items = props.items,
      link = props.link,
      relaxed = props.relaxed,
      unstackable = props.unstackable;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), 'items', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(ItemGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(ItemGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  var itemsJSX = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    var childKey = item.childKey,
        itemProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(item, ["childKey"]);

    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, itemProps, {
      key: finalKey
    }));
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), itemsJSX);
}

ItemGroup.handledProps = ["as", "children", "className", "content", "divided", "items", "link", "relaxed", "unstackable"];
ItemGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Items can be divided to better distinguish between grouped content. */
  divided: PropTypes.bool,

  /** Shorthand array of props for Item. */
  items: customPropTypes.collectionShorthand,

  /** An item can be formatted so that the entire contents link to another page. */
  link: PropTypes.bool,

  /** A group of items can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Prevent items from stacking on mobile. */
  unstackable: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ItemGroup);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Image__ = __webpack_require__(108);




/**
 * An item can contain an image.
 */

function ItemImage(props) {
  var size = props.size;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getUnhandledProps */])(ItemImage, props);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    size: size,
    ui: !!size,
    wrapped: true
  }));
}

ItemImage.handledProps = ["size"];
ItemImage.propTypes =  false ? {
  /** An image may appear at different sizes. */
  size: Image.propTypes.size
} : {};
ItemImage.create = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["l" /* createShorthandFactory */])(ItemImage, function (src) {
  return {
    src: src
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemImage);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatisticValue__ = __webpack_require__(557);









/**
 * A statistic emphasizes the current value of an attribute.
 */

function Statistic(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      floated = props.floated,
      horizontal = props.horizontal,
      inverted = props.inverted,
      label = props.label,
      size = props.size,
      text = props.text,
      value = props.value;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), 'statistic', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(Statistic, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(Statistic, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */].create(value, {
    defaultProps: {
      text: text
    },
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */].create(label, {
    autoGenerateKey: false
  }));
}

Statistic.handledProps = ["as", "children", "className", "color", "content", "floated", "horizontal", "inverted", "label", "size", "text", "value"];
Statistic.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A statistic can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Label content of the Statistic. */
  label: customPropTypes.contentShorthand,

  /** A statistic can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool,

  /** Value content of the Statistic. */
  value: customPropTypes.contentShorthand
} : {};
Statistic.Group = __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__["a" /* default */];
Statistic.Label = __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */];
Statistic.Value = __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */];
Statistic.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* createShorthandFactory */])(Statistic, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Statistic);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Statistic__ = __webpack_require__(554);








/**
 * A group of statistics.
 */

function StatisticGroup(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      horizontal = props.horizontal,
      inverted = props.inverted,
      items = props.items,
      size = props.size,
      widths = props.widths;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useWidthProp */])(widths), 'statistics', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(StatisticGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(StatisticGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), content);
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    return __WEBPACK_IMPORTED_MODULE_7__Statistic__["a" /* default */].create(item);
  }));
}

StatisticGroup.handledProps = ["as", "children", "className", "color", "content", "horizontal", "inverted", "items", "size", "widths"];
StatisticGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic group can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic group can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic group can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Array of props for Statistic. */
  items: customPropTypes.collectionShorthand,

  /** A statistic group can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** A statistic group can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (StatisticGroup);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A statistic can contain a label to help provide context for the presented value.
 */

function StatisticLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('label', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(StatisticLabel, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(StatisticLabel, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

StatisticLabel.handledProps = ["as", "children", "className", "content"];
StatisticLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StatisticLabel.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(StatisticLabel, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StatisticLabel);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A statistic can contain a numeric, icon, image, or text value.
 */

function StatisticValue(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      text = props.text;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(text, 'text'), 'value', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(StatisticValue, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(StatisticValue, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

StatisticValue.handledProps = ["as", "children", "className", "content", "text"];
StatisticValue.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Format the value with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool
} : {};
StatisticValue.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthandFactory */])(StatisticValue, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StatisticValue);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SafeAnchor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var defaultProps = {
  active: false
};
var BreadcrumbItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      active = _ref.active,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'li' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "active", "className", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'breadcrumb-item');

  var href = props.href,
      title = props.title,
      target = props.target,
      elementProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["href", "title", "target"]);

  var linkProps = {
    href: href,
    title: title,
    target: target
  };
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefix, className, {
      active: active
    }),
    "aria-current": active ? 'page' : undefined
  }, active ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, elementProps, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      active: active
    })
  })) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, elementProps, linkProps)));
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var defaultProps = {
  variant: null
};
var CardImg = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      variant = _ref.variant,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'img' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "variant", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'card-img');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(variant ? prefix + "-" + variant : prefix, className)
  }, props));
});
CardImg.displayName = 'CardImg';
CardImg.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CardImg);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('carousel-item'));

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var Col = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span, offset, order;

    if (propValue != null && typeof propValue === 'object') {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (span != null) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
    if (order != null) classes.push("order" + infix + "-" + order);
    if (offset != null) classes.push("offset" + infix + "-" + offset);
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a.apply(void 0, [className].concat(spans, classes))
  }));
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["a"] = (Col);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactPopper = __webpack_require__(310);

var _DropdownContext = _interopRequireDefault(__webpack_require__(312));

var _RootCloseWrapper = _interopRequireDefault(__webpack_require__(565));

var _mapContextToProps = _interopRequireDefault(__webpack_require__(1212));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownMenu, _React$Component);

  function DropdownMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      toggleId: null
    };
    _this.popperIsInitialized = false;

    _this.handleClose = function (e) {
      if (!_this.props.onToggle) return;

      _this.props.onToggle(false, e);
    };

    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
    // If, to the best we can tell, this update won't reinitialize popper,
    // manually schedule an update
    var shouldUpdatePopper = !prevProps.show && this.props.show && this.popperIsInitialized && // a new reference node will already trigger this internally
    prevProps.toggleNode === this.props.toggleNode;

    if (this.props.show && this.props.usePopper && !this.popperIsInitialized) {
      this.popperIsInitialized = true;
    }

    return !!shouldUpdatePopper;
  };

  _proto.componentDidUpdate = function componentDidUpdate(_, __, shouldUpdatePopper) {
    if (shouldUpdatePopper && this.scheduleUpdate) {
      this.scheduleUpdate();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        show = _this$props.show,
        flip = _this$props.flip,
        menuRef = _this$props.menuRef,
        alignEnd = _this$props.alignEnd,
        drop = _this$props.drop,
        usePopper = _this$props.usePopper,
        toggleNode = _this$props.toggleNode,
        rootCloseEvent = _this$props.rootCloseEvent,
        _this$props$popperCon = _this$props.popperConfig,
        popperConfig = _this$props$popperCon === void 0 ? {} : _this$props$popperCon;
    var placement = alignEnd ? 'bottom-end' : 'bottom-start';
    if (drop === 'up') placement = alignEnd ? 'top-end' : 'top-start';
    if (drop === 'right') placement = alignEnd ? 'right-end' : 'right-start';
    if (drop === 'left') placement = alignEnd ? 'left-end' : 'left-start';
    var menu = null;
    var menuProps = {
      ref: menuRef,
      'aria-labelledby': toggleNode && toggleNode.id
    };
    var childArgs = {
      show: show,
      alignEnd: alignEnd,
      close: this.handleClose
    };

    if (!usePopper) {
      menu = this.props.children(_extends({}, childArgs, {
        props: menuProps
      }));
    } else if (this.popperIsInitialized || show) {
      // Add it this way, so it doesn't override someones usage
      // with react-poppers <Reference>
      if (toggleNode) popperConfig.referenceElement = toggleNode;
      menu = _react.default.createElement(_reactPopper.Popper, _extends({}, popperConfig, {
        innerRef: menuRef,
        placement: placement,
        eventsEnabled: !!show,
        modifiers: _extends({
          flip: {
            enabled: !!flip
          }
        }, popperConfig.modifiers)
      }), function (_ref) {
        var ref = _ref.ref,
            style = _ref.style,
            popper = _objectWithoutPropertiesLoose(_ref, ["ref", "style"]);

        _this2.scheduleUpdate = popper.scheduleUpdate;
        return _this2.props.children(_extends({}, popper, childArgs, {
          props: _extends({}, menuProps, {
            ref: ref,
            style: style
          })
        }));
      });
    }

    return menu && _react.default.createElement(_RootCloseWrapper.default, {
      disabled: !show,
      event: rootCloseEvent,
      onRootClose: this.handleClose
    }, menu);
  };

  return DropdownMenu;
}(_react.default.Component);

DropdownMenu.displayName = 'ReactOverlaysDropdownMenu';
DropdownMenu.propTypes = {
  /**
   * A render prop that returns a Menu element. The `props`
   * argument should spread through to **a component that can accept a ref**.
   *
   * @type {Function ({
   *   show: boolean,
   *   alignEnd: boolean,
   *   close: (?SyntheticEvent) => void,
   *   placement: Placement,
   *   outOfBoundaries: ?boolean,
   *   scheduleUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */
  children: _propTypes.default.func.isRequired,

  /**
   * Controls the visible state of the menu, generally this is
   * provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */
  show: _propTypes.default.bool,

  /**
   * Aligns the dropdown menu to the 'end' of it's placement position.
   * Generally this is provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */
  alignEnd: _propTypes.default.bool,

  /**
   * Enables the Popper.js `flip` modifier, allowing the Dropdown to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: _propTypes.default.bool,
  usePopper: _propTypes.default.oneOf([true, false]),

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: _propTypes.default.object,

  /**
   * Override the default event used by RootCloseWrapper.
   */
  rootCloseEvent: _propTypes.default.string,

  /** @private */
  onToggle: _propTypes.default.func,

  /** @private */
  menuRef: _propTypes.default.func,

  /** @private */
  drop: _propTypes.default.string,

  /** @private */
  toggleNode: _propTypes.default.any
};
DropdownMenu.defaultProps = {
  usePopper: true
};
var DecoratedDropdownMenu = (0, _mapContextToProps.default)(_DropdownContext.default, function (_ref2, props) {
  var show = _ref2.show,
      alignEnd = _ref2.alignEnd,
      toggle = _ref2.toggle,
      drop = _ref2.drop,
      menuRef = _ref2.menuRef,
      toggleNode = _ref2.toggleNode;
  return {
    drop: drop,
    menuRef: menuRef,
    toggleNode: toggleNode,
    onToggle: toggle,
    show: show == null ? props.show : show,
    alignEnd: alignEnd == null ? props.alignEnd : alignEnd
  };
}, DropdownMenu);
var _default = DecoratedDropdownMenu;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _contains = _interopRequireDefault(__webpack_require__(205));

var _listen = _interopRequireDefault(__webpack_require__(313));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _ownerDocument = _interopRequireDefault(__webpack_require__(568));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var escapeKeyCode = 27;

var noop = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */


var RootCloseWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    _this.addEventListeners = function () {
      var event = _this.props.event;
      var doc = (0, _ownerDocument.default)(_assertThisInitialized(_assertThisInitialized(_this))); // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.

      _this.removeMouseCaptureListener = (0, _listen.default)(doc, event, _this.handleMouseCapture, true);
      _this.removeMouseListener = (0, _listen.default)(doc, event, _this.handleMouse);
      _this.removeKeyupListener = (0, _listen.default)(doc, 'keyup', _this.handleKeyUp);

      if ('ontouchstart' in doc.documentElement) {
        _this.mobileSafariHackListeners = [].slice.call(document.body.children).map(function (el) {
          return (0, _listen.default)(el, 'mousemove', noop);
        });
      }
    };

    _this.removeEventListeners = function () {
      if (_this.removeMouseCaptureListener) _this.removeMouseCaptureListener();
      if (_this.removeMouseListener) _this.removeMouseListener();
      if (_this.removeKeyupListener) _this.removeKeyupListener();
      if (_this.mobileSafariHackListeners) _this.mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains.default)(_reactDom.default.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this))), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  var _proto = RootCloseWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';
RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes.default.func,

  /**
   * Children to render.
   */
  children: _propTypes.default.element,

  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes.default.bool,

  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes.default.oneOf(['click', 'mousedown'])
};
RootCloseWrapper.defaultProps = {
  event: 'click'
};
var _default = RootCloseWrapper;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = _default;

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _ownerDocument = _interopRequireDefault(__webpack_require__(143));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(componentOrElement) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(componentOrElement));
}

module.exports = exports.default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = forwardRef;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function forwardRef(renderFn, _ref) {
  var displayName = _ref.displayName,
      propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps,
      _ref$allowFallback = _ref.allowFallback,
      allowFallback = _ref$allowFallback === void 0 ? false : _ref$allowFallback;

  var render = function render(props, ref) {
    return renderFn(props, ref);
  };

  Object.assign(render, {
    displayName: displayName
  });
  if (_react.default.forwardRef || !allowFallback) return Object.assign(_react.default.forwardRef(render), {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
  return Object.assign(function (props) {
    return render(props, null);
  }, {
    displayName: displayName,
    propTypes: propTypes,
    defaultProps: defaultProps
  });
}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _DropdownContext = _interopRequireDefault(__webpack_require__(312));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * A render prop that returns a Toggle element. The `props`
   * argument should spread through to **a component that can accept a ref**. Use
   * the `onToggle` argument to toggle the menu open or closed
   *
   * @type {Function ({
   *   show: boolean,
   *   toggle: (show: boolean) => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     aria-haspopup: true
   *     aria-expanded: boolean
   *   },
   * }) => React.Element}
   */
  children: _propTypes.default.func.isRequired
};

function DropdownToggle(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_DropdownContext.default.Consumer, null, function (_ref2) {
    var show = _ref2.show,
        toggle = _ref2.toggle,
        toggleRef = _ref2.toggleRef;
    return children({
      show: show,
      toggle: toggle,
      props: {
        ref: toggleRef,
        'aria-haspopup': true,
        'aria-expanded': !!show
      }
    });
  });
}

DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
DropdownToggle.propTypes = propTypes;
var _default = DropdownToggle;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SafeAnchor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavContext__ = __webpack_require__(314);









var defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__SafeAnchor__["a" /* default */],
  disabled: false
};
var DropdownItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      eventKey = _ref.eventKey,
      disabled = _ref.disabled,
      href = _ref.href,
      onClick = _ref.onClick,
      onSelect = _ref.onSelect,
      propActive = _ref.active,
      Component = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "eventKey", "disabled", "href", "onClick", "onSelect", "active", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'dropdown-item');
  var onSelectCtx = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["a" /* default */]);
  var navContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__NavContext__["a" /* default */]);

  var _ref2 = navContext || {},
      activeKey = _ref2.activeKey;

  var key = Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(eventKey, href);
  var active = propActive == null && key != null ? Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(activeKey) === key : propActive;
  var handleClick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["default"])(function (event) {
    // SafeAnchor handles the disabled case, but we handle it here
    // for other components
    if (disabled) return;
    if (onClick) onClick(event);
    if (onSelectCtx) onSelectCtx(key, event);
    if (onSelect) onSelect(key, event);
  });
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    href: href,
    disabled: disabled,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, active && 'active', disabled && 'disabled'),
    onClick: handleClick
  }), children);
});
DropdownItem.displayName = 'DropdownItem';
DropdownItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormContext__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var FormGroup = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      controlId = _ref.controlId,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "controlId", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-group');
  var context = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return {
      controlId: controlId
    };
  }, [controlId]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FormContext__["a" /* default */].Provider, {
    value: context
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }), children));
});
FormGroup.displayName = 'FormGroup';
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Feedback__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormContext__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);








var FormControl = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      type = _ref.type,
      size = _ref.size,
      id = _ref.id,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      plaintext = _ref.plaintext,
      readOnly = _ref.readOnly,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "type", "size", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "as"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-control');
  var classes;

  if (plaintext) {
    var _classes;

    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
  } else if (type === 'file') {
    var _classes2;

    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
  } else {
    var _classes3;

    classes = (_classes3 = {}, _classes3[bsPrefix] = true, _classes3[bsPrefix + "-" + size] = size, _classes3);
  }

   false ? warning(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    type: type,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
  }));
});
FormControl.displayName = 'FormControl';
FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_5__Feedback__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (FormControl);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);





var propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  as: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.elementType
};
var defaultProps = {
  type: 'valid'
};
var Feedback = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      type = _ref.type,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["as", "className", "type"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, type && type + "-feedback")
  }));
});
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
Feedback.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Feedback);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormContext__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Feedback__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormCheckInput__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormCheckLabel__ = __webpack_require__(1218);









var defaultProps = {
  type: 'checkbox',
  inline: false,
  disabled: false,
  isValid: false,
  isInvalid: false,
  title: ''
};
var FormCheck = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      disabled = _ref.disabled,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title,
      type = _ref.type,
      label = _ref.label,
      children = _ref.children,
      custom = _ref.custom,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "bsPrefix", "inline", "disabled", "isValid", "isInvalid", "feedback", "className", "style", "title", "type", "label", "children", "custom"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-check');

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  var innerFormContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = label != null && label !== false && !children;
  var input = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormCheckInput__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    type: type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    isStatic: !hasLabel,
    disabled: disabled
  }));
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FormContext__["a" /* default */].Provider, {
    value: innerFormContext
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !custom && bsPrefix, custom && "custom-control custom-" + type, inline && (custom ? 'custom-control' : bsPrefix) + "-inline")
  }, children || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, input, hasLabel && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FormCheckLabel__["a" /* default */], {
    title: title
  }, label), (isValid || isInvalid) && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Feedback__["a" /* default */], {
    type: isValid ? 'valid' : 'invalid'
  }, feedback))));
});
FormCheck.displayName = 'FormCheck';
FormCheck.defaultProps = defaultProps;
FormCheck.Input = __WEBPACK_IMPORTED_MODULE_7__FormCheckInput__["a" /* default */];
FormCheck.Label = __WEBPACK_IMPORTED_MODULE_8__FormCheckLabel__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (FormCheck);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Col__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormContext__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);








var defaultProps = {
  column: false,
  srOnly: false
};
var FormLabel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      column = _ref.column,
      srOnly = _ref.srOnly,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "column", "srOnly", "className", "htmlFor"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-label');
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, srOnly && 'sr-only', column && 'col-form-label');
   false ? warning(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Col__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    as: "label",
    className: classes,
    htmlFor: htmlFor
  }, props));
  return (// eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref,
      className: classes,
      htmlFor: htmlFor
    }, props))
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormLabel);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var FormText = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'small' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-text');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }));
});
FormText.displayName = 'FormText';
/* harmony default export */ __webpack_exports__["a"] = (FormText);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);







var Image =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        className = _this$props.className,
        fluid = _this$props.fluid,
        rounded = _this$props.rounded,
        roundedCircle = _this$props.roundedCircle,
        thumbnail = _this$props.thumbnail,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "className", "fluid", "rounded", "roundedCircle", "thumbnail"]);

    var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(fluid && bsPrefix + "-fluid", rounded && "rounded", roundedCircle && "rounded-circle", thumbnail && bsPrefix + "-thumbnail");
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Image.defaultProps = {
  fluid: false,
  rounded: false,
  roundedCircle: false,
  thumbnail: false
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Image, 'img'));

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_querySelectorAll__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_querySelectorAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_querySelectorAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__restart_context_mapContextToProps__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__restart_context_mapContextToProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__restart_context_mapContextToProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavContext__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabContext__ = __webpack_require__(315);










var noop = function noop() {};

var AbstractNav =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AbstractNav, _React$Component);

  function AbstractNav() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, event) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          parentOnSelect = _this$props.parentOnSelect;
      if (key == null) return;
      if (onSelect) onSelect(key, event);
      if (parentOnSelect) parentOnSelect(key, event);
    };

    _this.handleKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;
      if (onKeyDown) onKeyDown(event);
      var nextActiveChild;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          nextActiveChild = _this.getNextActiveChild(-1);
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          nextActiveChild = _this.getNextActiveChild(1);
          break;

        default:
          return;
      }

      if (!nextActiveChild) return;
      event.preventDefault();

      _this.handleSelect(nextActiveChild.dataset.rbEventKey, event);

      _this._needsRefocus = true;
    };

    _this.attachRef = function (ref) {
      _this.listNode = ref;
    };

    _this.state = {
      navContext: null
    };
    return _this;
  }

  AbstractNav.getDerivedStateFromProps = function getDerivedStateFromProps(_ref) {
    var activeKey = _ref.activeKey,
        getControlledId = _ref.getControlledId,
        getControllerId = _ref.getControllerId,
        role = _ref.role;
    return {
      navContext: {
        role: role,
        // used by NavLink to determine it's role
        activeKey: Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(activeKey),
        getControlledId: getControlledId || noop,
        getControllerId: getControllerId || noop
      }
    };
  };

  var _proto = AbstractNav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (!this._needsRefocus || !this.listNode) return;
    var activeChild = this.listNode.querySelector('[data-rb-event-key].active');
    if (activeChild) activeChild.focus();
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    if (!this.listNode) return null;
    var items = __WEBPACK_IMPORTED_MODULE_4_dom_helpers_query_querySelectorAll___default()(this.listNode, '[data-rb-event-key]:not(.disabled)');
    var activeChild = this.listNode.querySelector('.active');
    var index = items.indexOf(activeChild);
    if (index === -1) return null;
    var nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$as = _this$props2.as,
        Component = _this$props2$as === void 0 ? 'ul' : _this$props2$as,
        _ = _this$props2.onSelect,
        _0 = _this$props2.parentOnSelect,
        _1 = _this$props2.getControlledId,
        _2 = _this$props2.getControllerId,
        _3 = _this$props2.activeKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["as", "onSelect", "parentOnSelect", "getControlledId", "getControllerId", "activeKey"]);

    if (props.role === 'tablist') {
      props.onKeyDown = this.handleKeyDown;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["a" /* default */].Provider, {
      value: this.handleSelect
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavContext__["a" /* default */].Provider, {
      value: this.state.navContext
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onKeyDown: this.handleKeyDown,
      ref: this.attachRef
    }))));
  };

  return AbstractNav;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__restart_context_mapContextToProps___default()([__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__TabContext__["a" /* default */]], function (parentOnSelect, tabContext, _ref2) {
  var role = _ref2.role;
  if (!tabContext) return {
    parentOnSelect: parentOnSelect
  };
  var activeKey = tabContext.activeKey,
      getControllerId = tabContext.getControllerId,
      getControlledId = tabContext.getControlledId;
  return {
    activeKey: activeKey,
    parentOnSelect: parentOnSelect,
    role: role || 'tablist',
    // pass these two through to avoid having to listen to
    // both Tab and Nav contexts in NavLink
    getControllerId: getControllerId,
    getControlledId: getControlledId
  };
}, AbstractNav));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AbstractNavItem__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);









var ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ListGroupItem, _React$Component);

  function ListGroupItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleClick = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;

      if (disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (onClick) onClick(event);
    };

    return _this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        bsPrefix = _this$props2.bsPrefix,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        className = _this$props2.className,
        variant = _this$props2.variant,
        action = _this$props2.action,
        as = _this$props2.as,
        eventKey = _this$props2.eventKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["bsPrefix", "active", "disabled", "className", "variant", "action", "as", "eventKey"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AbstractNavItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      eventKey: Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(eventKey, props.href) // eslint-disable-next-line
      ,
      as: as || (action ? props.href ? 'a' : 'button' : 'div'),
      onClick: this.handleClick,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, active && 'active', disabled && 'disabled', variant && bsPrefix + "-" + variant, action && bsPrefix + "-action")
    }));
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ListGroupItem.defaultProps = {
  variant: null,
  active: false,
  disabled: false
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["a" /* createBootstrapComponent */])(ListGroupItem, 'list-group-item'));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavContext__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectableContext__ = __webpack_require__(67);







var defaultProps = {
  disabled: false
};
var AbstractNavItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      className = _ref.className,
      tabIndex = _ref.tabIndex,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick,
      Component = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["active", "className", "tabIndex", "eventKey", "onSelect", "onClick", "as"]);

  var navKey = Object(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["b" /* makeEventKey */])(eventKey, props.href);
  var parentOnSelect = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__SelectableContext__["a" /* default */]);
  var navContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__NavContext__["a" /* default */]);
  var isActive = active;

  if (navContext) {
    if (!props.role && navContext.role === 'tablist') props.role = 'tab';
    props['data-rb-event-key'] = navKey;
    props.id = navContext.getControllerId(navKey);
    props['aria-controls'] = navContext.getControlledId(navKey);
    isActive = active == null && navKey != null ? navContext.activeKey === navKey : active;
  }

  if (props.role === 'tab') {
    props.tabIndex = isActive ? tabIndex : -1;
    props['aria-selected'] = isActive;
  }

  var handleOnclick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["default"])(function (e) {
    if (onClick) onClick(e);
    if (navKey == null) return;
    if (onSelect) onSelect(navKey, e);
    if (parentOnSelect) parentOnSelect(navKey, e);
  });
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    onClick: handleOnclick,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, isActive && 'active')
  }));
});
AbstractNavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (AbstractNavItem);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(40);

var _createChainableTypeChecker = __webpack_require__(236);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _class = _interopRequireDefault(__webpack_require__(1232));

var _style = _interopRequireDefault(__webpack_require__(100));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(316));

var _isOverflowing = _interopRequireDefault(__webpack_require__(1235));

var _manageAriaHidden = __webpack_require__(1237);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$hideSiblingNodes = _ref.hideSiblingNodes,
        hideSiblingNodes = _ref$hideSiblingNodes === void 0 ? true : _ref$hideSiblingNodes,
        _ref$handleContainerO = _ref.handleContainerOverflow,
        handleContainerOverflow = _ref$handleContainerO === void 0 ? true : _ref$handleContainerO;

    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow;
    this.modals = [];
    this.containers = [];
    this.data = [];
    this.scrollbarSize = (0, _scrollbarSize.default)();
  }

  var _proto = ModalManager.prototype;

  _proto.isContainerOverflowing = function isContainerOverflowing(modal) {
    var data = this.data[this.containerIndexFromModal(modal)];
    return data && data.overflowing;
  };

  _proto.containerIndexFromModal = function containerIndexFromModal(modal) {
    return findIndexOf(this.data, function (d) {
      return d.modals.indexOf(modal) !== -1;
    });
  };

  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
    var style = {
      overflow: 'hidden' // we are only interested in the actual `style` here
      // becasue we will override it

    };
    containerState.style = {
      overflow: container.style.overflow,
      paddingRight: container.style.paddingRight
    };

    if (containerState.overflowing) {
      // use computed style, here to get the real padding
      // to add our scrollbar width
      style.paddingRight = parseInt((0, _style.default)(container, 'paddingRight') || 0, 10) + this.scrollbarSize + "px";
    }

    (0, _style.default)(container, style);
  };

  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
    var style = containerState.style;
    Object.keys(style).forEach(function (key) {
      container.style[key] = style[key];
    });
  };

  _proto.add = function add(modal, container, className) {
    var modalIdx = this.modals.indexOf(modal);
    var containerIdx = this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = this.modals.length;
    this.modals.push(modal);

    if (this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal);
    }

    if (containerIdx !== -1) {
      this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],
      overflowing: (0, _isOverflowing.default)(container)
    };

    if (this.handleContainerOverflow) {
      this.setContainerStyle(data, container);
    }

    data.classes.forEach(_class.default.addClass.bind(null, container));
    this.containers.push(container);
    this.data.push(data);
    return modalIdx;
  };

  _proto.remove = function remove(modal) {
    var modalIdx = this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = this.containerIndexFromModal(modal);
    var data = this.data[containerIdx];
    var container = this.containers[containerIdx];
    data.modals.splice(data.modals.indexOf(modal), 1);
    this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
    // clean up the container

    if (data.modals.length === 0) {
      data.classes.forEach(_class.default.removeClass.bind(null, container));

      if (this.handleContainerOverflow) {
        this.removeContainerStyle(data, container);
      }

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal);
      }

      this.containers.splice(containerIdx, 1);
      this.data.splice(containerIdx, 1);
    } else if (this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      var _data$modals = data.modals[data.modals.length - 1],
          backdrop = _data$modals.backdrop,
          dialog = _data$modals.dialog;
      (0, _manageAriaHidden.ariaHidden)(false, dialog);
      (0, _manageAriaHidden.ariaHidden)(false, backdrop);
    }
  };

  _proto.isTopModal = function isTopModal(modal) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
  };

  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _componentOrElement = _interopRequireDefault(__webpack_require__(207));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _WaitForContainer = _interopRequireDefault(__webpack_require__(586));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Portal, _React$Component);

  function Portal() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Portal.prototype;

  _proto.render = function render() {
    var _this = this;

    return this.props.children ? _react.default.createElement(_WaitForContainer.default, {
      container: this.props.container,
      onContainerResolved: this.props.onRendered
    }, function (container) {
      return _reactDom.default.createPortal(_this.props.children, container);
    }) : null;
  };

  return Portal;
}(_react.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes.default.oneOfType([_componentOrElement.default, _propTypes.default.func]),
  onRendered: _propTypes.default.func
};
var _default = Portal;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _componentOrElement = _interopRequireDefault(__webpack_require__(207));

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var _ownerDocument = _interopRequireDefault(__webpack_require__(143));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _getContainer = _interopRequireDefault(__webpack_require__(587));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes.default.oneOfType([_componentOrElement.default, _propTypes.default.func]),
  onContainerResolved: _propTypes.default.func
};

var WaitForContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(WaitForContainer, _React$Component);

  function WaitForContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    if (!_inDOM.default) return _assertThisInitialized(_this);
    var container = _this.props.container;
    if (typeof container === 'function') container = container();

    if (container && !_reactDom.default.findDOMNode(container)) {
      // The container is a React component that has not yet been rendered.
      // Don't set the container node yet.
      return _assertThisInitialized(_this);
    }

    _this.setContainer(container);

    return _this;
  }

  var _proto = WaitForContainer.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps.container);
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    if (!this._container) {
      this.setContainer(this.props.container);
      this.forceUpdate(this.props.onContainerResolved);
    } else if (this.props.onContainerResolved) {
      this.props.onContainerResolved();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._container = null;
  };

  _proto.setContainer = function setContainer(container) {
    this._container = (0, _getContainer.default)(container, (0, _ownerDocument.default)().body);
  };

  _proto.render = function render() {
    return this._container ? this.props.children(this._container) : null;
  };

  return WaitForContainer;
}(_react.default.Component);

WaitForContainer.propTypes = propTypes;
var _default = WaitForContainer;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = _interopRequireDefault(__webpack_require__(23));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  if (container == null) return defaultContainer;
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || null;
}

module.exports = exports.default;

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('modal-body'));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var ModalDialog = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      centered = _ref.centered,
      size = _ref.size,
      children = _ref.children,
      scrollable = _ref.scrollable,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "centered", "size", "children", "scrollable"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'modal');
  var dialogClass = bsPrefix + "-dialog";
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(dialogClass, className, size && bsPrefix + "-" + size, centered && dialogClass + "-centered", scrollable && dialogClass + "-scrollable")
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(bsPrefix + "-content")
  }, children));
});
ModalDialog.displayName = 'ModalDialog';
/* harmony default export */ __webpack_exports__["a"] = (ModalDialog);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('modal-footer'));

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ModalContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({
  onHide: function onHide() {}
});
/* harmony default export */ __webpack_exports__["a"] = (ModalContext);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_divWithClassName__ = __webpack_require__(308);


var DivStyledAsH4 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_divWithClassName__["a" /* default */])('h4');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('modal-title', {
  Component: DivStyledAsH4
}));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavbarContext__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardContext__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AbstractNav__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavLink__ = __webpack_require__(317);












var defaultProps = {
  justify: false,
  fill: false
};
var Nav = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (uncontrolledProps, ref) {
  var _classNames;

  var _useUncontrolled = __WEBPACK_IMPORTED_MODULE_5_uncontrollable_hook___default()(uncontrolledProps, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      bsPrefix = _useUncontrolled.bsPrefix,
      variant = _useUncontrolled.variant,
      fill = _useUncontrolled.fill,
      justify = _useUncontrolled.justify,
      navbar = _useUncontrolled.navbar,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      activeKey = _useUncontrolled.activeKey,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useUncontrolled, ["as", "bsPrefix", "variant", "fill", "justify", "navbar", "className", "children", "activeKey"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'nav');
  var navbarBsPrefix, cardHeaderBsPrefix;
  var navbarContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__NavbarContext__["a" /* default */]);
  var cardContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__CardContext__["a" /* default */]);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    navbar = navbar == null ? true : navbar;
  } else if (cardContext) {
    cardHeaderBsPrefix = cardContext.cardHeaderBsPrefix;
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AbstractNav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {}, _classNames[bsPrefix] = !navbar, _classNames[navbarBsPrefix + "-nav"] = navbar, _classNames[cardHeaderBsPrefix + "-" + variant] = !!cardHeaderBsPrefix, _classNames[bsPrefix + "-" + variant] = !!variant, _classNames[bsPrefix + "-fill"] = fill, _classNames[bsPrefix + "-justified"] = justify, _classNames))
  }, props), children);
});
Nav.displayName = 'Nav';
Nav.defaultProps = defaultProps;
Nav.Item = __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */];
Nav.Link = __WEBPACK_IMPORTED_MODULE_11__NavLink__["a" /* default */];
Nav._Nav = Nav; // for Testing until enzyme is working with context

/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var NavbarBrand = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      as = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'navbar-brand');
  var Component = as || (props.href ? 'a' : 'span');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }));
});
NavbarBrand.displayName = 'NavbarBrand';
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_overlays_Overlay__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_overlays_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_overlays_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fade__ = __webpack_require__(109);







var defaultProps = {
  transition: __WEBPACK_IMPORTED_MODULE_6__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'top'
};

function wrapRefs(props, arrowProps) {
  var ref = props.ref;
  var aRef = arrowProps.ref;

  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
    return ref(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(r));
  });

  arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function (r) {
    return aRef(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(r));
  });
}

function Overlay(_ref) {
  var overlay = _ref.children,
      transition = _ref.transition,
      outerProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["children", "transition"]);

  transition = transition === true ? __WEBPACK_IMPORTED_MODULE_6__Fade__["a" /* default */] : transition || null;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_overlays_Overlay___default.a, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerProps, {
    transition: transition
  }), function (_ref2) {
    var overlayProps = _ref2.props,
        arrowProps = _ref2.arrowProps,
        show = _ref2.show,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["props", "arrowProps", "show"]);

    wrapRefs(overlayProps, arrowProps);
    if (typeof overlay === 'function') return overlay(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, overlayProps, {
      show: show,
      arrowProps: arrowProps
    }));
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(overlay, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, overlayProps, {
      arrowProps: arrowProps,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(overlay.props.className, !transition && show && 'show'),
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, overlay.props.style, overlayProps.style)
    }));
  });
}

Overlay.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PageItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SafeAnchor__ = __webpack_require__(84);




/* eslint-disable react/no-multi-comp */



var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
function PageItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_5__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, 'page-item', {
      active: active,
      disabled: disabled
    })
  }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: "page-link",
    disabled: disabled
  }, props), children, active && activeLabel && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}
PageItem.defaultProps = defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children"]);

      delete props.active;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(PageItem, props, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
        "aria-hidden": "true"
      }, children || defaultValue), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
        className: "sr-only"
      }, label));
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.displayName = name, _temp;
}

var First = createButton('First', "\xAB");
var Prev = createButton('Prev', "\u2039", 'Previous');
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
var Next = createButton('Next', "\u203A");
var Last = createButton('Last', "\xBB");

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(202);







var noop = function noop() {};

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButton, _React$Component);

  function ToggleButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focused: false
    };

    _this.handleFocus = function (e) {
      if (e.target.tagName === 'INPUT') _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function (e) {
      if (e.target.tagName === 'INPUT') _this.setState({
        focused: false
      });
    };

    return _this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        className = _this$props.className,
        checked = _this$props.checked,
        type = _this$props.type,
        onChange = _this$props.onChange,
        value = _this$props.value,
        disabled = _this$props.disabled,
        inputRef = _this$props.inputRef,
        innerRef = _this$props.innerRef,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "name", "className", "checked", "type", "onChange", "value", "disabled", "inputRef", "innerRef"]);

    var focused = this.state.focused;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, focused && 'focus', disabled && 'disabled'),
      type: null,
      active: !!checked,
      as: "label"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", {
      name: name,
      type: type,
      value: value,
      ref: inputRef,
      autoComplete: "off",
      checked: !!checked,
      disabled: !!disabled,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onChange: onChange || noop
    }), children);
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (props, ref) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ToggleButton, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    innerRef: ref
  }, props));
}));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CloseButton__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToastContext__ = __webpack_require__(599);








var defaultProps = {
  closeLabel: 'Close',
  closeButton: true
};

var ToastHeader = function ToastHeader(_ref) {
  var bsPrefix = _ref.bsPrefix,
      closeLabel = _ref.closeLabel,
      closeButton = _ref.closeButton,
      className = _ref.className,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "closeLabel", "closeButton", "className", "children"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'toast-header');
  var context = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__ToastContext__["a" /* default */]);
  var handleClick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["default"])(function () {
    if (context) {
      context.onClose();
    }
  });
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(bsPrefix, className)
  }), children, closeButton && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CloseButton__["a" /* default */], {
    label: closeLabel,
    onClick: handleClick,
    className: "ml-2 mb-1",
    "data-dismiss": "toast"
  }));
};

ToastHeader.displayName = 'ToastHeader';
ToastHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ToastHeader);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ToastContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({
  onClose: function onClose() {}
});
/* harmony default export */ __webpack_exports__["a"] = (ToastContext);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('toast-body'));

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorManipulator__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__ = __webpack_require__(322);
/* unused harmony reexport createMuiTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMuiStrictModeTheme__ = __webpack_require__(1290);
/* unused harmony reexport unstable_createMuiStrictModeTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createStyles__ = __webpack_require__(1291);
/* unused harmony reexport createStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__makeStyles__ = __webpack_require__(1321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__makeStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__responsiveFontSizes__ = __webpack_require__(1322);
/* unused harmony reexport responsiveFontSizes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__(638);
/* unused harmony reexport styled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(36);
/* unused harmony reexport useTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withStyles__ = __webpack_require__(7);
/* unused harmony reexport withStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__withTheme__ = __webpack_require__(1324);
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__ = __webpack_require__(50);
/* unused harmony reexport createGenerateClassName */
/* unused harmony reexport jssPreset */
/* unused harmony reexport ServerStyleSheets */
/* unused harmony reexport StylesProvider */
/* unused harmony reexport MuiThemeProvider */
/* unused harmony reexport ThemeProvider */

 // eslint-disable-next-line camelcase












/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keys; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["a"] = (grey);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["a"] = (indigo);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["a"] = (pink);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["a"] = (red);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["a"] = (orange);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["a"] = (blue);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["a"] = (green);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__borders__ = __webpack_require__(612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__borders__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__(323);
/* unused harmony reexport breakpoints */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__compose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(1285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__css__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__display__ = __webpack_require__(1286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__display__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__flexbox__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__grid__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__grid__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__palette__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__palette__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__positions__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__positions__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shadows__ = __webpack_require__(1287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__shadows__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sizing__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__sizing__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__spacing__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__(68);
/* unused harmony reexport style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__typography__ = __webpack_require__(623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__typography__["a"]; });
/* unused harmony namespace reexport */
/** @license Material-UI v4.9.14
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */























/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export border */
/* unused harmony export borderTop */
/* unused harmony export borderRight */
/* unused harmony export borderBottom */
/* unused harmony export borderLeft */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* harmony default export */ __webpack_exports__["a"] = (borders);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (responsivePropType);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flexBasis */
/* unused harmony export flexDirection */
/* unused harmony export flexWrap */
/* unused harmony export justifyContent */
/* unused harmony export alignItems */
/* unused harmony export alignContent */
/* unused harmony export order */
/* unused harmony export flex */
/* unused harmony export flexGrow */
/* unused harmony export flexShrink */
/* unused harmony export alignSelf */
/* unused harmony export justifyItems */
/* unused harmony export justifySelf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);


var flexBasis = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexBasis'
});
var flexDirection = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexDirection'
});
var flexWrap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexWrap'
});
var justifyContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyContent'
});
var alignItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignItems'
});
var alignContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignContent'
});
var order = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'order'
});
var flex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flex'
});
var flexGrow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexGrow'
});
var flexShrink = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexShrink'
});
var alignSelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignSelf'
});
var justifyItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyItems'
});
var justifySelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifySelf'
});
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* harmony default export */ __webpack_exports__["a"] = (flexbox);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gridGap */
/* unused harmony export gridColumnGap */
/* unused harmony export gridRowGap */
/* unused harmony export gridColumn */
/* unused harmony export gridRow */
/* unused harmony export gridAutoFlow */
/* unused harmony export gridAutoColumns */
/* unused harmony export gridAutoRows */
/* unused harmony export gridTemplateColumns */
/* unused harmony export gridTemplateRows */
/* unused harmony export gridTemplateAreas */
/* unused harmony export gridArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);


var gridGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridGap'
});
var gridColumnGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumnGap'
});
var gridRowGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRowGap'
});
var gridColumn = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumn'
});
var gridRow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRow'
});
var gridAutoFlow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoColumns'
});
var gridAutoRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateAreas'
});
var gridArea = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridArea'
});
var grid = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ __webpack_exports__["a"] = (grid);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export color */
/* unused harmony export bgcolor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);


var color = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(color, bgcolor);
/* harmony default export */ __webpack_exports__["a"] = (palette);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export position */
/* unused harmony export zIndex */
/* unused harmony export top */
/* unused harmony export right */
/* unused harmony export bottom */
/* unused harmony export left */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);


var position = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'position'
});
var zIndex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'top'
});
var right = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'right'
});
var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bottom'
});
var left = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'left'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(position, zIndex, top, right, bottom, left));

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export width */
/* unused harmony export maxWidth */
/* unused harmony export minWidth */
/* unused harmony export height */
/* unused harmony export maxHeight */
/* unused harmony export minHeight */
/* unused harmony export sizeWidth */
/* unused harmony export sizeHeight */
/* unused harmony export boxSizing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);



function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'width',
  transform: transform
});
var maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minWidth',
  transform: transform
});
var height = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'height',
  transform: transform
});
var maxHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minHeight',
  transform: transform
});
var sizeWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
var sizeHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var boxSizing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxSizing'
});
var sizing = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ __webpack_exports__["a"] = (sizing);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUnarySpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memoize__ = __webpack_require__(1289);





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = Object(__WEBPACK_IMPORTED_MODULE_4__memoize__["a" /* default */])(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string') {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  }).reduce(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */], {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ __webpack_exports__["b"] = (spacing);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fontFamily */
/* unused harmony export fontSize */
/* unused harmony export fontStyle */
/* unused harmony export fontWeight */
/* unused harmony export letterSpacing */
/* unused harmony export lineHeight */
/* unused harmony export textAlign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);


var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'letterSpacing'
});
var lineHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'lineHeight'
});
var textAlign = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textAlign'
});
var typography = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* harmony default export */ __webpack_exports__["a"] = (typography);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["a"] = (zIndex);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["a"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyles__ = __webpack_require__(1293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStyles__["a"]; });


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ThemeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ThemeContext.displayName = 'ThemeContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ThemeContext);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = StylesProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jssPreset__ = __webpack_require__(325);







 // Default JSS instance.

var jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__["a" /* default */])(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(defaultOptions);

if (false) {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(StylesContext);

  var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerOptions), {}, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])({
      plugins: Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ __webpack_exports__["a"] = (noopTheme);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__ = __webpack_require__(1317);
/* unused harmony reexport default */


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled__ = __webpack_require__(1318);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__styled__["a"]; });


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__ = __webpack_require__(1319);
/* unused harmony reexport default */


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withStyles__ = __webpack_require__(1320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withStyles__["a"]; });


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(637);
/* unused harmony reexport default */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withTheme__["a"]; });



/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withThemeCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(111);







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["innerRef"]);

      var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme = withThemeCreator();
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(145);




var styled = function styled(Component) {
  var componentCreator = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["e" /* styled */])(Component);
  return function (style, options) {
    return componentCreator(style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
    }, options));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (styled);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize__ = __webpack_require__(21);
/* unused harmony reexport capitalize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(112);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createSvgIcon__ = __webpack_require__(45);
/* unused harmony reexport createSvgIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__debounce__ = __webpack_require__(95);
/* unused harmony reexport debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deprecatedPropType__ = __webpack_require__(1340);
/* unused harmony reexport deprecatedPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isMuiElement__ = __webpack_require__(146);
/* unused harmony reexport isMuiElement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ownerDocument__ = __webpack_require__(61);
/* unused harmony reexport ownerDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ownerWindow__ = __webpack_require__(214);
/* unused harmony reexport ownerWindow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__requirePropFactory__ = __webpack_require__(640);
/* unused harmony reexport requirePropFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__setRef__ = __webpack_require__(96);
/* unused harmony reexport setRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__unsupportedProp__ = __webpack_require__(215);
/* unused harmony reexport unsupportedProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useControlled__ = __webpack_require__(86);
/* unused harmony reexport useControlled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useEventCallback__ = __webpack_require__(75);
/* unused harmony reexport useEventCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__useForkRef__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_13__useForkRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__unstable_useId__ = __webpack_require__(216);
/* unused harmony reexport unstable_useId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__useIsFocusVisible__ = __webpack_require__(147);
/* unused harmony reexport useIsFocusVisible */













 // eslint-disable-next-line camelcase




/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1341);
/* unused harmony reexport default */


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(622);



function _toArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(1349);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" /* getInitialChildMapping */])(nextProps, handleExited) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" /* getNextChildMapping */])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" /* getChildMapping */])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
      value: contextValue
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  AccordionContext.displayName = 'AccordionContext';
}

/* harmony default export */ __webpack_exports__["a"] = (AccordionContext);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionActions__ = __webpack_require__(1352);
/* unused harmony reexport default */


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionDetails__ = __webpack_require__(1353);
/* unused harmony reexport default */


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionSummary__ = __webpack_require__(1354);
/* unused harmony reexport default */


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(1359);
/* unused harmony reexport default */


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avatar__ = __webpack_require__(1360);
/* unused harmony reexport default */


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(1364);
/* unused harmony reexport default */


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BottomNavigation__ = __webpack_require__(1365);
/* unused harmony reexport default */


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BottomNavigationAction__ = __webpack_require__(1366);
/* unused harmony reexport default */


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(1367);
/* unused harmony reexport default */
/* unused harmony reexport styleFunction */


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(1368);
/* unused harmony reexport default */


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonGroup__ = __webpack_require__(1373);
/* unused harmony reexport default */


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(1374);
/* unused harmony reexport default */


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardActionArea__ = __webpack_require__(1375);
/* unused harmony reexport default */


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardActions__ = __webpack_require__(1376);
/* unused harmony reexport default */


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardContent__ = __webpack_require__(1377);
/* unused harmony reexport default */


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardHeader__ = __webpack_require__(1378);
/* unused harmony reexport default */


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardMedia__ = __webpack_require__(1379);
/* unused harmony reexport default */


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1380);
/* unused harmony reexport default */


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chip__ = __webpack_require__(1384);
/* unused harmony reexport default */


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CircularProgress__ = __webpack_require__(1386);
/* unused harmony reexport default */


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(1388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Container__["a"]; });


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CssBaseline__ = __webpack_require__(1389);
/* unused harmony reexport default */


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(1390);
/* unused harmony reexport default */


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaHidden;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__ = __webpack_require__(214);





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container);

  if (doc.body === container) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__["a" /* default */])(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__["a" /* default */])();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();



/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogActions__ = __webpack_require__(1395);
/* unused harmony reexport default */


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogContent__ = __webpack_require__(1396);
/* unused harmony reexport default */


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogContentText__ = __webpack_require__(1397);
/* unused harmony reexport default */


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogTitle__ = __webpack_require__(1398);
/* unused harmony reexport default */


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(1399);
/* unused harmony reexport default */


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(334);
/* unused harmony reexport default */


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanel__ = __webpack_require__(1401);
/* unused harmony reexport default */


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var ExpansionPanelContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ExpansionPanelContext);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelActions__ = __webpack_require__(1402);
/* unused harmony reexport default */


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelDetails__ = __webpack_require__(1403);
/* unused harmony reexport default */


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelSummary__ = __webpack_require__(1404);
/* unused harmony reexport default */


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fab__ = __webpack_require__(1405);
/* unused harmony reexport default */


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormControlLabel__ = __webpack_require__(1410);
/* unused harmony reexport default */


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridList__ = __webpack_require__(1415);
/* unused harmony reexport default */


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridListTile__ = __webpack_require__(1416);
/* unused harmony reexport default */


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridListTileBar__ = __webpack_require__(1417);
/* unused harmony reexport default */


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hidden__ = __webpack_require__(1419);
/* unused harmony reexport default */


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isWidthUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWidthDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__useMediaQuery__ = __webpack_require__(341);









 // By default, returns true if screen width is the same or greater than the given breakpoint.

var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint) <= __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width);
  }

  return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint) < __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width) <= __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint);
  }

  return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width) < __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint);
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth;

    function WithWidth(props) {
      var contextTheme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
      var theme = props.theme || contextTheme;

      var _getThemeProps = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["b" /* getThemeProps */])({
        theme: theme,
        name: 'MuiWithWidth',
        props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props)
      }),
          initialWidth = _getThemeProps.initialWidth,
          width = _getThemeProps.width,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_getThemeProps, ["initialWidth", "width"]);

      var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
          mountedState = _React$useState[0],
          setMountedState = _React$useState[1];

      useEnhancedEffect(function () {
        setMountedState(true);
      }, []);
      /**
       * innerWidth |xs      sm      md      lg      xl
       *            |-------|-------|-------|-------|------>
       * width      |  xs   |  sm   |  md   |  lg   |  xl
       */

      var keys = theme.breakpoints.keys.slice().reverse();
      var widthComputed = keys.reduce(function (output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = Object(__WEBPACK_IMPORTED_MODULE_9__useMediaQuery__["a" /* default */])(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null);

      var more = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
      }, withThemeOption ? {
        theme: theme
      } : {}, other); // When rendering the component on the server,
      // we have no idea about the client browser screen width.
      // In order to prevent blinks and help the reconciliation of the React tree
      // we are not rendering the child component.
      //
      // An alternative is to use the `initialWidth` property.


      if (more.width === undefined) {
        return null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, more);
    }

     false ? WithWidth.propTypes = {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * You might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * https://caniuse.com/#search=client%20hint
       */
      initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: PropTypes.object,

      /**
       * Bypass the width calculation logic.
       */
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : void 0;

    if (false) {
      WithWidth.displayName = "WithWidth(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(WithWidth, Component);
    return WithWidth;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withWidth);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(1424);
/* unused harmony reexport default */


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputAdornment__ = __webpack_require__(1426);
/* unused harmony reexport default */


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(1429);
/* unused harmony reexport default */


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemAvatar__ = __webpack_require__(1432);
/* unused harmony reexport default */


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemIcon__ = __webpack_require__(1433);
/* unused harmony reexport default */


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemSecondaryAction__ = __webpack_require__(1434);
/* unused harmony reexport default */


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemText__ = __webpack_require__(1435);
/* unused harmony reexport default */


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListSubheader__ = __webpack_require__(1436);
/* unused harmony reexport default */


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(701);
/* unused harmony reexport default */


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popover__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuList__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_setRef__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(36);













var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEntering = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var contentAnchorRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = __WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"](instance);
          Object(__WEBPACK_IMPORTED_MODULE_11__utils_setRef__["a" /* default */])(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    onEntering: handleEntering,
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__MenuList__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.list, MenuListProps.className)
  }), items));
});
 false ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the menu is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenu'
})(Menu));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileStepper__ = __webpack_require__(1440);
/* unused harmony reexport default */


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeSelect__ = __webpack_require__(704);
/* unused harmony reexport default */


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Input__ = __webpack_require__(152);










var styles = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Input__["a" /* default */], null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](input, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__["a" /* default */],
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







/**
 * @ignore - internal component.
 */

var NativeSelectInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant))], disabled && classes.disabled)
  }));
});
 false ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,

  /**
   * @ignore
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (NativeSelectInput);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(1446);
/* unused harmony reexport default */


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRadioGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RadioGroupContext__ = __webpack_require__(709);


function useRadioGroup() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__RadioGroupContext__["a" /* default */]);
}

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var RadioGroupContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

/* harmony default export */ __webpack_exports__["a"] = (RadioGroupContext);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioGroup__ = __webpack_require__(1450);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useRadioGroup__ = __webpack_require__(708);
/* unused harmony reexport useRadioGroup */



/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RootRef__ = __webpack_require__(1451);
/* unused harmony reexport default */


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(1454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Slider__["a"]; });


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Snackbar__ = __webpack_require__(1456);
/* unused harmony reexport default */


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(1458);
/* unused harmony reexport default */


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepButton__ = __webpack_require__(1459);
/* unused harmony reexport default */


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepContent__ = __webpack_require__(1465);
/* unused harmony reexport default */


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stepper__ = __webpack_require__(1466);
/* unused harmony reexport default */


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SwipeableDrawer__ = __webpack_require__(1467);
/* unused harmony reexport default */


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Switch__ = __webpack_require__(1469);
/* unused harmony reexport default */


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(1470);
/* unused harmony reexport default */


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1471);
/* unused harmony reexport default */


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var TableContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  TableContext.displayName = 'TableContext';
}

/* harmony default export */ __webpack_exports__["a"] = (TableContext);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableBody__ = __webpack_require__(1472);
/* unused harmony reexport default */


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableContainer__ = __webpack_require__(1474);
/* unused harmony reexport default */


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableFooter__ = __webpack_require__(1475);
/* unused harmony reexport default */


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableHead__ = __webpack_require__(1476);
/* unused harmony reexport default */


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TablePagination__ = __webpack_require__(1477);
/* unused harmony reexport default */


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableRow__ = __webpack_require__(1480);
/* unused harmony reexport default */


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableSortLabel__ = __webpack_require__(1481);
/* unused harmony reexport default */


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1483);
/* unused harmony reexport default */


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextField__ = __webpack_require__(1489);
/* unused harmony reexport default */


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1490);
/* unused harmony reexport default */


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useScrollTrigger__ = __webpack_require__(1491);
/* unused harmony reexport default */


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMobileDialog__ = __webpack_require__(1492);
/* unused harmony reexport default */


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Zoom__ = __webpack_require__(1493);
/* unused harmony reexport default */


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LTNTLoading.9f67b36d.gif";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(740);
module.exports = __webpack_require__(745);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(741).enable()
  window.Promise = __webpack_require__(743)
}

// fetch() polyfill for making API calls.
__webpack_require__(744)

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(227)

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global)
}


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(358);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(358);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_css_semantic_min_css__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_css_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_css_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_App_App__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(70);
var appJsx=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_App_App__["a" /* default */],null));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(appJsx,document.getElementById('root'));

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(227),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(227),r=__webpack_require__(748);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(749);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(751);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(360)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(359)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v4.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 The Bootstrap Authors\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n:root {\n  --blue: #007bff;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #dc3545;\n  --orange: #fd7e14;\n  --yellow: #ffc107;\n  --green: #28a745;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #007bff;\n  --secondary: #6c757d;\n  --success: #28a745;\n  --info: #17a2b8;\n  --warning: #ffc107;\n  --danger: #dc3545;\n  --light: #f8f9fa;\n  --dark: #343a40;\n  --header: #331E36;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; }\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; }\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block; }\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff; }\n\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important; }\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem; }\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none; }\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit; }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0; }\n\ndt {\n  font-weight: 700; }\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; }\n\nblockquote {\n  margin: 0 0 1rem; }\n\nb,\nstrong {\n  font-weight: bolder; }\n\nsmall {\n  font-size: 80%; }\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline; }\n\nsub {\n  bottom: -.25em; }\n\nsup {\n  top: -.5em; }\n\na {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent; }\n  a:hover {\n    color: #0056b3;\n    text-decoration: underline; }\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none; }\n  a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {\n    color: inherit;\n    text-decoration: none; }\n  a:not([href]):not([tabindex]):focus {\n    outline: 0; }\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em; }\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto; }\n\nfigure {\n  margin: 0 0 1rem; }\n\nimg {\n  vertical-align: middle;\n  border-style: none; }\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle; }\n\ntable {\n  border-collapse: collapse; }\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom; }\n\nth {\n  text-align: inherit; }\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem; }\n\nbutton {\n  border-radius: 0; }\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color; }\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\n\nbutton,\ninput {\n  overflow: visible; }\n\nbutton,\nselect {\n  text-transform: none; }\n\nselect {\n  word-wrap: normal; }\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; }\n\nbutton:not(:disabled),\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled) {\n  cursor: pointer; }\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none; }\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0; }\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  -webkit-appearance: listbox; }\n\ntextarea {\n  overflow: auto;\n  resize: vertical; }\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0; }\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal; }\n\nprogress {\n  vertical-align: baseline; }\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none; }\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button; }\n\noutput {\n  display: inline-block; }\n\nsummary {\n  display: list-item;\n  cursor: pointer; }\n\ntemplate {\n  display: none; }\n\n[hidden] {\n  display: none !important; }\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2; }\n\nh1, .h1 {\n  font-size: 2.5rem; }\n\nh2, .h2 {\n  font-size: 2rem; }\n\nh3, .h3 {\n  font-size: 1.75rem; }\n\nh4, .h4 {\n  font-size: 1.5rem; }\n\nh5, .h5 {\n  font-size: 1.25rem; }\n\nh6, .h6 {\n  font-size: 1rem; }\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300; }\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1); }\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400; }\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3; }\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline-item {\n  display: inline-block; }\n  .list-inline-item:not(:last-child) {\n    margin-right: 0.5rem; }\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase; }\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem; }\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d; }\n  .blockquote-footer::before {\n    content: \"\\2014\\A0\"; }\n\n.img-fluid {\n  max-width: 100%;\n  height: auto; }\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto; }\n\n.figure {\n  display: inline-block; }\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1; }\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d; }\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-break: break-word; }\n  a > code {\n    color: inherit; }\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem; }\n  kbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700; }\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529; }\n  pre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal; }\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll; }\n\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n  @media (min-width: 576px) {\n    .container {\n      max-width: 540px; } }\n  @media (min-width: 768px) {\n    .container {\n      max-width: 720px; } }\n  @media (min-width: 992px) {\n    .container {\n      max-width: 960px; } }\n  @media (min-width: 1200px) {\n    .container {\n      max-width: 1140px; } }\n\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px; }\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%; }\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; }\n\n.col-1 {\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%; }\n\n.col-2 {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.col-4 {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.col-5 {\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%; }\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.col-7 {\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%; }\n\n.col-8 {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%; }\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%; }\n\n.col-10 {\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%; }\n\n.col-11 {\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%; }\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.order-first {\n  order: -1; }\n\n.order-last {\n  order: 13; }\n\n.order-0 {\n  order: 0; }\n\n.order-1 {\n  order: 1; }\n\n.order-2 {\n  order: 2; }\n\n.order-3 {\n  order: 3; }\n\n.order-4 {\n  order: 4; }\n\n.order-5 {\n  order: 5; }\n\n.order-6 {\n  order: 6; }\n\n.order-7 {\n  order: 7; }\n\n.order-8 {\n  order: 8; }\n\n.order-9 {\n  order: 9; }\n\n.order-10 {\n  order: 10; }\n\n.order-11 {\n  order: 11; }\n\n.order-12 {\n  order: 12; }\n\n.offset-1 {\n  margin-left: 8.33333%; }\n\n.offset-2 {\n  margin-left: 16.66667%; }\n\n.offset-3 {\n  margin-left: 25%; }\n\n.offset-4 {\n  margin-left: 33.33333%; }\n\n.offset-5 {\n  margin-left: 41.66667%; }\n\n.offset-6 {\n  margin-left: 50%; }\n\n.offset-7 {\n  margin-left: 58.33333%; }\n\n.offset-8 {\n  margin-left: 66.66667%; }\n\n.offset-9 {\n  margin-left: 75%; }\n\n.offset-10 {\n  margin-left: 83.33333%; }\n\n.offset-11 {\n  margin-left: 91.66667%; }\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-sm-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-sm-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-sm-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-sm-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-sm-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-sm-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-sm-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-sm-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-sm-first {\n    order: -1; }\n  .order-sm-last {\n    order: 13; }\n  .order-sm-0 {\n    order: 0; }\n  .order-sm-1 {\n    order: 1; }\n  .order-sm-2 {\n    order: 2; }\n  .order-sm-3 {\n    order: 3; }\n  .order-sm-4 {\n    order: 4; }\n  .order-sm-5 {\n    order: 5; }\n  .order-sm-6 {\n    order: 6; }\n  .order-sm-7 {\n    order: 7; }\n  .order-sm-8 {\n    order: 8; }\n  .order-sm-9 {\n    order: 9; }\n  .order-sm-10 {\n    order: 10; }\n  .order-sm-11 {\n    order: 11; }\n  .order-sm-12 {\n    order: 12; }\n  .offset-sm-0 {\n    margin-left: 0; }\n  .offset-sm-1 {\n    margin-left: 8.33333%; }\n  .offset-sm-2 {\n    margin-left: 16.66667%; }\n  .offset-sm-3 {\n    margin-left: 25%; }\n  .offset-sm-4 {\n    margin-left: 33.33333%; }\n  .offset-sm-5 {\n    margin-left: 41.66667%; }\n  .offset-sm-6 {\n    margin-left: 50%; }\n  .offset-sm-7 {\n    margin-left: 58.33333%; }\n  .offset-sm-8 {\n    margin-left: 66.66667%; }\n  .offset-sm-9 {\n    margin-left: 75%; }\n  .offset-sm-10 {\n    margin-left: 83.33333%; }\n  .offset-sm-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-md-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-md-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-md-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-md-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-md-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-md-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-md-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-md-first {\n    order: -1; }\n  .order-md-last {\n    order: 13; }\n  .order-md-0 {\n    order: 0; }\n  .order-md-1 {\n    order: 1; }\n  .order-md-2 {\n    order: 2; }\n  .order-md-3 {\n    order: 3; }\n  .order-md-4 {\n    order: 4; }\n  .order-md-5 {\n    order: 5; }\n  .order-md-6 {\n    order: 6; }\n  .order-md-7 {\n    order: 7; }\n  .order-md-8 {\n    order: 8; }\n  .order-md-9 {\n    order: 9; }\n  .order-md-10 {\n    order: 10; }\n  .order-md-11 {\n    order: 11; }\n  .order-md-12 {\n    order: 12; }\n  .offset-md-0 {\n    margin-left: 0; }\n  .offset-md-1 {\n    margin-left: 8.33333%; }\n  .offset-md-2 {\n    margin-left: 16.66667%; }\n  .offset-md-3 {\n    margin-left: 25%; }\n  .offset-md-4 {\n    margin-left: 33.33333%; }\n  .offset-md-5 {\n    margin-left: 41.66667%; }\n  .offset-md-6 {\n    margin-left: 50%; }\n  .offset-md-7 {\n    margin-left: 58.33333%; }\n  .offset-md-8 {\n    margin-left: 66.66667%; }\n  .offset-md-9 {\n    margin-left: 75%; }\n  .offset-md-10 {\n    margin-left: 83.33333%; }\n  .offset-md-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-lg-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-lg-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-lg-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-lg-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-lg-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-lg-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-lg-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-lg-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-lg-first {\n    order: -1; }\n  .order-lg-last {\n    order: 13; }\n  .order-lg-0 {\n    order: 0; }\n  .order-lg-1 {\n    order: 1; }\n  .order-lg-2 {\n    order: 2; }\n  .order-lg-3 {\n    order: 3; }\n  .order-lg-4 {\n    order: 4; }\n  .order-lg-5 {\n    order: 5; }\n  .order-lg-6 {\n    order: 6; }\n  .order-lg-7 {\n    order: 7; }\n  .order-lg-8 {\n    order: 8; }\n  .order-lg-9 {\n    order: 9; }\n  .order-lg-10 {\n    order: 10; }\n  .order-lg-11 {\n    order: 11; }\n  .order-lg-12 {\n    order: 12; }\n  .offset-lg-0 {\n    margin-left: 0; }\n  .offset-lg-1 {\n    margin-left: 8.33333%; }\n  .offset-lg-2 {\n    margin-left: 16.66667%; }\n  .offset-lg-3 {\n    margin-left: 25%; }\n  .offset-lg-4 {\n    margin-left: 33.33333%; }\n  .offset-lg-5 {\n    margin-left: 41.66667%; }\n  .offset-lg-6 {\n    margin-left: 50%; }\n  .offset-lg-7 {\n    margin-left: 58.33333%; }\n  .offset-lg-8 {\n    margin-left: 66.66667%; }\n  .offset-lg-9 {\n    margin-left: 75%; }\n  .offset-lg-10 {\n    margin-left: 83.33333%; }\n  .offset-lg-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-xl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-xl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-xl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-xl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-xl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-xl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-xl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-xl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-xl-first {\n    order: -1; }\n  .order-xl-last {\n    order: 13; }\n  .order-xl-0 {\n    order: 0; }\n  .order-xl-1 {\n    order: 1; }\n  .order-xl-2 {\n    order: 2; }\n  .order-xl-3 {\n    order: 3; }\n  .order-xl-4 {\n    order: 4; }\n  .order-xl-5 {\n    order: 5; }\n  .order-xl-6 {\n    order: 6; }\n  .order-xl-7 {\n    order: 7; }\n  .order-xl-8 {\n    order: 8; }\n  .order-xl-9 {\n    order: 9; }\n  .order-xl-10 {\n    order: 10; }\n  .order-xl-11 {\n    order: 11; }\n  .order-xl-12 {\n    order: 12; }\n  .offset-xl-0 {\n    margin-left: 0; }\n  .offset-xl-1 {\n    margin-left: 8.33333%; }\n  .offset-xl-2 {\n    margin-left: 16.66667%; }\n  .offset-xl-3 {\n    margin-left: 25%; }\n  .offset-xl-4 {\n    margin-left: 33.33333%; }\n  .offset-xl-5 {\n    margin-left: 41.66667%; }\n  .offset-xl-6 {\n    margin-left: 50%; }\n  .offset-xl-7 {\n    margin-left: 58.33333%; }\n  .offset-xl-8 {\n    margin-left: 66.66667%; }\n  .offset-xl-9 {\n    margin-left: 75%; }\n  .offset-xl-10 {\n    margin-left: 83.33333%; }\n  .offset-xl-11 {\n    margin-left: 91.66667%; } }\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #212529; }\n  .table th,\n  .table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6; }\n  .table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #dee2e6; }\n  .table tbody + tbody {\n    border-top: 2px solid #dee2e6; }\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem; }\n\n.table-bordered {\n  border: 1px solid #dee2e6; }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6; }\n  .table-bordered thead th,\n  .table-bordered thead td {\n    border-bottom-width: 2px; }\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0; }\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05); }\n\n.table-hover tbody tr:hover {\n  color: #212529;\n  background-color: rgba(0, 0, 0, 0.075); }\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #b8daff; }\n\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: #7abaff; }\n\n.table-hover .table-primary:hover {\n  background-color: #9fcdff; }\n  .table-hover .table-primary:hover > td,\n  .table-hover .table-primary:hover > th {\n    background-color: #9fcdff; }\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #d6d8db; }\n\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: #b3b7bb; }\n\n.table-hover .table-secondary:hover {\n  background-color: #c8cbcf; }\n  .table-hover .table-secondary:hover > td,\n  .table-hover .table-secondary:hover > th {\n    background-color: #c8cbcf; }\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #c3e6cb; }\n\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: #8fd19e; }\n\n.table-hover .table-success:hover {\n  background-color: #b1dfbb; }\n  .table-hover .table-success:hover > td,\n  .table-hover .table-success:hover > th {\n    background-color: #b1dfbb; }\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #bee5eb; }\n\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: #86cfda; }\n\n.table-hover .table-info:hover {\n  background-color: #abdde5; }\n  .table-hover .table-info:hover > td,\n  .table-hover .table-info:hover > th {\n    background-color: #abdde5; }\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #ffeeba; }\n\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: #ffdf7e; }\n\n.table-hover .table-warning:hover {\n  background-color: #ffe8a1; }\n  .table-hover .table-warning:hover > td,\n  .table-hover .table-warning:hover > th {\n    background-color: #ffe8a1; }\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #f5c6cb; }\n\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: #ed969e; }\n\n.table-hover .table-danger:hover {\n  background-color: #f1b0b7; }\n  .table-hover .table-danger:hover > td,\n  .table-hover .table-danger:hover > th {\n    background-color: #f1b0b7; }\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fdfdfe; }\n\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: #fbfcfc; }\n\n.table-hover .table-light:hover {\n  background-color: #ececf6; }\n  .table-hover .table-light:hover > td,\n  .table-hover .table-light:hover > th {\n    background-color: #ececf6; }\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c6c8ca; }\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: #95999c; }\n\n.table-hover .table-dark:hover {\n  background-color: #b9bbbe; }\n  .table-hover .table-dark:hover > td,\n  .table-hover .table-dark:hover > th {\n    background-color: #b9bbbe; }\n\n.table-header,\n.table-header > th,\n.table-header > td {\n  background-color: #c6c0c7; }\n\n.table-header th,\n.table-header td,\n.table-header thead th,\n.table-header tbody + tbody {\n  border-color: #958a96; }\n\n.table-hover .table-header:hover {\n  background-color: #bab3bb; }\n  .table-hover .table-header:hover > td,\n  .table-hover .table-header:hover > th {\n    background-color: #bab3bb; }\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075); }\n\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075); }\n  .table-hover .table-active:hover > td,\n  .table-hover .table-active:hover > th {\n    background-color: rgba(0, 0, 0, 0.075); }\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #454d55; }\n\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #dee2e6; }\n\n.table-dark {\n  color: #fff;\n  background-color: #343a40; }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th {\n    border-color: #454d55; }\n  .table-dark.table-bordered {\n    border: 0; }\n  .table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .table-dark.table-hover tbody tr:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, 0.075); }\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-sm > .table-bordered {\n      border: 0; } }\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-md > .table-bordered {\n      border: 0; } }\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-lg > .table-bordered {\n      border: 0; } }\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-xl > .table-bordered {\n      border: 0; } }\n\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch; }\n  .table-responsive > .table-bordered {\n    border: 0; }\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .form-control {\n      transition: none; } }\n  .form-control::-ms-expand {\n    background-color: transparent;\n    border: 0; }\n  .form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .form-control::placeholder {\n    color: #6c757d;\n    opacity: 1; }\n  .form-control:disabled, .form-control[readonly] {\n    background-color: #e9ecef;\n    opacity: 1; }\n\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff; }\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%; }\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5; }\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n  line-height: 1.5; }\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5; }\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0; }\n  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n    padding-right: 0;\n    padding-left: 0; }\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto; }\n\ntextarea.form-control {\n  height: auto; }\n\n.form-group {\n  margin-bottom: 1rem; }\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem; }\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px; }\n  .form-row > .col,\n  .form-row > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px; }\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem; }\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem; }\n  .form-check-input:disabled ~ .form-check-label {\n    color: #6c757d; }\n\n.form-check-label {\n  margin-bottom: 0; }\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem; }\n  .form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: 0.3125rem;\n    margin-left: 0; }\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #28a745; }\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(40, 167, 69, 0.9);\n  border-radius: 0.25rem; }\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #28a745;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: center right calc(0.375em + 0.1875rem);\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n    border-color: #28a745;\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n  .was-validated .form-control:valid ~ .valid-feedback,\n  .was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n  .form-control.is-valid ~ .valid-tooltip {\n    display: block; }\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #28a745;\n  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n    border-color: #28a745;\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n  .was-validated .custom-select:valid ~ .valid-feedback,\n  .was-validated .custom-select:valid ~ .valid-tooltip, .custom-select.is-valid ~ .valid-feedback,\n  .custom-select.is-valid ~ .valid-tooltip {\n    display: block; }\n\n.was-validated .form-control-file:valid ~ .valid-feedback,\n.was-validated .form-control-file:valid ~ .valid-tooltip, .form-control-file.is-valid ~ .valid-feedback,\n.form-control-file.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #28a745; }\n\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #28a745; }\n  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n    border-color: #28a745; }\n\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: #34ce57;\n  background-color: #34ce57; }\n\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #28a745; }\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #28a745; }\n\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545; }\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.9);\n  border-radius: 0.25rem; }\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center right calc(0.375em + 0.1875rem);\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n  .was-validated .form-control:invalid ~ .invalid-feedback,\n  .was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n  .form-control.is-invalid ~ .invalid-tooltip {\n    display: block; }\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n  .was-validated .custom-select:invalid ~ .invalid-feedback,\n  .was-validated .custom-select:invalid ~ .invalid-tooltip, .custom-select.is-invalid ~ .invalid-feedback,\n  .custom-select.is-invalid ~ .invalid-tooltip {\n    display: block; }\n\n.was-validated .form-control-file:invalid ~ .invalid-feedback,\n.was-validated .form-control-file:invalid ~ .invalid-tooltip, .form-control-file.is-invalid ~ .invalid-feedback,\n.form-control-file.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545; }\n\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #dc3545; }\n  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n    border-color: #dc3545; }\n\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: #e4606d;\n  background-color: #e4606d; }\n\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #dc3545; }\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #dc3545; }\n\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; }\n  .form-inline .form-check {\n    width: 100%; }\n  @media (min-width: 576px) {\n    .form-inline label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0; }\n    .form-inline .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0; }\n    .form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle; }\n    .form-inline .form-control-plaintext {\n      display: inline-block; }\n    .form-inline .input-group,\n    .form-inline .custom-select {\n      width: auto; }\n    .form-inline .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0; }\n    .form-inline .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: 0.25rem;\n      margin-left: 0; }\n    .form-inline .custom-control {\n      align-items: center;\n      justify-content: center; }\n    .form-inline .custom-control-label {\n      margin-bottom: 0; } }\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #212529;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .btn {\n      transition: none; } }\n  .btn:hover {\n    color: #212529;\n    text-decoration: none; }\n  .btn:focus, .btn.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .btn.disabled, .btn:disabled {\n    opacity: 0.65; }\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none; }\n\n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff; }\n  .btn-primary:hover {\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc; }\n  .btn-primary:focus, .btn-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5); }\n  .btn-primary.disabled, .btn-primary:disabled {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n  .show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #0062cc;\n    border-color: #005cbf; }\n    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-primary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5); }\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d; }\n  .btn-secondary:hover {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62; }\n  .btn-secondary:focus, .btn-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }\n  .btn-secondary.disabled, .btn-secondary:disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,\n  .show > .btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #545b62;\n    border-color: #4e555b; }\n    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-secondary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }\n\n.btn-success {\n  color: #fff;\n  background-color: #28a745;\n  border-color: #28a745; }\n  .btn-success:hover {\n    color: #fff;\n    background-color: #218838;\n    border-color: #1e7e34; }\n  .btn-success:focus, .btn-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5); }\n  .btn-success.disabled, .btn-success:disabled {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745; }\n  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n  .show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #1e7e34;\n    border-color: #1c7430; }\n    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-success.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5); }\n\n.btn-info {\n  color: #fff;\n  background-color: #17a2b8;\n  border-color: #17a2b8; }\n  .btn-info:hover {\n    color: #fff;\n    background-color: #138496;\n    border-color: #117a8b; }\n  .btn-info:focus, .btn-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5); }\n  .btn-info.disabled, .btn-info:disabled {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8; }\n  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n  .show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #117a8b;\n    border-color: #10707f; }\n    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-info.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5); }\n\n.btn-warning {\n  color: #212529;\n  background-color: #ffc107;\n  border-color: #ffc107; }\n  .btn-warning:hover {\n    color: #212529;\n    background-color: #e0a800;\n    border-color: #d39e00; }\n  .btn-warning:focus, .btn-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5); }\n  .btn-warning.disabled, .btn-warning:disabled {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107; }\n  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n  .show > .btn-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #d39e00;\n    border-color: #c69500; }\n    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-warning.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5); }\n\n.btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545; }\n  .btn-danger:hover {\n    color: #fff;\n    background-color: #c82333;\n    border-color: #bd2130; }\n  .btn-danger:focus, .btn-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5); }\n  .btn-danger.disabled, .btn-danger:disabled {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545; }\n  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n  .show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #bd2130;\n    border-color: #b21f2d; }\n    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-danger.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5); }\n\n.btn-light {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa; }\n  .btn-light:hover {\n    color: #212529;\n    background-color: #e2e6ea;\n    border-color: #dae0e5; }\n  .btn-light:focus, .btn-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }\n  .btn-light.disabled, .btn-light:disabled {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,\n  .show > .btn-light.dropdown-toggle {\n    color: #212529;\n    background-color: #dae0e5;\n    border-color: #d3d9df; }\n    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-light.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40; }\n  .btn-dark:hover {\n    color: #fff;\n    background-color: #23272b;\n    border-color: #1d2124; }\n  .btn-dark:focus, .btn-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }\n  .btn-dark.disabled, .btn-dark:disabled {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,\n  .show > .btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #1d2124;\n    border-color: #171a1d; }\n    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-dark.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }\n\n.btn-header {\n  color: #fff;\n  background-color: #331E36;\n  border-color: #331E36; }\n  .btn-header:hover {\n    color: #fff;\n    background-color: #1c101d;\n    border-color: #140c15; }\n  .btn-header:focus, .btn-header.focus {\n    box-shadow: 0 0 0 0.2rem rgba(82, 64, 84, 0.5); }\n  .btn-header.disabled, .btn-header:disabled {\n    color: #fff;\n    background-color: #331E36;\n    border-color: #331E36; }\n  .btn-header:not(:disabled):not(.disabled):active, .btn-header:not(:disabled):not(.disabled).active,\n  .show > .btn-header.dropdown-toggle {\n    color: #fff;\n    background-color: #140c15;\n    border-color: #0c070d; }\n    .btn-header:not(:disabled):not(.disabled):active:focus, .btn-header:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-header.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(82, 64, 84, 0.5); }\n\n.btn-outline-primary {\n  color: #007bff;\n  border-color: #007bff; }\n  .btn-outline-primary:hover {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n  .btn-outline-primary:focus, .btn-outline-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n  .btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #007bff;\n    background-color: transparent; }\n  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-primary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d; }\n  .btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #6c757d;\n    background-color: transparent; }\n  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-secondary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.btn-outline-success {\n  color: #28a745;\n  border-color: #28a745; }\n  .btn-outline-success:hover {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745; }\n  .btn-outline-success:focus, .btn-outline-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n  .btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #28a745;\n    background-color: transparent; }\n  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745; }\n    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-success.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n\n.btn-outline-info {\n  color: #17a2b8;\n  border-color: #17a2b8; }\n  .btn-outline-info:hover {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8; }\n  .btn-outline-info:focus, .btn-outline-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n  .btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #17a2b8;\n    background-color: transparent; }\n  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8; }\n    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-info.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n\n.btn-outline-warning {\n  color: #ffc107;\n  border-color: #ffc107; }\n  .btn-outline-warning:hover {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107; }\n  .btn-outline-warning:focus, .btn-outline-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n  .btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #ffc107;\n    background-color: transparent; }\n  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107; }\n    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-warning.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n\n.btn-outline-danger {\n  color: #dc3545;\n  border-color: #dc3545; }\n  .btn-outline-danger:hover {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545; }\n  .btn-outline-danger:focus, .btn-outline-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n  .btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #dc3545;\n    background-color: transparent; }\n  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545; }\n    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-danger.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n\n.btn-outline-light {\n  color: #f8f9fa;\n  border-color: #f8f9fa; }\n  .btn-outline-light:hover {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n  .btn-outline-light:focus, .btn-outline-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n  .btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #f8f9fa;\n    background-color: transparent; }\n  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-light.dropdown-toggle {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-light.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40; }\n  .btn-outline-dark:hover {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n  .btn-outline-dark:focus, .btn-outline-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n  .btn-outline-dark.disabled, .btn-outline-dark:disabled {\n    color: #343a40;\n    background-color: transparent; }\n  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-dark.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n\n.btn-outline-header {\n  color: #331E36;\n  border-color: #331E36; }\n  .btn-outline-header:hover {\n    color: #fff;\n    background-color: #331E36;\n    border-color: #331E36; }\n  .btn-outline-header:focus, .btn-outline-header.focus {\n    box-shadow: 0 0 0 0.2rem rgba(51, 30, 54, 0.5); }\n  .btn-outline-header.disabled, .btn-outline-header:disabled {\n    color: #331E36;\n    background-color: transparent; }\n  .btn-outline-header:not(:disabled):not(.disabled):active, .btn-outline-header:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-header.dropdown-toggle {\n    color: #fff;\n    background-color: #331E36;\n    border-color: #331E36; }\n    .btn-outline-header:not(:disabled):not(.disabled):active:focus, .btn-outline-header:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-header.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(51, 30, 54, 0.5); }\n\n.btn-link {\n  font-weight: 400;\n  color: #007bff;\n  text-decoration: none; }\n  .btn-link:hover {\n    color: #0056b3;\n    text-decoration: underline; }\n  .btn-link:focus, .btn-link.focus {\n    text-decoration: underline;\n    box-shadow: none; }\n  .btn-link:disabled, .btn-link.disabled {\n    color: #6c757d;\n    pointer-events: none; }\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.btn-block {\n  display: block;\n  width: 100%; }\n  .btn-block + .btn-block {\n    margin-top: 0.5rem; }\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%; }\n\n.fade {\n  transition: opacity 0.15s linear; }\n  @media (prefers-reduced-motion: reduce) {\n    .fade {\n      transition: none; } }\n  .fade:not(.show) {\n    opacity: 0; }\n\n.collapse:not(.show) {\n  display: none; }\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .collapsing {\n      transition: none; } }\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative; }\n\n.dropdown-toggle {\n  white-space: nowrap; }\n  .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent; }\n  .dropdown-toggle:empty::after {\n    margin-left: 0; }\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem; }\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0; }\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto; }\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto; } }\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem; }\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent; }\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem; }\n\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid; }\n\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-toggle::after {\n  vertical-align: 0; }\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem; }\n\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\"; }\n\n.dropleft .dropdown-toggle::after {\n  display: none; }\n\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent; }\n\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0; }\n\n.dropdown-menu[x-placement^=\"top\"], .dropdown-menu[x-placement^=\"right\"], .dropdown-menu[x-placement^=\"bottom\"], .dropdown-menu[x-placement^=\"left\"] {\n  right: auto;\n  bottom: auto; }\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef; }\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0; }\n  .dropdown-item:hover, .dropdown-item:focus {\n    color: #16181b;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .dropdown-item.active, .dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #007bff; }\n  .dropdown-item.disabled, .dropdown-item:disabled {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: transparent; }\n\n.dropdown-menu.show {\n  display: block; }\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #6c757d;\n  white-space: nowrap; }\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529; }\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; }\n  .btn-group > .btn,\n  .btn-group-vertical > .btn {\n    position: relative;\n    flex: 1 1 auto; }\n    .btn-group > .btn:hover,\n    .btn-group-vertical > .btn:hover {\n      z-index: 1; }\n    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n      z-index: 1; }\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start; }\n  .btn-toolbar .input-group {\n    width: auto; }\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px; }\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem; }\n  .dropdown-toggle-split::after,\n  .dropup .dropdown-toggle-split::after,\n  .dropright .dropdown-toggle-split::after {\n    margin-left: 0; }\n  .dropleft .dropdown-toggle-split::before {\n    margin-right: 0; }\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem; }\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem; }\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center; }\n  .btn-group-vertical > .btn,\n  .btn-group-vertical > .btn-group {\n    width: 100%; }\n  .btn-group-vertical > .btn:not(:first-child),\n  .btn-group-vertical > .btn-group:not(:first-child) {\n    margin-top: -1px; }\n  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n  .btn-group-vertical > .btn-group:not(:last-child) > .btn {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .btn-group-vertical > .btn:not(:first-child),\n  .btn-group-vertical > .btn-group:not(:first-child) > .btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0; }\n  .btn-group-toggle > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn input[type=\"checkbox\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none; }\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%; }\n  .input-group > .form-control,\n  .input-group > .form-control-plaintext,\n  .input-group > .custom-select,\n  .input-group > .custom-file {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0; }\n    .input-group > .form-control + .form-control,\n    .input-group > .form-control + .custom-select,\n    .input-group > .form-control + .custom-file,\n    .input-group > .form-control-plaintext + .form-control,\n    .input-group > .form-control-plaintext + .custom-select,\n    .input-group > .form-control-plaintext + .custom-file,\n    .input-group > .custom-select + .form-control,\n    .input-group > .custom-select + .custom-select,\n    .input-group > .custom-select + .custom-file,\n    .input-group > .custom-file + .form-control,\n    .input-group > .custom-file + .custom-select,\n    .input-group > .custom-file + .custom-file {\n      margin-left: -1px; }\n  .input-group > .form-control:focus,\n  .input-group > .custom-select:focus,\n  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3; }\n  .input-group > .custom-file .custom-file-input:focus {\n    z-index: 4; }\n  .input-group > .form-control:not(:last-child),\n  .input-group > .custom-select:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .input-group > .form-control:not(:first-child),\n  .input-group > .custom-select:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .input-group > .custom-file {\n    display: flex;\n    align-items: center; }\n    .input-group > .custom-file:not(:last-child) .custom-file-label,\n    .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0; }\n    .input-group > .custom-file:not(:first-child) .custom-file-label {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0; }\n\n.input-group-prepend,\n.input-group-append {\n  display: flex; }\n  .input-group-prepend .btn,\n  .input-group-append .btn {\n    position: relative;\n    z-index: 2; }\n    .input-group-prepend .btn:focus,\n    .input-group-append .btn:focus {\n      z-index: 3; }\n  .input-group-prepend .btn + .btn,\n  .input-group-prepend .btn + .input-group-text,\n  .input-group-prepend .input-group-text + .input-group-text,\n  .input-group-prepend .input-group-text + .btn,\n  .input-group-append .btn + .btn,\n  .input-group-append .btn + .input-group-text,\n  .input-group-append .input-group-text + .input-group-text,\n  .input-group-append .input-group-text + .btn {\n    margin-left: -1px; }\n\n.input-group-prepend {\n  margin-right: -1px; }\n\n.input-group-append {\n  margin-left: -1px; }\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem; }\n  .input-group-text input[type=\"radio\"],\n  .input-group-text input[type=\"checkbox\"] {\n    margin-top: 0; }\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1rem + 2px); }\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px); }\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem; }\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem; }\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem; }\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0; }\n  .custom-control-input:checked ~ .custom-control-label::before {\n    color: #fff;\n    border-color: #007bff;\n    background-color: #007bff; }\n  .custom-control-input:focus ~ .custom-control-label::before {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: #80bdff; }\n  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #b3d7ff;\n    border-color: #b3d7ff; }\n  .custom-control-input:disabled ~ .custom-control-label {\n    color: #6c757d; }\n    .custom-control-input:disabled ~ .custom-control-label::before {\n      background-color: #e9ecef; }\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top; }\n  .custom-control-label::before {\n    position: absolute;\n    top: 0.25rem;\n    left: -1.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    pointer-events: none;\n    content: \"\";\n    background-color: #fff;\n    border: #adb5bd solid 1px; }\n  .custom-control-label::after {\n    position: absolute;\n    top: 0.25rem;\n    left: -1.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    content: \"\";\n    background: no-repeat 50% / 50% 50%; }\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem; }\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\"); }\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #007bff;\n  background-color: #007bff; }\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\"); }\n\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5); }\n\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5); }\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%; }\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\"); }\n\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5); }\n\n.custom-switch {\n  padding-left: 2.25rem; }\n  .custom-switch .custom-control-label::before {\n    left: -2.25rem;\n    width: 1.75rem;\n    pointer-events: all;\n    border-radius: 0.5rem; }\n  .custom-switch .custom-control-label::after {\n    top: calc(0.25rem + 2px);\n    left: calc(-2.25rem + 2px);\n    width: calc(1rem - 4px);\n    height: calc(1rem - 4px);\n    background-color: #adb5bd;\n    border-radius: 0.5rem;\n    transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-switch .custom-control-label::after {\n        transition: none; } }\n  .custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n    background-color: #fff;\n    transform: translateX(0.75rem); }\n  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n    background-color: rgba(0, 123, 255, 0.5); }\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  appearance: none; }\n  .custom-select:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-select:focus::-ms-value {\n      color: #495057;\n      background-color: #fff; }\n  .custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: 0.75rem;\n    background-image: none; }\n  .custom-select:disabled {\n    color: #6c757d;\n    background-color: #e9ecef; }\n  .custom-select::-ms-expand {\n    display: none; }\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem; }\n\n.custom-select-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem; }\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin-bottom: 0; }\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin: 0;\n  opacity: 0; }\n  .custom-file-input:focus ~ .custom-file-label {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .custom-file-input:disabled ~ .custom-file-label {\n    background-color: #e9ecef; }\n  .custom-file-input:lang(en) ~ .custom-file-label::after {\n    content: \"Browse\"; }\n  .custom-file-input ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse); }\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem; }\n  .custom-file-label::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: calc(1.5em + 0.75rem);\n    padding: 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #495057;\n    content: \"Browse\";\n    background-color: #e9ecef;\n    border-left: inherit;\n    border-radius: 0 0.25rem 0.25rem 0; }\n\n.custom-range {\n  width: 100%;\n  height: calc(1rem + 0.4rem);\n  padding: 0;\n  background-color: transparent;\n  appearance: none; }\n  .custom-range:focus {\n    outline: none; }\n    .custom-range:focus::-webkit-slider-thumb {\n      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-range:focus::-moz-range-thumb {\n      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n    .custom-range:focus::-ms-thumb {\n      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n  .custom-range::-moz-focus-outer {\n    border: 0; }\n  .custom-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -0.25rem;\n    background-color: #007bff;\n    border: 0;\n    border-radius: 1rem;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    appearance: none; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-range::-webkit-slider-thumb {\n        transition: none; } }\n    .custom-range::-webkit-slider-thumb:active {\n      background-color: #b3d7ff; }\n  .custom-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dee2e6;\n    border-color: transparent;\n    border-radius: 1rem; }\n  .custom-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #007bff;\n    border: 0;\n    border-radius: 1rem;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    appearance: none; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-range::-moz-range-thumb {\n        transition: none; } }\n    .custom-range::-moz-range-thumb:active {\n      background-color: #b3d7ff; }\n  .custom-range::-moz-range-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #dee2e6;\n    border-color: transparent;\n    border-radius: 1rem; }\n  .custom-range::-ms-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: 0;\n    margin-right: 0.2rem;\n    margin-left: 0.2rem;\n    background-color: #007bff;\n    border: 0;\n    border-radius: 1rem;\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    appearance: none; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-range::-ms-thumb {\n        transition: none; } }\n    .custom-range::-ms-thumb:active {\n      background-color: #b3d7ff; }\n  .custom-range::-ms-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: 0.5rem; }\n  .custom-range::-ms-fill-lower {\n    background-color: #dee2e6;\n    border-radius: 1rem; }\n  .custom-range::-ms-fill-upper {\n    margin-right: 15px;\n    background-color: #dee2e6;\n    border-radius: 1rem; }\n  .custom-range:disabled::-webkit-slider-thumb {\n    background-color: #adb5bd; }\n  .custom-range:disabled::-webkit-slider-runnable-track {\n    cursor: default; }\n  .custom-range:disabled::-moz-range-thumb {\n    background-color: #adb5bd; }\n  .custom-range:disabled::-moz-range-track {\n    cursor: default; }\n  .custom-range:disabled::-ms-thumb {\n    background-color: #adb5bd; }\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .custom-control-label::before,\n    .custom-file-label,\n    .custom-select {\n      transition: none; } }\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem; }\n  .nav-link:hover, .nav-link:focus {\n    text-decoration: none; }\n  .nav-link.disabled {\n    color: #6c757d;\n    pointer-events: none;\n    cursor: default; }\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6; }\n  .nav-tabs .nav-item {\n    margin-bottom: -1px; }\n  .nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n      border-color: #e9ecef #e9ecef #dee2e6; }\n    .nav-tabs .nav-link.disabled {\n      color: #6c757d;\n      background-color: transparent;\n      border-color: transparent; }\n  .nav-tabs .nav-link.active,\n  .nav-tabs .nav-item.show .nav-link {\n    color: #495057;\n    background-color: #fff;\n    border-color: #dee2e6 #dee2e6 #fff; }\n  .nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.nav-pills .nav-link {\n  border-radius: 0.25rem; }\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #007bff; }\n\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center; }\n\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center; }\n\n.tab-content > .tab-pane {\n  display: none; }\n\n.tab-content > .active {\n  display: block; }\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem; }\n  .navbar > .container,\n  .navbar > .container-fluid {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between; }\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap; }\n  .navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none; }\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n  .navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-nav .dropdown-menu {\n    position: static;\n    float: none; }\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem; }\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center; }\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem; }\n  .navbar-toggler:hover, .navbar-toggler:focus {\n    text-decoration: none; }\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%; }\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-sm .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-sm .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-sm .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-md .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-md .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-md .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-lg .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-lg .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-lg .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-xl .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid {\n      flex-wrap: nowrap; }\n    .navbar-expand-xl .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-xl .navbar-toggler {\n      display: none; } }\n\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-expand .navbar-nav {\n    flex-direction: row; }\n    .navbar-expand .navbar-nav .dropdown-menu {\n      position: absolute; }\n    .navbar-expand .navbar-nav .nav-link {\n      padding-right: 0.5rem;\n      padding-left: 0.5rem; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid {\n    flex-wrap: nowrap; }\n  .navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto; }\n  .navbar-expand .navbar-toggler {\n    display: none; }\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9); }\n  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n    color: rgba(0, 0, 0, 0.9); }\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n    color: rgba(0, 0, 0, 0.7); }\n  .navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, 0.3); }\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9); }\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1); }\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"); }\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, 0.9); }\n    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n      color: rgba(0, 0, 0, 0.9); }\n\n.navbar-dark .navbar-brand {\n  color: #fff; }\n  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n    color: #fff; }\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.75); }\n  .navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25); }\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff; }\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1); }\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"); }\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-text a {\n    color: #fff; }\n    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n      color: #fff; }\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem; }\n  .card > hr {\n    margin-right: 0;\n    margin-left: 0; }\n  .card > .list-group:first-child .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n  .card > .list-group:last-child .list-group-item:last-child {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem; }\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1.25rem; }\n\n.card-title {\n  margin-bottom: 0.75rem; }\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0; }\n\n.card-text:last-child {\n  margin-bottom: 0; }\n\n.card-link:hover {\n  text-decoration: none; }\n\n.card-link + .card-link {\n  margin-left: 1.25rem; }\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-header:first-child {\n    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0; }\n  .card-header + .list-group .list-group-item:first-child {\n    border-top: 0; }\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-footer:last-child {\n    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px); }\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0; }\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem; }\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem; }\n\n.card-img {\n  width: 100%;\n  border-radius: calc(0.25rem - 1px); }\n\n.card-img-top {\n  width: 100%;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px); }\n\n.card-img-bottom {\n  width: 100%;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px); }\n\n.card-deck {\n  display: flex;\n  flex-direction: column; }\n  .card-deck .card {\n    margin-bottom: 15px; }\n  @media (min-width: 576px) {\n    .card-deck {\n      flex-flow: row wrap;\n      margin-right: -15px;\n      margin-left: -15px; }\n      .card-deck .card {\n        display: flex;\n        flex: 1 0 0%;\n        flex-direction: column;\n        margin-right: 15px;\n        margin-bottom: 0;\n        margin-left: 15px; } }\n\n.card-group {\n  display: flex;\n  flex-direction: column; }\n  .card-group > .card {\n    margin-bottom: 15px; }\n  @media (min-width: 576px) {\n    .card-group {\n      flex-flow: row wrap; }\n      .card-group > .card {\n        flex: 1 0 0%;\n        margin-bottom: 0; }\n        .card-group > .card + .card {\n          margin-left: 0;\n          border-left: 0; }\n        .card-group > .card:not(:last-child) {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0; }\n          .card-group > .card:not(:last-child) .card-img-top,\n          .card-group > .card:not(:last-child) .card-header {\n            border-top-right-radius: 0; }\n          .card-group > .card:not(:last-child) .card-img-bottom,\n          .card-group > .card:not(:last-child) .card-footer {\n            border-bottom-right-radius: 0; }\n        .card-group > .card:not(:first-child) {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0; }\n          .card-group > .card:not(:first-child) .card-img-top,\n          .card-group > .card:not(:first-child) .card-header {\n            border-top-left-radius: 0; }\n          .card-group > .card:not(:first-child) .card-img-bottom,\n          .card-group > .card:not(:first-child) .card-footer {\n            border-bottom-left-radius: 0; } }\n\n.card-columns .card {\n  margin-bottom: 0.75rem; }\n\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1; }\n    .card-columns .card {\n      display: inline-block;\n      width: 100%; } }\n\n.accordion > .card {\n  overflow: hidden; }\n  .accordion > .card:not(:first-of-type) .card-header:first-child {\n    border-radius: 0; }\n  .accordion > .card:not(:first-of-type):not(:last-of-type) {\n    border-bottom: 0;\n    border-radius: 0; }\n  .accordion > .card:first-of-type {\n    border-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .accordion > .card:last-of-type {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n  .accordion > .card .card-header {\n    margin-bottom: -1px; }\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.25rem; }\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem; }\n  .breadcrumb-item + .breadcrumb-item::before {\n    display: inline-block;\n    padding-right: 0.5rem;\n    color: #6c757d;\n    content: \"/\"; }\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline; }\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none; }\n\n.breadcrumb-item.active {\n  color: #6c757d; }\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.25rem; }\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  border: 1px solid #dee2e6; }\n  .page-link:hover {\n    z-index: 2;\n    color: #0056b3;\n    text-decoration: none;\n    background-color: #e9ecef;\n    border-color: #dee2e6; }\n  .page-link:focus {\n    z-index: 2;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem; }\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem; }\n\n.page-item.active .page-link {\n  z-index: 1;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff; }\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6; }\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5; }\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem; }\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem; }\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5; }\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem; }\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem; }\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .badge {\n      transition: none; } }\n  a.badge:hover, a.badge:focus {\n    text-decoration: none; }\n  .badge:empty {\n    display: none; }\n\n.btn .badge {\n  position: relative;\n  top: -1px; }\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem; }\n\n.badge-primary {\n  color: #fff;\n  background-color: #007bff; }\n  a.badge-primary:hover, a.badge-primary:focus {\n    color: #fff;\n    background-color: #0062cc; }\n  a.badge-primary:focus, a.badge-primary.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d; }\n  a.badge-secondary:hover, a.badge-secondary:focus {\n    color: #fff;\n    background-color: #545b62; }\n  a.badge-secondary:focus, a.badge-secondary.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.badge-success {\n  color: #fff;\n  background-color: #28a745; }\n  a.badge-success:hover, a.badge-success:focus {\n    color: #fff;\n    background-color: #1e7e34; }\n  a.badge-success:focus, a.badge-success.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }\n\n.badge-info {\n  color: #fff;\n  background-color: #17a2b8; }\n  a.badge-info:hover, a.badge-info:focus {\n    color: #fff;\n    background-color: #117a8b; }\n  a.badge-info:focus, a.badge-info.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }\n\n.badge-warning {\n  color: #212529;\n  background-color: #ffc107; }\n  a.badge-warning:hover, a.badge-warning:focus {\n    color: #212529;\n    background-color: #d39e00; }\n  a.badge-warning:focus, a.badge-warning.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }\n\n.badge-danger {\n  color: #fff;\n  background-color: #dc3545; }\n  a.badge-danger:hover, a.badge-danger:focus {\n    color: #fff;\n    background-color: #bd2130; }\n  a.badge-danger:focus, a.badge-danger.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }\n\n.badge-light {\n  color: #212529;\n  background-color: #f8f9fa; }\n  a.badge-light:hover, a.badge-light:focus {\n    color: #212529;\n    background-color: #dae0e5; }\n  a.badge-light:focus, a.badge-light.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n\n.badge-dark {\n  color: #fff;\n  background-color: #343a40; }\n  a.badge-dark:hover, a.badge-dark:focus {\n    color: #fff;\n    background-color: #1d2124; }\n  a.badge-dark:focus, a.badge-dark.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n\n.badge-header {\n  color: #fff;\n  background-color: #331E36; }\n  a.badge-header:hover, a.badge-header:focus {\n    color: #fff;\n    background-color: #140c15; }\n  a.badge-header:focus, a.badge-header.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(51, 30, 54, 0.5); }\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem; }\n  @media (min-width: 576px) {\n    .jumbotron {\n      padding: 4rem 2rem; } }\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0; }\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem; }\n\n.alert-heading {\n  color: inherit; }\n\n.alert-link {\n  font-weight: 700; }\n\n.alert-dismissible {\n  padding-right: 4rem; }\n  .alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0.75rem 1.25rem;\n    color: inherit; }\n\n.alert-primary {\n  color: #004085;\n  background-color: #cce5ff;\n  border-color: #b8daff; }\n  .alert-primary hr {\n    border-top-color: #9fcdff; }\n  .alert-primary .alert-link {\n    color: #002752; }\n\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db; }\n  .alert-secondary hr {\n    border-top-color: #c8cbcf; }\n  .alert-secondary .alert-link {\n    color: #202326; }\n\n.alert-success {\n  color: #155724;\n  background-color: #d4edda;\n  border-color: #c3e6cb; }\n  .alert-success hr {\n    border-top-color: #b1dfbb; }\n  .alert-success .alert-link {\n    color: #0b2e13; }\n\n.alert-info {\n  color: #0c5460;\n  background-color: #d1ecf1;\n  border-color: #bee5eb; }\n  .alert-info hr {\n    border-top-color: #abdde5; }\n  .alert-info .alert-link {\n    color: #062c33; }\n\n.alert-warning {\n  color: #856404;\n  background-color: #fff3cd;\n  border-color: #ffeeba; }\n  .alert-warning hr {\n    border-top-color: #ffe8a1; }\n  .alert-warning .alert-link {\n    color: #533f03; }\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb; }\n  .alert-danger hr {\n    border-top-color: #f1b0b7; }\n  .alert-danger .alert-link {\n    color: #491217; }\n\n.alert-light {\n  color: #818182;\n  background-color: #fefefe;\n  border-color: #fdfdfe; }\n  .alert-light hr {\n    border-top-color: #ececf6; }\n  .alert-light .alert-link {\n    color: #686868; }\n\n.alert-dark {\n  color: #1b1e21;\n  background-color: #d6d8d9;\n  border-color: #c6c8ca; }\n  .alert-dark hr {\n    border-top-color: #b9bbbe; }\n  .alert-dark .alert-link {\n    color: #040505; }\n\n.alert-header {\n  color: #1b101c;\n  background-color: #d6d2d7;\n  border-color: #c6c0c7; }\n  .alert-header hr {\n    border-top-color: #bab3bb; }\n  .alert-header .alert-link {\n    color: black; }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0; }\n  to {\n    background-position: 0 0; } }\n\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem; }\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #007bff;\n  transition: width 0.6s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .progress-bar {\n      transition: none; } }\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem; }\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite; }\n  @media (prefers-reduced-motion: reduce) {\n    .progress-bar-animated {\n      animation: none; } }\n\n.media {\n  display: flex;\n  align-items: flex-start; }\n\n.media-body {\n  flex: 1; }\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0; }\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit; }\n  .list-group-item-action:hover, .list-group-item-action:focus {\n    z-index: 1;\n    color: #495057;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .list-group-item-action:active {\n    color: #212529;\n    background-color: #e9ecef; }\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125); }\n  .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n  .list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem; }\n  .list-group-item.disabled, .list-group-item:disabled {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: #fff; }\n  .list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff; }\n\n.list-group-horizontal {\n  flex-direction: row; }\n  .list-group-horizontal .list-group-item {\n    margin-right: -1px;\n    margin-bottom: 0; }\n    .list-group-horizontal .list-group-item:first-child {\n      border-top-left-radius: 0.25rem;\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0; }\n    .list-group-horizontal .list-group-item:last-child {\n      margin-right: 0;\n      border-top-right-radius: 0.25rem;\n      border-bottom-right-radius: 0.25rem;\n      border-bottom-left-radius: 0; }\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row; }\n    .list-group-horizontal-sm .list-group-item {\n      margin-right: -1px;\n      margin-bottom: 0; }\n      .list-group-horizontal-sm .list-group-item:first-child {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n        border-top-right-radius: 0; }\n      .list-group-horizontal-sm .list-group-item:last-child {\n        margin-right: 0;\n        border-top-right-radius: 0.25rem;\n        border-bottom-right-radius: 0.25rem;\n        border-bottom-left-radius: 0; } }\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row; }\n    .list-group-horizontal-md .list-group-item {\n      margin-right: -1px;\n      margin-bottom: 0; }\n      .list-group-horizontal-md .list-group-item:first-child {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n        border-top-right-radius: 0; }\n      .list-group-horizontal-md .list-group-item:last-child {\n        margin-right: 0;\n        border-top-right-radius: 0.25rem;\n        border-bottom-right-radius: 0.25rem;\n        border-bottom-left-radius: 0; } }\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row; }\n    .list-group-horizontal-lg .list-group-item {\n      margin-right: -1px;\n      margin-bottom: 0; }\n      .list-group-horizontal-lg .list-group-item:first-child {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n        border-top-right-radius: 0; }\n      .list-group-horizontal-lg .list-group-item:last-child {\n        margin-right: 0;\n        border-top-right-radius: 0.25rem;\n        border-bottom-right-radius: 0.25rem;\n        border-bottom-left-radius: 0; } }\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row; }\n    .list-group-horizontal-xl .list-group-item {\n      margin-right: -1px;\n      margin-bottom: 0; }\n      .list-group-horizontal-xl .list-group-item:first-child {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n        border-top-right-radius: 0; }\n      .list-group-horizontal-xl .list-group-item:last-child {\n        margin-right: 0;\n        border-top-right-radius: 0.25rem;\n        border-bottom-right-radius: 0.25rem;\n        border-bottom-left-radius: 0; } }\n\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0; }\n  .list-group-flush .list-group-item:last-child {\n    margin-bottom: -1px; }\n\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0; }\n\n.list-group-flush:last-child .list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom: 0; }\n\n.list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff; }\n  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n    color: #004085;\n    background-color: #9fcdff; }\n  .list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #004085;\n    border-color: #004085; }\n\n.list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db; }\n  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n    color: #383d41;\n    background-color: #c8cbcf; }\n  .list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #383d41;\n    border-color: #383d41; }\n\n.list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb; }\n  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n    color: #155724;\n    background-color: #b1dfbb; }\n  .list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #155724;\n    border-color: #155724; }\n\n.list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb; }\n  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n    color: #0c5460;\n    background-color: #abdde5; }\n  .list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #0c5460;\n    border-color: #0c5460; }\n\n.list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba; }\n  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n    color: #856404;\n    background-color: #ffe8a1; }\n  .list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #856404;\n    border-color: #856404; }\n\n.list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb; }\n  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n    color: #721c24;\n    background-color: #f1b0b7; }\n  .list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #721c24;\n    border-color: #721c24; }\n\n.list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe; }\n  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n    color: #818182;\n    background-color: #ececf6; }\n  .list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #818182;\n    border-color: #818182; }\n\n.list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca; }\n  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n    color: #1b1e21;\n    background-color: #b9bbbe; }\n  .list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #1b1e21;\n    border-color: #1b1e21; }\n\n.list-group-item-header {\n  color: #1b101c;\n  background-color: #c6c0c7; }\n  .list-group-item-header.list-group-item-action:hover, .list-group-item-header.list-group-item-action:focus {\n    color: #1b101c;\n    background-color: #bab3bb; }\n  .list-group-item-header.list-group-item-action.active {\n    color: #fff;\n    background-color: #1b101c;\n    border-color: #1b101c; }\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5; }\n  .close:hover {\n    color: #000;\n    text-decoration: none; }\n  .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n    opacity: .75; }\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  appearance: none; }\n\na.close.disabled {\n  pointer-events: none; }\n\n.toast {\n  max-width: 350px;\n  overflow: hidden;\n  font-size: 0.875rem;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  opacity: 0;\n  border-radius: 0.25rem; }\n  .toast:not(:last-child) {\n    margin-bottom: 0.75rem; }\n  .toast.showing {\n    opacity: 1; }\n  .toast.show {\n    display: block;\n    opacity: 1; }\n  .toast.hide {\n    display: none; }\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05); }\n\n.toast-body {\n  padding: 0.75rem; }\n\n.modal-open {\n  overflow: hidden; }\n  .modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto; }\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0; }\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none; }\n  .modal.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n    transform: translate(0, -50px); }\n    @media (prefers-reduced-motion: reduce) {\n      .modal.fade .modal-dialog {\n        transition: none; } }\n  .modal.show .modal-dialog {\n    transform: none; }\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem); }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 1rem);\n    overflow: hidden; }\n  .modal-dialog-scrollable .modal-header,\n  .modal-dialog-scrollable .modal-footer {\n    flex-shrink: 0; }\n  .modal-dialog-scrollable .modal-body {\n    overflow-y: auto; }\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem); }\n  .modal-dialog-centered::before {\n    display: block;\n    height: calc(100vh - 1rem);\n    content: \"\"; }\n  .modal-dialog-centered.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%; }\n    .modal-dialog-centered.modal-dialog-scrollable .modal-content {\n      max-height: none; }\n    .modal-dialog-centered.modal-dialog-scrollable::before {\n      content: none; }\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0; }\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000; }\n  .modal-backdrop.fade {\n    opacity: 0; }\n  .modal-backdrop.show {\n    opacity: 0.5; }\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem; }\n  .modal-header .close {\n    padding: 1rem 1rem;\n    margin: -1rem -1rem -1rem auto; }\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5; }\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem; }\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #dee2e6;\n  border-bottom-right-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem; }\n  .modal-footer > :not(:first-child) {\n    margin-left: .25rem; }\n  .modal-footer > :not(:last-child) {\n    margin-right: .25rem; }\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll; }\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto; }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem); }\n    .modal-dialog-scrollable .modal-content {\n      max-height: calc(100vh - 3.5rem); }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem); }\n    .modal-dialog-centered::before {\n      height: calc(100vh - 3.5rem); }\n  .modal-sm {\n    max-width: 300px; } }\n\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px; } }\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px; } }\n\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0; }\n  .tooltip.show {\n    opacity: 0.9; }\n  .tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: 0.8rem;\n    height: 0.4rem; }\n    .tooltip .arrow::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0; }\n  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n    bottom: 0; }\n    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n      top: 0;\n      border-width: 0.4rem 0.4rem 0;\n      border-top-color: #000; }\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem; }\n  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    width: 0.4rem;\n    height: 0.8rem; }\n    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n      right: 0;\n      border-width: 0.4rem 0.4rem 0.4rem 0;\n      border-right-color: #000; }\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0; }\n  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n    top: 0; }\n    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n      bottom: 0;\n      border-width: 0 0.4rem 0.4rem;\n      border-bottom-color: #000; }\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem; }\n  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    width: 0.4rem;\n    height: 0.8rem; }\n    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n      left: 0;\n      border-width: 0.4rem 0 0.4rem 0.4rem;\n      border-left-color: #000; }\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem; }\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem; }\n  .popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 0.3rem; }\n    .popover .arrow::before, .popover .arrow::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem; }\n  .bs-popover-top > .arrow, .bs-popover-auto[x-placement^=\"top\"] > .arrow {\n    bottom: calc((0.5rem + 1px) * -1); }\n    .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n      bottom: 0;\n      border-width: 0.5rem 0.5rem 0;\n      border-top-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n      bottom: 1px;\n      border-width: 0.5rem 0.5rem 0;\n      border-top-color: #fff; }\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem; }\n  .bs-popover-right > .arrow, .bs-popover-auto[x-placement^=\"right\"] > .arrow {\n    left: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0; }\n    .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n      left: 0;\n      border-width: 0.5rem 0.5rem 0.5rem 0;\n      border-right-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n      left: 1px;\n      border-width: 0.5rem 0.5rem 0.5rem 0;\n      border-right-color: #fff; }\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem; }\n  .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\n    top: calc((0.5rem + 1px) * -1); }\n    .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n      top: 0;\n      border-width: 0 0.5rem 0.5rem 0.5rem;\n      border-bottom-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n      top: 1px;\n      border-width: 0 0.5rem 0.5rem 0.5rem;\n      border-bottom-color: #fff; }\n  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -0.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7; }\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem; }\n  .bs-popover-left > .arrow, .bs-popover-auto[x-placement^=\"left\"] > .arrow {\n    right: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0; }\n    .bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n      right: 0;\n      border-width: 0.5rem 0 0.5rem 0.5rem;\n      border-left-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n      right: 1px;\n      border-width: 0.5rem 0 0.5rem 0.5rem;\n      border-left-color: #fff; }\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px); }\n  .popover-header:empty {\n    display: none; }\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529; }\n\n.carousel {\n  position: relative; }\n\n.carousel.pointer-event {\n  touch-action: pan-y; }\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden; }\n  .carousel-inner::after {\n    display: block;\n    clear: both;\n    content: \"\"; }\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .carousel-item {\n      transition: none; } }\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block; }\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%); }\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%); }\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none; }\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1; }\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: 0s 0.6s opacity; }\n  @media (prefers-reduced-motion: reduce) {\n    .carousel-fade .active.carousel-item-left,\n    .carousel-fade .active.carousel-item-right {\n      transition: none; } }\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .carousel-control-prev,\n    .carousel-control-next {\n      transition: none; } }\n  .carousel-control-prev:hover, .carousel-control-prev:focus,\n  .carousel-control-next:hover,\n  .carousel-control-next:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: 0.9; }\n\n.carousel-control-prev {\n  left: 0; }\n\n.carousel-control-next {\n  right: 0; }\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50% / 100% 100%; }\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\"); }\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\"); }\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none; }\n  .carousel-indicators li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #fff;\n    background-clip: padding-box;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    opacity: .5;\n    transition: opacity 0.6s ease; }\n    @media (prefers-reduced-motion: reduce) {\n      .carousel-indicators li {\n        transition: none; } }\n  .carousel-indicators .active {\n    opacity: 1; }\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center; }\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg); } }\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border .75s linear infinite; }\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em; }\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0); }\n  50% {\n    opacity: 1; } }\n\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow .75s linear infinite; }\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem; }\n\n.align-baseline {\n  vertical-align: baseline !important; }\n\n.align-top {\n  vertical-align: top !important; }\n\n.align-middle {\n  vertical-align: middle !important; }\n\n.align-bottom {\n  vertical-align: bottom !important; }\n\n.align-text-bottom {\n  vertical-align: text-bottom !important; }\n\n.align-text-top {\n  vertical-align: text-top !important; }\n\n.bg-primary {\n  background-color: #007bff !important; }\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #0062cc !important; }\n\n.bg-secondary {\n  background-color: #6c757d !important; }\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #545b62 !important; }\n\n.bg-success {\n  background-color: #28a745 !important; }\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #1e7e34 !important; }\n\n.bg-info {\n  background-color: #17a2b8 !important; }\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #117a8b !important; }\n\n.bg-warning {\n  background-color: #ffc107 !important; }\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #d39e00 !important; }\n\n.bg-danger {\n  background-color: #dc3545 !important; }\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #bd2130 !important; }\n\n.bg-light {\n  background-color: #f8f9fa !important; }\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #dae0e5 !important; }\n\n.bg-dark {\n  background-color: #343a40 !important; }\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #1d2124 !important; }\n\n.bg-header {\n  background-color: #331E36 !important; }\n\na.bg-header:hover, a.bg-header:focus,\nbutton.bg-header:hover,\nbutton.bg-header:focus {\n  background-color: #140c15 !important; }\n\n.bg-white {\n  background-color: #fff !important; }\n\n.bg-transparent {\n  background-color: transparent !important; }\n\n.border {\n  border: 1px solid #dee2e6 !important; }\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important; }\n\n.border-right {\n  border-right: 1px solid #dee2e6 !important; }\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important; }\n\n.border-left {\n  border-left: 1px solid #dee2e6 !important; }\n\n.border-0 {\n  border: 0 !important; }\n\n.border-top-0 {\n  border-top: 0 !important; }\n\n.border-right-0 {\n  border-right: 0 !important; }\n\n.border-bottom-0 {\n  border-bottom: 0 !important; }\n\n.border-left-0 {\n  border-left: 0 !important; }\n\n.border-primary {\n  border-color: #007bff !important; }\n\n.border-secondary {\n  border-color: #6c757d !important; }\n\n.border-success {\n  border-color: #28a745 !important; }\n\n.border-info {\n  border-color: #17a2b8 !important; }\n\n.border-warning {\n  border-color: #ffc107 !important; }\n\n.border-danger {\n  border-color: #dc3545 !important; }\n\n.border-light {\n  border-color: #f8f9fa !important; }\n\n.border-dark {\n  border-color: #343a40 !important; }\n\n.border-header {\n  border-color: #331E36 !important; }\n\n.border-white {\n  border-color: #fff !important; }\n\n.rounded-sm {\n  border-radius: 0.2rem !important; }\n\n.rounded {\n  border-radius: 0.25rem !important; }\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important; }\n\n.rounded-right {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important; }\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important; }\n\n.rounded-left {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important; }\n\n.rounded-lg {\n  border-radius: 0.3rem !important; }\n\n.rounded-circle {\n  border-radius: 50% !important; }\n\n.rounded-pill {\n  border-radius: 50rem !important; }\n\n.rounded-0 {\n  border-radius: 0 !important; }\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\"; }\n\n.d-none {\n  display: none !important; }\n\n.d-inline {\n  display: inline !important; }\n\n.d-inline-block {\n  display: inline-block !important; }\n\n.d-block {\n  display: block !important; }\n\n.d-table {\n  display: table !important; }\n\n.d-table-row {\n  display: table-row !important; }\n\n.d-table-cell {\n  display: table-cell !important; }\n\n.d-flex {\n  display: flex !important; }\n\n.d-inline-flex {\n  display: inline-flex !important; }\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important; }\n  .d-sm-inline {\n    display: inline !important; }\n  .d-sm-inline-block {\n    display: inline-block !important; }\n  .d-sm-block {\n    display: block !important; }\n  .d-sm-table {\n    display: table !important; }\n  .d-sm-table-row {\n    display: table-row !important; }\n  .d-sm-table-cell {\n    display: table-cell !important; }\n  .d-sm-flex {\n    display: flex !important; }\n  .d-sm-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important; }\n  .d-md-inline {\n    display: inline !important; }\n  .d-md-inline-block {\n    display: inline-block !important; }\n  .d-md-block {\n    display: block !important; }\n  .d-md-table {\n    display: table !important; }\n  .d-md-table-row {\n    display: table-row !important; }\n  .d-md-table-cell {\n    display: table-cell !important; }\n  .d-md-flex {\n    display: flex !important; }\n  .d-md-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important; }\n  .d-lg-inline {\n    display: inline !important; }\n  .d-lg-inline-block {\n    display: inline-block !important; }\n  .d-lg-block {\n    display: block !important; }\n  .d-lg-table {\n    display: table !important; }\n  .d-lg-table-row {\n    display: table-row !important; }\n  .d-lg-table-cell {\n    display: table-cell !important; }\n  .d-lg-flex {\n    display: flex !important; }\n  .d-lg-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important; }\n  .d-xl-inline {\n    display: inline !important; }\n  .d-xl-inline-block {\n    display: inline-block !important; }\n  .d-xl-block {\n    display: block !important; }\n  .d-xl-table {\n    display: table !important; }\n  .d-xl-table-row {\n    display: table-row !important; }\n  .d-xl-table-cell {\n    display: table-cell !important; }\n  .d-xl-flex {\n    display: flex !important; }\n  .d-xl-inline-flex {\n    display: inline-flex !important; } }\n\n@media print {\n  .d-print-none {\n    display: none !important; }\n  .d-print-inline {\n    display: inline !important; }\n  .d-print-inline-block {\n    display: inline-block !important; }\n  .d-print-block {\n    display: block !important; }\n  .d-print-table {\n    display: table !important; }\n  .d-print-table-row {\n    display: table-row !important; }\n  .d-print-table-cell {\n    display: table-cell !important; }\n  .d-print-flex {\n    display: flex !important; }\n  .d-print-inline-flex {\n    display: inline-flex !important; } }\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden; }\n  .embed-responsive::before {\n    display: block;\n    content: \"\"; }\n  .embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0; }\n\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%; }\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%; }\n\n.embed-responsive-4by3::before {\n  padding-top: 75%; }\n\n.embed-responsive-1by1::before {\n  padding-top: 100%; }\n\n.flex-row {\n  flex-direction: row !important; }\n\n.flex-column {\n  flex-direction: column !important; }\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important; }\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important; }\n\n.flex-wrap {\n  flex-wrap: wrap !important; }\n\n.flex-nowrap {\n  flex-wrap: nowrap !important; }\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important; }\n\n.flex-fill {\n  flex: 1 1 auto !important; }\n\n.flex-grow-0 {\n  flex-grow: 0 !important; }\n\n.flex-grow-1 {\n  flex-grow: 1 !important; }\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important; }\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important; }\n\n.justify-content-start {\n  justify-content: flex-start !important; }\n\n.justify-content-end {\n  justify-content: flex-end !important; }\n\n.justify-content-center {\n  justify-content: center !important; }\n\n.justify-content-between {\n  justify-content: space-between !important; }\n\n.justify-content-around {\n  justify-content: space-around !important; }\n\n.align-items-start {\n  align-items: flex-start !important; }\n\n.align-items-end {\n  align-items: flex-end !important; }\n\n.align-items-center {\n  align-items: center !important; }\n\n.align-items-baseline {\n  align-items: baseline !important; }\n\n.align-items-stretch {\n  align-items: stretch !important; }\n\n.align-content-start {\n  align-content: flex-start !important; }\n\n.align-content-end {\n  align-content: flex-end !important; }\n\n.align-content-center {\n  align-content: center !important; }\n\n.align-content-between {\n  align-content: space-between !important; }\n\n.align-content-around {\n  align-content: space-around !important; }\n\n.align-content-stretch {\n  align-content: stretch !important; }\n\n.align-self-auto {\n  align-self: auto !important; }\n\n.align-self-start {\n  align-self: flex-start !important; }\n\n.align-self-end {\n  align-self: flex-end !important; }\n\n.align-self-center {\n  align-self: center !important; }\n\n.align-self-baseline {\n  align-self: baseline !important; }\n\n.align-self-stretch {\n  align-self: stretch !important; }\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important; }\n  .flex-sm-column {\n    flex-direction: column !important; }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important; }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-sm-fill {\n    flex: 1 1 auto !important; }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-sm-start {\n    justify-content: flex-start !important; }\n  .justify-content-sm-end {\n    justify-content: flex-end !important; }\n  .justify-content-sm-center {\n    justify-content: center !important; }\n  .justify-content-sm-between {\n    justify-content: space-between !important; }\n  .justify-content-sm-around {\n    justify-content: space-around !important; }\n  .align-items-sm-start {\n    align-items: flex-start !important; }\n  .align-items-sm-end {\n    align-items: flex-end !important; }\n  .align-items-sm-center {\n    align-items: center !important; }\n  .align-items-sm-baseline {\n    align-items: baseline !important; }\n  .align-items-sm-stretch {\n    align-items: stretch !important; }\n  .align-content-sm-start {\n    align-content: flex-start !important; }\n  .align-content-sm-end {\n    align-content: flex-end !important; }\n  .align-content-sm-center {\n    align-content: center !important; }\n  .align-content-sm-between {\n    align-content: space-between !important; }\n  .align-content-sm-around {\n    align-content: space-around !important; }\n  .align-content-sm-stretch {\n    align-content: stretch !important; }\n  .align-self-sm-auto {\n    align-self: auto !important; }\n  .align-self-sm-start {\n    align-self: flex-start !important; }\n  .align-self-sm-end {\n    align-self: flex-end !important; }\n  .align-self-sm-center {\n    align-self: center !important; }\n  .align-self-sm-baseline {\n    align-self: baseline !important; }\n  .align-self-sm-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important; }\n  .flex-md-column {\n    flex-direction: column !important; }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-md-wrap {\n    flex-wrap: wrap !important; }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-md-fill {\n    flex: 1 1 auto !important; }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-md-start {\n    justify-content: flex-start !important; }\n  .justify-content-md-end {\n    justify-content: flex-end !important; }\n  .justify-content-md-center {\n    justify-content: center !important; }\n  .justify-content-md-between {\n    justify-content: space-between !important; }\n  .justify-content-md-around {\n    justify-content: space-around !important; }\n  .align-items-md-start {\n    align-items: flex-start !important; }\n  .align-items-md-end {\n    align-items: flex-end !important; }\n  .align-items-md-center {\n    align-items: center !important; }\n  .align-items-md-baseline {\n    align-items: baseline !important; }\n  .align-items-md-stretch {\n    align-items: stretch !important; }\n  .align-content-md-start {\n    align-content: flex-start !important; }\n  .align-content-md-end {\n    align-content: flex-end !important; }\n  .align-content-md-center {\n    align-content: center !important; }\n  .align-content-md-between {\n    align-content: space-between !important; }\n  .align-content-md-around {\n    align-content: space-around !important; }\n  .align-content-md-stretch {\n    align-content: stretch !important; }\n  .align-self-md-auto {\n    align-self: auto !important; }\n  .align-self-md-start {\n    align-self: flex-start !important; }\n  .align-self-md-end {\n    align-self: flex-end !important; }\n  .align-self-md-center {\n    align-self: center !important; }\n  .align-self-md-baseline {\n    align-self: baseline !important; }\n  .align-self-md-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important; }\n  .flex-lg-column {\n    flex-direction: column !important; }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important; }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-lg-fill {\n    flex: 1 1 auto !important; }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-lg-start {\n    justify-content: flex-start !important; }\n  .justify-content-lg-end {\n    justify-content: flex-end !important; }\n  .justify-content-lg-center {\n    justify-content: center !important; }\n  .justify-content-lg-between {\n    justify-content: space-between !important; }\n  .justify-content-lg-around {\n    justify-content: space-around !important; }\n  .align-items-lg-start {\n    align-items: flex-start !important; }\n  .align-items-lg-end {\n    align-items: flex-end !important; }\n  .align-items-lg-center {\n    align-items: center !important; }\n  .align-items-lg-baseline {\n    align-items: baseline !important; }\n  .align-items-lg-stretch {\n    align-items: stretch !important; }\n  .align-content-lg-start {\n    align-content: flex-start !important; }\n  .align-content-lg-end {\n    align-content: flex-end !important; }\n  .align-content-lg-center {\n    align-content: center !important; }\n  .align-content-lg-between {\n    align-content: space-between !important; }\n  .align-content-lg-around {\n    align-content: space-around !important; }\n  .align-content-lg-stretch {\n    align-content: stretch !important; }\n  .align-self-lg-auto {\n    align-self: auto !important; }\n  .align-self-lg-start {\n    align-self: flex-start !important; }\n  .align-self-lg-end {\n    align-self: flex-end !important; }\n  .align-self-lg-center {\n    align-self: center !important; }\n  .align-self-lg-baseline {\n    align-self: baseline !important; }\n  .align-self-lg-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important; }\n  .flex-xl-column {\n    flex-direction: column !important; }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important; }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-xl-fill {\n    flex: 1 1 auto !important; }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-xl-start {\n    justify-content: flex-start !important; }\n  .justify-content-xl-end {\n    justify-content: flex-end !important; }\n  .justify-content-xl-center {\n    justify-content: center !important; }\n  .justify-content-xl-between {\n    justify-content: space-between !important; }\n  .justify-content-xl-around {\n    justify-content: space-around !important; }\n  .align-items-xl-start {\n    align-items: flex-start !important; }\n  .align-items-xl-end {\n    align-items: flex-end !important; }\n  .align-items-xl-center {\n    align-items: center !important; }\n  .align-items-xl-baseline {\n    align-items: baseline !important; }\n  .align-items-xl-stretch {\n    align-items: stretch !important; }\n  .align-content-xl-start {\n    align-content: flex-start !important; }\n  .align-content-xl-end {\n    align-content: flex-end !important; }\n  .align-content-xl-center {\n    align-content: center !important; }\n  .align-content-xl-between {\n    align-content: space-between !important; }\n  .align-content-xl-around {\n    align-content: space-around !important; }\n  .align-content-xl-stretch {\n    align-content: stretch !important; }\n  .align-self-xl-auto {\n    align-self: auto !important; }\n  .align-self-xl-start {\n    align-self: flex-start !important; }\n  .align-self-xl-end {\n    align-self: flex-end !important; }\n  .align-self-xl-center {\n    align-self: center !important; }\n  .align-self-xl-baseline {\n    align-self: baseline !important; }\n  .align-self-xl-stretch {\n    align-self: stretch !important; } }\n\n.float-left {\n  float: left !important; }\n\n.float-right {\n  float: right !important; }\n\n.float-none {\n  float: none !important; }\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important; }\n  .float-sm-right {\n    float: right !important; }\n  .float-sm-none {\n    float: none !important; } }\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important; }\n  .float-md-right {\n    float: right !important; }\n  .float-md-none {\n    float: none !important; } }\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important; }\n  .float-lg-right {\n    float: right !important; }\n  .float-lg-none {\n    float: none !important; } }\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important; }\n  .float-xl-right {\n    float: right !important; }\n  .float-xl-none {\n    float: none !important; } }\n\n.overflow-auto {\n  overflow: auto !important; }\n\n.overflow-hidden {\n  overflow: hidden !important; }\n\n.position-static {\n  position: static !important; }\n\n.position-relative {\n  position: relative !important; }\n\n.position-absolute {\n  position: absolute !important; }\n\n.position-fixed {\n  position: fixed !important; }\n\n.position-sticky {\n  position: sticky !important; }\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030; }\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030; }\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020; } }\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal; }\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; }\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important; }\n\n.shadow-none {\n  box-shadow: none !important; }\n\n.w-25 {\n  width: 25% !important; }\n\n.w-50 {\n  width: 50% !important; }\n\n.w-75 {\n  width: 75% !important; }\n\n.w-100 {\n  width: 100% !important; }\n\n.w-auto {\n  width: auto !important; }\n\n.h-25 {\n  height: 25% !important; }\n\n.h-50 {\n  height: 50% !important; }\n\n.h-75 {\n  height: 75% !important; }\n\n.h-100 {\n  height: 100% !important; }\n\n.h-auto {\n  height: auto !important; }\n\n.mw-100 {\n  max-width: 100% !important; }\n\n.mh-100 {\n  max-height: 100% !important; }\n\n.min-vw-100 {\n  min-width: 100vw !important; }\n\n.min-vh-100 {\n  min-height: 100vh !important; }\n\n.vw-100 {\n  width: 100vw !important; }\n\n.vh-100 {\n  height: 100vh !important; }\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0); }\n\n.m-0 {\n  margin: 0 !important; }\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important; }\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important; }\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important; }\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important; }\n\n.m-1 {\n  margin: 0.25rem !important; }\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important; }\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important; }\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important; }\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important; }\n\n.m-2 {\n  margin: 0.5rem !important; }\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important; }\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important; }\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important; }\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important; }\n\n.m-3 {\n  margin: 1rem !important; }\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important; }\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important; }\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important; }\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important; }\n\n.m-4 {\n  margin: 1.5rem !important; }\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important; }\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important; }\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important; }\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important; }\n\n.m-5 {\n  margin: 3rem !important; }\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important; }\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important; }\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important; }\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important; }\n\n.p-0 {\n  padding: 0 !important; }\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important; }\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important; }\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important; }\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important; }\n\n.p-1 {\n  padding: 0.25rem !important; }\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important; }\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important; }\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important; }\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important; }\n\n.p-2 {\n  padding: 0.5rem !important; }\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important; }\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important; }\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important; }\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important; }\n\n.p-3 {\n  padding: 1rem !important; }\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important; }\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important; }\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important; }\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important; }\n\n.p-4 {\n  padding: 1.5rem !important; }\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important; }\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important; }\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important; }\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important; }\n\n.p-5 {\n  padding: 3rem !important; }\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important; }\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important; }\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important; }\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important; }\n\n.m-n1 {\n  margin: -0.25rem !important; }\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important; }\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important; }\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important; }\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important; }\n\n.m-n2 {\n  margin: -0.5rem !important; }\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important; }\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important; }\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important; }\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important; }\n\n.m-n3 {\n  margin: -1rem !important; }\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important; }\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important; }\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important; }\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important; }\n\n.m-n4 {\n  margin: -1.5rem !important; }\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important; }\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important; }\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important; }\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important; }\n\n.m-n5 {\n  margin: -3rem !important; }\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important; }\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important; }\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important; }\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important; }\n\n.m-auto {\n  margin: auto !important; }\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important; }\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important; }\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important; }\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important; }\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important; }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important; }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important; }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important; }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important; }\n  .m-sm-1 {\n    margin: 0.25rem !important; }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important; }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important; }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important; }\n  .m-sm-2 {\n    margin: 0.5rem !important; }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important; }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important; }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important; }\n  .m-sm-3 {\n    margin: 1rem !important; }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important; }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important; }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important; }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important; }\n  .m-sm-4 {\n    margin: 1.5rem !important; }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important; }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important; }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important; }\n  .m-sm-5 {\n    margin: 3rem !important; }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important; }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important; }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important; }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important; }\n  .p-sm-0 {\n    padding: 0 !important; }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important; }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important; }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important; }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important; }\n  .p-sm-1 {\n    padding: 0.25rem !important; }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important; }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important; }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important; }\n  .p-sm-2 {\n    padding: 0.5rem !important; }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important; }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important; }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important; }\n  .p-sm-3 {\n    padding: 1rem !important; }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important; }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important; }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important; }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important; }\n  .p-sm-4 {\n    padding: 1.5rem !important; }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important; }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important; }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important; }\n  .p-sm-5 {\n    padding: 3rem !important; }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important; }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important; }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important; }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important; }\n  .m-sm-n1 {\n    margin: -0.25rem !important; }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important; }\n  .m-sm-n2 {\n    margin: -0.5rem !important; }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important; }\n  .m-sm-n3 {\n    margin: -1rem !important; }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important; }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important; }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important; }\n  .m-sm-n4 {\n    margin: -1.5rem !important; }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important; }\n  .m-sm-n5 {\n    margin: -3rem !important; }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important; }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important; }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important; }\n  .m-sm-auto {\n    margin: auto !important; }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important; }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important; }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important; }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important; }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important; }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important; }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important; }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important; }\n  .m-md-1 {\n    margin: 0.25rem !important; }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important; }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important; }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important; }\n  .m-md-2 {\n    margin: 0.5rem !important; }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important; }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important; }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important; }\n  .m-md-3 {\n    margin: 1rem !important; }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important; }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important; }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important; }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important; }\n  .m-md-4 {\n    margin: 1.5rem !important; }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important; }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important; }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important; }\n  .m-md-5 {\n    margin: 3rem !important; }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important; }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important; }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important; }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important; }\n  .p-md-0 {\n    padding: 0 !important; }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important; }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important; }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important; }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important; }\n  .p-md-1 {\n    padding: 0.25rem !important; }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important; }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important; }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important; }\n  .p-md-2 {\n    padding: 0.5rem !important; }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important; }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important; }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important; }\n  .p-md-3 {\n    padding: 1rem !important; }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important; }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important; }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important; }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important; }\n  .p-md-4 {\n    padding: 1.5rem !important; }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important; }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important; }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important; }\n  .p-md-5 {\n    padding: 3rem !important; }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important; }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important; }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important; }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important; }\n  .m-md-n1 {\n    margin: -0.25rem !important; }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important; }\n  .m-md-n2 {\n    margin: -0.5rem !important; }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important; }\n  .m-md-n3 {\n    margin: -1rem !important; }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important; }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important; }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important; }\n  .m-md-n4 {\n    margin: -1.5rem !important; }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important; }\n  .m-md-n5 {\n    margin: -3rem !important; }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important; }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important; }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important; }\n  .m-md-auto {\n    margin: auto !important; }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important; }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important; }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important; }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important; }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important; }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important; }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important; }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important; }\n  .m-lg-1 {\n    margin: 0.25rem !important; }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important; }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important; }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important; }\n  .m-lg-2 {\n    margin: 0.5rem !important; }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important; }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important; }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important; }\n  .m-lg-3 {\n    margin: 1rem !important; }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important; }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important; }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important; }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important; }\n  .m-lg-4 {\n    margin: 1.5rem !important; }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important; }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important; }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important; }\n  .m-lg-5 {\n    margin: 3rem !important; }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important; }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important; }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important; }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important; }\n  .p-lg-0 {\n    padding: 0 !important; }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important; }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important; }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important; }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important; }\n  .p-lg-1 {\n    padding: 0.25rem !important; }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important; }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important; }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important; }\n  .p-lg-2 {\n    padding: 0.5rem !important; }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important; }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important; }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important; }\n  .p-lg-3 {\n    padding: 1rem !important; }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important; }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important; }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important; }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important; }\n  .p-lg-4 {\n    padding: 1.5rem !important; }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important; }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important; }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important; }\n  .p-lg-5 {\n    padding: 3rem !important; }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important; }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important; }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important; }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important; }\n  .m-lg-n1 {\n    margin: -0.25rem !important; }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important; }\n  .m-lg-n2 {\n    margin: -0.5rem !important; }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important; }\n  .m-lg-n3 {\n    margin: -1rem !important; }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important; }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important; }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important; }\n  .m-lg-n4 {\n    margin: -1.5rem !important; }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important; }\n  .m-lg-n5 {\n    margin: -3rem !important; }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important; }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important; }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important; }\n  .m-lg-auto {\n    margin: auto !important; }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important; }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important; }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important; }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important; }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important; }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important; }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important; }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important; }\n  .m-xl-1 {\n    margin: 0.25rem !important; }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important; }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important; }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important; }\n  .m-xl-2 {\n    margin: 0.5rem !important; }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important; }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important; }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important; }\n  .m-xl-3 {\n    margin: 1rem !important; }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important; }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important; }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important; }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important; }\n  .m-xl-4 {\n    margin: 1.5rem !important; }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important; }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important; }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important; }\n  .m-xl-5 {\n    margin: 3rem !important; }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important; }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important; }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important; }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important; }\n  .p-xl-0 {\n    padding: 0 !important; }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important; }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important; }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important; }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important; }\n  .p-xl-1 {\n    padding: 0.25rem !important; }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important; }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important; }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important; }\n  .p-xl-2 {\n    padding: 0.5rem !important; }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important; }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important; }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important; }\n  .p-xl-3 {\n    padding: 1rem !important; }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important; }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important; }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important; }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important; }\n  .p-xl-4 {\n    padding: 1.5rem !important; }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important; }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important; }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important; }\n  .p-xl-5 {\n    padding: 3rem !important; }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important; }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important; }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important; }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important; }\n  .m-xl-n1 {\n    margin: -0.25rem !important; }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important; }\n  .m-xl-n2 {\n    margin: -0.5rem !important; }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important; }\n  .m-xl-n3 {\n    margin: -1rem !important; }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important; }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important; }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important; }\n  .m-xl-n4 {\n    margin: -1.5rem !important; }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important; }\n  .m-xl-n5 {\n    margin: -3rem !important; }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important; }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important; }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important; }\n  .m-xl-auto {\n    margin: auto !important; }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important; }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important; }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important; }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important; } }\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important; }\n\n.text-justify {\n  text-align: justify !important; }\n\n.text-wrap {\n  white-space: normal !important; }\n\n.text-nowrap {\n  white-space: nowrap !important; }\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.text-left {\n  text-align: left !important; }\n\n.text-right {\n  text-align: right !important; }\n\n.text-center {\n  text-align: center !important; }\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important; }\n  .text-sm-right {\n    text-align: right !important; }\n  .text-sm-center {\n    text-align: center !important; } }\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important; }\n  .text-md-right {\n    text-align: right !important; }\n  .text-md-center {\n    text-align: center !important; } }\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important; }\n  .text-lg-right {\n    text-align: right !important; }\n  .text-lg-center {\n    text-align: center !important; } }\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important; }\n  .text-xl-right {\n    text-align: right !important; }\n  .text-xl-center {\n    text-align: center !important; } }\n\n.text-lowercase {\n  text-transform: lowercase !important; }\n\n.text-uppercase {\n  text-transform: uppercase !important; }\n\n.text-capitalize {\n  text-transform: capitalize !important; }\n\n.font-weight-light {\n  font-weight: 300 !important; }\n\n.font-weight-lighter {\n  font-weight: lighter !important; }\n\n.font-weight-normal {\n  font-weight: 400 !important; }\n\n.font-weight-bold {\n  font-weight: 700 !important; }\n\n.font-weight-bolder {\n  font-weight: bolder !important; }\n\n.font-italic {\n  font-style: italic !important; }\n\n.text-white {\n  color: #fff !important; }\n\n.text-primary {\n  color: #007bff !important; }\n\na.text-primary:hover, a.text-primary:focus {\n  color: #0056b3 !important; }\n\n.text-secondary {\n  color: #6c757d !important; }\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #494f54 !important; }\n\n.text-success {\n  color: #28a745 !important; }\n\na.text-success:hover, a.text-success:focus {\n  color: #19692c !important; }\n\n.text-info {\n  color: #17a2b8 !important; }\n\na.text-info:hover, a.text-info:focus {\n  color: #0f6674 !important; }\n\n.text-warning {\n  color: #ffc107 !important; }\n\na.text-warning:hover, a.text-warning:focus {\n  color: #ba8b00 !important; }\n\n.text-danger {\n  color: #dc3545 !important; }\n\na.text-danger:hover, a.text-danger:focus {\n  color: #a71d2a !important; }\n\n.text-light {\n  color: #f8f9fa !important; }\n\na.text-light:hover, a.text-light:focus {\n  color: #cbd3da !important; }\n\n.text-dark {\n  color: #343a40 !important; }\n\na.text-dark:hover, a.text-dark:focus {\n  color: #121416 !important; }\n\n.text-header {\n  color: #331E36 !important; }\n\na.text-header:hover, a.text-header:focus {\n  color: #050305 !important; }\n\n.text-body {\n  color: #212529 !important; }\n\n.text-muted {\n  color: #6c757d !important; }\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important; }\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important; }\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0; }\n\n.text-decoration-none {\n  text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important;\n  overflow-wrap: break-word !important; }\n\n.text-reset {\n  color: inherit !important; }\n\n.visible {\n  visibility: visible !important; }\n\n.invisible {\n  visibility: hidden !important; }\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important; }\n  a:not(.btn) {\n    text-decoration: underline; }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\"; }\n  pre {\n    white-space: pre-wrap !important; }\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid; }\n  thead {\n    display: table-header-group; }\n  tr,\n  img {\n    page-break-inside: avoid; }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3; }\n  h2,\n  h3 {\n    page-break-after: avoid; }\n  @page {\n    size: a3; }\n  body {\n    min-width: 992px !important; }\n  .container {\n    min-width: 992px !important; }\n  .navbar {\n    display: none; }\n  .badge {\n    border: 1px solid #000; }\n  .table {\n    border-collapse: collapse !important; }\n    .table td,\n    .table th {\n      background-color: #fff !important; }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6 !important; }\n  .table-dark {\n    color: inherit; }\n    .table-dark th,\n    .table-dark td,\n    .table-dark thead th,\n    .table-dark tbody + tbody {\n      border-color: #dee2e6; }\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #dee2e6; } }\n", ""]);

// exports


/***/ }),
/* 752 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthenticatedRoute_AuthenticatedRoute__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_AutoDismissAlert__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SignUp_SignUp__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SignIn_SignIn__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SignOut_SignOut__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangePassword_ChangePassword__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Home_Home__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DevPage__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Games_Games__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Players_Players__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Card_Card__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__About_About__ = __webpack_require__(1495);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__webpack_require__(1496);var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.setUser=function(user){return _this.setState({user:user});};_this.clearUser=function(){return _this.setState({user:null});};_this.msgAlert=function(_ref){var heading=_ref.heading,message=_ref.message,variant=_ref.variant;_this.setState({msgAlerts:[].concat(_toConsumableArray(_this.state.msgAlerts),[{heading:heading,message:message,variant:variant}])});};_this.state={user:null,msgAlerts:[]};return _this;}_createClass(App,[{key:'render',value:function render(){var _this2=this;var _state=this.state,msgAlerts=_state.msgAlerts,user=_state.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header_Header__["a" /* default */],{user:user}),msgAlerts.map(function(msgAlert,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_AutoDismissAlert__["a" /* default */],{key:index,heading:msgAlert.heading,variant:msgAlert.variant,message:msgAlert.message});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/dev',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DevPage__["a" /* default */],{msgAlert:_this2.msgAlert,setUser:_this2.setUser});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Home_Home__["a" /* default */],{msgAlert:_this2.msgAlert,setUser:_this2.setUser});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/sign-up',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SignUp_SignUp__["a" /* default */],{msgAlert:_this2.msgAlert,setUser:_this2.setUser});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/sign-in',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SignIn_SignIn__["a" /* default */],{msgAlert:_this2.msgAlert,setUser:_this2.setUser});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/card/:id',render:function render(_ref2){var match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Card_Card__["a" /* default */],{msgAlert:_this2.msgAlert,setUser:_this2.setUser,id:match.params.id});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/about',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__About_About__["a" /* default */],{msgAlert:_this2.msgAlert,setUser:_this2.setUser});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuthenticatedRoute_AuthenticatedRoute__["a" /* default */],{user:user,path:'/sign-out',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SignOut_SignOut__["a" /* default */],{msgAlert:_this2.msgAlert,clearUser:_this2.clearUser,user:user});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuthenticatedRoute_AuthenticatedRoute__["a" /* default */],{user:user,path:'/change-password',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ChangePassword_ChangePassword__["a" /* default */],{msgAlert:_this2.msgAlert,user:user});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuthenticatedRoute_AuthenticatedRoute__["a" /* default */],{user:user,path:'/games',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Games_Games__["a" /* default */],{msgAlert:_this2.msgAlert,user:user});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AuthenticatedRoute_AuthenticatedRoute__["a" /* default */],{user:user,path:'/players',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Players_Players__["a" /* default */],{msgAlert:_this2.msgAlert,user:user});}})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(228);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(758);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(228);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(764);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(229);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(361);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(768);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(770);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(365);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(772);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(229);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(774);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(230);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(365);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(230);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(778);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(363);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// props will include a `user` object or empty object
// props will include a `component` as `Component` or a `render`
// all other props that may be passed in are `..rest`
var AuthenticatedRoute=function AuthenticatedRoute(_ref){var user=_ref.user,Component=_ref.component,render=_ref.render,rest=_objectWithoutProperties(_ref,['user','component','render']);// if props include a `user` object and a `render` then create route with `render`
if(user&&render){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],Object.assign({},rest,{render:render}));// if props include a `user` object but no `render` then create route with `Component`
// if props do not include a `user` object then redirect to home
}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],Object.assign({},rest,{render:function render(props){return user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:'/'});}}));}};/* harmony default export */ __webpack_exports__["a"] = (AuthenticatedRoute);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Alert__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AutoDismissAlert_scss__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AutoDismissAlert_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AutoDismissAlert_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoDismissAlert=function(_React$Component){_inherits(AutoDismissAlert,_React$Component);function AutoDismissAlert(props){_classCallCheck(this,AutoDismissAlert);var _this=_possibleConstructorReturn(this,(AutoDismissAlert.__proto__||Object.getPrototypeOf(AutoDismissAlert)).call(this,props));_this.handleClose=function(){return _this.setState({show:false});};_this.state={show:true};return _this;}_createClass(AutoDismissAlert,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timer=setInterval(function(){_this2.setState({show:false});},5000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer);}},{key:'render',value:function render(){var _props=this.props,variant=_props.variant,heading=_props.heading,message=_props.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Alert___default.a,{dismissible:true,show:this.state.show,variant:variant,onClose:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Alert___default.a.Heading,null,heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'alert-body'},message)));}}]);return AutoDismissAlert;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutoDismissAlert);

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _hook = _interopRequireDefault(__webpack_require__(99));

var _useEventCallback = _interopRequireDefault(__webpack_require__(62));

var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(231));

var _divWithClassName = _interopRequireDefault(__webpack_require__(785));

var _ThemeProvider = __webpack_require__(33);

var _Fade = _interopRequireDefault(__webpack_require__(786));

var _CloseButton = _interopRequireDefault(__webpack_require__(795));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(235));

var defaultProps = {
  show: true,
  transition: _Fade.default,
  closeLabel: 'Close alert'
};
var controllables = {
  show: 'onClose'
};

var Alert = _react.default.forwardRef(function (uncontrolledProps, ref) {
  var _useControllable = (0, _hook.default)(uncontrolledProps, controllables),
      bsPrefix = _useControllable.bsPrefix,
      show = _useControllable.show,
      closeLabel = _useControllable.closeLabel,
      className = _useControllable.className,
      children = _useControllable.children,
      variant = _useControllable.variant,
      onClose = _useControllable.onClose,
      dismissible = _useControllable.dismissible,
      Transition = _useControllable.transition,
      props = (0, _objectWithoutPropertiesLoose2.default)(_useControllable, ["bsPrefix", "show", "closeLabel", "className", "children", "variant", "onClose", "dismissible", "transition"]);

  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'alert');
  var handleClose = (0, _useEventCallback.default)(function (e) {
    onClose(false, e);
  });

  var alert = _react.default.createElement("div", (0, _extends2.default)({
    role: "alert"
  }, Transition ? props : undefined, {
    className: (0, _classnames.default)(className, prefix, variant && prefix + "-" + variant, dismissible && prefix + "-dismissible")
  }), dismissible && _react.default.createElement(_CloseButton.default, {
    onClick: handleClose,
    label: closeLabel
  }), children);

  if (!Transition) return show ? alert : null;
  return _react.default.createElement(Transition, (0, _extends2.default)({
    unmountOnExit: true,
    ref: ref
  }, props, {
    in: show
  }), alert);
});

var DivStyledAsH4 = (0, _divWithClassName.default)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
Alert.Link = (0, _createWithBsPrefix.default)('alert-link', {
  Component: _SafeAnchor.default
});
Alert.Heading = (0, _createWithBsPrefix.default)('alert-heading', {
  Component: DivStyledAsH4
});
var _default = Alert;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.canAcceptRef = canAcceptRef;

var _invariant = _interopRequireDefault(__webpack_require__(56));

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(value);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ __webpack_exports__["a"] = (useCommittedRef);

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _default = function _default(className) {
  return _react.default.forwardRef(function (p, ref) {
    return _react.default.createElement("div", (0, _extends2.default)({}, p, {
      ref: ref,
      className: (0, _classnames.default)(p.className, className)
    }));
  });
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

var _interopRequireWildcard = __webpack_require__(46);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireWildcard(__webpack_require__(156));

var _end = _interopRequireDefault(__webpack_require__(118));

var _triggerBrowserReflow = _interopRequireDefault(__webpack_require__(367));

var _fadeStyles;

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'show', _fadeStyles[_Transition.ENTERED] = 'show', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Fade, _React$Component);

  function Fade() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (node) {
      (0, _triggerBrowserReflow.default)(node);
      if (_this.props.onEnter) _this.props.onEnter(node);
    };

    return _this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "children"]);
    return _react.default.createElement(_Transition.default, (0, _extends2.default)({
      addEndListener: _end.default
    }, props, {
      onEnter: this.handleEnter
    }), function (status, innerProps) {
      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
        className: (0, _classnames.default)('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(_react.default.Component);

Fade.defaultProps = defaultProps;
var _default = Fade;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(791));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(366));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var propTypes = {
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func
};
var defaultProps = {
  label: 'Close'
};

var CloseButton = _react.default.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      className = _ref.className,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["label", "onClick", "className"]);
  return _react.default.createElement("button", (0, _extends2.default)({
    ref: ref,
    type: "button",
    className: (0, _classnames.default)('close', className),
    onClick: onClick
  }, props), _react.default.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), _react.default.createElement("span", {
    className: "sr-only"
  }, label));
});

CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
var _default = CloseButton;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(797);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(360)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./AutoDismissAlert.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./AutoDismissAlert.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(359)(undefined);
// imports


// module
exports.push([module.i, ".alert {\n  align-items: center;\n  animation: .5s ease-in-out 0s 1 light-bounce-in;\n  bottom: 1rem;\n  display: flex;\n  left: 0;\n  margin: auto;\n  max-width: 30rem;\n  position: fixed;\n  right: 0;\n  z-index: 10000; }\n  .alert .alert-body {\n    margin-bottom: 0; }\n\n.close:active, .close:focus {\n  outline: none; }\n\n@keyframes light-bounce-in {\n  0% {\n    opacity: 0;\n    transform: translateY(20%); }\n  50% {\n    transform: translateY(-5%); }\n  100% {\n    opacity: 1;\n    transform: translateY(0%); } }\n", ""]);

// exports


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LTNT_Logo_Mythic_Icon_svg__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LTNT_Logo_Mythic_Icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LTNT_Logo_Mythic_Icon_svg__);
var authenticatedOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#games'},'Games'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#players'},'Players'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#change-password'},'Change Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#sign-out'},'Sign Out'));var unauthenticatedOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#sign-up'},'Sign Up'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#sign-in'},'Sign In'));var alwaysOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#/'},'Home'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a.Link,{href:'#/about'},'About'));var Header=function Header(_ref){var user=_ref.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar___default.a,{bg:'header',variant:'dark',expand:'md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar___default.a.Brand,{href:'#/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__LTNT_Logo_Mythic_Icon_svg___default.a,width:'45',height:'45'}),'Lieutenant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar___default.a.Toggle,{'aria-controls':'basic-navbar-nav'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar___default.a.Collapse,{id:'basic-navbar-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Nav___default.a,{className:'ml-auto'},user&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'navbar-text mr-2'},'Welcome, ',user.email),alwaysOptions,user?authenticatedOptions:unauthenticatedOptions)));};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _all = _interopRequireDefault(__webpack_require__(369));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _hook = _interopRequireDefault(__webpack_require__(99));

var _ThemeProvider = __webpack_require__(33);

var _NavbarContext = _interopRequireDefault(__webpack_require__(157));

var _CardContext = _interopRequireDefault(__webpack_require__(800));

var _AbstractNav = _interopRequireDefault(__webpack_require__(801));

var _NavItem = _interopRequireDefault(__webpack_require__(803));

var _NavLink = _interopRequireDefault(__webpack_require__(804));

var defaultProps = {
  justify: false,
  fill: false
};

var Nav = _react.default.forwardRef(function (uncontrolledProps, ref) {
  var _classNames;

  var _useUncontrolled = (0, _hook.default)(uncontrolledProps, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      bsPrefix = _useUncontrolled.bsPrefix,
      variant = _useUncontrolled.variant,
      fill = _useUncontrolled.fill,
      justify = _useUncontrolled.justify,
      navbar = _useUncontrolled.navbar,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      activeKey = _useUncontrolled.activeKey,
      props = (0, _objectWithoutPropertiesLoose2.default)(_useUncontrolled, ["as", "bsPrefix", "variant", "fill", "justify", "navbar", "className", "children", "activeKey"]);

  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'nav');
  var navbarBsPrefix, cardHeaderBsPrefix;
  var navbarContext = (0, _react.useContext)(_NavbarContext.default);
  var cardContext = (0, _react.useContext)(_CardContext.default);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    navbar = navbar == null ? true : navbar;
  } else if (cardContext) {
    cardHeaderBsPrefix = cardContext.cardHeaderBsPrefix;
  }

  return _react.default.createElement(_AbstractNav.default, (0, _extends2.default)({
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: (0, _classnames.default)(className, (_classNames = {}, _classNames[bsPrefix] = !navbar, _classNames[navbarBsPrefix + "-nav"] = navbar, _classNames[cardHeaderBsPrefix + "-" + variant] = !!cardHeaderBsPrefix, _classNames[bsPrefix + "-" + variant] = !!variant, _classNames[bsPrefix + "-fill"] = fill, _classNames[bsPrefix + "-justified"] = justify, _classNames))
  }, props), children);
});

Nav.displayName = 'Nav';
Nav.defaultProps = defaultProps;
Nav.Item = _NavItem.default;
Nav.Link = _NavLink.default;
Nav._Nav = Nav; // for Testing until enzyme is working with context

var _default = Nav;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = _react.default.createContext(null);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));

var _react = _interopRequireDefault(__webpack_require__(0));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(101));

var _mapContextToProps = _interopRequireDefault(__webpack_require__(370));

var _SelectableContext = _interopRequireWildcard(__webpack_require__(237));

var _NavContext = _interopRequireDefault(__webpack_require__(371));

var _TabContext = _interopRequireDefault(__webpack_require__(802));

var noop = function noop() {};

var AbstractNav =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(AbstractNav, _React$Component);

  function AbstractNav() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, event) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          parentOnSelect = _this$props.parentOnSelect;
      if (key == null) return;
      if (onSelect) onSelect(key, event);
      if (parentOnSelect) parentOnSelect(key, event);
    };

    _this.handleKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;
      if (onKeyDown) onKeyDown(event);
      var nextActiveChild;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          nextActiveChild = _this.getNextActiveChild(-1);
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          nextActiveChild = _this.getNextActiveChild(1);
          break;

        default:
          return;
      }

      if (!nextActiveChild) return;
      event.preventDefault();

      _this.handleSelect(nextActiveChild.dataset.rbEventKey, event);

      _this._needsRefocus = true;
    };

    _this.attachRef = function (ref) {
      _this.listNode = ref;
    };

    _this.state = {
      navContext: null
    };
    return _this;
  }

  AbstractNav.getDerivedStateFromProps = function getDerivedStateFromProps(_ref) {
    var activeKey = _ref.activeKey,
        getControlledId = _ref.getControlledId,
        getControllerId = _ref.getControllerId,
        role = _ref.role;
    return {
      navContext: {
        role: role,
        // used by NavLink to determine it's role
        activeKey: (0, _SelectableContext.makeEventKey)(activeKey),
        getControlledId: getControlledId || noop,
        getControllerId: getControllerId || noop
      }
    };
  };

  var _proto = AbstractNav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (!this._needsRefocus || !this.listNode) return;
    var activeChild = this.listNode.querySelector('[data-rb-event-key].active');
    if (activeChild) activeChild.focus();
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    if (!this.listNode) return null;
    var items = (0, _querySelectorAll.default)(this.listNode, '[data-rb-event-key]:not(.disabled)');
    var activeChild = this.listNode.querySelector('.active');
    var index = items.indexOf(activeChild);
    if (index === -1) return null;
    var nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$as = _this$props2.as,
        Component = _this$props2$as === void 0 ? 'ul' : _this$props2$as,
        _ = _this$props2.onSelect,
        _0 = _this$props2.parentOnSelect,
        _1 = _this$props2.getControlledId,
        _2 = _this$props2.getControllerId,
        _3 = _this$props2.activeKey,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["as", "onSelect", "parentOnSelect", "getControlledId", "getControllerId", "activeKey"]);

    if (props.role === 'tablist') {
      props.onKeyDown = this.handleKeyDown;
    }

    return _react.default.createElement(_SelectableContext.default.Provider, {
      value: this.handleSelect
    }, _react.default.createElement(_NavContext.default.Provider, {
      value: this.state.navContext
    }, _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      onKeyDown: this.handleKeyDown,
      ref: this.attachRef
    }))));
  };

  return AbstractNav;
}(_react.default.Component);

var _default = (0, _mapContextToProps.default)([_SelectableContext.default, _TabContext.default], function (parentOnSelect, tabContext, _ref2) {
  var role = _ref2.role;
  if (!tabContext) return {
    parentOnSelect: parentOnSelect
  };
  var activeKey = tabContext.activeKey,
      getControllerId = tabContext.getControllerId,
      getControlledId = tabContext.getControlledId;
  return {
    activeKey: activeKey,
    parentOnSelect: parentOnSelect,
    role: role || 'tablist',
    // pass these two through to avoid having to listen to
    // both Tab and Nav contexts in NavLink
    getControllerId: getControllerId,
    getControlledId: getControlledId
  };
}, AbstractNav);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var TabContext = _react.default.createContext(null);

var _default = TabContext;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var NavItem = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "children", "as"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'nav-item');
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix)
  }), children);
});

NavItem.displayName = 'NavItem';
var _default = NavItem;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _SafeAnchor = _interopRequireDefault(__webpack_require__(235));

var _AbstractNavItem = _interopRequireDefault(__webpack_require__(805));

var _ThemeProvider = __webpack_require__(33);

var defaultProps = {
  disabled: false,
  as: _SafeAnchor.default
};

var NavLink = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      disabled = _ref.disabled,
      className = _ref.className,
      href = _ref.href,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      as = _ref.as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "disabled", "className", "href", "eventKey", "onSelect", "as"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'nav-link');
  return _react.default.createElement(_AbstractNavItem.default, (0, _extends2.default)({}, props, {
    href: href,
    ref: ref,
    eventKey: eventKey,
    as: as,
    disabled: disabled,
    onSelect: onSelect,
    className: (0, _classnames.default)(className, bsPrefix, disabled && 'disabled')
  }));
});

NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
var _default = NavLink;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _useEventCallback = _interopRequireDefault(__webpack_require__(62));

var _NavContext = _interopRequireDefault(__webpack_require__(371));

var _SelectableContext = _interopRequireWildcard(__webpack_require__(237));

var defaultProps = {
  disabled: false
};

var AbstractNavItem = _react.default.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      className = _ref.className,
      tabIndex = _ref.tabIndex,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick,
      Component = _ref.as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["active", "className", "tabIndex", "eventKey", "onSelect", "onClick", "as"]);
  var navKey = (0, _SelectableContext.makeEventKey)(eventKey, props.href);
  var parentOnSelect = (0, _react.useContext)(_SelectableContext.default);
  var navContext = (0, _react.useContext)(_NavContext.default);
  var isActive = active;

  if (navContext) {
    if (!props.role && navContext.role === 'tablist') props.role = 'tab';
    props['data-rb-event-key'] = navKey;
    props.id = navContext.getControllerId(navKey);
    props['aria-controls'] = navContext.getControlledId(navKey);
    isActive = active == null && navKey != null ? navContext.activeKey === navKey : active;
  }

  if (props.role === 'tab') {
    props.tabIndex = isActive ? tabIndex : -1;
    props['aria-selected'] = isActive;
  }

  var handleOnclick = (0, _useEventCallback.default)(function (e) {
    if (onClick) onClick(e);
    if (navKey == null) return;
    if (onSelect) onSelect(navKey, e);
    if (parentOnSelect) parentOnSelect(navKey, e);
  });
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    onClick: handleOnclick,
    className: (0, _classnames.default)(className, isActive && 'active')
  }));
});

AbstractNavItem.defaultProps = defaultProps;
var _default = AbstractNavItem;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _uncontrollable = _interopRequireDefault(__webpack_require__(77));

var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(231));

var _NavbarBrand = _interopRequireDefault(__webpack_require__(808));

var _NavbarCollapse = _interopRequireDefault(__webpack_require__(809));

var _NavbarToggle = _interopRequireDefault(__webpack_require__(811));

var _ThemeProvider = __webpack_require__(33);

var _NavbarContext = _interopRequireDefault(__webpack_require__(157));

var _SelectableContext = _interopRequireDefault(__webpack_require__(237));

var defaultProps = {
  expand: true,
  variant: 'light',
  collapseOnSelect: false
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Navbar, _React$Component);

  function Navbar() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleCollapse = function () {
      var _this$props = _this.props,
          onToggle = _this$props.onToggle,
          expanded = _this$props.expanded,
          collapseOnSelect = _this$props.collapseOnSelect,
          onSelect = _this$props.onSelect;
      if (onSelect) onSelect.apply(void 0, arguments);

      if (collapseOnSelect && expanded) {
        onToggle(false);
      }
    };

    _this.handleToggle = function () {
      var _this$props2 = _this.props,
          onToggle = _this$props2.onToggle,
          expanded = _this$props2.expanded;
      onToggle(!expanded);
    };

    _this.state = {
      navbarContext: {
        onToggle: _this.handleToggle
      }
    };
    return _this;
  }

  Navbar.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var bsPrefix = _ref.bsPrefix,
        expanded = _ref.expanded;
    return {
      navbarContext: (0, _extends2.default)({}, prevState.navbarContext, {
        bsPrefix: bsPrefix,
        expanded: expanded
      })
    };
  };

  var _proto = Navbar.prototype;

  _proto.render = function render() {
    var _this$props3 = this.props,
        bsPrefix = _this$props3.bsPrefix,
        expand = _this$props3.expand,
        variant = _this$props3.variant,
        bg = _this$props3.bg,
        fixed = _this$props3.fixed,
        sticky = _this$props3.sticky,
        className = _this$props3.className,
        children = _this$props3.children,
        _this$props3$as = _this$props3.as,
        Component = _this$props3$as === void 0 ? 'nav' : _this$props3$as,
        _1 = _this$props3.expanded,
        _2 = _this$props3.onToggle,
        _3 = _this$props3.onSelect,
        _4 = _this$props3.collapseOnSelect,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props3, ["bsPrefix", "expand", "variant", "bg", "fixed", "sticky", "className", "children", "as", "expanded", "onToggle", "onSelect", "collapseOnSelect"]); // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one

    if (props.role === undefined && Component !== 'nav') {
      props.role = 'navigation';
    }

    var expandClass = bsPrefix + "-expand";
    if (typeof expand === 'string') expandClass = expandClass + "-" + expand;
    return _react.default.createElement(_NavbarContext.default.Provider, {
      value: this.state.navbarContext
    }, _react.default.createElement(_SelectableContext.default.Provider, {
      value: this.handleCollapse
    }, _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      className: (0, _classnames.default)(className, bsPrefix, expand && expandClass, variant && bsPrefix + "-" + variant, bg && "bg-" + bg, sticky && "sticky-" + sticky, fixed && "fixed-" + fixed)
    }), children)));
  };

  return Navbar;
}(_react.default.Component);

Navbar.defaultProps = defaultProps;
var DecoratedNavbar = (0, _ThemeProvider.createBootstrapComponent)((0, _uncontrollable.default)(Navbar, {
  expanded: 'onToggle'
}), 'navbar');
DecoratedNavbar.Brand = _NavbarBrand.default;
DecoratedNavbar.Toggle = _NavbarToggle.default;
DecoratedNavbar.Collapse = _NavbarCollapse.default;
DecoratedNavbar.Text = (0, _createWithBsPrefix.default)('navbar-text', {
  Component: 'span'
});
var _default = DecoratedNavbar;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useUncontrolled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(372);



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var defaultValue = result[__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* defaultKey */](fieldName)],
        propsValue = result[fieldName],
        rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(result, [__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* defaultKey */](fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];
    var prevProps = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])({});

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(defaultValue),
        stateValue = _useState[0],
        setState = _useState[1];

    var isProp = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* isProp */](props, fieldName);
    var wasProp = __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* isProp */](prevProps.current, fieldName);
    prevProps.current = props;
    /**
     * If a prop switches from controlled to Uncontrolled
     * reset its value to the defaultValue
     */

    if (!isProp && wasProp) {
      setState(defaultValue);
    }

    var propsHandler = props[handlerName];
    var handler = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function (value) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (propsHandler) propsHandler.apply(void 0, [value].concat(args));
      setState(value);
    }, [setState, propsHandler]);
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, (_extends2 = {}, _extends2[fieldName] = isProp ? propsValue : stateValue, _extends2[handlerName] = handler, _extends2));
  }, props);
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var NavbarBrand = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      as = _ref.as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "as"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
  var Component = as || (props.href ? 'a' : 'span');
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix)
  }));
});

NavbarBrand.displayName = 'NavbarBrand';
var _default = NavbarBrand;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Collapse = _interopRequireDefault(__webpack_require__(810));

var _ThemeProvider = __webpack_require__(33);

var _NavbarContext = _interopRequireDefault(__webpack_require__(157));

var NavbarCollapse = _react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "bsPrefix"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
  return _react.default.createElement(_NavbarContext.default.Consumer, null, function (context) {
    return _react.default.createElement(_Collapse.default, (0, _extends2.default)({
      in: !!(context && context.expanded)
    }, props), _react.default.createElement("div", {
      ref: ref,
      className: bsPrefix
    }, children));
  });
});

NavbarCollapse.displayName = 'NavbarCollapse';
var _default = NavbarCollapse;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

var _interopRequireWildcard = __webpack_require__(46);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(51));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _style = _interopRequireDefault(__webpack_require__(100));

var _react = _interopRequireDefault(__webpack_require__(0));

var _end = _interopRequireDefault(__webpack_require__(118));

var _Transition = _interopRequireWildcard(__webpack_require__(156));

var _triggerBrowserReflow = _interopRequireDefault(__webpack_require__(367));

var _createChainedFunction = _interopRequireDefault(__webpack_require__(368));

var _collapseStyles;

var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDimensionValue(dimension, elem) {
  var offset = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
  var value = elem[offset];
  var margins = MARGINS[dimension];
  return value + parseInt((0, _style.default)(elem, margins[0]), 10) + parseInt((0, _style.default)(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[_Transition.EXITED] = 'collapse', _collapseStyles[_Transition.EXITING] = 'collapsing', _collapseStyles[_Transition.ENTERING] = 'collapsing', _collapseStyles[_Transition.ENTERED] = 'collapse show', _collapseStyles);
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      (0, _triggerBrowserReflow.default)(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }
  /* -- Expanding -- */
  ;

  // for testing
  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    var scroll = "scroll" + dimension[0].toUpperCase() + dimension.slice(1);
    return elem[scroll] + "px";
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);
    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = (0, _createChainedFunction.default)(this.handleEnter, onEnter);
    var handleEntering = (0, _createChainedFunction.default)(this.handleEntering, onEntering);
    var handleEntered = (0, _createChainedFunction.default)(this.handleEntered, onEntered);
    var handleExit = (0, _createChainedFunction.default)(this.handleExit, onExit);
    var handleExiting = (0, _createChainedFunction.default)(this.handleExiting, onExiting);
    return _react.default.createElement(_Transition.default, (0, _extends2.default)({
      addEndListener: _end.default
    }, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
        className: (0, _classnames.default)(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(_react.default.Component);

Collapse.defaultProps = defaultProps;
var _default = Collapse;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _useEventCallback = _interopRequireDefault(__webpack_require__(62));

var _ThemeProvider = __webpack_require__(33);

var _NavbarContext = _interopRequireDefault(__webpack_require__(157));

var defaultProps = {
  label: 'Toggle navigation'
};

var NavbarToggle = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      onClick = _ref.onClick,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "children", "label", "as", "onClick"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');

  var _ref2 = (0, _react.useContext)(_NavbarContext.default) || {},
      onToggle = _ref2.onToggle,
      expanded = _ref2.expanded;

  var handleClick = (0, _useEventCallback.default)(function (e) {
    if (onClick) onClick(e);
    if (onToggle) onToggle();
  });

  if (Component === 'button') {
    props.type = 'button';
  }

  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    onClick: handleClick,
    "aria-label": label,
    className: (0, _classnames.default)(className, bsPrefix, !!expanded && 'collapsed')
  }), children || _react.default.createElement("span", {
    className: bsPrefix + "-icon"
  }));
});

NavbarToggle.displayName = 'NavbarToggle';
NavbarToggle.defaultProps = defaultProps;
var _default = NavbarToggle;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LTNT_Logo_Mythic_Icon.56a73ef7.svg";

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignUp=function(_Component){_inherits(SignUp,_Component);function SignUp(){_classCallCheck(this,SignUp);var _this=_possibleConstructorReturn(this,(SignUp.__proto__||Object.getPrototypeOf(SignUp)).call(this));_this.handleChange=function(event){return _this.setState(_defineProperty({},event.target.name,event.target.value));};_this.onSignUp=function(event){event.preventDefault();var _this$props=_this.props,msgAlert=_this$props.msgAlert,history=_this$props.history,setUser=_this$props.setUser;Object(__WEBPACK_IMPORTED_MODULE_2__api_auth__["d" /* signUp */])(_this.state).then(function(){return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth__["b" /* signIn */])(_this.state);}).then(function(res){return setUser(res.data.user);}).then(function(){return msgAlert({heading:'Sign Up Success',message:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].signUpSuccess,variant:'success'});}).then(function(){return history.push('/');}).catch(function(error){_this.setState({username:'',email:'',password:'',passwordConfirmation:''});msgAlert({heading:'Sign Up Failed with error: '+error.message,message:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].signUpFailure,variant:'danger'});});};_this.state={username:'',email:'',password:'',passwordConfirmation:''};return _this;}_createClass(SignUp,[{key:'render',value:function render(){var _state=this.state,username=_state.username,email=_state.email,password=_state.password,passwordConfirmation=_state.passwordConfirmation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10 col-md-8 mx-auto mt-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Sign Up'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a,{onSubmit:this.onSignUp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Email address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,type:'email',name:'email',value:email,placeholder:'Enter email',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Username'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,type:'text',name:'username',value:username,placeholder:'Enter username',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,name:'password',value:password,type:'password',placeholder:'Password',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'passwordConfirmation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Password Confirmation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,name:'passwordConfirmation',value:passwordConfirmation,type:'password',placeholder:'Confirm Password',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button___default.a,{variant:'primary',type:'submit'},'Submit'))));}}]);return SignUp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(SignUp));

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var apiUrl=void 0;var apiUrls={production:'https://lieutenant-mctripp.herokuapp.com/',development:'http://localhost:4741'};if(window.location.hostname==='localhost'){apiUrl=apiUrls.development;}else{apiUrl=apiUrls.production;}/* harmony default export */ __webpack_exports__["a"] = (apiUrl);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);
var bind = __webpack_require__(373);
var Axios = __webpack_require__(817);
var defaults = __webpack_require__(239);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(377);
axios.CancelToken = __webpack_require__(831);
axios.isCancel = __webpack_require__(376);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(832);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 816 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(239);
var utils = __webpack_require__(52);
var InterceptorManager = __webpack_require__(826);
var dispatchRequest = __webpack_require__(827);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(375);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);
var transformData = __webpack_require__(828);
var isCancel = __webpack_require__(376);
var defaults = __webpack_require__(239);
var isAbsoluteURL = __webpack_require__(829);
var combineURLs = __webpack_require__(830);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(52);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(377);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _FormContext = _interopRequireDefault(__webpack_require__(102));

var _ThemeProvider = __webpack_require__(33);

var FormGroup = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      controlId = _ref.controlId,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "children", "controlId", "as"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-group');
  var context = (0, _react.useMemo)(function () {
    return {
      controlId: controlId
    };
  }, [controlId]);
  return _react.default.createElement(_FormContext.default.Provider, {
    value: context
  }, _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix)
  }), children));
});

FormGroup.displayName = 'FormGroup';
var _default = FormGroup;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(38));

var _Feedback = _interopRequireDefault(__webpack_require__(378));

var _FormContext = _interopRequireDefault(__webpack_require__(102));

var _ThemeProvider = __webpack_require__(33);

var FormControl = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      type = _ref.type,
      size = _ref.size,
      id = _ref.id,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      plaintext = _ref.plaintext,
      readOnly = _ref.readOnly,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "type", "size", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "as"]);

  var _useContext = (0, _react.useContext)(_FormContext.default),
      controlId = _useContext.controlId;

  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-control');
  var classes;

  if (plaintext) {
    var _classes;

    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
  } else if (type === 'file') {
    var _classes2;

    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
  } else {
    var _classes3;

    classes = (_classes3 = {}, _classes3[bsPrefix] = true, _classes3[bsPrefix + "-" + size] = size, _classes3);
  }

   false ? (0, _warning.default)(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    type: type,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: (0, _classnames.default)(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
  }));
});

FormControl.displayName = 'FormControl';
FormControl.Feedback = _Feedback.default;
var _default = FormControl;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var _FormContext = _interopRequireDefault(__webpack_require__(102));

var _Feedback = _interopRequireDefault(__webpack_require__(378));

var _FormCheckInput = _interopRequireDefault(__webpack_require__(836));

var _FormCheckLabel = _interopRequireDefault(__webpack_require__(837));

var defaultProps = {
  type: 'checkbox',
  inline: false,
  disabled: false,
  isValid: false,
  isInvalid: false,
  title: ''
};

var FormCheck = _react.default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      disabled = _ref.disabled,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title,
      type = _ref.type,
      label = _ref.label,
      children = _ref.children,
      custom = _ref.custom,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "bsPrefix", "inline", "disabled", "isValid", "isInvalid", "feedback", "className", "style", "title", "type", "label", "children", "custom"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-check');

  var _useContext = (0, _react.useContext)(_FormContext.default),
      controlId = _useContext.controlId;

  var innerFormContext = (0, _react.useMemo)(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = label != null && label !== false && !children;

  var input = _react.default.createElement(_FormCheckInput.default, (0, _extends2.default)({}, props, {
    type: type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    isStatic: !hasLabel,
    disabled: disabled
  }));

  return _react.default.createElement(_FormContext.default.Provider, {
    value: innerFormContext
  }, _react.default.createElement("div", {
    style: style,
    className: (0, _classnames.default)(className, !custom && bsPrefix, custom && "custom-control custom-" + type, inline && (custom ? 'custom-control' : bsPrefix) + "-inline")
  }, children || _react.default.createElement(_react.default.Fragment, null, input, hasLabel && _react.default.createElement(_FormCheckLabel.default, {
    title: title
  }, label), (isValid || isInvalid) && _react.default.createElement(_Feedback.default, {
    type: isValid ? 'valid' : 'invalid'
  }, feedback))));
});

FormCheck.displayName = 'FormCheck';
FormCheck.defaultProps = defaultProps;
FormCheck.Input = _FormCheckInput.default;
FormCheck.Label = _FormCheckLabel.default;
var _default = FormCheck;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var _FormContext = _interopRequireDefault(__webpack_require__(102));

var defaultProps = {
  type: 'checkbox'
};

var FormCheckInput = _react.default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      isStatic = _ref.isStatic,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "bsPrefix", "className", "isValid", "isInvalid", "isStatic"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-input');

  var _useContext = (0, _react.useContext)(_FormContext.default),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  return _react.default.createElement("input", (0, _extends2.default)({}, props, {
    ref: ref,
    id: id || controlId,
    className: (0, _classnames.default)(className, !custom && bsPrefix, custom && 'custom-control-input', isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
  }));
});

FormCheckInput.displayName = 'FormCheckInput';
FormCheckInput.defaultProps = defaultProps;
var _default = FormCheckInput;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var _FormContext = _interopRequireDefault(__webpack_require__(102));

var defaultProps = {
  type: 'checkbox'
};

var FormCheckLabel = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "htmlFor"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-label');

  var _useContext = (0, _react.useContext)(_FormContext.default),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  return _react.default.createElement("label", (0, _extends2.default)({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: (0, _classnames.default)(className, !custom && bsPrefix, custom && 'custom-control-label')
  }));
});

FormCheckLabel.displayName = 'FormCheckLabel';
FormCheckLabel.defaultProps = defaultProps;
var _default = FormCheckLabel;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(46);

var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(38));

var _Col = _interopRequireDefault(__webpack_require__(839));

var _FormContext = _interopRequireDefault(__webpack_require__(102));

var _ThemeProvider = __webpack_require__(33);

var defaultProps = {
  column: false,
  srOnly: false
};

var FormLabel = _react.default.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      column = _ref.column,
      srOnly = _ref.srOnly,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "column", "srOnly", "className", "htmlFor"]);

  var _useContext = (0, _react.useContext)(_FormContext.default),
      controlId = _useContext.controlId;

  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-label');
  var classes = (0, _classnames.default)(className, bsPrefix, srOnly && 'sr-only', column && 'col-form-label');
   false ? (0, _warning.default)(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return _react.default.createElement(_Col.default, (0, _extends2.default)({
    as: "label",
    className: classes,
    htmlFor: htmlFor
  }, props));
  return (// eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    _react.default.createElement("label", (0, _extends2.default)({
      ref: ref,
      className: classes,
      htmlFor: htmlFor
    }, props))
  );
});

FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps;
var _default = FormLabel;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];

var Col = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "as"]);
  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span, offset, order;

    if (propValue != null && typeof propValue === 'object') {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (span != null) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
    if (order != null) classes.push("order" + infix + "-" + order);
    if (offset != null) classes.push("offset" + infix + "-" + offset);
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: _classnames.default.apply(void 0, [className].concat(spans, classes))
  }));
});

Col.displayName = 'Col';
var _default = Col;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(4));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _ThemeProvider = __webpack_require__(33);

var FormText = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'small' : _ref$as,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "as"]);
  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-text');
  return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix)
  }));
});

FormText.displayName = 'FormText';
var _default = FormText;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignIn=function(_Component){_inherits(SignIn,_Component);function SignIn(){_classCallCheck(this,SignIn);var _this=_possibleConstructorReturn(this,(SignIn.__proto__||Object.getPrototypeOf(SignIn)).call(this));_this.handleChange=function(event){return _this.setState(_defineProperty({},event.target.name,event.target.value));};_this.onSignIn=function(event){event.preventDefault();var _this$props=_this.props,msgAlert=_this$props.msgAlert,history=_this$props.history,setUser=_this$props.setUser;Object(__WEBPACK_IMPORTED_MODULE_2__api_auth__["b" /* signIn */])(_this.state).then(function(res){return setUser(res.data.user);}).then(function(){return msgAlert({heading:'Sign In Success',message:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].signInSuccess,variant:'success'});}).then(function(){return history.push('/');}).catch(function(error){_this.setState({email:'',password:''});msgAlert({heading:'Sign In Failed with error: '+error.message,message:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].signInFailure,variant:'danger'});});};_this.state={email:'',password:''};return _this;}_createClass(SignIn,[{key:'render',value:function render(){var _state=this.state,email=_state.email,password=_state.password;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10 col-md-8 mx-auto mt-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Sign In'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a,{onSubmit:this.onSignIn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,type:'email',name:'email',value:email,placeholder:'Enter email',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,name:'password',value:password,type:'password',placeholder:'Password',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button___default.a,{variant:'primary',type:'submit'},'Submit'))));}}]);return SignIn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(SignIn));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__ = __webpack_require__(159);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignOut=function(_Component){_inherits(SignOut,_Component);function SignOut(){_classCallCheck(this,SignOut);return _possibleConstructorReturn(this,(SignOut.__proto__||Object.getPrototypeOf(SignOut)).apply(this,arguments));}_createClass(SignOut,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,msgAlert=_props.msgAlert,history=_props.history,clearUser=_props.clearUser,user=_props.user;Object(__WEBPACK_IMPORTED_MODULE_2__api_auth__["c" /* signOut */])(user).finally(function(){return msgAlert({heading:'Signed Out Successfully',messagE:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].signOutSuccess,variant:'success'});}).finally(function(){return history.push('/');}).finally(function(){return clearUser();});}},{key:'render',value:function render(){return'';}}]);return SignOut;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(SignOut));

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangePassword=function(_Component){_inherits(ChangePassword,_Component);function ChangePassword(){_classCallCheck(this,ChangePassword);var _this=_possibleConstructorReturn(this,(ChangePassword.__proto__||Object.getPrototypeOf(ChangePassword)).call(this));_this.handleChange=function(event){return _this.setState(_defineProperty({},event.target.name,event.target.value));};_this.onChangePassword=function(event){event.preventDefault();var _this$props=_this.props,msgAlert=_this$props.msgAlert,history=_this$props.history,user=_this$props.user;Object(__WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* changePassword */])(_this.state,user).then(function(){return msgAlert({heading:'Change Password Success',message:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].changePasswordSuccess,variant:'success'});}).then(function(){return history.push('/');}).catch(function(error){_this.setState({oldPassword:'',newPassword:''});msgAlert({heading:'Change Password Failed with error: '+error.message,message:__WEBPACK_IMPORTED_MODULE_3__AutoDismissAlert_messages__["a" /* default */].changePasswordFailure,variant:'danger'});});};_this.state={oldPassword:'',newPassword:''};return _this;}_createClass(ChangePassword,[{key:'render',value:function render(){var _state=this.state,oldPassword=_state.oldPassword,newPassword=_state.newPassword;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10 col-md-8 mx-auto mt-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Change Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a,{onSubmit:this.onChangePassword},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'oldPassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'Old password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,name:'oldPassword',value:oldPassword,type:'password',placeholder:'Old Password',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Group,{controlId:'newPassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Label,null,'New Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form___default.a.Control,{required:true,name:'newPassword',value:newPassword,type:'password',placeholder:'New Password',onChange:this.handleChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Button___default.a,{variant:'primary',type:'submit'},'Submit'))));}}]);return ChangePassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(ChangePassword));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainSearch_MainSearch__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BG_Mythic_png__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BG_Mythic_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BG_Mythic_png__);
// import CardDisplay from './CardDisplay/CardDisplay'
// const mtg = require('mtgsdk')
// import { card } from 'mtgsdk'
// TODO move this styling to .scss -----------------------------<<<---<<<
var bgStyle={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3__BG_Mythic_png___default.a+')',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundSize:'80%'};var textBg={backgroundColor:'rgba(255, 255, 255, 0.5)',padding:'5px'};var space={height:'15vh',display:'flex',justifyContent:'center',alignItems:'center'};var Home=function Home(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Container */],{fluid:'lg',className:'justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Col */],{style:bgStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Row */],{style:space}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Row */],{className:'justify-content-md-center',style:textBg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Lieutenant for Magic: The Gathering EDH/Commander')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Ever wonder who in your EDH group is abusing ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/f9baef6e-a086-41d4-a20e-486f01d72406'},'Cyclonic Rift'),' the most, or mucking up everyone\u2019s mana with ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/0806adab-6a08-411b-b249-e1c58ade354b'},'Vorinclex, Voice of Hunger'),'? Want to see how many times ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/db149aaa-3da9-48c4-92cc-b3d804285290'},'Avacyn, Angel of Hope'),' has been exiled by ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/057d2410-30d3-4b7a-9dc3-f2512c1cf31c'},'Swords to Plowshares'),', or how many ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/ed666385-a2e7-4e1f-ad2c-babbfc0c50b3'},'5/5 Elementals'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/58f311e7-7ebf-4428-b5a3-154255eb3ba1'},'Omnath, Locus of Rage'),' has produced, along with the amount of face damage that they\u2019ve done?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Lieutenant is a relational database meant to provide players with useful and informative stats about their cards. Currently, it is only functional as a card query on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://scryfall.com/'},'Scryfall'),'\'s API for cards and tokens. I am currently working on filling out the database with sample data from games I play with my friends, as well as a mobile companion app for intuitive data collection. I plan on having multiple groups testing out the system once I get it up and running.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Row */],{style:space}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Row */],{className:'justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Row */],{className:'justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MainSearch_MainSearch__["a" /* default */],null))))));};// }
/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBarJSON__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBarJSON___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchBarJSON__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var cardOptions=Object.values(__WEBPACK_IMPORTED_MODULE_3__SearchBarJSON___default.a).map(function(card){return{key:card.index,value:card.name,text:card.name,id:card.scryfallId,as:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],to:'/card/'+card.scryfallId};});// Removes duplicates
var filteredCardOptions=cardOptions.filter(function(item,index,self){return index===self.findIndex(function(t){return t.text===item.text;});});var style={width:'50vh',fontSize:'2rem',border:'0.1rem solid grey'};var MainSearch=function MainSearch(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState2=_slicedToArray(_useState,2),query=_useState2[0],setQuery=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('Search for a card...'),_useState4=_slicedToArray(_useState3,2),value=_useState4[0],setValue=_useState4[1];var handleSearchChange=function handleSearchChange(event){setQuery(event.target.value);};var handleChange=function handleChange(event){setValue(event.target.innerText);};var handleBlur=function handleBlur(){setQuery('');setValue('Search for a card...');};var dynamicSearch=function dynamicSearch(){return filteredCardOptions.filter(function(card){return card.text.toLowerCase().includes(query.toLowerCase());}).sort(function(a,b){if(a.text>b.text){return 1;}if(b.text>a.text){return-1;}return 0;});};// <Link key={index} to={'card/' + item.text}>{item.text}</Link>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Dropdown */],{style:style,value:value,clearable:true,className:'icon',floating:true,onSearchChange:handleSearchChange,onChange:handleChange,options:query.length>2?dynamicSearch():[],onBlur:handleBlur,search:true,selection:true,text:value}));};/* harmony default export */ __webpack_exports__["a"] = (MainSearch);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);


/** Checks that the passed object is a valid React ref object. */
var isRefObject = function isRefObject(ref) {
  return (// https://github.com/facebook/react/blob/v16.8.2/packages/react-reconciler/src/ReactFiberCommitWork.js#L665
    ref !== null && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(ref) === 'object' && ref.hasOwnProperty('current')
  );
};

/* harmony default export */ __webpack_exports__["a"] = (isRefObject);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var nullRefObject = {
  current: null // A map of created ref objects to provide memoization.

};
var refObjects = new WeakMap();
/** Creates a React ref object from existing DOM node. */

var toRefObject = function toRefObject(node) {
  // A "null" is not valid key for a WeakMap
  if (node === null) {
    return nullRefObject;
  }

  if (refObjects.has(node)) {
    return refObjects.get(node);
  }

  var refObject = {
    current: node
  };
  refObjects.set(node, refObject);
  return refObject;
};

/* harmony default export */ __webpack_exports__["a"] = (toRefObject);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RefFindNode__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RefForward__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(160);







var Ref = function Ref(props) {
  var children = props.children,
      innerRef = props.innerRef;
  var child = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children);
  var ElementType = __WEBPACK_IMPORTED_MODULE_2_react_is__["isForwardRef"](child) ? __WEBPACK_IMPORTED_MODULE_4__RefForward__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__RefFindNode__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ElementType, {
    innerRef: innerRef
  }, child);
};

Ref.displayName = 'Ref'; // TODO: use Babel plugin for this

if (false) {
  Ref.propTypes = {
    children: PropTypes.element.isRequired,
    innerRef: refPropType.isRequired
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Ref);

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirm__ = __webpack_require__(852);
/* unused harmony reexport default */



/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_Button__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_Modal__ = __webpack_require__(457);















/**
 * A Confirm modal gives the user a choice to confirm or cancel an action/
 * @see Modal
 */

var Confirm =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Confirm, _Component);

  function Confirm() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Confirm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Confirm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCancel", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onCancel', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCancelOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);

          _this.handleCancel(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleConfirmOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onConfirm', e, _this.props);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Confirm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelButton = _this$props.cancelButton,
          confirmButton = _this$props.confirmButton,
          content = _this$props.content,
          header = _this$props.header,
          open = _this$props.open,
          size = _this$props.size;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getUnhandledProps */])(Confirm, this.props); // `open` is auto controlled by the Modal
      // It cannot be present (even undefined) with `defaultOpen`
      // only apply it if the user provided an open prop

      var openProp = {};
      if (__WEBPACK_IMPORTED_MODULE_8_lodash_has___default()(this.props, 'open')) openProp.open = open;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, openProp, {
        size: size,
        onClose: this.handleCancel
      }), __WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */].Header.create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */].Content.create(content, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modules_Modal__["a" /* default */].Actions, null, __WEBPACK_IMPORTED_MODULE_13__elements_Button__["a" /* default */].create(cancelButton, {
        autoGenerateKey: false,
        overrideProps: this.handleCancelOverrides
      }), __WEBPACK_IMPORTED_MODULE_13__elements_Button__["a" /* default */].create(confirmButton, {
        autoGenerateKey: false,
        defaultProps: {
          primary: true
        },
        overrideProps: this.handleConfirmOverrides
      })));
    }
  }]);

  return Confirm;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Confirm, "defaultProps", {
  cancelButton: 'Cancel',
  confirmButton: 'OK',
  content: 'Are you sure?',
  size: 'small'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Confirm, "handledProps", ["cancelButton", "confirmButton", "content", "header", "onCancel", "onConfirm", "open", "size"]);

Confirm.propTypes =  false ? {
  /** The cancel button text. */
  cancelButton: customPropTypes.itemShorthand,

  /** The OK button text. */
  confirmButton: customPropTypes.itemShorthand,

  /** The ModalContent text. */
  content: customPropTypes.itemShorthand,

  /** The ModalHeader text. */
  header: customPropTypes.itemShorthand,

  /**
   * Called when the Modal is closed without clicking confirm.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onCancel: PropTypes.func,

  /**
   * Called when the OK button is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onConfirm: PropTypes.func,

  /** Whether or not the modal is visible. */
  open: PropTypes.bool,

  /** A Confirm can vary in size */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen'])
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Confirm);

/***/ }),
/* 853 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 856 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(247);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(859),
    ListCache = __webpack_require__(162),
    Map = __webpack_require__(249);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(860),
    hashDelete = __webpack_require__(865),
    hashGet = __webpack_require__(866),
    hashHas = __webpack_require__(867),
    hashSet = __webpack_require__(868);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(161);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(79),
    isMasked = __webpack_require__(862),
    isObject = __webpack_require__(47),
    toSource = __webpack_require__(385);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(863);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(44);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 865 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(161);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(161);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(161);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(163);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(163);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(163);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(163);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(164);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(164);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(164);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(164);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(166),
    castPath = __webpack_require__(122),
    last = __webpack_require__(881),
    parent = __webpack_require__(882),
    toKey = __webpack_require__(91);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

module.exports = baseInvoke;


/***/ }),
/* 881 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(167),
    baseSlice = __webpack_require__(168);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(387),
    defineProperty = __webpack_require__(388),
    identity = __webpack_require__(65);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(92);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isLength = __webpack_require__(250),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(397);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(58);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(891),
    getMatchData = __webpack_require__(904),
    matchesStrictComparable = __webpack_require__(408);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(174),
    baseIsEqual = __webpack_require__(254);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(162);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 893 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 894 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 895 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(162),
    Map = __webpack_require__(249),
    MapCache = __webpack_require__(248);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(174),
    equalArrays = __webpack_require__(398),
    equalByTag = __webpack_require__(900),
    equalObjects = __webpack_require__(901),
    getTag = __webpack_require__(81),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(104),
    isTypedArray = __webpack_require__(128);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 899 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    Uint8Array = __webpack_require__(400),
    eq = __webpack_require__(123),
    equalArrays = __webpack_require__(398),
    mapToArray = __webpack_require__(401),
    setToArray = __webpack_require__(177);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(402);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90),
    root = __webpack_require__(44);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(90),
    root = __webpack_require__(44);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(407),
    keys = __webpack_require__(48);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(254),
    get = __webpack_require__(59),
    hasIn = __webpack_require__(409),
    isKey = __webpack_require__(246),
    isStrictComparable = __webpack_require__(407),
    matchesStrictComparable = __webpack_require__(408),
    toKey = __webpack_require__(91);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(410),
    basePropertyDeep = __webpack_require__(908),
    isKey = __webpack_require__(246),
    toKey = __webpack_require__(91);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(167);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(175),
    arrayIncludes = __webpack_require__(178),
    arrayIncludesWith = __webpack_require__(257),
    arrayMap = __webpack_require__(71),
    baseUnary = __webpack_require__(93),
    cacheHas = __webpack_require__(176);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 911 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(130);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_startsWith__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_intersection__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_each__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AutoControlledComponent__ = __webpack_require__(390);



















var ModernAutoControlledComponent =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ModernAutoControlledComponent, _Component);

  function ModernAutoControlledComponent() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ModernAutoControlledComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ModernAutoControlledComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    var _this$constructor = _this.constructor,
        autoControlledProps = _this$constructor.autoControlledProps,
        getAutoControlledStateFromProps = _this$constructor.getAutoControlledStateFromProps;
    var state = __WEBPACK_IMPORTED_MODULE_15_lodash_invoke___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), 'getInitialAutoControlledState', _this.props) || {};

    if (false) {
      var _this$constructor2 = _this.constructor,
          defaultProps = _this$constructor2.defaultProps,
          name = _this$constructor2.name,
          propTypes = _this$constructor2.propTypes,
          getDerivedStateFromProps = _this$constructor2.getDerivedStateFromProps; // require usage of getAutoControlledStateFromProps()

      if (getDerivedStateFromProps !== ModernAutoControlledComponent.getDerivedStateFromProps) {
        /* eslint-disable-next-line no-console */
        console.error("Auto controlled ".concat(name, " must specify a static getAutoControlledStateFromProps() instead of getDerivedStateFromProps()."));
      } // require propTypes


      _each(autoControlledProps, function (prop) {
        var defaultProp = getDefaultPropName(prop); // regular prop

        if (!_has(propTypes, defaultProp)) {
          console.error("".concat(name, " is missing \"").concat(defaultProp, "\" propTypes validation for auto controlled prop \"").concat(prop, "\"."));
        } // its default prop


        if (!_has(propTypes, prop)) {
          console.error("".concat(name, " is missing propTypes validation for auto controlled prop \"").concat(prop, "\"."));
        }
      }); // prevent autoControlledProps in defaultProps
      //
      // When setting state, auto controlled props values always win (so the parent can manage them).
      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
      // Auto controlled props also listed in defaultProps can never be updated.
      //
      // To set defaults for an AutoControlled prop, you can set the initial state in the
      // constructor or by using an ES7 property initializer:
      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers


      var illegalDefaults = _intersection(autoControlledProps, _keys(defaultProps));

      if (!_isEmpty(illegalDefaults)) {
        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', "See ".concat(name, " props: \"").concat(illegalDefaults, "\".")].join(' '));
      } // prevent listing defaultProps in autoControlledProps
      //
      // Default props are automatically handled.
      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.


      var illegalAutoControlled = _filter(autoControlledProps, function (prop) {
        return _startsWith(prop, 'default');
      });

      if (!_isEmpty(illegalAutoControlled)) {
        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', "See ".concat(name, " autoControlledProps: \"").concat(illegalAutoControlled, "\".")].join(' '));
      }
    } // Auto controlled props are copied to state.
    // Set initial state by copying auto controlled props to state.
    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
    // so we can set initial values from defaults.


    var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
      acc[prop] = Object(__WEBPACK_IMPORTED_MODULE_17__AutoControlledComponent__["b" /* getAutoControlledStateValue */])(prop, _this.props, state, true);

      if (false) {
        var defaultPropName = getDefaultPropName(prop);
        var _name = _this.constructor.name; // prevent defaultFoo={} along side foo={}

        if (!_isUndefined(_this.props[defaultPropName]) && !_isUndefined(_this.props[prop])) {
          console.error("".concat(_name, " prop \"").concat(prop, "\" is auto controlled. Specify either ").concat(defaultPropName, " or ").concat(prop, ", but not both."));
        }
      }

      return acc;
    }, {});
    _this.state = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, state, initialAutoControlledState, {
      autoControlledProps: autoControlledProps,
      getAutoControlledStateFromProps: getAutoControlledStateFromProps
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ModernAutoControlledComponent, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var autoControlledProps = state.autoControlledProps,
          getAutoControlledStateFromProps = state.getAutoControlledStateFromProps; // Solve the next state for autoControlledProps

      var newStateFromProps = autoControlledProps.reduce(function (acc, prop) {
        var isNextDefined = !__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(props[prop]); // if next is defined then use its value

        if (isNextDefined) acc[prop] = props[prop];
        return acc;
      }, {}); // Due to the inheritance of the AutoControlledComponent we should call its
      // getAutoControlledStateFromProps() and merge it with the existing state

      if (getAutoControlledStateFromProps) {
        var computedState = getAutoControlledStateFromProps(props, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, state, newStateFromProps)); // We should follow the idea of getDerivedStateFromProps() and return only modified state

        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, newStateFromProps, computedState);
      }

      return newStateFromProps;
    }
    /**
     * Override this method to use getDerivedStateFromProps() in child components.
     */

  }, {
    key: "getAutoControlledStateFromProps",
    value: function getAutoControlledStateFromProps() {
      return null;
    }
  }]);

  return ModernAutoControlledComponent;
}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);



/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeChildMappings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);







/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {object} children Element's children
 * @return {object} Mapping of key to child
 */

var getChildMapping = function getChildMapping(children) {
  return __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(__WEBPACK_IMPORTED_MODULE_6_react__["Children"].toArray(children), __WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"]), 'key');
};

var getPendingKeys = function getPendingKeys(prev, next) {
  var nextKeysPending = {};
  var pendingKeys = [];

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(prev), function (prevKey) {
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(next, prevKey)) {
      pendingKeys.push(prevKey);
      return;
    }

    if (pendingKeys.length) {
      nextKeysPending[prevKey] = pendingKeys;
      pendingKeys = [];
    }
  });

  return [nextKeysPending, pendingKeys];
};

var getValue = function getValue(key, prev, next) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(next, key) ? next[key] : prev[key];
};
/**
 * When you're adding or removing children some may be added or removed in the same render pass. We want to show *both*
 * since we want to simultaneously animate elements in and out. This function takes a previous set of keys and a new set
 * of keys and merges them with its best guess of the correct ordering.
 *
 * @param {object} prev Prev children as returned from `getChildMapping()`
 * @param {object} next Next children as returned from `getChildMapping()`
 * @return {object} A key set that contains all keys in `prev` and all keys in `next` in a reasonable order
 */


var mergeChildMappings = function mergeChildMappings() {
  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var childMapping = {};

  var _getPendingKeys = getPendingKeys(prev, next),
      _getPendingKeys2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_getPendingKeys, 2),
      nextKeysPending = _getPendingKeys2[0],
      pendingKeys = _getPendingKeys2[1];

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(next), function (nextKey) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(nextKeysPending, nextKey)) {
      __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(nextKeysPending[nextKey], function (pendingKey) {
        childMapping[pendingKey] = getValue(pendingKey, prev, next);
      });
    }

    childMapping[nextKey] = getValue(nextKey, prev, next);
  });

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(pendingKeys, function (pendingKey) {
    childMapping[pendingKey] = getValue(pendingKey, prev, next);
  });

  return childMapping;
};

/***/ }),
/* 915 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 916 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 917 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(132),
    createAggregator = __webpack_require__(919);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(920),
    baseAggregator = __webpack_require__(921),
    baseIteratee = __webpack_require__(49),
    isArray = __webpack_require__(26);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(92);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "someByType", function() { return someByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findByType", function() { return findByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return isNil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



/**
 * Determine if child by type exists in children.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {Boolean}
 */

var someByType = function someByType(children, type) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), {
    type: type
  });
};
/**
 * Find child by type.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {undefined|Object}
 */

var findByType = function findByType(children, type) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), {
    type: type
  });
};
/**
 * Tests if children are nil in React and Preact.
 * @param {Object} children The children prop of a component.
 * @returns {Boolean}
 */

var isNil = function isNil(children) {
  return children === null || children === undefined || Array.isArray(children) && children.length === 0;
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(49),
    isArrayLike = __webpack_require__(58),
    keys = __webpack_require__(48);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(92);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useKeyOrValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useMultipleProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useTextAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return useVerticalAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useWidthProp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberToWord__ = __webpack_require__(260);


/*
 * There are 3 prop patterns used to build up the className for a component.
 * Each utility here is meant for use in a classnames() argument.
 *
 * There is no util for valueOnly() because it would simply return val.
 * Use the prop value inline instead.
 *   <Label size='big' />
 *   <div class="ui big label"></div>
 */

/**
 * Props where only the prop key is used in the className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label tag />
 * <div class="ui tag label"></div>
 */

var useKeyOnly = function useKeyOnly(val, key) {
  return val && key;
};
/**
 * Props that require both a key and value to create a className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label corner='left' />
 * <div class="ui left corner label"></div>
 */

var useValueAndKey = function useValueAndKey(val, key) {
  return val && val !== true && "".concat(val, " ").concat(key);
};
/**
 * Props whose key will be used in className, or value and key.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example Key Only
 * <Label pointing />
 * <div class="ui pointing label"></div>
 *
 * @example Key and Value
 * <Label pointing='left' />
 * <div class="ui left pointing label"></div>
 */

var useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
  return val && (val === true ? key : "".concat(val, " ").concat(key));
}; //
// Prop to className exceptions
//

/**
 * The "multiple" prop implements control of visibility and reserved classes for Grid subcomponents.
 *
 * @param {*} val The value of the "multiple" prop
 * @param {*} key A props key
 *
 * @example
 * <Grid.Row only='mobile' />
 * <Grid.Row only='mobile tablet' />
 * <div class="mobile only row"></div>
 * <div class="mobile only tablet only row"></div>
 */

var useMultipleProp = function useMultipleProp(val, key) {
  if (!val || val === true) return null;
  return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (prop) {
    return "".concat(prop.replace('-', ' '), " ").concat(key);
  }).join(' ');
};
/**
 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
 * In this case, only the class "justified" is used, ignoring the "aligned" class.
 * @param {*} val The value of the "textAlign" prop
 *
 * @example
 * <Container textAlign='justified' />
 * <div class="ui justified container"></div>
 *
 * @example
 * <Container textAlign='left' />
 * <div class="ui left aligned container"></div>
 */

var useTextAlignProp = function useTextAlignProp(val) {
  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
};
/**
 * The "verticalAlign" prop follows the useValueAndKey.
 *
 * @param {*} val The value of the "verticalAlign" prop
 *
 * @example
 * <Grid verticalAlign='middle' />
 * <div class="ui middle aligned grid"></div>
 */

var useVerticalAlignProp = function useVerticalAlignProp(val) {
  return useValueAndKey(val, 'aligned');
};
/**
 * Create "X", "X wide" and "equal width" classNames.
 * "X" is a numberToWord value and "wide" is configurable.
 * @param {*} val The prop value
 * @param {string} [widthClass=''] The class
 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
 *
 * @example
 * <Grid columns='equal' />
 * <div class="ui equal width grid"></div>
 *
 * <Form widths='equal' />
 * <div class="ui equal width form"></div>
 *
 * <FieldGroup widths='equal' />
 * <div class="equal width fields"></div>
 *
 * @example
 * <Grid columns={4} />
 * <div class="ui four column grid"></div>
 */

var useWidthProp = function useWidthProp(val) {
  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (canEqual && val === 'equal') {
    return 'equal width';
  }

  var valType = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(val);

  if ((valType === 'string' || valType === 'number') && widthClass) {
    return "".concat(Object(__WEBPACK_IMPORTED_MODULE_1__numberToWord__["a" /* numberToWord */])(val), " ").concat(widthClass);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__numberToWord__["a" /* numberToWord */])(val);
};

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export domNode */
/* unused harmony export suggest */
/* unused harmony export disallow */
/* unused harmony export every */
/* unused harmony export some */
/* unused harmony export givenProps */
/* unused harmony export demand */
/* unused harmony export multipleProp */
/* unused harmony export contentShorthand */
/* unused harmony export itemShorthand */
/* unused harmony export collectionShorthand */
/* unused harmony export deprecate */
/* unused harmony export refObject */
/* unused harmony export ref */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_fp_min__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__leven__ = __webpack_require__(440);




















var typeOf = function typeOf() {
  var _Object$prototype$toS;

  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
};
/**
 * Ensure a prop is a valid DOM node.
 */


var domNode = function domNode(props, propName) {
  // skip if prop is undefined
  if (props[propName] === undefined) return; // skip if prop is valid

  if (props[propName] instanceof Element) return;
  return new Error("Invalid prop \"".concat(propName, "\" supplied, expected a DOM node."));
};
/**
 * Similar to PropTypes.oneOf but shows closest matches.
 * Word order is ignored allowing `left chevron` to match `chevron left`.
 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
 * @param {string[]} suggestions An array of allowed values.
 */

var suggest = function suggest(suggestions) {
  if (!Array.isArray(suggestions)) {
    throw new Error('Invalid argument supplied to suggest, expected an instance of array.');
  }
  /* eslint-disable max-nested-callbacks */


  var findBestSuggestions = __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize___default()(function (str) {
    var propValueWords = str.split(' ');
    return __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (suggestion) {
      var suggestionWords = suggestion.split(' ');

      var propValueScore = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (x) {
        return __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (y) {
          return Object(__WEBPACK_IMPORTED_MODULE_18__leven__["a" /* default */])(x, y);
        }, suggestionWords);
      }), __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default.a), __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default.a)(propValueWords);

      var suggestionScore = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (x) {
        return __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (y) {
          return Object(__WEBPACK_IMPORTED_MODULE_18__leven__["a" /* default */])(x, y);
        }, propValueWords);
      }), __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default.a), __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default.a)(suggestionWords);

      return {
        suggestion: suggestion,
        score: propValueScore + suggestionScore
      };
    }), __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy___default()(['score', 'suggestion']), __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take___default()(3))(suggestions);
  });
  /* eslint-enable max-nested-callbacks */
  // Convert the suggestions list into a hash map for O(n) lookup times. Ensure
  // the words in each key are sorted alphabetically so that we have a consistent
  // way of looking up a value in the map, i.e. we can sort the words in the
  // incoming propValue and look that up without having to check all permutations.


  var suggestionsLookup = suggestions.reduce(function (acc, key) {
    acc[key.split(' ').sort().join(' ')] = true;
    return acc;
  }, {});
  return function (props, propName, componentName) {
    var propValue = props[propName]; // skip if prop is undefined or is included in the suggestions

    if (!propValue || suggestionsLookup[propValue]) return; // check if the words were correct but ordered differently.
    // Since we're matching for classNames we need to allow any word order
    // to pass validation, e.g. `left chevron` vs `chevron left`.

    var propValueSorted = propValue.split(' ').sort().join(' ');
    if (suggestionsLookup[propValueSorted]) return; // find best suggestions

    var bestMatches = findBestSuggestions(propValue); // skip if a match scored 0

    if (bestMatches.some(function (x) {
      return x.score === 0;
    })) return;
    return new Error(["Invalid prop `".concat(propName, "` of value `").concat(propValue, "` supplied to `").concat(componentName, "`."), "\n\nInstead of `".concat(propValue, "`, did you mean:"), bestMatches.map(function (x) {
      return "\n  - ".concat(x.suggestion);
    }).join(''), '\n'].join(''));
  };
};
/**
 * Disallow other props from being defined with this prop.
 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
 */

var disallow = function disallow(disallowedProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(disallowedProps)) {
      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', " See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(''));
    } // skip if prop is undefined


    if (__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(props[propName]) || props[propName] === false) return; // find disallowed props with values

    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(props[disallowedProp]) && props[disallowedProp] !== false) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(acc), [disallowedProp]);
      }

      return acc;
    }, []);

    if (disallowed.length > 0) {
      return new Error(["Prop `".concat(propName, "` in `").concat(componentName, "` conflicts with props: `").concat(disallowed.join('`, `'), "`."), 'They cannot be defined together, choose one or the other.'].join(' '));
    }
  };
};
/**
 * Ensure a prop adherers to multiple prop type validators.
 * @param {function[]} validators An array of propType functions.
 */

var every = function every(validators) {
  return function (props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to every, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var errors = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (validator) {
      if (typeof validator !== 'function') {
        throw new Error("every() argument \"validators\" should contain functions, found: ".concat(typeOf(validator), "."));
      }

      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    }), __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default.a)(validators); // we can only return one error at a time


    return errors[0];
  };
};
/**
 * Ensure a prop adherers to at least one of the given prop type validators.
 * @param {function[]} validators An array of propType functions.
 */

var some = function some(validators) {
  return function (props, propName, componentName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var errors = __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(validators, function (validator) {
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction___default()(validator)) {
        throw new Error("some() argument \"validators\" should contain functions, found: ".concat(typeOf(validator), "."));
      }

      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    })); // fail only if all validators failed


    if (errors.length === validators.length) {
      var error = new Error('One of these validators must pass:');
      error.message += "\n".concat(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(errors, function (err, i) {
        return "[".concat(i + 1, "]: ").concat(err.message);
      }).join('\n'));
      return error;
    }
  };
};
/**
 * Ensure a validator passes only when a component has a given propsShape.
 * @param {object} propsShape An object describing the prop shape.
 * @param {function} validator A propType function.
 */

var givenProps = function givenProps(propsShape, validator) {
  return function (props, propName, componentName) {
    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    if (!__WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject___default()(propsShape)) {
      throw new Error(['Invalid argument supplied to givenProps, expected an object.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    if (typeof validator !== 'function') {
      throw new Error(['Invalid argument supplied to givenProps, expected a function.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var shouldValidate = __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(propsShape).every(function (key) {
      var val = propsShape[key]; // require propShape validators to pass or prop values to match

      return typeof val === 'function' ? !val.apply(void 0, [props, key, componentName].concat(rest)) : val === props[propName];
    });

    if (!shouldValidate) return;
    var error = validator.apply(void 0, [props, propName, componentName].concat(rest));

    if (error) {
      // poor mans shallow pretty print, prevents JSON circular reference errors
      var prettyProps = "{ ".concat(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(propsShape), props)).map(function (key) {
        var val = props[key];
        var renderedValue = val;
        if (typeof val === 'string') renderedValue = "\"".concat(val, "\"");else if (Array.isArray(val)) renderedValue = "[".concat(val.join(', '), "]");else if (__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default()(val)) renderedValue = '{...}';
        return "".concat(key, ": ").concat(renderedValue);
      }).join(', '), " }");
      error.message = "Given props ".concat(prettyProps, ": ").concat(error.message);
      return error;
    }
  };
};
/**
 * Define prop dependencies by requiring other props.
 * @param {string[]} requiredProps An array of required prop names.
 */

var demand = function demand(requiredProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(requiredProps)) {
      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', " See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(''));
    } // skip if prop is undefined


    if (props[propName] === undefined) return;
    var missingRequired = requiredProps.filter(function (requiredProp) {
      return props[requiredProp] === undefined;
    });

    if (missingRequired.length > 0) {
      return new Error("`".concat(propName, "` prop in `").concat(componentName, "` requires props: `").concat(missingRequired.join('`, `'), "`."));
    }
  };
};
/**
 * Ensure an multiple prop contains a string with only possible values.
 * @param {string[]} possible An array of possible values to prop.
 */

var multipleProp = function multipleProp(possible) {
  return function (props, propName, componentName) {
    if (!Array.isArray(possible)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    }

    var propValue = props[propName]; // skip if prop is undefined

    if (__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(propValue) || propValue === false) return;
    var values = propValue.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (val) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim___default()(val).replace('-', ' ');
    });

    var invalid = __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference___default()(values, possible); // fail only if there are invalid values


    if (invalid.length > 0) {
      return new Error("`".concat(propName, "` prop in `").concat(componentName, "` has invalid values: `").concat(invalid.join('`, `'), "`."));
    }
  };
};
/**
 * Ensure a component can render as a node passed as a prop value in place of children.
 */

var contentShorthand = function contentShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node]).apply(void 0, arguments);
};
/**
 * Item shorthand is a description of a component that can be a literal,
 * a props object, or an element.
 */

var itemShorthand = function itemShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object]))])]).apply(void 0, arguments);
};
/**
 * Collection shorthand ensures a prop is an array of item shorthand.
 */

var collectionShorthand = function collectionShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.arrayOf(itemShorthand)]).apply(void 0, arguments);
};
/**
 * Show a deprecated warning for component props with a help message and optional validator.
 * @param {string} help A help message to display with the deprecation warning.
 * @param {function} [validator] A propType function.
 */

var deprecate = function deprecate(help, validator) {
  return function (props, propName, componentName) {
    if (typeof help !== 'string') {
      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
    } // skip if prop is undefined


    if (props[propName] === undefined) return; // deprecation error and help

    var error = new Error("The `".concat(propName, "` prop in `").concat(componentName, "` is deprecated."));
    if (help) error.message += " ".concat(help); // add optional validation error message

    if (validator) {
      if (typeof validator === 'function') {
        for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
          args[_key4 - 3] = arguments[_key4];
        }

        var validationError = validator.apply(void 0, [props, propName, componentName].concat(args));

        if (validationError) {
          error.message = "".concat(error.message, " ").concat(validationError.message);
        }
      } else {
        throw new Error(['Invalid argument supplied to deprecate, expected a function.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
      }
    }

    return error;
  };
};
/** A checker that matches the React.RefObject type. */

var refObject = __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.shape({
  current: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object
});
/** A checker that matches the React.Ref type. */

var ref = __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func, refObject]);

/***/ }),
/* 927 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 928 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 929 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('difference', __webpack_require__(270));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(932),
    fallbackHolder = __webpack_require__(28);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 932 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(934),
  'assign': __webpack_require__(426),
  'clone': __webpack_require__(947),
  'curry': __webpack_require__(962),
  'forEach': __webpack_require__(131),
  'isArray': __webpack_require__(26),
  'isError': __webpack_require__(963),
  'isFunction': __webpack_require__(79),
  'isWeakMap': __webpack_require__(964),
  'iteratee': __webpack_require__(965),
  'keys': __webpack_require__(172),
  'rearg': __webpack_require__(966),
  'toInteger': __webpack_require__(72),
  'toPath': __webpack_require__(969)
};


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(180);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(181),
    root = __webpack_require__(44);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(166),
    createCtor = __webpack_require__(181),
    createHybrid = __webpack_require__(418),
    createRecurry = __webpack_require__(421),
    getHolder = __webpack_require__(266),
    replaceHolders = __webpack_require__(182),
    root = __webpack_require__(44);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 937 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(261),
    LodashWrapper = __webpack_require__(265),
    baseLodash = __webpack_require__(262),
    isArray = __webpack_require__(26),
    isObjectLike = __webpack_require__(41),
    wrapperClone = __webpack_require__(940);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(261),
    LodashWrapper = __webpack_require__(265),
    copyArray = __webpack_require__(107);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 941 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 942 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(131),
    arrayIncludes = __webpack_require__(178);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(107),
    isIndex = __webpack_require__(125);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(166),
    createCtor = __webpack_require__(181),
    root = __webpack_require__(44);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(419),
    composeArgsRight = __webpack_require__(420),
    replaceHolders = __webpack_require__(182);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(427);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(134),
    keysIn = __webpack_require__(183);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47),
    isPrototype = __webpack_require__(173),
    nativeKeysIn = __webpack_require__(950);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(134),
    getSymbols = __webpack_require__(256);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(134),
    getSymbolsIn = __webpack_require__(429);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(268),
    cloneDataView = __webpack_require__(955),
    cloneRegExp = __webpack_require__(956),
    cloneSymbol = __webpack_require__(957),
    cloneTypedArray = __webpack_require__(431);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(268);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(959),
    baseUnary = __webpack_require__(93),
    nodeUtil = __webpack_require__(171);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(81),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(961),
    baseUnary = __webpack_require__(93),
    nodeUtil = __webpack_require__(171);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(81),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(180);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObjectLike = __webpack_require__(41),
    isPlainObject = __webpack_require__(135);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(81),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(427),
    baseIteratee = __webpack_require__(49);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(180),
    flatRest = __webpack_require__(269);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(136);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    isArguments = __webpack_require__(124),
    isArray = __webpack_require__(26);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71),
    copyArray = __webpack_require__(107),
    isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(88),
    stringToPath = __webpack_require__(384),
    toKey = __webpack_require__(91),
    toString = __webpack_require__(64);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('trim', __webpack_require__(971));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(165),
    castSlice = __webpack_require__(271),
    charsEndIndex = __webpack_require__(972),
    charsStartIndex = __webpack_require__(973),
    stringToArray = __webpack_require__(185),
    toString = __webpack_require__(64);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(179);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(179);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 974 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 975 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('isObject', __webpack_require__(47), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('pick', __webpack_require__(187));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(434),
    hasIn = __webpack_require__(409);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('keys', __webpack_require__(48), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('isPlainObject', __webpack_require__(135), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('isFunction', __webpack_require__(79), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('compact', __webpack_require__(436), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('isNil', __webpack_require__(31), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('take', __webpack_require__(985));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(168),
    toInteger = __webpack_require__(72);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('sortBy', __webpack_require__(987));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(136),
    baseOrderBy = __webpack_require__(988),
    baseRest = __webpack_require__(80),
    isIterateeCall = __webpack_require__(106);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71),
    baseIteratee = __webpack_require__(49),
    baseMap = __webpack_require__(437),
    baseSortBy = __webpack_require__(989),
    baseUnary = __webpack_require__(93),
    compareMultiple = __webpack_require__(990),
    identity = __webpack_require__(65);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 989 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(991);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(88);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('sum', __webpack_require__(993), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var baseSum = __webpack_require__(994),
    identity = __webpack_require__(65);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),
/* 994 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('min', __webpack_require__(996), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(997),
    baseLt = __webpack_require__(998),
    identity = __webpack_require__(65);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(88);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(1000);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(265),
    flatRest = __webpack_require__(269),
    getData = __webpack_require__(263),
    getFuncName = __webpack_require__(423),
    isArray = __webpack_require__(26),
    isLaziable = __webpack_require__(422);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('memoize', __webpack_require__(247));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__["instance"]);

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var env=__webpack_require__(1004);__webpack_require__(1);var React=__webpack_require__(0);function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function _createClass(e,t,n){return t&&_defineProperties(e.prototype,t),n&&_defineProperties(e,n),e}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _possibleConstructorReturn(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?_assertThisInitialized(e):t}var EventSet=function(){function e(t){_classCallCheck(this,e),_defineProperty(this,"handlers",void 0),this.handlers=t.slice(0)}return _createClass(e,[{key:"addHandlers",value:function(t){for(var n=this.handlers.slice(0),r=t.length,o=0;o<r;o+=1)n.push(t[o]);return new e(n)}},{key:"dispatchEvent",value:function(e,t){var n=this.handlers.length-1;if(t){for(var r=n;r>=0;r-=1)this.handlers[r].called||(this.handlers[r].called=!0,this.handlers[r](e));for(var o=n;o>=0;o-=1)this.handlers[o].called=!1}else{(0,this.handlers[n])(e)}}},{key:"hasHandlers",value:function(){return this.handlers.length>0}},{key:"removeHandlers",value:function(t){for(var n=[],r=this.handlers.length,o=0;o<r;o+=1){var a=this.handlers[o];-1===t.indexOf(a)&&n.push(a)}return new e(n)}}]),e}();function cloneMap(e){var t=new Map;return e.forEach(function(e,n){t.set(n,e)}),t}function normalizeHandlers(e){return Array.isArray(e)?e:[e]}var isRefObject=function(e){return null!==e&&"object"===_typeof(e)&&e.hasOwnProperty("current")};function normalizeTarget(e){return"document"===e?document:"window"===e?window:isRefObject(e)?e.current||document:e||document}var EventPool=function(){function e(t,n){_classCallCheck(this,e),_defineProperty(this,"handlerSets",void 0),_defineProperty(this,"poolName",void 0),this.handlerSets=n,this.poolName=t}return _createClass(e,[{key:"addHandlers",value:function(t,n){var r=cloneMap(this.handlerSets);if(r.has(t)){var o=r.get(t);r.set(t,o.addHandlers(n))}else r.set(t,new EventSet(n));return new e(this.poolName,r)}},{key:"dispatchEvent",value:function(e,t){var n=this.handlerSets.get(e),r="default"===this.poolName;n&&n.dispatchEvent(t,r)}},{key:"hasHandlers",value:function(e){if(!e)return this.handlerSets.size>0;var t=this.handlerSets.get(e);return!!t&&t.hasHandlers()}},{key:"removeHandlers",value:function(t,n){var r=cloneMap(this.handlerSets);if(!r.has(t))return new e(this.poolName,r);var o=r.get(t).removeHandlers(n);return o.hasHandlers()?r.set(t,o):r.delete(t),new e(this.poolName,r)}}]),e}();_defineProperty(EventPool,"createByType",function(e,t,n){var r=new Map;return r.set(t,new EventSet(n)),new EventPool(e,r)});var EventTarget=function(){function e(t){var n=this;_classCallCheck(this,e),_defineProperty(this,"handlers",new Map),_defineProperty(this,"pools",new Map),_defineProperty(this,"target",void 0),_defineProperty(this,"createEmitter",function(e){return function(t){n.pools.forEach(function(n){n.dispatchEvent(e,t)})}}),this.target=t}return _createClass(e,[{key:"addHandlers",value:function(e,t,n){if(this.pools.has(e)){var r=this.pools.get(e);this.pools.set(e,r.addHandlers(t,n))}else this.pools.set(e,EventPool.createByType(e,t,n));this.handlers.has(t)||this.addTargetHandler(t)}},{key:"hasHandlers",value:function(){return this.handlers.size>0}},{key:"removeHandlers",value:function(e,t,n){if(this.pools.has(e)){var r=this.pools.get(e).removeHandlers(t,n);r.hasHandlers()?this.pools.set(e,r):this.pools.delete(e);var o=!1;this.pools.forEach(function(e){return o=o||e.hasHandlers(t)}),o||this.removeTargetHandler(t)}}},{key:"addTargetHandler",value:function(e){var t=this.createEmitter(e);this.handlers.set(e,t),this.target.addEventListener(e,t,!0)}},{key:"removeTargetHandler",value:function(e){this.handlers.has(e)&&(this.target.removeEventListener(e,this.handlers.get(e),!0),this.handlers.delete(e))}}]),e}(),EventStack=function(){function e(){var t=this;_classCallCheck(this,e),_defineProperty(this,"targets",new Map),_defineProperty(this,"getTarget",function(e){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],r=normalizeTarget(e);if(t.targets.has(r))return t.targets.get(r);if(!n)return null;var o=new EventTarget(r);return t.targets.set(r,o),o}),_defineProperty(this,"removeTarget",function(e){t.targets.delete(normalizeTarget(e))})}return _createClass(e,[{key:"sub",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(env.canUseDOM){var r=n.target,o=void 0===r?document:r,a=n.pool,s=void 0===a?"default":a;this.getTarget(o).addHandlers(s,e,normalizeHandlers(t))}}},{key:"unsub",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(env.canUseDOM){var r=n.target,o=void 0===r?document:r,a=n.pool,s=void 0===a?"default":a,i=this.getTarget(o,!1);i&&(i.removeHandlers(s,e,normalizeHandlers(t)),i.hasHandlers()||this.removeTarget(o))}}}]),e}(),instance=new EventStack,EventStack$1=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.PureComponent),_createClass(t,[{key:"componentDidMount",value:function(){this.subscribe(this.props)}},{key:"componentDidUpdate",value:function(e){this.unsubscribe(e),this.subscribe(this.props)}},{key:"componentWillUnmount",value:function(){this.unsubscribe(this.props)}},{key:"subscribe",value:function(e){var t=e.name,n=e.on,r=e.pool,o=e.target;instance.sub(t,n,{pool:r,target:o})}},{key:"unsubscribe",value:function(e){var t=e.name,n=e.on,r=e.pool,o=e.target;instance.unsub(t,n,{pool:r,target:o})}},{key:"render",value:function(){return null}}]),t}();_defineProperty(EventStack$1,"defaultProps",{pool:"default",target:"document"}),EventStack$1.propTypes={},exports.instance=instance,exports.default=EventStack$1;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = createShorthand;
/* harmony export (immutable) */ __webpack_exports__["h"] = createShorthandFactory;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createHTMLDivision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHTMLIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createHTMLImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createHTMLInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createHTMLLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createHTMLParagraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);











 // ============================================================
// Factories
// ============================================================

/**
 * A more robust React.createElement. It can create elements from primitive values.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @param {string|object|function} val The value to create a ReactElement from
 * @param {Object} [options={}]
 * @param {object} [options.defaultProps={}] Default props object
 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
 * @param {boolean} [options.autoGenerateKey=true] Whether or not automatic key generation is allowed
 * @returns {object|null}
 */

function createShorthand(Component, mapValueToProps, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthand() Component must be a string or function.');
  } // short circuit noop values


  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(val) || __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean___default()(val)) return null;

  var valIsString = __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(val);

  var valIsNumber = __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default()(val);

  var valIsFunction = __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(val);

  var valIsReactElement = Object(__WEBPACK_IMPORTED_MODULE_11_react__["isValidElement"])(val);

  var valIsPropsObject = __WEBPACK_IMPORTED_MODULE_4_lodash_isPlainObject___default()(val);

  var valIsPrimitiveValue = valIsString || valIsNumber || __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(val); // unhandled type return null

  /* eslint-disable no-console */


  if (!valIsFunction && !valIsReactElement && !valIsPropsObject && !valIsPrimitiveValue) {
    if (false) {
      console.error(['Shorthand value must be a string|number|array|object|ReactElement|function.', ' Use null|undefined|boolean for none', " Received ".concat(_typeof(val), ".")].join(''));
    }

    return null;
  }
  /* eslint-enable no-console */
  // ----------------------------------------
  // Build up props
  // ----------------------------------------


  var _options$defaultProps = options.defaultProps,
      defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps; // User's props

  var usersProps = valIsReactElement && val.props || valIsPropsObject && val || valIsPrimitiveValue && mapValueToProps(val); // Override props

  var _options$overrideProp = options.overrideProps,
      overrideProps = _options$overrideProp === void 0 ? {} : _options$overrideProp;
  overrideProps = __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(overrideProps) ? overrideProps(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, usersProps)) : overrideProps; // Merge props

  /* eslint-disable react/prop-types */

  var props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, usersProps, overrideProps); // Merge className


  if (defaultProps.className || overrideProps.className || usersProps.className) {
    var mergedClassesNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(defaultProps.className, overrideProps.className, usersProps.className);
    props.className = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(mergedClassesNames.split(' ')).join(' ');
  } // Merge style


  if (defaultProps.style || overrideProps.style || usersProps.style) {
    props.style = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps.style, usersProps.style, overrideProps.style);
  } // ----------------------------------------
  // Get key
  // ----------------------------------------
  // Use key, childKey, or generate key


  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(props.key)) {
    var childKey = props.childKey;
    var _options$autoGenerate = options.autoGenerateKey,
        autoGenerateKey = _options$autoGenerate === void 0 ? true : _options$autoGenerate;

    if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(childKey)) {
      // apply and consume the childKey
      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
      delete props.childKey;
    } else if (autoGenerateKey && (valIsString || valIsNumber)) {
      // use string/number shorthand values as the key
      props.key = val;
    }
  } // ----------------------------------------
  // Create Element
  // ----------------------------------------
  // Clone ReactElements


  if (valIsReactElement) return Object(__WEBPACK_IMPORTED_MODULE_11_react__["cloneElement"])(val, props); // Create ReactElements from built up props

  if (valIsPrimitiveValue || valIsPropsObject) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Component, props); // Call functions with args similar to createElement()

  if (valIsFunction) return val(Component, props, props.children);
  /* eslint-enable react/prop-types */
} // ============================================================
// Factory Creators
// ============================================================

/**
 * Creates a `createShorthand` function that is waiting for a value and options.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
 */

createShorthand.handledProps = [];
function createShorthandFactory(Component, mapValueToProps) {
  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthandFactory() Component must be a string or function.');
  }

  return function (val, options) {
    return createShorthand(Component, mapValueToProps, val, options);
  };
} // ============================================================
// HTML Factories
// ============================================================

var createHTMLDivision = createShorthandFactory('div', function (val) {
  return {
    children: val
  };
});
var createHTMLIframe = createShorthandFactory('iframe', function (src) {
  return {
    src: src
  };
});
var createHTMLImage = createShorthandFactory('img', function (val) {
  return {
    src: val
  };
});
var createHTMLInput = createShorthandFactory('input', function (val) {
  return {
    type: val
  };
});
var createHTMLLabel = createShorthandFactory('label', function (val) {
  return {
    children: val
  };
});
var createHTMLParagraph = createShorthandFactory('p', function (val) {
  return {
    children: val
  };
});

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(405),
    noop = __webpack_require__(264),
    setToArray = __webpack_require__(177);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */
var getUnhandledProps = function getUnhandledProps(Component, props) {
  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
  var _Component$handledPro = Component.handledProps,
      handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
  return Object.keys(props).reduce(function (acc, prop) {
    if (prop === 'childKey') return acc;
    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (getUnhandledProps);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */
function getElementType(Component, props, getDefault) {
  var _Component$defaultPro = Component.defaultProps,
      defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
  // user defined "as" element type

  if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
  // computed default element type

  if (getDefault) {
    var computedDefault = getDefault();
    if (computedDefault) return computedDefault;
  } // ----------------------------------------
  // infer anchor links


  if (props.href) return 'a'; // ----------------------------------------
  // use defaultProp or 'div'

  return defaultProps.as || 'div';
}

/* harmony default export */ __webpack_exports__["a"] = (getElementType);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return htmlInputAttrs; });
/* unused harmony export htmlInputEvents */
/* unused harmony export htmlInputProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlImageProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return partitionHTMLProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);


var htmlInputAttrs = [// REACT
'selected', 'defaultValue', 'defaultChecked', // LIMITED HTML PROPS
'accept', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'checked', 'disabled', 'form', 'id', 'lang', 'list', 'max', 'maxLength', 'min', 'minLength', 'multiple', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'title', 'type', 'value'];
var htmlInputEvents = [// EVENTS
// keyboard
'onKeyDown', 'onKeyPress', 'onKeyUp', // focus
'onFocus', 'onBlur', // form
'onChange', 'onInput', // mouse
'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', // selection
'onSelect', // touch
'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
var htmlInputProps = [].concat(htmlInputAttrs, htmlInputEvents);
var htmlImageProps = ['alt', 'height', 'src', 'srcSet', 'width'];
/**
 * Returns an array of objects consisting of: props of html input element and rest.
 * @param {object} props A ReactElement props object
 * @param {Object} [options={}]
 * @param {Array} [options.htmlProps] An array of html input props
 * @param {boolean} [options.includeAria] Includes all input props that starts with "aria-"
 * @returns {[{}, {}]} An array of objects
 */

var partitionHTMLProps = function partitionHTMLProps(props) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$htmlProps = options.htmlProps,
      htmlProps = _options$htmlProps === void 0 ? htmlInputProps : _options$htmlProps,
      _options$includeAria = options.includeAria,
      includeAria = _options$includeAria === void 0 ? true : _options$includeAria;
  var inputProps = {};
  var rest = {};

  __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(props, function (val, prop) {
    var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
    var target = __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(htmlProps, prop) || possibleAria ? inputProps : rest;
    target[prop] = val;
  });

  return [inputProps, rest];
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);


var hasDocument = (typeof document === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(document)) === 'object' && document !== null;
var hasWindow = (typeof window === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(window)) === 'object' && window !== null && window.self === window; // eslint-disable-next-line no-confusing-arrow

var isBrowser = function isBrowser() {
  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
};

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_some__);






/**
 * Determines if a click's coordinates are within the bounds of a node.
 *
 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
 *
 * @param {object} node - A DOM node.
 * @param {object} e - A SyntheticEvent or DOM Event.
 * @returns {boolean}
 */
var doesNodeContainClick = function doesNodeContainClick(node, e) {
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([e, node], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false; // if there is an e.target and it is in the document, use a simple node.contains() check

  if (e.target) {
    __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default()(e.target, 'setAttribute', 'data-suir-click-target', true);

    if (document.querySelector('[data-suir-click-target=true]')) {
      __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default()(e.target, 'removeAttribute', 'data-suir-click-target');

      return node.contains(e.target);
    }
  } // Below logic handles cases where the e.target is no longer in the document.
  // The result of the click likely has removed the e.target node.
  // Instead of node.contains(), we'll identify the click by X/Y position.
  // return early if the event properties aren't available
  // prevent measuring the node and repainting if we don't need to


  var clientX = e.clientX,
      clientY = e.clientY;
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([clientX, clientY], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false; // false if the node is not visible

  var clientRects = node.getClientRects(); // Heads Up!
  // getClientRects returns a DOMRectList, not an array nor a plain object
  // We explicitly avoid _.isEmpty and check .length to cover all possible shapes

  if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false; // false if the node doesn't have a valid bounding rect

  var _first2 = __WEBPACK_IMPORTED_MODULE_1_lodash_first___default()(clientRects),
      top = _first2.top,
      bottom = _first2.bottom,
      left = _first2.left,
      right = _first2.right;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([top, bottom, left, right], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false; // we add a small decimal to the upper bound just to make it inclusive
  // don't add an whole pixel (1) as the event/node values may be decimal sensitive

  return __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(clientY, top, bottom + 0.001) && __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(clientX, left, right + 0.001);
};

/* harmony default export */ __webpack_exports__["a"] = (doesNodeContainClick);

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

module.exports = baseInRange;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1017);


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__ = __webpack_require__(1019);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__["a"]; });



/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemFactories__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rangeFactories__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paginationUtils__ = __webpack_require__(1025);




/**
 * @param {object} rawOptions
 * @param {number|string} rawOptions.activePage
 * @param {number|string} rawOptions.boundaryRange Number of always visible pages at the beginning and end.
 * @param {boolean} rawOptions.hideEllipsis Marks if ellipsis should be hidden.
 * @param {number|string} rawOptions.siblingRange Number of always visible pages before and after the current one.
 * @param {number|string} rawOptions.totalPages Total number of pages.
 */

var createPaginationItems = function createPaginationItems(rawOptions) {
  var options = Object(__WEBPACK_IMPORTED_MODULE_3__paginationUtils__["b" /* typifyOptions */])(rawOptions);
  var activePage = options.activePage,
      totalPages = options.totalPages;
  var pageFactory = Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["e" /* createPageFactory */])(activePage);
  var innerRange = Object(__WEBPACK_IMPORTED_MODULE_3__paginationUtils__["a" /* isSimplePagination */])(options) ? Object(__WEBPACK_IMPORTED_MODULE_2__rangeFactories__["b" /* createSimpleRange */])(1, totalPages, pageFactory) : Object(__WEBPACK_IMPORTED_MODULE_2__rangeFactories__["a" /* createComplexRange */])(options, pageFactory);
  return [Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["b" /* createFirstPage */])(), Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["f" /* createPrevItem */])(activePage)].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(innerRange), [Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["d" /* createNextItem */])(activePage, totalPages), Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["c" /* createLastItem */])(totalPages)]);
};

/* harmony default export */ __webpack_exports__["a"] = (createPaginationItems);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSimpleRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createComplexRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__suffixFactories__ = __webpack_require__(1024);




var createSimpleRange = function createSimpleRange(start, end, pageFactory) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(start, end + 1), pageFactory);
};
var createComplexRange = function createComplexRange(options, pageFactory) {
  var activePage = options.activePage,
      boundaryRange = options.boundaryRange,
      hideEllipsis = options.hideEllipsis,
      siblingRange = options.siblingRange,
      totalPages = options.totalPages;
  var ellipsisSize = hideEllipsis ? 0 : 1;
  var firstGroupEnd = boundaryRange;
  var firstGroup = createSimpleRange(1, firstGroupEnd, pageFactory);
  var lastGroupStart = totalPages + 1 - boundaryRange;
  var lastGroup = createSimpleRange(lastGroupStart, totalPages, pageFactory);
  var innerGroupStart = Math.min(Math.max(activePage - siblingRange, firstGroupEnd + ellipsisSize + 1), lastGroupStart - ellipsisSize - 2 * siblingRange - 1);
  var innerGroupEnd = innerGroupStart + 2 * siblingRange;
  var innerGroup = createSimpleRange(innerGroupStart, innerGroupEnd, pageFactory);
  return [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(firstGroup), [!hideEllipsis && Object(__WEBPACK_IMPORTED_MODULE_3__suffixFactories__["a" /* createInnerPrefix */])(firstGroupEnd, innerGroupStart, pageFactory)], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(innerGroup), [!hideEllipsis && Object(__WEBPACK_IMPORTED_MODULE_3__suffixFactories__["b" /* createInnerSuffix */])(innerGroupEnd, lastGroupStart, pageFactory)], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(lastGroup)).filter(Boolean);
};

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1022);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1023),
    isIterateeCall = __webpack_require__(106),
    toFinite = __webpack_require__(252);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInnerPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createInnerSuffix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__itemFactories__ = __webpack_require__(443);

var createInnerPrefix = function createInnerPrefix(firstGroupEnd, innerGroupStart, pageFactory) {
  var prefixPage = innerGroupStart - 1;
  var showEllipsis = prefixPage !== firstGroupEnd + 1;
  var prefixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["a" /* createEllipsisItem */] : pageFactory;
  return prefixFactory(prefixPage);
};
var createInnerSuffix = function createInnerSuffix(innerGroupEnd, lastGroupStart, pageFactory) {
  var suffixPage = innerGroupEnd + 1;
  var showEllipsis = suffixPage !== lastGroupStart - 1;
  var suffixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["a" /* createEllipsisItem */] : pageFactory;
  return suffixFactory(suffixPage);
};

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isSimplePagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return typifyOptions; });
/**
 * Checks the possibility of using simple range generation, if number of generated pages is equal
 * or greater than total pages to show.
 *
 * @param {object} options
 * @param {number} options.boundaryRange Number of always visible pages at the beginning and end.
 * @param {number} options.siblingRange Number of always visible pages before and after the current one.
 * @param {number} options.totalPages Total number of pages.
 * @return {boolean}
 */
var isSimplePagination = function isSimplePagination(_ref) {
  var boundaryRange = _ref.boundaryRange,
      hideEllipsis = _ref.hideEllipsis,
      siblingRange = _ref.siblingRange,
      totalPages = _ref.totalPages;
  var boundaryRangeSize = 2 * boundaryRange;
  var ellipsisSize = hideEllipsis ? 0 : 2;
  var siblingRangeSize = 2 * siblingRange;
  return 1 + ellipsisSize + siblingRangeSize + boundaryRangeSize >= totalPages;
};
var typifyOptions = function typifyOptions(_ref2) {
  var activePage = _ref2.activePage,
      boundaryRange = _ref2.boundaryRange,
      hideEllipsis = _ref2.hideEllipsis,
      siblingRange = _ref2.siblingRange,
      totalPages = _ref2.totalPages;
  return {
    activePage: +activePage,
    boundaryRange: +boundaryRange,
    hideEllipsis: !!hideEllipsis,
    siblingRange: +siblingRange,
    totalPages: +totalPages
  };
};

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLORS", function() { return COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOATS", function() { return FLOATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIZES", function() { return SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGNMENTS", function() { return TEXT_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERTICAL_ALIGNMENTS", function() { return VERTICAL_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VISIBILITY", function() { return VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDTHS", function() { return WIDTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIRECTIONAL_TRANSITIONS", function() { return DIRECTIONAL_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATIC_TRANSITIONS", function() { return STATIC_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSITIONS", function() { return TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCESSIBILITY", function() { return ACCESSIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROWS", function() { return ARROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_VIDEO", function() { return AUDIO_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUSINESS", function() { return BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHESS", function() { return CHESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CODE", function() { return CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMUNICATION", function() { return COMMUNICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPUTERS", function() { return COMPUTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CURRENCY", function() { return CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATE_TIME", function() { return DATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESIGN", function() { return DESIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITORS", function() { return EDITORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILES", function() { return FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GENDERS", function() { return GENDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HANDS_GESTURES", function() { return HANDS_GESTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEALTH", function() { return HEALTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGES", function() { return IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERFACES", function() { return INTERFACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGISTICS", function() { return LOGISTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAPS", function() { return MAPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDICAL", function() { return MEDICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OBJECTS", function() { return OBJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAYMENTS_SHOPPING", function() { return PAYMENTS_SHOPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHAPES", function() { return SHAPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNERS", function() { return SPINNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPORTS", function() { return SPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS_PEOPLE", function() { return USERS_PEOPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VEHICLES", function() { return VEHICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WRITING", function() { return WRITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRANDS", function() { return BRANDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_ALIASES", function() { return ICON_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS_AND_ALIASES", function() { return ICONS_AND_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPONENT_CONTEXT_SPECIFIC_ICONS", function() { return COMPONENT_CONTEXT_SPECIFIC_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALL_ICONS_IN_ALL_CONTEXTS", function() { return ALL_ICONS_IN_ALL_CONTEXTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numberToWord__ = __webpack_require__(260);





var COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
var FLOATS = ['left', 'right'];
var SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
var TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
var VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
var VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];
var WIDTHS = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_keys___default()(__WEBPACK_IMPORTED_MODULE_4__numberToWord__["b" /* numberToWordMap */])), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_keys___default()(__WEBPACK_IMPORTED_MODULE_4__numberToWord__["b" /* numberToWordMap */]).map(Number)), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_values___default()(__WEBPACK_IMPORTED_MODULE_4__numberToWord__["b" /* numberToWordMap */])));
var DIRECTIONAL_TRANSITIONS = ['browse', 'browse right', 'drop', 'fade', 'fade up', 'fade down', 'fade left', 'fade right', 'fly up', 'fly down', 'fly left', 'fly right', 'horizontal flip', 'vertical flip', 'scale', 'slide up', 'slide down', 'slide left', 'slide right', 'swing up', 'swing down', 'swing left', 'swing right', 'zoom'];
var STATIC_TRANSITIONS = ['jiggle', 'flash', 'shake', 'pulse', 'tada', 'bounce', 'glow'];
var TRANSITIONS = [].concat(DIRECTIONAL_TRANSITIONS, STATIC_TRANSITIONS); // Generated from:
// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css

var ACCESSIBILITY = ['american sign language interpreting', 'assistive listening systems', 'audio description', 'blind', 'braille', 'closed captioning', 'closed captioning outline', 'deaf', 'low vision', 'phone volume', 'question circle', 'question circle outline', 'sign language', 'tty', 'universal access', 'wheelchair'];
var ARROWS = ['angle double down', 'angle double left', 'angle double right', 'angle double up', 'angle down', 'angle left', 'angle right', 'angle up', 'arrow alternate circle down', 'arrow alternate circle down outline', 'arrow alternate circle left', 'arrow alternate circle left outline', 'arrow alternate circle right', 'arrow alternate circle right outline', 'arrow alternate circle up', 'arrow alternate circle up outline', 'arrow circle down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow down', 'arrow left', 'arrow right', 'arrow up', 'arrows alternate', 'arrows alternate horizontal', 'arrows alternate vertical', 'caret down', 'caret left', 'caret right', 'caret square down', 'caret square down outline', 'caret square left', 'caret square left outline', 'caret square right', 'caret square right outline', 'caret square up', 'caret square up outline', 'caret up', 'cart arrow down', 'chart line', 'chevron circle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron down', 'chevron left', 'chevron right', 'chevron up', 'cloud download', 'cloud upload', 'download', 'exchange', 'expand arrows alternate', 'external alternate', 'external square alternate', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'history', 'level down alternate', 'level up alternate', 'location arrow', 'long arrow alternate down', 'long arrow alternate left', 'long arrow alternate right', 'long arrow alternate up', 'mouse pointer', 'play', 'random', 'recycle', 'redo', 'redo alternate', 'reply', 'reply all', 'retweet', 'share', 'share square', 'share square outline', 'sign-in', 'sign-out', 'sign-in alternate', 'sign-out alternate', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'sync', 'sync alternate', 'text height', 'text width', 'undo', 'undo alternate', 'upload', 'zoom-in', 'zoom-out'];
var AUDIO_VIDEO = ['audio description', 'backward', 'circle', 'circle outline', 'closed captioning', 'closed captioning outline', 'compress', 'eject', 'expand', 'expand arrows alternate', 'fast backward', 'fast forward', 'file audio', 'file audio outline', 'file video', 'file video outline', 'film', 'forward', 'headphones', 'microphone', 'microphone slash', 'music', 'pause', 'pause circle', 'pause circle outline', 'phone volume', 'play', 'play circle', 'play circle outline', 'podcast', 'random', 'redo', 'redo alternate', 'rss', 'rss square', 'step backward', 'step forward', 'stop', 'stop circle', 'stop circle outline', 'sync', 'sync alternate', 'undo', 'undo alternate', 'video', 'volume down', 'volume off', 'volume up'];
var BUSINESS = ['address book', 'address book outline', 'address card', 'address card outline', 'archive', 'balance scale', 'birthday cake', 'book', 'briefcase', 'building', 'building outline', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'certificate', 'chart area', 'chart bar', 'chart bar outline', 'chart line', 'chart pie', 'clipboard', 'clipboard outline', 'coffee', 'columns', 'compass', 'compass outline', 'copy', 'copy outline', 'copyright', 'copyright outline', 'cut', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'eraser', 'fax', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'globe', 'industry', 'paperclip', 'paste', 'pen square', 'pencil alternate', 'percent', 'phone', 'phone square', 'phone volume', 'registered', 'registered outline', 'save', 'save outline', 'sitemap', 'sticky note', 'sticky note outline', 'suitcase', 'table', 'tag', 'tags', 'tasks', 'thumbtack', 'trademark'];
var CHESS = ['chess', 'chess bishop', 'chess board', 'chess king', 'chess knight', 'chess pawn', 'chess queen', 'chess rook', 'square full'];
var CODE = ['archive', 'barcode', 'bath', 'bug', 'code', 'code branch', 'coffee', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file code', 'file code outline', 'filter', 'fire extinguisher', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'microchip', 'qrcode', 'shield alternate', 'sitemap', 'terminal', 'user secret', 'window close', 'window close outline', 'window maximize', 'window maximize outline', 'window minimize', 'window minimize outline', 'window restore', 'window restore outline'];
var COMMUNICATION = ['address book', 'address book outline', 'address card', 'address card outline', 'american sign language interpreting', 'assistive listening systems', 'at', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bullhorn', 'comment', 'comment outline', 'comment alternate', 'comment alternate outline', 'comments', 'comments outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'fax', 'inbox', 'language', 'microphone', 'microphone slash', 'mobile', 'mobile alternate', 'paper plane', 'paper plane outline', 'phone', 'phone square', 'phone volume', 'rss', 'rss square', 'tty', 'wifi'];
var COMPUTERS = ['desktop', 'download', 'hdd', 'hdd outline', 'headphones', 'keyboard', 'keyboard outline', 'laptop', 'microchip', 'mobile', 'mobile alternate', 'plug', 'power off', 'print', 'save', 'save outline', 'server', 'tablet', 'tablet alternate', 'tv', 'upload'];
var CURRENCY = ['dollar sign', 'euro sign', 'lira sign', 'money bill alternate', 'money bill alternate outline', 'pound sign', 'ruble sign', 'rupee sign', 'shekel sign', 'won sign', 'yen sign'];
var DATE_TIME = ['bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'clock', 'clock outline', 'hourglass', 'hourglass outline', 'hourglass end', 'hourglass half', 'hourglass start', 'stopwatch'];
var DESIGN = ['adjust', 'clone', 'clone outline', 'copy', 'copy outline', 'crop', 'crosshairs', 'cut', 'edit', 'edit outline', 'eraser', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'object group', 'object group outline', 'object ungroup', 'object ungroup outline', 'paint brush', 'paste', 'pencil alternate', 'save', 'save outline', 'tint'];
var EDITORS = ['align center', 'align justify', 'align left', 'align right', 'bold', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'columns', 'copy', 'copy outline', 'cut', 'edit', 'edit outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'font', 'heading', 'i cursor', 'indent', 'italic', 'linkify', 'list', 'list alternate', 'list alternate outline', 'list ol', 'list ul', 'outdent', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'paste', 'pencil alternate', 'print', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'share', 'strikethrough', 'subscript', 'superscript', 'sync', 'sync alternate', 'table', 'tasks', 'text height', 'text width', 'th', 'th large', 'th list', 'trash', 'trash alternate', 'trash alternate outline', 'underline', 'undo', 'undo alternate', 'unlink'];
var FILES = ['archive', 'clone', 'clone outline', 'copy', 'copy outline', 'cut', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file archive', 'file archive outline', 'file audio', 'file audio outline', 'file code', 'file code outline', 'file excel', 'file excel outline', 'file image', 'file image outline', 'file pdf', 'file pdf outline', 'file powerpoint', 'file powerpoint outline', 'file video', 'file video outline', 'file word', 'file word outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'paste', 'save', 'save outline', 'sticky note', 'sticky note outline'];
var GENDERS = ['genderless', 'mars', 'mars double', 'mars stroke', 'mars stroke horizontal', 'mars stroke vertical', 'mercury', 'neuter', 'transgender', 'transgender alternate', 'venus', 'venus double', 'venus mars'];
var HANDS_GESTURES = ['hand lizard', 'hand lizard outline', 'hand paper', 'hand paper outline', 'hand peace', 'hand peace outline', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'hand rock', 'hand rock outline', 'hand scissors', 'hand scissors outline', 'hand spock', 'hand spock outline', 'handshake', 'handshake outline', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline'];
var HEALTH = ['ambulance', 'h square', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'medkit', 'plus square', 'plus square outline', 'stethoscope', 'user md', 'wheelchair'];
var IMAGES = ['adjust', 'bolt', 'camera', 'camera retro', 'clone', 'clone outline', 'compress', 'expand', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'file image', 'file image outline', 'film', 'id badge', 'id badge outline', 'id card', 'id card outline', 'image', 'image outline', 'images', 'images outline', 'sliders horizontal', 'tint'];
var INTERFACES = ['ban', 'barcode', 'bars', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bug', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'certificate', 'check', 'check circle', 'check circle outline', 'check square', 'check square outline', 'circle', 'circle outline', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'cloud', 'cloud download', 'cloud upload', 'coffee', 'cog', 'cogs', 'copy', 'copy outline', 'cut', 'database', 'dot circle', 'dot circle outline', 'download', 'edit', 'edit outline', 'ellipsis horizontal', 'ellipsis vertical', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'exclamation', 'exclamation circle', 'exclamation triangle', 'external alternate', 'external square alternate', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'filter', 'flag', 'flag outline', 'flag checkered', 'folder', 'folder outline', 'folder open', 'folder open outline', 'frown', 'frown outline', 'hashtag', 'heart', 'heart outline', 'history', 'home', 'i cursor', 'info', 'info circle', 'language', 'magic', 'meh', 'meh outline', 'microphone', 'microphone slash', 'minus', 'minus circle', 'minus square', 'minus square outline', 'paste', 'pencil alternate', 'plus', 'plus circle', 'plus square', 'plus square outline', 'qrcode', 'question', 'question circle', 'question circle outline', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'rss', 'rss square', 'save', 'save outline', 'search', 'search minus', 'search plus', 'share', 'share alternate', 'share alternate square', 'share square', 'share square outline', 'shield alternate', 'sign-in', 'sign-out', 'signal', 'sitemap', 'sliders horizontal', 'smile', 'smile outline', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'star', 'star outline', 'star half', 'star half outline', 'sync', 'sync alternate', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'times', 'times circle', 'times circle outline', 'toggle off', 'toggle on', 'trash', 'trash alternate', 'trash alternate outline', 'trophy', 'undo', 'undo alternate', 'upload', 'user', 'user outline', 'user circle', 'user circle outline', 'wifi'];
var LOGISTICS = ['box', 'boxes', 'clipboard check', 'clipboard list', 'dolly', 'dolly flatbed', 'pallet', 'shipping fast', 'truck', 'warehouse'];
var MAPS = ['ambulance', 'anchor', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bicycle', 'binoculars', 'birthday cake', 'blind', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'building', 'building outline', 'car', 'coffee', 'crosshairs', 'dollar sign', 'eye', 'eye slash', 'eye slash outline', 'fighter jet', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'gamepad', 'gavel', 'gift', 'glass martini', 'globe', 'graduation cap', 'h square', 'heart', 'heart outline', 'heartbeat', 'home', 'hospital', 'hospital outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'info', 'info circle', 'key', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'location arrow', 'low vision', 'magnet', 'male', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'money bill alternate', 'money bill alternate outline', 'motorcycle', 'music', 'newspaper', 'newspaper outline', 'paw', 'phone', 'phone square', 'phone volume', 'plane', 'plug', 'plus', 'plus square', 'plus square outline', 'print', 'recycle', 'road', 'rocket', 'search', 'search minus', 'search plus', 'ship', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'street view', 'subway', 'suitcase', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'tint', 'train', 'tree', 'trophy', 'truck', 'tty', 'umbrella', 'university', 'utensil spoon', 'utensils', 'wheelchair', 'wifi', 'wrench'];
var MEDICAL = ['ambulance', 'band aid', 'dna', 'first aid', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'hospital symbol', 'pills', 'plus', 'stethoscope', 'syringe', 'thermometer', 'user md', 'weight'];
var OBJECTS = ['ambulance', 'anchor', 'archive', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bicycle', 'binoculars', 'birthday cake', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'bug', 'building', 'building outline', 'bullhorn', 'bullseye', 'bus', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'camera', 'camera retro', 'car', 'clipboard', 'clipboard outline', 'cloud', 'coffee', 'cog', 'cogs', 'compass', 'compass outline', 'copy', 'copy outline', 'cube', 'cubes', 'cut', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'eye', 'eye dropper', 'fax', 'fighter jet', 'file', 'file outline', 'file alternate', 'file alternate outline', 'film', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'futbol', 'futbol outline', 'gamepad', 'gavel', 'gem', 'gem outline', 'gift', 'glass martini', 'globe', 'graduation cap', 'hdd', 'hdd outline', 'headphones', 'heart', 'heart outline', 'home', 'hospital', 'hospital outline', 'hourglass', 'hourglass outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'key', 'keyboard', 'keyboard outline', 'laptop', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'lock', 'lock open', 'magic', 'magnet', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'microchip', 'microphone', 'mobile', 'mobile alternate', 'money bill alternate', 'money bill alternate outline', 'moon', 'moon outline', 'motorcycle', 'newspaper', 'newspaper outline', 'paint brush', 'paper plane', 'paper plane outline', 'paperclip', 'paste', 'paw', 'pencil alternate', 'phone', 'plane', 'plug', 'print', 'puzzle piece', 'road', 'rocket', 'save', 'save outline', 'search', 'shield alternate', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'snowflake', 'snowflake outline', 'space shuttle', 'star', 'star outline', 'sticky note', 'sticky note outline', 'stopwatch', 'subway', 'suitcase', 'sun', 'sun outline', 'tablet', 'tablet alternate', 'tachometer alternate', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'train', 'trash', 'trash alternate', 'trash alternate outline', 'tree', 'trophy', 'truck', 'tv', 'umbrella', 'university', 'unlock', 'unlock alternate', 'utensil spoon', 'utensils', 'wheelchair', 'wrench'];
var PAYMENTS_SHOPPING = ['bell', 'bell outline', 'bookmark', 'bookmark outline', 'bullhorn', 'camera', 'camera retro', 'cart arrow down', 'cart plus', 'certificate', 'credit card', 'credit card outline', 'gem', 'gem outline', 'gift', 'handshake', 'handshake outline', 'heart', 'heart outline', 'key', 'shopping bag', 'shopping basket', 'shopping cart', 'star', 'star outline', 'tag', 'tags', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'trophy'];
var SHAPES = ['bookmark', 'bookmark outline', 'calendar', 'calendar outline', 'certificate', 'circle', 'circle outline', 'cloud', 'comment', 'comment outline', 'file', 'file outline', 'folder', 'folder outline', 'heart', 'heart outline', 'map marker', 'play', 'square', 'square outline', 'star', 'star outline'];
var SPINNERS = ['asterisk', 'certificate', 'circle notch', 'cog', 'compass', 'compass outline', 'crosshairs', 'life ring', 'life ring outline', 'snowflake', 'snowflake outline', 'spinner', 'sun', 'sun outline', 'sync'];
var SPORTS = ['baseball ball', 'basketball ball', 'bowling ball', 'football ball', 'futbol', 'futbol outline', 'golf ball', 'hockey puck', 'quidditch', 'table tennis', 'volleyball ball'];
var STATUS = ['ban', 'battery empty', 'battery full', 'battery half', 'battery quarter', 'battery three quarters', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'cart arrow down', 'cart plus', 'exclamation', 'exclamation circle', 'exclamation triangle', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'info', 'info circle', 'lock', 'lock open', 'minus', 'minus circle', 'minus square', 'minus square outline', 'plus', 'plus circle', 'plus square', 'plus square outline', 'question', 'question circle', 'question circle outline', 'shield alternate', 'shopping cart', 'sign in alternate', 'sign out alternate', 'thermometer empty', 'thermometer full', 'thermometer half', 'thermometer quarter', 'thermometer three quarters', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'toggle off', 'toggle on', 'unlock', 'unlock alternate'];
var USERS_PEOPLE = ['address book', 'address book outline', 'address card', 'address card outline', 'bed', 'blind', 'child', 'female', 'frown', 'frown outline', 'id badge', 'id badge outline', 'id card', 'id card outline', 'male', 'meh', 'meh outline', 'power off', 'smile', 'smile outline', 'street view', 'user', 'user outline', 'user circle', 'user circle outline', 'user md', 'user plus', 'user secret', 'user times', 'users', 'wheelchair'];
var VEHICLES = ['ambulance', 'bicycle', 'bus', 'car', 'fighter jet', 'motorcycle', 'paper plane', 'paper plane outline', 'plane', 'rocket', 'ship', 'shopping cart', 'space shuttle', 'subway', 'taxi', 'train', 'truck', 'wheelchair'];
var WRITING = ['archive', 'book', 'bookmark', 'bookmark outline', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'newspaper', 'newspaper outline', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'pen square', 'pencil alternate', 'quote left', 'quote right', 'sticky note', 'sticky note outline', 'thumbtack'];
var BRANDS = ['500px', 'accessible', 'accusoft', 'adn', 'adversal', 'affiliatetheme', 'algolia', 'amazon', 'amazon pay', 'amilia', 'android', 'angellist', 'angrycreative', 'angular', 'app store', 'app store ios', 'apper', 'apple', 'apple pay', 'asymmetrik', 'audible', 'autoprefixer', 'avianex', 'aviato', 'aws', 'bandcamp', 'behance', 'behance square', 'bimobject', 'bitbucket', 'bitcoin', 'bity', 'black tie', 'blackberry', 'blogger', 'blogger b', 'bluetooth', 'bluetooth b', 'btc', 'buromobelexperte', 'buysellads', 'cc amazon pay', 'cc amex', 'cc apple pay', 'cc diners club', 'cc discover', 'cc jcb', 'cc mastercard', 'cc paypal', 'cc stripe', 'cc visa', 'centercode', 'chrome', 'cloudscale', 'cloudsmith', 'cloudversify', 'codepen', 'codiepie', 'connectdevelop', 'contao', 'cpanel', 'creative commons', 'css3', 'css3 alternate', 'cuttlefish', 'd and d', 'dashcube', 'delicious', 'deploydog', 'deskpro', 'deviantart', 'digg', 'digital ocean', 'discord', 'discourse', 'dochub', 'docker', 'draft2digital', 'dribbble', 'dribbble square', 'dropbox', 'drupal', 'dyalog', 'earlybirds', 'edge', 'elementor', 'ember', 'empire', 'envira', 'erlang', 'ethereum', 'etsy', 'expeditedssl', 'facebook', 'facebook f', 'facebook messenger', 'facebook square', 'firefox', 'first order', 'firstdraft', 'flickr', 'flipboard', 'fly', 'font awesome', 'font awesome alternate', 'font awesome flag', 'fonticons', 'fonticons fi', 'fort awesome', 'fort awesome alternate', 'forumbee', 'foursquare', 'free code camp', 'freebsd', 'get pocket', 'gg', 'gg circle', 'git', 'git square', 'github', 'github alternate', 'github square', 'gitkraken', 'gitlab', 'gitter', 'glide', 'glide g', 'gofore', 'goodreads', 'goodreads g', 'google', 'google drive', 'google play', 'google plus', 'google plus g', 'google plus square', 'google wallet', 'gratipay', 'grav', 'gripfire', 'grunt', 'gulp', 'hacker news', 'hacker news square', 'hips', 'hire a helper', 'hooli', 'hotjar', 'houzz', 'html5', 'hubspot', 'imdb', 'instagram', 'internet explorer', 'ioxhost', 'itunes', 'itunes note', 'jenkins', 'joget', 'joomla', 'js', 'js square', 'jsfiddle', 'keycdn', 'kickstarter', 'kickstarter k', 'korvue', 'laravel', 'lastfm', 'lastfm square', 'leanpub', 'less', 'linechat', 'linkedin', 'linkedin alternate', 'linode', 'linux', 'lyft', 'magento', 'maxcdn', 'medapps', 'medium', 'medium m', 'medrt', 'meetup', 'microsoft', 'mix', 'mixcloud', 'mizuni', 'modx', 'monero', 'napster', 'nintendo switch', 'node', 'node js', 'npm', 'ns8', 'nutritionix', 'odnoklassniki', 'odnoklassniki square', 'opencart', 'openid', 'opera', 'optin monster', 'osi', 'page4', 'pagelines', 'palfed', 'patreon', 'paypal', 'periscope', 'phabricator', 'phoenix framework', 'php', 'pied piper', 'pied piper alternate', 'pied piper pp', 'pinterest', 'pinterest p', 'pinterest square', 'playstation', 'product hunt', 'pushed', 'python', 'qq', 'quinscape', 'quora', 'ravelry', 'react', 'rebel', 'redriver', 'reddit', 'reddit alien', 'reddit square', 'rendact', 'renren', 'replyd', 'resolving', 'rocketchat', 'rockrms', 'safari', 'sass', 'schlix', 'scribd', 'searchengin', 'sellcast', 'sellsy', 'servicestack', 'shirtsinbulk', 'simplybuilt', 'sistrix', 'skyatlas', 'skype', 'slack', 'slack hash', 'slideshare', 'snapchat', 'snapchat ghost', 'snapchat square', 'soundcloud', 'speakap', 'spotify', 'stack exchange', 'stack overflow', 'staylinked', 'steam', 'steam square', 'steam symbol', 'sticker mule', 'strava', 'stripe', 'stripe s', 'studiovinari', 'stumbleupon', 'stumbleupon circle', 'superpowers', 'supple', 'telegram', 'telegram plane', 'tencent weibo', 'themeisle', 'trello', 'tripadvisor', 'tumblr', 'tumblr square', 'twitch', 'twitter', 'twitter square', 'typo3', 'uber', 'uikit', 'uniregistry', 'untappd', 'usb', 'ussunnah', 'vaadin', 'viacoin', 'viadeo', 'viadeo square', 'viber', 'vimeo', 'vimeo square', 'vimeo v', 'vine', 'vk', 'vnv', 'vuejs', 'wechat', 'weibo', 'weixin', 'whatsapp', 'whatsapp square', 'whmcs', 'wikipedia w', 'windows', 'wordpress', 'wordpress simple', 'wpbeginner', 'wpexplorer', 'wpforms', 'xbox', 'xing', 'xing square', 'y combinator', 'yahoo', 'yandex', 'yandex international', 'yelp', 'yoast', 'youtube', 'youtube square'];
var ICONS = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(ACCESSIBILITY, ARROWS, AUDIO_VIDEO, BUSINESS, CHESS, CODE, COMMUNICATION, COMPUTERS, CURRENCY, DATE_TIME, DESIGN, EDITORS, FILES, GENDERS, HANDS_GESTURES, HEALTH, IMAGES, INTERFACES, LOGISTICS, MAPS, MEDICAL, OBJECTS, PAYMENTS_SHOPPING, SHAPES, SPINNERS, SPORTS, STATUS, USERS_PEOPLE, VEHICLES, WRITING, BRANDS));
var ICON_ALIASES = ['chess rock', 'ordered list', 'unordered list', 'user doctor', 'shield', 'puzzle', 'add circle', 'add square', 'add to calendar', 'add to cart', 'add user', 'add', 'alarm mute', 'alarm', 'ald', 'als', 'announcement', 'area chart', 'area graph', 'arrow down cart', 'asexual', 'asl interpreting', 'asl', 'assistive listening devices', 'attach', 'attention', 'balance', 'bar', 'bathtub', 'battery four', 'battery high', 'battery low', 'battery one', 'battery three', 'battery two', 'battery zero', 'birthday', 'block layout', 'bluetooth alternative', 'broken chain', 'browser', 'call square', 'call', 'cancel', 'cart', 'cc', 'chain', 'chat', 'checked calendar', 'checkmark', 'circle notched', 'close', 'cny', 'cocktail', 'commenting', 'computer', 'configure', 'content', 'deafness', 'delete calendar', 'delete', 'detective', 'discussions', 'doctor', 'dollar', 'dont', 'drivers license', 'dropdown', 'emergency', 'envira gallery', 'erase', 'eur', 'euro', 'eyedropper', 'factory', 'favorite', 'feed', 'female homosexual', 'file text', 'file text outline', 'find', 'first aid', 'fork', 'game', 'gay', 'gbp', 'google plus circle', 'google plus official', 'grab', 'graduation', 'grid layout', 'group', 'h', 'hand victory', 'handicap', 'hard of hearing', 'header', 'help circle', 'help', 'heterosexual', 'hide', 'hotel', 'hourglass four', 'hourglass full', 'hourglass one', 'hourglass three', 'hourglass two', 'idea', 'ils', 'in cart', 'inr', 'intergender', 'intersex', 'jpy', 'krw', 'lab', 'law', 'legal', 'lesbian', 'lightning', 'like', 'line graph', 'linkedin square', 'linkify', 'lira', 'list layout', 'magnify', 'mail forward', 'mail outline', 'mail square', 'mail', 'male homosexual', 'man', 'marker', 'mars alternate', 'mars horizontal', 'mars vertical', 'microsoft edge', 'military', 'ms edge', 'mute', 'new pied piper', 'non binary transgender', 'numbered list', 'options', 'other gender horizontal', 'other gender vertical', 'other gender', 'payment', 'paypal card', 'pencil square', 'photo', 'picture', 'pie chart', 'pie graph', 'pied piper hat', 'pin', 'plus cart', 'point', 'pointing down', 'pointing left', 'pointing right', 'pointing up', 'pound', 'power cord', 'power', 'privacy', 'r circle', 'rain', 'record', 'refresh', 'remove circle', 'remove from calendar', 'remove user', 'remove', 'repeat', 'rmb', 'rouble', 'rub', 'ruble', 'rupee', 's15', 'selected radio', 'send', 'setting', 'settings', 'shekel', 'sheqel', 'shipping', 'shop', 'shuffle', 'shutdown', 'sidebar', 'signing', 'signup', 'sliders', 'soccer', 'sort alphabet ascending', 'sort alphabet descending', 'sort ascending', 'sort content ascending', 'sort content descending', 'sort descending', 'sort numeric ascending', 'sort numeric descending', 'sound', 'spy', 'stripe card', 'student', 'talk', 'target', 'teletype', 'television', 'text cursor', 'text telephone', 'theme', 'thermometer', 'thumb tack', 'time', 'tm', 'toggle down', 'toggle left', 'toggle right', 'toggle up', 'translate', 'travel', 'treatment', 'triangle down', 'triangle left', 'triangle right', 'triangle up', 'try', 'unhide', 'unlinkify', 'unmute', 'usd', 'user cancel', 'user close', 'user delete', 'user x', 'vcard', 'video camera', 'video play', 'volume control phone', 'wait', 'warning circle', 'warning sign', 'warning', 'wi-fi', 'winner', 'wizard', 'woman', 'won', 'wordpress beginner', 'wordpress forms', 'world', 'write square', 'x', 'yen', 'zip', 'zoom in', 'zoom out', 'zoom', 'bitbucket square', 'checkmark box', 'circle thin', 'cloud download', 'cloud upload', 'compose', 'conversation', 'credit card alternative', 'currency', 'dashboard', 'diamond', 'disk', 'exchange', 'external share', 'external square', 'external', 'facebook official', 'food', 'hourglass zero', 'level down', 'level up', 'log out', 'meanpath', 'money', 'move', 'pencil', 'protect', 'radio', 'remove bookmark', 'resize horizontal', 'resize vertical', 'sign in', 'sign out', 'spoon', 'star half empty', 'star half full', 'ticket', 'times rectangle', 'write', 'youtube play'];
var ICONS_AND_ALIASES = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(ICONS), ICON_ALIASES)); // Some icon names are not part of icons.css.
// These are only valid as children of other components.
// Their CSS rules are defined by a specific component's CSS.
// We don't want to show name warnings for those usages so we add them as valid names here.

var COMPONENT_CONTEXT_SPECIFIC_ICONS = ['left dropdown'];
var ALL_ICONS_IN_ALL_CONTEXTS = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(ICONS_AND_ALIASES), COMPONENT_CONTEXT_SPECIFIC_ICONS));

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the offset value.
 * @param {number|array} value The value to normalize.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the duration of a transition.
 * @param {number|object} duration The value to normalize.
 * @param {'hide'|'show'} type The type of transition.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (duration, type) {
  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_transform__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_transform__);




/**
 * Naive and inefficient object difference, intended for development / debugging use only.
 * Deleted keys are shown as [DELETED].
 * @param {{}} source The source object
 * @param {{}} target The target object.
 * @returns {{}} A new object containing new/modified/deleted keys.
 * @example
 * import { objectDiff } from 'src/lib'
 *
 * const a = { key: 'val', foo: 'bar' }
 * const b = { key: 'val', foo: 'baz' }
 *
 * objectDiff(a, b)
 * //=> { foo: 'baz' }
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (source, target) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_transform___default()(source, function (res, val, key) {
    // deleted keys
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(target, key)) res[key] = '[DELETED]'; // new keys / changed values
    // Note, we tolerate isEqual here as this is a dev only utility and not included in production code
    else if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(val, target[key])) res[key] = target[key];
  }, {});
});

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(131),
    baseCreate = __webpack_require__(133),
    baseForOwn = __webpack_require__(170),
    baseIteratee = __webpack_require__(49),
    getPrototype = __webpack_require__(184),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(104),
    isFunction = __webpack_require__(79),
    isObject = __webpack_require__(47),
    isTypedArray = __webpack_require__(128);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addons_Portal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DimmerDimmable__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DimmerInner__ = __webpack_require__(450);














/**
 * A dimmer hides distractions to focus attention on particular content.
 */

var Dimmer =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Dimmer, _Component);

  function Dimmer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Dimmer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Dimmer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMount", function () {
      if (!Object(__WEBPACK_IMPORTED_MODULE_10__lib__["t" /* isBrowser */])()) return; // Heads up, IE doesn't support second argument in add()

      document.body.classList.add('dimmed');
      document.body.classList.add('dimmable');
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalUnmount", function () {
      if (!Object(__WEBPACK_IMPORTED_MODULE_10__lib__["t" /* isBrowser */])()) return; // Heads up, IE doesn't support second argument in add()

      document.body.classList.remove('dimmed');
      document.body.classList.remove('dimmable');
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Dimmer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          page = _this$props.page;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getUnhandledProps */])(Dimmer, this.props);

      if (page) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__addons_Portal__["a" /* default */], {
          closeOnEscape: false,
          closeOnDocumentClick: false,
          onMount: this.handlePortalMount,
          onUnmount: this.handlePortalUnmount,
          open: active,
          openOnTriggerClick: false
        }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DimmerInner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          active: active,
          page: page
        })));
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DimmerInner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        active: active,
        page: page
      }));
    }
  }]);

  return Dimmer;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Dimmer, "Dimmable", __WEBPACK_IMPORTED_MODULE_12__DimmerDimmable__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Dimmer, "Inner", __WEBPACK_IMPORTED_MODULE_13__DimmerInner__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Dimmer, "handledProps", ["active", "page"]);


Dimmer.propTypes =  false ? {
  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool
} : {};
Dimmer.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["l" /* createShorthandFactory */])(Dimmer, function (value) {
  return {
    content: value
  };
});

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_keyboard_key__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PortalInner__ = __webpack_require__(448);

















/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */
var Portal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Portal, _Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "contentRef", Object(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "triggerRef", Object(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "latestDocumentMouseDownEvent", null);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseDown", function (e) {
      _this.latestDocumentMouseDownEvent = e;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentClick", function (e) {
      var closeOnDocumentClick = _this.props.closeOnDocumentClick;
      var currentMouseDownEvent = _this.latestDocumentMouseDownEvent;
      _this.latestDocumentMouseDownEvent = null;

      if (!_this.contentRef.current || // no portal
      Object(__WEBPACK_IMPORTED_MODULE_14__lib__["m" /* doesNodeContainClick */])(_this.triggerRef.current, e) || // event happened in trigger (delegate to trigger handlers)
      currentMouseDownEvent && Object(__WEBPACK_IMPORTED_MODULE_14__lib__["m" /* doesNodeContainClick */])(_this.contentRef.current, currentMouseDownEvent) || // event originated in the portal but was ended outside
      Object(__WEBPACK_IMPORTED_MODULE_14__lib__["m" /* doesNodeContainClick */])(_this.contentRef.current, e) // event happened in the portal
      ) {
          return;
        } // ignore the click


      if (closeOnDocumentClick) {
        _this.close(e);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleEscape", function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_11_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_11_keyboard_key___default.a.Escape) return;

      _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMouseLeave", function (e) {
      var _this$props = _this.props,
          closeOnPortalMouseLeave = _this$props.closeOnPortalMouseLeave,
          mouseLeaveDelay = _this$props.mouseLeaveDelay;
      if (!closeOnPortalMouseLeave) return; // Do not close the portal when 'mouseleave' is triggered by children

      if (e.target !== _this.contentRef.current) return;
      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMouseEnter", function () {
      // In order to enable mousing from the trigger to the portal, we need to
      // clear the mouseleave timer that was set when leaving the trigger.
      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
      if (!closeOnPortalMouseLeave) return;
      clearTimeout(_this.mouseLeaveTimer);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerBlur", function (e) {
      var _this$props2 = _this.props,
          trigger = _this$props2.trigger,
          closeOnTriggerBlur = _this$props2.closeOnTriggerBlur; // Call original event handler

      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onBlur', e].concat(rest)); // IE 11 doesn't work with relatedTarget in blur events


      var target = e.relatedTarget || document.activeElement; // do not close if focus is given to the portal

      var didFocusPortal = __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.contentRef.current, 'contains', target);

      if (!closeOnTriggerBlur || didFocusPortal) return;

      _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerClick", function (e) {
      var _this$props3 = _this.props,
          trigger = _this$props3.trigger,
          closeOnTriggerClick = _this$props3.closeOnTriggerClick,
          openOnTriggerClick = _this$props3.openOnTriggerClick;
      var open = _this.state.open; // Call original event handler

      for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onClick', e].concat(rest));

      if (open && closeOnTriggerClick) {
        _this.close(e);
      } else if (!open && openOnTriggerClick) {
        _this.open(e);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerFocus", function (e) {
      var _this$props4 = _this.props,
          trigger = _this$props4.trigger,
          openOnTriggerFocus = _this$props4.openOnTriggerFocus; // Call original event handler

      for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        rest[_key4 - 1] = arguments[_key4];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onFocus', e].concat(rest));

      if (!openOnTriggerFocus) return;

      _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerMouseLeave", function (e) {
      clearTimeout(_this.mouseEnterTimer);
      var _this$props5 = _this.props,
          trigger = _this$props5.trigger,
          closeOnTriggerMouseLeave = _this$props5.closeOnTriggerMouseLeave,
          mouseLeaveDelay = _this$props5.mouseLeaveDelay; // Call original event handler

      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onMouseLeave', e].concat(rest));

      if (!closeOnTriggerMouseLeave) return;
      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerMouseEnter", function (e) {
      clearTimeout(_this.mouseLeaveTimer);
      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          mouseEnterDelay = _this$props6.mouseEnterDelay,
          openOnTriggerMouseEnter = _this$props6.openOnTriggerMouseEnter; // Call original event handler

      for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        rest[_key6 - 1] = arguments[_key6];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [trigger, 'props.onMouseEnter', e].concat(rest));

      if (!openOnTriggerMouseEnter) return;
      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", function (e) {
      var onOpen = _this.props.onOpen;
      if (onOpen) onOpen(e, _this.props);

      _this.trySetState({
        open: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "openWithTimeout", function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, e);

      return setTimeout(function () {
        return _this.open(eventClone);
      }, delay || 0);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "close", function (e) {
      var onClose = _this.props.onClose;
      if (onClose) onClose(e, _this.props);

      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeWithTimeout", function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, e);

      return setTimeout(function () {
        return _this.close(eventClone);
      }, delay || 0);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMount", function () {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onMount', null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUnmount", function () {
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onUnmount', null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTriggerRef", function (c) {
      _this.triggerRef.current = c;
      Object(__WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__["b" /* handleRef */])(_this.props.triggerRef, c);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clean up timers
      clearTimeout(this.mouseEnterTimer);
      clearTimeout(this.mouseLeaveTimer);
    } // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          children = _this$props7.children,
          eventPool = _this$props7.eventPool,
          mountNode = _this$props7.mountNode,
          trigger = _this$props7.trigger;
      var open = this.state.open;
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react__["Fragment"], null, open && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PortalInner__["a" /* default */], {
        innerRef: this.contentRef,
        mountNode: mountNode,
        onMount: this.handleMount,
        onUnmount: this.handleUnmount
      }, children), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "mouseleave",
        on: this.handlePortalMouseLeave,
        pool: eventPool,
        target: this.contentRef
      }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "mouseenter",
        on: this.handlePortalMouseEnter,
        pool: eventPool,
        target: this.contentRef
      }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "mousedown",
        on: this.handleDocumentMouseDown,
        pool: eventPool
      }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "click",
        on: this.handleDocumentClick,
        pool: eventPool
      }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.handleEscape,
        pool: eventPool
      })), trigger && __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.handleTriggerRef
      }, Object(__WEBPACK_IMPORTED_MODULE_13_react__["cloneElement"])(trigger, {
        onBlur: this.handleTriggerBlur,
        onClick: this.handleTriggerClick,
        onFocus: this.handleTriggerFocus,
        onMouseLeave: this.handleTriggerMouseLeave,
        onMouseEnter: this.handleTriggerMouseEnter
      })));
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "defaultProps", {
  closeOnDocumentClick: true,
  closeOnEscape: true,
  eventPool: 'default',
  openOnTriggerClick: true
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "autoControlledProps", ['open']);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "Inner", __WEBPACK_IMPORTED_MODULE_15__PortalInner__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Portal, "handledProps", ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"]);

Portal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Controls whether or not the portal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Controls whether or not the portal should close when escape is pressed is displayed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Controls whether or not the portal should close when mousing out of the portal.
   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
   * gap from the trigger to the portal.
   */
  closeOnPortalMouseLeave: PropTypes.bool,

  /** Controls whether or not the portal should close on blur of the trigger. */
  closeOnTriggerBlur: PropTypes.bool,

  /** Controls whether or not the portal should close on click of the trigger. */
  closeOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should close when mousing out of the trigger. */
  closeOnTriggerMouseLeave: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /** Milliseconds to wait before opening on mouse over */
  mouseEnterDelay: PropTypes.number,

  /** Milliseconds to wait before closing on mouse leave */
  mouseLeaveDelay: PropTypes.number,

  /**
   * Called when a close event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Controls whether or not the portal should open when the trigger is clicked. */
  openOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should open on focus of the trigger. */
  openOnTriggerFocus: PropTypes.bool,

  /** Controls whether or not the portal should open when mousing over the trigger. */
  openOnTriggerMouseEnter: PropTypes.bool,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node,

  /** Called with a ref to the trigger node. */
  triggerRef: customPropTypes.ref
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pick__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_reduce__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shallowequal__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__elements_Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__addons_MountNode__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__addons_Portal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ModalHeader__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ModalContent__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ModalActions__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ModalDescription__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils__ = __webpack_require__(1053);





























/**
 * A modal displays content that temporarily blocks interactions with the main view of a site.
 * @see Confirm
 * @see Portal
 */
var Modal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "legacy", Object(__WEBPACK_IMPORTED_MODULE_19__lib__["t" /* isBrowser */])() && Object(__WEBPACK_IMPORTED_MODULE_27__utils__["c" /* isLegacy */])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", Object(__WEBPACK_IMPORTED_MODULE_17_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "dimmerRef", Object(__WEBPACK_IMPORTED_MODULE_17_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "latestDocumentMouseDownEvent", null);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "getMountNode", function () {
      return Object(__WEBPACK_IMPORTED_MODULE_19__lib__["t" /* isBrowser */])() ? _this.props.mountNode || document.body : null;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleActionsOverrides", function (predefinedProps) {
      return {
        onActionClick: function onActionClick(e, actionProps) {
          __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(predefinedProps, 'onActionClick', e, actionProps);

          __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onActionClick', e, _this.props);

          _this.handleClose(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClose", function (e) {
      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);

      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseDown", function (e) {
      _this.latestDocumentMouseDownEvent = e;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentClick", function (e) {
      var closeOnDimmerClick = _this.props.closeOnDimmerClick;
      var currentDocumentMouseDownEvent = _this.latestDocumentMouseDownEvent;
      _this.latestDocumentMouseDownEvent = null;
      if (!closeOnDimmerClick || Object(__WEBPACK_IMPORTED_MODULE_19__lib__["m" /* doesNodeContainClick */])(_this.ref.current, currentDocumentMouseDownEvent) || Object(__WEBPACK_IMPORTED_MODULE_19__lib__["m" /* doesNodeContainClick */])(_this.ref.current, e)) return;

      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);

      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(predefinedProps, 'onClick', e);

          _this.handleClose(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOpen", function (e) {
      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);

      _this.trySetState({
        open: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMount", function (e) {
      var eventPool = _this.props.eventPool;

      _this.setState({
        scrolling: false
      });

      _this.setPositionAndClassNames();

      __WEBPACK_IMPORTED_MODULE_19__lib__["n" /* eventStack */].sub('mousedown', _this.handleDocumentMouseDown, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });
      __WEBPACK_IMPORTED_MODULE_19__lib__["n" /* eventStack */].sub('click', _this.handleDocumentClick, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });

      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onMount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalUnmount", function (e) {
      var eventPool = _this.props.eventPool;
      cancelAnimationFrame(_this.animationRequestId);
      __WEBPACK_IMPORTED_MODULE_19__lib__["n" /* eventStack */].unsub('mousedown', _this.handleDocumentMouseDown, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });
      __WEBPACK_IMPORTED_MODULE_19__lib__["n" /* eventStack */].unsub('click', _this.handleDocumentClick, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });

      __WEBPACK_IMPORTED_MODULE_13_lodash_invoke___default()(_this.props, 'onUnmount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "setDimmerNodeStyle", function () {
      var current = _this.dimmerRef.current;

      if (current && current.style && current.style.display !== 'flex') {
        current.style.setProperty('display', 'flex', 'important');
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPositionAndClassNames", function () {
      var _this$props = _this.props,
          centered = _this$props.centered,
          dimmer = _this$props.dimmer;
      var scrolling;
      var newState = {};

      if (_this.ref.current) {
        var rect = _this.ref.current.getBoundingClientRect();

        var isFitted = Object(__WEBPACK_IMPORTED_MODULE_27__utils__["a" /* canFit */])(rect);
        scrolling = !isFitted; // Styles should be computed for IE11

        var legacyStyles = _this.legacy ? Object(__WEBPACK_IMPORTED_MODULE_27__utils__["b" /* getLegacyStyles */])(isFitted, centered, rect) : {};

        if (!__WEBPACK_IMPORTED_MODULE_18_shallowequal___default()(_this.state.legacyStyles, legacyStyles)) {
          newState.legacyStyles = legacyStyles;
        }

        if (_this.state.scrolling !== scrolling) {
          newState.scrolling = scrolling;
        }
      }

      var classes = __WEBPACK_IMPORTED_MODULE_15_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(dimmer, 'dimmable dimmed'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(dimmer === 'blurring', ' blurring'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(scrolling, ' scrolling'));
      if (_this.state.mountClasses !== classes) newState.mountClasses = classes;
      if (!__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default()(newState)) _this.setState(newState);
      _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);

      _this.setDimmerNodeStyle();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderContent", function (rest) {
      var _this$props2 = _this.props,
          actions = _this$props2.actions,
          basic = _this$props2.basic,
          children = _this$props2.children,
          className = _this$props2.className,
          closeIcon = _this$props2.closeIcon,
          content = _this$props2.content,
          header = _this$props2.header,
          mountNode = _this$props2.mountNode,
          size = _this$props2.size,
          style = _this$props2.style;
      var _this$state = _this.state,
          legacyStyles = _this$state.legacyStyles,
          mountClasses = _this$state.mountClasses,
          scrolling = _this$state.scrolling;
      var classes = __WEBPACK_IMPORTED_MODULE_15_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(_this.legacy, 'legacy'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(scrolling, 'scrolling'), 'modal transition visible active', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["p" /* getElementType */])(Modal, _this.props);
      var closeIconName = closeIcon === true ? 'close' : closeIcon;
      var closeIconJSX = __WEBPACK_IMPORTED_MODULE_20__elements_Icon__["a" /* default */].create(closeIconName, {
        overrideProps: _this.handleIconOverrides
      });
      return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: _this.ref
      }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, legacyStyles, style)
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__addons_MountNode__["a" /* default */], {
        className: mountClasses,
        node: mountNode
      }), closeIconJSX, __WEBPACK_IMPORTED_MODULE_19__lib__["c" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_23__ModalHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_24__ModalContent__["a" /* default */].create(content, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_25__ModalActions__["a" /* default */].create(actions, {
        overrideProps: _this.handleActionsOverrides
      })) : children));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Modal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handlePortalUnmount();
    } // Do not access document when server side rendering

  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props3 = this.props,
          centered = _this$props3.centered,
          closeOnDocumentClick = _this$props3.closeOnDocumentClick,
          dimmer = _this$props3.dimmer,
          eventPool = _this$props3.eventPool,
          trigger = _this$props3.trigger;
      var mountNode = this.getMountNode(); // Short circuit when server side rendering

      if (!Object(__WEBPACK_IMPORTED_MODULE_19__lib__["t" /* isBrowser */])()) {
        return Object(__WEBPACK_IMPORTED_MODULE_17_react__["isValidElement"])(trigger) ? trigger : null;
      }

      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["q" /* getUnhandledProps */])(Modal, this.props);
      var portalPropNames = __WEBPACK_IMPORTED_MODULE_22__addons_Portal__["a" /* default */].handledProps;

      var rest = __WEBPACK_IMPORTED_MODULE_11_lodash_reduce___default()(unhandled, function (acc, val, key) {
        if (!__WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(portalPropNames, key)) acc[key] = val;
        return acc;
      }, {});

      var portalProps = __WEBPACK_IMPORTED_MODULE_9_lodash_pick___default()(unhandled, portalPropNames); // wrap dimmer modals


      var dimmerClasses = __WEBPACK_IMPORTED_MODULE_15_classnames___default()('ui', dimmer === 'inverted' && 'inverted', !centered && 'top aligned', 'page modals dimmer transition visible active'); // Heads up!
      //
      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
      //
      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
      // We need the immediate child to be the dimmer to :not() blur the modal itself!
      // Otherwise, the portal div is also blurred, blurring the modal.
      //
      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.

      return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__addons_Portal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        closeOnDocumentClick: closeOnDocumentClick
      }, portalProps, {
        trigger: trigger,
        eventPool: eventPool,
        mountNode: mountNode,
        open: open,
        onClose: this.handleClose,
        onMount: this.handlePortalMount,
        onOpen: this.handleOpen,
        onUnmount: this.handlePortalUnmount
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div", {
        className: dimmerClasses,
        ref: this.dimmerRef
      }, this.renderContent(rest)));
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_19__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "defaultProps", {
  centered: true,
  dimmer: true,
  closeOnDimmerClick: true,
  closeOnDocumentClick: false,
  eventPool: 'Modal'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "autoControlledProps", ['open']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Header", __WEBPACK_IMPORTED_MODULE_23__ModalHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Content", __WEBPACK_IMPORTED_MODULE_24__ModalContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Description", __WEBPACK_IMPORTED_MODULE_26__ModalDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "Actions", __WEBPACK_IMPORTED_MODULE_25__ModalActions__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Modal, "handledProps", ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"]);

Modal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
  actions: customPropTypes.itemShorthand,

  /** A modal can reduce its complexity */
  basic: PropTypes.bool,

  /** A modal can be vertically centered in the viewport */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for the close icon. Closes the modal on click. */
  closeIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.bool]),

  /** Whether or not the Modal should close when the dimmer is clicked. */
  closeOnDimmerClick: PropTypes.bool,

  /** Whether or not the Modal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Simple text content for the Modal. */
  content: customPropTypes.itemShorthand,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** A Modal can appear in a dimmer. */
  dimmer: PropTypes.oneOf([true, 'inverted', 'blurring']),

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** Modal displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: PropTypes.any,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onActionClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the Modal is displayed. */
  open: PropTypes.bool,

  /** A modal can vary in size */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen']),

  /** Custom styles. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node
  /**
   * NOTE: Any unhandled props that are defined in Portal are passed-through
   * to the wrapping Portal.
   */

} : {};
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MountNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_NodeRegistry__ = __webpack_require__(1052);












var nodeRegistry = new __WEBPACK_IMPORTED_MODULE_11__lib_NodeRegistry__["a" /* default */]();
/**
 * A component that allows to manage classNames on a DOM node in declarative manner.
 */

var MountNode =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(MountNode, _Component);

  function MountNode() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MountNode);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(MountNode).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MountNode, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var nextClassName = _ref.className;
      var currentClassName = this.props.className;
      return nextClassName !== currentClassName;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var nodeRef = Object(__WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__["a" /* default */])(this.props);
      nodeRegistry.add(nodeRef, this);
      nodeRegistry.emit(nodeRef, __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      nodeRegistry.emit(Object(__WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__["a" /* default */])(this.props), __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var nodeRef = Object(__WEBPACK_IMPORTED_MODULE_9__lib_getNodeRefFromProps__["a" /* default */])(this.props);
      nodeRegistry.del(nodeRef, this);
      nodeRegistry.emit(nodeRef, __WEBPACK_IMPORTED_MODULE_10__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return MountNode;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(MountNode, "handledProps", ["className", "node"]);


MountNode.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** The DOM node where we will apply class names. Defaults to document.body. */
  node: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject])
} : {};

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(5);



/**
 * Given `this.props`, return a `node` value or undefined.
 *
 * @param {object|React.RefObject} props Component's props
 * @return {React.RefObject|undefined}
 */

var getNodeRefFromProps = function getNodeRefFromProps(props) {
  var node = props.node;

  if (Object(__WEBPACK_IMPORTED_MODULE_2__lib__["t" /* isBrowser */])()) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__stardust_ui_react_component_ref__["c" /* isRefObject */])(node)) return node;
    return __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(node) ? Object(__WEBPACK_IMPORTED_MODULE_1__stardust_ui_react_component_ref__["d" /* toRefObject */])(document.body) : Object(__WEBPACK_IMPORTED_MODULE_1__stardust_ui_react_component_ref__["d" /* toRefObject */])(node);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getNodeRefFromProps);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeClassNames__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeClassNamesDifference__ = __webpack_require__(1051);




var prevClassNames = new Map();
/**
 * @param {React.RefObject} nodeRef
 * @param {Object[]} components
 */

var handleClassNamesChange = function handleClassNamesChange(nodeRef, components) {
  var currentClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__computeClassNames__["a" /* default */])(components);

  var _computeClassNamesDif = Object(__WEBPACK_IMPORTED_MODULE_3__computeClassNamesDifference__["a" /* default */])(prevClassNames.get(nodeRef), currentClassNames),
      _computeClassNamesDif2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_computeClassNamesDif, 2),
      forAdd = _computeClassNamesDif2[0],
      forRemoval = _computeClassNamesDif2[1];

  if (nodeRef.current) {
    __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(forAdd, function (className) {
      return nodeRef.current.classList.add(className);
    });

    __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(forRemoval, function (className) {
      return nodeRef.current.classList.remove(className);
    });
  }

  prevClassNames.set(nodeRef, currentClassNames);
};

/* harmony default export */ __webpack_exports__["a"] = (handleClassNamesChange);

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_split__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow__);









var computeClassNames = __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray___default.a, __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default()('props.className'), __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_split___default()(/\s+/)), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default.a), __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq___default.a);

/* harmony default export */ __webpack_exports__["a"] = (computeClassNames);

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('uniq', __webpack_require__(272), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('identity', __webpack_require__(65), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('filter', __webpack_require__(127));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('split', __webpack_require__(1043));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(165),
    castSlice = __webpack_require__(271),
    hasUnicode = __webpack_require__(186),
    isIterateeCall = __webpack_require__(106),
    isRegExp = __webpack_require__(1044),
    stringToArray = __webpack_require__(185),
    toString = __webpack_require__(64);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1045),
    baseUnary = __webpack_require__(93),
    nodeUtil = __webpack_require__(171);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(57),
    isObjectLike = __webpack_require__(41);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('flatMap', __webpack_require__(1047));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(136),
    map = __webpack_require__(30);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(29),
    func = convert('toArray', __webpack_require__(1049), __webpack_require__(60));

func.placeholder = __webpack_require__(28);
module.exports = func;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(89),
    copyArray = __webpack_require__(107),
    getTag = __webpack_require__(81),
    isArrayLike = __webpack_require__(58),
    isString = __webpack_require__(189),
    iteratorToArray = __webpack_require__(1050),
    mapToArray = __webpack_require__(401),
    setToArray = __webpack_require__(177),
    stringToArray = __webpack_require__(185),
    values = __webpack_require__(137);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_difference__);


var computeClassNamesDifference = function computeClassNamesDifference(prevClassNames, currentClassNames) {
  return [__WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(currentClassNames, prevClassNames), __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(prevClassNames, currentClassNames)];
};

/* harmony default export */ __webpack_exports__["a"] = (computeClassNamesDifference);

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NodeRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);



var NodeRegistry = function NodeRegistry() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NodeRegistry);

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(this, "add", function (nodeRef, component) {
    if (_this.nodes.has(nodeRef)) {
      var set = _this.nodes.get(nodeRef);

      set.add(component);
      return;
    }

    _this.nodes.set(nodeRef, new Set([component]));
  });

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(this, "del", function (nodeRef, component) {
    if (!_this.nodes.has(nodeRef)) return;

    var set = _this.nodes.get(nodeRef);

    if (set.size === 1) {
      _this.nodes["delete"](nodeRef);

      return;
    }

    set["delete"](component);
  });

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(this, "emit", function (nodeRef, callback) {
    callback(nodeRef, _this.nodes.get(nodeRef));
  });

  this.nodes = new Map();
};



/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLegacyStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLegacy; });
// https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L956
var OFFSET = 0; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L990

var PADDING = 50;
/**
 * Ensures that modal can fit viewport without scroll.
 *
 * @param modalRect {DOMRect}
 *
 * @see https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L608
 */

var canFit = function canFit(modalRect) {
  // original: scrollHeight = $module.prop('scrollHeight'),
  // is replaced by .height because scrollHeight provides integer which produces glitches
  // https://github.com/Semantic-Org/Semantic-UI-React/issues/2221
  var scrollHeight = modalRect.height + OFFSET; // $module.outerHeight() + settings.offset

  var height = modalRect.height + OFFSET; // original: $(window).height()

  var contextHeight = window.innerHeight;
  var verticalCenter = contextHeight / 2;
  var topOffset = -(height / 2); // padding with edge of page

  var paddingHeight = PADDING;
  var startPosition = verticalCenter + topOffset; // 0
  // original: scrollHeight > height
  //     ? startPosition + scrollHeight + paddingHeight < contextHeight
  //     : height + paddingHeight * 2 < contextHeight

  return startPosition + scrollHeight + paddingHeight < contextHeight;
};
/**
 * Creates legacy styles for IE11.
 *
 * @param isFitted {Boolean}
 * @param centered {Boolean}
 * @param modalRect {DOMRect}
 *
 * @see https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L718
 */

var getLegacyStyles = function getLegacyStyles(isFitted, centered, modalRect) {
  var marginTop = centered && isFitted ? -(modalRect.height / 2) : 0;
  var marginLeft = -(modalRect.width / 2);
  return {
    marginLeft: marginLeft,
    marginTop: marginTop
  };
}; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L631

/* istanbul ignore next */

var isLegacy = function isLegacy() {
  return !window.ActiveXObject && 'ActiveXObject' in window;
};

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(1055);
/* unused harmony reexport default */



/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Menu__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PaginationItem__ = __webpack_require__(469);

















/**
 * A component to render a pagination.
 */

var Pagination =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Pagination, _Component);

  function Pagination() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Pagination)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, _ref) {
      var nextActivePage = _ref.value;
      var prevActivePage = _this.state.activePage; // Heads up! We need the cast to the "number" type there, as `activePage` can be a string

      if (+prevActivePage === +nextActivePage) return;

      _this.trySetState({
        activePage: nextActivePage
      });

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onPageChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        activePage: nextActivePage
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemOverrides", function (active, type, value) {
      return function (predefinedProps) {
        return {
          active: active,
          type: type,
          key: "".concat(type, "-").concat(value),
          onClick: function onClick(e, itemProps) {
            __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);

            if (itemProps.type !== 'ellipsisItem') _this.handleItemClick(e, itemProps);
          }
        };
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          boundaryRange = _this$props.boundaryRange,
          disabled = _this$props.disabled,
          ellipsisItem = _this$props.ellipsisItem,
          siblingRange = _this$props.siblingRange,
          totalPages = _this$props.totalPages;
      var activePage = this.state.activePage;
      var items = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["j" /* createPaginationItems */])({
        activePage: activePage,
        boundaryRange: boundaryRange,
        hideEllipsis: __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(ellipsisItem),
        siblingRange: siblingRange,
        totalPages: totalPages
      });
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(Pagination, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__collections_Menu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        "aria-label": ariaLabel,
        pagination: true,
        role: "navigation"
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(items, function (_ref2) {
        var active = _ref2.active,
            type = _ref2.type,
            value = _ref2.value;
        return __WEBPACK_IMPORTED_MODULE_16__PaginationItem__["a" /* default */].create(_this2.props[type], {
          defaultProps: {
            content: value,
            disabled: disabled,
            value: value
          },
          overrideProps: _this2.handleItemOverrides(active, type, value)
        });
      }));
    }
  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "autoControlledProps", ['activePage']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "defaultProps", {
  'aria-label': 'Pagination Navigation',
  boundaryRange: 1,
  ellipsisItem: '...',
  firstItem: {
    'aria-label': 'First item',
    content: '«'
  },
  lastItem: {
    'aria-label': 'Last item',
    content: '»'
  },
  nextItem: {
    'aria-label': 'Next item',
    content: '⟩'
  },
  pageItem: {},
  prevItem: {
    'aria-label': 'Previous item',
    content: '⟨'
  },
  siblingRange: 1
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "Item", __WEBPACK_IMPORTED_MODULE_16__PaginationItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Pagination, "handledProps", ["activePage", "aria-label", "boundaryRange", "defaultActivePage", "disabled", "ellipsisItem", "firstItem", "lastItem", "nextItem", "onPageChange", "pageItem", "prevItem", "siblingRange", "totalPages"]);


Pagination.propTypes =  false ? {
  /** A pagination item can have an aria label. */
  'aria-label': PropTypes.string,

  /** Initial activePage value. */
  defaultActivePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active page. */
  activePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Number of always visible pages at the beginning and end. */
  boundaryRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A pagination can be disabled. */
  disabled: PropTypes.bool,

  /** A shorthand for PaginationItem. */
  ellipsisItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  firstItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  lastItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  nextItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  pageItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  prevItem: customPropTypes.itemShorthand,

  /**
   * Called on change of an active page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onPageChange: PropTypes.func,

  /** Number of always visible pages before and after the current one. */
  siblingRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Total number of pages. */
  totalPages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
} : {};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(1057),
    upperFirst = __webpack_require__(1064);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(458),
    deburr = __webpack_require__(467),
    words = __webpack_require__(1060);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(1059);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(1061),
    hasUnicodeWord = __webpack_require__(1062),
    toString = __webpack_require__(64),
    unicodeWords = __webpack_require__(1063);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1065);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(271),
    hasUnicode = __webpack_require__(186),
    stringToArray = __webpack_require__(185),
    toString = __webpack_require__(64);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__ = __webpack_require__(194);




/**
 * A Radio is sugar for <Checkbox radio />.
 * Useful for exclusive groups of sliders or toggles.
 * @see Checkbox
 * @see Form
 */

function Radio(props) {
  var slider = props.slider,
      toggle = props.toggle,
      type = props.type;
  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getUnhandledProps */])(Radio, props); // const ElementType = getElementType(Radio, props)
  // radio, slider, toggle are exclusive
  // use an undefined radio if slider or toggle are present

  var radio = !(slider || toggle) || undefined;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    type: type,
    radio: radio,
    slider: slider,
    toggle: toggle
  }));
}

Radio.handledProps = ["slider", "toggle", "type"];
Radio.propTypes =  false ? {
  /** Format to emphasize the current selection state. */
  slider: Checkbox.propTypes.slider,

  /** Format to show an on or off choice. */
  toggle: Checkbox.propTypes.toggle,

  /** HTML input type, either checkbox or radio. */
  type: Checkbox.propTypes.type
} : {};
Radio.defaultProps = {
  type: 'radio'
};
/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_set__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib__ = __webpack_require__(5);




















/**
 * A checkbox allows a user to select a value from a small set of options, often binary.
 * @see Form
 * @see Radio
 */
var Checkbox =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Checkbox, _Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "inputRef", Object(__WEBPACK_IMPORTED_MODULE_17_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "labelRef", Object(__WEBPACK_IMPORTED_MODULE_17_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "canToggle", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          radio = _this$props.radio,
          readOnly = _this$props.readOnly;
      var checked = _this.state.checked;
      return !disabled && !readOnly && !(radio && checked);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default()(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var id = _this.props.id;
      var _this$state = _this.state,
          checked = _this$state.checked,
          indeterminate = _this$state.indeterminate;

      var isInputClick = __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.inputRef.current, 'contains', e.target);

      var isLabelClick = __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.labelRef.current, 'contains', e.target);

      var isRootClick = !isLabelClick && !isInputClick;
      var hasId = !__WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default()(id);
      var isLabelClickAndForwardedToInput = isLabelClick && hasId; // https://github.com/Semantic-Org/Semantic-UI-React/pull/3351

      if (!isLabelClickAndForwardedToInput) {
        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onClick', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          checked: !checked,
          indeterminate: !!indeterminate
        }));
      }

      if (_this.isClickFromMouse) {
        _this.isClickFromMouse = false;

        if (isLabelClick && !hasId) {
          _this.handleChange(e);
        } // Changes should be triggered for the slider variation


        if (isRootClick) {
          _this.handleChange(e);
        }

        if (isLabelClick && hasId) {
          // To prevent two clicks from being fired from the component we have to stop the propagation
          // from the "input" click: https://github.com/Semantic-Org/Semantic-UI-React/issues/3433
          e.stopPropagation();
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var checked = _this.state.checked;
      if (!_this.canToggle()) return;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        checked: !checked,
        indeterminate: false
      }));

      _this.trySetState({
        checked: !checked,
        indeterminate: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseDown", function (e) {
      var _this$state2 = _this.state,
          checked = _this$state2.checked,
          indeterminate = _this$state2.indeterminate;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onMouseDown', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        checked: !!checked,
        indeterminate: !!indeterminate
      }));

      if (!e.defaultPrevented) {
        __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.inputRef.current, 'focus');
      } // Heads up!
      // We need to call "preventDefault" to keep element focused.


      e.preventDefault();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseUp", function (e) {
      var _this$state3 = _this.state,
          checked = _this$state3.checked,
          indeterminate = _this$state3.indeterminate;
      _this.isClickFromMouse = true;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onMouseUp', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        checked: !!checked,
        indeterminate: !!indeterminate
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "setIndeterminate", function () {
      var indeterminate = _this.state.indeterminate;

      __WEBPACK_IMPORTED_MODULE_10_lodash_set___default()(_this.inputRef, 'current.indeterminate', !!indeterminate);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIndeterminate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setIndeterminate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          label = _this$props3.label,
          id = _this$props3.id,
          name = _this$props3.name,
          radio = _this$props3.radio,
          readOnly = _this$props3.readOnly,
          slider = _this$props3.slider,
          toggle = _this$props3.toggle,
          type = _this$props3.type,
          value = _this$props3.value;
      var _this$state4 = this.state,
          checked = _this$state4.checked,
          indeterminate = _this$state4.indeterminate;
      var classes = __WEBPACK_IMPORTED_MODULE_15_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(checked, 'checked'), Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(indeterminate, 'indeterminate'), // auto apply fitted class to compact white space when there is no label
      // https://semantic-ui.com/modules/checkbox.html#fitted
      Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(__WEBPACK_IMPORTED_MODULE_13_lodash_isNil___default()(label), 'fitted'), Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(radio, 'radio'), Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(readOnly, 'read-only'), Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(slider, 'slider'), Object(__WEBPACK_IMPORTED_MODULE_18__lib__["y" /* useKeyOnly */])(toggle, 'toggle'), 'checkbox', className);
      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_18__lib__["q" /* getUnhandledProps */])(Checkbox, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_18__lib__["p" /* getElementType */])(Checkbox, this.props);

      var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_18__lib__["x" /* partitionHTMLProps */])(unhandled, {
        htmlProps: __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* htmlInputAttrs */]
      }),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1]; // Heads Up!
      // Do not remove empty labels, they are required by SUI CSS


      var labelElement = Object(__WEBPACK_IMPORTED_MODULE_18__lib__["h" /* createHTMLLabel */])(label, {
        defaultProps: {
          htmlFor: id
        },
        autoGenerateKey: false
      }) || __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label", {
        htmlFor: id
      });
      return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick,
        onChange: this.handleChange,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp
      }), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.inputRef
      }, __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("input", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, htmlInputProps, {
        checked: checked,
        className: "hidden",
        disabled: disabled,
        id: id,
        name: name,
        readOnly: true,
        tabIndex: this.computeTabIndex(),
        type: type,
        value: value
      }))), __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.labelRef
      }, labelElement));
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Checkbox, "defaultProps", {
  type: 'checkbox'
});

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Checkbox, "autoControlledProps", ['checked', 'indeterminate']);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Checkbox, "handledProps", ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"]);


Checkbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Whether or not checkbox is checked. */
  checked: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** The initial value of checked. */
  defaultChecked: PropTypes.bool,

  /** Whether or not checkbox is indeterminate. */
  defaultIndeterminate: PropTypes.bool,

  /** A checkbox can appear disabled and be unable to change states */
  disabled: PropTypes.bool,

  /** Removes padding for a label. Auto applied when there is no label. */
  fitted: PropTypes.bool,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Whether or not checkbox is indeterminate. */
  indeterminate: PropTypes.bool,

  /** The text of the associated label element. */
  label: customPropTypes.itemShorthand,

  /** The HTML input name. */
  name: PropTypes.string,

  /**
   * Called when the user attempts to change the checked state.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed checked/indeterminate state.
   */
  onChange: PropTypes.func,

  /**
   * Called when the checkbox or label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onClick: PropTypes.func,

  /**
   * Called when the user presses down on the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when the user releases the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseUp: PropTypes.func,

  /** Format as a radio element. This means it is an exclusive option. */
  radio: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['slider', 'toggle'])]),

  /** A checkbox can be read-only and unable to change states. */
  readOnly: PropTypes.bool,

  /** Format to emphasize the current selection state. */
  slider: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'toggle'])]),

  /** A checkbox can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Format to show an on or off choice. */
  toggle: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'slider'])]),

  /** HTML input type, either checkbox or radio. */
  type: PropTypes.oneOf(['checkbox', 'radio']),

  /** The HTML input value. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(435);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Responsive__ = __webpack_require__(1070);
/* unused harmony reexport default */



/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_isVisible__ = __webpack_require__(1071);













/**
 * Responsive can control visibility of content.
 */

var Responsive =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Responsive, _Component);

  function Responsive() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Responsive);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Responsive)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      visible: true
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleResize", function (e) {
      if (_this.ticking) return;
      _this.ticking = true;
      _this.frameId = requestAnimationFrame(function () {
        return _this.handleUpdate(e);
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUpdate", function (e) {
      _this.ticking = false;
      var visible = _this.state.visible;

      var width = __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'getWidth');

      var nextVisible = Object(__WEBPACK_IMPORTED_MODULE_12__lib_isVisible__["a" /* default */])(width, _this.props);
      if (visible !== nextVisible) _this.setState({
        visible: nextVisible
      });

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onUpdate', e, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        width: width
      }));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Responsive, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var fireOnMount = this.props.fireOnMount;
      __WEBPACK_IMPORTED_MODULE_11__lib__["n" /* eventStack */].sub('resize', this.handleResize, {
        target: 'window'
      });
      if (fireOnMount) this.handleUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_11__lib__["n" /* eventStack */].unsub('resize', this.handleResize, {
        target: 'window'
      });
      cancelAnimationFrame(this.frameId);
    } // ----------------------------------------
    // Event handlers
    // ----------------------------------------

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var children = this.props.children;
      var visible = this.state.visible;
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["p" /* getElementType */])(Responsive, this.props);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getUnhandledProps */])(Responsive, this.props);
      if (visible) return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, rest, children);
      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var width = __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(props, 'getWidth');

      var visible = Object(__WEBPACK_IMPORTED_MODULE_12__lib_isVisible__["a" /* default */])(width, props);
      return {
        visible: visible
      };
    }
  }]);

  return Responsive;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "defaultProps", {
  getWidth: function getWidth() {
    return Object(__WEBPACK_IMPORTED_MODULE_11__lib__["t" /* isBrowser */])() ? window.innerWidth : 0;
  }
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyMobile", {
  minWidth: 320,
  maxWidth: 767
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyTablet", {
  minWidth: 768,
  maxWidth: 991
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyComputer", {
  minWidth: 992
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyLargeScreen", {
  minWidth: 1200,
  maxWidth: 1919
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "onlyWidescreen", {
  minWidth: 1920
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Responsive, "handledProps", ["as", "children", "fireOnMount", "getWidth", "maxWidth", "minWidth", "onUpdate"]);


Responsive.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /**
   * Called to get width of screen. Defaults to using `window.innerWidth` when in a browser;
   * otherwise, assumes a width of 0.
   */
  getWidth: PropTypes.func,

  /** The maximum width at which content will be displayed. */
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The minimum width at which content will be displayed. */
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called on update.
   *
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onUpdate: PropTypes.func
} : {};

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);


var fitsMaxWidth = function fitsMaxWidth(width, maxWidth) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(maxWidth) ? true : width <= maxWidth;
};

var fitsMinWidth = function fitsMinWidth(width, minWidth) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(minWidth) ? true : width >= minWidth;
};

var isVisible = function isVisible(width, _ref) {
  var maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth;
  return fitsMinWidth(width, minWidth) && fitsMaxWidth(width, maxWidth);
};

/* harmony default export */ __webpack_exports__["a"] = (isVisible);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__ = __webpack_require__(195);




/**
 * A Select is sugar for <Dropdown selection />.
 * @see Dropdown
 * @see Form
 */

function Select(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
    selection: true
  }));
}

Select.handledProps = ["options"];
Select.propTypes =  false ? {
  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: PropTypes.arrayOf(PropTypes.shape(Dropdown.Item.propTypes)).isRequired
} : {};
Select.Divider = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Divider;
Select.Header = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Header;
Select.Item = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Item;
Select.Menu = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Menu;
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_compact__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_every__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_findIndex__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_find__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_reduce__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_some__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_deburr__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_deburr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_deburr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isFunction__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_filter__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_pick__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_dropRight__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_size__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_difference__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_union__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_noop__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_isUndefined__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_isEqual__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_lodash_has__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_keyboard_key__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_shallowequal__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__elements_Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__elements_Label__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__DropdownDivider__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__DropdownItem__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__DropdownHeader__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__DropdownMenu__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__DropdownSearchInput__ = __webpack_require__(477);




















































var getKeyOrValue = function getKeyOrValue(key, value) {
  return __WEBPACK_IMPORTED_MODULE_35_lodash_isNil___default()(key) ? value : key;
};
/**
 * A dropdown allows a user to select a value from a series of options.
 * @see Form
 * @see Select
 * @see Menu
 */


var Dropdown =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Dropdown, _Component);

  function Dropdown() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "searchRef", Object(__WEBPACK_IMPORTED_MODULE_41_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "sizerRef", Object(__WEBPACK_IMPORTED_MODULE_41_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", Object(__WEBPACK_IMPORTED_MODULE_41_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e, value) {
      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnChange", function (e) {
      var _this$props = _this.props,
          closeOnChange = _this$props.closeOnChange,
          multiple = _this$props.multiple;
      var shouldClose = __WEBPACK_IMPORTED_MODULE_31_lodash_isUndefined___default()(closeOnChange) ? !multiple : closeOnChange;
      if (shouldClose) _this.close(e, __WEBPACK_IMPORTED_MODULE_30_lodash_noop___default.a);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnEscape", function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.Escape) return;
      e.preventDefault();

      _this.close(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionOnKeyDown", function (e) {
      var _moves;

      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          selectOnNavigation = _this$props2.selectOnNavigation;
      var moves = (_moves = {}, __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_moves, __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.ArrowDown, 1), __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_moves, __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.ArrowUp, -1), _moves);
      var move = moves[__WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e)];
      if (move === undefined) return;
      e.preventDefault();

      _this.moveSelectionBy(move);

      if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "openOnSpace", function (e) {
      if (__WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.Spacebar) return;
      e.preventDefault();

      _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "openOnArrow", function (e) {
      var code = __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e);
      if (!__WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()([__WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.ArrowDown, __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.ArrowUp], code)) return;
      if (_this.state.open) return;
      e.preventDefault();

      _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "makeSelectedItemActive", function (e) {
      var _this$state = _this.state,
          open = _this$state.open,
          value = _this$state.value;
      var multiple = _this.props.multiple;

      var item = _this.getSelectedItem();

      var selectedValue = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(item, 'value'); // prevent selecting null if there was no selected item value
      // prevent selecting duplicate items when the dropdown is closed


      if (__WEBPACK_IMPORTED_MODULE_35_lodash_isNil___default()(selectedValue) || !open) return; // state value may be undefined

      var newValue = multiple ? __WEBPACK_IMPORTED_MODULE_27_lodash_union___default()(_this.state.value, [selectedValue]) : selectedValue;
      var valueHasChanged = multiple ? !!__WEBPACK_IMPORTED_MODULE_26_lodash_difference___default()(newValue, value).length : newValue !== value;

      if (valueHasChanged) {
        // notify the onChange prop that the user is trying to change value
        _this.setValue(newValue);

        _this.setSelectedIndex(newValue);

        _this.handleChange(e, newValue); // Heads up! This event handler should be called after `onChange`
        // Notify the onAddItem prop if this is a new value


        if (item['data-additional']) {
          __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onAddItem', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
            value: selectedValue
          }));
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "selectItemOnEnter", function (e) {
      var search = _this.props.search;
      var shouldSelect = __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.Enter || // https://github.com/Semantic-Org/Semantic-UI-React/pull/3766
      !search && __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.Spacebar;
      if (!shouldSelect) return;
      e.preventDefault();

      var optionSize = __WEBPACK_IMPORTED_MODULE_25_lodash_size___default()(_this.getMenuOptions());

      if (search && optionSize === 0) return;

      _this.makeSelectedItemActive(e);

      _this.closeOnChange(e);

      _this.clearSearchQuery();

      if (search) __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.searchRef.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "removeItemOnBackspace", function (e) {
      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          search = _this$props3.search;
      var _this$state2 = _this.state,
          searchQuery = _this$state2.searchQuery,
          value = _this$state2.value;
      if (__WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_39_keyboard_key___default.a.Backspace) return;
      if (searchQuery || !search || !multiple || __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(value)) return;
      e.preventDefault(); // remove most recent value

      var newValue = __WEBPACK_IMPORTED_MODULE_23_lodash_dropRight___default()(value);

      _this.setValue(newValue);

      _this.setSelectedIndex(newValue);

      _this.handleChange(e, newValue);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnDocumentClick", function (e) {
      if (!_this.props.closeOnBlur) return; // If event happened in the dropdown, ignore it

      if (_this.ref.current && Object(__WEBPACK_IMPORTED_MODULE_43__lib__["m" /* doesNodeContainClick */])(_this.ref.current, e)) return;

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseDown", function (e) {
      _this.isMouseDown = true;

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onMouseDown', e, _this.props);

      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseUp", function () {
      _this.isMouseDown = false;
      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var _this$props4 = _this.props,
          minCharacters = _this$props4.minCharacters,
          search = _this$props4.search;
      var _this$state3 = _this.state,
          open = _this$state3.open,
          searchQuery = _this$state3.searchQuery;

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onClick', e, _this.props); // prevent closeOnDocumentClick()


      e.stopPropagation();
      if (!search) return _this.toggle(e);

      if (open) {
        __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.searchRef.current, 'focus');

        return;
      }

      if (searchQuery.length >= minCharacters || minCharacters === 1) {
        _this.open(e);

        return;
      }

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.searchRef.current, 'focus');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconClick", function (e) {
      var clearable = _this.props.clearable;

      var hasValue = _this.hasValue();

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onClick', e, _this.props); // prevent handleClick()


      e.stopPropagation();

      if (clearable && hasValue) {
        _this.clearValue(e);
      } else {
        _this.toggle(e);
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, item) {
      var _this$props5 = _this.props,
          multiple = _this$props5.multiple,
          search = _this$props5.search;
      var currentValue = _this.state.value;
      var value = item.value; // prevent toggle() in handleClick()

      e.stopPropagation(); // prevent closeOnDocumentClick() if multiple or item is disabled

      if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
      if (item.disabled) return;
      var isAdditionItem = item['data-additional'];
      var newValue = multiple ? __WEBPACK_IMPORTED_MODULE_27_lodash_union___default()(_this.state.value, [value]) : value;
      var valueHasChanged = multiple ? !!__WEBPACK_IMPORTED_MODULE_26_lodash_difference___default()(newValue, currentValue).length : newValue !== currentValue; // notify the onChange prop that the user is trying to change value

      if (valueHasChanged) {
        _this.setValue(newValue);

        _this.setSelectedIndex(value);

        _this.handleChange(e, newValue);
      }

      _this.clearSearchQuery(value);

      if (search) {
        __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.searchRef.current, 'focus');
      } else {
        __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.ref.current, 'focus');
      }

      _this.closeOnChange(e); // Heads up! This event handler should be called after `onChange`
      // Notify the onAddItem prop if this is a new value


      if (isAdditionItem) __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onAddItem', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleFocus", function (e) {
      var focus = _this.state.focus;
      if (focus) return;

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onFocus', e, _this.props);

      _this.setState({
        focus: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleBlur", function (e) {
      // Heads up! Don't remove this.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
      var currentTarget = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(e, 'currentTarget');

      if (currentTarget && currentTarget.contains(document.activeElement)) return;
      var _this$props6 = _this.props,
          closeOnBlur = _this$props6.closeOnBlur,
          multiple = _this$props6.multiple,
          selectOnBlur = _this$props6.selectOnBlur; // do not "blur" when the mouse is down inside of the Dropdown

      if (_this.isMouseDown) return;

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onBlur', e, _this.props);

      if (selectOnBlur && !multiple) {
        _this.makeSelectedItemActive(e);

        if (closeOnBlur) _this.close();
      }

      _this.setState({
        focus: false
      });

      _this.clearSearchQuery();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSearchChange", function (e, _ref) {
      var value = _ref.value;
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;
      var newQuery = value;

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onSearchChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        searchQuery: newQuery
      }));

      _this.trySetState({
        searchQuery: newQuery,
        selectedIndex: 0
      }); // open search dropdown on search query


      if (!open && newQuery.length >= minCharacters) {
        _this.open();

        return;
      } // close search dropdown if search query is too small


      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getKeyAndValues", function (options) {
      return options ? options.map(function (option) {
        return __WEBPACK_IMPORTED_MODULE_22_lodash_pick___default()(option, ['key', 'value']);
      }) : options;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getMenuOptions", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.searchQuery;
      var _this$props7 = _this.props,
          additionLabel = _this$props7.additionLabel,
          additionPosition = _this$props7.additionPosition,
          allowAdditions = _this$props7.allowAdditions,
          deburr = _this$props7.deburr,
          multiple = _this$props7.multiple,
          search = _this$props7.search;
      var filteredOptions = options; // filter out active options

      if (multiple) {
        filteredOptions = __WEBPACK_IMPORTED_MODULE_21_lodash_filter___default()(filteredOptions, function (opt) {
          return !__WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()(value, opt.value);
        });
      } // filter by search query


      if (search && searchQuery) {
        if (__WEBPACK_IMPORTED_MODULE_20_lodash_isFunction___default()(search)) {
          filteredOptions = search(filteredOptions, searchQuery);
        } else {
          // remove diacritics on search input and options, if deburr prop is set
          var strippedQuery = deburr ? __WEBPACK_IMPORTED_MODULE_19_lodash_deburr___default()(searchQuery) : searchQuery;
          var re = new RegExp(__WEBPACK_IMPORTED_MODULE_18_lodash_escapeRegExp___default()(strippedQuery), 'i');
          filteredOptions = __WEBPACK_IMPORTED_MODULE_21_lodash_filter___default()(filteredOptions, function (opt) {
            return re.test(deburr ? __WEBPACK_IMPORTED_MODULE_19_lodash_deburr___default()(opt.text) : opt.text);
          });
        }
      } // insert the "add" item


      if (allowAdditions && search && searchQuery && !__WEBPACK_IMPORTED_MODULE_17_lodash_some___default()(filteredOptions, {
        text: searchQuery
      })) {
        var additionLabelElement = __WEBPACK_IMPORTED_MODULE_41_react___default.a.isValidElement(additionLabel) ? __WEBPACK_IMPORTED_MODULE_41_react___default.a.cloneElement(additionLabel, {
          key: 'addition-label'
        }) : additionLabel || '';
        var addItem = {
          key: 'addition',
          // by using an array, we can pass multiple elements, but when doing so
          // we must specify a `key` for React to know which one is which
          text: [additionLabelElement, __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement("b", {
            key: "addition-query"
          }, searchQuery)],
          value: searchQuery,
          className: 'addition',
          'data-additional': true
        };
        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
      }

      return filteredOptions;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getSelectedItem", function () {
      var selectedIndex = _this.state.selectedIndex;

      var options = _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(options, "[".concat(selectedIndex, "]"));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getEnabledIndices", function (givenOptions) {
      var options = givenOptions || _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_16_lodash_reduce___default()(options, function (memo, item, index) {
        if (!item.disabled) memo.push(index);
        return memo;
      }, []);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getItemByValue", function (value) {
      var options = _this.props.options;
      return __WEBPACK_IMPORTED_MODULE_15_lodash_find___default()(options, {
        value: value
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getMenuItemIndexByValue", function (value, givenOptions) {
      var options = givenOptions || _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_14_lodash_findIndex___default()(options, ['value', value]);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getDropdownAriaOptions", function () {
      var _this$props8 = _this.props,
          loading = _this$props8.loading,
          disabled = _this$props8.disabled,
          search = _this$props8.search,
          multiple = _this$props8.multiple;
      var open = _this.state.open;
      var ariaOptions = {
        role: search ? 'combobox' : 'listbox',
        'aria-busy': loading,
        'aria-disabled': disabled,
        'aria-expanded': !!open
      };

      if (ariaOptions.role === 'listbox') {
        ariaOptions['aria-multiselectable'] = multiple;
      }

      return ariaOptions;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "clearSearchQuery", function (value) {
      var searchQuery = _this.state.searchQuery;
      if (searchQuery === undefined || searchQuery === '') return;

      _this.trySetState({
        searchQuery: ''
      });

      _this.setSelectedIndex(value, undefined, '');
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "setValue", function (value) {
      _this.trySetState({
        value: value
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "setSelectedIndex", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.searchQuery;
      var multiple = _this.props.multiple;
      var selectedIndex = _this.state.selectedIndex;

      var options = _this.getMenuOptions(value, optionsProps, searchQuery);

      var enabledIndicies = _this.getEnabledIndices(options);

      var newSelectedIndex; // update the selected index

      if (!selectedIndex || selectedIndex < 0) {
        var firstIndex = enabledIndicies[0]; // Select the currently active item, if none, use the first item.
        // Multiple selects remove active items from the list,
        // their initial selected index should be 0.

        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
      } else if (multiple) {
        // multiple selects remove options from the menu as they are made active
        // keep the selected index within range of the remaining items
        if (selectedIndex >= options.length - 1) {
          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
        }
      } else {
        var activeIndex = _this.getMenuItemIndexByValue(value, options); // regular selects can only have one active item
        // set the selected index to the currently active item


        newSelectedIndex = __WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()(enabledIndicies, activeIndex) ? activeIndex : undefined;
      }

      if (!newSelectedIndex || newSelectedIndex < 0) {
        newSelectedIndex = enabledIndicies[0];
      }

      _this.setState({
        selectedIndex: newSelectedIndex
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleLabelClick", function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();

      _this.setState({
        selectedLabel: labelProps.value
      });

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onLabelClick', e, labelProps);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleLabelRemove", function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();
      var value = _this.state.value;

      var newValue = __WEBPACK_IMPORTED_MODULE_13_lodash_without___default()(value, labelProps.value);

      _this.setValue(newValue);

      _this.setSelectedIndex(newValue);

      _this.handleChange(e, newValue);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionBy", function (offset) {
      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;

      var options = _this.getMenuOptions(); // Prevent infinite loop
      // TODO: remove left part of condition after children API will be removed


      if (options === undefined || __WEBPACK_IMPORTED_MODULE_12_lodash_every___default()(options, 'disabled')) return;
      var lastIndex = options.length - 1;
      var wrapSelection = _this.props.wrapSelection; // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = startIndex + offset; // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change

      if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) {
        nextIndex = startIndex;
      } else if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      if (options[nextIndex].disabled) {
        _this.moveSelectionBy(offset, nextIndex);

        return;
      }

      _this.setState({
        selectedIndex: nextIndex
      });

      _this.scrollSelectedItemIntoView();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconOverrides", function (predefinedProps) {
      var clearable = _this.props.clearable;
      var classes = __WEBPACK_IMPORTED_MODULE_38_classnames___default()(clearable && _this.hasValue() && 'clear', predefinedProps.className);
      return {
        className: classes,
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(predefinedProps, 'onClick', e, predefinedProps);

          _this.handleIconClick(e);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "clearValue", function (e) {
      var multiple = _this.props.multiple;
      var newValue = multiple ? [] : '';

      _this.setValue(newValue);

      _this.setSelectedIndex(newValue);

      _this.handleChange(e, newValue);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeSearchInputTabIndex", function () {
      var _this$props9 = _this.props,
          disabled = _this$props9.disabled,
          tabIndex = _this$props9.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_35_lodash_isNil___default()(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeSearchInputWidth", function () {
      var searchQuery = _this.state.searchQuery;

      if (_this.sizerRef.current && searchQuery) {
        // resize the search input, temporarily show the sizer so we can measure it
        _this.sizerRef.current.style.display = 'inline';
        _this.sizerRef.current.textContent = searchQuery;
        var searchWidth = Math.ceil(_this.sizerRef.current.getBoundingClientRect().width);

        _this.sizerRef.current.style.removeProperty('display');

        return searchWidth;
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function () {
      var _this$props10 = _this.props,
          disabled = _this$props10.disabled,
          search = _this$props10.search,
          tabIndex = _this$props10.tabIndex; // don't set a root node tabIndex as the search input has its own tabIndex

      if (search) return undefined;
      if (disabled) return -1;
      return __WEBPACK_IMPORTED_MODULE_35_lodash_isNil___default()(tabIndex) ? 0 : tabIndex;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSearchInputOverrides", function (predefinedProps) {
      return {
        onChange: function onChange(e, inputProps) {
          __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(predefinedProps, 'onChange', e, inputProps);

          _this.handleSearchChange(e, inputProps);
        }
      };
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "hasValue", function () {
      var multiple = _this.props.multiple;
      var value = _this.state.value;
      return multiple ? !__WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(value) : !__WEBPACK_IMPORTED_MODULE_35_lodash_isNil___default()(value) && value !== '';
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "scrollSelectedItemIntoView", function () {
      if (!_this.ref.current) return;

      var menu = _this.ref.current.querySelector('.menu.visible');

      if (!menu) return;
      var item = menu.querySelector('.item.selected');
      if (!item) return;
      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        // eslint-disable-next-line no-mixed-operators
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "setOpenDirection", function () {
      if (!_this.ref.current) return;

      var menu = _this.ref.current.querySelector('.menu.visible');

      if (!menu) return;

      var dropdownRect = _this.ref.current.getBoundingClientRect();

      var menuHeight = menu.clientHeight;
      var spaceAtTheBottom = document.documentElement.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight;
      var spaceAtTheTop = dropdownRect.top - menuHeight;
      var upward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom; // set state only if there's a relevant difference

      if (!upward !== !_this.state.upward) {
        _this.trySetState({
          upward: upward
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", function (e) {
      var _this$props11 = _this.props,
          disabled = _this$props11.disabled,
          open = _this$props11.open,
          search = _this$props11.search;
      if (disabled) return;
      if (search) __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.searchRef.current, 'focus');

      __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);

      _this.trySetState({
        open: true
      });

      _this.scrollSelectedItemIntoView();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "close", function (e) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.handleClose;
      var open = _this.state.open;

      if (open) {
        __WEBPACK_IMPORTED_MODULE_32_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);

        _this.trySetState({
          open: false
        }, callback);
      }
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClose", function () {
      var hasSearchFocus = document.activeElement === _this.searchRef.current; // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
      // Blur the Dropdown on close so it is blurred after selecting an item.
      // This is to prevent it from re-opening when switching tabs after selecting an item.

      if (!hasSearchFocus && _this.ref.current) {
        _this.ref.current.blur();
      }

      var hasDropdownFocus = document.activeElement === _this.ref.current;
      var hasFocus = hasSearchFocus || hasDropdownFocus; // We need to keep the virtual model in sync with the browser focus change
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692

      _this.setState({
        focus: hasFocus
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "toggle", function (e) {
      return _this.state.open ? _this.close(e) : _this.open(e);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderText", function () {
      var _this$props12 = _this.props,
          multiple = _this$props12.multiple,
          placeholder = _this$props12.placeholder,
          search = _this$props12.search,
          text = _this$props12.text;
      var _this$state4 = _this.state,
          searchQuery = _this$state4.searchQuery,
          value = _this$state4.value,
          open = _this$state4.open;

      var hasValue = _this.hasValue();

      var classes = __WEBPACK_IMPORTED_MODULE_38_classnames___default()(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
      var _text = placeholder;

      if (text) {
        _text = text;
      } else if (open && !multiple) {
        _text = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.getSelectedItem(), 'text');
      } else if (hasValue) {
        _text = __WEBPACK_IMPORTED_MODULE_28_lodash_get___default()(_this.getItemByValue(value), 'text');
      }

      return __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement("div", {
        className: classes,
        role: "alert",
        "aria-live": "polite",
        "aria-atomic": true
      }, _text);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderSearchInput", function () {
      var _this$props13 = _this.props,
          search = _this$props13.search,
          searchInput = _this$props13.searchInput;
      var searchQuery = _this.state.searchQuery;
      return search && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: _this.searchRef
      }, __WEBPACK_IMPORTED_MODULE_50__DropdownSearchInput__["a" /* default */].create(searchInput, {
        defaultProps: {
          style: {
            width: _this.computeSearchInputWidth()
          },
          tabIndex: _this.computeSearchInputTabIndex(),
          value: searchQuery
        },
        overrideProps: _this.handleSearchInputOverrides
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderSearchSizer", function () {
      var _this$props14 = _this.props,
          search = _this$props14.search,
          multiple = _this$props14.multiple;
      return search && multiple && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement("span", {
        className: "sizer",
        ref: _this.sizerRef
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderLabels", function () {
      var _this$props15 = _this.props,
          multiple = _this$props15.multiple,
          renderLabel = _this$props15.renderLabel;
      var _this$state5 = _this.state,
          selectedLabel = _this$state5.selectedLabel,
          value = _this$state5.value;

      if (!multiple || __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(value)) {
        return;
      }

      var selectedItems = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(value, _this.getItemByValue);

      // if no item could be found for a given state value the selected item will be undefined
      // compact the selectedItems so we only have actual objects left
      return __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_compact___default()(selectedItems), function (item, index) {
        var defaultProps = {
          active: item.value === selectedLabel,
          as: 'a',
          key: getKeyOrValue(item.key, item.value),
          onClick: _this.handleLabelClick,
          onRemove: _this.handleLabelRemove,
          value: item.value
        };
        return __WEBPACK_IMPORTED_MODULE_45__elements_Label__["a" /* default */].create(renderLabel(item, index, defaultProps), {
          defaultProps: defaultProps
        });
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderOptions", function () {
      var _this$props16 = _this.props,
          lazyLoad = _this$props16.lazyLoad,
          multiple = _this$props16.multiple,
          search = _this$props16.search,
          noResultsMessage = _this$props16.noResultsMessage;
      var _this$state6 = _this.state,
          open = _this$state6.open,
          selectedIndex = _this$state6.selectedIndex,
          value = _this$state6.value; // lazy load, only render options when open

      if (lazyLoad && !open) return null;

      var options = _this.getMenuOptions();

      if (noResultsMessage !== null && search && __WEBPACK_IMPORTED_MODULE_24_lodash_isEmpty___default()(options)) {
        return __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement("div", {
          className: "message"
        }, noResultsMessage);
      }

      var isActive = multiple ? function (optValue) {
        return __WEBPACK_IMPORTED_MODULE_29_lodash_includes___default()(value, optValue);
      } : function (optValue) {
        return optValue === value;
      };
      return __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(options, function (opt, i) {
        return __WEBPACK_IMPORTED_MODULE_47__DropdownItem__["a" /* default */].create(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
          active: isActive(opt.value),
          onClick: _this.handleItemClick,
          selected: selectedIndex === i
        }, opt, {
          key: getKeyOrValue(opt.key, opt.value),
          // Needed for handling click events on disabled items
          style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, opt.style, {
            pointerEvents: 'all'
          })
        }));
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderMenu", function () {
      var _this$props17 = _this.props,
          children = _this$props17.children,
          direction = _this$props17.direction,
          header = _this$props17.header;
      var open = _this.state.open;

      var ariaOptions = _this.getDropdownMenuAriaOptions(); // single menu child


      if (!__WEBPACK_IMPORTED_MODULE_43__lib__["c" /* childrenUtils */].isNil(children)) {
        var menuChild = __WEBPACK_IMPORTED_MODULE_41_react__["Children"].only(children);
        var className = __WEBPACK_IMPORTED_MODULE_38_classnames___default()(direction, Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(open, 'visible'), menuChild.props.className);
        return Object(__WEBPACK_IMPORTED_MODULE_41_react__["cloneElement"])(menuChild, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
          className: className
        }, ariaOptions));
      }

      return __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__DropdownMenu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, ariaOptions, {
        direction: direction,
        open: open
      }), __WEBPACK_IMPORTED_MODULE_48__DropdownHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), _this.renderOptions());
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Dropdown, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState() {
      return {
        focus: false,
        searchQuery: ''
      };
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$state7 = this.state,
          open = _this$state7.open,
          value = _this$state7.value;
      this.setValue(value);
      this.setSelectedIndex(value);

      if (open) {
        this.open();
      }
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Dropdown.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, nextProps);

      /* eslint-disable no-console */
      if (false) {
        // in development, validate value type matches dropdown type
        var isNextValueArray = Array.isArray(nextProps.value);

        var hasValue = _has(nextProps, 'value');

        if (hasValue && nextProps.multiple && !isNextValueArray) {
          console.error('Dropdown `value` must be an array when `multiple` is set.' + " Received type: `".concat(Object.prototype.toString.call(nextProps.value), "`."));
        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
        }
      }
      /* eslint-enable no-console */


      if (!__WEBPACK_IMPORTED_MODULE_42_shallowequal___default()(nextProps.value, this.props.value)) {
        this.setValue(nextProps.value);
        this.setSelectedIndex(nextProps.value);
      } // The selected index is only dependent on option keys/values.
      // We only check those properties to avoid recursive performance impacts.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000


      if (!__WEBPACK_IMPORTED_MODULE_33_lodash_isEqual___default()(this.getKeyAndValues(nextProps.options), this.getKeyAndValues(this.props.options))) {
        this.setSelectedIndex(undefined, nextProps.options);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !__WEBPACK_IMPORTED_MODULE_42_shallowequal___default()(nextProps, this.props) || !__WEBPACK_IMPORTED_MODULE_42_shallowequal___default()(nextState, this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // eslint-disable-line complexity
      var _this$props18 = this.props,
          closeOnBlur = _this$props18.closeOnBlur,
          minCharacters = _this$props18.minCharacters,
          openOnFocus = _this$props18.openOnFocus,
          search = _this$props18.search; // focused / blurred

      if (!prevState.focus && this.state.focus) {
        if (!this.isMouseDown) {
          var openable = !search || search && minCharacters === 1 && !this.state.open;
          if (openOnFocus && openable) this.open();
        }
      } else if (prevState.focus && !this.state.focus) {
        if (!this.isMouseDown && closeOnBlur) {
          this.close();
        }
      } // opened / closed


      if (!prevState.open && this.state.open) {
        this.setOpenDirection();
        this.scrollSelectedItemIntoView();
      } else if (prevState.open && !this.state.open) {}
    } // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------
    // onChange needs to receive a value
    // can't rely on props.value if we are controlled

  }, {
    key: "getDropdownMenuAriaOptions",
    value: function getDropdownMenuAriaOptions() {
      var _this$props19 = this.props,
          search = _this$props19.search,
          multiple = _this$props19.multiple;
      var ariaOptions = {};

      if (search) {
        ariaOptions['aria-multiselectable'] = multiple;
        ariaOptions.role = 'listbox';
      }

      return ariaOptions;
    } // ----------------------------------------
    // Setters
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this$props20 = this.props,
          basic = _this$props20.basic,
          button = _this$props20.button,
          className = _this$props20.className,
          compact = _this$props20.compact,
          disabled = _this$props20.disabled,
          error = _this$props20.error,
          fluid = _this$props20.fluid,
          floating = _this$props20.floating,
          icon = _this$props20.icon,
          inline = _this$props20.inline,
          item = _this$props20.item,
          labeled = _this$props20.labeled,
          loading = _this$props20.loading,
          multiple = _this$props20.multiple,
          pointing = _this$props20.pointing,
          search = _this$props20.search,
          selection = _this$props20.selection,
          scrolling = _this$props20.scrolling,
          simple = _this$props20.simple,
          trigger = _this$props20.trigger;
      var _this$state8 = this.state,
          focus = _this$state8.focus,
          open = _this$state8.open,
          upward = _this$state8.upward; // Classes

      var classes = __WEBPACK_IMPORTED_MODULE_38_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(open, 'active visible'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(button, 'button'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(floating, 'floating'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(inline, 'inline'), // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
      // TODO: the icon class is only required when a dropdown is a button
      // useKeyOnly(icon, 'icon'),
      Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(labeled, 'labeled'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(item, 'item'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(multiple, 'multiple'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(search, 'search'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(selection, 'selection'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(simple, 'simple'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(scrolling, 'scrolling'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["y" /* useKeyOnly */])(upward, 'upward'), Object(__WEBPACK_IMPORTED_MODULE_43__lib__["z" /* useKeyOrValueAndKey */])(pointing, 'pointing'), 'dropdown', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_43__lib__["q" /* getUnhandledProps */])(Dropdown, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_43__lib__["p" /* getElementType */])(Dropdown, this.props);
      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
      return __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
        className: classes,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        tabIndex: this.computeTabIndex()
      }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), trigger || this.renderText(), __WEBPACK_IMPORTED_MODULE_44__elements_Icon__["a" /* default */].create(icon, {
        overrideProps: this.handleIconOverrides,
        autoGenerateKey: false
      }), this.renderMenu(), open && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.closeOnEscape
      }), open && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.moveSelectionOnKeyDown
      }), open && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "click",
        on: this.closeOnDocumentClick
      }), open && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.selectItemOnEnter
      }), focus && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.removeItemOnBackspace
      }), focus && !open && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.openOnArrow
      }), focus && !open && __WEBPACK_IMPORTED_MODULE_41_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__semantic_ui_react_event_stack___default.a, {
        name: "keydown",
        on: this.openOnSpace
      })));
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_43__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "defaultProps", {
  additionLabel: 'Add ',
  additionPosition: 'top',
  closeOnBlur: true,
  closeOnEscape: true,
  deburr: false,
  icon: 'dropdown',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  openOnFocus: true,
  renderLabel: function renderLabel(_ref2) {
    var text = _ref2.text;
    return text;
  },
  searchInput: 'text',
  selectOnBlur: true,
  selectOnNavigation: true,
  wrapSelection: true
});

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "autoControlledProps", ['open', 'searchQuery', 'selectedLabel', 'value', 'upward']);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Divider", __WEBPACK_IMPORTED_MODULE_46__DropdownDivider__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Header", __WEBPACK_IMPORTED_MODULE_48__DropdownHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Item", __WEBPACK_IMPORTED_MODULE_47__DropdownItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "Menu", __WEBPACK_IMPORTED_MODULE_49__DropdownMenu__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "SearchInput", __WEBPACK_IMPORTED_MODULE_50__DropdownSearchInput__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Dropdown, "handledProps", ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"]);


Dropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Label prefixed to an option added by a user. */
  additionLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
  additionPosition: PropTypes.oneOf(['top', 'bottom']),

  /**
   * Allow user additions to the list of options (boolean).
   * Requires the use of `selection`, `options` and `search`.
   */
  allowAdditions: customPropTypes.every([customPropTypes.demand(['options', 'selection', 'search']), PropTypes.bool]),

  /** A Dropdown can reduce its complexity. */
  basic: PropTypes.bool,

  /** Format the Dropdown to appear as a button. */
  button: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([customPropTypes.disallow(['options', 'selection']), customPropTypes.givenProps({
    children: PropTypes.any.isRequired
  }, PropTypes.element.isRequired)]),

  /** Additional classes. */
  className: PropTypes.string,

  /** Using the clearable setting will let users remove their selection from a dropdown. */
  clearable: PropTypes.bool,

  /** Whether or not the menu should close when the dropdown is blurred. */
  closeOnBlur: PropTypes.bool,

  /** Whether or not the dropdown should close when the escape key is pressed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Whether or not the menu should close when a value is selected from the dropdown.
   * By default, multiple selection dropdowns will remain open on change, while single
   * selection dropdowns will close on change.
   */
  closeOnChange: PropTypes.bool,

  /** A compact dropdown has no minimum width. */
  compact: PropTypes.bool,

  /** Whether or not the dropdown should strip diacritics in options and input search */
  deburr: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value of searchQuery. */
  defaultSearchQuery: PropTypes.string,

  /** Currently selected label in multi-select. */
  defaultSelectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Initial value of upward. */
  defaultUpward: PropTypes.bool,

  /** Initial value or value array if multiple. */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]))]),

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** A disabled dropdown menu or item does not allow user interaction. */
  disabled: PropTypes.bool,

  /** An errored dropdown can alert a user to a problem. */
  error: PropTypes.bool,

  /** A dropdown menu can contain floated content. */
  floating: PropTypes.bool,

  /** A dropdown can take the full width of its parent */
  fluid: PropTypes.bool,

  /** A dropdown menu can contain a header. */
  header: PropTypes.node,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A dropdown can be formatted to appear inline in other content. */
  inline: PropTypes.bool,

  /** A dropdown can be formatted as a Menu item. */
  item: PropTypes.bool,

  /** A dropdown can be labeled. */
  labeled: PropTypes.bool,

  /** A dropdown can defer rendering its options until it is open. */
  lazyLoad: PropTypes.bool,

  /** A dropdown can show that it is currently loading data. */
  loading: PropTypes.bool,

  /** The minimum characters for a search to begin showing results. */
  minCharacters: PropTypes.number,

  /** A selection dropdown can allow multiple selections. */
  multiple: PropTypes.bool,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /**
   * Called when a user adds a new item. Use this to update the options list.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and the new item's value.
   */
  onAddItem: PropTypes.func,

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called when the user attempts to change the value.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onChange: PropTypes.func,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called when a multi-select label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All label props.
   */
  onLabelClick: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of searchQuery.
   */
  onSearchChange: PropTypes.func,

  /** Controls whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** Whether or not the menu should open when the dropdown is focused. */
  openOnFocus: PropTypes.bool,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape(DropdownItem.propTypes))]),

  /** Placeholder text. */
  placeholder: PropTypes.string,

  /** A dropdown can be formatted so that its menu is pointing. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),

  /**
   * Mapped over the active items and returns shorthand for the active item Labels.
   * Only applies to `multiple` Dropdowns.
   *
   * @param {object} item - A currently active dropdown item.
   * @param {number} index - The current index.
   * @param {object} defaultLabelProps - The default props for an active item Label.
   * @returns {*} Shorthand for a Label.
   */
  renderLabel: PropTypes.func,

  /** A dropdown can have its menu scroll. */
  scrolling: PropTypes.bool,

  /**
   * A selection dropdown can allow a user to search through a large list of choices.
   * Pass a function here to replace the default search.
   */
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),

  /** A shorthand for a search input. */
  searchInput: PropTypes.oneOfType([PropTypes.array, PropTypes.node, PropTypes.object]),

  /** Current value of searchQuery. Creates a controlled component. */
  searchQuery: PropTypes.string,
  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?

  /** Define whether the highlighted item should be selected on blur. */
  selectOnBlur: PropTypes.bool,

  /**
   * Whether or not to change the value when navigating the menu using arrow keys.
   * Setting to false will require enter or left click to confirm a choice.
   */
  selectOnNavigation: PropTypes.bool,

  /** Currently selected label in multi-select. */
  selectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.string, PropTypes.number])]),

  /** A dropdown can be used to select between choices in a form. */
  selection: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['options']), PropTypes.bool]),

  /** A simple dropdown can open without Javascript. */
  simple: PropTypes.bool,

  /** A dropdown can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The text displayed in the dropdown, usually for the active item. */
  text: PropTypes.string,

  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
  trigger: customPropTypes.every([customPropTypes.disallow(['selection', 'text']), PropTypes.node]),

  /** Current value or value array if multiple. Creates a controlled component. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]))]),

  /** Controls whether the dropdown will open upward. */
  upward: PropTypes.bool,

  /**
   * A dropdown will go to the last element when ArrowUp is pressed on the first,
   * or go to the first when ArrowDown is pressed on the last( aka infinite selection )
   */
  wrapSelection: PropTypes.bool
} : {};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(16);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(1076),
    baseEvery = __webpack_require__(1077),
    baseIteratee = __webpack_require__(49),
    isArray = __webpack_require__(26),
    isIterateeCall = __webpack_require__(106);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 1076 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(92);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(64);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(168),
    toInteger = __webpack_require__(72);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(172),
    getTag = __webpack_require__(81),
    isArrayLike = __webpack_require__(58),
    isString = __webpack_require__(189),
    stringSize = __webpack_require__(1081);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1082),
    hasUnicode = __webpack_require__(186),
    unicodeSize = __webpack_require__(1083);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(410);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(136),
    baseRest = __webpack_require__(80),
    baseUniq = __webpack_require__(441),
    isArrayLikeObject = __webpack_require__(130);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(5);











var names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'uk', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];
/**
 * A flag is is used to represent a political state.
 */

var Flag =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Flag, _PureComponent);

  function Flag() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Flag);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Flag).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Flag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          name = _this$props.name;
      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(name, 'flag', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getUnhandledProps */])(Flag, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["p" /* getElementType */])(Flag, this.props);
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }));
    }
  }]);

  return Flag;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Flag, "defaultProps", {
  as: 'i'
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Flag, "handledProps", ["as", "className", "name"]);

Flag.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** Flag name, can use the two digit country code, the full name, or a common alias. */
  name: customPropTypes.suggest(names)
} : {};
Flag.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["l" /* createShorthandFactory */])(Flag, function (value) {
  return {
    name: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Flag);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);















/**
 * A TextArea can be used to allow for extended user input.
 * @see Form
 */

var TextArea =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(TextArea, _Component);

  function TextArea() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(TextArea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", Object(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      return _this.ref.current.focus();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleInput", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onInput', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(TextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rows = _this$props.rows,
          value = _this$props.value;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(TextArea, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["p" /* getElementType */])(TextArea, this.props);
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        onChange: this.handleChange,
        onInput: this.handleInput,
        rows: rows,
        value: value
      })));
    }
  }]);

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TextArea, "defaultProps", {
  as: 'textarea',
  rows: 3
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TextArea, "handledProps", ["as", "onChange", "onInput", "rows", "value"]);

TextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /**
   * Called on change.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onChange: PropTypes.func,

  /**
   * Called on input.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onInput: PropTypes.func,

  /** Indicates row count for a TextArea. */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The value of the textarea. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransitionablePortal__ = __webpack_require__(1088);
/* unused harmony reexport default */



/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Portal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_Transition__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);
















/**
 * A sugar for `Portal` and `Transition`.
 * @see Portal
 * @see Transition
 */
var TransitionablePortal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(TransitionablePortal, _Component);

  function TransitionablePortal(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, TransitionablePortal);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(TransitionablePortal).call(this, props));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalClose", function () {
      _this.setState({
        portalOpen: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalOpen", function () {
      _this.setState({
        portalOpen: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTransitionHide", function (nothing, data) {
      var portalOpen = _this.state.portalOpen;

      _this.setState({
        transitionVisible: false
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClose', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        portalOpen: false,
        transitionVisible: false
      }));

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onHide', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        portalOpen: portalOpen,
        transitionVisible: false
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleTransitionStart", function (nothing, data) {
      var portalOpen = _this.state.portalOpen;
      var status = data.status;
      var transitionVisible = status === __WEBPACK_IMPORTED_MODULE_13__modules_Transition__["a" /* default */].ENTERING;

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onStart', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        portalOpen: portalOpen,
        transitionVisible: transitionVisible
      })); // Heads up! TransitionablePortal fires onOpen callback on the start of transition animation


      if (!transitionVisible) return;

      _this.setState({
        transitionVisible: transitionVisible
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onOpen', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, data, {
        transitionVisible: transitionVisible,
        portalOpen: true
      }));
    });

    _this.state = {
      portalOpen: props.open
    };
    return _this;
  } // ----------------------------------------
  // Lifecycle
  // ----------------------------------------
  // eslint-disable-next-line camelcase


  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(TransitionablePortal, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var open = _ref.open;
      this.setState({
        portalOpen: open
      });
    } // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          transition = _this$props.transition;
      var _this$state = this.state,
          portalOpen = _this$state.portalOpen,
          transitionVisible = _this$state.transitionVisible;
      var open = portalOpen || transitionVisible;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(TransitionablePortal, this.props);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Portal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        open: open,
        onOpen: this.handlePortalOpen,
        onClose: this.handlePortalClose
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modules_Transition__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, transition, {
        transitionOnMount: true,
        onStart: this.handleTransitionStart,
        onHide: this.handleTransitionHide,
        visible: portalOpen
      }), children));
    }
  }]);

  return TransitionablePortal;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TransitionablePortal, "defaultProps", {
  transition: {
    animation: 'scale',
    duration: 400
  }
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(TransitionablePortal, "handledProps", ["children", "onClose", "onHide", "onOpen", "onStart", "open", "transition"]);


TransitionablePortal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onClose: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onHide: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onOpen: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onStart: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Transition props. */
  transition: PropTypes.object
} : {};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(132),
    baseForOwn = __webpack_require__(170),
    baseIteratee = __webpack_require__(49);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Visibility__ = __webpack_require__(1091);
/* unused harmony reexport default */



/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib__ = __webpack_require__(5);

















/**
 * Visibility provides a set of callbacks for when a content appears in the viewport.
 */

var Visibility =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Visibility, _Component);

  function Visibility() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Visibility);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Visibility)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "calculations", {
      bottomPassed: false,
      bottomVisible: false,
      fits: false,
      passing: false,
      offScreen: false,
      onScreen: false,
      topPassed: false,
      topVisible: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "firedCallbacks", []);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", Object(__WEBPACK_IMPORTED_MODULE_15_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "fire", function (_ref, value) {
      var callback = _ref.callback,
          name = _ref.name;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
          continuous = _this$props.continuous,
          once = _this$props.once; // Heads up! For the execution is required:
      // - current value correspond to the fired direction
      // - `continuous` is true or calculation values are different

      var matchesDirection = _this.calculations[value] !== reverse;
      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];
      if (matchesDirection && executionPossible) _this.execute(callback, name); // Heads up! We should remove callback from the happened when it's not `once`

      if (!once) _this.firedCallbacks = __WEBPACK_IMPORTED_MODULE_11_lodash_without___default()(_this.firedCallbacks, name);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUpdate", function () {
      if (_this.ticking) return;
      _this.ticking = true;
      _this.frameId = requestAnimationFrame(_this.update);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "update", function () {
      if (!_this.mounted) return;
      _this.ticking = false;
      _this.oldCalculations = _this.calculations;
      _this.calculations = _this.computeCalculations();
      _this.pageYOffset = _this.getPageYOffset();
      var _this$props2 = _this.props,
          onBottomPassed = _this$props2.onBottomPassed,
          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
          onBottomVisible = _this$props2.onBottomVisible,
          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
          onPassing = _this$props2.onPassing,
          onPassingReverse = _this$props2.onPassingReverse,
          onTopPassed = _this$props2.onTopPassed,
          onTopPassedReverse = _this$props2.onTopPassedReverse,
          onTopVisible = _this$props2.onTopVisible,
          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
          onOffScreen = _this$props2.onOffScreen,
          onOnScreen = _this$props2.onOnScreen,
          updateOn = _this$props2.updateOn;
      var forward = {
        bottomPassed: {
          callback: onBottomPassed,
          name: 'onBottomPassed'
        },
        bottomVisible: {
          callback: onBottomVisible,
          name: 'onBottomVisible'
        },
        passing: {
          callback: onPassing,
          name: 'onPassing'
        },
        offScreen: {
          callback: onOffScreen,
          name: 'onOffScreen'
        },
        onScreen: {
          callback: onOnScreen,
          name: 'onOnScreen'
        },
        topPassed: {
          callback: onTopPassed,
          name: 'onTopPassed'
        },
        topVisible: {
          callback: onTopVisible,
          name: 'onTopVisible'
        }
      };
      var reverse = {
        bottomPassed: {
          callback: onBottomPassedReverse,
          name: 'onBottomPassedReverse'
        },
        bottomVisible: {
          callback: onBottomVisibleReverse,
          name: 'onBottomVisibleReverse'
        },
        passing: {
          callback: onPassingReverse,
          name: 'onPassingReverse'
        },
        topPassed: {
          callback: onTopPassedReverse,
          name: 'onTopPassedReverse'
        },
        topVisible: {
          callback: onTopVisibleReverse,
          name: 'onTopVisibleReverse'
        }
      };

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onUpdate', null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        calculations: _this.calculations
      }));

      _this.fireOnPassed(); // Heads up! Reverse callbacks should be fired first


      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(reverse, function (data, value) {
        return _this.fire(data, value, true);
      });

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(forward, function (data, value) {
        return _this.fire(data, value);
      });

      if (updateOn === 'repaint') _this.handleUpdate();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Visibility, [{
    key: "UNSAFE_componentWillReceiveProps",
    // ----------------------------------------
    // Lifecycle
    // ----------------------------------------
    // eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillReceiveProps(_ref2) {
      var continuous = _ref2.continuous,
          once = _ref2.once,
          context = _ref2.context,
          updateOn = _ref2.updateOn;
      var cleanHappened = continuous !== this.props.continuous || once !== this.props.once || updateOn !== this.props.updateOn; // Heads up! We should clean up array of happened callbacks, if values of these props are changed

      if (cleanHappened) this.firedCallbacks = [];

      if (context !== this.props.context || updateOn !== this.props.updateOn) {
        this.unattachHandlers(this.props.context);
        this.attachHandlers(context, updateOn);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      if (!Object(__WEBPACK_IMPORTED_MODULE_16__lib__["t" /* isBrowser */])()) return;
      var _this$props3 = this.props,
          context = _this$props3.context,
          fireOnMount = _this$props3.fireOnMount,
          updateOn = _this$props3.updateOn;
      this.pageYOffset = this.getPageYOffset();
      this.attachHandlers(context, updateOn);
      if (fireOnMount) this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var context = this.props.context;
      this.unattachHandlers(context);
      this.mounted = false;
    }
  }, {
    key: "attachHandlers",
    value: function attachHandlers(context, updateOn) {
      if (updateOn === 'events') {
        if (context) {
          __WEBPACK_IMPORTED_MODULE_16__lib__["n" /* eventStack */].sub('resize', this.handleUpdate, {
            target: context
          });
          __WEBPACK_IMPORTED_MODULE_16__lib__["n" /* eventStack */].sub('scroll', this.handleUpdate, {
            target: context
          });
        }

        return;
      } // Heads up!
      // We will deal with `repaint` there


      this.handleUpdate();
    }
  }, {
    key: "unattachHandlers",
    value: function unattachHandlers(context) {
      if (context) {
        __WEBPACK_IMPORTED_MODULE_16__lib__["n" /* eventStack */].unsub('resize', this.handleUpdate, {
          target: context
        });
        __WEBPACK_IMPORTED_MODULE_16__lib__["n" /* eventStack */].unsub('scroll', this.handleUpdate, {
          target: context
        });
      }

      if (this.frameId) cancelAnimationFrame(this.frameId);
    } // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: "execute",
    value: function execute(callback, name) {
      var continuous = this.props.continuous;
      if (!callback) return; // Heads up! When `continuous` is true, callback will be fired always

      if (!continuous && __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(this.firedCallbacks, name)) return;
      callback(null, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.props, {
        calculations: this.calculations
      }));
      this.firedCallbacks.push(name);
    }
  }, {
    key: "fireOnPassed",
    value: function fireOnPassed() {
      var _this2 = this;

      var _this$calculations = this.calculations,
          percentagePassed = _this$calculations.percentagePassed,
          pixelsPassed = _this$calculations.pixelsPassed;
      var onPassed = this.props.onPassed;

      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(onPassed, function (callback, passed) {
        var pixelsValue = Number(passed);

        if (pixelsValue && pixelsPassed >= pixelsValue) {
          _this2.execute(callback, passed);

          return;
        }

        var matchPercentage = "".concat(passed).match(/^(\d+)%$/);
        if (!matchPercentage) return;
        var percentageValue = Number(matchPercentage[1]) / 100;
        if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
      });
    }
  }, {
    key: "computeCalculations",
    // ----------------------------------------
    // Helpers
    // ----------------------------------------
    value: function computeCalculations() {
      var offset = this.props.offset;

      var _this$ref$current$get = this.ref.current.getBoundingClientRect(),
          bottom = _this$ref$current$get.bottom,
          height = _this$ref$current$get.height,
          top = _this$ref$current$get.top,
          width = _this$ref$current$get.width;

      var _normalizeOffset = Object(__WEBPACK_IMPORTED_MODULE_16__lib__["v" /* normalizeOffset */])(offset),
          _normalizeOffset2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_normalizeOffset, 2),
          topOffset = _normalizeOffset2[0],
          bottomOffset = _normalizeOffset2[1];

      var newOffset = this.getPageYOffset();
      var direction = newOffset > this.pageYOffset ? 'down' : 'up';
      var topPassed = top < topOffset;
      var bottomPassed = bottom < bottomOffset;
      var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
      var percentagePassed = pixelsPassed / height;
      var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
      var topVisible = top >= topOffset && top <= window.innerHeight;
      var fits = topVisible && bottomVisible;
      var passing = topPassed && !bottomPassed;
      var onScreen = (topVisible || topPassed) && !bottomPassed;
      var offScreen = !onScreen;
      return {
        bottomPassed: bottomPassed,
        bottomVisible: bottomVisible,
        direction: direction,
        fits: fits,
        height: height,
        passing: passing,
        percentagePassed: percentagePassed,
        pixelsPassed: pixelsPassed,
        offScreen: offScreen,
        onScreen: onScreen,
        topPassed: topPassed,
        topVisible: topVisible,
        width: width
      };
    }
  }, {
    key: "getPageYOffset",
    value: function getPageYOffset() {
      var context = this.props.context;

      if (context) {
        // Heads up! `window` doesn't have `pageYOffset` property
        return context === window ? window.pageYOffset : context.scrollTop;
      }

      return 0;
    } // ----------------------------------------
    // Render
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_16__lib__["p" /* getElementType */])(Visibility, this.props);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_16__lib__["q" /* getUnhandledProps */])(Visibility, this.props);
      return __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(ElementType, rest, children));
    }
  }]);

  return Visibility;
}(__WEBPACK_IMPORTED_MODULE_15_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Visibility, "defaultProps", {
  context: Object(__WEBPACK_IMPORTED_MODULE_16__lib__["t" /* isBrowser */])() ? window : null,
  continuous: false,
  offset: [0, 0],
  once: true,
  updateOn: 'events'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Visibility, "handledProps", ["as", "children", "context", "continuous", "fireOnMount", "offset", "onBottomPassed", "onBottomPassedReverse", "onBottomVisible", "onBottomVisibleReverse", "onOffScreen", "onOnScreen", "onPassed", "onPassing", "onPassingReverse", "onTopPassed", "onTopPassedReverse", "onTopVisible", "onTopVisibleReverse", "onUpdate", "once", "updateOn"]);


Visibility.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Context which visibility should attach onscroll events. */
  context: PropTypes.object,

  /**
   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
   * threshold is met.
   */
  continuous: PropTypes.bool,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /**
   * Element's bottom edge has passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassed: PropTypes.func,

  /**
   * Element's bottom edge has not passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassedReverse: PropTypes.func,

  /**
   * Element's bottom edge has passed bottom of screen
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisible: PropTypes.func,

  /**
   * Element's bottom edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisibleReverse: PropTypes.func,

  /**
   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
   * page.
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),

  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
  once: PropTypes.bool,

  /** Element is not visible on the screen. */
  onPassed: PropTypes.object,

  /**
   * Any part of an element is visible on screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassing: PropTypes.func,

  /**
   * Element's top has not passed top of screen but bottom has.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassingReverse: PropTypes.func,

  /**
   * Element is not visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOffScreen: PropTypes.func,

  /**
   * Element is visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOnScreen: PropTypes.func,

  /**
   * Element's top edge has passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassed: PropTypes.func,

  /**
   * Element's top edge has not passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassedReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisible: PropTypes.func,

  /**
   * Element's top edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisibleReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUpdate: PropTypes.func,

  /**
   * Allows to choose the mode of the position calculations:
   * - `events` - (default) update and fire callbacks only on scroll/resize events
   * - `repaint` - update and fire callbacks on browser repaint (animation frames)
   */
  updateOn: PropTypes.oneOf(['events', 'repaint'])
} : {};

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb__ = __webpack_require__(1093);
/* unused harmony reexport default */



/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__ = __webpack_require__(483);









/**
 * A breadcrumb is used to show hierarchy between content.
 */

function Breadcrumb(props) {
  var children = props.children,
      className = props.className,
      divider = props.divider,
      icon = props.icon,
      sections = props.sections,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', size, 'breadcrumb', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(Breadcrumb, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(Breadcrumb, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var childElements = [];

  __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(sections, function (section, index) {
    // section
    var breadcrumbElement = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */].create(section);
    childElements.push(breadcrumbElement); // divider

    if (index !== sections.length - 1) {
      var key = "".concat(breadcrumbElement.key, "_divider") || JSON.stringify(section);
      childElements.push(__WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */].create({
        content: divider,
        icon: icon,
        key: key
      }));
    }
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), childElements);
}

Breadcrumb.handledProps = ["as", "children", "className", "divider", "icon", "sections", "size"];
Breadcrumb.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content of the Breadcrumb.Divider. */
  divider: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.contentShorthand]),

  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
   *  Breadcrumb.Divider. */
  icon: customPropTypes.every([customPropTypes.disallow(['divider']), customPropTypes.itemShorthand]),

  /** Shorthand array of props for Breadcrumb.Section. */
  sections: customPropTypes.collectionShorthand,

  /** Size of Breadcrumb. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
Breadcrumb.Divider = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */];
Breadcrumb.Section = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Breadcrumb);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(1095);
/* unused harmony reexport default */



/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FormButton__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FormCheckbox__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FormDropdown__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FormField__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FormGroup__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__FormInput__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormRadio__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormSelect__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FormTextArea__ = __webpack_require__(491);























/**
 * A Form displays a set of related user input fields in a structured way.
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Message
 * @see Radio
 * @see Select
 * @see Visibility
 */

var Form =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Form, _Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Form);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Form)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSubmit", function (e) {
      var action = _this.props.action; // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
      // method.

      if (typeof action !== 'string') __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(e, 'preventDefault');

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default.a.apply(void 0, [_this.props, 'onSubmit', e, _this.props].concat(args));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          children = _this$props.children,
          className = _this$props.className,
          error = _this$props.error,
          inverted = _this$props.inverted,
          loading = _this$props.loading,
          reply = _this$props.reply,
          size = _this$props.size,
          success = _this$props.success,
          unstackable = _this$props.unstackable,
          warning = _this$props.warning,
          widths = _this$props.widths;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(reply, 'reply'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(success, 'success'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["E" /* useWidthProp */])(widths, null, true), 'form', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(Form, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(Form, this.props);
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        action: action,
        className: classes,
        onSubmit: this.handleSubmit
      }), children);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "defaultProps", {
  as: 'form'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Field", __WEBPACK_IMPORTED_MODULE_17__FormField__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Button", __WEBPACK_IMPORTED_MODULE_14__FormButton__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Checkbox", __WEBPACK_IMPORTED_MODULE_15__FormCheckbox__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Dropdown", __WEBPACK_IMPORTED_MODULE_16__FormDropdown__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Group", __WEBPACK_IMPORTED_MODULE_18__FormGroup__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Input", __WEBPACK_IMPORTED_MODULE_19__FormInput__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Radio", __WEBPACK_IMPORTED_MODULE_20__FormRadio__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "Select", __WEBPACK_IMPORTED_MODULE_21__FormSelect__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "TextArea", __WEBPACK_IMPORTED_MODULE_22__FormTextArea__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "handledProps", ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"]);

Form.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The HTML form action */
  action: PropTypes.string,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Automatically show any error Message children. */
  error: PropTypes.bool,

  /** A form can have its color inverted for contrast. */
  inverted: PropTypes.bool,

  /** Automatically show a loading indicator. */
  loading: PropTypes.bool,

  /** The HTML form submit handler. */
  onSubmit: PropTypes.func,

  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
  reply: PropTypes.bool,

  /** A form can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Automatically show any success Message children. */
  success: PropTypes.bool,

  /** A form can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Automatically show any warning Message children. */
  warning: PropTypes.bool,

  /** Forms can automatically divide fields to be equal width. */
  widths: PropTypes.oneOf(['equal'])
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Button__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Label__ = __webpack_require__(140);























/**
 * An Input is a field used to elicit a response from a user.
 * @see Button
 * @see Form
 * @see Icon
 * @see Label
 */

var Input =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Input, _Component);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "inputRef", Object(__WEBPACK_IMPORTED_MODULE_18_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeIcon", function () {
      var _this$props = _this.props,
          loading = _this$props.loading,
          icon = _this$props.icon;
      if (!__WEBPACK_IMPORTED_MODULE_14_lodash_isNil___default()(icon)) return icon;
      if (loading) return 'spinner';
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeTabIndex", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__WEBPACK_IMPORTED_MODULE_14_lodash_isNil___default()(tabIndex)) return tabIndex;
      if (disabled) return -1;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      return _this.inputRef.current.focus();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "select", function () {
      return _this.inputRef.current.select();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_12_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: value
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChildOverrides", function (child, defaultProps) {
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, defaultProps, child.props, {
        ref: function ref(c) {
          Object(__WEBPACK_IMPORTED_MODULE_15__stardust_ui_react_component_ref__["b" /* handleRef */])(child.ref, c);
          _this.inputRef.current = c;
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "partitionProps", function () {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          type = _this$props3.type;

      var tabIndex = _this.computeTabIndex();

      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["q" /* getUnhandledProps */])(Input, _this.props);

      var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["x" /* partitionHTMLProps */])(unhandled),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return [__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, htmlInputProps, {
        disabled: disabled,
        type: type,
        tabIndex: tabIndex,
        onChange: _this.handleChange,
        ref: _this.inputRef
      }), rest];
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(Input, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          actionPosition = _this$props4.actionPosition,
          children = _this$props4.children,
          className = _this$props4.className,
          disabled = _this$props4.disabled,
          error = _this$props4.error,
          fluid = _this$props4.fluid,
          focus = _this$props4.focus,
          icon = _this$props4.icon,
          iconPosition = _this$props4.iconPosition,
          input = _this$props4.input,
          inverted = _this$props4.inverted,
          label = _this$props4.label,
          labelPosition = _this$props4.labelPosition,
          loading = _this$props4.loading,
          size = _this$props4.size,
          transparent = _this$props4.transparent,
          type = _this$props4.type;
      var classes = __WEBPACK_IMPORTED_MODULE_16_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(focus, 'focus'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(transparent, 'transparent'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["C" /* useValueAndKey */])(actionPosition, 'action') || Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(action, 'action'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["C" /* useValueAndKey */])(iconPosition, 'icon') || Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(icon || loading, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["C" /* useValueAndKey */])(labelPosition, 'labeled') || Object(__WEBPACK_IMPORTED_MODULE_19__lib__["y" /* useKeyOnly */])(label, 'labeled'), 'input', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["p" /* getElementType */])(Input, this.props);

      var _this$partitionProps = this.partitionProps(),
          _this$partitionProps2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_this$partitionProps, 2),
          htmlInputProps = _this$partitionProps2[0],
          rest = _this$partitionProps2[1]; // Render with children
      // ----------------------------------------


      if (!__WEBPACK_IMPORTED_MODULE_19__lib__["c" /* childrenUtils */].isNil(children)) {
        // add htmlInputProps to the `<input />` child
        var childElements = __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_18_react__["Children"].toArray(children), function (child) {
          if (child.type !== 'input') return child;
          return Object(__WEBPACK_IMPORTED_MODULE_18_react__["cloneElement"])(child, _this2.handleChildOverrides(child, htmlInputProps));
        });

        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), childElements);
      } // Render Shorthand
      // ----------------------------------------


      var actionElement = __WEBPACK_IMPORTED_MODULE_20__Button__["a" /* default */].create(action, {
        autoGenerateKey: false
      });
      var labelElement = __WEBPACK_IMPORTED_MODULE_22__Label__["a" /* default */].create(label, {
        defaultProps: {
          className: __WEBPACK_IMPORTED_MODULE_16_classnames___default()('label', // add 'left|right corner'
          __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(labelPosition, 'corner') && labelPosition)
        },
        autoGenerateKey: false
      });
      return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), actionPosition === 'left' && actionElement, labelPosition !== 'right' && labelElement, Object(__WEBPACK_IMPORTED_MODULE_19__lib__["g" /* createHTMLInput */])(input || type, {
        defaultProps: htmlInputProps,
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_21__Icon__["a" /* default */].create(this.computeIcon(), {
        autoGenerateKey: false
      }), actionPosition !== 'left' && actionElement, labelPosition === 'right' && labelElement);
    }
  }]);

  return Input;
}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Input, "defaultProps", {
  type: 'text'
});

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Input, "handledProps", ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"]);

Input.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An Input can be formatted to alert the user to an action they may perform. */
  action: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An action can appear along side an Input on the left or right. */
  actionPosition: PropTypes.oneOf(['left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** An Input field can show that it is disabled. */
  disabled: PropTypes.bool,

  /** An Input field can show the data contains errors. */
  error: PropTypes.bool,

  /** Take on the size of its container. */
  fluid: PropTypes.bool,

  /** An Input field can show a user is currently interacting with it. */
  focus: PropTypes.bool,

  /** Optional Icon to display inside the Input. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An Icon can appear inside an Input on the left or right. */
  iconPosition: PropTypes.oneOf(['left']),

  /** Shorthand for creating the HTML Input. */
  input: customPropTypes.itemShorthand,

  /** Format to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Optional Label to display along side the Input. */
  label: customPropTypes.itemShorthand,

  /** A Label can appear outside an Input on the left or right. */
  labelPosition: PropTypes.oneOf(['left', 'right', 'left corner', 'right corner']),

  /** An Icon Input field can show that it is currently loading data. */
  loading: PropTypes.bool,

  /**
   * Called on change.
   *
   * @param {ChangeEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and a proposed value.
   */
  onChange: PropTypes.func,

  /** An Input can vary in size. */
  size: PropTypes.oneOf(['mini', 'small', 'large', 'big', 'huge', 'massive']),

  /** An Input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Transparent Input has no background. */
  transparent: PropTypes.bool,

  /** The HTML input type. */
  type: PropTypes.string
} : {};
Input.create = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["l" /* createShorthandFactory */])(Input, function (type) {
  return {
    type: type
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(492);
/* unused harmony reexport default */



/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(1099);
/* unused harmony reexport default */



/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MessageContent__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MessageHeader__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MessageList__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__MessageItem__ = __webpack_require__(279);



















/**
 * A message displays information that explains nearby content.
 * @see Form
 */

var Message =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Message, _Component);

  function Message() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Message);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Message)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDismiss", function (e) {
      var onDismiss = _this.props.onDismiss;
      if (onDismiss) onDismiss(e, _this.props);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Message, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attached = _this$props.attached,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          compact = _this$props.compact,
          content = _this$props.content,
          error = _this$props.error,
          floating = _this$props.floating,
          header = _this$props.header,
          hidden = _this$props.hidden,
          icon = _this$props.icon,
          info = _this$props.info,
          list = _this$props.list,
          negative = _this$props.negative,
          onDismiss = _this$props.onDismiss,
          positive = _this$props.positive,
          size = _this$props.size,
          success = _this$props.success,
          visible = _this$props.visible,
          warning = _this$props.warning;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(floating, 'floating'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(icon, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(info, 'info'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(success, 'success'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(visible, 'visible'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), 'message', className);
      var dismissIcon = onDismiss && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */], {
        name: "close",
        onClick: this.handleDismiss
      });
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(Message, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(Message, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
          className: classes
        }), dismissIcon, children);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), dismissIcon, __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), (!__WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(header) || !__WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(content) || !__WEBPACK_IMPORTED_MODULE_8_lodash_isNil___default()(list)) && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__MessageContent__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_16__MessageHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_17__MessageList__["a" /* default */].create(list, {
        autoGenerateKey: false
      }), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["i" /* createHTMLParagraph */])(content, {
        autoGenerateKey: false
      })));
    }
  }]);

  return Message;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "Content", __WEBPACK_IMPORTED_MODULE_15__MessageContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "Header", __WEBPACK_IMPORTED_MODULE_16__MessageHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "List", __WEBPACK_IMPORTED_MODULE_17__MessageList__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "Item", __WEBPACK_IMPORTED_MODULE_18__MessageItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Message, "handledProps", ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"]);


Message.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A message can be formatted to attach itself to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['bottom', 'top'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A message can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A message can only take up the width of its content. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A message may be formatted to display a negative message. Same as `negative`. */
  error: PropTypes.bool,

  /** A message can float above content that it is related to. */
  floating: PropTypes.bool,

  /** Shorthand for MessageHeader. */
  header: customPropTypes.itemShorthand,

  /** A message can be hidden. */
  hidden: PropTypes.bool,

  /** A message can contain an icon. */
  icon: PropTypes.oneOfType([customPropTypes.itemShorthand, PropTypes.bool]),

  /** A message may be formatted to display information. */
  info: PropTypes.bool,

  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
  list: customPropTypes.collectionShorthand,

  /** A message may be formatted to display a negative message. Same as `error`. */
  negative: PropTypes.bool,

  /**
   * A message that the user can choose to hide.
   * Called when the user clicks the "x" icon. This also adds the "x" icon.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onDismiss: PropTypes.func,

  /** A message may be formatted to display a positive message.  Same as `success`. */
  positive: PropTypes.bool,

  /** A message can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A message may be formatted to display a positive message.  Same as `positive`. */
  success: PropTypes.bool,

  /** A message can be set to visible to force itself to be shown. */
  visible: PropTypes.bool,

  /** A message may be formatted to display warning messages. */
  warning: PropTypes.bool
} : {};

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1101);
/* unused harmony reexport default */



/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableBody__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableCell__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableFooter__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableHeader__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TableRow__ = __webpack_require__(500);













/**
 * A table displays a collections of data grouped into rows.
 */

function Table(props) {
  var attached = props.attached,
      basic = props.basic,
      celled = props.celled,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      color = props.color,
      columns = props.columns,
      compact = props.compact,
      definition = props.definition,
      fixed = props.fixed,
      footerRow = props.footerRow,
      headerRow = props.headerRow,
      headerRows = props.headerRows,
      inverted = props.inverted,
      padded = props.padded,
      renderBodyRow = props.renderBodyRow,
      selectable = props.selectable,
      singleLine = props.singleLine,
      size = props.size,
      sortable = props.sortable,
      stackable = props.stackable,
      striped = props.striped,
      structured = props.structured,
      tableData = props.tableData,
      textAlign = props.textAlign,
      unstackable = props.unstackable,
      verticalAlign = props.verticalAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(celled, 'celled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(collapsing, 'collapsing'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(definition, 'definition'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(fixed, 'fixed'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(selectable, 'selectable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(singleLine, 'single line'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(sortable, 'sortable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(striped, 'striped'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(structured, 'structured'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* useKeyOrValueAndKey */])(padded, 'padded'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["D" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useWidthProp */])(columns, 'column'), 'table', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getUnhandledProps */])(Table, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* getElementType */])(Table, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var hasHeaderRows = headerRow || headerRows;
  var headerShorthandOptions = {
    defaultProps: {
      cellAs: 'th'
    }
  };
  var headerElement = hasHeaderRows && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(headerRow, headerShorthandOptions), __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(headerRows, function (data) {
    return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(data, headerShorthandOptions);
  }));
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), headerElement, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */], null, renderBodyRow && __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(tableData, function (data, index) {
    return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(renderBodyRow(data, index));
  })), footerRow && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(footerRow)));
}

Table.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"];
Table.defaultProps = {
  as: 'table'
};
Table.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Attach table to other content */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A table can reduce its complexity to increase readability. */
  basic: PropTypes.oneOfType([PropTypes.oneOf(['very']), PropTypes.bool]),

  /** A table may be divided each row into separate cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A table can be collapsing, taking up only as much space as its rows. */
  collapsing: PropTypes.bool,

  /** A table can be given a color to distinguish it from other tables. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A table can specify its column count to divide its content evenly. */
  columns: PropTypes.oneOf(SUI.WIDTHS),

  /** A table may sometimes need to be more compact to make more rows visible at a time. */
  compact: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A table may be formatted to emphasize a first column that defines a rows content. */
  definition: PropTypes.bool,

  /**
   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
   */
  fixed: PropTypes.bool,

  /** Shorthand for a TableRow to be placed within Table.Footer. */
  footerRow: customPropTypes.itemShorthand,

  /** Shorthand for a TableRow to be placed within Table.Header. */
  headerRow: customPropTypes.every([customPropTypes.disallow(['headerRows']), customPropTypes.itemShorthand]),

  /** Shorthand for multiple TableRows to be placed within Table.Header. */
  headerRows: customPropTypes.every([customPropTypes.disallow(['headerRow']), customPropTypes.collectionShorthand]),

  /** A table's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A table may sometimes need to be more padded for legibility. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /**
   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
   *
   * @param {*} data - An element in the `tableData` array.
   * @param {number} index - The index of the current element in `tableData`.
   * @returns {*} Shorthand for a Table.Row.
   */
  renderBodyRow: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['tableData']), PropTypes.func]),

  /** A table can have its rows appear selectable. */
  selectable: PropTypes.bool,

  /** A table can specify that its cell contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table can also be small or large. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),

  /** A table may allow a user to sort contents by clicking on a table header. */
  sortable: PropTypes.bool,

  /** A table can specify how it stacks table content responsively. */
  stackable: PropTypes.bool,

  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
  striped: PropTypes.bool,

  /** A table can be formatted to display complex structured data. */
  structured: PropTypes.bool,

  /** Data to be passed to the renderBodyRow function. */
  tableData: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['renderBodyRow']), PropTypes.array]),

  /** A table can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table can specify how it stacks table content responsively. */
  unstackable: PropTypes.bool,

  /** A table can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
Table.Body = __WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */];
Table.Cell = __WEBPACK_IMPORTED_MODULE_8__TableCell__["a" /* default */];
Table.Footer = __WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */];
Table.Header = __WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */];
Table.HeaderCell = __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__["a" /* default */];
Table.Row = __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Table);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(1103);
/* unused harmony reexport default */



/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A container limits content to a maximum width.
 */

function Container(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      text = props.text,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(text, 'text'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useTextAlignProp */])(textAlign), 'container', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Container, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Container, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Container.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"];
Container.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Container has no maximum width. */
  fluid: PropTypes.bool,

  /** Reduce maximum width to more naturally accommodate text. */
  text: PropTypes.bool,

  /** Align container text. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Container);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(1105);
/* unused harmony reexport default */



/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A divider visually segments content into groups.
 */

function Divider(props) {
  var children = props.children,
      className = props.className,
      clearing = props.clearing,
      content = props.content,
      fitted = props.fitted,
      hidden = props.hidden,
      horizontal = props.horizontal,
      inverted = props.inverted,
      section = props.section,
      vertical = props.vertical;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(clearing, 'clearing'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(fitted, 'fitted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(section, 'section'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(vertical, 'vertical'), 'divider', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Divider, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Divider, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Divider.handledProps = ["as", "children", "className", "clearing", "content", "fitted", "hidden", "horizontal", "inverted", "section", "vertical"];
Divider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Divider can clear the content above it. */
  clearing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Divider can be fitted without any space above or below it. */
  fitted: PropTypes.bool,

  /** Divider can divide content without creating a dividing line. */
  hidden: PropTypes.bool,

  /** Divider can segment content horizontally. */
  horizontal: PropTypes.bool,

  /** Divider can have its colours inverted. */
  inverted: PropTypes.bool,

  /** Divider can provide greater margins to divide sections of content. */
  section: PropTypes.bool,

  /** Divider can segment content vertically. */
  vertical: PropTypes.bool
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Divider);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(1107);
/* unused harmony reexport default */



/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Image__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeaderContent__ = __webpack_require__(502);










/**
 * A header provides a short summary of content
 */

function Header(props) {
  var attached = props.attached,
      block = props.block,
      children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      disabled = props.disabled,
      dividing = props.dividing,
      floated = props.floated,
      icon = props.icon,
      image = props.image,
      inverted = props.inverted,
      size = props.size,
      sub = props.sub,
      subheader = props.subheader,
      textAlign = props.textAlign;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(block, 'block'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(dividing, 'dividing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(icon === true, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(image === true, 'image'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(sub, 'sub'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(Header, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(Header, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var iconElement = __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  });
  var imageElement = __WEBPACK_IMPORTED_MODULE_7__Image__["a" /* default */].create(image, {
    autoGenerateKey: false
  });
  var subheaderElement = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */].create(subheader, {
    autoGenerateKey: false
  });

  if (iconElement || imageElement) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), iconElement || imageElement, (content || subheaderElement) && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */], null, content, subheaderElement));
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), content, subheaderElement);
}

Header.handledProps = ["as", "attached", "block", "children", "className", "color", "content", "disabled", "dividing", "floated", "icon", "image", "inverted", "size", "sub", "subheader", "textAlign"];
Header.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Attach header  to other content, like a segment. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Format header to appear inside a content block. */
  block: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the header. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Show that the header is inactive. */
  disabled: PropTypes.bool,

  /** Divide header from the content below it. */
  dividing: PropTypes.bool,

  /** Header can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Add an icon by icon name or pass an Icon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Add an image by img src or pass an Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Inverts the color of the header for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Content headings are sized with em and are based on the font-size of their container. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'mini')),

  /** Headers may be formatted to label smaller or de-emphasized content. */
  sub: PropTypes.bool,

  /** Shorthand for Header.Subheader. */
  subheader: customPropTypes.itemShorthand,

  /** Align header content. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};
Header.Content = __WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */];
Header.Subheader = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Header);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1109);
/* unused harmony reexport default */



/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ListContent__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ListDescription__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ListHeader__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ListIcon__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ListItem__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ListList__ = __webpack_require__(504);




















/**
 * A list groups related content.
 */

var List =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(List, _Component);

  function List() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemOverrides", function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);

          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onItemClick', e, itemProps);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(List, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          animated = _this$props.animated,
          bulleted = _this$props.bulleted,
          celled = _this$props.celled,
          children = _this$props.children,
          className = _this$props.className,
          content = _this$props.content,
          divided = _this$props.divided,
          floated = _this$props.floated,
          horizontal = _this$props.horizontal,
          inverted = _this$props.inverted,
          items = _this$props.items,
          link = _this$props.link,
          ordered = _this$props.ordered,
          relaxed = _this$props.relaxed,
          selection = _this$props.selection,
          size = _this$props.size,
          verticalAlign = _this$props.verticalAlign;
      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(animated, 'animated'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(bulleted, 'bulleted'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(celled, 'celled'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(ordered, 'ordered'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["y" /* useKeyOnly */])(selection, 'selection'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["z" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["C" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["D" /* useVerticalAlignProp */])(verticalAlign), 'list', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getUnhandledProps */])(List, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["p" /* getElementType */])(List, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          role: "list",
          className: classes
        }, rest), children);
      }

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          role: "list",
          className: classes
        }, rest), content);
      }

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        role: "list",
        className: classes
      }, rest), __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(items, function (item) {
        return __WEBPACK_IMPORTED_MODULE_18__ListItem__["a" /* default */].create(item, {
          overrideProps: _this2.handleItemOverrides
        });
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Content", __WEBPACK_IMPORTED_MODULE_14__ListContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Description", __WEBPACK_IMPORTED_MODULE_15__ListDescription__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Header", __WEBPACK_IMPORTED_MODULE_16__ListHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Icon", __WEBPACK_IMPORTED_MODULE_17__ListIcon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "Item", __WEBPACK_IMPORTED_MODULE_18__ListItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "List", __WEBPACK_IMPORTED_MODULE_19__ListList__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "handledProps", ["animated", "as", "bulleted", "celled", "children", "className", "content", "divided", "floated", "horizontal", "inverted", "items", "link", "onItemClick", "ordered", "relaxed", "selection", "size", "verticalAlign"]);

List.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A list can animate to set the current item apart from the list. */
  animated: PropTypes.bool,

  /** A list can mark items with a bullet. */
  bulleted: PropTypes.bool,

  /** A list can divide its items into cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A list can show divisions between content. */
  divided: PropTypes.bool,

  /** An list can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A list can be formatted to have items appear horizontally. */
  horizontal: PropTypes.bool,

  /** A list can be inverted to appear on a dark background. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for ListItem. */
  items: customPropTypes.collectionShorthand,

  /** A list can be specially formatted for navigation links. */
  link: PropTypes.bool,

  /**
   * onClick handler for ListItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A list can be ordered numerically. */
  ordered: PropTypes.bool,

  /** A list can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A selection list formats list items as possible choices. */
  selection: PropTypes.bool,

  /** A list can vary in size. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (List);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(1111);
/* unused harmony reexport default */



/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * A loader alerts a user to wait for an activity to complete.
 * @see Dimmer
 */

function Loader(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      indeterminate = props.indeterminate,
      inline = props.inline,
      inverted = props.inverted,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(indeterminate, 'indeterminate'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(children || content, 'text'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["z" /* useKeyOrValueAndKey */])(inline, 'inline'), 'loader', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Loader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Loader, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Loader.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"];
Loader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A loader can be active or visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A loader can be disabled or hidden. */
  disabled: PropTypes.bool,

  /** A loader can show it's unsure of how long a task will take. */
  indeterminate: PropTypes.bool,

  /** Loaders can appear inline with content. */
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['centered'])]),

  /** Loaders can have their colors inverted. */
  inverted: PropTypes.bool,

  /** Loaders can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Loader);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Placeholder__ = __webpack_require__(1113);
/* unused harmony reexport default */



/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaceholderHeader__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlaceholderImage__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlaceholderLine__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlaceholderParagraph__ = __webpack_require__(508);









/**
 * A placeholder is used to reserve splace for content that soon will appear in a layout.
 */

function Placeholder(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      inverted = props.inverted;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), 'placeholder', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Placeholder, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Placeholder, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Placeholder.handledProps = ["as", "children", "className", "content", "fluid", "inverted"];
Placeholder.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid placeholder takes up the width of its container. */
  fluid: PropTypes.bool,

  /** A placeholder can have their colors inverted. */
  inverted: PropTypes.bool
} : {};
Placeholder.Header = __WEBPACK_IMPORTED_MODULE_5__PlaceholderHeader__["a" /* default */];
Placeholder.Image = __WEBPACK_IMPORTED_MODULE_6__PlaceholderImage__["a" /* default */];
Placeholder.Line = __WEBPACK_IMPORTED_MODULE_7__PlaceholderLine__["a" /* default */];
Placeholder.Paragraph = __WEBPACK_IMPORTED_MODULE_8__PlaceholderParagraph__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Placeholder);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rail__ = __webpack_require__(1115);
/* unused harmony reexport default */



/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(5);






/**
 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
 */

function Rail(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      close = props.close,
      content = props.content,
      dividing = props.dividing,
      internal = props.internal,
      position = props.position,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', position, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(dividing, 'dividing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* useKeyOnly */])(internal, 'internal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["z" /* useKeyOrValueAndKey */])(close, 'close'), 'rail', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getUnhandledProps */])(Rail, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* getElementType */])(Rail, props);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Rail.handledProps = ["as", "attached", "children", "className", "close", "content", "dividing", "internal", "position", "size"];
Rail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A rail can appear attached to the main viewport. */
  attached: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A rail can appear closer to the main viewport. */
  close: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A rail can create a division between itself and a container. */
  dividing: PropTypes.bool,

  /** A rail can attach itself to the inside of a container. */
  internal: PropTypes.bool,

  /** A rail can be presented on the left or right side of a container. */
  position: PropTypes.oneOf(SUI.FLOATS).isRequired,

  /** A rail can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Rail);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reveal__ = __webpack_require__(1117);
/* unused harmony reexport default */



/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RevealContent__ = __webpack_require__(509);






/**
 * A reveal displays additional content in place of previous content when activated.
 */

function Reveal(props) {
  var active = props.active,
      animated = props.animated,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      instant = props.instant;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', animated, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(instant, 'instant'), 'reveal', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Reveal, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Reveal, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Reveal.handledProps = ["active", "animated", "as", "children", "className", "content", "disabled", "instant"];
Reveal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An active reveal displays its hidden content. */
  active: PropTypes.bool,

  /** An animation name that will be applied to Reveal. */
  animated: PropTypes.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled reveal will not animate when hovered. */
  disabled: PropTypes.bool,

  /** An element can show its content without delay. */
  instant: PropTypes.bool
} : {};
Reveal.Content = __WEBPACK_IMPORTED_MODULE_5__RevealContent__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Reveal);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Segment__ = __webpack_require__(510);
/* unused harmony reexport default */



/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(513);
/* unused harmony reexport default */



/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(71),
    baseIteratee = __webpack_require__(49),
    basePickBy = __webpack_require__(434),
    getAllKeysIn = __webpack_require__(430);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionContent__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccordionPanel__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccordionTitle__ = __webpack_require__(286);









/**
 * An accordion allows users to toggle the display of sections of content.
 */

function Accordion(props) {
  var className = props.className,
      fluid = props.fluid,
      inverted = props.inverted,
      styled = props.styled;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(styled, 'styled'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Accordion, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }));
}

Accordion.handledProps = ["className", "fluid", "inverted", "styled"];
Accordion.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** Format to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Format for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Adds some basic styling to accordion panels. */
  styled: PropTypes.bool
} : {};
Accordion.Accordion = __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */];
Accordion.Content = __WEBPACK_IMPORTED_MODULE_6__AccordionContent__["a" /* default */];
Accordion.Panel = __WEBPACK_IMPORTED_MODULE_7__AccordionPanel__["a" /* default */];
Accordion.Title = __WEBPACK_IMPORTED_MODULE_8__AccordionTitle__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Embed__ = __webpack_require__(1123);
/* unused harmony reexport default */



/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_Icon__ = __webpack_require__(42);














/**
 * An embed displays content from other websites like YouTube videos or Google Maps.
 */

var Embed =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Embed, _Component);

  function Embed() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Embed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Embed)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClick", function (e) {
      var onClick = _this.props.onClick;
      var active = _this.state.active;
      if (onClick) onClick(e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        active: true
      }));
      if (!active) _this.trySetState({
        active: true
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Embed, [{
    key: "getSrc",
    value: function getSrc() {
      var _this$props = this.props,
          _this$props$autoplay = _this$props.autoplay,
          autoplay = _this$props$autoplay === void 0 ? true : _this$props$autoplay,
          _this$props$brandedUI = _this$props.brandedUI,
          brandedUI = _this$props$brandedUI === void 0 ? false : _this$props$brandedUI,
          _this$props$color = _this$props.color,
          color = _this$props$color === void 0 ? '#444444' : _this$props$color,
          _this$props$hd = _this$props.hd,
          hd = _this$props$hd === void 0 ? true : _this$props$hd,
          id = _this$props.id,
          source = _this$props.source,
          url = _this$props.url;

      if (source === 'youtube') {
        return ["//www.youtube.com/embed/".concat(id), '?autohide=true', "&amp;autoplay=".concat(autoplay), "&amp;color=".concat(encodeURIComponent(color)), "&amp;hq=".concat(hd), '&amp;jsapi=false', "&amp;modestbranding=".concat(brandedUI), "&amp;rel=".concat(brandedUI ? 0 : 1)].join('');
      }

      if (source === 'vimeo') {
        return ["//player.vimeo.com/video/".concat(id), '?api=false', "&amp;autoplay=".concat(autoplay), '&amp;byline=false', "&amp;color=".concat(encodeURIComponent(color)), '&amp;portrait=false', '&amp;title=false'].join('');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          aspectRatio = _this$props2.aspectRatio,
          className = _this$props2.className,
          icon = _this$props2.icon,
          placeholder = _this$props2.placeholder;
      var active = this.state.active;
      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ui', aspectRatio, Object(__WEBPACK_IMPORTED_MODULE_12__lib__["y" /* useKeyOnly */])(active, 'active'), 'embed', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getUnhandledProps */])(Embed, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["p" /* getElementType */])(Embed, this.props);
      var iconShorthand = icon !== undefined ? icon : 'video play';
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), __WEBPACK_IMPORTED_MODULE_13__elements_Icon__["a" /* default */].create(iconShorthand, {
        autoGenerateKey: false
      }), placeholder && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img", {
        className: "placeholder",
        src: placeholder
      }), this.renderEmbed());
    }
  }, {
    key: "renderEmbed",
    value: function renderEmbed() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          content = _this$props3.content,
          iframe = _this$props3.iframe,
          source = _this$props3.source;
      var active = this.state.active;
      if (!active) return null;
      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "embed"
      }, children);
      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "embed"
      }, content);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", {
        className: "embed"
      }, Object(__WEBPACK_IMPORTED_MODULE_12__lib__["e" /* createHTMLIframe */])(__WEBPACK_IMPORTED_MODULE_12__lib__["c" /* childrenUtils */].isNil(iframe) ? this.getSrc() : iframe, {
        defaultProps: {
          allowFullScreen: false,
          frameBorder: 0,
          height: '100%',
          scrolling: 'no',
          src: this.getSrc(),
          title: "Embedded content from ".concat(source, "."),
          width: '100%'
        },
        autoGenerateKey: false
      }));
    }
  }]);

  return Embed;
}(__WEBPACK_IMPORTED_MODULE_12__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Embed, "autoControlledProps", ['active']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Embed, "handledProps", ["active", "as", "aspectRatio", "autoplay", "brandedUI", "children", "className", "color", "content", "defaultActive", "hd", "icon", "id", "iframe", "onClick", "placeholder", "source", "url"]);


Embed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An embed can be active. */
  active: PropTypes.bool,

  /** An embed can specify an alternative aspect ratio. */
  aspectRatio: PropTypes.oneOf(['4:3', '16:9', '21:9']),

  /** Setting to true or false will force autoplay. */
  autoplay: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Whether to show networks branded UI like title cards, or after video calls to action. */
  brandedUI: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies a default chrome color with Vimeo or YouTube. */
  color: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initial value of active. */
  defaultActive: PropTypes.bool,

  /** Whether to prefer HD content. */
  hd: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Specifies an icon to use with placeholder content. */
  icon: customPropTypes.itemShorthand,

  /** Specifies an id for source. */
  id: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for HTML iframe. */
  iframe: customPropTypes.every([customPropTypes.demand(['source']), customPropTypes.itemShorthand]),

  /**
   * Сalled on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onClick: PropTypes.func,

  /** A placeholder image for embed. */
  placeholder: PropTypes.string,

  /** Specifies a source to use. */
  source: customPropTypes.every([customPropTypes.disallow(['sourceUrl']), PropTypes.oneOf(['youtube', 'vimeo'])]),

  /** Specifies a url to use for embed. */
  url: customPropTypes.every([customPropTypes.disallow(['source']), PropTypes.string])
} : {};

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup__ = __webpack_require__(1125);
/* unused harmony reexport default */



/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isArray__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_pick__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_includes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_reduce__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_popper__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shallowequal__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__addons_Portal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_positions__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_createReferenceProxy__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PopupContent__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__PopupHeader__ = __webpack_require__(529);































/**
 * A Popup displays additional information on top of a page.
 */
var Popup =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Popup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {});

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", false);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "triggerRef", Object(__WEBPACK_IMPORTED_MODULE_21_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPortalProps", function () {
      var portalProps = {};
      var _this$props = _this.props,
          on = _this$props.on,
          hoverable = _this$props.hoverable;
      var normalizedOn = __WEBPACK_IMPORTED_MODULE_12_lodash_isArray___default()(on) ? on : [on];

      if (hoverable) {
        portalProps.closeOnPortalMouseLeave = true;
        portalProps.mouseLeaveDelay = 300;
      }

      if (__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(normalizedOn, 'hover')) {
        portalProps.openOnTriggerClick = false;
        portalProps.closeOnTriggerClick = false;
        portalProps.openOnTriggerMouseEnter = true;
        portalProps.closeOnTriggerMouseLeave = true; // Taken from SUI: https://git.io/vPmCm

        portalProps.mouseLeaveDelay = 70;
        portalProps.mouseEnterDelay = 50;
      }

      if (__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(normalizedOn, 'click')) {
        portalProps.openOnTriggerClick = true;
        portalProps.closeOnTriggerClick = true;
        portalProps.closeOnDocumentClick = true;
      }

      if (__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(normalizedOn, 'focus')) {
        portalProps.openOnTriggerFocus = true;
        portalProps.closeOnTriggerBlur = true;
      }

      return portalProps;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "hideOnScroll", function (e) {
      _this.setState({
        closed: true
      });

      __WEBPACK_IMPORTED_MODULE_24__lib__["n" /* eventStack */].unsub('scroll', _this.hideOnScroll, {
        target: window
      });
      _this.timeoutId = setTimeout(function () {
        _this.setState({
          closed: false
        });
      }, 50);

      _this.handleClose(e);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleClose", function (e) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOpen", function (e) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalMount", function (e) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onMount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handlePortalUnmount", function (e) {
      _this.positionUpdate = null;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onUnmount', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderContent", function (_ref) {
      var popperPlacement = _ref.placement,
          popperRef = _ref.ref,
          scheduleUpdate = _ref.scheduleUpdate,
          popperStyle = _ref.style;
      var _this$props2 = _this.props,
          basic = _this$props2.basic,
          children = _this$props2.children,
          className = _this$props2.className,
          content = _this$props2.content,
          hideOnScroll = _this$props2.hideOnScroll,
          flowing = _this$props2.flowing,
          header = _this$props2.header,
          inverted = _this$props2.inverted,
          size = _this$props2.size,
          style = _this$props2.style,
          wide = _this$props2.wide;
      var contentRestProps = _this.state.contentRestProps;
      _this.positionUpdate = scheduleUpdate;
      var classes = __WEBPACK_IMPORTED_MODULE_19_classnames___default()('ui', __WEBPACK_IMPORTED_MODULE_26__lib_positions__["a" /* placementMapping */][popperPlacement], size, Object(__WEBPACK_IMPORTED_MODULE_24__lib__["z" /* useKeyOrValueAndKey */])(wide, 'wide'), Object(__WEBPACK_IMPORTED_MODULE_24__lib__["y" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_24__lib__["y" /* useKeyOnly */])(flowing, 'flowing'), Object(__WEBPACK_IMPORTED_MODULE_24__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), 'popup transition visible', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_24__lib__["p" /* getElementType */])(Popup, _this.props);

      var styles = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        // Heads up! We need default styles to get working correctly `flowing`
        left: 'auto',
        right: 'auto'
      }, popperStyle, style);

      return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: popperRef
      }, __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, contentRestProps, {
        className: classes,
        style: styles
      }), __WEBPACK_IMPORTED_MODULE_24__lib__["c" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_29__PopupHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_28__PopupContent__["a" /* default */].create(content, {
        autoGenerateKey: false
      })) : children, hideOnScroll && __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__semantic_ui_react_event_stack___default.a, {
        on: _this.hideOnScroll,
        name: "scroll",
        target: "window"
      })));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Popup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var depsEqual = __WEBPACK_IMPORTED_MODULE_23_shallowequal___default()(this.props.popperDependencies, prevProps.popperDependencies);

      if (!depsEqual) {
        this.handleUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      if (this.positionUpdate) this.positionUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          context = _this$props3.context,
          disabled = _this$props3.disabled,
          eventsEnabled = _this$props3.eventsEnabled,
          offset = _this$props3.offset,
          pinned = _this$props3.pinned,
          popperModifiers = _this$props3.popperModifiers,
          position = _this$props3.position,
          positionFixed = _this$props3.positionFixed,
          trigger = _this$props3.trigger;
      var _this$state = this.state,
          closed = _this$state.closed,
          portalRestProps = _this$state.portalRestProps;
      if (closed || disabled) return trigger;

      var modifiers = __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default()({
        arrow: {
          enabled: false
        },
        flip: {
          enabled: !pinned
        },
        // There are issues with `keepTogether` and `offset`
        // https://github.com/FezVrasta/popper.js/issues/557
        keepTogether: {
          enabled: !!offset
        },
        offset: {
          offset: offset
        }
      }, popperModifiers);

      var referenceElement = Object(__WEBPACK_IMPORTED_MODULE_27__lib_createReferenceProxy__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(context) ? this.triggerRef : context);

      var mergedPortalProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.getPortalProps(), portalRestProps);

      return __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__addons_Portal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, mergedPortalProps, {
        onClose: this.handleClose,
        onMount: this.handlePortalMount,
        onOpen: this.handleOpen,
        onUnmount: this.handlePortalUnmount,
        trigger: trigger,
        triggerRef: this.triggerRef
      }), __WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_popper__["a" /* Popper */], {
        eventsEnabled: eventsEnabled,
        modifiers: modifiers,
        placement: __WEBPACK_IMPORTED_MODULE_26__lib_positions__["b" /* positionsMapping */][position],
        positionFixed: positionFixed,
        referenceElement: referenceElement
      }, this.renderContent));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (state.closed || state.disabled) return {};
      var unhandledProps = Object(__WEBPACK_IMPORTED_MODULE_24__lib__["q" /* getUnhandledProps */])(Popup, props);

      var contentRestProps = __WEBPACK_IMPORTED_MODULE_15_lodash_reduce___default()(unhandledProps, function (acc, val, key) {
        if (!__WEBPACK_IMPORTED_MODULE_14_lodash_includes___default()(__WEBPACK_IMPORTED_MODULE_25__addons_Portal__["a" /* default */].handledProps, key)) acc[key] = val;
        return acc;
      }, {});

      var portalRestProps = __WEBPACK_IMPORTED_MODULE_13_lodash_pick___default()(unhandledProps, __WEBPACK_IMPORTED_MODULE_25__addons_Portal__["a" /* default */].handledProps);

      return {
        contentRestProps: contentRestProps,
        portalRestProps: portalRestProps
      };
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "defaultProps", {
  disabled: false,
  eventsEnabled: true,
  offset: 0,
  on: ['click', 'hover'],
  pinned: false,
  position: 'top left'
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "Content", __WEBPACK_IMPORTED_MODULE_28__PopupContent__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "Header", __WEBPACK_IMPORTED_MODULE_29__PopupHeader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Popup, "handledProps", ["as", "basic", "children", "className", "content", "context", "disabled", "eventsEnabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popperDependencies", "popperModifiers", "position", "positionFixed", "size", "style", "trigger", "wide"]);


Popup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Display the popup without the pointing arrow. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Simple text content for the popover. */
  content: customPropTypes.itemShorthand,

  /** Existing element the pop-up should be bound to. */
  context: PropTypes.oneOfType([PropTypes.object, customPropTypes.refObject]),

  /** A disabled popup only renders its trigger. */
  disabled: PropTypes.bool,

  /** Enables the Popper.js event listeners. */
  eventsEnabled: PropTypes.bool,

  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
  flowing: PropTypes.bool,

  /** Takes up the entire width of its offset container. */
  // TODO: implement the Popup fluid layout
  // fluid: PropTypes.bool,

  /** Header displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** Hide the Popup when scrolling the window. */
  hideOnScroll: PropTypes.bool,

  /** Whether the popup should not close on hover. */
  hoverable: PropTypes.bool,

  /** Invert the colors of the Popup. */
  inverted: PropTypes.bool,

  /** Offset value to apply to rendered popup. Accepts the following units:
   * - px or unit-less, interpreted as pixels
   * - %, percentage relative to the length of the trigger element
   * - %p, percentage relative to the length of the popup element
   * - vw, CSS viewport width unit
   * - vh, CSS viewport height unit
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Events triggering the popup. */
  on: PropTypes.oneOfType([PropTypes.oneOf(['hover', 'click', 'focus']), PropTypes.arrayOf(PropTypes.oneOf(['hover', 'click', 'focus']))]),

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Disables automatic repositioning of the component, it will always be placed according to the position value. */
  pinned: PropTypes.bool,

  /** Position for the popover. */
  position: PropTypes.oneOf(positions),

  /** Tells `Popper.js` to use the `position: fixed` strategy to position the popover. */
  positionFixed: PropTypes.bool,

  /** An object containing custom settings for the Popper.js modifiers. */
  popperModifiers: PropTypes.object,

  /** A popup can have dependencies which update will schedule a position update. */
  popperDependencies: PropTypes.array,

  /** Popup size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big', 'massive')),

  /** Custom Popup style. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the popup is defined. */
  trigger: PropTypes.node,

  /** Popup width. */
  wide: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])])
} : {};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1127),
    createAssigner = __webpack_require__(1130);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(174),
    assignMergeValue = __webpack_require__(517),
    baseFor = __webpack_require__(394),
    baseMergeDeep = __webpack_require__(1128),
    isObject = __webpack_require__(47),
    keysIn = __webpack_require__(183),
    safeGet = __webpack_require__(518);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(517),
    cloneBuffer = __webpack_require__(428),
    cloneTypedArray = __webpack_require__(431),
    copyArray = __webpack_require__(107),
    initCloneObject = __webpack_require__(432),
    isArguments = __webpack_require__(124),
    isArray = __webpack_require__(26),
    isArrayLikeObject = __webpack_require__(130),
    isBuffer = __webpack_require__(104),
    isFunction = __webpack_require__(79),
    isObject = __webpack_require__(47),
    isPlainObject = __webpack_require__(135),
    isTypedArray = __webpack_require__(128),
    safeGet = __webpack_require__(518),
    toPlainObject = __webpack_require__(1129);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(134),
    keysIn = __webpack_require__(183);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(80),
    isIterateeCall = __webpack_require__(106);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* unused harmony reexport Manager */
/* unused harmony reexport Reference */
// Public components



 // Public types

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_popper_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Manager__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(527);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !__WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_7_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(519);
var isArguments = __webpack_require__(1135);
var is = __webpack_require__(1136);
var isRegex = __webpack_require__(1143);
var flags = __webpack_require__(1145);
var isDate = __webpack_require__(1151);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(520); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(141);
var callBind = __webpack_require__(1137);

var implementation = __webpack_require__(521);
var getPolyfill = __webpack_require__(522);
var shim = __webpack_require__(1142);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(142);

var GetIntrinsic = __webpack_require__(1139);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

module.exports = function callBind() {
	return $reflectApply(bind, $call, arguments);
};

module.exports.apply = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1140)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(142);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(1141);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(522);
var define = __webpack_require__(141);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(1144);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(142);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(141);
var callBind = __webpack_require__(1146);

var implementation = __webpack_require__(523);
var getPolyfill = __webpack_require__(524);
var shim = __webpack_require__(1150);

var flagsBound = callBind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(142);

var GetIntrinsic = __webpack_require__(1147);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

module.exports = function callBind() {
	return $reflectApply(bind, $call, arguments);
};

module.exports.apply = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1148)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(142);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(1149);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(141).supportsDescriptors;
var getPolyfill = __webpack_require__(524);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1153);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(526);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(38);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(527);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return positionsMapping; });
/* unused harmony export positions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placementMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_invert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_keys__);


var positionsMapping = {
  'top center': 'top',
  'top left': 'top-start',
  'top right': 'top-end',
  'bottom center': 'bottom',
  'bottom left': 'bottom-start',
  'bottom right': 'bottom-end',
  'right center': 'right',
  'left center': 'left'
};
var positions = __WEBPACK_IMPORTED_MODULE_1_lodash_keys___default()(positionsMapping);
var placementMapping = __WEBPACK_IMPORTED_MODULE_0_lodash_invert___default()(positionsMapping);

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(387),
    createInverter = __webpack_require__(1157),
    identity = __webpack_require__(65);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var baseInverter = __webpack_require__(1158);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(170);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_memoize__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stardust_ui_react_component_ref__ = __webpack_require__(39);






var ReferenceProxy =
/*#__PURE__*/
function () {
  function ReferenceProxy(refObject) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ReferenceProxy);

    this.ref = refObject;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ReferenceProxy, [{
    key: "getBoundingClientRect",
    value: function getBoundingClientRect() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_invoke___default()(this.ref.current, 'getBoundingClientRect', {});
    }
  }, {
    key: "clientWidth",
    get: function get() {
      return this.getBoundingClientRect().width;
    }
  }, {
    key: "clientHeight",
    get: function get() {
      return this.getBoundingClientRect().height;
    }
  }, {
    key: "parentNode",
    get: function get() {
      return this.ref.current ? this.ref.current.parentNode : undefined;
    }
  }]);

  return ReferenceProxy;
}();
/**
 * Popper.js does not support ref objects from `createRef()` as referenceElement. If we will pass
 * directly `ref`, `ref.current` will be `null` at the render process. We use memoize to keep the
 * same reference between renders.
 *
 * @see https://popper.js.org/popper-documentation.html#referenceObject
 */


var createReferenceProxy = __WEBPACK_IMPORTED_MODULE_2_lodash_memoize___default()(function (reference) {
  return new ReferenceProxy(Object(__WEBPACK_IMPORTED_MODULE_4__stardust_ui_react_component_ref__["c" /* isRefObject */])(reference) ? reference : Object(__WEBPACK_IMPORTED_MODULE_4__stardust_ui_react_component_ref__["d" /* toRefObject */])(reference));
});

/* harmony default export */ __webpack_exports__["a"] = (createReferenceProxy);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Progress__ = __webpack_require__(1161);
/* unused harmony reexport default */



/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_round__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_clamp__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(5);
















/**
 * A progress bar shows the progression of a task.
 */

var Progress =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Progress, _Component);

  function Progress() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Progress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Progress)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "calculatePercent", function () {
      var _this$props = _this.props,
          percent = _this$props.percent,
          total = _this$props.total,
          value = _this$props.value;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(percent)) return percent;
      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(total) && !__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(value)) return value / total * 100;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "computeValueText", function (percent) {
      var _this$props2 = _this.props,
          progress = _this$props2.progress,
          total = _this$props2.total,
          value = _this$props2.value;
      if (progress === 'value') return value;
      if (progress === 'ratio') return "".concat(value, "/").concat(total);
      return "".concat(percent, "%");
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPercent", function () {
      var _this$props3 = _this.props,
          precision = _this$props3.precision,
          progress = _this$props3.progress,
          total = _this$props3.total,
          value = _this$props3.value;

      var percent = __WEBPACK_IMPORTED_MODULE_9_lodash_clamp___default()(_this.calculatePercent(), 0, 100);

      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(total) && !__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(value) && progress === 'value') {
        return value / total * 100;
      }

      if (progress === 'value') return value;
      if (__WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(precision)) return percent;
      return __WEBPACK_IMPORTED_MODULE_8_lodash_round___default()(percent, precision);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "isAutoSuccess", function () {
      var _this$props4 = _this.props,
          autoSuccess = _this$props4.autoSuccess,
          percent = _this$props4.percent,
          total = _this$props4.total,
          value = _this$props4.value;
      return autoSuccess && (percent >= 100 || value >= total);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderLabel", function () {
      var _this$props5 = _this.props,
          children = _this$props5.children,
          content = _this$props5.content,
          label = _this$props5.label;
      if (!__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "label"
      }, children);
      if (!__WEBPACK_IMPORTED_MODULE_15__lib__["c" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "label"
      }, content);
      return Object(__WEBPACK_IMPORTED_MODULE_15__lib__["d" /* createHTMLDivision */])(label, {
        autoGenerateKey: false,
        defaultProps: {
          className: 'label'
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderProgress", function (percent) {
      var _this$props6 = _this.props,
          precision = _this$props6.precision,
          progress = _this$props6.progress;
      if (!progress && __WEBPACK_IMPORTED_MODULE_10_lodash_isUndefined___default()(precision)) return;
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "progress"
      }, _this.computeValueText(percent));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Progress, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          active = _this$props7.active,
          attached = _this$props7.attached,
          className = _this$props7.className,
          color = _this$props7.color,
          disabled = _this$props7.disabled,
          error = _this$props7.error,
          indicating = _this$props7.indicating,
          inverted = _this$props7.inverted,
          size = _this$props7.size,
          success = _this$props7.success,
          warning = _this$props7.warning;
      var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(active || indicating, 'active'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(indicating, 'indicating'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(success || this.isAutoSuccess(), 'success'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["C" /* useValueAndKey */])(attached, 'attached'), 'progress', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* getUnhandledProps */])(Progress, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["p" /* getElementType */])(Progress, this.props);
      var percent = this.getPercent() || 0;
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        "data-percent": Math.floor(percent)
      }), __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div", {
        className: "bar",
        style: {
          width: "".concat(percent, "%")
        }
      }, this.renderProgress(percent)), this.renderLabel());
    }
  }]);

  return Progress;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Progress, "handledProps", ["active", "as", "attached", "autoSuccess", "children", "className", "color", "content", "disabled", "error", "indicating", "inverted", "label", "percent", "precision", "progress", "size", "success", "total", "value", "warning"]);

Progress.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A progress bar can show activity. */
  active: PropTypes.bool,

  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
  attached: PropTypes.oneOf(['top', 'bottom']),

  /** Whether success state should automatically trigger when progress completes. */
  autoSuccess: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A progress bar can have different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A progress bar be disabled. */
  disabled: PropTypes.bool,

  /** A progress bar can show a error state. */
  error: PropTypes.bool,

  /** An indicating progress bar visually indicates the current level of progress of a task. */
  indicating: PropTypes.bool,

  /** A progress bar can have its colors inverted. */
  inverted: PropTypes.bool,

  /** Can be set to either to display progress as percent or ratio. */
  label: customPropTypes.itemShorthand,

  /** Current percent complete. */
  percent: customPropTypes.every([customPropTypes.disallow(['total', 'value']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Decimal point precision for calculated progress. */
  precision: PropTypes.number,

  /** A progress bar can contain a text value indicating current progress. */
  progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['percent', 'ratio', 'value'])]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'huge', 'massive')),

  /** A progress bar can show a success state. */
  success: PropTypes.bool,

  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
  total: customPropTypes.every([customPropTypes.demand(['value']), customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
  value: customPropTypes.every([customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** A progress bar can show a warning state. */
  warning: PropTypes.bool
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Progress);

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(1163);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(44),
    toInteger = __webpack_require__(72),
    toNumber = __webpack_require__(169),
    toString = __webpack_require__(64);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(392),
    toNumber = __webpack_require__(169);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(1166);
/* unused harmony reexport default */



/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_times__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_times___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_times__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RatingIcon__ = __webpack_require__(530);

















/**
 * A rating indicates user interest in content.
 */

var Rating =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Rating, _Component);

  function Rating() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Rating);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Rating)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconClick", function (e, _ref) {
      var index = _ref.index;
      var _this$props = _this.props,
          clearable = _this$props.clearable,
          disabled = _this$props.disabled,
          maxRating = _this$props.maxRating,
          onRate = _this$props.onRate;
      var rating = _this.state.rating;
      if (disabled) return; // default newRating is the clicked icon
      // allow toggling a binary rating
      // allow clearing ratings

      var newRating = index + 1;

      if (clearable === 'auto' && maxRating === 1) {
        newRating = +!rating;
      } else if (clearable === true && newRating === rating) {
        newRating = 0;
      } // set rating


      _this.trySetState({
        rating: newRating,
        isSelecting: false
      });

      if (onRate) onRate(e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        rating: newRating
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleIconMouseEnter", function (e, _ref2) {
      var index = _ref2.index;
      if (_this.props.disabled) return;

      _this.setState({
        selectedIndex: index,
        isSelecting: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseLeave", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_10_lodash_invoke___default.a.apply(void 0, [_this.props, 'onMouseLeave'].concat(args));

      if (_this.props.disabled) return;

      _this.setState({
        selectedIndex: -1,
        isSelecting: false
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Rating, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          icon = _this$props2.icon,
          maxRating = _this$props2.maxRating,
          size = _this$props2.size;
      var _this$state = this.state,
          rating = _this$state.rating,
          selectedIndex = _this$state.selectedIndex,
          isSelecting = _this$state.isSelecting;
      var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', icon, size, Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* getUnhandledProps */])(Rating, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["p" /* getElementType */])(Rating, this.props);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        role: "radiogroup",
        onMouseLeave: this.handleMouseLeave,
        tabIndex: disabled ? 0 : -1
      }), __WEBPACK_IMPORTED_MODULE_9_lodash_times___default()(maxRating, function (i) {
        return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RatingIcon__["a" /* default */], {
          tabIndex: disabled ? -1 : 0,
          active: rating >= i + 1,
          "aria-checked": rating === i + 1,
          "aria-posinset": i + 1,
          "aria-setsize": maxRating,
          index: i,
          key: i,
          onClick: _this2.handleIconClick,
          onMouseEnter: _this2.handleIconMouseEnter,
          selected: selectedIndex >= i && isSelecting
        });
      }));
    }
  }]);

  return Rating;
}(__WEBPACK_IMPORTED_MODULE_15__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "autoControlledProps", ['rating']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "defaultProps", {
  clearable: 'auto',
  maxRating: 1
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "Icon", __WEBPACK_IMPORTED_MODULE_16__RatingIcon__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Rating, "handledProps", ["as", "className", "clearable", "defaultRating", "disabled", "icon", "maxRating", "onRate", "rating", "size"]);


Rating.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * You can clear the rating by clicking on the current start rating.
   * By default a rating will be only clearable if there is 1 icon.
   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
   */
  clearable: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['auto'])]),

  /** The initial rating value. */
  defaultRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** You can disable or enable interactive rating.  Makes a read-only rating. */
  disabled: PropTypes.bool,

  /** A rating can use a set of star or heart icons. */
  icon: PropTypes.oneOf(['star', 'heart']),

  /** The total number of icons. */
  maxRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called after user selects a new rating.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed rating.
   */
  onRate: PropTypes.func,

  /** The current number of active icons. */
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big'))
} : {};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(396),
    castFunction = __webpack_require__(413),
    toInteger = __webpack_require__(72);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1169);
/* unused harmony reexport default */



/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_partialRight__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_partialRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_partialRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_inRange__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_reduce__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_keyboard_key__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shallowequal__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__elements_Input__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SearchCategory__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SearchResult__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SearchResults__ = __webpack_require__(533);































/**
 * A search module allows a user to query for results from a selection of data
 */
var Search =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_inherits___default()(Search, _Component);

  function Search() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default()(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf___default()(Search)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleResultSelect", function (e, result) {
      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onResultSelect', e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        result: result
      }));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSelectionChange", function (e) {
      var result = _this.getSelectedResult();

      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onSelectionChange', e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        result: result
      }));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnEscape", function (e) {
      if (__WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.Escape) return;
      e.preventDefault();

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionOnKeyDown", function (e) {
      switch (__WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.ArrowDown:
          e.preventDefault();

          _this.moveSelectionBy(e, 1);

          break;

        case __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.ArrowUp:
          e.preventDefault();

          _this.moveSelectionBy(e, -1);

          break;

        default:
          break;
      }
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "selectItemOnEnter", function (e) {
      if (__WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_21_keyboard_key___default.a.Enter) return;

      var result = _this.getSelectedResult(); // prevent selecting null if there was no selected item value


      if (!result) return;
      e.preventDefault(); // notify the onResultSelect prop that the user is trying to change value

      _this.setValue(result.title);

      _this.handleResultSelect(e, result);

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "closeOnDocumentClick", function (e) {
      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleMouseDown", function (e) {
      _this.isMouseDown = true;

      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onMouseDown', e, _this.props);

      __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].sub('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentMouseUp", function () {
      _this.isMouseDown = false;
      __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].unsub('mouseup', _this.handleDocumentMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleInputClick", function (e) {
      // prevent closeOnDocumentClick()
      e.nativeEvent.stopImmediatePropagation();

      _this.tryOpen();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, _ref) {
      var id = _ref.id;

      var result = _this.getSelectedResult(id); // prevent closeOnDocumentClick()


      e.nativeEvent.stopImmediatePropagation(); // notify the onResultSelect prop that the user is trying to change value

      _this.setValue(result.title);

      _this.handleResultSelect(e, result);

      _this.close();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemMouseDown", function (e) {
      // Heads up! We should prevent default to prevent blur events.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3298
      e.preventDefault();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleFocus", function (e) {
      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onFocus', e, _this.props);

      _this.setState({
        focus: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleBlur", function (e) {
      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onBlur', e, _this.props);

      _this.setState({
        focus: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSearchChange", function (e) {
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;
      var newQuery = e.target.value;

      __WEBPACK_IMPORTED_MODULE_18_lodash_invoke___default()(_this.props, 'onSearchChange', e, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        value: newQuery
      })); // open search dropdown on search query


      if (newQuery.length < minCharacters) {
        _this.close();
      } else if (!open) {
        _this.tryOpen(newQuery);
      }

      _this.setValue(newQuery);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "getFlattenedResults", function () {
      var _this$props = _this.props,
          category = _this$props.category,
          results = _this$props.results;
      return !category ? results : __WEBPACK_IMPORTED_MODULE_17_lodash_reduce___default()(results, function (memo, categoryData) {
        return memo.concat(categoryData.results);
      }, []);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "getSelectedResult", function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;

      var results = _this.getFlattenedResults();

      return __WEBPACK_IMPORTED_MODULE_16_lodash_get___default()(results, index);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "setValue", function (value) {
      var selectFirstResult = _this.props.selectFirstResult;

      _this.trySetState({
        value: value,
        selectedIndex: selectFirstResult ? 0 : -1
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "moveSelectionBy", function (e, offset) {
      var selectedIndex = _this.state.selectedIndex;

      var results = _this.getFlattenedResults();

      var lastIndex = results.length - 1; // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = selectedIndex + offset;
      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      _this.setState({
        selectedIndex: nextIndex
      });

      _this.scrollSelectedItemIntoView();

      _this.handleSelectionChange(e);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "scrollSelectedItemIntoView", function () {
      // Do not access document when server side rendering
      if (!Object(__WEBPACK_IMPORTED_MODULE_25__lib__["t" /* isBrowser */])()) return;
      var menu = document.querySelector('.ui.search.active.visible .results.visible');
      var item = menu.querySelector('.result.active');
      if (!item) return;
      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "tryOpen", function () {
      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var minCharacters = _this.props.minCharacters;
      if (currentValue.length < minCharacters) return;

      _this.open();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "open", function () {
      _this.trySetState({
        open: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "close", function () {
      _this.trySetState({
        open: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderSearchInput", function (rest) {
      var _this$props2 = _this.props,
          icon = _this$props2.icon,
          input = _this$props2.input;
      var value = _this.state.value;
      return __WEBPACK_IMPORTED_MODULE_26__elements_Input__["a" /* default */].create(input, {
        autoGenerateKey: false,
        defaultProps: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, rest, {
          icon: icon,
          input: {
            className: 'prompt',
            tabIndex: '0',
            autoComplete: 'off'
          },
          onChange: _this.handleSearchChange,
          onClick: _this.handleInputClick,
          value: value
        })
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderNoResults", function () {
      var _this$props3 = _this.props,
          noResultsDescription = _this$props3.noResultsDescription,
          noResultsMessage = _this$props3.noResultsMessage;
      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div", {
        className: "message empty"
      }, __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div", {
        className: "header"
      }, noResultsMessage), noResultsDescription && __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div", {
        className: "description"
      }, noResultsDescription));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderResult", function (_ref2, index, _array) {
      var childKey = _ref2.childKey,
          result = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ["childKey"]);

      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var resultRenderer = _this.props.resultRenderer;
      var selectedIndex = _this.state.selectedIndex;
      var offsetIndex = index + offset;
      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__SearchResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        key: childKey || result.id || result.title,
        active: selectedIndex === offsetIndex,
        onClick: _this.handleItemClick,
        onMouseDown: _this.handleItemMouseDown,
        renderer: resultRenderer
      }, result, {
        id: offsetIndex // Used to lookup the result on item click

      }));
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderResults", function () {
      var results = _this.props.results;
      return __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(results, _this.renderResult);
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderCategories", function () {
      var _this$props4 = _this.props,
          categoryLayoutRenderer = _this$props4.categoryLayoutRenderer,
          categoryRenderer = _this$props4.categoryRenderer,
          categories = _this$props4.results;
      var selectedIndex = _this.state.selectedIndex;
      var count = 0;
      return __WEBPACK_IMPORTED_MODULE_15_lodash_map___default()(categories, function (_ref3) {
        var childKey = _ref3.childKey,
            category = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ["childKey"]);

        var categoryProps = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({
          key: childKey || category.name,
          active: __WEBPACK_IMPORTED_MODULE_14_lodash_inRange___default()(selectedIndex, count, count + category.results.length),
          layoutRenderer: categoryLayoutRenderer,
          renderer: categoryRenderer
        }, category);

        var renderFn = __WEBPACK_IMPORTED_MODULE_13_lodash_partialRight___default()(_this.renderResult, count);

        count += category.results.length;
        return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__SearchCategory__["a" /* default */], categoryProps, category.results.map(renderFn));
      });
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderMenuContent", function () {
      var _this$props5 = _this.props,
          category = _this$props5.category,
          showNoResults = _this$props5.showNoResults,
          results = _this$props5.results;

      if (__WEBPACK_IMPORTED_MODULE_12_lodash_isEmpty___default()(results)) {
        return showNoResults ? _this.renderNoResults() : null;
      }

      return category ? _this.renderCategories() : _this.renderResults();
    });

    __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this), "renderResultsMenu", function () {
      var open = _this.state.open;
      var resultsClasses = open ? 'visible' : '';

      var menuContent = _this.renderMenuContent();

      if (!menuContent) return;
      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__SearchResults__["a" /* default */], {
        className: resultsClasses
      }, menuContent);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default()(Search, [{
    key: "UNSAFE_componentWillMount",
    // eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillMount() {
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      this.setValue(value);
      if (open) this.open();
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_getPrototypeOf___default()(Search.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, nextProps);

      if (!__WEBPACK_IMPORTED_MODULE_24_shallowequal___default()(nextProps.value, this.props.value)) {
        this.setValue(nextProps.value);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !__WEBPACK_IMPORTED_MODULE_24_shallowequal___default()(nextProps, this.props) || !__WEBPACK_IMPORTED_MODULE_24_shallowequal___default()(nextState, this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // eslint-disable-line complexity
      // focused / blurred
      if (!prevState.focus && this.state.focus) {
        if (!this.isMouseDown) {
          this.tryOpen();
        }

        if (this.state.open) {
          __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
        }
      } else if (prevState.focus && !this.state.focus) {
        if (!this.isMouseDown) {
          this.close();
        }

        __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      } // opened / closed


      if (!prevState.open && this.state.open) {
        this.open();
        __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].sub('click', this.closeOnDocumentClick);
        __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      } else if (prevState.open && !this.state.open) {
        this.close();
        __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].unsub('click', this.closeOnDocumentClick);
        __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].unsub('click', this.closeOnDocumentClick);
      __WEBPACK_IMPORTED_MODULE_25__lib__["n" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    } // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          searchClasses = _this$state2.searchClasses,
          focus = _this$state2.focus,
          open = _this$state2.open;
      var _this$props6 = this.props,
          aligned = _this$props6.aligned,
          category = _this$props6.category,
          className = _this$props6.className,
          fluid = _this$props6.fluid,
          loading = _this$props6.loading,
          size = _this$props6.size; // Classes

      var classes = __WEBPACK_IMPORTED_MODULE_20_classnames___default()('ui', open && 'active visible', size, searchClasses, Object(__WEBPACK_IMPORTED_MODULE_25__lib__["y" /* useKeyOnly */])(category, 'category'), Object(__WEBPACK_IMPORTED_MODULE_25__lib__["y" /* useKeyOnly */])(focus, 'focus'), Object(__WEBPACK_IMPORTED_MODULE_25__lib__["y" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_25__lib__["y" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_25__lib__["C" /* useValueAndKey */])(aligned, 'aligned'), 'search', className);
      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_25__lib__["q" /* getUnhandledProps */])(Search, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_25__lib__["p" /* getElementType */])(Search, this.props);

      var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_25__lib__["x" /* partitionHTMLProps */])(unhandled, {
        htmlProps: __WEBPACK_IMPORTED_MODULE_25__lib__["s" /* htmlInputAttrs */]
      }),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return __WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onMouseDown: this.handleMouseDown
      }), this.renderSearchInput(htmlInputProps), this.renderResultsMenu());
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_25__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "defaultProps", {
  icon: 'search',
  input: 'text',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  showNoResults: true
});

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "autoControlledProps", ['open', 'value']);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "Category", __WEBPACK_IMPORTED_MODULE_27__SearchCategory__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "Result", __WEBPACK_IMPORTED_MODULE_28__SearchResult__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "Results", __WEBPACK_IMPORTED_MODULE_29__SearchResults__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_defineProperty___default()(Search, "handledProps", ["aligned", "as", "category", "categoryLayoutRenderer", "categoryRenderer", "className", "defaultOpen", "defaultValue", "fluid", "icon", "input", "loading", "minCharacters", "noResultsDescription", "noResultsMessage", "onBlur", "onFocus", "onMouseDown", "onResultSelect", "onSearchChange", "onSelectionChange", "open", "resultRenderer", "results", "selectFirstResult", "showNoResults", "size", "value"]);


Search.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  // ------------------------------------
  // Behavior
  // ------------------------------------

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value. */
  defaultValue: PropTypes.string,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** Minimum characters to query for results */
  minCharacters: PropTypes.number,

  /** Additional text for "No Results" message with less emphasis. */
  noResultsDescription: PropTypes.node,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /** Controls whether or not the results menu is displayed. */
  open: PropTypes.bool,

  /**
   * One of:
   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
   */
  results: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(SearchResult.propTypes)), PropTypes.shape(SearchCategory.propTypes)]),

  /** Whether the search should automatically select the first result after searching. */
  selectFirstResult: PropTypes.bool,

  /** Whether a "no results" message should be shown if no results are found. */
  showNoResults: PropTypes.bool,

  /** Current value of the search input. Creates a controlled component. */
  value: PropTypes.string,
  // ------------------------------------
  // Rendering
  // ------------------------------------

  /**
   * Renders the SearchCategory layout.
   *
   * @param {object} categoryContent - The Renderable SearchCategory contents.
   * @param {object} resultsContent - The Renderable SearchResult contents.
   * @returns {*} - Renderable SearchCategory layout.
   */
  categoryLayoutRenderer: PropTypes.func,

  /**
   * Renders the SearchCategory contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable SearchCategory contents.
   */
  categoryRenderer: PropTypes.func,

  /**
   * Renders the SearchResult contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable SearchResult contents.
   */
  resultRenderer: PropTypes.func,
  // ------------------------------------
  // Callbacks
  // ------------------------------------

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when a result is selected.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onResultSelect: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of search input.
   */
  onSearchChange: PropTypes.func,

  /**
   * Called when the active selection index is changed.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onSelectionChange: PropTypes.func,
  // ------------------------------------
  // Style
  // ------------------------------------

  /** A search can have its results aligned to its left or right container edge. */
  aligned: PropTypes.string,

  /** A search can display results from remote content ordered by categories. */
  category: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A search can have its results take up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand for input element. */
  input: customPropTypes.itemShorthand,

  /** A search can show a loading indicator. */
  loading: PropTypes.bool,

  /** A search can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(80),
    createWrap = __webpack_require__(180),
    getHolder = __webpack_require__(266),
    replaceHolders = __webpack_require__(182);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

module.exports = partialRight;


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function SearchCategoryLayout(props) {
  var categoryContent = props.categoryContent,
      resultsContent = props.resultsContent;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "name"
  }, categoryContent), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "results"
  }, resultsContent));
}

SearchCategoryLayout.handledProps = ["categoryContent", "resultsContent"];
SearchCategoryLayout.propTypes =  false ? {
  /** The rendered category content */
  categoryContent: PropTypes.element.isRequired,

  /** The rendered results content */
  resultsContent: PropTypes.element.isRequired
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchCategoryLayout);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1173);
/* unused harmony reexport default */



/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_event_listener__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SidebarPushable__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SidebarPusher__ = __webpack_require__(536);


















/**
 * A sidebar hides additional content beside a page.
 */

var Sidebar =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Sidebar, _Component);

  function Sidebar(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Sidebar);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Sidebar).call(this, props));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "ref", Object(__WEBPACK_IMPORTED_MODULE_14_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleAnimationStart", function () {
      var visible = _this.props.visible;
      var callback = visible ? 'onVisible' : 'onHide';
      clearTimeout(_this.animationTimer);
      _this.animationTimer = setTimeout(_this.handleAnimationEnd, Sidebar.animationDuration);

      if (_this.skipNextCallback) {
        _this.skipNextCallback = false;
        return;
      }

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, callback, null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleAnimationEnd", function () {
      var visible = _this.props.visible;
      var callback = visible ? 'onShow' : 'onHidden';

      _this.setState({
        animationTick: 0
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, callback, null, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDocumentClick", function (e) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_15__lib__["m" /* doesNodeContainClick */])(_this.ref.current, e)) {
        _this.skipNextCallback = true;

        __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onHide', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
          visible: false
        }));
      }
    });

    _this.state = {
      animationTick: 0,
      visible: props.visible
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Sidebar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.animationTick > prevState.animationTick) {
        this.handleAnimationStart();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.animationTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animation = _this$props.animation,
          className = _this$props.className,
          children = _this$props.children,
          content = _this$props.content,
          direction = _this$props.direction,
          target = _this$props.target,
          visible = _this$props.visible,
          width = _this$props.width;
      var animationTick = this.state.animationTick;
      var classes = __WEBPACK_IMPORTED_MODULE_12_classnames___default()('ui', animation, direction, width, Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(animationTick > 0, 'animating'), Object(__WEBPACK_IMPORTED_MODULE_15__lib__["y" /* useKeyOnly */])(visible, 'visible'), 'sidebar', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["q" /* getUnhandledProps */])(Sidebar, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_15__lib__["p" /* getElementType */])(Sidebar, this.props);
      var targetRef = Object(__WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__["c" /* isRefObject */])(target) ? target : Object(__WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__["d" /* toRefObject */])(target);
      return __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__stardust_ui_react_component_ref__["a" /* Ref */], {
        innerRef: this.ref
      }, __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: classes
      }), __WEBPACK_IMPORTED_MODULE_15__lib__["c" /* childrenUtils */].isNil(children) ? content : children, visible && __WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_event_listener__["EventListener"], {
        listener: this.handleDocumentClick,
        targetRef: targetRef,
        type: "click"
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // We use `animationTick` to understand when an animation should be scheduled
      var tickIncrement = !!props.visible === !!state.visible ? 0 : 1;
      return {
        animationTick: state.animationTick + tickIncrement,
        visible: props.visible
      };
    }
  }]);

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "defaultProps", {
  direction: 'left',
  target: __WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_event_listener__["documentRef"],
  visible: false
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "animationDuration", 500);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "autoControlledProps", ['visible']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "Pushable", __WEBPACK_IMPORTED_MODULE_16__SidebarPushable__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "Pusher", __WEBPACK_IMPORTED_MODULE_17__SidebarPusher__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sidebar, "handledProps", ["animation", "as", "children", "className", "content", "direction", "onHidden", "onHide", "onShow", "onVisible", "target", "visible", "width"]);

Sidebar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Animation style. */
  animation: PropTypes.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Direction the sidebar should appear on. */
  direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Called before a sidebar begins to animate out.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onHide: PropTypes.func,

  /**
   * Called after a sidebar has finished animating out.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onHidden: PropTypes.func,

  /**
   * Called when a sidebar has finished animating in.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onShow: PropTypes.func,

  /**
   * Called when a sidebar begins animating in.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onVisible: PropTypes.func,

  /** A sidebar can handle clicks on the passed element. */
  target: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Controls whether or not the sidebar is visible on the page. */
  visible: PropTypes.bool,

  /** Sidebar width. */
  width: PropTypes.oneOf(['very thin', 'thin', 'wide', 'very wide'])
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Sidebar);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "documentRef", function() { return documentRef; });
/* unused harmony export windowRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventListener__ = __webpack_require__(1175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventListener", function() { return __WEBPACK_IMPORTED_MODULE_0__EventListener__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useEventListener__ = __webpack_require__(534);
/* unused harmony reexport useEventListener */
var documentRef = {
  current: typeof document === 'undefined' ? null : document
};
var windowRef = {
  current: typeof window === 'undefined' ? null : window
};




/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useEventListener__ = __webpack_require__(534);



function EventListener(props) {
  Object(__WEBPACK_IMPORTED_MODULE_1__useEventListener__["a" /* default */])(props);
  return null;
}

EventListener.displayName = 'EventListener'; // TODO: use Babel plugin for this

EventListener.propTypes =  false ? {
  capture: PropTypes.bool,
  listener: PropTypes.func.isRequired,
  targetRef: PropTypes.shape({
    current: PropTypes.object
  }).isRequired,
  type: PropTypes.string.isRequired
} : {};
EventListener.defaultProps = {
  capture: false
};
/* harmony default export */ __webpack_exports__["a"] = (EventListener);

/***/ }),
/* 1176 */
/***/ (function(module, exports) {



/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sticky__ = __webpack_require__(1178);
/* unused harmony reexport default */



/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);















/**
 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
 */

var Sticky =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Sticky, _Component);

  function Sticky() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Sticky);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Sticky)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      sticky: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickyRef", Object(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "triggerRef", Object(__WEBPACK_IMPORTED_MODULE_13_react__["createRef"])());

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "addListeners", function (props) {
      var scrollContext = props.scrollContext;
      var scrollContextNode = Object(__WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__["c" /* isRefObject */])(scrollContext) ? scrollContext.current : scrollContext;

      if (scrollContextNode) {
        __WEBPACK_IMPORTED_MODULE_14__lib__["n" /* eventStack */].sub('resize', _this.handleUpdate, {
          target: scrollContextNode
        });
        __WEBPACK_IMPORTED_MODULE_14__lib__["n" /* eventStack */].sub('scroll', _this.handleUpdate, {
          target: scrollContextNode
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "removeListeners", function () {
      var scrollContext = _this.props.scrollContext;
      var scrollContextNode = Object(__WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__["c" /* isRefObject */])(scrollContext) ? scrollContext.current : scrollContext;

      if (scrollContextNode) {
        __WEBPACK_IMPORTED_MODULE_14__lib__["n" /* eventStack */].unsub('resize', _this.handleUpdate, {
          target: scrollContextNode
        });
        __WEBPACK_IMPORTED_MODULE_14__lib__["n" /* eventStack */].unsub('scroll', _this.handleUpdate, {
          target: scrollContextNode
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "update", function (e) {
      var pushing = _this.state.pushing;
      _this.ticking = false;

      _this.assignRects();

      if (pushing) {
        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
        return _this.stickToContextBottom(e);
      }

      if (_this.isOversized()) {
        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
      }

      if (_this.didTouchScreenTop()) {
        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
        return _this.stickToScreenTop(e);
      }

      return _this.stickToContextTop(e);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUpdate", function (e) {
      if (!_this.ticking) {
        _this.ticking = true;
        _this.frameId = requestAnimationFrame(function () {
          return _this.update(e);
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "assignRects", function () {
      var context = _this.props.context;
      var contextNode = Object(__WEBPACK_IMPORTED_MODULE_10__stardust_ui_react_component_ref__["c" /* isRefObject */])(context) ? context.current : context || document.body;
      _this.triggerRect = _this.triggerRef.current.getBoundingClientRect();
      _this.contextRect = contextNode.getBoundingClientRect();
      _this.stickyRect = _this.stickyRef.current.getBoundingClientRect();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didReachContextBottom", function () {
      var offset = _this.props.offset;
      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didReachStartingPoint", function () {
      return _this.stickyRect.top <= _this.triggerRect.top;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didTouchScreenTop", function () {
      return _this.triggerRect.top < _this.props.offset;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "didTouchScreenBottom", function () {
      var bottomOffset = _this.props.bottomOffset;
      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "isOversized", function () {
      return _this.stickyRect.height > window.innerHeight;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "pushing", function (pushing) {
      var possible = _this.props.pushing;
      if (possible) _this.setState({
        pushing: pushing
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stick", function (e, bound) {
      _this.setState({
        bound: bound,
        sticky: true
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onStick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "unstick", function (e, bound) {
      _this.setState({
        bound: bound,
        sticky: false
      });

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onUnstick', e, _this.props);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToContextBottom", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onBottom', e, _this.props);

      _this.stick(e, true);

      _this.pushing(true);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToContextTop", function (e) {
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onTop', e, _this.props);

      _this.unstick(e, false);

      _this.pushing(false);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToScreenBottom", function (e) {
      var bottom = _this.props.bottomOffset;

      _this.stick(e, false);

      _this.setState({
        bottom: bottom,
        top: null
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "stickToScreenTop", function (e) {
      var top = _this.props.offset;

      _this.stick(e, false);

      _this.setState({
        top: top,
        bottom: null
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Sticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_14__lib__["t" /* isBrowser */])()) return;
      var active = this.props.active;

      if (active) {
        this.handleUpdate();
        this.addListeners(this.props);
      }
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          current = _this$props.active,
          currentScrollContext = _this$props.scrollContext;
      var next = nextProps.active,
          nextScrollContext = nextProps.scrollContext;

      if (current === next) {
        if (currentScrollContext !== nextScrollContext) {
          this.removeListeners();
          this.addListeners(nextProps);
        }

        return;
      }

      if (next) {
        this.handleUpdate();
        this.addListeners(nextProps);
        return;
      }

      this.removeListeners();
      this.setState({
        sticky: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_14__lib__["t" /* isBrowser */])()) return;
      var active = this.props.active;

      if (active) {
        this.removeListeners();
        cancelAnimationFrame(this.frameId);
      }
    } // ----------------------------------------
    // Events
    // ----------------------------------------

  }, {
    key: "computeStyle",
    value: function computeStyle() {
      var styleElement = this.props.styleElement;
      var _this$state = this.state,
          bottom = _this$state.bottom,
          bound = _this$state.bound,
          sticky = _this$state.sticky,
          top = _this$state.top;
      if (!sticky) return styleElement;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        bottom: bound ? 0 : bottom,
        top: bound ? undefined : top,
        width: this.triggerRect.width
      }, styleElement);
    } // Return true when the component reached the bottom of the context

  }, {
    key: "render",
    // ----------------------------------------
    // Render
    // ----------------------------------------
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className;
      var _this$state2 = this.state,
          bottom = _this$state2.bottom,
          bound = _this$state2.bound,
          sticky = _this$state2.sticky;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(Sticky, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["p" /* getElementType */])(Sticky, this.props);
      var containerClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(sticky && 'ui', sticky && 'stuck-container', sticky && (bound ? 'bound-container' : 'fixed-container'), className);
      var elementClasses = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', sticky && (bound ? 'bound bottom' : 'fixed'), sticky && !bound && (bottom === null ? 'top' : 'bottom'), 'sticky');
      var triggerStyles = sticky && this.stickyRect ? {
        height: this.stickyRect.height
      } : {};
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
        className: containerClasses
      }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div", {
        ref: this.triggerRef,
        style: triggerStyles
      }), __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div", {
        className: elementClasses,
        ref: this.stickyRef,
        style: this.computeStyle()
      }, children));
    }
  }]);

  return Sticky;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sticky, "defaultProps", {
  active: true,
  bottomOffset: 0,
  offset: 0,
  scrollContext: Object(__WEBPACK_IMPORTED_MODULE_14__lib__["t" /* isBrowser */])() ? window : null
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Sticky, "handledProps", ["active", "as", "bottomOffset", "children", "className", "context", "offset", "onBottom", "onStick", "onTop", "onUnstick", "pushing", "scrollContext", "styleElement"]);


Sticky.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A Sticky can be active. */
  active: PropTypes.bool,

  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
  bottomOffset: PropTypes.number,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Context which sticky element should stick to. */
  context: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Offset in pixels from the top of the screen when fixing element to viewport. */
  offset: PropTypes.number,

  /**
   * Callback when element is bound to bottom of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBottom: PropTypes.func,

  /**
   * Callback when element is fixed to page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onStick: PropTypes.func,

  /**
   * Callback when element is bound to top of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onTop: PropTypes.func,

  /**
   * Callback when element is unfixed from page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onUnstick: PropTypes.func,

  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
  pushing: PropTypes.bool,

  /** Context which sticky should attach onscroll events. */
  scrollContext: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Custom style for sticky element. */
  styleElement: PropTypes.object
} : {};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(1180);
/* unused harmony reexport default */



/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Grid_Grid__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__collections_Menu_Menu__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TabPane__ = __webpack_require__(537);



















/**
 * A Tab is a hidden section of content activated by a Menu.
 * @see Menu
 * @see Segment
 */

var Tab =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Tab, _Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleItemClick", function (e, _ref) {
      var index = _ref.index;

      __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(_this.props, 'onTabChange', e, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this.props, {
        activeIndex: index
      }));

      _this.trySetState({
        activeIndex: index
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Tab, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState() {
      return {
        activeIndex: 0
      };
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this$props = this.props,
          panes = _this$props.panes,
          renderActiveOnly = _this$props.renderActiveOnly;
      var activeIndex = this.state.activeIndex;
      if (renderActiveOnly) return __WEBPACK_IMPORTED_MODULE_11_lodash_invoke___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(panes, "[".concat(activeIndex, "]")), 'render', this.props);
      return __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(panes, function (_ref2, index) {
        var pane = _ref2.pane;
        return __WEBPACK_IMPORTED_MODULE_18__TabPane__["a" /* default */].create(pane, {
          overrideProps: {
            active: index === activeIndex
          }
        });
      });
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this$props2 = this.props,
          menu = _this$props2.menu,
          panes = _this$props2.panes,
          menuPosition = _this$props2.menuPosition;
      var activeIndex = this.state.activeIndex;

      if (menu.tabular === true && menuPosition === 'right') {
        menu.tabular = 'right';
      }

      return __WEBPACK_IMPORTED_MODULE_17__collections_Menu_Menu__["a" /* default */].create(menu, {
        autoGenerateKey: false,
        overrideProps: {
          items: __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(panes, 'menuItem'),
          onItemClick: this.handleItemClick,
          activeIndex: activeIndex
        }
      });
    }
  }, {
    key: "renderVertical",
    value: function renderVertical(menu) {
      var _this$props3 = this.props,
          grid = _this$props3.grid,
          menuPosition = _this$props3.menuPosition;

      var paneWidth = grid.paneWidth,
          tabWidth = grid.tabWidth,
          gridProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(grid, ["paneWidth", "tabWidth"]);

      var position = menuPosition || menu.props.tabular === 'right' && 'right' || 'left';
      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__collections_Grid_Grid__["a" /* default */], gridProps, position === 'left' && __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__["a" /* default */].create({
        width: tabWidth,
        children: menu
      }, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__["a" /* default */].create({
        width: paneWidth,
        children: this.renderItems(),
        stretched: true
      }, {
        autoGenerateKey: false
      }), position === 'right' && __WEBPACK_IMPORTED_MODULE_16__collections_Grid_GridColumn__["a" /* default */].create({
        width: tabWidth,
        children: menu
      }, {
        autoGenerateKey: false
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var menu = this.renderMenu();
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getUnhandledProps */])(Tab, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["p" /* getElementType */])(Tab, this.props);

      if (menu.props.vertical) {
        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, rest, this.renderVertical(menu));
      }

      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(ElementType, rest, menu.props.attached !== 'bottom' && menu, this.renderItems(), menu.props.attached === 'bottom' && menu);
    }
  }]);

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* AutoControlledComponent */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "autoControlledProps", ['activeIndex']);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "defaultProps", {
  grid: {
    paneWidth: 12,
    tabWidth: 4
  },
  menu: {
    attached: true,
    tabular: true
  },
  renderActiveOnly: true
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "Pane", __WEBPACK_IMPORTED_MODULE_18__TabPane__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Tab, "handledProps", ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"]);

Tab.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The initial activeIndex. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active tab. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Shorthand props for the Menu.
   * tabular, if true, will derive final value from `menuPosition`, otherwise set 'left' or 'right' explicitly.
   */
  menu: PropTypes.object,

  /** Align vertical menu */
  menuPosition: PropTypes.oneOf(['left', 'right']),

  /** Shorthand props for the Grid. */
  grid: PropTypes.object,

  /**
   * Called on tab change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed new activeIndex.
   * @param {object} data.activeIndex - The new proposed activeIndex.
   */
  onTabChange: PropTypes.func,

  /**
   * Array of objects describing each Menu.Item and Tab.Pane:
   * { menuItem: 'Home', render: () => <Tab.Pane /> }
   * or
   * { menuItem: 'Home', pane: 'Welcome' }
   */
  panes: PropTypes.arrayOf(PropTypes.shape({
    menuItem: customPropTypes.itemShorthand,
    pane: customPropTypes.itemShorthand,
    render: PropTypes.func
  })),

  /** A Tab can render only active pane. */
  renderActiveOnly: PropTypes.bool
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Advertisement__ = __webpack_require__(1182);
/* unused harmony reexport default */



/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);





/**
 * An ad displays third-party promotional content.
 */

function Advertisement(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      test = props.test,
      unit = props.unit;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', unit, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(test, 'test'), 'ad', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Advertisement, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Advertisement, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes,
    "data-text": test
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Advertisement.handledProps = ["as", "centered", "children", "className", "content", "test", "unit"];
Advertisement.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Center the advertisement. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Text to be displayed on the advertisement. */
  test: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),

  /** Varies the size of the advertisement. */
  unit: PropTypes.oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (Advertisement);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment__ = __webpack_require__(1184);
/* unused harmony reexport default */



/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommentAction__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommentActions__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommentContent__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommentGroup__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CommentText__ = __webpack_require__(548);













/**
 * A comment displays user feedback to site content.
 */

function Comment(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content;
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["y" /* useKeyOnly */])(collapsed, 'collapsed'), 'comment', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getUnhandledProps */])(Comment, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["p" /* getElementType */])(Comment, props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["c" /* childrenUtils */].isNil(children) ? content : children);
}

Comment.handledProps = ["as", "children", "className", "collapsed", "content"];
Comment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comment can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
Comment.Author = __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__["a" /* default */];
Comment.Action = __WEBPACK_IMPORTED_MODULE_5__CommentAction__["a" /* default */];
Comment.Actions = __WEBPACK_IMPORTED_MODULE_6__CommentActions__["a" /* default */];
Comment.Avatar = __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__["a" /* default */];
Comment.Content = __WEBPACK_IMPORTED_MODULE_9__CommentContent__["a" /* default */];
Comment.Group = __WEBPACK_IMPORTED_MODULE_10__CommentGroup__["a" /* default */];
Comment.Metadata = __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__["a" /* default */];
Comment.Text = __WEBPACK_IMPORTED_MODULE_12__CommentText__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Comment);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Feed__ = __webpack_require__(1186);
/* unused harmony reexport default */



/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedContent__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FeedDate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FeedEvent__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeedExtra__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeedLabel__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FeedLike__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedMeta__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FeedSummary__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FeedUser__ = __webpack_require__(297);

















/**
 * A feed presents user activity chronologically.
 */

function Feed(props) {
  var children = props.children,
      className = props.className,
      events = props.events,
      size = props.size;
  var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ui', size, 'feed', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["q" /* getUnhandledProps */])(Feed, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["p" /* getElementType */])(Feed, props);

  if (!__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
      className: classes
    }), children);
  }

  var eventElements = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(events, function (eventProps) {
    var childKey = eventProps.childKey,
        date = eventProps.date,
        meta = eventProps.meta,
        summary = eventProps.summary,
        eventData = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(eventProps, ["childKey", "date", "meta", "summary"]);

    var finalKey = childKey || [date, meta, summary].join('-');
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      date: date,
      key: finalKey,
      meta: meta,
      summary: summary
    }, eventData));
  });

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, rest, {
    className: classes
  }), eventElements);
}

Feed.handledProps = ["as", "children", "className", "events", "size"];
Feed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand array of props for FeedEvent. */
  events: customPropTypes.collectionShorthand,

  /** A feed can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
} : {};
Feed.Content = __WEBPACK_IMPORTED_MODULE_8__FeedContent__["a" /* default */];
Feed.Date = __WEBPACK_IMPORTED_MODULE_9__FeedDate__["a" /* default */];
Feed.Event = __WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */];
Feed.Extra = __WEBPACK_IMPORTED_MODULE_11__FeedExtra__["a" /* default */];
Feed.Label = __WEBPACK_IMPORTED_MODULE_12__FeedLabel__["a" /* default */];
Feed.Like = __WEBPACK_IMPORTED_MODULE_13__FeedLike__["a" /* default */];
Feed.Meta = __WEBPACK_IMPORTED_MODULE_14__FeedMeta__["a" /* default */];
Feed.Summary = __WEBPACK_IMPORTED_MODULE_15__FeedSummary__["a" /* default */];
Feed.User = __WEBPACK_IMPORTED_MODULE_16__FeedUser__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Feed);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(550);
/* unused harmony reexport default */



/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Statistic__ = __webpack_require__(554);
/* unused harmony reexport default */



/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports = [{"index":0,"token":false,"name":"Sphinx of the Final Word","scryfallId":"f6555d1f-d4cf-41f7-99d3-88fd53e75457"},{"index":1,"token":false,"name":"Goblin King","scryfallId":"e3094187-d666-414b-a1fd-ae0ef55c3fcb"},{"index":2,"token":false,"name":"Caravan Vigil","scryfallId":"9a8dfb98-a975-41bf-8aac-c0001c9ddaa7"},{"index":3,"token":false,"name":"Deadshot Minotaur","scryfallId":"aacb131b-74c9-4e6c-9466-27710bc9441f"},{"index":4,"token":false,"name":"Rule of Law","scryfallId":"a1f4e79b-b103-4380-afa0-61a2b1773c9e"},{"index":5,"token":false,"name":"Merfolk Looter","scryfallId":"6b667700-9ea2-42cb-8d79-423272dd46b9"},{"index":6,"token":false,"name":"War Priest of Thune","scryfallId":"d28eb320-aea7-466e-8718-de8652a2b191"},{"index":7,"token":false,"name":"Scarab Feast","scryfallId":"7540895c-cbbc-46ac-ba96-882628358865"},{"index":8,"token":false,"name":"Narwhal","scryfallId":"64505a8b-4f7f-484c-ac6d-d64070c6d6e1"},{"index":9,"token":false,"name":"Wing Snare","scryfallId":"a58e1c71-b0e1-4c03-97cc-330e3ef94e52"},{"index":10,"token":false,"name":"Fury Charm","scryfallId":"ff2a382b-f63a-4520-ab6e-a5428a5e61db"},{"index":11,"token":false,"name":"Chandra, Fire of Kaladesh // Chandra, Roaring Flame","scryfallId":"7e0cfe44-9b57-4b9a-b23f-18d3237bd7ee"},{"index":12,"token":false,"name":"Saskia the Unyielding","scryfallId":"5733ce94-08d5-4288-8241-0ba5c0f99b27"},{"index":13,"token":false,"name":"Shinen of Fury's Fire","scryfallId":"6a3d65f0-a3ec-4fe0-9a9d-59cebc384e90"},{"index":14,"token":false,"name":"Cackling Imp","scryfallId":"ecae92e2-e2d0-4f32-b90b-3762e7c0e11d"},{"index":15,"token":false,"name":"Entangler","scryfallId":"ecc20785-4512-4ef6-8f62-928482cb585f"},{"index":16,"token":false,"name":"Dead Reveler","scryfallId":"61de28ab-f579-4419-bee0-4e150a836116"},{"index":17,"token":false,"name":"Bishop of Wings","scryfallId":"7847ae5d-c1d5-4641-93e3-4de44d2cde21"},{"index":18,"token":false,"name":"Infinite Reflection","scryfallId":"42506c54-e9bf-4d0f-8dd5-8b218668c925"},{"index":19,"token":false,"name":"Island","scryfallId":"8c8f9a84-2126-4564-9ec9-554cc88e1c63"},{"index":20,"token":false,"name":"Mire Kavu","scryfallId":"ccdd0086-eb27-48b3-91cb-a113aa1de102"},{"index":21,"token":false,"name":"Speaker of the Heavens","scryfallId":"9c7f5595-c30c-4666-ad80-d9393c5b3702"},{"index":22,"token":false,"name":"Plains","scryfallId":"dfa01578-faf9-4694-86a0-c81f5b2a0dd8"},{"index":23,"token":false,"name":"Shared Trauma","scryfallId":"8441e4e9-9be4-4f08-8a83-823cef64170a"},{"index":24,"token":false,"name":"Llanowar Reborn","scryfallId":"2b564606-8827-44c9-98ba-3ed0cccaac07"},{"index":25,"token":true,"name":"Saproling Token (G, 1/1)","scryfallId":"925715e5-bb94-406b-82b1-93b4d51f0cc2"},{"index":26,"token":false,"name":"Debtors' Knell","scryfallId":"abfd4afb-d5d0-42d2-8500-4c02d6639cbf"},{"index":27,"token":false,"name":"Seal of Fire","scryfallId":"210f4f5a-4a36-4f2f-8821-d04f3f52c8db"},{"index":28,"token":false,"name":"Basri's Acolyte","scryfallId":"08d1dd97-2675-4953-ab95-d47d23abfe05"},{"index":29,"token":false,"name":"Skyknight Legionnaire","scryfallId":"e1e4a4bf-6fd4-46b9-8f1d-c20c52e992f6"},{"index":30,"token":false,"name":"Treetop Village","scryfallId":"02212bd8-0c0f-4e8e-99f1-a8477476c03a"},{"index":31,"token":false,"name":"Shard Phoenix","scryfallId":"611445e9-5dfc-4fc8-b936-02f81de65012"},{"index":32,"token":false,"name":"Cyclonic Rift","scryfallId":"f9baef6e-a086-41d4-a20e-486f01d72406"},{"index":33,"token":false,"name":"Omen of the Sun","scryfallId":"86586fe3-1a6e-4648-b3ff-b0d9340e66ff"},{"index":34,"token":false,"name":"Arguel's Blood Fast // Temple of Aclazotz","scryfallId":"d78cd000-3908-446d-b155-dd8af3d8f166"},{"index":35,"token":false,"name":"Grapeshot","scryfallId":"4ee33cb6-768e-44a0-b6f4-b8638aa84330"},{"index":36,"token":false,"name":"Sublime Epiphany","scryfallId":"373d12e3-b403-452e-8bab-3e2318b890dd"},{"index":37,"token":false,"name":"Volcanic Hammer","scryfallId":"58c0489d-b073-4ad4-b044-447fcc865b6c"},{"index":38,"token":false,"name":"Mind Stone","scryfallId":"eed69870-1a65-4bec-842c-e837348493c6"},{"index":39,"token":false,"name":"Paralyze","scryfallId":"9a5bac82-8de1-41ce-afd0-a0d832666abb"},{"index":40,"token":false,"name":"Obelisk of Alara","scryfallId":"45ce958e-f763-4af6-9067-0fba3716ae7c"},{"index":41,"token":false,"name":"Nightpack Ambusher","scryfallId":"74824a9a-f490-4b4c-9a36-6a1745d49e90"},{"index":42,"token":false,"name":"Ninth Bridge Patrol","scryfallId":"4a9555fe-fa1d-4af9-90a4-c3f91e0edd9b"},{"index":43,"token":false,"name":"Feral Throwback","scryfallId":"5111a9a3-a92d-4677-8974-20800256dd4f"},{"index":44,"token":false,"name":"Restoration Angel","scryfallId":"fc1266de-3a58-4579-9781-78aaf852bbac"},{"index":45,"token":false,"name":"Cavern of Souls","scryfallId":"1381c8f1-a292-4bdf-b20c-a5c2a169ee84"},{"index":46,"token":false,"name":"Puppet Conjurer","scryfallId":"cc6ee904-95ca-4ec3-ad7d-ee084aa0c00f"},{"index":47,"token":false,"name":"Guardian Automaton","scryfallId":"7e8916b7-f5e4-4fae-8db8-9859d69212ec"},{"index":48,"token":false,"name":"Hull Breach","scryfallId":"772c0618-b805-4a5a-b5bc-7086b3b7f9df"},{"index":49,"token":false,"name":"Venomous Breath","scryfallId":"8eeb9e02-1d26-4959-a878-2ef8db2358bc"},{"index":50,"token":false,"name":"Nissa's Renewal","scryfallId":"86858f6f-a2d0-49cd-8c58-4ccf8db23ee3"},{"index":51,"token":false,"name":"Frenzied Raider","scryfallId":"22c59e0b-5b78-4cf5-9c2a-92ccf833778f"},{"index":52,"token":false,"name":"Tevesh Szat, Doom of Fools","scryfallId":"2f68b4de-271b-415f-ad8f-104981bb12ab"},{"index":53,"token":false,"name":"Gideon, Martial Paragon","scryfallId":"2c057ca8-9811-4dc3-9b0e-f9f69f752d1d"},{"index":54,"token":false,"name":"Daring Leap","scryfallId":"37ec6c4b-2de0-4759-a25d-007706cb18cc"},{"index":55,"token":false,"name":"Glint-Sleeve Siphoner","scryfallId":"e115dc72-4a82-4395-ae5a-d00cbe94c96c"},{"index":56,"token":false,"name":"Shambling Attendants","scryfallId":"459ca25c-775f-4110-8d70-59720692ab27"},{"index":57,"token":false,"name":"Rotlung Reanimator","scryfallId":"87b29d1e-9c06-4ad1-8178-b3eaa212f6f1"},{"index":58,"token":false,"name":"False Summoning","scryfallId":"cd7d30a8-bc7a-42bc-8d1b-600cbf78ab98"},{"index":59,"token":false,"name":"Swamp","scryfallId":"e6d31a95-f392-466a-a47c-bef9890317ab"},{"index":60,"token":false,"name":"Festering Goblin","scryfallId":"fce1a3a3-f0b8-4088-85f6-8cbdd1f29e65"},{"index":61,"token":false,"name":"Peppersmoke","scryfallId":"57f45251-e71e-4601-9b51-dbc08ab036c2"},{"index":62,"token":false,"name":"Bitterbow Sharpshooters","scryfallId":"8ecfcf99-be2b-4e5f-adef-1977ee5c6a0f"},{"index":63,"token":false,"name":"Cuombajj Witches","scryfallId":"6a26e910-275a-4981-831b-bfed936a7e3f"},{"index":64,"token":false,"name":"Ward of Piety","scryfallId":"73acef0c-34b1-4e04-8569-4f8d754585df"},{"index":65,"token":false,"name":"Dakmor Salvage","scryfallId":"3ecad18a-32cc-4916-8dc0-539f6759095c"},{"index":66,"token":false,"name":"Gravewaker","scryfallId":"4f624f77-032f-4b28-bec2-95d3a3fcb806"},{"index":67,"token":false,"name":"Plague Spores","scryfallId":"0d106d56-a688-49cc-8d5d-0279a5a7c0a7"},{"index":68,"token":false,"name":"Embersmith","scryfallId":"ee86cfc8-9faa-474c-90a9-5405f3f6037c"},{"index":69,"token":false,"name":"Aetherwind Basker","scryfallId":"fa04d5fa-6ba2-4833-8ea0-1941a03bd3e9"},{"index":70,"token":true,"name":"Faerie Spy Token (U, 1/1)","scryfallId":"1008e47a-a8c4-4f4f-8628-ac4b8f978dd0"},{"index":71,"token":false,"name":"Avenger of Zendikar","scryfallId":"03dea775-bbb3-4e9c-8514-0605b5ad2e8b"},{"index":72,"token":false,"name":"Compelling Argument","scryfallId":"7c35f4d5-2337-4ea0-a571-5a73e2d0d54a"},{"index":73,"token":false,"name":"Flaming Sword","scryfallId":"17ecd9ff-8c30-4e17-8cff-dd40d653c4af"},{"index":74,"token":false,"name":"Silhana Wayfinder","scryfallId":"02cc1d52-04bd-4546-a20f-d2993654c830"},{"index":75,"token":false,"name":"Patriarch's Bidding","scryfallId":"2deba175-8c02-492d-b404-5d842910c095"},{"index":76,"token":false,"name":"Sensei's Divining Top","scryfallId":"4a08ca06-58db-4ce6-b490-be4bea8956a1"},{"index":77,"token":false,"name":"Hope Tender","scryfallId":"8cb1391b-cfbe-4698-9891-9e1342d1916c"},{"index":78,"token":false,"name":"Entangling Vines","scryfallId":"f717a468-696c-4a84-b943-75046138f2bf"},{"index":79,"token":true,"name":"Treasure","scryfallId":"42e54aad-ec80-4914-9ba8-91bd53924778"},{"index":80,"token":false,"name":"Firebreathing","scryfallId":"285d54f3-d21f-4854-a4ab-5912771330a5"},{"index":81,"token":false,"name":"Ironclad Slayer","scryfallId":"2841f538-9686-423f-ac30-0580665112e5"},{"index":83,"token":false,"name":"Mind Grind","scryfallId":"671eb9e8-1a69-4570-8972-2e7de371cef4"},{"index":84,"token":false,"name":"Swiftwater Cliffs","scryfallId":"e782d005-a563-4738-978a-73a3465de78f"},{"index":85,"token":false,"name":"Elvish Archers","scryfallId":"bd92d92c-a9c7-40c5-82f3-dbd19697f999"},{"index":86,"token":false,"name":"Metallic Mimic","scryfallId":"1aa4eba9-9e91-4beb-9296-a18baa73a318"},{"index":87,"token":false,"name":"Grim Flayer","scryfallId":"025af99f-a029-4f99-9c76-676b68821520"},{"index":88,"token":false,"name":"Child of Night","scryfallId":"5d6124cc-1106-4cf6-8499-26fff83a9611"},{"index":89,"token":false,"name":"Inexorable Blob","scryfallId":"0210ff44-19d9-4d24-9d32-f1f9f219d9e0"},{"index":90,"token":false,"name":"Volcanic Offering","scryfallId":"4c30b821-09ec-4b66-9963-f97e3ef5005c"},{"index":91,"token":false,"name":"Prakhata Pillar-Bug","scryfallId":"9c91b356-b5d8-4239-bb45-dec7f673868d"},{"index":92,"token":false,"name":"Shapeshifter's Marrow","scryfallId":"48cb3fa8-555f-4df6-994e-cf01896f7470"},{"index":93,"token":false,"name":"Benthic Biomancer","scryfallId":"7b0cb4d6-350b-4e66-b035-dac7b3ba77cc"},{"index":94,"token":false,"name":"Leering Emblem","scryfallId":"d81bcabd-7bbe-463c-a35a-992c12c4e4bf"},{"index":95,"token":false,"name":"Skirk Marauder","scryfallId":"b0a0cc70-ac86-4e52-a785-6209cbec29dc"},{"index":96,"token":false,"name":"Shifting Ceratops","scryfallId":"adb259b2-c514-4e14-9482-fa471d9690e5"},{"index":97,"token":false,"name":"Raff Capashen, Ship's Mage","scryfallId":"aec102b2-6783-417e-a425-951bb78c8334"},{"index":98,"token":false,"name":"Serendib Efreet","scryfallId":"86820bf9-1d6c-47c6-9d9c-ae020f3dd3b0"},{"index":99,"token":false,"name":"Lazav, Dimir Mastermind","scryfallId":"003dc436-a3af-4e65-b4f8-387155fbcb85"},{"index":100,"token":false,"name":"Phyrexian Ghoul","scryfallId":"c6e3c258-5d30-490f-9127-83d93d276345"},{"index":101,"token":false,"name":"Ghitu Encampment","scryfallId":"d7cde268-4f49-4c9c-8ba4-59fc9410190f"},{"index":102,"token":false,"name":"Branchloft Pathway // Boulderloft Pathway","scryfallId":"5dfa0e82-da04-418b-9c60-038f3c2c31a5"},{"index":103,"token":true,"name":"Timeless Witness Token (B, 4/4)","scryfallId":"0e466a1b-a120-420a-884f-99c6629dcbc7"},{"index":104,"token":false,"name":"Acidic Slime","scryfallId":"bd7bef5a-e0ab-46d3-a802-620bf2a7546f"},{"index":105,"token":false,"name":"Sapphire Charm","scryfallId":"2944e5df-eef9-42be-a591-5ac15e306ad8"},{"index":106,"token":false,"name":"Underground Sea","scryfallId":"7f121e0c-6480-4e48-9e2c-03ce287c5112"},{"index":107,"token":false,"name":"Song-Mad Treachery // Song-Mad Ruins","scryfallId":"782ca27f-9f18-476c-b582-89c06fb2e322"},{"index":108,"token":false,"name":"Territorial Hellkite","scryfallId":"fa2c1779-145f-4315-91ec-726ed43daa07"},{"index":109,"token":false,"name":"Mulch","scryfallId":"7d3f43b4-ad21-4915-b6be-bcea714e8c31"},{"index":110,"token":false,"name":"Simian Spirit Guide","scryfallId":"5d7f701c-dcdc-4067-8d00-b4b7aadee9ba"},{"index":111,"token":false,"name":"Drowned Catacomb","scryfallId":"2d3a1881-aa9c-4b0e-8350-e033b0367035"},{"index":112,"token":false,"name":"Ifh-Bíff Efreet","scryfallId":"c0b10fb7-8667-42bf-aeb6-35767a82917b"},{"index":113,"token":true,"name":"1999 World Championships Ad","scryfallId":"8635dea0-985a-4c02-a02b-8b08d96fb2dd"},{"index":114,"token":false,"name":"Twiddle","scryfallId":"1994e753-799c-42c0-b331-39a78cfb8ee9"},{"index":115,"token":false,"name":"Eternal Witness","scryfallId":"0a520b45-77fa-4b9f-b395-06c58939578d"},{"index":116,"token":false,"name":"Power of Fire","scryfallId":"6c02d053-0885-4720-bf74-b65b3f87cfd9"},{"index":117,"token":false,"name":"Wickerbough Elder","scryfallId":"a5f5c90d-9c31-4d9f-bec0-023334ae0bac"},{"index":118,"token":false,"name":"Swords to Plowshares","scryfallId":"8bd501ae-5814-4336-a45b-2b88cb85d29e"},{"index":119,"token":false,"name":"Golgari Brownscale","scryfallId":"690cfc79-da41-4ac0-b0cc-719aa650b207"},{"index":120,"token":false,"name":"Graveyard Marshal","scryfallId":"4dc5f62c-2d29-4a94-8501-13dc6a93c5a1"},{"index":121,"token":false,"name":"Proteus Machine","scryfallId":"d1c8cff1-b289-41a4-9fa3-cc5e7ba70802"},{"index":122,"token":false,"name":"Vorosh, the Hunter","scryfallId":"da4438fe-b11b-4adb-b8dd-b44e12ef6124"},{"index":123,"token":false,"name":"Massacre Girl","scryfallId":"be8ec9e1-2c8e-496d-9111-4d453b75b578"},{"index":124,"token":false,"name":"Eliminate the Competition","scryfallId":"68a13bf0-ab63-420d-a553-988d7019c857"},{"index":125,"token":false,"name":"Ainok Survivalist","scryfallId":"db1a9d18-93ae-4ff9-99dd-569cf2e9f62a"},{"index":126,"token":false,"name":"Bonesplitter","scryfallId":"bda22fad-8149-42fb-b915-2c2580efb353"},{"index":127,"token":false,"name":"Circle of Protection: Red","scryfallId":"5790ce22-a94f-402e-bcc7-b98f71af9fe5"},{"index":128,"token":false,"name":"Feast of Succession","scryfallId":"ac83f97d-c8c9-480c-a32c-918035673ab4"},{"index":129,"token":false,"name":"Contagion Engine","scryfallId":"2f843059-b21f-4c78-8f18-b8450d69aaca"},{"index":130,"token":false,"name":"Yavimaya's Embrace","scryfallId":"1ac29eb6-2770-4723-942b-b393c2abc02b"},{"index":131,"token":false,"name":"Stone-Tongue Basilisk","scryfallId":"8ec4eeb5-2f82-460c-8140-20587442d40b"},{"index":132,"token":false,"name":"Cavalier of Gales","scryfallId":"6eb04dd5-1846-4e30-b349-2b0cc06e0257"},{"index":133,"token":false,"name":"Serpentine Spike","scryfallId":"030f71b7-f236-4ec8-92a8-5ad4b1bc5268"},{"index":134,"token":false,"name":"Liliana, Waker of the Dead","scryfallId":"97822ea2-162f-4e7d-9042-5ac4c258275b"},{"index":135,"token":false,"name":"Deathcap Cultivator","scryfallId":"fc4aee46-ac42-4ede-ad06-906e2955a9d3"},{"index":137,"token":false,"name":"Sakashima of a Thousand Faces","scryfallId":"714c3a1f-7b30-4ed8-8f38-6176758741fb"},{"index":138,"token":false,"name":"Aven Mindcensor","scryfallId":"508c8a22-a11a-42e3-9968-b0ced52ed3f5"},{"index":139,"token":false,"name":"Caltrops","scryfallId":"8769b55a-a0a1-4b6f-8c80-669385a34425"},{"index":140,"token":false,"name":"Avatar of Fury","scryfallId":"f9badf70-5e86-4d43-b457-5cbf821d97df"},{"index":141,"token":false,"name":"Laquatus's Disdain","scryfallId":"e2ea5448-2d72-42eb-814c-197153d8e06a"},{"index":142,"token":true,"name":"Germ Token (B, 0/0)","scryfallId":"d197efaf-4c60-460a-81d2-651e2914b82b"},{"index":143,"token":false,"name":"Iron Star","scryfallId":"43e1a0e8-3ca4-4928-9299-36efce7fb641"},{"index":144,"token":false,"name":"Repel the Abominable","scryfallId":"cf153f4d-0d37-41a9-80d8-7f2adaad79c7"},{"index":145,"token":false,"name":"Guardian of Vitu-Ghazi","scryfallId":"1c293144-df82-481d-8d24-2bdc164a355f"},{"index":146,"token":false,"name":"Phyrexian Arena","scryfallId":"81c3099f-cea5-41d8-a753-096f0021b11b"},{"index":147,"token":false,"name":"Skitter Eel","scryfallId":"db328f03-7dae-445b-8e71-99dd88f26a9e"},{"index":148,"token":false,"name":"Scroll Rack","scryfallId":"8b73f2db-0604-4d23-a9fb-cd6855eda57d"},{"index":149,"token":false,"name":"Combust","scryfallId":"f10346e2-46bd-4257-b191-c36c2577c534"},{"index":150,"token":false,"name":"Flametongue Kavu","scryfallId":"b6dab138-b96c-4610-9d28-1117fcdb9ef2"},{"index":151,"token":false,"name":"Slinn Voda, the Rising Deep","scryfallId":"cebf2c16-bd9d-4a8f-a1b6-6e0c393178bc"},{"index":152,"token":false,"name":"Living Artifact","scryfallId":"d7ca8c1d-866f-4ffb-adcb-924aba8f59a9"},{"index":153,"token":false,"name":"Snapcaster Mage","scryfallId":"9e5b279e-4670-4a1e-87d0-3cab7e4f9e58"},{"index":154,"token":false,"name":"Through the Breach","scryfallId":"611e7909-6b74-4b8b-beb3-ec9e94804d5f"},{"index":155,"token":false,"name":"Oracle of Bones","scryfallId":"ddb1931e-c282-47a7-9382-608de6ec8efa"},{"index":156,"token":false,"name":"Generous Stray","scryfallId":"3289db66-231f-4370-aca6-644d75bee293"},{"index":157,"token":false,"name":"Razorfield Thresher","scryfallId":"b0a74203-d342-489d-a584-bca78ef3331d"},{"index":158,"token":true,"name":"Double-Faced Substitute Card","scryfallId":"b1d747d2-5780-484d-ab25-bf2eb9ddc36a"},{"index":159,"token":false,"name":"Blinding Mage","scryfallId":"173675c1-685c-4f4c-a6dc-b42a3ae69137"},{"index":160,"token":false,"name":"Auratouched Mage","scryfallId":"2f1998b8-cb51-4917-94af-9be12b47306d"},{"index":161,"token":false,"name":"Wall of Roots","scryfallId":"000619be-f2b4-407d-a76c-7245d8cab7bd"},{"index":162,"token":false,"name":"Terramorphic Expanse","scryfallId":"f12aa1be-75b9-4144-a6a1-178aa3a10847"},{"index":163,"token":false,"name":"Lawmage's Binding","scryfallId":"c64771e8-94bb-452b-b028-619ed3b4327c"},{"index":164,"token":false,"name":"Vow of Lightning","scryfallId":"71218cff-7e57-40dd-83c2-d06b284a63fd"},{"index":165,"token":false,"name":"Royal Assassin","scryfallId":"df6df8b8-06f5-45e5-820e-3d76aebe250c"},{"index":166,"token":false,"name":"Ambush Commander","scryfallId":"5ecbf790-619b-4b55-ae4c-29f1459b0031"},{"index":167,"token":false,"name":"Golgari Rot Farm","scryfallId":"3c57438b-59d4-4040-b2bf-1eea33318761"},{"index":168,"token":false,"name":"Squelching Leeches","scryfallId":"694a0e92-8e5c-404e-a8bb-52139884e41a"},{"index":169,"token":false,"name":"Boros Garrison","scryfallId":"8e6a7b29-d028-41d0-badc-49b514972cfe"},{"index":170,"token":false,"name":"Fabricate","scryfallId":"44e49332-b1e1-4b88-b508-516b55c67a1d"},{"index":171,"token":true,"name":"Bird Token (W, 1/1)","scryfallId":"abbb3c16-a7ef-4b83-b1a9-637a905229d7"},{"index":172,"token":false,"name":"Tawnos's Wand","scryfallId":"d5f80962-6a4e-4cd4-a9fc-3b0e9d4ce0f0"},{"index":173,"token":false,"name":"Wind Shear","scryfallId":"b8324f44-c7f5-41ee-bc8d-16822bd8942f"},{"index":174,"token":false,"name":"Dread Return","scryfallId":"33a27556-5fb2-42de-ae41-31c6afd583d8"},{"index":175,"token":false,"name":"Horizon Scholar","scryfallId":"abbbb721-0c80-4cc2-b036-e629c0c95956"},{"index":176,"token":false,"name":"Distorting Lens","scryfallId":"ab196d8d-5d1c-4f0e-a924-37774db02821"},{"index":177,"token":false,"name":"Seeker of Skybreak","scryfallId":"5e73a140-0960-4a7a-8919-814c52c6fd71"},{"index":178,"token":false,"name":"Vela the Night-Clad","scryfallId":"610737cd-d1ef-49c0-8010-988320ed64d5"},{"index":179,"token":false,"name":"Mountain","scryfallId":"5deefab6-4734-464a-b930-64447a8490ca"},{"index":181,"token":false,"name":"Nahiri, Storm of Stone","scryfallId":"3f17544a-7bcd-4315-8e14-bea8317ee13a"},{"index":182,"token":false,"name":"Circle of Protection: Black","scryfallId":"4c0b0e01-1190-451c-b83c-14fcc5754f7b"},{"index":183,"token":false,"name":"Deepwood Legate","scryfallId":"54f01925-7fd0-472d-91a4-3309e615f22f"},{"index":184,"token":false,"name":"Noble Banneret","scryfallId":"0a7f0d35-b91e-461a-822c-7ae2798ca51a"},{"index":185,"token":false,"name":"Reincarnation","scryfallId":"7ee379cd-b3fb-487b-846c-eab02902de79"},{"index":186,"token":false,"name":"Tonic Peddler","scryfallId":"334bbd9d-3549-4352-9635-d772aab28503"},{"index":187,"token":false,"name":"Zulaport Cutthroat","scryfallId":"27db5cf4-e023-4bd8-9f51-4dc42957007e"},{"index":188,"token":false,"name":"Jaya's Immolating Inferno","scryfallId":"48268bb8-1326-451b-9fae-de6605eb6cfd"},{"index":189,"token":false,"name":"Eater of Hope","scryfallId":"e869a6c0-7dd9-4669-ac96-35ee08fa2f1a"},{"index":190,"token":false,"name":"Struggle for Sanity","scryfallId":"ba827c43-5dd5-471f-83b2-cb5428fcd063"},{"index":191,"token":false,"name":"Infiltrator il-Kor","scryfallId":"c3ab190b-c96f-4b00-8e97-33a11bb2ed08"},{"index":193,"token":false,"name":"Hunting Grounds","scryfallId":"5b14a736-5223-457b-9d4e-f4a2d6ed9a8d"},{"index":194,"token":false,"name":"Two-Headed Giant of Foriys","scryfallId":"c69db4eb-71a2-4e57-8f34-1f0749e11336"},{"index":195,"token":false,"name":"Sign in Blood","scryfallId":"e5ae9dea-98b4-4088-864c-8ca4b1da86e6"},{"index":196,"token":false,"name":"Huatli, the Sun's Heart","scryfallId":"d709742c-82a2-457e-9991-85e98d78029d"},{"index":197,"token":false,"name":"Forest","scryfallId":"657c597e-2a5a-4b6f-9a4e-e6df84e28ad9"},{"index":198,"token":false,"name":"Sapphire Medallion","scryfallId":"afdbb860-2bea-4cf6-8959-6a19ba1de56c"},{"index":199,"token":false,"name":"Rampaging Baloths","scryfallId":"1c6835b0-2367-4130-bf38-bee89a05f9cd"},{"index":200,"token":false,"name":"Kasmina, Enigmatic Mentor","scryfallId":"199b36b4-13fd-4233-98cb-f8d148e7fd2b"},{"index":201,"token":false,"name":"Surging Flame","scryfallId":"156994b5-a0f2-4d02-9bda-882e80d9905c"},{"index":202,"token":false,"name":"Glittering Wish","scryfallId":"0c89645b-5e53-48c0-b4bb-9f22332c7658"},{"index":203,"token":false,"name":"Recruiter of the Guard","scryfallId":"3cb635bb-def8-43f9-aad1-dd298dcc730b"},{"index":204,"token":false,"name":"Greed","scryfallId":"977d0b73-ebc1-4082-a90c-eda363732bbe"},{"index":205,"token":false,"name":"Andradite Leech","scryfallId":"6da0d4f3-9216-406c-8f3e-b9bb0a11dc75"},{"index":206,"token":false,"name":"Sword of Fire and Ice","scryfallId":"cf767c80-ba6e-4206-89a2-727307145ed5"},{"index":207,"token":false,"name":"Lava Serpent","scryfallId":"00ebd57f-7f7c-41b0-aa56-511c1816bc14"},{"index":208,"token":false,"name":"Chorus of Might","scryfallId":"214dc9c1-154d-4c35-845d-dd2928f1e142"},{"index":209,"token":false,"name":"Wear // Tear","scryfallId":"d169a3b2-18ae-4414-98ef-d879676fdcc0"},{"index":210,"token":false,"name":"Spectral Bears","scryfallId":"d4c234ed-0e5d-4074-ad95-bba1744aca9a"},{"index":211,"token":false,"name":"Arcane Flight","scryfallId":"09fbb1c0-ba57-4a5a-8ad6-77fbc6aeeec9"},{"index":212,"token":false,"name":"Shattering Pulse","scryfallId":"89d3b846-6071-4d65-86ba-da08c4bd0aa1"},{"index":213,"token":false,"name":"Gargoyle Sentinel","scryfallId":"6af328bc-bce5-4024-9da5-853ee16eaa8a"},{"index":215,"token":false,"name":"Paragon of Gathering Mists","scryfallId":"5afc32ed-c1a9-4c37-bfe0-562818c046fc"},{"index":216,"token":false,"name":"Steam Blast","scryfallId":"c5ee0888-7c60-44a7-a279-12f08a867d36"},{"index":217,"token":false,"name":"Aid the Fallen","scryfallId":"230ded05-b1e1-44bc-a859-081690596194"},{"index":219,"token":false,"name":"Foot Soldiers","scryfallId":"baff03f3-a8ca-4c35-ae71-43b5d237b519"},{"index":220,"token":false,"name":"Azorius Signet","scryfallId":"c7acfe5b-05ac-4030-b1da-789224fbddcf"},{"index":221,"token":false,"name":"Treefolk Seedlings","scryfallId":"4c275bdc-e960-4b6f-a8d3-b662739113c1"},{"index":222,"token":false,"name":"Dwarven Demolition Team","scryfallId":"8969c53d-091b-43ef-9c54-19d5b17715cb"},{"index":223,"token":false,"name":"Unknown Shores","scryfallId":"492181e4-5825-45d4-b8a1-37f29c32a845"},{"index":224,"token":false,"name":"Desert of the Fervent","scryfallId":"6795edf2-3134-45d1-87bf-d96213c37c89"},{"index":225,"token":false,"name":"Crossway Vampire","scryfallId":"3e7a137f-e19e-43a6-aab8-02b175c9d626"},{"index":226,"token":false,"name":"Kjeldoran Pride","scryfallId":"a88d1c1a-b53e-459b-8a83-4d559177188a"},{"index":227,"token":false,"name":"Geist-Honored Monk","scryfallId":"5d51355e-55fa-43bb-a5de-fc55ac7b6446"},{"index":228,"token":false,"name":"Burning Vengeance","scryfallId":"fd403810-840b-46ac-ae6e-5df23ce16fec"},{"index":229,"token":false,"name":"Coastal Hornclaw","scryfallId":"a5b91ddc-8630-4214-8dce-215f28ccc685"},{"index":230,"token":false,"name":"Sylvan Bounty","scryfallId":"2fed99a1-4cd6-40fc-8796-a92edc79bc76"},{"index":232,"token":false,"name":"Isochron Scepter","scryfallId":"362cdf24-442f-4f28-99ad-24343acecabe"},{"index":233,"token":false,"name":"Amrou Seekers","scryfallId":"2e0191a7-9928-4b6e-ae4f-0db2d41ca71a"},{"index":234,"token":false,"name":"Enforcer Griffin","scryfallId":"e4d6d488-01df-4d61-92ff-9881838b4018"},{"index":235,"token":false,"name":"Enlightened Tutor","scryfallId":"cbac1d27-15e2-4e2f-82ab-625a16e096cb"},{"index":236,"token":false,"name":"Dreamstone Hedron","scryfallId":"58382d72-9b2b-44cf-8a02-b745deafc286"},{"index":237,"token":false,"name":"Dark Hatchling","scryfallId":"d71ead99-f5dc-4a81-b792-a2fef70d60f5"},{"index":238,"token":false,"name":"Advent of the Wurm","scryfallId":"f40284e6-01a1-4372-a92c-940e5732607e"},{"index":239,"token":false,"name":"Chaotic Goo","scryfallId":"0e9881a4-3078-4fe0-be09-54ddad1d18a0"},{"index":240,"token":false,"name":"Volunteer Reserves","scryfallId":"5344911f-25e8-45ce-87b9-607e42db0139"},{"index":241,"token":false,"name":"Titan's Revenge","scryfallId":"b1b0f9ca-b752-4dd6-982b-06bb3a27ddbc"},{"index":242,"token":false,"name":"Mirari's Wake","scryfallId":"f0ecbb34-8029-431b-80bc-e623ee51d966"},{"index":243,"token":false,"name":"Lightning Greaves","scryfallId":"70eab734-875b-4b76-901b-3ac7d2133ad9"},{"index":244,"token":false,"name":"Frost Bite","scryfallId":"b24345ae-c2c9-435e-a578-1835bb1a9a00"},{"index":245,"token":false,"name":"Glistener Elf","scryfallId":"8b94f4c6-b518-43b3-be52-e889d1f3ea38"},{"index":246,"token":false,"name":"Whirling Dervish","scryfallId":"bbd1538a-3253-4d7c-bcfb-cf4388c815cc"},{"index":247,"token":false,"name":"Ruin Raider","scryfallId":"9bc387b8-30e4-4605-9b03-4477e98a0dcc"},{"index":248,"token":false,"name":"Giant Growth","scryfallId":"755a45bd-8fe6-4e4d-8065-024a2836751b"},{"index":249,"token":false,"name":"Weight of Conscience","scryfallId":"396c8c41-70b4-4189-9160-8b7367a817a2"},{"index":250,"token":false,"name":"Hill Giant","scryfallId":"4905e98f-0c5a-4ec7-b85b-dc2c3549d5d0"},{"index":251,"token":false,"name":"Hollowhenge Spirit","scryfallId":"0b1be91a-cdec-4933-b834-0a7838abb9b8"},{"index":252,"token":true,"name":"Punchcard","scryfallId":"37022fc1-6a13-4873-9eaf-b827da73328e"},{"index":253,"token":false,"name":"Shelkin Brownie","scryfallId":"fddcc557-871d-425b-b4ee-bc0c9bc717aa"},{"index":254,"token":false,"name":"Opportunity","scryfallId":"cf01d4d9-c9e9-4826-a155-4527f9be758e"},{"index":255,"token":true,"name":"Zombie Token (B, 2/2)","scryfallId":"6b365694-e056-48b9-aae3-599180c0c29c"},{"index":256,"token":false,"name":"Aetherspouts","scryfallId":"04a19129-312b-47e3-abed-1dc39e432921"},{"index":258,"token":false,"name":"Shadow Alley Denizen","scryfallId":"985997ae-59bc-49d7-87ca-e63ed9706fdf"},{"index":260,"token":false,"name":"Silumgar, the Drifting Death","scryfallId":"ca5afa5e-6e8d-4390-8de5-217413807d89"},{"index":261,"token":false,"name":"Disenchant","scryfallId":"2cfcbc11-bf1a-438b-9c66-0928cea6d297"},{"index":262,"token":false,"name":"Rootwalla","scryfallId":"4ed6122e-670f-4b02-a774-2c230f369147"},{"index":263,"token":false,"name":"Ghostfire","scryfallId":"a60475e5-0d37-4af0-b717-da4c8dea45ac"},{"index":264,"token":false,"name":"Wake Thrasher","scryfallId":"7340b21f-726d-47e8-a2bf-1cde21be70f4"},{"index":265,"token":false,"name":"Ajani's Pridemate","scryfallId":"aab58d83-5930-4d28-a26c-225c7a872216"},{"index":266,"token":false,"name":"Dream Pillager","scryfallId":"aa268b0b-a981-4774-8455-a608248a5e56"},{"index":267,"token":false,"name":"Roiling Vortex","scryfallId":"b64940bb-c92f-4c2f-aef6-927cdc070b13"},{"index":268,"token":false,"name":"Spellwild Ouphe","scryfallId":"231eb017-2945-4915-8032-c09894e88d49"},{"index":269,"token":false,"name":"Springing Tiger","scryfallId":"04462629-fb03-40e8-84e6-4a66e4d5392b"},{"index":270,"token":false,"name":"Clutch of Currents","scryfallId":"3d20f482-e0b2-4e4a-be32-347ab112912c"},{"index":271,"token":false,"name":"Pillory of the Sleepless","scryfallId":"2d01b08e-9cd6-4166-afcc-c58ea323e29f"},{"index":272,"token":false,"name":"Dark Banishing","scryfallId":"a49acc0d-49a1-4b3e-b848-35febc4b761f"},{"index":273,"token":false,"name":"Preordain","scryfallId":"d382c608-b3db-4112-b0c3-0e12199c4898"},{"index":274,"token":false,"name":"Wood Elemental","scryfallId":"edc71122-2951-43eb-8ca8-1cda6d231013"},{"index":275,"token":false,"name":"Blood Tyrant","scryfallId":"a235f619-6b44-4e60-ac16-0038b7531b77"},{"index":276,"token":false,"name":"Armorcraft Judge","scryfallId":"0893ada6-d7dd-4913-8c94-a780fc559859"},{"index":277,"token":false,"name":"Zahid, Djinn of the Lamp","scryfallId":"5c0caa74-3ffa-499a-80f2-03f7d0e9d821"},{"index":278,"token":false,"name":"Faerie Conclave","scryfallId":"f48061f5-02c3-432d-8d4b-9d0891258ecf"},{"index":279,"token":false,"name":"Unbender Tine","scryfallId":"2b322b16-d288-4643-80b2-e1077e6d4869"},{"index":280,"token":false,"name":"Beetleform Mage","scryfallId":"1e2f7d7f-4097-419b-8de0-b7bf28fc3a4b"},{"index":281,"token":false,"name":"Dragonskull Summit","scryfallId":"3fb05d9e-24b4-4cc6-bb75-fd801d183b69"},{"index":282,"token":false,"name":"Prophetic Bolt","scryfallId":"297773e8-d0c4-4a8e-9f8d-0d02206f3bec"},{"index":283,"token":false,"name":"Luminous Bonds","scryfallId":"9db10390-725e-40f5-885b-a433e7b46f52"},{"index":284,"token":false,"name":"Hoverguard Observer","scryfallId":"c7ab80bf-d115-4155-82e1-9a3a70b1b67d"},{"index":285,"token":false,"name":"Goblin Goon","scryfallId":"5b629eb0-0e84-4eaf-bbc3-ec85ae17a8a7"},{"index":286,"token":false,"name":"Commander's Sphere","scryfallId":"c5e75bf0-7f26-4852-b9e8-9576773ce78a"},{"index":287,"token":false,"name":"Vedalken Shackles","scryfallId":"cef06f56-a7a8-4c0f-8755-56b46d2aa82c"},{"index":288,"token":false,"name":"Firebolt","scryfallId":"5da1493c-78b4-4c4d-ab70-199fe506b61a"},{"index":289,"token":false,"name":"Stingerfling Spider","scryfallId":"3b781626-f4ce-4d00-aa7c-0e07f58f688f"},{"index":291,"token":false,"name":"Yawgmoth's Will","scryfallId":"337239c7-73c4-4e2d-9160-ed26927dea1d"},{"index":292,"token":false,"name":"Trained Orgg","scryfallId":"14a83031-8b57-41d2-b586-bb4dcf16136a"},{"index":293,"token":false,"name":"Svella, Ice Shaper","scryfallId":"a7054d48-5ed3-43a1-85e5-9f306b081b4f"},{"index":294,"token":false,"name":"Eye for an Eye","scryfallId":"f3ca4441-da50-4c16-bc53-735ba2585a83"},{"index":295,"token":false,"name":"Angel of Destiny","scryfallId":"9897074a-0ac4-4d1a-9aac-e77830cc5c78"},{"index":296,"token":false,"name":"Selesnya Guildmage","scryfallId":"a6b04f9b-b813-4a73-b28a-49f4ae06f2d0"},{"index":297,"token":false,"name":"King Crab","scryfallId":"aedea953-b5f1-4ec7-bd9f-b7827f9d40fe"},{"index":299,"token":false,"name":"Vivid Creek","scryfallId":"2e3c2935-84ee-446d-b247-2f574ea84a8f"},{"index":300,"token":false,"name":"Catalyst Stone","scryfallId":"aaca85d4-b4c2-4adc-a0f9-26339bacfd92"},{"index":301,"token":false,"name":"Jungle Lion","scryfallId":"613ceee3-92c7-46f1-8267-d6229ab15df5"},{"index":302,"token":false,"name":"Aggressive Urge","scryfallId":"37e3154d-9b1c-4f93-9bc3-a39e68d59d23"},{"index":303,"token":false,"name":"Karrthus, Tyrant of Jund","scryfallId":"d23a170e-e248-4df8-b56a-7f04f8f923ee"},{"index":304,"token":false,"name":"Hellkite Tyrant","scryfallId":"16937c7d-72c8-4640-8000-e4d2dc664a93"},{"index":305,"token":false,"name":"Narfi, Betrayer King","scryfallId":"421376e4-a4ad-427c-bc9c-d315308dcf68"},{"index":306,"token":false,"name":"Bounty of Might","scryfallId":"db217a40-4a67-499f-9183-9e3562fccef7"},{"index":307,"token":false,"name":"Aurora Phoenix","scryfallId":"3841b5f9-f9a3-433d-bcdc-f2aa5c783b6d"},{"index":308,"token":false,"name":"Ochran Assassin","scryfallId":"541ef933-64f8-4075-9bd3-97149ac84b2b"},{"index":309,"token":false,"name":"Utter End","scryfallId":"af9bcca2-8ab6-4169-81c7-a3e7c8320028"},{"index":310,"token":false,"name":"Esper Panorama","scryfallId":"03324b45-dd69-45d2-a1c0-e3cc4cf1eaf5"},{"index":311,"token":false,"name":"Edric, Spymaster of Trest","scryfallId":"9881e037-39ea-401c-987b-109e9a2918b6"},{"index":312,"token":false,"name":"Godtoucher","scryfallId":"032059cb-c1ad-4cc9-a89d-d68289800312"},{"index":313,"token":false,"name":"Hulking Goblin","scryfallId":"53eefcb7-9c43-4fca-9bb0-200257c7da8c"},{"index":314,"token":false,"name":"Veteran Swordsmith","scryfallId":"c50e0950-e1ef-4c5c-b758-e707ef026d54"},{"index":315,"token":false,"name":"Zoetic Cavern","scryfallId":"c1db30e1-31df-44b9-930a-02428bd5ce47"},{"index":317,"token":false,"name":"Ashen-Skin Zubera","scryfallId":"40cee88d-849d-4715-ad88-7cdb855a3088"},{"index":318,"token":false,"name":"Qasali Pridemage","scryfallId":"e669f0d0-30a2-488a-98a2-d9cfcbe9fc01"},{"index":319,"token":false,"name":"Trespasser il-Vec","scryfallId":"4903171e-76b2-437d-8965-e871e47a3482"},{"index":320,"token":false,"name":"Force of Will","scryfallId":"532e9a34-b908-44cf-9623-b946196c6276"},{"index":321,"token":false,"name":"Wall of Denial","scryfallId":"dd66cb50-6ef5-4b1f-b6c3-ad1210d2d380"},{"index":322,"token":false,"name":"Torchling","scryfallId":"1d9bee9f-701b-433e-b0c3-9bf00f598aa9"},{"index":323,"token":false,"name":"Wall of Blossoms","scryfallId":"6cece7ed-0e64-4833-8944-784d94ac67ba"},{"index":324,"token":false,"name":"Orazca Frillback","scryfallId":"00c81160-192c-4077-8ed1-3643919a2025"},{"index":325,"token":false,"name":"Adarkar Sentinel","scryfallId":"ff62754b-f4f0-4731-8dd7-327a820f60a8"},{"index":326,"token":false,"name":"Holy Strength","scryfallId":"9b8e984a-c533-4d4c-a0b9-6eab5bb99ef6"},{"index":327,"token":false,"name":"Ruby Medallion","scryfallId":"ad5b8a3c-8c75-4af4-975b-031e39d69da3"},{"index":328,"token":false,"name":"Apocalypse Chime","scryfallId":"c52caafd-1212-4da4-8a09-7bf12186559a"},{"index":329,"token":false,"name":"Mangara's Tome","scryfallId":"557ebacf-4a8f-4548-a142-533b7adfdac3"},{"index":330,"token":false,"name":"Cao Cao, Lord of Wei","scryfallId":"d7e5a530-c954-4696-85ce-6afaf7de1808"},{"index":331,"token":false,"name":"Phyrexian Processor","scryfallId":"6875ce99-badd-44da-8e5d-509600efa1d0"},{"index":332,"token":false,"name":"Otherworld Atlas","scryfallId":"46e4aa67-4643-42ff-8172-200498686494"},{"index":333,"token":false,"name":"Cenn's Tactician","scryfallId":"4ab6fde4-a8e0-4bbf-b382-ec0602333e76"},{"index":334,"token":false,"name":"Bristling Boar","scryfallId":"77d9f200-cfbf-4d59-9294-2bbbd532fedf"},{"index":335,"token":false,"name":"Rubblebelt Boar","scryfallId":"196bf114-e135-43f3-83d5-cb08ca766881"},{"index":336,"token":false,"name":"Needletooth Raptor","scryfallId":"e9a90b68-d5f4-4f3c-bd4b-af59dd868919"},{"index":337,"token":false,"name":"Those Who Serve","scryfallId":"482da3bd-c461-4de4-a2ef-4f2424be8456"},{"index":338,"token":false,"name":"Immolation","scryfallId":"4cfbcac8-a976-400e-ad84-56abddda219b"},{"index":339,"token":false,"name":"Birds of Paradise","scryfallId":"715eea77-a7d7-4731-b706-3ea17bded7fd"},{"index":340,"token":false,"name":"Hellion Eruption","scryfallId":"2ed2da5b-28ad-4fbe-be42-19fd52973b75"},{"index":341,"token":false,"name":"Streetbreaker Wurm","scryfallId":"d5313054-91a5-401c-84d1-03a2cd265060"},{"index":342,"token":false,"name":"Munda's Vanguard","scryfallId":"0dfb21b1-95a5-446d-afc6-aede81ee5a0d"},{"index":343,"token":false,"name":"Snapback","scryfallId":"de9135ba-9b6a-4443-a1c4-882f9bfae626"},{"index":344,"token":false,"name":"Erebos's Intervention","scryfallId":"a5e0691a-7a97-497c-9b57-6a8afa156d87"},{"index":345,"token":false,"name":"Scale Up","scryfallId":"3f2d9bae-2753-486c-be79-2438208ac353"},{"index":346,"token":false,"name":"Centaur Vinecrasher","scryfallId":"ef472cfa-9c26-440f-bb0b-ea9aee92e99d"},{"index":347,"token":false,"name":"Pest Summoning","scryfallId":"6267e19a-a777-4767-8433-86b6624362b6"},{"index":348,"token":false,"name":"Troll Ascetic","scryfallId":"5a87f701-ef4c-47dd-beec-8ae871306ffe"},{"index":349,"token":false,"name":"Wu Warship","scryfallId":"2e211d47-dab4-429a-a90b-5b8489441886"},{"index":351,"token":false,"name":"Renewed Faith","scryfallId":"1ea572b5-ff68-45aa-8200-78ee7f64a0ce"},{"index":352,"token":false,"name":"Mountain Goat","scryfallId":"47754124-37e2-4878-a711-a3e00ae0bc70"},{"index":353,"token":false,"name":"Blood Feud","scryfallId":"9f0ec743-46ac-4ace-9c48-8573c3b7a0fe"},{"index":355,"token":false,"name":"Inspired Charge","scryfallId":"e9822b57-8e42-4158-981d-f0b0b0646fc9"},{"index":356,"token":false,"name":"Aurochs Herd","scryfallId":"d757b3ad-b808-4506-934e-727e065f66c1"},{"index":357,"token":false,"name":"Corpse Connoisseur","scryfallId":"feecfe75-ca1e-4e89-af2f-0e4ed2df1ead"},{"index":358,"token":false,"name":"Wildfire Emissary","scryfallId":"9f255055-0499-400f-ae0a-c32624f0ce78"},{"index":359,"token":false,"name":"Sword of the Animist","scryfallId":"6b3a3944-c3e6-4710-a509-7f970cd692a2"},{"index":360,"token":true,"name":"Thopter // Thopter","scryfallId":"2d844ee2-20a0-4071-bc2c-4a58ab1dc07f"},{"index":361,"token":false,"name":"Cateran Overlord","scryfallId":"e8a1ffcb-40a7-423f-b28a-b5b4c1c9ffd0"},{"index":362,"token":false,"name":"Oraxid","scryfallId":"6c05609a-f32d-4454-af24-a24452997dcb"},{"index":363,"token":true,"name":"Soldier Token (W, 1/1)","scryfallId":"b159b57d-bc52-4cef-ac7a-e364e40c3d03"},{"index":364,"token":false,"name":"Ingot Chewer","scryfallId":"f84b4b61-0e92-4ca2-b4e0-ae846a2a8e37"},{"index":366,"token":false,"name":"Escape Artist","scryfallId":"7f5d0e3f-b8f1-472a-857b-5464174d243b"},{"index":367,"token":false,"name":"Scale Blessing","scryfallId":"a76515a0-31eb-4bba-bf07-1f9fde423e24"},{"index":368,"token":false,"name":"Zagras, Thief of Heartbeats","scryfallId":"f1158d64-50fa-41ac-9967-c95237fc207a"},{"index":369,"token":false,"name":"Ojutai, Soul of Winter","scryfallId":"67d470cd-9ff9-49d8-b66a-331cb6cf8257"},{"index":370,"token":true,"name":"Cat Token (W, 1/1)","scryfallId":"255dcc91-7b3d-4b58-85f3-b21be805966e"},{"index":371,"token":false,"name":"Sakura-Tribe Springcaller","scryfallId":"b2ca7687-ba90-4479-8c6e-ece3f29fff12"},{"index":372,"token":false,"name":"Undead Alchemist","scryfallId":"717f4592-6c81-43ac-8975-f6d5d6710310"},{"index":373,"token":false,"name":"Thalia's Lancers","scryfallId":"da02a655-5f49-46b3-b78a-0c8dd18b56d6"},{"index":374,"token":false,"name":"Ardenvale Tactician // Dizzying Swoop","scryfallId":"86927231-4e5f-4771-b520-f675e6e6772b"},{"index":375,"token":false,"name":"Lifeblood Hydra","scryfallId":"4d01469a-d085-4797-95ba-b2877c039469"},{"index":376,"token":false,"name":"Cephalid Constable","scryfallId":"6d98f05b-ddfe-4b93-b247-dbd1a89e0731"},{"index":377,"token":false,"name":"Sporecrown Thallid","scryfallId":"658b93b5-e16a-4a1a-bd26-74a9f25caffe"},{"index":378,"token":false,"name":"Midnight Oil","scryfallId":"14875840-044d-482f-845e-79240cad66f3"},{"index":380,"token":false,"name":"Necropanther","scryfallId":"2e1ed055-8988-4625-9d57-8ce8a4e04aea"},{"index":381,"token":false,"name":"Cascading Cataracts","scryfallId":"778739db-4431-4e58-91de-d2619aeef3ce"},{"index":382,"token":false,"name":"Abolish","scryfallId":"3c81ae90-5abd-4c79-b14a-d5f3a1daff38"},{"index":383,"token":false,"name":"Big Play","scryfallId":"9016d667-50a9-4093-9a99-b34dcdafe60b"},{"index":384,"token":false,"name":"Hinterland Harbor","scryfallId":"51f1c677-581e-469f-860f-a6079128049a"},{"index":385,"token":false,"name":"Thrun, the Last Troll","scryfallId":"5d393da0-4cb6-4ae8-b747-8e6d0fa7f55a"},{"index":386,"token":false,"name":"Woolly Thoctar","scryfallId":"7d5907d5-ae5c-4c9d-a5df-61f1c94f979d"},{"index":387,"token":false,"name":"Legion Conquistador","scryfallId":"f30590d7-59c7-4a1a-a8e5-3cc13f69bd41"},{"index":388,"token":false,"name":"Lancer Sliver","scryfallId":"9a4f8d9a-3760-449e-b8a6-72b2a641ff23"},{"index":389,"token":false,"name":"Aven Warcraft","scryfallId":"1fd5d21a-b151-4fea-ac0d-6659af131bf9"},{"index":390,"token":false,"name":"Needleverge Pathway // Pillarverge Pathway","scryfallId":"9102e1aa-7123-4c16-a810-d65b4505e147"},{"index":391,"token":false,"name":"Volcanic Strength","scryfallId":"bda0bffa-c58c-4630-8899-a1b332a7b8dc"},{"index":392,"token":false,"name":"Conspiracy","scryfallId":"cf453d83-c09b-422a-a11b-679e143f52be"},{"index":393,"token":false,"name":"Spoils of Victory","scryfallId":"743b489c-54a4-4022-b2d5-4de69a8927ce"},{"index":394,"token":false,"name":"Tranquil Thicket","scryfallId":"28272487-17fa-4d07-992f-9740b7f4e85f"},{"index":395,"token":false,"name":"Talisman of Creativity","scryfallId":"e0373057-f5c2-4cfb-b6a4-dea05035d1c6"},{"index":396,"token":false,"name":"Megrim","scryfallId":"3b04fca4-b4de-4343-ba58-d8aea39edc19"},{"index":397,"token":false,"name":"Raven Familiar","scryfallId":"8b60227d-74de-4f2a-b281-3512dd77ffe8"},{"index":398,"token":false,"name":"Embereth Paladin","scryfallId":"6bcfe06b-3bb5-434e-acf4-4bfa8a94141d"},{"index":399,"token":false,"name":"Priest of Urabrask","scryfallId":"e05862a2-dd14-4607-a0db-ae0533551cb9"},{"index":400,"token":false,"name":"Addle","scryfallId":"f7fcce83-4378-405f-8007-dd0ed002be6b"},{"index":402,"token":false,"name":"Chained to the Rocks","scryfallId":"a5af083f-5820-4185-ac04-4c4368f7703c"},{"index":403,"token":false,"name":"Rakdos Trumpeter","scryfallId":"2822aff3-9985-424b-9f19-b49e987c25e4"},{"index":404,"token":false,"name":"Act of Aggression","scryfallId":"8d34c3aa-7d74-4a8b-898c-cb62b1f05989"},{"index":405,"token":false,"name":"Bearer of Silence","scryfallId":"50460cce-ee1c-4384-bb0c-d90616e0d2e9"},{"index":406,"token":false,"name":"Goblin Ringleader","scryfallId":"2b549543-7447-4bb9-ad0e-b24fd3d7ed4f"},{"index":407,"token":false,"name":"Vampire Bats","scryfallId":"d2aed701-5164-4c63-9539-3d2406970f46"},{"index":408,"token":false,"name":"Choke","scryfallId":"e2f85205-3c4f-4411-b09c-d1271be56dde"},{"index":409,"token":false,"name":"Ascendant Spirit","scryfallId":"ea56de43-c0fd-4627-846d-41a962b95f17"},{"index":410,"token":false,"name":"Living Tempest","scryfallId":"a05ed233-9b53-4c67-ab1c-0217386c9fe4"},{"index":411,"token":false,"name":"Iizuka the Ruthless","scryfallId":"9ce461f7-385d-4379-83de-49571247c30d"},{"index":412,"token":false,"name":"Air Bladder","scryfallId":"a7363c6f-53a3-4f41-b451-8120bc24f1ee"},{"index":413,"token":false,"name":"Whirlwind","scryfallId":"66f22827-d7fd-4e9b-b598-3a0e74576ec9"},{"index":414,"token":false,"name":"Thrull Surgeon","scryfallId":"2d6fe257-b1bd-4eaf-9941-e8819f3bc89a"},{"index":415,"token":false,"name":"Swiftfoot Boots","scryfallId":"b79b931d-93b6-46fa-8dff-87abe6dd7170"},{"index":416,"token":false,"name":"Drana, Kalastria Bloodchief","scryfallId":"a33a16f7-434b-4d12-ab7d-95c900b9295e"},{"index":417,"token":false,"name":"Turntimber Symbiosis // Turntimber, Serpentine Wood","scryfallId":"61bd69ea-1e9e-46b0-b1a1-ed7fdbe3deb6"},{"index":418,"token":false,"name":"Death Ward","scryfallId":"286acb93-5967-4389-83fd-44bffd136988"},{"index":419,"token":false,"name":"Plummet","scryfallId":"54a0afaa-f99f-4c7a-9fa1-c6a46dfb2a29"},{"index":420,"token":false,"name":"Silklash Spider","scryfallId":"612fe88c-9c6e-42b4-8936-a9431c1808ea"},{"index":421,"token":false,"name":"Aspect of Wolf","scryfallId":"a20d7ce0-e57d-4403-b27a-e98e2210fed4"},{"index":422,"token":false,"name":"Act of Treason","scryfallId":"babcfccf-83db-40e7-8a2c-f77358ba3cc0"},{"index":423,"token":false,"name":"Abrade","scryfallId":"24da9431-7e52-44f5-bc18-2f2d8a4ca81e"},{"index":424,"token":false,"name":"Kalonian Hydra","scryfallId":"a310086d-1fa0-46a6-af82-5875a2fbc27e"},{"index":425,"token":false,"name":"Neoform","scryfallId":"92d8f67e-4f2f-4a1f-b190-7c3f39e477e4"},{"index":426,"token":false,"name":"Fountain of Youth","scryfallId":"8515a993-0f9d-4ac8-8452-889f23d9d9a9"},{"index":427,"token":false,"name":"Korozda Gorgon","scryfallId":"7006e5b9-d6a3-43ce-904b-b2ac0fea67e5"},{"index":428,"token":false,"name":"Pulse Tracker","scryfallId":"4604a63c-ebe0-420f-968e-3ffc7641ce22"},{"index":429,"token":false,"name":"Run Aground","scryfallId":"9ed573c6-2b95-4052-8b43-106cbaacb721"},{"index":430,"token":false,"name":"Frenzied Goblin","scryfallId":"d9ddc138-1fb2-4f96-ba03-22a61d9704bc"},{"index":431,"token":false,"name":"Planar Bridge","scryfallId":"dcb26bd7-a66f-4a2c-9e8a-081876b5b784"},{"index":433,"token":false,"name":"Unbreathing Horde","scryfallId":"1a91ea47-0c06-4333-a309-ac360c5cc9bd"},{"index":434,"token":false,"name":"Call the Scions","scryfallId":"91526a76-8700-4dd5-ba39-6c28e38bb513"},{"index":435,"token":false,"name":"Stoneshaker Shaman","scryfallId":"17a0edb0-697a-4e0b-872b-f3c15c19cbda"},{"index":436,"token":false,"name":"Fiendish Duo","scryfallId":"160d705f-48fb-4bff-a677-cdf1c3305080"},{"index":437,"token":false,"name":"Drana, the Last Bloodchief","scryfallId":"534fbc19-a8cd-4ae9-9807-2d0408f2c401"},{"index":438,"token":false,"name":"Cemetery Recruitment","scryfallId":"88531c36-2330-474b-9426-1e4dd0fe4e3e"},{"index":439,"token":false,"name":"Otrimi, the Ever-Playful","scryfallId":"a2376fd1-26aa-4263-81b1-00daf21337fc"},{"index":440,"token":false,"name":"Spirit of the Spires","scryfallId":"dbd11910-58e2-4233-a18c-e97413126597"},{"index":441,"token":false,"name":"Grothama, All-Devouring","scryfallId":"ab8935b1-ec87-4330-9952-9ef8cd344531"},{"index":442,"token":false,"name":"Dauntless Bodyguard","scryfallId":"a3f82012-5c33-47bc-a3c8-56ae2eea1fb9"},{"index":443,"token":false,"name":"Withdraw","scryfallId":"f1a3a52f-0ccd-4935-b3ca-9c69cba283cc"},{"index":444,"token":false,"name":"Lure","scryfallId":"7860fb3b-065d-4965-add5-55c7375e794e"},{"index":445,"token":false,"name":"Dream Strix","scryfallId":"2d9f0734-7bdf-4d06-b1ac-15919fb7bce3"},{"index":446,"token":false,"name":"Yavimaya Elder","scryfallId":"8549396b-f525-412d-9ff6-60b6a6b66a18"},{"index":447,"token":false,"name":"Silent Sentinel","scryfallId":"f4c7d693-c508-43e0-91e1-6c72a134c199"},{"index":448,"token":false,"name":"Ghostly Prison","scryfallId":"405ac0c1-dfc6-4b2a-99af-1f5e78c93a25"},{"index":449,"token":false,"name":"Chevill, Bane of Monsters","scryfallId":"fecbf0a3-ebe1-43b6-a720-462ba19002eb"},{"index":450,"token":false,"name":"Weaver of Lies","scryfallId":"12172d0e-0c73-4482-9f83-2c23ace9b7a0"},{"index":451,"token":false,"name":"Tall as a Beanstalk","scryfallId":"098bfd71-a47f-4dfc-b516-b88a388fb7b5"},{"index":452,"token":false,"name":"Essence Warden","scryfallId":"dd7e6400-5302-450b-8f22-4b67c8043063"},{"index":453,"token":false,"name":"Wonder","scryfallId":"675d6729-23da-4f0b-b222-fe54fe24dd90"},{"index":454,"token":false,"name":"Goblin Balloon Brigade","scryfallId":"866df71c-856c-451d-a11b-c2086c265868"},{"index":455,"token":false,"name":"Predatory Focus","scryfallId":"98fc1314-4bf2-44f2-a016-58765eb04607"},{"index":456,"token":false,"name":"Samite Healer","scryfallId":"97235dcc-30cd-4bb6-af10-8705b02eee48"},{"index":457,"token":false,"name":"Dispersal Shield","scryfallId":"0c257df6-f275-40db-bfe3-a9291356cdf7"},{"index":458,"token":false,"name":"Fledgling Osprey","scryfallId":"8cd46bfa-ca09-422f-9891-db9399fa2d3a"},{"index":459,"token":false,"name":"Gideon, Ally of Zendikar","scryfallId":"b5d66fdf-a5a6-48f2-a097-c389e37dc092"},{"index":460,"token":false,"name":"Cursed Land","scryfallId":"c68f617d-5596-4e8d-ae00-a35a3ba497d9"},{"index":461,"token":false,"name":"Mentor of the Meek","scryfallId":"46150e35-bcaf-4b53-871d-d1d9091a36ab"},{"index":463,"token":false,"name":"Rakdos, Lord of Riots","scryfallId":"2143f275-6d3e-4040-a60e-8259a82befdb"},{"index":464,"token":false,"name":"Nicol Bolas, the Deceiver","scryfallId":"74239d78-1608-4b27-b2fd-8c7453f6b86b"},{"index":465,"token":false,"name":"Mana Vault","scryfallId":"a748366b-654a-488b-8431-8f44c7e2e0ec"},{"index":466,"token":false,"name":"Secluded Steppe","scryfallId":"9c536cbd-3e81-4c6a-a4e1-02fbd2776706"},{"index":467,"token":false,"name":"Spellstutter Sprite","scryfallId":"4e5ba4a9-a282-4d4b-b25a-179e05e458f4"},{"index":468,"token":false,"name":"Restore Balance","scryfallId":"c3be9788-2360-4ff0-b7f6-0bfbefa03ce0"},{"index":469,"token":false,"name":"Denying Wind","scryfallId":"15f236ce-41ad-4a49-a6f9-7853a2395a84"},{"index":470,"token":false,"name":"Atarka's Command","scryfallId":"12ddf922-f5ae-488f-9e1d-bb1bd21f2b61"},{"index":471,"token":false,"name":"Wei Strike Force","scryfallId":"0b4cc234-f6b7-4801-a6d0-c98b72f446cf"},{"index":472,"token":false,"name":"Necroskitter","scryfallId":"128d1e8a-b80e-4963-aeff-4b364a02a246"},{"index":473,"token":false,"name":"Disrupt Decorum","scryfallId":"5c907e23-c637-4984-84f7-b06db90d26df"},{"index":474,"token":false,"name":"Tribute to the Wild","scryfallId":"a60d39c4-c97d-4876-81b6-d115910abe7b"},{"index":475,"token":false,"name":"Kasmina, Enigma Sage","scryfallId":"178bf300-38cf-4ab2-9e66-6fcaa112b649"},{"index":476,"token":false,"name":"Scavenging Ghoul","scryfallId":"33a5daf6-ce4f-4d00-8458-b7d1a9e037bc"},{"index":477,"token":false,"name":"Soul Feast","scryfallId":"9417a9db-5101-4fe1-84b7-283ca1fd42e5"},{"index":478,"token":false,"name":"Sorcerous Sight","scryfallId":"ecfd43dc-e5fd-43bc-babb-fe7ecb6ccd00"},{"index":479,"token":false,"name":"Crippling Blight","scryfallId":"6a96a5d6-6527-4018-923e-7e850fda106a"},{"index":480,"token":false,"name":"Okk","scryfallId":"5fecbdbc-dcfb-42ee-956c-a508db6eaafa"},{"index":481,"token":false,"name":"Call to the Grave","scryfallId":"2a346b4a-ac8a-4f99-9ed7-dd41102e56ce"},{"index":482,"token":true,"name":"Beast Token (G, 4/4)","scryfallId":"a1eff7f8-b645-41cb-bcd9-3dc1ab10200e"},{"index":483,"token":false,"name":"Crash","scryfallId":"7a26bde3-8392-4476-b347-f223d52554a6"},{"index":484,"token":false,"name":"Hermit Druid","scryfallId":"3efc0622-ac2c-4722-ba05-961cc98c5940"},{"index":485,"token":false,"name":"City of Brass","scryfallId":"193db964-feea-4b66-bf31-67a92772b792"},{"index":486,"token":false,"name":"Earth Elemental","scryfallId":"d9d53b5d-2324-4551-ad15-41852d366aee"},{"index":487,"token":false,"name":"Geyadrone Dihada","scryfallId":"3d228005-91f1-451e-ab6f-1f86316708a7"},{"index":488,"token":false,"name":"Barren Moor","scryfallId":"45be3811-a223-4c45-9b24-0317f2d53c60"},{"index":489,"token":false,"name":"Flicker of Fate","scryfallId":"59e19bac-176c-4e37-bfc8-27c00de7c37f"},{"index":490,"token":false,"name":"Storm Herald","scryfallId":"e0594aa2-1c53-4271-a0d0-9002c07f3697"},{"index":491,"token":false,"name":"Persuasion","scryfallId":"3ab3611c-b0ab-48ea-8c64-e7c500e95fc5"},{"index":492,"token":false,"name":"Hulking Cyclops","scryfallId":"a3ee5ea8-7023-4dde-ab51-d3ba234d74b9"},{"index":493,"token":false,"name":"Mammoth Spider","scryfallId":"9a684871-ff6e-4474-82da-30757c324c73"},{"index":494,"token":false,"name":"Adarkar Valkyrie","scryfallId":"fc2a4abc-85da-46a6-a616-9aa607ce7372"},{"index":495,"token":false,"name":"Hunted Wumpus","scryfallId":"2bf7258f-83c0-4cb0-8b1c-1f0c131abcd3"},{"index":496,"token":false,"name":"Wall of Resurgence","scryfallId":"c99f0dc1-c8cf-4733-a874-5ae57b38258e"},{"index":497,"token":false,"name":"Eyeblight Assassin","scryfallId":"8a480da7-1b5d-41a5-b603-e63af100724a"},{"index":498,"token":false,"name":"Cackling Flames","scryfallId":"a54a371e-fb82-41f1-892c-975f932b668e"},{"index":499,"token":false,"name":"Exponential Growth","scryfallId":"7d140f1c-719f-475f-826a-efcd2e01747e"},{"index":500,"token":false,"name":"Lovestruck Beast // Heart's Desire","scryfallId":"e1aa5205-45f7-4e54-bfc7-7bc6778506b6"},{"index":501,"token":false,"name":"Darba","scryfallId":"d82636dc-4b3e-44a8-bc72-dab1275dfb6d"},{"index":502,"token":false,"name":"Soul of Shandalar","scryfallId":"03543d10-202b-4b07-a34b-64216a745d84"},{"index":503,"token":false,"name":"Charging Badger","scryfallId":"66feeb05-7adc-4a0e-ba2e-24781e5a291a"},{"index":504,"token":false,"name":"Lifespring Druid","scryfallId":"01abad84-abb9-4c8e-94f8-12d2a6627188"},{"index":505,"token":false,"name":"Prairie Stream","scryfallId":"beaf2d9d-f25c-46d9-940d-b4c3287a5a74"},{"index":506,"token":false,"name":"Necrosavant","scryfallId":"164a9755-f003-456d-a827-d6ef6cc29a86"},{"index":507,"token":false,"name":"Rakshasa's Disdain","scryfallId":"bd9e8a25-2e71-431b-897f-8b62520a3ce9"},{"index":508,"token":false,"name":"Torgaar, Famine Incarnate","scryfallId":"cab46d5c-95dd-47a0-9f96-dde07d2f8b81"},{"index":509,"token":false,"name":"Wall of Spears","scryfallId":"b4f34f06-7f89-4f2b-8979-8219ac1c4560"},{"index":511,"token":false,"name":"Vampire Cutthroat","scryfallId":"954d53f3-ebbe-48e0-9e1a-7019d2b0740c"},{"index":512,"token":false,"name":"Life // Death","scryfallId":"2424f2c4-366b-42cf-bf4b-a8a5bfdd2c4b"},{"index":513,"token":false,"name":"Sunbringer's Touch","scryfallId":"ad4d33ea-0193-4ea5-92ea-5f50a533bf6b"},{"index":514,"token":false,"name":"Deadeye Brawler","scryfallId":"acb1ab66-f2ce-4094-b2dd-1fc63d78eea2"},{"index":515,"token":false,"name":"Peregrine Drake","scryfallId":"5d551c44-216b-42e9-acdd-7ca86f6ef254"},{"index":516,"token":false,"name":"Duergar Hedge-Mage","scryfallId":"7bf8f86e-3546-4b2c-b5f0-f578d307cbc5"},{"index":517,"token":false,"name":"Crop Sigil","scryfallId":"861e8c51-0cda-497a-b289-a9f678f0e328"},{"index":518,"token":false,"name":"Okiba-Gang Shinobi","scryfallId":"5cd9297e-301e-4e70-af9b-3218eacacf8d"},{"index":519,"token":false,"name":"Brooding Saurian","scryfallId":"b3ec586d-14c7-4d3a-9bb5-f6afdf87657c"},{"index":520,"token":false,"name":"Blood Baron of Vizkopa","scryfallId":"56955e63-db6f-4f1d-b3c4-dd268c902653"},{"index":521,"token":false,"name":"Arcane Denial","scryfallId":"ed81ccd0-8f96-4f83-8e28-dc94a500313f"},{"index":522,"token":false,"name":"Trinket Mage","scryfallId":"4c5a41ab-1840-4abb-a8bb-f0b1e7d1b450"},{"index":523,"token":false,"name":"Overwhelming Forces","scryfallId":"c56c7fb4-8b7b-40fc-879c-76cfb5d417b8"},{"index":524,"token":false,"name":"Zuran Orb","scryfallId":"618c8ecc-686d-41de-b9b1-1a7ee9cc7c14"},{"index":525,"token":false,"name":"Shadow of the Grave","scryfallId":"806830e3-7296-4982-b366-fa443bda3989"},{"index":526,"token":false,"name":"Necrobite","scryfallId":"06c5bca1-b0f0-4032-b2ed-71bdbaa41993"},{"index":528,"token":false,"name":"Lodestone Golem","scryfallId":"683a5707-cddb-494d-9b41-51b4584ded69"},{"index":529,"token":false,"name":"Kragma Butcher","scryfallId":"56d1dcab-7e46-4ff1-91f6-77352ef0cd90"},{"index":530,"token":false,"name":"Collar the Culprit","scryfallId":"545f38df-88c3-4472-afc9-ee5f67542cb8"},{"index":531,"token":false,"name":"Fathom Feeder","scryfallId":"89923289-0f62-444e-a781-d9948f32eedd"},{"index":532,"token":false,"name":"Spiteful Visions","scryfallId":"e2475965-01a6-4a32-bca9-80018ab31d9a"},{"index":533,"token":false,"name":"Brainstorm","scryfallId":"beb755c1-9221-480e-bef9-73f1f13a3345"},{"index":534,"token":false,"name":"Coercive Portal","scryfallId":"b010ece6-ccb9-4237-8682-2e147220f908"},{"index":535,"token":false,"name":"Tukatongue Thallid","scryfallId":"e870e12e-feed-46e1-ac3c-3b6687780825"},{"index":536,"token":false,"name":"Defile","scryfallId":"5bcb4398-edd1-41a7-a496-b12bce22ceb6"},{"index":537,"token":false,"name":"Magma Jet","scryfallId":"1dffd252-9eda-4da8-aa7e-7f478c5dbf97"},{"index":538,"token":true,"name":"Dragon Token (R, 2/2)","scryfallId":"4068d6ea-7452-45bf-beb1-94f1a5ec9d39"},{"index":539,"token":false,"name":"Verdurous Gearhulk","scryfallId":"0130b99e-5b2f-4482-b141-752e59b72c31"},{"index":542,"token":false,"name":"Sunblast Angel","scryfallId":"1b21bfb2-c20d-47f8-809d-19ea7702fb70"},{"index":543,"token":false,"name":"Woodland Stream","scryfallId":"d996a106-40b1-43fe-b7b9-359620c3794c"},{"index":544,"token":false,"name":"Bloodlord of Vaasgoth","scryfallId":"972fafa6-a001-4597-962b-1aed8e40adad"},{"index":545,"token":false,"name":"Marisi's Twinclaws","scryfallId":"eba9449b-d1f2-4322-a5d4-b8935f270fff"},{"index":546,"token":false,"name":"Soot Imp","scryfallId":"7df777c3-281b-4a2d-b852-4e2663672c06"},{"index":547,"token":false,"name":"Balduvian Rage","scryfallId":"f2938119-34a9-4471-bab6-49fa30122fa5"},{"index":548,"token":false,"name":"Bayou","scryfallId":"412ceddd-2b9a-4551-a6bf-ae2830a2010a"},{"index":549,"token":false,"name":"Gust Walker","scryfallId":"d3d5454a-a65b-4a06-9a91-91ea9e8fcf9c"},{"index":550,"token":false,"name":"Tempest Drake","scryfallId":"54aa5262-d0d9-4b4a-8027-00393568b3df"},{"index":551,"token":false,"name":"Karametra, God of Harvests","scryfallId":"74050cb3-ba99-475d-9124-726e498fb68e"},{"index":552,"token":false,"name":"Oath of Scholars","scryfallId":"d61376ad-21c8-4d34-b37d-ed60877f5d4a"},{"index":553,"token":false,"name":"Countervailing Winds","scryfallId":"0e127810-a9e8-44ff-a0a4-bf0bffeb9d1d"},{"index":555,"token":false,"name":"Ebon Dragon","scryfallId":"63ec235b-7d9a-4600-89db-48b14beb1aa7"},{"index":556,"token":false,"name":"Axgard Braggart","scryfallId":"4de5ff64-6fe7-4fc5-be27-cdbaa14545ab"},{"index":557,"token":false,"name":"Noble Templar","scryfallId":"6a9ede92-e64f-44a5-afb6-c7495077fb0b"},{"index":558,"token":false,"name":"Seal of Doom","scryfallId":"db03f466-f3a2-45ca-bd79-19773a3c8cf8"},{"index":559,"token":false,"name":"Into the Roil","scryfallId":"8637eef0-f5a8-41ce-b885-7d4b26e417d3"},{"index":561,"token":false,"name":"Cloudchaser Kestrel","scryfallId":"87003295-fd7c-489a-b724-b76eef187b57"},{"index":562,"token":false,"name":"Containment Priest","scryfallId":"d51bacdd-040e-45f7-9256-85f93801a10e"},{"index":563,"token":false,"name":"Angelic Voices","scryfallId":"1e9a66b2-7392-4030-a3a8-8f3697307a39"},{"index":564,"token":false,"name":"Tidal Flats","scryfallId":"2e820f3f-434e-4d09-91b9-0ebd6966b393"},{"index":565,"token":false,"name":"Dragonshift","scryfallId":"6c046e4e-810c-4123-bb1a-4f97e0cd43d1"},{"index":566,"token":false,"name":"Doomed Traveler","scryfallId":"5a4573af-feba-4c9d-b24b-3d15888a5ce2"},{"index":567,"token":false,"name":"Mahamoti Djinn","scryfallId":"5d464226-5607-4db2-bd43-7855efb92628"},{"index":568,"token":false,"name":"Charging Slateback","scryfallId":"d2cfff37-655f-4107-abf3-e6f63d0e4de2"},{"index":569,"token":false,"name":"Delusions of Mediocrity","scryfallId":"ab43fba7-699e-4bb5-ab3e-b5b1c290340c"},{"index":570,"token":true,"name":"Rogue Token (B, 2/2)","scryfallId":"4b633d7b-6d61-4b1a-8d65-6e1f3d5ffba7"},{"index":571,"token":false,"name":"Purphoros, God of the Forge","scryfallId":"7bf6baf2-d20b-467d-8929-abefcf7dfa99"},{"index":572,"token":false,"name":"Ghostblade Eidolon","scryfallId":"0795101e-07d9-419a-adca-3eb57536fd5f"},{"index":573,"token":false,"name":"Slipstream Eel","scryfallId":"ffe138be-435c-4618-8fc4-6c8af6acfcca"},{"index":574,"token":false,"name":"Nim Grotesque","scryfallId":"11ae8bc7-8bf1-4fce-afaa-76acfb261419"},{"index":575,"token":false,"name":"Healer's Headdress","scryfallId":"9565f076-54a6-43d6-bcf0-dcb932f6c116"},{"index":576,"token":true,"name":"Drake Token (U, 2/2)","scryfallId":"2fd81e9a-69b5-4764-91a7-8b6cdddcaa40"},{"index":577,"token":false,"name":"Mirage Mirror","scryfallId":"d3ce5a64-ff34-44d7-8315-c75033fd69c2"},{"index":578,"token":false,"name":"Goldmeadow Lookout","scryfallId":"99c0eb4c-c8f1-40cf-ae0a-a413432b4c5f"},{"index":579,"token":false,"name":"Weakness","scryfallId":"74da87a2-8b16-4c64-b224-21bab10f24a4"},{"index":580,"token":false,"name":"Villainous Wealth","scryfallId":"0610e69b-8b7c-40e4-bb10-28ee4411f861"},{"index":581,"token":false,"name":"Sea Gate Restoration // Sea Gate, Reborn","scryfallId":"a6cb69b6-88dd-4ae6-b123-c75d8f39c538"},{"index":582,"token":false,"name":"Gruul Signet","scryfallId":"1bb30340-96a4-49d8-838b-8788900401a0"},{"index":583,"token":false,"name":"Instill Infection","scryfallId":"82ef2567-f798-4447-9735-c7c0d88aba85"},{"index":584,"token":false,"name":"Wall of Omens","scryfallId":"4b64798d-e400-4e17-8b88-842a7a3e1bd1"},{"index":585,"token":false,"name":"Deathgrip","scryfallId":"5742739a-b257-496c-b345-d4e43b073a4e"},{"index":586,"token":false,"name":"Heroes' Bane","scryfallId":"380e82f6-30ee-49c5-b5a2-85c5cf3e9bb1"},{"index":588,"token":false,"name":"Pongify","scryfallId":"726b3de5-f2c1-4a92-9039-f61ae9575839"},{"index":590,"token":false,"name":"Puppet Strings","scryfallId":"53e0bb82-c64a-4ae6-962a-7a0c45329159"},{"index":591,"token":false,"name":"Golem Artisan","scryfallId":"441a3345-2507-46ed-bdb3-c5c45d17da51"},{"index":592,"token":false,"name":"Bog Wraith","scryfallId":"5644b8a9-8777-49da-813a-61ce75324d48"},{"index":593,"token":false,"name":"Jegantha, the Wellspring","scryfallId":"1d52e527-3835-4350-8c01-0f2d5d623b9c"},{"index":594,"token":false,"name":"Giant Trap Door Spider","scryfallId":"43b588cf-be57-48af-a2fd-d615bf5bf9af"},{"index":595,"token":false,"name":"Taste for Mayhem","scryfallId":"20fbb2eb-5738-46e5-a0a6-8ee98c7c8cfb"},{"index":596,"token":false,"name":"Show of Valor","scryfallId":"c07932c2-7b97-4abe-be2b-02fc04de780f"},{"index":597,"token":false,"name":"Rakdos Carnarium","scryfallId":"de25665f-6af2-46c8-b5f9-88e1caa8395c"},{"index":599,"token":false,"name":"Blightstep Pathway // Searstep Pathway","scryfallId":"0ce39a19-f51d-4a35-ae80-5b82eb15fcff"},{"index":601,"token":false,"name":"Leyline of the Void","scryfallId":"2e2ac775-d9bb-43f5-9dce-7cd9bc584b27"},{"index":602,"token":false,"name":"Razorverge Thicket","scryfallId":"d578981f-cda3-4ba4-bdc0-275a37386b84"},{"index":603,"token":false,"name":"Psychic Miasma","scryfallId":"fd9c3267-7988-416c-85a4-0e314e42ddb9"},{"index":604,"token":false,"name":"The Gitrog Monster","scryfallId":"5790dd89-2be5-4a77-9450-2d3c1422bfc9"},{"index":605,"token":false,"name":"Semester's End","scryfallId":"ef4743f7-28db-4d72-bfce-09cfbe413514"},{"index":606,"token":false,"name":"Chalice of the Void","scryfallId":"34b6caec-0dd8-4b65-83c8-d681c103d209"},{"index":607,"token":false,"name":"Tuinvale Treefolk // Oaken Boon","scryfallId":"7b7c91e7-b0c6-47e1-9c92-c5e9faace876"},{"index":608,"token":false,"name":"Dusk Charger","scryfallId":"012bdc02-fe5f-4e87-b840-53090f78c649"},{"index":609,"token":false,"name":"Extirpate","scryfallId":"4171dbd3-96d6-4e7a-afac-5b2882bf3872"},{"index":610,"token":false,"name":"Archaeomancer","scryfallId":"32d0ae8f-3d46-4692-a23c-c461f8aa6a58"},{"index":611,"token":false,"name":"Gelatinous Genesis","scryfallId":"4e5c2be0-76ab-4873-a1fc-9ff65a9347c7"},{"index":612,"token":false,"name":"White Knight","scryfallId":"042b8d98-59b8-4fba-96b0-608e416c487f"},{"index":613,"token":false,"name":"Gaze of Granite","scryfallId":"1aca163e-abff-459f-9925-09dda212dce2"},{"index":614,"token":false,"name":"Renegade Map","scryfallId":"ac063445-d0e2-4015-96dc-97098433f30a"},{"index":615,"token":false,"name":"Yotian Soldier","scryfallId":"25dcc48b-8f0c-43e6-91e2-69dc902ee580"},{"index":616,"token":false,"name":"Serrated Arrows","scryfallId":"c9cf9dc0-9a17-441a-bb99-5d01d568d09d"},{"index":617,"token":false,"name":"Dwarven Driller","scryfallId":"69d815d3-7e33-4de9-aa36-ff5ffb893d73"},{"index":618,"token":false,"name":"Bramble Elemental","scryfallId":"c348fb8f-f151-4ade-8cb3-b994219340c0"},{"index":620,"token":false,"name":"Migratory Greathorn","scryfallId":"6a2a287b-b83f-444f-84f7-e388beb616c2"},{"index":621,"token":true,"name":"Goblin Token (R, 1/1)","scryfallId":"b27dc0bd-ba46-4a5c-9559-7c11eb4ec37b"},{"index":622,"token":false,"name":"Thunder Spirit","scryfallId":"ef6a1355-8e4d-49b3-82e5-38bd880dadd9"},{"index":623,"token":false,"name":"The Flame of Keld","scryfallId":"324399ed-3d6e-4b4c-8f3d-b7802e2ecadf"},{"index":624,"token":false,"name":"Ulamog, the Infinite Gyre","scryfallId":"225e3cc6-34d0-4f81-9f49-162d97e2ea59"},{"index":625,"token":false,"name":"Wall of Deceit","scryfallId":"1496d941-88fd-433e-8fae-1218316ef3a9"},{"index":626,"token":false,"name":"Tavern Scoundrel","scryfallId":"55082c8a-d792-4cd8-94b1-d80c65804463"},{"index":627,"token":false,"name":"Bottle Gnomes","scryfallId":"75522385-2f94-4c7c-b7d2-e8827ea1164f"},{"index":628,"token":false,"name":"Freewind Equenaut","scryfallId":"3b720dd2-8c24-4951-b3c4-bcb0ae97b4f5"},{"index":629,"token":false,"name":"Fit of Rage","scryfallId":"09e7b9ec-90cf-4d23-af5e-48394398ff06"},{"index":630,"token":false,"name":"Frost Ogre","scryfallId":"1a91e5f1-9179-4763-b7c9-b7ad5451f6d0"},{"index":631,"token":false,"name":"Stasis Snare","scryfallId":"f4694ece-a576-45f9-8dd6-4fee0df9751d"},{"index":632,"token":false,"name":"Murmuring Bosk","scryfallId":"d07a08cc-e558-40a5-a10a-b52fd1c877e6"},{"index":633,"token":false,"name":"Retreat to Emeria","scryfallId":"4b65101f-808a-40b8-8864-ee84c00d2496"},{"index":634,"token":false,"name":"Victory's Herald","scryfallId":"33366563-6cb8-46f6-82c9-d7541a52af33"},{"index":635,"token":false,"name":"Dreamtail Heron","scryfallId":"2d1828b1-a6eb-4346-b405-7642e34b3e71"},{"index":636,"token":false,"name":"Mystical Dispute","scryfallId":"1e312cc9-5ad2-4436-9334-bcbbcaca914e"},{"index":637,"token":false,"name":"Regisaur Alpha","scryfallId":"dc2eec06-261c-4cb3-bd8e-23aaf07db47d"},{"index":639,"token":false,"name":"World-Weary","scryfallId":"f16d9113-d279-4a6d-9cf0-f5e104f77852"},{"index":640,"token":false,"name":"Sarkhan the Masterless","scryfallId":"fa83a8c7-9670-428d-8cd1-879266d34b12"},{"index":642,"token":false,"name":"Bog Hoodlums","scryfallId":"f2459953-a4b5-4a9c-85ed-928b684d7240"},{"index":643,"token":false,"name":"Mind's Eye","scryfallId":"5a0e1ef4-fdb1-42bd-8e46-ba84cf850939"},{"index":645,"token":false,"name":"Thornbow Archer","scryfallId":"3290c60a-f9a0-464d-a15e-8473a6d50d96"},{"index":647,"token":false,"name":"Gorilla Warrior","scryfallId":"cacd84b9-43ad-4a52-a438-b6c2e8d125d4"},{"index":648,"token":false,"name":"Bogardan Rager","scryfallId":"04128756-cfdc-4e7e-be5f-c9a34c2a0ccc"},{"index":649,"token":false,"name":"Numa, Joraga Chieftain","scryfallId":"9465d118-5ad5-42c5-a512-7aca5f7b905d"},{"index":650,"token":false,"name":"Duskborne Skymarcher","scryfallId":"baa524bb-0ce7-4c30-93c3-ae15c3b05e92"},{"index":651,"token":true,"name":"Giant Token (G, 7/7)","scryfallId":"3c1debc4-0b12-4848-b551-90680ab8c0ab"},{"index":652,"token":false,"name":"Mask of Immolation","scryfallId":"be2f4165-f87f-454b-b955-e4477c864e95"},{"index":654,"token":false,"name":"Response // Resurgence","scryfallId":"e9b44a8e-34b1-4ee1-894a-968db6f724b6"},{"index":655,"token":false,"name":"Holy Day","scryfallId":"f3895c0c-0db8-4962-b386-57887fb60701"},{"index":656,"token":false,"name":"Induce Despair","scryfallId":"9cd60569-5345-47ae-8fa4-2f41e1d58593"},{"index":657,"token":false,"name":"Vastwood Zendikon","scryfallId":"9bca11e1-3c75-4dba-b4a2-c77595cc3022"},{"index":658,"token":false,"name":"Kopala, Warden of Waves","scryfallId":"34561f87-09d9-4f23-8a05-907fe1303e70"},{"index":659,"token":false,"name":"Divinity of Pride","scryfallId":"cfb71651-7ede-4348-89a4-b441da72491b"},{"index":660,"token":false,"name":"Amrou Scout","scryfallId":"ea3e05e5-1340-4010-b39b-3571a5829840"},{"index":663,"token":false,"name":"Sea Eagle","scryfallId":"1bddb733-2100-42f8-8ea1-a55d516c5958"},{"index":664,"token":false,"name":"Ancestor's Chosen","scryfallId":"b93f39f9-fbdf-4096-9bd7-a7b2481e2dbd"},{"index":665,"token":false,"name":"Goblin Grenade","scryfallId":"3c2b7a33-3ff5-439b-bf42-69528b665822"},{"index":666,"token":false,"name":"Rewind","scryfallId":"47a7176f-0e35-406b-819a-e91b42d07172"},{"index":667,"token":false,"name":"Sunstrike Legionnaire","scryfallId":"0f5d519a-9f11-4b10-97ad-edccfda639bb"},{"index":668,"token":false,"name":"Serra Avenger","scryfallId":"a01fcf2a-50a2-42f6-905f-494f6820d439"},{"index":669,"token":false,"name":"Leviathan","scryfallId":"f2f142b2-08a1-4dfb-9b72-0a383ffbdbfc"},{"index":670,"token":false,"name":"Totem-Guide Hartebeest","scryfallId":"589346d3-b32b-40f2-8513-741ceb88bf7b"},{"index":671,"token":false,"name":"Melek, Izzet Paragon","scryfallId":"19b4dc6c-940e-478c-b87f-b3939a30efbd"},{"index":672,"token":false,"name":"War Elemental","scryfallId":"9cc32bfc-7d87-46d9-a424-eac64eefd7ea"},{"index":673,"token":false,"name":"Aladdin","scryfallId":"462094ff-5ec8-4a9b-8ab1-012c5f7d85ca"},{"index":674,"token":false,"name":"Garruk's Packleader","scryfallId":"dafeafa0-b937-4387-8626-449a810486b4"},{"index":676,"token":false,"name":"Craw Giant","scryfallId":"06274d3b-8feb-4c68-adbc-b1ee633c3353"},{"index":677,"token":false,"name":"Tectonic Rift","scryfallId":"075eebe9-a87f-44d9-ade6-ec58ff543fbb"},{"index":678,"token":false,"name":"Spin into Myth","scryfallId":"0808b800-9f5f-42ef-8cd0-c04e64945adf"},{"index":679,"token":false,"name":"Orcish Mechanics","scryfallId":"5e34fc6b-5f00-4a22-9ee2-afc1caf99961"},{"index":680,"token":false,"name":"Nature's Chosen","scryfallId":"7bd0b831-9d7e-40ce-8514-e852daee1a9e"},{"index":681,"token":false,"name":"Plateau","scryfallId":"2ff721e2-b12a-4cd1-b846-fccd61c6b69b"},{"index":683,"token":false,"name":"Territorial Kavu","scryfallId":"3b25acb5-3bd3-4835-9b6b-32a751c7ce97"},{"index":684,"token":false,"name":"Battle-Rattle Shaman","scryfallId":"a8e3e496-6bfa-4eb0-b51e-fbc35cf18bae"},{"index":686,"token":false,"name":"Wall of Fire","scryfallId":"74841ee8-2af0-4019-898d-d0ce72fc62c3"},{"index":687,"token":false,"name":"Castle Raptors","scryfallId":"d4a3ed1e-f07e-486d-8a44-b2fbfaffa547"},{"index":689,"token":false,"name":"Irencrag Pyromancer","scryfallId":"a763d58c-0806-4237-9ab2-85e93e7fc0fa"},{"index":690,"token":false,"name":"Infest","scryfallId":"6f9ad410-0de3-46d7-9c26-34b3f388a6d6"},{"index":691,"token":false,"name":"Kher Keep","scryfallId":"4d559369-59eb-4c8f-8bc1-987a529037b8"},{"index":692,"token":false,"name":"Sparring Mummy","scryfallId":"e4ec1587-0405-4b4d-96b5-1ac2c5a7c9dc"},{"index":693,"token":false,"name":"Keldon Halberdier","scryfallId":"a90723e0-fbb3-4976-9463-0373f8ed337c"},{"index":694,"token":false,"name":"Anowon, the Ruin Sage","scryfallId":"e3631ede-7703-4e84-aec0-b4880fdb3685"},{"index":695,"token":false,"name":"Denizen of the Deep","scryfallId":"95b00eca-065e-495e-947e-24eb79ffb1df"},{"index":697,"token":false,"name":"Virtuous Charge","scryfallId":"72ad4c79-a85d-4fc6-95ab-5a6d6d667579"},{"index":698,"token":false,"name":"Temple of Mystery","scryfallId":"81634185-eb67-4d13-8b82-a662b8c9a7f0"},{"index":699,"token":false,"name":"Thelonite Hermit","scryfallId":"4af2dbf0-5fb5-487b-a517-16a5dd98498a"},{"index":700,"token":false,"name":"Lead the Stampede","scryfallId":"b4d1f656-4a33-4348-b850-af7391ac071b"},{"index":701,"token":false,"name":"Krosan Reclamation","scryfallId":"ae897dd1-0a4d-4853-bed1-545e5a0a9f1b"},{"index":702,"token":false,"name":"Horn of Greed","scryfallId":"950660f9-b185-4979-a08b-cce4ec6ce07d"},{"index":703,"token":false,"name":"Waxmane Baku","scryfallId":"fd0c47e0-c87b-4304-b412-00496c2c289f"},{"index":704,"token":false,"name":"Selesnya Guildgate","scryfallId":"4c1d26ae-d775-4cd4-afc1-139021d77543"},{"index":705,"token":false,"name":"Quick Sliver","scryfallId":"30a60b2d-aeeb-4dbf-bf1a-20a274fe323f"},{"index":706,"token":false,"name":"Redirect","scryfallId":"efdb01f8-209d-4f8b-a280-b45e1ab0b880"},{"index":707,"token":false,"name":"Waste Not","scryfallId":"241d8f7d-3981-47c1-b7b8-748277fa452f"},{"index":708,"token":false,"name":"Feast of Sanity","scryfallId":"9f71309d-1b62-461d-b939-87f2932937a7"},{"index":709,"token":false,"name":"Chastise","scryfallId":"1169dab7-8f4c-474d-9289-42765a275376"},{"index":710,"token":false,"name":"Rathi Trapper","scryfallId":"a7449f03-fed0-4f8d-89ca-28182b6598f6"},{"index":711,"token":false,"name":"Ulvenwald Observer","scryfallId":"7a9d23d5-2f94-48e6-824f-f1de8f742989"},{"index":712,"token":false,"name":"Flame Fusillade","scryfallId":"7fcad5f0-53c4-4b72-ac05-ef9ca5b55611"},{"index":713,"token":false,"name":"Dragon Grip","scryfallId":"0269d5bd-d8aa-465b-bfe9-6703937f933c"},{"index":715,"token":false,"name":"Blasted Landscape","scryfallId":"55776293-fde5-481e-a069-31721866a7d7"},{"index":716,"token":false,"name":"Azami, Lady of Scrolls","scryfallId":"cafda395-840f-4359-9314-e1cbf137cc66"},{"index":718,"token":false,"name":"Rummaging Goblin","scryfallId":"b6f8f65b-022f-4599-a416-e82a6d45ceba"},{"index":719,"token":false,"name":"Subversion","scryfallId":"50f1bca9-5831-4e8b-8920-f28ebb3ffb27"},{"index":721,"token":false,"name":"Wintermoor Commander","scryfallId":"06e8d715-025f-4578-b427-e401318a9c58"},{"index":722,"token":false,"name":"Chaos Imps","scryfallId":"c70a702a-c9be-4bee-9087-22b5905f783a"},{"index":723,"token":false,"name":"Smoke","scryfallId":"7eb0cb82-d930-43c3-a6d6-f947018d45d6"},{"index":725,"token":false,"name":"Ragavan, Nimble Pilferer","scryfallId":"a9738cda-adb1-47fb-9f4c-ecd930228c4d"},{"index":726,"token":false,"name":"Caldera Hellion","scryfallId":"88866ce7-0b81-4b6c-a17e-ce5e51a0f2da"},{"index":727,"token":false,"name":"Midnight Charm","scryfallId":"33f51f18-41af-4a2c-a353-48bebd697599"},{"index":728,"token":false,"name":"Longbow Archer","scryfallId":"8ac3672e-ebab-4bb1-bf4d-5020047296d8"},{"index":729,"token":false,"name":"Haunted Cloak","scryfallId":"19ece771-d628-45e7-882d-a35f625d2e55"},{"index":730,"token":false,"name":"Water Elemental","scryfallId":"954dc110-54f3-442e-9f4b-82733a2480bc"},{"index":731,"token":false,"name":"Infinite Hourglass","scryfallId":"f9a42152-32c0-47ff-aaac-8deaf01873ca"},{"index":732,"token":false,"name":"Akroma's Blessing","scryfallId":"be43fdd6-917e-4a49-a9b8-d1673b421dce"},{"index":733,"token":false,"name":"Duskshell Crawler","scryfallId":"1af03fc3-5eb6-404e-96d9-e291a1e11ec3"},{"index":734,"token":false,"name":"Aggressive Mammoth","scryfallId":"323f3c76-5e79-43e6-ae78-f555810edbc3"},{"index":735,"token":false,"name":"Brave the Elements","scryfallId":"46357985-9b59-4ad7-aa18-4c8c28fe8bb5"},{"index":736,"token":false,"name":"Lashknife Barrier","scryfallId":"29189f1b-8a60-46ca-8168-6da407c94e05"},{"index":737,"token":false,"name":"Golem-Skin Gauntlets","scryfallId":"ee198804-a247-46b9-be6e-71bbb5840401"},{"index":738,"token":false,"name":"Volcanic Island","scryfallId":"154ce456-38d2-4195-93b7-302e11c006e2"},{"index":740,"token":false,"name":"Shamanic Revelation","scryfallId":"c8f77d9d-5b34-4f44-9554-28b235a26710"},{"index":741,"token":false,"name":"Asphyxiate","scryfallId":"894f3f5f-586d-45e4-9af7-4de80e44dfae"},{"index":742,"token":false,"name":"Wrong Turn","scryfallId":"3b69687d-191a-4bca-b1f7-eea27847c1af"},{"index":743,"token":false,"name":"Gilded Goose","scryfallId":"d274723a-27f3-49ec-ade0-d0b5e0e87d84"},{"index":744,"token":false,"name":"Zhang Fei, Fierce Warrior","scryfallId":"6364eba6-6aba-4c18-b9f0-aead17064b48"},{"index":745,"token":false,"name":"Storm Entity","scryfallId":"6f6e88a5-0d1f-4587-b855-42ab5452ddc8"},{"index":746,"token":false,"name":"Dauthi Ghoul","scryfallId":"0a70778e-8171-4d97-b86c-d4d92b7e7f06"},{"index":747,"token":false,"name":"Sudden Demise","scryfallId":"7217afaa-00e1-45a7-bb7f-66a770487b77"},{"index":748,"token":false,"name":"Fire Bowman","scryfallId":"18acc721-e9ae-4ba4-b435-754e41fb541e"},{"index":749,"token":false,"name":"Giant Spider","scryfallId":"d9fefe43-144a-4f47-80ce-c627efed9ac6"},{"index":750,"token":false,"name":"Dihada's Ploy","scryfallId":"9091e8dc-b546-4b74-9dc9-aef55f60d13a"},{"index":751,"token":true,"name":"Myr Token (U, 2/1)","scryfallId":"656af066-f9b3-4c23-b6c4-3ff55776858f"},{"index":752,"token":false,"name":"Cataclysm","scryfallId":"024ae668-a1ae-4020-89c8-acbd8bd0a691"},{"index":753,"token":false,"name":"Hengegate Pathway // Mistgate Pathway","scryfallId":"b851c41b-ed73-4ee4-9063-544f97f35f67"},{"index":755,"token":false,"name":"Altar of Dementia","scryfallId":"c16b08f8-9c26-450d-ad97-b7734e4f5bc4"},{"index":756,"token":false,"name":"General Ferrous Rokiric","scryfallId":"600dca0f-5964-45e7-86df-f16a5b4a0106"},{"index":757,"token":false,"name":"Flames of the Firebrand","scryfallId":"aba659ce-b15c-4af9-bba1-0fb79b23f444"},{"index":759,"token":false,"name":"Drownyard Explorers","scryfallId":"3714713f-deb4-4b1c-8764-35287293ca18"},{"index":760,"token":false,"name":"Always Watching","scryfallId":"555451d8-52c2-448a-9015-40fcd874b381"},{"index":761,"token":false,"name":"Midnight Banshee","scryfallId":"df0ff253-001a-45bc-98ab-4713a813fb11"},{"index":762,"token":true,"name":"Wurm Token (Colorless, 3/3)","scryfallId":"ec840840-36d2-419e-9ed8-0635a225f0df"},{"index":764,"token":false,"name":"Vial Smasher the Fierce","scryfallId":"a4dc32ca-89c9-4d3a-8809-846c34ef3592"},{"index":766,"token":false,"name":"Magmaquake","scryfallId":"e34f0871-c044-47a9-8c5c-3bd4705e5dbc"},{"index":767,"token":false,"name":"Shield Sphere","scryfallId":"7a76a97e-a857-4593-ae7c-e393d8a868ac"},{"index":768,"token":false,"name":"Undiscovered Paradise","scryfallId":"81873b26-43c5-4f5d-8a35-6852e194e1f2"},{"index":769,"token":false,"name":"Phyrexian Revoker","scryfallId":"6982a82c-dd32-40d2-8dd2-ec92d0fc6c2d"},{"index":770,"token":true,"name":"Ability Punchcard","scryfallId":"09230a40-87b6-4427-8c4b-457fcdf5699d"},{"index":771,"token":false,"name":"Mage Hunters' Onslaught","scryfallId":"ed85140f-f0e0-4ac1-a67f-26d17ff95e31"},{"index":772,"token":false,"name":"Walking Archive","scryfallId":"c390e074-bd30-4564-a39a-176af7df79f4"},{"index":773,"token":false,"name":"Goblin War Drums","scryfallId":"2a0185f3-fbc0-44d7-b933-30627cda1bf9"},{"index":774,"token":false,"name":"Ghost-Lit Redeemer","scryfallId":"aa90c02d-3090-402e-b74b-fc0358953263"},{"index":775,"token":false,"name":"Traveler's Amulet","scryfallId":"a5b0afa7-e9f9-4751-af36-d85343fabc26"},{"index":776,"token":false,"name":"Ghostly Flicker","scryfallId":"485ab561-9c2a-4f99-9317-8726bcdae364"},{"index":777,"token":false,"name":"Shifting Wall","scryfallId":"49b7a950-bf79-46fa-8b29-b7856b38e0fd"},{"index":778,"token":false,"name":"Infernal Tribute","scryfallId":"569739b2-f212-4cc9-84db-1be17b3f90fb"},{"index":779,"token":false,"name":"Hekma Sentinels","scryfallId":"a0490cec-28db-459a-964e-e3a90878cbc6"},{"index":780,"token":false,"name":"Teferi, Master of Time","scryfallId":"dc5e64a4-c62a-4431-a893-e3b174d5b97e"},{"index":781,"token":false,"name":"Wrath of God","scryfallId":"0d317a92-8bc5-4d1a-a817-699724674122"},{"index":782,"token":false,"name":"Pharika's Mender","scryfallId":"5deaa491-d95b-481f-aa47-8e7219174cc5"},{"index":783,"token":false,"name":"Thopter Arrest","scryfallId":"a4e738cb-e4ea-41c2-99a1-55b6167eccb0"},{"index":784,"token":false,"name":"Umara Raptor","scryfallId":"6049cc80-1faa-48bf-897e-fefe5a8e7ab2"},{"index":785,"token":false,"name":"Serra Angel","scryfallId":"9d1d2060-8c4b-4115-ab31-e572ee61a0cc"},{"index":786,"token":false,"name":"Jade Monolith","scryfallId":"70a8f00d-e813-4cb7-8d09-1edae560f287"},{"index":787,"token":false,"name":"Prodigal Sorcerer","scryfallId":"17c0b205-075c-4aab-8666-227a2ed3853e"},{"index":788,"token":false,"name":"Stitchwing Skaab","scryfallId":"f84bb1ce-a8a0-4a29-9129-b1d7041fd01a"},{"index":789,"token":false,"name":"Sangromancer","scryfallId":"9cdebdfd-a29b-4482-ab83-012d5faba2e4"},{"index":790,"token":false,"name":"Eternal Thirst","scryfallId":"5bbc405d-0cfb-45c6-baa1-75845d82e713"},{"index":791,"token":false,"name":"Soul Burn","scryfallId":"359f6e42-3435-48e5-b1ee-6333c37994fa"},{"index":792,"token":false,"name":"Reckless Fireweaver","scryfallId":"8e166c5b-8991-4738-be78-caaac116b0ec"},{"index":793,"token":false,"name":"Repulse","scryfallId":"4dc7777b-6e9e-4889-91da-fb5283340fa1"},{"index":794,"token":false,"name":"Ichorclaw Myr","scryfallId":"faef8b8b-2c45-4fed-b6ba-a8ac49c66330"},{"index":795,"token":false,"name":"Revitalize","scryfallId":"a3bd4bce-8ab0-40b9-aad7-7d57a011bb0b"},{"index":796,"token":false,"name":"Safe Haven","scryfallId":"50e7bbf0-d220-42be-9b6b-5a9a1d8dcc29"},{"index":797,"token":false,"name":"Phyrexian Metamorph","scryfallId":"d6afeb07-ed44-4e15-99b6-436f8365326f"},{"index":798,"token":false,"name":"Cleansing Screech","scryfallId":"8d86191f-01b0-488d-8c5f-e639ca9b6fae"},{"index":800,"token":false,"name":"Wirewood Lodge","scryfallId":"15a92571-1409-40c3-84c3-da01d6f1b104"},{"index":801,"token":false,"name":"Pacifism","scryfallId":"783ccfbb-4063-4614-8135-11787227ce97"},{"index":802,"token":false,"name":"Cobra Trap","scryfallId":"a8954f5e-9904-426f-9b66-8cdf86438f6a"},{"index":803,"token":false,"name":"Vassal's Duty","scryfallId":"8ef25165-2458-4c00-8b7c-0ad6fd98e3af"},{"index":804,"token":false,"name":"Silver Myr","scryfallId":"b83a73a2-fedb-40bd-8e29-82a7abd6f211"},{"index":805,"token":false,"name":"Fireblast","scryfallId":"977ebfdf-591e-41ce-ab1d-150d0aca3946"},{"index":806,"token":false,"name":"Forced Worship","scryfallId":"e050701d-4609-470d-85ff-4b7638893c6a"},{"index":807,"token":false,"name":"Goblin Anarchomancer","scryfallId":"633a3423-501d-4b22-95a6-743233be521e"},{"index":808,"token":false,"name":"Empty the Warrens","scryfallId":"06462b57-1b0e-4c9c-9531-c14b9f2d5a3b"},{"index":809,"token":false,"name":"Goblin Chirurgeon","scryfallId":"982115b2-e1e7-4b2f-8eb6-a1633477d4a8"},{"index":811,"token":false,"name":"Ambition's Cost","scryfallId":"9d67d5a4-1a82-4d82-a509-d57460b88a56"},{"index":812,"token":false,"name":"Skyshroud Cutter","scryfallId":"a558c4f5-a716-4e46-9234-5f84f1bd57aa"},{"index":813,"token":false,"name":"Octopus Umbra","scryfallId":"85c3cd03-bcf7-452b-bf0c-ff24f06a4f8f"},{"index":814,"token":false,"name":"Thornglint Bridge","scryfallId":"9d483643-6a11-47f7-a0aa-190e0179525f"},{"index":816,"token":false,"name":"Coveted Peacock","scryfallId":"54db04dc-48a3-4aff-aa1b-a14821c04762"},{"index":817,"token":false,"name":"Dingus Egg","scryfallId":"a804f742-f7cf-427e-ad0a-742587328156"},{"index":818,"token":false,"name":"Generous Gift","scryfallId":"26296a96-bdca-405f-ab06-e280b42c4ab9"},{"index":819,"token":false,"name":"Crackling Perimeter","scryfallId":"3323c86c-73bd-4e23-9f80-54bf5c1dd0bc"},{"index":820,"token":false,"name":"Minions' Murmurs","scryfallId":"d6438a3b-6acb-4b49-8a46-9db80811d17c"},{"index":821,"token":false,"name":"Liliana's Elite","scryfallId":"abd4dbd9-982c-43cf-b14c-c3179427d5a1"},{"index":822,"token":false,"name":"Solemn Recruit","scryfallId":"f42e1e2e-6559-42c1-bab4-e2e868723b43"},{"index":823,"token":false,"name":"Giant Strength","scryfallId":"61cc0a4a-7810-42f6-a9c3-217828e41f0f"},{"index":824,"token":false,"name":"Hushbringer","scryfallId":"e3fab4f3-35da-43a6-98e0-8259acc5b817"},{"index":825,"token":false,"name":"Dragon's Hoard","scryfallId":"5b441fc8-bc89-47d4-8745-2525aeb6d98d"},{"index":826,"token":false,"name":"Knight Errant","scryfallId":"9c31b4b4-18fc-4a6e-8d74-fd5340964320"},{"index":827,"token":false,"name":"Jovial Evil","scryfallId":"c993c74c-a574-423b-81c8-96b0a7a6e529"},{"index":828,"token":false,"name":"Talara's Battalion","scryfallId":"b0d00ea9-1111-47c3-9722-4c68ce3e4d56"},{"index":829,"token":false,"name":"Perimeter Sergeant","scryfallId":"2a174587-d964-48b3-8f69-fa576c1b8bba"},{"index":830,"token":false,"name":"Life Goes On","scryfallId":"5f39c264-a9a5-46f3-bd67-01d93d69e457"},{"index":832,"token":false,"name":"Archon of Justice","scryfallId":"ab707e7f-8ab5-43f1-9428-6a17c1b672fa"},{"index":833,"token":false,"name":"Ethereal Ambush","scryfallId":"825d3f4d-eba3-4c45-8846-03b246e93f6c"},{"index":835,"token":false,"name":"Zedruu the Greathearted","scryfallId":"342ccc77-ba91-48fc-9b34-2e15b9ae9467"},{"index":836,"token":false,"name":"Dwynen, Gilt-Leaf Daen","scryfallId":"2eb0f12b-9199-440d-9b85-831a5aec5dae"},{"index":837,"token":false,"name":"Navigator's Ruin","scryfallId":"eb082e5e-770a-4c5a-8976-ee394ab73c86"},{"index":838,"token":false,"name":"Flight","scryfallId":"26e21fa8-4617-4cef-a70d-387e73dafc22"},{"index":839,"token":false,"name":"Clockwork Steed","scryfallId":"9b080587-d062-42ff-abc5-8e04a20faece"},{"index":840,"token":false,"name":"Memory Lapse","scryfallId":"bf9c4e40-ff50-4837-ae11-1670d637bcfb"},{"index":841,"token":false,"name":"Ransack the Lab","scryfallId":"b547513d-8b69-41cd-84c9-4b08b6426f1d"},{"index":842,"token":false,"name":"Howling Mine","scryfallId":"afe62264-058d-4337-a793-a66eb42551f7"},{"index":844,"token":false,"name":"Axebane Beast","scryfallId":"2f420b35-1f73-41c8-a15f-1aee4af0999c"},{"index":845,"token":false,"name":"Elixir of Immortality","scryfallId":"99bd4740-9b1f-40a6-a14d-2c0d642b848b"},{"index":846,"token":false,"name":"Wall of Frost","scryfallId":"17bc35a7-e38b-4c15-889a-d58c8b360315"},{"index":847,"token":false,"name":"Calculated Dismissal","scryfallId":"252c360d-eb30-417d-9c1d-dab58b6fa305"},{"index":848,"token":false,"name":"Myr Battlesphere","scryfallId":"88d33b63-9a49-4c67-9932-270997f6625b"},{"index":849,"token":false,"name":"Tel-Jilad Exile","scryfallId":"e3529277-8409-45fe-9f29-64354597e918"},{"index":850,"token":false,"name":"Lord Windgrace","scryfallId":"b49ae623-c7ae-4643-9bec-3cb505911309"},{"index":851,"token":false,"name":"Fetid Pools","scryfallId":"f1688f02-3d03-4e3b-a491-1266f8ab7efd"},{"index":852,"token":false,"name":"Deranged Hermit","scryfallId":"bf0e94c9-61c4-4cc0-b5ce-db62bc2660ee"},{"index":853,"token":false,"name":"Mondronen Shaman // Tovolar's Magehunter","scryfallId":"98fc475a-809d-4278-be03-86eab62b46ce"},{"index":854,"token":false,"name":"Worldslayer","scryfallId":"3cb1b869-3e2d-4447-a12d-e790883feeee"},{"index":855,"token":false,"name":"Robber Fly","scryfallId":"7d5cf073-2ba0-463e-bcd4-979ad18e28fc"},{"index":856,"token":false,"name":"Berserk","scryfallId":"2fcc1f3a-85da-4012-8b01-adf9b8e56c63"},{"index":857,"token":false,"name":"Maze of Ith","scryfallId":"78114f25-f40a-4e2e-bf89-29ea9b3500e2"},{"index":859,"token":false,"name":"Fire Elemental","scryfallId":"0261cd0f-e763-49b5-96ed-5e5767a3d8d7"},{"index":860,"token":false,"name":"Captivating Crew","scryfallId":"c76e66c1-dbe2-4346-b4b3-20e8386e7d76"},{"index":861,"token":false,"name":"Fateful Showdown","scryfallId":"ef58e615-76aa-46b0-b5e2-9cc2f23290ab"},{"index":863,"token":false,"name":"Prophet of the Peak","scryfallId":"58131bf2-2a9f-4b81-9eeb-810372f3896c"},{"index":864,"token":false,"name":"Timber Wolves","scryfallId":"d8f84fc8-69b4-4756-9634-4d6c17ec88a1"},{"index":865,"token":false,"name":"Nucklavee","scryfallId":"50f54b0a-b0e1-44f1-bb91-523cc9e1c298"},{"index":866,"token":false,"name":"Karn Liberated","scryfallId":"cd1deda0-c99d-4570-a5dd-f51eb5d12570"},{"index":867,"token":false,"name":"Ornithopter","scryfallId":"331a0a01-0c12-4999-9bd7-f26991e4dad5"},{"index":868,"token":false,"name":"Lord of Atlantis","scryfallId":"7eaad8e0-947f-47d9-b78f-b0f2a5a06906"},{"index":869,"token":false,"name":"Furnace Whelp","scryfallId":"6baab3d0-4b3b-4446-b7eb-decde55628bd"},{"index":870,"token":false,"name":"Ich-Tekik, Salvage Splicer","scryfallId":"f77faeb0-f0f3-4934-bb39-808db8002efd"},{"index":871,"token":false,"name":"Coral Helm","scryfallId":"274e3a79-d7e5-46e2-bd9f-209e67294f82"},{"index":872,"token":false,"name":"Hibernation","scryfallId":"a33661f0-7dde-4b08-87da-1eeb723ddf9f"},{"index":873,"token":false,"name":"Karmic Guide","scryfallId":"1dab6c67-1fbb-44b7-a255-15ceaf8352cf"},{"index":874,"token":false,"name":"Deadbridge Goliath","scryfallId":"6ad03e99-25d3-4a09-819b-9192dfd8c9d2"},{"index":875,"token":false,"name":"Time Stop","scryfallId":"f968c5e9-12a8-4542-90b4-84e0238fa375"},{"index":876,"token":false,"name":"Counterspell","scryfallId":"dacdd380-71cf-4832-bd02-3697501325f3"},{"index":877,"token":false,"name":"Thought Vessel","scryfallId":"ac9da194-02e3-4f53-9e79-b94cc172fd3b"},{"index":878,"token":false,"name":"Dirgur Nemesis","scryfallId":"54c388de-c2c9-4975-9eac-86a8030a9884"},{"index":879,"token":false,"name":"Geist Trappers","scryfallId":"26f00a18-0ff7-42e4-be16-aa34fe27093b"},{"index":880,"token":false,"name":"Puppeteer Clique","scryfallId":"c348dba8-5ca1-4d5b-a374-6dc2114d1c58"},{"index":881,"token":false,"name":"Dualcaster Mage","scryfallId":"32d294e8-ed96-4584-b4f2-1b03ae6d1314"},{"index":882,"token":false,"name":"Omnath, Locus of the Roil","scryfallId":"b5f6005e-9bc6-47c7-b376-7e3964d2598b"},{"index":883,"token":false,"name":"Enlightened Ascetic","scryfallId":"76549fc3-5798-4c70-bb70-802b6f597eb7"},{"index":884,"token":false,"name":"Ethersworn Adjudicator","scryfallId":"a35a056c-1e38-416b-bf01-2a1762b08020"},{"index":885,"token":false,"name":"Sowing Salt","scryfallId":"de2f7251-f71a-47d2-a779-c898d94e807c"},{"index":886,"token":false,"name":"Air Elemental","scryfallId":"22905294-4ba6-4567-a21f-f53b8317acda"},{"index":887,"token":false,"name":"Baleful Stare","scryfallId":"118b1df0-1838-40df-af62-08a73c3d8033"},{"index":888,"token":false,"name":"Temur Banner","scryfallId":"9990bdff-c27a-447f-b530-d8b7614fe9a0"},{"index":889,"token":false,"name":"Fungal Reaches","scryfallId":"1a3580d6-345a-46ba-a327-0e924989d6b1"},{"index":890,"token":false,"name":"Shalai, Voice of Plenty","scryfallId":"d439c406-5822-47fe-96d2-6fb9ed828aea"},{"index":891,"token":false,"name":"Lotus Cobra","scryfallId":"577ad25e-75bf-43c4-b0d9-112ce3116b9f"},{"index":892,"token":false,"name":"Teferi's Puzzle Box","scryfallId":"1888b0f5-2c18-4a00-9a94-aaf7108f3c85"},{"index":893,"token":false,"name":"Martyrs' Tomb","scryfallId":"a906a775-7c2d-47b7-a20e-a325dd28d0bd"},{"index":894,"token":false,"name":"Glory Seeker","scryfallId":"efe29efb-a5fb-4d51-b71c-8c8686613039"},{"index":895,"token":false,"name":"Rime Transfusion","scryfallId":"e18318fe-b429-459f-9b70-d444b48b8dc7"},{"index":896,"token":false,"name":"Quest for Pure Flame","scryfallId":"7b43ac5a-21b9-4abe-b8be-86b9056ad70d"},{"index":899,"token":false,"name":"Tunnel","scryfallId":"b21ebc9f-a93e-4d18-b3e8-8459e3abbf31"},{"index":900,"token":true,"name":"Archaeology","scryfallId":"6c0966d2-3be6-499f-9c35-b7201f450e9b"},{"index":901,"token":false,"name":"Chandra, Pyromaster","scryfallId":"f08a4b69-bcc5-4699-a126-2c685f5e77ed"},{"index":904,"token":false,"name":"Tumble Magnet","scryfallId":"74baa632-d046-401a-9172-1ab6284240bc"},{"index":905,"token":false,"name":"Night Soil","scryfallId":"52a0eca1-f936-4f5a-820b-fa12542c593d"},{"index":906,"token":false,"name":"Seekers' Squire","scryfallId":"e37a6802-7a1d-4d37-bd65-f3e3e5127aca"},{"index":907,"token":false,"name":"Savannah Lions","scryfallId":"69da8664-c9b9-4f9c-b1c4-099990637646"},{"index":908,"token":false,"name":"Imperious Perfect","scryfallId":"02a828f1-652b-48d5-851e-6f7cbe549161"},{"index":909,"token":false,"name":"New Benalia","scryfallId":"efb003a9-d6de-4d38-8431-c37346d70aa8"},{"index":910,"token":false,"name":"Boneyard Parley","scryfallId":"04a82af7-309d-46f5-b3ec-ea301dfa042f"},{"index":912,"token":false,"name":"Dowsing Dagger // Lost Vale","scryfallId":"514d53be-6ade-4f73-a844-e9ae2dafd6ce"},{"index":913,"token":false,"name":"War Cadence","scryfallId":"e030d2eb-70c5-4ff7-8f03-ad5495cf9c69"},{"index":914,"token":false,"name":"Glyph of Delusion","scryfallId":"ee39da13-4b8a-4796-a7c2-aaa11992d573"},{"index":915,"token":false,"name":"Safe Passage","scryfallId":"3d61671e-3407-4553-8c33-32d23a015f9f"},{"index":916,"token":false,"name":"Karplusan Forest","scryfallId":"eb12ce05-cfc9-4628-a2a3-f207fd9b149a"},{"index":917,"token":false,"name":"Shimatsu the Bloodcloaked","scryfallId":"71de0e2c-61ca-496e-8990-ed0e6f6521a6"},{"index":918,"token":false,"name":"Condemn","scryfallId":"97eb5d19-8e8f-4102-9faa-87f01d81491f"},{"index":919,"token":false,"name":"Rush of Blood","scryfallId":"a2884824-d138-47f2-913b-32cd475e9584"},{"index":921,"token":false,"name":"Phyrexia's Core","scryfallId":"db36c8e7-0c13-4f0d-9947-68cb0e9ea239"},{"index":922,"token":true,"name":"Nightmare Token (B/U, 2/3)","scryfallId":"c528581f-f671-45ae-8d7a-ae26a4e62ceb"},{"index":923,"token":false,"name":"Boreas Charger","scryfallId":"d68003e1-11ea-417f-89d0-39456bf47b34"},{"index":924,"token":false,"name":"Wind Drake","scryfallId":"829f0bc4-62a1-4abb-8393-a5aaa408a18f"},{"index":925,"token":false,"name":"Vertigo Spawn","scryfallId":"a1bdfb7d-029d-4a70-8ae3-ef9a27e729c3"},{"index":926,"token":false,"name":"Drill-Skimmer","scryfallId":"3b60dc6a-3b38-4dde-9dd4-aa49a53f29ae"},{"index":927,"token":false,"name":"Grief","scryfallId":"ea859431-c1bf-4d07-9845-430bc217cb91"},{"index":928,"token":false,"name":"Chain of Plasma","scryfallId":"f94aa774-9036-4016-8880-4bde2710cb90"},{"index":929,"token":false,"name":"Beacon of Destiny","scryfallId":"30b1cad7-4e96-4ebe-8c99-4ed9217becf3"},{"index":930,"token":false,"name":"Lord of the Pit","scryfallId":"b53cde03-6f3b-443c-9f55-1f8de24c1722"},{"index":931,"token":false,"name":"Bad Moon","scryfallId":"bf812f48-633c-46ab-b0c3-4819ab1b4e49"},{"index":933,"token":false,"name":"Tome Scour","scryfallId":"6918d624-044b-4a32-8c91-7d17f58fd18c"},{"index":934,"token":false,"name":"Sengir Vampire","scryfallId":"5fbd5fbb-f689-4ff0-8f23-17e4cb0925a2"},{"index":935,"token":false,"name":"Muddle the Mixture","scryfallId":"4cc785b0-0a77-4b02-b0b4-2bda2fc621cc"},{"index":936,"token":false,"name":"Goblin Striker","scryfallId":"f7654d8a-7013-4311-b29e-b55aaa1bf502"},{"index":937,"token":false,"name":"Mission Briefing","scryfallId":"9d7829a5-b85f-4395-ab63-c4e8388c672e"},{"index":938,"token":false,"name":"Dark Favor","scryfallId":"5aae919b-7da6-42b1-84b4-fbc2971dad1e"},{"index":939,"token":false,"name":"Ball Lightning","scryfallId":"2b70b374-94b6-48d5-a1d7-04d012049c22"},{"index":940,"token":false,"name":"Urban Evolution","scryfallId":"6167aa4f-666d-4908-b2e5-a30a131d2727"},{"index":941,"token":false,"name":"Junún Efreet","scryfallId":"398a2b0f-0b91-408c-8083-3bc89873b69f"},{"index":942,"token":false,"name":"Atog","scryfallId":"f123fe6a-99ca-48c1-9a7a-ae905c10108a"},{"index":943,"token":false,"name":"Fireball","scryfallId":"51a242c2-58bf-457b-b5ad-83e85b08ddd1"},{"index":944,"token":false,"name":"Spawning Pool","scryfallId":"43ffec42-57f7-4592-99ab-6284d59829a1"},{"index":945,"token":false,"name":"Bonders' Enclave","scryfallId":"b7a26d0b-cf19-4c3e-bc81-6ffdc21757fa"},{"index":946,"token":false,"name":"Goblin Vandal","scryfallId":"b7ad3b81-f706-4b33-b1ec-7600182a5232"},{"index":947,"token":false,"name":"Pendelhaven","scryfallId":"a98eb95d-93e7-4c42-aa9a-83d028f6b877"},{"index":948,"token":false,"name":"Blightning","scryfallId":"7a1b4c07-588a-444f-9677-3eb1493b5394"},{"index":950,"token":false,"name":"Winter Blast","scryfallId":"3d4f72de-51e9-45c2-853b-1b6668416417"},{"index":951,"token":false,"name":"Reckless Abandon","scryfallId":"4327fd85-eb89-4707-80f8-bdf41179eda5"},{"index":953,"token":false,"name":"Rise and Shine","scryfallId":"f9011c3a-c9db-4e92-89d5-29f139017573"},{"index":954,"token":false,"name":"Ludevic's Test Subject // Ludevic's Abomination","scryfallId":"340b660c-9aa1-4bd2-8c6f-d9af7fee5f4a"},{"index":955,"token":false,"name":"Cloudhoof Kirin","scryfallId":"42aa0d70-8d66-47aa-9228-25dcdb4e7dad"},{"index":956,"token":false,"name":"Spell Snuff","scryfallId":"efadce19-07f4-47af-abc0-a436bafcdd65"},{"index":957,"token":false,"name":"Prosperity","scryfallId":"269bb4fc-9d8f-42cc-8f71-6a658e41533c"},{"index":958,"token":false,"name":"Nimbus Swimmer","scryfallId":"d691cd3b-afe5-4f28-95a9-125475515126"},{"index":959,"token":false,"name":"Kederekt Creeper","scryfallId":"701498e5-1d4d-42f4-9dd0-5d4cf78f0e68"},{"index":960,"token":false,"name":"Security Detail","scryfallId":"5b89d34b-1a67-4f5c-a731-54b56c5233ff"},{"index":961,"token":false,"name":"Kavu Predator","scryfallId":"965048e6-a693-4858-a244-3b9ee10bfb56"},{"index":962,"token":false,"name":"Gigantosaurus","scryfallId":"5873ee84-1fb8-401b-8c4b-1b4c28e9dd6c"},{"index":963,"token":false,"name":"Mystic Denial","scryfallId":"52d60f29-6da0-4ce6-9c92-96f313007271"},{"index":964,"token":false,"name":"Smite the Monstrous","scryfallId":"1405bb2e-2204-43ab-82a3-5d0c8537325a"},{"index":966,"token":false,"name":"Carrion Rats","scryfallId":"583bce65-3d2e-4f82-ba76-ad004533ac79"},{"index":967,"token":false,"name":"Caustic Tar","scryfallId":"81ddf81d-1746-41a7-951c-0bd68954505d"},{"index":968,"token":false,"name":"Dampening Pulse","scryfallId":"4a4393f6-54d7-4963-a3c0-b3a083c2440c"},{"index":969,"token":false,"name":"Oracle of Mul Daya","scryfallId":"7f89a173-0b2f-4a6a-b706-9aed8dbcabec"},{"index":972,"token":false,"name":"Penumbra Bobcat","scryfallId":"496cce86-ff61-4d24-8d37-8c27acaff21c"},{"index":973,"token":false,"name":"Prime Speaker Zegana","scryfallId":"7b844055-7581-4fbf-a0c9-6c4e9328a83e"},{"index":974,"token":false,"name":"Ugin, the Spirit Dragon","scryfallId":"9c017fa9-7021-417a-9c2e-3df409644fcf"},{"index":975,"token":false,"name":"Sun Titan","scryfallId":"dfbf6204-f08e-4bdc-904d-d617dabdfdd8"},{"index":976,"token":false,"name":"Warmind Infantry","scryfallId":"d8a5f801-9e55-4e14-85b0-5719521cd9d6"},{"index":977,"token":false,"name":"Knight of the White Orchid","scryfallId":"00aef0cf-8b96-4120-9ef4-16203b7c6b9b"},{"index":978,"token":false,"name":"Stingscourger","scryfallId":"d6bcc2bc-75a7-4b01-856b-4e0b8703e302"},{"index":979,"token":false,"name":"Miraculous Recovery","scryfallId":"73bf62f3-2221-4d37-bd14-544fdb296f24"},{"index":980,"token":false,"name":"Psychic Symbiont","scryfallId":"3188e533-9a72-4a02-b169-a918f7c095ba"},{"index":981,"token":false,"name":"Ghen, Arcanum Weaver","scryfallId":"4b335496-05d2-40f5-a52c-10029f7fa008"},{"index":982,"token":false,"name":"Elsha of the Infinite","scryfallId":"3b977c0b-07a1-4d16-9fdd-fc0563e0b68e"},{"index":983,"token":false,"name":"Ugin's Construct","scryfallId":"9e509ec4-ed77-4010-beb0-d0df0f620d6f"},{"index":984,"token":false,"name":"Armageddon","scryfallId":"605e9a62-53e4-4771-9730-56c78237004a"},{"index":985,"token":false,"name":"Oran-Rief, the Vastwood","scryfallId":"7c2c00cd-4330-4760-bf42-fa18c96da813"},{"index":986,"token":false,"name":"Blight","scryfallId":"099a0a13-6b89-475f-aad1-5c5c562861a3"},{"index":987,"token":false,"name":"Seal of Cleansing","scryfallId":"119d05de-5043-4fc3-ade4-78816cb75420"},{"index":988,"token":false,"name":"Deadwood Treefolk","scryfallId":"69983244-a9c6-4025-91c6-a4742cb1db1e"},{"index":989,"token":false,"name":"Last Rites","scryfallId":"dea9c89a-f48a-4c41-859f-771164763f46"},{"index":991,"token":false,"name":"Crucible of Fire","scryfallId":"d7a6f4dd-29c9-4084-a622-098b197a6eb7"},{"index":992,"token":false,"name":"Just Fate","scryfallId":"05012188-8c66-4001-84c7-d4a99dcd9cfa"},{"index":993,"token":false,"name":"Kalemne, Disciple of Iroas","scryfallId":"3c718940-dc07-4449-ba35-4029f366c3eb"},{"index":994,"token":false,"name":"Phantasmal Forces","scryfallId":"5223ed74-6b6d-49f4-b370-1d618efb356b"},{"index":995,"token":false,"name":"Opt","scryfallId":"6d9e1c48-c0a1-44d1-be82-f1c8371f51d5"},{"index":996,"token":false,"name":"Dragonmaster Outcast","scryfallId":"7417983e-3048-421d-b4cd-7bcc79b0f064"},{"index":997,"token":false,"name":"Hunting Cheetah","scryfallId":"99030058-283a-4888-8bfe-1bfab946fc98"},{"index":999,"token":false,"name":"Ajani's Chosen","scryfallId":"83ec7a9d-d932-4edc-857f-0fae060d1480"},{"index":1001,"token":false,"name":"Gravelgill Duo","scryfallId":"f2fd4959-bfff-46dc-b568-b6d69ef8eac9"},{"index":1002,"token":false,"name":"Ayula, Queen Among Bears","scryfallId":"ad7eac9d-31e3-480e-92fa-58458d6f83b2"},{"index":1004,"token":false,"name":"Remove","scryfallId":"adb08549-8ff8-410f-b817-0255abaf8b1e"},{"index":1005,"token":false,"name":"Stonecoil Serpent","scryfallId":"a47f84f5-56d2-45f7-acb6-7e0fcab31ee1"},{"index":1006,"token":false,"name":"Jinx","scryfallId":"f81fca41-2315-4d12-b05c-d921a4c3c19e"},{"index":1008,"token":false,"name":"Drift of the Dead","scryfallId":"2d96224a-178d-4d41-bc6a-b5ccfd27ed2f"},{"index":1009,"token":false,"name":"Rishadan Dockhand","scryfallId":"97f6f1da-ddef-44d0-af1b-e0c4024d9985"},{"index":1010,"token":false,"name":"Council of the Absolute","scryfallId":"da18a6a5-0042-40ae-bd33-a6d5a65a9944"},{"index":1011,"token":false,"name":"Angelic Blessing","scryfallId":"25d409ef-9635-4ebe-944f-03e371bc40f0"},{"index":1012,"token":false,"name":"Rhystic Study","scryfallId":"c6f8ca8d-f96f-4c1e-b577-1532a64324d2"},{"index":1013,"token":false,"name":"High Tide","scryfallId":"e4bfe5d1-0914-4c0b-b851-598d0850dc01"},{"index":1014,"token":false,"name":"Intrepid Hero","scryfallId":"49430d37-03af-4088-a92b-9e0ff3defe29"},{"index":1015,"token":false,"name":"Balduvian Bears","scryfallId":"662dc886-ce6b-4db1-a806-cc0d4fc504f6"},{"index":1016,"token":false,"name":"Shipbreaker Kraken","scryfallId":"9cba4eeb-5342-4430-898a-d41ddb59ad2c"},{"index":1017,"token":false,"name":"Tangleroot","scryfallId":"87ff2c28-770b-49cb-be10-35429233e048"},{"index":1019,"token":false,"name":"Final Strike","scryfallId":"ecdfcb03-2f77-4f54-af62-3012cd3efd4f"},{"index":1020,"token":false,"name":"Squad Commander","scryfallId":"c2ce186d-c9cd-41e9-bac2-ad9d36c4939f"},{"index":1021,"token":false,"name":"Fountain of Renewal","scryfallId":"6f730cc5-828a-4015-a33b-a6c86a50e477"},{"index":1022,"token":false,"name":"Shimmer Myr","scryfallId":"478c1a5b-237b-4ecb-be73-3c6dafd5ae53"},{"index":1023,"token":false,"name":"Deep-Sea Kraken","scryfallId":"f08d001b-de70-4f9f-8a3a-f16327ddddc0"},{"index":1024,"token":true,"name":"Wurm Token (G, 5/5)","scryfallId":"3fd53493-ac85-4dd0-b1db-0ae0130ea2d4"},{"index":1025,"token":false,"name":"Temple of Malady","scryfallId":"2ed1189f-427d-43d0-86af-20daec4143ef"},{"index":1026,"token":false,"name":"Alabaster Potion","scryfallId":"2806c7f6-8fdd-4e65-9c71-f2e8b0cdede2"},{"index":1028,"token":false,"name":"Harvest Gwyllion","scryfallId":"1a0491d1-343d-453e-aa52-a3d3daa1478e"},{"index":1029,"token":false,"name":"The Eldest Reborn","scryfallId":"c8318f40-ecd5-429e-8fe2-febf31f64841"},{"index":1030,"token":false,"name":"Jubilant Skybonder","scryfallId":"7f8f2d69-fba9-40e5-8ef7-75e14ef4070a"},{"index":1031,"token":false,"name":"Crush Underfoot","scryfallId":"756025a8-1096-4e7c-bbfe-6237e4a76216"},{"index":1032,"token":false,"name":"Lyev Decree","scryfallId":"773cf2aa-4337-4d14-8a8e-ff8b1fdec1b5"},{"index":1034,"token":false,"name":"Quasiduplicate","scryfallId":"766f72ce-ece9-4f26-903a-ad699fcec0b5"},{"index":1035,"token":false,"name":"Hurloon Minotaur","scryfallId":"78a9088f-8755-47cb-aa93-51d992ccab90"},{"index":1037,"token":false,"name":"Subtlety","scryfallId":"6ade923f-f064-4b5a-a6c0-348ca3e0dbed"},{"index":1038,"token":false,"name":"Viashino Grappler","scryfallId":"4a94aeb4-349c-4394-848d-c1c9133856e2"},{"index":1039,"token":false,"name":"Aetherstorm Roc","scryfallId":"f50355f1-6998-4f99-ba08-5b596868fceb"},{"index":1040,"token":false,"name":"Kolaghan Stormsinger","scryfallId":"8b6723f5-a7a9-425d-b4b0-f380da578ef8"},{"index":1042,"token":false,"name":"Plague Beetle","scryfallId":"c3a30a03-97dc-470e-b6d5-0bd7205a26ed"},{"index":1043,"token":false,"name":"Karn's Bastion","scryfallId":"6212aa6f-ee66-43c5-9982-1dda3e814a36"},{"index":1044,"token":false,"name":"Tel-Jilad Justice","scryfallId":"99fefa37-c876-4039-8cc4-4b2138181a1d"},{"index":1045,"token":false,"name":"Caravan Escort","scryfallId":"8452b0b7-8157-4a3f-8bef-a34e322b9463"},{"index":1046,"token":false,"name":"Grave Titan","scryfallId":"5c70da33-ce5d-4b8b-9c1d-9a356a7e196f"},{"index":1047,"token":false,"name":"Mimic Vat","scryfallId":"d10802a6-f6dc-4b05-9c07-00a71891c608"},{"index":1048,"token":false,"name":"Soul-Strike Technique","scryfallId":"34ba18f5-b894-47db-b49c-f2c4368ab769"},{"index":1049,"token":false,"name":"Loyal Retainers","scryfallId":"e963f7f7-6c50-461f-a71a-9a02588e79c6"},{"index":1050,"token":false,"name":"Kavu Monarch","scryfallId":"ea63dfd5-d8d7-45b8-8219-1cc2b3de5666"},{"index":1052,"token":false,"name":"Erratic Cyclops","scryfallId":"48dae537-ff11-438f-8367-46121a88f60f"},{"index":1054,"token":false,"name":"Wild Mongrel","scryfallId":"c23ecff2-1bee-4992-9548-99a69e6374fa"},{"index":1055,"token":false,"name":"Tuskguard Captain","scryfallId":"b341cc65-d316-41bb-95b8-294afa019a71"},{"index":1056,"token":true,"name":"Kor Warrior Token (W, 1/1)","scryfallId":"13412797-f831-49fe-adf3-369cdfacdbd5"},{"index":1057,"token":false,"name":"Risen Executioner","scryfallId":"95ff5e62-b73e-4b85-b65f-5226e75c7f97"},{"index":1058,"token":false,"name":"Naya Panorama","scryfallId":"4ba615a5-ad3a-4ad1-ab5f-69d7a3e4cf34"},{"index":1059,"token":false,"name":"Sulfurous Blast","scryfallId":"320154e9-01f1-44e6-b5b2-a2613b97d8d6"},{"index":1060,"token":false,"name":"Llanowar Visionary","scryfallId":"d6e23afa-7e08-4049-baf0-d4d0134ba2c8"},{"index":1061,"token":false,"name":"Clockwork Hydra","scryfallId":"54522c50-5333-47ac-ba3e-d87c599404c4"},{"index":1062,"token":false,"name":"Brindle Shoat","scryfallId":"318a41e3-1c5a-467e-9ffb-e6a5f817f8fe"},{"index":1063,"token":false,"name":"Dark Deal","scryfallId":"69dfaafe-2fbd-4f2f-913d-ea64e4ce44cd"},{"index":1064,"token":false,"name":"Esika, God of the Tree // The Prismatic Bridge","scryfallId":"ced8571a-24e1-45be-8698-3314b663940a"},{"index":1065,"token":false,"name":"Hydra Omnivore","scryfallId":"c34b4335-5cd0-4c9d-979e-a4b99b6576a1"},{"index":1066,"token":false,"name":"In Garruk's Wake","scryfallId":"19d774ac-394f-4c35-90d0-b94a8236773c"},{"index":1067,"token":false,"name":"Lat-Nam's Legacy","scryfallId":"aaac5b37-20a7-4dae-b0f7-04f5cb1e1532"},{"index":1068,"token":false,"name":"Ceaseless Searblades","scryfallId":"a7e103a3-555c-4b68-9768-42637bfd2478"},{"index":1069,"token":false,"name":"Knight of New Benalia","scryfallId":"88c50c4b-a2c8-4cdc-a171-aa3ff9ef107f"},{"index":1070,"token":false,"name":"Snow-Covered Plains","scryfallId":"b1e3a010-dae3-41b6-8dd8-e31d14c3ac4a"},{"index":1071,"token":true,"name":"Insect Token (G, 1/1)","scryfallId":"e101a5b1-614e-43a0-9e7e-de5a248e2e43"},{"index":1072,"token":false,"name":"Mythos of Illuna","scryfallId":"4dd48247-78c2-4329-8789-215f3d2d92dd"},{"index":1073,"token":false,"name":"Struggle // Survive","scryfallId":"80752994-d83f-4862-8c3b-3348178dbf52"},{"index":1075,"token":false,"name":"Slum Reaper","scryfallId":"6f0fea13-63cf-4574-8752-3c357eee4524"},{"index":1076,"token":false,"name":"Control Magic","scryfallId":"84992800-9bad-4598-afd4-f1e59d2e0956"},{"index":1077,"token":false,"name":"Scheming Symmetry","scryfallId":"01acc50b-856d-442d-9880-1a892b40643b"},{"index":1078,"token":false,"name":"Cloud Pirates","scryfallId":"9f7386c6-d17a-4c7d-884d-2471b87d8b8e"},{"index":1080,"token":false,"name":"Protomatter Powder","scryfallId":"273e2198-5549-4e82-8580-8769284d729d"},{"index":1081,"token":false,"name":"Goblin Commando","scryfallId":"fc7da4a2-697c-41fa-842d-793547ea5881"},{"index":1082,"token":false,"name":"Planar Cleansing","scryfallId":"99873316-4872-4500-a225-cf483e1ebaa9"},{"index":1083,"token":false,"name":"Cosi's Ravager","scryfallId":"cab3f6db-862f-4d85-9879-6f1b74e67a6a"},{"index":1084,"token":false,"name":"Gnaw to the Bone","scryfallId":"416148c8-13d3-46d3-ac93-6eb7cbab2881"},{"index":1086,"token":false,"name":"An-Havva Constable","scryfallId":"42c5a793-a777-44f9-a977-d16d26d3f852"},{"index":1087,"token":false,"name":"Pentarch Ward","scryfallId":"1c57549e-ea1a-435e-abcb-441583333071"},{"index":1088,"token":false,"name":"Cryptic Command","scryfallId":"81fe9eba-e7b0-46d6-a687-cfe911730014"},{"index":1089,"token":false,"name":"Uktabi Orangutan","scryfallId":"101c7d58-43cc-4ebd-87f1-2016fbff56dd"},{"index":1090,"token":false,"name":"Cruel Ultimatum","scryfallId":"73430a6c-7196-4f6c-91d6-50fcc8b0eedb"},{"index":1091,"token":false,"name":"Hanweir Lancer","scryfallId":"660392ed-b693-403f-9e19-cd214e65604b"},{"index":1092,"token":false,"name":"Celestial Prism","scryfallId":"a5003652-0b0c-4d46-b0d6-4be9032019b9"},{"index":1093,"token":false,"name":"Soratami Cloud Chariot","scryfallId":"25e6129a-fa5c-4e27-a4d4-cbde7392164b"},{"index":1094,"token":false,"name":"Curious Obsession","scryfallId":"04cf3030-dc92-45ab-9c26-f2e6aef67e56"},{"index":1095,"token":false,"name":"Conundrum Sphinx","scryfallId":"2905cea6-77cb-4d9b-93f4-e22211af25e1"},{"index":1096,"token":false,"name":"Ornithopter of Paradise","scryfallId":"025b0f0f-daf6-4071-82e7-39c015447ce4"},{"index":1098,"token":false,"name":"Puppeteer","scryfallId":"e6c74ee8-eee9-4652-8aac-73c10764b6a6"},{"index":1099,"token":false,"name":"Archangel","scryfallId":"e40d5c20-c599-4aa0-b214-48df40236b12"},{"index":1100,"token":false,"name":"Shadow Slice","scryfallId":"0497fbf4-cf09-4028-af16-349ed12ca360"},{"index":1101,"token":false,"name":"Urza's Power Plant","scryfallId":"e237d921-6d84-402e-b5e3-6bbdb3028f57"},{"index":1102,"token":false,"name":"Holy Armor","scryfallId":"b829b270-9af6-4105-bf70-2c15222cbdee"},{"index":1103,"token":false,"name":"Army of the Damned","scryfallId":"9aae1c1b-96f0-4529-995d-a53874a74c75"},{"index":1104,"token":false,"name":"Karn, Scion of Urza","scryfallId":"652ed9e7-b188-4903-b6a5-227dd66bcb6f"},{"index":1105,"token":false,"name":"Vastwood Gorger","scryfallId":"cdd9d448-ebd5-4e01-af88-e755833c2451"},{"index":1106,"token":false,"name":"Benalish Hero","scryfallId":"64795574-4984-473a-b47c-afa4fc43dd49"},{"index":1107,"token":false,"name":"Heavy Arbalest","scryfallId":"813fae24-ff38-45e8-8ab9-d539d4494435"},{"index":1108,"token":false,"name":"From the Ashes","scryfallId":"4529a3d2-e4e6-4cca-bcea-16b51f69bbec"},{"index":1110,"token":false,"name":"Concordant Crossroads","scryfallId":"4448d38f-d482-4cea-8f0f-1b482fc1794f"},{"index":1111,"token":false,"name":"Bubble Matrix","scryfallId":"0ca9c239-84ff-4527-aa23-bdb11856744c"},{"index":1112,"token":false,"name":"Angelic Guardian","scryfallId":"c6cb2bba-a745-492c-948f-9f8af05a68a4"},{"index":1113,"token":false,"name":"Ogre Geargrabber","scryfallId":"f0f6e2c3-0e0d-47ff-9d92-afc86a8c8aac"},{"index":1115,"token":false,"name":"Urza's Ruinous Blast","scryfallId":"d4ccd7ff-525a-485f-8c29-17a3a963f4ad"},{"index":1116,"token":false,"name":"Raging Goblin","scryfallId":"b47a96df-dce7-495b-acc0-5551641f5a57"},{"index":1117,"token":false,"name":"Alaborn Grenadier","scryfallId":"153b7197-57a7-4e38-bd4a-4550b9d22dd8"},{"index":1118,"token":false,"name":"Sigarda's Aid","scryfallId":"7fc32f1d-dee7-4f71-a652-26a006e6020a"},{"index":1119,"token":false,"name":"Gerrard's Verdict","scryfallId":"583740c0-68cf-4205-b682-2f97c0880d42"},{"index":1120,"token":false,"name":"Rebuke","scryfallId":"267185ac-a176-423e-a7f8-ee966d1d9a1e"},{"index":1121,"token":false,"name":"Helm of Chatzuk","scryfallId":"2ffc6b21-1926-42ff-b330-35017b36836e"},{"index":1122,"token":false,"name":"Volcanic Rush","scryfallId":"7b808883-f630-4070-ab7e-d347e26a9564"},{"index":1123,"token":false,"name":"Wurmcalling","scryfallId":"85402aef-3fb1-4e78-9103-e2e47e5f3c65"},{"index":1124,"token":false,"name":"Tolarian Serpent","scryfallId":"9236a857-c4ca-4de2-a4a2-e0914d16b54b"},{"index":1125,"token":false,"name":"Mystic Monastery","scryfallId":"35978c6a-6d36-452a-a3c5-cf4f3a11263f"},{"index":1126,"token":false,"name":"Nyxborn Marauder","scryfallId":"fd2a923a-1f9c-4a29-9c6b-344ae4d5ae8f"},{"index":1127,"token":false,"name":"Fiery Gambit","scryfallId":"6e2f138d-a39d-4bff-b334-9f556311881b"},{"index":1128,"token":false,"name":"Jhoira's Familiar","scryfallId":"3718761f-feb1-46c4-aaa3-7e07a3fa72fa"},{"index":1129,"token":false,"name":"Unclaimed Territory","scryfallId":"b96a5b3a-ee54-4864-a84c-385a97b8cb7b"},{"index":1131,"token":false,"name":"Glory-Bound Initiate","scryfallId":"756a4d03-d452-4b86-bd70-eb10739a8888"},{"index":1132,"token":false,"name":"Compulsive Research","scryfallId":"d5987001-abe9-4418-956e-3a360483cab7"},{"index":1133,"token":false,"name":"Elite Vanguard","scryfallId":"6bda0b4b-ab5a-4d91-9dd1-7a5a145b67f5"},{"index":1134,"token":false,"name":"Guardians' Pledge","scryfallId":"e7e6105c-8633-46f7-a7ca-2a5c36c6d548"},{"index":1135,"token":false,"name":"Drannith Magistrate","scryfallId":"98b0a4a8-9319-451b-9b79-b0bca7a41e91"},{"index":1136,"token":false,"name":"Twilight Prophet","scryfallId":"974e0e45-4820-4e8d-b397-15eb09628e10"},{"index":1137,"token":false,"name":"Cho-Arrim Bruiser","scryfallId":"26e98f06-ad8d-4a93-8ae6-3da42b63b5b5"},{"index":1138,"token":false,"name":"Devastation","scryfallId":"7d53e999-ffd4-4829-b999-384664ce5a96"},{"index":1140,"token":false,"name":"Nantuko Husk","scryfallId":"a5888a9e-4e72-4016-9629-68edcf174415"},{"index":1142,"token":false,"name":"Blossoming Sands","scryfallId":"828044d6-0f53-4caf-a581-d71919df4175"},{"index":1143,"token":false,"name":"Relic Putrescence","scryfallId":"ca940b4e-6f5e-4492-b6e0-dbf619eddadd"},{"index":1144,"token":false,"name":"Firebrand Ranger","scryfallId":"ee05211e-cf08-4dea-9740-ed06f8682153"},{"index":1145,"token":false,"name":"Murmurs from Beyond","scryfallId":"aa70562c-8e1e-44d0-b46c-ccd791be6644"},{"index":1146,"token":false,"name":"Samut's Sprint","scryfallId":"060de3c3-8927-4f69-a524-7ae0b3e3620b"},{"index":1147,"token":false,"name":"Pestilence","scryfallId":"bb93aead-8fba-4775-b1ae-86285c6d2ef9"},{"index":1148,"token":false,"name":"Spectral Gateguards","scryfallId":"8f658073-5d90-4dca-b867-35ab827f22fd"},{"index":1149,"token":true,"name":"Spirit Token (W, 1/1)","scryfallId":"4b3c4b73-9a95-4caa-9a91-b4777f85b6f8"},{"index":1150,"token":false,"name":"Balthor the Defiled","scryfallId":"ed4cc273-adc3-4f46-9743-134b552d1d56"},{"index":1151,"token":false,"name":"Returned Phalanx","scryfallId":"aeaa1dc6-b2e7-457b-9ad4-d024f21e8888"},{"index":1152,"token":false,"name":"Clash of Wills","scryfallId":"1c67ab53-9489-4658-859e-9dd8a6e0f20d"},{"index":1153,"token":false,"name":"Hero of the Pride","scryfallId":"81b56863-a52a-4559-a662-f6d9145d5804"},{"index":1154,"token":false,"name":"Ugin, the Ineffable","scryfallId":"86395749-e85a-460a-b14d-7228030bde59"},{"index":1155,"token":false,"name":"Cloud Dragon","scryfallId":"69aec764-7832-4d9c-b6c1-fdf5b27fedc0"},{"index":1156,"token":false,"name":"Cruel Edict","scryfallId":"6f11fe08-d745-4dc7-b995-8ed28cc8b501"},{"index":1157,"token":false,"name":"Putrefy","scryfallId":"0a16086c-5a74-45d0-8b38-e832cfbc80f7"},{"index":1158,"token":false,"name":"Flying Crane Technique","scryfallId":"f1ba7efe-ae5a-4d11-b535-1c2e5e6f5982"},{"index":1159,"token":false,"name":"Imoti, Celebrant of Bounty","scryfallId":"77d6f813-a1ff-49fe-9678-e0fcd12dea48"},{"index":1161,"token":false,"name":"Unstable Mutation","scryfallId":"2a157ce2-db13-4c49-95e0-f823bc9b6f97"},{"index":1162,"token":false,"name":"Farfinder","scryfallId":"53f63f40-46f1-4b9e-b447-ff9274f2b926"},{"index":1163,"token":false,"name":"Helm of Kaldra","scryfallId":"f76514aa-3cc1-4d5f-ba33-d933a36920a4"},{"index":1164,"token":false,"name":"Vow of Malice","scryfallId":"4d56090e-afae-4d5a-9213-186d0e867bd0"},{"index":1165,"token":false,"name":"Kiora, Behemoth Beckoner","scryfallId":"db38ea58-bdd1-4c3b-8a23-dab4c8b88d90"},{"index":1167,"token":false,"name":"Creative Technique","scryfallId":"441e8877-fa7e-45f3-bbb1-9581885e51fd"},{"index":1168,"token":false,"name":"Nest of Scarabs","scryfallId":"d849dc0a-4122-497c-a2a7-e5a21dc809f5"},{"index":1169,"token":false,"name":"Fugue","scryfallId":"1629cd63-95aa-40b6-aa57-7fb88f569e59"},{"index":1171,"token":false,"name":"Tempt with Discovery","scryfallId":"79248b68-4fab-46da-ab15-5c71c1f68d4b"},{"index":1172,"token":false,"name":"Scute Mob","scryfallId":"c217f6c6-e4be-4980-a125-18ccab318c96"},{"index":1173,"token":false,"name":"Silent Submersible","scryfallId":"ae2f3dee-1768-4562-9333-a50b9ee7570f"},{"index":1174,"token":false,"name":"Tendrils of Corruption","scryfallId":"75d33538-eff7-45a9-996a-f380a07d6026"},{"index":1175,"token":false,"name":"Divine Presence","scryfallId":"28cb898d-d6ce-410a-83bf-37962cca2735"},{"index":1176,"token":false,"name":"Stupor","scryfallId":"0fed2498-20ce-48ad-a56e-2c7e297c0c66"},{"index":1177,"token":false,"name":"Shivan Dragon","scryfallId":"5cbf9dde-e396-43dc-8288-b39e63a23164"},{"index":1178,"token":false,"name":"Searing Wind","scryfallId":"7b761f97-3690-497a-b6ab-c71f61b8e841"},{"index":1179,"token":false,"name":"Scathe Zombies","scryfallId":"a30abb09-2f80-46cf-a839-b4dac5c23dce"},{"index":1180,"token":false,"name":"Merfolk Thaumaturgist","scryfallId":"efa3d335-f39f-4291-85e0-7430561e953b"},{"index":1181,"token":false,"name":"Peace of Mind","scryfallId":"36e37aa2-d898-47f5-9679-5717bfa25688"},{"index":1182,"token":false,"name":"Riddlesmith","scryfallId":"29638358-d0fa-4cd5-9d42-66cee8e8ccc6"},{"index":1183,"token":false,"name":"Mind Twist","scryfallId":"9763ea41-55c4-4b0a-9dc2-91ad4938b343"},{"index":1185,"token":true,"name":"Octopus Token (U, 8/8)","scryfallId":"19ac0a35-fae7-49f9-ae96-4406df992dc9"},{"index":1186,"token":false,"name":"Maelstrom Wanderer","scryfallId":"9129baf5-ffa9-4ffb-bcab-19d6a42dbfcc"},{"index":1187,"token":false,"name":"Recover","scryfallId":"ba44d21e-b1f4-4691-9895-6dda5015ad34"},{"index":1188,"token":false,"name":"Nevinyrral's Disk","scryfallId":"7978b3a3-9139-4388-88fd-5dabca4b14d6"},{"index":1189,"token":false,"name":"Earthquake","scryfallId":"34dd0c90-202d-4b51-b59c-ec35caa17303"},{"index":1191,"token":false,"name":"Glacial Crevasses","scryfallId":"f69662bd-206e-4bd7-9145-eb5c24a31d3a"},{"index":1192,"token":false,"name":"Awesome Presence","scryfallId":"80017e84-87bc-4eb8-a663-5c263d8df812"},{"index":1193,"token":false,"name":"Tajic, Legion's Edge","scryfallId":"5e669a01-84d3-4fcc-8396-9e987bd89b4f"},{"index":1194,"token":false,"name":"Hungry Flames","scryfallId":"07392a36-e63a-4648-b8df-1172403922eb"},{"index":1196,"token":false,"name":"Lifecraft Cavalry","scryfallId":"0c60beae-9305-486a-8e39-3db76d96bc6a"},{"index":1197,"token":false,"name":"Inspired Sphinx","scryfallId":"7f58d798-9b99-45a9-9015-f689145018a8"},{"index":1198,"token":false,"name":"Angel's Feather","scryfallId":"476f1233-7474-4c01-8e8b-be642a638a61"},{"index":1199,"token":false,"name":"Bellowing Elk","scryfallId":"cec6cf54-79ff-44e8-af83-786fd72867dd"},{"index":1200,"token":false,"name":"Transguild Promenade","scryfallId":"9f325665-43cd-4b6d-8878-e42a39178e3f"},{"index":1201,"token":false,"name":"Ilharg, the Raze-Boar","scryfallId":"c0109b60-09aa-4a03-92e7-0c651d976d51"},{"index":1202,"token":false,"name":"Battalion Foot Soldier","scryfallId":"1db6393a-88b0-4973-9832-1482f69917ff"},{"index":1203,"token":false,"name":"Wind Spirit","scryfallId":"da614b44-a70a-454b-954b-a420e7f3d62f"},{"index":1204,"token":false,"name":"Nissa's Pilgrimage","scryfallId":"915d5dcd-f547-403c-9517-e4cdaa3fd247"},{"index":1206,"token":false,"name":"Harmonize","scryfallId":"ebbd37bc-1df2-49b3-87e1-603ca5cf0707"},{"index":1207,"token":false,"name":"Magical Hack","scryfallId":"c2349d53-d9f0-450f-be96-463791ee7aab"},{"index":1208,"token":false,"name":"Elephant Ambush","scryfallId":"b4abdf1c-a0a9-4e1d-b448-58742830f767"},{"index":1210,"token":false,"name":"Goblin Digging Team","scryfallId":"bc8fdbaa-bf48-4ed9-b3fd-c2c5d497a0be"},{"index":1211,"token":false,"name":"Watchful Naga","scryfallId":"81a5652b-bf5a-4672-abb6-074af48a9693"},{"index":1212,"token":false,"name":"Flying Carpet","scryfallId":"7edcc350-ab84-4aff-a9f0-2cc05c7c43bb"},{"index":1213,"token":false,"name":"Incinerate","scryfallId":"f81ebc1b-9850-4e13-a3b1-28e83e860036"},{"index":1214,"token":false,"name":"Grazing Whiptail","scryfallId":"75cbd690-4d6e-49a7-bded-e6ecee2c76b6"},{"index":1217,"token":false,"name":"Wall of Lost Thoughts","scryfallId":"03a0a627-ea7a-48bb-bf30-60b2677dd8ae"},{"index":1218,"token":false,"name":"Reminisce","scryfallId":"fab3a79f-354f-49b9-b3c9-44880369ced4"},{"index":1220,"token":false,"name":"Wild Griffin","scryfallId":"035fc0f8-5a2f-45d7-a482-2c80e6dd88d4"},{"index":1221,"token":false,"name":"Paladin of Prahv","scryfallId":"9797c1dc-e676-4c24-93b0-db2aae663ea2"},{"index":1222,"token":false,"name":"Thornwind Faeries","scryfallId":"d2f6a604-1a00-41c4-afe1-e80371c7596a"},{"index":1223,"token":false,"name":"Vulturous Zombie","scryfallId":"a6ae1633-7553-4496-9211-d08c5d6165c5"},{"index":1224,"token":false,"name":"Impulse","scryfallId":"2e48fe92-a2d7-49a8-a05d-6f032c532f14"},{"index":1225,"token":false,"name":"Moment of Craving","scryfallId":"c0e3ea55-162d-4466-ba4e-b938a0845fb5"},{"index":1227,"token":false,"name":"Dominator Drone","scryfallId":"12e7e2b5-3141-4a19-aa49-91ab7e5c211c"},{"index":1228,"token":false,"name":"Harbinger of the Tides","scryfallId":"94ca53de-cffb-4740-b318-a4ebfb3a31af"},{"index":1229,"token":false,"name":"Sokenzan Spellblade","scryfallId":"500eeccb-aee2-48d4-8a43-bb9668f1c1ab"},{"index":1231,"token":false,"name":"Nivix Guildmage","scryfallId":"603e7dd3-c361-4e66-9df5-4b24f40734e8"},{"index":1232,"token":false,"name":"Sleight of Hand","scryfallId":"1766d117-6ee1-4103-88e8-47b932a94d65"},{"index":1233,"token":false,"name":"Flowstone Sculpture","scryfallId":"448d1d1d-00bc-4026-8a63-4812d1f28502"},{"index":1235,"token":false,"name":"Windswept Heath","scryfallId":"7a7c5941-9c8a-4a40-9efb-a84f05c58e53"},{"index":1236,"token":false,"name":"Humility","scryfallId":"55ad6a45-a840-45ba-89ad-066e20e983f3"},{"index":1237,"token":false,"name":"Roalesk, Apex Hybrid","scryfallId":"de14b4fd-fb4e-4986-9123-69ae68b5050a"},{"index":1238,"token":false,"name":"Niblis of Dusk","scryfallId":"394dd931-e34e-4314-88c9-774a2f3c8c1b"},{"index":1240,"token":false,"name":"Ruination Guide","scryfallId":"f94ec12e-19ff-4dd3-9ab5-65c5275c97a5"},{"index":1241,"token":false,"name":"Dynavolt Tower","scryfallId":"62c76af5-030a-4155-a03c-876404fd3f11"},{"index":1242,"token":false,"name":"Inga Rune-Eyes","scryfallId":"d2d1b1a2-3861-4fbb-955b-4f3f8fcca9a7"},{"index":1243,"token":false,"name":"Mons's Goblin Raiders","scryfallId":"b4eb3db3-6a7c-488a-9433-d5d1d3133816"},{"index":1244,"token":false,"name":"Send to Sleep","scryfallId":"aa34d648-da0a-4615-8dd8-d2c8b1a1a574"},{"index":1245,"token":false,"name":"Avalanche Riders","scryfallId":"f4fa943a-f2eb-4cf8-b8bd-0fe2b2da74a9"},{"index":1246,"token":false,"name":"Ghor-Clan Rampager","scryfallId":"e58419b3-ff93-4eea-8a6b-5c112cbde54f"},{"index":1248,"token":false,"name":"Levitation","scryfallId":"6f05d944-1800-4542-a496-62504efc5292"},{"index":1249,"token":false,"name":"Bushi Tenderfoot // Kenzo the Hardhearted","scryfallId":"864ad989-19a6-4930-8efc-bbc077a18c32"},{"index":1251,"token":false,"name":"Ahn-Crop Champion","scryfallId":"2ddda94a-4b2d-47b0-8d2c-3ad70a0d5584"},{"index":1252,"token":false,"name":"Petrified Field","scryfallId":"eaeaf9f2-d196-4607-a704-06f2315d8cc5"},{"index":1253,"token":false,"name":"Rest in Peace","scryfallId":"37c2b1d1-faa0-40fd-82f4-216604ce7635"},{"index":1254,"token":false,"name":"Gravedigger","scryfallId":"b979d70e-d514-420f-886c-f60e2bb1861f"},{"index":1255,"token":false,"name":"Aethertide Whale","scryfallId":"e12c01d2-53c6-434e-af76-abb6f90cb9d5"},{"index":1256,"token":false,"name":"Overrun","scryfallId":"0ad7a961-d3a1-471a-8472-8407d1057de0"},{"index":1257,"token":false,"name":"Evacuation","scryfallId":"caccacb7-7d17-4b37-aee9-ba8ed8b90955"},{"index":1259,"token":false,"name":"Reality Anchor","scryfallId":"21204f62-c253-4d88-a4cd-7c0f6f0513e0"},{"index":1260,"token":false,"name":"Hornet Queen","scryfallId":"d245cb84-56aa-47a1-aa3a-17ffded57e15"},{"index":1261,"token":false,"name":"Thundersong Trumpeter","scryfallId":"7410c546-745c-469f-b3b8-eafb69391600"},{"index":1262,"token":false,"name":"Stifle","scryfallId":"ea24228f-da16-46eb-9dcf-a377286b6168"},{"index":1263,"token":false,"name":"Sanctuary Lockdown","scryfallId":"1387b7be-f69e-4919-9070-a89654c656f3"},{"index":1265,"token":false,"name":"Smother","scryfallId":"1d87e268-daab-4bf5-952c-a3baf82beb11"},{"index":1266,"token":false,"name":"Mutagenic Growth","scryfallId":"2e0861a2-1858-47af-8154-20a977c2b298"},{"index":1267,"token":false,"name":"Kokusho, the Evening Star","scryfallId":"06a80365-1613-4d26-abe3-8cec0d40146b"},{"index":1269,"token":false,"name":"Cryptbreaker","scryfallId":"31699dde-756d-49f1-9384-cdb9f210294c"},{"index":1270,"token":false,"name":"Mycoid Shepherd","scryfallId":"8331079e-0193-4243-9db9-ec7762a27633"},{"index":1271,"token":false,"name":"Winter Orb","scryfallId":"847de6a4-a268-492e-a4d2-5b12237bc130"},{"index":1273,"token":false,"name":"Lifecrafter's Bestiary","scryfallId":"5de7230d-dc3b-497c-97bc-02c06f6e2103"},{"index":1274,"token":false,"name":"Henge of Ramos","scryfallId":"0582b42f-5ae5-4be2-ba2d-ed62b3cb20c5"},{"index":1275,"token":false,"name":"New Perspectives","scryfallId":"286be1fb-8ed2-4228-9df8-0ea413714778"},{"index":1276,"token":false,"name":"Wasteland Viper","scryfallId":"35d15017-b6f8-47ea-9d15-e77dd83e6f01"},{"index":1277,"token":false,"name":"Nessian Wilds Ravager","scryfallId":"63cdf224-ddfc-408f-a50a-2baed74013c4"},{"index":1278,"token":false,"name":"Drudge Skeletons","scryfallId":"7cd9e7c4-9d49-4258-88e4-f70a8177f177"},{"index":1279,"token":false,"name":"Meteor Golem","scryfallId":"5d096068-0740-4b28-8c05-f5a5b7109ab9"},{"index":1280,"token":false,"name":"Cessation","scryfallId":"3a113f0c-8249-427b-979b-10898ec66a3a"},{"index":1281,"token":false,"name":"Unhinge","scryfallId":"b89deafd-cb7c-4da7-ab9b-8f795554a705"},{"index":1282,"token":false,"name":"Aspect of Lamprey","scryfallId":"27157f01-8aed-4485-9f0f-9e7486492e6e"},{"index":1283,"token":false,"name":"Mogg Sentry","scryfallId":"8536ec54-cebd-4d44-8e52-42344a3e6daa"},{"index":1285,"token":false,"name":"Tireless Provisioner","scryfallId":"5c5be54d-660e-42ab-b5ea-5e1cf3bad0bc"},{"index":1286,"token":false,"name":"Tsunami","scryfallId":"0ab151ce-9468-4427-853b-4e0011d783fb"},{"index":1288,"token":false,"name":"Mirror Universe","scryfallId":"a8f05d5e-bb7d-4554-b880-f0c6b4688357"},{"index":1290,"token":false,"name":"Swift Response","scryfallId":"a90c1ad0-83bd-471c-8d4c-e65bc2abaa18"},{"index":1291,"token":false,"name":"Goblin Rock Sled","scryfallId":"25f4f0c1-a43e-4282-b20e-91c711c57521"},{"index":1292,"token":false,"name":"Eiganjo Free-Riders","scryfallId":"fe47bbc5-6f7f-4135-9e83-9e2a428c97f5"},{"index":1293,"token":false,"name":"Orzhov Pontiff","scryfallId":"f2b5813b-955b-469a-b287-65325c589b59"},{"index":1294,"token":false,"name":"Zhalfirin Knight","scryfallId":"bb5b0fcb-c170-4d12-8761-de833e944e2f"},{"index":1296,"token":false,"name":"Soul Snare","scryfallId":"c8d05a08-732a-4423-a625-5bc4199a0da3"},{"index":1297,"token":false,"name":"Ravenous Bloodseeker","scryfallId":"6eadcfee-a4e7-41e0-96f3-0bbd1c7432e5"},{"index":1298,"token":false,"name":"Dragon Throne of Tarkir","scryfallId":"74cae89f-6719-46d9-9da2-5aaf8b9728f9"},{"index":1299,"token":false,"name":"Zodiac Goat","scryfallId":"439f290a-7f28-467e-ac8d-6b454e2c8a68"},{"index":1301,"token":false,"name":"All Is Dust","scryfallId":"8cf632ef-70e3-46f2-af21-14ea7ef30237"},{"index":1302,"token":false,"name":"Callous Bloodmage","scryfallId":"67a8dca6-48bd-4922-8201-7bd8a281de21"},{"index":1303,"token":false,"name":"Contagion Clasp","scryfallId":"4f6e4cbf-0bf0-45b1-8707-a82a7d91298a"},{"index":1304,"token":false,"name":"Jace, Wielder of Mysteries","scryfallId":"d9508bab-1bc3-4866-8029-92dcf2f391d7"},{"index":1305,"token":false,"name":"Rotted Hulk","scryfallId":"1066644a-ac62-4809-805c-607c645613c5"},{"index":1306,"token":false,"name":"Blood Ogre","scryfallId":"ef09e5fa-5a9d-42b8-8d95-36b169ac179f"},{"index":1307,"token":false,"name":"Horned Kavu","scryfallId":"ecd79fbf-626d-4549-917b-435f16b973d9"},{"index":1308,"token":false,"name":"Dismember","scryfallId":"3d286cf6-3e16-4941-9326-1818b1e06d69"},{"index":1309,"token":false,"name":"Thoughtlace","scryfallId":"23749375-1416-47a4-9251-52f41fe2fae9"},{"index":1310,"token":false,"name":"Stronghold Rats","scryfallId":"87761f00-bfbc-42dc-b96d-9f4258b43a8b"},{"index":1312,"token":false,"name":"Elvish Hunter","scryfallId":"baf265bf-0f83-4073-87c2-f0b9ef268592"},{"index":1313,"token":false,"name":"Liliana's Devotee","scryfallId":"68d242d3-a817-4cdb-a51e-5f8202233743"},{"index":1314,"token":false,"name":"Kumena's Awakening","scryfallId":"3a86f499-a2d4-47f1-9fc1-b543e5ad5c82"},{"index":1315,"token":true,"name":"Myr Token (Colorless, 1/1)","scryfallId":"fd2eef3b-9001-477a-8ec4-2a59d906acc6"},{"index":1317,"token":false,"name":"Golgari Signet","scryfallId":"254f4460-beb9-43ce-a176-d040f7dd7e9e"},{"index":1318,"token":false,"name":"Canyon Minotaur","scryfallId":"b670dcc2-e8e3-4fd7-a1db-c3152b005d39"},{"index":1319,"token":false,"name":"Village Bell-Ringer","scryfallId":"3543ed04-9519-4d69-b2ab-cd6c0747d9fd"},{"index":1320,"token":false,"name":"Pale Recluse","scryfallId":"13fad19c-fd45-45cf-b58c-82cdcdf49b06"},{"index":1321,"token":false,"name":"Colossus of Sardia","scryfallId":"c4b384c8-1aad-4b17-a7e6-e8e616f2542b"},{"index":1322,"token":false,"name":"Innocent Blood","scryfallId":"9499f72b-c1b7-4e03-a91b-2cd1e374b50a"},{"index":1323,"token":false,"name":"Pilgrim of the Ages","scryfallId":"c86714f5-e909-413f-8eb6-99dbea4d1897"},{"index":1324,"token":false,"name":"Master of the Pearl Trident","scryfallId":"3367f862-cd88-4e6d-8e87-693080e5c431"},{"index":1325,"token":false,"name":"Skyshroud Ridgeback","scryfallId":"410896ab-d3dc-478c-bfd1-c0cad5b1180a"},{"index":1326,"token":false,"name":"Burning-Eye Zubera","scryfallId":"ae9ca5c3-8367-4e08-a318-634f9d36dbdc"},{"index":1327,"token":false,"name":"Goldmane Griffin","scryfallId":"67edcb9b-f56b-4a34-b4bd-d22ee929041a"},{"index":1328,"token":false,"name":"Soldevi Steam Beast","scryfallId":"ead79d2c-170e-4106-962d-d69c4b5fead0"},{"index":1329,"token":false,"name":"Overgrown Tomb","scryfallId":"1c7d50d6-b63a-4d8c-88fa-1d78ae693a45"},{"index":1331,"token":false,"name":"Tormenting Voice","scryfallId":"d373ce86-c92d-4d91-b3bb-739aba7d09a1"},{"index":1333,"token":false,"name":"Bringer of the Black Dawn","scryfallId":"57ce0504-68af-43c3-9930-7e69e2655bc0"},{"index":1334,"token":false,"name":"Frog Tongue","scryfallId":"3941e799-a254-423e-90bb-091dbe56ca6a"},{"index":1335,"token":false,"name":"Unflinching Courage","scryfallId":"35952c24-d728-4ec6-b0d1-b8183a18554a"},{"index":1336,"token":false,"name":"Sunweb","scryfallId":"7261bcea-27e0-417f-b3bf-7089c1e8bf1e"},{"index":1337,"token":false,"name":"Pyretic Hunter","scryfallId":"0f17be2c-f8c7-41b3-b8fa-30b9e4e826c9"},{"index":1338,"token":false,"name":"Bend or Break","scryfallId":"b76b6660-d4b2-44de-a1a7-8d00811f90f6"},{"index":1339,"token":false,"name":"Island Fish Jasconius","scryfallId":"84f18188-70fa-433e-a114-2f1dd49388ed"},{"index":1340,"token":false,"name":"Horned Turtle","scryfallId":"faabd1d9-e1c0-4f5e-88d6-a8d480cf30ba"},{"index":1341,"token":false,"name":"Pearl Lake Ancient","scryfallId":"fbee4d2f-6b41-4717-a1c6-831034452bec"},{"index":1343,"token":false,"name":"Desert of the Indomitable","scryfallId":"f5d75537-faec-4585-a389-f352bca88af6"},{"index":1344,"token":false,"name":"Cryptic Serpent","scryfallId":"bad1b1ee-cb01-4f2c-993c-d88f75ebda19"},{"index":1345,"token":false,"name":"Jayemdae Tome","scryfallId":"2af7373a-c863-4ea0-aea7-1933d96920b4"},{"index":1346,"token":false,"name":"Urza's Tower","scryfallId":"dc2c039e-fbf9-4e45-874d-b0ab0d923e52"},{"index":1347,"token":false,"name":"Tragic Slip","scryfallId":"09666671-601e-4fca-bdfb-fb288bf2672c"},{"index":1348,"token":false,"name":"Halcyon Glaze","scryfallId":"fafd3018-1cfe-4c41-a08c-5c2ba3528c7e"},{"index":1349,"token":false,"name":"Glade Gnarr","scryfallId":"ee38eeae-918b-4d19-b37a-175ac5db37a4"},{"index":1350,"token":false,"name":"Decree of Annihilation","scryfallId":"3c281e45-7a11-44f4-9353-a7623b5f5b75"},{"index":1351,"token":false,"name":"Llanowar Elves","scryfallId":"3055e3a9-240e-42f6-8596-7b5b8c6d21c2"},{"index":1352,"token":false,"name":"Rakdos Ickspitter","scryfallId":"c007b10b-2701-4bac-8b95-8fc7dcfb9e21"},{"index":1353,"token":false,"name":"Audacious Reshapers","scryfallId":"71df4a44-189b-4d8d-adc7-1ea4b0f8c622"},{"index":1355,"token":false,"name":"Lost Legacy","scryfallId":"d5d0e447-d98e-43d5-9b53-166221c34be2"},{"index":1356,"token":false,"name":"Simic Fluxmage","scryfallId":"50633b59-6051-4f47-9e27-538fda03b5dd"},{"index":1357,"token":false,"name":"Sage of Shaila's Claim","scryfallId":"0987d29a-2043-4341-89d5-5e34bb6507e2"},{"index":1359,"token":false,"name":"Power Taint","scryfallId":"13d0296c-c0f5-491e-9e61-be8f5af2e631"},{"index":1360,"token":false,"name":"Drove of Elves","scryfallId":"0b557581-0bd9-4e4e-a33e-75cf1043ef11"},{"index":1361,"token":false,"name":"Spellbook","scryfallId":"1adade15-5675-495b-a536-e531c4306d3e"},{"index":1362,"token":false,"name":"Banishing Light","scryfallId":"d35bad68-e1a9-4cdc-bd68-cee4ccebef6c"},{"index":1363,"token":false,"name":"Searing Rays","scryfallId":"4f66ff2d-f2d2-4a6b-bf26-b510de60c0b6"},{"index":1364,"token":false,"name":"Dauntless Dourbark","scryfallId":"9b8da2c0-2dab-4219-9210-66f2a23ec486"},{"index":1365,"token":false,"name":"Exhaustion","scryfallId":"5a9ecdcf-833f-4df8-83fc-4fb0487e625f"},{"index":1366,"token":false,"name":"Collective Unconscious","scryfallId":"3b64755f-1381-4537-a12d-48da274993e6"},{"index":1367,"token":false,"name":"Capashen Knight","scryfallId":"78802af4-46b5-4bac-8cdf-5b77d0b19895"},{"index":1368,"token":false,"name":"Spawn of Mayhem","scryfallId":"8be01b8d-e0ef-44d1-ac97-39bb5a0e76be"},{"index":1369,"token":false,"name":"Meddling Mage","scryfallId":"3a7e8c93-8a50-4494-ac7f-84c8f0016d09"},{"index":1370,"token":false,"name":"Soltari Priest","scryfallId":"5b7558c2-b044-46f2-9fc3-bcab8d8ae8ce"},{"index":1371,"token":false,"name":"Jhoira, Weatherlight Captain","scryfallId":"21001560-a222-452f-8006-ba656c10a9e4"},{"index":1372,"token":false,"name":"Glassdust Hulk","scryfallId":"215a8c38-c968-4337-88b3-b0b03b249a4b"},{"index":1373,"token":false,"name":"Brutal Nightstalker","scryfallId":"b471102b-a66e-4cdc-b20f-7ae1f9bd0e8a"},{"index":1374,"token":false,"name":"Karma","scryfallId":"89aa1674-9e03-4ab8-a1ae-4492c2fb5cb3"},{"index":1375,"token":false,"name":"Wingsteed Rider","scryfallId":"9b189050-522b-4b8a-b4e6-1f5158ebe519"},{"index":1376,"token":false,"name":"Simic Sky Swallower","scryfallId":"93288c87-84ad-40c8-a998-a3e36075adfd"},{"index":1377,"token":false,"name":"Funeral March","scryfallId":"054c5678-63d1-45d9-bd51-43100fd10afd"},{"index":1378,"token":false,"name":"Autumn Willow","scryfallId":"cea60340-bbdb-48e2-94a6-5ac1197e978a"},{"index":1379,"token":false,"name":"Fatal Blow","scryfallId":"6890c3aa-9321-4c41-9b16-cff4e6364350"},{"index":1380,"token":false,"name":"Blooming Marsh","scryfallId":"03e2b6b3-7705-4afa-832b-ab3fc03be176"},{"index":1381,"token":false,"name":"Hydroblast","scryfallId":"040ef6d7-8cab-45f9-a55b-42ea8931a407"},{"index":1383,"token":false,"name":"Aven Shrine","scryfallId":"9890be7f-35af-43b7-b255-25be4ff20dc0"},{"index":1384,"token":false,"name":"Flusterstorm","scryfallId":"1e2e09bf-e7c8-4f13-bcee-f9c8cbc57993"},{"index":1385,"token":false,"name":"Knight Exemplar","scryfallId":"d8c05f52-d800-4648-9a7e-f664faab192c"},{"index":1386,"token":false,"name":"Scarred Vinebreeder","scryfallId":"a60c51c2-3a24-4376-850c-cebd4d75adca"},{"index":1387,"token":false,"name":"Armored Pegasus","scryfallId":"ed1b462d-4b0f-40cf-89a0-17a3e1c8a0ba"},{"index":1389,"token":false,"name":"Warpath","scryfallId":"e031c819-1237-4911-8a1d-87d6095a5faa"},{"index":1390,"token":false,"name":"Armor of Thorns","scryfallId":"dacdb9e7-d79e-4d24-8678-a37ab6e3a413"},{"index":1391,"token":false,"name":"Shadow Rift","scryfallId":"06f6d0bd-19b9-45d0-8768-691a6a593d81"},{"index":1392,"token":false,"name":"Turntimber Grove","scryfallId":"fc92d6ef-a578-4320-b5c8-3da192eea1f3"},{"index":1393,"token":false,"name":"Mesmeric Fiend","scryfallId":"b6edd4ea-c587-4d93-a675-4cdec3e0b1ca"},{"index":1394,"token":false,"name":"Ghost-Lit Drifter","scryfallId":"5a8cd89e-d849-4107-a629-98eae4c91489"},{"index":1395,"token":false,"name":"Touchstone","scryfallId":"923afe8a-e82c-4b93-bb42-8f5073acae13"},{"index":1397,"token":false,"name":"Order of Midnight // Alter Fate","scryfallId":"bc3d9ecb-d15e-4537-8fae-25d42a678916"},{"index":1398,"token":false,"name":"Orc General","scryfallId":"65a10fd5-506e-46bf-87e6-fde134c0dc04"},{"index":1400,"token":false,"name":"Blanchwood Armor","scryfallId":"21b462ff-a130-4c0f-97e9-b096511d7abb"},{"index":1401,"token":false,"name":"Pollen Lullaby","scryfallId":"deb2156a-8a77-4954-b557-1bdaf3ba171a"},{"index":1402,"token":false,"name":"Instill Energy","scryfallId":"4f1ce0ed-be4b-427a-ad71-a94a9ef80ff5"},{"index":1403,"token":false,"name":"Tor Wauki","scryfallId":"241a4854-e62c-4be4-a9cc-1e14db4eede9"},{"index":1404,"token":false,"name":"Huatli, Warrior Poet","scryfallId":"a0cc61ba-e91a-4b30-841c-cae8dd288b40"},{"index":1405,"token":false,"name":"Isolation Zone","scryfallId":"1ca698e3-1249-4a08-be04-bae3bd944e99"},{"index":1406,"token":false,"name":"Barbed Foliage","scryfallId":"1220fdd1-e4b0-4175-9b8a-178f6a84b8e6"},{"index":1407,"token":false,"name":"Terminal Moraine","scryfallId":"353a8ea8-3f1f-4f77-95bc-b09b96996285"},{"index":1408,"token":false,"name":"Faithless Looting","scryfallId":"b429172f-2182-49dd-b6f6-e5e09493628d"},{"index":1409,"token":false,"name":"Vastwood Hydra","scryfallId":"bfe7139a-3fd5-4574-a26b-75b1b17b2c2f"},{"index":1410,"token":false,"name":"Seer's Sundial","scryfallId":"314cb009-bd0e-40eb-98ea-c6dea8d83dcf"},{"index":1411,"token":false,"name":"Rise to the Challenge","scryfallId":"c656ad1b-e85b-4b0c-b538-506afe4a9da5"},{"index":1412,"token":false,"name":"Tricks of the Trade","scryfallId":"8c796ef9-4061-4f82-9ee9-3bc446804ee9"},{"index":1413,"token":false,"name":"Animal Sanctuary","scryfallId":"f8d7a2c7-666d-4fc6-bac8-ef8eb66e355d"},{"index":1414,"token":false,"name":"Curse of the Forsaken","scryfallId":"9af69b5e-f713-4af6-9990-f99be7801f73"},{"index":1415,"token":false,"name":"Mangara's Blessing","scryfallId":"b0125f79-ff68-4fb9-b309-8d277259f323"},{"index":1416,"token":false,"name":"Nylea's Emissary","scryfallId":"2f133775-09b3-4df4-a97f-0df75809b724"},{"index":1418,"token":false,"name":"Ray of Revelation","scryfallId":"33e1c83b-27d1-4c24-9e57-5dd6b7c8bf14"},{"index":1419,"token":false,"name":"Ral's Staticaster","scryfallId":"adfa16dc-03b3-4533-884c-a23b992b8d86"},{"index":1422,"token":false,"name":"Ohran Yeti","scryfallId":"8d6cfa21-75b1-4380-b0fc-a7450699660f"},{"index":1423,"token":false,"name":"Verdant Catacombs","scryfallId":"c7057b04-e22f-4e33-9f08-b9fbd2e54bf5"},{"index":1424,"token":false,"name":"Oathsworn Knight","scryfallId":"dec1a41b-4342-412a-823e-ab753b0baf53"},{"index":1426,"token":false,"name":"Relic Crush","scryfallId":"01c924b2-3b10-4bb0-b51d-122bfdd298aa"},{"index":1427,"token":false,"name":"Polymorph","scryfallId":"fbae8702-a152-4c53-8a76-691a221f2475"},{"index":1428,"token":false,"name":"Doubling Season","scryfallId":"dd5157b8-07df-4aec-8ea6-792cd582598f"},{"index":1429,"token":false,"name":"Floodwater Dam","scryfallId":"0f1bc264-1f28-4bd4-be23-baae9734c3d9"},{"index":1430,"token":false,"name":"Goblin Guide","scryfallId":"b2e2a777-0705-4a37-937d-c6e020ebc0f0"},{"index":1433,"token":false,"name":"Fireslinger","scryfallId":"36fefe0a-f515-496e-b6c7-5e821fbc2283"},{"index":1434,"token":false,"name":"Congregate","scryfallId":"8690166f-be52-48c4-9877-630b3f3dc614"},{"index":1435,"token":false,"name":"Evolving Wilds","scryfallId":"a561453e-499a-4455-b01d-26e3f58b189e"},{"index":1436,"token":false,"name":"Leonin Warleader","scryfallId":"3289bc5f-ecc6-4534-b34e-5b1385b29a45"},{"index":1437,"token":false,"name":"Witch Engine","scryfallId":"ef749290-58e2-4b40-a141-5fe294f9b995"},{"index":1438,"token":false,"name":"Alpha Myr","scryfallId":"f3f792d7-75be-429e-8f62-0b563b103642"},{"index":1439,"token":false,"name":"Axgard Cavalry","scryfallId":"2411c341-a470-4484-9248-7c1d3ca12978"},{"index":1440,"token":false,"name":"Umbilicus","scryfallId":"29a6db88-a11d-49b4-8692-28b24d23f3c7"},{"index":1442,"token":false,"name":"Frogmite","scryfallId":"0665de15-bfd3-4b08-9712-dfcc7907607a"},{"index":1443,"token":false,"name":"Skyship Stalker","scryfallId":"7a35be7b-d693-4433-9b13-8e019adc594e"},{"index":1444,"token":false,"name":"Viscera Seer","scryfallId":"d2e1c1c3-641a-4cd5-b46d-e03e5e529cc7"},{"index":1445,"token":false,"name":"River's Rebuke","scryfallId":"4c54cdaa-d72f-4613-adaf-d4353703ef3e"},{"index":1446,"token":false,"name":"Stormwing Entity","scryfallId":"0540ee72-6370-4f70-9526-6f441b3cac1e"},{"index":1447,"token":false,"name":"Myr Moonvessel","scryfallId":"af0515cc-bf2d-4674-b339-4f4eefbc943d"},{"index":1448,"token":false,"name":"Sailor of Means","scryfallId":"10f7d936-f4f0-4f66-b54c-db99deb01519"},{"index":1449,"token":false,"name":"Savage Offensive","scryfallId":"356744f3-e444-4f4e-bf00-80bb6b2ef76f"},{"index":1450,"token":false,"name":"Keldon Berserker","scryfallId":"daa3f9c0-66ff-4b94-b0c3-e1c65d2040b9"},{"index":1451,"token":false,"name":"Stormrider Rig","scryfallId":"38b08344-780d-4bd7-882a-dcadeb40f159"},{"index":1452,"token":false,"name":"Fierce Guardianship","scryfallId":"4c5ffa83-c88d-4f5d-851e-a642b229d596"},{"index":1453,"token":false,"name":"Hooded Kavu","scryfallId":"5464b80a-22fe-42c7-a839-31667712fb2d"},{"index":1454,"token":false,"name":"Engineered Plague","scryfallId":"1c7008a8-a841-4d6c-be17-c9ef60e51976"},{"index":1456,"token":false,"name":"Goblin Battle Jester","scryfallId":"c13e56b0-becc-4bc2-9ba3-23b3ca8bfe58"},{"index":1457,"token":false,"name":"Opal Palace","scryfallId":"6e4a569b-4cb6-4a7a-a9f7-0f1413486f71"},{"index":1458,"token":false,"name":"Conservator","scryfallId":"f6639eea-d0ae-4f0d-a8da-1b863b482b68"},{"index":1459,"token":false,"name":"Yavimaya Dryad","scryfallId":"9807f9a8-a994-4fb2-ad33-3d80d9702bfe"},{"index":1461,"token":false,"name":"Ashiok's Forerunner","scryfallId":"781bfbae-acd9-4583-88d2-d31978eef565"},{"index":1462,"token":false,"name":"Aven Surveyor","scryfallId":"dbb2185d-46c6-44c1-a67c-9b6af872e8eb"},{"index":1463,"token":false,"name":"Feed the Clan","scryfallId":"52f7c53d-0b53-400f-aa67-967547f3e394"},{"index":1464,"token":false,"name":"Call the Skybreaker","scryfallId":"9511172e-f5dc-4356-9a9d-9fd4527069e3"},{"index":1465,"token":false,"name":"Scavenging Scarab","scryfallId":"023603c1-3f1e-42d1-81e1-535547ef6ee0"},{"index":1467,"token":false,"name":"Ihsan's Shade","scryfallId":"838b7eb0-1435-476f-8327-7bd516a150c7"},{"index":1468,"token":false,"name":"Jace, Vryn's Prodigy // Jace, Telepath Unbound","scryfallId":"e7b5705f-dc56-41af-a781-8a41aaa7c5b8"},{"index":1470,"token":false,"name":"Auramancer","scryfallId":"469a4285-610e-4366-afe7-38b628b3b88c"},{"index":1471,"token":false,"name":"Windstorm Drake","scryfallId":"b40dae56-be19-4b64-b99d-f45b7f816287"},{"index":1472,"token":false,"name":"Amaranthine Wall","scryfallId":"73b49065-0a46-4813-a721-71d718e73d18"},{"index":1473,"token":false,"name":"Ostiary Thrull","scryfallId":"26407330-d7a1-4915-b7c6-e08e166cf638"},{"index":1474,"token":false,"name":"Overwhelming Intellect","scryfallId":"c5c5945d-7f62-4bae-b041-682f57ff2e4c"},{"index":1475,"token":false,"name":"Triumph of the Hordes","scryfallId":"64034e9c-1a1a-43e3-b101-cb2c7bbbccda"},{"index":1476,"token":false,"name":"Vow of Duty","scryfallId":"107c1b3f-1aab-48a1-a651-8302bc8682f9"},{"index":1477,"token":false,"name":"Tempest of Light","scryfallId":"d86e9c3f-c72d-4b7b-a2c2-5249fbf0990f"},{"index":1478,"token":false,"name":"Rootrunner","scryfallId":"98666241-4e2d-458c-8234-df84b8bbc4a0"},{"index":1479,"token":false,"name":"Fell Flagship","scryfallId":"ac26bcdb-7646-40eb-8eca-9e3ac9e58a75"},{"index":1480,"token":false,"name":"Tyrant of Valakut","scryfallId":"7ad27352-fdce-437e-950e-ecff1bdf0141"},{"index":1481,"token":false,"name":"Blast Zone","scryfallId":"ec979bd0-d571-4fac-a211-c236ef968c2c"},{"index":1482,"token":false,"name":"Pit Keeper","scryfallId":"4273650b-7b7a-4534-be80-87a6f2d57b1f"},{"index":1484,"token":true,"name":"Demon Token (B, 5/5)","scryfallId":"3b3c99d1-ebd3-4eb4-ba04-941819394567"},{"index":1486,"token":false,"name":"Undying Beast","scryfallId":"9c95c752-3add-4830-8159-036b8689f40a"},{"index":1487,"token":false,"name":"Laquatus's Champion","scryfallId":"74a397bb-6910-4724-833d-7f2d92723e3b"},{"index":1488,"token":false,"name":"Saheeli, Sublime Artificer","scryfallId":"a4d25e3c-37ac-4819-9915-32673012821d"},{"index":1489,"token":false,"name":"Hatching Plans","scryfallId":"ef327629-9831-4a0c-bd61-7542b0713ea8"},{"index":1490,"token":false,"name":"Sulfur Falls","scryfallId":"42892615-27a1-42d1-af71-cd9a3eb064dc"},{"index":1491,"token":false,"name":"Eldritch Evolution","scryfallId":"d0c46e0f-524d-47c8-a628-5540c86b93cf"},{"index":1492,"token":false,"name":"The Mirari Conjecture","scryfallId":"18ee3a98-0254-4fe9-ba6b-94eb9266ac70"},{"index":1493,"token":false,"name":"Stinkweed Imp","scryfallId":"566be83c-14a8-42ca-b9e5-51b486dc7849"},{"index":1496,"token":false,"name":"Elvish Ranger","scryfallId":"5eac1616-d764-4e62-9fc6-939c28b75f52"},{"index":1497,"token":false,"name":"Molten Ravager","scryfallId":"9ebc7622-e7a7-419c-abb4-d9d339e6cdb0"},{"index":1498,"token":false,"name":"Goretusk Firebeast","scryfallId":"9919d2dd-d6a1-4d45-b6aa-227ed05d7051"},{"index":1499,"token":false,"name":"Befuddle","scryfallId":"1414939c-7f15-4eb3-abeb-6e75c52d2b52"},{"index":1500,"token":false,"name":"Coastal Tower","scryfallId":"4febfcf0-6537-4e30-a963-9859314d0657"},{"index":1501,"token":false,"name":"Silent Departure","scryfallId":"a18dea16-d535-4310-94ff-836645253d73"},{"index":1502,"token":false,"name":"Sever the Bloodline","scryfallId":"9628c3bb-2fce-4321-bb6a-b0a3377649d6"},{"index":1503,"token":false,"name":"Phoenix of Ash","scryfallId":"d59b07e6-96b6-4cc1-81a2-aace9fe84f89"},{"index":1504,"token":false,"name":"Necrotic Sliver","scryfallId":"8ab51f12-dc78-4d3c-ac50-6438481b11a8"},{"index":1505,"token":false,"name":"Hymn to Tourach","scryfallId":"3faa8c5e-9e1b-4cee-b322-a033bf33dcbc"},{"index":1506,"token":true,"name":"Alex Borteh Decklist","scryfallId":"9597cfb4-f1ed-44ce-bb9c-cf80368546be"},{"index":1507,"token":false,"name":"War Mammoth","scryfallId":"55073560-e52c-4f03-a260-57cf084b3478"},{"index":1508,"token":false,"name":"Lonely Sandbar","scryfallId":"d8ddab06-aff7-4c40-bcaa-10cbfe899dd9"},{"index":1509,"token":false,"name":"Fear","scryfallId":"6c6b2afc-d4f5-47fb-abda-fc3de8bdacaa"},{"index":1512,"token":false,"name":"Sustaining Spirit","scryfallId":"c9ecf91a-9ce1-44a1-8859-7163d32cfba6"},{"index":1513,"token":false,"name":"Dhund Operative","scryfallId":"98f91094-5214-4268-8f91-5ba0b891256d"},{"index":1514,"token":false,"name":"Orcish Artillery","scryfallId":"606fca10-0eb8-4f70-80bb-dd9aee50a018"},{"index":1515,"token":false,"name":"Insult // Injury","scryfallId":"5f92876b-efe0-4862-8186-8336f80a9222"},{"index":1516,"token":false,"name":"Kor Bladewhirl","scryfallId":"e31b12c7-df11-4450-95e1-b9a5aa97af0e"},{"index":1517,"token":false,"name":"Lu Bu, Master-at-Arms","scryfallId":"07d60c27-8625-48eb-a3f0-1e26d6930ae7"},{"index":1518,"token":false,"name":"Submerged Boneyard","scryfallId":"4490b5fe-6a69-4d76-91f2-1b8dc016e2b5"},{"index":1519,"token":false,"name":"Raise Dead","scryfallId":"a68fdb3d-cb34-4691-ada3-ff47b6802363"},{"index":1520,"token":false,"name":"Lucid Dreams","scryfallId":"98aeda3d-3741-4b80-bfef-63bcc599d75b"},{"index":1521,"token":false,"name":"Wasteland","scryfallId":"6eff6724-202d-4b6b-bac9-88dc1504a0aa"},{"index":1522,"token":false,"name":"Dance of the Dead","scryfallId":"e7c53ba4-9956-4cd6-85ca-2d6b61a5127c"},{"index":1523,"token":false,"name":"Defiant Khenra","scryfallId":"67e3983d-b1ed-46a9-9ab0-96c4d0d77050"},{"index":1524,"token":false,"name":"Rashida Scalebane","scryfallId":"ebb48053-da60-477a-b1eb-a9ab9ea682af"},{"index":1526,"token":false,"name":"Hieroglyphic Illumination","scryfallId":"d2d79bdf-5cbe-4d85-8676-6e9346ab9909"},{"index":1527,"token":false,"name":"Celestial Flare","scryfallId":"4fb80f90-f686-4d3b-b015-ce20383615bf"},{"index":1528,"token":false,"name":"Fallen Angel","scryfallId":"612ecb2c-e732-40cc-9e92-d18b80a26c4c"},{"index":1529,"token":false,"name":"River Serpent","scryfallId":"951b9269-22fa-4d92-b3d3-43f79fbb2388"},{"index":1530,"token":false,"name":"Pulse of the Tangle","scryfallId":"f6613bf0-d2be-4a25-805a-d3592fa788e5"},{"index":1532,"token":false,"name":"Deflection","scryfallId":"217c899e-f624-4791-af64-b1b1e2ac53cd"},{"index":1533,"token":false,"name":"Hag Hedge-Mage","scryfallId":"1d461d67-8554-4b55-8f01-909a54d23117"},{"index":1534,"token":false,"name":"Make a Wish","scryfallId":"d0a8508d-25a7-4fb2-8aa3-349275f80c42"},{"index":1535,"token":false,"name":"Floodchaser","scryfallId":"71265bb0-bf51-4d9d-b94c-c90adf65c55b"},{"index":1536,"token":false,"name":"Sparring Regimen","scryfallId":"ab7c80d3-3e0c-4510-9ed0-bb9fe39d838f"},{"index":1537,"token":false,"name":"Vorel of the Hull Clade","scryfallId":"91bb9c52-2fb5-4b31-ae49-019273aed4d0"},{"index":1538,"token":false,"name":"Call of the Death-Dweller","scryfallId":"37e34017-0aeb-4a93-9edf-596bf3597a0e"},{"index":1539,"token":false,"name":"Amulet of Kroog","scryfallId":"b094f8dd-0184-41a2-9767-e848a6e4eac1"},{"index":1540,"token":false,"name":"Time Warp","scryfallId":"cd855dd4-eebe-4e57-84ec-362d6c6a0e0a"},{"index":1541,"token":false,"name":"Living Death","scryfallId":"0c699887-3e45-47eb-9e9e-f537b8756690"},{"index":1542,"token":false,"name":"Avarice Totem","scryfallId":"53a5cfa8-4091-445c-8641-64402cca7d2d"},{"index":1543,"token":false,"name":"Demon of Catastrophes","scryfallId":"d50f9563-7bf8-4c3c-ac82-327221e56551"},{"index":1544,"token":false,"name":"Gonti, Lord of Luxury","scryfallId":"7c9909cf-4d59-4bac-beff-d20d1cc4a818"},{"index":1545,"token":false,"name":"Shardless Agent","scryfallId":"ceb4df89-a97e-4479-b7f0-7083417a9565"},{"index":1546,"token":false,"name":"Run Away Together","scryfallId":"aeffc3c0-567c-442f-ba06-b7d9617c5789"},{"index":1547,"token":false,"name":"Detritivore","scryfallId":"2ec01f4b-b3df-4e2b-ae93-2f2d0cc279bd"},{"index":1548,"token":false,"name":"Alluring Scent","scryfallId":"2c488688-4e50-4705-afd5-09310e240777"},{"index":1549,"token":false,"name":"Damnation","scryfallId":"6c5823bb-d56d-4bed-ba3f-09bdd93c52dc"},{"index":1550,"token":false,"name":"Kozilek, Butcher of Truth","scryfallId":"fedb3888-a020-4c13-a845-0b5c808b96d3"},{"index":1551,"token":false,"name":"The Underworld Cookbook","scryfallId":"4f24504e-b397-4b98-b8e8-8166457f7a2e"},{"index":1553,"token":false,"name":"Steal Artifact","scryfallId":"cdb19bc2-1ebc-4f5c-92cb-66e22a0d92f0"},{"index":1556,"token":false,"name":"Foreboding Fruit","scryfallId":"c5f79ec4-3722-4fda-824b-e80dc7608d01"},{"index":1557,"token":false,"name":"Thunderscape Familiar","scryfallId":"26c9c0aa-9412-4320-aaee-e05369b8bc7b"},{"index":1559,"token":false,"name":"Lord Magnus","scryfallId":"2a02aabb-c464-4672-b37b-d5d713ef8939"},{"index":1560,"token":false,"name":"Ascendant Evincar","scryfallId":"f6cd986b-977a-4d3e-a395-a295c4604184"},{"index":1564,"token":false,"name":"Enormous Baloth","scryfallId":"e476533c-0ff5-4a28-b0c3-fa7b043e8a7f"},{"index":1565,"token":false,"name":"Lazotep Chancellor","scryfallId":"8b3e2d11-0f87-43f2-a961-99a47486f8fa"},{"index":1567,"token":false,"name":"Darkbore Pathway // Slitherbore Pathway","scryfallId":"87a4e5fe-161f-42da-9ca2-67c8e8970e94"},{"index":1568,"token":false,"name":"Mana Drain","scryfallId":"e351ec05-8c4d-4631-9dbf-7f85f664770b"},{"index":1569,"token":false,"name":"Ballynock Cohort","scryfallId":"d191b8f7-40e0-47f3-8395-659f26a12851"},{"index":1570,"token":false,"name":"Krosan Tusker","scryfallId":"13000e59-eb8f-4ab6-83dc-4eb7f974a8f5"},{"index":1572,"token":false,"name":"Pyrotechnics","scryfallId":"d6dd3f91-6651-4d32-8c9b-fa91c002ea24"},{"index":1574,"token":false,"name":"Guardian Angel","scryfallId":"e7bf120c-c229-4c97-8d88-09d8a6c7ba78"},{"index":1575,"token":false,"name":"Hostility","scryfallId":"9b54945a-d355-40fd-b1fd-9ecb2d696de5"},{"index":1576,"token":false,"name":"Yawgmoth's Agenda","scryfallId":"50f7ea7f-4f17-4f78-b68e-693e265ca829"},{"index":1577,"token":false,"name":"Weapon Surge","scryfallId":"19330317-0c5e-44fc-bb87-89b3f6dd3704"},{"index":1578,"token":false,"name":"Steelfin Whale","scryfallId":"7e7ca8b6-d7e0-4af2-a578-bf45a8731c19"},{"index":1579,"token":false,"name":"Dragon Whelp","scryfallId":"2014ba70-9f15-4d37-8574-73bcf69c37d2"},{"index":1580,"token":false,"name":"Twilight Panther","scryfallId":"5fb149cc-74ca-4bc3-8efc-10ce872b59fb"},{"index":1582,"token":false,"name":"Strength in Numbers","scryfallId":"9221d1fe-0269-45fc-b2b2-5bc242fa7218"},{"index":1583,"token":true,"name":"Goat Token (W, 0/1)","scryfallId":"6a0b0bdf-13c7-498a-b2fb-83257f1e0fea"},{"index":1584,"token":false,"name":"Blazing Specter","scryfallId":"3bd397be-0e61-4f41-b0cf-f0c9d2440da7"},{"index":1585,"token":true,"name":"Gargoyle Token (Colorless, 3/4)","scryfallId":"d41faa34-e156-4ca3-a528-dc78a442d261"},{"index":1588,"token":false,"name":"Timberpack Wolf","scryfallId":"d16928c9-0470-46ec-b92d-0d6ff9f23ef7"},{"index":1589,"token":false,"name":"Mind Control","scryfallId":"37151305-e489-4df1-9b0a-c5e11c77d2f1"},{"index":1590,"token":false,"name":"Aethersnipe","scryfallId":"a8691ca3-8772-40f6-a7dd-68fe8efd7cf4"},{"index":1591,"token":false,"name":"Court of Ambition","scryfallId":"5deb0185-62b3-474b-83a1-25473fdae4fa"},{"index":1593,"token":false,"name":"Eternal of Harsh Truths","scryfallId":"0389daf7-0818-488f-8e6a-94818a6c94a6"},{"index":1594,"token":false,"name":"Will of the Naga","scryfallId":"9fed1c4d-f11e-476a-bbb2-06ffc6e261f3"},{"index":1595,"token":false,"name":"Kargan Intimidator","scryfallId":"d52e4230-63f7-4a82-8fa8-30363ebabbce"},{"index":1596,"token":false,"name":"Skullclamp","scryfallId":"ae5d9152-6574-4a32-a93a-77077a782fce"},{"index":1597,"token":false,"name":"Patron of the Vein","scryfallId":"9b83c81d-b10e-47a3-a1b9-4582f3205fca"},{"index":1598,"token":false,"name":"Feroz's Ban","scryfallId":"5133a47c-bde3-49d5-ba44-196980ace436"},{"index":1599,"token":false,"name":"Blex, Vexing Pest // Search for Blex","scryfallId":"44fad71f-5928-4ba3-bd53-2dedd24f0277"},{"index":1600,"token":false,"name":"Razormane Masticore","scryfallId":"d9b1d6b0-a13a-4bb2-ba07-1a7742953b15"},{"index":1601,"token":false,"name":"Benthic Infiltrator","scryfallId":"b6072316-a837-4794-9ad8-d009f351360f"},{"index":1602,"token":false,"name":"Vessel of Endless Rest","scryfallId":"93ec86a5-7d2f-4413-919e-b4f7c70457df"},{"index":1603,"token":false,"name":"Grave Strength","scryfallId":"72bc4463-69f6-4039-987d-e5db2ef256d5"},{"index":1605,"token":false,"name":"Weed Strangle","scryfallId":"c1f7fb79-19a8-483a-bf91-e687f7da4e9c"},{"index":1606,"token":false,"name":"Trostani's Judgment","scryfallId":"d707bdb1-1f8c-4cc0-be01-496f3f03b878"},{"index":1607,"token":false,"name":"Belfry Spirit","scryfallId":"556e4e71-b149-49c8-8a22-83660bef57bb"},{"index":1608,"token":false,"name":"Throne of Makindi","scryfallId":"9a2731e9-ea63-4615-9ca4-8759fb15881e"},{"index":1609,"token":false,"name":"Shanodin Dryads","scryfallId":"1ac8bdb0-2dfd-4531-a4d9-420f2f2a90be"},{"index":1610,"token":false,"name":"Wormfang Behemoth","scryfallId":"1c7f29aa-c069-4adb-b313-6a56849905d4"},{"index":1611,"token":false,"name":"Dance of Shadows","scryfallId":"38a1b403-776f-4fd7-a77a-b73946ab179d"},{"index":1612,"token":false,"name":"Kindled Fury","scryfallId":"cffb2c38-76b0-4d5f-a4d1-e2494f4be192"},{"index":1613,"token":true,"name":"Angel Token (W, 4/4)","scryfallId":"71766a5a-ce00-4e48-b4f6-0d1a7f5b2691"},{"index":1614,"token":false,"name":"Beseech the Queen","scryfallId":"b578ec2d-31d2-4ce0-9fec-4263a4eceabd"},{"index":1615,"token":false,"name":"Saproling Infestation","scryfallId":"8642e530-914c-4149-944a-c4966ee27299"},{"index":1616,"token":false,"name":"Void Winnower","scryfallId":"ee3eabf8-48a8-49b8-858f-a246e549d1fe"},{"index":1617,"token":false,"name":"Coiling Oracle","scryfallId":"ab0aca0f-0f14-46d4-bfbc-ccfdfa2a2690"},{"index":1618,"token":false,"name":"Baral, Chief of Compliance","scryfallId":"60e16d94-1166-4050-8554-686e153a7f80"},{"index":1619,"token":false,"name":"Spined Karok","scryfallId":"c37ae6b5-225a-410e-ab22-13e923bdfb65"},{"index":1620,"token":false,"name":"Paradox Haze","scryfallId":"09dc5495-e992-4709-b04f-7ac980b6e99f"},{"index":1621,"token":false,"name":"Dimir Spybug","scryfallId":"7c18c450-0bfb-4ba6-9212-b5833fce63a2"},{"index":1622,"token":false,"name":"Spidery Grasp","scryfallId":"1dc24c93-2670-47c0-bb15-d1fff0fd19eb"},{"index":1623,"token":false,"name":"Jeska, Thrice Reborn","scryfallId":"2de336a3-224f-49e0-b4ff-34bf3de398bf"},{"index":1624,"token":false,"name":"Fated Conflagration","scryfallId":"9cf2cea6-0356-4036-9472-cf45ee225702"},{"index":1625,"token":false,"name":"Sylvan Might","scryfallId":"a4e1ecf4-bf72-4ae9-9993-9b9a6ca80da7"},{"index":1626,"token":false,"name":"Dreadmalkin","scryfallId":"7327cfac-a4a4-445e-9d04-51c1ca142140"},{"index":1627,"token":false,"name":"Crush Contraband","scryfallId":"13e162b3-2e5a-4235-a2a7-1c8e3e9f2c19"},{"index":1628,"token":false,"name":"Desolation Giant","scryfallId":"b74a47b5-100d-424f-8432-7668c50458f8"},{"index":1629,"token":false,"name":"Codex Shredder","scryfallId":"4f5a3293-f3e7-4f68-af6a-b478959226c1"},{"index":1630,"token":false,"name":"Ghost Quarter","scryfallId":"bbf4fd36-17b5-44e8-92e4-89e4c6fcdc75"},{"index":1631,"token":false,"name":"Hillcomber Giant","scryfallId":"e3d48857-2fb6-4163-8785-12436db1b37c"},{"index":1632,"token":false,"name":"Panic Attack","scryfallId":"e9c6cbc8-e33a-4692-aff0-4de9bb65421d"},{"index":1633,"token":false,"name":"Silverflame Ritual","scryfallId":"cad7efd1-5f53-4466-9a02-c474c265298a"},{"index":1634,"token":false,"name":"Phyrexian Rebirth","scryfallId":"36b7536d-6b0b-4906-ba88-7fcfe9b854ee"},{"index":1635,"token":false,"name":"Hurricane","scryfallId":"0dd7e1ab-9279-47b3-b5a8-401f35cd69f1"},{"index":1636,"token":false,"name":"Give // Take","scryfallId":"9af07d28-45a2-45d6-b1cb-0858c609a881"},{"index":1637,"token":false,"name":"Hungering Hydra","scryfallId":"249b3f2b-0725-4079-b7fd-70fd8b6c41e9"},{"index":1638,"token":false,"name":"Thran Dynamo","scryfallId":"508a8735-642c-4f22-bbd9-4a189d93e7b7"},{"index":1639,"token":false,"name":"Monstrous Growth","scryfallId":"0523c816-dddf-4b63-8db8-5e41dc673e5f"},{"index":1641,"token":false,"name":"Master Transmuter","scryfallId":"252482b2-aaa7-49f3-af8c-30923ca98994"},{"index":1644,"token":false,"name":"Snow-Covered Swamp","scryfallId":"65a3c27f-6b15-49b6-ac89-36cfb79b3b54"},{"index":1645,"token":false,"name":"Gyome, Master Chef","scryfallId":"c48d1586-23e9-4b0e-91ff-01bd6f32427c"},{"index":1646,"token":false,"name":"Capture Sphere","scryfallId":"51609ebc-2a80-47f9-99c5-e0d1a0f617e8"},{"index":1647,"token":false,"name":"Standstill","scryfallId":"3ede3f6f-e642-4fe4-aa37-0f01cdf4d149"},{"index":1648,"token":false,"name":"Library of Leng","scryfallId":"0634ab23-4691-4c77-9b8f-bfd9d99b31a1"},{"index":1650,"token":false,"name":"Master of Winds","scryfallId":"0caaf92a-3d9d-4c52-acff-cf960ec55e47"},{"index":1651,"token":true,"name":"Wolf Token (G, 2/2)","scryfallId":"ba563df6-08d8-465c-a89e-858e26f6b49b"},{"index":1652,"token":false,"name":"Magnetic Mountain","scryfallId":"8306561a-3e56-4743-92cb-3fc102977e6a"},{"index":1654,"token":false,"name":"High Market","scryfallId":"f4c58683-65a6-4df9-8952-458e397b1374"},{"index":1655,"token":false,"name":"Rukh Egg","scryfallId":"d805f1f4-ac45-404d-b52c-4d5eb019e24a"},{"index":1656,"token":false,"name":"Urza's Bauble","scryfallId":"58c9e9a7-e170-4361-b7d5-22fc0771c489"},{"index":1657,"token":false,"name":"Mizzium Mortars","scryfallId":"85e72d7b-8d0f-4953-b8b1-7ddfaaa9fc06"},{"index":1658,"token":false,"name":"Barishi","scryfallId":"f263eb80-f8f2-4b32-8e8b-a297de9f3666"},{"index":1659,"token":false,"name":"Tormod, the Desecrator","scryfallId":"82aab532-0f3e-4569-9bef-18ce90654e5d"},{"index":1660,"token":false,"name":"Sol Ring","scryfallId":"c4300d24-1cae-4dd5-be7e-38cc677cf5bd"},{"index":1661,"token":false,"name":"Thopter Assembly","scryfallId":"94858a1d-7107-4ae4-a519-c3f7904146fa"},{"index":1662,"token":false,"name":"Triplicate Titan","scryfallId":"568dd5a6-86f4-4039-87d7-812120c8ab94"},{"index":1663,"token":false,"name":"Mana Leak","scryfallId":"6170653c-3d34-4988-a7ca-a708cbc6da78"},{"index":1664,"token":false,"name":"Chaos Wand","scryfallId":"10b0724c-ad0e-4686-aa41-b9e955913b7f"},{"index":1665,"token":false,"name":"Emeria's Call // Emeria, Shattered Skyclave","scryfallId":"10bd9fc7-f079-42e8-8436-c5462abf0220"},{"index":1666,"token":false,"name":"Shatterskull Charger","scryfallId":"6c6d6bc3-2162-4c2b-a5de-25103e706e37"},{"index":1667,"token":false,"name":"Integrity // Intervention","scryfallId":"4a82084e-b178-442b-8007-7b2a70f3fbba"},{"index":1668,"token":false,"name":"Sky Hussar","scryfallId":"4d02d606-5701-444a-9743-b9cf0e742ccb"},{"index":1669,"token":false,"name":"Starfield Mystic","scryfallId":"80382963-a9d7-4c2d-8671-8dd3fdd4dbdc"},{"index":1671,"token":false,"name":"Ravenous Rats","scryfallId":"701efb83-ea12-4630-9345-87a3e86bec49"},{"index":1672,"token":false,"name":"Junktroller","scryfallId":"5e2c5f0a-755f-4d4f-b5f8-a938562797f9"},{"index":1673,"token":false,"name":"Void Stalker","scryfallId":"7fc30e31-4796-4e98-992c-a56cd51ad3c9"},{"index":1674,"token":false,"name":"Idyllic Tutor","scryfallId":"0a5e7a59-7322-46eb-9903-00131234b310"},{"index":1675,"token":false,"name":"Umara Wizard // Umara Skyfalls","scryfallId":"890eee8d-a339-4143-adfa-1b17ec10c099"},{"index":1676,"token":false,"name":"Zada's Commando","scryfallId":"f4ad826d-c7e6-4dfd-991f-15d75b87d504"},{"index":1677,"token":false,"name":"Kazandu Tuskcaller","scryfallId":"aec3ad60-dc8a-42ba-bfee-3b9008b0c91d"},{"index":1678,"token":false,"name":"Jolrael, Mwonvuli Recluse","scryfallId":"f1ccd23e-c883-474b-93e5-4131aa1e6e8a"},{"index":1681,"token":false,"name":"Keen Duelist","scryfallId":"04f9eb05-7c1d-49f5-a9dc-c44e1a1add89"},{"index":1682,"token":false,"name":"Desecrator Hag","scryfallId":"1de48517-5993-4d0f-99a5-55f1a4227507"},{"index":1683,"token":false,"name":"Skyclave Geopede","scryfallId":"490f3d74-6144-4cbc-80ed-37cfcdbd159a"},{"index":1684,"token":false,"name":"Vizier of the Scorpion","scryfallId":"2444c7dc-7aa1-4476-8660-19d26607306d"},{"index":1685,"token":false,"name":"Mishra's Factory","scryfallId":"ad1577a3-a350-45e3-af3d-62c85207514f"},{"index":1686,"token":false,"name":"Grave Servitude","scryfallId":"fbe072da-0524-492b-af3d-7c2600e915ab"},{"index":1687,"token":false,"name":"Nimble Mongoose","scryfallId":"8a6374ad-71be-422e-bd76-4f08fbf43048"},{"index":1688,"token":false,"name":"Ghirapur Guide","scryfallId":"23680a1a-7c8d-4ea0-a62c-a302f07b6ed5"},{"index":1689,"token":false,"name":"Nahiri's Wrath","scryfallId":"8ea4abfd-210e-45ec-acf2-bd270806b12f"},{"index":1690,"token":false,"name":"Liliana's Defeat","scryfallId":"2edf6d59-6c04-49d0-9960-f7b6a33304da"},{"index":1691,"token":false,"name":"Cinder Seer","scryfallId":"d96e7522-e0bc-4e23-8e4b-40a0c28ea986"},{"index":1692,"token":false,"name":"Defiant Vanguard","scryfallId":"4c0bd267-59ec-41df-b0b7-37f6e6d6b073"},{"index":1693,"token":false,"name":"Slaughter-Priest of Mogis","scryfallId":"a2b441c0-261e-4094-b694-5e11ea3c14ab"},{"index":1694,"token":false,"name":"Chrome Mox","scryfallId":"f340cbf7-5bbe-45b9-a4bf-d1caa500ff93"},{"index":1698,"token":false,"name":"Pus Kami","scryfallId":"4f142dea-4751-453f-93a5-c8fdaba8a1b3"},{"index":1699,"token":false,"name":"Specter's Shroud","scryfallId":"110cbd16-2105-4dc8-b253-8f4cc0f72b50"},{"index":1702,"token":false,"name":"Whirlwind Denial","scryfallId":"9e127856-bedd-40a9-9e8e-d1f9fbefe07d"},{"index":1704,"token":false,"name":"Forethought Amulet","scryfallId":"700f53d3-0a84-4c55-8495-786f0f0783db"},{"index":1706,"token":false,"name":"Satyr's Cunning","scryfallId":"646d8201-be68-42fa-bcfd-42d81a2ad195"},{"index":1708,"token":false,"name":"Wayward Swordtooth","scryfallId":"a53cf129-3ab1-4106-9cef-ce76c5ffcc4f"},{"index":1709,"token":false,"name":"Viashino Warrior","scryfallId":"bb467271-898f-4bcd-8533-e8165b318b43"},{"index":1710,"token":false,"name":"Dreadbore","scryfallId":"a83945c6-4dc6-4d9a-9bc2-2d4a264e5422"},{"index":1711,"token":false,"name":"Vizier of Many Faces","scryfallId":"b2781c44-aa90-4a37-a812-33c643ba4deb"},{"index":1713,"token":false,"name":"Manaforge Cinder","scryfallId":"812f4eb6-06bb-4bc9-83da-0141f7ee4730"},{"index":1714,"token":false,"name":"Kirtar's Wrath","scryfallId":"b5a0c4e6-d50e-42e8-b062-8f6ef5950ab7"},{"index":1715,"token":false,"name":"Blood-Toll Harpy","scryfallId":"c081f3e2-e4e6-4ef5-9969-64aca9c11413"},{"index":1716,"token":false,"name":"Urborg","scryfallId":"d0a261d0-7678-46f7-9285-d541486567d8"},{"index":1717,"token":false,"name":"Felidar Retreat","scryfallId":"45340647-4d3e-4be1-b0e6-e40cc56a438b"},{"index":1718,"token":false,"name":"Nested Shambler","scryfallId":"eb8595c6-5237-4ed1-98e4-8615bb0eb8e1"},{"index":1719,"token":false,"name":"Razorgrass Screen","scryfallId":"21e79f57-2214-414a-ab34-2b737d4bb972"},{"index":1720,"token":false,"name":"Mystic Repeal","scryfallId":"6797195a-508f-45b1-964d-da842dc46ca8"},{"index":1721,"token":false,"name":"Garna, the Bloodflame","scryfallId":"5c98ba8f-7380-4d9a-ba2c-db4b64c78b2d"},{"index":1722,"token":false,"name":"Roofstalker Wight","scryfallId":"8f43fb78-497b-4a05-84cd-d2aca4b2db1b"},{"index":1723,"token":false,"name":"Sunhome Stalwart","scryfallId":"a431f183-17eb-4a6c-a137-d106bdc8c997"},{"index":1724,"token":false,"name":"Relief Captain","scryfallId":"2ecacff4-87b9-4cc1-bfbe-019cfda82d17"},{"index":1725,"token":false,"name":"Nightscape Battlemage","scryfallId":"832f4afa-0cc6-4721-8714-c92552ba073e"},{"index":1727,"token":true,"name":"Elemental Token (R, 3/1)","scryfallId":"9b9cc37a-b9c3-40c2-a3e4-abfec86e199b"},{"index":1728,"token":false,"name":"Inscription of Abundance","scryfallId":"fcd2e01e-a143-4b62-8b01-d253fb35c590"},{"index":1730,"token":false,"name":"Illusionary Forces","scryfallId":"1f011ad5-0ff1-4538-942e-b72e93d87e3c"},{"index":1731,"token":false,"name":"Putrid Raptor","scryfallId":"9127942b-d73d-42a9-9f97-6a39fa798a8b"},{"index":1732,"token":false,"name":"Everflowing Chalice","scryfallId":"2f7fc988-273a-45f4-85b6-597d1827504f"},{"index":1733,"token":false,"name":"Pheres-Band Brawler","scryfallId":"10ac20a9-6b10-4165-ad81-a47587b64d1e"},{"index":1734,"token":false,"name":"Bogbrew Witch","scryfallId":"7559cf3e-7fad-4bcf-8551-045f9150e014"},{"index":1735,"token":false,"name":"Archangel of Thune","scryfallId":"531cba81-afd7-4be4-adec-87edb77ba2a9"},{"index":1736,"token":false,"name":"Nezumi Graverobber // Nighteyes the Desecrator","scryfallId":"8f047a8b-6c94-4b99-bcaa-10680400ee25"},{"index":1737,"token":false,"name":"Otherworldly Journey","scryfallId":"5cd220e4-2e2a-437e-aa4e-1007247c8e4d"},{"index":1738,"token":false,"name":"Sunflare Shaman","scryfallId":"6db24aa7-4922-4b39-9964-f76df09cba12"},{"index":1741,"token":false,"name":"Taiga","scryfallId":"453e1bf8-e570-4b9b-8f41-5f4f31ae3b0e"},{"index":1742,"token":false,"name":"Cancel","scryfallId":"c8153fad-8a06-46f3-8a5a-2d0d4841191a"},{"index":1744,"token":false,"name":"Pit Imp","scryfallId":"24c7acfe-b5b2-426f-a5a1-1ff8ef7ebf72"},{"index":1746,"token":false,"name":"Blight Sickle","scryfallId":"c0f828c7-aedc-462b-8455-46e8a90feb85"},{"index":1747,"token":false,"name":"Faerie Macabre","scryfallId":"ead8befa-27dd-4ec4-b317-1c231407e0ac"},{"index":1749,"token":false,"name":"Seek the Wilds","scryfallId":"31f20c0e-acd6-40fc-8b1a-163a3f661396"},{"index":1751,"token":false,"name":"Expedition Skulker","scryfallId":"2966b1f0-3d30-4d92-87e5-f39ceacefbd2"},{"index":1752,"token":false,"name":"Shaman's Trance","scryfallId":"dfc33a4f-9ec2-4324-82a1-a4b9700572f2"},{"index":1753,"token":false,"name":"Rabid Elephant","scryfallId":"fe394a38-ee44-4342-adcf-8c65d14f4978"},{"index":1754,"token":false,"name":"Cunning Survivor","scryfallId":"2f9093e7-c129-4efa-9f25-a2366f92e15a"},{"index":1755,"token":false,"name":"Shacklegeist","scryfallId":"04dc4dda-1bc2-4ff7-8b66-b55be96db6e8"},{"index":1756,"token":false,"name":"Evanescent Intellect","scryfallId":"d38cfe97-77b3-4423-95ac-88eb850cf854"},{"index":1758,"token":true,"name":"Spider Token (G, 1/3)","scryfallId":"7a0275af-708d-4c43-b226-c88cb9a8054c"},{"index":1759,"token":false,"name":"Nature's Revolt","scryfallId":"e0c9b948-63f9-458d-82ae-69ebe2ac9fe0"},{"index":1760,"token":false,"name":"Mortify","scryfallId":"38c5e2e8-b781-4265-bce1-98fa25ddd8c3"},{"index":1761,"token":false,"name":"Thunderheads","scryfallId":"56de9727-021e-4b37-b80b-08dcd898aec0"},{"index":1762,"token":true,"name":"Boar Token (G, 2/2)","scryfallId":"1a7f9534-ccbc-4304-afad-d2896be60b8e"},{"index":1763,"token":false,"name":"Yedora, Grave Gardener","scryfallId":"320b9678-5bbc-40dd-a508-90a647e95a71"},{"index":1765,"token":false,"name":"Rimrock Knight // Boulder Rush","scryfallId":"b218d970-d3a9-4845-8ee9-efad9aff0fdd"},{"index":1766,"token":false,"name":"Quicksand","scryfallId":"ce833a90-7c1d-4c05-ace3-57e974c0769b"},{"index":1767,"token":false,"name":"Seraph Sanctuary","scryfallId":"e1c1fa29-362f-40b4-b67f-513f6592fb3b"},{"index":1768,"token":false,"name":"Patron of the Moon","scryfallId":"5e5fcd6f-1653-44bf-a796-4c9ff9adf390"},{"index":1771,"token":false,"name":"Rishadan Port","scryfallId":"b7d8f28e-ea99-4a6f-82ac-c39725150806"},{"index":1772,"token":false,"name":"Saheeli, the Gifted","scryfallId":"b32b3dae-7616-46ad-b9bf-854559cda977"},{"index":1773,"token":false,"name":"Emberhorn Minotaur","scryfallId":"81e7aeca-eaba-4d9a-b061-0d9a63b03b3a"},{"index":1774,"token":false,"name":"Hour of Promise","scryfallId":"872f5078-95b2-44df-b135-d2e464b73d12"},{"index":1777,"token":false,"name":"Treasury Thrull","scryfallId":"98a943d6-e79d-4956-82f1-8dfbe5abd643"},{"index":1778,"token":false,"name":"Propaganda","scryfallId":"48f9976c-e8a2-4f5a-a2d0-aa63b27c19dc"},{"index":1780,"token":false,"name":"Rags // Riches","scryfallId":"11d84618-aca9-47dc-ae73-36a2c29f584c"},{"index":1781,"token":false,"name":"Kraken's Eye","scryfallId":"48052433-c4d3-434e-a609-e8400150a0f6"},{"index":1784,"token":false,"name":"Elder Spawn","scryfallId":"99cc045e-01a8-4f14-a86d-0a67ec35d6b7"},{"index":1785,"token":false,"name":"Riddleform","scryfallId":"4702b589-28cd-4fb7-add8-773f472b0df3"},{"index":1786,"token":false,"name":"Sudden Death","scryfallId":"5d724faa-a988-4c08-875d-d18f48926a0a"},{"index":1788,"token":false,"name":"Formless Nurturing","scryfallId":"495dad67-990c-48b0-9872-c4a92efc10a5"},{"index":1789,"token":false,"name":"Feral Krushok","scryfallId":"f6a81374-e0a1-4c5e-a123-5ed08673b5c6"},{"index":1790,"token":false,"name":"Groffskithur","scryfallId":"75e84098-c15c-40f4-9d8a-3fa5da26a268"},{"index":1791,"token":false,"name":"Crosis, the Purger","scryfallId":"e5f336d8-12a4-482d-8ffd-c205858c72ba"},{"index":1792,"token":false,"name":"Demystify","scryfallId":"d0df839f-dc4c-44b0-82c7-cb2037172ac5"},{"index":1793,"token":false,"name":"Visions","scryfallId":"f7d6a255-7b13-44ed-8604-5d3f82cabd98"},{"index":1794,"token":false,"name":"Sigiled Sword of Valeron","scryfallId":"497d08a8-cffe-4164-a941-d8c8c85644c7"},{"index":1795,"token":false,"name":"Ruinous Path","scryfallId":"709ab9cf-eed8-4d73-b10d-c7f6d8750328"},{"index":1796,"token":false,"name":"Inventor's Goggles","scryfallId":"8fc62d61-2bc0-4b84-a0e9-5a01fcd4ef92"},{"index":1797,"token":false,"name":"Embereth Shieldbreaker // Battle Display","scryfallId":"13b553f1-8107-42a8-841a-91adf71cff72"},{"index":1798,"token":false,"name":"Spellheart Chimera","scryfallId":"8782a7b7-79ca-4e5c-845b-d662222574c0"},{"index":1799,"token":false,"name":"Dragonlord Dromoka","scryfallId":"28fad224-4198-48cc-88cd-13bdc0ddcf8c"},{"index":1800,"token":false,"name":"Theft of Dreams","scryfallId":"29019e28-4ef8-4732-9972-0a47305fe303"},{"index":1801,"token":false,"name":"Spitting Earth","scryfallId":"a4c620ef-3575-467c-b9e7-e5f6bbd221be"},{"index":1802,"token":false,"name":"Ember Swallower","scryfallId":"901b2e10-fb43-4f75-8357-861988aeb05c"},{"index":1803,"token":false,"name":"Pyroclasm","scryfallId":"ea518d8f-568e-4f4a-b729-fdf4c770b9d0"},{"index":1804,"token":false,"name":"Shaleskin Plower","scryfallId":"42658b33-9a12-403b-bc7d-807fbe1f1a36"},{"index":1805,"token":false,"name":"Whiteout","scryfallId":"ee7bb29a-daf4-42d3-9404-c9f25d72a648"},{"index":1806,"token":false,"name":"Stigma Lasher","scryfallId":"ce5d1fd4-0543-46ce-bcea-1695fc04e85b"},{"index":1807,"token":false,"name":"Urza's Mine","scryfallId":"ddf85792-470b-4b42-99ac-9cb43a575523"},{"index":1808,"token":false,"name":"Sludge Strider","scryfallId":"7b8339ca-2971-4c5a-83ed-2682e5b3838d"},{"index":1809,"token":false,"name":"Rally the Troops","scryfallId":"61d92577-c3e2-4129-8974-89eb896cdc2d"},{"index":1812,"token":false,"name":"Dragonlord Ojutai","scryfallId":"27fd84d7-8b8f-4fe8-a3bc-649f9ae50e8f"},{"index":1813,"token":false,"name":"Uncomfortable Chill","scryfallId":"c4c30d7d-0ba6-4953-a90b-ad9405da0f05"},{"index":1814,"token":false,"name":"Summoner's Egg","scryfallId":"3581ac02-5dab-423a-9cf3-275d9203f26d"},{"index":1818,"token":false,"name":"Profane Procession // Tomb of the Dusk Rose","scryfallId":"828e8abf-30bc-486b-a3fb-8a0a9c73eeb1"},{"index":1819,"token":false,"name":"Anaba Bodyguard","scryfallId":"7f084952-991b-459f-b347-e7d2f2f04b31"},{"index":1820,"token":false,"name":"Sleeping Potion","scryfallId":"6f79f4b2-71cd-4f78-a161-d75b162c745e"},{"index":1821,"token":false,"name":"Infernal Darkness","scryfallId":"0230e9bf-da21-4014-a834-d4fd2f5b31df"},{"index":1822,"token":false,"name":"Choking Sands","scryfallId":"2211a86b-24d6-4db6-9621-3f84c7f94cc4"},{"index":1823,"token":false,"name":"Radiant Flames","scryfallId":"abaa3489-b00f-449e-b555-f6d33897388b"},{"index":1824,"token":false,"name":"Hedron-Field Purists","scryfallId":"c48e9f90-4b13-4281-943c-126be4ff1ce0"},{"index":1825,"token":false,"name":"Selesnya Sanctuary","scryfallId":"02c63879-d0e2-4bb3-b0fe-52be077030df"},{"index":1826,"token":false,"name":"Flashfires","scryfallId":"6751a503-c121-42ab-be8a-9d6494026edb"},{"index":1827,"token":false,"name":"Tezzeret's Gambit","scryfallId":"05e5dbfd-84cf-4fe1-850f-3d2965ed3120"},{"index":1828,"token":false,"name":"Mindmelter","scryfallId":"4a5bf575-6d09-4cb0-8fe0-8e49d2c39fd5"},{"index":1829,"token":false,"name":"Millikin","scryfallId":"527f6a89-92b3-4445-bc0a-012308bea2fd"},{"index":1830,"token":false,"name":"Battering Ram","scryfallId":"bd24f19a-50cc-482e-b6fc-141937f52640"},{"index":1831,"token":false,"name":"Enduring Scalelord","scryfallId":"5dfdfff3-0ef8-4e9a-b6bd-a0e11cbdf22e"},{"index":1832,"token":false,"name":"Psychic Spear","scryfallId":"1c2f024b-e77e-426b-930e-85b87e046f9b"},{"index":1833,"token":false,"name":"Wolf of Devil's Breach","scryfallId":"fedce04c-e7bc-4db0-94a1-66131761512c"},{"index":1834,"token":false,"name":"Sift","scryfallId":"bf5b23da-9ba8-4b43-a5c9-51e1fc253913"},{"index":1835,"token":false,"name":"Kuldotha Phoenix","scryfallId":"0610102f-bfc0-45f9-9b9c-cdade744e470"},{"index":1836,"token":false,"name":"Juggernaut","scryfallId":"82845f1e-a114-4d4f-8b6d-29e37fe1e925"},{"index":1837,"token":false,"name":"Silverquill Command","scryfallId":"201c00ae-8044-4c99-a791-5c076d71aa73"},{"index":1838,"token":false,"name":"Venom Sliver","scryfallId":"115537f3-0e1d-4c92-b496-8e6aabba15ca"},{"index":1839,"token":false,"name":"Tower Geist","scryfallId":"c9e9f552-34b6-43a5-8ef8-9d5208f4cae0"},{"index":1840,"token":false,"name":"Butcher Ghoul","scryfallId":"37117234-76eb-4a94-8230-a0a8c9b92e47"},{"index":1843,"token":false,"name":"Yavimaya Ancients","scryfallId":"91708e45-f9a1-4c2e-973d-bfc294926c93"},{"index":1844,"token":false,"name":"Razia, Boros Archangel","scryfallId":"87e80447-9572-43a7-8487-3249cd9ce596"},{"index":1845,"token":false,"name":"Avatar of Woe","scryfallId":"aaa29bab-6ffe-4fc8-8cda-cd745ca0cfd4"},{"index":1846,"token":false,"name":"Burrenton Shield-Bearers","scryfallId":"1afc1033-0004-43c1-9341-c5ed0b0048f2"},{"index":1847,"token":false,"name":"Blue Elemental Blast","scryfallId":"0892ec35-8bab-4fe5-8cc9-a25032d4bc8d"},{"index":1848,"token":false,"name":"Malakir Rebirth // Malakir Mire","scryfallId":"609d3ecf-f88d-4268-a8d3-4bf2bcf5df60"},{"index":1849,"token":false,"name":"Gempalm Incinerator","scryfallId":"909ac95c-ee41-482c-8b4d-196fe0d5b3c1"},{"index":1850,"token":false,"name":"Ertai's Familiar","scryfallId":"354c9de7-0cdf-4302-9d1a-ae17eca13053"},{"index":1852,"token":false,"name":"Zealous Inquisitor","scryfallId":"7621b1af-fdbd-4604-b37c-04fb8f68c3b6"},{"index":1853,"token":false,"name":"Elves of Deep Shadow","scryfallId":"6040ba5e-7042-4095-9000-89bcb8ce1ea6"},{"index":1854,"token":false,"name":"Orcish Lumberjack","scryfallId":"2b8cc73a-1598-497b-97f4-e42840085e10"},{"index":1855,"token":false,"name":"Phage the Untouchable","scryfallId":"d497a5a3-65fb-4c12-b3f2-8ce4cf4e0f6f"},{"index":1856,"token":false,"name":"Wardscale Crocodile","scryfallId":"aa5341b9-06e4-4360-a75d-f405d468276e"},{"index":1858,"token":false,"name":"Auriok Transfixer","scryfallId":"9f5c3f22-f228-4503-9d35-ee1b36a46ef0"},{"index":1860,"token":false,"name":"Impostor of the Sixth Pride","scryfallId":"83298c8a-02c4-4ada-9a41-4b973bb58ac6"},{"index":1861,"token":false,"name":"Sunscorch Regent","scryfallId":"6c01d109-f696-4e05-9a9d-0ffbb7861e4f"},{"index":1862,"token":false,"name":"Goblin Oriflamme","scryfallId":"eed56817-893e-4637-bcd6-00335993f5e9"},{"index":1864,"token":false,"name":"Majestic Auricorn","scryfallId":"3d63b878-4d0d-444c-9db2-05cf5dd3fa8c"},{"index":1865,"token":false,"name":"Reaper of Night // Harvest Fear","scryfallId":"39c0abef-f59c-473a-8a6e-eacd4a78ff72"},{"index":1866,"token":false,"name":"Apex Devastator","scryfallId":"b345eb6f-ef2e-4d24-964c-252956031e4f"},{"index":1867,"token":false,"name":"Needle Storm","scryfallId":"f31bc178-f5ec-4e90-b8cf-2c7b00386c98"},{"index":1869,"token":false,"name":"Tigereye Cameo","scryfallId":"25976da8-338d-4f46-b8ea-78a0aa3daa35"},{"index":1870,"token":false,"name":"Sakura-Tribe Elder","scryfallId":"341aae9f-ae72-4f7c-8fc3-6e3d32853e3e"},{"index":1872,"token":false,"name":"Serum Tank","scryfallId":"126ec055-1a7d-426b-a87f-c85c60aa7fc3"},{"index":1874,"token":false,"name":"Dance of the Manse","scryfallId":"c0cc14d0-8ddf-4cf0-b5f5-b398d4ff3651"},{"index":1875,"token":false,"name":"Spidersilk Armor","scryfallId":"9eb7694f-af4c-4152-b868-528257d05154"},{"index":1876,"token":false,"name":"Heart of Light","scryfallId":"f599cc6e-1ecb-407c-98fc-06e903f8b72f"},{"index":1877,"token":false,"name":"Port Town","scryfallId":"b866712a-c3ef-4a43-ac0f-146c7836f0d6"},{"index":1878,"token":false,"name":"Marauding Boneslasher","scryfallId":"ddfb7f50-14b1-4c7d-b4c8-f50bc14f4fb7"},{"index":1879,"token":false,"name":"Darksteel Colossus","scryfallId":"44012fb2-9dbc-408a-b84b-1302b442f699"},{"index":1880,"token":false,"name":"Pathrazer of Ulamog","scryfallId":"3fdd84b5-fd93-483e-a131-028d04d9dea7"},{"index":1881,"token":false,"name":"Feat of Resistance","scryfallId":"b6173466-30db-4b95-a556-dd69e03b731e"},{"index":1882,"token":false,"name":"Crackling Drake","scryfallId":"f00fa3a7-e3e2-4b23-a126-a076e75b5dbd"},{"index":1883,"token":false,"name":"Tranquil Cove","scryfallId":"685ef7b5-ffad-4342-9a3a-f01a6d67d5e2"},{"index":1884,"token":false,"name":"Palace Familiar","scryfallId":"fc0c17c9-54af-4dd4-8d4a-fd5a7b8c3c77"},{"index":1885,"token":false,"name":"Consecrated Sphinx","scryfallId":"da566bc8-6350-481d-99aa-9cea76da2a56"},{"index":1886,"token":false,"name":"The Rack","scryfallId":"0becfc6c-0813-4be1-8220-2742dddd8239"},{"index":1888,"token":false,"name":"Claustrophobia","scryfallId":"3acb4667-29dd-44cb-a817-b3602fc2bf08"},{"index":1889,"token":false,"name":"Consign // Oblivion","scryfallId":"dd76c977-9522-4031-ba4e-c278c8502258"},{"index":1890,"token":false,"name":"Blossoming Bogbeast","scryfallId":"332153ab-1b8e-40a8-b0b4-01f94866d368"},{"index":1891,"token":false,"name":"Arrogant Poet","scryfallId":"556a0816-83c5-41dc-8546-213b21e2cceb"},{"index":1892,"token":false,"name":"Gauntlets of Chaos","scryfallId":"6279176a-3b27-4be7-878c-2745941e12d6"},{"index":1893,"token":false,"name":"Sunrise Seeker","scryfallId":"709d87b3-bf42-47ed-961d-d0e86d3e1d90"},{"index":1894,"token":false,"name":"Amplifire","scryfallId":"8a529382-75d5-4129-880c-16d8425326be"},{"index":1895,"token":false,"name":"Sparkspitter","scryfallId":"0070bbf6-fdee-44ec-bfb8-3e99d6338e6e"},{"index":1896,"token":false,"name":"Exotic Curse","scryfallId":"8ee35d99-9a8a-421b-bf43-74446909d87d"},{"index":1897,"token":false,"name":"Golgari Germination","scryfallId":"2ccedd78-56f8-4624-93be-e69740a187f4"},{"index":1898,"token":false,"name":"Auriok Salvagers","scryfallId":"09c9cd1b-9260-4f98-ac7a-25bb5ae3e06d"},{"index":1899,"token":false,"name":"Cathars' Crusade","scryfallId":"91a54f0a-1e6b-4f1e-8109-605c8c2e777c"},{"index":1900,"token":false,"name":"Mystic Familiar","scryfallId":"b235567a-424e-48da-a94b-c6674a73b3fa"},{"index":1901,"token":false,"name":"Ancestral Blade","scryfallId":"2ba18114-af6c-48cd-82c9-eb6541d566bf"},{"index":1902,"token":false,"name":"Massacre","scryfallId":"4037d22d-3a05-4028-8446-455160beb20c"},{"index":1903,"token":false,"name":"Absolute Grace","scryfallId":"fe7d1839-7180-4b4c-8ddb-7df24573f740"},{"index":1906,"token":false,"name":"Treacherous Terrain","scryfallId":"fda29141-c66b-465c-b46c-dee038e5e59a"},{"index":1907,"token":false,"name":"Nekrataal","scryfallId":"1f6665d5-8896-4c85-afbb-f11de62962ef"},{"index":1908,"token":false,"name":"Vampire Nighthawk","scryfallId":"c6572c70-7162-440d-a315-9fb31cc4849d"},{"index":1909,"token":false,"name":"Return to Dust","scryfallId":"59713368-9626-4466-9be4-8ca08e03a888"},{"index":1910,"token":false,"name":"Midnight Clock","scryfallId":"9eef0851-c2bb-4b11-b9c2-c659abadd0d9"},{"index":1911,"token":false,"name":"Steamflogger Boss","scryfallId":"007ce039-def1-4039-a0a0-ba72e8872dc5"},{"index":1912,"token":false,"name":"Noxious Vapors","scryfallId":"e3cf9326-6e1c-4a05-abea-16d6b6cb2a6d"},{"index":1913,"token":false,"name":"Curfew","scryfallId":"044e36d6-0967-4a66-8269-2224777bbb6c"},{"index":1914,"token":false,"name":"Den Protector","scryfallId":"58ba1b95-270f-48b4-b842-1124a5f8ac34"},{"index":1915,"token":false,"name":"Essence Bottle","scryfallId":"7e3c7760-04d8-424d-a097-df0ca8297837"},{"index":1916,"token":false,"name":"Masked Admirers","scryfallId":"b8cc3361-046c-4908-8b8d-a0502bfc173a"},{"index":1917,"token":false,"name":"Sanitarium Skeleton","scryfallId":"b5e78a44-fff3-4cbf-929b-8dfed4e45d62"},{"index":1918,"token":false,"name":"Wall of Ice","scryfallId":"f1b483ba-ba51-4d8b-a455-a47c6be70ee8"},{"index":1919,"token":false,"name":"Nahiri's Binding","scryfallId":"421eac28-d6f2-44f2-b7ca-eb73fbf23887"},{"index":1920,"token":false,"name":"Woodland Cemetery","scryfallId":"ac7b9979-7bf6-4e06-8f50-2228b586690c"},{"index":1921,"token":false,"name":"Soothsaying","scryfallId":"def384ff-1b6f-4c4f-8151-3c72c29b63ce"},{"index":1922,"token":false,"name":"Wall of Water","scryfallId":"41faed1a-ded8-49ee-8e2a-c60d377775d7"},{"index":1924,"token":false,"name":"Swarm of Rats","scryfallId":"ba1a92e2-6a8f-45fe-84cc-08fde6210077"},{"index":1925,"token":false,"name":"Glen Elendra Archmage","scryfallId":"09516d3d-e6c2-4359-af2a-a4aa244ca033"},{"index":1926,"token":false,"name":"Fatal Push","scryfallId":"387c9f62-6a93-4c88-bdaf-205717d91216"},{"index":1927,"token":false,"name":"Dauthi Voidwalker","scryfallId":"7d54f0dd-5d27-483b-8af9-92a1c5a785f2"},{"index":1928,"token":false,"name":"Spirit Cairn","scryfallId":"d8baf60f-c20b-4b2f-9fe1-df008a9273c6"},{"index":1929,"token":false,"name":"Illuna, Apex of Wishes","scryfallId":"5c974c68-1a9f-457a-8bcb-265d29fee8e4"},{"index":1930,"token":false,"name":"Thriving Isle","scryfallId":"7eb8fd94-2b59-4b05-b4d0-c93497301d19"},{"index":1931,"token":false,"name":"Tidehollow Sculler","scryfallId":"71af4228-093e-4b07-8f9e-e95653da07e4"},{"index":1932,"token":false,"name":"Curse of Predation","scryfallId":"d7fcfc0b-4674-4cd1-85de-823f4ca8c6c5"},{"index":1933,"token":false,"name":"Shirei, Shizo's Caretaker","scryfallId":"0757cb66-7aa2-41a2-8efc-f3f35b70ab9e"},{"index":1934,"token":false,"name":"Ravages of War","scryfallId":"bdf7d5d9-d980-445e-b1e4-5af0681c6e60"},{"index":1935,"token":false,"name":"Duskdale Wurm","scryfallId":"8d10736d-047b-423f-9017-f59732d446bf"},{"index":1936,"token":false,"name":"Joiner Adept","scryfallId":"7acf1a5f-1dbd-4481-b58d-b84e32d2b6b3"},{"index":1938,"token":false,"name":"Negate","scryfallId":"9af377f8-36ee-487a-aa52-06658e544dad"},{"index":1939,"token":false,"name":"Gaea's Protector","scryfallId":"1e8307de-7cae-4618-ac4a-0a0bb89264ce"},{"index":1940,"token":false,"name":"Camouflage","scryfallId":"f50f074a-0825-4ef1-8734-4914c6d6af56"},{"index":1942,"token":false,"name":"Varchild, Betrayer of Kjeldor","scryfallId":"7849b360-afad-4f50-b455-3d118f7bfcd0"},{"index":1944,"token":false,"name":"Tempest Caller","scryfallId":"64d0f22d-0448-4039-b6f3-75d12e10f48c"},{"index":1945,"token":false,"name":"Scouring Sands","scryfallId":"273f25fc-9c9f-4b73-a28b-1461d8fcd443"},{"index":1946,"token":false,"name":"Mass Manipulation","scryfallId":"782760d7-59cc-4d40-a885-6a7980094fee"},{"index":1947,"token":false,"name":"Pristine Angel","scryfallId":"2fbd3a6b-831d-4876-9f84-861cab788747"},{"index":1948,"token":false,"name":"Nebuchadnezzar","scryfallId":"76a0b7cc-0889-4980-a23e-6f5088b374f8"},{"index":1949,"token":false,"name":"Paladin en-Vec","scryfallId":"6b1db895-5e14-48c7-b464-4e36be432579"},{"index":1951,"token":false,"name":"Roar of the Wurm","scryfallId":"14fb6b62-ecec-45c6-bf2e-45070370f0e1"},{"index":1952,"token":false,"name":"Brink of Madness","scryfallId":"ff5391d8-b546-4159-955e-16bb58052311"},{"index":1953,"token":false,"name":"Clockwork Beetle","scryfallId":"bc3c8db7-cf58-4571-b4ad-2b68d73495b2"},{"index":1954,"token":false,"name":"Benalish Marshal","scryfallId":"6dd1a7fc-5dbd-4ed2-9b02-9fd5c55bb629"},{"index":1955,"token":false,"name":"Gaea's Bounty","scryfallId":"66b55e37-fcad-4d50-89d4-5d88269fee66"},{"index":1956,"token":false,"name":"Guerrilla Tactics","scryfallId":"0da436c2-5cc9-49a6-bbf0-6fa3133a56c5"},{"index":1957,"token":false,"name":"Command Tower","scryfallId":"a10140e7-90a2-49fa-b47e-61214e35f9b8"},{"index":1959,"token":false,"name":"Discovery // Dispersal","scryfallId":"ace631d1-897a-417e-8628-0170713f03d3"},{"index":1960,"token":false,"name":"Exploration","scryfallId":"1c3fc61c-c26e-47f3-a1eb-f6f10f8469e2"},{"index":1961,"token":false,"name":"Boros Signet","scryfallId":"47660a06-a8f8-44e9-9de4-6740609ffd36"},{"index":1963,"token":false,"name":"Heirloom Blade","scryfallId":"aae598eb-871d-45af-b12c-346c344ae74b"},{"index":1964,"token":false,"name":"Call to Heel","scryfallId":"0aa6d18f-e814-4090-b9fd-8d62a738c720"},{"index":1965,"token":false,"name":"Feast of the Unicorn","scryfallId":"096e41d6-79c3-463f-ae63-872c3d8729a7"},{"index":1966,"token":false,"name":"Boneyard Wurm","scryfallId":"3342096a-24bf-4f66-911e-d8a0c856f722"},{"index":1967,"token":false,"name":"Beast Hunt","scryfallId":"db385ec5-a33a-45df-a1db-e99dd3f62f6d"},{"index":1968,"token":false,"name":"By Force","scryfallId":"74f429a7-4084-41aa-b156-04fe7262485a"},{"index":1969,"token":false,"name":"Obosh, the Preypiercer","scryfallId":"9c8cf901-1452-4664-be10-0bacc5bef83a"},{"index":1970,"token":false,"name":"Captain's Call","scryfallId":"ac907330-492d-4705-bb8a-1fdb080632e1"},{"index":1971,"token":false,"name":"History of Benalia","scryfallId":"8614579a-0a82-4329-8066-2d9cdf87d691"},{"index":1972,"token":false,"name":"Animate Dead","scryfallId":"1f2cd314-8f99-4443-ae86-a967effc7490"},{"index":1973,"token":false,"name":"Sarcomancy","scryfallId":"5e26f693-4e62-4925-923f-f46376a8a179"},{"index":1974,"token":false,"name":"Winds of Rath","scryfallId":"7cb9dfc8-d0b2-4351-bdd2-392544030558"},{"index":1975,"token":false,"name":"Fellwar Stone","scryfallId":"ce186c37-4a8c-48e5-9a24-69eef4d5be27"},{"index":1977,"token":false,"name":"Mind Funeral","scryfallId":"bff02baa-e1e1-42a3-9bea-97d40c8cd055"},{"index":1978,"token":false,"name":"Scalebane's Elite","scryfallId":"b3bff610-783a-46b7-bd15-061da41027bb"},{"index":1979,"token":false,"name":"Summer Bloom","scryfallId":"ce7ed9d7-012c-43d0-a8c0-e208b58cad6f"},{"index":1980,"token":false,"name":"Selvala, Explorer Returned","scryfallId":"fcd83749-5e4b-4e59-bf8f-821ce647e862"},{"index":1981,"token":false,"name":"Sibsig Icebreakers","scryfallId":"3835752e-11a6-406c-8bff-b7d4f2f31d85"},{"index":1982,"token":false,"name":"Tolsimir, Friend to Wolves","scryfallId":"b435f989-15a3-469d-8f5a-13648ffd9a93"},{"index":1984,"token":false,"name":"Fallen Askari","scryfallId":"00107210-313f-49c1-84ff-92628f75b764"},{"index":1985,"token":false,"name":"Phyrexian Plaguelord","scryfallId":"284f9e91-9318-44d9-995b-8c00752a3b01"},{"index":1986,"token":false,"name":"Rage Reflection","scryfallId":"84ef99c0-1a33-473a-80ff-bfe5544e7784"},{"index":1987,"token":false,"name":"Teferi, Mage of Zhalfir","scryfallId":"f0acc553-e289-478a-95ad-d238604508b9"},{"index":1988,"token":false,"name":"Eidolon of Rhetoric","scryfallId":"70f786bc-e7b3-4ebf-9fb7-ce8d25de2b19"},{"index":1989,"token":false,"name":"Hellspark Elemental","scryfallId":"a485fc8d-a7a0-444f-b4b3-aa0c9964ec53"},{"index":1990,"token":false,"name":"Arctic Foxes","scryfallId":"98f99c3e-dddc-492f-aab6-1d899346a385"},{"index":1991,"token":false,"name":"Urza's Factory","scryfallId":"6f5725dc-82a7-48b3-857e-7ccbf3726cbd"},{"index":1993,"token":false,"name":"Gwafa Hazid, Profiteer","scryfallId":"da097d1a-6e51-41d7-8dfe-f26acfb0038f"},{"index":1994,"token":false,"name":"Blood Reckoning","scryfallId":"24577bb2-61b0-4675-84e6-5d675b28fc0e"},{"index":1995,"token":false,"name":"The Tabernacle at Pendrell Vale","scryfallId":"9ff6dce8-02ed-47bd-8102-a10d7642683a"},{"index":1996,"token":false,"name":"Caller of Gales","scryfallId":"41bd76f3-299d-4bc0-a603-2cc7db7dac7b"},{"index":1997,"token":false,"name":"Vulshok Morningstar","scryfallId":"289d5f79-2346-4150-9be9-ca49efa2652b"},{"index":1998,"token":false,"name":"Mark of the Vampire","scryfallId":"cd074b3c-439d-4f78-87f6-bc52727966f5"},{"index":1999,"token":false,"name":"Vorinclex, Voice of Hunger","scryfallId":"603a7305-c036-47ef-8926-25b66a7905df"},{"index":2000,"token":false,"name":"Elemental Expressionist","scryfallId":"e842d841-39d5-490f-9136-14818ec6433e"},{"index":2001,"token":false,"name":"Wicker Witch","scryfallId":"ae115587-012d-40ff-a20d-270fabf2f8c6"},{"index":2002,"token":false,"name":"Runed Servitor","scryfallId":"0c79d7f3-2857-41cb-bb0d-ffaf9cf12fd1"},{"index":2003,"token":false,"name":"Spring // Mind","scryfallId":"c16b46c4-8d83-4176-aa3d-d5787bb54f3d"},{"index":2004,"token":false,"name":"Dirge of Dread","scryfallId":"a938b00e-a829-4860-a53a-83110493d0bd"},{"index":2005,"token":false,"name":"Sidisi's Pet","scryfallId":"e6e02a99-da37-4cea-9182-39ccb1e35ee9"},{"index":2007,"token":false,"name":"Baneslayer Angel","scryfallId":"c24806a1-c3b0-40ba-ac51-dbf0b29b35e7"},{"index":2008,"token":false,"name":"Baloth Cage Trap","scryfallId":"7f9c0792-1ff6-4c8c-b3d5-ff32644c366b"},{"index":2009,"token":false,"name":"Carrion Wall","scryfallId":"5cf312cf-fd6a-49a3-8bf0-338bbabc3381"},{"index":2010,"token":false,"name":"Frontier Bivouac","scryfallId":"31a0b728-dde3-4108-903e-e67fd117ed34"},{"index":2011,"token":false,"name":"Barrin, Master Wizard","scryfallId":"ec79e35f-9e78-462d-8b71-4f044e2eff90"},{"index":2012,"token":false,"name":"Skycat Sovereign","scryfallId":"6209dbfd-b765-44c5-b3ad-94f6e0705926"},{"index":2014,"token":false,"name":"Janjeet Sentry","scryfallId":"826b9080-2b6d-4f4e-93a6-cf977d40654f"},{"index":2015,"token":false,"name":"Illusionary Mask","scryfallId":"7244e5ed-e0a9-4624-a09e-f34a7b37f839"},{"index":2016,"token":false,"name":"Frantic Purification","scryfallId":"04f156d1-2655-42aa-a785-d8eb15cb5422"},{"index":2017,"token":false,"name":"Oakhame Ranger // Bring Back","scryfallId":"c389e04c-b009-4468-b760-5dd588cff9b9"},{"index":2018,"token":false,"name":"Craw Wurm","scryfallId":"19eee2f9-676d-4d98-a19e-ff5d841c636f"},{"index":2019,"token":false,"name":"Rakdos Guildgate","scryfallId":"26f7e55d-d4c9-4755-ab87-a592ba3fb64f"},{"index":2020,"token":false,"name":"Totally Lost","scryfallId":"adffef78-f776-42d3-ab40-3347c8e5c88b"},{"index":2021,"token":true,"name":"Merfolk Token (U, 1/1)","scryfallId":"90317f5e-d121-4c00-86cc-5bbee953f600"},{"index":2022,"token":false,"name":"Deadeye Tormentor","scryfallId":"d219fb0a-49a3-4711-9b37-a0c1b36f68d0"},{"index":2023,"token":false,"name":"Druid Lyrist","scryfallId":"e9923532-bc4f-44de-b963-d6914321c49a"},{"index":2024,"token":false,"name":"Nymris, Oona's Trickster","scryfallId":"b8cfc97a-3c8a-4d44-846b-7a523dc11878"},{"index":2025,"token":false,"name":"Scrubland","scryfallId":"14065271-d942-42a8-aa38-d8a622c0375d"},{"index":2026,"token":false,"name":"Serra's Embrace","scryfallId":"0c4ba0a5-2d4f-478d-897d-7206b9449911"},{"index":2027,"token":false,"name":"Reckless Waif // Merciless Predator","scryfallId":"028aeebc-4073-4595-94da-02f9f96ea148"},{"index":2028,"token":false,"name":"Annoyed Altisaur","scryfallId":"7536d618-0c98-45bb-913b-b8117b4acf87"},{"index":2029,"token":false,"name":"Tranquility","scryfallId":"ee21b620-4dfa-4e06-872e-8d8ffce12f76"},{"index":2030,"token":false,"name":"Explosive Vegetation","scryfallId":"da6efd31-ab5e-46ff-80d2-9382438e302c"},{"index":2031,"token":false,"name":"Magmaw","scryfallId":"08c571fe-54ef-4234-98c3-5d4a7b07e7d2"},{"index":2032,"token":false,"name":"Merchant of the Vale // Haggle","scryfallId":"0b4399b6-e67f-40d8-8676-f5db7e04a6c9"},{"index":2033,"token":false,"name":"Serpent Warrior","scryfallId":"ab726e7d-171f-48b2-9652-545e17913330"},{"index":2035,"token":false,"name":"Underworld Dreams","scryfallId":"5b1cbd83-c997-4c95-86a0-fe3c83d14975"},{"index":2037,"token":false,"name":"Guttersnipe","scryfallId":"2bc0185e-8ba5-423c-a8aa-a55cc1f34cef"},{"index":2038,"token":false,"name":"About Face","scryfallId":"85e71828-095b-4729-ab11-c6c39ba29aab"},{"index":2040,"token":false,"name":"Leyline Tyrant","scryfallId":"847ae75b-1c0f-4d0a-9933-9a302c88dc27"},{"index":2041,"token":false,"name":"Vengeful Rebirth","scryfallId":"270a2f52-56b9-4eb5-b2ae-8dbee42a490c"},{"index":2042,"token":false,"name":"Sanctum Seeker","scryfallId":"72150779-0bb6-4d20-a898-cda93a66e7cd"},{"index":2043,"token":false,"name":"Larceny","scryfallId":"dc6c71d1-c2d8-4d3e-81d8-65edbf3c3319"},{"index":2044,"token":false,"name":"Raise the Alarm","scryfallId":"8e189b1e-e5d9-44f0-afc7-0b7358fc161b"},{"index":2045,"token":false,"name":"Vulpikeet","scryfallId":"07bce816-3d18-4ca1-b88f-7307ec7c345d"},{"index":2047,"token":false,"name":"Graypelt Refuge","scryfallId":"c48e19dd-f1b0-4aab-8620-42c0247a2b3a"},{"index":2048,"token":false,"name":"Priest of Titania","scryfallId":"99a3376b-80be-4a53-9030-21d6256dc996"},{"index":2049,"token":false,"name":"Selective Memory","scryfallId":"555063cc-99ad-4014-b17b-c4c6b40d2e81"},{"index":2051,"token":false,"name":"Conduit of Storms // Conduit of Emrakul","scryfallId":"7f95145a-41a1-478e-bf8a-ea8838d6f9b1"},{"index":2052,"token":false,"name":"Victory Chimes","scryfallId":"9cb27fb1-41b1-49b8-bb3b-2c8a011ae7a9"},{"index":2055,"token":true,"name":"Avatar Token (W, 4/4)","scryfallId":"5f3f8f97-0c27-49d6-ae9a-a0fe2a7ce38b"},{"index":2056,"token":false,"name":"Siren's Call","scryfallId":"d992b336-3b6e-43e1-8662-d85664349b44"},{"index":2057,"token":false,"name":"Chronicler of Heroes","scryfallId":"21d4d6cc-bbd1-471e-888b-33e20a96ce60"},{"index":2058,"token":false,"name":"Erg Raiders","scryfallId":"35c73a97-531d-4dd5-8236-39b89c183c38"},{"index":2060,"token":false,"name":"Thought Collapse","scryfallId":"1759ce5a-bd01-4729-b4ca-712228c50b7f"},{"index":2061,"token":false,"name":"Dragon Scales","scryfallId":"8e78b364-015d-4074-ad9e-55c973ce2f4b"},{"index":2063,"token":false,"name":"Rune-Scarred Demon","scryfallId":"78ed184c-bb2a-47cc-a8e3-ba46b2fc4f64"},{"index":2064,"token":false,"name":"Magus of the Balance","scryfallId":"87dd1dba-2dda-4c04-bdbd-06aa838cacd3"},{"index":2065,"token":false,"name":"Naturalize","scryfallId":"0c187d05-0df4-48b6-8e75-690e725b8bcf"},{"index":2066,"token":false,"name":"Everquill Phoenix","scryfallId":"b841a987-7ab6-4ea1-a648-82afeb1fccd4"},{"index":2067,"token":false,"name":"Shimmering Grotto","scryfallId":"89a6aae2-f892-4f62-8333-970257ec301b"},{"index":2069,"token":false,"name":"Backwoods Survivalists","scryfallId":"f8257adc-5441-404d-a1fa-7abf8c15036c"},{"index":2071,"token":false,"name":"Soraya the Falconer","scryfallId":"19fb3ce2-a660-4829-9af4-330cfd612f06"},{"index":2072,"token":false,"name":"Filigree Familiar","scryfallId":"2859f9d8-40eb-4db4-b2ed-49d4724f93dc"},{"index":2073,"token":false,"name":"Doomed Necromancer","scryfallId":"3ca3e348-47cc-41d6-999a-60d1206aaf06"},{"index":2074,"token":false,"name":"Supernatural Stamina","scryfallId":"df2f1b32-5546-40c5-9bfa-7af3dffb0a75"},{"index":2075,"token":false,"name":"Perish","scryfallId":"7698d0c8-c9ed-42a5-b53e-75daac60a8d6"},{"index":2076,"token":false,"name":"Magus of the Bridge","scryfallId":"8ec4b7d1-16ed-4cc3-8db3-12fb8f25658c"},{"index":2077,"token":false,"name":"Electryte","scryfallId":"85c3d04f-4010-4db3-9e4e-afa8116b263d"},{"index":2078,"token":false,"name":"Hornet Sting","scryfallId":"9be7ca9f-c6f2-4373-b0cc-3a14a29e8a97"},{"index":2080,"token":false,"name":"Simoon","scryfallId":"84b1930d-2e4b-472f-98a9-008fd632f3be"},{"index":2081,"token":false,"name":"Vernadi Shieldmate","scryfallId":"efddad21-553e-4947-80d2-833b42c45f77"},{"index":2082,"token":false,"name":"Searing Meditation","scryfallId":"33c1fbdd-884d-467a-956e-7c28881002ab"},{"index":2083,"token":false,"name":"Reflecting Pool","scryfallId":"3d03dc37-03fb-47b2-aa25-60a85d0d94dd"},{"index":2084,"token":false,"name":"Icatian Town","scryfallId":"f7582903-57b0-42e6-991c-0f93ab9172d0"},{"index":2085,"token":false,"name":"Radha, Heart of Keld","scryfallId":"7777bc17-88cf-41fb-9169-77149c01eec8"},{"index":2086,"token":false,"name":"Zaffai, Thunder Conductor","scryfallId":"38400a08-4af1-415a-a9bd-8dc80fb771a0"},{"index":2087,"token":false,"name":"Settle the Score","scryfallId":"ee181d58-fed1-4f6d-96a3-4bf057ddd36e"},{"index":2088,"token":false,"name":"Leap of Flame","scryfallId":"c011b432-ec39-44c8-bf2a-1c3fec32a576"},{"index":2089,"token":false,"name":"Fungal Sprouting","scryfallId":"97413ae3-037e-4786-85a3-e92604acd771"},{"index":2090,"token":false,"name":"Weaver of Lightning","scryfallId":"302ec5d2-ea36-415c-9aa6-808c88a17932"},{"index":2091,"token":false,"name":"Atraxa, Praetors' Voice","scryfallId":"d0d33d52-3d28-4635-b985-51e126289259"},{"index":2092,"token":false,"name":"Elvish Lyrist","scryfallId":"40bab3e7-f2c8-4025-8463-9e4de10091e7"},{"index":2094,"token":false,"name":"Xira Arien","scryfallId":"21fa636b-8ce8-40b6-a4d0-3191a664bd92"},{"index":2095,"token":false,"name":"Chainbreaker","scryfallId":"094b023e-d5a3-4a57-adf0-898f3dcc8de2"},{"index":2100,"token":false,"name":"Crystal Quarry","scryfallId":"1012124a-5401-4bd1-a163-4633d934938f"},{"index":2101,"token":false,"name":"Morphic Pool","scryfallId":"63b9efd6-0709-4d4b-a907-d8a77ec1a327"},{"index":2102,"token":false,"name":"Mental Note","scryfallId":"9a3c72e5-056e-4687-a5ab-d64d425d598e"},{"index":2105,"token":false,"name":"Coordinated Barrage","scryfallId":"8d0b26b0-cc31-458b-8a92-aa3392d0ca0f"},{"index":2106,"token":false,"name":"Odious Trow","scryfallId":"bc2e0c36-645a-46c8-bd9e-4b8b591dfb58"},{"index":2107,"token":false,"name":"Garruk, Unleashed","scryfallId":"47a469be-e43a-48cb-b216-bb39ade32acb"},{"index":2108,"token":false,"name":"Leering Gargoyle","scryfallId":"a05d1cac-7012-4d22-82d3-0f82b168fe68"},{"index":2109,"token":false,"name":"Grenzo, Dungeon Warden","scryfallId":"b2513524-f149-4b0b-bf17-f6ef7f497508"},{"index":2110,"token":false,"name":"Pestermite","scryfallId":"b58a6a63-c7d8-4f2f-acaf-b0a871eb5a7c"},{"index":2111,"token":false,"name":"Glacial Stalker","scryfallId":"8821c7b9-702b-416f-b006-941ad57f9e11"},{"index":2112,"token":false,"name":"Suntouched Myr","scryfallId":"07d6c82f-b943-435e-a716-a58ae30b3922"},{"index":2113,"token":false,"name":"Kykar, Wind's Fury","scryfallId":"df5ac967-e40e-4065-9fe6-af6d7a5a0977"},{"index":2114,"token":false,"name":"Lightning Bolt","scryfallId":"fcf2ea50-44af-46d7-80c9-36fc18606748"},{"index":2115,"token":false,"name":"Akoum Refuge","scryfallId":"df319dcb-419d-4588-9c8a-fe82973b704a"},{"index":2116,"token":false,"name":"Peacewalker Colossus","scryfallId":"3cd849b0-095b-42a7-a46b-720122387d70"},{"index":2117,"token":false,"name":"Grasp of Fate","scryfallId":"42e1e595-4000-4c89-a2cd-dbaec25baa71"},{"index":2118,"token":false,"name":"Dominaria's Judgment","scryfallId":"9703d090-b415-48e2-8158-dd8fc57ecc50"},{"index":2119,"token":false,"name":"Jace Beleren","scryfallId":"39a89c44-1aa7-4f2e-909b-d821ec2b7948"},{"index":2121,"token":false,"name":"Durkwood Boars","scryfallId":"3e2275b3-08ea-48d4-8781-7e64f2b94d72"},{"index":2122,"token":false,"name":"Obsianus Golem","scryfallId":"9646da70-329f-41a2-9453-4ec6a9c9e7e4"},{"index":2123,"token":false,"name":"Dance of Many","scryfallId":"51ff8402-7bfe-441a-8c6e-6a9ee9608911"},{"index":2124,"token":false,"name":"Uro, Titan of Nature's Wrath","scryfallId":"bcf6e4d1-1b4f-450c-a0fc-2d02313979ca"},{"index":2125,"token":false,"name":"Subterranean Tremors","scryfallId":"0a61707a-9952-4304-ad72-521194e410d8"},{"index":2126,"token":false,"name":"Wood Elves","scryfallId":"06adbaaf-9600-4192-b93f-decf0c9bf219"},{"index":2127,"token":false,"name":"Think Twice","scryfallId":"53e44060-a9a2-4095-9f5b-f60297525315"},{"index":2128,"token":false,"name":"Shock","scryfallId":"6f096de6-995a-4c54-9e9e-b46410d6022d"},{"index":2130,"token":false,"name":"Umbral Juke","scryfallId":"3fbd0921-e953-492b-ad73-c8a8bfaa750b"},{"index":2131,"token":false,"name":"Liliana, Dreadhorde General","scryfallId":"199e3667-33be-415f-8f10-1c42a78d7637"},{"index":2132,"token":false,"name":"Court Hussar","scryfallId":"f3843e98-192c-44a2-be54-9ba79e51657c"},{"index":2133,"token":false,"name":"Grim Haruspex","scryfallId":"358ade1a-375d-44b4-910f-21d53c7498bb"},{"index":2134,"token":false,"name":"Cursed Mirror","scryfallId":"0c3bbdd4-146c-40ea-99e8-6cef0d04e953"},{"index":2135,"token":false,"name":"Echoes of the Kin Tree","scryfallId":"531414e6-ea72-4934-b05e-e1782249fd1f"},{"index":2136,"token":false,"name":"Boggart Brute","scryfallId":"042f10fb-5c19-4890-80ba-ea2c28805f0b"},{"index":2137,"token":false,"name":"Harvest Season","scryfallId":"bb18e745-a925-477f-a50f-3ec7fba22d88"},{"index":2138,"token":false,"name":"Draconic Intervention","scryfallId":"854ddfc9-1ecd-45e1-b9aa-3390a2e3776f"},{"index":2139,"token":false,"name":"Circle of Protection: White","scryfallId":"7a28dab1-f28d-4ac5-b5a2-f79b14e11b06"},{"index":2141,"token":false,"name":"Ertai's Trickery","scryfallId":"544e3575-9fb6-41f7-a4e6-f8460dfae344"},{"index":2142,"token":false,"name":"Duress","scryfallId":"db0b7cc4-fcc1-4c14-82c2-e2b3709baa2e"},{"index":2143,"token":false,"name":"Dead of Winter","scryfallId":"f480df6d-e227-4ccb-ad6d-a4ad48a360ad"},{"index":2145,"token":false,"name":"Thicket Elemental","scryfallId":"c5a462ca-0632-410d-9999-a096b71fc3ea"},{"index":2146,"token":false,"name":"Jodah, Archmage Eternal","scryfallId":"99d07bba-cb5b-4d1f-bab5-8a6e49cd0bdb"},{"index":2148,"token":false,"name":"Volcanic Eruption","scryfallId":"04961291-2659-421e-891f-a0ee4f02d246"},{"index":2149,"token":false,"name":"Shriek of Dread","scryfallId":"54a7fb3b-8e81-4763-b2a1-7c2108a00afe"},{"index":2150,"token":false,"name":"Augur of Skulls","scryfallId":"945404d5-9e44-45e7-84fd-5f8c893e7d27"},{"index":2152,"token":false,"name":"Polukranos, World Eater","scryfallId":"4979cc1b-9c1a-47e4-ae37-7c41798eb89a"},{"index":2153,"token":false,"name":"Tomik, Distinguished Advokist","scryfallId":"f346387c-2f13-472b-b5b1-968b490eb38f"},{"index":2154,"token":false,"name":"Megatherium","scryfallId":"c58a1e43-a173-45d6-ac55-363664bf6e1b"},{"index":2155,"token":false,"name":"Blinkmoth Urn","scryfallId":"1016fb10-82b5-465a-8f33-ec54f9785544"},{"index":2156,"token":false,"name":"Surtland Frostpyre","scryfallId":"0b02149a-4a8f-4be9-9944-3d216248b549"},{"index":2157,"token":true,"name":"Dark Ascension Checklist","scryfallId":"825c61e7-bf33-45ea-af78-97ab3bc96753"},{"index":2158,"token":false,"name":"Baki's Curse","scryfallId":"e3261b4c-7963-4ca0-875d-77b7c8571b3f"},{"index":2161,"token":false,"name":"Kabuto Moth","scryfallId":"cf3ccd16-bb1b-40d5-87a6-47a6132e0143"},{"index":2162,"token":false,"name":"Dwarven Lightsmith","scryfallId":"98689a75-aa88-4c83-8104-0352b829503e"},{"index":2164,"token":false,"name":"Spell Blast","scryfallId":"42d7af6a-bfd1-4e89-965a-68336507a9ee"},{"index":2165,"token":false,"name":"Misery Charm","scryfallId":"2be66eaf-222b-4c40-a9fa-aad56b9218e0"},{"index":2166,"token":false,"name":"Princess Lucrezia","scryfallId":"be8f707d-58a6-4e18-a45a-fcfdd1336a64"},{"index":2167,"token":false,"name":"Darkwater Egg","scryfallId":"fb988572-1e1d-4b1d-8dc7-78bda966554e"},{"index":2169,"token":false,"name":"Thallid Omnivore","scryfallId":"99b35391-f1dc-434b-b581-ca6cb6f3439f"},{"index":2173,"token":false,"name":"Magda, Brazen Outlaw","scryfallId":"4e446a2b-1e8e-49e2-9c09-9d614474b192"},{"index":2174,"token":false,"name":"Forcefield","scryfallId":"3f2004c1-8efe-407f-bf48-27b807422eea"},{"index":2175,"token":false,"name":"Footlight Fiend","scryfallId":"8c604697-5c81-4329-9b16-f19bd90ba08c"},{"index":2176,"token":false,"name":"Rise from the Grave","scryfallId":"bc73644e-884c-47cd-aeec-ab80360dd5ae"},{"index":2178,"token":false,"name":"Salivating Gremlins","scryfallId":"9e5b2544-da1a-4f7a-ba68-7f18cd905bf3"},{"index":2180,"token":false,"name":"Psionic Blast","scryfallId":"73b6b789-00c5-4d72-8fb3-6808bfbf0144"},{"index":2181,"token":false,"name":"Rune-Tail, Kitsune Ascendant // Rune-Tail's Essence","scryfallId":"1f1c4bf1-2a9a-4802-af28-4e7c3dae97ee"},{"index":2182,"token":false,"name":"Custodi Soulbinders","scryfallId":"a21df7d2-d9c7-4b63-a275-ae7fe1630935"},{"index":2184,"token":false,"name":"Helldozer","scryfallId":"e00bddd6-41da-4b5f-84da-43ebde4f3a2a"},{"index":2185,"token":false,"name":"Fiery Justice","scryfallId":"844a8a51-45fb-4957-b1fe-0d86dfff3fb5"},{"index":2186,"token":false,"name":"Sunset Pyramid","scryfallId":"377a4e80-0f28-42a2-9972-47ab66baee63"},{"index":2187,"token":false,"name":"Eldrazi Monument","scryfallId":"07ee3b07-3e4d-4cc6-9286-05bdc20827bd"},{"index":2188,"token":false,"name":"Court of Grace","scryfallId":"02f0be1b-554e-4b61-b495-6e2a7369cdb1"},{"index":2189,"token":false,"name":"Golgari Guildmage","scryfallId":"d91b994b-3cf2-43f7-8af6-7925e882208f"},{"index":2190,"token":false,"name":"Mold Shambler","scryfallId":"903cb570-d769-4d7f-afbe-90ebad96657c"},{"index":2192,"token":false,"name":"Simic Growth Chamber","scryfallId":"10919cb8-8307-44fc-a2fa-4aefc53d11b6"},{"index":2194,"token":false,"name":"Undercity Informer","scryfallId":"822d0f73-cfb0-41d9-b4eb-09c605112a13"},{"index":2195,"token":false,"name":"Avenging Arrow","scryfallId":"696678ff-44dc-4fe4-bf17-024e86cd0220"},{"index":2196,"token":false,"name":"Radha, Heir to Keld","scryfallId":"7924e5a5-9614-4fd0-a621-80fa3103cc22"},{"index":2197,"token":false,"name":"Lethal Sting","scryfallId":"eaded6bf-2db7-4b1d-93cc-4b7b571cd2de"},{"index":2199,"token":false,"name":"Gauntlet of Power","scryfallId":"5c3ac941-2af2-4652-9b3d-c62d04c8af60"},{"index":2200,"token":false,"name":"Castle Embereth","scryfallId":"51d972cc-b08c-499c-a35e-51d275d5a4aa"},{"index":2202,"token":false,"name":"Brackwater Elemental","scryfallId":"e324d70f-a6ca-4003-8420-83035fd4cd00"},{"index":2203,"token":false,"name":"Demonic Tutor","scryfallId":"711d4d54-5520-4de8-9b93-79902ed8e562"},{"index":2204,"token":false,"name":"Defense of the Heart","scryfallId":"9e93381f-627f-41b6-b1b6-45d712a44d8e"},{"index":2206,"token":false,"name":"Izzet Chemister","scryfallId":"cfc8fd50-b3be-49b0-9209-f5ce82d9868e"},{"index":2207,"token":false,"name":"Mind Raker","scryfallId":"a4d07fea-e16a-45e3-a172-9d726cd42769"},{"index":2209,"token":false,"name":"Empyrial Storm","scryfallId":"17604107-8f0d-4b52-943e-7720638a362c"},{"index":2210,"token":false,"name":"Llanowar Wastes","scryfallId":"a7218c70-b170-4d23-b98f-f8fa29312994"},{"index":2211,"token":false,"name":"Strip Mine","scryfallId":"1a060aea-3812-49da-b681-812fe20c023b"},{"index":2212,"token":false,"name":"Mire's Grasp","scryfallId":"0ae0c536-612d-4916-a8da-5aaaf14218b1"},{"index":2213,"token":false,"name":"Thought Prison","scryfallId":"409087ef-8232-489c-8b98-b601bb0a47a4"},{"index":2214,"token":false,"name":"Azorius Chancery","scryfallId":"0784336e-89ed-44ad-a9c4-58c5ee1fc01a"},{"index":2215,"token":false,"name":"Gaseous Form","scryfallId":"9e2c5fbd-74af-42ab-a42d-34af26577389"},{"index":2216,"token":false,"name":"Siren Song Lyre","scryfallId":"cfeca720-3163-4391-b90d-5f7aa5f5987b"},{"index":2217,"token":false,"name":"Consuming Aberration","scryfallId":"ca2a714e-4254-4138-ad36-4ae11da17289"},{"index":2218,"token":false,"name":"Alesha's Vanguard","scryfallId":"69bb135f-1c58-42ed-bbf2-4a2e842f99d7"},{"index":2219,"token":false,"name":"Stomping Slabs","scryfallId":"820f1acf-7f0c-4ee5-9f18-b5627aac7c81"},{"index":2222,"token":false,"name":"Lightning Helix","scryfallId":"79d1f0c1-9271-47e7-8bee-a102cdc396e9"},{"index":2223,"token":false,"name":"Mortivore","scryfallId":"e06670f5-0ee6-4b43-81a9-86c1d25df736"},{"index":2224,"token":false,"name":"Illusory Angel","scryfallId":"662fad3a-15b1-49d0-8dea-f7b57b42d9a5"},{"index":2225,"token":false,"name":"Scavenger Folk","scryfallId":"8a3ebda6-7eea-4a65-9fc1-9fc453ff39bb"},{"index":2227,"token":false,"name":"Kaza, Roil Chaser","scryfallId":"2ac9b854-701a-44a6-9f2e-a9c0d0620ed2"},{"index":2228,"token":false,"name":"Knollspine Invocation","scryfallId":"8157aade-9dfc-402d-8e1f-468bf2bccb9c"},{"index":2229,"token":false,"name":"Felidar Umbra","scryfallId":"fe83a23c-723e-4b34-a121-a10fc0efe1b5"},{"index":2230,"token":false,"name":"Thought Lash","scryfallId":"547b1405-3f4e-4c47-8600-3e92197b1dd7"},{"index":2231,"token":false,"name":"Lava Axe","scryfallId":"340b71f4-4245-4b22-a550-c0226e2710ee"},{"index":2233,"token":false,"name":"Akoum Warrior // Akoum Teeth","scryfallId":"d8ed0335-daa6-4dbe-a94d-4d56c8cfd093"},{"index":2234,"token":false,"name":"Zealot of the God-Pharaoh","scryfallId":"26084a6f-abec-4b63-825f-737095635421"},{"index":2235,"token":false,"name":"Kaalia of the Vast","scryfallId":"96a9079f-8b79-4b3b-afe4-494fa5052326"},{"index":2237,"token":false,"name":"Maja, Bretagard Protector","scryfallId":"b8832509-497d-4253-bbb1-92adfb69368f"},{"index":2239,"token":false,"name":"Ondu Giant","scryfallId":"1d356911-6832-4b7d-aea8-5b83c1337460"},{"index":2241,"token":false,"name":"Veteran Armorer","scryfallId":"026aaea6-ed4f-4505-9779-7c28ff6c2284"},{"index":2242,"token":false,"name":"Natural Spring","scryfallId":"7e306c6f-2e99-4578-82c1-1f7bd83f7ea1"},{"index":2243,"token":false,"name":"Adverse Conditions","scryfallId":"03d86e0b-294f-41b8-a5cd-d3144a019334"},{"index":2245,"token":false,"name":"Brightclimb Pathway // Grimclimb Pathway","scryfallId":"1dce4e5a-08ab-4f52-bdfb-6d2dafbb055f"},{"index":2246,"token":false,"name":"Vivid Flying Fish","scryfallId":"50334cea-de2d-449e-ac6c-77de8ca87620"},{"index":2247,"token":false,"name":"Uncaged Fury","scryfallId":"40440487-5ff2-43da-aa06-c649bf972ef1"},{"index":2248,"token":false,"name":"Underhanded Designs","scryfallId":"28855038-f96e-4fdb-9bfb-34c0fedd344f"},{"index":2250,"token":false,"name":"Lurking Informant","scryfallId":"012a7f5d-f798-4030-86e3-05956487a383"},{"index":2251,"token":false,"name":"Sea Gate Oracle","scryfallId":"60b7ea54-1bb5-40e6-bdaf-5ef6916d8f6f"},{"index":2252,"token":false,"name":"Agent of Masks","scryfallId":"7e9b0ab4-5c6b-494d-926d-daa38a3ac640"},{"index":2253,"token":false,"name":"Rhox","scryfallId":"5c32481e-59a0-4f89-b322-bdf1a78f40a4"},{"index":2254,"token":false,"name":"Keeper of Kookus","scryfallId":"d11b6df4-449f-44ea-a4fa-f079bcd26a54"},{"index":2255,"token":false,"name":"Oxidize","scryfallId":"96905be0-3f92-49ef-a7a1-00dd09d5c507"},{"index":2256,"token":false,"name":"Where Ancients Tread","scryfallId":"797e3faa-9573-4639-be99-517708c06218"},{"index":2257,"token":false,"name":"Juniper Order Ranger","scryfallId":"ce582ff6-6a21-418d-b72c-4402a43be7dc"},{"index":2258,"token":false,"name":"Toxic Deluge","scryfallId":"6d796c01-0821-4a20-a256-d98b774faedc"},{"index":2259,"token":false,"name":"Strength of Unity","scryfallId":"1a9d4ff8-af35-413f-9aa2-f4c6e34fade2"},{"index":2260,"token":false,"name":"Nature's Lore","scryfallId":"668d2969-b6b7-4507-bdd4-20bbaa68035a"},{"index":2262,"token":false,"name":"Seven Dwarves","scryfallId":"464adbae-70ea-48e1-b8ae-b404766f7a5a"},{"index":2264,"token":false,"name":"Ravenous Slime","scryfallId":"091c030f-7603-419d-b341-fee0bf109f95"},{"index":2266,"token":false,"name":"Hawkeater Moth","scryfallId":"842e8c4c-32f3-4ec3-b636-1d7dc9f0023e"},{"index":2268,"token":false,"name":"Vengeful Vampire","scryfallId":"d03c64a7-37d2-4d8f-bd7a-9435bc2f4101"},{"index":2269,"token":false,"name":"Turntimber Basilisk","scryfallId":"a1c82f0c-70ff-4f8b-a8c8-2b5313d9f0ec"},{"index":2270,"token":false,"name":"Elvish Mystic","scryfallId":"60d0e6a6-629a-45a7-bfcb-25ba7156788b"},{"index":2271,"token":false,"name":"Filigree Angel","scryfallId":"7a0c7a2a-85c1-4b20-95b9-04aab0bd0d3b"},{"index":2272,"token":false,"name":"Skeletal Crocodile","scryfallId":"ebcbbd6f-2915-4b4c-85d3-1d9b55d36c11"},{"index":2273,"token":false,"name":"Hunted Dragon","scryfallId":"4184638c-bfb8-424d-b106-ed7b3d80b668"},{"index":2274,"token":false,"name":"Hellrider","scryfallId":"0ec8d800-7f06-44e0-b22d-cdff0a9b153d"},{"index":2275,"token":false,"name":"Darksteel Citadel","scryfallId":"fef40a5a-f3d7-44f2-be1e-6f9e991dbf0c"},{"index":2276,"token":false,"name":"Troll-Horn Cameo","scryfallId":"42b1ca6c-6ca0-4b02-885a-58cee3fa2aa8"},{"index":2277,"token":false,"name":"Blunt the Assault","scryfallId":"6ecff12a-37d5-4a7b-b615-4c5e3bd950bb"},{"index":2278,"token":false,"name":"Solitude","scryfallId":"47a6234f-309f-4e03-9263-66da48b57153"},{"index":2281,"token":false,"name":"Dearly Departed","scryfallId":"16e88d15-26b3-4782-a7f9-231f23905fb5"},{"index":2284,"token":false,"name":"Malicious Intent","scryfallId":"f1dda42d-55eb-46fc-89da-17cc5bfaa823"},{"index":2285,"token":false,"name":"Teferi's Tutelage","scryfallId":"aefc721d-7c0b-4b3a-8131-f466bf3e7949"},{"index":2286,"token":false,"name":"Avacyn's Pilgrim","scryfallId":"7eb39e97-53c2-4df0-9fb3-a3d6a24ec41f"},{"index":2287,"token":false,"name":"Captain's Maneuver","scryfallId":"1ad535b8-7846-41a6-a981-fe97eaf588a6"},{"index":2288,"token":false,"name":"Blisterstick Shaman","scryfallId":"f8187e90-6a60-4ed0-9b3a-3a679743b7d0"},{"index":2289,"token":false,"name":"Shining Armor","scryfallId":"34390832-e590-49b8-b376-1be8db8e0943"},{"index":2290,"token":false,"name":"Herd Baloth","scryfallId":"c1e9cef5-c55f-47d9-9d2f-300dab8fcb0b"},{"index":2292,"token":false,"name":"Tethered Skirge","scryfallId":"0ab1d02c-5d9d-4436-af3b-fb7190c1c028"},{"index":2293,"token":false,"name":"Erratic Portal","scryfallId":"735baece-ad0d-4906-b457-7ad97f97ee04"},{"index":2294,"token":false,"name":"Night // Day","scryfallId":"e8f109f1-9798-4bd3-b51a-49f173251dfd"},{"index":2295,"token":false,"name":"Atarka Monument","scryfallId":"63d52217-a340-4567-9b07-28092a7dc561"},{"index":2297,"token":false,"name":"Spark Double","scryfallId":"c015a58b-46ef-438e-9448-e0d770322232"},{"index":2298,"token":false,"name":"Carrion Screecher","scryfallId":"57b9e3a3-8d01-4273-9658-9ffcbc2d2297"},{"index":2299,"token":false,"name":"Flowstone Shambler","scryfallId":"36e08d8a-c081-4aaf-8f8f-dd48218c17b3"},{"index":2300,"token":false,"name":"Power Sink","scryfallId":"e91c51ab-c8b1-47be-8169-7f842712771c"},{"index":2302,"token":false,"name":"Darkmoss Bridge","scryfallId":"f11f0be9-b9f7-45d2-9499-c5d849d7289f"},{"index":2304,"token":false,"name":"Thoughtcast","scryfallId":"efb965a7-877a-4302-b507-25b0a9e32d9b"},{"index":2305,"token":false,"name":"Circle of Protection: Artifacts","scryfallId":"c07458b6-e207-47f6-9ce2-36df0151f035"},{"index":2306,"token":false,"name":"Give No Ground","scryfallId":"1cb3347a-9b32-46a4-a621-4ae5244ba2f5"},{"index":2307,"token":false,"name":"Scion of Oona","scryfallId":"a29f95fe-2efa-4788-84d8-2bd88d8650b4"},{"index":2308,"token":false,"name":"Hazezon Tamar","scryfallId":"eb999fde-2be3-49a0-a033-fdb1048fad32"},{"index":2311,"token":false,"name":"Loam Lion","scryfallId":"4edfbb5f-6cb4-4971-b159-ee5f875ba260"},{"index":2312,"token":false,"name":"Simic Guildgate","scryfallId":"6e73e082-b16a-45d5-bc4a-24c694b0b9af"},{"index":2313,"token":false,"name":"Disciple of Bolas","scryfallId":"0c4fc28d-8be6-4639-bb9d-7b9fdd47e0d9"},{"index":2315,"token":false,"name":"Raven's Crime","scryfallId":"7271436b-897a-4b24-a5d2-d29dbea8c1bf"},{"index":2316,"token":false,"name":"Raging River","scryfallId":"9c118b97-1e50-4fd1-816d-a63a4128d539"},{"index":2317,"token":false,"name":"Pressure Point","scryfallId":"5d28b806-88a3-4852-982e-0d6be0a2edac"},{"index":2318,"token":false,"name":"Appetite for the Unnatural","scryfallId":"b8aa8840-31f8-4263-b992-40584e31595a"},{"index":2320,"token":false,"name":"Enter the God-Eternals","scryfallId":"4a7236b0-aae6-48ad-8770-70051d3809d9"},{"index":2321,"token":false,"name":"Code of Constraint","scryfallId":"258aeef1-565a-4f19-b12c-d46d54ba231d"},{"index":2324,"token":false,"name":"Recollect","scryfallId":"565e210a-47ee-44e6-bfbc-ad9679f67108"},{"index":2325,"token":false,"name":"Shepherd of the Lost","scryfallId":"ff23b1c2-7b99-4504-8944-ada264725524"},{"index":2326,"token":false,"name":"Nameless Inversion","scryfallId":"b1ea60ba-11ac-4112-92af-db0aa420dd8c"},{"index":2327,"token":false,"name":"Forbidden Friendship","scryfallId":"ae39803e-e67a-4d1b-a3fe-2e255d502656"},{"index":2329,"token":false,"name":"Dispatch","scryfallId":"6e5caadb-9438-460a-852b-123719635550"},{"index":2330,"token":false,"name":"Lone Rider // It That Rides as One","scryfallId":"9a55b60a-5d90-4f73-984e-53fdcc0366e4"},{"index":2331,"token":false,"name":"Terror","scryfallId":"21004958-2c7e-4a55-bc80-411c4d780106"},{"index":2333,"token":false,"name":"Bitter Revelation","scryfallId":"e42f5aa9-2a47-47c3-ab87-dc25735b0e54"},{"index":2334,"token":false,"name":"Chapel Geist","scryfallId":"790cdf67-80d6-4ade-aecf-f77120b509b0"},{"index":2335,"token":false,"name":"Jungle Troll","scryfallId":"59fb9591-399a-4196-a52d-f2954d287a10"},{"index":2336,"token":false,"name":"Drogskol Cavalry","scryfallId":"1a5c6454-67fa-4afb-885e-5cdd595c57ab"},{"index":2337,"token":false,"name":"Sheltered Thicket","scryfallId":"b22fb562-ee1d-4b0f-8910-2d6552513465"},{"index":2338,"token":false,"name":"Borderland Ranger","scryfallId":"8f067c26-c51d-44d0-a0af-106b5778f06a"},{"index":2339,"token":false,"name":"Farm // Market","scryfallId":"89ffcd32-6966-4288-9295-c5b89e8c5681"},{"index":2340,"token":false,"name":"Ruinous Minotaur","scryfallId":"e800a3fe-bb1a-45f1-8c81-5ec88ff8647b"},{"index":2341,"token":false,"name":"Mnemonic Wall","scryfallId":"ffaebb4a-cb9b-4ac8-b661-3e63d9d984f4"},{"index":2342,"token":false,"name":"Toolcraft Exemplar","scryfallId":"daae3dae-3297-4750-9bca-c8aadaf815ea"},{"index":2343,"token":false,"name":"Lull","scryfallId":"8bdb38b2-3eba-4b2e-b5d8-58e9ad799d1f"},{"index":2344,"token":false,"name":"Game Trail","scryfallId":"56916cf4-3bd5-4e93-91cc-579c2b3aaeb0"},{"index":2346,"token":false,"name":"Plumes of Peace","scryfallId":"c3ca5b8b-8c3c-4d3a-aff9-9905346a4c42"},{"index":2347,"token":false,"name":"Phyrexian Gremlins","scryfallId":"21a985a9-5612-4844-982e-fd1aa6249770"},{"index":2348,"token":false,"name":"Panharmonicon","scryfallId":"6064c5d0-250a-4933-aa69-652eb8afac7f"},{"index":2349,"token":false,"name":"Bringer of the Blue Dawn","scryfallId":"45dc82a0-f054-4614-a7b9-4c5a7c9d2a77"},{"index":2350,"token":false,"name":"Ogre Jailbreaker","scryfallId":"9a96c83d-96d9-4f8f-8020-77990130ad81"},{"index":2351,"token":false,"name":"Orzhov Signet","scryfallId":"9b5a2cd7-5b31-44e5-bbde-2feac5fb161c"},{"index":2353,"token":false,"name":"The Great Henge","scryfallId":"af915ed2-1f34-43f6-85f5-2430325b720f"},{"index":2354,"token":false,"name":"Greater Stone Spirit","scryfallId":"77697b16-7faa-400d-a865-732c8b0d3d41"},{"index":2355,"token":false,"name":"Scythe Specter","scryfallId":"590bd3e6-3bef-4c2d-9d4f-4b4bd5ff06d0"},{"index":2356,"token":false,"name":"Ashes to Ashes","scryfallId":"736c24f8-a5f7-44e3-a2c0-baca7d0d285f"},{"index":2357,"token":false,"name":"Haunted Plate Mail","scryfallId":"f7daae6f-fe19-4f42-b85d-75c996abe1be"},{"index":2358,"token":false,"name":"Whipcorder","scryfallId":"3bf6987e-a6e4-4a88-af0b-cf3b2d2b80c7"},{"index":2359,"token":false,"name":"Whirlwind of Thought","scryfallId":"ba620481-acc5-4917-9fd7-454b1e4b1efc"},{"index":2361,"token":false,"name":"Lava Spike","scryfallId":"e3abbec4-202d-47ee-9472-b41d41f75372"},{"index":2362,"token":false,"name":"Hivis of the Scale","scryfallId":"ee84e61e-d99a-489b-a3b1-cb45fc81bce6"},{"index":2363,"token":false,"name":"Moorland Inquisitor","scryfallId":"581dbbea-9995-4e4b-ba5c-d6d5597e4ace"},{"index":2364,"token":false,"name":"Intet, the Dreamer","scryfallId":"9a56c0db-beef-4ce7-abc9-d135eeff4c5a"},{"index":2365,"token":false,"name":"Walker of the Grove","scryfallId":"b014c3d9-0c24-42c3-8b70-eaf1064901ce"},{"index":2366,"token":false,"name":"Necroblossom Snarl","scryfallId":"8e68589e-d71f-4a2b-9a97-b768e81aefa4"},{"index":2368,"token":false,"name":"Karn, the Great Creator","scryfallId":"3ec0c0fb-1a4f-45f4-85b7-346a6d3ce2c5"},{"index":2369,"token":false,"name":"Shyft","scryfallId":"d7f2bbf6-65b7-41c4-a219-f8ea4aeb9bbc"},{"index":2370,"token":false,"name":"Clockwork Beast","scryfallId":"730933d3-bc94-421c-be76-7ca8f8796a67"},{"index":2371,"token":false,"name":"Shield Bearer","scryfallId":"318ff2da-d309-469c-8e2f-fa3c7517a15a"},{"index":2373,"token":false,"name":"Reckless Embermage","scryfallId":"b7f262e8-0567-4e6d-8435-eda661d89a8f"},{"index":2375,"token":false,"name":"Multiple Choice","scryfallId":"7ec3dfa3-1e78-420b-8a9f-d13626204d5a"},{"index":2376,"token":false,"name":"Elvish Scrapper","scryfallId":"ae85fafb-114b-4fd8-ac4c-5ada57054705"},{"index":2377,"token":false,"name":"Luxury Suite","scryfallId":"00e40c64-58fa-421e-9d01-93b0642f7d8b"},{"index":2378,"token":false,"name":"Quirion Ranger","scryfallId":"2a68656e-799d-414b-be27-4b25bd2bd468"},{"index":2379,"token":false,"name":"Mystical Tutor","scryfallId":"1571b584-9007-45ee-a3c3-6c72f227fee2"},{"index":2380,"token":false,"name":"Howling Wolf","scryfallId":"7416c68a-5a6a-4d51-8dc7-5c62da81ec77"},{"index":2381,"token":false,"name":"Phase Dolphin","scryfallId":"88fb4042-e9c1-4b0f-b1f6-4180b0d79663"},{"index":2382,"token":false,"name":"Dire Fleet Neckbreaker","scryfallId":"5146dd15-f696-42c3-b0e5-6a1b1d7be6b4"},{"index":2383,"token":false,"name":"Mawcor","scryfallId":"5baada74-d91e-4081-8d42-d165550b8373"},{"index":2384,"token":false,"name":"Profane Tutor","scryfallId":"44989011-7833-42e3-8fae-6ed0c7220e28"},{"index":2385,"token":false,"name":"As Foretold","scryfallId":"71d7b9ff-9a98-4443-bdb3-67010381e23c"},{"index":2386,"token":false,"name":"Fury of the Horde","scryfallId":"52dd1712-6937-4630-b44c-952699307da4"},{"index":2388,"token":false,"name":"Lynx","scryfallId":"2e8648e1-bc40-4eff-ad7b-ab0b62a47570"},{"index":2389,"token":false,"name":"Ogre Battledriver","scryfallId":"aafe6f1c-bd4c-412a-af18-228319dc8e87"},{"index":2390,"token":false,"name":"Timid Drake","scryfallId":"01bbdbd8-1517-4bfd-926b-465a32724082"},{"index":2391,"token":false,"name":"Appeal // Authority","scryfallId":"2c25b8ef-6331-49df-9457-b8b4e44da2c9"},{"index":2392,"token":false,"name":"Harrier Naga","scryfallId":"bcdc68c9-f5f3-4c5b-80df-85508cf15f84"},{"index":2393,"token":false,"name":"Thespian's Stage","scryfallId":"954c7792-c147-401d-bbe5-f1773ae3b301"},{"index":2395,"token":false,"name":"Soldier of Fortune","scryfallId":"37c05f46-2081-4ebb-a758-894ac040ea2a"},{"index":2396,"token":false,"name":"Goblin Caves","scryfallId":"bcba2255-b0ae-43b9-b9fd-62da04d5e397"},{"index":2398,"token":false,"name":"Salvager of Secrets","scryfallId":"c0b5b645-c90d-43aa-996d-03a1d575bdd6"},{"index":2399,"token":false,"name":"The Hive","scryfallId":"7ec7d032-72df-49ad-9f59-41bf468ba850"},{"index":2400,"token":false,"name":"Yavimaya Hollow","scryfallId":"d9fdbc02-7ab7-4f77-8a89-5a9e01eb32f5"},{"index":2401,"token":false,"name":"Crested Sunmare","scryfallId":"be89891e-c9c5-4c49-a6c6-8b5ee68e2efa"},{"index":2402,"token":false,"name":"Bird Maiden","scryfallId":"747bcb9f-40d5-4214-b658-cd7b0bf24fa2"},{"index":2403,"token":false,"name":"Krosan Grip","scryfallId":"504f6e78-2b4b-47ef-8e99-0e1e8ad42eef"},{"index":2404,"token":false,"name":"Arc Blade","scryfallId":"92b8fe7c-fe36-4f6d-9c7f-85286b745865"},{"index":2405,"token":false,"name":"Nightmare","scryfallId":"192bb40a-3ecd-41eb-acee-819f3138875a"},{"index":2406,"token":false,"name":"Jukai Messenger","scryfallId":"56e1967e-5bc5-47e7-9998-7fcfdffc3bb1"},{"index":2407,"token":false,"name":"Krovikan Mist","scryfallId":"6152487a-4b9b-4c26-9430-afab60e43101"},{"index":2409,"token":false,"name":"Field of the Dead","scryfallId":"68619895-e0bc-477e-b419-b188b6515768"},{"index":2410,"token":false,"name":"Fearless Fledgling","scryfallId":"48b8024d-a300-43cb-9dde-6b4cb1fa19f7"},{"index":2411,"token":false,"name":"Endless Cockroaches","scryfallId":"0d3d18b9-ad59-435b-934b-703e10287e32"},{"index":2412,"token":false,"name":"Snow-Covered Mountain","scryfallId":"435510c2-045a-4970-9979-2e92234bff19"},{"index":2413,"token":false,"name":"Aven Sentry","scryfallId":"ec03fcba-20dd-4685-b54d-966f2beab962"},{"index":2414,"token":false,"name":"Pillage","scryfallId":"7ad3693e-47ce-48bf-9f8c-eaf1411ac57d"},{"index":2415,"token":false,"name":"Alela, Artful Provocateur","scryfallId":"726e7dc5-2089-4758-93e1-79212aedf75f"},{"index":2416,"token":false,"name":"Thunderkin Awakener","scryfallId":"99b5d6e9-bca0-4481-b43e-61cabb3deb63"},{"index":2417,"token":false,"name":"Rag Man","scryfallId":"8e3809e6-41ac-47e8-80dc-9e9c8be1ed7a"},{"index":2418,"token":false,"name":"Elven Riders","scryfallId":"9a97723b-cdf0-4784-83a4-3b1a714e720a"},{"index":2419,"token":false,"name":"Jwar Isle Refuge","scryfallId":"490cde85-1fe2-45ce-939e-e7c9b81dc947"},{"index":2420,"token":false,"name":"Ana Sanctuary","scryfallId":"9d1599bb-4f43-4ab3-985a-8be5219f2195"},{"index":2421,"token":false,"name":"Worry Beads","scryfallId":"400edfe9-9efa-43f9-b713-13ad4eae2fa4"},{"index":2422,"token":false,"name":"Deadly Alliance","scryfallId":"007a5c8c-ed0b-4844-9393-a3d25d4ffa1d"},{"index":2423,"token":false,"name":"Dwarven Warriors","scryfallId":"2d4d87a3-5f8b-4152-9a8b-538ab49d62e8"},{"index":2424,"token":false,"name":"Mindwrack Demon","scryfallId":"dd80262b-5f4a-4ea5-88da-f21fca83df3e"},{"index":2426,"token":false,"name":"Stony Strength","scryfallId":"8bbab274-69dd-44a9-9310-a15779c35cad"},{"index":2427,"token":false,"name":"Annul","scryfallId":"5e71b6ad-4b81-4277-8512-0a3f2266cd23"},{"index":2428,"token":false,"name":"Fling","scryfallId":"60cd9d00-30eb-4060-baea-176104d3fa1a"},{"index":2430,"token":false,"name":"Nether Shadow","scryfallId":"11988c46-6d0c-46a8-85aa-8c6da72bfe30"},{"index":2431,"token":false,"name":"Staff of Zegon","scryfallId":"397a16db-dcba-4fca-a58b-438e43d7d574"},{"index":2432,"token":false,"name":"Alaborn Zealot","scryfallId":"a5eba273-0b83-42a7-b8b0-9e0cd6a7aa6f"},{"index":2434,"token":false,"name":"Demolish","scryfallId":"6ce356aa-9374-4f11-95b4-48bcaec64e93"},{"index":2435,"token":false,"name":"Aegis of the Gods","scryfallId":"f2b2f381-86a2-42ac-b694-dcde437d574f"},{"index":2437,"token":false,"name":"Kalastria Highborn","scryfallId":"c6ca7268-e60b-4ad3-9410-eb60d9aec0d4"},{"index":2438,"token":false,"name":"Relentless Advance","scryfallId":"4258e242-91c6-4b30-86ec-7759705aa97c"},{"index":2439,"token":false,"name":"Lurrus of the Dream-Den","scryfallId":"d1520f81-48ea-4970-b46e-00d01d425c63"},{"index":2440,"token":false,"name":"Mardu Shadowspear","scryfallId":"a599346d-27bd-4ba8-988e-f23fe594f3f7"},{"index":2442,"token":false,"name":"Xenagos, God of Revels","scryfallId":"5943d27d-6db2-422d-97f5-ae98270a2556"},{"index":2444,"token":false,"name":"Flowstone Overseer","scryfallId":"3e644ab8-3cc3-413d-a918-44fc636087ae"},{"index":2445,"token":false,"name":"Laboratory Drudge","scryfallId":"b6a1d1e2-caea-4e64-8a3a-740f62b36853"},{"index":2447,"token":false,"name":"Enlistment Officer","scryfallId":"38138bb4-25ea-4aaf-8b1c-e9e60678fc6b"},{"index":2448,"token":false,"name":"Agoraphobia","scryfallId":"b450de6b-4b2f-4004-be7c-484434f28faf"},{"index":2449,"token":true,"name":"Clue","scryfallId":"93acc8a5-c694-4ad8-b4c0-2e156424319d"},{"index":2450,"token":false,"name":"Augur of Bolas","scryfallId":"d19fbfe6-69bb-452a-be3c-b9c625e23193"},{"index":2451,"token":false,"name":"Cyclone Summoner","scryfallId":"cf5da39e-ba07-4b7f-90e4-3138b736337e"},{"index":2452,"token":false,"name":"Antler Skulkin","scryfallId":"ca66c361-3cea-4f9c-836d-3513f05d6b22"},{"index":2453,"token":false,"name":"Bonehoard","scryfallId":"75dc1b48-7d49-45ac-b345-988392183ff0"},{"index":2454,"token":false,"name":"Cinder Pyromancer","scryfallId":"514b8cc1-7d5b-40ff-9c71-bb5e54e40358"},{"index":2455,"token":false,"name":"Burning Sun's Avatar","scryfallId":"61254cfe-4870-4a6d-a60b-0704ae6e051c"},{"index":2456,"token":false,"name":"Nine-Tail White Fox","scryfallId":"1c61fcdc-bf2f-46e1-b96a-98935ccc187d"},{"index":2457,"token":false,"name":"Sabretooth Tiger","scryfallId":"c85964eb-c586-4e62-9a19-6a665e6ad98d"},{"index":2458,"token":false,"name":"Gluttonous Troll","scryfallId":"867e245b-6153-479c-9e09-682afb017ff3"},{"index":2459,"token":false,"name":"Steel Wall","scryfallId":"bac8df83-12c2-4543-b264-4f2d007fbf58"},{"index":2460,"token":false,"name":"Erhnam Djinn","scryfallId":"5bcf61ba-37fd-4029-b299-add7cf9d70bc"},{"index":2461,"token":false,"name":"Polluted Delta","scryfallId":"bf0cce8a-d391-4a63-b701-a1abce082b77"},{"index":2462,"token":false,"name":"Argivian Restoration","scryfallId":"fd7d85bd-121b-4a82-a1b7-9becd5845159"},{"index":2463,"token":false,"name":"Anticognition","scryfallId":"db99b872-77c7-4471-9c44-a36d4ff5d33f"},{"index":2464,"token":false,"name":"Invisibility","scryfallId":"7c4d29f9-5470-4a21-9ac9-82cfeccb247a"},{"index":2465,"token":false,"name":"Plumeveil","scryfallId":"aad6c9c6-53db-4f6f-a20b-16dcbae42d0c"},{"index":2466,"token":false,"name":"Bog Serpent","scryfallId":"2958de76-a5ec-4e14-a025-4fe0e84c8b4b"},{"index":2467,"token":false,"name":"Yahenni's Expertise","scryfallId":"0f4ddbb7-b317-44dc-bb3d-52f52c0a8f96"},{"index":2469,"token":false,"name":"Fire // Ice","scryfallId":"f98f4538-5b5b-475d-b98f-49d01dae6f04"},{"index":2470,"token":false,"name":"Chainer, Nightmare Adept","scryfallId":"875244ac-d129-407a-bd9b-9fb59958bef9"},{"index":2472,"token":false,"name":"Frostveil Ambush","scryfallId":"deef1197-e40a-4c9d-919a-213f1bdf3e3e"},{"index":2473,"token":false,"name":"Once Upon a Time","scryfallId":"4034e5ba-9974-43e3-bde7-8d9b4586c3a4"},{"index":2475,"token":false,"name":"Fevered Visions","scryfallId":"3ee3fc2b-c2e4-421d-ac1d-6a111bb44f44"},{"index":2476,"token":false,"name":"Banshee's Blade","scryfallId":"b77baad4-2bd6-492a-86ca-8e0088b751d2"},{"index":2477,"token":false,"name":"Panic Spellbomb","scryfallId":"e9a29832-8630-498a-9ac3-bc709a6dc95d"},{"index":2478,"token":false,"name":"Slayer's Cleaver","scryfallId":"9de4a83a-3a0c-4174-ba65-a6e100383b32"},{"index":2479,"token":false,"name":"Thryx, the Sudden Storm","scryfallId":"3044489e-84e0-453e-9248-a200d27ad17c"},{"index":2480,"token":false,"name":"Breathstealer","scryfallId":"0cd9da69-5e57-4719-a712-630c9464fada"},{"index":2482,"token":false,"name":"Order of the Sacred Torch","scryfallId":"ccc5cb36-c43d-4c71-8019-9b683e160a0a"},{"index":2483,"token":false,"name":"Magmatic Insight","scryfallId":"f00192e0-439d-43b2-882c-90a2d52103f8"},{"index":2484,"token":false,"name":"Wall of Swords","scryfallId":"7633809f-803c-41ba-8d59-e3762c4fe5a4"},{"index":2485,"token":false,"name":"Smoldering Marsh","scryfallId":"359b189d-aa51-4e90-820a-e79884562e34"},{"index":2486,"token":false,"name":"Chromatic Lantern","scryfallId":"ea123356-3055-4e42-b816-ac3c4e9087d1"},{"index":2488,"token":false,"name":"Spiketail Drakeling","scryfallId":"c752a0b9-cc87-4c3e-a1e8-0162715e011a"},{"index":2489,"token":false,"name":"Wall of Wood","scryfallId":"ae1f0f6f-2017-46d8-bc9d-809b002283e0"},{"index":2490,"token":false,"name":"Cruel Bargain","scryfallId":"96837a9e-dd68-4ce8-b760-0e1c22837164"},{"index":2491,"token":false,"name":"Madblind Mountain","scryfallId":"513adae2-6436-4284-9f23-87ef627e81b7"},{"index":2493,"token":false,"name":"Leyline of Vitality","scryfallId":"f5318113-9dfb-492c-9151-de90951d881e"},{"index":2494,"token":false,"name":"Phyrexian Furnace","scryfallId":"57219ccb-aa94-41e5-a0fe-8600fae6bf65"},{"index":2496,"token":false,"name":"Plague Wind","scryfallId":"327d38a9-e631-4f5e-a7c3-b99794a40954"},{"index":2497,"token":false,"name":"Fyndhorn Elder","scryfallId":"0b8532a8-966e-4cba-b3a5-99cfb0ee1220"},{"index":2498,"token":false,"name":"Commander Greven il-Vec","scryfallId":"ab0ce69f-a259-4801-9ac3-f6754040434c"},{"index":2499,"token":false,"name":"Locthwain Paladin","scryfallId":"da6f21a8-3dd0-42af-8a93-84f98968c781"},{"index":2500,"token":false,"name":"Goblin Piker","scryfallId":"e1a33fbd-dcf7-4503-8a99-c289252cb612"},{"index":2501,"token":false,"name":"Oasis Ritualist","scryfallId":"6f493481-0b83-4ed1-ae07-d780e75c6005"},{"index":2502,"token":false,"name":"Ivory Tower","scryfallId":"2f018f7f-1150-448e-93fd-2a75a0fcb289"},{"index":2503,"token":false,"name":"Hamza, Guardian of Arashin","scryfallId":"c793d594-c319-4e97-8620-de8eddaf247d"},{"index":2504,"token":false,"name":"Life from the Loam","scryfallId":"899ed197-e434-4f01-a71f-053ae3820d6c"},{"index":2505,"token":false,"name":"Dragonsoul Knight","scryfallId":"14674d80-2571-4794-863e-247c2e2cfc3e"},{"index":2506,"token":false,"name":"Jungle Creeper","scryfallId":"3d71282d-021c-4028-9ab7-f10e43e92c80"},{"index":2507,"token":false,"name":"Majestic Myriarch","scryfallId":"5cd7c382-725c-4407-b15e-0c830a573838"},{"index":2508,"token":false,"name":"Door of Destinies","scryfallId":"ac4800be-5f77-42f5-914c-2a8e647e3af5"},{"index":2509,"token":false,"name":"Stomping Ground","scryfallId":"a2773d8f-f906-475d-aaff-b7ca3b01f188"},{"index":2510,"token":false,"name":"Land Leeches","scryfallId":"ef8db5be-cd82-494e-aa2c-89362bdb5308"},{"index":2511,"token":false,"name":"Bomat Courier","scryfallId":"e7fb3cd7-cec6-4c93-8de6-1b074320052c"},{"index":2512,"token":false,"name":"Retriever Phoenix","scryfallId":"4dd6cb53-3c82-4ac3-be1e-311322729198"},{"index":2513,"token":false,"name":"Canopy Crawler","scryfallId":"0ccdc9d7-71b5-4304-8d19-a63952e17a6b"},{"index":2514,"token":false,"name":"Extinction Event","scryfallId":"2c4e7a67-391e-4427-894d-bdda683c086f"},{"index":2515,"token":false,"name":"Great Oak Guardian","scryfallId":"eab4d522-6784-4db4-a7df-fc728ddd88cd"},{"index":2516,"token":false,"name":"Arch of Orazca","scryfallId":"c6d47162-749b-47d5-9589-8f1dbf60b9f3"},{"index":2517,"token":false,"name":"Death Grasp","scryfallId":"ed67b8a0-8b6a-4b4b-a3ba-76e06474ce1b"},{"index":2518,"token":false,"name":"Cage of Hands","scryfallId":"36895e57-e355-403f-ba52-1d444ca5ffed"},{"index":2519,"token":false,"name":"Ethereal Absolution","scryfallId":"0872d0ff-1060-44cc-9ed0-a6aa496440c8"},{"index":2520,"token":false,"name":"Stromkirk Occultist","scryfallId":"1fa6a443-b23b-48ae-97bb-8fd4deec52c4"},{"index":2521,"token":false,"name":"Knight of Infamy","scryfallId":"9e339853-5b6b-47b7-8d88-e9d3befb803f"},{"index":2522,"token":false,"name":"Looming Spires","scryfallId":"b88177a2-de41-417d-a8f1-07edf005b453"},{"index":2524,"token":false,"name":"Hideous End","scryfallId":"519bf730-195c-4d3a-b80b-641b66ffc794"},{"index":2527,"token":false,"name":"Boil","scryfallId":"fc807868-bf6f-4d62-8ca3-51ec6c507df7"},{"index":2528,"token":false,"name":"Lavastep Raider","scryfallId":"2428f13f-c445-4eb4-bab1-309f27cab208"},{"index":2530,"token":false,"name":"Wall of Nets","scryfallId":"c1da8e79-365d-4a36-87c5-648085828f9f"},{"index":2531,"token":false,"name":"Circular Logic","scryfallId":"2b5836fd-a29c-423c-94dc-777d0b80b279"},{"index":2532,"token":false,"name":"Celestial Crusader","scryfallId":"147dc9b4-5fa6-4477-b3ea-40f09026efdf"},{"index":2533,"token":false,"name":"Sorrow's Path","scryfallId":"61f78b87-c861-4cd4-9b0a-a09396d51e6c"},{"index":2534,"token":false,"name":"Gigadrowse","scryfallId":"bf9f85b3-eb8c-43de-aaac-8a887e9c58da"},{"index":2535,"token":false,"name":"Akroan Phalanx","scryfallId":"fe23019a-e432-4a27-8acb-b17728a1e8b0"},{"index":2536,"token":false,"name":"Goldvein Pick","scryfallId":"9bf5e4ad-a6e9-4b7c-a1ec-8246d3a3b6ca"},{"index":2537,"token":false,"name":"Natural Affinity","scryfallId":"b9d782c5-1462-4533-8004-672450bf5c07"},{"index":2538,"token":false,"name":"Boros Cluestone","scryfallId":"87252577-3e7b-4ea2-b0ac-3ba3f0eaac40"},{"index":2539,"token":false,"name":"Shadowmage Infiltrator","scryfallId":"932ce702-565f-4d8c-b9fc-2d7c939ef7d7"},{"index":2541,"token":false,"name":"Ali Baba","scryfallId":"5e2bcd90-1d34-4ef6-a5eb-e0e790ca44e0"},{"index":2542,"token":false,"name":"Burrenton Bombardier","scryfallId":"fd872395-f351-4f7e-9290-c34d1c98a567"},{"index":2544,"token":false,"name":"Murder of Crows","scryfallId":"f914f7e4-06fc-4943-8597-b7f834938c00"},{"index":2545,"token":false,"name":"Rakdos Shred-Freak","scryfallId":"06899549-5534-4d11-86c1-afd1796e18b1"},{"index":2546,"token":false,"name":"Kormus Bell","scryfallId":"59fbace3-a975-470f-b41c-94361f0f5b42"},{"index":2547,"token":false,"name":"Devils' Playground","scryfallId":"92081d19-1885-4377-8eb0-f8e833293434"},{"index":2548,"token":false,"name":"Defensive Formation","scryfallId":"fdd76db0-1a67-4965-81a5-1d8d86b63971"},{"index":2549,"token":false,"name":"Earthbind","scryfallId":"8a05dcd8-4c5d-413c-b1c0-3613f211a284"},{"index":2550,"token":false,"name":"Rebbec, Architect of Ascension","scryfallId":"936cfe1a-3ddd-481a-80d3-02504d3004dc"},{"index":2552,"token":false,"name":"Skywhaler's Shot","scryfallId":"3e2c5013-523f-42b2-b947-abe304a6cb84"},{"index":2553,"token":false,"name":"Brain in a Jar","scryfallId":"98e2cec0-50b0-4a08-9182-24b0810cc2d4"},{"index":2555,"token":false,"name":"Grixis Illusionist","scryfallId":"ec7bd811-a49d-4d5d-9a58-2c35465ed606"},{"index":2556,"token":false,"name":"Angel of Serenity","scryfallId":"c175b50d-81cc-45dd-854f-7f8ca31cffa4"},{"index":2557,"token":false,"name":"Fate Foretold","scryfallId":"90d3ef99-6c86-4d70-a9a4-9c3cd4eb9538"},{"index":2560,"token":false,"name":"Dandân","scryfallId":"9ac60e8c-ef5b-4893-b3e5-4a54cb0a0d3a"},{"index":2561,"token":false,"name":"Melee","scryfallId":"b13a064d-bff4-4a48-a158-1b61951b0ac3"},{"index":2564,"token":false,"name":"Night of Souls' Betrayal","scryfallId":"dce44980-0540-4b31-9a81-35357a4382fa"},{"index":2565,"token":false,"name":"Ravenous Trap","scryfallId":"21e49fd8-cc6d-423d-93fe-2c521459f1e7"},{"index":2568,"token":false,"name":"Phyrexian Grimoire","scryfallId":"2fcf5b8a-563b-48d7-a874-e9c226192320"},{"index":2570,"token":false,"name":"Glorifier of Dusk","scryfallId":"aaf87f95-1c77-455a-8feb-57bfd4d159c9"},{"index":2572,"token":false,"name":"Feral Abomination","scryfallId":"b2890cb5-7899-42f4-9686-a8b5ac796c23"},{"index":2573,"token":false,"name":"Evincar's Justice","scryfallId":"139f9fe4-7120-48ac-a9bd-548374452024"},{"index":2574,"token":false,"name":"Chill of Foreboding","scryfallId":"0abd6534-92bb-44e3-88c2-6709f1a4f29c"},{"index":2575,"token":false,"name":"Epicure of Blood","scryfallId":"40b03528-f4ec-4825-ba4c-c485cb4eab3a"},{"index":2576,"token":false,"name":"Honden of Life's Web","scryfallId":"766562f1-63b2-41d3-b76d-a31bac70fa89"},{"index":2577,"token":false,"name":"Clone","scryfallId":"7a20fe69-5265-46c1-bcd2-eccbf7085266"},{"index":2580,"token":false,"name":"Spider Umbra","scryfallId":"762b8d61-53c9-41e1-aaa7-098b91d9b938"},{"index":2581,"token":false,"name":"Aether Hub","scryfallId":"a4a9c5ae-c6f2-4189-bf0e-2bd698caff0c"},{"index":2582,"token":false,"name":"Hall of Triumph","scryfallId":"634fd988-5d5c-4637-b7fd-05a41798ead8"},{"index":2583,"token":false,"name":"Vein Drinker","scryfallId":"25ad3372-51cb-4b82-a23c-81938b7c01b6"},{"index":2584,"token":false,"name":"Shatter","scryfallId":"7eb18d53-20de-43d7-86f7-97a6d14d54b8"},{"index":2585,"token":false,"name":"Phyrexian Vatmother","scryfallId":"f0024556-0317-4c28-83c3-0a6020d72a2b"},{"index":2586,"token":false,"name":"Curiosity","scryfallId":"fee17ef5-7e1a-42ae-b680-df81204df7dd"},{"index":2587,"token":false,"name":"Angelic Chorus","scryfallId":"d9e966cb-bb42-49d8-b351-114619b31497"},{"index":2588,"token":false,"name":"Samite Pilgrim","scryfallId":"c12529e4-f4b1-45be-8252-28783badbec5"},{"index":2589,"token":false,"name":"Malicious Affliction","scryfallId":"127f3f4d-93f4-4e52-b3c1-325c3981e0e1"},{"index":2590,"token":true,"name":"Jon Finkel Bio","scryfallId":"de9d6766-2b3c-4215-858b-5205702cbc8e"},{"index":2591,"token":false,"name":"Flailing Ogre","scryfallId":"e400e520-b2b8-4c13-a4ea-f8810c927bf7"},{"index":2593,"token":false,"name":"Shinka Gatekeeper","scryfallId":"8fdaf49b-9524-4824-807e-c40fcb381742"},{"index":2594,"token":false,"name":"Shrouded Lore","scryfallId":"79095e77-4e3a-4377-be8e-ae52380e6d5e"},{"index":2595,"token":false,"name":"Impale","scryfallId":"dfa0c4f7-3497-467d-9453-104fb4b5a0f3"},{"index":2597,"token":false,"name":"Civic Wayfinder","scryfallId":"76d01445-ada9-452e-a6c0-d9dff59755f9"},{"index":2598,"token":false,"name":"Deranged Whelp","scryfallId":"fd06f9eb-112e-458b-83c8-3761df6d60ff"},{"index":2599,"token":true,"name":"Squirrel Token (G, 1/1)","scryfallId":"3af9733f-192f-4028-8ad6-aa1187dd15e7"},{"index":2600,"token":false,"name":"River Kelpie","scryfallId":"970adaaf-1534-4529-8da4-c4dcf7c08b7b"},{"index":2601,"token":false,"name":"Skemfar Avenger","scryfallId":"21b5346e-b9d1-4214-a15e-c082fb0e0949"},{"index":2602,"token":false,"name":"Dispel","scryfallId":"72df0898-72a4-444a-83bf-8252bd6ae563"},{"index":2603,"token":false,"name":"Titania, Protector of Argoth","scryfallId":"bab161d9-45d7-48b7-af47-21e3dbae4d85"},{"index":2604,"token":false,"name":"Felhide Brawler","scryfallId":"4a829bb0-6a84-46de-9c2d-14176cf542e6"},{"index":2605,"token":false,"name":"Fire-Lit Thicket","scryfallId":"0ab9d6ad-f819-4a1e-b4ff-8dc00791f0fd"},{"index":2606,"token":false,"name":"Brothers of Fire","scryfallId":"ba2cc4a6-fdcc-4082-801a-d2c50e560e8d"},{"index":2609,"token":false,"name":"Mathas, Fiend Seeker","scryfallId":"09f688cd-9315-4d70-ae90-309f3e552c1f"},{"index":2612,"token":false,"name":"Badlands","scryfallId":"717f6d10-9144-4ade-9ac6-a481cc66b875"},{"index":2613,"token":false,"name":"Warren Weirding","scryfallId":"524aa84d-7838-4664-b30c-3c242b46fc6b"},{"index":2614,"token":false,"name":"Cursed Scroll","scryfallId":"680531a6-4248-4159-8eb0-aff6adce5e0d"},{"index":2615,"token":false,"name":"Tower of Calamities","scryfallId":"8a77391b-5727-4408-bb50-970f7a13a83c"},{"index":2617,"token":false,"name":"Relentless Pursuit","scryfallId":"752b9560-b1d6-441c-8bc8-bf6988112d25"},{"index":2618,"token":false,"name":"Barkhide Troll","scryfallId":"0cfd2e76-ad64-42ff-a6a2-c4cf1bec5932"},{"index":2619,"token":false,"name":"Sphinx's Tutelage","scryfallId":"4d90c3b0-f958-4a15-94a1-9bf1b0a9ac2a"},{"index":2620,"token":false,"name":"Fogwalker","scryfallId":"3e23d56b-0251-4bc7-af89-2fbc68e125b5"},{"index":2621,"token":false,"name":"Steel Leaf Champion","scryfallId":"24d8a688-79d4-49b9-ab0c-c7f5c9b551f4"},{"index":2622,"token":false,"name":"Stormbind","scryfallId":"45f03556-cef5-438d-a1d8-66c297502622"},{"index":2623,"token":false,"name":"Hermit of the Natterknolls // Lone Wolf of the Natterknolls","scryfallId":"d5e84d80-b5a6-4cd1-9f31-f6ca46bf2c0c"},{"index":2624,"token":false,"name":"Highland Lake","scryfallId":"46bb20af-a326-4a42-94d3-cb1990300e0f"},{"index":2625,"token":false,"name":"Rites of Flourishing","scryfallId":"3babf16d-b8ae-4679-88e2-f88077f1cb6a"},{"index":2626,"token":false,"name":"Arbiter of Knollridge","scryfallId":"6b598cf2-c327-422b-9527-1b28645ba70c"},{"index":2627,"token":false,"name":"Magnivore","scryfallId":"200fa50d-5a54-47eb-a123-29c4fb55ebee"},{"index":2628,"token":false,"name":"The Royal Scions","scryfallId":"6a7111f3-01a6-4311-bc08-036a1fba60f5"},{"index":2629,"token":false,"name":"Pristine Talisman","scryfallId":"6b6307f3-bc63-463c-8ffc-a8b8b829e5d7"},{"index":2630,"token":false,"name":"Rith, the Awakener","scryfallId":"822bb102-58a8-47c7-ab44-6fef29885425"},{"index":2631,"token":false,"name":"Ghostly Possession","scryfallId":"c11eb854-4c03-4abd-aaf1-9718608a34b3"},{"index":2632,"token":false,"name":"Elspeth, Sun's Champion","scryfallId":"c77b8e26-55bf-4e60-a708-f910f4a5cbf1"},{"index":2633,"token":true,"name":"Snapping Fang Head Token (Colorless, 0/8)","scryfallId":"11decc7a-58e7-43f3-acc5-9ec94cce858d"},{"index":2634,"token":false,"name":"Zendikar's Roil","scryfallId":"60297593-2438-48d7-9414-48af114a93d2"},{"index":2636,"token":false,"name":"Boreal Druid","scryfallId":"f656c45c-60f8-4588-9f18-67e7a5e2ae05"},{"index":2637,"token":false,"name":"Flamecast Wheel","scryfallId":"5cfa31c9-5a11-4366-9063-056a659f3d0d"},{"index":2639,"token":false,"name":"Cosmic Horror","scryfallId":"07e975cc-e89d-4ac3-b9dc-dad202dacc14"},{"index":2640,"token":false,"name":"Nadir Kraken","scryfallId":"f2d0afbf-4c75-4b28-aeed-df02593c9ce3"},{"index":2641,"token":false,"name":"Holy Justiciar","scryfallId":"640cad49-1db3-4611-a80d-7ce95f000fad"},{"index":2642,"token":false,"name":"Imaginary Pet","scryfallId":"1aa19ecb-146e-4109-b4ef-74675b35d8c4"},{"index":2643,"token":false,"name":"Kiora Bests the Sea God","scryfallId":"2b604451-4f6c-4cfa-8d3a-01f18d01d88f"},{"index":2644,"token":false,"name":"Explosive Welcome","scryfallId":"122c01e6-38a6-456e-971e-9004df85ac1c"},{"index":2645,"token":false,"name":"Mark of Mutiny","scryfallId":"c0794a98-e80e-4485-8bf7-7398818c60fa"},{"index":2646,"token":false,"name":"Gifted Aetherborn","scryfallId":"8644d4d1-8499-40a8-a01f-68172c82bf58"},{"index":2647,"token":false,"name":"Savage Twister","scryfallId":"5aa253a6-2513-4dfd-b34a-88c341d0372c"},{"index":2648,"token":false,"name":"Assault Griffin","scryfallId":"f72ced22-1f2c-4fa6-a938-8ebe2c15cc8d"},{"index":2649,"token":false,"name":"Invigorated Rampage","scryfallId":"2c1d1727-99d4-4aee-b6f5-8399ac1d0184"},{"index":2650,"token":false,"name":"Countersquall","scryfallId":"2b645d74-420e-45e5-aa82-ba3a8dfdd9a0"},{"index":2651,"token":false,"name":"Lava Burst","scryfallId":"45cb4936-52e5-4353-b984-a3badac8250c"},{"index":2652,"token":false,"name":"Briber's Purse","scryfallId":"7f9951f1-ca51-44a2-8480-602df466f0ab"},{"index":2653,"token":false,"name":"Turn Aside","scryfallId":"c422d5e0-8ae2-4803-95ac-8a873584fc65"},{"index":2654,"token":false,"name":"Sanctum Prelate","scryfallId":"0967318e-8117-460a-8262-a3b17fc0232c"},{"index":2655,"token":false,"name":"Vizier of Tumbling Sands","scryfallId":"b1514f3d-7444-4c6c-8f7c-bf3565603429"},{"index":2658,"token":false,"name":"Yuki-Onna","scryfallId":"63c6e1cd-e25d-41ff-a918-c495998376d8"},{"index":2659,"token":false,"name":"Search for Tomorrow","scryfallId":"a0383f8d-8b8a-4a6b-8756-b27d8351a856"},{"index":2660,"token":false,"name":"Crucible of the Spirit Dragon","scryfallId":"6bf563e0-1f42-4768-a667-3e120bdb6534"},{"index":2661,"token":false,"name":"Citadel Siege","scryfallId":"239c373a-465c-4cda-9895-624871d8606e"},{"index":2662,"token":false,"name":"Mox Opal","scryfallId":"3722deaf-de7b-4e49-b93b-b790fb598337"},{"index":2663,"token":false,"name":"Kamahl's Druidic Vow","scryfallId":"25b93f07-53bc-4fe7-8ac9-8df01dfd6398"},{"index":2665,"token":false,"name":"Ichorid","scryfallId":"97431dca-54ca-47ef-ab00-943140e8e758"},{"index":2666,"token":true,"name":"Feather","scryfallId":"a9cc7c63-5d13-4fd6-af9d-4a26c2bab8e6"},{"index":2667,"token":false,"name":"Feast of Blood","scryfallId":"658bf8b7-fbc4-4046-9300-249cdeb87924"},{"index":2668,"token":false,"name":"Ivory Cup","scryfallId":"fb83d2f1-36c6-4b79-b7f9-c9f91d048a39"},{"index":2669,"token":false,"name":"Jabari's Banner","scryfallId":"3d51a496-1ca6-4286-bdbe-990d43196a25"},{"index":2670,"token":false,"name":"Befoul","scryfallId":"7c5db137-33b9-4cea-9193-4e637d2966f1"},{"index":2671,"token":false,"name":"Mana Short","scryfallId":"b3e13709-6e6e-499e-b861-699d4d98a8a7"},{"index":2672,"token":false,"name":"Spineless Thug","scryfallId":"8bb39c4b-187d-479a-9b19-e8b24d5caef4"},{"index":2673,"token":false,"name":"Manabarbs","scryfallId":"6121f72f-680f-4bb4-ae4d-37ee4ebed4d8"},{"index":2674,"token":false,"name":"Suntail Hawk","scryfallId":"07b6c274-78e1-48eb-8436-05608797826f"},{"index":2675,"token":false,"name":"Cao Ren, Wei Commander","scryfallId":"4f7e8366-82ba-4df0-b9df-7d0aa9b972eb"},{"index":2676,"token":false,"name":"Paradoxical Outcome","scryfallId":"17e50157-bf49-4c5f-9b8a-bf73484e63a5"},{"index":2677,"token":false,"name":"Elvish Farmer","scryfallId":"9e37a5d9-2b6f-4412-aec2-0d6161e2a7d2"},{"index":2678,"token":false,"name":"Joven's Tools","scryfallId":"91c7aa8e-5873-4e18-8adb-1523c01d4e86"},{"index":2679,"token":false,"name":"Unmoored Ego","scryfallId":"95aecc12-3363-41f7-9b58-277c81859670"},{"index":2681,"token":false,"name":"Righteous Cause","scryfallId":"bc632184-b330-42d8-808d-17a94b08c535"},{"index":2682,"token":false,"name":"Moriok Rigger","scryfallId":"47ffdeb8-52d2-4059-b9c6-0ad71b96516a"},{"index":2683,"token":true,"name":"Griffin Token (W, 2/2)","scryfallId":"96c36884-df5e-435d-9473-65da550535fb"},{"index":2687,"token":false,"name":"Basking Rootwalla","scryfallId":"f2adb043-e9e6-403f-888b-cf693d35f411"},{"index":2688,"token":false,"name":"Frozen Aether","scryfallId":"a1769da6-e38a-48dd-80c5-fb7863ba718e"},{"index":2689,"token":false,"name":"Vivid Meadow","scryfallId":"d9dd64b1-12f8-49f6-b12e-f5a1b4f219dc"},{"index":2690,"token":false,"name":"Energy Flux","scryfallId":"5f75dea2-aec1-4674-8db9-4759270296ec"},{"index":2691,"token":false,"name":"Kitesail Corsair","scryfallId":"36056deb-a7f8-4bb3-9c51-890e96f41482"},{"index":2692,"token":false,"name":"Steamcore Weird","scryfallId":"8aee6138-5cc0-4479-add6-28fc0a062254"},{"index":2693,"token":false,"name":"Noxious Toad","scryfallId":"b5ec75ba-bae2-4ccc-b18b-ad4639cfb548"},{"index":2694,"token":false,"name":"Serra's Liturgy","scryfallId":"b84be3ef-a820-41e3-b66a-09303dad32dd"},{"index":2695,"token":false,"name":"Brimstone Volley","scryfallId":"6960f2da-6b84-4680-8ab2-f0567a5d1b0a"},{"index":2696,"token":false,"name":"Nahiri's Machinations","scryfallId":"a9ba0f1c-8641-4f5a-8f2e-f969fc7a058a"},{"index":2697,"token":false,"name":"Glorious Protector","scryfallId":"d9f08552-7f1a-4fdb-9a70-d99cdbf75910"},{"index":2698,"token":true,"name":"2004 World Championships Ad","scryfallId":"cbd6a762-f3c2-4b29-a07e-f0c9c81cf1ec"},{"index":2699,"token":false,"name":"Balduvian Shaman","scryfallId":"74859723-8ddf-4ee6-a0a7-87192c84e8ad"},{"index":2700,"token":false,"name":"Flamekin Herald","scryfallId":"68f03399-c9f8-40ca-bee5-07217788c186"},{"index":2701,"token":false,"name":"Kaervek, the Spiteful","scryfallId":"2d1023a9-175c-4bbe-a2a9-8ebe06261ae5"},{"index":2702,"token":false,"name":"Nin, the Pain Artist","scryfallId":"992420a5-f6c4-4310-a2d0-fe6893765aa2"},{"index":2704,"token":false,"name":"Phantasmal Terrain","scryfallId":"ea56a1bb-f52c-4c6b-a089-1f78600f3db0"},{"index":2705,"token":false,"name":"Vraska, Swarm's Eminence","scryfallId":"0be61d61-6a5b-471b-9a62-8a7fdeef1331"},{"index":2706,"token":false,"name":"Elven Rite","scryfallId":"daba8742-c246-4e64-8af1-8f4ebcdc4b5f"},{"index":2707,"token":false,"name":"Augmenter Pugilist // Echoing Equation","scryfallId":"b120e3c2-21b1-43e3-b685-9cf62bd7aa07"},{"index":2708,"token":false,"name":"Alpine Grizzly","scryfallId":"38bbf983-df71-4403-86f3-2e86aa8765b8"},{"index":2709,"token":false,"name":"Kavu Climber","scryfallId":"b343c2ba-e646-4614-aace-9f8772974069"},{"index":2710,"token":false,"name":"Overwhelming Instinct","scryfallId":"2d9e3793-7ddc-45c5-b25d-acd5cb96026f"},{"index":2711,"token":false,"name":"Phyrexian Rager","scryfallId":"f1cd5e02-9450-4097-b0a5-a62a8e2e552d"},{"index":2712,"token":false,"name":"Axis of Mortality","scryfallId":"3b9d72a8-8acf-42c6-8adf-cbaecb4a985a"},{"index":2713,"token":false,"name":"Skyhunter Skirmisher","scryfallId":"87bfcc61-80fe-4d21-8219-d31420a28989"},{"index":2714,"token":false,"name":"Lumithread Field","scryfallId":"a97636cf-d386-434d-8f7e-d80da60c96fc"},{"index":2715,"token":false,"name":"Elvish Visionary","scryfallId":"367ef35a-528b-407c-8b8d-679109662bae"},{"index":2716,"token":false,"name":"Consume the Meek","scryfallId":"921ebea0-48bf-4338-9e84-2cd06ffe6f4b"},{"index":2717,"token":false,"name":"Spawning Grounds","scryfallId":"30b07d5a-0934-4373-bec3-518e9d81ca59"},{"index":2718,"token":false,"name":"Master Symmetrist","scryfallId":"255cdc39-6ad8-4831-9718-6712cb17654c"},{"index":2719,"token":false,"name":"Entropic Eidolon","scryfallId":"5998cab0-77cd-4a22-8049-37d39928df6d"},{"index":2720,"token":false,"name":"Tahngarth, First Mate","scryfallId":"1692c11b-018e-47bf-b38d-3c3e6b79b37c"},{"index":2721,"token":false,"name":"Deeproot Elite","scryfallId":"c8b738ce-a609-448f-97ea-bbf90ba833d7"},{"index":2722,"token":false,"name":"Vindictive Mob","scryfallId":"23c5c72c-982c-4cfd-b576-089200b4cc04"},{"index":2723,"token":false,"name":"Jamuraan Lion","scryfallId":"bfc681f5-9fff-48b6-98d9-e85c85e582a3"},{"index":2724,"token":false,"name":"Show and Tell","scryfallId":"4b851c17-55ed-4671-b471-dc7b34944432"},{"index":2726,"token":false,"name":"Rowan Kenrith","scryfallId":"74374ac4-87e8-4872-b7b2-6cc009acd6d9"},{"index":2728,"token":false,"name":"Righteousness","scryfallId":"b847a2d1-5912-4f88-a68f-06790d0795dc"},{"index":2729,"token":false,"name":"Recoup","scryfallId":"46251a78-6f8e-4ad7-ac0e-f5d776f1755e"},{"index":2730,"token":false,"name":"Into Thin Air","scryfallId":"d0f31ff9-f403-4082-88f8-65807c0af812"},{"index":2731,"token":false,"name":"Maniacal Rage","scryfallId":"8c92200e-6f9a-4602-acbb-b04cb9bd294a"},{"index":2732,"token":false,"name":"Thought Scour","scryfallId":"88bf1ebb-9d85-4b9b-a614-c7f965c0893d"},{"index":2733,"token":false,"name":"Harald Unites the Elves","scryfallId":"bfe533c5-19c4-4d7a-8d8c-be7fa5b4e6bc"},{"index":2735,"token":false,"name":"Chromeshell Crab","scryfallId":"c91cf95f-5007-409c-b891-00e10a3477e0"},{"index":2736,"token":true,"name":"Gabriel Nassif Bio","scryfallId":"06a5f33a-9357-46c5-bc3b-aba91581287e"},{"index":2737,"token":false,"name":"Soul Separator","scryfallId":"eb9b1158-dfc4-4fe9-b970-338be8a99662"},{"index":2738,"token":false,"name":"Onward // Victory","scryfallId":"25a78829-a05b-46a1-a22c-bc3c3bd031b7"},{"index":2739,"token":false,"name":"Verdant Force","scryfallId":"d5a5533f-d24d-4cca-a47e-0676c6061a35"},{"index":2740,"token":false,"name":"Noyan Dar, Roil Shaper","scryfallId":"14e80ae2-f960-4ee0-a2eb-9eb7581159df"},{"index":2741,"token":false,"name":"Deadly Allure","scryfallId":"271bc29e-d33f-4c21-a3ee-b2c6b5c9015e"},{"index":2742,"token":false,"name":"Dismiss","scryfallId":"5a0f1e52-3926-47ae-b36f-6d6f1e3bf29d"},{"index":2743,"token":false,"name":"Phyrexian Scriptures","scryfallId":"7f3423d7-cb81-47bf-b9a6-a279ba6cedf4"},{"index":2744,"token":false,"name":"Golgari Charm","scryfallId":"d64cd06b-95aa-449b-8d03-5a166cb46f84"},{"index":2745,"token":false,"name":"Pyroblast","scryfallId":"f0ef36fc-1f9d-47e3-b71c-26f2cbb978ac"},{"index":2746,"token":false,"name":"Grapeshot Catapult","scryfallId":"9ae0fe07-85b6-4179-859b-fbae74faab5f"},{"index":2747,"token":false,"name":"Well of Knowledge","scryfallId":"5184b967-f474-4c9b-9a20-65ddb0d6e4f8"},{"index":2749,"token":false,"name":"Vampire Outcasts","scryfallId":"354eabab-39d2-457e-a0e7-5d6e26f0b17c"},{"index":2750,"token":false,"name":"Liliana's Contract","scryfallId":"eaa0a28f-213e-4cce-8b85-10c745008498"},{"index":2752,"token":false,"name":"Zombie Goliath","scryfallId":"8638edec-ddcd-4f50-9c2f-2e1668e3d175"},{"index":2753,"token":false,"name":"Rorix Bladewing","scryfallId":"0998e036-ff46-42e7-aca3-46ce9836b68a"},{"index":2754,"token":false,"name":"Alpine Moon","scryfallId":"0eaaa3ac-b5dc-417d-859b-eb81bebc05a0"},{"index":2755,"token":false,"name":"Tishana, Voice of Thunder","scryfallId":"19c5cfbe-3972-4d2e-a37f-e96cca33bb33"},{"index":2756,"token":false,"name":"Foul Spirit","scryfallId":"64b63e5f-b2cf-42c2-8111-1ebb9ed5ca33"},{"index":2757,"token":false,"name":"Incubation // Incongruity","scryfallId":"dd3a4d6e-34ae-4047-a9c7-11e28b0a276d"},{"index":2758,"token":false,"name":"Nikko-Onna","scryfallId":"bd7ecd0c-9cfb-4cf3-be62-d949b58b19a4"},{"index":2759,"token":false,"name":"Pithing Needle","scryfallId":"786c1e91-9d75-46a3-9e0d-56d29fcb01a7"},{"index":2760,"token":false,"name":"Evangel of Heliod","scryfallId":"bb914a85-3755-4663-8309-6f6d0319262e"},{"index":2762,"token":false,"name":"The Great Aurora","scryfallId":"b1d0eb3b-00b9-42ca-9f7d-5543bffc3480"},{"index":2763,"token":false,"name":"Fathom Mage","scryfallId":"4fa311f1-f11e-492d-9f18-e7489f950be7"},{"index":2764,"token":false,"name":"Inferno Titan","scryfallId":"f1e4a028-6462-4373-9864-a8adfc78d52b"},{"index":2766,"token":false,"name":"Genju of the Spires","scryfallId":"8d38859c-c5e5-4403-9328-5b5fb8450e4b"},{"index":2767,"token":false,"name":"Balancing Act","scryfallId":"7d6cb368-43f7-4d06-9cd5-492df5766567"},{"index":2768,"token":false,"name":"Deadly Rollick","scryfallId":"c61fa2c0-63c0-4dc2-9f17-5a00530e3348"},{"index":2769,"token":false,"name":"Frilled Mystic","scryfallId":"50595d02-edad-48a6-b10c-6fa859cc88bb"},{"index":2770,"token":true,"name":"Servo Token (Colorless, 1/1)","scryfallId":"d79e2bf1-d26d-4be3-a5ad-a43346ed445a"},{"index":2771,"token":true,"name":"Shark Token (U, */*)","scryfallId":"30d12226-6417-4b98-beb5-89a36c774141"},{"index":2772,"token":false,"name":"Expropriate","scryfallId":"9c8a2a5a-cb9b-4582-a453-085da78584f9"},{"index":2774,"token":false,"name":"Minotaur Tactician","scryfallId":"097decb6-03bd-4a84-ab9a-75becf85cae8"},{"index":2775,"token":false,"name":"Torpor Orb","scryfallId":"953610f6-ea96-4e71-969f-50ecac09c091"},{"index":2776,"token":false,"name":"Rosheen Meanderer","scryfallId":"472efa7f-203f-4c48-b9ad-505e18f2976f"},{"index":2777,"token":false,"name":"Chandra, Acolyte of Flame","scryfallId":"1b69993a-02ae-4eed-be6f-5682e2abb10e"},{"index":2781,"token":false,"name":"Perilous Predicament","scryfallId":"f0edc708-0c76-4fcd-a175-d9c6f1ca3ac1"},{"index":2782,"token":false,"name":"Cordial Vampire","scryfallId":"a90a1c44-ee0f-4c12-bfaf-6f371bcce167"},{"index":2784,"token":false,"name":"Hammer of Nazahn","scryfallId":"84da73cd-59f1-4e9c-9c60-d03c8b046a47"},{"index":2785,"token":false,"name":"First Sliver's Chosen","scryfallId":"7f5c4368-4f2e-4f5f-8944-8b0d49ab3e38"},{"index":2786,"token":false,"name":"Sylvan Ranger","scryfallId":"415a413c-ff4c-4d6d-8546-22fe4f86f564"},{"index":2788,"token":false,"name":"Cockatrice","scryfallId":"9cd91814-6177-4a3d-a1c1-a3be7d7c7957"},{"index":2790,"token":false,"name":"Vraska's Contempt","scryfallId":"bd7550dd-dfc5-43cd-a117-1244ee3086a8"},{"index":2793,"token":false,"name":"Windreaver","scryfallId":"91af5727-5348-4e2e-8a00-10f6983edce8"},{"index":2794,"token":false,"name":"Riders of Gavony","scryfallId":"bcc1647b-9271-4426-9938-7eb620ad0769"},{"index":2795,"token":false,"name":"Shielded by Faith","scryfallId":"88ae6d9a-c3f7-44b9-bf9b-ff1bce964f34"},{"index":2796,"token":false,"name":"Suppression Field","scryfallId":"0df7883b-f744-4410-a682-7391bd697afb"},{"index":2797,"token":false,"name":"Riding Red Hare","scryfallId":"c0504a24-4b92-471a-8da4-02ec57eb43be"},{"index":2798,"token":false,"name":"Doom Blade","scryfallId":"7e6c0fe2-a82b-42cb-8629-b9f00b7f08e9"},{"index":2799,"token":false,"name":"Ruthless Ripper","scryfallId":"bc78993c-ca67-43b3-a64d-ce0c3bc415bc"},{"index":2800,"token":false,"name":"Induce Paranoia","scryfallId":"bc462b75-8b08-47a3-be22-d7b5c062ec5b"},{"index":2802,"token":false,"name":"Bellowing Tanglewurm","scryfallId":"44eb3e3a-60ee-4293-a321-daa452d4c70d"},{"index":2803,"token":false,"name":"Granite Grip","scryfallId":"908c8414-5eff-4887-9007-43050058c2d0"},{"index":2804,"token":false,"name":"Unholy Strength","scryfallId":"caf00aa0-bcb9-4624-a224-bc79863cf4ed"},{"index":2805,"token":false,"name":"Abrupt Decay","scryfallId":"57010ba9-52be-484d-9976-7576c4ce48d0"},{"index":2806,"token":false,"name":"Icehide Troll","scryfallId":"02f3aaed-a01f-4c6a-b9bb-cd70b0f6ceb1"},{"index":2807,"token":false,"name":"Rise of Extus","scryfallId":"bbf97a71-485e-4d47-98de-bdf6f6dae0c2"},{"index":2808,"token":false,"name":"Silverglade Pathfinder","scryfallId":"9bc99b33-ce06-4a44-8b23-300b41b2b2fe"},{"index":2810,"token":false,"name":"Ironhoof Ox","scryfallId":"c8a2c5ce-ec87-46b9-b474-ecf133ccd092"},{"index":2811,"token":false,"name":"Mana Crypt","scryfallId":"9a61ac58-0bec-4056-be44-fc33db0e067b"},{"index":2812,"token":false,"name":"Marisi, Breaker of the Coil","scryfallId":"c366e1c0-f62d-41ce-baec-de11dbc1c5f4"},{"index":2813,"token":false,"name":"Rashmi, Eternities Crafter","scryfallId":"de743408-7d72-4f42-9dfe-040dc96269b6"},{"index":2814,"token":false,"name":"Dark Ritual","scryfallId":"b464bf34-d651-496c-9a92-bee839af1fa6"},{"index":2815,"token":false,"name":"Walk the Aeons","scryfallId":"9db567cf-3d26-4216-932b-53ca4cfeb5b7"},{"index":2816,"token":false,"name":"Mutiny","scryfallId":"010711a0-5e95-4a8c-816f-e314f2a909ef"},{"index":2817,"token":false,"name":"Bellowing Fiend","scryfallId":"2b0962d7-d797-4f07-bd73-9cd7a11ffad8"},{"index":2818,"token":true,"name":"Plant Token (G, 1/1)","scryfallId":"10a63c10-9bf9-4e0f-831c-830d7994a62a"},{"index":2819,"token":false,"name":"Protean Thaumaturge","scryfallId":"8206247e-43e6-4936-9ef5-42b174ff57c9"},{"index":2820,"token":false,"name":"Time of Ice","scryfallId":"dd6124aa-b1cd-4391-8c18-503b50f8452a"},{"index":2821,"token":false,"name":"Orim's Thunder","scryfallId":"dc77e7a2-87cf-46c9-b983-9917310cde64"},{"index":2822,"token":false,"name":"Infectious Bloodlust","scryfallId":"ee44df88-45a4-46ef-a8bd-f7fb7b9542b8"},{"index":2824,"token":false,"name":"Battle Mastery","scryfallId":"cf3cfe58-a300-4f78-a057-6f7810aff70e"},{"index":2825,"token":false,"name":"Virulent Plague","scryfallId":"2c9e351c-f494-4911-8817-d360a26ab758"},{"index":2826,"token":false,"name":"Nessian Boar","scryfallId":"a9ac0ddc-36f6-43e3-a210-ad71a17566f0"},{"index":2827,"token":false,"name":"Sinister Strength","scryfallId":"afe487b8-c1ae-483d-bcd5-62c62b66a22e"},{"index":2830,"token":false,"name":"Sandblast","scryfallId":"0f3c501c-4e23-4e56-ad99-1803c8a877ca"},{"index":2831,"token":false,"name":"Nimble Trapfinder","scryfallId":"ccdc085a-8d97-45fe-86bf-2f4783ebf65e"},{"index":2832,"token":false,"name":"Mesa Falcon","scryfallId":"a7ce1b8e-13ba-4eed-a445-435300f3101e"},{"index":2833,"token":false,"name":"Bant Panorama","scryfallId":"b22c6b34-0066-47f8-8062-9363c024fa56"},{"index":2836,"token":false,"name":"Manglehorn","scryfallId":"96c06ea2-d494-4eb0-b248-2a1125801bf7"},{"index":2838,"token":false,"name":"Web","scryfallId":"a9d17bcd-7f08-49d9-be5f-c7ae988fb972"},{"index":2839,"token":false,"name":"Glissa, the Traitor","scryfallId":"9e293b2d-5eae-43c3-bb1f-4c0ed2b0bd21"},{"index":2841,"token":false,"name":"Blaring Recruiter","scryfallId":"959bb0f1-0af3-4070-9303-684a07edfcfa"},{"index":2842,"token":false,"name":"Flameblast Dragon","scryfallId":"c01ab5c8-f9b7-482c-a900-1388b727b89f"},{"index":2843,"token":false,"name":"Izzet Signet","scryfallId":"ff0a314e-4705-4777-a44c-fdf7ec5171fd"},{"index":2844,"token":false,"name":"Scourge of Fleets","scryfallId":"a79471f9-5cc0-48f5-9fa4-1f1374993825"},{"index":2845,"token":false,"name":"Firemane Avenger","scryfallId":"05607d21-7613-4c28-b81f-995f36ab64f6"},{"index":2846,"token":false,"name":"Hidden Stockpile","scryfallId":"a9119c90-716b-4884-9b1e-471f262c2639"},{"index":2847,"token":false,"name":"Aether Rift","scryfallId":"692c186a-997c-4f7e-a339-bf84884e1019"},{"index":2849,"token":false,"name":"Rapid Decay","scryfallId":"97a247cf-7426-44b8-922d-18a5e9ef837b"},{"index":2850,"token":false,"name":"Battle Mammoth","scryfallId":"1b87cd73-9149-4e48-acff-dcfce4bd1b11"},{"index":2852,"token":false,"name":"Keldon Mantle","scryfallId":"35bb73df-f488-468c-a9ad-72f52c8da3dc"},{"index":2853,"token":false,"name":"Morkrut Banshee","scryfallId":"de6fd09e-55af-41dd-a0c0-ba1064737c90"},{"index":2855,"token":false,"name":"Aegis Turtle","scryfallId":"e433e7f0-7417-4dfe-a7a4-3f222b0a835f"},{"index":2856,"token":false,"name":"Toralf, God of Fury // Toralf's Hammer","scryfallId":"5af80f3b-229d-43f8-976e-50bee70b32e7"},{"index":2857,"token":false,"name":"Lightning Elemental","scryfallId":"9a557c16-2b58-45c4-9e97-cf6047a83d17"},{"index":2860,"token":false,"name":"Windgrace's Judgment","scryfallId":"d8b8f56c-091f-4932-9216-af58f7ea4bd7"},{"index":2861,"token":false,"name":"Dread Summons","scryfallId":"34ad664e-5fe7-49d9-aca8-779f3bc5bc23"},{"index":2862,"token":false,"name":"Sunscorched Desert","scryfallId":"38ba5598-ca5c-42da-83d7-b22243c8704e"},{"index":2863,"token":false,"name":"Angry Mob","scryfallId":"a26d1c4d-af95-4b40-83a5-b51f8b2506db"},{"index":2864,"token":false,"name":"Lantern Scout","scryfallId":"517996f1-0783-4be8-be5d-3a0765d07421"},{"index":2865,"token":false,"name":"Time Bomb","scryfallId":"092ec691-4729-46d3-a4e2-0cfc5df42a31"},{"index":2866,"token":false,"name":"Sky Ruin Drake","scryfallId":"2bdb5850-df1e-4d8a-af7a-15cab080fb8f"},{"index":2868,"token":false,"name":"Sword of Body and Mind","scryfallId":"3a96d85c-7b24-4e90-8425-7cdd985190e6"},{"index":2869,"token":false,"name":"Erratic Explosion","scryfallId":"f1d5d805-7fc5-4669-b094-b7d0dc0c97c7"},{"index":2872,"token":false,"name":"Starlight","scryfallId":"f6992524-6921-473b-8301-cb63fe502600"},{"index":2873,"token":false,"name":"Marsh Lurker","scryfallId":"90c4b759-f53d-4977-8d97-a93762622e75"},{"index":2874,"token":false,"name":"Cursebreak","scryfallId":"c71a0883-316c-4870-a029-25f16952fbc0"},{"index":2875,"token":false,"name":"Disturbing Plot","scryfallId":"b7796925-fe69-4019-82ab-7cb75760b045"},{"index":2876,"token":false,"name":"Fury Sliver","scryfallId":"eed1b11e-ca86-4b1b-b989-3a59e5772099"},{"index":2877,"token":false,"name":"Mercurial Chemister","scryfallId":"c7ebace0-4dbf-4dbc-9f5d-2d4d88d753cc"},{"index":2879,"token":false,"name":"Brindle Boar","scryfallId":"fc780658-fc10-481e-8319-d44a644e8fe8"},{"index":2880,"token":false,"name":"Planeswalker's Mirth","scryfallId":"0205d094-c846-4aa0-ade8-2a52c57b11da"},{"index":2881,"token":false,"name":"Bloodline Pretender","scryfallId":"eb8a16f6-55c1-40eb-998f-592bf31916b1"},{"index":2882,"token":false,"name":"Gremlin Infestation","scryfallId":"b51438f5-c4d4-434a-b7ea-dee0b60303e4"},{"index":2883,"token":false,"name":"Widespread Brutality","scryfallId":"ba6cc677-9e1c-4153-bb63-d9e812ceae74"},{"index":2884,"token":false,"name":"Coral Merfolk","scryfallId":"80ea1af2-f944-4ee1-88bd-2f3ea09bf9e6"},{"index":2885,"token":false,"name":"Ogre Errant","scryfallId":"0e96f3dc-dc58-4034-8d3d-3ae74fa64562"},{"index":2886,"token":false,"name":"Kukemssa Pirates","scryfallId":"d10b5ce7-16c9-48f3-a1da-8a91092d053a"},{"index":2888,"token":false,"name":"Blossoming Wreath","scryfallId":"2f944ad9-c9ce-47b2-80fa-d0f7fcf0fd5d"},{"index":2889,"token":false,"name":"Vryn Wingmare","scryfallId":"a34291dc-103f-493d-b217-bd1b0e946d8d"},{"index":2890,"token":false,"name":"Molten Rain","scryfallId":"f888b4d4-31f9-4322-8225-4d7e7a9f4dd5"},{"index":2891,"token":false,"name":"Despoiler of Souls","scryfallId":"f561ed8a-fa0b-405a-9a07-9ee2f8434d72"},{"index":2892,"token":false,"name":"Radiant Scrollwielder","scryfallId":"f74eea36-f7b6-4586-a16c-cd20ab89ab54"},{"index":2893,"token":false,"name":"Ghalta, Primal Hunger","scryfallId":"c11a7c2e-75e8-432e-84c4-df63e0df0981"},{"index":2894,"token":false,"name":"Volcanic Geyser","scryfallId":"2e89d367-b213-4f73-8f23-79788c00d7c1"},{"index":2895,"token":false,"name":"Marshal's Anthem","scryfallId":"f9d2ad27-d693-481c-a470-fe5859ad2380"},{"index":2897,"token":false,"name":"Gaea's Herald","scryfallId":"ab713e16-5103-4f37-b325-a30d3580b5dd"},{"index":2898,"token":false,"name":"Tezzeret the Seeker","scryfallId":"3b214b6f-4734-4200-8467-92d7e3469b5d"},{"index":2900,"token":false,"name":"Serpent Skin","scryfallId":"8c5722d9-d1a4-4ad2-bf85-db666d4a30d9"},{"index":2901,"token":false,"name":"Story Circle","scryfallId":"675378bb-7dc1-4bc8-b026-27e6e8e72e18"},{"index":2902,"token":false,"name":"Roving Keep","scryfallId":"9e64bc76-c6df-4b3c-b37f-f9386d30cab9"},{"index":2903,"token":false,"name":"Bloodthrone Vampire","scryfallId":"7c0b87e0-d5e4-44f2-8220-325443ee9f31"},{"index":2904,"token":false,"name":"Aerial Responder","scryfallId":"956adc86-c0d9-4408-837e-b5def19af1ec"},{"index":2905,"token":false,"name":"Fertile Ground","scryfallId":"789e3582-b541-4916-ac7e-015214d7a27a"},{"index":2906,"token":false,"name":"Mother of Runes","scryfallId":"a6a96d0b-5c8f-4563-92a0-a2c9e595100b"},{"index":2907,"token":false,"name":"Voice of Resurgence","scryfallId":"07246783-d475-4f61-99ac-e2b574072349"},{"index":2908,"token":false,"name":"Shadowstorm","scryfallId":"de128174-b174-42cf-b7cd-ddbaf8781500"},{"index":2909,"token":false,"name":"Goblin Bomb","scryfallId":"97e8a436-9fd0-409f-a020-0f9f41602d50"},{"index":2910,"token":false,"name":"Lorehold Excavation","scryfallId":"43105beb-46f3-4914-8222-4907bd76d48f"},{"index":2911,"token":false,"name":"Spiteful Returned","scryfallId":"017e8cfb-7cb0-403c-b8be-abee22369661"},{"index":2912,"token":false,"name":"Sleight of Mind","scryfallId":"d427790c-e322-446e-8d7d-a6b48ad41a42"},{"index":2913,"token":false,"name":"Spectral Shield","scryfallId":"7fe0a783-d086-4dc8-ae4a-59f3c2daaca0"},{"index":2916,"token":false,"name":"Maelstrom Pulse","scryfallId":"e2d85423-ebd8-4a6e-aedf-90e52f918764"},{"index":2917,"token":true,"name":"Morph Token (Colorless, 2/2)","scryfallId":"e9375cbe-93c0-41a5-a6e3-fb4416f54a69"},{"index":2918,"token":false,"name":"Balustrade Spy","scryfallId":"9dd991a9-4a8f-4679-83ea-046c37d1b118"},{"index":2919,"token":false,"name":"Narset, Enlightened Master","scryfallId":"0eb00508-afc5-4c54-aa93-bce93583a8be"},{"index":2921,"token":false,"name":"Shape Stealer","scryfallId":"da2a4871-8bc3-4db0-9f9e-b2e96b90ebd5"},{"index":2922,"token":false,"name":"Talent of the Telepath","scryfallId":"ed076b23-c5e1-4933-8d53-fb2e87c38583"},{"index":2923,"token":false,"name":"Conquer","scryfallId":"ae610e66-7bcb-40ec-bed5-86dcfd098654"},{"index":2924,"token":false,"name":"Filthy Cur","scryfallId":"634b2b46-b213-4eb0-81d8-0e9dd161b85f"},{"index":2925,"token":false,"name":"Forgotten Cave","scryfallId":"62b0b5f8-6b51-4fa5-85ae-290475525a9d"},{"index":2926,"token":false,"name":"Staunch Throneguard","scryfallId":"41017b24-957b-403d-b417-d84ad2624794"},{"index":2927,"token":false,"name":"Axgard Armory","scryfallId":"f9c77d35-8418-48fb-b7d7-7cfa763545c5"},{"index":2928,"token":false,"name":"Multani, Yavimaya's Avatar","scryfallId":"88733b6d-6d45-4318-ae49-623929231d17"},{"index":2930,"token":false,"name":"Supreme Inquisitor","scryfallId":"867de3d2-2178-4931-823e-ff439e1a45ea"},{"index":2932,"token":false,"name":"Savage Lands","scryfallId":"a4ac4cb1-6267-4404-8c9b-fd6b072f9c89"},{"index":2933,"token":false,"name":"Necromancer's Familiar","scryfallId":"e4dfb84f-582a-4fe2-9710-8b480a268571"},{"index":2934,"token":false,"name":"Price of Betrayal","scryfallId":"fd68e918-5089-46c9-8836-b05a3da3c7a3"},{"index":2935,"token":false,"name":"Wound Reflection","scryfallId":"b8cf8332-0ff2-40c5-980a-6f6be690fad0"},{"index":2936,"token":false,"name":"Savage Silhouette","scryfallId":"8b8547e0-2928-4edc-a15a-a613cb4d1eac"},{"index":2937,"token":false,"name":"Sleeper Dart","scryfallId":"311f827a-1585-483e-b0fd-3dc05969b485"},{"index":2938,"token":false,"name":"Underground River","scryfallId":"8c298bf7-2514-43d4-a285-1386d6ba0835"},{"index":2939,"token":false,"name":"Ogre Slumlord","scryfallId":"9342052f-6b6b-40b9-bbc9-7ba3e8365fe1"},{"index":2940,"token":false,"name":"Surging Sentinels","scryfallId":"264d120a-d7e2-4b9e-ac85-c66e976c577b"},{"index":2941,"token":false,"name":"Mascot Exhibition","scryfallId":"2047592c-739c-41dd-b3e8-31ae1c7688ab"},{"index":2942,"token":false,"name":"Game Plan","scryfallId":"bc068891-c251-4eee-b5ca-342d9df33bdc"},{"index":2943,"token":false,"name":"In Search of Greatness","scryfallId":"0f75c3ad-839a-4658-9706-5d9df7ce6dff"},{"index":2944,"token":false,"name":"Diluvian Primordial","scryfallId":"eb580daa-0cf3-4816-b8c5-49927682a91d"},{"index":2945,"token":false,"name":"Butcher of the Horde","scryfallId":"1a920210-42e1-4d27-a9ea-5d91674eb8fd"},{"index":2946,"token":false,"name":"Basri Ket","scryfallId":"5288bdcf-c374-457a-901e-ea829dae4c89"},{"index":2947,"token":false,"name":"Three Visits","scryfallId":"9e796981-6344-45d4-af28-47da6a8b29f0"},{"index":2948,"token":false,"name":"Spined Wurm","scryfallId":"113fad70-36bc-4ab7-962a-cda3bddd02fc"},{"index":2952,"token":false,"name":"Mortipede","scryfallId":"94a8ae6e-51b1-4985-9d09-f9c3818df911"},{"index":2953,"token":false,"name":"Pulse of the Dross","scryfallId":"bb8b1d0a-2c78-4173-b7ed-d7f3a0502fe7"},{"index":2954,"token":false,"name":"Ancient Hydra","scryfallId":"5de57c84-38b9-4606-b934-0ab270496582"},{"index":2955,"token":false,"name":"Mana Geode","scryfallId":"17315a12-a7f8-45ba-ac3b-a62c789e75d0"},{"index":2956,"token":true,"name":"Poison Counter","scryfallId":"92fcdd2b-dd90-458d-9b8b-5b1b9a3f8bd3"},{"index":2957,"token":false,"name":"Kyren Archive","scryfallId":"5e65a06a-e7af-422a-9481-446731009935"},{"index":2958,"token":false,"name":"Bedevil","scryfallId":"81e2b96b-ecf2-4dd9-bc9d-3c46ee8c59e6"},{"index":2961,"token":false,"name":"Pirate Ship","scryfallId":"d6119988-4797-4993-a75f-e7015c2c6354"},{"index":2962,"token":false,"name":"Oblivion Strike","scryfallId":"24e30acf-b30f-4bb3-b80e-dc7e9559da51"},{"index":2964,"token":false,"name":"Gemstone Mine","scryfallId":"7c973731-6579-44ee-ab27-265bc312e7fc"},{"index":2965,"token":false,"name":"Courier's Capsule","scryfallId":"39ae12ff-8039-4aac-aa50-f879376888a1"},{"index":2966,"token":false,"name":"Arashi, the Sky Asunder","scryfallId":"95bfae4a-01fe-4309-9291-b3123395f057"},{"index":2968,"token":false,"name":"Arcane Sanctum","scryfallId":"f9d52791-886f-4288-82f9-ba8ff62e323c"},{"index":2969,"token":false,"name":"Immaculate Magistrate","scryfallId":"9cf2d9af-6028-48e2-83f0-69d3964943c3"},{"index":2970,"token":false,"name":"Crumble","scryfallId":"3cfb6d26-a7f8-49b1-9e72-053a0d2ee06f"},{"index":2971,"token":false,"name":"Talas Researcher","scryfallId":"1c51008b-7031-4dbc-b4d6-7433c05bf6dc"},{"index":2972,"token":false,"name":"City of Shadows","scryfallId":"76e5ee8a-34e5-4a2e-a04e-9fcdc7e53dda"},{"index":2973,"token":false,"name":"Copy Artifact","scryfallId":"2b3299b8-4c76-4550-ad2a-227b2bff63e9"},{"index":2974,"token":true,"name":"Faerie Rogue Token (B, 1/1)","scryfallId":"7df94cc3-fed3-493d-9aa5-c85d6a2aeb05"},{"index":2976,"token":false,"name":"Thoughtbound Phantasm","scryfallId":"36478e73-162a-412c-bf5b-9ca0d92f51e2"},{"index":2978,"token":false,"name":"Chain Lightning","scryfallId":"9ca05db2-ad92-4f4a-992d-b7f08f4f9c26"},{"index":2979,"token":false,"name":"Syr Konrad, the Grim","scryfallId":"a808868f-aea8-4651-9357-85a4d7b4f290"},{"index":2980,"token":false,"name":"Spreading Plague","scryfallId":"ac86055d-ce08-4b05-a92c-45e007ca0ba4"},{"index":2982,"token":false,"name":"Enlarge","scryfallId":"b46cd181-59d8-4d4c-a8b6-e6b38704009c"},{"index":2983,"token":false,"name":"Lifetap","scryfallId":"5ca2ebe7-3e53-4cd0-8d75-2b6395612756"},{"index":2984,"token":false,"name":"Spellweaver Helix","scryfallId":"a48d44b4-1c3b-4109-aaad-8351bf8a7624"},{"index":2986,"token":false,"name":"Charming Prince","scryfallId":"7e9d9a8a-ea85-4d2e-8580-38125aebc736"},{"index":2989,"token":false,"name":"Reins of Power","scryfallId":"23f51759-2601-4965-bff0-894e4d4243ea"},{"index":2990,"token":false,"name":"Palace Jailer","scryfallId":"ed869151-02e9-4daa-994d-ccdf9f9dc3c8"},{"index":2991,"token":false,"name":"Essence Scatter","scryfallId":"e1e325e1-f1f9-4448-84e3-1fd929b0bc12"},{"index":2992,"token":false,"name":"Alley Grifters","scryfallId":"cfb648e3-f5ad-4b33-afa3-d4cda0d369a1"},{"index":2993,"token":false,"name":"Thornweald Archer","scryfallId":"182c14ac-82dd-4588-858a-b720247df410"},{"index":2994,"token":false,"name":"Vendilion Clique","scryfallId":"74ebe58d-0f94-47f7-b17b-0d9492b931d5"},{"index":2995,"token":false,"name":"Selvala's Charge","scryfallId":"426b63f9-5788-45d2-b934-1579320bc775"},{"index":2996,"token":false,"name":"Gigapede","scryfallId":"0a96a608-9237-41c1-824c-89d5fad939ad"},{"index":2997,"token":false,"name":"Sweltering Suns","scryfallId":"25a816bb-cc21-46e2-961d-8a520edd578f"},{"index":2998,"token":false,"name":"Earth-Origin Yak","scryfallId":"2b955515-f1c9-4ced-adfa-ed8c0390b5fe"},{"index":3000,"token":false,"name":"Mulldrifter","scryfallId":"6a9f464a-6a5f-46ad-a0f7-478107a1bd40"},{"index":3001,"token":false,"name":"Shadowspear","scryfallId":"7172110e-05b3-4f2e-9528-e5ec683fa3a1"},{"index":3002,"token":false,"name":"Mindstab Thrull","scryfallId":"499a791f-ac4f-4a96-b59b-37043686a79a"},{"index":3003,"token":false,"name":"Nomad Outpost","scryfallId":"5728dffd-0312-4844-8868-12f040b8326f"},{"index":3004,"token":false,"name":"Power Artifact","scryfallId":"c7b0c6c4-ec99-4af1-9527-41c428af7260"},{"index":3005,"token":false,"name":"Prized Elephant","scryfallId":"01597ede-94e7-44a4-93c2-7fd1db11e92a"},{"index":3006,"token":false,"name":"Vial of Dragonfire","scryfallId":"e50e88fe-307a-4944-9233-14df4e0bb775"},{"index":3007,"token":false,"name":"Untamed Wilds","scryfallId":"8c7e6705-b564-4d12-8aeb-6afcd26972f5"},{"index":3010,"token":false,"name":"Tail Slash","scryfallId":"91a59f12-8d1b-4378-abb8-e266d9b6cdba"},{"index":3015,"token":false,"name":"Auriok Champion","scryfallId":"b9e6bf0b-bb39-4d0f-9035-a276e604f609"},{"index":3016,"token":false,"name":"Inventors' Fair","scryfallId":"a4ba795a-8a08-4853-a7ca-cf3883a6f667"},{"index":3017,"token":false,"name":"Castle","scryfallId":"a8ba6b09-b24f-40cb-b219-ad8a1fd6692c"},{"index":3018,"token":false,"name":"Voidmage Prodigy","scryfallId":"4bdc1632-6824-4059-a6bd-bce9cd4a02f4"},{"index":3019,"token":false,"name":"Tidal Warrior","scryfallId":"991c6965-6e22-4a77-87b4-91c150ca62be"},{"index":3020,"token":false,"name":"Sylvan Reclamation","scryfallId":"db5f62fc-9106-435d-a076-61d59d44ade2"},{"index":3021,"token":false,"name":"Shattering Spree","scryfallId":"7a8de367-4a95-42ef-ba06-b256d3af9829"},{"index":3022,"token":false,"name":"Lone Missionary","scryfallId":"fdc00f4b-ca9a-468a-91e1-c81fe6585765"},{"index":3025,"token":false,"name":"Past in Flames","scryfallId":"e655061a-8071-4b7b-b993-27f9ea360f7c"},{"index":3027,"token":false,"name":"Benalish Knight","scryfallId":"bccebfdd-85cb-4549-93a4-c0dcd667ee04"},{"index":3028,"token":false,"name":"Markov Dreadknight","scryfallId":"7ff00ccd-481e-4bca-8860-6661c1882b1d"},{"index":3029,"token":false,"name":"Vedalken Mastermind","scryfallId":"ea34a540-486b-42dc-993c-93698988d024"},{"index":3030,"token":false,"name":"Promise of Power","scryfallId":"8be2edf8-4461-404e-902a-d5d398670221"},{"index":3031,"token":false,"name":"Talon Sliver","scryfallId":"f186c4b1-b7ec-46eb-a961-257411b401b0"},{"index":3032,"token":false,"name":"Waterspout Elemental","scryfallId":"425156e6-8eee-4bff-8f2f-86edd9a4f73b"},{"index":3033,"token":false,"name":"Tolarian Scholar","scryfallId":"00d89839-60d7-4de2-a78a-1afdcc21c053"},{"index":3034,"token":false,"name":"Kazandu Nectarpot","scryfallId":"7c9d3f4a-ef83-454e-b8a1-1fc5d5f44be8"},{"index":3036,"token":false,"name":"Scavenged Weaponry","scryfallId":"4e8072a9-2699-4c6c-9556-67d91bd67a4b"},{"index":3037,"token":false,"name":"Elkin Bottle","scryfallId":"cf5b60a9-3041-4524-9a53-ab3a597c20ac"},{"index":3039,"token":false,"name":"Volcanic Vision","scryfallId":"37aacf2b-b08f-4804-88ff-7b61620801e9"},{"index":3040,"token":false,"name":"Land Tax","scryfallId":"95bba319-5f66-4085-9f2a-ab71f727ab64"},{"index":3043,"token":false,"name":"Metalworker","scryfallId":"10f6e07b-36c1-429b-a857-ada8c643556c"},{"index":3044,"token":false,"name":"Immolating Gyre","scryfallId":"bd0b8aee-fbfb-470f-9ac2-64fce0b4b2fb"},{"index":3045,"token":false,"name":"Hazduhr the Abbot","scryfallId":"adfd416a-dddf-40e4-acf0-84057edb7a58"},{"index":3046,"token":false,"name":"Prophetic Prism","scryfallId":"cfb90d44-8cb1-4b83-b2f2-92c19d6304fb"},{"index":3047,"token":false,"name":"Battlegrace Angel","scryfallId":"b9be1142-3ba8-4915-9541-757e59ed046c"},{"index":3048,"token":false,"name":"Composite Golem","scryfallId":"3eba4407-0405-41fa-99e5-1bfa3a787398"},{"index":3049,"token":false,"name":"Sunken Hope","scryfallId":"f136c6af-fda0-4c4a-a67b-f431e4e51385"},{"index":3050,"token":false,"name":"Ulamog's Nullifier","scryfallId":"acd482ad-ca4a-470f-8a76-14ec7b58316a"},{"index":3051,"token":false,"name":"Coral Trickster","scryfallId":"9c5794e4-fc05-4e34-9cac-4c4bc074692d"},{"index":3053,"token":false,"name":"Telepathic Spies","scryfallId":"1aeb39c9-7853-4032-882a-83d4863dcbc5"},{"index":3054,"token":false,"name":"Siren Lookout","scryfallId":"0000cd57-91fe-411f-b798-646e965eec37"},{"index":3056,"token":false,"name":"Vodalian Illusionist","scryfallId":"9ce0e28b-9fd6-4763-8d6b-952b530358ab"},{"index":3058,"token":true,"name":"Elephant Token (G, 3/3)","scryfallId":"2853ba8b-650e-49e3-ab12-86b76e02743b"},{"index":3059,"token":false,"name":"Pygmy Troll","scryfallId":"7be9714d-125f-4700-879d-b920fe9f1b68"},{"index":3060,"token":false,"name":"Mantle of the Wolf","scryfallId":"83a786fa-4b86-40f7-ac58-1a05fb38fcdb"},{"index":3061,"token":false,"name":"Beetleback Chief","scryfallId":"16b8a76e-5ad9-42b6-ba03-819b2491c0c2"},{"index":3062,"token":false,"name":"Desert Drake","scryfallId":"24673b35-aed2-40c0-a4ae-93bc4d392562"},{"index":3064,"token":false,"name":"Reave Soul","scryfallId":"ce7ff657-aa44-4336-895a-87518159cef6"},{"index":3065,"token":false,"name":"Daring Saboteur","scryfallId":"34f0cf08-0409-492c-84c2-ceb4b86b8d68"},{"index":3066,"token":false,"name":"Kiora's Dambreaker","scryfallId":"acd61fb0-a82b-4f46-8043-c6b89764720b"},{"index":3069,"token":false,"name":"Wall of Kelp","scryfallId":"8c13f0b9-191b-4509-9dd8-a9aa494511ad"},{"index":3070,"token":false,"name":"Mogg Assassin","scryfallId":"1124725d-e643-43a1-873e-255636c7f334"},{"index":3071,"token":false,"name":"Unconventional Tactics","scryfallId":"52db5673-ecd3-4e58-8dc9-b42c76f80186"},{"index":3072,"token":false,"name":"Cephalid Coliseum","scryfallId":"8a5f2bbc-fe5f-40e9-9610-6297607822a0"},{"index":3073,"token":false,"name":"Rumbling Baloth","scryfallId":"a366fd5c-f6cd-4773-a25d-6114e11238cc"},{"index":3074,"token":false,"name":"Remand","scryfallId":"69001c08-2541-47e3-8343-2e5089a9b193"},{"index":3075,"token":false,"name":"Disciple of the Vault","scryfallId":"260b176c-a346-46aa-b498-919f65f07d35"},{"index":3076,"token":false,"name":"Foul Imp","scryfallId":"2fe63448-1198-4a7c-948b-514fe4934add"},{"index":3078,"token":true,"name":"Elemental Token (B/R, 5/5)","scryfallId":"0c5afb0a-a158-4995-881e-eae0f20805a6"},{"index":3079,"token":false,"name":"Saffi Eriksdotter","scryfallId":"c34bb91e-138b-4491-bb2d-5df2cd272bf0"},{"index":3080,"token":false,"name":"Emerge Unscathed","scryfallId":"d016f166-183e-4d9e-9292-9bfb1ca0d72b"},{"index":3081,"token":false,"name":"Welding Sparks","scryfallId":"35a77ab2-9fb9-4c21-bdd3-0761391b0a26"},{"index":3083,"token":false,"name":"Artisan of Kozilek","scryfallId":"f3eafe93-4245-482d-bb68-446ff96cbcb0"},{"index":3084,"token":false,"name":"Ingenious Mastery","scryfallId":"0cdd792a-9049-4f67-aed4-96e56e455c06"},{"index":3086,"token":false,"name":"Turn // Burn","scryfallId":"8d7fdd59-6d76-4a0c-ac75-816345ef4a39"},{"index":3087,"token":false,"name":"Spidersilk Net","scryfallId":"1f75f13e-43e6-4118-83a3-0446c2089d84"},{"index":3088,"token":false,"name":"Affa Protector","scryfallId":"9f770d50-420c-4e88-953a-d6e9c719869a"},{"index":3089,"token":false,"name":"Rugged Highlands","scryfallId":"825f18f4-a35d-4d92-a9f8-c4c5484891b0"},{"index":3090,"token":false,"name":"Aether Chaser","scryfallId":"4139592c-6f0c-44ac-9de0-ebd639cd893d"},{"index":3091,"token":false,"name":"Sanguine Indulgence","scryfallId":"abfcd08a-cfb5-4d34-b950-f57a88c5cb8e"},{"index":3093,"token":false,"name":"Bituminous Blast","scryfallId":"5d3c5532-20a4-48aa-bf08-73ab0579e5d4"},{"index":3096,"token":false,"name":"Paralyzing Grasp","scryfallId":"4af35801-9280-4ec1-9399-e34501919a8f"},{"index":3097,"token":false,"name":"Scaled Wurm","scryfallId":"07ad1b3a-3464-4080-819b-a62bf6c23a13"},{"index":3098,"token":false,"name":"Arcane Signet","scryfallId":"89ed88b1-c2b8-4c6e-87a6-168035b2f8c8"},{"index":3099,"token":false,"name":"Thrash of Raptors","scryfallId":"2a03b859-811c-45ff-8d8a-9e87e4bbf113"},{"index":3101,"token":false,"name":"Hashep Oasis","scryfallId":"3b15cca6-66ed-451c-88a5-46140bbce7e1"},{"index":3102,"token":false,"name":"Coalition Flag","scryfallId":"0e417461-a230-4548-bcc1-71377487f21b"},{"index":3103,"token":false,"name":"Prismite","scryfallId":"eedce8ab-771a-4247-9504-72ae0629df83"},{"index":3105,"token":false,"name":"Cower in Fear","scryfallId":"08e3cc81-2c08-4281-aa16-4c22f141f31d"},{"index":3106,"token":false,"name":"Clockwork Avian","scryfallId":"8013397b-55c4-4439-a320-9c9feb6864c2"},{"index":3107,"token":false,"name":"Soldevi Machinist","scryfallId":"1f0999df-2f94-499e-b9af-fe377d515400"},{"index":3109,"token":false,"name":"Mobilization","scryfallId":"fc25a245-4d47-45fe-82ae-4e0ecd4ed34e"},{"index":3113,"token":false,"name":"Minotaur Skullcleaver","scryfallId":"b6fef9f8-ff3e-4a3f-a3ff-4534ff0c3946"},{"index":3114,"token":false,"name":"Kor Skyfisher","scryfallId":"df51af32-403e-43bf-a2a3-92496c1c51ab"},{"index":3115,"token":false,"name":"Skymarch Bloodletter","scryfallId":"2c7f2740-a193-4b4c-af00-2dd22d74a4ba"},{"index":3116,"token":false,"name":"Niko Aris","scryfallId":"fc8353d8-bb68-4483-85b0-5ac61788c923"},{"index":3117,"token":false,"name":"Ogre Recluse","scryfallId":"aa425203-71fc-4d19-8014-871d16b11bfd"},{"index":3118,"token":false,"name":"Ascending Aven","scryfallId":"bd8b17df-615c-4cc1-af1a-2fc35a985af9"},{"index":3119,"token":false,"name":"Molder Slug","scryfallId":"44c76340-bcd4-42e9-8a2d-11766f8927c7"},{"index":3120,"token":false,"name":"Chief Engineer","scryfallId":"60055d82-4765-4989-b1b8-d2a2f4955d37"},{"index":3121,"token":false,"name":"Fated Intervention","scryfallId":"2c6f5752-cfb5-4c47-a7b2-17d3b900c7ec"},{"index":3122,"token":false,"name":"Sulfurous Mire","scryfallId":"35ebe245-ebb5-493c-b9c1-56fbfda9bd66"},{"index":3123,"token":false,"name":"Scrying Sheets","scryfallId":"19e95422-c6fe-4750-916b-43bf22ae193a"},{"index":3124,"token":false,"name":"Giant Cockroach","scryfallId":"68b79ee0-0a1b-474c-b68c-6e4ec69c018c"},{"index":3125,"token":false,"name":"Mijae Djinn","scryfallId":"31d12142-59aa-4afb-8883-58ba67cf3564"},{"index":3126,"token":false,"name":"Relentless Hunter","scryfallId":"91a52252-46b6-42e5-8cb5-c4f823cd0bf5"},{"index":3127,"token":false,"name":"Zombify","scryfallId":"4ed70fa9-b0ff-4874-ab81-75cd2f39cad3"},{"index":3128,"token":false,"name":"Adder-Staff Boggart","scryfallId":"d116839f-6a3a-4a2e-a3ab-ea177c012746"},{"index":3130,"token":false,"name":"Pernicious Deed","scryfallId":"7ccb3e75-dc82-4dab-be96-38da1c3f20e6"},{"index":3131,"token":false,"name":"Monastery Mentor","scryfallId":"abcd0e32-2e6b-419b-9e8a-af38f2b48a66"},{"index":3132,"token":false,"name":"Lose Hope","scryfallId":"438d7bf6-00f4-4c7e-b1a4-f7fd690d4788"},{"index":3133,"token":false,"name":"Hussar Patrol","scryfallId":"faaf07b2-57b0-4437-a8d7-51ff8894a7db"},{"index":3134,"token":false,"name":"Pyrite Spellbomb","scryfallId":"b76903b2-f8d2-4157-ad93-361eccc1a617"},{"index":3135,"token":false,"name":"Urza's Filter","scryfallId":"680c75b1-e766-40be-84d7-2332047bb3de"},{"index":3136,"token":false,"name":"Loyal Sentry","scryfallId":"7736c041-d333-4748-8045-79d42aba6e05"},{"index":3137,"token":false,"name":"Cephalid Illusionist","scryfallId":"dceb8cf5-b31a-400e-aea5-ad0c3552d697"},{"index":3138,"token":false,"name":"Twisted Abomination","scryfallId":"307cdd12-6fe0-4ee4-a7bf-d40cf4af2917"},{"index":3139,"token":false,"name":"Looming Shade","scryfallId":"3e94ab55-4390-4b3d-8e7f-a95996e2c5b7"},{"index":3140,"token":false,"name":"Jeskai Charm","scryfallId":"ca268705-ef04-4bf1-8a5d-866bb3e5bb61"},{"index":3142,"token":false,"name":"Vow of Flight","scryfallId":"cf97f184-a36a-435c-b683-56810032cf82"},{"index":3144,"token":false,"name":"Leonin Shikari","scryfallId":"cf9007a1-9a9a-474e-8b01-279988163d9c"},{"index":3145,"token":false,"name":"Sigil of the Empty Throne","scryfallId":"fce23fc9-3135-4537-a4b7-58f1334323b3"},{"index":3147,"token":false,"name":"Leave // Chance","scryfallId":"f928e8e8-aa20-402c-85bd-59106e9b9cc7"},{"index":3148,"token":false,"name":"Mortiphobia","scryfallId":"c7b93caa-0f43-43ac-84e9-99f6bcbf9e81"},{"index":3149,"token":false,"name":"Recumbent Bliss","scryfallId":"53c28634-337d-458a-bcf0-b7fbf65a41da"},{"index":3150,"token":false,"name":"Deekah, Fractal Theorist","scryfallId":"f0ae3869-8429-4fd3-902f-e36362d4feb9"},{"index":3151,"token":false,"name":"Jubilant Mascot","scryfallId":"88dde223-c697-40a7-a68e-ad9fcb8a3064"},{"index":3152,"token":false,"name":"Tattermunge Maniac","scryfallId":"88f80d05-0bc9-4f35-afc4-8e2ae81b94df"},{"index":3153,"token":false,"name":"Looter il-Kor","scryfallId":"368ee06f-9021-4b65-9f53-9c326bf3a27f"},{"index":3154,"token":false,"name":"Nettling Imp","scryfallId":"2c747289-a878-4ab6-8359-dfb87b44a1ab"},{"index":3155,"token":false,"name":"Karplusan Giant","scryfallId":"c524ac2a-294c-4b19-b00b-999e370a3b95"},{"index":3156,"token":false,"name":"Mage-Ring Responder","scryfallId":"7c60473d-5065-4e63-bfc2-a041a8ca48ed"},{"index":3157,"token":false,"name":"Elvish Aberration","scryfallId":"137d326f-83e1-449a-b934-71c7986c64e7"},{"index":3159,"token":false,"name":"Thornwood Falls","scryfallId":"e918f01a-3c24-440c-9e5b-c8cf47d81a82"},{"index":3160,"token":false,"name":"Downsize","scryfallId":"e8408a52-d34a-4e03-9312-700dec75d844"},{"index":3162,"token":false,"name":"Nighthawk Scavenger","scryfallId":"8ce97b6d-9988-4be5-a674-727424a09e70"},{"index":3163,"token":false,"name":"Brudiclad, Telchor Engineer","scryfallId":"25eff27a-eb58-4a95-b2df-4a341cf9bef6"},{"index":3164,"token":false,"name":"Exalted Angel","scryfallId":"90f5e185-f9c8-4538-b640-061d0e57053c"},{"index":3167,"token":false,"name":"Rile","scryfallId":"80925750-6c90-42d1-9525-27f1f0313398"},{"index":3168,"token":false,"name":"Nezahal, Primal Tide","scryfallId":"a959b40d-dd8c-49d8-8003-744d0c877b04"},{"index":3170,"token":false,"name":"Spirit Link","scryfallId":"0fc4de07-4a46-41d6-81b8-4d6299b88ee7"},{"index":3172,"token":false,"name":"Skarrg Guildmage","scryfallId":"00f206c0-a8a7-4ca0-b88f-4736c3dac588"},{"index":3173,"token":false,"name":"Fire Tempest","scryfallId":"ae311e17-ca96-4458-897f-30419a95a264"},{"index":3174,"token":false,"name":"Swarm of Bloodflies","scryfallId":"c29ee93e-ca9d-4a36-9efe-806be1d537d9"},{"index":3175,"token":false,"name":"Vault Skirge","scryfallId":"e46bb000-d420-48d3-850b-e5c9bb7a3ffa"},{"index":3176,"token":false,"name":"Niambi, Esteemed Speaker","scryfallId":"c60ec4f0-c304-4a98-9d67-28f881d1ad2b"},{"index":3177,"token":false,"name":"Ancestral Vengeance","scryfallId":"e0d0094e-07ff-4b47-8c6e-500adabf12e4"},{"index":3178,"token":false,"name":"Savage Surge","scryfallId":"0fa74aae-e857-410c-8836-953c8623d0b0"},{"index":3179,"token":false,"name":"Memnarch","scryfallId":"9f48defb-888b-4040-9dd2-16a0643c5c30"},{"index":3182,"token":false,"name":"Veteran Explorer","scryfallId":"31e93641-3370-46e4-8940-af09b33024cb"},{"index":3184,"token":false,"name":"Avarice Amulet","scryfallId":"ec56727f-6280-4625-96b9-9b599af0dada"},{"index":3185,"token":false,"name":"Narnam Renegade","scryfallId":"041cc6b1-61c8-4c34-86fc-d647ce306f59"},{"index":3186,"token":false,"name":"Soul-Scar Mage","scryfallId":"a8003786-6e2a-4e2d-a915-f23293c7273a"},{"index":3187,"token":false,"name":"Dreams of the Dead","scryfallId":"93372854-57e7-4db7-a1a6-376c9f49a514"},{"index":3189,"token":false,"name":"Quest for Ula's Temple","scryfallId":"77983bbf-6761-4126-82b4-bdcdd6b8e1dc"},{"index":3191,"token":false,"name":"Maro","scryfallId":"b4c3853c-8b41-4bce-b4e0-3824fc5888c4"},{"index":3192,"token":false,"name":"Radiant, Serra Archangel","scryfallId":"dc74d047-9fcc-476f-bd4a-a74e52785ebb"},{"index":3193,"token":false,"name":"Illumination","scryfallId":"eb28f6e5-c9ef-416e-b315-967d857e7600"},{"index":3194,"token":false,"name":"Ooze Garden","scryfallId":"623e57ed-7ed7-4283-b48f-77ecacad70b0"},{"index":3195,"token":true,"name":"Wolfgang Eder Decklist","scryfallId":"35417b4b-db3d-425c-909e-6803d27307e5"},{"index":3196,"token":false,"name":"Stronghold Machinist","scryfallId":"d3567b4e-6e31-40b0-83ea-4a2a58bd637c"},{"index":3197,"token":false,"name":"Gurmag Angler","scryfallId":"9c777933-edc2-4275-823c-3de3c4f42707"},{"index":3198,"token":false,"name":"Gleeful Sabotage","scryfallId":"d1b7d043-5f52-4df6-8dcf-5174a5b0c9cc"},{"index":3199,"token":false,"name":"Avatar of Discord","scryfallId":"48ccc561-5726-45df-b27a-e101ea9c0bac"},{"index":3200,"token":false,"name":"Rainbow Efreet","scryfallId":"1d6f03a6-3665-40e4-ae68-640913972770"},{"index":3202,"token":false,"name":"Lady Orca","scryfallId":"db766e38-5407-431c-bcf4-f33791a7e5f9"},{"index":3203,"token":false,"name":"Owlin Shieldmage","scryfallId":"d3350367-42bd-44af-be13-ad31c002f8ac"},{"index":3205,"token":false,"name":"Nightshade Stinger","scryfallId":"c894372f-7d28-4035-b45a-384c5bf8fd1f"},{"index":3206,"token":false,"name":"Soul Manipulation","scryfallId":"8c052464-0e9c-4ac6-af50-ef81711972c8"},{"index":3207,"token":false,"name":"Temple of Abandon","scryfallId":"37ec420c-bae6-40d6-b0d8-30742c14753b"},{"index":3208,"token":false,"name":"Mournful Zombie","scryfallId":"9ba12fb1-de8c-46c6-b33f-e0580ed2a3ee"},{"index":3210,"token":false,"name":"Blood-Chin Fanatic","scryfallId":"a52ce799-90b1-42f2-b3f3-310c848ce28e"},{"index":3211,"token":false,"name":"Copperhorn Scout","scryfallId":"4ee7f99e-7324-4d16-b163-8f1b2edb7b89"},{"index":3212,"token":false,"name":"Mind Unbound","scryfallId":"fd90cf36-9841-4adf-b5cb-0a7bf103eb93"},{"index":3213,"token":false,"name":"Jeleva, Nephalia's Scourge","scryfallId":"230fe340-b422-45a6-9d1c-8beb28026212"},{"index":3214,"token":false,"name":"Aliban's Tower","scryfallId":"7f711ea8-a73a-42da-8bf7-101ba588f203"},{"index":3215,"token":false,"name":"The Triumph of Anax","scryfallId":"49b5b348-1415-4062-a2a7-017694424c05"},{"index":3218,"token":false,"name":"Shimmering Wings","scryfallId":"9615a6c2-1732-4a04-9be1-cc0a8d39de3f"},{"index":3220,"token":false,"name":"Vigor","scryfallId":"c3c8cc70-a8c8-41db-99c1-b8be6f020180"},{"index":3221,"token":false,"name":"Meadowboon","scryfallId":"d4dc0113-f03c-47c2-9424-4c546793d25d"},{"index":3223,"token":false,"name":"Shivan Meteor","scryfallId":"108599c3-f641-48f1-af68-8e9a66c6afbc"},{"index":3224,"token":false,"name":"Lord of the Undead","scryfallId":"c95bacfd-e766-4e94-a22c-1996fdb11062"},{"index":3225,"token":false,"name":"Kami of the Painted Road","scryfallId":"7068739c-0a6a-49a1-88c3-68d7abc58ee2"},{"index":3226,"token":false,"name":"Goblin Welder","scryfallId":"6171e136-1167-4329-acb2-6853d3a814e5"},{"index":3227,"token":false,"name":"Gloom","scryfallId":"3444ab52-35fb-466f-a217-0202670cc2ad"},{"index":3228,"token":false,"name":"Gadrak, the Crown-Scourge","scryfallId":"333228c5-af16-4ebd-acfc-3776b21ef044"},{"index":3229,"token":false,"name":"In the Eye of Chaos","scryfallId":"733933dd-c871-4f75-8b08-d7c010dddbe6"},{"index":3231,"token":false,"name":"Loxodon Warhammer","scryfallId":"1c20b8a0-55b3-4974-9b80-5a80a53de144"},{"index":3232,"token":false,"name":"Charcoal Diamond","scryfallId":"7cc870ce-f296-4cb8-950f-69440651f4e7"},{"index":3233,"token":false,"name":"Ray of Command","scryfallId":"7f3c4851-0058-4b3f-982f-4365fd333edb"},{"index":3235,"token":false,"name":"Earthshaking Si","scryfallId":"418df457-4aab-486c-b691-41f03ec8a6df"},{"index":3236,"token":false,"name":"Mind Extraction","scryfallId":"7d77ddcc-e66b-4036-8a55-ec42953918d1"},{"index":3238,"token":false,"name":"Glint-Sleeve Artisan","scryfallId":"bea3b945-ae35-4cf0-a5dd-b2398d192c2f"},{"index":3239,"token":false,"name":"Isolation Cell","scryfallId":"c5e72c64-cb0e-4a04-97d0-3537bb0420cd"},{"index":3240,"token":false,"name":"Scapeshift","scryfallId":"84829605-50eb-455d-a236-ebfa11e883c5"},{"index":3242,"token":false,"name":"Twilight Mire","scryfallId":"53c59bee-0369-4a34-832f-fe3829a391b3"},{"index":3243,"token":false,"name":"Bident of Thassa","scryfallId":"57af7aa5-8626-4de2-843f-a2dc250e1381"},{"index":3244,"token":false,"name":"Skystreamer","scryfallId":"89d87407-7f92-47d6-bd89-69f39e0e0820"},{"index":3246,"token":false,"name":"Survival of the Fittest","scryfallId":"7b5862b3-e62e-4539-ab57-6c8f1138ac5d"},{"index":3247,"token":false,"name":"Ondu Cleric","scryfallId":"ced43447-fefc-482a-b8fa-33b9616aa532"},{"index":3248,"token":false,"name":"Disfigure","scryfallId":"099b46e0-53cb-4a1a-9a07-b34dd6d13ecf"},{"index":3251,"token":false,"name":"Tilonalli's Summoner","scryfallId":"2b107726-3a44-4b0f-86ef-4dbbf4473e7e"},{"index":3252,"token":false,"name":"Runed Crown","scryfallId":"1ef89770-2dbb-4a57-99f7-191591bb8e38"},{"index":3254,"token":false,"name":"Aerial Guide","scryfallId":"79c594bf-ca60-49d6-8c87-ed9d9f138334"},{"index":3255,"token":false,"name":"Silent Arbiter","scryfallId":"986a7ea8-a015-4dd8-9938-36b38ccd3980"},{"index":3256,"token":false,"name":"Primal Command","scryfallId":"b3b015a4-95c9-49c9-8665-3074e4fc2e5e"},{"index":3257,"token":false,"name":"Recall","scryfallId":"dc53dd70-e2a7-4203-ae00-240694d7220e"},{"index":3258,"token":false,"name":"Blight Herder","scryfallId":"b2758c4f-8d3b-41f3-84f7-9d8d5c301b93"},{"index":3259,"token":false,"name":"Darksteel Sentinel","scryfallId":"f9bd80ce-e36a-47ff-a009-17a05afce187"},{"index":3260,"token":false,"name":"Piper of the Swarm","scryfallId":"59cf9b3b-21ec-43c3-80d3-2e3c99f34714"},{"index":3261,"token":false,"name":"Aerial Predation","scryfallId":"ec3c023c-037e-495a-b7df-32be42a75f36"},{"index":3262,"token":false,"name":"Council's Judgment","scryfallId":"32301593-f16a-4a46-8a4e-eecedd2a9013"},{"index":3263,"token":false,"name":"Psychic Venom","scryfallId":"0ba1b264-1dd5-475b-9522-9eb9efcea572"},{"index":3264,"token":false,"name":"Plague Belcher","scryfallId":"280ae211-f025-4971-83e6-118ca08a1911"},{"index":3265,"token":false,"name":"Shadows' Verdict","scryfallId":"3d4f90f5-10d5-4a28-8db6-6993524ae155"},{"index":3267,"token":false,"name":"Purge","scryfallId":"fef7c2b7-4f7b-4f2f-a086-126c332d1469"},{"index":3268,"token":false,"name":"Chronomaton","scryfallId":"aac35e28-dd0e-4dc8-b8e6-4a1e33706214"},{"index":3269,"token":false,"name":"Freejam Regent","scryfallId":"d6b5147f-b422-47d3-98a0-dcc2d6f4e17a"},{"index":3270,"token":false,"name":"Terrifying Presence","scryfallId":"070408ff-5f23-4972-a9cc-d5351fd995f7"},{"index":3271,"token":false,"name":"Honden of Seeing Winds","scryfallId":"deab016b-b92e-4a7a-9dea-90aff4de0044"},{"index":3272,"token":false,"name":"Kessig Recluse","scryfallId":"695b8abe-796e-4d9b-aad3-4e03e925d2a7"},{"index":3275,"token":false,"name":"Unsettled Mariner","scryfallId":"eaea2e54-ee50-47b9-a2a5-e3353831248c"},{"index":3276,"token":false,"name":"Imposing Sovereign","scryfallId":"0f672328-3361-498e-a9f4-2d8e69a8b072"},{"index":3277,"token":false,"name":"Hunger of the Howlpack","scryfallId":"b38a0dbc-3ebd-4f87-a5fb-bc2ee8a48a8d"},{"index":3278,"token":false,"name":"Cast Out","scryfallId":"ec265d99-808f-4024-91b2-6575b46fd6f8"},{"index":3279,"token":false,"name":"Akroma's Vengeance","scryfallId":"83ea781d-0aa1-4ccc-a48b-d4af7e5dfdd5"},{"index":3281,"token":false,"name":"Knight of the Skyward Eye","scryfallId":"1d56e2bf-1937-42c1-8f61-1fd93e84cef7"},{"index":3283,"token":false,"name":"Myr Prototype","scryfallId":"6d929b28-c184-4e77-a40b-ee43b8a37d79"},{"index":3284,"token":false,"name":"Accumulated Knowledge","scryfallId":"ad88e5ee-0eee-47af-a7b4-9bac044e1c8c"},{"index":3285,"token":false,"name":"Brazen Borrower // Petty Theft","scryfallId":"4017fd72-5bb4-42f3-baf8-d83c1a4fd34a"},{"index":3286,"token":false,"name":"Healing Salve","scryfallId":"ba626b05-ef94-4ce5-b28b-e4b68d425f9b"},{"index":3287,"token":false,"name":"Path of Mettle // Metzali, Tower of Triumph","scryfallId":"8d4aa064-240f-4aea-97b7-b687e67b4cb9"},{"index":3288,"token":false,"name":"Macabre Waltz","scryfallId":"f49d5f95-c8a8-4d65-9546-26c2113db817"},{"index":3289,"token":false,"name":"Nightstalker Engine","scryfallId":"61e440ad-462f-4c7e-a646-8c5123a9f6b2"},{"index":3290,"token":false,"name":"Swarmyard","scryfallId":"db231a23-c556-4667-bf83-9216f13b9618"},{"index":3291,"token":false,"name":"Blood Sun","scryfallId":"5f156bb8-11b2-4f56-9f48-31a5cdf04474"},{"index":3292,"token":true,"name":"Antoine Ruel Bio","scryfallId":"fe3fbedf-fe21-4b19-b383-20d986ea2117"},{"index":3296,"token":false,"name":"Freyalise, Llanowar's Fury","scryfallId":"86dd3f7a-9d5c-49f7-bb1c-2e5f0eb0cf74"},{"index":3297,"token":false,"name":"Journey for the Elixir","scryfallId":"51a9c264-c614-4872-87a4-fc740fd5f2f7"},{"index":3299,"token":false,"name":"Diabolic Tutor","scryfallId":"06750380-a9a9-4ab4-a03b-d4d35a31132a"},{"index":3301,"token":false,"name":"Ankh of Mishra","scryfallId":"3e226943-312b-4128-a9fd-c49e3a65a0f5"},{"index":3304,"token":false,"name":"Cone of Flame","scryfallId":"9b434a60-0875-47f4-a626-2c9bfa3c9b3b"},{"index":3305,"token":false,"name":"Dutiful Return","scryfallId":"d5f83b3a-ce34-4179-8745-059181dd79b8"},{"index":3307,"token":false,"name":"Corpse Cur","scryfallId":"9c6e19a1-b9ea-4724-96d6-63c4b4967257"},{"index":3309,"token":false,"name":"Primevals' Glorious Rebirth","scryfallId":"8a58c19e-fd85-428f-9a76-f81c4c52c9c9"},{"index":3310,"token":false,"name":"Inferno Trap","scryfallId":"9a81ac38-c477-4797-ab91-cb7804cb727b"},{"index":3312,"token":false,"name":"Varchild's War-Riders","scryfallId":"e879b457-dffa-4b3b-a3cd-717a60c1e586"},{"index":3313,"token":false,"name":"Plagued Rusalka","scryfallId":"55237cdf-2a83-4467-abc0-f7d8bdcb4b62"},{"index":3315,"token":false,"name":"Cobalt Golem","scryfallId":"ec5e72f6-f573-4e37-9daa-abe6561ab086"},{"index":3316,"token":false,"name":"Mistcaller","scryfallId":"0972287a-8c68-4661-8e59-cb0d5c06670d"},{"index":3317,"token":false,"name":"Hunt the Weak","scryfallId":"546686cb-4cb1-4107-bbf5-0af943236ad2"},{"index":3318,"token":false,"name":"Mana Flare","scryfallId":"90d9af72-1633-4433-83ce-7de806611448"},{"index":3319,"token":false,"name":"Dismantle","scryfallId":"86862339-a5a5-45c4-bba5-981cff4f45f5"},{"index":3320,"token":false,"name":"Strength of Solidarity","scryfallId":"090b3da4-c942-480e-9997-bb9c20e8d62d"},{"index":3321,"token":false,"name":"Jinxed Idol","scryfallId":"269da2cd-0a50-4b07-a343-35371a9dcbb4"},{"index":3323,"token":false,"name":"Novijen, Heart of Progress","scryfallId":"28cfb5bf-cb71-4708-bcc0-6a08efa41891"},{"index":3324,"token":false,"name":"Ghitu Fire-Eater","scryfallId":"131dce1c-e9c8-437a-b7aa-36a47049d2d2"},{"index":3326,"token":false,"name":"Abyssal Gatekeeper","scryfallId":"1734df5a-7d3a-46c7-a0ad-adbbd1be958f"},{"index":3327,"token":false,"name":"Warkite Marauder","scryfallId":"c66f8e05-06e4-4315-9ae4-1e9b52533da1"},{"index":3329,"token":false,"name":"Noggle Bridgebreaker","scryfallId":"545a52ed-b4d4-4972-940d-9daf07a488b1"},{"index":3330,"token":false,"name":"Declaration in Stone","scryfallId":"77c3e441-1a4a-4144-83a4-e6a17d43bade"},{"index":3331,"token":false,"name":"Oath of Liliana","scryfallId":"2028f577-e0fb-48dd-89c6-f4a000b0a881"},{"index":3332,"token":false,"name":"Kilnmouth Dragon","scryfallId":"effe13c3-3c8b-4faa-bdd4-491039bfa82b"},{"index":3333,"token":false,"name":"Starstorm","scryfallId":"8efdb519-29c2-4a60-87ff-1a5ae34f224c"},{"index":3334,"token":false,"name":"Trap Digger","scryfallId":"05cd76bf-db08-45f8-b3ae-501bcca6df3c"},{"index":3336,"token":false,"name":"Shatterstorm","scryfallId":"eee5cbc2-7015-4b46-a9f4-d5dd27bed6e8"},{"index":3337,"token":false,"name":"Body of Jukai","scryfallId":"f43fe8e0-23ab-4fe7-8a48-1902be142c6a"},{"index":3339,"token":false,"name":"Ojutai's Command","scryfallId":"823b3d6d-31cb-4f0f-bdd1-73856d61f1a5"},{"index":3341,"token":false,"name":"Khalni Heart Expedition","scryfallId":"797d8cd6-fc6b-4560-9c6f-1a867dfce85a"},{"index":3343,"token":false,"name":"Unnerve","scryfallId":"f72779ce-bcd3-41dc-8b3f-bfb9a1b137d8"},{"index":3344,"token":false,"name":"Might of Old Krosa","scryfallId":"4246cfd0-f150-4142-8dd4-7ebeb707b6f4"},{"index":3345,"token":false,"name":"Varragoth, Bloodsky Sire","scryfallId":"aa0db676-6e0a-421d-a089-c6d6cfdd0584"},{"index":3346,"token":false,"name":"Sylvan Messenger","scryfallId":"085f1b89-857b-4e2b-b796-0b95e53322bd"},{"index":3348,"token":false,"name":"Pharika's Disciple","scryfallId":"f0b3d8f7-6a41-49ba-b111-d34a345394c0"},{"index":3349,"token":false,"name":"Constant Mists","scryfallId":"8e1a8567-ce22-43d6-a85d-5eadb1e023e7"},{"index":3351,"token":false,"name":"Gild","scryfallId":"ea315dab-e35d-4fdf-8574-b22e70643063"},{"index":3352,"token":false,"name":"Haunted Fengraf","scryfallId":"97a1d55a-39a8-4bf4-91b7-5565146c9c40"},{"index":3354,"token":false,"name":"Izzet Guildgate","scryfallId":"165ee8d7-d509-41d4-abd2-298b3db3ca46"},{"index":3356,"token":false,"name":"Nivix Cyclops","scryfallId":"f6abe6ca-9345-41bc-9acd-b17ac887cb9d"},{"index":3357,"token":false,"name":"Kiki-Jiki, Mirror Breaker","scryfallId":"162018eb-5483-4fa2-9c5a-abb639eecf91"},{"index":3359,"token":false,"name":"Glaring Aegis","scryfallId":"daa83dc2-4ec0-4e4f-8bfd-4f6d6df06a2d"},{"index":3360,"token":false,"name":"Stone Giant","scryfallId":"1fd3860d-c303-4936-a4f1-eeeac77a18e7"},{"index":3361,"token":false,"name":"Plargg, Dean of Chaos // Augusta, Dean of Order","scryfallId":"9ed6f39f-286b-4b46-8c40-52358c011f2e"},{"index":3362,"token":false,"name":"Jester's Cap","scryfallId":"1d113a8c-0cbf-4c48-96f5-ad8c77947a0a"},{"index":3364,"token":false,"name":"Orzhov Basilica","scryfallId":"b31f4a31-fe5c-4430-a8b3-630ceb80e38d"},{"index":3365,"token":false,"name":"Quakebringer","scryfallId":"c5bbffb9-1f1c-40e5-97f4-29bf1fc68625"},{"index":3366,"token":false,"name":"Rough // Tumble","scryfallId":"0c93c9a0-53eb-44cc-bd79-8103774bfd4c"},{"index":3367,"token":false,"name":"Darkwater Catacombs","scryfallId":"2583b941-6156-4c4b-a068-0d0ac75a3dd3"},{"index":3370,"token":false,"name":"Talisman of Resilience","scryfallId":"cc25a254-edd2-4817-ab80-7373239da7d2"},{"index":3372,"token":false,"name":"Brassclaw Orcs","scryfallId":"6f068807-3e0d-42b0-aa11-7fd61492f12b"},{"index":3374,"token":false,"name":"Demonfire","scryfallId":"af2ad333-722e-4d7e-972a-903c24068931"},{"index":3376,"token":false,"name":"Somber Hoverguard","scryfallId":"edd7f87e-dcb4-4774-a0b5-dd965a5264df"},{"index":3377,"token":false,"name":"Shackles of Treachery","scryfallId":"db743c6e-1385-468e-921a-7a525b88a1b6"},{"index":3378,"token":false,"name":"Circle of Flame","scryfallId":"231bc57d-dd92-4ec8-931d-828bf984a24c"},{"index":3379,"token":false,"name":"Eternity Snare","scryfallId":"de753839-cf75-48d0-98c3-5765779678c0"},{"index":3380,"token":false,"name":"Mind Rot","scryfallId":"9df7f95a-0629-4568-9f0a-9074daa0d743"},{"index":3381,"token":false,"name":"Firehoof Cavalry","scryfallId":"edb2b284-f79c-41eb-a25f-4710d4a5228f"},{"index":3382,"token":false,"name":"Tragic Arrogance","scryfallId":"215f75ff-bcbb-45db-8393-9bce650998c2"},{"index":3384,"token":false,"name":"Cabal Surgeon","scryfallId":"29ce55a2-d838-48ab-862e-d419b0cda3c9"},{"index":3385,"token":false,"name":"Slayers' Stronghold","scryfallId":"939a4351-3ec7-4e6c-8cdd-766bfd670391"},{"index":3386,"token":false,"name":"Riptide Crab","scryfallId":"7e42ae1d-62b4-4b19-aafc-f12bdd6fb8cc"},{"index":3389,"token":false,"name":"Voracious Typhon","scryfallId":"efa2bccb-0e01-4629-b9a8-5c0ea26239b3"},{"index":3391,"token":false,"name":"Wing Splicer","scryfallId":"e2dbfb1b-092c-44a3-932d-a8b27be0a72b"},{"index":3392,"token":false,"name":"Conviction","scryfallId":"94507660-cf60-4fd8-a796-7a6e6f28396d"},{"index":3393,"token":false,"name":"Unburial Rites","scryfallId":"f09e0915-a8b0-4310-8cad-f837eff5d812"},{"index":3394,"token":false,"name":"Moltensteel Dragon","scryfallId":"13b78018-bfbe-43fa-809f-9b52a155e11c"},{"index":3395,"token":false,"name":"Jace, Unraveler of Secrets","scryfallId":"0cd42763-980b-4a77-b528-fda483af6ba8"},{"index":3397,"token":false,"name":"Empty-Shrine Kannushi","scryfallId":"86c2e405-afe2-4de2-9e45-c5f357d788ac"},{"index":3398,"token":false,"name":"Spontaneous Combustion","scryfallId":"34e6c04f-9d1a-497b-bc96-a0e48a1c1904"},{"index":3399,"token":false,"name":"Delay","scryfallId":"e821d337-4bc5-4401-ac9b-34adf4012b73"},{"index":3400,"token":false,"name":"Ulvenwald Mystics // Ulvenwald Primordials","scryfallId":"8325c570-4d74-4e65-891c-3e153abf4bf9"},{"index":3401,"token":false,"name":"Capsize","scryfallId":"122c819d-2b13-49af-92dc-af96d4de45de"},{"index":3403,"token":false,"name":"Matopi Golem","scryfallId":"92378d6f-89ee-49dc-8964-0e9c55daeffc"},{"index":3404,"token":false,"name":"Dauthi Warlord","scryfallId":"af3ca689-482a-457d-9744-0bd79981f361"},{"index":3405,"token":false,"name":"Dwarven Trader","scryfallId":"4db9aa47-f42b-41e9-948c-8b012c3809fb"},{"index":3408,"token":false,"name":"Daggerback Basilisk","scryfallId":"66587523-b973-4f05-a601-cf25d61a903a"},{"index":3410,"token":false,"name":"Sengir Bats","scryfallId":"2ddb981a-d9e3-4efe-a383-5c98ee3b0b84"},{"index":3411,"token":false,"name":"Vaevictis Asmadi","scryfallId":"df01b548-9738-4c84-beb6-9a375f41d496"},{"index":3412,"token":false,"name":"Curse of Chains","scryfallId":"5db21bcb-60e8-4d15-8ea7-7298c2b1607c"},{"index":3413,"token":false,"name":"Arbor Elf","scryfallId":"b7d6b117-0c14-4455-92fc-29555ee75d97"},{"index":3415,"token":false,"name":"Disdainful Stroke","scryfallId":"5f6677e9-cd9a-4690-8f1c-6c5910c5605a"},{"index":3416,"token":false,"name":"Sword of Light and Shadow","scryfallId":"d22437d0-b6e1-4175-b4bb-c2d67141ac84"},{"index":3417,"token":false,"name":"Heroic Intervention","scryfallId":"63729bb5-28ad-45a4-8890-7b4a0b265674"},{"index":3418,"token":false,"name":"Crafty Pathmage","scryfallId":"c3eb5c44-3a6f-49b9-a36a-63d0398a34a0"},{"index":3419,"token":false,"name":"Twincast","scryfallId":"07d65aee-242e-4255-b2a7-5a3a3b464b48"},{"index":3420,"token":false,"name":"Tuvasa the Sunlit","scryfallId":"87a66020-f670-4650-86c0-56ac6c7dfca0"},{"index":3421,"token":false,"name":"Wurmweaver Coil","scryfallId":"531e3496-291d-43b3-9c1e-5624a1601697"},{"index":3422,"token":false,"name":"Perplexing Chimera","scryfallId":"f9cff40b-9cae-47d0-8df4-c287a17a33e4"},{"index":3423,"token":false,"name":"Sunhome, Fortress of the Legion","scryfallId":"9181ca1c-a2b4-4cd1-88dd-93df2dcef703"},{"index":3424,"token":false,"name":"Brainstone","scryfallId":"10b9a9f6-5be5-47aa-8e2f-576d06c5abb9"},{"index":3426,"token":false,"name":"Talas Merchant","scryfallId":"2f779d7e-6e37-49bc-b76d-3bb490ff142b"},{"index":3427,"token":false,"name":"Seismic Mage","scryfallId":"9524432a-3186-4c7b-a780-28bdbe36053f"},{"index":3428,"token":false,"name":"Unstable Hulk","scryfallId":"889cfde2-42fa-4278-ae4e-7e4dd993cda8"},{"index":3429,"token":false,"name":"Temple of the False God","scryfallId":"1f3b5582-4530-4f9a-b416-275dfbfa0477"},{"index":3430,"token":false,"name":"Fen Hauler","scryfallId":"b6f6f2df-ee84-4d07-888b-2a0692c18d61"},{"index":3431,"token":false,"name":"Cruel Revival","scryfallId":"245aba23-2abb-4084-b4cb-d06e46de2108"},{"index":3432,"token":false,"name":"Loxodon Line Breaker","scryfallId":"449a5550-fc64-4f73-852e-3e450ee98055"},{"index":3433,"token":false,"name":"Ral's Outburst","scryfallId":"6be3dd3e-50d2-4729-9caa-b2cd984f4c97"},{"index":3434,"token":false,"name":"Brute Strength","scryfallId":"7776b3cb-0410-4d9c-958f-3ea042f9eaea"},{"index":3437,"token":false,"name":"Mirrodin Besieged","scryfallId":"d8423d8d-744a-4bbe-a853-8ad756451bdb"},{"index":3438,"token":false,"name":"Magus of the Mirror","scryfallId":"4a6e8ff6-323d-4cc3-b7b6-8607bf89597e"},{"index":3439,"token":false,"name":"Death Mutation","scryfallId":"01f33e98-e024-422f-9f18-a938ba1f76af"},{"index":3442,"token":false,"name":"Evil Presence","scryfallId":"0551d66e-8cd4-48f0-aa17-15f26be9d85f"},{"index":3443,"token":false,"name":"Burn Bright","scryfallId":"f19b4a80-41e1-4c5f-869a-682f08543f12"},{"index":3444,"token":false,"name":"Snapping Thragg","scryfallId":"c8a47d41-b893-46b9-90c9-ccd8f9f78855"},{"index":3445,"token":false,"name":"Hasran Ogress","scryfallId":"feba4ad9-3d6d-4676-862a-c2cc9ad35350"},{"index":3446,"token":false,"name":"Dregs of Sorrow","scryfallId":"c5c4223d-8846-489d-abfc-8330dc58d12b"},{"index":3448,"token":false,"name":"Multani's Acolyte","scryfallId":"4e5fdecb-bca0-48ea-b5bb-d0886c7d3316"},{"index":3449,"token":false,"name":"Outland Boar","scryfallId":"41f77d13-385a-4ee6-b620-564fd51388c7"},{"index":3454,"token":false,"name":"Goblin Rabblemaster","scryfallId":"bce84a87-093a-42de-9696-8c3250e0f33b"},{"index":3456,"token":false,"name":"Cursed Ronin","scryfallId":"b8f24fe9-22c4-4e53-9d7a-3cbf5533ac9b"},{"index":3457,"token":false,"name":"Living Armor","scryfallId":"b9da41f7-c1d2-4d5c-b6a5-09f6cc05cd4a"},{"index":3458,"token":false,"name":"Briarhorn","scryfallId":"40ecdeac-3454-40e4-ad9b-68310299004b"},{"index":3461,"token":true,"name":"Clue // Clue","scryfallId":"9b111525-0600-4bae-94a3-df8f9472388f"},{"index":3462,"token":false,"name":"Peema Outrider","scryfallId":"2ab38bd5-64bb-41aa-851b-c6bc6b44bcf0"},{"index":3463,"token":false,"name":"Consecrate // Consume","scryfallId":"00320106-ce51-46a9-b0f9-79b3baf4e505"},{"index":3464,"token":false,"name":"Zealous Guardian","scryfallId":"9951214b-43a9-4c51-bbb4-05bac81b9866"},{"index":3466,"token":false,"name":"Kazarov, Sengir Pureblood","scryfallId":"2aff7077-496b-46ca-b9d7-a8c1772f9a91"},{"index":3467,"token":false,"name":"Torpor Dust","scryfallId":"8840551f-d43a-487f-a960-9b220dec5df4"},{"index":3468,"token":false,"name":"Heavenly Blademaster","scryfallId":"88549b0e-063a-4faf-984e-efff33522f14"},{"index":3469,"token":false,"name":"Cauldron of Souls","scryfallId":"8a0137d0-d10a-43d4-b174-72ce59d2f2fd"},{"index":3470,"token":true,"name":"Cloud Sprite Token (U, 1/1)","scryfallId":"4a2144f2-d4be-419e-bfca-116cedfdf18b"},{"index":3472,"token":false,"name":"Icy Manipulator","scryfallId":"1a99b138-dd24-4336-b58c-b8d4e5a84997"},{"index":3473,"token":false,"name":"Hour of Glory","scryfallId":"f35e66cb-af50-411a-b6f2-16fb7072eff5"},{"index":3474,"token":false,"name":"Skithiryx, the Blight Dragon","scryfallId":"cab61c7e-e00a-413b-a0b5-7718b479582f"},{"index":3475,"token":false,"name":"Thief of Sanity","scryfallId":"2d95b77d-382d-4787-bf17-db99c4b2a548"},{"index":3476,"token":false,"name":"Afterlife","scryfallId":"258946f2-294a-4ddf-be91-9ff4c94e4bdb"},{"index":3477,"token":false,"name":"Kathari Remnant","scryfallId":"26bba70d-11ea-48ba-861f-8f450d990824"},{"index":3478,"token":false,"name":"Barbed Lightning","scryfallId":"2509482a-68d8-4e94-9d1e-5b069ebdc2e4"},{"index":3479,"token":false,"name":"Guard Gomazoa","scryfallId":"07700062-28fc-4d30-8859-14f200618f6a"},{"index":3480,"token":false,"name":"Blessed Wine","scryfallId":"aee815d6-ce79-42ff-9d18-b2f92671d1c4"},{"index":3482,"token":false,"name":"Anvilwrought Raptor","scryfallId":"aa6d7bbe-0418-4a58-a97b-13b50eb0b642"},{"index":3483,"token":false,"name":"Sunken City","scryfallId":"a72df566-56ae-403e-9aa4-7bff5b8f12e4"},{"index":3484,"token":false,"name":"Primal Plasma","scryfallId":"44ef3cce-21cf-48ef-90de-72426e481ba6"},{"index":3486,"token":false,"name":"Weirding Wood","scryfallId":"b8033b16-7a48-4455-9b1b-f62ceb7b9b61"},{"index":3488,"token":false,"name":"Thrasios, Triton Hero","scryfallId":"845bf543-0367-4d2c-81ba-e424bfbfb7de"},{"index":3489,"token":false,"name":"Dream Chisel","scryfallId":"e89610e9-f1d3-4332-901a-2598bf01d61d"},{"index":3492,"token":false,"name":"Blight Mound","scryfallId":"41b4171c-9518-404f-ad42-f3115fb5abe9"},{"index":3493,"token":false,"name":"Willow Elf","scryfallId":"c063a072-0cd4-45fb-ac68-96e359bf3ef5"},{"index":3495,"token":false,"name":"Outrider en-Kor","scryfallId":"e3e0d923-d94f-4f12-a025-86587b18878f"},{"index":3496,"token":false,"name":"Garenbrig Carver // Shield's Might","scryfallId":"bb6b2759-c315-42cb-8842-dc4f0f42c01d"},{"index":3497,"token":false,"name":"Storm's Wrath","scryfallId":"4bc9ecd2-7664-471b-90f2-2d0dd1acec80"},{"index":3498,"token":false,"name":"Grave Scrabbler","scryfallId":"5c82a0d6-6b74-48b8-8f6a-d3ccf4e4daef"},{"index":3499,"token":false,"name":"Ghazbán Ogre","scryfallId":"85bcd723-780b-45ca-9476-d28270350013"},{"index":3500,"token":false,"name":"Sound the Call","scryfallId":"ae586221-c13c-4f4e-83ae-9b1ab0aeae61"},{"index":3501,"token":false,"name":"Glorious Anthem","scryfallId":"a3ba79d6-7da0-46ba-a26a-dc484bdae41d"},{"index":3503,"token":false,"name":"Reshape","scryfallId":"8f8a8f14-bced-4388-b263-5e70431b191f"},{"index":3506,"token":false,"name":"Borrowing the East Wind","scryfallId":"96ba9014-d750-4924-aa6f-8b9f421807f9"},{"index":3508,"token":false,"name":"Stinkdrinker Bandit","scryfallId":"dd75155b-a13d-4bed-8014-70f27175aa74"},{"index":3509,"token":false,"name":"Mental Misstep","scryfallId":"61e9c6df-1c84-4eab-9076-a4feb6347c10"},{"index":3510,"token":false,"name":"Stampede Driver","scryfallId":"35390394-013f-4996-9d1a-e4c53de941ba"},{"index":3511,"token":false,"name":"Bretagard Stronghold","scryfallId":"24a0f2e2-cfd7-4374-a172-4357d5de47bb"},{"index":3514,"token":false,"name":"Scoured Barrens","scryfallId":"6fad82a9-82c5-41d9-9eba-c0003370eb27"},{"index":3516,"token":false,"name":"Tromp the Domains","scryfallId":"c3815bd2-bc3c-46b8-b9e1-8eea25156440"},{"index":3518,"token":false,"name":"Sacred Foundry","scryfallId":"b7b598d0-535d-477d-a33d-d6a10ff5439a"},{"index":3519,"token":false,"name":"Thicket Crasher","scryfallId":"534eb449-3f1c-46ec-a965-0f5812e2c93e"},{"index":3521,"token":false,"name":"Glacial Chasm","scryfallId":"c5d439cb-50bc-4a33-bb1e-7bb2b81bfce7"},{"index":3524,"token":false,"name":"Slitherwisp","scryfallId":"d2a641ad-4268-46c4-a5fb-c1515e52d648"},{"index":3525,"token":false,"name":"Burning Wish","scryfallId":"0c889db9-a20e-4bfb-b51b-838e2bd34c38"},{"index":3526,"token":false,"name":"Boompile","scryfallId":"e27c6a13-d19f-44c5-9e68-0153a627b343"},{"index":3528,"token":false,"name":"Nissa's Revelation","scryfallId":"a229b53f-f34b-44f5-b0b4-94239b85a15b"},{"index":3529,"token":false,"name":"Goblin Chainwhirler","scryfallId":"08ca01f2-7706-4cf4-b111-0dade88653b2"},{"index":3530,"token":false,"name":"Backfire","scryfallId":"d23b43c3-6cc5-402b-ac6c-3295287bce42"},{"index":3532,"token":false,"name":"Ornery Dilophosaur","scryfallId":"c2c4a0e7-9ca4-4291-94de-165cc2ded822"},{"index":3533,"token":false,"name":"Aurelia, the Warleader","scryfallId":"fd455e45-8139-41ea-b738-828f89ee72d6"},{"index":3534,"token":false,"name":"Cradle of Vitality","scryfallId":"e15d671d-a48c-4c37-b4d6-eecead82ffb6"},{"index":3535,"token":false,"name":"Tinder Wall","scryfallId":"2a7c6489-21e9-4b86-a54a-b1e2f1fce318"},{"index":3536,"token":false,"name":"Warstorm Surge","scryfallId":"213e448e-8d8c-4ba8-aad1-93c4e6900b0d"},{"index":3537,"token":false,"name":"Burnished Hart","scryfallId":"bdf2d103-8614-4cc1-be90-a8b331eff0d2"},{"index":3538,"token":false,"name":"Collective Voyage","scryfallId":"3f2d44f0-c71e-4061-bb7c-1f91fbce8f51"},{"index":3539,"token":false,"name":"Viashino Sandstalker","scryfallId":"3f16f22f-838f-47da-baa3-4d0facd39aab"},{"index":3541,"token":false,"name":"Bull Cerodon","scryfallId":"47b40638-de74-41a5-b7e7-64f0cd4ab648"},{"index":3542,"token":false,"name":"Simic Cluestone","scryfallId":"e3c47552-afed-463d-bd24-13eb1cd724fc"},{"index":3543,"token":false,"name":"Minion of the Wastes","scryfallId":"d9f120fc-c681-47b6-827e-1cc7ead47a0f"},{"index":3545,"token":false,"name":"Rats' Feast","scryfallId":"b243ce02-4fff-444c-acc4-e1a199621a53"},{"index":3546,"token":false,"name":"Merfolk Wayfinder","scryfallId":"71ab86f3-aa75-40ce-a71e-90d40dad4bdc"},{"index":3547,"token":false,"name":"Leonin Armorguard","scryfallId":"8a57cdbd-3cd2-47c1-aec8-7f4fd7a7b804"},{"index":3548,"token":false,"name":"Spike Weaver","scryfallId":"9c561a2a-91c6-4d4b-9f96-bffd43a00478"},{"index":3549,"token":false,"name":"Tiana, Ship's Caretaker","scryfallId":"fdefab69-4c4e-4e1a-baa0-3f7210f2f0d5"},{"index":3550,"token":false,"name":"Crevasse","scryfallId":"a432d6ae-a17f-484b-ad55-4b4b6674ba8d"},{"index":3551,"token":false,"name":"Thoughtweft Gambit","scryfallId":"b7990b23-d460-46e2-bb05-396e2a653429"},{"index":3553,"token":false,"name":"Knight of the Reliquary","scryfallId":"648da53a-5cce-4133-9779-62d18783dd67"},{"index":3555,"token":false,"name":"Nightwing Shade","scryfallId":"ba6232c3-f840-450a-8583-540aec0f17ed"},{"index":3556,"token":false,"name":"Kjeldoran Knight","scryfallId":"d5b9db8f-93b5-44e3-9e2b-728c80dfbb37"},{"index":3557,"token":false,"name":"Cenn's Enlistment","scryfallId":"ab1c1375-9908-4fe8-960a-595b9b58cd10"},{"index":3558,"token":false,"name":"Scragnoth","scryfallId":"c355e0e2-6854-437f-9fff-86f98bd16f34"},{"index":3559,"token":false,"name":"Marrow-Gnawer","scryfallId":"34da1276-5321-4781-832e-4daf3e13ca16"},{"index":3560,"token":false,"name":"Thalia, Guardian of Thraben","scryfallId":"e6f9792f-7435-49dd-98b4-cc2e9f556338"},{"index":3561,"token":false,"name":"Agony Warp","scryfallId":"e21ffd69-bde1-4a8a-8390-e93534fc78e5"},{"index":3562,"token":false,"name":"Augury Owl","scryfallId":"51351173-2ac0-44a9-a744-9dbf3cedbba5"},{"index":3563,"token":false,"name":"Into the Wilds","scryfallId":"ecfa6c8d-b5b5-4b68-9ad4-c9d8169659d6"},{"index":3564,"token":false,"name":"Severed Legion","scryfallId":"80b04f15-8639-457b-8665-de585996fa12"},{"index":3566,"token":false,"name":"Loyal Drake","scryfallId":"1197e710-278f-4942-87b0-f6363d329e65"},{"index":3567,"token":false,"name":"Rhox Bodyguard","scryfallId":"1e9f43c8-9df6-49df-b145-4a19bc55e8f4"},{"index":3568,"token":false,"name":"Crystal Shard","scryfallId":"cd9b7bf9-4087-4235-a21e-33f52ae69b48"},{"index":3569,"token":false,"name":"Peach Garden Oath","scryfallId":"41bfd51a-0aca-4686-a9c5-11288f409a22"},{"index":3570,"token":false,"name":"Ravenous Demon // Archdemon of Greed","scryfallId":"abbbb466-31ef-42dd-9993-124f7ec3d8ae"},{"index":3571,"token":false,"name":"Diamond Lion","scryfallId":"2116f1a3-f621-4bef-b5bd-fa4a644f76b1"},{"index":3572,"token":false,"name":"Mtenda Lion","scryfallId":"cb05cf5b-2a0d-432a-b8e7-10335c2a18e8"},{"index":3573,"token":false,"name":"Tawnos's Weaponry","scryfallId":"4750787e-9fef-4bdf-b2e3-e410c84999f2"},{"index":3576,"token":false,"name":"Skirk Prospector","scryfallId":"5ec17ffd-6be9-4f1a-9279-24927b408da6"},{"index":3577,"token":false,"name":"Ethereal Haze","scryfallId":"7f1996af-5f15-447f-9b1d-98a7e97df53a"},{"index":3578,"token":false,"name":"Gadwick, the Wizened","scryfallId":"62ddce0d-f22a-4fcd-9a4a-d71938750ba1"},{"index":3580,"token":false,"name":"Bishop of Rebirth","scryfallId":"22061eba-4069-46e1-a48a-856254e6d81f"},{"index":3582,"token":false,"name":"Spitting Drake","scryfallId":"c9ec1676-f59b-4ab6-995c-d2525ac11370"},{"index":3583,"token":false,"name":"Geist of Saint Traft","scryfallId":"35b57113-b39a-460b-b4aa-02606b40bbd0"},{"index":3584,"token":false,"name":"Thrasher Brute","scryfallId":"7c2a6f9c-49c4-433c-9269-fb075f2e0902"},{"index":3588,"token":false,"name":"Brushland","scryfallId":"792f4213-67ab-41d9-975d-ff783668f93d"},{"index":3590,"token":false,"name":"Anger","scryfallId":"c82ca741-cf8e-4f53-bb71-dcf80f149346"},{"index":3592,"token":false,"name":"Nacatl War-Pride","scryfallId":"6baf21f8-75d2-4733-9d1f-4767b7f50d54"},{"index":3594,"token":false,"name":"Renegade Tactics","scryfallId":"6c06a39c-68bb-4e65-9a6d-9d9bc745201f"},{"index":3596,"token":false,"name":"Bestial Fury","scryfallId":"626225b9-2cfd-4cf5-b11c-89e5a231b09e"},{"index":3597,"token":true,"name":"Beast Token (G, 3/3)","scryfallId":"3fc3a29a-280d-4f2c-9a01-8cfead75f583"},{"index":3598,"token":false,"name":"Divine Favor","scryfallId":"43c1ddf8-e38a-44df-9195-40e2b0d4cd5f"},{"index":3599,"token":false,"name":"Skyreach Manta","scryfallId":"f6b11e69-09ec-4e26-a64d-c129c45574b1"},{"index":3600,"token":false,"name":"Ruham Djinn","scryfallId":"a46c7718-1ecc-418c-b213-13be9de5cb7f"},{"index":3601,"token":false,"name":"Indomitable Creativity","scryfallId":"19fd6a55-564f-45c3-8231-29adfb7d7366"},{"index":3602,"token":false,"name":"Necrogen Scudder","scryfallId":"c2045ddd-fa05-4769-aa7a-17b9ab8d6fc0"},{"index":3603,"token":false,"name":"Weather the Storm","scryfallId":"f6a9fa51-78c3-42e6-8c2e-39658f59ed87"},{"index":3604,"token":false,"name":"Expedite","scryfallId":"44072f87-3a99-49dd-9709-85aa83d4819f"},{"index":3605,"token":false,"name":"Mortal Obstinacy","scryfallId":"67652df1-f2cc-44cd-ac66-9722d4cd86e9"},{"index":3606,"token":false,"name":"Demon of Dark Schemes","scryfallId":"99c99736-5c9c-4d2f-946d-05606fcdd039"},{"index":3608,"token":false,"name":"Rain of Embers","scryfallId":"2d5391a9-6c30-4f9b-b746-a4427a3e63fc"},{"index":3609,"token":false,"name":"Goblin Ruinblaster","scryfallId":"dceb0cf3-0724-414a-a762-f772332ca27e"},{"index":3610,"token":false,"name":"Nightfire Giant","scryfallId":"11da48a7-903d-43f5-8085-1b3790ed079a"},{"index":3611,"token":false,"name":"Mercy Killing","scryfallId":"6f55536d-8573-42c2-9e8a-5a2ce24d1878"},{"index":3612,"token":false,"name":"Warmonger","scryfallId":"8165c159-490e-408b-8f2e-8950d883526d"},{"index":3613,"token":false,"name":"Dromoka, the Eternal","scryfallId":"04e19ddc-0d13-4540-a399-73258f741bb2"},{"index":3615,"token":false,"name":"Mana Confluence","scryfallId":"4cb8d03e-e1d2-451e-97a8-141082f92501"},{"index":3617,"token":false,"name":"Urza's Incubator","scryfallId":"94e10277-a935-4c78-b45f-52ab5ea0f95c"},{"index":3618,"token":false,"name":"Vedalken Archmage","scryfallId":"8b38da97-5141-4de6-bd7f-3fcbf46cfd96"},{"index":3619,"token":false,"name":"Mila, Crafty Companion // Lukka, Wayward Bonder","scryfallId":"34332dc9-d81c-4b16-bf59-2c75eaa05c21"},{"index":3620,"token":false,"name":"Dimir Guildgate","scryfallId":"2b7faa71-72f3-4b64-b6e2-d05ebd9c705d"},{"index":3621,"token":false,"name":"Queen of Ice // Rage of Winter","scryfallId":"81b16101-c0ac-4224-ade9-abba72773ec1"},{"index":3624,"token":false,"name":"Hissing Iguanar","scryfallId":"fa215c80-decf-40b5-8002-eac8b20a779e"},{"index":3625,"token":false,"name":"False Peace","scryfallId":"d4234262-56c6-4bd1-b425-12db931829d5"},{"index":3626,"token":false,"name":"Surreal Memoir","scryfallId":"681912e7-9dee-436f-a115-1701287f8a49"},{"index":3627,"token":false,"name":"Arid Mesa","scryfallId":"81ad48fa-9464-40bf-8bf5-af31a6a38fb3"},{"index":3629,"token":false,"name":"Angelic Accord","scryfallId":"03f26bc2-53d7-4448-8021-de35aa82fcc6"},{"index":3630,"token":false,"name":"Loyal Pegasus","scryfallId":"7cae7971-953b-454a-84dd-ae2974946da9"},{"index":3631,"token":false,"name":"Saproling Migration","scryfallId":"e4837842-ff2b-44f5-a833-e97ea02786f7"},{"index":3633,"token":false,"name":"Contradict","scryfallId":"a0b3d4ff-09d1-4d9f-8c83-cdfbd7bb1079"},{"index":3634,"token":false,"name":"Bog Raiders","scryfallId":"d702b165-badf-4443-8b69-04e660ebeed2"},{"index":3636,"token":false,"name":"Black Knight","scryfallId":"05c5f46f-0922-4c99-8c81-a76a0c9bb851"},{"index":3638,"token":false,"name":"Spirit Flare","scryfallId":"efdbe7c6-99ad-4c73-bffe-7bbdc6965854"},{"index":3639,"token":false,"name":"Zephid's Embrace","scryfallId":"fb3312de-c153-4e75-8f8c-b7762b30d492"},{"index":3642,"token":false,"name":"Lead Astray","scryfallId":"20a8fd2f-11fa-4879-be89-ea7833cf60d4"},{"index":3643,"token":false,"name":"Brutal Suppression","scryfallId":"17b3725b-924d-4137-9078-1a28f06c84fa"},{"index":3644,"token":false,"name":"Charix, the Raging Isle","scryfallId":"97982bcc-e1b1-4d21-b208-a6587613b8a1"},{"index":3645,"token":false,"name":"Jinxed Choker","scryfallId":"987910b0-0419-45ff-bda6-c6683fd00e49"},{"index":3649,"token":false,"name":"Mikaeus, the Lunarch","scryfallId":"1b24d60d-bd80-4363-829c-a9d7f8c61fdf"},{"index":3650,"token":false,"name":"Seaside Citadel","scryfallId":"697d2a41-59c1-48c2-9c64-65fb7e78ce4a"},{"index":3651,"token":false,"name":"Mesa Enchantress","scryfallId":"bd5335eb-e81f-46c5-a9e8-011f0c962b41"},{"index":3652,"token":false,"name":"Dragon-Style Twins","scryfallId":"52b876cb-2f75-44c1-a417-4a48f151e172"},{"index":3653,"token":false,"name":"Wild Pair","scryfallId":"f3153d2c-9168-4889-9179-23faa9c48721"},{"index":3655,"token":false,"name":"Deathbloom Thallid","scryfallId":"dc4513e1-9978-44ce-b7a5-4e2b5b63ad9e"},{"index":3656,"token":false,"name":"Wheel of Fortune","scryfallId":"4c23fbbc-511c-494b-9a5c-c164b1af6091"},{"index":3657,"token":false,"name":"Darkslick Shores","scryfallId":"e530388b-eb19-4211-abd8-8a4c3c38c3af"},{"index":3658,"token":false,"name":"Soul of New Phyrexia","scryfallId":"755c95c9-eead-486a-9a0e-384cc3143f6c"},{"index":3660,"token":false,"name":"Yurlok of Scorch Thrash","scryfallId":"ead8a1f5-6260-47fa-a649-43711ec5bbeb"},{"index":3661,"token":false,"name":"Ghastly Conscription","scryfallId":"120f7d4a-27b3-43e8-a301-c81d4d403a8f"},{"index":3662,"token":false,"name":"Grinning Ignus","scryfallId":"31716a43-2522-46ff-a9a4-b6952cd41f11"},{"index":3664,"token":false,"name":"Plague Rats","scryfallId":"b5f25e35-d07a-4e46-8ff9-53aff9059a2f"},{"index":3665,"token":false,"name":"Crookclaw Transmuter","scryfallId":"ac4e2977-b518-4fa3-83e4-5af326ded290"},{"index":3666,"token":false,"name":"Magus of the Moon","scryfallId":"c06a4443-6851-4873-8fb8-2ef76c9d6d2c"},{"index":3667,"token":false,"name":"Relic Robber","scryfallId":"49f6a537-fa85-44ab-a853-7a32812a4b32"},{"index":3668,"token":false,"name":"Bad River","scryfallId":"7e1dd7c0-f92d-4fbf-9a28-5fa6481ff7ff"},{"index":3669,"token":false,"name":"Aetherplasm","scryfallId":"95bee334-c56e-4221-97ed-bea73a61b812"},{"index":3670,"token":false,"name":"Collective Restraint","scryfallId":"d71daa57-ac02-4dd9-8c90-d38bdd45fb51"},{"index":3671,"token":false,"name":"Greater Realm of Preservation","scryfallId":"ab8eb77b-cdf7-44c6-8dce-898cfa173d66"},{"index":3672,"token":false,"name":"Choked Estuary","scryfallId":"99ff640a-9403-4b16-ade2-758f0650c540"},{"index":3673,"token":false,"name":"Manalith","scryfallId":"d4b420ed-75b8-4779-aaa2-e245e84202d1"},{"index":3676,"token":false,"name":"Death Denied","scryfallId":"8f66ddc5-f5e6-44de-8189-87b6521d1fea"},{"index":3677,"token":false,"name":"Burrowing","scryfallId":"45891e6e-1711-4b3e-8399-0873df67b874"},{"index":3679,"token":false,"name":"Animate Wall","scryfallId":"b6ee58e5-f493-4e27-9639-5599a9573387"},{"index":3681,"token":false,"name":"Rishadan Airship","scryfallId":"b3ea87f1-fbe2-4905-8a97-ceef9d3d0faf"},{"index":3682,"token":false,"name":"Hallowed Fountain","scryfallId":"f97a6d34-03ab-49f1-b02e-405b733f8843"},{"index":3683,"token":false,"name":"Harness the Storm","scryfallId":"5294d359-c599-40ed-9e06-2a3cc8624d6a"},{"index":3684,"token":false,"name":"Giant Spectacle","scryfallId":"7c425337-6f1f-494e-a7ae-7d533d7a0b4e"},{"index":3685,"token":false,"name":"Unified Front","scryfallId":"53472387-6909-462e-8183-02fd1d45126e"},{"index":3687,"token":false,"name":"Primordial Mist","scryfallId":"ebf1d150-f453-42e9-ac8c-99911d8eb498"},{"index":3688,"token":false,"name":"Rabble-Rouser","scryfallId":"c6877862-f7c5-493d-baaf-41a91d4c7982"},{"index":3690,"token":false,"name":"Verdant Sun's Avatar","scryfallId":"9dbb5b6a-dc74-4e3e-9de1-5b379abdf2b4"},{"index":3691,"token":false,"name":"Road of Return","scryfallId":"e718b21b-46d1-4844-985c-52745657b1ac"},{"index":3693,"token":true,"name":"Daniel Zink Bio","scryfallId":"a1352676-9a0e-44bc-972a-b2c26b99e529"},{"index":3694,"token":false,"name":"Suq'Ata Lancer","scryfallId":"2884d8df-7fd5-4247-9da5-38c31333ff5d"},{"index":3696,"token":false,"name":"Wanderer's Twig","scryfallId":"e5a05105-7aa2-4b50-9dc2-f8506dd50060"},{"index":3697,"token":false,"name":"Divine Offering","scryfallId":"fe7c7a65-5a96-4986-877b-b34583092bb6"},{"index":3701,"token":false,"name":"Callow Jushi // Jaraku the Interloper","scryfallId":"ca03131a-9bd4-4fba-b95c-90f1831e86e7"},{"index":3702,"token":false,"name":"Elfhame Palace","scryfallId":"fc964131-169a-44fe-9b3b-f9672781de71"},{"index":3704,"token":false,"name":"Dungrove Elder","scryfallId":"678c11d1-567e-4153-b828-a4f18fc7bd58"},{"index":3705,"token":false,"name":"Sandbar Crocodile","scryfallId":"53d668ab-8cfd-422a-9497-0158c836c2e8"},{"index":3706,"token":false,"name":"Kujar Seedsculptor","scryfallId":"a8664c65-77ca-4881-959a-e1923e1a6b98"},{"index":3708,"token":false,"name":"Howl from Beyond","scryfallId":"d954e8a7-6b22-4f53-9435-ff1f7782a3d4"},{"index":3709,"token":false,"name":"Sanctum Gargoyle","scryfallId":"1da1a2d5-d1fe-4aa2-aa83-64d6c269f7bc"},{"index":3712,"token":false,"name":"Gravebane Zombie","scryfallId":"6e16f8bc-3200-4a0a-b298-c7e7b4e8376c"},{"index":3713,"token":false,"name":"Lorescale Coatl","scryfallId":"e81c31c9-d7d7-4b45-893e-7e36d26c645f"},{"index":3714,"token":false,"name":"Prey Upon","scryfallId":"0eb1b036-0856-4cfb-ace5-2731f13696bd"},{"index":3715,"token":false,"name":"Jeweled Lotus","scryfallId":"3c7de64b-3dc8-47dd-8999-4353b5a3a06f"},{"index":3716,"token":false,"name":"Gaea's Blessing","scryfallId":"8b09be15-1674-4ce7-a3fb-acf572cc25bf"},{"index":3717,"token":true,"name":"Mowu // Mowu Token (G, 3/3)","scryfallId":"b10441dd-9029-4f95-9566-d3771ebd36bd"},{"index":3718,"token":false,"name":"Aphetto Dredging","scryfallId":"c4e7fadf-40f1-45ff-97ef-5830381accc9"},{"index":3719,"token":false,"name":"Walk the Plank","scryfallId":"a42aeec8-f3bb-484c-a7db-d6ae07966694"},{"index":3720,"token":false,"name":"Windfall","scryfallId":"bd1f6a7d-2f43-4b15-80da-b536b83a4742"},{"index":3721,"token":false,"name":"Arrogant Wurm","scryfallId":"2dd6977e-269a-4cd1-99ad-37846a0647a7"},{"index":3722,"token":false,"name":"Turnabout","scryfallId":"8497ab30-02e9-47a7-8e15-c6ae98394fb5"},{"index":3725,"token":false,"name":"Devouring Light","scryfallId":"53fcc46c-682c-4482-8422-811b951d96cf"},{"index":3726,"token":false,"name":"Undermine","scryfallId":"a23735a3-8ec8-48ae-8bd0-3b6b782690c8"},{"index":3727,"token":false,"name":"Breath of Fury","scryfallId":"a1fce58d-d754-4532-b4d0-4bb3cf108090"},{"index":3728,"token":false,"name":"Fresh Meat","scryfallId":"78bbdc81-d47f-4f0a-b359-c146cc07931d"},{"index":3730,"token":false,"name":"Flashfreeze","scryfallId":"f97aaed2-5e10-4080-b373-31f67fbac1a9"},{"index":3731,"token":false,"name":"Lady Zhurong, Warrior Queen","scryfallId":"307858f0-f8db-40b3-870b-b7e6d6833d01"},{"index":3732,"token":false,"name":"Whispersilk Cloak","scryfallId":"8d08b6b7-50dc-432d-afcc-03bbab4a03f4"},{"index":3733,"token":false,"name":"Crimson Acolyte","scryfallId":"c1718028-3009-4bdd-9f6f-59c17edd1344"},{"index":3734,"token":false,"name":"Jungle Shrine","scryfallId":"2678d0f4-cafe-4e7e-9443-6b7917af0182"},{"index":3735,"token":false,"name":"Arcbound Bruiser","scryfallId":"a4672ba6-cd82-4208-bc08-764986899999"},{"index":3736,"token":false,"name":"Granite Gargoyle","scryfallId":"e2067284-c6af-41d7-a4ac-d66a86d9346c"},{"index":3737,"token":false,"name":"Peema Aether-Seer","scryfallId":"8b0e54a3-cd9b-47bc-957c-3611993d2d05"},{"index":3741,"token":false,"name":"Simulacrum","scryfallId":"5bcda143-55f8-4d02-918f-975d9090d03f"},{"index":3743,"token":false,"name":"Camaraderie","scryfallId":"890a2fa9-1141-4a4c-85af-05723aba5e39"},{"index":3744,"token":false,"name":"Incandescent Soulstoke","scryfallId":"c8829b3c-5267-44c6-b709-c2dfc683b0a8"},{"index":3745,"token":false,"name":"Destructor Dragon","scryfallId":"a87cb2f2-00ed-46a3-a69d-5360e1558b03"},{"index":3746,"token":false,"name":"Excavated Wall","scryfallId":"fed54d00-b11f-4529-864c-63a114617b36"},{"index":3748,"token":false,"name":"Supply Runners","scryfallId":"f8c10c77-1446-4581-9587-dc2860fe78fe"},{"index":3750,"token":false,"name":"Merfolk Secretkeeper // Venture Deeper","scryfallId":"8182c9e0-861e-4736-997b-e79e62a2fec5"},{"index":3751,"token":false,"name":"Rend Spirit","scryfallId":"100f0235-a7fe-4e23-b154-3d30668a29a7"},{"index":3752,"token":false,"name":"Lingering Souls","scryfallId":"1d371239-b231-455f-a724-5025284ee023"},{"index":3753,"token":false,"name":"Symbiotic Wurm","scryfallId":"a5c748cb-6386-4479-8f4d-248cae98d2b8"},{"index":3754,"token":false,"name":"Life and Limb","scryfallId":"2721724d-92ae-4c0c-88dd-628888c468bf"},{"index":3755,"token":false,"name":"Disciple of the Ring","scryfallId":"3d344f86-a02d-4de3-82c1-2586dd9ddbfe"},{"index":3756,"token":false,"name":"Fleeting Memories","scryfallId":"4b9eaf90-2a9e-44a7-bdae-03c26f9d21e7"},{"index":3757,"token":false,"name":"Somberwald Vigilante","scryfallId":"45acf61c-0cc6-4f74-8c81-5ea4b8282e2a"},{"index":3760,"token":false,"name":"Practiced Tactics","scryfallId":"91b448f4-aa0c-42c7-a771-e8dd20e0520c"},{"index":3762,"token":false,"name":"Stirring Wildwood","scryfallId":"d556d10b-83cc-4736-b269-4ce65aae2837"},{"index":3763,"token":false,"name":"Brion Stoutarm","scryfallId":"21574f79-0a89-49c2-9ab0-d2ac7e3953ae"},{"index":3765,"token":false,"name":"Mindstab","scryfallId":"3efd28ef-77db-4e7b-a69d-5a089e016737"},{"index":3767,"token":false,"name":"Pyrewild Shaman","scryfallId":"561e7a13-6b85-456f-b074-4dc037bc14f9"},{"index":3768,"token":false,"name":"Pako, Arcane Retriever","scryfallId":"066c8f63-52e6-475e-8d27-6ee37e92fc05"},{"index":3769,"token":false,"name":"Time and Tide","scryfallId":"152b348a-0301-4d45-a2c1-d78802c445ba"},{"index":3771,"token":false,"name":"Dual Shot","scryfallId":"0bb504d2-d3de-4b09-9007-3d403fc9a216"},{"index":3772,"token":false,"name":"Kaalia, Zenith Seeker","scryfallId":"70c679a2-bddf-48ad-ad02-fd747d1df536"},{"index":3775,"token":false,"name":"Assault // Battery","scryfallId":"4a9f1e99-9de8-45cb-b035-4f920477e2e5"},{"index":3777,"token":false,"name":"The Cauldron of Eternity","scryfallId":"ab0cc8dd-b32c-4306-a542-cc97dc2aafdf"},{"index":3778,"token":false,"name":"Tablet of the Guilds","scryfallId":"6b006384-6fb6-4129-b1d2-7674d1141f8f"},{"index":3779,"token":false,"name":"Saheeli's Silverwing","scryfallId":"dba77c07-5d23-4a1a-90a0-b8293848d637"},{"index":3780,"token":false,"name":"Roast","scryfallId":"cbb23f79-60b2-4d99-a0f0-e706cb706077"},{"index":3781,"token":false,"name":"Fiery Cannonade","scryfallId":"396f1cdf-712b-4518-a0e8-0039303dccdc"},{"index":3782,"token":false,"name":"Mosswort Bridge","scryfallId":"38234590-812c-4d29-80c1-32b9e1282580"},{"index":3784,"token":false,"name":"Tangle","scryfallId":"daed0e25-fdfb-410f-81d1-f79fc9a35e3c"},{"index":3785,"token":false,"name":"Crosstown Courier","scryfallId":"d04e6d05-5ec8-4e7d-86b8-da9549dbaa5e"},{"index":3786,"token":false,"name":"Pearled Unicorn","scryfallId":"2543f1e5-e91a-4967-b623-9b5b23c3e37a"},{"index":3787,"token":false,"name":"Scarecrone","scryfallId":"a8c9d86a-54a3-457c-b9b4-61f914de6e14"},{"index":3788,"token":false,"name":"Rejuvenating Springs","scryfallId":"5888b82e-79e0-4b8e-9c16-07dddc2bfeff"},{"index":3789,"token":false,"name":"Nut Collector","scryfallId":"f4eec210-5df0-4fb8-8eb1-e616d9995acc"},{"index":3790,"token":false,"name":"Eager Cadet","scryfallId":"81a5ec5a-b490-456a-98e8-36cf4b836d2a"},{"index":3791,"token":false,"name":"Ephara's Radiance","scryfallId":"e0741582-0c7b-4d5b-83a9-dd8862de1f24"},{"index":3795,"token":false,"name":"Errand of Duty","scryfallId":"88640e95-eda3-46c9-b8cf-f7e493c7a256"},{"index":3796,"token":true,"name":"Spirit // Spirit","scryfallId":"41fc8b22-f6fe-4853-b80a-64ab70a41f1d"},{"index":3797,"token":false,"name":"Shieldmate's Blessing","scryfallId":"f58a26f8-a2c9-48e5-8662-7cbd43c00411"},{"index":3798,"token":false,"name":"Umezawa's Jitte","scryfallId":"a1d09418-de9b-42a3-b324-c04ce3012bf7"},{"index":3799,"token":false,"name":"Burrenton Forge-Tender","scryfallId":"c000c3e4-d71a-43c8-8ded-f3da54bc088d"},{"index":3801,"token":false,"name":"Sepulchral Primordial","scryfallId":"eb0865cd-d9b4-43ea-87d2-ad5c65fc0459"},{"index":3803,"token":false,"name":"Ravenous Baloth","scryfallId":"2f48df6c-8d5d-4d8a-b98a-793f6a56184d"},{"index":3804,"token":false,"name":"Seething Anger","scryfallId":"2294ef08-c27a-4bb4-bd59-434516717961"},{"index":3805,"token":false,"name":"Mogg Flunkies","scryfallId":"ed2f1b5d-1b16-4f35-9cce-2f089905fddd"},{"index":3806,"token":false,"name":"Balthor the Stout","scryfallId":"e81ecdc5-d2c7-4292-9b59-fd6bf3ba29d5"},{"index":3807,"token":false,"name":"Fugitive Wizard","scryfallId":"520ad9d0-5f41-4183-a04e-58a61ad7202b"},{"index":3810,"token":false,"name":"Creature Bond","scryfallId":"fb601439-7610-4bf7-a2f3-5fb6e9a0d82c"},{"index":3811,"token":false,"name":"Tree of Redemption","scryfallId":"e39cc3c8-79c2-4593-8340-c3285f3a4c3a"},{"index":3812,"token":false,"name":"Mardu Scout","scryfallId":"0e7891b8-ba69-4c5b-a29f-ee7bcf2374f0"},{"index":3813,"token":false,"name":"Search for Glory","scryfallId":"bd06b52f-f14d-48f1-9eb8-b17b2af4689e"},{"index":3815,"token":false,"name":"Deeproot Champion","scryfallId":"ca0a34e8-53e3-4fe4-948f-1e6f6ab436c3"},{"index":3817,"token":false,"name":"Windbrisk Heights","scryfallId":"ec7f0e60-8fa4-4eab-8465-baf4e5e8196b"},{"index":3818,"token":false,"name":"Stormblood Berserker","scryfallId":"3fc6e8a2-99fc-434a-a1c4-0f425686c54a"},{"index":3819,"token":false,"name":"Ral, Storm Conduit","scryfallId":"828289fa-6335-43c3-9d42-1c0199b9af67"},{"index":3820,"token":false,"name":"Pir, Imaginative Rascal","scryfallId":"5a7241f5-4d69-47fe-b037-95037008184c"},{"index":3821,"token":false,"name":"Resize","scryfallId":"c5dded16-e516-430e-a528-c49a483f03b4"},{"index":3823,"token":false,"name":"Skullcage","scryfallId":"9e658a5a-8d84-4225-b595-5265a0bfd996"},{"index":3824,"token":false,"name":"Sacred Wolf","scryfallId":"ff4661dd-2075-48c3-b19b-fc7f8aaba1b8"},{"index":3825,"token":false,"name":"Great Teacher's Decree","scryfallId":"7fc449dc-60c7-4b78-9a73-afa1de64a41e"},{"index":3827,"token":false,"name":"Bonds of Faith","scryfallId":"cc5dbb93-63a2-478e-b874-1fdf3a03cbff"},{"index":3828,"token":false,"name":"Selenia, Dark Angel","scryfallId":"9c1624f7-8275-46d3-ab7e-7b162e27593f"},{"index":3830,"token":false,"name":"Thopter Spy Network","scryfallId":"edee5a68-21c3-47a6-84b7-a12748760943"},{"index":3831,"token":false,"name":"Cruel Reality","scryfallId":"ee5ba8e9-869e-4f68-b668-8ef03929ff3f"},{"index":3835,"token":true,"name":"Eldrazi Scion Token (Colorless, 1/1)","scryfallId":"b999a0fe-d2d0-4367-9abb-6ce5f3764f19"},{"index":3836,"token":false,"name":"Morphling","scryfallId":"812f4d5c-aacf-4bd8-849d-80a357a7804d"},{"index":3837,"token":false,"name":"Ramos, Dragon Engine","scryfallId":"cba697aa-9f33-4048-98a6-45175c4ed95d"},{"index":3839,"token":false,"name":"Phyrexian Colossus","scryfallId":"887b377f-4080-4cfa-a5a7-bab32b6891f9"},{"index":3840,"token":false,"name":"Ryusei, the Falling Star","scryfallId":"f05861f1-f6f1-44fa-91e9-f7cfa66b38ff"},{"index":3841,"token":false,"name":"Aether Mutation","scryfallId":"a9507116-ede8-40a1-8fa3-705e6f6f64c0"},{"index":3842,"token":false,"name":"Epic Downfall","scryfallId":"63da83fe-fa59-40cb-a42e-e1b14b650bc8"},{"index":3843,"token":false,"name":"Architects of Will","scryfallId":"edd69ea7-aab6-4f30-98f4-640cb0a6046c"},{"index":3844,"token":false,"name":"Arc Lightning","scryfallId":"f4a13429-8741-478b-8b17-1a0d8a1a7d02"},{"index":3845,"token":false,"name":"Peat Bog","scryfallId":"bcc9d1e0-c8f4-4bac-90d4-8167f7a1515a"},{"index":3846,"token":false,"name":"Manic Scribe","scryfallId":"eb0fadba-4205-47ce-b4cf-e0ff7308749b"},{"index":3847,"token":false,"name":"Wizened Cenn","scryfallId":"585f1c8e-6898-4def-8e3f-d45cd263f776"},{"index":3849,"token":false,"name":"Seer's Vision","scryfallId":"0c94618a-808c-4b3c-8f34-45e64d0414d3"},{"index":3850,"token":false,"name":"Foundry Champion","scryfallId":"84e39703-db78-4d3d-aacd-5396848253ed"},{"index":3851,"token":false,"name":"Darigaaz, the Igniter","scryfallId":"54dcf5e3-4303-41a3-b54c-24a9d462ce07"},{"index":3852,"token":false,"name":"Necromantic Selection","scryfallId":"a105c396-7c69-49ff-be06-891d51d861c6"},{"index":3853,"token":false,"name":"Sever Soul","scryfallId":"b66c9ddf-b45c-4362-89db-6623b39ad1b3"},{"index":3854,"token":false,"name":"Firemind's Research","scryfallId":"cd318e8f-418a-4e17-bf0e-a4bfc0fb8ebf"},{"index":3856,"token":false,"name":"Johtull Wurm","scryfallId":"ff4f2361-2f99-41f5-b295-ca26c9eee27c"},{"index":3857,"token":false,"name":"Karador, Ghost Chieftain","scryfallId":"1026c294-76e6-48dd-bf2d-5998d5d6cdf7"},{"index":3860,"token":false,"name":"Moonlight Bargain","scryfallId":"7957c37f-96da-4b7e-9581-afdf73a85edd"},{"index":3863,"token":false,"name":"Temur Runemark","scryfallId":"ddd76874-842e-4f4c-b18e-0e441dae59d7"},{"index":3864,"token":false,"name":"Leonin Skyhunter","scryfallId":"15d6476c-1944-48e8-9af6-6db78edd58e5"},{"index":3865,"token":false,"name":"Penumbra Spider","scryfallId":"6a989ac1-df69-45e7-98bf-564cc7c38973"},{"index":3866,"token":false,"name":"Dreamwinder","scryfallId":"2ae3a000-478c-4185-a8c0-82f29942497b"},{"index":3867,"token":false,"name":"Root Sliver","scryfallId":"315f5a46-8345-4841-8161-b8bdcb00d993"},{"index":3868,"token":false,"name":"Angelic Wall","scryfallId":"6d7c9675-e663-4ad1-9271-38d5c050a7c7"},{"index":3870,"token":false,"name":"Polluted Mire","scryfallId":"23d64aa6-b677-4292-9e24-7b239f0e5065"},{"index":3871,"token":false,"name":"Fungusaur","scryfallId":"75a58f0b-c772-4254-8686-182d26889f9c"},{"index":3872,"token":false,"name":"Arboria","scryfallId":"095078b0-0f26-442f-9d3b-45e30cdb33c4"},{"index":3873,"token":false,"name":"Marrow Bats","scryfallId":"38dcbad0-267e-411f-8e99-5d90b537bf9b"},{"index":3875,"token":false,"name":"Calciform Pools","scryfallId":"297a2b09-562a-46d8-905d-0b32e854e9d2"},{"index":3877,"token":false,"name":"Sejiri Steppe","scryfallId":"668f5732-da88-4d42-9186-70cfef81f689"},{"index":3879,"token":false,"name":"Selesnya Signet","scryfallId":"3b9f23f3-de55-4aaa-bc26-380591906c89"},{"index":3881,"token":false,"name":"Raven Wings","scryfallId":"60916ebe-6d84-4873-bd91-351bbe219c57"},{"index":3883,"token":false,"name":"Chandra Ablaze","scryfallId":"43da8995-77da-4ec4-94a5-5e7932a3c969"},{"index":3884,"token":false,"name":"Sylvan Advocate","scryfallId":"7f5ac7ee-52e0-4c30-83cd-d27c29c19dbc"},{"index":3885,"token":false,"name":"Time Sieve","scryfallId":"c2e8b424-0cec-490e-a571-bd051f952adf"},{"index":3886,"token":true,"name":"Reanimated","scryfallId":"150bfd7c-fdae-468c-836b-8f63cc0aab08"},{"index":3887,"token":false,"name":"Diminishing Returns","scryfallId":"a375ec24-4841-4792-ad58-f29cdf0d1bbb"},{"index":3888,"token":true,"name":"Peer Kröger Decklist","scryfallId":"d77ca534-43c2-4624-9146-43be9f692c19"},{"index":3891,"token":false,"name":"Tendrils of Agony","scryfallId":"90d5ef43-9f62-4bb4-9d79-9dcdec83bb3d"},{"index":3892,"token":false,"name":"Scythe Leopard","scryfallId":"89ef0054-a290-4c41-846d-12f8119c52ae"},{"index":3893,"token":false,"name":"Guardian Lions","scryfallId":"3defc506-537e-4659-815d-5dab15fbf199"},{"index":3894,"token":false,"name":"Wispweaver Angel","scryfallId":"57300d02-faad-43b2-afa9-023d1c3a0901"},{"index":3895,"token":false,"name":"Sarcomite Myr","scryfallId":"77a425d3-a0b7-4d8d-8013-a27c59758b28"},{"index":3897,"token":false,"name":"Reconstruct History","scryfallId":"3e565e38-43d5-482e-a911-ce525dfee74f"},{"index":3899,"token":false,"name":"Aven Eternal","scryfallId":"fe479484-a827-4d3c-8e35-e905e4f6664a"},{"index":3900,"token":false,"name":"Leechridden Swamp","scryfallId":"3bc4c0e9-3869-45c7-8335-7276606edef0"},{"index":3901,"token":false,"name":"Skyshroud War Beast","scryfallId":"19d809c1-e674-40b8-816d-c45d77c66722"},{"index":3902,"token":false,"name":"Protect // Serve","scryfallId":"9b8acd7d-f3e2-4358-91ab-40901b68d64c"},{"index":3903,"token":false,"name":"Lifelace","scryfallId":"bf312acb-2fa6-440a-964b-424ad8abc331"},{"index":3906,"token":false,"name":"Epochrasite","scryfallId":"6d4fafc8-3466-42f7-9d8d-8c6250da7bd5"},{"index":3908,"token":false,"name":"Emmara Tandris","scryfallId":"c7c91a0a-2f14-4131-8ca7-1d0046a8edd2"},{"index":3911,"token":false,"name":"Hagra Crocodile","scryfallId":"3394a7a2-8f1a-4f07-843a-77db62de49bd"},{"index":3913,"token":false,"name":"Erratic Mutation","scryfallId":"d06d3fb1-abfa-4724-a4e7-f65de88521f8"},{"index":3914,"token":false,"name":"Stream Hopper","scryfallId":"55371d0e-29da-4517-ab16-075782a1326f"},{"index":3915,"token":false,"name":"Legion Loyalist","scryfallId":"ff93d9e3-3e27-4bd4-955b-076788519694"},{"index":3917,"token":false,"name":"Primal Beyond","scryfallId":"b4c28c1d-0ebf-4e95-8d0a-56be10cc0ef2"},{"index":3918,"token":false,"name":"Saltcrusted Steppe","scryfallId":"2adc67a6-9b05-4480-be0c-70b860075d70"},{"index":3919,"token":false,"name":"Spectral Shift","scryfallId":"b1a3f75d-9a79-4c16-8f50-43a18add4579"},{"index":3920,"token":false,"name":"Sandstorm","scryfallId":"f92e1405-33a9-4da4-a87d-91d55eaaa2d2"},{"index":3921,"token":false,"name":"Reality Hemorrhage","scryfallId":"c044168d-cb08-493d-98c1-b66b6149fe5a"},{"index":3922,"token":false,"name":"Simic Signet","scryfallId":"4cb9a0b9-ddc8-4cdc-b352-0289c66f6fed"},{"index":3923,"token":false,"name":"Alaborn Cavalier","scryfallId":"8877b120-55ee-4e5a-9f51-e72a110f638e"},{"index":3924,"token":false,"name":"Ancient Excavation","scryfallId":"36cae0db-d56f-4bd1-b897-3ac54e307363"},{"index":3925,"token":false,"name":"Cloudchaser Eagle","scryfallId":"a48a0cef-701e-46eb-90de-5dfe85c59014"},{"index":3926,"token":false,"name":"Waterfront Bouncer","scryfallId":"e86415a6-fd4c-4f04-ab0f-685ef062245a"},{"index":3928,"token":false,"name":"Sisay's Ingenuity","scryfallId":"bbe20cc1-621a-4813-9bbb-ace006e173ff"},{"index":3929,"token":false,"name":"Visara the Dreadful","scryfallId":"77d17aa7-bdd4-4ae0-b791-9deadd32273f"},{"index":3930,"token":false,"name":"Warden of the Woods","scryfallId":"f1d81cfc-cff8-4478-92b6-efbfc5084165"},{"index":3931,"token":false,"name":"Crown-Hunter Hireling","scryfallId":"0babeae3-79fe-4d04-b496-e3dc7fa2ad60"},{"index":3932,"token":false,"name":"Cultivate","scryfallId":"faf2ef91-fb95-4cc0-a2a6-53fac5cd807d"},{"index":3935,"token":false,"name":"Mage's Guile","scryfallId":"301cb538-a931-4916-927b-4986046b1158"},{"index":3937,"token":false,"name":"The Mimeoplasm","scryfallId":"96bddc7e-6dab-4ea8-a474-ed9b28ff1457"},{"index":3938,"token":false,"name":"Kobold Drill Sergeant","scryfallId":"2e918e64-66dd-4037-ba1a-1c569a9907f7"},{"index":3939,"token":false,"name":"Rally the Ranks","scryfallId":"b661481d-62cc-4c00-a53f-1cee380d9d75"},{"index":3940,"token":false,"name":"Sworn Guardian","scryfallId":"6452ba94-6bb0-409c-99f7-71e6457c3f2a"},{"index":3941,"token":false,"name":"Vesuvan Doppelganger","scryfallId":"408ec348-183b-43de-abac-7ae9e3843c10"},{"index":3942,"token":false,"name":"Crown of Flames","scryfallId":"5a46239c-3de7-48ca-8f5c-b51f307fd0e5"},{"index":3943,"token":false,"name":"Mage Duel","scryfallId":"92325638-0321-4409-8910-2287c64c182e"},{"index":3944,"token":false,"name":"Aysen Bureaucrats","scryfallId":"b01c564f-d997-4667-93af-c8495d8764e6"},{"index":3945,"token":false,"name":"Nightscape Familiar","scryfallId":"cf0ac499-c72a-4b9b-b028-ec498d4984fd"},{"index":3946,"token":false,"name":"Hypnotic Specter","scryfallId":"55d3b95a-2103-4145-9820-e55e3d86c682"},{"index":3947,"token":false,"name":"Drifting Meadow","scryfallId":"bd6aef10-22c9-48de-b67f-32aff932cfea"},{"index":3948,"token":false,"name":"Ignite Disorder","scryfallId":"e38419d9-e321-4642-aad4-99c5489f8fa8"},{"index":3949,"token":false,"name":"Hollowborn Barghest","scryfallId":"544fba3c-0db4-4ac3-ac70-ae9a5468ab5d"},{"index":3950,"token":false,"name":"Moss Viper","scryfallId":"a4d35ec4-0e0d-4611-8ad9-39d2c8a2ad6e"},{"index":3952,"token":false,"name":"Psychic Overload","scryfallId":"b32d0779-ef2a-42be-ad67-cee9b06122de"},{"index":3954,"token":false,"name":"Biogenic Upgrade","scryfallId":"0dd73fb2-453f-40b9-8beb-dfa99e6a706e"},{"index":3955,"token":false,"name":"Electrolyze","scryfallId":"521a1843-e604-4954-be21-38b31867f670"},{"index":3956,"token":false,"name":"Volunteer Militia","scryfallId":"de307b2e-9a1c-4f95-887f-14c9d99577aa"},{"index":3958,"token":false,"name":"Voidmage Apprentice","scryfallId":"55924a25-e749-48f6-8ef1-1fa8376f96b1"},{"index":3959,"token":false,"name":"Primeval Force","scryfallId":"70a4e884-b36c-4fde-84bb-a19a3ce160ae"},{"index":3960,"token":false,"name":"Kynaios and Tiro of Meletis","scryfallId":"97fa8615-2b6c-445a-bcaf-44a7e847bf65"},{"index":3961,"token":false,"name":"Rathi Intimidator","scryfallId":"6fc59fa5-144f-49e6-b6bd-2ba6d3f2eff2"},{"index":3962,"token":false,"name":"Trumpet Blast","scryfallId":"89a3e069-856a-4fe7-9357-56697fb665fc"},{"index":3963,"token":false,"name":"Whetstone","scryfallId":"627805a0-535f-4cba-8176-a4de290b9c15"},{"index":3964,"token":false,"name":"Devout Lightcaster","scryfallId":"16e31e43-84d3-429e-9e81-60b325989c93"},{"index":3965,"token":false,"name":"Gather the Townsfolk","scryfallId":"76f66ee8-8289-4780-aaec-feabd8ea9e3d"},{"index":3966,"token":false,"name":"Echoing Truth","scryfallId":"8c426c11-0c9c-476f-9547-fd61eecab4db"},{"index":3967,"token":false,"name":"Kjeldoran Skycaptain","scryfallId":"dc368160-aa0b-4814-8c35-00314e023963"},{"index":3969,"token":false,"name":"Bonecrusher Giant // Stomp","scryfallId":"87df5566-84e6-4517-9448-96f22525bcea"},{"index":3971,"token":false,"name":"Obsidian Battle-Axe","scryfallId":"c7978371-9ea8-4264-9a2f-38226ea25018"},{"index":3974,"token":false,"name":"Kefnet the Mindful","scryfallId":"6c5235a8-578a-48be-9967-79b42bcc8388"},{"index":3975,"token":false,"name":"Thopter Squadron","scryfallId":"5fd13ac2-9642-4d59-a5c6-cc13c86991f0"},{"index":3976,"token":false,"name":"Erebos's Titan","scryfallId":"f5972911-2d41-4a0c-8a8f-b3d35a6594d8"},{"index":3978,"token":false,"name":"Grim Lavamancer","scryfallId":"00c1c7c9-ca58-465a-9001-05e1c7baa51a"},{"index":3981,"token":false,"name":"Cut the Tethers","scryfallId":"4ff18307-9ef8-4e3a-89e9-cb8c04997222"},{"index":3982,"token":false,"name":"Nantuko Monastery","scryfallId":"aa0412da-ad2a-4895-bceb-c7938c2ae929"},{"index":3983,"token":false,"name":"Curator of Mysteries","scryfallId":"875a775c-2c90-4944-9b1c-643b1dc38b65"},{"index":3984,"token":false,"name":"Prison Term","scryfallId":"2158a10d-12f8-46be-9042-c631904b425a"},{"index":3985,"token":false,"name":"Voice of Many","scryfallId":"fccfa714-7fa0-4846-88c9-570f13683aa4"},{"index":3986,"token":false,"name":"Harbor Bandit","scryfallId":"8422e109-de8d-46ea-a7f8-d5ccb6340497"},{"index":3988,"token":false,"name":"Initiates of the Ebon Hand","scryfallId":"5be87527-3b8f-4529-afdb-a61ad4e787e1"},{"index":3989,"token":false,"name":"Orzhov Guildgate","scryfallId":"27c6f99a-4a1a-44a3-bc41-507aa7b62e1c"},{"index":3990,"token":false,"name":"Garruk, Apex Predator","scryfallId":"543515aa-4b8c-437c-89aa-56dd57a4a6d5"},{"index":3991,"token":false,"name":"Star of Extinction","scryfallId":"fdcd1f4a-100e-4d7b-9632-91410f4e65b9"},{"index":3992,"token":false,"name":"Saltblast","scryfallId":"edd1833d-64b0-4c9b-8f6b-1cf15c29d473"},{"index":3993,"token":true,"name":"Svend Geertsen Bio","scryfallId":"0760ec21-0efc-4585-8aca-778e3d9fae68"},{"index":3994,"token":false,"name":"Magus of the Will","scryfallId":"24c41068-59d8-4ef4-aae4-a93b0a9ee19e"},{"index":3996,"token":false,"name":"Wild Growth","scryfallId":"ac714416-60ec-477d-b49f-83b3853a409f"},{"index":3997,"token":false,"name":"Scholarship Sponsor","scryfallId":"8fe7b44e-c47c-4180-b255-171f7dea2607"},{"index":3998,"token":false,"name":"Rolling Earthquake","scryfallId":"d1392e68-fe1e-400f-9412-9ae11079b08c"},{"index":3999,"token":false,"name":"Vorinclex, Monstrous Raider","scryfallId":"dd4b4019-b73d-4be3-991e-2deb811ee675"},{"index":4000,"token":false,"name":"Nezumi Shortfang // Stabwhisker the Odious","scryfallId":"84b1a2d9-9b48-4eeb-8971-b1ebe1b0e0cb"},{"index":4001,"token":false,"name":"Fortify","scryfallId":"1eff4028-d4f9-4822-81d6-9f5e5e6f3011"},{"index":4003,"token":false,"name":"Red Elemental Blast","scryfallId":"5bd3480f-4428-4040-bd01-2d33425814ab"},{"index":4004,"token":false,"name":"Sylvan Library","scryfallId":"b1b337de-4c43-45b6-a0ca-262a983f3589"},{"index":4005,"token":false,"name":"Vraska, Relic Seeker","scryfallId":"08d9fdda-c665-4e9a-9e9e-d9fec6f275b8"},{"index":4007,"token":false,"name":"Become Immense","scryfallId":"96e32a8c-6f5b-40e3-ab24-8296275df295"},{"index":4011,"token":false,"name":"Oath of Kaya","scryfallId":"4565b563-fc89-425a-b0f8-9384746e4f3e"},{"index":4016,"token":false,"name":"Foundry Street Denizen","scryfallId":"7008624f-ddff-4714-a73e-aa96df7f567a"},{"index":4018,"token":false,"name":"Inferno Jet","scryfallId":"0c6a43fe-369d-4943-a825-570eb3cceba4"},{"index":4019,"token":false,"name":"Abyssal Specter","scryfallId":"15beb937-dc3a-4b3a-8d33-5a74fa9addeb"},{"index":4021,"token":false,"name":"Giver of Runes","scryfallId":"4e117771-5a8b-4812-b487-32ba34b7f724"},{"index":4025,"token":false,"name":"Fledgling Mawcor","scryfallId":"4a34ed67-0878-444f-9cfd-76d36cf23a6a"},{"index":4026,"token":false,"name":"Wall of Diffusion","scryfallId":"48f627f9-4d7e-41fe-b6ad-fb229802d4e0"},{"index":4028,"token":false,"name":"Wild Elephant","scryfallId":"7809131c-747c-4c33-a3ca-13e573a92b66"},{"index":4029,"token":false,"name":"Selfless Glyphweaver // Deadly Vanity","scryfallId":"7de65f62-a768-4196-b114-0100d5d28f22"},{"index":4031,"token":false,"name":"Arena of the Ancients","scryfallId":"9337996e-a119-4529-b422-f6d286c78e3f"},{"index":4032,"token":false,"name":"Mangara, the Diplomat","scryfallId":"011cfa46-6827-4418-881b-686eb34e06ce"},{"index":4034,"token":false,"name":"Quicksmith Rebel","scryfallId":"54b8a03a-de93-43ed-b90d-7d168a21801a"},{"index":4035,"token":false,"name":"Thriving Bluff","scryfallId":"15481459-3703-4185-ad27-105d95691e9d"},{"index":4036,"token":false,"name":"Collected Company","scryfallId":"cfa7b456-7e83-4587-a875-9b35fde318c2"},{"index":4037,"token":true,"name":"Dwarf Berserker Token (R, 2/1)","scryfallId":"142bbbe1-4446-4d80-b82d-0df8ef17eac1"},{"index":4039,"token":false,"name":"Angel of Despair","scryfallId":"9ae71424-df9c-481c-9305-a0c30adcfda2"},{"index":4040,"token":false,"name":"Talisman of Progress","scryfallId":"e95e5d23-e71c-4dbd-b428-422302ce6440"},{"index":4041,"token":false,"name":"Titanium Golem","scryfallId":"8defd53c-3792-4ed3-aee9-cffda2b8a8b6"},{"index":4043,"token":true,"name":"Thopter Token (Colorless, 1/1)","scryfallId":"d0044cd9-2136-423e-aa2a-829e8f007535"},{"index":4045,"token":false,"name":"Elgaud Shieldmate","scryfallId":"e7d376ef-c900-4abb-9a0b-5eb9369f5739"},{"index":4046,"token":false,"name":"Kozilek's Predator","scryfallId":"4ab37d0e-5542-4ae0-a48e-d0a4e6bf48e7"},{"index":4048,"token":false,"name":"Glacial Fortress","scryfallId":"bc9d29ee-1a21-4c3e-99c1-f815d40e8f19"},{"index":4049,"token":true,"name":"Hydra Token (G, */*)","scryfallId":"75961f7c-fc3b-49c6-96cc-c42d2aa1a044"},{"index":4050,"token":false,"name":"Revealing Wind","scryfallId":"36bdd624-e412-4ec8-9929-e1f6b4720e82"},{"index":4051,"token":false,"name":"Force of Nature","scryfallId":"29dfaa49-013b-4760-ba1c-48f6b5a10393"},{"index":4053,"token":false,"name":"Feast of Worms","scryfallId":"33119e6a-d69b-4039-add2-97fe35a89e8e"},{"index":4054,"token":false,"name":"Dimir Keyrune","scryfallId":"20f79f1a-690f-4ec1-86b8-49aa7ae8ff08"},{"index":4055,"token":false,"name":"Masticore","scryfallId":"a1052d7d-374d-45c3-91d1-ffa38d2e5088"},{"index":4057,"token":false,"name":"Abuna Acolyte","scryfallId":"9e17bbf7-00c0-46f2-9718-2762fd7388d3"},{"index":4058,"token":false,"name":"The Lady of the Mountain","scryfallId":"70802e74-c292-446f-aa9a-dd32454a4b3d"},{"index":4059,"token":false,"name":"Helm of the Ghastlord","scryfallId":"653dd5b7-1ad3-4df1-bd2a-4e6ae362a8a2"},{"index":4060,"token":false,"name":"Epic Struggle","scryfallId":"968ed97c-86e8-46aa-b24c-b85183566a34"},{"index":4061,"token":false,"name":"Impelled Giant","scryfallId":"78f26c8b-2767-430d-a7b9-1dbb61a0993e"},{"index":4062,"token":false,"name":"Vraska's Stoneglare","scryfallId":"27fc4db6-a5f5-4254-ae64-c8eaf2c98030"},{"index":4063,"token":false,"name":"Obeka, Brute Chronologist","scryfallId":"afa7030c-e3b8-4ea1-b245-60432ca6e303"},{"index":4064,"token":false,"name":"Rishkar's Expertise","scryfallId":"af250087-50e2-44f1-b1b3-d6a9c26c034e"},{"index":4065,"token":false,"name":"Immobilizing Ink","scryfallId":"ee6e2d96-dd9e-45f6-b412-78562f2ada40"},{"index":4066,"token":false,"name":"Enthralling Victor","scryfallId":"623fbebb-a43a-487b-a8f6-57781e5d5199"},{"index":4067,"token":false,"name":"Power Leak","scryfallId":"436fd628-c545-4cbf-8100-4e6aa8475868"},{"index":4069,"token":false,"name":"Duskhunter Bat","scryfallId":"3438edfe-479d-4595-a694-5848f07156d6"},{"index":4070,"token":false,"name":"Unburden","scryfallId":"30d81da3-dc88-4cf7-ab9a-c8ade2cfa0e1"},{"index":4071,"token":false,"name":"Adarkar Wastes","scryfallId":"f31cf014-7ac9-428b-9ce9-8ba5ebfdd252"},{"index":4074,"token":false,"name":"Daru Lancer","scryfallId":"cd888ca8-0ebe-46f0-9317-3b193ccc43fb"},{"index":4076,"token":false,"name":"Fires of Yavimaya","scryfallId":"fceb13d0-a2c3-4fe0-b8ef-20926a31b2d7"},{"index":4077,"token":false,"name":"Orchard Warden","scryfallId":"7a4e2c5c-26ad-4b13-934b-e545038b6729"},{"index":4078,"token":false,"name":"Divine Visitation","scryfallId":"da3789d4-3621-44a1-bb72-8e3bbac8bf72"},{"index":4079,"token":false,"name":"Druid of the Cowl","scryfallId":"9b65e001-e84c-4fbd-9138-d5c4bc337e0d"},{"index":4080,"token":false,"name":"Gravebreaker Lamia","scryfallId":"408a2073-d068-44bc-b596-5a3a3a446ee1"},{"index":4081,"token":false,"name":"Flailing Drake","scryfallId":"43d246ac-1ca5-4c55-856c-4a83a4d638ab"},{"index":4083,"token":false,"name":"Triskelavus","scryfallId":"899eb19e-9932-4066-9de6-dfdbbab5e769"},{"index":4085,"token":false,"name":"Loafing Giant","scryfallId":"fab5f738-04d0-44c9-88ec-28469b668040"},{"index":4086,"token":false,"name":"Jadzi, Oracle of Arcavios // Journey to the Oracle","scryfallId":"b0a96416-9ee5-4202-a99f-e09db8794567"},{"index":4087,"token":false,"name":"Terashi's Grasp","scryfallId":"44f0d818-b463-4ef7-93b4-1ae341b52e2c"},{"index":4088,"token":false,"name":"Hand of Justice","scryfallId":"7f371a5d-0e79-46d9-ae6c-a9eada48cd55"},{"index":4089,"token":false,"name":"Knight of Sorrows","scryfallId":"4f35e4c3-3461-4f53-a081-393057d509aa"},{"index":4090,"token":false,"name":"Soulbound Guardians","scryfallId":"62e8128f-9858-4c48-ab43-1beca3db70e5"},{"index":4093,"token":false,"name":"Peer into the Abyss","scryfallId":"dc5b1db0-1328-4693-a480-c8783c5a60ae"},{"index":4094,"token":false,"name":"Capture of Jingzhou","scryfallId":"f639b8b9-0439-407c-9ed6-764ba96aec4e"},{"index":4096,"token":false,"name":"Sylvok Replica","scryfallId":"7caa3ce3-15a9-40ca-ad45-baff0f276483"},{"index":4098,"token":false,"name":"Aerie Mystics","scryfallId":"58e86a42-cc53-4731-819a-e76f203a742a"},{"index":4099,"token":false,"name":"Breya's Apprentice","scryfallId":"c32b5b2e-dabf-4672-b476-4873781f636e"},{"index":4100,"token":false,"name":"Baleful Mastery","scryfallId":"03f0f6ef-89fe-4969-a15b-30158133ff82"},{"index":4101,"token":false,"name":"Serra Inquisitors","scryfallId":"f1fbe3c8-92fb-41b9-b778-726d22c63054"},{"index":4103,"token":false,"name":"Famine","scryfallId":"8d6c10ca-f6d6-4322-aa17-7e874cb10bb1"},{"index":4104,"token":false,"name":"Armillary Sphere","scryfallId":"0c1afa73-cd98-4a4c-b9fe-3a84d4e7aeda"},{"index":4105,"token":false,"name":"Reckless One","scryfallId":"19617614-2ef4-4a13-9b4a-af842594d336"},{"index":4106,"token":false,"name":"Pensive Minotaur","scryfallId":"902b462a-a552-42d4-91f0-bd33cd9cb719"},{"index":4110,"token":false,"name":"Mistwalker","scryfallId":"92f64b49-327c-473b-a492-f020a322aed7"},{"index":4111,"token":false,"name":"Elephant Guide","scryfallId":"95a191bb-85c1-4287-a5ef-93d48f0b9a3d"},{"index":4113,"token":false,"name":"Yidaro, Wandering Monster","scryfallId":"9679442a-ecd4-4220-aae4-01b95dc18486"},{"index":4117,"token":false,"name":"Tainted Pact","scryfallId":"c513f51b-a0db-4c08-8acc-1e91060b93b7"},{"index":4118,"token":false,"name":"Overflowing Insight","scryfallId":"f6b3dd8f-902e-45b8-a422-370705621294"},{"index":4119,"token":false,"name":"Dream Thrush","scryfallId":"258217df-ae88-4d93-895a-3fd242baacd1"},{"index":4120,"token":false,"name":"Compulsion","scryfallId":"e21803d8-b862-430c-9a21-df262f8a6678"},{"index":4122,"token":false,"name":"Diabolic Edict","scryfallId":"6b4992d2-8664-4179-a3f3-bfb2166484dd"},{"index":4123,"token":false,"name":"Screeching Buzzard","scryfallId":"ab285e6a-b937-4b34-ba20-662d36b9f3dc"},{"index":4124,"token":false,"name":"Inspired Ultimatum","scryfallId":"c4e96967-d694-4c26-8e10-d904e1e64c09"},{"index":4126,"token":false,"name":"Prying Eyes","scryfallId":"eb58d7ba-ba86-433e-8f1e-3f492c380796"},{"index":4127,"token":false,"name":"Artful Takedown","scryfallId":"4c9e8f24-af62-4d13-bfed-a8b3294b64c3"},{"index":4128,"token":false,"name":"Falkenrath Aristocrat","scryfallId":"57ac7f19-bf6f-4a87-ad39-6eb2553d2202"},{"index":4129,"token":false,"name":"Aven Trailblazer","scryfallId":"cb032cd3-96a4-4cef-bb89-0843f2ed8189"},{"index":4130,"token":false,"name":"Paladin of the Bloodstained","scryfallId":"5a0385d5-d0f4-40b8-af28-6557ffdfb625"},{"index":4132,"token":false,"name":"Planar Collapse","scryfallId":"ee22cf3c-51b0-4790-ab13-985cbe900c3b"},{"index":4134,"token":false,"name":"Taste of Paradise","scryfallId":"a774c426-ec0e-48de-b00f-5a05cc6dc34b"},{"index":4135,"token":false,"name":"Dovin, Hand of Control","scryfallId":"cf4ffbff-8923-499c-811d-143191ac87af"},{"index":4136,"token":false,"name":"Moldervine Cloak","scryfallId":"d771cf62-b454-4c7f-918e-68335e695702"},{"index":4137,"token":false,"name":"Reclamation Sage","scryfallId":"c5a306f0-87a5-417b-9f92-18d22a8ec7d7"},{"index":4138,"token":false,"name":"Golgari Grave-Troll","scryfallId":"f61b50e6-2166-435d-bf48-c4a0cff9999c"},{"index":4139,"token":false,"name":"Wall of Bone","scryfallId":"588f455f-75e4-4f87-8487-5d3d73298618"},{"index":4140,"token":false,"name":"Ashnod's Transmogrant","scryfallId":"f790fd2d-a325-43a5-a46a-86e3b91ec8db"},{"index":4142,"token":false,"name":"Sphere of Resistance","scryfallId":"17f4d2a5-bb85-4662-b2dd-a363ec7eab9b"},{"index":4144,"token":false,"name":"Gift of Immortality","scryfallId":"2336faaa-fc6d-4fbb-bdd4-969eae565c72"},{"index":4145,"token":false,"name":"Abu Ja'far","scryfallId":"d74359cb-2a56-4344-9785-ce7cc9f387ad"},{"index":4146,"token":false,"name":"Cloudreader Sphinx","scryfallId":"2afaeec0-9ea3-4aec-9876-8e005e787d71"},{"index":4147,"token":false,"name":"Second Sunrise","scryfallId":"4e50ee7c-f2a2-4d49-a1cc-8233fd8dd0c5"},{"index":4148,"token":false,"name":"Painful Truths","scryfallId":"79290aa2-0c52-45fb-80d7-1206bf20ab18"},{"index":4149,"token":false,"name":"Nacatl Hunt-Pride","scryfallId":"a1214688-084e-4a6a-928e-9434d594725a"},{"index":4150,"token":false,"name":"Akron Legionnaire","scryfallId":"5d074af2-8dbd-42d3-87eb-30f6e7d171ff"},{"index":4152,"token":false,"name":"Lumengrid Augur","scryfallId":"65704c0f-cc97-490e-a0f7-fab9a18e1e88"},{"index":4154,"token":false,"name":"Dust to Dust","scryfallId":"ade075fd-73ee-4d12-a2da-48e5938043af"},{"index":4155,"token":false,"name":"Necrogen Mists","scryfallId":"18291514-9ffb-4032-9c77-cec0200bf1b6"},{"index":4156,"token":false,"name":"Ice Over","scryfallId":"c01d2835-060c-4ac3-b586-84811878a64d"},{"index":4157,"token":false,"name":"Minds Aglow","scryfallId":"4e2c50ba-ea58-4bb0-8ea9-3f8c37cf49f6"},{"index":4159,"token":false,"name":"Kitesail","scryfallId":"4bf0479c-4d90-4b81-8170-a42100f91d89"},{"index":4160,"token":false,"name":"Haunted Angel","scryfallId":"78d2d11b-12e4-4810-a32d-8f1cdda3ec49"},{"index":4161,"token":false,"name":"Reverse Damage","scryfallId":"5f938c52-c7f6-41a4-b480-632b43b60b67"},{"index":4162,"token":false,"name":"Status // Statue","scryfallId":"44614c6d-5508-4077-b825-66d5d684086c"},{"index":4163,"token":false,"name":"Lightning Blow","scryfallId":"d1a4ed99-f38c-4e0f-9ff2-2e1e9126e6ef"},{"index":4164,"token":false,"name":"Blue Ward","scryfallId":"9b79eaa0-8a15-4828-9ab7-16c2aab5f19f"},{"index":4166,"token":false,"name":"Lightning Storm","scryfallId":"71b2046a-62a6-453b-8ee5-982ddec3b18f"},{"index":4167,"token":false,"name":"Mortician Beetle","scryfallId":"a19ee3e4-5f76-4c28-bee6-f1c063ec0cb3"},{"index":4168,"token":false,"name":"Aven Gagglemaster","scryfallId":"c5b57247-81cc-44ec-b5a9-0702111a98a8"},{"index":4170,"token":false,"name":"Outlaws' Merriment","scryfallId":"7ed44b99-c0f3-4bb0-b08b-6d6c24f7fa4a"},{"index":4171,"token":false,"name":"Ogre Arsonist","scryfallId":"474f4537-905d-44f2-bc69-1e94c6727ad1"},{"index":4172,"token":false,"name":"Lookout's Dispersal","scryfallId":"f5751a3c-7695-4c47-9cbd-92fd5b1b7ec9"},{"index":4173,"token":false,"name":"Questing Beast","scryfallId":"e41cf82d-3213-47ce-a015-6e51a8b07e4f"},{"index":4174,"token":false,"name":"Elvish Rejuvenator","scryfallId":"27e4eef3-06a4-4d48-85f3-88fb33e9122a"},{"index":4175,"token":false,"name":"Genju of the Realm","scryfallId":"e9eb7b9b-5189-4d20-8dec-e9d3df63e26e"},{"index":4177,"token":false,"name":"Harald, King of Skemfar","scryfallId":"8fc37772-7052-46a9-a34e-f982331595a3"},{"index":4182,"token":false,"name":"Silverchase Fox","scryfallId":"e87d38e7-cb88-4a1e-927b-7646f8c33960"},{"index":4184,"token":false,"name":"Siegehorn Ceratops","scryfallId":"b70c0b83-47f9-4f29-93a9-61d616534452"},{"index":4185,"token":false,"name":"Impact Tremors","scryfallId":"ba1ebfa2-7e23-48a3-a9bc-59a24a2c1ed7"},{"index":4186,"token":false,"name":"Norn's Annex","scryfallId":"a64073f2-99f5-4dc7-9403-e7cb94ce0e60"},{"index":4188,"token":false,"name":"Branchsnap Lorian","scryfallId":"52118ff1-ad76-4b97-9fdc-6adfe80140f8"},{"index":4189,"token":false,"name":"Static Orb","scryfallId":"86bf43b1-8d4e-4759-bb2d-0b2e03ba7012"},{"index":4191,"token":false,"name":"Fearless Halberdier","scryfallId":"ef9351dc-9af0-48d1-9012-7c478fdc34e1"},{"index":4194,"token":false,"name":"Khalni Garden","scryfallId":"55d17634-db36-47e3-855f-7c3a8419cce7"},{"index":4195,"token":false,"name":"Red Ward","scryfallId":"f8bef21c-33f9-4182-838d-819ca742484a"},{"index":4196,"token":false,"name":"Sosuke, Son of Seshiro","scryfallId":"c6f244dc-5361-4a89-8278-8b15e413c72e"},{"index":4199,"token":false,"name":"Thief of Blood","scryfallId":"6df10f38-6658-49ea-b996-45b33c02bd57"},{"index":4200,"token":false,"name":"Wirewood Pride","scryfallId":"afb3cf5b-2ce4-4439-ae63-ac650f881448"},{"index":4201,"token":false,"name":"Malfunction","scryfallId":"3ca7f2ff-5bca-4579-b0b3-ba7a33ab63db"},{"index":4203,"token":false,"name":"Ashcoat Bear","scryfallId":"9b7a6ab5-8a8f-492c-8484-3089354ce8cf"},{"index":4204,"token":false,"name":"Burr Grafter","scryfallId":"935e52a1-a651-4d88-99a8-7de074a01576"},{"index":4205,"token":false,"name":"Queen Marchesa","scryfallId":"4d35f19a-6afe-4c99-baa3-39ad7f48d580"},{"index":4207,"token":false,"name":"Sickle Dancer","scryfallId":"2c0c1f54-3868-4009-b0eb-de787cd7e5cc"},{"index":4208,"token":false,"name":"Dragon Breath","scryfallId":"0900c3b6-cf56-4089-a1e3-c1f53edcf23a"},{"index":4209,"token":false,"name":"Wayward Soul","scryfallId":"28f96d5d-1d16-40bb-aaa7-8a7dd465d37b"},{"index":4210,"token":false,"name":"Unblinking Bleb","scryfallId":"06111178-685d-4bda-8325-1db142d5801c"},{"index":4211,"token":false,"name":"Goblin Tunneler","scryfallId":"a3a55db6-d501-4d15-910a-1bd98df2ad0d"},{"index":4213,"token":false,"name":"Knight-Captain of Eos","scryfallId":"02ef25ce-4d6a-45ff-8b6b-fd5c29307099"},{"index":4214,"token":false,"name":"Kitsune Bonesetter","scryfallId":"a94c12e0-8eb1-43f9-a421-43ca9bcffb0e"},{"index":4216,"token":false,"name":"Nefarious Lich","scryfallId":"d90f5a4e-8c3a-4803-bb59-d3d7c23761db"},{"index":4217,"token":true,"name":"Under the Sea","scryfallId":"e9aa78fd-d16a-4238-828e-c2a2e5b4be9d"},{"index":4218,"token":false,"name":"Timely Reinforcements","scryfallId":"79f88e0f-9639-4ade-9c9f-34cbe335b96c"},{"index":4219,"token":false,"name":"Wurmcoil Engine","scryfallId":"4ab5195f-7cc3-4972-92f8-1b26fa3fb927"},{"index":4220,"token":false,"name":"Lavamancer's Skill","scryfallId":"0d4dd156-a2c1-4fab-b9f4-3302a4e8835a"},{"index":4222,"token":true,"name":"Elemental Token (G/W, */*)","scryfallId":"8676704a-419e-4a00-a052-bca2ad34ecae"},{"index":4224,"token":false,"name":"Scourge of the Throne","scryfallId":"5c594486-e4cf-4c32-8a6f-d70613c06d02"},{"index":4227,"token":false,"name":"Daggerclaw Imp","scryfallId":"b3212559-0af0-4d07-9be1-badabfc5231f"},{"index":4228,"token":false,"name":"Cloudcrown Oak","scryfallId":"833211c0-3bec-4548-97a0-c9381660cd88"},{"index":4229,"token":false,"name":"Nissa, Vastwood Seer // Nissa, Sage Animist","scryfallId":"8c40a7db-12f2-41bc-9025-d243208e8d70"},{"index":4230,"token":false,"name":"Anya, Merciless Angel","scryfallId":"04aacbf3-c78f-4caf-829d-0bd96be10ae9"},{"index":4231,"token":false,"name":"Bronze Bombshell","scryfallId":"0f2ec20d-b862-4f13-989c-aa88efa51cdf"},{"index":4232,"token":false,"name":"Temple of Deceit","scryfallId":"e3d4fd29-dab5-481f-94c9-eeb70f3c29dd"},{"index":4233,"token":false,"name":"Temur Battle Rage","scryfallId":"d344f38d-0ef2-434b-914c-934c639e7e18"},{"index":4234,"token":false,"name":"Dry Spell","scryfallId":"997ea663-40a1-49b7-80f1-2e1febc1b6fa"},{"index":4236,"token":false,"name":"Highland Giant","scryfallId":"32f49716-1522-4f36-92c9-63ef2059c4ef"},{"index":4237,"token":false,"name":"Dawn of Hope","scryfallId":"cf2a9e82-8670-4b7f-b5f0-8e10f8aeff1c"},{"index":4239,"token":false,"name":"Sea Monster","scryfallId":"2cecf934-d1fe-424f-932a-043908546157"},{"index":4240,"token":false,"name":"The Immortal Sun","scryfallId":"8a57f003-d162-4ea7-880c-328413235fd4"},{"index":4241,"token":false,"name":"Pay No Heed","scryfallId":"3bb836f0-527d-445b-877e-7158a4579c33"},{"index":4243,"token":false,"name":"Elvish Soultiller","scryfallId":"9e2c8de5-bc80-4fad-af09-6d0a639f6e18"},{"index":4244,"token":false,"name":"Thieving Magpie","scryfallId":"68ad3cfe-5bae-4eb7-81a3-744315093ae1"},{"index":4245,"token":false,"name":"Mishra's Helix","scryfallId":"0ffc556f-d8f5-422e-b3f7-bc01f7fd4d9d"},{"index":4246,"token":false,"name":"Insidious Dreams","scryfallId":"e8a29622-23a6-42c7-8e56-690613572c94"},{"index":4247,"token":false,"name":"Inexorable Tide","scryfallId":"40441345-23ca-47e4-b349-bd13d986e41e"},{"index":4248,"token":false,"name":"Helm of Awakening","scryfallId":"41bba882-39b8-42db-9a01-54c6712b8019"},{"index":4249,"token":false,"name":"Ivory Giant","scryfallId":"c1b1b580-4a2c-41a4-a1e0-85b659b3a30e"},{"index":4250,"token":false,"name":"Segovian Leviathan","scryfallId":"22e6e890-d1d0-4a9b-a453-5b51974a9dff"},{"index":4251,"token":false,"name":"Angel of Finality","scryfallId":"bd3c34c9-2072-4ebb-93ef-34173015bfb8"},{"index":4252,"token":false,"name":"Hammer of Bogardan","scryfallId":"06f02542-142b-4de3-988e-bc562b077cc5"},{"index":4253,"token":false,"name":"Self-Assembler","scryfallId":"86527a1f-d9a6-403e-b42d-89de84653e9b"},{"index":4254,"token":false,"name":"Foe-Razer Regent","scryfallId":"04a266c3-de47-4e94-bdc4-210e34981de3"},{"index":4255,"token":false,"name":"Tarnished Citadel","scryfallId":"30375d24-ccfe-47a2-babd-1bda0a6298fe"},{"index":4256,"token":false,"name":"Flamerush Rider","scryfallId":"c074adc3-50f1-4443-ae9b-47f8d9fdf3a2"},{"index":4258,"token":false,"name":"Balefire Liege","scryfallId":"81c9142f-bcd9-4cb1-9df8-dde0e6c78903"},{"index":4259,"token":false,"name":"Gurmag Swiftwing","scryfallId":"a7492918-b3c6-468f-9484-d73f0a27b37b"},{"index":4260,"token":false,"name":"Idol of Endurance","scryfallId":"b7bbaf25-fea1-42a4-a650-976481ef3d83"},{"index":4262,"token":false,"name":"Flamewave Invoker","scryfallId":"bdd4a223-ed72-4d0b-bf1e-34f62c6b2c80"},{"index":4264,"token":false,"name":"Shivan Hellkite","scryfallId":"e9de5450-030e-4347-a852-1380527b3219"},{"index":4265,"token":false,"name":"Warmonger's Chariot","scryfallId":"44da7915-98bd-4f4e-9bcc-801eb10c8a18"},{"index":4267,"token":false,"name":"Watcher of the Spheres","scryfallId":"354b9ea4-3d55-48cc-b426-c46b1d1bb397"},{"index":4269,"token":false,"name":"Octavia, Living Thesis","scryfallId":"f35834dd-876e-4f5e-9b0c-ce484b14ef24"},{"index":4270,"token":false,"name":"Beledros Witherbloom","scryfallId":"e34dd2ef-a52d-48b6-becc-825f0e78eb75"},{"index":4271,"token":false,"name":"Aven Smokeweaver","scryfallId":"57f5d024-f137-4ea8-be02-7de46dee95fd"},{"index":4273,"token":false,"name":"Gate Colossus","scryfallId":"37d124dd-c5d8-4d53-820f-546be18685ef"},{"index":4275,"token":false,"name":"Lightning Coils","scryfallId":"a800f326-3416-4917-a1cf-0f90255777d3"},{"index":4276,"token":false,"name":"Agonizing Memories","scryfallId":"6556e1e2-44a6-49f1-8417-be8dae4ef65b"},{"index":4278,"token":false,"name":"Beacon of Immortality","scryfallId":"601bb6d1-77f4-4ffe-94d0-bed74c33013b"},{"index":4280,"token":false,"name":"Thieving Amalgam","scryfallId":"06ed7c94-ed3c-427a-b62a-32e91e054671"},{"index":4282,"token":false,"name":"Kindred Charge","scryfallId":"67cd1c43-a85d-44f9-9e25-cf4aeb0367af"},{"index":4283,"token":false,"name":"Murmuring Mystic","scryfallId":"5fc6adff-dcb3-456d-a8c2-0e77b784ff89"},{"index":4284,"token":false,"name":"Scythe of the Wretched","scryfallId":"143e7a81-fb3d-4bad-854a-b24138ca7415"},{"index":4285,"token":false,"name":"Verdant Eidolon","scryfallId":"8120d141-2759-49d4-bed9-e20617a0b009"},{"index":4286,"token":false,"name":"Setessan Champion","scryfallId":"e8b2168d-38e5-429f-8663-f0d258c9c441"},{"index":4287,"token":false,"name":"Battle-Mad Ronin","scryfallId":"a6e4394a-fa91-4cf9-99c1-dc0bc1011c5b"},{"index":4288,"token":false,"name":"Master of Cruelties","scryfallId":"7b4d8ab5-252c-4727-817d-6f18cbaedd91"},{"index":4289,"token":false,"name":"Utopia Mycon","scryfallId":"5664e121-d3f1-4ff5-9576-ef515e22bde7"},{"index":4290,"token":false,"name":"Changeling Berserker","scryfallId":"9f2e8f24-2ee1-4516-bf60-7fe6a0c4baec"},{"index":4293,"token":false,"name":"Silverflame Squire // On Alert","scryfallId":"5599841a-7766-497e-9f36-b206b10a37c8"},{"index":4295,"token":true,"name":"Tom van de Logt Bio (2001)","scryfallId":"67f1746f-4f15-48da-9de7-3dd62811afdb"},{"index":4296,"token":false,"name":"Etali, Primal Storm","scryfallId":"a9ac0e01-9732-470c-abd1-560386e30f80"},{"index":4300,"token":false,"name":"Fervent Mastery","scryfallId":"c8cf5c70-25e8-489a-9cab-ce45eab191ed"},{"index":4302,"token":false,"name":"Hundred-Talon Kami","scryfallId":"a7b2892a-5c16-4624-9a47-6a47f10e2466"},{"index":4304,"token":false,"name":"Might Weaver","scryfallId":"dbd09923-4a4b-4ac6-a487-6e00d17183cb"},{"index":4306,"token":false,"name":"Fool's Tome","scryfallId":"83be257c-8945-46be-8b58-fb2881084026"},{"index":4308,"token":false,"name":"Mortarpod","scryfallId":"f1e6b292-41e7-40f9-b9fe-34f27d4526af"},{"index":4309,"token":false,"name":"Command Beacon","scryfallId":"9a14e63f-3b95-447c-a433-caf944fdef3f"},{"index":4310,"token":false,"name":"Thunderbreak Regent","scryfallId":"06287e93-0da9-4526-88a9-7dda7662e777"},{"index":4311,"token":false,"name":"Lust for War","scryfallId":"9c8fa150-383d-448c-8e14-f24f65e13770"},{"index":4312,"token":false,"name":"Kris Mage","scryfallId":"4389fbcd-182a-4cac-b14f-aa971948cf8e"},{"index":4313,"token":false,"name":"Grave Pact","scryfallId":"c87fe9b8-3dae-4b22-bceb-be48cd082921"},{"index":4314,"token":false,"name":"Confessor","scryfallId":"984c0bdb-e9e2-435e-aa68-2dbad52c3dbd"},{"index":4318,"token":false,"name":"Khorvath Brightflame","scryfallId":"32c9cc8f-913e-46b4-9e17-050f977e77f3"},{"index":4319,"token":false,"name":"Zombie Infestation","scryfallId":"e2709a7b-734e-45df-beb4-950b102d42e9"},{"index":4320,"token":false,"name":"Ranger-Captain of Eos","scryfallId":"af3928b4-813a-4120-8799-de34235d60ac"},{"index":4321,"token":false,"name":"Onulet","scryfallId":"5e6e91cb-1104-4feb-885b-0a49c0b4e60d"},{"index":4325,"token":false,"name":"Glorybringer","scryfallId":"3277ad99-5682-4baa-b106-de15721876a6"},{"index":4326,"token":false,"name":"Wilt-Leaf Cavaliers","scryfallId":"52554536-d3d9-42b9-9056-43209a32c650"},{"index":4327,"token":false,"name":"Everdream","scryfallId":"b71c923f-34ee-4743-98fb-1e6b727ded6d"},{"index":4328,"token":false,"name":"Diffusion Sliver","scryfallId":"fb110a55-c8f9-4627-82c2-edb10db4f380"},{"index":4329,"token":false,"name":"Chittering Harvester","scryfallId":"dbd157ee-d17e-402c-a97d-206445dcf864"},{"index":4335,"token":false,"name":"Splendid Reclamation","scryfallId":"787b023f-0561-4e19-86c9-ec9054dfa074"},{"index":4337,"token":false,"name":"Tangle Spider","scryfallId":"3ca75ce1-8f4e-4980-adb7-5816446d56a9"},{"index":4340,"token":false,"name":"Soulsworn Jury","scryfallId":"668c4e40-0035-44e0-8401-dd17fa11ecd4"},{"index":4342,"token":false,"name":"Retreat to Kazandu","scryfallId":"4d3a089f-2049-406f-aa7e-2fdcbc59a826"},{"index":4344,"token":false,"name":"Rocket Launcher","scryfallId":"d5bb2093-78a8-4a6c-abe7-9a5afc181ec5"},{"index":4345,"token":false,"name":"Flaring Flame-Kin","scryfallId":"cc7aa01f-c647-43d2-8c4a-b93a198d03b4"},{"index":4349,"token":false,"name":"World Shaper","scryfallId":"8b18133c-3522-4922-9a49-4bed75c5a51a"},{"index":4350,"token":false,"name":"Devil's Play","scryfallId":"e6dd2f9e-16c2-4d25-98c4-0017ccd42228"},{"index":4351,"token":false,"name":"Grappler Spider","scryfallId":"e2324d0b-ac63-45e5-ba27-a643c61538c7"},{"index":4352,"token":false,"name":"Skirk Fire Marshal","scryfallId":"b71117d0-5cf7-4041-b568-00bd8a975dd8"},{"index":4353,"token":false,"name":"Kessig Wolf","scryfallId":"3255480b-c1cf-43d9-a40e-43e38112bb18"},{"index":4354,"token":false,"name":"Nighthowler","scryfallId":"77b85aef-2f4b-4318-8f29-8adfbee92628"},{"index":4355,"token":false,"name":"Roaring Primadox","scryfallId":"19529b2f-03f0-469d-92d4-e2a2a933d5dc"},{"index":4356,"token":false,"name":"Avacyn's Judgment","scryfallId":"0c5f44ce-1464-4282-9afa-20e9ea44c613"},{"index":4357,"token":false,"name":"Convolute","scryfallId":"b8a68347-c0ef-46ff-9705-6d82d004d32c"},{"index":4358,"token":false,"name":"Axebane Stag","scryfallId":"bfce7c02-ccc3-44cd-8087-627eaa6a072e"},{"index":4360,"token":false,"name":"Triton Fortune Hunter","scryfallId":"1173ff96-998c-4fe7-9b28-602d990e0339"},{"index":4361,"token":false,"name":"Surgical Extraction","scryfallId":"319587d8-fd69-415d-8274-3902722146b0"},{"index":4362,"token":false,"name":"Tundra","scryfallId":"16cbac60-fd88-4369-942e-e8a1d16f7300"},{"index":4363,"token":false,"name":"Divine Gambit","scryfallId":"ac62fae3-2525-4b71-80d1-83e608070e4f"},{"index":4364,"token":false,"name":"Island Sanctuary","scryfallId":"c5521bab-3252-4f81-9e9e-783160a5718c"},{"index":4365,"token":false,"name":"Groundbreaker","scryfallId":"cc87fc0b-73b6-4f50-a6f1-473cddc40247"},{"index":4366,"token":false,"name":"Sporoloth Ancient","scryfallId":"57a96041-1b20-464e-9119-93c19675ac46"},{"index":4369,"token":false,"name":"Tithe","scryfallId":"aae08938-e563-4322-b2eb-db81913ea730"},{"index":4372,"token":false,"name":"Tymna the Weaver","scryfallId":"cec4983f-c2ec-4bf5-9f14-e75f0a2788a6"},{"index":4374,"token":false,"name":"Sentinel Spider","scryfallId":"17bdafb1-abb9-4020-8f74-18f9321de90a"},{"index":4375,"token":false,"name":"Frontline Strategist","scryfallId":"1c43fac2-62fb-4924-848d-a8d739773d6e"},{"index":4376,"token":false,"name":"Agadeem's Awakening // Agadeem, the Undercrypt","scryfallId":"67f4c93b-080c-4196-b095-6a120a221988"},{"index":4377,"token":false,"name":"Deep-Sea Serpent","scryfallId":"f2d7f8d8-30fb-47c7-8927-646c41f0b9bc"},{"index":4378,"token":false,"name":"Moratorium Stone","scryfallId":"5529edfc-22bd-43dc-878b-6ec9fba74795"},{"index":4379,"token":false,"name":"Desperate Charge","scryfallId":"304cc153-36ac-4527-a6e2-91d994bcc35c"},{"index":4380,"token":false,"name":"Divest","scryfallId":"4494cb6d-1a99-40b6-96cc-0dc2ddec102f"},{"index":4381,"token":false,"name":"Shunt","scryfallId":"44ee290e-c22b-4fad-bf99-0630a2b89d68"},{"index":4383,"token":false,"name":"Font of Fertility","scryfallId":"658f0830-08c9-4c8f-ae0e-118b88e19ab6"},{"index":4384,"token":false,"name":"Seismic Rupture","scryfallId":"0c3c3db6-cb91-45c6-baad-f10a1904952a"},{"index":4385,"token":false,"name":"Blighted Fen","scryfallId":"48c0e762-761f-49a6-9004-308ca26d2af1"},{"index":4386,"token":false,"name":"River Hoopoe","scryfallId":"d7b42a91-81e7-45e9-80ae-0ca905884692"},{"index":4387,"token":false,"name":"Siege Wurm","scryfallId":"ae199825-563e-4837-a6d2-7b009b93cd4d"},{"index":4388,"token":false,"name":"Halam Djinn","scryfallId":"369ade1f-e909-47ae-bb01-19588269ad8f"},{"index":4389,"token":false,"name":"Sea-Dasher Octopus","scryfallId":"7a7d21ec-7566-4821-a1db-d91bc7e8fccc"},{"index":4390,"token":false,"name":"Fruit of the First Tree","scryfallId":"2d3e6a6a-4a19-41e1-b29e-a8f19838efe3"},{"index":4391,"token":false,"name":"Orgg","scryfallId":"c7eef087-8500-4fca-a10a-ff65d348bcb1"},{"index":4393,"token":false,"name":"Irontread Crusher","scryfallId":"efaefcd1-1ed0-482d-bf69-e9a34289a605"},{"index":4395,"token":false,"name":"Scattershot","scryfallId":"cf22f3e7-1626-4bab-9f62-7d4774704395"},{"index":4397,"token":false,"name":"Mogg Squad","scryfallId":"4b267071-42a6-4e25-9c92-5bca32f8d9af"},{"index":4398,"token":false,"name":"Arcane Lighthouse","scryfallId":"fa90e142-15d4-461a-9e57-4a301a5df958"},{"index":4399,"token":false,"name":"Shaper Parasite","scryfallId":"4e311fa4-c854-45af-9353-5844216255fe"},{"index":4401,"token":false,"name":"Brush with Death","scryfallId":"04013bc6-7774-400b-a6af-de755b4c324d"},{"index":4402,"token":false,"name":"Isperia, Supreme Judge","scryfallId":"1e3b82a7-ebef-4190-9f50-40b992ba89c9"},{"index":4404,"token":false,"name":"Underworld Coinsmith","scryfallId":"ea5346e3-3fe4-47ea-a184-e237091cc4a1"},{"index":4405,"token":false,"name":"Fertile Imagination","scryfallId":"e5c879af-a092-4cc4-a53d-760553d94864"},{"index":4407,"token":false,"name":"Trained Armodon","scryfallId":"bc7c1774-908f-43ab-b589-e46606267381"},{"index":4408,"token":false,"name":"Ghost Warden","scryfallId":"4304abfe-3c81-4053-a398-574cfac613a7"},{"index":4409,"token":false,"name":"Confidence from Strength","scryfallId":"98945e26-61e5-457d-ba8c-def924a7b1d1"},{"index":4410,"token":false,"name":"Lotus Bloom","scryfallId":"035c3112-222d-4362-9109-c8b872a59a2b"},{"index":4411,"token":false,"name":"Copper Myr","scryfallId":"0cecd069-638b-489f-9e2d-a0a4d9a8906a"},{"index":4415,"token":false,"name":"Annihilate","scryfallId":"4a3bf039-ecf6-477e-997c-e32c55323c01"},{"index":4416,"token":false,"name":"Witch's Vengeance","scryfallId":"dac28cfb-dedc-4dac-8b26-27f963f4d310"},{"index":4418,"token":false,"name":"Mass Mutiny","scryfallId":"6d18e6fb-e4ae-4ff4-9412-f16edb2e56c6"},{"index":4420,"token":false,"name":"Pentavus","scryfallId":"eb10af81-8ff3-4063-a67a-b760fdba95f8"},{"index":4421,"token":false,"name":"Beast Whisperer","scryfallId":"0ced02ab-018d-432b-a8c2-102dde57aa91"},{"index":4422,"token":false,"name":"Unsummon","scryfallId":"84402e82-bae7-470a-8b2f-929dac888018"},{"index":4423,"token":false,"name":"Extraplanar Lens","scryfallId":"622a6523-3b12-4657-a656-00a57a3ae59c"},{"index":4424,"token":false,"name":"Revered Unicorn","scryfallId":"8c642dd2-1a3e-4b08-917e-6e8aed358b72"},{"index":4425,"token":false,"name":"Tenth District Guard","scryfallId":"829f959e-91cd-42ea-8644-ce828a304d01"},{"index":4426,"token":false,"name":"Brain Freeze","scryfallId":"59a43ef5-08f0-44fc-802d-b6cfd56b7d1f"},{"index":4428,"token":false,"name":"Growth Spiral","scryfallId":"3b71eff3-7571-4dc1-b8c7-b8b6fc8a3565"},{"index":4430,"token":false,"name":"Shimmerdrift Vale","scryfallId":"f09d98db-0176-41a7-b99b-ead29876cdab"},{"index":4431,"token":false,"name":"Supreme Verdict","scryfallId":"fc6f705a-63cc-4dee-aca0-2b6a75e19c1e"},{"index":4434,"token":false,"name":"Cathodion","scryfallId":"4f8d963e-f210-44ca-a427-6a040cec102d"},{"index":4435,"token":false,"name":"Call the Cavalry","scryfallId":"7978a719-b159-4155-88d9-9c0b15183037"},{"index":4436,"token":false,"name":"Slag Fiend","scryfallId":"c0d1ee33-e247-4ada-bb01-518611cd7d00"},{"index":4437,"token":false,"name":"Behemoth Sledge","scryfallId":"1cf41508-64c0-48ce-8bd3-e1ec554d085f"},{"index":4438,"token":false,"name":"Fog","scryfallId":"f5498e4d-8ccd-4874-8ecc-3b1819b15f85"},{"index":4440,"token":false,"name":"Koth of the Hammer","scryfallId":"af8b9c79-a161-4d7d-944d-82a44a5f2ab9"},{"index":4441,"token":false,"name":"Order of the Golden Cricket","scryfallId":"5d1c2f16-5661-4c17-8265-f4b88ff1e833"},{"index":4442,"token":false,"name":"Dragon Blood","scryfallId":"d0712389-bc0c-4654-90e6-741387d84213"},{"index":4443,"token":false,"name":"Knight's Pledge","scryfallId":"4e786d0e-d6bf-4c6b-b989-28ca1ed53e2e"},{"index":4444,"token":false,"name":"Primordial Sage","scryfallId":"3ede6241-5884-433e-b914-7e7e1f92687c"},{"index":4446,"token":false,"name":"Mwonvuli Beast Tracker","scryfallId":"0034d32c-cc82-48d7-a913-d58cc3d3afeb"},{"index":4447,"token":false,"name":"Infuriate","scryfallId":"7ac778f6-8997-47ee-a676-3eb9f8d1592f"},{"index":4448,"token":true,"name":"Construct Token (Colorless, */*)","scryfallId":"623a08d1-f5ff-48b7-bdb6-54b8d7a4b931"},{"index":4450,"token":false,"name":"Scab-Clan Mauler","scryfallId":"10634fb3-8222-4778-8b2f-e9d0cae90b81"},{"index":4451,"token":false,"name":"Pallid Mycoderm","scryfallId":"29a2a28e-c241-4228-9ece-2e49d4d3733a"},{"index":4452,"token":false,"name":"Epic Proportions","scryfallId":"3783bbed-5ae8-4d62-b39e-99136c42eeb6"},{"index":4453,"token":false,"name":"Thornscape Master","scryfallId":"7e8f164d-3782-4eaa-a4db-ab7082d45ee7"},{"index":4455,"token":false,"name":"Hexplate Golem","scryfallId":"49b913f3-6581-45ae-9cdb-274c2ccd8899"},{"index":4458,"token":false,"name":"Valorous Stance","scryfallId":"20516400-b37a-46d2-89c8-d6be88f5ab3d"},{"index":4460,"token":false,"name":"Innocence Kami","scryfallId":"df62efbb-2313-4667-82e6-3b474d998ef5"},{"index":4461,"token":false,"name":"Knight of Old Benalia","scryfallId":"a422ae32-deed-4bdd-a756-5cf452c909f1"},{"index":4463,"token":false,"name":"Diplomacy of the Wastes","scryfallId":"69faf63b-f39b-4005-a35d-1204faaa6d57"},{"index":4465,"token":false,"name":"Ardent Militia","scryfallId":"8c78d392-9f2f-4241-9a10-6ac9b1e86154"},{"index":4466,"token":false,"name":"Mistform Stalker","scryfallId":"9e80d109-b73f-4b5d-b9e4-534e8d69633f"},{"index":4467,"token":false,"name":"Yavimaya Coast","scryfallId":"a661606e-675a-4fd9-963b-cd7bd3f96438"},{"index":4468,"token":false,"name":"Jokulhaups","scryfallId":"99d26ff7-afff-40a0-b515-7928c2428809"},{"index":4471,"token":false,"name":"Deft Duelist","scryfallId":"1f9d3d09-09e5-40d8-bce7-912cfc214f7a"},{"index":4472,"token":false,"name":"Reclaim","scryfallId":"2b47c082-57f6-4f69-87e8-a07cad9ef042"},{"index":4473,"token":false,"name":"Keepers of the Faith","scryfallId":"b63a69ae-99ce-4d26-88b7-784793c43cd4"},{"index":4474,"token":false,"name":"Serendib Sorcerer","scryfallId":"5270c9cb-f322-4a21-b985-be8670c317cb"},{"index":4475,"token":false,"name":"Darksteel Ingot","scryfallId":"8dba9786-a504-49d0-9558-b70bf05bb694"},{"index":4476,"token":false,"name":"Anje's Ravager","scryfallId":"22924c44-5551-4a48-a574-dfef91a5d4d7"},{"index":4477,"token":false,"name":"Goblin Outlander","scryfallId":"5e33683b-8bda-4bb9-beb4-fc0cd5ed79ae"},{"index":4478,"token":false,"name":"Elvish Clancaller","scryfallId":"0f18dbbb-498c-4180-b467-f97b372d050b"},{"index":4480,"token":false,"name":"Bitterblossom","scryfallId":"8145fed6-6b51-420a-84cf-4ea5e0aa1883"},{"index":4481,"token":false,"name":"Tamiyo, Collector of Tales","scryfallId":"e5ad78c6-8af3-4efa-b47a-29a646ea412a"},{"index":4482,"token":false,"name":"Gerrard's Battle Cry","scryfallId":"814c4295-5d99-45da-87cc-29bb1b774e99"},{"index":4483,"token":false,"name":"Boreal Shelf","scryfallId":"3f2f8396-72ab-4387-9276-987836427107"},{"index":4484,"token":false,"name":"Decree of Pain","scryfallId":"85a24793-2d19-4e29-bdb9-0b8e0ba90fd3"},{"index":4485,"token":false,"name":"Ancient Silverback","scryfallId":"3f2f8a99-b01d-4d0a-bf1c-a3cf08fbc469"},{"index":4486,"token":true,"name":"Metallic Sliver Token (Colorless, 1/1)","scryfallId":"2c7e0d67-b627-4cf7-8f56-e1f0bd75cd5c"},{"index":4488,"token":false,"name":"Savage Thallid","scryfallId":"ad59a9c5-6b96-4da1-886c-fb55dee74ed2"},{"index":4489,"token":false,"name":"Wooden Sphere","scryfallId":"8e04657c-9a09-4e69-a884-39e083ad22b8"},{"index":4491,"token":false,"name":"Sacrifice","scryfallId":"ef3616ba-c95f-4650-9643-1c5f27be1a89"},{"index":4493,"token":false,"name":"Deepglow Skate","scryfallId":"1c970be9-d777-4e05-b12a-80d8b27b8526"},{"index":4494,"token":false,"name":"Skyrider Trainee","scryfallId":"5d760a01-d6c4-462b-b66c-cfd0f594e13a"},{"index":4496,"token":false,"name":"Garrison Sergeant","scryfallId":"2bd957a1-a354-48e9-80ad-66e49aa845fc"},{"index":4497,"token":false,"name":"Selvala's Stampede","scryfallId":"85d6e48e-3d26-4915-9739-25edbd80bdf1"},{"index":4499,"token":false,"name":"Celestial Kirin","scryfallId":"77338072-8682-4be4-8dfe-23a4593e8849"},{"index":4500,"token":false,"name":"Renegade Rallier","scryfallId":"90bad312-80e3-45b0-9556-60ce06808a47"},{"index":4501,"token":false,"name":"Hoard-Smelter Dragon","scryfallId":"8492c80b-c38a-44b0-b2a4-9292077a74c7"},{"index":4503,"token":false,"name":"Thassa's Intervention","scryfallId":"24d7f87c-4154-4370-af32-e34fd1be5a93"},{"index":4504,"token":false,"name":"Revenant","scryfallId":"307a8465-9e33-4441-b512-a112e8524328"},{"index":4505,"token":false,"name":"Cackling Counterpart","scryfallId":"5a040326-2412-4d7b-b96d-07047c3433c8"},{"index":4506,"token":false,"name":"Luminesce","scryfallId":"38e8fe10-a4b7-4504-849f-a5c8379e587d"},{"index":4507,"token":false,"name":"Chorus of the Conclave","scryfallId":"d2792033-19e1-4629-8155-85c6c2d89106"},{"index":4508,"token":false,"name":"Thawing Glaciers","scryfallId":"397facec-f473-45a5-a4ce-02cb56e7bfab"},{"index":4514,"token":false,"name":"Flood","scryfallId":"2aefbeae-ac72-4a13-8898-8d1e42a633a6"},{"index":4516,"token":false,"name":"Crashing Tide","scryfallId":"8c06593d-3214-4c3a-981d-5300f1065573"},{"index":4517,"token":false,"name":"Owl Familiar","scryfallId":"f8e6d260-231d-4874-9ef4-d24ea9673ff8"},{"index":4521,"token":false,"name":"Flaxen Intruder // Welcome Home","scryfallId":"06bd1ad2-fb5d-4aef-87d1-13a341c686fa"},{"index":4522,"token":false,"name":"Wings of Aesthir","scryfallId":"00341664-d848-44d2-ba06-21a6ae8e6788"},{"index":4523,"token":false,"name":"Fathom Seer","scryfallId":"a80b0701-2f79-4c94-9796-01fb9f5422b9"},{"index":4524,"token":false,"name":"Flame Spill","scryfallId":"b3090004-d7dd-47bc-92e5-977be4fd9ae5"},{"index":4525,"token":false,"name":"Nurturing Licid","scryfallId":"0bf53069-44ac-49c5-83bf-9c3c1274e407"},{"index":4526,"token":false,"name":"Kiora's Dismissal","scryfallId":"21b040e5-651b-42ca-b487-66cf1d8180f9"},{"index":4528,"token":false,"name":"Spire Monitor","scryfallId":"b40a12fb-05ef-411a-9914-f7d8cdada01a"},{"index":4530,"token":false,"name":"Spike Feeder","scryfallId":"759522b6-264c-4a02-ad0a-e767e20f0ab1"},{"index":4531,"token":false,"name":"Ratcatcher","scryfallId":"e9cb08a7-cfcf-49ee-948b-4be859c1d256"},{"index":4532,"token":false,"name":"Niblis of Frost","scryfallId":"ed006552-8e6c-4fc2-ba83-ec91ca466fba"},{"index":4533,"token":false,"name":"Beacon of Tomorrows","scryfallId":"3ab166c9-af3e-4e65-88ed-9766b046c95b"},{"index":4534,"token":false,"name":"Hickory Woodlot","scryfallId":"af7aafb7-6870-4d09-a191-70786766c459"},{"index":4535,"token":false,"name":"Mistveil Plains","scryfallId":"724acbe2-4c82-4360-a738-38cc6aa0c4a4"},{"index":4536,"token":false,"name":"Lathliss, Dragon Queen","scryfallId":"9460e3c6-e745-41d3-8e17-0b92fb126a16"},{"index":4537,"token":false,"name":"Yavimaya Kavu","scryfallId":"1872f104-7cf1-41e3-b1b4-ca75c678e08b"},{"index":4539,"token":false,"name":"Spellweaver Duo","scryfallId":"87ba22f6-5299-46c3-bd01-9140634e60ea"},{"index":4540,"token":false,"name":"Beastmaster Ascension","scryfallId":"3ac51aa4-710e-4171-9fb8-9f28525e3e26"},{"index":4543,"token":true,"name":"Zombie Army Token (B, 0/0)","scryfallId":"c46d82e0-ef99-473c-a09c-8f552db759bf"},{"index":4544,"token":true,"name":"Phoberos Reaver Token (Colorless, 2/3)","scryfallId":"1eda2434-523d-4e9c-a8f1-acbee5c87aac"},{"index":4545,"token":false,"name":"Courser of Kruphix","scryfallId":"59592a53-c5a5-4e0c-8b91-b2431fa84b07"},{"index":4546,"token":false,"name":"Hornet Cannon","scryfallId":"51e9afeb-4d27-441c-b379-3dfe974053b8"},{"index":4547,"token":false,"name":"Izzet Charm","scryfallId":"b8f5032a-bf0d-4a66-b3d4-32b2ec61d308"},{"index":4548,"token":false,"name":"Thunderherd Migration","scryfallId":"8aef082b-b245-463d-84e5-ed1672845492"},{"index":4549,"token":false,"name":"Standing Troops","scryfallId":"013a1d59-af2a-4ae1-826e-88bd77c7ce5d"},{"index":4550,"token":false,"name":"Kess, Dissident Mage","scryfallId":"01711ff6-475c-48c4-91f4-438433f88a95"},{"index":4551,"token":false,"name":"Weatherseed Elf","scryfallId":"4e74f8ae-992b-40a6-87e3-7b321dba4ffa"},{"index":4552,"token":false,"name":"Vivid Grove","scryfallId":"58b4e602-f41f-4653-84b8-354f47704da5"},{"index":4553,"token":false,"name":"Shimian Specter","scryfallId":"1ca9e99b-e46c-4f7a-9c51-e2cfe8810450"},{"index":4555,"token":false,"name":"Skarrg, the Rage Pits","scryfallId":"715228ea-009e-4426-ab15-3394f95fa8c9"},{"index":4556,"token":false,"name":"Emmara, Soul of the Accord","scryfallId":"4eed0bcf-cef3-4f09-8070-6866072b38fb"},{"index":4558,"token":false,"name":"Fall of the Titans","scryfallId":"80f2a0ff-2a63-4f6b-8e7a-311fef92dac8"},{"index":4559,"token":false,"name":"Living Lore","scryfallId":"15b137fb-3f90-4a44-a225-cff5ca153190"},{"index":4560,"token":false,"name":"Rapid Hybridization","scryfallId":"e9a52e70-b7a7-4ad4-97e1-a7033925db53"},{"index":4561,"token":false,"name":"Coat with Venom","scryfallId":"0ac6933c-173b-42d1-af2f-8c3f5380fe32"},{"index":4562,"token":false,"name":"Lightning Mauler","scryfallId":"241cc968-b93e-4fe3-a66d-7776d29aa023"},{"index":4563,"token":false,"name":"Kyren Toy","scryfallId":"7a8318bb-bc3c-45e9-bd57-60ae72b6f8b0"},{"index":4565,"token":false,"name":"Wirewood Channeler","scryfallId":"36e5579e-dab7-49db-a141-a5bc5b5aee90"},{"index":4566,"token":false,"name":"Reality Shift","scryfallId":"c9a96e38-413f-49cd-90fa-178a91a406ba"},{"index":4567,"token":false,"name":"Staff of Nin","scryfallId":"5be0ec9b-17ea-4503-b9c2-67a3ca2a2b13"},{"index":4569,"token":false,"name":"Shrine of Burning Rage","scryfallId":"8255740d-f822-4359-8f9e-6f08235ef539"},{"index":4571,"token":false,"name":"Infernal Plunge","scryfallId":"b3f50e17-c29c-4d2c-b3e7-45d1216b81ea"},{"index":4572,"token":false,"name":"Leonin Relic-Warder","scryfallId":"c938a21a-ea74-4cc1-a175-08b9b98b2e4e"},{"index":4573,"token":false,"name":"Slay","scryfallId":"eccda747-2680-4793-8a13-35e49b4de12f"},{"index":4575,"token":false,"name":"Bloodlust Inciter","scryfallId":"b1cd0757-1b06-4e1b-a236-31271bd0d9a3"},{"index":4577,"token":false,"name":"Bound in Silence","scryfallId":"c809f77a-2c9a-4134-9c29-0709ee4f4957"},{"index":4580,"token":false,"name":"Contaminated Bond","scryfallId":"a1a64356-3064-47a2-80be-5e2f56c85556"},{"index":4583,"token":false,"name":"Comet Storm","scryfallId":"48743445-6e2e-4001-b314-365b9a8b091e"},{"index":4586,"token":false,"name":"Sage Owl","scryfallId":"ec9a3aba-25ae-4b5e-b356-9745e7236f35"},{"index":4588,"token":false,"name":"Koll, the Forgemaster","scryfallId":"37533179-8e58-40bc-af16-0d2c58b773ba"},{"index":4589,"token":false,"name":"Gruul Nodorog","scryfallId":"a57e9d57-c017-4126-b58d-22cb378521a2"},{"index":4590,"token":false,"name":"Reinforcements","scryfallId":"c0b26881-3ad7-4d70-8051-a7e222d910bf"},{"index":4592,"token":false,"name":"Hooded Brawler","scryfallId":"8a292aa9-e959-42e7-82f9-4c9be5b79979"},{"index":4593,"token":false,"name":"Vine Mare","scryfallId":"b9980835-cd32-4870-88df-c79cd5534968"},{"index":4594,"token":false,"name":"Word of Binding","scryfallId":"ee30efdb-f1f1-497f-80a6-ec961db67c1d"},{"index":4595,"token":false,"name":"Charge of the Forever-Beast","scryfallId":"4bf147a6-2282-4120-9cbd-d0309fc9b02b"},{"index":4597,"token":false,"name":"Trokin High Guard","scryfallId":"9c2b9302-fca6-43ca-a01c-03aec51acd0d"},{"index":4598,"token":false,"name":"Stormfront Pegasus","scryfallId":"c2e03297-3124-4f83-98ef-772fa213a422"},{"index":4599,"token":false,"name":"Fleshbag Marauder","scryfallId":"f9220bde-ff88-4080-b657-3aca494e1d12"},{"index":4600,"token":false,"name":"Ob Nixilis Reignited","scryfallId":"58bfed5d-103b-438e-92c6-d9d03203ba27"},{"index":4602,"token":false,"name":"Lightning Prowess","scryfallId":"5578e3e2-2460-4dfb-9016-527463f2d918"},{"index":4605,"token":false,"name":"Sterling Grove","scryfallId":"ba03e105-a76c-4769-a35a-d780448890ec"},{"index":4606,"token":false,"name":"Stream of Life","scryfallId":"9d51d054-3c42-42d4-b2fe-d7197703cc6e"},{"index":4607,"token":false,"name":"Goblin Warchief","scryfallId":"5bac033c-dc4e-40a0-b103-4892e4b50249"},{"index":4608,"token":false,"name":"Dragon Fangs","scryfallId":"9754f52f-8937-4402-8956-2c18b520898a"},{"index":4609,"token":false,"name":"Sun Quan, Lord of Wu","scryfallId":"b4e9ec34-4bf6-46da-b2c4-acedb1b19210"},{"index":4610,"token":false,"name":"Ghoulsteed","scryfallId":"6b8f7cfd-88db-4cc1-b65f-3462332a2873"},{"index":4611,"token":false,"name":"Shield Wall","scryfallId":"a5032bf0-f9c0-4ef0-8ec2-fe7ccea9bdf3"},{"index":4612,"token":false,"name":"Rod of Ruin","scryfallId":"2fbb8867-8bde-411b-afbd-27079172dcd1"},{"index":4613,"token":false,"name":"Titanic Growth","scryfallId":"6da62557-9783-4e6c-9b5f-2b77dbf96909"},{"index":4614,"token":false,"name":"Phyrexian Denouncer","scryfallId":"1444786c-fb9f-4398-b442-c7cfd6f1df40"},{"index":4615,"token":false,"name":"Squallmonger","scryfallId":"c845e1b8-6a39-456c-aa67-d180ae63e200"},{"index":4616,"token":false,"name":"Plated Rootwalla","scryfallId":"6f5e2cc1-3f16-4984-b1a3-db21c9a38408"},{"index":4618,"token":false,"name":"Quarry Colossus","scryfallId":"d921128a-ebfd-4e3c-8728-481a8c3c03f3"},{"index":4621,"token":false,"name":"Gorilla Shaman","scryfallId":"5a16231c-1f73-4dec-9d88-e3d62e93a70f"},{"index":4622,"token":false,"name":"Collected Conjuring","scryfallId":"9a60eacf-55bb-4da1-b960-5b6efd55e0cc"},{"index":4625,"token":false,"name":"Galvanic Juggernaut","scryfallId":"7a006dd2-8a7f-4eef-a6aa-b6bcc0b56ed6"},{"index":4626,"token":false,"name":"Notorious Throng","scryfallId":"6f4b5890-21d3-4eb9-a959-645dd389dde6"},{"index":4628,"token":false,"name":"Confirm Suspicions","scryfallId":"cf7fcbc2-1034-442d-9f2a-7d79ea40ac3d"},{"index":4629,"token":false,"name":"Argentum Armor","scryfallId":"c5247934-554a-44fb-ad5c-0e581c4421a6"},{"index":4631,"token":false,"name":"Conclave Phalanx","scryfallId":"83854443-736b-4650-8a7e-e123ee6e0b8b"},{"index":4632,"token":false,"name":"Rally the Ancestors","scryfallId":"85f6cdd6-725d-4fa2-a783-7293c50a0cf2"},{"index":4636,"token":false,"name":"Polluted Bonds","scryfallId":"c6439222-de30-44cd-a53f-a7de0cb00b8f"},{"index":4638,"token":false,"name":"Stalwart Valkyrie","scryfallId":"89ecb530-e429-4b50-a24c-8437614cf224"},{"index":4639,"token":false,"name":"Divination","scryfallId":"cb3b35b8-f321-46d8-a441-6b9a6efa9021"},{"index":4640,"token":false,"name":"Obsidian Acolyte","scryfallId":"868efcee-bb13-4b6f-b81b-99408685e4c4"},{"index":4641,"token":false,"name":"Titans' Nest","scryfallId":"75fdbefd-f6a1-454c-b075-1aef7c670152"},{"index":4643,"token":false,"name":"Flood Plain","scryfallId":"3f0d377b-9bd0-4aa9-b672-dcf4eaf8b7a9"},{"index":4644,"token":false,"name":"Peacekeeper","scryfallId":"592a5683-5f2f-4933-9fc3-5f7773f72f93"},{"index":4646,"token":false,"name":"Kydele, Chosen of Kruphix","scryfallId":"86eee902-dc0b-48d0-a8db-7e6de89977ef"},{"index":4647,"token":false,"name":"Crowd of Cinders","scryfallId":"0dd88305-d57b-4e77-aec9-f0a3ace42c37"},{"index":4649,"token":false,"name":"Dawning Purist","scryfallId":"b8cb25b0-e4c3-4a4e-b722-ea30e695f917"},{"index":4650,"token":false,"name":"Myr Matrix","scryfallId":"4a1af62e-d566-4f39-a467-244602c9240b"},{"index":4651,"token":false,"name":"Ring of Gix","scryfallId":"b3e75332-4f26-42c9-818f-f8f9396b4210"},{"index":4652,"token":false,"name":"Torture","scryfallId":"0afdd3de-4f0c-4b78-8534-562db8be9c6b"},{"index":4653,"token":false,"name":"Shoreline Ranger","scryfallId":"a9957cbe-da88-41fe-a4aa-e32ec9e7aa38"},{"index":4656,"token":false,"name":"Dream Cache","scryfallId":"641fd917-338b-4197-ac63-b72523ffd112"},{"index":4659,"token":false,"name":"Archfiend of Ifnir","scryfallId":"34a476f3-9506-44d5-a54d-b16322befed1"},{"index":4660,"token":false,"name":"Thassa, Deep-Dwelling","scryfallId":"b69d2f7b-4705-4d61-964b-6ce892ed0abc"},{"index":4663,"token":false,"name":"Dirtwater Wraith","scryfallId":"fcc3fa22-a4c4-423d-969b-98c65b23e782"},{"index":4664,"token":false,"name":"Black Vise","scryfallId":"485ee825-7d3c-490f-a092-c6fabd2c704f"},{"index":4665,"token":false,"name":"Abundance","scryfallId":"7f3fff7e-f34d-4a99-a805-bd66c4e9f0cb"},{"index":4669,"token":false,"name":"Chandra Nalaar","scryfallId":"a3ce115a-28f8-4350-8e66-74e7a3727657"},{"index":4670,"token":false,"name":"Essence Drain","scryfallId":"9950052e-f674-4f09-802e-3f5f52f5e717"},{"index":4673,"token":false,"name":"Samite Alchemist","scryfallId":"68224871-d4c2-4b43-9ab8-c0685588b035"},{"index":4675,"token":false,"name":"Crash of Rhinos","scryfallId":"d74e0337-d9ac-4bf2-b2b5-aadc97433030"},{"index":4676,"token":false,"name":"Dauntless River Marshal","scryfallId":"efedfd1e-5073-47e2-9137-5f2bf4e436e3"},{"index":4677,"token":false,"name":"Farseek","scryfallId":"8180abec-9459-4b81-987e-b1794e45d543"},{"index":4678,"token":false,"name":"Avaricious Dragon","scryfallId":"354255d7-dc29-403b-aa90-9044cde669d0"},{"index":4679,"token":false,"name":"Armix, Filigree Thrasher","scryfallId":"879a678a-d81a-4994-a864-0b1af80a39ca"},{"index":4680,"token":false,"name":"Brutal Deceiver","scryfallId":"e3d532b3-4bd6-4c1d-974d-789976117497"},{"index":4682,"token":false,"name":"O-Naginata","scryfallId":"08db5b31-6b5a-4b99-b103-d628afaea2ba"},{"index":4683,"token":false,"name":"Lightning Axe","scryfallId":"91344085-92ef-4212-b59f-848ab57cd3e0"},{"index":4684,"token":false,"name":"Scryb Sprites","scryfallId":"2d0a7b28-63bb-4aeb-98de-5a795cef838a"},{"index":4686,"token":false,"name":"Sorcerous Spyglass","scryfallId":"e47e85d1-8c4a-43a9-92b3-7cb2a5b89219"},{"index":4687,"token":false,"name":"Skittering Crustacean","scryfallId":"61195835-2375-420c-b693-dc11653c4864"},{"index":4688,"token":false,"name":"Goreclaw, Terror of Qal Sisma","scryfallId":"430e64a3-6604-419a-bbb7-769362114788"},{"index":4689,"token":false,"name":"Anarchist","scryfallId":"5514627a-b24c-48c9-9a5a-5a375adcdf62"},{"index":4691,"token":false,"name":"Professor Onyx","scryfallId":"013eeb99-1b66-4fba-ad96-78deee901ea4"},{"index":4692,"token":false,"name":"Diving Griffin","scryfallId":"ec9f72b2-e3d0-4b24-9a73-b95d54695fa4"},{"index":4694,"token":false,"name":"Orim's Prayer","scryfallId":"2dc45565-4b56-49ba-b115-be8e0de7d937"},{"index":4695,"token":false,"name":"Fool's Demise","scryfallId":"3ed39bd7-d059-4a44-9f03-0f628dcdb119"},{"index":4696,"token":false,"name":"Drowner Initiate","scryfallId":"28accc5f-63a5-47d0-b0e6-747aa0aa43e5"},{"index":4697,"token":false,"name":"Built to Smash","scryfallId":"6f054978-446c-4565-b51e-8f1f0e0f01e2"},{"index":4698,"token":false,"name":"Daxos, Blessed by the Sun","scryfallId":"94355044-e67a-4605-a37b-e879784fc9e5"},{"index":4699,"token":false,"name":"Havenwood Battleground","scryfallId":"6aded00a-0bf3-416e-8eac-15c04554705d"},{"index":4700,"token":false,"name":"Vorrac Battlehorns","scryfallId":"b1b19949-90c9-46f1-85d4-d6eda0b7977e"},{"index":4701,"token":false,"name":"Mavinda, Students' Advocate","scryfallId":"e32e0bb1-073f-4583-ad9c-1dc0c7eb8ef8"},{"index":4702,"token":false,"name":"Goblin Cadets","scryfallId":"60081115-16bc-4924-b76d-7cfc0ad2287c"},{"index":4703,"token":false,"name":"Graveborn Muse","scryfallId":"3d460b79-f1a5-41c4-a5b3-61f703fd97df"},{"index":4704,"token":false,"name":"Storm Crow","scryfallId":"a2d4ea78-16f1-46ac-8a60-db20c37aad5e"},{"index":4705,"token":false,"name":"Snapdax, Apex of the Hunt","scryfallId":"004237f7-1099-4422-9ce9-6065a803e230"},{"index":4706,"token":false,"name":"Mirrodin's Core","scryfallId":"c0a9fbb3-9fe4-4ec6-82f0-3bb101524e1e"},{"index":4707,"token":false,"name":"Blue Mana Battery","scryfallId":"48f9e736-4d24-4dfe-8931-a511e2cb73f3"},{"index":4708,"token":false,"name":"Wojek Siren","scryfallId":"a55c0d7d-2325-4d7e-b449-c8fdcf988ec0"},{"index":4710,"token":false,"name":"Curse of the Cabal","scryfallId":"d4323aa6-a1fb-42ee-9634-3747129fde3b"},{"index":4712,"token":false,"name":"Aether Tradewinds","scryfallId":"9eb4b340-6d1a-4c95-b191-1fb6e7d1b8c7"},{"index":4714,"token":false,"name":"Carrion Feeder","scryfallId":"083f4ccc-9cfc-44b1-af77-304b65bd878b"},{"index":4715,"token":false,"name":"Stensia Bloodhall","scryfallId":"cc2741d8-2c02-4acd-8ca2-55b4bf6aef1c"},{"index":4716,"token":false,"name":"Nissa of Shadowed Boughs","scryfallId":"6d69f943-d474-47c0-bc6b-1b247a5dd6f3"},{"index":4717,"token":false,"name":"Sphinx of the Chimes","scryfallId":"31a0cae5-925f-4d00-a4da-1db8bae5511b"},{"index":4718,"token":false,"name":"Diabolic Intent","scryfallId":"6b34a328-8d6a-4baf-99de-c8b050b23e10"},{"index":4720,"token":false,"name":"Morality Shift","scryfallId":"b5c83e4d-ccc1-4ebf-9e74-2cc1ff9a7b07"},{"index":4721,"token":false,"name":"Boros Charm","scryfallId":"36c3288b-ab10-40df-a0ce-17ee4ecdb98e"},{"index":4723,"token":false,"name":"Coils of the Medusa","scryfallId":"502bfb38-4a37-4053-af20-d5606ffc67c8"},{"index":4724,"token":false,"name":"Gloryscale Viashino","scryfallId":"8e02e9e6-4cff-404a-94a3-e844ef7cadee"},{"index":4726,"token":false,"name":"Revival Experiment","scryfallId":"694bfbbf-4246-4b2c-96a0-9e895b4f7709"},{"index":4727,"token":false,"name":"Journeyer's Kite","scryfallId":"5440121d-d3b5-4d26-a2d9-674af73d449a"},{"index":4728,"token":false,"name":"Riftwing Cloudskate","scryfallId":"7a150bc3-1d1a-4364-a97a-a71b6c09f6c9"},{"index":4729,"token":false,"name":"Spiritmonger","scryfallId":"733093ba-654a-4d80-ab6c-606a4841eb51"},{"index":4731,"token":false,"name":"Amulet of Vigor","scryfallId":"d62617c4-e3fc-4ac2-a969-aa33afcd76eb"},{"index":4732,"token":false,"name":"Lignify","scryfallId":"264fd6c5-8d73-4928-aed7-5ed637426780"},{"index":4733,"token":false,"name":"Hanna, Ship's Navigator","scryfallId":"a8a28b9c-9e47-48b9-8e09-7f3476a2d0b4"},{"index":4734,"token":false,"name":"Fleeting Distraction","scryfallId":"1ba49d16-e3e4-470a-8ca2-a93a5b358f6e"},{"index":4735,"token":false,"name":"Doomfall","scryfallId":"47d9bed8-6657-472c-9553-8def06ce9f23"},{"index":4736,"token":false,"name":"Elf Replica","scryfallId":"b92cce55-22ee-40a7-bb94-4889093f142c"},{"index":4737,"token":false,"name":"Magus of the Wheel","scryfallId":"62b6dde7-77b7-4993-b983-4beb110b2d83"},{"index":4739,"token":false,"name":"Harvest Hand // Scrounged Scythe","scryfallId":"0d200f98-3377-46a3-9197-3cbd95d03dbf"},{"index":4741,"token":false,"name":"Even the Odds","scryfallId":"f704cd76-dca8-4526-b03f-7e3753d8fbb5"},{"index":4742,"token":false,"name":"Surge of Thoughtweft","scryfallId":"e0b61fb2-11e5-45ae-873d-85f79f161950"},{"index":4744,"token":false,"name":"Pyramid of the Pantheon","scryfallId":"cef335b2-8086-4b29-b8e3-47de6faa1334"},{"index":4745,"token":false,"name":"Vampiric Tutor","scryfallId":"e7e778ce-3f1e-4626-8f55-bba03970d91a"},{"index":4746,"token":false,"name":"Overbeing of Myth","scryfallId":"11bbc404-a456-4a4b-af88-23921d80d671"},{"index":4747,"token":false,"name":"Great Furnace","scryfallId":"12d377a8-a088-4396-9183-a28b6a1cc017"},{"index":4748,"token":false,"name":"Wildfire Elemental","scryfallId":"272e317c-55c4-43b2-91aa-3e0009cfd7d5"},{"index":4749,"token":false,"name":"Premature Burial","scryfallId":"e96cea6a-fea6-4a6b-84b2-7b57237be96a"},{"index":4750,"token":false,"name":"Cubwarden","scryfallId":"f531cb03-edf0-4e46-9c89-e6e1a95112eb"},{"index":4754,"token":false,"name":"Glint","scryfallId":"db98d19a-9df3-41ae-a3cd-fc27b850b3e9"},{"index":4755,"token":false,"name":"Stonybrook Banneret","scryfallId":"3e3e9c6c-e11a-4771-ae1a-3c13cc97e92e"},{"index":4758,"token":false,"name":"Aerie Worshippers","scryfallId":"06c8b3b9-f0fb-4cc1-8916-82ee2c74f089"},{"index":4759,"token":false,"name":"Cranial Archive","scryfallId":"1284b15f-2a70-48d6-89d3-e787af3f07eb"},{"index":4760,"token":false,"name":"Solar Blaze","scryfallId":"3f6de1fd-12c6-4cbd-b8ce-09602787cf53"},{"index":4761,"token":false,"name":"Thicket Basilisk","scryfallId":"e92cce01-b3bd-4307-aae5-9a7c8fa386ab"},{"index":4762,"token":false,"name":"Pawn of Ulamog","scryfallId":"85f4d77d-e0de-48fe-899b-5718cee779e2"},{"index":4764,"token":false,"name":"Benefactor's Draught","scryfallId":"e40f3dfb-3c5d-468a-9e0e-610ad3e11787"},{"index":4767,"token":false,"name":"Mutavault","scryfallId":"927ed667-c228-4b96-a9f6-7cbadade8134"},{"index":4768,"token":false,"name":"Rivals' Duel","scryfallId":"3d42804d-b469-4fd4-98b3-c06a2fd52096"},{"index":4769,"token":false,"name":"Jetting Glasskite","scryfallId":"27e27d8f-3527-413d-a5d3-bced692e9034"},{"index":4770,"token":false,"name":"Lyra Dawnbringer","scryfallId":"93be6799-7b9d-44d4-84dc-2961692b5a85"},{"index":4771,"token":false,"name":"Silumgar's Scorn","scryfallId":"077bee72-62f6-4d90-8557-ff9cac42ec9a"},{"index":4772,"token":false,"name":"Leopard-Spotted Jiao","scryfallId":"91df110f-85d2-41cb-96b6-6c79cebfada7"},{"index":4773,"token":false,"name":"Wall of Brambles","scryfallId":"4650c604-57ef-4281-a6d7-dd567b2c539e"},{"index":4778,"token":false,"name":"Destructive Tampering","scryfallId":"e1f2e0c4-0ac2-42e8-ab45-148f6123ee58"},{"index":4781,"token":false,"name":"Embolden","scryfallId":"36848fb0-4070-40cf-b24a-2e8f47c5ebc3"},{"index":4783,"token":false,"name":"Sure Strike","scryfallId":"074dd176-4608-42ca-8fc3-c7040cd7b32e"},{"index":4784,"token":false,"name":"Logic Knot","scryfallId":"624feb0e-f683-4eb6-a63b-7872d0e28f1f"},{"index":4785,"token":false,"name":"Yavimaya Enchantress","scryfallId":"b60e2daa-3740-40f0-a333-8b7f4c2da34a"},{"index":4786,"token":false,"name":"Force of Rage","scryfallId":"0aaa2d10-3725-4b3a-94fe-3c6648db9a2a"},{"index":4787,"token":false,"name":"Hammerfist Giant","scryfallId":"446f946d-9715-466e-b322-905995d28107"},{"index":4789,"token":false,"name":"Spike Colony","scryfallId":"a45a1cbd-329b-4a76-92b4-1f0f60fc06e6"},{"index":4792,"token":false,"name":"Pyromancer's Assault","scryfallId":"b2c8dad1-278c-4ced-8124-5593b140d361"},{"index":4793,"token":false,"name":"Harrowing Journey","scryfallId":"9cf96a6c-8481-4954-b149-7153b80480be"},{"index":4794,"token":false,"name":"Outmuscle","scryfallId":"40d0ddcc-e6df-4fe1-9ac9-f895885ccc84"},{"index":4796,"token":false,"name":"Fierce Invocation","scryfallId":"0137de04-9fd7-41b0-b497-163e6e93432b"},{"index":4799,"token":false,"name":"Decoction Module","scryfallId":"b08ae769-0070-47a6-aae0-1a3bcfd40d07"},{"index":4800,"token":false,"name":"Identity Thief","scryfallId":"9865100f-dddc-407e-a379-2c285475ec89"},{"index":4801,"token":false,"name":"Goblin Fireslinger","scryfallId":"e6c043b7-1eec-4d11-986c-8fb3823fc3b1"},{"index":4802,"token":false,"name":"Blood Pet","scryfallId":"9ff08225-82a5-4636-be6a-d38d32f5663f"},{"index":4803,"token":false,"name":"Jade Guardian","scryfallId":"aca83e48-6e32-477f-8714-6103e77c06df"},{"index":4804,"token":false,"name":"Electrostatic Pummeler","scryfallId":"fcb18848-1754-4c2a-adf8-0bb9d4f8673d"},{"index":4805,"token":false,"name":"Trial // Error","scryfallId":"553028fc-eeab-42e2-9887-cf45ea3f01a6"},{"index":4808,"token":false,"name":"Flickering Ward","scryfallId":"d4d2b011-bb0d-463c-bf2a-04b6650771a3"},{"index":4811,"token":false,"name":"Lhurgoyf","scryfallId":"770afb99-e80e-4214-9422-27c94d688af9"},{"index":4812,"token":false,"name":"Goblin Warrens","scryfallId":"2d8ce8ad-2bb9-4c53-8e36-9690e8a118f1"},{"index":4814,"token":false,"name":"Rankle, Master of Pranks","scryfallId":"7d767e41-99fc-47aa-ad16-27e1368315a6"},{"index":4817,"token":false,"name":"Kin-Tree Invocation","scryfallId":"926b49a1-f220-41ab-8c67-8354a91a15e8"},{"index":4819,"token":false,"name":"Vapor Snag","scryfallId":"59f26d0a-e9f3-442f-b5c6-8016cf736432"},{"index":4820,"token":false,"name":"Void Shatter","scryfallId":"4bf13c5e-3968-48ad-ba08-99ba58873223"},{"index":4821,"token":false,"name":"The Chain Veil","scryfallId":"0df7a6c7-0c48-42e7-9e2d-7ac21855cdbb"},{"index":4822,"token":false,"name":"Trinisphere","scryfallId":"6a78299b-27bc-4730-bcb3-75fabc8f92c7"},{"index":4823,"token":false,"name":"Ob Nixilis, Unshackled","scryfallId":"109b28dc-c0d1-4b88-b18e-074ac0464e03"},{"index":4824,"token":false,"name":"Mayael's Aria","scryfallId":"bfd6f5dc-2fa6-450a-a1b1-6b6e31773365"},{"index":4825,"token":false,"name":"Thoughts of Ruin","scryfallId":"2a0f2db3-41a6-4283-9812-46b6ae6d1df6"},{"index":4826,"token":false,"name":"Ajani, the Greathearted","scryfallId":"00b33e71-ef08-4aeb-bca2-a2a4a43c2e0d"},{"index":4827,"token":false,"name":"Coercion","scryfallId":"f3b07d33-f5f5-45cc-b2ac-360eaf2d4146"},{"index":4828,"token":false,"name":"Sylvan Scrying","scryfallId":"1f882c71-dd90-4eac-9756-0bf487cba625"},{"index":4831,"token":false,"name":"Blessed Spirits","scryfallId":"4ffa548f-3c72-40a8-9ca9-8e7ae8bab838"},{"index":4832,"token":false,"name":"Leonin Bladetrap","scryfallId":"de829013-dd6a-47a7-afd4-a2bda0da6ac5"},{"index":4833,"token":false,"name":"Copper Carapace","scryfallId":"24eb220b-3ff1-4396-87e3-7aaaa1098691"},{"index":4834,"token":false,"name":"Benthic Explorers","scryfallId":"397d7602-d374-484c-aab2-3e57f12ceaa4"},{"index":4836,"token":false,"name":"God-Eternal Kefnet","scryfallId":"5e14060f-9167-4e28-a053-77689e066e30"},{"index":4837,"token":false,"name":"Managorger Hydra","scryfallId":"1a08e5ab-1ff9-4470-ab28-fea19bb79845"},{"index":4838,"token":false,"name":"Adventurous Impulse","scryfallId":"197d7b7c-456f-478e-950e-38610e07435d"},{"index":4839,"token":false,"name":"King Suleiman","scryfallId":"4d3dce0f-2168-4f63-b2f9-156a11beeea7"},{"index":4842,"token":false,"name":"Price of Progress","scryfallId":"52fdf6bf-c383-416e-9bf8-42347ba846ad"},{"index":4844,"token":false,"name":"Gemrazer","scryfallId":"d75546a5-81fd-41c1-a081-d8980f6bd60a"},{"index":4849,"token":false,"name":"Bosh, Iron Golem","scryfallId":"fb87532e-9d81-444d-b3ef-69b2528b6311"},{"index":4850,"token":false,"name":"Knowledge Vault","scryfallId":"c416fca6-e201-4dbc-b9c7-248d70967746"},{"index":4851,"token":false,"name":"Shriekmaw","scryfallId":"5aa05888-8766-4443-b4bb-b42150ccc0ec"},{"index":4852,"token":true,"name":"Elemental Token (U, 1/0)","scryfallId":"f0e68ed9-d863-4822-b281-e184f3d62faa"},{"index":4854,"token":false,"name":"Gratuitous Violence","scryfallId":"093e3fc5-b2e0-4376-b8ad-4470e02e3f63"},{"index":4855,"token":false,"name":"Ardent Recruit","scryfallId":"69c42dac-f0b3-41aa-b3b2-f203e265131d"},{"index":4856,"token":false,"name":"Magus of the Order","scryfallId":"a93e5fa9-cfe3-487b-af77-0dbf6c68ee04"},{"index":4857,"token":false,"name":"Man-o'-War","scryfallId":"5eaa4199-df9b-494a-af7a-2491e8b0ef70"},{"index":4859,"token":false,"name":"Escape to the Wilds","scryfallId":"1bff641e-aad3-414f-ad5b-8d32c734efa9"},{"index":4860,"token":false,"name":"Survivor of the Unseen","scryfallId":"8a28c9cb-ae41-4f9c-b3f6-151ef95c81b3"},{"index":4861,"token":false,"name":"Commanding Presence","scryfallId":"24e2f681-918e-4f1f-afb1-0f9587c0d7bf"},{"index":4862,"token":false,"name":"Skyscanner","scryfallId":"eb1b7a49-f89f-4c38-8c0f-9260f855d00c"},{"index":4863,"token":false,"name":"Rhystic Deluge","scryfallId":"0a3dd540-7f54-46fe-b1e8-7b07f57e71d0"},{"index":4864,"token":false,"name":"Nessian Courser","scryfallId":"4697f3aa-abde-4379-af82-f30115f59be0"},{"index":4865,"token":false,"name":"Emrakul, the Promised End","scryfallId":"8d74a469-c71d-4773-99d3-5456b31df424"},{"index":4867,"token":false,"name":"Moat","scryfallId":"952ba126-0915-47f0-9b6a-a0a6dcd22c6f"},{"index":4868,"token":false,"name":"Final Flare","scryfallId":"f0c95dee-a480-4878-a967-9e46be9ee372"},{"index":4869,"token":false,"name":"Lake of the Dead","scryfallId":"008d7611-eaee-4474-bf16-30d11b5d310f"},{"index":4870,"token":false,"name":"Ringwarden Owl","scryfallId":"1acf216d-ef8f-431b-9b65-1e2e91285517"},{"index":4872,"token":false,"name":"Sanguine Guard","scryfallId":"2c1fa0c5-8eef-484e-9d5f-38e87d99ed73"},{"index":4875,"token":false,"name":"Vendetta","scryfallId":"67ced38e-0f33-4bda-8e18-09f6ac03a3d7"},{"index":4876,"token":false,"name":"Debilitating Injury","scryfallId":"79a47c13-fad4-4399-ae49-cc7d190c5ec1"},{"index":4877,"token":false,"name":"Spite of Mogis","scryfallId":"5676d255-707e-4621-a0df-3305f999f124"},{"index":4878,"token":false,"name":"Nature's Claim","scryfallId":"2144f53e-5f3b-4ee4-8b2a-b7cb22fa14ca"},{"index":4879,"token":false,"name":"Survive the Night","scryfallId":"d032a2b2-81a8-4b4b-a582-5bfa1afda829"},{"index":4880,"token":false,"name":"Furious Reprisal","scryfallId":"e3eeeecd-1d62-49f3-82b0-60f1f5e57d97"},{"index":4881,"token":false,"name":"Rot Shambler","scryfallId":"1a403b28-f91a-4637-af72-d6fc86c3bb9a"},{"index":4882,"token":false,"name":"Snap","scryfallId":"f7e0549e-2d23-4ea8-b8d1-ae21af2c9091"},{"index":4883,"token":false,"name":"Urza's Miter","scryfallId":"438f0c61-a61d-4a9e-b21f-4e86420c7913"},{"index":4884,"token":false,"name":"Kambal, Consul of Allocation","scryfallId":"55259ef8-b4d5-495e-ac41-d074bf474bb7"},{"index":4885,"token":false,"name":"Dungeon Geists","scryfallId":"030fe26c-0bef-4cd6-bb37-1bbe4b9c20ca"},{"index":4887,"token":false,"name":"Chromatic Star","scryfallId":"117fded3-1157-41a3-b37a-e76dcd1b5447"},{"index":4888,"token":false,"name":"Xathrid Necromancer","scryfallId":"26494f96-1d97-4435-a116-3ade1becaab4"},{"index":4890,"token":false,"name":"Cleric of Life's Bond","scryfallId":"953db280-6999-4b91-bc40-c6e7f7dd13ef"},{"index":4891,"token":false,"name":"Temur Sabertooth","scryfallId":"2bf59e8d-0746-440d-878f-d6f6f74610d8"},{"index":4892,"token":false,"name":"Lava Blister","scryfallId":"cd0e9e53-2710-4c2a-a8e4-48f25375ebc7"},{"index":4894,"token":false,"name":"Jhessian Thief","scryfallId":"1227fb31-2780-48e2-9790-4a7e9a413f75"},{"index":4895,"token":false,"name":"Thalia, Heretic Cathar","scryfallId":"ab0cee38-5e24-49d0-870c-22843ed4e101"},{"index":4896,"token":true,"name":"Unwavering Initiate Token (W, 3/2)","scryfallId":"07ab720d-40fc-4315-bc8d-c7073cea588b"},{"index":4898,"token":false,"name":"Alchemist's Greeting","scryfallId":"7b68c607-27f2-4a00-9876-186b5a426764"},{"index":4899,"token":false,"name":"Dawnglare Invoker","scryfallId":"37128dc6-86a7-408d-a1e8-6728d584fbf9"},{"index":4904,"token":false,"name":"Krav, the Unredeemed","scryfallId":"0a255a75-2fbd-43d5-974e-8196da0be810"},{"index":4905,"token":false,"name":"Skeletal Vampire","scryfallId":"7cb8d6b0-13c1-4b04-9a92-1b87f2b7c1ea"},{"index":4909,"token":false,"name":"Sunblade Angel","scryfallId":"9211c0e1-b314-495f-9c43-9a0e95c9efb9"},{"index":4912,"token":false,"name":"Sorceress Queen","scryfallId":"b83d7331-e573-4dea-901a-de9150d4b5c0"},{"index":4913,"token":false,"name":"Regress","scryfallId":"e869775f-72fa-463f-a46a-7c3e955f8590"},{"index":4915,"token":false,"name":"Angelic Captain","scryfallId":"ef0baf56-816a-4e0a-beb3-73b51487ff00"},{"index":4916,"token":false,"name":"Scrap Trawler","scryfallId":"53b6212c-b4eb-44a7-88db-8e9fa1ee2167"},{"index":4917,"token":false,"name":"Gravetiller Wurm","scryfallId":"66d9fe36-2eac-49e3-8f89-810009ba8a4b"},{"index":4918,"token":false,"name":"Devouring Rage","scryfallId":"608a6e1e-3e95-4ce4-aaf6-5f14c0456850"},{"index":4920,"token":false,"name":"Armored Ascension","scryfallId":"15ebbb4e-9e1d-49f5-b05b-ae59df0deb17"},{"index":4922,"token":false,"name":"Spark Trooper","scryfallId":"09eb69b5-b8e2-48c6-8c27-cb0108df8dad"},{"index":4923,"token":false,"name":"Fractal Harness","scryfallId":"b7fdad91-fa92-42b6-ad44-f4a3819212f2"},{"index":4925,"token":false,"name":"Call of the Nightwing","scryfallId":"f299929e-507f-4e94-96ca-49708181a4f7"},{"index":4926,"token":false,"name":"Lantern Spirit","scryfallId":"b50a5772-f411-458a-97f9-9f3967bb79c5"},{"index":4929,"token":false,"name":"Whispers of Emrakul","scryfallId":"0b7ba428-5a35-4062-8e16-39eb927cb316"},{"index":4932,"token":false,"name":"Brilliant Halo","scryfallId":"3d454961-1ab3-442b-935d-68c25b56aea0"},{"index":4934,"token":false,"name":"Migratory Route","scryfallId":"3c5ed87f-a439-4136-a8c4-9f6a694c459b"},{"index":4935,"token":false,"name":"Diabolic Machine","scryfallId":"80520091-1c80-41d8-8c1d-f11ae7d15d90"},{"index":4936,"token":false,"name":"Alms Collector","scryfallId":"9fe88f96-fd3a-44e5-aa05-3bc63581e33d"},{"index":4941,"token":false,"name":"Admonition Angel","scryfallId":"4800ebc2-d5a7-4c26-a2f7-943a540ae47e"},{"index":4942,"token":false,"name":"Judith, the Scourge Diva","scryfallId":"0a742125-730d-4082-bfd8-5feb7733def4"},{"index":4943,"token":false,"name":"Gloom Surgeon","scryfallId":"1b00c711-007d-4c85-9dd9-dd9d52f1649d"},{"index":4944,"token":false,"name":"Thraben Gargoyle // Stonewing Antagonizer","scryfallId":"f2687683-2986-4e22-97d9-7820c870475b"},{"index":4945,"token":false,"name":"Scorching Spear","scryfallId":"9e4817bd-68e8-4a85-983a-ee6dda2bbf33"},{"index":4946,"token":false,"name":"Fendeep Summoner","scryfallId":"10fb2b62-eea7-469f-b237-fdce20b8bdcf"},{"index":4947,"token":false,"name":"Dryad Arbor","scryfallId":"8cee476d-42e1-4997-87af-73e18f542167"},{"index":4948,"token":false,"name":"Trespasser's Curse","scryfallId":"0e467a14-00b5-4dfb-9c3a-4e064de1b5fc"},{"index":4950,"token":false,"name":"Sacred Prey","scryfallId":"e965d32c-3151-48e8-b256-0b7fa8a8a211"},{"index":4951,"token":false,"name":"Shaman of the Pack","scryfallId":"9eedf655-771d-4a08-a24a-3dc5d1725314"},{"index":4952,"token":false,"name":"Reverse Engineer","scryfallId":"9307ffe1-a24c-4a33-8948-a88cc1c7dc32"},{"index":4953,"token":false,"name":"Wild Nacatl","scryfallId":"a7ab68bf-c574-41bc-813e-944de7b20f33"},{"index":4954,"token":false,"name":"Entomb","scryfallId":"466d6254-4d5c-4f66-a018-eb4a3ec1881c"},{"index":4955,"token":false,"name":"Eidolon of Obstruction","scryfallId":"02694fb6-7695-4296-b5d6-cfe60829f1e7"},{"index":4956,"token":false,"name":"Taigam, Sidisi's Hand","scryfallId":"6d378caf-93e9-45ff-95ea-8d105d034021"},{"index":4957,"token":false,"name":"Scourge Wolf","scryfallId":"fb355176-143a-4edd-9a2d-53293c445b8a"},{"index":4959,"token":true,"name":"Elemental Token (G, 4/4)","scryfallId":"8b4ef48d-a328-4eb9-a2e3-925c1cd38b1a"},{"index":4960,"token":false,"name":"Memnite","scryfallId":"73b13472-3de8-4117-9c32-1ee6b149a2e2"},{"index":4961,"token":false,"name":"Marsh Flats","scryfallId":"9e1e76a2-ec37-4fd8-8185-f98f675ff0cb"},{"index":4962,"token":false,"name":"Headstone","scryfallId":"2fdae7fa-1076-4ff3-b771-fc3f5d9ba89f"},{"index":4964,"token":false,"name":"Viridian Revel","scryfallId":"2d7f565e-0fb8-40c8-9540-213d35af846a"},{"index":4965,"token":false,"name":"Basalt Gargoyle","scryfallId":"9d49201b-bd41-49b7-b00e-4ab8034a3a03"},{"index":4966,"token":false,"name":"Sage of the Inward Eye","scryfallId":"fca25454-6b18-4d37-a069-7d53f5ebdb14"},{"index":4967,"token":false,"name":"Walker of Secret Ways","scryfallId":"4bd06752-a40a-4761-9d70-f65bead86c8f"},{"index":4968,"token":false,"name":"Arlinn, Voice of the Pack","scryfallId":"8de4dd9b-46d5-4141-9a72-000d96698e74"},{"index":4969,"token":false,"name":"Vito, Thorn of the Dusk Rose","scryfallId":"0fe79ee4-c3f3-4a6b-a967-203ca3b70ee5"},{"index":4970,"token":false,"name":"Healing Technique","scryfallId":"33897125-a1df-4d7a-a45a-9c049cb662f6"},{"index":4971,"token":false,"name":"Alrund's Epiphany","scryfallId":"c94fcb53-a7bd-4a80-a536-9fb0eb24261a"},{"index":4974,"token":false,"name":"Ardenn, Intrepid Archaeologist","scryfallId":"6eb712a0-b648-460b-8d3d-7d920ed11a8c"},{"index":4975,"token":false,"name":"Academy Ruins","scryfallId":"a95b7645-154f-4904-bf71-db7eb24d4df2"},{"index":4976,"token":false,"name":"Goblin Mountaineer","scryfallId":"66a072ec-717c-453e-a331-49056e3d917d"},{"index":4977,"token":true,"name":"Ooze Token (G, */*)","scryfallId":"2a9cea73-9421-4f91-b8f9-1a8081b3811a"},{"index":4978,"token":false,"name":"Soulstinger","scryfallId":"876a4141-6412-45d3-9e00-e86003b367ce"},{"index":4979,"token":false,"name":"Desert","scryfallId":"b94cad14-1324-4611-9024-3839d01a82d9"},{"index":4982,"token":false,"name":"Spectator Seating","scryfallId":"b16e9306-79bc-451a-9046-6a0f8d4b9606"},{"index":4983,"token":false,"name":"Leaping Lizard","scryfallId":"81665785-88f2-43e4-aebc-1086c5d908ca"},{"index":4984,"token":false,"name":"Thraben Inspector","scryfallId":"d140c3b7-ca78-483d-baeb-307b624fea8b"},{"index":4987,"token":false,"name":"Braingeyser","scryfallId":"23b33d16-dbaa-4742-9317-eac745f772ac"},{"index":4989,"token":false,"name":"Repentant Vampire","scryfallId":"2c1dbad4-1105-4426-8d4d-a30f6fa95ce8"},{"index":4991,"token":false,"name":"Estrid, the Masked","scryfallId":"fab1667b-f8ca-424c-8e6a-275fc2522f7d"},{"index":4992,"token":false,"name":"Boldwyr Intimidator","scryfallId":"453fd37e-5455-471c-aef5-c048f5f0c201"},{"index":4994,"token":false,"name":"Ainok Bond-Kin","scryfallId":"22d2a844-17fc-4628-9591-684555e98f7b"},{"index":4995,"token":false,"name":"Garruk, Cursed Huntsman","scryfallId":"673b6205-3bf6-4bae-a8e4-17387719be44"},{"index":4998,"token":false,"name":"Chasm Skulker","scryfallId":"92a08fad-56ad-4437-9bb8-6d016c1c714f"},{"index":5001,"token":false,"name":"Force Spike","scryfallId":"97a6c6c9-dd26-4ce7-850f-0b3fc49245bd"},{"index":5002,"token":false,"name":"Goblins of the Flarg","scryfallId":"cb91b7c0-c453-481b-9d3d-0223057291ed"},{"index":5003,"token":false,"name":"Legacy's Allure","scryfallId":"649a89c5-71bd-4fee-ae35-78081e4e0353"},{"index":5007,"token":false,"name":"Olivia, Mobilized for War","scryfallId":"7297dd81-8367-42e9-abf9-9227e202e7ae"},{"index":5008,"token":false,"name":"Grixis Panorama","scryfallId":"356c3e6a-e51f-44e2-942c-e5c247e4a9bd"},{"index":5009,"token":false,"name":"Punish the Enemy","scryfallId":"4179a72b-8482-46ec-9815-f5d6d94b5aa5"},{"index":5010,"token":false,"name":"Hollowsage","scryfallId":"b6618713-0573-44f6-82d9-dfc16dfef052"},{"index":5011,"token":false,"name":"Henge Walker","scryfallId":"9925f0bc-8685-4e38-8864-0ad3a9549ab5"},{"index":5013,"token":false,"name":"Descend upon the Sinful","scryfallId":"541af167-d28a-4d34-9bbe-d93be71d1f73"},{"index":5014,"token":false,"name":"Storm Spirit","scryfallId":"7a383a5f-4814-4b92-aa80-2a6440a719bc"},{"index":5015,"token":false,"name":"Captain's Hook","scryfallId":"6e7123eb-e5af-41a9-97f6-9233d111359e"},{"index":5017,"token":false,"name":"Ranar the Ever-Watchful","scryfallId":"1c8c41dd-8551-4ce8-a9be-9b9f65718852"},{"index":5018,"token":false,"name":"Flamekin Village","scryfallId":"88d589b9-2da2-4323-ae9d-086a6d5ab2bf"},{"index":5019,"token":false,"name":"Selhoff Occultist","scryfallId":"94975b02-f678-4442-9d1a-cf586aee8789"},{"index":5020,"token":false,"name":"Memory Sluice","scryfallId":"5fd93980-55f6-43a0-87db-5fa1203aa7b6"},{"index":5023,"token":false,"name":"Ajani Steadfast","scryfallId":"370e6f6f-67a7-4eea-9a33-efbb64783e4a"},{"index":5024,"token":false,"name":"Sparktongue Dragon","scryfallId":"69e64ce4-f9e8-4d36-b649-717b1cb8992f"},{"index":5026,"token":false,"name":"Curious Pair // Treats to Share","scryfallId":"4f8ca405-f3e2-4efd-9f31-2acc44fefc1b"},{"index":5027,"token":false,"name":"Seraph of the Scales","scryfallId":"25938792-397a-4e9b-bf89-cc04d82cdea1"},{"index":5028,"token":false,"name":"Pore Over the Pages","scryfallId":"b2288f7b-05b1-4a6c-8d02-42ffcadc6f0b"},{"index":5029,"token":false,"name":"Take Heart","scryfallId":"b26f10d5-b826-45b0-abed-80d86e1335c9"},{"index":5032,"token":false,"name":"Wizard Replica","scryfallId":"0678cc06-061b-4e8a-9727-23279d3c9df1"},{"index":5033,"token":false,"name":"Personal Incarnation","scryfallId":"0b107c80-0c9a-46cd-8f00-26c37f080ce7"},{"index":5034,"token":false,"name":"Bear's Companion","scryfallId":"d6912c5b-6aff-4506-96ca-acb5ce660322"},{"index":5036,"token":false,"name":"Thran Foundry","scryfallId":"33dfdeef-a433-4395-aa0c-d25544ae8824"},{"index":5037,"token":false,"name":"Conqueror's Galleon // Conqueror's Foothold","scryfallId":"c92712f9-2ee6-441e-b103-6d43410cf01d"},{"index":5038,"token":false,"name":"Myriad Landscape","scryfallId":"e447a118-32b8-4312-bb89-a3a0e6b89c71"},{"index":5039,"token":false,"name":"Tarpan","scryfallId":"d2160d57-9ebf-43fb-811f-0c014e417ea0"},{"index":5040,"token":false,"name":"Murderous Rider // Swift End","scryfallId":"e73d8a84-2c0d-423c-89c7-71de0af9e1ac"},{"index":5042,"token":false,"name":"Attended Knight","scryfallId":"eac22a3b-4536-4372-a854-bc7f0919830b"},{"index":5043,"token":false,"name":"Idle Thoughts","scryfallId":"797f80be-019d-4e44-a48d-43c6e52d2ab5"},{"index":5044,"token":false,"name":"Talus Paladin","scryfallId":"4f5212f4-f04c-4ca3-b254-654bb263829b"},{"index":5045,"token":false,"name":"Extus, Oriq Overlord // Awaken the Blood Avatar","scryfallId":"ba09360a-067e-48a5-bdc5-a19fd066a785"},{"index":5046,"token":false,"name":"Lava Zombie","scryfallId":"fd87185b-1242-4fb3-abee-44bc267ee5fb"},{"index":5047,"token":false,"name":"Sangrite Surge","scryfallId":"801b10d7-be9f-4bad-872d-d91db7608a9e"},{"index":5048,"token":false,"name":"Keeper of Tresserhorn","scryfallId":"aaf8b0ec-f81a-488c-850c-098a8a3119e5"},{"index":5049,"token":true,"name":"Dragon Egg Token (R, 0/2)","scryfallId":"0e80f154-9409-40fa-a564-6fc296498d80"},{"index":5050,"token":false,"name":"Charging Rhino","scryfallId":"90341fb4-ac97-43ff-ae2d-0fe5995e7fd7"},{"index":5051,"token":false,"name":"Thirst for Knowledge","scryfallId":"b936c609-835d-4bb5-8ac6-c942b23b4654"},{"index":5052,"token":false,"name":"Silent Skimmer","scryfallId":"9b715fc0-9c36-4619-8d65-6d1064ed8a32"},{"index":5054,"token":false,"name":"Barbed Sextant","scryfallId":"db9791ab-1cc4-41ad-a721-57f214c357f8"},{"index":5059,"token":false,"name":"Satyr Hedonist","scryfallId":"88c67e15-833c-406a-b75f-8de97fbacf5a"},{"index":5060,"token":false,"name":"Beastmaster's Magemark","scryfallId":"7b5eea61-373a-4bca-a793-d6be7f6214e2"},{"index":5061,"token":false,"name":"Orzhov Guildmage","scryfallId":"d898743b-7e0f-4339-963e-aa4232c681ec"},{"index":5062,"token":false,"name":"Nimbus Maze","scryfallId":"80d1f953-9403-4e0a-b8e1-3f7d928a2834"},{"index":5063,"token":false,"name":"Assassin's Trophy","scryfallId":"906b6e99-128f-4c11-8daf-16099d35b0d4"},{"index":5066,"token":false,"name":"Snow-Covered Island","scryfallId":"6abf0692-07d1-4b72-af06-93d0e338589d"},{"index":5067,"token":false,"name":"Goblin Arsonist","scryfallId":"cc6f5598-6fbd-4808-bae6-e4d62ce6d315"},{"index":5069,"token":false,"name":"Nyxbloom Ancient","scryfallId":"b57909d8-b3e6-4aed-9065-e69d143ee7a4"},{"index":5070,"token":false,"name":"Dormant Sliver","scryfallId":"3d646252-6d42-4000-bfc1-ad12f2386b99"},{"index":5072,"token":false,"name":"Forsaken Monument","scryfallId":"ca7e891b-a302-4c8b-897a-fa17e64156df"},{"index":5073,"token":false,"name":"Liliana's Spoils","scryfallId":"e960fb5a-70cc-490d-99cf-99bc65485cfb"},{"index":5074,"token":false,"name":"Forest Bear","scryfallId":"fae9abc7-ecd3-4042-a5b0-5f2b24491fa6"},{"index":5076,"token":false,"name":"Soul Shepherd","scryfallId":"f45a39ba-5fbf-46c3-8dc7-3058ac6d24e8"},{"index":5079,"token":false,"name":"Infernal Caretaker","scryfallId":"8a028a30-6242-4d87-9501-d1826ecb69b0"},{"index":5081,"token":false,"name":"Reconstruction","scryfallId":"052a63b3-4225-448f-817c-62cffca534e2"},{"index":5082,"token":false,"name":"Indulgent Aristocrat","scryfallId":"f24200d4-cd98-424c-bc2f-69f8b361d8fc"},{"index":5083,"token":false,"name":"Fulminator Mage","scryfallId":"be1df367-8e85-4fd8-aa6f-f02a478fecb3"},{"index":5084,"token":false,"name":"Fortified Area","scryfallId":"3662a9df-c954-440c-93fa-fa126845f615"},{"index":5086,"token":false,"name":"Crystal Rod","scryfallId":"f973046b-ce81-4e35-89f3-a6e857d751b8"},{"index":5087,"token":false,"name":"Cadaverous Knight","scryfallId":"86dc3679-9832-46e4-b5f8-c78bf5249a5e"},{"index":5089,"token":false,"name":"Coffin Purge","scryfallId":"541e06cb-5616-40b4-9d36-89471a795ac8"},{"index":5091,"token":false,"name":"Champion of Lambholt","scryfallId":"af185b08-4511-4720-b029-4ce01056d8d3"},{"index":5092,"token":false,"name":"Surrakar Banisher","scryfallId":"27e88b32-ba7a-4a40-bbe6-903303079570"},{"index":5093,"token":false,"name":"Stitched Drake","scryfallId":"c897804e-4993-4b5c-971c-96827fc3a725"},{"index":5095,"token":false,"name":"Lowland Giant","scryfallId":"6d8ce76f-8ced-4ee9-a450-1bcc27d36e7d"},{"index":5096,"token":false,"name":"Void Beckoner","scryfallId":"29ae88c2-1f9b-4515-9f2e-78e1dc5468b1"},{"index":5097,"token":false,"name":"Court of Ire","scryfallId":"73ca0dcc-7a87-49da-8011-8c11a8835df2"},{"index":5098,"token":false,"name":"Aven Wind Guide","scryfallId":"878d4576-8079-4555-938b-1e318c5f332e"},{"index":5100,"token":false,"name":"Wayfaring Temple","scryfallId":"77d4920f-94f7-4780-9c5f-f0df6f6d3d6e"},{"index":5101,"token":false,"name":"Armory Guard","scryfallId":"2a907337-8096-4110-8b83-be7eba309dc9"},{"index":5102,"token":false,"name":"Ravaging Horde","scryfallId":"6278d679-fc54-4527-ab16-90735574ab9b"},{"index":5103,"token":false,"name":"Elvish Warrior","scryfallId":"d0670e0c-0235-4efb-8eee-e8e72c629037"},{"index":5104,"token":false,"name":"Coiled Tinviper","scryfallId":"426a28bd-033d-41af-b577-ece73cbd7b3a"},{"index":5106,"token":false,"name":"Holy Light","scryfallId":"34fbb723-2507-489a-acf1-22ac0dcbcd9c"},{"index":5107,"token":false,"name":"Goblin Dark-Dwellers","scryfallId":"e4372442-789f-483c-82ab-3ee2218cf470"},{"index":5108,"token":false,"name":"Lonesome Unicorn // Rider in Need","scryfallId":"68fe8de1-8c3b-4e05-9d4a-67d979184980"},{"index":5109,"token":false,"name":"Burning of Xinye","scryfallId":"9aae2b96-36f5-4492-a942-cc988408b1e4"},{"index":5112,"token":false,"name":"Cultivator's Caravan","scryfallId":"402f4d64-7606-40c6-a90a-6e902e39f869"},{"index":5116,"token":false,"name":"Eyeblight's Ending","scryfallId":"e0c08701-7038-4d6b-bbf8-056fd8ffb226"},{"index":5117,"token":false,"name":"Chaos Moon","scryfallId":"aae0543f-7f8b-4327-b735-ac21244e9936"},{"index":5118,"token":false,"name":"Thran Temporal Gateway","scryfallId":"a97dfa1c-8f9a-4699-9575-867e9de622d1"},{"index":5119,"token":false,"name":"Terminate","scryfallId":"d55fe100-bbc5-49f8-ab64-5bd0b34f325f"},{"index":5121,"token":false,"name":"Godsire","scryfallId":"77cc7ff8-375b-45db-96a1-7142cc5403d8"},{"index":5122,"token":false,"name":"Ancient Tomb","scryfallId":"bd3d4b4b-cf31-4f89-8140-9650edb03c7b"},{"index":5123,"token":false,"name":"Writ of Passage","scryfallId":"abd58eee-1108-49be-9ae7-da179fb081c2"},{"index":5124,"token":false,"name":"Curse of Thirst","scryfallId":"a23ed5d1-44dc-4733-9e01-65fbc5dc02f2"},{"index":5125,"token":false,"name":"Ore-Scale Guardian","scryfallId":"e789333b-21ee-4613-8eba-52a719b0f1e5"},{"index":5127,"token":false,"name":"Wolverine Pack","scryfallId":"fab6d1e8-0985-4560-aea2-7ad1925a2f5a"},{"index":5128,"token":false,"name":"Font of Agonies","scryfallId":"d7c02aec-4a89-4ccc-8525-6f979c10d799"},{"index":5129,"token":false,"name":"Ixidron","scryfallId":"c30ec372-5cf7-471c-b3fd-411095fc249a"},{"index":5130,"token":false,"name":"Staff of the Ages","scryfallId":"5c709836-55b6-4de9-b190-b5f66dc53c87"},{"index":5131,"token":false,"name":"Reckless Amplimancer","scryfallId":"bc8072b1-6080-45cd-b1c7-353b54a55931"},{"index":5132,"token":false,"name":"Staff of the Flame Magus","scryfallId":"0fd137db-296a-4c17-ba46-8b189d96c1f9"},{"index":5134,"token":false,"name":"Fork","scryfallId":"e6b43916-fe2d-417a-a550-d7c795023297"},{"index":5136,"token":false,"name":"Skyreaping","scryfallId":"40eb76b3-b527-4ed8-8ce3-d3de48562b6e"},{"index":5137,"token":false,"name":"Arcane Subtraction","scryfallId":"68cdb00c-ea86-4b72-8f62-570820edfa1b"},{"index":5138,"token":false,"name":"Invisible Stalker","scryfallId":"14d265aa-c1d8-4faa-b282-5c273ab725fd"},{"index":5139,"token":false,"name":"Weatherseed Treefolk","scryfallId":"dd9ee91a-293d-4222-b7c3-18f0752f5f76"},{"index":5140,"token":false,"name":"Barrel Down Sokenzan","scryfallId":"02c52e00-ad17-42aa-9f5f-38fb52dad5ea"},{"index":5141,"token":false,"name":"Dismal Backwater","scryfallId":"ebfed84b-6fc7-41c4-91f0-4b46dcd46aed"},{"index":5142,"token":false,"name":"Okaun, Eye of Chaos","scryfallId":"ec874b1b-0bdc-47c8-a2a8-15ec47ea3510"},{"index":5143,"token":false,"name":"Guile","scryfallId":"0a837cde-356e-40b1-8434-5799acdaa946"},{"index":5144,"token":false,"name":"Bramblewood Paragon","scryfallId":"ca687bef-3503-4020-a054-953152be7aad"},{"index":5146,"token":false,"name":"Syphon Mind","scryfallId":"72f2d9a7-ae9f-4332-a5ec-11da7141bcbd"},{"index":5148,"token":false,"name":"Kessig Dire Swine","scryfallId":"9235ac46-dac9-46e6-9c7f-a69caaee1a2e"},{"index":5149,"token":false,"name":"Rowan, Scholar of Sparks // Will, Scholar of Frost","scryfallId":"9bf78711-0e41-458d-9841-72b173f092d0"},{"index":5150,"token":false,"name":"Disciple of Grace","scryfallId":"1d1790cb-34e4-4f23-8a13-1906fd9a956f"},{"index":5152,"token":false,"name":"Phyrexian Delver","scryfallId":"36cb477d-85b1-4cb4-a4b7-c700a3a0e148"},{"index":5154,"token":false,"name":"Nullmage Shepherd","scryfallId":"c4a15a09-cf68-411a-a18d-aaad00d308c9"},{"index":5155,"token":false,"name":"Necromantic Summons","scryfallId":"3afe7891-09d5-470e-aa41-71d89249875b"},{"index":5156,"token":false,"name":"Quartzwood Crasher","scryfallId":"39e1effa-92a6-4e8c-9cd6-fc57ae7b3cbf"},{"index":5157,"token":false,"name":"Vanishing Verse","scryfallId":"2d19559a-55e2-4991-b48f-e5ea4dd1b7e9"},{"index":5158,"token":false,"name":"Bottle of Suleiman","scryfallId":"d1924860-4532-40c2-b0e8-28584d22ccb5"},{"index":5163,"token":false,"name":"Fiery Temper","scryfallId":"fc8282aa-5347-44c7-8397-609aed82bc8c"},{"index":5164,"token":false,"name":"Vantress Gargoyle","scryfallId":"dc201a44-608a-4e04-8454-6f802a903e8f"},{"index":5165,"token":false,"name":"Groundskeeper","scryfallId":"424d7132-0f7a-48c7-beb6-37fc114113da"},{"index":5167,"token":false,"name":"Nature's Spiral","scryfallId":"af72071d-e1d2-45f7-94ad-2bdf2c67e819"},{"index":5170,"token":false,"name":"Enemy of the Guildpact","scryfallId":"3dcc7d53-2510-4322-969c-1e138287562c"},{"index":5171,"token":false,"name":"Mind's Dilation","scryfallId":"fe5b7a96-954d-44ad-8365-318ae6ddb573"},{"index":5174,"token":false,"name":"Remorseless Punishment","scryfallId":"1dde9379-b335-400f-9748-a7ca3e293ee0"},{"index":5175,"token":false,"name":"Unmask","scryfallId":"2db7a0e6-eea5-4fa6-ac14-401411b106cc"},{"index":5176,"token":false,"name":"Regna, the Redeemer","scryfallId":"0c2bf475-9845-40ed-9f55-669325fb6183"},{"index":5177,"token":true,"name":"Insect Token (B, 1/1)","scryfallId":"242c381e-df58-4365-a68c-add1127a83cc"},{"index":5178,"token":false,"name":"Solfatara","scryfallId":"c5d4bd6f-b019-4594-aa41-138fa58ba529"},{"index":5179,"token":false,"name":"Elspeth Conquers Death","scryfallId":"66c4b6c9-81a0-4b13-8504-28768ce1017c"},{"index":5180,"token":false,"name":"Caregiver","scryfallId":"0c33d3fe-cdd3-4829-8f10-6611f063983b"},{"index":5181,"token":false,"name":"Vivid Marsh","scryfallId":"e38203e9-acb8-4fa9-84f2-1a0560152503"},{"index":5182,"token":false,"name":"Petals of Insight","scryfallId":"134c8764-028e-4f7f-988d-ffd4d3827eb6"},{"index":5184,"token":false,"name":"Execute","scryfallId":"333123bc-fb66-4b5a-bf55-045d2906c8c3"},{"index":5186,"token":false,"name":"Startled Awake // Persistent Nightmare","scryfallId":"2385cf77-9791-4453-831f-eaf9af62270c"},{"index":5187,"token":false,"name":"Gaddock Teeg","scryfallId":"701418b2-5d26-4da8-9091-d7f909f3ea3b"},{"index":5189,"token":false,"name":"Whirling Catapult","scryfallId":"6206d65a-6907-4d11-acb0-8820277f2cf2"},{"index":5190,"token":false,"name":"Ifnir Deadlands","scryfallId":"0b88728b-9b18-40c6-b634-f87f8da83665"},{"index":5191,"token":false,"name":"Blink of an Eye","scryfallId":"ab830392-4d7e-4b45-93cf-35ed1e935228"},{"index":5193,"token":false,"name":"Explore","scryfallId":"098e528a-bd6c-41f3-a246-cba986c54776"},{"index":5195,"token":false,"name":"Kjeldoran Elite Guard","scryfallId":"6d6c998f-aae9-4467-ad55-6a107cc18946"},{"index":5196,"token":false,"name":"Feedback","scryfallId":"c8a0596f-053e-4f3e-aed0-7f4ec2b89235"},{"index":5197,"token":false,"name":"Wheel and Deal","scryfallId":"61f50a1a-f3d0-4fcf-bd32-0e173b0d3247"},{"index":5198,"token":false,"name":"Singing Bell Strike","scryfallId":"7fd07489-13c0-4744-a222-ce90ace4ae5b"},{"index":5199,"token":false,"name":"Cathar's Companion","scryfallId":"0291a964-1117-4fbd-9193-9719b273c348"},{"index":5200,"token":false,"name":"Dread Cacodemon","scryfallId":"ed5d7539-e27c-46b6-8029-744c3b5fbfd8"},{"index":5202,"token":true,"name":"Wurm Token (G, 6/6)","scryfallId":"a4d87f38-c342-4186-8768-c3f1aceb680a"},{"index":5203,"token":false,"name":"Xathrid Demon","scryfallId":"059e8ead-f295-4ca7-a309-6768e6e765cf"},{"index":5205,"token":false,"name":"Hydroid Krasis","scryfallId":"24a26df1-8530-412a-932c-f86ec230d12d"},{"index":5208,"token":false,"name":"Opulent Palace","scryfallId":"80dbbb02-3361-4b35-b193-9b5752222647"},{"index":5209,"token":false,"name":"Triplicate Spirits","scryfallId":"9d258bcc-3379-4f56-b584-be25979e5244"},{"index":5211,"token":false,"name":"Bonfire of the Damned","scryfallId":"e60610fe-891d-46de-b556-d03b637dccec"},{"index":5212,"token":false,"name":"Temur Charm","scryfallId":"009c5aac-194f-4b95-8f69-cc74aa15c3a5"},{"index":5213,"token":false,"name":"Archangel Avacyn // Avacyn, the Purifier","scryfallId":"ae155ee2-008f-4dc6-82bf-476be7baa224"},{"index":5214,"token":false,"name":"Tendershoot Dryad","scryfallId":"c80973f3-ee03-491d-9e91-d4bcca5667ef"},{"index":5215,"token":false,"name":"Ephara, God of the Polis","scryfallId":"e549057e-fb55-4752-903c-41355f9a0589"},{"index":5217,"token":false,"name":"Hooting Mandrills","scryfallId":"090d678c-f0e4-4757-8900-93dfe67aefe9"},{"index":5218,"token":false,"name":"Myojin of Cleansing Fire","scryfallId":"a0570ba0-2877-46f6-acea-6913f8915d6d"},{"index":5219,"token":false,"name":"Battle for Bretagard","scryfallId":"cd31ec15-2fe0-40ab-b320-bc4333db4787"},{"index":5220,"token":false,"name":"Black Ward","scryfallId":"3e3c9e9e-105d-4f1e-a77c-b415f215363f"},{"index":5222,"token":false,"name":"Ley Druid","scryfallId":"1bc4af41-0dcc-47f9-bff8-6bd90816edb5"},{"index":5226,"token":false,"name":"Stronghold Zeppelin","scryfallId":"d672110d-b7c4-4233-9c46-73323be7204d"},{"index":5228,"token":false,"name":"Rhonas's Last Stand","scryfallId":"ad17d302-0fe3-448f-8420-b7712f9ac164"},{"index":5230,"token":false,"name":"Spontaneous Generation","scryfallId":"ce5765cb-00cd-4920-9fe8-68791048ec4a"},{"index":5231,"token":false,"name":"Master Warcraft","scryfallId":"a95749cf-dd12-4bca-a74d-01301b9b76df"},{"index":5232,"token":false,"name":"Tobias Andrion","scryfallId":"9469a9b3-430c-43b1-bede-80e6949fd895"},{"index":5233,"token":false,"name":"Jade Statue","scryfallId":"af0495f8-4f18-4860-b1b4-58fa67414c8e"},{"index":5234,"token":false,"name":"Skeleton Shard","scryfallId":"eeffcd61-ea1f-4ccd-b3d3-79efa9d4a0cf"},{"index":5235,"token":false,"name":"Censor","scryfallId":"4cb4e315-1a77-479a-9f15-fb23575de805"},{"index":5236,"token":false,"name":"Spined Fluke","scryfallId":"8a14524b-e690-4f77-b43e-416d5ec3cbb9"},{"index":5237,"token":false,"name":"Icy Blast","scryfallId":"b098f029-6b5d-49e4-9a81-f497ebbdb5ce"},{"index":5238,"token":false,"name":"Skyline Cascade","scryfallId":"29b0027d-c232-4cdd-89c4-75947687aa71"},{"index":5239,"token":false,"name":"Primal Order","scryfallId":"21a3b8f7-c794-40ef-9ebd-dec5357260d4"},{"index":5241,"token":false,"name":"Gray Merchant of Asphodel","scryfallId":"d794d0a4-4041-43c0-aedb-e2a76611a3ea"},{"index":5242,"token":false,"name":"Hydra Broodmaster","scryfallId":"5b11bb5a-66e3-4dc6-9df4-e1683c57e488"},{"index":5243,"token":false,"name":"Oreskos Explorer","scryfallId":"18cf5b23-dad0-4d4f-bd73-0133dbc9f8e1"},{"index":5244,"token":false,"name":"Tormentor's Helm","scryfallId":"2318d4f8-309e-4645-b6d1-46572edd6996"},{"index":5245,"token":false,"name":"Moonring Island","scryfallId":"64b36993-666c-40d0-b61a-1d162bd06dcc"},{"index":5246,"token":false,"name":"Acclaimed Contender","scryfallId":"0dbf3260-b956-40da-abc7-764781c9f26f"},{"index":5247,"token":false,"name":"Leeches","scryfallId":"90db206e-b254-476c-b2f3-1cd56bb5297d"},{"index":5248,"token":false,"name":"Heliod's Pilgrim","scryfallId":"7ea54b97-9182-4d46-9d70-3cc7f9b18ada"},{"index":5249,"token":true,"name":"Rock","scryfallId":"661cbde4-9444-4259-b2cf-7c8f9814a071"},{"index":5252,"token":false,"name":"Corrupt","scryfallId":"91355d59-3445-4fb4-82c5-25610714c271"},{"index":5254,"token":false,"name":"Incendiary Sabotage","scryfallId":"0ee44ca0-1989-42fa-8024-b6b3e5c3883c"},{"index":5256,"token":true,"name":"Randy Buehler Decklist","scryfallId":"7db7d019-aabb-4436-a570-e2280dc2d368"},{"index":5257,"token":false,"name":"Skyline Despot","scryfallId":"86f74736-0557-4b73-a8ad-5abaa34ccd94"},{"index":5258,"token":false,"name":"Territorial Baloth","scryfallId":"2e898137-c214-452a-b916-8a2f3c9bd02d"},{"index":5259,"token":false,"name":"Obstinate Baloth","scryfallId":"98d12669-ca08-4a3c-b30f-15168b75abe4"},{"index":5261,"token":false,"name":"Chatterstorm","scryfallId":"b34f0ac1-6894-4761-b62c-b85d927acf09"},{"index":5265,"token":false,"name":"Village Ironsmith // Ironfang","scryfallId":"cd5435d0-789f-4c42-8efc-165c072404a2"},{"index":5266,"token":false,"name":"Siege Dragon","scryfallId":"12dc18f7-f4d4-421e-869e-c2e7598a9c77"},{"index":5267,"token":false,"name":"Planar Guide","scryfallId":"7087cb1e-f2e2-4b75-bacf-bc4153e398e3"},{"index":5268,"token":false,"name":"Seeds of Renewal","scryfallId":"ba13b3ba-c36e-4c79-aaa6-2c2619a2d999"},{"index":5269,"token":false,"name":"Ray of Distortion","scryfallId":"ba1af997-bf99-4330-b24d-368615107ebc"},{"index":5270,"token":false,"name":"Diamond Mare","scryfallId":"e2a4cdab-5dd7-4119-bfdc-21980db58058"},{"index":5273,"token":false,"name":"Harrow","scryfallId":"3c207142-4880-4935-9827-b91bc7d9d643"},{"index":5274,"token":false,"name":"Paradise Mantle","scryfallId":"19cd6bcc-ca47-47cc-9fe4-c29e9c176485"},{"index":5276,"token":false,"name":"Lich's Caress","scryfallId":"32bd3acd-aa62-4708-9336-e3430fd0e541"},{"index":5277,"token":false,"name":"Repeated Reverberation","scryfallId":"ec25f534-0ed6-46ba-98fe-67bafd30ad4f"},{"index":5278,"token":false,"name":"Phantom Nomad","scryfallId":"4644e7a0-0588-4b9e-b6d7-77b2b9208695"},{"index":5279,"token":false,"name":"Evolutionary Leap","scryfallId":"c731ba3b-3c48-472b-88ec-05205690e703"},{"index":5283,"token":false,"name":"Goliath Sphinx","scryfallId":"864a792b-ad04-4892-92d9-0f6abe3759e8"},{"index":5284,"token":false,"name":"Drover of the Mighty","scryfallId":"51fdf2fc-d948-4c64-a34e-2f90eab83212"},{"index":5285,"token":false,"name":"Fervor","scryfallId":"b4df70ea-2b6b-4e25-a564-655989ef16fa"},{"index":5286,"token":false,"name":"Icatian Javelineers","scryfallId":"a0797d96-ddf5-4c9c-912f-62ceba776211"},{"index":5287,"token":false,"name":"Deepwood Tantiv","scryfallId":"bfa2028e-4e73-4ff2-a9e2-9ac347d67893"},{"index":5290,"token":false,"name":"Sage of Lat-Nam","scryfallId":"f7395b77-f7f7-404b-8639-9db6dc28d558"},{"index":5292,"token":false,"name":"Eldrazi Mimic","scryfallId":"c3c2249a-a623-4dc5-8483-6774c9f3ea27"},{"index":5293,"token":false,"name":"Makeshift Munitions","scryfallId":"65689442-e679-4844-91a8-f6a39a7c1f9b"},{"index":5295,"token":false,"name":"Worm Harvest","scryfallId":"36b5c006-115f-441e-84d4-fbff390a2c00"},{"index":5296,"token":false,"name":"Protean Hulk","scryfallId":"2f0c4714-b9cd-48a3-8a2a-72860d0ac000"},{"index":5297,"token":false,"name":"Arni Brokenbrow","scryfallId":"ff334bba-0805-4d5d-86c4-99185fe9a77a"},{"index":5298,"token":false,"name":"Stangg","scryfallId":"a277775a-6b48-4238-a618-3ae94c4cc85c"},{"index":5299,"token":false,"name":"Kaheera, the Orphanguard","scryfallId":"c522ca8b-a3a3-4162-a46d-0b7e318c9ae3"},{"index":5300,"token":false,"name":"Grab the Reins","scryfallId":"570fa211-e937-4ad7-bc72-60f8adc3203d"},{"index":5301,"token":false,"name":"Undead Leotau","scryfallId":"7ab9a62a-5503-430d-8b67-061a46b5c22c"},{"index":5302,"token":false,"name":"Nyxathid","scryfallId":"80c706ef-5a31-419d-83a3-d60522c14451"},{"index":5303,"token":false,"name":"Captain Lannery Storm","scryfallId":"5ab86a8a-7a0a-473e-9a97-da2fe0ab866c"},{"index":5304,"token":false,"name":"Stunted Growth","scryfallId":"5781a1c4-7aef-42bc-9073-d57793c7fdf6"},{"index":5305,"token":false,"name":"Adrix and Nev, Twincasters","scryfallId":"7bbe5a69-1ab3-43de-be1c-b21cccbd3b06"},{"index":5306,"token":false,"name":"Infernal Denizen","scryfallId":"b63ac9a6-aaa5-4659-97d1-c5f6b0d5ccfe"},{"index":5308,"token":false,"name":"Armored Griffin","scryfallId":"03c66685-0844-493d-a97b-640dc9ed79af"},{"index":5309,"token":false,"name":"Grinding Station","scryfallId":"df1df511-b52c-45cd-9503-ffce4271a802"},{"index":5310,"token":false,"name":"Venarian Gold","scryfallId":"11fb92c0-bb1e-463a-a6b6-887a5d0cb873"},{"index":5314,"token":false,"name":"Primal Vigor","scryfallId":"dafea0d1-6986-46b3-affc-1337ef564947"},{"index":5315,"token":false,"name":"Dragon's Eye Savants","scryfallId":"f20656d9-cd4f-4694-8715-04c017eb6760"},{"index":5321,"token":false,"name":"Spore Flower","scryfallId":"f9681dc0-d0fc-4d5b-a23c-63ec1cc8343d"},{"index":5322,"token":false,"name":"Extravagant Spirit","scryfallId":"99243564-9dbd-420c-922d-c17854c99d2a"},{"index":5323,"token":false,"name":"Ovinomancer","scryfallId":"ae4f0988-4194-4481-a6b7-27753261174a"},{"index":5325,"token":false,"name":"Rampaging Ferocidon","scryfallId":"80f08709-639a-4fae-bcfc-a9855b0214cf"},{"index":5327,"token":false,"name":"Curious Homunculus // Voracious Reader","scryfallId":"22e816af-df55-4a3f-a6e7-0ff3bb1b45b5"},{"index":5329,"token":false,"name":"Jalum Tome","scryfallId":"dbf531e2-9a4f-4e8b-836e-065c49f58a31"},{"index":5330,"token":false,"name":"Ironfist Crusher","scryfallId":"c7284e32-de54-4c83-a7de-7b249c47319a"},{"index":5331,"token":false,"name":"Leonin Scimitar","scryfallId":"e786d55b-42e5-431d-aa27-d68c2a2ebcea"},{"index":5332,"token":false,"name":"Crossroads Consecrator","scryfallId":"b1a83854-dc45-4c26-aca0-67f372236383"},{"index":5333,"token":false,"name":"Acquisitions Expert","scryfallId":"281336c7-ca7c-4c91-bdfb-d253a965cb7c"},{"index":5334,"token":false,"name":"Drowner of Hope","scryfallId":"0fd5b48c-6850-47d4-8106-297be6c8f708"},{"index":5337,"token":false,"name":"Marshmist Titan","scryfallId":"093d2e4c-f2c4-4d4e-a1b7-200327ce23b0"},{"index":5338,"token":false,"name":"Gigantiform","scryfallId":"aa476306-9d6b-45ed-9e6c-fd4aee6592e7"},{"index":5339,"token":false,"name":"Armadillo Cloak","scryfallId":"e22c22d0-a928-450a-9b14-3157b7bdf309"},{"index":5340,"token":false,"name":"Crystal Vein","scryfallId":"ddc150ee-b2ae-483b-be8e-503000e2884d"},{"index":5341,"token":false,"name":"Reckless Pangolin","scryfallId":"c4ed22f1-37da-4375-a873-59e361d142e9"},{"index":5346,"token":false,"name":"Wastes","scryfallId":"bf10c264-c7f6-4ae3-b3ef-ff12bd7b64c0"},{"index":5347,"token":false,"name":"Ripjaw Raptor","scryfallId":"4bdf9bf0-5247-4a30-91f1-0172b6aa6be6"},{"index":5349,"token":false,"name":"Durkwood Baloth","scryfallId":"df027117-9cb2-428f-b5ab-eb4491493fa3"},{"index":5350,"token":false,"name":"Corpse Lunge","scryfallId":"2a74b987-527a-4560-a018-19d6bdf7e8b7"},{"index":5351,"token":false,"name":"Bog Imp","scryfallId":"5f95195e-2237-4fff-bea3-14ead5db3ecd"},{"index":5352,"token":false,"name":"Quirion Sentinel","scryfallId":"2fc639ea-a925-4f1e-879f-b8fcb12bf257"},{"index":5354,"token":false,"name":"Oni Possession","scryfallId":"65404e7b-acce-4e5b-82b7-3d7ce9572eec"},{"index":5356,"token":false,"name":"Martyrdom","scryfallId":"07f91817-8e79-4885-a57b-d26241c4791f"},{"index":5357,"token":false,"name":"Essence Filter","scryfallId":"943b890b-5232-43d5-b007-b5ebbc8af133"},{"index":5359,"token":false,"name":"Increasing Savagery","scryfallId":"c59b2ab3-c5e3-4599-9af0-3fa7a9544b97"},{"index":5365,"token":false,"name":"Arachnoform","scryfallId":"acbe560b-f7b5-4614-91f1-b669a39abc16"},{"index":5366,"token":false,"name":"Maskwood Nexus","scryfallId":"b9900049-65e4-47e0-a90a-38678cc940a5"},{"index":5367,"token":false,"name":"Vanquisher's Banner","scryfallId":"c92b54a7-30c9-4955-8e71-7437528de18c"},{"index":5368,"token":false,"name":"Karn, Silver Golem","scryfallId":"18fb9c27-0027-4b77-87bf-af0d0bd2278b"},{"index":5371,"token":false,"name":"Lotus Path Djinn","scryfallId":"197ec248-70d9-47f4-a53b-99b23f021116"},{"index":5372,"token":true,"name":"Tom van de Logt Decklist (2000)","scryfallId":"0e4702c0-1999-4982-aef8-1af478f1d511"},{"index":5374,"token":false,"name":"Audacious Infiltrator","scryfallId":"36a348bb-cdc5-4e2a-933f-21f91faab891"},{"index":5375,"token":false,"name":"Waterknot","scryfallId":"8b4579ee-76c4-4ed6-9208-55d2b598d3b5"},{"index":5376,"token":false,"name":"Vedalken Infuser","scryfallId":"a52b9d11-0aab-4300-90b6-c8b56de36ec3"},{"index":5379,"token":false,"name":"Soul Swallower","scryfallId":"22fbc045-2c86-4816-8622-db56929ae94d"},{"index":5382,"token":false,"name":"Kenrith's Transformation","scryfallId":"896e5f61-6074-458d-9e8c-aff99fda75d7"},{"index":5383,"token":false,"name":"Fissure","scryfallId":"ddee3964-6725-4524-99d9-0ccd3a3f5cc6"},{"index":5384,"token":false,"name":"Necropolis Regent","scryfallId":"2b6009d3-4f70-492c-9860-8d33421936f8"},{"index":5385,"token":false,"name":"Grotag Night-Runner","scryfallId":"0568341b-f972-407f-92ce-1b7c9ef742f6"},{"index":5387,"token":false,"name":"Magmatic Chasm","scryfallId":"e62a56c4-a3d9-43ab-83a8-6333578bcbc8"},{"index":5388,"token":false,"name":"Hollow Trees","scryfallId":"90845410-e09a-4753-ad4c-bf2b2f3c95ac"},{"index":5390,"token":false,"name":"Deserted Temple","scryfallId":"d1fa74b2-f9bd-4617-8b65-878781f3a2fd"},{"index":5393,"token":false,"name":"Deep Analysis","scryfallId":"221921d9-34d8-420a-be5e-6b4468e703fa"},{"index":5394,"token":false,"name":"Wildfire Devils","scryfallId":"09eb879c-5caf-4d6d-b340-5b99ffeefc3a"},{"index":5395,"token":false,"name":"Ancestor's Prophet","scryfallId":"4d9ff386-5fcc-484a-abd2-d135f522c41e"},{"index":5396,"token":true,"name":"Dragon Token (R, 5/5)","scryfallId":"e290b7f1-1598-4581-96b1-f57419ec408e"},{"index":5400,"token":false,"name":"Parallax Tide","scryfallId":"7fe593eb-df3c-43e5-97a6-418f91e87cb3"},{"index":5402,"token":false,"name":"Yahenni, Undying Partisan","scryfallId":"e88c5363-58b3-4199-a01c-acd6b2ca3185"},{"index":5405,"token":false,"name":"Bloodrock Cyclops","scryfallId":"5c642fd9-38f7-4029-ab93-e1dc5636c1ad"},{"index":5408,"token":false,"name":"Warden of the Wall","scryfallId":"fd1a1f48-d46b-4b8e-a642-fc70fd9ef7df"},{"index":5409,"token":false,"name":"Start // Finish","scryfallId":"9c6f5433-57cc-4cb3-8621-2575fcbff392"},{"index":5410,"token":false,"name":"Grisly Salvage","scryfallId":"d5b4768f-fe15-4632-8bc5-bac35dc0e9e8"},{"index":5411,"token":false,"name":"Pestilent Spirit","scryfallId":"5f9a0387-5116-484b-bb2b-064bd42e7fff"},{"index":5413,"token":false,"name":"Crown of the Ages","scryfallId":"77b549e5-c25d-4688-b362-faab109ba092"},{"index":5414,"token":false,"name":"Embermaw Hellion","scryfallId":"035ea998-1ae5-4e56-bdca-65d9a0fe387d"},{"index":5415,"token":false,"name":"Slith Firewalker","scryfallId":"9ee6c9a1-5e3c-4a3e-8f48-7054c1626bb1"},{"index":5416,"token":false,"name":"Sultai Skullkeeper","scryfallId":"21a93355-553c-456b-999b-e9f826a1f572"},{"index":5420,"token":false,"name":"Alaborn Veteran","scryfallId":"79d7992d-9acd-4eaa-b6e0-a47acb880548"},{"index":5421,"token":false,"name":"Timberwatch Elf","scryfallId":"4145fdfb-451b-483a-a780-05ac0f452aef"},{"index":5423,"token":false,"name":"Dragon's Claw","scryfallId":"cd62ce2f-bf20-427a-9dbc-40732ff639ab"},{"index":5424,"token":false,"name":"Mishra's Bauble","scryfallId":"2b8877c3-1f04-4452-9f2c-98fb8dc71e5f"},{"index":5425,"token":false,"name":"Sentinel of the Pearl Trident","scryfallId":"a19284d8-4404-4032-8dee-3c7af2819045"},{"index":5426,"token":false,"name":"Verix Bladewing","scryfallId":"4ae6e078-2539-4e90-8172-220df1119e4e"},{"index":5427,"token":false,"name":"Unyielding Krumar","scryfallId":"a232d196-490d-4712-b2a2-466751b28d11"},{"index":5428,"token":false,"name":"Vexing Gull","scryfallId":"869fee23-df75-448d-9fca-6ba6713d459f"},{"index":5430,"token":false,"name":"Tetsuo Umezawa","scryfallId":"ec22ddf8-cb5e-4ca0-8f2f-c5d48f2cbd26"},{"index":5431,"token":true,"name":"Rollicking Throng Token (Colorless, 1/3)","scryfallId":"8da84d4f-5526-401f-9762-4fcfbc313c81"},{"index":5432,"token":false,"name":"White Ward","scryfallId":"2d3c467f-0e33-43e8-b108-0ea00d6adcc2"},{"index":5433,"token":false,"name":"Elvish Skysweeper","scryfallId":"ff4b950c-bd01-45e0-bd60-5b55640a50a8"},{"index":5437,"token":false,"name":"Destructive Flow","scryfallId":"7db86e34-c3ec-4a29-8779-81350a985644"},{"index":5438,"token":true,"name":"Minotaur Token (R, 2/3)","scryfallId":"fe6b9fbc-4060-4ca4-bccb-a631268b57d9"},{"index":5439,"token":false,"name":"Tezzeret's Touch","scryfallId":"5b42227b-a251-46f0-a386-c1d9e7eb40a8"},{"index":5440,"token":false,"name":"Carapace","scryfallId":"6d51d61e-c010-4b4e-a337-20ba5eb845e3"},{"index":5441,"token":false,"name":"Stronghold Discipline","scryfallId":"46fa5472-5341-47cd-884e-fe2fcca12c0d"},{"index":5443,"token":false,"name":"Enraged Giant","scryfallId":"f100ff31-26d9-4543-b1e1-9b8fdfd13a59"},{"index":5444,"token":false,"name":"Spellgorger Weird","scryfallId":"91551f85-4630-43a0-af72-8332d2ff0752"},{"index":5445,"token":false,"name":"Chant of Vitu-Ghazi","scryfallId":"23c22d01-1d14-4f73-a2db-a77f96a9a0e3"},{"index":5446,"token":false,"name":"Divine Verdict","scryfallId":"48444e14-c73b-47d1-9c55-0ff4dc3c6034"},{"index":5447,"token":false,"name":"Beacon Behemoth","scryfallId":"0cc42e33-7489-4a32-bb30-adc80ec13521"},{"index":5449,"token":false,"name":"Grafted Skullcap","scryfallId":"3ff78a37-c321-4f02-bd10-e73823b954cf"},{"index":5450,"token":false,"name":"Farsight Mask","scryfallId":"98312bc3-9d2a-480c-bcf0-db8d70d632b9"},{"index":5451,"token":false,"name":"Kobold Overlord","scryfallId":"0861cb0a-277f-49fe-b263-b044f0117cdd"},{"index":5452,"token":false,"name":"Spinebiter","scryfallId":"cfc79ac6-ffc6-4506-9dea-e20176f960ea"},{"index":5454,"token":false,"name":"Gideon, Champion of Justice","scryfallId":"93d0509a-a863-4d9c-b39f-625a8cc1a547"},{"index":5455,"token":false,"name":"Smelt-Ward Ignus","scryfallId":"4f24b2b6-b994-455f-b8e6-aa73e1be81b4"},{"index":5457,"token":false,"name":"Golgari Guildgate","scryfallId":"80658042-3998-49ca-88ef-f87320a5bd43"},{"index":5460,"token":false,"name":"Blind Creeper","scryfallId":"60077344-eff6-432a-91b2-4491a2c7033f"},{"index":5462,"token":false,"name":"Runed Halo","scryfallId":"95b26297-f6a3-46b4-acf2-2953daa8966c"},{"index":5464,"token":false,"name":"Swiftblade Vindicator","scryfallId":"c2a89a8f-b3a7-4c38-80fb-b5484ddbf8ec"},{"index":5466,"token":false,"name":"The Bloodsky Massacre","scryfallId":"ec475385-6755-4b90-a48f-5e58e326aaca"},{"index":5467,"token":false,"name":"Shade's Breath","scryfallId":"a37be9a8-ef69-4c62-8455-e129e62fe69a"},{"index":5468,"token":false,"name":"Soul Nova","scryfallId":"f862682d-cbf3-4c35-83d0-76883b0ac105"},{"index":5469,"token":false,"name":"Wild Swing","scryfallId":"66d05ffc-2e28-4190-a944-1be746ff9b59"},{"index":5471,"token":false,"name":"Swarm Shambler","scryfallId":"121deaec-29a1-496b-b357-c6db81988aa9"},{"index":5473,"token":false,"name":"Elvish Promenade","scryfallId":"20602cb8-f925-4de0-ad4b-86d0f5514384"},{"index":5474,"token":false,"name":"Troubled Healer","scryfallId":"54407ba7-6671-42a9-acbe-8a1104c7166c"},{"index":5476,"token":false,"name":"Rogue's Passage","scryfallId":"a92994a8-94b5-4ac9-80b5-265c8ac4100d"},{"index":5478,"token":false,"name":"Dig Through Time","scryfallId":"9914fb69-ebe8-469a-953a-763d89deb810"},{"index":5479,"token":false,"name":"Malefic Scythe","scryfallId":"89e2bc57-8f18-4ba1-a11b-9d69d029f56a"},{"index":5480,"token":false,"name":"Citanul Druid","scryfallId":"2d6c1b0a-3fb9-426e-b3ed-f5d8d1096a51"},{"index":5481,"token":false,"name":"Sporeweb Weaver","scryfallId":"11e674c4-c967-4848-b949-796b8ab8b261"},{"index":5482,"token":false,"name":"Chandra's Triumph","scryfallId":"70f43c17-7022-4052-86b8-90b74382b7bf"},{"index":5483,"token":false,"name":"Cinder Storm","scryfallId":"813b3d34-9a16-4eea-8ab3-2a0de5df4ef5"},{"index":5484,"token":false,"name":"All Hallow's Eve","scryfallId":"50e504f2-eced-4d38-9741-4d9f2cf9d51d"},{"index":5485,"token":false,"name":"Smoldering Crater","scryfallId":"06f740fe-44b1-4a31-b353-6fbc6fb45fbf"},{"index":5486,"token":false,"name":"Allosaurus Rider","scryfallId":"471e6542-45d4-4974-85d0-5e0a8881e622"},{"index":5489,"token":false,"name":"Swooping Talon","scryfallId":"34c3d19c-d4c6-4c5c-85eb-11d55959a89c"},{"index":5490,"token":false,"name":"Voice of All","scryfallId":"f22cc27a-86f0-455a-bacb-8d3dc4b72bec"},{"index":5494,"token":false,"name":"Hall of Oracles","scryfallId":"7642dddd-4461-46dd-b396-9e0a89f7232e"},{"index":5496,"token":false,"name":"Welding Jar","scryfallId":"42b7b73b-4800-4fc7-9a5c-93e00ea88498"},{"index":5497,"token":false,"name":"Ogre Taskmaster","scryfallId":"96c08378-7344-4f11-8206-bec2a72f0570"},{"index":5498,"token":false,"name":"Mogg Hollows","scryfallId":"474e3fb0-b0f9-4c6d-8c57-e5079a3a3c66"},{"index":5499,"token":false,"name":"Glasses of Urza","scryfallId":"4bd9f45f-30b3-4bff-9fd3-9a71137ac741"},{"index":5500,"token":false,"name":"Predator's Rapport","scryfallId":"47324ab7-df78-4859-be0b-2eef5d4f8082"},{"index":5501,"token":false,"name":"Valeron Outlander","scryfallId":"7e73cd46-0dec-441b-bb91-ec6defb3355e"},{"index":5502,"token":true,"name":"2001 World Championships Ad","scryfallId":"3513d5d3-7e88-4f5d-927f-1e67eb18e58e"},{"index":5503,"token":false,"name":"Battle Squadron","scryfallId":"01c3c73d-03e8-4afc-bbfd-08fc87808012"},{"index":5504,"token":false,"name":"Beast Within","scryfallId":"808aff4d-422d-4ead-8f15-d86efe8d4c0f"},{"index":5505,"token":false,"name":"Sea Serpent","scryfallId":"5371142e-bafc-4259-b86a-16902c4a6404"},{"index":5506,"token":false,"name":"Hanged Executioner","scryfallId":"b4b358d9-d0d2-4264-afd2-df479102199d"},{"index":5507,"token":false,"name":"Yawgmoth's Edict","scryfallId":"3f16be4b-4540-476a-b3ac-7442507ed314"},{"index":5510,"token":false,"name":"Meekstone","scryfallId":"a71da253-1d40-4833-92a7-df8dd90e66e4"},{"index":5512,"token":false,"name":"Geist of the Archives","scryfallId":"44d4fcbc-15b2-4370-a267-bc2c63ba2aa5"},{"index":5514,"token":false,"name":"Noggle Hedge-Mage","scryfallId":"4e599ae8-2ae5-42de-bd5d-885f197119c5"},{"index":5515,"token":false,"name":"Goldspan Dragon","scryfallId":"9d914868-9000-4df2-a818-0ef8a7f636ae"},{"index":5516,"token":false,"name":"Bloodbond Vampire","scryfallId":"ca31ce70-24c5-4fb2-8d88-c9ffa8474c8f"},{"index":5518,"token":false,"name":"Wall of Stone","scryfallId":"8c4b68e0-ec8b-4dad-91ee-dc1da5db6251"},{"index":5520,"token":false,"name":"Ulamog's Crusher","scryfallId":"c391c62f-d219-4b6d-ab49-2f8975f880c6"},{"index":5521,"token":false,"name":"Shrill Howler // Howling Chorus","scryfallId":"a63c30c0-369a-4a75-b352-edab4d263d1b"},{"index":5524,"token":false,"name":"Daretti, Scrap Savant","scryfallId":"243c8e0f-5339-442d-ab1a-22942e24bfe3"},{"index":5527,"token":false,"name":"Thran Golem","scryfallId":"5778c52b-248b-4131-b5c0-12ea1986786e"},{"index":5528,"token":false,"name":"Emberstrike Duo","scryfallId":"9ccd4374-5339-4529-99f3-f7dcc939e874"},{"index":5529,"token":false,"name":"Magma Spray","scryfallId":"988a7993-eb7d-4ae2-8a22-1676f517558b"},{"index":5530,"token":false,"name":"Sphinx of the Steel Wind","scryfallId":"b95c1f54-c605-451e-abc4-87cf0f2c5c39"},{"index":5531,"token":false,"name":"Frost Lynx","scryfallId":"2cd55b49-bb7a-4e56-a1fc-5b52ce3cb22c"},{"index":5533,"token":false,"name":"Skophos Maze-Warden","scryfallId":"0f470a7b-63ef-4efa-855e-f8a3ce1ab534"},{"index":5537,"token":false,"name":"Roc Egg","scryfallId":"92ae6206-ff0d-4248-b9cb-4ffbf20504fa"},{"index":5538,"token":false,"name":"Wee Dragonauts","scryfallId":"14fd3734-8c28-4bd0-b202-eee1ab98c328"},{"index":5540,"token":false,"name":"Tibalt, the Fiend-Blooded","scryfallId":"5ddb3936-8f5a-498d-a46c-27eb9546c76c"},{"index":5541,"token":false,"name":"Mnemonic Betrayal","scryfallId":"a5cf45aa-ed34-4add-a2ec-fc11f8c15ffa"},{"index":5543,"token":false,"name":"Barrow Witches","scryfallId":"45707c22-fce8-4dbd-9d19-73f08c68f449"},{"index":5544,"token":false,"name":"Bag of Holding","scryfallId":"04c192a3-5533-4442-b149-af91046885cd"},{"index":5545,"token":false,"name":"Crystalline Sliver","scryfallId":"8c10b48a-f21c-4f4a-84d1-2beedef05270"},{"index":5546,"token":false,"name":"Flameshadow Conjuring","scryfallId":"b473ee0c-b037-4968-9dda-82c2288e54f7"},{"index":5548,"token":false,"name":"Storm Herd","scryfallId":"058a7abf-8112-4f67-b465-317c87ad0d63"},{"index":5550,"token":false,"name":"Skirge Familiar","scryfallId":"b0fafdf1-6810-44e9-bd59-1bf2bcfb5f26"},{"index":5551,"token":false,"name":"Burst of Speed","scryfallId":"dc8c7aa0-2067-4513-a658-ed866279e671"},{"index":5552,"token":false,"name":"Decoy Gambit","scryfallId":"39671ac5-c730-4ba2-a2d9-23d5ac13f12b"},{"index":5553,"token":false,"name":"Lazotep Reaver","scryfallId":"594bbe43-a8aa-42aa-bc49-cb4f3bc05cad"},{"index":5554,"token":true,"name":"Food","scryfallId":"4fdfb0ba-d086-4e7c-97e0-70d1e8328ded"},{"index":5556,"token":false,"name":"Dack Fayden","scryfallId":"5335ad67-5145-48f5-b5af-19996c4d11c0"},{"index":5557,"token":false,"name":"Scourge of Valkas","scryfallId":"726a3816-f782-4cb7-ba6f-c4b70d59f96c"},{"index":5558,"token":false,"name":"Skyshroud Elite","scryfallId":"cbc1c8e7-8712-498e-b1e7-220c70276c5d"},{"index":5559,"token":false,"name":"Arrogant Vampire","scryfallId":"e7342875-d49b-4fa7-a2fb-8dfc5e3d6e4f"},{"index":5560,"token":false,"name":"Gilt-Leaf Palace","scryfallId":"cc4bbbb5-4218-4b2a-9ca2-de4d5f5dda19"},{"index":5561,"token":false,"name":"Knight of New Alara","scryfallId":"0d3fc235-d0d7-41f8-b35a-6e08761f7fa4"},{"index":5562,"token":false,"name":"Hua Tuo, Honored Physician","scryfallId":"6ea24ba5-7809-44ca-b6e4-38e10401508f"},{"index":5563,"token":false,"name":"Ancient Stone Idol","scryfallId":"15a29d3d-7868-4a28-ba78-aa9d3c258767"},{"index":5564,"token":false,"name":"Sungrass Prairie","scryfallId":"2960114b-649d-4545-a156-8bd0500c5c6e"},{"index":5565,"token":false,"name":"Forbidden Alchemy","scryfallId":"86fbd65c-544f-48fa-9697-4c3a147b01b1"},{"index":5566,"token":false,"name":"Clash of Titans","scryfallId":"ca10e2b8-a317-4c98-a866-43bf274e82cb"},{"index":5567,"token":false,"name":"Headstrong Brute","scryfallId":"66973e90-0c8b-4438-bc22-6e78930c194d"},{"index":5568,"token":false,"name":"Siege Modification","scryfallId":"e1a4e33f-53f0-4919-98a1-c832dcd32efb"},{"index":5569,"token":false,"name":"Indatha Triome","scryfallId":"62bbdc86-f5a0-4738-a5f6-f2347c8b2a58"},{"index":5570,"token":false,"name":"Stroke of Genius","scryfallId":"5ecb5078-4439-4fdc-88e8-aac3becbbad8"},{"index":5571,"token":false,"name":"Archon of the Triumvirate","scryfallId":"07baef91-d7fd-4890-8c00-62f1a416dc76"},{"index":5572,"token":false,"name":"Memory Jar","scryfallId":"37dbe1a3-3c44-452b-9fb9-37f5d793d0b5"},{"index":5574,"token":false,"name":"Ring of Renewal","scryfallId":"9d44967f-7739-4f63-a93a-e7277d9cc2a9"},{"index":5575,"token":false,"name":"Killer Instinct","scryfallId":"c808a8ec-895c-4777-9e11-e83ce34eddef"},{"index":5577,"token":false,"name":"Power Surge","scryfallId":"e84f7666-1681-4464-960e-c3774d6b73e3"},{"index":5578,"token":false,"name":"Skyclave Apparition","scryfallId":"3491b0ba-8a51-4afb-802f-4463997d31b6"},{"index":5581,"token":false,"name":"Brawn","scryfallId":"4e1d2acd-a3ef-4c9a-9346-322a0e16898c"},{"index":5582,"token":false,"name":"Jeskai Sage","scryfallId":"59faca44-2a97-4202-8840-314b5ddabece"},{"index":5584,"token":false,"name":"Moss Monster","scryfallId":"9903c043-9a7a-4994-b532-136d4c46edfd"},{"index":5587,"token":false,"name":"Djinn of the Lamp","scryfallId":"3a5e7b52-2663-4140-9758-f24b8b947876"},{"index":5589,"token":false,"name":"Cloudseeder","scryfallId":"a9adcc82-0754-4cb7-ac28-e5624f563b7f"},{"index":5590,"token":false,"name":"Winterflame","scryfallId":"b8924ab9-fa55-4348-b67d-b2b9e48a357a"},{"index":5591,"token":false,"name":"Martial Coup","scryfallId":"50845867-20a7-433c-b97e-081276bc739f"},{"index":5592,"token":false,"name":"Márton Stromgald","scryfallId":"7880e815-53e7-43e0-befd-e368f00a75d8"},{"index":5594,"token":false,"name":"Soul Warden","scryfallId":"122cfae7-ab44-4458-9f1d-ca43f9766777"},{"index":5595,"token":false,"name":"Guan Yu, Sainted Warrior","scryfallId":"1575fadf-cd5c-4b4f-8965-c006e571334b"},{"index":5596,"token":false,"name":"Blightspeaker","scryfallId":"4ae24bc0-1217-4db9-a745-8860f23b6d57"},{"index":5602,"token":true,"name":"Aeo Paquette Bio","scryfallId":"06e5f736-2696-4428-a611-2d93e0c4e1cf"},{"index":5603,"token":false,"name":"Symbol of Unsummoning","scryfallId":"c49f9400-9359-409c-9886-ea28e24257a8"},{"index":5604,"token":false,"name":"Ith, High Arcanist","scryfallId":"01dfe0a3-b7b6-47b8-9834-44cb208f425f"},{"index":5606,"token":false,"name":"Tymaret, Chosen from Death","scryfallId":"14b28eae-e8ed-4b99-b6ec-86d0716ec473"},{"index":5607,"token":false,"name":"Ribbon Snake","scryfallId":"eb5135dc-4fc1-48a1-8405-44b2f93a3c21"},{"index":5608,"token":false,"name":"Armored Skyhunter","scryfallId":"ac255917-c54d-4569-b6f9-88a0e16c9064"},{"index":5609,"token":false,"name":"Epitaph Golem","scryfallId":"937aaed7-d9ad-45e0-915c-df61316c606a"},{"index":5610,"token":false,"name":"Timber Gorge","scryfallId":"c5ac9935-ffe7-4280-8b0b-d5913dbf9e6b"},{"index":5613,"token":false,"name":"Relic Seeker","scryfallId":"e3848b51-b432-4b58-a5aa-477395d7a429"},{"index":5614,"token":false,"name":"Aven Initiate","scryfallId":"eba15599-ba74-4506-847a-4472214d8d33"},{"index":5616,"token":false,"name":"Reckless Crew","scryfallId":"328adc1b-2e28-4615-a65b-4874dd2a1af5"},{"index":5617,"token":false,"name":"Reliquary Tower","scryfallId":"c5c0c1a5-dce7-4c7d-8a5b-0bf93ba68ace"},{"index":5619,"token":false,"name":"Sifter Wurm","scryfallId":"5dbaf7e3-e2fc-4399-aa83-c13df43008a0"},{"index":5620,"token":false,"name":"Charging Bandits","scryfallId":"1721ee11-c7ee-4878-b2ab-4f090e0c5def"},{"index":5622,"token":false,"name":"Cytoshape","scryfallId":"758023cb-548a-4a98-a355-f5c6e9eab5ff"},{"index":5624,"token":false,"name":"Time Ebb","scryfallId":"69e63f0c-a09f-493d-a8a9-ddcc0a0ca383"},{"index":5626,"token":false,"name":"Faerie Artisans","scryfallId":"ff05c503-2536-48f5-a639-480614a2e5f8"},{"index":5627,"token":false,"name":"Pillar of Flame","scryfallId":"c983e879-d9d2-47cc-9958-506711ca80cd"},{"index":5628,"token":false,"name":"Explosive Apparatus","scryfallId":"608f431b-a05c-4610-94f7-928d87b2c056"},{"index":5629,"token":false,"name":"Renegade Warlord","scryfallId":"a69ea676-60ba-4807-bc9b-976bf5666485"},{"index":5631,"token":false,"name":"Spectral Steel","scryfallId":"cf036489-ef9e-40ee-a1bb-24ee37c554f1"},{"index":5635,"token":false,"name":"Siege-Gang Commander","scryfallId":"92e78cec-aaf9-4fe8-887b-b7e356d63315"},{"index":5636,"token":false,"name":"Counterbore","scryfallId":"f4228b80-d87d-4ebe-ae92-04e4a7d0dc43"},{"index":5638,"token":false,"name":"Scattered Groves","scryfallId":"79feda10-5d6f-4497-ae2e-9f41004dc343"},{"index":5639,"token":false,"name":"Chandra's Outburst","scryfallId":"f1e849c3-f357-4e81-a580-be5056bed51b"},{"index":5640,"token":false,"name":"Demon's Jester","scryfallId":"90a3f694-0cf3-4d25-8ab0-36a3f637ff9a"},{"index":5641,"token":false,"name":"Wildfire Eternal","scryfallId":"78902053-ee27-4d79-9c95-69e4b051322b"},{"index":5643,"token":false,"name":"Strategic Planning","scryfallId":"d67fe651-d2da-4657-a671-c06f88eac511"},{"index":5644,"token":false,"name":"Nylea, God of the Hunt","scryfallId":"f185a734-a32a-4244-88e8-dabafbfd064f"},{"index":5645,"token":false,"name":"Mishra's War Machine","scryfallId":"8f6b4652-a1d4-418f-a89b-6a977a920a9e"},{"index":5646,"token":false,"name":"Plague Wight","scryfallId":"cef35d0d-5643-4612-b70e-a3037df1c64d"},{"index":5648,"token":false,"name":"Lightning Cloud","scryfallId":"7fcfc2ad-a1a4-4f65-a239-f11383aaafe1"},{"index":5649,"token":false,"name":"Raging Spirit","scryfallId":"a196c21b-e9f5-4ae8-8a1e-668685ef4cf0"},{"index":5650,"token":false,"name":"Bone Shredder","scryfallId":"63d0b5f0-ed45-4b30-9c24-1c12011e3513"},{"index":5651,"token":false,"name":"Noose Constrictor","scryfallId":"6432431d-e9cd-4a33-8247-0b35bac37cad"},{"index":5652,"token":false,"name":"Veteran Motorist","scryfallId":"f0c02fd3-8051-4a35-b14a-462d765f42e5"},{"index":5653,"token":false,"name":"Blade Juggler","scryfallId":"099bc474-e656-4167-b105-3a3a36c0b23e"},{"index":5654,"token":true,"name":"Squid Token (U, 1/1)","scryfallId":"8084eae3-6b2a-4803-9959-1fc5c80500de"},{"index":5657,"token":false,"name":"Irini Sengir","scryfallId":"518e3b77-d482-4b90-94c0-0b8cdd949b9f"},{"index":5658,"token":false,"name":"Grip of Chaos","scryfallId":"defbbd3a-0e7d-4af2-b25f-9003ddad0bf5"},{"index":5659,"token":false,"name":"Last Breath","scryfallId":"1857fc37-1e7e-4b93-9fa9-ec139f16b7fa"},{"index":5660,"token":false,"name":"Kitsune Diviner","scryfallId":"c50fb007-d1fd-4b61-91c3-4863e40472ed"},{"index":5661,"token":false,"name":"Firemane Angel","scryfallId":"493730ab-c30d-4830-a188-0462426fc5bf"},{"index":5662,"token":false,"name":"Ohran Viper","scryfallId":"6f9caaa9-7d8d-459a-8d6b-75f85877c426"},{"index":5664,"token":false,"name":"Sheer Drop","scryfallId":"c6630f43-1513-4ef0-b80e-4036414463f2"},{"index":5668,"token":false,"name":"Bamboozle","scryfallId":"44012bb8-17b7-4b50-a796-662ef09bfc29"},{"index":5669,"token":false,"name":"Tahngarth's Rage","scryfallId":"36658368-88c8-4c55-8147-f6e581f6af36"},{"index":5670,"token":false,"name":"Tragic Fall","scryfallId":"affc1d27-55f6-46e9-a67c-f15b6832813d"},{"index":5671,"token":false,"name":"Expose Evil","scryfallId":"9de0341a-cd45-439c-adc2-8d24c47c4bd5"},{"index":5673,"token":false,"name":"Life Burst","scryfallId":"7f8eee50-efd2-45fd-b815-051167ef4541"},{"index":5676,"token":false,"name":"Blackcleave Cliffs","scryfallId":"3d71be5f-0fd7-4a88-8041-f4d6bc4cc9ac"},{"index":5677,"token":false,"name":"Juvenile Gloomwidow","scryfallId":"d7f323d5-f26c-46e9-9d6a-be5c254fe8b6"},{"index":5678,"token":false,"name":"Dragon Tempest","scryfallId":"97dc5b48-5664-4e0e-90ce-c728beb9513c"},{"index":5679,"token":false,"name":"Blood Moon","scryfallId":"310647b0-54a4-4c0a-acdd-5e8e91972a87"},{"index":5680,"token":false,"name":"Oubliette","scryfallId":"30d1450f-2909-410e-9920-731278fa74de"},{"index":5681,"token":false,"name":"Palinchron","scryfallId":"5621db3f-a9e7-4350-9c6a-0ba04a628947"},{"index":5683,"token":false,"name":"Mycoloth","scryfallId":"15360a16-b785-4ffe-bfa8-6c7f6a37455d"},{"index":5685,"token":false,"name":"Murasa Ranger","scryfallId":"c4a3c02b-b576-4099-9016-15449f93bb09"},{"index":5686,"token":false,"name":"Westvale Abbey // Ormendahl, Profane Prince","scryfallId":"c1f53d7a-9dad-46e8-b686-cd1362867445"},{"index":5688,"token":false,"name":"Demonic Gifts","scryfallId":"3f23c487-ac4a-475b-ad5e-ec6f8678e668"},{"index":5689,"token":false,"name":"Blacklance Paragon","scryfallId":"fe0a63bb-dd94-429f-aa9b-21f3d1c53ae5"},{"index":5690,"token":false,"name":"Extruder","scryfallId":"e94e53f0-cfca-4b40-9867-94ea771463cd"},{"index":5692,"token":false,"name":"Kuldotha Forgemaster","scryfallId":"f0e9cd81-dfee-4c94-ac70-afcb27b6a86a"},{"index":5693,"token":false,"name":"Sandstone Bridge","scryfallId":"c781e932-4605-47aa-add1-4ee62f4e7ead"},{"index":5694,"token":false,"name":"Cavern Lampad","scryfallId":"e340de29-026f-4c76-8cb5-1abfcecbb3b1"},{"index":5695,"token":false,"name":"General's Regalia","scryfallId":"fb99d982-8ab1-4d6a-ba24-58ac23a9b9e7"},{"index":5696,"token":false,"name":"Sweatworks Brawler","scryfallId":"cc603ab7-2789-4732-a72b-1f9294d07f80"},{"index":5700,"token":false,"name":"Culling Scales","scryfallId":"db9a57d6-bba6-463d-ad12-6f93c035d16b"},{"index":5702,"token":false,"name":"Skyrider Patrol","scryfallId":"650461af-081b-4cc9-a140-865a666f1443"},{"index":5705,"token":false,"name":"Apocalypse Hydra","scryfallId":"4fc4bf11-dece-4cb7-bef1-69391488f987"},{"index":5707,"token":false,"name":"Drain Power","scryfallId":"4a8ffad1-9cb0-4ba6-8ae9-00c3b74b9b3f"},{"index":5708,"token":false,"name":"Oran-Rief Ooze","scryfallId":"51ace107-f8fe-4ff4-8b81-300e76d27926"},{"index":5709,"token":false,"name":"Eerie Ultimatum","scryfallId":"fdbe5a6f-82a2-4c6b-a69d-3a07917e15c9"},{"index":5710,"token":false,"name":"Sacred Ground","scryfallId":"37ae4b01-a9c1-4eec-9204-78cb2508e0df"},{"index":5711,"token":false,"name":"Celestial Purge","scryfallId":"1a5dbac5-273c-4452-a9c2-32fb6086a8d1"},{"index":5712,"token":false,"name":"Exploding Borders","scryfallId":"f247aaaf-4d65-4dfc-bab2-3c1331762647"},{"index":5713,"token":false,"name":"Thorntooth Witch","scryfallId":"140265a2-61c3-4731-989c-9d55c27400ec"},{"index":5714,"token":true,"name":"Elemental Shaman Token (R, 3/1)","scryfallId":"a271bdf3-2868-425d-987c-4ce272152a2f"},{"index":5716,"token":false,"name":"Elvish Bard","scryfallId":"62261004-ed32-4865-824a-4320548f4234"},{"index":5717,"token":false,"name":"Viashino Slasher","scryfallId":"5fa18f23-c995-4fcc-8e95-bbf76426e703"},{"index":5718,"token":false,"name":"Shambling Remains","scryfallId":"5fdea923-094d-4f43-a5b6-b6e3f4b891d8"},{"index":5719,"token":false,"name":"Crater Hellion","scryfallId":"88e3a05a-d5c7-46d9-9a66-8de4b737e9dd"},{"index":5721,"token":false,"name":"Umori, the Collector","scryfallId":"a4efefd8-6623-4ae1-af91-dc43f658583e"},{"index":5722,"token":false,"name":"Mystic Redaction","scryfallId":"57bec76f-243b-41b6-9e47-17a61f18ae53"},{"index":5724,"token":false,"name":"Martyr of Ashes","scryfallId":"600a2cd2-166a-4fd8-838d-e513534b7cb0"},{"index":5725,"token":false,"name":"Stratus Walk","scryfallId":"947bb8f3-51f5-4fbe-9098-7e48f9fe1452"},{"index":5728,"token":false,"name":"Blazing Shoal","scryfallId":"8b915daa-d239-4460-bd6b-e1327fdf7f51"},{"index":5729,"token":false,"name":"Destined // Lead","scryfallId":"4442330b-23cf-410b-9e2b-7bd2f234a6e3"},{"index":5730,"token":false,"name":"Descendant of Kiyomaro","scryfallId":"354af7fc-fd15-4209-b3e8-8729a401b6a6"},{"index":5732,"token":false,"name":"Hunted Troll","scryfallId":"cfe19e16-33f6-4594-9dd3-2699a66ba0e8"},{"index":5734,"token":false,"name":"Taj-Nar Swordsmith","scryfallId":"70d4f00f-8e3b-48bf-ac71-4e9e0f2a6808"},{"index":5736,"token":false,"name":"Keranos, God of Storms","scryfallId":"93c13445-60e3-43a0-a56a-de91c6442367"},{"index":5737,"token":false,"name":"Aeolipile","scryfallId":"95964406-2c06-49ba-9c26-4c4a26947795"},{"index":5739,"token":false,"name":"Relic of Progenitus","scryfallId":"c76628dc-fa87-4931-bebf-91a55b8cd3d2"},{"index":5740,"token":false,"name":"Ironroot Treefolk","scryfallId":"3f5d5011-099f-4f2f-b12d-a1260fe5bbde"},{"index":5741,"token":false,"name":"Aethergeode Miner","scryfallId":"aff9859d-ff0c-4865-9629-cf3dc31ccbef"},{"index":5742,"token":false,"name":"Darksteel Garrison","scryfallId":"e77eaaa0-40f9-40e4-b0ba-5a8addd764d3"},{"index":5743,"token":false,"name":"Riptide Entrancer","scryfallId":"2cd9abc9-f289-4294-bc0f-4addc8b92a4e"},{"index":5745,"token":false,"name":"Relentless Assault","scryfallId":"b8e23c4c-f1f3-417c-a430-957e246a98ec"},{"index":5747,"token":false,"name":"Elite Cat Warrior","scryfallId":"7396c4e9-b0d8-4b8f-8c17-6f913a967b17"},{"index":5748,"token":false,"name":"Sage of Fables","scryfallId":"37b3e46e-7a65-4c2a-989b-b626b20e1b14"},{"index":5750,"token":false,"name":"Adaptive Snapjaw","scryfallId":"0d3c0c43-2d6d-49b8-a112-07611a23ae69"},{"index":5751,"token":false,"name":"Arcbound Prototype","scryfallId":"1cb0a1a4-9216-47f8-a4e3-20fe0de6a518"},{"index":5752,"token":false,"name":"Hero of Precinct One","scryfallId":"1007842c-27b9-4e0e-a12d-e05d96e9db15"},{"index":5753,"token":false,"name":"Cinder Giant","scryfallId":"de97c939-2c44-4c43-9d66-1087bcee692b"},{"index":5756,"token":false,"name":"Abzan Beastmaster","scryfallId":"6e8abee6-87e6-4d1a-a117-aeb8122c5199"},{"index":5758,"token":false,"name":"Beanstalk Giant // Fertile Footsteps","scryfallId":"1f4495c3-46be-4b9c-bedf-7998e313662b"},{"index":5759,"token":false,"name":"Arena Trickster","scryfallId":"e096049d-9f02-4abb-bb5a-97b14fd17099"},{"index":5763,"token":false,"name":"Pain Kami","scryfallId":"3c567bd1-84bf-4d52-a420-4768aded583c"},{"index":5765,"token":false,"name":"Slag Strider","scryfallId":"a3a271f3-ea5f-4947-aac3-b4cffdfa87ac"},{"index":5766,"token":true,"name":"Elf Warrior Token (G, 1/1)","scryfallId":"9e0eeebf-7c4a-436b-8cb4-292e53783ff2"},{"index":5767,"token":false,"name":"Frenzied Tilling","scryfallId":"03bce9a7-6215-43ff-b4d0-55f96f683aba"},{"index":5768,"token":false,"name":"Rumbling Slum","scryfallId":"f45ddde8-cfd3-4679-b9fb-5c2d14260469"},{"index":5771,"token":false,"name":"Soul Conduit","scryfallId":"aa7e4989-cba7-4e0c-bb9d-140af6c006c3"},{"index":5772,"token":false,"name":"Llanowar Behemoth","scryfallId":"f47054d9-ab6c-4d66-8744-b458721a6c98"},{"index":5773,"token":false,"name":"Silumgar's Command","scryfallId":"18c53663-6658-4bef-810d-6980d6d49dad"},{"index":5774,"token":false,"name":"Hunter's Prowess","scryfallId":"2c0e5ac0-48f2-44c2-814e-9bc90ff01760"},{"index":5775,"token":false,"name":"Shackles","scryfallId":"b5a92d31-d569-4520-b06a-0664fe050e64"},{"index":5776,"token":false,"name":"Ghoulcaller's Accomplice","scryfallId":"4e27974c-1279-486f-8e14-b326cd90cb06"},{"index":5777,"token":false,"name":"Slice in Twain","scryfallId":"244831cc-6383-4daf-aeee-ea4893fdb4c2"},{"index":5778,"token":false,"name":"Show of Confidence","scryfallId":"65837f39-deb7-4a4b-8b67-125a71cd0d45"},{"index":5781,"token":false,"name":"Goblin Sky Raider","scryfallId":"03555889-bb1d-4e83-9da4-5a3b4294654f"},{"index":5782,"token":false,"name":"High Ground","scryfallId":"1c5239dc-f51b-48c0-91a2-ed6551aaff32"},{"index":5783,"token":false,"name":"Xantcha, Sleeper Agent","scryfallId":"89b03b9a-7e20-47cb-bc64-23513acea855"},{"index":5784,"token":false,"name":"Court Homunculus","scryfallId":"fd20150c-ae49-457d-9f64-b72160745ff9"},{"index":5785,"token":false,"name":"Timeless Dragon","scryfallId":"d476cc60-e59d-4f34-abc9-f3eafdc2890d"},{"index":5786,"token":false,"name":"Civic Guildmage","scryfallId":"a9319039-db2f-47bf-9ef0-8d3a381d54fb"},{"index":5787,"token":false,"name":"Orcish Veteran","scryfallId":"334004e6-bf8c-4a4e-a30c-1537a99819c9"},{"index":5789,"token":false,"name":"Pristine Skywise","scryfallId":"516512f5-b4ce-46d3-bdda-c88b357192ca"},{"index":5790,"token":false,"name":"Drown in the Loch","scryfallId":"8bf5df5b-164d-4ec2-a5e6-bbaea152e271"},{"index":5791,"token":false,"name":"Lightning Dragon","scryfallId":"37d67f0d-82ed-4e40-baa6-8e4985af2224"},{"index":5792,"token":false,"name":"Sylvan Basilisk","scryfallId":"b9c09886-a733-4797-a489-46150cecfc13"},{"index":5794,"token":false,"name":"Reaper from the Abyss","scryfallId":"0831a574-33c5-4ab2-b7f6-17db2829df51"},{"index":5795,"token":false,"name":"Bringer of the White Dawn","scryfallId":"9e5a7117-b1e2-46bd-873e-baf9d9fac009"},{"index":5796,"token":false,"name":"Karlov of the Ghost Council","scryfallId":"10c9597a-abcf-4b88-9bb2-ce2d1fb68f5e"},{"index":5797,"token":false,"name":"Stonybrook Angler","scryfallId":"047709e7-c44f-47e4-a9cc-1d941264e454"},{"index":5798,"token":false,"name":"Storm Seeker","scryfallId":"456a2fdf-e91f-4d6d-840e-562fe7f5acd3"},{"index":5799,"token":false,"name":"Naya Charm","scryfallId":"8c4bf4d5-c438-407c-a1ef-64efde0f27bd"},{"index":5800,"token":false,"name":"Terror of the Peaks","scryfallId":"432ecd5f-966f-4403-a973-51e175a524a0"},{"index":5801,"token":false,"name":"Reckless Rage","scryfallId":"0e4b97a3-8f6f-461e-aa55-ab752752f539"},{"index":5802,"token":false,"name":"Martyr's Bond","scryfallId":"6eb1c64f-be2c-4033-913d-d8482a169509"},{"index":5804,"token":false,"name":"Ichor Slick","scryfallId":"33faa287-2a12-4a94-8d42-77da2b24d86f"},{"index":5805,"token":false,"name":"Sungrass Egg","scryfallId":"70e888f9-c583-478a-9ef0-2e89db8a8dbb"},{"index":5807,"token":false,"name":"Arrester's Zeal","scryfallId":"57491415-9ab8-42c1-95cb-46a0f2969a5d"},{"index":5808,"token":false,"name":"Sultai Flayer","scryfallId":"7f3b2ef3-551d-4782-8dce-a923c0e2965e"},{"index":5809,"token":false,"name":"Sky Weaver","scryfallId":"5095e0e4-d077-46a5-850c-68399fd16da6"},{"index":5810,"token":false,"name":"Myr Incubator","scryfallId":"31b0f9ef-7404-4e05-b759-aaf1ebcfcb31"},{"index":5816,"token":false,"name":"Vampire Hexmage","scryfallId":"93d2c4d1-6205-404a-b03d-995b90a3a33a"},{"index":5817,"token":true,"name":"Bear Token (G, 2/2)","scryfallId":"0a21bc37-6f21-4dda-a313-a0d75696f7fc"},{"index":5819,"token":false,"name":"Lead by Example","scryfallId":"2cdcb985-b0bb-4921-a7e4-3ee6e8f8992b"},{"index":5820,"token":false,"name":"Smothering Abomination","scryfallId":"e6f372a8-f69d-4c4c-af5d-07488dc3bc5c"},{"index":5822,"token":false,"name":"Energy Chamber","scryfallId":"4e6a6ad6-77a5-4dec-922f-1cd6780c8671"},{"index":5823,"token":false,"name":"Lumengrid Sentinel","scryfallId":"48068b80-9a98-45d0-8224-ee298cbf708f"},{"index":5825,"token":false,"name":"Dimir Infiltrator","scryfallId":"bbaebdf6-bd3c-4a71-a40c-6e9785582629"},{"index":5826,"token":false,"name":"Kabira Crossroads","scryfallId":"7f6a18b8-d490-490d-83a5-227a416ccf92"},{"index":5827,"token":false,"name":"Inquisition of Kozilek","scryfallId":"e7dd9fad-d8e3-4e46-b4d7-792d029736de"},{"index":5828,"token":false,"name":"Ancient Greenwarden","scryfallId":"31f9ca34-8bc0-4821-940b-912918ff2ac2"},{"index":5829,"token":false,"name":"Murder","scryfallId":"68c5d614-7b7a-4768-8e81-707f1f6bb34f"},{"index":5830,"token":false,"name":"Kami of Old Stone","scryfallId":"422fe3bd-d92e-4c91-8c30-3b5aec00201a"},{"index":5831,"token":false,"name":"Séance","scryfallId":"e00ae92c-af6d-4a00-b102-c6d3bcc394b4"},{"index":5832,"token":false,"name":"Primal Growth","scryfallId":"6664675f-1ef6-49ba-8f08-cfeac2f38ec7"},{"index":5834,"token":false,"name":"Serum Raker","scryfallId":"f157d08a-7cd7-4120-a8bb-1b50fa0ba99b"},{"index":5835,"token":false,"name":"Dread Wanderer","scryfallId":"fc325778-8987-40c5-a01f-264740525df0"},{"index":5837,"token":false,"name":"Midnight Haunting","scryfallId":"fe1eb098-7128-4ec8-8218-51fdde3e8326"},{"index":5839,"token":false,"name":"Battle of Wits","scryfallId":"d0375153-c663-4fb3-b0d8-50e645925e67"},{"index":5845,"token":false,"name":"Rakdos, the Showstopper","scryfallId":"4e3c30c7-c52e-41a0-b7c2-21d39c05160b"},{"index":5847,"token":false,"name":"Resilient Khenra","scryfallId":"033a69fb-2af9-426c-b1d6-3e5b18c78c9a"},{"index":5849,"token":false,"name":"Fleeting Image","scryfallId":"35971a15-7d8f-4b05-918e-605a26a11f4c"},{"index":5850,"token":false,"name":"Groundswell","scryfallId":"821e9cb9-f78e-4d11-9c36-42e8b84b49cd"},{"index":5852,"token":false,"name":"Iname as One","scryfallId":"4e13f122-0dfe-42f3-9815-9ae1a29fca99"},{"index":5853,"token":false,"name":"Foresight","scryfallId":"a4fe74e0-bcde-4176-8da5-38e78daad5e5"},{"index":5856,"token":false,"name":"Ob Nixilis of the Black Oath","scryfallId":"54a43f00-9f9d-4622-9189-93f7fe449ae7"},{"index":5857,"token":false,"name":"Angelic Page","scryfallId":"5a5022ca-9b8b-4d54-a4fa-706690b535d4"},{"index":5858,"token":false,"name":"Freewind Falcon","scryfallId":"33dc0244-319c-4e15-9083-8d21ad0364d8"},{"index":5860,"token":false,"name":"Ever After","scryfallId":"9a530a54-2711-4858-bc88-559d90be4f05"},{"index":5861,"token":false,"name":"Skyclave Relic","scryfallId":"fa2fb74a-d235-4ba6-bd7e-d439478dce44"},{"index":5862,"token":false,"name":"Hyena Umbra","scryfallId":"87128a82-bcde-4def-9447-0ab8165d6b5e"},{"index":5864,"token":false,"name":"Sylvan Echoes","scryfallId":"f5b55fa6-4c94-4ab4-bc30-4fb8b1d3e38f"},{"index":5865,"token":false,"name":"Two-Headed Sliver","scryfallId":"2f89fb3b-0238-4d76-a46d-7d6fa4a74620"},{"index":5867,"token":false,"name":"Disallow","scryfallId":"e423e3fe-0acb-4318-9b98-7aa7a3f4c931"},{"index":5869,"token":false,"name":"Thrive","scryfallId":"8ce041c2-5a63-4007-a0fa-f0a6f4b39c16"},{"index":5870,"token":false,"name":"Blazing Archon","scryfallId":"cd0bc05b-ec48-41fd-a97a-ffb0d5a2dee0"},{"index":5871,"token":false,"name":"Gossamer Phantasm","scryfallId":"307d53c7-ef63-464f-b5f0-90220ee2b575"},{"index":5872,"token":false,"name":"Reciprocate","scryfallId":"0440701b-8df5-4125-8e06-f29f91acba2f"},{"index":5874,"token":false,"name":"Audacious Thief","scryfallId":"e1ff5e66-4718-43c3-8a58-1a0a8e788f83"},{"index":5876,"token":false,"name":"Unquenchable Thirst","scryfallId":"3f4859bc-f461-48f1-97bf-6e5286afed70"},{"index":5877,"token":false,"name":"Nicol Bolas, Dragon-God","scryfallId":"2c3d5102-c305-4461-8360-534aba0f5c02"},{"index":5878,"token":false,"name":"Team Pennant","scryfallId":"be294c4e-712b-459c-a36c-e26ed5c27edb"},{"index":5881,"token":true,"name":"Julien Nuijten Bio","scryfallId":"9022a74a-f758-4475-88af-164d9e5ecf31"},{"index":5882,"token":false,"name":"Commit // Memory","scryfallId":"186b40ef-16c3-4d59-83fc-9526ca3e33e7"},{"index":5884,"token":false,"name":"Harmonious Archon","scryfallId":"c7093834-9627-4da2-9322-c03bfd5b3a71"},{"index":5889,"token":false,"name":"Bone Flute","scryfallId":"12aa4c51-4b3d-48c2-bebb-13ea98ebc3b2"},{"index":5890,"token":false,"name":"Admiral Beckett Brass","scryfallId":"fc92ac48-e09b-4301-9fb2-e129dbb97dba"},{"index":5892,"token":false,"name":"Liliana, Heretical Healer // Liliana, Defiant Necromancer","scryfallId":"b101dd14-aff1-4811-bf1b-468930dd2999"},{"index":5893,"token":false,"name":"Arcum Dagsson","scryfallId":"dd9d3ce7-53db-4808-88bc-03c120211f81"},{"index":5895,"token":true,"name":"Spider Token (G, 1/2)","scryfallId":"e8efa0fc-e710-44f8-8128-485c2d43cc9e"},{"index":5897,"token":false,"name":"Regeneration","scryfallId":"cc3d7a4f-8ccc-44cf-bacc-5055c7e1edbc"},{"index":5899,"token":false,"name":"Rakeclaw Gargantuan","scryfallId":"a158bb17-d2e0-416d-840a-5e25fb5ac5c1"},{"index":5900,"token":false,"name":"Sandsteppe Citadel","scryfallId":"799bf0da-20c3-432a-8283-646ceab76e35"},{"index":5905,"token":false,"name":"Spawning Bed","scryfallId":"e3a532b2-de88-40af-8961-b01eada05bd3"},{"index":5907,"token":false,"name":"Vivien, Monsters' Advocate","scryfallId":"504ebb84-7e7b-4119-a128-a9c183c5d9de"},{"index":5908,"token":false,"name":"Elspeth's Devotee","scryfallId":"0f82064c-b335-454c-9be6-9fbcb21aa8e5"},{"index":5910,"token":false,"name":"Spirit Shackle","scryfallId":"a30bb266-5bd1-4998-ae94-56f0f3354167"},{"index":5911,"token":false,"name":"Excavation","scryfallId":"1a4b87ff-42a9-4ea0-a79e-1208ca35ffb2"},{"index":5913,"token":false,"name":"Garruk, Savage Herald","scryfallId":"48133629-4a5b-4c91-b496-2ee94f6cbc4c"},{"index":5914,"token":false,"name":"Scent of Cinder","scryfallId":"c030eca0-bc5f-403b-8600-1f295fc85fee"},{"index":5915,"token":false,"name":"Goblin Diplomats","scryfallId":"4ad346cb-c3e5-4aea-8de6-bb62827e25a9"},{"index":5916,"token":false,"name":"Purphoros's Emissary","scryfallId":"4d4ddc30-844c-4860-b394-d3c807c31162"},{"index":5920,"token":false,"name":"Meletis Astronomer","scryfallId":"af9adca9-3e69-474f-896d-bb05b1d67252"},{"index":5922,"token":false,"name":"Genesis Ultimatum","scryfallId":"556dfe7a-43e8-4801-ad79-89ab2148eca6"},{"index":5924,"token":false,"name":"Soul of Zendikar","scryfallId":"e3563033-b1a9-402b-b289-4845efb17bfe"},{"index":5925,"token":false,"name":"Vraska's Scorn","scryfallId":"569ff807-365d-4f25-9fad-86617ed1c8f2"},{"index":5927,"token":false,"name":"Wormfang Crab","scryfallId":"dcf56dcf-ec1a-4298-8644-1fe248443b7e"},{"index":5928,"token":false,"name":"Lavabrink Venturer","scryfallId":"f2ab4e55-7c55-4480-83df-c9d9fd4df65a"},{"index":5930,"token":false,"name":"Intangible Virtue","scryfallId":"0dd21f5e-d284-4072-87b9-7f0e6140fe60"},{"index":5931,"token":false,"name":"Desolation Twin","scryfallId":"a68742d8-69f6-4b4c-a288-164c1b17ae47"},{"index":5932,"token":false,"name":"Puca's Mischief","scryfallId":"e741cabc-6722-44a4-8241-78a2356a2a94"},{"index":5933,"token":false,"name":"Giant Ambush Beetle","scryfallId":"0f6782d0-5399-4853-ae6f-0d05372dbf34"},{"index":5935,"token":false,"name":"Cobblebrute","scryfallId":"2d450105-7655-452e-9fe8-3dee579c082d"},{"index":5939,"token":false,"name":"Deadlock Trap","scryfallId":"f956dedc-2cf4-4039-8302-feab94b78426"},{"index":5940,"token":false,"name":"Elvish Vanguard","scryfallId":"455c6923-8d0e-4a7f-a5c0-add8db519ee3"},{"index":5942,"token":false,"name":"Coordinated Assault","scryfallId":"6c29f484-5f4b-4d29-846f-192425ab7fe3"},{"index":5944,"token":false,"name":"Tireless Tracker","scryfallId":"262331f4-5e9c-4019-8ab8-3a97a2a6f1e6"},{"index":5945,"token":false,"name":"Demonlord Belzenlok","scryfallId":"ffb4dbe8-15fa-467f-9366-66382b192113"},{"index":5947,"token":false,"name":"Soratami Mindsweeper","scryfallId":"70cb4090-0685-40ce-aea7-18d2cde1adda"},{"index":5948,"token":false,"name":"Elvish Warmaster","scryfallId":"32bd6e06-8971-4134-9ca4-5300a9022d85"},{"index":5949,"token":false,"name":"Mogg Fanatic","scryfallId":"f1a2c84b-53f2-48fd-9602-301b18e2813d"},{"index":5950,"token":false,"name":"Reclaiming Vines","scryfallId":"88a864ef-bc44-4ec2-b88a-7f4a59a5c1bc"},{"index":5952,"token":false,"name":"Bash to Bits","scryfallId":"694b24de-d7f8-49c6-8ab3-d5fab13b6a8f"},{"index":5953,"token":false,"name":"Pygmy Razorback","scryfallId":"0ad9744f-797a-4dd3-8617-192773be995c"},{"index":5955,"token":false,"name":"Apprentice Wizard","scryfallId":"fe75a1c1-e55e-4c49-9419-43bf5962142d"},{"index":5956,"token":false,"name":"Rakdos Guildmage","scryfallId":"0e01fef8-5563-4dec-ab8e-e486e19e202c"},{"index":5958,"token":false,"name":"Treetop Bracers","scryfallId":"d6d85032-26e9-44af-ab52-56d9c24e337d"},{"index":5959,"token":false,"name":"Time Spiral","scryfallId":"f3d62dbd-63db-4ac9-950f-9852627f23f2"},{"index":5961,"token":false,"name":"Primordial Ooze","scryfallId":"dab748e8-5917-4c7f-8d5f-18dadcb82abe"},{"index":5962,"token":false,"name":"Hedron Alignment","scryfallId":"23675c56-ba6c-4100-a203-a5006bf02eee"},{"index":5964,"token":false,"name":"Racecourse Fury","scryfallId":"15d13d35-b5f7-4d3d-a1fa-84178b28acae"},{"index":5965,"token":false,"name":"Vile Entomber","scryfallId":"36590526-2f1b-4959-ba9e-55f3ebcffd1e"},{"index":5966,"token":false,"name":"Opposition","scryfallId":"95be2701-af7c-483e-8165-e8bd4b2774ed"},{"index":5968,"token":false,"name":"Departed Deckhand","scryfallId":"1081df25-1137-4c4d-909b-40e78723652c"},{"index":5970,"token":false,"name":"Blindblast","scryfallId":"1d49637b-2255-4f16-8f24-140145966bfa"},{"index":5971,"token":false,"name":"Blasphemous Act","scryfallId":"40e1ef14-cb26-486e-9b54-0b532f5b7435"},{"index":5972,"token":false,"name":"Carrion Ants","scryfallId":"21bf491b-b876-4453-8c85-8d7c419b0900"},{"index":5973,"token":false,"name":"Sea Drake","scryfallId":"5a8b69ff-22ef-451f-8322-b54eec79bacf"},{"index":5974,"token":false,"name":"Courageous Outrider","scryfallId":"4123da54-9947-462e-9862-3eecc459a75b"},{"index":5976,"token":false,"name":"Farmstead","scryfallId":"3d79940b-9384-4009-8b74-3d56a2c5a8a5"},{"index":5978,"token":false,"name":"Ondu Inversion // Ondu Skyruins","scryfallId":"9595a1af-0eae-4beb-bdde-d09706209aa8"},{"index":5979,"token":false,"name":"Gravepurge","scryfallId":"3c0c266b-9ef5-4de2-a358-65739de41491"},{"index":5982,"token":false,"name":"Path to Exile","scryfallId":"206fd18a-f263-42cd-a77a-e40ae31a468a"},{"index":5983,"token":false,"name":"Boon Reflection","scryfallId":"1a27ba4d-53af-427d-9e51-be04db077fac"},{"index":5984,"token":false,"name":"Creeping Renaissance","scryfallId":"71569961-d56c-43f9-ae51-d86561419743"},{"index":5985,"token":false,"name":"Jace, Mirror Mage","scryfallId":"573ab90a-61af-4e2d-9da8-ba468086a716"},{"index":5986,"token":false,"name":"Mageta the Lion","scryfallId":"5861dffc-5afa-44a3-a3fa-9fd440093377"},{"index":5987,"token":false,"name":"Overlaid Terrain","scryfallId":"230c7926-9a4b-4ead-b4c8-889f84210545"},{"index":5988,"token":false,"name":"Crash Through","scryfallId":"8257c205-00cd-4d41-bd58-098575ea2343"},{"index":5989,"token":false,"name":"Kozilek's Translator","scryfallId":"d80665ae-fcb2-48fd-95be-8768293bcef7"},{"index":5992,"token":false,"name":"Harsh Mentor","scryfallId":"8936bf9d-c973-4bce-b5c2-2a01b7953638"},{"index":5993,"token":false,"name":"Cursed Rack","scryfallId":"cac00b69-e889-4f1a-b9cd-f0670bf7e60c"},{"index":5996,"token":false,"name":"Shambleshark","scryfallId":"07855a17-4e68-4257-af7f-275c9fb0a9b8"},{"index":5997,"token":false,"name":"Soul's Fire","scryfallId":"11217e72-9009-40c7-a9eb-98e10b41667b"},{"index":5998,"token":false,"name":"Nostalgic Dreams","scryfallId":"299065ad-ee2e-4973-9b41-fd04c36d19a4"},{"index":6001,"token":false,"name":"Coal Stoker","scryfallId":"3a6bdc34-1ef6-4de3-a9a9-b5dd503e02c0"},{"index":6002,"token":true,"name":"Elemental Token (R, 1/1)","scryfallId":"577a3396-e974-47fb-91bd-01751cae83bf"},{"index":6004,"token":false,"name":"Sacred Mesa","scryfallId":"6622f325-6bc3-49dc-ba8e-154e70772dd5"},{"index":6008,"token":false,"name":"Wildwood Patrol","scryfallId":"cceaf927-261e-4d61-9fac-eb8abbe87593"},{"index":6009,"token":false,"name":"Teferi, Hero of Dominaria","scryfallId":"5d10b752-d9cb-419d-a5c4-d4ee1acb655e"},{"index":6010,"token":false,"name":"Tale's End","scryfallId":"1421115b-9a98-4ab2-bcb2-7d8899ce12db"},{"index":6016,"token":false,"name":"Death Rattle","scryfallId":"8cddafc8-57d6-456e-af58-4b7f45e195d5"},{"index":6017,"token":false,"name":"Thunderscape Battlemage","scryfallId":"d707243e-7f11-44bc-b8b8-af635ab1dc87"},{"index":6018,"token":false,"name":"Sleeper's Robe","scryfallId":"3411f0fd-8b85-4d0d-a202-701a24ffac9f"},{"index":6019,"token":false,"name":"Temporal Mastery","scryfallId":"266e5267-2288-4bb0-8c54-0c556521cec3"},{"index":6020,"token":false,"name":"Kaya the Inexorable","scryfallId":"35e3a516-2989-4cac-892f-deb3d754ba7d"},{"index":6021,"token":false,"name":"Ajani Goldmane","scryfallId":"46c50891-af21-4427-a495-0e66aef54809"},{"index":6022,"token":false,"name":"Languish","scryfallId":"98bd5747-dd78-41c5-b840-e023beb3206e"},{"index":6025,"token":false,"name":"Primal Might","scryfallId":"0b61676e-6911-4d34-bbaf-2a63ee83310d"},{"index":6026,"token":false,"name":"Plague Sliver","scryfallId":"703d491e-b25f-44fa-8b76-b955a4e75ba5"},{"index":6027,"token":false,"name":"Rampant Growth","scryfallId":"a429a983-d28e-46e7-816f-0398428db11a"},{"index":6030,"token":false,"name":"Trumpeting Armodon","scryfallId":"38f94fd1-6f85-41ad-9674-f05cc893324f"},{"index":6031,"token":false,"name":"Herald of Secret Streams","scryfallId":"4d71f0b5-777c-4e6c-b703-41b2442a2d4a"},{"index":6032,"token":false,"name":"Trailblazer","scryfallId":"9194c69d-c849-4c4a-976c-d1382bd5cf32"},{"index":6033,"token":false,"name":"Root Cage","scryfallId":"db109497-7674-4067-a12b-dfb5c317a358"},{"index":6035,"token":false,"name":"Hangarback Walker","scryfallId":"791c21fb-fc78-4106-9a42-abc73f41ab8b"},{"index":6036,"token":false,"name":"Pox","scryfallId":"d9debe4f-c1cc-4b90-aae4-f31f737e2016"},{"index":6037,"token":false,"name":"Arcum's Weathervane","scryfallId":"6d18593a-a839-419f-ab6d-c7b9b3cde816"},{"index":6038,"token":false,"name":"Sliver Queen","scryfallId":"ab68bd00-7151-4a6b-ad98-134ca02d7d59"},{"index":6039,"token":false,"name":"Godless Shrine","scryfallId":"ced4c824-2dfc-42ae-84e6-09f8e3f51b5b"},{"index":6040,"token":false,"name":"Rancor","scryfallId":"6e3e20db-94d2-47eb-ab21-c8159e42f677"},{"index":6043,"token":false,"name":"Guardian of the Great Conduit","scryfallId":"72638ac5-84fd-4688-9b81-0eea3c05e53e"},{"index":6045,"token":false,"name":"Eager First-Year","scryfallId":"7a83543b-3b6f-4e28-96f9-007b814bcfd6"},{"index":6048,"token":false,"name":"Guiding Voice","scryfallId":"d6fb3163-12ca-4a7f-a0c7-b8ddfc9408a0"},{"index":6051,"token":false,"name":"Reckless Spite","scryfallId":"32bf8018-e5d8-4ddc-bf4f-26abe16de1d3"},{"index":6052,"token":false,"name":"Cartouche of Zeal","scryfallId":"36323cd9-70f9-423c-a0ef-9c2758f7201c"},{"index":6055,"token":false,"name":"Leave in the Dust","scryfallId":"049955c6-63f5-4f80-8c60-34c890f3c71a"},{"index":6056,"token":false,"name":"Secure the Scene","scryfallId":"d6467d96-e43a-4b1e-b6ce-578d991077b5"},{"index":6057,"token":true,"name":"Treefolk Warrior Token (G, */*)","scryfallId":"2569593a-d2f2-414c-9e61-2c34e8a5832d"},{"index":6058,"token":false,"name":"Pardic Collaborator","scryfallId":"a9a60f33-1d1a-4c7c-9eb2-d9fc0d56b127"},{"index":6059,"token":false,"name":"Mystic Gate","scryfallId":"3fe71ae5-5553-4b41-89e0-fd767f9bf430"},{"index":6060,"token":false,"name":"Zo-Zu the Punisher","scryfallId":"c4d85598-5ec5-4084-8e30-07053b939dba"},{"index":6061,"token":false,"name":"Padeem, Consul of Innovation","scryfallId":"e31b30a7-13e8-408e-a758-60e6e9290808"},{"index":6062,"token":false,"name":"Artificer's Epiphany","scryfallId":"4c847774-c76d-44bd-acf6-bc1bc865ac77"},{"index":6065,"token":false,"name":"Wasp of the Bitter End","scryfallId":"46d348eb-7db0-4209-8960-c6adc473417d"},{"index":6066,"token":false,"name":"Platinum Angel","scryfallId":"2bffc898-16c6-46ab-89b7-cb218d08beea"},{"index":6067,"token":false,"name":"Lightning Spear","scryfallId":"f72fcda4-feb4-46e4-87d9-88bd95474fe9"},{"index":6069,"token":false,"name":"Yarok, the Desecrated","scryfallId":"260d1cee-2a05-44d2-ae7d-07048bb4c851"},{"index":6072,"token":false,"name":"Thornling","scryfallId":"16691f25-8d6f-4edd-84ad-3209e8a74cf3"},{"index":6074,"token":false,"name":"Pariah","scryfallId":"51b2136c-392c-436d-9263-b3236adc4a10"},{"index":6075,"token":false,"name":"Armorer Guildmage","scryfallId":"e999fdc3-9269-44d7-9015-e16f5e5b73eb"},{"index":6077,"token":false,"name":"Honden of Infinite Rage","scryfallId":"174bcea4-4e9c-4de5-b001-6a9df2242e37"},{"index":6078,"token":false,"name":"Akroan Crusader","scryfallId":"a47c50d9-11ec-486b-a5ce-5a6b70858f30"},{"index":6080,"token":false,"name":"Gravity Negator","scryfallId":"85f9b63e-6ecc-4d85-9724-87b8176ae6a6"},{"index":6082,"token":false,"name":"Dark Revenant","scryfallId":"2167cc6d-ddb5-4f13-8905-a0c5123b852a"},{"index":6084,"token":false,"name":"Early Harvest","scryfallId":"4f4e18b5-baef-4fe9-807e-097b972c879f"},{"index":6086,"token":false,"name":"Twitch","scryfallId":"267f18b9-efe7-4ff4-9932-7fbb3cfe5436"},{"index":6087,"token":false,"name":"Stave Off","scryfallId":"992f0d69-6755-4316-982a-75e5537204a6"},{"index":6088,"token":false,"name":"Thieves' Auction","scryfallId":"b5708c87-108d-4ba1-a1e9-e83cb9b16b6c"},{"index":6089,"token":false,"name":"Ironclad Krovod","scryfallId":"afb16895-6542-405e-9793-154ffc439f23"},{"index":6094,"token":false,"name":"Riddle of Lightning","scryfallId":"338be9e2-c0b8-4b69-b7b6-6ba9927a3a4d"},{"index":6095,"token":false,"name":"Déjà Vu","scryfallId":"ade6a71a-e8ec-4d41-8a39-3eacf0097c8b"},{"index":6098,"token":false,"name":"Righteous War","scryfallId":"bbcacb8e-1aff-4807-b70c-a17d6703d279"},{"index":6099,"token":false,"name":"Stand or Fall","scryfallId":"60c34970-a106-490c-ac37-6156eb7f34ce"},{"index":6101,"token":false,"name":"Pelakka Wurm","scryfallId":"00906b47-6316-4e00-bbf5-b801ab583f4f"},{"index":6102,"token":false,"name":"Forcemage Advocate","scryfallId":"1ad217fe-9309-4c67-8a6a-cfb8b1ce91f1"},{"index":6104,"token":false,"name":"Cyclops of One-Eyed Pass","scryfallId":"71a25c69-8e57-4a44-955a-da1541bbe0fe"},{"index":6105,"token":false,"name":"Stone Rain","scryfallId":"eb5935ef-8cc5-4587-b8eb-f6a2b2856260"},{"index":6106,"token":false,"name":"Abbey Griffin","scryfallId":"bf87803b-e7c6-4122-add4-72e596167b7e"},{"index":6108,"token":false,"name":"Chosen by Heliod","scryfallId":"d8ead499-920c-465a-a23d-f08710d7e9bc"},{"index":6109,"token":false,"name":"Null Champion","scryfallId":"8bf39e84-a554-49e3-8f65-e304e1720818"},{"index":6111,"token":false,"name":"Deep-Sea Terror","scryfallId":"007b526c-5387-4ed4-a320-b826d507e014"},{"index":6112,"token":false,"name":"Emiel the Blessed","scryfallId":"f74dfd07-d17c-4890-82c3-4b12a6029940"},{"index":6116,"token":false,"name":"Agonizing Syphon","scryfallId":"3532a279-b8e1-4124-bcd7-d7f4c71673eb"},{"index":6117,"token":false,"name":"Siege Mastodon","scryfallId":"40e7a30f-bb29-4c6b-bf70-53e9e4292814"},{"index":6118,"token":false,"name":"Primeval Bounty","scryfallId":"e750d55d-d5e8-4abe-99cf-f6b8ba86cf16"},{"index":6119,"token":false,"name":"Pteramander","scryfallId":"d1fb3393-8ba7-400a-adf7-7c42e002e701"},{"index":6120,"token":false,"name":"Highspire Mantis","scryfallId":"0761bc38-92e7-44e0-80bd-083a6f9a4fde"},{"index":6122,"token":false,"name":"Gruul Turf","scryfallId":"550b70e0-ebd5-49de-b62c-5224b8bf8e98"},{"index":6123,"token":false,"name":"Welkin Guide","scryfallId":"ee5c82bd-9946-4121-94f6-70442dab9f54"},{"index":6125,"token":false,"name":"Realm-Cloaked Giant // Cast Off","scryfallId":"fa40eedd-6de3-4d63-8304-0101e1e3d51a"},{"index":6126,"token":false,"name":"Deathless Knight","scryfallId":"39c6e952-97b5-435c-a7fd-6271ddc23200"},{"index":6127,"token":false,"name":"Tolarian Sentinel","scryfallId":"da4d6572-4748-4242-98d2-62e668a59a48"},{"index":6128,"token":false,"name":"Defeat","scryfallId":"9089c86d-c29a-45f3-b826-8cdb81cda990"},{"index":6129,"token":false,"name":"Niv-Mizzet, the Firemind","scryfallId":"93fd56e6-5d54-426e-9e44-ec2ad8a63724"},{"index":6130,"token":false,"name":"Boar Umbra","scryfallId":"bf6e8df5-afe6-42f9-a9b6-487be1a59483"},{"index":6135,"token":false,"name":"Neheb, the Worthy","scryfallId":"bc64efb4-46ea-4caf-b864-3e38ca6369d4"},{"index":6137,"token":false,"name":"Basilisk Collar","scryfallId":"9aeab4ce-0828-40f1-a058-0d6695646f4e"},{"index":6138,"token":false,"name":"Malakir Cullblade","scryfallId":"70861692-1eb2-4cb1-8d7f-b881386c37d1"},{"index":6139,"token":false,"name":"Iroas, God of Victory","scryfallId":"cacf28cb-feea-4afb-b22e-1b8d50ee66c1"},{"index":6140,"token":false,"name":"Tree of Tales","scryfallId":"ba5f8529-27a0-4807-979a-02fdfe7998ba"},{"index":6141,"token":false,"name":"Platinum Emperion","scryfallId":"861100b0-ff7b-4aac-82aa-039365c826aa"},{"index":6144,"token":false,"name":"Sinuous Vermin","scryfallId":"e50f5505-fcbb-4a84-bcf6-950362d83201"},{"index":6145,"token":false,"name":"Walking Ballista","scryfallId":"33622675-7bb3-4d4c-9bca-5db68d7d166b"},{"index":6146,"token":false,"name":"Questing Phelddagrif","scryfallId":"3b05a233-2601-41cb-9091-8f4a2a254209"},{"index":6147,"token":false,"name":"Karoo Meerkat","scryfallId":"16396594-4f59-4600-8e39-d99544062265"},{"index":6148,"token":false,"name":"Giant Tortoise","scryfallId":"78ecdc6d-52e7-4a41-be96-623c11e314ea"},{"index":6149,"token":false,"name":"Keep Watch","scryfallId":"6e702ee4-62b5-4d3b-a202-8cac4b84591c"},{"index":6151,"token":false,"name":"Shineshadow Snarl","scryfallId":"f8847609-a7fd-447b-be7a-8f31bc5ea43f"},{"index":6152,"token":false,"name":"Oblivion Stone","scryfallId":"d5894997-030f-4c8a-b294-f08f0819f754"},{"index":6153,"token":false,"name":"Task Force","scryfallId":"17a58c5b-28c2-4261-992c-2ecadb721880"},{"index":6156,"token":false,"name":"Force of Despair","scryfallId":"8f497b0d-4448-4201-bd55-c147da1a216d"},{"index":6157,"token":false,"name":"Drain Life","scryfallId":"41a9b3b2-4ac9-4e50-bcd2-8831d0739e85"},{"index":6158,"token":false,"name":"Trial of Strength","scryfallId":"acadb754-4a3b-4633-b784-252c0e1ab650"},{"index":6160,"token":false,"name":"Ice-Fang Coatl","scryfallId":"6a55cfed-e76c-4ade-ac78-a546e05fe8da"},{"index":6161,"token":false,"name":"Lost in a Labyrinth","scryfallId":"09aa7744-680f-4c2a-8fa0-9cb0c176ae8f"},{"index":6162,"token":false,"name":"Halimar Excavator","scryfallId":"d147dce7-b2dd-426a-9ff7-843d50bb8b01"},{"index":6163,"token":true,"name":"Illusion Token (U, 1/1)","scryfallId":"b24ae780-d226-4deb-9a4a-91262763d0cd"},{"index":6165,"token":false,"name":"Orah, Skyclave Hierophant","scryfallId":"1969f815-cffb-48ca-bd01-2b9420685644"},{"index":6167,"token":false,"name":"Imposing Vantasaur","scryfallId":"b6fa5feb-f5e9-4079-acc9-84e458044769"},{"index":6170,"token":false,"name":"Skeletal Kathari","scryfallId":"a3e7e593-e5b0-4348-b8e5-20173d41aa39"},{"index":6171,"token":false,"name":"Cromat","scryfallId":"7d9e0a23-d2a8-40a6-9076-ed6fb539141b"},{"index":6174,"token":false,"name":"Ruthless Knave","scryfallId":"1ce91e38-4601-4354-ad1b-2c5c1c70da17"},{"index":6175,"token":false,"name":"Sorin's Thirst","scryfallId":"1f14a435-811d-4057-93a9-ce74aa852a09"},{"index":6178,"token":false,"name":"Tempest Djinn","scryfallId":"9ef01d2d-63dc-40b1-a6d6-b03be9064996"},{"index":6179,"token":false,"name":"Blood Tribute","scryfallId":"c76487d3-1d52-4c31-917e-eb929907218d"},{"index":6183,"token":false,"name":"Shade of Trokair","scryfallId":"a4e4d9c6-416b-47fd-93a5-6c19d89b7c7f"},{"index":6184,"token":true,"name":"Rivals of Ixalan Checklist","scryfallId":"9236ab9c-7730-46d9-a543-84ff7b245ece"},{"index":6186,"token":false,"name":"Bronze Sable","scryfallId":"ba7e563d-964c-4afd-9e21-9d400f8719d4"},{"index":6187,"token":false,"name":"Scion of the Ur-Dragon","scryfallId":"565b2a40-57b1-451f-8c2a-e02222502288"},{"index":6190,"token":false,"name":"Gnat Alley Creeper","scryfallId":"0ccf9c8b-8a03-4ef8-8267-af57ac35fe02"},{"index":6193,"token":false,"name":"Spinneret Sliver","scryfallId":"7f86e30d-d9e8-48f7-8bd1-f2645f0ab3f4"},{"index":6194,"token":false,"name":"Gideon Jura","scryfallId":"79aa9588-373d-440b-9a43-2d4a50fe8e5e"},{"index":6196,"token":false,"name":"Pitfall Trap","scryfallId":"ad230704-996e-4c43-af4a-806c90d06025"},{"index":6197,"token":false,"name":"Cyclopean Mummy","scryfallId":"8de50323-7ce8-4ca6-a90b-b4be9d639752"},{"index":6198,"token":false,"name":"Eidolon of Inspiration","scryfallId":"53343a0c-d97c-4d6f-b696-5343a962e3dd"},{"index":6201,"token":false,"name":"Murk Dwellers","scryfallId":"7731dc37-2eac-4e60-bb0f-6230205a5323"},{"index":6202,"token":false,"name":"Stitch in Time","scryfallId":"4a57766e-8966-4e14-b78f-48ecb5d889c1"},{"index":6203,"token":false,"name":"Flash Counter","scryfallId":"dc14e61f-481a-4bfa-aca0-fb63dc952be6"},{"index":6205,"token":false,"name":"Incremental Growth","scryfallId":"ca3528ed-e1a1-4020-acba-c079484de0ba"},{"index":6206,"token":false,"name":"God-Pharaoh's Gift","scryfallId":"b2e85a9e-4c37-4721-b7ea-de3413ec39df"},{"index":6207,"token":false,"name":"Ripscale Predator","scryfallId":"c9141d96-ad3a-4e30-b356-44e136e1f62f"},{"index":6208,"token":false,"name":"Dwarven Miner","scryfallId":"436a714e-3408-4fe6-b400-f7877829c556"},{"index":6210,"token":false,"name":"Selesnya Charm","scryfallId":"6e52d1a2-064f-4dcb-983d-322aec1776f8"},{"index":6212,"token":false,"name":"Thought Reflection","scryfallId":"e169e197-5ef4-454d-a31f-fcadedb74cfc"},{"index":6214,"token":false,"name":"Loxodon Peacekeeper","scryfallId":"9c9e7029-bea3-4a33-bd05-774e802616d4"},{"index":6215,"token":false,"name":"Clout of the Dominus","scryfallId":"7c8ce6d6-014f-46c2-baf3-f250e9dc3085"},{"index":6220,"token":false,"name":"Undying Rage","scryfallId":"4f7ff7d2-a8f1-4ce4-acad-828ef36afe07"},{"index":6224,"token":false,"name":"Cloudshift","scryfallId":"12b1e18f-f781-498c-ba84-cdee49c24230"},{"index":6226,"token":false,"name":"Robber of the Rich","scryfallId":"0ecbe097-ba51-42e5-957c-382eb66c08f0"},{"index":6227,"token":false,"name":"Write into Being","scryfallId":"548ee36f-b1be-4e81-bb04-1ccdacde615c"},{"index":6230,"token":false,"name":"Withered Wretch","scryfallId":"29190989-77af-44af-a757-2a3b63fe9e77"},{"index":6232,"token":false,"name":"Kazandu Refuge","scryfallId":"6ca097f1-eef0-4e18-ab5d-49bb4aeb74e2"},{"index":6234,"token":false,"name":"Keldon Necropolis","scryfallId":"4f0cccf6-b79b-4fff-89aa-801341598532"},{"index":6235,"token":false,"name":"Goham Djinn","scryfallId":"d67796c7-4d93-4c50-8839-bb69e075bc42"},{"index":6236,"token":false,"name":"Murmuring Phantasm","scryfallId":"9752644c-7c43-429e-a79c-1239b9a0bc8a"},{"index":6238,"token":false,"name":"Dwarven Ruins","scryfallId":"048fc9a8-cc3c-43a1-89dd-c9a8fa72bdc6"},{"index":6240,"token":false,"name":"Varina, Lich Queen","scryfallId":"715af497-ea9d-440e-90eb-5da45a61c1ac"},{"index":6242,"token":false,"name":"Weathered Wayfarer","scryfallId":"1caacfab-84cf-4a29-9493-3da6250f2c1f"},{"index":6243,"token":false,"name":"Boomerang","scryfallId":"f4095675-1e3f-4d3c-b565-5c434d2e5cc0"},{"index":6245,"token":false,"name":"Coveted Prize","scryfallId":"dceacc17-c5a9-40b7-a54e-b8fcc0267ad0"},{"index":6247,"token":false,"name":"Kinsbaile Skirmisher","scryfallId":"ff0c73b7-a242-4fca-ab96-194750c984a7"},{"index":6248,"token":false,"name":"Dermotaxi","scryfallId":"43a37428-e969-4c0c-8e1c-55d1adf9c171"},{"index":6249,"token":false,"name":"Utopia Vow","scryfallId":"d97f2ddb-3111-45a2-8334-a526bc885415"},{"index":6250,"token":false,"name":"Desert of the Glorified","scryfallId":"04a19aea-209d-4354-8c59-d08244185eb8"},{"index":6251,"token":false,"name":"Rakdos Charm","scryfallId":"ff218327-ce37-4eb7-95a5-cc4d038920d9"},{"index":6252,"token":false,"name":"Voracious Greatshark","scryfallId":"de44e59a-d140-4b65-b0a3-6951ffda1c1e"},{"index":6253,"token":false,"name":"Sword of Hearth and Home","scryfallId":"a16fabbe-4557-4067-b882-f2e5dbd8b458"},{"index":6254,"token":false,"name":"Reidane, God of the Worthy // Valkmira, Protector's Shield","scryfallId":"c717b484-4b88-4073-a185-71b6085e7324"},{"index":6255,"token":false,"name":"Vacuumelt","scryfallId":"f8ee2e36-783c-4037-99f7-303d7db7fd15"},{"index":6257,"token":false,"name":"Dowsing Shaman","scryfallId":"31a2a6d8-52de-4796-b299-69b586fa0b92"},{"index":6258,"token":false,"name":"Warlord's Axe","scryfallId":"41ab6393-df29-475b-b56d-c56eb95de05d"},{"index":6259,"token":false,"name":"Might of Oaks","scryfallId":"b1bab68d-da36-43b9-9778-d385d81a0bc5"},{"index":6260,"token":false,"name":"Battering Sliver","scryfallId":"d0dc86d6-aa3e-46c6-9405-86f1e1ee7844"},{"index":6261,"token":false,"name":"Hidden Dragonslayer","scryfallId":"87c760a8-e051-4584-ae1b-178164b84427"},{"index":6262,"token":false,"name":"Showdown of the Skalds","scryfallId":"60c80c69-3bee-4c53-aac8-afc313973abc"},{"index":6264,"token":false,"name":"Acorn Harvest","scryfallId":"32987720-cc0c-416b-b79b-217d3b37542d"},{"index":6267,"token":false,"name":"Zameck Guildmage","scryfallId":"feeaf99b-7720-42e3-8cb1-23218b646458"},{"index":6268,"token":false,"name":"Reflex Sliver","scryfallId":"9017d37d-f47d-405e-95d8-78a8eec8addc"},{"index":6269,"token":false,"name":"Curse of Inertia","scryfallId":"32d0c2a7-4277-43eb-bb09-5ca0c27edee4"},{"index":6272,"token":false,"name":"Hurr Jackal","scryfallId":"50d7c23b-d836-48e1-a0f6-2966a30b7eba"},{"index":6274,"token":false,"name":"Grind // Dust","scryfallId":"54103be4-eb5a-40b7-be22-ae0a15bc71cf"},{"index":6277,"token":false,"name":"Ingenious Infiltrator","scryfallId":"a92b3ded-40d9-4e50-a64c-b326e3fd52ed"},{"index":6278,"token":false,"name":"Sunscape Battlemage","scryfallId":"679e3d63-8902-458e-a9a3-cefe14f6b415"},{"index":6279,"token":false,"name":"Ensoul Artifact","scryfallId":"8351efc5-a392-4ec8-877f-15d5b3dc0929"},{"index":6281,"token":false,"name":"Golgari Keyrune","scryfallId":"913b803f-ba82-4660-86be-49677d1e32c9"},{"index":6282,"token":false,"name":"Furnace of Rath","scryfallId":"e139a085-d8fe-40a0-984d-4ce9378c48f7"},{"index":6283,"token":false,"name":"Chandra, Bold Pyromancer","scryfallId":"ba9d2384-5c3f-4eb1-86b4-26ee13f1c767"},{"index":6285,"token":false,"name":"Total War","scryfallId":"6107388b-ec1e-401e-a407-a821c908ed8d"},{"index":6286,"token":false,"name":"Captain Ripley Vance","scryfallId":"71052204-d35c-4603-9af6-a1691f438d48"},{"index":6287,"token":false,"name":"Natural Connection","scryfallId":"27d47d9d-673f-4a79-8dee-91b474c68df3"},{"index":6289,"token":false,"name":"Resupply","scryfallId":"ecf47c52-4065-4b81-acdc-878e74767bba"},{"index":6291,"token":false,"name":"Heir of the Wilds","scryfallId":"20989657-bb6b-4be2-93c7-84b0ad3022e0"},{"index":6293,"token":false,"name":"Moorish Cavalry","scryfallId":"c6ae847c-9b88-4e34-930f-2f4fd28423f7"},{"index":6294,"token":false,"name":"Maze Behemoth","scryfallId":"0a7c9678-dea7-4219-bac0-9e1cef531f54"},{"index":6296,"token":false,"name":"Nezumi Cutthroat","scryfallId":"8a9c29bf-a177-40d5-9ade-129221222900"},{"index":6297,"token":true,"name":"Kithkin Soldier Token (W, 1/1)","scryfallId":"2807ea6a-479e-45c2-b3c7-df59783b0e5b"},{"index":6299,"token":false,"name":"Planar Birth","scryfallId":"c7cacdff-aa83-4644-b2f0-ce8c89dddfbf"},{"index":6300,"token":false,"name":"Oath of Lieges","scryfallId":"470a2092-eeda-4557-8cee-ac401b61a225"},{"index":6301,"token":false,"name":"Hedron Matrix","scryfallId":"54fef322-b214-40b4-bed5-bc867bcf280b"},{"index":6302,"token":false,"name":"New Horizons","scryfallId":"02c521da-677e-43b9-b5fe-c84dc64e66ec"},{"index":6304,"token":false,"name":"Elvish Harbinger","scryfallId":"78db70ff-f68c-474a-9785-12a71be4f699"},{"index":6306,"token":false,"name":"Enigma Sphinx","scryfallId":"ae197165-53ad-4e85-92e0-e3531c2db412"},{"index":6308,"token":false,"name":"Aven Sunstriker","scryfallId":"4a54b36b-5a8d-41a1-9371-1a59d81c2733"},{"index":6309,"token":false,"name":"Elvish Herder","scryfallId":"3cb2b07e-3d50-4b85-be2a-c99e9c8ebf25"},{"index":6314,"token":false,"name":"Oblivion Ring","scryfallId":"83e36474-441a-48e3-967d-14984c77ec20"},{"index":6315,"token":false,"name":"Word of Undoing","scryfallId":"22b04476-5a5d-4843-a948-82db209c4218"},{"index":6316,"token":false,"name":"Doom Foretold","scryfallId":"4e6d15f8-7ebc-43b7-b8fd-00555e74bcb0"},{"index":6319,"token":false,"name":"Mythos of Nethroi","scryfallId":"c2ee2fb3-eb0e-47dc-b001-3771140c6dd9"},{"index":6322,"token":false,"name":"Borrowing 100,000 Arrows","scryfallId":"d48d2295-d2ad-4ebb-bab7-217f5987a0ff"},{"index":6324,"token":false,"name":"Borrowed Hostility","scryfallId":"8e68545e-c137-4541-a2e5-33cc307199b7"},{"index":6326,"token":false,"name":"Sarkhan's Triumph","scryfallId":"f9a0ff4d-060e-41dc-8b79-1fa42838adf2"},{"index":6327,"token":false,"name":"Crux of Fate","scryfallId":"e1d45374-a41b-4b3f-a7c8-3eb5ca767cf6"},{"index":6329,"token":false,"name":"Persist","scryfallId":"90f390c3-af1c-424f-9721-e26e9321e5a3"},{"index":6330,"token":false,"name":"Shatterskull Smashing // Shatterskull, the Hammer Pass","scryfallId":"caf85b78-8318-4dfa-9c75-5b5857a4cf07"},{"index":6331,"token":false,"name":"Rhox War Monk","scryfallId":"84d52069-b094-4c99-8ac4-a2d7ecd5deb6"},{"index":6332,"token":false,"name":"Fyndhorn Brownie","scryfallId":"06204e82-9dfd-4334-a23a-f8240fc37772"},{"index":6334,"token":false,"name":"Briar Patch","scryfallId":"b5913fc6-eeb0-411b-9264-1e75bea8489b"},{"index":6335,"token":false,"name":"Ovalchase Dragster","scryfallId":"20411aa0-f87b-49dd-b943-ca82d59db185"},{"index":6337,"token":false,"name":"Endless Atlas","scryfallId":"d2547a42-b2b9-4887-8671-4cf63a7b0eff"},{"index":6339,"token":false,"name":"Yoked Ox","scryfallId":"12fc09d4-e6ce-428b-818b-b465093af88e"},{"index":6340,"token":false,"name":"Jerrard of the Closed Fist","scryfallId":"7f841918-813b-4784-ab57-907185b0a355"},{"index":6342,"token":false,"name":"Puresteel Paladin","scryfallId":"ca100248-fcd6-41ed-8d75-bcb473845edd"},{"index":6343,"token":false,"name":"Fungus Sliver","scryfallId":"be17c49e-7634-4698-a2e4-7cd3068d9971"},{"index":6344,"token":false,"name":"Viashino Sandscout","scryfallId":"237da964-df20-4bb1-bb87-c3a9582b54ab"},{"index":6345,"token":false,"name":"Voltaic Key","scryfallId":"02efd6cf-1ed0-44b3-b3b9-94a45696e1f3"},{"index":6346,"token":false,"name":"Patron of the Kitsune","scryfallId":"102ee72e-5fb8-4059-9dfa-98004e222c27"},{"index":6348,"token":false,"name":"Brisela, Voice of Nightmares","scryfallId":"5a7a212e-e0b6-4f12-a95c-173cae023f93"},{"index":6350,"token":false,"name":"Horned Helm","scryfallId":"3d995d55-9450-43aa-b220-054201755d6f"},{"index":6353,"token":false,"name":"Into the Void","scryfallId":"236fbb72-3aea-4737-bf90-bd4d4e80b527"},{"index":6355,"token":false,"name":"Will of the All-Hunter","scryfallId":"aa7acbfa-ce3b-424d-886d-6865bc5fc085"},{"index":6356,"token":false,"name":"Sphinx of the Second Sun","scryfallId":"e68b70a6-a150-4d81-921c-9b178fe0037d"},{"index":6359,"token":false,"name":"Llanowar Tribe","scryfallId":"723d3d8d-e78b-40b8-aed5-888a2d0baa60"},{"index":6360,"token":false,"name":"Sudden Shock","scryfallId":"4724e754-fa23-4c60-9531-c6ef0d5f9f76"},{"index":6361,"token":false,"name":"Uncontrollable Anger","scryfallId":"83fca4fa-d0e1-41c4-999a-9804786eacbb"},{"index":6362,"token":false,"name":"Azra Bladeseeker","scryfallId":"08b8a222-483c-480d-bbb3-c46922175aaf"},{"index":6363,"token":false,"name":"Wind-Scarred Crag","scryfallId":"75f5875e-487f-4586-95f3-3627050a6744"},{"index":6365,"token":false,"name":"Glass Casket","scryfallId":"562f1c51-d245-4771-bf61-415297e4f9d5"},{"index":6366,"token":false,"name":"Mirrorpool","scryfallId":"edbea2b5-eed3-464b-9d5c-9591f309f298"},{"index":6368,"token":false,"name":"Wings of Hope","scryfallId":"be0d2402-f1ef-4a71-ac01-c7099c4ce54c"},{"index":6369,"token":false,"name":"Funnel-Web Recluse","scryfallId":"b486c9cf-b0a6-44a4-b4c1-b3f5eed6c294"},{"index":6370,"token":false,"name":"Untaidake, the Cloud Keeper","scryfallId":"3c571f66-7a00-4cb0-9da9-8271083f49d3"},{"index":6371,"token":false,"name":"Incendiary Command","scryfallId":"512367a2-f8f6-4c28-9eb3-8e04d2694e4b"},{"index":6375,"token":false,"name":"Timestream Navigator","scryfallId":"14770537-209a-4260-88a4-30f4e2b5ede0"},{"index":6376,"token":false,"name":"Prototype Portal","scryfallId":"e2ccdd3b-9c39-4785-99b9-64b5de1177be"},{"index":6377,"token":false,"name":"Hour of Eternity","scryfallId":"01040ed3-4f64-4e47-8f80-3d3a339004f7"},{"index":6379,"token":false,"name":"Okina Nightwatch","scryfallId":"27975411-1e35-420e-8564-af7f323dfabb"},{"index":6380,"token":false,"name":"Myr Scrapling","scryfallId":"5b9072a5-bd7f-4007-a34a-ebe251c95356"},{"index":6386,"token":false,"name":"Traitorous Instinct","scryfallId":"d4456951-844a-4847-b933-c32cfafbfef0"},{"index":6387,"token":false,"name":"Mindslicer","scryfallId":"895b1c9b-b1a1-457b-92cd-3469a38b69a3"},{"index":6389,"token":false,"name":"Pendulum of Patterns","scryfallId":"7ad452a4-be42-4d2f-a161-2b327f423b9c"},{"index":6390,"token":false,"name":"Elvish Scout","scryfallId":"1faff88d-594e-473c-a2d1-cd60f51b2ee7"},{"index":6393,"token":false,"name":"Gift of Paradise","scryfallId":"d6b4e2b7-2687-4ad1-99e4-0f8411b5f50d"},{"index":6394,"token":false,"name":"Basalt Ravager","scryfallId":"b32aea04-04f7-48a8-a8ab-8b38fa53da3b"},{"index":6396,"token":false,"name":"Sword of the Paruns","scryfallId":"d21d7452-b49e-499e-9cf3-4a883e5e9e57"},{"index":6397,"token":false,"name":"Baton of Courage","scryfallId":"d363970c-2418-42f9-8d13-0e5700161b62"},{"index":6399,"token":false,"name":"Eldrazi Temple","scryfallId":"e9cb2f3d-0ad8-4d5a-a51d-e161ec311b09"},{"index":6400,"token":false,"name":"Dauthi Horror","scryfallId":"c5a8bb3a-3a84-442f-8e31-8af2f04408ab"},{"index":6401,"token":false,"name":"Pillardrop Warden","scryfallId":"7d509f73-cd62-4116-9652-0ed801ed8b36"},{"index":6403,"token":false,"name":"Sonic Seizure","scryfallId":"98eb9371-aa20-4790-baf8-a1ad95de39de"},{"index":6405,"token":false,"name":"Prepare // Fight","scryfallId":"8902590b-8f14-4e5a-a81f-214af73be9a0"},{"index":6406,"token":false,"name":"Military Intelligence","scryfallId":"f10fafb6-3476-4cf1-a762-42fec628a579"},{"index":6408,"token":false,"name":"Ruinous Ultimatum","scryfallId":"9c9a9115-ac31-4515-84e2-13e590028bab"},{"index":6409,"token":false,"name":"Charm Peddler","scryfallId":"082e6ee3-cc1f-46c7-9d82-56751478b3cf"},{"index":6410,"token":false,"name":"Disintegrate","scryfallId":"9ef11af8-3050-4ee7-a287-a53cc9fe38c6"},{"index":6411,"token":false,"name":"Meishin, the Mind Cage","scryfallId":"70efc52b-7852-44c4-9825-d5e1bd796160"},{"index":6416,"token":true,"name":"Spark Elemental Token (R, 3/1)","scryfallId":"b1270173-72fc-489a-beef-85e2d8096bd7"},{"index":6417,"token":false,"name":"Siege Rhino","scryfallId":"fcfb4ea4-2bcc-496b-9d02-6cce1dbb8b1b"},{"index":6418,"token":false,"name":"Displace","scryfallId":"8ab850c5-6f5e-41b7-ab52-094579caca12"},{"index":6421,"token":false,"name":"Captain Vargus Wrath","scryfallId":"0f7502db-947b-49ca-968c-58ee83bd19b3"},{"index":6422,"token":false,"name":"Dragonsguard Elite","scryfallId":"ae495297-a0bb-425e-9f13-0c8dfe3606ec"},{"index":6423,"token":false,"name":"Weight of Memory","scryfallId":"2f2359aa-9230-4519-b12e-ec395a8dd2a0"},{"index":6426,"token":false,"name":"Bloodfire Infusion","scryfallId":"2639e9b7-ed8c-48fd-a8b7-b99d8dad4bc0"},{"index":6428,"token":false,"name":"Sunglasses of Urza","scryfallId":"49fcf47d-0f1d-469e-a8c4-d5c97be7a1ef"},{"index":6429,"token":false,"name":"Cyclopean Tomb","scryfallId":"7c77c7c1-39a5-4049-8e2c-3561b046152e"},{"index":6430,"token":false,"name":"Bone Splinters","scryfallId":"387eda28-f35b-48b0-ba59-773d82902327"},{"index":6431,"token":false,"name":"Yorion, Sky Nomad","scryfallId":"275426c4-c14e-47d0-a9d4-24da7f6f6911"},{"index":6435,"token":false,"name":"Whitemane Lion","scryfallId":"97c98609-b2e5-447f-9b9d-6833584d2998"},{"index":6437,"token":false,"name":"Monstrous Carabid","scryfallId":"b09e668d-02ca-4164-88ee-c7ea6c665975"},{"index":6444,"token":false,"name":"Craterhoof Behemoth","scryfallId":"44afd414-cc69-4888-ba12-7ea87e60b1f7"},{"index":6446,"token":false,"name":"Tower Drake","scryfallId":"5d759d6f-daf0-47f4-8a35-81c9d6437495"},{"index":6448,"token":false,"name":"Cryptwailing","scryfallId":"13337c99-7d9e-4464-905b-87e8deb072ac"},{"index":6450,"token":false,"name":"Silverblade Paladin","scryfallId":"7961bfbc-db89-4ea6-b841-06529a53af40"},{"index":6452,"token":false,"name":"Spell Swindle","scryfallId":"c3ff02c8-d030-407b-bf54-515cbc71a7d5"},{"index":6453,"token":false,"name":"Deceiver of Form","scryfallId":"a416d54b-ac84-48ac-92f8-eeb348f26016"},{"index":6456,"token":false,"name":"Torrent Elemental","scryfallId":"dc4850e4-acb9-458d-952f-b3952cab2a5b"},{"index":6457,"token":false,"name":"Anoint","scryfallId":"ca65ee0f-fdd7-4a5e-a4a3-5dd9c62096ab"},{"index":6458,"token":false,"name":"Eye of Singularity","scryfallId":"fa84e4ad-738a-4d23-a84c-06c39ff4200b"},{"index":6459,"token":false,"name":"Sapseep Forest","scryfallId":"d1e29d9f-6aa9-49ef-8484-54af216aa509"},{"index":6460,"token":false,"name":"House Guildmage","scryfallId":"45ee7bc8-d5cf-47b1-93c2-7e1d5f536c85"},{"index":6461,"token":false,"name":"Animar, Soul of Elements","scryfallId":"46407f28-39f6-43ca-b7aa-da5120215c49"},{"index":6462,"token":false,"name":"Rafiq of the Many","scryfallId":"bd1206d4-ce7d-4504-addc-8182a586087e"},{"index":6464,"token":false,"name":"Ice Storm","scryfallId":"9914836e-2fa6-4390-94b2-431427848a54"},{"index":6465,"token":false,"name":"Ritual of Subdual","scryfallId":"3ca0d060-7bf7-4311-92f4-6cdfef6f85df"},{"index":6467,"token":false,"name":"Skeletal Scrying","scryfallId":"f03c5d53-4b23-47fa-850b-04e82fe173d9"},{"index":6470,"token":false,"name":"Caldera Lake","scryfallId":"f79313f8-0b79-4fe3-8eb1-db523587b714"},{"index":6471,"token":false,"name":"Angelic Edict","scryfallId":"f14ed7f7-83c4-425b-a2b7-5bd76558ce76"},{"index":6473,"token":false,"name":"Chaotic Backlash","scryfallId":"c1f96c71-e585-4c99-b054-e53ab12b392c"},{"index":6475,"token":false,"name":"Wildcall","scryfallId":"af005507-8cba-46d9-9525-4cf9ca7e4d1c"},{"index":6476,"token":false,"name":"Dehydration","scryfallId":"d71dc4af-a026-4e52-9031-cbef4f2ae134"},{"index":6478,"token":false,"name":"Rampage of the Clans","scryfallId":"e768b0f4-ba5f-4d1a-b68a-1274d761de90"},{"index":6482,"token":false,"name":"Commencement of Festivities","scryfallId":"f447b7a1-9950-479a-9115-9c2def2d4fba"},{"index":6484,"token":false,"name":"Krosan Verge","scryfallId":"bae25abc-22c2-436d-9e08-f123543a0911"},{"index":6485,"token":false,"name":"Scholar of Stars","scryfallId":"5fc4498e-24e6-40e9-8cd5-f42220366664"},{"index":6488,"token":false,"name":"Parallel Evolution","scryfallId":"73cce010-a8e7-477b-9179-bbad38aa6438"},{"index":6490,"token":false,"name":"Insight","scryfallId":"1dfd9cb9-51f6-4d09-b5c0-5b0ed9d16542"},{"index":6491,"token":false,"name":"Angel of Glory's Rise","scryfallId":"7a8be765-0949-491c-875c-0385fb83e4b9"},{"index":6493,"token":false,"name":"Dream Halls","scryfallId":"2c6606d1-619f-4cc9-8d5b-771c4b4d9615"},{"index":6494,"token":false,"name":"Mana Seism","scryfallId":"1bde4cba-57b2-485f-9724-0f79d156d664"},{"index":6495,"token":false,"name":"Ghostly Sentinel","scryfallId":"de867066-df5c-4412-9d51-56626b6d0220"},{"index":6496,"token":false,"name":"Fleshgrafter","scryfallId":"01095217-bc33-4d71-bf10-2ead9f8ebd25"},{"index":6497,"token":false,"name":"Ghost of Ramirez DePietro","scryfallId":"e4a41506-85c6-4362-b983-36df13db09d9"},{"index":6498,"token":false,"name":"Make Your Mark","scryfallId":"7e937830-3804-44e8-b9d0-3e5f5cf39eab"},{"index":6499,"token":false,"name":"Gaea's Cradle","scryfallId":"285fe3ac-e53e-47c4-a420-f7560bc62c39"},{"index":6500,"token":false,"name":"Deathgreeter","scryfallId":"561b8539-cb84-42f0-97f2-2c94839777e3"},{"index":6502,"token":false,"name":"Emperor Crocodile","scryfallId":"9ccba208-1e24-45bb-a556-a3eb936efb10"},{"index":6503,"token":false,"name":"Goblin Scouts","scryfallId":"a4b87068-aaa6-41de-9b9a-76ca4210a485"},{"index":6504,"token":false,"name":"Leyline of Combustion","scryfallId":"3da94182-93e8-4df3-8430-a85342c38b95"},{"index":6505,"token":false,"name":"Lost in Thought","scryfallId":"f5fb391a-2687-461d-b5ef-a494287ddb5d"},{"index":6506,"token":false,"name":"Rhox Faithmender","scryfallId":"62498e3c-2e9b-4444-a61c-fae3f8906010"},{"index":6507,"token":false,"name":"Baleful Eidolon","scryfallId":"853a89c6-63f9-4b12-8a5b-2c382e22b226"},{"index":6508,"token":false,"name":"Deadly Tempest","scryfallId":"177cc55d-e00d-4246-9191-1b457f92a935"},{"index":6510,"token":false,"name":"Wilt","scryfallId":"55987bab-c24f-4261-b97e-f0ad4474b0a0"},{"index":6511,"token":false,"name":"Sasaya, Orochi Ascendant // Sasaya's Essence","scryfallId":"d224c50f-8146-4c91-9401-04e5bd306d02"},{"index":6512,"token":false,"name":"Grim Monolith","scryfallId":"0c3bc412-689f-4385-807b-ed60d6276d76"},{"index":6513,"token":false,"name":"Powder Keg","scryfallId":"479c188f-605b-4081-ba43-c163cd8f7997"},{"index":6514,"token":false,"name":"Cauldron Familiar","scryfallId":"32cf273e-b8f7-434b-9d5d-883dfd6f7423"},{"index":6515,"token":false,"name":"Omnispell Adept","scryfallId":"e17664df-e8ba-464d-b338-3e671d2d7f0e"},{"index":6516,"token":false,"name":"Dragon Egg","scryfallId":"4cdad3f3-7009-4b8b-9105-263b454217c8"},{"index":6517,"token":true,"name":"Pirate // Treasure","scryfallId":"46bf5e2b-869f-480e-ac37-1bdb40a92f8c"},{"index":6519,"token":false,"name":"Barkchannel Pathway // Tidechannel Pathway","scryfallId":"87c33c94-4b56-4a96-9c4c-a376f8d54943"},{"index":6521,"token":false,"name":"Young Pyromancer","scryfallId":"9c1f44d0-7fb2-40f5-93a9-1a465372dd82"},{"index":6522,"token":false,"name":"Mob","scryfallId":"3c216e13-3779-4734-b481-9aad7aba9925"},{"index":6523,"token":false,"name":"Mana Geyser","scryfallId":"32cd847e-a247-4f6e-95ea-316e7535e6fb"},{"index":6524,"token":true,"name":"Horror Token (Colorless, */*)","scryfallId":"7db68985-a1d5-4bd5-bfc6-c7208689d7df"},{"index":6525,"token":false,"name":"Linessa, Zephyr Mage","scryfallId":"799538af-e497-457b-b096-ee6f342f51b5"},{"index":6526,"token":false,"name":"Kabira Outrider","scryfallId":"53c81719-f820-4674-9cfb-cd5eaf0c1f0d"},{"index":6527,"token":false,"name":"Esper Stormblade","scryfallId":"e60ac6f0-fdec-4e2c-86c6-02d36c7bbaf5"},{"index":6529,"token":false,"name":"Carnifex Demon","scryfallId":"0d02db50-315a-4b15-b9bd-7feb20e3bae0"},{"index":6531,"token":false,"name":"Phantasmal Image","scryfallId":"98e7bf8f-dba7-4005-8cee-634c9153931d"},{"index":6533,"token":false,"name":"Gaea's Will","scryfallId":"488996b2-06c8-4866-bf0d-4664640c2be1"},{"index":6537,"token":false,"name":"Thunderscape Master","scryfallId":"22abdc2f-bdc8-46c4-8ce2-f06befedbc32"},{"index":6539,"token":false,"name":"Swift Kick","scryfallId":"bcc38a68-e696-4a1d-9c63-6bdaba0efd54"},{"index":6540,"token":false,"name":"Hornet Nest","scryfallId":"8846a7d6-1fea-4fd6-bf2b-90d38651538b"},{"index":6543,"token":false,"name":"Twilight's Call","scryfallId":"3c97c8a5-33b3-4f7f-a224-bb4df7b4bcc0"},{"index":6545,"token":false,"name":"Promising Duskmage","scryfallId":"2ea0dff9-71c3-4d56-aa7b-e0fb9938529a"},{"index":6546,"token":false,"name":"Cleansing Nova","scryfallId":"388703ff-16c5-46a6-bb05-a9c60ed6f06f"},{"index":6548,"token":false,"name":"Clickslither","scryfallId":"db203977-87e0-4736-9725-8a0229f2f6dd"},{"index":6552,"token":false,"name":"Maverick Thopterist","scryfallId":"e2718058-16d5-49cb-8b05-b7a39ce7aa62"},{"index":6554,"token":false,"name":"Mazemind Tome","scryfallId":"6a9833f2-6f97-4b0f-97fa-6b24ab05fa50"},{"index":6555,"token":false,"name":"Resurrection","scryfallId":"a176b295-9406-4d6b-b15c-e81a72e66874"},{"index":6556,"token":false,"name":"Wolfhunter's Quiver","scryfallId":"d84c9b19-9b4d-4a60-984f-636b749c8bcc"},{"index":6557,"token":false,"name":"Mogg War Marshal","scryfallId":"e6da34e4-3ad6-40a2-be7f-0b2cb6fa2be7"},{"index":6558,"token":false,"name":"Phantasmal Dreadmaw","scryfallId":"c2484b24-ca5e-421d-8dbf-41df7094c8a8"},{"index":6559,"token":false,"name":"Omen of the Dead","scryfallId":"8023fc44-fb8e-420d-a68c-b45912c4e5bd"},{"index":6561,"token":false,"name":"Haktos the Unscarred","scryfallId":"1ca9a1f1-4921-4294-bb09-05ff635fb460"},{"index":6563,"token":false,"name":"Concordia Pegasus","scryfallId":"55f32ff8-3b49-4ce8-96a0-ba0d99477de1"},{"index":6564,"token":false,"name":"Elite Archers","scryfallId":"b2341478-2a91-4ce8-881a-21e826b55c34"},{"index":6565,"token":false,"name":"Wildfire","scryfallId":"826fd527-9356-4eec-8542-781116f23eb7"},{"index":6566,"token":false,"name":"Not of This World","scryfallId":"569e2c39-7a49-4a3b-afe5-1862a7da8026"},{"index":6567,"token":false,"name":"Genesis","scryfallId":"2640ff4e-c022-46ed-a4d2-a4bae6a43f05"},{"index":6569,"token":false,"name":"Hero of Iroas","scryfallId":"7917f2ee-f093-4ffb-83ed-a181b14b5957"},{"index":6570,"token":false,"name":"Crowd's Favor","scryfallId":"536b8104-9d8d-444b-8535-62bcbe279de2"},{"index":6572,"token":false,"name":"Meandering River","scryfallId":"88fd9890-131e-47dd-8d57-23ff12776336"},{"index":6574,"token":false,"name":"Retraction Helix","scryfallId":"4fe8c0b9-fdf4-4fc0-aa7c-774546cdd792"},{"index":6575,"token":false,"name":"Scorch Spitter","scryfallId":"bb701a84-24bd-41ed-9f06-25c8338902a5"},{"index":6576,"token":false,"name":"Cunning Wish","scryfallId":"335358c5-1909-4290-ad44-e590c0b10fb0"},{"index":6577,"token":false,"name":"Trip Wire","scryfallId":"6ba99278-0a8f-4cee-8a50-dfac97996106"},{"index":6578,"token":false,"name":"Oreskos Swiftclaw","scryfallId":"0ea1dfb4-1983-41f7-956c-f2a1d1489b54"},{"index":6580,"token":false,"name":"Regrowth","scryfallId":"898cd314-9060-4f1c-a821-1d61a292a12b"},{"index":6581,"token":false,"name":"Bloodline Keeper // Lord of Lineage","scryfallId":"13896468-e3d0-4bcb-b09e-b5c187aecb03"},{"index":6582,"token":false,"name":"Jagged Lightning","scryfallId":"49304f24-a961-4d1e-b85c-af6e3d8d5edc"},{"index":6583,"token":false,"name":"Hour of Reckoning","scryfallId":"4854af5b-1771-4f1c-93e0-d107db28d97c"},{"index":6586,"token":false,"name":"Thelon of Havenwood","scryfallId":"783f1b9f-9866-4ead-96cf-88babf459ce2"},{"index":6587,"token":false,"name":"Grave Peril","scryfallId":"2c216ff3-26e1-43bc-beb5-65fc7fd1b6db"},{"index":6589,"token":false,"name":"Glistening Oil","scryfallId":"483e99fd-7e48-400d-9817-451089089e0c"},{"index":6591,"token":false,"name":"Caribou Range","scryfallId":"1e5f8041-67fc-4e00-b119-d216e5cc5a3a"},{"index":6595,"token":false,"name":"Dauthi Mercenary","scryfallId":"c340e779-c648-48fd-a159-174b46f2d1b3"},{"index":6599,"token":false,"name":"Meng Huo, Barbarian King","scryfallId":"e340647c-fb6d-45a6-9f42-235390b40337"},{"index":6601,"token":false,"name":"Living Wall","scryfallId":"10fcbf64-9c5a-4dbd-93ea-9e3105a7aeef"},{"index":6604,"token":false,"name":"Metallic Sliver","scryfallId":"0f302984-9bf6-4583-865a-5545711e7a27"},{"index":6605,"token":false,"name":"Precinct Captain","scryfallId":"fef6faa4-520c-4823-bfdf-715cec7fcd4b"},{"index":6607,"token":false,"name":"Whiptail Wurm","scryfallId":"a1e76072-e76d-485e-b94c-c29849bc8a6f"},{"index":6608,"token":false,"name":"Wake the Past","scryfallId":"f19e64de-d7bc-46d6-a58c-97701f159e1d"},{"index":6609,"token":false,"name":"Gift of the Deity","scryfallId":"ee2dba5c-2f00-4a44-9093-3b845a8bf552"},{"index":6610,"token":false,"name":"Mortuary Mire","scryfallId":"c5b2faa7-1fdc-4c9a-a5ee-4b6c90f18acb"},{"index":6613,"token":false,"name":"Gauntlet of Might","scryfallId":"63c0e240-07b0-45fb-90af-f4fce18c604e"},{"index":6614,"token":false,"name":"Mizzium Tank","scryfallId":"159b094b-28c9-4b90-b3ae-4d538ff2fa48"},{"index":6615,"token":false,"name":"Zephyr Charge","scryfallId":"f9ea2808-0dde-4065-ae7d-905aae98703f"},{"index":6616,"token":false,"name":"Anathemancer","scryfallId":"ab106855-bd85-4c00-b596-c46d34f8cdd0"},{"index":6617,"token":false,"name":"Ironclaw Orcs","scryfallId":"0e17623a-5bc0-42d7-a842-394de0a01a01"},{"index":6619,"token":false,"name":"Final Reward","scryfallId":"8f202f6b-710f-4376-a49c-e5f135b26eaf"},{"index":6620,"token":false,"name":"Ancient Ziggurat","scryfallId":"0348247d-0a70-4961-8590-9de41386c69b"},{"index":6623,"token":false,"name":"Anje Falkenrath","scryfallId":"64f1bc91-a96a-4472-ba19-e58582dfa662"},{"index":6624,"token":false,"name":"Mask of Memory","scryfallId":"512f8021-aaf3-4b1c-b08c-fe667ce2d8e1"},{"index":6625,"token":false,"name":"Ritual of Soot","scryfallId":"dfffaef0-a12c-4c52-9b89-7c5cdeb134ae"},{"index":6626,"token":false,"name":"Urborg Emissary","scryfallId":"74b8a44c-dc1f-4ea9-ad83-a301e623e8fc"},{"index":6627,"token":false,"name":"Lash Out","scryfallId":"80a67ccc-eeae-4914-a807-d4a8bb81c85f"},{"index":6628,"token":false,"name":"Omnath, Locus of Creation","scryfallId":"9b5bc5d7-c0f8-4632-adb7-dd3b75a3d87d"},{"index":6629,"token":false,"name":"Glacial Wall","scryfallId":"c059330e-1aef-4d22-b3c2-cd84cab5fe38"},{"index":6631,"token":false,"name":"Vampire Charmseeker","scryfallId":"d26a4969-410c-4402-889e-d3623e1cb57c"},{"index":6634,"token":false,"name":"Glen Elendra Pranksters","scryfallId":"2a71800f-3e67-4cfb-a3b1-8c073a91b909"},{"index":6635,"token":false,"name":"Green Sun's Zenith","scryfallId":"9781b0d5-2ea0-49ed-ba8a-f61dbed840e0"},{"index":6636,"token":false,"name":"Kolaghan Monument","scryfallId":"3efb210e-00a9-470e-ac30-4036a7befd4c"},{"index":6637,"token":false,"name":"Ley Weaver","scryfallId":"64fad61c-4bca-4d61-a59c-7d752bc373fa"},{"index":6638,"token":false,"name":"Deputy of Detention","scryfallId":"7e362055-78a1-48fa-a4ef-6cf7e0b21b14"},{"index":6640,"token":false,"name":"Despark","scryfallId":"b4d8275d-957c-41d2-a54c-fcb3842b5fe7"},{"index":6641,"token":false,"name":"Agent of Horizons","scryfallId":"cc08576f-1d48-4db4-9bb9-e039f75c98b8"},{"index":6642,"token":false,"name":"Amphin Cutthroat","scryfallId":"fd169064-9c7b-40bd-8be0-a89fcb28ae2f"},{"index":6644,"token":false,"name":"Markov Blademaster","scryfallId":"122163dd-e070-48af-8036-e9850541d138"},{"index":6645,"token":false,"name":"Increasing Vengeance","scryfallId":"d4867546-a609-4958-a48e-522fb9258faf"},{"index":6646,"token":false,"name":"Barl's Cage","scryfallId":"913d734e-8788-42fd-849f-ac46b40ffa10"},{"index":6647,"token":false,"name":"Council of Advisors","scryfallId":"0c59f45b-46fa-4494-9b25-cf9d3e462539"},{"index":6653,"token":false,"name":"Dark Sphere","scryfallId":"72cfe9b9-677d-4ecb-83ab-67fb6481371d"},{"index":6654,"token":false,"name":"Rescuer Sphinx","scryfallId":"00ba9fa2-bfd2-4dc7-b96d-d22a8886a6ae"},{"index":6656,"token":false,"name":"Sharding Sphinx","scryfallId":"7367a533-0555-4b5d-b07d-aa58d37894dd"},{"index":6657,"token":false,"name":"Resolute Strike","scryfallId":"78b82476-4320-4719-9785-af8d68503234"},{"index":6658,"token":false,"name":"Cragplate Baloth","scryfallId":"38dfa693-2cea-4722-8b12-fbc2f2fd8081"},{"index":6663,"token":false,"name":"Sky Theater Strix","scryfallId":"98902dd9-f21c-4419-8205-4b9d6592bf28"},{"index":6664,"token":false,"name":"Winding Constrictor","scryfallId":"eb4de39a-2c60-4f9d-bd72-a395c391f92c"},{"index":6666,"token":false,"name":"Deepfathom Skulker","scryfallId":"496a22cc-36dd-4d4d-b887-8c4733a29870"},{"index":6667,"token":false,"name":"Misdirection","scryfallId":"a494b6df-a144-49a3-a204-2b3dfbe9873b"},{"index":6668,"token":false,"name":"Gaea's Liege","scryfallId":"ac600faf-ac84-40b8-99be-8e49291e290c"},{"index":6669,"token":false,"name":"Cinder Marsh","scryfallId":"9fee067d-c31f-4b09-99f5-84d1102f96b0"},{"index":6670,"token":false,"name":"Chain of Silence","scryfallId":"9a60ac8e-11eb-433f-86f9-8e593b38c617"},{"index":6671,"token":false,"name":"Opal Avenger","scryfallId":"f9337bbe-e092-469d-8122-77f92e233306"},{"index":6672,"token":false,"name":"Nessian Game Warden","scryfallId":"5099d18d-c8b5-4706-bc93-40d1bb12988d"},{"index":6674,"token":false,"name":"Immerwolf","scryfallId":"9326061f-ea76-4be7-a06f-aefb63454777"},{"index":6676,"token":false,"name":"Blightcaster","scryfallId":"b8986163-6362-4c70-8ece-22ae22da5031"},{"index":6678,"token":false,"name":"Depala, Pilot Exemplar","scryfallId":"0b490955-14cf-4796-b699-d430e34d960a"},{"index":6679,"token":false,"name":"Renewing Touch","scryfallId":"6b038fbf-d8cc-48c2-a2b6-893c4b5c5f05"},{"index":6680,"token":false,"name":"Mina and Denn, Wildborn","scryfallId":"d27ff523-0ff3-480d-ae95-ff5e04483e40"},{"index":6683,"token":false,"name":"Fae of Wishes // Granted","scryfallId":"822ec13d-031f-4ec7-806d-27271618153f"},{"index":6685,"token":false,"name":"Raugrin Triome","scryfallId":"c303a627-cce3-4045-81f8-fe7427e0a941"},{"index":6687,"token":false,"name":"Screamreach Brawler","scryfallId":"47fe9cb3-c513-442c-b24e-13606ed9e46c"},{"index":6689,"token":false,"name":"Magmatic Core","scryfallId":"98db70f9-1feb-4932-97be-02db824eda70"},{"index":6690,"token":false,"name":"Archmage Emeritus","scryfallId":"761df6cd-0928-4167-8902-58fdb50181a0"},{"index":6693,"token":false,"name":"Goblin Artisans","scryfallId":"f6cf2517-a7fa-4444-bfa7-abe5941c50bb"},{"index":6694,"token":false,"name":"Mana Bloom","scryfallId":"d7592d88-64e8-4a31-b00a-f65d4b1867fc"},{"index":6696,"token":false,"name":"Knight of Cliffhaven","scryfallId":"9a1c3f32-9add-455d-bb7f-b31c430c6590"},{"index":6698,"token":false,"name":"Bounteous Kirin","scryfallId":"1d7fe65e-81b1-4e69-913a-25fc99d96d81"},{"index":6700,"token":false,"name":"Vivid Crag","scryfallId":"ed2564b4-0fa2-49cc-b571-0a997fc73c56"},{"index":6701,"token":false,"name":"Liliana's Specter","scryfallId":"70539f2d-b211-43b9-8dcc-53cac50a53b5"},{"index":6702,"token":false,"name":"Invocation of Saint Traft","scryfallId":"5efcbd08-708f-4a4d-ab1a-b0cb81f451e8"},{"index":6703,"token":false,"name":"Gold Myr","scryfallId":"fe0b7ec4-1297-4544-8c4a-52edc85c8aca"},{"index":6704,"token":false,"name":"Rain of Tears","scryfallId":"803ba4ef-24ed-4f45-aed8-f9442322e31e"},{"index":6709,"token":false,"name":"Whirlpool Rider","scryfallId":"0de47f44-8c5e-4114-9064-145d2d8813c6"},{"index":6711,"token":false,"name":"Baton of Morale","scryfallId":"8bc29872-b1a2-4851-9eca-f3e67ae6e14c"},{"index":6712,"token":false,"name":"Esper Sentinel","scryfallId":"676758ee-dac8-4c97-8a62-fff25bcbb6df"},{"index":6713,"token":false,"name":"Bloodbraid Elf","scryfallId":"33abc681-b82c-41fe-980a-f0ead136e28f"},{"index":6714,"token":false,"name":"Champion of Wits","scryfallId":"14126767-4ab6-496a-80ca-7ee77e3e0897"},{"index":6715,"token":false,"name":"Sun Sentinel","scryfallId":"5cd0b4d6-9753-46a3-924c-2adf3dad2819"},{"index":6716,"token":false,"name":"Raging Kavu","scryfallId":"27573679-e9e5-4bfc-b5d5-85d4648b01b6"},{"index":6718,"token":false,"name":"Rabid Bite","scryfallId":"bbe53385-d63f-4d07-94ed-3ea5a48c79c8"},{"index":6720,"token":false,"name":"Unleash Fury","scryfallId":"e854e6a3-8684-43fa-9560-ef4c3b62c935"},{"index":6721,"token":false,"name":"Rosethorn Acolyte // Seasonal Ritual","scryfallId":"2a0d430f-da84-4752-940c-8457c525aac9"},{"index":6722,"token":false,"name":"Batterskull","scryfallId":"674a54bc-d283-4852-9b3a-71587874e628"},{"index":6725,"token":false,"name":"Shadow Lance","scryfallId":"02b5590f-d964-49cb-8e2e-94b067112c8e"},{"index":6726,"token":false,"name":"Aysen Highway","scryfallId":"adfa87eb-9a11-459c-bff8-87bb09b61b87"},{"index":6727,"token":false,"name":"Riverglide Pathway // Lavaglide Pathway","scryfallId":"2668ac91-6cda-4f81-a08d-4fc5f9cb35b2"},{"index":6728,"token":false,"name":"Meandering Towershell","scryfallId":"a637fbe8-a2c3-4477-9da2-c3b0bebc892d"},{"index":6729,"token":false,"name":"Urborg, Tomb of Yawgmoth","scryfallId":"5295d06d-97c5-4e10-8723-a62dfd9f0425"},{"index":6731,"token":false,"name":"Lurking Predators","scryfallId":"e864c824-89a1-41f6-9481-83b2284471e0"},{"index":6732,"token":false,"name":"Arcbound Reclaimer","scryfallId":"3e4c5228-1dff-4df0-9d14-f8103364c701"},{"index":6735,"token":false,"name":"Charge","scryfallId":"8b46269c-35d3-4f8f-8fef-f58cf8be4054"},{"index":6738,"token":false,"name":"Setessan Starbreaker","scryfallId":"03af8b3b-a897-43e2-a87d-833da93edc41"},{"index":6739,"token":false,"name":"Ghostly Changeling","scryfallId":"7d9f1fda-8a94-48fe-9682-5b2fdbc31bad"},{"index":6740,"token":false,"name":"Dragon Bell Monk","scryfallId":"5a4db84d-8aa2-4cb0-a30f-5f1abd2136b5"},{"index":6742,"token":false,"name":"Diabolic Servitude","scryfallId":"0a616616-8fbb-4e89-ae29-61d31cf49f65"},{"index":6745,"token":false,"name":"Split-Tail Miko","scryfallId":"0528fe29-f3c1-4d10-9030-053c3de57b7b"},{"index":6746,"token":false,"name":"Slippery Karst","scryfallId":"7c173bb1-a177-407e-a94b-73fea1f8195a"},{"index":6747,"token":false,"name":"Call of the Herd","scryfallId":"e390251b-86d2-444e-bdaa-2502feff1e84"},{"index":6748,"token":true,"name":"Acorn Stash","scryfallId":"e8fb396f-3ae1-4705-bf94-3e1b0556e910"},{"index":6749,"token":false,"name":"Soldier of the Pantheon","scryfallId":"5cfc0f46-4df4-4ae3-bfe6-391916eb590f"},{"index":6750,"token":false,"name":"Erebos, Bleak-Hearted","scryfallId":"e340df19-b89a-403f-9736-4bd30b65de74"},{"index":6753,"token":false,"name":"Shriekgeist","scryfallId":"424b08b1-d9a3-4f18-a5ef-0f46698ac7ed"},{"index":6754,"token":false,"name":"Wall of Blood","scryfallId":"17320043-f81c-4e14-b9ba-c1309972c22b"},{"index":6755,"token":false,"name":"Volcanic Salvo","scryfallId":"393b60c7-600a-4bbf-a888-05efe56b7de8"},{"index":6757,"token":false,"name":"Ruination","scryfallId":"6330d925-96a8-47e1-855d-035ddc2af709"},{"index":6758,"token":false,"name":"Skeleton Ship","scryfallId":"271c8a7c-0f71-4f9d-ab0e-ca7c8c4aca50"},{"index":6759,"token":false,"name":"Dolmen Gate","scryfallId":"a6502dc2-8d8a-4057-89e3-98a7fda87346"},{"index":6761,"token":false,"name":"Disrupting Scepter","scryfallId":"1129d16c-de2b-4d21-a0fd-b63e4ba95d8d"},{"index":6762,"token":false,"name":"Skull Raid","scryfallId":"4589c520-4db3-47bf-bfb2-5d7e02ede4bf"},{"index":6763,"token":false,"name":"Wretched Anurid","scryfallId":"aab525ad-1f62-4d9c-9b74-c7b0048da452"},{"index":6766,"token":false,"name":"Ostracize","scryfallId":"abdaffcc-59f6-4489-88bf-1061ad6b0512"},{"index":6768,"token":false,"name":"Battle Hurda","scryfallId":"2f540b83-67fd-4630-a461-69bc84b88ed3"},{"index":6772,"token":false,"name":"Cunning","scryfallId":"52f36bb8-5a97-4596-8ca3-707665770c76"},{"index":6773,"token":false,"name":"Dead Weight","scryfallId":"f09a09de-35c9-4a4e-a4ac-1ce24e166ad9"},{"index":6776,"token":false,"name":"Messenger Drake","scryfallId":"13dd3172-0b45-4dc8-adc6-9e0ba112e664"},{"index":6777,"token":false,"name":"Rogue Kavu","scryfallId":"61e1a445-129d-4bb9-a8b0-3f55e3e0bc58"},{"index":6778,"token":false,"name":"Bloated Toad","scryfallId":"9686f1a8-035e-415e-9a06-933d6ce1cd5c"},{"index":6782,"token":false,"name":"Emeria Angel","scryfallId":"491c6b65-244e-4146-9fbc-6eb00e78e1b7"},{"index":6783,"token":false,"name":"Wanderlust","scryfallId":"077cdb3f-b70f-4310-bc5d-47a0ee35c701"},{"index":6785,"token":false,"name":"Goblin Trailblazer","scryfallId":"ca382425-2454-4300-b903-fdefd31582d3"},{"index":6787,"token":true,"name":"Dreamstealer Token (B, 4/4)","scryfallId":"8c362d05-f2f7-4415-8937-f9f368986e61"},{"index":6789,"token":false,"name":"Highland Weald","scryfallId":"38bcd111-0830-4fc0-a113-37eb306fb1a0"},{"index":6790,"token":true,"name":"Soldier // Soldier Token (R/W, 1/1)","scryfallId":"887efa4e-f713-4165-a7e1-b0f00ac81784"},{"index":6791,"token":false,"name":"Merfolk Falconer","scryfallId":"acb0d55a-9d6a-443d-aa82-5cea93188fd2"},{"index":6793,"token":false,"name":"Mobile Fort","scryfallId":"5f642246-5b2a-46a6-9236-524a297d7608"},{"index":6794,"token":false,"name":"Reap What Is Sown","scryfallId":"120babed-841f-4bf1-ac2d-3ab097c0760b"},{"index":6795,"token":false,"name":"Mizzium Transreliquat","scryfallId":"d29c3bf9-d37c-4e0a-ac44-15d47770ed44"},{"index":6796,"token":false,"name":"Ceremonious Rejection","scryfallId":"08c5ed8e-4804-4042-8a1d-ad24c6846816"},{"index":6797,"token":false,"name":"Crumbling Necropolis","scryfallId":"80b0c087-4642-4297-aa1c-27d17fb879b9"},{"index":6798,"token":false,"name":"Torbran, Thane of Red Fell","scryfallId":"24b63513-5e53-4357-8b28-cb91790e9a72"},{"index":6799,"token":false,"name":"Myr Servitor","scryfallId":"d53712a0-e11d-4b83-aebc-8e97244f085b"},{"index":6800,"token":false,"name":"Brilliant Spectrum","scryfallId":"b9a05765-b33e-42a8-a186-eaaefcfc2326"},{"index":6801,"token":false,"name":"Pitiless Gorgon","scryfallId":"c1a925a0-9d26-441b-8b4a-0614a0485fe6"},{"index":6802,"token":false,"name":"Suffocating Blast","scryfallId":"c2a70297-2a7b-4a0c-ace5-cd61bfe6dafd"},{"index":6803,"token":false,"name":"Goblin Lackey","scryfallId":"9b848caa-aad8-4060-8f86-304a8556de2d"},{"index":6804,"token":false,"name":"Anarchy","scryfallId":"7f5dfbff-683e-4444-a50b-54f7266f6892"},{"index":6807,"token":false,"name":"Fatal Frenzy","scryfallId":"4e2fe87d-e886-4e30-8ff2-3886199f0461"},{"index":6809,"token":false,"name":"Tanazir Quandrix","scryfallId":"a5c7241c-c053-440b-b91c-f7298080d626"},{"index":6812,"token":false,"name":"Tormod's Crypt","scryfallId":"efdfb60b-948b-40fb-b18e-08f0300624b3"},{"index":6813,"token":false,"name":"Squirrel Nest","scryfallId":"6914d43c-bc5a-47c5-a01c-59ddb1ee8eca"},{"index":6814,"token":false,"name":"Faith of the Devoted","scryfallId":"3171e131-349a-4109-9da0-9bfaba785b14"},{"index":6815,"token":false,"name":"Bottle Golems","scryfallId":"513a36a1-b2e3-4779-b8a7-66f01c488bf0"},{"index":6816,"token":false,"name":"Hostile Desert","scryfallId":"082f35df-2b3b-4a99-9666-30531d98eec7"},{"index":6817,"token":false,"name":"Unlikely Aid","scryfallId":"9c260c5c-e796-4f81-9e15-0c5be75106b9"},{"index":6818,"token":false,"name":"Verdant Touch","scryfallId":"c19849f9-cb47-42c9-aaf8-e2e90e157f6e"},{"index":6819,"token":false,"name":"Yawning Fissure","scryfallId":"fa364a1c-14e4-4dda-aa1f-edb879a64a2d"},{"index":6820,"token":false,"name":"Leapfrog","scryfallId":"2e415a03-f7f8-4fca-954a-ef21b4a2c60f"},{"index":6821,"token":false,"name":"Growing Ranks","scryfallId":"b34a80a7-65f1-412e-8f28-2384cd8b006a"},{"index":6826,"token":false,"name":"One with the Machine","scryfallId":"01719820-28d3-4f3a-bc5a-69c471378a43"},{"index":6827,"token":false,"name":"Temporary Truce","scryfallId":"5f6ee294-7dbb-4872-81d1-c69c7337cf9f"},{"index":6828,"token":true,"name":"Djinn Monk Token (U, 2/2)","scryfallId":"12b5e32a-b86b-4f8b-ae93-19f0b95c4514"},{"index":6829,"token":false,"name":"Knowledge Pool","scryfallId":"d3e684c1-7718-4f00-a787-a692c148f0ff"},{"index":6830,"token":false,"name":"Keldon Overseer","scryfallId":"350513cc-2bbe-4eb3-986e-bbd957512a49"},{"index":6833,"token":false,"name":"Kirtar's Desire","scryfallId":"7f1e36fe-ecbe-46aa-9ee8-2ba4daba7d31"},{"index":6836,"token":false,"name":"Colossal Plow","scryfallId":"fba3fe29-067f-4c7e-8b3b-779f3b37712a"},{"index":6837,"token":false,"name":"Slaughter","scryfallId":"8ff06c7d-5e78-4bcf-864b-34487f6555b2"},{"index":6838,"token":false,"name":"Frazzle","scryfallId":"68b7f705-4d64-4551-8d76-826d91324e9e"},{"index":6839,"token":false,"name":"Daily Regimen","scryfallId":"45d83dae-747b-4acf-adfd-7822dd64cfcc"},{"index":6840,"token":false,"name":"Mikokoro, Center of the Sea","scryfallId":"7ef72797-328e-4303-8ffb-9686086648b8"},{"index":6841,"token":false,"name":"Keeper of the Lens","scryfallId":"86d6c502-ae3e-4e67-8f1d-3323b4468f72"},{"index":6843,"token":false,"name":"Disentomb","scryfallId":"ce7473bb-d092-4d76-b3c3-5036222dbdf7"},{"index":6844,"token":false,"name":"Lucille","scryfallId":"d92f06af-47bd-4ede-a174-21be69387c1b"},{"index":6846,"token":false,"name":"Temple of Triumph","scryfallId":"c0516f04-127a-44de-8d49-e40d3fe192e3"},{"index":6847,"token":false,"name":"Satyr Wayfinder","scryfallId":"ff3d4e53-3b46-4258-8403-98552d57c5ca"},{"index":6848,"token":false,"name":"Spiketail Drake","scryfallId":"4db398ca-6b0b-4225-baaa-c4b1c243b2bd"},{"index":6851,"token":false,"name":"Wavebreak Hippocamp","scryfallId":"543356bc-d4ab-4250-80c8-5ca69c11af87"},{"index":6852,"token":false,"name":"Gisa and Geralf","scryfallId":"09b76448-08db-44ea-ab65-0812e1d1e73c"},{"index":6853,"token":false,"name":"Rushing River","scryfallId":"52ddf7bf-de9c-4657-8d5b-79869d36fa63"},{"index":6855,"token":false,"name":"Sanctum Spirit","scryfallId":"aa4795dd-75d4-4ce5-87e7-fe892616e42e"},{"index":6856,"token":false,"name":"Last Chance","scryfallId":"264bddc6-51ac-4958-8466-21aded92c66e"},{"index":6858,"token":false,"name":"Tiger Claws","scryfallId":"0146a689-4817-4849-a90d-4cc64566960d"},{"index":6859,"token":false,"name":"Dusk // Dawn","scryfallId":"d3c99f65-2355-444b-b49a-c6b916f268b1"},{"index":6860,"token":true,"name":"Shapeshifter Token (Colorless, 1/1)","scryfallId":"798cef87-237b-4e4a-b7ed-78d15c720391"},{"index":6861,"token":false,"name":"Savage Punch","scryfallId":"3ab7f94b-6fb1-4be8-8498-7d9522a6d4ee"},{"index":6864,"token":false,"name":"Ghostway","scryfallId":"8b83d750-16d9-41e4-b823-3295c5f6b319"},{"index":6865,"token":false,"name":"Loyal Subordinate","scryfallId":"3d62f207-a10e-4908-97ae-fb2377208fb1"},{"index":6868,"token":false,"name":"Engineered Explosives","scryfallId":"420bf1e9-f2ec-4dff-b540-e64de71e58be"},{"index":6869,"token":false,"name":"Faith's Fetters","scryfallId":"af68753a-9507-4fc8-b981-78ebcdabec6d"},{"index":6870,"token":false,"name":"Tidings","scryfallId":"7fcb93dc-503e-45fa-99da-1597a8a0ab4e"},{"index":6871,"token":false,"name":"Cloudfin Raptor","scryfallId":"67e126ac-6a47-4b6e-ac68-8d0acbd9cc9a"},{"index":6873,"token":false,"name":"Voice of the Woods","scryfallId":"1ebb4668-eebf-4b7e-ae29-75fff5963868"},{"index":6874,"token":false,"name":"Juzám Djinn","scryfallId":"b03bc922-782b-4254-897c-90d202b4cda4"},{"index":6876,"token":false,"name":"Kytheon, Hero of Akros // Gideon, Battle-Forged","scryfallId":"3c52157c-aafa-4d6d-8d2d-3a471e6ee10c"},{"index":6877,"token":false,"name":"Chandra, Heart of Fire","scryfallId":"1e494793-ec53-46dc-a5db-90dadc8cc015"},{"index":6878,"token":false,"name":"Viridian Shaman","scryfallId":"21971049-f988-40ec-b5ae-0ac0575f1939"},{"index":6879,"token":false,"name":"General Tazri","scryfallId":"34e9aa86-1a31-4c0f-928d-923f066286b6"},{"index":6880,"token":false,"name":"Pillarfield Ox","scryfallId":"d70a8ff1-f0cf-4aef-ad90-06902f98d434"},{"index":6881,"token":false,"name":"Psychic Puppetry","scryfallId":"9e341d6b-f4b0-4347-8055-f5fab756334c"},{"index":6882,"token":false,"name":"Isolated Chapel","scryfallId":"4e1ad9b1-f59c-4990-a43f-1a705f09bae7"},{"index":6883,"token":false,"name":"Pegasus Courser","scryfallId":"cca2ad42-884f-4898-a643-5abff536e946"},{"index":6884,"token":false,"name":"Merciless Eviction","scryfallId":"d9876a4c-714b-47e5-9589-148a623af96a"},{"index":6885,"token":false,"name":"Scavenging Ooze","scryfallId":"ae57dc27-539b-45f2-a18a-ca1f699f645d"},{"index":6886,"token":false,"name":"Mind Rake","scryfallId":"682ccb0a-5e73-462e-a035-87d4dac59779"},{"index":6887,"token":false,"name":"Insidious Bookworms","scryfallId":"7a043cc2-1bd4-4b44-ba23-d2585ffc3841"},{"index":6891,"token":false,"name":"Imperial Seal","scryfallId":"5ab21006-7f61-49e0-8b6a-0397c5d4c3bd"},{"index":6892,"token":false,"name":"Keldon Vandals","scryfallId":"4fc5c47f-12bb-4eed-8db3-1558495eb2ca"},{"index":6893,"token":false,"name":"Merfolk of the Pearl Trident","scryfallId":"3c3e6ac4-8ee4-4802-bd86-5480222aba57"},{"index":6894,"token":false,"name":"Green Mana Battery","scryfallId":"d0a6e224-72df-4f1f-93d1-5114779aed2c"},{"index":6896,"token":false,"name":"Mole Worms","scryfallId":"4914f6fc-e3e7-426b-8688-12157c7df9e7"},{"index":6897,"token":false,"name":"Deflecting Swat","scryfallId":"84f035e1-6c89-457b-b05f-85680a50ed91"},{"index":6899,"token":false,"name":"Thunderous Wrath","scryfallId":"804458a2-5376-462d-a2cd-fa596750c0aa"},{"index":6900,"token":false,"name":"Purple-Crystal Crab","scryfallId":"e26c576d-94c8-4f63-9f54-732fb1eade12"},{"index":6901,"token":false,"name":"Sphinx of Foresight","scryfallId":"b8edd796-34c4-4d3b-a5a8-3417af96b3b0"},{"index":6902,"token":false,"name":"Darksteel Relic","scryfallId":"0fd8c918-62d9-41be-a3e1-32ddac71b7e7"},{"index":6903,"token":false,"name":"Gustcloak Harrier","scryfallId":"a7735aaf-192f-4a28-81e2-330133a56058"},{"index":6904,"token":false,"name":"Thran Turbine","scryfallId":"791c310f-b50d-4993-9add-9f585f6172af"},{"index":6906,"token":false,"name":"Abzan Charm","scryfallId":"c13fbd5d-6ebe-4f7f-a2fb-2d1af4beea6f"},{"index":6910,"token":false,"name":"Gempalm Avenger","scryfallId":"dbc66291-fdcc-4106-8875-94d2b0a70deb"},{"index":6911,"token":false,"name":"Gargos, Vicious Watcher","scryfallId":"4e446e90-6e31-43ed-bcb1-a01422b503c0"},{"index":6912,"token":false,"name":"Doran, the Siege Tower","scryfallId":"b006b169-295d-4ead-8e8e-29a9c3246025"},{"index":6913,"token":false,"name":"Knighthood","scryfallId":"1d5e98d3-2521-4340-8d48-98e8c2c7818d"},{"index":6916,"token":false,"name":"Abzan Skycaptain","scryfallId":"c4195373-e902-4fc3-aead-1f6e728dbbae"},{"index":6919,"token":false,"name":"Grasp of Darkness","scryfallId":"7737b578-8ae3-4846-b508-93ef40f25244"},{"index":6920,"token":false,"name":"Supreme Phantom","scryfallId":"5d65c22b-7640-4433-930b-4bc381ac7361"},{"index":6922,"token":false,"name":"Willow Faerie","scryfallId":"83ce80dc-86d9-4613-af98-c385ca5d1cf4"},{"index":6923,"token":false,"name":"Suspension Field","scryfallId":"dbeb9475-64d8-4c9a-98e6-c473075ee343"},{"index":6926,"token":false,"name":"Abundant Harvest","scryfallId":"16782095-0b7f-4489-8a97-b74f8efef352"},{"index":6928,"token":false,"name":"Lowland Oaf","scryfallId":"02813ade-7d11-40ad-a290-02405e40532d"},{"index":6930,"token":false,"name":"Odric, Lunarch Marshal","scryfallId":"cd9ae6f9-468e-4fb1-85da-0a29dc8ceb79"},{"index":6931,"token":false,"name":"Sedge Sliver","scryfallId":"18dc8d7e-745c-46ba-842c-526f1beb89a7"},{"index":6937,"token":false,"name":"Arcbound Overseer","scryfallId":"9dac661f-70fc-4156-a301-b2a46b87513e"},{"index":6938,"token":false,"name":"Opal Caryatid","scryfallId":"3a8a2e24-c959-40a2-883d-c0114589cfe7"},{"index":6939,"token":false,"name":"Nyxborn Wolf","scryfallId":"91a78895-5e09-46a5-8a74-a07f0befc4e5"},{"index":6940,"token":false,"name":"Winged Shepherd","scryfallId":"04301470-82d9-43c7-aaf1-a41e185cb109"},{"index":6942,"token":false,"name":"Harvest Mage","scryfallId":"95b29329-b9a3-4d59-b0f8-2abc67337760"},{"index":6944,"token":false,"name":"Myrsmith","scryfallId":"783c15b7-6a7f-471e-b9f7-8c38115e66c0"},{"index":6945,"token":false,"name":"Soaring Seacliff","scryfallId":"651a1a4f-bdaa-44d6-ac45-050894788063"},{"index":6946,"token":false,"name":"Burrog Befuddler","scryfallId":"6040c573-cd8c-4593-8ade-d9922482035c"},{"index":6947,"token":false,"name":"Minamo, School at Water's Edge","scryfallId":"7536292c-da25-41c8-ba28-1e35758a7f3d"},{"index":6948,"token":false,"name":"Dark Confidant","scryfallId":"4c008ad2-ad33-46ee-a3f1-af85368c8734"},{"index":6950,"token":false,"name":"Wall of Dust","scryfallId":"b25b81fb-1d0f-4c0c-8d54-fbf9c1d54578"},{"index":6952,"token":false,"name":"Boggart Ram-Gang","scryfallId":"63e25b70-fa21-4663-aabd-34b7e0b75c34"},{"index":6956,"token":false,"name":"Consume Spirit","scryfallId":"f267137c-57f5-43b1-9a4b-98f2b84106b9"},{"index":6958,"token":false,"name":"Baleful Strix","scryfallId":"06cb1bd6-73e0-4104-b344-4bc52d7dcedf"},{"index":6961,"token":false,"name":"Roc of Kher Ridges","scryfallId":"4a4aa139-842f-45b9-82ba-d184f0b24bc5"},{"index":6962,"token":false,"name":"Feral Hydra","scryfallId":"46f76986-e9fb-4c51-b946-880b501775b0"},{"index":6963,"token":false,"name":"Mnemonic Sliver","scryfallId":"3457f86f-422c-483d-9d3f-b8e99fdab6c8"},{"index":6964,"token":false,"name":"Sunken Hollow","scryfallId":"367fae2b-9128-4df8-a42b-3ea03d0b9345"},{"index":6966,"token":false,"name":"Revoke Privileges","scryfallId":"55640426-54a4-4c1c-a0ad-fde4090a2456"},{"index":6969,"token":false,"name":"Spread the Sickness","scryfallId":"5a89ba3a-7438-4d3b-ba36-b5a064392a11"},{"index":6972,"token":false,"name":"Vhati il-Dal","scryfallId":"a8564611-b678-4336-87e0-5a00a930de48"},{"index":6973,"token":false,"name":"Mogg Conscripts","scryfallId":"c67c26d7-f752-40a5-b79e-1f4c531cbef5"},{"index":6974,"token":false,"name":"Explorer's Scope","scryfallId":"b16cf33f-ef8d-4d10-87fe-ab03b8525766"},{"index":6975,"token":false,"name":"Seedling Charm","scryfallId":"e42746e1-f422-4453-a860-3993d5796479"},{"index":6976,"token":false,"name":"Elvish Berserker","scryfallId":"0ee84f5c-130b-4f44-a045-3e5728ce0950"},{"index":6977,"token":false,"name":"Last Stand","scryfallId":"7dc3d054-6266-4ce0-89ed-f8b170794f2e"},{"index":6982,"token":false,"name":"Stab Wound","scryfallId":"88f959a3-b8d4-49f8-9348-cad0098bd84c"},{"index":6983,"token":false,"name":"Whirler Rogue","scryfallId":"23dcb171-884d-480f-ba05-2a7c9cde5cfd"},{"index":6985,"token":false,"name":"Armor Sliver","scryfallId":"c275aba7-cac6-48e8-b12c-6bd77a5c38fe"},{"index":6986,"token":false,"name":"Cataclysmic Gearhulk","scryfallId":"7b10947b-c276-41c4-b72c-efcddd94d13b"},{"index":6987,"token":false,"name":"Shepherd of the Flock // Usher to Safety","scryfallId":"c0b4f0ce-0d18-4546-803d-94a2f4f30951"},{"index":6988,"token":false,"name":"Forgotten Ancient","scryfallId":"cbfba394-c79a-4169-abe8-08c4549268b9"},{"index":6992,"token":false,"name":"Flooded Grove","scryfallId":"063e3c8e-7d5d-4e38-bb9c-3d8f93c27369"},{"index":6995,"token":false,"name":"Bond of Discipline","scryfallId":"948351f2-2273-4cad-acfd-b7b4643beb7b"},{"index":6996,"token":false,"name":"Taigam, Ojutai Master","scryfallId":"b47e2781-544f-442c-98d0-43b9d91bab03"},{"index":6997,"token":false,"name":"Tourach, Dread Cantor","scryfallId":"2e7caf6c-9f5b-45c4-99ab-2968c3d574e9"},{"index":6998,"token":true,"name":"Bird Token (W, 3/3)","scryfallId":"5a84671e-cbe8-467e-9a8a-bbecba6158fa"},{"index":6999,"token":false,"name":"Snake Basket","scryfallId":"e992d139-1b53-42f1-ab9b-9d8df0c1fe73"},{"index":7002,"token":false,"name":"Treasure Cruise","scryfallId":"acda7194-dd78-4641-8bc2-7f40b05cecec"},{"index":7003,"token":false,"name":"Sinister Starfish","scryfallId":"db209732-c290-4999-a1aa-2369dfa8790c"},{"index":7005,"token":false,"name":"Lay Waste","scryfallId":"46fa1186-51fa-419a-9cd0-42403d1dd4a7"},{"index":7007,"token":false,"name":"Stoneforge Mystic","scryfallId":"6003e1e8-13d5-4f17-bbd4-ee05a6c4b30d"},{"index":7009,"token":false,"name":"Assassinate","scryfallId":"074dc791-96d2-4401-963a-6e2f3d72dcfc"},{"index":7010,"token":false,"name":"Knight of Sursi","scryfallId":"84b23129-25b2-4870-9462-ab12718ae7be"},{"index":7011,"token":false,"name":"Ornery Goblin","scryfallId":"2164e358-cbb4-4c3a-aea2-48f1891757df"},{"index":7013,"token":false,"name":"Thalakos Lowlands","scryfallId":"8522c51f-9126-41eb-84b5-f8489c7ad7ff"},{"index":7015,"token":false,"name":"Pyre of Heroes","scryfallId":"ae9a8e44-f5de-497d-be48-adf1bcbaec97"},{"index":7016,"token":false,"name":"Wojek Embermage","scryfallId":"e1614866-fb0b-47bd-ab26-5c20ff175d10"},{"index":7018,"token":false,"name":"Corpsejack Menace","scryfallId":"b519f1ed-0411-4c85-a266-3c4f2895000a"},{"index":7020,"token":false,"name":"Saproling Burst","scryfallId":"675a531a-072d-4a59-ac72-5b3a04d1ec3b"},{"index":7022,"token":false,"name":"Maggot Therapy","scryfallId":"6ab963aa-2304-4ee6-a8c7-c485c5133b40"},{"index":7023,"token":false,"name":"Invasive Species","scryfallId":"c1fb5a98-94f4-419f-850b-e3a01f17080f"},{"index":7024,"token":false,"name":"Moldervine Reclamation","scryfallId":"34c282d0-fe83-4ced-b696-cf0e2c6b13d0"},{"index":7025,"token":false,"name":"Halimar Depths","scryfallId":"d017b08e-4f52-4599-9037-73113b36fec8"},{"index":7028,"token":false,"name":"Restoration Gearsmith","scryfallId":"1534ad62-597b-4cc3-ae63-1d3385a752ac"},{"index":7031,"token":false,"name":"Legion Warboss","scryfallId":"23675d49-0ddf-414c-9bf5-5f0e480c479d"},{"index":7033,"token":false,"name":"Sun-Crowned Hunters","scryfallId":"3cab793e-0e17-4940-9cab-a30d62df5c20"},{"index":7040,"token":false,"name":"Glimpse the Future","scryfallId":"f4d875e9-713d-4ddb-ae0a-db8483366319"},{"index":7044,"token":false,"name":"Watercourser","scryfallId":"a27c441a-b31d-4214-8fc5-054003e257dc"},{"index":7045,"token":false,"name":"Butcher's Glee","scryfallId":"e046bccf-f714-4bf3-9323-388656dd2cd8"},{"index":7046,"token":false,"name":"Balduvian Horde","scryfallId":"34eb627d-d711-4c5b-a0b1-744ce0bb0cf0"},{"index":7047,"token":false,"name":"Corrupted Zendikon","scryfallId":"0ce7d93d-3998-4486-b277-e4f91f6e3feb"},{"index":7048,"token":false,"name":"Turtleshell Changeling","scryfallId":"a72b078e-e324-4775-9d38-08943017a48e"},{"index":7049,"token":false,"name":"Goblin Dirigible","scryfallId":"d2ed2990-e5bf-4567-9a41-1846108a8aeb"},{"index":7051,"token":false,"name":"Vow of Wildness","scryfallId":"d98134ea-a06f-4ad1-84ac-0409bbfaa783"},{"index":7053,"token":true,"name":"Wolfgang Eder Bio","scryfallId":"53b08fa1-f76a-407a-ba07-43cadc13453c"},{"index":7054,"token":false,"name":"Volcanic Awakening","scryfallId":"aebd5c57-cfc8-4a3c-b4a2-0cd64a5e3575"},{"index":7055,"token":false,"name":"Willow Priestess","scryfallId":"31479296-5ea7-470c-9d3f-257e67844fbc"},{"index":7056,"token":false,"name":"Teysa, Envoy of Ghosts","scryfallId":"cbd8183c-6967-4332-b822-02b82c14ef2d"},{"index":7058,"token":false,"name":"Enchanted Evening","scryfallId":"5654a20f-13f5-4467-b06c-1cf9869157b3"},{"index":7059,"token":false,"name":"Koma, Cosmos Serpent","scryfallId":"876ad1df-e926-4d89-aad7-499a37b27f4c"},{"index":7061,"token":false,"name":"Poultice Sliver","scryfallId":"bc6db2cf-5171-4791-82b4-c9fac37902a3"},{"index":7062,"token":false,"name":"Hex","scryfallId":"ea5685ef-684b-4426-bab7-710a51f994f8"},{"index":7063,"token":false,"name":"Terminus","scryfallId":"9e564a2c-e8f0-4ef2-bb1f-1d607dcb0b63"},{"index":7067,"token":false,"name":"Mana Leech","scryfallId":"8a288616-5350-43eb-b718-5bfeb5be4ed4"},{"index":7068,"token":false,"name":"Wooded Foothills","scryfallId":"cdad38f7-9dfa-4f1b-9fac-41ab2b253f53"},{"index":7069,"token":false,"name":"Benediction of Moons","scryfallId":"d8ea99d1-9e88-4b14-b0b3-39bcd8191eab"},{"index":7070,"token":false,"name":"Grizzled Angler // Grisly Anglerfish","scryfallId":"1eb4ddf4-f695-412d-be80-b93392432498"},{"index":7072,"token":false,"name":"Soulflayer","scryfallId":"e249a406-6783-4502-952a-27ec744a38b3"},{"index":7073,"token":false,"name":"Rending Vines","scryfallId":"34cf7931-d086-496e-98dc-5daa60e01f5b"},{"index":7074,"token":false,"name":"Sword of Feast and Famine","scryfallId":"0d239414-fd5a-4e7a-9f53-79fb38e46435"},{"index":7076,"token":false,"name":"Go for the Throat","scryfallId":"8185ecd0-2fdf-4d8b-a396-d5db593985b9"},{"index":7077,"token":false,"name":"Leafkin Avenger","scryfallId":"7bd3a903-23e0-4b5a-9c7e-390d5ced8371"},{"index":7079,"token":false,"name":"Moroii","scryfallId":"b71986c1-cbcd-4241-a2bb-574b7b6d1667"},{"index":7080,"token":false,"name":"Delver of Secrets // Insectile Aberration","scryfallId":"28059d09-2c7d-4c61-af55-8942107a7c1f"},{"index":7081,"token":false,"name":"Cemetery Puca","scryfallId":"eec3b06b-d8c5-459c-aae5-3e51059cfdf1"},{"index":7082,"token":false,"name":"Iridescent Drake","scryfallId":"5c99c962-aa33-4e19-96b2-7a05b97d06d4"},{"index":7083,"token":false,"name":"Abjure","scryfallId":"fbad9449-d09c-4fd0-b2ad-2aa3a29e03bf"},{"index":7084,"token":false,"name":"Llanowar Scout","scryfallId":"c8026d80-2e91-46f9-ae97-1f137848236c"},{"index":7085,"token":false,"name":"Overgrown Battlement","scryfallId":"50974264-b509-4df9-802b-623805a4cbee"},{"index":7087,"token":true,"name":"Demon Berserker Token (R, 2/3)","scryfallId":"c58def55-f2ca-4c41-b891-c32e5220fc66"},{"index":7088,"token":true,"name":"Elemental Token (G, 5/3)","scryfallId":"5cddb130-a354-4373-9dc4-60c7d57eec8b"},{"index":7089,"token":false,"name":"Immortal Phoenix","scryfallId":"afcb9f15-be65-494c-9672-162d38c6f0a5"},{"index":7091,"token":false,"name":"Thought Sponge","scryfallId":"70406543-ba78-4dd8-8f16-3c5a9ee458a1"},{"index":7093,"token":false,"name":"Cleaver Riot","scryfallId":"6761eacf-03fc-4ccd-a4a6-eca5357b5c5b"},{"index":7094,"token":false,"name":"Taste of Blood","scryfallId":"29268cef-da18-4c1d-9066-e0d513a61bf9"},{"index":7096,"token":false,"name":"Aetherize","scryfallId":"7b7283bc-6407-4715-9d0a-19c3cca1dbd0"},{"index":7098,"token":false,"name":"Mouth // Feed","scryfallId":"99a14aba-a7db-4138-9869-ec296e39bf97"},{"index":7099,"token":false,"name":"Tishana's Wayfinder","scryfallId":"af52383b-545e-4b64-93f9-317ba6dcf5a8"},{"index":7100,"token":false,"name":"Cosima, God of the Voyage // The Omenkeel","scryfallId":"fab2fca4-a99f-4ffe-9c02-edb6e0be2358"},{"index":7101,"token":false,"name":"Beast Attack","scryfallId":"b57bb8a9-3cba-4814-9073-e6f672ed5e4f"},{"index":7102,"token":false,"name":"Chemister's Insight","scryfallId":"0e13a295-0d51-4b56-8c58-0896eb41c567"},{"index":7103,"token":false,"name":"Screeching Harpy","scryfallId":"5c2e2364-9181-4745-9267-3fa1b775331e"},{"index":7104,"token":false,"name":"Farrel's Zealot","scryfallId":"9e3aeee7-975c-419a-bfb3-45bb48ba6918"},{"index":7106,"token":false,"name":"Open the Graves","scryfallId":"9ced1022-abd9-4e22-a4f2-fef738295224"},{"index":7107,"token":false,"name":"Arvad the Cursed","scryfallId":"bf9d5d4f-3ad3-45d2-b826-b3c0ef24e234"},{"index":7112,"token":false,"name":"Basal Thrull","scryfallId":"fcf60db5-4f69-4db4-9dc2-1a6fbdec0429"},{"index":7113,"token":false,"name":"Closing Statement","scryfallId":"785e6d07-fe40-4723-b963-02da0a0987c7"},{"index":7114,"token":false,"name":"Fume Spitter","scryfallId":"bb1ef824-306c-4975-abca-19f0bd77449f"},{"index":7115,"token":false,"name":"Eternal Warrior","scryfallId":"470fefdd-1220-4418-8fa5-42dae682a350"},{"index":7116,"token":false,"name":"Stoic Ephemera","scryfallId":"63058b80-8b19-4077-9219-f064255d1c74"},{"index":7117,"token":false,"name":"Spitting Image","scryfallId":"63aac154-5d93-4e79-b3a9-811330b59b19"},{"index":7118,"token":false,"name":"Sundial of the Infinite","scryfallId":"d77b771d-9c7e-43b1-ac23-849ca882113b"},{"index":7119,"token":false,"name":"Immortal Servitude","scryfallId":"88366762-4be0-422a-a0ff-ed046d30afe1"},{"index":7120,"token":false,"name":"Abandoned Sarcophagus","scryfallId":"23b587f3-5eac-45a7-a048-dd73d2a2b74f"},{"index":7121,"token":false,"name":"Cephalid Sage","scryfallId":"434e2ece-7b00-4ad1-9c35-cca16fbb002b"},{"index":7123,"token":false,"name":"Blademane Baku","scryfallId":"78bfd388-3648-4bc3-8c10-d6b3b79a9479"},{"index":7124,"token":false,"name":"Desperate Ravings","scryfallId":"43e57605-9936-48d3-9bae-f6244045573e"},{"index":7125,"token":false,"name":"Huatli, Radiant Champion","scryfallId":"d56a9058-ab65-4023-baf8-4f199b8e56e4"},{"index":7126,"token":false,"name":"Sword of War and Peace","scryfallId":"fab5bc6c-8943-4078-866a-5d02f9be0eef"},{"index":7127,"token":false,"name":"Ring of Valkas","scryfallId":"cb3c0bc4-6f89-48e2-b525-5efcb091bc5e"},{"index":7129,"token":false,"name":"Thrummingbird","scryfallId":"dc2dd336-e457-49a1-88ae-c35f0c846e99"},{"index":7130,"token":false,"name":"Treasure Hunt","scryfallId":"b411f39f-19d6-47ac-9962-105323996ebe"},{"index":7131,"token":false,"name":"Ruthless Winnower","scryfallId":"886ef13a-4f9d-425b-a071-6366cdb637c8"},{"index":7132,"token":false,"name":"Frostling","scryfallId":"230f40c3-342c-4775-bde1-5ca025cb02dd"},{"index":7133,"token":false,"name":"Saproling Symbiosis","scryfallId":"2bb63748-5c84-43a0-8f17-a2a17f658337"},{"index":7134,"token":false,"name":"Torrent of Souls","scryfallId":"d0074236-ac60-4005-9c4d-c52761e873ca"},{"index":7135,"token":false,"name":"Charmbreaker Devils","scryfallId":"47361f61-b717-4468-8050-5f28a8fe6754"},{"index":7138,"token":false,"name":"Venerable Monk","scryfallId":"3b59eeaf-5629-4216-8d97-1dbd1927b8fe"},{"index":7143,"token":false,"name":"Sentinel","scryfallId":"ffd4921f-cda5-4318-837d-a3fe4f0d9362"},{"index":7147,"token":false,"name":"Maze Abomination","scryfallId":"dd84659f-4209-42a2-800a-61706470ce54"},{"index":7149,"token":false,"name":"Ophidian","scryfallId":"4e244697-76ef-4228-9057-fd73ecf667a6"},{"index":7150,"token":false,"name":"Kozilek, the Great Distortion","scryfallId":"3ecd0b92-18a0-45bb-a023-a0b49eadded9"},{"index":7151,"token":false,"name":"Kraum, Ludevic's Opus","scryfallId":"c48dc814-8a91-4689-b4a4-a09fdcdc58cf"},{"index":7154,"token":false,"name":"Vintara Elephant","scryfallId":"f99f7aef-7398-4e10-9f4e-68e7c294c101"},{"index":7156,"token":true,"name":"Rat Token (B, 1/1)","scryfallId":"1a85fe9d-ef18-46c4-88b0-cf2e222e30e4"},{"index":7158,"token":false,"name":"Emrakul's Influence","scryfallId":"112476e7-72ab-4ebc-9e6e-e96fbf5109c0"},{"index":7159,"token":false,"name":"Fiend Hunter","scryfallId":"1f8fd6e7-a7d9-433c-9d8c-ec279132af50"},{"index":7161,"token":false,"name":"Hinder","scryfallId":"6e76260a-e26a-45ea-8874-3c9b261aef22"},{"index":7163,"token":false,"name":"Watery Grave","scryfallId":"7d4595f2-9297-40dc-b2dd-7144bbb401f7"},{"index":7165,"token":false,"name":"Sliver Legion","scryfallId":"8bd37a04-87b1-42ad-b3e2-f17cd8998f9d"},{"index":7168,"token":false,"name":"Kor Spiritdancer","scryfallId":"59813c47-e779-404d-8a1c-70ea29bc7023"},{"index":7169,"token":false,"name":"Azorius Guildmage","scryfallId":"3dc24fbf-6a61-404d-8944-9659f3f5f0a4"},{"index":7170,"token":false,"name":"Sphinx of Magosi","scryfallId":"a2b4f70d-e922-4ecb-9d5a-6253f7a7716c"},{"index":7172,"token":false,"name":"Grand Arbiter Augustin IV","scryfallId":"337fd1aa-1c85-4aee-923b-c457e43cda72"},{"index":7176,"token":false,"name":"Shaile, Dean of Radiance // Embrose, Dean of Shadow","scryfallId":"24e5912f-e7cb-4a59-aece-ad29dfaf0e09"},{"index":7179,"token":false,"name":"Chittering Rats","scryfallId":"5162306a-47f9-4725-bc6f-4610d2416a56"},{"index":7182,"token":false,"name":"Horned Troll","scryfallId":"7f2a6d10-054e-4d6f-aeb7-4204f02490c7"},{"index":7187,"token":false,"name":"Heated Debate","scryfallId":"f40c88e2-28ed-4e5b-bcb3-4397d6a15a6f"},{"index":7188,"token":false,"name":"Jaws of Stone","scryfallId":"49298937-c793-4903-b665-9b77288f795f"},{"index":7190,"token":false,"name":"Sarkhan, the Dragonspeaker","scryfallId":"c58064fd-4d8b-4f54-812f-0bb1d7e2ddc2"},{"index":7192,"token":false,"name":"Orcish Cannoneers","scryfallId":"8c8f69b2-ccd2-4ba3-b6d9-127163b02aca"},{"index":7193,"token":false,"name":"Arcbound Ravager","scryfallId":"c0c33a92-5621-40b4-a3a2-b67893edbc01"},{"index":7194,"token":false,"name":"Homarid","scryfallId":"33536b0a-1cff-481f-b695-eadaf6897bf0"},{"index":7195,"token":false,"name":"Dromoka's Command","scryfallId":"df1e43a8-0adc-4e26-bc56-6b914bd35838"},{"index":7198,"token":false,"name":"Oppressive Rays","scryfallId":"1eac995f-514d-4c65-8135-417f2b1a6fba"},{"index":7199,"token":false,"name":"Brainwash","scryfallId":"840289aa-bc83-41f6-86ea-bb848793776b"},{"index":7200,"token":false,"name":"Silumgar Spell-Eater","scryfallId":"20a99655-34b2-4756-bf12-b344eb71ad37"},{"index":7201,"token":false,"name":"Nefashu","scryfallId":"29b206a3-829f-421e-b8bf-0bcc0d9845c1"},{"index":7202,"token":false,"name":"Wildborn Preserver","scryfallId":"55f76830-369e-4224-9ded-7d1ce04c87e4"},{"index":7204,"token":false,"name":"Sulfur Elemental","scryfallId":"0aed10f9-8c52-400b-a432-a0d8c6458e87"},{"index":7205,"token":false,"name":"Prowling Caracal","scryfallId":"09ae21d0-771e-4b04-826e-e352fff31ad6"},{"index":7207,"token":false,"name":"Peace Strider","scryfallId":"834b616f-7470-4c90-b35d-2b5f164b3b54"},{"index":7208,"token":false,"name":"Wei Elite Companions","scryfallId":"f2393871-86a8-4c23-b3ec-2bc68bdaf087"},{"index":7210,"token":false,"name":"Falkenrath Noble","scryfallId":"65b51d77-2335-4170-8d86-96052e9dc260"},{"index":7211,"token":false,"name":"Burning-Rune Demon","scryfallId":"f358a52b-8044-404e-8d04-2ec5903386cc"},{"index":7212,"token":false,"name":"Zombie Master","scryfallId":"a1bfda92-b932-46d8-b549-e2bc2b584a17"},{"index":7214,"token":false,"name":"Orim's Chant","scryfallId":"a0d59d90-0a4f-45f1-81ad-23a348a1a868"},{"index":7216,"token":false,"name":"Stain the Mind","scryfallId":"c7d2b046-59bc-4e39-94ce-981179307bd3"},{"index":7217,"token":false,"name":"Pestilence Demon","scryfallId":"a6931673-20e0-410e-bc2a-d14efa2b488a"},{"index":7218,"token":false,"name":"Mistmeadow Witch","scryfallId":"aeb05bcc-345e-4883-9b43-1c3cfa3a4f51"},{"index":7219,"token":false,"name":"Lace with Moonglove","scryfallId":"32f209d6-c194-4208-864d-f8a44b88997f"},{"index":7220,"token":false,"name":"Provoke","scryfallId":"fa3c58f1-5276-420e-8c09-d256492ee87b"},{"index":7221,"token":false,"name":"Zhur-Taa Goblin","scryfallId":"13070db2-cf89-4552-8b6c-76426274321a"},{"index":7222,"token":false,"name":"Shivan Reef","scryfallId":"eea38777-e67d-40a5-9301-d4e6d3819899"},{"index":7224,"token":false,"name":"Thundercloud Elemental","scryfallId":"597aea42-43e0-41ed-bfe7-fc92b6b8e680"},{"index":7225,"token":false,"name":"Kor Outfitter","scryfallId":"00006596-1166-4a79-8443-ca9f82e6db4e"},{"index":7226,"token":false,"name":"Blue Sun's Zenith","scryfallId":"678a3223-7a4b-4f45-88c6-92a0d181d721"},{"index":7227,"token":false,"name":"Primal Rage","scryfallId":"ebe3b738-703d-465c-bc76-2b66f1e0aff2"},{"index":7229,"token":true,"name":"Elf Warrior Token (G/W, 1/1)","scryfallId":"49180301-f72f-48ca-8be1-df295e89cdd7"},{"index":7230,"token":false,"name":"Cruel Celebrant","scryfallId":"87ead6ac-b1c5-4852-8413-7fa43c6cfc57"},{"index":7231,"token":false,"name":"Winged Words","scryfallId":"3449f98f-92d2-4be4-a596-fefa8843b6fd"},{"index":7233,"token":false,"name":"Daring Skyjek","scryfallId":"6c28412d-9add-4911-8487-c84559006fb0"},{"index":7234,"token":false,"name":"Scattershot Archer","scryfallId":"d74d6cdb-a087-4b3d-bf25-509200ed6d93"},{"index":7236,"token":false,"name":"Sublime Exhalation","scryfallId":"ac6d4a9e-a7fd-480e-96cf-5cf6d2390189"},{"index":7237,"token":false,"name":"Strider Harness","scryfallId":"9d7b9e54-b3ef-44fb-9240-0d67c1c4b7f6"},{"index":7238,"token":false,"name":"Marionette Master","scryfallId":"09b3b0f5-5532-4367-9967-cd68ff869c7e"},{"index":7240,"token":false,"name":"Collective Blessing","scryfallId":"53c84c4d-e6d6-4eac-9d14-5b6cba914c3d"},{"index":7242,"token":false,"name":"Shoving Match","scryfallId":"aa9f4787-9b29-4f57-b105-1f9eb4bb8861"},{"index":7243,"token":false,"name":"Arcanis the Omnipotent","scryfallId":"e7a7941b-68bf-48b1-a5ed-2013068b486c"},{"index":7244,"token":false,"name":"Thunder-Thrash Elder","scryfallId":"92ecd6d2-f052-4dc6-823b-a1997a911cf9"},{"index":7245,"token":false,"name":"Verge Rangers","scryfallId":"071bee6a-21ed-4776-ad78-2cc8ef5ab959"},{"index":7247,"token":true,"name":"Etherium Cell","scryfallId":"9616ca53-ea6a-4fc1-8e01-94e0fb47e5ed"},{"index":7248,"token":false,"name":"Sidisi, Undead Vizier","scryfallId":"e6a67a3e-4091-46a6-8526-3718cfb7b5b4"},{"index":7251,"token":false,"name":"Treacherous Link","scryfallId":"2e5f8581-411b-4403-9c3a-3cf2156f6779"},{"index":7252,"token":false,"name":"Illuminate History","scryfallId":"1caa9c12-ac06-458e-bf03-21dd1b3ed986"},{"index":7254,"token":false,"name":"Keeper of the Light","scryfallId":"06eda847-c599-4163-b48b-aa76b153ed86"},{"index":7255,"token":false,"name":"Rootborn Defenses","scryfallId":"deccfa48-b8df-4dcc-ba1b-920f8352def7"},{"index":7256,"token":false,"name":"Vault of Whispers","scryfallId":"73866487-33f4-4f64-b100-2c4ddadcd74e"},{"index":7258,"token":false,"name":"Argothian Treefolk","scryfallId":"36b0d5b3-84d7-4888-90e9-2d0eb16c11d6"},{"index":7259,"token":false,"name":"Fathom Fleet Cutthroat","scryfallId":"65a7004c-1952-41df-b645-b34bcbc3e401"},{"index":7266,"token":false,"name":"Telepathy","scryfallId":"ce03b4b4-612b-4fc9-b063-b0d367712eaf"},{"index":7267,"token":false,"name":"Mind Sludge","scryfallId":"e86a26e9-e4cb-452a-9263-489d57233d41"},{"index":7270,"token":false,"name":"Seht's Tiger","scryfallId":"497f5776-c741-4351-9686-4696daad2288"},{"index":7271,"token":false,"name":"Discontinuity","scryfallId":"0b2f8208-0dba-49e0-ae53-b1c9347b92b6"},{"index":7275,"token":false,"name":"Rainbow Vale","scryfallId":"c1b138e1-f8fc-435c-9aed-98004768479c"},{"index":7276,"token":true,"name":"Wild Maenads Token (Colorless, 3/1)","scryfallId":"7b8ec95a-e728-446b-8c4a-a3571e6aa458"},{"index":7277,"token":false,"name":"Trail of Mystery","scryfallId":"6149685f-cb05-4c1f-95a4-3810505d1a95"},{"index":7278,"token":false,"name":"Adarkar Windform","scryfallId":"c18bce4a-9afb-4b91-bc9a-d62634b0f8dd"},{"index":7281,"token":false,"name":"Supreme Will","scryfallId":"b677e7cb-7b5d-4993-8f13-881493c498ce"},{"index":7282,"token":false,"name":"Hunger of the Nim","scryfallId":"bba50e47-2417-447f-b334-50ef0faecfae"},{"index":7283,"token":false,"name":"Kamahl's Will","scryfallId":"51fe007f-fddf-4b3a-b336-0a88df95cb14"},{"index":7284,"token":true,"name":"Manuel Bevand Decklist","scryfallId":"836c1c87-7542-45e5-9bdc-73b9c6df1c0f"},{"index":7286,"token":false,"name":"March from the Tomb","scryfallId":"85aa9af2-b179-4752-9ccd-fbd5f4e5a42c"},{"index":7287,"token":true,"name":"Antoine Ruel Decklist","scryfallId":"771e021b-7ef8-46c3-9545-1f625d38d1e6"},{"index":7288,"token":false,"name":"Cut // Ribbons","scryfallId":"bfca1ca4-8a6d-436d-8be4-88e015ccdac8"},{"index":7289,"token":false,"name":"Faerie Vandal","scryfallId":"789c5c2b-3e51-4f6c-ac76-d276facf716f"},{"index":7290,"token":false,"name":"Canyon Wildcat","scryfallId":"4bd2baa7-1264-4139-881d-e8169391c48b"},{"index":7291,"token":false,"name":"Slashing Tiger","scryfallId":"4fbedd66-457a-4e1c-a9f3-fa37dec81c7a"},{"index":7292,"token":false,"name":"Volrath's Shapeshifter","scryfallId":"ec89ee13-34ef-41c8-8fe4-0a6b21df2032"},{"index":7293,"token":false,"name":"Tinybones, Trinket Thief","scryfallId":"4063be5b-bfd9-43c5-bc39-09a40bc793bf"},{"index":7295,"token":false,"name":"Sunmane Pegasus","scryfallId":"52e28f5a-55ee-4fcc-bc16-e59944592fcd"},{"index":7298,"token":false,"name":"Jaya, Venerated Firemage","scryfallId":"df6c3050-965a-466c-b7a2-d190cee42bdf"},{"index":7299,"token":false,"name":"Aphotic Wisps","scryfallId":"52fd47e7-02c5-4f91-bb3b-697c4c53232a"},{"index":7300,"token":false,"name":"Rite of Belzenlok","scryfallId":"da97eb9c-8768-42d1-a80e-c88bccc4c9b3"},{"index":7301,"token":false,"name":"Cyclone Sire","scryfallId":"bff62270-57ed-4706-bedf-11f60ae2da43"},{"index":7303,"token":false,"name":"Underworld Breach","scryfallId":"18e1bdc9-be60-4abd-9756-d3e70e2fcdb5"},{"index":7304,"token":false,"name":"Horn of Plenty","scryfallId":"d5e04462-1d10-47df-b456-211dd0a87891"},{"index":7305,"token":false,"name":"Glarecaster","scryfallId":"7e505e8e-51aa-4415-81e6-cf022279edb0"},{"index":7306,"token":false,"name":"Nimble Obstructionist","scryfallId":"f604709d-51aa-455f-94fc-dc56d3004a42"},{"index":7308,"token":false,"name":"Sylvan Safekeeper","scryfallId":"f1b8413f-c9fc-4cea-b416-a1fcf651b009"},{"index":7309,"token":false,"name":"Binding Grasp","scryfallId":"6b086186-5fbf-4ba7-af0d-ee3ad61d27bb"},{"index":7310,"token":true,"name":"Walker Token (B, 2/2)","scryfallId":"4d03f760-6e5a-404e-beb9-07d78a53364d"},{"index":7311,"token":false,"name":"Flood of Tears","scryfallId":"c3621820-4ab5-42bf-8a02-d5c066db4653"},{"index":7312,"token":false,"name":"Painful Lesson","scryfallId":"becbd481-311d-4f85-aacd-df1f7d7ef587"},{"index":7313,"token":false,"name":"Kor Castigator","scryfallId":"f4db2f0e-d7d4-417b-9b94-5ade727907e9"},{"index":7314,"token":false,"name":"Caves of Koilos","scryfallId":"6358592c-b6e8-4263-b96b-c548fdac5193"},{"index":7315,"token":false,"name":"Deafening Clarion","scryfallId":"1e115a81-001d-4e17-98af-6a63f2b0967f"},{"index":7317,"token":false,"name":"Fervent Denial","scryfallId":"7b15428e-946e-490d-93bb-9888bfd3a1df"},{"index":7320,"token":false,"name":"Pikemen","scryfallId":"8f1e5f89-cd60-4a87-a6b5-a02045894c81"},{"index":7321,"token":false,"name":"Near-Death Experience","scryfallId":"77d61706-f9c1-4590-8057-7aa7fa199e6d"},{"index":7322,"token":false,"name":"Chandra's Fury","scryfallId":"25335fee-d320-4622-bcf4-292400dee52b"},{"index":7323,"token":false,"name":"Tormented Soul","scryfallId":"ceb5d4c4-d6b5-4d28-8ed7-e367c6201f24"},{"index":7324,"token":false,"name":"Vorstclaw","scryfallId":"7591ee4f-9bfe-4419-84df-abf35d85bb94"},{"index":7327,"token":false,"name":"Canopy Cover","scryfallId":"4fcc34db-60be-4017-adfa-6bdfacec793f"},{"index":7329,"token":false,"name":"Leonin Abunas","scryfallId":"14397b59-ff0d-4838-92c3-9728bf6b0af5"},{"index":7330,"token":false,"name":"Rabid Bloodsucker","scryfallId":"ed20b43d-7cad-4dc3-a128-46247ef4b612"},{"index":7332,"token":false,"name":"Hypersonic Dragon","scryfallId":"99dc07bf-7c55-442b-9260-5ea74a42af41"},{"index":7336,"token":false,"name":"Flinthoof Boar","scryfallId":"873be98f-e263-4e84-afa0-1e329aa47550"},{"index":7337,"token":false,"name":"Floating Shield","scryfallId":"4dbda39b-a998-4ad9-95df-72ed9556c390"},{"index":7338,"token":false,"name":"Genesis Hydra","scryfallId":"49f0118e-4449-4394-b4c1-5b4f83d7bc4a"},{"index":7339,"token":false,"name":"Horror of the Broken Lands","scryfallId":"35828576-124a-45d6-ad4c-af2926314953"},{"index":7340,"token":false,"name":"Offspring's Revenge","scryfallId":"82dccdf7-25d0-4d5f-ab4b-98632796de2e"},{"index":7341,"token":false,"name":"Jwari Scuttler","scryfallId":"04129038-3b02-418a-862a-229e9dde339b"},{"index":7342,"token":false,"name":"Skinbrand Goblin","scryfallId":"9535cdfe-d505-4ee5-bec0-cfd7aa4b2a23"},{"index":7344,"token":true,"name":"Human Token (W, 1/1)","scryfallId":"8894949b-f190-461e-996a-cf2b39f08a5d"},{"index":7348,"token":false,"name":"Sphere of Grace","scryfallId":"d5b49d82-6d11-4294-a367-0b5b45c05e44"},{"index":7352,"token":false,"name":"Firja's Retribution","scryfallId":"03dff23e-d7e3-4d75-a9dc-fdf4a42f31e0"},{"index":7354,"token":false,"name":"Voidslime","scryfallId":"7fcdf84e-0156-46ee-81a2-784fe60d6525"},{"index":7355,"token":false,"name":"Morale","scryfallId":"ef794248-812a-4c60-bc80-dd58b52db9d2"},{"index":7357,"token":false,"name":"Willbender","scryfallId":"7c35a94e-4449-4093-9652-5db0ec8b8bdd"},{"index":7358,"token":false,"name":"The Akroan War","scryfallId":"3471c130-a3e9-4bb7-9a0c-c22fb8fead28"},{"index":7359,"token":false,"name":"Vivien's Arkbow","scryfallId":"97a24162-6a95-4dcb-afe0-753b8680c456"},{"index":7360,"token":false,"name":"Sedge Scorpion","scryfallId":"66733fcb-fddc-4c15-bc51-c2cd42ac5a70"},{"index":7364,"token":false,"name":"Cabal Inquisitor","scryfallId":"c0530e09-5206-460e-abd2-e928eca294a5"},{"index":7365,"token":false,"name":"Blood Seeker","scryfallId":"8033de8d-a396-4097-aedd-f9facb800b33"},{"index":7367,"token":false,"name":"Timely Hordemate","scryfallId":"dcb3c08e-b591-421a-898a-533021cbabd2"},{"index":7368,"token":false,"name":"Happily Ever After","scryfallId":"802b088d-2b9f-4b88-b083-b550f775daf7"},{"index":7369,"token":false,"name":"Anti-Magic Aura","scryfallId":"54642f0e-2d5f-49eb-8181-054c84038072"},{"index":7370,"token":false,"name":"Dragonrage","scryfallId":"77b7bf2a-9d68-4aa8-a0b1-5df22a5a3c1b"},{"index":7371,"token":true,"name":"Beast Token (B, 3/3)","scryfallId":"fc48bf5f-5fe1-41ef-a63d-85daacd941f7"},{"index":7372,"token":false,"name":"Worldgorger Dragon","scryfallId":"9dae8fa6-c86e-492b-b28b-96d4ee83f6c6"},{"index":7373,"token":false,"name":"Selkie Hedge-Mage","scryfallId":"c879bd30-2209-4409-9e4d-3d65565ceddf"},{"index":7375,"token":false,"name":"Repudiate // Replicate","scryfallId":"f6200937-3146-4972-ab83-051ade3b7a52"},{"index":7376,"token":false,"name":"Abduction","scryfallId":"63c82bef-50d6-4d25-bc3f-dda2826fc99c"},{"index":7378,"token":false,"name":"Kor Cartographer","scryfallId":"6063b7ee-94ae-4a5b-9902-6aa0335af593"},{"index":7380,"token":false,"name":"Armageddon Clock","scryfallId":"ab55bb84-03c2-4989-8db4-0d5578ea0431"},{"index":7381,"token":false,"name":"Scaleguard Sentinels","scryfallId":"0df0389d-50f5-4acf-bb9b-b97fd9fa031f"},{"index":7382,"token":false,"name":"Hedge Troll","scryfallId":"2b2e6027-598d-4ba0-93ae-f76d031de8af"},{"index":7384,"token":false,"name":"Aegis Automaton","scryfallId":"e5f9fa2d-4bf4-4fcb-9b76-fd4a9ff5a58c"},{"index":7385,"token":false,"name":"Reckless Scholar","scryfallId":"d46f9dd3-45cc-4682-a6a0-99f67c0b73c6"},{"index":7386,"token":false,"name":"Kezzerdrix","scryfallId":"2744639b-f7fa-435b-9275-026eae1dd0b7"},{"index":7389,"token":false,"name":"Defender of Law","scryfallId":"9c8e8719-8c33-429d-8b95-b7f813888850"},{"index":7395,"token":false,"name":"Davriel's Shadowfugue","scryfallId":"09c8fe63-37a7-478d-b9ba-33a0f6519cf1"},{"index":7396,"token":false,"name":"Thought Harvester","scryfallId":"46f9eeb2-22f6-4bdb-bbf8-f53774cc6226"},{"index":7398,"token":false,"name":"Splendid Agony","scryfallId":"568b0f30-9e78-4f05-b562-77cd8b048c9e"},{"index":7399,"token":false,"name":"Terastodon","scryfallId":"32141ae3-0c1c-480c-8f61-90a46d5ce54c"},{"index":7400,"token":false,"name":"Feast of Flesh","scryfallId":"2d344791-5d5c-40c5-99c7-931954ea39d1"},{"index":7401,"token":false,"name":"Sengir Autocrat","scryfallId":"234a5401-bbe4-40ab-9204-12d944fbd2b1"},{"index":7402,"token":false,"name":"Oni of Wild Places","scryfallId":"647f0ced-564d-46d4-99f1-fcc2ddfb047d"},{"index":7404,"token":false,"name":"Harm's Way","scryfallId":"9c59d43e-0e07-4601-b6df-178010ea909f"},{"index":7405,"token":false,"name":"Beaming Defiance","scryfallId":"7e22411c-11c1-4770-8491-7952dd406e01"},{"index":7408,"token":false,"name":"Sealock Monster","scryfallId":"136eb37c-776c-46df-818a-d29088f0185c"},{"index":7409,"token":false,"name":"Woodweaver's Puzzleknot","scryfallId":"899d7420-f16d-4910-adf7-6deff47ecf1e"},{"index":7410,"token":false,"name":"Cadaver Imp","scryfallId":"1e20385c-a093-43a4-8573-68746b2d8d1e"},{"index":7413,"token":false,"name":"Runehorn Hellkite","scryfallId":"f5fd8668-900c-48d1-aac3-8355cfc0bb74"},{"index":7415,"token":false,"name":"Thragtusk","scryfallId":"a62f09c4-4ed2-429b-b8cc-a40c83fc60ff"},{"index":7418,"token":false,"name":"Magistrate's Veto","scryfallId":"2f83d39e-bf49-4968-829e-c0e9abf2fb86"},{"index":7420,"token":false,"name":"Boartusk Liege","scryfallId":"318338f8-f52b-4b9a-8d38-08291bcc2e98"},{"index":7422,"token":false,"name":"Flayer Husk","scryfallId":"20b394f9-644d-426e-801b-110774092018"},{"index":7423,"token":false,"name":"Uba Mask","scryfallId":"fa3ecb4e-d08f-4fac-8842-c3e772b95bd5"},{"index":7425,"token":false,"name":"Borderland Marauder","scryfallId":"41eaedf2-38be-4825-a711-3cc0f7659ae3"},{"index":7426,"token":false,"name":"Desolate Lighthouse","scryfallId":"16fb45bc-6152-4b01-9831-a8e80b1c1852"},{"index":7427,"token":false,"name":"Necromaster Dragon","scryfallId":"2435ef2c-7c3d-4d79-a1e1-bb120a6f1b7a"},{"index":7429,"token":false,"name":"Oblivion Sower","scryfallId":"9f3a5dea-0422-49f8-a35b-757ea500a52d"},{"index":7431,"token":true,"name":"Knight Token (W, 2/2)","scryfallId":"bf9acfe1-de7a-48fe-aed3-28a72db6d1c0"},{"index":7434,"token":false,"name":"Battlemage's Bracers","scryfallId":"1a14aad2-47f0-4d21-9fcf-5ca171faffaf"},{"index":7436,"token":false,"name":"Pendrell Flux","scryfallId":"34847e03-c529-415e-9d49-fd4647ca8892"},{"index":7437,"token":false,"name":"Exhumer Thrull","scryfallId":"c8c53fda-3768-4cc5-8ca3-a60805c340ba"},{"index":7438,"token":false,"name":"Vermin Gorger","scryfallId":"d3166b10-5bc3-4db6-bb5b-81045d98e446"},{"index":7439,"token":false,"name":"Viseling","scryfallId":"38a6105e-a67b-4805-b50c-dea404f60fac"},{"index":7440,"token":false,"name":"Clay Statue","scryfallId":"9064a52d-286e-40d7-91b8-8412afe85260"},{"index":7442,"token":true,"name":"Elemental Token (G/R, 5/5)","scryfallId":"ed666385-a2e7-4e1f-ad2c-babbfc0c50b3"},{"index":7443,"token":false,"name":"Azusa, Lost but Seeking","scryfallId":"1507b7bc-cf3d-42c7-a4c8-e5b22cea9ec0"},{"index":7452,"token":false,"name":"Jareth, Leonine Titan","scryfallId":"bf57d9ec-d161-4cb4-989b-72278bfdba4c"},{"index":7454,"token":false,"name":"Woolly Loxodon","scryfallId":"9fbd0dab-5714-42f1-8626-e6759a8a1aa3"},{"index":7455,"token":false,"name":"Blanchwood Treefolk","scryfallId":"f824502c-d712-41af-ba44-33e8294c3735"},{"index":7456,"token":false,"name":"Marble Diamond","scryfallId":"72125260-f4b7-4317-99f1-cbb78646296d"},{"index":7457,"token":false,"name":"Bartizan Bats","scryfallId":"23795291-5acc-465f-aa02-95ead947ced8"},{"index":7458,"token":false,"name":"Crackling Doom","scryfallId":"f83c7d53-2599-42a9-ae96-a2699c5164cb"},{"index":7459,"token":false,"name":"Vaevictis Asmadi, the Dire","scryfallId":"d19fdc00-21eb-48dc-966a-6b634dc5a2c4"},{"index":7460,"token":false,"name":"Sanctifier of Souls","scryfallId":"cbe2aaa5-1b87-4ede-a85d-ae85e88c61f5"},{"index":7461,"token":false,"name":"Soulsurge Elemental","scryfallId":"d0dcb81b-dcdb-44ca-9ef5-0b45d276c0dd"},{"index":7463,"token":false,"name":"Lord of the Accursed","scryfallId":"3941562d-3e39-4746-9a18-d3aa6d3468b0"},{"index":7465,"token":false,"name":"Lord of the Void","scryfallId":"75b83fe5-fd00-4532-bc67-07836abfc99c"},{"index":7466,"token":false,"name":"Firewake Sliver","scryfallId":"5d3f5a0d-029e-44fd-b3e6-c70176b5b4ac"},{"index":7467,"token":false,"name":"Open the Armory","scryfallId":"6db45698-9da9-4cea-b9bf-0f84ab276b51"},{"index":7469,"token":false,"name":"Ash Barrens","scryfallId":"3ef8d765-b799-463b-a003-caee721df354"},{"index":7472,"token":false,"name":"Mistblade Shinobi","scryfallId":"d1868a23-0c36-4302-b983-caf0a1023669"},{"index":7473,"token":false,"name":"Impending Disaster","scryfallId":"44497303-9686-4810-bf0f-876dd9696cab"},{"index":7475,"token":false,"name":"Pouncing Kavu","scryfallId":"7e6e2e49-7bde-43c1-8caf-43d237dfc052"},{"index":7476,"token":false,"name":"Seasons Past","scryfallId":"87711595-6f91-4f55-9146-e71143354bb3"},{"index":7477,"token":false,"name":"Endless Wurm","scryfallId":"53772435-e20e-4b9e-a2f1-c1c6a4dcac79"},{"index":7478,"token":false,"name":"Balduvian Trading Post","scryfallId":"a329ff98-36fd-44c3-b037-dcc6e78ee61e"},{"index":7479,"token":false,"name":"Clock of Omens","scryfallId":"5b087992-9c30-4434-acb3-a12ee6f207b3"},{"index":7480,"token":false,"name":"Vesuva","scryfallId":"82fc9498-7397-4857-87fe-7c9010944ed8"},{"index":7481,"token":false,"name":"Clot Sliver","scryfallId":"5cfcd459-23e8-4207-b896-55062ef30a23"},{"index":7482,"token":false,"name":"Haunting Voyage","scryfallId":"cccb5f07-69ba-475f-8b91-9a5e1cd58594"},{"index":7483,"token":false,"name":"Dead // Gone","scryfallId":"45b090c7-f1ba-4656-8b51-915fc1876922"},{"index":7484,"token":false,"name":"Etched Champion","scryfallId":"ab2242c2-7379-4fff-a745-d180685da6db"},{"index":7485,"token":false,"name":"Eland Umbra","scryfallId":"f3a2ec16-bee4-4dfd-81cb-cb81b017170c"},{"index":7487,"token":false,"name":"Academic Probation","scryfallId":"545011ff-848c-46b3-9d56-0d82b11fa7b6"},{"index":7488,"token":false,"name":"Skyclave Cleric // Skyclave Basilica","scryfallId":"014027c4-7f9d-4096-b308-ea4be574c0d4"},{"index":7489,"token":false,"name":"Razorfin Hunter","scryfallId":"5159d6fd-87cf-455d-ae18-0300b68485b6"},{"index":7491,"token":false,"name":"Skittering Monstrosity","scryfallId":"fb6f872f-adfa-4d29-87df-9d39fb06b5be"},{"index":7492,"token":false,"name":"Lightning Berserker","scryfallId":"3285cb6f-a9c0-4195-b6b2-3f33a16eaa01"},{"index":7493,"token":false,"name":"Bloodfire Dwarf","scryfallId":"86b5c38e-7d74-4862-8187-f5db4a3d1e0f"},{"index":7494,"token":false,"name":"Finale of Eternity","scryfallId":"90188f56-fad8-4d4c-936f-db80a09b167f"},{"index":7495,"token":false,"name":"Mistral Singer","scryfallId":"d961c441-b76b-4bd8-b510-a3e073207a1b"},{"index":7496,"token":false,"name":"Treespring Lorian","scryfallId":"f525d7ce-37d3-4989-beb4-173447cb5294"},{"index":7497,"token":false,"name":"Blaze of Glory","scryfallId":"edb6fd83-5fc8-4caf-a2cb-d87ab4b70fe1"},{"index":7498,"token":false,"name":"Ascended Lawmage","scryfallId":"b1f00799-80ce-431e-97bb-8bb4e0e8ba49"},{"index":7499,"token":false,"name":"Vega, the Watcher","scryfallId":"28fced7f-3078-4a54-8f76-0ef14c732e97"},{"index":7500,"token":false,"name":"Nylea's Intervention","scryfallId":"45c8e04d-f2cf-43d5-8fbd-f74550940fd3"},{"index":7502,"token":false,"name":"Mist Raven","scryfallId":"c0ea1af2-e86d-4c62-92b1-55473b622592"},{"index":7503,"token":false,"name":"Noxious Grasp","scryfallId":"8e5758cc-1f84-455d-a983-8ec471727eaf"},{"index":7504,"token":false,"name":"Shattered Ego","scryfallId":"191d1ab9-cd9e-4351-9acd-d7a57b963253"},{"index":7505,"token":false,"name":"Goblin Festival","scryfallId":"ac067eb8-427f-4bfa-b392-0bb41ac8370e"},{"index":7506,"token":false,"name":"Shivan Zombie","scryfallId":"f4c99269-f730-4d33-bbce-9e855e9ad0fc"},{"index":7507,"token":false,"name":"End-Raze Forerunners","scryfallId":"a50d79fe-6d37-42f3-b7b0-0c3018282fa2"},{"index":7509,"token":false,"name":"Crawling Barrens","scryfallId":"954e1d00-cc8e-49ae-9dc7-bd50f0acf6d3"},{"index":7511,"token":false,"name":"Asylum Visitor","scryfallId":"f7b601c3-eb95-4140-8550-4a1ec616a0fa"},{"index":7512,"token":false,"name":"Nicol Bolas, Planeswalker","scryfallId":"605a6165-bf78-486b-b186-6a55e0ffe28f"},{"index":7513,"token":false,"name":"Jor Kadeen, the Prevailer","scryfallId":"ceb9bf41-5995-46a9-be37-a105cf8812a4"},{"index":7516,"token":false,"name":"Mists of Littjara","scryfallId":"6cfd4944-790f-4835-a8a1-c23ef7047648"},{"index":7517,"token":false,"name":"Goblin Spelunkers","scryfallId":"6c3889c5-3321-486c-b03c-8607f2393a75"},{"index":7518,"token":false,"name":"Linvala, Keeper of Silence","scryfallId":"82b80a09-7e75-4091-a60e-04aff79339a3"},{"index":7519,"token":false,"name":"Slaughter Pact","scryfallId":"dd740d1d-ad70-47de-aef1-aec5ab2135d2"},{"index":7520,"token":false,"name":"Foresee","scryfallId":"c0bd95b5-1e90-41c5-8a9f-f3009f3f504a"},{"index":7521,"token":false,"name":"Metrognome","scryfallId":"d71f153d-2d07-4a8a-b725-747bb96afe00"},{"index":7522,"token":false,"name":"Seedborn Muse","scryfallId":"3927cd85-9ee9-4f3c-b92e-8c860136283b"},{"index":7523,"token":false,"name":"Jace's Sentinel","scryfallId":"9131361b-ec1e-4390-82c9-b9b9f77792a8"},{"index":7524,"token":false,"name":"Prickleboar","scryfallId":"e6da2545-e2f5-40e6-bb92-3bc1822695ae"},{"index":7526,"token":false,"name":"Calciderm","scryfallId":"e0d4b681-9f20-4bb5-8a6d-552f069e577f"},{"index":7527,"token":false,"name":"Anaba Shaman","scryfallId":"f3c2a5d1-cdf0-4551-aad0-c6590fb3c018"},{"index":7528,"token":false,"name":"Mirror of the Forebears","scryfallId":"7af172c3-03ed-4586-9fb4-490a069d9d3f"},{"index":7529,"token":false,"name":"Mistform Sliver","scryfallId":"79a53c29-6753-4f6b-b4ee-00c1adf7e9c6"},{"index":7530,"token":false,"name":"Parhelion Patrol","scryfallId":"eef126f2-7e72-4338-8021-3ad95e4ab982"},{"index":7535,"token":false,"name":"Keeper of the Mind","scryfallId":"7bc232d4-ab4f-4d88-a9ec-72403d05ec04"},{"index":7536,"token":false,"name":"Undead Warchief","scryfallId":"01482b0c-d05b-4356-9144-e044159f4dcb"},{"index":7538,"token":false,"name":"Cabal Coffers","scryfallId":"8d941af4-fa5d-4b5b-9930-8066aeace254"},{"index":7540,"token":false,"name":"Johan","scryfallId":"2f2f3b3e-63f3-4cab-aa95-030990157ed5"},{"index":7542,"token":false,"name":"Quicksilver Amulet","scryfallId":"ecfdebbe-6432-426f-ac2a-5a9af3047813"},{"index":7543,"token":false,"name":"Figure of Destiny","scryfallId":"6add511b-1931-4e4e-9a4c-083bc5ff2bc2"},{"index":7544,"token":false,"name":"Vulshok Replica","scryfallId":"32885a6c-b293-405f-9f2e-9e0dd7d1cb8c"},{"index":7545,"token":false,"name":"Binding the Old Gods","scryfallId":"d93ee644-d7d7-48d8-a04b-fb479b74edb0"},{"index":7546,"token":false,"name":"Spark Elemental","scryfallId":"f9a8ddf2-03f8-4e6f-8dbb-0e09e1717221"},{"index":7548,"token":false,"name":"Howling Golem","scryfallId":"775ab60a-2dc1-44fc-8022-f7becd8ee195"},{"index":7550,"token":false,"name":"Dimir House Guard","scryfallId":"9a021caf-d9e7-470b-85be-3af42a3adfd3"},{"index":7552,"token":false,"name":"Lay of the Land","scryfallId":"90b10608-8917-4337-ad60-ab31ab8c0fc4"},{"index":7553,"token":false,"name":"Fog Bank","scryfallId":"2f234849-42c7-4862-aee1-863a77eeacb7"},{"index":7554,"token":false,"name":"Cease-Fire","scryfallId":"1646c998-aee5-497f-bd75-24ced1dabef9"},{"index":7557,"token":false,"name":"Shrink","scryfallId":"c4e319d7-53f3-40e8-9a75-fe1fd8716733"},{"index":7558,"token":false,"name":"Dire Fleet Poisoner","scryfallId":"bb8f2fbe-e4f2-45e7-8cd1-a20f59f1859f"},{"index":7561,"token":false,"name":"Enrage","scryfallId":"a519d526-440c-4b12-90f3-6467a1fbfbbf"},{"index":7565,"token":true,"name":"Salamander Warrior Token (U, 4/3)","scryfallId":"4c0a6832-677f-4226-bd8d-f93eeeffd02d"},{"index":7566,"token":false,"name":"Voracious Wurm","scryfallId":"da15100b-2934-438c-9917-84ad8bdc4181"},{"index":7567,"token":false,"name":"Galvanic Blast","scryfallId":"cf528b2b-fb72-4751-9a1c-ad3f9015a1a1"},{"index":7568,"token":false,"name":"Monk Idealist","scryfallId":"00a9bcaf-47ea-406e-ac51-e68ba181214a"},{"index":7569,"token":false,"name":"Fascination","scryfallId":"6b23b3f9-d363-4113-a477-ea8ff86ee6e3"},{"index":7570,"token":false,"name":"Yorvo, Lord of Garenbrig","scryfallId":"ae2998a1-1713-467e-a08e-0efd8720aa5b"},{"index":7571,"token":false,"name":"Star Compass","scryfallId":"b1d0beb4-c3dd-4bb1-b49b-a48b2d4ad38d"},{"index":7575,"token":false,"name":"Angel of Renewal","scryfallId":"0b5f5162-d024-41ac-9f91-1c5d4394718e"},{"index":7577,"token":false,"name":"Faerie Mechanist","scryfallId":"3dc5a5af-6599-4a29-8c4e-1fdf7e920046"},{"index":7578,"token":false,"name":"Herdchaser Dragon","scryfallId":"5fb84323-b6f7-43ea-baf1-3e29b33b680d"},{"index":7580,"token":false,"name":"Uthden Troll","scryfallId":"18bd9ec1-4784-4b8d-bdeb-8df4b91c954f"},{"index":7582,"token":false,"name":"Lunar Mystic","scryfallId":"c8a32b4b-4b8d-40e0-9166-06a678fd6e06"},{"index":7587,"token":false,"name":"Thallid","scryfallId":"ba7b31c0-45d0-44e6-961b-fa8108e571e3"},{"index":7589,"token":false,"name":"Evil Twin","scryfallId":"7b1969ce-3bf1-4beb-bbf8-22edfda8e3f8"},{"index":7592,"token":false,"name":"Withering Gaze","scryfallId":"0e952a48-9e60-4fce-8423-7f0bafd29bb1"},{"index":7593,"token":false,"name":"Wolf Pack","scryfallId":"290f395d-0827-4f62-b117-4766d4ab5dca"},{"index":7597,"token":false,"name":"Treacherous Werewolf","scryfallId":"c9647726-302b-4fc4-91d7-2aa0bba0b653"},{"index":7600,"token":false,"name":"Elvish Piper","scryfallId":"5666cb39-5fea-4eaa-a6da-1b2ffc5a3811"},{"index":7602,"token":false,"name":"Order of the Ebon Hand","scryfallId":"4e5b869d-26e8-493d-9081-febf3eb919cb"},{"index":7603,"token":false,"name":"Freyalise's Winds","scryfallId":"b11cd2e0-9419-4267-807e-5b73915c748a"},{"index":7604,"token":false,"name":"Narcomoeba","scryfallId":"09cd1219-f6e1-47ba-bc05-4f0603d56835"},{"index":7605,"token":false,"name":"Alaborn Musketeer","scryfallId":"4776a9ed-dbc6-44d2-9761-b2d09ff34008"},{"index":7606,"token":false,"name":"Wooded Bastion","scryfallId":"4927d717-b2c4-46c0-af2c-e507d0c85cdd"},{"index":7607,"token":false,"name":"Akroma's Memorial","scryfallId":"d2cb3bdf-dff5-4285-ad67-ae7ca84c9fbc"},{"index":7608,"token":false,"name":"Teyo, the Shieldmage","scryfallId":"9fe8ca73-388c-429f-8c75-afb5839cfb42"},{"index":7611,"token":false,"name":"Creeping Mold","scryfallId":"277b549c-8691-42b2-9867-802b158a506c"},{"index":7612,"token":false,"name":"Runeclaw Bear","scryfallId":"58b12b9c-2e3f-4c86-b7a6-73bbe97eaaab"},{"index":7613,"token":false,"name":"Devouring Deep","scryfallId":"0855a5a8-8c40-4396-9ad1-8fa0fc6a0c59"},{"index":7616,"token":false,"name":"Saddleback Lagac","scryfallId":"19673455-8655-4135-a7b3-5995fee8b281"},{"index":7620,"token":false,"name":"Transmogrify","scryfallId":"7f6252e7-aa4f-4d7b-a655-6564c5c124e6"},{"index":7622,"token":false,"name":"Grizzly Bears","scryfallId":"e921b721-74c3-4f25-8593-ff5685a74a91"},{"index":7623,"token":false,"name":"Nemesis Trap","scryfallId":"20a9f5cb-3139-4c6e-a2d4-69e1659b8db2"},{"index":7624,"token":false,"name":"Spawn of Thraxes","scryfallId":"24d4a5fa-b867-4e29-a8e2-3231698a9fca"},{"index":7625,"token":false,"name":"Throne Warden","scryfallId":"2b0e11c0-5347-4241-9a7e-f1a266d058c2"},{"index":7626,"token":false,"name":"Stalker Hag","scryfallId":"5c0eed33-553a-4865-9b22-30c33fbd1c51"},{"index":7627,"token":false,"name":"Eidolon of Blossoms","scryfallId":"8cfdec45-122b-462b-960c-bacca4a5d0f2"},{"index":7628,"token":false,"name":"War-Torch Goblin","scryfallId":"259469b3-1212-4030-97ae-a84f132798d4"},{"index":7630,"token":false,"name":"Mystic of the Hidden Way","scryfallId":"7aa17b98-8347-48ab-8ed3-d1f12e5e5309"},{"index":7634,"token":false,"name":"Kindred Discovery","scryfallId":"e0d80c4e-ab81-4aa4-9b89-791675afd615"},{"index":7637,"token":false,"name":"Bone to Ash","scryfallId":"db7a29e0-02a8-4d04-8b80-831a7bed58f7"},{"index":7639,"token":false,"name":"Chartooth Cougar","scryfallId":"d1aff81b-9c70-4447-b391-5de982e84cce"},{"index":7642,"token":false,"name":"Weldfast Monitor","scryfallId":"fcecfd0d-6d2b-40e9-b5bc-9303ff455689"},{"index":7644,"token":false,"name":"Covert Operative","scryfallId":"dbda6799-3b55-4714-8305-713e1e198a15"},{"index":7645,"token":false,"name":"Rimewood Falls","scryfallId":"da1db084-f235-4e26-8867-5f0835a0d283"},{"index":7646,"token":false,"name":"Ulvenwald Mysteries","scryfallId":"460c1bc0-e420-4c38-9460-cd4ee13d5396"},{"index":7648,"token":false,"name":"Djinn Illuminatus","scryfallId":"3e39a2b4-fa70-4572-8480-533bdbf6293a"},{"index":7650,"token":true,"name":"Assassin Token (B, 1/1)","scryfallId":"b7e997ac-5a4a-4555-9b37-06c25a5db356"},{"index":7651,"token":false,"name":"Midnight Guard","scryfallId":"87c1d85d-b2b8-4c9d-84fa-2566b14cb5ea"},{"index":7652,"token":false,"name":"Plagiarize","scryfallId":"80eccbe9-f197-4ec0-b8c1-45a36a063e30"},{"index":7654,"token":false,"name":"Foul Emissary","scryfallId":"41446e3b-ecd1-442f-9209-713f0abfc538"},{"index":7655,"token":false,"name":"Nourish","scryfallId":"0597dd97-fe6f-4e74-88e5-35528ada0140"},{"index":7656,"token":false,"name":"Word of Blasting","scryfallId":"c5362ead-9162-4160-bfa9-432f7d0e222d"},{"index":7657,"token":false,"name":"Kardur, Doomscourge","scryfallId":"9685e2a0-5573-41bc-a914-f40c3011459b"},{"index":7658,"token":false,"name":"Disrupt","scryfallId":"c000a02f-6b7e-4925-a938-59e645e980d7"},{"index":7662,"token":false,"name":"Lost Hours","scryfallId":"4dfff4a8-43ae-41d4-acca-998234f9df35"},{"index":7666,"token":false,"name":"Stampeding Wildebeests","scryfallId":"b0912be9-afa5-4ca9-940a-682df7f993fd"},{"index":7668,"token":false,"name":"Memory Erosion","scryfallId":"79defdbc-fd05-46e2-8340-5c3e75b21545"},{"index":7670,"token":false,"name":"Dance with Devils","scryfallId":"f1112ebe-2a42-48b9-b0e5-f708305d088a"},{"index":7672,"token":false,"name":"Suffocation","scryfallId":"d22104df-8147-45fd-897a-f99a815be062"},{"index":7673,"token":false,"name":"Magmatic Force","scryfallId":"e98eb29b-af03-4a96-b84c-a0bd51f80f03"},{"index":7674,"token":false,"name":"Garenbrig Paladin","scryfallId":"8445020a-6fab-47dd-9e57-886c28f68b3f"},{"index":7675,"token":false,"name":"River Heralds' Boon","scryfallId":"e355a98d-093d-4ab2-84f2-f560d08f1fca"},{"index":7676,"token":false,"name":"Megatog","scryfallId":"2e9734b1-c5fb-4b2b-bada-c45c3a725e01"},{"index":7677,"token":false,"name":"Harvester of Souls","scryfallId":"7008d740-e22b-4462-868b-dc3b08d11ff4"},{"index":7678,"token":false,"name":"Plague Myr","scryfallId":"8f932690-9a38-4a3f-8805-a192208152a3"},{"index":7679,"token":false,"name":"Victimize","scryfallId":"855e9253-2219-4c43-8131-47633c564ee2"},{"index":7680,"token":false,"name":"Shaman of Spring","scryfallId":"8e974df6-d78a-43ea-ada5-17c53fcca97b"},{"index":7681,"token":false,"name":"Supply // Demand","scryfallId":"d4628887-bda4-47e4-84d1-d31a8298f9e5"},{"index":7682,"token":false,"name":"Phylath, World Sculptor","scryfallId":"e7af88c9-70ca-484c-bddf-b705e0ea7bc7"},{"index":7684,"token":false,"name":"Conspicuous Snoop","scryfallId":"5955db79-e235-41a8-b287-918551923e6c"},{"index":7685,"token":false,"name":"Condescend","scryfallId":"9f53ae73-b3e7-4e24-8e9b-2206d126b844"},{"index":7687,"token":false,"name":"Oashra Cultivator","scryfallId":"209f0f09-0b16-420e-ac34-b3313ebe8cdb"},{"index":7688,"token":false,"name":"Crystal Ball","scryfallId":"56dc98fb-a956-46f7-aca2-97929b4236ee"},{"index":7689,"token":false,"name":"Basic Conjuration","scryfallId":"4f222fdb-eddd-4179-b779-a45171bfb010"},{"index":7692,"token":false,"name":"Sparkhunter Masticore","scryfallId":"85c25bcb-0b13-46df-9b51-e11f781476e0"},{"index":7693,"token":false,"name":"Clockwork Gnomes","scryfallId":"f74a8952-fad0-40c3-88eb-3cc05acaf590"},{"index":7696,"token":false,"name":"Greater Auramancy","scryfallId":"1177787f-bf1e-438b-9615-97d03b04128c"},{"index":7697,"token":false,"name":"Rabid Wombat","scryfallId":"f5dbfeb2-76ac-48b2-99fb-fa4bcc59b2a5"},{"index":7699,"token":false,"name":"Gray Ogre","scryfallId":"c2353776-6cc8-4cb3-9608-6ed4aa5bdd1b"},{"index":7700,"token":false,"name":"Pride of Lions","scryfallId":"65c3274b-3eb0-450a-88bf-fb378e6cf94a"},{"index":7701,"token":false,"name":"Pollenbright Druid","scryfallId":"382fb8a8-8298-4383-9304-6db9c6711f3d"},{"index":7703,"token":false,"name":"Singing Tree","scryfallId":"3003bf1e-8085-45d8-882b-c449109e7631"},{"index":7704,"token":false,"name":"Bite of the Black Rose","scryfallId":"254d1363-1204-41d2-9799-34484a3eb211"},{"index":7705,"token":false,"name":"Steady Aim","scryfallId":"4af6a1b5-a561-4d92-b429-de13b2ccaf81"},{"index":7708,"token":false,"name":"Invert the Skies","scryfallId":"d6d0a6f9-478f-43c7-8591-3b601c12ed01"},{"index":7710,"token":false,"name":"Vizkopa Guildmage","scryfallId":"41f505a3-2c54-43a9-b4a9-43a1451b36f6"},{"index":7711,"token":false,"name":"Spontaneous Mutation","scryfallId":"6919154c-154e-4430-b7fd-ab9fe70326dc"},{"index":7715,"token":false,"name":"Drana's Emissary","scryfallId":"99e82d47-9bbb-4bf9-a935-2c0b27b64a84"},{"index":7716,"token":false,"name":"Death of a Thousand Stings","scryfallId":"a31ca907-a274-436e-8433-7f11b0303f75"},{"index":7719,"token":false,"name":"Bearer of the Heavens","scryfallId":"061d9fa5-a8e0-4263-9804-22d648554eba"},{"index":7722,"token":false,"name":"Tandem Lookout","scryfallId":"a9953e53-3d56-4129-8fab-df33c69b8a95"},{"index":7725,"token":false,"name":"Horizon Canopy","scryfallId":"93f7c880-9bae-4d29-b7b6-b6be6b2ffa89"},{"index":7726,"token":false,"name":"Lightning Talons","scryfallId":"8fc1ad4c-b394-48b9-9a5a-ec9f42bf6a00"},{"index":7729,"token":false,"name":"Borderland Behemoth","scryfallId":"34dee9d2-8369-44e0-83b8-7a209693cdd4"},{"index":7730,"token":false,"name":"Temporal Adept","scryfallId":"0ff2dfe6-dbc0-46c3-9d5c-9f0ba6f511ec"},{"index":7732,"token":false,"name":"Visions of Beyond","scryfallId":"75657d26-b0f8-4892-8684-533c103c921d"},{"index":7734,"token":false,"name":"Aligned Hedron Network","scryfallId":"b41cecd5-85d0-402a-ae50-a31b397c1fa4"},{"index":7736,"token":false,"name":"Nykthos, Shrine to Nyx","scryfallId":"834b27a0-dfd7-4f96-8cde-cacac4b24acc"},{"index":7750,"token":true,"name":"Gold","scryfallId":"9b180a33-65ef-43b3-b969-f603b1fc23fb"},{"index":7751,"token":false,"name":"Soulcatchers' Aerie","scryfallId":"b30df994-bb09-4d16-8443-223c6ce342dc"},{"index":7754,"token":false,"name":"Elvish Archdruid","scryfallId":"99f37891-fac7-4868-a20b-0e879f7e0859"},{"index":7756,"token":false,"name":"Reflections of Littjara","scryfallId":"4ebaa07d-68f6-4cdb-a5cd-cd715e50abf5"},{"index":7760,"token":false,"name":"Bathe in Light","scryfallId":"a7bd976e-56c7-482e-8d2f-073b0b589274"},{"index":7761,"token":false,"name":"Hum of the Radix","scryfallId":"328f3afb-1a56-42a5-bd1e-3e704291972f"},{"index":7763,"token":false,"name":"Tezzeret the Schemer","scryfallId":"c10e9fdf-8a51-4bc2-95bf-b88f6969f959"},{"index":7767,"token":false,"name":"Merfolk Assassin","scryfallId":"36313dc7-6bf2-4d73-b696-969d984a7466"},{"index":7769,"token":false,"name":"Labyrinth of Skophos","scryfallId":"ff0dd221-2660-43f6-8e28-8000e3fe72a4"},{"index":7771,"token":false,"name":"Zur the Enchanter","scryfallId":"1dd33e67-3bf5-41cf-a552-1db6a28b8561"},{"index":7773,"token":false,"name":"Jolt","scryfallId":"3e0c085a-e17d-4003-bb58-f97555365fcf"},{"index":7774,"token":false,"name":"Bruse Tarl, Boorish Herder","scryfallId":"f988e82c-73a3-45a2-b257-386545f496e2"},{"index":7776,"token":false,"name":"Digsite Engineer","scryfallId":"0050be51-8c4e-4b97-b171-ede5fadfd141"},{"index":7777,"token":false,"name":"Stitch Together","scryfallId":"b7ee82ac-08e3-45e3-9817-0369a4ae72db"},{"index":7779,"token":false,"name":"Goblin Engineer","scryfallId":"31f675f6-df29-4b90-a5e6-26d915fdc6a1"},{"index":7780,"token":false,"name":"Alloy Golem","scryfallId":"1fb6d6a1-9d71-405b-9c93-1a7f06c67abd"},{"index":7781,"token":false,"name":"Necrogoyf","scryfallId":"f200ea9a-198b-4ba2-ad2b-ea4a133b7f40"},{"index":7783,"token":false,"name":"Surge Mare","scryfallId":"9002d0f1-ff2c-4d1c-a7db-3252ef6bebbd"},{"index":7785,"token":false,"name":"Argivian Archaeologist","scryfallId":"ce83a3cb-467d-44f6-a051-4855c8cf52a6"},{"index":7786,"token":false,"name":"Safeguard","scryfallId":"2c8e174c-7abb-4a93-aa1d-8c2a2e815ba6"},{"index":7790,"token":false,"name":"Faultgrinder","scryfallId":"be88b32a-986c-4317-b4a3-119f67e13b83"},{"index":7791,"token":false,"name":"Smelt","scryfallId":"4592b9c5-61bc-436c-91ce-ec1c4d2b484f"},{"index":7794,"token":false,"name":"Ice Cage","scryfallId":"a5e14b62-c050-4d43-aeee-873f46d1e295"},{"index":7795,"token":true,"name":"Jakub Šlemr Bio (1999)","scryfallId":"966b93ba-f671-4244-b879-aa20b355775a"},{"index":7796,"token":false,"name":"Peer Pressure","scryfallId":"be0110ba-49e4-4729-8a84-4d408b20df53"},{"index":7798,"token":false,"name":"Chaos Warp","scryfallId":"c144b325-53a3-4590-beb1-2a39cbced47e"},{"index":7799,"token":false,"name":"Voltaic Brawler","scryfallId":"0d5b5141-7437-4779-af68-737672217d77"},{"index":7800,"token":false,"name":"Riftsweeper","scryfallId":"785d5a98-97b2-4a9e-83ee-2a74479add7b"},{"index":7803,"token":false,"name":"One Dozen Eyes","scryfallId":"451f317f-f587-4187-9e02-6ac5d7ae9cd8"},{"index":7804,"token":false,"name":"Shrieking Specter","scryfallId":"81d3b0fd-a81e-4665-bba6-b6d085693abf"},{"index":7806,"token":false,"name":"Budoka Pupil // Ichiga, Who Topples Oaks","scryfallId":"73636ca0-2309-4bb3-9300-8bd0c0bb5b31"},{"index":7808,"token":false,"name":"Borderland Minotaur","scryfallId":"9c7f6eb2-feae-4dc9-a009-0ad60f89a592"},{"index":7809,"token":false,"name":"Overwhelm","scryfallId":"91d7d3ca-8e0d-43ce-9cdb-310d017873ca"},{"index":7811,"token":false,"name":"Forbid","scryfallId":"267738fd-234f-47a4-bc3c-35872b7e2cb0"},{"index":7812,"token":false,"name":"Chasm Guide","scryfallId":"fbd0fad7-264d-40fc-a616-a88dc94fa4d7"},{"index":7815,"token":false,"name":"Zombie Apocalypse","scryfallId":"756119c5-f10e-431b-9f8b-5da5850a72fd"},{"index":7818,"token":false,"name":"Mangara of Corondor","scryfallId":"a785b66c-c5a4-4520-a9fa-aa199f7f56e5"},{"index":7819,"token":false,"name":"Icatian Moneychanger","scryfallId":"cf9521ae-6fac-4d86-9c60-adecaae5687d"},{"index":7825,"token":false,"name":"Guardian Gladewalker","scryfallId":"587eed42-5111-4161-9af5-bf76556c542a"},{"index":7826,"token":false,"name":"Jade Leech","scryfallId":"3392171d-ed25-46a1-91cc-a4f24537617d"},{"index":7827,"token":false,"name":"Zetalpa, Primal Dawn","scryfallId":"f557ebfc-6fa2-4512-9d46-b6a2b0464eeb"},{"index":7828,"token":false,"name":"Bladewing the Risen","scryfallId":"2bd3e13d-53f8-42bf-aa83-09a9ca94a9f0"},{"index":7830,"token":false,"name":"Growing Rites of Itlimoc // Itlimoc, Cradle of the Sun","scryfallId":"7ea26869-d923-42e1-9b34-3993f63f64b4"},{"index":7835,"token":false,"name":"Feldon's Cane","scryfallId":"fe3a92db-10be-4e80-8728-dfeecd160b1d"},{"index":7837,"token":false,"name":"Behold the Multiverse","scryfallId":"27855a38-a682-4f97-ad22-ac625e86faec"},{"index":7838,"token":false,"name":"Kiln Fiend","scryfallId":"6c957c94-3d2d-4b98-8990-cd8909462081"},{"index":7839,"token":false,"name":"Delirium","scryfallId":"c52981ea-1173-4f4b-a929-705a11c6e381"},{"index":7842,"token":false,"name":"Scholar of the Lost Trove","scryfallId":"aa254a86-3c30-408d-9c14-befd472f9740"},{"index":7843,"token":false,"name":"Noble Hierarch","scryfallId":"77cc142c-9e74-4bc0-ae3a-a7699cf516ee"},{"index":7847,"token":false,"name":"Frogify","scryfallId":"d89be5f5-75d4-42a0-81e9-5da5bf868e73"},{"index":7848,"token":false,"name":"Ashen Powder","scryfallId":"686aebd0-0d34-47e3-bbbd-ad08d2a3a864"},{"index":7849,"token":false,"name":"Aurelia, Exemplar of Justice","scryfallId":"8a230f8e-08c2-4d3e-af01-ea37fe212d8b"},{"index":7851,"token":false,"name":"Golem's Heart","scryfallId":"538edc3c-973a-4d58-8318-32ce366401fe"},{"index":7854,"token":false,"name":"Alexi, Zephyr Mage","scryfallId":"6f8fc0b0-4a23-47ed-b61b-a4505fcfc5d2"},{"index":7856,"token":false,"name":"Incremental Blight","scryfallId":"f2633f1c-0563-4b3d-bab0-415757bc5ecd"},{"index":7859,"token":false,"name":"Gutterbones","scryfallId":"6a1c710b-bd67-4174-ab02-6ae98a7575ac"},{"index":7860,"token":false,"name":"Nameless Race","scryfallId":"348a467a-4661-4fdb-af1d-9171a1a930d9"},{"index":7861,"token":false,"name":"Reflect Damage","scryfallId":"3a2bf39b-9665-426b-b618-eb731d24a1ee"},{"index":7862,"token":false,"name":"Gruul Guildgate","scryfallId":"99c54269-8798-4023-836f-640103e08ce0"},{"index":7863,"token":false,"name":"Guttural Response","scryfallId":"e0662ab6-b475-4b8d-ae77-a9b654e611da"},{"index":7870,"token":false,"name":"Griffin Sentinel","scryfallId":"b40d6626-a85f-4116-9721-19e39b83cba0"},{"index":7871,"token":false,"name":"Phantasmal Abomination","scryfallId":"40d9c83f-ddd2-4929-887f-9df6155c4b82"},{"index":7872,"token":false,"name":"Fertilid","scryfallId":"9c6b39b9-0615-4899-8de2-b579d5b12f1c"},{"index":7874,"token":false,"name":"Swallowing Plague","scryfallId":"ac549d51-3862-4eb0-9951-f13a8ba28822"},{"index":7875,"token":false,"name":"Anguished Unmaking","scryfallId":"2cef491b-1838-473c-949e-671e8aae8585"},{"index":7876,"token":false,"name":"Blaze","scryfallId":"26f8c6ab-ae62-4e2e-a5ba-2ec5bbe22445"},{"index":7877,"token":false,"name":"Netherborn Altar","scryfallId":"541151af-f1a3-494f-858e-2c3fe447e036"},{"index":7878,"token":false,"name":"Silumgar Scavenger","scryfallId":"047fd05e-7545-4148-b3d7-eccf72ae43fb"},{"index":7879,"token":false,"name":"Noxious Groodion","scryfallId":"b6cb3d78-1a60-4e9b-b387-afeb58677536"},{"index":7883,"token":false,"name":"Centaur Garden","scryfallId":"ca041d5e-c65f-4e7e-ae4f-9c748a069aa3"},{"index":7884,"token":false,"name":"Kudzu","scryfallId":"789965c4-f3c8-4ef3-8854-9b4016356d20"},{"index":7885,"token":false,"name":"Urza's Armor","scryfallId":"e40375cf-8649-4f06-9e08-f0577f35d1bf"},{"index":7887,"token":false,"name":"Goblin Elite Infantry","scryfallId":"3f5b7dfe-f24b-4d73-813f-f63c926f3672"},{"index":7891,"token":false,"name":"It of the Horrid Swarm","scryfallId":"2e9160cb-d3de-49ca-a97d-2cd259cd5447"},{"index":7892,"token":false,"name":"The World Tree","scryfallId":"999fa01b-4e54-4e3e-973d-7af137a53684"},{"index":7893,"token":false,"name":"Mirri, Cat Warrior","scryfallId":"2c4a6ac2-bec1-4d01-8d7c-e8fd43bd9e4d"},{"index":7896,"token":false,"name":"Ichor Wellspring","scryfallId":"03c16dfb-7e7a-4372-a1e2-8eb06d890c5c"},{"index":7897,"token":false,"name":"Bolas's Citadel","scryfallId":"bb6e5c8c-2c03-45b2-a0c0-e3a365e2fead"},{"index":7898,"token":false,"name":"Dusk Legion Zealot","scryfallId":"1908d03c-e8ed-43c7-bcae-194d826a152b"},{"index":7899,"token":false,"name":"Changeling Hero","scryfallId":"d6c6635c-8d53-4ea2-8db9-3ba13ce1a999"},{"index":7900,"token":false,"name":"Oneirophage","scryfallId":"caefbac6-b2a0-4a70-a912-25173eafd7b3"},{"index":7903,"token":false,"name":"Venser, the Sojourner","scryfallId":"8f61a0ea-c2e8-4571-9669-19abd8bbc874"},{"index":7905,"token":false,"name":"Stenchskipper","scryfallId":"c376fd5f-596a-4208-b173-0b2e5165f2e9"},{"index":7906,"token":false,"name":"Eutropia the Twice-Favored","scryfallId":"c2159949-3d21-448d-bc34-a3dbaf219476"},{"index":7908,"token":false,"name":"Silence","scryfallId":"37b70d17-e4ec-4731-8892-b444f82be7a2"},{"index":7910,"token":false,"name":"Thallid Devourer","scryfallId":"1a392801-bdc8-4342-8cdd-48f874e22afa"},{"index":7912,"token":false,"name":"Blood Celebrant","scryfallId":"805de325-6f14-4a52-bb85-f9a9545d82a4"},{"index":7913,"token":false,"name":"Spiderwig Boggart","scryfallId":"88e77c10-b569-485f-ba3e-16ef0c57dd81"},{"index":7914,"token":false,"name":"Atarka Pummeler","scryfallId":"d55f2528-f37f-46b9-b95f-4d142f656723"},{"index":7916,"token":false,"name":"Ghirapur Orrery","scryfallId":"74ef0715-104a-44d1-9528-e2f77df4dc6e"},{"index":7917,"token":false,"name":"Jirina Kudro","scryfallId":"6e660d42-f5d3-452a-9662-74e18a1ae9e4"},{"index":7921,"token":false,"name":"Primal Empathy","scryfallId":"656c2277-7420-4e4d-bed5-3683ec1c70de"},{"index":7923,"token":false,"name":"Butcher of Malakir","scryfallId":"1c428841-6ac7-4ca6-a3ff-2541a1444893"},{"index":7925,"token":true,"name":"Centaur Token (G, 3/3)","scryfallId":"91a182ce-11e6-4a7e-a306-15e3670fc433"},{"index":7926,"token":false,"name":"Convalescent Care","scryfallId":"48f3ad80-d000-496a-b704-d09e07981b6e"},{"index":7927,"token":false,"name":"Razorfield Rhino","scryfallId":"2019a1b4-7f88-4c8a-9ef4-bdfbd2f9e9cc"},{"index":7929,"token":false,"name":"Sturdy Hatchling","scryfallId":"e41330e2-c6e8-47af-831d-b2d2bd1d06a3"},{"index":7930,"token":false,"name":"Tainted Aether","scryfallId":"838cffb6-8099-44d7-a127-b2ab3b53ea44"},{"index":7932,"token":false,"name":"Skittering Skirge","scryfallId":"47bb3019-3e36-4200-8ad9-40de84ea23a1"},{"index":7934,"token":false,"name":"Elvish Champion","scryfallId":"88c329c4-6c40-467a-ab37-95896a0c1159"},{"index":7936,"token":false,"name":"Goblin Freerunner","scryfallId":"5082e0a1-5c3e-4b8c-ba88-290151564133"},{"index":7938,"token":false,"name":"Assure // Assemble","scryfallId":"05307822-0891-4de8-a962-e91e60ba5b65"},{"index":7939,"token":false,"name":"Wilderness Reclamation","scryfallId":"54af08f7-9c6c-464e-b2f7-2b5803f36481"},{"index":7941,"token":false,"name":"Dimir Cutpurse","scryfallId":"b50f7d5f-8b4d-46d4-86ce-92fbc475c039"},{"index":7945,"token":false,"name":"Teachings of the Archaics","scryfallId":"f6cdb9e1-a8e5-470b-81e2-759c38d10b69"},{"index":7946,"token":false,"name":"Cavalier of Flame","scryfallId":"a5b41a48-fc4d-4d1a-a742-db958ea67801"},{"index":7947,"token":false,"name":"Magma Rift","scryfallId":"ee526306-6959-421c-9969-3c19b666d6da"},{"index":7948,"token":false,"name":"Keral Keep Disciples","scryfallId":"7b862e46-f5a2-4fce-98b5-2c5aa49ec648"},{"index":7950,"token":false,"name":"Servant of Tymaret","scryfallId":"dfb16d4f-ed42-4b19-9e45-330db88eea9b"},{"index":7951,"token":false,"name":"Bombard","scryfallId":"0a605abc-78e8-47ba-9022-0fad9006fd05"},{"index":7952,"token":false,"name":"Obsidian Giant","scryfallId":"aad8a194-cee7-4671-8310-19357fc1a450"},{"index":7954,"token":false,"name":"Vec Townships","scryfallId":"8b4fbb5f-3fa8-41e2-8035-4f0f3ae078e4"},{"index":7955,"token":false,"name":"Search for Survivors","scryfallId":"2f19a1b5-48ba-44a9-b91f-2f628b223ffb"},{"index":7957,"token":true,"name":"Horror Token (B/U, 1/1)","scryfallId":"79a71b52-58f9-4945-9557-0fbcbbf5a241"},{"index":7958,"token":false,"name":"Call to Arms","scryfallId":"1a772cac-c853-4621-a61f-a9b06f2e2dec"},{"index":7961,"token":false,"name":"Saruli Caretaker","scryfallId":"ef3358cb-714c-49bf-b7e9-a69d02d7799e"},{"index":7963,"token":false,"name":"Square Up","scryfallId":"3d548d5a-1dd7-448a-8483-249572e08c47"},{"index":7964,"token":false,"name":"Sarkhan's Unsealing","scryfallId":"edfa8c8c-8013-46d5-8e80-3d9285fe81c8"},{"index":7965,"token":false,"name":"Failed Inspection","scryfallId":"f8900f91-cb17-4f99-a5ce-15819369beb8"},{"index":7967,"token":false,"name":"Ghostly Pilferer","scryfallId":"bd8a95f1-7fd9-4a13-8eb5-6b61078ccda6"},{"index":7968,"token":false,"name":"Trap Runner","scryfallId":"eba97681-1d1f-4ab6-a21b-fbbbe63a1c74"},{"index":7970,"token":false,"name":"Soul Exchange","scryfallId":"6666dca1-5e33-4f5b-b449-76bcb0e15296"},{"index":7975,"token":false,"name":"Emperor's Vanguard","scryfallId":"c730874b-e275-4325-9fd8-eaf4494571f4"},{"index":7976,"token":false,"name":"Lava Dart","scryfallId":"b16dd041-451d-4914-8c46-aa315a90d802"},{"index":7977,"token":false,"name":"Delirium Skeins","scryfallId":"3a480f1d-1959-4318-bf66-680266fcefd0"},{"index":7978,"token":false,"name":"Altar of the Brood","scryfallId":"362436c0-f89b-4447-afc6-5e47be5c932b"},{"index":7982,"token":false,"name":"Tempered Steel","scryfallId":"53cb7fdc-04df-466b-a1d9-a1fcee5c10a8"},{"index":7984,"token":false,"name":"Inner-Flame Igniter","scryfallId":"107b3dbc-fc02-4548-90cf-844da42db13f"},{"index":7986,"token":false,"name":"Untethered Express","scryfallId":"67a27473-bd70-49a5-9985-70350282fc79"},{"index":7987,"token":false,"name":"Touch of Invisibility","scryfallId":"a5a0c915-92a9-4eb0-a02a-c1571b00761b"},{"index":7988,"token":false,"name":"Undercity Necrolisk","scryfallId":"2571d168-38d4-46d7-afae-ffbd12bd2313"},{"index":7989,"token":true,"name":"Soldier // Soldier Token (W, 1/1)","scryfallId":"887efa4e-f713-4165-a7e1-b0f00ac81784"},{"index":7990,"token":false,"name":"Grasping Dunes","scryfallId":"a8fcc939-6a31-4fb3-abe7-7663b85868dd"},{"index":7991,"token":false,"name":"Vengeful Dreams","scryfallId":"b58b5af8-a4ad-4080-af3f-f1c42ecf862a"},{"index":7992,"token":false,"name":"Ragemonger","scryfallId":"1eb6eda2-e3df-440a-8900-8310f11db6e9"},{"index":7993,"token":false,"name":"Capricious Efreet","scryfallId":"3d844b29-3b5e-4824-befc-affe6aac6d87"},{"index":7995,"token":false,"name":"Myr Enforcer","scryfallId":"563350ab-1a32-4304-921f-1fd80cb3a630"},{"index":7996,"token":false,"name":"Dazzling Lights","scryfallId":"be623551-57cb-443d-a727-48e141f89dbe"},{"index":7997,"token":false,"name":"Iron Verdict","scryfallId":"2fb38f5b-a2c2-4b06-8c9c-9615475a43e7"},{"index":7998,"token":false,"name":"Tibalt's Rager","scryfallId":"2985520d-dfce-414e-a4ac-61695be67406"},{"index":7999,"token":false,"name":"Brave the Sands","scryfallId":"09ab8b60-cdb1-43a8-b180-b562bb89b5a1"},{"index":8000,"token":false,"name":"Carth the Lion","scryfallId":"e09e9b65-ff0e-4efe-b96a-ede69c96e2ea"},{"index":8002,"token":false,"name":"Worship","scryfallId":"d64f89e7-a91b-4c67-bc64-8b6f03820a4d"},{"index":8003,"token":false,"name":"Angelic Gift","scryfallId":"db0775f2-3fd9-42aa-80e3-edac67764fa2"},{"index":8005,"token":false,"name":"Time Wipe","scryfallId":"6ab4b490-67d8-4f13-86cb-858a8012a46a"},{"index":8006,"token":false,"name":"Tamiyo, Field Researcher","scryfallId":"25a31242-5e4c-489f-9425-912d6fb7a651"},{"index":8007,"token":false,"name":"Leshrac's Sigil","scryfallId":"ad5ba7ee-d6df-4b62-a8a1-c81e6fca392a"},{"index":8009,"token":false,"name":"Wings of the Cosmos","scryfallId":"d6b26c95-f90d-43fb-8c99-2a3aa13ac2c6"},{"index":8010,"token":false,"name":"Titan's Presence","scryfallId":"39d5e3ab-9719-4918-af4f-25bda5401191"},{"index":8017,"token":false,"name":"Nissa, Vital Force","scryfallId":"250d56bd-2f6d-40d9-8e9d-bc51dbdd2c3d"},{"index":8018,"token":false,"name":"Berserkers of Blood Ridge","scryfallId":"033fce45-20d8-48cc-96d3-7f16c99da83d"},{"index":8019,"token":false,"name":"Rionya, Fire Dancer","scryfallId":"536c2936-2fdc-4664-97fd-bd580fc2d90e"},{"index":8020,"token":false,"name":"Solid Footing","scryfallId":"0900a8d1-a1b1-48c9-8af1-726a623c7d74"},{"index":8022,"token":false,"name":"Ajani Unyielding","scryfallId":"e3b4faf6-ea41-433c-bc74-9523cc82d4ad"},{"index":8023,"token":false,"name":"Feather, the Redeemed","scryfallId":"be4e8bb8-fa07-4858-aafb-7eab7f01ddae"},{"index":8024,"token":false,"name":"Blighted Woodland","scryfallId":"b4073c69-fce0-4755-97f2-0a10fabed3e4"},{"index":8028,"token":false,"name":"Geist of the Lonely Vigil","scryfallId":"13118343-e026-4970-bf03-ba2d8fc58bac"},{"index":8029,"token":false,"name":"Dragon Fodder","scryfallId":"a90e1524-d94a-4aba-ab2a-ba2b006cadbe"},{"index":8030,"token":true,"name":"Elemental Token (R/U, 5/5)","scryfallId":"ae82b600-c406-4c3b-a09b-a18e18fc57b1"},{"index":8031,"token":false,"name":"Rip-Clan Crasher","scryfallId":"b0e33ff0-c188-4964-adad-b29c6fd97e74"},{"index":8034,"token":false,"name":"Sprouting Thrinax","scryfallId":"123e398b-b965-4688-962f-12b2fca3002f"},{"index":8036,"token":false,"name":"Reveka, Wizard Savant","scryfallId":"27c32cc5-b4da-4345-9118-1fe46a5049cb"},{"index":8038,"token":false,"name":"Death by Dragons","scryfallId":"4a7f32c5-f844-46c9-ba8b-84613390859d"},{"index":8040,"token":false,"name":"Hunting Triad","scryfallId":"093f039a-47af-4284-a7ab-67971c2bc5b2"},{"index":8041,"token":false,"name":"Encroaching Wastes","scryfallId":"a591bffd-2f03-48f4-a719-04f2142abd77"},{"index":8042,"token":false,"name":"Wellgabber Apothecary","scryfallId":"129933ba-60a0-4764-a705-28fa7bb10bd3"},{"index":8043,"token":false,"name":"Reality Scramble","scryfallId":"19a40023-f7ac-4db7-9cc1-c8b113d5c5b8"},{"index":8044,"token":false,"name":"Telekinetic Sliver","scryfallId":"61b934ad-4858-4680-924a-53ea4f250f9e"},{"index":8045,"token":false,"name":"Swamp Mosquito","scryfallId":"21961b79-637a-4aa5-89b5-4e6e9f60d4d1"},{"index":8046,"token":false,"name":"Highspire Artisan","scryfallId":"72a26cb0-655f-4bf8-899a-952d5bfe2b42"},{"index":8047,"token":false,"name":"Goblin Glory Chaser","scryfallId":"07679f88-4bbe-46e1-9b24-3b9f5670860f"},{"index":8049,"token":false,"name":"Pillar of the Paruns","scryfallId":"236dcb39-b81e-4ae2-b153-01be0577ed93"},{"index":8051,"token":false,"name":"Fill with Fright","scryfallId":"e682bbd3-9f52-452d-b886-a6a8def35f27"},{"index":8052,"token":false,"name":"Shattered Angel","scryfallId":"e0b7359f-531a-4bfd-ab97-a8ae474373a7"},{"index":8053,"token":false,"name":"Witherbloom Campus","scryfallId":"7346fb2e-754e-47de-b33d-eb089b357ee4"},{"index":8054,"token":false,"name":"Tombfire","scryfallId":"bb08a4a7-941b-4b54-a89b-a4145a6fc14e"},{"index":8055,"token":false,"name":"Cast Down","scryfallId":"116ce944-6871-4f51-a889-d9c4a5d7cff2"},{"index":8056,"token":false,"name":"Thought Gorger","scryfallId":"f9b6b512-6252-4899-bb9c-5c304f37d10a"},{"index":8057,"token":false,"name":"Ballista Charger","scryfallId":"2ef64020-9265-400b-a553-1b9071d15145"},{"index":8058,"token":false,"name":"Psychotic Episode","scryfallId":"5e61fbcd-b673-4d1d-bc38-a791a56a9aac"},{"index":8059,"token":false,"name":"True-Faith Censer","scryfallId":"815eb91c-06fa-4362-803e-e9bf7d374856"},{"index":8060,"token":false,"name":"Ebony Charm","scryfallId":"937c8016-43c8-418b-9057-b5d6715f71f7"},{"index":8061,"token":false,"name":"Fury","scryfallId":"071daca8-ccc6-4707-843e-adac40dd1588"},{"index":8063,"token":false,"name":"Skyknight Vanguard","scryfallId":"549634d8-1c33-401b-841d-a79ef4374dd1"},{"index":8064,"token":false,"name":"Naked Singularity","scryfallId":"5edddcbb-0e01-4473-b7a8-1e59cf7ee506"},{"index":8065,"token":false,"name":"Kami of Ancient Law","scryfallId":"bd158029-11ac-41d2-aa93-99af286c790d"},{"index":8066,"token":false,"name":"Abundant Growth","scryfallId":"ae1d3532-d229-4674-9746-b7e73605892d"},{"index":8068,"token":false,"name":"Marchesa, the Black Rose","scryfallId":"a23aa9ef-0e3e-4a4e-a519-29915c258951"},{"index":8069,"token":false,"name":"Grakmaw, Skyclave Ravager","scryfallId":"cdb5b964-720e-4c11-ba0a-7bdaab1f302c"},{"index":8070,"token":false,"name":"Ardent Dustspeaker","scryfallId":"7ff4832a-26c0-4da5-abbb-1941e7084e72"},{"index":8071,"token":false,"name":"Elder Mastery","scryfallId":"4b4dfa8c-9068-4373-a9ae-fd0c63eeda44"},{"index":8072,"token":true,"name":"Golem Token (Colorless, 3/3)","scryfallId":"c705b843-ca62-47bb-95dd-f303c60088bb"},{"index":8073,"token":false,"name":"Hand of Silumgar","scryfallId":"d3cbb127-6149-4d0b-ad98-1968f2ebe8e4"},{"index":8075,"token":false,"name":"Alpha Authority","scryfallId":"fbc42ca6-db90-41d0-8a4b-3217fb2c114c"},{"index":8076,"token":false,"name":"Shifting Sliver","scryfallId":"1f68c4c2-91b5-4ffe-9dff-a6834038aa94"},{"index":8081,"token":false,"name":"Catapult Master","scryfallId":"544df614-277e-43dd-8611-3ec1e1747f57"},{"index":8085,"token":false,"name":"Coat of Arms","scryfallId":"9642852b-8736-4fce-9f91-37594cbc3f71"},{"index":8086,"token":false,"name":"Kongming, \"Sleeping Dragon\"","scryfallId":"2ee5a4a2-b3a8-4e5c-b2d9-2fb7437944d4"},{"index":8087,"token":false,"name":"Profane Command","scryfallId":"a770a18f-c333-431b-b15a-69bb025601c2"},{"index":8089,"token":false,"name":"Scalding Tarn","scryfallId":"5a985f59-2b4e-416d-8f11-46b9317199c5"},{"index":8090,"token":false,"name":"Chance Encounter","scryfallId":"49a4b0c9-a35b-4b55-ab27-7246bbca0d16"},{"index":8091,"token":false,"name":"Prodigious Growth","scryfallId":"ba2b0966-4e9e-44dc-9145-3c1e644578bc"},{"index":8092,"token":false,"name":"Sire of Stagnation","scryfallId":"fc760157-2908-4c8f-b498-e2ad8a8a78c9"},{"index":8093,"token":false,"name":"Island of Wak-Wak","scryfallId":"17f4a1aa-395f-423c-b70c-00cf178bb84d"},{"index":8094,"token":false,"name":"Barrier of Bones","scryfallId":"28129aaf-aaff-47f4-8dd2-8c576c55052c"},{"index":8095,"token":false,"name":"Teysa, Orzhov Scion","scryfallId":"4716ede8-d08e-426b-aed3-8cf36c9b51c9"},{"index":8096,"token":false,"name":"Deathless Behemoth","scryfallId":"0d98f1df-f99a-43c5-81cd-9d333226857a"},{"index":8097,"token":false,"name":"Soul Stair Expedition","scryfallId":"902d03cd-2df7-4f87-ab99-fd52f0df6339"},{"index":8098,"token":false,"name":"Thrull Retainer","scryfallId":"cc830040-543e-4d19-8601-4b687ee49122"},{"index":8102,"token":false,"name":"Naya Soulbeast","scryfallId":"f0e4b468-096b-4f80-9e78-022fe24a7e45"},{"index":8105,"token":false,"name":"Angus Mackenzie","scryfallId":"57264bd9-94f6-4d4d-baff-2b2900585635"},{"index":8106,"token":false,"name":"Mnemonic Nexus","scryfallId":"200edda9-7ad9-47fc-837e-37ec9e5b4b51"},{"index":8107,"token":false,"name":"Jace's Sanctum","scryfallId":"8148adc6-7946-4abd-8601-b1f4cd6916c2"},{"index":8111,"token":false,"name":"Pack Leader","scryfallId":"a8b94bc1-68d1-41dc-914c-a33ecb9aeb49"},{"index":8114,"token":false,"name":"Crackle with Power","scryfallId":"d1c038e6-2346-4544-bea1-b64098f63f23"},{"index":8117,"token":false,"name":"Mu Yanling, Sky Dancer","scryfallId":"4a47e8ee-405c-4592-a818-85d2a8e3261f"},{"index":8118,"token":false,"name":"Mesa Pegasus","scryfallId":"f0aafc81-3dec-4948-adca-49aecfd3f8cd"},{"index":8119,"token":false,"name":"War Elephant","scryfallId":"cd87344d-9113-4fec-9a93-38bc1abe2af5"},{"index":8120,"token":false,"name":"Sarkhan's Rage","scryfallId":"4787924f-3186-4e18-b53c-dd67c5f42220"},{"index":8122,"token":false,"name":"Crown of Awe","scryfallId":"aeaea4bc-dcea-4340-a039-ebc97b944673"},{"index":8123,"token":false,"name":"Fortuitous Find","scryfallId":"61237de8-af60-4a81-8cac-a791ebaab126"},{"index":8125,"token":false,"name":"Preyseizer Dragon","scryfallId":"468534eb-b6fb-4141-9260-c0c7b43480b9"},{"index":8126,"token":false,"name":"Fieldmist Borderpost","scryfallId":"9650a717-b1e4-4cd2-894d-766f6b311369"},{"index":8127,"token":false,"name":"Jeering Homunculus","scryfallId":"23eb23e1-388f-4338-a5ed-0646aa602ea6"},{"index":8128,"token":false,"name":"Frontline Rebel","scryfallId":"b742738a-2663-474d-b75a-28f1f67dc335"},{"index":8130,"token":false,"name":"Certain Death","scryfallId":"6b944c3a-a0b1-4a54-addd-a82d685390b8"},{"index":8131,"token":false,"name":"Narrow Escape","scryfallId":"2c9942a2-11d2-403b-89c6-35c23ac9e9da"},{"index":8132,"token":false,"name":"Leaf Gilder","scryfallId":"2381eb3b-e45b-4fbb-a84a-0858b356a008"},{"index":8133,"token":false,"name":"Lorehold Command","scryfallId":"44494eff-8f41-4c80-8042-169a50c47f27"},{"index":8134,"token":false,"name":"Weatherseed Totem","scryfallId":"3275df49-c3f1-4310-87dd-25e3e0ee7fca"},{"index":8135,"token":false,"name":"Rootha, Mercurial Artist","scryfallId":"acb8f24d-8d1d-48aa-a534-238e969a474c"},{"index":8139,"token":false,"name":"Blood Knight","scryfallId":"64d02c9b-7362-4479-b26d-7de843bd2ac3"},{"index":8145,"token":false,"name":"Howling Banshee","scryfallId":"ce096d78-e8b0-4ba2-a734-aa1e96d2dabe"},{"index":8147,"token":false,"name":"Alabaster Mage","scryfallId":"b7026ffb-98de-4da7-84a8-1198639873f4"},{"index":8151,"token":false,"name":"Aladdin's Ring","scryfallId":"40b7370d-8ab4-4506-b7dd-d02c1ba92032"},{"index":8152,"token":false,"name":"Deep Water","scryfallId":"9dd6a230-6bc0-499c-b7fd-4aaa2569f98f"},{"index":8153,"token":false,"name":"Seizures","scryfallId":"da369c86-7e17-43d8-b626-b6842e3d2d50"},{"index":8154,"token":false,"name":"Expedition Raptor","scryfallId":"ca743b62-6dae-4afb-ba57-ab94d0075434"},{"index":8156,"token":false,"name":"Barrin, Tolarian Archmage","scryfallId":"fc3765b7-bd99-4c66-8761-1c9cc5bd8666"},{"index":8157,"token":false,"name":"Satyr Hoplite","scryfallId":"b8754d66-facb-432e-a6c2-91430a6dec94"},{"index":8159,"token":false,"name":"Apex of Power","scryfallId":"c827bccf-38f9-4a7c-bd0e-038594a9f63b"},{"index":8160,"token":false,"name":"Coax from the Blind Eternities","scryfallId":"6f0271ac-e5da-466e-8b0b-f5c193293905"},{"index":8161,"token":false,"name":"Stoke the Flames","scryfallId":"1d94c000-52e0-4215-83af-6351dc43e636"},{"index":8163,"token":false,"name":"Battlewise Valor","scryfallId":"7d967a4c-2323-4361-a907-5ca9140d8793"},{"index":8164,"token":false,"name":"Soltari Emissary","scryfallId":"a18751d3-052b-4ae5-ba07-16f00a1af40e"},{"index":8166,"token":false,"name":"Pacification Array","scryfallId":"8bed742a-a12a-4728-a771-07e3d1417419"},{"index":8168,"token":false,"name":"Frost Giant","scryfallId":"a742bfa4-3730-4bfd-865c-92fb4b40f2f2"},{"index":8169,"token":false,"name":"Soldevi Sentry","scryfallId":"85976b5c-4eed-4cf9-b2b0-a8421a97ab2a"},{"index":8170,"token":false,"name":"Evolution Sage","scryfallId":"969bf351-c7df-4eb0-8065-9b8d5233f8f3"},{"index":8171,"token":false,"name":"Wild Hunger","scryfallId":"9bacc50a-71d7-4660-be1d-4db10c9b8fa8"},{"index":8173,"token":false,"name":"Dominate","scryfallId":"b9cfd7fc-22a5-4f21-bebf-d4823db48841"},{"index":8175,"token":false,"name":"Leyline Prowler","scryfallId":"c5d9286d-449b-4959-98ae-bd6a35be221d"},{"index":8176,"token":false,"name":"Secret Plans","scryfallId":"01589046-a969-400f-b4ac-90cbbb814504"},{"index":8177,"token":false,"name":"Sunspire Griffin","scryfallId":"1388ce6e-8199-46c1-8ee3-71266b0929bf"},{"index":8178,"token":false,"name":"Wakeroot Elemental","scryfallId":"02c9396d-28f2-40b7-908e-51db51da57a7"},{"index":8179,"token":false,"name":"Nihil Spellbomb","scryfallId":"2cbaefb7-98d2-418c-926a-6c2c1cba79ba"},{"index":8180,"token":false,"name":"Urborg Mindsucker","scryfallId":"8acbd8c6-da34-45d6-921a-11f370662833"},{"index":8183,"token":false,"name":"Sovereigns of Lost Alara","scryfallId":"9d68ea02-66d3-4cca-ba0c-96f4340f683c"},{"index":8185,"token":false,"name":"Fire Giant's Fury","scryfallId":"c7f05d49-dfc1-4dad-89e0-07174330d98e"},{"index":8186,"token":false,"name":"Dross Scorpion","scryfallId":"27c5381c-2e79-41fa-b1d7-2cf0c6dc1808"},{"index":8187,"token":false,"name":"Shower of Sparks","scryfallId":"490827a4-c2bc-44b3-b48e-993996d04d5c"},{"index":8188,"token":false,"name":"Corsair Captain","scryfallId":"a9b016d4-ddf6-47d6-b934-a0b979b60680"},{"index":8189,"token":false,"name":"Vedalken Entrancer","scryfallId":"faf5e4b8-3bb9-4a4c-b8fa-2cae5372ba24"},{"index":8190,"token":false,"name":"Beast of Burden","scryfallId":"e978114b-c3d5-4533-a89a-75d6f65eb9b1"},{"index":8193,"token":false,"name":"Neheb, the Eternal","scryfallId":"54231832-d492-4812-b658-4ab9a30fefe2"},{"index":8194,"token":false,"name":"Flame Jab","scryfallId":"4dacce86-be7f-496c-9a70-676dc39ca2c8"},{"index":8197,"token":false,"name":"Ebony Horse","scryfallId":"b9827cea-34c1-4af3-8a1f-e5764c92c126"},{"index":8198,"token":false,"name":"Clearwater Pathway // Murkwater Pathway","scryfallId":"94598167-dec4-425a-86bc-5989e2c3ba7c"},{"index":8199,"token":false,"name":"Gut Shot","scryfallId":"a54a2a30-b96a-49c7-9151-1f4b0d4a4413"},{"index":8202,"token":false,"name":"Ceta Sanctuary","scryfallId":"32cec6f3-295a-45e3-8466-e35fb043a596"},{"index":8204,"token":false,"name":"Goblin Gaveleer","scryfallId":"3f44f3ea-504e-4745-9716-cbe28ed7873d"},{"index":8206,"token":false,"name":"Skulking Knight","scryfallId":"a7f7927b-64ae-4448-9540-8d7bbe88c9cc"},{"index":8209,"token":false,"name":"Pollywog Symbiote","scryfallId":"77adf375-e7d7-4ebd-8c86-ad7e822a5483"},{"index":8211,"token":false,"name":"Novice Knight","scryfallId":"00101358-0e89-4bd1-b1f2-e889645b616e"},{"index":8212,"token":false,"name":"Power Matrix","scryfallId":"a578599c-7d90-4881-b59a-9cf64b90d917"},{"index":8213,"token":false,"name":"Rith's Charm","scryfallId":"dd30f389-bac8-4b82-a8a7-6948d43a9f60"},{"index":8216,"token":false,"name":"Echoing Return","scryfallId":"39eb0e67-f989-4430-b2d6-b8b647f0b7ca"},{"index":8217,"token":true,"name":"Sliver Token (Colorless, 1/1)","scryfallId":"68353af0-9cd0-43c0-9b39-8f904c618e3a"},{"index":8218,"token":false,"name":"Conclave Tribunal","scryfallId":"9d9fda5d-df8f-45d6-b8f0-33f903c4bf83"},{"index":8221,"token":false,"name":"Disease Carriers","scryfallId":"49125cfc-dbae-4543-9d2d-4cc78f45ce9a"},{"index":8222,"token":false,"name":"Wizard's Retort","scryfallId":"bae30b7d-9306-46ef-adea-c4057f59c9c1"},{"index":8224,"token":false,"name":"Perilous Myr","scryfallId":"33823e16-810e-4138-950b-e18ef1204438"},{"index":8225,"token":false,"name":"Carrion Howler","scryfallId":"cf946168-0d42-4c1d-be32-f38783361f8c"},{"index":8226,"token":false,"name":"Bounty of the Hunt","scryfallId":"15c68996-a6a8-4f5f-83ad-43b94e4fa64e"},{"index":8230,"token":false,"name":"Enemy of Enlightenment","scryfallId":"28bf15e0-f61b-43b9-9113-39bd341a0163"},{"index":8231,"token":false,"name":"Imprisoned in the Moon","scryfallId":"7990ebba-e9f2-4ba4-a352-e26ec81d4bed"},{"index":8234,"token":false,"name":"Shielded Passage","scryfallId":"6546b6c4-73b2-41b3-9ff9-316e9ce916e5"},{"index":8235,"token":false,"name":"Dromad Purebred","scryfallId":"0106caf1-2201-4661-96a5-56af02963fa6"},{"index":8236,"token":false,"name":"Grave Robbers","scryfallId":"a131605a-f646-4745-a1e4-48d155a3d94f"},{"index":8239,"token":false,"name":"Gallia of the Endless Dance","scryfallId":"0744f08e-a588-4efe-ad56-5e9ed91dda40"},{"index":8240,"token":false,"name":"Hagi Mob","scryfallId":"d3b18cdb-bc17-42ae-bfb7-4eafce01cd39"},{"index":8241,"token":false,"name":"Ancestral Mask","scryfallId":"1203f98a-fb6e-4f16-88e3-553eba177450"},{"index":8243,"token":false,"name":"Gwyllion Hedge-Mage","scryfallId":"914e6fda-808f-43fb-8024-8b8a8781a7ac"},{"index":8244,"token":false,"name":"Whelming Wave","scryfallId":"ddb863a0-3ff8-42a3-a151-4ea9aa433336"},{"index":8245,"token":false,"name":"Vengevine","scryfallId":"51eb9f05-9d5a-4196-9329-626ce4793c42"},{"index":8248,"token":false,"name":"Void Maw","scryfallId":"ba464b81-2633-4422-a4b5-3593dfb7e7aa"},{"index":8250,"token":false,"name":"Angelic Favor","scryfallId":"871ad2f3-1dd2-45ea-881d-529aad3b76ec"},{"index":8252,"token":false,"name":"Phyrexian Hulk","scryfallId":"1687b5a7-7013-409a-ba8d-9cd8b5bb08f3"},{"index":8253,"token":false,"name":"Leyline of Anticipation","scryfallId":"4c0b68cd-1bd2-47d9-a041-e343b8c198a6"},{"index":8254,"token":false,"name":"Magnetic Theft","scryfallId":"de0c1e37-fedc-43d9-97fd-b797c6c2fbbe"},{"index":8255,"token":false,"name":"Living Twister","scryfallId":"c8d92676-a994-4031-834c-6cf7c43bd170"},{"index":8256,"token":false,"name":"Jester's Scepter","scryfallId":"7118c2e0-04d6-4a71-8ffd-b9365b154050"},{"index":8259,"token":false,"name":"Returned Reveler","scryfallId":"9ea61098-2c6a-48d2-b99f-f3065c67d8e3"},{"index":8261,"token":false,"name":"Blade Historian","scryfallId":"96edfb62-e488-497e-b3c2-24aa23c23dbe"},{"index":8263,"token":false,"name":"Biomathematician","scryfallId":"b41a35ef-dae1-4534-a12a-d3951b285273"},{"index":8264,"token":false,"name":"Frenzy Sliver","scryfallId":"d796119a-f1eb-4de9-a9ca-d322017e9c5e"},{"index":8269,"token":false,"name":"Fate Forgotten","scryfallId":"9b2161d9-ad52-45a6-9be9-e7ff09ec8f5a"},{"index":8271,"token":false,"name":"Mistmoon Griffin","scryfallId":"8ec71a29-19db-4747-8276-7fd4d563d4df"},{"index":8274,"token":false,"name":"Nightmare Void","scryfallId":"892299e9-8ee9-4a81-b4aa-b03ad2565eb4"},{"index":8275,"token":true,"name":"Zombie Token (U, */*)","scryfallId":"d791c7af-1ba7-45ab-ad0c-be9ebc9e51f9"},{"index":8278,"token":false,"name":"Malakir Bloodwitch","scryfallId":"be917193-f4ab-485d-aac2-826db6a08275"},{"index":8280,"token":false,"name":"Savai Thundermane","scryfallId":"73d3925c-cf7d-4546-bc70-33f04d4b7566"},{"index":8281,"token":false,"name":"Aphetto Vulture","scryfallId":"107492b9-03a8-4d53-a0cf-4814ffbec409"},{"index":8282,"token":false,"name":"King Cheetah","scryfallId":"38149d49-8661-427c-9338-93c11a2a8093"},{"index":8283,"token":false,"name":"Bloodtracker","scryfallId":"ca3519c4-4d8c-4caf-bc93-6e6160a3d5b6"},{"index":8286,"token":false,"name":"Pestilent Cauldron // Restorative Burst","scryfallId":"f1ebfe27-d5a4-4fc9-8049-fcebe65dd592"},{"index":8289,"token":false,"name":"Hero of Goma Fada","scryfallId":"e8797c33-c731-4748-bcf0-3b2400b9ab42"},{"index":8290,"token":false,"name":"Trapjaw Tyrant","scryfallId":"b2c280c8-3471-4ae1-be96-0f392b095ce2"},{"index":8292,"token":false,"name":"Teferi's Protection","scryfallId":"2271862c-b1df-45f8-bb19-ae4b8ab0739e"},{"index":8293,"token":false,"name":"Dream's Grip","scryfallId":"7ffaa6a2-7c86-45b4-8892-b837e05f11a6"},{"index":8294,"token":false,"name":"Sprinting Warbrute","scryfallId":"a215bde8-1680-4aea-9d0f-2d6d80a592e3"},{"index":8296,"token":false,"name":"Nausea","scryfallId":"a10531d8-fc99-4a2b-94b0-97a25521d725"},{"index":8298,"token":false,"name":"Robe of Mirrors","scryfallId":"110b92c8-6bc3-4b2d-b71d-d04db8c3b465"},{"index":8301,"token":false,"name":"Cartouche of Knowledge","scryfallId":"20c806dc-a1f5-463d-93c9-58f37002bb2e"},{"index":8305,"token":false,"name":"Foundry Inspector","scryfallId":"2f1a1d68-2066-43f6-9b34-7dfe6ba70d25"},{"index":8306,"token":false,"name":"Errant Ephemeron","scryfallId":"3779a76a-0171-4714-9713-a65dc173a33f"},{"index":8307,"token":false,"name":"Wall of Air","scryfallId":"dc2a53c7-99fa-4183-a173-f84ec06088b2"},{"index":8309,"token":false,"name":"Spectral Searchlight","scryfallId":"17094ffd-a886-44cc-95c7-c6297aaf8767"},{"index":8311,"token":false,"name":"Thran Forge","scryfallId":"b9c9691b-bee8-4251-8275-5f6ba14a8ecd"},{"index":8313,"token":false,"name":"Viscerid Drone","scryfallId":"6ef8e1b3-b423-4ee6-a7fc-098f86e2fd9d"},{"index":8314,"token":false,"name":"Chandra's Phoenix","scryfallId":"e8371c83-d7c5-4432-8511-cb3c1dc7d59f"},{"index":8317,"token":false,"name":"Uktabi Wildcats","scryfallId":"d0f287ff-1b1b-454a-9360-fac34c8e1f24"},{"index":8319,"token":false,"name":"Telekinetic Bonds","scryfallId":"d68fad1d-a517-433a-b939-d0635e8f5535"},{"index":8321,"token":false,"name":"Stolen Identity","scryfallId":"8838088d-7fbd-4501-b97f-83e08ca376f3"},{"index":8323,"token":false,"name":"Concerted Effort","scryfallId":"4afa3367-eb7e-4c92-96a1-2b6865b24f52"},{"index":8326,"token":false,"name":"Essence Leak","scryfallId":"9099b2e6-9ed8-4a9c-97ca-77cc47678228"},{"index":8327,"token":false,"name":"Chandra's Ignition","scryfallId":"7d4c90de-49aa-43ed-a18a-f7f96268e5eb"},{"index":8328,"token":false,"name":"Dryad Militant","scryfallId":"5828933a-ba9e-4672-ac6f-64496e56c457"},{"index":8329,"token":false,"name":"Font of Fortunes","scryfallId":"25de3481-9b0d-4747-a97b-171b6aa41073"},{"index":8332,"token":false,"name":"Serra's Sanctum","scryfallId":"f7a18130-dbaa-4657-a885-3a96a985935a"},{"index":8333,"token":false,"name":"Smash to Smithereens","scryfallId":"655c489f-bffb-45a4-8e7c-2d1a35220197"},{"index":8334,"token":false,"name":"Dead Man's Chest","scryfallId":"10027c0a-7ee2-424f-a879-374d857ae359"},{"index":8335,"token":false,"name":"Talisman of Unity","scryfallId":"d6cc8a5a-b98b-4758-a168-bf2ef738fb05"},{"index":8336,"token":false,"name":"Trostani's Summoner","scryfallId":"2a50a999-8b16-4f0f-ba30-61e7d1114f1a"},{"index":8337,"token":false,"name":"Scion of the Wild","scryfallId":"85a78413-17e3-4652-91b4-708aa66a50ca"},{"index":8338,"token":false,"name":"Liliana Vess","scryfallId":"96bb667b-7240-4072-beb7-9a803c9eabe3"},{"index":8339,"token":false,"name":"Tetravus","scryfallId":"23eb19f9-2e8f-4bf0-9bf8-868e6da70e2d"},{"index":8340,"token":false,"name":"Embercleave","scryfallId":"4b09eb0e-ce97-41fb-9c97-0ecc2b0e13cb"},{"index":8342,"token":false,"name":"Shrine of Limitless Power","scryfallId":"61873223-f378-4478-9cf3-f1326eb76834"},{"index":8348,"token":false,"name":"Musician","scryfallId":"9f8d2247-a10e-413a-b497-2add3918f991"},{"index":8354,"token":false,"name":"Necrogenesis","scryfallId":"32a50be8-3937-458b-a2f9-e75569016665"},{"index":8355,"token":false,"name":"Sigil of Sleep","scryfallId":"a31f3c70-e2c3-479e-8d22-2fd1429e9857"},{"index":8356,"token":false,"name":"Goblin Wizard","scryfallId":"9b73dfb4-d930-4a89-b621-129dd9f6328c"},{"index":8358,"token":false,"name":"Filth","scryfallId":"37de06dc-c0c1-4edb-9732-2d16dbabfb31"},{"index":8359,"token":false,"name":"Centaur Glade","scryfallId":"1c75f9c8-9640-4f64-b32a-916436e461fc"},{"index":8360,"token":false,"name":"Lashwrithe","scryfallId":"de21d433-5c2c-49c0-80d1-bf6e8471f9d4"},{"index":8362,"token":false,"name":"Nature's Resurgence","scryfallId":"2df9fb85-f7fa-4617-87bd-4d457c830f46"},{"index":8366,"token":false,"name":"Timetwister","scryfallId":"38f1f76f-4eff-4a38-9619-166b9f245012"},{"index":8367,"token":false,"name":"Kogla, the Titan Ape","scryfallId":"3c35ca79-eb72-427a-a8ed-404b2214389a"},{"index":8371,"token":false,"name":"Urborg Uprising","scryfallId":"1f4f0fdb-fb1a-41e0-b7af-a2dc25cf116e"},{"index":8373,"token":false,"name":"Noggle Bandit","scryfallId":"552c9c66-8023-41ef-8d4f-3b0dc30743f3"},{"index":8374,"token":false,"name":"Thunderbolt","scryfallId":"5845a5bc-6b7d-4bbb-80b3-a0f877b95553"},{"index":8375,"token":false,"name":"Qumulox","scryfallId":"90c61861-079d-481c-b976-593ba88afe85"},{"index":8376,"token":false,"name":"Patrician's Scorn","scryfallId":"4edfd70c-2923-4813-bf14-04194518163c"},{"index":8377,"token":false,"name":"Extinguish","scryfallId":"8194b7c8-74d1-488a-9d8e-8d9421a63bae"},{"index":8378,"token":false,"name":"Soul of Innistrad","scryfallId":"c3221d23-3130-4737-9fdd-1598d2722d04"},{"index":8379,"token":false,"name":"Basandra, Battle Seraph","scryfallId":"4d889584-276b-4d40-89ab-67ac5a841ea9"},{"index":8380,"token":false,"name":"Rimefeather Owl","scryfallId":"7e8e3552-a251-4a80-b0bb-a96a9f8a4c56"},{"index":8383,"token":false,"name":"Lost in the Mist","scryfallId":"1e5fc39d-590a-436b-ab90-a1741d2ae3da"},{"index":8385,"token":false,"name":"Do or Die","scryfallId":"05f63cd9-e82b-4cf8-b8ce-f0aa0157692b"},{"index":8390,"token":false,"name":"Everlasting Torment","scryfallId":"28f857d3-661b-45cd-a8d3-65b9ac0a34c8"},{"index":8392,"token":false,"name":"Siegebreaker Giant","scryfallId":"ede2b911-8eec-4993-ab1c-59b55dfb11b4"},{"index":8393,"token":false,"name":"Cold Storage","scryfallId":"b26e28d4-50e1-41db-984d-c55781295012"},{"index":8394,"token":false,"name":"Rude Awakening","scryfallId":"019897e4-d3ba-43b1-9bd9-2ebba6e3b349"},{"index":8395,"token":false,"name":"Sentinel Totem","scryfallId":"0d8097eb-518a-4b8e-8d6a-a139d4ddcc8f"},{"index":8396,"token":false,"name":"Nivix, Aerie of the Firemind","scryfallId":"a025a42d-cbcc-4bd2-9331-5c7dc677da20"},{"index":8398,"token":false,"name":"Stone Quarry","scryfallId":"315e782c-2159-4e8d-b2d7-9f96b7609db4"},{"index":8399,"token":false,"name":"Flamewright","scryfallId":"fc0f2b5a-f9fd-4f58-bc98-201b4c0e8252"},{"index":8401,"token":false,"name":"Dirty Wererat","scryfallId":"a64856ad-fe59-43ba-95c8-3a5839532dd9"},{"index":8402,"token":false,"name":"Primeval Shambler","scryfallId":"e45931d2-3fbf-4509-aa41-13d7839578df"},{"index":8403,"token":false,"name":"Cyclops of Eternal Fury","scryfallId":"44a92b7a-7119-45b3-b9ed-5dbf5abca818"},{"index":8404,"token":false,"name":"Forgotten Harvest","scryfallId":"9fefbace-03cb-43db-a221-0be2b8784357"},{"index":8405,"token":false,"name":"Thieves' Guild Enforcer","scryfallId":"df99f770-2c39-4025-a8a2-a5890f61eb53"},{"index":8406,"token":false,"name":"Defy Death","scryfallId":"028028d7-80ff-4d63-8b84-795f257a3456"},{"index":8410,"token":false,"name":"Lampad of Death's Vigil","scryfallId":"e8c9ada9-ea25-4a96-a4be-e4cf8f7a014f"},{"index":8412,"token":false,"name":"Yusri, Fortune's Flame","scryfallId":"ecc06edb-d7dd-40e4-abbb-03ec2d467193"},{"index":8414,"token":false,"name":"Gold-Forged Sentinel","scryfallId":"4e154012-5922-45d1-8e20-d2a2b1de0785"},{"index":8416,"token":false,"name":"Loxodon Sergeant","scryfallId":"c57f873b-5fb2-4638-b66c-f6d1aec156ba"},{"index":8417,"token":false,"name":"Scorching Dragonfire","scryfallId":"3b74a806-ed74-458e-8903-d3d084e9f507"},{"index":8418,"token":false,"name":"Taunt","scryfallId":"f4d87322-aba4-4187-9655-1da1f18615f8"},{"index":8424,"token":false,"name":"Metallurgeon","scryfallId":"4ad9f9d5-62c1-4dae-a2c8-5552210a70a4"},{"index":8429,"token":false,"name":"Teferi's Response","scryfallId":"ca603260-6bda-436b-b6d3-792cf4a9a13d"},{"index":8430,"token":false,"name":"Chandra's Outrage","scryfallId":"b00553c7-d3f9-4d77-8433-2f425361516f"},{"index":8433,"token":false,"name":"Victory's Envoy","scryfallId":"7e7fa9e2-4c16-4e94-9b0e-09657303132c"},{"index":8436,"token":false,"name":"Phantasmal Bear","scryfallId":"d2a5e968-6ba4-44e9-9587-6ef456721b97"},{"index":8437,"token":false,"name":"Muse Drake","scryfallId":"c5df7a96-6548-41c0-85a6-e0c4566e0fe6"},{"index":8440,"token":false,"name":"Runic Repetition","scryfallId":"8cabd32b-187d-4a41-92b2-72c3b3216728"},{"index":8448,"token":false,"name":"Necra Sanctuary","scryfallId":"5a0bf165-d7eb-4ae6-b30a-4e9fd55f401d"},{"index":8450,"token":false,"name":"Scurrid Colony","scryfallId":"c9c0a096-870d-443c-92d3-f7ec1f362616"},{"index":8451,"token":false,"name":"Guiltfeeder","scryfallId":"b3e3ee6f-9f2d-4092-b4d0-4cfc74eb26fd"},{"index":8452,"token":false,"name":"Vicious Kavu","scryfallId":"31e9e629-7c25-4d45-aa35-9ba5f95b43cb"},{"index":8453,"token":false,"name":"Kavu Titan","scryfallId":"2c5fb86d-1d9a-4da2-bb5b-4266faa20197"},{"index":8454,"token":false,"name":"Storm Elemental","scryfallId":"3ba391bb-1bc2-4d4f-b415-ed99d176c29f"},{"index":8455,"token":false,"name":"Stoneshock Giant","scryfallId":"3706025b-2a67-43a3-80fc-57a3bc38276e"},{"index":8456,"token":false,"name":"Eddytrail Hawk","scryfallId":"a691752f-eaac-4ff2-b32a-05cf565ae5f6"},{"index":8457,"token":true,"name":"Elemental Token (G, 7/7)","scryfallId":"5e37e5ee-d860-4a81-951b-d03bcea9feff"},{"index":8459,"token":false,"name":"Reef Pirates","scryfallId":"2d712139-bf12-4f7b-bb9b-34d15fac56df"},{"index":8461,"token":false,"name":"Grove of the Burnwillows","scryfallId":"e0b4d4b1-6e25-4c4b-a21a-1b7b1c1d6452"},{"index":8464,"token":false,"name":"Ancient Den","scryfallId":"5803fdbb-57a4-4b70-8585-23c1cc54d657"},{"index":8465,"token":false,"name":"War Horn","scryfallId":"45c17671-7c4a-4114-b2b7-d34af4e2f8c1"},{"index":8468,"token":true,"name":"Bird Illusion Token (U, 1/1)","scryfallId":"0fd60456-70aa-49ae-a0a7-2c50cb085223"},{"index":8469,"token":false,"name":"Krond the Dawn-Clad","scryfallId":"63d25986-2d71-43b8-b660-502acef9a70c"},{"index":8472,"token":false,"name":"Might Sliver","scryfallId":"8bb8c52f-e608-4710-872f-8a8ae2b5c00c"},{"index":8475,"token":false,"name":"Herald's Horn","scryfallId":"e64d51b3-20a2-4cc3-bd70-7f165940c157"},{"index":8476,"token":false,"name":"Tidal Wave","scryfallId":"f94db3a7-ae06-494c-8af5-824dee6f23f0"},{"index":8477,"token":false,"name":"Narcolepsy","scryfallId":"42910ab0-902f-43e9-ba21-6a35f9334e59"},{"index":8478,"token":false,"name":"Spiritual Guardian","scryfallId":"7dadcfcf-f093-44e9-a632-fcc719c570d7"},{"index":8479,"token":false,"name":"Wake the Dead","scryfallId":"842fb0f2-8a03-4b43-be41-dbc5b6509269"},{"index":8480,"token":false,"name":"The Ur-Dragon","scryfallId":"51f538ae-0ee3-4726-a888-ed9df521f322"},{"index":8481,"token":false,"name":"Colossification","scryfallId":"7b6e6f2a-5015-44c6-aa8d-85188494d1a6"},{"index":8482,"token":false,"name":"Blood Curdle","scryfallId":"4184c851-1419-476c-ba9c-9f0cb1137114"},{"index":8483,"token":false,"name":"Ravager Wurm","scryfallId":"e20cbaf3-64d8-4fd5-866a-74e1a2aa41fa"},{"index":8485,"token":false,"name":"Heaven // Earth","scryfallId":"60c9821a-dcba-4eb1-8a79-00e798532154"},{"index":8486,"token":false,"name":"Sigil Blessing","scryfallId":"8ae9ce20-d283-4d29-8140-bc4cf8de66df"},{"index":8487,"token":false,"name":"Phantom General","scryfallId":"11f42791-070a-4e3a-91c8-b801980abb76"},{"index":8488,"token":false,"name":"Refresh","scryfallId":"0084ba4e-98eb-4eb4-b23e-c5ab4d7d95cb"},{"index":8490,"token":false,"name":"Coastal Piracy","scryfallId":"1bf882f7-4450-46f4-946b-43d6d3594c02"},{"index":8492,"token":false,"name":"Aggravated Assault","scryfallId":"6bcaa16c-4841-4962-88ca-b17175189e5c"},{"index":8493,"token":false,"name":"Thassa's Rebuff","scryfallId":"816a6ff7-cede-4346-b3e6-aee33aefac3a"},{"index":8494,"token":false,"name":"Blizzard Elemental","scryfallId":"5949c5a7-9656-466a-add8-1800973fefee"},{"index":8495,"token":false,"name":"Ferocious Tigorilla","scryfallId":"5976e8d8-5122-4423-b3eb-61170390ad7a"},{"index":8496,"token":false,"name":"Moan of the Unhallowed","scryfallId":"bbed06f6-c7f0-4304-b57a-b996a531adb1"},{"index":8497,"token":false,"name":"Jiwari, the Earth Aflame","scryfallId":"6b46105b-32c2-48fc-b71d-c3e8fcb8a8ea"},{"index":8498,"token":false,"name":"Angel's Trumpet","scryfallId":"0c7b248a-3c74-4592-b357-47989568298c"},{"index":8499,"token":false,"name":"Wanderer's Strike","scryfallId":"85e1d63e-9692-4988-bda2-7c2c9b42217b"},{"index":8500,"token":false,"name":"Atzocan Archer","scryfallId":"3e214e0d-bd3d-467b-83fb-d8a232e166e4"},{"index":8501,"token":false,"name":"Surrak, the Hunt Caller","scryfallId":"37c48dc1-973e-419e-8219-f9554827cfbb"},{"index":8502,"token":false,"name":"Graven Dominator","scryfallId":"b6dc44f8-ff1d-4c5a-971d-c3ce9a65f35d"},{"index":8503,"token":false,"name":"Bane of the Living","scryfallId":"946a0fb7-0e36-47d5-8083-09f48725dff1"},{"index":8506,"token":false,"name":"Belligerent Sliver","scryfallId":"b78b8268-b090-4012-a3ba-5daab491f78d"},{"index":8509,"token":false,"name":"Fireflux Squad","scryfallId":"4bcff20b-06f7-4228-a99c-6ff46e73e353"},{"index":8510,"token":false,"name":"Vengeance","scryfallId":"011b9836-fee4-4e83-add7-5e13cb1275d6"},{"index":8513,"token":false,"name":"Rumbling Crescendo","scryfallId":"ddf267c2-c3d5-48ba-93af-dd0af133add3"},{"index":8515,"token":false,"name":"Goblin Assailant","scryfallId":"e41acc81-7c22-4b59-97b8-54473623db6f"},{"index":8517,"token":false,"name":"Prismatic Vista","scryfallId":"e37da81e-be12-45a2-9128-376f1ad7b3e8"},{"index":8522,"token":false,"name":"Goblin Assault","scryfallId":"26bccccc-f694-47a8-90fa-e3f1f62b9664"},{"index":8523,"token":false,"name":"Blades of Velis Vel","scryfallId":"83b17fb1-4a33-454f-9222-c6d5671c7e2f"},{"index":8525,"token":false,"name":"Verdeloth the Ancient","scryfallId":"44e811ab-af9f-414d-8f4b-62df991059b9"},{"index":8526,"token":false,"name":"Armored Guardian","scryfallId":"6de5e1bd-1d31-4f9f-b18d-d6f49bc7ef10"},{"index":8528,"token":false,"name":"Kodama's Reach","scryfallId":"8da1bbb5-7884-46a9-962b-cfc9fe35500a"},{"index":8530,"token":false,"name":"Familiar's Ruse","scryfallId":"55b9be91-f3a1-49ce-8a3e-2ecd30e2e692"},{"index":8532,"token":false,"name":"Scion of Darkness","scryfallId":"fe179672-87c0-4ca9-88f8-d432542b3289"},{"index":8534,"token":false,"name":"Phantatog","scryfallId":"6967608d-141d-426f-a129-6f1a6a58273c"},{"index":8535,"token":false,"name":"Windreader Sphinx","scryfallId":"f566741d-a847-4f24-b6fc-7873f0797d59"},{"index":8536,"token":false,"name":"Concentrate","scryfallId":"5aca3338-30a6-4ce4-b74c-a18144b6efc9"},{"index":8537,"token":false,"name":"Shizo, Death's Storehouse","scryfallId":"e0de48b1-b61f-408e-915a-602309ded8ea"},{"index":8538,"token":false,"name":"Dragonlair Spider","scryfallId":"a9e2bb08-9be0-4046-9c22-7b132ce5f506"},{"index":8540,"token":true,"name":"Experience","scryfallId":"590f96f6-3857-4c75-8461-fe2d404bc5b7"},{"index":8543,"token":false,"name":"Viridian Corrupter","scryfallId":"0cc13aee-5a74-4dab-a6af-7dc31255981d"},{"index":8544,"token":false,"name":"Murasa Sproutling","scryfallId":"f53472b7-53da-4833-b7f9-204706dfb721"},{"index":8545,"token":false,"name":"Wall of Mulch","scryfallId":"8b3b4448-50f0-4996-94a1-db9ce356d925"},{"index":8546,"token":false,"name":"Ironroot Warlord","scryfallId":"b78765aa-f952-47f5-b6fc-8aca93fc4104"},{"index":8548,"token":false,"name":"Detonate","scryfallId":"ffd7eb90-ae95-49df-898a-9510187bce1c"},{"index":8549,"token":true,"name":"Tentacle Token (U, 1/1)","scryfallId":"7b9f04f7-587e-4774-8aaa-09e8520efacb"},{"index":8551,"token":false,"name":"Glacial Crasher","scryfallId":"e8bf55bf-ee38-4e68-81ca-0fdb8af779ef"},{"index":8555,"token":false,"name":"Gruesome Encore","scryfallId":"3f7f31fb-af96-4c8c-80fa-219ebd7c3d4d"},{"index":8556,"token":false,"name":"Whims of the Fates","scryfallId":"aeb8d3fc-99e4-49dd-b1f1-bb479b361743"},{"index":8561,"token":false,"name":"Dutiful Servants","scryfallId":"7684db4c-6eff-4da1-a410-48d707fb5bf1"},{"index":8562,"token":false,"name":"Bloodspore Thrinax","scryfallId":"f8bc8355-3a02-44a5-b06f-8be24d7cbcbe"},{"index":8565,"token":false,"name":"Precognitive Perception","scryfallId":"8c800486-345f-4cf7-86a1-d217ed06edad"},{"index":8566,"token":false,"name":"Molten Disaster","scryfallId":"17ca6865-e894-4390-ba27-b7cc8b03a424"},{"index":8567,"token":false,"name":"Alley Strangler","scryfallId":"d0b97fa0-4c5b-4211-9c8d-99197dc20636"},{"index":8568,"token":false,"name":"Drainpipe Vermin","scryfallId":"4d7251f3-df66-4611-a84c-1897f74431f7"},{"index":8569,"token":false,"name":"Vivien, Arkbow Ranger","scryfallId":"592c5e27-c538-425e-b41f-1d6708428853"},{"index":8570,"token":false,"name":"Call to the Netherworld","scryfallId":"caccee1e-971d-4b92-9f9a-624865c508d9"},{"index":8571,"token":false,"name":"Castle Vantress","scryfallId":"0a8b9d37-e89c-44ad-bd1b-51cb06ec3e0b"},{"index":8572,"token":false,"name":"Demonic Hordes","scryfallId":"dc20c19b-7216-4f23-a3bb-70d4dcd3865e"},{"index":8573,"token":false,"name":"Disaster Radius","scryfallId":"9318ae4a-1084-49d9-b5de-dbe4d80836cb"},{"index":8574,"token":false,"name":"Phyrexian Broodlings","scryfallId":"edf4c9e1-eff6-4abc-ad4e-ffd7f1895d8d"},{"index":8575,"token":false,"name":"Cabal Trainee","scryfallId":"d345d702-b205-4391-985a-6201e707f0ba"},{"index":8578,"token":false,"name":"Underrealm Lich","scryfallId":"97da1362-1eaf-4e4d-9184-4f35e6ad8926"},{"index":8579,"token":false,"name":"Tidespout Tyrant","scryfallId":"9a7c2716-35ab-411d-8456-267e09833358"},{"index":8581,"token":false,"name":"Murderous Betrayal","scryfallId":"0063ed19-494b-4199-9120-d479bfcb625a"},{"index":8582,"token":false,"name":"Crown of Doom","scryfallId":"201a7054-e4e8-4e5a-a002-319fcd210994"},{"index":8584,"token":false,"name":"Catalog","scryfallId":"0b50620d-430e-4c38-a95d-3d69a4c29ff9"},{"index":8585,"token":false,"name":"Careful Study","scryfallId":"59d28041-1ca2-4fba-a802-72e0ba592165"},{"index":8588,"token":false,"name":"Part Water","scryfallId":"4b659475-c8b7-493d-af63-04f34d8cc3b1"},{"index":8589,"token":false,"name":"Bestial Menace","scryfallId":"434b99c2-26f5-4d45-8453-77d9dedb7892"},{"index":8591,"token":false,"name":"Smoldering Tar","scryfallId":"fcdc55c0-c8ac-49d5-969b-9bf0ee8e696c"},{"index":8592,"token":true,"name":"Wall Token (W, 0/3)","scryfallId":"e8ae8c31-70cb-44e1-a105-f4d29f1f9356"},{"index":8594,"token":false,"name":"Treefolk Mystic","scryfallId":"9697acf5-9bc5-411d-8574-fe6185f18672"},{"index":8596,"token":false,"name":"Warden of Evos Isle","scryfallId":"8c58807d-1663-486a-ac94-627a8677f2b3"},{"index":8598,"token":false,"name":"Cinderclasm","scryfallId":"5516cf97-805f-4a21-a4c6-2d6e55865336"},{"index":8599,"token":false,"name":"Ridged Kusite","scryfallId":"a51ea7d3-a9d7-4b1d-bf3b-3fcfb6a49624"},{"index":8601,"token":false,"name":"Balance of Power","scryfallId":"ae27edb4-424b-4a2f-a588-d3b60c8d78e5"},{"index":8602,"token":false,"name":"Gustcloak Skirmisher","scryfallId":"71262335-cccc-4484-bc3b-93e16f5161f9"},{"index":8603,"token":false,"name":"Coralhelm Commander","scryfallId":"4f8d1bea-58cd-4483-a70a-0330ad5ab4a1"},{"index":8605,"token":false,"name":"Fencing Ace","scryfallId":"86d8754c-816f-4d07-8dcd-9611bf0beb87"},{"index":8608,"token":false,"name":"Nicol Bolas","scryfallId":"8e92ba96-372c-418d-b271-45e1bf5c7af5"},{"index":8610,"token":false,"name":"Rings of Brighthearth","scryfallId":"3c7c38ea-a1a4-47dd-9d73-a84872b57736"},{"index":8611,"token":false,"name":"Nim Deathmantle","scryfallId":"f638bd96-8424-461f-87bf-4b7a7153fd35"},{"index":8615,"token":false,"name":"Sanctum of Calm Waters","scryfallId":"80b2fb65-5868-4cab-b45d-e103558ce7dc"},{"index":8617,"token":false,"name":"Superior Numbers","scryfallId":"43d90914-ddfc-49c2-8e58-fdc3693040f2"},{"index":8618,"token":false,"name":"Mishra's Workshop","scryfallId":"85c857d8-7703-48e6-a5ed-9385e621755c"},{"index":8619,"token":false,"name":"Felidar Sovereign","scryfallId":"78769295-e1e3-4bd7-9ece-b60e124efbba"},{"index":8620,"token":false,"name":"Aether Figment","scryfallId":"15fd5ce4-335f-409c-a09e-e17a41c2da71"},{"index":8621,"token":false,"name":"Woe Strider","scryfallId":"b90e9037-87e0-4ad6-a4e4-c5f55a60007c"},{"index":8622,"token":false,"name":"Chimeric Mass","scryfallId":"3ef3dea8-b3e5-432e-a65d-442fe06ca976"},{"index":8623,"token":false,"name":"Giant Oyster","scryfallId":"f8045d23-e6e6-474c-a3e7-ddfc6121657a"},{"index":8624,"token":false,"name":"Arashin Sovereign","scryfallId":"ff954f7c-3778-4650-9d4f-48beb6e4fda0"},{"index":8625,"token":false,"name":"Ashiok, Nightmare Muse","scryfallId":"eee1d0b9-64c0-466e-978d-31e744f156d6"},{"index":8626,"token":false,"name":"Quicksilver Dagger","scryfallId":"a376f7a3-50fa-4be9-830c-102507682256"},{"index":8630,"token":false,"name":"Soldevi Adnate","scryfallId":"8b2651b0-1ab2-4d7e-834f-7505797da474"},{"index":8638,"token":false,"name":"Wrap in Flames","scryfallId":"babdaf80-f9a3-42cb-9df6-10878301f335"},{"index":8640,"token":false,"name":"Syncopate","scryfallId":"d6be7925-5466-4c75-9651-3a314baff72a"},{"index":8641,"token":false,"name":"Vampire Nocturnus","scryfallId":"b0d8588f-7986-4c35-b230-375287b4f475"},{"index":8642,"token":false,"name":"Scuttling Doom Engine","scryfallId":"16f74ee4-f647-49b1-88b8-1aae8df3b271"},{"index":8643,"token":false,"name":"Protector of the Crown","scryfallId":"d4ed6d32-abee-42f1-b47f-3c168465bf6b"},{"index":8645,"token":false,"name":"Tarmogoyf","scryfallId":"2b49dfb7-dbe7-4a2b-b9de-c620a0db2e47"},{"index":8647,"token":false,"name":"Ghost-Lit Stalker","scryfallId":"0d3cc092-b673-4f4e-b9a8-8e60ff562dbd"},{"index":8648,"token":false,"name":"Botanical Sanctum","scryfallId":"813ed97e-58d9-4471-9316-cb1db340cd20"},{"index":8650,"token":false,"name":"Bonds of Quicksilver","scryfallId":"c071dca0-fccb-48b8-b65a-74741b12e3f0"},{"index":8653,"token":false,"name":"Decree of Silence","scryfallId":"f2fc46e2-5e19-4999-a4cd-1e84697066c1"},{"index":8654,"token":true,"name":"Booster Sleuth // Booster Sleuth (cont'd)","scryfallId":"44b0da54-3c2e-42d9-b46b-a67bb7fd10fe"},{"index":8657,"token":false,"name":"Martyr of Frost","scryfallId":"b249136c-94d4-4f65-95a4-d45b4f20429b"},{"index":8658,"token":false,"name":"Hand to Hand","scryfallId":"af4cb86a-db01-4d9a-99e9-bb50ce23507f"},{"index":8659,"token":false,"name":"Long-Forgotten Gohei","scryfallId":"6fc4b500-ca74-4b90-9a8c-d4efa80ebe2c"},{"index":8660,"token":false,"name":"Volcanic Dragon","scryfallId":"d99c5c70-7568-42d3-939c-b6ee1ed94b9f"},{"index":8664,"token":false,"name":"Hell's Caretaker","scryfallId":"b6269968-0f58-4e20-94d0-678d39207988"},{"index":8665,"token":false,"name":"Ogre Leadfoot","scryfallId":"e3c77744-3a86-46cf-9e0f-5a217a1c08b9"},{"index":8667,"token":false,"name":"Azorius Guildgate","scryfallId":"9c116304-0e37-498a-898d-51d1b75d54c7"},{"index":8671,"token":false,"name":"Steel Overseer","scryfallId":"292ac228-7a1e-4c21-b81e-204014c0f3b1"},{"index":8673,"token":false,"name":"Grindstone","scryfallId":"f4459187-de64-456f-bb66-56dea40d5c3e"},{"index":8674,"token":false,"name":"Banewhip Punisher","scryfallId":"005a19e2-c334-4b87-bc8b-55f62fc9abd9"},{"index":8677,"token":false,"name":"Hyalopterous Lemure","scryfallId":"d2c9e037-f4d5-46fd-b439-56bee6fb2ad3"},{"index":8678,"token":false,"name":"Veteran Bodyguard","scryfallId":"6ef12925-e181-47be-81cd-4c1d55ad8395"},{"index":8680,"token":false,"name":"Ruins of Oran-Rief","scryfallId":"1316b473-ec52-474e-87b8-07e21fda5482"},{"index":8682,"token":false,"name":"Ishai, Ojutai Dragonspeaker","scryfallId":"3e7b2b70-1a86-4d3d-84e0-e17c73f391ed"},{"index":8686,"token":false,"name":"One with the Stars","scryfallId":"98b7070d-4b09-4390-aa21-1bc0aa2b629c"},{"index":8692,"token":false,"name":"Body of Research","scryfallId":"98b56823-0076-49cc-b5aa-4accb8e2782e"},{"index":8693,"token":false,"name":"Reef Worm","scryfallId":"b35e03a9-73e7-4577-a544-d39470678c76"},{"index":8697,"token":false,"name":"Street Wraith","scryfallId":"ea7edbaa-68c8-4a1c-ab5f-d096e74c0d01"},{"index":8699,"token":false,"name":"Tower Gargoyle","scryfallId":"f2562ab8-6491-4f13-bd20-4e4eacf840cb"},{"index":8700,"token":false,"name":"Kaervek the Merciless","scryfallId":"444fa5a5-b5b0-4555-bd69-67c1c0cbf317"},{"index":8701,"token":false,"name":"Kolvori, God of Kinship // The Ringhart Crest","scryfallId":"b76bed98-30b1-4572-b36c-684ada06826c"},{"index":8703,"token":false,"name":"Liege of the Tangle","scryfallId":"f7fc5b67-f521-4ba4-a10f-103e8b6af688"},{"index":8707,"token":false,"name":"Two-Headed Dragon","scryfallId":"1501ca1d-1c76-4786-a395-86986b4f2962"},{"index":8708,"token":false,"name":"Hurkyl's Recall","scryfallId":"5115baa1-9392-4067-b438-b79dfe32a5b4"},{"index":8711,"token":false,"name":"Teferi, Time Raveler","scryfallId":"6e2b2e55-21a3-4f71-a14b-d3d1b137d18c"},{"index":8715,"token":false,"name":"Gang of Devils","scryfallId":"0430b9fa-3bc6-4183-ad5b-d70ad401fa97"},{"index":8717,"token":false,"name":"Drag to the Underworld","scryfallId":"91852444-9361-4588-a44f-fb90ba1b30e5"},{"index":8718,"token":false,"name":"Detention Vortex","scryfallId":"54ebe581-be17-415a-a160-28d8f4e95636"},{"index":8723,"token":false,"name":"Ashnod's Altar","scryfallId":"91ca97db-2c83-4c87-9491-e5878293afe5"},{"index":8724,"token":false,"name":"Scrounging Bandar","scryfallId":"761a11a7-175d-440d-b09d-918572c8e5d3"},{"index":8725,"token":false,"name":"Boulderfall","scryfallId":"66470bac-cce0-4e79-82f9-9fb77aa950eb"},{"index":8728,"token":false,"name":"Foundry of the Consuls","scryfallId":"09d83c1d-6916-48e7-8a0d-b5abadc34b2a"},{"index":8729,"token":false,"name":"Crawling Filth","scryfallId":"9c735bda-5454-4177-a23a-f9f00b7480d2"},{"index":8734,"token":false,"name":"Mire Triton","scryfallId":"d9dc87b3-60b2-4cf8-b620-334700db1aa9"},{"index":8737,"token":false,"name":"Sluiceway Scorpion","scryfallId":"7b6dbadf-a6f7-4876-9c3f-44e4a33b2bee"},{"index":8738,"token":false,"name":"Down // Dirty","scryfallId":"c35c63c1-6344-4d8c-8f7d-cd253d12f9ae"},{"index":8740,"token":false,"name":"Undying Evil","scryfallId":"325f2243-54fd-484b-a742-166cea7ec179"},{"index":8741,"token":false,"name":"Toski, Bearer of Secrets","scryfallId":"86fba621-3cda-4090-999e-84ae4897c576"},{"index":8742,"token":false,"name":"Chain Reaction","scryfallId":"288fd67a-46ee-417d-b2ce-05944e30011e"},{"index":8743,"token":false,"name":"Dwarven Soldier","scryfallId":"0dfb3fa6-f4d7-4ed0-b2be-661d59d95800"},{"index":8745,"token":false,"name":"Doomgape","scryfallId":"173fd1c6-ffd9-424f-ad65-90b193edbe00"},{"index":8746,"token":false,"name":"Skyrider Elf","scryfallId":"477eb787-aec7-43fd-9813-184111d9dcc5"},{"index":8747,"token":false,"name":"Sundering Growth","scryfallId":"14d5048e-cb76-48c4-8a95-70dcc14775f6"},{"index":8749,"token":false,"name":"Fault Riders","scryfallId":"1c9d3579-3fc1-434e-8f26-d5dbd6344429"},{"index":8751,"token":false,"name":"Canyon Slough","scryfallId":"5d2af3bd-35a3-4a94-b35d-ea493ac0dc17"},{"index":8753,"token":false,"name":"Bronze Guardian","scryfallId":"8cd5cc66-2ade-4142-9269-7d9905b029e5"},{"index":8754,"token":false,"name":"Augmenting Automaton","scryfallId":"7d017798-8278-4f9c-a691-912935c10c20"},{"index":8755,"token":false,"name":"Whitewater Naiads","scryfallId":"3f61c85c-03cf-411a-aa66-cbe178aeaa02"},{"index":8757,"token":false,"name":"Foul-Tongue Invocation","scryfallId":"ac6d021a-7bb8-4173-9a2f-e4a1d21fda8e"},{"index":8758,"token":false,"name":"Serra Bestiary","scryfallId":"c92bb33d-567c-4504-8e3c-5152fb61d100"},{"index":8760,"token":false,"name":"Moon Sprite","scryfallId":"f0944759-ee9f-4ae0-9d1b-2533ff6791a2"},{"index":8762,"token":false,"name":"Lay Claim","scryfallId":"713bc732-1d06-4c0a-925e-be5fe9503a5d"},{"index":8763,"token":false,"name":"Oracle's Attendants","scryfallId":"0dc85607-dfdd-4989-b299-c68adb8c7159"},{"index":8764,"token":false,"name":"Ramunap Excavator","scryfallId":"90a54d18-8403-441d-a115-ee462fabdabb"},{"index":8765,"token":false,"name":"Rhet-Crop Spearmaster","scryfallId":"2f4228f0-03bf-4a33-a226-a694df6b9f3b"},{"index":8767,"token":false,"name":"Crossbow Infantry","scryfallId":"d61cc896-1da5-419c-87db-01321522c40b"},{"index":8768,"token":false,"name":"Makeshift Mannequin","scryfallId":"89dfcad2-a737-405b-b3df-9583e6f0dd54"},{"index":8770,"token":false,"name":"Jandor's Ring","scryfallId":"2b56c9ed-c912-4829-9be0-e80303759c9c"},{"index":8771,"token":false,"name":"Bring to Light","scryfallId":"d25b13a4-6282-4426-8b01-9550f7d52d16"},{"index":8772,"token":false,"name":"Pentad Prism","scryfallId":"2a2862c5-afa8-4e38-a312-483300f8b194"},{"index":8773,"token":false,"name":"Phantom Tiger","scryfallId":"32839296-e583-4f71-aa44-dbe16408665e"},{"index":8774,"token":false,"name":"Child of Thorns","scryfallId":"b32c342f-ee1a-461c-9082-d2f6d9412f54"},{"index":8775,"token":false,"name":"Fomori Nomad","scryfallId":"cfd3eadb-74bb-423b-923f-a6fc2259e0d7"},{"index":8777,"token":false,"name":"Voice of the Provinces","scryfallId":"c2599730-fc82-468b-bb5c-7e722dbabbe7"},{"index":8778,"token":false,"name":"Kitchen Imp","scryfallId":"20c7b777-c002-45c7-b2bb-d21dab591445"},{"index":8783,"token":false,"name":"Champion of the Parish","scryfallId":"ec2120ff-a6d4-4192-96c0-33c139155ddf"},{"index":8784,"token":false,"name":"Mercurial Geists","scryfallId":"8bb0e56e-48d5-4e0e-91f3-8f5a39151e2b"},{"index":8785,"token":false,"name":"Chameleon Spirit","scryfallId":"05972ea2-b0bc-40fd-bce4-07eebdb150d5"},{"index":8788,"token":false,"name":"Fledgling Djinn","scryfallId":"0863567a-13d6-4876-99eb-c592c3ea49a3"},{"index":8789,"token":false,"name":"Living Airship","scryfallId":"b0441eef-392e-4af4-b189-2f1fb8bf3fca"},{"index":8790,"token":false,"name":"Vona's Hunger","scryfallId":"aab958d5-9c1f-420f-b358-ec0325f22f84"},{"index":8792,"token":false,"name":"Plated Pegasus","scryfallId":"873fddf3-40e7-41ee-9519-98d0a5268fd1"},{"index":8793,"token":false,"name":"Auger Spree","scryfallId":"9580a40b-b413-4f0d-9b38-13903a9d367d"},{"index":8796,"token":false,"name":"Crusader of Odric","scryfallId":"b81e6aaa-aea4-4187-a4ca-fbbea0d10c7d"},{"index":8797,"token":false,"name":"Seafloor Stalker","scryfallId":"985e9696-6c76-4241-97fc-f166fe2420ce"},{"index":8801,"token":false,"name":"Oros, the Avenger","scryfallId":"c287d593-cfd0-46b6-bde0-0c04a83d828b"},{"index":8805,"token":false,"name":"Remote Isle","scryfallId":"e48d55ff-10d0-4d9b-9202-02ebb2137953"},{"index":8806,"token":false,"name":"Goblin Deathraiders","scryfallId":"0c0b85d3-ce46-4f12-8315-4cbf338eb8f0"},{"index":8808,"token":false,"name":"Artisan's Sorrow","scryfallId":"b4f38f7e-2369-48c9-9121-4b13c29ea869"},{"index":8810,"token":false,"name":"Witch-Maw Nephilim","scryfallId":"185d56ab-b7f2-4eb2-9540-db8f2dc9b436"},{"index":8811,"token":false,"name":"Armored Whirl Turtle","scryfallId":"fcc87fdf-6473-4b91-a8b9-2986e57dc071"},{"index":8812,"token":false,"name":"Dirge Bat","scryfallId":"30d3dc97-3590-457b-ae02-2d2a6acb49e7"},{"index":8813,"token":false,"name":"Porphyry Nodes","scryfallId":"dfe6f333-ccb4-44ea-be59-bba6335acf99"},{"index":8817,"token":false,"name":"Land Grant","scryfallId":"d6862005-32d1-473e-a28b-5dfc4b7782cd"},{"index":8818,"token":false,"name":"Spore Cloud","scryfallId":"17fe098c-c9b5-4bba-92b5-5720d6919073"},{"index":8820,"token":false,"name":"Sphere of Duty","scryfallId":"4bdcd0de-6466-488c-a882-bad80c86504d"},{"index":8822,"token":false,"name":"Marauding Raptor","scryfallId":"0da7e676-202c-441e-9515-0f33849f8968"},{"index":8823,"token":false,"name":"Quest for the Goblin Lord","scryfallId":"e23adb09-d216-47f5-a7d4-cb6a2ce48ada"},{"index":8824,"token":false,"name":"Reanimate","scryfallId":"0de43163-a243-4d32-93ee-22fcea52f0eb"},{"index":8825,"token":false,"name":"Repentance","scryfallId":"7d02c74a-8bc7-4a4d-830b-e59a7aed5722"},{"index":8828,"token":false,"name":"Ravenous Chupacabra","scryfallId":"06c5f722-949d-41c9-9444-c9c9f1d3baf5"},{"index":8829,"token":false,"name":"Bontu the Glorified","scryfallId":"34fab289-9ef7-49ca-b5c8-0ade254bda28"},{"index":8830,"token":false,"name":"Cetavolver","scryfallId":"69063cc2-4f6e-4cce-bb09-ccd57b69b993"},{"index":8831,"token":false,"name":"Crown of Empires","scryfallId":"1482eb68-64f2-48de-a535-a76af462ecac"},{"index":8833,"token":false,"name":"Raven Guild Initiate","scryfallId":"c1e11f70-06c3-4dc5-aafe-82d65080085e"},{"index":8835,"token":false,"name":"Balshan Collaborator","scryfallId":"e23ebd3b-59bf-4f3d-b320-9283871c4540"},{"index":8839,"token":false,"name":"Firestorm","scryfallId":"e674aa8a-668a-4345-95ee-73a0b87bbcb1"},{"index":8841,"token":false,"name":"Decree of Justice","scryfallId":"2a8cf425-6272-459c-95d4-fd7a9719cf60"},{"index":8842,"token":false,"name":"Dawn to Dusk","scryfallId":"026ee3ff-bfd3-42d7-a4fa-2a6372599aef"},{"index":8846,"token":false,"name":"Selvala, Heart of the Wilds","scryfallId":"99a3e619-fbdb-406c-9f21-eb582cb878c0"},{"index":8848,"token":false,"name":"Unstable Shapeshifter","scryfallId":"84e8cbd4-f49d-420d-a027-3be64ca58989"},{"index":8851,"token":false,"name":"Risen Sanctuary","scryfallId":"a0b6c136-2bbe-48c1-ac53-2a8221b96936"},{"index":8853,"token":false,"name":"Hamletback Goliath","scryfallId":"01ddeef1-f6f9-48c0-a93c-7bb3877c0e59"},{"index":8854,"token":false,"name":"Linden, the Steadfast Queen","scryfallId":"052ab231-6575-4682-9208-13ac6b9d7910"},{"index":8856,"token":false,"name":"Guardians of Meletis","scryfallId":"cde06929-b16b-44ce-9bd9-82806ec5e04b"},{"index":8857,"token":false,"name":"Krenko's Command","scryfallId":"84df41e9-e973-4441-b17f-434517134d46"},{"index":8859,"token":false,"name":"The Birth of Meletis","scryfallId":"d824f8bd-58f8-4796-80b5-5cd3033d35e8"},{"index":8860,"token":false,"name":"Combat Medic","scryfallId":"9cfd96cb-03d6-4845-8595-50bf17b35726"},{"index":8863,"token":false,"name":"Kraken Hatchling","scryfallId":"45d100a3-93f2-428c-8f54-8807e71f2638"},{"index":8864,"token":false,"name":"Agonizing Remorse","scryfallId":"57b7f7bd-6db3-4716-b1c3-015b0a6d37e3"},{"index":8866,"token":false,"name":"Witch Hunt","scryfallId":"1db6d2a4-183e-47ff-bebe-efefd4bcc4be"},{"index":8868,"token":true,"name":"Randy Buehler Bio","scryfallId":"23239786-8ac6-460c-9c19-c439b8fa9734"},{"index":8872,"token":false,"name":"Firedrinker Satyr","scryfallId":"683eaf5a-2f43-477f-b212-70ca5fe04f13"},{"index":8873,"token":false,"name":"Anaconda","scryfallId":"0a2012ad-6425-4935-83af-fc7309ec2ece"},{"index":8874,"token":false,"name":"Rune of Sustenance","scryfallId":"0e31b716-f325-445a-9098-9ca75d7b35a4"},{"index":8876,"token":false,"name":"Watchful Giant","scryfallId":"61a38f24-1eb3-4914-be1f-0b5f6d4b09d5"},{"index":8878,"token":false,"name":"Enduring Sliver","scryfallId":"6ed0f6a5-ed40-44fc-a5e1-3f8bb968d1d9"},{"index":8879,"token":false,"name":"Stealer of Secrets","scryfallId":"02acbe9b-fac7-4135-8318-5f3dc93a9e58"},{"index":8884,"token":false,"name":"Spike Rogue","scryfallId":"f0d9b671-344b-460d-8f65-d65129db91c3"},{"index":8885,"token":false,"name":"Flailing Manticore","scryfallId":"6eee8c2e-bda7-4bf9-80fe-87d96024ca8b"},{"index":8887,"token":false,"name":"Efreet Weaponmaster","scryfallId":"8986cb2e-76e0-41f3-8810-3d11c39a527a"},{"index":8888,"token":false,"name":"Phyrexian Ingester","scryfallId":"cb95f8a3-af5d-4cf0-b1cb-4fa99033be36"},{"index":8890,"token":false,"name":"Zuran Spellcaster","scryfallId":"29d414a2-9afd-4bf1-908a-d9b5bea06222"},{"index":8892,"token":false,"name":"Soul Shred","scryfallId":"036d6420-ac71-47b4-869f-64381dcf3348"},{"index":8893,"token":false,"name":"Universal Solvent","scryfallId":"aac2aed4-bae5-4f92-b94f-b4820a0e1f7f"},{"index":8895,"token":false,"name":"Unholy Hunger","scryfallId":"5994b7b0-3bca-480b-b265-ed269f15c17e"},{"index":8897,"token":false,"name":"Primitive Etchings","scryfallId":"eae26b8d-c3af-42d1-94f4-56950ceac1c7"},{"index":8899,"token":false,"name":"Maw of Kozilek","scryfallId":"48669993-ad68-499e-8f2e-bc5c651b4b28"},{"index":8900,"token":false,"name":"Crown of Suspicion","scryfallId":"8953e11b-cc3a-4c8d-9d7e-04bf90c77027"},{"index":8901,"token":false,"name":"Tel-Jilad Fallen","scryfallId":"643891b6-23d0-4734-81e0-b315d2d58f50"},{"index":8902,"token":false,"name":"Nyxborn Eidolon","scryfallId":"76f79804-cd90-472b-9d09-3c71e4c6be22"},{"index":8904,"token":false,"name":"Eye of Ugin","scryfallId":"a49e324f-8727-4ab5-aa76-c3c3c8725602"},{"index":8908,"token":false,"name":"Reyhan, Last of the Abzan","scryfallId":"8afad106-a49b-4910-959e-228c109ea983"},{"index":8909,"token":false,"name":"Daemogoth Titan","scryfallId":"b6a595a8-20f3-49e9-82ca-18923958f21b"},{"index":8912,"token":false,"name":"Radiant Destiny","scryfallId":"9d44584d-e501-40aa-b3f2-a6155e2ee6e7"},{"index":8913,"token":false,"name":"Swift Justice","scryfallId":"a94801ba-0295-4611-abda-4c6508d69cc3"},{"index":8916,"token":false,"name":"Cold-Eyed Selkie","scryfallId":"0c70d33b-b898-4f0e-a133-5f003ecca6d6"},{"index":8918,"token":false,"name":"Welcome to the Fold","scryfallId":"2d07fbe1-e66a-4893-86ee-7752ad77b120"},{"index":8919,"token":false,"name":"Spellshock","scryfallId":"75ff468c-fdc6-49f1-bcec-1ba70fc60d5d"},{"index":8920,"token":false,"name":"Unstable Obelisk","scryfallId":"6821525c-91e5-4264-91bf-5095422e0751"},{"index":8925,"token":false,"name":"Dryad of the Ilysian Grove","scryfallId":"36adefc7-44a8-40d0-8bdf-ad12d010b0bd"},{"index":8926,"token":false,"name":"Myriad Construct","scryfallId":"db9b1de4-9aba-4145-804d-2072f258af3b"},{"index":8927,"token":false,"name":"Awaken the Erstwhile","scryfallId":"ea166114-2f9b-4ca6-b573-1f49f7485580"},{"index":8928,"token":false,"name":"Taurean Mauler","scryfallId":"f0d098fc-439e-4dfa-a400-50108537fde6"},{"index":8931,"token":false,"name":"Cemetery Reaper","scryfallId":"d51634e0-84ee-4432-9ef4-c3f3cff01647"},{"index":8932,"token":false,"name":"Temple of Malice","scryfallId":"52f50818-aede-4667-883a-e0339d86d870"},{"index":8933,"token":false,"name":"Jungle Hollow","scryfallId":"b7c3df5f-baa6-4cbd-8ecf-cdf590475172"},{"index":8934,"token":false,"name":"Ana Disciple","scryfallId":"7efe00f9-bf42-4d6f-9a22-b357b1c1e092"},{"index":8935,"token":false,"name":"Epic Experiment","scryfallId":"42f0b68a-de4b-4c0c-98ac-a812017f88a7"},{"index":8936,"token":false,"name":"Simic Locket","scryfallId":"29c65978-e5b0-428e-aace-f99768ca6106"},{"index":8937,"token":false,"name":"Inkfathom Divers","scryfallId":"758a8ca6-1fc1-454a-a2be-9745ac964eb7"},{"index":8940,"token":false,"name":"Crosis's Charm","scryfallId":"b5e1e94d-6876-4351-9c6e-98882e277ccc"},{"index":8942,"token":false,"name":"Lys Alana Huntmaster","scryfallId":"acb2ccaf-19fa-440f-8cb1-d4404a3a289c"},{"index":8943,"token":false,"name":"Soulcatcher","scryfallId":"14d24d2f-699b-46d8-9353-45e6a67f99d2"},{"index":8945,"token":false,"name":"No Rest for the Wicked","scryfallId":"c20a4bce-15db-43a7-9514-5e657b618aac"},{"index":8946,"token":false,"name":"Samite Ministration","scryfallId":"b1de62ed-79e6-4daf-a2ab-dc0726e1f7df"},{"index":8947,"token":false,"name":"Pharika's Libation","scryfallId":"0307bb5c-0a46-4f6b-b6d5-58cf31987bb5"},{"index":8948,"token":false,"name":"Clearwater Goblet","scryfallId":"20b81117-d2f3-46fb-ab04-236374daff47"},{"index":8952,"token":false,"name":"Lightning Stormkin","scryfallId":"43c6db4e-cc37-4473-b0f5-48d8a0b82f33"},{"index":8953,"token":false,"name":"Mystic Archaeologist","scryfallId":"1b19cad0-5754-4625-8303-c8310bc7cbd5"},{"index":8954,"token":false,"name":"Blinding Souleater","scryfallId":"2220e9dd-f1d8-4a69-9df9-1322e4a5cdc7"},{"index":8957,"token":false,"name":"Steward of Solidarity","scryfallId":"eda3cd3b-d4c5-4537-8c81-5ccf269f810e"},{"index":8961,"token":false,"name":"Baloth Null","scryfallId":"8811d210-23e2-4318-9730-7ee3b2021c68"},{"index":8963,"token":false,"name":"Crystal Chimes","scryfallId":"17a453d0-c195-47fd-ad6b-d31c86faef71"},{"index":8965,"token":false,"name":"Mirror Entity","scryfallId":"ce459d29-af63-4714-a1df-f33ecbf33708"},{"index":8966,"token":false,"name":"Jinxed Ring","scryfallId":"1c675814-094c-45d4-93ee-0f50b4755e79"},{"index":8967,"token":true,"name":"Giant Warrior Token (W, 5/5)","scryfallId":"0661166a-7d6c-4cba-8190-8d3eedf7f58c"},{"index":8969,"token":false,"name":"Flight of Equenauts","scryfallId":"accfc430-114e-4ce0-93ea-e8900955a71e"},{"index":8970,"token":false,"name":"Arcades, the Strategist","scryfallId":"eb5ed016-2272-43fb-89c8-d6b3a96b69c4"},{"index":8971,"token":false,"name":"Spectral Cloak","scryfallId":"7524fd0d-a675-41d6-bc99-bd3ba336893b"},{"index":8972,"token":false,"name":"Selvala's Enforcer","scryfallId":"000ba9c3-cd88-47c1-966a-00466569a9bf"},{"index":8974,"token":false,"name":"Shepherd of Rot","scryfallId":"952c021f-74c9-455f-9cd9-f0d354e8bea8"},{"index":8975,"token":false,"name":"Rift Bolt","scryfallId":"88dde96e-6824-4d26-9fb5-86b9f3c50959"},{"index":8977,"token":false,"name":"Jungle Weaver","scryfallId":"5f46870b-3d8d-4aae-8d59-6bd88a50b37c"},{"index":8978,"token":false,"name":"Untamed Might","scryfallId":"17979f0e-bd39-449f-b4ed-9156c229223b"},{"index":8982,"token":false,"name":"Countless Gears Renegade","scryfallId":"c2d6f334-0040-42b1-9c72-362e4dcaa65e"},{"index":8986,"token":false,"name":"Dread of Night","scryfallId":"d08586d4-8163-454c-b8d8-c5034c4aee6c"},{"index":8990,"token":false,"name":"Sword of Truth and Justice","scryfallId":"2be8d24e-1370-4e85-90f2-66b6d6e9c4a4"},{"index":8993,"token":false,"name":"Fabled Passage","scryfallId":"d313d051-7295-4884-8cbf-f2f835fd45f4"},{"index":8995,"token":false,"name":"Reflector Mage","scryfallId":"cf8229a3-a65e-4e9c-beb6-5752de53eb56"},{"index":8996,"token":true,"name":"Whale Token (U, 6/6)","scryfallId":"ccd172b9-377a-4dbf-a11a-e4985da62c72"},{"index":8997,"token":false,"name":"Minotaur Sureshot","scryfallId":"777b98c3-d0b8-4ee3-9d89-e86344269ff1"},{"index":8998,"token":false,"name":"Biowaste Blob","scryfallId":"699ee8a9-a06c-4f95-9308-f8f7fb272568"},{"index":9000,"token":false,"name":"Fragmentize","scryfallId":"5bf09deb-2607-4eb0-94a7-9584e771fdfb"},{"index":9002,"token":false,"name":"Rootwater Mystic","scryfallId":"94af81f2-383c-4129-b8dc-60633c3f4ea1"},{"index":9003,"token":false,"name":"Guildless Commons","scryfallId":"c6c8d290-b5d2-412c-8db9-5a6246f430e8"},{"index":9005,"token":false,"name":"Rebuild","scryfallId":"4dc1613c-a149-4f04-9950-41637d35d675"},{"index":9006,"token":false,"name":"Remorseful Cleric","scryfallId":"2e91e16a-f122-4f93-a350-c40b98d18c98"},{"index":9007,"token":false,"name":"Vesuvan Shapeshifter","scryfallId":"458031cc-238d-45f0-9a81-b52e82286e0f"},{"index":9008,"token":false,"name":"Temple of Silence","scryfallId":"d9c95724-9851-4567-9017-b3ef8ace5e8a"},{"index":9009,"token":false,"name":"Walking Corpse","scryfallId":"344a26ab-524f-4daa-ae0a-9d94e34c96df"},{"index":9014,"token":false,"name":"Lumengrid Warden","scryfallId":"44aadd54-6e83-4bcf-9760-16479d919a56"},{"index":9016,"token":false,"name":"Cathedral of Serra","scryfallId":"e65356e6-0ead-49fd-b069-be1ea9b1c105"},{"index":9018,"token":false,"name":"Labyrinth Minotaur","scryfallId":"eb8c1786-a2c1-43f9-9cef-8c4542833093"},{"index":9019,"token":false,"name":"Kraul Swarm","scryfallId":"490dc165-b10d-4384-8c13-d7969844b2bb"},{"index":9020,"token":false,"name":"Marshdrinker Giant","scryfallId":"04d1fbb7-aa02-4f56-8be7-88a3ba55f7d2"},{"index":9022,"token":false,"name":"Nightshade Assassin","scryfallId":"2e57492c-ca26-4f75-a27e-5c54967534ea"},{"index":9024,"token":false,"name":"Orzhov Enforcer","scryfallId":"6a72b49e-be14-485b-a467-31cbac9aa1c5"},{"index":9028,"token":false,"name":"Library of Lat-Nam","scryfallId":"9ea40438-90ca-47ff-9805-df130d47ae48"},{"index":9030,"token":true,"name":"Dragon Token (Colorless, 4/4)","scryfallId":"6819b8c9-73a3-4e8e-ad7a-95cffabf873a"},{"index":9031,"token":false,"name":"Fiery Fall","scryfallId":"1c4f7a3f-9d88-43ca-a0ae-6b29db197a89"},{"index":9032,"token":false,"name":"Affa Guard Hound","scryfallId":"f762546c-f5eb-420d-a8f7-c3566cd8f506"},{"index":9034,"token":false,"name":"Korozda Guildmage","scryfallId":"761c16aa-d4a7-492d-9275-98d0e07de45a"},{"index":9036,"token":false,"name":"Khabál Ghoul","scryfallId":"98f443cb-55bb-4e83-826a-98261287bfd3"},{"index":9037,"token":true,"name":"Human Soldier Token (W, 1/1)","scryfallId":"90de6d1e-e654-4f4a-8014-061ce69e540f"},{"index":9038,"token":false,"name":"Lay Bare the Heart","scryfallId":"d4b76ff8-b26c-4567-9339-bb6a37713f4b"},{"index":9039,"token":false,"name":"Parallax Wave","scryfallId":"ee88fd61-900d-49cb-a967-52fad325b6c5"},{"index":9043,"token":false,"name":"Dismissive Pyromancer","scryfallId":"172b35c3-af41-4619-9a99-b68b4913e478"},{"index":9045,"token":false,"name":"Ketria Triome","scryfallId":"d40ef5f6-9221-4b7d-8566-58ad43e77f02"},{"index":9046,"token":false,"name":"Restock","scryfallId":"11a013ff-7c99-445a-b9e0-0fc45036f068"},{"index":9047,"token":true,"name":"Bird Token (U/W, 1/1)","scryfallId":"a813c741-d0d4-48cd-9bbf-8a04a544ce8e"},{"index":9048,"token":false,"name":"Tunneler Wurm","scryfallId":"c8e246c8-3b3f-47c4-8a1b-b5f2d36f0ca4"},{"index":9049,"token":false,"name":"Sighted-Caste Sorcerer","scryfallId":"d07e2d4c-a33b-42b1-9576-2269d137a868"},{"index":9050,"token":false,"name":"Akki Lavarunner // Tok-Tok, Volcano Born","scryfallId":"6ee6cd34-c117-4d7e-97d1-8f8464bfaac8"},{"index":9051,"token":false,"name":"Zombie Cutthroat","scryfallId":"fe491cba-6ec7-4c44-ad1e-832d936986a0"},{"index":9054,"token":false,"name":"Inner Demon","scryfallId":"dcbfc305-f3b3-4f8f-b18f-bb7af01a39a4"},{"index":9056,"token":false,"name":"Pyric Salamander","scryfallId":"7f2dc1a7-4b70-4643-90a8-fdc7877c01ca"},{"index":9058,"token":false,"name":"Sword of Vengeance","scryfallId":"032af060-4d49-4a0a-8841-9eb2d45a4b77"},{"index":9059,"token":false,"name":"Knotvine Paladin","scryfallId":"a715673f-77f1-46d6-91ae-01fb3af54760"},{"index":9061,"token":false,"name":"Akiri, Fearless Voyager","scryfallId":"52ec2a93-0708-498e-86f2-6f70d51ae4cd"},{"index":9062,"token":false,"name":"Quandrix Campus","scryfallId":"f788da28-481b-41fa-a70c-b53db6b0f068"},{"index":9064,"token":false,"name":"Spirit en-Kor","scryfallId":"f8adc368-ede3-4b1c-af93-a5e0f2e24d83"},{"index":9065,"token":false,"name":"Dusk Urchins","scryfallId":"adce41c5-3a43-4fe0-b84e-8baaad1a0777"},{"index":9068,"token":false,"name":"Embodiment of Insight","scryfallId":"b034a95d-4f51-4f04-94c2-dad073ea0f35"},{"index":9069,"token":false,"name":"Sanguine Bond","scryfallId":"ad4de9f1-7a39-45af-828e-c59234d9e9b9"},{"index":9071,"token":false,"name":"Undergrowth Champion","scryfallId":"d53104d8-5b9a-45b6-a2f9-b2c5d231a03d"},{"index":9072,"token":false,"name":"Gemhide Sliver","scryfallId":"f09135b0-fd57-4205-aa74-c9869946c264"},{"index":9073,"token":false,"name":"Hands of Binding","scryfallId":"afeef50a-f5c9-47ab-ad04-645f49bbae6b"},{"index":9075,"token":false,"name":"Krark, the Thumbless","scryfallId":"06a981cd-1951-438e-95c9-68294795638e"},{"index":9080,"token":false,"name":"Will-o'-the-Wisp","scryfallId":"4b60630c-f97c-43be-8410-53a68613b735"},{"index":9081,"token":false,"name":"Crimson Hellkite","scryfallId":"5451e44f-8dd2-48c6-ba67-5c62a04819ef"},{"index":9083,"token":false,"name":"Goblin Trenches","scryfallId":"2100844c-6a41-40f5-b7f8-9b426d5a6945"},{"index":9086,"token":false,"name":"Aetherborn Marauder","scryfallId":"fce02ef8-1731-43a9-9bd0-9ec592e3883f"},{"index":9091,"token":false,"name":"Gemstone Caverns","scryfallId":"7f273641-c5f3-48bc-b89e-3cff52d26a0b"},{"index":9092,"token":false,"name":"Skaab Goliath","scryfallId":"7c1134a5-5434-4733-812b-3587b1817813"},{"index":9093,"token":false,"name":"Village Rites","scryfallId":"f9e6276c-0b80-4d11-b889-8a24b210c4f0"},{"index":9094,"token":false,"name":"Jhoira of the Ghitu","scryfallId":"64553587-e707-41d2-a2f4-768dfa47e893"},{"index":9095,"token":false,"name":"Gilt-Leaf Ambush","scryfallId":"47bf7254-4302-41a0-bc87-d7dc437ff38d"},{"index":9096,"token":false,"name":"Thermal Flux","scryfallId":"523ab8a0-906a-43b3-a554-db0d3dcd62d3"},{"index":9099,"token":false,"name":"Choking Tethers","scryfallId":"14884e61-fb1e-4989-ae29-57dfd910b53f"},{"index":9100,"token":false,"name":"Sigarda, Host of Herons","scryfallId":"fcac0cff-efa6-4068-a69c-67ea4e7acea0"},{"index":9101,"token":false,"name":"Form of the Dragon","scryfallId":"1cfc77f1-290a-4394-bc16-76f3659810f0"},{"index":9102,"token":false,"name":"Epicenter","scryfallId":"1a9232ae-9f32-4bbc-a020-554b3f9cbbd3"},{"index":9103,"token":false,"name":"Flooded Strand","scryfallId":"0df37cc8-3703-406a-adaf-ee0bb9d7aa61"},{"index":9104,"token":false,"name":"Firespout","scryfallId":"8fecd098-bbf2-44f1-b9f1-7b93ea660880"},{"index":9105,"token":false,"name":"Join Shields","scryfallId":"d3a5c2e5-7914-4edc-960a-75f3dfb5afc4"},{"index":9107,"token":false,"name":"Stormfront Riders","scryfallId":"ef0e4521-7f16-49e4-b820-62af2cc807c6"},{"index":9109,"token":false,"name":"Mold Adder","scryfallId":"a216a729-6283-4c2b-90fe-ec8f3b9c570f"},{"index":9110,"token":false,"name":"Elder Pine of Jukai","scryfallId":"51c3e47b-a788-46b7-bf15-1216692e637a"},{"index":9112,"token":false,"name":"Kwain, Itinerant Meddler","scryfallId":"e30d4b6e-44c3-4bf9-8edd-aebf97438f19"},{"index":9113,"token":false,"name":"Stoneforge Masterwork","scryfallId":"937e98ff-1440-4d1a-be98-baa20105c54b"},{"index":9115,"token":false,"name":"Tribal Flames","scryfallId":"07fafa53-1e22-43f5-abf3-bbab8130f84d"},{"index":9116,"token":false,"name":"Yennett, Cryptic Sovereign","scryfallId":"870fc68d-f61b-4c05-8ddb-077415c7dda7"},{"index":9117,"token":false,"name":"Lava Tubes","scryfallId":"1f12466f-7474-48ca-b4d1-3463a34f9b00"},{"index":9118,"token":false,"name":"Manifold Key","scryfallId":"715e637a-dfd8-45a0-b1ea-53e4abd29307"},{"index":9119,"token":false,"name":"Relic Barrier","scryfallId":"12d760d8-030e-47d0-a555-d88ee43d3d80"},{"index":9120,"token":false,"name":"Moss Diamond","scryfallId":"87cea56a-b64f-452a-8e4b-40363aabb452"},{"index":9121,"token":false,"name":"Electrostatic Field","scryfallId":"7096c9a6-2e73-41f8-b20a-b29a9f0b760c"},{"index":9123,"token":false,"name":"One Thousand Lashes","scryfallId":"eef2d548-477b-4be1-b946-6df6aac2ee6e"},{"index":9124,"token":false,"name":"Thunderstaff","scryfallId":"4b5c9daf-c9a6-4cbf-8203-4ec9600b4d0e"},{"index":9125,"token":false,"name":"Sulam Djinn","scryfallId":"7aeab16f-e104-47e7-81c7-b6e0123120d7"},{"index":9127,"token":false,"name":"Deprive","scryfallId":"2efecdd9-bd3a-4b79-92da-6485589d5bde"},{"index":9128,"token":false,"name":"Minotaur Abomination","scryfallId":"9dca75a1-443d-4f8e-b12b-2aada3a8e3e4"},{"index":9129,"token":false,"name":"Pouncing Jaguar","scryfallId":"3eb106b6-cf21-4684-8c79-f84b744bd324"},{"index":9130,"token":false,"name":"Stonebrow, Krosan Hero","scryfallId":"f5fd5a5f-f051-4173-a6d1-33dff40014fb"},{"index":9131,"token":false,"name":"Khalni Ambush // Khalni Territory","scryfallId":"99535539-aa73-41ed-86ab-21c97b92620d"},{"index":9133,"token":false,"name":"Temur Ascendancy","scryfallId":"4512f8d1-0d81-424a-a6e4-2a38411dc84b"},{"index":9135,"token":false,"name":"Quarum Trench Gnomes","scryfallId":"1c3b33bf-3074-406e-86f3-2a9843cf4862"},{"index":9136,"token":false,"name":"Festergloom","scryfallId":"5da1371f-8888-4428-b3f4-d8f07e12f91b"},{"index":9137,"token":false,"name":"Selfless Spirit","scryfallId":"a4624976-3773-4a1e-b725-5f6efce147a5"},{"index":9142,"token":false,"name":"Blistering Firecat","scryfallId":"e0ddcf4a-1943-49dd-a02c-75804ce4bc3e"},{"index":9143,"token":false,"name":"Silverglade Elemental","scryfallId":"ef0f6574-9035-4020-90ec-22a1e3816d00"},{"index":9144,"token":false,"name":"Curse of the Nightly Hunt","scryfallId":"2983c017-1697-4d45-ac58-3f3ccbaaefff"},{"index":9145,"token":false,"name":"Cranial Extraction","scryfallId":"a8cad7a3-777e-4c84-b404-5f504844ab3b"},{"index":9147,"token":false,"name":"Bartel Runeaxe","scryfallId":"f1a42691-98bb-4234-9b56-085e6677f3e4"},{"index":9148,"token":false,"name":"Polyraptor","scryfallId":"f8965a3a-93fe-4021-a665-b6013bdc86f7"},{"index":9149,"token":false,"name":"Sheltered Aerie","scryfallId":"afecf5a8-3c9e-48e0-8818-e2e3183e958c"},{"index":9150,"token":false,"name":"Electrodominance","scryfallId":"5c63877b-cdab-4ce4-a1c0-c088eb62a57a"},{"index":9152,"token":false,"name":"Curse of Exhaustion","scryfallId":"b737a959-e974-4b2a-8dca-a257da6084b0"},{"index":9153,"token":false,"name":"Blastoderm","scryfallId":"9db5d6c2-b11f-442a-b172-c0c99c9bec07"},{"index":9155,"token":false,"name":"Umbral Mantle","scryfallId":"4cebecc8-52e9-4381-8d66-dc625df8aaf3"},{"index":9159,"token":false,"name":"Scholar of the Ages","scryfallId":"8bfa31b5-8a4f-4766-9606-648cb8ee2916"},{"index":9163,"token":false,"name":"Grasslands","scryfallId":"47e0ca2f-6059-44e4-996d-e243edbfbd79"},{"index":9164,"token":false,"name":"Back from the Brink","scryfallId":"b4bba140-5c06-4542-9ae0-b2517104ab7c"},{"index":9167,"token":false,"name":"Jandor's Saddlebags","scryfallId":"71180ace-14e8-4aee-b616-a6b3444d000d"},{"index":9168,"token":false,"name":"Zodiac Snake","scryfallId":"6d30d6f0-ca4c-4442-a47f-ecdf52088ecc"},{"index":9169,"token":false,"name":"Pharika, God of Affliction","scryfallId":"109bfa3d-02e0-4395-bd6e-edaad77f25f7"},{"index":9171,"token":false,"name":"Statecraft","scryfallId":"76dcd19e-8daf-4d53-946b-c07d5eca3cc9"},{"index":9172,"token":false,"name":"Telling Time","scryfallId":"3caf69d0-58bd-4cd1-9108-56e6cbf882e4"},{"index":9174,"token":false,"name":"Sphinx Summoner","scryfallId":"83226f26-8d8f-42f2-ab23-997e72e954f2"},{"index":9175,"token":false,"name":"Wake of Vultures","scryfallId":"52420b80-7f34-4426-ac97-a6e15167c7a9"},{"index":9177,"token":false,"name":"Goblin Matron","scryfallId":"862409e1-33e0-474c-8627-b03d25b654b9"},{"index":9178,"token":false,"name":"Deathlace","scryfallId":"c3e02432-b8bd-4091-a520-6895313ff141"},{"index":9182,"token":false,"name":"Goblin Firestarter","scryfallId":"84ee21ef-26c0-4def-9046-5d6fcfa3bfeb"},{"index":9186,"token":false,"name":"Blood Frenzy","scryfallId":"06f39d83-e1ea-45c9-8181-2a2b6e5148da"},{"index":9187,"token":false,"name":"Shieldhide Dragon","scryfallId":"fcfd0af4-44e1-424b-8e55-87f84a42d40a"},{"index":9188,"token":false,"name":"Cateran Kidnappers","scryfallId":"3768bdc1-4055-423a-a1cc-69b4c620e3e6"},{"index":9189,"token":false,"name":"Ghirapur Aether Grid","scryfallId":"2e4a0c29-a759-465f-9136-9d709b6f30fc"},{"index":9192,"token":false,"name":"Fumiko the Lowblood","scryfallId":"482678b8-bce6-4847-9f43-1761d61645d8"},{"index":9194,"token":false,"name":"Lotus Field","scryfallId":"0e013033-3995-4ba8-b0c3-0614c79aaaab"},{"index":9196,"token":false,"name":"Aphetto Runecaster","scryfallId":"7c5de028-91ce-48d8-8557-ae12542adea2"},{"index":9198,"token":false,"name":"Aegis Angel","scryfallId":"29edd82c-8d47-4417-85fb-c38a02d7e0fa"},{"index":9200,"token":false,"name":"Castle Ardenvale","scryfallId":"7f910495-8bd7-4134-a281-c16fd666d5cc"},{"index":9201,"token":false,"name":"Ivy Lane Denizen","scryfallId":"2ad9d411-4bc2-48d8-99aa-c38604ef8c6f"},{"index":9203,"token":false,"name":"Chaoslace","scryfallId":"91f5ef08-0e54-49c2-9947-fdd5f843973d"},{"index":9204,"token":false,"name":"Strength of Arms","scryfallId":"6843952d-e633-4992-99d5-4ef8b87494c8"},{"index":9206,"token":false,"name":"Gor Muldrak, Amphinologist","scryfallId":"40b006f9-a287-4e64-915f-ca71712b8d27"},{"index":9210,"token":false,"name":"Warp World","scryfallId":"aa6e1fb5-a06b-4e10-8cc7-785e0f0b298e"},{"index":9214,"token":false,"name":"Full Flowering","scryfallId":"ea2e9f4c-b6b4-4199-93ae-10df75590715"},{"index":9217,"token":false,"name":"Spirit Away","scryfallId":"d8823bdc-0467-47f1-9bef-a281b4a7071d"},{"index":9220,"token":false,"name":"Fateful End","scryfallId":"56455067-92c0-45b5-ac2e-525c35b41215"},{"index":9221,"token":false,"name":"Luminarch Aspirant","scryfallId":"ebe9427d-068f-487c-9263-b40366a164bc"},{"index":9224,"token":false,"name":"Sphinx of Uthuun","scryfallId":"77a77dbb-4737-44dc-aa78-2df77ba53a57"},{"index":9226,"token":false,"name":"Shared Triumph","scryfallId":"0d07ebe6-76cf-4345-b59b-9954496c44d0"},{"index":9230,"token":false,"name":"Hampering Snare","scryfallId":"5f7b331a-bd21-429b-a49f-88da9a31c98e"},{"index":9231,"token":false,"name":"Cleansing Beam","scryfallId":"8ad0c91e-2765-4516-ae7a-3500f856eb31"},{"index":9232,"token":false,"name":"Quicksilver Gargantuan","scryfallId":"b83f5aea-80f2-4f3d-8508-9619413e0087"},{"index":9234,"token":false,"name":"Thing from the Deep","scryfallId":"cb3b9682-7f3a-4857-9ecf-01f3530659fc"},{"index":9236,"token":false,"name":"An-Zerrin Ruins","scryfallId":"4f905d57-2f52-4179-8041-2667b1fb1baa"},{"index":9238,"token":false,"name":"Dreadhorde Arcanist","scryfallId":"27933adb-9c7a-4248-9908-f01e6a6bf12c"},{"index":9240,"token":false,"name":"Huatli's Snubhorn","scryfallId":"e2d88e6c-4aa8-4175-9f5d-a4c0182cdf74"},{"index":9241,"token":false,"name":"Candlelight Vigil","scryfallId":"e920a75f-7dec-4815-a358-e174401da83b"},{"index":9242,"token":false,"name":"Two-Headed Giant","scryfallId":"478fb341-d177-4372-a7ce-c4bc67bfbbb5"},{"index":9243,"token":false,"name":"Mighty Leap","scryfallId":"03469462-7f51-4d11-8cc2-b7ac1bdcff50"},{"index":9244,"token":false,"name":"Treasure Map // Treasure Cove","scryfallId":"c0f9c733-0818-4a03-8f0c-a163d09e0fff"},{"index":9245,"token":false,"name":"Squealing Devil","scryfallId":"1b445a0e-798d-4f82-88cc-04f600d38e49"},{"index":9246,"token":false,"name":"Endoskeleton","scryfallId":"ce4630c3-bf8e-46ac-be68-f454c4ca1047"},{"index":9247,"token":false,"name":"Rubble Slinger","scryfallId":"f006255f-b18d-4d52-b97a-17909b67decc"},{"index":9250,"token":false,"name":"Skyclave Shade","scryfallId":"0af31ee0-ce94-4434-8fd4-aac38e52a133"},{"index":9252,"token":false,"name":"Angel of Sanctions","scryfallId":"f3f7f258-7ac0-4149-9d8c-712b5ea7f0a8"},{"index":9253,"token":false,"name":"Goblin Tinkerer","scryfallId":"54eef0db-dd7b-4ba9-bcb9-4cabdf6a1431"},{"index":9254,"token":false,"name":"Bojuka Bog","scryfallId":"0ac2a3ab-a221-47a7-b1c1-a9306fa48b0c"},{"index":9256,"token":false,"name":"Lavalanche","scryfallId":"749981d6-78e7-4f53-80a8-f211e61bd532"},{"index":9258,"token":false,"name":"Knights of Thorn","scryfallId":"ae541c73-9903-49e6-997a-db4701135145"},{"index":9260,"token":false,"name":"Koma's Faithful","scryfallId":"af0f1a90-af64-4122-9c1a-954edf8fa240"},{"index":9261,"token":false,"name":"Paleoloth","scryfallId":"b83ad801-44e7-48d0-9f34-0d10536bb4dc"},{"index":9262,"token":false,"name":"Ratchet Bomb","scryfallId":"d5bd85da-9aba-46ea-9c10-617bec99a2f5"},{"index":9263,"token":false,"name":"Zulaport Chainmage","scryfallId":"d2f94241-6996-4d6d-9c0c-bd765b64e697"},{"index":9267,"token":false,"name":"Tireless Tribe","scryfallId":"1d23e47a-21d5-4d7e-8aa0-3b3064da5967"},{"index":9268,"token":false,"name":"Darkblast","scryfallId":"075fc4cb-49ac-4488-a24d-bc687f027182"},{"index":9269,"token":false,"name":"Induced Amnesia","scryfallId":"d36d5b78-6d63-4666-a103-66c449d5f734"},{"index":9270,"token":false,"name":"Gnarlback Rhino","scryfallId":"68a69558-aca0-413d-9762-2fa115b44abd"},{"index":9271,"token":false,"name":"Backdraft Hellkite","scryfallId":"2af9027d-c1d2-49b6-b303-04e37d38e010"},{"index":9273,"token":false,"name":"Failure // Comply","scryfallId":"f61abbc1-5e3a-4185-8532-c3dfdd54cc9b"},{"index":9275,"token":false,"name":"Jalira, Master Polymorphist","scryfallId":"425da4aa-4374-41b0-a665-568a04f57c38"},{"index":9276,"token":false,"name":"Traxos, Scourge of Kroog","scryfallId":"d376c607-49e0-454c-b3a1-8bf36c1158bf"},{"index":9277,"token":false,"name":"Selfless Savior","scryfallId":"6911759c-7177-402c-a95a-f9f46efaf521"},{"index":9278,"token":false,"name":"Flowering Lumberknot","scryfallId":"78fa2ddc-142b-4562-8812-ecb72e3bae57"},{"index":9279,"token":false,"name":"Rugged Prairie","scryfallId":"e31f8b2a-acf4-423c-bc99-8cf44f3c018a"},{"index":9282,"token":false,"name":"Palladia-Mors","scryfallId":"ad64874d-ce33-4e0a-bcca-723f129ef415"},{"index":9283,"token":false,"name":"Terror of the Fairgrounds","scryfallId":"04623df9-8fa9-44cc-b528-c2c484626d1f"},{"index":9288,"token":false,"name":"Selesnya Evangel","scryfallId":"3afd9bc0-442b-4e0f-bb5e-821c1070b213"},{"index":9289,"token":false,"name":"Frenzied Saddlebrute","scryfallId":"d518fffb-542f-4752-be05-d0dbcf4dd6c2"},{"index":9290,"token":false,"name":"Goblin Legionnaire","scryfallId":"88989f2f-3019-41ec-9dac-3b389f0ce1e4"},{"index":9292,"token":false,"name":"Serpent Generator","scryfallId":"5e2ee41c-5592-42bd-8db2-92b3233b1d61"},{"index":9295,"token":false,"name":"Brine Hag","scryfallId":"2a1e7796-fbfb-4976-879f-bb748429d5c7"},{"index":9299,"token":false,"name":"Sphinx-Bone Wand","scryfallId":"b7da189e-f692-4b91-a452-3c628c3c2b1c"},{"index":9301,"token":false,"name":"Breeding Pool","scryfallId":"b98b2a35-ec2b-47fe-903d-dd292e469a3c"},{"index":9302,"token":false,"name":"Humble Defector","scryfallId":"e2093386-ad77-4b35-982b-518ee4c05cc6"},{"index":9303,"token":false,"name":"Ikra Shidiqi, the Usurper","scryfallId":"8dfe40d8-1f6d-466e-8c9f-1a3893baa366"},{"index":9304,"token":false,"name":"Bubble Snare","scryfallId":"1bfba7a0-d5ca-4197-9e58-21f28345f1a6"},{"index":9305,"token":false,"name":"Nightveil Predator","scryfallId":"193289c9-837d-4d18-9ef1-720e8e335e62"},{"index":9306,"token":false,"name":"Fists of Ironwood","scryfallId":"7e61a67a-6298-48e0-b0e6-fa70330353f6"},{"index":9307,"token":false,"name":"Soul Net","scryfallId":"482eaca7-dd1c-4d96-8ded-69aa2184fd24"},{"index":9309,"token":false,"name":"Talrand, Sky Summoner","scryfallId":"bc1a6867-921d-4912-afae-c3c445ad81e7"},{"index":9311,"token":false,"name":"Despise","scryfallId":"ee7bfcd3-9f2b-41f5-93b4-8c1ee6ba4d88"},{"index":9312,"token":false,"name":"Battle of Frost and Fire","scryfallId":"a4e2e7ec-f90b-4646-8bda-627488236d06"},{"index":9314,"token":false,"name":"Dust Bowl","scryfallId":"9ef93e7a-e799-4c73-b5a1-38b91f368072"},{"index":9315,"token":false,"name":"Wurm's Tooth","scryfallId":"b96c8868-a88e-495a-9d61-f5fffe32bee5"},{"index":9316,"token":false,"name":"Infantry Veteran","scryfallId":"a2f425bf-856d-48e9-a7b7-66993d550119"},{"index":9317,"token":false,"name":"Squirrel Sovereign","scryfallId":"d512e5b8-2394-42d9-9dbf-345137710cde"},{"index":9318,"token":false,"name":"Chain Stasis","scryfallId":"f14f0c52-67c2-4302-82bd-fbb4e3c6d4f4"},{"index":9320,"token":false,"name":"Reprocess","scryfallId":"569408b3-43c8-4cb1-a70f-15ab2aeaf8ed"},{"index":9322,"token":false,"name":"Pyre Hound","scryfallId":"cd970484-49b3-442a-806a-cabc56526ee1"},{"index":9324,"token":false,"name":"Blatant Thievery","scryfallId":"0210b3b4-d253-464f-b533-b79bf67d47a4"},{"index":9326,"token":true,"name":"Phyrexian Germ Token (B, 0/0)","scryfallId":"b53e0681-603e-4180-bc86-3dadf214e61a"},{"index":9327,"token":false,"name":"Sphinx of New Prahv","scryfallId":"d9aec56e-50a3-491f-89c6-32907ea3161a"},{"index":9329,"token":false,"name":"Despondency","scryfallId":"ef400a6a-628a-40d6-80dc-feabe40d6ce1"},{"index":9331,"token":false,"name":"Cavalier of Night","scryfallId":"59eb97ec-c6d8-4a66-b6f7-045f32485e02"},{"index":9334,"token":false,"name":"Avacyn, Angel of Hope","scryfallId":"a0519776-3d86-4f7d-9c3b-71c1dfbf7e12"},{"index":9335,"token":false,"name":"Jungle Wurm","scryfallId":"f17f81b9-1fa1-4062-a9b3-048179274c05"},{"index":9338,"token":false,"name":"Convicted Killer // Branded Howler","scryfallId":"f43f5f02-1b29-4e75-a6af-378dcc88c3df"},{"index":9340,"token":false,"name":"Skarrgan Pit-Skulk","scryfallId":"eb483ff0-7641-4f79-bd85-5003a8718848"},{"index":9341,"token":false,"name":"Riot Devils","scryfallId":"cd35107b-6aaf-4fd8-bf1c-12b724d1482e"},{"index":9344,"token":false,"name":"Stitcher's Apprentice","scryfallId":"7e0fcc53-cd0b-4b4c-b6de-5d301232106a"},{"index":9345,"token":false,"name":"Heat Stroke","scryfallId":"1baf2a6c-57ec-4b38-8b08-4b3f800dbe99"},{"index":9346,"token":false,"name":"Greenseeker","scryfallId":"423d0c1d-1791-4c80-86d1-f87f3c6a8611"},{"index":9349,"token":false,"name":"Razorfoot Griffin","scryfallId":"819e2046-9b78-4fd0-92f8-798bfac51195"},{"index":9350,"token":false,"name":"Sink into Takenuma","scryfallId":"d519df1b-0c81-4d0d-85c6-2a288c6fa269"},{"index":9351,"token":false,"name":"Wheel of Fate","scryfallId":"34d572a8-e96c-4a60-a741-374f30211173"},{"index":9354,"token":false,"name":"Unbreakable Bond","scryfallId":"c9da02a1-7b39-4a0e-8466-6512a02f3e3b"},{"index":9355,"token":false,"name":"Honor's Reward","scryfallId":"084c8b16-7aae-4d1f-87c2-6a150f11bb15"},{"index":9356,"token":false,"name":"Thrill of the Hunt","scryfallId":"6bed96ea-f509-40eb-80b7-71a02d9ac69f"},{"index":9359,"token":false,"name":"Disposal Mummy","scryfallId":"b446e445-5305-4c3d-a146-caeafb26beca"},{"index":9360,"token":false,"name":"Forked-Branch Garami","scryfallId":"0ff39ae5-a241-4607-903e-201f56c675f9"},{"index":9361,"token":false,"name":"Tolaria West","scryfallId":"a9e80f06-ea05-4151-920f-7ddc88952169"},{"index":9363,"token":false,"name":"Dust of Moments","scryfallId":"1d2c8f6f-8dcd-4b47-bc79-9657824cf1b7"},{"index":9366,"token":false,"name":"Viridian Claw","scryfallId":"2154e3c6-ab69-4661-b1ef-a50cc0f6f763"},{"index":9368,"token":false,"name":"Ragnar","scryfallId":"2cf6a3a3-4a06-4eb7-981a-b70cf05b2473"},{"index":9370,"token":false,"name":"Fecundity","scryfallId":"c5be15b0-e754-4d1f-a36f-901c20641a40"},{"index":9371,"token":false,"name":"Elven Fortress","scryfallId":"9387105d-46d0-4db0-8980-dd0fded15eef"},{"index":9372,"token":false,"name":"Crucible of Worlds","scryfallId":"57fb8472-b7ff-4d70-998f-7628eae979bd"},{"index":9373,"token":false,"name":"Fissure Wizard","scryfallId":"9fa10a18-5059-46ab-9983-0ea78b507331"},{"index":9376,"token":false,"name":"Finale of Glory","scryfallId":"a5dbb033-33bf-4209-8ad7-8b3559db197b"},{"index":9378,"token":false,"name":"Gerrard, Weatherlight Hero","scryfallId":"c835a37a-776a-44ef-a252-4af1f31bf0b3"},{"index":9379,"token":false,"name":"Ensnaring Bridge","scryfallId":"df5dcf3e-9556-4e1e-929b-eff38abc989c"},{"index":9380,"token":false,"name":"Soul Foundry","scryfallId":"6c7a441b-e4af-41ba-85a4-fcb4f40534c3"},{"index":9381,"token":false,"name":"Kiora, Master of the Depths","scryfallId":"58c6a939-a8e9-4901-b15b-e68643801357"},{"index":9383,"token":false,"name":"Peek","scryfallId":"869a6c06-eae5-418e-9a5c-26598a929416"},{"index":9385,"token":false,"name":"Ember-Eye Wolf","scryfallId":"98fe1e1e-b14a-4efe-894b-b9da635f007f"},{"index":9386,"token":false,"name":"Dregscape Zombie","scryfallId":"f990b683-e49e-422e-a4e2-85cd09a6eb0d"},{"index":9387,"token":true,"name":"Hippo Token (G, 3/3)","scryfallId":"1aea5e0b-dc4e-4055-9e13-1dfbc25a2f00"},{"index":9389,"token":false,"name":"Cliffside Rescuer","scryfallId":"c998d2ba-d2ca-4a85-b22a-ce8f42bb0d2f"},{"index":9391,"token":false,"name":"Zealous Conscripts","scryfallId":"df3784d4-80cd-4f78-afb3-d61f3bab5b2c"},{"index":9393,"token":true,"name":"Eldrazi Spawn Token (Colorless, 0/1)","scryfallId":"35fb1a3d-3f1a-45ba-a643-1dca435c77de"},{"index":9396,"token":false,"name":"Wojek Apothecary","scryfallId":"ef74fea5-2345-4ffd-8951-f420e17259e6"},{"index":9400,"token":false,"name":"Death Spark","scryfallId":"ba841b44-475c-402c-ac11-763de0cf27d9"},{"index":9403,"token":false,"name":"Treacherous Urge","scryfallId":"22563bcd-1f29-4544-ba43-173ead61e62a"},{"index":9408,"token":false,"name":"Eyes in the Skies","scryfallId":"e1a1d9ad-a434-43de-bcb3-143d07dbd775"},{"index":9409,"token":false,"name":"Cat Burglar","scryfallId":"947109f9-7035-4a2a-bbc2-a2958f8c5d01"},{"index":9411,"token":false,"name":"Glory","scryfallId":"2a9c7fca-304a-43cf-80a9-cfb8c72d43fa"},{"index":9412,"token":false,"name":"Molder Beast","scryfallId":"1636f571-43ed-4b60-b5d9-129ff94dd0fa"},{"index":9413,"token":false,"name":"Goblin General","scryfallId":"23c9eef2-849f-4799-9829-bd845f8eaf6e"},{"index":9416,"token":false,"name":"Goldmeadow Harrier","scryfallId":"b6a7508c-2815-40eb-92f7-3e66dfb28484"},{"index":9420,"token":false,"name":"Essence Vortex","scryfallId":"fe07e496-5070-4116-a91a-a3bbe19c12af"},{"index":9424,"token":false,"name":"Bloodflow Connoisseur","scryfallId":"1a788fb3-fc21-47b2-b387-ceff438969af"},{"index":9425,"token":false,"name":"Pyromancy","scryfallId":"35a91a58-cc8b-47a3-8c53-43c32753a00d"},{"index":9426,"token":false,"name":"Icon of Ancestry","scryfallId":"9b78e53c-1aec-4c49-bf58-165dd7b59d64"},{"index":9427,"token":false,"name":"Archers of Qarsi","scryfallId":"0fcf0074-162a-4cc0-9726-8672a0261307"},{"index":9430,"token":false,"name":"Harmonic Convergence","scryfallId":"5aafc380-cf4d-4843-b9c3-c389d9c5e942"},{"index":9431,"token":true,"name":"The Monarch","scryfallId":"40b79918-22a7-4fff-82a6-8ebfe6e87185"},{"index":9437,"token":false,"name":"Stasis","scryfallId":"ccba06c1-d623-4751-99c9-08824a98569b"},{"index":9438,"token":false,"name":"Overload","scryfallId":"c91fca91-7296-422e-b251-d571b710ff71"},{"index":9439,"token":false,"name":"Atris, Oracle of Half-Truths","scryfallId":"0071c208-c5cc-49f2-83d7-b4d2a71a0a31"},{"index":9441,"token":false,"name":"Ground Seal","scryfallId":"977383a8-9a31-4aad-ace2-6ed4d0dd1cbe"},{"index":9443,"token":false,"name":"Clash of Realities","scryfallId":"064dcfb2-6088-49c9-89b2-88d63c9add53"},{"index":9445,"token":false,"name":"Kamahl, Pit Fighter","scryfallId":"7a65dd4d-f838-4964-bd5a-a517960cc644"},{"index":9449,"token":false,"name":"Armed and Armored","scryfallId":"4f4c1253-7eba-454b-9269-3695ba746a7a"},{"index":9450,"token":false,"name":"Tribal Golem","scryfallId":"6e208be1-8b24-4048-90b2-6389f08043d1"},{"index":9452,"token":false,"name":"Fall of the Gavel","scryfallId":"64f42848-963b-4b16-aeec-66d0f349758b"},{"index":9454,"token":false,"name":"Minion of Tevesh Szat","scryfallId":"ea9f3ab5-6a31-47db-b8bf-4c56a7ff19d1"},{"index":9455,"token":false,"name":"Broken Ambitions","scryfallId":"8052d90b-bc49-4a9e-9211-159a54aa2bcd"},{"index":9458,"token":false,"name":"Whir of Invention","scryfallId":"0279fd3c-9252-4958-9d7a-5f33aa25907e"},{"index":9459,"token":false,"name":"Glarewielder","scryfallId":"59fdc845-7165-40f3-a082-21a502b3f0f6"},{"index":9461,"token":false,"name":"Black Cat","scryfallId":"32efcfad-818c-4485-9022-cf94403f370b"},{"index":9463,"token":false,"name":"Merchant's Dockhand","scryfallId":"3abdefd1-5562-4c10-8127-aaf3a9009adf"},{"index":9468,"token":false,"name":"Return of the Wildspeaker","scryfallId":"b88a4943-bd1b-4d10-9cd3-b2ab91b25c10"},{"index":9469,"token":false,"name":"Mistform Ultimus","scryfallId":"b74feed4-840b-4f10-9861-7a6885ce7907"},{"index":9470,"token":false,"name":"Safehold Sentry","scryfallId":"caa8bd74-9897-4515-b1a0-50d5f1bda673"},{"index":9471,"token":false,"name":"Naban, Dean of Iteration","scryfallId":"88f41175-880f-491e-96c3-bf52f3c0db5d"},{"index":9472,"token":false,"name":"Dawnray Archer","scryfallId":"86c1ff65-8ad5-42e0-9e4c-1caf83ab86e0"},{"index":9473,"token":false,"name":"Celestial Mantle","scryfallId":"136dfcf5-130a-4d75-9785-a090215a29b1"},{"index":9474,"token":false,"name":"Culling the Weak","scryfallId":"50c33f18-0a5c-4e46-ab0d-6e450915594f"},{"index":9476,"token":false,"name":"Herd Gnarr","scryfallId":"fdd98b8a-3a9e-4211-93af-24e35de6d1c3"},{"index":9477,"token":false,"name":"Repeal","scryfallId":"4acaef84-55d1-43dc-b10a-696182e6709b"},{"index":9478,"token":false,"name":"Primal Clay","scryfallId":"cc49d724-b46d-449b-bd2b-03551e130a06"},{"index":9484,"token":true,"name":"Savage Vigor Head Token (Colorless, 0/8)","scryfallId":"4b90bd09-d6aa-4201-a7fe-78accbcfc4e8"},{"index":9485,"token":false,"name":"Kalemne's Captain","scryfallId":"3c8cfcc3-55c6-4011-ae13-dff1ddaed37a"},{"index":9486,"token":false,"name":"Torrent of Lava","scryfallId":"19528a24-4968-4742-a2d1-06f94e60f290"},{"index":9487,"token":false,"name":"Flowstone Salamander","scryfallId":"bf5b6749-42a6-498b-8908-b28d1749dea6"},{"index":9488,"token":false,"name":"Oxidda Golem","scryfallId":"3a5994a9-dc0c-486d-a622-0e2a68699073"},{"index":9489,"token":false,"name":"Shield of the Ages","scryfallId":"b4afbc5a-9084-48be-9a33-0aa013775d34"},{"index":9490,"token":false,"name":"Witherbloom Pledgemage","scryfallId":"a6cc6914-2dcb-411d-90a5-01853ff2d5b8"},{"index":9491,"token":false,"name":"Zirda, the Dawnwaker","scryfallId":"a8c08043-cd12-4431-a8a3-e9b3495fc678"},{"index":9492,"token":false,"name":"Spikewheel Acrobat","scryfallId":"58f70b8a-62ec-4ae6-97d2-3c6ae86a3602"},{"index":9493,"token":false,"name":"Royal Decree","scryfallId":"d22231f5-30af-4f46-b2c9-0b71124c6939"},{"index":9494,"token":false,"name":"Shivan Sand-Mage","scryfallId":"d21beb25-09a4-4d7f-84e3-87178e1721eb"},{"index":9495,"token":false,"name":"Browbeat","scryfallId":"cb8d13f7-f061-4834-b58a-69a3f550dc13"},{"index":9496,"token":false,"name":"Presence of Gond","scryfallId":"57c95805-54c5-47af-9d7f-21dd8f970aac"},{"index":9498,"token":false,"name":"Goblin Bombardment","scryfallId":"e262f55e-9239-4a97-a19e-9b08fb34502e"},{"index":9499,"token":false,"name":"Road // Ruin","scryfallId":"edf8a080-2327-4ae0-97bc-ed488a619797"},{"index":9500,"token":false,"name":"Phantom Nishoba","scryfallId":"56ebc372-aabd-4174-a943-c7bf59e5028d"},{"index":9501,"token":false,"name":"Geist of the Moors","scryfallId":"6fd246d1-a7cb-45a0-b735-53509ba2d5ca"},{"index":9503,"token":false,"name":"Chosen of Markov // Markov's Servant","scryfallId":"7c5a3c09-5656-4975-ba03-2d809903ed18"},{"index":9506,"token":false,"name":"Deathpact Angel","scryfallId":"d9a7c48e-f021-4884-a3dd-f36ddd491803"},{"index":9509,"token":false,"name":"Earthen Arms","scryfallId":"dadc77d8-ef1c-431d-8716-9583f4fad33f"},{"index":9510,"token":false,"name":"Feral Prowler","scryfallId":"a59d92b0-5ad1-42a7-9c06-1cb31a63bd64"},{"index":9513,"token":false,"name":"Sifter of Skulls","scryfallId":"1afd2ad0-2721-4434-96dc-4271c759a13a"},{"index":9514,"token":false,"name":"Dread Reaper","scryfallId":"d158309e-6fc8-4d41-96cf-aedd31ff1422"},{"index":9517,"token":false,"name":"Blood on the Snow","scryfallId":"5dd7d506-2f02-47a2-8786-fdccbb60f28c"},{"index":9518,"token":false,"name":"Crippling Fatigue","scryfallId":"e4e4b243-345e-4fbd-9959-224d24b7c531"},{"index":9520,"token":false,"name":"Sanctifier en-Vec","scryfallId":"c6ed75e0-f016-4c62-b96e-de97f7fdb6d8"},{"index":9521,"token":false,"name":"Shu Defender","scryfallId":"ee57a9ab-c385-4a51-aff7-6a654f5d7611"},{"index":9522,"token":false,"name":"Quiet Disrepair","scryfallId":"c74cf3eb-66be-455c-8e5e-8debc7f9f6fd"},{"index":9523,"token":false,"name":"Grappling Hook","scryfallId":"acfbfddd-1535-477d-8bf4-5afd2648ac81"},{"index":9529,"token":false,"name":"Mana Echoes","scryfallId":"1b15d04c-62cb-4704-8cc7-9842cef27a1b"},{"index":9530,"token":false,"name":"Dampen Thought","scryfallId":"17c8590d-21f8-4bbf-8b71-1588428e2467"},{"index":9531,"token":false,"name":"Magefire Wings","scryfallId":"be18c2d9-60c4-454b-b6c7-7c22ed2985fb"},{"index":9533,"token":false,"name":"Thunderfoot Baloth","scryfallId":"db929e1a-5f5d-4851-95fc-c6114f1abeb9"},{"index":9535,"token":false,"name":"Branching Bolt","scryfallId":"e7468876-f401-4a75-81c0-bed09cdda3e1"},{"index":9537,"token":false,"name":"Jadelight Ranger","scryfallId":"e809730a-aa0e-4e15-9046-1da11f7832d6"},{"index":9538,"token":false,"name":"Frontline Devastator","scryfallId":"21d8a65b-140d-438c-be9e-999bdf858275"},{"index":9539,"token":false,"name":"Dauntless Cathar","scryfallId":"bb1a458a-d3b6-44d9-ac80-a7a46b505805"},{"index":9540,"token":false,"name":"Rise // Fall","scryfallId":"37257329-5946-44df-9f5a-50bd38b6a151"},{"index":9541,"token":false,"name":"Gristle Grinner","scryfallId":"f1d6e32e-6479-48b3-93ae-da5378c09bb1"},{"index":9544,"token":false,"name":"Manifold Insights","scryfallId":"e9c67dc7-dee8-4e62-bf4e-a371f1688975"},{"index":9545,"token":false,"name":"Viashino Cutthroat","scryfallId":"bcbab69d-3259-40f4-a588-ab550858a178"},{"index":9547,"token":false,"name":"Brushstrider","scryfallId":"7f45508b-467d-4504-b13b-650b798396d2"},{"index":9548,"token":false,"name":"Empyrial Armor","scryfallId":"e4d278c1-8610-435d-8cfa-dd268a74eb63"},{"index":9550,"token":false,"name":"Moonlight Geist","scryfallId":"4cf4c4cf-df35-4725-81ca-d62b70b8d0dd"},{"index":9553,"token":false,"name":"Solidarity of Heroes","scryfallId":"9ba88e10-d306-44df-bdbf-f5ba85887fe8"},{"index":9554,"token":false,"name":"Belligerent Hatchling","scryfallId":"72cdf36c-d8a2-4629-8f2a-d4ac86ac9320"},{"index":9556,"token":false,"name":"Warning","scryfallId":"5cfbcb49-a640-4c0d-800f-482b813369a3"},{"index":9557,"token":false,"name":"Unbreakable Formation","scryfallId":"07af73d7-5d8e-4c64-91f0-1ecc35b57024"},{"index":9558,"token":false,"name":"Overwhelming Splendor","scryfallId":"6a4bcbde-6fef-4a01-8896-8cc223894cf8"},{"index":9560,"token":false,"name":"Arashin War Beast","scryfallId":"a0fbf69f-7e30-442b-bd30-da28de876d3e"},{"index":9561,"token":false,"name":"Hofri Ghostforge","scryfallId":"274aed35-81cc-4b2c-8507-c86db1669b12"},{"index":9562,"token":false,"name":"Genju of the Falls","scryfallId":"99820c21-71b2-409b-b3fd-0334fb416e17"},{"index":9563,"token":false,"name":"Kolaghan Skirmisher","scryfallId":"ced0adca-d11c-41b6-aec4-4799946425d3"},{"index":9564,"token":true,"name":"Carnivore Token (R, 3/1)","scryfallId":"8437b125-6057-4d17-9f2c-28ea56553f84"},{"index":9565,"token":false,"name":"Spectral Force","scryfallId":"d7dff1c4-6297-46f6-9c70-544c67319dd0"},{"index":9567,"token":false,"name":"Harmless Offering","scryfallId":"a181ab7d-d3bc-43d4-9603-702ac0087d5a"},{"index":9570,"token":false,"name":"Katabatic Winds","scryfallId":"97b34ce8-1eb2-44eb-813a-09d0308e27a0"},{"index":9571,"token":false,"name":"Renegade Demon","scryfallId":"bbd61cbe-92b8-4141-b11c-04046e35578a"},{"index":9572,"token":false,"name":"Spy Kit","scryfallId":"c0fd4069-5860-42f5-9f7f-e07f1d4ff0b3"},{"index":9574,"token":false,"name":"Tyvar Kell","scryfallId":"a007cfa6-4ef5-4e84-af31-fb87601a55f9"},{"index":9577,"token":false,"name":"Faceless Butcher","scryfallId":"4073be21-c54a-4eee-9109-f3adfe757c4e"},{"index":9582,"token":false,"name":"Leaden Fists","scryfallId":"be497544-bbf0-472d-adf6-ff1fd1951370"},{"index":9585,"token":false,"name":"Inferno","scryfallId":"2cfa44a4-5351-4334-a9d5-c5c19fcccca5"},{"index":9587,"token":false,"name":"Tandem Tactics","scryfallId":"6a8aaf9c-9aa5-44db-9610-402389a3ddc5"},{"index":9588,"token":false,"name":"Torment of Hailfire","scryfallId":"f69d77d1-5980-436c-bf48-790939b069aa"},{"index":9589,"token":false,"name":"Interpret the Signs","scryfallId":"696f2da6-3943-4555-9610-e6b925b3d6bc"},{"index":9590,"token":false,"name":"Ageless Entity","scryfallId":"a4f9d79a-dff5-46e1-b767-30a451b54942"},{"index":9592,"token":false,"name":"Thopter Foundry","scryfallId":"3d8dcd5e-d4d0-49ae-a591-78d80322105d"},{"index":9593,"token":false,"name":"Dwindle","scryfallId":"cb38f190-30f0-49ca-99c3-d3cdf21075e8"},{"index":9594,"token":false,"name":"Flameblade Angel","scryfallId":"21605e20-f002-4afa-b742-fe3664e09310"},{"index":9596,"token":false,"name":"Nephalia Moondrakes","scryfallId":"af4b0fab-4ce1-4516-8960-3f8ca37d7644"},{"index":9599,"token":false,"name":"Psychatog","scryfallId":"d3622975-51e0-499b-8be1-844bb204281c"},{"index":9601,"token":false,"name":"Akroma, Angel of Fury","scryfallId":"77bd8a6f-895c-4434-9eaf-644650b4e42c"},{"index":9602,"token":false,"name":"Destructive Revelry","scryfallId":"798af7cb-645f-4526-8a19-6e4595b93964"},{"index":9603,"token":false,"name":"Duskfang Mentor","scryfallId":"fc38fe5d-6c35-4fff-8f1b-726a0685c6f8"},{"index":9604,"token":false,"name":"Decompose","scryfallId":"916fb8a8-f402-4ef6-8a6b-8fc591e04367"},{"index":9606,"token":false,"name":"Nomadic Elf","scryfallId":"3b69e57a-5b19-450c-9cf5-c189e8505781"},{"index":9609,"token":false,"name":"Geth, Lord of the Vault","scryfallId":"2b060e36-225a-49b6-9b19-48ee90fd764c"},{"index":9610,"token":false,"name":"Neheb, Dreadhorde Champion","scryfallId":"f617d6ef-8d7a-4642-9de6-2cebc4980b24"},{"index":9611,"token":false,"name":"Lightning Rift","scryfallId":"d775d729-0ad9-4b14-9d44-6282f6936e07"},{"index":9612,"token":false,"name":"Asceticism","scryfallId":"ec2b56b0-126c-411b-8c43-b690fc8c194b"},{"index":9614,"token":false,"name":"Liliana, the Last Hope","scryfallId":"fb6f35ba-d746-46bc-b68b-be5054c41042"},{"index":9615,"token":false,"name":"Speedway Fanatic","scryfallId":"8c994dfe-6365-400f-ba86-ca1e6f41d464"},{"index":9616,"token":false,"name":"Scourge of the Skyclaves","scryfallId":"4dea7bcc-3ff8-40b0-8264-0cd678d6ff31"},{"index":9619,"token":false,"name":"Tajuru Warcaller","scryfallId":"762501fe-5102-4c21-8ad5-430590a59830"},{"index":9623,"token":false,"name":"Three Dreams","scryfallId":"ddd4bbfb-80c9-4bdd-86c6-96fba00d3d12"},{"index":9624,"token":false,"name":"Castle Locthwain","scryfallId":"aad27ff1-ed28-4536-bfdb-5a5de2aa9505"},{"index":9628,"token":false,"name":"Ancient Grudge","scryfallId":"c6440065-8d1e-4767-9706-8906d5aa29a9"},{"index":9629,"token":false,"name":"Deathless Angel","scryfallId":"8b5e6882-4c37-4c47-92c4-4083c66e9019"},{"index":9631,"token":false,"name":"Dark Nourishment","scryfallId":"053c4cf0-992b-4f76-b8d1-cd67f894172c"},{"index":9635,"token":false,"name":"Daxos the Returned","scryfallId":"7d59e215-4b92-41a1-a2c2-52551489f759"},{"index":9636,"token":false,"name":"Hailstorm Valkyrie","scryfallId":"a5a272b3-aaab-4c98-86a8-85c67a5f3d4d"},{"index":9637,"token":false,"name":"Esper Charm","scryfallId":"62add4fe-c19e-40bd-82f6-cb1307a331b1"},{"index":9638,"token":false,"name":"Spiritual Asylum","scryfallId":"e5eea354-2d92-4b57-aec7-25260ab7a70f"},{"index":9639,"token":false,"name":"Mystic Enforcer","scryfallId":"ec2a7910-61b5-42a0-900c-b06e520e20c4"},{"index":9641,"token":false,"name":"Grim Physician","scryfallId":"b7e92c82-840f-4c75-b617-7b58a07be5b4"},{"index":9647,"token":false,"name":"Degavolver","scryfallId":"36a52c3a-2f58-4b4d-b3c6-f9a08e25c7de"},{"index":9649,"token":false,"name":"Ambassador Laquatus","scryfallId":"b261067f-b5de-41cc-ba9e-6ef4c061e170"},{"index":9651,"token":false,"name":"Chandra, Fire Artisan","scryfallId":"3b129f92-e6c4-4967-bd0c-02ff85f09636"},{"index":9652,"token":false,"name":"Griffin Protector","scryfallId":"5c32c4f2-4fa5-4874-8413-eac822121a0b"},{"index":9653,"token":false,"name":"Orcish Conscripts","scryfallId":"17025cde-28a1-4a38-ad5a-1ead518d77af"},{"index":9656,"token":false,"name":"Teneb, the Harvester","scryfallId":"907ae925-322f-4d70-bef7-64a6f800c52b"},{"index":9657,"token":false,"name":"Soul Diviner","scryfallId":"1af8977f-1613-4515-9e9e-433365b2a8af"},{"index":9659,"token":false,"name":"Calibrated Blast","scryfallId":"37962700-e4d9-419e-8972-d3fd955ff40e"},{"index":9661,"token":false,"name":"Abzan Runemark","scryfallId":"9df457a4-6329-4047-8b0d-391418000cb3"},{"index":9664,"token":false,"name":"Ancient Stirrings","scryfallId":"726039a0-6c0d-48ef-9b42-99de5d4e41d2"},{"index":9667,"token":false,"name":"Mardu Blazebringer","scryfallId":"cbf7a797-f32a-4ed2-b835-a356120f5817"},{"index":9668,"token":false,"name":"Scroll of Avacyn","scryfallId":"871e6e2a-7e45-446b-b964-94377eb6ca92"},{"index":9670,"token":false,"name":"Wayfarer's Bauble","scryfallId":"3db8fc1d-69fa-4a88-8f12-11fd614aac01"},{"index":9677,"token":false,"name":"Erithizon","scryfallId":"ec4ea4e2-2102-4b99-bea5-6fc4203f2b26"},{"index":9678,"token":false,"name":"True Conviction","scryfallId":"9e5dc58b-f486-4b9f-9138-33efa31a05e4"},{"index":9680,"token":false,"name":"Peregrine Griffin","scryfallId":"0296eaa6-f9fe-4fb8-af9c-04928d99e2e2"},{"index":9681,"token":false,"name":"Drogskol Captain","scryfallId":"d9d6ae20-9b67-4c6d-ac33-5ae31a336dab"},{"index":9684,"token":false,"name":"Contagious Nim","scryfallId":"e83a9dea-2aa1-48cd-afe2-f98057b95f6e"},{"index":9688,"token":false,"name":"Spinal Embrace","scryfallId":"f1f40893-82b6-4849-a882-b5807dbb03ff"},{"index":9689,"token":false,"name":"Outland Colossus","scryfallId":"6a891032-1395-40bc-9994-78c1dde4faed"},{"index":9690,"token":false,"name":"Grim Backwoods","scryfallId":"b9ece708-870f-4bbc-8920-119267030c46"},{"index":9691,"token":false,"name":"Mending Hands","scryfallId":"5b6ba253-fb50-4240-8129-6b86895d1ff9"},{"index":9692,"token":false,"name":"Deepwood Wolverine","scryfallId":"db9a9a76-741a-4ba3-bd4b-0eb87d678253"},{"index":9693,"token":false,"name":"Springleaf Drum","scryfallId":"fa8b09d0-fbd2-4441-9d87-02450412e0db"},{"index":9694,"token":false,"name":"Lunar Avenger","scryfallId":"3f2348e5-6bf9-4a7e-91a4-ba93bb108897"},{"index":9695,"token":false,"name":"Aura Gnarlid","scryfallId":"3729a071-8eb0-4142-be7e-c53139c40c46"},{"index":9696,"token":false,"name":"Ancestral Vision","scryfallId":"a5dc736d-7e61-4909-973f-61f7adb82b64"},{"index":9697,"token":false,"name":"Winnower Patrol","scryfallId":"a47bed84-5a4a-4f16-af6c-789c542ce3a7"},{"index":9699,"token":false,"name":"Smiting Helix","scryfallId":"5fa3e132-125a-492f-aab7-c560ea36b779"},{"index":9700,"token":false,"name":"Diregraf Escort","scryfallId":"640e21ad-5064-41bc-886e-2c997f69a3f5"},{"index":9701,"token":false,"name":"Transgress the Mind","scryfallId":"f5742910-3d0f-4710-a5f5-f7a7908833dc"},{"index":9703,"token":false,"name":"Fact or Fiction","scryfallId":"994ae903-576d-4945-911d-9c086bbf75d7"},{"index":9706,"token":false,"name":"Endbringer","scryfallId":"8f5ccdb9-f880-4804-a6a1-0ebbe4c639d5"},{"index":9707,"token":false,"name":"Sorin, Vengeful Bloodlord","scryfallId":"da6510f4-91c2-4984-a6ef-e92aa8632a16"},{"index":9708,"token":false,"name":"Archivist","scryfallId":"083507d3-b28f-4e84-909b-bca2a2131233"},{"index":9710,"token":false,"name":"Secret Salvage","scryfallId":"d9b9f3e2-b5e8-4234-aaf3-5f1938a20c78"},{"index":9712,"token":false,"name":"Stinging Barrier","scryfallId":"ca7f7cd5-4e91-474a-9f60-a66f3f462b1c"},{"index":9713,"token":false,"name":"Jeska's Will","scryfallId":"4e91d96d-cc69-439b-b876-a7d57039022c"},{"index":9715,"token":false,"name":"Wistful Selkie","scryfallId":"fb74a444-0f77-4369-95db-666be769bfc9"},{"index":9716,"token":false,"name":"Well of Lost Dreams","scryfallId":"36f43e97-c14b-48ca-92f9-49e07e80c12f"},{"index":9718,"token":false,"name":"Faerie Miscreant","scryfallId":"28aa0337-94bd-4274-b2ee-6f43747c77b3"},{"index":9721,"token":false,"name":"Vile Aggregate","scryfallId":"1ec66525-a7e9-450f-83df-03d9957837d5"},{"index":9722,"token":false,"name":"Veteran's Voice","scryfallId":"93babf85-eb13-4e06-b45b-8927791bcde5"},{"index":9723,"token":false,"name":"Winged Sliver","scryfallId":"044fcfb2-14ad-44c8-8ce6-8f939c3a5063"},{"index":9725,"token":false,"name":"Ridgescale Tusker","scryfallId":"84b689cc-35ef-4a23-bb1e-4d81b9fb8455"},{"index":9727,"token":false,"name":"Colossal Dreadmaw","scryfallId":"76ac5b70-47db-4cdb-91e7-e5c18c42e516"},{"index":9728,"token":false,"name":"Fire-Field Ogre","scryfallId":"0d023dd3-e92f-4b8a-a178-b60db018bf2a"},{"index":9731,"token":false,"name":"Verdant Confluence","scryfallId":"dada0427-aade-437f-bfca-410347f9ebe1"},{"index":9732,"token":true,"name":"Illusion Token (U, 2/2)","scryfallId":"5dcbf662-7263-414a-b64b-ccf9aab20faa"},{"index":9733,"token":false,"name":"Reborn Hero","scryfallId":"b4acbc7f-c86e-4285-a66d-d7b03fe44377"},{"index":9735,"token":false,"name":"Heritage Druid","scryfallId":"a726acbd-724e-46c5-a4cf-4aee7c2abb16"},{"index":9736,"token":false,"name":"Monstrous Onslaught","scryfallId":"cc96681e-2ef6-4257-8b31-f1b3945fbdea"},{"index":9737,"token":false,"name":"Nest Invader","scryfallId":"24517d9c-6cde-41e8-9e82-ee73f069379a"},{"index":9738,"token":false,"name":"Path of Peace","scryfallId":"af7a2719-7910-4601-be88-7b3c249199d3"},{"index":9739,"token":false,"name":"Bramblefort Fink","scryfallId":"fc83a142-9d0f-4a39-baeb-4e2f62009204"},{"index":9743,"token":false,"name":"Utopia Sprawl","scryfallId":"5047e271-fbf1-402c-9eb9-0806e5988f76"},{"index":9749,"token":false,"name":"Fire Prophecy","scryfallId":"4c2029e5-cf7d-461f-b7b9-bf96399d8f49"},{"index":9750,"token":false,"name":"Spire Golem","scryfallId":"b299c599-1a10-4122-ac0b-8f52a9cec7b6"},{"index":9752,"token":false,"name":"Predatory Impetus","scryfallId":"13c29179-99f4-4e02-bc04-2ffe6ca4a7c3"},{"index":9753,"token":false,"name":"Arclight Phoenix","scryfallId":"4fc5577f-7eb6-4f7e-b5c1-91f9c498cc91"},{"index":9754,"token":false,"name":"Spined Thopter","scryfallId":"bd27f71a-cd22-4b5e-9536-3e160111875a"},{"index":9755,"token":false,"name":"Pearl Dragon","scryfallId":"41ac3411-3286-4698-b5d9-d4bb2db30770"},{"index":9757,"token":false,"name":"Flagstones of Trokair","scryfallId":"e93d3a9f-abc2-4f63-a74d-e5936609386f"},{"index":9758,"token":false,"name":"Hand of Emrakul","scryfallId":"84d602f4-5876-416a-95e5-821a285358bf"},{"index":9759,"token":false,"name":"Heartstone","scryfallId":"0ed17325-6d2f-404e-b13f-d2d419d522b7"},{"index":9761,"token":false,"name":"Cunning Evasion","scryfallId":"300a431c-48a9-4d63-8256-cb6bdaa67b4c"},{"index":9762,"token":false,"name":"Spectral Procession","scryfallId":"9964629e-d79e-46e4-b3fd-e7d1759cbc60"},{"index":9768,"token":false,"name":"Spitebellows","scryfallId":"ef7390a8-78c7-4bb2-9615-18c0f2ffd9eb"},{"index":9769,"token":false,"name":"Oketra's Attendant","scryfallId":"28ee2a16-58d3-4548-85ee-c7b3a7e57d0a"},{"index":9770,"token":false,"name":"Deadbridge Chant","scryfallId":"ec89d15b-415e-4c70-abfc-fc97ce9c5c14"},{"index":9772,"token":true,"name":"Insect Token (R/U, 1/1)","scryfallId":"ae56d9e8-de05-456b-af32-b5992992ee15"},{"index":9774,"token":false,"name":"Invigorate","scryfallId":"406b343c-90b5-4a4d-91c3-2fddcc9a0e05"},{"index":9776,"token":false,"name":"Wrecking Ogre","scryfallId":"87f1a27c-c576-4c34-873f-6faf020c2773"},{"index":9778,"token":false,"name":"Animate Artifact","scryfallId":"2d3bd58b-0da4-4640-b4e7-c0e3ea528870"},{"index":9779,"token":false,"name":"Armory of Iroas","scryfallId":"703a03ac-5bb5-4e36-ab9b-a5c007ffc03d"},{"index":9780,"token":false,"name":"Quandrix Pledgemage","scryfallId":"07633b7f-4150-458b-89c3-d05dc0e3c4bd"},{"index":9783,"token":false,"name":"Nissa, Voice of Zendikar","scryfallId":"8625f32b-0453-4fa6-ba1a-7e64a0541a17"},{"index":9785,"token":false,"name":"Rabid Wolverines","scryfallId":"99121a2b-c735-47be-b01e-cdf59809e7f3"},{"index":9786,"token":false,"name":"Plague Engineer","scryfallId":"35c48959-caba-430a-9ac3-0e3459277ed0"},{"index":9788,"token":false,"name":"Omnath, Locus of Mana","scryfallId":"4ce5b167-df7a-499e-8dcc-7aec2e28b382"},{"index":9791,"token":false,"name":"Mad Prophet","scryfallId":"8f498cb6-2be2-4cd0-b002-564a0f006a69"},{"index":9792,"token":false,"name":"Dissipate","scryfallId":"1c707e5b-c510-4aaa-a6f1-4ad244087ab3"},{"index":9793,"token":false,"name":"Relic Runner","scryfallId":"fbced19d-7035-4284-93b3-cf2d4bcf9734"},{"index":9794,"token":false,"name":"Wu Light Cavalry","scryfallId":"60e55b25-fde2-4b57-b5db-65b75262ff3d"},{"index":9795,"token":false,"name":"Viridian Lorebearers","scryfallId":"85673b93-39b7-44e1-b27d-b716bde42f0b"},{"index":9796,"token":false,"name":"Wolf-Skull Shaman","scryfallId":"804ef999-0d44-420e-ad0c-a6dcf8e9c392"},{"index":9803,"token":false,"name":"Grafted Exoskeleton","scryfallId":"9aa64374-0693-47c9-8b69-56def3817b14"},{"index":9804,"token":false,"name":"Yavimaya Scion","scryfallId":"a2f80036-1058-4513-8549-0557df9b5d61"},{"index":9805,"token":false,"name":"Whalebone Glider","scryfallId":"752a5d93-b98b-424e-9bbe-f22327484adf"},{"index":9806,"token":false,"name":"Shaman of the Great Hunt","scryfallId":"bfbd8cd1-465c-4501-94ba-5a3402f30ded"},{"index":9807,"token":false,"name":"Veiling Oddity","scryfallId":"4d7fd5f3-e5af-4591-9db8-5d85dfe0170f"},{"index":9809,"token":false,"name":"Neutralizing Blast","scryfallId":"e549a8fc-6001-43db-88b1-ce8ed42a3443"},{"index":9810,"token":false,"name":"Fiery Hellhound","scryfallId":"6d6b2c8a-8019-4e4b-8f4e-058ab5284153"},{"index":9811,"token":false,"name":"Forebear's Blade","scryfallId":"52212fd5-551e-4bc1-9dac-6361e27c27ad"},{"index":9813,"token":false,"name":"Ferocious Zheng","scryfallId":"012e05ec-e429-45ba-814c-3789673fe311"},{"index":9814,"token":false,"name":"Riptide Pilferer","scryfallId":"b5fb9744-79cc-48d6-9e3b-f16073dde1e4"},{"index":9816,"token":false,"name":"Sephara, Sky's Blade","scryfallId":"9ca29ed5-e8f1-4fdf-9842-9ab70b9a099f"},{"index":9817,"token":false,"name":"Shadowborn Demon","scryfallId":"3884c05b-c10e-4f1d-a8bd-8b5118657972"},{"index":9819,"token":false,"name":"Root-Kin Ally","scryfallId":"e469162b-c8c9-4746-80f3-d2c2acd89e0f"},{"index":9821,"token":false,"name":"Buried Alive","scryfallId":"7db3697e-a31b-45a5-b742-fdfb00ce3929"},{"index":9827,"token":false,"name":"Promise of Bunrei","scryfallId":"1250735d-d43b-488f-bddf-ed10261a6382"},{"index":9828,"token":false,"name":"Ballista Squad","scryfallId":"5bb5923b-f2c1-47c4-af1f-af24ac7cb56b"},{"index":9831,"token":false,"name":"Vampire Envoy","scryfallId":"a44988f6-5de6-4025-8e67-cedaa44025b5"},{"index":9833,"token":false,"name":"Muscle Burst","scryfallId":"217dada5-7ffc-488b-8062-34c034906ea9"},{"index":9835,"token":false,"name":"Solar Blast","scryfallId":"811fd183-70c0-49c2-ba75-4994c5c4b355"},{"index":9836,"token":true,"name":"Rukh Token (R, 4/4)","scryfallId":"b5489e26-6aec-4706-9c3e-8454878fa6c3"},{"index":9837,"token":false,"name":"Sneaky Homunculus","scryfallId":"a9020f16-4c26-4a7b-8b5c-1d8df3e910a9"},{"index":9838,"token":false,"name":"Temur Charger","scryfallId":"f77258fc-8683-4656-84a3-4df4ea2a8435"},{"index":9839,"token":false,"name":"Sword of Kaldra","scryfallId":"c29907d2-ecd4-4143-8f33-35f9663927da"},{"index":9840,"token":false,"name":"Celestial Dawn","scryfallId":"c1836bce-b19c-4a3b-a52e-9bf4012497b0"},{"index":9842,"token":false,"name":"Glint-Horn Buccaneer","scryfallId":"df2df9cb-14f5-470f-b438-20f4ae8d0d59"},{"index":9845,"token":false,"name":"Kothophed, Soul Hoarder","scryfallId":"6e4e9b3c-366a-4c37-9071-29073d1ab27f"},{"index":9847,"token":false,"name":"Far // Away","scryfallId":"d13cdb71-a499-41db-84e6-95f84650c524"},{"index":9848,"token":false,"name":"Battlefield Forge","scryfallId":"eb139e09-4e88-498a-908e-d16b5ddf1320"},{"index":9850,"token":false,"name":"Gideon of the Trials","scryfallId":"75a73179-43e2-481e-bec8-25891d35baad"},{"index":9851,"token":false,"name":"Trygon Predator","scryfallId":"cd9f1b7c-96b4-4036-9c1b-0ea9891da89e"},{"index":9853,"token":false,"name":"Death-Hood Cobra","scryfallId":"def88ab5-1b82-46f5-a136-ee1addff4214"},{"index":9854,"token":false,"name":"Gideon Blackblade","scryfallId":"b9581ba4-8b7a-410c-9a7d-d4a976880435"},{"index":9856,"token":false,"name":"Raging Swordtooth","scryfallId":"2a658710-bb9a-4f58-8e42-7bb686923329"},{"index":9858,"token":false,"name":"Goblin Motivator","scryfallId":"9f1027e0-c12b-449f-95eb-c425ed5655b3"},{"index":9861,"token":false,"name":"Urza's Rage","scryfallId":"37a3fec5-d3ee-4822-8e5b-63264edd0302"},{"index":9862,"token":false,"name":"Old Man of the Sea","scryfallId":"d10f8a05-78b0-42a7-adcd-83f6bafe5417"},{"index":9863,"token":false,"name":"Traumatic Visions","scryfallId":"0b4fae95-9cce-4f15-8288-987e698b8c7d"},{"index":9864,"token":false,"name":"Ashiok's Erasure","scryfallId":"62a0d2ba-c75b-4f40-a03b-914a10c35939"},{"index":9865,"token":false,"name":"Alchemist's Refuge","scryfallId":"c767a897-52e3-4401-8104-930157bb2b02"},{"index":9867,"token":false,"name":"Answered Prayers","scryfallId":"175b6e34-9cb3-4c8d-9cc0-960082a9ee71"},{"index":9868,"token":false,"name":"Halberdier","scryfallId":"b69dfc05-51ba-4798-ac00-1e9b8bbbf280"},{"index":9871,"token":false,"name":"Argent Mutation","scryfallId":"507fa5fd-2aa5-4721-a059-2c8c3056a4ca"},{"index":9873,"token":false,"name":"Marshland Bloodcaster","scryfallId":"024ab7f9-1891-4c71-9fcf-cf124b1c6d10"},{"index":9875,"token":false,"name":"Tend the Pests","scryfallId":"8f43ed93-008d-44db-8204-ef2cc3b7cf8a"},{"index":9878,"token":false,"name":"Vindicate","scryfallId":"97aeb745-5b98-4240-a1a8-861c06d616cc"},{"index":9879,"token":false,"name":"Arcbond","scryfallId":"988c59ba-4027-4e78-a6e2-07714438b3a6"},{"index":9881,"token":false,"name":"Songs of the Damned","scryfallId":"9133b267-295d-4987-b1d6-f32a85b66081"},{"index":9883,"token":false,"name":"Gatekeeper of Malakir","scryfallId":"2a206992-cdd2-4ced-807d-3a98f9fa1e71"},{"index":9885,"token":false,"name":"Skirsdag High Priest","scryfallId":"6b5771ae-8c27-40b3-b384-974cd75283fb"},{"index":9887,"token":false,"name":"Goblin Raider","scryfallId":"68fe9691-d788-42cb-8d13-005724939b62"},{"index":9894,"token":false,"name":"Purelace","scryfallId":"bd89c79a-668e-4f3c-b248-6f067e6fca65"},{"index":9895,"token":false,"name":"Varchild's Crusader","scryfallId":"b5ade7ad-ce32-4296-8cec-20bd79c7b16a"},{"index":9897,"token":false,"name":"Protean Raider","scryfallId":"cb75eabb-c366-48fa-9fb7-d3fb2d43a849"},{"index":9898,"token":false,"name":"Aether Gale","scryfallId":"9f04015b-0286-4230-a72f-36c511d89f45"},{"index":9900,"token":false,"name":"Alena, Kessig Trapper","scryfallId":"011dc183-eb83-4c66-9604-63d9ecf33705"},{"index":9902,"token":false,"name":"Volcanic Spray","scryfallId":"97daab4b-d934-4a3f-a043-f7c9c1dd32bf"},{"index":9903,"token":false,"name":"Serra Avatar","scryfallId":"bcab2e1e-6190-4d84-84b2-ae0ec34488de"},{"index":9904,"token":false,"name":"Cave People","scryfallId":"99e9ff47-b98c-4ab6-a4bc-8914360c3f6d"},{"index":9906,"token":false,"name":"Ruhan of the Fomori","scryfallId":"ccafb9b7-c9f4-46e6-91a7-dc34849d8aca"},{"index":9908,"token":false,"name":"Finest Hour","scryfallId":"ad89ace6-b872-4a56-8128-795119ceb972"},{"index":9909,"token":false,"name":"Benevolent Bodyguard","scryfallId":"9e1097d7-b40f-4a85-a335-636d40fe908e"},{"index":9910,"token":false,"name":"Fractured Identity","scryfallId":"8db735ea-f9cf-4e3c-9200-4f180df55baa"},{"index":9912,"token":false,"name":"Sprite Noble","scryfallId":"0de52e53-8a45-4c0a-bb7d-6dc0d659a7c0"},{"index":9913,"token":false,"name":"Heroes' Podium","scryfallId":"a3cb14f9-343c-4672-b4ee-db7f1d1a98ff"},{"index":9918,"token":false,"name":"Undertow","scryfallId":"cf05e5c9-b7e4-4bd8-ab73-b54565710527"},{"index":9919,"token":false,"name":"Aura Shards","scryfallId":"ee38a29d-20a4-48bb-8116-b62fe9342b84"},{"index":9920,"token":false,"name":"Khenra Eternal","scryfallId":"1892e24d-57c1-4a56-968a-77f8a8b508fc"},{"index":9923,"token":false,"name":"Nissa Revane","scryfallId":"4afe1f83-f53d-477d-8523-3e6fa8e51a0b"},{"index":9929,"token":false,"name":"Strixhaven Stadium","scryfallId":"421674ee-4b85-4942-b166-952598165826"},{"index":9931,"token":false,"name":"Indulgent Tormentor","scryfallId":"bca3a97b-a047-4841-8929-2e9802498fca"},{"index":9932,"token":false,"name":"Temple of Enlightenment","scryfallId":"adad8390-66d8-4022-a059-c68e44e718fe"},{"index":9933,"token":false,"name":"Steppe Glider","scryfallId":"cca16c1b-92e1-40f5-9d1f-8106ab03d2f9"},{"index":9935,"token":false,"name":"Sensor Splicer","scryfallId":"3369340f-d170-4566-b8e8-e4dc918f7f85"},{"index":9936,"token":false,"name":"Brawl","scryfallId":"3f4e783c-0717-4127-bd7b-885ca617ca29"},{"index":9937,"token":false,"name":"Dakkon, Shadow Slayer","scryfallId":"05467b80-0781-4f03-8027-59dbb44d8826"},{"index":9941,"token":false,"name":"Chainer's Edict","scryfallId":"edcff171-587d-4459-b6cc-8d7bc5ae145e"},{"index":9945,"token":false,"name":"Gush","scryfallId":"e755bbef-bf34-49c0-ae72-d70e3599de52"},{"index":9947,"token":false,"name":"Lesser Gargadon","scryfallId":"3946b496-858c-401b-a68f-f39cd6de0661"},{"index":9950,"token":false,"name":"Silver Erne","scryfallId":"685076cc-098c-4f98-918c-0ad825eda10f"},{"index":9954,"token":false,"name":"Unquestioned Authority","scryfallId":"ca33d5e6-aafe-4d18-919e-6be3c52f8eb8"},{"index":9955,"token":false,"name":"Dragonlord's Servant","scryfallId":"ce134b85-2cbd-4dab-b233-040fd1f31765"},{"index":9956,"token":false,"name":"Shambling Suit","scryfallId":"1100b898-31a8-4fdf-a54f-a1470ec032f3"},{"index":9958,"token":false,"name":"Supreme Exemplar","scryfallId":"2bea92ba-d6e3-4fba-be81-86b10852a9d1"},{"index":9961,"token":false,"name":"Thraben Standard Bearer","scryfallId":"12d4c34b-7ab7-4022-a43b-7c7e73a56864"},{"index":9962,"token":false,"name":"Rite of the Serpent","scryfallId":"005b9fec-66de-4079-88e0-c7de7e22d18e"},{"index":9964,"token":false,"name":"Inkfathom Witch","scryfallId":"2a48062c-faac-4183-830f-919ab255b907"},{"index":9968,"token":false,"name":"Wizard's Lightning","scryfallId":"59bf371a-164c-4db8-9207-197c2e7c3c10"},{"index":9969,"token":false,"name":"Icatian Lieutenant","scryfallId":"39fec59a-4ade-4c6f-ae7d-911fbe6da26d"},{"index":9970,"token":false,"name":"Bant Battlemage","scryfallId":"2c597b1d-d8b5-4922-a3f2-1f173a73ea2a"},{"index":9971,"token":false,"name":"Lurking Chupacabra","scryfallId":"abdbaa34-1ee5-4a2a-bdb3-2f04809a5b42"},{"index":9972,"token":false,"name":"Flowstone Blade","scryfallId":"08ffbdce-bf74-4366-a4c5-422e3d5c92b4"},{"index":9973,"token":false,"name":"Crimson Manticore","scryfallId":"47785679-8daf-4f52-82ef-4ccaa636b67e"},{"index":9974,"token":false,"name":"Llanowar Empath","scryfallId":"4465aff0-5481-4a38-80c5-a5427de9d2b1"},{"index":9975,"token":false,"name":"Honor of the Pure","scryfallId":"229c83e2-ff37-4ae2-9b0e-564197f35b78"},{"index":9976,"token":false,"name":"Hammerheim","scryfallId":"2816d30e-1e52-4323-b30e-1688fba23368"},{"index":9977,"token":false,"name":"Shield of Kaldra","scryfallId":"b645e258-ac76-48ac-80b6-785d81c68997"},{"index":9978,"token":false,"name":"Undercity Troll","scryfallId":"2fe1ebf9-8378-444b-870a-5be12aa1f5fa"},{"index":9980,"token":false,"name":"Silhouette","scryfallId":"e6d6fac6-9a23-465f-a813-92e1ed1cd742"},{"index":9981,"token":false,"name":"Beacon of Unrest","scryfallId":"ef3349a2-d867-4141-8b2b-2f9870897703"},{"index":9983,"token":false,"name":"Lapse of Certainty","scryfallId":"166d21f0-4ac8-44a0-bdd6-ae5ba8faec71"},{"index":9985,"token":false,"name":"Crown of Convergence","scryfallId":"c1b9f8c8-2927-4746-a540-dd3853b9a00e"},{"index":9987,"token":false,"name":"Ancient Kavu","scryfallId":"c8ccb5d0-735b-443f-addd-8b70f5f2c60d"},{"index":9990,"token":false,"name":"Wormfang Newt","scryfallId":"df8012c1-76ec-4c36-8b38-5bc41ce5e156"},{"index":9991,"token":false,"name":"Wall of Resistance","scryfallId":"fd25787d-b90c-4b25-8259-1ac41d4dcd15"},{"index":9993,"token":false,"name":"Gathan Raiders","scryfallId":"8af5c695-d0f4-4ea7-bc12-f3a24d5b6a11"},{"index":9994,"token":false,"name":"Pursued Whale","scryfallId":"143052f0-4fcc-4703-9147-75b65ddb8e0f"},{"index":9996,"token":false,"name":"Vinelasher Kudzu","scryfallId":"34955f52-521f-466c-9025-c117f6162e97"},{"index":9997,"token":false,"name":"Folio of Fancies","scryfallId":"2059629f-510a-4e4c-9116-1c0235cbaf52"},{"index":9998,"token":false,"name":"Akoum Flameseeker","scryfallId":"6ef4e1e2-7961-47d2-bb55-9168ea201214"},{"index":10002,"token":false,"name":"Vedalken Dismisser","scryfallId":"0656f4eb-40c5-4a21-b994-4ab07bc63981"},{"index":10003,"token":false,"name":"Jenara, Asura of War","scryfallId":"d643c335-e3a7-461d-a024-095795ab6770"},{"index":10004,"token":false,"name":"Thunderclap","scryfallId":"b3f8c5ee-2179-4c05-adc9-0b66d02b59ad"},{"index":10005,"token":false,"name":"Dust Elemental","scryfallId":"144e9391-f417-464b-8c04-c952193997c7"},{"index":10006,"token":false,"name":"Gloomlance","scryfallId":"7b45bfb2-7c48-4da5-a0fd-29d353221814"},{"index":10011,"token":false,"name":"Ephara's Warden","scryfallId":"71f7f788-2795-46a7-82ae-270f1e9415ca"},{"index":10012,"token":false,"name":"Death Pits of Rath","scryfallId":"f13af256-c9bd-4c44-b5f7-60b8d8efba75"},{"index":10013,"token":false,"name":"Cat Warriors","scryfallId":"90823485-83cd-4260-b860-7f05d8588905"},{"index":10014,"token":false,"name":"Hammerhead Shark","scryfallId":"48c1a040-9045-4977-84e4-695de0f886a9"},{"index":10016,"token":false,"name":"Sphinx of Jwar Isle","scryfallId":"1304a4e9-fd62-4b97-b652-b4ebc0f6ebe8"},{"index":10017,"token":false,"name":"Kuldotha Flamefiend","scryfallId":"189fea03-24db-4574-bbc2-4d3bc9e629a5"},{"index":10018,"token":false,"name":"Desertion","scryfallId":"ac212677-daa3-49ee-adb1-53a169cb7e9d"},{"index":10019,"token":false,"name":"Skullsnatcher","scryfallId":"3c16e4ae-d221-45e5-acc8-4dc15927c407"},{"index":10020,"token":false,"name":"Quest for the Gravelord","scryfallId":"5972edbd-ffe8-46e8-9c3e-5399c7d6879b"},{"index":10022,"token":false,"name":"Dauthi Mindripper","scryfallId":"6fb990ee-f027-4c74-a67e-98ada6aa21e4"},{"index":10023,"token":false,"name":"Cloud Spirit","scryfallId":"938d6c51-903b-4e0b-8702-291666581f2a"},{"index":10025,"token":false,"name":"Offalsnout","scryfallId":"737679bd-b38f-402e-a6b2-7964da0f8d2f"},{"index":10027,"token":false,"name":"Sun Clasp","scryfallId":"e3f1fb74-bc08-4c3b-9fbe-da6973aaeaa2"},{"index":10029,"token":false,"name":"Flamescroll Celebrant // Revel in Silence","scryfallId":"b52f1a16-ee9d-406c-8d5c-708361402b37"},{"index":10030,"token":false,"name":"Magmatic Channeler","scryfallId":"711c3023-1429-4aa1-b822-85ab1badf086"},{"index":10032,"token":false,"name":"Decimator of the Provinces","scryfallId":"5c39467b-50f8-45d1-a314-3267e8463231"},{"index":10034,"token":false,"name":"Zada, Hedron Grinder","scryfallId":"41de1c32-2b9e-46f9-ac23-dca869d83920"},{"index":10035,"token":true,"name":"Sphinx Token (U/W, 4/4)","scryfallId":"f82ba894-7b10-45ae-9322-60ef85a2869d"},{"index":10038,"token":false,"name":"Fractured Powerstone","scryfallId":"3b276615-24e2-4c8d-a2b4-b5ff777c5086"},{"index":10040,"token":false,"name":"Putrid Imp","scryfallId":"1b9e6c5c-4bc4-4f41-8c2c-f5b8c97c53c5"},{"index":10042,"token":false,"name":"Shimmer of Possibility","scryfallId":"76e3092d-2422-438c-b5dd-bf8eca33a76e"},{"index":10043,"token":false,"name":"Aladdin's Lamp","scryfallId":"8fecc5d2-5298-4d47-b085-f160603f220e"},{"index":10045,"token":false,"name":"Dire Fleet Warmonger","scryfallId":"1fa781df-859f-4346-9424-b3713b17e1f6"},{"index":10047,"token":false,"name":"Primitive Justice","scryfallId":"d6b7829b-2a10-47e7-9cf9-8ae49d2b398a"},{"index":10055,"token":false,"name":"Leonin of the Lost Pride","scryfallId":"e1be3729-7970-45df-8c26-4fe09e56629d"},{"index":10057,"token":true,"name":"Mouse Token (W, 1/1)","scryfallId":"fe10da68-dd05-4e8e-ab94-37262e835fb3"},{"index":10058,"token":false,"name":"Bramblecrush","scryfallId":"2e1bd3ff-f3cd-4e9d-ae2e-2c51d0aaec7f"},{"index":10059,"token":false,"name":"Grand Melee","scryfallId":"9a0d3142-4224-4b51-885d-33c8938418c1"},{"index":10060,"token":false,"name":"Apostle of Purifying Light","scryfallId":"62f69602-b5fd-46d6-8dae-d77df35e378c"},{"index":10061,"token":false,"name":"Latch Seeker","scryfallId":"f6b15693-8549-4663-9b0f-88a1247abc0b"},{"index":10063,"token":false,"name":"Graven Cairns","scryfallId":"0127d42f-bf40-48f4-a3a0-1a1c4039f432"},{"index":10065,"token":false,"name":"Syndicate Guildmage","scryfallId":"e82d3c8d-849a-445b-bc7c-365514d1511f"},{"index":10067,"token":false,"name":"Inspiring Call","scryfallId":"c565b991-7021-4b81-b9c0-f7231daae360"},{"index":10069,"token":false,"name":"Fire Whip","scryfallId":"3ee194b4-f18f-4ebd-b42f-c7dfef42f22e"},{"index":10070,"token":false,"name":"Raiding Nightstalker","scryfallId":"0df2887c-e70b-4ff3-a437-450c0037fb07"},{"index":10072,"token":false,"name":"Dreamscape Artist","scryfallId":"f244985e-7487-44db-bd69-47c781753f2e"},{"index":10073,"token":false,"name":"Anara, Wolvid Familiar","scryfallId":"8f2aadfd-e35a-4a00-9d64-265b57526d05"},{"index":10074,"token":false,"name":"Planar Outburst","scryfallId":"5f34f930-a7c6-400d-b6e8-b9908e0f0404"},{"index":10076,"token":false,"name":"Etched Oracle","scryfallId":"874c6926-1368-45fb-8ce6-2d1c3e231bf0"},{"index":10077,"token":false,"name":"Caustic Rain","scryfallId":"71fde21d-ce4e-41b7-97d5-c982f90b84a0"},{"index":10078,"token":false,"name":"Xun Yu, Wei Advisor","scryfallId":"3156d253-e38f-4d2b-b899-6119d9e1cb31"},{"index":10080,"token":false,"name":"Aerie Bowmasters","scryfallId":"2cc81518-773d-4d03-af15-360fe18752d1"},{"index":10081,"token":false,"name":"Cavalier of Dawn","scryfallId":"4065423b-d8f1-4ced-80ff-5ad35c32741b"},{"index":10082,"token":false,"name":"Trickster Mage","scryfallId":"b31b2e24-1a70-48bd-8946-ff29e12c6f3d"},{"index":10085,"token":false,"name":"Broodmate Dragon","scryfallId":"ea62ec34-be95-4682-a3fd-9a92a89103b5"},{"index":10086,"token":false,"name":"Scythe Tiger","scryfallId":"9d289043-edb5-4a7e-801b-4881709edb32"},{"index":10087,"token":false,"name":"Accomplished Alchemist","scryfallId":"ed275072-f84b-47ef-8631-3a4e787ea330"},{"index":10089,"token":false,"name":"Living Terrain","scryfallId":"64558128-7990-470c-88c9-d47d622e44db"},{"index":10090,"token":false,"name":"Divine Transformation","scryfallId":"8dd92623-d3a6-4f32-bd19-1a1c40e29190"},{"index":10091,"token":false,"name":"Gallowbraid","scryfallId":"8df86192-6374-42ac-94bc-95e2e8284bd6"},{"index":10092,"token":false,"name":"Sultai Runemark","scryfallId":"60b1524c-48fa-4197-9f54-3f5ddfb15925"},{"index":10095,"token":true,"name":"Spider Token (B, 2/4)","scryfallId":"2d833298-a270-4b89-987c-5b6432bbc311"},{"index":10096,"token":false,"name":"Goblin Bird-Grabber","scryfallId":"54fbbf39-cd52-474a-908e-b7a78cb5eb5b"},{"index":10098,"token":false,"name":"Patagia Golem","scryfallId":"d5b5d7ea-6240-44a4-9792-6a8416d15e49"},{"index":10100,"token":false,"name":"Bronzehide Lion","scryfallId":"c65f4d9d-aa87-439c-8db5-3789cabcce4c"},{"index":10101,"token":false,"name":"Gavony Township","scryfallId":"b5f73443-2fe8-424f-8e71-fc7ce1f3a3eb"},{"index":10103,"token":false,"name":"Foul Presence","scryfallId":"7c5a6fa8-d422-4e56-9e7b-2ff2fc8aecfe"},{"index":10104,"token":false,"name":"Precise Strike","scryfallId":"3cd2e7ab-b63e-48e8-a32a-6ff8673241d9"},{"index":10105,"token":false,"name":"Backdraft","scryfallId":"58d5b9fe-b66a-48c9-94c4-db783e605f37"},{"index":10106,"token":false,"name":"Grave-Shell Scarab","scryfallId":"23f7c7d0-a48b-4153-8386-a9ab71e01dbe"},{"index":10108,"token":false,"name":"Spectral Shepherd","scryfallId":"ac355ae2-7553-4b51-bcce-1c4168dad0d6"},{"index":10109,"token":false,"name":"Icebind Pillar","scryfallId":"a3152f1f-5d3f-4bc4-9b6f-f2983ab3f691"},{"index":10111,"token":false,"name":"Blinding Spray","scryfallId":"9b588355-c349-458d-aeb7-0e2780caa3f9"},{"index":10115,"token":true,"name":"Zombie Giant Token (B, 5/5)","scryfallId":"be7e26e1-5db6-49ba-a88e-c79d889cd364"},{"index":10117,"token":false,"name":"Dawnbreak Reclaimer","scryfallId":"b6d097f4-4831-4611-81d9-3a09b7926d1a"},{"index":10118,"token":false,"name":"Rootwater Depths","scryfallId":"4d4bcbef-66bf-4625-82d5-a01c39d3d78e"},{"index":10119,"token":false,"name":"Chorus of Woe","scryfallId":"0289ddb3-b35c-4edf-92bb-06f84a3475d9"},{"index":10120,"token":false,"name":"Oasis","scryfallId":"ea9f541b-8f78-4bfd-974d-b49e03c3113a"},{"index":10122,"token":false,"name":"Vodalian Soldiers","scryfallId":"7eb50256-9113-4b03-bcef-9aea24be8493"},{"index":10123,"token":false,"name":"Ordruun Veteran","scryfallId":"20fea3f6-e64a-4964-86bc-c0b8fef0ab25"},{"index":10125,"token":false,"name":"Mist-Syndicate Naga","scryfallId":"65c8f074-e260-4f8e-85d1-1904ca928b51"},{"index":10126,"token":false,"name":"Djinn of Wishes","scryfallId":"74c621dd-9c60-4951-beaf-eb6b597c2f0f"},{"index":10127,"token":false,"name":"Flamestick Courier","scryfallId":"e822161d-0434-4578-aecd-c9ef0b84bd4e"},{"index":10128,"token":false,"name":"Tuktuk the Explorer","scryfallId":"bc4c0d5b-6424-44bd-8445-833e01bb6af4"},{"index":10130,"token":false,"name":"Ignite the Beacon","scryfallId":"159a7470-e345-4597-b960-304a4489e66a"},{"index":10133,"token":false,"name":"Blister Beetle","scryfallId":"7f42bdeb-5a51-4303-96d8-9722f95d2905"},{"index":10135,"token":false,"name":"Bountiful Harvest","scryfallId":"8d7a4494-2ced-4405-9204-d2617961a1d6"},{"index":10137,"token":false,"name":"Patchwork Gnomes","scryfallId":"a3e2ec88-68d7-4b28-8614-ecaf49ecd8e4"},{"index":10138,"token":false,"name":"Assembled Alphas","scryfallId":"bc7f2b5d-7dff-4d83-9c08-bd32f36cab03"},{"index":10139,"token":false,"name":"Iridescent Hornbeetle","scryfallId":"214ef641-b08c-42d0-94a5-3054fa7fcebc"},{"index":10144,"token":false,"name":"Path of Ancestry","scryfallId":"88b9476e-3556-4229-a4fe-84e527894b41"},{"index":10145,"token":false,"name":"Fable of Wolf and Owl","scryfallId":"be364b69-aa59-420c-a613-b1d0b303a4e5"},{"index":10146,"token":false,"name":"Inspiring Roar","scryfallId":"4ef9708e-bfe4-4d24-8304-1618daa1c3ee"},{"index":10147,"token":false,"name":"Boros Swiftblade","scryfallId":"bf25cd63-3304-4eea-841b-1f058010c627"},{"index":10149,"token":false,"name":"Renegade Troops","scryfallId":"a75095f4-a77f-4237-ae25-2e6f2f8788c1"},{"index":10150,"token":false,"name":"Immersturm Skullcairn","scryfallId":"12ed97de-736d-43d8-977b-308ac54f88f4"},{"index":10151,"token":false,"name":"Kill Shot","scryfallId":"1977d0d0-a7cc-48b8-ab61-199de54fb591"},{"index":10152,"token":false,"name":"Devastation Tide","scryfallId":"23b62be6-1a80-4f16-a94a-374203052662"},{"index":10153,"token":false,"name":"Keldon Marauders","scryfallId":"150c1f6c-52b2-4dbd-921f-78a3f76a3f3b"},{"index":10154,"token":false,"name":"Chandra's Incinerator","scryfallId":"53e99879-2132-46de-a589-42990e59bf2b"},{"index":10157,"token":false,"name":"Jet Medallion","scryfallId":"7f85698a-821f-452d-9e31-e525c0100f2d"},{"index":10159,"token":false,"name":"Altar of Bone","scryfallId":"75d5b014-8675-4d91-a539-ac5c31d44b35"},{"index":10161,"token":false,"name":"Ogre Marauder","scryfallId":"f083bd50-d171-4e49-b8e6-972802879c24"},{"index":10162,"token":false,"name":"Sparkmage Apprentice","scryfallId":"6ca91f7f-4b17-469e-8650-4c18e1521ea9"},{"index":10164,"token":false,"name":"Arrow Volley Trap","scryfallId":"b8b3ea52-2338-4499-9100-c4be73cdfc32"},{"index":10165,"token":false,"name":"Distortion Strike","scryfallId":"315f1cf8-7bde-4592-a14e-ef9e2e3e7ac0"},{"index":10168,"token":false,"name":"Centaur Courser","scryfallId":"e8b67ee8-3189-4426-8b1a-b540267768fd"},{"index":10171,"token":false,"name":"Vulshok Battlegear","scryfallId":"13e731de-32e9-4dae-804f-9b962b457cf3"},{"index":10175,"token":false,"name":"Frost Augur","scryfallId":"a2ae592f-caf6-445a-970b-f8101998e657"},{"index":10177,"token":false,"name":"Waterkin Shaman","scryfallId":"184bfbc4-1c9b-44f7-b4a7-068290db3bac"},{"index":10179,"token":false,"name":"Monastery Swiftspear","scryfallId":"58db2f81-6ff5-402c-8aef-0b667e82cdc4"},{"index":10184,"token":false,"name":"Bounty of the Luxa","scryfallId":"0b52126a-edde-46df-a63b-4071be2768e4"},{"index":10185,"token":false,"name":"Oath of Nissa","scryfallId":"613513ea-55dd-4ae8-93b2-247e468112a6"},{"index":10186,"token":false,"name":"Dwarven Pony","scryfallId":"53a3019f-0b27-4ba3-be4c-73ed50eb9514"},{"index":10187,"token":false,"name":"Replication Technique","scryfallId":"bf4341ec-027d-47eb-b2ca-f18f9885d82d"},{"index":10189,"token":false,"name":"Reito Lantern","scryfallId":"90eba910-852b-47e0-b4cd-07f30d80f921"},{"index":10190,"token":false,"name":"Brought Back","scryfallId":"aecdc315-95e5-450c-bedc-998eea46cf8c"},{"index":10191,"token":false,"name":"Ancestral Tribute","scryfallId":"3f28b2af-7891-49eb-a07f-5552b5fe3d15"},{"index":10192,"token":false,"name":"Kjeldoran Dead","scryfallId":"590c219d-536a-47a4-93a4-b77ce808a024"},{"index":10193,"token":false,"name":"Gearseeker Serpent","scryfallId":"d32d8327-6ec2-4d43-b254-b04407612715"},{"index":10195,"token":false,"name":"Warrior's Honor","scryfallId":"09117d06-79e6-4f86-ba92-d1f8fe165147"},{"index":10197,"token":false,"name":"Enigma Drake","scryfallId":"006b0048-8a84-469c-974f-b75177b4dd81"},{"index":10205,"token":false,"name":"Pack's Favor","scryfallId":"d3393b18-2097-4f88-aca2-a138c9ea71c1"},{"index":10206,"token":false,"name":"Deadfall","scryfallId":"0d78f0fc-3ab2-46ee-b5a9-55ae97d08c1a"},{"index":10209,"token":false,"name":"Alpha Status","scryfallId":"9c10c6eb-24a1-4fd7-aabe-c6ae0e163b1a"},{"index":10210,"token":false,"name":"Mind Spring","scryfallId":"3efa29a6-64bc-4d0d-8522-b548bd18bc76"},{"index":10211,"token":false,"name":"Dimir Signet","scryfallId":"501d0d13-b6a4-415c-916e-fdb0809a67d8"},{"index":10212,"token":false,"name":"Leatherback Baloth","scryfallId":"55f97b4c-42c7-4986-a150-0b8de11f0537"},{"index":10213,"token":false,"name":"Servant of the Conduit","scryfallId":"9ce9cf30-4baa-4f28-84e8-b9b1168a40e0"},{"index":10215,"token":false,"name":"Dual Nature","scryfallId":"6890e414-d7e1-4320-924c-083e65a2ae72"},{"index":10216,"token":false,"name":"Hakim, Loreweaver","scryfallId":"8192bca7-03e5-4ea1-ae77-8bc811c19417"},{"index":10217,"token":false,"name":"Mind Slash","scryfallId":"966b77b0-0604-4935-bdac-bef8af014802"},{"index":10219,"token":false,"name":"Soltari Champion","scryfallId":"a112edf3-c976-426c-a407-e86255586e41"},{"index":10221,"token":false,"name":"Prognostic Sphinx","scryfallId":"9f0a27a6-54b8-4615-89b3-591a4e3ef626"},{"index":10223,"token":false,"name":"Dimir Aqueduct","scryfallId":"7b108bfd-f32d-49d4-9f3c-666799b3dd0d"},{"index":10224,"token":false,"name":"Wrecking Ball","scryfallId":"1182e0cf-475e-4cb9-a00a-c9a4032f51e4"},{"index":10226,"token":false,"name":"Blade of Selves","scryfallId":"6e8735b5-64ef-4782-8d8d-4477b409e52d"},{"index":10227,"token":true,"name":"Ogre Token (R, 4/4)","scryfallId":"efaa37e5-302e-4b4b-bb2d-6a0f9f80cd3f"},{"index":10229,"token":false,"name":"Fathom Fleet Swordjack","scryfallId":"53c267b7-dbd6-43c5-9741-10f635bff4b1"},{"index":10230,"token":false,"name":"Cosmos Elixir","scryfallId":"6bf084fe-7762-49c5-974a-cdecc10666b3"},{"index":10231,"token":false,"name":"Slipstream Serpent","scryfallId":"f16dac30-52d2-4b87-90b4-4bc7f8f729ee"},{"index":10232,"token":false,"name":"Fauna Shaman","scryfallId":"bddcec63-a60a-4d73-af6d-9ac978703811"},{"index":10234,"token":false,"name":"Whiplash Trap","scryfallId":"0eed2a1e-118a-4e0c-b670-8561e1700ced"},{"index":10235,"token":false,"name":"Mistmeadow Skulk","scryfallId":"b18ff12f-3b0e-404a-8e35-3f7d05d0c0a7"},{"index":10236,"token":false,"name":"Tidewalker","scryfallId":"9464c2aa-8f12-4654-89c5-3323d7e7ab73"},{"index":10238,"token":false,"name":"First Volley","scryfallId":"d6e5e360-ed47-40c1-8ad7-57645c2854ca"},{"index":10239,"token":false,"name":"Indentured Oaf","scryfallId":"af6e976c-3c0b-4ba5-b614-e1b576b57e86"},{"index":10240,"token":false,"name":"Neurok Stealthsuit","scryfallId":"d5e58c74-0ba6-452a-94a6-8256c4f6aba8"},{"index":10241,"token":false,"name":"Back to Nature","scryfallId":"b49270b2-ba15-4268-adb3-16d09c09adee"},{"index":10242,"token":false,"name":"Harsh Mercy","scryfallId":"b6473b4d-1f59-4216-ace9-f3e5306266fb"},{"index":10247,"token":false,"name":"Firestorm Phoenix","scryfallId":"3247a7dd-f48c-4cb4-8475-4864acccef7a"},{"index":10250,"token":false,"name":"Grizzled Outrider","scryfallId":"4a1d4473-5317-4bdd-9cb9-93670acf52e9"},{"index":10251,"token":false,"name":"Genju of the Cedars","scryfallId":"9d621b82-c863-437b-b42c-31a0872be6d4"},{"index":10253,"token":false,"name":"Snow-Covered Forest","scryfallId":"1c59fc48-704b-4187-b9d3-2a2cff6dd54b"},{"index":10255,"token":false,"name":"Unyaro Bee Sting","scryfallId":"71bdd944-e86c-4e5e-b75c-9bbf4fb27ccd"},{"index":10256,"token":false,"name":"Power Armor","scryfallId":"ed1981dd-c0f3-4e9d-a1f1-8bea823326ef"},{"index":10257,"token":false,"name":"Flesh // Blood","scryfallId":"02b40fe4-901a-4832-8d52-a6bb5cc07b63"},{"index":10262,"token":false,"name":"Akroan Conscriptor","scryfallId":"decb529f-44fd-409d-932f-be9c403f12f6"},{"index":10263,"token":false,"name":"Dramatic Finale","scryfallId":"a78e69f1-d779-4b53-a621-e9540491934d"},{"index":10265,"token":false,"name":"Trial of Knowledge","scryfallId":"89020c72-4cda-4634-8475-6d16a02236f1"},{"index":10266,"token":false,"name":"Day of Judgment","scryfallId":"6ba873f7-a7a4-44aa-84a6-44501424dc7a"},{"index":10267,"token":false,"name":"Tidal Barracuda","scryfallId":"aacdf4c2-9bc8-400a-8ffc-d6597d8d7da9"},{"index":10268,"token":false,"name":"Dirtcowl Wurm","scryfallId":"eafbc345-7f8a-4173-9168-fbaefdd42f2e"},{"index":10269,"token":false,"name":"Sanctum of All","scryfallId":"fb899b8c-210f-487d-9fa8-dc64c8f20475"},{"index":10273,"token":false,"name":"Kianne, Dean of Substance // Imbraham, Dean of Theory","scryfallId":"5501da7b-2f7f-4638-aa31-400d538fcfd0"},{"index":10274,"token":false,"name":"Thousand Winds","scryfallId":"f73d6480-2ddb-465d-8d21-11163744378d"},{"index":10275,"token":false,"name":"Pitchburn Devils","scryfallId":"fbd306cf-6625-4414-b9e5-4b909bb1bb13"},{"index":10278,"token":false,"name":"Forgotten Creation","scryfallId":"8bbc46c1-8f93-4d76-a779-2744f57b41a3"},{"index":10279,"token":false,"name":"Chandra, Flame's Fury","scryfallId":"5d1c6c4b-62ab-4d44-a2d7-64b44d163606"},{"index":10280,"token":false,"name":"Lashknife","scryfallId":"fd7451cc-4126-4518-a103-2558fa81323f"},{"index":10282,"token":false,"name":"Inscription of Insight","scryfallId":"281cdb1c-21ae-4430-8e0f-c993f52ba891"},{"index":10287,"token":false,"name":"Master of Waves","scryfallId":"19242db3-660d-4d66-800c-d6cee636bcaf"},{"index":10292,"token":false,"name":"Echo Tracer","scryfallId":"e856fbd5-0e8b-4f28-bfea-0ad73418d140"},{"index":10294,"token":false,"name":"Sulfur Vent","scryfallId":"22c66ed6-55fb-4c65-aac4-26d9cc3053b8"},{"index":10297,"token":false,"name":"Mind's Desire","scryfallId":"1290e00b-c41b-4e30-8b65-a7fd4356d462"},{"index":10298,"token":false,"name":"Artifact Possession","scryfallId":"587d6ac8-fad8-49e0-862e-636e06628ff9"},{"index":10299,"token":false,"name":"Nine Lives","scryfallId":"db53841f-5fae-412d-8b85-86b876d47e87"},{"index":10300,"token":false,"name":"Slagwurm Armor","scryfallId":"684a6e3f-909a-4ca0-a6aa-7354b9476df2"},{"index":10301,"token":false,"name":"Horizon Drake","scryfallId":"022f07c5-c644-41cd-9434-a57068f73ab2"},{"index":10308,"token":false,"name":"Mishra's Self-Replicator","scryfallId":"e6f342b2-1ba6-4b72-9f03-bc076c795b3d"},{"index":10309,"token":false,"name":"Rakish Heir","scryfallId":"4afab3a6-95e3-4786-94f2-d9aa7365a4de"},{"index":10311,"token":false,"name":"Quirion Dryad","scryfallId":"dead95f5-2e72-4591-be1e-bce6726e1c5e"},{"index":10312,"token":false,"name":"Spinal Graft","scryfallId":"21fe0fc2-cd6d-4d81-872f-9a7757b88ec0"},{"index":10313,"token":false,"name":"Graverobber Spider","scryfallId":"41810472-ba24-44b6-886c-f8906ff0a7df"},{"index":10314,"token":false,"name":"Savaen Elves","scryfallId":"38fb3014-f631-4a75-92cd-7e626b13a4c3"},{"index":10315,"token":false,"name":"Living Lands","scryfallId":"124b1032-5cbc-477a-b263-7fe0d47431d9"},{"index":10316,"token":false,"name":"Samite Blessing","scryfallId":"3b21aa2e-df36-4101-89b6-515858f2ab88"},{"index":10317,"token":false,"name":"Cosi's Trickster","scryfallId":"e1eb7372-481a-44a6-937d-21430ee02ff9"},{"index":10319,"token":false,"name":"Ixalli's Diviner","scryfallId":"b22b55f6-681f-45da-bc57-a0cf7b8f671d"},{"index":10322,"token":false,"name":"Wight of Precinct Six","scryfallId":"776e36b2-d035-41a0-b218-6f2cb96f92af"},{"index":10323,"token":false,"name":"Prosperous Pirates","scryfallId":"5d778bde-f927-419e-8052-6230562bdedd"},{"index":10327,"token":false,"name":"Rogue's Gloves","scryfallId":"22a35bd7-8f0f-421a-948d-810513e6b0a0"},{"index":10328,"token":false,"name":"Whirlpool Whelm","scryfallId":"1934c34a-c163-4fac-a80d-8b17e8d64efa"},{"index":10331,"token":false,"name":"Vedalken Engineer","scryfallId":"d06a2d9a-9401-4711-97b6-825652090c4d"},{"index":10332,"token":false,"name":"Cultivator of Blades","scryfallId":"5d21d35b-1b4e-43aa-8fb7-0dd7a2fa91a1"},{"index":10333,"token":false,"name":"Sporesower Thallid","scryfallId":"7facb43f-275f-4f7f-a1b2-9c0e4b15addc"},{"index":10334,"token":false,"name":"Teferi's Ageless Insight","scryfallId":"09971b9a-f0b0-4fd1-8104-29de581ef93e"},{"index":10339,"token":false,"name":"Belltoll Dragon","scryfallId":"97e8fba0-fcb4-440c-9442-92278e21c5e9"},{"index":10341,"token":false,"name":"Eye of the Storm","scryfallId":"479d546f-4c42-4539-aa43-bf3c4af797b4"},{"index":10343,"token":false,"name":"Zhur-Taa Druid","scryfallId":"b82d8359-4841-478c-851b-13a1a0f94737"},{"index":10344,"token":false,"name":"Dawntreader Elk","scryfallId":"524fab2b-ff28-4e02-9f25-e038c754b2cf"},{"index":10346,"token":false,"name":"Etherium Spinner","scryfallId":"cdc8056f-4c8e-4a2b-b32f-c50c2cb7601a"},{"index":10348,"token":false,"name":"Jötun Grunt","scryfallId":"27118cbb-a386-4145-8716-961ed0f653bf"},{"index":10353,"token":false,"name":"Gisela, Blade of Goldnight","scryfallId":"4d039ff5-907f-4c27-8941-83e5e75bd19d"},{"index":10355,"token":false,"name":"Blitz Leech","scryfallId":"7d9b5bde-a851-480b-b45e-d384fd1c11bb"},{"index":10356,"token":false,"name":"Wildest Dreams","scryfallId":"3ddd0a9f-b937-44c8-9ce2-259c52162a60"},{"index":10358,"token":false,"name":"Pheres-Band Centaurs","scryfallId":"2168fcf4-cf87-4ab8-9710-6ec672750a9a"},{"index":10359,"token":false,"name":"Death Baron","scryfallId":"13edd66d-5d4c-4e3a-ac35-cb74f05a6c55"},{"index":10361,"token":false,"name":"Vanquish the Weak","scryfallId":"c15852d4-2c79-4841-bb65-6661d88fdfab"},{"index":10362,"token":false,"name":"Weatherseed Faeries","scryfallId":"8c7ebec7-7375-4362-9489-437ff9305f19"},{"index":10364,"token":false,"name":"Doubling Cube","scryfallId":"220d3a38-10f8-4d4a-84b8-f17b10a2cd6c"},{"index":10366,"token":false,"name":"Alesha, Who Smiles at Death","scryfallId":"09ac9669-d0ee-4df8-af77-12dfccac774f"},{"index":10368,"token":false,"name":"Xantid Swarm","scryfallId":"022ab408-3292-40b6-b35e-ac1b7f06dffa"},{"index":10369,"token":false,"name":"Forget","scryfallId":"fceaa7b0-b11d-47d6-9cdf-7c9fa85bea20"},{"index":10370,"token":false,"name":"Liliana's Mastery","scryfallId":"5c57b3b8-71f1-479c-b7f7-508fee2b5b0f"},{"index":10372,"token":false,"name":"Graceful Adept","scryfallId":"648430cc-80d1-479f-ae31-76687d2eb57c"},{"index":10373,"token":false,"name":"Frilled Deathspitter","scryfallId":"d20a38fa-bf26-403e-98bb-4e078084b154"},{"index":10377,"token":false,"name":"Ashenmoor Gouger","scryfallId":"80c7931f-e979-4f43-81dd-c34166526f87"},{"index":10378,"token":false,"name":"Viridian Emissary","scryfallId":"129fa334-f561-4fbd-9f51-2fa044b674e1"},{"index":10379,"token":false,"name":"Silvos, Rogue Elemental","scryfallId":"01e4e341-e0ab-41bc-8064-0a22ccd7eb7d"},{"index":10380,"token":false,"name":"Ancient Craving","scryfallId":"57710f0d-267d-4351-8662-156688df1f65"},{"index":10381,"token":false,"name":"Skull Catapult","scryfallId":"6c1e2ca0-7bb1-45eb-a57d-a8f00f5293a1"},{"index":10382,"token":false,"name":"Nadier, Agent of the Duskenel","scryfallId":"706b078f-0355-45cd-94db-26b925777efe"},{"index":10383,"token":false,"name":"Sol'kanar the Swamp King","scryfallId":"4c56d4b5-08fb-4547-91e2-6e5f8fae408d"},{"index":10384,"token":false,"name":"Venomous Hierophant","scryfallId":"9dc2b661-2f42-419d-837f-bbf097c1153c"},{"index":10385,"token":false,"name":"Terrarion","scryfallId":"48eda056-e00f-4e28-ad26-9150a4704d21"},{"index":10387,"token":false,"name":"Temporal Extortion","scryfallId":"883a1afb-423d-4f12-93e1-75cc336553b8"},{"index":10389,"token":false,"name":"Belbe's Portal","scryfallId":"6b46f93d-cdc5-4521-940d-e05d5463c30d"},{"index":10391,"token":false,"name":"Expel from Orazca","scryfallId":"64f5119f-3921-48a5-a8fb-0cb1bbabde30"},{"index":10392,"token":false,"name":"Combustible Gearhulk","scryfallId":"19d3e0fc-99f5-4aef-945a-dd65ad11b5fc"},{"index":10393,"token":false,"name":"Orvar, the All-Form","scryfallId":"7f36775e-9e48-49cc-a771-d58481712edc"},{"index":10396,"token":false,"name":"Geyser Glider","scryfallId":"b8aec169-4c62-4d53-a19c-68baa20c8e59"},{"index":10398,"token":false,"name":"Invoke the Divine","scryfallId":"7c1d36b5-37fb-4e52-ad85-c3a09a990ea0"},{"index":10399,"token":false,"name":"Presence of the Wise","scryfallId":"f6aedb5a-48f5-47db-9469-14075e2b9269"},{"index":10401,"token":false,"name":"Lord of Tresserhorn","scryfallId":"1d9d8732-9ff2-42e4-bdfc-723cb6a76969"},{"index":10402,"token":false,"name":"Rakdos Pit Dragon","scryfallId":"e47bdc80-26e9-4119-9dda-476aac8447ba"},{"index":10403,"token":true,"name":"Avatar Token (B/R, 3/6)","scryfallId":"94a50acd-ac2d-47bf-b331-0bcf5edd9c75"},{"index":10404,"token":false,"name":"Tenacious Hunter","scryfallId":"3eec0010-52ab-4bf2-b589-e7fd97c290fe"},{"index":10406,"token":false,"name":"Ivy Elemental","scryfallId":"ec93afed-b75b-4ee3-97f4-2ceda78f679b"},{"index":10407,"token":true,"name":"Spooky","scryfallId":"af16e16e-3d36-4016-8e7d-97c48bc22e2b"},{"index":10410,"token":false,"name":"Marrow Shards","scryfallId":"53ca60ee-e54b-4a28-b6a6-7bf3503c35b4"},{"index":10411,"token":false,"name":"Anticipate","scryfallId":"87f7a3f3-517a-4f7a-bb28-94f11790b598"},{"index":10413,"token":false,"name":"Runesword","scryfallId":"741dbcf2-3372-45a8-b66f-d2ae12b4aac6"},{"index":10415,"token":false,"name":"Tropical Island","scryfallId":"a0f5c6bc-65dc-42a1-a62d-a0b101310a1f"},{"index":10418,"token":false,"name":"Char-Rumbler","scryfallId":"13f696f9-afa2-40c4-950a-e1e01c452017"},{"index":10420,"token":false,"name":"Sigarda, Heron's Grace","scryfallId":"264639c6-2307-470f-b521-a0cbb8b7b765"},{"index":10422,"token":false,"name":"Bazaar Krovod","scryfallId":"b07bb2fe-3a9b-47d0-864b-99a662d9544b"},{"index":10426,"token":false,"name":"Divine Arrow","scryfallId":"73cbb58a-1b00-4883-9b45-da7ded7317e3"},{"index":10428,"token":false,"name":"Magma Giant","scryfallId":"57670afe-cc40-44f5-b97c-a8f0377c710a"},{"index":10429,"token":false,"name":"Serum Visions","scryfallId":"4bc61952-88ba-447a-835a-f1e9643fcd0d"},{"index":10435,"token":false,"name":"Riku of Two Reflections","scryfallId":"87d0ac34-a04d-426c-8392-6e12bdeb7760"},{"index":10436,"token":false,"name":"Fountain of Cho","scryfallId":"41f352c3-4b63-4174-b2b4-6c19fb8c06ff"},{"index":10437,"token":false,"name":"Duplicant","scryfallId":"d981ca03-c3a4-4fcc-9b4a-a02377102832"},{"index":10442,"token":false,"name":"Baloth Woodcrasher","scryfallId":"8223dc6a-2bee-4be9-86d5-f0a17a24c33e"},{"index":10443,"token":false,"name":"Travel Preparations","scryfallId":"e9654ae7-af2c-4956-be3a-68befa33f523"},{"index":10445,"token":false,"name":"Ma Chao, Western Warrior","scryfallId":"4b0fc563-46c8-4bd6-8e9b-bb0f08d9464d"},{"index":10446,"token":false,"name":"Spelltithe Enforcer","scryfallId":"0dd5682a-ca93-4b5f-af21-e1ff4439361b"},{"index":10447,"token":false,"name":"Summary Dismissal","scryfallId":"4368812a-69cb-4c26-b36e-5ff65bc89470"},{"index":10448,"token":false,"name":"Angel of Light","scryfallId":"750ea219-b62d-49bd-9b30-8e0a62e75553"},{"index":10449,"token":false,"name":"Requiem Angel","scryfallId":"ad135475-d1f6-4e78-a536-6bf61204c739"},{"index":10450,"token":false,"name":"Dark Withering","scryfallId":"3da58e0d-5877-43c4-b129-993e154b6087"},{"index":10451,"token":false,"name":"Castle Garenbrig","scryfallId":"fbef0b7f-f680-4915-a74c-300502745ea6"},{"index":10452,"token":false,"name":"Iona's Judgment","scryfallId":"d35ad15a-82c8-4cdd-84e7-02ef66fd0d19"},{"index":10454,"token":false,"name":"Celestial Archon","scryfallId":"9d049a62-c047-4c67-8b7e-519e71b96c3b"},{"index":10455,"token":false,"name":"Tar Pitcher","scryfallId":"30f40e38-2fcc-4927-9ce2-2080fa2d832c"},{"index":10456,"token":false,"name":"Canopy Vista","scryfallId":"a3262c7f-4fdf-4648-ba59-9279c75d222d"},{"index":10457,"token":false,"name":"Bomb Squad","scryfallId":"8e9535a5-29ea-4085-a36b-4905d85e97ac"},{"index":10460,"token":false,"name":"Nacre Talisman","scryfallId":"06912236-8225-4eb0-8086-c6a163c69892"},{"index":10462,"token":false,"name":"Font of Return","scryfallId":"c13eacff-0fd1-4e2e-8213-5bf5fff973c8"},{"index":10463,"token":false,"name":"Kor Hookmaster","scryfallId":"1c77d014-8ea2-4203-88b4-53be3819bf3c"},{"index":10464,"token":false,"name":"Vanish into Memory","scryfallId":"a6b697b5-cfa2-4f3f-a36f-a3f8b79c2060"},{"index":10465,"token":false,"name":"Orcish Oriflamme","scryfallId":"6184400c-9652-44c5-81bb-3072bfa84dee"},{"index":10467,"token":false,"name":"Metathran Zombie","scryfallId":"6676a0f7-8213-4547-b2ac-b904cd418073"},{"index":10470,"token":false,"name":"Miscast","scryfallId":"033afbd5-9937-4957-98ba-48e469a490bb"},{"index":10471,"token":false,"name":"Klothys, God of Destiny","scryfallId":"4d747889-04db-4e7a-ad4c-7549514b5112"},{"index":10472,"token":false,"name":"First-Sphere Gargantua","scryfallId":"e387dc5d-292f-4c69-9cf7-0b489bd0a027"},{"index":10474,"token":false,"name":"Sunforger","scryfallId":"3945c488-6966-4c7d-a0b7-487a2c1837aa"},{"index":10477,"token":false,"name":"Roots","scryfallId":"efb4c256-e790-41ec-a9ab-e6358e810798"},{"index":10478,"token":false,"name":"Simic Charm","scryfallId":"97c27bdd-77f5-4e93-8f54-93a204fc980a"},{"index":10479,"token":false,"name":"Time of Need","scryfallId":"514577a5-c7ae-4cfc-872a-e3786d78a6c3"},{"index":10480,"token":false,"name":"Tolsimir Wolfblood","scryfallId":"069ac859-e0ef-4685-bad3-5c741102b5b9"},{"index":10481,"token":false,"name":"Sickle Ripper","scryfallId":"831462c0-476b-4106-8381-e4177626b570"},{"index":10486,"token":false,"name":"Implement of Improvement","scryfallId":"2cb8eb0c-d7fa-4229-ae65-1890c77b2c7c"},{"index":10489,"token":false,"name":"Flanking Troops","scryfallId":"a219a031-2466-4850-b646-79a09e30cf18"},{"index":10490,"token":true,"name":"Horror Token (B, 4/4)","scryfallId":"a0b5e1f4-9206-40b6-9cf6-331f6a95d045"},{"index":10491,"token":false,"name":"Geralf's Masterpiece","scryfallId":"691e0b63-e676-4a20-8b8a-00155c5143aa"},{"index":10493,"token":false,"name":"Comeuppance","scryfallId":"92d59c06-41f7-4009-9157-70ba90cc978b"},{"index":10494,"token":true,"name":"Dwarf Token (R, 1/1)","scryfallId":"cab5d0dd-8095-4410-8feb-8c13edfcb2e5"},{"index":10498,"token":false,"name":"Liege of the Axe","scryfallId":"eb518bf0-17ad-4bbf-b922-42ee76ffcbea"},{"index":10500,"token":false,"name":"Ancestral Memories","scryfallId":"9953a9d1-62db-4610-bf8c-74c321f059c2"},{"index":10501,"token":true,"name":"Human Cleric Token (R/W, 2/1)","scryfallId":"db951f76-b785-453e-91b9-b3b8a5c1cfd4"},{"index":10505,"token":false,"name":"Infuse with Vitality","scryfallId":"840600a9-3e78-48a6-b75b-860446b82c1b"},{"index":10506,"token":false,"name":"Copper-Leaf Angel","scryfallId":"7be413dd-d6e0-4bd3-8c14-4dbe44e8ee41"},{"index":10507,"token":false,"name":"Empty the Pits","scryfallId":"e94b1ac7-dd7b-46a1-a74e-aa0563bab3cd"},{"index":10508,"token":false,"name":"Phantom Centaur","scryfallId":"c32a21c0-acaa-4701-8347-edf961827c08"},{"index":10509,"token":false,"name":"Barbed Shocker","scryfallId":"41b6f45a-7219-4b59-bf0a-9e374599ae5e"},{"index":10510,"token":false,"name":"Tanglebloom","scryfallId":"eb8ff237-dac6-4c79-9d8c-b047d60083e8"},{"index":10511,"token":false,"name":"Chillbringer","scryfallId":"c364d1b2-259d-400e-8a1a-ee851aee77f8"},{"index":10517,"token":false,"name":"Traumatize","scryfallId":"99bf943d-497a-4720-8be0-4bc2cd7642ee"},{"index":10518,"token":false,"name":"Together Forever","scryfallId":"8abdea02-8d56-488d-b042-f25d1ba523f5"},{"index":10520,"token":false,"name":"Preeminent Captain","scryfallId":"32faaece-2775-4ab5-8376-d9f68959d5ac"},{"index":10522,"token":false,"name":"Pull from the Deep","scryfallId":"a051b622-fa1d-4694-aef7-0fcdd7bff8d2"},{"index":10523,"token":false,"name":"Wildfire Cerberus","scryfallId":"d7a26c23-abb9-41c3-aea1-bb241093119d"},{"index":10525,"token":false,"name":"Bone Harvest","scryfallId":"f22e9279-0f7c-4f82-918f-0a3d794c6be3"},{"index":10528,"token":false,"name":"Bogardan Hellkite","scryfallId":"e99ee7b4-7a9b-4ccf-830b-adf203e2fe7f"},{"index":10529,"token":false,"name":"Mirri's Guile","scryfallId":"91b89b1a-56a2-4479-a58a-ebc0843c9e83"},{"index":10530,"token":false,"name":"Cloudpost","scryfallId":"70a3197b-fe3c-41f0-be53-a747532a8eb5"},{"index":10531,"token":false,"name":"Mindwrack Liege","scryfallId":"0b412a60-b49e-42ea-9547-03e4ef44ffea"},{"index":10533,"token":true,"name":"Ox Token (W, 2/4)","scryfallId":"8f1d69f9-d9d7-47a9-9236-351f81ffa9ae"},{"index":10534,"token":false,"name":"Nearheath Stalker","scryfallId":"388e15b2-eb90-4a5c-9f87-9d682c1a675e"},{"index":10541,"token":false,"name":"Seat of the Synod","scryfallId":"1fedc183-2d95-471c-ba78-2169e4df13f8"},{"index":10542,"token":false,"name":"Tidal Courier","scryfallId":"80b7cd5d-e81a-4729-b5d3-45587756413a"},{"index":10544,"token":false,"name":"Cystbearer","scryfallId":"b6c10302-f0b3-4076-ae5c-a8c8c09a7d41"},{"index":10546,"token":false,"name":"Vandalize","scryfallId":"48b04f7a-4fd6-47d2-b378-99c7fb0c1809"},{"index":10550,"token":false,"name":"Doomed Dissenter","scryfallId":"a1c0b645-de43-46d0-84c1-03f295def217"},{"index":10551,"token":false,"name":"Metalwork Colossus","scryfallId":"45d095bf-9231-4955-8096-a12ae39d02c1"},{"index":10553,"token":false,"name":"Martyr of Sands","scryfallId":"59c55105-bffc-43dc-b5f3-2e6bb9323230"},{"index":10554,"token":false,"name":"Bond of Revival","scryfallId":"82839c0f-3e71-4c7d-af3d-dace06e4d94b"},{"index":10555,"token":false,"name":"Reprisal","scryfallId":"40a529b3-28ea-4d51-a249-901e4b413271"},{"index":10559,"token":false,"name":"Farsight Adept","scryfallId":"5949bb9a-b4e8-4992-a12d-8e31953aff0d"},{"index":10560,"token":false,"name":"Grim Feast","scryfallId":"a69dc4ac-7354-465e-b859-d8556f3b1498"},{"index":10562,"token":false,"name":"Chained Brute","scryfallId":"1d4e5c23-3a7f-4a6b-99c4-6a1487a9b097"},{"index":10563,"token":false,"name":"Brash Taunter","scryfallId":"e7a21fd4-eea7-4ec9-b21e-92a9270d2578"},{"index":10564,"token":false,"name":"Daring Demolition","scryfallId":"c469b909-7032-4a65-ac6f-e33eb41bbb59"},{"index":10566,"token":false,"name":"Funeral Charm","scryfallId":"6fc44e66-7ff8-4fcd-9f98-e53707590d67"},{"index":10567,"token":false,"name":"Suppression Bonds","scryfallId":"d34c717b-224b-4289-826d-f5b1f7c3dbfb"},{"index":10568,"token":false,"name":"Azorius Cluestone","scryfallId":"09eeb301-bc28-4515-ad69-0b1b5164a5bc"},{"index":10570,"token":false,"name":"Ghoul's Feast","scryfallId":"6a0054c1-6510-41dd-8695-9bf50296b615"},{"index":10571,"token":false,"name":"Vivien Reid","scryfallId":"f74192e6-3441-41f4-898d-ca4f19a0f03b"},{"index":10574,"token":false,"name":"Haazda Officer","scryfallId":"f766418a-eb1d-4536-ae51-7f3e8969bb78"},{"index":10576,"token":false,"name":"Pilgrim's Eye","scryfallId":"3bef04f5-4498-40c7-bfc2-0e2e619fcca1"},{"index":10577,"token":false,"name":"Dragon Appeasement","scryfallId":"3bb8fb53-000a-4a04-afdf-38f2cd052c72"},{"index":10578,"token":false,"name":"Safehold Duo","scryfallId":"32b70339-9918-4f7e-9cd0-d4ce36b65997"},{"index":10580,"token":false,"name":"Grotag Siege-Runner","scryfallId":"01c1a241-38ad-453e-b6c2-a79006031e2d"},{"index":10583,"token":false,"name":"Ammit Eternal","scryfallId":"41dfef51-fdfb-495a-a16f-245c92e8f28b"},{"index":10584,"token":false,"name":"Dragonspeaker Shaman","scryfallId":"6205a849-f70d-4ba8-95e2-7789fcb5d5f2"},{"index":10586,"token":false,"name":"Pearl Medallion","scryfallId":"44588d53-7cce-406a-8e61-cd9866691966"},{"index":10587,"token":false,"name":"Moonsilver Spear","scryfallId":"e5b2a74d-ee03-402d-a7c4-d9363e72c971"},{"index":10588,"token":false,"name":"Witchstalker","scryfallId":"5a5ce47d-ea4f-4e15-adb6-5bb66981ed24"},{"index":10589,"token":false,"name":"Lumbering Battlement","scryfallId":"2469bc93-57ca-4077-bda2-160b4160adad"},{"index":10590,"token":false,"name":"Mirari","scryfallId":"7de1dfcf-f2e7-4c7c-8b00-c5d30a2d3f98"},{"index":10591,"token":false,"name":"Custodi Peacekeeper","scryfallId":"add304ab-7a45-40c4-96eb-e32a285c2a50"},{"index":10592,"token":false,"name":"People of the Woods","scryfallId":"2fb5926f-9988-4bc0-b2b7-e286db208310"},{"index":10594,"token":false,"name":"Filigree Attendant","scryfallId":"e0cb828c-a19b-4e6d-853f-85e5ea7cadf8"},{"index":10596,"token":false,"name":"Crypt of the Eternals","scryfallId":"cab5b199-e79d-4ca9-970c-cfd9df8fd1e4"},{"index":10598,"token":false,"name":"Mavren Fein, Dusk Apostle","scryfallId":"f7294e40-11b3-4d5c-82d0-c8ec6bd3a6c9"},{"index":10600,"token":false,"name":"Greater Sandwurm","scryfallId":"6abb132f-ac90-4367-b60d-2bacca91017a"},{"index":10603,"token":false,"name":"Elvish Branchbender","scryfallId":"f3731491-097c-4915-acab-1da2d5176b37"},{"index":10604,"token":false,"name":"Spiketail Hatchling","scryfallId":"9988f0fe-a7d4-44f9-b37c-fa30014ea215"},{"index":10606,"token":false,"name":"Wasteland Scorpion","scryfallId":"2bab1782-498c-40fc-bf2e-5c991d0c3501"},{"index":10609,"token":false,"name":"Master of Etherium","scryfallId":"cf2a6c7c-ad50-4650-96a3-cd78a802bf01"},{"index":10612,"token":false,"name":"Mine Collapse","scryfallId":"e3eeb96a-1e2c-47fa-9cfc-7d1ead1cfab6"},{"index":10616,"token":false,"name":"Vedalken Anatomist","scryfallId":"0c13bb9b-c4e9-4b82-852a-dbd5602b1aa9"},{"index":10617,"token":false,"name":"Adun Oakenshield","scryfallId":"184da30e-0db4-450c-8856-5c23088c35be"},{"index":10618,"token":false,"name":"Scrapheap","scryfallId":"14aa4474-96a0-4c1d-a09d-73b9c1073b00"},{"index":10619,"token":false,"name":"Earthbrawn","scryfallId":"478208df-9776-4354-b8a9-8da16ae1f50a"},{"index":10620,"token":false,"name":"Maximize Altitude","scryfallId":"3b5a08a0-b002-4bfe-9cac-d2bf96175f8e"},{"index":10621,"token":false,"name":"The First Iroan Games","scryfallId":"2f289f79-7168-4f1a-97e4-a2c44c73fa8e"},{"index":10622,"token":false,"name":"Fearsome Awakening","scryfallId":"5a672979-024a-4f69-91ae-a2cf4055e0a8"},{"index":10623,"token":false,"name":"Death's Duet","scryfallId":"666647e9-afc3-4b04-bad9-b4ce11438ee4"},{"index":10624,"token":false,"name":"Shimmering Efreet","scryfallId":"23c5704f-5856-4422-9d82-14558dbe1434"},{"index":10627,"token":false,"name":"Narset, Parter of Veils","scryfallId":"b519e716-063a-4fba-8831-90aa5a5069e8"},{"index":10628,"token":false,"name":"Cunning Rhetoric","scryfallId":"879ce7b1-535f-4d74-8409-9d358bf989c9"},{"index":10633,"token":false,"name":"Quarry Hauler","scryfallId":"1b2877c5-7680-4c2d-8e46-1d4548f0b03a"},{"index":10634,"token":false,"name":"Lurker","scryfallId":"b39eb671-e17e-4c5a-8913-1e3be7faedfb"},{"index":10636,"token":false,"name":"Faith Healer","scryfallId":"5d51ff6a-ba1b-4015-8d0b-df1a1bb5a0c1"},{"index":10638,"token":false,"name":"Threaten","scryfallId":"31694de6-567f-449e-a5e5-54d2f62be205"},{"index":10639,"token":false,"name":"Dragon Wings","scryfallId":"7674ab4d-9bc0-45c3-88e1-3fd2c947cfaa"},{"index":10641,"token":false,"name":"Serra Ascendant","scryfallId":"1ee65b44-eeb6-418b-b022-a0aef587c738"},{"index":10643,"token":false,"name":"Rage Forger","scryfallId":"fe140361-93b2-4382-b85e-8c263d2f446e"},{"index":10644,"token":false,"name":"Fledgling Griffin","scryfallId":"1739550d-3bd8-421b-b2a9-95dd3bff2ce2"},{"index":10646,"token":false,"name":"Spell Pierce","scryfallId":"a4f8b11a-6b21-4532-96c9-bdb2cad603e8"},{"index":10647,"token":false,"name":"Thallid Shell-Dweller","scryfallId":"d0eee2d9-bb7e-40d8-b1bf-ca98c107c5d2"},{"index":10648,"token":false,"name":"Tenacious Dead","scryfallId":"5b96fed2-0be9-4181-94ae-10f031e2aeb2"},{"index":10650,"token":false,"name":"Implement of Examination","scryfallId":"5d3ed900-f88a-4288-9915-12035717a40a"},{"index":10653,"token":false,"name":"Ebon Stronghold","scryfallId":"11a23578-165c-4156-ad0d-102bb1dda2ac"},{"index":10654,"token":false,"name":"Kelsinko Ranger","scryfallId":"8402543e-5406-404f-95c4-800a1dce35f1"},{"index":10656,"token":false,"name":"Drake Haven","scryfallId":"4cfe0645-79ec-4e94-a6eb-b38b920d2dab"},{"index":10657,"token":false,"name":"Sunbaked Canyon","scryfallId":"c36820fa-ee86-4206-9a0d-737a67cf5208"},{"index":10658,"token":false,"name":"Magus of the Abyss","scryfallId":"9954157a-0c05-4788-8a0f-6093ebbb38c3"},{"index":10660,"token":false,"name":"Ridgeline Rager","scryfallId":"5f663a4a-592a-4a3b-bbaf-e9c5c3049021"},{"index":10661,"token":false,"name":"Galvanic Relay","scryfallId":"ad0a4bba-4512-4718-89b5-f02331f3aa5f"},{"index":10662,"token":false,"name":"Blastfire Bolt","scryfallId":"0d836420-96a9-4041-9e17-8d65b1564ccb"},{"index":10664,"token":false,"name":"Mine Excavation","scryfallId":"eee9dce2-3d2c-4ac4-a61e-3e352b6d4557"},{"index":10667,"token":false,"name":"Phantom Nantuko","scryfallId":"2fd65594-cf66-4dd4-8d7b-b565756f2f86"},{"index":10668,"token":false,"name":"Kitchen Finks","scryfallId":"828ca886-dfe0-4c28-ab41-69489e4167c8"},{"index":10669,"token":false,"name":"Confiscate","scryfallId":"095d77fd-c1d1-49e6-89f8-a272522e09fe"},{"index":10670,"token":false,"name":"Headless Specter","scryfallId":"888b4b76-6af9-4479-8cfd-cde3b8694fe5"},{"index":10671,"token":false,"name":"Kithkin Mourncaller","scryfallId":"0a8b6f90-c609-4ffd-9136-9fd7a833ebb3"},{"index":10673,"token":false,"name":"Ghave, Guru of Spores","scryfallId":"5c1439cc-12dd-454a-ba04-4c0216804b9b"},{"index":10674,"token":false,"name":"Orzhova, the Church of Deals","scryfallId":"9015cc09-56c9-4d8f-b241-a0cfaec7e1f1"},{"index":10677,"token":false,"name":"Shatterskull Giant","scryfallId":"9cfbb4dd-56a2-4a94-9b15-b3ef8b2f1d0b"},{"index":10680,"token":false,"name":"Calamity Bearer","scryfallId":"a15edad1-ff68-4f20-95f6-99fe549bea98"},{"index":10684,"token":false,"name":"Zombie Brute","scryfallId":"b37db470-3aef-4fc4-98ce-63b5fb2546f6"},{"index":10685,"token":false,"name":"Life's Legacy","scryfallId":"5d964629-6d1d-4253-ac23-92f2199323b4"},{"index":10686,"token":false,"name":"Creeping Trailblazer","scryfallId":"f0b96e41-caae-4e22-82f9-df5a054ea3b7"},{"index":10689,"token":false,"name":"Ulrich of the Krallenhorde // Ulrich, Uncontested Alpha","scryfallId":"321bbf60-14a3-49b7-9401-0f2bb0660908"},{"index":10690,"token":false,"name":"Storm Fleet Swashbuckler","scryfallId":"7093bd0e-3b98-4f46-9717-202ddd277bf5"},{"index":10692,"token":false,"name":"Karplusan Wolverine","scryfallId":"8f99a807-f93f-403a-9426-b75c227b8c94"},{"index":10693,"token":false,"name":"Alloy Myr","scryfallId":"abd3350b-89fb-40b4-a942-28e0c8c274aa"},{"index":10694,"token":false,"name":"Molten Vortex","scryfallId":"d99fd073-c249-4cd2-9d71-be417c88c493"},{"index":10695,"token":false,"name":"Phyrexian War Beast","scryfallId":"e7d651f6-50be-4df9-80f8-4c62bb860e71"},{"index":10699,"token":false,"name":"Sealed Fate","scryfallId":"36cf9da8-f078-4f6e-8077-bb24a7ed487f"},{"index":10700,"token":false,"name":"Nova Chaser","scryfallId":"07f97507-abbe-4c8b-9683-f044e38f8d4b"},{"index":10704,"token":false,"name":"Forced Landing","scryfallId":"5cb319a7-564c-4748-82cf-c26ab110c32c"},{"index":10705,"token":false,"name":"Volcanic Fallout","scryfallId":"9e2c51bc-ebc9-4264-9426-122e7f568bd1"},{"index":10707,"token":false,"name":"Jace's Archivist","scryfallId":"47c6b294-3840-4007-a4e3-67309f6581dd"},{"index":10710,"token":false,"name":"Consulate Turret","scryfallId":"1b67f56e-f35f-4b10-8ec1-baa1a348d3c2"},{"index":10711,"token":false,"name":"Hypervolt Grasp","scryfallId":"fdaa3c6e-1f8a-4580-8e03-e670f50ab958"},{"index":10716,"token":false,"name":"Blood Tithe","scryfallId":"cf166294-3359-4da4-84d0-006c75c183fd"},{"index":10717,"token":false,"name":"Balduvian War-Makers","scryfallId":"12fd561e-6a26-4140-a033-1204f5dda5f3"},{"index":10720,"token":false,"name":"Phyrexian Obliterator","scryfallId":"acf5cbe2-84fa-46f4-a4f2-97b48ddf2d39"},{"index":10722,"token":false,"name":"Skysovereign, Consul Flagship","scryfallId":"1df70ef3-8919-43ac-9317-23548437a181"},{"index":10724,"token":false,"name":"Solemn Offering","scryfallId":"41d6d379-b991-48da-a6b3-a4a38931057c"},{"index":10725,"token":false,"name":"Seal of Removal","scryfallId":"487becfe-a9b1-4029-a487-2a32561570cb"},{"index":10728,"token":false,"name":"Rain of Salt","scryfallId":"4792293a-e11d-4c5e-bbd9-6f09e69ee617"},{"index":10731,"token":false,"name":"Rupture Spire","scryfallId":"8a2c2fea-d657-49f1-af03-d5d3fef3ead0"},{"index":10732,"token":false,"name":"Kalastria Nightwatch","scryfallId":"98527faa-9d06-4f46-b2f7-c78aedacc3a4"},{"index":10733,"token":false,"name":"Thornscape Battlemage","scryfallId":"88b9281b-471a-4491-84bb-dbdd48f71393"},{"index":10735,"token":false,"name":"Cateran Enforcer","scryfallId":"9e9b6da8-39da-4fce-89cf-ea972f981331"},{"index":10737,"token":false,"name":"Chromium, the Mutable","scryfallId":"50c1de2c-1acc-47c8-9b5e-a9dae3da8a49"},{"index":10738,"token":false,"name":"Trail of Crumbs","scryfallId":"2688ac16-4ed6-4e79-815a-be173deb4603"},{"index":10740,"token":false,"name":"Aku Djinn","scryfallId":"369a5df5-fc36-476c-84f4-ec4bdeb4f9d2"},{"index":10742,"token":false,"name":"Shatter the Sky","scryfallId":"349ca9f3-f8d4-4fd3-b6dd-1a1d56ffd97c"},{"index":10745,"token":false,"name":"Hecatomb","scryfallId":"8f59620f-ff9e-44d8-9c4e-be9de1a919e8"},{"index":10747,"token":false,"name":"Virtue's Ruin","scryfallId":"6fecf6d4-faa8-4d55-97a8-e05eca1d384f"},{"index":10748,"token":false,"name":"Gnottvold Recluse","scryfallId":"af46c8c8-5dfa-4ebb-b0b9-cd25d01dd432"},{"index":10751,"token":false,"name":"Molting Harpy","scryfallId":"ddfe33fb-71d5-4552-bcd3-f07e4e3847e1"},{"index":10752,"token":false,"name":"Bartered Cow","scryfallId":"1de43c67-7dfe-4282-b433-4e394366d2e9"},{"index":10754,"token":false,"name":"Rhox Pikemaster","scryfallId":"b3684a28-e819-4909-912e-dec4a9cf1b11"},{"index":10757,"token":false,"name":"Leyline of the Meek","scryfallId":"efc58757-abcc-41c9-b4d2-e70e9f387cbb"},{"index":10758,"token":false,"name":"Combat Celebrant","scryfallId":"a505914a-a3e0-413e-8781-fc5407cd024b"},{"index":10761,"token":false,"name":"Gluttonous Zombie","scryfallId":"db909e95-7979-41f0-b17a-874c4137fcc1"},{"index":10762,"token":false,"name":"Coalition Relic","scryfallId":"a9fae620-8fa5-44db-8326-11cb323c626e"},{"index":10765,"token":false,"name":"Fynn, the Fangbearer","scryfallId":"2bb2319b-e23b-46df-87e6-c256f0cb111e"},{"index":10766,"token":false,"name":"Justice","scryfallId":"9a6e0c8d-0fc1-4f52-8357-e550b0ac579a"},{"index":10767,"token":false,"name":"Overwhelming Stampede","scryfallId":"50846a7b-d174-439e-9ffb-31b50bb3a84f"},{"index":10769,"token":false,"name":"Dwarven Weaponsmith","scryfallId":"aa9d6484-84ce-4dfe-b512-a9168b970ec1"},{"index":10773,"token":false,"name":"Thraben Watcher","scryfallId":"5b4e0e11-2f16-42ad-b835-c9410c4bd7e3"},{"index":10775,"token":false,"name":"Mindclaw Shaman","scryfallId":"0f342fe9-aa73-4222-b908-d4035b5746be"},{"index":10777,"token":false,"name":"Tahngarth, Talruum Hero","scryfallId":"6cdab0f9-7208-4555-b509-e61773ebc1f9"},{"index":10781,"token":false,"name":"Hitchclaw Recluse","scryfallId":"bf335eac-e57b-44ec-afe2-8aed567469e7"},{"index":10785,"token":false,"name":"War Screecher","scryfallId":"d2ff7868-eeb9-4292-a2f4-cac18f9ba270"},{"index":10786,"token":false,"name":"Reassembling Skeleton","scryfallId":"a3d4ac21-2203-45f4-b5f2-dc186ccdbe69"},{"index":10787,"token":false,"name":"Veldrane of Sengir","scryfallId":"fe0ce7d7-d370-4ef8-b1fa-aa70b2fd5ab1"},{"index":10789,"token":false,"name":"Vulshok Battlemaster","scryfallId":"083f3b83-b7d3-472f-87b2-ed247c9c937e"},{"index":10792,"token":false,"name":"Gruul War Plow","scryfallId":"92efc66e-4112-413b-ae7c-85f270abc4ff"},{"index":10793,"token":false,"name":"Witchbane Orb","scryfallId":"53e0bf16-62f5-4b62-96e8-bc7e049bcf89"},{"index":10798,"token":false,"name":"Nissa's Zendikon","scryfallId":"fd37ea0e-ff72-4522-aa5b-d46bff832a34"},{"index":10800,"token":false,"name":"Kjeldoran Home Guard","scryfallId":"af8fd3bc-2244-45c7-a271-ec982fbc13ff"},{"index":10804,"token":false,"name":"Mystic Genesis","scryfallId":"56b93af3-f7b9-4b66-8a66-366134ebb896"},{"index":10805,"token":false,"name":"Erase","scryfallId":"8618b737-faa0-4a0c-a3f2-bee685c00580"},{"index":10809,"token":false,"name":"Council Guardian","scryfallId":"3394ecc3-3b37-4e4a-880b-3aa62b288900"},{"index":10814,"token":false,"name":"Rock Hydra","scryfallId":"410ac9e6-fbc1-4cc8-84db-84e2eb1bab97"},{"index":10815,"token":false,"name":"Flame Elemental","scryfallId":"498e813d-b0b3-4040-b87a-4fa2be681ec5"},{"index":10817,"token":false,"name":"Inspiration","scryfallId":"95233b5e-9401-4d6d-8ec4-959ca22270ff"},{"index":10818,"token":false,"name":"Arjun, the Shifting Flame","scryfallId":"4cfcf0e1-1918-4442-b18a-e872f5055f30"},{"index":10819,"token":false,"name":"Keen Sense","scryfallId":"4197d992-f868-44dd-85f7-598b22e208f3"},{"index":10820,"token":false,"name":"Goblin Electromancer","scryfallId":"632af23c-eb5c-4725-afca-637e84cecf94"},{"index":10823,"token":false,"name":"Nightbird's Clutches","scryfallId":"f8952ef0-d81e-491e-a137-be08a74ed005"},{"index":10826,"token":false,"name":"Rattleclaw Mystic","scryfallId":"c2b2fe45-f2ee-457d-8bf5-2d0014993318"},{"index":10827,"token":false,"name":"Elder of Laurels","scryfallId":"32b82ef0-c974-4357-b21a-4c2a28ec7279"},{"index":10829,"token":false,"name":"Mystic Retrieval","scryfallId":"4e5a2f5e-b9b3-41ee-a659-76dd763bad65"},{"index":10831,"token":false,"name":"Keening Banshee","scryfallId":"4e9c7c36-33af-4390-8ac7-3072907503f7"},{"index":10832,"token":false,"name":"Wirecat","scryfallId":"6333d686-58ec-4360-8929-9f7302f9a09c"},{"index":10833,"token":false,"name":"Furious Resistance","scryfallId":"4eeea013-1cf8-4c77-a097-aa69e141e3f4"},{"index":10834,"token":false,"name":"Outmaneuver","scryfallId":"4a5a69fa-71ff-4e4f-9406-7cfebccb3384"},{"index":10835,"token":false,"name":"Cursed Totem","scryfallId":"5dde91a9-7d2d-4a7b-861a-3d1c16ec79d9"},{"index":10838,"token":false,"name":"Behold the Beyond","scryfallId":"fd22350b-d48c-4ae6-b95f-63336fabe0e3"},{"index":10840,"token":false,"name":"Face of Divinity","scryfallId":"14167f33-00e2-41f9-b545-b476562881c6"},{"index":10844,"token":false,"name":"Corpsehatch","scryfallId":"f0715429-0b15-47fc-adf4-fdb5c8dfb029"},{"index":10847,"token":false,"name":"Boiling Blood","scryfallId":"3fcb85b6-ab5a-40db-aaae-555315f32877"},{"index":10851,"token":false,"name":"Plea for Power","scryfallId":"4f7e9c34-2434-4aac-83d8-af57e4f54aee"},{"index":10852,"token":false,"name":"Wit's End","scryfallId":"68f8e20c-6d8e-45a1-aabd-176d8df843db"},{"index":10853,"token":false,"name":"Sky Spirit","scryfallId":"2ab0fa2e-c0e8-4d78-956e-df6e126bc63e"},{"index":10855,"token":false,"name":"Decision Paralysis","scryfallId":"e46c7d04-977a-449b-9088-38e07bf62314"},{"index":10857,"token":false,"name":"Sandstone Oracle","scryfallId":"70e917fe-648c-4b26-ae9a-c3b1a8c55c86"},{"index":10858,"token":false,"name":"Snakeskin Veil","scryfallId":"d9849b22-1fba-4f6a-bd94-df1bc1764e6b"},{"index":10860,"token":false,"name":"Aether Vial","scryfallId":"d93510d4-7772-4260-b862-6dc096496404"},{"index":10863,"token":false,"name":"Annex","scryfallId":"c95d5cb7-3121-430b-80c3-84c75e5f869e"},{"index":10865,"token":false,"name":"Wayward Giant","scryfallId":"db01e574-7a96-472c-8e5a-bbd503280c71"},{"index":10869,"token":false,"name":"Gather Courage","scryfallId":"ccb80abd-cbf0-4b7c-a588-29926a09bf29"},{"index":10870,"token":false,"name":"Griffin Guide","scryfallId":"deee22d6-43be-4ae9-9ae1-b28371b24031"},{"index":10872,"token":false,"name":"Mad Auntie","scryfallId":"c7d83313-ca4d-441b-b540-d305e470fe7b"},{"index":10873,"token":false,"name":"Tattered Mummy","scryfallId":"7f9a5267-eb90-43bc-bf92-fcfb06821bae"},{"index":10874,"token":false,"name":"Thrashing Mossdog","scryfallId":"ffd0d63a-d947-4ce4-8e34-5c1521955b18"},{"index":10876,"token":false,"name":"Rootwater Shaman","scryfallId":"caa1b84b-efda-4324-9106-0d1d00385cdc"},{"index":10879,"token":false,"name":"Grim Tutor","scryfallId":"928558ab-e29a-44cb-ac2f-88443571f41a"},{"index":10887,"token":false,"name":"Field Creeper","scryfallId":"e148c1bf-84a2-48cd-882e-ad0fd74b8f0f"},{"index":10889,"token":false,"name":"Merseine","scryfallId":"5c7fb804-65ba-477e-93e8-eea101c1521e"},{"index":10890,"token":false,"name":"Griffin Aerie","scryfallId":"6ea1ee60-5644-4f78-913d-32c36065957f"},{"index":10891,"token":false,"name":"Eureka","scryfallId":"71725234-14fa-4a29-9efc-6dd2366d9798"},{"index":10895,"token":false,"name":"Urbis Protector","scryfallId":"19ddc04b-49ce-41ca-aadc-e0e9234ac762"},{"index":10899,"token":false,"name":"Argothian Wurm","scryfallId":"93294349-75ae-4a6b-896d-b403a5d69e98"},{"index":10902,"token":false,"name":"Temple of Epiphany","scryfallId":"29b1fdfa-660b-4605-be08-606e8b81edb3"},{"index":10903,"token":false,"name":"Puncturing Blow","scryfallId":"d7d88da5-d9a3-49b3-a091-458b058c9114"},{"index":10907,"token":false,"name":"Phyrexian Gargantua","scryfallId":"18f3d99d-f6e7-4633-948b-21dd64d918fa"},{"index":10908,"token":false,"name":"Cloak of Feathers","scryfallId":"9746790c-a426-4135-8c9d-afb82a0c26b8"},{"index":10910,"token":false,"name":"Orochi Hatchery","scryfallId":"5d3804ed-192d-47a1-ae7e-60b6827e2a72"},{"index":10911,"token":false,"name":"Carnivorous Plant","scryfallId":"f6692b56-feeb-4c91-906e-877cfa3b8748"},{"index":10914,"token":false,"name":"Information Dealer","scryfallId":"a45ac59c-654d-44de-b266-532d44b34137"},{"index":10915,"token":false,"name":"Ludevic, Necro-Alchemist","scryfallId":"07d6724f-f781-446b-be69-5c6949f9bbaa"},{"index":10916,"token":false,"name":"Burn Away","scryfallId":"f4b24e40-c0f0-4472-973e-d3b0e88fc93e"},{"index":10918,"token":false,"name":"Darigaaz's Charm","scryfallId":"241e6d40-15af-40df-b09d-b47227f305ab"},{"index":10919,"token":false,"name":"Alarum","scryfallId":"155f2aa6-6c47-4a06-b0ef-2d9205cd133e"},{"index":10920,"token":false,"name":"Spike Worker","scryfallId":"2713de6c-b754-435c-8d11-5215fd602a40"},{"index":10921,"token":false,"name":"Spike Soldier","scryfallId":"aa45664c-ac39-40f8-9f56-cf25ed60a84a"},{"index":10922,"token":false,"name":"Boneyard Lurker","scryfallId":"37e4df5b-ec53-4f8a-8c26-272b3177c0a6"},{"index":10923,"token":false,"name":"Thraben Sentry // Thraben Militia","scryfallId":"58ae9cbc-d88d-42df-ab76-63ab5d05c023"},{"index":10925,"token":false,"name":"Permeating Mass","scryfallId":"b71290eb-b529-4fc3-ab94-fee0ab9e2169"},{"index":10926,"token":false,"name":"Ghoulcaller's Chant","scryfallId":"2b8c1b10-2155-404a-8f20-eb8f643849d6"},{"index":10927,"token":false,"name":"Dovin, Architect of Law","scryfallId":"b0c7cffe-8751-4da7-8c1c-59f472ef3735"},{"index":10929,"token":false,"name":"Deathcult Rogue","scryfallId":"a4c186d2-e631-4811-83ea-fdb54e730a5d"},{"index":10932,"token":false,"name":"Endemic Plague","scryfallId":"15326971-a53b-45f2-8f1d-1b82935286e1"},{"index":10934,"token":false,"name":"Pride of the Clouds","scryfallId":"48e6b67f-ebf5-4413-9417-ed45a576a390"},{"index":10936,"token":false,"name":"Heart of Ramos","scryfallId":"a0046226-7563-4345-aa4b-a2c732c2780a"},{"index":10937,"token":false,"name":"Cathartic Reunion","scryfallId":"c68a6226-6dd7-4e1a-9e8a-124eef2caa13"},{"index":10939,"token":false,"name":"Purify","scryfallId":"0cfb77ea-6776-4bb4-886d-9a60f56e1fa7"},{"index":10940,"token":false,"name":"Sunspire Gatekeepers","scryfallId":"0a3bc6b9-475b-4257-a3bc-1a0b70d45f79"},{"index":10941,"token":false,"name":"Slinking Giant","scryfallId":"b259c6cd-43c8-415e-baca-b31e2374631f"},{"index":10942,"token":false,"name":"Xenagos, the Reveler","scryfallId":"3aecfe99-9c4b-4087-84ee-fb208fd22820"},{"index":10944,"token":false,"name":"False Defeat","scryfallId":"5ca71ce3-8633-428a-8d9e-9b807b77a8e2"},{"index":10945,"token":false,"name":"Strange Inversion","scryfallId":"316a78af-a991-4a5e-bdc2-f39947b89bb2"},{"index":10949,"token":false,"name":"Brood Monitor","scryfallId":"ea7d4a49-8681-4f95-8718-96648bf73c39"},{"index":10951,"token":false,"name":"Avalanche Tusker","scryfallId":"1a386d18-69f6-4c78-87b1-b9805b73b140"},{"index":10952,"token":false,"name":"Treetop Scout","scryfallId":"780e545c-5636-4a83-b8f9-17325cb9d1e0"},{"index":10955,"token":false,"name":"Sage of the Beyond","scryfallId":"1f5497d0-0765-4619-a218-b6a8709810cb"},{"index":10956,"token":false,"name":"Cyclone","scryfallId":"45b467e2-9cb7-4fb4-9ecc-e68bea2df130"},{"index":10957,"token":false,"name":"Hound of the Farbogs","scryfallId":"99f0a14c-17e3-4f0b-8b8e-7cd0268cde74"},{"index":10958,"token":false,"name":"Drownyard Temple","scryfallId":"c230b8c6-c3d7-41a8-8e8e-949195696d84"},{"index":10959,"token":false,"name":"Staff of the Sun Magus","scryfallId":"e1f51ff4-9b5c-4e26-b811-4000a4c8f965"},{"index":10961,"token":false,"name":"Madcap Skills","scryfallId":"ba77b1ff-e73d-4181-9564-d71df348b2fe"},{"index":10963,"token":false,"name":"Falling Timber","scryfallId":"6e54c84d-ccc9-4c52-b02c-e0392e8fe447"},{"index":10967,"token":false,"name":"Clutch of the Undercity","scryfallId":"24437641-85a1-4fcd-93dc-bd19a7abf969"},{"index":10970,"token":false,"name":"Shatter Assumptions","scryfallId":"7f224f64-513f-4c01-9b1b-bb89e366f1c4"},{"index":10974,"token":false,"name":"Torrent of Fire","scryfallId":"feeee859-f64a-4cd8-be0b-ad60cff8812e"},{"index":10976,"token":false,"name":"Skyhunter Patrol","scryfallId":"675bfd45-4b73-451c-b1d9-2fe46b5dd5aa"},{"index":10977,"token":false,"name":"Tornado Elemental","scryfallId":"db00891f-7e30-4881-bb6b-718fd36aa102"},{"index":10979,"token":false,"name":"Angel of Vitality","scryfallId":"e2f39777-b80a-4618-9310-a9e5b91bb2a2"},{"index":10981,"token":false,"name":"Entrancing Melody","scryfallId":"40794b41-a4c1-4734-b893-6271e8d948cf"},{"index":10983,"token":false,"name":"Spireside Infiltrator","scryfallId":"b9551190-9764-47a6-b414-8411beec89d2"},{"index":10985,"token":false,"name":"Rishadan Cutpurse","scryfallId":"947fc270-11e3-46cd-9086-e880a5845c79"},{"index":10986,"token":false,"name":"Minamo Scrollkeeper","scryfallId":"821c99d3-389a-4138-99a2-0c4a4b243fe7"},{"index":10989,"token":false,"name":"Ironclaw Buzzardiers","scryfallId":"b07e37ea-aa8d-4443-9af6-4351994bc00c"},{"index":10990,"token":false,"name":"Swell of Growth","scryfallId":"b06da6fe-57bf-437e-8589-7e57a5881801"},{"index":10991,"token":false,"name":"Sram, Senior Edificer","scryfallId":"adc08ef6-61fc-4d01-a78b-df0cf99585d9"},{"index":10992,"token":false,"name":"Mirror Mockery","scryfallId":"f837b050-70a6-46f0-963d-4badb37a42a1"},{"index":10993,"token":false,"name":"Center Soul","scryfallId":"bfca3763-9823-4fa4-968d-c701434b3d28"},{"index":10995,"token":false,"name":"Centaur Archer","scryfallId":"887243ef-51fd-4eb7-8828-a81a32edf8c0"},{"index":10997,"token":false,"name":"Blood Oath","scryfallId":"f1556a12-ff45-4a12-988a-63615b3799a9"},{"index":10998,"token":false,"name":"Banishing Stroke","scryfallId":"4eea01e5-d3ea-4d05-8d17-cae7b982d882"},{"index":10999,"token":false,"name":"Wirewood Symbiote","scryfallId":"49488b76-abaf-4dba-b01f-7b418e4ff295"},{"index":11000,"token":false,"name":"Vineglimmer Snarl","scryfallId":"f77e5ca7-dde1-435f-9b40-87558dd88749"},{"index":11002,"token":false,"name":"Unearth","scryfallId":"b6cb2549-e485-44d6-9d65-7605c568909e"},{"index":11003,"token":false,"name":"Snake Umbra","scryfallId":"4b70dadb-541b-4c5b-ad65-0faf263b86d1"},{"index":11004,"token":false,"name":"Sorin, Lord of Innistrad","scryfallId":"329b9f70-2c35-4fec-813a-5b7f26d34c8e"},{"index":11007,"token":false,"name":"Bioshift","scryfallId":"6e18f7a9-2af6-467a-8f62-5f7da83a3c92"},{"index":11008,"token":false,"name":"Holistic Wisdom","scryfallId":"2134a564-b089-4049-bd9c-a3f10e072263"},{"index":11012,"token":false,"name":"Acquire","scryfallId":"993957c7-5d61-4c98-826d-b657aed667e1"},{"index":11015,"token":false,"name":"Orim's Touch","scryfallId":"559f551e-7891-4c6d-8798-a25c0255fa3b"},{"index":11016,"token":false,"name":"Slaughter Cry","scryfallId":"c93b0eda-693e-4a17-be1d-1df162702146"},{"index":11017,"token":false,"name":"Crushing Canopy","scryfallId":"01398f5f-f38e-45a7-b755-e65c8fa779f8"},{"index":11020,"token":false,"name":"Enter the Unknown","scryfallId":"96acf94b-75bb-4f0e-92be-978ce5920710"},{"index":11023,"token":false,"name":"Nahiri, the Lithomancer","scryfallId":"0d8c5514-e2b4-4952-9bfc-8bf370d98ec8"},{"index":11024,"token":false,"name":"Dragon's Herald","scryfallId":"2d5873e8-ba15-4a24-aab8-91f1f390d821"},{"index":11026,"token":false,"name":"Custodian of the Trove","scryfallId":"eb14f061-9506-40fb-b10d-4bada38ca0f7"},{"index":11027,"token":false,"name":"Excoriate","scryfallId":"ba8db734-1923-40e9-821b-17b534ba5995"},{"index":11030,"token":false,"name":"Ukud Cobra","scryfallId":"71d2f6ee-af76-48f0-898d-3a19698d2790"},{"index":11031,"token":false,"name":"Instigator Gang // Wildblood Pack","scryfallId":"bb90a6f1-c7f2-4c2e-ab1e-59c5c7937841"},{"index":11034,"token":true,"name":"Bird Token (U, 2/2)","scryfallId":"ca6ce21f-2a29-480e-91f9-b089232863ff"},{"index":11035,"token":false,"name":"Broodbirth Viper","scryfallId":"ebf51c44-aa06-476e-b081-b71c11b1e8ba"},{"index":11039,"token":false,"name":"Circle of Protection: Blue","scryfallId":"4b7cdfd5-bef9-4f33-b81a-2a395c9bba29"},{"index":11041,"token":false,"name":"Torrential Gearhulk","scryfallId":"d52868cb-087e-4f91-91bc-455f2e2e7cd7"},{"index":11043,"token":false,"name":"Lone Wolf","scryfallId":"6d085684-aabf-4b63-a0b3-3deb4679909b"},{"index":11044,"token":false,"name":"The Wretched","scryfallId":"729f4543-79f3-4fe2-973f-fb2598045877"},{"index":11045,"token":false,"name":"Release the Gremlins","scryfallId":"6d851efc-bb42-43a9-92ff-55eeaefd9b45"},{"index":11046,"token":false,"name":"Skittish Valesk","scryfallId":"4cc8a6e6-ed62-4784-ba9a-b1f703fc6119"},{"index":11052,"token":false,"name":"Oversimplify","scryfallId":"0baba16f-086f-4051-9e86-527e45c0f367"},{"index":11054,"token":false,"name":"Ayumi, the Last Visitor","scryfallId":"f037520e-2a44-4650-b7cb-c81d93d1418d"},{"index":11055,"token":true,"name":"Assembly-Worker Token (Colorless, 2/2)","scryfallId":"e72daa68-0680-431c-a616-b3693fd58813"},{"index":11056,"token":false,"name":"Edge of Autumn","scryfallId":"03998e86-ef67-4329-b106-61252f3f532a"},{"index":11058,"token":false,"name":"Kjeldoran Royal Guard","scryfallId":"2da50eb5-e559-4d67-8568-d5be80ff62de"},{"index":11059,"token":false,"name":"Keldon Warlord","scryfallId":"e5d8ea15-d3ba-492a-9b38-58310857a586"},{"index":11060,"token":true,"name":"Dragon Token (R, 6/6)","scryfallId":"84310f84-3e5f-4db8-bff1-16bef64de1a0"},{"index":11062,"token":false,"name":"Vernal Equinox","scryfallId":"33fa1b4c-c8dc-4809-80b8-c4dfab847137"},{"index":11065,"token":false,"name":"Fire Juggler","scryfallId":"f04d5eef-da88-496b-a902-b87b0b386f96"},{"index":11068,"token":false,"name":"Metal Fatigue","scryfallId":"9fa32494-24bc-44c7-81d4-7285bd1fe3c8"},{"index":11071,"token":false,"name":"Casualties of War","scryfallId":"69e7a17b-c2de-469f-bbf7-5f9833e80069"},{"index":11072,"token":false,"name":"Southern Elephant","scryfallId":"77c3a2b3-5ad8-4b16-a7a8-8344b78ca77b"},{"index":11073,"token":false,"name":"Ghired's Belligerence","scryfallId":"b8348ef6-f2ae-4277-ae04-7849c508f0e4"},{"index":11074,"token":false,"name":"Mind Burst","scryfallId":"c07889a1-1582-4f14-8925-fa21a1a5fd65"},{"index":11076,"token":false,"name":"Twinblade Paladin","scryfallId":"6397d426-00e0-44da-b23c-44ccea65f5aa"},{"index":11080,"token":false,"name":"Izzet Boilerworks","scryfallId":"7f7a1f12-0c2e-4c72-839d-ae13bffa1ef0"},{"index":11081,"token":false,"name":"Wildsize","scryfallId":"29736ee5-cc53-4c2e-a6c2-0fb107932c38"},{"index":11082,"token":false,"name":"Jace's Erasure","scryfallId":"3662d1cc-1279-409f-9f0a-9c15c3407103"},{"index":11083,"token":false,"name":"Miren, the Moaning Well","scryfallId":"0427f5b7-ef54-4751-b121-b754dadc9a0a"},{"index":11084,"token":false,"name":"Bold Plagiarist","scryfallId":"0f081282-73da-4469-92bc-d3eaf688a0aa"},{"index":11086,"token":false,"name":"Mind Warp","scryfallId":"e1f0d58c-24fa-498f-9531-e62144401e86"},{"index":11088,"token":false,"name":"Hunting Moa","scryfallId":"926cefa1-3c5c-4bd6-859b-de620a3ee777"},{"index":11089,"token":false,"name":"Massive Raid","scryfallId":"8b16fbd8-fb62-4f75-92b3-a6295d95b327"},{"index":11090,"token":false,"name":"Quandrix Cultivator","scryfallId":"e3ca9ff7-0dcf-4ecc-879c-957d290ad7f5"},{"index":11092,"token":false,"name":"Pause for Reflection","scryfallId":"3cfcf84c-a30c-4c4f-9f8c-ee807661e499"},{"index":11093,"token":false,"name":"Thoughtleech","scryfallId":"95e214df-93a2-4d21-8818-cc00bff1b318"},{"index":11096,"token":false,"name":"Fervent Strike","scryfallId":"e4f76e51-a726-4a5f-ae2b-2e826e89f5f7"},{"index":11098,"token":false,"name":"Spike Breeder","scryfallId":"f7e11ef7-18a9-4ab1-981e-b337b1488ebd"},{"index":11099,"token":false,"name":"Hunting Wilds","scryfallId":"0097101d-e63d-4785-8c68-5d2fca3ded78"},{"index":11102,"token":false,"name":"Lukka, Coppercoat Outcast","scryfallId":"5c500e65-67a8-46fb-b0f3-9b863e482966"},{"index":11103,"token":false,"name":"Goblin Roughrider","scryfallId":"e79787dd-6d2f-4773-aefe-16a4eb93d3cc"},{"index":11104,"token":false,"name":"Borderland Explorer","scryfallId":"50dc9da3-9384-4e98-b00c-b3841ecd564d"},{"index":11106,"token":false,"name":"Diregraf Ghoul","scryfallId":"b9cf8ad2-de95-417c-8808-83e60df9c007"},{"index":11109,"token":false,"name":"Track Down","scryfallId":"b41b6c8a-bd76-4b69-ae72-4c8acac379b4"},{"index":11115,"token":false,"name":"Thorn Elemental","scryfallId":"45f022dd-025d-4979-982a-794ebed68cca"},{"index":11116,"token":false,"name":"Salvage Scout","scryfallId":"5909e77e-a930-4713-bca4-c6b265238c17"},{"index":11117,"token":false,"name":"Bull Rush","scryfallId":"9ed55a4d-d99c-44ae-a5b9-fd9d1b8477f9"},{"index":11118,"token":false,"name":"Double Cleave","scryfallId":"2c7ac70a-6484-4b1f-8948-4646a380ed20"},{"index":11125,"token":false,"name":"Kaervek's Spite","scryfallId":"d385b9e5-e13d-4098-ba74-ea55bde164d9"},{"index":11126,"token":false,"name":"Gnathosaur","scryfallId":"27dcb0c8-e6d5-4f6b-a74f-e495b5e42606"},{"index":11127,"token":false,"name":"Dark Impostor","scryfallId":"78e79bbf-9b18-44d2-ae57-1559cdb38bc5"},{"index":11128,"token":false,"name":"Paragon of Open Graves","scryfallId":"33d7de75-b6e1-44f5-ae1c-e095b41e8d0b"},{"index":11130,"token":false,"name":"Stunt Double","scryfallId":"85232dbe-396c-427d-b736-5f010f4b80bd"},{"index":11132,"token":false,"name":"Risk Factor","scryfallId":"daee6fa5-6522-4175-884f-938cfc7b2871"},{"index":11133,"token":false,"name":"Squadron Hawk","scryfallId":"affaf05a-020c-44c1-84fa-7976c3d2a5cc"},{"index":11134,"token":false,"name":"Surge of Strength","scryfallId":"2f532e49-5f70-4210-9b09-5a8ced370215"},{"index":11135,"token":false,"name":"Skittering Surveyor","scryfallId":"b8e9f488-db24-4bcd-bdf9-38c1e50f5504"},{"index":11137,"token":false,"name":"Fire Ants","scryfallId":"22452304-6c27-42e3-8dd8-3bbcc8bcd0df"},{"index":11140,"token":false,"name":"Ink Dissolver","scryfallId":"6e1bf0ad-f718-4118-9e9b-19041cfbb5cf"},{"index":11141,"token":false,"name":"Rite of Replication","scryfallId":"863c3968-d23d-4bf3-97ab-fbf2f6015a70"},{"index":11142,"token":false,"name":"Damnable Pact","scryfallId":"1d696b28-bec8-481d-a4ff-fefab93e00c1"},{"index":11143,"token":false,"name":"Carven Caryatid","scryfallId":"56bbc15e-003b-4d8b-9840-d0d2f74f44c0"},{"index":11144,"token":false,"name":"That Which Was Taken","scryfallId":"d80c84ad-171f-42c3-94b4-a9fe25b877e7"},{"index":11147,"token":false,"name":"Smite","scryfallId":"2698f01a-8574-4ae8-9441-a4361b1c29c6"},{"index":11149,"token":false,"name":"Thresher Beast","scryfallId":"57996732-c9e4-4271-9d5f-2a8c77f8d177"},{"index":11152,"token":false,"name":"Dictate of the Twin Gods","scryfallId":"8583ee22-780f-4b57-8b9d-c7c445b5707d"},{"index":11153,"token":false,"name":"Brilliant Plan","scryfallId":"6acae374-9d71-4f8d-ba75-a983756624c7"},{"index":11154,"token":false,"name":"Hornet Harasser","scryfallId":"45598727-a8b1-4b3e-87c6-70c36f0d4fe8"},{"index":11155,"token":false,"name":"Incorrigible Youths","scryfallId":"4e826571-6f00-4b40-975b-d51b2b17b4a4"},{"index":11159,"token":false,"name":"Arashin Foremost","scryfallId":"1f88ecc5-df1d-47e6-8cf3-1d708e2389e4"},{"index":11161,"token":false,"name":"Fist of Suns","scryfallId":"2a499b65-8a7e-4fbc-a09b-826b8454d857"},{"index":11162,"token":false,"name":"Elementalist's Palette","scryfallId":"b7b0dfee-563a-43d1-ad2b-e4bee663f435"},{"index":11164,"token":false,"name":"Karn's Touch","scryfallId":"07845861-f974-43b7-829c-79a4a41ac3e3"},{"index":11166,"token":false,"name":"Guise of Fire","scryfallId":"beb10d42-fa19-400c-bad8-ec3827f077bc"},{"index":11169,"token":false,"name":"Rathi Fiend","scryfallId":"07ca1184-ade0-4d6d-87f9-ad17f37679b3"},{"index":11170,"token":false,"name":"Howlgeist","scryfallId":"dad60d45-1c99-41d1-a237-c0ee18ce5361"},{"index":11171,"token":false,"name":"Creeping Chill","scryfallId":"f5456173-7a08-4b5c-8450-7123375f4a86"},{"index":11172,"token":false,"name":"Pledge of Unity","scryfallId":"ca9b3518-7fcd-49e2-a4c4-e5daa8be6c21"},{"index":11173,"token":false,"name":"Homura, Human Ascendant // Homura's Essence","scryfallId":"84920a21-ee2a-41ac-a369-347633d10371"},{"index":11175,"token":false,"name":"Greater Good","scryfallId":"046aff0b-fa01-4a2d-a030-021a7ad01e60"},{"index":11176,"token":false,"name":"Hagra Mauling // Hagra Broodpit","scryfallId":"b2274cda-b97f-4027-9cd8-c35eeaa0b5e6"},{"index":11178,"token":false,"name":"Basri's Lieutenant","scryfallId":"26439775-7880-4e12-81eb-92185daca3fd"},{"index":11183,"token":false,"name":"Roc Charger","scryfallId":"4932c635-b729-4348-92de-2c1b207ea460"},{"index":11187,"token":false,"name":"Turn to Frog","scryfallId":"f13c604f-b2a7-4370-b7e4-698d8e8647bb"},{"index":11193,"token":false,"name":"Austere Command","scryfallId":"45000021-a6d9-4f86-a92e-3e52d1000c20"},{"index":11194,"token":false,"name":"Crimson Fleet Commodore","scryfallId":"c90fdccf-30a6-40ee-9b35-83a6ee5c0681"},{"index":11195,"token":false,"name":"Seasoned Marshal","scryfallId":"11fafc94-543b-4e9d-83aa-ac510aed87ea"},{"index":11196,"token":false,"name":"Contraband Kingpin","scryfallId":"69beafcd-6c90-40c2-afff-0bd82377febf"},{"index":11197,"token":false,"name":"Rune of Protection: Lands","scryfallId":"4e874700-8002-41e7-8861-b4ce29ba6d9e"},{"index":11198,"token":false,"name":"Perimeter Captain","scryfallId":"4e532309-5cf9-4d12-b673-f9baad30b800"},{"index":11199,"token":false,"name":"Sinuous Striker","scryfallId":"ed2b97d1-3e69-4305-b1df-947ff64c5043"},{"index":11200,"token":false,"name":"Hero's Blade","scryfallId":"dbd53b6a-6daf-436e-8069-270bed7b4b39"},{"index":11201,"token":false,"name":"Food Chain","scryfallId":"18a1bb9e-006c-495e-8f99-d451183d2669"},{"index":11202,"token":false,"name":"Rubblehulk","scryfallId":"3422b1bf-c5b6-4d1c-bcea-8e81b83b996e"},{"index":11206,"token":false,"name":"Sivitri Scarzam","scryfallId":"58ab11d1-5536-4a4d-a324-bce236358f58"},{"index":11208,"token":false,"name":"Samite Archer","scryfallId":"07a262d7-6d0c-43d0-89b6-9f46a1a9eb69"},{"index":11211,"token":false,"name":"Kiln Walker","scryfallId":"91678632-ebe6-41b6-9250-cd3ffd63663b"},{"index":11213,"token":false,"name":"Gishath, Sun's Avatar","scryfallId":"dd1e21f6-2314-469e-b80e-8678c960c09e"},{"index":11214,"token":false,"name":"Winding Wurm","scryfallId":"ed75dc43-172c-4302-8807-23bfdd65baf4"},{"index":11215,"token":false,"name":"Rushwood Dryad","scryfallId":"2f61a381-7945-4535-b707-5ebd050d7fc5"},{"index":11216,"token":false,"name":"Harbinger of the Hunt","scryfallId":"66caece7-c04b-46c2-b49a-386e742ccb50"},{"index":11218,"token":false,"name":"Chained Throatseeker","scryfallId":"3a7bb447-c2b0-429e-bf82-02d6a966fe73"},{"index":11219,"token":false,"name":"Ral, Izzet Viceroy","scryfallId":"2713d344-1062-48e9-a717-f50690dd2ef0"},{"index":11227,"token":false,"name":"Sanguine Glorifier","scryfallId":"12993e53-8790-4d6f-9da1-a259f67aa5bf"},{"index":11233,"token":false,"name":"Gatstaf Shepherd // Gatstaf Howler","scryfallId":"57f0907f-74f4-4d86-93df-f2e50c9d0b2f"},{"index":11234,"token":false,"name":"Desperate Stand","scryfallId":"e8a4fb8d-8ddd-4d1d-92c7-2bf6b0e6c488"},{"index":11237,"token":false,"name":"Stonebound Mentor","scryfallId":"9c64e954-adfc-40a2-a3b2-85f1b4626976"},{"index":11238,"token":false,"name":"Copper Tablet","scryfallId":"c17cb591-916e-4176-aeb9-e2275d68d472"},{"index":11239,"token":false,"name":"Krenko, Tin Street Kingpin","scryfallId":"de1b2455-6ddf-4b1c-8be5-2767c7957ccb"},{"index":11241,"token":false,"name":"Ashcloud Phoenix","scryfallId":"4a53752c-5689-4939-9a8b-bf59d88d7c6b"},{"index":11246,"token":false,"name":"Trufflesnout","scryfallId":"8bba47c1-a874-456e-bea3-e99e2d61cfba"},{"index":11248,"token":false,"name":"Mizzix of the Izmagnus","scryfallId":"f008d7be-f2a6-431b-82a6-de2aaf8ac6da"},{"index":11249,"token":false,"name":"Underworld Charger","scryfallId":"f2dd847f-0db2-4f6a-bdfb-5c88ce7802f9"},{"index":11250,"token":false,"name":"Shuriken","scryfallId":"73f3b7bd-90f4-49e2-b571-334b3be648a4"},{"index":11251,"token":false,"name":"Dire Fleet Daredevil","scryfallId":"13e3c0c5-7451-4da9-acc0-d6e4e1f2655e"},{"index":11252,"token":false,"name":"Kangee, Sky Warden","scryfallId":"99988f41-99b4-4423-be5f-9dc4ec7d813b"},{"index":11254,"token":false,"name":"Bloom Hulk","scryfallId":"fd1c9129-254d-4d1d-9d95-112292bd6bcc"},{"index":11255,"token":false,"name":"Rust","scryfallId":"ad4974c8-34c5-4290-b325-7586a67f6d56"},{"index":11256,"token":false,"name":"Talruum Minotaur","scryfallId":"2d2d1e5b-7757-46e4-b42d-76c28785f835"},{"index":11257,"token":false,"name":"Priest of Gix","scryfallId":"8cbc4c4c-f1f5-4593-9894-1d8715a2f2c1"},{"index":11262,"token":false,"name":"Sleep","scryfallId":"93ba1c16-eeb2-405d-9f66-6de2f4354224"},{"index":11266,"token":false,"name":"Daru Cavalier","scryfallId":"eb2e9b7e-434e-477f-b3e8-e85ceb913650"},{"index":11271,"token":false,"name":"Wave of Vitriol","scryfallId":"3be74c99-e978-4ce8-86d4-b4b798f11f13"},{"index":11272,"token":false,"name":"Serene Master","scryfallId":"06223a09-a32c-4c60-86a1-f8f7bf5a7cdd"},{"index":11273,"token":false,"name":"The Magic Mirror","scryfallId":"08b89af1-7b22-4153-b42d-a2ea4e0f320c"},{"index":11276,"token":false,"name":"Order of the White Shield","scryfallId":"a29d0beb-0640-42d3-82a6-c4fe9dd384a8"},{"index":11277,"token":false,"name":"Priest of Iroas","scryfallId":"013ec9f5-8bf3-4067-a942-d535d011af82"},{"index":11278,"token":false,"name":"Exile","scryfallId":"cba8fb8d-fdde-4e4b-9dc7-feaecf8ed222"},{"index":11281,"token":false,"name":"Hypnotic Sprite // Mesmeric Glare","scryfallId":"bc40d11e-ab26-4a95-8503-24a6a378e2eb"},{"index":11283,"token":false,"name":"Thalakos Drifters","scryfallId":"468e13d2-6bd7-403c-8e2e-e00917b39597"},{"index":11284,"token":false,"name":"Slithering Shade","scryfallId":"5c216194-0c6b-4c03-9262-bd2613e17d9a"},{"index":11285,"token":false,"name":"Akki Coalflinger","scryfallId":"e25f5846-3832-42ba-a2bd-c2a29ed12e41"},{"index":11287,"token":false,"name":"Stone Golem","scryfallId":"a579b67a-a5ac-496e-be41-9eabe29d0e93"},{"index":11289,"token":false,"name":"Chaotic Strike","scryfallId":"061df8e4-6947-4bbb-9fe7-52ca4fd95d65"},{"index":11290,"token":false,"name":"Wall of Heat","scryfallId":"a38059a8-be69-4cc1-969b-951c610f2f11"},{"index":11293,"token":false,"name":"Verdigris","scryfallId":"683c74be-ba8a-4c6b-b637-ce22f98a7cda"},{"index":11296,"token":false,"name":"Winds of Rebuke","scryfallId":"f2718457-1e3b-48bc-99fe-2300277ee1e0"},{"index":11297,"token":false,"name":"Daxos's Torment","scryfallId":"885284bd-492e-4fc1-921a-a55a069c3fa9"},{"index":11298,"token":false,"name":"Sanctuary Cat","scryfallId":"af79c8fb-9189-48c2-a7b8-a1097dbaf138"},{"index":11299,"token":false,"name":"Wandering Archaic // Explore the Vastlands","scryfallId":"a662a862-c592-4c5b-9728-279d04be22bf"},{"index":11300,"token":false,"name":"Incurable Ogre","scryfallId":"5ad3381e-ae2f-40cf-8a7b-62375e9f453e"},{"index":11301,"token":false,"name":"Krosan Restorer","scryfallId":"06f9f54d-b8c7-407d-bc25-dad4db833208"},{"index":11302,"token":false,"name":"Shefet Dunes","scryfallId":"2ac19bca-0fd3-48ec-86a8-aa8be2f76853"},{"index":11305,"token":false,"name":"Zealous Persecution","scryfallId":"80b73c66-3b26-4067-bc44-b74fe0f6547e"},{"index":11306,"token":false,"name":"Pygmy Pyrosaur","scryfallId":"42e01129-254c-4a16-9f11-21a7a9c66f32"},{"index":11309,"token":false,"name":"Hazoret the Fervent","scryfallId":"36ed9f9d-99a7-49f4-b0ad-d71355809d32"},{"index":11311,"token":false,"name":"Venser, Shaper Savant","scryfallId":"b4fd3241-ac43-45fc-ac06-e441daee1b31"},{"index":11313,"token":false,"name":"Gruesome Slaughter","scryfallId":"3d3e464c-3032-4579-8840-4fe75474e3fb"},{"index":11314,"token":false,"name":"Arctic Merfolk","scryfallId":"86369fe5-d86d-4f4c-8f3d-dedc174f2032"},{"index":11316,"token":false,"name":"Terashi's Verdict","scryfallId":"bc5fa34b-95c6-4e02-9e15-3f595f744741"},{"index":11317,"token":false,"name":"Feral Thallid","scryfallId":"72f77884-6cec-4ccc-b619-3492b04bc3f7"},{"index":11318,"token":false,"name":"Grand Architect","scryfallId":"14ce909d-a53e-4711-a9fd-b110433d460f"},{"index":11320,"token":false,"name":"Muscle Sliver","scryfallId":"510a8590-48f5-40ee-a0c8-77238055a937"},{"index":11321,"token":false,"name":"Deathless Ancient","scryfallId":"8adc1cd9-22ff-4263-856b-0aaa990a3893"},{"index":11322,"token":false,"name":"Outpost Siege","scryfallId":"880f6602-f335-4ad8-9e2f-f32b6d715f72"},{"index":11324,"token":false,"name":"Knight of Stromgald","scryfallId":"e89b4384-6176-463a-ba43-5921d3dc84cb"},{"index":11325,"token":false,"name":"Herald of the Host","scryfallId":"84623b0d-47a9-46d2-95aa-3e74b2df06f3"},{"index":11326,"token":false,"name":"Goblin Razerunners","scryfallId":"8e1e4b26-0a2b-4078-adb3-1f66315afcf5"},{"index":11329,"token":false,"name":"Silverstorm Samurai","scryfallId":"10d2a6d9-5848-4481-a0f9-42320ff2c230"},{"index":11330,"token":false,"name":"Stream of Acid","scryfallId":"0365ba64-f78d-4efc-b00c-8155d01971a6"},{"index":11334,"token":false,"name":"Cinder Elemental","scryfallId":"78c3c616-1f95-41b1-a624-79d6362d4f16"},{"index":11338,"token":false,"name":"Crib Swap","scryfallId":"6ee74bfb-d207-4887-8deb-22467a621060"},{"index":11339,"token":false,"name":"Millstone","scryfallId":"1da21381-38bf-49d0-98d3-81eb9c99ce82"},{"index":11344,"token":false,"name":"Galina's Knight","scryfallId":"11b492d6-5e28-4f4b-942c-080d03cb0e92"},{"index":11348,"token":false,"name":"Nyx-Fleece Ram","scryfallId":"783d5756-2fab-4757-b7e0-2d222c2d010e"},{"index":11350,"token":false,"name":"Selective Snare","scryfallId":"2adfc0ac-08a9-487a-b01c-5de52fae0312"},{"index":11351,"token":false,"name":"Shielded Aether Thief","scryfallId":"8075899c-15de-4e3d-82bd-82310c1fa56a"},{"index":11353,"token":false,"name":"Anger of the Gods","scryfallId":"90795891-5e67-47c0-8d52-a5e5c5a9ef81"},{"index":11355,"token":false,"name":"Hematite Golem","scryfallId":"3cf8d47d-6ecb-424a-a908-a6501f308c8e"},{"index":11356,"token":false,"name":"Pack's Disdain","scryfallId":"79713cf7-2715-44cc-9f15-4c809b82efb6"},{"index":11357,"token":false,"name":"Wall of Souls","scryfallId":"a5b8d9a2-91d7-4172-b778-b5dc3ac28abe"},{"index":11358,"token":false,"name":"Rune of Protection: Red","scryfallId":"2916023b-cf67-443f-9ac7-f03313f9d3b7"},{"index":11360,"token":false,"name":"Spined Sliver","scryfallId":"9a8a9442-7b08-4cc8-94ec-bddb8feab1a8"},{"index":11363,"token":false,"name":"Rustvale Bridge","scryfallId":"2207467a-b82a-47ae-8867-15a859328fe9"},{"index":11364,"token":false,"name":"Femeref Archers","scryfallId":"61df49d2-1324-460b-8c72-6b6fe8b03c15"},{"index":11367,"token":true,"name":"Dinosaur Token (G, 3/3)","scryfallId":"1ccee594-e1e6-4a82-bc17-93bcdeb36198"},{"index":11368,"token":false,"name":"Lightform","scryfallId":"82b194d0-8f1c-4864-b2dd-603cbe1d9dc6"},{"index":11371,"token":false,"name":"Skirk Drill Sergeant","scryfallId":"8b211acb-3e96-48f0-adf1-94d6a600dc89"},{"index":11372,"token":false,"name":"Starfield of Nyx","scryfallId":"861dc1a5-4e84-47bc-83a2-f289804086d8"},{"index":11374,"token":false,"name":"Purphoros's Intervention","scryfallId":"01be13b4-aa80-4250-82e8-96ec7f860111"},{"index":11377,"token":false,"name":"Pit Scorpion","scryfallId":"fe106ff1-cdc6-44cc-adb7-131203a05292"},{"index":11378,"token":false,"name":"Lotus-Eye Mystics","scryfallId":"fc60d34a-eb40-4c26-8c9c-edc26f066e03"},{"index":11381,"token":false,"name":"Aeromoeba","scryfallId":"25de0eb6-94f5-440f-8201-cc7dad2f0805"},{"index":11383,"token":false,"name":"Orzhov Keyrune","scryfallId":"fd5c0f38-916a-4f6c-b678-7447cb0709e0"},{"index":11384,"token":false,"name":"Hero of the Games","scryfallId":"cdb7c7a6-4e9b-4300-a776-b7e7916950c8"},{"index":11385,"token":false,"name":"Teferi's Protege","scryfallId":"5449d71c-5c1b-44c6-9407-0212aa3c3e3a"},{"index":11387,"token":false,"name":"Killer Whale","scryfallId":"50401076-b5d1-4bc6-9a5e-a2e69a3e493d"},{"index":11388,"token":false,"name":"Nimble Innovator","scryfallId":"c292d05e-2cca-4c4d-800c-ab306873a256"},{"index":11392,"token":false,"name":"Fishliver Oil","scryfallId":"c066c452-1d87-4946-8d3b-6cc160a82282"},{"index":11396,"token":false,"name":"Indestructible Aura","scryfallId":"ed2a7333-c9ce-4011-b00e-1304e1eec25e"},{"index":11402,"token":false,"name":"Salvager of Ruin","scryfallId":"8dd2ebbe-71c6-405b-bad0-5680f0ff575c"},{"index":11403,"token":false,"name":"Twilight Drover","scryfallId":"b3c44b4b-616e-4652-b85f-a627025d09b8"},{"index":11404,"token":false,"name":"Mugging","scryfallId":"05ca502f-73a3-42f3-b7ad-f69aa239900a"},{"index":11405,"token":false,"name":"Archmage's Charm","scryfallId":"8a2ab58d-a632-4162-82b2-664e9ac4b319"},{"index":11409,"token":false,"name":"Screeching Skaab","scryfallId":"3d0142f7-7461-446a-b690-6882ccd93116"},{"index":11410,"token":false,"name":"Narset's Reversal","scryfallId":"49face5c-4779-4504-80db-7c494fc9fa72"},{"index":11411,"token":false,"name":"Dreadbringer Lampads","scryfallId":"fd0c7359-355b-4808-8959-7155d96c4e86"},{"index":11412,"token":false,"name":"Wild Ricochet","scryfallId":"8d3dddfa-9579-42d7-867b-7e37b83b3eeb"},{"index":11415,"token":false,"name":"Kaya's Ghostform","scryfallId":"98f3be88-24e2-433f-9138-f0cb59d09a0f"},{"index":11416,"token":false,"name":"Bishop of Binding","scryfallId":"aaadceb3-8a57-45de-b3f1-aca94f20de18"},{"index":11418,"token":false,"name":"Vigorspore Wurm","scryfallId":"b62625de-3a2f-43d6-8cf7-ea38f038f3b6"},{"index":11419,"token":false,"name":"Merieke Ri Berit","scryfallId":"63f7cf94-78f6-4f30-ab24-8b90231520f1"},{"index":11420,"token":false,"name":"Hibernation's End","scryfallId":"093ab03a-99e3-4596-a19a-033845f77a93"},{"index":11421,"token":false,"name":"Wayward Guide-Beast","scryfallId":"3a0d661b-26e0-4df3-83de-488865efccdd"},{"index":11422,"token":false,"name":"Jori En, Ruin Diver","scryfallId":"40c020f2-5809-4aa6-a6f5-6030568058aa"},{"index":11423,"token":false,"name":"Xiahou Dun, the One-Eyed","scryfallId":"91bed8a9-ede6-4fdc-966e-d1e4261c68e4"},{"index":11426,"token":false,"name":"Verdant Command","scryfallId":"070a3f30-0839-4678-a37c-475ee189811e"},{"index":11427,"token":false,"name":"Treacherous Blessing","scryfallId":"7cde9bcb-1c60-4f3f-af07-7db3f8baf1cc"},{"index":11428,"token":false,"name":"Blim, Comedic Genius","scryfallId":"3d8cd7dc-028a-4da2-b2a1-435d40cf48ca"},{"index":11429,"token":false,"name":"Realmwalker","scryfallId":"dd38662b-06c7-4e75-81c8-a6e071632e0f"},{"index":11430,"token":false,"name":"Aviation Pioneer","scryfallId":"e6966738-b4fc-4854-81b0-09de305854f2"},{"index":11431,"token":false,"name":"Ohran Frostfang","scryfallId":"9eb08e11-c247-404c-9f40-a12cb7087d0c"},{"index":11432,"token":true,"name":"Snake Token (B/G, 1/1)","scryfallId":"5910a7f2-71a7-4e85-8feb-4a0da228eb15"},{"index":11433,"token":true,"name":"Demon Token (B, */*)","scryfallId":"8597029c-3b0d-476e-a6ee-48402f815dab"},{"index":11434,"token":false,"name":"Squad Captain","scryfallId":"24c98bc7-f6a9-4aaf-a6dc-7067c3d8a41a"},{"index":11437,"token":false,"name":"Cultist's Staff","scryfallId":"8da8c523-44e8-43e7-8431-28dbed1015ac"},{"index":11439,"token":false,"name":"See Red","scryfallId":"4686cbaf-1de8-4f30-8027-c6c8a85dde7a"},{"index":11440,"token":false,"name":"Draining Whelk","scryfallId":"c559d326-b97b-43d9-b7c9-c09e1a0e9db6"},{"index":11442,"token":false,"name":"Extractor Demon","scryfallId":"5cb42b47-0ae4-4ca4-9e24-d398dca7bbd1"},{"index":11445,"token":false,"name":"Crash the Ramparts","scryfallId":"20b52d17-7efb-4c6e-9e6a-4763d1ef1daa"},{"index":11450,"token":false,"name":"Reconnaissance Mission","scryfallId":"ae9f7efa-d125-4f83-825e-172ea099a62a"},{"index":11451,"token":false,"name":"Gruesome Deformity","scryfallId":"5696db03-206f-4e7e-9b65-ccef31bfd7d2"},{"index":11454,"token":false,"name":"Tidy Conclusion","scryfallId":"dfcf6849-4fac-41b9-8e70-dc77c4562a42"},{"index":11455,"token":false,"name":"Toil // Trouble","scryfallId":"15bb3454-e3bb-4af9-9e93-461e210c26b7"},{"index":11458,"token":false,"name":"Grayscaled Gharial","scryfallId":"89c2c94a-31df-4789-a309-4cdfe7f6a719"},{"index":11459,"token":false,"name":"Hateful Eidolon","scryfallId":"812d0f15-f738-4644-9d29-2589d7e66915"},{"index":11462,"token":false,"name":"Keldon Arsonist","scryfallId":"113f58b1-d8d7-4544-8363-e2b96e9d2623"},{"index":11463,"token":false,"name":"Polukranos, Unchained","scryfallId":"8dab2674-7882-46b5-9b99-3a13b434a2a2"},{"index":11467,"token":false,"name":"Kismet","scryfallId":"cf81644f-6a93-4183-9f71-c3505cca6db4"},{"index":11472,"token":false,"name":"Magistrate's Scepter","scryfallId":"d4785ed7-c948-4ad2-b24d-2f45806d9fcc"},{"index":11473,"token":false,"name":"Raka Disciple","scryfallId":"41462d43-4f9f-46ba-b79d-434597e74b6b"},{"index":11474,"token":false,"name":"Clear","scryfallId":"c7cdb977-7d5b-4050-bb01-181f6b363de7"},{"index":11475,"token":false,"name":"Halo Hunter","scryfallId":"5f96344c-4b1f-42a6-bbf2-dc5cf11cdb02"},{"index":11476,"token":false,"name":"Fortified Rampart","scryfallId":"5095e2ab-a7f5-45bc-8b2f-31198ea27bba"},{"index":11478,"token":false,"name":"Bull Elephant","scryfallId":"fa7f5f41-ed30-412b-b51e-37d26e9e6455"},{"index":11481,"token":false,"name":"Ulcerate","scryfallId":"f78ab496-a19f-4c70-a56c-09a512d40c87"},{"index":11483,"token":false,"name":"Rescue","scryfallId":"08050607-b558-4f99-b716-bbbab54e9b68"},{"index":11486,"token":false,"name":"Lamplighter of Selhoff","scryfallId":"80dadecc-f1f1-44a2-8829-6c94aade73a0"},{"index":11489,"token":false,"name":"Spell Snare","scryfallId":"79418c88-5335-4a02-bcad-c1a611be25b7"},{"index":11491,"token":false,"name":"Terrain Elemental","scryfallId":"32b89e5c-ffb4-406f-99d1-ec2797aca061"},{"index":11493,"token":false,"name":"Primal Amulet // Primal Wellspring","scryfallId":"9235dfc1-19bf-4923-84f7-721018514866"},{"index":11495,"token":false,"name":"Forbidden Crypt","scryfallId":"76f5f509-707b-4ed6-9824-626dea5869b0"},{"index":11496,"token":false,"name":"Preacher","scryfallId":"d8e6f74c-0c69-4b83-ba4e-4470f50c1fb4"},{"index":11497,"token":false,"name":"Weirded Vampire","scryfallId":"4d29b11d-e3c4-41b6-a21a-ecf01b0c6fea"},{"index":11500,"token":false,"name":"Shizuko, Caller of Autumn","scryfallId":"dab9407d-9389-4ec9-963c-80de095a6812"},{"index":11504,"token":false,"name":"Rout","scryfallId":"3eb01bba-798f-418c-8e45-387b96c9e732"},{"index":11506,"token":false,"name":"Snowfield Sinkhole","scryfallId":"6611dc5e-6acc-48df-b8c4-4b327314578b"},{"index":11507,"token":false,"name":"Step Through","scryfallId":"716534cb-aa89-4de7-9aa5-8d8aa4422a6a"},{"index":11508,"token":false,"name":"Spite // Malice","scryfallId":"5e50dd95-0f65-4150-9f22-0cabcabe2c30"},{"index":11509,"token":false,"name":"Regenesis","scryfallId":"18a362c1-af92-4094-a7c2-f09952767606"},{"index":11518,"token":false,"name":"Exotic Orchard","scryfallId":"236e40f8-ea7b-4c3f-b23e-81aed45b5375"},{"index":11520,"token":false,"name":"Last Laugh","scryfallId":"d4c05f2a-b844-42b3-af91-65694b4211dd"},{"index":11522,"token":false,"name":"Thundering Ceratok","scryfallId":"9888d9a4-ad72-43f6-8031-1031877171a9"},{"index":11523,"token":false,"name":"High Seas","scryfallId":"f12eb6a6-14cc-4ad6-9684-ff33a39ba09f"},{"index":11528,"token":false,"name":"Brightling","scryfallId":"b11d200b-4bf0-4510-8bdb-9de310516286"},{"index":11529,"token":false,"name":"Circle of Protection: Green","scryfallId":"eecc0e7d-a15b-4930-93d1-832c4fed733b"},{"index":11531,"token":false,"name":"Liu Bei, Lord of Shu","scryfallId":"dea7f8a1-e848-4f4f-9b03-b4c6c977c7de"},{"index":11532,"token":false,"name":"Aether Helix","scryfallId":"7d1c653e-f629-4105-a52c-379c5cd78208"},{"index":11534,"token":false,"name":"Arenson's Aura","scryfallId":"ba2bf14c-f04d-4380-b0d5-25028ddd999b"},{"index":11535,"token":false,"name":"Aether Flash","scryfallId":"780f9197-e910-4c7a-bb4b-2c4a94903c39"},{"index":11536,"token":false,"name":"Norin the Wary","scryfallId":"45524a5f-253e-4fd7-a359-be6df50c0f53"},{"index":11537,"token":false,"name":"Phyrexian Vault","scryfallId":"da70e601-ec60-434e-af9e-eb0bf2a580e2"},{"index":11538,"token":false,"name":"Tetzimoc, Primal Death","scryfallId":"30d8237e-cec6-496b-93cb-7b522159fbaf"},{"index":11539,"token":false,"name":"Angelic Renewal","scryfallId":"7dddde7d-8565-45a7-a1db-f2dea2a6a3ba"},{"index":11540,"token":false,"name":"Manakin","scryfallId":"9f91e78e-9297-4ae3-b55f-d73e79d0d21a"},{"index":11541,"token":false,"name":"Garruk's Harbinger","scryfallId":"9e0fa0b6-5f3f-4669-84e8-2c38c9593d88"},{"index":11542,"token":false,"name":"Diligent Farmhand","scryfallId":"7bb40e09-6855-46d5-9bc9-bc6b2b0d7653"},{"index":11543,"token":false,"name":"Deceiver Exarch","scryfallId":"35437d86-6f92-480a-aa0c-c17c3943c00c"},{"index":11544,"token":false,"name":"Stone Haven Pilgrim","scryfallId":"5cd3287d-e4d8-4670-a2dd-b683055ae4b9"},{"index":11545,"token":false,"name":"Spire Tracer","scryfallId":"428b0d43-94c9-4f7f-b042-ea63f88ac697"},{"index":11546,"token":false,"name":"Kaya, Bane of the Dead","scryfallId":"981850b2-3013-4f12-ab13-6410431585f2"},{"index":11547,"token":false,"name":"Nature's Way","scryfallId":"29a4abe5-9770-4a55-b20a-2ceb6bb00db6"},{"index":11550,"token":false,"name":"Stone Haven Outfitter","scryfallId":"c02f4b26-b3b5-47a6-9926-4f19f8b71b81"},{"index":11551,"token":false,"name":"Karok Wrangler","scryfallId":"74729320-f6ee-4176-9463-397d6e477d7a"},{"index":11555,"token":true,"name":"Spirit Token (Colorless, 1/1)","scryfallId":"ef264a95-afe4-4b8c-9648-e8f95bfaed2a"},{"index":11556,"token":false,"name":"Myojin of Life's Web","scryfallId":"bd61a4de-4b3a-4098-80d9-69f4f4f1b791"},{"index":11557,"token":false,"name":"Kjeldoran Guard","scryfallId":"bdf41f17-8f82-4a8c-adec-0f3804faff3b"},{"index":11559,"token":false,"name":"Rescue from the Underworld","scryfallId":"b1c17fe5-ab40-4652-ad97-09ccfae199c1"},{"index":11560,"token":false,"name":"Gallows Warden","scryfallId":"15947b20-8c8e-42ed-9599-8b180a382d21"},{"index":11562,"token":false,"name":"Foundry Hornet","scryfallId":"f6dc7865-16ed-4d12-bdb4-d40fbdd48a23"},{"index":11565,"token":false,"name":"Wei Ambush Force","scryfallId":"9b241ba4-cff5-48ce-83bd-d70fb5e20ff4"},{"index":11567,"token":false,"name":"Dictate of Kruphix","scryfallId":"aa9f176b-6d33-4510-9ba2-98bdd12ba34e"},{"index":11568,"token":false,"name":"Hot Springs","scryfallId":"1d4fe072-81a7-424e-8d21-aaca010d5b1d"},{"index":11571,"token":false,"name":"Kabira Takedown // Kabira Plateau","scryfallId":"366e9845-019d-47cc-adb8-8fbbaad35b6d"},{"index":11573,"token":false,"name":"Steam Vents","scryfallId":"2349e6aa-5bbf-4250-a19a-321bd308ddcb"},{"index":11574,"token":false,"name":"Stonewise Fortifier","scryfallId":"4b1cd291-92a0-4f0f-b73a-64fc498da1ef"},{"index":11575,"token":false,"name":"Raking Claws","scryfallId":"6eb0d9a2-f9bb-4d8e-a1ca-896c42f8ad56"},{"index":11577,"token":false,"name":"Shipwreck Singer","scryfallId":"b17cf2d7-454c-4103-8d98-11c65d0d76ef"},{"index":11578,"token":false,"name":"Ixidor, Reality Sculptor","scryfallId":"314d5e89-55f7-42b4-af19-d4d0f499a265"},{"index":11579,"token":false,"name":"Docent of Perfection // Final Iteration","scryfallId":"30c3d4c1-dc3d-4529-9d6e-8c16149cf6da"},{"index":11581,"token":false,"name":"Zealous Strike","scryfallId":"ae8a01fb-dd47-44de-b528-8b7ca4b3388b"},{"index":11583,"token":false,"name":"Oversold Cemetery","scryfallId":"3bbfd715-0772-4516-8cd8-89495dbccf4a"},{"index":11584,"token":false,"name":"Osai Vultures","scryfallId":"da915d3c-8d43-44c2-9052-08c1cd2afa7b"},{"index":11586,"token":false,"name":"Mazirek, Kraul Death Priest","scryfallId":"aee3d3be-b0a8-4a15-8422-83a8040a67f5"},{"index":11590,"token":false,"name":"Withering Boon","scryfallId":"6e6499cb-6073-4c94-8c82-47f489094df5"},{"index":11592,"token":false,"name":"Sunlance","scryfallId":"46144ca5-aa81-4314-a1e5-1716f8565d70"},{"index":11593,"token":false,"name":"Delraich","scryfallId":"da64094f-df6e-4c43-b4ae-03aab6b92816"},{"index":11597,"token":true,"name":"Boar Token (G, 1/1)","scryfallId":"365b2234-c29d-42db-a8e0-80685a4b6434"},{"index":11600,"token":false,"name":"Power Conduit","scryfallId":"b0f5c84f-1924-4a4a-84c1-00dcb756e9c9"},{"index":11601,"token":false,"name":"Plated Sliver","scryfallId":"82846d31-4981-4ef1-85c3-703569146a84"},{"index":11602,"token":false,"name":"Akroan Sergeant","scryfallId":"31913547-460c-45b3-be23-89f0e3a43325"},{"index":11604,"token":false,"name":"Orcish Squatters","scryfallId":"86a27af5-cb26-4f39-8648-193bb116e3d6"},{"index":11605,"token":false,"name":"Eliminate","scryfallId":"65e93381-0192-4b89-af64-dcc7150b757b"},{"index":11606,"token":false,"name":"Firefist Adept","scryfallId":"0569365d-9e50-436f-a8f3-90820ef06381"},{"index":11607,"token":false,"name":"Festercreep","scryfallId":"ef212d10-bf33-435a-accc-febbc499d3ca"},{"index":11610,"token":false,"name":"Gleam of Resistance","scryfallId":"4db35e37-3634-4238-aa64-a826f41d8ee6"},{"index":11611,"token":false,"name":"Overgrowth Elemental","scryfallId":"7c9a13eb-2daf-43e0-b175-c6ec5b9e191e"},{"index":11612,"token":false,"name":"Izzet Chronarch","scryfallId":"d2f8fe93-8d20-41d4-8205-597a9c9b8bbe"},{"index":11613,"token":false,"name":"Gleancrawler","scryfallId":"0a721695-8734-47bf-a74d-0dd619f68bde"},{"index":11614,"token":false,"name":"Naga Oracle","scryfallId":"9060b7b5-3ef1-443e-8f8a-450cc42c43a6"},{"index":11615,"token":false,"name":"Elvish Pioneer","scryfallId":"7e71fc2d-643b-4fad-89a8-624d330895d6"},{"index":11616,"token":false,"name":"Sage Aven","scryfallId":"af71e998-0ce3-4533-84cd-91cc6f288986"},{"index":11617,"token":false,"name":"Psionic Entity","scryfallId":"6641a587-c066-4f0a-a951-b91d3f749eb2"},{"index":11618,"token":false,"name":"Vile Requiem","scryfallId":"2be44b37-2383-4bf4-ba30-d8d4e2cb8939"},{"index":11619,"token":false,"name":"Phytotitan","scryfallId":"e0e6eedf-8f5a-407e-b15b-48e19df20bed"},{"index":11620,"token":false,"name":"Wreak Havoc","scryfallId":"0c3b44e5-0ad8-4487-a6e2-d43b123086ab"},{"index":11621,"token":false,"name":"Shock Troops","scryfallId":"49fe44af-5d8f-44ee-b767-2267917cf4bf"},{"index":11623,"token":false,"name":"Light Up the Stage","scryfallId":"60ae69dd-d0a0-40aa-ac8f-081d2a015928"},{"index":11625,"token":false,"name":"Molder","scryfallId":"8c0eb32c-89b1-40be-a77c-62c114a73ccc"},{"index":11626,"token":false,"name":"Mountain Yeti","scryfallId":"09242f08-3bfc-4082-b32f-703c7fed62a0"},{"index":11628,"token":false,"name":"Disharmony","scryfallId":"e09a6b9b-eb0e-475d-8558-08e347412790"},{"index":11629,"token":false,"name":"Nightshade Harvester","scryfallId":"c4e30039-580d-4ad0-a913-54298ceec42e"},{"index":11630,"token":false,"name":"Sultai Emissary","scryfallId":"73be7ed8-0221-4e87-ac65-a7eb8cb8f48d"},{"index":11632,"token":false,"name":"Bruna, Light of Alabaster","scryfallId":"e390bc78-31ad-4131-a9e4-93ee0c7c2f34"},{"index":11635,"token":false,"name":"Praetor's Grasp","scryfallId":"9588be49-d9b5-4491-a5a0-10bcadc9f8b3"},{"index":11636,"token":false,"name":"Searing Barrage","scryfallId":"d2f11135-e9ce-4e4c-bea7-72a46d326e40"},{"index":11639,"token":false,"name":"Radjan Spirit","scryfallId":"4290cdec-bc35-4ebe-b93d-2503c5fa997a"},{"index":11640,"token":false,"name":"Grimdancer","scryfallId":"819257c8-9806-48bd-ba49-e117ca31de54"},{"index":11641,"token":false,"name":"Greater Gargadon","scryfallId":"1fec2fe8-bc9d-436e-a3f6-65679d3045d0"},{"index":11642,"token":false,"name":"Tezzeret's Ambition","scryfallId":"a2e6e5df-958b-48f7-93e0-a945a938d571"},{"index":11647,"token":false,"name":"Dauthi Trapper","scryfallId":"6d83770e-16ff-49c6-b4e7-eb7fc566eef8"},{"index":11648,"token":false,"name":"Manamorphose","scryfallId":"f079df56-60f9-46e5-8f2e-032e62b6a5f1"},{"index":11651,"token":false,"name":"Righteous Valkyrie","scryfallId":"0ab9ab79-cdee-4847-91f8-6344794cb2af"},{"index":11652,"token":false,"name":"Canopy Spider","scryfallId":"39d29122-f10b-4172-aa38-28c42c27f21f"},{"index":11655,"token":false,"name":"Ransack","scryfallId":"97b8db82-4632-40fd-b1e2-7172ddf8d6de"},{"index":11656,"token":false,"name":"Vulshok Sorcerer","scryfallId":"b7153854-c548-48de-b9e2-72b7d9397563"},{"index":11657,"token":false,"name":"Omenspeaker","scryfallId":"a026c260-eb95-4aa9-8310-73a4c4a453dd"},{"index":11658,"token":false,"name":"Lim-Dûl's High Guard","scryfallId":"b5afe9b5-3be8-472a-95c3-2c34231bc042"},{"index":11660,"token":false,"name":"Grandmother Sengir","scryfallId":"b43b2370-fe1b-491b-9dd0-b49a30bb2b93"},{"index":11661,"token":false,"name":"D'Avenant Healer","scryfallId":"deac6492-ce39-4137-8418-6169d3b1b632"},{"index":11665,"token":false,"name":"Breena, the Demagogue","scryfallId":"6cb82b10-d785-4e20-84ac-0660d49be8ad"},{"index":11667,"token":false,"name":"Hoarder's Greed","scryfallId":"9666a328-cc51-4be1-abef-06bbe41dd866"},{"index":11669,"token":false,"name":"Defiant Bloodlord","scryfallId":"55a241c3-c221-4064-800a-d08a1fa096b7"},{"index":11671,"token":false,"name":"Custody Battle","scryfallId":"b72257f5-0cf9-45ca-8dc7-a1a93bd7dd1e"},{"index":11676,"token":false,"name":"Keymaster Rogue","scryfallId":"970ee9a3-a862-46a7-9aa5-7b6fc4ffa1ab"},{"index":11678,"token":false,"name":"Warden of the First Tree","scryfallId":"2e0c6628-04f1-4800-baa8-bcaefe64f59f"},{"index":11679,"token":false,"name":"Death Watch","scryfallId":"0e939d8f-6989-4884-989b-9cba566c9963"},{"index":11682,"token":false,"name":"Yavimaya, Cradle of Growth","scryfallId":"4e4b6e22-93b2-4896-bba5-0ceaa5d8ea3c"},{"index":11683,"token":false,"name":"Blessed Alliance","scryfallId":"b5805eab-9a32-4c0c-9015-7bdb74ad7634"},{"index":11684,"token":false,"name":"Chancellor of the Annex","scryfallId":"7253b970-b394-4b39-abe1-ba243887f7d0"},{"index":11691,"token":false,"name":"Thousand-Year Storm","scryfallId":"270a0863-7d07-43f0-925d-a8ce0383a1cb"},{"index":11693,"token":false,"name":"Tribal Forcemage","scryfallId":"104735d7-6cea-4d4a-8cc8-e1934883da97"},{"index":11695,"token":false,"name":"Warleader's Helix","scryfallId":"81e474ac-54f7-43f9-8af9-2f1adf258b15"},{"index":11697,"token":false,"name":"Put Away","scryfallId":"c17dff9e-23f7-4b12-95e7-aa1c00ab3d18"},{"index":11699,"token":false,"name":"Metallurgic Summonings","scryfallId":"77dbf358-0f4f-4b7a-aede-a7fc13619f24"},{"index":11702,"token":false,"name":"Burning-Tree Shaman","scryfallId":"133863fc-e820-4be6-a354-a02e7fe25eae"},{"index":11705,"token":false,"name":"Sejiri Merfolk","scryfallId":"6ae04d82-56f5-4c72-b1c1-40c7d9640b7c"},{"index":11706,"token":false,"name":"Cabal Initiate","scryfallId":"b279a03f-85ab-43f2-b5ca-1bc10563e5ad"},{"index":11707,"token":false,"name":"Koskun Keep","scryfallId":"395fe900-ed19-438e-a658-ed7cf85818e5"},{"index":11708,"token":false,"name":"Magus of the Arena","scryfallId":"d28af8d4-98e8-48aa-9697-49c94dfabedb"},{"index":11709,"token":false,"name":"Parallectric Feedback","scryfallId":"891f1d29-377a-4f71-917f-ff10e785caee"},{"index":11710,"token":false,"name":"Angel's Grace","scryfallId":"310deafe-124b-4813-a383-bc9a9d028cfc"},{"index":11714,"token":false,"name":"Ghoulraiser","scryfallId":"52c537d1-2d57-4a87-9dac-594d40d95633"},{"index":11715,"token":false,"name":"Pillar of War","scryfallId":"e4c1371b-ffec-41c7-8fc1-acb2bd538080"},{"index":11717,"token":false,"name":"Thassa's Ire","scryfallId":"4cc6245f-c60f-4674-8c6d-24fe3b78e00e"},{"index":11718,"token":false,"name":"Psychosis Crawler","scryfallId":"26719c8b-2783-4f97-a961-725b52091bb7"},{"index":11721,"token":false,"name":"Gilded Cerodon","scryfallId":"f68c8fbd-9223-447d-a85c-fa6222c75277"},{"index":11723,"token":false,"name":"Urborg Syphon-Mage","scryfallId":"dba37d3d-96fe-4c42-88a5-5c4198007194"},{"index":11725,"token":false,"name":"Patron of the Valiant","scryfallId":"b251797c-8ba7-4011-ad6d-a67f2aabb7d3"},{"index":11726,"token":false,"name":"Silas Renn, Seeker Adept","scryfallId":"4e3fe912-1374-47c7-b73f-89ef55c479c1"},{"index":11728,"token":false,"name":"Cling to Dust","scryfallId":"52c2de5f-e486-4cfe-9fb6-be0078ce5f93"},{"index":11729,"token":false,"name":"Foreboding Ruins","scryfallId":"59f35e2d-c442-4f25-87f9-f66db67f0021"},{"index":11732,"token":false,"name":"Flame Wave","scryfallId":"f592d08e-db49-4cd5-bc45-aea56da3f828"},{"index":11734,"token":false,"name":"Whippoorwill","scryfallId":"e56146bf-5db0-4bef-83bb-efa5ebec6684"},{"index":11735,"token":false,"name":"Kaya's Onslaught","scryfallId":"f28e151f-b61b-486f-b7f8-7abde207c442"},{"index":11736,"token":false,"name":"Master Trinketeer","scryfallId":"cdb6beb3-1669-4e7b-9c76-65424673eb36"},{"index":11737,"token":false,"name":"Merrow Wavebreakers","scryfallId":"9919382e-3dcd-4f83-8135-be71345e57c0"},{"index":11739,"token":false,"name":"Lena, Selfless Champion","scryfallId":"636d64a0-6e7c-4849-b836-54b628f2984b"},{"index":11740,"token":false,"name":"Painbringer","scryfallId":"3f993815-af2f-4fa0-8848-979fc8c72d9a"},{"index":11741,"token":false,"name":"Duskmantle, House of Shadow","scryfallId":"2d3c85e2-58a5-4469-85ea-7e89268f310c"},{"index":11744,"token":true,"name":"Gnome Token (Colorless, 1/1)","scryfallId":"dbf33cc3-254f-4c5c-be22-3a2d96f29b80"},{"index":11745,"token":false,"name":"Ruby Leech","scryfallId":"be621b12-4f4e-43a6-b65e-da4223e742b5"},{"index":11746,"token":false,"name":"Moodmark Painter","scryfallId":"82903e5f-c10f-4767-a2c0-6f8cc7280fa0"},{"index":11749,"token":false,"name":"Blinkmoth Nexus","scryfallId":"de7a5608-b552-45cf-8252-f831c643e031"},{"index":11756,"token":false,"name":"Kor Duelist","scryfallId":"62a4742c-3af3-429f-a89d-bd316b813914"},{"index":11757,"token":false,"name":"Starnheim Unleashed","scryfallId":"86999e06-62a3-4878-8db0-dc36b52d9794"},{"index":11761,"token":false,"name":"Sea Spirit","scryfallId":"6f0a26cf-03d5-4d4c-83c2-a4544639def4"},{"index":11763,"token":false,"name":"The Mending of Dominaria","scryfallId":"726feeb3-6403-4f23-8415-a4a6878faf61"},{"index":11765,"token":false,"name":"Sunder from Within","scryfallId":"46783ba7-6e23-43d0-b5aa-9a0ea75cfb67"},{"index":11767,"token":false,"name":"Colfenor's Plans","scryfallId":"f8d06368-d226-4089-84d4-950a3ebdfb15"},{"index":11768,"token":false,"name":"Pentagram of the Ages","scryfallId":"a2334ac3-2a58-49ba-902e-98dbad51547b"},{"index":11769,"token":false,"name":"Epic Confrontation","scryfallId":"02ac4e89-d5fa-4f1b-bd61-be15eb322f40"},{"index":11770,"token":false,"name":"Tainted Wood","scryfallId":"c673009f-569c-40c2-9546-16a25c95fc69"},{"index":11771,"token":false,"name":"Crypt Sliver","scryfallId":"8adb281d-e5af-48d9-9649-aaeacadeb531"},{"index":11772,"token":false,"name":"Think Tank","scryfallId":"8c1c9d34-ea4c-4e89-a7ed-06c4469c1aca"},{"index":11775,"token":false,"name":"Vampire of the Dire Moon","scryfallId":"b3c185b9-5d97-4a5a-af0b-8b9c44dcd235"},{"index":11777,"token":false,"name":"Arcane Laboratory","scryfallId":"f9e3bcd7-60f8-472a-ada0-c3147cf06588"},{"index":11778,"token":false,"name":"Giant Mantis","scryfallId":"a56fb945-ab66-40e5-8638-de69d2598c54"},{"index":11781,"token":false,"name":"Volatile Chimera","scryfallId":"f6d3334c-7cf6-4e50-bece-d1ce462cfce8"},{"index":11782,"token":false,"name":"Reya Dawnbringer","scryfallId":"1e90abc3-aa03-4d3e-a8db-6286e7da8a1f"},{"index":11785,"token":false,"name":"Savra, Queen of the Golgari","scryfallId":"fa6999a6-5840-4c9a-b6d4-4275c2554cc5"},{"index":11786,"token":false,"name":"Pyrrhic Revival","scryfallId":"fae92d23-2028-450c-9598-6932a71f8c32"},{"index":11787,"token":false,"name":"Breaking // Entering","scryfallId":"66724f4e-59dd-4c70-b09b-49947320e6d1"},{"index":11788,"token":false,"name":"Agent of Stromgald","scryfallId":"4a7506f8-cf09-46ca-ad80-3c398c487ae2"},{"index":11791,"token":false,"name":"Confiscation Coup","scryfallId":"bba61752-2751-42ff-a776-7e61eb83194e"},{"index":11794,"token":false,"name":"Goblin Test Pilot","scryfallId":"a8dbb9aa-1bf8-447d-a96c-33e2248bfb01"},{"index":11795,"token":false,"name":"Skirk Volcanist","scryfallId":"8cdfb7e3-e077-400a-868d-3f3811e7a35c"},{"index":11796,"token":false,"name":"Mausoleum Secrets","scryfallId":"9269228c-56d6-48a8-b6be-9c20360878dd"},{"index":11800,"token":false,"name":"Jace, the Mind Sculptor","scryfallId":"a5d1f66f-75b5-4a9b-8b98-f237f065de9c"},{"index":11801,"token":false,"name":"Sunpetal Grove","scryfallId":"d1e07144-e524-4ced-b0fa-8749924f65a0"},{"index":11802,"token":false,"name":"Aphemia, the Cacophony","scryfallId":"d796356d-f63a-4863-b414-716a60c38ab7"},{"index":11804,"token":false,"name":"Algae Gharial","scryfallId":"b7d30720-5baa-4779-a435-14fab778bad6"},{"index":11808,"token":false,"name":"Vessel of Volatility","scryfallId":"81647b86-2c84-4a14-8d5a-919f7a5b8bc7"},{"index":11809,"token":false,"name":"Elder Gargaroth","scryfallId":"8ee9b3ad-0774-4952-b49b-be390182b245"},{"index":11810,"token":false,"name":"Mana Maze","scryfallId":"0d62cc17-8fa3-495c-a098-ffbbec89fa53"},{"index":11811,"token":false,"name":"Fate Unraveler","scryfallId":"f15cd233-e27b-4cfd-aa4e-18040d1de22f"},{"index":11812,"token":false,"name":"Rest for the Weary","scryfallId":"75eb8537-42c9-41d5-be0a-1186bc8dee0b"},{"index":11813,"token":false,"name":"Orb of Dreams","scryfallId":"5fbe52a3-f85e-4b3a-a345-413b64d69c49"},{"index":11815,"token":false,"name":"Sunken Field","scryfallId":"9211ee02-e854-4414-92b1-65a7af29f0b9"},{"index":11816,"token":false,"name":"Talisman of Conviction","scryfallId":"7a32f159-cc51-40d9-8c33-88ca8eb8b6f4"},{"index":11817,"token":false,"name":"Cartouche of Solidarity","scryfallId":"90eaf94e-85a7-4958-aa58-8e2fe44db58d"},{"index":11818,"token":false,"name":"Heaven's Gate","scryfallId":"461d7c11-3a7d-42c2-bb6b-0a43779e6842"},{"index":11824,"token":false,"name":"Timberland Guide","scryfallId":"50965f7e-a4e2-41b7-8b81-4a2ffa9db123"},{"index":11825,"token":false,"name":"Myr Superion","scryfallId":"ea58b15c-8648-42f9-a7ec-25b17697bb8c"},{"index":11826,"token":false,"name":"Fumigate","scryfallId":"f00f27a7-9e92-4fbf-baa8-f47a5eee48a6"},{"index":11827,"token":false,"name":"Painted Bluffs","scryfallId":"8b373131-2a1d-4710-8a11-c1b366a174d4"},{"index":11829,"token":false,"name":"Gravestorm","scryfallId":"5e273b71-85ca-49d2-ba96-70cc0ae8d718"},{"index":11830,"token":false,"name":"Brago, King Eternal","scryfallId":"1691145e-e9c2-45e7-be35-83245a6e5eaf"},{"index":11831,"token":false,"name":"Nomad Stadium","scryfallId":"64300b71-050f-47a3-83be-f24480bdc01d"},{"index":11833,"token":true,"name":"Warrior Token (W, 1/1)","scryfallId":"677a1d9d-86fd-49db-9573-8cd2cbc1a096"},{"index":11836,"token":false,"name":"Crimson Mage","scryfallId":"52f544fa-170f-4da4-bd28-72f713a045ba"},{"index":11837,"token":false,"name":"Goblin Offensive","scryfallId":"012a37ff-55f3-4943-b401-dc7a7cc22dae"},{"index":11839,"token":false,"name":"Storm the Vault // Vault of Catlacan","scryfallId":"c16ba84e-a0cc-4c6c-9b80-713247b8fef9"},{"index":11841,"token":false,"name":"Fiendslayer Paladin","scryfallId":"5cfb0f4a-e273-4ffb-91cd-dd1a7b6f6a8f"},{"index":11842,"token":false,"name":"Topan Freeblade","scryfallId":"3e953224-6ea0-4580-b2a2-c1ff133fb991"},{"index":11843,"token":false,"name":"Gods Willing","scryfallId":"72ba4521-8ad0-4f20-ab99-81c7671e5799"},{"index":11844,"token":false,"name":"Divergent Transformations","scryfallId":"2fb220db-604d-4779-9f57-fbcaf5c92cbf"},{"index":11847,"token":false,"name":"Time to Feed","scryfallId":"799d08a6-d978-4731-98ad-38acd57f3196"},{"index":11851,"token":false,"name":"Force of Negation","scryfallId":"b769ba9e-2ac8-48a9-9f45-23a4ccd0cb96"},{"index":11852,"token":false,"name":"Village Cannibals","scryfallId":"a5400460-da9d-437b-bb81-cf382beb371e"},{"index":11855,"token":true,"name":"Carlos Romão Decklist","scryfallId":"62a4afbd-6325-4451-9840-6d5fda836118"},{"index":11857,"token":false,"name":"Squirrel Wrangler","scryfallId":"feb48ab0-5f7e-44f2-896e-1cd8c4afac7e"},{"index":11860,"token":false,"name":"Imposing Visage","scryfallId":"24a256b0-e25b-43c6-9f7a-2ad76b268d22"},{"index":11861,"token":false,"name":"Bronze Sword","scryfallId":"0b33162d-8d8f-4312-b31e-04ce86e3b914"},{"index":11862,"token":false,"name":"Prowling Felidar","scryfallId":"b9d1c11a-a32c-449c-95c6-450dce6c26d2"},{"index":11863,"token":false,"name":"Cloak of Mists","scryfallId":"5b66239c-2369-48b4-9cd7-70d4b3f974f6"},{"index":11867,"token":false,"name":"Expedition Map","scryfallId":"8bc6178b-16e7-4089-974f-7048b9632fc2"},{"index":11868,"token":false,"name":"Tooth and Nail","scryfallId":"403f6e97-eb7a-470a-8673-4997256e79f0"},{"index":11869,"token":false,"name":"Gamble","scryfallId":"81e57561-17d4-48db-8e40-f41019010bc9"},{"index":11870,"token":false,"name":"Demon of Loathing","scryfallId":"57564f6f-7c99-4325-8a0e-22342e73767b"},{"index":11871,"token":false,"name":"Ezuri's Predation","scryfallId":"3103505c-b071-4ae9-bf82-978e582d030c"},{"index":11873,"token":false,"name":"Behind the Scenes","scryfallId":"7fac171d-a8b6-4bb7-a559-473574aa02a8"},{"index":11874,"token":false,"name":"Tainted Well","scryfallId":"2eec00a1-7e12-42d2-8f46-de8ab7323c2c"},{"index":11875,"token":false,"name":"Channel the Suns","scryfallId":"7bf574c8-a7e0-482e-bb41-680454988097"},{"index":11878,"token":false,"name":"Jace, Memory Adept","scryfallId":"2801a4ad-5d44-4414-af62-458c7f90dad6"},{"index":11880,"token":false,"name":"Timberland Ruins","scryfallId":"dd2e8770-c72b-439c-8f79-3aa24646cdd5"},{"index":11881,"token":false,"name":"Spatial Contortion","scryfallId":"acaee41d-5f7c-481d-8591-f9dc47c784e4"},{"index":11882,"token":false,"name":"Vraska, Golgari Queen","scryfallId":"d004e922-1f2b-4325-93f1-04a336192c06"},{"index":11883,"token":false,"name":"Predatory Sliver","scryfallId":"a2e37de8-66a1-4afa-aa6f-1151f849dfa8"},{"index":11884,"token":false,"name":"Teetering Peaks","scryfallId":"ce85799d-f8f1-43d6-b8f5-0759723ebd1a"},{"index":11886,"token":false,"name":"Warriors' Lesson","scryfallId":"c719bc31-962f-4bf5-a2fd-8cbac6c498d6"},{"index":11889,"token":false,"name":"Barbarian General","scryfallId":"060da652-03c7-45e3-ad83-f0a9fa9d1049"},{"index":11892,"token":false,"name":"Paranoid Delusions","scryfallId":"af406038-91ce-41fe-8b6d-55408a96d0a2"},{"index":11893,"token":false,"name":"Minion of Leshrac","scryfallId":"a4bbed56-50c9-4a57-b0f2-ddf4a94fbdb8"},{"index":11896,"token":false,"name":"Stream of Thought","scryfallId":"8b75bef5-a039-4edf-8e43-56b8d089605e"},{"index":11897,"token":false,"name":"Arc Trail","scryfallId":"56306d90-7f58-4559-954c-f8ca43d04be8"},{"index":11902,"token":false,"name":"Ragamuffyn","scryfallId":"2db5cccc-e9e4-4db8-affb-93d629d67b91"},{"index":11905,"token":false,"name":"Expansion // Explosion","scryfallId":"7680bab7-6ee8-4093-8bbc-74df018b1e9e"},{"index":11906,"token":false,"name":"Zendikar Resurgent","scryfallId":"a5bbe76a-df80-47d7-bbc7-91f189175cc2"},{"index":11907,"token":false,"name":"Canal Monitor","scryfallId":"78226edc-87dd-4c38-987c-52aefe0f9531"},{"index":11908,"token":false,"name":"Huang Zhong, Shu General","scryfallId":"1ebf9dea-b4f8-4955-9824-7da5bbba91e9"},{"index":11909,"token":false,"name":"Mitotic Slime","scryfallId":"8f748c8f-9d30-4925-821c-48feec45921d"},{"index":11912,"token":false,"name":"Part the Waterveil","scryfallId":"dd1582cf-5a25-434b-aab5-cfde257beaf3"},{"index":11913,"token":false,"name":"Vectis Agents","scryfallId":"1e5ac1be-43e4-4535-8633-730f306c0d00"},{"index":11914,"token":false,"name":"Mistfire Adept","scryfallId":"acdb2388-9ec4-496a-a63e-6b3f33a608a7"},{"index":11915,"token":false,"name":"Conclave Naturalists","scryfallId":"082a5372-b25a-4559-96b8-2d8d54199a38"},{"index":11917,"token":false,"name":"Helionaut","scryfallId":"3a4d395e-d7d6-4e93-9761-b0bae63b7b1c"},{"index":11920,"token":false,"name":"Heart-Piercer Bow","scryfallId":"48168005-65cc-43dc-9d45-17ea5dd4848f"},{"index":11922,"token":false,"name":"Professor of Zoomancy","scryfallId":"8347f2e8-ef70-4879-860a-12f7cab25902"},{"index":11923,"token":false,"name":"Leyline of Sanctity","scryfallId":"ee94e4a5-21fa-4fdc-b604-785bc76c69e9"},{"index":11924,"token":false,"name":"Stand Firm","scryfallId":"93d3a024-6cf3-4008-a4f6-1d96ff5de22a"},{"index":11932,"token":true,"name":"Carlos Romão Bio","scryfallId":"baf955be-0742-483d-a7df-e58792f31817"},{"index":11937,"token":false,"name":"Vampiric Touch","scryfallId":"231f7598-8c47-4828-8240-e2a545a7ac5b"},{"index":11940,"token":false,"name":"Honored Crop-Captain","scryfallId":"b1b44194-fed5-491c-a791-80b986dd66d6"},{"index":11941,"token":false,"name":"Rite of Passage","scryfallId":"bea92a0c-f73f-4e85-9d87-6401aa1b052e"},{"index":11943,"token":false,"name":"Hallar, the Firefletcher","scryfallId":"c896643e-eeef-49a6-a1ca-2577b55af2b0"},{"index":11945,"token":false,"name":"Court Street Denizen","scryfallId":"7eed8c7a-cd9b-4a02-90c6-f8c5c2ad95a7"},{"index":11949,"token":false,"name":"Fanning the Flames","scryfallId":"79075361-e6ee-4cc9-990b-88fef27bbb1c"},{"index":11950,"token":false,"name":"Wall of Shadows","scryfallId":"69c6e076-d7bf-435b-ba79-84aa9f073130"},{"index":11952,"token":false,"name":"Phyrexian Battleflies","scryfallId":"da27c489-c541-4b0d-a844-71aa65e55ceb"},{"index":11953,"token":false,"name":"Leadership Vacuum","scryfallId":"4fa953a9-171c-4532-a352-40ce27eed3c4"},{"index":11958,"token":false,"name":"Scrapskin Drake","scryfallId":"c9f03bae-1d23-43ea-9079-4b09d61bbadd"},{"index":11962,"token":false,"name":"Quirion Explorer","scryfallId":"d56bae65-1811-4428-93f4-60c36ceee715"},{"index":11963,"token":false,"name":"Frontline Sage","scryfallId":"46acbabc-9d0a-4fba-9604-7d131c22cdeb"},{"index":11966,"token":false,"name":"Rain of Revelation","scryfallId":"da367981-9d6f-419f-9f58-f969b6183336"},{"index":11967,"token":false,"name":"Plasma Elemental","scryfallId":"035a8a69-1e48-4c44-b407-cc8acc8ba94c"},{"index":11968,"token":false,"name":"Earth Servant","scryfallId":"6007db49-f750-43c6-ac09-86a61efc1bb2"},{"index":11971,"token":false,"name":"Uvilda, Dean of Perfection // Nassari, Dean of Expression","scryfallId":"fa953715-a6ac-47e7-86d6-8f8f342aa289"},{"index":11972,"token":false,"name":"Rafter Demon","scryfallId":"bf8dad4d-bc4f-46fb-892c-dbf6481cdc46"},{"index":11973,"token":false,"name":"Shu Soldier-Farmers","scryfallId":"53100324-b42f-4cd1-a5db-8a3b292d2da7"},{"index":11974,"token":false,"name":"Canyon Drake","scryfallId":"22f84143-5912-43ca-a274-f26ed0dbadd0"},{"index":11975,"token":false,"name":"Sakashima's Protege","scryfallId":"d6d313bc-2ae5-4f97-ae34-12da285d7fa7"},{"index":11977,"token":false,"name":"Elven Bow","scryfallId":"34c599c7-bcc1-4005-b830-1fa4811af66e"},{"index":11978,"token":false,"name":"Smuggler's Copter","scryfallId":"7832abb5-5107-4603-904e-491b221bd3e3"},{"index":11979,"token":false,"name":"Deadly Recluse","scryfallId":"61031a81-7cb7-48ec-b5b9-97197b6df23e"},{"index":11980,"token":true,"name":"Proven Combatant Token (B, 4/4)","scryfallId":"7c9d8aac-c032-4e0d-a8ef-99a7c53c7a19"},{"index":11985,"token":false,"name":"Gravecrawler","scryfallId":"2c816ca2-3c30-4fc1-9cc6-e4d238b78f82"},{"index":11986,"token":false,"name":"Deathbringer Regent","scryfallId":"93359159-b33c-493d-8ae4-610c560adac0"},{"index":11987,"token":false,"name":"Jedit Ojanen of Efrava","scryfallId":"aba23c7b-27c0-440b-b9b2-f1cd3892ba7b"},{"index":11989,"token":false,"name":"Return to Battle","scryfallId":"1841e615-fdcd-4187-bd69-d07abde0e1ae"},{"index":11992,"token":false,"name":"Mossfire Egg","scryfallId":"1fd66433-b0e9-453d-9a27-ea0efb158dac"},{"index":11995,"token":false,"name":"Maul Splicer","scryfallId":"2d2c6a6d-5b59-47d7-b290-df3640d9555f"},{"index":11997,"token":false,"name":"Turret Ogre","scryfallId":"8b5f624f-c5eb-4150-b36e-6147b440ff56"},{"index":12000,"token":false,"name":"Tawnos's Coffin","scryfallId":"09786406-ad00-43a7-9f98-b2d0552fe27b"},{"index":12002,"token":false,"name":"Slave of Bolas","scryfallId":"6fc177ec-dcd5-409d-a278-d84c3e6d28fa"},{"index":12003,"token":false,"name":"Arachnus Web","scryfallId":"26278000-4b73-478f-8ee5-6dd8692e53d6"},{"index":12006,"token":false,"name":"Thieving Otter","scryfallId":"07f84b0a-37d9-4b0f-8d75-1fab45a12d44"},{"index":12007,"token":false,"name":"Manaplasm","scryfallId":"439d3e7e-7c4f-4e1e-a95d-7ef44972d515"},{"index":12009,"token":false,"name":"Akoum Hellhound","scryfallId":"3a5ad1c8-3d70-43ed-9539-2aa6289c5c4a"},{"index":12012,"token":false,"name":"Rockslide Sorcerer","scryfallId":"e105c546-ce4f-49c7-97ba-ea5fbe70df82"},{"index":12013,"token":false,"name":"Stalking Tiger","scryfallId":"35730e8e-bc86-41d5-9c7a-75a92e6dd11e"},{"index":12018,"token":false,"name":"Deathmark","scryfallId":"e72e8728-d0a0-4ee5-87c3-092ca94225e0"},{"index":12022,"token":false,"name":"All Suns' Dawn","scryfallId":"15629398-bb20-4ff3-ab0e-061dcea916d5"},{"index":12023,"token":false,"name":"Wrench Mind","scryfallId":"360a6ada-b257-44b8-b830-aaa122474bce"},{"index":12025,"token":false,"name":"Urza's Blueprints","scryfallId":"026f0d4b-c13e-48a6-915f-b0edd2ac0ae8"},{"index":12026,"token":false,"name":"Nafs Asp","scryfallId":"4fa4e9f0-6520-473e-837f-5669f0ca98ff"},{"index":12027,"token":false,"name":"Wand of Ith","scryfallId":"80c9070a-8c70-480e-a476-e00f8e2c71b9"},{"index":12029,"token":false,"name":"Verdant Rebirth","scryfallId":"993f4343-8f0a-4c50-b6fd-49f1f11d96f0"},{"index":12031,"token":false,"name":"Rip Apart","scryfallId":"101f135f-1404-4333-946e-62d3aa919a62"},{"index":12032,"token":false,"name":"Qilin's Blessing","scryfallId":"028ad74f-8366-4c14-b532-63fa892f5784"},{"index":12033,"token":true,"name":"Horror Token (B, */*)","scryfallId":"fadae5ee-1973-4905-8b37-69e826523905"},{"index":12037,"token":false,"name":"Mass of Ghouls","scryfallId":"20c3f515-de7d-41eb-8ba0-532f4c13ac39"},{"index":12038,"token":false,"name":"Southern Paladin","scryfallId":"b2fa1570-3103-494c-8316-8f0bf484f22d"},{"index":12042,"token":false,"name":"Jousting Dummy","scryfallId":"f6601056-af08-4239-97d5-5e11597fce18"},{"index":12044,"token":false,"name":"Curse of the Pierced Heart","scryfallId":"71010182-c004-4d18-adab-80319cd1e625"},{"index":12047,"token":false,"name":"Colossal Might","scryfallId":"294330bb-3e77-4524-be2c-3299cf6f841f"},{"index":12050,"token":false,"name":"Whip-Spine Drake","scryfallId":"111ddb99-08a4-4349-a246-d19de32527e2"},{"index":12054,"token":false,"name":"Doomskar","scryfallId":"11224400-f8c7-4d8e-9793-49436255aeef"},{"index":12055,"token":false,"name":"Pirate's Cutlass","scryfallId":"b1ff526b-3822-4073-baab-8ea5f95daf91"},{"index":12057,"token":false,"name":"Meng Huo's Horde","scryfallId":"e1642802-055e-44d2-a261-c2a45ad515e8"},{"index":12058,"token":false,"name":"Theater of Horrors","scryfallId":"ad42efd5-79c8-44f9-b3d6-d9058e0cb0f6"},{"index":12059,"token":false,"name":"Atarka, World Render","scryfallId":"4a20db41-58c4-48d1-975b-45ab5d031ca7"},{"index":12061,"token":false,"name":"Chandra's Spitfire","scryfallId":"8a857da7-5438-465b-821a-bd5bfd780c69"},{"index":12062,"token":false,"name":"Treva's Attendant","scryfallId":"9857af81-fb95-4dc4-b048-9ce4e96d1eca"},{"index":12064,"token":false,"name":"Lotus Vale","scryfallId":"2e5cd12a-2a07-44a8-8eac-de00d26fe9e3"},{"index":12065,"token":false,"name":"Saprazzan Heir","scryfallId":"0e3d913d-2dcf-4747-8169-0c44ec895864"},{"index":12066,"token":false,"name":"Curse of Wizardry","scryfallId":"a86f2f28-2dd4-48ad-8b2d-107d747f7407"},{"index":12067,"token":false,"name":"Sizzle","scryfallId":"f1ca1eee-d97d-48c6-84f1-7d1f972c3ca9"},{"index":12068,"token":false,"name":"Lonis, Cryptozoologist","scryfallId":"5dfd08da-6717-49ee-94ba-2562224f5baa"},{"index":12069,"token":false,"name":"Countryside Crusher","scryfallId":"8ca3f7a3-05e7-44c0-9e09-3f28378677c1"},{"index":12072,"token":false,"name":"Court Archers","scryfallId":"a3776b1c-4a3f-43b9-962e-64010f286ba5"},{"index":12073,"token":false,"name":"Impetuous Protege","scryfallId":"34c18b74-75ae-4716-8e1c-613a0553ef98"},{"index":12074,"token":false,"name":"Mizzium Meddler","scryfallId":"762d568d-a2d6-449b-85c2-a92755efe4c3"},{"index":12075,"token":false,"name":"Martial Glory","scryfallId":"3690c96c-70a3-45e5-84d7-5c82809a8f45"},{"index":12077,"token":false,"name":"Vigilant Drake","scryfallId":"fbf2703c-1b0f-4ffa-9214-e2f575d037e8"},{"index":12078,"token":false,"name":"Marsh Viper","scryfallId":"503bad9f-0e4b-4f8f-a9fb-19d053e88ccc"},{"index":12080,"token":false,"name":"Judge's Familiar","scryfallId":"a94cfc94-08cd-406b-8e58-0a69ea0e312f"},{"index":12081,"token":false,"name":"Reins of the Vinesteed","scryfallId":"407a0ef5-a63e-4013-b3d9-b42f2c42c7a4"},{"index":12082,"token":false,"name":"Urborg Volcano","scryfallId":"c76f346c-ae34-4f5f-8e3b-6c77b0c4d530"},{"index":12085,"token":false,"name":"Hoodwink","scryfallId":"8d505fbb-ec85-475b-a0e1-6670627ec017"},{"index":12086,"token":false,"name":"Reduce to Ashes","scryfallId":"c978c53c-1b27-4c8d-8b01-5646ee1bdb1c"},{"index":12090,"token":false,"name":"Elven Ambush","scryfallId":"70479c44-da7c-48c7-8c6a-47210dc03277"},{"index":12091,"token":false,"name":"The Raven's Warning","scryfallId":"aa206f9e-5dfc-4ffa-bfbd-c19142f97f98"},{"index":12093,"token":false,"name":"Reef Shaman","scryfallId":"c6f56714-0baa-48f9-8da1-50d9279e759c"},{"index":12094,"token":false,"name":"Mystic Forge","scryfallId":"4415cd76-f953-455e-afb0-c0a0f150643f"},{"index":12095,"token":false,"name":"Dreamcaller Siren","scryfallId":"744eccf5-d7cc-42c9-ad9f-7d003cbcbdc1"},{"index":12096,"token":false,"name":"Inalla, Archmage Ritualist","scryfallId":"7c6e803a-451c-4aa6-97a2-400077f32c47"},{"index":12097,"token":false,"name":"Oona's Blackguard","scryfallId":"065b8f9e-3b0c-4d8f-bdf2-7aada41e114b"},{"index":12099,"token":false,"name":"Maraxus of Keld","scryfallId":"59329155-a423-4e8d-a7d4-c99555ff5ed1"},{"index":12100,"token":false,"name":"Green Ward","scryfallId":"73f6058a-9292-4474-a794-7161ec9a99f0"},{"index":12103,"token":false,"name":"Deathgazer","scryfallId":"27a4e022-a5d9-4798-8f04-39c6ce627761"},{"index":12104,"token":false,"name":"Seismic Shudder","scryfallId":"20365082-6102-4e3b-8791-c9b66846270d"},{"index":12105,"token":false,"name":"Barrage Ogre","scryfallId":"98e67a2f-7556-47aa-a953-89dcfe57a6ee"},{"index":12109,"token":false,"name":"Goblin Snowman","scryfallId":"5a9e8d45-a7e7-4131-9985-eaf693c1b55b"},{"index":12110,"token":false,"name":"Cinder Glade","scryfallId":"cfabc340-0391-4019-8e96-f010177b1d68"},{"index":12111,"token":false,"name":"Scion of Draco","scryfallId":"3e7da55c-7f05-46b2-aa3c-17f8d5df46bb"},{"index":12112,"token":false,"name":"Scavenger Grounds","scryfallId":"ddd96b62-a752-4fc9-8d1e-fc35f9617f90"},{"index":12114,"token":false,"name":"Air Servant","scryfallId":"0cbc279d-952a-4b8d-b6ff-37166daa2dd5"},{"index":12116,"token":false,"name":"Idol of Oblivion","scryfallId":"daed8456-011e-44e2-b180-6a8a75089257"},{"index":12117,"token":false,"name":"Skyshroud Behemoth","scryfallId":"1c01d17e-45a2-4b6f-aaa5-2af9c8f26181"},{"index":12120,"token":false,"name":"Merrow Reejerey","scryfallId":"dc7d9234-d938-42cd-a365-10136441eb20"},{"index":12121,"token":false,"name":"Lurking Evil","scryfallId":"f5ef7201-4443-4a77-b9e1-6f1f39e8f993"},{"index":12122,"token":false,"name":"Wandering Champion","scryfallId":"9faa3573-c8c3-4e13-9242-5a32ac957513"},{"index":12123,"token":false,"name":"Norwood Ranger","scryfallId":"ff569e60-7591-4824-9961-1786a8cde300"},{"index":12124,"token":false,"name":"Memory Drain","scryfallId":"aadc1809-d6bb-455c-b6ce-dd11521808b6"},{"index":12125,"token":false,"name":"Endless One","scryfallId":"70532516-d39b-4a0f-af57-fa640284e5c2"},{"index":12126,"token":false,"name":"Intuition","scryfallId":"c99f6785-e5a1-4fdc-9fb5-e1a372e7e848"},{"index":12127,"token":false,"name":"Trusted Pegasus","scryfallId":"89bbcaf5-80e9-43f2-b470-de6cbed6a95a"},{"index":12132,"token":false,"name":"Vampire Opportunist","scryfallId":"a8cf21a4-616d-48a5-a104-180c24491761"},{"index":12133,"token":false,"name":"Marauding Blight-Priest","scryfallId":"730ddbcd-0814-4e22-85e9-78b0878324b6"},{"index":12138,"token":false,"name":"Revive","scryfallId":"7b19b453-8393-424d-9578-3ab568c92882"},{"index":12140,"token":true,"name":"Vampire Token (B, */*)","scryfallId":"969eff58-d91e-49e2-a1e1-8f32b4598810"},{"index":12141,"token":false,"name":"Spell Syphon","scryfallId":"b883113c-e52b-4633-b4a4-016093327b6a"},{"index":12145,"token":false,"name":"Teleport","scryfallId":"18f86e13-f942-423e-b175-930d768cb811"},{"index":12147,"token":false,"name":"Metathran Transport","scryfallId":"4fa9048d-1599-44a5-b4b2-45382c5b238d"},{"index":12148,"token":false,"name":"Assault Suit","scryfallId":"5074e318-ef4e-4779-988c-d2e043c41cfb"},{"index":12149,"token":false,"name":"Chalice of Life // Chalice of Death","scryfallId":"9d9c1c46-7aa7-464c-87b0-b29b9663daef"},{"index":12150,"token":false,"name":"Goblin Cohort","scryfallId":"faa652d7-16d3-400f-9ba4-7ba8078d4a08"},{"index":12151,"token":false,"name":"Bullwhip","scryfallId":"ff312dd7-456c-4ce5-9614-e2cbe3c2219c"},{"index":12152,"token":false,"name":"Sinstriker's Will","scryfallId":"a6889030-f4cd-41a3-8596-b552a9539873"},{"index":12153,"token":false,"name":"Black Mana Battery","scryfallId":"d0c66e64-e357-457d-8302-b3a1fc0c56ce"},{"index":12156,"token":false,"name":"The Biblioplex","scryfallId":"de969f0a-23df-408e-9f92-4b909caf73d0"},{"index":12158,"token":false,"name":"Blood Lust","scryfallId":"58bcd5f0-f9af-4ddf-b2a3-03f531908b3e"},{"index":12159,"token":false,"name":"Fiery Emancipation","scryfallId":"0b12e4b7-2c45-4795-94d3-901f89b8f290"},{"index":12161,"token":false,"name":"Rats of Rath","scryfallId":"318c2cf5-6246-41e6-b391-7be39368ae65"},{"index":12162,"token":false,"name":"Cautery Sliver","scryfallId":"11df0ed7-ae08-4a95-8b79-d6be0df9e31a"},{"index":12163,"token":false,"name":"Liliana's Triumph","scryfallId":"fe1f0f9e-556c-40b7-bba9-a539c4c4fd30"},{"index":12164,"token":false,"name":"Stinkdrinker Daredevil","scryfallId":"bca9593b-764f-4fb8-80bd-91cdebc83356"},{"index":12166,"token":false,"name":"Dragon's Rage Channeler","scryfallId":"4ced112a-e775-4f97-97b3-74877e9dce12"},{"index":12167,"token":false,"name":"Rune of Mortality","scryfallId":"6f75a5e5-70df-49c3-abe1-8cc6975f5171"},{"index":12169,"token":false,"name":"Echo Storm","scryfallId":"546da0df-db26-4f50-8b5e-eb09782dd1d1"},{"index":12170,"token":false,"name":"Rowan Treefolk","scryfallId":"852a0956-8558-4754-ab57-6f1cc4de740e"},{"index":12171,"token":false,"name":"Soul Kiss","scryfallId":"42fbf6a5-86fe-41a3-891e-f72f11ad0aee"},{"index":12172,"token":false,"name":"Argothian Enchantress","scryfallId":"9ababc1a-515e-4e20-8819-19d84d9b0af5"},{"index":12173,"token":false,"name":"Reckless Charge","scryfallId":"d9275605-15a0-4db6-bd7d-66755138e8d7"},{"index":12174,"token":false,"name":"Cranial Plating","scryfallId":"71186d82-6c31-4cab-85fa-944bedc79329"},{"index":12175,"token":false,"name":"Entreat the Angels","scryfallId":"09aa3482-a068-4018-bbbf-8097a8d1482b"},{"index":12176,"token":false,"name":"Shielding Plax","scryfallId":"24a99c3c-0041-49c0-9d81-e8ec731ba072"},{"index":12177,"token":false,"name":"Burdened Aerialist","scryfallId":"8387bc7c-2e0a-4ff2-9882-e5e7c92c8463"},{"index":12180,"token":false,"name":"Engulfing Flames","scryfallId":"0a125db4-2580-4b98-8c62-4b5e8377d7ab"},{"index":12182,"token":false,"name":"Eldrazi Displacer","scryfallId":"f0bb1a5c-0f59-4951-827f-fe9df968232d"},{"index":12183,"token":false,"name":"Servo Schematic","scryfallId":"0acf747f-7ade-486c-b3b2-b48193a364fd"},{"index":12184,"token":false,"name":"Narset of the Ancient Way","scryfallId":"fa7b28d8-b835-44a0-978d-cadfd392fff5"},{"index":12186,"token":false,"name":"Tendo Ice Bridge","scryfallId":"d246f521-b9a0-4b4f-b38c-0e4eb4066212"},{"index":12188,"token":false,"name":"Aquitect's Will","scryfallId":"3c4273f6-bcce-4761-80ef-14cd4fc4bb19"},{"index":12189,"token":false,"name":"Mourning","scryfallId":"4649d881-709f-4ed0-91de-744d232a82f5"},{"index":12190,"token":false,"name":"Vitaspore Thallid","scryfallId":"cad14bc9-b90e-48e0-9e72-173874dab6bc"},{"index":12191,"token":false,"name":"Sorin's Vengeance","scryfallId":"2cb62846-c5da-4c7c-b0d7-9b677dce68d1"},{"index":12193,"token":false,"name":"Verdant Mastery","scryfallId":"197455e5-7929-47b8-ad00-8d3918949eb7"},{"index":12196,"token":false,"name":"Rakshasa Vizier","scryfallId":"cb39e674-919d-4db6-9ac1-cfa1cca02207"},{"index":12200,"token":false,"name":"Horseshoe Crab","scryfallId":"e261b86d-7bbc-40e2-82dd-faca07ece7cf"},{"index":12201,"token":false,"name":"Cinder Barrens","scryfallId":"93f6bd6b-92fb-4b4f-89c2-762cc2c465f3"},{"index":12202,"token":false,"name":"Order of Whiteclay","scryfallId":"06eb5f06-7f9c-4240-bbbb-6c59a49a5f0c"},{"index":12203,"token":false,"name":"Karplusan Strider","scryfallId":"5eef91c5-3861-40de-9bb7-67f44431428a"},{"index":12207,"token":false,"name":"Outrider of Jhess","scryfallId":"d3b681c8-6d20-4e43-95f8-e83d34626145"},{"index":12208,"token":false,"name":"Aven Cloudchaser","scryfallId":"08afe190-368e-4259-9959-00beaccee7ba"},{"index":12213,"token":false,"name":"Creeping Tar Pit","scryfallId":"e7d7e102-c52d-4891-a2a2-55fead79dc61"},{"index":12217,"token":false,"name":"Deadly Grub","scryfallId":"44e872ae-2e41-49f5-9015-e8f9fa7da987"},{"index":12218,"token":false,"name":"Birgi, God of Storytelling // Harnfel, Horn of Bounty","scryfallId":"44657ab1-0a6a-4a5f-9688-86f239083821"},{"index":12219,"token":false,"name":"Magus of the Unseen","scryfallId":"73c0d236-f283-454f-909f-296dafc4f7da"},{"index":12220,"token":false,"name":"Guardian Project","scryfallId":"a375e3d3-22f5-416b-ad32-83b6028f7024"},{"index":12225,"token":false,"name":"Wing Shards","scryfallId":"d5c9bac3-aa1e-4b38-a847-4f2b9631820c"},{"index":12230,"token":false,"name":"Ronom Unicorn","scryfallId":"cb993412-69bc-4000-ac8f-b2f62161fc55"},{"index":12231,"token":false,"name":"Viridian Longbow","scryfallId":"be892d73-d1f4-4c36-b674-01ae21ff1484"},{"index":12233,"token":true,"name":"Rhino Token (G, 4/4)","scryfallId":"214a48bc-4a1c-44e3-9415-a73af3d4fd95"},{"index":12234,"token":false,"name":"Academy Raider","scryfallId":"6652ed29-ee90-4abc-a6cf-6b18a6cbae86"},{"index":12235,"token":false,"name":"Jeering Instigator","scryfallId":"cd66527a-b831-4a5c-9f16-b2955df23d3a"},{"index":12238,"token":false,"name":"Windrider Eel","scryfallId":"4b19497f-b917-416c-b8d9-fe105f96f280"},{"index":12239,"token":false,"name":"White Sun's Zenith","scryfallId":"029e0450-ceb1-484d-8a18-e769defac428"},{"index":12241,"token":false,"name":"Callaphe, Beloved of the Sea","scryfallId":"c5d433f2-0a3b-4f45-83a3-ed600a6d10b1"},{"index":12244,"token":false,"name":"Oust","scryfallId":"cbe02056-74b5-4e73-8af6-5d7bf3064146"},{"index":12245,"token":false,"name":"Cloudcrest Lake","scryfallId":"9bcbd030-762e-4754-ae95-685d59ccdfb9"},{"index":12248,"token":false,"name":"Agent of Acquisitions","scryfallId":"c57def6f-cc2a-4aec-927b-6a561d9fa7a1"},{"index":12249,"token":false,"name":"Juniper Order Advocate","scryfallId":"4552650d-242e-4f8b-9359-d4aa19207fac"},{"index":12252,"token":false,"name":"Brute Force","scryfallId":"efa32b2a-ce3c-441a-88d4-1ee853a7c265"},{"index":12254,"token":false,"name":"Silverquill Silencer","scryfallId":"f28a10a2-a3e5-480f-9864-eed608baa118"},{"index":12255,"token":false,"name":"Bedlam","scryfallId":"2788ec1a-930e-4a19-ad69-ea456c1390fd"},{"index":12259,"token":false,"name":"Jugan, the Rising Star","scryfallId":"da0d044c-b6ff-4434-a059-081832130212"},{"index":12260,"token":false,"name":"Ogre Menial","scryfallId":"6271c5c1-5f39-4908-b838-0f34c74e912e"},{"index":12261,"token":false,"name":"Mind Shatter","scryfallId":"e089963a-f253-4e7a-9ddb-1880291a6a23"},{"index":12262,"token":false,"name":"Stonewood Invoker","scryfallId":"4680a8da-69bd-4dc9-b7b0-e15d9488a8d5"},{"index":12263,"token":false,"name":"Sorin, Vampire Lord","scryfallId":"bf20ea7b-e480-4b0e-b080-888f24d3c08d"},{"index":12264,"token":false,"name":"Citanul Centaurs","scryfallId":"5a3ac987-7906-4159-a007-ed409baea9d7"},{"index":12265,"token":false,"name":"Breath of Darigaaz","scryfallId":"480bb7e3-df03-454d-ada0-592ef8a4a6f0"},{"index":12266,"token":false,"name":"Chandra's Firemaw","scryfallId":"76cf0b50-155f-4e65-9e48-88b378ad93a1"},{"index":12267,"token":false,"name":"Mountain Valley","scryfallId":"42e927a0-e5f8-4e90-9e60-342ef5ae9b3e"},{"index":12268,"token":false,"name":"Worthy Knight","scryfallId":"0a0d32a5-3cdd-42af-a42e-0b6b45918798"},{"index":12269,"token":false,"name":"Bladewing's Thrall","scryfallId":"9d63d3d8-5699-4577-a908-4415bc96b404"},{"index":12271,"token":false,"name":"Waterveil Cavern","scryfallId":"405805e0-07f6-420f-86f9-5bde822caa5c"},{"index":12272,"token":false,"name":"Akrasan Squire","scryfallId":"59fdc045-b938-4321-aec3-51685cbbaa52"},{"index":12275,"token":false,"name":"Sneak Attack","scryfallId":"3d9709ea-5962-4590-8b14-5213b14f9229"},{"index":12277,"token":false,"name":"Master of the Feast","scryfallId":"d528f7a3-0a7b-42e3-8e4f-f1eeab02e23a"},{"index":12279,"token":false,"name":"Fleetfeather Cockatrice","scryfallId":"1139236e-5d71-4fc1-937d-ba1efadee031"},{"index":12280,"token":false,"name":"Spelltwine","scryfallId":"0f749639-a16a-4865-afdb-f415324f2ed7"},{"index":12281,"token":false,"name":"Isleback Spawn","scryfallId":"a014b49d-0500-47b2-8456-e70485d94be8"},{"index":12284,"token":false,"name":"Conjurer's Closet","scryfallId":"3435fd09-a7a2-475e-a690-3c2011b70024"},{"index":12290,"token":false,"name":"Sage-Eye Harrier","scryfallId":"3cc7b4c3-647e-48da-86f8-f55e3e990ac1"},{"index":12291,"token":false,"name":"Elite Scaleguard","scryfallId":"2f3498b6-c03f-40c3-9a75-8d196f494670"},{"index":12292,"token":false,"name":"Bloodrage Brawler","scryfallId":"c3b633bf-a77e-4b78-b729-a83896abf17c"},{"index":12293,"token":false,"name":"Manticore Eternal","scryfallId":"b03a9686-d30b-4048-8b0a-23fd2f0aed4b"},{"index":12294,"token":false,"name":"Angelic Overseer","scryfallId":"221d999c-dde1-4a0f-87cf-9e9f44969f94"},{"index":12296,"token":false,"name":"Inspiring Unicorn","scryfallId":"3320865c-ef02-4f18-82b0-47a6d845de0f"},{"index":12299,"token":false,"name":"Runic Armasaur","scryfallId":"6fac9765-5811-4c45-a872-05a7fbc1a769"},{"index":12301,"token":false,"name":"March of the Machines","scryfallId":"3245f858-b5c3-42dd-8ec2-3f775ad9e1ec"},{"index":12302,"token":false,"name":"Banefire","scryfallId":"e03d70c6-fde0-4eb0-8d39-69879448ab05"},{"index":12304,"token":false,"name":"Hanweir Garrison // Hanweir, the Writhing Township","scryfallId":"6c81b141-4c00-4779-b7d4-d0518f733682"},{"index":12305,"token":false,"name":"Defense Grid","scryfallId":"9c57c6ee-1e97-4005-bae0-7df86b2cdc27"},{"index":12309,"token":false,"name":"Farhaven Elf","scryfallId":"89d7ff79-779f-4fb1-a842-56ba38e80fdd"},{"index":12310,"token":false,"name":"Riot Piker","scryfallId":"4daaccd2-733c-4b3b-aa3f-cc825bcc3e53"},{"index":12311,"token":false,"name":"Sibsig Host","scryfallId":"2791f1a5-bf29-48ac-8a41-88b7f97ede41"},{"index":12312,"token":false,"name":"Ominous Sphinx","scryfallId":"2361bd3b-9ae0-4198-9296-6d278feff042"},{"index":12314,"token":false,"name":"Volatile Fjord","scryfallId":"f2392fbb-d9c4-4688-b99c-4e7614c60c12"},{"index":12315,"token":false,"name":"Marshaling the Troops","scryfallId":"56e4df87-7908-4274-a07f-81d42be89f18"},{"index":12317,"token":false,"name":"Lorthos, the Tidemaker","scryfallId":"c0e189da-2db9-4633-a68a-78845f20fa38"},{"index":12318,"token":false,"name":"Oath of Druids","scryfallId":"4da8f836-b41c-4717-887f-e0e873320d17"},{"index":12319,"token":false,"name":"Keening Stone","scryfallId":"442b8c31-f346-4984-9159-2dce6a7485ac"},{"index":12321,"token":false,"name":"Silhana Ledgewalker","scryfallId":"d1c7e82b-2df1-4d28-860b-33528f37c625"},{"index":12322,"token":false,"name":"Protean Hydra","scryfallId":"8a530d1e-2aff-4684-8f21-743a73f285ff"},{"index":12324,"token":false,"name":"Ghoultree","scryfallId":"a413c65e-5965-429b-8c25-11f8b73cba03"},{"index":12326,"token":false,"name":"Touch of Death","scryfallId":"15e529fb-b951-4f64-85c9-1c2e3b9581a2"},{"index":12330,"token":false,"name":"Krark-Clan Engineers","scryfallId":"2110a5e2-31e1-4a63-96cd-56295f67d436"},{"index":12332,"token":false,"name":"Silkwrap","scryfallId":"68ee9009-59a7-40e6-bf1a-1d26d4b399e8"},{"index":12336,"token":false,"name":"Asmoranomardicadaistinaculdacar","scryfallId":"5e6fac09-34e1-495a-ba70-8110845fbefb"},{"index":12340,"token":true,"name":"Thopter Token (U, 1/1)","scryfallId":"6c9a9020-2bf0-4bdd-94a2-545304226a53"},{"index":12341,"token":false,"name":"Desperate Sentry","scryfallId":"4135c619-fcff-4339-b778-31dd83e68fcb"},{"index":12343,"token":false,"name":"Subjugator Angel","scryfallId":"af01371c-cd09-4882-9caf-04426dd4c965"},{"index":12346,"token":false,"name":"Brazen Freebooter","scryfallId":"45657345-b564-4e5f-a57a-01dc54df7e7c"},{"index":12347,"token":false,"name":"Orcish Cannonade","scryfallId":"32d6973c-f919-4923-a7c6-edc47cd6276f"},{"index":12351,"token":false,"name":"Rain of Thorns","scryfallId":"909fbbde-9db4-42fa-9d79-4f2b0568ae24"},{"index":12353,"token":false,"name":"Banshee of the Dread Choir","scryfallId":"eed3cb72-9531-498b-8242-7a503c7b467d"},{"index":12354,"token":false,"name":"Return from Extinction","scryfallId":"c6db664e-f0c4-4e60-add7-89b9f210cbc7"},{"index":12355,"token":false,"name":"Rakdos Signet","scryfallId":"571eaa3e-2302-4449-a2aa-059df5713780"},{"index":12356,"token":false,"name":"Mind Bend","scryfallId":"952eb6ae-a530-4f4f-92f0-a6602beaa7b2"},{"index":12357,"token":false,"name":"Village Survivors","scryfallId":"13c0e852-9966-4145-b7c3-ac957f729376"},{"index":12364,"token":false,"name":"Vineshaper Mystic","scryfallId":"c4a27502-f6f4-4c12-af0e-eab00d942ada"},{"index":12366,"token":false,"name":"Basalt Monolith","scryfallId":"b90331d4-74f0-43bf-8ed2-f8616d782859"},{"index":12367,"token":false,"name":"Street Spasm","scryfallId":"9a19d3b8-80d0-480f-8900-47be527d0e53"},{"index":12369,"token":false,"name":"Disruptive Pitmage","scryfallId":"5b0d9c2f-356c-4f27-8560-8ffceadac31c"},{"index":12372,"token":false,"name":"Mistvein Borderpost","scryfallId":"5d0588a8-6039-42d6-98ee-8fea16f63e88"},{"index":12379,"token":false,"name":"Archon of Coronation","scryfallId":"9e367c30-3b77-445e-a1fb-78f6c5971826"},{"index":12382,"token":false,"name":"Root Out","scryfallId":"ffb04258-d6ab-440c-85d2-05a995aeba2c"},{"index":12383,"token":false,"name":"Goblin Gathering","scryfallId":"147bef05-4497-44d5-9dd6-fb5dc08e78f7"},{"index":12387,"token":false,"name":"Faithless Salvaging","scryfallId":"2958aa5c-176d-4f6e-be52-ef2afbe8d452"},{"index":12394,"token":false,"name":"Defiler of Souls","scryfallId":"16e8b418-04af-4b99-b8fd-deb1fe21a61c"},{"index":12396,"token":false,"name":"Prison Realm","scryfallId":"d476e8e5-2377-464b-b2d5-a3cd66ee2e45"},{"index":12397,"token":false,"name":"Ghoulcaller Gisa","scryfallId":"bbd9aba4-6db6-417b-8515-5617f0acdc9b"},{"index":12398,"token":false,"name":"Waterspout Weavers","scryfallId":"7db5c04f-fd5e-4e4c-9146-f9e6ef20a159"},{"index":12399,"token":false,"name":"Ursine Champion","scryfallId":"e60b6c02-c1f1-4ab9-bd62-ae3b447a898f"},{"index":12402,"token":false,"name":"Razorjaw Oni","scryfallId":"92a44255-2f3e-4e0b-aeab-9d2385b2afcd"},{"index":12406,"token":false,"name":"Intervene","scryfallId":"4b0e3894-5dfe-4d03-9996-eebf96c58168"},{"index":12412,"token":false,"name":"Rakshasa Gravecaller","scryfallId":"0bf584fd-b13b-4f86-9c9a-fa6514255aba"},{"index":12415,"token":false,"name":"Bloodfell Caves","scryfallId":"b1a99862-adbe-43c5-8abd-835e377020a3"},{"index":12419,"token":false,"name":"Huatli, Dinosaur Knight","scryfallId":"6a5a6f7b-149d-46d3-9814-d38a302db17c"},{"index":12420,"token":false,"name":"Carnival of Souls","scryfallId":"847340fb-9251-4439-b33b-f86bff507dcd"},{"index":12422,"token":false,"name":"Vine Trellis","scryfallId":"ba462242-82de-4173-98d2-b1b7a1f3d8b4"},{"index":12426,"token":false,"name":"Mystic Decree","scryfallId":"2bc4a9a8-1c00-4e37-9942-3c7bb7ff8307"},{"index":12427,"token":false,"name":"Azure Mage","scryfallId":"a473897f-49eb-4e0f-a5b6-ea75e10be91a"},{"index":12428,"token":false,"name":"Breya, Etherium Shaper","scryfallId":"2143f700-7311-46a4-ad9b-4e743a345785"},{"index":12433,"token":false,"name":"Reaper of the Wilds","scryfallId":"ca96c0ef-5462-4b4b-99b8-bdffeda78e04"},{"index":12434,"token":false,"name":"Elite Guardmage","scryfallId":"d2e40b14-48a2-4b9e-b767-e914cab04b30"},{"index":12437,"token":false,"name":"Llanowar Mentor","scryfallId":"b23f0074-40ad-4057-a672-42ed4f9564c0"},{"index":12440,"token":false,"name":"Crushing Pain","scryfallId":"c58b4374-1a50-4574-8493-f5535c1020e8"},{"index":12442,"token":false,"name":"Volrath's Curse","scryfallId":"bce63d86-8748-428a-aa9c-d3c0526537a2"},{"index":12445,"token":false,"name":"Smallpox","scryfallId":"93c8159b-8c1d-480a-b517-dbd67bba1838"},{"index":12447,"token":false,"name":"Bramble Sovereign","scryfallId":"cc2d644f-6fb9-406b-ba57-a9b3d1c9646b"},{"index":12448,"token":false,"name":"Demolition Stomper","scryfallId":"e9af13a0-a9c1-454c-992d-ce79ff161187"},{"index":12449,"token":false,"name":"El-Hajjâj","scryfallId":"78b3e7ad-e928-4e15-9ec4-9feafff83d14"},{"index":12450,"token":false,"name":"Mortal Combat","scryfallId":"f1d9cfce-1507-4cdf-9d58-6ebaf44e72e3"},{"index":12451,"token":false,"name":"Unscythe, Killer of Kings","scryfallId":"cc647ef4-1f17-4b8b-a312-60d548347d12"},{"index":12454,"token":false,"name":"Blinding Light","scryfallId":"4ea283d2-8f00-4836-81b4-c041b0469dcb"},{"index":12462,"token":false,"name":"Blizzard Specter","scryfallId":"0167df83-3bf4-4442-897d-c4ed06fa05a6"},{"index":12464,"token":false,"name":"Trophy Mage","scryfallId":"19754fe4-2f61-42a3-afa2-3a6a8257b81b"},{"index":12465,"token":false,"name":"Scroll of the Masters","scryfallId":"d6c7f24e-5ead-4b32-a804-4c89929508f6"},{"index":12466,"token":true,"name":"Knight Token (B, 2/2)","scryfallId":"c31ce82f-6c4a-4986-be1e-032348504ad6"},{"index":12469,"token":false,"name":"Kazandu Stomper","scryfallId":"afdfe5aa-8b15-4a89-a22a-03baf6afa4e7"},{"index":12470,"token":false,"name":"Canyon Jerboa","scryfallId":"26b3938e-ebd7-4668-be3a-422c02ff5b08"},{"index":12472,"token":false,"name":"Gideon's Intervention","scryfallId":"6e2524fb-ec90-4f8e-b851-f78034edef3f"},{"index":12475,"token":false,"name":"Planar Portal","scryfallId":"8743b2ce-0e18-42c9-aee4-f13197a9c481"},{"index":12477,"token":false,"name":"Stampede","scryfallId":"bc8265a1-4621-4d25-8f7f-f0179951a694"},{"index":12478,"token":false,"name":"Herald of Anguish","scryfallId":"ad6f6990-369c-4cc2-8c74-bb9831e6cf99"},{"index":12480,"token":false,"name":"Abzan Falconer","scryfallId":"9c06621d-a0c9-4c84-8b1a-cb0abd8390c4"},{"index":12483,"token":false,"name":"Youthful Knight","scryfallId":"b995d4c0-ebb4-44f4-9f1c-0cbea6a1cd1a"},{"index":12484,"token":false,"name":"Jade Avenger","scryfallId":"793f5aef-15ad-4ad7-b390-201b3c0c149d"},{"index":12485,"token":false,"name":"Harsh Sustenance","scryfallId":"770d60a0-23fc-4224-873c-2e5549b3a816"},{"index":12486,"token":false,"name":"Burnout","scryfallId":"5a8f5a18-e490-4010-ac1c-c74a5f2dcbda"},{"index":12488,"token":false,"name":"Plated Seastrider","scryfallId":"97171611-c677-48a6-b081-98a27ecef979"},{"index":12495,"token":false,"name":"Harsh Deceiver","scryfallId":"01e19753-b94b-458f-a51b-c8ec8fbec6c8"},{"index":12498,"token":false,"name":"Brass's Bounty","scryfallId":"571797ef-1e44-4b1c-9c88-3d4c60358175"},{"index":12499,"token":false,"name":"Magma Vein","scryfallId":"69ed2b52-2862-423c-8ce3-6c8232d9d92c"},{"index":12502,"token":false,"name":"Ionize","scryfallId":"8bdff27a-e2dc-4b12-a67d-9b28128ec15c"},{"index":12503,"token":false,"name":"Tempted by the Oriq","scryfallId":"20792bef-3875-4d09-abd9-77f158b1c420"},{"index":12506,"token":false,"name":"Bloodhaze Wolverine","scryfallId":"3d6c0bc1-cb07-4009-83b1-1122381cf9c4"},{"index":12508,"token":false,"name":"Griptide","scryfallId":"9fe8228b-ff9c-4a2a-a0e3-12f6d388a3c2"},{"index":12509,"token":false,"name":"Mantis Engine","scryfallId":"97f7ebfb-f955-4849-a0f5-6806ff6ae891"},{"index":12511,"token":false,"name":"Crash of Rhino Beetles","scryfallId":"7d18265b-f84f-483a-9c80-591bd93deeb4"},{"index":12513,"token":false,"name":"Spinerock Knoll","scryfallId":"48f09add-2ec3-4447-84d3-3a4b268b17ca"},{"index":12514,"token":false,"name":"Spellpyre Phoenix","scryfallId":"f492c4f5-27b7-4f09-a3af-2fb1aeac50d5"},{"index":12515,"token":false,"name":"Tatyova, Benthic Druid","scryfallId":"7be895ac-5a45-4195-99df-386197d6b106"},{"index":12518,"token":false,"name":"Cryoclasm","scryfallId":"6a892711-a1a4-4402-957f-92077d00320d"},{"index":12519,"token":false,"name":"Rattlechains","scryfallId":"505e7f2c-c040-427a-a3a1-e7b36066e4fe"},{"index":12520,"token":false,"name":"Scourge of Skola Vale","scryfallId":"baef76dc-7cef-449b-b8a7-e038887129d9"},{"index":12522,"token":false,"name":"Bearded Axe","scryfallId":"2381dbab-e968-4bbc-b3a7-a1e55b066039"},{"index":12527,"token":false,"name":"Diamond Valley","scryfallId":"37ccc3ab-9875-4bd2-bdbd-e3af5e01d682"},{"index":12529,"token":false,"name":"Rootbound Crag","scryfallId":"5dfbf5cb-ce19-4124-9dad-522809487faa"},{"index":12531,"token":false,"name":"Orcish Spy","scryfallId":"28e08767-7e92-4ff4-b0d8-196565fbc23c"},{"index":12532,"token":false,"name":"Seraph of the Sword","scryfallId":"d9789cac-5774-4f72-82c3-18f11f9d4a62"},{"index":12533,"token":false,"name":"Giant Adephage","scryfallId":"8bae725f-e582-4377-a855-51af035cdac3"},{"index":12538,"token":false,"name":"Kadena's Silencer","scryfallId":"cfe101fc-0c3d-461b-8c46-bb1bef97e739"},{"index":12539,"token":false,"name":"Char","scryfallId":"53de6c9a-b7af-45bc-b0f7-41ebd5910cf4"},{"index":12540,"token":false,"name":"Sidar Kondo of Jamuraa","scryfallId":"6e8d5e9a-4a69-41d6-82b1-eb90e534d9e6"},{"index":12545,"token":false,"name":"Hideous Laughter","scryfallId":"941fd135-1c5a-4650-8faf-dfa2c93ec8c9"},{"index":12546,"token":false,"name":"Pyrohemia","scryfallId":"ad840567-c3ac-4e14-b398-0d11c88931bc"},{"index":12547,"token":false,"name":"Gabriel Angelfire","scryfallId":"2e349074-1402-44cf-be19-33a661cff3b6"},{"index":12549,"token":false,"name":"Inkling Summoning","scryfallId":"04a8a5b8-9743-4d1a-89e9-61bdf180b2e0"},{"index":12552,"token":false,"name":"Fireborn Knight","scryfallId":"6716f46c-806d-4b3e-8a1c-fd6dcedacf8e"},{"index":12553,"token":false,"name":"Shaman of Forgotten Ways","scryfallId":"a3e9c8f7-2232-4a2a-8a00-0a2908bc7543"},{"index":12556,"token":false,"name":"Mercurial Pretender","scryfallId":"3998c87e-e71f-4432-afca-974c9dc79676"},{"index":12559,"token":false,"name":"Makeshift Mauler","scryfallId":"8782f856-06d3-43ef-958a-d2397353fa3a"},{"index":12561,"token":false,"name":"Ally Encampment","scryfallId":"bcb7124c-ba69-4da8-ad81-58f00fd0181d"},{"index":12564,"token":true,"name":"Cat Token (W, 2/2)","scryfallId":"58a18a05-4fa1-467e-9310-e5c6dc797fcf"},{"index":12570,"token":false,"name":"Obelisk Spider","scryfallId":"e0b62c2f-566c-47fb-a2ad-da375da98598"},{"index":12572,"token":false,"name":"Tower of Champions","scryfallId":"f5280aef-dfd2-4d52-bc87-4a6d1f2bd173"},{"index":12573,"token":false,"name":"Far Wanderings","scryfallId":"db67c59e-a9fb-4580-a8cc-ac5ef6c07440"},{"index":12575,"token":false,"name":"Reverse Polarity","scryfallId":"40bc8b95-1bb7-4d47-b89a-45052212b102"},{"index":12576,"token":false,"name":"Lim-Dûl's Vault","scryfallId":"f9b0164c-2d4e-48ab-addd-322d9b504739"},{"index":12579,"token":false,"name":"Faith Unbroken","scryfallId":"12bf6e58-c278-4bfe-8443-33afc7618b38"},{"index":12580,"token":false,"name":"Bomat Bazaar Barge","scryfallId":"0f32be75-979d-43a9-9132-2cf013ddaf3b"},{"index":12586,"token":false,"name":"Sanctum of Ugin","scryfallId":"c817a0ac-7917-4542-b7d2-52cf43158533"},{"index":12587,"token":false,"name":"Tamiyo, the Moon Sage","scryfallId":"0d237175-0bda-44df-af32-ca963d0a0520"},{"index":12589,"token":false,"name":"Viridian Acolyte","scryfallId":"64448241-978c-43e0-b0ea-b4bb3e25b715"},{"index":12591,"token":false,"name":"Ajani Vengeant","scryfallId":"c6ffd45c-2353-4292-b6f6-29d8f7e031ca"},{"index":12592,"token":false,"name":"Corpse Augur","scryfallId":"93f5edce-094e-4fe6-bb1c-8b1d28fdf6cd"},{"index":12593,"token":false,"name":"Daughter of Autumn","scryfallId":"972e9c59-f340-414c-b55b-39d46dd97e8e"},{"index":12594,"token":false,"name":"Lotus Petal","scryfallId":"9814d8e8-c462-41ca-9909-1c659f488543"},{"index":12595,"token":false,"name":"Deathmark Prelate","scryfallId":"b54fb4b2-ecce-4a6c-8d76-4b5879ba836f"},{"index":12597,"token":false,"name":"Embodiment of Agonies","scryfallId":"b5190b07-db55-46bd-bc33-41ff9743e059"},{"index":12598,"token":false,"name":"Mask of the Mimic","scryfallId":"09891c87-eb74-4174-ad46-11a7f79de859"},{"index":12602,"token":false,"name":"Tangle Asp","scryfallId":"5e13ac56-72a9-4605-b389-24d1cb712b3c"},{"index":12603,"token":false,"name":"Lizard Warrior","scryfallId":"6da5a962-e00c-452f-b9ad-4cf6615c9dcd"},{"index":12604,"token":false,"name":"Rite of the Raging Storm","scryfallId":"d44411e5-4046-422e-bf85-c0883c0f16ab"},{"index":12605,"token":false,"name":"Thundering Giant","scryfallId":"77d3cde7-ac3f-4178-908f-0f51c4379b44"},{"index":12608,"token":false,"name":"Yamabushi's Storm","scryfallId":"0a5a930d-ae59-47e2-9b98-f703e308b5c0"},{"index":12609,"token":false,"name":"Diregraf Colossus","scryfallId":"92c5e37e-3cc9-42bc-bd99-58eebb9c9bf0"},{"index":12611,"token":false,"name":"Scaldkin","scryfallId":"8110eb0a-63dc-43df-b55a-9241f45b1cc6"},{"index":12612,"token":false,"name":"Pia Nalaar","scryfallId":"ba07c7db-9ec7-47c1-96a4-fa67492870f0"},{"index":12613,"token":false,"name":"Spontaneous Artist","scryfallId":"b8bbeb22-5e50-4b90-b756-9d420f9cfe7f"},{"index":12614,"token":false,"name":"Tibor and Lumia","scryfallId":"d59d7fb6-6aa1-4ae1-8580-92e6080aa757"},{"index":12615,"token":false,"name":"Craven Knight","scryfallId":"d4cbae27-4a1a-4e16-8876-9a2925c45302"},{"index":12617,"token":false,"name":"D'Avenant Trapper","scryfallId":"a5881ab3-566b-4999-997e-cd5ecb84282b"},{"index":12620,"token":false,"name":"Temple of Plenty","scryfallId":"61dc9a80-850c-4945-b84a-85381cc3ee85"},{"index":12622,"token":false,"name":"Pir's Whim","scryfallId":"b816ce6e-d876-4c6d-83ed-e3887dcfa5d5"},{"index":12623,"token":false,"name":"Cauldron Dance","scryfallId":"50e70e67-eba0-46f4-97d8-62c249b267c8"},{"index":12624,"token":false,"name":"Zhur-Taa Swine","scryfallId":"7a191269-d2e4-4810-b65f-91a1e03fbae6"},{"index":12626,"token":false,"name":"Act of Heroism","scryfallId":"969860ba-6923-4715-b065-81803bba3dd6"},{"index":12628,"token":false,"name":"Illusionary Terrain","scryfallId":"691f4a1b-4706-41aa-82da-ae920739f036"},{"index":12629,"token":false,"name":"Cloudthresher","scryfallId":"f315762b-b386-41ec-8282-4bc4e7cddef1"},{"index":12630,"token":false,"name":"Grim Affliction","scryfallId":"33da8323-86b2-48c8-b77a-578bbdfa2bde"},{"index":12631,"token":false,"name":"Gorgon Recluse","scryfallId":"abdeb7c9-98bd-4143-87e4-1c78c0ce627e"},{"index":12632,"token":false,"name":"Slither Blade","scryfallId":"06b56909-65b3-479f-8e52-d025641f4a8e"},{"index":12635,"token":false,"name":"Staunch Defenders","scryfallId":"df28f2aa-ad79-4f80-ab0d-b53f98072c0e"},{"index":12639,"token":false,"name":"Undo","scryfallId":"2bef942e-9d17-4d40-a4c9-8be715e73a08"},{"index":12641,"token":true,"name":"Pegasus Token (W, 1/1)","scryfallId":"01a2a64d-088a-4340-a129-6338cdf90203"},{"index":12642,"token":false,"name":"Impeccable Timing","scryfallId":"9e7994d5-4381-47be-bce3-59bb3facd2a3"},{"index":12643,"token":false,"name":"Salvage Drone","scryfallId":"4b8ce2a9-9d8e-442b-bc12-74545ceb65bd"},{"index":12646,"token":false,"name":"Run Wild","scryfallId":"939a7354-162c-489d-955d-4df17b930e1c"},{"index":12647,"token":false,"name":"Mardu Charm","scryfallId":"c35fb7a3-7c7f-4470-b1ad-5b8709a608e6"},{"index":12648,"token":false,"name":"Scourglass","scryfallId":"b8993b57-3060-45ca-80ed-3366784ec61d"},{"index":12650,"token":false,"name":"Djeru's Resolve","scryfallId":"4cb43aab-f490-4ded-af46-3815a09c59d4"},{"index":12651,"token":false,"name":"Blessed Reversal","scryfallId":"806d854b-a165-4d40-86d7-d6a0aa17ce18"},{"index":12655,"token":false,"name":"Piston Sledge","scryfallId":"cf6a88da-0b51-42d1-aa63-8c4b5e5c03c3"},{"index":12660,"token":false,"name":"God-Eternal Oketra","scryfallId":"df70f155-2336-421c-8a9d-69772d2b51a8"},{"index":12661,"token":false,"name":"Soulbright Flamekin","scryfallId":"eaf72b4d-a399-49fb-a890-653b184a9e95"},{"index":12665,"token":false,"name":"Reckless Reveler","scryfallId":"188adefd-a808-4991-80be-53249c24df8f"},{"index":12666,"token":false,"name":"Tajuru Paragon","scryfallId":"ca767812-3ff1-4f4e-a8de-cfd7c650d6fa"},{"index":12667,"token":false,"name":"Watcher Sliver","scryfallId":"7d72a950-82ed-4e7b-9e18-b8231a2ebea7"},{"index":12668,"token":false,"name":"Plague Spitter","scryfallId":"8845e6bd-40ee-45ca-a099-53f19ff20a8a"},{"index":12669,"token":false,"name":"Savage Gorger","scryfallId":"8ee2735e-05a8-4e3b-a44c-4e7532f1d312"},{"index":12670,"token":false,"name":"Planar Void","scryfallId":"b035c718-ac11-4c97-a9bb-0cd88dc71904"},{"index":12671,"token":false,"name":"Rebellion of the Flamekin","scryfallId":"abd2c8cb-4852-4bde-b2cf-72ceb9b0dd3e"},{"index":12674,"token":false,"name":"Sakashima's Student","scryfallId":"91b0a6cb-1c2e-4122-8874-a48e69e1c464"},{"index":12675,"token":false,"name":"Exemplar of Strength","scryfallId":"a6c28900-780a-4cd3-9e44-19c1c1137d53"},{"index":12677,"token":false,"name":"Grounded","scryfallId":"dc4982f0-0ede-4846-82c8-bcf7ad63d099"},{"index":12680,"token":false,"name":"Academy Manufactor","scryfallId":"bdb31a63-a4c9-4432-9029-eb5a50c769b4"},{"index":12681,"token":false,"name":"Moriok Reaver","scryfallId":"e2a0410f-95c5-49bf-856d-dea796c96e3b"},{"index":12684,"token":false,"name":"Aerial Assault","scryfallId":"58e84a4a-034f-4f55-a827-e62f2b61f091"},{"index":12687,"token":false,"name":"Lunarch Mantle","scryfallId":"b6eb3c20-e853-4399-a107-c3308b2e5d4e"},{"index":12688,"token":false,"name":"Welkin Tern","scryfallId":"357931d0-8ba6-4857-9db9-7f42d81514a5"},{"index":12689,"token":false,"name":"Pith Driller","scryfallId":"28e960c6-6da0-4679-87eb-55bac890e0c6"},{"index":12690,"token":false,"name":"Webweaver Changeling","scryfallId":"91571765-8da8-49f9-a776-7778d86cfb99"},{"index":12691,"token":false,"name":"Winds of Change","scryfallId":"cebfd866-2a71-4a09-b41e-0b1e6a2ca44d"},{"index":12696,"token":false,"name":"Stormcaller of Keranos","scryfallId":"d397bdc3-a866-45be-8740-185d9ccf29c4"},{"index":12701,"token":false,"name":"Sky Diamond","scryfallId":"f8a28252-e904-4ac4-978c-64cc5241293d"},{"index":12705,"token":false,"name":"Nascent Metamorph","scryfallId":"61e7984b-8c20-4867-8045-4fb52cd6e2d4"},{"index":12708,"token":false,"name":"Frenzied Raptor","scryfallId":"c5952b88-3e67-4e8e-97cc-dc14317d8e92"},{"index":12709,"token":false,"name":"Carnophage","scryfallId":"d17c057f-cb1b-4895-831a-fb35c75d3845"},{"index":12713,"token":false,"name":"Sorcerer's Wand","scryfallId":"69ee3692-54e3-42de-85c6-0a3b5c6a2402"},{"index":12715,"token":false,"name":"Ornitharch","scryfallId":"f95a0bf4-10c7-4afa-8cf6-e31196cc2bd5"},{"index":12716,"token":false,"name":"Arborback Stomper","scryfallId":"3d0c7584-a716-47cc-8ea5-3b5ab16952dc"},{"index":12717,"token":false,"name":"Skybind","scryfallId":"91e3117a-0955-47fc-81c0-7a662c8c487f"},{"index":12719,"token":false,"name":"Petra Sphinx","scryfallId":"e799b225-7bd7-40dd-b555-37ea500e12fe"},{"index":12720,"token":false,"name":"Chakram Retriever","scryfallId":"b57d518c-21bb-4451-8248-9ee838460c09"},{"index":12723,"token":false,"name":"Ivorytusk Fortress","scryfallId":"c8dabe64-48c2-4979-959f-5619d11d72b7"},{"index":12730,"token":false,"name":"Footfall Crater","scryfallId":"f1b75aac-54e3-4181-bac5-5a142757ec05"},{"index":12732,"token":false,"name":"Passwall Adept","scryfallId":"a8ed28c3-8c66-4883-8774-67ac5ab9e81c"},{"index":12733,"token":false,"name":"Vent Sentinel","scryfallId":"07989612-d3c4-44f7-b1ee-1ddf2d93a7da"},{"index":12735,"token":false,"name":"Rowan's Battleguard","scryfallId":"9c8a3119-ce9b-4fe5-aea3-871a7eee216e"},{"index":12736,"token":false,"name":"Cloudblazer","scryfallId":"3f5c2288-28b3-49e5-92c2-ffe740c4331b"},{"index":12737,"token":false,"name":"Subterranean Scout","scryfallId":"3c9289dd-f1a3-4be5-8ed1-4b4dd4e97743"},{"index":12739,"token":false,"name":"Golden Ratio","scryfallId":"626fbddb-3963-4dd2-8507-9777ed66bbbc"},{"index":12741,"token":false,"name":"Sawtusk Demolisher","scryfallId":"a34a1550-183a-4f7d-ba28-f3249e13a9d6"},{"index":12743,"token":false,"name":"Archfiend of Despair","scryfallId":"11d8b7ac-fb65-4496-9d9f-184fa8ad8012"},{"index":12744,"token":false,"name":"Judge Unworthy","scryfallId":"46b0f9cb-f848-460e-94cc-d85b23133d6e"},{"index":12747,"token":false,"name":"Kiora, the Crashing Wave","scryfallId":"0c5c6b15-b72d-4341-92c2-7469210452da"},{"index":12748,"token":false,"name":"Tundra Wolves","scryfallId":"030d414a-5155-41cc-8b01-07d297254d1c"},{"index":12750,"token":true,"name":"Elves","scryfallId":"be1d8ebf-efa5-4624-985c-07a85be09258"},{"index":12751,"token":false,"name":"Animal Boneyard","scryfallId":"e3379317-be18-4252-84ad-b7ebb6e557ff"},{"index":12753,"token":false,"name":"Nevinyrral, Urborg Tyrant","scryfallId":"0f7247d7-fa1d-4d40-8630-e1874e41996b"},{"index":12755,"token":false,"name":"Hidetsugu's Second Rite","scryfallId":"39a6b945-7cca-4c30-98e3-a89d39ed3830"},{"index":12758,"token":true,"name":"Goblin Rogue Token (B, 1/1)","scryfallId":"33bd708d-dc84-44d3-a563-536ade028bd0"},{"index":12760,"token":false,"name":"Weaponize the Monsters","scryfallId":"68bba622-a0ab-4c0e-88b1-9120690ea5a0"},{"index":12761,"token":false,"name":"Quiet Purity","scryfallId":"ecd4d7cd-12a9-49f2-912d-2a6024112d13"},{"index":12762,"token":false,"name":"Muck Rats","scryfallId":"ded268ef-f1a3-4d53-82f6-9562fe51c3e4"},{"index":12767,"token":false,"name":"Bewilder","scryfallId":"7be63098-6446-4e64-85b0-9af914f5e075"},{"index":12768,"token":false,"name":"Gluttonous Slime","scryfallId":"9ba0ace8-dcc0-4ecb-bc5a-156577a52684"},{"index":12769,"token":false,"name":"Vodalian Mystic","scryfallId":"81ec203a-067e-4360-9b4d-2d67db472aab"},{"index":12770,"token":false,"name":"Alaborn Trooper","scryfallId":"a3bc4e43-1935-402b-a309-c575c83e849f"},{"index":12775,"token":false,"name":"Brine Elemental","scryfallId":"0b93a80e-7b93-4ea8-96b7-f48d5159360f"},{"index":12776,"token":false,"name":"Hanna's Custody","scryfallId":"7ea44536-ef4e-4dcf-9c1a-c1122dd00cbb"},{"index":12778,"token":false,"name":"Vedalken Heretic","scryfallId":"5ab2ba75-e52e-46f5-8a34-3fe1e07446fd"},{"index":12779,"token":false,"name":"Staff of the Mind Magus","scryfallId":"cf76bee3-2b69-4c7b-9b7c-1a9f4bbcfde0"},{"index":12780,"token":false,"name":"Contagion","scryfallId":"90036bbd-bb67-477b-a924-d0a2bf436d34"},{"index":12781,"token":false,"name":"Sparksmith","scryfallId":"ee9ffdf4-24c8-490c-ac82-b8be5cd29241"},{"index":12782,"token":false,"name":"Hightide Hermit","scryfallId":"69c871fa-d333-4c73-9d5c-f5cfec5954da"},{"index":12784,"token":true,"name":"Hornet Token (Colorless, 1/1)","scryfallId":"54ec2cd6-51f6-4e12-af90-fa254f14ad32"},{"index":12785,"token":false,"name":"Revoke Existence","scryfallId":"7bd4fc26-8351-4371-948b-f43346c3e771"},{"index":12788,"token":false,"name":"Rograkh, Son of Rohgahh","scryfallId":"a4fab67f-00c2-4125-9262-d21a29411797"},{"index":12790,"token":false,"name":"Archon of Sun's Grace","scryfallId":"94f05268-0d4f-4638-aec3-a85fc339e3a7"},{"index":12791,"token":false,"name":"Kruin Outlaw // Terror of Kruin Pass","scryfallId":"ec00d2d2-6597-474a-9353-345bbedfe57e"},{"index":12792,"token":false,"name":"Abiding Grace","scryfallId":"db113c47-c403-4c7f-9fa9-212c977df8d1"},{"index":12794,"token":false,"name":"Sisay, Weatherlight Captain","scryfallId":"673cfb84-b76f-44c2-9ca1-5d57d1ac525f"},{"index":12796,"token":false,"name":"Assemble the Legion","scryfallId":"43675ed7-ece1-4414-965e-9ebadcbf3dfb"},{"index":12797,"token":false,"name":"Runaway Steam-Kin","scryfallId":"dbdbc518-ab95-4708-b611-d2b88f7daebb"},{"index":12798,"token":false,"name":"Thraben Valiant","scryfallId":"a8a8282b-bba6-4815-80fe-7a37a1fec3c1"},{"index":12801,"token":false,"name":"Snake of the Golden Grove","scryfallId":"08b10bd7-3f8b-426f-acdf-5a9559b9bc7d"},{"index":12805,"token":false,"name":"Horribly Awry","scryfallId":"4cd05532-686e-40dc-858b-8a77a3628c99"},{"index":12809,"token":false,"name":"Akki Blizzard-Herder","scryfallId":"7ce1ee90-67d1-4e83-ae1e-3bd71069aae4"},{"index":12810,"token":false,"name":"Sorin Markov","scryfallId":"29606aca-f23f-4dfe-b685-2065193109c8"},{"index":12814,"token":false,"name":"Lone Revenant","scryfallId":"5cb09a51-07c1-4047-81cd-67219c01e9b3"},{"index":12815,"token":false,"name":"Shambling Vent","scryfallId":"30a73816-1f33-4798-a9d6-5f0410d19625"},{"index":12816,"token":false,"name":"Wash Out","scryfallId":"dd8e5e14-27f3-49fc-a3d2-3f0647d5b767"},{"index":12817,"token":false,"name":"Vraska the Unseen","scryfallId":"19b9432d-9ae5-4821-b6c4-2e90240d8623"},{"index":12819,"token":false,"name":"Wall of Mist","scryfallId":"62a37646-8f7c-40fc-851d-e3fdd205b012"},{"index":12821,"token":false,"name":"Yuriko, the Tiger's Shadow","scryfallId":"e1ed95a7-23b7-4384-8395-5649c9a2fec9"},{"index":12825,"token":false,"name":"Quakefoot Cyclops","scryfallId":"c1ac1167-a622-4dc9-85cb-a8622e32d295"},{"index":12827,"token":false,"name":"Rowdy Crew","scryfallId":"bdb3821a-ecc8-478d-93de-57200476868c"},{"index":12828,"token":false,"name":"Killing Glare","scryfallId":"f7a4d87d-b844-4f20-8b14-4fd32c53dea5"},{"index":12829,"token":false,"name":"Rousing Read","scryfallId":"c82be2ca-8350-4cf5-83b6-e8b60a9e21c6"},{"index":12830,"token":false,"name":"Gustcloak Savior","scryfallId":"5303ce82-e82a-498e-af4f-16a56d8188ff"},{"index":12831,"token":false,"name":"Mirror Gallery","scryfallId":"00beba34-54cc-4a30-8424-71a1215647a6"},{"index":12832,"token":false,"name":"Nahiri's Lithoforming","scryfallId":"f3802a09-d9f8-45d8-afc8-1182dce715b4"},{"index":12833,"token":false,"name":"Ramosian Revivalist","scryfallId":"250ee8d2-6f03-44a5-8f4c-ced4eaa4cdea"},{"index":12834,"token":false,"name":"Rakdos Roustabout","scryfallId":"5ed534af-e16a-4d1d-8884-938fc7e13ca8"},{"index":12836,"token":false,"name":"Fledgling Dragon","scryfallId":"315e5b4e-ae58-412a-be27-c4ef4899fbbd"},{"index":12837,"token":false,"name":"Stoic Angel","scryfallId":"37fd303a-0a51-4931-9735-704ce8179a98"},{"index":12840,"token":false,"name":"Silent-Blade Oni","scryfallId":"f0016f82-f428-4ee4-bf60-0199b22b8453"},{"index":12842,"token":false,"name":"Soulquake","scryfallId":"4b3a7470-b93e-4c3a-ab1c-0a4dd401e95a"},{"index":12845,"token":true,"name":"Janosch Kühn Bio 1997","scryfallId":"c420f353-0d9f-44ad-a566-5ed0b58964c2"},{"index":12847,"token":false,"name":"Nemesis Mask","scryfallId":"d6fc3b76-bc51-49ce-8f3f-2314207be4a7"},{"index":12849,"token":false,"name":"Crovax, Ascendant Hero","scryfallId":"94a9dfa5-0e94-433e-8f4a-edfa2dac4913"},{"index":12850,"token":false,"name":"Molten Slagheap","scryfallId":"3e0f846d-661b-4330-a32e-566cc13b258e"},{"index":12851,"token":false,"name":"Sneaking Guide","scryfallId":"569c9e8c-7808-49d0-82c1-72d5b835f51c"},{"index":12852,"token":false,"name":"Sadistic Glee","scryfallId":"d9e1959c-b87b-4e17-a0d2-0489ea79220b"},{"index":12855,"token":false,"name":"Rust Elemental","scryfallId":"967a08cd-72b3-4b3f-9f23-15697704acb3"},{"index":12864,"token":false,"name":"Oakenform","scryfallId":"0bf71f42-6e42-46c0-9e8f-394d2c4519ee"},{"index":12866,"token":false,"name":"Boreal Centaur","scryfallId":"05231fa1-47b8-49aa-9393-ec4d8384c41b"},{"index":12867,"token":false,"name":"Servo Exhibition","scryfallId":"3727b70d-bee0-432d-863d-a319dd14a9fb"},{"index":12868,"token":false,"name":"Witch's Familiar","scryfallId":"8c9f3b3b-de16-4ae5-844e-1373e0f84469"},{"index":12869,"token":false,"name":"Splatter Thug","scryfallId":"7c511805-3392-4033-8679-811711a0aaca"},{"index":12870,"token":false,"name":"Nikya of the Old Ways","scryfallId":"90ff41a6-6604-4953-a43d-816c4568b742"},{"index":12872,"token":false,"name":"Empyrean Eagle","scryfallId":"ac555709-c7cc-4c64-8a6f-8fe2bc149fcd"},{"index":12873,"token":false,"name":"Conclave's Blessing","scryfallId":"86235d9f-ba69-417d-9203-812ab428b374"},{"index":12874,"token":false,"name":"Blazing Hellhound","scryfallId":"332769b1-1eb5-4c77-8317-27addc28650b"},{"index":12875,"token":false,"name":"Uncle Istvan","scryfallId":"5feed985-7bc2-4e9a-99f7-f50641086ed7"},{"index":12877,"token":false,"name":"Mighty Emergence","scryfallId":"8ee66318-4dbb-49a3-a3c8-ee0e1a9f02b7"},{"index":12879,"token":false,"name":"Warp Artifact","scryfallId":"94355dce-dfd6-45d6-9b86-0c2bc10e0231"},{"index":12880,"token":false,"name":"Dark Depths","scryfallId":"e00d16f9-ea27-4aa3-a134-4e04f934d020"},{"index":12886,"token":false,"name":"Earthen Goo","scryfallId":"b347f1bf-6167-4c59-bfa6-3e921874ab9a"},{"index":12887,"token":false,"name":"Sulfuric Vapors","scryfallId":"e133997f-1620-4fe9-8275-057edc998fba"},{"index":12891,"token":false,"name":"Jade Mage","scryfallId":"3d57bc86-7625-4669-9d33-b662263bd5bf"},{"index":12894,"token":false,"name":"Elder Cathar","scryfallId":"c21b9e51-fecd-4f9a-9354-a6dc1613feb3"},{"index":12897,"token":false,"name":"Knotvine Mystic","scryfallId":"f6372fa0-e9c8-45d0-a3b8-72eb191c6b26"},{"index":12900,"token":false,"name":"Consulate Dreadnought","scryfallId":"ca9df3da-8b66-4726-a133-6047ed9fc3d1"},{"index":12903,"token":false,"name":"Ancient Amphitheater","scryfallId":"c68137c5-c2f9-4b0d-ac4b-12c519854166"},{"index":12908,"token":false,"name":"Patagia Viper","scryfallId":"d5e565b4-d5ca-4a29-8bb4-0063bae2a85c"},{"index":12911,"token":false,"name":"Oreskos Sun Guide","scryfallId":"064435e7-20ea-4ba4-b039-a945afeeb5c6"},{"index":12912,"token":false,"name":"Devastate","scryfallId":"bfe7c990-a34b-475e-a612-447c22f998d3"},{"index":12913,"token":false,"name":"Jund Charm","scryfallId":"7a0ddf00-926c-4283-a8b2-daa02fa99b8b"},{"index":12914,"token":false,"name":"Kolaghan, the Storm's Fury","scryfallId":"24866c61-a4f1-46f7-81e2-1c9e4458b6f7"},{"index":12916,"token":false,"name":"Imagecrafter","scryfallId":"91be6441-8a45-43e4-8d12-a886dcaadbd3"},{"index":12918,"token":false,"name":"Mortuary","scryfallId":"860f46ea-6fd0-456d-971d-8d1eccc7fa60"},{"index":12919,"token":false,"name":"Mythos of Vadrok","scryfallId":"ce59b5b6-97d8-4678-9381-2800667fdb41"},{"index":12920,"token":false,"name":"Forge of Heroes","scryfallId":"4c01c015-bdbf-4d6e-9c6e-0f764f6ef3bd"},{"index":12921,"token":false,"name":"Argothian Swine","scryfallId":"afe5e4ec-9c0e-4b1a-b3c6-e9631cf214eb"},{"index":12922,"token":false,"name":"Sandstone Needle","scryfallId":"82bc7c6b-2e3d-42d1-b2bb-b37b6f34d33b"},{"index":12923,"token":false,"name":"Snapping Drake","scryfallId":"03b2ad93-8287-4b87-88ed-c627bd54fd49"},{"index":12925,"token":false,"name":"Carom","scryfallId":"184e0964-1e04-49f9-bb76-0a6e682c52f5"},{"index":12928,"token":false,"name":"Cloudform","scryfallId":"00e3ff89-9901-48ba-900c-5778cdd1b112"},{"index":12929,"token":false,"name":"Ink-Eyes, Servant of Oni","scryfallId":"e103987b-3c88-44ce-bc97-2efb92620347"},{"index":12930,"token":true,"name":"Enchanted","scryfallId":"2a871c86-c203-4456-b911-fb8e215e62bf"},{"index":12932,"token":false,"name":"Ion Storm","scryfallId":"2296acb6-a304-42ab-b26b-5cbe796e72b7"},{"index":12933,"token":false,"name":"Witherbloom Command","scryfallId":"e95c7c40-4bb1-4533-b031-d595fc5d9e8e"},{"index":12935,"token":false,"name":"Patient Rebuilding","scryfallId":"2256e07f-a35a-4393-9744-045564d5770b"},{"index":12937,"token":true,"name":"Stangg Twin Token (G/R, 3/4)","scryfallId":"eba90d37-d7ac-4097-a04d-1f27e4c9e5de"},{"index":12938,"token":false,"name":"Valley Rannet","scryfallId":"cf92a04d-279a-4843-949f-6a191fff559e"},{"index":12939,"token":false,"name":"Highland Forest","scryfallId":"682eee5f-7986-45d3-910f-407303fdbcc4"},{"index":12940,"token":false,"name":"Blackblade Reforged","scryfallId":"659afdec-36fb-411e-b0d0-6b76d8a744b3"},{"index":12941,"token":false,"name":"Demonic Embrace","scryfallId":"e9122aad-ffc4-476d-9311-978d506bc03b"},{"index":12942,"token":false,"name":"Hold the Line","scryfallId":"d20ee9c8-6d58-42fc-8b27-bfd0ea6d4374"},{"index":12945,"token":false,"name":"Elusive Tormentor // Insidious Mist","scryfallId":"25f7030d-a6a1-4a51-b3c9-a48071adb7e0"},{"index":12949,"token":false,"name":"Erosion","scryfallId":"8dc539ff-03f5-4bec-877a-061fb5d40de9"},{"index":12952,"token":false,"name":"Artful Maneuver","scryfallId":"7fcaf67e-ba97-4af9-8c47-dbca703cba35"},{"index":12953,"token":false,"name":"Leonin Lightscribe","scryfallId":"690beef8-a20f-450a-924e-973f9810f84f"},{"index":12955,"token":false,"name":"Serrated Biskelion","scryfallId":"cc2e3173-d2d5-4c6b-8156-0d78f8b1b5d1"},{"index":12956,"token":false,"name":"Mist-Cloaked Herald","scryfallId":"574f73a7-9ff7-4ce3-9f56-002af968d35a"},{"index":12959,"token":false,"name":"Giant Dustwasp","scryfallId":"f8c2033c-3be6-413f-93b9-a375af9b5cf1"},{"index":12963,"token":false,"name":"Snowhorn Rider","scryfallId":"f5d9aa9b-1ed4-46db-89d1-6c9593c29f55"},{"index":12964,"token":false,"name":"Caligo Skin-Witch","scryfallId":"df919224-0e49-4098-9ec5-d2c5f0a91053"},{"index":12965,"token":false,"name":"Elephant Graveyard","scryfallId":"18348df2-9037-4db4-bddb-76dc933229bf"},{"index":12970,"token":false,"name":"Shining Aerosaur","scryfallId":"9e214072-551f-48fa-b207-8f6303646941"},{"index":12973,"token":false,"name":"Conflux","scryfallId":"e25e43a7-509b-4cc1-a336-a0229229c2ff"},{"index":12977,"token":false,"name":"Harbinger of Spring","scryfallId":"19fd23b5-5e57-44dc-8248-c4b9eb71c4f3"},{"index":12980,"token":false,"name":"Heliod's Emissary","scryfallId":"49663acb-582e-495a-b45e-5fc5f4949f22"},{"index":12982,"token":false,"name":"Jiang Yanggu, Wildcrafter","scryfallId":"47770786-b291-4a7d-a2b3-9ec25aaae0a2"},{"index":12984,"token":false,"name":"Screeching Phoenix","scryfallId":"4b9477ba-e198-4085-8733-fd392a5648e7"},{"index":12986,"token":false,"name":"Ashes of the Abhorrent","scryfallId":"5505040d-2d75-4041-bb82-74a33cad00d7"},{"index":12988,"token":false,"name":"Palladium Myr","scryfallId":"27305aad-f1bd-4895-8611-143bc0250bee"},{"index":12991,"token":false,"name":"Call the Coppercoats","scryfallId":"e11cb353-d864-4b22-bdaf-1d42c25f0918"},{"index":12992,"token":false,"name":"Healing Hands","scryfallId":"9a26559c-0ac5-42a7-b6ac-b39938c31026"},{"index":12994,"token":false,"name":"Splintering Wind","scryfallId":"0afa94e5-fef6-4f3a-9196-d7aa6dd841c2"},{"index":12995,"token":false,"name":"Fevered Convulsions","scryfallId":"3a790769-e76e-49e9-9d6d-05ce8e858243"},{"index":12996,"token":false,"name":"Fluctuator","scryfallId":"c06a2fb3-d933-461f-bcf8-5c614bb75d0b"},{"index":13000,"token":false,"name":"Chamber of Manipulation","scryfallId":"50496069-0f55-4dfe-8b1e-7fc4f649f2f1"},{"index":13001,"token":false,"name":"Molimo, Maro-Sorcerer","scryfallId":"f48c4a3b-a841-412e-b322-27627ded8bca"},{"index":13003,"token":false,"name":"Trip Noose","scryfallId":"1b2b3dd8-cedb-4577-8897-967952dd3c13"},{"index":13004,"token":false,"name":"Furycalm Snarl","scryfallId":"a209b7f8-cfa8-4040-9bbe-069cfff2f832"},{"index":13005,"token":false,"name":"Tromokratis","scryfallId":"69fcad7f-2740-49ff-a448-4b232c456e16"},{"index":13006,"token":false,"name":"Silver Drake","scryfallId":"726aa407-dadd-4575-aee2-b7888e67a722"},{"index":13008,"token":false,"name":"Reservoir Walker","scryfallId":"4e55a834-2f36-4eaa-835e-0172efc86cb6"},{"index":13011,"token":false,"name":"Zodiac Dog","scryfallId":"cc61aa62-25ee-40a4-9b6e-d6277316b464"},{"index":13015,"token":false,"name":"Obelisk of Naya","scryfallId":"df6317b0-15fd-4924-9302-41bed2354546"},{"index":13018,"token":false,"name":"Vigorous Charge","scryfallId":"af6f57ad-d370-4c81-8da0-c15d87725ab1"},{"index":13019,"token":false,"name":"Twin-Silk Spider","scryfallId":"7cf3188c-879b-4b18-88b4-6237d7162271"},{"index":13024,"token":false,"name":"Arcbound Slith","scryfallId":"46b468b4-ceb7-4bbd-9d77-046df3b5ba61"},{"index":13025,"token":false,"name":"Midsummer Revel","scryfallId":"b40a7f65-10fe-4ce5-ad1c-be53a635d7a9"},{"index":13026,"token":false,"name":"Runechanter's Pike","scryfallId":"0f54e38b-b4a0-4406-a635-7a5ab3722f25"},{"index":13027,"token":false,"name":"Noggin Whack","scryfallId":"932649ab-ed5e-405f-986f-855d8a7c8eb2"},{"index":13028,"token":false,"name":"Time Elemental","scryfallId":"61510e88-97d0-410a-9431-ebf12990e33d"},{"index":13032,"token":false,"name":"Living Wish","scryfallId":"d505d319-093d-47af-8ee9-fafae3885aa0"},{"index":13033,"token":false,"name":"Abeyance","scryfallId":"9987d80f-d2cb-4cc1-b728-1506d2d41cde"},{"index":13034,"token":false,"name":"Pack Guardian","scryfallId":"64dcc129-88c2-4f20-be0b-36c4141688c9"},{"index":13040,"token":false,"name":"Thieving Sprite","scryfallId":"244d864d-fc74-4147-aca6-d0498691b1a9"},{"index":13044,"token":false,"name":"Deadly Insect","scryfallId":"d8222dd3-12fa-4c4c-baf4-46eb6e07289c"},{"index":13048,"token":false,"name":"Hundred-Handed One","scryfallId":"817b8dae-6248-41a4-80a7-7e8102479de4"},{"index":13049,"token":false,"name":"Shrewd Negotiation","scryfallId":"37900980-c2e2-4b70-8511-405f0a8389cd"},{"index":13050,"token":false,"name":"Jwar Isle Avenger","scryfallId":"0a5b059f-2fa3-474f-9c74-6d4021703add"},{"index":13051,"token":false,"name":"Magus of the Vineyard","scryfallId":"63005c92-fc0b-45dc-b488-489350527453"},{"index":13055,"token":false,"name":"Just the Wind","scryfallId":"98b3d18c-7029-4eff-a918-f75e7d9d79d7"},{"index":13059,"token":false,"name":"Scourge of Nel Toth","scryfallId":"95536859-a8d9-45fa-9dbd-639bc626812d"},{"index":13067,"token":false,"name":"Followed Footsteps","scryfallId":"d00e2fcc-0fa2-451e-8c69-7a24ba533e0b"},{"index":13069,"token":false,"name":"Malfegor","scryfallId":"010a4b07-c2d5-433e-9898-6e148104e9e0"},{"index":13070,"token":false,"name":"Daggersail Aeronaut","scryfallId":"5a46b090-8b03-4498-840e-cf130510892c"},{"index":13072,"token":false,"name":"Fortitude","scryfallId":"d54d5240-8afc-4c61-aaf6-a78d2b92e5c9"},{"index":13073,"token":false,"name":"Screaming Seahawk","scryfallId":"cc5856ac-e710-44ee-8516-6070f4f31ce5"},{"index":13074,"token":false,"name":"Consuming Vapors","scryfallId":"008de17e-aa79-4d4c-ab66-d516eca49e42"},{"index":13075,"token":false,"name":"Bravado","scryfallId":"019ba422-4837-400c-a913-b56d87b49e26"},{"index":13076,"token":false,"name":"Petravark","scryfallId":"ffc98d09-439e-426b-8403-4a3e12167336"},{"index":13078,"token":false,"name":"The Prismatic Piper","scryfallId":"b6a221ac-2022-49b6-929e-91db38929a9f"},{"index":13080,"token":false,"name":"Fists of Flame","scryfallId":"1897b60d-7e15-488c-84d5-505187739b00"},{"index":13086,"token":false,"name":"Fervent Paincaster","scryfallId":"e3c78708-254c-446f-b6eb-8839faf08790"},{"index":13087,"token":false,"name":"Raging Kronch","scryfallId":"ae38aa2d-6c0e-409a-bfc7-ed4281457670"},{"index":13089,"token":false,"name":"Flesh Reaver","scryfallId":"e3dc6a91-ca13-45da-ba65-8fbb16c159c0"},{"index":13090,"token":false,"name":"Wild Cantor","scryfallId":"242dc29e-d8f5-4207-abbf-cf5425f08551"},{"index":13092,"token":false,"name":"Mother Bear","scryfallId":"efae4d84-8134-461a-a352-a5bdff7259a7"},{"index":13094,"token":false,"name":"Granulate","scryfallId":"e13798b8-689e-4f19-af10-b72d3fe19f3c"},{"index":13099,"token":false,"name":"Vicious Hunger","scryfallId":"a232093a-f136-428d-9a6d-c03b1a20126a"},{"index":13100,"token":false,"name":"Teferi's Drake","scryfallId":"c24823df-5651-4578-a0c8-f9f52f66abe4"},{"index":13102,"token":false,"name":"Siegecraft","scryfallId":"fbd17ef9-9f1b-4937-a60a-d7175f04eef2"},{"index":13104,"token":false,"name":"Shadowblood Egg","scryfallId":"044bbf15-e71d-4f47-bac3-bba8021118bd"},{"index":13105,"token":false,"name":"Cavalry Drillmaster","scryfallId":"62d2e929-7ae3-4560-9cfa-53b89c8a6016"},{"index":13106,"token":false,"name":"Willowdusk, Essence Seer","scryfallId":"42a97ec1-f613-49a5-9236-7fded1a81f3b"},{"index":13107,"token":false,"name":"White Mana Battery","scryfallId":"35fbbe41-d21b-4028-905f-054c44d30eb2"},{"index":13108,"token":false,"name":"Flamekin Brawler","scryfallId":"42da4ec7-9d30-4c4e-9220-db0f4172bf9c"},{"index":13109,"token":false,"name":"Terra Stomper","scryfallId":"e093b461-49c4-4fff-bc1b-cab3f05d9615"},{"index":13110,"token":false,"name":"Garth One-Eye","scryfallId":"23774462-9f17-4b50-a2ac-b2edd706bbfe"},{"index":13112,"token":false,"name":"Radiant Fountain","scryfallId":"8090e148-2550-4156-89e3-052abda9f0e7"},{"index":13114,"token":false,"name":"Searing Light","scryfallId":"bb8746cd-bc88-40ef-8b69-2bf1a34b4ac4"},{"index":13115,"token":false,"name":"Tajuru Snarecaster","scryfallId":"e1894cf9-7d53-4b7e-aaae-8db42bdd8e49"},{"index":13118,"token":false,"name":"Dispeller's Capsule","scryfallId":"0710e943-8882-4a31-973b-1bb07d545af8"},{"index":13119,"token":false,"name":"Slith Ascendant","scryfallId":"b90157f8-ba3c-479e-80d8-8f9e042c540c"},{"index":13123,"token":false,"name":"Pteron Ghost","scryfallId":"1aff26fc-e6d3-4135-96b9-0da7cb8b6dae"},{"index":13124,"token":false,"name":"Tidal Kraken","scryfallId":"569d1014-e04a-4f8d-a2b2-699b5be08d5d"},{"index":13126,"token":false,"name":"Akroan Hoplite","scryfallId":"695ccac5-c87e-49af-9131-8f1730e84bc0"},{"index":13129,"token":false,"name":"Naga Vitalist","scryfallId":"578349f0-44be-455f-9a75-010d4f5d0d27"},{"index":13130,"token":false,"name":"Tariff","scryfallId":"24333832-2a87-4810-9443-ec993468d103"},{"index":13131,"token":false,"name":"Righteous Blow","scryfallId":"b4501520-acf4-438f-9e96-4a649875ffdd"},{"index":13132,"token":false,"name":"Patagia Tiger","scryfallId":"be398100-89e2-432b-8017-74fb7e4dbc26"},{"index":13133,"token":false,"name":"Twilight Shepherd","scryfallId":"651e76ac-3ee0-4234-af7b-2d41b84dd351"},{"index":13134,"token":false,"name":"Daru Sanctifier","scryfallId":"38b14a24-c74a-4465-9b36-8f5309e0a333"},{"index":13135,"token":false,"name":"Cowl Prowler","scryfallId":"f372f545-b70c-470b-9aab-4a2ea900f777"},{"index":13136,"token":false,"name":"Colossus Hammer","scryfallId":"fa35b2b5-3e91-4a6c-90b1-8581b4ecaf8b"},{"index":13137,"token":false,"name":"Sirocco","scryfallId":"ce37492e-4f07-4171-97d4-84f28fb4e2be"},{"index":13138,"token":false,"name":"Veldt","scryfallId":"987534fb-74a9-46a3-805f-fe2fe2df4a90"},{"index":13139,"token":false,"name":"Torment of Scarabs","scryfallId":"d978129d-6811-4471-9d91-af969a3d5715"},{"index":13143,"token":false,"name":"Enduring Renewal","scryfallId":"be77edac-9a8b-4b7f-a859-27df76b10aa6"},{"index":13144,"token":false,"name":"Joven","scryfallId":"0dabe3af-cd5b-461e-95a4-aad046646419"},{"index":13147,"token":false,"name":"Crippling Fear","scryfallId":"0b82ca44-6c80-4220-bf41-76a62cd3459f"},{"index":13149,"token":false,"name":"Righteous Confluence","scryfallId":"69c14aa7-0c6c-426e-a14d-d6847b0633b4"},{"index":13150,"token":false,"name":"Unlicensed Disintegration","scryfallId":"74843584-d6b1-4ee6-bedb-999ab0a42bb9"},{"index":13151,"token":false,"name":"Misthollow Griffin","scryfallId":"30ce5bc6-cd22-4855-82b1-2a8c224e0764"},{"index":13155,"token":false,"name":"Phantasmal Mount","scryfallId":"75afdbe6-a3f9-49cf-b4ef-f370e518e960"},{"index":13156,"token":false,"name":"Clone Legion","scryfallId":"ecc8a1bb-60f4-44a3-b5f0-a2c004966b57"},{"index":13157,"token":false,"name":"Metamorphose","scryfallId":"a0f0c20c-184e-4d27-ae8b-933abb6fee0c"},{"index":13158,"token":false,"name":"Inner Calm, Outer Strength","scryfallId":"40f56817-aabf-469c-a82c-37315decc73c"},{"index":13160,"token":false,"name":"Glyph of Reincarnation","scryfallId":"a67e8214-a192-4143-9d5e-d0e254e1bf6e"},{"index":13161,"token":false,"name":"Hyperion Blacksmith","scryfallId":"44d499a9-fe7c-4a1a-9eb3-a7fd9f85ae08"},{"index":13163,"token":false,"name":"Implement of Malice","scryfallId":"94871f9d-173d-47bb-ae1d-fc8cee9ce083"},{"index":13164,"token":false,"name":"Frost Breath","scryfallId":"85d3f777-7660-48ae-8c32-6777ec8427d4"},{"index":13166,"token":false,"name":"Ixalli's Keeper","scryfallId":"e5b98537-abf4-46cb-853f-9561811ab439"},{"index":13170,"token":false,"name":"Riding the Dilu Horse","scryfallId":"56fe32f2-8967-4814-b43b-bdccd2019bdf"},{"index":13171,"token":false,"name":"Generous Patron","scryfallId":"59ea095b-af0e-4178-b6f4-816abb635fc0"},{"index":13172,"token":false,"name":"General Kudro of Drannith","scryfallId":"668c33c1-5d85-4db1-bde7-e582433a6845"},{"index":13173,"token":false,"name":"Discordant Dirge","scryfallId":"d48e753c-ba11-4aa3-9a73-584f8a7538f5"},{"index":13176,"token":false,"name":"Grollub","scryfallId":"47f6301a-d581-4aaf-9993-3013323074aa"},{"index":13177,"token":false,"name":"Daraja Griffin","scryfallId":"2f7afcaa-9df8-4dd6-89ad-bc2e15f1ec4b"},{"index":13178,"token":false,"name":"Darkheart Sliver","scryfallId":"3541ff31-0043-49a9-abac-77369f95b942"},{"index":13179,"token":false,"name":"Luminous Broodmoth","scryfallId":"9d1e5df5-fbfe-498e-89ee-2a7782d20a98"},{"index":13180,"token":false,"name":"Spincrusher","scryfallId":"b1269a34-cec6-4978-a109-592723cd80dc"},{"index":13181,"token":false,"name":"Scrivener","scryfallId":"ac6ccaeb-353a-4e40-8fe3-a88f7b20650f"},{"index":13182,"token":false,"name":"Remove Soul","scryfallId":"fd6bbb81-b830-4b22-be9a-852d9edbda21"},{"index":13183,"token":false,"name":"Possessed Aven","scryfallId":"997c56c7-c625-4209-b4b6-d274dee2db48"},{"index":13184,"token":false,"name":"Plague Reaver","scryfallId":"230b9bc8-29c8-49cb-b4f5-1aceeda8bf45"},{"index":13186,"token":false,"name":"Startling Development","scryfallId":"a12680db-957f-48c1-9062-2edd9115ba26"},{"index":13188,"token":false,"name":"Ritual of Rejuvenation","scryfallId":"691c0acb-1882-482f-9513-e7d010cc1d15"},{"index":13189,"token":false,"name":"Tocatli Honor Guard","scryfallId":"a3fc3501-e7bd-4589-98c5-4476258842ea"},{"index":13192,"token":false,"name":"Elesh Norn, Grand Cenobite","scryfallId":"78c2bfef-06a5-4c7f-8283-ea3fb673b7a1"},{"index":13193,"token":false,"name":"Rubble Reading","scryfallId":"8ace095a-3ea9-4121-8ffb-5b3612b96985"},{"index":13196,"token":false,"name":"Arachnus Spinner","scryfallId":"23321b80-d7e7-48fd-985d-1e9dc3adcd35"},{"index":13197,"token":false,"name":"Vines of Vastwood","scryfallId":"6203e3d4-8998-41d6-9f7e-b68af0f1f8b5"},{"index":13199,"token":false,"name":"Dark Offering","scryfallId":"2a39cf31-3cc2-4fe5-bb49-960c8d8b54fc"},{"index":13201,"token":false,"name":"Sift Through Sands","scryfallId":"077bde4d-4cdb-42db-acc5-441ed8fa4a5b"},{"index":13206,"token":false,"name":"Prismatic Lens","scryfallId":"eb3da3e2-fdef-4ff4-bef6-85e57dc4c56d"},{"index":13208,"token":true,"name":"Well-Read","scryfallId":"45f1e279-9306-45ac-8198-2da6672f452b"},{"index":13210,"token":false,"name":"Rolling Thunder","scryfallId":"5dd980d5-c6d1-4834-977b-22e80f0b449d"},{"index":13211,"token":false,"name":"Dimir Doppelganger","scryfallId":"a48be841-d35c-4d99-aebc-3684b36760ac"},{"index":13212,"token":false,"name":"Crimson Muckwader","scryfallId":"a0811f91-ed92-4a8e-badd-ae5054e7707d"},{"index":13213,"token":false,"name":"Sidar Jabari","scryfallId":"c6d7c16b-27f2-4608-bb79-c2edb86abdef"},{"index":13215,"token":false,"name":"Wirewood Herald","scryfallId":"f6c6476e-c406-451d-9d47-9d0d885f4cbb"},{"index":13216,"token":false,"name":"Heart of Yavimaya","scryfallId":"40c59cb9-559b-4716-9bd7-c818b3f46f1d"},{"index":13217,"token":false,"name":"Wandering Ones","scryfallId":"8f973d6b-4a34-4b0e-b092-ead05bf2e535"},{"index":13221,"token":true,"name":"Bat Token (B, 1/2)","scryfallId":"4c532e0f-8934-4ad3-bb1a-640abe946e10"},{"index":13222,"token":false,"name":"Tar Pit Warrior","scryfallId":"e1283190-094e-4a9f-bf67-f9fd05778744"},{"index":13227,"token":false,"name":"Cephalid Scout","scryfallId":"6efdf190-970d-4751-b214-cd962f7f2ca8"},{"index":13229,"token":false,"name":"Prakhata Club Security","scryfallId":"c46da57d-bcb9-4303-aa1c-72d08bb2b5a8"},{"index":13230,"token":false,"name":"Distant Melody","scryfallId":"0db49f7f-1790-435a-a75a-59129fa1cf97"},{"index":13232,"token":false,"name":"Graf Harvest","scryfallId":"fbc17697-9db9-41d4-aacf-b2f2e6ff80cf"},{"index":13233,"token":false,"name":"Talisman of Dominance","scryfallId":"43ec73b2-4215-4e30-ad6d-1764879030f4"},{"index":13235,"token":false,"name":"Selesnya Sagittars","scryfallId":"9a72e933-d977-4be9-985f-8b8cf1267f8c"},{"index":13236,"token":false,"name":"Bloodied Ghost","scryfallId":"c68b6fc7-e565-4f7d-8efb-c4d29e41c689"},{"index":13239,"token":false,"name":"Kinnan, Bonder Prodigy","scryfallId":"93fd24a9-6b17-4e82-a683-9e35be514fbd"},{"index":13247,"token":false,"name":"Cinder Crawler","scryfallId":"a9406050-d76b-4569-a463-e21acaf84166"},{"index":13258,"token":false,"name":"Grisly Spectacle","scryfallId":"434fec21-1338-4f5b-91aa-91be81bf6e5c"},{"index":13259,"token":false,"name":"Pincher Beetles","scryfallId":"74bf9529-43de-4e94-87f4-75546c138b2c"},{"index":13260,"token":false,"name":"Keeper of the Dead","scryfallId":"6b641171-35bc-4945-ada9-3ea28ea9fabf"},{"index":13261,"token":false,"name":"Lathril, Blade of the Elves","scryfallId":"547888c3-a9a6-4413-b29a-6bcd8a9279bf"},{"index":13262,"token":false,"name":"Abbey Gargoyles","scryfallId":"b1fe1429-d008-4a41-b16f-b823d5979026"},{"index":13267,"token":false,"name":"Shapeshifter","scryfallId":"649dadb0-bff4-47fd-b110-6228d90b526b"},{"index":13270,"token":false,"name":"Shake the Foundations","scryfallId":"b5bd4bdd-3a2a-40d9-9f86-fefe0a462cd2"},{"index":13271,"token":false,"name":"Putrefaction","scryfallId":"65104b23-58a6-41c0-b887-90a3fb959289"},{"index":13273,"token":false,"name":"Guul Draz Assassin","scryfallId":"b3cd4451-d872-4027-800c-62a9c607f89f"},{"index":13274,"token":false,"name":"Josu Vess, Lich Knight","scryfallId":"e4db6011-26e8-46d8-bf04-790a2988ce1d"},{"index":13275,"token":false,"name":"Pathmaker Initiate","scryfallId":"4535c643-7a2d-401b-8c2b-ac7fd6f594b8"},{"index":13277,"token":false,"name":"Tribal Unity","scryfallId":"f1379753-0a37-4e33-ac46-8ef33cb98b06"},{"index":13278,"token":false,"name":"Daru Warchief","scryfallId":"2630d3b5-8f3a-4aad-a45e-22a7979429f3"},{"index":13281,"token":false,"name":"Sire of the Storm","scryfallId":"2e76d003-2d15-43d7-9cbb-e00564d0cabf"},{"index":13284,"token":false,"name":"Buried Ruin","scryfallId":"da65afdc-a994-44cb-83f9-6e7f0f3ab2f1"},{"index":13285,"token":false,"name":"Molten Birth","scryfallId":"0cd182be-1604-47e1-858f-3c304fd0ee63"},{"index":13287,"token":false,"name":"Solemn Simulacrum","scryfallId":"a2df1622-bfdc-405f-bbd9-f03fe4acd347"},{"index":13290,"token":false,"name":"Goblin Berserker","scryfallId":"a3c7635d-98b2-4505-9153-d7e9e53ea16d"},{"index":13291,"token":false,"name":"Frontier Siege","scryfallId":"5e7ee5ff-eabc-4947-b5fe-2647c7e2eb82"},{"index":13293,"token":false,"name":"Shadrix Silverquill","scryfallId":"23468e63-2e7a-4e3b-970c-cb57b067d6c1"},{"index":13294,"token":false,"name":"Heliod's Intervention","scryfallId":"6c0674c3-4e6c-4dbb-a4b0-a5607fcfc3f1"},{"index":13295,"token":false,"name":"Simic Keyrune","scryfallId":"d039aae6-38f5-42b5-a530-e0dd03abc7d5"},{"index":13296,"token":false,"name":"Funeral Rites","scryfallId":"30aa6796-0cb6-426b-9e3f-4d7e4959a6a4"},{"index":13298,"token":false,"name":"Reviving Dose","scryfallId":"15b3dd79-ac4c-4ffc-9442-1efa0082f60f"},{"index":13299,"token":false,"name":"Costly Plunder","scryfallId":"c3f1f41e-98fc-4f6b-b287-c8899dff8ab0"},{"index":13300,"token":false,"name":"Herald of Leshrac","scryfallId":"ad6080b1-b032-4172-8594-4d894a60a80d"},{"index":13306,"token":false,"name":"Aim High","scryfallId":"98cd33cc-df39-4db1-a4a0-09756ec8372c"},{"index":13307,"token":false,"name":"Kor Blademaster","scryfallId":"fc6d6049-5599-47eb-ae58-a8eb96927ece"},{"index":13308,"token":false,"name":"Flame-Kin Zealot","scryfallId":"fe7db99b-903f-43d8-bc60-cab2d914a0cb"},{"index":13310,"token":false,"name":"Skullbriar, the Walking Grave","scryfallId":"69dad154-2616-4bd6-8448-0e0458ee136d"},{"index":13311,"token":false,"name":"Tidebinder Mage","scryfallId":"f6ed9fb1-de68-46ae-88d0-b3b4cd0e381e"},{"index":13315,"token":false,"name":"Zephyr Falcon","scryfallId":"662d49c3-6f47-4106-b473-869392f9de05"},{"index":13316,"token":false,"name":"Esperzoa","scryfallId":"7269b26a-058c-4a5c-aadf-733ea60f3de0"},{"index":13318,"token":false,"name":"Honor the God-Pharaoh","scryfallId":"75844d13-74f5-4008-9bc6-2f6d04f378aa"},{"index":13319,"token":false,"name":"Stormtide Leviathan","scryfallId":"a0fde11c-ee26-4005-87f0-300f2be838fc"},{"index":13323,"token":false,"name":"Homing Lightning","scryfallId":"d6535816-8fa4-4c8b-8677-ac80f769f528"},{"index":13324,"token":false,"name":"Serene Heart","scryfallId":"aff19d9d-8069-4f8d-a81b-e2fcd94c13b3"},{"index":13325,"token":false,"name":"Kazuul Warlord","scryfallId":"da42df13-eded-48e2-ad1a-ff74d718ce3c"},{"index":13327,"token":false,"name":"Skatewing Spy","scryfallId":"ef4a517c-515b-4adc-8ea6-fb86820f22ed"},{"index":13332,"token":false,"name":"Nearheath Pilgrim","scryfallId":"d81d6fe0-c7c2-46a6-811c-f121284937ea"},{"index":13333,"token":false,"name":"Loxodon Stalwart","scryfallId":"7ed3a28f-01bb-4ddf-8427-ed9f43e6e17b"},{"index":13334,"token":false,"name":"Into the North","scryfallId":"c6a52be0-79c2-4aa1-b909-2cc0fbbdf1f7"},{"index":13336,"token":false,"name":"Summoner's Pact","scryfallId":"ee0f88ac-8a90-4057-b0e6-c15fbd02da38"},{"index":13338,"token":false,"name":"Facet Reader","scryfallId":"b1199596-ae77-4192-ae70-3e2ebd009b64"},{"index":13339,"token":false,"name":"Tithe Drinker","scryfallId":"3f252d54-33c9-4f88-8f07-bb920adc0cdc"},{"index":13340,"token":false,"name":"Krenko, Mob Boss","scryfallId":"36aef540-1565-4f03-a01a-a51eb8cd1f0f"},{"index":13341,"token":false,"name":"Pheres-Band Warchief","scryfallId":"8456730a-607c-44c0-b18e-0df8f35b0634"},{"index":13343,"token":false,"name":"Dovin Baan","scryfallId":"4da08e91-54d4-4fff-9cc8-4e3c2515d3bf"},{"index":13345,"token":true,"name":"Voja, Friend to Elves Token (G/W, 3/3)","scryfallId":"39475e91-1e71-4546-ae4a-47ea66e47536"},{"index":13346,"token":false,"name":"Sudden Edict","scryfallId":"57cc8aeb-221d-46a1-b03f-df8499bba26d"},{"index":13347,"token":false,"name":"Greenwheel Liberator","scryfallId":"23b7a17d-f8b5-4c35-a16c-ece5834ea292"},{"index":13349,"token":false,"name":"Syphon Soul","scryfallId":"f3020304-7a39-411e-b055-3ade72b4bff8"},{"index":13350,"token":false,"name":"Soul's Majesty","scryfallId":"50f6f3b7-96d6-489b-b55c-1304e627e190"},{"index":13351,"token":false,"name":"Teysa Karlov","scryfallId":"247de9ae-802f-4f3d-a33e-7bc9af24b8c8"},{"index":13352,"token":false,"name":"Emeria Shepherd","scryfallId":"2eb942b5-fe9e-4619-97e5-48bd784354a2"},{"index":13353,"token":false,"name":"River Merfolk","scryfallId":"e61b64e7-2516-4132-b9a8-06da93ff6ac7"},{"index":13358,"token":false,"name":"Keruga, the Macrosage","scryfallId":"c5e30d11-184b-4d2a-82b4-b594cc269f4c"},{"index":13359,"token":false,"name":"Spellskite","scryfallId":"59cf65d1-15c7-4d45-ae36-85e915fedcc0"},{"index":13363,"token":false,"name":"The Unspeakable","scryfallId":"5212bd3e-e8d8-483e-871b-29fd378f817e"},{"index":13366,"token":false,"name":"Spike Hatcher","scryfallId":"1f79fb79-37a0-483f-ba19-853cbfffc73d"},{"index":13367,"token":false,"name":"Linvala, Shield of Sea Gate","scryfallId":"49b66956-82e1-402f-9088-2201bdc0d4b8"},{"index":13370,"token":false,"name":"Drooling Ogre","scryfallId":"2036745a-09ea-476f-ace6-1d06b8502f83"},{"index":13372,"token":false,"name":"Panic","scryfallId":"97a86ee4-200e-4994-bd6f-0c1d3227ce5b"},{"index":13373,"token":false,"name":"Hymn of Rebirth","scryfallId":"61d0f2f2-f6e2-4b8a-8418-10b17c5e0ea9"},{"index":13374,"token":false,"name":"Riptide Laboratory","scryfallId":"25a9cb87-e572-4885-8561-1d4b158ec7e4"},{"index":13378,"token":false,"name":"See Beyond","scryfallId":"a7242e6e-b2e6-42f5-b611-3e8e0dfc0b6b"},{"index":13379,"token":false,"name":"Fae Offering","scryfallId":"9de8307a-7da3-4a4c-98dc-d6624b1f869d"},{"index":13380,"token":false,"name":"Profit // Loss","scryfallId":"0eb3ce46-ddd2-43b3-9e45-019ae91df686"},{"index":13381,"token":false,"name":"Golgari Raiders","scryfallId":"37284ba8-441c-4cf6-95c6-6a0f52e6d36d"},{"index":13384,"token":false,"name":"Grafdigger's Cage","scryfallId":"a5f25a6e-c98c-45e9-857f-c9fbfe7867bb"},{"index":13385,"token":false,"name":"Steeple Roc","scryfallId":"5fecafab-97f4-40ed-bc43-d186eb2f3af6"},{"index":13389,"token":false,"name":"Joraga Warcaller","scryfallId":"650200df-4408-4d2c-97b0-ef4cd744196c"},{"index":13390,"token":false,"name":"Mire Boa","scryfallId":"4ab20019-d4b7-4bbb-b258-c9cc14bf2b3a"},{"index":13393,"token":false,"name":"Scroll Thief","scryfallId":"19bc4f11-98d3-4f71-a50f-24eddd551147"},{"index":13394,"token":false,"name":"Scarecrow","scryfallId":"93850e74-744c-4261-a84e-01eaced6e49a"},{"index":13395,"token":false,"name":"Nahiri, the Harbinger","scryfallId":"ddbecd25-250e-4a49-b007-698b36551254"},{"index":13396,"token":false,"name":"Hewed Stone Retainers","scryfallId":"250bc19c-b882-42ae-b516-fe876d0d047d"},{"index":13398,"token":false,"name":"Indebted Samurai","scryfallId":"bb03bc2b-6d39-4315-964c-ca7db2db054a"},{"index":13399,"token":false,"name":"Inner-Chamber Guard","scryfallId":"4d34bfb9-abc7-4469-9546-aa8988da8259"},{"index":13400,"token":false,"name":"Chainer's Torment","scryfallId":"f42beafb-2fba-482c-a86a-7d668fa7cb4b"},{"index":13403,"token":false,"name":"Depose // Deploy","scryfallId":"ab0ba4ef-9e82-4177-a80f-8fa6f6a5bd60"},{"index":13405,"token":false,"name":"Balm of Restoration","scryfallId":"7f95de4a-7fae-42bc-9660-39ea7685ca02"},{"index":13409,"token":false,"name":"Genesis Chamber","scryfallId":"93bd7e73-63dc-45b2-aaa8-984be8b900ab"},{"index":13411,"token":false,"name":"Undergrowth","scryfallId":"7b07df91-49be-4a50-9d3b-ddde0e6c1be9"},{"index":13412,"token":false,"name":"Benalish Lancer","scryfallId":"3a38d40a-e745-4fee-b179-f8c27e9b2fbd"},{"index":13415,"token":false,"name":"Charging Griffin","scryfallId":"d86bd259-bc2f-402c-9e7a-030f9a3781e2"},{"index":13418,"token":false,"name":"Makindi Stampede // Makindi Mesas","scryfallId":"ada9a974-8f1f-4148-bd61-200fc14714b2"},{"index":13421,"token":false,"name":"Barrage of Boulders","scryfallId":"2eb1a9f7-32ba-48fd-a7f7-788b0ec052c6"},{"index":13426,"token":false,"name":"Echo Chamber","scryfallId":"06425615-6c10-4766-8128-a1a09a35649d"},{"index":13428,"token":false,"name":"Sunspear Shikari","scryfallId":"20ac29ef-02e1-4500-bb83-5987beeaa849"},{"index":13429,"token":false,"name":"Conquering Manticore","scryfallId":"95f5bf3f-3fa7-47db-981b-933cdb505398"},{"index":13430,"token":false,"name":"Faerie Invaders","scryfallId":"5546fbd6-908d-46be-8d17-9470842f78a7"},{"index":13431,"token":false,"name":"Urabrask the Hidden","scryfallId":"b3a660f8-e583-4442-90d6-2b270cb4ff91"},{"index":13432,"token":false,"name":"Inkmoth Nexus","scryfallId":"0ff1104e-ee09-4d5f-a7a8-81aba56f9d4b"},{"index":13434,"token":false,"name":"Masumaro, First to Live","scryfallId":"2c4625b7-c8b1-4fdf-af9f-935313436b35"},{"index":13436,"token":false,"name":"Soulreaper of Mogis","scryfallId":"55e2f383-d2a0-4424-bf7a-79e82d6f691f"},{"index":13437,"token":false,"name":"Culmination of Studies","scryfallId":"1f198c49-9192-4b7f-bbc6-9f01395836f2"},{"index":13440,"token":false,"name":"Sutured Ghoul","scryfallId":"8390d9b7-5adf-4039-8682-02bfba421ff9"},{"index":13443,"token":false,"name":"Charging Paladin","scryfallId":"851f3f72-2923-4432-898a-02679a8b320f"},{"index":13444,"token":false,"name":"Starke of Rath","scryfallId":"a0f063fc-f1c4-4f3c-a72b-5f446d0c6381"},{"index":13445,"token":false,"name":"Vitu-Ghazi Guildmage","scryfallId":"275a3199-1297-4281-a95c-374bcdc198ce"},{"index":13447,"token":false,"name":"Blinding Flare","scryfallId":"e07f43b6-e07f-4d0c-90d2-e5b0d23ba0f9"},{"index":13450,"token":false,"name":"River Boa","scryfallId":"390dc916-2207-4a76-a886-13fe47496a4a"},{"index":13451,"token":false,"name":"Sudden Spoiling","scryfallId":"acfcf183-9c87-4a62-988c-3bedc9d87c12"},{"index":13452,"token":false,"name":"Reason // Believe","scryfallId":"1c000d66-500f-4a3b-bb6f-13a56f303869"},{"index":13455,"token":false,"name":"Triton Shorestalker","scryfallId":"d86d8c25-016b-4607-a3f7-01f7b3158a24"},{"index":13457,"token":false,"name":"Lightning Surge","scryfallId":"0452d78d-eafc-4ccb-a478-d1f46bcefffe"},{"index":13460,"token":false,"name":"Frantic Salvage","scryfallId":"aff909bc-0bda-4e8a-b7a3-ebc963552246"},{"index":13462,"token":false,"name":"Shapers of Nature","scryfallId":"7aa682fb-f5b6-41c1-9428-6043b0b76744"},{"index":13465,"token":false,"name":"Iceberg","scryfallId":"dcb32615-4a97-4196-8c8c-3cd2748e74ea"},{"index":13466,"token":false,"name":"Acolyte of Affliction","scryfallId":"a14afed6-ca42-442d-ba86-621179e6957c"},{"index":13469,"token":false,"name":"Frilled Sea Serpent","scryfallId":"0e82bd0d-647f-42bd-b6d2-9a5d2a7bcd2f"},{"index":13474,"token":false,"name":"Elemental Augury","scryfallId":"62bbff2a-5109-400a-961b-eacffb9aed67"},{"index":13477,"token":false,"name":"Elbrus, the Binding Blade // Withengar Unbound","scryfallId":"a66d5ee9-86a7-4052-a868-8dc6398342b3"},{"index":13478,"token":false,"name":"Arachnoid","scryfallId":"836d5ce6-d5c9-4fb5-8302-53d25b5531b5"},{"index":13482,"token":false,"name":"Inspiring Veteran","scryfallId":"0c3f372d-259d-4a31-9491-2d369b3f3f8b"},{"index":13486,"token":false,"name":"Thunder Dragon","scryfallId":"65e29b11-c25f-4230-a697-431284b0e487"},{"index":13489,"token":false,"name":"Pious Evangel // Wayward Disciple","scryfallId":"7ac2a5aa-71c3-482b-9431-5f0b228cf64d"},{"index":13490,"token":true,"name":"Discarding","scryfallId":"e05a2980-8541-40b1-9504-c28cb4dd2466"},{"index":13493,"token":false,"name":"Thoughtrender Lamia","scryfallId":"69799971-6e24-4b90-ba72-44c6393fc3c4"},{"index":13499,"token":false,"name":"Cloudgoat Ranger","scryfallId":"6dfaa74a-0ef0-44bb-b8b5-6d121278b5a2"},{"index":13500,"token":false,"name":"Dwarven Hold","scryfallId":"a3142ded-ff62-4817-aa54-75a7ea4498a6"},{"index":13502,"token":false,"name":"Driven // Despair","scryfallId":"f7020563-0701-4cd0-9a78-1568a23bf02d"},{"index":13503,"token":false,"name":"Skull Storm","scryfallId":"abba6778-5f78-4716-b149-e12dbda2c771"},{"index":13506,"token":false,"name":"Serra's Boon","scryfallId":"881aae7e-1458-4b0c-b991-82ed93f7932a"},{"index":13508,"token":false,"name":"Triton Tactics","scryfallId":"9106bb1b-ea17-4da7-89d2-da856059c5bc"},{"index":13512,"token":false,"name":"Sekki, Seasons' Guide","scryfallId":"9883e973-54c3-4bec-91d8-22f2829cdfa2"},{"index":13513,"token":false,"name":"Ever-Watching Threshold","scryfallId":"b711a0aa-90e5-4f16-9dc3-9cc331fc3101"},{"index":13516,"token":false,"name":"Unsubstantiate","scryfallId":"8b184d7e-46ae-450e-9228-eb605ac3ad41"},{"index":13518,"token":false,"name":"Biomantic Mastery","scryfallId":"8d63d4b7-5378-4ba9-9a5f-3ab385d83568"},{"index":13519,"token":false,"name":"Wharf Infiltrator","scryfallId":"ceaa1e02-b11b-4f30-9f8b-2e735309dcb9"},{"index":13524,"token":false,"name":"Shed Weakness","scryfallId":"81803f44-6260-4df9-b566-2a2694d4deb0"},{"index":13525,"token":false,"name":"Changeling Outcast","scryfallId":"08151d00-513a-4957-aa16-01c0f0245112"},{"index":13527,"token":false,"name":"Samurai of the Pale Curtain","scryfallId":"ead15cf8-f692-4cb9-ac86-0dff00236145"},{"index":13530,"token":false,"name":"Holy Mantle","scryfallId":"95567596-c5b1-426f-bc2c-43306f7221b0"},{"index":13534,"token":false,"name":"Eye of Yawgmoth","scryfallId":"9c258aa1-cd9f-45e9-b478-d689b78850cd"},{"index":13535,"token":false,"name":"Night Market Guard","scryfallId":"8ae03e5c-9655-425c-90ef-b70a0e66868d"},{"index":13536,"token":false,"name":"Needleshot Gourna","scryfallId":"f9b1628d-aacd-4e19-9ebb-bcd9b2842c91"},{"index":13537,"token":false,"name":"Goblin Furrier","scryfallId":"4f8ec9c1-da73-44fb-9e30-5279a7ed4e7e"},{"index":13542,"token":false,"name":"Words of Waste","scryfallId":"d2dcb8ed-23e7-4cee-9f43-042232c6035a"},{"index":13543,"token":false,"name":"Bosk Banneret","scryfallId":"203f41a7-ecf5-4757-9162-01ffd2a42ee9"},{"index":13546,"token":false,"name":"Force Void","scryfallId":"226555ba-22af-45f1-a3f4-d265f8685dd5"},{"index":13548,"token":false,"name":"Confounding Conundrum","scryfallId":"ddd0134c-627c-40f5-bd02-13be69d028a1"},{"index":13549,"token":false,"name":"Krosan Warchief","scryfallId":"7a15c7e0-6b00-4947-a7f0-24d91c9b77eb"},{"index":13550,"token":false,"name":"Alharu, Solemn Ritualist","scryfallId":"58ee8919-65f7-475c-972a-36d9c8d063fc"},{"index":13551,"token":false,"name":"Carrion Imp","scryfallId":"958caf1d-b159-4c27-8248-00c345f880be"},{"index":13552,"token":false,"name":"Blitz of the Thunder-Raptor","scryfallId":"a0174556-9f9b-4756-84ca-d14a5a60720c"},{"index":13553,"token":false,"name":"Rite of Ruin","scryfallId":"89e7fec3-94b5-411e-aeb0-44a64f517986"},{"index":13559,"token":false,"name":"Die Young","scryfallId":"165b937f-1f01-4312-a86c-938d2e301131"},{"index":13560,"token":false,"name":"Acidic Soil","scryfallId":"790157c9-b1ed-4da5-9d50-e99e0dd807b7"},{"index":13561,"token":false,"name":"Nalathni Dragon","scryfallId":"7f9c6be5-ec44-4c66-aad6-cf9eca765b6b"},{"index":13564,"token":false,"name":"Jace's Projection","scryfallId":"c4d35a34-01b7-41e1-8491-a6589175d027"},{"index":13572,"token":false,"name":"Rhonas's Stalwart","scryfallId":"1fff6268-03b1-409f-a0b1-8886a751ac18"},{"index":13573,"token":false,"name":"Master Biomancer","scryfallId":"32ed38e8-c7eb-4ec8-9bde-a37639fafe45"},{"index":13574,"token":false,"name":"Lithoform Blight","scryfallId":"5b36d12e-9a68-4d3d-92e8-9840cd5320bc"},{"index":13577,"token":false,"name":"Indrik Stomphowler","scryfallId":"09267a0b-025e-4caa-bba2-a6e0e01378a5"},{"index":13580,"token":false,"name":"Call for Unity","scryfallId":"eeca4557-98aa-433b-a3ee-050e4a3e6d88"},{"index":13582,"token":false,"name":"Foulmire Knight // Profane Insight","scryfallId":"fe264b37-ff86-4f53-b8f7-37ebc2ce86de"},{"index":13584,"token":false,"name":"Rootbreaker Wurm","scryfallId":"9a686ed6-fc13-4882-b56c-667f556d9804"},{"index":13586,"token":false,"name":"Sedraxis Alchemist","scryfallId":"7fbbc5d7-86d0-4e09-b37c-e40eb88f3f33"},{"index":13590,"token":false,"name":"Ephemeral Shields","scryfallId":"c92b6e0a-3bfa-405e-8960-fb42bb88a736"},{"index":13592,"token":false,"name":"Shard Convergence","scryfallId":"285beca0-4876-426f-a4b4-ecefe79ad55d"},{"index":13593,"token":false,"name":"Might of the Masses","scryfallId":"9900f47d-e1ec-411d-92f3-aed8e01ee535"},{"index":13594,"token":false,"name":"Angel of Mercy","scryfallId":"dac5c913-4eb5-4cfb-9c24-223f14f07064"},{"index":13595,"token":false,"name":"Psychic Allergy","scryfallId":"fec3275e-4491-43a8-9f23-d7b48177c103"},{"index":13596,"token":false,"name":"Serendib Djinn","scryfallId":"0458b733-d689-4cb5-8970-3b675c67fc4d"},{"index":13598,"token":false,"name":"Eager Construct","scryfallId":"66f8ae7b-02a5-45ce-8a63-aa880b1e582a"},{"index":13599,"token":false,"name":"Rathi Dragon","scryfallId":"7df61bff-a459-4ddb-a084-f47859a43795"},{"index":13600,"token":false,"name":"Primal Bellow","scryfallId":"23b0c6a9-a7c0-4518-8580-653712062265"},{"index":13601,"token":false,"name":"Coretapper","scryfallId":"bbeaca72-aadd-4ef8-939a-36f320100e6e"},{"index":13604,"token":false,"name":"Mindwarper","scryfallId":"ebe796e1-97f9-469a-a6b6-a09161058e12"},{"index":13607,"token":false,"name":"Arixmethes, Slumbering Isle","scryfallId":"881607c8-bfe7-4903-861f-b51a5a332c17"},{"index":13608,"token":false,"name":"Imperiosaur","scryfallId":"b6d0f09b-cab8-42d8-ac93-1fd7c1244560"},{"index":13610,"token":false,"name":"Bloodstained Mire","scryfallId":"81216384-83f9-4fc0-9393-207bea6fd8b4"},{"index":13611,"token":false,"name":"Selesnya Cluestone","scryfallId":"34ad5631-439a-43e2-b00a-04f78d66b8e6"},{"index":13612,"token":false,"name":"Burning Inquiry","scryfallId":"5b5f03d2-608c-4fae-9a05-1695e277adf8"},{"index":13613,"token":false,"name":"Masterwork of Ingenuity","scryfallId":"09686fb3-ae0f-481a-aee6-3fd75fa43557"},{"index":13614,"token":false,"name":"Swab Goblin","scryfallId":"0403b8e5-29c5-4a4a-b9e7-1e79a7452f14"},{"index":13615,"token":false,"name":"Feline Sovereign","scryfallId":"fbea5a3c-03b7-44da-b8f7-534a962b8e1e"},{"index":13616,"token":false,"name":"Amber Prison","scryfallId":"db90a5e7-8238-442a-a6a4-78c59a6adb3d"},{"index":13619,"token":false,"name":"Angel of Deliverance","scryfallId":"870668b9-96b6-4216-97c0-b48078224c64"},{"index":13620,"token":false,"name":"Assassin's Strike","scryfallId":"9aacb3ae-c889-4912-bc2d-2aa0adfd20bd"},{"index":13622,"token":true,"name":"Dogs","scryfallId":"a5d3bb88-4c15-4205-a4a1-d7b0b79e7ada"},{"index":13624,"token":false,"name":"Sudden Reclamation","scryfallId":"2ac7645d-ea10-4ca6-92a5-ac3418c6a510"},{"index":13625,"token":false,"name":"Dark Maze","scryfallId":"d3d68a76-c843-4c67-90a7-2f79295798d0"},{"index":13628,"token":false,"name":"Cindervines","scryfallId":"9f970f79-3051-4ba1-badb-697ef321cbb3"},{"index":13629,"token":false,"name":"Seeker of the Way","scryfallId":"cc6b2f8b-8fac-4483-b560-4ede70ff7010"},{"index":13630,"token":false,"name":"Aethertorch Renegade","scryfallId":"e5c443e1-fd13-4627-85a9-8e9a340a2786"},{"index":13631,"token":false,"name":"Merfolk Skydiver","scryfallId":"2bf211eb-837b-4c02-b02e-8d9e62f1abb1"},{"index":13634,"token":false,"name":"Last Gasp","scryfallId":"c8b51876-3a4b-4af5-b1a2-3e54162d423f"},{"index":13636,"token":false,"name":"Valakut Exploration","scryfallId":"6954cc66-ab80-4457-b0da-61d80e80e25e"},{"index":13640,"token":false,"name":"The Elderspell","scryfallId":"0ddebc3e-230c-4072-995d-4b25e6c1a017"},{"index":13642,"token":false,"name":"Collision // Colossus","scryfallId":"9bd15da6-2b86-4dba-951d-318c7d9a5dde"},{"index":13643,"token":false,"name":"Venerable Warsinger","scryfallId":"d7f5d466-c91c-452a-bad4-a56fe02549d4"},{"index":13644,"token":false,"name":"Iron Myr","scryfallId":"5bd0a588-b695-4060-b5d5-c6a74710ff0f"},{"index":13645,"token":false,"name":"Youthful Valkyrie","scryfallId":"ffe93b27-f8ae-4abf-8ade-90f503f132c2"},{"index":13646,"token":false,"name":"Sentry of the Underworld","scryfallId":"018a9c98-1cb4-4c53-a765-c15808c4ab44"},{"index":13650,"token":false,"name":"Amugaba","scryfallId":"8d73d1e7-79be-4b28-a480-b65b4f34f755"},{"index":13653,"token":false,"name":"Silvergill Adept","scryfallId":"9e07a38a-2d88-4b01-9634-f24cbc8d96d6"},{"index":13655,"token":false,"name":"Immolating Glare","scryfallId":"2f468338-bb66-4db0-a883-69095566092b"},{"index":13657,"token":false,"name":"Manaweft Sliver","scryfallId":"1216b0b3-4f59-4e81-aaea-1b272e2b7c4e"},{"index":13659,"token":false,"name":"Highland Game","scryfallId":"4ec59964-42c1-4c29-8c60-37b7f376c347"},{"index":13661,"token":false,"name":"Heartless Hidetsugu","scryfallId":"46f9aa1d-7ed1-498e-9cdd-45ed4c9e6f43"},{"index":13662,"token":false,"name":"Evernight Shade","scryfallId":"1091fadf-97c4-4f87-8466-6a1246a72226"},{"index":13664,"token":false,"name":"Heavy Fog","scryfallId":"499fee7b-1942-4eb9-b1d0-806a1f6c0cd8"},{"index":13669,"token":false,"name":"Hexdrinker","scryfallId":"89f5cc05-5d9d-4709-b3c5-a6249c294acc"},{"index":13671,"token":false,"name":"Gallows at Willow Hill","scryfallId":"8a840ee7-5728-4b1b-92ac-54612e5397b3"},{"index":13673,"token":false,"name":"Bee Sting","scryfallId":"ee668507-a903-47ed-834f-fe6247db0542"},{"index":13676,"token":false,"name":"Selesnya Locket","scryfallId":"ea0c04b9-c7fc-4204-9af2-5d1987bdd97e"},{"index":13677,"token":false,"name":"Blessing","scryfallId":"4273cf50-db65-4b1f-95e1-f24ba6582c8b"},{"index":13680,"token":false,"name":"Pouncing Cheetah","scryfallId":"5803f4d8-4d8e-46d6-83c8-c53b38c8c140"},{"index":13684,"token":false,"name":"Caller of the Claw","scryfallId":"01c3d747-fdc4-4833-a3c4-28d5069b80d5"},{"index":13686,"token":false,"name":"Silkweaver Elite","scryfallId":"d10938c8-6fc4-495f-912a-1d3f12278f78"},{"index":13688,"token":false,"name":"Aid from the Cowl","scryfallId":"565cb7fc-cf90-4020-84fe-05ec7b18709d"},{"index":13689,"token":false,"name":"Excise","scryfallId":"8d4f97dd-434b-4156-8e9d-253a943784e3"},{"index":13691,"token":false,"name":"Pollen Remedy","scryfallId":"9797c813-0cda-44ad-ae41-330e9bde9cb9"},{"index":13693,"token":false,"name":"Bubbling Cauldron","scryfallId":"9af87c24-a534-462b-968b-dccf6ac63299"},{"index":13697,"token":false,"name":"Arena","scryfallId":"e5b7afa9-e07a-4a84-a41f-7a8bc5c1d274"},{"index":13698,"token":false,"name":"Oak Street Innkeeper","scryfallId":"08274d1b-52b7-46c1-8f93-7631d2e21def"},{"index":13699,"token":false,"name":"Syphon Flesh","scryfallId":"4141ea12-1ef6-4a8f-bd52-b4c69da00a31"},{"index":13701,"token":false,"name":"Footbottom Feast","scryfallId":"fc04f820-9505-4ccd-98e7-1bb861161af5"},{"index":13702,"token":false,"name":"Orochi Leafcaller","scryfallId":"f6c39031-1c49-4c1e-83df-66c3795ddc72"},{"index":13703,"token":false,"name":"Kwende, Pride of Femeref","scryfallId":"4def5e17-f695-4c4b-84fb-42bc8880a1f9"},{"index":13705,"token":false,"name":"Magmatic Sinkhole","scryfallId":"61f8ba6c-1fc9-42c5-94ea-1ee495fa4090"},{"index":13707,"token":false,"name":"Brazen Buccaneers","scryfallId":"b4bdfdaf-a0ce-4c0b-a3ce-d648877bdd36"},{"index":13710,"token":false,"name":"Obsidian Fireheart","scryfallId":"49ef5a91-d293-468a-8816-b16ca4ba79e0"},{"index":13712,"token":false,"name":"Field Research","scryfallId":"a48c3a2f-678b-4e70-a53f-258457d88d29"},{"index":13713,"token":false,"name":"Eladamri's Call","scryfallId":"42936b12-df0c-4332-a91f-2da2acc36dd7"},{"index":13714,"token":false,"name":"Oracle en-Vec","scryfallId":"cc538730-c46c-4e5f-bc1f-0efb7765086d"},{"index":13715,"token":false,"name":"Overblaze","scryfallId":"97040b82-ad9e-4c06-a9ac-74d0688279f9"},{"index":13717,"token":false,"name":"Galepowder Mage","scryfallId":"2a02121b-725b-4b1f-aee4-df5f9c4bbed7"},{"index":13719,"token":true,"name":"Construct Token (Colorless, 0/0)","scryfallId":"a7caaf39-8f16-4f1d-bee6-a45674306319"},{"index":13724,"token":false,"name":"Skirk Commando","scryfallId":"24506c97-b693-4ce9-a458-7bcb201592d0"},{"index":13725,"token":false,"name":"Mirran Mettle","scryfallId":"edbb5778-fa9a-4a1f-be4f-627630c3e3ca"},{"index":13726,"token":false,"name":"Arcane Artisan","scryfallId":"6b2441e0-06f6-4455-8fa8-a34c3e241a56"},{"index":13727,"token":false,"name":"Scarab of the Unseen","scryfallId":"d5da1c71-6059-4e4e-933d-dbca1cc4bd15"},{"index":13728,"token":false,"name":"Brago's Representative","scryfallId":"bfa2b59c-eaeb-4946-80e0-f937a206aa0c"},{"index":13737,"token":false,"name":"Phytoburst","scryfallId":"7507afc4-f504-4eb2-a86d-f99bc2860838"},{"index":13738,"token":false,"name":"Temple Altisaur","scryfallId":"fa8f8d61-51d6-479b-a812-6cbacc7ea1fc"},{"index":13739,"token":false,"name":"Pouncing Shoreshark","scryfallId":"c859b339-b55b-41fe-948c-27502e3b3ea8"},{"index":13740,"token":false,"name":"Flourishing Defenses","scryfallId":"6223f5d6-83f1-454e-9cd5-aba157850430"},{"index":13741,"token":false,"name":"Seraphic Greatsword","scryfallId":"ff9b6e59-8e95-413d-825e-f1dc8874eaa9"},{"index":13744,"token":false,"name":"Crystalline Giant","scryfallId":"8e5b4c21-342f-4b46-86bb-8e8f38659f82"},{"index":13745,"token":false,"name":"Allied Strategies","scryfallId":"51d4f211-10e8-486d-b982-287ab0c060c9"},{"index":13752,"token":false,"name":"Mask of Avacyn","scryfallId":"4ff1acce-bed4-452c-8416-06726004f2e8"},{"index":13754,"token":false,"name":"Loxodon Hierarch","scryfallId":"826f4791-d6ca-4620-bc30-6d11d8d22e81"},{"index":13758,"token":false,"name":"False Mourning","scryfallId":"61bdfefb-f2e2-409c-b5e1-66d24ab3ee5d"},{"index":13760,"token":false,"name":"Stonerise Spirit","scryfallId":"388f2e45-570f-4a35-b205-37e1345b5d06"},{"index":13762,"token":false,"name":"Enlisted Wurm","scryfallId":"1af3eae1-daf0-482f-80ce-db185d16fb88"},{"index":13763,"token":false,"name":"Paroxysm","scryfallId":"53320321-4f02-40ee-8171-2375b1d4ed66"},{"index":13766,"token":false,"name":"Marsh Flitter","scryfallId":"040e1039-1943-4c2d-aa98-b7f9519de321"},{"index":13767,"token":false,"name":"Anurid Scavenger","scryfallId":"21a21190-3c05-40fe-9310-493ed0f9e42e"},{"index":13771,"token":false,"name":"Tooth and Claw","scryfallId":"a8c77d9f-22bd-4676-b594-8499369c449c"},{"index":13772,"token":false,"name":"Chain of Vapor","scryfallId":"30f6b4a2-5780-46e9-b239-459d2cf37743"},{"index":13773,"token":false,"name":"Radiant Performer","scryfallId":"dea0ea77-1c78-45ec-b3d9-813d4035c34b"},{"index":13775,"token":false,"name":"Winds of Abandon","scryfallId":"345a4aee-5846-4ae9-9af1-4c8fe8d692ec"},{"index":13777,"token":false,"name":"Hostage Taker","scryfallId":"e8dc67a0-05d9-463e-9794-30a7e951c240"},{"index":13778,"token":false,"name":"Wandering Mage","scryfallId":"75a5fe4d-ef72-47cd-805d-bfc90755590f"},{"index":13779,"token":false,"name":"Chromium","scryfallId":"e85e54f3-012b-460f-a6f9-d0242a174adc"},{"index":13780,"token":false,"name":"Righteous Avengers","scryfallId":"d96b463e-9579-4e7b-87c2-342527b91e7c"},{"index":13782,"token":false,"name":"Sprout","scryfallId":"ddc48187-511d-49ed-96be-3a059c6fdb43"},{"index":13789,"token":false,"name":"Jungle Basin","scryfallId":"4b0773b7-ae25-4fb0-aff1-1c91af81e70a"},{"index":13795,"token":false,"name":"Murderous Cut","scryfallId":"52569fa7-26f0-4558-80ef-7f17326a219a"},{"index":13796,"token":false,"name":"Statute of Denial","scryfallId":"af13770d-dddb-4b78-9cd3-4a0dc50472f4"},{"index":13798,"token":false,"name":"Icebreaker Kraken","scryfallId":"f1fdb9bb-09a2-4ff7-bcd4-35ea33c1b752"},{"index":13800,"token":false,"name":"Autumn's Veil","scryfallId":"7e354ce5-b4c1-4a9c-99d1-7624301b594b"},{"index":13801,"token":false,"name":"Thopter Engineer","scryfallId":"77b83dbe-77de-4446-96a5-6b4c4b6e8a27"},{"index":13807,"token":false,"name":"Thunderclap Wyvern","scryfallId":"64551550-6279-4f6e-a5b9-e1332e927421"},{"index":13809,"token":false,"name":"Sengir, the Dark Baron","scryfallId":"24d6256a-42b5-40f8-92e6-878d7002768f"},{"index":13811,"token":false,"name":"Driver of the Dead","scryfallId":"56113cde-4210-46be-bd53-8966c36ef2a3"},{"index":13812,"token":false,"name":"Maelstrom Nexus","scryfallId":"eed832fa-9902-4c5c-bf9c-e972c5c31fb8"},{"index":13813,"token":false,"name":"Tyrant's Familiar","scryfallId":"e5e8e6f6-8247-4b4a-808e-139b9b770b4e"},{"index":13814,"token":false,"name":"Vindictive Vampire","scryfallId":"7c0bfb47-c753-42fa-969b-7b10b87b0462"},{"index":13819,"token":false,"name":"Dread Drone","scryfallId":"38d65339-e419-40b9-814a-374874f5585f"},{"index":13823,"token":false,"name":"Reality Spasm","scryfallId":"ec85a97d-4f02-4d0d-ab9a-e172e327da0e"},{"index":13824,"token":false,"name":"Fall of the Hammer","scryfallId":"50f9b279-c8b8-44ec-83bd-2e4767b3e87c"},{"index":13827,"token":false,"name":"Fierce Empath","scryfallId":"31293564-a080-456e-893f-151cb063e7a9"},{"index":13828,"token":false,"name":"Short Sword","scryfallId":"973c166e-3e93-4ed5-b4c5-84dc158a8e4f"},{"index":13831,"token":false,"name":"Ghor-Clan Savage","scryfallId":"a55f4387-9f0e-49de-b5c3-c72ce047ca41"},{"index":13833,"token":false,"name":"Arachnogenesis","scryfallId":"7967cb69-1868-45c0-92d1-39dabe30f2a2"},{"index":13836,"token":false,"name":"Taste of Death","scryfallId":"a4e52634-8502-4b72-950d-eb4c2f6b3bc4"},{"index":13842,"token":false,"name":"Faerie Seer","scryfallId":"3989e920-05df-4b30-9ec3-e6ecaa436fce"},{"index":13847,"token":false,"name":"Ring of Evos Isle","scryfallId":"a7c740a8-1bbc-4ec8-a72c-01aee9e48f3d"},{"index":13852,"token":false,"name":"Miner's Bane","scryfallId":"c52d48ac-1685-4061-9907-31248ae38cc9"},{"index":13854,"token":false,"name":"Overcome","scryfallId":"718352b9-1a68-44a1-947b-34f525f21223"},{"index":13855,"token":false,"name":"Gahiji, Honored One","scryfallId":"8fc19e3c-9d29-4e0d-b6cf-db00d39d8b20"},{"index":13857,"token":false,"name":"Wall of Tombstones","scryfallId":"55da1e86-fe18-486a-b510-f941e6f6e378"},{"index":13858,"token":false,"name":"Slitherhead","scryfallId":"d9327905-a254-4885-8310-69fc153ec52f"},{"index":13859,"token":false,"name":"Shared Summons","scryfallId":"1e1e49b6-ed0f-42f5-af22-6f4aa23ce4ef"},{"index":13860,"token":false,"name":"Steelshaper's Gift","scryfallId":"ca7123ec-5a29-4734-bc8c-6173c3da2f51"},{"index":13861,"token":false,"name":"Jedit's Dragoons","scryfallId":"3f190c65-f939-4453-95d7-9acb36cf97c2"},{"index":13862,"token":false,"name":"Kiyomaro, First to Stand","scryfallId":"3b3351bb-5c4e-498b-b6c9-94f571baffd5"},{"index":13863,"token":false,"name":"Ledev Champion","scryfallId":"bc4f508b-a48d-4462-9d89-ee2ead3a0847"},{"index":13864,"token":false,"name":"Throne of Bone","scryfallId":"98e77be1-3c29-40b4-9c47-44fa2d9d4454"},{"index":13866,"token":false,"name":"Scoria Wurm","scryfallId":"406f7fef-00f0-4ca5-ada4-c4a760e68467"},{"index":13867,"token":false,"name":"Alrund, God of the Cosmos // Hakka, Whispering Raven","scryfallId":"4e1e85b9-db1d-4bf8-b504-d419bcbd5ee2"},{"index":13869,"token":false,"name":"Escape Velocity","scryfallId":"90c2a3da-2458-4921-8574-9eb9d5925ae8"},{"index":13870,"token":false,"name":"Frantic Search","scryfallId":"fd030d0d-b5cc-4f80-bda4-730e70866952"},{"index":13871,"token":false,"name":"Sea Legs","scryfallId":"ae48b747-b9ea-4af1-84c5-3f5835d1ba1f"},{"index":13873,"token":false,"name":"Greater Mossdog","scryfallId":"08a45585-15e9-4df0-8b10-c6e26b166a20"},{"index":13874,"token":false,"name":"Thassa's Oracle","scryfallId":"726e8b29-13e9-4138-b6a9-d2a0d8188d1c"},{"index":13877,"token":false,"name":"Skarrgan Firebird","scryfallId":"bb8e19f8-1084-4dac-ad2c-3a7db5c69492"},{"index":13878,"token":false,"name":"Warchanter of Mogis","scryfallId":"757948b3-8cb2-4709-9bbf-031c2bf6d4c5"},{"index":13879,"token":false,"name":"Circu, Dimir Lobotomist","scryfallId":"80d88d83-d614-4995-ad3e-7ac062f4a93c"},{"index":13880,"token":false,"name":"Sweep the Skies","scryfallId":"e22dcb4e-ac39-4bee-b8d0-1b6ed038834e"},{"index":13881,"token":false,"name":"Jackal Familiar","scryfallId":"0a47a2dc-f7f2-4103-9ebe-8cd8b83915ae"},{"index":13882,"token":false,"name":"Celestial Gatekeeper","scryfallId":"0b4dc1d3-53a1-411b-abf9-f5e4e80edc63"},{"index":13889,"token":false,"name":"Goblin Spymaster","scryfallId":"79c6d79a-d4da-49cf-9eaa-7ecf5b864d5e"},{"index":13890,"token":true,"name":"Saproling // Insect Token (B/G, undefined/undefined)","scryfallId":"c06bcc5b-4ccd-452d-8579-beee6c5cbe98"},{"index":13893,"token":false,"name":"Alms of the Vein","scryfallId":"79b80948-a3cd-4962-8fce-d58f2db7e68e"},{"index":13895,"token":false,"name":"Spinal Centipede","scryfallId":"74d579fb-615a-43a6-a1c1-c535087abf2a"},{"index":13897,"token":false,"name":"Necropolis","scryfallId":"893e8e9c-983e-4db1-8d93-10637025a559"},{"index":13898,"token":false,"name":"Blessed Sanctuary","scryfallId":"ff80029e-650e-469d-8393-0edf7d9cd695"},{"index":13899,"token":false,"name":"Beneath the Sands","scryfallId":"e92c0cf0-df4a-4e50-8396-53713f925b53"},{"index":13902,"token":false,"name":"Hand of Death","scryfallId":"d17d9a95-5586-4d16-9700-215b9af63f6f"},{"index":13906,"token":false,"name":"Jump","scryfallId":"34c7db89-8409-4acc-8fb8-6a788b517d05"},{"index":13907,"token":false,"name":"Presence of the Master","scryfallId":"1cb86b2f-116d-4952-b35a-1398341baaf5"},{"index":13908,"token":false,"name":"Stonecloaker","scryfallId":"d64ea201-61bf-41af-9aa9-a6976c01995f"},{"index":13915,"token":false,"name":"Stony Silence","scryfallId":"8e7faede-f794-4bda-9d64-21390ba19266"},{"index":13918,"token":false,"name":"March of the Returned","scryfallId":"983f7521-16e3-4057-a482-7d86392daa57"},{"index":13921,"token":true,"name":"Garruk","scryfallId":"16481c20-92a9-4d1c-8441-1601dce78c42"},{"index":13922,"token":false,"name":"Touch of Brilliance","scryfallId":"196474ce-e28e-48f0-b407-dc5535adf1b6"},{"index":13924,"token":false,"name":"Nirkana Assassin","scryfallId":"2ca43ea1-ba7b-4dc7-b6f6-a0c92321ebe1"},{"index":13927,"token":false,"name":"Lightning Diadem","scryfallId":"9223ac16-e6fc-4ba6-91d9-7ff27cc17271"},{"index":13932,"token":true,"name":"Goblin // Soldier Token (R, 1/1)","scryfallId":"64f4dc68-060b-4c63-8f43-00f53c52a251"},{"index":13935,"token":false,"name":"Bound // Determined","scryfallId":"9dc20e14-e304-4c14-a87b-322a76e214d5"},{"index":13936,"token":false,"name":"Chance for Glory","scryfallId":"85edf6f9-b863-41e2-bb51-857ea2798090"},{"index":13937,"token":false,"name":"Shrieking Drake","scryfallId":"63971a64-c5f3-4d1f-ae0d-489d7d5b18f0"},{"index":13938,"token":false,"name":"Citadel Castellan","scryfallId":"9aa11f30-f2b7-4279-9176-c336c74538bf"},{"index":13940,"token":false,"name":"Sword Dancer","scryfallId":"ec270d53-042e-4b11-b0f4-6416348b8fff"},{"index":13944,"token":false,"name":"Grove of the Guardian","scryfallId":"0079326b-ef87-49b8-9772-9134fb5deb3e"},{"index":13945,"token":false,"name":"Traverse the Outlands","scryfallId":"507590c4-fe55-404a-926b-24de387a2098"},{"index":13946,"token":false,"name":"Thunderblade Charge","scryfallId":"88a85be1-9de5-4f96-9fd1-15f3f17c4bea"},{"index":13947,"token":false,"name":"Proteus Staff","scryfallId":"55e5c69c-43d0-4f5b-8720-40074eb122bb"},{"index":13950,"token":false,"name":"Ox of Agonas","scryfallId":"38beac66-fab1-4999-b43c-524e3225d70c"},{"index":13951,"token":false,"name":"Clever Impersonator","scryfallId":"3889b4d6-2541-484d-88dd-d67800545327"},{"index":13953,"token":false,"name":"Reckless Wurm","scryfallId":"2f77bc31-3754-4b33-b067-a802e2d35484"},{"index":13954,"token":false,"name":"Alley Evasion","scryfallId":"6063d9b7-9874-47da-90aa-8938df2086ab"},{"index":13955,"token":false,"name":"Angel of the Ruins","scryfallId":"ea96229a-5c33-4f79-97d4-059947dd7617"},{"index":13956,"token":false,"name":"Blade of the Sixth Pride","scryfallId":"f6ccfe28-ec08-4751-b65c-c40b2bafa955"},{"index":13959,"token":false,"name":"Dead Reckoning","scryfallId":"ad16a3b8-e99e-47ed-92ce-ef42310f9f46"},{"index":13961,"token":false,"name":"Stalking Stones","scryfallId":"27856bc5-4f39-4461-baa0-700442942aff"},{"index":13963,"token":false,"name":"Flameblade Adept","scryfallId":"f974d05a-3b31-4661-af18-58d87b76f19e"},{"index":13964,"token":false,"name":"Unbridled Growth","scryfallId":"393fc419-a6ce-447d-9994-744cf41f9a27"},{"index":13965,"token":false,"name":"Grip of Amnesia","scryfallId":"43dc7e2a-5b9b-4f0f-8b2e-a7c7f847e1f1"},{"index":13966,"token":false,"name":"Solve the Equation","scryfallId":"66c04ee2-c1e0-45fb-aaf5-1b4459df80fc"},{"index":13970,"token":false,"name":"Sinking Feeling","scryfallId":"1aac9a8a-7594-4270-a8b6-57b4f8f2a390"},{"index":13971,"token":false,"name":"Knight of Meadowgrain","scryfallId":"1eb33901-1f97-4080-a9dd-922ef29f42c9"},{"index":13972,"token":false,"name":"Trusty Retriever","scryfallId":"ab4eb490-acd0-4162-8e8a-7e7ff003d0f3"},{"index":13978,"token":false,"name":"Magma Opus","scryfallId":"9a3ccc0f-d66f-4eea-8dc1-9d1f1e0f9982"},{"index":13981,"token":false,"name":"Moldgraf Scavenger","scryfallId":"76755763-7c02-451f-b799-2106a3a4973b"},{"index":13983,"token":false,"name":"Two-Headed Zombie","scryfallId":"2cc5760e-8b27-4d37-9772-c9eda90b1d95"},{"index":13984,"token":false,"name":"Davriel, Rogue Shadowmage","scryfallId":"7ba61ea6-67b5-49f4-bd1d-9674337f9004"},{"index":13987,"token":false,"name":"Counsel of the Soratami","scryfallId":"4401911c-bfb0-4c94-9fc1-49198ccecc94"},{"index":13989,"token":false,"name":"Phantasmal Dragon","scryfallId":"4ed5909d-b54c-44d5-9f3f-7e9a2c6a25c7"},{"index":13990,"token":false,"name":"Gideon's Phalanx","scryfallId":"30142729-de9a-4a0b-b060-8f68e1ef234d"},{"index":13992,"token":false,"name":"Dalakos, Crafter of Wonders","scryfallId":"6bec7361-96d4-4d82-bbfc-227a85992c16"},{"index":13995,"token":false,"name":"Chimeric Egg","scryfallId":"d516f267-e72b-453c-bceb-4766582568d2"},{"index":13998,"token":false,"name":"Gruul War Chant","scryfallId":"df383a6a-5eb1-48e8-a5f3-f4731ddb871b"},{"index":14005,"token":false,"name":"Fleet-Footed Monk","scryfallId":"03cd972d-1cc1-4fb1-9b4e-a88ea115cf7f"},{"index":14007,"token":false,"name":"Teroh's Faithful","scryfallId":"bff8cf45-c84f-49d7-ad3d-b5e046286cb3"},{"index":14010,"token":false,"name":"Bounding Krasis","scryfallId":"0feca3b2-e822-4772-a644-782789f938cb"},{"index":14011,"token":false,"name":"Tatsumasa, the Dragon's Fang","scryfallId":"98d3bc63-8814-46e7-a6ee-dd5b94a8257e"},{"index":14012,"token":false,"name":"Lightning Crafter","scryfallId":"1caa3ca6-40e3-46d5-bee7-52b34dc4569c"},{"index":14021,"token":false,"name":"Insurrection","scryfallId":"555d2687-01cd-4e7b-b031-cd4cd44fcb76"},{"index":14023,"token":false,"name":"Evasive Action","scryfallId":"d8fad630-bd1c-42df-86b5-cc00da28abfd"},{"index":14026,"token":false,"name":"Tomb of the Spirit Dragon","scryfallId":"eb6be7ab-8fad-4606-b623-f2188219d60b"},{"index":14027,"token":false,"name":"Duergar Assailant","scryfallId":"a6555cbb-97fc-4258-9b11-096c3eaec833"},{"index":14029,"token":false,"name":"Navigator's Compass","scryfallId":"6a283135-7a51-4cf7-82a6-7e50894e64a5"},{"index":14032,"token":false,"name":"Raging Redcap","scryfallId":"d9325398-41c3-4177-a64d-ea38cb7a8737"},{"index":14034,"token":false,"name":"Dragon Mage","scryfallId":"416cfb3f-237b-4516-824e-230e0db64a5d"},{"index":14035,"token":false,"name":"Wild Might","scryfallId":"7a8c0be2-ba90-4e7a-b1a6-c68be550e33d"},{"index":14037,"token":false,"name":"Codie, Vociferous Codex","scryfallId":"1f062c51-8f68-4111-be7e-c3d011b2992b"},{"index":14038,"token":false,"name":"Myr Galvanizer","scryfallId":"e55ca835-b7f3-497c-b0bc-50a182cabecf"},{"index":14041,"token":false,"name":"Jace's Phantasm","scryfallId":"96a4783a-db1f-4222-b989-559eead14bd6"},{"index":14042,"token":false,"name":"Ambassador Oak","scryfallId":"fb619508-67a2-426d-819b-57e21bf61d66"},{"index":14043,"token":false,"name":"Farbog Boneflinger","scryfallId":"3185eeac-39ae-4e6e-bfdd-4b8edd984af1"},{"index":14044,"token":true,"name":"Brainiac Token (R, 1/1)","scryfallId":"af1a8115-127d-4268-a4d0-95360862e5fb"},{"index":14047,"token":false,"name":"Myr Retriever","scryfallId":"33940107-e210-4334-a409-48ab591af2ec"},{"index":14050,"token":false,"name":"Loyal Cathar // Unhallowed Cathar","scryfallId":"cb09041b-4d09-4cae-9e85-b859edae885b"},{"index":14051,"token":false,"name":"Rielle, the Everwise","scryfallId":"0235c888-63f7-4059-a6da-5b3b05d011b7"},{"index":14053,"token":false,"name":"Reforge the Soul","scryfallId":"36506caa-2630-46ec-9aa0-e1885749ad90"},{"index":14054,"token":false,"name":"Falthis, Shadowcat Familiar","scryfallId":"ffb45a20-bfcc-45e2-9863-da58f5e9a0e0"},{"index":14055,"token":false,"name":"Angelsong","scryfallId":"0832e87f-afef-41a5-ba36-3eaf65551576"},{"index":14058,"token":false,"name":"Hunted Nightmare","scryfallId":"5f2dddce-583e-4af3-b144-a60dd268e84f"},{"index":14059,"token":false,"name":"Paradigm Shift","scryfallId":"e64a17a8-091d-4029-908e-31d6a050b479"},{"index":14060,"token":false,"name":"Bog Gnarr","scryfallId":"3f230831-023c-41aa-832e-16ac81e68588"},{"index":14061,"token":false,"name":"Shriek Raptor","scryfallId":"73071a3b-9329-418e-9285-fa4765463d1f"},{"index":14063,"token":false,"name":"Lifeforce","scryfallId":"fa1681fa-2edc-4c0c-b5ca-f7f2602a3467"},{"index":14067,"token":false,"name":"Crow of Dark Tidings","scryfallId":"1b9454d4-b91c-4c66-af71-32c96395765a"},{"index":14068,"token":false,"name":"Goblin Swine-Rider","scryfallId":"49980982-d534-4204-bc15-3e6c4ffa1a53"},{"index":14070,"token":false,"name":"Dual Strike","scryfallId":"6ef580f8-efec-4d31-8dc3-2018dd48b6f4"},{"index":14072,"token":false,"name":"Sophic Centaur","scryfallId":"582cefca-6c11-4df3-8b54-46309dafff4a"},{"index":14075,"token":false,"name":"Messenger Falcons","scryfallId":"f088f625-9c72-4949-8e53-c2313397a197"},{"index":14077,"token":false,"name":"Authority of the Consuls","scryfallId":"955af30d-3d20-406f-95be-4c171673c9c7"},{"index":14080,"token":false,"name":"Ancient Crab","scryfallId":"783794e3-fe0c-4014-ae5a-6c249af23ddc"},{"index":14081,"token":false,"name":"Krovikan Horror","scryfallId":"e1f3cb1c-6bde-4b55-b5bc-5b64b56930f2"},{"index":14083,"token":false,"name":"Forgotten Lore","scryfallId":"fb01dd39-a957-4c1a-86cf-f31a699a154a"},{"index":14085,"token":false,"name":"Lithoform Engine","scryfallId":"e3b02012-56b1-4386-936b-139480162e8f"},{"index":14086,"token":false,"name":"Makindi Ox","scryfallId":"fd0d164a-bce2-4474-abe0-b735eb6c9442"},{"index":14088,"token":false,"name":"Bruna, the Fading Light // Brisela, Voice of Nightmares","scryfallId":"2b45fb19-450d-40bd-91c7-b5ace4a77f2a"},{"index":14090,"token":false,"name":"Bloom Tender","scryfallId":"d7cc2828-dfe7-410b-9735-10bb7211f0f5"},{"index":14091,"token":false,"name":"Brain Maggot","scryfallId":"acdc31d5-6726-453e-94e0-69d2fe9447af"},{"index":14094,"token":false,"name":"Darksteel Mutation","scryfallId":"7f11af1f-6402-47a9-a515-06aad9c497fd"},{"index":14095,"token":false,"name":"Underworld Fires","scryfallId":"0fe616c4-dcb0-4284-ba10-6fbf7cecd217"},{"index":14098,"token":false,"name":"Song of Freyalise","scryfallId":"a45b534b-8442-4074-a8d2-f38e83f24868"},{"index":14099,"token":false,"name":"Cragcrown Pathway // Timbercrown Pathway","scryfallId":"5e5288f2-b27e-4009-b537-d19f61b34c4a"},{"index":14101,"token":false,"name":"Select for Inspection","scryfallId":"fa31b045-b0b3-418a-9997-4c5886af21aa"},{"index":14102,"token":false,"name":"Aeronaut Admiral","scryfallId":"f3dc5c66-1198-4f2a-a143-a6f4299f4100"},{"index":14103,"token":false,"name":"Ashen Ghoul","scryfallId":"6bb83301-5662-4628-b536-6a3ee0296f2e"},{"index":14104,"token":false,"name":"Hard Evidence","scryfallId":"501599d6-1072-4124-b05d-01f96de153f3"},{"index":14106,"token":false,"name":"Jhessian Infiltrator","scryfallId":"1761d867-2eb0-406b-b175-97a90c457844"},{"index":14108,"token":false,"name":"Siege Striker","scryfallId":"7a0ffa89-e6ee-466c-8edc-dd24c8b52e80"},{"index":14110,"token":false,"name":"Archaeomancer's Map","scryfallId":"4847b1f7-7ade-4544-b157-a5453db371b1"},{"index":14111,"token":true,"name":"Golem Token (R/W, 4/4)","scryfallId":"7ddb9e14-b299-4064-a41b-0fb6b078942e"},{"index":14113,"token":false,"name":"Shell Shield","scryfallId":"3daede39-8eef-4272-a483-312dbd2dd30f"},{"index":14114,"token":false,"name":"Scuttlegator","scryfallId":"d886fd9a-7800-41f1-b692-32a439b045da"},{"index":14115,"token":false,"name":"Graxiplon","scryfallId":"0c16e565-0b7f-46b1-a091-64c47c923a9f"},{"index":14118,"token":false,"name":"Golgari Rotwurm","scryfallId":"2cc97674-f60a-4854-a807-60dbcf90637e"},{"index":14122,"token":false,"name":"Utvara Hellkite","scryfallId":"f17c6478-dd80-4854-9560-bfc5ef597872"},{"index":14126,"token":false,"name":"Strangleroot Geist","scryfallId":"c840aa15-6d54-41ee-b2e3-c049785ae10d"},{"index":14128,"token":false,"name":"Triumphant Reckoning","scryfallId":"3e1dbbb8-c384-42fe-a9b3-ab94f18e360f"},{"index":14131,"token":false,"name":"Rune of Speed","scryfallId":"47faee66-b274-466a-890e-bb396dda943d"},{"index":14132,"token":true,"name":"Phyrexian","scryfallId":"e5226d8b-ec55-4aca-bb9a-0f941d89c8ae"},{"index":14135,"token":false,"name":"Mayor of Avabruck // Howlpack Alpha","scryfallId":"dd8ca448-f734-4cb9-b1d5-790eed9a4b2d"},{"index":14138,"token":false,"name":"Tuktuk Scrapper","scryfallId":"d3a84a2a-6384-497a-8ee2-de0fa74fcc80"},{"index":14139,"token":false,"name":"Plague Boiler","scryfallId":"869e27e3-1707-4e1d-b04a-8309da2e41b4"},{"index":14140,"token":false,"name":"Jace, Architect of Thought","scryfallId":"736b07e8-4eb4-492d-a323-3125823ae090"},{"index":14142,"token":false,"name":"Gust of Wind","scryfallId":"faabea92-d8cf-4591-b528-3e597d56b31f"},{"index":14145,"token":false,"name":"Warrant // Warden","scryfallId":"0070651d-79aa-4ea6-b703-6ecd3528b548"},{"index":14146,"token":false,"name":"Vampiric Sliver","scryfallId":"28c56db1-bb2d-4383-90aa-72d00fe476b2"},{"index":14147,"token":false,"name":"Haphazard Bombardment","scryfallId":"243bd39f-ad96-449f-8f77-e204356ae972"},{"index":14148,"token":false,"name":"Silent Artisan","scryfallId":"dce5647d-1546-4eff-a2a2-9e9ef26db533"},{"index":14149,"token":false,"name":"Bar the Door","scryfallId":"b593f544-2d82-4237-b9a9-88503b5036cc"},{"index":14151,"token":false,"name":"Soulfire Grand Master","scryfallId":"fc3a4e7d-6667-4c2f-b6b4-484f401b0455"},{"index":14152,"token":false,"name":"Nimble-Blade Khenra","scryfallId":"5e36a17b-89d6-4de9-867b-9762afedb4f1"},{"index":14154,"token":true,"name":"Bear Token (G, 4/4)","scryfallId":"ca3dae7d-3880-4c0a-acfb-8fd227cf9fab"},{"index":14155,"token":false,"name":"Pulse of Murasa","scryfallId":"c591c615-69e8-4661-a089-8c4e152adac7"},{"index":14157,"token":false,"name":"Shifting Shadow","scryfallId":"802211eb-f9d5-484c-952f-be73ba0b9191"},{"index":14159,"token":false,"name":"Yavimaya Barbarian","scryfallId":"8e17377d-4dad-4144-b0ce-c849636096a2"},{"index":14161,"token":false,"name":"Lifecrafter's Gift","scryfallId":"fa000086-e4aa-4bb6-8e66-f4c96e875749"},{"index":14166,"token":false,"name":"Advice from the Fae","scryfallId":"d874f345-e623-4317-9aa7-66d14a011303"},{"index":14167,"token":false,"name":"Mass Calcify","scryfallId":"316a2d2f-ca94-463f-ada4-2b12bce6312f"},{"index":14168,"token":false,"name":"Altered Ego","scryfallId":"c05da08d-8fac-47bc-80d8-78a80d1463d2"},{"index":14172,"token":false,"name":"Heliod, Sun-Crowned","scryfallId":"01a8576e-cadc-4521-aadd-3a05f0bc4d20"},{"index":14174,"token":false,"name":"Natural Order","scryfallId":"8c68f1e6-b1f2-4e04-beee-97abad3cd4d5"},{"index":14178,"token":false,"name":"Rift Sower","scryfallId":"97dbd212-f1e8-429a-bf00-b2ea966d880e"},{"index":14179,"token":false,"name":"Alchemist's Vial","scryfallId":"d6df465c-11f5-4b42-9ff1-e89b92aa1f31"},{"index":14182,"token":false,"name":"Phantom Monster","scryfallId":"daa120ce-63a6-4d5e-9801-123d5e05646e"},{"index":14183,"token":false,"name":"Gate Smasher","scryfallId":"001e8222-8dea-4767-8c13-21fb7ba556d7"},{"index":14184,"token":false,"name":"Trained Jackal","scryfallId":"01deb3cc-91e8-4ef3-964f-f36c6a21207c"},{"index":14185,"token":false,"name":"Retract","scryfallId":"4e09a443-0a00-458a-b351-8cb188e9218c"},{"index":14186,"token":false,"name":"Violent Ultimatum","scryfallId":"9c91fd4a-0785-4d88-818e-eab305ed84e8"},{"index":14187,"token":false,"name":"Oko, Thief of Crowns","scryfallId":"058c60d2-25d1-42bf-9747-715e9ff56e0b"},{"index":14188,"token":false,"name":"Mardu Ascendancy","scryfallId":"b95749d7-5967-4e49-9de0-74e156650095"},{"index":14190,"token":false,"name":"Hulking Devil","scryfallId":"651bf12d-a8db-4ba2-840b-41affa3955c2"},{"index":14191,"token":false,"name":"Goblin Marshal","scryfallId":"6a85b2f9-c12c-46dd-ae04-470ebf5ec6d9"},{"index":14194,"token":false,"name":"Arrest","scryfallId":"f52d6cf9-1d92-4d3b-8631-0db19a073b44"},{"index":14197,"token":false,"name":"Ashiok, Sculptor of Fears","scryfallId":"36a5fc37-e7bd-41a9-88ac-74a3f14fea8b"},{"index":14199,"token":false,"name":"Dross Hopper","scryfallId":"1a0656f6-a016-479a-a003-72e106e986b0"},{"index":14200,"token":false,"name":"Emerald Charm","scryfallId":"0b601f88-a32a-4dd5-ac88-17a67eec19ff"},{"index":14202,"token":false,"name":"Excavator","scryfallId":"6dc3d5b4-b04f-4b34-afd2-72fb3de0a33b"},{"index":14204,"token":false,"name":"Elspeth, Knight-Errant","scryfallId":"200e0e28-88cc-43e5-8774-28ba791cfa63"},{"index":14205,"token":false,"name":"Sin Prodder","scryfallId":"db89172e-0542-4858-9e65-38b1bac8cdeb"},{"index":14207,"token":false,"name":"Sulfurous Springs","scryfallId":"29880e73-5636-43ec-bcfc-7323d52fec3c"},{"index":14209,"token":false,"name":"Angel of Retribution","scryfallId":"807f4edf-a961-4f52-a44e-abde0fd35722"},{"index":14212,"token":false,"name":"Swaggering Corsair","scryfallId":"22da9f6a-9598-4cfe-b465-719266b65dee"},{"index":14213,"token":false,"name":"Mogg Infestation","scryfallId":"bfeb1145-3729-481e-a314-c325ed2f2a35"},{"index":14214,"token":false,"name":"Aftershock","scryfallId":"41cd7b16-a920-4a92-9f3d-5047df9a5c3e"},{"index":14215,"token":false,"name":"Giant Scorpion","scryfallId":"c27221df-ec7a-4c51-b3a8-34b65b236b49"},{"index":14221,"token":false,"name":"Pitiless Horde","scryfallId":"8d6999c0-7823-45da-b37d-8013e42b5b36"},{"index":14225,"token":false,"name":"Deepcavern Imp","scryfallId":"13cfa5f3-495f-457b-ad44-bd2cf3414ce4"},{"index":14227,"token":false,"name":"Take Inventory","scryfallId":"a3584150-4f09-4c15-b13e-707bd91b3004"},{"index":14229,"token":false,"name":"Scarblade Elite","scryfallId":"1bd5c2b6-fcb2-4865-a0e5-9af59d94ae5a"},{"index":14232,"token":false,"name":"Thran Quarry","scryfallId":"4b2d6c41-7d82-4062-a783-37d88536279c"},{"index":14234,"token":false,"name":"Crypt of Agadeem","scryfallId":"ba4c4c6b-65bf-480f-bdd5-e7acc8a512bf"},{"index":14236,"token":false,"name":"Malakir Blood-Priest","scryfallId":"3d14ea81-d303-47db-90b4-7d10588f7ea6"},{"index":14237,"token":false,"name":"Silvercoat Lion","scryfallId":"e37523d3-7719-48e1-9b3e-2670772a509b"},{"index":14238,"token":false,"name":"Rhythmic Water Vortex","scryfallId":"be82ea29-66d4-471d-bef7-c6524207b96d"},{"index":14240,"token":false,"name":"Windborn Muse","scryfallId":"b4be85b7-f150-4ee3-b83a-3c8c2e12b28f"},{"index":14247,"token":false,"name":"Scalding Salamander","scryfallId":"5a0e9433-88d7-4bfc-99a0-ff47807fd594"},{"index":14254,"token":false,"name":"Spined Megalodon","scryfallId":"6d42d3dd-29df-44a1-89b8-994761eda77d"},{"index":14255,"token":false,"name":"Samurai Enforcers","scryfallId":"8b2be3fe-87a2-47b2-8af1-b99a48622c7b"},{"index":14256,"token":false,"name":"Flame Jet","scryfallId":"a511f9df-b53b-4fea-87cd-9f18f6833f92"},{"index":14258,"token":false,"name":"Rush of Adrenaline","scryfallId":"d0def54b-9f0a-4ab1-9df9-25506a06350c"},{"index":14263,"token":false,"name":"Sylvan Yeti","scryfallId":"096e7d5a-d998-4ef7-b34f-986aa69c526b"},{"index":14264,"token":false,"name":"Thassa, God of the Sea","scryfallId":"d6876c7a-8bbe-484e-b733-70229fa336cd"},{"index":14265,"token":false,"name":"Keleth, Sunmane Familiar","scryfallId":"9b7e280f-1f41-4d70-8f8c-bb77c66bcf8b"},{"index":14267,"token":false,"name":"Deadly Brew","scryfallId":"87d33e48-90fc-4aac-b09a-68050bc053b5"},{"index":14273,"token":false,"name":"Pavel Maliki","scryfallId":"c6627e4c-dc84-4ea0-8f69-dea92f55c943"},{"index":14275,"token":false,"name":"Saheeli's Directive","scryfallId":"494c32ef-6fce-4330-9e34-a68497ae865e"},{"index":14276,"token":false,"name":"Primal Forcemage","scryfallId":"98fa7f5c-8a10-4037-9a94-42e0559b4b72"},{"index":14278,"token":false,"name":"Loreseeker's Stone","scryfallId":"0ce4585e-c739-4dee-8ef9-ec4508564ea4"},{"index":14280,"token":false,"name":"Birchlore Rangers","scryfallId":"8ce3a3a1-3569-4909-a604-f78d4888781e"},{"index":14282,"token":false,"name":"Mountain Bandit","scryfallId":"34fd541d-9956-4595-9527-a83db4c5f74f"},{"index":14283,"token":false,"name":"Breakthrough","scryfallId":"aceeb1f7-d780-4da5-87b6-0be4f136c2e6"},{"index":14284,"token":false,"name":"Zephyr Scribe","scryfallId":"d23ae0d2-0ca1-4095-8710-be5800e389cd"},{"index":14286,"token":false,"name":"Neurok Spy","scryfallId":"47b86a02-d40a-4615-8402-bd5700cb5101"},{"index":14290,"token":false,"name":"Kyren Glider","scryfallId":"0bc55e01-342e-4856-937e-14561b8d165b"},{"index":14293,"token":false,"name":"Marshaling Cry","scryfallId":"920d7f7e-8df3-4465-be07-83cb340cffc1"},{"index":14295,"token":false,"name":"Assault Formation","scryfallId":"7f672dd0-cd63-464c-9581-0ec6f0e391f7"},{"index":14296,"token":false,"name":"Trostani, Selesnya's Voice","scryfallId":"9d1d9d86-5666-4e59-9766-137657b4e040"},{"index":14304,"token":false,"name":"Glasspool Mimic // Glasspool Shore","scryfallId":"fee79733-4df7-4870-9e42-03407b5e1528"},{"index":14307,"token":false,"name":"Portal Mage","scryfallId":"56f9677e-739d-499a-a9f3-4152b4b02d8a"},{"index":14309,"token":false,"name":"Trestle Troll","scryfallId":"6d224279-83f3-4a29-9fd9-86b72407b87a"},{"index":14313,"token":false,"name":"Sphinx of Enlightenment","scryfallId":"0faa9eea-fbf1-41f7-9def-1ec3d5134a53"},{"index":14314,"token":false,"name":"Alpine Watchdog","scryfallId":"c392a7e5-6ff5-4c2f-9590-f8811a724f44"},{"index":14316,"token":false,"name":"Lunar Force","scryfallId":"76614db3-480f-41f6-91ad-66301fc8e394"},{"index":14318,"token":false,"name":"Rotwidow Pack","scryfallId":"2cda35eb-ae42-43be-9015-3c468c7ebede"},{"index":14319,"token":false,"name":"Emergent Ultimatum","scryfallId":"400d79b0-102a-406c-8369-8d024b18c4e9"},{"index":14320,"token":false,"name":"Path of Discovery","scryfallId":"a907663c-d249-4b59-b6b8-44a10fa6fc40"},{"index":14321,"token":false,"name":"Sun-Blessed Mount","scryfallId":"6f06ac1f-0bae-4aaa-9ff4-28c806828c40"},{"index":14322,"token":false,"name":"Enclave Elite","scryfallId":"5af0ef2e-4273-432a-8d03-3480165f1be7"},{"index":14323,"token":false,"name":"Myr Sire","scryfallId":"a3f2e2e5-5ed2-4040-92ba-ad1ac13f03f6"},{"index":14324,"token":false,"name":"Atarka Efreet","scryfallId":"8d5fbc45-be3d-4a70-9c4e-cdc84ee46f77"},{"index":14326,"token":false,"name":"Fire Covenant","scryfallId":"2bf2da97-3331-4614-b4ff-f03d061500a7"},{"index":14331,"token":false,"name":"Vitality Charm","scryfallId":"e1abae21-ed8f-4e21-b227-f721b840c11f"},{"index":14336,"token":false,"name":"Balduvian Barbarians","scryfallId":"caba00ff-df58-456e-8aeb-fc8b632018a6"},{"index":14337,"token":false,"name":"Capricopian","scryfallId":"0b81f82a-f004-44f3-9dad-1675941fe57b"},{"index":14339,"token":false,"name":"Knollspine Dragon","scryfallId":"ed0b7440-c3d8-452a-a3ec-b9d9b991ccec"},{"index":14340,"token":false,"name":"Suspicious Bookcase","scryfallId":"7b14ff70-6817-4539-b19b-142f8f6b6b1f"},{"index":14342,"token":false,"name":"Killer Bees","scryfallId":"096c7da0-a341-4044-9033-95e7bf2d605a"},{"index":14344,"token":false,"name":"Momentous Fall","scryfallId":"0271550a-0610-4e21-849a-f29547a77bdc"},{"index":14347,"token":false,"name":"Lord of Shatterskull Pass","scryfallId":"3593abc2-18b1-4653-9db8-153ba5d22825"},{"index":14348,"token":false,"name":"Obelisk of Jund","scryfallId":"1fe43306-f48f-4812-8d40-1903cc6f19d2"},{"index":14351,"token":false,"name":"Nova Pentacle","scryfallId":"0e627164-da4e-4860-b516-7304fc41161e"},{"index":14352,"token":false,"name":"Nicol Bolas, the Ravager // Nicol Bolas, the Arisen","scryfallId":"6ab66344-4959-4c7b-8828-b1a89b274e0b"},{"index":14353,"token":false,"name":"Goblin War Paint","scryfallId":"4388e57e-0c87-4d66-a862-58261d76c5ac"},{"index":14359,"token":false,"name":"Fireforger's Puzzleknot","scryfallId":"7a1c11ca-c81b-451e-a767-68865827e06d"},{"index":14361,"token":false,"name":"Damia, Sage of Stone","scryfallId":"299e20e6-6670-4904-bc62-c51acc23ee9b"},{"index":14362,"token":false,"name":"Moon-Eating Dog","scryfallId":"9f93a143-eaf6-41bc-8bb9-4c7c7dc9df96"},{"index":14363,"token":false,"name":"Kaya, Ghost Assassin","scryfallId":"38b403e1-8c7e-45af-8d10-fceabbe79bfb"},{"index":14366,"token":false,"name":"Territorial Allosaurus","scryfallId":"cf5c7436-870f-41ff-ba7e-4b3e0840ea13"},{"index":14370,"token":false,"name":"Eel Umbra","scryfallId":"697e28a0-80a6-4157-97d0-0ed5b56dc341"},{"index":14371,"token":false,"name":"Amulet of Safekeeping","scryfallId":"d45ac8dc-281f-4257-9658-80af65a0295b"},{"index":14372,"token":false,"name":"Chief of the Foundry","scryfallId":"145ae70d-8d0d-4bf2-b50c-af75b6874899"},{"index":14374,"token":false,"name":"Traverse the Ulvenwald","scryfallId":"6b339992-640b-421c-a250-b9c2d821b13d"},{"index":14380,"token":false,"name":"Champion of Arashin","scryfallId":"95c360d1-d0f4-42db-90fe-3f3dc98cc27f"},{"index":14383,"token":false,"name":"Unnatural Speed","scryfallId":"a542b1f4-82f8-471a-b0a6-7ead9167da27"},{"index":14385,"token":false,"name":"Searchlight Geist","scryfallId":"b0dc1a94-0193-464e-a481-730b34b57db5"},{"index":14386,"token":false,"name":"Precognition Field","scryfallId":"cf2a92ee-2b20-4299-84b2-b4963f4a42a1"},{"index":14387,"token":false,"name":"Bloodwater Entity","scryfallId":"474d0a04-b640-4d1d-b538-2d946c1ff913"},{"index":14391,"token":false,"name":"Winter Sky","scryfallId":"af1035f3-3027-4a41-834c-55222b13c2bc"},{"index":14393,"token":false,"name":"Worn Powerstone","scryfallId":"f1fe6ef9-9a75-4ec0-98fb-8972204ed010"},{"index":14394,"token":false,"name":"Faerie Noble","scryfallId":"4d0687f4-f2d0-4915-a797-3797377195b7"},{"index":14398,"token":false,"name":"Cloudstone Curio","scryfallId":"47cbda17-d368-4dc3-b41c-95b146468b44"},{"index":14399,"token":false,"name":"Gnarlwood Dryad","scryfallId":"fa506387-e538-4b2c-94df-29866eb74a71"},{"index":14400,"token":false,"name":"Sustainer of the Realm","scryfallId":"ff4226fb-2152-48a4-aa58-896138b68b4c"},{"index":14404,"token":false,"name":"Gaea's Embrace","scryfallId":"cce99456-d7cc-480f-b283-0ba063c89e0a"},{"index":14406,"token":false,"name":"Rally the Peasants","scryfallId":"b9f3eab5-89fb-440a-b56a-b35e2dca44f0"},{"index":14407,"token":false,"name":"Argothian Pixies","scryfallId":"5712e87a-2381-4f5b-a853-6973841f9bf1"},{"index":14409,"token":false,"name":"Darksteel Brute","scryfallId":"06125c05-a345-481d-bc7f-bf234b946b5b"},{"index":14410,"token":false,"name":"Gavony Unhallowed","scryfallId":"21f4c713-089b-497c-8c0f-826cab10aa87"},{"index":14411,"token":false,"name":"Sawtooth Ogre","scryfallId":"4a237580-f7f6-4d6b-a342-0d11fc0b5a59"},{"index":14412,"token":false,"name":"Ascent of the Worthy","scryfallId":"0bf01666-0fbf-4b15-a33d-964165bbfafb"},{"index":14413,"token":false,"name":"Phyrexian Portal","scryfallId":"c165b61b-3cd5-4035-a9d3-1c03289ae5ba"},{"index":14415,"token":false,"name":"Topple the Statue","scryfallId":"ab74e12a-ad7c-4563-aa06-632654bac91d"},{"index":14418,"token":false,"name":"Planeswalker's Scorn","scryfallId":"8ed08376-836f-4313-83d0-481895ead9da"},{"index":14419,"token":false,"name":"Hunting Pack","scryfallId":"33bdda6c-d32c-4666-b885-039eccc5a2ef"},{"index":14421,"token":false,"name":"Birthing Hulk","scryfallId":"a1a644e0-96e5-4b73-873f-1132948cb21f"},{"index":14422,"token":false,"name":"Walking Wall","scryfallId":"d80ab112-032a-41e5-a6b8-82dc9b389b02"},{"index":14424,"token":false,"name":"Woodborn Behemoth","scryfallId":"8c73dbf3-e68e-4f21-b6ca-94302bf5574c"},{"index":14425,"token":false,"name":"Prismatic Omen","scryfallId":"e75594cc-de47-49f2-9a8b-ba76c576368e"},{"index":14429,"token":false,"name":"Polluted Dead","scryfallId":"036c1954-37d3-4787-8df8-f2d0dd39058a"},{"index":14430,"token":false,"name":"Inspirit","scryfallId":"55e0e300-db79-4328-ba1d-9c3910e47f52"},{"index":14433,"token":false,"name":"Onslaught","scryfallId":"0afaf142-dbca-45bf-aea2-01c53bda635a"},{"index":14436,"token":false,"name":"Reiterate","scryfallId":"4bc2151b-acec-4237-8f6f-ed97055f3bb9"},{"index":14437,"token":false,"name":"Etherium-Horn Sorcerer","scryfallId":"3df330d3-7687-4a05-b215-adca15f332da"},{"index":14438,"token":false,"name":"Thought Erasure","scryfallId":"e8783e7e-d294-4e62-9e1d-fc1c67f6fb45"},{"index":14444,"token":false,"name":"Rogue Refiner","scryfallId":"618652b4-7ce9-4994-9d16-68d2cc8644ef"},{"index":14445,"token":false,"name":"Unholy Indenture","scryfallId":"31e22edb-a815-413d-b62d-f32f8932b6e6"},{"index":14447,"token":false,"name":"Rampaging Cyclops","scryfallId":"5c0d9e73-5ef7-4d8f-9b50-ac884a0458a2"},{"index":14450,"token":false,"name":"Giant Warthog","scryfallId":"c402ef0e-51e7-4da6-a434-b99c5d435698"},{"index":14452,"token":false,"name":"See the Truth","scryfallId":"24bad175-0d22-476e-a2e8-c3b7173cad2c"},{"index":14454,"token":false,"name":"Synthetic Destiny","scryfallId":"27fe6a2e-54f2-42d7-909a-726a0ab891ee"},{"index":14455,"token":false,"name":"Nim Shrieker","scryfallId":"c3a2c39b-b302-4cc3-b507-e4fe00614036"},{"index":14456,"token":false,"name":"Pashalik Mons","scryfallId":"11616853-34b1-4bb1-9590-461e12970ec3"},{"index":14457,"token":false,"name":"Bastion Mastodon","scryfallId":"c3ea690f-fd4e-4d05-b815-22d97736e894"},{"index":14458,"token":false,"name":"Smokestack","scryfallId":"6a37ab2d-094f-431e-878f-93aef0360413"},{"index":14462,"token":false,"name":"Rise Again","scryfallId":"660ec88f-2063-404a-853e-c985e21d17b0"},{"index":14463,"token":false,"name":"Ancestral Statue","scryfallId":"c7124a6f-b690-4326-93b5-036a8c520c1f"},{"index":14465,"token":false,"name":"Feeding Frenzy","scryfallId":"a6d74c30-ebca-4684-ad84-3ca19193ad88"},{"index":14467,"token":false,"name":"Survey the Wreckage","scryfallId":"a6e750f9-ad86-4d60-98a3-78d11cd52cd1"},{"index":14468,"token":false,"name":"Hammerhand","scryfallId":"f980def6-9a87-4948-9d02-956d568a95fe"},{"index":14469,"token":false,"name":"Hordeling Outburst","scryfallId":"1cc85221-b849-414c-99e3-9b7666cc2f56"},{"index":14470,"token":false,"name":"Spoils of the Vault","scryfallId":"6eb97a96-2c56-4638-b971-00cdf1eafd43"},{"index":14473,"token":false,"name":"Wrexial, the Risen Deep","scryfallId":"b783ac32-f9f0-45e1-9632-547392bc7a11"},{"index":14474,"token":false,"name":"Necropotence","scryfallId":"c89c6895-b0f8-444a-9c89-c6b4fd027b3e"},{"index":14476,"token":false,"name":"Gideon's Lawkeeper","scryfallId":"1c71eb81-a077-4c85-a4ce-4ad664486bee"},{"index":14482,"token":false,"name":"Keiga, the Tide Star","scryfallId":"ea83eaeb-cf82-406b-977f-2bac41925739"},{"index":14483,"token":false,"name":"Perilous Research","scryfallId":"0669285c-5560-4f49-8d0a-44b8c33e23d0"},{"index":14484,"token":false,"name":"Elemental Summoning","scryfallId":"ea51991c-1589-4c62-965b-5ae8d233520b"},{"index":14487,"token":false,"name":"Progenitus","scryfallId":"8bbd3493-1466-4d58-b004-00627ceb4a04"},{"index":14488,"token":false,"name":"Undercity's Embrace","scryfallId":"bfcb9805-eca0-476c-9480-0c958acdb50f"},{"index":14492,"token":false,"name":"Archelos, Lagoon Mystic","scryfallId":"25e5643c-26d9-4ada-bc03-cafda0f64f40"},{"index":14493,"token":false,"name":"Wingcrafter","scryfallId":"04a3059f-92f2-4163-b79a-154118a4e36d"},{"index":14494,"token":false,"name":"Frightshroud Courier","scryfallId":"4a0fa75a-a82b-44cd-965f-07e0fe7a111a"},{"index":14495,"token":false,"name":"Phantasmal Sphere","scryfallId":"a84617c7-c70a-497c-b834-3d98346180cf"},{"index":14496,"token":false,"name":"Wall of Caltrops","scryfallId":"664ad588-3002-4f63-93bd-38663171018f"},{"index":14500,"token":true,"name":"Frog Lizard Token (G, 3/3)","scryfallId":"495d3391-6311-418e-b55a-10c0af751026"},{"index":14501,"token":false,"name":"Exclusion Mage","scryfallId":"c6344ecd-ca57-4104-a77a-d7d14264776d"},{"index":14506,"token":false,"name":"Plaguecrafter","scryfallId":"8682fb87-df14-4277-aaa0-0d53d766c406"},{"index":14509,"token":false,"name":"Frenzied Rage","scryfallId":"f9ca9c16-5720-4531-88ea-48b48d189479"},{"index":14510,"token":false,"name":"Golgari Thug","scryfallId":"6dba86d9-0dd2-45cf-8fe9-c995d2cbb7d9"},{"index":14511,"token":false,"name":"Pia and Kiran Nalaar","scryfallId":"0b243acf-e164-456e-b51e-086954fa5f9f"},{"index":14512,"token":false,"name":"Absolute Law","scryfallId":"9fc78f1d-a191-4182-8064-8970ec47a525"},{"index":14513,"token":false,"name":"Liliana, Death's Majesty","scryfallId":"193b9060-3b1b-4f62-86db-b1a9e37d654b"},{"index":14515,"token":false,"name":"Honden of Night's Reach","scryfallId":"526419ae-5a49-40e8-ac45-f213a76c7326"},{"index":14516,"token":false,"name":"Living Lightning","scryfallId":"7e84379a-369e-4a9f-8c8b-bf47ab524c4e"},{"index":14517,"token":false,"name":"Illusionist's Gambit","scryfallId":"a00cc6ab-e97c-4eba-bc7e-49d77690433b"},{"index":14521,"token":true,"name":"Kobolds of Kher Keep Token (R, 0/1)","scryfallId":"4f4e8e64-7caa-4d98-8e20-0a4a20056143"},{"index":14529,"token":true,"name":"Soldier Token (R/W, 1/1)","scryfallId":"d651b974-24f2-4c5d-a3bc-94b802b3b90c"},{"index":14531,"token":false,"name":"Dreadhorde Butcher","scryfallId":"ff18f9c2-123a-419c-8ae3-086be217e142"},{"index":14533,"token":false,"name":"Read the Bones","scryfallId":"dbbdbf1a-2d15-4291-aa19-614f854d8cb3"},{"index":14535,"token":false,"name":"Soul Reap","scryfallId":"e2a129e2-bed5-4ee7-b223-851452f72682"},{"index":14538,"token":false,"name":"Nether Spirit","scryfallId":"82f1f3e1-d986-4c0b-850e-5e8f2eaa0642"},{"index":14542,"token":false,"name":"Syndicate Trafficker","scryfallId":"d89427f0-08d5-49a1-9684-ebe8769430f6"},{"index":14543,"token":false,"name":"Noxious Hatchling","scryfallId":"898fd93f-05f2-4523-a3f5-18b48a7365a2"},{"index":14546,"token":false,"name":"Landscaper Colos","scryfallId":"f45a9e86-133e-4626-a239-73ef88d9ae12"},{"index":14547,"token":false,"name":"Bogardan Dragonheart","scryfallId":"feb81f44-8f22-4d28-a452-a50bef69a3e3"},{"index":14550,"token":false,"name":"Goblin Traprunner","scryfallId":"36f0fd37-eb34-418d-b136-03d816c93034"},{"index":14553,"token":false,"name":"Scorching Lava","scryfallId":"2a85437f-052e-494c-a9ee-265c4624a409"},{"index":14558,"token":false,"name":"Without Weakness","scryfallId":"d6695fa8-881c-407c-91d9-3ac770372d35"},{"index":14559,"token":false,"name":"Cathedral Sanctifier","scryfallId":"76cac47a-9e83-4039-8d80-fa9bdadb7527"},{"index":14561,"token":false,"name":"Brutal Expulsion","scryfallId":"0cd0e11a-0398-431b-b523-9d3c8a0155cb"},{"index":14562,"token":false,"name":"Run Amok","scryfallId":"d3f2aa2c-deec-4927-a2d6-f5dce5967e26"},{"index":14566,"token":false,"name":"Ponder","scryfallId":"15813b4a-9eee-4724-97f3-c1b845cba330"},{"index":14568,"token":false,"name":"Fulgent Distraction","scryfallId":"c33a8cf1-e413-4633-b348-2ef594a945a5"},{"index":14569,"token":false,"name":"Soul of Theros","scryfallId":"63e391d3-cf19-4f73-9d39-22587e0f3c0d"},{"index":14570,"token":false,"name":"Storm Cauldron","scryfallId":"0bb5bdd3-6ecd-49cd-bfa2-e7da1ee85d88"},{"index":14572,"token":false,"name":"Silundi Vision // Silundi Isle","scryfallId":"11568cdf-6148-494c-8b98-f5ca5797d775"},{"index":14574,"token":false,"name":"Tread Upon","scryfallId":"87f04d27-f38a-4be2-8eb6-7dd0d3a1ac6d"},{"index":14576,"token":false,"name":"Altar's Reap","scryfallId":"00108a1c-e620-4124-9b31-3bb3ff2a0407"},{"index":14577,"token":false,"name":"Armored Cancrix","scryfallId":"3b455b0f-a69c-43b4-bbf5-605ed41f10e0"},{"index":14580,"token":false,"name":"Cephalid Inkshrouder","scryfallId":"2c3e8c80-690b-4d79-9dee-99d1a3876160"},{"index":14581,"token":false,"name":"Baleful Ammit","scryfallId":"fb662d58-ae50-423d-b1c5-abd45baca12b"},{"index":14583,"token":false,"name":"Invasion Plans","scryfallId":"f52c2f83-9535-4ee5-9964-5cc01e617981"},{"index":14584,"token":false,"name":"Acid Rain","scryfallId":"13281377-6d16-4ed3-8aa6-c47d6eb783df"},{"index":14585,"token":false,"name":"Sphere of the Suns","scryfallId":"7a2c0735-1816-489b-9793-89d1060d78f7"},{"index":14588,"token":false,"name":"Merciless Eternal","scryfallId":"11a6becd-15be-4f2d-8fda-35b1b289b28f"},{"index":14592,"token":false,"name":"Spatial Binding","scryfallId":"176d625f-1410-4ad6-a279-9a184fac6507"},{"index":14599,"token":false,"name":"Zulaport Duelist","scryfallId":"0b4c7268-60c6-4038-8ce9-d9d51bed4577"},{"index":14600,"token":false,"name":"Confound","scryfallId":"4f3b7d39-ce98-48e2-b2bf-0d55b4d3102b"},{"index":14601,"token":false,"name":"Abstruse Interference","scryfallId":"249a7be3-311e-4ce6-97dc-97242463ae23"},{"index":14605,"token":false,"name":"Kitsune Mystic // Autumn-Tail, Kitsune Sage","scryfallId":"4c663245-dfb6-4d92-8ac7-ffe3d5d12187"},{"index":14606,"token":false,"name":"Tranquil Expanse","scryfallId":"42787d2b-3f9d-4c29-9ece-e65544eb1340"},{"index":14607,"token":false,"name":"Falter","scryfallId":"e279126c-0512-4ee6-ad83-6fdfc7ae46c5"},{"index":14609,"token":false,"name":"Nivmagus Elemental","scryfallId":"b1892003-2e4c-43bd-8a37-3a97a76f113a"},{"index":14612,"token":false,"name":"Jund Sojourners","scryfallId":"893c08b2-1391-4aaf-b79c-d1125b232f73"},{"index":14613,"token":false,"name":"The Scarab God","scryfallId":"70d1af08-f4e6-4030-8ebe-30d9d706b114"},{"index":14614,"token":false,"name":"Epiphany Storm","scryfallId":"dd3a0128-4499-498d-9721-b1fd70ea84b4"},{"index":14617,"token":false,"name":"Advocate of the Beast","scryfallId":"b1320400-5aa8-48d6-be84-197b4559456f"},{"index":14619,"token":false,"name":"Godsend","scryfallId":"2dcf3975-7f81-4bdd-810d-476f46444b7a"},{"index":14620,"token":false,"name":"Aeon Chronicler","scryfallId":"5cec8dcc-8ebb-4640-a5f3-90e6e62c27e5"},{"index":14621,"token":false,"name":"Avatar of Hope","scryfallId":"f7246341-5a22-4857-b7ab-331843db0915"},{"index":14623,"token":false,"name":"Higure, the Still Wind","scryfallId":"743f3cf5-f8aa-49d4-947d-76b91799547a"},{"index":14628,"token":false,"name":"Svogthos, the Restless Tomb","scryfallId":"5cf3ba87-93a0-44db-83d9-92e23a677a62"},{"index":14630,"token":false,"name":"Bring Down","scryfallId":"e18146f9-369c-41c8-8a1d-7737edd2c18e"},{"index":14632,"token":false,"name":"Defiant Elf","scryfallId":"3b7a0b8f-6942-40b0-8efc-234ae77855b4"},{"index":14633,"token":false,"name":"Lightning Serpent","scryfallId":"f6b4f4b6-51cd-4ae0-9585-82ad964853ba"},{"index":14637,"token":false,"name":"Messenger Jays","scryfallId":"1da770c0-fd1f-4a60-9690-ef08dc65b01a"},{"index":14639,"token":false,"name":"Lavaborn Muse","scryfallId":"74adb3f7-2453-4133-a08b-4a2b1dc714b9"},{"index":14642,"token":false,"name":"Miming Slime","scryfallId":"6b4b68fa-6b82-470a-a2ca-10aba024c914"},{"index":14644,"token":false,"name":"Tainted Field","scryfallId":"82eea1f3-b8b3-4369-964e-32c3917be90c"},{"index":14647,"token":false,"name":"Energizer","scryfallId":"914f204c-7f3d-41f2-a771-0b6227d539eb"},{"index":14648,"token":false,"name":"Tectonic Giant","scryfallId":"f85b4708-e4c7-4115-b353-1d32f4dcff39"},{"index":14653,"token":false,"name":"Captain Sisay","scryfallId":"f44d22ed-7b85-4669-b49c-b1872a448611"},{"index":14654,"token":false,"name":"Mannichi, the Fevered Dream","scryfallId":"b403bdbb-13ab-43dd-a994-d45b994f6e0e"},{"index":14655,"token":false,"name":"Wall of Runes","scryfallId":"6ac0f66a-213f-463e-8ebb-35ff5940ea06"},{"index":14656,"token":false,"name":"Bloodstone Cameo","scryfallId":"f9db32fa-64b2-4ef6-88f2-28e758d420bb"},{"index":14658,"token":false,"name":"Akroma's Devoted","scryfallId":"798893df-e720-471d-822d-50284de23efd"},{"index":14660,"token":false,"name":"Maze of Shadows","scryfallId":"db3ea047-d18c-4f2a-913e-17469d3bd14c"},{"index":14661,"token":false,"name":"Sensory Deprivation","scryfallId":"454739db-a3d6-45e8-849a-287438c36627"},{"index":14663,"token":false,"name":"Misguided Rage","scryfallId":"74b5e00a-fef0-4711-9112-2fd067321890"},{"index":14664,"token":false,"name":"Fire Diamond","scryfallId":"f57070e7-6359-4be2-b4d3-4a3489a2deaa"},{"index":14665,"token":false,"name":"Chittering Host","scryfallId":"70b94f21-4f01-46f8-ad50-e2bb0b68ea33"},{"index":14667,"token":false,"name":"Gryff Vanguard","scryfallId":"b7238136-c8de-4949-9b54-ff75094e0569"},{"index":14668,"token":false,"name":"Larger Than Life","scryfallId":"11d4a9bf-368d-41e4-a520-20a485846631"},{"index":14670,"token":false,"name":"Shadowed Caravel","scryfallId":"d04e5a78-4cd5-4be9-a06e-71562435836e"},{"index":14672,"token":false,"name":"Sudden Strength","scryfallId":"7fa71e27-cd3a-40af-82ed-1bd716106be5"},{"index":14675,"token":false,"name":"Bloodchief's Thirst","scryfallId":"f7be5c0a-b538-4bc5-89c7-f5a81de7ccc3"},{"index":14677,"token":false,"name":"Boros Locket","scryfallId":"c61204b7-02c2-41be-8841-0b261798de7a"},{"index":14678,"token":false,"name":"Undead Executioner","scryfallId":"8d330058-16af-4486-aa89-b6be759e35d4"},{"index":14681,"token":false,"name":"Drake Hatchling","scryfallId":"64ee32f9-6120-4f15-a692-89a4cd8167c6"},{"index":14682,"token":false,"name":"Rescind","scryfallId":"0f138d4b-64ab-490f-a79b-94e516b1c047"},{"index":14683,"token":false,"name":"Deny Reality","scryfallId":"a75cd57b-de8b-4274-898b-f53f22be2c9e"},{"index":14686,"token":false,"name":"Ice Tunnel","scryfallId":"8cff3ef0-4dfb-472e-aa1e-77613dd0f6d8"},{"index":14688,"token":false,"name":"Burning Sands","scryfallId":"9a5d5eef-6e3c-4907-a277-a13de2916e2b"},{"index":14690,"token":false,"name":"Abnormal Endurance","scryfallId":"de2de2bd-9ba7-4b6f-94c2-dafb2011a48e"},{"index":14691,"token":false,"name":"Consulate Skygate","scryfallId":"37ae4308-c062-4a6e-9375-f36539ca3941"},{"index":14694,"token":false,"name":"Nykthos Paragon","scryfallId":"2963205e-b181-44d1-809f-6577e29fa812"},{"index":14695,"token":false,"name":"Sedge Troll","scryfallId":"02ec317b-52a6-4490-80e5-a56826b06771"},{"index":14696,"token":false,"name":"Fires of Invention","scryfallId":"a12b16b0-f75f-42d8-9b24-947c1908e0f7"},{"index":14697,"token":false,"name":"Veteran's Sidearm","scryfallId":"9c1b3e7d-0fd8-4324-be7b-382e75ae9c17"},{"index":14704,"token":false,"name":"Heat Shimmer","scryfallId":"a432470c-7f68-4429-970a-3da8eabcf0b8"},{"index":14705,"token":false,"name":"Facevaulter","scryfallId":"a1a25f62-0ef5-4941-b9af-1ce1a63fb5e8"},{"index":14707,"token":false,"name":"Foreshadow","scryfallId":"d54c51de-bfac-4198-a7c4-37b4db74e525"},{"index":14708,"token":false,"name":"Goblin Sharpshooter","scryfallId":"d100f9ae-c1c7-48ce-acc1-5d2f40ccf539"},{"index":14709,"token":false,"name":"Angelic Arbiter","scryfallId":"6f2833f5-283d-4e86-8caf-f4f97432622e"},{"index":14710,"token":false,"name":"Coiling Woodworm","scryfallId":"341a70be-2dbf-4365-9c7a-e52cb62a74fa"},{"index":14712,"token":false,"name":"Unstable Footing","scryfallId":"d41c658e-68ec-4b55-bc5b-fd9fe8dbbdb3"},{"index":14715,"token":false,"name":"Evil Eye of Orms-by-Gore","scryfallId":"c31caa65-accd-4306-a975-1aaa5d98aeaa"},{"index":14716,"token":false,"name":"Cascade Bluffs","scryfallId":"30bd7f43-a0ed-4601-a6d8-f87e7bbd269d"},{"index":14717,"token":false,"name":"Providence","scryfallId":"2e5edd8d-8e10-4414-a326-95a672dfcff7"},{"index":14719,"token":false,"name":"Burning Oil","scryfallId":"47773da8-afe4-43e1-8355-6ab51451ee00"},{"index":14720,"token":false,"name":"Thornscape Apprentice","scryfallId":"ef276e2e-7e4d-48a0-af51-70cd843c6561"},{"index":14721,"token":false,"name":"Elvish Reclaimer","scryfallId":"39c431d7-d94b-46c4-bb89-f3db56214ab4"},{"index":14723,"token":false,"name":"Raksha Golden Cub","scryfallId":"a0a6f29d-67df-4006-a2a7-977389edec3d"},{"index":14725,"token":false,"name":"Parasitic Strix","scryfallId":"a36cd0c3-1955-41b1-9a9c-b30b31a2f094"},{"index":14727,"token":false,"name":"Sanctum of Stone Fangs","scryfallId":"d1439412-618c-483d-89b9-5ea37f0f1edc"},{"index":14729,"token":false,"name":"Aether Storm","scryfallId":"ce479e91-7b21-4312-a3c0-950d9f6dc029"},{"index":14731,"token":false,"name":"Swell of Courage","scryfallId":"0fddb694-d863-4364-9bf9-650d7be3b471"},{"index":14733,"token":false,"name":"Daring Sleuth // Bearer of Overwhelming Truths","scryfallId":"440f9f10-6999-4cff-ab98-8aed77813b07"},{"index":14737,"token":false,"name":"Last Kiss","scryfallId":"5ac5e741-3eee-4580-a931-7cad50c77934"},{"index":14742,"token":false,"name":"Feral Lightning","scryfallId":"2391265f-ef0c-463f-9371-5a0b71dbbb49"},{"index":14747,"token":false,"name":"Curse of Shallow Graves","scryfallId":"849996e2-fb62-428f-88f1-4ac419617395"},{"index":14751,"token":false,"name":"Brinelin, the Moon Kraken","scryfallId":"4b063dfd-5a80-48c9-8f7b-48d21a129a76"},{"index":14752,"token":false,"name":"Supply-Line Cranes","scryfallId":"764bd86e-4156-4c58-9ce0-ca3dffbc7298"},{"index":14757,"token":false,"name":"Talrand's Invocation","scryfallId":"c2cd809c-557a-42a5-950b-56b5b47b325b"},{"index":14761,"token":false,"name":"Soldevi Sage","scryfallId":"07392841-2df5-47f1-9868-edae3376e35a"},{"index":14762,"token":false,"name":"Psychic Possession","scryfallId":"e8364ce0-4c11-4af0-9f4b-e4c20d640dfc"},{"index":14763,"token":false,"name":"Citanul Hierophants","scryfallId":"905506cc-f77e-4214-8eb3-6f141997336c"},{"index":14764,"token":false,"name":"Doublecast","scryfallId":"be8875d8-fe8c-4721-aa8d-978bf72e9c26"},{"index":14765,"token":false,"name":"Veteran Adventurer","scryfallId":"e524ddf0-9a2f-4c1c-ae72-4b5b48f55645"},{"index":14766,"token":false,"name":"Rofellos's Gift","scryfallId":"a41347ba-b2e3-4d7e-8018-e6fd30243559"},{"index":14767,"token":false,"name":"Sima Yi, Wei Field Marshal","scryfallId":"0fa7239c-a833-4a8f-8010-d55386c1b057"},{"index":14768,"token":false,"name":"Blinding Powder","scryfallId":"f097fbb8-0db5-4ceb-8972-dcd21b3fb4d5"},{"index":14769,"token":false,"name":"Viscera Dragger","scryfallId":"6d6d2d84-7141-4485-8379-b3c71af47cd1"},{"index":14774,"token":false,"name":"Quandrix Command","scryfallId":"021b62d8-d160-47f5-bc51-0474f160d13f"},{"index":14775,"token":false,"name":"Shell Skulkin","scryfallId":"c0953373-66e1-4af1-a4ec-cc990e20a1de"},{"index":14777,"token":false,"name":"Desert of the True","scryfallId":"3f96abac-9876-4fb6-af56-6c0c47c9d86b"},{"index":14778,"token":false,"name":"Spiraling Duelist","scryfallId":"81ac77ab-e51a-4c5c-ab6b-3fb610a5fa27"},{"index":14779,"token":false,"name":"Blossom Dryad","scryfallId":"66a3645f-2b71-4816-a1f2-6cd4e987882f"},{"index":14780,"token":false,"name":"Hunters' Feast","scryfallId":"2fc0c0d2-bae4-4bec-b85c-498db713fd4a"},{"index":14781,"token":false,"name":"Oracle's Insight","scryfallId":"533d455a-88c9-4e41-b31e-5dcf821c6f6f"},{"index":14784,"token":false,"name":"Sejiri Refuge","scryfallId":"26eb0e81-2395-4e78-9947-a57725ce6e1c"},{"index":14785,"token":false,"name":"Aurelia's Fury","scryfallId":"cb65939d-296d-4aac-8a51-bce8be01dbee"},{"index":14786,"token":false,"name":"Plow Under","scryfallId":"fd12efad-be0e-41a8-a835-e2f309af244a"},{"index":14787,"token":true,"name":"Avatar Token (W, */*)","scryfallId":"863768b5-3cf9-415c-b4fd-371dc5afee18"},{"index":14788,"token":false,"name":"Ghirapur Osprey","scryfallId":"2186f382-2d68-4191-b490-a072f49eaabf"},{"index":14791,"token":false,"name":"Thunder of Hooves","scryfallId":"9e4f796a-6831-4d83-824d-88fd2148b4c1"},{"index":14793,"token":false,"name":"Barrage Tyrant","scryfallId":"adf81fdf-0499-4deb-a658-0cdf03595e99"},{"index":14794,"token":false,"name":"Knight of the Last Breath","scryfallId":"76fccf60-2df5-4c14-893f-41d3f86c545f"},{"index":14797,"token":false,"name":"Scar","scryfallId":"b34e3f7c-468a-456c-8ed0-0cb88f6d86fc"},{"index":14798,"token":false,"name":"Seal of Primordium","scryfallId":"fd5592ab-6883-4c5a-8d50-d9530d905b19"},{"index":14804,"token":false,"name":"Old Ghastbark","scryfallId":"5b5ab941-89cc-4fdd-a916-3a54651f6478"},{"index":14805,"token":false,"name":"Laelia, the Blade Reforged","scryfallId":"00760b58-8a7d-44fa-a5e7-9df54c21c77d"},{"index":14807,"token":false,"name":"Kaya's Guile","scryfallId":"179bd74b-c458-49d6-90ac-6075454e43dd"},{"index":14811,"token":false,"name":"Smitten Swordmaster // Curry Favor","scryfallId":"ea2a7e55-be1c-4552-92f0-c68f085f3a27"},{"index":14820,"token":false,"name":"Krosan Wayfarer","scryfallId":"5356e684-c2fc-465e-a16c-7300824d2a8d"},{"index":14824,"token":false,"name":"Ankle Shanker","scryfallId":"bb0cdd23-7f36-4d48-82a6-78ee94e19baf"},{"index":14828,"token":false,"name":"Rageblood Shaman","scryfallId":"ffaa31fd-5ba5-49d4-90b6-fafb9f1a8b3a"},{"index":14830,"token":false,"name":"Lab Rats","scryfallId":"3132c128-e0bd-4524-9526-914b3c7181fc"},{"index":14831,"token":false,"name":"Sarkhan's Dragonfire","scryfallId":"b96a7320-089a-4a7e-813f-49ca1620df76"},{"index":14832,"token":false,"name":"Tightening Coils","scryfallId":"a014dd06-626d-4917-8981-e0064718b571"},{"index":14835,"token":false,"name":"Windscouter","scryfallId":"bb70925a-4bef-4067-a1d7-79114aff5847"},{"index":14840,"token":false,"name":"Darksteel Juggernaut","scryfallId":"22c4148a-477d-419e-8d6b-5d558048e0db"},{"index":14841,"token":false,"name":"Puresight Merrow","scryfallId":"77f25680-d1b3-4bf6-83e2-2eea0b5419ad"},{"index":14844,"token":false,"name":"Hydrolash","scryfallId":"eeaaa583-bdd3-448a-921e-527df5f7f548"},{"index":14845,"token":false,"name":"Hellkite Overlord","scryfallId":"7e3c4f96-4a43-440d-b75f-2cdb7c24b92e"},{"index":14846,"token":false,"name":"Eye Collector","scryfallId":"2b9bb2f3-a7c7-4e8f-ba39-44e6acd9240b"},{"index":14847,"token":false,"name":"Campus Guide","scryfallId":"87a9a8a2-de81-441b-b501-418311b677f7"},{"index":14849,"token":false,"name":"Scour All Possibilities","scryfallId":"7c6466cb-d1d0-4461-b48d-7497bdc9c474"},{"index":14850,"token":false,"name":"Volcanic Upheaval","scryfallId":"8d90bd68-0521-4db3-b590-a4e007da9f2e"},{"index":14851,"token":false,"name":"Sinew Sliver","scryfallId":"6d568f39-3f18-4c31-b3b8-5c85a3d60528"},{"index":14852,"token":false,"name":"Mogg Cannon","scryfallId":"5ee64a77-5308-45c7-b865-400820968c74"},{"index":14853,"token":false,"name":"Ulasht, the Hate Seed","scryfallId":"066b677d-5a4c-4bb4-a3e0-1e616aafb9da"},{"index":14854,"token":false,"name":"Immersturm Raider","scryfallId":"77da4de2-4d34-40e5-8fc0-850aef05356b"},{"index":14855,"token":false,"name":"Deathrite Shaman","scryfallId":"70496f16-c4c0-4c03-beef-454eb4824cd1"},{"index":14856,"token":false,"name":"Gatstaf Arsonists // Gatstaf Ravagers","scryfallId":"6ab67098-d3d5-4799-ae03-c734244f370e"},{"index":14857,"token":false,"name":"Launch the Fleet","scryfallId":"bc3e52c0-2f79-4537-8f1c-70b68836bac0"},{"index":14865,"token":false,"name":"Tin Street Hooligan","scryfallId":"ad525bb3-15fd-4887-a3e7-0a036258dcc7"},{"index":14866,"token":false,"name":"Moonglove Winnower","scryfallId":"effb7761-98a8-4cb8-883a-ddcb91d30c08"},{"index":14874,"token":false,"name":"Quash","scryfallId":"62019ac4-a5a1-4a8c-bfb4-96e818949bbe"},{"index":14875,"token":false,"name":"Grotag Thrasher","scryfallId":"9275cb0a-e777-40f8-934a-a3f6e6071ec6"},{"index":14876,"token":false,"name":"Silence the Believers","scryfallId":"d6dc2bd1-a980-4eab-8bb3-1ce28c3f9ef4"},{"index":14877,"token":false,"name":"Archfiend of Depravity","scryfallId":"0ec85db7-c8ec-4730-b692-c140977436aa"},{"index":14882,"token":false,"name":"Persecute","scryfallId":"4f8e2be6-124d-412e-be34-aa4495a83e02"},{"index":14883,"token":false,"name":"Ravos, Soultender","scryfallId":"dde62b0c-ea15-4b25-9cb1-697cc2e459c0"},{"index":14884,"token":false,"name":"Tezzeret's Strider","scryfallId":"8cf74535-31e3-4d2c-b42a-072580fa4ba0"},{"index":14888,"token":false,"name":"Of One Mind","scryfallId":"c95fb136-f21d-4f3a-82b7-bcf490b7e90c"},{"index":14891,"token":false,"name":"Melancholy","scryfallId":"faa6fe9a-27ba-480f-84ce-b8d3306f0339"},{"index":14893,"token":false,"name":"Trueheart Duelist","scryfallId":"9eaa27ce-42e2-4b17-aea7-59f4ad246505"},{"index":14897,"token":false,"name":"Stormbound Geist","scryfallId":"040eddb0-fca2-41eb-ab07-c48d49385973"},{"index":14899,"token":false,"name":"Bonescythe Sliver","scryfallId":"a26bb68b-1830-470a-8cea-91edc7db0c57"},{"index":14900,"token":false,"name":"Charnelhoard Wurm","scryfallId":"1c0ec55e-88df-40f8-b08d-6185cdb4a3cc"},{"index":14901,"token":false,"name":"Vizier of Remedies","scryfallId":"3082a2e4-03a8-4b26-a48d-e299a8b5cc56"},{"index":14903,"token":false,"name":"Dimir Machinations","scryfallId":"14bfd72a-78c1-4167-89bf-ea1fccccd5b1"},{"index":14906,"token":false,"name":"Tariel, Reckoner of Souls","scryfallId":"c09448cf-70c9-494d-90e2-63a958b49bcd"},{"index":14910,"token":false,"name":"Moment of Heroism","scryfallId":"49217b63-0604-4351-b6de-add0e3e1dbc9"},{"index":14912,"token":false,"name":"Karfell Harbinger","scryfallId":"4911016c-b92a-47cc-9553-b424d7be196a"},{"index":14913,"token":false,"name":"Wheel of Misfortune","scryfallId":"74177b51-a300-49d9-8ea7-557b19cf80c7"},{"index":14914,"token":false,"name":"Guardian Augmenter","scryfallId":"5c0dfab3-e130-4295-bcc8-da11074497b5"},{"index":14917,"token":false,"name":"Gift of Doom","scryfallId":"ad6e1ba7-047b-41a3-8ab4-17a5c5476749"},{"index":14918,"token":false,"name":"Haze Frog","scryfallId":"72d8e000-5b4c-4340-ab85-7522107ab589"},{"index":14920,"token":false,"name":"Weapon Rack","scryfallId":"89ca22d2-3ba5-4173-9c8c-6587a901ff4a"},{"index":14926,"token":false,"name":"Grave Birthing","scryfallId":"0e996a30-3a4d-4a26-8386-f9eb9c999dc0"},{"index":14931,"token":false,"name":"Lens of Clarity","scryfallId":"3c82e2b8-f0f6-44da-83ee-8a671344ac62"},{"index":14932,"token":false,"name":"Icatian Phalanx","scryfallId":"93383078-b17f-47f5-a47a-cd6b5bfd8411"},{"index":14933,"token":false,"name":"Gibbering Fiend","scryfallId":"5113c437-3276-4591-b95e-c2afb9d6329a"},{"index":14938,"token":false,"name":"Iron Maiden","scryfallId":"ad925fb0-1d5c-44a0-8347-202a38c23107"},{"index":14940,"token":false,"name":"Tectonic Instability","scryfallId":"0476cc6b-ecc6-44d6-9f44-a90d4ee85daa"},{"index":14941,"token":false,"name":"Necropouncer","scryfallId":"4ed51dbc-bbec-4c78-a71e-26322a8d2439"},{"index":14942,"token":false,"name":"Tears of Rage","scryfallId":"070fa2d9-6238-49f6-9d63-75ae88ced8e5"},{"index":14943,"token":false,"name":"Staff of the Wild Magus","scryfallId":"e64f31e8-0b49-4510-a4df-2e0bea793d3e"},{"index":14944,"token":false,"name":"Ahn-Crop Invader","scryfallId":"2dea2466-5c7f-40ce-b749-100ae89d2c90"},{"index":14946,"token":false,"name":"Experimental Frenzy","scryfallId":"a7cee8be-589c-4661-88a6-966095844b50"},{"index":14948,"token":false,"name":"Dromar's Charm","scryfallId":"69f752d3-3f42-4275-be09-d257c89da70d"},{"index":14950,"token":false,"name":"Daggerdrome Imp","scryfallId":"6d9417ab-e2af-436b-9677-6e0120770d80"},{"index":14951,"token":false,"name":"Seismic Elemental","scryfallId":"998e5964-b758-413e-8360-4df4cb119f58"},{"index":14952,"token":false,"name":"Feldon of the Third Path","scryfallId":"44130046-cd48-42d5-8083-5e4e7dd37a7b"},{"index":14953,"token":false,"name":"One with Nothing","scryfallId":"d6f327ad-a6eb-41df-94c9-83607f73f6e7"},{"index":14954,"token":false,"name":"Demon of Wailing Agonies","scryfallId":"ace249fc-0d05-4132-8c0c-4abdc3b42119"},{"index":14955,"token":false,"name":"Abzan Guide","scryfallId":"fadcff4d-7b5d-4bbb-a893-0002c06731e5"},{"index":14957,"token":false,"name":"Steel Hellkite","scryfallId":"90410a4b-59a5-4e11-8034-91a596098b61"},{"index":14959,"token":false,"name":"Stronghold Assassin","scryfallId":"cc0f043c-efb3-4392-ae25-b3ec180b0cb2"},{"index":14960,"token":false,"name":"Bedeck // Bedazzle","scryfallId":"4411a717-fda0-45f1-a8ba-618884de5ce2"},{"index":14961,"token":true,"name":"Goblin Soldier Token (R/W, 1/1)","scryfallId":"3022b41d-05c1-452e-a1cd-5ec5a7f4d79d"},{"index":14962,"token":false,"name":"Academy Drake","scryfallId":"f8bacb12-da46-4b00-804f-9ff6bff452bc"},{"index":14963,"token":false,"name":"Krovikan Scoundrel","scryfallId":"1b672836-dba8-4a32-ac04-616644268534"},{"index":14964,"token":false,"name":"Vance's Blasting Cannons // Spitfire Bastion","scryfallId":"0f4d3cec-bd91-4edd-9b6b-568e272e7891"},{"index":14965,"token":false,"name":"Bone Pit Brute","scryfallId":"6075e0a3-a0ab-4a11-8ad2-7dabb071d309"},{"index":14967,"token":false,"name":"Astral Cornucopia","scryfallId":"182864e2-81ef-41bc-94cd-b0ea67f60bda"},{"index":14970,"token":false,"name":"Grim Return","scryfallId":"15b69f74-3b54-4db4-abf3-b71db8cc9562"},{"index":14971,"token":false,"name":"Kathari Bomber","scryfallId":"3dafece7-c3a0-465b-84c2-e095890a7a8b"},{"index":14973,"token":false,"name":"Iron-Barb Hellion","scryfallId":"0cb36352-2f16-4572-b1aa-dc28b11f4229"},{"index":14977,"token":false,"name":"Ravenous Harpy","scryfallId":"676ec702-75c4-4733-b500-eb15406778bb"},{"index":14981,"token":false,"name":"Xenic Poltergeist","scryfallId":"a72dd03f-9e54-4403-8b7d-52475785cb65"},{"index":14983,"token":false,"name":"Grazing Gladehart","scryfallId":"fc1b8c33-05f5-426f-99eb-0e1e185c7862"},{"index":14985,"token":false,"name":"Increasing Ambition","scryfallId":"c8f508dc-7c7d-47e8-a4ef-0e8fd99cbd74"},{"index":14987,"token":false,"name":"Wind Strider","scryfallId":"613a8ab1-9c5e-4b56-aa51-daeb8c1983b9"},{"index":14988,"token":false,"name":"Energy Field","scryfallId":"81ff5770-b207-41e1-97b7-b9347c72b407"},{"index":14989,"token":false,"name":"Watchwolf","scryfallId":"95e5828a-3e54-4b9c-9e84-21880930f2d5"},{"index":14990,"token":false,"name":"Garruk, Primal Hunter","scryfallId":"9945307b-d49d-4d21-bba0-2aebba68d57a"},{"index":14991,"token":false,"name":"Cloak of Confusion","scryfallId":"f5fd387e-d77f-4502-8d2e-752a53f577fc"},{"index":14993,"token":false,"name":"Rohgahh of Kher Keep","scryfallId":"1429cc3d-f6a2-4011-b716-5c3e0cf251d0"},{"index":14994,"token":false,"name":"Venerated Loxodon","scryfallId":"93599fba-7c53-4621-85b5-6434be077bf6"},{"index":14998,"token":false,"name":"Dragon Engine","scryfallId":"42c1fd91-001d-4c94-bb0a-d3fc570c7f12"},{"index":14999,"token":false,"name":"Shrine of the Forsaken Gods","scryfallId":"9da2af9a-28c4-4edd-95c4-cc09c2de4adc"},{"index":15000,"token":false,"name":"Tidal Influence","scryfallId":"b2192c7b-ef6f-4ff6-9017-b1a125340517"},{"index":15002,"token":false,"name":"Pardic Miner","scryfallId":"4a734abe-7bfd-4153-be2d-1c289fb60996"},{"index":15006,"token":false,"name":"Gruul Scrapper","scryfallId":"377b56f3-e8d1-4f4b-b4ff-9c9a268979c6"},{"index":15007,"token":false,"name":"Desperate Ritual","scryfallId":"0827c728-5526-4abe-ad21-311594a0bc13"},{"index":15016,"token":false,"name":"Cephalid Snitch","scryfallId":"33d989b2-0198-4e5b-8aad-ee939191dd28"},{"index":15017,"token":false,"name":"Gallant Cavalry","scryfallId":"e388c433-3a37-45f6-825a-d13d2223b6f7"},{"index":15019,"token":false,"name":"Cherished Hatchling","scryfallId":"0a14fe6c-b272-415b-974d-c60d016ab786"},{"index":15023,"token":false,"name":"Vodalian Knights","scryfallId":"68d97e1b-2526-4740-b354-f158734d1f72"},{"index":15025,"token":false,"name":"Mistfolk","scryfallId":"4f3f4d4e-ca4a-4fba-b9fd-cd1d9457cfa1"},{"index":15027,"token":false,"name":"Spitting Slug","scryfallId":"d98e413b-35bb-424f-9ae9-3319cf433785"},{"index":15029,"token":false,"name":"Ground Assault","scryfallId":"7e5d3a87-89f6-4051-918c-736b0a4b8ec2"},{"index":15033,"token":false,"name":"Precision Bolt","scryfallId":"a59b4e5b-e9e0-4507-b9e7-8fba7e3a54f9"},{"index":15038,"token":false,"name":"Sea Gate Stormcaller","scryfallId":"1e14e677-9bfa-4bcc-9772-8e7758d7538a"},{"index":15041,"token":false,"name":"Teferi, Temporal Archmage","scryfallId":"c86be64e-79d3-4ba8-8d28-f01c994a8a7c"},{"index":15044,"token":false,"name":"Hypnotic Cloud","scryfallId":"a7502ea2-7555-449e-baee-6ecef5573a3b"},{"index":15045,"token":false,"name":"Exhume","scryfallId":"41c79afa-8f88-48bd-9122-984327d3e54d"},{"index":15047,"token":false,"name":"Turn to Dust","scryfallId":"fcfcb643-bbd1-419a-b1a8-daae1062c8bc"},{"index":15048,"token":false,"name":"Cycle of Life","scryfallId":"49b53861-97aa-4fff-9526-7d496d1717a4"},{"index":15049,"token":false,"name":"Struggle for Skemfar","scryfallId":"a67747a9-3299-4b4a-a4e0-e8a269c4f927"},{"index":15053,"token":false,"name":"Appetite for Brains","scryfallId":"ef9b4e72-2ac9-444c-81a9-756c5d3f2d65"},{"index":15058,"token":false,"name":"Rockslide Elemental","scryfallId":"d4f26025-8777-41a2-a871-ea8d1af164ae"},{"index":15059,"token":false,"name":"Spectral Sliver","scryfallId":"bec97e3c-7b75-4abb-a50e-86bc8cc3bf06"},{"index":15060,"token":false,"name":"Necromancer's Covenant","scryfallId":"10e39147-6261-4e49-b6f2-28584582489f"},{"index":15062,"token":false,"name":"Echo of Eons","scryfallId":"ff590af2-2d6c-4f16-a9b8-1a6dab6e9ad5"},{"index":15063,"token":false,"name":"Burlfist Oak","scryfallId":"3d0ec3bd-d894-4861-abcb-7b2e4f4de05c"},{"index":15064,"token":false,"name":"Rock Badger","scryfallId":"dff05df8-76f5-48c6-ac96-7b4e6a7050f6"},{"index":15065,"token":false,"name":"Ticking Gnomes","scryfallId":"db6358cf-fcb9-42af-9755-dd1f39bfc8ff"},{"index":15069,"token":false,"name":"Dryad Sophisticate","scryfallId":"0b5bf5ce-f7f8-47cb-abb8-f14ce5f1af67"},{"index":15070,"token":false,"name":"Call of the Wild","scryfallId":"3332b35c-fd4f-4195-baee-e759dee6a682"},{"index":15075,"token":false,"name":"Parhelion II","scryfallId":"813b991e-b812-4fee-8f21-c739292ade53"},{"index":15079,"token":false,"name":"Might of Murasa","scryfallId":"42914fd9-e56e-4c3e-a445-fdfa45a45178"},{"index":15084,"token":false,"name":"Iron League Steed","scryfallId":"c47993b2-694d-4697-8b06-64aa5663598b"},{"index":15087,"token":true,"name":"Marit Lage Token (B, 20/20)","scryfallId":"105e687e-7196-4010-a6b7-cfa42d998fa4"},{"index":15088,"token":false,"name":"Golden Guardian // Gold-Forge Garrison","scryfallId":"7b597c97-dad9-4caf-adfc-b5a33dad9c8c"},{"index":15090,"token":false,"name":"Thundercloud Shaman","scryfallId":"5864f207-2878-461b-8ff6-76475abc324d"},{"index":15091,"token":false,"name":"Imperial Recruiter","scryfallId":"a5c8b70c-3e9e-4941-9509-0e3a5b1bbc95"},{"index":15092,"token":false,"name":"Mind Carver","scryfallId":"105b6e18-bcd8-43b7-870d-6c7e5c06f99b"},{"index":15097,"token":false,"name":"Blinkmoth Well","scryfallId":"e4c79155-b6d8-46df-891f-487b24c4e0d5"},{"index":15103,"token":true,"name":"2003 World Championships Ad","scryfallId":"a7040e1c-cbea-4597-89f2-7830714cfcae"},{"index":15106,"token":false,"name":"Aura Mutation","scryfallId":"0526debc-6eca-413e-b68c-50aa70927058"},{"index":15107,"token":false,"name":"Mindless Null","scryfallId":"b5d43b60-5bbc-4f9d-a96b-8d886b0c6dbd"},{"index":15111,"token":false,"name":"Arcane Encyclopedia","scryfallId":"0ce4702d-f65b-413e-99da-112f632a0a63"},{"index":15112,"token":false,"name":"Wall of Essence","scryfallId":"2f237426-a657-4234-9f79-0a06558eeb39"},{"index":15113,"token":false,"name":"Tomb Hex","scryfallId":"9beaaa66-0dae-4631-895d-06570834ba7c"},{"index":15114,"token":false,"name":"Flamekin Bladewhirl","scryfallId":"1b6ea1c8-ca58-4240-adb7-71cd49664414"},{"index":15120,"token":false,"name":"Corpse Traders","scryfallId":"4cd6d782-ce5a-4994-8310-34faf9c41de2"},{"index":15122,"token":false,"name":"Eyeblight Massacre","scryfallId":"be00670b-64a8-428a-8db0-9119efddaa1b"},{"index":15126,"token":false,"name":"Daredevil Dragster","scryfallId":"6a178595-f051-4ad6-86c4-597ab738be85"},{"index":15127,"token":false,"name":"Ego Erasure","scryfallId":"f577831b-2aa2-44a1-bd6b-ef111bc2e211"},{"index":15128,"token":false,"name":"Merfolk Branchwalker","scryfallId":"2c6f0d4a-4827-47b6-8af6-803949c195f8"},{"index":15131,"token":false,"name":"Thermo-Alchemist","scryfallId":"c9cac6a6-ded0-47cb-88d2-8838db9cc6b2"},{"index":15133,"token":false,"name":"Oketra's Last Mercy","scryfallId":"c4d3bf26-6003-4699-a26e-b3b5bcd3e8dc"},{"index":15135,"token":false,"name":"Paradise Druid","scryfallId":"7810e5c8-cb96-46aa-831a-c04ed7d771ed"},{"index":15137,"token":false,"name":"Virulent Wound","scryfallId":"7ae09e1a-c257-45e9-88c8-7b1a7a6d714b"},{"index":15142,"token":false,"name":"Lagac Lizard","scryfallId":"b47e9cfa-5547-4ef3-9e36-8d0f36dfa59a"},{"index":15144,"token":false,"name":"Kor Dirge","scryfallId":"b6e1ec29-508f-4e5e-b601-79e27743bcea"},{"index":15147,"token":false,"name":"Pallimud","scryfallId":"61adc314-cfb2-4fdd-925c-cc1dc4692992"},{"index":15150,"token":false,"name":"Confront the Past","scryfallId":"9975e3c0-cd32-4658-9802-3749a1a475aa"},{"index":15151,"token":true,"name":"Devil Token (R, 1/1)","scryfallId":"3e78c4b8-371b-43d7-a315-fb299704aa60"},{"index":15152,"token":false,"name":"Frozen Shade","scryfallId":"cbd0b4ff-f49f-4079-991a-f66d1220235d"},{"index":15153,"token":false,"name":"Vitality Hunter","scryfallId":"2bec0d43-f321-49eb-9402-83632d00d4be"},{"index":15154,"token":false,"name":"From Beyond","scryfallId":"f5559960-e306-4992-b607-9654327c4507"},{"index":15155,"token":false,"name":"Merfolk Windrobber","scryfallId":"112077b8-1514-4320-a70f-b23f3c7ce18a"},{"index":15156,"token":false,"name":"Dementia Sliver","scryfallId":"955028d2-33df-4295-8ee3-572e5979b04c"},{"index":15157,"token":false,"name":"Boros Challenger","scryfallId":"d04c0902-7882-46c2-b228-0aa6c63b6684"},{"index":15159,"token":false,"name":"Razor Swine","scryfallId":"2fb022a3-5f9e-491e-8340-087e33f927d6"},{"index":15162,"token":false,"name":"Benalish Trapper","scryfallId":"2ec50bd8-cc23-41b9-9a42-03e28801a4a6"},{"index":15164,"token":false,"name":"Righteous Indignation","scryfallId":"c1fb6335-cfd8-438c-b936-09b850d61b28"},{"index":15165,"token":false,"name":"Steelform Sliver","scryfallId":"c15d6329-ffb1-43fd-8558-60c8315f5b91"},{"index":15166,"token":false,"name":"Sunder Shaman","scryfallId":"9bb6a8bb-9eec-4f9b-a5a8-604631e4b823"},{"index":15167,"token":false,"name":"Messenger's Speed","scryfallId":"93d7f033-217f-4fb3-a57b-e32291257ec8"},{"index":15169,"token":false,"name":"Blood Rites","scryfallId":"89d77b63-eeee-4d8a-9622-b1ea36dc70de"},{"index":15172,"token":false,"name":"Jaya's Greeting","scryfallId":"ec66f169-5cf9-4d7c-a5ab-c64fc4801358"},{"index":15176,"token":false,"name":"Sigiled Starfish","scryfallId":"85a61f99-44f8-4a2b-b7f2-7899a694552d"},{"index":15177,"token":false,"name":"Thundering Spineback","scryfallId":"a2e40ded-6daf-423e-8d74-2c6d448e0853"},{"index":15178,"token":false,"name":"Deep Spawn","scryfallId":"e70373b7-ced5-4d88-9ff3-04b6f59c69c9"},{"index":15180,"token":false,"name":"Highborn Ghoul","scryfallId":"fbe999ed-b419-440c-9189-1046f43d7b87"},{"index":15182,"token":false,"name":"Aetherflux Reservoir","scryfallId":"96b6b2e1-c3e6-464c-8a13-b15deb34e862"},{"index":15183,"token":false,"name":"Angel of the Dawn","scryfallId":"f4bae0e4-1143-4dc4-afb1-e6b4201ff101"},{"index":15184,"token":false,"name":"Vernal Bloom","scryfallId":"80a49c80-02ee-4d5a-83cb-53ac3e7870e7"},{"index":15187,"token":false,"name":"Gustrider Exuberant","scryfallId":"5343e6f2-7db7-4731-8e1b-70bf74316a79"},{"index":15188,"token":false,"name":"Hallowed Burial","scryfallId":"c42fad4b-caeb-4aa2-9586-cb26bdec56cd"},{"index":15189,"token":false,"name":"Stolen Goods","scryfallId":"57b6f501-a5f8-4a54-bd77-d9b11ab430ff"},{"index":15190,"token":false,"name":"Netcaster Spider","scryfallId":"07c95074-32c8-426e-b615-8ad5427c6c1c"},{"index":15195,"token":true,"name":"Cleric Token (W, 2/1)","scryfallId":"7e4c9173-e530-4237-a03b-9aeca60ab0e4"},{"index":15199,"token":false,"name":"Lead-Belly Chimera","scryfallId":"5d89b377-80d2-42a0-b84e-a455a72ed9fe"},{"index":15201,"token":false,"name":"Dromoka Dunecaster","scryfallId":"fc98e542-4bcc-43e1-9616-64ce40348a34"},{"index":15202,"token":false,"name":"Isolate","scryfallId":"3d9ce5eb-eaeb-4c93-8d31-4aeb8fcc4cce"},{"index":15203,"token":false,"name":"Colfenor, the Last Yew","scryfallId":"a3a2c725-6133-4264-96ac-d80fe85b3632"},{"index":15204,"token":false,"name":"Hound of Griselbrand","scryfallId":"0fe68bce-6207-4fd1-9e82-a18fd2d6ddca"},{"index":15206,"token":false,"name":"Future Sight","scryfallId":"63b54145-6686-4814-a617-7d8ed661a72c"},{"index":15208,"token":false,"name":"Angelic Armaments","scryfallId":"92824de1-23f2-44c6-b8ab-46db94b8f79e"},{"index":15210,"token":false,"name":"Gruesome Fate","scryfallId":"3ea07116-afe7-4d88-a530-54424e791b74"},{"index":15211,"token":false,"name":"Dwarven Armory","scryfallId":"7d14a430-6e08-40cf-970a-cae84bba6ef7"},{"index":15212,"token":false,"name":"Dusk Imp","scryfallId":"b7f264f6-832c-42fe-8642-00ee0f009c08"},{"index":15214,"token":false,"name":"Consecrate Land","scryfallId":"a48304bb-ed7b-474b-a245-4eee18ecd0a4"},{"index":15215,"token":false,"name":"Take Up Arms","scryfallId":"fc783f49-f58a-4783-87b4-4dbc7e896f2e"},{"index":15216,"token":false,"name":"Martyred Rusalka","scryfallId":"b445f608-d825-459a-835d-878da5c92335"},{"index":15221,"token":false,"name":"Northern Paladin","scryfallId":"4ba8493c-ae69-48d1-a050-a887ae27c83f"},{"index":15222,"token":false,"name":"Grixis Battlemage","scryfallId":"4dbd260c-a625-42a4-8192-27e42e18ac0f"},{"index":15223,"token":false,"name":"Crack the Earth","scryfallId":"8ab16152-4617-4deb-b995-195e21f8f485"},{"index":15225,"token":false,"name":"Nahiri, Heir of the Ancients","scryfallId":"408be425-b8a6-4c03-b2a6-7ff7bd6555e0"},{"index":15226,"token":false,"name":"Reach of Branches","scryfallId":"034215f1-62f5-49ce-a818-44577138b508"},{"index":15227,"token":false,"name":"Barrage of Expendables","scryfallId":"b9e0912d-b4b9-497c-bce7-ed80b79bab32"},{"index":15232,"token":false,"name":"Returned Centaur","scryfallId":"1067cf71-a270-4b1b-aa06-0ec0e732ed16"},{"index":15233,"token":false,"name":"Spiked Baloth","scryfallId":"522777b1-a89f-4969-a962-0137018ec86c"},{"index":15234,"token":false,"name":"Master Splicer","scryfallId":"f2c44c1e-60b8-49f7-af9a-d23dcd8a3771"},{"index":15235,"token":false,"name":"Jungle Wayfinder","scryfallId":"b9f143f7-77e8-43c3-9da6-0d71d446a349"},{"index":15240,"token":true,"name":"Shadows Over Innistrad Checklist 1","scryfallId":"4d323ead-24f5-42e4-9e23-aa14eb66264d"},{"index":15241,"token":false,"name":"Stuffy Doll","scryfallId":"14ca7425-a499-4864-b955-369ef2577849"},{"index":15242,"token":false,"name":"Whitesun's Passage","scryfallId":"a74d1bf3-4630-4be0-af5f-590789d27a0c"},{"index":15245,"token":false,"name":"Scorned Villager // Moonscarred Werewolf","scryfallId":"6f35e364-81d9-4888-993b-acc7a53d963c"},{"index":15247,"token":false,"name":"Invincible Hymn","scryfallId":"712c64bc-ba0c-4bab-9329-54805f4efa8a"},{"index":15248,"token":false,"name":"Spontaneous Flight","scryfallId":"3dc24dd4-d259-4687-8247-f56aa7abb5b9"},{"index":15251,"token":false,"name":"Nightmare Shepherd","scryfallId":"87141d83-50b4-4aeb-bfc5-8baa8b31a47a"},{"index":15254,"token":false,"name":"Karametra's Acolyte","scryfallId":"579f4800-8fd0-44c8-ab46-acf4a5d20384"},{"index":15260,"token":false,"name":"Nantuko Mentor","scryfallId":"48cb5283-d384-490e-a0a5-2d10c1acc8cc"},{"index":15262,"token":false,"name":"Mindmoil","scryfallId":"0ccc79f7-2f35-4daf-a0c2-775f5fa6c249"},{"index":15263,"token":false,"name":"Gyrus, Waker of Corpses","scryfallId":"9278b339-8700-4b25-8c89-8f3888a73290"},{"index":15264,"token":false,"name":"Volrath's Dungeon","scryfallId":"a4ab28e1-74e1-4c4e-920f-a658c6a44d75"},{"index":15266,"token":false,"name":"Krovikan Vampire","scryfallId":"7e8cbd3c-e88d-4d08-8553-20dfbad5f833"},{"index":15270,"token":false,"name":"Sandsower","scryfallId":"7aa4d334-9a16-4fe3-ac7b-eb14861ca769"},{"index":15271,"token":false,"name":"Sphere of Purity","scryfallId":"392944d5-bff1-4125-86db-68d05682a430"},{"index":15273,"token":false,"name":"Retreat to Hagra","scryfallId":"c80046c2-021f-448c-9f54-2a1a100ec0aa"},{"index":15274,"token":false,"name":"Vexing Scuttler","scryfallId":"1c3dd0aa-f6e9-435c-af64-20e9de67efe9"},{"index":15275,"token":false,"name":"Bone Saw","scryfallId":"b83a19c7-26ad-408d-aafd-5c76ea010b96"},{"index":15276,"token":false,"name":"Enclave Cryptologist","scryfallId":"eda2af80-3d76-4dbb-8d70-7b652f27f29b"},{"index":15277,"token":false,"name":"Metallic Rebuke","scryfallId":"9e570f79-9710-4c2f-838e-a2ac33fd7000"},{"index":15280,"token":false,"name":"Earwig Squad","scryfallId":"6ed366b1-a289-4b30-9326-738caaf1cc4c"},{"index":15282,"token":false,"name":"Honored Hydra","scryfallId":"21c33902-a06a-4321-bdf4-cea5494fda63"},{"index":15289,"token":false,"name":"Folk of the Pines","scryfallId":"ee55f1d0-5bb7-4c11-8534-76b3efd12169"},{"index":15291,"token":false,"name":"Jace's Defeat","scryfallId":"c6b103c1-9b25-4bfe-9081-570977e9fdad"},{"index":15293,"token":false,"name":"Index","scryfallId":"01491b39-283b-438f-8c7c-8df1285e9a83"},{"index":15299,"token":false,"name":"Proud Mentor","scryfallId":"a41ff277-d465-4e30-8291-3d5ca5763cff"},{"index":15300,"token":false,"name":"Flame-Kin War Scout","scryfallId":"c8092518-99ba-43b8-b5e9-8b46f1679696"},{"index":15301,"token":false,"name":"Ghosthelm Courier","scryfallId":"cd6cc30a-9ed4-4f36-95cb-6f0a2b8dce02"},{"index":15303,"token":false,"name":"Spirit of Malevolence","scryfallId":"cf3765b7-11e2-4837-b5e5-ca24adc0e33c"},{"index":15304,"token":false,"name":"Zuo Ci, the Mocking Sage","scryfallId":"5c4c2944-30f0-4928-87fb-4b4ccad9e72f"},{"index":15305,"token":false,"name":"Specter's Wail","scryfallId":"d1637b62-e364-4250-aad5-841c6a47a11e"},{"index":15310,"token":false,"name":"Relic Vial","scryfallId":"4b9ae607-e0bc-4415-ad58-65944848bbe9"},{"index":15313,"token":false,"name":"Benalish Cavalry","scryfallId":"a0fd40fa-4144-41b4-b441-a71d09a11305"},{"index":15314,"token":false,"name":"Rishadan Footpad","scryfallId":"51865d7a-7075-47a2-9b1e-9dabee9602ad"},{"index":15319,"token":false,"name":"Sanity Grinding","scryfallId":"7d3e377f-6bb7-4fa1-b58b-7e2af06ca4b7"},{"index":15320,"token":false,"name":"Ruin Crab","scryfallId":"738ce273-c938-42d2-83b2-c4f5f4000b0b"},{"index":15324,"token":true,"name":"Kraken Token (U, 8/8)","scryfallId":"c3365aea-823d-44a9-94d3-ed2a31d85f34"},{"index":15326,"token":false,"name":"Light of Day","scryfallId":"3d5af047-7d98-4ba9-9ce1-c67563c19866"},{"index":15327,"token":false,"name":"Soulshriek","scryfallId":"5c3bf717-2b88-4704-a7e9-f62dbb3d3d3d"},{"index":15328,"token":false,"name":"Elder Land Wurm","scryfallId":"fabf3c77-cbd9-42ac-ace2-791e04b6eaea"},{"index":15329,"token":false,"name":"Primal Druid","scryfallId":"e928f694-c53b-46c5-8390-fa24b53f559c"},{"index":15330,"token":false,"name":"Burning Prophet","scryfallId":"01c5b095-13c9-4673-bf0c-553de455e521"},{"index":15332,"token":false,"name":"Knacksaw Clique","scryfallId":"22353590-f248-460e-a1a5-0b7431a4c82d"},{"index":15334,"token":false,"name":"Dreadship Reef","scryfallId":"bbf58ba5-c7e4-40df-99b2-5fa4273b85cf"},{"index":15340,"token":false,"name":"Floodtide Serpent","scryfallId":"7a2a4b24-096a-4d36-a872-73fa4552bb35"},{"index":15341,"token":false,"name":"River Bear","scryfallId":"b8508e3b-a934-4795-a2df-07e792f2685f"},{"index":15343,"token":false,"name":"Tasigur's Cruelty","scryfallId":"169748df-10ac-4db4-ba94-192345c6fad3"},{"index":15348,"token":false,"name":"Putrid Goblin","scryfallId":"333406d5-abcc-4629-a33b-395d0662ba1b"},{"index":15350,"token":false,"name":"Grotesque Mutation","scryfallId":"ce84d54c-ef63-4b90-a2b6-99a4aa21c02d"},{"index":15356,"token":false,"name":"Hedron Rover","scryfallId":"c0a36448-ca96-4c10-baf9-89c248c3510b"},{"index":15357,"token":false,"name":"Grizzly Fate","scryfallId":"75d22bb3-824e-4699-8352-42392af307d1"},{"index":15358,"token":true,"name":"Copy // Horror","scryfallId":"a020dc47-3747-4123-9954-f0e87a858b8c"},{"index":15360,"token":false,"name":"Magus of the Moat","scryfallId":"59264c1f-38f1-408b-a6e9-b7c6dcb46103"},{"index":15362,"token":false,"name":"Aven of Enduring Hope","scryfallId":"02c1310c-1b54-42dd-bf24-889770fa2ded"},{"index":15363,"token":false,"name":"Morinfen","scryfallId":"b5006ad3-16ca-4be3-8d56-d4fe4e9e0a44"},{"index":15365,"token":false,"name":"Sphinx's Revelation","scryfallId":"404d9413-ef57-4b6e-8584-48a1dc7fe6f1"},{"index":15366,"token":false,"name":"Fire Drake","scryfallId":"d3419db6-1c38-4aa4-b953-1dde7d22b927"},{"index":15367,"token":false,"name":"Lotleth Troll","scryfallId":"3b628197-f26c-457a-b9a4-c1f1d3e02f3d"},{"index":15368,"token":false,"name":"Goblin Gardener","scryfallId":"7eab0544-9c0b-4365-86bb-bc0c3e9d87ce"},{"index":15371,"token":false,"name":"Noetic Scales","scryfallId":"18506777-cd69-42f6-99c9-cde9b0958868"},{"index":15372,"token":false,"name":"Orcish Vandal","scryfallId":"a6ac010e-bcd9-4e40-91f5-3f6058dca104"},{"index":15374,"token":false,"name":"Spike Drone","scryfallId":"5d45a3d3-a114-496e-b575-504179a297cc"},{"index":15376,"token":false,"name":"Soldevi Golem","scryfallId":"5d51269c-5b79-4833-aed4-2934d5e15e1a"},{"index":15377,"token":false,"name":"Teferi's Sentinel","scryfallId":"058304f4-f08a-4b3a-ae74-c06f4968c99a"},{"index":15379,"token":false,"name":"Miasmic Mummy","scryfallId":"47ef9e66-678c-4e8d-9ca7-3f2b72b9468c"},{"index":15380,"token":false,"name":"Ephemerate","scryfallId":"deda067d-0026-48f4-a5d4-c1f2ac4ab16a"},{"index":15388,"token":false,"name":"Kami of Tattered Shoji","scryfallId":"dc6deb57-4ee3-4716-8644-28283704f994"},{"index":15389,"token":false,"name":"Commune with the Gods","scryfallId":"abf3916b-ddbc-4711-8636-833026d62a2a"},{"index":15391,"token":false,"name":"Plated Geopede","scryfallId":"fd8b5c0c-acda-411e-9f17-6d9292628a56"},{"index":15393,"token":false,"name":"Elven Lyre","scryfallId":"2ed92578-7e25-4079-aa29-f269606f149c"},{"index":15396,"token":false,"name":"Prophetic Titan","scryfallId":"468b92ae-eb84-4548-a5e5-a07c79b77f7f"},{"index":15397,"token":false,"name":"Makindi Shieldmate","scryfallId":"e76e9555-966c-4fc3-9ef4-a0154ccb8329"},{"index":15398,"token":false,"name":"Desert Twister","scryfallId":"5603ce3f-3b39-4433-8ccf-44b44dc99de5"},{"index":15399,"token":false,"name":"Mizzix's Mastery","scryfallId":"89978bd5-8222-4052-9625-3a5db81baa27"},{"index":15403,"token":false,"name":"Savage Alliance","scryfallId":"b5255da8-8511-48a7-98e5-ba43ca6e8681"},{"index":15404,"token":false,"name":"Mesmeric Orb","scryfallId":"e24fbdbb-f2ae-4823-9d2a-4c505332aa5b"},{"index":15405,"token":false,"name":"Fold into Aether","scryfallId":"615157d6-0160-417b-b06c-0e253b306c37"},{"index":15406,"token":false,"name":"Elder Druid","scryfallId":"aa88ff5b-44df-40eb-b0bb-37936ae0d854"},{"index":15408,"token":false,"name":"Rix Maadi, Dungeon Palace","scryfallId":"c0f56ce7-1974-417e-a4cb-c9d9a9509039"},{"index":15411,"token":false,"name":"Glowrider","scryfallId":"9ad94e39-0aac-46bb-a7f2-bd88c537cb9c"},{"index":15412,"token":false,"name":"Field of Souls","scryfallId":"9816a3ef-e2a8-4d97-afbf-d190a62265bf"},{"index":15413,"token":false,"name":"Bone Dragon","scryfallId":"004b44af-9b27-4689-a6b6-bcd3ad0aca7e"},{"index":15414,"token":false,"name":"Sigiled Contender","scryfallId":"5ba81e67-8fa5-441c-bf14-2d75c168a617"},{"index":15415,"token":false,"name":"Spitfire Handler","scryfallId":"efe72820-952f-4c53-9ee7-ea7ea54fc848"},{"index":15419,"token":false,"name":"Titan's Strength","scryfallId":"0e48f309-8e56-4741-a9ff-e899dafb333a"},{"index":15420,"token":false,"name":"Kavu Lair","scryfallId":"f4581b53-23a0-4ca6-a77c-97d79e7a6570"},{"index":15427,"token":false,"name":"Renowned Weaver","scryfallId":"240830be-53f8-4f46-a0fb-6ecc439d1349"},{"index":15429,"token":false,"name":"Balduvian Conjurer","scryfallId":"5b616963-fac0-451c-8df4-2cacc9466b17"},{"index":15430,"token":true,"name":"Blank Card","scryfallId":"8d7f421e-6947-4509-a179-8522fa4a29f8"},{"index":15431,"token":false,"name":"Shrike Harpy","scryfallId":"1c2b1eeb-6cc9-48a7-a068-afa1011c45f2"},{"index":15433,"token":false,"name":"Blightsoil Druid","scryfallId":"b696f2e5-563f-4f77-b0ae-049ab1e4ba44"},{"index":15435,"token":false,"name":"Amphin Mutineer","scryfallId":"c7be9d06-3651-47f4-9e44-00ecd4a15e3c"},{"index":15436,"token":false,"name":"Stromgald Cabal","scryfallId":"0a4cf65d-c96a-40e6-8a26-da9885b5bc98"},{"index":15438,"token":false,"name":"Dust Stalker","scryfallId":"2322e8c3-a983-4b3d-b6fa-f6b67f6fa8cc"},{"index":15441,"token":false,"name":"Reverent Mantra","scryfallId":"48364e19-a3ea-4980-925f-7918e57315f1"},{"index":15442,"token":false,"name":"Swan Song","scryfallId":"9d968dde-c406-48ef-a1ab-373aebc24693"},{"index":15443,"token":false,"name":"Ob Nixilis's Cruelty","scryfallId":"94db72a8-57f7-4f17-9f09-cae90ef50304"},{"index":15445,"token":false,"name":"Cloven Casting","scryfallId":"c62ee3ea-8b85-4b14-87ae-7fca1d98b98b"},{"index":15446,"token":false,"name":"Sunscape Familiar","scryfallId":"9621f341-bf85-4b77-bf19-2fb013b4c955"},{"index":15447,"token":false,"name":"Ethercaste Knight","scryfallId":"125126e1-1e48-42ed-ac94-02f62ab13d05"},{"index":15450,"token":false,"name":"Kataki, War's Wage","scryfallId":"4d84ac44-01d8-415e-af69-7c608ac8ae20"},{"index":15451,"token":false,"name":"Pact of Negation","scryfallId":"3ab90299-547a-4538-a31c-f55afab10c50"},{"index":15452,"token":false,"name":"Dimir Locket","scryfallId":"dfb6810b-9bc9-43c5-8cd9-817b12ee3110"},{"index":15454,"token":false,"name":"Icy Prison","scryfallId":"39a7e496-8d2e-49db-b298-475d9017537a"},{"index":15455,"token":false,"name":"Tattermunge Witch","scryfallId":"c4ee564d-d663-4ed7-afbd-713e90ba5c50"},{"index":15462,"token":false,"name":"Muse Vortex","scryfallId":"a6154df1-c9c0-4ec9-a3f1-8a4ae3f0f0a5"},{"index":15463,"token":false,"name":"Weed-Pruner Poplar","scryfallId":"d44d2eb4-e5a3-4401-86cb-311374a2de04"},{"index":15464,"token":false,"name":"Toymaker","scryfallId":"76f3992a-553c-4032-b144-55aad2f909f1"},{"index":15465,"token":false,"name":"Inscription of Ruin","scryfallId":"a267c7c9-dc93-445a-92e0-8cda9742e4cb"},{"index":15466,"token":false,"name":"Ancient Brontodon","scryfallId":"39421ce8-86d5-4739-b6fd-78d63c0bb258"},{"index":15468,"token":false,"name":"Patron Wizard","scryfallId":"8d7dca82-d981-41b4-ac14-a85e6a6b8433"},{"index":15469,"token":false,"name":"Magma Hellion","scryfallId":"ef9d02dc-4cb2-4ae1-84c3-e70aeb3c29ff"},{"index":15473,"token":false,"name":"Duskmantle Seer","scryfallId":"4946e4f9-aab3-4f81-af44-f6b03cd07dc8"},{"index":15477,"token":false,"name":"Dream Eater","scryfallId":"9f3a4677-7683-4f63-af31-b76491ec9f9c"},{"index":15478,"token":false,"name":"Scourge of Kher Ridges","scryfallId":"bede410a-8b5c-48c0-8f5d-d8bd17e0b86b"},{"index":15479,"token":false,"name":"Storm Shaman","scryfallId":"e08b23e1-a36c-4ca7-b7f6-cac03d6a6dd9"},{"index":15480,"token":false,"name":"Giant Crab","scryfallId":"f5eab308-f2b1-46ed-aeb5-ecc3a49ed693"},{"index":15483,"token":false,"name":"Talisman of Indulgence","scryfallId":"243253fb-5fca-401f-9363-c152a5943e13"},{"index":15484,"token":false,"name":"Back to Basics","scryfallId":"fab4cd7e-b56f-4408-a0e9-c07e040cc38f"},{"index":15486,"token":false,"name":"Pest Infestation","scryfallId":"4720b4f2-e6af-4223-9250-a0ed21ed5693"},{"index":15491,"token":false,"name":"Serenity","scryfallId":"3b37593d-13e7-4489-84bc-7074032b6f05"},{"index":15492,"token":false,"name":"Goldenglow Moth","scryfallId":"358ca237-d13c-43ba-b37a-fe6803de3a09"},{"index":15498,"token":false,"name":"Mudbrawler Cohort","scryfallId":"8fcb1f26-9a2a-40bd-b291-4ef8ce375cdf"},{"index":15500,"token":false,"name":"Stormwild Capridor","scryfallId":"2afded81-2fc1-4285-bf48-d25f72e72138"},{"index":15501,"token":false,"name":"Teferi's Honor Guard","scryfallId":"4177d5bf-db48-4bbf-bbd4-ee6313031920"},{"index":15502,"token":false,"name":"Wolfbriar Elemental","scryfallId":"60da801e-c47c-4aac-928c-2e7eab2d24c6"},{"index":15504,"token":false,"name":"Rootweaver Druid","scryfallId":"a1bea124-3241-4c0a-8863-a2e603c66126"},{"index":15508,"token":false,"name":"Unifying Theory","scryfallId":"8aa4bf82-65e7-4b0c-9f96-dd84a67dcfb2"},{"index":15509,"token":false,"name":"Linvala, the Preserver","scryfallId":"ef0dbb08-d124-46da-bfb1-af7ef4a18179"},{"index":15511,"token":false,"name":"Halvar, God of Battle // Sword of the Realms","scryfallId":"feddb683-a8f8-4def-bd3e-6d630c42cd34"},{"index":15512,"token":false,"name":"False Orders","scryfallId":"65defd15-fc99-4359-a222-05aab6dd73a2"},{"index":15515,"token":false,"name":"Durable Coilbug","scryfallId":"a0cbdfb6-c029-440f-bc07-c95e03c20110"},{"index":15520,"token":false,"name":"Soul Shatter","scryfallId":"b6bf770a-18bc-4f47-b77b-e1c54c70ee3f"},{"index":15524,"token":false,"name":"Spinning Darkness","scryfallId":"58e64a8e-84b1-416c-9fa7-8b10130dc9e9"},{"index":15527,"token":false,"name":"No-Dachi","scryfallId":"6c6061a8-d27f-4258-9e95-cd12365c4248"},{"index":15529,"token":false,"name":"Eron the Relentless","scryfallId":"00a52735-fb3b-4e61-a07f-f6d1cd433a75"},{"index":15530,"token":false,"name":"Garruk's Horde","scryfallId":"3313f4ea-1275-4835-b4ff-73d3601c04e1"},{"index":15531,"token":false,"name":"Labyrinth Guardian","scryfallId":"132c19f0-3b75-49a9-b3a9-501031fe3f50"},{"index":15533,"token":false,"name":"Perpetual Timepiece","scryfallId":"bbc87a27-93d9-4ce0-a022-0309242c1e89"},{"index":15534,"token":false,"name":"Luminous Angel","scryfallId":"c3ac419f-7630-48c7-9039-88ce28898b6d"},{"index":15535,"token":false,"name":"The Ozolith","scryfallId":"d09586ac-90c1-4358-ba89-fe0b8b5fa606"},{"index":15536,"token":false,"name":"Rakdos Keyrune","scryfallId":"f5647ef4-736e-4861-8718-06c53a2253b3"},{"index":15539,"token":false,"name":"Zhang He, Wei General","scryfallId":"736e4bf1-fee9-47cc-9bbc-093f21c77297"},{"index":15540,"token":false,"name":"Opal Titan","scryfallId":"379f1f01-88c6-4cc2-9049-078aa6980582"},{"index":15541,"token":false,"name":"Rathi Assassin","scryfallId":"70b69fe0-e378-4710-9334-4550db52af42"},{"index":15545,"token":false,"name":"Mirri the Cursed","scryfallId":"6da09233-952f-4784-995e-0d85d8b56637"},{"index":15549,"token":false,"name":"Wall of Opposition","scryfallId":"23243752-25c5-407e-9ce4-4bc1f02d01c1"},{"index":15550,"token":false,"name":"Warclamp Mastiff","scryfallId":"102e48e0-8a5f-499d-ac62-005d3c075ef3"},{"index":15551,"token":false,"name":"Invert // Invent","scryfallId":"054a4e4f-8baa-41cf-b24c-d068e8b9a070"},{"index":15553,"token":false,"name":"Hell's Thunder","scryfallId":"2b5fab78-9391-4247-ab26-467fc78e9b97"},{"index":15555,"token":false,"name":"Willow Satyr","scryfallId":"2afe33f6-d93b-4ca5-bf21-396efbb9b94f"},{"index":15556,"token":false,"name":"Angrath, Captain of Chaos","scryfallId":"aa3a4cb5-945e-4caf-8a18-1ef977879fe8"},{"index":15557,"token":false,"name":"Stadium Vendors","scryfallId":"2d25baa1-4794-4bed-bf0c-7d99f39f9656"},{"index":15558,"token":false,"name":"Drifter il-Dal","scryfallId":"4c3de909-b47e-45d7-9922-8d5e08a76ec9"},{"index":15559,"token":false,"name":"Knowledge Exploitation","scryfallId":"3d283c49-2e81-4b2e-956a-69152cc4704e"},{"index":15560,"token":true,"name":"Hellion Token (R, 4/4)","scryfallId":"3b43b811-ec0f-4ad7-a152-f7f077bafaa4"},{"index":15561,"token":false,"name":"Skilled Animator","scryfallId":"586d5000-1fdb-4bfe-aa34-63b25ee94bb9"},{"index":15562,"token":false,"name":"Damping Sphere","scryfallId":"a5c7d16b-8f4e-42b9-be24-3cb091932d7c"},{"index":15563,"token":false,"name":"Feast of Dreams","scryfallId":"de07e21e-c12a-47a6-ad2c-ef6fed343407"},{"index":15565,"token":false,"name":"Ichor Rats","scryfallId":"2013aed6-7415-4bf0-a3bb-46d6beecbaff"},{"index":15566,"token":false,"name":"Cast into Darkness","scryfallId":"0c1880d4-90c7-46a2-bbc9-d2b52971d11c"},{"index":15568,"token":false,"name":"Stromkirk Condemned","scryfallId":"c4a8403e-bf4c-4aae-9102-188f49c61ddf"},{"index":15569,"token":false,"name":"Grave Sifter","scryfallId":"598fe7f1-bcc2-4909-9933-06bf02372adc"},{"index":15571,"token":false,"name":"Nature's Kiss","scryfallId":"64b09c44-d463-45a9-9fa2-89407c21200b"},{"index":15577,"token":false,"name":"Omniscience","scryfallId":"fc9644e2-4a76-4de4-bca7-0d95976f0d99"},{"index":15578,"token":false,"name":"Bankrupt in Blood","scryfallId":"e635c433-0398-442a-856e-1869f6bf2cfd"},{"index":15579,"token":false,"name":"Resurgent Belief","scryfallId":"a0e60c9e-0b9c-4daa-8a61-52111e03f49f"},{"index":15582,"token":false,"name":"Mogis, God of Slaughter","scryfallId":"2c8df131-c29d-4181-8dc4-815a581b0209"},{"index":15588,"token":false,"name":"Sea of Clouds","scryfallId":"080aebe8-535e-4632-b733-8aba98abff22"},{"index":15590,"token":false,"name":"Uncontrolled Infestation","scryfallId":"d9ead6c3-a4e9-43e0-ae2a-6eb73033bc49"},{"index":15592,"token":false,"name":"Thrashing Wumpus","scryfallId":"86bc07c6-2ba7-41f8-90ab-f9bbac86dd08"},{"index":15593,"token":false,"name":"Wild Research","scryfallId":"74ffcf3f-7c37-4934-943a-428841e776c3"},{"index":15594,"token":false,"name":"Dancing Scimitar","scryfallId":"e3d92537-7934-4191-8836-2f61ff6ab2fa"},{"index":15595,"token":false,"name":"Awakened Amalgam","scryfallId":"e738223b-c685-40d7-a6e6-6417b1a65554"},{"index":15601,"token":false,"name":"Draco","scryfallId":"87a69f0c-69c2-41d5-b784-502dadf9d048"},{"index":15602,"token":false,"name":"Ydwen Efreet","scryfallId":"efdba2a9-d171-45ed-8dd4-9d0046128f68"},{"index":15605,"token":false,"name":"Kulrath Knight","scryfallId":"2408b0bb-37d6-48a3-b140-c826de74c3a0"},{"index":15606,"token":false,"name":"Bane of Progress","scryfallId":"3ea495ff-33df-406b-98e3-5579e2158bbc"},{"index":15608,"token":false,"name":"Rime Tender","scryfallId":"8ce0ab73-4df6-479f-8710-61ef87cce3b4"},{"index":15610,"token":false,"name":"Bloodghast","scryfallId":"63870c81-63bf-4a9a-aeb5-74c6eaded9f1"},{"index":15611,"token":false,"name":"Weigh Down","scryfallId":"6ffa795d-2211-49b0-a6df-812599758f7b"},{"index":15612,"token":false,"name":"Epiphany at the Drownyard","scryfallId":"23a22389-752d-4937-a5a3-8e30c2c9a11f"},{"index":15613,"token":false,"name":"Sea Sprite","scryfallId":"40af5ba4-aa52-4f84-bc80-bc4f37b6787f"},{"index":15614,"token":false,"name":"Boros Reckoner","scryfallId":"82a18b07-38b8-4854-9735-3cfe83b11bf1"},{"index":15615,"token":false,"name":"Lead Golem","scryfallId":"b2ba3857-9bd7-434d-b77f-d697776f33e4"},{"index":15617,"token":false,"name":"Lobotomy","scryfallId":"a79536d3-24eb-47e9-8c87-fa9cdba17c87"},{"index":15618,"token":false,"name":"Hint of Insanity","scryfallId":"d6abaca0-7ce1-4024-adf6-ef6cc0fbcb75"},{"index":15619,"token":false,"name":"Norwood Warrior","scryfallId":"6f7ddf0a-1081-4ae0-ab91-b052153bab4c"},{"index":15620,"token":false,"name":"Drana's Chosen","scryfallId":"3f506988-29f9-48f2-9271-5e8cfc811c35"},{"index":15624,"token":false,"name":"Ageless Sentinels","scryfallId":"ccaa4a19-8eba-4c43-8a9a-636e234df751"},{"index":15626,"token":false,"name":"Wishcoin Crab","scryfallId":"f368f804-055f-4a4f-bb0c-fe3dc52433c0"},{"index":15628,"token":true,"name":"Beast Token (Colorless, 6/6)","scryfallId":"4de1d095-459f-42fd-9d9f-8f71d002a5b2"},{"index":15629,"token":false,"name":"Obsessive Search","scryfallId":"62b886ae-0109-4e9a-aabc-d22b792715cb"},{"index":15630,"token":false,"name":"Daze","scryfallId":"f05e9a3e-8a35-4687-85cb-e31b3927a5e2"},{"index":15637,"token":false,"name":"Abhorrent Overlord","scryfallId":"c7e3cf6b-ac9b-40b1-a6f5-ee2193db59c0"},{"index":15639,"token":false,"name":"Keeper of Keys","scryfallId":"0274bd7a-5db7-4676-91bf-f3a5deee27b6"},{"index":15646,"token":false,"name":"Incite War","scryfallId":"ee30527c-0eb1-4b66-9028-1607a960019a"},{"index":15648,"token":false,"name":"Wydwen, the Biting Gale","scryfallId":"62b8f8e9-a2b0-41c5-9fae-340f7caaeff9"},{"index":15649,"token":false,"name":"Hazy Homunculus","scryfallId":"f87489f2-82b7-4be6-80ae-3d5955d5ed92"},{"index":15650,"token":true,"name":"Shapeshifter Token (Colorless, 2/2)","scryfallId":"a33fda72-e61d-478f-bc33-ff1a23b5f45b"},{"index":15652,"token":false,"name":"Hoarding Dragon","scryfallId":"5c6cd59a-f184-4e8e-885e-36fbceddfc06"},{"index":15653,"token":false,"name":"Accorder's Shield","scryfallId":"a7305c18-5058-42dd-b62a-7f6a42624036"},{"index":15656,"token":false,"name":"Ulrich's Kindred","scryfallId":"86d0ee03-a8c6-4f37-9885-60a26a2e2728"},{"index":15657,"token":false,"name":"Reality Smasher","scryfallId":"52d4b652-a830-4fd4-94bb-c17c227f2928"},{"index":15658,"token":false,"name":"Eye Gouge","scryfallId":"94d4eb34-0529-48a0-ac52-b57cead7b651"},{"index":15662,"token":false,"name":"Armament Corps","scryfallId":"dbd2c383-67a9-4f2f-b35f-b6e86c4d1a48"},{"index":15665,"token":false,"name":"Battle at the Bridge","scryfallId":"aef6009c-8d93-4b33-b468-dc021290164b"},{"index":15671,"token":false,"name":"Aven Fogbringer","scryfallId":"c0ee9e09-c4b1-4133-90a3-350677f0b72a"},{"index":15673,"token":false,"name":"Snapping Gnarlid","scryfallId":"834409e3-134e-4a34-89cb-53e2a039e980"},{"index":15679,"token":false,"name":"Cloud Sprite","scryfallId":"3ffda5fa-c88c-493b-a65e-2120a6259600"},{"index":15680,"token":false,"name":"Makindi Sliderunner","scryfallId":"2df12b9f-2f39-470d-b3c7-76c3228aecc2"},{"index":15682,"token":false,"name":"Howl of the Night Pack","scryfallId":"5b0e60aa-2d92-4e76-9615-84bb6cd28779"},{"index":15685,"token":false,"name":"Armament Master","scryfallId":"975f7752-e981-4046-ae9b-90b20db6b23a"},{"index":15687,"token":false,"name":"Churning Eddy","scryfallId":"bd28bc8e-842f-4788-92a0-3019e3c2385f"},{"index":15688,"token":false,"name":"Deepchannel Mentor","scryfallId":"e8ae429d-c09d-4818-8eb8-7e1c97e4b0c9"},{"index":15689,"token":false,"name":"Worldly Tutor","scryfallId":"b34d9054-5ad8-4a7d-a5c8-58bc39051834"},{"index":15690,"token":false,"name":"Tsabo's Decree","scryfallId":"0c1a0ebd-1add-49e6-b5e6-5b26abb1de88"},{"index":15692,"token":false,"name":"Cleansing Meditation","scryfallId":"fd6609ef-71af-4775-affc-34153700c556"},{"index":15693,"token":false,"name":"Witches' Eye","scryfallId":"6d989daa-78eb-4120-81b5-7866a7b04590"},{"index":15695,"token":false,"name":"Moonlit Scavengers","scryfallId":"6a658bbd-8d64-460b-87ae-ec8054204794"},{"index":15697,"token":false,"name":"Savage Ventmaw","scryfallId":"faefc6de-868f-4b06-a5d3-6f8416c2961c"},{"index":15698,"token":false,"name":"Bloodgift Demon","scryfallId":"6a2e1d4a-8df4-472f-a98f-d6b71c1dd1c4"},{"index":15701,"token":false,"name":"Madcap Experiment","scryfallId":"05768b87-d2df-42fc-bf63-e471d31b32e3"},{"index":15702,"token":false,"name":"Bant Sureblade","scryfallId":"162feb2b-e641-4338-bcf1-1f7e7a11bb9d"},{"index":15703,"token":false,"name":"Icatian Store","scryfallId":"d7cd8d8c-52c7-402f-92e1-5e5866f2555a"},{"index":15704,"token":false,"name":"Feebleness","scryfallId":"1ba2660d-b661-4266-b7e5-07bb8b72bce6"},{"index":15710,"token":false,"name":"Emmessi Tome","scryfallId":"89dbf782-3f94-4043-8852-0390ce2e4d87"},{"index":15711,"token":false,"name":"Opportunistic Dragon","scryfallId":"d647f55e-a0ef-42d4-b23a-680d2d7f2d6a"},{"index":15716,"token":false,"name":"Ghor-Clan Bloodscale","scryfallId":"00cab68b-ee26-46eb-a18b-9b42bf2d10e5"},{"index":15717,"token":false,"name":"Permafrost Trap","scryfallId":"03b6dc43-62d3-4572-a2e1-b0e67dcc21c7"},{"index":15725,"token":false,"name":"Parcelbeast","scryfallId":"780c0087-f745-4ffa-924c-139d5fde4282"},{"index":15727,"token":false,"name":"Clear Shot","scryfallId":"a7ff66fc-bd38-4607-b394-8c4e09affec8"},{"index":15731,"token":false,"name":"Fevered Strength","scryfallId":"13e53d6c-67f5-4d74-8205-6325c75d1d07"},{"index":15732,"token":false,"name":"Soulcage Fiend","scryfallId":"dce1b1d3-9602-42bf-b341-d96976ff1e60"},{"index":15736,"token":false,"name":"Pale Bears","scryfallId":"7f19c2a3-6403-4a78-bf45-6e339578d673"},{"index":15737,"token":false,"name":"Whip Vine","scryfallId":"4b66b9fe-47f1-4786-96d5-981d62012663"},{"index":15738,"token":false,"name":"Take Vengeance","scryfallId":"30fff340-8e2a-4182-9ece-af5749fa0d2e"},{"index":15739,"token":false,"name":"Supply Caravan","scryfallId":"71899431-c397-4031-b01a-d8bd960bbe2d"},{"index":15741,"token":true,"name":"Plus One","scryfallId":"ee80a74b-8a84-4895-b89b-8b9fb5086029"},{"index":15745,"token":false,"name":"Meren of Clan Nel Toth","scryfallId":"17d6703c-ad79-457b-a1b5-c2284e363085"},{"index":15746,"token":false,"name":"Seismic Assault","scryfallId":"6b2eb4e6-4ce1-4f72-9b3d-b6a44b22bd2e"},{"index":15747,"token":false,"name":"Sensei Golden-Tail","scryfallId":"5c3d2005-b61a-450b-8d8f-33006c12afb5"},{"index":15749,"token":false,"name":"Dack's Duplicate","scryfallId":"bc8e9859-10b3-460c-99d5-4ace259c2d48"},{"index":15750,"token":false,"name":"Synod Centurion","scryfallId":"6e2c0a63-5128-408a-bf95-2489b92817a9"},{"index":15751,"token":false,"name":"Retraced Image","scryfallId":"c62fa778-ce44-4a3e-958a-91dfe5398944"},{"index":15753,"token":false,"name":"Bloodfire Colossus","scryfallId":"088f00a5-95b5-4892-9572-9e022b0eb01f"},{"index":15754,"token":false,"name":"Omen of the Sea","scryfallId":"a5f30ecd-d009-4d44-aef4-c926ed55a521"},{"index":15758,"token":false,"name":"Krark's Thumb","scryfallId":"d011d66d-7d27-4305-8a1b-7b5c24169769"},{"index":15759,"token":false,"name":"Zaxara, the Exemplary","scryfallId":"c07de85d-343e-49e0-b438-ddf1342ab654"},{"index":15761,"token":false,"name":"Dragonkin Berserker","scryfallId":"e7f22fe4-2390-4c3d-8b5e-0cf398d97f6a"},{"index":15762,"token":false,"name":"Marked by Honor","scryfallId":"332380e9-ed94-4b6b-a0f1-7f05d13dbc5b"},{"index":15767,"token":false,"name":"Nature's Panoply","scryfallId":"32177b9c-eef3-4eea-b623-74bfea1afad6"},{"index":15768,"token":false,"name":"Trynn, Champion of Freedom","scryfallId":"168d7532-c925-4a96-a756-2ce4dd0fec33"},{"index":15769,"token":false,"name":"Elvish Lookout","scryfallId":"d9a8a0e2-311a-4627-8a48-43df045c3112"},{"index":15774,"token":true,"name":"Elemental Token (W, 4/4)","scryfallId":"17057115-9163-4f91-b2b9-8387ea547c9d"},{"index":15776,"token":false,"name":"Aether Spellbomb","scryfallId":"f3792e8b-4ad7-4e2d-994c-c4eaac0fa55f"},{"index":15777,"token":false,"name":"Staff of Domination","scryfallId":"fde838c8-2f32-4e7d-a236-0bc42dd7abd9"},{"index":15778,"token":false,"name":"Verdant Embrace","scryfallId":"3dd1d130-98e7-4898-9f13-2bb58fa4777b"},{"index":15779,"token":false,"name":"Battleground Geist","scryfallId":"129905ef-5b3b-4860-923c-109a7d7cad80"},{"index":15781,"token":false,"name":"Midnight Ritual","scryfallId":"0e98c4f7-b0f4-48c6-b502-3dc5802d827f"},{"index":15785,"token":false,"name":"Giant Killer // Chop Down","scryfallId":"a755e9d9-171f-421c-9ed9-7a296b2b0c9b"},{"index":15787,"token":false,"name":"Ahn-Crop Crasher","scryfallId":"2afe4ab9-2213-4b73-9735-83e1d6c33b04"},{"index":15791,"token":false,"name":"Vesperlark","scryfallId":"32776159-3fb6-4a70-be84-837ccd1d54a7"},{"index":15792,"token":false,"name":"Wojek Bodyguard","scryfallId":"ebff5313-e325-47c3-814b-38fdb4c6c8d2"},{"index":15795,"token":false,"name":"Catch // Release","scryfallId":"29968873-56f3-4528-ab0b-f11dd67dd162"},{"index":15796,"token":false,"name":"Sapphire Drake","scryfallId":"d0fe14cf-5d34-47d1-9071-4a532819719b"},{"index":15799,"token":false,"name":"Fyndhorn Pollen","scryfallId":"3efbe59d-bebc-40b1-85ac-2e4c1ff3731e"},{"index":15801,"token":false,"name":"Maritime Guard","scryfallId":"1008ff1b-7fb0-4570-b23e-9fda14b97640"},{"index":15804,"token":false,"name":"Inferno Fist","scryfallId":"721a42f4-5884-418f-b1f9-7cb651559ad0"},{"index":15805,"token":false,"name":"Zareth San, the Trickster","scryfallId":"1856bc9f-f4c2-4d4d-aec5-7d51f45e9796"},{"index":15817,"token":false,"name":"Valentin, Dean of the Vein // Lisette, Dean of the Root","scryfallId":"302bf145-e7af-4e55-b715-5174c5760d0a"},{"index":15818,"token":false,"name":"Dance of the Skywise","scryfallId":"c548d140-3d81-4b33-9985-87703d316a83"},{"index":15819,"token":false,"name":"Blight Mamba","scryfallId":"cf9b3335-565c-406d-bd94-f36974602552"},{"index":15822,"token":false,"name":"Desert of the Mindful","scryfallId":"b24894d2-7fd6-4de1-badb-27282749a0d6"},{"index":15833,"token":false,"name":"Hunter's Insight","scryfallId":"c12cf74d-aad9-41d8-959e-66557c39204d"},{"index":15835,"token":true,"name":"Kraken Token (U, 9/9)","scryfallId":"f62080da-a11b-4da3-bb8f-57f543bf076a"},{"index":15838,"token":false,"name":"Rise of the Dread Marn","scryfallId":"b9f68e39-e3a9-4f9e-ba43-bd4b126a9137"},{"index":15839,"token":false,"name":"Scuzzback Marauders","scryfallId":"0e013b28-7a90-4b4e-a91c-7d864105d28b"},{"index":15842,"token":false,"name":"Magus of the Mind","scryfallId":"34a0d8a1-8564-4d4a-9390-06a06312e668"},{"index":15844,"token":false,"name":"Patron of the Orochi","scryfallId":"6d6787c4-170a-45b6-8792-af3ea32ef538"},{"index":15847,"token":false,"name":"Bloodbraid Marauder","scryfallId":"6286fd93-bb97-4721-8a40-1c5a884c2edb"},{"index":15850,"token":false,"name":"Law-Rune Enforcer","scryfallId":"a3d39238-e21d-4345-84c8-648ef3a66703"},{"index":15852,"token":false,"name":"Geier Reach Sanitarium","scryfallId":"ce583e4c-830a-4f10-883b-e0dc1ce9cc67"},{"index":15853,"token":false,"name":"Hazoret's Favor","scryfallId":"8b467412-c06b-4cd9-a877-7722051fb758"},{"index":15854,"token":false,"name":"Day of Destiny","scryfallId":"99f49ff1-54f6-4825-987b-c50a152f7275"},{"index":15857,"token":false,"name":"Umara Entangler","scryfallId":"0d4ddc45-cd67-4b2c-84d0-4604783fd8e7"},{"index":15858,"token":false,"name":"Teferi's Wavecaster","scryfallId":"d67e4c42-a44f-456b-87e7-21ca56dc4630"},{"index":15859,"token":false,"name":"Demon's Horn","scryfallId":"cd708b10-472f-44b1-9b62-668da6104ef5"},{"index":15860,"token":false,"name":"Caustic Caterpillar","scryfallId":"c7f035ad-b268-44be-9193-ba2ef0a491ce"},{"index":15861,"token":false,"name":"Scalpelexis","scryfallId":"29c3b7fa-78e7-4a0c-bcdc-4b829638e3f6"},{"index":15862,"token":false,"name":"Primordial Hydra","scryfallId":"3dcc5521-df8f-4992-b93e-e430d8cc7715"},{"index":15863,"token":true,"name":"Basri","scryfallId":"0867e879-cbee-4ee1-be8c-b7ff1bcfa6d0"},{"index":15864,"token":false,"name":"Vandalblast","scryfallId":"5925c559-3e3c-481b-ba95-20a405cbffce"},{"index":15867,"token":false,"name":"Drafna's Restoration","scryfallId":"4be2aa3b-207b-4d21-abfb-6788520c7676"},{"index":15871,"token":false,"name":"Flowstone Hellion","scryfallId":"680ccbc7-aa97-4f01-9d26-0df184af3c3e"},{"index":15873,"token":false,"name":"Misshapen Fiend","scryfallId":"a43cf59e-7583-4651-968a-2a7201c69b6b"},{"index":15875,"token":false,"name":"Phantom Warrior","scryfallId":"e12a1a64-5b32-4b85-8fae-c407d7926547"},{"index":15876,"token":false,"name":"Goblin Medics","scryfallId":"72cc08b6-f31a-46b3-b233-f6bb2c6b1106"},{"index":15877,"token":false,"name":"Jaya Ballard","scryfallId":"f4da5284-52a4-4999-9e95-9495cee5cade"},{"index":15878,"token":false,"name":"Avalanche Caller","scryfallId":"89cef049-6a47-4264-b2bc-b9d291a09c4c"},{"index":15882,"token":false,"name":"Traitor's Roar","scryfallId":"751e2700-6425-45b8-b026-8c78098f08b2"},{"index":15885,"token":false,"name":"Necropede","scryfallId":"8d2e522b-e6f8-4fae-8c08-ce2bb8bed04f"},{"index":15886,"token":false,"name":"Kithkin Rabble","scryfallId":"7f9a0afa-50e6-4bce-b261-4559fd31295e"},{"index":15889,"token":false,"name":"Admiral's Order","scryfallId":"720406ef-4460-475f-bbc1-491c8c48794e"},{"index":15892,"token":false,"name":"Orazca Raptor","scryfallId":"b7080f86-0a9f-4471-a52b-0d44d19e6e59"},{"index":15893,"token":false,"name":"Planar Chaos","scryfallId":"5dae5e16-d2fc-488c-9c53-d35c377d6a00"},{"index":15895,"token":false,"name":"Marwyn, the Nurturer","scryfallId":"aad61d99-5c8e-47b7-ab1a-e70905f59205"},{"index":15900,"token":false,"name":"Mysterious Pathlighter","scryfallId":"1028aa10-aded-4aeb-b70f-d7a9003ae846"},{"index":15901,"token":false,"name":"Vulshok Berserker","scryfallId":"1dd6e25f-e58e-4ff8-83f3-b01d5f783632"},{"index":15902,"token":false,"name":"Guardian Beast","scryfallId":"9941f83b-2903-4eab-ac6d-5313e3978fa3"},{"index":15911,"token":false,"name":"Douse in Gloom","scryfallId":"e34fa15b-4559-4a8f-aa29-5c43eb4eeef9"},{"index":15912,"token":false,"name":"Strionic Resonator","scryfallId":"88326f60-1c86-4aca-8e6a-b1882a048635"},{"index":15914,"token":false,"name":"Ironclaw Curse","scryfallId":"e796f0ff-4e7b-4849-b463-0aac860c72ea"},{"index":15918,"token":false,"name":"Trait Doctoring","scryfallId":"e21a7981-5940-4b75-907f-7600a742f946"},{"index":15919,"token":false,"name":"Deadly Wanderings","scryfallId":"23bb5d9f-9b12-482a-91b4-6786e8310805"},{"index":15920,"token":false,"name":"The Fallen","scryfallId":"262053e7-09b7-4cfc-9959-f8ab7c8149d8"},{"index":15923,"token":false,"name":"Gift of Growth","scryfallId":"3f1f81db-30e7-4be1-a3b7-68c072d42ed2"},{"index":15924,"token":true,"name":"Liliana","scryfallId":"f394a07c-bb58-4f52-ac2b-344a8f738319"},{"index":15925,"token":false,"name":"Student of Elements // Tobita, Master of Winds","scryfallId":"9de1eebf-5725-438c-bcf0-f3a4d8a89fb0"},{"index":15927,"token":false,"name":"Misinformation","scryfallId":"90a79cd5-d951-4ad7-a6a1-0cade4d0c189"},{"index":15928,"token":false,"name":"Burgeoning","scryfallId":"3f8d7171-81d2-4c84-aa10-9a5daf8d25c1"},{"index":15929,"token":false,"name":"Serene Sunset","scryfallId":"0a6ded26-b748-406d-8740-9b8590be2bb1"},{"index":15930,"token":false,"name":"Deathbringer Thoctar","scryfallId":"fdffa46e-8802-4479-a669-d33618f75d4f"},{"index":15931,"token":false,"name":"Valki, God of Lies // Tibalt, Cosmic Impostor","scryfallId":"a70c5a0b-77d8-4d9e-a143-aaa2be4dc494"},{"index":15932,"token":false,"name":"Ninja of the Deep Hours","scryfallId":"6394b9e1-674e-4eda-ad0b-206cdbb5bf5e"},{"index":15933,"token":false,"name":"Tibalt's Trickery","scryfallId":"9067f5b3-1685-42b6-b838-3e19f1f6b36e"},{"index":15934,"token":false,"name":"Seek the Horizon","scryfallId":"d5269292-11be-4647-9074-7ce8115bf36f"},{"index":15935,"token":false,"name":"Liliana of the Veil","scryfallId":"e653437e-2e56-4443-aec5-5bb7d8860238"},{"index":15938,"token":false,"name":"Humble","scryfallId":"8b876e92-ec9f-4b96-9ec2-2d44f4231b14"},{"index":15939,"token":false,"name":"Scholar of Athreos","scryfallId":"95a36e06-39f3-47d0-b6a9-43728afceb4a"},{"index":15941,"token":false,"name":"Rustwing Falcon","scryfallId":"c6691e62-8887-41e8-8e74-76ee2353d45e"},{"index":15943,"token":false,"name":"Lavinia, Azorius Renegade","scryfallId":"45f0a8d8-9993-467a-a83d-6aa8ef9f8d56"},{"index":15945,"token":false,"name":"Vampire's Bite","scryfallId":"6460a752-e5a7-4fd0-9ae5-e0773b86f19b"},{"index":15947,"token":false,"name":"Words of Wind","scryfallId":"5595a57a-a76c-467b-afaf-5affffc24f35"},{"index":15948,"token":false,"name":"Tragic Poet","scryfallId":"f957b353-7765-4c16-9645-d41000154130"},{"index":15950,"token":false,"name":"Zodiac Dragon","scryfallId":"46652ae3-6572-4296-939b-0789923180d5"},{"index":15954,"token":true,"name":"Sacred Cat Token (W, 1/1)","scryfallId":"56ea5f68-3818-43d3-9b7b-c344305a8423"},{"index":15955,"token":false,"name":"Asha's Favor","scryfallId":"28b817f7-ae05-4d31-8a2c-29d8082b4132"},{"index":15959,"token":false,"name":"Voracious Hatchling","scryfallId":"b66b1a84-ab15-48d8-909c-08116dc71c76"},{"index":15960,"token":false,"name":"Order of Leitbur","scryfallId":"1373dea4-3565-4612-8505-ab8fba3ddb67"},{"index":15961,"token":false,"name":"Slab Hammer","scryfallId":"18c64671-9bdd-475f-8def-7575775bf900"},{"index":15962,"token":false,"name":"Witch's Cottage","scryfallId":"b87891cd-b457-4dff-8d18-a7eaf6748fc6"},{"index":15968,"token":false,"name":"Tel-Jilad Stylus","scryfallId":"522570eb-e654-4f8a-828c-3e456a0ad8e6"},{"index":15969,"token":false,"name":"Steadfast Armasaur","scryfallId":"197934d5-726c-4cd3-a934-3d6449a5a56e"},{"index":15970,"token":false,"name":"Pestilent Kathari","scryfallId":"dba00df7-2c8d-435a-86d1-6bd7b7413585"},{"index":15972,"token":false,"name":"Goblin Shortcutter","scryfallId":"5daeaa2e-68e5-4f49-9220-58c0c9b1a3d0"},{"index":15973,"token":false,"name":"Vampirism","scryfallId":"2dff2817-1813-410f-aca7-96e8f9f4ce81"},{"index":15974,"token":false,"name":"Zombie Assassin","scryfallId":"c4649311-1300-42fb-ac10-90490756c7aa"},{"index":15975,"token":false,"name":"Ojutai's Breath","scryfallId":"6d220d0e-b0d4-49c9-90bd-9aa655edc429"},{"index":15977,"token":false,"name":"Radiant's Judgment","scryfallId":"28d2718e-c6fc-4961-b094-11f25f1177ff"},{"index":15979,"token":false,"name":"Sandcrafter Mage","scryfallId":"8998b4a5-d94b-45b3-b619-bd850e240ce0"},{"index":15981,"token":false,"name":"Bone Mask","scryfallId":"1f46aea3-ea00-46c4-b207-522ceeeae68b"},{"index":15986,"token":false,"name":"Search for Azcanta // Azcanta, the Sunken Ruin","scryfallId":"dd67b716-713c-4925-ac9c-0acaa705d5a5"},{"index":15987,"token":false,"name":"Tergrid, God of Fright // Tergrid's Lantern","scryfallId":"66904768-09d0-4836-a6a0-c474678f19c1"},{"index":15991,"token":false,"name":"Lowland Basilisk","scryfallId":"2c3cce7a-637f-4c68-af30-6f89f6c9f096"},{"index":15992,"token":false,"name":"Connive // Concoct","scryfallId":"d9374771-c737-4cc8-b379-19039e66a525"},{"index":15997,"token":false,"name":"Relentless Rats","scryfallId":"7a3d472f-6454-427e-8434-ae70af43dcaf"},{"index":16000,"token":false,"name":"Infernal Kirin","scryfallId":"c79e7a4c-e0e7-42ac-b125-1db2f3d9325c"},{"index":16002,"token":false,"name":"Keldon Raider","scryfallId":"f1245212-d081-4e95-a508-e1d3a7496473"},{"index":16004,"token":false,"name":"Barricade Breaker","scryfallId":"7cc81a94-955d-4734-b056-9b9a86cae60b"},{"index":16006,"token":false,"name":"Bristling Hydra","scryfallId":"4bf38096-05bc-4734-b33c-eb1e8f2986de"},{"index":16007,"token":false,"name":"Pain Magnification","scryfallId":"844801e4-cf37-4f20-9149-b58a57b9276e"},{"index":16010,"token":false,"name":"Cragganwick Cremator","scryfallId":"2a5b228b-4ea3-426f-a74b-1efd35592ccb"},{"index":16013,"token":false,"name":"Ebony Treefolk","scryfallId":"2b85dadb-351f-4975-a2c3-febf5e80bc85"},{"index":16014,"token":false,"name":"Rupture","scryfallId":"d2a2a4e7-3173-4b73-8898-2c668f9eebf9"},{"index":16020,"token":false,"name":"Bloodfire Expert","scryfallId":"0742564e-f7a7-4107-b9ed-63703ca4702c"},{"index":16024,"token":false,"name":"Gust-Skimmer","scryfallId":"5970d053-e2e8-471b-b342-2e9b9177724c"},{"index":16028,"token":false,"name":"Territorial Dispute","scryfallId":"4fa8a13a-f09f-4b10-8fab-3ea4fdc643d1"},{"index":16030,"token":false,"name":"Ice Floe","scryfallId":"0550a334-f185-4f1f-8759-d320b154c62f"},{"index":16032,"token":false,"name":"Ali from Cairo","scryfallId":"2719516a-7a47-413e-b1a3-15543d229e08"},{"index":16035,"token":false,"name":"Vilis, Broker of Blood","scryfallId":"a44d0f9c-5683-4c4c-9609-02a6d4e5996d"},{"index":16045,"token":false,"name":"Jilt","scryfallId":"a010d2b1-960d-4032-a47a-61fe0998bee3"},{"index":16046,"token":false,"name":"Flight of Fancy","scryfallId":"4b770973-2061-44cb-8c02-b2251d711e92"},{"index":16047,"token":false,"name":"Warthog","scryfallId":"dd2510b8-52d6-4d2e-89a5-31b27b732dd8"},{"index":16048,"token":false,"name":"Flame Spirit","scryfallId":"add2b82a-9aa5-4d5c-a1c2-e313541f12c8"},{"index":16053,"token":false,"name":"Volrath's Stronghold","scryfallId":"6c056c47-9a94-45d1-accb-ebf0dd09bd7a"},{"index":16055,"token":false,"name":"Fire Imp","scryfallId":"ea7edaf3-7941-4085-bdbc-e5c9832b6444"},{"index":16057,"token":false,"name":"Orzhov Advokist","scryfallId":"e328ba49-20e8-45f0-a4b9-d51318743255"},{"index":16059,"token":false,"name":"Domesticated Hydra","scryfallId":"5a4953f0-8f15-40dd-8e9f-80da48851121"},{"index":16060,"token":false,"name":"Turntimber Sower","scryfallId":"cf2e7201-8dd9-4837-a472-b72050b65a8e"},{"index":16062,"token":false,"name":"Archetype of Endurance","scryfallId":"ffb4429d-ff97-46d9-8ae0-5382c8ce6594"},{"index":16064,"token":false,"name":"Glen Elendra Liege","scryfallId":"94cc72b7-b593-438f-a07a-35f2452e1c48"},{"index":16065,"token":false,"name":"Vile Rebirth","scryfallId":"3fd46f2b-1458-44b1-9c65-960b261b81a5"},{"index":16066,"token":false,"name":"Aurochs","scryfallId":"35ec940e-093f-40a9-9fc3-8f7d96af446b"},{"index":16068,"token":false,"name":"Gauntlets of Light","scryfallId":"da0d5436-b881-45ac-b8ec-248d88714021"},{"index":16070,"token":false,"name":"Axegrinder Giant","scryfallId":"e55619f2-5951-4e2f-962b-8f40afff1d41"},{"index":16071,"token":false,"name":"Overseer of the Damned","scryfallId":"d1a73408-27b3-45d8-9153-ca964d99fe80"},{"index":16073,"token":false,"name":"Noxious Dragon","scryfallId":"911a3074-6c86-4483-9c1e-7df3b03ad6c8"},{"index":16075,"token":false,"name":"Keldon Megaliths","scryfallId":"da7c4600-1dc3-4a9d-a112-1b70abcb8951"},{"index":16076,"token":false,"name":"Pendant of Prosperity","scryfallId":"531f70f5-b667-436f-9a45-41dd08439191"},{"index":16081,"token":false,"name":"Fungal Infection","scryfallId":"a3f6baa5-666d-40b0-82e8-b0df10ff3cdd"},{"index":16085,"token":false,"name":"Cinder Wall","scryfallId":"4dfcc240-9010-4e0c-afda-7f70c42da7d2"},{"index":16088,"token":false,"name":"Fatespinner","scryfallId":"33bd5541-0ffb-4e82-ab17-f64ad555ddb6"},{"index":16091,"token":false,"name":"Heartless Pillage","scryfallId":"c5e791ce-1380-4de0-b314-246ea6dfc3cc"},{"index":16093,"token":false,"name":"Wild Ox","scryfallId":"f34823b8-fd6f-4e66-bfda-cc72181f4ca7"},{"index":16094,"token":false,"name":"Molten Echoes","scryfallId":"8ca1dbc4-2177-477e-88e2-d07cefb542e4"},{"index":16096,"token":false,"name":"Wood Sage","scryfallId":"92c9bb32-626b-4367-844d-20ae9fbfb9aa"},{"index":16098,"token":false,"name":"Orzhov Cluestone","scryfallId":"4823f904-1c41-42cf-aef7-db0dcf82b10b"},{"index":16100,"token":false,"name":"Psychogenic Probe","scryfallId":"e83d1ed5-3a49-4cfa-bad2-e342ef28649e"},{"index":16101,"token":false,"name":"Heartless Act","scryfallId":"928b0234-fc62-4ab8-b257-3fddcc52376b"},{"index":16104,"token":false,"name":"Aquastrand Spider","scryfallId":"af9dd8d6-013a-4018-9186-988f5e8d0ab9"},{"index":16105,"token":false,"name":"Homarid Warrior","scryfallId":"c9a9bdcf-543b-4140-b836-9e222a4a9233"},{"index":16107,"token":false,"name":"Incubator Drone","scryfallId":"e0855762-7068-4111-a6bf-fe6d5b092c74"},{"index":16109,"token":false,"name":"Splinter Twin","scryfallId":"718e0e1d-35bd-4af2-9810-c0cd804e4691"},{"index":16110,"token":false,"name":"Brazen Scourge","scryfallId":"60d002f9-ae69-4e07-943f-95036f083dea"},{"index":16113,"token":false,"name":"Pathbreaker Ibex","scryfallId":"4608ea44-e1b2-42de-a0a2-e6d6d24d89d0"},{"index":16116,"token":false,"name":"Gift of Estates","scryfallId":"2298765a-07b9-4138-bba9-bee0c462ce23"},{"index":16122,"token":true,"name":"Shapeshifter Token (U, 2/2)","scryfallId":"ef775ad0-b1a9-4254-ab6f-304558bb77a1"},{"index":16123,"token":false,"name":"Inflame","scryfallId":"cd7bc4c0-9bfd-444b-b22c-f1b7e1426807"},{"index":16126,"token":false,"name":"Boulder Salvo","scryfallId":"4e269989-bb22-4da4-a374-434a572e8e8f"},{"index":16129,"token":false,"name":"Cloud Cover","scryfallId":"943b3886-5556-474f-8dc1-18219e25abc3"},{"index":16130,"token":false,"name":"Aven Riftwatcher","scryfallId":"647208dd-77f3-4509-b9d6-7801a52418d9"},{"index":16131,"token":false,"name":"Fortress Crab","scryfallId":"87ca16d4-089f-42a7-a648-55301a77faea"},{"index":16134,"token":false,"name":"Sandstone Deadfall","scryfallId":"241ebc17-b8ae-4ca4-8413-f53501d86244"},{"index":16137,"token":false,"name":"Outwit","scryfallId":"429f7cf0-579a-4003-b5cf-4baf5d420796"},{"index":16141,"token":false,"name":"Sabertooth Cobra","scryfallId":"48ead72b-f3f5-4065-a33c-0992cf1fdb34"},{"index":16143,"token":false,"name":"Setessan Griffin","scryfallId":"35d2ae77-b16c-4a01-84ce-5c78be5a54d8"},{"index":16144,"token":false,"name":"Palladia-Mors, the Ruiner","scryfallId":"c60ce3b8-7396-49c4-bad6-ef710d8a38ec"},{"index":16145,"token":false,"name":"Darigaaz's Attendant","scryfallId":"6f22b575-443a-4c06-8e75-d4140cbd3660"},{"index":16146,"token":false,"name":"Spectral Prison","scryfallId":"89d141bc-7307-40c2-a7ed-427caaec5efc"},{"index":16149,"token":false,"name":"Scion of Glaciers","scryfallId":"5e370939-831b-4c42-8291-8ffb0b6c1af7"},{"index":16150,"token":false,"name":"Blood Bairn","scryfallId":"433821dd-9a38-4ace-b9d2-cd081784e957"},{"index":16151,"token":false,"name":"Join the Ranks","scryfallId":"e27e2eb4-d48b-43c3-bd19-e1748f310c54"},{"index":16152,"token":false,"name":"Summoner's Bane","scryfallId":"54a9a782-3479-41cd-9c4f-fa38bfad98c8"},{"index":16154,"token":false,"name":"Kargan Warleader","scryfallId":"cbef1409-4e7c-445e-ae6b-b3133faf1f73"},{"index":16155,"token":false,"name":"Noxious Ghoul","scryfallId":"7d67511b-c130-44d5-8536-4278a695627c"},{"index":16156,"token":false,"name":"Domri's Nodorog","scryfallId":"1abe58d8-67d1-4719-8e84-27747dea3506"},{"index":16159,"token":false,"name":"Exclude","scryfallId":"aeb359c8-209c-455f-84b2-970e5678a9fa"},{"index":16161,"token":false,"name":"Jungle Delver","scryfallId":"be0e3547-d8cb-4b68-a396-8c8fbc3b2b1c"},{"index":16162,"token":false,"name":"Godtracker of Jund","scryfallId":"7bd3fb7a-3eed-4b0a-9de0-ed8b7cf03533"},{"index":16163,"token":false,"name":"Sharuum the Hegemon","scryfallId":"f8896272-4806-40ba-94fd-51310269aa07"},{"index":16169,"token":false,"name":"Jhessian Balmgiver","scryfallId":"5e638e38-15b9-4081-8340-985d4646e3d7"},{"index":16173,"token":false,"name":"Gitaxian Probe","scryfallId":"995486ce-58bb-4753-a812-0ca73ef1a235"},{"index":16174,"token":false,"name":"Soratami Rainshaper","scryfallId":"b942ee46-c78b-414a-9de7-4376370532fa"},{"index":16177,"token":false,"name":"Searing Spear","scryfallId":"44c5f884-d071-40c2-bb2c-925dc2197ea3"},{"index":16178,"token":false,"name":"Steam Catapult","scryfallId":"cdbf23ff-e095-4c5c-afe6-76badfc422c5"},{"index":16179,"token":false,"name":"Gladehart Cavalry","scryfallId":"47857014-0ddf-4797-988e-f5da4dd585a6"},{"index":16185,"token":false,"name":"Ultimate Price","scryfallId":"b41f7cf3-bd76-4184-b694-f565aa5cf3a4"},{"index":16188,"token":false,"name":"Deeproot Waters","scryfallId":"24bec3b7-5dfc-4b48-ae8f-5bf49470d030"},{"index":16189,"token":false,"name":"Darien, King of Kjeldor","scryfallId":"ed5f96a4-55e0-4ae3-bd78-f01703649e9d"},{"index":16190,"token":false,"name":"Shadewing Laureate","scryfallId":"64795a8b-8cf2-436e-8f95-9e8bb40c0d7d"},{"index":16191,"token":false,"name":"Seasinger","scryfallId":"c5266aa1-e2ea-46b9-91ab-b94a7bb7e9f9"},{"index":16192,"token":false,"name":"Flying Men","scryfallId":"25ab9a2b-e248-4ae2-aac3-b49fdb3e260a"},{"index":16194,"token":false,"name":"Silburlind Snapper","scryfallId":"d7347f4c-a4b3-4c71-91e5-699475e5926e"},{"index":16195,"token":false,"name":"Eidolon of the Great Revel","scryfallId":"183ef738-0559-49ca-85b4-e6836521f203"},{"index":16196,"token":false,"name":"Nephalia Drownyard","scryfallId":"ef058312-6926-49f8-ae72-a8d60fedbf6c"},{"index":16200,"token":false,"name":"Balan, Wandering Knight","scryfallId":"5d0b279c-9a6d-4a56-878e-0ebf3f609f65"},{"index":16201,"token":false,"name":"Riot Spikes","scryfallId":"63d0f909-9906-4ff7-9b10-9d817f20d8a9"},{"index":16202,"token":false,"name":"Windcaller Aven","scryfallId":"88d26568-be8f-4a04-82b6-4c37b55d4cfd"},{"index":16206,"token":false,"name":"True Believer","scryfallId":"85a9c5c4-47d1-4b87-8cbd-2212ee6c5887"},{"index":16207,"token":false,"name":"Hada Freeblade","scryfallId":"099718e6-9896-4d5e-8edb-3bc9a15c81ec"},{"index":16208,"token":false,"name":"Sunspring Expedition","scryfallId":"b0811c4c-9e91-4785-b3d2-e4221c5d92d8"},{"index":16209,"token":false,"name":"Ob Nixilis, the Hate-Twisted","scryfallId":"b049e8fe-aa50-40a9-9d2d-5ae69314bcef"},{"index":16212,"token":false,"name":"Woodfall Primus","scryfallId":"0bb81647-e8ff-492e-a862-1b1ca142efe6"},{"index":16214,"token":false,"name":"Hellkite Igniter","scryfallId":"83715873-9330-4d29-b106-cf1e6a66d1e9"},{"index":16216,"token":false,"name":"Rakdos Headliner","scryfallId":"aad6576b-605c-4007-a2a7-0d7550520d6d"},{"index":16217,"token":false,"name":"Pardic Firecat","scryfallId":"16858395-c742-4657-88c2-5af20c92718d"},{"index":16220,"token":false,"name":"Konda's Banner","scryfallId":"759b2f39-e1b1-44aa-b49a-00ef6926a6ac"},{"index":16221,"token":false,"name":"Lightning Blast","scryfallId":"a20fee0e-93b8-4dc0-b156-8237271ae66c"},{"index":16222,"token":false,"name":"Dead Revels","scryfallId":"f5b2c21a-419d-4896-82e3-1b5cb32b158e"},{"index":16227,"token":false,"name":"Drake Umbra","scryfallId":"3e1f7334-658d-44da-a81c-26b258e44c26"},{"index":16228,"token":false,"name":"Trace of Abundance","scryfallId":"6151001a-cf4b-4f95-a986-7181313e2224"},{"index":16229,"token":false,"name":"Endless Swarm","scryfallId":"f64d9404-9685-495d-a591-63d6164a88a9"},{"index":16230,"token":false,"name":"Sigil of the New Dawn","scryfallId":"64393586-42c6-4874-9473-85c63c7ed2ad"},{"index":16232,"token":false,"name":"Morbid Bloom","scryfallId":"684ebc3a-e3b4-4dee-92ff-4a85556e0571"},{"index":16233,"token":false,"name":"Town Gossipmonger // Incited Rabble","scryfallId":"d238d324-8c88-43ca-b203-133830d29447"},{"index":16235,"token":false,"name":"Brigid, Hero of Kinsbaile","scryfallId":"da70a20f-213e-4d79-a46f-1ef1fc3f4a51"},{"index":16236,"token":false,"name":"Blisterspit Gremlin","scryfallId":"4ec65b97-d5c0-4609-8a60-3c4daa3e59c1"},{"index":16238,"token":false,"name":"Akroma, Vision of Ixidor","scryfallId":"c0bdd07d-9fb9-4ee4-80db-494ee0cba58d"},{"index":16240,"token":true,"name":"Bird Token (U, 1/1)","scryfallId":"26e0e196-36e6-4d7a-a76b-1c2a18270267"},{"index":16241,"token":false,"name":"Tidewater Minion","scryfallId":"67ffa68f-cc21-41c8-ad3d-d6b60a4ccd36"},{"index":16242,"token":true,"name":"Lizard Token (R, 8/8)","scryfallId":"70345006-5cde-44f8-ab66-9d8163d4c4f6"},{"index":16243,"token":false,"name":"Wall of Junk","scryfallId":"cd3f88b3-9796-4d4d-af8b-543f0d280e77"},{"index":16244,"token":false,"name":"Guan Yu's 1,000-Li March","scryfallId":"cdb63900-b600-47ab-9f53-cd1441df31d2"},{"index":16245,"token":false,"name":"Corpulent Corpse","scryfallId":"c8680e7c-f180-45b9-9af6-a8e93037b851"},{"index":16246,"token":false,"name":"Heartwood Giant","scryfallId":"d7ba2884-128b-4bfb-9a6e-cb81ff4ac00d"},{"index":16247,"token":false,"name":"Sheltering Prayers","scryfallId":"a30803e6-7f0e-4832-b121-b18480c6465c"},{"index":16250,"token":false,"name":"Defiant Falcon","scryfallId":"4c80032b-daeb-4661-9a66-61abe9d12ddd"},{"index":16251,"token":false,"name":"Araba Mothrider","scryfallId":"f6e4a170-1075-47e4-abe6-996b161573c1"},{"index":16252,"token":false,"name":"Valduk, Keeper of the Flame","scryfallId":"253f9e43-5bc6-4f26-a8e9-773cd0ca3d02"},{"index":16255,"token":false,"name":"Flowstone Crusher","scryfallId":"fd861b1c-8d91-4595-9fcd-b324234f2264"},{"index":16256,"token":false,"name":"Suncleanser","scryfallId":"3644df41-b690-4581-ac7d-c85cec75411f"},{"index":16260,"token":false,"name":"Dragon Roost","scryfallId":"25ee944f-7898-4597-ac45-074bd20bda2b"},{"index":16261,"token":false,"name":"Dunerider Outlaw","scryfallId":"9965d9f9-0a7b-48bc-a6ab-d8b73c4550a8"},{"index":16262,"token":false,"name":"Bog Wreckage","scryfallId":"189b4925-b34b-43bd-869e-1b1db99450e6"},{"index":16267,"token":false,"name":"Apothecary Initiate","scryfallId":"9b6ae637-bdb7-4117-8539-e424159bad6f"},{"index":16272,"token":false,"name":"Gisela, the Broken Blade // Brisela, Voice of Nightmares","scryfallId":"e48b5d96-3c27-4d14-abfc-92db5cbb13ee"},{"index":16274,"token":false,"name":"Canopy Tactician","scryfallId":"3eaf48c9-09bc-4d81-a3a5-432219a71754"},{"index":16278,"token":true,"name":"Champion of Wits Token (B, 4/4)","scryfallId":"65eebe6c-5bc9-463c-b74c-eae79fc3c1b6"},{"index":16280,"token":false,"name":"Crush Dissent","scryfallId":"94c70f23-0ca9-425e-a53a-6c09921c0075"},{"index":16281,"token":false,"name":"Ichor Explosion","scryfallId":"0b207e2f-4604-43c5-bb35-a877e35ddd81"},{"index":16282,"token":false,"name":"Honor-Worn Shaku","scryfallId":"babe91f2-06be-4501-a95b-20968e906e1b"},{"index":16284,"token":false,"name":"Skyspear Cavalry","scryfallId":"c86ab26f-0959-476f-9f83-939e9138ca8d"},{"index":16290,"token":false,"name":"Iroas's Blessing","scryfallId":"ab6e99a5-b105-489e-aff6-7d2ca50d8ba9"},{"index":16292,"token":false,"name":"Crashing Boars","scryfallId":"e264adbc-1c52-4207-b2e6-0dd76a58f2d6"},{"index":16293,"token":false,"name":"Dictate of Heliod","scryfallId":"aa103dfb-20a0-4a7b-a34b-99339f0364a7"},{"index":16294,"token":false,"name":"Soaring Show-Off","scryfallId":"2e6c52da-efc8-4279-b6b5-01e490bcb035"},{"index":16295,"token":false,"name":"Crypt Angel","scryfallId":"d3c3dfbe-b520-42fb-af03-bc6c15f7ba92"},{"index":16299,"token":false,"name":"Gnarlid Pack","scryfallId":"87fb769d-a2bd-4bd1-bf98-b67997f541b1"},{"index":16301,"token":false,"name":"Dragonstorm","scryfallId":"230cd568-f7ed-4571-a609-36522add91d0"},{"index":16303,"token":false,"name":"Sultai Scavenger","scryfallId":"2cb8e423-f7e7-4ac3-acc2-2a3722e409e7"},{"index":16304,"token":false,"name":"Sliver Hivelord","scryfallId":"ba4106de-20c7-48cf-8a36-8c6913b46c89"},{"index":16309,"token":true,"name":"Elemental // Centaur Token (G, 3/3)","scryfallId":"d2d19d33-407b-42fc-84de-d8a0642723c1"},{"index":16310,"token":false,"name":"Final-Sting Faerie","scryfallId":"fb237de0-bf73-445f-a42b-c3da4cd35973"},{"index":16311,"token":true,"name":"Kai Budde Decklist","scryfallId":"b62b648e-f572-4b3b-8315-983d27704b8c"},{"index":16312,"token":false,"name":"Pale Wayfarer","scryfallId":"f852508e-7087-42e1-ad9b-c84708e92de7"},{"index":16315,"token":false,"name":"Brain Weevil","scryfallId":"40e1bd88-939a-4adc-8693-210a7ba9a5a1"},{"index":16316,"token":false,"name":"Walker of the Wastes","scryfallId":"34f635ac-ad6d-4a13-a08e-64c8e2b9779c"},{"index":16317,"token":false,"name":"Bone Miser","scryfallId":"21f348f7-f14a-4752-a4d1-d8becffa1ba8"},{"index":16318,"token":false,"name":"Whispers of the Muse","scryfallId":"75c5cfd1-3f7c-4250-a84d-8db83c6d7eb7"},{"index":16321,"token":false,"name":"Reverberate","scryfallId":"7062e2f3-bf4a-4a9a-962c-b45718a464bc"},{"index":16323,"token":false,"name":"Wall of Putrid Flesh","scryfallId":"07a17b74-a9c9-419a-8369-9ab4fec213f2"},{"index":16324,"token":false,"name":"Gorilla Chieftain","scryfallId":"9e76185a-519f-4bec-b399-989ebddbab71"},{"index":16325,"token":false,"name":"Wren's Run Vanquisher","scryfallId":"96ad01fc-2641-48fd-8c95-fe69a42f1c85"},{"index":16326,"token":false,"name":"Gang of Elk","scryfallId":"cd0a61c9-8b14-4255-8453-4b74d90fe0a3"},{"index":16327,"token":false,"name":"Longshot Squad","scryfallId":"dd9edd62-dc18-4887-a020-4464e31b79c2"},{"index":16329,"token":false,"name":"Dark Temper","scryfallId":"e3209997-8cdc-40e9-9e95-92a0f33e7f8e"},{"index":16330,"token":false,"name":"Saheeli's Artistry","scryfallId":"02e746ba-953b-417c-85fa-cd301bc05205"},{"index":16333,"token":false,"name":"Woodwraith Strangler","scryfallId":"be72ff91-f810-46c3-884f-6e65827824bc"},{"index":16334,"token":false,"name":"Zephyr Spirit","scryfallId":"e6cbe78f-4325-416b-bf23-282efed5b407"},{"index":16335,"token":false,"name":"Battlefield Promotion","scryfallId":"89f8e970-b90c-4829-8970-0a3364027bbb"},{"index":16336,"token":false,"name":"Workshop Elders","scryfallId":"53913e26-d98b-4ca6-aeea-23633d762d46"},{"index":16338,"token":false,"name":"Shapers' Sanctuary","scryfallId":"cb40097f-2a92-40b3-97cc-9159386baf49"},{"index":16341,"token":false,"name":"Insolent Neonate","scryfallId":"b4521c0e-3f64-4f37-b919-d2500f42607c"},{"index":16344,"token":true,"name":"2002 World Championships Ad","scryfallId":"9b896682-eb09-47cb-8135-e8546e9173e1"},{"index":16345,"token":true,"name":"Manifest Token (Colorless, 2/2)","scryfallId":"e9f896d4-34b4-407d-be7e-bf7a69aaf811"},{"index":16346,"token":false,"name":"Tremor","scryfallId":"8531efb1-d77d-451a-8621-424fc278ccf9"},{"index":16348,"token":false,"name":"Bad Deal","scryfallId":"c73d8462-6901-47c4-99e8-93efb5d54737"},{"index":16349,"token":false,"name":"Sand Squid","scryfallId":"4efd7ce9-b920-409d-a4d2-a07fff280712"},{"index":16351,"token":false,"name":"Iron Lance","scryfallId":"41f7d212-faf2-4a6f-a338-d9e5014b56d5"},{"index":16354,"token":false,"name":"Deadeye Tracker","scryfallId":"848902db-7a10-4754-b50a-57a9e845705a"},{"index":16361,"token":false,"name":"Soldevi Simulacrum","scryfallId":"9fabc7b6-e766-4e3c-816e-04cfeceaff09"},{"index":16363,"token":false,"name":"Kodama of the East Tree","scryfallId":"af5105ee-09e2-4344-ab39-00f0e9034c47"},{"index":16364,"token":false,"name":"Diabolic Revelation","scryfallId":"145d6d7b-1e87-47b7-baf3-d201458ad996"},{"index":16366,"token":false,"name":"Stampeding Rhino","scryfallId":"cd02ae80-4af6-4da1-ba3b-b56068c49785"},{"index":16367,"token":false,"name":"Elemental Resonance","scryfallId":"9757631a-c505-4a16-94c1-8bb609ce7bc5"},{"index":16368,"token":false,"name":"Heartwood Dryad","scryfallId":"e2b9a001-2a1e-4fc4-9b84-c776f741a858"},{"index":16369,"token":false,"name":"Hallowed Ground","scryfallId":"4b35c0f4-5633-4ea9-9bda-daaf787aebdd"},{"index":16372,"token":false,"name":"Llanowar Sentinel","scryfallId":"6f37ea4b-66e2-4ad5-ae7f-d02fd59131bd"},{"index":16373,"token":false,"name":"Mirko Vosk, Mind Drinker","scryfallId":"559f12ac-ed65-4762-bf60-1e9167c0ce18"},{"index":16377,"token":false,"name":"Eradicate","scryfallId":"0fad4607-c11d-4407-b5fa-bd34f74e41b3"},{"index":16378,"token":false,"name":"Necrotic Ooze","scryfallId":"58cbcf51-3824-4ab3-89e3-cdcc1a0c7267"},{"index":16383,"token":false,"name":"Ashen Firebeast","scryfallId":"ebaef0bd-8288-49ba-a889-d897a4aae64c"},{"index":16385,"token":false,"name":"Moss Kami","scryfallId":"a437cde4-c40b-40a3-bc19-e461c98186dc"},{"index":16388,"token":false,"name":"Rogue Skycaptain","scryfallId":"97aebf3b-e77d-4d18-b58b-117ae91792e2"},{"index":16390,"token":false,"name":"Plague Mare","scryfallId":"995596a3-343d-4272-86bf-d76fd32ab78e"},{"index":16392,"token":false,"name":"Game of Chaos","scryfallId":"95b44933-6b0b-426a-97d4-7a7cf6ad1d65"},{"index":16393,"token":false,"name":"Dread Defiler","scryfallId":"37d3e2c2-c4bd-4c13-a9f8-be692815c7bb"},{"index":16394,"token":false,"name":"Steadfast Sentinel","scryfallId":"707a30d2-0fca-4b39-91fb-9b03152705ba"},{"index":16395,"token":false,"name":"Vampire Interloper","scryfallId":"e22b76e5-4b37-4638-9002-089d5d967cd3"},{"index":16396,"token":false,"name":"Gang Up","scryfallId":"10d01449-3e4e-44ef-90aa-9489c86c57df"},{"index":16398,"token":false,"name":"Starnheim Aspirant","scryfallId":"ea007a18-b31a-4881-92c4-86120dc5729b"},{"index":16401,"token":false,"name":"Pardic Lancer","scryfallId":"f487a6a7-066a-49bb-ab76-d79fc4300c29"},{"index":16405,"token":false,"name":"Chandra, the Firebrand","scryfallId":"beb039db-7367-4af1-8d85-4951f58e2732"},{"index":16406,"token":false,"name":"Attendant of Vraska","scryfallId":"7f4840f1-3db3-4ba6-b75b-bbd87251a3af"},{"index":16407,"token":false,"name":"Puncturing Light","scryfallId":"5b101264-4994-43b7-9156-228f7d10d2bd"},{"index":16409,"token":false,"name":"Serra's Emissary","scryfallId":"b6534049-3045-4546-b1e8-e5b1b0df5f56"},{"index":16411,"token":false,"name":"Fire-Omen Crane","scryfallId":"5ea4142d-bcc1-4716-ab1c-4d7f70a2fc5a"},{"index":16413,"token":true,"name":"Heart-Piercer Manticore Token (W, 4/3)","scryfallId":"ad1863c6-13c8-4116-9312-32c215f88ee1"},{"index":16415,"token":false,"name":"Overwhelming Denial","scryfallId":"1023b971-4f29-4f58-8da7-836bcfeb980e"},{"index":16416,"token":false,"name":"Numot, the Devastator","scryfallId":"073438f2-0897-4226-b42a-4fd26d8f4e71"},{"index":16417,"token":false,"name":"Chitinous Cloak","scryfallId":"15e54603-af67-497f-afe0-88cfa4d00095"},{"index":16418,"token":false,"name":"Synchronized Strike","scryfallId":"fcb09d11-5a6d-498f-9173-3539760b19fb"},{"index":16426,"token":false,"name":"Observant Alseid","scryfallId":"e1410d10-476a-4ed2-ae44-75383ed0e359"},{"index":16427,"token":false,"name":"Unfulfilled Desires","scryfallId":"3389d6c7-2a8a-48d6-a09d-aa195d830576"},{"index":16428,"token":false,"name":"High Sentinels of Arashin","scryfallId":"abd163f9-5510-47e2-a47a-a34d0bb14855"},{"index":16429,"token":false,"name":"Segmented Krotiq","scryfallId":"dcdbe824-f9c7-4f4d-af92-438b16057d99"},{"index":16431,"token":false,"name":"Grixis Charm","scryfallId":"fa22f972-39c2-4e18-878d-bd091dfb9877"},{"index":16436,"token":false,"name":"Bloodhusk Ritualist","scryfallId":"5b5445e2-1fa8-4c66-b441-892a76675810"},{"index":16437,"token":false,"name":"Geistflame","scryfallId":"c671b096-17a4-4cdb-b954-7b04981e7aef"},{"index":16439,"token":false,"name":"Dissenter's Deliverance","scryfallId":"ab13ce7b-ad08-4538-ab22-13f2a25ba55a"},{"index":16442,"token":false,"name":"Kytheon's Irregulars","scryfallId":"1c9d2dd8-cdcf-4a89-ac5d-b00c13ce94ff"},{"index":16444,"token":false,"name":"Torsten Von Ursus","scryfallId":"5fd99522-4a91-4ccd-91bf-5f32a6ac3510"},{"index":16446,"token":false,"name":"Adorned Pouncer","scryfallId":"2f5c8b10-eacd-4a7e-aa25-e3406d5c0b5a"},{"index":16447,"token":false,"name":"Goblin Chariot","scryfallId":"b6590436-d0f9-4c50-bab4-f7a094aa6e1a"},{"index":16449,"token":false,"name":"Dream Leash","scryfallId":"0de4fa3d-a144-4918-b032-7495ab2e1c8c"},{"index":16453,"token":false,"name":"Crowned Ceratok","scryfallId":"e63308fc-40b6-40f5-a0a8-d0ca06d83de5"},{"index":16455,"token":false,"name":"Chronosavant","scryfallId":"d6264d4f-adf1-4d7b-b17a-fd7122e9b2cd"},{"index":16456,"token":false,"name":"Thorn of the Black Rose","scryfallId":"2e4829c6-50d4-4602-af78-59249486a97c"},{"index":16458,"token":false,"name":"Augur il-Vec","scryfallId":"1c1fdf86-22aa-4c18-a971-8ff1fd8b3de1"},{"index":16460,"token":false,"name":"Skeletal Changeling","scryfallId":"6f1d8e26-304b-4571-9b33-7713265d9bbf"},{"index":16461,"token":false,"name":"Legion Angel","scryfallId":"bcc4014f-f9aa-4a46-b772-474e56ed72c3"},{"index":16462,"token":false,"name":"Silverfur Partisan","scryfallId":"a20f5392-5cde-4326-a322-7463ec4b0515"},{"index":16464,"token":false,"name":"Essence Depleter","scryfallId":"996da623-1c34-4545-a800-648238ea91ae"},{"index":16469,"token":false,"name":"Dingus Staff","scryfallId":"065b4358-5dee-4f13-bff9-8254bdb92069"},{"index":16472,"token":false,"name":"Chime of Night","scryfallId":"1ec7c917-b254-4643-afc2-b6387f267469"},{"index":16477,"token":false,"name":"Descendant of Soramaro","scryfallId":"b5217d17-3667-46c6-8fba-763197fb2970"},{"index":16478,"token":false,"name":"Greenbelt Rampager","scryfallId":"f3f06124-bcc4-48c0-a7a6-a461c7485ecd"},{"index":16480,"token":false,"name":"Gluttonous Slug","scryfallId":"9514ce0d-8d61-4cce-b2ad-8f417869d04e"},{"index":16481,"token":false,"name":"Steam Vines","scryfallId":"d3936053-b2ed-49b8-ab69-fe47a972cfe4"},{"index":16483,"token":false,"name":"Phyrexian Reaper","scryfallId":"ccdd498b-1081-43fe-8193-518337a5a3ea"},{"index":16485,"token":false,"name":"Aven Tactician","scryfallId":"b9dfc3ec-ca06-40a6-b77c-c2432af9802f"},{"index":16486,"token":false,"name":"Blinding Beam","scryfallId":"d0b15737-1026-407f-b2a8-4f7932b2bb18"},{"index":16487,"token":false,"name":"Ogre Resister","scryfallId":"60b7407d-f677-403b-893c-361df456009a"},{"index":16490,"token":false,"name":"Dark Prophecy","scryfallId":"ecf82c3b-7a35-43dd-8bf3-ebc68dc1b8fc"},{"index":16491,"token":false,"name":"Empyrial Plate","scryfallId":"e1735bbb-402e-4657-8ad0-df2c56d5ee01"},{"index":16493,"token":false,"name":"Blade of the Bloodchief","scryfallId":"0c80fbef-ad13-4ff1-92ae-f8363ed5c6ab"},{"index":16496,"token":false,"name":"Boros Guildgate","scryfallId":"095082a3-1b7d-4d45-954b-2c2881256ad8"},{"index":16498,"token":true,"name":"Beast // Beast","scryfallId":"610def80-1303-488e-bfd9-4a27f031d20e"},{"index":16499,"token":false,"name":"Petrified Wood-Kin","scryfallId":"a56fbf32-f08f-4882-b8d4-41ccb60cba63"},{"index":16501,"token":false,"name":"Enchantment Alteration","scryfallId":"f94c7a9a-4b7e-438e-9f8f-b22a9e757f4f"},{"index":16502,"token":false,"name":"Kithkin Shielddare","scryfallId":"7e5102a7-2147-4e22-b683-c08b4a725617"},{"index":16503,"token":false,"name":"Fa'adiyah Seer","scryfallId":"70180e04-1453-43dc-9bbb-ab0d6291a8b5"},{"index":16507,"token":false,"name":"Mind Over Matter","scryfallId":"6e091dd6-149f-46ea-bae0-224e79e3aacb"},{"index":16509,"token":false,"name":"Sultai Charm","scryfallId":"993c9028-9b1b-4903-81b2-3cf4f37b7229"},{"index":16511,"token":false,"name":"Icehide Golem","scryfallId":"b2671c36-96fa-49e3-90dc-52820b2c8a62"},{"index":16515,"token":false,"name":"Chaos Charm","scryfallId":"ebf8ccb8-57fb-491c-b07d-93348b33a765"},{"index":16516,"token":false,"name":"Ulamog, the Ceaseless Hunger","scryfallId":"1192f7a9-102e-4b3a-b154-18c8eb332217"},{"index":16519,"token":false,"name":"Baird, Steward of Argive","scryfallId":"72168ec2-e520-4c14-b94d-c5ff03179498"},{"index":16520,"token":false,"name":"Glenn, the Voice of Calm","scryfallId":"6e5df29a-af3b-4acc-8312-f2024ab039e0"},{"index":16522,"token":false,"name":"Thieving Skydiver","scryfallId":"8541c7cb-b59e-46be-b388-78ab1603c7ad"},{"index":16523,"token":false,"name":"Eyes of the Watcher","scryfallId":"f7bb0716-e0fc-415d-8fc3-d3f5ee31e9c5"},{"index":16524,"token":false,"name":"Parasitic Impetus","scryfallId":"0e8dec27-b09c-43dc-8ed9-b8de12336298"},{"index":16526,"token":false,"name":"Subira, Tulzidi Caravanner","scryfallId":"440c4603-3654-40b0-97b9-8078cdd4168b"},{"index":16530,"token":false,"name":"Infiltrate","scryfallId":"c549b817-8ad6-44d0-9761-5e4ff9e62c71"},{"index":16531,"token":false,"name":"Sickleslicer","scryfallId":"eb0a9736-c84d-42a6-831c-3b1a8bad50b7"},{"index":16532,"token":false,"name":"Hanabi Blast","scryfallId":"881fecf4-8c14-4614-84bd-c1a3dcdbb5ff"},{"index":16534,"token":false,"name":"Demonic Torment","scryfallId":"d3ec14bc-95e9-47ce-b51e-d5eac9b345fe"},{"index":16535,"token":false,"name":"Shape the Sands","scryfallId":"ce0aadcf-25bf-454a-b025-49656cad0349"},{"index":16537,"token":false,"name":"Nighthaze","scryfallId":"290b215b-13cb-493a-83f9-f89edfa6b314"},{"index":16539,"token":false,"name":"Twins of Maurer Estate","scryfallId":"726f760e-90e6-4b24-aa43-c5a0ef4d4432"},{"index":16543,"token":false,"name":"Burning-Tree Emissary","scryfallId":"48335a70-151d-4d92-8365-e2ad9ac153ac"},{"index":16545,"token":false,"name":"Segmented Wurm","scryfallId":"4d780bcf-9480-451c-a6c8-d86457816210"},{"index":16549,"token":false,"name":"Archers' Parapet","scryfallId":"64ac0667-8ecc-4034-89bb-dce0af531014"},{"index":16551,"token":false,"name":"Rubblebelt Runner","scryfallId":"78cc4e02-949f-4879-9f32-7c33490d0b45"},{"index":16553,"token":false,"name":"Emissary of the Sleepless","scryfallId":"cc5fa496-a830-4031-a19a-d6467d074ad1"},{"index":16554,"token":false,"name":"Rain of Blades","scryfallId":"7a25bf0b-7de0-4e71-ae3e-59a6665dc903"},{"index":16556,"token":false,"name":"Plague Stinger","scryfallId":"568d7e97-ae65-47e8-b53d-1bc367738c78"},{"index":16559,"token":false,"name":"Silverquill Campus","scryfallId":"42583850-ba5c-4a71-8717-406b5c6d048f"},{"index":16560,"token":false,"name":"Fate Transfer","scryfallId":"3e052cde-985a-401f-828a-2d98511bbcd5"},{"index":16562,"token":false,"name":"School of Piranha","scryfallId":"71217af5-3538-4e42-9343-3949b5306671"},{"index":16563,"token":false,"name":"Rustrazor Butcher","scryfallId":"daa0dd3e-51d1-4d75-b0f4-835992f420d6"},{"index":16566,"token":false,"name":"Dwarven Sea Clan","scryfallId":"4cb722d9-1998-4912-a6f2-4ffa8d21311a"},{"index":16569,"token":false,"name":"Eon Hub","scryfallId":"d5d6b270-b4c9-489d-9322-7c8ddc0ca0ac"},{"index":16571,"token":false,"name":"Coalition Honor Guard","scryfallId":"2c7c2b5c-634a-4d83-81bc-c6128e3ac339"},{"index":16572,"token":false,"name":"Judge of Currents","scryfallId":"3073f3f5-bff8-4ec1-a68f-c83d63435843"},{"index":16573,"token":false,"name":"Satyr Piper","scryfallId":"e244c4d0-2c30-4a56-94bb-0fff9ffe4a6a"},{"index":16574,"token":false,"name":"Tablet of Epityr","scryfallId":"4534c401-a144-41de-b4ee-f3b389d21316"},{"index":16575,"token":false,"name":"Creeping Corrosion","scryfallId":"05d5a7b3-18b6-4b1d-85cc-2253e605390c"},{"index":16576,"token":false,"name":"Scryb Ranger","scryfallId":"8cb36481-20a5-43b1-845d-ef7de3fb6410"},{"index":16577,"token":false,"name":"Thunder Drake","scryfallId":"125d16a5-d7b8-4e50-aca1-5f94a0c19260"},{"index":16582,"token":false,"name":"Overeager Apprentice","scryfallId":"8b886292-5937-44ee-bc2a-f316791c91ae"},{"index":16583,"token":false,"name":"Nether Void","scryfallId":"2e72f8cb-5bc3-4711-9b7c-a6eea9a0beaf"},{"index":16584,"token":false,"name":"Frilled Sandwalla","scryfallId":"07b1be52-5e54-4840-bb53-0b2512785e0b"},{"index":16586,"token":false,"name":"Door to Nothingness","scryfallId":"151e0e5d-656e-4bec-8110-f31a3bb5f014"},{"index":16587,"token":false,"name":"Warden of the Eye","scryfallId":"04135bf7-2bcf-4a92-80f0-6d5eefca551b"},{"index":16591,"token":false,"name":"Wrangle","scryfallId":"5ea93a49-5a7c-4d15-8548-a57c9460e0f0"},{"index":16593,"token":false,"name":"Psychic Battle","scryfallId":"8758ca24-e613-43bf-be58-4cf557f82d0c"},{"index":16594,"token":false,"name":"Allure of the Unknown","scryfallId":"54aabd14-7fc7-4ba0-9fde-0aac3edb077d"},{"index":16596,"token":false,"name":"Hearth Kami","scryfallId":"d7361289-5111-49c2-a786-b7181384596b"},{"index":16597,"token":false,"name":"Felidar Guardian","scryfallId":"44bdbed8-5d21-4bf5-8a32-9623b1139c85"},{"index":16602,"token":false,"name":"Beck // Call","scryfallId":"66b3f745-055b-4338-b6f0-7b7281d63afd"},{"index":16603,"token":false,"name":"Hapatra, Vizier of Poisons","scryfallId":"b43ba233-30c4-4b18-8489-4df76551aa73"},{"index":16604,"token":false,"name":"Stolen by the Fae","scryfallId":"e2292d6e-da39-4755-8cd8-639e47a4576e"},{"index":16605,"token":false,"name":"Strength of Lunacy","scryfallId":"afda26e7-4fdd-45e1-bcd1-f0abf91979aa"},{"index":16608,"token":false,"name":"Endbringer's Revel","scryfallId":"b76843b0-0e71-473b-8c9b-6a8bc30255da"},{"index":16611,"token":false,"name":"Sylvan Paradise","scryfallId":"f323c3bb-cece-4035-b1a7-c4817cf7a08c"},{"index":16612,"token":false,"name":"Keeper of the Accord","scryfallId":"60f50b6f-0049-4f2c-8a41-1345d1b88dae"},{"index":16620,"token":false,"name":"Wu Infantry","scryfallId":"ebe4115e-7ca3-4996-a390-133c2e6d09b7"},{"index":16621,"token":false,"name":"Gorehorn Minotaurs","scryfallId":"cda652b4-3ae5-4a5b-be82-c0e47a886907"},{"index":16624,"token":false,"name":"Ghost-Lit Raider","scryfallId":"4280a08a-90fe-445e-b49d-1a3b13d3c6e9"},{"index":16627,"token":false,"name":"Jagwasp Swarm","scryfallId":"bd4e933b-de65-4089-877f-c598004b8e7e"},{"index":16628,"token":false,"name":"Creeperhulk","scryfallId":"c70f3a79-5b79-4496-9234-58baeae74af3"},{"index":16629,"token":false,"name":"Vexing Shusher","scryfallId":"7e0acfb7-c2d9-4b94-9ac6-9374856abad1"},{"index":16630,"token":false,"name":"Fated Return","scryfallId":"5d168856-5568-4ee0-942d-78865d2bb1ef"},{"index":16632,"token":false,"name":"Chilling Trap","scryfallId":"60f9adfd-a940-4d62-894b-84f17c693a10"},{"index":16633,"token":false,"name":"Aquamoeba","scryfallId":"78eb2ea6-78cc-4f97-a692-34d95cf9a540"},{"index":16634,"token":false,"name":"Hurly-Burly","scryfallId":"7a6e0b97-c2a9-4cd6-957e-87e9b22f7b48"},{"index":16635,"token":false,"name":"Kei Takahashi","scryfallId":"82703d7c-0759-46ac-b41e-12deeffa10e0"},{"index":16636,"token":false,"name":"The First Sliver","scryfallId":"59fa538b-fa1c-4cdc-9fc0-801d6b618f01"},{"index":16637,"token":false,"name":"Orchard Spirit","scryfallId":"aac43ced-35b0-4e70-a049-1a65db9b2b1e"},{"index":16638,"token":false,"name":"Runeforge Champion","scryfallId":"4368b087-05a0-4a88-ab43-0cd16446239b"},{"index":16639,"token":false,"name":"Scrapbasket","scryfallId":"3c7f0a6d-4127-4ea4-be16-2ed6b263a3f3"},{"index":16643,"token":false,"name":"Breeding Pit","scryfallId":"37c9b663-5c02-4221-9efb-59841dfd2188"},{"index":16645,"token":false,"name":"Knight of the Pilgrim's Road","scryfallId":"b9de5f39-b07a-4272-8992-ed971132c9c4"},{"index":16647,"token":false,"name":"Unpredictable Cyclone","scryfallId":"84b94e1d-f328-4e4c-b112-45d6c6f98376"},{"index":16651,"token":false,"name":"Feasting Troll King","scryfallId":"70dbb5f3-0552-408c-9d02-9f9afc72fa7b"},{"index":16652,"token":false,"name":"Silent Dart","scryfallId":"4e12530d-5509-46f1-8273-dce2c1f60965"},{"index":16654,"token":false,"name":"Conqueror's Flail","scryfallId":"1644f535-9281-4a88-8fac-916bc0021d1d"},{"index":16657,"token":false,"name":"Teferi's Moat","scryfallId":"9ed5845c-ef6d-4a7b-b725-b09d3e9bbc17"},{"index":16658,"token":false,"name":"Eightfold Maze","scryfallId":"d0fb20ae-269b-452b-894b-a8a285428b15"},{"index":16659,"token":false,"name":"Incendiary Flow","scryfallId":"ae93a313-c265-435f-b745-7b7a7ed6208e"},{"index":16661,"token":false,"name":"Lance","scryfallId":"402eea7c-2afe-4e93-9773-3e0424cabfdd"},{"index":16662,"token":false,"name":"Etchings of the Chosen","scryfallId":"7036ab83-94a3-4634-9f0a-dde7af3be450"},{"index":16665,"token":false,"name":"Elspeth Tirel","scryfallId":"ebe9116e-7b04-4f2a-aa67-89a42c6e1801"},{"index":16669,"token":false,"name":"Omen of the Forge","scryfallId":"70388773-709b-4cd8-a8b7-56093fd77a1d"},{"index":16670,"token":false,"name":"Malicious Advice","scryfallId":"7b1547c2-ae9f-4871-a675-4026bf20e7e1"},{"index":16675,"token":false,"name":"Coastline Chimera","scryfallId":"01320a31-25fa-4324-8225-d150c6aa58a1"},{"index":16678,"token":false,"name":"Negan, the Cold-Blooded","scryfallId":"35d03f86-5219-4456-8136-802699ff26d3"},{"index":16679,"token":false,"name":"Echo Mage","scryfallId":"abb327b4-01b0-468c-9916-129c7c64341d"},{"index":16680,"token":false,"name":"Loathsome Curator","scryfallId":"11a59a6f-6ef0-4acc-8358-a4e2cebdb7d5"},{"index":16681,"token":false,"name":"Mayhem Devil","scryfallId":"17416926-168b-49b3-9231-acbb8f8a1d13"},{"index":16685,"token":false,"name":"Resplendent Marshal","scryfallId":"52de996e-e06d-4507-86d1-ffe836182e08"},{"index":16688,"token":false,"name":"Wishmonger","scryfallId":"5a0d8834-109e-4235-a145-75edc43da0ec"},{"index":16689,"token":false,"name":"Lost Leonin","scryfallId":"8209fa5d-2c0e-4827-813b-fff123533f16"},{"index":16690,"token":false,"name":"Guardian Idol","scryfallId":"a6a62a73-b7db-47ec-9b68-65dd7c1a06a5"},{"index":16691,"token":false,"name":"Aryel, Knight of Windgrace","scryfallId":"58e2981b-bf25-4d9d-8811-5a1ff0b4d5d2"},{"index":16693,"token":false,"name":"Wave of Reckoning","scryfallId":"788abc7e-2173-4f6b-81c0-130fd41d7694"},{"index":16694,"token":false,"name":"Tezzeret, Artifice Master","scryfallId":"e5e12371-f05c-41cf-92ca-7cb17c2f7f1a"},{"index":16695,"token":false,"name":"Titania's Song","scryfallId":"f837f0c8-4822-41f1-8677-988c13efe8d5"},{"index":16697,"token":true,"name":"Gabriel Nassif Decklist","scryfallId":"07232e81-f67f-45f2-ab7e-3109e89cf039"},{"index":16698,"token":false,"name":"Song of Serenity","scryfallId":"2ba85b2f-37da-4595-9880-8e9f1ddbac09"},{"index":16701,"token":false,"name":"Brutalizer Exarch","scryfallId":"9ddfa4ed-70fb-4e25-875d-df0f973f7294"},{"index":16702,"token":false,"name":"Aven Brigadier","scryfallId":"da24ef56-8d54-4146-97e9-4abded807545"},{"index":16704,"token":false,"name":"Prismari Campus","scryfallId":"768120f5-9401-4e52-924e-3374bde65b3d"},{"index":16706,"token":false,"name":"Trostani Discordant","scryfallId":"fa1190a4-3d7e-4500-991f-e36ec3d1d9dc"},{"index":16709,"token":false,"name":"Tazri, Beacon of Unity","scryfallId":"d4b79138-5728-4541-9ea5-dce1a5ae7e6a"},{"index":16710,"token":false,"name":"Search the City","scryfallId":"9cd77575-fedc-45b1-a53b-dfed0f34c875"},{"index":16715,"token":false,"name":"Inescapable Blaze","scryfallId":"a5e77225-3b31-49ba-909c-b0c2b3aaeb9b"},{"index":16718,"token":false,"name":"Crushing Vines","scryfallId":"c59b3653-5a50-48f2-bcf1-ab305ef30902"},{"index":16720,"token":false,"name":"Painwracker Oni","scryfallId":"1b371b32-7758-4dc9-b4c5-1d1df1f1826a"},{"index":16721,"token":false,"name":"Hive Stirrings","scryfallId":"34348286-c4b4-4a40-8d6a-b7a0e0186aee"},{"index":16722,"token":false,"name":"Ruxa, Patient Professor","scryfallId":"72de20ad-82dc-4161-9627-42ac2e1258c1"},{"index":16726,"token":false,"name":"Champion of Rhonas","scryfallId":"be86bd0a-46df-4e53-8fe3-7575d0670eef"},{"index":16728,"token":false,"name":"Teferi's Isle","scryfallId":"b6ed7ca8-fd91-46e3-9149-a3de23c7078e"},{"index":16730,"token":false,"name":"Defiant Strike","scryfallId":"ade8f339-4afb-477a-9434-e6cd9126cd10"},{"index":16731,"token":false,"name":"Maul of the Skyclaves","scryfallId":"2537b138-6fc8-41de-b682-fa4c998d980b"},{"index":16732,"token":false,"name":"Wellwisher","scryfallId":"ad9c1236-2bcc-47b5-9e1e-2352e34194aa"},{"index":16733,"token":false,"name":"Gempalm Sorcerer","scryfallId":"67bda65b-2e26-4531-9f6a-952df314c8f7"},{"index":16735,"token":false,"name":"Sage of Ancient Lore // Werewolf of Ancient Hunger","scryfallId":"94c5f7fe-9ca6-4040-bf7c-062ab22e6a02"},{"index":16736,"token":false,"name":"Fetid Imp","scryfallId":"90156192-bf25-4ce5-8c98-0286e96c349e"},{"index":16738,"token":false,"name":"Tatterkite","scryfallId":"dfaf852c-b8a9-44d4-b2cd-3f1e071a8be9"},{"index":16743,"token":false,"name":"Mogis's Warhound","scryfallId":"f2e73e06-d708-41dc-b20c-1f71651230e1"},{"index":16749,"token":false,"name":"Carnival // Carnage","scryfallId":"d1dbc559-c78c-4675-9582-9c28f8151bc7"},{"index":16751,"token":false,"name":"Rowan's Stalwarts","scryfallId":"b537c4e3-88d1-430d-b4c8-16e0716d1927"},{"index":16755,"token":false,"name":"Servant of Volrath","scryfallId":"691afabb-f266-45fd-b5a3-577be4f10f86"},{"index":16756,"token":false,"name":"Oona's Prowler","scryfallId":"9675b8ea-47f9-440e-9535-de879da53f76"},{"index":16761,"token":false,"name":"Disperse","scryfallId":"0ae239b2-1596-4906-9711-1d180a246d35"},{"index":16764,"token":false,"name":"Mindleech Mass","scryfallId":"7cd1ace7-d4fe-4f96-9434-7ab1442bf36f"},{"index":16765,"token":false,"name":"Big Game Hunter","scryfallId":"a61f38a9-6f15-4186-a602-78cdb00f2d75"},{"index":16766,"token":false,"name":"Savage Firecat","scryfallId":"52e14dbe-4d33-405c-ab84-2fc6b1e000b8"},{"index":16767,"token":false,"name":"Victim of Night","scryfallId":"c128272d-4611-477c-84b9-081bddcc7188"},{"index":16768,"token":false,"name":"Neurok Transmuter","scryfallId":"e604172f-e9b8-41bc-aee4-691f9fa4ce42"},{"index":16769,"token":false,"name":"Arcbound Crusher","scryfallId":"748448bb-a1b2-4e84-b09a-5ecc4322f3c6"},{"index":16770,"token":false,"name":"Tundra Fumarole","scryfallId":"50112dbc-275c-47ab-adb1-e9c4de002f40"},{"index":16779,"token":false,"name":"Velomachus Lorehold","scryfallId":"b7151c4b-4d42-44c1-a6f4-8be29ace1df3"},{"index":16782,"token":false,"name":"Marsh Casualties","scryfallId":"0a007dd4-f20d-4ed3-ab0b-96f6ad7236d5"},{"index":16794,"token":false,"name":"Silver Seraph","scryfallId":"1465ca9e-a997-4b8c-9677-6c7961f67eba"},{"index":16795,"token":false,"name":"Initiate of Blood // Goka the Unjust","scryfallId":"b3523b8e-065f-427c-8d5b-eb731ca91ede"},{"index":16798,"token":false,"name":"Lurebound Scarecrow","scryfallId":"89503bf6-d720-4fd5-b2cf-fc1197bf0f16"},{"index":16802,"token":false,"name":"Joven's Ferrets","scryfallId":"3765ab78-a645-4e4f-9f83-5a6bc762b8d0"},{"index":16804,"token":false,"name":"Battle Rampart","scryfallId":"63d2f943-8abc-4042-9d86-80182084ce29"},{"index":16806,"token":false,"name":"Plated Wurm","scryfallId":"b51f8724-8f26-4a9d-b586-4223354ae7fc"},{"index":16807,"token":false,"name":"Avatar of Will","scryfallId":"bf65efc7-6ab5-4116-b003-1f028af80939"},{"index":16810,"token":false,"name":"Sram's Expertise","scryfallId":"3658c18f-e940-479d-a1aa-7ddb41337ef1"},{"index":16811,"token":false,"name":"Herald of Dromoka","scryfallId":"8987b2af-66d6-4271-a139-37e544cdec62"},{"index":16813,"token":false,"name":"Disciple of Law","scryfallId":"7a5c8701-a294-4474-9747-129f972cfb18"},{"index":16815,"token":false,"name":"Juxtapose","scryfallId":"fe9dc8dd-6212-465b-9633-f99cebf492f9"},{"index":16818,"token":false,"name":"Norwood Priestess","scryfallId":"7afd472f-1ede-4e78-b44c-3298ee4c8694"},{"index":16819,"token":false,"name":"Blood Artist","scryfallId":"2e1fb442-68ff-4249-8e44-87edf6fae211"},{"index":16820,"token":false,"name":"Combat Professor","scryfallId":"3f669ac4-98ed-4e23-91a9-281f8277ab04"},{"index":16822,"token":false,"name":"Blot Out the Sky","scryfallId":"0141312f-4b68-4c56-b1dc-5b7e6afbb96c"},{"index":16829,"token":false,"name":"Dimir Informant","scryfallId":"0230afeb-5ce8-436e-9afc-73cdd7baf424"},{"index":16831,"token":false,"name":"Nimbus of the Isles","scryfallId":"fbb41d25-b65b-4570-8523-ffb11779708f"},{"index":16832,"token":false,"name":"Goblin Shrine","scryfallId":"12711fa3-455d-498a-a1e9-881c62e9bb4f"},{"index":16833,"token":false,"name":"Rhys the Exiled","scryfallId":"f26da029-9c95-4e9b-9a1b-62048c16acaf"},{"index":16834,"token":false,"name":"Rousing Refrain","scryfallId":"dc2a5627-8726-45d6-bb1b-a6172096a28a"},{"index":16836,"token":false,"name":"Bounty Agent","scryfallId":"1542ad81-169e-4ac8-bd85-038494489594"},{"index":16839,"token":false,"name":"Fall of the Thran","scryfallId":"cf18f4fb-77d1-4f39-a961-50a318cd74e8"},{"index":16840,"token":false,"name":"Elvish Fury","scryfallId":"e5a24943-0121-4c64-9624-2e4cff37e6ca"},{"index":16844,"token":false,"name":"Steeling Stance","scryfallId":"4f89bd01-310e-4ec2-8d42-052c66ff8d0f"},{"index":16849,"token":false,"name":"New Blood","scryfallId":"f6b44503-7978-4c9e-a8a1-fd38c76d3545"},{"index":16850,"token":false,"name":"Hematite Talisman","scryfallId":"83585337-56a9-44d2-9ed1-8a959bcfb010"},{"index":16851,"token":false,"name":"Smokebraider","scryfallId":"d026cc47-9045-4f5b-b940-a6ea794d6fb9"},{"index":16852,"token":false,"name":"Acidic Sliver","scryfallId":"f2e23d03-9ee4-44c1-88d3-7708ef5b79c9"},{"index":16854,"token":false,"name":"Tanglesap","scryfallId":"a3c4e15b-7460-4d61-a209-6de27e4df6bb"},{"index":16855,"token":false,"name":"Night's Whisper","scryfallId":"e4638720-a55d-4c3b-b57d-2d028db5894d"},{"index":16856,"token":false,"name":"Liege of the Hollows","scryfallId":"dff4512b-8244-4e38-bffb-0062a97d9531"},{"index":16863,"token":false,"name":"Species Gorger","scryfallId":"e0087a98-55cf-4c8b-a180-fb0d9c336eb2"},{"index":16864,"token":false,"name":"Tidal Bore","scryfallId":"f68fd547-59fb-41e6-be55-1ec17fe2840b"},{"index":16865,"token":false,"name":"Mwonvuli Ooze","scryfallId":"aa9c6f65-93a1-4913-87e7-a17ebfcc7780"},{"index":16868,"token":false,"name":"Throne of the God-Pharaoh","scryfallId":"8c47b08c-7182-4315-8ad1-8ecad048a0df"},{"index":16870,"token":false,"name":"Ben-Ben, Akki Hermit","scryfallId":"d7c015a6-4d7d-421b-84fa-30bf070cff83"},{"index":16872,"token":false,"name":"Riptide Turtle","scryfallId":"cc4ba296-950c-4e39-ab5e-06be07e4a190"},{"index":16873,"token":false,"name":"Vampire's Zeal","scryfallId":"88c507f6-c178-40be-bca7-3bd5adb1c5b1"},{"index":16875,"token":false,"name":"Shinka, the Bloodsoaked Keep","scryfallId":"d2d5f30e-cc3a-46c1-82a9-2cd73705b2f5"},{"index":16876,"token":false,"name":"Kami of Lunacy","scryfallId":"4baef070-d265-4c6d-9b4b-3cafbd3b34c3"},{"index":16878,"token":false,"name":"Forked Lightning","scryfallId":"85883197-fd55-4e82-862f-87be4f789493"},{"index":16879,"token":false,"name":"Cephalid Vandal","scryfallId":"2500976f-a329-4a51-bcc1-cafe39bc3ccf"},{"index":16882,"token":false,"name":"Temple Garden","scryfallId":"b51c5f18-7093-445f-bb63-33fede285d35"},{"index":16883,"token":false,"name":"Thrull Wizard","scryfallId":"c4e732fb-cbef-4fd8-b704-e4d513a6cf2d"},{"index":16884,"token":false,"name":"General's Enforcer","scryfallId":"f6a45d0e-582a-4ec1-b83b-71b6a0ff6249"},{"index":16893,"token":false,"name":"Savai Crystal","scryfallId":"6954a5c1-89b1-4edd-814e-8f88fd49cda3"},{"index":16894,"token":false,"name":"Gird for Battle","scryfallId":"77238879-6dc7-46ff-8354-89e60c2a04e9"},{"index":16898,"token":false,"name":"Mystic Confluence","scryfallId":"fda21404-b683-4aed-b606-cb4241e42c9b"},{"index":16901,"token":false,"name":"Pyromania","scryfallId":"6a5af4e9-a2b6-43c7-8ff4-e761fbf693a7"},{"index":16903,"token":false,"name":"Shambling Strider","scryfallId":"96ae491d-deb9-4342-be39-2146c808584a"},{"index":16904,"token":false,"name":"Hush","scryfallId":"35f01c95-ce9e-4b45-9d15-a5d37100a5d8"},{"index":16905,"token":false,"name":"Beguiler of Wills","scryfallId":"e21ae024-d565-48a1-8004-5aa320a5d24d"},{"index":16919,"token":false,"name":"Cryptolith Fragment // Aurora of Emrakul","scryfallId":"078b2103-15ce-456d-b092-352fa7222935"},{"index":16920,"token":false,"name":"Illusory Ambusher","scryfallId":"6e3934ec-22fb-457d-9ce1-55f9e961ac14"},{"index":16921,"token":false,"name":"Aegar, the Freezing Flame","scryfallId":"edac3fd7-8124-4614-ae50-651608d45adb"},{"index":16924,"token":false,"name":"Norwood Archers","scryfallId":"c545fa63-d0dd-422b-8d3b-88b444f13fce"},{"index":16925,"token":false,"name":"Sun's Bounty","scryfallId":"bde59b0e-c75e-455b-b375-e0dac430a6d1"},{"index":16926,"token":false,"name":"Fledgling Imp","scryfallId":"d11770ee-dcf0-4dd4-ab43-b98f1133cec7"},{"index":16927,"token":false,"name":"Ember Beast","scryfallId":"b5d53c2b-32fe-4b92-bff1-e7416c0acd7c"},{"index":16928,"token":false,"name":"Sylvan Tutor","scryfallId":"9dcad208-cbea-458f-af8d-6f5e9ec32df7"},{"index":16929,"token":false,"name":"Dying Wail","scryfallId":"2a25a472-495e-4062-b66f-c37f148b494f"},{"index":16930,"token":false,"name":"Trash for Treasure","scryfallId":"75993427-fb8d-41cc-9016-323e804a5eb7"},{"index":16933,"token":false,"name":"Onyx Talisman","scryfallId":"a89b2368-1180-4821-bcb8-8161c18e5538"},{"index":16937,"token":false,"name":"Fists of the Anvil","scryfallId":"eb94bc02-b348-43c2-9e78-e2e3fd541d6a"},{"index":16939,"token":false,"name":"Tempt with Vengeance","scryfallId":"48ad7c26-edb5-4354-9872-87c667183be7"},{"index":16940,"token":false,"name":"Dripping-Tongue Zubera","scryfallId":"e752b762-38b7-463c-aa09-37fecfe71a53"},{"index":16941,"token":false,"name":"Natural State","scryfallId":"fdd4bdd5-1673-4f22-b593-41df8ce95a97"},{"index":16942,"token":false,"name":"Songstitcher","scryfallId":"e5488f15-ea0e-447b-8d06-d33565609213"},{"index":16943,"token":false,"name":"Dakmor Ghoul","scryfallId":"5caeb415-0e90-4f5b-ada4-a46241cf5dda"},{"index":16945,"token":false,"name":"Boros Keyrune","scryfallId":"e72ae9bc-d0a7-4adb-866d-94b8453a2837"},{"index":16947,"token":false,"name":"Firemind Vessel","scryfallId":"ec0ebb6b-d35a-47db-8071-7fef2a46c17b"},{"index":16949,"token":false,"name":"Blur of Blades","scryfallId":"b53f5b9b-d24b-4e9a-bc90-7ed198cd1132"},{"index":16955,"token":false,"name":"Servant of the Scale","scryfallId":"ca887c41-a8ee-4751-a902-87149c29a9df"},{"index":16958,"token":false,"name":"Tinder Farm","scryfallId":"989b5901-aeb0-4a48-8c53-3b0ec0e0deba"},{"index":16960,"token":false,"name":"District Guide","scryfallId":"c150deec-3287-40ef-9b9c-c22bf5d70b02"},{"index":16961,"token":false,"name":"Sisters of the Flame","scryfallId":"e1a99d52-6c20-4962-a4bb-1d2c21887bf7"},{"index":16964,"token":false,"name":"Find // Finality","scryfallId":"27446bd7-74d6-4831-8bb9-1c71b19aecf7"},{"index":16965,"token":false,"name":"Ghitu Lavarunner","scryfallId":"040ba7c4-c890-45b3-98cd-aa4ab7970e0a"},{"index":16971,"token":false,"name":"Bloodcrazed Neonate","scryfallId":"c42ac57c-b432-46cf-b108-32c3ec5f9de3"},{"index":16972,"token":false,"name":"Forbidding Spirit","scryfallId":"c17056e7-95c6-4bed-a747-3b40dcda275a"},{"index":16974,"token":false,"name":"Commander's Plate","scryfallId":"f520601f-c092-4f83-9c21-66e999a01c16"},{"index":16976,"token":false,"name":"Training Grounds","scryfallId":"e2cf16f8-6e69-46b3-8453-1d1a2a5670e2"},{"index":16978,"token":false,"name":"Fire Sprites","scryfallId":"d26fa79a-ede8-4c80-98d5-f49696f8104d"},{"index":16979,"token":false,"name":"Ethereal Champion","scryfallId":"7c1733e2-bee2-4b85-b165-d4329402578b"},{"index":16981,"token":false,"name":"Fortunate Few","scryfallId":"15b601b1-3071-4cab-b5a8-c62c7b1a318a"},{"index":16983,"token":false,"name":"Kunoros, Hound of Athreos","scryfallId":"9057b31b-daf3-4690-9a42-39ed2ded5acb"},{"index":16987,"token":false,"name":"Umara Mystic","scryfallId":"fb979cfc-3e5b-42c9-b78d-584c274ed912"},{"index":16988,"token":false,"name":"Skyshroud Claim","scryfallId":"cf3e09ff-c917-4c0c-8ddb-e152b4b0b82c"},{"index":16990,"token":false,"name":"Cradle Guard","scryfallId":"8b659c1c-cc0b-40f0-87b4-aeddb44dfac5"},{"index":16993,"token":false,"name":"Latchkey Faerie","scryfallId":"9fd63974-2a37-49bc-9eaf-a128c5ee3109"},{"index":16994,"token":false,"name":"Floodbringer","scryfallId":"0058be07-a8a1-448e-8c3d-61718cb384ec"},{"index":16995,"token":false,"name":"Hero of Bretagard","scryfallId":"4458c16c-b71d-481d-863b-f2e3b1320178"},{"index":16996,"token":false,"name":"Kuon, Ogre Ascendant // Kuon's Essence","scryfallId":"41004bdf-8e09-4b2c-9e9c-26c25eac9854"},{"index":16997,"token":false,"name":"Clan Defiance","scryfallId":"efa05298-9c94-4179-b75a-49ee2ca92920"},{"index":16999,"token":false,"name":"Retether","scryfallId":"0faa005e-c753-4484-bf64-349350d59094"},{"index":17000,"token":false,"name":"Disorder","scryfallId":"b6d11422-60a9-4386-8e7f-dd7dcdac58d8"},{"index":17002,"token":false,"name":"Purify the Grave","scryfallId":"dc396f54-8f54-4456-b473-a9bb38e88f62"},{"index":17004,"token":false,"name":"Arcanum Wings","scryfallId":"47e6e715-abd8-4ff9-a8aa-8f4b929b0283"},{"index":17005,"token":false,"name":"Hellkite Charger","scryfallId":"b26a7453-3c5d-4933-8fea-7696ac329f71"},{"index":17006,"token":false,"name":"Scorchwalker","scryfallId":"14ac6bde-1fef-45f4-b505-80a66b03140a"},{"index":17008,"token":false,"name":"Thaumatic Compass // Spires of Orazca","scryfallId":"392af78e-34d5-4b1b-8b29-0e702271e4d7"},{"index":17009,"token":false,"name":"Niambi, Faithful Healer","scryfallId":"c638677c-2b92-4d0c-b61c-598b5a843844"},{"index":17011,"token":false,"name":"Damping Engine","scryfallId":"87841977-75ff-49c3-b832-3f0cf48b50b2"},{"index":17013,"token":false,"name":"Knight of the Holy Nimbus","scryfallId":"8fdeb716-4632-4895-b771-0ebd59c868d5"},{"index":17017,"token":false,"name":"Oloro, Ageless Ascetic","scryfallId":"abf8df47-405c-42d8-be9e-0f0d0a49589b"},{"index":17021,"token":false,"name":"Render Silent","scryfallId":"4514a13f-5eee-49a8-876c-6b4befff4592"},{"index":17023,"token":false,"name":"Garruk's Companion","scryfallId":"b8d8806c-43c5-4c6c-9420-6210a17ec2b0"},{"index":17024,"token":false,"name":"Maximize Velocity","scryfallId":"fed08b50-9601-4571-83bd-58d5ae11eb04"},{"index":17025,"token":false,"name":"Spell Crumple","scryfallId":"2247df4a-c5d8-4b34-b3a6-3c958eb65f94"},{"index":17027,"token":false,"name":"Earthlore","scryfallId":"319d252e-7c43-47d6-8873-f69b0e063256"},{"index":17028,"token":false,"name":"Glowstone Recluse","scryfallId":"06a9698d-400c-4c31-82cd-28d0897fe28c"},{"index":17030,"token":false,"name":"Wallop","scryfallId":"45ce5126-e7b1-41ab-9e56-1e12927c4d27"},{"index":17031,"token":false,"name":"Arbor Armament","scryfallId":"71c10923-a5b3-4b50-ae51-59982e05963a"},{"index":17032,"token":false,"name":"Ruthless Instincts","scryfallId":"d2c8bfde-c4c5-40de-83de-ff236999d79b"},{"index":17033,"token":false,"name":"Grove Rumbler","scryfallId":"012b8eff-cdf3-423e-ae17-72a909e7ebd3"},{"index":17037,"token":false,"name":"Ajani, Valiant Protector","scryfallId":"791fdd9a-0ab6-4db9-84f9-859d2d862518"},{"index":17038,"token":false,"name":"Gorger Wurm","scryfallId":"00e5a9be-bfb2-466b-b0fe-3b24694e9f84"},{"index":17039,"token":false,"name":"Bloodrage Vampire","scryfallId":"692013da-b090-49d1-9c7a-ff5863d6ffd5"},{"index":17040,"token":false,"name":"Threads of Disloyalty","scryfallId":"0c4a061e-45ac-47b5-a955-5744199589b1"},{"index":17041,"token":false,"name":"Candelabra of Tawnos","scryfallId":"5e8416b8-aae1-4599-9e22-650dd86aefcb"},{"index":17043,"token":false,"name":"Ferocious Charge","scryfallId":"3749181f-7b4e-4b9d-aaf3-94f707c306aa"},{"index":17044,"token":false,"name":"Conspiracy Theorist","scryfallId":"9c70711e-11e4-42e2-baeb-099327962573"},{"index":17045,"token":false,"name":"Pinion Feast","scryfallId":"45d6df03-c3c3-42c3-85a4-6fccb0741592"},{"index":17046,"token":false,"name":"Edifice of Authority","scryfallId":"66e6fa29-087f-4da6-9114-30feec708560"},{"index":17049,"token":false,"name":"Impaler Shrike","scryfallId":"91e1f8b5-4792-457d-b3de-1d4874ddf72e"},{"index":17050,"token":false,"name":"Refocus","scryfallId":"35c78973-f2ae-4c76-802f-793d1022fcbd"},{"index":17053,"token":false,"name":"Throatseeker","scryfallId":"b07b3736-25e7-46f2-bea5-543ec13995b1"},{"index":17054,"token":false,"name":"Graceful Reprieve","scryfallId":"38748fbe-0d3e-4697-b9c4-d93a4ac59f9a"},{"index":17055,"token":false,"name":"Portent","scryfallId":"e040be83-3fb5-4da5-ba7a-4923b8854b74"},{"index":17056,"token":false,"name":"Gustcloak Sentinel","scryfallId":"57693fce-6896-4cb5-a5ad-4d0d687335dd"},{"index":17058,"token":false,"name":"Cavalier of Thorns","scryfallId":"7b1600ff-6ef8-4c4f-b857-7634e2967cce"},{"index":17067,"token":false,"name":"Bear Umbra","scryfallId":"212a953b-3205-41bf-a5b2-5b852e889c5a"},{"index":17068,"token":false,"name":"Bygone Bishop","scryfallId":"7c45198f-fb2b-4c83-abdc-8b1a0071cfed"},{"index":17070,"token":false,"name":"Kor Haven","scryfallId":"3d5529ca-5c20-4dfd-8595-96d6dfa6debe"},{"index":17071,"token":false,"name":"Turntimber Ascetic","scryfallId":"b33b6922-2584-43e1-98d4-e722e7c9393c"},{"index":17077,"token":false,"name":"Tremble","scryfallId":"7e1dc36f-3fdd-42cf-9d3a-695f4bf60c68"},{"index":17079,"token":false,"name":"Skirk Shaman","scryfallId":"b400819f-7009-407c-ae0b-7cf6e4a82a07"},{"index":17082,"token":false,"name":"Goblin Bushwhacker","scryfallId":"4085a5bf-a71b-4c73-9b39-0dcc328fe11b"},{"index":17083,"token":false,"name":"Dauthi Jackal","scryfallId":"37b3667e-c7e5-4304-bc73-5b3ec7ac224a"},{"index":17084,"token":false,"name":"Scurry Oak","scryfallId":"0fb48c2e-ee0f-4fae-9c22-247870c10d5b"},{"index":17085,"token":false,"name":"Eight-and-a-Half-Tails","scryfallId":"f10a72dc-10ca-4925-b1ea-5377f7867b57"},{"index":17086,"token":false,"name":"Conclave Cavalier","scryfallId":"b658a309-d14c-4e20-8c76-e7b3c5156bf2"},{"index":17088,"token":false,"name":"Blasting Station","scryfallId":"f28263e6-ee21-415e-b633-377af6f40d5b"},{"index":17090,"token":false,"name":"Squirrel Mob","scryfallId":"ff276249-e7ca-4264-9039-d32b38cc4a7e"},{"index":17093,"token":false,"name":"Wayward Angel","scryfallId":"1fb726e8-162d-4143-9778-32476c0e1ab1"},{"index":17095,"token":false,"name":"Kozilek's Return","scryfallId":"55ae93d4-c72d-47f6-9e15-fc7edf88a6c0"},{"index":17097,"token":false,"name":"Sabertooth Outrider","scryfallId":"64ddda91-3ccb-4c87-82e6-d4e60f4afc24"},{"index":17100,"token":true,"name":"Lightning","scryfallId":"a0fd47fd-c615-466e-989f-c6a4fa1cda17"},{"index":17101,"token":false,"name":"Szadek, Lord of Secrets","scryfallId":"b4ac4fbb-cd0b-4baf-b9bf-7c625d420e9c"},{"index":17106,"token":false,"name":"Nissa, Who Shakes the World","scryfallId":"41e108a5-4e2f-42cf-9ea1-87bf3c0a2b7f"},{"index":17107,"token":false,"name":"Search Warrant","scryfallId":"d55f625a-6e9e-40ba-ae46-cf6bafc0a41b"},{"index":17111,"token":false,"name":"Losheel, Clockwork Scholar","scryfallId":"db1d67fe-bffe-45ad-af6a-cb131ddb1a12"},{"index":17113,"token":false,"name":"Wingmate Roc","scryfallId":"25f0f6a2-b392-45e6-97c4-4f00016144d3"},{"index":17114,"token":false,"name":"Rift Elemental","scryfallId":"39dd1bc9-734b-41c6-941f-f9ed5eaa2337"},{"index":17117,"token":false,"name":"Finale of Revelation","scryfallId":"ffee435f-77f7-4506-9569-f316a564827e"},{"index":17118,"token":false,"name":"Apex Altisaur","scryfallId":"5f8b022e-3e7a-40e6-99a0-53e5adbdafc5"},{"index":17119,"token":false,"name":"Aggressive Instinct","scryfallId":"5168caa9-2b2e-4ac9-896f-f937c3987d52"},{"index":17122,"token":false,"name":"Bloodmark Mentor","scryfallId":"ddbaf909-63a4-46a0-97f6-7f1834da3e16"},{"index":17129,"token":false,"name":"Poison the Cup","scryfallId":"7fb94456-5266-47db-b514-a0e17e34b771"},{"index":17144,"token":false,"name":"Stealth Mission","scryfallId":"7ddfd4f5-7fe1-4a22-9a85-bd9b75b16380"},{"index":17152,"token":false,"name":"Unmake the Graves","scryfallId":"d6fd00bb-b247-45b7-9cb2-0d65b92c0360"},{"index":17153,"token":false,"name":"Dakmor Sorceress","scryfallId":"985ef9ad-b842-40b7-8d56-98143ecef0dc"},{"index":17156,"token":false,"name":"Streambed Aquitects","scryfallId":"fdb6b1ae-db92-447f-943a-8d33de940d44"},{"index":17159,"token":false,"name":"Goblin Charbelcher","scryfallId":"b6c37fc1-4842-4bc5-93ed-83fff9e420f2"},{"index":17161,"token":false,"name":"Fyndhorn Elves","scryfallId":"450744cf-7eba-491b-97b0-ca80c6368bbb"},{"index":17166,"token":false,"name":"Astral Drift","scryfallId":"07a2c7fa-7aea-4da4-b7d5-9c24f5024c74"},{"index":17167,"token":false,"name":"Fiend of the Shadows","scryfallId":"38167118-f5b3-4e07-8060-b170b49cff9e"},{"index":17170,"token":false,"name":"Aeromunculus","scryfallId":"671c94c1-df52-4985-ad78-3e1c9c78df18"},{"index":17171,"token":false,"name":"Patron of the Nezumi","scryfallId":"622e5d64-11ec-4eb5-8160-b2fb8a333812"},{"index":17172,"token":false,"name":"Canal Courier","scryfallId":"a3af3351-9457-443c-b31f-a57a2fc9be46"},{"index":17173,"token":false,"name":"Mossfire Valley","scryfallId":"6b6c08ce-d01d-4ae6-81d3-149679e27e6a"},{"index":17178,"token":false,"name":"Broken Fall","scryfallId":"d43f5349-a3f8-492d-a835-24a9f948741c"},{"index":17179,"token":false,"name":"Viashino Sandsprinter","scryfallId":"f7d1def0-1450-44ec-b7c4-0fa50fe12c15"},{"index":17181,"token":false,"name":"Nurturing Peatland","scryfallId":"2744ac83-a79f-4042-8720-688b5adda382"},{"index":17190,"token":false,"name":"Dementia Bat","scryfallId":"72ae22c3-2dea-463e-894a-188657849909"},{"index":17202,"token":false,"name":"Tormented Angel","scryfallId":"00d4d751-50df-4d8f-a6d9-4e76797c429a"},{"index":17205,"token":false,"name":"Pride Guardian","scryfallId":"c8d8d723-743c-45d6-b11b-7213f4872cf1"},{"index":17208,"token":false,"name":"Urza's Saga","scryfallId":"2138dfbb-a4e3-49db-b908-95d0b2b7e82f"},{"index":17210,"token":false,"name":"Enchanted Being","scryfallId":"94c2880d-b37a-43ea-9fee-cd5a8ed75a7e"},{"index":17217,"token":false,"name":"Invulnerability","scryfallId":"d66d1f00-e857-4bc3-a36d-a33669d281e9"},{"index":17223,"token":false,"name":"Hollow One","scryfallId":"4c61d8af-a638-4b8c-9241-b47d299dee69"},{"index":17225,"token":false,"name":"Candles of Leng","scryfallId":"ee874779-e654-48f0-8f2d-cc98ef150d75"},{"index":17231,"token":false,"name":"Legacy Weapon","scryfallId":"ae2ef7bf-6e5b-40a0-8b25-478323b64bdc"},{"index":17233,"token":false,"name":"Cumber Stone","scryfallId":"7963ff52-1897-4f62-a91d-b0eaf155fce9"},{"index":17235,"token":false,"name":"Ethersworn Shieldmage","scryfallId":"0ce33f36-e29e-4cac-a237-a7b932d50bbb"},{"index":17237,"token":true,"name":"Pentavite Token (Colorless, 1/1)","scryfallId":"0a9a25fd-1a4c-4d63-bbfa-296ef53feb8b"},{"index":17239,"token":false,"name":"Sarulf, Realm Eater","scryfallId":"a6d55b53-ccd2-496a-a969-23fcde8f2210"},{"index":17242,"token":false,"name":"Vedalken Plotter","scryfallId":"85bba39e-73bd-48e5-97ce-4b4661bab71b"},{"index":17243,"token":false,"name":"Ring of Kalonia","scryfallId":"2082e04f-f972-424e-a724-7a5975215538"},{"index":17244,"token":false,"name":"Barrow Ghoul","scryfallId":"f7055007-83dd-40fe-b2a1-4b3132f636db"},{"index":17245,"token":false,"name":"Victual Sliver","scryfallId":"90b3df6c-bddd-4680-b8e2-0f9698302f5e"},{"index":17246,"token":false,"name":"Mardu Hordechief","scryfallId":"23426221-30a8-4be2-9c70-f0eb022edad7"},{"index":17249,"token":false,"name":"Trapfinder's Trick","scryfallId":"0c9dfda7-c034-478e-a52a-e4a272c7d160"},{"index":17254,"token":false,"name":"Pathbreaker Wurm","scryfallId":"fe65eded-37ef-4cf0-b55c-390d34aab7b8"},{"index":17255,"token":false,"name":"Priest of the Blood Rite","scryfallId":"1a0df50f-59b8-46b6-8bac-6e3f93b9c979"},{"index":17258,"token":false,"name":"Mind Bomb","scryfallId":"0ee810a5-f0f9-4b73-8194-3d1344784050"},{"index":17259,"token":false,"name":"Ashnod's Cylix","scryfallId":"d84e6fcf-4745-4dfb-9103-17beec4e45b6"},{"index":17262,"token":false,"name":"Knight of Obligation","scryfallId":"0c2a1100-a2e6-4ef5-a8e3-2aca552d6b66"},{"index":17263,"token":false,"name":"Armored Transport","scryfallId":"f8cf8f6c-217e-4d51-aa63-859c2d38d438"},{"index":17264,"token":false,"name":"Manor Gargoyle","scryfallId":"6bb40965-9096-4a19-b71d-4da2a5b36baa"},{"index":17269,"token":false,"name":"Basilica Guards","scryfallId":"2be39fed-4b39-4027-9c80-f2186f7dd941"},{"index":17271,"token":false,"name":"Quicksilver Geyser","scryfallId":"fb209cf5-ac7b-4521-b488-ef72451e3a25"},{"index":17273,"token":false,"name":"Blazing Blade Askari","scryfallId":"cabf35d5-de8a-4d9d-be59-7ad7039873c6"},{"index":17274,"token":false,"name":"Skinshifter","scryfallId":"d56c82ad-5eb1-4653-8f02-e9bb1f6f3154"},{"index":17275,"token":false,"name":"Urborg Panther","scryfallId":"268263bb-6e94-44ce-b84b-53858d4721a7"},{"index":17276,"token":false,"name":"Oath of Gideon","scryfallId":"97976ade-c6ec-4068-be6b-953255b86a79"},{"index":17279,"token":false,"name":"Merfolk of the Depths","scryfallId":"bddb2e15-a53e-4647-a627-6c7032429fca"},{"index":17280,"token":false,"name":"Skullknocker Ogre","scryfallId":"dfa89e28-c0a9-4b76-b0d5-8dcaa75bfd59"},{"index":17281,"token":false,"name":"Duplicity","scryfallId":"d529cb33-292d-40e3-8cfe-db5eeb0d711e"},{"index":17282,"token":false,"name":"Zodiac Horse","scryfallId":"fb24cb19-3409-45f7-b0e0-7c652064d2dd"},{"index":17284,"token":false,"name":"Piston-Fist Cyclops","scryfallId":"2ec7523a-a9c4-4b76-8f9e-b591a88e2e37"},{"index":17293,"token":false,"name":"Bloodfray Giant","scryfallId":"a8c468cd-1255-4257-9a69-c6b40a27c427"},{"index":17295,"token":true,"name":"Voja // Saproling Token (G, 1/1)","scryfallId":"2879010f-b752-4808-8531-d24e612de0d9"},{"index":17296,"token":false,"name":"Warrior's Stand","scryfallId":"53bffc2e-67b6-4eb0-9742-e2a5918cc8d8"},{"index":17300,"token":false,"name":"Breaking Wave","scryfallId":"1b39cd77-97aa-4099-8405-366f82079758"},{"index":17301,"token":false,"name":"Necroplasm","scryfallId":"372424cf-85b3-4a78-bcf2-0543b0b88c0b"},{"index":17302,"token":false,"name":"Bottled Cloister","scryfallId":"5bf42acc-d2d3-4165-b257-6885df2d1ba4"},{"index":17304,"token":false,"name":"Crop Rotation","scryfallId":"187abedf-c2eb-453b-bea0-a10afa399e03"},{"index":17306,"token":false,"name":"Esix, Fractal Bloom","scryfallId":"9c381bc2-d26e-4d7e-9a0b-a8f7d2d802be"},{"index":17310,"token":false,"name":"Increasing Devotion","scryfallId":"87b5de81-65a6-4a74-8a71-767b92e89e91"},{"index":17311,"token":false,"name":"Sawtooth Thresher","scryfallId":"3c36de4a-807d-471d-ba59-0462d7bb028a"},{"index":17312,"token":false,"name":"Ephemeron","scryfallId":"867c9416-2e4c-45d4-9a54-216cf815eee0"},{"index":17323,"token":false,"name":"Bloodcrazed Paladin","scryfallId":"46ad3a65-3598-4656-9dc2-249c302013c6"},{"index":17324,"token":false,"name":"Prowling Serpopard","scryfallId":"06c1b234-d12f-408b-985d-db63f264f881"},{"index":17326,"token":false,"name":"Great Sable Stag","scryfallId":"451c8a79-1e8a-437d-836f-31155914c551"},{"index":17327,"token":false,"name":"Spirit Summoning","scryfallId":"74be6236-4095-419c-9927-fbd874df21f8"},{"index":17329,"token":false,"name":"Deadeye Rig-Hauler","scryfallId":"db310d8f-0db7-44c9-9f2d-9a0773b565b0"},{"index":17330,"token":false,"name":"Mortal Wound","scryfallId":"808830ff-496a-41dc-8b64-334ddaca9435"},{"index":17331,"token":false,"name":"Double Vision","scryfallId":"d4955455-c708-4f96-ba21-0a6de0e74336"},{"index":17333,"token":false,"name":"Sanctimony","scryfallId":"cfc6b744-92c7-4839-9b27-833bedb92bba"},{"index":17334,"token":false,"name":"Return to the Earth","scryfallId":"95a53144-2ef3-47d9-a176-73d620202df6"},{"index":17335,"token":false,"name":"Healer's Hawk","scryfallId":"3313bd5c-b657-47a3-822a-dd0d9165492a"},{"index":17336,"token":false,"name":"Feral Shadow","scryfallId":"90cc7336-7dd8-49c1-bb8e-2f8085cb8aa9"},{"index":17337,"token":false,"name":"Incendiary","scryfallId":"854f4775-29b1-4ed1-94d9-db5930a35157"},{"index":17338,"token":false,"name":"Bulwark Giant","scryfallId":"11510817-edb3-40d4-bd27-6161fedadd11"},{"index":17339,"token":false,"name":"Tangle Wire","scryfallId":"74d29b3d-f588-431d-bf4e-f7215683ab39"},{"index":17340,"token":false,"name":"Drifting Shade","scryfallId":"00dcb25e-764b-47d6-bec4-225aaace77b0"},{"index":17345,"token":false,"name":"Genju of the Fields","scryfallId":"e0cf9142-be8e-48d8-a1b4-9a7fb71718d0"},{"index":17354,"token":false,"name":"Inspiring Statuary","scryfallId":"40f38409-f087-4300-a139-22b226680a6d"},{"index":17356,"token":false,"name":"Titania's Chosen","scryfallId":"d9450340-2c29-4573-8da2-0d3cae9759c1"},{"index":17357,"token":false,"name":"Agrus Kos, Wojek Veteran","scryfallId":"e525be2e-26e6-4082-b713-ac74fcbd13d3"},{"index":17360,"token":false,"name":"Mossdog","scryfallId":"2bbe0201-3df3-4d0c-8aa4-8f35f12c322c"},{"index":17361,"token":false,"name":"Kindred Summons","scryfallId":"602dce20-f8eb-4817-b532-1c5b1192aec4"},{"index":17362,"token":false,"name":"Quicksmith Genius","scryfallId":"7fed8df9-600c-4502-83a3-883724f2f7c6"},{"index":17363,"token":false,"name":"Stream of Consciousness","scryfallId":"4faef057-8734-442b-a213-c309c219cdee"},{"index":17370,"token":false,"name":"Lairwatch Giant","scryfallId":"c64ba1c8-b93a-4169-9ba0-d3fc5bf57676"},{"index":17371,"token":false,"name":"Midnight Reaper","scryfallId":"5e122fe0-51c5-404d-a7b9-3d161a426c35"},{"index":17373,"token":false,"name":"Conclave Equenaut","scryfallId":"b49ae4dd-4a02-45bb-ae43-f62c52118003"},{"index":17378,"token":false,"name":"False Prophet","scryfallId":"f41a43ba-1867-4ce3-97fe-5ae67d3f36c3"},{"index":17382,"token":false,"name":"Dungeon Shade","scryfallId":"3e2f317a-578c-4f7d-a185-b22bf7c32624"},{"index":17385,"token":false,"name":"Doomwake Giant","scryfallId":"f6add387-928e-4f86-90a9-28c6090fae9e"},{"index":17386,"token":false,"name":"Infernal Harvest","scryfallId":"ccf85ac9-f5d8-4a36-aa6c-3a31427a0348"},{"index":17387,"token":true,"name":"Pirate Token (B, 2/2)","scryfallId":"2d7fc721-6b5b-4920-86fa-0fbfd90adaf5"},{"index":17390,"token":false,"name":"Yare","scryfallId":"9a14343d-c2cd-4a67-ae54-6b6a4677ca85"},{"index":17393,"token":false,"name":"Forge Devil","scryfallId":"bd7308e6-4303-4f01-928b-f154b376e1a5"},{"index":17394,"token":false,"name":"Sevinne's Reclamation","scryfallId":"7e68f4df-88ce-4e09-a03c-7edf40bff167"},{"index":17395,"token":false,"name":"Norwood Riders","scryfallId":"904ba8db-853e-4f51-acfe-83e472524380"},{"index":17396,"token":false,"name":"Clergy en-Vec","scryfallId":"fcb0e068-16d0-4e1c-acad-0a6d34148c5a"},{"index":17397,"token":false,"name":"Chandra, Torch of Defiance","scryfallId":"ff8086cd-b868-4f4e-823e-2635ad7ebc07"},{"index":17398,"token":false,"name":"Training Drone","scryfallId":"8b7e986f-5b28-46d2-8ec2-ee719b07dbfd"},{"index":17401,"token":false,"name":"Restore","scryfallId":"0c0ae36e-19c8-4e05-8c02-cc7fb5da5a39"},{"index":17407,"token":false,"name":"Grave Upheaval","scryfallId":"812c4b37-ec81-4ab6-b2f1-baca68116b1e"},{"index":17409,"token":false,"name":"Ravaging Blaze","scryfallId":"5d9404b2-f0ea-4a31-bc7b-6748574c57d3"},{"index":17412,"token":false,"name":"Mogg Toady","scryfallId":"ee8edaf6-d46e-4efb-8bc0-ec11e06eb499"},{"index":17413,"token":false,"name":"Old-Growth Dryads","scryfallId":"06458882-94c8-4d92-a21c-955e9d70f0d4"},{"index":17417,"token":false,"name":"Manta Ray","scryfallId":"80f74884-9b82-419d-9e97-c947a6b7d09f"},{"index":17418,"token":false,"name":"Dire Undercurrents","scryfallId":"8d6fb3b2-eef2-4699-ab5e-ff7d8de2a1de"},{"index":17419,"token":false,"name":"In Oketra's Name","scryfallId":"9eb26608-8843-4f02-8f2b-abc96a9038e8"},{"index":17422,"token":false,"name":"Dutiful Attendant","scryfallId":"f35fd9cd-795f-4a8b-b2e9-648f6273927e"},{"index":17424,"token":false,"name":"Charmed Stray","scryfallId":"357513b9-0505-4b67-9a29-36a705a175b1"},{"index":17429,"token":false,"name":"Extract from Darkness","scryfallId":"64e4da15-190d-44d9-962e-8102e8090a5f"},{"index":17430,"token":false,"name":"Hanweir Militia Captain // Westvale Cult Leader","scryfallId":"7e137566-5033-48e8-88ba-65e3821b3cec"},{"index":17432,"token":false,"name":"Soul Link","scryfallId":"425e0ca4-8592-4802-b7c4-6e3323edd78c"},{"index":17434,"token":false,"name":"Ice Cave","scryfallId":"fc2877c2-4426-4c07-92a2-8ba5107d5e7e"},{"index":17436,"token":false,"name":"Jeweled Amulet","scryfallId":"34f7bad2-d28f-42d2-9246-fe3545ef49a7"},{"index":17438,"token":false,"name":"Bloodbriar","scryfallId":"d9f1d82e-876f-48a6-8153-f02a44cf90a8"},{"index":17440,"token":false,"name":"Murktide Regent","scryfallId":"20c4aae1-7665-4df7-bd51-a1d95bf8a17d"},{"index":17441,"token":false,"name":"Aquamorph Entity","scryfallId":"9781ab73-5c79-41f3-b319-c9299b03353a"},{"index":17448,"token":false,"name":"Mystic Compass","scryfallId":"e80bfd76-52f9-4dea-9056-8570c9b290a4"},{"index":17450,"token":false,"name":"Mogg Alarm","scryfallId":"f246e128-0a43-478a-a232-51020fab76d5"},{"index":17451,"token":false,"name":"Nezumi Bone-Reader","scryfallId":"77dc102f-1d0c-4144-b741-eb0df3d7c11e"},{"index":17452,"token":false,"name":"Fatal Mutation","scryfallId":"57cf9f50-8858-44a6-8bd5-0ce1e281a584"},{"index":17456,"token":false,"name":"Archfiend of Spite","scryfallId":"1df2ca13-4062-4827-ae2f-c61cf88ba3b3"},{"index":17459,"token":false,"name":"Gilded Light","scryfallId":"8c9b8d21-28b9-43c6-8cb9-07c11a778867"},{"index":17460,"token":false,"name":"Clairvoyance","scryfallId":"46740353-e2ba-4d80-a97d-1368bc67bf30"},{"index":17461,"token":false,"name":"Skulking Ghost","scryfallId":"f8ca7e96-0545-4f36-85c0-944d5c0b760a"},{"index":17463,"token":false,"name":"Tormented Hero","scryfallId":"9bfa3e85-6d65-43cd-ab95-396b75aca575"},{"index":17464,"token":false,"name":"Carapace Forger","scryfallId":"e9948e4c-d583-4fde-a305-df926cf00199"},{"index":17465,"token":false,"name":"Balefire Dragon","scryfallId":"b0dce4ac-f472-4f3b-b01a-eff0902a578f"},{"index":17474,"token":false,"name":"Illicit Auction","scryfallId":"97d68c39-cfdd-4883-9058-d648d073ae36"},{"index":17477,"token":false,"name":"Goblin Mutant","scryfallId":"07a22271-e96e-4614-9b61-1e2398f976c3"},{"index":17481,"token":false,"name":"Fangren Hunter","scryfallId":"58020835-22bb-4e42-991a-c146a3148fff"},{"index":17484,"token":false,"name":"Bound by Moonsilver","scryfallId":"7bdf107d-eb67-421c-a7a9-b3e62e03f766"},{"index":17486,"token":false,"name":"Sinister Sabotage","scryfallId":"6cbef36d-7170-424f-8fb1-8e7e112b7f0b"},{"index":17490,"token":false,"name":"Voodoo Doll","scryfallId":"089e12c0-e60f-4b60-a2eb-b6c1d088ac50"},{"index":17495,"token":false,"name":"Gideon's Company","scryfallId":"a0a64d2e-8b89-4642-84c2-b01dfe11312e"},{"index":17497,"token":false,"name":"Anointed Chorister","scryfallId":"9c977c67-b0c0-40b0-b129-28de094aaf40"},{"index":17498,"token":false,"name":"Deathgaze Cockatrice","scryfallId":"9f17b58c-9738-4cdb-a408-e1595c384b92"},{"index":17499,"token":false,"name":"Seeker","scryfallId":"7052825f-d9fc-4820-b8c4-dbc204730b7c"},{"index":17500,"token":false,"name":"Somberwald Dryad","scryfallId":"307edca0-769d-4071-9654-3537341e96bd"},{"index":17501,"token":false,"name":"Rumbling Ruin","scryfallId":"71fe7057-de70-456d-8f33-f64652447bdd"},{"index":17504,"token":false,"name":"Otarian Juggernaut","scryfallId":"752420dc-d69a-4c9d-b563-f8928a4a0920"},{"index":17510,"token":false,"name":"Arcane Teachings","scryfallId":"c12cd686-e08f-4365-a6c4-4273140391f6"},{"index":17511,"token":false,"name":"Melira, Sylvok Outcast","scryfallId":"e83851a1-e4e8-49ec-af5c-4efe86fa51ad"},{"index":17512,"token":false,"name":"Marrow Chomper","scryfallId":"d31a32e7-e709-4524-8752-ad0ec8c77fde"},{"index":17515,"token":false,"name":"Maddening Cacophony","scryfallId":"738b29d9-18a9-423b-afe6-171751fa5c18"},{"index":17516,"token":false,"name":"Hate Weaver","scryfallId":"b5b3c413-96ca-42c5-b263-f2da195c1854"},{"index":17517,"token":false,"name":"Bloodthirsty Aerialist","scryfallId":"378b2e55-e383-408e-af57-072e47cea779"},{"index":17521,"token":false,"name":"Nylea, Keen-Eyed","scryfallId":"2a022e36-5074-4875-ac30-aaa09b7ef421"},{"index":17523,"token":false,"name":"Overgrowth","scryfallId":"bb9179f5-c3e0-4499-9cfb-6cb7e8329a59"},{"index":17524,"token":false,"name":"Razortooth Rats","scryfallId":"5ab55c86-3576-43fd-b555-ab0b3ad936c7"},{"index":17525,"token":false,"name":"Aqueous Form","scryfallId":"ba104245-0483-407f-971b-ad6d8efd9733"},{"index":17529,"token":false,"name":"Gerrard's Irregulars","scryfallId":"8a88f507-3d78-4f7f-a91f-8489ad9250f2"},{"index":17533,"token":false,"name":"Infernal Offering","scryfallId":"8af751fd-bfac-43cb-af3b-6116fd643703"},{"index":17534,"token":false,"name":"Utility Knife","scryfallId":"1e5c781d-cd89-4671-8fbe-fae82c33357b"},{"index":17537,"token":false,"name":"Devoted Druid","scryfallId":"820e2f07-f637-4144-b45a-0e1430dcf55e"},{"index":17539,"token":false,"name":"Lightmine Field","scryfallId":"5602b52a-5904-4780-9192-72990d07c975"},{"index":17540,"token":false,"name":"Mycosynth Wellspring","scryfallId":"1b162378-9792-41ca-af99-bce1428e24be"},{"index":17541,"token":false,"name":"Vampire Neonate","scryfallId":"c7649d57-3537-45a2-b57e-98e7d32025c9"},{"index":17542,"token":false,"name":"Hide // Seek","scryfallId":"ac347ec8-4537-4cdf-aeff-44da1f7be01b"},{"index":17548,"token":false,"name":"Earthshaker Giant","scryfallId":"dbcdbf7a-9294-47ad-9f93-c16b78c7463a"},{"index":17558,"token":false,"name":"Siren Stormtamer","scryfallId":"72f7375c-2d9b-4738-b539-00e1949980e7"},{"index":17561,"token":false,"name":"Tainted Sigil","scryfallId":"abcf3694-d6b0-459d-8c3a-1532237b487a"},{"index":17563,"token":false,"name":"Spikeshot Elder","scryfallId":"14c14e44-20ff-4128-b07d-4b751fc82d4e"},{"index":17566,"token":false,"name":"Stranglehold","scryfallId":"10a4d051-8e13-47c1-bfd6-17ab44670250"},{"index":17569,"token":false,"name":"Rebuff the Wicked","scryfallId":"fa47fcce-d4c4-40a2-8853-6d7569d50926"},{"index":17572,"token":false,"name":"Safehold Elite","scryfallId":"d049f233-7fcb-49cb-897b-a12d57692fe0"},{"index":17576,"token":false,"name":"Foil","scryfallId":"c0d3218a-7fd5-406c-a3ee-cd34fd3dda55"},{"index":17577,"token":false,"name":"Arrogant Bloodlord","scryfallId":"5ed08a7f-6682-46a4-89df-b9b418df3f1a"},{"index":17578,"token":false,"name":"Bred for the Hunt","scryfallId":"4258a536-2275-45e8-8833-e921ca15c5a7"},{"index":17581,"token":false,"name":"Cabal Torturer","scryfallId":"ebcf8dd7-f45c-4ac2-9507-fa175fe89887"},{"index":17584,"token":false,"name":"Heir of Falkenrath // Heir to the Night","scryfallId":"cf2ad186-4d85-4628-ae84-3c58c88d34cb"},{"index":17587,"token":false,"name":"Stonybrook Schoolmaster","scryfallId":"69fa2293-f398-4ad8-895e-c739ddea56d0"},{"index":17588,"token":false,"name":"Sidewinder Sliver","scryfallId":"5616e0c7-1f1d-4716-95e5-773a8e3ae5e3"},{"index":17592,"token":false,"name":"Wind Sail","scryfallId":"17ef39fd-96d0-4a02-97d5-580d121b92a3"},{"index":17595,"token":true,"name":"Cleric Token (B, 0/1)","scryfallId":"74791ac4-7297-4731-aff8-20130da8b4b7"},{"index":17596,"token":false,"name":"Chromatic Orrery","scryfallId":"06bea508-4039-4aee-b61c-8f68ec405ef7"},{"index":17600,"token":false,"name":"Omega Myr","scryfallId":"ddaa5c60-054f-4397-a110-21df58264caf"},{"index":17602,"token":false,"name":"Nantuko Calmer","scryfallId":"c76b1198-feff-437c-9d4c-94785144c98f"},{"index":17604,"token":false,"name":"Scars of the Veteran","scryfallId":"632870c3-7c0b-48ad-865d-95f8c4e887d0"},{"index":17606,"token":false,"name":"Chandra's Pyrohelix","scryfallId":"1c482f51-9222-4e9e-a9fd-bb14a0afe156"},{"index":17608,"token":false,"name":"Vampire Aristocrat","scryfallId":"7f9a6d22-2e87-410c-b42a-6b54d83a7d30"},{"index":17610,"token":false,"name":"Prized Griffin","scryfallId":"877bd423-83ff-4a28-b0d2-447a7821bb8c"},{"index":17612,"token":false,"name":"Fylgja","scryfallId":"3c6358a1-37f0-4b40-93d4-4f1652c38404"},{"index":17613,"token":false,"name":"Inkwell Leviathan","scryfallId":"cb380a5a-a3f9-42fb-ac5c-f54afa3c1079"},{"index":17614,"token":true,"name":"Sinuous Striker Token (B, 4/4)","scryfallId":"513f2ce9-0127-4479-b37a-a835fbada8f8"},{"index":17618,"token":false,"name":"Rising Waters","scryfallId":"ec9c84db-cf45-43e1-b38f-8bbf53cf088b"},{"index":17619,"token":false,"name":"Aven Skirmisher","scryfallId":"05f7a3b1-4d92-4d32-a823-2e774c6e7e73"},{"index":17620,"token":false,"name":"Chitterspitter","scryfallId":"2d7687d1-d168-4279-b21d-fcfc7573c7b5"},{"index":17621,"token":false,"name":"Gibbering Descent","scryfallId":"d4839a0b-47db-4464-9e9a-0e976d468106"},{"index":17628,"token":false,"name":"Dawnstrider","scryfallId":"2d193a35-8950-4a77-ace3-c4d4085727f4"},{"index":17630,"token":false,"name":"Searing Blaze","scryfallId":"301f13dd-39b8-4a93-9c05-3dc4fa1f1c75"},{"index":17631,"token":false,"name":"Hungry Spriggan","scryfallId":"8be81b15-eb12-452b-8fdd-bde64807f422"},{"index":17632,"token":false,"name":"Devastating Mastery","scryfallId":"99d68fbc-1200-4b84-8438-c6bbc3bc722e"},{"index":17635,"token":false,"name":"Azorius Herald","scryfallId":"813cea4e-1e87-4d2f-a580-16805ff53ff0"},{"index":17639,"token":false,"name":"Allosaurus Shepherd","scryfallId":"0ee4a931-5d61-49ba-affc-f022263938ca"},{"index":17641,"token":true,"name":"Snake Token (G, 1/1)","scryfallId":"169dfab7-ff75-47df-8a20-7b4a729feafe"},{"index":17646,"token":false,"name":"Blazing Torch","scryfallId":"1e9d1ff2-9ce3-4737-af1d-9fc82e4dffe6"},{"index":17648,"token":false,"name":"Draugr Necromancer","scryfallId":"0a918f05-23cf-4d3a-b21a-dc4539f7fb95"},{"index":17650,"token":false,"name":"Desecration Plague","scryfallId":"42dbc5e5-5d46-47f7-a700-b65781a13c7a"},{"index":17651,"token":false,"name":"Elspeth, Sun's Nemesis","scryfallId":"4cc79a65-67bd-44ef-a42e-4591a1b6d31a"},{"index":17652,"token":false,"name":"Mind Ravel","scryfallId":"1a9a0296-3690-45c7-98af-d546296ad9fe"},{"index":17654,"token":false,"name":"Bolt of Keranos","scryfallId":"4df70b14-5d67-4a92-aaba-72480c621d10"},{"index":17655,"token":false,"name":"Scuttling Death","scryfallId":"7f68a90c-1afb-43d3-aed2-4704f4599e75"},{"index":17657,"token":false,"name":"Yavimaya Sapherd","scryfallId":"ae7eb7e9-288e-447e-919d-a91a40717eb6"},{"index":17659,"token":false,"name":"Neutralize","scryfallId":"0430da3c-9460-4b62-ae28-2e7e6f4d06a4"},{"index":17660,"token":false,"name":"Thrashing Brontodon","scryfallId":"d3a45c57-9dc5-418b-99f3-b770a94eea47"},{"index":17661,"token":false,"name":"Custodi Squire","scryfallId":"a9151422-8df1-409c-a686-0cd89247eb43"},{"index":17670,"token":false,"name":"Razorclaw Bear","scryfallId":"08c0cdbe-ca74-4edc-96ea-6db8eefe99d8"},{"index":17676,"token":false,"name":"Pine Barrens","scryfallId":"b0f794f0-3588-4fe2-8792-64a58482ff8b"},{"index":17678,"token":false,"name":"Firefly","scryfallId":"a312f0cf-225a-4f3d-b9a7-c47dd03b25c3"},{"index":17684,"token":false,"name":"Centaur Healer","scryfallId":"8a0743cd-26e3-4de5-b98b-3e16b6aff2ac"},{"index":17686,"token":false,"name":"Heat Ray","scryfallId":"32d91705-de45-41a1-b7e8-f40d3dcf1520"},{"index":17689,"token":false,"name":"Wipe Away","scryfallId":"37eb43af-367c-4778-a7cc-7ee3b3103379"},{"index":17690,"token":false,"name":"Stensia Innkeeper","scryfallId":"ee40c471-70c8-4171-a214-ce932c4c7e2e"},{"index":17694,"token":false,"name":"Into the Core","scryfallId":"9cb91ecb-1962-4cd1-80c1-c9e2485822ae"},{"index":17695,"token":false,"name":"Spell Snip","scryfallId":"d6870203-ece9-4fe0-912b-2dcf685f3eb0"},{"index":17696,"token":false,"name":"Clamor Shaman","scryfallId":"b3f073d7-f60a-44c1-aec9-cf42bbdb3153"},{"index":17698,"token":false,"name":"Obsidian Charmaw","scryfallId":"ee6d08be-a6fc-44a5-932d-b6a8705534c0"},{"index":17700,"token":false,"name":"Azorius Keyrune","scryfallId":"d3e9e7be-598a-4353-8a7e-350837a7c0a0"},{"index":17705,"token":false,"name":"Wirewood Savage","scryfallId":"99982622-98bc-45ae-8642-41cd543f32a8"},{"index":17706,"token":false,"name":"Arasta of the Endless Web","scryfallId":"03b9304c-9993-4539-9165-48568eb81db1"},{"index":17710,"token":false,"name":"Guardian of the Gateless","scryfallId":"86940635-7001-4ecf-b4ee-25aa1e2d81fc"},{"index":17711,"token":false,"name":"Fossil Find","scryfallId":"2ff61d34-f38f-440b-a234-7bb7251eb5b8"},{"index":17715,"token":false,"name":"Sporemound","scryfallId":"2d256cd0-6fe9-4905-9886-fb1457292db5"},{"index":17716,"token":false,"name":"Savannah","scryfallId":"5ae71290-c133-406c-8b17-9ea22b437806"},{"index":17717,"token":false,"name":"Acridian","scryfallId":"05d5a38f-5a60-46da-af1c-440e4bf7fe9e"},{"index":17718,"token":false,"name":"Goblin Masons","scryfallId":"124070d9-c362-4053-a405-9438b1cfac02"},{"index":17719,"token":false,"name":"Undead Slayer","scryfallId":"3439568c-606e-4b95-b4fc-4d31e12ff30a"},{"index":17720,"token":false,"name":"Hate Mirage","scryfallId":"9e58b2ad-0c5e-468e-983a-45d412454a67"},{"index":17721,"token":false,"name":"Demanding Dragon","scryfallId":"2cdc6a4c-c2ac-4ef0-b742-00174df20450"},{"index":17723,"token":false,"name":"Sweet-Gum Recluse","scryfallId":"9c5ffa3d-ecff-457f-9216-f4e8d3202536"},{"index":17730,"token":false,"name":"Ghastly Demise","scryfallId":"c1cae244-923e-4bcb-b79b-e11693167e12"},{"index":17732,"token":false,"name":"Ondu War Cleric","scryfallId":"d54714d2-d6b2-41c1-a502-405f816ad51b"},{"index":17736,"token":false,"name":"Needlebug","scryfallId":"d54fbd8a-1e2a-450e-98f2-26bbc9e9ac79"},{"index":17740,"token":false,"name":"Wring Flesh","scryfallId":"d6b77692-08aa-40b6-b21b-c29a2dc87709"},{"index":17742,"token":false,"name":"Kashi-Tribe Warriors","scryfallId":"7cd4df4a-fbab-4598-ad8e-b24ed0bb4497"},{"index":17745,"token":false,"name":"Plumb the Forbidden","scryfallId":"5034227f-3b8a-45bf-917c-c2cbd98f2192"},{"index":17749,"token":false,"name":"Haunting Echoes","scryfallId":"720e9113-6e97-43af-9e61-71c7917c0870"},{"index":17751,"token":false,"name":"Heroism","scryfallId":"08ee87a0-a7eb-4472-9045-85d11e8a1501"},{"index":17752,"token":false,"name":"Azorius Charm","scryfallId":"9740ceaf-4ef9-48dd-ab7d-cd5eb3be8cec"},{"index":17756,"token":false,"name":"Vexing Devil","scryfallId":"dbbefd98-4b17-4cc2-9ef9-8807f594cb16"},{"index":17758,"token":false,"name":"Treacherous Pit-Dweller","scryfallId":"eec7dfd7-d7b2-44fa-b351-022a19fe81b8"},{"index":17761,"token":false,"name":"Oko, the Trickster","scryfallId":"83e61813-c4c8-4e80-8808-ac5107966ee3"},{"index":17763,"token":false,"name":"Ogre Siegebreaker","scryfallId":"0aba1c64-c552-4aeb-b669-da885c8c75b2"},{"index":17768,"token":false,"name":"Hero's Demise","scryfallId":"d22dd514-814f-4a62-926d-fef311896c02"},{"index":17769,"token":false,"name":"Hypothesizzle","scryfallId":"d5690329-feb8-49c0-8f59-ee13782e8d3b"},{"index":17770,"token":false,"name":"Mothdust Changeling","scryfallId":"95da9bc9-6ac5-432d-ac12-04088cc6c74d"},{"index":17773,"token":false,"name":"Mischievous Poltergeist","scryfallId":"d11803b8-d1df-454d-93ec-b1bb276843b6"},{"index":17776,"token":false,"name":"Soul Channeling","scryfallId":"55cd09ef-1655-4a62-b6c5-6eda33d2607a"},{"index":17778,"token":false,"name":"Shark Typhoon","scryfallId":"9e97f8b1-01e9-42c3-af0d-05e861de82e5"},{"index":17779,"token":false,"name":"Cabal Patriarch","scryfallId":"0d2f0da3-a13e-4a45-98dc-6227cf952a5e"},{"index":17780,"token":false,"name":"Dream Stalker","scryfallId":"a0e8fc8e-3b23-4275-b19b-43aa6a307619"},{"index":17781,"token":false,"name":"Sudden Spinnerets","scryfallId":"3730996a-96d2-4311-a4dc-0045a2f8ccc9"},{"index":17782,"token":false,"name":"Alchor's Tomb","scryfallId":"f4395b19-2118-4a09-8932-f9ce9bc54d6d"},{"index":17783,"token":false,"name":"Knight of Autumn","scryfallId":"3028075c-5fc5-4942-a984-1ffcf7a8933d"},{"index":17784,"token":false,"name":"Hunt for Specimens","scryfallId":"8ff0f47f-75cb-42b0-ba4d-78522cad9861"},{"index":17785,"token":true,"name":"Dinosaur Cat Token (R/W, 2/2)","scryfallId":"cb87f3e1-f4ba-459d-9bb9-6651fe073a0a"},{"index":17786,"token":false,"name":"Karplusan Minotaur","scryfallId":"963f45d7-ce84-47af-ae1c-727172a31f0f"},{"index":17791,"token":false,"name":"Unhallowed Pact","scryfallId":"b26d73e6-9138-43b2-8031-6e3b25fa33f9"},{"index":17793,"token":false,"name":"Severed Strands","scryfallId":"bce654d6-fcf1-40a8-8bdb-5c37e561f7dc"},{"index":17794,"token":false,"name":"Lavacore Elemental","scryfallId":"d6b2f4de-fc41-4e68-8655-577616b10c7e"},{"index":17795,"token":false,"name":"Soul Summons","scryfallId":"0fcc772e-da73-4a60-ab9b-8b558ac320ec"},{"index":17796,"token":false,"name":"Eternal Isolation","scryfallId":"021963bf-87fc-432f-b9a1-4f627885a7a9"},{"index":17797,"token":false,"name":"Booby Trap","scryfallId":"1af0c9a0-0dfa-4245-8b29-7bd37982b7d2"},{"index":17798,"token":false,"name":"Lantern Kami","scryfallId":"99625787-f184-48a5-a678-e30b7024c7bb"},{"index":17799,"token":false,"name":"Noxious Gearhulk","scryfallId":"60d1b650-6c5f-435c-826a-f025d7b796e5"},{"index":17805,"token":false,"name":"Energy Vortex","scryfallId":"87e060d7-42ed-49ab-bc5c-2f3210cbd0d1"},{"index":17807,"token":false,"name":"Goldmaw Champion","scryfallId":"44d4cd64-8560-48f5-b0bc-f75286c1c91c"},{"index":17810,"token":false,"name":"Disrupting Shoal","scryfallId":"15589745-4c0a-4edf-ad45-3b7fa45e70c5"},{"index":17815,"token":false,"name":"Veiled Shade","scryfallId":"35cb18ae-0229-40a1-8838-ffb678ab2ed9"},{"index":17816,"token":false,"name":"Imperial Lancer","scryfallId":"7ed3784a-2dc0-4626-aa6a-268c1e2ac83c"},{"index":17818,"token":false,"name":"Inkshield","scryfallId":"5e1c14a0-cd68-45fc-a127-422ca6113048"},{"index":17823,"token":false,"name":"Urborg Drake","scryfallId":"97d1327e-bf87-423f-8a04-8124e45b9ae0"},{"index":17824,"token":false,"name":"Unspeakable Symbol","scryfallId":"2cc4601b-5f34-4733-8c32-9779de4c502c"},{"index":17827,"token":false,"name":"Seething Pathblazer","scryfallId":"4971a447-29c8-47b6-863c-f13a69b4148b"},{"index":17831,"token":false,"name":"Stormscape Familiar","scryfallId":"4c831c42-77a0-4f4f-9628-ad630541cf66"},{"index":17837,"token":false,"name":"Kavu Primarch","scryfallId":"66f97473-b782-46e4-a295-b50354875eac"},{"index":17838,"token":false,"name":"Spawning Pit","scryfallId":"36a3345d-1190-45f4-8191-897b4dcec376"},{"index":17842,"token":false,"name":"Kobolds of Kher Keep","scryfallId":"a6797542-0781-43d6-aa8e-b55e5c1e08c0"},{"index":17850,"token":false,"name":"Ib Halfheart, Goblin Tactician","scryfallId":"8591364d-dd9c-49e7-9115-ef7f68bf98f1"},{"index":17851,"token":false,"name":"Oran-Rief Recluse","scryfallId":"37a69043-23f5-478e-bf9b-f170e326c0e0"},{"index":17853,"token":false,"name":"Dakmor Plague","scryfallId":"bb2b809a-5bb7-4d7d-8ba1-c99051b83231"},{"index":17855,"token":false,"name":"Skarrgan Skybreaker","scryfallId":"c9767e0b-1284-4c9e-9d0c-fb0d17c35044"},{"index":17859,"token":false,"name":"Orcish Farmer","scryfallId":"efa5beef-d609-4809-a813-621b0b4cff7f"},{"index":17861,"token":false,"name":"Kalitas, Traitor of Ghet","scryfallId":"ec646a3c-a0f4-43ea-9753-ec7ad395894b"},{"index":17867,"token":false,"name":"Oketra the True","scryfallId":"b3aa8c17-e37e-430e-a940-d016c4ab5852"},{"index":17870,"token":false,"name":"Alabaster Dragon","scryfallId":"3a2fcc23-ac09-4ada-b194-424739c9c734"},{"index":17871,"token":false,"name":"Sakura-Tribe Scout","scryfallId":"437123f4-bd37-4872-a950-463eaf8a2217"},{"index":17874,"token":false,"name":"Zegana, Utopian Speaker","scryfallId":"a3a9755c-b76f-4afd-b891-6ad85e3a5e2b"},{"index":17878,"token":false,"name":"Chronozoa","scryfallId":"a77c1ac0-5548-42b0-aa46-d532b3518632"},{"index":17881,"token":false,"name":"Earthlink","scryfallId":"7d33739b-c47a-431c-b0df-e09f27b38a9e"},{"index":17885,"token":false,"name":"Inventor's Apprentice","scryfallId":"07649897-df87-48b4-8f70-a11230f7df41"},{"index":17886,"token":false,"name":"Flurry of Wings","scryfallId":"dbabaf1d-0220-438d-8263-e23d8010fe24"},{"index":17888,"token":false,"name":"Lucent Liminid","scryfallId":"cd700719-2f65-4fd5-b3aa-3e9402560c79"},{"index":17889,"token":false,"name":"Goblin Locksmith","scryfallId":"cf2bed0a-990a-499a-af0a-52b77557d7cb"},{"index":17890,"token":false,"name":"Encrust","scryfallId":"f531a657-9e60-453a-b72c-2ba04913698f"},{"index":17891,"token":false,"name":"Kalonian Twingrove","scryfallId":"dabe0865-5420-463e-9138-ccd805be8b31"},{"index":17894,"token":false,"name":"Flowstone Wyvern","scryfallId":"ee7949c7-ab80-46a1-9cf7-d8e8c004df6e"},{"index":17896,"token":false,"name":"Selesnya Eulogist","scryfallId":"3e65d501-6a11-4278-949b-53a3f3502fcc"},{"index":17897,"token":false,"name":"Tin Street Dodger","scryfallId":"b3815ab6-87cd-4310-8068-ec721ee10a24"},{"index":17899,"token":false,"name":"Temple Acolyte","scryfallId":"e32032f0-74a3-450e-8684-646ac2bda4fb"},{"index":17900,"token":false,"name":"Skeleton Archer","scryfallId":"3db03880-0138-44f8-8147-f2c07878a7d8"},{"index":17902,"token":false,"name":"Elvish Pathcutter","scryfallId":"c7d810b8-1a15-46cc-9d9d-871ac43b7036"},{"index":17903,"token":false,"name":"Nemesis of Reason","scryfallId":"aa1243b2-502c-4aee-b61e-f23656bf29f2"},{"index":17907,"token":false,"name":"Dream Prowler","scryfallId":"1444f76b-c876-4166-b957-b17313221fea"},{"index":17911,"token":false,"name":"Lurking Nightstalker","scryfallId":"002715a3-b84f-40ba-8fa9-6b2854626f4d"},{"index":17912,"token":false,"name":"Slash of Talons","scryfallId":"d1dd1e31-102e-4ebd-84a0-faab4ba22b06"},{"index":17913,"token":false,"name":"Wren's Run Packmaster","scryfallId":"a44a2d69-df93-475b-8233-f73d8402594a"},{"index":17915,"token":false,"name":"Electrify","scryfallId":"60bee89d-d916-4095-830f-6270f8c4f0d8"},{"index":17916,"token":false,"name":"Decaying Soil","scryfallId":"f2bea0ec-52e0-4f45-a445-8805dc6ed596"},{"index":17918,"token":false,"name":"Gleaming Overseer","scryfallId":"0b4604b4-df53-485c-a604-4d823b33d8ba"},{"index":17919,"token":false,"name":"Sun Droplet","scryfallId":"9bdd01de-2ac6-4393-ad53-d52df137bc08"},{"index":17921,"token":false,"name":"Shadowblood Ridge","scryfallId":"093fd241-d251-41a0-8363-0b4238a9bbea"},{"index":17926,"token":false,"name":"Ambush Party","scryfallId":"4e464c69-84c0-4c09-ae86-b728a15ec77f"},{"index":17928,"token":false,"name":"Whisper, Blood Liturgist","scryfallId":"0647feeb-ad7a-40c7-830f-f307ba8339ad"},{"index":17929,"token":false,"name":"Dimir Charm","scryfallId":"9ac14998-ea7c-4d62-9507-0a309cc39c7c"},{"index":17931,"token":false,"name":"Akroan Horse","scryfallId":"ec95a60f-5164-47f9-9430-11b114c87815"},{"index":17934,"token":false,"name":"Kederekt Parasite","scryfallId":"878c7d8c-4df0-43ac-8197-d89c8be5e70d"},{"index":17937,"token":false,"name":"Boreal Elemental","scryfallId":"47996512-d547-491f-b481-a9c83dff04db"},{"index":17938,"token":false,"name":"Roil Elemental","scryfallId":"61514906-0041-49b7-8990-0643dd3431f0"},{"index":17941,"token":false,"name":"Quarry Beetle","scryfallId":"69e11478-bfc7-4bcc-b65c-dc2d4449e99f"},{"index":17945,"token":false,"name":"Double Major","scryfallId":"b7808c57-24ad-4fc3-aa70-15836afde452"},{"index":17946,"token":false,"name":"Bog Initiate","scryfallId":"8962dc3b-24ca-4c3c-ba1d-933c29cf7b73"},{"index":17950,"token":false,"name":"Favor of the Woods","scryfallId":"da0e760a-241b-40c5-b201-bfc03effed2e"},{"index":17951,"token":false,"name":"Mimeofacture","scryfallId":"f4ada33a-5b7c-426a-8416-4ce01bccaa5c"},{"index":17952,"token":false,"name":"Alhammarret, High Arbiter","scryfallId":"4200b101-19d3-4442-bddd-3eb77d5f99a9"},{"index":17954,"token":false,"name":"Blood Funnel","scryfallId":"5f4e8084-4b9e-48e0-bf59-d45543e176f8"},{"index":17958,"token":false,"name":"Palace Siege","scryfallId":"da855bb6-adc2-484c-a084-83aff2b267f1"},{"index":17963,"token":false,"name":"Enshrined Memories","scryfallId":"aeefab6e-582a-42bb-bb27-d6aadd1d35c5"},{"index":17975,"token":false,"name":"Growth-Chamber Guardian","scryfallId":"213c938d-85dc-494e-96ab-5df2c247a84c"},{"index":17978,"token":false,"name":"Experiment Kraj","scryfallId":"cb7f42a1-0996-4799-ad3a-9525c8e31343"},{"index":17979,"token":false,"name":"Arcane Melee","scryfallId":"32355574-34ed-4427-86d9-72295d32ac4f"},{"index":17982,"token":false,"name":"Experiment One","scryfallId":"d56a2703-06b8-4bdf-b346-dd38dbc06f2b"},{"index":17985,"token":false,"name":"Sharktocrab","scryfallId":"e0f31228-0c47-4c51-932d-50fdec965f15"},{"index":17987,"token":false,"name":"Windseeker Centaur","scryfallId":"e105e6c0-2d75-4ebe-beca-e7b4101f87f6"},{"index":17990,"token":false,"name":"Loxodon Mystic","scryfallId":"5976c352-ac49-4e0d-a4c0-ec9b6b78db9c"},{"index":17991,"token":false,"name":"Angrath's Rampage","scryfallId":"f5a39379-7313-463a-9a02-e5157b9557f4"},{"index":17997,"token":false,"name":"Null Chamber","scryfallId":"814f8976-6612-438f-a04a-8edb63edb1e7"},{"index":18003,"token":false,"name":"Sawtooth Loon","scryfallId":"31b0a87f-e946-4ef1-b30d-fe32c19a0f52"},{"index":18005,"token":false,"name":"Anafenza, the Foremost","scryfallId":"c8b432a7-53da-4480-b571-e6feb1364a3a"},{"index":18006,"token":false,"name":"Psychic Transfer","scryfallId":"d848a3e1-de15-4b8f-9881-d32aa2456488"},{"index":18009,"token":true,"name":"Horror Token (B, 3/3)","scryfallId":"8cfb1a9c-3f34-4362-bc2d-4cd584488820"},{"index":18010,"token":false,"name":"Lawless Broker","scryfallId":"8597bd16-61e0-43ee-b486-2fe2947e77ee"},{"index":18016,"token":false,"name":"Forced Fruition","scryfallId":"f7ea1c6e-c0af-40b0-b492-8d71f496903e"},{"index":18019,"token":false,"name":"Hazardous Conditions","scryfallId":"daa9b08b-c56f-480e-874e-069e72d979c8"},{"index":18022,"token":false,"name":"Mightstone","scryfallId":"39310639-643d-42d0-9e92-7bc0da9abd21"},{"index":18023,"token":false,"name":"Hunt the Hunter","scryfallId":"61d4899f-11a4-4a2c-a499-3a447b792f86"},{"index":18025,"token":false,"name":"Consign to Dust","scryfallId":"54cb25b6-049c-46dd-88a4-f3890e018db0"},{"index":18027,"token":false,"name":"Shimmering Mirage","scryfallId":"7263e20e-5473-42e9-90c3-3bcd848644ca"},{"index":18030,"token":false,"name":"Humble Naturalist","scryfallId":"8f56705d-eb64-4cef-b716-edbeac60bf79"},{"index":18035,"token":false,"name":"Sanctum Guardian","scryfallId":"0d09137f-0f4c-4389-a915-0ce02c833d94"},{"index":18042,"token":false,"name":"Iron Will","scryfallId":"bee0ee84-6c22-4649-b621-e3fdb08bbe45"},{"index":18043,"token":false,"name":"Lurking Jackals","scryfallId":"97d082d8-f401-47ad-845c-77776ee647ba"},{"index":18044,"token":false,"name":"Opal Guardian","scryfallId":"905ad286-e70b-46cd-87fd-eec13ed2d43b"},{"index":18045,"token":false,"name":"Drop of Honey","scryfallId":"588f1bc5-2230-4437-8d5e-a18f6e55b390"},{"index":18047,"token":false,"name":"Kolaghan Forerunners","scryfallId":"2c56a8de-8ae8-4672-8119-9e6a1f4cf5cd"},{"index":18049,"token":false,"name":"Whirlpool Warrior","scryfallId":"01f891ca-4e6a-4710-b1cf-5dabb5e1ad93"},{"index":18051,"token":false,"name":"Teferi, Timebender","scryfallId":"eb2b7388-ac6b-45c0-a5cc-da6450724b59"},{"index":18053,"token":false,"name":"Rampart Smasher","scryfallId":"2fb9a632-a56b-48fb-bc24-14572b6a8a55"},{"index":18054,"token":false,"name":"Prey's Vengeance","scryfallId":"dfd0d15f-8200-46a4-a9e9-e7f0ee2aa0e4"},{"index":18057,"token":false,"name":"Underworld Hermit","scryfallId":"735a5082-72f4-4812-adcc-d8095d8eee51"},{"index":18061,"token":false,"name":"Mindsparker","scryfallId":"a94295dc-d078-4f3f-9856-bd0a1899a9ca"},{"index":18062,"token":false,"name":"Field Trip","scryfallId":"f235060a-eb49-4a73-bb5f-01228c3c4070"},{"index":18064,"token":false,"name":"Pandemonium","scryfallId":"c54cc43c-8c06-4c23-8021-94689eeb4ad4"},{"index":18067,"token":false,"name":"Symbiosis","scryfallId":"ffc15aa3-a0cd-43bc-a4e5-89c55766e4da"},{"index":18070,"token":false,"name":"Avenging Angel","scryfallId":"28333138-60bc-459b-a0cd-1b7fd19c89cd"},{"index":18077,"token":false,"name":"Reveillark","scryfallId":"06a4d2e0-1410-41f4-8070-2b0144c71e1d"},{"index":18079,"token":false,"name":"Horn of Ramos","scryfallId":"6b17f541-8e9d-43b0-b688-e3f2e7fa55c8"},{"index":18081,"token":false,"name":"Swirling Torrent","scryfallId":"8dbb3d2f-4ee4-46e2-98aa-4aa388bd5375"},{"index":18084,"token":false,"name":"Storm Fleet Spy","scryfallId":"f7c33ef4-60bb-4f95-92a5-7abedaac6767"},{"index":18086,"token":false,"name":"Tymaret, the Murder King","scryfallId":"4c4ce848-a57d-4e88-8093-9fb1408523bc"},{"index":18088,"token":false,"name":"Roar of Reclamation","scryfallId":"d560e242-44ef-4162-8589-965897e4cdad"},{"index":18089,"token":false,"name":"Grip of Phyresis","scryfallId":"48fcbb32-f6fa-4722-abaa-9c7411d5bae6"},{"index":18090,"token":false,"name":"Thrill-Kill Assassin","scryfallId":"a9f32204-eda7-4184-92e5-9da8b15b2359"},{"index":18091,"token":false,"name":"Kargan Dragonlord","scryfallId":"20687fb9-fb0e-4a05-93b0-ef9a0bea8c52"},{"index":18096,"token":false,"name":"Goblin Banneret","scryfallId":"90b3b56c-5236-4319-b17e-5f71143a7906"},{"index":18097,"token":false,"name":"Rushing-Tide Zubera","scryfallId":"51a5357b-b479-46a7-8c3a-d51ed8f71a17"},{"index":18098,"token":false,"name":"Humongulus","scryfallId":"21982dc7-4f79-4251-8382-95cd1f627e0f"},{"index":18102,"token":false,"name":"Semblance Anvil","scryfallId":"0380b46d-1660-404d-9d11-705d8809ea46"},{"index":18107,"token":false,"name":"Lobber Crew","scryfallId":"b9d4aa15-a3c2-42a3-a87a-443e7dd20c04"},{"index":18108,"token":false,"name":"Eternal Taskmaster","scryfallId":"94a6644a-52e6-454e-a479-44b086240974"},{"index":18111,"token":false,"name":"Ruric Thar, the Unbowed","scryfallId":"84dd3586-7c3b-4f9c-a1eb-7745b75339b0"},{"index":18113,"token":false,"name":"Sundering Stroke","scryfallId":"bca6a51f-d0be-4eb2-8f5b-77cabd192f3a"},{"index":18115,"token":false,"name":"Myojin of Infinite Rage","scryfallId":"df630ae9-aa17-46e9-95e7-4980f4a76ade"},{"index":18116,"token":false,"name":"Headlong Rush","scryfallId":"9f0db04c-5101-4a43-9109-3964ac66bdab"},{"index":18117,"token":false,"name":"Glorious End","scryfallId":"7558f4b5-a436-4223-b41e-a34646f3a550"},{"index":18118,"token":false,"name":"Liliana, Death Wielder","scryfallId":"ac79d8f6-7c36-4eb9-8bda-3b813c634399"},{"index":18119,"token":false,"name":"Mouth of Ronom","scryfallId":"2d8f7396-23d3-48e2-8686-2b59ccbfc7e5"},{"index":18121,"token":false,"name":"Drag Down","scryfallId":"03eb2163-cce2-4d07-b7d7-9c70a41fa373"},{"index":18126,"token":false,"name":"Blind with Anger","scryfallId":"a50a0fe0-249d-4a88-a538-cdf622388ce2"},{"index":18129,"token":false,"name":"Tourach's Gate","scryfallId":"d77f6401-a9fb-449c-b511-6fb837055bb4"},{"index":18133,"token":false,"name":"Greater Harvester","scryfallId":"c0b9c148-5f31-405e-9215-a12bafcac99a"},{"index":18134,"token":false,"name":"Grim Discovery","scryfallId":"1ddf4a3e-4f99-439a-980b-8c6125602a73"},{"index":18136,"token":false,"name":"Flaming Gambit","scryfallId":"fb7fd9b7-c394-4ab3-b945-b4aab694eb6a"},{"index":18141,"token":true,"name":"Giant Warrior Token (G/R, 4/4)","scryfallId":"6f84b406-112d-4b01-8500-60391692a17e"},{"index":18142,"token":false,"name":"Fierce Witchstalker","scryfallId":"d63a6be2-ae9a-4758-9d5c-0297ef9af57c"},{"index":18145,"token":false,"name":"Shipwreck Moray","scryfallId":"78a64b31-6f6b-4393-99ba-4ed9d22d7213"},{"index":18146,"token":false,"name":"Summit Prowler","scryfallId":"eec9005d-eca8-45a6-b221-9d5a2cfb1e91"},{"index":18147,"token":false,"name":"Winged Coatl","scryfallId":"bc4be69d-68e7-4e56-8c32-b252a40f0ca3"},{"index":18148,"token":false,"name":"Lithatog","scryfallId":"c69742a8-cc6d-457b-8d99-81d05ab1bf0b"},{"index":18150,"token":false,"name":"Patron of the Akki","scryfallId":"18325283-ace8-414b-bf48-2ed36b5a9c24"},{"index":18151,"token":false,"name":"Cloudpiercer","scryfallId":"3ec5f005-d8fb-48b8-8ac5-74445cc83273"},{"index":18152,"token":false,"name":"Mystic Visionary","scryfallId":"48ed1b3d-0f7e-46ff-ada7-ebbd416ecf5b"},{"index":18154,"token":false,"name":"Blight Keeper","scryfallId":"3bcabe2d-82d2-4c1b-8f28-21dc29c9dbf2"},{"index":18155,"token":false,"name":"Wave of Terror","scryfallId":"d40ab3e7-9abb-4acc-9932-de03b533722f"},{"index":18158,"token":false,"name":"Dispossess","scryfallId":"4eb88be3-f790-45d7-a6d1-c78f6ba00208"},{"index":18160,"token":false,"name":"Eagle of the Watch","scryfallId":"8af7956d-f811-49d3-bef7-07f294dcea3c"},{"index":18161,"token":false,"name":"Rise from the Tides","scryfallId":"cfd602d4-0dc4-48bf-a163-c0066b3f1439"},{"index":18164,"token":false,"name":"Duty-Bound Dead","scryfallId":"5150aa90-1284-4261-8625-2528139f0015"},{"index":18168,"token":false,"name":"Salt Marsh","scryfallId":"8be7836e-adcb-435a-b65a-6675a5606f99"},{"index":18170,"token":false,"name":"Manaforce Mace","scryfallId":"ab60e11f-ea7c-4d87-bc82-9e7f4eaeef5a"},{"index":18171,"token":false,"name":"Truce","scryfallId":"97cc05bf-c3d3-4c09-8a4c-a748856b225c"},{"index":18174,"token":true,"name":"Kor Soldier Token (W, 1/1)","scryfallId":"d9623e74-3b94-4842-903f-ed52931bdf6a"},{"index":18175,"token":false,"name":"Sell-Sword Brute","scryfallId":"db513835-af5a-4ff3-8cf8-31936732a4db"},{"index":18179,"token":false,"name":"Dosan's Oldest Chant","scryfallId":"b525f824-fcce-48cc-887d-98d4058b1d31"},{"index":18181,"token":false,"name":"Wall of One Thousand Cuts","scryfallId":"d96478bb-27bf-4405-8d00-d7b75f24493b"},{"index":18185,"token":false,"name":"Skizzik","scryfallId":"afbccd46-3c9f-4f70-8afd-d8b459ca01b6"},{"index":18186,"token":false,"name":"Discerning Taste","scryfallId":"9f395828-9d6d-4ffa-be92-b681350031b0"},{"index":18187,"token":false,"name":"Abomination","scryfallId":"4fe42ef8-2126-4453-8509-563abcf9890d"},{"index":18190,"token":false,"name":"Weldfast Engineer","scryfallId":"51464df6-557f-47e5-838e-2a30145511f0"},{"index":18194,"token":false,"name":"Scuzzback Scrapper","scryfallId":"8e2ed66f-75bd-43d8-90c4-cb0a5827b2f0"},{"index":18197,"token":false,"name":"Powerstone Shard","scryfallId":"d62fd366-c287-48c3-9ded-5dc63a34518c"},{"index":18199,"token":false,"name":"Midnight Entourage","scryfallId":"2838c6dd-d816-4363-a861-f2f8052d1430"},{"index":18201,"token":false,"name":"Witch of the Moors","scryfallId":"f484f19a-0121-4173-a70b-6698cc5f6303"},{"index":18202,"token":false,"name":"Dwarven Scorcher","scryfallId":"099873b1-7181-4b9d-8ce1-8ec63c814afe"},{"index":18203,"token":false,"name":"Ragged Veins","scryfallId":"c7f3312f-71d0-4dfd-ba39-c2a2ff8d5bd0"},{"index":18206,"token":false,"name":"Endless Sands","scryfallId":"9ebd3e0a-30cc-4bc1-b9fa-6d65db9a6f5b"},{"index":18209,"token":false,"name":"Natural End","scryfallId":"84dcd314-f4d2-461e-a66e-7b1d8f141879"},{"index":18212,"token":false,"name":"Ashaya, Soul of the Wild","scryfallId":"74943390-d25f-47cb-90bb-cbf70c87f4a2"},{"index":18213,"token":false,"name":"Feast or Famine","scryfallId":"92105bc6-b64a-4bdc-99fe-7a2ccdbd4486"},{"index":18214,"token":false,"name":"Rakalite","scryfallId":"d436239d-ea38-497b-bcdd-9bfa41cb21e5"},{"index":18226,"token":false,"name":"Hulking Ogre","scryfallId":"7acfffab-0532-438d-978c-9fd986420ee6"},{"index":18228,"token":false,"name":"Invasion of the Giants","scryfallId":"7f5075a0-c72a-474c-937c-95dc9205d14f"},{"index":18233,"token":false,"name":"Throat Slitter","scryfallId":"3244bb0f-bbc7-4b5b-a9b6-78eb06da241b"},{"index":18237,"token":false,"name":"Uktabi Faerie","scryfallId":"c3cdee9f-7ea9-4397-a230-ce610be5d3af"},{"index":18239,"token":false,"name":"Imperial Mask","scryfallId":"bb02f692-80a9-4740-afde-cb4792d24774"},{"index":18240,"token":false,"name":"Aboshan's Desire","scryfallId":"137b701e-6140-463e-84b5-58d8a728df40"},{"index":18241,"token":false,"name":"Skyhunter Prowler","scryfallId":"f84f34ff-de33-4091-90b6-9de5336987f0"},{"index":18243,"token":false,"name":"Pull Under","scryfallId":"016afdaa-29bf-4690-bdfe-9074087a191c"},{"index":18246,"token":false,"name":"Darksteel Forge","scryfallId":"99078ecc-f50a-43e0-93c1-63240cd97bf7"},{"index":18249,"token":false,"name":"Claim the Firstborn","scryfallId":"feaf1e6c-c7d9-4ac7-9aeb-c4b5d61548ec"},{"index":18250,"token":false,"name":"Cytoplast Root-Kin","scryfallId":"7b83483c-95d0-4db8-b4d4-c6db400ebc97"},{"index":18254,"token":false,"name":"Night Incarnate","scryfallId":"35a5956b-8ea4-4149-83dc-ed4f70d12d34"},{"index":18255,"token":false,"name":"Shields of Velis Vel","scryfallId":"f550f44f-8b8f-4c1d-a583-9fd986d3061c"},{"index":18258,"token":false,"name":"Wall of Reverence","scryfallId":"1515e039-b838-40b6-b087-eb9e9d9ff008"},{"index":18259,"token":false,"name":"Wirefly Hive","scryfallId":"7bdb7e06-748c-4fc0-adc5-f8f2ec62029a"},{"index":18263,"token":false,"name":"Putrid Warrior","scryfallId":"17fce298-3338-4f41-8156-ab6322951a76"},{"index":18265,"token":false,"name":"Psychic Corrosion","scryfallId":"285d22fa-1623-463a-83c0-a9aa7c969ce2"},{"index":18268,"token":false,"name":"Merfolk Observer","scryfallId":"16fa8c72-320b-4a7e-9181-bad7ec0c865c"},{"index":18269,"token":false,"name":"Essence Pulse","scryfallId":"e3e32d1b-e580-4d09-b285-c8d6c5297896"},{"index":18270,"token":false,"name":"Commando Raid","scryfallId":"bb237330-ac2e-411d-836c-6628f96f3262"},{"index":18273,"token":false,"name":"Crimson Wisps","scryfallId":"a65c81ff-fc5d-4191-93fb-52eb806457b7"},{"index":18274,"token":false,"name":"Malevolent Awakening","scryfallId":"35d94052-aae3-4ced-9309-fc4a0d1f159d"},{"index":18276,"token":false,"name":"Kozilek's Channeler","scryfallId":"c550d179-32ec-4ad8-91c2-d79320a21cba"},{"index":18278,"token":false,"name":"Oran-Rief Invoker","scryfallId":"572a2dc4-3f8f-4412-8a40-9e61df33db76"},{"index":18280,"token":false,"name":"Jeskai Banner","scryfallId":"684dc050-a66b-4364-9880-56f383db6c0a"},{"index":18289,"token":false,"name":"Adanto Vanguard","scryfallId":"21c950d7-b4f6-4902-8c9a-98f2933f9fa5"},{"index":18291,"token":false,"name":"Red Mana Battery","scryfallId":"e4e507bc-441d-4f44-85d4-cf93ca199d2e"},{"index":18292,"token":false,"name":"Desecration Demon","scryfallId":"8242fade-754c-4404-b3fb-f3cccf84b3b6"},{"index":18293,"token":false,"name":"Murderous Redcap","scryfallId":"50b28eca-631b-4421-a72b-d66f89729f78"},{"index":18294,"token":false,"name":"Magma Sliver","scryfallId":"9091d908-456f-4127-857d-b22fdb4f2fd9"},{"index":18298,"token":false,"name":"Drakuseth, Maw of Flames","scryfallId":"32af39b9-c326-4aa2-9e88-142babe0f2c4"},{"index":18302,"token":false,"name":"Mudbutton Torchrunner","scryfallId":"571127d4-cc3c-4dba-989f-9b26896e6080"},{"index":18303,"token":false,"name":"Dwarven Recruiter","scryfallId":"6a15d274-85b4-4f3c-b502-f6dfe7db4d37"},{"index":18304,"token":false,"name":"Etched Monstrosity","scryfallId":"f6be7947-b929-408d-ad67-3b07b93dd36e"},{"index":18305,"token":false,"name":"Rune of Protection: Artifacts","scryfallId":"e18cce33-92be-4189-9f99-cb47bd617fd2"},{"index":18311,"token":false,"name":"Reverse the Sands","scryfallId":"aae9c988-5e8c-4d3a-af6d-8ac083698159"},{"index":18312,"token":false,"name":"Spitfire Lagac","scryfallId":"b6008794-a7ca-4a3e-b88b-e5dbb9e0f39b"},{"index":18316,"token":false,"name":"Rhonas's Monument","scryfallId":"53d2260a-e001-4d03-a108-759591e4d233"},{"index":18318,"token":false,"name":"Talons of Falkenrath","scryfallId":"f8e38239-a9ec-4149-9c90-74dcd46ed95d"},{"index":18323,"token":false,"name":"Daybreak Ranger // Nightfall Predator","scryfallId":"25b54a1d-e201-453b-9173-b04e06ee6fb7"},{"index":18324,"token":true,"name":"Ogre Token (R, 3/3)","scryfallId":"6722527e-883e-49cc-9eab-daee962a740f"},{"index":18326,"token":false,"name":"Stone Spirit","scryfallId":"705c927b-1258-4758-bbff-10cc032587a2"},{"index":18327,"token":false,"name":"The Circle of Loyalty","scryfallId":"86a4ffbb-9113-4c61-a369-95c1a52cea02"},{"index":18328,"token":false,"name":"Consulate Crackdown","scryfallId":"de80cc7d-d868-41ba-b81a-39c2e4f69fe2"},{"index":18330,"token":false,"name":"D'Avenant Archer","scryfallId":"dfc44b22-c46c-4b7e-91ff-3eff416bb357"},{"index":18331,"token":false,"name":"Danitha Capashen, Paragon","scryfallId":"ce5391bc-6b50-49b0-96a1-df944a55d62e"},{"index":18335,"token":false,"name":"Towering Indrik","scryfallId":"c6049e92-6c52-44be-a3c7-aa8e8bf9c10a"},{"index":18337,"token":false,"name":"Wake the Reflections","scryfallId":"3db0074c-95cf-4d15-8fe1-7282803ec757"},{"index":18339,"token":false,"name":"War Falcon","scryfallId":"7e092a0d-c031-4a76-86c1-7f83878a06e8"},{"index":18342,"token":false,"name":"Sheoldred, Whispering One","scryfallId":"f3da4e5a-e0ca-47ea-9dd0-5bc29ae569bb"},{"index":18343,"token":false,"name":"Hedron Archive","scryfallId":"f8900980-6e0d-4d78-91a7-60a2e8cc92a5"},{"index":18345,"token":false,"name":"Havoc Sower","scryfallId":"f8585871-24a2-41d7-ae12-29aabfbc9ccc"},{"index":18349,"token":false,"name":"Shrieking Mogg","scryfallId":"0ce46919-d312-490c-8942-39fbb2d375bf"},{"index":18353,"token":false,"name":"Mindlash Sliver","scryfallId":"f8c54575-dc1d-491c-a4f6-41f76eba2a2d"},{"index":18356,"token":false,"name":"Fervent Champion","scryfallId":"24dc2c6b-1152-4b20-a5bf-d89cf1be8036"},{"index":18357,"token":false,"name":"Mardu Strike Leader","scryfallId":"2a6b5de6-74e3-4ba8-8ec4-3fcef01a2d18"},{"index":18361,"token":false,"name":"Quagmire Druid","scryfallId":"ccb57a8b-1b2e-4119-a90e-b2b3de79e791"},{"index":18362,"token":false,"name":"Armor Thrull","scryfallId":"fcd8c672-85f7-4bec-9297-7d253419eaa9"},{"index":18369,"token":false,"name":"Seachrome Coast","scryfallId":"99939b90-e88c-4c2f-ba78-56d455611703"},{"index":18370,"token":false,"name":"Spore Swarm","scryfallId":"b2314215-23af-4c8e-860f-b029e151af36"},{"index":18373,"token":false,"name":"Falconer Adept","scryfallId":"fb4733e6-6fe2-4460-ac9f-82feb583d790"},{"index":18374,"token":false,"name":"Goblin Chieftain","scryfallId":"42673eb6-f4d0-4c80-b8cf-8322f5382bd8"},{"index":18375,"token":false,"name":"Gloomdrifter","scryfallId":"baaf8c24-3f5e-4ea5-941b-40ad1299af39"},{"index":18376,"token":false,"name":"Tarfire","scryfallId":"d13a898e-6a97-4fd9-980e-3bfd8d755386"},{"index":18380,"token":false,"name":"Unnatural Selection","scryfallId":"c575e2cb-3990-4c73-b81c-e16311ec6bbb"},{"index":18381,"token":false,"name":"Fleecemane Lion","scryfallId":"e5c834ad-14d4-4c2f-88d3-a6a892299c4c"},{"index":18384,"token":false,"name":"Vow of Torment","scryfallId":"ae74624e-3850-4153-b682-d044272269c1"},{"index":18385,"token":false,"name":"Black Scarab","scryfallId":"5bfd4ee1-05f9-45ae-a31d-1225b271dbe6"},{"index":18386,"token":false,"name":"Dryad's Favor","scryfallId":"c259509e-9f95-4566-b78a-ba34107539f7"},{"index":18388,"token":false,"name":"Triskelion","scryfallId":"5611b053-0879-450b-b556-501e5aaa4aab"},{"index":18389,"token":false,"name":"Panacea","scryfallId":"89414770-2a19-4baf-9b18-76104b7b0b9a"},{"index":18392,"token":false,"name":"Wail of the Nim","scryfallId":"a8c32faa-c6d1-418a-aed6-ccc5849daa1f"},{"index":18393,"token":false,"name":"Gargantuan Gorilla","scryfallId":"49f367c2-f47e-43e1-9936-4324be664475"},{"index":18394,"token":false,"name":"O-Kagachi, Vengeful Kami","scryfallId":"8d8a5329-2512-407b-aa35-e83dd56dc26a"},{"index":18403,"token":false,"name":"Mold Demon","scryfallId":"649a33aa-7eac-4161-ae1a-fcbc758abccf"},{"index":18404,"token":false,"name":"Cathartic Adept","scryfallId":"8e63626d-f55c-4155-9712-511f591c0614"},{"index":18408,"token":false,"name":"Hard Cover","scryfallId":"e16c9f3a-534b-42d4-9765-8d1cb15375aa"},{"index":18411,"token":false,"name":"Blazing Rootwalla","scryfallId":"4404fc9c-ef02-479c-9638-0cc163f0b48f"},{"index":18414,"token":false,"name":"Cloud Elemental","scryfallId":"caa91c8a-0838-4c12-8f7a-c038ff6d6e69"},{"index":18416,"token":false,"name":"Zoologist","scryfallId":"be645675-d263-42c4-9e71-f98cf4c2aab5"},{"index":18420,"token":false,"name":"Discombobulate","scryfallId":"cef584c5-6e2d-419b-9c11-a1b6c9c9ab2a"},{"index":18427,"token":false,"name":"Freed from the Real","scryfallId":"c47ee6f6-50c1-4f56-b9ce-4c309bfb92ca"},{"index":18428,"token":false,"name":"Final Punishment","scryfallId":"72df60bb-3309-43e0-ab4a-cec1390fc7cf"},{"index":18430,"token":false,"name":"Homeward Path","scryfallId":"2e14a24d-e31b-4e25-b004-5812f33a0d97"},{"index":18437,"token":false,"name":"Vivien's Invocation","scryfallId":"52ed9153-117a-4942-bc37-db840d007e0a"},{"index":18439,"token":false,"name":"Timecrafting","scryfallId":"fd6da5ef-7e5b-4536-ad28-6fe66f3e0438"},{"index":18441,"token":false,"name":"Akroan Line Breaker","scryfallId":"a5114db5-b545-43dc-85a3-c0e68ab22a95"},{"index":18442,"token":false,"name":"Kethis, the Hidden Hand","scryfallId":"fe28de73-76f3-4a9e-a020-dbe5921b9be5"},{"index":18444,"token":false,"name":"Loaming Shaman","scryfallId":"15f39dfb-56ee-4aae-b252-afa3f5f05855"},{"index":18447,"token":false,"name":"Boris Devilboon","scryfallId":"b61e5753-d11d-4ef5-ae0e-510c4d5809a9"},{"index":18448,"token":false,"name":"Eternal Dominion","scryfallId":"d6a1cd08-5991-43f1-943a-42dd03233041"},{"index":18451,"token":false,"name":"Sarkhan's Whelp","scryfallId":"07135c4d-b4de-4054-800a-11090ed32692"},{"index":18452,"token":false,"name":"Flawless Maneuver","scryfallId":"c972abe6-c732-4745-bde4-8b51698f05be"},{"index":18453,"token":false,"name":"Skyshooter","scryfallId":"f56f195e-a80c-4447-8d3f-cc1259035d1b"},{"index":18454,"token":false,"name":"Topplegeist","scryfallId":"c987f24a-679f-4c4f-a04f-251cec3aef67"},{"index":18456,"token":false,"name":"Fetid Heath","scryfallId":"713d95ae-4217-4544-9e00-06854fd0c6c7"},{"index":18458,"token":false,"name":"Enter the Infinite","scryfallId":"612beb8f-2ab1-4a8b-84c5-c47d19d400ab"},{"index":18460,"token":true,"name":"Companion","scryfallId":"6b95e8bd-2686-4790-afeb-9b17d482f156"},{"index":18461,"token":false,"name":"Open into Wonder","scryfallId":"0df4db1e-f2a7-44e7-9b8d-fecf73d1e01c"},{"index":18462,"token":false,"name":"Ajani's Last Stand","scryfallId":"1aebbb57-31b3-4289-815e-4f529e29f3ea"},{"index":18463,"token":false,"name":"Trapmaker's Snare","scryfallId":"9cbc98ab-9f8a-41ed-b368-22f1f4ae594b"},{"index":18464,"token":false,"name":"Tornado","scryfallId":"a2fd58e4-eb9a-4a12-8914-0a9a8300626c"},{"index":18465,"token":false,"name":"Oppression","scryfallId":"8838e751-b206-4052-9263-a67b8fea05cc"},{"index":18470,"token":false,"name":"Trial of Zeal","scryfallId":"6778e1de-16d6-408c-b49b-b17a45bacf83"},{"index":18476,"token":false,"name":"River of Tears","scryfallId":"a8de9ac4-e03f-4d08-b836-83f461159bd3"},{"index":18477,"token":false,"name":"Thrumming Stone","scryfallId":"31412335-110c-449a-9c2f-bff8763a6504"},{"index":18478,"token":false,"name":"Gnarled Professor","scryfallId":"831607fb-92ba-46d2-85a8-0aa7023e3e30"},{"index":18480,"token":false,"name":"Spark Reaper","scryfallId":"922537f0-4caf-481c-b431-826f0c44e5c5"},{"index":18481,"token":false,"name":"Horizon Stone","scryfallId":"eba7f1a7-5e3a-4567-8f4e-176f6322f4a8"},{"index":18484,"token":false,"name":"Cartouche of Ambition","scryfallId":"e68b96b1-b75e-4ee1-a6d7-6545a34fef9b"},{"index":18486,"token":false,"name":"Merrow Levitator","scryfallId":"e2b2f122-0406-44f4-82b0-9f46b52e7d99"},{"index":18487,"token":true,"name":"Faerie Rogue Token (B/U, 1/1)","scryfallId":"a07b4786-1592-42c7-9d3e-d0d66abaed99"},{"index":18488,"token":false,"name":"Decimate","scryfallId":"358bbaf9-8d48-448b-b87f-211344e36e29"},{"index":18493,"token":false,"name":"Salvage Slasher","scryfallId":"095b0fd1-7445-4dba-bb90-ddd5f5ee8573"},{"index":18494,"token":false,"name":"Souvenir Snatcher","scryfallId":"f7845c68-ab08-4fb3-a1af-167ba6c8b82a"},{"index":18496,"token":false,"name":"Master Healer","scryfallId":"c6a4a15d-9f16-4aa1-adc0-5d4c85991062"},{"index":18499,"token":false,"name":"Artificer's Intuition","scryfallId":"abe37c88-afd7-45ac-9f84-f4bd881a1462"},{"index":18500,"token":false,"name":"Cutthroat Maneuver","scryfallId":"62497880-64dc-4911-8513-f95b73086136"},{"index":18501,"token":false,"name":"Festerhide Boar","scryfallId":"1cb8cf51-12e0-4727-9f97-5e471ace8278"},{"index":18504,"token":false,"name":"Liberating Combustion","scryfallId":"c9d2156e-2d54-440e-b0fd-7bef702afbfc"},{"index":18511,"token":false,"name":"Quest for the Nihil Stone","scryfallId":"c604a567-71dd-47d9-ae5d-b87b4db98df4"},{"index":18513,"token":false,"name":"Stern Marshal","scryfallId":"18fbfbc0-c55b-4e56-a3d2-5d09571c36c8"},{"index":18514,"token":false,"name":"Scavenging Harpy","scryfallId":"b0e237c5-45b4-49df-adb9-62b9f3b62986"},{"index":18517,"token":false,"name":"Barter in Blood","scryfallId":"39b4fab6-73ce-4a56-a305-4d2e93dbb4ee"},{"index":18519,"token":false,"name":"Vizier of the Anointed","scryfallId":"78462416-8951-45be-8390-8f0dc4084642"},{"index":18527,"token":false,"name":"Nebelgast Herald","scryfallId":"768c0715-416c-4316-98ef-ff90bb3112ae"},{"index":18530,"token":false,"name":"Thought-Knot Seer","scryfallId":"c43911f0-1af0-4df9-9d7e-e417ac9ce948"},{"index":18532,"token":false,"name":"Gleaming Barrier","scryfallId":"62447a76-4aa7-4823-941e-84bc18eb672a"},{"index":18534,"token":false,"name":"Regathan Firecat","scryfallId":"4b4df1dd-886d-4fe7-b3f7-2dca044de41c"},{"index":18536,"token":false,"name":"Realm Seekers","scryfallId":"4e469f84-004d-4a92-98fe-9869b4945181"},{"index":18538,"token":false,"name":"Wicked Pact","scryfallId":"bdc849bf-9c29-41a7-8fc0-ad0137c5724e"},{"index":18541,"token":false,"name":"Refuse // Cooperate","scryfallId":"054b07d8-99ae-430b-8e54-f9601fa572e7"},{"index":18543,"token":false,"name":"Pewter Golem","scryfallId":"28aa6682-bf11-4959-9d07-423a55f35199"},{"index":18544,"token":false,"name":"Phobian Phantasm","scryfallId":"a14802be-f9d4-4984-86e0-537467f37fd7"},{"index":18545,"token":false,"name":"Master Decoy","scryfallId":"da7ad113-b04f-4611-b1cd-494cd2a8c5ac"},{"index":18546,"token":false,"name":"Benthicore","scryfallId":"f240d225-9fbf-438a-93c3-5fef325035e8"},{"index":18548,"token":false,"name":"Tooth of Chiss-Goria","scryfallId":"db5a91db-1b86-4471-badc-884142c355ca"},{"index":18549,"token":false,"name":"Scourge of the Nobilis","scryfallId":"6adccc97-3774-4c57-aa78-dcb9fbbe9324"},{"index":18550,"token":false,"name":"Blinkmoth Infusion","scryfallId":"ccb4d9a3-e7f6-41e2-9545-4682efd71f46"},{"index":18554,"token":false,"name":"Graven Lore","scryfallId":"e4386e5c-32b1-4096-a93f-fedd1a4801fc"},{"index":18558,"token":false,"name":"Pyromatics","scryfallId":"795a7929-2c32-4006-bdf1-def0a4400f59"},{"index":18562,"token":false,"name":"Oggyar Battle-Seer","scryfallId":"a38329f1-af6e-47b8-86e4-f2a39e1edbf8"},{"index":18568,"token":false,"name":"Pulsemage Advocate","scryfallId":"0dce0e8f-9ad6-42b6-af61-c883613efc97"},{"index":18569,"token":false,"name":"Jester's Mask","scryfallId":"daa1ba0c-cb89-4bb2-8a35-6a4a4eecccf7"},{"index":18570,"token":false,"name":"Thrill of Possibility","scryfallId":"2e807edb-838d-44fe-a37e-fb864d59beaa"},{"index":18571,"token":false,"name":"Mind Whip","scryfallId":"3f3ff5fb-4126-4a18-b540-2beaae382e59"},{"index":18573,"token":false,"name":"Silver Knight","scryfallId":"8c3fca0b-354f-43d1-9f1f-bbb7b52b416b"},{"index":18577,"token":false,"name":"Orcish Hellraiser","scryfallId":"56ea32e5-b164-4a8d-9312-c35ae5cd8b2a"},{"index":18578,"token":false,"name":"Treetop Sentinel","scryfallId":"606b4e02-f81a-490c-8d2e-cfea7917d6b7"},{"index":18583,"token":false,"name":"Seed Spark","scryfallId":"53dbebf0-1279-45b8-98c4-e717a3b94c63"},{"index":18584,"token":false,"name":"Phyrexian Infiltrator","scryfallId":"224b8254-553d-4d88-8163-1f15e1244bd2"},{"index":18588,"token":false,"name":"Nezumi Ronin","scryfallId":"0c3b8d6f-c60a-4107-b931-31b10f497237"},{"index":18590,"token":false,"name":"Omnath, Locus of Rage","scryfallId":"6cdf3e94-137c-4add-92bc-a744455ef6f5"},{"index":18592,"token":false,"name":"Transcendent Envoy","scryfallId":"a9241289-28d2-4827-970e-81bdecbb5c16"},{"index":18596,"token":false,"name":"Relearn","scryfallId":"a0e4d974-2462-4b6c-a6c6-1d43899820d7"},{"index":18600,"token":false,"name":"Wishclaw Talisman","scryfallId":"9ebcb070-953c-4b47-ad8a-ef207c65053f"},{"index":18604,"token":false,"name":"Anthroplasm","scryfallId":"089e2bc7-0063-47bf-8f66-48bed6eb046b"},{"index":18611,"token":false,"name":"Evermind","scryfallId":"a556ab3e-02aa-4666-a1c8-1baf3cecc1ae"},{"index":18614,"token":false,"name":"Ire Shaman","scryfallId":"18f8ac7a-a68a-4adf-995f-1cd96ee3d295"},{"index":18615,"token":false,"name":"Killian, Ink Duelist","scryfallId":"23ef4f09-2aa1-4a03-b2e2-66d1522f1e46"},{"index":18616,"token":false,"name":"Skycloud Expanse","scryfallId":"95245046-7506-40c1-853d-bd7d022653ab"},{"index":18624,"token":false,"name":"Apprentice Necromancer","scryfallId":"6d7cc1f6-9897-4de4-8e94-40cbe2d962a2"},{"index":18628,"token":false,"name":"Temple Bell","scryfallId":"5bc51134-3698-48b8-8a30-2064f9add2b1"},{"index":18629,"token":false,"name":"Kumena, Tyrant of Orazca","scryfallId":"a3aef818-c896-46e6-aaff-56aee52a066c"},{"index":18632,"token":false,"name":"Thrull Parasite","scryfallId":"c38dfb08-ab41-4759-9967-b5a25f18518a"},{"index":18634,"token":false,"name":"Ethersworn Sphinx","scryfallId":"5f3a54c0-98f0-47be-aae1-608479f4b9cf"},{"index":18639,"token":false,"name":"Glorious Charge","scryfallId":"f8672cfd-e34b-4587-9e24-015e03c7574d"},{"index":18641,"token":false,"name":"Pitiless Vizier","scryfallId":"c5cdbca9-edb5-46dc-8ae3-30d211b8e344"},{"index":18643,"token":false,"name":"Crag Puca","scryfallId":"25c11707-1ded-4891-82b4-9827a7dfc489"},{"index":18644,"token":false,"name":"Brazen Wolves","scryfallId":"ab8e2ece-3c66-4f34-9042-fc02639c6a79"},{"index":18646,"token":false,"name":"Arcbound Worker","scryfallId":"a8ab623d-25bc-4a28-a1fb-49e036a41e09"},{"index":18648,"token":false,"name":"Kyren Sniper","scryfallId":"4df99e19-0b1e-48ec-a146-38cf147eab61"},{"index":18651,"token":false,"name":"Dakmor Lancer","scryfallId":"660cc594-63f5-4819-a556-7a9484145f72"},{"index":18656,"token":false,"name":"Emergent Growth","scryfallId":"8e396762-fe76-4b2d-b571-373ab2c240ad"},{"index":18659,"token":false,"name":"Zodiac Tiger","scryfallId":"e372ec5d-6321-4cce-a7a4-76b4adde60de"},{"index":18665,"token":false,"name":"Sip of Hemlock","scryfallId":"22051427-9b2a-4571-8c9f-ee84d8d0e4d1"},{"index":18672,"token":false,"name":"Furyborn Hellkite","scryfallId":"b5b735e5-da9d-4740-acff-aac9dd24334c"},{"index":18674,"token":false,"name":"Hardened Scales","scryfallId":"01c4a294-d8b5-4237-af09-f592029c917a"},{"index":18675,"token":false,"name":"Furor of the Bitten","scryfallId":"cb0e6279-8a66-4124-9def-fa0c83c26db9"},{"index":18677,"token":false,"name":"Evaporate","scryfallId":"a3c99939-4854-4e28-a142-4cb7f89fe898"},{"index":18679,"token":false,"name":"Munda, Ambush Leader","scryfallId":"863af3aa-8127-48c2-bb2a-386efeb904bb"},{"index":18680,"token":false,"name":"Unruly Mob","scryfallId":"012d76b7-1445-4853-9e54-159154bbb144"},{"index":18681,"token":true,"name":"Zombie // Zombie Token (B, 2/2)","scryfallId":"5a561f84-5696-44a5-8dc1-227af883341d"},{"index":18687,"token":false,"name":"Awakener Druid","scryfallId":"821bd93c-e25e-4a8d-b4ec-b459ef37f6c8"},{"index":18690,"token":false,"name":"Prohibit","scryfallId":"5f3af1f2-8581-4e5d-b128-d74a0a9eaf12"},{"index":18695,"token":false,"name":"Azorius Ploy","scryfallId":"763f2c68-77a9-43e9-8f9b-2f318afcd686"},{"index":18697,"token":false,"name":"Loathsome Catoblepas","scryfallId":"4a8cff2f-ba52-4d22-83e8-13c56368f1df"},{"index":18700,"token":false,"name":"Thick-Skinned Goblin","scryfallId":"96f6dfd2-f4b1-41bc-b848-5afa30b13e36"},{"index":18704,"token":false,"name":"Beacon of Creation","scryfallId":"5bc629de-18a3-4780-9df6-28ee54a34b81"},{"index":18706,"token":false,"name":"Magus of the Future","scryfallId":"27ba1ea5-c861-4bb4-a681-fc0633268bd9"},{"index":18708,"token":false,"name":"Carrionette","scryfallId":"884e19fb-67a4-42d8-b163-720a99cb8506"},{"index":18709,"token":false,"name":"Yosei, the Morning Star","scryfallId":"1b38f14a-bd10-47c1-8772-5abe0a0b243f"},{"index":18713,"token":false,"name":"Knightly Valor","scryfallId":"20930fab-eb4f-4179-94a7-84dc7055710a"},{"index":18716,"token":false,"name":"Yeva's Forcemage","scryfallId":"3f9ebf02-56b3-492e-88fb-2e95f13f5764"},{"index":18719,"token":false,"name":"Angelic Benediction","scryfallId":"22125507-31e3-424c-9527-d994e4525d75"},{"index":18728,"token":false,"name":"Boiling Seas","scryfallId":"d08ff26e-c561-4b55-9745-50f896689d0d"},{"index":18732,"token":false,"name":"Shield of Duty and Reason","scryfallId":"4ddf4ee0-75d6-48a5-955c-97faf73b899f"},{"index":18734,"token":false,"name":"Kozilek's Shrieker","scryfallId":"a384cd5b-2c6c-4969-bb62-a017e2fc9794"},{"index":18735,"token":false,"name":"Grixis Slavedriver","scryfallId":"8049cd41-bec4-425e-b750-939a1ba905fe"},{"index":18738,"token":false,"name":"Obelisk of Undoing","scryfallId":"ab4e3d43-563d-4566-95e5-43adc38f14d1"},{"index":18739,"token":false,"name":"Viral Drake","scryfallId":"d89b312b-cc90-4f08-ae2e-043a79e51156"},{"index":18740,"token":false,"name":"Dissolve","scryfallId":"f678811b-a768-4cbb-8a82-e9bc24c4f1e4"},{"index":18744,"token":false,"name":"Wasp Lancer","scryfallId":"ac48a4ff-433b-4fd0-b0d1-43b188ee81b6"},{"index":18750,"token":false,"name":"Rookie Mistake","scryfallId":"b19de7a5-c291-405b-a2e6-8d3ac56e6570"},{"index":18753,"token":false,"name":"Horrible Hordes","scryfallId":"cf04f2cd-d9f8-4e0c-adaf-6d38bc14dd7a"},{"index":18755,"token":false,"name":"Thornwatch Scarecrow","scryfallId":"3489ac0a-cbdb-43d5-be73-6cb65ae54a20"},{"index":18758,"token":false,"name":"Thrilling Discovery","scryfallId":"bac1f45e-1884-490e-a94f-f7d312f0e229"},{"index":18760,"token":false,"name":"Fiend Binder","scryfallId":"d0870d21-603f-4d36-8054-943adba06301"},{"index":18769,"token":false,"name":"Reclusive Artificer","scryfallId":"5299a549-06cf-47e8-b6cd-7e44d9f1efb8"},{"index":18770,"token":false,"name":"Professor's Warning","scryfallId":"862fded6-e474-4b20-86d8-fd9af5f25b1a"},{"index":18771,"token":false,"name":"Thrashing Mudspawn","scryfallId":"da84de0e-a4cd-4dff-8ee3-87c9debf0969"},{"index":18774,"token":false,"name":"Rampaging Hippo","scryfallId":"4c97229f-2fc8-439a-a18b-efa09b366b70"},{"index":18776,"token":true,"name":"Voja // Saproling Token (G/W, 2/2)","scryfallId":"2879010f-b752-4808-8531-d24e612de0d9"},{"index":18778,"token":false,"name":"Szat's Will","scryfallId":"9828be7b-1eae-4718-9e71-2f625121b00b"},{"index":18779,"token":false,"name":"Deadeye Harpooner","scryfallId":"a018decf-25e1-45fc-be7d-2523dcfb7a4c"},{"index":18781,"token":false,"name":"Force Bubble","scryfallId":"742ac116-86ed-4ce6-9805-76f47a41c4c4"},{"index":18783,"token":false,"name":"Vadrok, Apex of Thunder","scryfallId":"658b75a1-c12c-4904-8a65-4eb75d1d32f7"},{"index":18786,"token":true,"name":"Sunscourge Champion Token (B, 4/4)","scryfallId":"289a9593-151e-47d0-b0de-5eb9f061515a"},{"index":18788,"token":false,"name":"Dead Ringers","scryfallId":"9b78028c-3ebd-432d-b628-e1fa284f08f3"},{"index":18792,"token":false,"name":"Valakut Awakening // Valakut Stoneforge","scryfallId":"a156b510-8879-4a7b-b15b-71374cb1e6f7"},{"index":18793,"token":false,"name":"Guul Draz Vampire","scryfallId":"f3c92575-1c97-48bf-801b-22f34040cf9a"},{"index":18796,"token":false,"name":"Incite Rebellion","scryfallId":"3633c759-f86a-436d-b54d-0d6c9ef14b63"},{"index":18801,"token":false,"name":"Transcendent Master","scryfallId":"6b007f42-9ec2-466b-8d6b-1d55c516080b"},{"index":18803,"token":false,"name":"Oblation","scryfallId":"dcfdea72-4736-4442-987b-173f6885528a"},{"index":18806,"token":false,"name":"Goblin Turncoat","scryfallId":"2ac74e64-8831-4af2-9c6d-22c533389144"},{"index":18808,"token":false,"name":"Major Teroh","scryfallId":"3229ca5a-5340-48b8-bd46-b0b924c8faf7"},{"index":18817,"token":false,"name":"Chaos Maw","scryfallId":"37e96b28-81bd-42e6-9ec2-e36f39a409ea"},{"index":18820,"token":false,"name":"Kalastria Healer","scryfallId":"42c21cb3-21f4-4a8d-8068-52649f2a1846"},{"index":18825,"token":false,"name":"Mirri, Weatherlight Duelist","scryfallId":"7f7b6d78-4c18-4f96-9f0c-53a5c81aa6f9"},{"index":18829,"token":false,"name":"Unlikely Alliance","scryfallId":"c14d2c73-1934-4504-bbfb-62ba82e0a0e3"},{"index":18832,"token":false,"name":"Upwelling","scryfallId":"d5c47cac-679f-4b48-977f-2fa149a6c3c3"},{"index":18836,"token":false,"name":"Stonework Packbeast","scryfallId":"a29e17ba-d584-4296-9f43-17467edaa25f"},{"index":18849,"token":false,"name":"Aeronaut Tinkerer","scryfallId":"e145e85d-1eaa-4ec6-9208-ca6491577302"},{"index":18851,"token":false,"name":"Brontotherium","scryfallId":"a171f5e2-ed3d-4675-a4fc-953ebb907aa0"},{"index":18857,"token":false,"name":"Angel's Mercy","scryfallId":"4e2b0942-423a-4378-b8cd-022a6b608a2e"},{"index":18858,"token":false,"name":"Golgari Longlegs","scryfallId":"d44058ba-3419-4777-8d59-05dea5e864e1"},{"index":18862,"token":false,"name":"Soul's Might","scryfallId":"77ef536d-d55b-447a-b6ab-04123f1cfaa3"},{"index":18864,"token":false,"name":"Landbind Ritual","scryfallId":"245357c6-b4cd-40f3-b7c2-413eee767239"},{"index":18865,"token":false,"name":"Dinrova Horror","scryfallId":"c0018de2-0646-48fe-8112-11952867c3bb"},{"index":18868,"token":false,"name":"Prismatic Geoscope","scryfallId":"28117e89-8803-4bac-aa44-cb11988e4b8d"},{"index":18870,"token":false,"name":"Crumbling Vestige","scryfallId":"265d3d67-37de-4461-86d0-0f398b5e4169"},{"index":18873,"token":true,"name":"Replicated Ring","scryfallId":"b3ce1236-ec2f-4cd1-9701-ba6ead74c220"},{"index":18874,"token":false,"name":"Bloodhall Priest","scryfallId":"dde7ad2c-21fb-4f2c-96a6-59f8b0eafd19"},{"index":18875,"token":false,"name":"Caller of the Untamed","scryfallId":"c62f25d9-7eb2-491e-ba7b-b71e49ee87b4"},{"index":18876,"token":false,"name":"Sickening Dreams","scryfallId":"56aece28-d590-44f5-90c0-98e8244bfc16"},{"index":18881,"token":false,"name":"Shoal Serpent","scryfallId":"a4a98047-8e6d-416c-b11d-cc4c2a56b624"},{"index":18883,"token":false,"name":"Heartwood Shard","scryfallId":"b13328a9-fc03-4c1b-b1b7-61cd41766300"},{"index":18886,"token":false,"name":"Spellbreaker Behemoth","scryfallId":"a197e3f2-e69f-4716-9979-a304a87506c3"},{"index":18889,"token":false,"name":"Cackling Fiend","scryfallId":"ae410ae8-1e72-4727-96df-c7c195063fb5"},{"index":18890,"token":false,"name":"Malach of the Dawn","scryfallId":"6f5df373-5dad-4e33-9e2b-351f1f4bdde4"},{"index":18891,"token":false,"name":"Kor Chant","scryfallId":"27e20ee1-ab61-463b-b516-0a883d9c7c39"},{"index":18895,"token":false,"name":"Phantom Whelp","scryfallId":"9216e73b-56ef-48b9-a6a1-b370fb0d97c1"},{"index":18898,"token":false,"name":"Deranged Outcast","scryfallId":"e2b35fee-8e24-4d89-ad77-d55d06bb1d7f"},{"index":18904,"token":false,"name":"Grand Abolisher","scryfallId":"67e35a40-37dd-436c-b4ac-b17b04508c1f"},{"index":18907,"token":false,"name":"Chronostutter","scryfallId":"bbef107d-c19f-4af3-9236-c66123075b41"},{"index":18910,"token":false,"name":"Lavaball Trap","scryfallId":"c0d411e1-5488-4818-95a4-9f637efb9be6"},{"index":18911,"token":false,"name":"Soulherder","scryfallId":"ea23111b-ccc1-4d5c-a9d2-9db14c728820"},{"index":18912,"token":false,"name":"Altar of the Goyf","scryfallId":"e0b3a98f-2b3c-438b-b78c-eef8d917f68e"},{"index":18913,"token":false,"name":"Wandering Goblins","scryfallId":"217281d9-a8f4-4e7a-987f-7ece0ae15eba"},{"index":18915,"token":false,"name":"Mischievous Chimera","scryfallId":"f8a3df0e-4ee8-458b-adf5-56aca20493e9"},{"index":18919,"token":false,"name":"Mundungu","scryfallId":"d6e320ca-848b-4743-93f1-ec04ef1ce402"},{"index":18920,"token":false,"name":"Pang Tong, \"Young Phoenix\"","scryfallId":"f484d47a-fb1d-4746-8f1d-dd9d24e67c1a"},{"index":18921,"token":false,"name":"Sphinx's Herald","scryfallId":"bd7e2501-2d36-41eb-a77a-747b62affc09"},{"index":18922,"token":false,"name":"Loxodon Convert","scryfallId":"00c050c3-4f50-4bb6-8477-6737887ca10d"},{"index":18925,"token":false,"name":"Elvish Dreadlord","scryfallId":"5039df58-70f9-404e-8b18-d1169c77699c"},{"index":18926,"token":false,"name":"Standard Bearer","scryfallId":"e0f8e16a-55f0-4147-a01a-dba7938f31c4"},{"index":18927,"token":false,"name":"Aeve, Progenitor Ooze","scryfallId":"75a03422-4106-4d06-b26a-06b1e3b0cb2a"},{"index":18929,"token":false,"name":"Dark Heart of the Wood","scryfallId":"e3d3df64-1e90-4aef-86ae-0062aa23ff30"},{"index":18930,"token":false,"name":"Najeela, the Blade-Blossom","scryfallId":"be898edb-35dd-4896-96d9-323aca64a2ce"},{"index":18931,"token":false,"name":"Boros Elite","scryfallId":"a03974e6-aced-4664-8c5c-3190bb1eb233"},{"index":18933,"token":false,"name":"Toxin Sliver","scryfallId":"c04ab6b6-27ee-4c93-a87c-cbc3743f4faf"},{"index":18937,"token":false,"name":"Heartwood Storyteller","scryfallId":"7a5e2f7a-8cfe-4d1b-a68d-7e6d8d10bd27"},{"index":18942,"token":false,"name":"Wall of Vines","scryfallId":"9f7b7563-752b-4391-95d1-f5e3960d35c1"},{"index":18943,"token":false,"name":"Seismic Spike","scryfallId":"b9caddbe-1329-4ac2-9071-6fc5059d4dec"},{"index":18950,"token":false,"name":"Refreshing Rain","scryfallId":"c5e24850-bd9b-40ab-878f-b8a554da1956"},{"index":18952,"token":false,"name":"Burn at the Stake","scryfallId":"d46e9902-81fb-4a3c-9f2f-d3faf031631d"},{"index":18953,"token":false,"name":"Voracious Cobra","scryfallId":"9d8c5669-11a9-4d95-8431-7065037f1fb6"},{"index":18955,"token":false,"name":"Crosswinds","scryfallId":"f182a85b-a119-46e2-8b8b-48b6758d9c39"},{"index":18957,"token":false,"name":"Swift Warden","scryfallId":"1531cb47-b0ff-4d66-acf2-ef5bb5f690fc"},{"index":18958,"token":false,"name":"Marsh Crocodile","scryfallId":"813279d1-d7bd-4d49-bd9d-fc9a6595dd39"},{"index":18960,"token":false,"name":"Aven Battle Priest","scryfallId":"b0060e75-a5a4-4d9a-894c-45bb7e2feffc"},{"index":18963,"token":false,"name":"Flood of Recollection","scryfallId":"c14a5b69-ce04-40fc-9933-20b16537de24"},{"index":18968,"token":false,"name":"Albino Troll","scryfallId":"a122894b-def7-412a-981c-6218b9c6b1a7"},{"index":18969,"token":false,"name":"Banisher Priest","scryfallId":"d75365b9-1fb0-4ac3-a43a-cf70eb8b37a5"},{"index":18973,"token":false,"name":"Vapor Snare","scryfallId":"bf09358e-099a-4115-807e-48ceb024d186"},{"index":18977,"token":false,"name":"Etherwrought Page","scryfallId":"568785f1-47c7-4011-926f-44693f7e0233"},{"index":18980,"token":false,"name":"Hope of Ghirapur","scryfallId":"6f4bcadd-7eff-4294-94d5-52482a734d5b"},{"index":18983,"token":true,"name":"Ashaya, the Awoken World Token (G, 4/4)","scryfallId":"0affd414-f774-48d1-af9e-bff74e58e1ca"},{"index":18991,"token":false,"name":"Necromantic Thirst","scryfallId":"0a46880c-a9f4-452d-8b91-51d8aa97cbd2"},{"index":18993,"token":false,"name":"Elite Skirmisher","scryfallId":"982eed00-e9fe-4d0f-a2b7-9606aa7926a1"},{"index":18994,"token":false,"name":"Ayula's Influence","scryfallId":"1b9296ca-39a8-4aad-be92-0a56c704e950"},{"index":19000,"token":false,"name":"Sage of Hours","scryfallId":"8cb55caf-fc95-40dc-80af-5144f94333ee"},{"index":19001,"token":false,"name":"Memorial to Genius","scryfallId":"b97bb62e-45cf-4862-b181-5af463a442b5"},{"index":19003,"token":false,"name":"Deathbringer Liege","scryfallId":"371f5fdf-b436-4a4b-a181-68b08c9f2ea6"},{"index":19012,"token":false,"name":"Stoneforge Acolyte","scryfallId":"a5b1ec11-48c3-49d8-9dcd-1da5ffaf9184"},{"index":19013,"token":false,"name":"Keldon Champion","scryfallId":"aec38450-81f7-4071-8735-4a21dc6b1c1f"},{"index":19015,"token":false,"name":"Death Pit Offering","scryfallId":"2d0ba945-671a-4a97-a613-18af7071fa24"},{"index":19016,"token":false,"name":"Psychic Spiral","scryfallId":"59b09c16-f611-4c90-a990-e22bf46bd0e2"},{"index":19017,"token":false,"name":"Hinterland Logger // Timber Shredder","scryfallId":"14529bed-9632-4d58-8edc-c5a1359f6604"},{"index":19019,"token":false,"name":"Vodalian Mage","scryfallId":"a47beac4-161d-4f8e-9778-78293ff9b383"},{"index":19020,"token":false,"name":"Valor in Akros","scryfallId":"7e7428ad-4bd4-401d-a45c-3900bb05a3f7"},{"index":19024,"token":false,"name":"Inner Sanctum","scryfallId":"2298faae-370e-4b87-bf32-d20c2282a928"},{"index":19027,"token":false,"name":"Dazzling Beauty","scryfallId":"ad0ece98-5506-4a18-b900-8d1a6cd87385"},{"index":19031,"token":false,"name":"Champion Lancer","scryfallId":"26b4171b-2d49-4e06-a2fd-9fe3cfd6ce95"},{"index":19034,"token":false,"name":"Stoic Rebuttal","scryfallId":"e9f8146e-ca33-4fa2-8f39-5a44b0db4bd6"},{"index":19036,"token":false,"name":"Seasoned Hallowblade","scryfallId":"feb59931-8941-46fb-8e1c-f80ff3730dd9"},{"index":19037,"token":false,"name":"Tolaria","scryfallId":"d43c01b7-443d-4061-a934-6863d230c9b8"},{"index":19038,"token":false,"name":"Makindi Aeronaut","scryfallId":"a35d3113-6cb7-4b74-94a3-8160d9ac1b89"},{"index":19039,"token":false,"name":"Sculpting Steel","scryfallId":"3aac5f6f-97c1-4546-94ed-016292e98c9d"},{"index":19040,"token":false,"name":"Awaken the Sky Tyrant","scryfallId":"5c3d57d1-1031-45e0-97d1-8e8e3e6ab516"},{"index":19045,"token":false,"name":"Lilting Refrain","scryfallId":"ef319154-c5fc-4432-a860-a05508c132d4"},{"index":19046,"token":false,"name":"Wing Puncture","scryfallId":"05a5188b-9ae3-4ca0-8289-b8a266a9073b"},{"index":19049,"token":false,"name":"Riftmarked Knight","scryfallId":"d503b565-a3c8-4b57-9e30-fb97d2a49afa"},{"index":19051,"token":false,"name":"Shrapnel Blast","scryfallId":"f8baa9d1-b45d-4947-9eb6-7f580c83a2c3"},{"index":19061,"token":false,"name":"Coma Veil","scryfallId":"2d5b820c-fd07-4e1f-9451-da9267347acd"},{"index":19063,"token":false,"name":"Raging Ravine","scryfallId":"cb7b6fb5-4d38-4734-b46f-923322cff24e"},{"index":19065,"token":false,"name":"Pulse of the Grid","scryfallId":"b6805341-fa4f-4d89-8003-b27280fadfbd"},{"index":19069,"token":false,"name":"Jedit Ojanen","scryfallId":"97b80124-2b59-425c-93cc-9b032e631c6e"},{"index":19070,"token":false,"name":"Phyrexian Negator","scryfallId":"de51da2a-8771-4a27-b15f-13be8a17d536"},{"index":19071,"token":false,"name":"Kjeldoran Outrider","scryfallId":"bd641b1d-dab8-415b-9655-09e033df761d"},{"index":19072,"token":false,"name":"Lich","scryfallId":"4250caec-0e37-41be-9ec4-8938deb5f0d0"},{"index":19075,"token":false,"name":"Death Stroke","scryfallId":"edff316e-e3a3-4d88-a124-51eab1c7953f"},{"index":19077,"token":false,"name":"Ainok Guide","scryfallId":"c361ea9c-a989-4ded-8b2c-f565aa9d8a1d"},{"index":19078,"token":false,"name":"Zombie Trailblazer","scryfallId":"82e4675f-ebec-483f-a111-b505629760fd"},{"index":19079,"token":false,"name":"Shadow Sliver","scryfallId":"fb725914-1b0f-4efc-808b-9fe2eaa7f17d"},{"index":19081,"token":false,"name":"Deathspore Thallid","scryfallId":"44ee5ee3-11f8-4a4e-bfa3-10ff45ed6d1b"},{"index":19084,"token":false,"name":"Kjeldoran Skyknight","scryfallId":"f794665a-8353-482a-b065-2a0777a8acda"},{"index":19085,"token":false,"name":"Relic Ward","scryfallId":"f0459667-b7da-43bd-b981-0e515432d147"},{"index":19088,"token":false,"name":"Bonded Fetch","scryfallId":"de72afaf-a4b4-431c-8831-86ddfba2403c"},{"index":19089,"token":false,"name":"Takklemaggot","scryfallId":"d8f49b3d-7fcb-4169-9298-cdf7a1dbe3f5"},{"index":19091,"token":false,"name":"Decisive Denial","scryfallId":"b2e9d132-95f7-4ee7-9c91-be19e4ad7a5d"},{"index":19095,"token":false,"name":"Make a Stand","scryfallId":"4a0857fa-f2cc-4c01-9fe5-8f74d08d1b29"},{"index":19096,"token":false,"name":"Awakening Zone","scryfallId":"bae2f694-a4e1-4cfd-a0bf-07aaf27886a6"},{"index":19103,"token":false,"name":"Horn of Deafening","scryfallId":"bfbd36dd-3e6f-40c7-a166-0e8ecaabe7fa"},{"index":19105,"token":false,"name":"Ram Through","scryfallId":"ac0b24e7-14e7-45ee-b5d8-bdb8674b669c"},{"index":19106,"token":false,"name":"Homing Sliver","scryfallId":"a7f2073b-bc1f-4611-9bdf-73cb86892886"},{"index":19108,"token":false,"name":"Tah-Crop Skirmisher","scryfallId":"ab0429ec-0809-4e68-9790-8c21bde201a2"},{"index":19109,"token":false,"name":"Ghosts of the Damned","scryfallId":"d15e5505-74ad-4540-8b23-ab5e5add9227"},{"index":19110,"token":false,"name":"Flowstone Armor","scryfallId":"1160e476-8a2b-4b90-b4db-f386a80ab067"},{"index":19115,"token":false,"name":"Skeletal Grimace","scryfallId":"b9b28f37-d6b8-4d35-95e9-9533aea0a071"},{"index":19119,"token":false,"name":"Belltower Sphinx","scryfallId":"ef04340d-284c-4e7b-afd7-444d21a6b382"},{"index":19129,"token":false,"name":"Thundermare","scryfallId":"7068c0c3-4ec9-4c02-84db-42b609df545f"},{"index":19131,"token":false,"name":"Relic Golem","scryfallId":"0b59c75b-d8f8-4f95-9030-ed73c67d988e"},{"index":19132,"token":false,"name":"Scornful Egotist","scryfallId":"fec6b189-97e7-4627-9785-a9ce2f1ad89f"},{"index":19133,"token":false,"name":"Spur Grappler","scryfallId":"50bf91a7-4d04-437c-a290-6adb52f25312"},{"index":19138,"token":false,"name":"Fungal Behemoth","scryfallId":"53c1910b-9475-4551-b9a0-4b24511a6f98"},{"index":19141,"token":false,"name":"Ill-Tempered Cyclops","scryfallId":"d1f7f757-31ac-43e6-8be0-c5948d478d2f"},{"index":19142,"token":false,"name":"Deputy of Acquittals","scryfallId":"b0e7dff8-faae-46b8-8dd9-58830e1df61e"},{"index":19143,"token":false,"name":"Backlash","scryfallId":"dadf030d-5451-43fc-bf0c-c1629fdf88ec"},{"index":19145,"token":false,"name":"Desecrated Tomb","scryfallId":"f2e78997-6a04-49fe-a306-c76ed3525117"},{"index":19148,"token":false,"name":"Scrying Glass","scryfallId":"7286819f-6c57-4503-898c-528786ad86e9"},{"index":19152,"token":false,"name":"Debtor's Pulpit","scryfallId":"fafb0372-6860-4b0b-b92e-873735489006"},{"index":19153,"token":false,"name":"Reki, the History of Kamigawa","scryfallId":"86317339-5a39-41eb-8aee-5ea926da8cd4"},{"index":19154,"token":false,"name":"Endless Obedience","scryfallId":"c70ceae6-8b25-4ce2-b89b-45300401fec5"},{"index":19156,"token":false,"name":"Chill to the Bone","scryfallId":"312505d7-362e-43cf-bd23-28c248a8b7e1"},{"index":19159,"token":false,"name":"Molten Primordial","scryfallId":"a8f5c7e2-f4da-4cee-a7d0-80b29bb73acd"},{"index":19160,"token":false,"name":"Storage Matrix","scryfallId":"2aa41221-ee75-4713-99bd-683013ba64de"},{"index":19161,"token":false,"name":"Longtusk Cub","scryfallId":"c4de778a-4419-49a5-9dcf-5d0095c873fa"},{"index":19162,"token":false,"name":"Night Terrors","scryfallId":"9b41fe67-daf0-47ed-8f0e-db216f8394d1"},{"index":19164,"token":false,"name":"Galvanic Arc","scryfallId":"64d816df-51e5-46f8-ad9a-68f3f656dbcd"},{"index":19166,"token":false,"name":"Tar Snare","scryfallId":"06ee017c-25ae-4668-8cfe-ae3b55e851aa"},{"index":19168,"token":false,"name":"Illusionist's Stratagem","scryfallId":"4747d3ee-5437-4393-9e02-f9e253a7f7e3"},{"index":19171,"token":false,"name":"Stalking Leonin","scryfallId":"9194919e-0876-4824-9ea7-de9b97f0e75d"},{"index":19173,"token":false,"name":"Frightcrawler","scryfallId":"d79129e7-6cc4-4060-8b76-3afbd2e0d456"},{"index":19174,"token":false,"name":"Vigil for the Lost","scryfallId":"4a87b48b-2ae9-4753-8719-62411f94ca87"},{"index":19175,"token":false,"name":"Mage-Ring Network","scryfallId":"4988180b-a374-43fd-b299-fb61c781df2e"},{"index":19177,"token":false,"name":"Ashiok's Adept","scryfallId":"86acd1cc-5238-4734-a324-b4cecffc0bab"},{"index":19178,"token":false,"name":"Kaleidostone","scryfallId":"79826f7f-e46b-489d-8fcb-1712d36e8f60"},{"index":19181,"token":false,"name":"Werebear","scryfallId":"964cf7e3-932d-432f-8ad4-9bd651aada96"},{"index":19182,"token":false,"name":"Dagger Caster","scryfallId":"48a7ac34-ec4a-4571-abb1-bff1fb67c78f"},{"index":19183,"token":false,"name":"Undead Servant","scryfallId":"36afdfd4-8db7-45b6-9b6d-b9293fe6c26d"},{"index":19185,"token":false,"name":"Stir the Sands","scryfallId":"0cb84193-9648-46e5-a34d-c12cc3f1d7f2"},{"index":19194,"token":true,"name":"Minion Token (B, */*)","scryfallId":"a9930d11-4772-4fc2-abbd-9af0a9b23a3e"},{"index":19195,"token":false,"name":"Twigwalker","scryfallId":"90b8ba27-c3bb-48cf-b831-518f5d255c2e"},{"index":19200,"token":false,"name":"Forsake the Worldly","scryfallId":"11b8403f-5f2d-4b4f-b032-13be64553213"},{"index":19202,"token":false,"name":"Retaliator Griffin","scryfallId":"b3289594-2a2e-4495-9553-b45c18055775"},{"index":19203,"token":false,"name":"Blind-Spot Giant","scryfallId":"75aaca31-8ed5-4e8a-8332-1cca77903f88"},{"index":19206,"token":false,"name":"Pardic Dragon","scryfallId":"fd618eb1-0013-461c-873e-a66377fa284a"},{"index":19208,"token":false,"name":"Quirion Druid","scryfallId":"8ca5319a-5c26-487f-ba87-d317633122ba"},{"index":19209,"token":false,"name":"White Shield Crusader","scryfallId":"368322d7-d399-45e1-8d7f-8001d048071e"},{"index":19211,"token":false,"name":"Temporal Manipulation","scryfallId":"a638908e-e703-427f-a42c-d64681b8b4f6"},{"index":19212,"token":false,"name":"Chandra's Regulator","scryfallId":"c3010664-64fa-436e-9bad-6a145b9da742"},{"index":19213,"token":false,"name":"Blazing Salvo","scryfallId":"f7d192ef-a174-4df5-b67f-22918c32cf71"},{"index":19214,"token":false,"name":"Return to Nature","scryfallId":"3f1b4490-d96d-4448-835b-6cc453c1f344"},{"index":19215,"token":false,"name":"Poison-Tip Archer","scryfallId":"1677d49e-3d63-45bd-9849-01b1bdd95ad8"},{"index":19216,"token":false,"name":"Shattered Perception","scryfallId":"0f5223b4-e0d1-4fc6-a363-ebcdfeee56d1"},{"index":19226,"token":false,"name":"Dwarven Priest","scryfallId":"7e1e0f13-35a6-4a5e-8666-47bc5c275be7"},{"index":19228,"token":false,"name":"Heroes' Reunion","scryfallId":"135d6043-5ec1-4ad4-8296-41fe23f11cb9"},{"index":19233,"token":false,"name":"Drumhunter","scryfallId":"343ef398-576a-43b6-a32b-f916ccd63579"},{"index":19234,"token":false,"name":"Ashen Monstrosity","scryfallId":"de3218e3-4640-4f73-a52b-f11ea5ea23a9"},{"index":19235,"token":false,"name":"Raise the Draugr","scryfallId":"1a67c196-632c-4c7b-a132-de07d894e634"},{"index":19241,"token":false,"name":"Pain Seer","scryfallId":"4351fc8e-ba98-40ad-812a-d43d6db91859"},{"index":19245,"token":false,"name":"Changeling Titan","scryfallId":"2d5b9719-2861-477e-bb78-225fd03d7bbc"},{"index":19249,"token":false,"name":"Elite Inquisitor","scryfallId":"98f687bb-157c-4e98-b39b-2dce7f145fa5"},{"index":19251,"token":false,"name":"Gruul Charm","scryfallId":"33c6f53f-538c-4124-84fb-f2045bec3491"},{"index":19252,"token":false,"name":"Mage Slayer","scryfallId":"2d0bfe8c-120c-4c4b-8709-efe40e26a35c"},{"index":19254,"token":false,"name":"Weatherlight","scryfallId":"9e41242c-cd23-40ae-84dc-afdb6a3a3a52"},{"index":19256,"token":true,"name":"Ajani's Pridemate Token (W, 2/2)","scryfallId":"b0819e8e-fb7e-43c7-a7cf-d768f43193ac"},{"index":19260,"token":false,"name":"Virulent Sliver","scryfallId":"66de9c95-e590-4b0d-a2d7-886d7a488a10"},{"index":19262,"token":true,"name":"Plant Token (G, 0/1)","scryfallId":"c1424e8d-1f96-44af-9382-c337b6695ddf"},{"index":19265,"token":false,"name":"Moderation","scryfallId":"c41b3d7a-f8e1-46b8-a689-6125dcd9cb17"},{"index":19269,"token":false,"name":"Unmake","scryfallId":"338f7852-9f69-4406-b6ad-93a2574296f7"},{"index":19271,"token":false,"name":"Dubious Challenge","scryfallId":"3c2f72f7-69e1-4944-98ad-66d88ee2d727"},{"index":19272,"token":false,"name":"Truth or Tale","scryfallId":"5b3e301a-02a5-4d92-9cdd-5ab877bf8ed3"},{"index":19273,"token":false,"name":"Nettling Curse","scryfallId":"69bf458c-9e2c-4d36-90c5-d9b772f99d3c"},{"index":19274,"token":false,"name":"Mystic Skyfish","scryfallId":"0002ab72-834b-4c81-82b1-0d2760ea96b0"},{"index":19275,"token":false,"name":"Kavu Howler","scryfallId":"5fdf502f-445d-4724-b7d0-8fdd5bf557a8"},{"index":19277,"token":false,"name":"Cauldron Haze","scryfallId":"a8d0def7-42dd-46f4-8499-d79876783a39"},{"index":19278,"token":false,"name":"Lifespark Spellbomb","scryfallId":"0adde668-67af-4a08-a36a-2a49893ab20d"},{"index":19279,"token":false,"name":"Licia, Sanguine Tribune","scryfallId":"f53f595f-7fca-41f3-b932-38f85c6db223"},{"index":19281,"token":false,"name":"Eternal Dragon","scryfallId":"2c110eeb-23bf-41f0-a7d0-9aec29d0f6de"},{"index":19283,"token":false,"name":"Gerrard's Wisdom","scryfallId":"e43378f0-b518-499e-9950-c583bc2f11f8"},{"index":19284,"token":false,"name":"Kestia, the Cultivator","scryfallId":"6d49d5e5-fca7-47ec-89f0-282641413245"},{"index":19285,"token":false,"name":"Collective Defiance","scryfallId":"4a715efd-0350-489e-973f-24e7828c483a"},{"index":19288,"token":false,"name":"Neurok Commando","scryfallId":"aa7084f3-9335-401f-9a62-6f131351338d"},{"index":19291,"token":false,"name":"Glare of Subdual","scryfallId":"ed6166c1-3c2e-47af-873e-d3b39f42bd27"},{"index":19292,"token":false,"name":"Stormcloud Spirit","scryfallId":"b371bba8-08b1-468b-924b-c1f3d64bb096"},{"index":19293,"token":false,"name":"Scrabbling Claws","scryfallId":"415027f8-ccef-4b38-ace2-db4e94f066fe"},{"index":19295,"token":false,"name":"Nantuko Shaman","scryfallId":"a3370c6d-a743-49b3-b869-da65b49391d9"},{"index":19297,"token":true,"name":"Copy","scryfallId":"c7ba6540-3743-445c-99bf-feb5af2fd56d"},{"index":19303,"token":false,"name":"Deepwater Hypnotist","scryfallId":"4ab7c6a7-8214-4644-8f2e-ec74d2aff27e"},{"index":19308,"token":false,"name":"Ordeal of Erebos","scryfallId":"9e02ddba-fdc1-4d7b-89eb-00a0417f8963"},{"index":19311,"token":false,"name":"Skullwinder","scryfallId":"d20c54c4-d93b-45f2-b071-adb641de81ce"},{"index":19312,"token":false,"name":"Petrified Plating","scryfallId":"1195c459-5e06-4f4e-aa6e-58fefa712684"},{"index":19315,"token":false,"name":"Wicked Wolf","scryfallId":"09476eac-55d2-4955-8951-ae4ce117c98b"},{"index":19318,"token":false,"name":"Ogre Warrior","scryfallId":"66e72970-df1f-4ded-a686-036008555a76"},{"index":19319,"token":false,"name":"Bubbling Beebles","scryfallId":"002cf7d8-3fc2-48eb-a727-a1ce5a049665"},{"index":19326,"token":false,"name":"Sylvia Brightspear","scryfallId":"564a9faa-71a6-4481-ac7e-1fc0f9b11e1a"},{"index":19329,"token":false,"name":"Rooting Kavu","scryfallId":"12c25a4c-d93a-402b-999f-0b9919123cc5"},{"index":19331,"token":false,"name":"Rappelling Scouts","scryfallId":"113b8366-e6d0-423e-af4b-52c1e08ed446"},{"index":19332,"token":false,"name":"Mikaeus, the Unhallowed","scryfallId":"8879190f-d8ff-47ce-a5d8-6a481a67236a"},{"index":19333,"token":false,"name":"Gorm the Great","scryfallId":"41603938-9527-42fc-a870-b662c3871ae3"},{"index":19335,"token":false,"name":"Grim Poppet","scryfallId":"3bac9d9c-6685-465b-8933-dd6164569f4d"},{"index":19338,"token":false,"name":"Skyclaw Thrash","scryfallId":"fafde9c4-57c0-4ae5-a4db-38aae434ddcd"},{"index":19341,"token":false,"name":"Rag Dealer","scryfallId":"18ef007a-fcf4-4293-933e-4f9f7f602002"},{"index":19342,"token":false,"name":"Archon of Absolution","scryfallId":"684ca60c-7ed4-49e1-b54a-91d129539375"},{"index":19344,"token":false,"name":"Kitesail Freebooter","scryfallId":"88496096-fd9a-451a-85d9-31ccc3580623"},{"index":19345,"token":false,"name":"Inferno Hellion","scryfallId":"9cd11004-5b8f-4c71-bde0-eb75eed869b0"},{"index":19346,"token":false,"name":"Myth Unbound","scryfallId":"df0a0719-defc-4a28-af8e-173340b41b33"},{"index":19347,"token":false,"name":"Crafty Cutpurse","scryfallId":"117d84f7-45c5-4cfc-a5cd-c44416b48417"},{"index":19348,"token":false,"name":"Vampire Noble","scryfallId":"b2435f17-0378-4480-8d56-d256245c7ced"},{"index":19349,"token":false,"name":"Regal Force","scryfallId":"2b6eb422-6e99-42bc-890b-99d4f6cd20f2"},{"index":19350,"token":false,"name":"Basri's Solidarity","scryfallId":"aa6daf0d-d581-434e-9b5f-cea1e7fd7967"},{"index":19351,"token":false,"name":"Shield Dancer","scryfallId":"1d885360-1ce1-4b80-8928-29437731993f"},{"index":19355,"token":false,"name":"Shepherd of Heroes","scryfallId":"1f70baa3-5232-4e10-80b4-a9ead6ed6ec3"},{"index":19357,"token":false,"name":"Bloodmad Vampire","scryfallId":"b64e974a-3cf7-49f1-9d5a-c74f920f0169"},{"index":19360,"token":false,"name":"Cloudshredder Sliver","scryfallId":"f7b8521e-8706-4480-9a47-9600a015cc96"},{"index":19363,"token":false,"name":"Rogue Elephant","scryfallId":"b51b2c1e-671d-4506-9311-e136ec2f182b"},{"index":19367,"token":false,"name":"Golgari Locket","scryfallId":"1c2e7843-9a87-46cb-be06-6db58649db85"},{"index":19373,"token":false,"name":"Precursor Golem","scryfallId":"dc90d632-fc78-4ae6-83c6-314ee5744de5"},{"index":19374,"token":false,"name":"Orcish Mine","scryfallId":"3a630875-b43d-4591-992c-117e1212fa34"},{"index":19375,"token":false,"name":"Elkin Lair","scryfallId":"bcb625ba-3718-4988-962c-bf2e11eb4c16"},{"index":19376,"token":true,"name":"Earthshaker Khenra Token (B, 4/4)","scryfallId":"c4bb3bd7-5aef-495e-81ba-f5d287981dbd"},{"index":19377,"token":false,"name":"Gluttonous Cyclops","scryfallId":"e583f6be-3d78-4085-9059-c3c989a4977f"},{"index":19378,"token":false,"name":"Olivia's Dragoon","scryfallId":"868067ce-3415-4239-b7c3-d3ad4c03fb8d"},{"index":19380,"token":false,"name":"Renegade's Getaway","scryfallId":"056b4bd0-1794-4319-9f72-8aad1298b8ca"},{"index":19382,"token":false,"name":"Goblin Settler","scryfallId":"503ef4d7-2028-4363-b3af-f9fe690510f9"},{"index":19386,"token":false,"name":"Antagonism","scryfallId":"6b9db511-089e-413f-8005-ccb05ec3b06e"},{"index":19393,"token":false,"name":"Flowstone Thopter","scryfallId":"5bf016ec-2654-4c3e-8e2e-6c70c4604d28"},{"index":19394,"token":false,"name":"Dangerous Wager","scryfallId":"636c4042-703f-4548-9a0f-cb550c468bf9"},{"index":19396,"token":false,"name":"Aether Snap","scryfallId":"c89eed52-aa5b-4a59-9bc6-cea65e504deb"},{"index":19398,"token":false,"name":"Gutwrencher Oni","scryfallId":"7698a5da-5c70-4818-927b-3a923314e537"},{"index":19401,"token":false,"name":"Besmirch","scryfallId":"534c652a-2345-48d5-bd78-33f91ed914b4"},{"index":19403,"token":false,"name":"Might of the Nephilim","scryfallId":"ca5c4a29-0650-4b9e-af6b-39bee19167ad"},{"index":19404,"token":false,"name":"Blood for Bones","scryfallId":"7892b516-0dce-491f-8b42-031d64397e26"},{"index":19405,"token":false,"name":"Painful Memories","scryfallId":"79223c17-ecb1-47f1-8e24-eea464cc9b1e"},{"index":19408,"token":false,"name":"Trial of Solidarity","scryfallId":"a2604d43-a105-440b-86b1-60d1d0c04339"},{"index":19410,"token":false,"name":"Fin-Clade Fugitives","scryfallId":"3eb7af70-e024-44bf-a52b-209074b005a3"},{"index":19411,"token":false,"name":"Yellow Scarves Troops","scryfallId":"3ca36a8d-ca44-485e-a219-85814f160c4d"},{"index":19414,"token":false,"name":"Territorial Scythecat","scryfallId":"5e0f725c-8d1f-47ff-ad81-a5007199a5e2"},{"index":19427,"token":false,"name":"Coveted Jewel","scryfallId":"5a70b63b-d7b7-4e3d-83ab-8e7f1efd7a49"},{"index":19433,"token":false,"name":"Despotic Scepter","scryfallId":"53e381a4-810e-4b75-aed3-c16cf0eb06fa"},{"index":19434,"token":false,"name":"Overtaker","scryfallId":"40a80610-5d34-4870-bc30-0c8dd3f08ac6"},{"index":19439,"token":false,"name":"Huatli's Spurring","scryfallId":"a19440e2-855f-4f60-a443-b99500394611"},{"index":19443,"token":false,"name":"Ethersworn Canonist","scryfallId":"8cc5cc11-db9d-4d5c-9a64-326c210e30a7"},{"index":19445,"token":false,"name":"Isamaru, Hound of Konda","scryfallId":"1c4968e7-c656-419d-980b-5384de02bc8e"},{"index":19447,"token":false,"name":"Ravenous Intruder","scryfallId":"cd793778-f099-4b8e-af19-fc0ec4292824"},{"index":19448,"token":false,"name":"Cerebral Eruption","scryfallId":"77161159-ee2c-485d-8674-d8590ccc62e1"},{"index":19449,"token":false,"name":"Kjeldoran Gargoyle","scryfallId":"484a4892-fba0-459d-9e72-e82f7e079d78"},{"index":19452,"token":false,"name":"Firemind's Foresight","scryfallId":"555778df-8ed9-4eb3-859b-4246d9e05ee5"},{"index":19453,"token":false,"name":"Powerleech","scryfallId":"ae1d7b09-3a1f-410f-b330-04ae768b0455"},{"index":19456,"token":false,"name":"Dromosaur","scryfallId":"65de0b43-64df-44dc-850c-25f48d6ab53b"},{"index":19467,"token":false,"name":"Finale of Devastation","scryfallId":"09c2da24-2ad7-4c72-944e-84aa919ded67"},{"index":19469,"token":false,"name":"Wei Assassins","scryfallId":"9b448c08-140f-41d6-aed5-ce9b68efafa9"},{"index":19474,"token":false,"name":"Hand of the Praetors","scryfallId":"94ca493e-f09b-4b11-bb47-0562dfc203ca"},{"index":19478,"token":false,"name":"Grassland Crusader","scryfallId":"c129f361-8769-4f9a-9745-eb5d0c085b88"},{"index":19481,"token":false,"name":"Goblin Racketeer","scryfallId":"eac5c565-1553-4be1-a289-6189e07460a0"},{"index":19482,"token":false,"name":"Geier Reach Bandit // Vildin-Pack Alpha","scryfallId":"d728141b-2bb8-4e18-bb28-971b6641cc05"},{"index":19484,"token":false,"name":"Reap","scryfallId":"229f8a3d-d1a5-46d7-9b1b-e165397e6579"},{"index":19487,"token":false,"name":"World at War","scryfallId":"a47a05ad-fe86-481e-b770-e1760be4f852"},{"index":19490,"token":false,"name":"Crime // Punishment","scryfallId":"2edeab08-86eb-4fa8-ba24-23dacb32e0fd"},{"index":19494,"token":false,"name":"Claws of Valakut","scryfallId":"1bd90bc0-93b6-427f-96ad-b303dcc0383f"},{"index":19497,"token":false,"name":"Magus of the Coffers","scryfallId":"cf6b93ea-8ada-404c-9920-7976690c3e8c"},{"index":19503,"token":false,"name":"Mirrormade","scryfallId":"a10c1407-d397-4caa-b7b7-e7d91ffd4ee9"},{"index":19506,"token":false,"name":"Woodlot Crawler","scryfallId":"11f1e6fe-e959-4030-9925-9ccc27040275"},{"index":19509,"token":false,"name":"Fry","scryfallId":"070d7766-a662-443c-93c5-811dbdac2480"},{"index":19511,"token":false,"name":"Merciless Resolve","scryfallId":"356af156-a059-416c-b78b-d9058b742818"},{"index":19514,"token":true,"name":"Thrull Token (B, 0/1)","scryfallId":"b9f3042b-784c-4006-9bf1-60a323e60c5c"},{"index":19515,"token":false,"name":"Cloudkin Seer","scryfallId":"e2111753-a930-403f-9d94-a86dfcb069da"},{"index":19516,"token":false,"name":"Abzan Ascendancy","scryfallId":"63e735b1-7643-48db-9731-aea0212d0e2b"},{"index":19517,"token":true,"name":"Construct Token (Colorless, 6/12)","scryfallId":"8936efa7-c4d0-426d-977b-38c957a9f025"},{"index":19521,"token":false,"name":"Call of the Full Moon","scryfallId":"369d837a-a19b-457c-8146-cc1766a63ec1"},{"index":19524,"token":false,"name":"Mana Cylix","scryfallId":"c6f95767-afda-4d74-bbd4-1b702eeae54b"},{"index":19525,"token":false,"name":"Bala Ged Scorpion","scryfallId":"4acb66bd-6abd-46dd-a272-09bea66e2917"},{"index":19528,"token":false,"name":"Dawn of the Dead","scryfallId":"baabadd3-3fc1-4c9a-ad3b-c79d60fb3390"},{"index":19529,"token":false,"name":"Sydri, Galvanic Genius","scryfallId":"757473a8-b2cc-47be-a39b-809f3e04d3ea"},{"index":19531,"token":false,"name":"Tattermunge Duo","scryfallId":"ac93faba-8b40-48f4-b4eb-7c8677ed07e2"},{"index":19534,"token":false,"name":"Skyclave Plunder","scryfallId":"3ff05312-787e-4e5e-a0d5-8f3fb576fc49"},{"index":19535,"token":false,"name":"Swift Warkite","scryfallId":"f62db9d7-3cc7-49cb-bffc-d2f9c286aa36"},{"index":19537,"token":false,"name":"Eerie Interlude","scryfallId":"4ba9f15f-00d2-4797-9228-91b320e85705"},{"index":19538,"token":false,"name":"Mitotic Manipulation","scryfallId":"2abd4521-62c8-4b2f-a406-a8ddfa8f475a"},{"index":19539,"token":false,"name":"Sewer Rats","scryfallId":"42fe08c3-5024-486c-ba03-19d371ceccb0"},{"index":19542,"token":false,"name":"Fortifying Provisions","scryfallId":"98ce113c-53da-4fab-b7c9-fc3df248b65e"},{"index":19543,"token":false,"name":"Jaspera Sentinel","scryfallId":"1a68615d-9808-479d-aa80-50651246954e"},{"index":19547,"token":false,"name":"Fortified Village","scryfallId":"1ba50dda-9747-4a09-8c43-807d2c856cde"},{"index":19549,"token":true,"name":"Human Warrior Token (R/W, 3/1)","scryfallId":"c994ea90-71f4-403f-9418-2b72cc2de14d"},{"index":19557,"token":false,"name":"Generator Servant","scryfallId":"51d8683f-2195-40ae-9f18-8a10b3c7897c"},{"index":19558,"token":false,"name":"Isareth the Awakener","scryfallId":"f12cefef-19c7-40b9-9bf5-1a03ba9657d0"},{"index":19559,"token":false,"name":"Break Open","scryfallId":"a5ae8050-b644-41db-b1e9-d9bad2173485"},{"index":19560,"token":true,"name":"Soldier Token (R, 1/1)","scryfallId":"509e44d4-72c1-4d68-b942-c3e8de6ed7a8"},{"index":19562,"token":false,"name":"Ruin Grinder","scryfallId":"c82ec87d-5e65-4936-8097-c4bca0fd1d94"},{"index":19563,"token":false,"name":"Flitterstep Eidolon","scryfallId":"9a79cee0-6023-42bc-a934-69b99fd5fb02"},{"index":19566,"token":false,"name":"Vivify","scryfallId":"f8b5e7ed-a0ab-48f6-8f69-56a8bd115007"},{"index":19571,"token":false,"name":"Ivory Guardians","scryfallId":"9bf9cccd-fe97-4632-a90a-9eeb0d41135e"},{"index":19572,"token":false,"name":"Darigaaz Reincarnated","scryfallId":"9459ffca-5a1f-4641-88d4-8a499b261faa"},{"index":19582,"token":false,"name":"Copperhoof Vorrac","scryfallId":"81fff4cc-b2ab-4a41-bede-0d807552ba46"},{"index":19588,"token":false,"name":"Wardscale Dragon","scryfallId":"d4290215-3aec-40b8-aac5-e5c39c035cfe"},{"index":19593,"token":true,"name":"Cat Bird Token (W, 1/1)","scryfallId":"816da759-e224-4960-b2b6-453cadc2faf1"},{"index":19596,"token":false,"name":"Stabilizer","scryfallId":"b72dbe81-96d0-4b0d-97a7-c59345f081e8"},{"index":19602,"token":false,"name":"Liliana, Untouched by Death","scryfallId":"d80c7498-b13c-48a1-bbd6-2ba79190f6b4"},{"index":19604,"token":false,"name":"Tizerus Charger","scryfallId":"2ed4901c-9b1e-4e0e-ae71-81cb10779f07"},{"index":19605,"token":false,"name":"Tuskeri Firewalker","scryfallId":"a54d0170-a375-4e65-b98d-3e94a3aeef90"},{"index":19607,"token":false,"name":"Icequake","scryfallId":"550880ba-26a0-463d-9da2-0160d224cda1"},{"index":19610,"token":false,"name":"Flare","scryfallId":"1bd7755f-7ca5-4948-8baf-976823906891"},{"index":19612,"token":false,"name":"Profaner of the Dead","scryfallId":"87630910-47cc-4347-b126-fd779e7dadc0"},{"index":19613,"token":false,"name":"Foul Familiar","scryfallId":"8bad3541-8e40-4a2f-ac9d-f7b61f3d75a1"},{"index":19616,"token":false,"name":"Throes of Chaos","scryfallId":"6c02cc57-f589-4c5d-b306-cceb0ab3ce8b"},{"index":19617,"token":false,"name":"Sacred Cat","scryfallId":"4c8e85ef-d5ef-4be0-a13f-bd3715d41561"},{"index":19621,"token":false,"name":"Greenwarden of Murasa","scryfallId":"5b03132c-0bb7-48f9-babd-6e106d8f202c"},{"index":19626,"token":false,"name":"Warping Wail","scryfallId":"f2ef4db8-b51c-4f52-84f1-6fee31c4a14c"},{"index":19628,"token":false,"name":"Rush of Knowledge","scryfallId":"65b03b40-671f-4973-8d75-c3fa878ef603"},{"index":19629,"token":false,"name":"Sylvan Brushstrider","scryfallId":"16482e12-7a8d-4999-8438-da227e6d1305"},{"index":19630,"token":false,"name":"Kingfisher","scryfallId":"442bc3ba-00b3-4616-a5b2-55524ff8a736"},{"index":19631,"token":false,"name":"Covenant of Minds","scryfallId":"6ef9a534-8938-4f73-aa62-dd4d81a18cc1"},{"index":19633,"token":false,"name":"Sangrophage","scryfallId":"ab9abc52-76f6-4b1f-8602-2e5abdd23b6b"},{"index":19634,"token":false,"name":"Stitcher's Supplier","scryfallId":"2b737126-50b5-4678-91bf-197b64086fe4"},{"index":19635,"token":false,"name":"Amrou Kithkin","scryfallId":"278d86b4-8d62-4932-a66d-062971295631"},{"index":19639,"token":false,"name":"Leonin Snarecaster","scryfallId":"9745cc70-d6a0-43c5-b8d7-a930d95e94c7"},{"index":19640,"token":false,"name":"Viashino Skeleton","scryfallId":"b9451a62-31a4-4aaf-beef-2bf149f25ae3"},{"index":19642,"token":false,"name":"Frostboil Snarl","scryfallId":"ae79f483-88c5-461c-a7c5-6b898317b1e3"},{"index":19643,"token":false,"name":"Promise of Tomorrow","scryfallId":"b9a307a1-d2b3-481b-92cd-14a2866a022d"},{"index":19645,"token":false,"name":"Rockslide Ambush","scryfallId":"1546ba6b-54ea-45b1-958d-284ba6867af6"},{"index":19646,"token":false,"name":"Beacon of Destruction","scryfallId":"6830b73b-1def-4d34-902d-966ecdbc7717"},{"index":19648,"token":false,"name":"Squall","scryfallId":"2fab5336-a020-4d08-87fd-d2534d98bee1"},{"index":19649,"token":false,"name":"Knight of the Ebon Legion","scryfallId":"41ffac3e-4b7b-423f-b629-6eba108cf327"},{"index":19651,"token":false,"name":"Bazaar Trademage","scryfallId":"9d75faf7-fc27-4fc2-9e80-e35232c42542"},{"index":19654,"token":false,"name":"Sudden Impact","scryfallId":"a6560bb7-28d4-4b5c-bdfa-986a5c114349"},{"index":19655,"token":false,"name":"Harmonic Prodigy","scryfallId":"4290d31a-ce74-4a22-8266-9e44d23d506f"},{"index":19657,"token":false,"name":"Samut, Tyrant Smasher","scryfallId":"197c8c75-3b53-49ab-adb5-32937b49e834"},{"index":19658,"token":false,"name":"Plaza of Harmony","scryfallId":"07f2ae00-206d-4984-84eb-d10ab75d3791"},{"index":19662,"token":false,"name":"Bridge from Below","scryfallId":"52c44610-6d4b-4c14-839f-2c085badec90"},{"index":19663,"token":false,"name":"Barbarian Ring","scryfallId":"1809361e-ae1a-4c47-8464-e6496e94d962"},{"index":19669,"token":false,"name":"Aether Web","scryfallId":"ce9a6af9-1b39-41e1-bd71-210700b7608b"},{"index":19671,"token":false,"name":"Lurking Deadeye","scryfallId":"43925a8d-dd02-4907-929e-c015d678bb49"},{"index":19677,"token":false,"name":"Naya Sojourners","scryfallId":"1a7dcba8-416e-4908-8969-bf5511a117e8"},{"index":19678,"token":false,"name":"Pollenbright Wings","scryfallId":"e190a22c-31d3-4c16-81c2-735e58348df1"},{"index":19681,"token":false,"name":"Jeskai Runemark","scryfallId":"2ada6302-326b-4ab1-a9a3-ae4fa6a9001c"},{"index":19682,"token":false,"name":"Animus of Predation","scryfallId":"e5e8f955-4fa5-4d57-ac77-2a7be95ed4ad"},{"index":19683,"token":false,"name":"Thriving Grove","scryfallId":"79cabbe0-1c44-4888-8ebc-25a4c3e2c5d7"},{"index":19689,"token":false,"name":"Spire Mangler","scryfallId":"a3ce548d-764a-4397-bae3-d348dca78421"},{"index":19691,"token":false,"name":"Dawn Gryff","scryfallId":"42d30894-82b9-4af8-b0bb-48a78acbc4bd"},{"index":19694,"token":false,"name":"Sand Strangler","scryfallId":"31848da0-17a7-490a-a2fc-d2114a88cf66"},{"index":19697,"token":false,"name":"The Abyss","scryfallId":"f11db51c-bbbc-4890-960e-d8a3eacca1e5"},{"index":19700,"token":false,"name":"Plea for Guidance","scryfallId":"1d1d6d76-f399-475a-b5cd-544bd7c6d967"},{"index":19701,"token":false,"name":"Gilt-Leaf Winnower","scryfallId":"fea7fbfc-c17d-4a5b-863e-842d4040200a"},{"index":19702,"token":false,"name":"Psychic Vortex","scryfallId":"3bc2a419-7122-4eeb-bb64-738a647cfd82"},{"index":19704,"token":false,"name":"Ojutai Monument","scryfallId":"8ef29942-a7e3-4e47-9f95-527a5d7e4f1d"},{"index":19708,"token":false,"name":"Naga Eternal","scryfallId":"0f244233-f2e8-48f8-9106-e7cd186efd51"},{"index":19710,"token":false,"name":"Headless Horseman","scryfallId":"d1aa37c8-98fa-4984-b09b-cf65ad84e97b"},{"index":19711,"token":false,"name":"Polar Kraken","scryfallId":"aee01e9c-0445-4228-a73a-3e5744844ed3"},{"index":19716,"token":false,"name":"Dreadhorde Invasion","scryfallId":"04c6e42d-991d-4e6b-a900-38480931f79e"},{"index":19717,"token":false,"name":"Stonehorn Chanter","scryfallId":"cd6ec61b-c039-4526-a359-a7947eeba5c3"},{"index":19719,"token":false,"name":"Vitu-Ghazi, the City-Tree","scryfallId":"afc35026-a29e-4fb0-931f-5e90faf41802"},{"index":19722,"token":false,"name":"Dichotomancy","scryfallId":"61583ead-bccc-44d9-bd1d-2a13511990b5"},{"index":19725,"token":false,"name":"Time of Heroes","scryfallId":"9f70224d-e723-436d-8493-dcec5049f1a0"},{"index":19726,"token":false,"name":"Thalakos Mistfolk","scryfallId":"9e7b5b00-9d14-4090-b8c3-28b70375571e"},{"index":19732,"token":false,"name":"Display of Dominance","scryfallId":"65572ff2-281f-431d-b776-e8231f24d2c6"},{"index":19735,"token":false,"name":"Burst Lightning","scryfallId":"2dc16614-5cf8-444d-a5ae-cac25018af68"},{"index":19736,"token":false,"name":"Energy Storm","scryfallId":"a8628e29-3d20-4601-8693-70524dac3f98"},{"index":19739,"token":false,"name":"Drowsing Tyrannodon","scryfallId":"288b056a-ea80-4fdc-990d-0ee1e9a7bf64"},{"index":19740,"token":false,"name":"Errant Minion","scryfallId":"61648ddb-6efb-43d0-b2b1-418cc957854c"},{"index":19742,"token":false,"name":"Cathar's Shield","scryfallId":"61c18ffa-ffff-4dc4-9db0-d5f183c35e17"},{"index":19744,"token":false,"name":"Urge to Feed","scryfallId":"eed371fb-b23b-41b0-9fa2-4cb1be8b77cc"},{"index":19745,"token":false,"name":"Viridian Scout","scryfallId":"3260a427-b67f-4908-8c56-5c0fab009598"},{"index":19746,"token":false,"name":"Overwhelmed Apprentice","scryfallId":"8659092e-4fe8-42be-ab03-efc99ed37436"},{"index":19747,"token":false,"name":"Captain's Claws","scryfallId":"3acbc14b-89e6-44ef-ae12-e2049adc06b1"},{"index":19749,"token":false,"name":"Morbid Curiosity","scryfallId":"2f26722e-e7fc-4a90-9a5b-cefda096e5fe"},{"index":19751,"token":false,"name":"Dueling Coach","scryfallId":"45b3dbb0-0d68-4351-bfc9-a09c50454bf7"},{"index":19754,"token":false,"name":"Primal Cocoon","scryfallId":"3a75889d-8746-4516-934b-efce9c48dc70"},{"index":19755,"token":false,"name":"Promised Kannushi","scryfallId":"7aac4236-9573-4cff-88d9-711a56da4346"},{"index":19756,"token":false,"name":"Gilanra, Caller of Wirewood","scryfallId":"745d297d-4bb4-40cf-bb9c-99dac04e5069"},{"index":19758,"token":false,"name":"Angelfire Crusader","scryfallId":"a7af8350-9a51-437c-a55e-19f3e07acfa9"},{"index":19760,"token":false,"name":"Hammer of Purphoros","scryfallId":"bdc6e339-55db-48cd-a7cf-87474f4dc63a"},{"index":19763,"token":false,"name":"Predator's Strike","scryfallId":"75e5bcc2-9203-4526-a9a9-fac6fd02a854"},{"index":19767,"token":false,"name":"Introduction to Annihilation","scryfallId":"b0bc4682-bcaf-4f51-be0b-9f2851a16e3b"},{"index":19773,"token":false,"name":"Darkblade Agent","scryfallId":"f0b610c5-61e5-43df-a87b-3eaaa915402b"},{"index":19777,"token":false,"name":"Hesitation","scryfallId":"e3ce5dbc-3597-42e8-859a-cac105c8102e"},{"index":19779,"token":false,"name":"Sabertooth Nishoba","scryfallId":"8338c296-cf3f-41d7-b380-3fb4237cb41c"},{"index":19780,"token":false,"name":"Kaya, Orzhov Usurper","scryfallId":"e360f0de-375e-4ba5-8f0c-0ee630b5b1a3"},{"index":19786,"token":false,"name":"Fuming Effigy","scryfallId":"7ce76a38-fc5f-4e29-ba24-4a877179a62c"},{"index":19789,"token":false,"name":"Inverter of Truth","scryfallId":"33ec3988-9256-4cc4-9cd0-b91dd35e79e3"},{"index":19790,"token":false,"name":"Storm-Kiln Artist","scryfallId":"fa96b8dc-233a-4884-ab84-235cbc7df0b6"},{"index":19794,"token":false,"name":"Oran-Rief Hydra","scryfallId":"ff8c4bff-d37a-44b0-958f-91f4de6745c9"},{"index":19795,"token":false,"name":"Narnam Cobra","scryfallId":"68aa2f07-6b9c-43ef-b30d-82fc69b1c047"},{"index":19797,"token":false,"name":"Glimmervoid","scryfallId":"bad82f93-ed5a-41d2-a737-86f1c7f9512f"},{"index":19799,"token":false,"name":"Muldrotha, the Gravetide","scryfallId":"cf3f12dd-5b96-4eee-bd2d-a221757c24d3"},{"index":19807,"token":false,"name":"Cogworker's Puzzleknot","scryfallId":"4c0401df-6eb4-4eeb-b666-4384b5b739f4"},{"index":19809,"token":false,"name":"Endless Scream","scryfallId":"e9474231-34c5-4563-8a61-fd1bc2693f86"},{"index":19812,"token":true,"name":"Citizen Token (W, 1/1)","scryfallId":"165164e7-5693-4d65-b789-8ed8a222365b"},{"index":19814,"token":false,"name":"Vengeant Vampire","scryfallId":"ffbc33a9-ccca-45c4-a81f-c4805bf3de15"},{"index":19816,"token":false,"name":"Haven of the Spirit Dragon","scryfallId":"9910042e-091f-47da-ad29-8f76c9d3b8c1"},{"index":19817,"token":false,"name":"Keeneye Aven","scryfallId":"1a355c58-cd28-4d2d-9df1-91b4196b01ef"},{"index":19818,"token":false,"name":"Stench of Evil","scryfallId":"4c7065a2-f819-4cbe-b453-a55e904f0461"},{"index":19819,"token":false,"name":"Sidewinder Naga","scryfallId":"c3786d75-1a8a-4917-aa98-6836df1b9145"},{"index":19823,"token":false,"name":"Zodiac Rabbit","scryfallId":"005b9531-3b50-4d13-9ed5-a42d961ab6af"},{"index":19825,"token":false,"name":"Pharika's Cure","scryfallId":"c0efc963-5848-44eb-a654-c08b5bd4501d"},{"index":19831,"token":false,"name":"Veilstone Amulet","scryfallId":"3705d3e4-317e-460d-b16e-e57238a19070"},{"index":19832,"token":false,"name":"Loxodon Lifechanter","scryfallId":"8cc5703a-5b04-4ac7-9f5f-112e439d4870"},{"index":19834,"token":false,"name":"Blazing Effigy","scryfallId":"921011ff-1696-4575-9198-abe993a0ee7a"},{"index":19835,"token":false,"name":"Shimmering Barrier","scryfallId":"2aa7158a-5c00-4969-a116-c40cefdf4591"},{"index":19836,"token":false,"name":"Sandstone Warrior","scryfallId":"0c8a607b-b79a-4dc5-bbf5-f6de556f1c7d"},{"index":19837,"token":true,"name":"Elf Druid Token (G, 1/1)","scryfallId":"01b1f130-2e12-4e57-876b-fc81619ff01f"},{"index":19838,"token":false,"name":"Piranha Marsh","scryfallId":"ea077cff-b5c9-4a40-8e66-8810c37be5cb"},{"index":19839,"token":false,"name":"Havengul Lich","scryfallId":"321077a4-e468-4e74-94f7-80c83790e0d9"},{"index":19840,"token":false,"name":"Aura Barbs","scryfallId":"132af2c2-2bae-4c05-9d61-a5777818a057"},{"index":19841,"token":false,"name":"Soulblade Corrupter","scryfallId":"e81b80d3-d109-4d9e-8576-15f09dc1cbb9"},{"index":19843,"token":false,"name":"Viscid Lemures","scryfallId":"863f04d7-da34-41e3-9153-97891a428889"},{"index":19847,"token":false,"name":"Chandler","scryfallId":"4dd3a8e3-9a90-44f4-996c-57242d3c47a5"},{"index":19848,"token":false,"name":"Rishkar, Peema Renegade","scryfallId":"60c5f5d3-fc82-444e-80c3-dd8ab8bdece4"},{"index":19849,"token":false,"name":"Mordant Dragon","scryfallId":"c8b32069-a707-4a4b-8379-c097d829bb90"},{"index":19850,"token":false,"name":"Woolly Spider","scryfallId":"3f835154-38fd-464c-8015-9eb6b4da00d0"},{"index":19853,"token":false,"name":"Guardian Archon","scryfallId":"c5acd77a-5763-4663-886b-1bfa8a98ef03"},{"index":19855,"token":false,"name":"Llanowar Envoy","scryfallId":"1a667bba-ecf0-4212-8ca3-75d4db6abce2"},{"index":19862,"token":false,"name":"New Frontiers","scryfallId":"fd1f6cfa-9576-4bb8-83db-33c2b147206d"},{"index":19863,"token":false,"name":"Eon Frolicker","scryfallId":"acaec4bf-69c8-43c1-960f-cb5b5bff660a"},{"index":19867,"token":false,"name":"Aethermage's Touch","scryfallId":"2b93eac0-8205-4e52-ad6c-823756f90ab1"},{"index":19871,"token":false,"name":"Skarrgan Hellkite","scryfallId":"be941a2e-4eb0-45b3-9da0-834053907a65"},{"index":19879,"token":false,"name":"Athreos, Shroud-Veiled","scryfallId":"871c19fc-7d99-4022-9e13-d679a9e3547e"},{"index":19881,"token":false,"name":"Devout Monk","scryfallId":"cd1101f5-0bc1-47fa-891b-206b9c1c7f79"},{"index":19887,"token":false,"name":"Kitesail Apprentice","scryfallId":"88e2315e-41d9-4e46-bee4-c8f92e91e2a9"},{"index":19888,"token":true,"name":"Insect Token (G, 6/1)","scryfallId":"0ff2e2bd-b8e9-4563-85ad-fdbb0607fb7c"},{"index":19889,"token":false,"name":"Kavu Chameleon","scryfallId":"df7718fe-0137-4b0d-95cc-f02813f9d970"},{"index":19896,"token":false,"name":"Skyshroud Troll","scryfallId":"b44370ea-b62a-4001-86f0-1fe006005217"},{"index":19899,"token":false,"name":"Armed // Dangerous","scryfallId":"ff7f4fc2-6f76-44e7-a30b-7166a0d10d2a"},{"index":19901,"token":false,"name":"Karmic Justice","scryfallId":"ea141e39-8124-4d72-a154-eb76e71be1dc"},{"index":19903,"token":false,"name":"Heal","scryfallId":"a20676ce-fd87-4a63-9b96-02a26015edc2"},{"index":19907,"token":false,"name":"Inheritance","scryfallId":"9fe88de7-b226-4a43-9662-8b408e4281d3"},{"index":19910,"token":false,"name":"Ezuri, Claw of Progress","scryfallId":"5ce6761c-9af4-4836-bcdf-402e68503593"},{"index":19911,"token":false,"name":"Retribution","scryfallId":"55bacf5b-70d4-45bc-a7e2-44492fa182bc"},{"index":19914,"token":false,"name":"Flower // Flourish","scryfallId":"feb4b39f-d309-49ba-b427-240b7fdc1099"},{"index":19915,"token":false,"name":"Raving Visionary","scryfallId":"347cee3a-6e0e-43c2-85e5-531b19297c3d"},{"index":19923,"token":false,"name":"Tempered Sliver","scryfallId":"69026075-adfa-48b0-b30e-04b0a76904c3"},{"index":19924,"token":false,"name":"Glissa's Scorn","scryfallId":"f11187c1-de35-4e85-87c3-656f978b2d7e"},{"index":19927,"token":false,"name":"Bull-Rush Bruiser","scryfallId":"f0270fed-4591-4111-a95f-91d4a0ab0d14"},{"index":19936,"token":false,"name":"Waxing Moon","scryfallId":"617f9f3a-61a1-4c73-8efe-3d74fe362901"},{"index":19937,"token":false,"name":"Solarion","scryfallId":"9070dd3e-7600-493e-84b9-931ac92f44bc"},{"index":19939,"token":false,"name":"God-Eternal Rhonas","scryfallId":"0eb444f0-69cc-47c8-8cd6-1f9edad5d903"},{"index":19940,"token":false,"name":"Lionheart Maverick","scryfallId":"704ba6ce-5d28-417b-8574-d3c097e6e39f"},{"index":19941,"token":false,"name":"Royal Herbalist","scryfallId":"027e03e1-1a39-47ba-b206-44d022b4c346"},{"index":19944,"token":false,"name":"An-Havva Township","scryfallId":"9afac347-4316-43e2-848b-e474ed563af6"},{"index":19945,"token":false,"name":"Surge Node","scryfallId":"743fc231-2ab3-42f1-9dd3-af42241229aa"},{"index":19946,"token":false,"name":"Aethersnatch","scryfallId":"0ce562a9-ca35-4f31-8618-bc26d3d40169"},{"index":19951,"token":false,"name":"Twisted Justice","scryfallId":"d8efa02d-c301-47e1-8cdf-26ff9e97a243"},{"index":19954,"token":false,"name":"Flametongue Yearling","scryfallId":"33ab05b5-d6f5-439c-9aed-1a58ceb282ad"},{"index":19957,"token":false,"name":"Seton's Desire","scryfallId":"70d05b6a-5c7e-4e08-88d3-98f2b5b054bc"},{"index":19958,"token":false,"name":"Brown Ouphe","scryfallId":"e26ce35b-ba65-451d-a5ed-e1db6f1d0c6f"},{"index":19962,"token":false,"name":"Niall Silvain","scryfallId":"9d5911b5-a54e-4ebb-9c36-d4dc8e97bb4b"},{"index":19963,"token":false,"name":"Force Away","scryfallId":"dda70b3e-4b70-404e-a579-41dd126be084"},{"index":19967,"token":false,"name":"Great Hart","scryfallId":"70cd7d2b-e9c4-4900-89a0-f6eb0c6cb22b"},{"index":19968,"token":false,"name":"Shore Keeper","scryfallId":"135d1145-8640-44e1-8079-45832fa2556d"},{"index":19969,"token":false,"name":"Enfeeblement","scryfallId":"4adaf0bf-b26d-4166-8809-431283690de7"},{"index":19971,"token":false,"name":"Tangle Kelp","scryfallId":"497bc42d-ab81-4d84-bdf7-e3a05a7c984d"},{"index":19977,"token":false,"name":"Exorcist","scryfallId":"f3e37705-341e-4c13-9adf-c798e8ed490f"},{"index":19978,"token":false,"name":"Blood Vassal","scryfallId":"7e692dea-750b-40b2-9440-8b570e67c23e"},{"index":19982,"token":false,"name":"Sphinx's Disciple","scryfallId":"ba33f00d-dbed-4bfb-a295-90f729be98de"},{"index":19983,"token":false,"name":"Predatory Urge","scryfallId":"d7f8adaa-2852-4e9c-b91d-ce80a21859c9"},{"index":19986,"token":false,"name":"Woodland Champion","scryfallId":"250f5303-428a-478c-9bd5-2410f7fcc4dd"},{"index":19989,"token":false,"name":"Wargate","scryfallId":"ac44861f-cf42-424a-a607-a6c7a4df5c9b"},{"index":19991,"token":false,"name":"Valakut Invoker","scryfallId":"7e142dd7-feb9-437a-904b-130c4fede48e"},{"index":19992,"token":false,"name":"Thallid Germinator","scryfallId":"951473f8-6925-4fe4-8595-ad4886282330"},{"index":19993,"token":false,"name":"Chameleon Colossus","scryfallId":"5b966758-2377-4fce-a942-217d0869de80"},{"index":19997,"token":false,"name":"Chulane, Teller of Tales","scryfallId":"83f43730-1c1f-4150-8771-d901c54bedc4"},{"index":19998,"token":false,"name":"Barrier Breach","scryfallId":"822f8403-77a7-4e75-88af-60d604632f5d"},{"index":20002,"token":false,"name":"Healing Leaves","scryfallId":"d6f58258-a1bd-4364-954e-c39938f7dab2"},{"index":20003,"token":false,"name":"League Guildmage","scryfallId":"7439118d-4869-486e-8930-6e00db2634b2"},{"index":20004,"token":false,"name":"Felidar Cub","scryfallId":"ea76a183-e15c-4968-b29d-91c074aa8681"},{"index":20005,"token":false,"name":"Forced Retreat","scryfallId":"9753d211-3436-4a9b-86d9-54a541770ec2"},{"index":20008,"token":false,"name":"Divine Reckoning","scryfallId":"8ac97124-eac7-49f9-b221-301a59d2c360"},{"index":20009,"token":false,"name":"Kazuul's Fury // Kazuul's Cliffs","scryfallId":"75240bbc-adc7-48ff-9523-c79776d710d3"},{"index":20011,"token":false,"name":"Lapis Lazuli Talisman","scryfallId":"ce00bb19-983e-427d-be54-ae6daf0ccdde"},{"index":20015,"token":false,"name":"Mindculling","scryfallId":"6faf4372-6fb5-48aa-9b94-b0e77c867116"},{"index":20016,"token":false,"name":"Dragonlord Atarka","scryfallId":"d5915956-7900-47bb-b6e5-403d64e0d0c1"},{"index":20020,"token":false,"name":"Grist, the Hunger Tide","scryfallId":"808a3770-057a-4985-ba5c-870d7b1cd527"},{"index":20021,"token":false,"name":"Silverstrike","scryfallId":"0f27b92a-cde9-41bc-9b23-d83b74b167d4"},{"index":20027,"token":false,"name":"Sky Skiff","scryfallId":"cf4a4939-130b-40d7-8a0f-e31eb931d2d5"},{"index":20029,"token":false,"name":"Crossbow Ambush","scryfallId":"283146fd-2307-4019-b23d-7fb1893dc46c"},{"index":20031,"token":false,"name":"Avacynian Missionaries // Lunarch Inquisitors","scryfallId":"1001e708-e4f9-456a-8b9d-3421a2a3833d"},{"index":20035,"token":false,"name":"Exotic Disease","scryfallId":"4e9624e5-79a2-41de-997b-12d871d4be66"},{"index":20041,"token":false,"name":"Marchesa's Smuggler","scryfallId":"ff3a2dc1-3549-4a92-a5fa-6297cb894d22"},{"index":20047,"token":false,"name":"Radiant, Archangel","scryfallId":"99509da7-3e11-4c38-804b-286ce572f36e"},{"index":20048,"token":false,"name":"Cloud Djinn","scryfallId":"ed6e3741-6247-4180-8e79-2759af7f70df"},{"index":20050,"token":false,"name":"Onyx Goblet","scryfallId":"3686eb57-e9c8-480f-8ab4-2894e1b5fe20"},{"index":20053,"token":false,"name":"Victorious Destruction","scryfallId":"7b81cb30-e9f8-41f3-a10b-26e0ba2503aa"},{"index":20055,"token":false,"name":"Magister of Worth","scryfallId":"c38dd57c-1b48-4c76-8bfd-90c6096b4f4d"},{"index":20057,"token":false,"name":"Hateflayer","scryfallId":"38c26ba3-e325-433b-b653-4e80e737b54d"},{"index":20058,"token":true,"name":"Weird Token (R/U, */*)","scryfallId":"2a0d9c67-69ee-48c4-af4c-18cc3c2ef3cd"},{"index":20060,"token":false,"name":"Flame Sweep","scryfallId":"8e489d6c-2eb2-4914-ae71-c9da55b51d0b"},{"index":20061,"token":false,"name":"Thalakos Dreamsower","scryfallId":"d725cdc0-3a85-4722-bb13-40c336f511b6"},{"index":20066,"token":false,"name":"Ghost Ship","scryfallId":"665d9226-0457-4b35-89aa-18e9f54fc3c6"},{"index":20067,"token":false,"name":"Inquisitor Exarch","scryfallId":"49e241a0-a027-494b-8187-6ecb006d1d33"},{"index":20069,"token":false,"name":"Rubinia Soulsinger","scryfallId":"c87cecd6-ea9d-4515-890c-262bb15e9f37"},{"index":20071,"token":false,"name":"Thelonite Druid","scryfallId":"cd8772dd-513d-4dd0-a5db-5214dc8da4e0"},{"index":20073,"token":false,"name":"Grave Bramble","scryfallId":"8be1d4d2-5215-44b2-9b67-627d088efdb5"},{"index":20075,"token":false,"name":"Chatter of the Squirrel","scryfallId":"84273844-7fab-4ff7-afb3-c82153132daf"},{"index":20076,"token":false,"name":"Invigorating Boon","scryfallId":"c46f324b-63c6-4fb5-a80a-e9da51c3eb77"},{"index":20078,"token":false,"name":"Endless Whispers","scryfallId":"266323da-9528-462e-a0a8-6ef2dda5f1ee"},{"index":20083,"token":false,"name":"Faceless Haven","scryfallId":"3a377a2a-4f79-4ea5-9ce2-4677ba6df081"},{"index":20085,"token":false,"name":"Pyromancer's Goggles","scryfallId":"0f92d8df-e913-4a95-9f65-4fe98c332a6e"},{"index":20086,"token":false,"name":"Chakram Slinger","scryfallId":"9c5f7446-836d-4df1-91b9-f3a47d1f640e"},{"index":20087,"token":false,"name":"Devout Invocation","scryfallId":"8a286954-fb40-4440-9f0e-a28367c6823c"},{"index":20089,"token":false,"name":"Test of Faith","scryfallId":"67ba07ca-7be4-400e-a104-f7bbd527b6b4"},{"index":20092,"token":false,"name":"Skullmulcher","scryfallId":"b5178576-573d-4da8-97ae-a684e1e95fa4"},{"index":20094,"token":false,"name":"Bind the Monster","scryfallId":"080be8d1-e453-4250-b917-f0eb26644895"},{"index":20101,"token":false,"name":"Saltskitter","scryfallId":"823bdf79-998f-4d7c-834d-7a474cfa895e"},{"index":20102,"token":false,"name":"Fractured Sanity","scryfallId":"413ac8fb-5156-4f90-81f5-1879e273c9e2"},{"index":20104,"token":false,"name":"Stonehands","scryfallId":"888746d8-6322-4554-8acb-ce88eba55c51"},{"index":20105,"token":false,"name":"Hellkite Whelp","scryfallId":"65e902e8-bbd5-40fe-a655-45d3d3bc9fde"},{"index":20107,"token":false,"name":"Reinforced Bulwark","scryfallId":"437a91e7-f98e-4ed8-9ab7-f4db62979f5b"},{"index":20110,"token":false,"name":"Anurid Brushhopper","scryfallId":"097c7637-ab37-4d99-9828-d53bdd849924"},{"index":20111,"token":false,"name":"Palace Sentinels","scryfallId":"acc773ab-bf78-4cef-abab-b1a8ca76e252"},{"index":20112,"token":false,"name":"Righteous Charge","scryfallId":"f1bde9d5-953f-4e8d-9a24-6185cef0a304"},{"index":20117,"token":false,"name":"Night Market Lookout","scryfallId":"4edb03b7-e5a2-4ba1-b0ec-bfbfeaa94efd"},{"index":20118,"token":false,"name":"Touch of the Void","scryfallId":"006ead4a-dc57-4856-8e13-235ba55483e6"},{"index":20122,"token":false,"name":"Shattered Crypt","scryfallId":"117df45d-4500-459b-96b5-ca41952580c1"},{"index":20125,"token":false,"name":"Breath of Malfegor","scryfallId":"7a12e4d0-8471-46ac-85e4-a2ea5be8bf8f"},{"index":20127,"token":false,"name":"Kazandu Mammoth // Kazandu Valley","scryfallId":"37002423-4984-45d2-8aa7-b1816fef6e91"},{"index":20128,"token":false,"name":"Otherworldly Outburst","scryfallId":"34409e34-04e9-4279-8d21-6ef362b20b72"},{"index":20132,"token":false,"name":"Brokkos, Apex of Forever","scryfallId":"c9f07625-fbd8-4581-8568-eb3cfb2a4c1e"},{"index":20134,"token":false,"name":"Bloodcurdling Scream","scryfallId":"dcb0ec62-6d6f-4d10-bc2d-37f25495f884"},{"index":20135,"token":false,"name":"Kor Sanctifiers","scryfallId":"038b04fe-d77a-4192-a084-654ef39aa9ff"},{"index":20139,"token":false,"name":"Diminish","scryfallId":"9d468111-f7af-4ea2-a250-cd8c15ba60cc"},{"index":20144,"token":false,"name":"Phyrexian Driver","scryfallId":"efeef7f3-5b87-440d-a851-95ae2bdb840d"},{"index":20148,"token":false,"name":"Soul Scourge","scryfallId":"4aa7d91b-cfbb-4da0-97fa-3c0a15f1dbb9"},{"index":20149,"token":false,"name":"Nemesis of Mortals","scryfallId":"c4010889-1d7a-4db3-a27c-c39baa024765"},{"index":20150,"token":true,"name":"Oketra's Attendant Token (W, 3/3)","scryfallId":"aa5fedcd-e5d5-4250-b64e-a04772cb9025"},{"index":20151,"token":false,"name":"Moggcatcher","scryfallId":"9ba582d7-1dce-4664-8bd9-6b419596788c"},{"index":20152,"token":false,"name":"Airdrop Aeronauts","scryfallId":"49827a57-cf10-4a44-a1fd-ac611da39dc9"},{"index":20157,"token":false,"name":"Charging Binox","scryfallId":"68222ab7-7b9c-43e5-b80e-db643d80a6d9"},{"index":20158,"token":false,"name":"Mythos of Brokkos","scryfallId":"fa4fc5b1-6666-4c60-898f-f927212c7923"},{"index":20161,"token":false,"name":"Krark-Clan Stoker","scryfallId":"a90da818-ffa1-435d-8734-fc7a1330d323"},{"index":20164,"token":false,"name":"Masterful Replication","scryfallId":"63832647-bb4d-4380-8acb-cf11e8727672"},{"index":20166,"token":false,"name":"Porcelain Legionnaire","scryfallId":"2616aa0e-8413-4e63-877c-bffd5263f552"},{"index":20173,"token":false,"name":"Grinning Totem","scryfallId":"f3558ddf-2bc6-4870-bd24-2467d870ffe5"},{"index":20174,"token":false,"name":"Vesper Ghoul","scryfallId":"669efa40-be9a-4475-9bcb-3325518403b5"},{"index":20176,"token":false,"name":"Cleansing Wildfire","scryfallId":"492d77e5-acc6-41b8-8930-f39d69234919"},{"index":20178,"token":false,"name":"Veinfire Borderpost","scryfallId":"75ad0cc1-66bd-43c3-a296-c36cf9a64e85"},{"index":20181,"token":false,"name":"Reviving Vapors","scryfallId":"47a23c32-e122-400b-b252-e636ea2e684b"},{"index":20185,"token":false,"name":"Unholy Citadel","scryfallId":"9de534ff-fb48-4692-bd0f-dd237ca28502"},{"index":20192,"token":false,"name":"Tallowisp","scryfallId":"a018aa51-d75e-4d94-b4b3-0cd14fc87d44"},{"index":20193,"token":false,"name":"Auriok Replica","scryfallId":"02745a0a-9872-4c30-a25d-61695c5fa9cc"},{"index":20194,"token":false,"name":"Swans of Bryn Argoll","scryfallId":"a8903e1d-e255-4eda-bb8e-c6229a88c8a7"},{"index":20200,"token":false,"name":"Ricochet Trap","scryfallId":"5d782375-9192-4ed0-bd79-f3404e5a1b01"},{"index":20201,"token":false,"name":"Merciless Executioner","scryfallId":"7c588d7a-e352-40a0-9fc7-55c7b4bfd013"},{"index":20203,"token":false,"name":"Impact Resonance","scryfallId":"cd1742a6-adbd-4fbe-82c7-fe3589623d14"},{"index":20204,"token":false,"name":"Aether Adept","scryfallId":"fa6f04ca-cab7-4c86-a56c-79d6ae3b73e6"},{"index":20207,"token":false,"name":"Weathered Bodyguards","scryfallId":"991a18e5-a183-4b84-b157-5a3609b3f910"},{"index":20209,"token":false,"name":"Captivating Glance","scryfallId":"642be353-a46a-4d14-a35a-7716fd552870"},{"index":20211,"token":false,"name":"Anointed Procession","scryfallId":"a425c968-933f-4284-a971-919047b00fd2"},{"index":20213,"token":false,"name":"Reduce // Rubble","scryfallId":"d2f3035c-ca27-40f3-ad73-c4e54bb2bcd7"},{"index":20215,"token":false,"name":"Symbiotic Elf","scryfallId":"8e552d26-d203-4040-ba11-d01d65f038a4"},{"index":20217,"token":false,"name":"Ray of Dissolution","scryfallId":"b55c31d1-6b05-4ea1-a444-51ad57ebcfa0"},{"index":20219,"token":false,"name":"Snowblind","scryfallId":"5f62c376-487a-42bc-bd85-ab8b0480f7dc"},{"index":20221,"token":false,"name":"Jeskai Ascendancy","scryfallId":"a29161fc-b8a2-498e-a949-5fdf9c37e90d"},{"index":20223,"token":false,"name":"Ur-Golem's Eye","scryfallId":"50700965-7fac-4351-8967-8eafe5d68aff"},{"index":20227,"token":false,"name":"Prizefighter Construct","scryfallId":"8e389c92-b54b-46b3-a7ab-b8a5a2a7d380"},{"index":20231,"token":false,"name":"Bastion Inventor","scryfallId":"7b6fa167-9f2f-4889-8715-11ed20c4cc94"},{"index":20236,"token":false,"name":"Glimmering Angel","scryfallId":"f14f55e4-eded-4a86-87f4-b8fa6f30bc0f"},{"index":20237,"token":false,"name":"Gargadon","scryfallId":"88167b74-c25f-4a9b-a4f5-33a51e01d498"},{"index":20245,"token":false,"name":"Kaseto, Orochi Archmage","scryfallId":"a65bd1e5-0d02-474d-b93d-02fec9723e2f"},{"index":20246,"token":false,"name":"Brood Sliver","scryfallId":"33803c12-1d78-49fe-a3a3-7f47c60a96b6"},{"index":20252,"token":false,"name":"Font of Mythos","scryfallId":"72859ec4-718e-4acb-9923-d607e77f525a"},{"index":20254,"token":false,"name":"Gossamer Chains","scryfallId":"e9917a29-c6b4-4e0a-a301-21868bd27e17"},{"index":20263,"token":false,"name":"Lightning Reaver","scryfallId":"24a0860d-d3b9-4a00-a8cb-617bc317b93d"},{"index":20264,"token":false,"name":"Elusive Krasis","scryfallId":"dd62e422-e5e2-4736-9ed3-d2dc693f6f8f"},{"index":20267,"token":false,"name":"Shattering Blow","scryfallId":"a77058d9-d2b5-424a-bfe2-070b754051cb"},{"index":20268,"token":false,"name":"Falkenrath Reaver","scryfallId":"cd2023b3-5999-44b1-a67f-3f2a76cb2d14"},{"index":20272,"token":false,"name":"Smoldering Spires","scryfallId":"ad1b05db-4475-49cd-99a3-5e5640c6da9b"},{"index":20276,"token":false,"name":"Crocodile of the Crossing","scryfallId":"2f64ca9c-99c4-45d4-bd21-3ede61702250"},{"index":20279,"token":false,"name":"Survivors' Encampment","scryfallId":"c7b0404e-0f42-456b-91ce-f960195c4951"},{"index":20285,"token":false,"name":"Student of Ojutai","scryfallId":"3d06616c-a0df-4d2d-8bfc-9f59060d323b"},{"index":20286,"token":false,"name":"Momentum","scryfallId":"10bd11a2-7cab-4d3f-b52b-f5bb66fbbec6"},{"index":20289,"token":false,"name":"Drownyard Behemoth","scryfallId":"082690e8-07b9-4a91-b779-e0123a69ee12"},{"index":20292,"token":false,"name":"Worms of the Earth","scryfallId":"65a97821-ca5b-46fb-af08-86de81d0daac"},{"index":20293,"token":false,"name":"Galvanic Alchemist","scryfallId":"b0e24d65-0e6f-4978-8de1-c5e4acac12fb"},{"index":20302,"token":false,"name":"Cloudheath Drake","scryfallId":"7f71ec76-47e1-4f55-bc57-e7b1c88baedd"},{"index":20307,"token":false,"name":"Demonspine Whip","scryfallId":"ff5a4434-0d5e-4ba8-8d10-cba9b4db5713"},{"index":20313,"token":false,"name":"Forging the Tyrite Sword","scryfallId":"3ce46100-461d-424e-afa4-7a0bb7d0a822"},{"index":20315,"token":false,"name":"Lost Auramancers","scryfallId":"c0595c72-5b32-4d7b-8efc-7ce5c83504dd"},{"index":20323,"token":false,"name":"Marauder's Axe","scryfallId":"49d8aa8a-3e87-42ac-9c79-2baec771c1ef"},{"index":20326,"token":false,"name":"Tidehollow Strix","scryfallId":"41dd3af0-ff18-42de-89ed-6feb8383eff0"},{"index":20327,"token":false,"name":"Creeping Dread","scryfallId":"8b3376c4-369a-4d63-bd48-966bcfb0c9b9"},{"index":20333,"token":false,"name":"Indatha Crystal","scryfallId":"bdace59f-f025-4717-8eb4-3d1e13b31d2b"},{"index":20337,"token":false,"name":"Thantis, the Warweaver","scryfallId":"91c54ac0-0edc-406f-8a22-f2996f604f36"},{"index":20341,"token":true,"name":"Storm Crow Token (U, 1/2)","scryfallId":"80165be4-c6c8-4b22-b259-c64eb4b7fc95"},{"index":20343,"token":false,"name":"Encase in Ice","scryfallId":"bcad5bd9-3236-48d4-920f-c3ed12d5f329"},{"index":20345,"token":false,"name":"Thallid Soothsayer","scryfallId":"204173b6-ae51-49ca-bd67-0703e882bf9e"},{"index":20348,"token":false,"name":"Null Brooch","scryfallId":"d5d5a0c6-916c-428a-ae66-8adc8844e56e"},{"index":20349,"token":false,"name":"Pegasus Stampede","scryfallId":"a5301a1b-5fa1-4311-a515-ff1b64c98945"},{"index":20350,"token":false,"name":"Pontiff of Blight","scryfallId":"4b05a4a4-2b5b-4f3d-a315-9e1512569d5e"},{"index":20354,"token":false,"name":"Liliana's Standard Bearer","scryfallId":"a13215b4-b7c0-4919-b653-efd195e016bc"},{"index":20355,"token":false,"name":"Ixidor's Will","scryfallId":"1b713448-853a-41ee-a302-963e9c1c1c65"},{"index":20356,"token":false,"name":"Brood of Cockroaches","scryfallId":"30b6150e-7d0c-4361-b99b-79de96dfc53a"},{"index":20358,"token":false,"name":"Jhessian Zombies","scryfallId":"82afe98a-1b57-4fe4-8c8c-c8995c313410"},{"index":20360,"token":true,"name":"Spirit Warrior Token (B/G, */*)","scryfallId":"febc7ce0-387f-413c-a387-2952b990ff3f"},{"index":20363,"token":false,"name":"Akoum Hellkite","scryfallId":"a96d1704-b554-4662-9974-92f99adb9450"},{"index":20366,"token":false,"name":"Huntmaster Liger","scryfallId":"058d6a7d-12b0-4d82-a5bd-91fa44bbc5e1"},{"index":20370,"token":false,"name":"Incarnation Technique","scryfallId":"43cabf97-0e52-43ac-9ecf-049456b83a7c"},{"index":20373,"token":false,"name":"Paragon of the Amesha","scryfallId":"d21c4772-fa03-4b71-a95e-1ad8466d25da"},{"index":20377,"token":false,"name":"Foriysian Brigade","scryfallId":"0d11b6ef-3a24-4709-a62f-c5e062a6cee1"},{"index":20379,"token":false,"name":"Flight Spellbomb","scryfallId":"0fa09e06-08fd-4ecd-83fe-f0e0856547a5"},{"index":20381,"token":false,"name":"Scoria Cat","scryfallId":"784badd7-9803-49b8-a675-aa34dcf267d6"},{"index":20382,"token":false,"name":"Uncovered Clues","scryfallId":"9dd24556-994f-4480-835e-11d4443f0700"},{"index":20384,"token":false,"name":"Revel in Riches","scryfallId":"b004a88d-2fd6-44dd-9f40-2bf8012fc959"},{"index":20386,"token":true,"name":"Bat Token (B, 1/1)","scryfallId":"8450021c-61be-4b2a-ac05-c51a4f71e701"},{"index":20388,"token":false,"name":"Bringer of the Green Dawn","scryfallId":"bc208f3e-5a6a-4fae-8a7c-2bed28ad0c41"},{"index":20390,"token":false,"name":"Mystic Reflection","scryfallId":"302580e6-b639-40a3-9754-4f5cfc98a9a1"},{"index":20394,"token":false,"name":"Salvage Titan","scryfallId":"7175febd-ae8e-4945-91ab-b6c67c40f04b"},{"index":20395,"token":false,"name":"Sliptide Serpent","scryfallId":"f8647649-5669-46c4-8840-9ff967fabd99"},{"index":20396,"token":false,"name":"Floating-Dream Zubera","scryfallId":"63ea55a8-6c21-4cc1-a2c4-86cd60cddced"},{"index":20398,"token":false,"name":"Narstad Scrapper","scryfallId":"f808ed9b-95ac-4069-bdca-b100bc816b5b"},{"index":20399,"token":false,"name":"Curse of the Swine","scryfallId":"78831fc6-ea90-4546-b46a-9c192dbefc65"},{"index":20401,"token":false,"name":"Stoic Champion","scryfallId":"cd693780-85df-4cea-be03-43c1d80ab740"},{"index":20404,"token":false,"name":"Shanna, Sisay's Legacy","scryfallId":"2c86aae8-08bb-4acc-b39b-10e5b2ac40d9"},{"index":20406,"token":false,"name":"Merfolk Sovereign","scryfallId":"0b1a55bc-7a62-4d0f-9885-db98e4324ff7"},{"index":20407,"token":false,"name":"Soulfire Eruption","scryfallId":"6532b62a-3cc3-44ed-8eac-eaa091be3cee"},{"index":20409,"token":false,"name":"Said // Done","scryfallId":"43ab3ed2-2b50-4488-a21f-60965222970a"},{"index":20412,"token":false,"name":"Kemba, Kha Regent","scryfallId":"1964ca48-3260-4e2d-9014-984c1efc9a43"},{"index":20414,"token":false,"name":"Destructive Urge","scryfallId":"479645b3-54af-4fbf-928e-2224540fe892"},{"index":20419,"token":true,"name":"Stoneforged Blade","scryfallId":"59a00cac-53ae-46ad-8468-e6d1db40b266"},{"index":20421,"token":false,"name":"Weight of the Underworld","scryfallId":"839dcbcb-1061-4cba-a2f7-e7b01531c6a0"},{"index":20423,"token":false,"name":"Rally","scryfallId":"e1e9f80e-5d75-45b7-9c66-c0f30996f4dc"},{"index":20425,"token":false,"name":"Dragonlord Silumgar","scryfallId":"2eae504d-d4a9-440f-8ceb-df967cc50494"},{"index":20427,"token":false,"name":"Emberwilde Djinn","scryfallId":"c9e8c9f5-61dd-4dcc-bd40-8f366374ea18"},{"index":20428,"token":false,"name":"Thalakos Scout","scryfallId":"1703fe9d-ca70-4e8a-9d6a-6173a17d0f04"},{"index":20431,"token":false,"name":"Scrapheap Scrounger","scryfallId":"216a8e4e-ea7b-41c7-a982-b5751025ff25"},{"index":20432,"token":false,"name":"Rhonas the Indomitable","scryfallId":"50f23c47-278c-4188-8fb4-ae20a0c423c5"},{"index":20433,"token":false,"name":"Striped Riverwinder","scryfallId":"4466da89-7380-4fad-9304-7b580c577975"},{"index":20436,"token":false,"name":"Gobbling Ooze","scryfallId":"465d8a63-0ced-4aec-be34-2098b72c8af6"},{"index":20440,"token":false,"name":"Legion's Initiative","scryfallId":"672051a6-d232-4546-842a-369d412c38d2"},{"index":20444,"token":false,"name":"Champion's Helm","scryfallId":"dcad6846-0b35-4193-b647-16e597357f9b"},{"index":20445,"token":false,"name":"Sword-Point Diplomacy","scryfallId":"23f069ff-23ee-4c35-a942-d4f2893f1897"},{"index":20447,"token":false,"name":"Vengeful Archon","scryfallId":"a505d07f-61cf-4b00-a1d5-028747899eaa"},{"index":20451,"token":true,"name":"Shrieking Titan Head Token (Colorless, 0/8)","scryfallId":"44ef6754-b611-4e52-a04b-dc2c794d2cb8"},{"index":20452,"token":false,"name":"Chimeric Idol","scryfallId":"063990db-559d-4bfa-83af-b73fdc4cb038"},{"index":20453,"token":false,"name":"Scrap Mastery","scryfallId":"03436927-eedc-48cf-820d-54cef4360f13"},{"index":20455,"token":false,"name":"Wei Night Raiders","scryfallId":"f5a0292e-ecf4-42df-8abf-f4479f8ad6cb"},{"index":20460,"token":false,"name":"Bloodbond March","scryfallId":"fb977f5b-2202-43c1-a8c0-7fba8c093fa2"},{"index":20465,"token":false,"name":"Teleportal","scryfallId":"b8322a64-f1a0-49c6-ad59-2b803598f7d1"},{"index":20472,"token":false,"name":"Silhana Starfletcher","scryfallId":"fa9c7e09-8384-4866-af92-ba56bd307d9c"},{"index":20473,"token":false,"name":"Embalmer's Tools","scryfallId":"7c044f47-7435-4cb4-b4ad-48bb146daa9f"},{"index":20474,"token":false,"name":"Treachery","scryfallId":"613694aa-b169-400d-8063-2b83d8303611"},{"index":20475,"token":false,"name":"Fortune's Favor","scryfallId":"6a67dd08-0064-4750-adf5-07bacb0296eb"},{"index":20480,"token":false,"name":"Deepwood Denizen","scryfallId":"333f02f7-3b8a-41e3-9ae5-2151539e64ad"},{"index":20481,"token":false,"name":"Reaper of Sheoldred","scryfallId":"a300a645-aec6-4cda-8c11-1e8a6af056ff"},{"index":20482,"token":false,"name":"Theoretical Duplication","scryfallId":"1575a14e-fa70-44f0-8384-95cb90031337"},{"index":20483,"token":false,"name":"Horobi's Whisper","scryfallId":"f16e029c-cf98-4c98-b394-923247579ee5"},{"index":20485,"token":false,"name":"Echoing Courage","scryfallId":"d005fe70-5d6a-4878-a805-0b5d01379581"},{"index":20486,"token":false,"name":"Excavation Elephant","scryfallId":"ec277255-9ba1-4fee-aeb8-b41f2c94e7ac"},{"index":20488,"token":false,"name":"Igneous Elemental","scryfallId":"974bf524-5322-4287-ac49-face12655874"},{"index":20489,"token":true,"name":"Drake Token (G/U, 2/2)","scryfallId":"c06d2c07-7d3e-46e3-86f0-7ceba3b0aee0"},{"index":20496,"token":false,"name":"Trusty Machete","scryfallId":"c8df2abd-d7b7-4746-b8cf-7d3dedb5d349"},{"index":20497,"token":false,"name":"Wu Longbowman","scryfallId":"87134379-273b-48dd-9f05-3d35f5659fb7"},{"index":20500,"token":false,"name":"Gruesome Menagerie","scryfallId":"73c0e4d9-bf0d-4e28-a647-9010701a915e"},{"index":20502,"token":false,"name":"Boros Guildmage","scryfallId":"072a1ff1-9c50-426a-a83c-817bde5beab7"},{"index":20504,"token":false,"name":"Kruphix, God of Horizons","scryfallId":"27427233-da58-45af-ade8-e0727929efaa"},{"index":20506,"token":false,"name":"Feral Animist","scryfallId":"ad65c721-b601-46f9-ba0b-ac4d96567cee"},{"index":20507,"token":false,"name":"Breathless Knight","scryfallId":"c4785739-821d-49b0-a298-3c2b95e16972"},{"index":20508,"token":false,"name":"Evolution Vat","scryfallId":"4ed874e4-87ca-41f0-af0a-a803194d78c9"},{"index":20510,"token":false,"name":"Ramirez DePietro","scryfallId":"c9890742-f1cb-41fd-bf14-297b3ca88b93"},{"index":20514,"token":false,"name":"Vampiric Fury","scryfallId":"de4fd254-0ae9-498d-b9da-4fb3d6a1a55c"},{"index":20515,"token":false,"name":"Telim'Tor's Edict","scryfallId":"088a60f0-2224-4e00-a06a-1d376c8d82a4"},{"index":20519,"token":false,"name":"Eldrazi Devastator","scryfallId":"04b13e32-01b9-4a86-a3df-ca8b784c6a6c"},{"index":20521,"token":false,"name":"Viper's Kiss","scryfallId":"0906ebfc-4756-4caf-83ff-859e181f3bef"},{"index":20522,"token":false,"name":"Fog Elemental","scryfallId":"868ea140-dced-444b-bae5-3e79a9b4bc0d"},{"index":20523,"token":false,"name":"Scepter of Insight","scryfallId":"8ac51021-e66c-4cd1-b54f-031b69d9699f"},{"index":20526,"token":false,"name":"Thorn Lieutenant","scryfallId":"a7a41a54-5b56-472b-8910-1c669603a16e"},{"index":20529,"token":false,"name":"Natural Selection","scryfallId":"315a6bfb-5417-465f-97d9-e157f5c3cf79"},{"index":20537,"token":false,"name":"Stolen Grain","scryfallId":"1865c8f3-3dbb-4d50-bca8-5b289613c157"},{"index":20539,"token":false,"name":"Doorkeeper","scryfallId":"a8990408-6180-423a-9f60-64f5997d4a16"},{"index":20542,"token":false,"name":"Inviolability","scryfallId":"9ece8504-389a-43e3-b178-7067722c4b75"},{"index":20547,"token":true,"name":"Vampire Token (B, 1/1)","scryfallId":"5d328599-b5c8-4cf7-9d62-fe8492e02f48"},{"index":20548,"token":false,"name":"Willbreaker","scryfallId":"7d68fee8-173f-43b5-92a3-37ecbc8b62df"},{"index":20550,"token":false,"name":"Surveyor's Scope","scryfallId":"07a2e39d-037a-464e-9102-f06feebefaf9"},{"index":20551,"token":false,"name":"Ranger's Guile","scryfallId":"02392840-f0c4-462e-84ce-9a7cdd9f5efb"},{"index":20552,"token":false,"name":"Goliath Spider","scryfallId":"cecc53b1-942e-4b44-bf93-dd2d8cc92d6d"},{"index":20553,"token":false,"name":"Deserter's Quarters","scryfallId":"8f7d3b2d-e06e-4d30-9ed8-2a52aa7e31c6"},{"index":20556,"token":false,"name":"Ground Rift","scryfallId":"62333783-6a18-4461-88ce-1c37eaf64e2b"},{"index":20560,"token":false,"name":"Blighted Bat","scryfallId":"6c0cc3d9-85f1-49ed-bf8a-81fc6c60bd2a"},{"index":20562,"token":false,"name":"Blowfly Infestation","scryfallId":"ae027b38-a6cc-41f7-8f0d-9d1402b46517"},{"index":20563,"token":false,"name":"Feedback Bolt","scryfallId":"a370375c-14bf-4381-9359-f2e600867e7c"},{"index":20565,"token":false,"name":"Pooling Venom","scryfallId":"0911fb8b-d27a-4afc-9114-212f3e090393"},{"index":20569,"token":false,"name":"Accursed Spirit","scryfallId":"e8e26415-b1af-4718-9aef-aca0297d176f"},{"index":20570,"token":false,"name":"Oketra's Monument","scryfallId":"f86bc112-4744-4310-a3a8-df5c6c9421b3"},{"index":20572,"token":false,"name":"Hydrosurge","scryfallId":"1fd4dacb-912e-4e54-ab60-16a5262d0fbb"},{"index":20579,"token":false,"name":"Kapsho Kitefins","scryfallId":"a964c5ed-b0ed-47cb-a0f0-79d28ef7f70b"},{"index":20581,"token":false,"name":"Ghitu Firebreathing","scryfallId":"9098b989-072a-4e5b-8972-22c61645c5bb"},{"index":20582,"token":false,"name":"Chains of Mephistopheles","scryfallId":"db7a0517-b0ef-4fc2-be62-40f0dada02a5"},{"index":20586,"token":false,"name":"Mana Clash","scryfallId":"a01f27b7-f1d0-4fb6-b743-ca7a810ef85c"},{"index":20587,"token":false,"name":"Selective Adaptation","scryfallId":"adbd8ffa-c7d3-4ef6-b3a7-8a967b50ce49"},{"index":20588,"token":false,"name":"Blessed Breath","scryfallId":"9e2d8650-b8c3-4e89-9aa2-424a98715c38"},{"index":20591,"token":false,"name":"Vestige of Emrakul","scryfallId":"a5d84986-64a1-4bd1-a4f6-3eb147aca357"},{"index":20594,"token":false,"name":"Torch Drake","scryfallId":"0beff896-df7a-42b3-aaca-0b9ca1b8cf0c"},{"index":20595,"token":false,"name":"God-Pharaoh's Faithful","scryfallId":"9cb8a25b-2ad0-4ffe-b41a-6b3f8b48c1e9"},{"index":20598,"token":false,"name":"Hope Charm","scryfallId":"a1a8980f-07ab-49b7-b83d-f394952ced57"},{"index":20602,"token":false,"name":"Angler Drake","scryfallId":"d14c753e-c5bf-4c34-b408-ac367b6ca6ab"},{"index":20603,"token":false,"name":"Clear a Path","scryfallId":"8a8f904b-a9a3-4bae-9284-4e9cbe7592ee"},{"index":20605,"token":false,"name":"Garruk's Uprising","scryfallId":"8dce84db-d331-4e5b-bdd8-9b1b3bec50cc"},{"index":20609,"token":false,"name":"Farbog Revenant","scryfallId":"0f6de332-debb-49f3-8b29-1719060ab00c"},{"index":20612,"token":false,"name":"Coralhelm Chronicler","scryfallId":"50b54524-8345-4b47-913f-d883a1cbe3a1"},{"index":20615,"token":false,"name":"Toggo, Goblin Weaponsmith","scryfallId":"16a097ba-6242-4a28-a6f1-72a5b3ec3a8f"},{"index":20616,"token":false,"name":"Twisted Image","scryfallId":"aa18c2c2-f1a1-469d-acd8-9d6e0605bcf9"},{"index":20620,"token":false,"name":"Roiling Terrain","scryfallId":"87d3a425-01d1-4001-92f9-8e297dd862b7"},{"index":20621,"token":false,"name":"Joraga Treespeaker","scryfallId":"1132218d-56cd-441e-9006-df3c50344491"},{"index":20623,"token":false,"name":"Krovikan Fetish","scryfallId":"73f75891-00fa-428b-a3cb-88867ff35cd2"},{"index":20628,"token":false,"name":"Rhys the Redeemed","scryfallId":"b91dadcb-31e9-43b0-b425-c9311af3e9d7"},{"index":20632,"token":false,"name":"Prowling Pangolin","scryfallId":"0f037e99-75fb-4a2a-b4c6-448ef21b16a3"},{"index":20639,"token":false,"name":"Tombstalker","scryfallId":"8bd55a11-8658-4b92-9151-d6173a11991a"},{"index":20644,"token":false,"name":"Cached Defenses","scryfallId":"41ad36cf-5f29-41c4-b2a3-6b8e8c0c493f"},{"index":20645,"token":false,"name":"Lorehold Campus","scryfallId":"d35461cf-becf-4399-8329-64b4496b7fc2"},{"index":20649,"token":false,"name":"Sunstone","scryfallId":"3c1c67fa-ff88-4a61-b8a5-8a872b3dc44f"},{"index":20651,"token":false,"name":"Void Attendant","scryfallId":"1f66eb97-b151-48b1-aff0-f1280af66291"},{"index":20655,"token":false,"name":"Soltari Foot Soldier","scryfallId":"3524d78b-d120-46ff-83e3-c502589fd5ba"},{"index":20657,"token":false,"name":"Myr Landshaper","scryfallId":"0fb654ac-9bb0-465e-8878-5456c154274f"},{"index":20658,"token":false,"name":"Byway Courier","scryfallId":"adbc0fba-3993-4ed3-bf29-02b682c7456a"},{"index":20661,"token":false,"name":"Guardian of Solitude","scryfallId":"85d16011-956b-40ac-afb6-6c7ad774802f"},{"index":20662,"token":false,"name":"Curse of the Bloody Tome","scryfallId":"bb4b500e-2616-4135-ae04-ca14a33fce59"},{"index":20663,"token":false,"name":"Skywise Teachings","scryfallId":"87875281-12d1-45b9-b1a9-fe0ae7448ab8"},{"index":20665,"token":false,"name":"Sabertooth Wyvern","scryfallId":"a196fc8f-e17f-41bb-90df-d74b9c3f59c4"},{"index":20666,"token":false,"name":"Firescreamer","scryfallId":"155a2213-bf6e-4a54-924b-e450b7d06f26"},{"index":20669,"token":false,"name":"Mist Leopard","scryfallId":"3f3a26c7-e028-4741-803d-6384925b8500"},{"index":20670,"token":false,"name":"Mystifying Maze","scryfallId":"16e92409-d301-49f5-a8a9-acd531a928d4"},{"index":20672,"token":false,"name":"Misty Rainforest","scryfallId":"1f47bd65-b37c-4b7e-a271-8d67e0c90deb"},{"index":20673,"token":true,"name":"Rogues","scryfallId":"e11080b5-ec02-4b72-8e65-a0542852f281"},{"index":20675,"token":true,"name":"Jakub Šlemr Decklist","scryfallId":"fc79931b-36f7-4727-86d7-e92076c2fab9"},{"index":20676,"token":false,"name":"Tithebearer Giant","scryfallId":"e49bddc9-0b0b-4d6d-a708-019356f9649e"},{"index":20679,"token":false,"name":"Chariot of Victory","scryfallId":"c2dd03d2-05ef-4929-b973-3dbe49fc7592"},{"index":20687,"token":false,"name":"Dromoka Warrior","scryfallId":"13ae001b-556f-4576-8cf4-0b8902997bb1"},{"index":20693,"token":false,"name":"Captured Sunlight","scryfallId":"fcafc9eb-efa3-4f6c-a2ca-aec8692fddc1"},{"index":20695,"token":false,"name":"Regal Leosaur","scryfallId":"b6fdf313-740b-4976-911f-9fb5eb54afce"},{"index":20701,"token":false,"name":"Winter's Grasp","scryfallId":"7af28a5d-45dc-4e31-9009-5c0bd25a9032"},{"index":20702,"token":false,"name":"Vizzerdrix","scryfallId":"168821ce-d77c-4294-a9fd-2a30852801ab"},{"index":20704,"token":false,"name":"Engineered Might","scryfallId":"675b5fc7-51b2-4425-b053-a5d19c1595e0"},{"index":20705,"token":false,"name":"Glacial Ray","scryfallId":"5aa3b25c-a1e1-4eb0-9b65-3c4c6b2a8903"},{"index":20706,"token":false,"name":"Malevolent Noble","scryfallId":"6bc7e996-151f-4d88-8e1e-91bb88f5db02"},{"index":20712,"token":false,"name":"Kresh the Bloodbraided","scryfallId":"d485fe46-ed24-4b55-8ddc-ac2fdf4eec93"},{"index":20713,"token":false,"name":"Henchfiend of Ukor","scryfallId":"d6a8f7ae-bb2b-4ecc-b020-427486315855"},{"index":20714,"token":false,"name":"Righteous Fury","scryfallId":"8f241635-31c6-4cee-b4d6-f723faea80ba"},{"index":20715,"token":false,"name":"Viashino Bey","scryfallId":"26cc07c6-60c7-4abe-8197-7544887ec64d"},{"index":20717,"token":false,"name":"Riven Turnbull","scryfallId":"d11f90e7-ced1-4d80-8083-99acbf459ad7"},{"index":20719,"token":false,"name":"Fodder Cannon","scryfallId":"229ba320-69c9-4400-a0d7-f0f79e8d9856"},{"index":20721,"token":false,"name":"Clackbridge Troll","scryfallId":"3e20bdb7-2b29-4a67-83e4-de01138fb043"},{"index":20723,"token":false,"name":"Zanam Djinn","scryfallId":"57a3c1d5-0ca8-443b-ae7a-66e0363e377b"},{"index":20733,"token":false,"name":"Impassioned Orator","scryfallId":"696d6c4b-69d7-498b-87d4-0a03b16cc971"},{"index":20737,"token":false,"name":"Nightveil Sprite","scryfallId":"6a16a2e7-143a-46ce-9fb6-069a28bdd6bc"},{"index":20739,"token":false,"name":"Barrenton Medic","scryfallId":"8888e0aa-3682-4800-9c50-fff5d5c9547d"},{"index":20741,"token":true,"name":"Cat Dragon Token (B/G/R, 3/3)","scryfallId":"748d267d-9c81-4dc0-92b7-eafb7691c6cc"},{"index":20742,"token":false,"name":"Lava Coil","scryfallId":"f6135cf4-50c2-4e44-b9b0-96e1187a2200"},{"index":20743,"token":false,"name":"Skull of Ramos","scryfallId":"f071957c-9bea-4d00-9ffd-30f98d57b8d2"},{"index":20747,"token":false,"name":"Cagemail","scryfallId":"72ab91ab-2bcf-4617-bec3-2bf040d4997c"},{"index":20750,"token":false,"name":"Bulwark","scryfallId":"a2041b95-ec5b-4512-b012-f875ca686669"},{"index":20752,"token":false,"name":"Swathcutter Giant","scryfallId":"700b38c5-3fd2-4566-8d27-9a09d5ab02b2"},{"index":20753,"token":false,"name":"Slith Strider","scryfallId":"85866351-a721-4b3c-9b6f-4d291daab657"},{"index":20754,"token":false,"name":"Bala Ged Recovery // Bala Ged Sanctuary","scryfallId":"c5cb3052-358d-44a7-8cfd-cd31b236494a"},{"index":20756,"token":true,"name":"Vampire Knight Token (B, 1/1)","scryfallId":"8989fdb4-723b-4c80-89b4-930ccac13b22"},{"index":20757,"token":false,"name":"Ethereal Forager","scryfallId":"97543d69-547e-41f8-9a4f-908e5eb0ee4a"},{"index":20762,"token":false,"name":"Banish into Fable","scryfallId":"2b5e4c5d-7d1d-4426-8351-35c12e29d9c3"},{"index":20766,"token":false,"name":"Tapestry of the Ages","scryfallId":"122e5e24-d704-4f1c-9577-0f25aaabb7ed"},{"index":20768,"token":false,"name":"Konda, Lord of Eiganjo","scryfallId":"5edab171-94b9-4e5e-ab61-bd8c6c8cfc38"},{"index":20769,"token":false,"name":"Diabolic Vision","scryfallId":"1ea01324-1cfb-498c-8299-f690373864bd"},{"index":20771,"token":false,"name":"Stinging Study","scryfallId":"b8840226-1693-44bc-a067-e50198c5e17e"},{"index":20773,"token":false,"name":"Skyshroud Poacher","scryfallId":"0fb4e44e-656e-4294-a53b-1f7aa96fab31"},{"index":20780,"token":false,"name":"Orator of Ojutai","scryfallId":"c9eb6441-c463-4b1e-a084-063f4a1301fe"},{"index":20784,"token":false,"name":"Pulsating Illusion","scryfallId":"d3297f28-a15d-43dd-a96e-09701d5f9aed"},{"index":20789,"token":false,"name":"Ghirapur Gearcrafter","scryfallId":"e6087550-9f15-4a06-b030-18b0be652065"},{"index":20803,"token":false,"name":"Nessian Asp","scryfallId":"788c502d-360e-4610-b5a3-c9ed0af01b1d"},{"index":20805,"token":false,"name":"Stalking Bloodsucker","scryfallId":"16705695-1ba8-4169-974f-d8c683ab2652"},{"index":20807,"token":false,"name":"Reduce to Memory","scryfallId":"7bfc408e-34d6-4e94-8678-4cc229cbc6f5"},{"index":20808,"token":false,"name":"Haldan, Avid Arcanist","scryfallId":"16a86a35-f7e5-434d-bf44-61ae7cb0f98b"},{"index":20810,"token":false,"name":"To Arms!","scryfallId":"2f72d4b7-3b65-411b-a072-8218a0202974"},{"index":20811,"token":false,"name":"Shisato, Whispering Hunter","scryfallId":"5cc79c9c-f776-4c55-a7d1-9fac33f14630"},{"index":20815,"token":false,"name":"Descent into Madness","scryfallId":"fa016bb7-ad8b-40d5-90db-412a9cf19e4e"},{"index":20816,"token":false,"name":"Death's Oasis","scryfallId":"112e2cca-bae7-4296-9514-e6058f4b38a5"},{"index":20817,"token":false,"name":"Soul Charmer","scryfallId":"1656bd2a-e7ce-48b1-8fa1-5f470fe6058e"},{"index":20822,"token":false,"name":"Moldering Karok","scryfallId":"70c2ef30-0db5-4ef5-999c-7ffa48769421"},{"index":20823,"token":false,"name":"Korvold, Fae-Cursed King","scryfallId":"67629212-a080-4245-8d7d-20d38cc4ad87"},{"index":20824,"token":false,"name":"Stalking Vengeance","scryfallId":"d4bc5e83-2f92-49e7-aab2-b9c9e5ce40a6"},{"index":20825,"token":false,"name":"Punishing Fire","scryfallId":"0da4409b-fe3f-4500-bf4b-890593f7d313"},{"index":20827,"token":false,"name":"Dega Disciple","scryfallId":"fb9cd7d9-8aad-4607-890c-9c8efe016a92"},{"index":20830,"token":false,"name":"Niv-Mizzet, Parun","scryfallId":"c102220d-9d6a-4946-b47f-3d3ff67a20dd"},{"index":20833,"token":false,"name":"Jarad, Golgari Lich Lord","scryfallId":"c6717954-35d8-4d7e-95aa-f7d26d15d4b2"},{"index":20839,"token":false,"name":"Approach of the Second Sun","scryfallId":"c8248731-1005-46e3-ab37-0a3ff039d607"},{"index":20842,"token":false,"name":"Adherent of Hope","scryfallId":"ce2bc7ad-458d-445e-a0a9-7897b596fdd0"},{"index":20843,"token":false,"name":"Saheeli Rai","scryfallId":"8b2e11a3-98d6-415b-8f53-c00c59e62804"},{"index":20844,"token":false,"name":"Zenith Flare","scryfallId":"0efac1ed-3f01-487c-86be-8239568b4425"},{"index":20846,"token":true,"name":"Eldritch Moon Checklist","scryfallId":"cd8586f9-97e2-438d-b74f-1e53c811f314"},{"index":20849,"token":false,"name":"Commune with Dinosaurs","scryfallId":"de4b9a07-6631-477a-8c77-3b04f211439d"},{"index":20850,"token":false,"name":"Folk of An-Havva","scryfallId":"9f4a595e-51f6-4e84-aa3a-5d9c18dc8b3f"},{"index":20854,"token":false,"name":"Terravore","scryfallId":"150ee46e-b8f9-4b8b-be7d-7886bd67b662"},{"index":20858,"token":false,"name":"Remember the Fallen","scryfallId":"6d9b8325-2a28-4312-b778-40087f8ea778"},{"index":20860,"token":false,"name":"Basri, Devoted Paladin","scryfallId":"2688b45d-9d74-4d9f-9a63-29c82b48d64f"},{"index":20861,"token":false,"name":"Skirk Ridge Exhumer","scryfallId":"4e783332-ea4e-4330-ba91-d23e5a58a7eb"},{"index":20866,"token":false,"name":"Hyena Pack","scryfallId":"f9fa8351-567e-4ef4-8346-c58e50c778a6"},{"index":20868,"token":false,"name":"Hans Eriksson","scryfallId":"24a0babe-8da4-4c95-9cdf-626a5c5e2e5c"},{"index":20869,"token":false,"name":"Wiitigo","scryfallId":"9ee86bf2-6c54-4c6e-8394-eb39f98d5a85"},{"index":20870,"token":false,"name":"Dripping Dead","scryfallId":"cdb3b483-01a8-4f54-9a3a-0d3f5aa3cd8b"},{"index":20871,"token":false,"name":"Sultai Ascendancy","scryfallId":"3314d77a-039f-43e4-a457-6ceba20c0ffe"},{"index":20872,"token":false,"name":"Geistblast","scryfallId":"19b1dfd9-b717-4c23-b8e5-a6ec835b278a"},{"index":20874,"token":false,"name":"Ringskipper","scryfallId":"72d3ae1f-5442-4725-a16a-502f13359a85"},{"index":20876,"token":true,"name":"Fish // Kraken Token (U, 9/9)","scryfallId":"8ce300b8-ab50-4c96-ba05-30701a249230"},{"index":20878,"token":false,"name":"Ivory Mask","scryfallId":"35ea3762-a419-412c-b2bd-0a40902d8d51"},{"index":20880,"token":false,"name":"Sai of the Shinobi","scryfallId":"6f11deb8-aca1-4cdf-b443-2aecb054fb10"},{"index":20884,"token":false,"name":"Market Festival","scryfallId":"c3a70329-ecae-4647-b912-75d936a6c8c5"},{"index":20886,"token":false,"name":"Herald of the Forgotten","scryfallId":"c3dba1c4-ee9a-4ea6-bf66-f639d38711cd"},{"index":20887,"token":false,"name":"Dawn Evangel","scryfallId":"f7e152ae-43ec-4b9d-a43f-786c2f6c7366"},{"index":20888,"token":false,"name":"Verduran Enchantress","scryfallId":"55454150-de1b-4921-9c23-7d10724c2ee7"},{"index":20891,"token":false,"name":"Drake Familiar","scryfallId":"b4583623-e367-48cc-8e86-e6c5e35f1a9c"},{"index":20893,"token":false,"name":"True-Name Nemesis","scryfallId":"a63b327c-c07c-4bce-afe0-f4996b8a11b7"},{"index":20894,"token":false,"name":"Branded Brawlers","scryfallId":"90a48065-fbf1-4f2a-993e-7061057a4c45"},{"index":20897,"token":false,"name":"Chain of Acid","scryfallId":"1d47ddca-a363-4ab7-b7f2-d0e0043c9916"},{"index":20901,"token":false,"name":"Gatebreaker Ram","scryfallId":"5ef592d1-e5e1-4252-8741-402c32d65dfd"},{"index":20905,"token":false,"name":"Contaminated Ground","scryfallId":"3d2ba8f3-58f5-43e5-9201-974ba58f56f8"},{"index":20906,"token":false,"name":"Advanced Stitchwing","scryfallId":"f9c9e68a-6b73-456b-8895-065d26446430"},{"index":20910,"token":false,"name":"Wildwood Tracker","scryfallId":"3538eba1-475a-4388-8a72-55ab7cd1027e"},{"index":20915,"token":false,"name":"Vines of the Recluse","scryfallId":"6a59419a-9b49-4dcd-b510-6faaf355664d"},{"index":20917,"token":false,"name":"Cunning Geysermage","scryfallId":"2217f0a9-5af5-45cc-8cf7-8878d4f66dd8"},{"index":20920,"token":false,"name":"Paradise Plume","scryfallId":"1205ac7e-4d4e-4849-b3ae-1e4e0558fd96"},{"index":20921,"token":false,"name":"Goblin Skycutter","scryfallId":"c45406cd-a036-45d5-a0fb-3c195d40d746"},{"index":20923,"token":false,"name":"Weldfast Wingsmith","scryfallId":"8b115a65-e273-4264-9db7-317e1855f492"},{"index":20936,"token":false,"name":"Bolt Bend","scryfallId":"39b35408-3728-4e1b-9f58-b0775df914d6"},{"index":20938,"token":false,"name":"Dragon's Presence","scryfallId":"53855022-7aff-4d13-bdd8-0abbf69204a4"},{"index":20939,"token":false,"name":"Rush of Vitality","scryfallId":"1657337f-9da7-4d1f-969d-f1df3ff811c1"},{"index":20940,"token":false,"name":"Chub Toad","scryfallId":"0d977294-051a-4e6d-b2ba-c04494474aac"},{"index":20941,"token":false,"name":"Kraul Foragers","scryfallId":"b5ed4b08-8583-4ad4-b0ba-0463d367efc8"},{"index":20946,"token":false,"name":"Shatterskull Minotaur","scryfallId":"9d311f5f-ad68-48d4-aa5d-66916034ddb9"},{"index":20948,"token":false,"name":"Brimstone Dragon","scryfallId":"54c72f51-2e8c-4a2f-9b61-80f36f8af521"},{"index":20951,"token":false,"name":"Regal Behemoth","scryfallId":"644e5b24-394a-43f1-8384-186d6108f540"},{"index":20955,"token":false,"name":"Ashenmoor Liege","scryfallId":"9a40793a-f5d1-4a1b-a7ab-0cb7513a00ca"},{"index":20956,"token":false,"name":"Accomplished Automaton","scryfallId":"61dc2362-f901-4ec6-9bc4-1988f30380fd"},{"index":20957,"token":false,"name":"Bereavement","scryfallId":"06a1e5f5-a164-4359-bae1-e5dfd4801688"},{"index":20960,"token":false,"name":"Sudden Disappearance","scryfallId":"a51b792c-b987-49b6-9cc6-80d613c7d065"},{"index":20963,"token":true,"name":"Witchcraft","scryfallId":"fcef82fa-6288-44a9-b6b6-bc9389c018bc"},{"index":20970,"token":false,"name":"Radiating Lightning","scryfallId":"94454128-92f1-475d-abc4-c235f501eeb6"},{"index":20971,"token":false,"name":"Skulduggery","scryfallId":"ba30343b-1637-490f-810e-d614219789e3"},{"index":20973,"token":true,"name":"Shadows Over Innistrad Checklist 2","scryfallId":"4825c59d-9e27-4a12-ba84-642b8540e573"},{"index":20974,"token":false,"name":"Glimpse the Unthinkable","scryfallId":"48058253-54b8-403b-8d95-94d8da986e69"},{"index":20975,"token":false,"name":"Yavimaya Granger","scryfallId":"05414a41-b50c-49b6-9c27-f3170017d9b0"},{"index":20978,"token":false,"name":"Maggot Carrier","scryfallId":"ab2c3dc4-bb49-4ec3-a6c8-4256d1939326"},{"index":20981,"token":false,"name":"Pursue Glory","scryfallId":"f5668ae2-fa74-47c9-877e-5326cac67659"},{"index":20982,"token":false,"name":"Scald","scryfallId":"8a8202f7-ef7c-4b76-b053-88b7edcb921e"},{"index":20988,"token":false,"name":"Silversmote Ghoul","scryfallId":"ff5444cb-0ecd-4482-a8d8-09332f382dbd"},{"index":20992,"token":false,"name":"Consult the Necrosages","scryfallId":"6f51484b-3bad-4332-87f8-61924e153799"},{"index":20995,"token":false,"name":"Golos, Tireless Pilgrim","scryfallId":"737122cb-b8f4-4d51-80c4-83be6e8dfc86"},{"index":20996,"token":false,"name":"Trailblazer's Boots","scryfallId":"ec0b5e2f-1c6c-40d4-8631-17e77cdaa2d5"},{"index":20997,"token":false,"name":"Sea Gate Wreckage","scryfallId":"cd42576b-9de5-4d77-9d30-1ef5b5a4fd73"},{"index":21000,"token":false,"name":"Irrigated Farmland","scryfallId":"25d2ef53-0986-4509-8af3-9dfb8ebcf908"},{"index":21002,"token":false,"name":"Tavern Swindler","scryfallId":"4fb036e2-8f6a-4c47-b194-12ca2e5f43de"},{"index":21006,"token":false,"name":"Fourth Bridge Prowler","scryfallId":"80fcfdd4-09af-4664-98e0-3f0fb735dc73"},{"index":21007,"token":false,"name":"Bogstomper","scryfallId":"ad005eef-d4e4-4f46-81a5-9bbce87014ce"},{"index":21009,"token":false,"name":"Sunastian Falconer","scryfallId":"bd0eb8b1-e48d-4e83-86df-d6aa86f95ffd"},{"index":21011,"token":false,"name":"Tayam, Luminous Enigma","scryfallId":"05b837a2-5773-4340-87f9-b4d6a43deb27"},{"index":21015,"token":false,"name":"Black Market","scryfallId":"05976e5c-b46c-431e-9dbd-1dc5fad3536c"},{"index":21016,"token":false,"name":"Mindbender Spores","scryfallId":"f41066eb-be5e-4a6d-9156-64f5e56c7ab3"},{"index":21022,"token":false,"name":"Dread Rider","scryfallId":"205eb029-68a0-4895-b142-2eb09987b5cb"},{"index":21024,"token":false,"name":"Dreg Mangler","scryfallId":"ecc43058-6708-489f-a88f-33930c58ebce"},{"index":21025,"token":false,"name":"Mana Breach","scryfallId":"e36a7eff-89c8-4799-b264-38892912ba05"},{"index":21026,"token":false,"name":"Kathril, Aspect Warper","scryfallId":"ebc57f73-a517-463e-8d55-56aa996d091e"},{"index":21032,"token":false,"name":"Vibrating Sphere","scryfallId":"7f0da2b7-ed3b-47fd-962e-ca5dc745cfc7"},{"index":21035,"token":false,"name":"Wicked Guardian","scryfallId":"71cd91b2-0f9b-4582-ad90-32fa3ee1fde7"},{"index":21038,"token":false,"name":"Reduce to Dreams","scryfallId":"10962b1b-4039-4d8a-88e0-fc67537920a9"},{"index":21040,"token":false,"name":"Tel-Jilad Wolf","scryfallId":"ac40a1c6-88df-4f01-aa59-4ef3c6b57e75"},{"index":21045,"token":false,"name":"Emberwilde Augur","scryfallId":"9a118b11-c9b9-423e-8cad-839f8e6aa0ec"},{"index":21046,"token":false,"name":"Treefolk Harbinger","scryfallId":"9ef45cdc-2e1c-40c7-8978-b09a50f511fb"},{"index":21047,"token":false,"name":"Amok","scryfallId":"5c5bdb8c-2a2e-47cf-a502-2d62f9ada3fa"},{"index":21051,"token":false,"name":"Kamahl, Fist of Krosa","scryfallId":"97ab4974-d0a4-4033-b150-8928b46dc626"},{"index":21055,"token":false,"name":"Seascape Aerialist","scryfallId":"3690efc8-de2b-4476-87da-d8ed9572dc84"},{"index":21059,"token":false,"name":"Plaguebearer","scryfallId":"a8493df6-9954-4e33-867c-ca4bcf3953b2"},{"index":21061,"token":false,"name":"Merfolk Mistbinder","scryfallId":"2935b829-23fb-415e-90f2-2e0016b5cde9"},{"index":21070,"token":false,"name":"Sanguimancy","scryfallId":"fb129def-4055-4b12-9944-39406b451553"},{"index":21072,"token":false,"name":"Exsanguinate","scryfallId":"18a67eaf-b02a-4c01-a007-6c1ea96a5c08"},{"index":21074,"token":false,"name":"Derevi, Empyrial Tactician","scryfallId":"3a1d0dad-18a8-489e-ac11-08f64b72fda4"},{"index":21075,"token":false,"name":"Commander's Insignia","scryfallId":"44cccb23-a515-4e49-b4ae-a12d81f7d6ef"},{"index":21077,"token":false,"name":"Budoka Gardener // Dokai, Weaver of Life","scryfallId":"58164521-aeec-43fc-9db9-d595432dea6f"},{"index":21079,"token":false,"name":"Snake Pit","scryfallId":"059a70a5-d4fb-445e-af98-e81821df2c59"},{"index":21082,"token":false,"name":"Coldsteel Heart","scryfallId":"4f268dd7-94a4-481f-aa03-ab6af0065a26"},{"index":21084,"token":false,"name":"Deathrender","scryfallId":"ea48de8d-edcd-414e-b630-473af2d95abe"},{"index":21085,"token":false,"name":"Oracle of Nectars","scryfallId":"b09f27f4-58c0-4fe0-a985-f5a1bb6a68cd"},{"index":21092,"token":false,"name":"Martyr's Cause","scryfallId":"8f32622e-1481-43ee-99fa-bb97282550d3"},{"index":21093,"token":false,"name":"Blade Splicer","scryfallId":"277bc4e5-f43a-4f1e-a7e9-11796e78fcdf"},{"index":21096,"token":false,"name":"Wildheart Invoker","scryfallId":"dc8315bf-03af-4f19-92c7-556e486cb099"},{"index":21100,"token":true,"name":"Ape Token (G, 3/3)","scryfallId":"8343e00c-5fc6-46a0-a238-3759338dced4"},{"index":21103,"token":false,"name":"Crack Open","scryfallId":"42b77a34-9b69-4b01-9f2c-2ff8de47fc12"},{"index":21107,"token":false,"name":"Aggression","scryfallId":"f3f26060-0c24-496c-b8e2-4dac7ea6166b"},{"index":21108,"token":false,"name":"Borborygmos","scryfallId":"326911cc-04fb-4897-8a43-e1cacf928c06"},{"index":21125,"token":false,"name":"Vedalken Mesmerist","scryfallId":"5b5e0a12-2589-473b-90e4-1ee5acc055a2"},{"index":21126,"token":false,"name":"Gatherer of Graces","scryfallId":"68d75367-88e7-44e6-9234-590dc143fd1d"},{"index":21129,"token":false,"name":"Vigean Graftmage","scryfallId":"7c75901c-fe69-49b8-b491-879e9adf7902"},{"index":21132,"token":false,"name":"Svyelunite Temple","scryfallId":"8b3fde62-ab21-459b-9c5d-01aa6fe1d08e"},{"index":21139,"token":false,"name":"Goblin Sledder","scryfallId":"cacb205f-f57d-4275-8efe-0943b84408e7"},{"index":21145,"token":false,"name":"Portcullis Vine","scryfallId":"d1abd95a-4ecc-479c-b200-5aaf7c993ef8"},{"index":21148,"token":false,"name":"Vengeful Reaper","scryfallId":"854c99fd-71ba-40b7-98cf-b783f01a77b4"},{"index":21149,"token":false,"name":"Extricator of Sin // Extricator of Flesh","scryfallId":"b6867ddd-f953-41c6-ba36-86ae2c14c908"},{"index":21150,"token":false,"name":"Dragonstalker","scryfallId":"58017ff1-74d2-4be2-976a-8dff53e16150"},{"index":21155,"token":false,"name":"Vigean Intuition","scryfallId":"be493737-0457-447b-802b-043d7a77f389"},{"index":21156,"token":false,"name":"Irregular Cohort","scryfallId":"92c46961-cf1a-4f20-83aa-3d256db2388f"},{"index":21160,"token":false,"name":"Guardian of Pilgrims","scryfallId":"a41b6ca9-1d6f-46ce-aba0-952871a10a4b"},{"index":21163,"token":false,"name":"Stratadon","scryfallId":"324bc757-9942-4862-b691-5af42e07f682"},{"index":21164,"token":false,"name":"Kelinore Bat","scryfallId":"542b3ec9-7800-4dea-bf39-b51a11b58339"},{"index":21168,"token":false,"name":"Nethroi, Apex of Death","scryfallId":"ba04c102-e4c1-43a8-9c2f-d1f3c9bf5edf"},{"index":21172,"token":false,"name":"Giant Caterpillar","scryfallId":"b7f602a6-3d35-49a3-b5cb-d754e03a9573"},{"index":21175,"token":false,"name":"Raugrin Crystal","scryfallId":"c5bce0fb-53d6-47ee-8c5a-a99e50f67fc9"},{"index":21180,"token":false,"name":"Sage's Row Savant","scryfallId":"d573626b-e7fa-4c31-a3d4-b853adfe787e"},{"index":21182,"token":false,"name":"Soliton","scryfallId":"7b608c28-18cc-47d6-861e-2fd783aa3ade"},{"index":21183,"token":false,"name":"Ritual of Steel","scryfallId":"21205189-0d00-44d5-9772-820e607dba25"},{"index":21184,"token":false,"name":"Catacomb Crocodile","scryfallId":"440c53f0-7922-4e14-802d-d7a22f8fed85"},{"index":21185,"token":false,"name":"Gouged Zealot","scryfallId":"5c0595a6-a9e5-4ea8-b733-382e6c365759"},{"index":21188,"token":false,"name":"Callous Giant","scryfallId":"330028c4-8e91-4fe3-a87d-1660dfd2507e"},{"index":21189,"token":false,"name":"Pride of the Perfect","scryfallId":"30272e6d-683d-4c9a-90d6-ea7908943267"},{"index":21191,"token":false,"name":"Oran-Rief Survivalist","scryfallId":"0d598220-bddd-48a4-8c80-eb149c6292a3"},{"index":21192,"token":false,"name":"Skyblade of the Legion","scryfallId":"67e788e2-12e9-4041-8210-753aaef2576c"},{"index":21194,"token":false,"name":"Mirran Crusader","scryfallId":"7fd97de7-1ffe-4dd2-8b00-9c9d04601c5f"},{"index":21198,"token":false,"name":"Artificial Evolution","scryfallId":"f46894d1-2503-43fa-938e-7bbf19101d13"},{"index":21201,"token":false,"name":"Parallax Nexus","scryfallId":"862c50c7-0840-46e0-a653-5b660fdfd4bd"},{"index":21204,"token":false,"name":"Coral Fighters","scryfallId":"4f6e1cf2-1c0e-4b9b-9687-dd02ac019fbc"},{"index":21205,"token":false,"name":"Hearthfire Hobgoblin","scryfallId":"9c5fc104-7189-480c-bfe1-c5da07df48f4"},{"index":21206,"token":false,"name":"Deftblade Elite","scryfallId":"d576b8f2-9b5b-47c0-8f9f-faa209d59595"},{"index":21208,"token":false,"name":"Unbound Flourishing","scryfallId":"19907ce2-345d-44a9-a8f5-5c74efc86915"},{"index":21209,"token":false,"name":"Spectral Deluge","scryfallId":"7238c46e-6338-4aca-96f2-934c44c8cc36"},{"index":21210,"token":false,"name":"Feint","scryfallId":"95b265bc-a94d-403b-8232-8fdfa0f8d9d5"},{"index":21211,"token":false,"name":"Breath of Fire","scryfallId":"4c7c39a5-76aa-439f-a280-811d5c21b8c2"},{"index":21212,"token":false,"name":"Scoria Elemental","scryfallId":"ca4d9198-52a7-4dfe-8f7f-4fa6e19a2479"},{"index":21215,"token":false,"name":"Spirit of the Hunt","scryfallId":"5c5f7b11-49ac-4078-aab7-efe3aff746b2"},{"index":21216,"token":false,"name":"Surveilling Sprite","scryfallId":"97265692-3b45-47f4-9e9f-e78751240007"},{"index":21217,"token":false,"name":"Mana Cache","scryfallId":"583a33b3-7833-48e5-88c3-849a5771ef6e"},{"index":21219,"token":false,"name":"Sun-Crested Pterodon","scryfallId":"c298b51f-b725-4a51-a91e-4c66cf6dfe9d"},{"index":21221,"token":false,"name":"Exquisite Archangel","scryfallId":"d04018c9-510c-4610-9daa-677434628805"},{"index":21222,"token":false,"name":"Tanglepool Bridge","scryfallId":"57d2b895-8921-4615-a674-fb85eed5ea3f"},{"index":21224,"token":false,"name":"Slurrk, All-Ingesting","scryfallId":"1bc1783d-751a-490f-abe3-4661a76fce9e"},{"index":21226,"token":false,"name":"Mistfire Weaver","scryfallId":"8003a31f-7662-4e9e-8165-1ceea04fdf20"},{"index":21229,"token":false,"name":"Topan Ascetic","scryfallId":"6d0952ed-efc7-4ff5-a233-e64c0f11119b"},{"index":21231,"token":false,"name":"Goblin Rally","scryfallId":"38b8c2a5-d84f-44c7-85dd-50c78f8b47da"},{"index":21235,"token":false,"name":"Seafloor Oracle","scryfallId":"4316eacf-4b78-4b99-833c-53ecf49a0ae5"},{"index":21238,"token":false,"name":"Searing Spear Askari","scryfallId":"5cf66916-7f6b-412f-acd6-f96ad4539a46"},{"index":21240,"token":false,"name":"Dakmor Scorpion","scryfallId":"2d860dee-93a9-48e5-ba7a-80ad8cdc84e4"},{"index":21241,"token":false,"name":"Telekinesis","scryfallId":"d5aa920e-b93f-41c2-b505-a9350353be8b"},{"index":21243,"token":false,"name":"Prodigal Pyromancer","scryfallId":"ea894b56-7427-4dda-a63a-65608252f13e"},{"index":21249,"token":false,"name":"Fire Dragon","scryfallId":"72c6eb99-759d-4baa-8ce9-f20583671e82"},{"index":21257,"token":false,"name":"Loxodon Mender","scryfallId":"c17ac7c1-6d53-40b4-921f-4e23e4026041"},{"index":21258,"token":false,"name":"Menagerie Liberator","scryfallId":"e7b2b659-2689-4de0-aa07-2568b45f86a8"},{"index":21262,"token":false,"name":"Flayed Nim","scryfallId":"fd2381b3-ebf8-4c65-8e89-e089c2e57145"},{"index":21264,"token":false,"name":"Bastion Enforcer","scryfallId":"7cbf17a0-2dbc-4e79-9cfa-ea49b1605105"},{"index":21266,"token":false,"name":"Reiver Demon","scryfallId":"d109abda-982f-4907-8b64-ec63e138bc42"},{"index":21269,"token":false,"name":"Shinen of Life's Roar","scryfallId":"a77d9516-7275-40df-8989-418933671263"},{"index":21270,"token":false,"name":"Apocalypse Demon","scryfallId":"39dfbf99-55e8-468b-bcd9-9179cad7cab6"},{"index":21274,"token":false,"name":"Long Road Home","scryfallId":"6f883c9b-c9c0-4777-b0a4-186620243f02"},{"index":21277,"token":false,"name":"Boggart Shenanigans","scryfallId":"e0bed87a-790a-4bf7-8a85-16fe6bfa04f0"},{"index":21279,"token":false,"name":"Obzedat's Aid","scryfallId":"b846ba99-81ba-424a-98eb-f9f69c40f984"},{"index":21280,"token":false,"name":"Temporary Insanity","scryfallId":"415d0678-539f-4c19-8a6e-b43e747a97de"},{"index":21281,"token":false,"name":"Aria of Flame","scryfallId":"95a96eb1-f87c-4b1d-82c7-f239bcbc62b8"},{"index":21289,"token":false,"name":"Broodhatch Nantuko","scryfallId":"38315ba3-57a0-4aa0-b1bc-4b1fcdd763d4"},{"index":21290,"token":false,"name":"Kira, Great Glass-Spinner","scryfallId":"437ded6e-4e53-49fa-a5ca-fd76b9165a47"},{"index":21301,"token":false,"name":"Viridian Harvest","scryfallId":"666eb9a5-b105-45c1-be3e-7ac5cc650338"},{"index":21304,"token":false,"name":"Triskaidekaphobia","scryfallId":"a11bf081-c870-4ebb-9b19-9aaffdef73bf"},{"index":21308,"token":false,"name":"Cryptic Caves","scryfallId":"204acb48-a705-4c5f-b462-2bcb3bc75fa4"},{"index":21309,"token":false,"name":"Stomper Cub","scryfallId":"89be64a8-dd78-48c3-bb47-4f2a5ad9ec10"},{"index":21312,"token":true,"name":"Saproling // Insect Token (G, 1/1)","scryfallId":"c06bcc5b-4ccd-452d-8579-beee6c5cbe98"},{"index":21313,"token":false,"name":"Storm God's Oracle","scryfallId":"a6d22f24-f752-4bc8-ba97-061b2c060ec8"},{"index":21314,"token":false,"name":"Soulless One","scryfallId":"c826d786-0d96-4f77-94ae-6907fbce51e0"},{"index":21316,"token":false,"name":"Infected Vermin","scryfallId":"00615487-3526-4b4c-bb06-8f2af1f101d0"},{"index":21318,"token":false,"name":"Hidden Horror","scryfallId":"751b406f-59cd-4059-9c2d-eb3ee8133444"},{"index":21324,"token":false,"name":"Endangered Armodon","scryfallId":"29d43e8f-a914-44ed-bbd3-3746fb4ea6da"},{"index":21325,"token":false,"name":"Duneblast","scryfallId":"8e3fba5b-b4cd-4050-b9f0-d8eabe82e7d6"},{"index":21327,"token":false,"name":"Ambush Krotiq","scryfallId":"fd3068c6-d403-46d5-b3d7-1c3b00b9a9b1"},{"index":21329,"token":false,"name":"Azra Oddsmaker","scryfallId":"78630f58-8733-43ec-ba20-fbb21b276434"},{"index":21330,"token":false,"name":"Wall of Limbs","scryfallId":"66d46b81-3131-4561-beca-ccf4a0973610"},{"index":21334,"token":false,"name":"Aisling Leprechaun","scryfallId":"640a161d-ad7b-4e5b-8f2d-d3753cb9daa3"},{"index":21335,"token":false,"name":"Bomber Corps","scryfallId":"5bbe9f73-5515-48c4-8b3d-d544d369e013"},{"index":21336,"token":false,"name":"Fiery Confluence","scryfallId":"4c454a20-8ec8-41d9-b9c3-acaa510d050b"},{"index":21337,"token":false,"name":"Hunted Lammasu","scryfallId":"b84de052-65e5-4723-a746-5c554fa1612d"},{"index":21339,"token":false,"name":"Broodstar","scryfallId":"07a194cb-53c9-4690-ba63-79beecaebe0e"},{"index":21340,"token":false,"name":"Skirsdag Cultist","scryfallId":"e63fa0de-2ec3-41ff-8e5d-0b54f400f27f"},{"index":21342,"token":false,"name":"Sen Triplets","scryfallId":"13ac5292-9817-4f5d-b3fa-611f9ba44443"},{"index":21343,"token":false,"name":"Cunning Breezedancer","scryfallId":"2ed8508b-c987-4197-aaee-e6410f7db58e"},{"index":21352,"token":false,"name":"Angelic Ascension","scryfallId":"e8cca776-b0e4-4cd2-815f-36c1f86cf497"},{"index":21357,"token":false,"name":"Loam Larva","scryfallId":"affa9314-0021-445e-9496-349254b16bf8"},{"index":21358,"token":false,"name":"Godo, Bandit Warlord","scryfallId":"73ade6a3-a461-4f90-8bd6-9b17892a8405"},{"index":21360,"token":false,"name":"Canopy Baloth","scryfallId":"6b04160c-89a7-4dcd-b05d-5dc846824d64"},{"index":21361,"token":false,"name":"Path to the World Tree","scryfallId":"606da75d-382a-47a8-9739-644438594700"},{"index":21368,"token":false,"name":"Impetuous Sunchaser","scryfallId":"e6d4c13b-95ef-49df-b349-26e0fec109ad"},{"index":21369,"token":false,"name":"Legion's Judgment","scryfallId":"032f6c5a-8d88-4a55-a54b-28df42d801e1"},{"index":21375,"token":false,"name":"Death's Approach","scryfallId":"f954e983-397c-4fdc-a6a1-142d03bfec7e"},{"index":21380,"token":false,"name":"Silverquill Pledgemage","scryfallId":"a3f64ad2-4041-421d-baa2-206cedcecf0e"},{"index":21385,"token":false,"name":"Spreading Flames","scryfallId":"c655b1dc-8df1-44c8-a963-bd0a671ec7e5"},{"index":21392,"token":false,"name":"Curse of Chaos","scryfallId":"fd95b9aa-1abb-4a10-a622-51a2bb578d17"},{"index":21396,"token":true,"name":"Treefolk Shaman Token (G, 2/5)","scryfallId":"d75c1ada-2a49-49e8-800d-f11d08263dde"},{"index":21399,"token":false,"name":"Goblin Grenadiers","scryfallId":"5a73db23-727f-4d63-97d7-2ca542276722"},{"index":21403,"token":false,"name":"Caged Sun","scryfallId":"dfe6f9ec-3b7f-4c11-acd1-440e14217e5d"},{"index":21407,"token":false,"name":"Corrupt Official","scryfallId":"5cb652fc-5a21-4e02-a776-a38fb41ad18c"},{"index":21408,"token":false,"name":"Desperate Gambit","scryfallId":"f4245160-274e-4c39-9bcd-c64e9a44dfdb"},{"index":21409,"token":false,"name":"Pilfering Imp","scryfallId":"646dedff-150c-4ed2-8f2e-3b2e6ba5521a"},{"index":21410,"token":false,"name":"Field of Ruin","scryfallId":"3e84e179-9d59-4d08-8a36-51ad2fc32ae3"},{"index":21412,"token":false,"name":"Vault Robber","scryfallId":"74f68014-489d-4f51-a959-0f335541cb4e"},{"index":21414,"token":false,"name":"Thundering Djinn","scryfallId":"28642fbe-90c8-4beb-9950-91af28d93326"},{"index":21418,"token":false,"name":"Chandra, Novice Pyromancer","scryfallId":"d678cf4c-60e3-40a1-a9cc-b0bd157bcf36"},{"index":21423,"token":false,"name":"Rapacious Dragon","scryfallId":"6ca026be-d204-4ec2-a349-aac5fc3a05ec"},{"index":21424,"token":false,"name":"Kjeldoran Javelineer","scryfallId":"48b0776b-d1ed-4b0d-9684-99978e3e3b46"},{"index":21427,"token":false,"name":"Crash Landing","scryfallId":"f8683546-85b7-4658-91be-91ef65fb3fc3"},{"index":21430,"token":false,"name":"Gate to the Afterlife","scryfallId":"ad0c603b-4642-438b-95cc-97abecdc0753"},{"index":21434,"token":false,"name":"Nantuko Disciple","scryfallId":"3f5db5e0-bd95-4c82-a12d-7288dbbbe3ba"},{"index":21435,"token":false,"name":"Cowardice","scryfallId":"c71fe070-3656-4c69-84ae-dca3a8f7aa5a"},{"index":21437,"token":false,"name":"Polymorphist's Jest","scryfallId":"f5f935cb-4ec2-4131-878b-f8e557d848b9"},{"index":21440,"token":false,"name":"Fangren Firstborn","scryfallId":"ec1bf1ed-0db3-4e4b-b2a5-8416b15ab894"},{"index":21441,"token":false,"name":"Descendant of Masumaro","scryfallId":"b7512d74-4330-4de7-9c0c-4bb7f37f6066"},{"index":21443,"token":false,"name":"Swordwise Centaur","scryfallId":"1776ebd7-91fc-49e1-a978-f2012162d1cf"},{"index":21446,"token":false,"name":"Shrewd Hatchling","scryfallId":"bee63435-36c6-42c1-8969-85e3ed3ab680"},{"index":21451,"token":false,"name":"Rampart Crawler","scryfallId":"8b60f86f-c78a-4dfb-bb18-e9bcf21b26c4"},{"index":21452,"token":false,"name":"Surtland Elementalist","scryfallId":"1c9e7fdc-676f-4901-83ff-bfea3a96d937"},{"index":21453,"token":false,"name":"Rites of Initiation","scryfallId":"f17d9c60-5f81-4b65-8af1-9c5bb757bd7d"},{"index":21456,"token":false,"name":"Aviary Mechanic","scryfallId":"b97b0767-4308-4e5d-bc12-6cf8d8724797"},{"index":21457,"token":false,"name":"Lightning-Core Excavator","scryfallId":"b1b959af-bb23-42e7-8848-7405ed597c8d"},{"index":21463,"token":false,"name":"Roon of the Hidden Realm","scryfallId":"f8ff4b08-fa1a-4564-b427-ea89e54a0e7b"},{"index":21464,"token":false,"name":"Daru Mender","scryfallId":"de13fba8-3fee-4ce2-b84d-b518a99eefe0"},{"index":21465,"token":false,"name":"Repel the Darkness","scryfallId":"90fa47c3-3209-4e01-920a-aed2184520c2"},{"index":21470,"token":false,"name":"Mausoleum Wanderer","scryfallId":"5016d3ee-2da3-4bcf-92c1-7b52aa6b4ed6"},{"index":21473,"token":false,"name":"Pyramids","scryfallId":"d2e9decf-47b7-44e0-b380-8055b6011021"},{"index":21476,"token":false,"name":"Rot Hulk","scryfallId":"ce9cf26d-f214-4e76-b000-8dd895cce8d9"},{"index":21482,"token":false,"name":"Horned Cheetah","scryfallId":"a28ad983-ce91-40b6-a1ce-fe36ec7fbce8"},{"index":21484,"token":false,"name":"Bog Rats","scryfallId":"d64c9153-bc6d-4a64-885f-c039a5487a31"},{"index":21485,"token":false,"name":"Predator, Flagship","scryfallId":"838a9ce9-7175-475b-993f-fff7685b8f54"},{"index":21487,"token":false,"name":"Nomad Mythmaker","scryfallId":"0468f109-8020-4a74-8ffd-bba771362f76"},{"index":21491,"token":false,"name":"Reyav, Master Smith","scryfallId":"90307dd6-196d-4d51-9b3f-6ff339882d31"},{"index":21495,"token":true,"name":"Angel of Sanctions Token (W, 3/4)","scryfallId":"a1786cb3-6f38-4f10-b5f1-8feb20e3baaf"},{"index":21497,"token":true,"name":"Steadfast Sentinel Token (B, 4/4)","scryfallId":"872694ba-0666-43c1-8884-47a2e92a127c"},{"index":21498,"token":false,"name":"Reshape the Earth","scryfallId":"ada14bc8-4549-4a73-8cbb-9a43698deb36"},{"index":21503,"token":false,"name":"Ninja of the New Moon","scryfallId":"08be60eb-15ec-4112-919c-995062a9ed54"},{"index":21504,"token":false,"name":"Auratog","scryfallId":"8a63fab4-8e9d-4972-9e3d-51ce8575535b"},{"index":21505,"token":false,"name":"Gift of Tusks","scryfallId":"3821122c-c495-42b0-b8f6-3f469967f16d"},{"index":21510,"token":false,"name":"Everdawn Champion","scryfallId":"46c38e2a-3a82-402f-a436-f9ebb2ba2ea4"},{"index":21511,"token":false,"name":"Wild Aesthir","scryfallId":"feffa722-fe05-4e70-ba4c-1cf110b3662f"},{"index":21514,"token":false,"name":"Sparkmage's Gambit","scryfallId":"736ad6c8-e275-4644-9d1e-d2d380149839"},{"index":21519,"token":false,"name":"Saltfield Recluse","scryfallId":"667a8a34-5f4c-43c3-9010-5c43453916f5"},{"index":21524,"token":false,"name":"Zabaz, the Glimmerwasp","scryfallId":"5d58a96f-939c-4b9b-a4c2-fb83d896eefb"},{"index":21526,"token":false,"name":"Pierce the Sky","scryfallId":"e391d93e-aebb-459e-9fb5-b2a3dc5c59b8"},{"index":21527,"token":false,"name":"Crown of Ascension","scryfallId":"2fe86733-7851-4c2a-8d94-dba6f071b94d"},{"index":21535,"token":false,"name":"Chief of the Edge","scryfallId":"28822a9a-97fa-4784-ad97-072fcfc7b9ed"},{"index":21536,"token":false,"name":"Tectonic Reformation","scryfallId":"49052be3-9d40-4363-9613-c2098b26eebf"},{"index":21537,"token":false,"name":"Dust Corona","scryfallId":"bb554768-d908-474d-832d-d4e36d293712"},{"index":21539,"token":false,"name":"Giantbaiting","scryfallId":"0fa3dd33-7240-4b32-b5ee-a67f24b42e4d"},{"index":21545,"token":false,"name":"Rune-Cervin Rider","scryfallId":"9d9574f6-40b3-4fe2-950c-234bc358ecf6"},{"index":21546,"token":false,"name":"Nettle Drone","scryfallId":"e633833a-cc4b-4c8c-a0d3-cd263e09df81"},{"index":21547,"token":false,"name":"Nema Siltlurker","scryfallId":"a477e081-949f-4cf0-b0d2-b9bdff6c760d"},{"index":21549,"token":false,"name":"Slinking Serpent","scryfallId":"070a7004-5a28-4ccb-8640-ad6b07b51ece"},{"index":21556,"token":false,"name":"Laccolith Grunt","scryfallId":"f27fd65a-5631-491f-b158-45012832ccf1"},{"index":21559,"token":false,"name":"Ezzaroot Channeler","scryfallId":"a7fd9ede-cc6e-4a96-934b-d91d4aa7fa0a"},{"index":21562,"token":false,"name":"Divine Intervention","scryfallId":"e250897e-a875-4c3c-bfec-4a09143dd587"},{"index":21563,"token":false,"name":"Lagonna-Band Storyteller","scryfallId":"c3a87498-2c2c-411a-aa71-d594b2c6cb26"},{"index":21566,"token":false,"name":"Nullpriest of Oblivion","scryfallId":"2774af92-db1a-4541-bf5c-0c34bf543aca"},{"index":21573,"token":false,"name":"Akki Raider","scryfallId":"c8fb34ae-157c-4f4b-bb47-2a9dc394a20c"},{"index":21576,"token":false,"name":"Ancient Runes","scryfallId":"e315c1c2-436e-48ff-9214-938697178393"},{"index":21580,"token":false,"name":"Boros Mastiff","scryfallId":"27a3bfb6-3843-4bda-bbcb-905e4b351dea"},{"index":21582,"token":false,"name":"Forsaken Wastes","scryfallId":"198cc126-f697-4aca-a6c9-4ae2ce1ee36f"},{"index":21583,"token":false,"name":"Ainok Tracker","scryfallId":"0ff9400d-4842-471f-bf7e-3b21df352e0a"},{"index":21585,"token":false,"name":"Intimidation Bolt","scryfallId":"17e4fb54-9f31-4d75-b4ab-7b11f745b807"},{"index":21587,"token":false,"name":"Spurnmage Advocate","scryfallId":"9c014b89-895c-432f-94f5-cda2dfac57e4"},{"index":21588,"token":false,"name":"Claim // Fame","scryfallId":"d6bf44f3-3d3d-444b-a2ec-fa223d745b7b"},{"index":21589,"token":false,"name":"Wild Instincts","scryfallId":"58fafd9d-777f-4d88-ad93-63af6d7ef274"},{"index":21592,"token":false,"name":"Voltaic Construct","scryfallId":"a1ca55ec-d262-40d8-b654-40e177bcfd6e"},{"index":21594,"token":false,"name":"Order // Chaos","scryfallId":"2a427922-c659-4563-ada5-4237e3e6353b"},{"index":21599,"token":false,"name":"Luminous Guardian","scryfallId":"a5becc51-4df8-4f67-a029-42a3da598a26"},{"index":21601,"token":false,"name":"Light of Promise","scryfallId":"d5f80411-0a95-4e0a-b7a8-af23ddf385cc"},{"index":21608,"token":false,"name":"Gruul Beastmaster","scryfallId":"2b0aaded-515f-4ac9-a72f-6948b4d4df51"},{"index":21612,"token":false,"name":"Desert's Hold","scryfallId":"8082298e-05c4-48b3-9367-713f59aafdc6"},{"index":21613,"token":true,"name":"Satyr Token (G/R, 2/2)","scryfallId":"baa93038-2849-4c26-ab4f-1d50d276659f"},{"index":21614,"token":false,"name":"Turn Against","scryfallId":"4de8ef35-f141-4bc6-8ea1-f87aa6f5ecd7"},{"index":21616,"token":false,"name":"Mu Yanling, Celestial Wind","scryfallId":"84ae9595-8e76-4d8c-a08c-00434be75672"},{"index":21619,"token":false,"name":"Phyrexian Digester","scryfallId":"f9112062-1a1b-462b-85d3-821ea91778b8"},{"index":21620,"token":false,"name":"Python","scryfallId":"e7e99969-6c21-4de6-ba57-44ef7f9c8c47"},{"index":21622,"token":false,"name":"Kor Firewalker","scryfallId":"ae763b22-68f2-44af-90ba-8df7309231e3"},{"index":21626,"token":false,"name":"Teyo's Lightshield","scryfallId":"dfffe235-98b1-43db-9461-1b2da5f0690e"},{"index":21627,"token":false,"name":"Grand Warlord Radha","scryfallId":"75d57c2c-147f-4d78-b990-bca9d7b697a0"},{"index":21629,"token":true,"name":"1998 World Championships Ad","scryfallId":"25e228f1-8619-4a9a-a01f-727c50abf733"},{"index":21631,"token":false,"name":"Scarland Thrinax","scryfallId":"e2a179b9-e962-49a4-ad92-8cd0291296c1"},{"index":21633,"token":false,"name":"Apex Hawks","scryfallId":"2dcbd8bc-45c8-48a9-bfb6-a2146fd26061"},{"index":21636,"token":false,"name":"Merfolk Seastalkers","scryfallId":"4fe5d069-45a0-46ea-b3ec-4e75f0531382"},{"index":21637,"token":false,"name":"Ornamental Courage","scryfallId":"ec0c49ab-da04-4461-8440-d6c9086443c6"},{"index":21638,"token":false,"name":"Mysterious Egg","scryfallId":"f333b41d-e42c-4b12-be08-742eefb4e401"},{"index":21645,"token":false,"name":"Kinsbaile Borderguard","scryfallId":"82a2e219-9e84-4f54-88e2-3925e48c4827"},{"index":21657,"token":false,"name":"Death Wind","scryfallId":"462a0961-cca5-4d63-867f-7426dbef8639"},{"index":21659,"token":false,"name":"Battering Krasis","scryfallId":"5d9aa740-9adf-412a-b6ec-0b9bb1b4618b"},{"index":21660,"token":false,"name":"Celestial Colonnade","scryfallId":"af33a0a6-8391-44d7-a9b8-71ed61ba9731"},{"index":21664,"token":false,"name":"Stormscape Battlemage","scryfallId":"d4f67ad7-4080-4b95-a210-52fe4651fbe9"},{"index":21666,"token":false,"name":"Zurzoth, Chaos Rider","scryfallId":"3d94b4c3-7944-41b6-8c92-78fd6e50658d"},{"index":21671,"token":false,"name":"Quicksilver Dragon","scryfallId":"e93577bd-2711-443c-aa88-a235345d7800"},{"index":21673,"token":false,"name":"War Barge","scryfallId":"9023c078-4169-498b-8626-a4862e0631f8"},{"index":21676,"token":false,"name":"Battlewise Hoplite","scryfallId":"4c929a57-2c23-4bbf-b265-666630a4fde8"},{"index":21677,"token":false,"name":"Demonic Vigor","scryfallId":"09950456-09d6-4675-9995-0dc540ddb6e4"},{"index":21681,"token":false,"name":"Shadow Guildmage","scryfallId":"ba3fc11e-db36-430c-920b-31195913c16a"},{"index":21682,"token":false,"name":"Bump in the Night","scryfallId":"5c3ec389-a267-484f-994d-4a29ef494eb1"},{"index":21686,"token":false,"name":"Norritt","scryfallId":"35abefe6-c39b-4fe5-b2e3-d213f0c4f447"},{"index":21687,"token":false,"name":"Forbidden Lore","scryfallId":"366069fb-3322-4992-aa1e-858951a8c492"},{"index":21689,"token":false,"name":"Canal Dredger","scryfallId":"a5365f0d-5e51-4e5d-9385-c4d08882c24f"},{"index":21690,"token":false,"name":"Dimir Guildmage","scryfallId":"69b822aa-4144-400a-b993-f146cbeed54f"},{"index":21692,"token":false,"name":"Arisen Gorgon","scryfallId":"e39502fd-193c-4526-8dd8-0cd8c822552c"},{"index":21693,"token":false,"name":"Sol Grail","scryfallId":"62652722-e345-4670-9547-d9579efa227d"},{"index":21694,"token":false,"name":"Rhox Veteran","scryfallId":"6384e266-d0dc-4af1-b3ab-ecaf9be2553c"},{"index":21695,"token":false,"name":"Executioner's Hood","scryfallId":"7447d115-9b29-4086-8435-40c7c957f242"},{"index":21698,"token":false,"name":"Tragic Lesson","scryfallId":"a0f0353c-f1e0-49db-9edc-eea9090de872"},{"index":21703,"token":false,"name":"Elemental Uprising","scryfallId":"e194b283-a7d2-4c0a-9ee2-8689a8e911b9"},{"index":21704,"token":false,"name":"Dovin's Acuity","scryfallId":"0b191592-7221-422a-8b5a-65f7b1caec1a"},{"index":21705,"token":false,"name":"Cast Through Time","scryfallId":"c9850489-c056-4b17-8743-a5b514d8edf4"},{"index":21710,"token":false,"name":"Squee, the Immortal","scryfallId":"a3974c62-a524-454e-9ce7-2c23b704e5cb"},{"index":21712,"token":false,"name":"Indomitable Ancients","scryfallId":"ddf33cb6-d159-4af3-8403-d0ac10af9894"},{"index":21716,"token":false,"name":"Vigilant Martyr","scryfallId":"a02e3c10-cc21-4e06-a987-b03aee61bd50"},{"index":21717,"token":false,"name":"Ant Queen","scryfallId":"6ee46d8b-559e-4c33-99fb-b55f00aeee72"},{"index":21718,"token":false,"name":"Arcades Sabboth","scryfallId":"8520de8b-0d8d-465a-b112-342ecbbaffa6"},{"index":21720,"token":false,"name":"Master of Pearls","scryfallId":"24decff2-6fb5-4666-83b6-b1860649bc0e"},{"index":21723,"token":false,"name":"Entrapment Maneuver","scryfallId":"229c1b67-cb5e-48d1-bc9e-db19126352d1"},{"index":21726,"token":false,"name":"Verdant Succession","scryfallId":"bd3c78de-0c2a-441e-8912-ff920fc563ef"},{"index":21728,"token":false,"name":"Leyline of Abundance","scryfallId":"35ceac21-f2c6-4f48-8bf3-04a005ade645"},{"index":21733,"token":false,"name":"Root Maze","scryfallId":"727c757a-2ae5-45fd-9832-646a355a5710"},{"index":21735,"token":false,"name":"Tyrite Sanctum","scryfallId":"53d85e79-ec12-41bc-bbd7-5cf37e889051"},{"index":21737,"token":false,"name":"Glyph Keeper","scryfallId":"a81b7f8d-d931-4b7e-b48f-9f6207abb9cb"},{"index":21739,"token":false,"name":"Tolarian Drake","scryfallId":"e04bba8a-48ee-4981-adc2-4f82c0f2c1bd"},{"index":21741,"token":false,"name":"Adventurers' Guildhouse","scryfallId":"32865e68-5842-4f17-b2ea-4ffa743b511f"},{"index":21747,"token":false,"name":"Strength of the Pack","scryfallId":"81a1ba0c-1131-4b16-9a11-90947cdb6292"},{"index":21751,"token":false,"name":"Dire Fleet Ravager","scryfallId":"53bd7ccc-aa71-4a3f-a86e-936cb3b2cce3"},{"index":21755,"token":false,"name":"Leave No Trace","scryfallId":"58466d46-7225-42ff-8471-6d489be32cf3"},{"index":21756,"token":false,"name":"Relic Bane","scryfallId":"9cbafa51-693b-485c-807d-64020540f16a"},{"index":21757,"token":false,"name":"Territorial Roc","scryfallId":"0c83aa5e-b607-4c4f-a5f6-db61c93a1152"},{"index":21759,"token":false,"name":"Peak Eruption","scryfallId":"ed0a00f7-aee0-4ab2-bab6-bc0949176a7a"},{"index":21763,"token":false,"name":"Broken Dam","scryfallId":"a0f7b8b1-f1dc-46a3-8f4a-c6181e8a049f"},{"index":21765,"token":false,"name":"Downpour","scryfallId":"f220afb1-8638-4b54-b6af-0043b4cc1cef"},{"index":21767,"token":false,"name":"Obelisk of Grixis","scryfallId":"e45bffc0-a12e-4c0e-81de-8d5b91109330"},{"index":21768,"token":false,"name":"Tolarian Kraken","scryfallId":"c2776694-6183-498d-9a38-e4c5c9e78179"},{"index":21771,"token":false,"name":"Ley Line","scryfallId":"f8990efd-708a-4019-bce0-2d6409ecc004"},{"index":21774,"token":false,"name":"Afiya Grove","scryfallId":"c495e1f3-0845-4556-83e6-de8b9d518d1d"},{"index":21782,"token":false,"name":"Rhystic Scrying","scryfallId":"81a59737-f06f-49b7-a490-3dc1115b47b7"},{"index":21783,"token":false,"name":"Soltari Visionary","scryfallId":"f67bb845-8ace-47e4-b18b-7b4d20931308"},{"index":21784,"token":false,"name":"Bower Passage","scryfallId":"b9f0048f-aaa0-4597-b898-ee754d0bbe4b"},{"index":21786,"token":false,"name":"Flash Foliage","scryfallId":"b71c63da-dfe3-475f-88d9-20008c01163a"},{"index":21787,"token":false,"name":"Renegade Wheelsmith","scryfallId":"792e3f9f-07e4-4fec-95f5-5b58f1fe6ab0"},{"index":21788,"token":false,"name":"Steel Sabotage","scryfallId":"c227437d-1fc7-4a00-ace5-80795adc51d3"},{"index":21791,"token":false,"name":"Essence Fracture","scryfallId":"df0b6c7a-0891-492d-8e07-6a198bf2ccc4"},{"index":21794,"token":false,"name":"Junk Diver","scryfallId":"119a814f-0325-4b69-a0b6-4c623b981f4a"},{"index":21796,"token":false,"name":"Fireshrieker","scryfallId":"9f653742-b92a-4cfa-b3b5-8d20aabdb5dd"},{"index":21798,"token":false,"name":"Frontier Mastodon","scryfallId":"26d480cb-3893-4bf8-b5df-d6119ad5b8a0"},{"index":21802,"token":false,"name":"Blood Aspirant","scryfallId":"8d4f3fa3-ba1f-48dc-a56b-738936f1bf86"},{"index":21804,"token":false,"name":"Stratozeppelid","scryfallId":"7ccfc49d-2a07-4088-a288-ba7be4da7bc2"},{"index":21806,"token":false,"name":"Drastic Revelation","scryfallId":"90f1f430-d6a5-4380-95f2-9e0fc9e81597"},{"index":21808,"token":false,"name":"Everglades","scryfallId":"c1f2eaf7-7f08-446b-892f-5a844f74808f"},{"index":21810,"token":false,"name":"Dark Petition","scryfallId":"7094e9d4-ba51-40d6-b95c-1970d3f89a66"},{"index":21814,"token":false,"name":"Valakut Predator","scryfallId":"88318272-8192-4d6d-a22a-eca87abb480d"},{"index":21815,"token":false,"name":"Grim Harvest","scryfallId":"bdb1972f-2ef7-4fe2-8c8e-ab07f48a3176"},{"index":21817,"token":false,"name":"Chancellor of the Dross","scryfallId":"eec6d85e-6263-44b4-a91f-d51585c561c2"},{"index":21823,"token":false,"name":"Thought Nibbler","scryfallId":"7284a7fd-cda8-43ac-b119-ad47b33c2ec4"},{"index":21824,"token":false,"name":"Psychic Theft","scryfallId":"f6f86c92-c19e-4f2c-96d3-d3b05623cb00"},{"index":21825,"token":false,"name":"Goblin Cannon","scryfallId":"b023c0cd-7046-418b-ad31-5c91c6930d45"},{"index":21826,"token":false,"name":"Kor Aeronaut","scryfallId":"dd9dc5af-0fc9-4e2a-9980-180459eeba07"},{"index":21827,"token":false,"name":"Ondu Greathorn","scryfallId":"33f7e1dc-ad84-41af-8ca0-6ffb3d7d645a"},{"index":21829,"token":false,"name":"Megantic Sliver","scryfallId":"3ddea611-856c-41e4-909a-80826f3dfca1"},{"index":21830,"token":false,"name":"Tower of Fortunes","scryfallId":"7622d6fe-73f2-417c-806c-8ca13192d271"},{"index":21832,"token":false,"name":"Niv-Mizzet Reborn","scryfallId":"71b2b245-05b5-4fb6-9beb-8c1bb1f08e3f"},{"index":21838,"token":false,"name":"Gideon's Sacrifice","scryfallId":"849c79ad-8bfc-4512-ab41-f213b6b285ab"},{"index":21840,"token":false,"name":"Marit Lage's Slumber","scryfallId":"4f5d2a6e-22cd-4493-9e58-e9c2aa3a31ab"},{"index":21847,"token":false,"name":"Brawler's Plate","scryfallId":"da0a017e-eb8e-4f92-91f7-7d980461e284"},{"index":21848,"token":false,"name":"Mistform Shrieker","scryfallId":"d1f0d34b-ab98-4bb4-8795-58688bcf02b5"},{"index":21849,"token":false,"name":"Pinpoint Avalanche","scryfallId":"d5cf8876-4c7d-4779-9363-d0a58bb7d851"},{"index":21850,"token":false,"name":"Orzhov Euthanist","scryfallId":"104adc35-69fb-4b63-9b03-a71097e15652"},{"index":21852,"token":false,"name":"Sages of the Anima","scryfallId":"f98a21af-cd1a-4438-a4c2-0c92ad92efef"},{"index":21853,"token":false,"name":"Boseiju, Who Shelters All","scryfallId":"e01b7141-9576-445b-bcd4-00d79850a4dd"},{"index":21854,"token":false,"name":"Overmaster","scryfallId":"afd2e0f0-8a8e-4021-bd24-aff1a3212345"},{"index":21855,"token":false,"name":"Ravenous Baboons","scryfallId":"6d00b68b-8b6a-48c9-8911-2a3270897091"},{"index":21859,"token":false,"name":"Quicken","scryfallId":"e6209bbf-5861-4755-abb6-0f04def9527e"},{"index":21860,"token":false,"name":"Dream Twist","scryfallId":"a9fa20df-b8d5-4de7-a2fa-6ced4bfcf979"},{"index":21864,"token":false,"name":"Aboshan, Cephalid Emperor","scryfallId":"82db4a41-03e8-4f0c-946c-a98fc5c9f7c8"},{"index":21866,"token":true,"name":"Zombie Berserker Token (B, 2/2)","scryfallId":"e4bbd379-6728-4c6b-b375-295926fe6b00"},{"index":21869,"token":false,"name":"Talon of Pain","scryfallId":"cb4ab5e0-5f6b-422d-8ba7-9e0ce1450af8"},{"index":21871,"token":false,"name":"Repel","scryfallId":"68ea14a6-539a-47eb-9147-a310be7b63fe"},{"index":21873,"token":false,"name":"Savageborn Hydra","scryfallId":"c84a2043-d8e1-42e4-bbd4-0e6163ecd91f"},{"index":21875,"token":false,"name":"Ember Gale","scryfallId":"acf0cafc-ca14-4c1a-8237-565515a81dec"},{"index":21878,"token":false,"name":"Pilfered Plans","scryfallId":"3475fcc6-ee53-48da-89d2-80685a584e6a"},{"index":21880,"token":false,"name":"Artillerize","scryfallId":"034522ae-f531-44d9-b186-ada046ce0abc"},{"index":21882,"token":false,"name":"Time Stretch","scryfallId":"3c878780-f666-44ab-a60e-c9985f628fc3"},{"index":21885,"token":false,"name":"Shifty Doppelganger","scryfallId":"538ffe1e-c312-4797-99dd-9bf5f896bdc3"},{"index":21886,"token":false,"name":"Noxious Revival","scryfallId":"1bdd1243-1d14-496a-9b7a-0c5b34461361"},{"index":21888,"token":false,"name":"Sandbar Merfolk","scryfallId":"65ce3960-abf1-4f28-8434-ab3b27d3b7cb"},{"index":21889,"token":false,"name":"Warped Researcher","scryfallId":"5df94a4e-1371-4b75-a557-eeb83c23cf9d"},{"index":21891,"token":false,"name":"Razaketh, the Foulblooded","scryfallId":"e14adff9-33cc-467e-b782-068854c5e7b7"},{"index":21899,"token":false,"name":"Ember Hauler","scryfallId":"d9df1b79-bf3a-4da3-8d98-bdf175445f10"},{"index":21900,"token":false,"name":"Spirebluff Canal","scryfallId":"4e587ea7-0632-4789-ba75-3c410da2bb96"},{"index":21903,"token":false,"name":"Goblin Smuggler","scryfallId":"95dc1a65-271c-455a-ae0c-f652444a53ac"},{"index":21913,"token":false,"name":"Mirrorweave","scryfallId":"dea002c6-d15f-4536-9349-92c77ae5021a"},{"index":21915,"token":false,"name":"Tidal Visionary","scryfallId":"a72a3051-7f46-4b6b-b4fb-0f170d9687ab"},{"index":21916,"token":false,"name":"Eater of the Dead","scryfallId":"d89fe2be-bb7e-4bae-9b1f-9f0d58f20ceb"},{"index":21918,"token":false,"name":"Cathedral of War","scryfallId":"272257da-9126-40d1-af8e-9bd52dbe1c12"},{"index":21921,"token":false,"name":"Cultbrand Cinder","scryfallId":"f6b80a10-a9a9-445e-8040-6cc0155271d8"},{"index":21922,"token":false,"name":"Spawning Kraken","scryfallId":"44917638-3c84-4c21-b139-5084e6e1efc6"},{"index":21924,"token":false,"name":"Well-Laid Plans","scryfallId":"1c55eb8f-925a-42c1-9e48-d7f99cab3b01"},{"index":21926,"token":false,"name":"Sea Kings' Blessing","scryfallId":"11d1f02d-533e-4b77-a72a-ff5f91ae0626"},{"index":21927,"token":false,"name":"Sphinx's Insight","scryfallId":"d71c2435-0312-4279-a9e1-fab7432756b7"},{"index":21928,"token":false,"name":"Scourge Servant","scryfallId":"45ded51b-2ced-46d6-a1d4-0f49d4b1ed2d"},{"index":21931,"token":false,"name":"Altar Golem","scryfallId":"fed81c72-743d-4d2a-97a6-22f5651e15d5"},{"index":21932,"token":false,"name":"Elven Cache","scryfallId":"9dd8ccfe-9a64-4b5c-b7d7-a36ca99666ef"},{"index":21933,"token":false,"name":"Sauroform Hybrid","scryfallId":"2f7ecad5-8bb5-416f-b8ef-a04aba4dc4b5"},{"index":21936,"token":false,"name":"Calming Licid","scryfallId":"cfd7a1ae-f5e4-40d1-8408-82dfc052cc1e"},{"index":21937,"token":false,"name":"Karona's Zealot","scryfallId":"29214308-711a-490f-8e93-bf61baf1749c"},{"index":21943,"token":false,"name":"Aurification","scryfallId":"93d9e9ea-9f88-4206-8960-b5ebe839ee16"},{"index":21945,"token":false,"name":"Summary Judgment","scryfallId":"c0b20fec-8373-4c6c-b3c1-ee7cff64dd37"},{"index":21946,"token":false,"name":"Kranioceros","scryfallId":"52aece74-cc1f-4f32-ad1f-00733eb79007"},{"index":21949,"token":false,"name":"Krenko's Enforcer","scryfallId":"ce2ceeb0-03b6-48bc-a084-069176ebccb2"},{"index":21951,"token":false,"name":"Scatter the Seeds","scryfallId":"c4415070-4304-482b-b8e5-2bf689af0843"},{"index":21952,"token":false,"name":"Aethershield Artificer","scryfallId":"226f7c45-db9f-4d48-b575-4d2f1904c963"},{"index":21955,"token":false,"name":"Stun Sniper","scryfallId":"277bdef5-4887-42f5-b7c2-8c18f03db365"},{"index":21956,"token":false,"name":"Vulshok Gauntlets","scryfallId":"14a04bbd-1d07-4b11-aa54-01790b9dd3a0"},{"index":21957,"token":false,"name":"Ghostly Wings","scryfallId":"58fb2705-82e7-49d9-b8cc-f98f652dd6c1"},{"index":21966,"token":false,"name":"Battle Screech","scryfallId":"eacf7dd0-5855-4e7b-b75c-8119cc3d1460"},{"index":21971,"token":false,"name":"Paliano Vanguard","scryfallId":"2b120f2d-2585-4827-a8c5-d6ecdc8108e5"},{"index":21972,"token":false,"name":"Dauntless Aven","scryfallId":"0ae07a9b-dfb3-4387-a415-fabaff4370bb"},{"index":21973,"token":false,"name":"Charity Extractor","scryfallId":"3594f726-cdbb-4b7d-bcfe-17d5f8cd5228"},{"index":21976,"token":false,"name":"Cultural Exchange","scryfallId":"d4f38d07-829c-4311-a61b-2785cf2266ef"},{"index":21977,"token":true,"name":"Llanowar Elves Token (G, 1/1)","scryfallId":"cbcb0668-e88c-4462-b079-34f140c0277e"},{"index":21980,"token":false,"name":"Hypnox","scryfallId":"0e0e53a1-11d5-4975-b698-8b5d72d241f0"},{"index":21984,"token":false,"name":"Deep Forest Hermit","scryfallId":"96c5607b-55fe-43c2-93fe-0084d84499d9"},{"index":21988,"token":false,"name":"Eidolon of Countless Battles","scryfallId":"4d16283b-b5bb-48e8-8c97-db5ad74fd544"},{"index":21992,"token":false,"name":"Rootgrapple","scryfallId":"0fe6051f-6252-4ad1-90ab-d21705a708d1"},{"index":21995,"token":false,"name":"Sunbird's Invocation","scryfallId":"c665dd04-6e2a-4bb3-b800-235a13ae67d4"},{"index":22001,"token":false,"name":"Heartbeat of Spring","scryfallId":"6be3ba05-dce0-463b-bfe6-d51df63cc1a8"},{"index":22003,"token":false,"name":"Stoic Farmer","scryfallId":"f53f39e9-f07e-444f-8420-4545e56253e5"},{"index":22005,"token":false,"name":"Typhoid Rats","scryfallId":"9f8723f6-96b1-4441-8a57-435fb82d6db4"},{"index":22008,"token":false,"name":"Dire Wolves","scryfallId":"a602c93d-e00f-4b4f-a7ff-95316b7e7641"},{"index":22009,"token":false,"name":"Wall of Forgotten Pharaohs","scryfallId":"d3f8f211-79f9-4d34-8e23-c0835703cd91"},{"index":22010,"token":false,"name":"Harvest Wurm","scryfallId":"9d21139d-edfc-4140-aa43-d4165331d7f3"},{"index":22017,"token":false,"name":"Artificer's Assistant","scryfallId":"deadf867-b999-49b2-88d8-91da975a3cc5"},{"index":22018,"token":false,"name":"Esior, Wardwing Familiar","scryfallId":"ae854d22-f511-4bed-b30f-b3b52aed50a4"},{"index":22019,"token":false,"name":"Phylactery Lich","scryfallId":"4aefd084-548d-4326-901e-832a1b5f5391"},{"index":22021,"token":false,"name":"Anax, Hardened in the Forge","scryfallId":"badac9b4-bfaf-4b02-a48a-ec141393566c"},{"index":22029,"token":false,"name":"Dawn's Reflection","scryfallId":"d0994be7-fc69-426f-b01b-cff05b5e2fa7"},{"index":22030,"token":false,"name":"Demoralize","scryfallId":"2e2f16f9-4980-45e9-99bf-0e00e3008b1d"},{"index":22033,"token":true,"name":"Construct Token (Colorless, 1/1)","scryfallId":"3462c167-e6cf-46f8-9b77-2a88815e3b82"},{"index":22034,"token":false,"name":"Priest of Forgotten Gods","scryfallId":"e3378fe8-3355-48aa-90d4-9cb739200160"},{"index":22035,"token":false,"name":"Aether Swooper","scryfallId":"d0a0595f-b98d-4593-a25f-3cfc5db14668"},{"index":22036,"token":false,"name":"Carnivorous Moss-Beast","scryfallId":"bd814ce3-9555-4e9d-a212-e40717f4e546"},{"index":22037,"token":false,"name":"Phyrexian Unlife","scryfallId":"b4a1e16a-39f0-47ab-aba8-73e82ba9ab18"},{"index":22038,"token":false,"name":"Magma Phoenix","scryfallId":"b3857c9b-136d-4e6a-bd3b-92dab1b71947"},{"index":22039,"token":false,"name":"Human Frailty","scryfallId":"1d1de712-86ac-4c03-be86-2403cd121f66"},{"index":22041,"token":false,"name":"Rotting Legion","scryfallId":"bfe5e62c-83ce-4c2b-a745-acd7670e115d"},{"index":22052,"token":false,"name":"Thunder Strike","scryfallId":"abdc38f3-194a-4f43-8ada-9cfc17094d20"},{"index":22053,"token":false,"name":"Essence of the Wild","scryfallId":"dec48cba-1b5d-44e7-9e25-16922dedb67d"},{"index":22054,"token":false,"name":"Nightmare Incursion","scryfallId":"7cccd244-9fd4-4f58-85da-af6d235ef7bb"},{"index":22057,"token":false,"name":"Festering Newt","scryfallId":"05764968-0abe-4a6f-9f8a-066a4d484571"},{"index":22063,"token":false,"name":"Lightning Angel","scryfallId":"47a2145c-7d71-40db-8963-596288773681"},{"index":22066,"token":false,"name":"Kalonian Tusker","scryfallId":"135946fc-fe67-401f-821d-d7145c63f030"},{"index":22070,"token":false,"name":"Jhoira's Toolbox","scryfallId":"edb38309-c02c-496c-894f-786a2f6e3d1c"},{"index":22071,"token":false,"name":"Ember Weaver","scryfallId":"81472afe-9e3d-4477-bd88-46bc5a2f3416"},{"index":22073,"token":false,"name":"Kyren Negotiations","scryfallId":"0c263a17-bbc2-433e-93f8-72e57b818322"},{"index":22076,"token":false,"name":"Forever Young","scryfallId":"7873c1f9-572c-4740-82f8-cf3cbc7318d0"},{"index":22081,"token":false,"name":"Battlefront Krushok","scryfallId":"e3b425cd-c5a5-48e9-b697-3860dfa6d5d3"},{"index":22094,"token":false,"name":"Ancient Hellkite","scryfallId":"96cede38-0f02-4ce0-b947-ce3d7d7c2882"},{"index":22106,"token":false,"name":"Blizzard","scryfallId":"c369e4f9-0f2b-446c-9e2d-d3eefab0586d"},{"index":22107,"token":false,"name":"Frost Trickster","scryfallId":"fd79c9cc-0a8c-4d88-96e2-cb177134a18d"},{"index":22109,"token":false,"name":"Nephalia Academy","scryfallId":"9243eb5b-905e-446f-9ee0-7557e3b31db3"},{"index":22110,"token":false,"name":"Vodalian Merchant","scryfallId":"c1c0effa-a4b8-4166-a66a-90cf01c6ea0d"},{"index":22112,"token":false,"name":"Nyxborn Seaguard","scryfallId":"9ad0c7d7-0e44-496f-a2fc-fafc604cb1f1"},{"index":22113,"token":false,"name":"Wormwood Treefolk","scryfallId":"2fa20173-e88a-4b14-9c54-14567ca5571c"},{"index":22114,"token":false,"name":"Deathcoil Wurm","scryfallId":"97cafdf4-e912-4855-8ff5-c3270eb876d8"},{"index":22115,"token":false,"name":"Mindblaze","scryfallId":"59418766-5567-4ec4-af1f-1cb2db2958d0"},{"index":22122,"token":false,"name":"Zhur-Taa Ancient","scryfallId":"2076308f-0f4e-4b31-9e75-c2965942e7d1"},{"index":22123,"token":false,"name":"Wolf's Quarry","scryfallId":"5d21c15f-378e-4abf-992f-9743aa6ab6b8"},{"index":22124,"token":false,"name":"Map the Wastes","scryfallId":"3d2cfee3-a5ca-4294-8189-97dbd71f57bc"},{"index":22128,"token":false,"name":"Wind Dancer","scryfallId":"469d217a-0f8c-48f8-bfc0-cf5e202c0ddc"},{"index":22131,"token":false,"name":"Drana, Liberator of Malakir","scryfallId":"31d0c37f-ebce-4362-9400-6b9a6e439247"},{"index":22133,"token":false,"name":"Nylea's Huntmaster","scryfallId":"2a4fe89a-0d2b-493f-883e-a1e0b0918340"},{"index":22134,"token":false,"name":"Benthic Behemoth","scryfallId":"cc9fb7b6-d20c-4c08-9dae-4ccc9138b662"},{"index":22135,"token":true,"name":"Saproling // Elf Knight Token (G/W, 2/2)","scryfallId":"cc77373d-34d1-475b-ade9-f49bb64bff9c"},{"index":22136,"token":false,"name":"Gainsay","scryfallId":"5d65d126-a225-434d-93e9-37c04897acda"},{"index":22144,"token":false,"name":"Wishful Merfolk","scryfallId":"a61a7809-4bef-48e9-afbc-e473eb7072e8"},{"index":22149,"token":false,"name":"Somberwald Sage","scryfallId":"409c0272-7a43-4a6c-ab3f-740397b1f5c8"},{"index":22150,"token":false,"name":"Sanity Gnawers","scryfallId":"c088d28d-16c2-4dd2-b036-946dfdb8ec98"},{"index":22151,"token":false,"name":"Gatekeeper Gargoyle","scryfallId":"4bbdd54e-5d7e-4e4b-8d59-4e3f46877d39"},{"index":22152,"token":false,"name":"Angelic Curator","scryfallId":"c63ba2da-6dea-44ac-8439-527222da565b"},{"index":22155,"token":false,"name":"Tajuru Pathwarden","scryfallId":"b073e75b-b432-41a5-a71e-d169fecf774f"},{"index":22157,"token":false,"name":"Coral Barrier","scryfallId":"f34cd305-d823-4996-9f8f-806386491f5d"},{"index":22159,"token":false,"name":"Vodalian Arcanist","scryfallId":"a52e90c0-b012-4ce5-8462-1e33c7143de5"},{"index":22163,"token":false,"name":"Prismatic Ward","scryfallId":"6f8b50fd-3d1d-4ea8-a3c7-98ca7a8a455e"},{"index":22165,"token":false,"name":"Path of Bravery","scryfallId":"6d389a05-2e1a-471d-a865-1c3b68a03e01"},{"index":22166,"token":false,"name":"Zara, Renegade Recruiter","scryfallId":"34b1455e-b9c2-4501-a24f-b50534466c31"},{"index":22167,"token":false,"name":"Swimmer in Nightmares","scryfallId":"ebc6b5ee-e764-444e-8b27-26e00f4b2074"},{"index":22168,"token":false,"name":"Spikeshot Goblin","scryfallId":"50b2651d-6418-42c6-abf4-e8cdb977833f"},{"index":22171,"token":false,"name":"Krumar Bond-Kin","scryfallId":"6f9fb16b-8a07-42ab-9008-5e3cae66a46f"},{"index":22172,"token":false,"name":"Aysen Crusader","scryfallId":"b865abb2-6bfe-4368-920b-a2c327fa6e43"},{"index":22175,"token":false,"name":"Healer's Flock","scryfallId":"b93b5429-8512-4ab6-9ecd-fa270e0144f3"},{"index":22176,"token":false,"name":"Death Match","scryfallId":"143e9057-267a-4c78-b72a-4f8018b627a8"},{"index":22177,"token":false,"name":"Skyhunter Cub","scryfallId":"17f573c5-7dba-4385-9c4f-30d512ca61a0"},{"index":22179,"token":false,"name":"Unbounded Potential","scryfallId":"9955a344-dcd8-404d-9757-f62ed158ba22"},{"index":22182,"token":false,"name":"Sewers of Estark","scryfallId":"b0da11d4-3603-4f59-8f61-7204bf04e165"},{"index":22183,"token":false,"name":"Bastion of Remembrance","scryfallId":"2dd354dd-939e-4b1a-8ed6-fe89a7fd64bf"},{"index":22184,"token":false,"name":"Pyromancer Ascension","scryfallId":"0f9cea68-4390-4d73-a374-d6299cbc9271"},{"index":22185,"token":false,"name":"Zurgo Helmsmasher","scryfallId":"41c14eef-852c-4094-b3e7-cdf47306d0b5"},{"index":22187,"token":false,"name":"Ronin Cavekeeper","scryfallId":"3c532e5a-01f4-4258-ba48-99257cc577d4"},{"index":22189,"token":true,"name":"Temmet, Vizier of Naktamun Token (W, 2/2)","scryfallId":"5a6201e6-7dcd-40b1-97aa-fd9c860cea97"},{"index":22193,"token":false,"name":"Sunhome Guildmage","scryfallId":"d1d2de3e-5885-45df-8570-69d2d3e0e25c"},{"index":22197,"token":false,"name":"Great Wall","scryfallId":"cd860a1d-aa17-4579-b9b1-d101d2416387"},{"index":22200,"token":false,"name":"Yoke of the Damned","scryfallId":"8786d461-0ea5-4224-82e4-bfbe4d0d8b9f"},{"index":22201,"token":false,"name":"Bloodscale Prowler","scryfallId":"8197cc43-c787-4372-81dc-759a9fe24708"},{"index":22202,"token":false,"name":"Allied Reinforcements","scryfallId":"fd7d7c93-5622-45ca-9359-110685d9162c"},{"index":22204,"token":false,"name":"Twinning Staff","scryfallId":"e7971306-700e-4677-bf52-83e4f9ac04c1"},{"index":22205,"token":false,"name":"Hornbash Mentor","scryfallId":"d47d2596-a321-44c0-a9f6-87bf80abc1c4"},{"index":22206,"token":false,"name":"Inspiring Captain","scryfallId":"d1aab968-fdf2-4035-8c04-04169c113153"},{"index":22211,"token":false,"name":"Wasteland Strangler","scryfallId":"d7777518-2c63-44af-b85a-fd4c79eb8ea1"},{"index":22215,"token":false,"name":"Detection Tower","scryfallId":"a7288ec7-69e3-49db-bd76-13f8c61c703b"},{"index":22217,"token":false,"name":"Lunk Errant","scryfallId":"f459acfa-a9db-43c6-b0e9-ed66d772a335"},{"index":22222,"token":false,"name":"Planeswalker's Mischief","scryfallId":"79aa232c-3f16-4c68-99dc-09a7aeef477b"},{"index":22229,"token":false,"name":"Baral's Expertise","scryfallId":"d273f5b7-b3a3-485a-acc8-34e10a504646"},{"index":22234,"token":false,"name":"Jagged Poppet","scryfallId":"e796a838-3599-4769-b90b-9bbbaad76fcb"},{"index":22238,"token":false,"name":"Merciless Javelineer","scryfallId":"2e3ba102-ef8b-43ca-8add-6cc87ab3af9f"},{"index":22242,"token":false,"name":"Steam Augury","scryfallId":"6b63ac91-ea7b-4a6f-a53e-f2a216c01d80"},{"index":22245,"token":false,"name":"Simian Brawler","scryfallId":"df2ed9f3-50b1-493b-9c14-0f8ddb4d8c57"},{"index":22250,"token":false,"name":"Eastern Paladin","scryfallId":"d75f7d29-9c73-4b5e-a6fd-5608bb737278"},{"index":22253,"token":false,"name":"Skyshroud Vampire","scryfallId":"de545a92-a489-4695-8a03-c02a8e92f1b6"},{"index":22258,"token":false,"name":"Plaxcaster Frogling","scryfallId":"64bb1946-8057-4a31-9de7-4bd1a9845165"},{"index":22260,"token":false,"name":"The Crowd Goes Wild","scryfallId":"94ae9160-5bc0-4162-8ea6-ef11c387c195"},{"index":22262,"token":false,"name":"Rusting Golem","scryfallId":"c2605448-8e0d-492b-a635-468923c64625"},{"index":22265,"token":false,"name":"Phyrexian Tower","scryfallId":"566e84c2-c6b6-429c-8a31-ffc99cebc396"},{"index":22269,"token":false,"name":"Expedition Champion","scryfallId":"30084dc1-f501-4b7c-972d-1a3b9137083a"},{"index":22273,"token":false,"name":"Ribbons of Night","scryfallId":"a5053c57-599d-4487-a7e2-97d60a2b6165"},{"index":22274,"token":false,"name":"Bold Defense","scryfallId":"5f657723-dd5d-4786-9d9b-ac7ed279615a"},{"index":22282,"token":false,"name":"Glowing Anemone","scryfallId":"708593e6-787b-4f76-a86c-1d52857493ea"},{"index":22283,"token":false,"name":"Woodland Mystic","scryfallId":"2d6117cf-5cb3-41f3-8756-c01b5e9c760e"},{"index":22293,"token":false,"name":"Elite Spellbinder","scryfallId":"d68ff357-456f-4b8a-90fa-a209c409de3c"},{"index":22297,"token":false,"name":"Staggershock","scryfallId":"7c7eeca0-a4cf-455f-888c-57571cf3555d"},{"index":22300,"token":false,"name":"Bloodmist Infiltrator","scryfallId":"909489a9-2678-4b6f-9d5e-2c04bb4cbd66"},{"index":22301,"token":true,"name":"Snake Token (G/U, 1/1)","scryfallId":"153f01ac-8601-488f-8da7-72f392c0a3c6"},{"index":22302,"token":false,"name":"Whipflare","scryfallId":"3be1bd09-ffa4-4ec9-9b07-de90b2e67114"},{"index":22307,"token":false,"name":"Scroll of Fate","scryfallId":"a25ffab0-1119-4eca-9abe-077a699f19d0"},{"index":22315,"token":false,"name":"Granitic Titan","scryfallId":"607bdb54-a956-4a9c-89cf-af6f1163b856"},{"index":22320,"token":false,"name":"Willow Dryad","scryfallId":"dd1d6b6e-ad4d-4fd4-bdd2-6a308d6cd2aa"},{"index":22323,"token":false,"name":"Living Plane","scryfallId":"0341da27-3d77-4959-b7fa-5929b2cc7141"},{"index":22325,"token":false,"name":"Lumbering Satyr","scryfallId":"5d897088-0667-4864-91c3-5f0ac7f9b220"},{"index":22326,"token":false,"name":"Wall of Distortion","scryfallId":"d2b2d07a-9ea1-430d-b432-ae507f4fe73b"},{"index":22327,"token":false,"name":"Kediss, Emberclaw Familiar","scryfallId":"23766fa0-e673-46c7-a29f-3fb140844b1c"},{"index":22328,"token":false,"name":"Deeproot Warrior","scryfallId":"7c1a1963-ec46-4ed3-9be1-e4cc09687922"},{"index":22331,"token":false,"name":"Life's Finale","scryfallId":"ffd3fbd2-87c7-4f08-baaa-91d61c1114da"},{"index":22333,"token":false,"name":"Infernal Tutor","scryfallId":"6a4e4be5-e057-4b50-9f86-76bc0b9987de"},{"index":22337,"token":false,"name":"Militia Bugler","scryfallId":"43c5bf25-937c-4e17-9ed4-b4c4579fa9dc"},{"index":22338,"token":false,"name":"Mox Diamond","scryfallId":"bf9fecfd-d122-422f-bd0a-5bf69b434dfe"},{"index":22339,"token":false,"name":"Odylic Wraith","scryfallId":"3a3b7cd1-051c-43a8-b5f0-72a9d704efbc"},{"index":22340,"token":false,"name":"Ferocity of the Wilds","scryfallId":"8f7005fd-5917-4f7d-9a7d-7ccc044d0f87"},{"index":22341,"token":false,"name":"Skyclave Pick-Axe","scryfallId":"9965a54b-8b22-418c-9a0d-bf154932f2e2"},{"index":22342,"token":false,"name":"Wandering Tombshell","scryfallId":"e66e1d97-d676-471a-a140-deb39600a7a9"},{"index":22343,"token":false,"name":"Seismic Strike","scryfallId":"156a28c2-ddff-4f46-a5c9-8908a67d20cc"},{"index":22347,"token":false,"name":"Azorius Knight-Arbiter","scryfallId":"60befc28-2ab8-4b59-a33f-0328c5d2f995"},{"index":22348,"token":true,"name":"Giant Teddy Bear Token (Colorless, 5/5)","scryfallId":"628c542b-7579-4070-9143-6f1f7221468f"},{"index":22349,"token":false,"name":"Read the Runes","scryfallId":"5d42a892-e5d4-4c73-8316-b7a08c5c09cc"},{"index":22351,"token":false,"name":"Acolyte of Xathrid","scryfallId":"4b0b14d4-41de-42ac-9894-77bbcebaabfc"},{"index":22352,"token":false,"name":"Hunter Sliver","scryfallId":"ca9aea1a-6f50-4f66-9f36-2e214dce41b4"},{"index":22353,"token":false,"name":"Eye Spy","scryfallId":"74d0fa75-41dc-4fe9-af12-d9d4006b708f"},{"index":22355,"token":false,"name":"Coastline Marauders","scryfallId":"7a47e6bc-422a-4627-b21e-5a042193bed0"},{"index":22359,"token":false,"name":"Clockwork Condor","scryfallId":"02a7e1a6-347e-47bc-8a14-e584a45941e1"},{"index":22360,"token":false,"name":"Hamlet Captain","scryfallId":"43435939-20cf-49c9-8e37-63681740399b"},{"index":22361,"token":false,"name":"Purphoros, Bronze-Blooded","scryfallId":"3dd4cce9-a0b3-4ecb-9364-7ea7347f9d4c"},{"index":22364,"token":false,"name":"Ironshell Beetle","scryfallId":"7d5573f8-5fdd-4050-af2a-fbdec51e4f37"},{"index":22365,"token":false,"name":"Firesong and Sunspeaker","scryfallId":"649256e0-22ed-4a04-b770-47c18bd9de05"},{"index":22366,"token":false,"name":"Teferi's Veil","scryfallId":"cbf39b80-d972-4f79-902f-cc613c32e446"},{"index":22367,"token":true,"name":"Cat Warrior Token (G, 2/2)","scryfallId":"0742ca95-9455-4f56-b26c-2994d12af602"},{"index":22371,"token":false,"name":"Barkshell Blessing","scryfallId":"cd273ef2-4aed-4c7e-8c97-fe8b1af9ce69"},{"index":22372,"token":false,"name":"Favorable Winds","scryfallId":"adfe8174-4e75-4e8f-b59c-f80a98492b5f"},{"index":22378,"token":false,"name":"Thornado","scryfallId":"eadffd6b-d707-4fc5-a600-44eb9124b195"},{"index":22379,"token":false,"name":"Fortune Thief","scryfallId":"b9700b3c-c309-4305-8761-3cf3ec902639"},{"index":22382,"token":false,"name":"Wretched Gryff","scryfallId":"c08d4f91-3859-4c3b-8d56-d4bbe36c4de0"},{"index":22387,"token":false,"name":"Ocular Halo","scryfallId":"6c883e75-5c37-44bb-a6c8-f97aa704c739"},{"index":22388,"token":false,"name":"Illusionary Armor","scryfallId":"d09346ff-6e63-499b-9265-c15a7b2cdece"},{"index":22392,"token":false,"name":"Limestone Golem","scryfallId":"b522518c-1846-4e95-b77d-2aadac78684d"},{"index":22393,"token":false,"name":"Ambush","scryfallId":"b7dd8623-b64a-4b47-a69d-ed62d44596fb"},{"index":22395,"token":false,"name":"Wild Dogs","scryfallId":"d0d09d02-bfcf-4065-9fa3-7c511d905869"},{"index":22399,"token":false,"name":"Pattern of Rebirth","scryfallId":"9f23c4f4-a191-4225-a3b7-dab5b1462922"},{"index":22402,"token":false,"name":"Esper Battlemage","scryfallId":"2cac0076-8bd5-4fe2-bac8-fd102688fdcb"},{"index":22406,"token":false,"name":"Elegant Edgecrafters","scryfallId":"352941f3-951e-428d-bec4-7790c3ea7cb2"},{"index":22408,"token":false,"name":"Thada Adel, Acquisitor","scryfallId":"3bfcbeab-7a1e-4dcf-99bf-98f42c2b6a6f"},{"index":22409,"token":false,"name":"Selfless Exorcist","scryfallId":"c9b1c300-aec3-4512-9902-309615e86c73"},{"index":22410,"token":false,"name":"Phyrexian Reclamation","scryfallId":"2f47ec65-1ae0-4385-84d9-0b3f2239d2da"},{"index":22412,"token":false,"name":"Snake Cult Initiation","scryfallId":"93b47606-82d1-402c-b1c6-591457b10d86"},{"index":22413,"token":false,"name":"Haunting Misery","scryfallId":"939b83ba-8ba8-4b98-8a13-a037ba7805e9"},{"index":22415,"token":false,"name":"Fabrication Module","scryfallId":"f93a9693-f899-47ac-8ee0-3549d9333fff"},{"index":22416,"token":false,"name":"Flowstone Channeler","scryfallId":"9f10fa1c-2c7b-49ba-87b6-3b652b65704d"},{"index":22417,"token":false,"name":"Dizzying Gaze","scryfallId":"71a482cf-a1cd-47b5-a76a-08e03965c679"},{"index":22419,"token":false,"name":"Tranquil Domain","scryfallId":"801f34a6-9f22-43c2-b1e5-194395cc7da1"},{"index":22423,"token":false,"name":"Hogaak, Arisen Necropolis","scryfallId":"0049e68d-0caf-474f-9523-dad343f1250a"},{"index":22425,"token":false,"name":"Vile Redeemer","scryfallId":"a6d9ef87-cd84-452e-a54b-d919c02f450c"},{"index":22426,"token":false,"name":"Ior Ruin Expedition","scryfallId":"c7a6e64e-4a9d-4fab-b85c-e9c4e88bca2f"},{"index":22427,"token":false,"name":"Citanul Flute","scryfallId":"bf71fab2-d936-40f0-bda2-b0630948e1fa"},{"index":22429,"token":false,"name":"Ashiok, Dream Render","scryfallId":"ee592de0-5f41-4017-b21d-ec8c65365582"},{"index":22430,"token":false,"name":"Sylvok Explorer","scryfallId":"3ed328af-bc0d-4a9d-a9ee-bc0196a2afaf"},{"index":22433,"token":false,"name":"Hardy Veteran","scryfallId":"62f2755f-276f-4260-a201-f02af88b5708"},{"index":22434,"token":false,"name":"Helm of Obedience","scryfallId":"fd71f8b8-2c6e-49b6-b0ac-d291c7042833"},{"index":22436,"token":false,"name":"Wizards' School","scryfallId":"b30d026a-4bb4-4dd8-9786-e60ff8f02e3b"},{"index":22437,"token":false,"name":"Mindless Automaton","scryfallId":"6ddfc5ab-b11b-4ad7-ab46-8ee60d938a5b"},{"index":22445,"token":false,"name":"Sliver Overlord","scryfallId":"2ffd66b5-08fe-416b-a680-2d98e9286b77"},{"index":22446,"token":false,"name":"Soul Collector","scryfallId":"a3ac85d2-186b-46f9-853e-6ee23210540a"},{"index":22449,"token":false,"name":"Herald of Faith","scryfallId":"452591ca-7273-4e47-820b-3ff89697a036"},{"index":22450,"token":false,"name":"Oona's Gatewarden","scryfallId":"972bb6e4-300c-49f5-8305-459a3ba67baa"},{"index":22451,"token":false,"name":"Fasting","scryfallId":"8da35f9f-e72c-4154-a212-7de98f84ad7d"},{"index":22452,"token":false,"name":"Ghostly Touch","scryfallId":"3ebae54a-47e0-4e82-8a29-b5d9354a748b"},{"index":22454,"token":false,"name":"Treasure Keeper","scryfallId":"9c5d73d2-60cc-4b64-8274-4ba1bb98b6fa"},{"index":22456,"token":false,"name":"Malcolm, Keen-Eyed Navigator","scryfallId":"dd85fd88-7e5b-494a-9106-c78602604a1d"},{"index":22460,"token":false,"name":"Bloodforged Battle-Axe","scryfallId":"d9a5219e-f0f3-4fbe-b162-9a03c7019056"},{"index":22464,"token":false,"name":"Breaker of Armies","scryfallId":"9c414c52-e076-42ea-b080-6b34316eb736"},{"index":22466,"token":false,"name":"Elenda, the Dusk Rose","scryfallId":"a52af49b-cfeb-47a8-9ce5-5d35bfa9eb75"},{"index":22468,"token":false,"name":"Set Adrift","scryfallId":"cdad122d-a872-449f-9a7c-0f054b711d11"},{"index":22469,"token":false,"name":"Darksteel Plate","scryfallId":"ba60731f-ed96-4eba-b2de-94965745f35a"},{"index":22471,"token":false,"name":"Mystical Teachings","scryfallId":"a057e5f3-b6bd-4995-b990-714201f36989"},{"index":22472,"token":false,"name":"Cosmos Charger","scryfallId":"4ec318c6-b718-436f-b9e8-e0c6154e5010"},{"index":22473,"token":false,"name":"Endrek Sahr, Master Breeder","scryfallId":"48eac047-f888-49c7-aa7e-339f900f558f"},{"index":22478,"token":false,"name":"Winota, Joiner of Forces","scryfallId":"d0ede0eb-122e-449f-a2c1-41d33d5e6cbf"},{"index":22482,"token":false,"name":"Triumph of Ferocity","scryfallId":"7bb41fa6-0cc6-43e5-9aa8-fcd9c781f4ce"},{"index":22489,"token":false,"name":"Izzet Locket","scryfallId":"a32ecc71-b924-4414-94ee-c6cb0ba752e5"},{"index":22494,"token":false,"name":"Tourach's Canticle","scryfallId":"4d97fd7d-c29f-4db0-b909-2f6aa9c39d65"},{"index":22496,"token":false,"name":"Chillerpillar","scryfallId":"7f57005c-414d-4c83-9b4f-cd26e547d54d"},{"index":22501,"token":false,"name":"Everbark Shaman","scryfallId":"077ae521-a176-4d93-92b1-89ba674f86e4"},{"index":22502,"token":false,"name":"Slip Through Space","scryfallId":"2dee6dca-9c7e-4347-bea7-7fecc69e5827"},{"index":22504,"token":false,"name":"Skullcrack","scryfallId":"8068a146-f6fe-46f3-a42e-822fbc3502e6"},{"index":22505,"token":false,"name":"Feral Deceiver","scryfallId":"6c49d705-9b0c-4c2e-9c27-46eec35deb92"},{"index":22508,"token":false,"name":"Ranger of Eos","scryfallId":"25b55042-3988-4a5e-8cb1-e909f2937276"},{"index":22510,"token":false,"name":"Dragon Tyrant","scryfallId":"04d1a29b-af80-4f9a-881b-ef7374ecbce1"},{"index":22511,"token":false,"name":"Goblin Cavaliers","scryfallId":"c4d81d6c-b45a-4565-89ef-a6ba20a1e9e7"},{"index":22512,"token":false,"name":"Bloodfire Enforcers","scryfallId":"e72f0a37-32d6-4c1f-858d-7eec096dd42a"},{"index":22514,"token":false,"name":"Oketra's Avenger","scryfallId":"9138ce93-8fba-4ce5-8892-0a263e614ead"},{"index":22517,"token":false,"name":"Ceta Disciple","scryfallId":"b1c40c26-3b82-4f72-acb5-85fbdd51665a"},{"index":22519,"token":false,"name":"Treva, the Renewer","scryfallId":"2b4d2c34-c9a9-4de3-a6df-7b815cd043af"},{"index":22526,"token":false,"name":"Quilled Wolf","scryfallId":"fa1569b5-94ef-4ba5-98c6-f1bd4f73c7d5"},{"index":22528,"token":false,"name":"Alseid of Life's Bounty","scryfallId":"0ad40aed-f247-41b3-8198-6367fdeee953"},{"index":22529,"token":false,"name":"Pheres-Band Thunderhoof","scryfallId":"a19a2e8e-9d8f-4537-838c-ac60e09d78bf"},{"index":22534,"token":false,"name":"Daru Stinger","scryfallId":"ff5866a4-f4c0-45bc-9b33-b77387441d34"},{"index":22540,"token":false,"name":"Thoughtseize","scryfallId":"6fff168c-6a0f-473f-86db-8cc8f619fd58"},{"index":22541,"token":false,"name":"Lurching Rotbeast","scryfallId":"9f06be97-71c8-46c8-a1c2-5da3af25e6de"},{"index":22544,"token":false,"name":"Hapless Researcher","scryfallId":"22ed0ee7-6749-4f38-8e53-c11b46b17e5d"},{"index":22545,"token":false,"name":"Doomsday","scryfallId":"944c5be4-3daa-4ed4-9b73-4c39d1ed2d10"},{"index":22546,"token":false,"name":"Shambling Ghoul","scryfallId":"95a52cb8-e02f-477a-adb6-2bfb7836c704"},{"index":22552,"token":false,"name":"Putrid Leech","scryfallId":"d2ffdf98-7c67-464b-b9d0-f31b56a7e880"},{"index":22553,"token":false,"name":"Crawlspace","scryfallId":"97c8e1ed-b3ab-4a08-9336-e513f23d45b3"},{"index":22555,"token":false,"name":"Instigator","scryfallId":"2e3f57af-17d4-4a4c-ae46-fe37f97466fa"},{"index":22557,"token":false,"name":"Xathrid Gorgon","scryfallId":"e07524e0-303d-465d-b112-ca605b9b27fc"},{"index":22558,"token":false,"name":"Warbreak Trumpeter","scryfallId":"fc942957-1067-428c-8ee1-01f9e260efe1"},{"index":22560,"token":false,"name":"No Escape","scryfallId":"bc9888a1-6f35-4802-b8fb-902017736d4a"},{"index":22563,"token":false,"name":"Living Hive","scryfallId":"407dad3c-d721-412a-8b29-bc15be56d2fe"},{"index":22567,"token":false,"name":"Savage Knuckleblade","scryfallId":"cc527b03-2202-4d37-8da6-9c7697531980"},{"index":22569,"token":false,"name":"Prowess of the Fair","scryfallId":"b870c742-e799-4276-bb3d-f2c288ce0db8"},{"index":22577,"token":false,"name":"Lady Caleria","scryfallId":"84b9a2b7-6ff7-4a81-86ae-64cc77c23030"},{"index":22584,"token":false,"name":"Elephant Grass","scryfallId":"f4c1f5a7-0d28-43ab-9b66-937e963f42cd"},{"index":22585,"token":false,"name":"Excruciator","scryfallId":"a3c98460-e8b8-45d6-9bf0-7600b234964b"},{"index":22590,"token":false,"name":"Sleeper Agent","scryfallId":"b1b2c4bd-2397-4ebd-b4fb-3b3e9c6c7dec"},{"index":22592,"token":false,"name":"Bane Alley Broker","scryfallId":"7996df7f-70f5-412c-9573-9512e4e131ac"},{"index":22593,"token":false,"name":"Mana Web","scryfallId":"2c72ec90-dacc-496f-a7f5-f18bfce5eb3e"},{"index":22594,"token":false,"name":"Go Blank","scryfallId":"846e8657-7435-44c6-a997-b8b156d0cd2c"},{"index":22595,"token":true,"name":"Gremlin // Energy Reserve","scryfallId":"d67c7d80-05c9-4bd3-9a8e-14dfe4c075cd"},{"index":22599,"token":false,"name":"Elvish Spirit Guide","scryfallId":"806f8664-d447-42d5-bb52-9fe282f9a653"},{"index":22602,"token":false,"name":"Praetor's Counsel","scryfallId":"b67c8bea-d4c9-4759-8a37-10546b234472"},{"index":22608,"token":false,"name":"Cryptic Trilobite","scryfallId":"a73c630c-c98d-4f8a-9e6a-2576d5fec4ee"},{"index":22610,"token":false,"name":"Valorous Charge","scryfallId":"67f61bdf-cbcd-4a63-8866-eb13ec9b351c"},{"index":22613,"token":false,"name":"Plover Knights","scryfallId":"d84fdc31-43f8-4cb9-b9a8-4ad3d1e90edb"},{"index":22615,"token":false,"name":"Flux Channeler","scryfallId":"c6202e82-e159-482f-9224-292cb533171c"},{"index":22616,"token":false,"name":"Scab-Clan Charger","scryfallId":"964c88d3-3141-44ab-8856-44a3f08331ea"},{"index":22618,"token":false,"name":"Lightwalker","scryfallId":"788524af-7231-4af7-8cd8-a41d1b167526"},{"index":22620,"token":false,"name":"Dive Down","scryfallId":"b33e493e-1aef-43b3-9716-52158b002430"},{"index":22621,"token":false,"name":"Conversion","scryfallId":"45bf4297-ccf4-4fa0-b7ce-5aaebca50813"},{"index":22622,"token":false,"name":"Gisa's Bidding","scryfallId":"e01e904c-7d8e-447b-90cb-1f4ae3fb304d"},{"index":22623,"token":false,"name":"Moraug, Fury of Akoum","scryfallId":"aecfbd48-7da0-4b44-b9a2-d31412f65eb1"},{"index":22625,"token":false,"name":"Hijack","scryfallId":"519c5660-4daf-4404-b808-66d1c840ab70"},{"index":22626,"token":false,"name":"Skemfar Shadowsage","scryfallId":"c204130f-0483-49ed-8512-03a74894702e"},{"index":22627,"token":false,"name":"Nissa, Steward of Elements","scryfallId":"8d64871b-6ee5-426b-9828-125cb9c7746d"},{"index":22632,"token":false,"name":"Temporal Fissure","scryfallId":"47af145a-5427-4874-89a1-860299a0536a"},{"index":22634,"token":false,"name":"Aura of Silence","scryfallId":"17474840-7444-4295-97c7-d0002fa3eff6"},{"index":22636,"token":true,"name":"Soldier Token (W, 2/2)","scryfallId":"ca11c711-93fe-45ca-b393-3851148defc4"},{"index":22638,"token":false,"name":"Rottenheart Ghoul","scryfallId":"933f0504-c611-4557-b1e6-f5be72154805"},{"index":22639,"token":false,"name":"Clear the Mind","scryfallId":"a7da6982-9e57-41d2-a052-f2a3bb646436"},{"index":22642,"token":false,"name":"Deathknell Berserker","scryfallId":"f9f2029f-ffda-4374-9a78-79866ac23fca"},{"index":22645,"token":false,"name":"Jeweled Torque","scryfallId":"eab076bc-e4c3-42a1-b701-9bc49bcc3cdd"},{"index":22648,"token":false,"name":"Heightened Reflexes","scryfallId":"4f7cc8e7-3002-4ee0-869f-931438d8362d"},{"index":22649,"token":true,"name":"Vampire Token (W, 1/1)","scryfallId":"09293ae7-0629-417b-9eda-9bd3f6d8e118"},{"index":22650,"token":false,"name":"Grave Consequences","scryfallId":"9ad5f9f2-282a-4ee0-a259-cc24404ddf6f"},{"index":22651,"token":false,"name":"Winds of Qal Sisma","scryfallId":"0c45d98d-b8bd-409d-bce9-d7d73be735a9"},{"index":22654,"token":false,"name":"Parasitic Implant","scryfallId":"e34f1bf3-9f3a-47f0-9761-8b2356328a39"},{"index":22660,"token":false,"name":"Kindercatch","scryfallId":"4954e8a3-e72b-4f28-8762-2b1c658c31b6"},{"index":22666,"token":false,"name":"Myth Realized","scryfallId":"37bd9f67-32a7-4022-bb53-5bfc671520c7"},{"index":22668,"token":false,"name":"Barrenton Cragtreads","scryfallId":"361dab9e-22f0-45e4-a793-aa6c97a96781"},{"index":22670,"token":false,"name":"Kari Zev, Skyship Raider","scryfallId":"1a9e43d4-41ff-468c-b817-7e8467fadb1a"},{"index":22671,"token":false,"name":"Ruins of Trokair","scryfallId":"a28ec8a0-5cde-4c24-b605-b5f53553d065"},{"index":22672,"token":false,"name":"Dread Statuary","scryfallId":"6e54bace-7484-484e-987e-8d3a9a430ab9"},{"index":22678,"token":false,"name":"Storrev, Devkarin Lich","scryfallId":"59c906bd-f443-4f4b-b40b-9218e71f1196"},{"index":22679,"token":false,"name":"Flickerwisp","scryfallId":"6931aad2-aa2c-4069-9e5a-2566b9f3eae4"},{"index":22682,"token":false,"name":"Catastrophe","scryfallId":"00574054-7fac-4d77-a955-06e49fb01ae1"},{"index":22684,"token":false,"name":"Fade from Memory","scryfallId":"56b34afa-0183-49aa-aa5f-03e070020136"},{"index":22686,"token":false,"name":"Colfenor's Urn","scryfallId":"419fea28-3813-4e65-8b90-6d335fdf0a0b"},{"index":22687,"token":false,"name":"Staunch-Hearted Warrior","scryfallId":"3485eb83-f83c-4776-b164-abd72f3c9547"},{"index":22691,"token":false,"name":"Grimoire of the Dead","scryfallId":"0d8aac24-564a-420f-bb05-c67c3b0e2187"},{"index":22701,"token":false,"name":"Skyraker Giant","scryfallId":"c5f0d87a-8f37-4598-9106-c3545dadf6fd"},{"index":22702,"token":false,"name":"Iname, Life Aspect","scryfallId":"be027e3c-8891-46f0-bca7-d28a94ca281a"},{"index":22705,"token":false,"name":"Extinguish All Hope","scryfallId":"6895024f-a04b-46cf-b020-df4487d0c758"},{"index":22708,"token":false,"name":"Deathreap Ritual","scryfallId":"d5158343-febf-43d0-80e2-a30a27a9c49b"},{"index":22709,"token":false,"name":"Goring Ceratops","scryfallId":"0b58a736-0099-40b9-a987-5b37153a6ad3"},{"index":22712,"token":false,"name":"Tribute Mage","scryfallId":"6c180888-6acd-401b-815a-6ed434482681"},{"index":22715,"token":false,"name":"Moaning Spirit","scryfallId":"cdd99210-5201-4ecc-b86a-aee9dafe2657"},{"index":22716,"token":false,"name":"Yeva, Nature's Herald","scryfallId":"22ecead7-58b3-4e34-8f7d-b095abee7f24"},{"index":22717,"token":false,"name":"Jokulmorder","scryfallId":"a8bd1c2f-dab8-4f22-9400-a0e45618757a"},{"index":22720,"token":false,"name":"Virtus's Maneuver","scryfallId":"73f2e058-c1a8-4a66-b1da-1b3885c6736f"},{"index":22722,"token":false,"name":"Feral Invocation","scryfallId":"c2d08b7a-4ed9-4e4c-a52e-9bf2a16420a9"},{"index":22725,"token":false,"name":"Warrior en-Kor","scryfallId":"16a9ca33-3e9b-4ed9-b503-a1c09c17ca8b"},{"index":22726,"token":false,"name":"Pull from Tomorrow","scryfallId":"f3187822-46fe-4de4-b312-b9f7996a6ed7"},{"index":22729,"token":false,"name":"Carnival Hellsteed","scryfallId":"d8ada7ce-c693-48f0-a6e3-766f61d93370"},{"index":22731,"token":false,"name":"True Love's Kiss","scryfallId":"23a4bac2-f6cb-4712-8510-a63657c43a5c"},{"index":22737,"token":false,"name":"Intimidation","scryfallId":"1b9e1724-91cf-422e-909b-ddb69a6f9f76"},{"index":22741,"token":false,"name":"Anointer of Champions","scryfallId":"3379dc97-abdf-43d7-8625-f8ac04b5687e"},{"index":22742,"token":false,"name":"Noble Stand","scryfallId":"5f53ab12-7c16-43b1-b9f9-a5e523cf431b"},{"index":22746,"token":false,"name":"Heartfire Immolator","scryfallId":"869fb9f1-0d59-4874-aa52-ac665c3cc0e8"},{"index":22755,"token":false,"name":"Rowen","scryfallId":"bbc536ff-3e12-4e1b-b96f-b0c32dcb6734"},{"index":22757,"token":false,"name":"Goblin Goliath","scryfallId":"5973744a-72c3-48e6-b99a-8f6d634c06bb"},{"index":22758,"token":false,"name":"Test of Talents","scryfallId":"6e2b6236-b40c-430c-98b0-7940b942657a"},{"index":22759,"token":false,"name":"Hinterland Drake","scryfallId":"cf393788-1465-4d3b-95a8-0fd08d7f12e2"},{"index":22762,"token":false,"name":"Leonin Arbiter","scryfallId":"4b0453cd-62ab-41ba-8d9c-9d6d25dc9a56"},{"index":22763,"token":false,"name":"Sea Gate Loremaster","scryfallId":"5cd723c8-4b3d-4fbb-a825-79934279382d"},{"index":22765,"token":false,"name":"Satyr Enchanter","scryfallId":"e31c544f-a748-4180-8366-9bb1622bb99d"},{"index":22769,"token":false,"name":"Breaching Hippocamp","scryfallId":"8841c01e-015e-4541-942a-f8859dd03fea"},{"index":22770,"token":false,"name":"Ingenuity Engine","scryfallId":"ac255db4-9c46-4971-bf89-f9014602999c"},{"index":22771,"token":false,"name":"Dune Beetle","scryfallId":"923cb904-c725-4d57-bc17-7aa87a7cd8e0"},{"index":22776,"token":false,"name":"Nissa's Expedition","scryfallId":"815701df-3ed1-417a-bd9a-fdb9f4802c39"},{"index":22777,"token":false,"name":"Avacynian Priest","scryfallId":"08a47828-a79a-4189-9eef-2a5fc5125b61"},{"index":22779,"token":false,"name":"Grief Tyrant","scryfallId":"971a3b39-5b4b-41a4-9f67-1f24c48ba621"},{"index":22781,"token":false,"name":"Detainment Spell","scryfallId":"c467446b-0168-4c7d-9ab6-57ad8b664877"},{"index":22784,"token":false,"name":"Treasure Mage","scryfallId":"8893dfef-92bd-4b09-807a-1fe71c5602fe"},{"index":22789,"token":false,"name":"Strike It Rich","scryfallId":"1c7c2814-a617-4123-acdf-1b01b2768210"},{"index":22795,"token":false,"name":"Nylea's Forerunner","scryfallId":"2cf2b6be-80a8-4464-a909-8cc658196a14"},{"index":22796,"token":false,"name":"Ink-Treader Nephilim","scryfallId":"d29bb432-1ca6-4305-b6d3-d7afe06c6c69"},{"index":22800,"token":false,"name":"Ayara, First of Locthwain","scryfallId":"d64632c5-3a56-4210-9432-69b30bf89487"},{"index":22801,"token":false,"name":"Brass Man","scryfallId":"0ba1daee-a5ac-4d9e-b681-3e3c7a3eb095"},{"index":22803,"token":false,"name":"Silverclad Ferocidons","scryfallId":"0b480b36-61b1-476c-a04c-37720fd35c05"},{"index":22805,"token":false,"name":"Abyssal Hunter","scryfallId":"3c3f6ad7-4782-40db-8eb3-e71d71ec3388"},{"index":22807,"token":false,"name":"Dromar's Attendant","scryfallId":"24936fa9-41a3-4da5-91cf-c28fa45f47c9"},{"index":22814,"token":false,"name":"Shambling Swarm","scryfallId":"b5b93715-985f-4719-a3c3-044c2a150e96"},{"index":22816,"token":false,"name":"Collector Ouphe","scryfallId":"085107a2-c1ec-473c-81d8-23e5a7197776"},{"index":22818,"token":false,"name":"Hunding Gjornersen","scryfallId":"4049abac-cb54-4af2-b2df-ffb8fdc22e84"},{"index":22819,"token":false,"name":"Bassara Tower Archer","scryfallId":"95a1e5c2-7f5b-4ae4-83d9-06e334ba57ea"},{"index":22820,"token":false,"name":"Heartwarming Redemption","scryfallId":"af569235-f5cb-4e3e-ba77-c1c429ed0a60"},{"index":22821,"token":false,"name":"Deadeye Plunderers","scryfallId":"63a7a1a4-aec2-467d-91a1-1a2605718c7c"},{"index":22822,"token":false,"name":"Shower of Coals","scryfallId":"b1e623a8-145e-4649-b2cc-d3bb8a93f0f3"},{"index":22826,"token":false,"name":"Terrain Generator","scryfallId":"e6fe66a2-8e70-414f-bedb-8f1f85f1d2d9"},{"index":22853,"token":false,"name":"Ballot Broker","scryfallId":"591e124d-3317-455e-9189-5d76089c1c03"},{"index":22854,"token":false,"name":"Grasping Current","scryfallId":"e7344ffb-aada-4be1-bc82-2ed96e6cb5bf"},{"index":22855,"token":false,"name":"Stasis Cocoon","scryfallId":"5b2ca75e-ccb0-4e5b-8dda-445fe0130732"},{"index":22858,"token":false,"name":"Desolation Angel","scryfallId":"445127d4-8afb-47cf-b2a1-564540b1fdae"},{"index":22859,"token":false,"name":"Nevermore","scryfallId":"67b610fe-36ee-4d58-8ed4-04e7a12587b2"},{"index":22860,"token":false,"name":"Agility","scryfallId":"5694cb42-7489-40c5-b21a-aeb36636015f"},{"index":22867,"token":false,"name":"Suppress","scryfallId":"97d048c2-7456-4d68-b2f9-19d91d5e68d7"},{"index":22869,"token":false,"name":"Gnawing Zombie","scryfallId":"56653d9e-0c29-440b-8724-cae746abb1a9"},{"index":22871,"token":false,"name":"Nessian Hornbeetle","scryfallId":"8200fcda-e30c-460f-9964-47e657b7c758"},{"index":22872,"token":false,"name":"Jangling Automaton","scryfallId":"2e2a427b-9869-4059-aeeb-d9b97b324e4e"},{"index":22875,"token":false,"name":"Cursed Flesh","scryfallId":"fb151ae8-9281-434d-ba8d-9ce34f0875eb"},{"index":22877,"token":false,"name":"The Antiquities War","scryfallId":"bbda670a-00a7-419c-b4b5-bfdb323f006d"},{"index":22881,"token":false,"name":"Snarespinner","scryfallId":"46700ccc-0975-49d1-b3fc-edb1eda3b624"},{"index":22884,"token":false,"name":"Sisay's Ring","scryfallId":"1ae27220-2b62-4214-81b5-612dd770612b"},{"index":22887,"token":false,"name":"Angelic Purge","scryfallId":"d38bae3e-95f3-413a-bb4d-6a0814112a7a"},{"index":22889,"token":true,"name":"Servo // Thopter Token (Colorless, 1/1)","scryfallId":"4e3690fa-627e-4b3b-b517-e2cd1b4bbdd0"},{"index":22892,"token":false,"name":"Pull from Eternity","scryfallId":"601bf68d-f3ea-4b45-b6dd-59bd507086f6"},{"index":22894,"token":false,"name":"Dreamborn Muse","scryfallId":"2daf8f6a-431d-45dc-8e47-ad554ff76e3e"},{"index":22899,"token":false,"name":"Bonder's Ornament","scryfallId":"5afe425c-50a7-4d29-ac14-0edb094fc770"},{"index":22904,"token":false,"name":"Veteran of the Depths","scryfallId":"c36fe821-e9b1-453d-8e44-f8dce111a6de"},{"index":22906,"token":false,"name":"Reaper of Flight Moonsilver","scryfallId":"58cf3ac8-db59-4acc-abb6-e63b95b849ac"},{"index":22911,"token":false,"name":"Nyx Weaver","scryfallId":"de71b145-6db9-490c-9e86-b441fcb107c8"},{"index":22913,"token":false,"name":"Midnight Scavengers // Chittering Host","scryfallId":"5a57187c-f0ec-40de-b725-786f787b00a2"},{"index":22916,"token":false,"name":"Dredge","scryfallId":"68bfa3d5-0f0b-4684-9567-f1478da01df7"},{"index":22919,"token":false,"name":"Cudgel Troll","scryfallId":"e156b8d8-5309-494e-9709-44f98826a69f"},{"index":22921,"token":false,"name":"Adventuring Gear","scryfallId":"3aa395f2-656e-4bf3-bd9b-6240bd3e2774"},{"index":22923,"token":false,"name":"Krovikan Sorcerer","scryfallId":"ffd3bd1e-8aeb-45f2-b3d2-56029c19c89f"},{"index":22924,"token":false,"name":"Consumptive Goo","scryfallId":"0f0f549f-6607-483a-9d89-2019ca9ef571"},{"index":22928,"token":false,"name":"Phalanx Leader","scryfallId":"eca571f9-81e0-4b01-9d2f-745bf0bdf51e"},{"index":22932,"token":false,"name":"Control of the Court","scryfallId":"3e4f0005-4f19-4352-9cd2-3993ae6db879"},{"index":22933,"token":false,"name":"Heart Wolf","scryfallId":"e0427dcd-26da-462b-b936-a382d3d8afce"},{"index":22934,"token":false,"name":"Slaughterhorn","scryfallId":"4010a419-8291-4c8b-8cda-38c35fbd7b88"},{"index":22935,"token":false,"name":"Enigma Thief","scryfallId":"3536a97f-565b-45c6-a54b-96afd2a268ec"},{"index":22936,"token":false,"name":"Divert","scryfallId":"8eb6e9f8-a508-451e-8a72-5f9834ba5352"},{"index":22937,"token":false,"name":"Goblin Dynamo","scryfallId":"9462cb4e-a38c-4a41-bad2-4ea3b22b0edb"},{"index":22938,"token":false,"name":"Cruel Fate","scryfallId":"44bea0d4-946e-4cb8-b6f1-50231d52bfbe"},{"index":22940,"token":false,"name":"Accelerate","scryfallId":"6a28dd88-db90-4f02-8aa9-39051d2c4763"},{"index":22944,"token":false,"name":"Ophidian Eye","scryfallId":"26836ff5-b3c3-4b10-af1e-df3658781cb2"},{"index":22946,"token":false,"name":"Bladed Bracers","scryfallId":"897a5116-043c-46aa-880e-be8dcb1618bc"},{"index":22949,"token":false,"name":"Coffin Puppets","scryfallId":"c34019cb-5d87-4451-a102-b751ea3a97f8"},{"index":22953,"token":false,"name":"Roar of the Crowd","scryfallId":"e4b0e072-c51a-4e97-a089-8e5b540355aa"},{"index":22958,"token":false,"name":"Freyalise's Radiance","scryfallId":"4bafb0b4-9f01-4c67-add4-a0ffe0a3a691"},{"index":22959,"token":false,"name":"Brothers Yamazaki","scryfallId":"2a9d3876-0f16-4469-ad35-94160446fd70"},{"index":22970,"token":false,"name":"Corrosive Gale","scryfallId":"04a13825-ab9b-4ffd-9b59-6198181891b9"},{"index":22971,"token":false,"name":"Mystic Veil","scryfallId":"7ddb640d-5c54-4d0a-b8c2-e22fe04f96c2"},{"index":22972,"token":false,"name":"Morbid Plunder","scryfallId":"bd6a8817-05fc-400e-9464-b7d925c5c312"},{"index":22973,"token":false,"name":"Lightning Mare","scryfallId":"2ca822a3-4793-4cbc-a2f3-f43985e7ce8f"},{"index":22974,"token":false,"name":"Pitiless Plunderer","scryfallId":"c87ebffe-5907-427b-9f9b-7c36a12b4a03"},{"index":22977,"token":false,"name":"Dread Presence","scryfallId":"8e4b2d08-4fe7-452d-85b1-c378c890102c"},{"index":22990,"token":false,"name":"Angelic Destiny","scryfallId":"06911410-9b19-4859-b41a-0eb2cd10d89c"},{"index":22991,"token":true,"name":"Spirit Token (B/W, */*)","scryfallId":"03553980-53fa-4256-b478-c7e0e73e2b5b"},{"index":22994,"token":false,"name":"Viashino Sandswimmer","scryfallId":"0790607f-51b7-40ff-80f9-4f7f5cd2d63c"},{"index":22998,"token":false,"name":"Gravel Slinger","scryfallId":"87551307-6b5f-4f12-aa1f-4beebefad3b3"},{"index":23000,"token":false,"name":"Chef's Kiss","scryfallId":"c706922d-c892-43d0-a4f5-91283999d291"},{"index":23003,"token":false,"name":"Sinkhole","scryfallId":"485cef94-d7aa-4bb3-b2e6-61d0ccf8007e"},{"index":23005,"token":false,"name":"Cremate","scryfallId":"013d5260-f906-4f6a-97ed-725197743b60"},{"index":23007,"token":false,"name":"Marble Gargoyle","scryfallId":"1e9900b8-da89-433b-ada5-f17c82e60c64"},{"index":23009,"token":false,"name":"Grasping Scoundrel","scryfallId":"8f6da2e7-4cf0-49ae-b0ba-3b994ff21587"},{"index":23016,"token":false,"name":"Pyxis of Pandemonium","scryfallId":"dbc6a246-f32a-4dc0-9785-4038804f372f"},{"index":23017,"token":false,"name":"Erebos, God of the Dead","scryfallId":"ac8bdb4c-2d68-4cb4-904f-1649427751dc"},{"index":23035,"token":false,"name":"Decree of Savagery","scryfallId":"e643fbf1-74d5-412b-beba-ab3c712edb3b"},{"index":23036,"token":false,"name":"Wakedancer","scryfallId":"b02c8c59-52b1-4f68-8ebf-4026c78ef9fa"},{"index":23037,"token":false,"name":"Fumarole","scryfallId":"efa53e9a-0d7c-4d17-b2be-56930edfa2c2"},{"index":23038,"token":false,"name":"Destructive Digger","scryfallId":"d981b310-5e75-4f30-baf6-37f069f00aa3"},{"index":23039,"token":false,"name":"Mire's Malice","scryfallId":"c2d737fb-fd09-4483-8128-8897cbcdc4f5"},{"index":23040,"token":false,"name":"Scourge Devil","scryfallId":"976e2ba9-8d23-4aca-8b50-4beb598d4a60"},{"index":23047,"token":false,"name":"Solitary Confinement","scryfallId":"e7a8eb7a-eb3f-405e-8f44-d8ea64d76386"},{"index":23051,"token":false,"name":"Scour the Desert","scryfallId":"b87d368f-e1e0-41ab-9da0-f07c01c8ae38"},{"index":23055,"token":false,"name":"Nadier's Nightblade","scryfallId":"11fbba08-0d93-4750-9dd6-d6a2779c6cf3"},{"index":23057,"token":false,"name":"Heat of Battle","scryfallId":"8dbb98db-f2ee-446f-9170-dd05b1a7dbd8"},{"index":23060,"token":false,"name":"Jar of Eyeballs","scryfallId":"72825270-d5c1-4ab1-903a-e2868ade17f2"},{"index":23063,"token":false,"name":"The Wanderer","scryfallId":"6c428225-e17f-46b8-96d4-933ad0023d2a"},{"index":23066,"token":false,"name":"Wei Infantry","scryfallId":"72c6465f-3144-4faf-b248-a9fb941dc002"},{"index":23067,"token":false,"name":"Khalni Gem","scryfallId":"8b5f6b2b-8d98-4609-b991-a69523b5a07d"},{"index":23069,"token":false,"name":"Wandering Stream","scryfallId":"6da5cb6c-253b-44f0-98f9-d75f42c6e14b"},{"index":23070,"token":false,"name":"Burning Palm Efreet","scryfallId":"a194488a-1d6f-4bc3-8f30-82e2c3c91389"},{"index":23077,"token":true,"name":"Spirit Token (B/W, 1/1)","scryfallId":"91f3a4b0-0992-4245-b245-033ad1083a93"},{"index":23081,"token":false,"name":"Skitter of Lizards","scryfallId":"153c1465-9cbc-424b-8147-79e95fd45b3d"},{"index":23089,"token":false,"name":"Strength of the Tajuru","scryfallId":"1f123e02-eb74-4cc1-bc06-54989aeab784"},{"index":23098,"token":false,"name":"Sarulf's Packmate","scryfallId":"6061113e-7dd8-4739-b4dd-55bb7f9e39a2"},{"index":23100,"token":false,"name":"Long-Finned Skywhale","scryfallId":"772e9472-c710-474e-b8e9-54662330a592"},{"index":23101,"token":false,"name":"Staff of the Death Magus","scryfallId":"624fe171-8bd8-4156-b40e-74e2a847d380"},{"index":23103,"token":false,"name":"Ebony Rhino","scryfallId":"81db749e-a1df-4615-9449-94731fa23a9f"},{"index":23104,"token":false,"name":"Glaring Spotlight","scryfallId":"a6070239-54a7-49d4-bd3c-d5c4cda971db"},{"index":23112,"token":false,"name":"Urgoros, the Empty One","scryfallId":"e8652fb7-1bce-44ee-b75e-4c773ff8fdb3"},{"index":23116,"token":false,"name":"Phosphorescent Feast","scryfallId":"7ca13d7a-0f60-4de6-9455-aea454cb2e46"},{"index":23117,"token":false,"name":"Quirion Elves","scryfallId":"74a39656-769f-4540-9a30-f637a8ec302e"},{"index":23118,"token":false,"name":"Hallow","scryfallId":"80fe80a0-cb3d-48bc-b67e-2e2253cfee14"},{"index":23119,"token":false,"name":"Dark Privilege","scryfallId":"c63ecd7b-a5e6-4e19-9ca2-dda14754305a"},{"index":23120,"token":false,"name":"Taranika, Akroan Veteran","scryfallId":"28c3be11-ae71-4042-bb82-457cdb6bd5d1"},{"index":23123,"token":false,"name":"Etherium Abomination","scryfallId":"312bbd63-d6ff-4da5-868f-ed68cbc12d43"},{"index":23127,"token":false,"name":"Deal Broker","scryfallId":"42dc14d0-60e2-419a-a6cf-ba155c51c310"},{"index":23130,"token":false,"name":"Scaled Hulk","scryfallId":"3b27457e-2c40-4983-9680-b7292db4c668"},{"index":23131,"token":false,"name":"Mystic Sanctuary","scryfallId":"170e792c-80d5-4775-ad95-37614574ab84"},{"index":23133,"token":false,"name":"Scalelord Reckoner","scryfallId":"c91c3606-d037-4b97-a7b6-ab1ed09bc976"},{"index":23134,"token":false,"name":"Abbey Matron","scryfallId":"158caa84-da2e-4c4c-b24d-0c035c900e20"},{"index":23136,"token":false,"name":"Fearless Liberator","scryfallId":"212462b7-e23e-4c87-93aa-9cadefbf1ac8"},{"index":23139,"token":false,"name":"Firemaw Kavu","scryfallId":"d592bc85-41ca-48a4-b35a-4d86c8e76d54"},{"index":23141,"token":true,"name":"Zombie // Zombie","scryfallId":"5a561f84-5696-44a5-8dc1-227af883341d"},{"index":23143,"token":false,"name":"Rust Scarab","scryfallId":"c57335b5-30e2-431f-ab50-d5f1981783c3"},{"index":23144,"token":false,"name":"Forerunner of the Legion","scryfallId":"10718d37-63d4-44b7-9450-5d49cffce944"},{"index":23146,"token":false,"name":"Fain, the Broker","scryfallId":"f5829ea0-1f41-46ba-a5e6-b7bd7051a591"},{"index":23152,"token":false,"name":"Phyrexian Totem","scryfallId":"31593a02-d026-4108-82e0-21ad5ff8c890"},{"index":23155,"token":false,"name":"Trial of Ambition","scryfallId":"db1e79b7-931d-49bf-8c2c-d42c55a93c74"},{"index":23159,"token":false,"name":"Woebearer","scryfallId":"dde90cd6-ab7d-4c21-a18d-9c1883d9260c"},{"index":23161,"token":false,"name":"Supplant Form","scryfallId":"4c99f6cb-31da-491d-9088-7b46efd02c52"},{"index":23165,"token":false,"name":"Refurbish","scryfallId":"ce3a5ca7-bda2-4f85-8c67-198751301a2d"},{"index":23166,"token":false,"name":"Rain of Daggers","scryfallId":"bb09a5bb-9730-43cd-8dea-3842634c9983"},{"index":23170,"token":false,"name":"Swat","scryfallId":"947b8923-d9d6-4dd8-928b-91be9105ffb4"},{"index":23171,"token":false,"name":"Thwart","scryfallId":"c12a0717-e9ea-4be3-a29f-179671ed4489"},{"index":23175,"token":false,"name":"Moat Piranhas","scryfallId":"543b3f69-19be-494b-928f-e16b92560e35"},{"index":23178,"token":false,"name":"Gaea's Anthem","scryfallId":"43febc63-597d-4392-b8ea-a00841148c45"},{"index":23179,"token":false,"name":"Zuran Enchanter","scryfallId":"721edcef-f40a-4d43-9d80-26161dc425cb"},{"index":23184,"token":false,"name":"Sleeper's Guile","scryfallId":"a001ca83-35b5-48e5-8337-92258d5affc2"},{"index":23187,"token":false,"name":"Liturgy of Blood","scryfallId":"fbe00ed2-d316-46f8-a5cf-6aad93fe88a0"},{"index":23188,"token":false,"name":"Waveskimmer Aven","scryfallId":"e75ebcb4-5db8-4c72-9f65-8ee8f2c893ea"},{"index":23192,"token":false,"name":"Torch Gauntlet","scryfallId":"dfcf9a88-c5f8-4c26-a2ee-d2827e9a31d8"},{"index":23195,"token":false,"name":"Constricting Tendrils","scryfallId":"1a110be3-93ec-40ef-94a6-e4c43f1ce211"},{"index":23204,"token":false,"name":"Blood Divination","scryfallId":"51278b56-5056-4a37-a1e8-daca45d8e360"},{"index":23208,"token":false,"name":"Ertai, the Corrupted","scryfallId":"66b950d9-8fef-4deb-b51b-26edb90abc56"},{"index":23213,"token":false,"name":"Clifftop Retreat","scryfallId":"fd7e1bf9-bd6a-48e3-9331-178e5142c06a"},{"index":23215,"token":false,"name":"Novablast Wurm","scryfallId":"64733f34-2eb4-4df5-8656-57bdb8b3a983"},{"index":23216,"token":false,"name":"Griffin Canyon","scryfallId":"705d8194-3ad0-41b7-ae32-9c0cd8cd46b9"},{"index":23217,"token":false,"name":"Brass Herald","scryfallId":"7c0380a4-225f-4a80-8c8b-d0f7e54f1626"},{"index":23219,"token":false,"name":"Gruesome Scourger","scryfallId":"0ffbb50e-76ca-4bfd-b6d1-95ab8cf3bbf8"},{"index":23221,"token":false,"name":"Laccolith Whelp","scryfallId":"86eb5b9e-320f-40de-8668-ee0c08f63ec1"},{"index":23223,"token":false,"name":"Temporal Distortion","scryfallId":"74bd0d14-8d26-403f-9405-d0dcdecd1a49"},{"index":23224,"token":false,"name":"Stench of Decay","scryfallId":"b4b93845-f17a-4892-a1ce-a4630dced218"},{"index":23228,"token":false,"name":"Hammer Dropper","scryfallId":"9efac789-587b-45c1-b16e-616e9486b59b"},{"index":23229,"token":false,"name":"Oboro Envoy","scryfallId":"a0309dcb-6c13-4ffe-b44d-3b735c8277d2"},{"index":23230,"token":false,"name":"Naya Battlemage","scryfallId":"4fe73f62-2e80-4d5f-b7b5-c54c895a3e4d"},{"index":23232,"token":false,"name":"Stonehewer Giant","scryfallId":"da9aa48f-c960-4148-b03a-026a027e436b"},{"index":23236,"token":false,"name":"Indigo Faerie","scryfallId":"62e6e481-a050-4515-a557-d59ba6136ff6"},{"index":23244,"token":false,"name":"Breeches, Brazen Plunderer","scryfallId":"83e8fe2e-ec6c-47fc-85c0-6eec185ecdce"},{"index":23247,"token":false,"name":"Ketria Crystal","scryfallId":"7df435cb-3aeb-490a-8fca-91f3b6936965"},{"index":23248,"token":false,"name":"Wandering Wolf","scryfallId":"96d4361f-a889-4031-8b95-27dbef3922f3"},{"index":23249,"token":false,"name":"Rune of Protection: Blue","scryfallId":"85f4ed3a-1851-49b1-baac-fdc8c00b6b71"},{"index":23250,"token":false,"name":"Earth Rift","scryfallId":"e2e10742-77c9-4f91-81b2-37b2ac910f09"},{"index":23252,"token":false,"name":"Eternal Skylord","scryfallId":"f5aacfc9-1d45-4250-9abc-698d8941699f"},{"index":23255,"token":false,"name":"Elvish Eulogist","scryfallId":"207de426-ed83-44d5-a74b-ef2f33958b7f"},{"index":23257,"token":false,"name":"Ardent Soldier","scryfallId":"39dce974-846f-4365-b0a5-851e38668e7d"},{"index":23258,"token":false,"name":"Favored of Iroas","scryfallId":"f09e7aff-d873-4420-b0d5-1c63d686dd73"},{"index":23261,"token":false,"name":"Flame Lash","scryfallId":"8383e698-0dd7-4f35-aecb-53f0ee746999"},{"index":23262,"token":false,"name":"Primal Frenzy","scryfallId":"f5e2d822-09d0-42e5-ad91-67c66e947b3d"},{"index":23263,"token":false,"name":"Tomb Robber","scryfallId":"6645cfbc-a384-4f48-b4de-7ec0e889d387"},{"index":23264,"token":false,"name":"Amass the Components","scryfallId":"bd288635-a795-4f87-85d5-ba7ebb493e85"},{"index":23271,"token":false,"name":"Pattern Matcher","scryfallId":"ad608eb3-d387-4414-b194-703f38863896"},{"index":23272,"token":false,"name":"Blow Your House Down","scryfallId":"c559c827-a9f4-49d5-b5e0-5cde9e7f461f"},{"index":23278,"token":false,"name":"Masked Gorgon","scryfallId":"0d62728b-b834-4fa8-aed5-6348033ee69c"},{"index":23280,"token":false,"name":"Tide Shaper","scryfallId":"2ff414bc-6736-428b-bb60-9d62793a5ae5"},{"index":23281,"token":false,"name":"Toothy, Imaginary Friend","scryfallId":"ebdf2f50-f69a-47c4-a75f-ff55781bb0c8"},{"index":23286,"token":false,"name":"Aethersquall Ancient","scryfallId":"55127a25-dc64-4f26-ae50-ed7247c22ae6"},{"index":23289,"token":true,"name":"Feathered Friends","scryfallId":"166523b2-31a5-41db-a19d-8ec08e2e0653"},{"index":23291,"token":false,"name":"Author of Shadows","scryfallId":"87373340-e0d0-4cef-9400-639041010b94"},{"index":23294,"token":false,"name":"Springbloom Druid","scryfallId":"6161d2ed-7cff-4c90-9e74-1d179a6c1498"},{"index":23296,"token":false,"name":"Goblin Boom Keg","scryfallId":"14343e23-83fb-4d2e-a272-20d7787ef2ca"},{"index":23300,"token":false,"name":"Grindclock","scryfallId":"53498863-2e69-4b98-b0f0-7ae13dc1033e"},{"index":23301,"token":false,"name":"Eiganjo Castle","scryfallId":"219c1d76-40cf-4edf-8145-e6cec8ca39ad"},{"index":23304,"token":false,"name":"Samut, the Tested","scryfallId":"d2341d0a-482c-4194-a8c9-088e27df1f4c"},{"index":23306,"token":false,"name":"War Room","scryfallId":"48d6ce7c-5dc8-449b-acbd-db259ae687ed"},{"index":23310,"token":false,"name":"Underworld Connections","scryfallId":"19c52e3b-b3b8-4243-96fe-fa4c8eea7c59"},{"index":23311,"token":false,"name":"Haunted Dead","scryfallId":"14a7c8b7-ca77-47a0-8965-949723ec902d"},{"index":23315,"token":false,"name":"Lightning Strike","scryfallId":"084b7337-c06f-4cbf-8fc0-0b20c221f1dc"},{"index":23316,"token":false,"name":"Temporal Isolation","scryfallId":"eb406292-1879-4aa9-a369-082822dae1d7"},{"index":23317,"token":false,"name":"Moonveil Dragon","scryfallId":"92503118-b37b-4c52-b40a-487f6ad695ef"},{"index":23321,"token":false,"name":"Fleet Swallower","scryfallId":"885db066-b4f8-4855-bcf2-36e339495c28"},{"index":23322,"token":false,"name":"Needle Spires","scryfallId":"9933bb5c-068b-408e-b779-4b32be01bb46"},{"index":23327,"token":false,"name":"Cyclops Tyrant","scryfallId":"f0b8e733-22a7-4696-83b3-297cbe75dadc"},{"index":23330,"token":true,"name":"Base Race // Base Race (cont'd)","scryfallId":"89b9ded0-6ddf-4d3e-9442-53e647bad172"},{"index":23331,"token":false,"name":"Barrin's Codex","scryfallId":"9951b225-f11e-41bd-ab6e-e1fda957dff3"},{"index":23333,"token":false,"name":"Wild Onslaught","scryfallId":"eb75cf21-08be-4b92-bdf6-014a36090738"},{"index":23335,"token":false,"name":"Porcuparrot","scryfallId":"e6373fe1-c834-419e-8a0b-590fb5dc555e"},{"index":23336,"token":false,"name":"Weave Fate","scryfallId":"04e57fc1-1633-447f-ae32-ad7da25a4177"},{"index":23341,"token":false,"name":"Ulvenwald Hydra","scryfallId":"0700d1c1-faab-4a1a-b55d-a2fa4582a2b4"},{"index":23346,"token":false,"name":"Easy Prey","scryfallId":"312fb6e4-1eb1-4fbb-b7a4-125829a6e96a"},{"index":23347,"token":false,"name":"Wild Defiance","scryfallId":"7eaa6be7-2c6f-4442-85d1-ae31ad87fd98"},{"index":23348,"token":false,"name":"Customs Depot","scryfallId":"067d8c46-c334-4b00-af06-2e28b6086c58"},{"index":23350,"token":false,"name":"Piper's Melody","scryfallId":"642ea1f9-49f0-4e0d-8122-c3a305c149e9"},{"index":23353,"token":false,"name":"Memoricide","scryfallId":"c9d74bae-0b96-4a78-b805-a0b764d0716c"},{"index":23358,"token":false,"name":"Death Pulse","scryfallId":"524fd470-e535-47ea-98a0-6187e429dfe1"},{"index":23359,"token":false,"name":"Crypt Rats","scryfallId":"f9b2f697-01cc-4610-b4aa-cae83b38647a"},{"index":23363,"token":false,"name":"Razor Golem","scryfallId":"64a86ec3-378f-4fca-b5f7-6dc02d47f7b9"},{"index":23364,"token":false,"name":"Elder Deep-Fiend","scryfallId":"3c2789fb-a263-4207-8a56-4eeb015a024c"},{"index":23365,"token":true,"name":"Vampire Token (B, 2/2)","scryfallId":"71496671-f7ba-4014-a895-d70a27979db7"},{"index":23368,"token":false,"name":"Dragon-Scarred Bear","scryfallId":"de63c8dd-d83e-4a3e-b75f-6049f8759997"},{"index":23372,"token":false,"name":"Carnage Altar","scryfallId":"52688a03-26a4-40ff-8a99-a268113a9802"},{"index":23374,"token":false,"name":"Marsh Hulk","scryfallId":"ff347b25-7ce9-42c4-811d-86f3e9c55d75"},{"index":23376,"token":false,"name":"Profane Prayers","scryfallId":"bc8320ef-af97-4cf6-9aaf-17818174d842"},{"index":23377,"token":false,"name":"Illuminate","scryfallId":"ceef2761-7301-42de-8f54-49b8cd1e457b"},{"index":23378,"token":false,"name":"Drooling Groodion","scryfallId":"1653a373-b266-4efa-9a82-98b3bbad27a4"},{"index":23383,"token":true,"name":"Vampire // Treasure","scryfallId":"05934d59-7e98-4fff-8ccb-70cd1a61c6fd"},{"index":23384,"token":false,"name":"Titanoth Rex","scryfallId":"b4817b86-d55a-4334-82ee-603f8c4b3e93"},{"index":23385,"token":false,"name":"Thrull Champion","scryfallId":"4d3cafdd-a03b-4b08-b9c1-c776f8450d3a"},{"index":23387,"token":false,"name":"Giant's Skewer","scryfallId":"050c03f9-ccbd-4dcc-9789-8013875ef470"},{"index":23388,"token":false,"name":"Liliana of the Dark Realms","scryfallId":"2cd2d81e-1388-4f34-9917-2289971cf8da"},{"index":23391,"token":true,"name":"Elemental // Elemental Token (G/W, */*)","scryfallId":"70f1f745-9fc2-41a6-9d39-fb4964595cf5"},{"index":23392,"token":false,"name":"Deadbridge Shaman","scryfallId":"f110fa8e-3fbf-4a81-a743-e709f58e4414"},{"index":23393,"token":false,"name":"Virtus the Veiled","scryfallId":"524ef939-32d5-467a-a9c6-0e46949bd83a"},{"index":23397,"token":false,"name":"Nissa's Triumph","scryfallId":"7946b256-ae79-4b99-8bf4-0d627baf9044"},{"index":23406,"token":false,"name":"Kami of the Palace Fields","scryfallId":"bca205d1-5e2c-4a94-9944-bacb2f1427f8"},{"index":23410,"token":false,"name":"Fearsome Temper","scryfallId":"c6e7884c-2d66-42d1-87d1-1341a6fa52d8"},{"index":23412,"token":false,"name":"Phyrexian Swarmlord","scryfallId":"8a91dea7-9792-4714-82b0-ba2c06cef304"},{"index":23414,"token":false,"name":"Phantasmal Fiend","scryfallId":"cf96bea5-6d59-4895-84d0-664b2babb17e"},{"index":23415,"token":false,"name":"Last Word","scryfallId":"139d2ece-f656-4cac-8d77-b0f083f76c70"},{"index":23416,"token":false,"name":"Blistergrub","scryfallId":"98f66448-1144-47c0-b33d-bbe57efd899c"},{"index":23417,"token":false,"name":"Vizier of Deferment","scryfallId":"a26afe04-aa80-4a7e-8c61-ce2fda091957"},{"index":23419,"token":false,"name":"Simian Grunts","scryfallId":"a0aaea3e-a67a-4d9c-9059-e6beb05f97b1"},{"index":23420,"token":false,"name":"Locust Swarm","scryfallId":"bd269842-4c31-4398-9451-be0d941397ac"},{"index":23421,"token":false,"name":"Crashing Footfalls","scryfallId":"a8cca2a2-69e3-4136-936c-7a2774c19351"},{"index":23424,"token":false,"name":"Archipelagore","scryfallId":"f24b1030-64d5-4c94-a04c-1d9520bfddab"},{"index":23427,"token":true,"name":"Dragon Token (R, 4/4)","scryfallId":"cb928e3f-b15e-4f76-8909-0ceebe45a8ea"},{"index":23428,"token":false,"name":"Shattergang Brothers","scryfallId":"a1b922ce-c398-43d4-9f79-2d15f28eae2f"},{"index":23431,"token":false,"name":"Dark Suspicions","scryfallId":"d518e2fd-7767-43d7-92e3-62a4a465154c"},{"index":23434,"token":false,"name":"Ordruun Commando","scryfallId":"aa726c0e-3a7e-4299-8842-4ce1f9f26567"},{"index":23436,"token":false,"name":"Thalakos Seer","scryfallId":"50210dd8-83c6-4e64-a488-f8e7fd85d992"},{"index":23438,"token":false,"name":"Hokori, Dust Drinker","scryfallId":"5a03f5d5-d5c3-4a7d-8d44-e60b498b4ed5"},{"index":23442,"token":false,"name":"Nephalia Smuggler","scryfallId":"a67bcad1-b535-4e51-a5f4-50612b0346ce"},{"index":23444,"token":false,"name":"Mastery of the Unseen","scryfallId":"1dad4bad-253e-4c0c-b2ce-7ddc77eaeb22"},{"index":23446,"token":false,"name":"Battlefield Scrounger","scryfallId":"f5ac74bc-1198-4a9a-bcde-668cca08b274"},{"index":23453,"token":false,"name":"Infernal Scarring","scryfallId":"d1ead8cc-5b7d-4a6d-a56f-95da91a958d2"},{"index":23457,"token":false,"name":"Bathe in Dragonfire","scryfallId":"102740d0-ca74-460d-af30-c71bddad87c4"},{"index":23463,"token":false,"name":"He Who Hungers","scryfallId":"1ccf0f8d-f988-45ec-b75b-d97206326cfb"},{"index":23464,"token":false,"name":"Pure // Simple","scryfallId":"b3a5d913-0b78-4918-87cf-0bb33b9d120e"},{"index":23467,"token":false,"name":"Skeletal Wurm","scryfallId":"2feedcf2-c443-4363-80cf-a90579a64342"},{"index":23469,"token":false,"name":"Gonti's Aether Heart","scryfallId":"9e4fc5ed-e90d-4965-985a-ed126a713506"},{"index":23471,"token":false,"name":"Garrison Griffin","scryfallId":"94a04717-5cd7-4982-bf36-00cea30b9ef1"},{"index":23472,"token":false,"name":"Bloodsky Berserker","scryfallId":"a6308a53-de07-4ed9-80a1-3579843466c2"},{"index":23473,"token":false,"name":"Blinding Angel","scryfallId":"e04256f8-c275-4a24-8a95-371d424f7a01"},{"index":23485,"token":false,"name":"Archaeological Dig","scryfallId":"35f55af0-5a46-4900-b3d0-ca796b710e07"},{"index":23486,"token":false,"name":"Edgar Markov","scryfallId":"61cbfcac-11ea-4c18-acfb-4a3ce11b739a"},{"index":23487,"token":false,"name":"Land's Edge","scryfallId":"fb3d9b29-948c-4768-b5ea-db2512817c30"},{"index":23488,"token":false,"name":"Harbor Serpent","scryfallId":"aa10b43f-eb63-4999-92a0-56826031b686"},{"index":23491,"token":false,"name":"Wailing Ghoul","scryfallId":"7b1bf0dd-825c-4c8a-a48d-84f35fbe5901"},{"index":23496,"token":false,"name":"Barbed Sliver","scryfallId":"19bddea7-daa7-4bdb-9b91-f7fcbc0d7a57"},{"index":23497,"token":false,"name":"Foundry Screecher","scryfallId":"4313802f-b969-47d0-b4aa-b049df0755c0"},{"index":23500,"token":false,"name":"Furystoke Giant","scryfallId":"5b102dc6-d7ef-48dd-8b77-2ce43955f7fa"},{"index":23501,"token":false,"name":"Slice and Dice","scryfallId":"7e8c87a8-b527-4d76-8516-d1147e21773f"},{"index":23502,"token":false,"name":"Geode Golem","scryfallId":"bb640095-92f2-4fc7-b3f4-11d5c4629d10"},{"index":23508,"token":false,"name":"Metamorphosis","scryfallId":"4d0776db-ebb3-472d-8a90-5bd149b97346"},{"index":23510,"token":true,"name":"Horse Token (W, 5/5)","scryfallId":"f3dd4d92-6471-4f4b-9c70-cbd2196e8c7b"},{"index":23511,"token":false,"name":"Alluring Siren","scryfallId":"dea89d38-765d-4902-b985-bcc15363c4f2"},{"index":23513,"token":false,"name":"Living End","scryfallId":"b1eede29-17a4-437f-a5c2-e24cccbc6a33"},{"index":23521,"token":false,"name":"Agonizing Demise","scryfallId":"b7621aab-4839-45ef-bfa2-9aa2417bbec0"},{"index":23524,"token":false,"name":"Emerald Dragonfly","scryfallId":"a3e81250-52c3-49f6-be43-17c34339e177"},{"index":23525,"token":false,"name":"Staggering Insight","scryfallId":"125b8be1-76b9-434e-a505-5099d950767c"},{"index":23527,"token":false,"name":"Dwarven Landslide","scryfallId":"48ab243e-d08d-4ece-9725-4bb5f67b1c92"},{"index":23530,"token":false,"name":"Gruul Guildmage","scryfallId":"de5340c5-ae86-4ea2-b53a-964319bf3b59"},{"index":23531,"token":true,"name":"Harpy Token (B, 1/1)","scryfallId":"26b24bbe-f5bc-44d3-b716-6612d39b07bc"},{"index":23537,"token":false,"name":"Zephyr Boots","scryfallId":"4d0566fd-3775-48f1-ba22-6e659558c3d3"},{"index":23538,"token":false,"name":"Ecological Appreciation","scryfallId":"e76ba861-beb0-4cd2-8e06-626f587f6f44"},{"index":23539,"token":false,"name":"Black Sun's Zenith","scryfallId":"4ac0c0af-8886-4021-9919-eb8ef18e9eb2"},{"index":23542,"token":false,"name":"Helm of the Host","scryfallId":"1a0fd50b-ccde-4098-bd37-feb6038c53a7"},{"index":23549,"token":false,"name":"Game-Trail Changeling","scryfallId":"f2bfd529-9ef5-4497-8545-9a25ac384849"},{"index":23552,"token":false,"name":"Ashnod's Battle Gear","scryfallId":"0bc11285-0891-4cc3-a056-b698911166c7"},{"index":23555,"token":false,"name":"Bull Hippo","scryfallId":"74a3555f-cc81-4dcc-a3e1-2bd1864885c5"},{"index":23556,"token":false,"name":"Aven Fateshaper","scryfallId":"7a4b41c4-0d14-4b9c-8e0c-a626ba6b104d"},{"index":23557,"token":false,"name":"Boggart Arsonists","scryfallId":"8d7481d2-b814-4ced-afae-15b2495ab398"},{"index":23558,"token":false,"name":"Arcbound Wanderer","scryfallId":"d4242f34-33c0-4e16-a6d9-18499dc8f2eb"},{"index":23559,"token":false,"name":"Woolly Mammoths","scryfallId":"69ec2c31-f8f1-4bfc-998c-f4e41c366ec0"},{"index":23561,"token":false,"name":"Simplify","scryfallId":"7a43fd3e-1e08-400c-b22b-e22da82bcdee"},{"index":23562,"token":false,"name":"Flurry of Horns","scryfallId":"be522ae8-9cf4-4c63-9a1c-0010d482c00a"},{"index":23568,"token":false,"name":"Consuming Ferocity","scryfallId":"05835e35-f4f8-4513-b5a1-9e31b21168f0"},{"index":23569,"token":false,"name":"Flowstone Mauler","scryfallId":"bb44cde5-a31b-4901-b2ca-9f317a9dd395"},{"index":23571,"token":false,"name":"Death Cloud","scryfallId":"b0870b88-2794-4646-9f51-f3af03bc8bc8"},{"index":23572,"token":false,"name":"Imi Statue","scryfallId":"91c33332-8a72-4b81-a8e9-a73aaac6013c"},{"index":23574,"token":false,"name":"Hover Barrier","scryfallId":"884afdb3-0d5f-45a1-b57e-6c3760aa0031"},{"index":23577,"token":false,"name":"Deadeye Navigator","scryfallId":"fa94262b-f740-48fb-a937-75776864c9ee"},{"index":23578,"token":false,"name":"Undergrowth Scavenger","scryfallId":"4f8dc77e-f003-4c25-8394-cda22e3ea039"},{"index":23580,"token":true,"name":"Minotaur Younghorn Token (Colorless, 2/2)","scryfallId":"2c8e22f9-6b70-425c-a0a8-09b6101a286e"},{"index":23581,"token":false,"name":"Melting","scryfallId":"8d90065e-2c7e-44e5-9f59-015d468214bf"},{"index":23583,"token":false,"name":"Field Marshal","scryfallId":"1e22d287-274e-4222-9ed7-3e609a84ac07"},{"index":23585,"token":false,"name":"Mistform Wakecaster","scryfallId":"1e5cbfb9-9bd0-4f8b-a444-a480de4b9662"},{"index":23587,"token":false,"name":"Druid's Deliverance","scryfallId":"83b35961-f4d5-4e14-a793-335147110627"},{"index":23590,"token":false,"name":"Ulamog's Despoiler","scryfallId":"55b6b7f0-d7fc-46b6-99ff-ba8206ecd628"},{"index":23591,"token":false,"name":"Scab-Clan Berserker","scryfallId":"cd680805-5f82-4002-bacc-84e35f2d837c"},{"index":23593,"token":false,"name":"Nicol Bolas, God-Pharaoh","scryfallId":"c3d3bc3a-0c88-41ad-8607-f56cd4aa71d1"},{"index":23594,"token":false,"name":"Auriok Edgewright","scryfallId":"0f76b18a-396b-41f5-b34b-ac232b7f316b"},{"index":23595,"token":false,"name":"Xathrid Slyblade","scryfallId":"909a9252-1e97-4e85-9648-66050f301f8a"},{"index":23601,"token":false,"name":"Mardu Skullhunter","scryfallId":"dd3ca5e7-96f3-4326-9315-34bb396a054c"},{"index":23603,"token":false,"name":"Brink of Disaster","scryfallId":"dbab78cd-a899-4c5d-86b3-0666adadba87"},{"index":23604,"token":false,"name":"Conifer Strider","scryfallId":"baac2239-789a-42e6-8eb6-0b26836efb64"},{"index":23607,"token":false,"name":"Wild Celebrants","scryfallId":"6b9e72f4-0087-4a79-b9af-296c8b930a25"},{"index":23610,"token":false,"name":"Mage Hunter","scryfallId":"56fcbe4a-2d98-4fa9-a6c3-e28255171a4d"},{"index":23615,"token":false,"name":"Runaway Carriage","scryfallId":"6c8ce5d3-0184-4cfb-a41d-3d58229b2a5f"},{"index":23619,"token":false,"name":"Nissa, Genesis Mage","scryfallId":"2923c85a-4022-4cda-bcbb-bb000137f64f"},{"index":23621,"token":false,"name":"Feral Instinct","scryfallId":"20dec7cf-2865-4642-9022-d3006fd7ac30"},{"index":23622,"token":false,"name":"Marble Titan","scryfallId":"e4816f18-9f66-4539-9764-2f65f2826812"},{"index":23630,"token":false,"name":"Fungal Shambler","scryfallId":"433057b4-8663-46fc-a61b-bccbb677b75b"},{"index":23632,"token":true,"name":"Timeless Dragon Token (B, 4/4)","scryfallId":"f7ab74f3-897a-4dd9-b460-f31a0f496bb4"},{"index":23633,"token":false,"name":"Mine Layer","scryfallId":"497efda1-5013-45d2-b717-b0296218c42b"},{"index":23637,"token":false,"name":"Grixis Sojourners","scryfallId":"0cde5f43-0b91-45c9-9382-20ea6328266f"},{"index":23638,"token":false,"name":"Pact of the Titan","scryfallId":"8f332ef3-335a-494d-a90f-61a9e9834ccd"},{"index":23639,"token":false,"name":"Rona, Disciple of Gix","scryfallId":"45420f5e-f7f8-4db7-9b54-e2fa1be22094"},{"index":23644,"token":false,"name":"Vorapede","scryfallId":"f20ad28c-80a0-47c4-a5b6-685569d6a718"},{"index":23645,"token":false,"name":"Jackal Pup","scryfallId":"bb02ff74-e73f-467e-ac26-429d279a8e95"},{"index":23649,"token":false,"name":"Spirespine","scryfallId":"ac71491f-3027-4257-a18f-ba4de6041feb"},{"index":23652,"token":false,"name":"Neglected Heirloom // Ashmouth Blade","scryfallId":"5cc2ac21-d31f-4a0d-956a-dabb6e1f3b5a"},{"index":23654,"token":false,"name":"Vexing Arcanix","scryfallId":"0c9ea118-6a19-4e1b-aa5a-9b2729efc096"},{"index":23656,"token":false,"name":"Djeru, With Eyes Open","scryfallId":"2234df89-0835-4a17-b5d8-2334ee8f692d"},{"index":23660,"token":false,"name":"Arctic Treeline","scryfallId":"b20e3117-f1e4-4449-ae9d-0b66abfc717d"},{"index":23661,"token":false,"name":"Herald of War","scryfallId":"77e92bbb-c22d-4879-9437-b87a3ff70a2d"},{"index":23663,"token":false,"name":"Incite","scryfallId":"6ba4dcc6-05a5-43e9-b445-bae83180aa79"},{"index":23664,"token":false,"name":"Gerrard's Command","scryfallId":"d0fda263-b6a7-43e3-998a-72a9d84c4572"},{"index":23667,"token":false,"name":"Titanic Brawl","scryfallId":"bcf9b57a-a759-4488-965a-651070cd2156"},{"index":23669,"token":false,"name":"Tainted Isle","scryfallId":"595acbd2-d876-4ec5-8c0b-272e9ae73d0d"},{"index":23675,"token":false,"name":"Honored Hierarch","scryfallId":"3f9a4d21-5c19-494a-a323-9aa84b8b734b"},{"index":23680,"token":false,"name":"Drudge Spell","scryfallId":"52b352de-e989-4ad5-963c-818092fc9f1a"},{"index":23683,"token":false,"name":"Keeper of the Nine Gales","scryfallId":"ebe22587-662c-4f43-adbc-a614f5680636"},{"index":23684,"token":false,"name":"Academy Elite","scryfallId":"f3728fbb-3a99-443a-b514-40f9990669c5"},{"index":23686,"token":false,"name":"Choice of Damnations","scryfallId":"05939f15-2d95-47df-b66f-131c3e7ea95f"},{"index":23687,"token":false,"name":"Demonmail Hauberk","scryfallId":"aa33caa8-2a07-4f6c-a6c2-d21cf2d61193"},{"index":23689,"token":false,"name":"Scute Swarm","scryfallId":"6cf51c72-f237-4eec-8b95-d068c77bde8c"},{"index":23693,"token":false,"name":"Felisa, Fang of Silverquill","scryfallId":"229dec6e-7997-4954-bff7-c79dd4339211"},{"index":23695,"token":false,"name":"Toshiro Umezawa","scryfallId":"0e767e07-febd-4025-bf03-d4d816bc1d3d"},{"index":23697,"token":false,"name":"Llanowar Elite","scryfallId":"1d5d20ee-d5a5-4030-a2a1-8624c0ccc486"},{"index":23702,"token":false,"name":"Clarion Spirit","scryfallId":"86a4c348-1012-4339-960a-c7bc7fd84fbb"},{"index":23703,"token":false,"name":"Gods' Eye, Gate to the Reikai","scryfallId":"bdc33a21-d196-4c17-a296-87ff08e7ef69"},{"index":23705,"token":false,"name":"Sword of the Meek","scryfallId":"5a0c2773-3205-4ac4-b31c-c54fb06fdd7c"},{"index":23707,"token":false,"name":"Screeching Griffin","scryfallId":"5e2fa710-4615-42de-8716-41b009b56d32"},{"index":23712,"token":false,"name":"Evra, Halcyon Witness","scryfallId":"9f8e0d6e-6dbe-41d4-a251-c54e7d5cf2ec"},{"index":23714,"token":false,"name":"Zndrsplt, Eye of Wisdom","scryfallId":"2c370b8c-fa8c-4a80-82a7-f81c6a924078"},{"index":23719,"token":false,"name":"Dragon Broodmother","scryfallId":"e178108d-7347-405c-91ac-64bb012aa443"},{"index":23720,"token":false,"name":"Giant Opportunity","scryfallId":"40383646-3fc4-4267-b9ad-bf90a85972fc"},{"index":23723,"token":false,"name":"Ornery Kudu","scryfallId":"7c3b11c6-339f-4d11-8aeb-ec38834ee188"},{"index":23725,"token":false,"name":"Spiny Starfish","scryfallId":"b072ccea-816a-4176-9a77-478f207a9a1e"},{"index":23726,"token":false,"name":"Mistform Wall","scryfallId":"ebaa7a26-8516-4d71-a524-77b2d3f030d5"},{"index":23727,"token":false,"name":"Orcish Healer","scryfallId":"7ff511f3-416e-4919-acd6-fd8183bf5c60"},{"index":23730,"token":false,"name":"Jund Panorama","scryfallId":"a2b31fcd-43eb-44ad-b63e-4f2e6984963c"},{"index":23732,"token":false,"name":"Harbor Guardian","scryfallId":"78a2359f-6586-42a6-a855-c0049b448cb9"},{"index":23738,"token":false,"name":"Student of Warfare","scryfallId":"9f4df9be-324b-458a-9379-ab4aa437a6d2"},{"index":23740,"token":false,"name":"Awakening of Vitu-Ghazi","scryfallId":"b42b2fb4-8016-462c-8764-2639adec931f"},{"index":23742,"token":false,"name":"Galazeth Prismari","scryfallId":"c5214f65-2bab-46e4-aff5-a16cac249b53"},{"index":23743,"token":false,"name":"Ghitu Slinger","scryfallId":"923de31f-0941-4df1-8939-3eed75b7eb39"},{"index":23746,"token":false,"name":"Tormod's Cryptkeeper","scryfallId":"05900f1d-f065-4656-a8a2-2f719d3fdea8"},{"index":23747,"token":false,"name":"Tawnos, Urza's Apprentice","scryfallId":"a031a6c1-d7d1-4980-ac8e-30440ff4408f"},{"index":23750,"token":false,"name":"Wings of Velis Vel","scryfallId":"cc5f287b-beaa-4b51-8db7-91982e2c0bb0"},{"index":23754,"token":false,"name":"Enervate","scryfallId":"c4fdfc5b-c2ab-4c4d-b120-301e17f3d9c6"},{"index":23755,"token":false,"name":"Hopeful Eidolon","scryfallId":"4c69995b-ef31-4635-8d5a-b31f73993364"},{"index":23756,"token":false,"name":"Garruk Wildspeaker","scryfallId":"90816131-aa45-4c41-9c37-571d492e5052"},{"index":23761,"token":false,"name":"Dissipation Field","scryfallId":"247694c5-5813-4256-9fd8-478d4be52081"},{"index":23762,"token":false,"name":"Chord of Calling","scryfallId":"dac257a9-39bf-4185-9d2e-f80f0848a96a"},{"index":23764,"token":false,"name":"Sly Instigator","scryfallId":"d0fb17dc-12b1-4f37-a03b-573a95ec7bd2"},{"index":23776,"token":false,"name":"Pyknite","scryfallId":"6ffc64e4-ae3c-49f9-8ed6-518dd497bfe6"},{"index":23777,"token":false,"name":"Rouse","scryfallId":"ad01a8e2-5dc5-49a3-ad1c-7d5bf006b774"},{"index":23778,"token":false,"name":"Bandage","scryfallId":"79ed559a-9a88-43d2-85d1-4bbec038f71e"},{"index":23779,"token":false,"name":"Winding Canyons","scryfallId":"f26672a8-f4ff-4c64-bb3e-f5072bbc9e3e"},{"index":23780,"token":false,"name":"Mesmerizing Benthid","scryfallId":"5bed7c69-1302-4c1a-b410-b4e6c4ef4c0c"},{"index":23782,"token":true,"name":"Zombie Token (B, */*)","scryfallId":"95c59642-575f-4356-ae1a-20b90895545b"},{"index":23784,"token":false,"name":"Archon of Cruelty","scryfallId":"c38d9873-f4e9-418f-aee8-8623b2576f6c"},{"index":23789,"token":false,"name":"Loxodon Punisher","scryfallId":"df2b90b8-8306-4543-b9f4-3cfd033f5ca5"},{"index":23791,"token":false,"name":"Nyx Lotus","scryfallId":"f3e73185-afdf-4fae-82c3-b5ea355c1572"},{"index":23792,"token":false,"name":"Odric, Master Tactician","scryfallId":"00111afb-26fe-487b-8d12-087cd8a8fe86"},{"index":23797,"token":false,"name":"Necrologia","scryfallId":"8c2ee9d9-20be-46f0-8752-1df50942f59c"},{"index":23800,"token":false,"name":"Engulfing Slagwurm","scryfallId":"8aeabc4a-7b4f-4e3d-bcc7-423bb703563a"},{"index":23803,"token":false,"name":"Tel-Jilad Defiance","scryfallId":"ef01d3f6-c172-43fb-bc65-ff12567111da"},{"index":23804,"token":false,"name":"Rubblebelt Maaka","scryfallId":"2f3f29fe-8985-4939-8ced-786145261085"},{"index":23807,"token":false,"name":"Goblin Flectomancer","scryfallId":"8170c05b-826c-4879-b202-29eec6f955ea"},{"index":23810,"token":false,"name":"Kheru Dreadmaw","scryfallId":"e8b10468-18b8-4321-a791-0cbd18ea9c4d"},{"index":23812,"token":false,"name":"Screaming Fury","scryfallId":"7e8488b6-3785-4346-a81b-c28d355f9d25"},{"index":23813,"token":false,"name":"Exiled Doomsayer","scryfallId":"74aaf095-143a-43fc-a858-b1e82a4b906e"},{"index":23814,"token":false,"name":"King Narfi's Betrayal","scryfallId":"e4a160a0-df41-4a33-bed2-7fca8e1edc87"},{"index":23817,"token":false,"name":"Glacian, Powerstone Engineer","scryfallId":"a736df42-18e9-4259-b0b8-54d21143e72e"},{"index":23822,"token":false,"name":"Goldnight Commander","scryfallId":"80be2fea-3fe6-477e-bcb8-63f441d6cfc1"},{"index":23823,"token":false,"name":"Trumpeting Gnarr","scryfallId":"2fe88a45-a420-4998-b242-b475c6b5b0bc"},{"index":23824,"token":false,"name":"Alabaster Kirin","scryfallId":"ad1ce529-06ed-4e85-9988-8c8b58401ed5"},{"index":23827,"token":false,"name":"Windborne Charge","scryfallId":"6cbfac9f-1935-4526-8dfa-9a535ff14950"},{"index":23829,"token":false,"name":"Arahbo, Roar of the World","scryfallId":"81dc3d00-97cd-4549-b5a4-15a1e08767f5"},{"index":23833,"token":false,"name":"Crosis's Attendant","scryfallId":"45edc18c-2046-4d0e-92fe-a6cf4aaf1c6f"},{"index":23843,"token":false,"name":"Aerial Caravan","scryfallId":"adac91af-5165-4779-99f7-e75c83fa5d5d"},{"index":23847,"token":false,"name":"Commander's Authority","scryfallId":"08ef4383-11e7-4426-a04a-058570f46e47"},{"index":23849,"token":false,"name":"Academy Rector","scryfallId":"21aa9f50-face-4f2d-860d-9cd51a1b36d7"},{"index":23851,"token":false,"name":"Armada Wurm","scryfallId":"26290f14-f2f4-4c6c-b167-75379d78370d"},{"index":23853,"token":false,"name":"Brightwood Tracker","scryfallId":"e1fb9767-29bf-4a69-b37c-0925d41f6b46"},{"index":23860,"token":false,"name":"Krosan Druid","scryfallId":"c332dc82-7664-44d0-b92a-a3d867399884"},{"index":23862,"token":false,"name":"Kruphix's Insight","scryfallId":"94e14f09-9629-443a-bc55-03152eabb2e7"},{"index":23863,"token":false,"name":"Hatred","scryfallId":"2383a8d9-96fd-4f9a-bcf9-eb81fdb15ead"},{"index":23864,"token":false,"name":"Mnemonic Deluge","scryfallId":"2d0e725b-2250-4189-9682-73461b5cfed2"},{"index":23865,"token":false,"name":"Liquimetal Torque","scryfallId":"13c6101a-da40-4785-8ccb-4e779bbbdb55"},{"index":23874,"token":false,"name":"Angelic Skirmisher","scryfallId":"50a38cb7-d663-4fca-a462-a0199694aee3"},{"index":23875,"token":false,"name":"Unexpectedly Absent","scryfallId":"04bf7e2b-a05f-4ce6-b64c-809b74790b59"},{"index":23877,"token":false,"name":"Hidden Herbalists","scryfallId":"9ec8db01-415e-42a1-8eb2-57280d58b38e"},{"index":23880,"token":false,"name":"Zagoth Triome","scryfallId":"64ecb374-9be6-4ee2-807b-f2adbb19bb2a"},{"index":23888,"token":false,"name":"City of Traitors","scryfallId":"71624139-a255-48be-93ca-594a4beba487"},{"index":23890,"token":false,"name":"Phantom Flock","scryfallId":"617d4246-c827-4742-ab6a-c5170c12cb87"},{"index":23898,"token":false,"name":"Sower of Temptation","scryfallId":"2f5320da-7214-4348-84d8-74bf951c9f2f"},{"index":23904,"token":false,"name":"Boggart Forager","scryfallId":"fbc26374-d8de-4740-b1ec-ac92cfedbebc"},{"index":23907,"token":false,"name":"Strongarm Thug","scryfallId":"20aa9108-470c-484d-908a-c31cf6935765"},{"index":23911,"token":false,"name":"Skeleton Scavengers","scryfallId":"57af1b3f-661a-4b02-be08-0ec721d7cab8"},{"index":23912,"token":false,"name":"Arlinn's Wolf","scryfallId":"747223a5-c669-4d0e-a062-265eb47710cd"},{"index":23917,"token":false,"name":"Implements of Sacrifice","scryfallId":"aa5deb95-79a6-4398-b82a-c1df169550d9"},{"index":23921,"token":false,"name":"Hive Mind","scryfallId":"88d50518-5cfc-45de-a125-acabf97b8743"},{"index":23922,"token":false,"name":"Commune with Lava","scryfallId":"1ef4c8b0-6da7-443d-9c1f-6e83e6831f43"},{"index":23924,"token":false,"name":"Minamo Sightbender","scryfallId":"a598d08d-c9d4-4de5-bef5-998dd115b8b6"},{"index":23929,"token":false,"name":"Zhalfirin Commander","scryfallId":"cb0e63cb-6da5-4f65-a976-e79d201e9fc7"},{"index":23936,"token":true,"name":"Human Warrior Token (W, 1/1)","scryfallId":"06fbcd85-c54e-492e-9e42-5e101cac4255"},{"index":23937,"token":false,"name":"Voice of Reason","scryfallId":"ed3d5a10-6d4b-4383-b400-7323f2b4670e"},{"index":23943,"token":false,"name":"Feral Incarnation","scryfallId":"d8c0c7e7-81f5-4e75-8120-95488fd6ff60"},{"index":23950,"token":false,"name":"Kabira Vindicator","scryfallId":"52b1e9b3-d641-4fe5-a3bf-14d953f62e73"},{"index":23951,"token":false,"name":"Bitterblade Warrior","scryfallId":"dd54edbb-c35d-4f7f-b5ce-d39b0f766ab8"},{"index":23955,"token":false,"name":"Prismari Command","scryfallId":"8ffb6717-93f5-4774-9cc3-29b883b144b5"},{"index":23956,"token":false,"name":"Nyxborn Colossus","scryfallId":"8b4f003c-1e99-4e53-ad6d-81ff3c592b2c"},{"index":23963,"token":false,"name":"Sindbad","scryfallId":"7b112a10-ac40-4353-bbdd-e5efd4546330"},{"index":23964,"token":false,"name":"Curiosity Crafter","scryfallId":"7e01c4c7-ad59-464c-b01c-7cb7010b816f"},{"index":23965,"token":false,"name":"Merrow Grimeblotter","scryfallId":"b839c9d0-ef08-4661-8009-3bcb256bf508"},{"index":23967,"token":false,"name":"Ritual of the Machine","scryfallId":"537b4109-ae7c-451a-8576-97f817a70d75"},{"index":23971,"token":false,"name":"Oathkeeper, Takeno's Daisho","scryfallId":"01b7c8e4-db88-48f3-bfd5-8d990f449b1c"},{"index":23986,"token":false,"name":"Untamed Hunger","scryfallId":"caccbba0-80b1-461c-b548-33d7f3a48342"},{"index":23989,"token":false,"name":"Brutal Hordechief","scryfallId":"ab8ec769-99cd-4542-9b4d-61ee41b622bc"},{"index":23993,"token":false,"name":"Ravenous Gigantotherium","scryfallId":"ca260253-40b8-4846-9e41-4e9cfc56d691"},{"index":23994,"token":false,"name":"Nissa, Worldwaker","scryfallId":"07eb2476-488b-4610-8567-f0456601f7fd"},{"index":23996,"token":true,"name":"Pirate // Treasure Token (B, 2/2)","scryfallId":"46bf5e2b-869f-480e-ac37-1bdb40a92f8c"},{"index":23997,"token":false,"name":"Glint Hawk Idol","scryfallId":"0a742da4-638d-4888-94f1-db2f4ada9f94"},{"index":23998,"token":false,"name":"Wilderness Hypnotist","scryfallId":"1947000d-bc0f-4f8b-a9a6-09bf29f846ea"},{"index":24004,"token":false,"name":"Merfolk Skyscout","scryfallId":"92ad1471-96d2-4d61-9695-5f2daf122353"},{"index":24013,"token":false,"name":"Myr Turbine","scryfallId":"71a76840-47f7-4e1e-b68b-00cb7da98cdf"},{"index":24014,"token":false,"name":"Animation Module","scryfallId":"34bdc973-db45-46a6-ac48-ce88fb59920a"},{"index":24015,"token":false,"name":"Shinen of Stars' Light","scryfallId":"64cd3ee0-d893-4346-98b6-7d7896ad7663"},{"index":24017,"token":true,"name":"Minotaurs","scryfallId":"3b2273cc-feeb-42ee-8d4f-eae2c670fcf0"},{"index":24018,"token":false,"name":"Skyshroud Condor","scryfallId":"a7d05ef5-c046-4929-b59d-988f0313a645"},{"index":24019,"token":false,"name":"Fiery Mantle","scryfallId":"c41deea2-c12f-40cd-8fc4-47227c762f42"},{"index":24021,"token":false,"name":"Su-Chi","scryfallId":"a64d4f93-0c04-4078-aec0-7e9de92f260f"},{"index":24023,"token":false,"name":"Hissing Miasma","scryfallId":"f394fd39-842f-4c98-b857-bdad3fd09758"},{"index":24025,"token":false,"name":"Cephalid Pathmage","scryfallId":"88528929-4953-452a-b85e-dac15786e094"},{"index":24029,"token":false,"name":"Silver Wyvern","scryfallId":"02a20067-4ac2-4688-b8e8-3463185c4a41"},{"index":24030,"token":false,"name":"Void Grafter","scryfallId":"6c2e37e2-a4bd-4f90-9191-3125784a3369"},{"index":24033,"token":false,"name":"Nightveil Specter","scryfallId":"e3754b8c-16d2-41e3-b41b-4b2e70833e82"},{"index":24038,"token":false,"name":"Primal Visitation","scryfallId":"2dd518e8-047a-4df0-a0b8-ba116d048fa8"},{"index":24039,"token":false,"name":"Dragonscale General","scryfallId":"df904cc6-3ee0-4326-a854-818695aa2890"},{"index":24041,"token":false,"name":"Akuta, Born of Ash","scryfallId":"08730b49-e51e-4868-9cc8-4ddc4a1dce4c"},{"index":24044,"token":false,"name":"Voyaging Satyr","scryfallId":"155ae6c0-5085-45f1-ba9f-508d501fee2c"},{"index":24054,"token":false,"name":"Forgestoker Dragon","scryfallId":"db79ab19-0ab2-4ed9-b39a-eeaf22aabdbd"},{"index":24057,"token":false,"name":"Ravnica at War","scryfallId":"e0f83824-43c6-4101-88fd-9109958b23e2"},{"index":24059,"token":false,"name":"Horobi, Death's Wail","scryfallId":"b41983cb-c4e4-4384-bd69-df3fc6e74cd0"},{"index":24066,"token":false,"name":"Jwari Disruption // Jwari Ruins","scryfallId":"301750a7-d1fd-435e-bfa8-9d2fb22ad627"},{"index":24069,"token":false,"name":"Vile Consumption","scryfallId":"7f7e5716-77f3-45d2-a40a-f5bf500f6ad7"},{"index":24074,"token":false,"name":"Hunter's Ambush","scryfallId":"6250c566-b224-405c-b1ac-97ca3b0aa44e"},{"index":24075,"token":false,"name":"Fraying Sanity","scryfallId":"9e36bf9b-5ba6-407d-972a-04bf314fd12e"},{"index":24076,"token":false,"name":"Trade Routes","scryfallId":"f5a23417-3419-4edc-a722-b695e676a3ce"},{"index":24077,"token":false,"name":"Timberline Ridge","scryfallId":"87cc2fc9-0a24-4ac1-afcc-9317b90c7178"},{"index":24078,"token":false,"name":"Sphinx of Lost Truths","scryfallId":"d97b61b6-bf80-4326-a646-a1985e0b50d7"},{"index":24081,"token":false,"name":"Decorated Champion","scryfallId":"0cee6784-3171-4f28-af3d-f7993bc45303"},{"index":24085,"token":false,"name":"Lodestone Myr","scryfallId":"617ddf01-3678-470d-b009-003d6a561dbf"},{"index":24088,"token":false,"name":"Foundation Breaker","scryfallId":"4f08381e-34f5-4d08-b737-8c37964719e0"},{"index":24091,"token":false,"name":"Jewel-Eyed Cobra","scryfallId":"8f8db60d-3adf-45e1-b4d0-3b5e24f5e01d"},{"index":24092,"token":false,"name":"Inevitable End","scryfallId":"a6522f01-ae7a-467e-9a05-530a5ccd304d"},{"index":24094,"token":false,"name":"Merchant Raiders","scryfallId":"fad152da-057d-4805-9e0c-3842ad43e336"},{"index":24097,"token":false,"name":"Scent of Brine","scryfallId":"d117bf8d-23ec-4f9d-99d0-3a990c5f7075"},{"index":24102,"token":false,"name":"Day of the Dragons","scryfallId":"91d702a9-efdc-4e88-afe1-451f3a5b3ebb"},{"index":24103,"token":false,"name":"Elaborate Firecannon","scryfallId":"4b9170f0-d332-42ba-98c7-7e99922fa3fb"},{"index":24105,"token":false,"name":"Torch Fiend","scryfallId":"e3e258a9-d978-4bcd-ad51-e05744847cbe"},{"index":24109,"token":true,"name":"Ravenous Brute Head Token (Colorless, 0/6)","scryfallId":"a76d49f7-2860-4972-ab97-1e798ea017d1"},{"index":24115,"token":false,"name":"Miara, Thorn of the Glade","scryfallId":"7bdb9bfe-5e56-429d-af23-7548532e2406"},{"index":24122,"token":false,"name":"Predatory Hunger","scryfallId":"db6d9d28-3a05-4dfa-a322-36b4cc2697d4"},{"index":24127,"token":false,"name":"Festering Wound","scryfallId":"927eed13-510b-4b06-811d-91a6a069cb8c"},{"index":24128,"token":false,"name":"Fell the Mighty","scryfallId":"0741e122-e538-4e0b-bdf4-c21b47d27b5c"},{"index":24131,"token":false,"name":"Treva's Charm","scryfallId":"72acb67d-01cb-4fde-8b0b-199e8d1e396a"},{"index":24139,"token":false,"name":"Spirit Weaver","scryfallId":"90b0ef47-cb22-4146-a17e-e49a6031a7e6"},{"index":24141,"token":false,"name":"Doom Whisperer","scryfallId":"0a11ee0d-ff8d-4648-8b4e-29440c135c30"},{"index":24146,"token":false,"name":"Domri, Anarch of Bolas","scryfallId":"3f30584c-31e6-4227-96b1-00ce1acb47ad"},{"index":24152,"token":false,"name":"Adventure Awaits","scryfallId":"db50f988-da46-4b9b-9cc5-78497df2df8b"},{"index":24154,"token":false,"name":"Gilded Lotus","scryfallId":"bc8add12-e02e-477d-b51d-d94d14923fd6"},{"index":24156,"token":false,"name":"Savage Gorilla","scryfallId":"32ad3f87-9f25-455f-9933-3b0b0eaad467"},{"index":24158,"token":false,"name":"Silumgar Butcher","scryfallId":"40cb67f7-b4e1-423b-8f55-d44ed383e778"},{"index":24163,"token":false,"name":"Heart Sliver","scryfallId":"27a83ab6-0d15-49e4-90e3-b3a2a095c632"},{"index":24164,"token":false,"name":"Domri, Chaos Bringer","scryfallId":"1f56bbf3-3884-495a-b9cd-6585d86f76f1"},{"index":24165,"token":false,"name":"Sprout Swarm","scryfallId":"0b915355-4e98-44df-81bd-961a3d3c86b8"},{"index":24167,"token":false,"name":"Thassa's Devourer","scryfallId":"d4ebd8c0-bb03-434d-b669-d9b35d07b2c6"},{"index":24168,"token":false,"name":"Gale Swooper","scryfallId":"d2e3b99c-e48e-4f4d-ba7a-e9218137b432"},{"index":24173,"token":false,"name":"Goblin Champion","scryfallId":"9543660a-6797-4719-bbe7-ff6e40709599"},{"index":24180,"token":false,"name":"Dreadwaters","scryfallId":"c4c1434a-4832-4008-a091-e0703dedd0a2"},{"index":24182,"token":false,"name":"Shape Anew","scryfallId":"b3d5462e-f60c-4550-b29e-4d9f9cd72385"},{"index":24185,"token":false,"name":"Blossoming Calm","scryfallId":"792610fd-736d-43b0-8899-dbb5accddca0"},{"index":24187,"token":false,"name":"Mammoth Growth","scryfallId":"0e55041f-69a5-4bcf-899f-a4b44c208b4d"},{"index":24188,"token":false,"name":"Dreg Reaver","scryfallId":"e7771eba-bc2d-40f2-bab4-5e9cc4fe8f34"},{"index":24192,"token":false,"name":"Cinderhaze Wretch","scryfallId":"644319c2-f122-4369-b1f8-56ad7d8ce861"},{"index":24193,"token":false,"name":"Silent Gravestone","scryfallId":"ff60f685-a17e-4be6-bbb6-d14a053533ef"},{"index":24194,"token":false,"name":"Birthing Pod","scryfallId":"96d8b133-6431-4dd8-bb41-60f0e2cb67d6"},{"index":24201,"token":false,"name":"Watcher in the Web","scryfallId":"0b6a0d46-d32d-4eb3-963b-2a952b6fdc83"},{"index":24202,"token":false,"name":"Rootless Yew","scryfallId":"992aba3f-e1cb-4f5a-8b6f-328a069102a4"},{"index":24204,"token":false,"name":"Relentless Dead","scryfallId":"2a0d7998-2f3d-43b8-a0be-6ff7e5c83223"},{"index":24205,"token":false,"name":"Child of Alara","scryfallId":"863f701f-fba2-48db-95ef-0926986cdac9"},{"index":24208,"token":false,"name":"Moonlit Strider","scryfallId":"04fe00af-1634-45bd-bf1b-42997c4c3359"},{"index":24210,"token":false,"name":"Vedalken Humiliator","scryfallId":"edcce058-f628-42d7-b5c7-726df0de3e32"},{"index":24214,"token":false,"name":"Rank and File","scryfallId":"59481cb5-2cb0-4b8c-84ee-519399862d46"},{"index":24215,"token":false,"name":"Thalia's Geistcaller","scryfallId":"4531482d-9238-40de-957e-61beb5700330"},{"index":24216,"token":false,"name":"Kjeldoran Outpost","scryfallId":"77211807-63f5-486d-8677-c146ab9bb783"},{"index":24219,"token":false,"name":"Blood Crypt","scryfallId":"3d7c66e7-2b43-443f-998c-80613735a87f"},{"index":24228,"token":false,"name":"Charging Cinderhorn","scryfallId":"fc0b61f2-4bb7-4dfa-907c-71787930d58f"},{"index":24229,"token":false,"name":"Seacoast Drake","scryfallId":"5333de10-a6d4-47ff-ab57-4edb49535739"},{"index":24230,"token":false,"name":"Witch's Mist","scryfallId":"651c7735-088d-495b-a58f-69abf4cac197"},{"index":24232,"token":false,"name":"Bellows Lizard","scryfallId":"5da4a644-9809-4591-9007-6b70b5f9d923"},{"index":24233,"token":false,"name":"Marsh Gas","scryfallId":"b80ecb15-258b-4fc9-86e4-c2bf01891606"},{"index":24238,"token":false,"name":"Striped Bears","scryfallId":"0bf54365-56ae-485d-b931-784a4cf9d8f2"},{"index":24247,"token":false,"name":"Spotted Griffin","scryfallId":"5fbba1f3-53c6-4c74-850b-dde17bde0021"},{"index":24250,"token":false,"name":"Warded Battlements","scryfallId":"f234999b-54e9-40f5-a537-7d6ce169c710"},{"index":24255,"token":false,"name":"Infectious Horror","scryfallId":"bb460855-f09d-4460-9d3f-1bfcc7f3e626"},{"index":24256,"token":false,"name":"Quirion Trailblazer","scryfallId":"c2b258c1-5fb4-4072-bb32-ad364df1874a"},{"index":24258,"token":false,"name":"Soul Seizer // Ghastly Haunting","scryfallId":"f500cb95-d5ea-4cf2-920a-f1df45a9059b"},{"index":24259,"token":false,"name":"Ezuri's Archers","scryfallId":"32cc93af-d9a0-4ed8-8c22-686d005ea77e"},{"index":24260,"token":false,"name":"Sleek Schooner","scryfallId":"767e2bfb-bcf5-442c-b092-bdb1f4f13561"},{"index":24261,"token":false,"name":"Deny the Divine","scryfallId":"1200f68a-a8ea-4777-b6b0-de48b2203fd1"},{"index":24262,"token":false,"name":"Benevolent Blessing","scryfallId":"0d5c2401-da2c-46f9-b850-f37edcbb85cd"},{"index":24263,"token":false,"name":"Pariah's Shield","scryfallId":"cc316f1e-84ce-4013-a150-d537f964a604"},{"index":24268,"token":false,"name":"Dreamspoiler Witches","scryfallId":"7d5c2487-5da0-4d9a-beb2-598feeb068a1"},{"index":24273,"token":false,"name":"Flaying Tendrils","scryfallId":"10bf8dbf-ae2e-41cd-904c-84b9cca14c27"},{"index":24274,"token":false,"name":"Elfhame Druid","scryfallId":"5e62226e-3585-42d2-9b7a-2462fcd967f5"},{"index":24276,"token":false,"name":"Trade Caravan","scryfallId":"fdcc821b-8125-4585-ba44-4bf8c1873fbf"},{"index":24277,"token":false,"name":"Ainok Artillerist","scryfallId":"3a4c8964-06e4-4a24-9a7e-9cac0fb8518e"},{"index":24278,"token":false,"name":"Matsu-Tribe Sniper","scryfallId":"143af295-040d-400e-ae23-59abd2f88e11"},{"index":24279,"token":false,"name":"Satyr Firedancer","scryfallId":"7fc6a735-cbf5-4af2-b15c-7ced82f0d9da"},{"index":24280,"token":false,"name":"Infernal Pet","scryfallId":"80340582-655b-4bf1-88fb-14bcbe17aa04"},{"index":24284,"token":false,"name":"Haakon, Stromgald Scourge","scryfallId":"60dd9df6-478c-475e-a04e-86a2cd5abf3a"},{"index":24287,"token":false,"name":"Dovin's Dismissal","scryfallId":"6328e6b5-9dfb-4fd4-99ee-a1ffc2c707da"},{"index":24288,"token":false,"name":"Pyrokinesis","scryfallId":"25f98f02-9ada-4561-93fd-9cfcb0f48b5d"},{"index":24291,"token":false,"name":"Bant Charm","scryfallId":"65b65c87-b084-44aa-b841-411a3c73e234"},{"index":24293,"token":false,"name":"Finishing Blow","scryfallId":"2b85a552-2119-4d9c-b7c1-c09c2d9f2f38"},{"index":24294,"token":false,"name":"Malevolent Whispers","scryfallId":"c5b781ed-9f16-4cef-8b97-7a3e90abfdb3"},{"index":24296,"token":false,"name":"Wooden Stake","scryfallId":"7e2825f5-8112-4108-910a-4303b2d57356"},{"index":24297,"token":false,"name":"Covenant of Blood","scryfallId":"752b7d05-19d7-4765-9bf8-05a7cb539c3f"},{"index":24299,"token":false,"name":"Endling","scryfallId":"d8831634-ad60-40c0-91fd-abde22caae00"},{"index":24301,"token":false,"name":"Dune Diviner","scryfallId":"01818188-e18e-4dc0-b7ef-34cedef64f7e"},{"index":24305,"token":false,"name":"Nantuko Cultivator","scryfallId":"33a7e43a-4028-41e5-b5dd-be8ef6a1b510"},{"index":24306,"token":false,"name":"Arcbound Fiend","scryfallId":"408f42ae-fb83-4c8a-8638-38c719dec197"},{"index":24308,"token":false,"name":"Volrath the Fallen","scryfallId":"08bdd66e-9ca1-456e-a61c-7c96cf6f7c56"},{"index":24309,"token":false,"name":"Diaochan, Artful Beauty","scryfallId":"a72946ac-8e7f-4ed4-9a07-ee4d5c8a85b9"},{"index":24310,"token":false,"name":"Sacred Knight","scryfallId":"57b19990-c4a2-433d-a9ce-005216e9e4ac"},{"index":24312,"token":false,"name":"Herald of Kozilek","scryfallId":"2a4180ae-1fd9-4185-b4f0-9e8f668a5737"},{"index":24313,"token":false,"name":"Darksteel Axe","scryfallId":"4d6bfe57-872d-4f69-bff5-a3f2584d6e0a"},{"index":24315,"token":false,"name":"Infinite Authority","scryfallId":"dc60077f-d577-4a6c-a78f-697317024c40"},{"index":24316,"token":false,"name":"Liability","scryfallId":"0b07c66d-5f37-4098-b7e6-03e6c684806b"},{"index":24317,"token":false,"name":"Last-Ditch Effort","scryfallId":"295f7fe0-0681-4b25-807f-30ed70ec78d5"},{"index":24318,"token":false,"name":"Gryff's Boon","scryfallId":"9d8aecb0-c535-493c-bf64-4964e061deba"},{"index":24322,"token":false,"name":"Sphere of Safety","scryfallId":"a18d7582-185a-429a-9c6a-fc51b981e0a1"},{"index":24323,"token":false,"name":"Nomads' Assembly","scryfallId":"00afdd58-a6e3-490c-8ff5-3d761fcd3885"},{"index":24324,"token":false,"name":"Mercadian Atlas","scryfallId":"00ad3531-399c-4897-b0ee-ad2a26445a17"},{"index":24326,"token":false,"name":"Kessig Cagebreakers","scryfallId":"b4cf67ac-63b8-4cd5-843f-0dd1724dcc46"},{"index":24334,"token":false,"name":"Sky-Eel School","scryfallId":"5cfc4db7-13b5-4c88-91f2-581c9792f1ff"},{"index":24335,"token":false,"name":"Freyalise Supplicant","scryfallId":"5b1e718a-882a-4bdc-9d62-4dda88da0ba0"},{"index":24341,"token":false,"name":"Munitions Expert","scryfallId":"a8572dfd-9da1-4727-b549-47f9b119f6ac"},{"index":24343,"token":false,"name":"Steward of Valeron","scryfallId":"237c62b7-7c0e-44bb-b420-d41aad2792a0"},{"index":24347,"token":false,"name":"Visage of Bolas","scryfallId":"f29bbfe2-d59f-4361-8ea4-6a8d1b909769"},{"index":24357,"token":false,"name":"Undercity Scavenger","scryfallId":"1be7e297-4602-44f8-b919-07015813fd7e"},{"index":24358,"token":false,"name":"Freyalise's Charm","scryfallId":"3e147ac1-d221-49c7-966e-5e665ddeab6b"},{"index":24362,"token":false,"name":"Wirewood Hivemaster","scryfallId":"24792e17-4ec6-4413-9e96-4b382490f385"},{"index":24364,"token":false,"name":"Opalescence","scryfallId":"1a2f4972-8987-4349-953d-1e5c71368b08"},{"index":24366,"token":false,"name":"Nurturer Initiate","scryfallId":"2330c78d-1655-4074-a650-27740be4cee1"},{"index":24370,"token":false,"name":"Aspect of Mongoose","scryfallId":"b3eb61f4-627b-4f42-85aa-eb676a035fbd"},{"index":24372,"token":false,"name":"Mirror Golem","scryfallId":"d9467839-b2a2-4cfe-a60e-12766e2ba983"},{"index":24373,"token":false,"name":"Magus of the Disk","scryfallId":"70cdad7a-f041-4bbe-87ed-876ac6d0c31b"},{"index":24375,"token":true,"name":"Zombie Warrior Token (B, 4/4)","scryfallId":"2e06aa97-1611-4af6-8bad-32051927fcfd"},{"index":24379,"token":false,"name":"Sanctuary Raptor","scryfallId":"ccbdb1eb-2546-4c1a-bfab-ef61bdadd364"},{"index":24385,"token":false,"name":"Boundless Realms","scryfallId":"e3c3cf16-ba81-4558-b1a6-79942a02f629"},{"index":24391,"token":false,"name":"Kiss of the Amesha","scryfallId":"3f73da96-6dea-4a0a-9ca1-6fed10ff601a"},{"index":24393,"token":false,"name":"Lifesmith","scryfallId":"28e5dcac-0d59-4bcc-8a0e-036cc23065b5"},{"index":24394,"token":false,"name":"Fyndhorn Druid","scryfallId":"778b028f-fa4e-4638-82b4-fb287223ea20"},{"index":24396,"token":false,"name":"Mindwhip Sliver","scryfallId":"fa966fbb-140d-4057-a4fc-998ebe07c307"},{"index":24397,"token":false,"name":"Soratami Mirror-Guard","scryfallId":"3ff8968b-cd96-4f44-85f8-2af20d61d7cb"},{"index":24398,"token":false,"name":"Song of Creation","scryfallId":"7e98d2e6-8247-4915-928b-25d6e2efc908"},{"index":24403,"token":false,"name":"Tower of Eons","scryfallId":"0eb67150-53e4-4164-bea5-dd3659469b8e"},{"index":24408,"token":false,"name":"Rootwater Thief","scryfallId":"38addef3-1dd7-41a1-9706-3be5c86a58c9"},{"index":24410,"token":false,"name":"Library Larcenist","scryfallId":"cb33529b-80bd-4f52-94cc-d8371c53ad75"},{"index":24411,"token":false,"name":"Hooded Hydra","scryfallId":"9d7e651f-4187-44c5-99bf-34042d6dd9a2"},{"index":24412,"token":false,"name":"Ogre Gatecrasher","scryfallId":"ffddd4e2-e98c-4535-bac2-0af73f1535c5"},{"index":24416,"token":true,"name":"Roil Royale // Roil Royale (cont'd)","scryfallId":"1f69159e-46cc-4399-8efe-3f94a5368e86"},{"index":24417,"token":false,"name":"Encampment Keeper","scryfallId":"5eb32517-6bd8-4918-b3f8-70c5cf512d7c"},{"index":24425,"token":false,"name":"Kraken of the Straits","scryfallId":"12ae69b3-afa5-4763-a0c8-c3d9d96f6ddc"},{"index":24428,"token":false,"name":"Muzzio, Visionary Architect","scryfallId":"d4af4cc3-bd51-4161-baec-091d729ac820"},{"index":24434,"token":false,"name":"Expressive Iteration","scryfallId":"93e5c7e8-e6bf-4186-8140-d1171fbb8552"},{"index":24438,"token":false,"name":"Thieves' Fortune","scryfallId":"8175ec81-f4e2-45d2-a9d8-e8855e17ff4a"},{"index":24439,"token":false,"name":"Legion's End","scryfallId":"49a1cd92-9d75-4e22-a934-a26d84967015"},{"index":24443,"token":false,"name":"Planar Despair","scryfallId":"3a92d454-3f23-45bf-921f-25b0da4ce138"},{"index":24444,"token":false,"name":"Hellraiser Goblin","scryfallId":"c6d4ab45-ab42-4144-9c57-ba046b76860c"},{"index":24448,"token":false,"name":"Kavu Aggressor","scryfallId":"a2832ad3-ce7f-44d2-beb2-c95d982905a6"},{"index":24450,"token":false,"name":"Empty City Ruse","scryfallId":"4d37c84c-80e5-453d-bd2e-4f77ff864c89"},{"index":24453,"token":false,"name":"Veteran Cavalier","scryfallId":"31072355-0b20-4830-9d46-ca71783af84b"},{"index":24454,"token":false,"name":"Corrupted Crossroads","scryfallId":"7043e193-8051-4f1b-9633-9c1f250d3607"},{"index":24458,"token":false,"name":"Walking Sponge","scryfallId":"b125d1e7-5d9b-4997-88b0-71bdfc19c6f2"},{"index":24459,"token":false,"name":"Glyph of Life","scryfallId":"ba1384e5-d140-4074-9548-250af09cb413"},{"index":24463,"token":false,"name":"Vitalize","scryfallId":"d6ee4997-4b1a-4e03-88ac-63b451bb7b38"},{"index":24469,"token":false,"name":"Skirsdag Flayer","scryfallId":"274976b0-2bb5-46e6-b62e-b50d80a77e28"},{"index":24470,"token":false,"name":"Deathbellow War Cry","scryfallId":"cf0f58ac-88ef-445c-a12b-0bb1cf482298"},{"index":24474,"token":false,"name":"Arm with Aether","scryfallId":"a0878b20-315d-49fa-a4d7-232ba1ed6b0d"},{"index":24476,"token":false,"name":"Watcher in the Mist","scryfallId":"fb971f49-8898-444a-a17c-caeb1696c62a"},{"index":24481,"token":false,"name":"Signal the Clans","scryfallId":"34261992-db62-49e3-95bc-1b2960868de4"},{"index":24487,"token":false,"name":"Uril, the Miststalker","scryfallId":"11e22185-47d0-465b-8181-afe194af5cac"},{"index":24488,"token":false,"name":"Triton Cavalry","scryfallId":"4b9b6c6b-35f8-4c8a-aa29-ae71d5166121"},{"index":24495,"token":false,"name":"Windrider Wizard","scryfallId":"c790a86d-db91-4a87-aa3a-3f9fc4d4b662"},{"index":24497,"token":false,"name":"Eureka Moment","scryfallId":"e400c9b7-c789-49dd-9f72-b9d1df03fcca"},{"index":24502,"token":false,"name":"Rakdos Locket","scryfallId":"4fd60d9b-2282-4b32-9bff-efb2bcf87d22"},{"index":24503,"token":false,"name":"Reckless Cohort","scryfallId":"77a4cdec-e5fc-4ea8-a7bc-f1109fadae3c"},{"index":24507,"token":false,"name":"Vassal Soul","scryfallId":"dfc61748-029f-4bae-a7ec-e08b7059226d"},{"index":24508,"token":false,"name":"Emberwilde Caliph","scryfallId":"9598a9b4-15bb-4645-92ed-8eedef75dc24"},{"index":24509,"token":false,"name":"Rampaging Brontodon","scryfallId":"4232ef32-de63-49b1-8fbb-d080231c4bbd"},{"index":24510,"token":false,"name":"Pistus Strike","scryfallId":"1a2918d6-50f7-4bc1-aef2-930a5c84be8d"},{"index":24514,"token":false,"name":"Spelleater Wolverine","scryfallId":"a5f03ffd-dcdb-441c-8dfc-4fe06a289b22"},{"index":24516,"token":false,"name":"Web of Inertia","scryfallId":"0e6d2721-1dfc-4f4f-a914-9352ca6981c0"},{"index":24519,"token":false,"name":"Shah of Naar Isle","scryfallId":"cee5e9e3-e3ae-4e1b-a8fb-48c523631105"},{"index":24522,"token":false,"name":"Charging Troll","scryfallId":"a3d4b427-7fef-4a56-91a4-89cfbd881c89"},{"index":24524,"token":false,"name":"Cruel Tutor","scryfallId":"4fc89e7f-f2a4-41a6-a948-17b230545fe9"},{"index":24528,"token":false,"name":"Skyshaper","scryfallId":"234ed934-6ea7-41f6-bd13-3df8662a3a1d"},{"index":24530,"token":false,"name":"Ramunap Ruins","scryfallId":"af11d41a-0d29-45e9-9d27-a41282b9e292"},{"index":24531,"token":false,"name":"Dub","scryfallId":"c3de35fd-425d-46b8-bc7d-c2f05d86858d"},{"index":24536,"token":false,"name":"Monstrous Hound","scryfallId":"7ae4162d-e080-4db1-912f-d53674c76170"},{"index":24555,"token":false,"name":"Wu Elite Cavalry","scryfallId":"7cf562e2-be8e-4514-b2c8-3268dc1ab0db"},{"index":24560,"token":false,"name":"Lavabelly Sliver","scryfallId":"87731608-7038-453f-97dc-12cfa5b9211d"},{"index":24561,"token":false,"name":"Ether Well","scryfallId":"0a2cf195-01bf-4076-a0c6-ca5403d84f7d"},{"index":24562,"token":false,"name":"Zndrsplt's Judgment","scryfallId":"17eed02c-e2af-4642-b411-1b20494109a7"},{"index":24563,"token":false,"name":"Prized Unicorn","scryfallId":"757d1e9b-4292-4dcc-ae52-d9f60aa6694d"},{"index":24566,"token":false,"name":"Moldgraf Monstrosity","scryfallId":"b20a1d49-699d-413e-985b-7890f3e7115e"},{"index":24567,"token":false,"name":"Gideon's Defeat","scryfallId":"4722eb81-1aa1-4863-8dfb-d9d6035bd6c6"},{"index":24568,"token":false,"name":"Defiling Tears","scryfallId":"db7cba29-9472-4874-bd54-37edf70645b2"},{"index":24578,"token":false,"name":"Mossbridge Troll","scryfallId":"537c39cc-44d3-4869-9e76-dd9c2c68ee90"},{"index":24582,"token":false,"name":"Staunch Shieldmate","scryfallId":"db17f25a-32d1-469b-bb5f-f1761e227990"},{"index":24583,"token":false,"name":"Conqueror's Pledge","scryfallId":"1af1844a-601a-48c1-bf96-921d2d2e2aa1"},{"index":24585,"token":false,"name":"Throne of Geth","scryfallId":"583d7386-3eb5-4f1d-8da9-f00e020a307b"},{"index":24587,"token":false,"name":"Game Preserve","scryfallId":"1bb62356-72bb-4dc1-a2f9-45a3aca62e41"},{"index":24590,"token":false,"name":"Spitemare","scryfallId":"fefeb0e2-ddd4-4881-bca4-6c7699c82d79"},{"index":24593,"token":false,"name":"Bruvac the Grandiloquent","scryfallId":"82f70920-94ca-4cc6-9ad7-bc2f28d6b615"},{"index":24597,"token":false,"name":"Call for Blood","scryfallId":"be04ed26-8036-4505-83d3-b782e7e1fb45"},{"index":24599,"token":false,"name":"Galvanoth","scryfallId":"fc1a696b-642a-419f-bd43-09af39a9401b"},{"index":24603,"token":false,"name":"Flourishing Fox","scryfallId":"5d0b6981-0fd4-4f58-bba4-a7efd4c633d0"},{"index":24605,"token":false,"name":"Workshop Assistant","scryfallId":"b8e4b2f1-88a6-42d9-99b3-2eaaf15f034a"},{"index":24608,"token":false,"name":"Darksteel Reactor","scryfallId":"1b2f1e30-7b30-4853-aeac-3b0933d4ac5e"},{"index":24609,"token":false,"name":"Never // Return","scryfallId":"a4b32135-7061-4278-a01a-4fcbaadc9706"},{"index":24610,"token":false,"name":"Boneknitter","scryfallId":"c9d58030-a95a-4221-93bc-30a59344e30b"},{"index":24612,"token":false,"name":"Rustic Clachan","scryfallId":"19bc170c-4a84-4c07-b481-b50b82f62f44"},{"index":24613,"token":false,"name":"Riptide Biologist","scryfallId":"4d399b71-c365-492c-976e-2c79d97d08bc"},{"index":24615,"token":false,"name":"Flowstone Slide","scryfallId":"ec7b02e1-0a20-4247-ae2a-056c5356f168"},{"index":24616,"token":false,"name":"Druidic Satchel","scryfallId":"ccc796ae-360f-4a3f-83d3-610ff3162b9a"},{"index":24620,"token":false,"name":"Necrogen Censer","scryfallId":"4f707119-ede9-4697-b723-d6cea96e6f2b"},{"index":24621,"token":false,"name":"Seething Song","scryfallId":"9213d580-7953-455f-abbe-99d3db2705cf"},{"index":24622,"token":false,"name":"Nissa, Nature's Artisan","scryfallId":"777533c3-0a87-4625-8987-d850fc236ddb"},{"index":24623,"token":false,"name":"Cerodon Yearling","scryfallId":"116abc15-d79b-4dfe-8f9f-f38bcf429da8"},{"index":24627,"token":false,"name":"Jorn, God of Winter // Kaldring, the Rimestaff","scryfallId":"c0195076-ce62-4a4e-b381-aaf7c009b9ee"},{"index":24628,"token":false,"name":"Virulent Swipe","scryfallId":"b61d7f4b-e3c3-49f1-a600-6e6ac71a5515"},{"index":24631,"token":false,"name":"Sublime Archangel","scryfallId":"95e53129-c49b-4bb8-a816-629fc87e58bb"},{"index":24632,"token":false,"name":"Ranger en-Vec","scryfallId":"4a89e82c-7206-4d74-95c6-ad3627e5a9ce"},{"index":24633,"token":true,"name":"Matt Linde Bio","scryfallId":"24af7223-40ba-4bc3-93f7-12cafa8090b2"},{"index":24643,"token":false,"name":"Immersturm Predator","scryfallId":"0d83d2d9-b9d0-47f5-989b-f2c726401ade"},{"index":24647,"token":false,"name":"Vine Dryad","scryfallId":"fc9c9158-faed-42ae-9f6b-71dee49ff79f"},{"index":24652,"token":false,"name":"Thing in the Ice // Awoken Horror","scryfallId":"ffc5eb51-14ba-4f31-b47c-3c9b7aee96e0"},{"index":24654,"token":false,"name":"Neurok Familiar","scryfallId":"52fd15b0-4ada-41c7-81e0-4f8956798685"},{"index":24659,"token":false,"name":"Manifestation Sage","scryfallId":"14a7a615-d187-45bd-8f65-3458d896ce5e"},{"index":24660,"token":false,"name":"Sadistic Augermage","scryfallId":"db9ee363-40c4-495f-910a-4f4cd6377e84"},{"index":24672,"token":true,"name":"Janosch Kühn Decklist (2000)","scryfallId":"170c4817-104c-4a10-a796-6e62c5104920"},{"index":24677,"token":false,"name":"Flame Javelin","scryfallId":"407858c8-316d-47a7-8234-c490a0bc87a6"},{"index":24678,"token":false,"name":"Infernal Reckoning","scryfallId":"4e291f27-d74f-48e7-bcb4-ddcc558c2211"},{"index":24679,"token":false,"name":"Browse","scryfallId":"3fd1b41f-5113-4a7c-9c35-04ebdf002af2"},{"index":24680,"token":false,"name":"Dragonloft Idol","scryfallId":"0bdff68c-ad98-48b0-9e00-8c5032a3cdb1"},{"index":24685,"token":false,"name":"Emergency Powers","scryfallId":"547d62cb-9cf1-48c8-8b58-3ce1db4c0a2f"},{"index":24694,"token":false,"name":"Nav Squad Commandos","scryfallId":"9d81d7f8-375f-40f5-98cd-08be08580bef"},{"index":24696,"token":false,"name":"Solidarity","scryfallId":"7810eec1-9bb4-480f-9074-712ad9eb8fba"},{"index":24705,"token":false,"name":"Invader Parasite","scryfallId":"89a8c53f-2cb0-41ea-8391-c32667f17c30"},{"index":24709,"token":false,"name":"Temmet, Vizier of Naktamun","scryfallId":"1024c07a-8764-4a78-8f82-1b1dd943e06f"},{"index":24710,"token":false,"name":"Magmaroth","scryfallId":"d7df3cea-37ec-4651-a99a-5a0f8a52adcb"},{"index":24712,"token":false,"name":"Tradewind Rider","scryfallId":"6afb09b1-4af7-4778-a88b-51530e12a39c"},{"index":24715,"token":false,"name":"Seer's Lantern","scryfallId":"348c4c68-c16d-4b65-821f-dc7e2c3eaec7"},{"index":24716,"token":false,"name":"Scytheclaw","scryfallId":"fd8f1665-5884-411a-9449-08938713df6b"},{"index":24719,"token":false,"name":"Castigate","scryfallId":"8114941e-71b8-4310-8c2a-bee7f940b724"},{"index":24723,"token":false,"name":"Chill","scryfallId":"f26eae3c-628c-4aa8-8e74-bbd2b11e71f7"},{"index":24725,"token":false,"name":"Mtenda Griffin","scryfallId":"162dd988-0beb-48e4-9eaa-a08ddb835648"},{"index":24729,"token":false,"name":"Mirror Strike","scryfallId":"148fbe36-b22d-44e6-9341-7f707baca49d"},{"index":24732,"token":false,"name":"Archpriest of Iona","scryfallId":"a23d588e-f7d8-4a11-9bf5-77b9f6faffd4"},{"index":24733,"token":false,"name":"Lethal Vapors","scryfallId":"f96acfea-009a-4ac9-8746-64f65199024f"},{"index":24737,"token":false,"name":"Mindslaver","scryfallId":"98fb1eaa-2871-491a-a4f5-3e358778ba40"},{"index":24744,"token":false,"name":"Anointed Deacon","scryfallId":"9bae5e75-0048-41fd-8bbb-89607ab96d6e"},{"index":24745,"token":false,"name":"Haunting Hymn","scryfallId":"2be041f3-482d-40f3-a525-39e3d6890c56"},{"index":24749,"token":false,"name":"Smoldering Efreet","scryfallId":"af33b204-6b50-4404-b986-9f6b970a7f06"},{"index":24751,"token":false,"name":"Avizoa","scryfallId":"a993986c-e8f1-41b1-86e6-c72021c53b87"},{"index":24752,"token":false,"name":"Territorial Gorger","scryfallId":"eb895f4d-8d3a-450a-9611-c5704decd444"},{"index":24757,"token":false,"name":"Fanatical Firebrand","scryfallId":"5e5565de-028c-4799-a9f6-4dcd685639eb"},{"index":24758,"token":false,"name":"Jelenn Sphinx","scryfallId":"533c89eb-d7c6-4945-9689-2f2c0e428b84"},{"index":24760,"token":false,"name":"Life Chisel","scryfallId":"50052f9a-d667-4a96-a9b1-b4169ee495e6"},{"index":24761,"token":false,"name":"Head Games","scryfallId":"73ab3037-7e62-46a7-800e-8bfa7d33f237"},{"index":24763,"token":false,"name":"Underworld Cerberus","scryfallId":"3a078c3d-88db-4459-9667-ce610ae2f660"},{"index":24766,"token":false,"name":"Piety","scryfallId":"8a5a1a13-dfc8-49b7-9b17-3f0c5ca1b8be"},{"index":24767,"token":false,"name":"Street Riot","scryfallId":"80b352d5-4a57-41bc-b4c4-8b81255a9db8"},{"index":24769,"token":false,"name":"Soul of the Harvest","scryfallId":"0fb9e961-7c1c-41ce-b058-11ef33198057"},{"index":24774,"token":false,"name":"Shivan Gorge","scryfallId":"e32266dd-abd5-475d-9e89-1eb8ef30287b"},{"index":24775,"token":false,"name":"Hunter of Eyeblights","scryfallId":"bbd5b8db-4a56-45bd-9704-a1316016ec5b"},{"index":24776,"token":false,"name":"Storm Fleet Pyromancer","scryfallId":"ab5f5e45-2abb-43e1-aecb-97f0390282a7"},{"index":24778,"token":false,"name":"Inertia Bubble","scryfallId":"72b2d227-68b3-40e8-bef7-45ea43e17318"},{"index":24781,"token":false,"name":"Muck Drubb","scryfallId":"e5bda3fc-89e8-44c2-bcfb-d17064bbc391"},{"index":24782,"token":false,"name":"Serpent of the Endless Sea","scryfallId":"f525d734-7e19-4c1e-a5c2-097b718df7c4"},{"index":24783,"token":false,"name":"Spine of Ish Sah","scryfallId":"59313b00-ac75-484a-ad74-db9d8960c0f8"},{"index":24785,"token":false,"name":"Obelisk of Bant","scryfallId":"0cefe6ab-c018-4b87-8948-295a28f63cb1"},{"index":24786,"token":false,"name":"Centaur Nurturer","scryfallId":"bf020acb-e0c6-43b4-8324-0f2ec68b73d6"},{"index":24788,"token":false,"name":"Frenetic Sliver","scryfallId":"424b1d87-ff9d-4511-a196-b8ae8b5b5e1d"},{"index":24789,"token":false,"name":"Enslave","scryfallId":"b47beeb9-0ce1-49cf-bf6f-3673c489af62"},{"index":24792,"token":false,"name":"Voracious Dragon","scryfallId":"fbda3a22-2aff-49db-8779-38551142b860"},{"index":24800,"token":false,"name":"Dromar's Cavern","scryfallId":"85f10cee-6a63-438e-a9df-6b902dd025b8"},{"index":24808,"token":false,"name":"Dreadful Apathy","scryfallId":"e20c2369-db77-465e-9f0e-bb009225345a"},{"index":24811,"token":false,"name":"Soulblade Renewer","scryfallId":"98c7bdf9-cda0-4498-8f6e-c7e8bc735fd8"},{"index":24814,"token":false,"name":"Pardic Wanderer","scryfallId":"2fffe967-3a99-4f00-af46-f4e5567598df"},{"index":24820,"token":false,"name":"Spire Barrage","scryfallId":"f8c8fe2a-3203-4545-bb25-b1f107b13cca"},{"index":24821,"token":false,"name":"Bloodthorn Taunter","scryfallId":"8769e8f6-15ad-4f1b-bb4d-848ae6b7549e"},{"index":24822,"token":false,"name":"Leaf-Crowned Elder","scryfallId":"c666dc97-8780-4982-b9e7-7d4a358f922c"},{"index":24823,"token":false,"name":"Stunning Reversal","scryfallId":"6714197d-7420-43a1-8b08-4e1fd6355b54"},{"index":24827,"token":false,"name":"Rekindling Phoenix","scryfallId":"36da8a69-2547-4836-ac33-805306a7f3af"},{"index":24828,"token":false,"name":"Gift of the Gargantuan","scryfallId":"1850be87-54de-49b3-a407-6fb2b278b25c"},{"index":24829,"token":false,"name":"Warden of the Chained","scryfallId":"ff48d55e-aa8b-4061-9c77-fd7e696fd7ba"},{"index":24830,"token":true,"name":"Cat Token (G, 1/1)","scryfallId":"fbdf8dc1-1b10-4fce-97b9-1f5600500cc1"},{"index":24831,"token":false,"name":"Spectral Flight","scryfallId":"f7149f2a-6917-4ad7-8035-c7a1babd4d4b"},{"index":24834,"token":false,"name":"Village Elder","scryfallId":"253a1d97-ec45-41c9-ba81-bbb6ab584b2b"},{"index":24836,"token":true,"name":"Warrior Token (B, 2/1)","scryfallId":"3b5eaba1-a7e1-4bbb-949c-e7f6a9592f50"},{"index":24840,"token":false,"name":"Spiteflame Witch","scryfallId":"41d1a332-f950-4f56-9b1e-37c0954e72f6"},{"index":24847,"token":true,"name":"Ben Rubin Decklist","scryfallId":"e869f999-0f28-4ad8-ac3d-1e2d5f410d18"},{"index":24851,"token":false,"name":"Lady Sun","scryfallId":"0f45e837-7b98-46ef-b21b-e3508ce999e5"},{"index":24852,"token":false,"name":"Blade Sliver","scryfallId":"a8d6f7a6-7b6a-44f4-be04-7c02806b9f09"},{"index":24857,"token":false,"name":"Commence the Endgame","scryfallId":"209d70a2-c8c1-4072-ab1f-57804b55a09a"},{"index":24859,"token":false,"name":"Somnophore","scryfallId":"c35aa7a8-5579-46b7-83ef-f5ecc2b31847"},{"index":24861,"token":false,"name":"Legion's Landing // Adanto, the First Fort","scryfallId":"4ee6e3d4-8c42-4632-b573-1ef0f2dc2030"},{"index":24865,"token":false,"name":"Dwarven Grunt","scryfallId":"6f00d726-4289-48ff-8c14-6a5080a00fda"},{"index":24866,"token":false,"name":"Dense Foliage","scryfallId":"f6232f04-cd4c-4889-97dc-cccc4a09f9c4"},{"index":24867,"token":false,"name":"Dark Intimations","scryfallId":"8338f5d2-38e8-460e-ade3-c7f96025362b"},{"index":24871,"token":false,"name":"Keldon Warcaller","scryfallId":"22d2e230-2d60-402d-98e4-0f33d2f27c56"},{"index":24874,"token":false,"name":"Into the Fray","scryfallId":"c99d116c-41c0-41af-9a68-9ac995f3000b"},{"index":24878,"token":false,"name":"Benalish Commander","scryfallId":"44814da0-3bc8-423d-9b22-3fea123048fa"},{"index":24882,"token":false,"name":"Siani, Eye of the Storm","scryfallId":"8812e448-241e-4640-9cb6-0cdbe1ad2fcc"},{"index":24885,"token":false,"name":"Grand Coliseum","scryfallId":"f8829b0a-88dc-401e-94ef-50c9e83bacf5"},{"index":24891,"token":false,"name":"Gift of Strength","scryfallId":"75f5e144-4dd6-441f-b3e2-433aa82bdf7b"},{"index":24898,"token":false,"name":"Floodwaters","scryfallId":"3a211df0-fe9e-4d2c-9e0e-c7be50e6b906"},{"index":24900,"token":false,"name":"Wall of Vipers","scryfallId":"00042443-4d4e-4087-b4e5-5e781e7cc5fa"},{"index":24902,"token":false,"name":"Harsh Justice","scryfallId":"3657001a-7f79-4d3f-9d35-462ecf684fa8"},{"index":24906,"token":false,"name":"Dryad's Caress","scryfallId":"8cf707f2-1a62-458e-bcc8-8b1cd081f225"},{"index":24907,"token":false,"name":"Gravitational Shift","scryfallId":"bad32b9f-0aa4-4036-90e6-c087cffd52e7"},{"index":24913,"token":false,"name":"Old-Growth Troll","scryfallId":"b759b0f6-342c-4bba-89f1-8451835d8c45"},{"index":24917,"token":false,"name":"Voidmage Husher","scryfallId":"e199afa3-d16d-4b8e-b553-86bc3884aed1"},{"index":24918,"token":false,"name":"Mothrider Samurai","scryfallId":"35a236f7-f008-4eb8-91d9-31ea8589cf0c"},{"index":24920,"token":false,"name":"Nobilis of War","scryfallId":"6d54ab6e-dd56-40fe-abab-a1e67b024744"},{"index":24922,"token":false,"name":"Setessan Training","scryfallId":"1947f64a-5ca0-4dda-8bbd-8472e72ecf18"},{"index":24923,"token":false,"name":"Tymaret Calls the Dead","scryfallId":"ed58ad91-5279-41c8-8da9-f5a5a49e1f7e"},{"index":24928,"token":false,"name":"Take Down","scryfallId":"f8e702db-8c73-4947-9c13-5dcb50f4efab"},{"index":24929,"token":false,"name":"Cerulean Sphinx","scryfallId":"dc95d4a6-ad4b-46c5-8a75-e70102363844"},{"index":24931,"token":false,"name":"Veiled Sentry","scryfallId":"de458a9d-6c09-42bb-b470-c2691e95345a"},{"index":24934,"token":true,"name":"Sheep Token (G, 2/2)","scryfallId":"281d2c14-2343-44c9-a589-7f4da37978a2"},{"index":24936,"token":false,"name":"Nocturnal Raid","scryfallId":"3ce3de8a-de37-4ae4-89a0-8cad68885609"},{"index":24939,"token":false,"name":"Greel, Mind Raker","scryfallId":"e9d1f317-efd1-4595-92e2-44815a2b8147"},{"index":24941,"token":false,"name":"Leovold's Operative","scryfallId":"d41deffe-766f-4a46-8552-73483adc0cfb"},{"index":24946,"token":false,"name":"Crippling Chill","scryfallId":"53f73e5f-6228-494f-b74e-aca3520dc2b2"},{"index":24948,"token":false,"name":"Gorgon Flail","scryfallId":"eefc48cb-79aa-4e28-a736-ae9e4e2bc97b"},{"index":24951,"token":false,"name":"Snakeform","scryfallId":"7d96d4f2-7f19-4687-927a-5b840254a4f9"},{"index":24955,"token":false,"name":"Battlefield Thaumaturge","scryfallId":"467ffc93-b107-457c-af04-a1b682a4b886"},{"index":24959,"token":false,"name":"Test of Endurance","scryfallId":"cf16bd6b-e99c-4da3-bd03-11f63b7ee85d"},{"index":24960,"token":false,"name":"Chaosphere","scryfallId":"bd41cb92-578b-4fc8-b1e6-56604088fcd5"},{"index":24962,"token":false,"name":"Fiend Artisan","scryfallId":"653e706a-5506-4efd-a86b-2a25bb66a2ae"},{"index":24963,"token":false,"name":"Barbed-Back Wurm","scryfallId":"1b96810d-72d3-4dee-a29f-cdf85ea5ce6f"},{"index":24966,"token":false,"name":"Waterspout Djinn","scryfallId":"0c4d3ffe-3e4d-496f-98d7-60f3b1757b67"},{"index":24970,"token":false,"name":"Bloodfire Mentor","scryfallId":"4836fb70-a8f3-44ed-bae4-890ef7d07f88"},{"index":24974,"token":false,"name":"Benevolent Ancestor","scryfallId":"f23110b5-0dd4-49a2-8991-bc673aed53c9"},{"index":24976,"token":false,"name":"Undergrowth Stadium","scryfallId":"35bd7a70-0cd1-48f2-96b6-7869c003a8c7"},{"index":24977,"token":false,"name":"Unesh, Criosphinx Sovereign","scryfallId":"53d56953-cac5-4bd4-bec9-d442d70d7e96"},{"index":24980,"token":false,"name":"Liliana, the Necromancer","scryfallId":"4d2cbc2c-dbe3-4ecb-8fbe-785cb80b9e76"},{"index":24985,"token":false,"name":"Price of Knowledge","scryfallId":"97f536be-7836-4c9a-befc-94590e602f26"},{"index":24994,"token":false,"name":"Ghitu Chronicler","scryfallId":"de91c5b9-0225-4174-be22-5a32637e524b"},{"index":24995,"token":false,"name":"Thousand-legged Kami","scryfallId":"5c88355e-dff0-4d51-a33c-08e14d6217d4"},{"index":24996,"token":false,"name":"Rakdos Drake","scryfallId":"bb413a6f-407c-4705-963c-223fdf524a4a"},{"index":25004,"token":false,"name":"Tree of Perdition","scryfallId":"29d59151-09e5-4e6c-8c46-586796535733"},{"index":25005,"token":false,"name":"Somberwald Alpha","scryfallId":"492808ec-7e23-4266-adc5-519e74a06bbb"},{"index":25010,"token":false,"name":"Quilled Sliver","scryfallId":"72486240-eabb-4b37-99cc-ab13413683fa"},{"index":25011,"token":false,"name":"Death's Shadow","scryfallId":"59ed2566-97c4-40d8-bb43-80bcbe465a3c"},{"index":25012,"token":false,"name":"Thundering Chariot","scryfallId":"cd2fa92d-5521-421c-b3f8-7c14bbef3080"},{"index":25013,"token":false,"name":"Surprise Deployment","scryfallId":"9a26148b-b981-4af5-995b-52b1426737e3"},{"index":25017,"token":false,"name":"Void Squall","scryfallId":"3d8a7aee-6403-44ce-a119-66147aa311fd"},{"index":25019,"token":false,"name":"Runed Stalactite","scryfallId":"9be88336-83c7-422d-8826-13ceb8db5534"},{"index":25022,"token":false,"name":"Zombie Mob","scryfallId":"ab85551f-c9cc-409c-9fb5-a45de695e521"},{"index":25023,"token":false,"name":"Merchant of Secrets","scryfallId":"10227a24-d4f7-4dfa-a54d-eaf183fd7e79"},{"index":25024,"token":false,"name":"Spirit of the Hearth","scryfallId":"93fb7e08-ff15-49b9-bed8-0faadfa8338f"},{"index":25028,"token":false,"name":"Prismwake Merrow","scryfallId":"4d7ac836-07c9-469d-9ed0-4a0aab457e31"},{"index":25031,"token":false,"name":"Grizzled Leotau","scryfallId":"2b388381-9e13-4ce7-b5b3-56a74cc23d93"},{"index":25032,"token":false,"name":"Magus of the Bazaar","scryfallId":"d117ed81-7b5c-4e29-b958-6126d48ac5a6"},{"index":25034,"token":false,"name":"Guul Draz Mucklord","scryfallId":"b996743e-7f48-49d8-948b-ceb75bddf215"},{"index":25035,"token":false,"name":"Skyclave Shadowcat","scryfallId":"b27fcfc5-a1a9-4b21-8240-2ed6346c64e1"},{"index":25037,"token":false,"name":"Cascade Seer","scryfallId":"13105c88-2926-40ad-bc7a-09d515aa36c6"},{"index":25045,"token":false,"name":"Gyre Sage","scryfallId":"6345376a-3d2d-4fff-9430-5e90a96e2f0f"},{"index":25048,"token":false,"name":"Xyris, the Writhing Storm","scryfallId":"447db519-7825-4330-99e7-a2429e1f6b2e"},{"index":25050,"token":false,"name":"Splitting Slime","scryfallId":"6c1ffb14-9d92-4239-8694-61d156c9dba7"},{"index":25057,"token":false,"name":"Goblin Recruiter","scryfallId":"6ee791d5-1d48-40e8-b65f-b6aa889f3467"},{"index":25062,"token":false,"name":"Crimson Honor Guard","scryfallId":"9597255c-2657-40e4-855f-c8701a70aa39"},{"index":25066,"token":false,"name":"Irencrag Feat","scryfallId":"9c7c5be0-33b6-404a-b52f-501be19e43f5"},{"index":25067,"token":false,"name":"Screeching Sliver","scryfallId":"313e71da-ce72-4976-8286-f4495ea56485"},{"index":25070,"token":false,"name":"Silent Clearing","scryfallId":"ac07e230-0297-4e1d-bdfe-119010e0ad8e"},{"index":25073,"token":false,"name":"Swarm Intelligence","scryfallId":"2c573d12-4c69-4a54-b1b9-236c003ba98a"},{"index":25074,"token":false,"name":"Warren Instigator","scryfallId":"98637219-40d8-414c-939d-e2c90b909725"},{"index":25077,"token":false,"name":"Crumbling Sanctuary","scryfallId":"c8473918-46f5-4b72-9eb3-bd31f7a2602e"},{"index":25080,"token":false,"name":"Bushmeat Poacher","scryfallId":"cc01faf4-fabb-40c9-a1d6-359280535f91"},{"index":25081,"token":false,"name":"Grizzled Wolverine","scryfallId":"95bb17b9-55c4-4cc1-83f6-75490b9a97d0"},{"index":25082,"token":false,"name":"Fork in the Road","scryfallId":"0a7ad701-65c3-494a-8986-b4ea1bab46bc"},{"index":25088,"token":false,"name":"Return of the Nightstalkers","scryfallId":"e85d85c2-9f34-4375-adcd-a1c5b487cacc"},{"index":25093,"token":false,"name":"Drain the Well","scryfallId":"28ebd1f5-55ee-48c9-a8df-85c8c4bf3473"},{"index":25096,"token":false,"name":"Fade into Antiquity","scryfallId":"59d6bdf8-f06f-43b7-b0c6-012fa989ba79"},{"index":25098,"token":false,"name":"Toxic Stench","scryfallId":"8c4d1f59-0dba-4b83-8386-ae564fb4b771"},{"index":25099,"token":false,"name":"Goblin Game","scryfallId":"cbe6e7e5-ffea-4c6c-8a42-28e695029f24"},{"index":25101,"token":false,"name":"Revenge of the Hunted","scryfallId":"36f7d663-115c-4ad0-a072-633df054cce4"},{"index":25102,"token":false,"name":"Ready // Willing","scryfallId":"22081f95-dc8e-41ed-b609-b6a22ee5428b"},{"index":25104,"token":false,"name":"Sunken Ruins","scryfallId":"9d91a31c-b70a-45bd-a8dd-48d49b277f24"},{"index":25105,"token":false,"name":"Griffin Dreamfinder","scryfallId":"b569fadd-d9ca-4b0d-bee2-9d45574e56f0"},{"index":25109,"token":false,"name":"Warteye Witch","scryfallId":"e0d4dd61-cc7e-4fc5-afce-73a4b326cfdb"},{"index":25110,"token":false,"name":"Cho-Arrim Alchemist","scryfallId":"42c9d49d-61eb-4f33-b06b-03bdd990efd0"},{"index":25113,"token":false,"name":"Ruinous Gremlin","scryfallId":"895ba64d-1310-4f7d-a2ff-1c33ba43d3c2"},{"index":25114,"token":false,"name":"Sudden Storm","scryfallId":"6beffc33-58fd-4364-b87b-d4573ecaf4bd"},{"index":25118,"token":false,"name":"Thundering Wurm","scryfallId":"8b0ba623-d17f-4f0e-b914-da139a3971df"},{"index":25119,"token":false,"name":"Skinwing","scryfallId":"3c65e0ff-7dab-4090-8a99-f42d486728c9"},{"index":25120,"token":false,"name":"Heartseeker","scryfallId":"a4f33c08-f3c3-4015-970d-ac0530f97c9c"},{"index":25125,"token":false,"name":"Astrolabe","scryfallId":"a4578576-de6b-4387-aad3-0ae9d91244d1"},{"index":25126,"token":false,"name":"Ajani's Aid","scryfallId":"7026c374-0776-403b-86fd-5092677fd5c9"},{"index":25129,"token":false,"name":"Volt Charge","scryfallId":"aa88011c-a19d-4faa-8da6-86b9980cd571"},{"index":25132,"token":false,"name":"Rivalry","scryfallId":"3b79677b-d5b9-47c7-a5f5-45446d5cddff"},{"index":25135,"token":false,"name":"Stun","scryfallId":"c09c0da6-37a7-42ba-b264-18898ee372f0"},{"index":25137,"token":false,"name":"Flamekin Spitfire","scryfallId":"9a7878e5-fcb0-4de5-8dda-fcdb4b138ec1"},{"index":25140,"token":false,"name":"Shared Animosity","scryfallId":"ca5feaf7-3ca0-4ad7-b56b-b76d39e4bec7"},{"index":25146,"token":false,"name":"Meteor Shower","scryfallId":"50b4851e-677b-468e-9baa-e47a3b4b8339"},{"index":25153,"token":false,"name":"Clockspinning","scryfallId":"1323d548-e2fe-47c5-8df3-f181aed537c5"},{"index":25154,"token":false,"name":"Commune with Nature","scryfallId":"fb648eea-c731-4c4c-bf4a-a3f136983c36"},{"index":25155,"token":false,"name":"Peel from Reality","scryfallId":"fb56f097-0878-40bc-83ea-d28bcd91125b"},{"index":25158,"token":false,"name":"Casting of Bones","scryfallId":"88442ddf-c12b-4a25-804d-29fef5a90a0c"},{"index":25163,"token":false,"name":"Bog Glider","scryfallId":"086a5620-704b-47a9-9a5d-73e28631d6f8"},{"index":25166,"token":false,"name":"Swerve","scryfallId":"10affb59-7c57-4b72-892b-d813f385f4a9"},{"index":25167,"token":false,"name":"Glare of Heresy","scryfallId":"8ed3d16f-f0c6-4080-8913-758208b08234"},{"index":25178,"token":false,"name":"Balloon Peddler","scryfallId":"c34963e6-850e-4ce4-b04f-5e623ce5b73f"},{"index":25179,"token":false,"name":"Uninvited Geist // Unimpeded Trespasser","scryfallId":"4dea7c9f-ce66-447b-9f1b-d9bca5806153"},{"index":25182,"token":false,"name":"Auriok Survivors","scryfallId":"deffb601-6a53-4d88-a6af-686ce97eb4f0"},{"index":25183,"token":true,"name":"Ooze Token (G, 2/2)","scryfallId":"8ea26341-372c-4657-8910-08e0131fe0fc"},{"index":25196,"token":false,"name":"Yavimaya Ants","scryfallId":"5ded1c83-a289-4951-b72a-477a041610d3"},{"index":25198,"token":false,"name":"Surging Dementia","scryfallId":"1eb7cb72-24f7-433b-9858-26009189daaa"},{"index":25204,"token":false,"name":"Hunted Horror","scryfallId":"0ca680e3-2d10-4a32-8b0c-8b0c6be96540"},{"index":25205,"token":false,"name":"Alpine Meadow","scryfallId":"8702d6b9-bb01-4841-a76d-4a576066c772"},{"index":25207,"token":false,"name":"Geode Rager","scryfallId":"28f684e5-a263-4841-b297-a094c76d906f"},{"index":25210,"token":false,"name":"Banewasp Affliction","scryfallId":"ca513a31-7e47-4239-adfc-74def9cf17ec"},{"index":25213,"token":false,"name":"Akroan Mastiff","scryfallId":"7e21938b-46b1-4b2f-8269-0cd0e998cddc"},{"index":25214,"token":false,"name":"Sandskin","scryfallId":"80b59844-c9d4-4bc1-86e6-4cc596d9165d"},{"index":25217,"token":false,"name":"Xenograft","scryfallId":"f52f08e1-b234-42e4-8f1f-485a4f6edb3b"},{"index":25219,"token":false,"name":"Withering Wisps","scryfallId":"ad1e6ae5-c972-42c0-ae78-f203873aeeb1"},{"index":25221,"token":false,"name":"Mindleecher","scryfallId":"2bf6b21a-8e18-400c-a39c-d693e487e47b"},{"index":25230,"token":false,"name":"Curtain of Light","scryfallId":"fc382831-e338-49bd-a37f-931bf611b165"},{"index":25232,"token":false,"name":"Avarax","scryfallId":"ae76705f-ec95-48b0-9e26-84ce40c9514b"},{"index":25237,"token":false,"name":"Leonin Den-Guard","scryfallId":"c9f30b7a-75bb-44e6-b1a2-726df1b5b1f3"},{"index":25240,"token":false,"name":"Vaporous Djinn","scryfallId":"e7ea65e2-68d8-429f-9be7-e6e5e12a2a4d"},{"index":25241,"token":false,"name":"Retaliation","scryfallId":"7a6e3814-5b9f-40da-8205-263fc49294da"},{"index":25243,"token":false,"name":"Rosemane Centaur","scryfallId":"e516b8f2-8c79-42c9-8e49-8e4f461c7ebe"},{"index":25244,"token":false,"name":"Arlinn Kord // Arlinn, Embraced by the Moon","scryfallId":"ce0a6fa9-f664-4263-8deb-8112f860814c"},{"index":25249,"token":false,"name":"Ghost Council of Orzhova","scryfallId":"d83a5785-a9a9-4a07-82c7-97dc5b9a2475"},{"index":25251,"token":false,"name":"Tempt with Reflections","scryfallId":"ebb0070f-8686-4127-91c3-4f1488e2d995"},{"index":25260,"token":false,"name":"Sunrise Sovereign","scryfallId":"9bface8b-1bdc-4b4b-b0b5-b584731bced8"},{"index":25267,"token":false,"name":"Ancient Spider","scryfallId":"75ca99de-57e7-47c4-b40a-6e41e3b18069"},{"index":25268,"token":false,"name":"Hour of Revelation","scryfallId":"89a89652-95ef-45b4-80c3-02241483f3c0"},{"index":25269,"token":false,"name":"Telemin Performance","scryfallId":"3ac0f1fb-0ada-4b3c-b9bd-654ffc0a167d"},{"index":25271,"token":false,"name":"Structural Distortion","scryfallId":"a7895890-a774-4c7c-9f15-78b8aadfd9ef"},{"index":25272,"token":false,"name":"Hot Soup","scryfallId":"cc46f4b0-1992-4060-8f21-643698d476f7"},{"index":25275,"token":false,"name":"Pursuit of Flight","scryfallId":"37a6290c-a0a8-4032-972b-84a7eef04dae"},{"index":25276,"token":false,"name":"Dystopia","scryfallId":"452c1fe9-1640-4d0e-9f54-7c673b13b091"},{"index":25283,"token":false,"name":"Nimbus Naiad","scryfallId":"19e9c9a2-4c5b-4518-a127-e4ffb23437d6"},{"index":25285,"token":false,"name":"Wander in Death","scryfallId":"7749df63-5983-4712-804a-224be0b6d867"},{"index":25291,"token":false,"name":"Moonlight Hunt","scryfallId":"d9633603-a80f-448d-98d9-00064d379c26"},{"index":25293,"token":false,"name":"Spreading Rot","scryfallId":"3007dd28-655a-47e3-9c01-6db2f5c213a4"},{"index":25295,"token":false,"name":"Heartstabber Mosquito","scryfallId":"b2ce0a6f-4990-41ae-a37d-b89da2b9e4de"},{"index":25297,"token":false,"name":"Territorial Boar","scryfallId":"5e9ddae7-7e7c-46c7-ad7d-9a686c256b9d"},{"index":25301,"token":false,"name":"Sarkhan Unbroken","scryfallId":"192452f8-93c2-4a20-a52b-0093741a9e45"},{"index":25302,"token":false,"name":"Etherium Sculptor","scryfallId":"86e072aa-4234-416d-b83e-cdc4f511a6d9"},{"index":25303,"token":false,"name":"Blisterpod","scryfallId":"e16f1803-634a-41b0-ae21-484d6f914a0d"},{"index":25312,"token":false,"name":"Era of Innovation","scryfallId":"5dae3b1f-6a31-4a8a-9e44-063f8f670134"},{"index":25316,"token":false,"name":"Nimbus Wings","scryfallId":"5dae4042-8806-437c-8fc1-2d6996ff38c6"},{"index":25317,"token":false,"name":"Crag Saurian","scryfallId":"1f0907a5-938e-4ef4-aa85-e7c1ae4317a6"},{"index":25319,"token":false,"name":"Ayli, Eternal Pilgrim","scryfallId":"8815cb28-ed85-4f27-b37f-f1a024facf36"},{"index":25323,"token":false,"name":"Kin-Tree Warden","scryfallId":"dfddafbc-590b-4610-894a-b91335a60528"},{"index":25325,"token":false,"name":"Repentant Blacksmith","scryfallId":"211635a6-ce21-409c-a5f7-7e7e39fbbd99"},{"index":25328,"token":false,"name":"Briarknit Kami","scryfallId":"8c042f8b-df20-48c1-a291-4d7e1bc5b384"},{"index":25331,"token":false,"name":"Shelter","scryfallId":"431360c2-3c7c-4c96-b09b-9caafe211d83"},{"index":25334,"token":false,"name":"Krark-Clan Ironworks","scryfallId":"c60174d6-1f9d-4870-b3db-34d6fcb3f6ab"},{"index":25335,"token":false,"name":"Glory of Warfare","scryfallId":"a6117bf5-4084-45bd-82aa-81cf6d9b7eb4"},{"index":25336,"token":true,"name":"Dragons","scryfallId":"1f0d86f7-e751-4b8e-b828-c879234f29ec"},{"index":25342,"token":false,"name":"Skaab Ruinator","scryfallId":"44c40cdc-a11a-47df-b902-d8fbe9014d03"},{"index":25345,"token":false,"name":"Mogg Raider","scryfallId":"94e9cc0a-c210-4525-8c7f-9c6306cc21b0"},{"index":25347,"token":false,"name":"Defiant Greatmaw","scryfallId":"b74cb0ba-c691-4823-aa94-399b1aaeaf0b"},{"index":25349,"token":false,"name":"Faerie Tauntings","scryfallId":"33727782-dafd-4a7c-96dd-6ffaf667cc6b"},{"index":25354,"token":false,"name":"Zodiac Ox","scryfallId":"1a731b3a-0065-448d-841c-28700d78a4fd"},{"index":25355,"token":false,"name":"Ravenous Squirrel","scryfallId":"505b77d0-8651-4b40-a2e9-6dd00ac3c575"},{"index":25363,"token":false,"name":"Fiery Intervention","scryfallId":"67f36a25-3692-4f2e-a25e-84b90656e6a4"},{"index":25367,"token":false,"name":"Memorial to Folly","scryfallId":"09901edf-44da-42fa-a6bf-d149ba107f73"},{"index":25370,"token":false,"name":"Dismantling Blow","scryfallId":"d0bb986a-a64b-4bb1-a32c-44628d453fc4"},{"index":25373,"token":false,"name":"Ad Nauseam","scryfallId":"0a4ce4a1-65e3-4b40-be35-8fc55a968ec8"},{"index":25377,"token":false,"name":"Burning-Tree Bloodscale","scryfallId":"a9abed9a-cf7f-4aaf-9934-42710f349506"},{"index":25382,"token":false,"name":"Storm World","scryfallId":"cdf0afa6-7003-454d-9b8a-e3328aaf29ed"},{"index":25387,"token":false,"name":"Maalfeld Twins","scryfallId":"fa715fde-8339-447b-8ac8-3126830bece8"},{"index":25389,"token":false,"name":"Necrotic Hex","scryfallId":"009d2fb8-6144-46d9-9085-26232c174109"},{"index":25390,"token":false,"name":"Deepwood Ghoul","scryfallId":"29cd6685-37ca-47c7-8f64-1fb86e9610ca"},{"index":25394,"token":false,"name":"Inundate","scryfallId":"d5047c92-2885-4a7b-b51f-f3e093dca5ad"},{"index":25397,"token":false,"name":"Dross Ripper","scryfallId":"55d54f08-53f0-41b2-8b86-8244515224eb"},{"index":25401,"token":false,"name":"Ironclad Revolutionary","scryfallId":"43a5535b-b1d1-4648-aa72-4f64e9fcd95d"},{"index":25402,"token":false,"name":"Adeliz, the Cinder Wind","scryfallId":"2622a06f-decc-4b8e-911c-ff106051bc36"},{"index":25404,"token":false,"name":"Gearsmith Prodigy","scryfallId":"77d9e666-d9c9-4ccd-89a5-83de79677fa6"},{"index":25408,"token":false,"name":"Angelheart Vial","scryfallId":"4cf1fe7a-eb30-4252-bada-ce3f8096e091"},{"index":25411,"token":false,"name":"Spire Winder","scryfallId":"aca438d7-1134-4fee-9fad-85c3b1abe8ed"},{"index":25412,"token":false,"name":"Predator Dragon","scryfallId":"352c3c86-1662-4055-b814-026826632cff"},{"index":25418,"token":false,"name":"Honden of Cleansing Fire","scryfallId":"93c3a75d-7cae-4199-8e87-915ebb439b62"},{"index":25421,"token":false,"name":"Glass of the Guildpact","scryfallId":"d1022d41-c1d0-42bf-b3e5-d6fb02d47119"},{"index":25423,"token":false,"name":"Hadana's Climb // Winged Temple of Orazca","scryfallId":"8e7554bc-8583-4059-8895-c3845bc27ae3"},{"index":25429,"token":false,"name":"Primal Surge","scryfallId":"4278f7bd-afff-4a1d-a0bb-bf9ce3ad5a2e"},{"index":25431,"token":false,"name":"Feudkiller's Verdict","scryfallId":"f2993319-5b3d-48ca-b78d-563a8b66d76d"},{"index":25432,"token":false,"name":"Expose to Daylight","scryfallId":"094c2ac3-040f-41fe-9a37-c037d90baec0"},{"index":25433,"token":false,"name":"Relic Bind","scryfallId":"f5188c51-f563-4f37-9ca7-cd9f04b61398"},{"index":25438,"token":false,"name":"Act on Impulse","scryfallId":"bfe513d1-2509-4051-ba85-49a19479fa5c"},{"index":25440,"token":false,"name":"Drudge Reavers","scryfallId":"03c07d9a-afed-4028-9fa1-ec439b60f08f"},{"index":25441,"token":false,"name":"Fblthp, the Lost","scryfallId":"f7308076-755c-4508-8920-5a6641a17a8a"},{"index":25442,"token":false,"name":"Kamahl's Desire","scryfallId":"c99e1ded-7440-40a6-846b-7450a9b7d2a8"},{"index":25443,"token":false,"name":"Angel of Invention","scryfallId":"72afe4d6-7160-438e-b6bc-b8edc160f36c"},{"index":25444,"token":false,"name":"Dovin, Grand Arbiter","scryfallId":"e6784910-0204-4a39-bb38-50daa03e94c2"},{"index":25446,"token":false,"name":"Lingering Mirage","scryfallId":"050b4a82-a1d5-4dcc-9264-96005fdf53f5"},{"index":25447,"token":false,"name":"Trusty Packbeast","scryfallId":"0fcfe1b5-e35b-4a23-8ca8-4dee2ef94f32"},{"index":25448,"token":false,"name":"Parallel Thoughts","scryfallId":"d913c541-a8fb-4383-bbab-988be3e0f5d5"},{"index":25450,"token":false,"name":"Villagers of Estwald // Howlpack of Estwald","scryfallId":"e42a0a3d-a987-4b24-b9d4-27380a12e093"},{"index":25451,"token":false,"name":"Boldwyr Heavyweights","scryfallId":"88d90bc4-7f70-4203-b554-800c70c775ef"},{"index":25452,"token":false,"name":"Oath of Teferi","scryfallId":"5a7fadca-0a94-4624-ab95-2c2410829824"},{"index":25454,"token":false,"name":"Planebound Accomplice","scryfallId":"85fb9418-a22b-4f92-b494-f68c29bcb92a"},{"index":25457,"token":false,"name":"Archfiend's Vessel","scryfallId":"83437022-ba00-4370-83c2-ce1260336fcc"},{"index":25462,"token":false,"name":"Etherium Astrolabe","scryfallId":"d60731c6-7a25-4f2b-8ed1-2469a2d300c6"},{"index":25464,"token":false,"name":"Guul Draz Overseer","scryfallId":"793bb4e0-8fdd-440e-9e6e-92a899794cae"},{"index":25465,"token":false,"name":"Starlit Angel","scryfallId":"36691cd0-c709-4452-a61a-d6e2049fdfcf"},{"index":25466,"token":false,"name":"Reflective Golem","scryfallId":"c01770c4-8848-495d-8af4-26152d45e9d3"},{"index":25467,"token":false,"name":"Craven Giant","scryfallId":"ea3cf964-88f6-4e62-97ce-cf0e179a53fb"},{"index":25468,"token":false,"name":"Arrester's Admonition","scryfallId":"637c2d6a-e6b8-4dc5-81aa-da1b7384e006"},{"index":25469,"token":false,"name":"Obuun, Mul Daya Ancestor","scryfallId":"3ae4c174-e57e-4f7b-afd4-48f25e444dda"},{"index":25475,"token":false,"name":"Portcullis","scryfallId":"a4de4af2-fa75-4a87-b0e1-0117727917a5"},{"index":25482,"token":false,"name":"Rhox Brute","scryfallId":"237de286-5bf0-4c8e-8504-2d01d3133b55"},{"index":25494,"token":false,"name":"Blighted Shaman","scryfallId":"1d46c90a-215a-4897-94f8-52a02abf25c4"},{"index":25504,"token":false,"name":"Nylea's Colossus","scryfallId":"5cf50d41-02ce-4a39-b3a0-82ddd7277fca"},{"index":25505,"token":false,"name":"Growth Cycle","scryfallId":"1e619121-f2e8-4da5-8652-a2b5dae2e55c"},{"index":25506,"token":false,"name":"Liliana's Shade","scryfallId":"1cf0c01d-a4a0-43fb-970d-e428e9ac63d7"},{"index":25508,"token":false,"name":"Active Volcano","scryfallId":"ad402e65-6fac-4005-a2d4-592983df0c30"},{"index":25511,"token":false,"name":"Flycatcher Giraffid","scryfallId":"1988e220-d746-46e4-a534-164203e63c14"},{"index":25512,"token":true,"name":"Paul McCabe Bio","scryfallId":"09901fef-3daf-4890-9d8f-466881326cbd"},{"index":25513,"token":false,"name":"Illusory Demon","scryfallId":"f4d69f7f-ac70-477b-9246-8d81fef7d335"},{"index":25516,"token":false,"name":"Jungle Barrier","scryfallId":"afe5c401-1cb7-477a-803e-a4eaf51cf118"},{"index":25518,"token":false,"name":"Qasali Slingers","scryfallId":"de8ce2aa-cb2b-4e5f-98b9-1f3cac5cab1c"},{"index":25533,"token":false,"name":"Halfdane","scryfallId":"2e939761-3542-4044-9038-d1d30c6a38fc"},{"index":25535,"token":false,"name":"Copperline Gorge","scryfallId":"671486a5-4050-430c-8af4-58def77562ec"},{"index":25537,"token":false,"name":"Nezumi Shadow-Watcher","scryfallId":"04bdcdce-68fb-460b-874d-40df7afd99ca"},{"index":25545,"token":false,"name":"Exultant Cultist","scryfallId":"b2c22e0a-81c5-485f-81f0-3e85397108e0"},{"index":25546,"token":false,"name":"Mirror March","scryfallId":"50a27943-f08c-4cbd-affb-8e59411b3d4f"},{"index":25547,"token":false,"name":"Barkhide Mauler","scryfallId":"b9196ce7-3ff4-4dda-a628-559ada11c9ba"},{"index":25551,"token":false,"name":"Nightmarish End","scryfallId":"4bab0e0a-7eb9-4422-a1d4-82cc05b4374d"},{"index":25554,"token":false,"name":"Seal of Strength","scryfallId":"57650f78-3bf0-485a-bba8-7e7e14e47508"},{"index":25555,"token":false,"name":"Curse of Vitality","scryfallId":"30ff281f-c567-44e9-8156-4e803787864d"},{"index":25558,"token":false,"name":"Kami of Fire's Roar","scryfallId":"4380118d-f209-446d-829b-3564796e0219"},{"index":25562,"token":false,"name":"Jeskai Elder","scryfallId":"ea4ff6f3-cc53-4f4a-b884-2e751732f9c8"},{"index":25567,"token":false,"name":"Hystrodon","scryfallId":"1c964473-7c54-4c2d-a3eb-dba01c842103"},{"index":25568,"token":false,"name":"Chromanticore","scryfallId":"8d171b46-69e7-4e39-b3b2-97ed022cd933"},{"index":25569,"token":false,"name":"Clattering Augur","scryfallId":"a22dd28d-eb65-410a-af17-51b5064c6033"},{"index":25570,"token":false,"name":"Entrancing Lyre","scryfallId":"064abee6-7394-4b75-946f-4ad9840034ac"},{"index":25572,"token":false,"name":"Arctic Flats","scryfallId":"609b15f6-e65b-46d6-95e8-dc39f25d7efa"},{"index":25574,"token":false,"name":"Royal Trooper","scryfallId":"d2ef5a76-e91c-4687-8323-7436ced35153"},{"index":25575,"token":false,"name":"Transguild Courier","scryfallId":"449a9db4-f219-4a6a-b9a3-3dd3edec2a16"},{"index":25577,"token":false,"name":"Switcheroo","scryfallId":"9d3d062c-5853-44f9-b951-a264e9e0d72d"},{"index":25578,"token":false,"name":"Hisoka, Minamo Sensei","scryfallId":"a87aea05-5970-455e-a728-668cf23940a6"},{"index":25580,"token":false,"name":"Goblin Lyre","scryfallId":"951114fb-5ae5-4eb0-8e03-6e39b0b634b5"},{"index":25585,"token":false,"name":"Witch Hunter","scryfallId":"4eef9bb7-cd3c-422e-a93b-90d98684675a"},{"index":25587,"token":false,"name":"Impatience","scryfallId":"d39c8166-9e63-4b02-af7b-4caf14ca73ac"},{"index":25588,"token":false,"name":"Bazaar of Wonders","scryfallId":"78e7a165-e135-4b85-943d-8352b6e65870"},{"index":25590,"token":false,"name":"Soul Ransom","scryfallId":"0f187c27-a2ad-4560-ba74-1012046303cc"},{"index":25592,"token":false,"name":"Lupine Prototype","scryfallId":"dd8272ca-8e3d-4980-99f2-352a1db76d74"},{"index":25593,"token":false,"name":"Allay","scryfallId":"f20a1c6d-ec6a-4bd6-b3b2-b997f71d41fc"},{"index":25595,"token":false,"name":"Diamond Faerie","scryfallId":"0072cf13-284b-4fb8-ab2c-b2e15388a30a"},{"index":25598,"token":false,"name":"Goblin Lore","scryfallId":"660e7067-9f1d-4e2c-bd12-0ad752a3cec8"},{"index":25599,"token":false,"name":"Volrath's Gardens","scryfallId":"7d74f7d8-10eb-4082-9b07-41de13359b8c"},{"index":25601,"token":false,"name":"Enigmatic Incarnation","scryfallId":"dd116c0b-0404-42ba-978f-7044b1a03d90"},{"index":25602,"token":false,"name":"Unliving Psychopath","scryfallId":"694bbf39-fd66-4ff4-9cc3-ec75b1fb3a51"},{"index":25603,"token":false,"name":"Orzhov Charm","scryfallId":"8ca44265-5e1b-4fbf-9002-52b2ce9b7448"},{"index":25606,"token":false,"name":"Sanctuary Blade","scryfallId":"c9cf2480-10cd-4200-a47e-cc7f49182692"},{"index":25607,"token":false,"name":"Shriekhorn","scryfallId":"bb41269f-007d-43ba-a682-d3929cc69696"},{"index":25610,"token":false,"name":"Squire","scryfallId":"374df061-ebd2-4f1f-9a6e-7940a49197a9"},{"index":25613,"token":false,"name":"Sandwurm Convergence","scryfallId":"18c3358a-96d2-4b7c-85e8-e641ef86cedc"},{"index":25616,"token":false,"name":"Soul's Attendant","scryfallId":"3223c0ac-cc22-4886-8919-11273b477cc7"},{"index":25617,"token":false,"name":"Silvar, Devourer of the Free","scryfallId":"fc9cbc83-b9e3-4a22-948b-5a71112154c1"},{"index":25618,"token":false,"name":"Sporecap Spider","scryfallId":"7bc33252-145f-45c0-bb70-23183c698f66"},{"index":25619,"token":false,"name":"Child of Gaea","scryfallId":"a836d9bd-a4cb-4676-935c-5fb7b793a42f"},{"index":25625,"token":false,"name":"Boreal Outrider","scryfallId":"455ae615-20d7-4251-828d-72a3345d06f1"},{"index":25630,"token":false,"name":"Evolution Charm","scryfallId":"19c01269-faf0-4c29-bdc4-17f0ba3ee7c8"},{"index":25631,"token":false,"name":"Azor, the Lawbringer","scryfallId":"30dc237e-b28a-4b65-9790-6b434828bf2e"},{"index":25632,"token":true,"name":"Matt Linde Decklist","scryfallId":"72dd6b5f-f95b-48f8-a126-0ade77f0f638"},{"index":25633,"token":false,"name":"Rapacious One","scryfallId":"be25bcb7-2be6-4257-8762-2a26dc8a16ff"},{"index":25636,"token":false,"name":"Tyrranax","scryfallId":"5cb0cc0e-f71f-456f-a6ec-6a70cf838c35"},{"index":25645,"token":false,"name":"Order of the Stars","scryfallId":"41981edd-df29-4ded-85d6-0d1a2a3a7a59"},{"index":25647,"token":false,"name":"Exalted Dragon","scryfallId":"7537bab3-4bac-4b83-9ad3-dfcb4ff19d6d"},{"index":25650,"token":false,"name":"Repeating Barrage","scryfallId":"ba90a2d6-8292-4ff1-91d0-b30ae9775f12"},{"index":25652,"token":false,"name":"Call of the Conclave","scryfallId":"c6df8f4d-a07a-4664-878d-efec8b2affb9"},{"index":25656,"token":false,"name":"Guul Draz Specter","scryfallId":"6f6ee73e-fe6e-4698-b92e-606d5d10e5e0"},{"index":25660,"token":false,"name":"Kraul Stinger","scryfallId":"46b88fe9-2450-47ee-ac1e-bbbccbf5684f"},{"index":25663,"token":false,"name":"Henge Guardian","scryfallId":"f01d6807-8fbd-4593-9582-71d4cd720728"},{"index":25665,"token":false,"name":"Thunder Wall","scryfallId":"4fc5d510-c4f7-4a09-bf86-83c3fa3f8928"},{"index":25671,"token":false,"name":"Rushwood Legate","scryfallId":"827b9c99-87d7-493c-9dc3-0c6aa4a61b49"},{"index":25672,"token":false,"name":"Gyruda, Doom of Depths","scryfallId":"97eb1804-6fd8-4917-af36-87fdfce39d3a"},{"index":25676,"token":false,"name":"Wizened Snitches","scryfallId":"bf35807a-a003-4a99-a883-03b8e097f1b2"},{"index":25678,"token":false,"name":"Legerdemain","scryfallId":"65506830-fa2c-4e3b-9f64-5a569dd28249"},{"index":25679,"token":false,"name":"Morningtide","scryfallId":"a62e17a7-3602-45af-bdb6-fa5f2a9f1155"},{"index":25681,"token":false,"name":"Twinblade Assassins","scryfallId":"5d387b19-a0a7-45c0-b1e9-71ca55fb4adc"},{"index":25683,"token":false,"name":"Falkenrath Marauders","scryfallId":"b9c09887-6d2b-48b4-a483-16b8a45babd0"},{"index":25686,"token":false,"name":"Angelic Protector","scryfallId":"9820b4e0-300f-4dce-9f25-e8f59cdd10e0"},{"index":25690,"token":false,"name":"Squeaking Pie Grubfellows","scryfallId":"81290ae9-9217-482a-ae1a-be1a0ef47b5d"},{"index":25693,"token":false,"name":"Ring of Thune","scryfallId":"fda91fbd-bf5b-46c4-bd96-037b507f3daa"},{"index":25694,"token":false,"name":"Tangled Florahedron // Tangled Vale","scryfallId":"235d1ffc-72aa-40a2-95dc-3f6a8d495061"},{"index":25695,"token":false,"name":"Zhalfirin Void","scryfallId":"5d1851b2-c291-41ac-8985-e72988de1dbe"},{"index":25696,"token":false,"name":"Loch Dragon","scryfallId":"9a99088e-7162-4e65-867f-bca1c7400ce3"},{"index":25701,"token":false,"name":"Breakneck Rider // Neck Breaker","scryfallId":"fe9f85e8-1e4c-4478-8344-71fae357b694"},{"index":25703,"token":false,"name":"Sly Requisitioner","scryfallId":"c2d05324-6d85-40da-a087-b5822bc8f42e"},{"index":25706,"token":false,"name":"Mesmeric Sliver","scryfallId":"b8bf083e-d0ec-4df9-a17a-8a28ad13d594"},{"index":25708,"token":false,"name":"Chorus of the Tides","scryfallId":"6e576f7a-0390-4514-aaed-20406fe6acdf"},{"index":25709,"token":false,"name":"Hixus, Prison Warden","scryfallId":"d0c21a35-4b70-4de4-93ff-c0ccabdc39e0"},{"index":25711,"token":false,"name":"Shivan Wurm","scryfallId":"f03b5c7e-e830-4cfc-a43a-3e8285979aa0"},{"index":25712,"token":false,"name":"Pennon Blade","scryfallId":"afc89a7c-cdb9-45cd-a9e7-d66dd2066d1d"},{"index":25718,"token":false,"name":"Sacred Boon","scryfallId":"f8086253-5a66-4161-bdef-f460851368ed"},{"index":25719,"token":false,"name":"Finale of Promise","scryfallId":"811b2dda-e1b7-4a46-83cc-5cdc17554836"},{"index":25720,"token":false,"name":"Watcher of the Roost","scryfallId":"93182a46-1b5b-4545-94bf-ec375f3a33a3"},{"index":25721,"token":false,"name":"Key to the City","scryfallId":"0dd7b24e-052f-41c7-9858-0be6c1b6ec5b"},{"index":25722,"token":false,"name":"Yixlid Jailer","scryfallId":"ff6ba6a5-942d-44ff-87a9-3febf0b7e39b"},{"index":25727,"token":false,"name":"Lotleth Giant","scryfallId":"b1dc38b7-52f7-4394-b095-5442429ab291"},{"index":25728,"token":false,"name":"Tolarian Entrancer","scryfallId":"c29dd04a-b3aa-48b6-beef-3314344b84a6"},{"index":25730,"token":false,"name":"Diligent Excavator","scryfallId":"65212970-770e-4110-aa86-c89128688867"},{"index":25731,"token":false,"name":"Obstinate Familiar","scryfallId":"88468a76-1f64-4189-bbb8-7c333181d57c"},{"index":25733,"token":false,"name":"Thundering Rebuke","scryfallId":"dc671707-4708-44d8-8ec8-d5332599adf9"},{"index":25734,"token":false,"name":"Zodiac Rooster","scryfallId":"205bb3d6-3629-4106-8337-d6c142e356c9"},{"index":25737,"token":false,"name":"Uphill Battle","scryfallId":"73fa3455-3ba0-41ad-aefd-40f183aed2a6"},{"index":25739,"token":false,"name":"Watchers of the Dead","scryfallId":"8db41268-9223-4dd9-91b8-7a63f75884e9"},{"index":25744,"token":false,"name":"Bloodpyre Elemental","scryfallId":"89e39677-5e04-45af-8f4c-1d4b6e737213"},{"index":25745,"token":false,"name":"Prossh, Skyraider of Kher","scryfallId":"e6d5e182-1c99-475e-9468-5ed2fb4bfd71"},{"index":25746,"token":false,"name":"Simic Manipulator","scryfallId":"e3dff9e6-5e0c-4e5b-8184-f0ae9cf347b3"},{"index":25747,"token":false,"name":"Gempalm Polluter","scryfallId":"37393701-03ac-4cfc-b85c-1e7d65a5160f"},{"index":25748,"token":false,"name":"Inner Struggle","scryfallId":"b43be50a-8624-46f6-860a-39ffbfbdaa6a"},{"index":25750,"token":false,"name":"Gaze of the Gorgon","scryfallId":"16c9e772-5213-4c28-9b6c-1cfa6675ee8f"},{"index":25755,"token":true,"name":"Treefolk Token (G, */*)","scryfallId":"21d86b5f-4c85-443a-8d56-d0922112c116"},{"index":25757,"token":false,"name":"Mangara's Equity","scryfallId":"6d796153-3f7f-4d94-8ad4-5a4b2c8e09bb"},{"index":25759,"token":false,"name":"Force of Virtue","scryfallId":"9736d6f4-5ff6-4006-b45d-8e630382d160"},{"index":25764,"token":false,"name":"Kessig Wolf Run","scryfallId":"b1140b05-49cf-49d5-a9a6-dfb2f0d1ec55"},{"index":25771,"token":false,"name":"Unerring Sling","scryfallId":"ecf946b8-8574-406a-83fd-966ed912921f"},{"index":25772,"token":false,"name":"Kird Ape","scryfallId":"27423c7b-d1fd-471b-9648-8ea5ed9ebaf2"},{"index":25774,"token":false,"name":"Trading Post","scryfallId":"1ae64bb3-115a-4c68-99c9-a45b6f788b80"},{"index":25776,"token":false,"name":"Banishment Decree","scryfallId":"2c5f605c-9d16-493e-bc44-0e15bdf8c0bf"},{"index":25777,"token":false,"name":"Cathedral Membrane","scryfallId":"07592731-68be-4218-bb2c-c2523c5a27f1"},{"index":25778,"token":false,"name":"Fire Servant","scryfallId":"0a5c7bb2-37ef-4f99-a447-0c6e4d18fd5c"},{"index":25780,"token":false,"name":"Piracy Charm","scryfallId":"9cb19ac2-edf9-4f9a-b9ba-2a33ba96a4d8"},{"index":25782,"token":false,"name":"Journey of Discovery","scryfallId":"a3f4356f-8cfb-43ed-bdf9-6191bb563388"},{"index":25785,"token":false,"name":"Suspend","scryfallId":"f2b39f1d-6d8b-4d5d-a956-094de5c26ba8"},{"index":25787,"token":false,"name":"Open the Vaults","scryfallId":"ffb29703-96de-475a-9499-b3cd2a2d6566"},{"index":25793,"token":false,"name":"Kodama's Might","scryfallId":"d0ef91bb-ec25-463f-9fc9-f0f9c0652cf5"},{"index":25798,"token":false,"name":"Deathforge Shaman","scryfallId":"1122983b-94c7-4edc-af75-deecf9bdc067"},{"index":25801,"token":false,"name":"Spellbound Dragon","scryfallId":"551518b7-1b71-4fa6-8828-5ae08eab1887"},{"index":25802,"token":false,"name":"Soothing Balm","scryfallId":"96b8f4be-9f4d-4373-8141-a03518ecd38a"},{"index":25803,"token":false,"name":"Rage Weaver","scryfallId":"57cec628-5f6a-4b42-9044-3f9a80cac3e6"},{"index":25805,"token":false,"name":"Squire's Devotion","scryfallId":"91de07da-564d-42f3-987d-a2321c3216bc"},{"index":25806,"token":false,"name":"Mask of Law and Grace","scryfallId":"6bd97150-b405-4bb5-b5a8-fceda4a45ebb"},{"index":25807,"token":false,"name":"Duskworker","scryfallId":"7d18dd3b-980b-4833-93fd-79dc3a260da4"},{"index":25808,"token":false,"name":"Monkey Cage","scryfallId":"07f6be53-7a20-4e6b-a6ce-11cba06af8cb"},{"index":25811,"token":false,"name":"Mudslide","scryfallId":"65acce56-8674-471e-9d5e-91b7e3f672c1"},{"index":25816,"token":false,"name":"Smell Fear","scryfallId":"956a2a42-6a91-45b5-99f1-87c2cf1dd608"},{"index":25817,"token":false,"name":"Unyaro Griffin","scryfallId":"d6db3573-2cc5-47ca-b65f-080aab7fdddc"},{"index":25819,"token":false,"name":"Aven Flock","scryfallId":"29866d0b-f9be-4284-9d21-03598ef6ae4f"},{"index":25820,"token":false,"name":"Magister Sphinx","scryfallId":"cd2abff9-6927-42cc-8cf1-a0876d3a45d7"},{"index":25821,"token":false,"name":"Smashing Success","scryfallId":"c22c7383-ba4d-4b3c-91d6-2d6528e19825"},{"index":25824,"token":false,"name":"Aven Envoy","scryfallId":"40ead30e-9f96-4fca-b619-fdc8d1b5e2e0"},{"index":25827,"token":false,"name":"Tangletrap","scryfallId":"80fbf729-00c0-4237-8294-c857f96364d3"},{"index":25829,"token":false,"name":"Dauthi Cutthroat","scryfallId":"127b8994-fff8-4500-8ab4-244eeb3ed110"},{"index":25833,"token":false,"name":"Obliterate","scryfallId":"cdabde40-2143-4677-b7b4-ea8fbf9b1f25"},{"index":25835,"token":false,"name":"Brand","scryfallId":"bafbd034-c8a0-4798-a680-555c13bdd251"},{"index":25838,"token":false,"name":"Retaliate","scryfallId":"58acdda6-6754-46f2-ad68-f1580b8ab0dd"},{"index":25840,"token":false,"name":"Pieces of the Puzzle","scryfallId":"69204c83-2e43-4ca1-a4cd-d75399a7d6dd"},{"index":25853,"token":false,"name":"The Haunt of Hightower","scryfallId":"61a908e8-6952-46c0-94ec-3962b7a4caef"},{"index":25863,"token":false,"name":"Slobad, Goblin Tinkerer","scryfallId":"df14aa0e-6d34-48ca-aee0-3563bbfb3b15"},{"index":25865,"token":false,"name":"Steal Enchantment","scryfallId":"734be7fa-0998-4771-9b97-4989b3fc1471"},{"index":25866,"token":false,"name":"Puppet's Verdict","scryfallId":"052b743a-456d-49c3-881e-4f30c7645fa5"},{"index":25867,"token":false,"name":"Akki Avalanchers","scryfallId":"bfef6acb-a11c-4a3f-9cfb-9394dece2675"},{"index":25869,"token":false,"name":"Mana Skimmer","scryfallId":"8a39ed44-bc0c-40e2-ba53-cd586c2d5877"},{"index":25877,"token":false,"name":"Peace Talks","scryfallId":"d4200017-5b26-40fe-9a0d-2872aa3b017e"},{"index":25878,"token":false,"name":"Charge Across the Araba","scryfallId":"fe3e0bd8-d80f-4cda-b381-ed185072d83c"},{"index":25883,"token":false,"name":"Illusions of Grandeur","scryfallId":"44c20ed5-7064-436d-ad76-85a1d6bf0103"},{"index":25884,"token":false,"name":"Benthic Giant","scryfallId":"1ff8671d-4da4-4dc2-a8c4-d695ff1aca0f"},{"index":25885,"token":false,"name":"Glacial Revelation","scryfallId":"f615a5e9-deec-46cc-9444-de81cb0da9c0"},{"index":25886,"token":false,"name":"Sonic Burst","scryfallId":"42eeded8-163f-4a85-8bed-4343df43adee"},{"index":25893,"token":false,"name":"Atla Palani, Nest Tender","scryfallId":"f6aa473b-85cd-431d-844b-218368fe955e"},{"index":25894,"token":false,"name":"Corpse Hauler","scryfallId":"11f7bdf8-505e-4ed2-8a3b-aba263afd196"},{"index":25895,"token":false,"name":"Grizzled Outcasts // Krallenhorde Wantons","scryfallId":"4b43b0cb-a5a3-47b4-9b6b-9d2638222bb6"},{"index":25897,"token":false,"name":"Voyage's End","scryfallId":"c55c60dc-40ed-4a36-9daa-702f79ffe818"},{"index":25910,"token":false,"name":"Soulmender","scryfallId":"31b83ffd-bd08-48c6-98a3-811abc203f60"},{"index":25915,"token":false,"name":"Dire Fleet Interloper","scryfallId":"e2e3f7ee-98d0-45bd-97ae-3dc8050085a1"},{"index":25918,"token":false,"name":"Vigor Mortis","scryfallId":"a63f0a70-5a80-4a30-943f-5224ab3f531b"},{"index":25919,"token":false,"name":"Animating Faerie // Bring to Life","scryfallId":"e0355992-8c21-4646-9fbb-f13a1be6153e"},{"index":25922,"token":false,"name":"Mind Knives","scryfallId":"d17e23a6-6313-416d-b826-5df5833371dc"},{"index":25923,"token":false,"name":"Living Tsunami","scryfallId":"107a4e2b-e463-46f3-a431-66ea954ef487"},{"index":25928,"token":false,"name":"Waking the Trolls","scryfallId":"8fe7367c-d5fe-404a-9e21-ff61c22bf5fc"},{"index":25930,"token":false,"name":"Vanishing","scryfallId":"8d1fb805-1382-458c-b98d-4491f13833b6"},{"index":25932,"token":false,"name":"Sprite Dragon","scryfallId":"7172db88-2208-47c4-8226-bc094fd04a9b"},{"index":25934,"token":false,"name":"Hardened Berserker","scryfallId":"e6dbda48-1216-4cbf-8360-46196c5f4ff5"},{"index":25938,"token":false,"name":"Saruli Gatekeepers","scryfallId":"471a5b1d-e2e5-4d90-b72a-ffae81ad6602"},{"index":25940,"token":false,"name":"Necrotic Wound","scryfallId":"9ab636af-5b30-4138-8e68-81f567f10417"},{"index":25942,"token":false,"name":"Cave of Temptation","scryfallId":"d86e9149-6fd9-44fc-b765-3e646c7d83d6"},{"index":25945,"token":false,"name":"Goblin Burrows","scryfallId":"232bcc20-bb2f-4e45-89f4-6c797f1bea3b"},{"index":25947,"token":false,"name":"Emerald Medallion","scryfallId":"67e87f30-b27a-48e2-a133-192309dd5902"},{"index":25950,"token":false,"name":"Saber Ants","scryfallId":"58f0a2f9-5c5e-4477-ae7e-a52cf5778962"},{"index":25952,"token":false,"name":"Farbog Explorer","scryfallId":"489c6a2f-38b4-4ff9-95f7-431384480ed9"},{"index":25953,"token":false,"name":"Nether Traitor","scryfallId":"8f3482ec-8466-4680-bfdc-e1029c0fbe89"},{"index":25954,"token":false,"name":"Clockwork Dragon","scryfallId":"ca6448da-b513-4bea-95f4-47bdfa0df078"},{"index":25956,"token":false,"name":"Kukemssa Serpent","scryfallId":"9099eacf-1898-493c-ae87-d5ff4a3646a2"},{"index":25962,"token":false,"name":"Imaginary Threats","scryfallId":"50c3a6a5-9a50-4a38-9f5f-b8caa320909d"},{"index":25966,"token":false,"name":"Witness the End","scryfallId":"0c06d8ec-55ab-4be9-a470-77c79d643d1f"},{"index":25969,"token":false,"name":"Skyshroud Falcon","scryfallId":"afb86621-1a6e-4d56-ab0e-531105775c56"},{"index":25971,"token":false,"name":"Anowon, the Ruin Thief","scryfallId":"fed9d62b-e1af-4cad-9708-35a95c469c45"},{"index":25980,"token":false,"name":"Flesh-Eater Imp","scryfallId":"c9b1925a-d0d5-4ee6-bf80-734237a9dd31"},{"index":25983,"token":false,"name":"Cephalid Looter","scryfallId":"cb6f1c4e-4fbc-4474-8dd2-5846d417b6ab"},{"index":25985,"token":false,"name":"Esper Cormorants","scryfallId":"2c5068ed-8477-4d8d-9e37-c72474208e2d"},{"index":25987,"token":false,"name":"Slate of Ancestry","scryfallId":"c64a4da1-477d-4452-92f4-0ec2b1fea22d"},{"index":25988,"token":false,"name":"Manta Riders","scryfallId":"ec6f7657-0b39-4c2d-8a0e-9fda96abb639"},{"index":25989,"token":false,"name":"Root Greevil","scryfallId":"306e3429-b3b4-4186-935b-18cfc308d22c"},{"index":25997,"token":false,"name":"Talruum Piper","scryfallId":"ca2cb9a7-5063-4b31-9782-8bfd784bca0a"},{"index":25999,"token":false,"name":"Vex","scryfallId":"e28a9f15-5469-4dc2-8a73-646f854fec7e"},{"index":26001,"token":false,"name":"Seton's Scout","scryfallId":"732bf7bb-5326-4742-8311-96ddbfe14b38"},{"index":26004,"token":false,"name":"Undersea Invader","scryfallId":"550c745b-64e8-4d20-9cf0-024248ddbd57"},{"index":26014,"token":false,"name":"Throne of Empires","scryfallId":"87352716-4cf6-4b2f-bb0a-b7aafae64478"},{"index":26015,"token":false,"name":"Esika's Chariot","scryfallId":"a87606cc-fbf0-4e2c-9798-f1c935d0573d"},{"index":26022,"token":false,"name":"Roterothopter","scryfallId":"87504dd5-3f2f-411a-b966-c523b0ea1f9c"},{"index":26024,"token":false,"name":"Talas Air Ship","scryfallId":"80bc3159-f585-45cd-8578-f3bf2fa9b2d1"},{"index":26030,"token":false,"name":"Three Tragedies","scryfallId":"42acaa44-15d5-4760-9aa8-b44eda9ed98a"},{"index":26032,"token":false,"name":"Sage-Eye Avengers","scryfallId":"8050bb72-4fd4-4acd-ab21-e83f8503dcc1"},{"index":26034,"token":false,"name":"Goblin Trashmaster","scryfallId":"9cd13e25-b2d1-4f90-8540-6e38e168f0f9"},{"index":26037,"token":false,"name":"Crescendo of War","scryfallId":"ab4e8458-58b1-4218-9923-7f1aa393ff7d"},{"index":26040,"token":false,"name":"Fire Snake","scryfallId":"d4c36e32-59e8-4e3d-903e-a264211f2a82"},{"index":26042,"token":false,"name":"Cenn's Heir","scryfallId":"a7610d2f-e35f-42fa-a3fb-fcae54bf5a1d"},{"index":26045,"token":false,"name":"Teshar, Ancestor's Apostle","scryfallId":"19d10bdc-197d-44fd-83ca-5726465c912d"},{"index":26047,"token":false,"name":"Nyx Infusion","scryfallId":"1910d072-1660-4918-a338-d9f87926541d"},{"index":26052,"token":false,"name":"Greater Forgeling","scryfallId":"eef8ad11-4ffa-4878-9354-737be6f9e90c"},{"index":26054,"token":true,"name":"Demon Token (B, 6/6)","scryfallId":"73b858b5-803b-4bcf-99d6-8c20c8b37f07"},{"index":26056,"token":false,"name":"Starnheim Courser","scryfallId":"5c5373dd-4aec-4e93-97fb-a639aa096764"},{"index":26057,"token":false,"name":"Scabland","scryfallId":"68142d89-58c3-4142-bffe-449c92329965"},{"index":26058,"token":false,"name":"Electrostatic Bolt","scryfallId":"c455c8d4-6f20-4dcb-8e82-c2bb70d6bc3e"},{"index":26060,"token":false,"name":"Reliquary Monk","scryfallId":"243e9386-2a7f-406a-9ed3-77d4bf1b50fd"},{"index":26065,"token":false,"name":"Ghoulflesh","scryfallId":"2eed3d1b-3142-437c-99e9-85ba76e23e6d"},{"index":26068,"token":false,"name":"Mantle of Leadership","scryfallId":"9ef5d122-cf18-42c3-be24-cfd92bd18be9"},{"index":26074,"token":false,"name":"Dream Fracture","scryfallId":"4cfd71ff-d899-4f5b-b7df-ec47e2840be9"},{"index":26075,"token":false,"name":"Nightscape Master","scryfallId":"d86174b8-dd9e-4ece-bc23-4f9ac50bccd3"},{"index":26079,"token":false,"name":"The Bears of Littjara","scryfallId":"be43a643-6cb7-4bb6-a28d-8ad30b7fbb6d"},{"index":26081,"token":false,"name":"Bannerhide Krushok","scryfallId":"1271251b-7d79-4cb4-80bb-98574aa63249"},{"index":26084,"token":false,"name":"Invigorating Falls","scryfallId":"ec74e797-390e-4ebd-a53b-098ef3edd7d1"},{"index":26090,"token":false,"name":"Cabal Therapy","scryfallId":"186a6db2-caf7-4e29-a3e3-6ba93402cd33"},{"index":26091,"token":false,"name":"Boom // Bust","scryfallId":"7ce986a4-5f82-4e7e-bef5-b49f05bf96a6"},{"index":26099,"token":false,"name":"Harmless Assault","scryfallId":"a77fef2c-227e-474e-896e-c0ebe227f494"},{"index":26106,"token":false,"name":"Angel of Salvation","scryfallId":"1dbe2835-62fe-4a9a-aea4-04983377a4b9"},{"index":26110,"token":false,"name":"Coral Eel","scryfallId":"bfe7084d-dab9-47ee-9813-9f79cc2c5c4c"},{"index":26111,"token":false,"name":"Hope and Glory","scryfallId":"7cc6478f-4ae5-4f26-baa9-b28e992f962e"},{"index":26118,"token":false,"name":"Tasigur, the Golden Fang","scryfallId":"095b6fd9-d0e5-4026-895a-851a462cbf90"},{"index":26119,"token":false,"name":"Dark Bargain","scryfallId":"6ef6f861-90ef-4e1d-9f17-1dd306e7d0af"},{"index":26120,"token":false,"name":"Mirror Wall","scryfallId":"d0e52b73-ebdf-4339-8780-84327a59ca57"},{"index":26122,"token":false,"name":"Holdout Settlement","scryfallId":"cf08c317-6f2d-47e3-ab5b-8af73fd3e404"},{"index":26124,"token":false,"name":"Guardian Seraph","scryfallId":"a84613ce-9b59-4ef6-8c76-5b208ff9de88"},{"index":26127,"token":false,"name":"Notion Thief","scryfallId":"be530d89-6735-4bd3-9369-22432fe6affb"},{"index":26128,"token":false,"name":"Skymarcher Aspirant","scryfallId":"9473190f-5e96-4cf7-a0fa-a77d916acc2e"},{"index":26132,"token":false,"name":"Sanctum of Tranquil Light","scryfallId":"34a5478a-1a2c-4117-b543-da083ed2b562"},{"index":26133,"token":false,"name":"Sootstoke Kindler","scryfallId":"4b2260b4-c069-4f59-9bd9-35745c98c518"},{"index":26143,"token":false,"name":"Hostile Minotaur","scryfallId":"ad6d0a11-3a9c-4de0-9a46-06d2b9356eb7"},{"index":26146,"token":false,"name":"Crush of Tentacles","scryfallId":"3989530c-1557-4ed8-9107-8ffe3680cb24"},{"index":26149,"token":false,"name":"Herald of the Pantheon","scryfallId":"ffeca7a7-2a14-4166-9e89-0f4eb94b79f5"},{"index":26157,"token":false,"name":"Spider Spawning","scryfallId":"b727615a-1d3c-4c93-8362-708241486938"},{"index":26158,"token":false,"name":"Syr Alin, the Lion's Claw","scryfallId":"4cddb2d2-d813-4b83-a592-380ba4edf54f"},{"index":26159,"token":false,"name":"Phyrexian Prowler","scryfallId":"e26f79b5-780a-4cbb-b49d-01673a411d1f"},{"index":26161,"token":false,"name":"Heartfire","scryfallId":"af482a14-a144-4e60-bd04-a548a3c89f5a"},{"index":26162,"token":false,"name":"Goblin Ski Patrol","scryfallId":"6827594e-3912-44f2-bd84-bf7ef69276de"},{"index":26165,"token":false,"name":"Wall of Tanglecord","scryfallId":"792e2aed-ce6e-4fa1-a31c-a4574e5cf1f5"},{"index":26167,"token":false,"name":"Hikari, Twilight Guardian","scryfallId":"e2dc7ba1-6194-45ba-97c5-ad14331cc3a6"},{"index":26171,"token":false,"name":"Murderous Compulsion","scryfallId":"33b94db1-ac8c-4667-81d5-408df0f30879"},{"index":26174,"token":false,"name":"Clutch of Undeath","scryfallId":"7301fdec-ca17-47ae-9a0a-84ea8665ece1"},{"index":26176,"token":false,"name":"Eviscerate","scryfallId":"62ba90b8-3a30-4058-b8d3-72900b1f4fe0"},{"index":26177,"token":false,"name":"Skull of Orm","scryfallId":"aa1d9bb5-972a-4705-bf22-0fa1e974dd26"},{"index":26178,"token":false,"name":"Gingerbread Cabin","scryfallId":"b11f5296-5f7d-41ca-a67d-e976273d7386"},{"index":26184,"token":false,"name":"Polymorphous Rush","scryfallId":"2ff5f703-339f-430c-b342-77bcc2c63222"},{"index":26185,"token":false,"name":"Tolarian Winds","scryfallId":"5c29399d-0a59-4dcb-9bd4-f31eea3f39f9"},{"index":26187,"token":false,"name":"Forge Armor","scryfallId":"2873b6d5-af76-498c-bc2d-a26c36be3cbd"},{"index":26189,"token":false,"name":"Delaying Shield","scryfallId":"14e8195a-d0e4-4b11-b413-765ed1cae834"},{"index":26190,"token":false,"name":"Final Fortune","scryfallId":"83589c25-58a2-4172-8f60-6033a61f34c6"},{"index":26194,"token":false,"name":"Nessian Wanderer","scryfallId":"50d50576-c3ee-479a-8533-6c147f5cb1c4"},{"index":26196,"token":false,"name":"Atogatog","scryfallId":"4a3e6eb5-6d0f-4f82-86f9-bbce8d27afbb"},{"index":26197,"token":false,"name":"Devastating Summons","scryfallId":"15b09784-8e89-4013-975d-57e4d26cc926"},{"index":26198,"token":false,"name":"Crown of Fury","scryfallId":"6caae974-f531-469d-8c6a-2077c4f3294a"},{"index":26199,"token":false,"name":"Lord of Extinction","scryfallId":"c1a7890c-4b93-4181-900f-d95aeb6a8db3"},{"index":26203,"token":false,"name":"Redwood Treefolk","scryfallId":"e9399667-ae2a-4b64-84dd-8f97f3e5fe79"},{"index":26213,"token":false,"name":"Second Thoughts","scryfallId":"b09586de-4853-4e51-a4ac-70eabb37eef4"},{"index":26217,"token":false,"name":"Wild Mammoth","scryfallId":"4d927fdb-11c0-42b6-95d4-7af051e45213"},{"index":26218,"token":false,"name":"Goblin Taskmaster","scryfallId":"a8701316-b247-4fff-a7ac-e6ce6701aee3"},{"index":26220,"token":false,"name":"Envelop","scryfallId":"e7ed250e-12d0-4ebc-9410-5711e71c6d1f"},{"index":26221,"token":false,"name":"Barbarian Horde","scryfallId":"d1f930c2-e828-4566-b2df-3b054f311be5"},{"index":26222,"token":false,"name":"Caress of Phyrexia","scryfallId":"5ef987ad-a3dc-4ef5-90ec-9a8cfa95965b"},{"index":26224,"token":false,"name":"Canyon Lurkers","scryfallId":"ef6c56d1-6eca-43be-9834-0478bea67b48"},{"index":26225,"token":false,"name":"Friendly Fire","scryfallId":"ac4272ca-bb15-415c-a589-a472953a0dd9"},{"index":26228,"token":false,"name":"Pathway Arrows","scryfallId":"15b98611-a6f7-498c-87e3-893a3f4b4f73"},{"index":26231,"token":false,"name":"Sagu Mauler","scryfallId":"4c64af58-963d-497b-ab95-104839d96b94"},{"index":26234,"token":false,"name":"Morbid Hunger","scryfallId":"47a4e7d0-ff09-4e19-8456-f4845f56dc8b"},{"index":26236,"token":false,"name":"Fiddlehead Kami","scryfallId":"db328ac4-1b7d-4310-9798-8c8dc8740062"},{"index":26237,"token":false,"name":"Consuming Sinkhole","scryfallId":"82a42b28-3d1b-4432-b8c9-2d42e4d0e1c5"},{"index":26238,"token":false,"name":"Sulfuric Vortex","scryfallId":"79955e27-eef7-43bd-9895-e9209ed1537f"},{"index":26239,"token":false,"name":"Fencer Clique","scryfallId":"77c0929f-bee6-416d-8571-6540ae4f6e4f"},{"index":26243,"token":false,"name":"Shieldmage Advocate","scryfallId":"2ea66a41-cb2e-49d6-81fe-3f69b0dfd40e"},{"index":26249,"token":false,"name":"Undead Augur","scryfallId":"b358328b-53f2-45ba-a5f2-d0a666241d53"},{"index":26252,"token":false,"name":"Eat to Extinction","scryfallId":"a0fae55a-6edd-42ea-b909-ccc39a64a0ed"},{"index":26253,"token":false,"name":"Maddening Imp","scryfallId":"dda08eb5-c75c-4c21-bfd1-1f04a3575241"},{"index":26254,"token":true,"name":"Milling","scryfallId":"df6b34ca-747b-451c-beb4-3dfef9743933"},{"index":26258,"token":false,"name":"Forsaken Sanctuary","scryfallId":"f3e0b983-62e7-43fb-b5d5-402ea60a64d7"},{"index":26260,"token":false,"name":"Roiling Horror","scryfallId":"f83006a5-c42b-4083-a246-f46b25412150"},{"index":26261,"token":false,"name":"Kemuri-Onna","scryfallId":"4eed13fd-68be-4bc3-af6a-d88baaf9c98d"},{"index":26268,"token":false,"name":"Vampire Lacerator","scryfallId":"4403436b-2605-495b-ab08-9a2001cc7f8b"},{"index":26271,"token":false,"name":"Dralnu, Lich Lord","scryfallId":"b3828efe-cbe1-473c-8dde-60ea9aaf23a2"},{"index":26273,"token":false,"name":"Mystic Might","scryfallId":"e35d7f08-0687-41bd-8c53-31a49adabb11"},{"index":26277,"token":false,"name":"Tilonalli's Skinshifter","scryfallId":"f0e6ca8a-4e8a-4be4-bcc7-0a4cb1196aac"},{"index":26281,"token":false,"name":"Shinen of Fear's Chill","scryfallId":"762499b4-4b4f-456e-8a03-2de300b2db5e"},{"index":26283,"token":false,"name":"Reweave","scryfallId":"4ff68016-80b4-4801-b796-5c5fdbc8faa1"},{"index":26290,"token":false,"name":"Lavaclaw Reaches","scryfallId":"7c9fb3d9-e018-4aa3-9c14-1a51fae176b4"},{"index":26291,"token":false,"name":"Sleep of the Dead","scryfallId":"4007572b-a6c8-4a56-b1a7-ff099189c9c0"},{"index":26292,"token":false,"name":"Insatiable Hemophage","scryfallId":"ada6588b-3efc-4464-ae83-11586eb54775"},{"index":26295,"token":false,"name":"Dead-Iron Sledge","scryfallId":"1dc312c0-14da-4b23-8293-6fa41bdd3167"},{"index":26296,"token":false,"name":"Burnt Offering","scryfallId":"1dae52a2-3af7-4b97-9d2e-2448b7c413fb"},{"index":26299,"token":false,"name":"Windwright Mage","scryfallId":"9aba0e7d-9146-402f-898e-16a0ff08d368"},{"index":26302,"token":false,"name":"Fan Bearer","scryfallId":"f6cec477-f86f-4ccf-aa57-b6b7ade46eed"},{"index":26307,"token":false,"name":"Viridian Betrayers","scryfallId":"cc6ea52f-4b24-45ff-99e1-4d0e1bd42875"},{"index":26308,"token":false,"name":"Hammer of Ruin","scryfallId":"308c6bc5-701d-4ae8-bb52-c2e2c6956946"},{"index":26309,"token":false,"name":"Branching Evolution","scryfallId":"4a6971ad-cbb4-4f66-9bc4-b407c5805e85"},{"index":26312,"token":false,"name":"Corpse Dance","scryfallId":"de839585-564e-4d5c-9782-8ca6b021fc7b"},{"index":26314,"token":false,"name":"Dwarven Blastminer","scryfallId":"2970831a-738b-476f-9d46-39f10a1f91e7"},{"index":26317,"token":false,"name":"Possessed Centaur","scryfallId":"608e11b2-9636-48a0-8705-f5ce3bc98117"},{"index":26319,"token":false,"name":"Zagoth Crystal","scryfallId":"9138a442-8e8b-465f-bb76-b6af7e6dab6f"},{"index":26322,"token":false,"name":"Scorn Effigy","scryfallId":"4fa13084-3e68-49f4-8cc9-6d02286fd150"},{"index":26324,"token":false,"name":"Dwarven Song","scryfallId":"29a50f72-9524-4440-9380-9d3e0b693351"},{"index":26325,"token":false,"name":"Krosan Drover","scryfallId":"e92a7141-119f-4bf8-a82d-eb7c0c37185c"},{"index":26328,"token":false,"name":"Torch Slinger","scryfallId":"229dec8c-ec73-4bab-8c37-517cb4a01988"},{"index":26330,"token":false,"name":"Soul Bleed","scryfallId":"54800a5a-33fe-4291-a7b4-a1eb256dfa8f"},{"index":26331,"token":false,"name":"Rocky Tar Pit","scryfallId":"39ca4803-ac8f-4288-a47e-9da62cb16827"},{"index":26337,"token":false,"name":"Aethersphere Harvester","scryfallId":"0ef0434b-e4c7-4d3f-9a6e-83863a89a6c3"},{"index":26342,"token":false,"name":"Fires of Undeath","scryfallId":"6d94aaa4-c2fd-4714-9198-8415158b9c4d"},{"index":26347,"token":false,"name":"Raging Cougar","scryfallId":"fd9d126a-9db9-4adc-9cf6-11408c63201d"},{"index":26349,"token":false,"name":"Shreds of Sanity","scryfallId":"782e5600-ac63-4f90-acbe-49c04d2840ee"},{"index":26350,"token":false,"name":"Spinal Parasite","scryfallId":"1aefaec4-741b-4a90-bf2c-e18215aac57c"},{"index":26353,"token":false,"name":"False Demise","scryfallId":"48872422-895f-45f0-ba2a-7cd307285c7d"},{"index":26356,"token":false,"name":"Omen of the Hunt","scryfallId":"7d4ebdea-78d4-4034-921b-735bdb11a716"},{"index":26357,"token":false,"name":"Ignition Team","scryfallId":"9dc89eb3-4497-4f05-8fed-d378b6e425ca"},{"index":26358,"token":false,"name":"Adriana, Captain of the Guard","scryfallId":"e7e1443c-2790-40a0-b5fc-c3b1b710f650"},{"index":26360,"token":false,"name":"Rhox Maulers","scryfallId":"f91e25c0-8f10-4829-86d1-f6df105b46bd"},{"index":26363,"token":false,"name":"Nightshade Seer","scryfallId":"e2262467-1354-4aec-84a2-21916c44b9ef"},{"index":26365,"token":false,"name":"Aven Reedstalker","scryfallId":"f0c2d70a-d646-44eb-9f65-ddf6e329ab43"},{"index":26366,"token":false,"name":"Notorious Assassin","scryfallId":"239e48d8-e2ba-4e25-88ef-301420c796b4"},{"index":26369,"token":false,"name":"Earth Surge","scryfallId":"325503ee-ea62-459b-a58a-53fb3c1ef027"},{"index":26372,"token":false,"name":"Conflagrate","scryfallId":"b782ffb4-3c9d-4d5c-a927-8988166c2d94"},{"index":26373,"token":false,"name":"Oviya Pashiri, Sage Lifecrafter","scryfallId":"e1c2b1b4-6439-4203-967d-c8a40a2e701e"},{"index":26375,"token":false,"name":"Prickly Marmoset","scryfallId":"bad8512f-31b9-48ba-bb10-1497303dcfba"},{"index":26376,"token":false,"name":"Skittering Horror","scryfallId":"6ef0eab9-37e7-4d6b-82e8-15e9b5575d1b"},{"index":26378,"token":false,"name":"Malignus","scryfallId":"8a6a7000-4a1d-4cd4-a85e-4b7b20d8e543"},{"index":26382,"token":false,"name":"Bloodthirsty Ogre","scryfallId":"c557f035-f93b-41ce-b8de-dea79dcf15be"},{"index":26383,"token":false,"name":"Deep Freeze","scryfallId":"072173bd-e384-4d77-904f-477eecf66be3"},{"index":26385,"token":false,"name":"Leonin Elder","scryfallId":"4a942fcc-e33a-4be1-8ef4-368fb7953873"},{"index":26386,"token":false,"name":"Towering Titan","scryfallId":"a2c3eac5-3354-44ce-97c2-bafce78433ca"},{"index":26388,"token":false,"name":"Guild Globe","scryfallId":"a7faf99e-f61f-46cb-a275-2e12c41f1e31"},{"index":26393,"token":false,"name":"Academy Journeymage","scryfallId":"a46a65e0-66a3-4896-8acc-0ad5e9927c40"},{"index":26396,"token":false,"name":"Jötun Owl Keeper","scryfallId":"1566c8a2-aaca-4ce0-a36b-620ea6f135cb"},{"index":26402,"token":false,"name":"Whipstitched Zombie","scryfallId":"9cd00b0b-2ac1-4926-a735-215f402ba1c4"},{"index":26411,"token":false,"name":"Igneous Cur","scryfallId":"d2bfec5d-3182-415a-afe8-0b5511cfd656"},{"index":26419,"token":true,"name":"Elemental // Centaur Token (G/W, 8/8)","scryfallId":"d2d19d33-407b-42fc-84de-d8a0642723c1"},{"index":26425,"token":false,"name":"Reckless Brute","scryfallId":"5fd32a9e-1d39-4792-9657-69d17e5e0134"},{"index":26426,"token":false,"name":"Ghitu Fire","scryfallId":"78827acd-a526-411b-bd22-ab9b538c75dd"},{"index":26434,"token":false,"name":"Daring Archaeologist","scryfallId":"7defe0ab-181a-4288-9274-bfb48cfd3b7d"},{"index":26435,"token":false,"name":"Hidden Stag","scryfallId":"0501e115-ef61-4db5-bdb3-36dc4334431c"},{"index":26436,"token":false,"name":"Abyssal Persecutor","scryfallId":"aee68b52-6377-419b-b772-2af1e57cbe5d"},{"index":26437,"token":false,"name":"Oracle's Vault","scryfallId":"43fcc4a5-3ab0-4344-85af-d80aae293b75"},{"index":26439,"token":false,"name":"Pride of Conquerors","scryfallId":"ff0a769c-6602-4f6f-a388-f5aa15fb3c90"},{"index":26442,"token":false,"name":"Baleful Force","scryfallId":"a5e79f7b-0212-476b-9dea-bf1ada419e72"},{"index":26444,"token":false,"name":"Gift of Orzhova","scryfallId":"da824204-a7ed-46f1-b890-f21fcc39ce7e"},{"index":26445,"token":false,"name":"Kami of the Honored Dead","scryfallId":"46e53299-f480-4769-bfc6-86fb19964280"},{"index":26446,"token":false,"name":"Access Tunnel","scryfallId":"edf8eb51-9643-4c54-b38e-e7abea92bbe1"},{"index":26447,"token":false,"name":"Pine Walker","scryfallId":"93a49d9c-8fe7-494b-9a26-cf4bde71e420"},{"index":26448,"token":false,"name":"Town Sentry","scryfallId":"e5e9db36-0592-4e59-951a-d9d6c1522b99"},{"index":26450,"token":false,"name":"Pitchstone Wall","scryfallId":"9bfea263-6ff0-41be-9755-03bcdebfb255"},{"index":26452,"token":false,"name":"Stand // Deliver","scryfallId":"be8b338f-6f05-43c6-beeb-c5052cc0d6a9"},{"index":26453,"token":false,"name":"Mind Sculpt","scryfallId":"037d6277-1fc3-41a4-ade6-7cca10535b0f"},{"index":26457,"token":false,"name":"Savai Sabertooth","scryfallId":"d46702b0-7e10-462a-9aac-7564efe91804"},{"index":26458,"token":false,"name":"Falkenrath Gorger","scryfallId":"474895d8-1f2c-45bb-b721-4cf7c290eb23"},{"index":26459,"token":false,"name":"Thought Distortion","scryfallId":"f4a9d636-6720-4d7e-8b81-12c20bce6495"},{"index":26461,"token":false,"name":"Stormcrag Elemental","scryfallId":"a906f718-635b-4d51-8896-530c52b260f7"},{"index":26462,"token":false,"name":"Cryptic Annelid","scryfallId":"d717d62d-87b0-494c-8798-33c52ec4e764"},{"index":26463,"token":false,"name":"Dominating Licid","scryfallId":"e3e03323-43e8-4ddc-a874-211a97fd7648"},{"index":26464,"token":false,"name":"Controvert","scryfallId":"0e670f6b-d16e-47fc-a5b7-7ca0d8763644"},{"index":26465,"token":false,"name":"Nessian Demolok","scryfallId":"ee0683b2-8bc2-4c6a-964e-b909693b68c1"},{"index":26474,"token":false,"name":"Curse of Echoes","scryfallId":"147dbe42-665a-4e21-b405-d17554d5efcf"},{"index":26485,"token":false,"name":"Yawgmoth's Vile Offering","scryfallId":"bf9794a7-caf5-40b9-8046-67823ff64a2c"},{"index":26493,"token":false,"name":"Ral, Caller of Storms","scryfallId":"c44f0c60-5732-4c25-9ba9-4829f1891762"},{"index":26498,"token":false,"name":"Rotting Mastodon","scryfallId":"1564a20a-0e57-4ced-9eda-7acff74274e7"},{"index":26499,"token":false,"name":"Marauding Looter","scryfallId":"3c41fee8-7b03-4dc8-babb-f8c8369a74c2"},{"index":26502,"token":false,"name":"Tel-Jilad Outrider","scryfallId":"1d811d8f-437b-4c9f-8ea2-c85590a07935"},{"index":26503,"token":false,"name":"Dark Triumph","scryfallId":"794657cd-b292-41d7-a4a6-3f3dd20dc07a"},{"index":26504,"token":false,"name":"Crypt Champion","scryfallId":"ed424a46-8bac-4a3c-a6e6-87d02a20b292"},{"index":26505,"token":false,"name":"Torrent Sculptor // Flamethrower Sonata","scryfallId":"6e245502-1214-4b3c-9a6f-098f5641a409"},{"index":26507,"token":false,"name":"Leveler","scryfallId":"54b9d8fa-2427-49fb-af69-3b2688dc8a8c"},{"index":26508,"token":false,"name":"Contested Cliffs","scryfallId":"8d6363ea-3814-4014-ad9e-1066c72d907c"},{"index":26509,"token":false,"name":"Garruk Relentless // Garruk, the Veil-Cursed","scryfallId":"bb89599a-1883-45da-a87a-25e3f70c5a33"},{"index":26510,"token":false,"name":"Rakdos Riteknife","scryfallId":"7fb6e10a-3df1-4c6f-bf4c-d4a2a0467c60"},{"index":26511,"token":false,"name":"Quest for the Gemblades","scryfallId":"ea12a160-9c05-4f66-bd80-035ea52f415b"},{"index":26514,"token":false,"name":"Starfall","scryfallId":"13921f0d-f163-4275-b025-045c1ccd99e5"},{"index":26515,"token":false,"name":"Skyline Scout","scryfallId":"b052b641-fce9-45c1-a15b-1e22f1a64e4d"},{"index":26516,"token":false,"name":"Acid-Spewer Dragon","scryfallId":"aa8f58f1-4843-4926-b3c4-98898201c216"},{"index":26523,"token":false,"name":"Chrome Steed","scryfallId":"ce881675-690f-4d4c-a951-ab8302e904ab"},{"index":26526,"token":false,"name":"Savage Stomp","scryfallId":"cb862587-8821-43c7-ad08-2b7d2b82cc71"},{"index":26531,"token":false,"name":"Kaijin of the Vanishing Touch","scryfallId":"39e177ce-98bf-4fbc-83d1-1f64ca5d86c6"},{"index":26536,"token":false,"name":"Thud","scryfallId":"11bed78a-c579-424a-8fcc-322ce2630dbc"},{"index":26538,"token":false,"name":"Raging Regisaur","scryfallId":"ad6c43a7-e9c5-4b1c-9a6d-0d8798303045"},{"index":26539,"token":false,"name":"Quenchable Fire","scryfallId":"ee1c0ded-2a80-4ed4-b9fc-3a18bf5c3239"},{"index":26540,"token":false,"name":"Tattered Haunter","scryfallId":"fd8ac8da-7497-4b07-af86-29bac1361c8e"},{"index":26543,"token":false,"name":"Meddle","scryfallId":"0245553c-b483-47df-940b-5d7deb108642"},{"index":26546,"token":false,"name":"Sultai Banner","scryfallId":"1695cf35-8f7c-4674-bfd3-43520b13d084"},{"index":26549,"token":false,"name":"Moritte of the Frost","scryfallId":"22fdbe71-abca-4e48-99b2-1cb6b35d930b"},{"index":26551,"token":false,"name":"Archive Trap","scryfallId":"67bb2ca9-32b8-442d-b6a0-d624a87f5af8"},{"index":26554,"token":false,"name":"Bow of Nylea","scryfallId":"504505be-f58a-45fc-872c-f4a49dc715e1"},{"index":26557,"token":false,"name":"Guardian Shield-Bearer","scryfallId":"59d6e5dd-1243-4135-b6a7-adb9e3a847c9"},{"index":26558,"token":false,"name":"Immolating Souleater","scryfallId":"abbaf916-067d-4834-a55c-b400fe0d8c1f"},{"index":26560,"token":false,"name":"Soulscour","scryfallId":"6b431711-ac9d-4f05-af66-44f1ca5fabf1"},{"index":26565,"token":false,"name":"Phyrexian Scuta","scryfallId":"52b46846-a320-4b82-a440-f96c84426938"},{"index":26575,"token":false,"name":"Heartmender","scryfallId":"5b8c1070-cb58-4948-99c9-febef7fef0d5"},{"index":26580,"token":false,"name":"Sprouting Phytohydra","scryfallId":"6a478eaa-2658-49db-965f-db25fc1d720e"},{"index":26583,"token":false,"name":"Dauthi Slayer","scryfallId":"652ccd79-aefd-4b45-b747-75190da0cfc6"},{"index":26585,"token":false,"name":"Kaya's Wrath","scryfallId":"5ed140c1-752b-4539-88f2-1fa354049b17"},{"index":26586,"token":false,"name":"Idyllic Grange","scryfallId":"ca2c611c-3a6f-44b0-9daa-837a465845e0"},{"index":26587,"token":false,"name":"Agent of Treachery","scryfallId":"607cedae-c336-4844-b2a8-1334a2bced85"},{"index":26591,"token":false,"name":"Pious Kitsune","scryfallId":"bb4124b9-5169-471e-b805-ceeffeec9184"},{"index":26593,"token":false,"name":"Familiar Ground","scryfallId":"7a4e963b-d316-4c45-8c01-4a40042b977e"},{"index":26605,"token":false,"name":"Ravenous Daggertooth","scryfallId":"309b204b-774a-47bc-aead-c78db90f3be2"},{"index":26607,"token":false,"name":"Sleep Paralysis","scryfallId":"2babef35-27ab-45aa-88cd-f21dccae5125"},{"index":26613,"token":false,"name":"Panther Warriors","scryfallId":"8be610ce-5b84-416e-b427-98887642ff01"},{"index":26617,"token":false,"name":"Apes of Rath","scryfallId":"25eff287-6b53-4e6d-9da2-d80d05bb8c51"},{"index":26618,"token":false,"name":"Cradle to Grave","scryfallId":"3ec275cf-bb4e-4de0-9184-4d53dd87dad3"},{"index":26619,"token":false,"name":"Death Frenzy","scryfallId":"92096311-a3fa-41fc-b7a9-71ac2310f7fe"},{"index":26621,"token":false,"name":"Meteor Crater","scryfallId":"043a2299-1cfc-4732-a10a-58c773b9992c"},{"index":26628,"token":false,"name":"Sidisi, Brood Tyrant","scryfallId":"9cf8280f-463a-43a5-9c92-d9e7f54b2a32"},{"index":26629,"token":false,"name":"Reverence","scryfallId":"4d5e65e1-be52-4023-81cc-ee4948444195"},{"index":26630,"token":false,"name":"Subterranean Spirit","scryfallId":"132e8aac-9698-45fa-8d64-b460fd5deffc"},{"index":26633,"token":false,"name":"Blackcleave Goblin","scryfallId":"95986875-59f5-414f-867f-94f30cefa5d6"},{"index":26636,"token":false,"name":"Blood Clock","scryfallId":"28328b4d-99d1-4460-9bbe-a64c6c0b6cb2"},{"index":26637,"token":false,"name":"Careless Celebrant","scryfallId":"bac6bdd4-b25b-41f6-835d-7d1570cdb951"},{"index":26638,"token":false,"name":"Whip Sergeant","scryfallId":"2e6b3f38-87c9-4cea-b9e5-b8fb42e64794"},{"index":26641,"token":false,"name":"Foratog","scryfallId":"b2e1195d-443f-4826-a748-bc6e7e24153a"},{"index":26643,"token":false,"name":"Temur War Shaman","scryfallId":"a873164f-d8eb-460e-a8cc-8b2a663dcf3a"},{"index":26644,"token":false,"name":"Screams from Within","scryfallId":"86c03b3c-5140-4577-a1aa-952986223a82"},{"index":26645,"token":false,"name":"Rimehorn Aurochs","scryfallId":"3844b3f8-2d42-4265-b2dd-fa888492efff"},{"index":26648,"token":false,"name":"Kheru Spellsnatcher","scryfallId":"dd8ac93b-0658-4fc5-819c-77ba0260142e"},{"index":26652,"token":false,"name":"Lu Xun, Scholar General","scryfallId":"54274222-d2c3-4249-a12e-7a5f53331937"},{"index":26655,"token":false,"name":"Soulblast","scryfallId":"92fe38cc-2b12-4491-8deb-fbcb306febf2"},{"index":26658,"token":false,"name":"Horde of Boggarts","scryfallId":"023562bf-da7d-486d-93fc-60353f55b8a7"},{"index":26661,"token":false,"name":"Heirs of Stromkirk","scryfallId":"ff89ad3b-b154-49e2-a0fd-135279512250"},{"index":26662,"token":false,"name":"Grim Reminder","scryfallId":"35baa726-8c2f-4a0b-93d1-d7ecfae69fe4"},{"index":26664,"token":false,"name":"Carrion Beetles","scryfallId":"524c21ae-793f-4cb8-ab51-975afc8a409c"},{"index":26665,"token":false,"name":"Yanling's Harbinger","scryfallId":"93aca389-6830-4297-97bc-e3a2a1a1d41a"},{"index":26666,"token":false,"name":"Storm the Citadel","scryfallId":"04b3b12e-bef7-409e-86b3-9e90640e598c"},{"index":26668,"token":false,"name":"Trove of Temptation","scryfallId":"fb2df914-bb56-449e-9ef8-8b1012a76f64"},{"index":26671,"token":false,"name":"Rune of Protection: Black","scryfallId":"3f69050b-c54d-43f2-8348-2801c365dc4c"},{"index":26673,"token":false,"name":"Chromatic Sphere","scryfallId":"edabc8b2-4413-48e4-8d6f-521b19d839a6"},{"index":26676,"token":false,"name":"Gallantry","scryfallId":"d7992f83-93ad-4132-b8f2-a9f93bc96b4e"},{"index":26680,"token":false,"name":"Guided Strike","scryfallId":"d13138c1-e98f-4803-8c68-ffc80139c168"},{"index":26682,"token":false,"name":"Sir Shandlar of Eberyn","scryfallId":"31570ded-f5e3-44c4-b95f-294ac10b2cd2"},{"index":26683,"token":false,"name":"Taunting Arbormage","scryfallId":"ca6f8996-bf72-4e55-944f-5b8202b6068c"},{"index":26686,"token":false,"name":"Stormcloud Djinn","scryfallId":"ea1b0791-618b-4060-b4d9-3bd7a778098e"},{"index":26688,"token":false,"name":"Hammer Mage","scryfallId":"b959d7ad-a78e-439f-9225-4dbb89f490d7"},{"index":26696,"token":false,"name":"Misfortune's Gain","scryfallId":"80abd7c1-8f7a-4279-b76f-251a02624345"},{"index":26699,"token":false,"name":"Magus of the Candelabra","scryfallId":"960ba1a0-eb35-4622-a7c5-6f9eb1357e23"},{"index":26709,"token":false,"name":"Comparative Analysis","scryfallId":"dd83129b-7e8c-4cc5-a7b3-e0ae221d7ad4"},{"index":26715,"token":false,"name":"Tectonic Edge","scryfallId":"fdcf5c0f-9d18-406d-a930-c179a781264f"},{"index":26720,"token":false,"name":"Emissary of Hope","scryfallId":"f4c47553-4209-4634-a49c-25714cd3967b"},{"index":26722,"token":false,"name":"Darting Merfolk","scryfallId":"438e15f7-59bb-4047-af1f-ef92cc1866b8"},{"index":26723,"token":true,"name":"Golem Token (Colorless, 9/9)","scryfallId":"2d84926d-5892-4c62-a943-fac9f0ddc569"},{"index":26726,"token":false,"name":"Blind Hunter","scryfallId":"be1c8995-be36-43f6-9bd7-7b8712894331"},{"index":26728,"token":false,"name":"Skin Invasion // Skin Shedder","scryfallId":"c0243401-e3ae-41c6-a3a0-9cd4b330c200"},{"index":26729,"token":false,"name":"Ajani, Caller of the Pride","scryfallId":"5e7f410a-7934-48ae-a90b-ffd096aed43d"},{"index":26730,"token":false,"name":"Aerial Engineer","scryfallId":"5314bae2-4930-4f8a-8a52-853bc3feb88f"},{"index":26731,"token":false,"name":"Goblin Brigand","scryfallId":"862a481a-f236-4e99-b4b9-086e6cb8f4de"},{"index":26732,"token":false,"name":"Leaf Arrow","scryfallId":"2d531ba4-df99-41e4-9dd3-a27a420ad63c"},{"index":26733,"token":false,"name":"Mogis's Favor","scryfallId":"de6bf7fb-11ca-4878-8072-cebaa763a549"},{"index":26736,"token":false,"name":"Batwing Brume","scryfallId":"165960f2-b26a-4204-8234-9c00a98a8b34"},{"index":26739,"token":false,"name":"Bioessence Hydra","scryfallId":"fb01a161-49a1-407c-8410-6933bc8f7b6a"},{"index":26742,"token":false,"name":"Once and Future","scryfallId":"1c5dd4e8-4d5f-45a0-9cae-4f842751894d"},{"index":26744,"token":false,"name":"Disciple of the Old Ways","scryfallId":"3c62b3ee-db2b-45c3-87d5-5d917ea4baeb"},{"index":26747,"token":false,"name":"Humiliate","scryfallId":"dc3ae8cb-fbdb-45a8-83c2-cbf4aff01f90"},{"index":26751,"token":false,"name":"Loyal Guardian","scryfallId":"1fc62139-cbb3-43e2-852e-9242a8a53153"},{"index":26752,"token":false,"name":"Mental Agony","scryfallId":"4f8a1d51-aa7f-41fd-b97d-56bc48221615"},{"index":26755,"token":false,"name":"Gangrenous Goliath","scryfallId":"69b58b6b-24cd-4440-b99c-d88d44b3c41c"},{"index":26756,"token":false,"name":"Amorphous Axe","scryfallId":"8d149ede-3201-451a-a640-d0c10b024dbc"},{"index":26762,"token":false,"name":"Monastery Siege","scryfallId":"eef398b5-38f7-4a11-8fcf-d4e0d27267cf"},{"index":26764,"token":true,"name":"Spirit Token (R/W, 3/2)","scryfallId":"f98c0167-7434-4607-87c4-315fa8b6972e"},{"index":26765,"token":true,"name":"Sim Han How Bio","scryfallId":"73bb5b31-d562-4c2f-af92-b995abb8d6eb"},{"index":26771,"token":false,"name":"Spark Harvest","scryfallId":"e4d42177-dd1b-482c-a549-6f563b3f3249"},{"index":26776,"token":false,"name":"Duskmantle Operative","scryfallId":"16eb5a6b-5e69-497c-a0c9-4165ad0f5d0b"},{"index":26777,"token":false,"name":"Nath's Elite","scryfallId":"f2a2b029-02ba-46b0-88a2-99025727cc56"},{"index":26778,"token":false,"name":"Horde of Notions","scryfallId":"80b9ea46-ae9b-4729-b206-0ba3ddc7660d"},{"index":26791,"token":false,"name":"Ranger's Path","scryfallId":"26858a53-1054-407a-b2a2-34a7c4ae0f10"},{"index":26792,"token":false,"name":"Live Fast","scryfallId":"3aaba860-65ed-4aa5-b6fd-42a54dde9a4a"},{"index":26793,"token":false,"name":"Skillful Lunge","scryfallId":"2a28abc1-3e75-4db4-baa1-b47abdb7453b"},{"index":26794,"token":false,"name":"Dodecapod","scryfallId":"ded8b992-a1c2-4e43-ad0a-ea3995a3c8b8"},{"index":26799,"token":false,"name":"Thunderblust","scryfallId":"d5872624-7994-468c-9e16-4a771a0dbcfa"},{"index":26800,"token":false,"name":"Filigree Fracture","scryfallId":"65075828-d685-4107-866e-75a53cbc6414"},{"index":26802,"token":false,"name":"Yawgmoth Demon","scryfallId":"696a9fe1-ce63-4638-8793-5187fc726731"},{"index":26803,"token":false,"name":"Thorn Thallid","scryfallId":"1e8f50be-1629-40eb-8916-019903d2e6a4"},{"index":26804,"token":false,"name":"Careful Consideration","scryfallId":"08b7224b-adb9-4c31-b0bb-1c498f2922fb"},{"index":26809,"token":false,"name":"Soul Strings","scryfallId":"e34f9d1b-a89a-439f-8aa9-b96a1bf892eb"},{"index":26810,"token":false,"name":"Wave-Wing Elemental","scryfallId":"c36ba40a-d977-41ea-865e-00656dfd5299"},{"index":26820,"token":false,"name":"Leap of Faith","scryfallId":"7ba52aed-440c-4b32-8f25-0c5364441712"},{"index":26821,"token":false,"name":"Pillaging Horde","scryfallId":"aa287437-a9e9-437e-b997-20cae8357ce8"},{"index":26822,"token":false,"name":"Blind Obedience","scryfallId":"07c3e78d-d917-4552-842f-feff99c059e0"},{"index":26825,"token":false,"name":"Wasitora, Nekoru Queen","scryfallId":"0f680395-8e4f-49e9-8259-1c3ae56c8c2e"},{"index":26828,"token":false,"name":"Riverfall Mimic","scryfallId":"bc5ed3ce-d7f7-4275-baef-edc5127475d7"},{"index":26833,"token":false,"name":"Kird Chieftain","scryfallId":"4189a909-2e20-4dc7-894c-21446da5b0cf"},{"index":26834,"token":false,"name":"Cabal Conditioning","scryfallId":"eb81c6e6-fded-4cd3-a6fa-486419a5408a"},{"index":26837,"token":false,"name":"Vessel of Malignity","scryfallId":"81b44857-1edb-4de4-b646-917101faf881"},{"index":26841,"token":false,"name":"Soulblade Djinn","scryfallId":"d07bc465-ef74-471f-9b33-12479ae12d3c"},{"index":26843,"token":false,"name":"Smoldering Werewolf // Erupting Dreadwolf","scryfallId":"0b0eab47-af62-4ee8-99cf-a864fadade2d"},{"index":26846,"token":false,"name":"Spire Serpent","scryfallId":"9a14e2a4-484b-46e4-a5a1-c66cb13be178"},{"index":26847,"token":false,"name":"Dawn Elemental","scryfallId":"fd90a303-25fb-460b-bd55-6249f61c361c"},{"index":26849,"token":false,"name":"Boon of the Wish-Giver","scryfallId":"0e790851-f0f7-4f1a-80e6-94be649499b6"},{"index":26853,"token":false,"name":"Portent of Betrayal","scryfallId":"6288606e-182a-4260-bbe9-3f8f09c2f33c"},{"index":26854,"token":false,"name":"Hungry Mist","scryfallId":"a486eab3-3a09-4bd5-ad97-8ec620434f7e"},{"index":26855,"token":false,"name":"Selesnya Keyrune","scryfallId":"1645eafd-cd17-463a-9d7e-42f5f7b5196f"},{"index":26862,"token":false,"name":"Retrofitter Foundry","scryfallId":"5da578b8-19e6-4068-9336-e7cd33c585f1"},{"index":26865,"token":false,"name":"Sedgemoor Witch","scryfallId":"075bfaa8-3d54-4934-aaf6-72be43a87324"},{"index":26869,"token":false,"name":"Raiders' Karve","scryfallId":"f572cbb1-49ee-4c95-90a3-82704cf92454"},{"index":26873,"token":false,"name":"Scarred Puma","scryfallId":"067ff95e-c4dc-41bb-9677-67f51a09b05a"},{"index":26875,"token":false,"name":"Wayward Servant","scryfallId":"e9e00112-8c6c-4551-ad68-389e315fe148"},{"index":26877,"token":true,"name":"Aeo Paquette Decklist","scryfallId":"2cb77c74-f4cd-46e0-a2de-1fcdc1bdbd1d"},{"index":26880,"token":false,"name":"Young Necromancer","scryfallId":"84b5f6da-5e0f-4cce-92fe-7aa69124e265"},{"index":26881,"token":false,"name":"Disciple of Tevesh Szat","scryfallId":"8f99ec07-8af7-4e80-9f0e-fa304a94d4b4"},{"index":26883,"token":false,"name":"Cinder Cloud","scryfallId":"f044c470-50ce-4a6c-b8ab-665357c3c11e"},{"index":26886,"token":false,"name":"Faithful Squire // Kaiso, Memory of Loyalty","scryfallId":"758abd53-6ad2-406e-8615-8e48678405b4"},{"index":26888,"token":false,"name":"Spirit Shield","scryfallId":"213d6e0d-5ec9-441e-a38d-50ce44583e4b"},{"index":26895,"token":false,"name":"Lin Sivvi, Defiant Hero","scryfallId":"e574e522-2632-4cd4-8545-c582ac3b641f"},{"index":26896,"token":false,"name":"Endurance","scryfallId":"1fc6d14a-1328-4032-ad9e-cd85cd365bd3"},{"index":26898,"token":false,"name":"Dormant Volcano","scryfallId":"6aa92be7-883f-42bd-8623-00eb2df28a98"},{"index":26900,"token":false,"name":"Apocalypse","scryfallId":"7ff23780-d183-4cca-ad0c-448ef325bf36"},{"index":26904,"token":false,"name":"Rakdos's Return","scryfallId":"d72981c0-1632-4d64-9341-2a76047d9b36"},{"index":26906,"token":false,"name":"Conduit of Ruin","scryfallId":"4bc855d3-817c-4748-a7f5-1533d8b0e930"},{"index":26907,"token":false,"name":"Red Cliffs Armada","scryfallId":"d0391b4f-e819-409a-9e81-1bff932808e7"},{"index":26909,"token":false,"name":"Howling Giant","scryfallId":"eb8434fd-5ee5-4be9-a28d-9e04b1b94327"},{"index":26911,"token":false,"name":"Enraging Licid","scryfallId":"fb7bff44-36e1-4855-aa2d-5c7bd6bf6f10"},{"index":26912,"token":false,"name":"Legion Lieutenant","scryfallId":"33f7ff99-65d6-4e97-bdfa-b6e6eac0588f"},{"index":26921,"token":false,"name":"Roost of Drakes","scryfallId":"ba1240d4-dbd0-483b-934a-5f7c505fad42"},{"index":26922,"token":false,"name":"Imperial Ceratops","scryfallId":"a5030e80-58c4-4ce3-877e-8395b653f6e8"},{"index":26923,"token":false,"name":"Demigod of Revenge","scryfallId":"bc6f15b2-3045-43a4-a5cb-82aa40a5361c"},{"index":26924,"token":false,"name":"Woodwraith Corrupter","scryfallId":"d1ee1ceb-61dd-4c98-bc48-a0763315a14f"},{"index":26925,"token":false,"name":"Sea Gate Banneret","scryfallId":"6ae4634e-1487-4b66-8f70-bcb4b1fa6e77"},{"index":26931,"token":false,"name":"Dream Trawler","scryfallId":"41c80ec6-3dfa-4e87-bccc-2bada06e7291"},{"index":26936,"token":false,"name":"Tana, the Bloodsower","scryfallId":"a3d8d64f-a403-42a7-881b-4f70e9fe15a2"},{"index":26937,"token":false,"name":"Nivix Barrier","scryfallId":"0b9b968d-b0cc-411d-9366-8358be28aef2"},{"index":26938,"token":false,"name":"Soul of Ravnica","scryfallId":"a7332471-c052-4a24-abf1-a5805d685658"},{"index":26940,"token":false,"name":"Brimstone Trebuchet","scryfallId":"77c49e0e-4375-4e45-a57b-8df667e45ce6"},{"index":26945,"token":false,"name":"Octoprophet","scryfallId":"bec0a0fc-7b82-4812-b8cc-cbfba4987142"},{"index":26957,"token":false,"name":"Uktabi Drake","scryfallId":"8b8c401a-8c66-4054-894f-afd866b3b95b"},{"index":26964,"token":false,"name":"Isperia the Inscrutable","scryfallId":"0ca226e3-e392-4c7c-88f0-14e6e3bd17ad"},{"index":26970,"token":false,"name":"Simic Basilisk","scryfallId":"59e7af53-62d8-45b8-829f-c575dda53e25"},{"index":26976,"token":false,"name":"Gnarled Mass","scryfallId":"5c28728d-4839-4cdf-91d4-b9fb4b5d0449"},{"index":26982,"token":false,"name":"Choking Restraints","scryfallId":"4549735d-df63-47db-ad53-0497499fe387"},{"index":26983,"token":false,"name":"Brushfire Elemental","scryfallId":"8fc448f6-a7fe-47c4-ac7c-385a77326469"},{"index":26984,"token":false,"name":"Thunderous Snapper","scryfallId":"9576d4f1-47bb-45e0-803c-93fa2cdacbe5"},{"index":26990,"token":false,"name":"Master's Call","scryfallId":"8a4c6e74-bb8d-406d-9fb0-ac879108db81"},{"index":26991,"token":false,"name":"Queen's Agent","scryfallId":"cfcb83d2-6524-4991-97e5-d41579fb54dc"},{"index":26998,"token":false,"name":"Lyev Skyknight","scryfallId":"11cbeb3b-1579-4318-a024-4a2c06896eaf"},{"index":26999,"token":false,"name":"Kindle","scryfallId":"49ab00d1-7242-4509-a9db-59d4edb2e654"},{"index":27003,"token":false,"name":"Mana Tithe","scryfallId":"e7f32354-893d-4f0b-b555-e0757fb5443b"},{"index":27004,"token":false,"name":"Quill-Slinger Boggart","scryfallId":"c3a15a9d-46d7-4181-8131-50ba46a11c7b"},{"index":27007,"token":false,"name":"Single Combat","scryfallId":"886d8eb4-778f-4322-bbbd-a2cd6489b0d0"},{"index":27010,"token":false,"name":"Hidden Retreat","scryfallId":"5be86f1f-c85a-4396-aa16-a39fbf493c96"},{"index":27011,"token":false,"name":"Slaying Fire","scryfallId":"9dfe8919-6244-41ca-a637-07ee971042ed"},{"index":27014,"token":false,"name":"Fruit of Tizerus","scryfallId":"66e577a0-e5d7-4e6a-919c-d85c2ae819ce"},{"index":27020,"token":false,"name":"Abyssal Horror","scryfallId":"10dd1b9b-95db-4aa8-bfea-36b95e7a6613"},{"index":27022,"token":false,"name":"Brine Shaman","scryfallId":"f445962c-44a1-4f3f-88d4-17048f8ca9dc"},{"index":27023,"token":false,"name":"Vicious Shadows","scryfallId":"d040791e-eee4-4eef-ace1-507216a5d268"},{"index":27024,"token":false,"name":"Steeple Creeper","scryfallId":"f4afafb4-3fc0-4ccf-a942-e4bd2f146d89"},{"index":27027,"token":true,"name":"Human Wizard Token (U, 1/1)","scryfallId":"e4439a8b-ef98-428d-a274-53c660b23afe"},{"index":27031,"token":false,"name":"Phantom Wings","scryfallId":"a96e5a18-5958-426e-892f-5c68f44c1b41"},{"index":27034,"token":false,"name":"Entourage of Trest","scryfallId":"3d7ee777-6113-43f8-883e-c7569eefb872"},{"index":27039,"token":false,"name":"Exava, Rakdos Blood Witch","scryfallId":"6cb72a64-89e7-4b0e-a3d3-1309829071d2"},{"index":27042,"token":false,"name":"Chandra's Defeat","scryfallId":"f218e595-4943-42b1-a136-f7483df103a6"},{"index":27045,"token":false,"name":"Skull Fracture","scryfallId":"93e3c013-319f-4a77-a55e-11323468b8ea"},{"index":27047,"token":false,"name":"Frontier Guide","scryfallId":"2f70f45f-aad0-47d5-9ed1-d5b1d591f775"},{"index":27050,"token":false,"name":"Shivan Harvest","scryfallId":"47dbd765-d7ea-4181-bd22-5c749ad081af"},{"index":27051,"token":false,"name":"Godo's Irregulars","scryfallId":"f7a7afc5-be73-459d-8bd1-116a0bf1210f"},{"index":27052,"token":false,"name":"Tempting Wurm","scryfallId":"857c2b6c-cfdf-4c88-a334-2937cb7db603"},{"index":27053,"token":false,"name":"Nature's Cloak","scryfallId":"86b97d7d-6a72-4663-8b09-bef306485ed6"},{"index":27054,"token":false,"name":"Essence Extraction","scryfallId":"7a2c095e-3391-4256-8258-94ae33b1c231"},{"index":27055,"token":false,"name":"River Darter","scryfallId":"8e97eb8b-a8ff-4f5f-a62d-1aee11664ca2"},{"index":27058,"token":false,"name":"Fight as One","scryfallId":"5c62ea13-9bd5-46ce-a861-68cf9a2c6f8c"},{"index":27061,"token":false,"name":"Minotaur Illusionist","scryfallId":"d8a49d29-6d01-4b1d-80c8-9e5378a76878"},{"index":27062,"token":false,"name":"Havengul Runebinder","scryfallId":"beca3e00-2c04-41be-98d1-59bc2b5f05e4"},{"index":27065,"token":true,"name":"Xenagos Ascended Token (Colorless, 6/5)","scryfallId":"fe9dd9f0-3071-4bbd-80d2-e35b153006d7"},{"index":27069,"token":false,"name":"Magnifying Glass","scryfallId":"7a0c879b-c566-431e-a8fa-6104c39b6d7c"},{"index":27072,"token":false,"name":"Azure Drake","scryfallId":"c511ae41-05c0-4fb2-b74b-f27f2a4475be"},{"index":27085,"token":false,"name":"Drogskol Shieldmate","scryfallId":"156b4bca-4145-472b-bf80-13edb0bef561"},{"index":27086,"token":false,"name":"Mirran Spy","scryfallId":"50e576ad-3e03-424c-8857-88ec8898a92e"},{"index":27087,"token":false,"name":"Rubblebelt Raiders","scryfallId":"f5f0d394-f929-40e7-adb5-ca813b312dde"},{"index":27089,"token":false,"name":"Rain of Filth","scryfallId":"1cf07d5a-6618-48e2-a9f0-669b75bb6e85"},{"index":27090,"token":false,"name":"Orcish Librarian","scryfallId":"31f074bb-5ff6-4ce7-a186-1782d940c4a9"},{"index":27091,"token":false,"name":"Initiate's Companion","scryfallId":"380e83c1-e5e3-49b2-bbf3-fad8cc7d020a"},{"index":27092,"token":false,"name":"Momentary Blink","scryfallId":"1be7ab3b-beca-411e-bc27-024f42c013e1"},{"index":27094,"token":false,"name":"Circle of Elders","scryfallId":"a99df522-cc97-41e3-8073-72e092afe8bb"},{"index":27097,"token":false,"name":"Nightwind Glider","scryfallId":"0968401d-522f-4def-92a1-d504471ac54e"},{"index":27098,"token":false,"name":"Lava Runner","scryfallId":"09d0fbe6-6ce1-4b95-afb7-a7386b5033cf"},{"index":27100,"token":false,"name":"Damn","scryfallId":"402060d4-10d6-4cee-aa8b-cd083bf5df43"},{"index":27102,"token":false,"name":"Magnetic Flux","scryfallId":"03ab7022-fa0f-42da-b0ca-998cbd0c791c"},{"index":27104,"token":false,"name":"Prismatic Lace","scryfallId":"d1129585-6d59-4217-9404-747a100f1e8c"},{"index":27110,"token":false,"name":"Slate Street Ruffian","scryfallId":"d683abb8-46b4-424e-8a10-325519477419"},{"index":27115,"token":false,"name":"Perilous Shadow","scryfallId":"2c101171-a988-4c1d-9954-634e2f1c6f01"},{"index":27117,"token":false,"name":"Aven Fisher","scryfallId":"bba2cd91-84a7-4d05-9a0c-55440491be1e"},{"index":27120,"token":false,"name":"Bind","scryfallId":"cfa51783-9ef8-4e51-ba0d-ce8439d83bdf"},{"index":27121,"token":false,"name":"Energy Bolt","scryfallId":"711f4cff-0256-44b2-a2fe-1cae6e9edb2b"},{"index":27137,"token":false,"name":"Straw Soldiers","scryfallId":"8ae5ba21-eb8e-4663-bfd8-3e19a0c10774"},{"index":27138,"token":false,"name":"Tamanoa","scryfallId":"6d32955b-cbf6-429b-9513-17ca75d4ec2c"},{"index":27141,"token":false,"name":"Icatian Infantry","scryfallId":"e0e4a9d2-ea43-46ac-8b8b-00496a478103"},{"index":27143,"token":false,"name":"Viashino Weaponsmith","scryfallId":"def316ed-b080-4d1d-b946-d7a86ebb8ad9"},{"index":27144,"token":false,"name":"Evil Eye of Urborg","scryfallId":"fc17fe31-11f1-48e0-9b0d-7c7dcda417a6"},{"index":27147,"token":false,"name":"Frenzied Fugue","scryfallId":"71a66675-7673-498a-9eb8-f0f58278dcc4"},{"index":27149,"token":false,"name":"Pelakka Predation // Pelakka Caverns","scryfallId":"e63f8b20-f45b-4293-9aac-cdc021939be6"},{"index":27151,"token":false,"name":"Forbidden Orchard","scryfallId":"54e03a6c-1c0a-4a24-a3fe-2f3244938769"},{"index":27155,"token":false,"name":"Vampire Sovereign","scryfallId":"ee338221-ead9-4b89-8b0c-12745c4ca13d"},{"index":27161,"token":false,"name":"Liliana's Reaver","scryfallId":"fa9396f3-a93c-47ee-91da-78af864c86c3"},{"index":27163,"token":false,"name":"Necromentia","scryfallId":"9350ab9a-263b-4698-b4e7-2beb01c39134"},{"index":27164,"token":false,"name":"Centaur Battlemaster","scryfallId":"2975a0b4-7436-4588-8f79-c001a291c459"},{"index":27167,"token":false,"name":"Withstand","scryfallId":"bb458f79-13dd-4446-be75-463f19548867"},{"index":27171,"token":false,"name":"Fast // Furious","scryfallId":"5b209759-6215-49e8-a6a0-a6c94040adb2"},{"index":27172,"token":false,"name":"Sea Gate Colossus","scryfallId":"b04fd8e8-ee8d-4cb7-87ab-955303c46ece"},{"index":27177,"token":false,"name":"Harmattan Efreet","scryfallId":"d8fc0ba3-6ffa-4fd4-b332-88da41b8778a"},{"index":27178,"token":false,"name":"Vile Manifestation","scryfallId":"6e75e057-5cc0-4dd7-bcd0-079717b44812"},{"index":27183,"token":false,"name":"Make Obsolete","scryfallId":"e0a96feb-accc-4c30-8ecd-7d9272ebd45b"},{"index":27184,"token":false,"name":"Dakkon Blackblade","scryfallId":"235bbf86-02ad-497b-b698-e60930bbde9c"},{"index":27199,"token":false,"name":"Horned Sliver","scryfallId":"b8c36ddb-286f-47be-9a8b-aa3161e4186a"},{"index":27203,"token":false,"name":"Aminatou, the Fateshifter","scryfallId":"c562ff50-f74b-4311-972a-ba62366411d5"},{"index":27204,"token":false,"name":"Word of Seizing","scryfallId":"84260f0d-3484-4557-a5bd-8a10a82e9878"},{"index":27210,"token":false,"name":"Scrapdiver Serpent","scryfallId":"ce3ba315-f4da-4022-9251-961a378b35ce"},{"index":27214,"token":false,"name":"Flickering Spirit","scryfallId":"64ef9188-737e-4cc6-b3a5-95aafddcf665"},{"index":27217,"token":false,"name":"Volrath's Laboratory","scryfallId":"23e9e60a-5718-460d-b031-b47d6f6715d1"},{"index":27218,"token":false,"name":"Seagraf Skaab","scryfallId":"065d497d-5cfd-43c9-8c86-9a1da3d7e17e"},{"index":27220,"token":false,"name":"Regicide","scryfallId":"07f56287-91e0-418f-8b57-35c6c30cee33"},{"index":27222,"token":false,"name":"See the Unwritten","scryfallId":"3689a7f1-9713-412e-a030-9cba463c170e"},{"index":27224,"token":false,"name":"Aesthir Glider","scryfallId":"7c05edb0-c659-429e-8057-138571d9337e"},{"index":27226,"token":false,"name":"Famished Paladin","scryfallId":"d80e3bc9-7b67-4eab-916a-6d83da06f20a"},{"index":27238,"token":false,"name":"Trap Essence","scryfallId":"2bb37bd9-10a0-48d5-87f0-23a03b5c1072"},{"index":27243,"token":false,"name":"Razia's Purification","scryfallId":"73bfefd3-bddd-47bb-92f3-9356a7bca637"},{"index":27245,"token":false,"name":"Suq'Ata Assassin","scryfallId":"1b7178c6-f989-437d-83e3-04b9817f2c54"},{"index":27247,"token":false,"name":"Blessed Orator","scryfallId":"6c044857-2124-44f4-aafb-495511f26b3b"},{"index":27249,"token":false,"name":"Story Seeker","scryfallId":"e3dae817-3db1-4edf-86ba-c2c2b238fcf5"},{"index":27251,"token":false,"name":"Springjack Shepherd","scryfallId":"c0c0ff06-a43e-4790-90aa-4544b89da3f0"},{"index":27252,"token":false,"name":"Stonehoof Chieftain","scryfallId":"4670d196-9cd9-47b1-b3c6-f78fe0422707"},{"index":27253,"token":false,"name":"Loxodon Partisan","scryfallId":"9fc32454-fc44-454e-ba25-7bd0687cf99d"},{"index":27263,"token":false,"name":"Karplusan Yeti","scryfallId":"6ad95118-104c-41d4-a393-941e7b97fd8e"},{"index":27264,"token":false,"name":"Mistform Skyreaver","scryfallId":"e394e096-ea70-4813-9039-e4bd065d0a17"},{"index":27266,"token":false,"name":"Kinsbaile Cavalier","scryfallId":"3865c05a-a366-4786-ae76-c8a233a3456d"},{"index":27271,"token":true,"name":"Trueheart Duelist Token (W, 2/2)","scryfallId":"c770d91c-b7d1-44ef-922d-128cb3faef08"},{"index":27274,"token":false,"name":"One with Nature","scryfallId":"2321b01c-7eef-48cc-a86b-4074dfa5b86b"},{"index":27275,"token":false,"name":"Scavenged Blade","scryfallId":"3280f0d0-de0d-4f87-a6ef-c941cb7c9784"},{"index":27276,"token":false,"name":"Dreamstealer","scryfallId":"888bbabf-ba52-42cf-a068-db8246f10517"},{"index":27279,"token":false,"name":"Jolrael's Centaur","scryfallId":"31588ea3-31d2-4118-9b9f-4ce820c16a15"},{"index":27281,"token":false,"name":"Snuff Out","scryfallId":"18a3cca1-e50e-49b6-9e1a-f86640e3b177"},{"index":27282,"token":false,"name":"Kuldotha Rebirth","scryfallId":"7ee07266-a95d-4cd8-9863-1664922e9490"},{"index":27285,"token":false,"name":"Flamewake Phoenix","scryfallId":"fefd5848-9fe1-4129-a5d7-e51606bf76ef"},{"index":27289,"token":false,"name":"Arbalest Elite","scryfallId":"094c839e-0aea-4754-af37-edf6292623e1"},{"index":27291,"token":false,"name":"Kithkin Harbinger","scryfallId":"64735178-3dc5-4a95-92fa-e15bd04e5733"},{"index":27292,"token":false,"name":"Angrath's Marauders","scryfallId":"f0bfc9e0-14e8-43ce-8fca-773b7f2387dc"},{"index":27293,"token":false,"name":"Briarpack Alpha","scryfallId":"a052e945-7535-4b0a-b580-cf76377633f3"},{"index":27294,"token":false,"name":"Renewal","scryfallId":"ab998cd1-2f49-42e7-b889-c6717b0ce884"},{"index":27305,"token":false,"name":"Nantuko Shade","scryfallId":"8032dd8b-bd4f-4d44-8d7a-daac5497c8e8"},{"index":27311,"token":false,"name":"Journey to Eternity // Atzal, Cave of Eternity","scryfallId":"d81c4b3f-81c2-403b-8a5d-c9415f73a1f9"},{"index":27312,"token":false,"name":"Fiery Encore","scryfallId":"ae544d03-2d12-4994-b573-424c41ecc91d"},{"index":27313,"token":true,"name":"Aven Initiate Token (W, 3/2)","scryfallId":"1a3814e3-7ad2-4c87-8630-ab56e13b6ee9"},{"index":27318,"token":false,"name":"Opaline Unicorn","scryfallId":"cfba304c-9cb8-4d5c-b70d-b7f61a365977"},{"index":27319,"token":false,"name":"Gaea's Touch","scryfallId":"0e1ae3d6-6d96-4db6-bbc4-cee91bae6cf7"},{"index":27331,"token":false,"name":"Pierce Strider","scryfallId":"88b449a5-634f-47b1-a757-86a6849f6777"},{"index":27332,"token":false,"name":"Riparian Tiger","scryfallId":"7599508f-1a61-430b-819e-681040c81f79"},{"index":27333,"token":false,"name":"Fodder Tosser","scryfallId":"fd401525-b874-4af2-99a3-c2c83e22547e"},{"index":27335,"token":false,"name":"Hatchery Spider","scryfallId":"1bb060d8-dfb1-42b3-8a3d-0256673054f2"},{"index":27341,"token":false,"name":"Boggart Loggers","scryfallId":"9ed9a638-c3f9-48dd-9633-5c52146e0dcd"},{"index":27342,"token":false,"name":"Morgue Burst","scryfallId":"7b3c2909-87ab-4027-9b56-58a2abae3fa3"},{"index":27346,"token":false,"name":"Sylvan Caryatid","scryfallId":"41769d51-014b-4d23-b495-fa4a6e03684e"},{"index":27350,"token":false,"name":"Crackdown Construct","scryfallId":"993bc69a-b615-48c5-af81-252a73384e8c"},{"index":27352,"token":false,"name":"Geomancer's Gambit","scryfallId":"664777d0-0b14-4e15-8bbb-db8113c9ab34"},{"index":27361,"token":false,"name":"Devoted Crop-Mate","scryfallId":"d3677f10-b530-4606-b7c8-a72dd2131160"},{"index":27362,"token":false,"name":"Phyrexian Altar","scryfallId":"3c66c54b-b2d1-494d-ae10-a950c184a52f"},{"index":27366,"token":false,"name":"Mystic Snake","scryfallId":"38810fe4-dc72-439e-adf7-362af772b8f8"},{"index":27367,"token":false,"name":"Piru, the Volatile","scryfallId":"53945b5e-75da-48e5-ac87-5c02f318fdf0"},{"index":27368,"token":false,"name":"Ugin's Insight","scryfallId":"f37d5938-9c8f-4203-8f3f-d6e89ced28ef"},{"index":27369,"token":false,"name":"Wing Storm","scryfallId":"59e66be1-f18a-433f-8504-aa1e85e22023"},{"index":27377,"token":false,"name":"Kraul Raider","scryfallId":"133d9d56-d906-4252-9954-e34cc8564ced"},{"index":27380,"token":false,"name":"Viridian Joiner","scryfallId":"b50679df-bf82-4bb2-9fe3-8ebd7a9decde"},{"index":27382,"token":false,"name":"Pharika's Spawn","scryfallId":"a2c8244b-7d86-4dff-9419-3945beb2a7b7"},{"index":27385,"token":false,"name":"Tower of Murmurs","scryfallId":"2ad7e6c4-27a1-4aef-81a1-7e8fbcce89e3"},{"index":27388,"token":false,"name":"Settle the Wreckage","scryfallId":"9cbd346e-098a-4cf6-a72f-468376fd2e8f"},{"index":27389,"token":false,"name":"Worthy Cause","scryfallId":"1f610d8b-1782-43a4-bfb3-40887bdedba0"},{"index":27391,"token":false,"name":"Stern Dismissal","scryfallId":"0aec4d0f-ba1e-45f8-9764-9bcc3fa50e51"},{"index":27400,"token":false,"name":"Nantuko Shrine","scryfallId":"4b66bab3-ee6f-4f74-bbc1-8099c9c4904b"},{"index":27404,"token":false,"name":"Rusted Relic","scryfallId":"797a4456-1677-49d5-bb4f-4fb062522f1e"},{"index":27405,"token":false,"name":"Cunning Advisor","scryfallId":"5e31ede4-b0bb-4f63-b8df-1330152611a4"},{"index":27407,"token":false,"name":"Skirsdag Supplicant","scryfallId":"b3f63897-15a1-4b34-9916-d9df62f66785"},{"index":27410,"token":false,"name":"War-Spike Changeling","scryfallId":"523500d3-5614-4be8-95c7-d63ca279c1b1"},{"index":27411,"token":false,"name":"Scattering Stroke","scryfallId":"c536c1ce-a012-4d77-ab29-8574be164731"},{"index":27412,"token":false,"name":"Greenweaver Druid","scryfallId":"f7e9aa24-f5a3-4100-ab29-c9772a0fcbbc"},{"index":27417,"token":false,"name":"Still Life","scryfallId":"12be33d7-f25e-4dbf-9706-74403103b127"},{"index":27420,"token":false,"name":"Jace, Ingenious Mind-Mage","scryfallId":"e3b274f6-833f-430f-ac1a-d1d1d5b03e71"},{"index":27437,"token":false,"name":"Arnjlot's Ascent","scryfallId":"2307fb16-8b77-45b5-8a02-51a13214791d"},{"index":27438,"token":false,"name":"Scourge of Numai","scryfallId":"b7692ef1-bfae-411d-a589-f493128ef44b"},{"index":27439,"token":false,"name":"Nettlecyst","scryfallId":"4a0bb5dc-75a6-4bd6-81f8-611197fb0fba"},{"index":27443,"token":false,"name":"Conversion Chamber","scryfallId":"14d5a8f3-05b6-4bb7-bbe1-e753e22cbb50"},{"index":27451,"token":false,"name":"Sadistic Skymarcher","scryfallId":"1334ee90-c798-42ec-b2be-68dac766a7eb"},{"index":27453,"token":false,"name":"Giant Slug","scryfallId":"43a612e5-a680-4c5b-8ce7-432a86240a6c"},{"index":27457,"token":false,"name":"Mammoth Umbra","scryfallId":"8bb0323e-2efc-4daf-a67f-f194beba11cc"},{"index":27458,"token":false,"name":"Jacques le Vert","scryfallId":"ee5a45b1-169b-468e-9251-424c09cd7f0f"},{"index":27459,"token":false,"name":"Heart of Kiran","scryfallId":"e5f329a6-e49c-47cb-bdc4-2fd945d64fe1"},{"index":27462,"token":false,"name":"Arena Rector","scryfallId":"acabfe00-5224-485e-a6eb-c4b9fdf690f8"},{"index":27466,"token":false,"name":"Root Snare","scryfallId":"5f38b1a2-3f85-4dcd-b90d-bb049651b8b7"},{"index":27468,"token":false,"name":"Read the Tides","scryfallId":"5360fe8c-41b0-4409-b03e-072f129fb352"},{"index":27469,"token":false,"name":"Horror of Horrors","scryfallId":"07c7a302-937d-42db-aafd-dd03c20cc73a"},{"index":27476,"token":false,"name":"Dread Charge","scryfallId":"ed0ca934-6989-415b-8816-7c66d22b4707"},{"index":27477,"token":false,"name":"Orim, Samite Healer","scryfallId":"7567daf2-343f-4d62-977e-0b3b6001d57a"},{"index":27478,"token":false,"name":"Entreat the Dead","scryfallId":"31a147bb-37ef-4a52-82e2-160a53323516"},{"index":27480,"token":false,"name":"Ghastly Gloomhunter","scryfallId":"f272ac54-fea8-4044-83e2-f8fdc10f467d"},{"index":27490,"token":false,"name":"Cunning Bandit // Azamuki, Treachery Incarnate","scryfallId":"1fe2b76f-ddb7-49d5-933b-ccb06be5d46f"},{"index":27492,"token":false,"name":"Metathran Elite","scryfallId":"aa941f17-1b81-4017-90ae-4466eba8da2f"},{"index":27497,"token":false,"name":"Hindering Touch","scryfallId":"db9735d9-4aac-4175-8ec8-fc9bfd8f2c5c"},{"index":27499,"token":false,"name":"Soul Echo","scryfallId":"cb6f9427-ef5c-49fd-81e1-ddf130d69da0"},{"index":27503,"token":false,"name":"Niv-Mizzet, Dracogenius","scryfallId":"1b1c4bed-9b6b-42f9-939d-ece0f959a0a3"},{"index":27505,"token":false,"name":"Soldevi Heretic","scryfallId":"9613ca47-c9d1-4485-b0bd-71b0b587567e"},{"index":27511,"token":false,"name":"Grapple with the Past","scryfallId":"5dbb27d2-c2c2-47af-b943-00c8627a4501"},{"index":27515,"token":false,"name":"Metalspinner's Puzzleknot","scryfallId":"9b1639c3-f22d-4246-9252-219a4b2b2999"},{"index":27520,"token":false,"name":"Spellseeker","scryfallId":"74b4c336-5d4c-4bc5-b82a-35084a6ad808"},{"index":27521,"token":false,"name":"Sungrace Pegasus","scryfallId":"52d851b9-c290-4fcc-860d-a3250923b850"},{"index":27524,"token":false,"name":"Face of Fear","scryfallId":"17542219-1165-4483-9cef-7abecaebb6a2"},{"index":27526,"token":false,"name":"Firja, Judge of Valor","scryfallId":"9ec8cdd5-e55b-40e0-a61e-f28890f5628d"},{"index":27531,"token":false,"name":"Wild Jhovall","scryfallId":"64bcc06a-de86-4387-882d-ead33e9c9e01"},{"index":27534,"token":false,"name":"Elderwood Scion","scryfallId":"c16dabf9-6b77-44dd-8fe8-bd3e36a57d7e"},{"index":27535,"token":false,"name":"Land Equilibrium","scryfallId":"9c406b25-03f8-4aaa-9ea7-48bf754166b7"},{"index":27537,"token":false,"name":"Anchor to the Aether","scryfallId":"15058f91-d266-4804-96af-fc050b6c8436"},{"index":27538,"token":false,"name":"Hellfire","scryfallId":"362f1fe9-20af-434c-9957-7a1a564d89e6"},{"index":27541,"token":false,"name":"Trumpeting Herd","scryfallId":"b0f3b68e-f616-4687-bc2d-075165162cd1"},{"index":27544,"token":false,"name":"Sacred Excavation","scryfallId":"1dc2ab27-0f68-480c-99c9-53243c1ab0ac"},{"index":27552,"token":false,"name":"Reaver Ambush","scryfallId":"fceaac2f-b26c-4da9-bf4f-c7672394dd7f"},{"index":27553,"token":false,"name":"Razing Snidd","scryfallId":"d2090b80-2ce2-4c9a-87fe-d221f3c677b4"},{"index":27555,"token":false,"name":"Fatal Fumes","scryfallId":"967aa636-a11d-4c5c-ba85-648734b295c2"},{"index":27567,"token":false,"name":"Heavenly Qilin","scryfallId":"f1cb6fba-e314-4270-bbba-fa0584530f72"},{"index":27568,"token":false,"name":"Honorable Passage","scryfallId":"6559d301-98bd-40a9-abf4-1079d7283214"},{"index":27574,"token":false,"name":"Malachite Golem","scryfallId":"d1193164-5ee5-40ff-b244-f80d426bbf89"},{"index":27579,"token":false,"name":"Armory Automaton","scryfallId":"cc0be4ff-c346-4c22-8357-9a2383a53469"},{"index":27581,"token":false,"name":"Time Reversal","scryfallId":"1468c851-b20e-4c78-9fcb-45e60b7149db"},{"index":27583,"token":false,"name":"Splicer's Skill","scryfallId":"c59dfb0f-45c7-431f-b5a3-d9b429fc6dde"},{"index":27585,"token":false,"name":"Flash of Insight","scryfallId":"ffaab905-0b97-42c2-a1a3-1e72275caa82"},{"index":27589,"token":false,"name":"Cliffhaven Vampire","scryfallId":"5544247d-1f8f-443f-a4c4-d8461db28a79"},{"index":27595,"token":false,"name":"Wanderguard Sentry","scryfallId":"52ac6290-1401-41c5-90a1-99acb344719e"},{"index":27596,"token":false,"name":"Stolen Strategy","scryfallId":"bb90e4b8-8f66-45f0-a457-a081f2ff231c"},{"index":27601,"token":false,"name":"Skywing Aven","scryfallId":"91a20b6b-43e6-4feb-9792-909332e1a846"},{"index":27603,"token":false,"name":"Hail Storm","scryfallId":"8627bdbb-0ee3-4f4e-9016-ca0d33d27d40"},{"index":27604,"token":false,"name":"Herald of the Fair","scryfallId":"ce9ed217-8378-4a58-a00d-fa4e4cb27c9d"},{"index":27605,"token":false,"name":"Syndicate Enforcer","scryfallId":"cde6ee2e-a114-4935-8345-d3e264f9fc26"},{"index":27612,"token":false,"name":"Circle of Protection: Shadow","scryfallId":"49f29a3b-7136-496c-bc29-8808bfff0f82"},{"index":27616,"token":false,"name":"Voice of Law","scryfallId":"daec52a4-02da-4bff-aff4-5247baed1326"},{"index":27618,"token":false,"name":"Sporeback Troll","scryfallId":"18bdca24-3beb-4d0d-b3bc-b98c23316fe7"},{"index":27619,"token":false,"name":"Slash the Ranks","scryfallId":"528f9922-b0c3-410e-86ca-87495a4fbd3d"},{"index":27621,"token":false,"name":"Dire Fleet Captain","scryfallId":"8200f8a3-d60b-470a-a558-0c3555d1f10b"},{"index":27623,"token":false,"name":"Adamaro, First to Desire","scryfallId":"d2fa85ea-f5d5-4be3-a874-ce246c3e4245"},{"index":27624,"token":false,"name":"Goblin Assassin","scryfallId":"14fb223b-70b9-4bfd-8f7e-1a562cc08f9d"},{"index":27629,"token":false,"name":"Eye of Ramos","scryfallId":"78d22400-39f6-444d-b508-783a7df7e945"},{"index":27631,"token":false,"name":"Goldnight Castigator","scryfallId":"ca3d3c9a-d41b-4743-87a6-68d116460fe2"},{"index":27633,"token":false,"name":"Glorious Enforcer","scryfallId":"de1365aa-e814-471b-8c9e-cf4c5011bcc3"},{"index":27635,"token":false,"name":"Gigantoplasm","scryfallId":"27163b43-61e2-495c-b544-55c349eba99c"},{"index":27641,"token":false,"name":"Distress","scryfallId":"1ebb7ade-ebbb-49fb-b64f-fa247f9a9af6"},{"index":27642,"token":false,"name":"Sokenzan Bruiser","scryfallId":"2d147088-2191-49e8-9c0b-419d4048604a"},{"index":27643,"token":false,"name":"Vanguard of Brimaz","scryfallId":"892e59df-95ea-490a-8207-ef735faed307"},{"index":27644,"token":false,"name":"Sorin, Imperious Bloodlord","scryfallId":"9f764be3-dd3f-44b1-a4a6-807d1387590b"},{"index":27648,"token":false,"name":"Hollow Dogs","scryfallId":"ecbecdc8-7140-4485-85d9-86e6e4fbed14"},{"index":27656,"token":false,"name":"Crested Craghorn","scryfallId":"aadb40c8-3d54-4705-82dc-54e8d6e315d5"},{"index":27657,"token":false,"name":"Zhang Liao, Hero of Hefei","scryfallId":"8f42a953-3073-4e74-9bb8-c8c5a45d1dfa"},{"index":27660,"token":false,"name":"Orochi Ranger","scryfallId":"e8dc216f-4447-4370-b31a-18304507669b"},{"index":27668,"token":false,"name":"Spark Spray","scryfallId":"f60d8716-4297-484c-8e02-c30ce2773a65"},{"index":27675,"token":false,"name":"Exert Influence","scryfallId":"c35e9d13-ee4b-42f1-a154-18ab32947ad3"},{"index":27679,"token":true,"name":"Resilient Khenra Token (B, 4/4)","scryfallId":"c1326c5d-b5a5-4942-b15d-37830ac62c7d"},{"index":27682,"token":false,"name":"Throttle","scryfallId":"b6b71c00-3f38-47dc-90bc-6464d346c098"},{"index":27683,"token":false,"name":"Liliana, Death Mage","scryfallId":"921e3dc3-f8eb-4498-a6a8-b424952230cd"},{"index":27690,"token":false,"name":"Goatnapper","scryfallId":"78f32852-2a18-453d-910a-829c3a2b5b1b"},{"index":27692,"token":false,"name":"Bloodstone Goblin","scryfallId":"31adbfd4-56aa-4137-aeba-8720233260be"},{"index":27693,"token":false,"name":"Sharpened Pitchfork","scryfallId":"4ce20f19-a159-40e6-bb67-6108872ac1e0"},{"index":27694,"token":false,"name":"Recoil","scryfallId":"225f700c-fdf6-41ea-a091-36b0f75f0211"},{"index":27696,"token":false,"name":"Choking Fumes","scryfallId":"1b9af543-5273-4754-ab7d-75d0b632240f"},{"index":27697,"token":false,"name":"Wall of Hope","scryfallId":"b463b3e1-e314-4a65-a89e-0712f630b016"},{"index":27700,"token":false,"name":"Sandstorm Charger","scryfallId":"9757be26-4480-43b7-a38a-8e4bde4e2d50"},{"index":27701,"token":false,"name":"Claws of Gix","scryfallId":"78372366-8c4c-46ac-bd7c-a735c2b24b5d"},{"index":27702,"token":false,"name":"Akim, the Soaring Wind","scryfallId":"23736c5f-bd1c-4505-8639-5fb92cd74b21"},{"index":27713,"token":false,"name":"Energy Tap","scryfallId":"9f67692d-9df6-4841-a36b-26c28110b63b"},{"index":27718,"token":false,"name":"Ring of Three Wishes","scryfallId":"219ab03a-2b3b-4eef-8a42-2cbe793d2f33"},{"index":27723,"token":false,"name":"Whisk Away","scryfallId":"5b5d96a9-11dd-44cc-baf1-bab298ae03f0"},{"index":27724,"token":false,"name":"Wildwood Scourge","scryfallId":"46ff0b33-d153-4b0e-ac48-7e5ed70dea09"},{"index":27727,"token":false,"name":"Giant Octopus","scryfallId":"a391d681-3530-4f6a-b421-12025e7c3b89"},{"index":27731,"token":false,"name":"Frondland Felidar","scryfallId":"c6facdf4-1f06-499e-b752-b640b016f282"},{"index":27733,"token":false,"name":"Goblin War Party","scryfallId":"2b4155d1-0a87-4d2c-a1a0-06b2553eaae4"},{"index":27735,"token":false,"name":"Tithe Taker","scryfallId":"4d7969a1-afae-4076-bb1f-fb52014badea"},{"index":27737,"token":false,"name":"Blood-Chin Rager","scryfallId":"e8e93684-a587-4510-b48b-ecf27ff695f4"},{"index":27739,"token":false,"name":"Talara's Bane","scryfallId":"bd68e4c4-0216-4f58-a3ce-3432ab5830c6"},{"index":27740,"token":false,"name":"Celestial Force","scryfallId":"0d51a3f0-2546-43c1-9a92-625997a24e9b"},{"index":27745,"token":false,"name":"Undead Gladiator","scryfallId":"3bad2f48-9aa9-4f38-a22f-9b4802d0ee7f"},{"index":27746,"token":false,"name":"Haazda Exonerator","scryfallId":"87ca97f2-cf38-4d68-80a9-f4e890271e5c"},{"index":27752,"token":false,"name":"Advanced Hoverguard","scryfallId":"7384d50a-5801-47ed-ab9f-5c7e4f1f20dd"},{"index":27755,"token":false,"name":"Daring Apprentice","scryfallId":"0344006b-990e-46a0-a6d4-ace88af66b46"},{"index":27758,"token":false,"name":"Monoskelion","scryfallId":"4736aae2-5136-4f8f-9283-baf6b542a6a8"},{"index":27761,"token":false,"name":"Skinthinner","scryfallId":"e0c9b43c-e544-47eb-98f5-45d1b57aabb4"},{"index":27762,"token":false,"name":"Wrath of Marit Lage","scryfallId":"1d512f5c-0327-4d49-8a26-672574a49102"},{"index":27766,"token":false,"name":"Elderfang Ritualist","scryfallId":"57348f93-8764-4b1a-b02e-4e7881337fa2"},{"index":27768,"token":false,"name":"Gravel-Hide Goblin","scryfallId":"4942068c-ffde-4a6b-849e-8acf05e1d2e1"},{"index":27769,"token":false,"name":"Odds // Ends","scryfallId":"6d3ff7fb-b781-4d5f-b989-3ca24066095f"},{"index":27770,"token":false,"name":"Chrome Courier","scryfallId":"a11d8da1-a183-470a-b4ed-2e35ac5ab9a9"},{"index":27775,"token":false,"name":"Chatterfang, Squirrel General","scryfallId":"1785cf85-1ac0-4246-9b89-1a8221a8e1b2"},{"index":27782,"token":false,"name":"God-Eternal Bontu","scryfallId":"3714a135-e2b9-43a7-a2a2-fa5a2e0ac61a"},{"index":27786,"token":false,"name":"Blazing Volley","scryfallId":"3adc0288-acdf-4a99-9bfb-919cae1aeb69"},{"index":27789,"token":false,"name":"Veilborn Ghoul","scryfallId":"d3f49232-2853-427f-8c20-322e09a3ccde"},{"index":27796,"token":false,"name":"Archon of Valor's Reach","scryfallId":"c43f47e3-ebb8-4d6e-a00c-4c190e2d3daf"},{"index":27807,"token":false,"name":"Bloodhall Ooze","scryfallId":"e8b7208e-aa64-43fa-b7f8-8d40d7005358"},{"index":27812,"token":false,"name":"Grotag Bug-Catcher","scryfallId":"5b310b01-f9cb-48ce-8af3-5957d3abf098"},{"index":27825,"token":false,"name":"Spire Phantasm","scryfallId":"2b6b39d3-b98f-4e52-bf67-a0782b175f55"},{"index":27829,"token":false,"name":"Aminatou's Augury","scryfallId":"488a7bbd-b2e3-43d8-8f37-d8c2ddd320f3"},{"index":27835,"token":false,"name":"Unyaro Bees","scryfallId":"76356bc9-2285-44a7-815e-a27ad4e07afc"},{"index":27839,"token":false,"name":"Murder Investigation","scryfallId":"07d8d6f7-ed22-4e01-9aeb-c6bc0065c89c"},{"index":27843,"token":false,"name":"Demonic Consultation","scryfallId":"8d727b9b-6114-414d-9172-16b6e1db41cc"},{"index":27846,"token":false,"name":"Disruptive Student","scryfallId":"6a50779d-f5c8-4df1-8625-7edc8bb0251c"},{"index":27849,"token":false,"name":"Fracturing Gust","scryfallId":"cf9d6522-567d-4357-a5de-25eaf8e9cac3"},{"index":27853,"token":false,"name":"Heap Doll","scryfallId":"86d726e1-a363-4d77-97d4-e8c94f93fd51"},{"index":27854,"token":false,"name":"Thought Hemorrhage","scryfallId":"b2b38a7e-d7c4-40c2-ba54-ae5649589cc9"},{"index":27855,"token":false,"name":"Lagonna-Band Trailblazer","scryfallId":"38a6f533-6acb-4c24-ae9d-fe4977230156"},{"index":27858,"token":false,"name":"Citywatch Sphinx","scryfallId":"9b809f89-13c7-4236-86a5-60745defb271"},{"index":27861,"token":false,"name":"Knight of Dawn","scryfallId":"cadc628a-7d7e-4111-b0dc-6f973d7ed3ca"},{"index":27864,"token":false,"name":"Bludgeon Brawl","scryfallId":"a30fa96d-64d1-423e-a62e-d43453ea838d"},{"index":27866,"token":false,"name":"Coral Net","scryfallId":"abe9cf1e-d398-41e0-8b11-afe1015e4fd9"},{"index":27869,"token":false,"name":"Pedantic Learning","scryfallId":"67445332-0b56-4fec-8dcd-bb9a87194db5"},{"index":27878,"token":false,"name":"Heart-Piercer Manticore","scryfallId":"a4acf2a5-729d-4d80-8e0f-bd6e6de7527f"},{"index":27884,"token":false,"name":"Pledge of Loyalty","scryfallId":"d6f98c26-5b30-400c-8af1-8c6c43065f63"},{"index":27888,"token":false,"name":"Realms Uncharted","scryfallId":"8967ceff-9e25-46da-926b-e05f4ee98325"},{"index":27890,"token":false,"name":"Gruul Cluestone","scryfallId":"bc47d1fe-8ab2-42f6-bcab-4bc2084ceba7"},{"index":27891,"token":false,"name":"Grimgrin, Corpse-Born","scryfallId":"f3b7c90e-888c-4447-b4be-40b3a8c42a2d"},{"index":27892,"token":false,"name":"Triclopean Sight","scryfallId":"444b5d72-ac5b-43d2-b5dc-0cc4bf63e43d"},{"index":27894,"token":false,"name":"Penumbra Wurm","scryfallId":"de4ce98d-0a19-42c5-9ef9-32408da1d2a1"},{"index":27896,"token":false,"name":"Pulse of the Forge","scryfallId":"ea3ed9c8-b552-4a9a-b77a-8b148638b4f0"},{"index":27897,"token":false,"name":"Woodland Patrol","scryfallId":"7a134bd1-3c5a-467e-bad1-65548b33faa5"},{"index":27898,"token":false,"name":"Goatnap","scryfallId":"709d4928-e976-4c7c-ba09-cce95d1797b2"},{"index":27903,"token":false,"name":"Tropical Storm","scryfallId":"cd5f473c-e11e-4047-91f9-81b80f0a3562"},{"index":27917,"token":false,"name":"Elvish Handservant","scryfallId":"9854f9a9-160c-4c96-b871-0f85914597d0"},{"index":27920,"token":false,"name":"Light of the Legion","scryfallId":"83afa9d3-7a8d-4baa-942e-39fdf7407e47"},{"index":27926,"token":false,"name":"Pyromantic Pilgrim","scryfallId":"f670d02b-9bfc-4671-97ed-59bfbe633d82"},{"index":27929,"token":false,"name":"Second Guess","scryfallId":"0d22d093-8e89-4d54-ac04-14c8759de3ea"},{"index":27931,"token":false,"name":"Desecration Elemental","scryfallId":"829b4406-c066-4cd6-9520-8a7cb3cbfdb2"},{"index":27933,"token":false,"name":"Salvage Scuttler","scryfallId":"480be626-cf37-410d-a9c7-e5464345085f"},{"index":27937,"token":false,"name":"Concealed Courtyard","scryfallId":"8fd4ac43-ac4a-425a-a5dc-53ddc66c241f"},{"index":27941,"token":false,"name":"Lazotep Behemoth","scryfallId":"b4be6f22-e9e8-462a-956b-e1c78bbadacc"},{"index":27946,"token":false,"name":"Dauntless Escort","scryfallId":"a71699b8-9644-4b05-99c8-657442e2df73"},{"index":27948,"token":false,"name":"Nullify","scryfallId":"a940d859-3fb1-4946-8277-b7c503605b1e"},{"index":27954,"token":false,"name":"Drown in Sorrow","scryfallId":"287c7570-8080-43dc-a586-963e15566446"},{"index":27955,"token":false,"name":"Skola Grovedancer","scryfallId":"076ec900-345d-4720-96b6-441bce01618a"},{"index":27957,"token":false,"name":"Phantom Ninja","scryfallId":"a392b557-e809-4371-92d7-6e93caed4f1b"},{"index":27958,"token":false,"name":"The Scorpion God","scryfallId":"bcb59fb1-60be-44fe-a382-0d42031d7ee7"},{"index":27963,"token":false,"name":"Mark of Asylum","scryfallId":"d9801e68-9a03-491f-be23-f0b830c4a0c5"},{"index":27965,"token":false,"name":"Memorial to Unity","scryfallId":"994d903b-0d54-4af4-898f-213e716e9ed4"},{"index":27976,"token":false,"name":"Oyobi, Who Split the Heavens","scryfallId":"313bd276-2f69-447e-a2b1-240cf839614a"},{"index":27979,"token":false,"name":"Craven Hulk","scryfallId":"2be804ab-1024-4eee-b339-48ed8b84d363"},{"index":27980,"token":false,"name":"Empty the Catacombs","scryfallId":"e41cbd0b-9f54-4e8f-9a4b-fed8e435a2e0"},{"index":27981,"token":false,"name":"Duelist's Heritage","scryfallId":"fefef556-dd3c-49b9-a6f5-8b86af64416e"},{"index":27982,"token":false,"name":"Mayael the Anima","scryfallId":"3d2eb803-ccb3-4594-a737-7b8c844b9409"},{"index":27992,"token":false,"name":"Puncture Blast","scryfallId":"3bf90b4d-98cf-4953-b6ae-c41d21ab559b"},{"index":27994,"token":false,"name":"Derelor","scryfallId":"b050783f-945e-4d61-a896-9a5b79ae7982"},{"index":27998,"token":false,"name":"Fallen Shinobi","scryfallId":"900c9dfd-ece1-4b09-a801-0fa05e1994b9"},{"index":28000,"token":false,"name":"Kyren Legate","scryfallId":"6f0e9806-be8c-4b88-a4be-0111d1be81d9"},{"index":28001,"token":false,"name":"Broken Bond","scryfallId":"d76a975d-61d6-4a1f-ae39-528f3648c355"},{"index":28006,"token":false,"name":"Magmasaur","scryfallId":"48115601-fa00-4d33-8205-faac02997bb4"},{"index":28014,"token":false,"name":"Morgue Theft","scryfallId":"937465ca-4cf7-4412-86eb-264efb0fdddd"},{"index":28015,"token":false,"name":"Warren-Scourge Elf","scryfallId":"7ab5fe17-5499-427b-9267-3b3a9676a087"},{"index":28016,"token":false,"name":"Cho-Arrim Legate","scryfallId":"1427a3a1-24e1-4697-b5eb-1c0a24f89e75"},{"index":28019,"token":false,"name":"Dark-Dweller Oracle","scryfallId":"29c7df4b-fc79-4a6f-8f85-677331470e23"},{"index":28021,"token":false,"name":"Daunting Defender","scryfallId":"38737f38-26bd-417c-b6b4-53f26e4e8044"},{"index":28024,"token":false,"name":"Alchemist's Apprentice","scryfallId":"31abba67-1241-4fb3-88b5-4c4668ec5f25"},{"index":28026,"token":true,"name":"Aven Wind Guide Token (W, 2/3)","scryfallId":"a8f339c6-2c0d-4631-849b-44d4360b5131"},{"index":28032,"token":false,"name":"Second Sight","scryfallId":"24a07cdc-8335-45da-9ae2-3052193663ef"},{"index":28040,"token":false,"name":"Shadowbane","scryfallId":"0fbe8fa5-5ca8-43ce-863e-61802126e485"},{"index":28041,"token":false,"name":"Nightguard Patrol","scryfallId":"ff138110-e694-4c8e-a3ff-d9820f3bd8a0"},{"index":28045,"token":false,"name":"Dire Fleet Hoarder","scryfallId":"d6f86b94-2a86-4120-97cd-ec2c89d106cb"},{"index":28060,"token":false,"name":"Breaking Point","scryfallId":"73e348dd-2d8a-4ee6-a834-2d5861566043"},{"index":28062,"token":false,"name":"Respite","scryfallId":"d9b5c747-43d6-4c5f-9ca3-feaf004a88cb"},{"index":28065,"token":false,"name":"Keen-Eyed Archers","scryfallId":"594de429-58ed-4a0c-9631-464cde7a48c3"},{"index":28067,"token":false,"name":"Soul Rend","scryfallId":"7fa084e1-05c2-4691-b9fe-3e3c717e5c9d"},{"index":28068,"token":false,"name":"Deflecting Palm","scryfallId":"c5580886-a402-4048-b8b6-39e19479f491"},{"index":28071,"token":false,"name":"Avenging Druid","scryfallId":"fca9fd31-639a-4fbc-84bd-c3078df29c0a"},{"index":28073,"token":false,"name":"Elderscale Wurm","scryfallId":"20f3f63d-0f04-4945-9895-940c916a2547"},{"index":28074,"token":false,"name":"Verdant Crescendo","scryfallId":"ea890019-f48f-4164-b057-773499ef273f"},{"index":28076,"token":false,"name":"Auspicious Starrix","scryfallId":"f7b41cfa-b22e-4d34-bfe9-68c9d8740704"},{"index":28082,"token":false,"name":"Lathnu Hellion","scryfallId":"be51c18a-048d-4c97-bdf9-d7f85e61c35a"},{"index":28087,"token":false,"name":"Riptide Replicator","scryfallId":"41bb314f-237a-43fc-95c8-b26188dc4476"},{"index":28100,"token":false,"name":"Meteor Blast","scryfallId":"de18b9ff-9847-4347-a02f-391470332f6e"},{"index":28102,"token":false,"name":"Deliver Unto Evil","scryfallId":"5f5c8116-69f1-4b66-91ab-69619e01288e"},{"index":28110,"token":false,"name":"Urborg Elf","scryfallId":"1d8521bf-d026-4d26-831e-a2f253307c93"},{"index":28113,"token":false,"name":"Goblin Instigator","scryfallId":"90cef94d-d941-4e08-afec-a116626b74fb"},{"index":28118,"token":false,"name":"Icefeather Aven","scryfallId":"ecdee089-8e89-4c99-9390-e8f4c189cffb"},{"index":28126,"token":false,"name":"Mycologist","scryfallId":"56d8e9fa-e241-4a11-99b8-ffced81eb38b"},{"index":28129,"token":false,"name":"Dread Specter","scryfallId":"00c48e08-9a77-4ba2-8041-90998f7e3812"},{"index":28130,"token":false,"name":"Ishi-Ishi, Akki Crackshot","scryfallId":"8e94fec2-dc56-4961-ba80-b9c904a345ab"},{"index":28134,"token":false,"name":"Sigil Captain","scryfallId":"f767f262-57fd-4479-b719-189942ddfd9e"},{"index":28137,"token":false,"name":"Arcbound Whelp","scryfallId":"154ed1d3-e24a-48ba-8f7b-be254c08d1cc"},{"index":28140,"token":false,"name":"Stupefying Touch","scryfallId":"6355ae63-3072-4c6f-bf46-ee6e9c4fedba"},{"index":28143,"token":false,"name":"Goblin Glider","scryfallId":"5ad2736f-e48e-49e6-87ec-cfba1d643114"},{"index":28146,"token":false,"name":"Start from Scratch","scryfallId":"55c99486-ae64-4293-81fb-a4b02e8fcae6"},{"index":28147,"token":false,"name":"Airborne Aid","scryfallId":"0aaa43b0-601f-4b99-a328-541b04d5696d"},{"index":28151,"token":false,"name":"Deadeye Quartermaster","scryfallId":"5ba70d58-69fd-4675-85d2-90bc2595c01c"},{"index":28153,"token":false,"name":"Auriok Siege Sled","scryfallId":"7d3808b1-41df-467a-9779-70bbdfbefa6f"},{"index":28156,"token":true,"name":"Jakub Šlemr Bio","scryfallId":"fb38f4dd-b0ce-4613-a876-764897d29923"},{"index":28162,"token":false,"name":"Public Execution","scryfallId":"2503fe09-5b18-4bff-9431-1de4c161cafe"},{"index":28177,"token":false,"name":"Rending Volley","scryfallId":"8234090e-9df1-4915-90ef-8a4bc6212655"},{"index":28178,"token":false,"name":"Wolfkin Bond","scryfallId":"2c419a2b-4389-49bc-91f1-a613ffcbfa0b"},{"index":28179,"token":false,"name":"Laquatus's Creativity","scryfallId":"dcd48c28-bfa3-4eca-8e1a-f72d785b2ab9"},{"index":28181,"token":false,"name":"Undertaker","scryfallId":"e99bb258-7b05-4c70-8a67-d7a5709a60ff"},{"index":28186,"token":false,"name":"Cogwork Assembler","scryfallId":"6dddacdd-bbc4-4f9b-be1c-5f2c64be3cbc"},{"index":28187,"token":false,"name":"Tide Drifter","scryfallId":"4c590579-e0ef-4839-8f67-f52813cd9fe7"},{"index":28201,"token":false,"name":"Cultivator Drone","scryfallId":"bbe4bb6f-bec6-49d2-99d7-e3750a0ea03f"},{"index":28204,"token":false,"name":"Razorfin Abolisher","scryfallId":"ed978036-c473-46d8-8302-3707d222aff5"},{"index":28205,"token":false,"name":"Phyrexian Dreadnought","scryfallId":"7b8197b9-0cd1-4fa1-9668-d1b5f1759151"},{"index":28208,"token":false,"name":"Cerulean Wyvern","scryfallId":"5c599f95-c0dd-4dd8-a8d7-9481df0cf649"},{"index":28210,"token":false,"name":"Shivan Oasis","scryfallId":"9841f7e8-162c-44a3-96f3-af944fce15d1"},{"index":28212,"token":false,"name":"Aether Tunnel","scryfallId":"5d6178ed-6353-4733-81e1-7b3dc592c3bd"},{"index":28214,"token":false,"name":"Sightless Ghoul","scryfallId":"018bd4ae-cdea-410d-9ce6-6a70f12de966"},{"index":28215,"token":false,"name":"Army of Allah","scryfallId":"9899352a-a4c9-47bf-b9cb-0c34060ae1c4"},{"index":28218,"token":false,"name":"Baloth Pup","scryfallId":"3f9c87f4-4fa5-4c97-9654-c4acd250f850"},{"index":28223,"token":false,"name":"Stir the Pride","scryfallId":"38fc57c6-d54a-4d77-afa2-ff2b90219526"},{"index":28227,"token":true,"name":"Spirits","scryfallId":"3c449d13-95d8-49b2-af7c-30a0a2aeaed3"},{"index":28230,"token":false,"name":"Essence Capture","scryfallId":"ce137910-0f0e-4f94-9b95-6e0eeeba164e"},{"index":28231,"token":false,"name":"Qarsi Deceiver","scryfallId":"64d64264-895f-4d4d-8e5c-ab1d0d6e340b"},{"index":28232,"token":false,"name":"Anax and Cymede","scryfallId":"63cb977e-bd42-43b1-83d1-124e7a413aca"},{"index":28236,"token":false,"name":"Oriss, Samite Guardian","scryfallId":"7a9a3aeb-a316-4b1e-927b-36c3f999f2c3"},{"index":28243,"token":false,"name":"Archdemon of Paliano","scryfallId":"632122b0-6525-4b41-840f-4fd5bea2f0ea"},{"index":28245,"token":false,"name":"Gift of the Woods","scryfallId":"da48976b-667d-4a1e-92de-9c3cb25dfd21"},{"index":28246,"token":false,"name":"Heliod, God of the Sun","scryfallId":"e90d01c9-e76e-42ff-b0fa-8b6786242aae"},{"index":28250,"token":false,"name":"Clergy of the Holy Nimbus","scryfallId":"db1f578f-fa3b-4447-953b-1490852b6c80"},{"index":28251,"token":false,"name":"Duskrider Peregrine","scryfallId":"bfad8c3e-e459-477c-b602-34df2dda1efe"},{"index":28252,"token":false,"name":"Border Guard","scryfallId":"985af775-2036-459d-83c6-31ac84a0ffb1"},{"index":28253,"token":false,"name":"Nightshade Peddler","scryfallId":"4d3de66c-2283-458f-9d0d-943027520aa2"},{"index":28259,"token":false,"name":"Cutthroat il-Dal","scryfallId":"192bc089-696d-41b4-a02f-d7dc166feedd"},{"index":28260,"token":false,"name":"Geralf's Messenger","scryfallId":"bffaad78-97ff-431f-bfb0-e96c7558f974"},{"index":28263,"token":false,"name":"Stonework Puma","scryfallId":"35155ed9-35f4-4b20-8885-c72b8372fa1d"},{"index":28267,"token":false,"name":"Excavation Technique","scryfallId":"38435284-52f8-45e6-a6f2-595eb974886e"},{"index":28273,"token":false,"name":"Shard of Broken Glass","scryfallId":"7a4924d7-f787-474b-beca-3b369903485c"},{"index":28275,"token":false,"name":"Phytohydra","scryfallId":"86c336d2-cc14-4b74-a6f9-aab7a084d0de"},{"index":28278,"token":false,"name":"Ramunap Hydra","scryfallId":"9e63321b-8fc5-4681-83b2-d3e5f6352912"},{"index":28279,"token":false,"name":"Deathgorge Scavenger","scryfallId":"ea339676-f51c-4d0b-990b-e3d2d5a968b3"},{"index":28283,"token":false,"name":"Vampiric Dragon","scryfallId":"4f21d595-c248-4aae-9fd7-4e5787ab8781"},{"index":28285,"token":false,"name":"Lightning Shrieker","scryfallId":"0071bf6e-a78b-4286-b3e7-acf44631a001"},{"index":28287,"token":false,"name":"Runewing","scryfallId":"749961e6-b135-4629-ae9d-124de0d70db9"},{"index":28288,"token":false,"name":"Grave Defiler","scryfallId":"f8f76edc-6067-43bd-9582-1d59caf91597"},{"index":28291,"token":false,"name":"Sphinx's Decree","scryfallId":"8c9daefa-3716-4391-b95c-fc6f2abea56d"},{"index":28292,"token":false,"name":"Omen of Fire","scryfallId":"9c724b46-6e17-4bee-9bc6-e9fc5a379dd7"},{"index":28294,"token":false,"name":"Aleatory","scryfallId":"7380af0a-8a8f-44fd-9456-14a68a2830d3"},{"index":28299,"token":false,"name":"Oaken Brawler","scryfallId":"e9fdb060-8f4d-453a-9516-92c390fbc85a"},{"index":28303,"token":false,"name":"Lion's Eye Diamond","scryfallId":"433f5a5e-5977-453e-ba72-ffa0462ba17d"},{"index":28304,"token":false,"name":"Merrow Bonegnawer","scryfallId":"09e49aa4-ac23-49b1-b9b7-49d45b56b21d"},{"index":28305,"token":false,"name":"Bribery","scryfallId":"e0b099ef-4b43-4b63-a7fc-cec19cf29f4e"},{"index":28308,"token":false,"name":"Valiant Knight","scryfallId":"6ad750bc-850b-483b-8910-eb6562f925bc"},{"index":28310,"token":false,"name":"Spring Cleaning","scryfallId":"dc20ef13-e97f-454c-8295-7bb8a7c4e4be"},{"index":28311,"token":false,"name":"Wretched Confluence","scryfallId":"bd9e38ad-389e-4178-9c8a-5ca89c1a2f73"},{"index":28314,"token":false,"name":"Krovikan Whispers","scryfallId":"e9ac2469-db92-44e4-8930-96f2c40c60f1"},{"index":28316,"token":false,"name":"Hail of Arrows","scryfallId":"c4a57083-e82c-41aa-94b9-2e6db97f7159"},{"index":28318,"token":false,"name":"Avatar of the Resolute","scryfallId":"7bf18a2f-f93e-4a18-92d5-c9d2cca276d7"},{"index":28323,"token":false,"name":"Seraph","scryfallId":"f2de654e-ee5c-4ae6-bd4c-c564ed6a5e83"},{"index":28324,"token":false,"name":"Erratic Visionary","scryfallId":"40dfe354-d527-4f56-8457-b95884700a40"},{"index":28325,"token":true,"name":"Insect Token (B/G, 1/1)","scryfallId":"03ce1033-ce07-40ef-9315-beb759af9465"},{"index":28326,"token":false,"name":"Psychic Barrier","scryfallId":"1cba7d67-5c6c-4738-8907-7cce503e3180"},{"index":28333,"token":false,"name":"Precognition","scryfallId":"76a0e317-5a76-4eac-a903-b0e3f0a45873"},{"index":28336,"token":false,"name":"Souldrinker","scryfallId":"07d2d0ff-e44e-427a-9d68-3ed2d51b1b86"},{"index":28338,"token":false,"name":"Mistford River Turtle","scryfallId":"0c78c386-c64b-4fab-a718-f18b46360e20"},{"index":28341,"token":false,"name":"Spiteful Motives","scryfallId":"592d7349-d066-49b0-9920-c1ec1595e00d"},{"index":28342,"token":false,"name":"Star-Crowned Stag","scryfallId":"2707adf1-2eea-4822-bd62-79105c963af2"},{"index":28345,"token":false,"name":"Avian Oddity","scryfallId":"f325873b-97de-4701-910f-ec5cdb66de33"},{"index":28348,"token":false,"name":"Obzedat, Ghost Council","scryfallId":"4029c3a0-a999-453a-a838-7adb81e481ee"},{"index":28349,"token":false,"name":"Towering Baloth","scryfallId":"2a8cc948-28ff-4bbe-b8c9-71de37478023"},{"index":28350,"token":false,"name":"Radiant's Dragoons","scryfallId":"8a0f39de-6ad2-410c-bc6c-75fd3c8d159b"},{"index":28354,"token":false,"name":"Hibernation Sliver","scryfallId":"747d69d4-a7d4-4d6d-8f12-2366655c15d9"},{"index":28355,"token":false,"name":"Stronghold Gambit","scryfallId":"0d18050e-9aad-471e-a6ae-66e5fa2bbb6f"},{"index":28357,"token":false,"name":"Captain of the Mists","scryfallId":"aa959355-ffac-442c-9c59-b2a654b4b400"},{"index":28363,"token":false,"name":"Lore Broker","scryfallId":"c7935b2b-aebe-44b3-b91b-52978bb4ded5"},{"index":28364,"token":false,"name":"Cephalid Broker","scryfallId":"b1d2cfe5-b905-4d8a-89e4-474619e2796c"},{"index":28367,"token":false,"name":"Thran Weaponry","scryfallId":"60f005ae-fca1-4a48-84a3-4b217ac879ce"},{"index":28370,"token":false,"name":"Sagittars' Volley","scryfallId":"d3104cad-e684-4bd7-b26b-5aa862f7a2b3"},{"index":28375,"token":false,"name":"Thirst","scryfallId":"12630ac5-a6c4-4852-abd9-5a0bc71bbf83"},{"index":28377,"token":false,"name":"Renegade Freighter","scryfallId":"7a10e2c3-0132-4eb2-94f0-5915caca2a17"},{"index":28380,"token":false,"name":"Nantuko Blightcutter","scryfallId":"42a6f1b6-e1ed-497a-b50e-1bfa257c18c0"},{"index":28382,"token":false,"name":"Divine Light","scryfallId":"8f596ce1-b754-4e34-98e3-e1ddda2fd9b0"},{"index":28389,"token":false,"name":"Spiteful Prankster","scryfallId":"d59ee7a6-3dfa-44c7-8f00-0183137c4d31"},{"index":28397,"token":false,"name":"Moonmist","scryfallId":"57153c3f-9e55-418c-b67b-36901f29f9c1"},{"index":28402,"token":false,"name":"Launch Party","scryfallId":"a49b95d9-2b64-4f33-97b1-db350026aa95"},{"index":28406,"token":false,"name":"Inkfathom Infiltrator","scryfallId":"28854f0f-48d3-4a54-8811-c6329ad2e88e"},{"index":28409,"token":false,"name":"Elixir of Vitality","scryfallId":"60450239-6055-4561-9f8c-565b4e4d9cb1"},{"index":28411,"token":false,"name":"Ashes of the Fallen","scryfallId":"d59df09f-d8b9-4398-a705-329b768d5004"},{"index":28412,"token":false,"name":"Search the Premises","scryfallId":"d0345668-0cc1-41d2-8e4f-de7726fd0365"},{"index":28413,"token":false,"name":"Ixalan's Binding","scryfallId":"5f3c8c31-ceb8-4a2c-beb6-0ff5f7b6ae07"},{"index":28418,"token":false,"name":"Deep-Slumber Titan","scryfallId":"cbe3a68e-c29e-48a8-a2d7-49c8bff3dd8a"},{"index":28428,"token":false,"name":"Grotesque Demise","scryfallId":"b698c5e1-3816-4f35-8e39-65dc68f5c64f"},{"index":28429,"token":false,"name":"Aboroth","scryfallId":"8c72ac67-e4fb-49a1-b1e5-cd2e414bec28"},{"index":28430,"token":false,"name":"Primalcrux","scryfallId":"1f805f7b-bb7e-436b-abd3-20a35e7ef71e"},{"index":28433,"token":false,"name":"Ashiok's Skulker","scryfallId":"7dd5b0a1-104d-4e0f-82de-65487fbf01ff"},{"index":28439,"token":false,"name":"Tamiyo's Journal","scryfallId":"f644fa1d-9d53-4620-8d22-7d3ed5c4ec2a"},{"index":28440,"token":false,"name":"Biting Rain","scryfallId":"5ac62d2f-6834-4d98-b69d-bd7b5831d981"},{"index":28443,"token":false,"name":"Loyal Unicorn","scryfallId":"7d2fb006-3376-4322-8473-69de9b745412"},{"index":28444,"token":false,"name":"Frozen Solid","scryfallId":"9b89b98d-0245-4b64-b835-d101ce2bd3fa"},{"index":28445,"token":false,"name":"Samite Censer-Bearer","scryfallId":"7de6aeea-0144-4148-b7a6-47b703f64af9"},{"index":28447,"token":false,"name":"Mana Reflection","scryfallId":"1fcf02eb-2aaa-4c22-a3b3-f57019664118"},{"index":28448,"token":false,"name":"Take Possession","scryfallId":"78366049-4613-4cd1-aab0-308996926563"},{"index":28455,"token":false,"name":"Attrition","scryfallId":"e3eb615b-249d-433f-a521-8310e8784b5d"},{"index":28456,"token":false,"name":"Synchronous Sliver","scryfallId":"c02fa57b-4b7f-46e1-b2b5-6b1a9e9d1643"},{"index":28463,"token":false,"name":"Play of the Game","scryfallId":"85b09595-0d81-4cc0-872f-9a6fb539298b"},{"index":28464,"token":false,"name":"Kavu Scout","scryfallId":"cbc2670d-a3f4-47c2-b424-01fd379ff186"},{"index":28465,"token":false,"name":"Scrounge","scryfallId":"1a30f99a-b295-45a2-bff7-479cbe7541a5"},{"index":28470,"token":false,"name":"Squee, Goblin Nabob","scryfallId":"2bca6f8b-6e6a-43dd-b6a4-9eedfcc24281"},{"index":28471,"token":false,"name":"Flameshot","scryfallId":"3f7b61a8-a1ff-4e2a-bc24-8990c61a5e5b"},{"index":28473,"token":false,"name":"Uyo, Silent Prophet","scryfallId":"50840915-545b-4de2-94bb-22a0b1e0dc7a"},{"index":28474,"token":false,"name":"Bogardan Firefiend","scryfallId":"6517a2ed-adbc-4f73-9bd9-dde739f3a3bd"},{"index":28477,"token":false,"name":"Multani's Presence","scryfallId":"38bfa984-5fe9-44ad-b13f-3276951f9f10"},{"index":28479,"token":false,"name":"Embodiment of Spring","scryfallId":"12444831-04de-432f-9dd1-dc3e99a388a3"},{"index":28482,"token":false,"name":"Kalamax, the Stormsire","scryfallId":"979e237b-2b38-41c9-ab4d-3f3926dfdd82"},{"index":28487,"token":false,"name":"Broken Wings","scryfallId":"c0fc2dfd-85b0-4add-be18-b39549235921"},{"index":28490,"token":false,"name":"Arbor Colossus","scryfallId":"dfbd7c65-ebe5-47a6-8d2f-9a8c63a30a7b"},{"index":28496,"token":false,"name":"Fighting Drake","scryfallId":"99c0a102-b31c-4cbd-894b-44b1c1e677d2"},{"index":28506,"token":false,"name":"Kardur's Vicious Return","scryfallId":"233e4774-e701-42d9-aa25-e7e06c14e43d"},{"index":28510,"token":false,"name":"Hedron Scrabbler","scryfallId":"6422e062-0ce1-4239-8c2d-06449627a55a"},{"index":28513,"token":false,"name":"Seton, Krosan Protector","scryfallId":"641a3bae-9146-4e70-862a-86a56f7c3816"},{"index":28517,"token":false,"name":"Silverclaw Griffin","scryfallId":"54528722-a6aa-4567-9cd1-e4a97adec7d0"},{"index":28520,"token":false,"name":"Zulaport Enforcer","scryfallId":"1975d18a-df3f-4c1f-8fde-d11dabbc4adc"},{"index":28521,"token":false,"name":"Balduvian Hydra","scryfallId":"c3a3b37f-daa6-4502-bb12-c72afe3df035"},{"index":28524,"token":false,"name":"Lifegift","scryfallId":"27eaba1c-3137-4419-bf90-eb287a7c736e"},{"index":28525,"token":false,"name":"Leafcrown Dryad","scryfallId":"8202e426-ad91-4d2e-9373-7a829b58fff5"},{"index":28528,"token":false,"name":"Vivien's Crocodile","scryfallId":"7c51c6bd-2ecc-4d92-a406-fcb31e889b45"},{"index":28533,"token":false,"name":"Dying Wish","scryfallId":"b46e83d3-c66d-42fb-8435-b6c448db01ae"},{"index":28534,"token":false,"name":"Dread Slag","scryfallId":"e3cdad60-3a73-49ac-bbbd-679254b6ba9e"},{"index":28541,"token":false,"name":"Magma Mine","scryfallId":"1aecc3df-7ce6-419c-b3d6-60fc28bfe941"},{"index":28546,"token":false,"name":"Salvage","scryfallId":"f135a2a0-d496-45c4-b89c-52e2506a28a9"},{"index":28550,"token":false,"name":"Skyshroud Archer","scryfallId":"485aeabb-4a9b-4d88-80ad-83e31da6804b"},{"index":28553,"token":false,"name":"Venerable Kumo","scryfallId":"308566ed-18cc-4e3b-b5ab-d5b17795f2f1"},{"index":28554,"token":false,"name":"Talisman of Hierarchy","scryfallId":"826f99c7-f534-4183-8f0d-efe1609808ac"},{"index":28556,"token":false,"name":"War Behemoth","scryfallId":"99c081c6-6d66-4dbb-9e0c-a7232cdc07ac"},{"index":28559,"token":false,"name":"Sapling of Colfenor","scryfallId":"33c19062-9e1c-4cae-bb97-7ca9e4523593"},{"index":28560,"token":false,"name":"Martyr's Soul","scryfallId":"7c17428c-e31d-42f3-8811-6734abd96b0b"},{"index":28561,"token":false,"name":"Mastermind's Acquisition","scryfallId":"84ce5147-c418-4b11-8a78-46bd0bdced8d"},{"index":28562,"token":false,"name":"Spike Jester","scryfallId":"cec50499-70d4-4dc1-9cae-abbecfc8e87d"},{"index":28569,"token":false,"name":"Hope Against Hope","scryfallId":"a6f7c6f5-159a-40ed-823a-8740a1ce373e"},{"index":28570,"token":false,"name":"Necrotic Fumes","scryfallId":"5e1b68a4-fb8d-4b59-b049-73505296f775"},{"index":28571,"token":true,"name":"Wurm // Saproling Token (G, 1/1)","scryfallId":"d0c052ed-c761-4f1d-816b-092cdd6cb0fa"},{"index":28583,"token":false,"name":"Oxidda Daredevil","scryfallId":"4b0bde7b-dc2d-45d2-b124-69b4b51ef3d9"},{"index":28593,"token":false,"name":"Riptide Shapeshifter","scryfallId":"85be34ac-7bc2-4da2-8d9c-2412b9946073"},{"index":28594,"token":false,"name":"Cloudskate","scryfallId":"e7f97e50-3aeb-4c79-81b1-505a2f32d8ac"},{"index":28596,"token":false,"name":"Circle of Solace","scryfallId":"07f567dc-8a60-40e1-b947-199872d8df08"},{"index":28597,"token":false,"name":"Subtle Strike","scryfallId":"0d3f531a-ce45-4cba-be24-6db749e38abd"},{"index":28598,"token":false,"name":"Tivadar of Thorn","scryfallId":"f34d3a74-496e-462d-afa6-370dc2b8347d"},{"index":28599,"token":false,"name":"North Star","scryfallId":"daac2a6b-27c8-4567-9e0c-7b262628d331"},{"index":28606,"token":false,"name":"Dematerialize","scryfallId":"04217c17-7c29-4b02-b9b6-bfa1df50d4bc"},{"index":28611,"token":false,"name":"Locthwain Gargoyle","scryfallId":"02551bee-335c-4bf7-b38e-67dd71d1d567"},{"index":28614,"token":false,"name":"Temporal Cascade","scryfallId":"daf180c6-7ab6-4922-9f5e-73b4f2c9488a"},{"index":28625,"token":false,"name":"Slimy Kavu","scryfallId":"8e82044d-88cd-4ee4-8ec9-e71a0a85ed46"},{"index":28628,"token":false,"name":"Welkin Hawk","scryfallId":"8166253c-c6ac-4b5e-9746-09ce3774c66b"},{"index":28630,"token":false,"name":"Imps' Taunt","scryfallId":"79d6ed64-9f5c-4233-85a9-028b8e5949c3"},{"index":28632,"token":false,"name":"Somnomancer","scryfallId":"eaf51122-fd7c-40b5-b759-65e21c28e3d6"},{"index":28633,"token":true,"name":"Mark Le Pine Bio","scryfallId":"3a959416-27be-4c92-ac4b-0404529ca978"},{"index":28634,"token":false,"name":"Lifespinner","scryfallId":"c6a83083-f7c6-4ddf-aee9-538a1778697d"},{"index":28644,"token":false,"name":"Lost Soul","scryfallId":"43694d4a-e855-462e-9065-6b584a4229e5"},{"index":28650,"token":false,"name":"Dragonlord Kolaghan","scryfallId":"1cbf8933-32a1-4892-9bdc-89464ed9ce1b"},{"index":28654,"token":false,"name":"Iron Bully","scryfallId":"ded2c66e-402c-4d5c-b987-402679aa914b"},{"index":28655,"token":false,"name":"King's Assassin","scryfallId":"670a3149-54fb-4fd2-bc66-3ee9bcc3519d"},{"index":28659,"token":false,"name":"Wall of Earth","scryfallId":"c12e97c1-ca28-432a-8140-3f08bb4485a3"},{"index":28660,"token":false,"name":"Goldenhide Ox","scryfallId":"d107c72f-483a-4af9-b86f-681669d99c46"},{"index":28665,"token":false,"name":"Talon Trooper","scryfallId":"266a6a0d-5c56-47f5-92d0-f883f1bb7630"},{"index":28669,"token":false,"name":"Drannith Healer","scryfallId":"ff5a821c-eaec-4f69-97c7-8299cdebc2f4"},{"index":28677,"token":false,"name":"Dread Shade","scryfallId":"cdc00740-cef6-4019-85a2-ea02cf9509f5"},{"index":28678,"token":false,"name":"Pilgrim of Virtue","scryfallId":"be58f0dd-3856-4960-83de-06eed78ed703"},{"index":28679,"token":false,"name":"Kami of Twisted Reflection","scryfallId":"8aaf1b2f-933f-4ad3-a816-2797d96ff37f"},{"index":28681,"token":false,"name":"Magnetic Web","scryfallId":"9f3c7309-4efb-49ce-a9cc-a8f7b04c1a15"},{"index":28684,"token":false,"name":"Debt of Loyalty","scryfallId":"d19ed33b-42d4-4a5d-a763-cfb43348769c"},{"index":28688,"token":false,"name":"Lightning Hounds","scryfallId":"9bc1c309-501f-4b7b-a68d-9a907fd7ca09"},{"index":28690,"token":false,"name":"Hanweir Watchkeep // Bane of Hanweir","scryfallId":"2b14ed17-1a35-4c49-ac46-3cad42d46c14"},{"index":28695,"token":false,"name":"Truefire Captain","scryfallId":"6099a230-9298-4649-b257-243af40d0625"},{"index":28696,"token":false,"name":"Trench Wurm","scryfallId":"1b076f85-d1bf-491a-af9d-f35b8e1bd163"},{"index":28698,"token":false,"name":"Serra's Blessing","scryfallId":"2794cca9-3df0-4864-8a98-4de71a2bcf17"},{"index":28700,"token":false,"name":"Clockwork Vorrac","scryfallId":"7e876938-1b8e-44cf-ade2-a42f8acdf24c"},{"index":28703,"token":false,"name":"Slime Molding","scryfallId":"44a439e8-d586-4995-abfc-3dee5c860968"},{"index":28708,"token":false,"name":"Briarberry Cohort","scryfallId":"caf9d87a-533c-4641-9738-e7b98d92b015"},{"index":28709,"token":false,"name":"Nemata, Grove Guardian","scryfallId":"8c6a0ca4-5006-4c9b-91cd-e01d77e4fdc2"},{"index":28710,"token":false,"name":"Artifact Mutation","scryfallId":"ad22e43b-e244-43f2-bb2a-f94b777a4602"},{"index":28715,"token":false,"name":"Sibilant Spirit","scryfallId":"ae32232f-3b75-45a2-bb25-1ff2e0f05bdc"},{"index":28716,"token":false,"name":"Daru Encampment","scryfallId":"12306750-86d6-4f70-820a-365894884e56"},{"index":28719,"token":false,"name":"Energy Arc","scryfallId":"ef7aae6c-199f-486f-9de6-a41dd8b847a3"},{"index":28723,"token":false,"name":"Back for More","scryfallId":"3fc7210c-da23-4cec-9195-4de75587f40f"},{"index":28726,"token":false,"name":"Spell Queller","scryfallId":"cf1320b1-3eac-4c5a-9f75-6fdff3cc2639"},{"index":28727,"token":false,"name":"Improbable Alliance","scryfallId":"eceaa1d6-0d31-4f2d-8ffb-5a4e31712ffa"},{"index":28728,"token":false,"name":"Ajani, Strength of the Pride","scryfallId":"fa0ec90a-9571-4048-be2d-0fd422228146"},{"index":28734,"token":false,"name":"World Queller","scryfallId":"134ff41d-1645-4d3a-94b6-e13a30dedb8e"},{"index":28742,"token":false,"name":"Gloomwidow's Feast","scryfallId":"59b989b4-692c-4ccb-a290-0ff00abacba9"},{"index":28744,"token":false,"name":"Haze of Pollen","scryfallId":"0edab1ed-4c53-4f46-b1a4-e2aa2effbed7"},{"index":28747,"token":false,"name":"Meditation Puzzle","scryfallId":"f31f5c19-9650-4fdc-a316-866eddd29c1a"},{"index":28748,"token":false,"name":"Ogre Shaman","scryfallId":"e5e11a62-7885-4494-b128-938485dea8a5"},{"index":28755,"token":false,"name":"Purraj of Urborg","scryfallId":"4704bf02-c6be-4983-9bc7-a1d464d21b31"},{"index":28760,"token":false,"name":"Strength of Cedars","scryfallId":"85ab46f5-d3e1-403f-92e7-f40de51a3d4d"},{"index":28762,"token":false,"name":"Seraph of Dawn","scryfallId":"5da345bd-8f2b-4966-97f5-c0e4c6cfe3b7"},{"index":28765,"token":false,"name":"Talisman of Curiosity","scryfallId":"fd52688a-39fd-430f-b950-cb56e0004396"},{"index":28766,"token":false,"name":"Gristleback","scryfallId":"b82f763a-c960-4b59-8c77-f3bea7bd8c8b"},{"index":28768,"token":false,"name":"Coralhelm Guide","scryfallId":"0fbfa0fa-da69-4d6b-a722-52856c20f4f0"},{"index":28770,"token":false,"name":"Convalescence","scryfallId":"0fd49a61-42ba-400a-8ca9-9f6058bf85ca"},{"index":28782,"token":false,"name":"Somberwald Stag","scryfallId":"6dbe1270-7300-4408-a4c8-92157a8a076f"},{"index":28783,"token":false,"name":"Cavern Thoctar","scryfallId":"34748acb-7045-42b6-a93f-a3f11a1bc839"},{"index":28788,"token":false,"name":"Baffling End","scryfallId":"208c6f51-3c00-4fc6-8579-8f57444d0e97"},{"index":28795,"token":false,"name":"Moment of Silence","scryfallId":"3f50b5f5-8dac-4785-b1af-a0bd64ce7a92"},{"index":28797,"token":false,"name":"Belligerent Whiptail","scryfallId":"a5b5b7d2-acb8-4aca-b9e7-67e59aeb384b"},{"index":28802,"token":false,"name":"Blessing of Frost","scryfallId":"29f32166-20b9-4e4d-b357-a72e5c923f9a"},{"index":28803,"token":false,"name":"Scour the Laboratory","scryfallId":"4c3247a4-f99a-4fff-a3a1-c3d51ed1a754"},{"index":28804,"token":false,"name":"Nazahn, Revered Bladesmith","scryfallId":"8f21a5b4-1cfa-466b-8a16-a8b11f20b818"},{"index":28805,"token":false,"name":"Price of Glory","scryfallId":"785ccfe1-04f1-4d2e-9e30-2ae3efe7213a"},{"index":28807,"token":false,"name":"Tetsuko Umezawa, Fugitive","scryfallId":"2dda9fa0-46b3-4e42-95d9-5d1d2de51925"},{"index":28808,"token":false,"name":"Flowstone Flood","scryfallId":"8bcda003-6fac-4879-87e6-ec0c115630ba"},{"index":28809,"token":false,"name":"Predatory Nightstalker","scryfallId":"017fdca2-ea9f-4fa7-8bd3-bbcf600f116d"},{"index":28810,"token":false,"name":"Whispering Specter","scryfallId":"bcb1b486-e336-4e88-b635-b6ff18cb4841"},{"index":28811,"token":false,"name":"Pain // Suffering","scryfallId":"81be27d6-e16f-4158-b2b6-66a0f3315327"},{"index":28812,"token":false,"name":"Scrapyard Salvo","scryfallId":"3a4874eb-635b-47f0-bbee-6bd8b26e2f10"},{"index":28820,"token":false,"name":"Spire of Industry","scryfallId":"8331724d-6fab-454a-b06c-b06e499fa552"},{"index":28823,"token":false,"name":"Hero of the Nyxborn","scryfallId":"9854e673-1816-4a76-b9db-bb399ac7489f"},{"index":28831,"token":false,"name":"Druid of Horns","scryfallId":"19ca91ea-dffd-44a9-a54a-c664d83c357b"},{"index":28836,"token":false,"name":"City of Solitude","scryfallId":"be499b81-bb2d-4f1d-9deb-c8bfcdca8e13"},{"index":28840,"token":false,"name":"Rage Nimbus","scryfallId":"7c213b45-d86b-4ced-9ab9-44cd84ad94a4"},{"index":28841,"token":false,"name":"Destiny Spinner","scryfallId":"ba264166-948b-47d4-b302-64476acc1a55"},{"index":28847,"token":false,"name":"Thrash // Threat","scryfallId":"2eefd8c1-96ce-4d7a-8aaf-29c35d634dda"},{"index":28850,"token":false,"name":"Carry Away","scryfallId":"9a17e86f-410e-42d0-8ef8-739ea26da0a7"},{"index":28857,"token":false,"name":"Fissure Vent","scryfallId":"c16cbb92-8d1e-44ec-a66a-57549042de19"},{"index":28858,"token":false,"name":"Sand Silos","scryfallId":"3f6f1fcb-d903-4a31-abab-40488569eef6"},{"index":28861,"token":false,"name":"Fanatic of Xenagos","scryfallId":"babc2e1f-d7cf-42e0-9d1a-4391e74deee5"},{"index":28863,"token":false,"name":"Fairgrounds Warden","scryfallId":"03ade279-31c8-4d2b-970b-440049ed053d"},{"index":28866,"token":false,"name":"Terramorph","scryfallId":"28b08596-f6c7-4366-a4ed-21a11fbc901a"},{"index":28868,"token":false,"name":"Cognivore","scryfallId":"7de76ff6-d065-4db1-b28d-4a4ccb1cc0fa"},{"index":28873,"token":false,"name":"Devilthorn Fox","scryfallId":"57bea4c2-7a15-4f31-938d-c4c906e4ebe7"},{"index":28879,"token":false,"name":"Puffer Extract","scryfallId":"83093cdf-0b12-419c-a748-21acf166e195"},{"index":28884,"token":false,"name":"Ekundu Griffin","scryfallId":"a1eec4ac-7d28-4f76-a1d5-a0a19c142514"},{"index":28885,"token":false,"name":"Skysnare Spider","scryfallId":"f1743227-94fd-44c0-884d-fa269bcfd67d"},{"index":28892,"token":false,"name":"Teremko Griffin","scryfallId":"96267012-24da-43ae-97af-69ca3d7704f8"},{"index":28893,"token":false,"name":"Sage's Row Denizen","scryfallId":"06ad3e3e-176b-48f0-af2f-fa4fc4759775"},{"index":28896,"token":false,"name":"Entangling Trap","scryfallId":"0d1cec6f-5308-4bff-b19a-df9e3325bb06"},{"index":28898,"token":false,"name":"Vantress Paladin","scryfallId":"52dd633f-9a07-47df-adb1-36013fc2f43a"},{"index":28900,"token":false,"name":"Separatist Voidmage","scryfallId":"e5634d1a-ca4b-4528-9e0e-b88f1025d434"},{"index":28901,"token":false,"name":"Septic Rats","scryfallId":"8e7915d9-b941-4675-9a1b-18e579977144"},{"index":28902,"token":false,"name":"Jared Carthalion, True Heir","scryfallId":"6b925277-89e7-4143-8985-46c2fe3aeb9c"},{"index":28904,"token":false,"name":"Ominous Seas","scryfallId":"ce8965f2-756a-4461-a643-db024a11c2de"},{"index":28906,"token":false,"name":"Sculptor of Winter","scryfallId":"9dab2ca2-0039-4eac-a7dc-68756362737d"},{"index":28909,"token":false,"name":"Mausoleum Guard","scryfallId":"2c7b19de-96a6-4590-bfc3-31b0c7b2e25e"},{"index":28914,"token":false,"name":"Blood Speaker","scryfallId":"f218bb94-d5a2-41f6-8bca-b689dcd09a43"},{"index":28916,"token":false,"name":"Dramatic Rescue","scryfallId":"416e6241-72c6-4d6d-b839-d96c35695b9d"},{"index":28920,"token":false,"name":"Icefall","scryfallId":"6cf90fc3-b08b-4261-a194-d6b06fdd59d8"},{"index":28921,"token":false,"name":"Deception","scryfallId":"bdb63768-2d8a-4a74-a312-b981dd462cdc"},{"index":28922,"token":false,"name":"Dreampod Druid","scryfallId":"1e35f72d-a62e-490b-a3b2-a56af22f8ff7"},{"index":28926,"token":false,"name":"Wrenn and Six","scryfallId":"4a706ecf-3277-40e3-871c-4ba4ead16e20"},{"index":28928,"token":false,"name":"Anurid Swarmsnapper","scryfallId":"3636a9f8-d1d7-4452-8a53-788b514fdb97"},{"index":28929,"token":false,"name":"Frankenstein's Monster","scryfallId":"8f99894d-5ece-44f1-acce-474494ae2084"},{"index":28930,"token":false,"name":"Tergrid's Shadow","scryfallId":"417f71d2-d7da-4279-8847-d27c67e9ea9d"},{"index":28931,"token":false,"name":"Mana Vortex","scryfallId":"b9d4d7da-f98a-4622-91b8-3460fe44551a"},{"index":28932,"token":false,"name":"Gruul Locket","scryfallId":"1ec78880-a8ec-4c87-bc3f-e2a79d154884"},{"index":28933,"token":false,"name":"Thumbscrews","scryfallId":"71025a6b-3aed-4943-a907-9584d135f6c0"},{"index":28937,"token":true,"name":"Goblin Warrior Token (G/R, 1/1)","scryfallId":"0f827ad1-4931-404d-a0ff-bff8b98eae42"},{"index":28942,"token":false,"name":"Bedlam Reveler","scryfallId":"526682f2-011c-4cab-9115-ef605489ee01"},{"index":28944,"token":false,"name":"Absorb","scryfallId":"1e8a43c1-42d1-45ef-8a63-4b87775a6e88"},{"index":28949,"token":false,"name":"Tajuru Preserver","scryfallId":"c8d03346-0802-4058-b89e-1b6076963c8e"},{"index":28952,"token":false,"name":"Rhystic Circle","scryfallId":"4a76711e-b508-4bb7-a87c-911a11905af3"},{"index":28954,"token":false,"name":"Reign of Terror","scryfallId":"7bd83049-aec1-4911-bc70-39adba04b174"},{"index":28956,"token":false,"name":"Kor Sky Climber","scryfallId":"54938334-ebad-4dde-82e6-8c854aef4a91"},{"index":28959,"token":false,"name":"Scuttletide","scryfallId":"38e4ce27-aba2-4a3f-8de7-d442323d8be2"},{"index":28966,"token":false,"name":"Journey to Nowhere","scryfallId":"09cfe585-8a55-4b27-89e0-dfb6946fe1f3"},{"index":28967,"token":false,"name":"Muraganda Petroglyphs","scryfallId":"4091524c-569c-4668-b18a-7f869b1169f3"},{"index":28971,"token":false,"name":"Valeron Wardens","scryfallId":"e693a7e7-d95e-4cd8-9524-ca5fc517189a"},{"index":28972,"token":false,"name":"Embargo","scryfallId":"3fca3c65-f20e-4978-bfbb-ee7f9e1d829f"},{"index":28976,"token":false,"name":"Arterial Flow","scryfallId":"13c41212-9f16-48e0-8c4b-985ce331164b"},{"index":28978,"token":false,"name":"Skulltap","scryfallId":"48a90779-008e-401f-9877-be0a935d2ccd"},{"index":28989,"token":false,"name":"Blessed Wind","scryfallId":"3cb624d6-9aec-498c-8df9-6fd025c74487"},{"index":28991,"token":false,"name":"Doom Cannon","scryfallId":"4abde0d7-266b-41bd-ade1-c4d93507eb16"},{"index":28994,"token":false,"name":"Sunblade Elf","scryfallId":"5e9925c5-98d5-4eb9-8aaa-a96b63a5812d"},{"index":28995,"token":false,"name":"Electric Eel","scryfallId":"b8834c18-0e4e-4785-9d15-b33345e3789b"},{"index":28996,"token":false,"name":"Isolated Watchtower","scryfallId":"c86c22bf-8c20-4d9e-85ed-f6870b104984"},{"index":29000,"token":false,"name":"Curse of Disturbance","scryfallId":"80d42b98-62d2-4ca6-8478-36222d709048"},{"index":29006,"token":false,"name":"Mystic Barrier","scryfallId":"ffb70bd4-e876-4242-b5b4-bb7493710f0f"},{"index":29008,"token":false,"name":"Dreadhorde Twins","scryfallId":"82017bf6-352f-4e81-8fd5-c1b0daf05b01"},{"index":29012,"token":false,"name":"Furnace Brood","scryfallId":"0a79c6d9-96f1-434a-89b8-d773aa77ac5e"},{"index":29013,"token":false,"name":"Beckon Apparition","scryfallId":"3bae1a3b-881b-4b10-ac5f-822c809edc36"},{"index":29014,"token":false,"name":"Maulfist Squad","scryfallId":"5e4cd13a-66b6-4c65-a5a0-82f93145d16a"},{"index":29015,"token":false,"name":"Gravebind","scryfallId":"4782fd4f-2474-4d0d-8301-e0b52af93746"},{"index":29020,"token":false,"name":"Spawn of Rix Maadi","scryfallId":"6196e702-7f76-49db-8ee4-bd343359d498"},{"index":29022,"token":true,"name":"Egg Token (G, 0/1)","scryfallId":"bb66de6b-8815-4e6c-a093-18607b003b88"},{"index":29023,"token":false,"name":"Fairgrounds Trumpeter","scryfallId":"65983338-8806-4386-94a6-4670eb853848"},{"index":29024,"token":false,"name":"Vermiculos","scryfallId":"9b68e084-0760-4817-a656-32dc4b094370"},{"index":29025,"token":false,"name":"Rakdos Firewheeler","scryfallId":"d819a944-0b3e-4e26-87da-2417081928e7"},{"index":29028,"token":false,"name":"Dismantling Wave","scryfallId":"9db4c1ec-ddd6-4443-8d93-8628e67aa6bb"},{"index":29029,"token":false,"name":"Rakdos Ragemutt","scryfallId":"bb36840a-3f85-4fca-87ab-379dfce8e542"},{"index":29030,"token":false,"name":"Counterbalance","scryfallId":"3f4a8acd-1d49-4fa7-a88e-83cfe741de89"},{"index":29033,"token":false,"name":"Grenzo's Rebuttal","scryfallId":"1b798ace-18e4-45fb-98ae-69528f7b5a2f"},{"index":29041,"token":false,"name":"Might of Alara","scryfallId":"9514c013-bc11-4cc5-af8c-f82fd4098bcf"},{"index":29043,"token":true,"name":"Strictly Better // Strictly Better (cont'd)","scryfallId":"ef8d4393-0ded-41c2-a6b5-b01d994b32a2"},{"index":29045,"token":false,"name":"Bonebreaker Giant","scryfallId":"cc17e5c1-a6b4-401b-95eb-1c01cd1da570"},{"index":29046,"token":false,"name":"Balshan Beguiler","scryfallId":"5d977da2-4024-4c7b-b557-e89564f8d465"},{"index":29047,"token":false,"name":"Oath of Jace","scryfallId":"e8e7b007-a14b-40b2-9de7-38545c50a073"},{"index":29050,"token":false,"name":"Joraga Bard","scryfallId":"b903472f-bd9b-4d7e-9820-34b7dd601ecb"},{"index":29052,"token":false,"name":"Hinterland Hermit // Hinterland Scourge","scryfallId":"b6edac85-78e7-4e90-b538-b67c88bb5c62"},{"index":29062,"token":false,"name":"Meteorite","scryfallId":"ec3a2c95-4e7a-43c5-90bd-6f1de7c82a5c"},{"index":29063,"token":false,"name":"Havengul Skaab","scryfallId":"4c7ff97f-fb06-4a61-98cd-50965a6522d4"},{"index":29064,"token":true,"name":"Glyph Keeper Token (W, 5/3)","scryfallId":"e3d97a02-9187-4dbc-a511-2a15ca840cda"},{"index":29066,"token":false,"name":"Lesser Werewolf","scryfallId":"baae02e4-7db9-4a7b-a4ee-ecb22fcb77bd"},{"index":29072,"token":false,"name":"Dwarven Reinforcements","scryfallId":"40bcc7cb-65dd-4bc6-8606-a162fa6c65f7"},{"index":29074,"token":false,"name":"Wolfcaller's Howl","scryfallId":"47f3f7bc-1dea-4c84-88b6-a36b23af82ff"},{"index":29077,"token":false,"name":"Huntmaster of the Fells // Ravager of the Fells","scryfallId":"4d553078-afaf-42db-879b-fb4cb4d25742"},{"index":29080,"token":false,"name":"Ongoing Investigation","scryfallId":"19b8f962-8d4e-4dd8-a157-c0a55f9e152a"},{"index":29082,"token":false,"name":"Reap and Sow","scryfallId":"ff6c4ae7-8509-47a2-bc28-d131b1e6676c"},{"index":29086,"token":false,"name":"Tournament Grounds","scryfallId":"cd438d51-a778-4b38-8b4b-a6a9cd9b4b22"},{"index":29091,"token":false,"name":"Tower Defense","scryfallId":"195e94a4-a698-4c66-9428-5cc8a40d42c6"},{"index":29096,"token":false,"name":"Shrine of Boundless Growth","scryfallId":"b2ec7b95-667f-43ed-b310-b657befd55a2"},{"index":29099,"token":false,"name":"Progenitor Mimic","scryfallId":"aaebefc1-fe01-45ac-a533-1ddc27269fa5"},{"index":29103,"token":false,"name":"Icatian Priest","scryfallId":"d7690cdd-6610-4310-9e93-60dc4db2ae8d"},{"index":29104,"token":true,"name":"Soldier // Goblin Token (R, 1/1)","scryfallId":"f78c0976-83c4-4694-a93f-13046902cdd9"},{"index":29105,"token":false,"name":"Voltaic Servant","scryfallId":"28564ac6-8b9b-4b99-9630-8fb3158d354c"},{"index":29106,"token":false,"name":"Gnarled Sage","scryfallId":"5f22116a-8b6a-4bbe-999f-7329e1e2b2d9"},{"index":29107,"token":false,"name":"Rotting Rats","scryfallId":"34dea310-8738-4fd9-b790-0361afe1e150"},{"index":29113,"token":false,"name":"Callous Oppressor","scryfallId":"b3dd3ce7-e0e3-4412-9983-ff933584f59b"},{"index":29122,"token":false,"name":"Urza, Lord High Artificer","scryfallId":"86d744cd-225c-4279-898a-858dc316cf7f"},{"index":29124,"token":false,"name":"Diviner's Wand","scryfallId":"277eed87-6b78-456d-91fb-774c72b3ae8c"},{"index":29125,"token":false,"name":"Iron-Heart Chimera","scryfallId":"5899a575-a97d-4850-b55c-22ad6900ba20"},{"index":29129,"token":false,"name":"Goblin Patrol","scryfallId":"9b9d0b79-a55b-4bec-b7c4-4374048ba3ec"},{"index":29130,"token":false,"name":"Banshee","scryfallId":"70a68d3f-fd2a-475f-8d17-6a62e773a312"},{"index":29134,"token":false,"name":"Orochi Sustainer","scryfallId":"5fb40d7a-f2d3-4c9a-a1ab-6b08bd143fe5"},{"index":29139,"token":false,"name":"Jin-Gitaxias, Core Augur","scryfallId":"bd46fc9f-5b92-44d7-8940-2f39b0962b8f"},{"index":29142,"token":false,"name":"New Prahv Guildmage","scryfallId":"698b47d1-c72e-4dc3-b28b-7421e0163f22"},{"index":29145,"token":false,"name":"Nomads en-Kor","scryfallId":"b3a03c68-0ebe-488a-8e6c-7cbf7a448416"},{"index":29150,"token":false,"name":"Longhorn Firebeast","scryfallId":"bf0dcf33-8d3f-429c-8ad8-a65d07d7c790"},{"index":29152,"token":false,"name":"Palliation Accord","scryfallId":"cda10c3b-ee16-4de5-9e54-d0187cd5cc80"},{"index":29153,"token":false,"name":"Sek'Kuar, Deathkeeper","scryfallId":"9257bb20-de32-460c-96cf-375acb6a0b1d"},{"index":29159,"token":false,"name":"Pondering Mage","scryfallId":"c08c5ac8-5c0b-4c89-8f06-e5aadfccee01"},{"index":29165,"token":false,"name":"Kroxa, Titan of Death's Hunger","scryfallId":"01cb2a12-4c1c-413d-91b1-574e4a00e251"},{"index":29167,"token":true,"name":"Copy // Horror Token (Colorless, 1/1)","scryfallId":"a020dc47-3747-4123-9954-f0e87a858b8c"},{"index":29168,"token":false,"name":"Vampire Champion","scryfallId":"d47f91ff-c916-4938-8e01-2c684004dd9a"},{"index":29183,"token":false,"name":"Martial Impetus","scryfallId":"25656d3d-dc5a-4085-8461-cab11b96e70a"},{"index":29185,"token":false,"name":"Triton Waverider","scryfallId":"b8cb11d7-feae-4511-9a03-bda23119b6a5"},{"index":29188,"token":false,"name":"Kessig Prowler // Sinuous Predator","scryfallId":"f89f116a-1e8e-4ae7-be39-552e4954f229"},{"index":29197,"token":false,"name":"Renowned Weaponsmith","scryfallId":"ec947bb8-8cb0-4e1e-8873-fe9bb9761e01"},{"index":29200,"token":false,"name":"Stampeding Horncrest","scryfallId":"3d4d4bb3-583c-4c3b-b6b7-342a78bbaec6"},{"index":29203,"token":false,"name":"Mind Swords","scryfallId":"3d6d91df-008b-48f2-a84f-550702fbcdb3"},{"index":29205,"token":false,"name":"Settle Beyond Reality","scryfallId":"72ed8e57-61bb-4e89-9484-ff2be800a449"},{"index":29215,"token":false,"name":"Alpha Brawl","scryfallId":"e2ec168a-3e4f-4527-901a-bc28cc28d125"},{"index":29216,"token":false,"name":"Daybreak Charger","scryfallId":"ff87a671-054f-4357-8a62-450d36559a1b"},{"index":29217,"token":false,"name":"Red Sun's Zenith","scryfallId":"373eb109-0e30-41c1-b2df-6bc78d968890"},{"index":29220,"token":false,"name":"Nightshade Schemers","scryfallId":"af9a61cd-3a26-4142-83ce-9c41cdb16eb4"},{"index":29223,"token":false,"name":"Convincing Mirage","scryfallId":"fb757102-4636-46ae-b202-c2095aeb187c"},{"index":29226,"token":false,"name":"Thalakos Deceiver","scryfallId":"ae4cc2f5-3a50-40c8-87ea-6b92f081f55c"},{"index":29231,"token":false,"name":"Aven Redeemer","scryfallId":"8a2fa0a3-e40f-49e4-a4fd-427e7e808afd"},{"index":29233,"token":false,"name":"Talonrend","scryfallId":"b5f6256e-5d24-4fa0-a83b-5ff971f7e1cc"},{"index":29234,"token":false,"name":"Riptide Director","scryfallId":"7c059a25-8702-43af-a8cd-aa02d7fd939f"},{"index":29236,"token":false,"name":"Earthshaker Khenra","scryfallId":"0d60eabe-b281-4eba-9c26-287364ed2067"},{"index":29240,"token":false,"name":"Rancid Rats","scryfallId":"336e0a75-8104-4e88-aad0-af7ac3efc115"},{"index":29243,"token":false,"name":"Hypergenesis","scryfallId":"da4d6969-e579-4b28-a76b-5a99c7488f15"},{"index":29248,"token":false,"name":"Dormant Gomazoa","scryfallId":"131d2925-d87c-415f-aa84-97f14030624e"},{"index":29259,"token":false,"name":"Affectionate Indrik","scryfallId":"f0bc344c-9a61-4ba8-91a1-147298472e19"},{"index":29265,"token":false,"name":"Fortifying Draught","scryfallId":"6789b717-a000-464a-a39b-32c1aeefe560"},{"index":29266,"token":false,"name":"Lantern of Insight","scryfallId":"2ae5baac-2a1e-42c3-b146-ecca9d21f044"},{"index":29268,"token":false,"name":"Secluded Glen","scryfallId":"9e4afa65-7933-4a64-b50f-a9a9f832b112"},{"index":29269,"token":false,"name":"Kodama of the Center Tree","scryfallId":"6b9264c5-1ecd-48cc-a12d-d4bd8050cfae"},{"index":29275,"token":false,"name":"Intruder Alarm","scryfallId":"7e55f653-0952-4713-8d43-ca50acff9e3b"},{"index":29280,"token":false,"name":"Emeria, the Sky Ruin","scryfallId":"fdf6016e-71e7-4339-80f9-78e9aa44c54b"},{"index":29283,"token":false,"name":"Mirror Shield","scryfallId":"e7624e84-93ce-4983-8624-ebc934cab67f"},{"index":29284,"token":false,"name":"Noggle Ransacker","scryfallId":"e6dbe4e2-77f3-4764-b9fb-b555a1228bf3"},{"index":29285,"token":false,"name":"Regal Unicorn","scryfallId":"daa1fb8c-12fa-4e9c-979f-55e89356acaf"},{"index":29286,"token":false,"name":"Verdant Haven","scryfallId":"beec869b-fe2c-4f30-ae36-9ce5bdc555e1"},{"index":29292,"token":false,"name":"Sling-Gang Lieutenant","scryfallId":"f82aec21-441b-4fcd-b666-61723bd79531"},{"index":29297,"token":true,"name":"Innistrad Checklist","scryfallId":"99ce1bee-8f95-4284-8e06-9de9bfcb53b5"},{"index":29299,"token":false,"name":"Never Happened","scryfallId":"edb2be3c-7a81-4a1c-9701-8446166b83e6"},{"index":29300,"token":false,"name":"Ramosian Rally","scryfallId":"7fc0ff04-43e7-4a0d-b7e2-8bab72cc6cc0"},{"index":29301,"token":false,"name":"Empress Galina","scryfallId":"6851dbc7-f072-41e7-a899-897445d99425"},{"index":29303,"token":false,"name":"Harabaz Druid","scryfallId":"78a538cf-2291-49aa-8429-17d97d454479"},{"index":29308,"token":false,"name":"Roiling Regrowth","scryfallId":"fa259096-b24f-414c-af59-301bed4b4627"},{"index":29313,"token":false,"name":"Shard Volley","scryfallId":"43db4810-078e-487a-afef-57cbc1db0cc7"},{"index":29314,"token":false,"name":"Ivory Charm","scryfallId":"0706acf6-587e-4f29-944a-fdf25aeacb6d"},{"index":29317,"token":false,"name":"Stirring Address","scryfallId":"2de3e3b0-6ecf-4bf6-9595-0e5e59ef1d6a"},{"index":29318,"token":false,"name":"Gateway Plaza","scryfallId":"3433a2c2-d252-4cd8-97e8-389875b2cda0"},{"index":29319,"token":false,"name":"High Priest of Penance","scryfallId":"84a3ff8d-6d7e-49f0-8d30-7f8c23db568b"},{"index":29321,"token":false,"name":"Sage of Epityr","scryfallId":"8e2ea578-069e-4020-a762-d108a3e14861"},{"index":29322,"token":false,"name":"Scaretiller","scryfallId":"83ad06e3-c498-49f8-b8d4-34d044ede097"},{"index":29324,"token":false,"name":"Minotaur Aggressor","scryfallId":"e22959dc-8759-454e-80b9-623a799af354"},{"index":29327,"token":false,"name":"Treasure Hunter","scryfallId":"06452630-621b-498e-8f25-ecfe544d4213"},{"index":29332,"token":false,"name":"Compost","scryfallId":"91fc8eca-7549-45b5-b3db-89a58d7d2a4a"},{"index":29338,"token":false,"name":"Soltari Trooper","scryfallId":"1bc2cfc0-bc62-4a36-a30b-77c6912be2e9"},{"index":29339,"token":true,"name":"Spellcasting","scryfallId":"e1beb6c6-aa58-4c48-a3ab-df8b7fa98357"},{"index":29342,"token":false,"name":"Massacre Wurm","scryfallId":"26eeb24a-4945-4017-a490-62df6f62cc00"},{"index":29343,"token":false,"name":"Monastery Loremaster","scryfallId":"04d73869-4313-412c-9731-3cf96dea142c"},{"index":29351,"token":false,"name":"Soldier Replica","scryfallId":"e31761a8-1146-4003-9653-881233787ac4"},{"index":29355,"token":false,"name":"Replenish","scryfallId":"7fd2fe13-bbc0-42b7-bc42-3b51910ce118"},{"index":29360,"token":false,"name":"Goblinslide","scryfallId":"a9d80e96-3956-4408-84fb-5f94a364eb41"},{"index":29362,"token":false,"name":"Extract","scryfallId":"97f99a3d-d811-4666-aac8-5957068157dc"},{"index":29364,"token":false,"name":"Belbe, Corrupted Observer","scryfallId":"ee6c3f6e-3c46-47b2-abcc-8aeb2f12d2fa"},{"index":29367,"token":false,"name":"Barbarian Lunatic","scryfallId":"6c899f9b-ebce-4424-9cd9-861a50a5f7d2"},{"index":29373,"token":false,"name":"Bösium Strip","scryfallId":"3884bede-df28-42e8-9ac9-ae03118b1985"},{"index":29375,"token":false,"name":"Grateful Apparition","scryfallId":"7dcb1f9d-105d-48c6-bd66-d7e8839de9e1"},{"index":29379,"token":false,"name":"Insatiable Gorgers","scryfallId":"bb56491b-bad7-44da-8aa5-91ffd875e76a"},{"index":29381,"token":false,"name":"Rendclaw Trow","scryfallId":"bc293a4b-abd6-47b6-99d1-578bc22580de"},{"index":29384,"token":false,"name":"Phyrexian Defiler","scryfallId":"6a4a7dcf-b624-4462-859f-e7b2c4ab02ce"},{"index":29394,"token":false,"name":"Ghostly Visit","scryfallId":"ab5ff1e3-f3d3-4811-841e-87a43f0ce58e"},{"index":29395,"token":true,"name":"Angels","scryfallId":"6355b4c4-7dc9-4d8a-9223-1c0fee664cdf"},{"index":29399,"token":false,"name":"Warchief Giant","scryfallId":"49b311c5-90f5-4d26-86ce-b9f645c137e4"},{"index":29401,"token":false,"name":"Alive // Well","scryfallId":"db84415e-048a-4cfc-9121-5ae17a412198"},{"index":29403,"token":false,"name":"Hollowhenge Beast","scryfallId":"052ab91f-ac01-43f4-9276-9af35dbfbf71"},{"index":29404,"token":false,"name":"Complicate","scryfallId":"33f69670-e494-42b8-9148-fe105ec61aa0"},{"index":29405,"token":false,"name":"Needle Specter","scryfallId":"21af9e72-fbaf-460a-a2eb-a09b925ebd9a"},{"index":29406,"token":false,"name":"Lich's Mastery","scryfallId":"77f4c9cb-f364-4556-8673-4b19d52a2cff"},{"index":29409,"token":false,"name":"Frost Walker","scryfallId":"ebb2c83d-48db-4d0b-8c3a-f4b0353eeb86"},{"index":29411,"token":false,"name":"Brass-Talon Chimera","scryfallId":"200c9655-e51c-4b63-96cf-7f3fba3ec75c"},{"index":29412,"token":false,"name":"Sage of Mysteries","scryfallId":"4138fd65-e0c3-42a1-9c0d-4d5f20228b55"},{"index":29422,"token":false,"name":"Gamekeeper","scryfallId":"d7df331e-0150-4aba-be18-93f88d17c308"},{"index":29424,"token":false,"name":"Welder Automaton","scryfallId":"938066de-d111-4df2-87f0-9eb72aa4cdac"},{"index":29427,"token":false,"name":"Rock Jockey","scryfallId":"8f836e90-3255-48bd-a174-6a127528551e"},{"index":29432,"token":false,"name":"Slith Predator","scryfallId":"14bae45c-eaa8-4c6d-8042-df5cf26e294f"},{"index":29433,"token":false,"name":"Barktooth Warbeard","scryfallId":"bffbda3c-61c0-421d-a724-6bb9a7005c0f"},{"index":29452,"token":false,"name":"Aerie Ouphes","scryfallId":"b2e4cb09-c99f-4a17-a6fd-55c9a169a808"},{"index":29455,"token":false,"name":"Daybreak Chaplain","scryfallId":"c2f461b1-c801-4f0c-8fd7-fe68b6078ac6"},{"index":29456,"token":false,"name":"Sylvan Anthem","scryfallId":"a119edc2-9e0f-43d1-a13d-25827f86e3e3"},{"index":29457,"token":false,"name":"Gnarlid Colony","scryfallId":"7327289d-eed8-44b1-8495-7172e2b49d5f"},{"index":29460,"token":false,"name":"Foxfire","scryfallId":"eb1638c4-effb-460b-af5d-aa17559dbd37"},{"index":29462,"token":false,"name":"Surrak Dragonclaw","scryfallId":"9fa09f29-7647-4a26-aea5-8174bd2075b8"},{"index":29463,"token":false,"name":"Neurok Replica","scryfallId":"4e32d5a8-0916-4728-9cb2-3903262bf873"},{"index":29465,"token":true,"name":"Elemental Token (G, */*)","scryfallId":"c5ad13b4-bbf5-4c98-868f-4d105eaf8833"},{"index":29471,"token":false,"name":"Serpentine Curve","scryfallId":"d651b9e9-d723-4340-a010-d71b2a697e73"},{"index":29475,"token":false,"name":"Gavi, Nest Warden","scryfallId":"80bc07d5-bdbb-4a6d-8958-0c172ea80245"},{"index":29488,"token":false,"name":"Shriveling Rot","scryfallId":"25c255d5-9246-4a93-8750-0da8871fb12d"},{"index":29490,"token":false,"name":"Hammerheim Deadeye","scryfallId":"791cb45a-66f0-4609-8da8-56112e31cef0"},{"index":29491,"token":false,"name":"Shimmering Glasskite","scryfallId":"94bfedca-5a85-41e9-94be-67ed16bd634e"},{"index":29493,"token":false,"name":"Eldrazi Obligator","scryfallId":"cf6e5964-1afc-4435-8c6f-8e3e292f1fb4"},{"index":29499,"token":false,"name":"Elderfang Venom","scryfallId":"7d5bbb02-a04e-4add-ae9a-67819cffdb3a"},{"index":29502,"token":false,"name":"Steadfast Sentry","scryfallId":"8d92614e-05da-4b5c-a98b-addf8ab2de7b"},{"index":29504,"token":false,"name":"Rubblebelt Recluse","scryfallId":"b0d43107-713d-4ff2-8cbd-237c7393229f"},{"index":29506,"token":false,"name":"Ruthless Sniper","scryfallId":"6c85da54-e21a-4548-b85a-f4c2e9084c03"},{"index":29511,"token":false,"name":"Loathsome Chimera","scryfallId":"3afe6283-3642-4883-ac6e-83ae3280af9c"},{"index":29512,"token":true,"name":"Koma's Coil Token (U, 3/3)","scryfallId":"54a1c6a9-3531-4432-9157-e4400dbc89fd"},{"index":29514,"token":false,"name":"Gustha's Scepter","scryfallId":"797c84fa-3704-4fec-bd72-468d6415ae70"},{"index":29518,"token":false,"name":"Tethmos High Priest","scryfallId":"51baeea2-a922-4e98-8253-f395546c30c8"},{"index":29522,"token":false,"name":"Griffin Rider","scryfallId":"3f1a5517-e442-4fbc-b8c3-fea28e5e44d2"},{"index":29523,"token":false,"name":"Defiant Salvager","scryfallId":"e601e4cb-0903-44a6-aefb-8c3a57f27c26"},{"index":29524,"token":false,"name":"Hour of Devastation","scryfallId":"c1eb6163-2580-4658-91d3-96db9ff047a0"},{"index":29532,"token":false,"name":"Draconic Roar","scryfallId":"6cf5591c-46e3-4904-8b4e-4f1f84d3118f"},{"index":29537,"token":false,"name":"Zendikar Incarnate","scryfallId":"eb12b1d8-c53e-4d48-89e5-2168ff34a853"},{"index":29539,"token":false,"name":"Biomass Mutation","scryfallId":"85ba6f28-e47d-4223-80d8-bcb5ef8a0b13"},{"index":29541,"token":false,"name":"Lathiel, the Bounteous Dawn","scryfallId":"29d3484f-abd1-43fe-99f8-e0fa0a7b6692"},{"index":29542,"token":false,"name":"Straw Golem","scryfallId":"43d62479-92ac-43e2-a3d3-b41dfe0fbb20"},{"index":29543,"token":false,"name":"Swift Reckoning","scryfallId":"820096b5-0d64-47a0-88a4-17d3f24cb165"},{"index":29544,"token":false,"name":"Burden of Guilt","scryfallId":"d7440288-6c55-4502-bf20-3c5b50a2de5a"},{"index":29545,"token":false,"name":"Martyrs of Korlis","scryfallId":"41c0b6a9-8d1b-42b6-862d-7b21023df3a7"},{"index":29548,"token":false,"name":"Chancellor of the Forge","scryfallId":"dd3520a7-a55f-4c00-b4f1-c1c154adfc8f"},{"index":29550,"token":false,"name":"Mystic Speculation","scryfallId":"92adfcb4-6a0a-46f9-a171-bfa9fade2156"},{"index":29552,"token":false,"name":"Wyluli Wolf","scryfallId":"5a24af58-5d75-4b41-a226-60abc415ff71"},{"index":29553,"token":false,"name":"Hellkite Hatchling","scryfallId":"08902c09-a1d9-4a63-9b6d-93a9878ec060"},{"index":29556,"token":false,"name":"Kolaghan Aspirant","scryfallId":"aa17972e-c16b-4dec-a108-1c3fb0138a4e"},{"index":29561,"token":false,"name":"Courtly Provocateur","scryfallId":"ba912207-a8bf-4ffb-9967-34029cb09f7f"},{"index":29570,"token":false,"name":"Nettle Sentinel","scryfallId":"3f290ed2-d1a8-4a90-a3a7-8240652dc109"},{"index":29575,"token":false,"name":"Heroes Remembered","scryfallId":"9902b260-82cf-4b10-a353-321231824a3b"},{"index":29576,"token":false,"name":"Kor Scythemaster","scryfallId":"5ce587ba-f23a-4548-a5b8-fca54984d4b4"},{"index":29580,"token":false,"name":"Highcliff Felidar","scryfallId":"ecbeac44-9392-4522-8ff5-87079386bd0a"},{"index":29583,"token":false,"name":"Captain of the Watch","scryfallId":"8e3c18f5-89cd-4d33-8d5b-12dacad9f9b3"},{"index":29589,"token":false,"name":"Towering Thunderfist","scryfallId":"d68e9280-cb1a-48e1-a91e-217e101f19c5"},{"index":29590,"token":false,"name":"Centaur Chieftain","scryfallId":"cb106dd9-32f4-4716-9578-8e7164cc704a"},{"index":29591,"token":false,"name":"Ekundu Cyclops","scryfallId":"9047d292-8f5c-4a6b-b74e-c8dbf3e0ab24"},{"index":29593,"token":false,"name":"Skirk Alarmist","scryfallId":"fd1c1d41-8666-4c1d-9498-0e259472958d"},{"index":29595,"token":false,"name":"Iwamori of the Open Fist","scryfallId":"9c05f3bf-5785-4a53-9c34-cffd7783d107"},{"index":29600,"token":false,"name":"Zhuge Jin, Wu Strategist","scryfallId":"60790b07-53da-41fa-b9e0-e7ce22fdcb11"},{"index":29609,"token":false,"name":"Serpentine Basilisk","scryfallId":"4052a5af-20b2-4817-8c94-78d488ee220f"},{"index":29614,"token":false,"name":"Cave Tiger","scryfallId":"c782eb28-0cdd-4c3d-9d89-8b23c29cddd4"},{"index":29617,"token":false,"name":"Belle of the Brawl","scryfallId":"2c3c992a-70b5-4d3c-9a96-93c3365691ac"},{"index":29620,"token":false,"name":"Greenhilt Trainee","scryfallId":"370f8ef5-c809-43cc-903a-077fad33cd30"},{"index":29626,"token":false,"name":"Press the Advantage","scryfallId":"abca9292-e110-4edb-b9ce-703317175b68"},{"index":29627,"token":false,"name":"Jwari Shapeshifter","scryfallId":"587f91f6-b46e-4dd5-a86d-1048054dd3c0"},{"index":29629,"token":false,"name":"Vertigo","scryfallId":"3067e7af-7bbd-48c1-9f1d-df2a91a0ec54"},{"index":29630,"token":false,"name":"Rally for the Throne","scryfallId":"548d7ff0-70b6-4221-b50b-3ee8547e1b0a"},{"index":29632,"token":false,"name":"Triassic Egg","scryfallId":"7ccd4ea9-1552-4fcc-a443-0718b81dc6a6"},{"index":29635,"token":false,"name":"Slingbow Trap","scryfallId":"def592b9-9d8b-4e2d-9b52-e1bc9f4bd019"},{"index":29638,"token":false,"name":"Due Respect","scryfallId":"a7159850-964b-4f12-957f-614eb0570544"},{"index":29643,"token":false,"name":"Rite of Flame","scryfallId":"10548126-2bac-435d-b7ee-cbfea97a40ea"},{"index":29647,"token":false,"name":"Faceless Devourer","scryfallId":"c49d6139-fc0c-41db-be08-dfa87c685092"},{"index":29648,"token":false,"name":"Gruul Ragebeast","scryfallId":"080ef367-7904-4e5c-a8b4-1fb62f951f3e"},{"index":29664,"token":false,"name":"Indrik Umbra","scryfallId":"fc8b5e68-1938-4775-a015-bdfcb85c0593"},{"index":29667,"token":false,"name":"Garrulous Sycophant","scryfallId":"7e38aafe-d89f-412d-b7b5-1060bff51c6e"},{"index":29668,"token":false,"name":"Kumano, Master Yamabushi","scryfallId":"f93870f9-343f-43e7-8ae8-e7aaa56aacca"},{"index":29672,"token":false,"name":"Waylay","scryfallId":"867a33ee-0340-413a-8243-9d6bc2d944e2"},{"index":29675,"token":false,"name":"Carrion Thrash","scryfallId":"f14c7b9e-eb80-4842-8aa3-1d0c46d9677e"},{"index":29678,"token":false,"name":"Paragon of Fierce Defiance","scryfallId":"3ad97067-2b6b-4e60-817c-6414e2739806"},{"index":29680,"token":false,"name":"Thoughtflare","scryfallId":"d90514aa-e356-4502-9e0e-76ab7644a07a"},{"index":29681,"token":false,"name":"Aetherworks Marvel","scryfallId":"3f92cfc3-7b87-4945-b7d6-b106c9d8bfed"},{"index":29684,"token":false,"name":"Silvergill Douser","scryfallId":"8875c883-8d56-406b-bd89-42199a6e79f5"},{"index":29685,"token":false,"name":"Stormbreath Dragon","scryfallId":"471979de-f569-444a-8651-12d7e726949a"},{"index":29687,"token":false,"name":"Cursed Monstrosity","scryfallId":"8de97585-3d24-4e8d-8bf9-edd75ee88443"},{"index":29694,"token":false,"name":"Ronin Houndmaster","scryfallId":"614ead7b-1975-4a99-bdc2-f8afc6cf92d7"},{"index":29695,"token":false,"name":"Avenger en-Dal","scryfallId":"fcf6f711-c0bc-4e12-b9d0-41581924e13c"},{"index":29696,"token":false,"name":"Intrepid Provisioner","scryfallId":"da3ac63b-8386-4175-9555-84c54566f5b4"},{"index":29701,"token":false,"name":"Blurred Mongoose","scryfallId":"4b073e3f-6a6f-495a-ab16-39d906b660f1"},{"index":29703,"token":false,"name":"Soul Sear","scryfallId":"62584e4f-dac1-4d99-ac0a-6a2451603889"},{"index":29708,"token":false,"name":"Korlash, Heir to Blackblade","scryfallId":"79809fe9-b170-46bf-b67c-c06da4e196ea"},{"index":29709,"token":false,"name":"Abzan Advantage","scryfallId":"3ffd46f5-afd1-4130-b019-d8822e61fdfa"},{"index":29710,"token":false,"name":"Vedalken Orrery","scryfallId":"94b546fa-af65-4afa-bb16-69b33674d3d1"},{"index":29712,"token":false,"name":"Master Thief","scryfallId":"77c273d3-ef0f-40c6-baf5-e39279d10509"},{"index":29713,"token":false,"name":"Nirkana Revenant","scryfallId":"e6990bf6-3b2a-44c8-b7fb-04d74249abfe"},{"index":29714,"token":false,"name":"Elemental Bond","scryfallId":"516ebdba-0f25-459a-a26b-f6fa928b96e6"},{"index":29719,"token":false,"name":"Whipkeeper","scryfallId":"3d86db25-3ec1-42f3-8b02-2729d50dd201"},{"index":29721,"token":true,"name":"Zombie Wizard Token (B/U, 1/1)","scryfallId":"bde17901-35fb-4045-8ba5-deab046cd44f"},{"index":29722,"token":false,"name":"Aggravate","scryfallId":"999f40a7-b723-42e1-83c1-f45a72a26dd4"},{"index":29726,"token":false,"name":"Fountain Watch","scryfallId":"690daa19-1842-4605-9bda-bf67e4ede3c4"},{"index":29729,"token":false,"name":"Liar's Pendulum","scryfallId":"66372597-c182-4850-a630-231737b1482b"},{"index":29732,"token":false,"name":"Beskir Shieldmate","scryfallId":"dfc1df84-9c47-444b-9d58-d9c7bed51c66"},{"index":29734,"token":false,"name":"Ravaging Riftwurm","scryfallId":"5e09949e-c8cd-4bb4-9ed4-699abbc7ad3c"},{"index":29735,"token":false,"name":"Part the Veil","scryfallId":"d870e607-1607-46f3-bc9f-925d0164bcf9"},{"index":29737,"token":false,"name":"Skullscorch","scryfallId":"88f1343c-77bf-4f44-8226-fdfb2c2c7015"},{"index":29740,"token":false,"name":"Workhorse","scryfallId":"c2571ff7-0287-4ba2-8365-5ff08de641a2"},{"index":29742,"token":false,"name":"Equinox","scryfallId":"840c6586-a7a9-4ae8-96be-a995a0693eb6"},{"index":29743,"token":false,"name":"Village Messenger // Moonrise Intruder","scryfallId":"44deb8cf-b9d1-4a14-aeaf-e62cf3dc9ef2"},{"index":29748,"token":false,"name":"Krosan Beast","scryfallId":"47ea2f2d-14ca-4b57-b973-5ce7db35bebf"},{"index":29753,"token":false,"name":"Chandra's Magmutt","scryfallId":"91d3e366-4da5-42c8-bbd5-a0c178c0da28"},{"index":29758,"token":false,"name":"Silt Crawler","scryfallId":"f334e864-4e62-4bc3-9470-661be3d879e2"},{"index":29759,"token":false,"name":"Sower of Discord","scryfallId":"0bf36e46-824d-4146-8804-69bfdd4fd3fa"},{"index":29761,"token":false,"name":"Culling Dais","scryfallId":"b1fd69d0-754c-4b8d-90ad-908ab191e2a4"},{"index":29762,"token":false,"name":"Black Carriage","scryfallId":"87068116-6000-44ee-b47f-f5cb8c233bb2"},{"index":29763,"token":false,"name":"Lumbering Falls","scryfallId":"f0d8d2e4-3ebe-4311-b99e-dea9fb0b20ac"},{"index":29764,"token":false,"name":"Feaster of Fools","scryfallId":"4472ad84-b548-4ed8-a315-ecf9ba9d49ff"},{"index":29765,"token":false,"name":"Anavolver","scryfallId":"5e685a8c-fba6-495f-ac0f-1ff5456b22d0"},{"index":29771,"token":false,"name":"Zodiac Monkey","scryfallId":"a69f3e18-76c7-4683-992c-5133ca0a2cc9"},{"index":29772,"token":false,"name":"Demon's Disciple","scryfallId":"836f5197-e42b-45e0-8170-1b0a8a5beebd"},{"index":29773,"token":false,"name":"Mageta's Boon","scryfallId":"22db8a3b-413d-4f4d-b103-f50fc0415e9b"},{"index":29775,"token":false,"name":"Lancers en-Kor","scryfallId":"e7cd99c2-6d4a-48e8-8848-6fdc0788525d"},{"index":29777,"token":false,"name":"Lathnu Sailback","scryfallId":"33998799-f31b-4522-93b2-0c34c570ebf7"},{"index":29780,"token":false,"name":"Cabal Evangel","scryfallId":"d218d2a2-bb5d-4ea8-a131-341c574410b2"},{"index":29785,"token":false,"name":"Bloodsoaked Champion","scryfallId":"34bc9bb0-5ec1-400f-89e7-b450980a3391"},{"index":29787,"token":false,"name":"Dryad Greenseeker","scryfallId":"4368b8d6-6310-44cc-81f0-bf1af6d361b2"},{"index":29793,"token":false,"name":"Corpse Blockade","scryfallId":"84234e51-e5d6-43d9-89d0-f0398fc6b7fd"},{"index":29794,"token":false,"name":"Teardrop Kami","scryfallId":"b015ae03-c083-4e4a-b4a2-88e55aef9001"},{"index":29795,"token":false,"name":"Prism Array","scryfallId":"6e18c46d-dd6b-4feb-9eb3-3d52985ce6e1"},{"index":29807,"token":false,"name":"Hollow Warrior","scryfallId":"163add05-9ee9-4a8f-8838-3c4143ddc2f5"},{"index":29810,"token":false,"name":"Kyscu Drake","scryfallId":"b6f14bbe-2436-4a5a-8e2a-8066b740b715"},{"index":29812,"token":false,"name":"Bloodchief Ascension","scryfallId":"aa213dbb-c52a-4084-92aa-d0b5d97a97d9"},{"index":29816,"token":false,"name":"Primal Huntbeast","scryfallId":"56e027ec-430f-4c7d-9794-a431efa3693f"},{"index":29818,"token":false,"name":"Golgothian Sylex","scryfallId":"856be1dd-a20b-49c2-be9d-7db76c7efd8b"},{"index":29831,"token":false,"name":"Nephalia Seakite","scryfallId":"174a1d08-cd79-43d6-897f-3ee9a682d15e"},{"index":29832,"token":false,"name":"Reborn Hope","scryfallId":"59038868-6278-4d8c-a107-35aa85b5648f"},{"index":29836,"token":false,"name":"Needlepeak Spider","scryfallId":"00c7d94f-3760-4c97-b0bf-c895f4132c7f"},{"index":29841,"token":false,"name":"Evolutionary Escalation","scryfallId":"399d4b05-d671-4462-9d5d-4cfe3457727e"},{"index":29845,"token":false,"name":"Crater Elemental","scryfallId":"c03105c8-da23-4a59-b82b-f37805156e1e"},{"index":29846,"token":false,"name":"Orbs of Warding","scryfallId":"c33ba4e5-217f-47e3-a6ce-f935a70c7566"},{"index":29847,"token":false,"name":"Tormented Thoughts","scryfallId":"6be2be08-5bad-4813-b6f3-45b564e10b2f"},{"index":29848,"token":false,"name":"Thraben Heretic","scryfallId":"f8cc36df-040b-4f29-bcc1-f5600803f71d"},{"index":29867,"token":false,"name":"Mardu Roughrider","scryfallId":"d6341345-55a6-43f3-915a-c03afea92ec3"},{"index":29870,"token":false,"name":"Well of Ideas","scryfallId":"54227dc5-ca00-4b23-9fb0-f1dd7ff5691a"},{"index":29871,"token":false,"name":"Fertile Thicket","scryfallId":"15231a9b-1956-4ff6-b637-942444d3349f"},{"index":29873,"token":false,"name":"Krosan Vorine","scryfallId":"b7d1c6c6-16b3-4a52-aeda-683b1aeb0e7f"},{"index":29876,"token":false,"name":"Deadapult","scryfallId":"bdc93b3d-bde4-422f-9edc-e337719be7b4"},{"index":29877,"token":false,"name":"Raptor Companion","scryfallId":"cd614f6c-ce6b-4eab-8c9b-83bc1e603c0a"},{"index":29878,"token":false,"name":"Vampiric Link","scryfallId":"a9be1058-0668-4938-8801-e9a98464651c"},{"index":29881,"token":false,"name":"Tyrant's Choice","scryfallId":"5ed37b1c-7377-40bd-ae98-7f5ce56156b1"},{"index":29882,"token":false,"name":"Sorin, Grim Nemesis","scryfallId":"b0b62d9c-3caf-45dd-a192-def88b22d3fe"},{"index":29884,"token":false,"name":"Shadow of Doubt","scryfallId":"7dbd0e3c-b26d-4080-b7cf-1c64fce09668"},{"index":29885,"token":false,"name":"Immolation Shaman","scryfallId":"45e668e5-ef50-43eb-852e-b111370459c8"},{"index":29890,"token":false,"name":"Glimmer of Genius","scryfallId":"19f1673d-c92c-43be-8648-af7fbc790421"},{"index":29891,"token":false,"name":"Sword of Sinew and Steel","scryfallId":"2afc63e4-10be-415b-9512-f6c1a477af8f"},{"index":29894,"token":false,"name":"Essence Sliver","scryfallId":"1346fa14-1d9f-4c6a-887d-d3a93de00743"},{"index":29896,"token":false,"name":"Tracker","scryfallId":"74f0400c-35dd-4ba5-97d1-2e57689c9d53"},{"index":29897,"token":false,"name":"Null Profusion","scryfallId":"c996792c-0846-4b78-bce5-1c6ad29640f6"},{"index":29898,"token":false,"name":"Elusive Spellfist","scryfallId":"af13b8c2-9d7d-44d8-8934-16458e7267dc"},{"index":29911,"token":false,"name":"Icatian Scout","scryfallId":"db63ad7f-6dc4-4249-b360-46ec5569a5a9"},{"index":29912,"token":false,"name":"Lord of the Unreal","scryfallId":"b09140f6-fa75-4bee-9ca0-3a71cd2b5a7b"},{"index":29913,"token":false,"name":"Warbringer","scryfallId":"ed4951ef-2519-4511-b952-c835cd81def7"},{"index":29915,"token":false,"name":"Merchant Scroll","scryfallId":"d4133ceb-6176-411a-9eb8-51721c1bb435"},{"index":29917,"token":false,"name":"Rebuking Ceremony","scryfallId":"5940ed12-5224-4aed-9edc-dd4190691ee9"},{"index":29918,"token":false,"name":"Pyromancer's Swath","scryfallId":"456c4d8b-1dec-42ca-af89-4c40545261bb"},{"index":29919,"token":false,"name":"Minister of Inquiries","scryfallId":"94d6f8c1-8467-4f36-b73d-0747ebd73e09"},{"index":29921,"token":false,"name":"Graven Abomination","scryfallId":"89880f30-aa38-4231-8d16-25c644bde6bf"},{"index":29922,"token":false,"name":"Steelclad Serpent","scryfallId":"71b02044-f3b4-425c-8e6c-697fff2c4ef7"},{"index":29923,"token":false,"name":"Pack Mastiff","scryfallId":"39934090-36a6-4183-9176-97ea932d2685"},{"index":29924,"token":false,"name":"Stormscape Master","scryfallId":"9b704165-4587-48f1-8830-c5a07ec666cc"},{"index":29927,"token":false,"name":"The Brute","scryfallId":"498a0068-e83d-4ba6-800e-4ba185113088"},{"index":29935,"token":false,"name":"Scrapper Champion","scryfallId":"6e6cc1c8-142f-49bd-9b8f-8ab3afff8e2a"},{"index":29936,"token":false,"name":"Fretwork Colony","scryfallId":"ec38a8a2-b73b-43da-9dec-f862a2d03db3"},{"index":29938,"token":false,"name":"Kamahl, Heart of Krosa","scryfallId":"4c3560ae-b1f6-4269-a9eb-1a45247b6232"},{"index":29944,"token":false,"name":"Nimana Skydancer","scryfallId":"e72eaa0f-cbec-45a1-b390-cbbedf5a02f2"},{"index":29945,"token":false,"name":"Mind Games","scryfallId":"4da50979-1f5d-48d1-9406-dfc785273c04"},{"index":29947,"token":false,"name":"Kentaro, the Smiling Cat","scryfallId":"ddcea3b3-5852-4ae1-a952-7b392564cb9d"},{"index":29955,"token":false,"name":"Bloodshot Cyclops","scryfallId":"9320f3d8-0e51-43d0-aedb-bfed771101e9"},{"index":29957,"token":false,"name":"Storm Fleet Sprinter","scryfallId":"41ad8525-7618-4c2b-8037-46f53dd42ee0"},{"index":29959,"token":false,"name":"Devouring Swarm","scryfallId":"735c2c79-9b4f-4f86-9dec-0749237fe9ce"},{"index":29961,"token":false,"name":"Mesa Unicorn","scryfallId":"fed11288-5c3d-47de-bbad-6ca5912a3bce"},{"index":29962,"token":true,"name":"City's Blessing // Elemental","scryfallId":"60ca146d-4e88-4e87-a775-9cfbc9e6b9f2"},{"index":29966,"token":false,"name":"Stromgald Crusader","scryfallId":"a5baeff5-40e9-47b6-85a8-3a6548565b5f"},{"index":29982,"token":false,"name":"Skeletonize","scryfallId":"b47ce40e-23e3-47e7-a900-c77c12f122a5"},{"index":29987,"token":false,"name":"Cho-Manno, Revolutionary","scryfallId":"fe04dfe7-6376-4c12-9404-0e1ae0942917"},{"index":29990,"token":false,"name":"Light of Sanction","scryfallId":"daff382a-980e-4f0c-b26c-70c8a43c66f1"},{"index":29994,"token":false,"name":"Fencer's Magemark","scryfallId":"318a33fb-8b36-4dad-9eef-e0e601723f78"},{"index":30000,"token":false,"name":"Planeswalker's Favor","scryfallId":"b3387540-93bf-451e-8e7a-fc78caab42b0"},{"index":30001,"token":false,"name":"Arcbound Mouser","scryfallId":"9d66e724-49ee-4f08-a160-584350de1d95"},{"index":30003,"token":false,"name":"Slith Bloodletter","scryfallId":"22a04ccb-cb57-4548-81db-e1b77b09f5da"},{"index":30004,"token":false,"name":"Kheru Mind-Eater","scryfallId":"a7fafa31-d366-4001-9180-deff7e2b7128"},{"index":30006,"token":false,"name":"Tidal Surge","scryfallId":"5dae1d63-aee0-4cbe-852d-25fde10fa4b7"},{"index":30007,"token":false,"name":"Run Ashore","scryfallId":"7eed5a2d-d7a4-4f64-a96b-04c5d4206c5a"},{"index":30010,"token":false,"name":"Glint Hawk","scryfallId":"284c4710-4183-4743-9c8b-515cc98cbbb8"},{"index":30013,"token":false,"name":"Gempalm Strider","scryfallId":"574b1d7e-beee-4744-a266-bce9c93bf1ca"},{"index":30014,"token":false,"name":"Talas Scout","scryfallId":"48e12f17-855e-47e0-b7e3-df5c388b01bb"},{"index":30016,"token":false,"name":"Battlefield Raptor","scryfallId":"389f0045-218d-41cd-bdca-8a9a0ab1b31b"},{"index":30018,"token":false,"name":"Standing Stones","scryfallId":"6d4c853e-2231-4af2-bcb0-1781c18ec3be"},{"index":30020,"token":false,"name":"Opal Acrolith","scryfallId":"839b4c10-f68f-4321-82ee-5ec257f63866"},{"index":30022,"token":false,"name":"Sands of Time","scryfallId":"a782ee95-bde4-41f4-a947-b073cc4c1e7c"},{"index":30024,"token":false,"name":"Forbidden Ritual","scryfallId":"f5327e6d-db4e-4b44-a00e-b764e80b8946"},{"index":30026,"token":false,"name":"Phyrexian Triniform","scryfallId":"af2a6582-2281-4f75-8103-80fcb2846805"},{"index":30030,"token":false,"name":"Pride Sovereign","scryfallId":"2bd8511e-39ac-482e-b932-c0588f8cb432"},{"index":30031,"token":false,"name":"Catacomb Slug","scryfallId":"d30d6df7-6199-4b06-9d45-785ee1e2ed3b"},{"index":30036,"token":false,"name":"Taunting Elf","scryfallId":"6b24af94-9632-47da-9bf3-e81bb743cd43"},{"index":30039,"token":false,"name":"Hada Spy Patrol","scryfallId":"a9110a51-a83b-4af8-bd52-32d42688a26b"},{"index":30043,"token":false,"name":"Favored Hoplite","scryfallId":"251015ed-9408-4941-894a-158551ed2613"},{"index":30047,"token":false,"name":"Laccolith Titan","scryfallId":"e36bc466-0f74-46fd-add2-c1cf3b3fe46b"},{"index":30048,"token":false,"name":"Subterranean Shambler","scryfallId":"f9429ec0-ff23-494d-ab1c-b88f3a0dee1b"},{"index":30051,"token":false,"name":"Retromancer","scryfallId":"e9fbf63d-7106-47d5-97c3-4596d8239925"},{"index":30064,"token":false,"name":"Reset","scryfallId":"1c829d83-d5b8-4be7-80f7-55b42f52b309"},{"index":30074,"token":false,"name":"Stonefury","scryfallId":"9c111bf0-dedb-48eb-982c-f877120f12c3"},{"index":30091,"token":false,"name":"Boggart Birth Rite","scryfallId":"1bb4916d-ab50-45c9-bf7e-e7a7e761aef4"},{"index":30094,"token":false,"name":"Odunos River Trawler","scryfallId":"a5d1eda4-ac34-4905-9022-59f91d38dbb3"},{"index":30100,"token":false,"name":"Eyeblight Cullers","scryfallId":"da777e75-6f1f-4e07-a5ec-e25454a0636c"},{"index":30103,"token":false,"name":"Desert Cerodon","scryfallId":"f0b8bedb-d7b7-49b4-8b19-188066d359ca"},{"index":30104,"token":false,"name":"Cunning Giant","scryfallId":"0aa284a7-3aac-4e88-becb-548a28c77401"},{"index":30105,"token":false,"name":"Leonin Bola","scryfallId":"62002790-d080-4c46-962a-62e37d727f61"},{"index":30109,"token":false,"name":"Disowned Ancestor","scryfallId":"2d8bd496-632d-4d6d-a529-f35cf3222de7"},{"index":30112,"token":false,"name":"Indomitable Will","scryfallId":"47772a34-c72f-44e8-b272-4ef2d2af5c82"},{"index":30115,"token":false,"name":"Abomination of Llanowar","scryfallId":"567dbc64-4d59-4bab-a551-08fc66c085fa"},{"index":30119,"token":false,"name":"Vigilant Sentry","scryfallId":"c3790282-ea04-4600-8912-dac541ffd081"},{"index":30123,"token":false,"name":"Shadowcloak Vampire","scryfallId":"f48084a8-afd0-4360-a42d-f8d11e2a767c"},{"index":30132,"token":false,"name":"Crush of Wurms","scryfallId":"32a924b3-3bd6-43ad-acbd-1303dd670db4"},{"index":30140,"token":false,"name":"Cavern Whisperer","scryfallId":"fecae13c-fbbf-4199-a1dc-0e14263ed887"},{"index":30142,"token":false,"name":"Spectral Reserves","scryfallId":"7618aa2d-d5b3-41e6-978f-2c8292f7f896"},{"index":30145,"token":false,"name":"Infiltration Lens","scryfallId":"1baa10da-2733-4657-a1ea-74eb5a5a82b1"},{"index":30157,"token":false,"name":"Shield of the Realm","scryfallId":"7207edf8-8534-4982-969f-df97febcb9fc"},{"index":30158,"token":false,"name":"Furious Assault","scryfallId":"27a07fae-0f34-45e7-b22d-97eea9031022"},{"index":30162,"token":false,"name":"Arrows of Justice","scryfallId":"c64a15f4-6e2f-4479-95da-8805ce2091fa"},{"index":30163,"token":false,"name":"Mesa Lynx","scryfallId":"f65af09b-656f-4d81-b95d-b4f902e56bb7"},{"index":30168,"token":false,"name":"Abbot of Keral Keep","scryfallId":"c7a1ddfa-c746-448e-90e0-bf001fbad3d0"},{"index":30171,"token":false,"name":"Three Wishes","scryfallId":"dbb2b253-7023-44d1-963b-eae98d48f498"},{"index":30173,"token":false,"name":"Mystic Restraints","scryfallId":"96cc4428-3f86-4359-927d-4009ada52c5d"},{"index":30174,"token":false,"name":"Engulf the Shore","scryfallId":"57dfeab4-d468-45f2-8993-5c3a8f8ab1fe"},{"index":30175,"token":false,"name":"Chariot of the Sun","scryfallId":"2e3bc470-cfcc-4835-b46f-c08d698ee1ab"},{"index":30180,"token":false,"name":"Horror of the Dim","scryfallId":"f5d36c9d-967e-42dc-890c-0485b12f704f"},{"index":30184,"token":false,"name":"Maw of the Obzedat","scryfallId":"cd1131c6-04da-4c4d-ab61-874ac5be7087"},{"index":30185,"token":false,"name":"Mountain Titan","scryfallId":"bcc1d589-02a2-4896-a283-9d0385534667"},{"index":30189,"token":false,"name":"Kindred Boon","scryfallId":"3b09c3dc-94ed-4d9d-8c5f-51169200de45"},{"index":30192,"token":false,"name":"Vedalken Certarch","scryfallId":"fed33cda-aab2-49cf-b353-411320e8fd14"},{"index":30193,"token":false,"name":"Stronghold Biologist","scryfallId":"6215a5d9-d6d2-4f9f-8a0c-a65d1afd956a"},{"index":30194,"token":false,"name":"Aysen Abbey","scryfallId":"2a2e669b-61b2-4729-b636-094796fb1d93"},{"index":30195,"token":false,"name":"Tor Giant","scryfallId":"7ef8f279-1a10-4685-99d6-bc971a7f922b"},{"index":30199,"token":false,"name":"Benalish Missionary","scryfallId":"e9ac1992-6212-4f05-af16-c892dfc40643"},{"index":30200,"token":false,"name":"Spindrift Drake","scryfallId":"c881c388-430f-4a4b-9cd1-fba0a2bc2cd6"},{"index":30206,"token":false,"name":"Season of Growth","scryfallId":"65b9a718-01b9-46b2-85eb-55f6206ee5e4"},{"index":30207,"token":false,"name":"Shield of the Righteous","scryfallId":"9e6474b6-1e1a-4c29-8f01-1cabf729b34f"},{"index":30209,"token":false,"name":"Igneous Pouncer","scryfallId":"83d59b32-d47f-4b05-87eb-58ffb8006fa8"},{"index":30218,"token":false,"name":"Visionary Augmenter","scryfallId":"a77979b6-100a-40ed-ac40-6ed4941e4ca3"},{"index":30219,"token":false,"name":"Annihilating Fire","scryfallId":"ae12fd10-c13e-4777-a233-96204ec75ac1"},{"index":30223,"token":false,"name":"Steel Dromedary","scryfallId":"d8dcff03-0ef9-4485-80db-5447e9ca4ef9"},{"index":30225,"token":false,"name":"Guardians of Akrasa","scryfallId":"383c9aa5-30ad-4a2a-8b64-65d4b333c613"},{"index":30226,"token":false,"name":"Dawnglade Regent","scryfallId":"4f1c8567-9d47-433c-b8d6-101d43f62a9a"},{"index":30227,"token":false,"name":"Naru Meha, Master Wizard","scryfallId":"cf44910a-4e24-4e36-a58e-ae7f463db368"},{"index":30229,"token":false,"name":"Angel of the Dire Hour","scryfallId":"dab9c9e5-2d73-4052-8fd1-529ddedfc2c1"},{"index":30234,"token":false,"name":"Cursecatcher","scryfallId":"d257a3c9-443f-4899-badc-f075a14667c5"},{"index":30240,"token":false,"name":"Tibalt, Rakish Instigator","scryfallId":"7fcd6cc0-91b5-47ca-8f3d-c25cf26b81d7"},{"index":30245,"token":false,"name":"Bloodfire Kavu","scryfallId":"4b215c35-9d76-4a0e-8d01-fdc080d46b5a"},{"index":30246,"token":false,"name":"Enchantress's Presence","scryfallId":"75def198-99d6-4b0a-8878-5151f44bc0a4"},{"index":30250,"token":false,"name":"Stoic Builder","scryfallId":"5ba97067-9420-4327-916b-8dddb60399dd"},{"index":30252,"token":false,"name":"Commander's Insight","scryfallId":"a70d1553-40f4-42ce-a02e-e42525f9d75e"},{"index":30258,"token":false,"name":"Kefnet's Last Word","scryfallId":"4d7e5103-ee7d-40d7-bcd4-c5d1a48e9821"},{"index":30261,"token":false,"name":"Toxic Iguanar","scryfallId":"28fd2dce-b91f-441f-a3ea-af87cc925713"},{"index":30262,"token":false,"name":"Dovin's Veto","scryfallId":"5d6b5054-2224-4f68-9d82-3ed17c5dacc4"},{"index":30268,"token":false,"name":"Faeburrow Elder","scryfallId":"46a91c7a-ec6d-45ee-9f5e-46717a84321f"},{"index":30270,"token":false,"name":"Voice of Truth","scryfallId":"40377e3d-77d9-4d86-ac8c-4e27803e48d8"},{"index":30274,"token":false,"name":"Purging Scythe","scryfallId":"0ef8128a-e0f5-43d6-b7bd-3f2003d83eab"},{"index":30287,"token":false,"name":"Valiant Guard","scryfallId":"83ec1486-900b-4763-9b5b-390cb00aff02"},{"index":30289,"token":false,"name":"Resounding Silence","scryfallId":"5b3b0908-5408-41fd-8e69-2bc785e19304"},{"index":30290,"token":false,"name":"Apothecary Geist","scryfallId":"37e2358c-211e-4d79-8120-88bb9e656cba"},{"index":30293,"token":false,"name":"Yasova Dragonclaw","scryfallId":"da235d42-a190-46c6-9e94-7ff4e3fffbe1"},{"index":30299,"token":false,"name":"Sacred Rites","scryfallId":"3d7f1dd0-ee1b-484a-949d-dde4c3340a09"},{"index":30300,"token":false,"name":"Flensermite","scryfallId":"0017de60-ee1c-4675-b04e-cdfa2c2a596e"},{"index":30303,"token":false,"name":"The Trickster-God's Heist","scryfallId":"4aa19a68-0d71-4123-a64d-8cb76f93cd74"},{"index":30305,"token":true,"name":"Fish Token (U, 3/3)","scryfallId":"1f3cea7c-d092-410d-8c32-af0f4c8bc878"},{"index":30306,"token":false,"name":"Fervent Cathar","scryfallId":"0fceeb14-a22a-4ab6-9e6d-ba375b6865c0"},{"index":30307,"token":false,"name":"Wandering Fumarole","scryfallId":"dd0ee251-6c79-499b-8366-c281c989b061"},{"index":30319,"token":false,"name":"Winter's Night","scryfallId":"7f020ebc-4950-4407-8cb8-7630cad226f6"},{"index":30320,"token":false,"name":"Withstand Death","scryfallId":"b059cca0-2373-428b-a3a6-c8be5523c96f"},{"index":30325,"token":false,"name":"Skullmane Baku","scryfallId":"005edd3a-238d-471a-8d5b-2df735c49f67"},{"index":30332,"token":false,"name":"Frenetic Raptor","scryfallId":"8f6bc3c0-2d6e-4a09-84c4-b26a352186bb"},{"index":30337,"token":false,"name":"Mournwhelk","scryfallId":"3a62a282-5f94-444b-9095-4c36fabdad57"},{"index":30340,"token":false,"name":"Lightwielder Paladin","scryfallId":"8e4146a2-08a2-4a9c-b208-a2d02c68e713"},{"index":30341,"token":false,"name":"Carnage Wurm","scryfallId":"c086eb41-3524-4815-97c9-761ba86a30b2"},{"index":30343,"token":false,"name":"Snapping Sailback","scryfallId":"0af1eadf-f7ea-40be-a0cc-b79e4161db34"},{"index":30346,"token":false,"name":"Quiet Contemplation","scryfallId":"5dc7c9d5-904e-4ab6-9773-5c4f1c6d34c4"},{"index":30347,"token":false,"name":"Havenwood Wurm","scryfallId":"561a4bb5-285a-4d52-b372-d165e442cff3"},{"index":30349,"token":false,"name":"Domineering Will","scryfallId":"daec34ec-964f-456b-b1af-4eb4fb41c968"},{"index":30350,"token":false,"name":"Ruthless Cullblade","scryfallId":"dae03745-cec0-4fb1-ab5b-2b0ce5bfdbac"},{"index":30353,"token":false,"name":"Sejiri Shelter // Sejiri Glacier","scryfallId":"f25d56f9-aa54-4657-9ac9-e93fbba3e715"},{"index":30357,"token":false,"name":"Radiant Kavu","scryfallId":"153077a8-38c0-44aa-9b84-cdd9ade50ad6"},{"index":30358,"token":false,"name":"Flowstone Surge","scryfallId":"bc450922-0bbf-46c4-9955-79f4d41ee488"},{"index":30365,"token":false,"name":"Flash Flood","scryfallId":"5ae88c06-f28c-4fbc-a28c-5eb203a04722"},{"index":30368,"token":false,"name":"Lurking Skirge","scryfallId":"9063cc12-a822-4488-856e-93d70ecfe37f"},{"index":30371,"token":false,"name":"Ritual of Restoration","scryfallId":"73142844-de7c-4427-8183-c2281bde6449"},{"index":30374,"token":false,"name":"Touch of the Eternal","scryfallId":"55c5f0c2-99e6-42b7-aa16-61d5815d060d"},{"index":30376,"token":false,"name":"Leaping Master","scryfallId":"0f786a1d-4703-4bac-abba-632506d2726c"},{"index":30379,"token":false,"name":"Serra Disciple","scryfallId":"fa4336df-63ea-4e98-9cfb-a42582acbca2"},{"index":30384,"token":false,"name":"Tajuru Beastmaster","scryfallId":"3447b4af-2eb2-48ae-a12e-2fdf83d4cb70"},{"index":30387,"token":false,"name":"Exquisite Firecraft","scryfallId":"42eca98e-a164-4f70-a0b0-7a604863f30b"},{"index":30388,"token":false,"name":"Call the Bloodline","scryfallId":"3ec85cca-ac2c-4b1b-850b-6a762df72bd0"},{"index":30389,"token":false,"name":"Hoof Skulkin","scryfallId":"ea91be37-aca0-484a-ab94-0186073269d2"},{"index":30392,"token":false,"name":"Veteran Warleader","scryfallId":"46c7f3e0-b23a-4786-b452-583d905113e2"},{"index":30394,"token":false,"name":"Skarrg Goliath","scryfallId":"ed355430-24e4-44eb-b8d3-f8a712a8c905"},{"index":30395,"token":false,"name":"Battle Plan","scryfallId":"2bc1e907-0e77-42ee-9eca-eae632020204"},{"index":30398,"token":false,"name":"Sisters of Stone Death","scryfallId":"d214d25b-96c3-4479-88f0-3996805d6e6f"},{"index":30399,"token":false,"name":"Mairsil, the Pretender","scryfallId":"87b71b08-668c-4b32-8243-8def1a9acf26"},{"index":30402,"token":false,"name":"Golden Bear","scryfallId":"d7dfc789-7ea0-4eb8-8c3b-2c50fd52cbab"},{"index":30403,"token":false,"name":"Blightsteel Colossus","scryfallId":"7928bb14-7631-4830-a756-26d1ea832ba2"},{"index":30405,"token":false,"name":"Knight of the Keep","scryfallId":"0d49653d-cd4e-40a7-99de-fc531b5d8594"},{"index":30406,"token":false,"name":"Sentinel Sliver","scryfallId":"74c28560-e6ac-4be9-a253-22c4613b0d90"},{"index":30410,"token":false,"name":"Nine-Ringed Bo","scryfallId":"445e60aa-1a0a-499e-9887-7d17a1f80a02"},{"index":30415,"token":false,"name":"Groundling Pouncer","scryfallId":"57e7056e-42b9-436a-8302-fcbfa0abd84f"},{"index":30417,"token":false,"name":"Balduvian Fallen","scryfallId":"6a52b952-6e3b-403b-b355-2af47a282ab6"},{"index":30423,"token":false,"name":"Glaive of the Guildpact","scryfallId":"e19723ad-7bd2-49ee-a57a-ece99018f4e8"},{"index":30425,"token":false,"name":"Krark-Clan Ogre","scryfallId":"649f561c-0b90-4f1d-a003-bab351632bd3"},{"index":30428,"token":false,"name":"Resolute Archangel","scryfallId":"8c673b78-3317-4bf4-8ac3-b2ebe1fc9100"},{"index":30438,"token":false,"name":"Akroma, Angel of Wrath","scryfallId":"ce9049ad-2bcd-4b5e-b09c-06424cf76cdc"},{"index":30439,"token":false,"name":"Aerial Modification","scryfallId":"b89cab47-25fb-49ea-bb43-90a0089b6b20"},{"index":30440,"token":false,"name":"Basilica Screecher","scryfallId":"d233c6bc-c4dd-482d-b0f4-87359acab7cb"},{"index":30441,"token":false,"name":"Hero's Downfall","scryfallId":"cb6f32e0-57ab-42fb-959e-1a845e74ae04"},{"index":30443,"token":false,"name":"Beacon Bolt","scryfallId":"39c9e4b5-364b-4c0b-bb47-266563a6abf2"},{"index":30446,"token":false,"name":"Lichenthrope","scryfallId":"76f0c356-a81d-41d4-a8b7-8c159146a8b8"},{"index":30454,"token":false,"name":"Dismal Failure","scryfallId":"35786a7a-faa6-457d-9b92-da560b93a43a"},{"index":30457,"token":false,"name":"Hagra Sharpshooter","scryfallId":"a706b2e3-bd0e-4111-8b68-976869c7d707"},{"index":30458,"token":false,"name":"Devout Decree","scryfallId":"2dcde8fe-d4a4-4c6e-926e-c4a1b45045e4"},{"index":30459,"token":false,"name":"Enraged Revolutionary","scryfallId":"dffcd035-e7e7-4763-813c-5e4193cdb893"},{"index":30461,"token":false,"name":"Ruination Wurm","scryfallId":"ce04d1ee-2605-472d-b3ee-24800342e9af"},{"index":30463,"token":false,"name":"Evershrike","scryfallId":"499d1789-f7b0-47a1-962e-4c75b23befd5"},{"index":30465,"token":false,"name":"Horizon Spellbomb","scryfallId":"9d93378e-1de2-4954-9458-dd3306f2996e"},{"index":30474,"token":false,"name":"Gilder Bairn","scryfallId":"bf0cbe51-94a3-455e-8224-2fcbbaa041ab"},{"index":30478,"token":false,"name":"Necrogen Spellbomb","scryfallId":"0950bfe7-2600-4e01-8f54-f03a5c023520"},{"index":30480,"token":false,"name":"Skygames","scryfallId":"7ab5bf75-762f-46ef-8304-aacdb248bc5b"},{"index":30486,"token":false,"name":"Calix, Destiny's Hand","scryfallId":"86458929-ea21-4de8-84d8-a07398ed3bc0"},{"index":30487,"token":false,"name":"Combo Attack","scryfallId":"d7703507-e7f1-47fd-97f3-ef6319b807a8"},{"index":30488,"token":false,"name":"Flesh Carver","scryfallId":"cf0f88d9-681c-4152-bb45-628850717430"},{"index":30491,"token":false,"name":"Spawnsire of Ulamog","scryfallId":"9ff46819-bfb3-4448-ab4f-f22ff9e2b2b4"},{"index":30492,"token":false,"name":"Fractal Summoning","scryfallId":"cc3f1f7e-eb19-49c1-a1ee-93b85ac8815c"},{"index":30494,"token":false,"name":"Canopy Surge","scryfallId":"2e19d68e-7554-4627-a316-beb1f75fa494"},{"index":30505,"token":false,"name":"Crosis's Catacombs","scryfallId":"7caad74f-c0d0-4eca-94be-b89a2c9a3980"},{"index":30508,"token":false,"name":"Rooting Moloch","scryfallId":"cc2fd581-5cf8-4154-90dd-922afddcd556"},{"index":30510,"token":false,"name":"Snow Fortress","scryfallId":"e283874b-a2c8-46a2-94ad-17d1fc6cc1e5"},{"index":30511,"token":false,"name":"Yoked Plowbeast","scryfallId":"ddbbc7dc-efdf-46e8-bf19-0daa4034f6ec"},{"index":30512,"token":false,"name":"Aether Poisoner","scryfallId":"c9b217f1-1621-40d1-8a98-24c1f7cba800"},{"index":30514,"token":false,"name":"Blood Hound","scryfallId":"baa1e796-809c-49af-a84e-ec088f7f48f8"},{"index":30516,"token":false,"name":"Myr Reservoir","scryfallId":"60678391-44b2-4525-94dc-ffc5a433b79b"},{"index":30517,"token":false,"name":"Valiant Rescuer","scryfallId":"a2b13ff6-67e9-4760-aef4-a8548ea44344"},{"index":30518,"token":false,"name":"Errantry","scryfallId":"01624057-cae4-42e8-b61b-34543c09488d"},{"index":30519,"token":false,"name":"Day's Undoing","scryfallId":"1a11287a-8002-4679-9f69-a7360e7f4d3c"},{"index":30520,"token":false,"name":"Tideforce Elemental","scryfallId":"f23e758d-c9a4-4f8e-b366-634f8c451b61"},{"index":30521,"token":false,"name":"Foothill Guide","scryfallId":"409adb7b-6dcb-4e7f-a5dd-c0adf12140a4"},{"index":30523,"token":false,"name":"Elderfang Disciple","scryfallId":"7f3a6148-d005-49c1-a7fc-867c4e8251cd"},{"index":30525,"token":false,"name":"Plaxmanta","scryfallId":"8ae3598d-4d76-45ac-ab96-00d27a8de6c8"},{"index":30527,"token":false,"name":"Resounding Roar","scryfallId":"217bf237-a758-4500-b221-5e88fed9d0fc"},{"index":30529,"token":false,"name":"Aven Wind Mage","scryfallId":"1b12dfc1-81f2-44b2-baa2-73cc21363978"},{"index":30532,"token":false,"name":"Vodalian Zombie","scryfallId":"f30a5a06-32ce-4d71-b71f-e3e1d8d4511a"},{"index":30538,"token":false,"name":"Hollowhenge Scavenger","scryfallId":"6c9ff632-0e27-4521-9e9d-5725e618f5dd"},{"index":30539,"token":false,"name":"Rise to Glory","scryfallId":"cf6c11c8-64a1-46a4-979c-56a6d5b873d3"},{"index":30542,"token":false,"name":"Witch's Clinic","scryfallId":"fe17b08f-4790-4885-8b2b-b22f00b52d4e"},{"index":30548,"token":false,"name":"Null Rod","scryfallId":"bc45f2cb-c256-4a0f-879a-c7db5b1a0b94"},{"index":30549,"token":true,"name":"Eldrazi Token (Colorless, 10/10)","scryfallId":"390b256c-3381-4807-85a6-ff9e62a99bae"},{"index":30552,"token":false,"name":"Sliversmith","scryfallId":"b242b7dd-a632-4024-a69a-179a63fb93a8"},{"index":30553,"token":false,"name":"Goryo's Vengeance","scryfallId":"6261205d-3506-4f0a-98ce-690f40df7a5a"},{"index":30556,"token":false,"name":"Veteran Cathar","scryfallId":"a471e83e-c0e0-4af6-bfcf-7f4a39f6fccf"},{"index":30557,"token":false,"name":"Ordeal of Heliod","scryfallId":"dd652c85-f8ca-4e38-a21b-f21b729bcf92"},{"index":30568,"token":false,"name":"Giant Badger","scryfallId":"10e9dd66-8580-4c96-9ab9-cc392dc6ee74"},{"index":30575,"token":false,"name":"Agent of Erebos","scryfallId":"1e07a595-5579-4d5a-b07c-84239d690459"},{"index":30577,"token":false,"name":"Sentinel Tower","scryfallId":"25d9500e-a536-4f8e-bfdd-6cb08f709890"},{"index":30585,"token":false,"name":"Wildgrowth Walker","scryfallId":"52e4c0f8-d5f0-4224-9974-190606911480"},{"index":30587,"token":false,"name":"Savage Swipe","scryfallId":"eea7e77c-ede5-41bd-b766-9a76ce691607"},{"index":30596,"token":false,"name":"Astral Slide","scryfallId":"d14993b6-ed8d-4b9b-b54c-2837b343a61e"},{"index":30602,"token":false,"name":"Deathmask Nezumi","scryfallId":"743e38d1-b1cd-4828-ad3d-529a9f882115"},{"index":30610,"token":false,"name":"Shu Grain Caravan","scryfallId":"7bf26eb7-8a31-4022-87bb-67394653f06a"},{"index":30611,"token":false,"name":"Plated Crusher","scryfallId":"cd68e01c-4a09-450b-bfa0-8fbac8721764"},{"index":30612,"token":false,"name":"Draconic Disciple","scryfallId":"a353510a-30de-4891-97b9-d7d556531c41"},{"index":30613,"token":false,"name":"Divining Witch","scryfallId":"be981eef-9dd2-4233-82c9-03f9f2e82c59"},{"index":30618,"token":false,"name":"Soltari Lancer","scryfallId":"f9c67950-121b-4881-979e-c9488212aa8e"},{"index":30624,"token":false,"name":"Soratami Mirror-Mage","scryfallId":"215209b1-1a5d-48f4-9eca-19a9848b2fed"},{"index":30625,"token":false,"name":"Blood Host","scryfallId":"1454a83d-f018-446c-89fb-21460924e589"},{"index":30626,"token":false,"name":"Rolling Spoil","scryfallId":"e6c5546f-2429-4099-a9bd-eda3f52779b7"},{"index":30630,"token":false,"name":"Attended Healer","scryfallId":"6ca80b5a-3943-41ca-8cd1-8e3db1b2a1c8"},{"index":30639,"token":false,"name":"Mortal's Resolve","scryfallId":"131a96b4-393d-4e8e-9b6a-f15f3804febb"},{"index":30640,"token":false,"name":"Call to the Feast","scryfallId":"f7226de1-0e05-4baf-8c2f-54297fee43c1"},{"index":30644,"token":false,"name":"Brain Gorgers","scryfallId":"b02161f4-505c-4c01-ae33-5c61598c71d7"},{"index":30647,"token":false,"name":"Spire Patrol","scryfallId":"1daaf494-70af-4a8d-836f-f6a9d6c1f080"},{"index":30649,"token":false,"name":"Venerated Teacher","scryfallId":"9ec4d902-8841-4f37-9b07-9e8d0f671071"},{"index":30654,"token":false,"name":"Skyscribing","scryfallId":"079bcd66-a083-4c3b-9113-50966374e79f"},{"index":30660,"token":false,"name":"Azor's Gateway // Sanctum of the Sun","scryfallId":"303d51ab-b9c4-4647-950f-291daabe7b81"},{"index":30663,"token":false,"name":"Pheres-Band Tromper","scryfallId":"a2d7e7d1-70ee-450b-8018-ff373cc91c68"},{"index":30670,"token":false,"name":"Windstorm","scryfallId":"3cb7d122-34e8-48e1-a978-831c78a37d0c"},{"index":30671,"token":false,"name":"Dockside Extortionist","scryfallId":"571bc9eb-8d13-4008-86b5-2e348a326d58"},{"index":30674,"token":false,"name":"Triangle of War","scryfallId":"4c1d7d4d-bed7-4d28-a304-ad33f42e9831"},{"index":30678,"token":false,"name":"Resplendent Angel","scryfallId":"586854d1-edfd-4c66-873d-df459324dbfd"},{"index":30684,"token":false,"name":"Llanowar Vanguard","scryfallId":"72e6ed79-bdfd-49f9-bfa4-be4196880487"},{"index":30688,"token":false,"name":"Sporogenesis","scryfallId":"839d969b-b1f7-4978-b00c-db0766161f63"},{"index":30692,"token":false,"name":"Homarid Shaman","scryfallId":"c17c6416-86d6-46ea-aea1-41b98a66b250"},{"index":30694,"token":false,"name":"Trollbred Guardian","scryfallId":"8e3e51f6-7091-4cf3-86a3-b8c5946f3796"},{"index":30695,"token":false,"name":"Paradox Zone","scryfallId":"2368e844-6db2-4715-a4c2-2e56ccd5f422"},{"index":30696,"token":false,"name":"Battle Sliver","scryfallId":"68490b8c-e9d1-4f5c-9001-750be0e0569f"},{"index":30705,"token":false,"name":"Kry Shield","scryfallId":"a558f23c-c2ce-40d0-b894-f8ccbff8f622"},{"index":30708,"token":false,"name":"Urza's Chalice","scryfallId":"d436a794-9c0f-454e-a5e3-319f106896b2"},{"index":30710,"token":false,"name":"Malakir Familiar","scryfallId":"24fe5c92-7da2-47b5-ad13-f95590e93ac2"},{"index":30716,"token":false,"name":"Counterintelligence","scryfallId":"eafbeafb-ef84-4a8d-9ca8-ca305b1feeea"},{"index":30718,"token":false,"name":"Repay in Kind","scryfallId":"90d1db4c-1e79-410a-92ab-c9d58c5e58a6"},{"index":30724,"token":false,"name":"Archetype of Finality","scryfallId":"f326b9c5-063b-4c53-a696-11cd89fc88d8"},{"index":30727,"token":false,"name":"Cloaked Siren","scryfallId":"5f2f76f9-b883-42e1-bd74-71934e15b973"},{"index":30731,"token":false,"name":"Enchanter's Bane","scryfallId":"70378910-bd4a-4116-b71c-4d6d185973ab"},{"index":30734,"token":false,"name":"Zealot il-Vec","scryfallId":"3a2a2740-68cb-48c9-9716-081d369075e0"},{"index":30736,"token":false,"name":"Archdemon of Unx","scryfallId":"b260fbe1-21cb-4a66-aca3-e504b67ed712"},{"index":30737,"token":false,"name":"Steadfastness","scryfallId":"cb4693b3-d5d7-4401-aee3-119d3eb276a2"},{"index":30745,"token":false,"name":"Ebon Drake","scryfallId":"254ea05c-c349-4a95-8751-779b044603bb"},{"index":30749,"token":false,"name":"Serra Advocate","scryfallId":"d7d48d56-c79e-4c7c-a9a0-92b7fb980e5c"},{"index":30750,"token":false,"name":"Rosethorn Halberd","scryfallId":"d4a66e33-af5c-42b5-bef6-0ff0197ecc14"},{"index":30761,"token":false,"name":"Zhou Yu, Chief Commander","scryfallId":"6e2cf83b-417d-41ca-8e65-86aa65180c40"},{"index":30763,"token":false,"name":"Secret Rendezvous","scryfallId":"39528cf0-343e-499b-a69f-c5c3c2898c25"},{"index":30768,"token":false,"name":"Escape Protocol","scryfallId":"2d3eeddd-c86d-4f35-ba57-3caa9565fcb0"},{"index":30772,"token":false,"name":"Noble Panther","scryfallId":"3f327818-8222-4295-8cef-118757b34d17"},{"index":30777,"token":true,"name":"Peer Kröger Bio","scryfallId":"6a45947b-7832-4a0b-836b-63693bf550f8"},{"index":30786,"token":false,"name":"Daretti, Ingenious Iconoclast","scryfallId":"ad30aec2-cb67-4c92-9694-d33bef1884ee"},{"index":30789,"token":false,"name":"Leafkin Druid","scryfallId":"8968a942-72f6-42ad-ae9d-418a1dff0ab3"},{"index":30791,"token":false,"name":"Mogg Bombers","scryfallId":"16064ad4-eec2-4c32-b66d-a2bdb1a6191f"},{"index":30799,"token":false,"name":"Hyrax Tower Scout","scryfallId":"bb7f2638-d757-4df6-90b0-b616534dd3a0"},{"index":30801,"token":false,"name":"Reap Intellect","scryfallId":"c6297df2-c67a-4054-9617-5c6202c76de8"},{"index":30806,"token":false,"name":"Midnight Duelist","scryfallId":"2371bd0c-ca38-4a62-b525-bef4d1ca0646"},{"index":30808,"token":false,"name":"Thwart the Grave","scryfallId":"bd037e51-9088-4145-8289-00a86fb72ca1"},{"index":30818,"token":false,"name":"Null Caller","scryfallId":"4afe773b-2987-4001-a0fd-9dca414a9129"},{"index":30820,"token":false,"name":"Crystalline Crawler","scryfallId":"02b90a7c-288d-420a-91b2-bd9ced5767e4"},{"index":30823,"token":false,"name":"Slippery Bogbonder","scryfallId":"c2f9c4a7-ea53-4da0-9746-2195579f98f6"},{"index":30824,"token":false,"name":"Flickerform","scryfallId":"6165de5d-57f0-419b-95a1-02bd53e5a0c5"},{"index":30827,"token":false,"name":"Flay Essence","scryfallId":"297eaa16-890b-41dc-a470-fa8c313e6e1b"},{"index":30828,"token":false,"name":"Inferno Project","scryfallId":"f6a09368-3fa6-492b-8cfd-8d92113cadca"},{"index":30829,"token":false,"name":"Vault of Champions","scryfallId":"7695a48e-391a-4ac1-93d6-35373e13718f"},{"index":30830,"token":false,"name":"Flame Rift","scryfallId":"e63ed449-d249-4639-85d2-f8fe75496d5c"},{"index":30841,"token":false,"name":"Mardu Warshrieker","scryfallId":"2f4122e5-4c40-4598-b666-aeebf22d57b6"},{"index":30843,"token":false,"name":"Gruul Spellbreaker","scryfallId":"326679a2-782d-45a0-9a06-b147ceff3979"},{"index":30848,"token":false,"name":"Mounted Archers","scryfallId":"4f3abcf2-fe52-4096-8fdb-6917d75a04e3"},{"index":30849,"token":false,"name":"Kytheon's Tactics","scryfallId":"b0521669-206e-4909-be6f-a74603203a70"},{"index":30857,"token":false,"name":"Introduction to Prophecy","scryfallId":"7820923e-bad2-4d6a-92b3-97b9737d2ca9"},{"index":30866,"token":false,"name":"Frogtosser Banneret","scryfallId":"bec81e20-b644-421a-9c93-5a3dc52eb88b"},{"index":30870,"token":false,"name":"Redeem","scryfallId":"05a7756d-df25-4969-96ad-b006df09788b"},{"index":30871,"token":false,"name":"Lingering Tormentor","scryfallId":"f5165880-9727-4f52-9633-fd5cecce7f01"},{"index":30875,"token":false,"name":"Crab Umbra","scryfallId":"3fe6e1ce-bc46-4f86-9504-f8cc062ed3c6"},{"index":30876,"token":false,"name":"Inaction Injunction","scryfallId":"5342ec3c-9d26-474a-9df5-c21ac90bb233"},{"index":30877,"token":false,"name":"Azorius Arrester","scryfallId":"199f7563-563e-483c-8317-5380a83db955"},{"index":30882,"token":false,"name":"Mycosynth Lattice","scryfallId":"94f89714-3b26-46a2-b9a8-3e664f391cd9"},{"index":30883,"token":false,"name":"Fade Away","scryfallId":"a6f9103e-dcc2-4f7a-a8ca-eaa831f5f83b"},{"index":30884,"token":false,"name":"Cobbled Wings","scryfallId":"6f8fe253-8f0c-43b6-81cd-357e33fe7e0d"},{"index":30885,"token":false,"name":"Rith's Attendant","scryfallId":"a26e8130-7fe9-4ef4-98af-928814f5b130"},{"index":30887,"token":false,"name":"Contested War Zone","scryfallId":"bee9b696-5203-4235-9bdd-f2a389d69813"},{"index":30888,"token":false,"name":"Wall of Vapor","scryfallId":"6a6c0a27-d410-4ded-a842-70e1656ea21e"},{"index":30890,"token":false,"name":"Lava-Field Overlord","scryfallId":"8465c5dd-c246-49e4-89bf-18e022816162"},{"index":30892,"token":false,"name":"Highway Robber","scryfallId":"2126c83b-75ce-4526-8f91-5cd8b6ec74a5"},{"index":30895,"token":false,"name":"Lim-Dûl's Cohort","scryfallId":"3d0006f6-2f96-453d-9145-eaefa588efbc"},{"index":30896,"token":false,"name":"Summoning Trap","scryfallId":"72ce4a96-9cb2-4032-9291-7fa0849aeab9"},{"index":30904,"token":false,"name":"Angelheart Protector","scryfallId":"c06cc03f-da73-4ba5-96c9-618b497a7ea3"},{"index":30916,"token":false,"name":"Deft Dismissal","scryfallId":"5cb26d5b-ffeb-4dac-ad61-f85e5e7b1675"},{"index":30920,"token":false,"name":"Leshrac's Rite","scryfallId":"e4d37d29-b667-4124-907d-5636a6db044f"},{"index":30922,"token":false,"name":"Cloudreach Cavalry","scryfallId":"65680bda-b999-4c2a-99a8-b03287e00807"},{"index":30927,"token":false,"name":"Flames of the Raze-Boar","scryfallId":"5b32bb8a-ff23-436d-8e63-bbaf05e830ca"},{"index":30928,"token":false,"name":"Shrivel","scryfallId":"a87c80a1-5818-45fd-9a37-a2ee3396626e"},{"index":30932,"token":false,"name":"Jeskai Infiltrator","scryfallId":"ea15d083-551b-4c13-92ad-3fc2d5414ab3"},{"index":30938,"token":false,"name":"Phalanx Tactics","scryfallId":"5f114a10-0b00-4f3a-bd73-d4c791fbf4d5"},{"index":30939,"token":false,"name":"Champion's Victory","scryfallId":"451ef657-8590-497a-9d98-a732d4de6165"},{"index":30943,"token":false,"name":"Kiora's Follower","scryfallId":"097a8598-f209-417e-a200-b1f3db475845"},{"index":30945,"token":false,"name":"Young Wolf","scryfallId":"0c39aa40-ef5f-40f1-a6dd-fbce91172c50"},{"index":30946,"token":false,"name":"Safewright Quest","scryfallId":"61edb39b-ff82-4568-971f-baf22e209c88"},{"index":30947,"token":false,"name":"Ogre Enforcer","scryfallId":"b0f072d6-7489-4eb0-8c53-1fa42ad806a4"},{"index":30950,"token":false,"name":"Traproot Kami","scryfallId":"ce65aabe-5fd8-4b62-b13c-12e4bb91aacb"},{"index":30955,"token":false,"name":"Breath of Life","scryfallId":"fee1bad3-85e0-4c65-916c-d744e6e6ec61"},{"index":30958,"token":false,"name":"Tyrant's Machine","scryfallId":"088045cd-8aec-43ff-bb8f-d17927b79cfb"},{"index":30960,"token":false,"name":"Noble Vestige","scryfallId":"dae1e55c-bdf2-4327-9f97-032c2c3c7d0c"},{"index":30962,"token":false,"name":"Venom","scryfallId":"cbb503ef-31a4-492d-9c7d-26b72c36904b"},{"index":30966,"token":false,"name":"Noble Purpose","scryfallId":"ad5ff149-8516-456e-af8a-3dea78715acb"},{"index":30967,"token":false,"name":"Banishing Knack","scryfallId":"371a769a-ddae-47f6-b2c2-957de5c18417"},{"index":30968,"token":false,"name":"Sword of the Ages","scryfallId":"aad10ff3-6d8d-4de4-9c30-1ae1aec85e5e"},{"index":30971,"token":false,"name":"Infinite Obliteration","scryfallId":"71a6f6a0-3670-4b72-8c8e-668f47252fa0"},{"index":30974,"token":false,"name":"View from Above","scryfallId":"0dc73034-4886-4855-b6de-392fa053fe9e"},{"index":30980,"token":false,"name":"Hedron Crawler","scryfallId":"9f827f92-1df6-4fd0-aa61-ec2e53476f9c"},{"index":30985,"token":false,"name":"Spellshift","scryfallId":"f5c897a6-5835-42ac-8cc7-e8d9fc1e7c77"},{"index":30990,"token":false,"name":"Honor Guard","scryfallId":"20f208a8-115a-4734-b56a-9330018cb269"},{"index":30995,"token":false,"name":"Sunscape Apprentice","scryfallId":"a9d6bd19-77c9-4a1a-a2d5-6f9737693fea"},{"index":30998,"token":false,"name":"Mer-Ek Nightblade","scryfallId":"fe8589b2-9527-46ba-bf9e-0dec7d84d5d2"},{"index":30999,"token":false,"name":"Boros Battleshaper","scryfallId":"6c43e449-acf2-4e94-b7cf-8c84d70191da"},{"index":31001,"token":false,"name":"Hermetic Study","scryfallId":"8321888a-a450-4c15-9461-255cfaa05367"},{"index":31008,"token":false,"name":"Scare Tactics","scryfallId":"6a9d4e11-ce2e-445a-9536-756a6687d6d7"},{"index":31011,"token":false,"name":"Kjeldoran Frostbeast","scryfallId":"4d923d51-a6c8-416e-94cf-cac785d29d7d"},{"index":31012,"token":false,"name":"Hoverguard Sweepers","scryfallId":"55773fd5-86a2-4fd4-9849-a2f0d4c8298f"},{"index":31014,"token":false,"name":"Tree Monkey","scryfallId":"4724d00a-b93b-43fd-9c86-56f127db450b"},{"index":31015,"token":false,"name":"Braids, Conjurer Adept","scryfallId":"0f16252d-0692-43f6-b980-ed9a6d937637"},{"index":31031,"token":false,"name":"Fleetwheel Cruiser","scryfallId":"5fdaca1e-5741-456e-ae98-e2c45fd1731b"},{"index":31036,"token":false,"name":"Fang Skulkin","scryfallId":"ff5ed574-4ff2-4f67-8989-d3e47ba1d750"},{"index":31043,"token":false,"name":"Shefet Monitor","scryfallId":"53341739-264d-42cf-b964-04b5c76ed232"},{"index":31050,"token":false,"name":"Flunk","scryfallId":"f8487884-e991-4feb-823b-90d9125edf19"},{"index":31054,"token":false,"name":"Flame-Wreathed Phoenix","scryfallId":"a36bca58-e92f-4496-92d6-5ecba7a0424d"},{"index":31055,"token":false,"name":"Rally of Wings","scryfallId":"f043642d-35fe-4ea9-a1d3-78ddfdddeaf4"},{"index":31062,"token":false,"name":"Unwavering Initiate","scryfallId":"c872459b-9e3e-4843-b61a-668922668d80"},{"index":31068,"token":false,"name":"Obsessive Stitcher","scryfallId":"2929f5c1-99a4-4c7e-aa4e-096a0c35c610"},{"index":31070,"token":false,"name":"Peer Through Depths","scryfallId":"ae3cc8b1-19af-426e-8b8b-d94b3280c728"},{"index":31074,"token":false,"name":"Enhanced Awareness","scryfallId":"21df7db7-c23b-4dca-b9c8-c785d7007285"},{"index":31075,"token":false,"name":"Lost Order of Jarkeld","scryfallId":"0f8fe1e5-69d2-401f-97cb-3cc01064bad3"},{"index":31078,"token":false,"name":"Drake-Skull Cameo","scryfallId":"4a3ce135-9c2f-45bd-b2db-c0e00c50c964"},{"index":31081,"token":false,"name":"Crush the Weak","scryfallId":"875a20c2-1d17-46ea-b4d2-3e70bc05aae3"},{"index":31085,"token":false,"name":"Divine Congregation","scryfallId":"9f781071-e9bc-49ee-ac94-23490134b909"},{"index":31088,"token":false,"name":"Unexpected Fangs","scryfallId":"aa6494ad-a35e-4b09-8623-7740f3c20b0b"},{"index":31089,"token":false,"name":"Leonin Vanguard","scryfallId":"724738ad-6a9b-4ef6-b637-558645cd8151"},{"index":31094,"token":false,"name":"Migration Path","scryfallId":"363428be-0f89-4de5-a804-93172da4d99f"},{"index":31095,"token":false,"name":"Consuming Fervor","scryfallId":"d529d230-89b0-453b-987b-a47e15bc3830"},{"index":31098,"token":false,"name":"Shimmerwing Chimera","scryfallId":"f3b54bea-f2c5-4000-9cbd-04c03a1d2ea2"},{"index":31099,"token":false,"name":"Fatal Attraction","scryfallId":"930ff9ec-6b97-445e-b274-7c8c5fe0c0fc"},{"index":31111,"token":false,"name":"Vault of the Archangel","scryfallId":"35a65437-430a-42ef-854f-6e66f8e1a04a"},{"index":31115,"token":true,"name":"Wall Token (U, 5/5)","scryfallId":"353aaec9-79fb-4b83-b4f4-8c7dc2a6b1c1"},{"index":31118,"token":false,"name":"Recycle","scryfallId":"ae984b86-ac6d-45e2-9c8d-0b7ac50021a1"},{"index":31122,"token":false,"name":"Phyrexian Splicer","scryfallId":"b1e9061a-b9e6-49ec-bc7e-c18557da9fd5"},{"index":31126,"token":false,"name":"Anafenza, Kin-Tree Spirit","scryfallId":"55611f05-10cf-42d0-b93e-7f0c0c852a06"},{"index":31129,"token":false,"name":"Skull Rend","scryfallId":"1c8efb23-bac0-41d2-b4ee-27a6b1fe3134"},{"index":31130,"token":false,"name":"Alert Heedbonder","scryfallId":"15a2ccae-c322-4e99-a094-a68fc5d52ea3"},{"index":31133,"token":false,"name":"Centaur Peacemaker","scryfallId":"0e630e9b-7817-4255-9de1-795b2a788d80"},{"index":31143,"token":false,"name":"Grotesque Hybrid","scryfallId":"6b063c3a-267f-4f22-be51-0a14880afc24"},{"index":31145,"token":false,"name":"Festival of the Guildpact","scryfallId":"d15fc49c-07a9-4e55-a977-24f7b7c2df1a"},{"index":31148,"token":false,"name":"Darkling Stalker","scryfallId":"4eb883b7-da6a-45c3-9dde-61334a0ddcae"},{"index":31151,"token":false,"name":"Unnerving Assault","scryfallId":"109eccfd-19d0-48cc-8b27-9027e4911fee"},{"index":31153,"token":false,"name":"Kari Zev's Expertise","scryfallId":"47155b2a-d8e3-43be-bf72-1583745e6262"},{"index":31159,"token":false,"name":"Wheel of Sun and Moon","scryfallId":"55976e4b-718f-44b2-b93d-de5f75dc3bbe"},{"index":31161,"token":false,"name":"Saprazzan Breaker","scryfallId":"2de7bf0f-5ad5-467b-ad80-28517951bbe1"},{"index":31166,"token":false,"name":"Nefarox, Overlord of Grixis","scryfallId":"abc382f3-fdb9-4987-acf4-bf1ac4fd2ef7"},{"index":31167,"token":false,"name":"Domestication","scryfallId":"7bf0b7e3-fe3f-4710-9b92-9ffdb242e92e"},{"index":31168,"token":false,"name":"War Tax","scryfallId":"e7c15159-8466-43e5-9dc5-a8cc94619931"},{"index":31170,"token":false,"name":"Rath's Edge","scryfallId":"42681dce-5c63-4e56-955e-39f085ea6ae9"},{"index":31171,"token":false,"name":"Tivadar's Crusade","scryfallId":"af57687b-da90-41df-85a3-cb92933f2ca8"},{"index":31173,"token":false,"name":"Sphere of Reason","scryfallId":"76ef2016-b3c8-4615-a056-3000bcccb68e"},{"index":31180,"token":false,"name":"Worldsoul Colossus","scryfallId":"b5186304-b0fb-44a6-ba61-0265b7f42da4"},{"index":31188,"token":false,"name":"Mages' Contest","scryfallId":"14864a20-29b6-4c3b-9d33-8121bff6d792"},{"index":31194,"token":false,"name":"Combine Chrysalis","scryfallId":"d7ac6ff5-4caa-48ee-a9a4-de7c1300e326"},{"index":31200,"token":true,"name":"Human // Wolf Token (W, 2/2)","scryfallId":"3a98c51f-c55c-4bd9-853b-65b8bad5a29f"},{"index":31201,"token":false,"name":"Drift of Phantasms","scryfallId":"c1096ce5-f776-4028-b231-e6eaee35014b"},{"index":31206,"token":true,"name":"Shard","scryfallId":"df826c7d-5508-4e21-848c-91bc3e3f447a"},{"index":31213,"token":false,"name":"Stromkirk Noble","scryfallId":"9c16cf74-f9e0-4d80-9a29-b91dec0b6b38"},{"index":31219,"token":false,"name":"Call to the Kindred","scryfallId":"ee35f96c-6060-4456-897e-27b74c8c2137"},{"index":31220,"token":false,"name":"Quillspike","scryfallId":"14cb4054-d5d6-4015-ae86-6f99280afe0a"},{"index":31225,"token":false,"name":"Sojourner's Companion","scryfallId":"8c6af084-eee7-4259-a58b-a866e0cf171b"},{"index":31231,"token":false,"name":"Fickle Efreet","scryfallId":"ca6d047a-f3dc-4c34-9679-fb76037e4044"},{"index":31234,"token":false,"name":"Bog Down","scryfallId":"8752a605-38f8-4d75-b122-063a788dff6e"},{"index":31236,"token":false,"name":"Faerie Guidemother // Gift of the Fae","scryfallId":"e8bbece8-9620-44d9-b991-350fe952538a"},{"index":31238,"token":false,"name":"Genju of the Fens","scryfallId":"3d41c71a-5024-4433-986e-c82473952606"},{"index":31242,"token":false,"name":"Urza's Avenger","scryfallId":"60bd9559-1a8f-47d0-af6b-d0681cae4060"},{"index":31265,"token":false,"name":"Hurloon Shaman","scryfallId":"70a359c9-1889-426d-acaf-074cfd9f274d"},{"index":31267,"token":false,"name":"Anthousa, Setessan Hero","scryfallId":"8d592f31-297f-4bcd-b438-f5b7e839852a"},{"index":31269,"token":false,"name":"Psychotrope Thallid","scryfallId":"e2803fdc-2ae1-438c-b5b1-559817e85fdb"},{"index":31273,"token":false,"name":"Priest of Fell Rites","scryfallId":"96a63c64-bbf4-46cc-bffe-0992bea502cc"},{"index":31274,"token":false,"name":"Gorging Vulture","scryfallId":"37cbe5f2-5b6b-41de-9586-c7cc83464cf2"},{"index":31277,"token":false,"name":"Archfiend of Sorrows","scryfallId":"f4d089f1-718e-4853-a634-64114735fba5"},{"index":31279,"token":false,"name":"Smolder Initiate","scryfallId":"16ecbed3-3a41-4823-8cd2-498daaaa0d4f"},{"index":31285,"token":false,"name":"Nightcreep","scryfallId":"55f7f7f7-c7eb-466c-bfe6-0ef586284ee9"},{"index":31287,"token":false,"name":"Veteran Armorsmith","scryfallId":"42f506b5-2e24-47fd-a41e-1e834ce48cd1"},{"index":31290,"token":false,"name":"Prescient Chimera","scryfallId":"f4bb655d-8d62-4a79-9a9d-7384d1cb2cc0"},{"index":31294,"token":false,"name":"Firestorm Hellkite","scryfallId":"def23574-4a41-4323-84d9-49f58b2ca322"},{"index":31296,"token":false,"name":"Hidden Strings","scryfallId":"216e8047-6f54-49ce-bf86-27dc8fc8c8f7"},{"index":31300,"token":false,"name":"Saving Grace","scryfallId":"9ac7b2d8-7702-4b8c-84ed-1d785dea5cc5"},{"index":31307,"token":false,"name":"Conifer Wurm","scryfallId":"84f99d23-5d3e-4f36-b1c7-3a893e4b4c32"},{"index":31310,"token":false,"name":"Cabal Ritual","scryfallId":"5403b49d-03a7-4cc3-af3c-df098c1c9c2e"},{"index":31314,"token":false,"name":"Awaken the Bear","scryfallId":"803a6ac7-9327-4c2f-b023-93f5f65f83b8"},{"index":31320,"token":false,"name":"Zuberi, Golden Feather","scryfallId":"c1b24a80-b5e1-484f-9e21-886cb6b5db48"},{"index":31325,"token":false,"name":"Cateran Brute","scryfallId":"73b6ce76-0ed0-4994-ae2c-d8e51ae09920"},{"index":31327,"token":false,"name":"Dress Down","scryfallId":"1d7dcf74-110c-421f-87db-c2133d7a8281"},{"index":31331,"token":false,"name":"Salt Road Patrol","scryfallId":"2c5ee84d-e5b9-4103-8ba7-ccd79a272c0f"},{"index":31332,"token":false,"name":"Triumphant Surge","scryfallId":"75d6eb18-a49d-4fa5-a333-78aafbc4abcb"},{"index":31335,"token":true,"name":"Giant Wizard Token (U, 4/4)","scryfallId":"a40a0cb8-0caf-4dd1-b7d0-abbc626985d2"},{"index":31341,"token":false,"name":"Universal Automaton","scryfallId":"b1211495-12ba-4f57-90f9-8befec5fc03d"},{"index":31342,"token":false,"name":"Mirror Match","scryfallId":"9309cfc2-7d5f-422f-8efa-d0843dbd5ca7"},{"index":31354,"token":false,"name":"Brinebarrow Intruder","scryfallId":"89960a74-9e17-4e30-874a-4286dd4c917d"},{"index":31356,"token":false,"name":"Guard Dogs","scryfallId":"ba32eee7-10ba-4f0b-8a87-c3ecfa22ae41"},{"index":31361,"token":false,"name":"Clockwork Servant","scryfallId":"c3af5942-d171-401a-9444-3b59c579e4db"},{"index":31362,"token":false,"name":"Siege Behemoth","scryfallId":"46440515-7923-45ba-ad80-052999eaeaac"},{"index":31370,"token":false,"name":"Spitting Gourna","scryfallId":"746b98bf-5398-4a00-b4fe-a990ea9cfd77"},{"index":31371,"token":false,"name":"Archon of Redemption","scryfallId":"1f7dfcf6-c41b-48d6-a3b4-4b4a7bed82eb"},{"index":31372,"token":false,"name":"Boggart Mob","scryfallId":"a61990de-0daf-4340-8e6b-c49852d46980"},{"index":31379,"token":false,"name":"Cairn Wanderer","scryfallId":"f84b53c7-10db-40f6-a1d4-0baab88355e5"},{"index":31384,"token":false,"name":"Mutant's Prey","scryfallId":"d9e32d47-2796-4eac-b373-a93506d8d6b7"},{"index":31386,"token":false,"name":"Chancellor of the Tangle","scryfallId":"6d129aa8-b637-451e-8123-5221e08cc2cc"},{"index":31388,"token":false,"name":"Ertai, Wizard Adept","scryfallId":"91971e19-61ce-45ac-b700-9ffca5091a27"},{"index":31392,"token":false,"name":"Corrupt Court Official","scryfallId":"9d3ba2e3-e680-47cd-81c5-555deea7d00f"},{"index":31400,"token":false,"name":"Stormwatch Eagle","scryfallId":"21c3bb62-63b4-4b53-9e4d-edfc7487494b"},{"index":31401,"token":false,"name":"Gate Hound","scryfallId":"06732c6f-c3b5-4c68-82a0-655cffff79db"},{"index":31406,"token":false,"name":"Mournwillow","scryfallId":"45aa37d8-6765-443f-9b70-200fecf8fa1e"},{"index":31409,"token":false,"name":"Shared Fate","scryfallId":"ad0d5b02-ef38-4dab-8ac6-78814ef27b55"},{"index":31412,"token":false,"name":"Blessed Respite","scryfallId":"2217881d-26dc-44c0-81d8-8c78c44bc5f0"},{"index":31415,"token":false,"name":"Ikiral Outrider","scryfallId":"7e1532b1-6f3b-48d3-ada9-ec395e842b96"},{"index":31425,"token":false,"name":"Spring of Eternal Peace","scryfallId":"f6862d7a-04ee-48ac-a5b3-46a4e8694d5b"},{"index":31428,"token":false,"name":"Eladamri, Lord of Leaves","scryfallId":"0b1689f3-9dfa-4525-90b3-7af15f7eb720"},{"index":31434,"token":false,"name":"Rumbling Rockslide","scryfallId":"96f9aaa7-11c7-4cd0-9803-9471c14ab846"},{"index":31435,"token":false,"name":"Illusion // Reality","scryfallId":"8e7dd90a-4f93-43aa-b503-18289fdd571e"},{"index":31445,"token":false,"name":"Ogre Savant","scryfallId":"1940a64a-51da-4509-b33e-86415aeeafad"},{"index":31446,"token":false,"name":"Elephant Resurgence","scryfallId":"22147f72-7ff8-40c4-9bdd-df41dce17dad"},{"index":31453,"token":false,"name":"Wolfrider's Saddle","scryfallId":"ba18cc9a-411d-45c6-bcc3-9e02ef5e2d92"},{"index":31466,"token":false,"name":"Khenra Scrapper","scryfallId":"21288bf8-b976-4ef0-9ad5-8c0e64631277"},{"index":31467,"token":false,"name":"Aerial Formation","scryfallId":"fce86785-bc03-451e-8422-8bb53082cc12"},{"index":31468,"token":false,"name":"Archetype of Imagination","scryfallId":"3de0f770-b62b-4a9d-bea7-6bb7bc2020ad"},{"index":31470,"token":false,"name":"Lash of Malice","scryfallId":"af3da2c6-29ed-4563-8bae-d1cc05df8897"},{"index":31474,"token":false,"name":"Domri, City Smasher","scryfallId":"8fe16cdb-90df-4670-a084-55c505791d85"},{"index":31478,"token":false,"name":"Farrel's Mantle","scryfallId":"af092da3-8713-4a59-86d3-827b942d6456"},{"index":31482,"token":false,"name":"Ministrant of Obligation","scryfallId":"bf2a093a-25f0-4247-94dc-550865d86317"},{"index":31486,"token":false,"name":"Basal Sliver","scryfallId":"4564e9df-bfa3-48e5-a12e-f7e96a504cb1"},{"index":31491,"token":false,"name":"Infested Roothold","scryfallId":"f9fc7bf3-fa3f-450a-875e-05a022794181"},{"index":31493,"token":false,"name":"Grim Draugr","scryfallId":"54340c59-03a9-4d9d-bd27-9aed337ce75a"},{"index":31494,"token":false,"name":"Leafdrake Roost","scryfallId":"1afe37e4-e2ba-4275-9d24-d58382587924"},{"index":31498,"token":false,"name":"Spawnbinder Mage","scryfallId":"5677bd49-69eb-41dc-8e64-2df3b7f5c45f"},{"index":31503,"token":false,"name":"Repercussion","scryfallId":"d0f3c78e-16c0-4fbc-8ef4-fbf610f9d464"},{"index":31507,"token":false,"name":"Bronze Horse","scryfallId":"e52122a1-e204-4299-b889-609df93b36fa"},{"index":31515,"token":false,"name":"Defender of Chaos","scryfallId":"717ae26a-e5a0-4478-9995-00ea6bd84c03"},{"index":31523,"token":true,"name":"Beast Token (G/R, 4/4)","scryfallId":"87ec9ade-1e06-43c9-97df-55465cabdf32"},{"index":31525,"token":false,"name":"Mirrorwing Dragon","scryfallId":"4b7e33a8-765b-4909-a5c6-5fe8f8774a51"},{"index":31529,"token":false,"name":"Thought Monitor","scryfallId":"55c98ef7-be05-4bcf-be4b-62a437297330"},{"index":31532,"token":false,"name":"Specter of the Fens","scryfallId":"73e3cfbc-7177-4bbc-89c4-560c9c2f97db"},{"index":31533,"token":false,"name":"Sentry Oak","scryfallId":"ab09d6d7-e2f0-4e78-a9a3-ac37f02f4096"},{"index":31534,"token":false,"name":"Diregraf Captain","scryfallId":"827f0a95-6c07-46c6-8217-234de0310f5f"},{"index":31552,"token":false,"name":"Windbrisk Raptor","scryfallId":"5df7b710-d44c-4ebc-be5b-f81d697086c4"},{"index":31555,"token":false,"name":"Spirit Mirror","scryfallId":"fbbfb4ae-4d41-4957-8f1f-2e8dc9bc1c29"},{"index":31561,"token":false,"name":"Steel of the Godhead","scryfallId":"0d3c9145-14d0-4731-bc07-eb4c3f71d7e4"},{"index":31564,"token":false,"name":"Void","scryfallId":"35be3cbb-88e8-4f4d-90bb-3ee302f3b12e"},{"index":31565,"token":false,"name":"Bladeback Sliver","scryfallId":"7066c9ab-9420-46f9-a6c7-ce4d5273e2fa"},{"index":31572,"token":false,"name":"Death Cultist","scryfallId":"bd0a2fe3-45ab-4bac-aca7-a6418e28d0be"},{"index":31576,"token":false,"name":"Unexpected Results","scryfallId":"65e10a22-6070-48d7-99ab-45f770f16fd1"},{"index":31578,"token":false,"name":"Synod Sanctum","scryfallId":"a4ee3b93-6a9c-4e87-b7e3-904114f7e8a1"},{"index":31580,"token":false,"name":"Stern Proctor","scryfallId":"7042fdc8-e2dd-4f9a-97b9-00d95c9eae74"},{"index":31582,"token":false,"name":"Looming Altisaur","scryfallId":"d0aea3ad-a24b-4562-b7a3-18465a61c2bb"},{"index":31587,"token":false,"name":"Faerie Duelist","scryfallId":"a7da9c9b-aeef-4f48-bc8f-39425841cc8c"},{"index":31593,"token":false,"name":"Reaping the Graves","scryfallId":"9c008328-deeb-4f93-abe8-ee424d3ab986"},{"index":31594,"token":false,"name":"Sinister Possession","scryfallId":"7f54c15b-fec0-49a6-8a49-d1af4eeee40e"},{"index":31596,"token":false,"name":"Boros Fury-Shield","scryfallId":"c46b2f5c-3c7a-4421-9d6f-81197e93d8d0"},{"index":31597,"token":false,"name":"Lavakin Brawler","scryfallId":"3eeea9e5-3041-4439-bc52-fd00ec83c7a1"},{"index":31598,"token":false,"name":"Calcite Snapper","scryfallId":"aec0c914-1188-45c9-a68c-c3b915dbebf7"},{"index":31603,"token":false,"name":"Leeching Licid","scryfallId":"27bffefb-23c0-4d03-b716-b1a7eff39a05"},{"index":31605,"token":false,"name":"Mind Drain","scryfallId":"0683d586-a54b-425a-a24d-2efb2342f150"},{"index":31607,"token":false,"name":"Contingency Plan","scryfallId":"40dc6986-202e-4f65-aee7-a631dda88ed0"},{"index":31612,"token":false,"name":"Nantuko Elder","scryfallId":"5c0a4e6e-cc4e-43d5-aece-f009e117366a"},{"index":31613,"token":false,"name":"Clarion Ultimatum","scryfallId":"39e8bf21-0baf-4ee9-b224-b9eee50df280"},{"index":31615,"token":false,"name":"Bladed Pinions","scryfallId":"bf479c90-c791-4152-a8e6-fd3123f698df"},{"index":31619,"token":false,"name":"Protective Sphere","scryfallId":"ef5ef13e-1cf0-42a9-95d0-30ade254d6a8"},{"index":31622,"token":false,"name":"Horizon Seed","scryfallId":"4d48efd0-68e3-4206-b9a0-58868cc8ddc6"},{"index":31627,"token":false,"name":"Ritual of the Returned","scryfallId":"20bdf00a-e7f1-42f4-997f-388f3b28bf8f"},{"index":31628,"token":false,"name":"Hellion Crucible","scryfallId":"ad8274ef-a46a-4f5f-8ad1-6ce828f24210"},{"index":31629,"token":false,"name":"Illusory Wrappings","scryfallId":"a67aefde-2c91-4974-b89d-84333a2874eb"},{"index":31633,"token":false,"name":"Regal Bloodlord","scryfallId":"65a75d3a-58cb-4ee0-88d3-52099cb57ac3"},{"index":31634,"token":false,"name":"Radiant Essence","scryfallId":"d9b1853c-d5b9-4361-8a2f-36946a62847b"},{"index":31635,"token":false,"name":"Hall Monitor","scryfallId":"02fdc551-0b22-49f4-8765-143ad82f16a3"},{"index":31637,"token":false,"name":"Gloom Sower","scryfallId":"a1b4f7ec-ea2e-4d90-98cd-0c92bd9f64c1"},{"index":31638,"token":false,"name":"Fire and Brimstone","scryfallId":"d5208dbb-63d2-4789-8ef9-f82499a43b3a"},{"index":31640,"token":false,"name":"Birthing Boughs","scryfallId":"1db211da-8abd-4644-b337-338b4c2ff08d"},{"index":31643,"token":false,"name":"Quickchange","scryfallId":"3f90c1a1-679d-45c5-a1d4-53dad05e45fa"},{"index":31652,"token":false,"name":"Smelt-Ward Gatekeepers","scryfallId":"8237b11f-36d2-4624-a0ef-520663385891"},{"index":31659,"token":false,"name":"Moonglove Changeling","scryfallId":"6955348b-70e9-49c3-9343-9becf977abe8"},{"index":31660,"token":false,"name":"Colossal Majesty","scryfallId":"56f8fd3b-5b1c-4d8c-86c7-ee3ba7de69c7"},{"index":31662,"token":false,"name":"Charmed Sleep","scryfallId":"4238ad00-af9c-4535-a589-c5afb0d2ec57"},{"index":31663,"token":false,"name":"Carnassid","scryfallId":"46e614ca-3ef8-44bf-b3f8-bda66c82ed6f"},{"index":31664,"token":false,"name":"Embraal Gear-Smasher","scryfallId":"3ad5c175-581c-4fdd-b008-e7d10b0928c7"},{"index":31667,"token":false,"name":"Specimen Collector","scryfallId":"bdfaed69-bc4c-4c73-abc3-00dce5e0177e"},{"index":31670,"token":false,"name":"Kruin Striker","scryfallId":"73e72249-84ea-4e9c-9f64-b67b02ffdf3a"},{"index":31677,"token":false,"name":"Deathsprout","scryfallId":"26a0ae4f-a48c-4333-a53f-70702b5b4c9e"},{"index":31680,"token":false,"name":"Engulfing Eruption","scryfallId":"f198c7e3-8a85-48f3-a7c2-93320fd4fb81"},{"index":31683,"token":false,"name":"Leeching Sliver","scryfallId":"888ca52b-1270-4587-804d-1d08b07d7c5d"},{"index":31685,"token":false,"name":"Vithian Stinger","scryfallId":"dbca500a-f349-4873-a2d5-f8dfbd957a3d"},{"index":31687,"token":false,"name":"Yasharn, Implacable Earth","scryfallId":"7cc89118-9546-4ef7-acf2-196edfdd5a27"},{"index":31691,"token":false,"name":"Accursed Witch // Infectious Curse","scryfallId":"8093f8b0-5d50-48ca-b616-e92535a47138"},{"index":31697,"token":false,"name":"Snare the Skies","scryfallId":"28f75827-a144-4fe2-a713-4439ae7567eb"},{"index":31705,"token":false,"name":"Teferi's Imp","scryfallId":"048f2368-0e2f-4197-b977-353d38b38ccc"},{"index":31707,"token":false,"name":"Ajani, Mentor of Heroes","scryfallId":"596f6812-2cee-4f0b-b1e5-ddf1f57c3f95"},{"index":31710,"token":false,"name":"Gaea's Revenge","scryfallId":"68f610a9-73b0-4ef8-b725-f3eee1b78fad"},{"index":31712,"token":false,"name":"Heavy Ballista","scryfallId":"9c587228-b633-4049-beb8-e45aae967167"},{"index":31716,"token":false,"name":"Run Afoul","scryfallId":"bd328139-0dc1-403b-ad79-b1cf3479ac33"},{"index":31719,"token":false,"name":"Marchesa's Infiltrator","scryfallId":"e9ac1e2c-1b9c-43b8-819e-9b391967e16c"},{"index":31721,"token":false,"name":"Essence Flare","scryfallId":"13ebb5dd-d7f1-4b06-8585-7004045be542"},{"index":31724,"token":false,"name":"Intellectual Offering","scryfallId":"63de9e39-3c16-452f-9f06-4c1298752f57"},{"index":31725,"token":false,"name":"Empyreal Voyager","scryfallId":"4554b10e-9c3e-4eb4-b0fe-044e483e872f"},{"index":31727,"token":false,"name":"Hidden Path","scryfallId":"cbc93c0b-0ac8-4b8f-b2f6-96887d1acd77"},{"index":31734,"token":false,"name":"Clan Guildmage","scryfallId":"34a18415-015c-4d3f-8042-b156a673e125"},{"index":31735,"token":false,"name":"Crown of Vigor","scryfallId":"e7e320a6-88e2-4be1-97e2-30e0f3c2e450"},{"index":31736,"token":false,"name":"Commander Eesha","scryfallId":"3607f6a9-b8d2-4119-9f70-95dcedc0662d"},{"index":31739,"token":false,"name":"Inspire Awe","scryfallId":"b23c8b5a-2e18-4dd8-b236-5b1fd356f867"},{"index":31740,"token":false,"name":"Ojutai Interceptor","scryfallId":"59a84666-ad2b-494c-b52b-ecee14788ef2"},{"index":31741,"token":false,"name":"Mindblade Render","scryfallId":"1f994e2b-1784-4bb7-9784-ac2de600cf5f"},{"index":31743,"token":false,"name":"Disciple of Malice","scryfallId":"74cc7ab0-a5db-4ae9-af9a-89fd5aaaab57"},{"index":31746,"token":false,"name":"Barbed Battlegear","scryfallId":"03b80b2f-8d07-4ad3-9b20-4ba0fe9f37a2"},{"index":31747,"token":false,"name":"Sarkhan Vol","scryfallId":"181e20e9-94a2-40b6-abc4-797f588866bf"},{"index":31748,"token":false,"name":"Decomposition","scryfallId":"b0ea46a1-ea65-4802-812c-4f0e0f3088d2"},{"index":31753,"token":false,"name":"Wandering Eye","scryfallId":"2869efd2-060f-4af3-b0dc-b7dc5e1143b8"},{"index":31754,"token":false,"name":"Fated Infatuation","scryfallId":"9e5ba99d-d95d-4a3b-b6b6-a5e2589d538e"},{"index":31755,"token":false,"name":"Maelstrom Djinn","scryfallId":"9c102f29-6f3f-4f97-8177-4307586bd1b2"},{"index":31758,"token":false,"name":"Swarm Guildmage","scryfallId":"7599adc7-72b2-4079-ac0a-1a821f9de925"},{"index":31762,"token":false,"name":"Trudge Garden","scryfallId":"ca77dda1-d21f-47db-8f6f-778eadaefb1d"},{"index":31767,"token":false,"name":"Corrupting Licid","scryfallId":"c12c6548-20e6-4697-ba26-e711590f9e28"},{"index":31768,"token":false,"name":"Kaervek's Torch","scryfallId":"0a1624ab-e50e-48a3-acf7-457069914616"},{"index":31775,"token":false,"name":"Chasm Drake","scryfallId":"5e7e246d-92f8-4e6e-89fc-991b888fc1e8"},{"index":31783,"token":false,"name":"Aether Shockwave","scryfallId":"aec2b3f1-715e-4de4-9bf0-d309afba75ec"},{"index":31786,"token":false,"name":"Arsenal Thresher","scryfallId":"f63c72f4-fbce-41c5-a46f-bfe4d1833965"},{"index":31791,"token":false,"name":"Gnostro, Voice of the Crags","scryfallId":"c171f179-9ccf-4819-915c-7f2cd3a91ad8"},{"index":31797,"token":false,"name":"Shivan Emissary","scryfallId":"945c596e-492e-4cf5-857c-4ddbbdd78485"},{"index":31809,"token":false,"name":"Makindi Griffin","scryfallId":"05c4a9c4-20d5-457d-9127-c27b8768255a"},{"index":31811,"token":false,"name":"Sin Collector","scryfallId":"b00e9e15-0f1c-4a40-9391-98a14eacc170"},{"index":31812,"token":false,"name":"Bladetusk Boar","scryfallId":"1558dfaf-15ed-4220-9051-bf0bf442b2e9"},{"index":31815,"token":false,"name":"Mark of Sakiko","scryfallId":"7611a97d-6500-4311-baa1-be3ee0791f3a"},{"index":31817,"token":false,"name":"Quagnoth","scryfallId":"335c3aa3-af89-44ce-955a-69e12d83175f"},{"index":31825,"token":false,"name":"Eater of Days","scryfallId":"ef6870db-8aca-4aee-8e4d-c56a7d8dc242"},{"index":31828,"token":false,"name":"Jagged-Scar Archers","scryfallId":"0f6ff643-461c-428b-8420-3b3393bbb003"},{"index":31831,"token":false,"name":"Perilous Vault","scryfallId":"25f9c83e-00fb-4574-bdca-b4162f7ba353"},{"index":31833,"token":false,"name":"Blade Banish","scryfallId":"35a30091-7f68-4a67-b47e-f44318fc93b2"},{"index":31840,"token":false,"name":"Yuan Shao, the Indecisive","scryfallId":"5e9b3794-d0f0-4d28-85cb-22492e195ae1"},{"index":31841,"token":false,"name":"Kozilek's Pathfinder","scryfallId":"b75585bd-fdd8-44d1-8c7c-b96df5fc473e"},{"index":31844,"token":false,"name":"Aluren","scryfallId":"268403bc-733d-446e-a7c1-abc957c42bc2"},{"index":31845,"token":false,"name":"Mardu Hateblade","scryfallId":"f1d1cdfa-834c-4028-8036-c4bfb7da071b"},{"index":31846,"token":false,"name":"Army Ants","scryfallId":"7e129be5-e2c5-4f69-b8e8-539ac2085c7a"},{"index":31849,"token":false,"name":"Fiery Impulse","scryfallId":"5b81a589-44bf-4441-9079-1ae66d067519"},{"index":31851,"token":false,"name":"Glacial Grasp","scryfallId":"381d84d6-7b34-44cb-a697-54b835ba1281"},{"index":31854,"token":false,"name":"Marjhan","scryfallId":"047ac2cb-3a96-4ff6-8b5a-251399974c47"},{"index":31859,"token":false,"name":"Sunbond","scryfallId":"9f14bbff-8a3c-4aa0-a5aa-0dd6cb23b2a3"},{"index":31860,"token":false,"name":"Decommission","scryfallId":"1cca66e9-be21-4fc7-8951-cd99e9b213dc"},{"index":31863,"token":true,"name":"Minions","scryfallId":"1531c478-ae50-4c59-9396-4c0ac059e6f0"},{"index":31865,"token":false,"name":"Firefist Striker","scryfallId":"ccbc2f22-4500-4c74-a1a2-51d8238c1d16"},{"index":31867,"token":false,"name":"Proud Wildbonder","scryfallId":"f4876e17-a206-4351-9c0b-0845db4569a3"},{"index":31876,"token":false,"name":"Auramancer's Guise","scryfallId":"c787368d-d208-4aac-936d-b0c189d1cd90"},{"index":31878,"token":false,"name":"Inevitable Betrayal","scryfallId":"28c015a6-dc4c-49f6-8d39-4c7b598e5a61"},{"index":31879,"token":false,"name":"Summit Apes","scryfallId":"367e7821-44f1-4064-a9a3-d9852c7c235c"},{"index":31886,"token":false,"name":"Damping Field","scryfallId":"12ab9836-bc90-4d92-a86d-b8e1b7671aa7"},{"index":31887,"token":false,"name":"Wolfbitten Captive // Krallenhorde Killer","scryfallId":"1303e02a-ef69-4817-bca5-02c74774b811"},{"index":31892,"token":false,"name":"Soothsayer Adept","scryfallId":"eb93c9d2-88eb-403d-bb67-8e8b0462ac27"},{"index":31893,"token":false,"name":"Skyshroud Ranger","scryfallId":"efe01296-2b8b-4cdf-a041-a08bebea9c29"},{"index":31894,"token":false,"name":"Arcum's Sleigh","scryfallId":"e9780ce2-756c-48e5-9936-45f6a224f61d"},{"index":31898,"token":false,"name":"Sphinx Ambassador","scryfallId":"b0937274-d5cb-4790-8c10-804f537c5581"},{"index":31899,"token":false,"name":"Reparations","scryfallId":"0a9edf28-79c0-42a5-af0f-6df9c3a1f546"},{"index":31903,"token":false,"name":"Kelpie Guide","scryfallId":"0112ebfb-55ad-401c-9dc5-ffd829f5b5bf"},{"index":31904,"token":false,"name":"Liesa, Shroud of Dusk","scryfallId":"ed90b377-8f27-47fc-a004-0f84f4ad6490"},{"index":31908,"token":true,"name":"1997 World Championships Ad","scryfallId":"40b9dcb9-05c1-4a2e-b0cb-6554483ca5c9"},{"index":31912,"token":false,"name":"Lay Bare","scryfallId":"0454c2a8-b17d-4cdf-8562-9a28bc6cf0be"},{"index":31914,"token":false,"name":"Quicksilver Elemental","scryfallId":"2905f6ac-d054-454b-8e1a-9c32db13a581"},{"index":31917,"token":false,"name":"Bloodsworn Steward","scryfallId":"e185f493-57c3-47dd-8dac-de8690ce8fbc"},{"index":31918,"token":true,"name":"Tuktuk the Returned Token (Colorless, 5/5)","scryfallId":"11f55fa2-bb6f-4609-85ec-72703638fbd9"},{"index":31923,"token":false,"name":"Veil of Secrecy","scryfallId":"329ae5c2-4f97-4315-b03f-c061eed3ed79"},{"index":31926,"token":false,"name":"Vizier of the Menagerie","scryfallId":"e27d4f0e-508c-4bd4-bb47-c75802ca85f8"},{"index":31932,"token":false,"name":"Woodripper","scryfallId":"5126b782-d74c-40ca-a9b2-a6c78f94d138"},{"index":31933,"token":false,"name":"Renounce the Guilds","scryfallId":"bc9acc14-24e0-4c03-a09a-2afee351f2cc"},{"index":31936,"token":false,"name":"Ring of Immortals","scryfallId":"61706102-67fd-4167-bd7d-ec6da41db362"},{"index":31941,"token":false,"name":"Sygg, River Cutthroat","scryfallId":"3926f037-aaec-416e-a486-b59aae6faf44"},{"index":31942,"token":false,"name":"Glimpse of Freedom","scryfallId":"c1e9c025-1cdb-4da8-8d28-14ad5efb512d"},{"index":31943,"token":false,"name":"Soratami Cloudskater","scryfallId":"5e3d3024-bef2-4b50-ab84-8ae2a23cdf27"},{"index":31947,"token":false,"name":"Whirlermaker","scryfallId":"ff1a1246-d5a0-43dc-825a-062a3bb4def9"},{"index":31949,"token":false,"name":"Eye of Doom","scryfallId":"b48d431d-3ead-417e-8f2a-0189bd1ef9f3"},{"index":31955,"token":false,"name":"Izzet Cluestone","scryfallId":"8cf63def-e2cc-48c7-8409-c08a36eddf93"},{"index":31956,"token":false,"name":"Sacellum Archers","scryfallId":"160335df-8377-4f72-9d3f-4b1492bd23ea"},{"index":31958,"token":false,"name":"Lightning Skelemental","scryfallId":"5734012b-31db-4125-8fea-c88666969cd6"},{"index":31966,"token":false,"name":"Skyship Plunderer","scryfallId":"ec78ef7e-f969-4d7a-a5ea-fe4905ab0c94"},{"index":31974,"token":false,"name":"God-Pharaoh's Statue","scryfallId":"7dce06ba-c1e1-45ec-82a7-fc10b0fa8870"},{"index":31977,"token":false,"name":"Dauntless Onslaught","scryfallId":"aae001aa-10a0-482a-86fe-bf6ca7fc0866"},{"index":31982,"token":false,"name":"Rakdos Cackler","scryfallId":"5f873c0b-e779-4f09-8e9c-94a1765eb5da"},{"index":31983,"token":false,"name":"Lens Flare","scryfallId":"7d92f037-a121-428a-ac53-98437366ecfd"},{"index":31989,"token":false,"name":"Assembly Hall","scryfallId":"1676ccbb-91d2-4f26-b3a5-ccb1a21bdebf"},{"index":31990,"token":false,"name":"Temporal Spring","scryfallId":"b584dfd1-a56c-406e-8504-47ea136dc102"},{"index":32000,"token":false,"name":"Body of Knowledge","scryfallId":"786ae686-0790-4ba1-927f-523984331549"},{"index":32001,"token":false,"name":"Shenanigans","scryfallId":"0123a56a-04e5-4fb3-aaae-c8b9193be17b"},{"index":32003,"token":false,"name":"Ponyback Brigade","scryfallId":"192d77ef-e8b5-44e2-842b-2c1f342c1e69"},{"index":32004,"token":false,"name":"Entomber Exarch","scryfallId":"379c81d8-804b-4fe6-80df-8a4246fbf695"},{"index":32007,"token":false,"name":"Rend Flesh","scryfallId":"92b300a3-e6a8-4ca9-bb26-03f57b5ff6ec"},{"index":32008,"token":false,"name":"Swirling Spriggan","scryfallId":"303d057c-c51c-46bb-b8fe-aabe7f3b07b6"},{"index":32010,"token":false,"name":"Bontu's Last Reckoning","scryfallId":"9aae9aa6-b989-4bc8-ad04-51d833b91dcc"},{"index":32012,"token":false,"name":"Spirit Loop","scryfallId":"31ffb2e6-b1bc-41c5-9e52-294c060b1d45"},{"index":32020,"token":false,"name":"Unstable Frontier","scryfallId":"d97e739f-8675-488e-be2b-4e455fbe390b"},{"index":32021,"token":false,"name":"Unraveling Mummy","scryfallId":"fe3802f3-feb3-4dcd-a5ba-f493baf3d447"},{"index":32024,"token":false,"name":"Chandra, Flamecaller","scryfallId":"abe0031a-d8ed-4ff8-9f24-2f553063f119"},{"index":32027,"token":false,"name":"Plated Slagwurm","scryfallId":"941fa83a-cb61-47b1-83a7-7ce7e894c338"},{"index":32029,"token":false,"name":"Steam Frigate","scryfallId":"ec3193cb-2c00-4ef8-bf2e-d3b1e3b875a3"},{"index":32033,"token":false,"name":"Ronin Warclub","scryfallId":"46ad31cd-38dc-4fd3-b9e4-8988f4898719"},{"index":32034,"token":false,"name":"Thraximundar","scryfallId":"7574ea35-6bd8-4615-b42a-6d90408aba23"},{"index":32035,"token":false,"name":"Mishra, Artificer Prodigy","scryfallId":"d5deaec5-499d-4e19-b879-8bcd1dc35f3e"},{"index":32037,"token":false,"name":"Fountain of Ichor","scryfallId":"b022a628-4883-427a-8477-0e87d1a71028"},{"index":32042,"token":false,"name":"Book Burning","scryfallId":"bead678c-7b6a-4668-9919-623312e08a65"},{"index":32043,"token":false,"name":"Ashmouth Hound","scryfallId":"a2b4cbb7-c9ad-4320-9322-a6a3afbc4a50"},{"index":32046,"token":false,"name":"Glint-Eye Nephilim","scryfallId":"f4737444-19a0-44ef-9466-ee12b7e248f7"},{"index":32048,"token":false,"name":"Carrier Thrall","scryfallId":"bd2ab895-9225-4eba-90c3-4023db4f8b70"},{"index":32050,"token":false,"name":"Warrior's Charge","scryfallId":"8668e4af-ae89-4fab-8015-8dc643c6cd36"},{"index":32057,"token":false,"name":"Silumgar Assassin","scryfallId":"818034cf-8b55-4c9b-b265-b08c23fb0aef"},{"index":32060,"token":false,"name":"General Jarkeld","scryfallId":"6a4f5a28-0bd2-4cc4-b67f-324e89193caa"},{"index":32061,"token":true,"name":"Soldier // Goblin Token (R/W, 1/1)","scryfallId":"f78c0976-83c4-4694-a93f-13046902cdd9"},{"index":32065,"token":false,"name":"Garza Zol, Plague Queen","scryfallId":"046a01ee-54d5-4942-b176-4c9ceedea2d6"},{"index":32068,"token":false,"name":"Joyous Respite","scryfallId":"1e33847f-fa55-4b2e-9d88-9a9e118b5cc8"},{"index":32069,"token":false,"name":"Carrion Crow","scryfallId":"97d80cc4-f3be-4306-8126-e60f7b00d384"},{"index":32074,"token":false,"name":"Aeon Engine","scryfallId":"ea4dfdd7-f35a-45d6-9fc7-2c096f92dd5f"},{"index":32075,"token":false,"name":"Jaya Ballard, Task Mage","scryfallId":"a1f85b2a-7836-4058-87a5-859c4311a7e4"},{"index":32076,"token":false,"name":"Vish Kal, Blood Arbiter","scryfallId":"926d6c8b-88c1-46f9-ba3c-5ddd8328e421"},{"index":32079,"token":false,"name":"Unexplained Disappearance","scryfallId":"9c99b239-50d2-4393-80ec-94dbfaa6ae70"},{"index":32084,"token":false,"name":"Phenax, God of Deception","scryfallId":"73f9e502-23a3-4f1c-af10-e6c48a5262b2"},{"index":32091,"token":false,"name":"Volrath, the Shapestealer","scryfallId":"a149d6a5-c865-475a-87b7-596a19f6c80d"},{"index":32093,"token":false,"name":"Dwarven Vigilantes","scryfallId":"077d33bb-41bf-440d-939b-67ab5aacb092"},{"index":32094,"token":false,"name":"Jushi Apprentice // Tomoya the Revealer","scryfallId":"33a8e5b9-6bfb-4ff2-a16d-3168a5412807"},{"index":32097,"token":false,"name":"Ghostform","scryfallId":"347760a1-03f5-4cc9-87ad-e08986b1ea21"},{"index":32101,"token":false,"name":"Stampeding Elk Herd","scryfallId":"7e55e213-6eab-4086-96cd-024de6150fbe"},{"index":32103,"token":false,"name":"Thirsting Axe","scryfallId":"f47e5303-c07a-4be0-a314-bf5739a856e5"},{"index":32104,"token":false,"name":"Bolt Hound","scryfallId":"9f8cf3f9-4e3b-4af2-b5ef-a97eb1d2b674"},{"index":32105,"token":false,"name":"Akoum Firebird","scryfallId":"3d637cb2-b770-4637-a75c-c2ed9e562538"},{"index":32106,"token":false,"name":"Aven Squire","scryfallId":"60301dbd-40d1-4af8-8e2b-797febfa859f"},{"index":32108,"token":false,"name":"Avatar of Growth","scryfallId":"f524a232-7158-4f85-880e-fede2f9d35d1"},{"index":32110,"token":false,"name":"Onyx Mage","scryfallId":"eabd38e6-1e59-42d2-bd1a-555c77cf6747"},{"index":32117,"token":false,"name":"Marker Beetles","scryfallId":"5cbd3c78-197a-40b9-94d1-bbb1ec1e64b1"},{"index":32119,"token":false,"name":"Spellbinder","scryfallId":"4d193d4f-1beb-4938-b3fb-b2e96d0c9ec4"},{"index":32120,"token":false,"name":"Argothian Elder","scryfallId":"49216e44-5fa2-4140-b0c5-8b5a647f54e9"},{"index":32122,"token":false,"name":"Muse Vessel","scryfallId":"10482209-19b1-4941-9133-f2764eeba092"},{"index":32124,"token":false,"name":"Promise of Loyalty","scryfallId":"fc21e7d5-3641-47fe-add0-8becf5173e28"},{"index":32126,"token":false,"name":"Warmonger Hellkite","scryfallId":"e555b5af-48ed-4682-bf9a-f9f145548e18"},{"index":32129,"token":false,"name":"Chaos Harlequin","scryfallId":"ec7d7c80-4e3c-454e-b2ed-6f0436df19c9"},{"index":32132,"token":false,"name":"Vampire Revenant","scryfallId":"2bd3a6c6-33b8-4530-9d80-c488898afd6e"},{"index":32137,"token":false,"name":"Desert Sandstorm","scryfallId":"588ad2bf-405d-4c36-b485-e415c22f2703"},{"index":32142,"token":false,"name":"Dread Warlock","scryfallId":"4f964660-c2db-4995-bb16-65383362cf19"},{"index":32144,"token":false,"name":"Blood Cultist","scryfallId":"fb468da0-b72b-4b46-994a-20677206ffb7"},{"index":32146,"token":false,"name":"Poet's Quill","scryfallId":"685473bf-1f68-4dc7-8353-d950a7b8526b"},{"index":32151,"token":false,"name":"Propeller Pioneer","scryfallId":"cee60224-960a-4f92-996a-7b0b878109e4"},{"index":32153,"token":false,"name":"Pack Rat","scryfallId":"f3864bc8-f86e-4c41-b454-e19d1939147b"},{"index":32154,"token":false,"name":"Venomous Fangs","scryfallId":"f5ae1348-c063-4ec8-9d8c-3d19a6421800"},{"index":32155,"token":false,"name":"Autochthon Wurm","scryfallId":"7002a87b-a55f-42ec-b247-119a3229129f"},{"index":32160,"token":false,"name":"Crown of Skemfar","scryfallId":"e6297586-8953-408e-a38c-2239d45807e1"},{"index":32161,"token":false,"name":"Soldevi Excavations","scryfallId":"4678132d-85bc-49cc-b3be-62cf709de42b"},{"index":32163,"token":false,"name":"Torch Song","scryfallId":"6ba8cdf0-492a-4e64-9143-4ccb29ba1d56"},{"index":32165,"token":false,"name":"Murkfiend Liege","scryfallId":"bcd7296c-ace8-43ea-8164-c69f8843d022"},{"index":32171,"token":false,"name":"Lair Delve","scryfallId":"604948d8-6224-45ca-9ebb-d716644bbfd0"},{"index":32175,"token":false,"name":"Bonesplitter Sliver","scryfallId":"705e29c5-2d9b-44ad-a04c-9a62dd74eb12"},{"index":32176,"token":false,"name":"Howltooth Hollow","scryfallId":"5c678643-6640-49e1-a5b0-2954123bcabc"},{"index":32193,"token":false,"name":"Scent of Ivy","scryfallId":"a56b4894-b959-4d00-b631-95d26eb85a4e"},{"index":32196,"token":false,"name":"Painter's Servant","scryfallId":"599c303c-7040-4a96-a5d4-cfe8489baaae"},{"index":32197,"token":false,"name":"Gulf Squid","scryfallId":"bf424982-a0ab-4db9-8889-f3cef10966c6"},{"index":32202,"token":false,"name":"Kangee's Lieutenant","scryfallId":"a0f431b3-6f4e-40a5-b9d1-f2c67b70544d"},{"index":32204,"token":false,"name":"King of the Pride","scryfallId":"c4e83abd-6f15-491e-9253-90af9f6f1025"},{"index":32209,"token":false,"name":"Tideshaper Mystic","scryfallId":"e526ebbf-2041-4c3e-9a20-73bbf6f90251"},{"index":32210,"token":false,"name":"Watchdog","scryfallId":"8c2ffc07-9993-40de-b36e-33c7afd4cfc2"},{"index":32215,"token":false,"name":"Oakgnarl Warrior","scryfallId":"7d508a8e-badf-4167-bf92-89d54c8662f5"},{"index":32216,"token":false,"name":"Faith's Reward","scryfallId":"fa19fe94-0302-4d08-9821-fa0db722048a"},{"index":32218,"token":false,"name":"Thornbite Staff","scryfallId":"c1ab3225-64a9-411e-b22b-1869e958b8e5"},{"index":32227,"token":false,"name":"Taniwha","scryfallId":"72d12315-4220-470d-9628-b9a3ea904ca7"},{"index":32239,"token":false,"name":"Goblin Bangchuckers","scryfallId":"b56ddad0-23ea-4139-a200-c76c9c46e8c5"},{"index":32244,"token":false,"name":"Patriarch's Desire","scryfallId":"309bc2e7-bece-493d-b7ab-0e08a9f40909"},{"index":32246,"token":false,"name":"Rootwater Alligator","scryfallId":"3a840bba-4725-45fd-885f-1b3d615dfa97"},{"index":32247,"token":false,"name":"Volition Reins","scryfallId":"aa8fa025-56e6-4d24-a615-a51b6be937e9"},{"index":32249,"token":false,"name":"Assert Authority","scryfallId":"fc339ed7-e1d4-4fe9-a4c4-b030d3e74c00"},{"index":32250,"token":false,"name":"Burden of Greed","scryfallId":"d37abcf5-f009-4258-bf32-b93b47cb71dc"},{"index":32256,"token":false,"name":"Labyrinth Raptor","scryfallId":"e6b4a7b3-9eb3-4f96-b151-8b1c4c85118b"},{"index":32258,"token":false,"name":"Nekusar, the Mindrazer","scryfallId":"da08bf11-6f6f-45a6-b0c1-83bcc5efecfb"},{"index":32260,"token":false,"name":"Magebane Armor","scryfallId":"95b0f586-a100-4817-93f8-1ee2df39ce03"},{"index":32263,"token":false,"name":"Fiery Conclusion","scryfallId":"104365ec-7452-4542-b409-b7eb5d314735"},{"index":32265,"token":false,"name":"Ferocity","scryfallId":"4afda489-8397-4ad4-89dc-e8bad92db133"},{"index":32267,"token":false,"name":"Palisade Giant","scryfallId":"fdfd37ca-e4c9-4674-a75f-15d8ebcce72b"},{"index":32268,"token":true,"name":"Gremlin Token (R, 2/2)","scryfallId":"c6071fed-39c1-4f3b-a821-1611aedd8054"},{"index":32273,"token":false,"name":"Mosstodon","scryfallId":"05afd921-ef3b-40fe-a1a8-582ee94ed3f0"},{"index":32277,"token":false,"name":"Ghostfire Blade","scryfallId":"711145d8-5178-4fdc-8494-4ab680f55b1a"},{"index":32284,"token":false,"name":"Civilized Scholar // Homicidal Brute","scryfallId":"7bf864db-4754-433d-9d77-6695f78f6c09"},{"index":32285,"token":false,"name":"Circle of Affliction","scryfallId":"1f059cd0-7924-495e-bac4-021f0e46bb87"},{"index":32286,"token":false,"name":"Captured by the Consulate","scryfallId":"e0c20018-4446-4c2b-bdc5-53fcf1fbc3bf"},{"index":32287,"token":false,"name":"Inquisitor's Snare","scryfallId":"c607ec00-2d44-485e-ad85-24c0c7a284f9"},{"index":32292,"token":false,"name":"Possessed Skaab","scryfallId":"6ebc94e5-a595-43ab-929b-426009190669"},{"index":32293,"token":false,"name":"Scout's Warning","scryfallId":"e6639e3d-b0c4-4c08-83d5-f3fc58fac9b2"},{"index":32294,"token":false,"name":"Mana Prism","scryfallId":"81137c17-18b8-484e-8334-28f143c08177"},{"index":32296,"token":false,"name":"Covetous Dragon","scryfallId":"ffb65fe6-1a7a-4357-9567-bbb53cd5266e"},{"index":32299,"token":false,"name":"Outnumber","scryfallId":"a1214fc4-26ac-4a57-b894-6fd634d4d4fd"},{"index":32302,"token":false,"name":"Ember Shot","scryfallId":"6a9eb72b-9ae2-4b64-bbb9-187446b5fd2f"},{"index":32305,"token":false,"name":"Jeweled Spirit","scryfallId":"b0d3e681-bd4b-41e9-8db4-083172f3caad"},{"index":32307,"token":false,"name":"Mage-Ring Bully","scryfallId":"1a129f22-dd7e-4b2c-a514-a2ac55bb5661"},{"index":32310,"token":false,"name":"Monologue Tax","scryfallId":"4c1d9656-7a27-4142-a307-cca3449cf42b"},{"index":32316,"token":false,"name":"Shauku, Endbringer","scryfallId":"06d94b21-7568-4e5c-a8ec-ff5bb48a4f36"},{"index":32317,"token":false,"name":"Warchanter Skald","scryfallId":"f79c5e95-f6c6-4e2f-9c6c-d99addb757ac"},{"index":32323,"token":false,"name":"Surge of Zeal","scryfallId":"b6c07fa6-b575-46f9-ab39-fb777d4b8acd"},{"index":32325,"token":false,"name":"Warren Pilferers","scryfallId":"bc98177b-34a6-44e1-9abd-6fd8df09fc70"},{"index":32329,"token":false,"name":"Seaside Haven","scryfallId":"9c940a6b-3c5e-4ce2-92b6-63e2cb575c15"},{"index":32331,"token":false,"name":"Drudge Sentinel","scryfallId":"13cacdf2-d325-444a-900b-2d0f90c89ca2"},{"index":32336,"token":false,"name":"Riot Ringleader","scryfallId":"c043f30b-548f-4c31-a415-0e59c2841dcf"},{"index":32340,"token":false,"name":"First Response","scryfallId":"36341d37-064e-449e-8be7-a2716ae7e317"},{"index":32344,"token":false,"name":"Mobilized District","scryfallId":"78e8e836-906e-4636-9677-a9f7781a1fba"},{"index":32346,"token":false,"name":"Moonglove Extract","scryfallId":"2d016c5f-265b-4426-8dd8-87872f075f33"},{"index":32351,"token":false,"name":"Monstrous Step","scryfallId":"893f300b-a823-4156-90f2-0636e9f499b0"},{"index":32354,"token":false,"name":"Fortress Cyclops","scryfallId":"39f835f0-abba-402c-bdae-be03ad3fb658"},{"index":32360,"token":false,"name":"Citywide Bust","scryfallId":"8469c788-5c11-40e3-b825-8b14dc5c5575"},{"index":32374,"token":false,"name":"Headwater Sentries","scryfallId":"2af2c338-f5e9-4596-9435-c6aa965ae541"},{"index":32376,"token":false,"name":"Seize the Initiative","scryfallId":"6d745f35-944a-4157-a351-baa06f67b725"},{"index":32380,"token":false,"name":"Wispmare","scryfallId":"56389c91-a470-4c43-9368-98df4d38f7fd"},{"index":32383,"token":false,"name":"Raging Gorilla","scryfallId":"07c284ce-33b8-4fb2-9dd9-4c477bedc774"},{"index":32386,"token":false,"name":"Bonethorn Valesk","scryfallId":"297d7326-ad03-464d-97e2-443042d48f92"},{"index":32391,"token":false,"name":"Youthful Scholar","scryfallId":"43ae8147-bf25-44f9-b75f-837b81ebe0de"},{"index":32392,"token":true,"name":"Soldier Token (W, 1/2)","scryfallId":"3d5c2f87-f0c9-4188-9b20-1c2a1d3c4f45"},{"index":32394,"token":false,"name":"Angrath, Minotaur Pirate","scryfallId":"f17103dd-f31b-4f6e-b2ea-4ea91815bdd6"},{"index":32396,"token":false,"name":"Stitcher's Graft","scryfallId":"eb6d700e-0514-41d7-9255-cedd859316fc"},{"index":32398,"token":false,"name":"Llanowar Knight","scryfallId":"e6c75d89-e432-49aa-a407-555b223b7eff"},{"index":32401,"token":false,"name":"Plaguemaw Beast","scryfallId":"a4a7c67d-d287-4207-8820-9d186949af52"},{"index":32402,"token":false,"name":"Vengeful Warchief","scryfallId":"d405e1bc-bf58-4cce-8abe-57fb40ef0996"},{"index":32405,"token":false,"name":"Vildin-Pack Outcast // Dronepack Kindred","scryfallId":"460f7733-c0a6-4439-a313-7b26ae6ee15b"},{"index":32410,"token":false,"name":"Children of Korlis","scryfallId":"221a5895-bc21-4f10-b5fc-a4980fde843e"},{"index":32416,"token":false,"name":"Lore Weaver","scryfallId":"5493d051-4dcc-4415-a1ad-368f260257f5"},{"index":32418,"token":false,"name":"Burglar Rat","scryfallId":"e9f7f218-fd2a-4233-8753-065ddc314f2d"},{"index":32419,"token":false,"name":"Reaper King","scryfallId":"1b3463a8-79f6-4fec-afd6-ad8c412d648c"},{"index":32420,"token":false,"name":"Pillardrop Rescuer","scryfallId":"0884666e-8f9b-44b1-a1e3-c1c8941e2152"},{"index":32423,"token":false,"name":"Jace's Scrutiny","scryfallId":"3d0eea0d-c790-4d91-962f-f05b22d0c8fa"},{"index":32424,"token":false,"name":"Belligerent Brontodon","scryfallId":"5b0570bc-1ef5-4767-b40a-b9c878599724"},{"index":32433,"token":false,"name":"Parapet","scryfallId":"a7bbcaa9-edbf-48ad-bcd2-65e8fb9bb938"},{"index":32434,"token":false,"name":"Well of Life","scryfallId":"bf3f4fc3-3819-470d-92d9-98cb390f89b9"},{"index":32436,"token":false,"name":"Dracoplasm","scryfallId":"3560556c-f1d3-4d69-afe7-c2a5fa2a5c3d"},{"index":32442,"token":false,"name":"Emeria Captain","scryfallId":"6490370e-fff5-4f17-b715-74ff8df5bc7c"},{"index":32444,"token":false,"name":"Goblin Kaboomist","scryfallId":"80e1d85a-18e5-4c6a-85fd-a009bd8fda38"},{"index":32451,"token":false,"name":"Phyrexian Debaser","scryfallId":"cd434b31-a92a-4e0e-aabd-4d3e77ff6dcc"},{"index":32452,"token":false,"name":"Battlefield Scavenger","scryfallId":"c5adb7de-47f0-4969-85dc-6b64f04b9517"},{"index":32455,"token":false,"name":"Heidar, Rimewind Master","scryfallId":"39916d65-60a6-4da6-8675-8a8ef9505772"},{"index":32463,"token":false,"name":"Absorb Vis","scryfallId":"18ed2ea8-614b-472d-979d-0d026895abca"},{"index":32464,"token":false,"name":"Spirit Mantle","scryfallId":"930c8444-ccce-411e-bc4f-e5abca749608"},{"index":32466,"token":false,"name":"Winding Way","scryfallId":"4e5d9776-b6ce-4ad6-8acc-69115ba5de76"},{"index":32477,"token":false,"name":"Vengeful Firebrand","scryfallId":"e5db7e33-188f-4d66-a58b-7b5c5760a773"},{"index":32478,"token":false,"name":"Shambling Goblin","scryfallId":"ebf11069-2eba-4636-8fbe-2bbb7ef52b29"},{"index":32484,"token":false,"name":"Angelic Shield","scryfallId":"5aaa3e4e-4e08-4df2-9e0c-66e15a10fec4"},{"index":32485,"token":false,"name":"Cantivore","scryfallId":"b5243fc3-176b-44a3-9f1a-ab069a08757a"},{"index":32486,"token":false,"name":"Riverwise Augur","scryfallId":"3ea5ac8f-f83d-47ca-a20e-3d129afb34d2"},{"index":32490,"token":false,"name":"Channeler Initiate","scryfallId":"e80a5536-212a-4763-b28d-5e2d58428e91"},{"index":32492,"token":false,"name":"Akki Underminer","scryfallId":"efdd1e22-d68d-4858-b253-80071d26d50e"},{"index":32494,"token":false,"name":"Pridemalkin","scryfallId":"df520254-0c72-496b-9222-263ca9d3c5d5"},{"index":32496,"token":false,"name":"Ice Cauldron","scryfallId":"1a3e095a-7056-4df3-bf7d-9c217d591446"},{"index":32497,"token":false,"name":"Veiled Serpent","scryfallId":"25193fd6-3156-48ff-90fa-71328ee7adf5"},{"index":32504,"token":false,"name":"Frost Titan","scryfallId":"358baa9f-390f-4b99-a274-d28f3bd56824"},{"index":32506,"token":false,"name":"Brightmare","scryfallId":"0fc18921-59f5-413f-a221-dc47d31b2ec8"},{"index":32510,"token":false,"name":"Kjeldoran Phalanx","scryfallId":"b6e91ba0-b229-4ab1-84f3-2a490dfa5051"},{"index":32515,"token":false,"name":"Apprentice Sorcerer","scryfallId":"9e1fd317-5500-40e8-ad79-323832815f81"},{"index":32517,"token":false,"name":"Barbarian Riftcutter","scryfallId":"152f4cfa-4f03-404d-a6f7-24c27505906f"},{"index":32519,"token":false,"name":"Greater Basilisk","scryfallId":"d23127ac-24ec-4038-b9bb-25d9ca0e71e0"},{"index":32521,"token":false,"name":"Aura Blast","scryfallId":"090f5ad6-e10e-49b3-8643-51a4e792517c"},{"index":32523,"token":true,"name":"Satyr Token (R, 1/1)","scryfallId":"903e30f3-580e-4a14-989b-ae0632363407"},{"index":32527,"token":false,"name":"Justiciar's Portal","scryfallId":"1df611df-3490-4b07-8034-6da9a0122a81"},{"index":32531,"token":false,"name":"Domri Rade","scryfallId":"21b48170-99dd-440f-9954-fc229d6094d3"},{"index":32532,"token":false,"name":"Caller of the Pack","scryfallId":"1286208b-896b-4f41-a837-1c8a2b199a0f"},{"index":32535,"token":false,"name":"Identity Crisis","scryfallId":"930d0de1-39af-4b08-81a3-2cca8aae5d40"},{"index":32536,"token":false,"name":"Majestic Heliopterus","scryfallId":"0a012af0-c54e-4658-8a3b-b81cc8835e1b"},{"index":32538,"token":false,"name":"Bioplasm","scryfallId":"7170a1db-3502-4caf-a54b-bd0df0d93f2d"},{"index":32542,"token":false,"name":"Wild Wanderer","scryfallId":"0d20e020-30e1-4deb-8dfc-4c5fe056193d"},{"index":32544,"token":false,"name":"Chainflinger","scryfallId":"670a5bba-a10f-41f6-88cd-cef1dfe4bfa9"},{"index":32548,"token":false,"name":"Gibbering Hyenas","scryfallId":"a252a1f5-bba5-4525-8141-57caea9624e9"},{"index":32552,"token":false,"name":"Myojin of Seeing Winds","scryfallId":"8f5f8d3a-95e7-4dd9-8510-43517eb02693"},{"index":32553,"token":false,"name":"Artifact Blast","scryfallId":"1506d99d-7b2e-4101-84a5-c950dadb263a"},{"index":32557,"token":false,"name":"Hunting Drake","scryfallId":"5b0293a9-48fe-4018-bd25-3e02c227a3dd"},{"index":32558,"token":false,"name":"Vampiric Feast","scryfallId":"9dfc875c-e79e-435a-906f-fb7e88550f01"},{"index":32565,"token":false,"name":"Squeaking Pie Sneak","scryfallId":"b7184715-3ed3-4f56-9bf3-ff431cca86be"},{"index":32569,"token":false,"name":"Ambush Viper","scryfallId":"0e386888-57f5-4eb6-88e8-5679bb8eb290"},{"index":32573,"token":false,"name":"Gaze of Pain","scryfallId":"48401643-ec4b-444a-8f9a-1a5ea471ff4a"},{"index":32574,"token":true,"name":"Angel // Demon Token (W, 4/4)","scryfallId":"4ac2b852-92b2-4daf-9d1f-f71d3b27c241"},{"index":32575,"token":false,"name":"Mark for Death","scryfallId":"45498dbd-a512-4299-800b-06c15a4fd94e"},{"index":32578,"token":false,"name":"Torch Courier","scryfallId":"020e13af-53eb-4285-b6b4-d388689e4484"},{"index":32581,"token":false,"name":"Slimefoot, the Stowaway","scryfallId":"b373739b-95e8-4142-aa4b-1590a7791b4d"},{"index":32584,"token":false,"name":"Swarm Surge","scryfallId":"837287cc-f3a4-4ba7-8518-9b1e4a53acda"},{"index":32587,"token":false,"name":"Knight of Valor","scryfallId":"25aa80ae-bb17-4e52-a269-efe75cf4c041"},{"index":32589,"token":false,"name":"Pangosaur","scryfallId":"0335d282-cd1a-4be3-8eb2-82aaee91401a"},{"index":32590,"token":false,"name":"Herald of the Sun","scryfallId":"9c62f724-7fb4-4498-b5c1-cf65d86d8e95"},{"index":32595,"token":false,"name":"Shamble Back","scryfallId":"f6913dce-05f5-4e1b-9dd9-67eb347b5be8"},{"index":32598,"token":false,"name":"Impending Doom","scryfallId":"5681db91-5dab-41e6-96f2-275ec9495e5b"},{"index":32599,"token":false,"name":"Endless Ranks of the Dead","scryfallId":"5db15c5f-80b7-4f7f-985a-9bbec3199ad9"},{"index":32601,"token":false,"name":"Blighted Cataract","scryfallId":"433cfdee-7e3c-4349-aa89-7e57723d2bf8"},{"index":32606,"token":false,"name":"Riddlemaster Sphinx","scryfallId":"037f6792-ab41-4bcd-a0a3-a4af4a801eb7"},{"index":32607,"token":false,"name":"Samut, Voice of Dissent","scryfallId":"14cbb69e-92da-4370-8cd9-b8278e7ee1f1"},{"index":32612,"token":false,"name":"Festering Mummy","scryfallId":"906c4c95-5815-44c8-8d3c-b0fda9db55a1"},{"index":32616,"token":false,"name":"Jolrael, Empress of Beasts","scryfallId":"01084157-60e5-4693-bbec-be60b0b4e04f"},{"index":32619,"token":false,"name":"Niko Defies Destiny","scryfallId":"19312f53-5b9d-4e76-91e8-65f444bb68c9"},{"index":32620,"token":false,"name":"Inquisitor's Flail","scryfallId":"3014f59d-9012-473a-8bb1-8085c6e91632"},{"index":32627,"token":false,"name":"Pact of the Serpent","scryfallId":"c5b3d118-ba4b-4a93-92a2-cd763de49d29"},{"index":32646,"token":false,"name":"Conch Horn","scryfallId":"860a9ba3-e4c4-4af9-bdfe-1ada39289fd5"},{"index":32648,"token":false,"name":"Syndic of Tithes","scryfallId":"2bafaa3b-eeaa-427f-9a73-6a1c98d257ca"},{"index":32649,"token":false,"name":"Blighted Agent","scryfallId":"cddaebde-a060-4510-8c97-68432d931987"},{"index":32657,"token":false,"name":"Fleetfoot Panther","scryfallId":"b70220d8-f81b-44a4-b92e-d66de8c1b4ce"},{"index":32660,"token":false,"name":"Fireblade Artist","scryfallId":"21e1161f-bd2c-45a7-a86b-3b2e5210f148"},{"index":32663,"token":false,"name":"Goblin Soothsayer","scryfallId":"686b847c-242c-4b91-9fa9-69c9c9f187a7"},{"index":32664,"token":false,"name":"Verity Circle","scryfallId":"3d866d26-b630-46d3-bcc2-b810c844cc89"},{"index":32668,"token":false,"name":"Multiform Wonder","scryfallId":"9cb0bf55-49aa-4bcc-b38f-7b66b03b0719"},{"index":32670,"token":false,"name":"Death's-Head Buzzard","scryfallId":"f507174c-6e8c-4711-9ce7-680413af99f6"},{"index":32674,"token":false,"name":"Grumgully, the Generous","scryfallId":"b9d50d26-3c44-4c8f-81bb-9093dacfb804"},{"index":32676,"token":false,"name":"Coastal Wizard","scryfallId":"0b8c7377-1404-44a4-9689-1fc6cdc286c8"},{"index":32682,"token":false,"name":"Ephara's Enlightenment","scryfallId":"6e480d04-9a35-463e-928e-8da3556629e6"},{"index":32684,"token":false,"name":"Convulsing Licid","scryfallId":"d5e50a1d-b9f5-4a03-a1c2-ca45ace53a52"},{"index":32690,"token":false,"name":"Steelbane Hydra","scryfallId":"91d0e54d-6e18-44a5-adc2-d875d5b6784f"},{"index":32695,"token":false,"name":"Arcbound Stinger","scryfallId":"c397ea22-93cd-498a-a493-9af841d09bf5"},{"index":32698,"token":false,"name":"Gelectrode","scryfallId":"9926e2d7-808c-412c-86f5-2c4792538b2f"},{"index":32699,"token":false,"name":"Bloodline Shaman","scryfallId":"5fdfc473-8477-4c04-a4e7-ecac1b0a5716"},{"index":32710,"token":false,"name":"Flash of Defiance","scryfallId":"3e550776-b806-4f66-8aab-e6a5dac6d5cc"},{"index":32711,"token":false,"name":"Quintorius, Field Historian","scryfallId":"06c55ef1-8e62-4d43-bd4c-b2c3c5203338"},{"index":32712,"token":false,"name":"Aura Finesse","scryfallId":"0e398a02-1456-4fae-be75-4231c968bf47"},{"index":32714,"token":false,"name":"Brass Secretary","scryfallId":"c5685cff-b607-4a81-aa47-6676ab1a5782"},{"index":32716,"token":false,"name":"Springjack Pasture","scryfallId":"c02df7f4-c664-48bd-9508-f0b4298b1ef8"},{"index":32717,"token":false,"name":"Ampryn Tactician","scryfallId":"82a2e1d9-6763-4024-a18b-982d96395553"},{"index":32718,"token":false,"name":"Oathsworn Vampire","scryfallId":"405f82d6-2991-4958-a563-572f0d298346"},{"index":32720,"token":false,"name":"Incubation Druid","scryfallId":"075bbe5d-d0f3-4be3-a3a6-072d5d3d614c"},{"index":32721,"token":false,"name":"Wilt-Leaf Liege","scryfallId":"0a0bcfad-cb7e-4b12-b308-a4a1245bd835"},{"index":32727,"token":false,"name":"Steel Leaf Paladin","scryfallId":"28e8697f-fdf3-4a1a-a84d-dd29b17336c2"},{"index":32729,"token":false,"name":"Thief of Hope","scryfallId":"0a3029b8-01e2-4419-817e-318f23d6ce04"},{"index":32732,"token":false,"name":"Locket of Yesterdays","scryfallId":"b316f198-4465-4fb5-a7a6-a92bf8eae8c1"},{"index":32734,"token":false,"name":"Stalwart Aven","scryfallId":"4248b993-87c6-42a8-b800-75d958805440"},{"index":32736,"token":false,"name":"Fight with Fire","scryfallId":"72c94d7a-cad7-438f-bc96-e6a7158ab0e6"},{"index":32737,"token":false,"name":"Pin to the Earth","scryfallId":"c04e6915-39b0-4fbc-9114-2ecf371b6f72"},{"index":32738,"token":false,"name":"Fleshpulper Giant","scryfallId":"f2726d3c-c182-4d8a-a723-0de2c5c4b152"},{"index":32739,"token":false,"name":"Wu Spy","scryfallId":"f77b8e34-e7e9-4ac6-bc21-0ef52c6696c7"},{"index":32742,"token":false,"name":"Slippery Bogle","scryfallId":"c4e4bbea-7e3f-4de0-bb01-dfd67f21c254"},{"index":32750,"token":false,"name":"Torment of Venom","scryfallId":"2f66410b-67a3-4f6a-b3ae-dcad9858a5da"},{"index":32763,"token":false,"name":"Impulsive Maneuvers","scryfallId":"d9b404c0-9ce1-4491-82fd-6dba7e6895cd"},{"index":32767,"token":false,"name":"Quest for Ancient Secrets","scryfallId":"0de22b67-968e-49e1-ae96-6dd0ee75cd54"},{"index":32776,"token":false,"name":"Brainbite","scryfallId":"925c08bd-120d-49a5-a258-bda3859c1d4c"},{"index":32780,"token":false,"name":"Mirrorworks","scryfallId":"cade6dde-1edf-44b8-a37e-a22f9207db51"},{"index":32784,"token":true,"name":"Foretell","scryfallId":"fb02637f-1385-4d3d-8dc0-de513db7633a"},{"index":32786,"token":false,"name":"Reclusive Wight","scryfallId":"384b14c6-78a0-4e82-924e-781719c8defb"},{"index":32787,"token":false,"name":"Ashiok, Nightmare Weaver","scryfallId":"599c3c9f-dfb7-4357-9d9c-9a1a4616b103"},{"index":32788,"token":false,"name":"Dragon Mask","scryfallId":"f098e329-adc8-42dd-b779-d00d9ccc3dbd"},{"index":32789,"token":false,"name":"Batterbone","scryfallId":"94266c32-774f-42fa-84d7-7b646c950587"},{"index":32791,"token":false,"name":"Guardians of Koilos","scryfallId":"bbbc615a-708a-444b-acab-871cce22694d"},{"index":32796,"token":false,"name":"Sythis, Harvest's Hand","scryfallId":"76ebe313-3452-415c-a93f-52c7467531a3"},{"index":32798,"token":false,"name":"River Delta","scryfallId":"ea335fc0-0591-4acd-9ae8-7858222770da"},{"index":32804,"token":false,"name":"Pirate's Prize","scryfallId":"48d97373-9b55-4eb7-99b6-8912f09bd0bb"},{"index":32808,"token":true,"name":"Angel // Angel Token (W, 4/4)","scryfallId":"e2235007-b02e-463b-95e1-a8bea74a0f9d"},{"index":32810,"token":false,"name":"Flames of the Blood Hand","scryfallId":"d60ce86f-1697-4613-ab7d-cc2fcf3f1810"},{"index":32813,"token":false,"name":"Faithbearer Paladin","scryfallId":"af15a774-b97f-4bc0-913d-4d2a047fed8a"},{"index":32814,"token":false,"name":"Sedraxis Specter","scryfallId":"c6ca8f2a-ee0e-4708-97d8-c1836d824d4e"},{"index":32821,"token":false,"name":"Kithkin Greatheart","scryfallId":"777d091f-7718-434f-894d-2fe40e0e67dd"},{"index":32824,"token":false,"name":"Belbe's Percher","scryfallId":"d95dcb2e-8945-47dd-ad40-b5bdcc3ea742"},{"index":32828,"token":false,"name":"Obelisk of Esper","scryfallId":"19869e75-0925-45dc-b5d9-6968fbfb35b5"},{"index":32831,"token":false,"name":"Valor","scryfallId":"ea65e470-4892-4b2b-b187-2296c7a8d46a"},{"index":32835,"token":false,"name":"Executioner's Capsule","scryfallId":"48185059-fff9-47b0-9774-ad37dee345ed"},{"index":32836,"token":false,"name":"Green Scarab","scryfallId":"0fbf9266-c97e-4666-b0fa-1802a69a62cc"},{"index":32847,"token":false,"name":"Fiery Islet","scryfallId":"a3aab13c-9d9d-4507-ae5d-da979990ae1b"},{"index":32848,"token":false,"name":"Celestial Sword","scryfallId":"2bc0e8d3-633b-4281-863f-c51c69eed0b6"},{"index":32855,"token":false,"name":"Warping Wurm","scryfallId":"a2c41d0f-f1db-4797-b245-7de12ffa3a0d"},{"index":32856,"token":false,"name":"Belbe's Armor","scryfallId":"0052158b-58d1-4416-a7ce-7c6a7595263c"},{"index":32857,"token":false,"name":"Threnody Singer","scryfallId":"242cdffb-5037-4d49-b194-4b60274a8758"},{"index":32860,"token":false,"name":"Renegade Reaper","scryfallId":"a5675655-dc9f-45ad-9cd0-ce28fba1f972"},{"index":32863,"token":false,"name":"Revered Dead","scryfallId":"f9a78d5c-27f8-4061-be89-0246fb69e752"},{"index":32878,"token":false,"name":"Banners Raised","scryfallId":"a7792df3-e2ab-4e60-abee-f24b72807107"},{"index":32879,"token":false,"name":"Shifting Sky","scryfallId":"fed441d0-b8c8-4d63-80ff-cc4fb47d0b26"},{"index":32881,"token":false,"name":"Sixth Sense","scryfallId":"e564db6b-0b8b-4c67-9135-5da76d2225fe"},{"index":32882,"token":false,"name":"Blinding Drone","scryfallId":"4eb60957-0811-40c3-a92b-cce3e6a94745"},{"index":32885,"token":false,"name":"Scuttling Sliver","scryfallId":"e0e63efe-b5ec-426e-8860-a881c495c39e"},{"index":32894,"token":false,"name":"Farrelite Priest","scryfallId":"e11bf79b-a951-4d0c-acdf-d8ba5290a648"},{"index":32899,"token":false,"name":"Ondu Champion","scryfallId":"7206cdd5-3f86-4415-a236-9b331b4ac42a"},{"index":32901,"token":false,"name":"Abomination of Gudul","scryfallId":"7df9759e-1072-4a6a-be57-f73b15bf3847"},{"index":32902,"token":false,"name":"Druid of the Anima","scryfallId":"de32bf78-73c2-4cd4-b3b3-ef8be53e1e5e"},{"index":32909,"token":false,"name":"Tenement Crasher","scryfallId":"44af9170-bd99-4fde-b673-62d988312b2d"},{"index":32910,"token":false,"name":"The Locust God","scryfallId":"b398f212-62c3-40fa-acee-ccb4233b4954"},{"index":32920,"token":false,"name":"Roilmage's Trick","scryfallId":"d2194713-c08c-4fba-8e31-bb67c9932173"},{"index":32923,"token":false,"name":"Tidal Control","scryfallId":"cb9a7b7d-3d37-4bb6-ab48-1fec2bfb4fdc"},{"index":32928,"token":false,"name":"Lys Alana Scarblade","scryfallId":"58b3b63d-fabb-46ad-aabe-1e9fb34b4f8c"},{"index":32929,"token":false,"name":"Viashino Heretic","scryfallId":"143e435e-e3a1-45b0-81c3-bd47916df8ac"},{"index":32930,"token":false,"name":"Heavy Mattock","scryfallId":"8b09df01-0b3e-463e-bf00-0a9f1822261a"},{"index":32934,"token":false,"name":"Memorial to War","scryfallId":"53920ed7-fc9a-4b50-85c8-d62de05b2390"},{"index":32937,"token":false,"name":"Grudge Keeper","scryfallId":"cf00b8d3-30bb-44b8-8531-4bfd018acc0c"},{"index":32944,"token":false,"name":"Thought Eater","scryfallId":"4e05f63c-f93d-44b9-98e9-c5e3e3aad6b9"},{"index":32952,"token":false,"name":"Emancipation Angel","scryfallId":"9b2a972a-a953-485d-920d-8f4f978ef758"},{"index":32954,"token":false,"name":"Lyzolda, the Blood Witch","scryfallId":"18df285f-4cb9-4998-bd26-eefbe28f80c7"},{"index":32955,"token":false,"name":"Sick and Tired","scryfallId":"8736f8a2-ee8d-49d2-883f-b22cbe3f3645"},{"index":32956,"token":false,"name":"Rhystic Syphon","scryfallId":"750c5df2-e299-4bf3-8018-725893702314"},{"index":32961,"token":false,"name":"Foul Orchard","scryfallId":"7b6ead34-e2c3-40c5-9d33-c653a6daae32"},{"index":32962,"token":false,"name":"Dong Zhou, the Tyrant","scryfallId":"51ccdca0-2c29-4b5c-ba5a-364cc6945801"},{"index":32968,"token":false,"name":"Frantic Inventory","scryfallId":"8f14abb0-0e9f-448e-85d7-6cb71f756c56"},{"index":32970,"token":false,"name":"Bring Low","scryfallId":"9ba5e7bf-2ad8-4061-937a-ef1e9b63da3d"},{"index":32978,"token":false,"name":"Ebonblade Reaper","scryfallId":"16ebef2c-8bb2-4816-a628-0062f95e512e"},{"index":32984,"token":false,"name":"Gruesome Discovery","scryfallId":"d0a9d733-24b6-49ed-a15a-c00285eea4b2"},{"index":32987,"token":false,"name":"Vizier of the True","scryfallId":"c1800882-e886-48d5-ac85-0a8e5841dc9a"},{"index":32989,"token":false,"name":"Azra Smokeshaper","scryfallId":"f627e521-2b8f-4d0f-a9d3-cc4e331ce57d"},{"index":32993,"token":false,"name":"Skyblinder Staff","scryfallId":"d1602ee8-019d-4dde-8d31-042207017615"},{"index":32997,"token":false,"name":"Aether Herder","scryfallId":"e8744a31-451b-4349-8f62-e2392a72a154"},{"index":32999,"token":false,"name":"Armored Warhorse","scryfallId":"52daf505-d436-4ea6-a157-4268af2ff7a8"},{"index":33000,"token":false,"name":"Lash of the Whip","scryfallId":"ba32cf1f-375c-4cc5-9963-c4f9510e3b39"},{"index":33011,"token":false,"name":"Stonehorn Dignitary","scryfallId":"c3797f7f-489d-4735-af56-6359e0fa0a6b"},{"index":33012,"token":false,"name":"Ranging Raptors","scryfallId":"9e91efc6-0e6a-4a9e-a486-adf53e53d3f1"},{"index":33016,"token":false,"name":"Druid's Familiar","scryfallId":"1d8c794a-7964-41f0-bc9c-27af7cf87aaa"},{"index":33018,"token":false,"name":"Nexus Wardens","scryfallId":"68cb4e56-bcad-43a3-8600-a3594047205a"},{"index":33020,"token":false,"name":"Jaddi Offshoot","scryfallId":"aca704d5-b6e0-4726-8856-0b3a6732bbd8"},{"index":33021,"token":false,"name":"Jarad's Orders","scryfallId":"c59171ce-7dc6-4dd9-a124-3c2c3028d93d"},{"index":33022,"token":false,"name":"Creakwood Liege","scryfallId":"5bcc8f83-07a5-4ced-a0f4-78c75c287903"},{"index":33023,"token":false,"name":"Zanikev Locust","scryfallId":"adcbd7ee-8958-46fe-abb0-e899e7d2e654"},{"index":33024,"token":false,"name":"Sandsteppe Scavenger","scryfallId":"861f215b-4f3b-4aca-9664-3ef9a0ddea1a"},{"index":33029,"token":false,"name":"Noosegraf Mob","scryfallId":"8f436bf2-13d0-4544-86f5-86b653058445"},{"index":33030,"token":false,"name":"Dominus of Fealty","scryfallId":"19eb1803-72b7-4ada-94b1-ff71c5e5d49a"},{"index":33032,"token":false,"name":"Akroan Skyguard","scryfallId":"d55e85c3-234e-49c4-a307-96fb4497eea8"},{"index":33033,"token":false,"name":"Revolutionary Rebuff","scryfallId":"b41d084f-0fc5-40b9-8939-8d9a18d38822"},{"index":33034,"token":false,"name":"Taborax, Hope's Demise","scryfallId":"331bf97d-f447-4c68-bfc7-2bb593106d66"},{"index":33039,"token":false,"name":"Ezuri, Renegade Leader","scryfallId":"e9544132-bbb5-4ec4-af82-dad56e5091af"},{"index":33040,"token":false,"name":"Drag Under","scryfallId":"75eacac3-cba4-4c30-b1df-19fcc5f96076"},{"index":33041,"token":false,"name":"Fury Storm","scryfallId":"10dad353-7200-46de-96ad-4c457b94c62b"},{"index":33043,"token":false,"name":"Bog Witch","scryfallId":"6a926f9e-ee63-4b6e-8e5b-0650b74344a5"},{"index":33044,"token":false,"name":"Necropolis Fiend","scryfallId":"f27fb4a1-cf88-45e3-90bc-aa146f7c4ffa"},{"index":33047,"token":false,"name":"Dark Betrayal","scryfallId":"56adf4ea-1b1c-4737-8574-1848ca47d4f3"},{"index":33049,"token":false,"name":"Metathran Soldier","scryfallId":"650d40d0-78ec-4b6e-8ea0-28d43ce175d5"},{"index":33053,"token":false,"name":"From Under the Floorboards","scryfallId":"3e644706-223d-4e56-9614-b224e281be2f"},{"index":33057,"token":false,"name":"Snapsail Glider","scryfallId":"fc98e0af-b18e-4172-bc56-19952ebd0303"},{"index":33063,"token":false,"name":"Training Center","scryfallId":"15a0efa5-6559-446b-a4d9-47585f6e94fb"},{"index":33078,"token":false,"name":"Weight of Spires","scryfallId":"d5f26a87-4562-450c-800b-7d4acc1ae17b"},{"index":33079,"token":false,"name":"Goblin Brawler","scryfallId":"f6586c04-f92d-4c3f-8b03-59e5ef158ed4"},{"index":33091,"token":false,"name":"Rakshasa Deathdealer","scryfallId":"ab4e0b33-dad1-4443-a7c7-a7bab067d04a"},{"index":33096,"token":false,"name":"Greater Werewolf","scryfallId":"34b77373-6066-436b-aa60-4cb0f8077599"},{"index":33101,"token":false,"name":"Azorius Justiciar","scryfallId":"9f56272e-c05e-446b-8871-e3783dd29a8b"},{"index":33109,"token":false,"name":"Ancient Ooze","scryfallId":"3b57b41c-f99c-4525-8541-f025b7e31974"},{"index":33111,"token":false,"name":"Smuggler Captain","scryfallId":"b10ce284-c994-429c-ad61-ffe1ca88d691"},{"index":33112,"token":false,"name":"Letter of Acceptance","scryfallId":"34750231-34aa-401c-b192-47b56588923a"},{"index":33113,"token":false,"name":"Path of Anger's Flame","scryfallId":"046fd4b1-d3a4-4859-a0d4-0e8341e6c6c7"},{"index":33114,"token":false,"name":"Rancid Earth","scryfallId":"23d07a96-85ba-4714-94a5-4a8125954f58"},{"index":33115,"token":false,"name":"Thorned Moloch","scryfallId":"01ab2615-5a02-4b59-b8bd-577b91a1a0e3"},{"index":33123,"token":false,"name":"Ral Zarek","scryfallId":"5639a7a6-8155-44b6-b22f-4596581002c3"},{"index":33125,"token":false,"name":"Transmutation","scryfallId":"329f7eb2-eadf-46ec-aed4-63152051f3c1"},{"index":33131,"token":false,"name":"Sengir Nosferatu","scryfallId":"71dc9f1e-b889-402d-a5a1-fa0d7d493246"},{"index":33136,"token":false,"name":"Bell Borca, Spectral Sergeant","scryfallId":"5602cf54-3c34-4f86-8440-13ac28ace68c"},{"index":33137,"token":false,"name":"Dragon's Eye Sentry","scryfallId":"87448a85-37a1-4daa-8728-dfa5b9a89b9b"},{"index":33141,"token":false,"name":"Living Inferno","scryfallId":"1c4b8143-2742-4262-b18f-2825bf8cea6f"},{"index":33147,"token":false,"name":"Truefire Paladin","scryfallId":"a42906c1-cf32-4c14-b08a-d800d1858d8f"},{"index":33165,"token":false,"name":"Scapegoat","scryfallId":"20454d36-d98d-4421-b3aa-d2dd4b368d84"},{"index":33168,"token":false,"name":"War Flare","scryfallId":"243f33d8-ec20-4376-99c2-a12098773dee"},{"index":33169,"token":false,"name":"Mass Hysteria","scryfallId":"1431354a-fcfa-4f67-a822-6dcc4d13ac3f"},{"index":33172,"token":false,"name":"Wretched Banquet","scryfallId":"3bdaf55b-2de3-4c8a-90ae-9c88c9d00fd7"},{"index":33178,"token":false,"name":"Capashen Standard","scryfallId":"16665386-405e-48c9-8c69-c21b03931c2f"},{"index":33181,"token":false,"name":"Sarkhan the Mad","scryfallId":"26c1ba92-556e-4da9-8e3a-a4a82612cb29"},{"index":33182,"token":false,"name":"Ravenous Giant","scryfallId":"52337d8d-e0ee-4229-848d-9bbd989e15b7"},{"index":33183,"token":false,"name":"Rimewind Taskmage","scryfallId":"e9cdc06e-1458-4b19-a272-28a3d0453643"},{"index":33190,"token":false,"name":"Silkenfist Order","scryfallId":"93741517-90ed-46fe-a505-fe6299f188bf"},{"index":33192,"token":false,"name":"Sickening Shoal","scryfallId":"d92f4129-19fc-4ee9-9e3d-77fcf1563e4b"},{"index":33193,"token":false,"name":"Mob Rule","scryfallId":"1d76845f-c827-4cb4-b2d0-3f2cf5ee0e81"},{"index":33197,"token":false,"name":"Bishop of the Bloodstained","scryfallId":"373131be-bd66-49f5-80fa-836ced03fedf"},{"index":33199,"token":true,"name":"Elemental Token (G/W, 8/8)","scryfallId":"b64c5f80-4676-4860-be0e-20bcf2227405"},{"index":33202,"token":false,"name":"Darkslick Drake","scryfallId":"234f4131-1e7f-4220-b46c-bb4a6713876e"},{"index":33203,"token":false,"name":"Chrome Replicator","scryfallId":"1e01bcb4-e823-4da5-b433-e75be3356367"},{"index":33205,"token":false,"name":"Whisperwood Elemental","scryfallId":"66c61828-98b9-4264-b3dd-e83f881f4a67"},{"index":33210,"token":false,"name":"Deranged Assistant","scryfallId":"73373421-c43d-4152-818a-55abc85b477a"},{"index":33212,"token":false,"name":"Rotting Regisaur","scryfallId":"d88c61cb-dbf9-46c3-8795-8896ba1208d5"},{"index":33213,"token":false,"name":"Mirror of Fate","scryfallId":"08b480c8-d899-4e63-b0e2-f4bec3a3ca4f"},{"index":33222,"token":false,"name":"Explosion of Riches","scryfallId":"da2f3dd5-a943-447b-8c76-8f69f06cefa4"},{"index":33223,"token":false,"name":"Ersatz Gnomes","scryfallId":"5a2747ab-00c8-4f59-b9a6-54ff4e99f6c8"},{"index":33224,"token":false,"name":"Rally the Forces","scryfallId":"8f251c71-0e83-424d-9e0e-85790289087c"},{"index":33227,"token":false,"name":"Emblazoned Golem","scryfallId":"98527fc6-4f4c-4ded-9e72-49186b7e5bd3"},{"index":33228,"token":false,"name":"Tome of the Guildpact","scryfallId":"95e307d4-7e5f-4f00-869e-da0e7abbf27f"},{"index":33229,"token":false,"name":"Raging Bull","scryfallId":"ec10a51c-d2c3-4d14-9a71-9e59155bf980"},{"index":33237,"token":false,"name":"Hotheaded Giant","scryfallId":"74481546-debc-44df-b5a9-7fde0ada0eca"},{"index":33240,"token":false,"name":"Blessing of Belzenlok","scryfallId":"83dfee3c-ca41-4691-90e8-892cc5de1577"},{"index":33242,"token":false,"name":"Opal Archangel","scryfallId":"a75fca33-fa06-4385-866c-5d463ae6aaf6"},{"index":33244,"token":false,"name":"Rockcaster Platoon","scryfallId":"4ab62812-acc5-4b4b-97d3-106e399d69da"},{"index":33248,"token":false,"name":"Crusading Knight","scryfallId":"a4ab4640-1871-41dd-bd21-64741e21ba37"},{"index":33251,"token":false,"name":"Harness Infinity","scryfallId":"38ca358d-9f66-4edf-b143-18a1ce809149"},{"index":33253,"token":false,"name":"Boltwing Marauder","scryfallId":"769c1e97-e9d9-4542-b09d-6cb8640604c4"},{"index":33258,"token":false,"name":"Verazol, the Split Current","scryfallId":"0584fc6c-88c6-46b5-8cc5-42d4a6f7e2f4"},{"index":33260,"token":false,"name":"Titan of Eternal Fire","scryfallId":"eeb8e4df-930c-4fb1-9258-184ff6c415d0"},{"index":33261,"token":false,"name":"Sarpadian Empires, Vol. VII","scryfallId":"b37a6cf7-f239-4bca-b4c3-a48932ef56b5"},{"index":33267,"token":false,"name":"Ancestor Dragon","scryfallId":"9ba9d1f0-a864-490c-b258-6bf9de251c4b"},{"index":33272,"token":false,"name":"Grasp of the Hieromancer","scryfallId":"604cbc43-f2d9-4fd7-8ff0-b2ca736f274d"},{"index":33274,"token":false,"name":"Murasa Rootgrazer","scryfallId":"e70b3b78-9bdc-449b-82a9-c2fc3dd7f120"},{"index":33278,"token":false,"name":"Tundra Kavu","scryfallId":"fc34e735-ac3c-4954-a4c8-3ed55d811715"},{"index":33279,"token":false,"name":"Blood Researcher","scryfallId":"3e35e9ba-a10e-4926-a7a6-3a65efc2a730"},{"index":33283,"token":false,"name":"Wheel of Torture","scryfallId":"87edc873-169a-4cd3-8a94-84b5810b5ed8"},{"index":33290,"token":false,"name":"Shifting Loyalties","scryfallId":"ed9ff175-2e4c-4658-813e-1bfb4b9a6ca0"},{"index":33299,"token":true,"name":"Dinosaur // Treasure","scryfallId":"21f5880d-6272-4ba8-bdf8-f9a7e54a3336"},{"index":33300,"token":false,"name":"Snare Thopter","scryfallId":"687febd3-1825-4fd2-b9ab-bd32a9baffc7"},{"index":33306,"token":false,"name":"Rageform","scryfallId":"038ed726-bde8-46b0-bdf5-f88e2f074434"},{"index":33307,"token":false,"name":"Segovian Angel","scryfallId":"b5dbaec5-502d-48c2-9e71-c12cd0bccc6a"},{"index":33310,"token":false,"name":"Territorial Hammerskull","scryfallId":"507fb744-c6dc-4ff2-a329-872bd8c4d39c"},{"index":33317,"token":false,"name":"Inspiring Refrain","scryfallId":"fa083791-6c1b-4165-b0bc-393cc369503a"},{"index":33319,"token":false,"name":"Vault Skyward","scryfallId":"4e934192-2ea3-48fe-a2a9-42c2ee9b22f7"},{"index":33326,"token":false,"name":"Noble Elephant","scryfallId":"65f399cb-dddb-422a-8d36-938b82b59e10"},{"index":33330,"token":false,"name":"Keepsake Gorgon","scryfallId":"ac988f7b-9a10-4b48-8215-50376dc8678c"},{"index":33331,"token":false,"name":"Cruel Deceiver","scryfallId":"7cc6972a-5305-423f-a936-16ee0fbf9200"},{"index":33339,"token":false,"name":"Ceremonial Guard","scryfallId":"4a6c69d1-5295-419f-bb8f-af826bf92cb3"},{"index":33340,"token":true,"name":"Worm Token (B/G, 1/1)","scryfallId":"1fd82205-5d3e-4a8d-a31b-020efc6303d0"},{"index":33341,"token":false,"name":"Sluggishness","scryfallId":"2ba91431-3fcd-4b44-ae7b-a69eb18efd5f"},{"index":33350,"token":false,"name":"Gravitic Punch","scryfallId":"05fe0428-6e7d-49d4-9a29-80a3589f565a"},{"index":33351,"token":false,"name":"Oath of the Ancient Wood","scryfallId":"9bc42032-8727-4f78-b369-ba103d965b73"},{"index":33357,"token":false,"name":"Dwell on the Past","scryfallId":"77ac905a-839b-4fb5-8c17-7fd6c2c0c492"},{"index":33369,"token":false,"name":"Blight-Breath Catoblepas","scryfallId":"7865c079-1d91-48d4-852d-d104b6e0c157"},{"index":33371,"token":false,"name":"Scout the Borders","scryfallId":"eb15c6c7-8fe6-496c-9977-3e7942b920c4"},{"index":33372,"token":false,"name":"Essence Feed","scryfallId":"b9cf2116-7ae5-4b6a-830a-919a55235690"},{"index":33374,"token":false,"name":"Sandsteppe Mastodon","scryfallId":"acc5168c-e36f-4fc8-abf1-7e9a88754ea9"},{"index":33377,"token":false,"name":"Nyxborn Rollicker","scryfallId":"b2081bf0-09f5-4c95-b4cc-48a8784294d4"},{"index":33381,"token":false,"name":"Hanweir, the Writhing Township","scryfallId":"671fe14d-0070-4bc7-8983-707b570f4492"},{"index":33385,"token":false,"name":"Doomed Artisan","scryfallId":"ded9c409-7131-4b3f-a6b9-25fa32c5ec2c"},{"index":33388,"token":false,"name":"Earnest Fellowship","scryfallId":"66392169-5c6f-46bf-b0df-5670e40aecd9"},{"index":33393,"token":false,"name":"Steel Golem","scryfallId":"9aa927e0-5a65-4ac1-8eca-c000bb8080e7"},{"index":33394,"token":false,"name":"Gobhobbler Rats","scryfallId":"ae123ca6-2b96-4bbe-82b2-0be294edff80"},{"index":33397,"token":false,"name":"Squeeze","scryfallId":"bbe63220-992b-459c-81ca-d4e2de273ce1"},{"index":33403,"token":false,"name":"Beastbreaker of Bala Ged","scryfallId":"b24c2406-ba46-428b-9d5c-38954818edc0"},{"index":33407,"token":false,"name":"Golden Wish","scryfallId":"dc409ded-41f3-4f14-8199-72a9fe98bac0"},{"index":33409,"token":false,"name":"Tower of the Magistrate","scryfallId":"ee0481db-15ae-46b4-89a3-01c95a9626c7"},{"index":33412,"token":false,"name":"Livonya Silone","scryfallId":"d4ef4c06-9dab-499c-a270-0ba7f0b5fd77"},{"index":33413,"token":false,"name":"Global Ruin","scryfallId":"336474b4-2cf5-44c0-b72c-f75f1a7ed928"},{"index":33416,"token":false,"name":"Wild Slash","scryfallId":"6975490f-7679-48b3-ba34-04dec97a29c2"},{"index":33417,"token":false,"name":"Shelldock Isle","scryfallId":"85439d4e-9dac-4ed8-82ca-b9631b41dfb4"},{"index":33418,"token":false,"name":"Reckless Racer","scryfallId":"21c0afd6-1242-42bf-a13f-9f218c9d9dfc"},{"index":33427,"token":false,"name":"Gwendlyn Di Corci","scryfallId":"473d70b6-a88c-49f4-9415-19919c4468ae"},{"index":33429,"token":false,"name":"Stormwing Dragon","scryfallId":"6da2b004-97e5-41ab-98b0-3637cb32a35a"},{"index":33432,"token":false,"name":"Burning Fields","scryfallId":"dee12f01-581e-4a3c-a8b5-41bef2516781"},{"index":33433,"token":false,"name":"Hunted Witness","scryfallId":"8c31b8e5-2349-4119-9dc2-3e41c5364a78"},{"index":33443,"token":false,"name":"Viashino Outrider","scryfallId":"26ba659c-7e0f-4d8b-b91c-3c0725102ba2"},{"index":33445,"token":false,"name":"Treasure Trove","scryfallId":"b4f65e7a-be66-4a57-9e33-c1b02285f65e"},{"index":33448,"token":false,"name":"Hornet Cobra","scryfallId":"27180bad-9bbc-462b-8832-626dc403a3fd"},{"index":33460,"token":false,"name":"Attune with Aether","scryfallId":"32b0707d-241e-4ced-9251-b16af4fef2cb"},{"index":33461,"token":false,"name":"Luminous Wake","scryfallId":"4f8d5a36-cc29-47fc-bdf7-b753f3bc5197"},{"index":33464,"token":false,"name":"Spectacle Mage","scryfallId":"f74223e1-b66b-42fa-aaac-001f5dab2aac"},{"index":33466,"token":false,"name":"Strangling Soot","scryfallId":"872d8f4d-6ee5-4494-9900-db62d3e4cedd"},{"index":33467,"token":false,"name":"Treva's Ruins","scryfallId":"8bae2458-b54f-426a-ad40-13529a73c423"},{"index":33468,"token":false,"name":"Donate","scryfallId":"7f6d8ce9-f8c8-45ad-b74c-97fba0e2982e"},{"index":33471,"token":false,"name":"Eligeth, Crossroads Augur","scryfallId":"65c163d7-8e63-42d0-a943-7cea3771fd87"},{"index":33472,"token":false,"name":"Moonblade Shinobi","scryfallId":"f4ab7f30-ca75-4656-9738-1d965f18a22d"},{"index":33474,"token":false,"name":"Angel of Condemnation","scryfallId":"90dad070-e41d-419b-ae27-ace82b9ab2c5"},{"index":33477,"token":false,"name":"Sigardian Priest","scryfallId":"f8e798c7-0cbc-444e-8033-629baec7dca8"},{"index":33481,"token":false,"name":"Archetype of Courage","scryfallId":"8e6c4afb-6a94-4519-91c6-9824fed2892c"},{"index":33482,"token":false,"name":"Floodgate","scryfallId":"fb2f594d-e608-444b-b81f-836de2452868"},{"index":33484,"token":false,"name":"Screeching Silcaw","scryfallId":"1767355d-82a2-495e-ae95-d91984a9c62a"},{"index":33486,"token":false,"name":"Crater's Claws","scryfallId":"fc8d5e1c-f3d5-4af3-bae0-c40d54dd67dd"},{"index":33489,"token":false,"name":"Sol Talisman","scryfallId":"18052761-39c3-4342-b6e6-38dc5b7b05dd"},{"index":33496,"token":false,"name":"Bargaining Table","scryfallId":"85da9395-42e9-4408-832d-74ea4b01256b"},{"index":33498,"token":false,"name":"Seraph of the Suns","scryfallId":"80b56a6f-4d8b-4321-9a92-2272ec3f197c"},{"index":33502,"token":false,"name":"Lithophage","scryfallId":"bff49651-3673-4670-9807-3ef3a42b8f8f"},{"index":33503,"token":false,"name":"Merchant Ship","scryfallId":"2b827094-fb2c-46db-b898-02e0c308601f"},{"index":33505,"token":false,"name":"Rolling Stones","scryfallId":"dd27e9c9-0a47-4fa3-9da5-1993f20305c2"},{"index":33507,"token":false,"name":"Glimmerpoint Stag","scryfallId":"c97a0c45-7aea-41e3-b633-b5f1518a1455"},{"index":33508,"token":false,"name":"Syphon Life","scryfallId":"b0547b01-aabc-4114-b71c-ae44cb2bb871"},{"index":33509,"token":false,"name":"Tempting Witch","scryfallId":"8b217e5a-3c18-48b4-8124-b8c4fd7b2df1"},{"index":33510,"token":false,"name":"Rainbow Crow","scryfallId":"7e622ad2-473f-489e-b4cf-bbdcc44d0cde"},{"index":33511,"token":false,"name":"Steadfast Cathar","scryfallId":"5e1b65a7-d385-428b-986c-a0d9283a5f75"},{"index":33517,"token":false,"name":"Dispersal Technician","scryfallId":"5d93a915-ffea-4f50-88ac-2b3253f7dfdf"},{"index":33519,"token":false,"name":"Scorched Rusalka","scryfallId":"c6b9dd6d-e286-41e8-bd9d-0b42daa5c062"},{"index":33521,"token":false,"name":"Quicksilver Wall","scryfallId":"a680aeaf-8c6e-45b5-8814-7fd04e963220"},{"index":33522,"token":false,"name":"Dogged Pursuit","scryfallId":"60f6a159-b969-4767-802e-409f8bf286fe"},{"index":33525,"token":false,"name":"Bloodhunter Bat","scryfallId":"99c10705-6e0e-46f6-a64c-0095b2796aaf"},{"index":33526,"token":false,"name":"Symbiotic Deployment","scryfallId":"a6e2b7e9-d52b-478e-b118-e890a81fd471"},{"index":33527,"token":false,"name":"Champion of Dusk","scryfallId":"507a4fb1-d27b-4393-9eed-48fe05b367d8"},{"index":33529,"token":false,"name":"Leyline Phantom","scryfallId":"2bb3035b-3f13-4c1c-83a1-44c2750455ec"},{"index":33532,"token":true,"name":"Wolf Token (B, 1/1)","scryfallId":"7a49607c-427a-474c-ad77-60cd05844b3c"},{"index":33536,"token":false,"name":"Jiang Yanggu","scryfallId":"2e3008a4-6d43-499a-94ea-51e97b574f62"},{"index":33537,"token":false,"name":"Suture Spirit","scryfallId":"08520f97-e7f5-45fc-9423-fa6a3a507671"},{"index":33542,"token":false,"name":"Scuttlemutt","scryfallId":"5fbd8e7c-13cb-4aea-a3cb-c7ed29d43163"},{"index":33544,"token":false,"name":"Revered Elder","scryfallId":"b0793175-e56b-4ff8-9e22-3a96a698068c"},{"index":33549,"token":false,"name":"Devkarin Dissident","scryfallId":"490cd287-5f09-442f-9150-4a6ac2cf3e2e"},{"index":33553,"token":false,"name":"Salt Road Quartermasters","scryfallId":"4076bf6b-c8b1-49ef-8f23-afaf7a234e2d"},{"index":33559,"token":true,"name":"Merfolk // Treasure Token (U, 1/1)","scryfallId":"2e20d047-0d43-4709-919c-0b0f714e9903"},{"index":33566,"token":false,"name":"Dwarven Catapult","scryfallId":"8c1c6932-638a-4df7-bf9b-8d921f7484d9"},{"index":33570,"token":false,"name":"Searing Flesh","scryfallId":"d83db110-42e7-4823-a686-b83205faf503"},{"index":33577,"token":false,"name":"Gorilla War Cry","scryfallId":"613762ea-6111-4f74-bea2-c13b76e0751c"},{"index":33583,"token":true,"name":"Goblin Wizard Token (R, 1/1)","scryfallId":"fd7094d6-6e23-47f2-a9da-4dd680294ac8"},{"index":33585,"token":false,"name":"Dwarven Strike Force","scryfallId":"a2bc3d85-5ba1-4f2e-a676-be989bdb04f7"},{"index":33591,"token":false,"name":"Pharika's Chosen","scryfallId":"8119ce0c-d709-463c-9abc-f7025673ea72"},{"index":33593,"token":false,"name":"Personal Sanctuary","scryfallId":"56f10d57-687d-4ee3-8226-bae525d56e9e"},{"index":33596,"token":false,"name":"Zacama, Primal Calamity","scryfallId":"3581f83f-f757-468d-bb4d-17793ac666b3"},{"index":33598,"token":false,"name":"Veyran, Voice of Duality","scryfallId":"56d93855-c749-4bdf-9a90-4f69f4226e46"},{"index":33599,"token":true,"name":"Mark Le Pine Decklist","scryfallId":"3ed7790c-72db-490d-a427-f3202d730aab"},{"index":33616,"token":false,"name":"Surrakar Spellblade","scryfallId":"9a4199be-e1ec-4f0e-a31f-29a7007128a5"},{"index":33618,"token":false,"name":"Zhao Zilong, Tiger General","scryfallId":"2d16cf1d-a7c3-4038-a648-299c1bedae99"},{"index":33619,"token":false,"name":"Stillmoon Cavalier","scryfallId":"400dc91e-96c0-49bf-b307-677d6f80f3ed"},{"index":33620,"token":false,"name":"Prowling Nightstalker","scryfallId":"749e3992-693b-4b4f-b410-b5f2faac0040"},{"index":33622,"token":false,"name":"Kasmina's Transmutation","scryfallId":"a9771412-695a-4e89-b146-0e3a7336d319"},{"index":33623,"token":false,"name":"Shambling Shell","scryfallId":"4c93baa2-a23e-4e18-b4cd-779c992d2042"},{"index":33625,"token":false,"name":"Dawnfeather Eagle","scryfallId":"d66063d3-ca80-4589-ab1c-1ed53f7a5a13"},{"index":33627,"token":false,"name":"Bookwurm","scryfallId":"57d230fc-d382-40b4-bdbd-5fe880fa16bf"},{"index":33630,"token":false,"name":"Necrite","scryfallId":"b8dc0941-5837-41cf-9ae6-5f8d1fe4dfe4"},{"index":33631,"token":false,"name":"Jaded Response","scryfallId":"6a9ab1f0-4e75-4165-85bc-6f838c221d6a"},{"index":33632,"token":false,"name":"Heavy Infantry","scryfallId":"4b2bf2c3-26d7-480d-8d3c-e00853966879"},{"index":33636,"token":false,"name":"Skyward Eye Prophets","scryfallId":"056f9887-3ab0-486a-b859-5999d39f9ec2"},{"index":33637,"token":false,"name":"Iridescent Angel","scryfallId":"b0769d87-62f7-469a-936f-5a4f6b9360b6"},{"index":33645,"token":false,"name":"Razortide Bridge","scryfallId":"e7ea7395-430e-4036-92c9-17a850ec2371"},{"index":33650,"token":false,"name":"Ishkanah, Grafwidow","scryfallId":"84b09c07-a811-4b1c-8264-f63efea93e06"},{"index":33661,"token":false,"name":"Sparring Golem","scryfallId":"d829d9de-83fa-4feb-8efc-0075315163c6"},{"index":33667,"token":false,"name":"Kaho, Minamo Historian","scryfallId":"d85a5f54-9b79-4c3d-b983-021b4b01b122"},{"index":33677,"token":false,"name":"Colossal Whale","scryfallId":"9d0efe16-d789-4299-b381-080a6e5d9944"},{"index":33680,"token":false,"name":"Treasured Find","scryfallId":"a2c0e00b-2290-493f-a3fc-3b9bff2830cc"},{"index":33682,"token":false,"name":"Mogg Salvage","scryfallId":"403aa48c-b684-4c54-8863-460958055a1f"},{"index":33685,"token":true,"name":"Hydra Head Token (Colorless, 0/3)","scryfallId":"27d772a9-7542-4ffe-9cd4-e144d129f342"},{"index":33688,"token":false,"name":"Liliana's Steward","scryfallId":"aa9ab339-5f1a-425d-abfd-0b65a33d5c85"},{"index":33697,"token":false,"name":"Gorilla Pack","scryfallId":"046f6b76-5f17-4728-aa34-72b7eff1d4c9"},{"index":33699,"token":false,"name":"Bontu's Monument","scryfallId":"18c1fcb8-1b50-4fc0-a3e1-34a748652a60"},{"index":33701,"token":false,"name":"Dimensional Infiltrator","scryfallId":"5b314380-1168-43b9-8df7-8bde997c4d79"},{"index":33702,"token":false,"name":"Mardu Woe-Reaper","scryfallId":"0bf14a32-b97b-48c7-8395-d9c3626735c1"},{"index":33706,"token":false,"name":"Combat Calligrapher","scryfallId":"acde0431-0226-495d-80e9-fd3de1b9473e"},{"index":33711,"token":false,"name":"Razor Barrier","scryfallId":"0455bae2-030b-4176-9953-11be82021145"},{"index":33713,"token":false,"name":"Duct Crawler","scryfallId":"d913e4d2-3502-41f3-871e-59b3b13df58a"},{"index":33715,"token":false,"name":"Blustersquall","scryfallId":"1736aaf7-b61d-426e-af5e-f70272e7b07e"},{"index":33716,"token":false,"name":"Scab-Clan Giant","scryfallId":"a8e360ae-4c78-47a9-81d4-1849cfa518b7"},{"index":33717,"token":false,"name":"Khalni Hydra","scryfallId":"06d17713-a67e-471f-89ed-4866acb52ba4"},{"index":33723,"token":false,"name":"Predatory Rampage","scryfallId":"3e054ea5-3657-4198-9715-6acc0e362da3"},{"index":33727,"token":false,"name":"Magnify","scryfallId":"7b9bb2c6-f1a6-42c3-a7cb-3a1a46854c9b"},{"index":33729,"token":false,"name":"Well of Discovery","scryfallId":"82331a8a-c0f1-4d89-87f8-1b1d0fccabb8"},{"index":33733,"token":false,"name":"Razor Boomerang","scryfallId":"41526ad7-730d-44ad-bd19-e1b8a2717cf7"},{"index":33737,"token":false,"name":"Crackdown","scryfallId":"a7009fd8-1d80-41bb-a1b0-fea9c909c63d"},{"index":33742,"token":false,"name":"Roaming Ghostlight","scryfallId":"8cbac0e4-f79f-476d-b410-d19ab3696606"},{"index":33743,"token":false,"name":"Vodalian Hypnotist","scryfallId":"721fd877-0a28-4002-8b47-058bac4ac44d"},{"index":33757,"token":false,"name":"Oath of Ajani","scryfallId":"2e29077a-5e72-4104-bc9e-25a59a470b24"},{"index":33760,"token":false,"name":"Timeless Witness","scryfallId":"f22c07e2-91d2-4edb-bd2b-cca6d4cefcc9"},{"index":33762,"token":false,"name":"Mindwrack Harpy","scryfallId":"6c5ce79a-fcbd-46ab-8911-480f967ca57f"},{"index":33768,"token":false,"name":"Release the Ants","scryfallId":"9ce93fb7-3873-4855-99ad-e93f8f45078e"},{"index":33770,"token":false,"name":"Shaman en-Kor","scryfallId":"a9a13c4c-d5c0-4947-bb68-d2e9611bcdea"},{"index":33776,"token":false,"name":"Agent of the Fates","scryfallId":"ecd59977-8788-417d-ba50-e21b8a636bd3"},{"index":33782,"token":false,"name":"Searing Blood","scryfallId":"bb43fd07-d281-447d-88bf-c53498c2cf20"},{"index":33785,"token":false,"name":"Wind-Kin Raiders","scryfallId":"8037f588-6b9f-472d-b26a-2c06db976ad0"},{"index":33792,"token":false,"name":"Relic Axe","scryfallId":"ca8705e3-0e44-45c9-bcdf-c24507b038fe"},{"index":33801,"token":false,"name":"Drowned Secrets","scryfallId":"bfc98428-7a0f-445f-9d48-eeb76c3e10d6"},{"index":33805,"token":false,"name":"Penance","scryfallId":"1f3db848-8394-43bd-a236-264641033a6d"},{"index":33810,"token":false,"name":"Fire Shrine Keeper","scryfallId":"54135905-9b15-4bf9-8f4d-4ea7a0c75b77"},{"index":33813,"token":false,"name":"Vedalken Aethermage","scryfallId":"496eb37d-5c8f-4dd7-a0a7-3ed1bd2210d6"},{"index":33815,"token":false,"name":"Steelshaper Apprentice","scryfallId":"a4793de1-4d5d-4538-b48f-db5d31757bcc"},{"index":33816,"token":false,"name":"Marang River Prowler","scryfallId":"491a3dc5-d297-47e1-acf9-dda103136519"},{"index":33823,"token":false,"name":"Hissing Quagmire","scryfallId":"6ef11b54-205a-48e9-92d0-5d416be869ef"},{"index":33824,"token":false,"name":"Zof Shade","scryfallId":"b46976d4-7266-4359-bf7a-7e81983ae6e3"},{"index":33825,"token":false,"name":"Afflicted Deserter // Werewolf Ransacker","scryfallId":"a2c044c0-3625-4bdf-9445-b462394cecae"},{"index":33826,"token":false,"name":"Avenging Huntbonder","scryfallId":"24ad6b07-3487-4e19-b554-196697a413df"},{"index":33827,"token":false,"name":"Broken Visage","scryfallId":"824823fb-5ae1-48b1-bc46-e452afa73cd8"},{"index":33830,"token":false,"name":"Parting Thoughts","scryfallId":"5c6d1240-9d9a-42b2-a0f7-2e9c8f744d5f"},{"index":33832,"token":false,"name":"Quench","scryfallId":"ee0ba01b-de96-4f8f-9405-ff3ad288afac"},{"index":33833,"token":false,"name":"Resolute Blademaster","scryfallId":"bea96f8d-0c57-448d-8145-51f9cca04432"},{"index":33838,"token":false,"name":"Soul Sculptor","scryfallId":"fe6ef073-1c83-47a4-b19d-86fb8bed5db9"},{"index":33840,"token":false,"name":"Recantation","scryfallId":"95479839-779e-4dbe-8989-ccf26cc488fe"},{"index":33842,"token":false,"name":"Nils, Discipline Enforcer","scryfallId":"2de6edc9-4dd6-402e-a697-58957522fabc"},{"index":33844,"token":false,"name":"Break Asunder","scryfallId":"fb989895-a5c7-4151-8620-ab277d826303"},{"index":33847,"token":false,"name":"Withercrown","scryfallId":"597fe119-64a7-4499-8b69-738af5a71a20"},{"index":33852,"token":false,"name":"Kjeldoran War Cry","scryfallId":"320b2b02-a3ff-4f68-93e6-8539d7caa005"},{"index":33853,"token":false,"name":"Ill-Gotten Inheritance","scryfallId":"3d44b342-f611-4836-a9d5-83b00a24318f"},{"index":33854,"token":false,"name":"Demonic Pact","scryfallId":"b0122db7-6a3a-4dda-9357-fcac5376f1b2"},{"index":33855,"token":false,"name":"Cabal Stronghold","scryfallId":"309119c4-acf7-4f95-abf9-707b4da02301"},{"index":33859,"token":false,"name":"Efreet Flamepainter","scryfallId":"d9f0731c-2a3d-4613-bffa-8b967e4f142e"},{"index":33864,"token":false,"name":"Curse of Opulence","scryfallId":"6615d7f1-1ed6-43af-a916-6caa4bd35ca3"},{"index":33865,"token":false,"name":"Scorched Earth","scryfallId":"e6a97817-d1fd-4ba4-9ced-c2702b081523"},{"index":33870,"token":false,"name":"King Harald's Revenge","scryfallId":"71a659b6-c4a8-4c0a-8b2a-07b6c9e27dfc"},{"index":33873,"token":false,"name":"Structural Collapse","scryfallId":"d10da484-db67-4afc-90ef-6caf7d2e3a75"},{"index":33874,"token":false,"name":"Kami of the Crescent Moon","scryfallId":"f01ee008-76dd-4d4d-8273-ad5b28c8a2c7"},{"index":33880,"token":false,"name":"Parasitic Bond","scryfallId":"47bd3995-3013-468e-b586-0c5720a0bde6"},{"index":33881,"token":false,"name":"Murk Strider","scryfallId":"130849ba-3893-490d-bfb0-51c76e53cf62"},{"index":33891,"token":false,"name":"Corrupted Resolve","scryfallId":"28432161-023b-4a98-b92a-55dc6d936cd1"},{"index":33892,"token":false,"name":"Temper","scryfallId":"e4bff910-24ab-45a0-b014-30bef6263c38"},{"index":33897,"token":false,"name":"Prison Barricade","scryfallId":"449c4800-8718-4593-a61e-03ad7f348c6d"},{"index":33913,"token":false,"name":"Horncaller's Chant","scryfallId":"7b8d33ed-9ca2-41d1-ba35-fdeb5b88ad44"},{"index":33919,"token":false,"name":"Dunes of the Dead","scryfallId":"326c7483-2c45-4804-85c4-d40ecdba4fc7"},{"index":33927,"token":false,"name":"Divine Deflection","scryfallId":"ec06e42f-e294-44ef-8fa8-1d1a4c2090d8"},{"index":33929,"token":false,"name":"Elvish Healer","scryfallId":"00bd8485-d63a-4077-a3d1-4d0f2f4d8035"},{"index":33931,"token":false,"name":"Ivy Dancer","scryfallId":"73597c90-a527-4338-9668-126c6cf15927"},{"index":33934,"token":false,"name":"Spore Burst","scryfallId":"92fab6e3-29a5-42e0-872e-5c2f4f72bfc5"},{"index":33936,"token":false,"name":"Balduvian Warlord","scryfallId":"a3286dbd-c8b8-45cb-98e4-d572289f2c14"},{"index":33937,"token":false,"name":"Oriq Loremage","scryfallId":"c1264f92-c090-48c2-ba0c-5e13d91ef5c1"},{"index":33946,"token":false,"name":"Cauldron's Gift","scryfallId":"5db19a94-1170-45a0-9f06-893bf58b7233"},{"index":33948,"token":false,"name":"Feral Ridgewolf","scryfallId":"78c66cc0-cb0f-4daf-8141-0923ad46a834"},{"index":33951,"token":false,"name":"Clever Lumimancer","scryfallId":"69957656-cfdf-4001-8e84-0ef29e4a468d"},{"index":33954,"token":false,"name":"Angrath, the Flame-Chained","scryfallId":"a4d76d03-4fcf-42f8-8c2e-ad6b03d58677"},{"index":33958,"token":false,"name":"Herald of Serra","scryfallId":"22a2b882-d616-495e-99f6-196031235f93"},{"index":33960,"token":false,"name":"Skemfar Elderhall","scryfallId":"82c2a0f7-0f53-4627-8be8-227fde331a69"},{"index":33964,"token":false,"name":"Vampiric Rites","scryfallId":"3416309a-5824-48f5-876e-00e0f180acf9"},{"index":33968,"token":false,"name":"Averna, the Chaos Bloom","scryfallId":"e46b3ef3-3ba9-4da7-a675-86468a8da4c7"},{"index":33972,"token":false,"name":"Devout Chaplain","scryfallId":"4be0f70c-6bee-4208-8111-735b2fa31b4d"},{"index":33979,"token":false,"name":"Aphetto Alchemist","scryfallId":"dfd2628f-63c4-4e19-83ea-26041650faab"},{"index":33984,"token":false,"name":"Kaysa","scryfallId":"8e04a31e-24b6-4d54-90c3-3f37d457131b"},{"index":33993,"token":false,"name":"Inquisitive Puppet","scryfallId":"807a570a-b5eb-420d-9fa5-6e5364025510"},{"index":33996,"token":false,"name":"Spare from Evil","scryfallId":"d01b5d97-b5ae-42a7-944a-feb12febd63c"},{"index":33997,"token":false,"name":"Qarsi Sadist","scryfallId":"068c44b9-0ba8-4275-b73d-18ad366f4b45"},{"index":34004,"token":false,"name":"Yavimaya Gnats","scryfallId":"9d8b7020-ca8f-4867-bc51-13d824daf154"},{"index":34010,"token":false,"name":"Woodland Guidance","scryfallId":"92adead0-f8b4-4c49-b4ce-d9253980ee03"},{"index":34012,"token":false,"name":"Rumbling Aftershocks","scryfallId":"01fd58c6-5bca-4160-bc1e-63b9cb3996ab"},{"index":34014,"token":true,"name":"Energy Reserve","scryfallId":"a446b9f8-cb22-408a-93ff-bee44a0dccc0"},{"index":34018,"token":true,"name":"Dinosaur // Treasure Token (G, 3/3)","scryfallId":"21f5880d-6272-4ba8-bdf8-f9a7e54a3336"},{"index":34023,"token":false,"name":"Sheltering Word","scryfallId":"93cd9be4-1ce4-4a7c-b2a6-98d3fde0a92b"},{"index":34024,"token":false,"name":"Contemplation","scryfallId":"848672be-b1cd-40ef-a7ed-ce1620aebd2e"},{"index":34036,"token":false,"name":"Spellkeeper Weird","scryfallId":"74e42dad-5958-443f-a196-12b3f3e44213"},{"index":34045,"token":false,"name":"Shu Yun, the Silent Tempest","scryfallId":"bd79e83a-a34b-472c-9317-12af4ed2ca28"},{"index":34049,"token":false,"name":"Scrap","scryfallId":"3f070430-59d6-462f-9f04-306ffc2ae01b"},{"index":34051,"token":false,"name":"Halimar Tidecaller","scryfallId":"dc3e3b18-bf00-4f1a-9918-9a0e9d75b747"},{"index":34055,"token":false,"name":"Symbiotic Beast","scryfallId":"bb61443d-e47a-4fe1-b777-67a3670a5a56"},{"index":34060,"token":false,"name":"Sideswipe","scryfallId":"6bd611b7-7bd3-4a76-bd69-34a7235965ae"},{"index":34063,"token":false,"name":"Wall of Stolen Identity","scryfallId":"359cc32c-ba90-43e0-b584-09efd321a672"},{"index":34066,"token":false,"name":"Liquimetal Coating","scryfallId":"43ec9201-06e7-4a70-8dcf-7462a019965d"},{"index":34070,"token":false,"name":"Gladecover Scout","scryfallId":"26710d5c-01d1-498b-9f54-521dfd195843"},{"index":34072,"token":false,"name":"Hall of Gemstone","scryfallId":"18e4551f-9f6c-4421-ad66-a270df6d3463"},{"index":34073,"token":false,"name":"Drekavac","scryfallId":"459d8cb7-cbb8-4e73-9571-44277f1d1be2"},{"index":34077,"token":false,"name":"Two-Headed Cerberus","scryfallId":"f8d2f75c-ef2a-4d30-86d1-c47307fc47ac"},{"index":34082,"token":false,"name":"Kindly Stranger // Demon-Possessed Witch","scryfallId":"e326d5f4-63e1-45fa-8c48-6fdc05709c52"},{"index":34084,"token":false,"name":"Greatsword","scryfallId":"63b4041d-7c95-4cb9-a18b-6568db05942b"},{"index":34085,"token":false,"name":"Reckless Assault","scryfallId":"ff0f568e-4d3a-40a5-b72a-63040ec5402d"},{"index":34089,"token":false,"name":"Bitter Feud","scryfallId":"26387ab4-74da-49d7-965e-352da48d6a90"},{"index":34091,"token":false,"name":"Towering-Wave Mystic","scryfallId":"8203f709-0fac-41c1-a056-3fa1a2c1d127"},{"index":34093,"token":false,"name":"Saproling Cluster","scryfallId":"681224b6-ddf1-4405-8720-951c0fce44a5"},{"index":34094,"token":false,"name":"Dawnbringer Charioteers","scryfallId":"eca7b7d9-8b69-411a-8a1d-9b7d0492e7d0"},{"index":34095,"token":false,"name":"Cunning Strike","scryfallId":"e4991f81-3190-4d33-bf09-9d5387cbec11"},{"index":34098,"token":false,"name":"Offering to Asha","scryfallId":"260fe443-ca03-42b1-bcee-86e5173c1aaf"},{"index":34100,"token":false,"name":"Giant Ox","scryfallId":"fc71d8ca-c613-4534-bc9d-bc1e13202a2c"},{"index":34101,"token":false,"name":"Krakilin","scryfallId":"6d19ce30-a33e-4d34-a73e-21ff79b010e5"},{"index":34103,"token":false,"name":"Implement of Ferocity","scryfallId":"bcdee084-0d1a-486a-8361-680d394a5e23"},{"index":34112,"token":false,"name":"Ancestral Knowledge","scryfallId":"05b90d72-00ac-4423-8cdf-e1471c6cd0ae"},{"index":34113,"token":false,"name":"Veteran Brawlers","scryfallId":"ee4d3acb-68be-409d-beb7-92a7cbc0402f"},{"index":34120,"token":false,"name":"Dream Tides","scryfallId":"3bd292a0-ec08-4250-8d75-0802e985d6e6"},{"index":34122,"token":false,"name":"Feiyi Snake","scryfallId":"099d92e3-d77a-4307-8c2f-9587abd20998"},{"index":34128,"token":false,"name":"Hell Mongrel","scryfallId":"f7da32a3-8e33-4603-abd2-8db144062f6a"},{"index":34129,"token":false,"name":"Sparring Collar","scryfallId":"5fc31145-19b4-4dbe-8756-f49791aa147e"},{"index":34133,"token":false,"name":"Artifact Ward","scryfallId":"b3a5101a-ec66-4658-950c-9ad49c29b836"},{"index":34136,"token":false,"name":"Anaba Ancestor","scryfallId":"c4d33cc0-525d-4e25-927b-b6b18087c27b"},{"index":34148,"token":false,"name":"Harness by Force","scryfallId":"9bde89c1-aafa-43d9-adbf-671fa2b52d4f"},{"index":34152,"token":false,"name":"Shimmerscale Drake","scryfallId":"edb13075-0ea0-480a-84c0-8eec3119db45"},{"index":34154,"token":false,"name":"Kindle the Carnage","scryfallId":"4b5dfa91-8f93-41b7-95e9-3374550f1617"},{"index":34155,"token":false,"name":"Junk Winder","scryfallId":"66b7833a-a6b6-4aca-b574-66a6aea471ea"},{"index":34157,"token":false,"name":"Sunfire Balm","scryfallId":"0d563ebb-ecd1-406c-9d69-c101acdeced7"},{"index":34159,"token":false,"name":"War's Toll","scryfallId":"de5f6c39-55eb-4d8d-83cf-94652b07bc46"},{"index":34161,"token":false,"name":"Captivating Vampire","scryfallId":"1b825bd1-9cbc-45a8-bfbe-fc3e8fdc575e"},{"index":34165,"token":false,"name":"Clear the Land","scryfallId":"b87f3579-f314-4207-a02c-14e9cb269b47"},{"index":34168,"token":false,"name":"Riot Control","scryfallId":"d7886607-86db-4221-8752-296104aaaef2"},{"index":34172,"token":false,"name":"Quicksmith Spy","scryfallId":"e6bfd5d4-cd83-4617-9a5c-98adc65369b3"},{"index":34181,"token":false,"name":"Voldaren Pariah // Abolisher of Bloodlines","scryfallId":"90193e53-aa2f-48ad-b133-18338fedb64b"},{"index":34184,"token":true,"name":"Construct Token (Colorless, 4/4)","scryfallId":"7fee6034-f0bb-49b9-ad75-67d3d6be1159"},{"index":34185,"token":false,"name":"Corpse Knight","scryfallId":"42e1033b-383e-49b4-875f-ccdc94e08c9d"},{"index":34196,"token":false,"name":"Nim Devourer","scryfallId":"a037ef49-8849-41aa-aa6e-3ac6ee34cdad"},{"index":34198,"token":false,"name":"Reflexes","scryfallId":"139d9770-4316-4ac1-b235-5a1d6e15cece"},{"index":34199,"token":false,"name":"Grunn, the Lonely King","scryfallId":"b6a9aa5c-1501-4958-872a-39c512514033"},{"index":34200,"token":false,"name":"Cave-In","scryfallId":"440d9d26-f304-467d-af79-914cc65f082e"},{"index":34206,"token":false,"name":"Dazzling Reflection","scryfallId":"f77977e8-25d8-4531-a6fc-8c46e6904670"},{"index":34211,"token":true,"name":"Pheres-Band Revelers Token (Colorless, 4/4)","scryfallId":"ae0182f2-31c0-4927-9ca5-0b3f4d342409"},{"index":34213,"token":false,"name":"Meglonoth","scryfallId":"b69e32b7-87d6-44a8-a544-5dabcd64c9f3"},{"index":34217,"token":false,"name":"Port Inspector","scryfallId":"ef25d969-68d9-4580-bb29-f72bd5646a3d"},{"index":34220,"token":false,"name":"Infiltrator's Magemark","scryfallId":"703d7848-f0ff-4f52-9320-95a2153d36b2"},{"index":34221,"token":false,"name":"Krosan Groundshaker","scryfallId":"82105090-5f71-4690-9ade-187354311ae3"},{"index":34224,"token":false,"name":"Bile Urchin","scryfallId":"801c2b46-c7a7-44d6-ae38-5d34bf00c404"},{"index":34225,"token":false,"name":"Livewire Lash","scryfallId":"bbef3e31-eb5a-43f7-a0b2-12348df6968d"},{"index":34232,"token":false,"name":"Kinjalli's Caller","scryfallId":"625211d4-c89c-4aee-a0b0-4bfabd3509ad"},{"index":34235,"token":false,"name":"Waking Nightmare","scryfallId":"3cc87c53-0612-42a7-9c32-f7d1adf246af"},{"index":34239,"token":false,"name":"Brackish Trudge","scryfallId":"90ba37ee-159f-421f-8d37-a7b5f1b562f0"},{"index":34240,"token":false,"name":"Trolls of Tel-Jilad","scryfallId":"6535f2ad-6cda-4be9-8e4f-6f062b63be31"},{"index":34243,"token":false,"name":"Traveler's Cloak","scryfallId":"c29e4a61-8f84-4c19-909d-6aebb3b9ab9b"},{"index":34245,"token":false,"name":"Tah-Crop Elite","scryfallId":"7f9a21a5-693c-4681-a0dd-36500ae17288"},{"index":34246,"token":false,"name":"Firewing Phoenix","scryfallId":"08d7c90a-b999-4e0b-87df-7355d6c36fb1"},{"index":34253,"token":false,"name":"Golden Urn","scryfallId":"ec7abeca-da01-4962-b107-dd7a77469753"},{"index":34254,"token":false,"name":"Mercenary Informer","scryfallId":"98ee3f50-09d7-4960-8214-680a7299fa20"},{"index":34255,"token":false,"name":"Planar Overlay","scryfallId":"1315fef0-234e-44f5-a7a3-bf3db78943c3"},{"index":34259,"token":true,"name":"Vampire // Treasure Token (W, 1/1)","scryfallId":"05934d59-7e98-4fff-8ccb-70cd1a61c6fd"},{"index":34261,"token":false,"name":"Gnottvold Slumbermound","scryfallId":"735470df-65d8-43e9-837e-4869c8e4f052"},{"index":34263,"token":false,"name":"Imperial Hellkite","scryfallId":"1fc3c5f3-f71b-4a1e-bd90-365d23889925"},{"index":34264,"token":false,"name":"Sweep Away","scryfallId":"cad50269-6e80-47ea-a027-fa274f904e86"},{"index":34270,"token":false,"name":"Dragonscale Boon","scryfallId":"7dfc2e53-719c-4d07-aac4-c99fb8dd70e8"},{"index":34273,"token":false,"name":"Furnace Scamp","scryfallId":"97538294-058c-47d4-b7a8-4db3753a6628"},{"index":34276,"token":true,"name":"Brian Selden Decklist","scryfallId":"b172a9c5-802d-46af-a97b-86b0bce4596a"},{"index":34280,"token":false,"name":"Faerie Squadron","scryfallId":"4c707c81-dbbd-43be-a79a-7bc92a584839"},{"index":34281,"token":false,"name":"Escape Routes","scryfallId":"dbc9062e-ddd9-41ac-a88a-33f5a7b22103"},{"index":34284,"token":true,"name":"Ixalan Checklist","scryfallId":"4a8b3030-5495-404b-938c-8c4a387a1341"},{"index":34299,"token":false,"name":"Forbidding Watchtower","scryfallId":"ac2d2959-6d31-4547-8c04-c19009c94434"},{"index":34301,"token":true,"name":"Lightning Rager Token (R, 5/1)","scryfallId":"cde2b3db-d71b-401f-852c-81c39d585a16"},{"index":34309,"token":false,"name":"Burn the Impure","scryfallId":"b5641730-428d-4484-866e-ec1ac669537f"},{"index":34310,"token":false,"name":"Pitiless Pontiff","scryfallId":"98f66c03-cf79-4de0-be55-b921cbdc5038"},{"index":34313,"token":false,"name":"Kavu Runner","scryfallId":"2bc1b462-4e3c-47cc-87c5-f6e29dd70c01"},{"index":34314,"token":false,"name":"Quag Vampires","scryfallId":"d6f0220f-6120-433a-b37f-f655f25322c5"},{"index":34315,"token":false,"name":"Lurking Automaton","scryfallId":"e052a306-2bcd-4dcd-b41d-fa886227dab6"},{"index":34316,"token":false,"name":"Dazzling Sphinx","scryfallId":"47287f15-c480-4c93-8f04-10f57a089c2e"},{"index":34328,"token":false,"name":"Timebender","scryfallId":"62fdf8bd-a069-41ca-9cbb-deb7f53cbcbe"},{"index":34332,"token":false,"name":"Strict Proctor","scryfallId":"6d414102-f31a-4a5d-95f0-879a6f0113b6"},{"index":34334,"token":true,"name":"Dinosaur Token (R, 1/1)","scryfallId":"f918b740-1984-4090-8886-9e290a698b95"},{"index":34336,"token":false,"name":"Final Payment","scryfallId":"49a21a8f-9c7b-4ae8-8635-f2ee2151c8de"},{"index":34340,"token":false,"name":"Whimwader","scryfallId":"b10e1d8b-edae-4b5e-b897-2c0a307e650c"},{"index":34344,"token":false,"name":"Infernal Contract","scryfallId":"d0e91036-eb02-465a-96f3-d2ac5656d0a8"},{"index":34349,"token":false,"name":"Champion of Stray Souls","scryfallId":"f0efbddb-c076-4552-b417-3608e0696a77"},{"index":34352,"token":false,"name":"Ethereal Valkyrie","scryfallId":"552912bf-4085-49ad-902f-5c41540df97a"},{"index":34355,"token":false,"name":"Sarkhan, Fireblood","scryfallId":"3553a70e-75de-4a8c-9b20-92cd4a317101"},{"index":34356,"token":false,"name":"Starlight Invoker","scryfallId":"4c66afc4-3d6d-4ce7-acfc-a4ad34aa3e99"},{"index":34359,"token":false,"name":"Skitterskin","scryfallId":"e3cbecdc-bc30-4797-bf6f-a7a61db05b48"},{"index":34364,"token":false,"name":"Thorncaster Sliver","scryfallId":"3655d837-945f-4ff5-8952-cff5f7b2d18f"},{"index":34365,"token":false,"name":"Spore Frog","scryfallId":"6d42fd52-34ea-4d1b-80dc-58fb0593bb5b"},{"index":34373,"token":false,"name":"Scarscale Ritual","scryfallId":"71d3f64a-ffb9-4f66-91c0-463b5d2d381b"},{"index":34376,"token":false,"name":"Extinction","scryfallId":"a233a244-7f84-4525-b0ce-e10db0a95385"},{"index":34381,"token":false,"name":"Matsu-Tribe Birdstalker","scryfallId":"f1afb0c0-e138-4d2b-b3aa-fa40778f8d79"},{"index":34391,"token":false,"name":"Great Whale","scryfallId":"58a2acf1-dad8-4f93-a34e-891e5178a48f"},{"index":34392,"token":false,"name":"Lich's Mirror","scryfallId":"78aa9a89-b7bf-49bc-a6e8-793d52120a22"},{"index":34394,"token":false,"name":"Civic Stalwart","scryfallId":"aa981489-4301-43f6-b1d7-2aa42e00cf75"},{"index":34396,"token":false,"name":"Protective Bubble","scryfallId":"7ab1db58-66b6-4b92-9dcd-e044fa383469"},{"index":34399,"token":false,"name":"Fungus Elemental","scryfallId":"4336bfd1-27a4-414d-b6fe-f186a0563dc0"},{"index":34412,"token":false,"name":"Anthem of Rakdos","scryfallId":"ea00d757-0ea9-4123-89f6-0a437d7fd33d"},{"index":34426,"token":false,"name":"Chronomantic Escape","scryfallId":"cb6989fd-05cf-4169-96c0-37c556454b92"},{"index":34429,"token":false,"name":"Jace's Ingenuity","scryfallId":"0b2c652a-f82f-4ad1-96ff-5788d6b4aebf"},{"index":34433,"token":false,"name":"Imminent Doom","scryfallId":"3f5615d9-a451-41cc-aca0-120ccddb46bd"},{"index":34438,"token":false,"name":"Helm of Possession","scryfallId":"79e16191-8dca-491b-b892-17696023d581"},{"index":34440,"token":false,"name":"Fanatical Devotion","scryfallId":"be0ed1fb-d380-4e3e-a43f-c39660a996e9"},{"index":34444,"token":false,"name":"Golgari Cluestone","scryfallId":"ff77e1ee-7fa3-4370-a0c9-ec008b63302f"},{"index":34446,"token":false,"name":"Kiss of Death","scryfallId":"bf6832c1-a0a9-49ec-a787-879e510aee08"},{"index":34453,"token":false,"name":"Roaring Slagwurm","scryfallId":"0338c6fe-54f6-4be0-a70d-b15e5403d842"},{"index":34457,"token":false,"name":"Cogwork Tracker","scryfallId":"2ad996e5-f3b4-4aca-8b37-d20632245b4e"},{"index":34458,"token":false,"name":"Bay Falcon","scryfallId":"df45268a-b757-4ad2-bab0-869058ee9186"},{"index":34461,"token":false,"name":"Ajani's Mantra","scryfallId":"089b1057-ed1f-45a5-ba95-28aa51713764"},{"index":34462,"token":false,"name":"Ruin Processor","scryfallId":"d997088b-f8f9-4e4c-ba64-aa7f43cc7505"},{"index":34465,"token":false,"name":"Skyshroud Forest","scryfallId":"4f2ec3d4-9dd6-42ee-ac6e-e05ae243e663"},{"index":34470,"token":false,"name":"Sightless Brawler","scryfallId":"7e2fcd27-c068-468f-9825-2825c0cf217d"},{"index":34472,"token":false,"name":"Study Hall","scryfallId":"a3de9859-98b6-4efe-847a-43bac5b1ef9f"},{"index":34473,"token":false,"name":"Chimeric Sphere","scryfallId":"cc96857c-b38e-4614-9838-cacd3700e3ee"},{"index":34474,"token":false,"name":"Zodiac Rat","scryfallId":"e96a635b-202f-4ffe-ac98-b8634cd5dc50"},{"index":34476,"token":false,"name":"Kingpin's Pet","scryfallId":"3465cf63-4f10-4b53-9703-69746364dbc7"},{"index":34478,"token":false,"name":"Drannith Stinger","scryfallId":"612ee4be-e7a2-423c-a37c-7c6ca97f630e"},{"index":34485,"token":false,"name":"Midvast Protector","scryfallId":"d4f6214f-90cb-4575-b221-3c8d0ed65ffe"},{"index":34492,"token":false,"name":"Blessed Light","scryfallId":"4cf3eb65-0f52-49c1-8243-14ce05de9f3b"},{"index":34496,"token":false,"name":"Tezzeret's Gatebreaker","scryfallId":"584e0528-01c2-49fb-aa4a-098172bb17a7"},{"index":34498,"token":false,"name":"Utopia Tree","scryfallId":"720452e9-3245-4b0e-94b6-843cbcb641a5"},{"index":34506,"token":false,"name":"Dwarven Lieutenant","scryfallId":"ea9a38b1-4676-425a-b40d-4fb478966024"},{"index":34509,"token":false,"name":"Dawn Charm","scryfallId":"a4c9667b-1d94-42eb-ae8e-1ae4755e200a"},{"index":34510,"token":false,"name":"Psychotic Fury","scryfallId":"4f626c70-1ede-4b00-bd95-d6ee26371131"},{"index":34516,"token":false,"name":"Savai Triome","scryfallId":"5d24f4bc-e0a4-4838-bf26-3e87c715e3bb"},{"index":34525,"token":false,"name":"Nagging Thoughts","scryfallId":"a8a6d6e4-e91f-444f-9eed-88fceaf1a4b8"},{"index":34527,"token":false,"name":"Last Caress","scryfallId":"12317075-92a2-4b3a-a694-3b764132beaf"},{"index":34533,"token":false,"name":"Warped Devotion","scryfallId":"3bce620f-799a-4ad8-9edb-6fb3d9ea1cc6"},{"index":34540,"token":false,"name":"Verdant Automaton","scryfallId":"52c66c5a-0b1b-4936-9e07-2d169f16c1a6"},{"index":34543,"token":false,"name":"Syr Gwyn, Hero of Ashvale","scryfallId":"a33add37-379d-4a90-9c04-529dff676986"},{"index":34544,"token":false,"name":"Goblin Hero","scryfallId":"1d21c8c9-6e16-4eb2-b2f5-3998f0f958ae"},{"index":34548,"token":false,"name":"Lotus Blossom","scryfallId":"46d17e0a-5407-4fde-8eb0-8f580eab5565"},{"index":34556,"token":false,"name":"Star Pupil","scryfallId":"99e9318f-2e17-4b6e-895f-c17cd5d0d282"},{"index":34563,"token":false,"name":"Silent Observer","scryfallId":"ef62550a-e6d4-4693-8bb4-1363f07e7e7a"},{"index":34566,"token":false,"name":"Scrib Nibblers","scryfallId":"4170ddd3-53bd-4ec7-82c0-4fb48f400aa5"},{"index":34567,"token":false,"name":"Thundering Sparkmage","scryfallId":"a9e6de80-3516-426b-8a1b-bda45f8c0cac"},{"index":34569,"token":false,"name":"Updraft Elemental","scryfallId":"9621c700-569d-4d07-847e-68b97113415f"},{"index":34570,"token":false,"name":"Killing Wave","scryfallId":"33de2371-175e-4f8a-9636-35f996e3cf24"},{"index":34576,"token":false,"name":"Visions of Brutality","scryfallId":"ec9ed374-54ad-4b81-b071-0b4668feb282"},{"index":34580,"token":false,"name":"Earthshaker","scryfallId":"283b47a9-c21e-4c0a-9c70-38b8ebbffab3"},{"index":34586,"token":false,"name":"Seahunter","scryfallId":"c375f65a-6d88-4d3c-a7a7-8c7a5cc5807f"},{"index":34587,"token":false,"name":"Mercenaries","scryfallId":"7b28762d-1ab7-460e-b433-27f5fa858959"},{"index":34589,"token":false,"name":"Smokespew Invoker","scryfallId":"fea393a4-58c8-4a42-bd95-a3312504f2e2"},{"index":34591,"token":false,"name":"Reality Twist","scryfallId":"1b7e955c-3de2-430c-93b9-0b39ccea5420"},{"index":34599,"token":false,"name":"Homarid Spawning Bed","scryfallId":"16e9392f-195d-4d4a-95c8-ef4597b5e26b"},{"index":34600,"token":true,"name":"Labyrinth Guardian Token (W, 2/3)","scryfallId":"754eeff5-b495-4aa5-94ce-ff20216c952b"},{"index":34608,"token":false,"name":"So Shiny","scryfallId":"135db79f-6f07-486c-ae3a-d4244aaf6dc8"},{"index":34613,"token":false,"name":"Nantuko Vigilante","scryfallId":"912f302f-fb56-4453-8a66-35d34e493508"},{"index":34618,"token":false,"name":"Kaervek's Purge","scryfallId":"7a42ef95-92ec-40fe-ab30-a476f012a525"},{"index":34620,"token":false,"name":"Scepter of Fugue","scryfallId":"21f7e17c-45df-45e9-8dcf-7fc90fa4d65d"},{"index":34622,"token":false,"name":"Culling Mark","scryfallId":"d4c45eda-9f00-4b40-b91d-0ed00151923c"},{"index":34624,"token":false,"name":"Sylvan Hierophant","scryfallId":"432a6908-0ee3-45c5-9089-b7f8cf1184bb"},{"index":34626,"token":false,"name":"Vulshok War Boar","scryfallId":"bb6b232a-834c-4c9a-bf36-821d125dc318"},{"index":34628,"token":false,"name":"Khorvath's Fury","scryfallId":"39107560-58d5-4a7d-84a0-df26f89856b4"},{"index":34629,"token":false,"name":"Gore Swine","scryfallId":"31c36d53-1173-4a55-8fb8-63a624fde7de"},{"index":34632,"token":false,"name":"Dread","scryfallId":"9b608658-9150-439b-b0a0-4a994722b95c"},{"index":34635,"token":false,"name":"Scandalmonger","scryfallId":"10c97baa-9bc0-4894-867c-ad1f56c469fd"},{"index":34641,"token":false,"name":"Azimaet Drake","scryfallId":"854ba4e0-f6f3-4b6c-b6cb-ab2b93d64601"},{"index":34644,"token":false,"name":"Dictate of Karametra","scryfallId":"d5114607-df8f-4e44-8ef5-b6af89964bbc"},{"index":34645,"token":false,"name":"Altac Bloodseeker","scryfallId":"f5dacedc-f532-43b3-a783-e1dc7ccea53b"},{"index":34646,"token":false,"name":"Dusk Legion Dreadnought","scryfallId":"aec26144-9acf-43b7-8614-1a2952df613d"},{"index":34647,"token":false,"name":"Lore Seeker","scryfallId":"9b8c78c8-b3fa-4a67-bf6c-cf708dedf42e"},{"index":34649,"token":true,"name":"Cat Token (G, 2/2)","scryfallId":"f6541414-c506-449d-b3a8-79f47be531a9"},{"index":34651,"token":false,"name":"Spell Burst","scryfallId":"f95c8015-fd7d-4329-ab23-aec37a824083"},{"index":34653,"token":true,"name":"Magic Origins Checklist","scryfallId":"f3dcc7b5-c911-44c9-be5a-087298ddb492"},{"index":34656,"token":false,"name":"Mistform Mutant","scryfallId":"a25b2697-5d7f-490a-8474-c775096e681e"},{"index":34665,"token":false,"name":"Binding Mummy","scryfallId":"fae54072-ae27-4aae-a2b7-71f4551934f6"},{"index":34668,"token":false,"name":"Shadow Stinger","scryfallId":"093e0b1e-2cd9-4743-9c0e-b8f3fbc41798"},{"index":34669,"token":false,"name":"Carpet of Flowers","scryfallId":"93abb48a-85f2-432d-8602-0a1d17fbb409"},{"index":34673,"token":false,"name":"Infuse with the Elements","scryfallId":"0ec25fe4-7967-42e2-8790-593738991eaa"},{"index":34679,"token":false,"name":"Sphinx Mindbreaker","scryfallId":"d70c50ce-48f0-49a6-9653-42b8ccb9a647"},{"index":34681,"token":false,"name":"Roughshod Mentor","scryfallId":"abe77862-516f-4eb2-9a41-0c6401d02843"},{"index":34683,"token":false,"name":"Phyrexian Boon","scryfallId":"6f82668b-50b3-4746-b7fd-82f8560ebd95"},{"index":34695,"token":false,"name":"Mass Polymorph","scryfallId":"13ffe61f-e52e-4d62-854b-10ac9cfbadd3"},{"index":34705,"token":false,"name":"Flux","scryfallId":"368b28e4-a367-4a38-866d-c3768bd9b7ad"},{"index":34708,"token":false,"name":"Kadena, Slinking Sorcerer","scryfallId":"6f6c7757-bcde-4d1e-9bdc-2b650905b5d8"},{"index":34709,"token":false,"name":"Onakke Ogre","scryfallId":"76e42d07-57d9-4de4-8d41-eb42dd1573ed"},{"index":34712,"token":false,"name":"Nuisance Engine","scryfallId":"ba455e40-274a-4de7-bf9d-9b55b1896eda"},{"index":34713,"token":false,"name":"Markov Warlord","scryfallId":"5035276f-31b9-4dd3-9ec8-42a664bdbd5c"},{"index":34717,"token":false,"name":"Duskrider Falcon","scryfallId":"bee3a23a-6ecf-439c-8637-e096fa8c1a80"},{"index":34722,"token":false,"name":"Keskit, the Flesh Sculptor","scryfallId":"b6448e6e-f625-4dce-a7b9-01fee55cce6f"},{"index":34723,"token":false,"name":"Ordeal of Purphoros","scryfallId":"16d4e46d-7aae-4fe5-9b0b-9a39e02e4883"},{"index":34725,"token":false,"name":"Blackbloom Rogue // Blackbloom Bog","scryfallId":"32779721-b021-4bd4-95d1-4a19b78d9faa"},{"index":34733,"token":false,"name":"Survival Cache","scryfallId":"1f98f6aa-d80b-426c-8160-6073af871fa8"},{"index":34737,"token":false,"name":"Wily Goblin","scryfallId":"a175b24c-c256-45a8-b24a-6b83e42d5efa"},{"index":34738,"token":false,"name":"Infernal Medusa","scryfallId":"26a5333f-2761-42b8-ae8b-1d360b109daf"},{"index":34748,"token":false,"name":"Axelrod Gunnarson","scryfallId":"a9c5dbc6-b0c5-4ae2-8c23-a26524fee543"},{"index":34749,"token":false,"name":"Garruk, Caller of Beasts","scryfallId":"d61f670e-8e4c-493f-bef0-c4c7b0bcd288"},{"index":34756,"token":false,"name":"In the Web of War","scryfallId":"f12b7124-d9d0-480c-b622-777a74d4f679"},{"index":34758,"token":false,"name":"Femeref Knight","scryfallId":"915a2e07-b449-4d94-93e3-e756e891c542"},{"index":34764,"token":false,"name":"Savannah Sage","scryfallId":"5b5fa4bb-e061-456f-808e-8d98b2c8abf5"},{"index":34766,"token":false,"name":"Thoughtpicker Witch","scryfallId":"b6f8df33-a955-403c-aafc-85e5589c5041"},{"index":34767,"token":false,"name":"Bog Elemental","scryfallId":"75191915-352e-4de7-b216-63f0ff588ba5"},{"index":34768,"token":false,"name":"Squall Line","scryfallId":"3f368729-a6f2-4bf7-8b06-39c551f0b24a"},{"index":34771,"token":false,"name":"Deafening Silence","scryfallId":"6072d9b0-d3c7-46f4-bd24-095bb13c4dea"},{"index":34775,"token":false,"name":"Vivien, Champion of the Wilds","scryfallId":"69f0f563-0f9b-4c61-966d-1384fefb8152"},{"index":34779,"token":false,"name":"Hostile Realm","scryfallId":"e172b353-7a16-4831-b735-206230b22e59"},{"index":34781,"token":false,"name":"Dross Prowler","scryfallId":"1fff470a-3574-42be-8f0b-ac5e7a70f61a"},{"index":34788,"token":false,"name":"Realm Razer","scryfallId":"da3ecfc6-1f9e-443e-a445-51df518025a5"},{"index":34790,"token":false,"name":"Myr Welder","scryfallId":"eff75f16-413c-4618-b766-67bd8ff4d161"},{"index":34792,"token":false,"name":"Fungal Rebirth","scryfallId":"4037e3b2-cb62-4f88-943d-3edcd6827c23"},{"index":34794,"token":false,"name":"Volley of Boulders","scryfallId":"aecab75c-25e5-4465-9c0a-28c2f6dc2ce5"},{"index":34797,"token":false,"name":"Draugr Recruiter","scryfallId":"6b0fe66b-0067-4e5c-9b3a-b014b2f0daf2"},{"index":34798,"token":false,"name":"Manascape Refractor","scryfallId":"7f164226-99e4-474e-a67d-b3fbff015a64"},{"index":34803,"token":false,"name":"Gift of Granite","scryfallId":"d7b5231b-aed9-4b88-aba5-43e57a705dc5"},{"index":34805,"token":false,"name":"Tsabo Tavoc","scryfallId":"ccbe2539-7a7c-468b-a270-7ca1bdcccb1e"},{"index":34807,"token":false,"name":"Mystic Remora","scryfallId":"13a08c07-e8b8-43bf-99e6-d268c79a62bf"},{"index":34814,"token":false,"name":"Wormhole Serpent","scryfallId":"2d0fd73f-e161-4e42-b4f9-9246a9dba785"},{"index":34821,"token":true,"name":"Ecstatic Piper Token (Colorless, 2/2)","scryfallId":"8f960d71-b55d-4730-9b3f-49e9afd2809c"},{"index":34827,"token":false,"name":"Rib Cage Spider","scryfallId":"d71bebea-1634-4d9a-b3ad-2e01ecacad7e"},{"index":34829,"token":false,"name":"Retribution of the Meek","scryfallId":"860b8633-1bfc-426a-8666-5e6a584d4525"},{"index":34833,"token":false,"name":"Escaped Shapeshifter","scryfallId":"e0171d4f-c871-4a7f-821a-82b7f401e9ca"},{"index":34834,"token":false,"name":"Pyroclastic Hellion","scryfallId":"5929c89b-8c61-47f5-a8ec-b64bf41e9d5b"},{"index":34837,"token":false,"name":"Skyship Weatherlight","scryfallId":"f4e97912-8afb-4f89-a130-627128a0abfb"},{"index":34846,"token":false,"name":"Aether Meltdown","scryfallId":"d07619d8-0902-4a1f-ad63-3e085062ec72"},{"index":34850,"token":false,"name":"Cinderbones","scryfallId":"22dcf40c-62fb-4205-807e-71655066a61b"},{"index":34862,"token":false,"name":"Hullbreacher","scryfallId":"4df8aabc-7fcb-4b7b-980b-18f499e6c170"},{"index":34863,"token":false,"name":"Malachite Talisman","scryfallId":"63fb8a24-ce53-4a69-be2a-55c6dbba5ee7"},{"index":34864,"token":false,"name":"Queen's Commission","scryfallId":"f06c0007-299e-4d71-99c3-f905d942759d"},{"index":34870,"token":false,"name":"Blaster Mage","scryfallId":"801b0fd1-bbb2-47c0-a4c3-4129a67473b9"},{"index":34874,"token":false,"name":"Elite Arcanist","scryfallId":"99b225fe-c07d-4d8a-bf2b-c1777bd29061"},{"index":34875,"token":false,"name":"Salt Flats","scryfallId":"224cb63f-9af0-4b00-ba0b-0b604abf20c8"},{"index":34878,"token":false,"name":"Takeno's Cavalry","scryfallId":"0cf9cd2e-5cf6-4959-abf2-56b686b636a3"},{"index":34886,"token":false,"name":"Toxic Nim","scryfallId":"5823990c-8d40-4352-8d34-74332934adb2"},{"index":34890,"token":false,"name":"Chandra, Flame's Catalyst","scryfallId":"1e49ce44-5286-4310-88c2-f8a1402b113b"},{"index":34891,"token":false,"name":"Hellfire Mongrel","scryfallId":"8f975874-24a6-4a14-bc5c-898c3d8e90e5"},{"index":34893,"token":false,"name":"Resplendent Griffin","scryfallId":"915f2ad9-fd39-465c-8261-bfa34116cbcc"},{"index":34904,"token":false,"name":"Savage Summoning","scryfallId":"b5346ed7-2e17-4d8c-9c4b-b5efdd26380d"},{"index":34906,"token":false,"name":"Canker Abomination","scryfallId":"00fac2e0-b65e-4b84-9d7e-2a9b2ddfe970"},{"index":34907,"token":false,"name":"Phyrexian Lens","scryfallId":"6ec9a91d-7af0-44a8-839f-fb9960be0ddd"},{"index":34909,"token":false,"name":"Leech Fanatic","scryfallId":"307f9fe7-241b-4eb6-a059-be5384b4a1b6"},{"index":34911,"token":false,"name":"Brighthearth Banneret","scryfallId":"cb44df5b-6c89-46ae-b068-5056b8c4c189"},{"index":34920,"token":false,"name":"Thaumatog","scryfallId":"aa559342-9587-4fe3-9059-3b3a08d6637a"},{"index":34921,"token":false,"name":"Indomitable Archangel","scryfallId":"94810748-7c70-4491-a355-c7c56cc03df0"},{"index":34935,"token":false,"name":"Summoning Station","scryfallId":"c8072944-268a-41e0-a1d8-9fe33e964bff"},{"index":34936,"token":false,"name":"Benthic Djinn","scryfallId":"95b03586-8d04-4114-a7ce-b8c8ab5ff857"},{"index":34937,"token":false,"name":"Surge of Righteousness","scryfallId":"114366f3-237f-4f96-b644-5bd82d97b18b"},{"index":34942,"token":false,"name":"Scorched Ruins","scryfallId":"75a4e843-937c-47fb-8768-0f42c5cb4e4f"},{"index":34949,"token":false,"name":"Dralnu's Pet","scryfallId":"cd5f4daf-7b54-4425-a93a-19532dfb83ca"},{"index":34950,"token":false,"name":"Talas Warrior","scryfallId":"de3d8cc5-5889-4e52-a32c-d15556fd2166"},{"index":34958,"token":false,"name":"Angler Turtle","scryfallId":"86caf85d-7fb3-4e28-b8ba-a8857f0268a4"},{"index":34961,"token":false,"name":"Deepfire Elemental","scryfallId":"d81fc89c-6eb8-4b75-bbaf-a7eb9679bab2"},{"index":34965,"token":false,"name":"Roil Eruption","scryfallId":"560c02ec-f21e-405b-8267-7f7ff089904a"},{"index":34967,"token":false,"name":"Snubhorn Sentry","scryfallId":"77642e28-24db-4082-971c-e7137c305a39"},{"index":34972,"token":false,"name":"Ward of Bones","scryfallId":"a271351e-5d5e-443b-99a4-ebdc8a3c4923"},{"index":34973,"token":false,"name":"Glimpse of Tomorrow","scryfallId":"7ee1fcbc-3573-42c5-b3e3-1f44a6400cd0"},{"index":34987,"token":false,"name":"Cinderheart Giant","scryfallId":"e4802e6c-6921-4dac-bf44-7e09d6942b71"},{"index":34988,"token":false,"name":"Fallen Ideal","scryfallId":"6b2d24b0-f0d3-40f0-a51f-074f8e95e6af"},{"index":34990,"token":false,"name":"Voyager Staff","scryfallId":"76554c65-edea-48b0-b3a5-483dfe80eaac"},{"index":34991,"token":false,"name":"Lantern-Lit Graveyard","scryfallId":"484a7675-787f-49be-9b44-edd0a7d73812"},{"index":34994,"token":false,"name":"Jodah's Avenger","scryfallId":"6c92ae75-a209-4cc4-8817-06ff18f3ac02"},{"index":34995,"token":false,"name":"Mindstorm Crown","scryfallId":"347c1442-036b-43e7-9f86-b81a54d6bc41"},{"index":34996,"token":false,"name":"Villainous Ogre","scryfallId":"0277c1ba-eae4-442b-8b80-20869ba20568"},{"index":34998,"token":false,"name":"Mosquito Guard","scryfallId":"626040ca-adb0-49c8-82cd-d1e27926cb79"},{"index":35012,"token":false,"name":"Canopy Dragon","scryfallId":"20c5e4d6-b716-4994-b226-b1eb799bec25"},{"index":35017,"token":false,"name":"Fettergeist","scryfallId":"8e89ef0e-1bfe-4e12-90ee-38f993cd8110"},{"index":35027,"token":false,"name":"Plasm Capture","scryfallId":"0ffe8485-d5fb-47cc-af53-6e0fd062b7a2"},{"index":35028,"token":false,"name":"Conclave Mentor","scryfallId":"a328a93a-e720-46d5-a190-cc65d1c90cea"},{"index":35029,"token":false,"name":"Crumble to Dust","scryfallId":"63352c11-807d-4878-a975-02ef451c3184"},{"index":35031,"token":false,"name":"Testament of Faith","scryfallId":"f399b371-fed0-42b8-8f95-5d76fdbe193d"},{"index":35032,"token":false,"name":"Mentor's Guidance","scryfallId":"0dbb1230-a465-4499-bb9c-35a06712a08b"},{"index":35033,"token":false,"name":"Sea Troll","scryfallId":"b7da23d4-f9fb-40a5-8395-51b47a064600"},{"index":35042,"token":false,"name":"Jazal Goldmane","scryfallId":"22641d54-f16c-417d-b6e0-a77e8f56e31c"},{"index":35049,"token":false,"name":"Sunbeam Spellbomb","scryfallId":"d23ffdb7-9f8e-4376-9431-cf1c1814f2c4"},{"index":35054,"token":false,"name":"Blast of Genius","scryfallId":"7a97c6e7-affd-455a-925c-332ca6b7a6a5"},{"index":35055,"token":false,"name":"Rootwater Hunter","scryfallId":"cdf7ea34-2cde-4ec5-9b12-99b0002da986"},{"index":35056,"token":false,"name":"Metamorphic Alteration","scryfallId":"e3e2218b-7472-49fa-8b85-590586f293bf"},{"index":35057,"token":false,"name":"Beacon Hawk","scryfallId":"be04ea4a-087e-4a6d-9973-0778a1ed2b7e"},{"index":35059,"token":false,"name":"Vine Kami","scryfallId":"fa5241c8-7f50-413e-9ac0-9ab0ad5c884c"},{"index":35062,"token":false,"name":"Deepwood Drummer","scryfallId":"acbed0f5-2ac0-48d8-b5ab-b4cd7176fde2"},{"index":35066,"token":false,"name":"Dwarven Armorer","scryfallId":"1d50bf06-97ab-4874-a484-9289f41dc98e"},{"index":35068,"token":false,"name":"Pillar Tombs of Aku","scryfallId":"153f93fd-4f2c-4dce-a774-4483031ed532"},{"index":35069,"token":false,"name":"Silent-Chant Zubera","scryfallId":"272dfee6-9c90-4409-9289-f451261909e7"},{"index":35074,"token":false,"name":"Nath of the Gilt-Leaf","scryfallId":"0c6c69bd-a8bf-4085-85fa-364b8e92b88a"},{"index":35075,"token":false,"name":"Caldera Kavu","scryfallId":"fcad32aa-2ce1-402d-a9d8-ad5c81fe4c5b"},{"index":35079,"token":false,"name":"Quickling","scryfallId":"278fbdb9-51e3-4ed6-bcc5-c5b86f06c216"},{"index":35084,"token":true,"name":"Eldrazi Horror Token (Colorless, 3/2)","scryfallId":"11d25bde-a303-4b06-a3e1-4ad642deae58"},{"index":35085,"token":false,"name":"Acorn Catapult","scryfallId":"9fed5706-d7bd-4c8c-b301-4909b3167d06"},{"index":35086,"token":false,"name":"Brittle Effigy","scryfallId":"b1e2a430-339c-46ae-a43f-61e11e018b7b"},{"index":35087,"token":false,"name":"Lammastide Weave","scryfallId":"667fd7ab-de75-48e7-8d4b-a96130ae4666"},{"index":35089,"token":false,"name":"Silverback Ape","scryfallId":"025b3156-975d-4f64-b19c-172cb21266c5"},{"index":35091,"token":false,"name":"Dauntless Unity","scryfallId":"b12a4d17-68e6-4133-99fd-e501e24e6c6b"},{"index":35092,"token":false,"name":"Fallen Cleric","scryfallId":"7652dc61-9170-4895-a0bf-c32a1ee0350e"},{"index":35102,"token":false,"name":"Solar Tide","scryfallId":"57ce33b6-267f-4ee8-a3f7-f41c619d0cfa"},{"index":35106,"token":false,"name":"Parapet Watchers","scryfallId":"499f9987-87d8-4cd3-98c4-b6976c70739e"},{"index":35120,"token":false,"name":"Stream of Unconsciousness","scryfallId":"54ba05db-6b09-4b6a-b7fe-13c1e1058e25"},{"index":35121,"token":false,"name":"Avatar of Slaughter","scryfallId":"f2e0978f-8577-443b-9f7d-59f439510d78"},{"index":35122,"token":false,"name":"Fell Specter","scryfallId":"e8cb52a4-5fec-41a0-8030-503a61e3d33e"},{"index":35123,"token":false,"name":"Zhalfirin Crusader","scryfallId":"d8ed802f-6e54-4fed-a71e-6d404c2c664b"},{"index":35124,"token":false,"name":"Nakaya Shade","scryfallId":"eefd9315-9b7c-4c6b-8a15-a6af873dab6f"},{"index":35127,"token":false,"name":"Blinking Spirit","scryfallId":"f6ff7626-de7d-443a-8eb7-fccaba6f2336"},{"index":35131,"token":false,"name":"Dream Devourer","scryfallId":"30c01887-d4b3-46d2-af6b-2877659d057f"},{"index":35133,"token":false,"name":"Nissa's Chosen","scryfallId":"8f370eff-3980-4c19-808b-c1099279ef20"},{"index":35135,"token":false,"name":"Lavinia of the Tenth","scryfallId":"c31e25f7-cc27-4f72-a314-1cf7971a2fbc"},{"index":35142,"token":false,"name":"Curse of Marit Lage","scryfallId":"69b381c1-aa71-4d40-a320-70f58a440d51"},{"index":35146,"token":false,"name":"Goblin Bully","scryfallId":"6f22a45e-7352-4f5b-b298-eca4375ea28c"},{"index":35147,"token":false,"name":"Caught in the Brights","scryfallId":"4d5bea27-d825-4691-8ae0-c4831574ec53"},{"index":35148,"token":false,"name":"On Serra's Wings","scryfallId":"c0a57c65-5010-4472-b877-42daf2f15af2"},{"index":35157,"token":false,"name":"Undercity Plague","scryfallId":"7b25d3bc-33e9-4d1a-855d-38580e67b6cc"},{"index":35170,"token":false,"name":"Blood Burglar","scryfallId":"01efd5af-ed6d-4132-8f33-37f6a9fa55d0"},{"index":35172,"token":false,"name":"Blind Fury","scryfallId":"0ff91a17-0a5f-456f-a431-8505ba29e679"},{"index":35184,"token":false,"name":"Wolverine Riders","scryfallId":"70fd0439-294b-454c-b2af-e814b85f4590"},{"index":35185,"token":false,"name":"Wall of Wonder","scryfallId":"14c65a4e-ea5a-4cad-9542-1cfd18eb3c25"},{"index":35187,"token":false,"name":"Draconian Cylix","scryfallId":"a419c9e3-5615-44f9-9256-94a3022bb69f"},{"index":35189,"token":false,"name":"Amareth, the Lustrous","scryfallId":"f31ad3a5-4e42-4f2c-badf-4cef2a39be41"},{"index":35191,"token":false,"name":"Spreading Seas","scryfallId":"37454c1c-4098-4ac2-884e-3f65f1384bdb"},{"index":35192,"token":false,"name":"Knight Watch","scryfallId":"cd492072-9a8c-4d55-ac71-3c8efaa3fc87"},{"index":35194,"token":false,"name":"Vicious Rumors","scryfallId":"b1939952-608e-4786-beeb-a6ff0fa36624"},{"index":35195,"token":false,"name":"Spoils of Adventure","scryfallId":"9b3b1ef0-a653-4adb-8112-82d4822446b4"},{"index":35202,"token":false,"name":"Sadistic Hypnotist","scryfallId":"22d0fb5a-2545-4081-82f9-82a68b9a7bfb"},{"index":35203,"token":false,"name":"Blood of the Martyr","scryfallId":"22d4761d-acf2-4cb3-86a8-a3f30420a92e"},{"index":35205,"token":false,"name":"Colorful Feiyi Sparrow","scryfallId":"f05d9ff6-5f52-441a-a952-1693717d6995"},{"index":35206,"token":false,"name":"Anurid Murkdiver","scryfallId":"9e43d62c-488a-4c8d-b193-bacbf8037761"},{"index":35209,"token":false,"name":"Guardian of Tazeem","scryfallId":"5b55cf5e-4499-4e3a-9748-7b1568286b5a"},{"index":35217,"token":false,"name":"Demonic Collusion","scryfallId":"f1a68a28-05fa-4c6e-896d-ddb9aea3a38d"},{"index":35219,"token":false,"name":"Chlorophant","scryfallId":"c4fd0ea3-4134-4f7d-a0c8-01c49bacfcfc"},{"index":35228,"token":true,"name":"Sim Han How Decklist","scryfallId":"84e93fcb-b8cb-4f31-9ff4-d0180c40845a"},{"index":35233,"token":false,"name":"Capricious Sorcerer","scryfallId":"b8d5eec0-0afe-4af9-ba1b-70282df8cd0a"},{"index":35237,"token":false,"name":"Reach Through Mists","scryfallId":"0b6d5d29-4f38-4229-ac50-c4fa97fcc536"},{"index":35244,"token":false,"name":"Gorilla Berserkers","scryfallId":"344b4613-17f8-4c8b-b5bc-f773a8f8007a"},{"index":35247,"token":false,"name":"Lingering Death","scryfallId":"f174fd76-f28d-4272-8cb0-7f66cd60579e"},{"index":35252,"token":false,"name":"Oona's Grace","scryfallId":"441aa75a-e0f1-43d1-836a-9788e9fd1be5"},{"index":35254,"token":false,"name":"Orcish Captain","scryfallId":"e43cf61d-b4d6-4461-a228-47fd8b026d33"},{"index":35255,"token":false,"name":"Grismold, the Dreadsower","scryfallId":"8df64c80-9e98-4429-b869-7ac824fe9580"},{"index":35256,"token":false,"name":"Ambuscade","scryfallId":"cfc06303-cb35-4feb-b23d-7ac0a2fa7ce3"},{"index":35257,"token":false,"name":"Glimmerbell","scryfallId":"54f71f8a-546a-465e-a254-09a3ae873ef4"},{"index":35262,"token":false,"name":"Seismic Stomp","scryfallId":"4889cf72-3ae9-4880-81b8-4a14c0bfba2e"},{"index":35264,"token":false,"name":"Transmute Artifact","scryfallId":"6eab6765-eba3-4844-81ca-ae37a6e903df"},{"index":35267,"token":false,"name":"Sylvan Offering","scryfallId":"89cefed1-fcef-4def-8e16-d40a24e0c307"},{"index":35269,"token":false,"name":"Pardic Arsonist","scryfallId":"1c2538fa-2eb7-47ca-a1cf-e5546e26e584"},{"index":35271,"token":false,"name":"Charge Through","scryfallId":"ed16926f-feb0-481a-8c5e-88ea119752cd"},{"index":35272,"token":false,"name":"Slithery Stalker","scryfallId":"0c875bb6-55bb-41cc-8825-8011581ff001"},{"index":35273,"token":false,"name":"Kinjalli's Sunwing","scryfallId":"ed28e7f9-04b2-4103-8cca-899366f0fa84"},{"index":35275,"token":false,"name":"Snow Day","scryfallId":"a6b6f17d-45ba-4d60-a963-5eee026f2219"},{"index":35281,"token":false,"name":"Voldaren Duelist","scryfallId":"2a838f4d-1277-42ed-9f0a-d6112f7b5b4c"},{"index":35284,"token":false,"name":"Witherscale Wurm","scryfallId":"5187fc71-e4d3-4071-9ea1-d4513f30c529"},{"index":35285,"token":false,"name":"Celestial Ancient","scryfallId":"a0c6dcc4-2ad4-4f62-882b-01da7ace2591"},{"index":35286,"token":false,"name":"Temporal Machinations","scryfallId":"9ba8df17-ab81-4e28-b274-ad38aa2899b3"},{"index":35288,"token":false,"name":"Bog Tatters","scryfallId":"a0830c00-02fa-4fc8-907c-19d4b7f9cd6e"},{"index":35289,"token":false,"name":"Fall from Favor","scryfallId":"e709a18f-b99d-4fa1-ae5c-7f22abd02c0a"},{"index":35302,"token":false,"name":"Kavu Mauler","scryfallId":"79adc3af-5fa3-4cb6-9bbc-52ede0c69263"},{"index":35307,"token":false,"name":"Kagemaro, First to Suffer","scryfallId":"752f8672-1c37-4ab2-b290-fe3147784475"},{"index":35309,"token":false,"name":"Opaline Bracers","scryfallId":"3ae84edd-1294-4722-89d1-84d9f336871c"},{"index":35321,"token":false,"name":"Drossforge Bridge","scryfallId":"5b46b8d8-723a-4752-b97d-29ef83bd294c"},{"index":35322,"token":false,"name":"Kurkesh, Onakke Ancient","scryfallId":"2e2a0e9e-0e45-4af1-9f03-6fd3652933f9"},{"index":35324,"token":false,"name":"Arctic Wolves","scryfallId":"b5fb56a2-5138-4c31-aa4b-0824a1a24573"},{"index":35327,"token":false,"name":"Downdraft","scryfallId":"ab4ced80-926a-4e4d-8ebd-d4fe7374a6ad"},{"index":35330,"token":false,"name":"Thaumaturge's Familiar","scryfallId":"7b497153-69a8-480e-b02f-88afec9d5053"},{"index":35334,"token":false,"name":"Cavalcade of Calamity","scryfallId":"8a81e889-490b-4aeb-8e84-ea9a390bb8fe"},{"index":35336,"token":false,"name":"Mudbrawler Raiders","scryfallId":"cbe4af47-d913-4c19-a027-501e2c78758c"},{"index":35344,"token":false,"name":"Death or Glory","scryfallId":"81f967c9-b38d-489d-96cc-44a6b1804e10"},{"index":35349,"token":false,"name":"Loxodon Smiter","scryfallId":"69247168-2bfb-4cce-a2a6-61459a0fbce4"},{"index":35360,"token":false,"name":"Glowering Rogon","scryfallId":"974b0881-bd26-4074-93dd-a1e3600347c4"},{"index":35362,"token":false,"name":"Phyrexian Tyranny","scryfallId":"afd5f97c-2d6f-4856-9269-f4f8a0b3d6ff"},{"index":35373,"token":true,"name":"Core Set 2019 Checklist","scryfallId":"68d08909-a214-433b-a3b7-4baf916cd458"},{"index":35375,"token":false,"name":"Goldnight Redeemer","scryfallId":"df5656e3-5f53-41f8-9f24-04caad5e4ca3"},{"index":35376,"token":false,"name":"Scourge of Geier Reach","scryfallId":"e0c25932-96e7-4ae5-b544-8780f92d0be7"},{"index":35385,"token":false,"name":"Stensia Masquerade","scryfallId":"48f1b024-d7d5-4e81-b016-06826e2b8bbf"},{"index":35386,"token":false,"name":"Adaptive Automaton","scryfallId":"a3a74bb9-b850-4d94-81f4-ffe062e91c49"},{"index":35387,"token":false,"name":"Wrap in Vigor","scryfallId":"92d53533-b10e-430a-a6f6-58ecb508be77"},{"index":35388,"token":false,"name":"Planewide Celebration","scryfallId":"ed71c29a-a03a-401e-80f0-c8a08b902e71"},{"index":35397,"token":false,"name":"Mephidross Vampire","scryfallId":"754f202f-4f08-4c39-9219-1114d8508788"},{"index":35398,"token":false,"name":"Adamant Will","scryfallId":"3dfb8817-ca3c-44ba-92f2-e9d6294cd25d"},{"index":35399,"token":false,"name":"Pulmonic Sliver","scryfallId":"31c19d42-aaaf-417c-a303-74262f82e365"},{"index":35403,"token":false,"name":"Rysorian Badger","scryfallId":"ab87a387-678b-4913-a0c7-85f0238cee26"},{"index":35404,"token":false,"name":"Privileged Position","scryfallId":"f8fa7566-6f7d-4c01-a442-ff7b38684de5"},{"index":35405,"token":false,"name":"Flayer of the Hatebound","scryfallId":"ffb17c3f-0154-49ee-bb5f-cd1df8546871"},{"index":35409,"token":false,"name":"Silkwing Scout","scryfallId":"04f165aa-2986-47d1-912d-d50490a15c0b"},{"index":35412,"token":false,"name":"Netter en-Dal","scryfallId":"2190649d-f898-4693-8ccf-80e6709d8496"},{"index":35414,"token":false,"name":"Darkness","scryfallId":"584834fb-b7b6-40eb-9fec-8df17172ce5f"},{"index":35415,"token":false,"name":"Attunement","scryfallId":"0c01e2bc-0415-43cf-b955-9a529d0ab20f"},{"index":35417,"token":false,"name":"Barrin's Spite","scryfallId":"6d8ec4dc-c74a-4d49-856e-95703675fe9b"},{"index":35421,"token":false,"name":"Gore Vassal","scryfallId":"c2889bba-58a8-46e1-959c-0fd38c1732f9"},{"index":35427,"token":false,"name":"Vicious Offering","scryfallId":"aaed7828-57c1-4ad3-a91b-209c66f0876b"},{"index":35435,"token":false,"name":"Blighted Gorge","scryfallId":"f133ba0a-e141-4f57-9819-bc17bbacd7b3"},{"index":35437,"token":true,"name":"Minotaur Goreseeker Token (Colorless, 3/2)","scryfallId":"3d2f2bcc-0db9-4aa1-b63d-587c62468015"},{"index":35441,"token":false,"name":"Sorcerer's Broom","scryfallId":"071e8f20-18b3-4bf5-a23a-adb42bf5819b"},{"index":35446,"token":false,"name":"Kindred Dominance","scryfallId":"9794115a-5509-4d9a-b119-d2b61942e87b"},{"index":35447,"token":false,"name":"Curious Herd","scryfallId":"5a20acbc-6ca8-4b0c-ab7e-4bb8d429336b"},{"index":35448,"token":false,"name":"Cryptborn Horror","scryfallId":"8ffd77d7-3fe6-4493-96eb-f62183c0358d"},{"index":35451,"token":false,"name":"Opal-Eye, Konda's Yojimbo","scryfallId":"e08d5618-4fe0-4ae5-af16-696467aae02d"},{"index":35452,"token":false,"name":"Slagwoods Bridge","scryfallId":"e51b48e9-a75a-4acd-9462-5e1ac2b0d803"},{"index":35454,"token":false,"name":"Karplusan Hound","scryfallId":"95179b31-8cb5-4dd9-ad93-782b8774534d"},{"index":35464,"token":false,"name":"Duskmantle Prowler","scryfallId":"bcb031da-d41a-496a-b78e-0773f6504303"},{"index":35479,"token":false,"name":"City in a Bottle","scryfallId":"cfd5c243-2a40-4ba8-ad00-715f52eeda62"},{"index":35480,"token":false,"name":"Whiptail Moloch","scryfallId":"ccd8e674-49be-47b7-910d-736c9acfa916"},{"index":35488,"token":false,"name":"Fraying Omnipotence","scryfallId":"f0fa0ad8-854a-4b4e-9f87-e1dfaa11253c"},{"index":35489,"token":false,"name":"Maned Serval","scryfallId":"5ac51e35-e2c5-4457-981c-e59894584288"},{"index":35492,"token":false,"name":"Oakhame Adversary","scryfallId":"9fb4e77f-e189-4ad3-9fca-8da04289e396"},{"index":35493,"token":false,"name":"Goblin Grappler","scryfallId":"5c948872-295c-41b9-8094-db7db7578b0d"},{"index":35495,"token":false,"name":"Dawnstrike Paladin","scryfallId":"549ca818-f7bf-47a8-9005-18ddabd3c360"},{"index":35502,"token":false,"name":"Fire-Belly Changeling","scryfallId":"d4732342-71a4-4079-b549-f4454945273a"},{"index":35505,"token":false,"name":"Survivors' Bond","scryfallId":"530ff2a1-6447-4653-a661-d9a39156d6fa"},{"index":35510,"token":false,"name":"Hair-Strung Koto","scryfallId":"c5354475-6a0b-4b1f-b94c-7c103d99e88b"},{"index":35512,"token":false,"name":"Gilt-Leaf Seer","scryfallId":"0b4cc889-9bc1-48dd-b1d1-95daa73b8fbe"},{"index":35514,"token":false,"name":"Cursed Minotaur","scryfallId":"df48004d-004b-41b6-b975-80b350408944"},{"index":35517,"token":false,"name":"Righteous Authority","scryfallId":"8fd3341d-38e4-4dc0-9e95-34cb1f796e7e"},{"index":35520,"token":false,"name":"Coastal Discovery","scryfallId":"c1df2411-0b0d-4b93-bf30-a22487b3c6ef"},{"index":35529,"token":false,"name":"Hideous Visage","scryfallId":"25925751-b6cb-45a3-915f-d5ec3edcda78"},{"index":35530,"token":false,"name":"Seer of the Last Tomorrow","scryfallId":"95828631-66fe-4e08-8b24-a7e6327188ea"},{"index":35533,"token":false,"name":"Rotting Giant","scryfallId":"0a2db4b2-6209-4a49-b868-e5d229ffcbc1"},{"index":35535,"token":false,"name":"Dauthi Marauder","scryfallId":"ee847d84-ec8d-4ec3-8436-68d6f144e22f"},{"index":35537,"token":false,"name":"Rushwood Herbalist","scryfallId":"9afde98f-a429-4eff-9d06-8582267ac74b"},{"index":35540,"token":false,"name":"Plunge into Darkness","scryfallId":"d21c74b4-dd9e-43d6-ad0a-06e026a8d672"},{"index":35549,"token":false,"name":"Buccaneer's Bravado","scryfallId":"d82c583f-3d2b-4c7f-a6f4-97da150423b4"},{"index":35567,"token":false,"name":"Molten Sentry","scryfallId":"a9eb6c92-b385-4ef4-83ac-65a1a23e3d22"},{"index":35578,"token":false,"name":"Lazav, the Multifarious","scryfallId":"24c1e710-f61c-4dd6-b620-6d2e1ecab689"},{"index":35580,"token":false,"name":"Blazing Hope","scryfallId":"b6beac36-e12f-408d-a37b-a70e0e6c52d8"},{"index":35586,"token":false,"name":"Shield Mare","scryfallId":"d21e0516-4430-4292-850b-f5c524d7f8f8"},{"index":35587,"token":false,"name":"Treefolk Healer","scryfallId":"73c6f5c0-686d-4b3a-add7-487f9fff5faa"},{"index":35595,"token":false,"name":"Apostle's Blessing","scryfallId":"616b0dba-0b8c-406d-87e5-f0055fadccbb"},{"index":35597,"token":false,"name":"Battering Craghorn","scryfallId":"9ef71f42-87e5-4b1d-aac1-3752b81cee7c"},{"index":35600,"token":false,"name":"Worldheart Phoenix","scryfallId":"1927081a-4eea-48dd-a81a-2e751552751d"},{"index":35606,"token":false,"name":"Lashweed Lurker","scryfallId":"a13f9a76-3370-4809-88ff-c300bca31c9e"},{"index":35612,"token":false,"name":"Carrion Call","scryfallId":"bc3c1a8e-3bdb-42cf-9442-5de7e4670d66"},{"index":35613,"token":false,"name":"Pheres-Band Raiders","scryfallId":"80856020-f569-4d73-8c44-7b48535a69e8"},{"index":35614,"token":false,"name":"Igneous Inspiration","scryfallId":"5781ad7b-dc1b-4cc1-9e72-6e714b9ba1de"},{"index":35619,"token":false,"name":"Descendants' Path","scryfallId":"ada93208-5cda-4e2d-b9a7-15345e30b831"},{"index":35622,"token":false,"name":"Mascot Interception","scryfallId":"8f0ea66f-1756-4b0d-8ccc-3b3a7370b531"},{"index":35624,"token":false,"name":"Mobile Garrison","scryfallId":"da443378-f5cb-4240-9524-2c40ec17c933"},{"index":35626,"token":false,"name":"Collective Brutality","scryfallId":"59dcf43b-a65f-43e4-a683-437021565f6a"},{"index":35629,"token":false,"name":"Ghastly Remains","scryfallId":"63e67323-df54-4043-a6b6-18bb89ef1f62"},{"index":35634,"token":false,"name":"Archweaver","scryfallId":"f99dc8ff-932c-4d56-9253-99ce9e145306"},{"index":35636,"token":false,"name":"Turn the Tide","scryfallId":"bdc91fc7-7927-4c5d-888a-f40cbf658866"},{"index":35637,"token":false,"name":"Sawback Manticore","scryfallId":"c24e74e9-ce88-48af-a113-b4fe76f963d4"},{"index":35639,"token":false,"name":"Furnace Dragon","scryfallId":"c8cf297f-56df-4a6e-8dc9-eca3354dfb13"},{"index":35642,"token":false,"name":"Mechanized Production","scryfallId":"235dd8f1-215a-4b0a-9e94-0d0d5a3c730b"},{"index":35646,"token":false,"name":"Barbarian Outcast","scryfallId":"b9d67b5c-ab20-456e-8ff5-7521be8273b2"},{"index":35651,"token":false,"name":"Kefnet's Monument","scryfallId":"f5d20f0a-aa7c-4d40-acb2-2b86666afd53"},{"index":35656,"token":false,"name":"Rummaging Wizard","scryfallId":"ad96e158-bf2b-4f3e-9692-0f79efdd94f5"},{"index":35657,"token":false,"name":"Tenth District Veteran","scryfallId":"ef573e92-3106-4b42-90e8-0e165de0659f"},{"index":35659,"token":false,"name":"Tempered Veteran","scryfallId":"3b43d7bc-173c-41eb-bba9-a9d94dcfc5fa"},{"index":35660,"token":false,"name":"Body Snatcher","scryfallId":"c7d4c858-5a11-485d-a514-12a6d80459f0"},{"index":35666,"token":false,"name":"Heliod's Punishment","scryfallId":"3b8e6878-06aa-4505-b3a5-172083b7d258"},{"index":35667,"token":false,"name":"Vaultbreaker","scryfallId":"12891fcf-7118-428a-bdfe-9495a77f8b3d"},{"index":35675,"token":false,"name":"Stormchaser Mage","scryfallId":"7bba1b45-d8ae-42fd-b30f-c904640ab173"},{"index":35676,"token":false,"name":"Aphetto Exterminator","scryfallId":"06be8f63-daf2-4dbe-bb07-2b246145cdab"},{"index":35680,"token":false,"name":"Preferred Selection","scryfallId":"59ce9668-78ef-44a5-ba9c-49fa740b8cb5"},{"index":35681,"token":false,"name":"Transcendence","scryfallId":"84e8bee2-9e3d-493c-a937-645bf3dcf0db"},{"index":35682,"token":false,"name":"Spelljack","scryfallId":"3eda8c7b-ce35-482a-bece-52a30cc78a9a"},{"index":35694,"token":false,"name":"Fiery Finish","scryfallId":"3e38127d-63af-4d26-9ff5-358c8a61f39c"},{"index":35696,"token":false,"name":"Painsmith","scryfallId":"79301fd4-2f00-4ff5-993f-a6af2440064b"},{"index":35699,"token":true,"name":"Elemental Token (R/U, 4/4)","scryfallId":"3d0b9b88-705e-4df0-8a93-3e240b81355b"},{"index":35701,"token":false,"name":"Maralen of the Mornsong","scryfallId":"ba98d363-194b-4bc0-b9fe-987c498ab6fa"},{"index":35710,"token":false,"name":"Forlorn Pseudamma","scryfallId":"1c236a33-fb20-41f4-8946-beb65d1cf684"},{"index":35711,"token":false,"name":"Sethron, Hurloon General","scryfallId":"274cdb39-1454-4c9b-acd8-4f762a48e71f"},{"index":35713,"token":false,"name":"River Kaijin","scryfallId":"e403cad6-84b0-4a6b-a2d8-cb572ec09932"},{"index":35714,"token":false,"name":"Skinrender","scryfallId":"be358357-2abe-4ead-bb18-76cad8274489"},{"index":35723,"token":false,"name":"Dark Dabbling","scryfallId":"b3d5a047-2315-41a5-a78d-6a690622c457"},{"index":35729,"token":false,"name":"Eviscerator","scryfallId":"167e7f67-8d44-4134-b7b9-54ccdfb8675c"},{"index":35745,"token":false,"name":"Anointer of Valor","scryfallId":"d66fcbb8-0fa5-48a9-b40c-d5a12f09a858"},{"index":35755,"token":false,"name":"Glowspore Shaman","scryfallId":"08fe260a-d204-4e75-b3e5-0cd9b4ca7084"},{"index":35758,"token":false,"name":"Nissa's Judgment","scryfallId":"96b263fb-00b5-4050-85e1-cfc4018bb75d"},{"index":35760,"token":false,"name":"Cruel Entertainment","scryfallId":"3e304424-4a50-43bb-aee0-e9f960583aac"},{"index":35761,"token":false,"name":"Savvy Hunter","scryfallId":"15c98441-2b31-4e48-a399-f36dffcfa41d"},{"index":35768,"token":false,"name":"Cyclopean Giant","scryfallId":"fab6bc89-492a-46a4-90dc-95ae2e2bc483"},{"index":35770,"token":false,"name":"Yarok's Wavecrasher","scryfallId":"c86a8974-df86-43ee-b07f-fd2837c08a6a"},{"index":35774,"token":false,"name":"Skyline Predator","scryfallId":"5839556c-6635-44c4-96ed-666e4466b929"},{"index":35783,"token":false,"name":"Retreat to Coralhelm","scryfallId":"a40241b9-6bec-412e-9258-e487ea44223b"},{"index":35785,"token":false,"name":"Mischievous Quanar","scryfallId":"dc48c2db-f5b4-4c24-a5fa-00750b7ff56f"},{"index":35793,"token":false,"name":"Goblin Fire Fiend","scryfallId":"64d3b2d2-4ec2-495d-833d-7476cbfc80f6"},{"index":35796,"token":false,"name":"Raiders' Spoils","scryfallId":"cd3e423e-cb62-43e1-9d0c-e702f823c8e1"},{"index":35798,"token":false,"name":"Dragon Mantle","scryfallId":"d97b1080-9001-4751-b2f5-7f56d9f58dff"},{"index":35802,"token":false,"name":"Patrol Hound","scryfallId":"e216a539-152b-4a83-98ef-1996182a5714"},{"index":35814,"token":false,"name":"Mark of Fury","scryfallId":"5b21b2f4-a05d-477b-8a39-632f7ff7f5f5"},{"index":35818,"token":false,"name":"Jace's Mindseeker","scryfallId":"f67852a6-ae75-44e7-9e2d-d458c7b9d869"},{"index":35825,"token":false,"name":"Afflict","scryfallId":"20f18447-2853-469b-b3b3-20d6bcafa6e7"},{"index":35837,"token":false,"name":"Seizan, Perverter of Truth","scryfallId":"e1e61750-f7d7-4e6d-9d68-e1e357868a8d"},{"index":35838,"token":false,"name":"Indulging Patrician","scryfallId":"642e0c48-1f77-41e0-abbe-f570b757cd66"},{"index":35840,"token":false,"name":"Grasping Giant","scryfallId":"a238aa9c-661e-449a-8f05-70b7954e544f"},{"index":35844,"token":false,"name":"Akiri, Line-Slinger","scryfallId":"ccf9923a-ad50-49e5-bf96-c669a39b84fd"},{"index":35845,"token":false,"name":"Benalish Veteran","scryfallId":"09a5603a-88c8-4b0c-b091-6d97e873859a"},{"index":35846,"token":false,"name":"Insidious Will","scryfallId":"8eafb2bb-58bf-4c6b-ae8f-91bcea12c7d2"},{"index":35847,"token":false,"name":"Windgrace Acolyte","scryfallId":"f835285e-96d9-4574-a497-3b612cae8e22"},{"index":35848,"token":false,"name":"Cleansing","scryfallId":"fc1973a3-1410-4c6d-9b09-bd9d18646a1e"},{"index":35849,"token":false,"name":"Goblin Piledriver","scryfallId":"e754551e-a3cb-45f4-8106-a22dcf2c567a"},{"index":35854,"token":false,"name":"Giant Solifuge","scryfallId":"d4bb6038-e2e9-4de2-a94e-0798c80a94c6"},{"index":35856,"token":false,"name":"Serra Aviary","scryfallId":"688a8de2-0167-4b35-a38d-3574034a892c"},{"index":35858,"token":false,"name":"Cosmic Intervention","scryfallId":"933c4a54-5c3a-496b-aa35-edf791155d8d"},{"index":35863,"token":false,"name":"Astral Steel","scryfallId":"64f836d3-52c8-4628-b18a-8c8fb67969c9"},{"index":35864,"token":false,"name":"Board the Weatherlight","scryfallId":"a11d10fa-d42d-4867-9e2f-fc8de582d5e7"},{"index":35866,"token":false,"name":"Forgotten Sentinel","scryfallId":"3bd39a06-c53a-42c2-b2df-028358f03406"},{"index":35873,"token":false,"name":"Curse of Stalked Prey","scryfallId":"11a18883-8990-40a0-bcb2-e01d0e82bfad"},{"index":35876,"token":false,"name":"Capashen Unicorn","scryfallId":"ec3e5741-88d7-4837-9b43-ba8304d9ee74"},{"index":35878,"token":false,"name":"Braidwood Sextant","scryfallId":"16dc7634-8ef5-4a03-8276-7e1dae4244c2"},{"index":35879,"token":false,"name":"Masako the Humorless","scryfallId":"d6b2507f-4035-47d5-8295-0a3773f187fb"},{"index":35880,"token":false,"name":"Crimson Roc","scryfallId":"2e63836c-37af-49c1-84a1-8650ed072805"},{"index":35881,"token":false,"name":"Chilling Shade","scryfallId":"d050c8b9-2b5a-4025-9886-73c418f4e22f"},{"index":35886,"token":false,"name":"Ironscale Hydra","scryfallId":"0215cbbf-7bac-4ff7-bceb-23d728797848"},{"index":35890,"token":false,"name":"Unmarked Grave","scryfallId":"4d05400a-862f-4dcc-8ebc-edb0b5deaadd"},{"index":35892,"token":false,"name":"Roiling Waters","scryfallId":"3d878c10-de5e-4224-98ce-d49902b5ab8b"},{"index":35895,"token":false,"name":"Kels, Fight Fixer","scryfallId":"b70d445b-d3d6-4f7c-b9ea-bed6a26d4a2a"},{"index":35896,"token":false,"name":"Volcanic Torrent","scryfallId":"eb586da6-670d-4c50-9d9b-f320f1c288d7"},{"index":35901,"token":false,"name":"Crystal Golem","scryfallId":"4b1d3280-f3e1-42ea-93e1-dbab7336fb73"},{"index":35916,"token":false,"name":"Dromoka Monument","scryfallId":"d4df975f-b6ef-4e8e-8be8-529c0ffd8a37"},{"index":35918,"token":false,"name":"Deathcurse Ogre","scryfallId":"62bd3c73-fff4-40e8-b9db-80a010a4dd37"},{"index":35923,"token":true,"name":"Wizard Token (U, 2/2)","scryfallId":"7b0b95ce-4821-4955-a27c-93471240f54b"},{"index":35927,"token":false,"name":"The Three Seasons","scryfallId":"48ce03b3-ec7c-46df-b89a-55405f3b5245"},{"index":35930,"token":false,"name":"Maze's End","scryfallId":"401f7042-24fd-42a0-ae7c-e6b7de1aa446"},{"index":35932,"token":false,"name":"Purgatory","scryfallId":"9ed5e58b-46f3-437c-89ac-24235a65bd1f"},{"index":35935,"token":false,"name":"Planar Gate","scryfallId":"c880c236-a9d9-4e0d-bc4b-8910c75639cd"},{"index":35938,"token":false,"name":"Nahiri's Stoneblades","scryfallId":"0a14331e-8da5-4455-ac69-e510684e989c"},{"index":35942,"token":false,"name":"Book of Rass","scryfallId":"5a391ada-e9e3-45db-ae84-17421ac6b44d"},{"index":35945,"token":false,"name":"Umbra Stalker","scryfallId":"1efdd70a-5a84-48a5-82bf-ba29fda097c0"},{"index":35952,"token":false,"name":"Scarwood Bandits","scryfallId":"7ca0e682-22c1-4cd9-9283-fb91ef29a752"},{"index":35956,"token":false,"name":"Blizzard Strix","scryfallId":"217dfa26-d3ad-4fe8-9db4-ddd753a4b679"},{"index":35963,"token":false,"name":"Aven Windreader","scryfallId":"1e017119-4040-4277-849f-3ed961c992c6"},{"index":35969,"token":false,"name":"Boggart Harbinger","scryfallId":"8ea8d2b8-bcac-410d-aa5a-e4a74f7d5315"},{"index":35970,"token":false,"name":"Bastion Protector","scryfallId":"19e09431-0655-404b-a04f-1f4591716f57"},{"index":35975,"token":false,"name":"Footsteps of the Goryo","scryfallId":"ca7bedbe-8b87-402f-9a0c-83e46ae10279"},{"index":35977,"token":false,"name":"Commandeer","scryfallId":"7e6e6204-c622-4efe-ac4f-8195528cec9c"},{"index":35982,"token":false,"name":"Imp's Mischief","scryfallId":"22ec70a6-40b7-41da-a6c0-c140cadf5509"},{"index":35984,"token":false,"name":"Rayami, First of the Fallen","scryfallId":"6997ad62-f34c-4490-aee4-6d5c08e14709"},{"index":35989,"token":false,"name":"Magewright's Stone","scryfallId":"1c5d56f1-6a28-455d-b2b8-c7b99733a088"},{"index":35991,"token":false,"name":"Chainer, Dementia Master","scryfallId":"40342b11-1005-4ccc-bef4-9ea4c640b048"},{"index":35992,"token":false,"name":"Shivan Wumpus","scryfallId":"7958a1e5-b671-4ecb-95de-240ffaf5021e"},{"index":35993,"token":false,"name":"Surgespanner","scryfallId":"1d5b00cb-ebc3-44e8-970d-724150eb7876"},{"index":35994,"token":false,"name":"Iroas's Champion","scryfallId":"c0441583-c9d5-47a1-8754-c9162cec64bc"},{"index":35995,"token":false,"name":"Hold the Gates","scryfallId":"48fd52d0-0e41-48d5-b96f-4c6409788c18"},{"index":35997,"token":false,"name":"Gangrenous Zombies","scryfallId":"5b49b583-ed1b-44ee-8f50-be5ae3527399"},{"index":35999,"token":false,"name":"Primeval Light","scryfallId":"293ce819-c228-4ff1-827c-3d0cbed703ea"},{"index":36005,"token":false,"name":"Demon's Herald","scryfallId":"f5aa309e-5df3-4419-9e9c-3fd928c1e360"},{"index":36006,"token":false,"name":"Charging Monstrosaur","scryfallId":"d5222448-95d1-4b63-ab76-d5060febcf38"},{"index":36008,"token":false,"name":"Quiet Speculation","scryfallId":"3a75b57d-1527-4918-bb56-79e3e546f8be"},{"index":36009,"token":false,"name":"Chandra's Pyreling","scryfallId":"e7744fcf-2336-489d-bc05-f3fce78713a9"},{"index":36013,"token":false,"name":"Sandals of Abdallah","scryfallId":"8f99a520-b8a9-40b0-9854-48aac297c5ee"},{"index":36015,"token":false,"name":"Luminarch Ascension","scryfallId":"df4fa94d-a06c-4583-95d9-ff95a1814f31"},{"index":36016,"token":false,"name":"Auntie's Snitch","scryfallId":"dc5caf12-9358-490b-aafa-fc4d2b8b9b22"},{"index":36019,"token":false,"name":"Festering Evil","scryfallId":"2d688bda-fee2-496d-9793-794c2568b54e"},{"index":36022,"token":false,"name":"Cryptoplasm","scryfallId":"15a31710-c1d6-45e4-9dbe-a75453a74da0"},{"index":36023,"token":false,"name":"Lightning Phoenix","scryfallId":"b52a3f11-6d55-4492-9a2c-c128c09b3d77"},{"index":36027,"token":false,"name":"Amphibious Kavu","scryfallId":"37d94fb2-958c-487e-9f64-52d2771c6ea4"},{"index":36031,"token":false,"name":"Nightsnare","scryfallId":"391a1023-69e7-425c-ac54-987ba366f8f4"},{"index":36032,"token":false,"name":"Bloodshot Trainee","scryfallId":"779a130b-1d23-4a20-9914-dbdc2268ae3b"},{"index":36035,"token":false,"name":"Floral Spuzzem","scryfallId":"d141b9e3-7129-41e5-8b44-d3867e1c7e1d"},{"index":36038,"token":false,"name":"Yargle, Glutton of Urborg","scryfallId":"dc2efd68-98ff-4ddb-8a74-bac0ef5a6561"},{"index":36045,"token":false,"name":"Furnace Celebration","scryfallId":"9d90b132-f668-47e1-b89c-7aa569525117"},{"index":36047,"token":true,"name":"Kor Ally Token (W, 1/1)","scryfallId":"1d582916-8e67-43f8-a116-37d29a8a5149"},{"index":36053,"token":false,"name":"Grenzo's Ruffians","scryfallId":"8b29a4ae-0dcc-4cdd-a5f7-d0f6555c6052"},{"index":36054,"token":false,"name":"Yamabushi's Flame","scryfallId":"1a9bacba-55c4-4b92-bdd9-01b6035ed1b2"},{"index":36070,"token":false,"name":"Demonic Appetite","scryfallId":"ca51786a-d58c-455f-910d-01efa5ef8470"},{"index":36072,"token":false,"name":"Benevolent Unicorn","scryfallId":"2a243bd7-af98-4e44-af6e-3b0b71d4837b"},{"index":36076,"token":false,"name":"Scourgemark","scryfallId":"ed36a150-a686-4fa6-8364-8be262ad7d98"},{"index":36082,"token":false,"name":"Reckless Imp","scryfallId":"74a44e0a-5fff-4fc0-a76d-1b097f1d4d5d"},{"index":36083,"token":false,"name":"Witherbloom Apprentice","scryfallId":"7f80a11b-188b-464c-b00d-c9d1cfb8ddee"},{"index":36085,"token":false,"name":"Serra Sphinx","scryfallId":"4fb01cf8-9bca-4446-9e56-62777c6dfbe8"},{"index":36086,"token":false,"name":"Watchwing Scarecrow","scryfallId":"5c7774fd-3460-46e3-9c9c-7aa70f2ff6d8"},{"index":36088,"token":false,"name":"Latulla's Orders","scryfallId":"a56cd728-5c3c-4fd6-bb01-0bf0875508c7"},{"index":36092,"token":false,"name":"Tooth Collector","scryfallId":"a0f7106b-6550-4b84-82df-98d47b823548"},{"index":36095,"token":false,"name":"Quagmire","scryfallId":"94e2aa9e-af6a-41c6-99a8-ca9335730ddb"},{"index":36098,"token":false,"name":"Rally to Battle","scryfallId":"d0798546-1ef4-485e-b094-cba12a12c67c"},{"index":36102,"token":false,"name":"Keeper of Fables","scryfallId":"6754d6cf-3506-48b5-a0ef-8a90b8dd2701"},{"index":36107,"token":false,"name":"Sonorous Howlbonder","scryfallId":"595f0b25-6e6e-43c4-a4a0-903920067df1"},{"index":36110,"token":false,"name":"Murasa Brute","scryfallId":"efe1c5b2-4356-41ae-ab7e-ad9fc835a911"},{"index":36114,"token":false,"name":"Trenching Steed","scryfallId":"9a359837-2e41-4ddc-9299-89a783d62014"},{"index":36117,"token":false,"name":"Tajuru Stalwart","scryfallId":"f916220b-a942-41af-8949-aa384fa7857d"},{"index":36119,"token":false,"name":"Captive Flame","scryfallId":"147a6ab8-e49c-402c-ae6a-17231054b1fa"},{"index":36121,"token":false,"name":"Balduvian Frostwaker","scryfallId":"18096cdb-0ba9-41e0-b597-c5ed819e7497"},{"index":36126,"token":false,"name":"Glass Asp","scryfallId":"118253e9-f33a-455d-b785-dd9df657e7cf"},{"index":36128,"token":false,"name":"Hagra Constrictor","scryfallId":"f971b71a-af69-43a7-b06c-e80eaaaf4a5f"},{"index":36131,"token":false,"name":"Absolver Thrull","scryfallId":"711979c3-e70b-4973-a4f1-020db534fc73"},{"index":36134,"token":false,"name":"Flayer Drone","scryfallId":"3931db42-3773-4aae-b6eb-2209e7312f8c"},{"index":36135,"token":false,"name":"Carnage Tyrant","scryfallId":"15e1b2a6-a4d1-445d-9c20-26eddff25047"},{"index":36136,"token":false,"name":"Thoughtweft Trio","scryfallId":"9e48d34d-063c-4703-870b-4a22d5774c89"},{"index":36139,"token":false,"name":"Tide of War","scryfallId":"43b5bd60-87ed-41d2-bbcb-bd4a40a772c9"},{"index":36144,"token":true,"name":"Janosch Kühn Bio (2000)","scryfallId":"fe1a99b3-5ff4-48d4-8603-7271f12269f4"},{"index":36161,"token":false,"name":"Lithomancer's Focus","scryfallId":"dd5a1376-88b3-4bdc-9ce9-e90617e6c55e"},{"index":36164,"token":false,"name":"Arbiter of the Ideal","scryfallId":"01f73840-5566-4198-ac60-72bac3c62a7c"},{"index":36168,"token":false,"name":"Ruthless Invasion","scryfallId":"bc2bbff9-af57-4858-9351-d148b8c4bc3a"},{"index":36169,"token":false,"name":"Takeno, Samurai General","scryfallId":"d038df46-4a30-4125-be0e-8781b16b523e"},{"index":36170,"token":false,"name":"Djinn of Infinite Deceits","scryfallId":"55cd81fc-0f2a-4842-801c-22533f30bd8e"},{"index":36172,"token":false,"name":"Ordeal of Thassa","scryfallId":"fa764244-c5d5-4f27-9c56-866566a1404a"},{"index":36175,"token":false,"name":"Boneyard Scourge","scryfallId":"55a3a094-48c5-4da5-8626-e30a0e8d8f3a"},{"index":36176,"token":false,"name":"Zombie Cannibal","scryfallId":"5fe73ea4-caa2-41de-a065-272a4d850362"},{"index":36179,"token":false,"name":"Creative Outburst","scryfallId":"eab58d87-bf01-45dc-8958-e2b3375f914b"},{"index":36181,"token":false,"name":"Fungal Plots","scryfallId":"56419f2a-63cf-4ab7-bad0-b0f773fc0570"},{"index":36190,"token":false,"name":"Oona, Queen of the Fae","scryfallId":"48ab4b6f-480c-40ac-a8cc-335a22b5acb9"},{"index":36193,"token":false,"name":"Strands of Night","scryfallId":"d8f6685d-eb5d-403f-b89a-b8b67900b602"},{"index":36194,"token":false,"name":"Dragon Shadow","scryfallId":"0ec35e03-022b-417c-9987-7379cf3956f9"},{"index":36197,"token":false,"name":"Processor Assault","scryfallId":"5a689975-d27b-4b8f-8d46-6e97c754ae81"},{"index":36204,"token":false,"name":"Inner-Flame Acolyte","scryfallId":"70ec84e5-2a49-4738-9594-f51c76387d33"},{"index":36212,"token":false,"name":"Lurking Crocodile","scryfallId":"4cd7d075-031e-4766-89e9-03a8a7197019"},{"index":36214,"token":false,"name":"Fists of the Demigod","scryfallId":"9b28e501-fbb1-443b-a296-420716e49ab0"},{"index":36219,"token":false,"name":"Assassin's Blade","scryfallId":"b80e8fe0-eccb-4268-a6ce-1365c68e6b13"},{"index":36221,"token":false,"name":"Demon's Grasp","scryfallId":"ff953948-db26-43af-9905-7d387769b4a9"},{"index":36225,"token":false,"name":"Distemper of the Blood","scryfallId":"d0ad2acb-073b-4a98-be8c-2ea39ca85496"},{"index":36227,"token":false,"name":"Efficient Construction","scryfallId":"abfbe1d5-beb7-49b8-a504-f1cc47ee4731"},{"index":36228,"token":false,"name":"Cyclopean Snare","scryfallId":"22ba776a-c959-4d15-aa36-9fba1fcb512d"},{"index":36230,"token":false,"name":"Tazeem Roilmage","scryfallId":"6f222fb7-375d-4ee2-9ff6-bd71f63ab31a"},{"index":36232,"token":false,"name":"Liege of the Pit","scryfallId":"52e7c608-d224-472b-8736-273874211f24"},{"index":36236,"token":false,"name":"Woodcutter's Grit","scryfallId":"cc329134-4b71-4c33-8cfb-c3867a733115"},{"index":36239,"token":false,"name":"Predatory Wurm","scryfallId":"4073cbc6-11de-4d4a-bcd7-792f9b7c5219"},{"index":36240,"token":false,"name":"Waning Wurm","scryfallId":"b20b0048-f93a-4349-b5d1-201ab0a38d1b"},{"index":36242,"token":false,"name":"Leap","scryfallId":"0841423d-7a27-4bc5-9ac2-0ba47648c6f1"},{"index":36245,"token":false,"name":"Ivory Crane Netsuke","scryfallId":"dfd84d1a-1e74-4779-996f-f8518f0b5f8c"},{"index":36246,"token":false,"name":"Thriving Heath","scryfallId":"fe424eb3-7df8-4317-8776-6d960afbb90a"},{"index":36248,"token":false,"name":"Pegasus Refuge","scryfallId":"a2bce334-0ae6-4a7d-85db-99ee205ce546"},{"index":36251,"token":false,"name":"Whispering Madness","scryfallId":"5a62cda0-34b2-42f0-83bd-c08eecf02fa4"},{"index":36253,"token":false,"name":"Trained Pronghorn","scryfallId":"720ec745-226c-4211-974f-e04a4f9e1902"},{"index":36256,"token":false,"name":"Sustenance","scryfallId":"5a61db44-80dc-4058-9c9d-65cd18e63fd4"},{"index":36258,"token":false,"name":"Turn to Slag","scryfallId":"7275ede4-22d6-41db-91e9-3b0295abb8a9"},{"index":36261,"token":false,"name":"Gleam of Authority","scryfallId":"96847438-eb09-4e3f-8ebf-f064b88f70c9"},{"index":36262,"token":false,"name":"Sarcatog","scryfallId":"760a329c-e815-49d3-8df1-d052ce19b0c6"},{"index":36263,"token":false,"name":"Pack Hunt","scryfallId":"1c46caa8-efc0-4b72-b122-61e5d86a5b86"},{"index":36264,"token":false,"name":"Svyelun of Sea and Sky","scryfallId":"c6f9ece1-669a-47c9-96c3-1e1dbf87421c"},{"index":36267,"token":false,"name":"Overabundance","scryfallId":"4183e73d-609a-4292-b173-e39eb51949f3"},{"index":36283,"token":false,"name":"Barbarian Bully","scryfallId":"e38f0f9f-ad7b-48da-89f3-b3e5346a3b71"},{"index":36284,"token":false,"name":"Aurora Eidolon","scryfallId":"51bb3d0b-8630-4373-b863-bc831cf08098"},{"index":36286,"token":false,"name":"Orim's Cure","scryfallId":"754ae359-363b-456a-bbca-52fbfbaa86b8"},{"index":36290,"token":false,"name":"Ravenous Vampire","scryfallId":"5ee67033-7f0f-49b4-8472-3bc4fbb8ffe1"},{"index":36294,"token":false,"name":"Hisoka's Defiance","scryfallId":"09fd4d01-1204-46a3-b237-45c37985acac"},{"index":36295,"token":false,"name":"Equipoise","scryfallId":"53783312-3551-4361-ab02-c9651ce2a926"},{"index":36298,"token":false,"name":"Saprazzan Skerry","scryfallId":"6f21feef-341c-4e1d-89c0-c3282a98bd31"},{"index":36299,"token":false,"name":"Deeptread Merrow","scryfallId":"42ebd6ff-2b1c-4e93-81cc-81998459c5c7"},{"index":36300,"token":false,"name":"Wipe Clean","scryfallId":"cf7c14c9-cb5a-49f0-be2c-eb3166f02510"},{"index":36301,"token":false,"name":"Arc Runner","scryfallId":"32014715-7faa-412a-b8b4-751102e6b8a3"},{"index":36304,"token":false,"name":"Mire Shade","scryfallId":"120822b8-02ae-411f-bda5-a774c21db66c"},{"index":36311,"token":false,"name":"Rush of Ice","scryfallId":"f9ae6f63-d1b2-4bf9-a423-ed6fbb540d4b"},{"index":36312,"token":false,"name":"Timbermare","scryfallId":"2d604bac-58b7-4479-8ab8-2e0680746e0e"},{"index":36314,"token":false,"name":"Cylian Elf","scryfallId":"b3afaab6-4768-4852-a0b6-4e6a0295bde7"},{"index":36319,"token":false,"name":"Acceptable Losses","scryfallId":"9082bfb8-0ab0-4378-976d-a2c9d3c35a5e"},{"index":36325,"token":false,"name":"Blessed Reincarnation","scryfallId":"6f17070a-9102-4bfd-86d1-78dff65f6ba2"},{"index":36326,"token":false,"name":"Vulshok Heartstoker","scryfallId":"9d3152bc-5c59-4e98-95de-a51de05a3c98"},{"index":36329,"token":false,"name":"Mantle of Tides","scryfallId":"c058d01e-f705-4407-bd9e-a2d127afdf04"},{"index":36334,"token":false,"name":"Port Razer","scryfallId":"e0d0527b-bb28-4986-9843-040d06bd9def"},{"index":36337,"token":false,"name":"Recalibrate","scryfallId":"b95cc841-4e4f-4896-a073-f2e246ca62e4"},{"index":36338,"token":false,"name":"Prismatic Circle","scryfallId":"8d4e3de4-f173-4bcc-a5fb-089eee7108d3"},{"index":36340,"token":false,"name":"Elemental Mastery","scryfallId":"91705d63-8aae-47c2-a880-1b07c6d33bde"},{"index":36347,"token":false,"name":"Thalia's Lieutenant","scryfallId":"4be51f41-7ce1-4bc9-8659-306493c23bb5"},{"index":36348,"token":false,"name":"Necromancer's Stockpile","scryfallId":"2ba07e86-fdef-4f51-808e-7780883eefe3"},{"index":36352,"token":false,"name":"Spirit of the Night","scryfallId":"f8d4c95e-7d18-4bb5-b373-e964a21e144b"},{"index":36356,"token":false,"name":"Lumberknot","scryfallId":"d011276d-4084-4102-9437-88f488b71ace"},{"index":36363,"token":false,"name":"Yidris, Maelstrom Wielder","scryfallId":"9d64a386-d426-4897-b14c-cd0706edd2a4"},{"index":36364,"token":false,"name":"Sword of the Chosen","scryfallId":"401678d7-11dc-47ec-be28-4facdd949bc1"},{"index":36369,"token":false,"name":"Joint Assault","scryfallId":"6516c7c6-d49b-49c5-8968-563622c2c8c1"},{"index":36371,"token":true,"name":"Eldrazi Token (Colorless, 7/7)","scryfallId":"f9a7ed9a-25e4-41ad-a53e-d589e923af2c"},{"index":36375,"token":false,"name":"Woeleecher","scryfallId":"d05c7868-e589-478e-af0c-512d0fe4f253"},{"index":36388,"token":false,"name":"Crazed Skirge","scryfallId":"816272de-f134-45fa-ac1f-70d35d30c7e1"},{"index":36393,"token":false,"name":"Diseased Vermin","scryfallId":"39703080-524d-4aa1-8c58-d512c41ae5d4"},{"index":36395,"token":false,"name":"Spearbreaker Behemoth","scryfallId":"132367ee-22e9-48e2-82e0-62ad9aaa62f3"},{"index":36404,"token":false,"name":"Vivisection","scryfallId":"684a3631-f2d6-4a64-a04a-893f452e3a60"},{"index":36405,"token":false,"name":"Sigil of Valor","scryfallId":"a9f43c75-e744-48a1-88f7-b54eab961177"},{"index":36409,"token":false,"name":"Golgari Decoy","scryfallId":"511a42a8-71ce-476f-98fa-fc0dc822edcf"},{"index":36411,"token":false,"name":"Gravelgill Axeshark","scryfallId":"5efc174a-f710-4602-aace-c2165473f6c2"},{"index":36413,"token":false,"name":"Helvault","scryfallId":"16d2448c-1b2e-466a-a0ab-e20ba1de6bc9"},{"index":36416,"token":false,"name":"Ayesha Tanaka","scryfallId":"03bd3d4b-d01a-475d-bf3b-cf96f43bc9ef"},{"index":36417,"token":false,"name":"Mace of the Valiant","scryfallId":"6c141ed6-02ee-49c4-98af-938ebcefb2f5"},{"index":36420,"token":false,"name":"Dukhara Scavenger","scryfallId":"c55bf227-4f9f-4bff-ae82-1d8a2a36ccb4"},{"index":36421,"token":false,"name":"Crypsis","scryfallId":"bd445b01-34af-4132-a9fe-a03858624492"},{"index":36423,"token":false,"name":"Agent of Shauku","scryfallId":"d8316804-6f8b-423e-a2c3-fa476c095544"},{"index":36432,"token":false,"name":"Drill Bit","scryfallId":"73f8710c-9c5e-4d11-b45f-0728c54bd631"},{"index":36433,"token":false,"name":"Mindswipe","scryfallId":"557e8303-a021-4257-b41a-7d25f04618c8"},{"index":36434,"token":false,"name":"Balduvian Dead","scryfallId":"c9aee135-65f6-4abb-b0ca-ee5ceb958a24"},{"index":36436,"token":false,"name":"Rally the Righteous","scryfallId":"9da51b6c-2e27-4b41-8fb0-bd9f6ad47b19"},{"index":36439,"token":false,"name":"Trespassing Souleater","scryfallId":"b5263269-9f64-43de-9e82-408644dbc628"},{"index":36443,"token":false,"name":"Viridian Zealot","scryfallId":"4c2052ce-0c60-4baa-8bac-4a479a7368e2"},{"index":36444,"token":false,"name":"Rashka the Slayer","scryfallId":"ddf30363-9db2-44c5-8c13-dbf1aaa8c86b"},{"index":36445,"token":false,"name":"Souls of the Faultless","scryfallId":"24f02a09-e959-438c-ab48-abd34b10d07c"},{"index":36449,"token":false,"name":"Molten-Tail Masticore","scryfallId":"48311a45-c0e1-4170-8dab-2b3495096c48"},{"index":36453,"token":false,"name":"Slumbering Tora","scryfallId":"e32ac983-a909-4342-882e-f3b7e2e064d8"},{"index":36463,"token":false,"name":"Centaur's Herald","scryfallId":"08598b2b-6fd2-4a1d-8d74-7ca6d93ad382"},{"index":36464,"token":false,"name":"Mythos of Snapdax","scryfallId":"0a12b361-ed36-4a89-a973-1e4c7fb56fa9"},{"index":36471,"token":false,"name":"Restoration Specialist","scryfallId":"63682db3-1a56-4d8e-a9b7-04465a577518"},{"index":36472,"token":false,"name":"Lochmere Serpent","scryfallId":"7e2f8d03-67a3-4dea-90ad-a39851821722"},{"index":36481,"token":false,"name":"Steppe Lynx","scryfallId":"b0aaec1c-8084-4468-82e7-2e4cc5ebe244"},{"index":36483,"token":false,"name":"Stromkirk Captain","scryfallId":"5bfcca87-04f8-480a-bae6-ae87f7afb7e1"},{"index":36484,"token":false,"name":"Nightmare Lash","scryfallId":"7f8e3fa6-494c-412f-90cc-36d45cd2b175"},{"index":36491,"token":false,"name":"Tangleclaw Werewolf // Fibrous Entangler","scryfallId":"ee648500-a213-4aa4-a97c-b7223c11bebd"},{"index":36492,"token":false,"name":"Kuldotha Ringleader","scryfallId":"3cda5434-c0a5-4551-8e30-b1923f0001b8"},{"index":36496,"token":false,"name":"Archwing Dragon","scryfallId":"6c6f1a8b-329e-4094-8141-6bc88311a08c"},{"index":36498,"token":false,"name":"Prime Speaker Vannifar","scryfallId":"84abfc59-10a7-4cb5-9cdd-81797116c810"},{"index":36499,"token":false,"name":"Black Oak of Odunos","scryfallId":"5f1e9195-a711-4f4d-9d53-d5d230c092ef"},{"index":36500,"token":false,"name":"Syndicate Messenger","scryfallId":"10273046-4c74-42d8-afaa-6cfbe0bd4e8f"},{"index":36501,"token":false,"name":"Night Revelers","scryfallId":"e3f82c5c-77fa-45f3-a91e-4c2489444855"},{"index":36503,"token":false,"name":"Piracy","scryfallId":"daeab88f-2bfc-4f40-8eed-ee44a9e90bd7"},{"index":36505,"token":false,"name":"Dreadwurm","scryfallId":"339736a8-a00f-4e21-8d92-38486f73dba9"},{"index":36510,"token":false,"name":"Monastery Flock","scryfallId":"e53c0e50-4b0b-43d8-80c0-2c216722c87a"},{"index":36512,"token":false,"name":"Ulvenwald Captive // Ulvenwald Abomination","scryfallId":"0dbaef61-fa39-4ea7-bc21-445401c373e7"},{"index":36515,"token":false,"name":"Borrowed Grace","scryfallId":"2b33bcf6-2acf-476f-a49b-48bdb2f5786e"},{"index":36521,"token":false,"name":"Warped Landscape","scryfallId":"16793435-8eb3-4d57-8683-de1120eb46b6"},{"index":36526,"token":false,"name":"Wingspan Mentor","scryfallId":"89348a02-29f6-40b9-b39f-cb5f8c230a02"},{"index":36527,"token":false,"name":"Oracle of Dust","scryfallId":"2c121d73-0c87-4a3f-b013-4f9314e22606"},{"index":36529,"token":false,"name":"Elemental Masterpiece","scryfallId":"4331a7a6-e98e-4517-b0f9-ace379426a94"},{"index":36530,"token":false,"name":"Seize the Day","scryfallId":"0ee67808-abe3-4755-83a0-03681ad5f82f"},{"index":36538,"token":false,"name":"Timely Ward","scryfallId":"5de08a92-9b60-4672-9f3b-3ceb53ca82ca"},{"index":36540,"token":false,"name":"Ornate Kanzashi","scryfallId":"baeb4c10-59cb-4bc1-b824-6ec8edd6f45e"},{"index":36545,"token":false,"name":"Wall of Shields","scryfallId":"6376c7c4-aaca-4625-83d4-a49f01aec535"},{"index":36553,"token":false,"name":"Downhill Charge","scryfallId":"2ebfc91c-d764-4e63-a428-82704f8bf1fd"},{"index":36556,"token":false,"name":"Unwind","scryfallId":"97da6607-9131-4f8b-8af3-63439a59b78b"},{"index":36559,"token":false,"name":"Errant Doomsayers","scryfallId":"0eb5c6e6-7251-4b80-9561-742442d8a497"},{"index":36563,"token":false,"name":"Wings of the Guard","scryfallId":"4084a009-f366-416b-b82d-a762189abf43"},{"index":36564,"token":false,"name":"Memorial to Glory","scryfallId":"564d6ff1-2be1-42f1-a919-fe8c2e148c3f"},{"index":36575,"token":false,"name":"Tarox Bladewing","scryfallId":"0b06bd73-c45a-4560-bd8d-413608c5f89e"},{"index":36576,"token":false,"name":"Pili-Pala","scryfallId":"bbd4f8bd-a4f3-45e6-8ea7-a5cd4c142871"},{"index":36583,"token":false,"name":"Nameless One","scryfallId":"79cf3535-3f80-4b76-aad3-dd851e6885a6"},{"index":36590,"token":false,"name":"Sangrite Backlash","scryfallId":"fa56b15e-d02d-4306-82a6-ced778fee90f"},{"index":36591,"token":false,"name":"Crypt Ripper","scryfallId":"9920e91d-58c1-4c1a-a177-43423db96842"},{"index":36601,"token":false,"name":"Demon Bolt","scryfallId":"5f856b0e-b413-49b0-9aa7-d935ad40ae53"},{"index":36603,"token":false,"name":"Infuse","scryfallId":"74f0acc2-de90-4299-ab89-5dd1717a98ce"},{"index":36606,"token":false,"name":"Favor of the Mighty","scryfallId":"20d858be-4c03-4819-94e9-ca4ca3de9032"},{"index":36611,"token":false,"name":"Boiling Earth","scryfallId":"cdaab44c-4ce1-43fb-915c-c687fe8559ce"},{"index":36613,"token":false,"name":"Goblin Cratermaker","scryfallId":"86ecaedc-08f1-4de7-aae8-056df57940e0"},{"index":36622,"token":false,"name":"Lore Drakkis","scryfallId":"83e035ca-eccd-4b63-817c-f2c676b9c98d"},{"index":36623,"token":false,"name":"Ferrovore","scryfallId":"8dcc7170-38d9-4b9e-a5f9-73ac1208c439"},{"index":36636,"token":false,"name":"Will-Forged Golem","scryfallId":"0175bafa-dc9f-464c-8f9e-dd4131732652"},{"index":36637,"token":false,"name":"Flamespeaker's Will","scryfallId":"32b5e3bb-f9e8-4a74-9798-41d8f8515e12"},{"index":36641,"token":false,"name":"Aurora Griffin","scryfallId":"bfd6c695-1944-4bb0-a701-0daf47cdbcb4"},{"index":36642,"token":false,"name":"Desiccated Naga","scryfallId":"21f31e96-bb66-4b28-b14a-426d1d5839a6"},{"index":36646,"token":false,"name":"Mine Bearer","scryfallId":"a8151510-2445-4244-b851-ab332b908170"},{"index":36655,"token":false,"name":"Foul Watcher","scryfallId":"71d00175-5e5e-40dd-a71b-5ba56d763134"},{"index":36656,"token":false,"name":"Glimpse the Cosmos","scryfallId":"dc96ebe8-f4b3-4788-a6f5-2a50b6c0d935"},{"index":36661,"token":false,"name":"Night Market Aeronaut","scryfallId":"2637f860-01dd-4559-97b3-71c2e7cdbca4"},{"index":36663,"token":false,"name":"Smoldering Butcher","scryfallId":"7f764936-fceb-4a3d-ac32-15397d7ce664"},{"index":36665,"token":false,"name":"Ezuri's Brigade","scryfallId":"079a6b44-3492-4484-aed1-5cd2449e702d"},{"index":36667,"token":false,"name":"Kor Entanglers","scryfallId":"0039ead5-2afa-49d6-ae4a-45ae2118188a"},{"index":36668,"token":false,"name":"Nature's Blessing","scryfallId":"5ba0e677-361d-4e03-9c2c-018d1c383456"},{"index":36671,"token":false,"name":"Gilded Drake","scryfallId":"8de3fdae-cc2c-4a14-b15b-4fe1a983dfbf"},{"index":36675,"token":false,"name":"Bond of Flourishing","scryfallId":"df901fdc-8672-44f5-ade5-7c4e0b5c5d81"},{"index":36680,"token":false,"name":"Benalish Honor Guard","scryfallId":"73a5ecf1-2063-4cb3-a4ab-a0601b28256a"},{"index":36681,"token":false,"name":"Hungry Lynx","scryfallId":"22e3d351-62b3-4c89-bbcf-b50684d977a4"},{"index":36682,"token":false,"name":"Erdwal Illuminator","scryfallId":"63df99f9-4f85-4c76-8d76-9075c9ef2b86"},{"index":36684,"token":false,"name":"Darklit Gargoyle","scryfallId":"1e7162e5-8c56-457e-91eb-b8ae4d1b6adb"},{"index":36685,"token":false,"name":"Mistform Seaswift","scryfallId":"b2f6c73c-8162-499f-8d16-92f17c0c2bee"},{"index":36686,"token":false,"name":"Alliance of Arms","scryfallId":"eeb1f8ff-c32f-4d75-8c04-f97d05ba47d6"},{"index":36689,"token":false,"name":"Delif's Cube","scryfallId":"14749600-9eca-4122-b04f-30ddda091b74"},{"index":36692,"token":false,"name":"Vitalizing Wind","scryfallId":"0fbd7c20-d527-4d97-9630-896d5e7bf1de"},{"index":36693,"token":false,"name":"Ormos, Archive Keeper","scryfallId":"711412f1-9ab3-48b6-91a4-77232b416a32"},{"index":36699,"token":false,"name":"Nature's Wrath","scryfallId":"91a05306-f3f7-436d-8d8c-58217f04610b"},{"index":36702,"token":false,"name":"Scalding Tongs","scryfallId":"34136f2c-3edd-4ca3-b1ef-1fdcaa4518a0"},{"index":36707,"token":false,"name":"Lifeline","scryfallId":"40cee82f-36b2-48a9-930a-8e23cb2742fc"},{"index":36708,"token":false,"name":"Sun Ce, Young Conquerer","scryfallId":"6f5f375f-38b0-413e-8099-64044cad98a3"},{"index":36714,"token":false,"name":"Glissa's Courier","scryfallId":"45da44df-a83a-4974-bc22-5243dcda7cbd"},{"index":36716,"token":false,"name":"Channel Harm","scryfallId":"8801465e-295f-4b6b-a321-120f1b1edd0b"},{"index":36718,"token":false,"name":"Latulla, Keldon Overseer","scryfallId":"fd3c7b0c-98bd-4c63-bbb0-80484a5ab26f"},{"index":36729,"token":false,"name":"Builder's Bane","scryfallId":"fb398027-5a29-4c81-aab5-b1a2b82fd655"},{"index":36732,"token":false,"name":"Dinosaur Hunter","scryfallId":"93ff5a4e-9ec5-4b52-90f5-b8b6753c958d"},{"index":36734,"token":false,"name":"Poisonbelly Ogre","scryfallId":"a168b953-eac4-472e-ac74-598febb05f83"},{"index":36738,"token":false,"name":"Nulltread Gargantuan","scryfallId":"a263f594-621e-46af-8561-f7eee565a19a"},{"index":36740,"token":false,"name":"Alchemist's Gift","scryfallId":"6e4c9574-1ee3-461e-848f-8f02c6a8b7ee"},{"index":36741,"token":false,"name":"Pestilence Rats","scryfallId":"bff7f6a6-0e90-4eb4-b76e-d98454975fb6"},{"index":36745,"token":false,"name":"Kuro, Pitlord","scryfallId":"e1f9531a-7201-4dfc-beb1-4128ec41728c"},{"index":36746,"token":false,"name":"Hushwing Gryff","scryfallId":"7b44eb0d-5a3a-4624-aee4-11d6978fb4b0"},{"index":36754,"token":false,"name":"Cunning Lethemancer","scryfallId":"972891e6-6a23-40df-af22-adf8cd7ea582"},{"index":36761,"token":true,"name":"Reflection Token (U, 3/2)","scryfallId":"ab1c23b2-ac39-46b1-aa2b-7d6cbedba767"},{"index":36766,"token":false,"name":"Signal Pest","scryfallId":"d0f0bf8e-60ae-4f69-b599-f2982c0bb49d"},{"index":36772,"token":false,"name":"Impromptu Raid","scryfallId":"f2171e1c-fd36-43a6-ade3-c3aba8915139"},{"index":36773,"token":false,"name":"Sorcerer's Strongbox","scryfallId":"09379286-54c1-432a-bb3f-00ad56273977"},{"index":36774,"token":false,"name":"Avacyn, Guardian Angel","scryfallId":"a79662d5-3b6f-4c5a-8540-63c201027b66"},{"index":36776,"token":false,"name":"Kobold Taskmaster","scryfallId":"ef0a0cce-0f9f-4d47-9fc4-8c6a64f83404"},{"index":36777,"token":false,"name":"Earthcraft","scryfallId":"9dda7531-82a1-4f49-8858-601ddbc6e2bc"},{"index":36780,"token":false,"name":"Sibsig Muckdraggers","scryfallId":"f88297c1-c612-47bf-80b7-374099b00e07"},{"index":36781,"token":false,"name":"Dictate of Erebos","scryfallId":"9f06db70-95f9-41eb-8e5f-8bc56fd34c09"},{"index":36786,"token":false,"name":"Remembrance","scryfallId":"556d334e-3ac9-45b0-98d2-aff49ada0f75"},{"index":36789,"token":false,"name":"Vanguard's Shield","scryfallId":"ce8d9db6-5737-4a1f-ae4e-75821a602784"},{"index":36798,"token":false,"name":"Medomai the Ageless","scryfallId":"b5f4b3cf-2c78-42c9-9873-3758c7f7bb7d"},{"index":36799,"token":false,"name":"Pia's Revolution","scryfallId":"d67ba34d-58cc-4392-81ba-d21576fae1de"},{"index":36800,"token":false,"name":"Helix Pinnacle","scryfallId":"33a3745a-b4f4-4767-8e92-0a400e6199a6"},{"index":36805,"token":false,"name":"Laboratory Brute","scryfallId":"efb142ff-634c-4425-99fc-f9426692f5eb"},{"index":36808,"token":false,"name":"Celestial Messenger","scryfallId":"89e92e98-202f-4790-8411-17aebffe19fe"},{"index":36812,"token":false,"name":"Sacellum Godspeaker","scryfallId":"cad80819-22d4-43a8-97b2-7cf20f61bca5"},{"index":36813,"token":false,"name":"Suffer the Past","scryfallId":"40696611-b5eb-4d69-9614-c694f3422523"},{"index":36815,"token":false,"name":"Opaline Sliver","scryfallId":"75af1cc6-cb40-48c8-818b-91e64bdbe691"},{"index":36819,"token":true,"name":"Saproling // Elf Knight Token (G, 1/1)","scryfallId":"cc77373d-34d1-475b-ade9-f49bb64bff9c"},{"index":36823,"token":false,"name":"Petalmane Baku","scryfallId":"7c7ba032-66d6-41bd-af4f-9853b031a474"},{"index":36824,"token":false,"name":"Hero of Oxid Ridge","scryfallId":"1a516bce-3d2d-4e0f-afc7-27be3d88848c"},{"index":36831,"token":true,"name":"Daniel Zink Decklist","scryfallId":"93380a7d-8df1-4cce-bf88-67e3b73eb70c"},{"index":36833,"token":false,"name":"Devouring Tendrils","scryfallId":"f7444555-da19-4d2d-ad81-233c54fbb78e"},{"index":36834,"token":false,"name":"Cosmotronic Wave","scryfallId":"69c5bafa-8cd8-4158-98e0-46dc74c027c0"},{"index":36838,"token":false,"name":"Predator's Gambit","scryfallId":"88810a96-d5f8-4030-93f1-e2ad0d480317"},{"index":36849,"token":false,"name":"Shivan Phoenix","scryfallId":"112aa0e2-7e4a-4ae8-bedb-d84b4116df5e"},{"index":36875,"token":false,"name":"Quicksilver Behemoth","scryfallId":"645bfe2d-845b-4cf3-88b6-b2b62b8531e4"},{"index":36876,"token":false,"name":"Tenth District Legionnaire","scryfallId":"44f3090b-917b-4122-b522-27c30dca8e69"},{"index":36878,"token":false,"name":"Despoil","scryfallId":"06bb6ff7-2cd6-430e-a618-0b83d9c1d044"},{"index":36890,"token":false,"name":"Zur's Weirding","scryfallId":"741612e3-fe3a-4099-9d2b-4a654c4ce949"},{"index":36891,"token":false,"name":"Tolarian Emissary","scryfallId":"1cbc55e5-b84c-4449-a288-ec26cdd3997c"},{"index":36892,"token":false,"name":"Healing Grace","scryfallId":"db244a1f-867e-47b2-a20b-3b5d1b116c16"},{"index":36895,"token":false,"name":"Bojuka Brigand","scryfallId":"33e0aa67-0ea9-4c50-8297-369ab486fd0f"},{"index":36897,"token":false,"name":"False Cure","scryfallId":"ef397db1-2d99-4cb0-a6e9-6f72d615ebad"},{"index":36898,"token":false,"name":"Merrow Harbinger","scryfallId":"b47af11c-1090-4f0a-8eea-64a3b639e535"},{"index":36901,"token":false,"name":"Corrupted Roots","scryfallId":"c8a7fe66-db40-4eca-8953-0eb2cf98e4e8"},{"index":36903,"token":false,"name":"Harsh Scrutiny","scryfallId":"fe68b484-cc8d-4a0b-94c2-1fec9090dfcd"},{"index":36906,"token":false,"name":"Vedalken Blademaster","scryfallId":"572c15ab-2229-4536-b586-638ec77d9cb7"},{"index":36913,"token":false,"name":"Cyclical Evolution","scryfallId":"f2b2fa14-b08b-4cb9-bd77-c9da1dfa91d4"},{"index":36917,"token":false,"name":"Thundermaw Hellkite","scryfallId":"a75f6bb4-ab06-42ca-a0df-326d9a098a26"},{"index":36919,"token":false,"name":"Imperial Outrider","scryfallId":"0dd3aca5-516f-4500-9d7f-95630401d3ae"},{"index":36922,"token":false,"name":"Pendelhaven Elder","scryfallId":"63d759b5-1739-414e-9616-723625883ebf"},{"index":36923,"token":false,"name":"Dusk Feaster","scryfallId":"d34a6fdc-5be9-4cb4-97cc-de63e8a0dde1"},{"index":36925,"token":false,"name":"Skittering Heartstopper","scryfallId":"0722fbdf-c092-4e80-913f-29390177cdcb"},{"index":36928,"token":false,"name":"Selfless Squire","scryfallId":"0d7bc9a0-bbc9-406d-83c1-ad7c06891463"},{"index":36929,"token":false,"name":"Bane Alley Blackguard","scryfallId":"15fcad03-4567-4f96-976e-01a07d8ab050"},{"index":36931,"token":false,"name":"Natural Reclamation","scryfallId":"3e98fb7c-6962-4b57-b7b7-c71899564002"},{"index":36934,"token":false,"name":"Rune of Might","scryfallId":"5c0d507b-fc08-46cb-b092-484fa4adeef6"},{"index":36936,"token":false,"name":"Sosuke's Summons","scryfallId":"42359e94-9f57-45ae-ae39-d4b939813015"},{"index":36951,"token":false,"name":"Gutless Ghoul","scryfallId":"b8bb97ce-d9cf-47db-93cb-02745ebeb05e"},{"index":36954,"token":false,"name":"Weaponcraft Enthusiast","scryfallId":"fe99535a-cc81-4e79-9d30-d514c86b849c"},{"index":36955,"token":false,"name":"Stomp and Howl","scryfallId":"be523140-7c68-4231-a692-7b3af417d858"},{"index":36967,"token":false,"name":"Kemba's Legion","scryfallId":"30731756-81a8-480b-938f-48c1d0cb95d7"},{"index":36969,"token":false,"name":"Conjurer's Ban","scryfallId":"39849576-b58f-45f0-ad33-a9bf2135d9b7"},{"index":36981,"token":false,"name":"Flatten","scryfallId":"a2acae67-5238-40bb-a173-6fc858264a6c"},{"index":36986,"token":false,"name":"Wistful Thinking","scryfallId":"d5031831-49ee-4c54-9200-448b8953f915"},{"index":36988,"token":false,"name":"Evangelize","scryfallId":"0f58e1aa-587c-4f89-9552-1128c8c2da1a"},{"index":36989,"token":false,"name":"Spit Flame","scryfallId":"c7ddf468-a9c7-4143-9028-1aef8a25d4ea"},{"index":36991,"token":false,"name":"Orochi Eggwatcher // Shidako, Broodmistress","scryfallId":"a4f4aa3b-c64a-4430-b1a2-a7fca87d0a22"},{"index":36995,"token":false,"name":"Fog of Gnats","scryfallId":"3f1e9c54-134b-41da-8c3d-ec699d96778a"},{"index":36996,"token":false,"name":"Essence Infusion","scryfallId":"71a48d0c-1e5b-43f2-8974-e2e5bb06310d"},{"index":37001,"token":false,"name":"Ignoble Hierarch","scryfallId":"aba51852-af8f-49d8-8fb6-22d52a1742b8"},{"index":37004,"token":false,"name":"Suture Priest","scryfallId":"31432e98-86cd-42ea-ad37-eb4383dc6a81"},{"index":37005,"token":false,"name":"Fistful of Force","scryfallId":"f7f77c7e-d35f-477e-acc4-a393044319ea"},{"index":37007,"token":false,"name":"Tenured Inkcaster","scryfallId":"92eba33e-efea-4e58-a832-1c6049fb211f"},{"index":37008,"token":false,"name":"Pain's Reward","scryfallId":"6d16da68-85f6-4d54-9751-9cf046f5e99a"},{"index":37010,"token":false,"name":"Open the Omenpaths","scryfallId":"4e4023c8-8e7f-42b9-99e5-87e80fc3d6c8"},{"index":37011,"token":false,"name":"Enslaved Scout","scryfallId":"ea21414e-65f7-4d65-b0dc-7fec7b9b416d"},{"index":37012,"token":false,"name":"Garruk's Gorehorn","scryfallId":"dd5c6492-4934-4d61-85ef-3dd64677dee3"},{"index":37013,"token":false,"name":"Triumph of Cruelty","scryfallId":"906618e2-2638-4017-9d6e-e6f282967a81"},{"index":37015,"token":false,"name":"Kithkin Armor","scryfallId":"395e7882-0429-46aa-8e38-be707067c588"},{"index":37017,"token":false,"name":"Western Paladin","scryfallId":"aa4d19d4-a29b-4b1f-b29b-adcad557c3c7"},{"index":37025,"token":false,"name":"Sigrid, God-Favored","scryfallId":"105e4824-306a-46d2-a1f4-d19a4302cc58"},{"index":37027,"token":false,"name":"Cinder Shade","scryfallId":"b8dd933a-19ed-4d30-a94a-bfb2f66f8f13"},{"index":37036,"token":false,"name":"Raka Sanctuary","scryfallId":"62cab0be-589c-42a0-a297-1faaec46c73f"},{"index":37037,"token":false,"name":"Thelon's Curse","scryfallId":"9b868846-cc3c-4756-a5dd-2335bb380567"},{"index":37038,"token":false,"name":"Aggressive Mining","scryfallId":"e15a3f1a-83af-4541-8d1c-bf7844f969c9"},{"index":37039,"token":false,"name":"Insolence","scryfallId":"d8009a37-f966-4a71-9a2a-469127758dc6"},{"index":37047,"token":false,"name":"Blackmail","scryfallId":"053e7c76-16b7-44eb-9612-a6800ffb35f8"},{"index":37051,"token":false,"name":"Liliana's Indignation","scryfallId":"3817ea1a-b3d8-46f1-ac6c-69caf2466bab"},{"index":37054,"token":false,"name":"Vivien's Jaguar","scryfallId":"d4b406cf-738b-4e65-ac00-b1c36ded5f96"},{"index":37056,"token":true,"name":"Snake Token (G, 5/4)","scryfallId":"57708b3d-ddfb-4924-b5c9-123aa9e967ad"},{"index":37057,"token":false,"name":"Wingfold Pteron","scryfallId":"11e21a5f-fae7-4488-9463-f0af6e4c5233"},{"index":37061,"token":false,"name":"Crypt Ghast","scryfallId":"3795a4e7-646f-4bb7-b154-2610eb740e8d"},{"index":37063,"token":false,"name":"Clockwork Swarm","scryfallId":"dfd89e5c-79dc-4a57-b5ea-16491443fea1"},{"index":37064,"token":false,"name":"Manic Vandal","scryfallId":"985a5866-8c62-46af-a0c0-e69d01d87f4f"},{"index":37072,"token":false,"name":"Lightning Runner","scryfallId":"0b0eeac3-27f9-4576-a8cc-c4e8738bc9d7"},{"index":37078,"token":false,"name":"Fathom Fleet Firebrand","scryfallId":"52280963-ba5b-4735-b5cb-67866f8624c9"},{"index":37079,"token":false,"name":"Izzet Staticaster","scryfallId":"190ac2fe-532d-4d7e-9d74-07ae6850aac8"},{"index":37082,"token":false,"name":"Viashino Shanktail","scryfallId":"f5dd72d5-548a-4b0e-95bb-e6b8d2de0fbe"},{"index":37087,"token":false,"name":"Jace, Cunning Castaway","scryfallId":"b75f56f2-88fd-44ba-ad02-56ea3391f173"},{"index":37096,"token":false,"name":"Water Servant","scryfallId":"0ba4e555-7528-46fd-9cf8-aa1a70e2cc6a"},{"index":37097,"token":false,"name":"Loam Dryad","scryfallId":"61c9441d-18d9-4ec6-859e-e9a7893b54e3"},{"index":37100,"token":false,"name":"Beasts of Bogardan","scryfallId":"cec0fe2c-e7e6-42d1-8128-58d70a7f1177"},{"index":37115,"token":false,"name":"Miracle Worker","scryfallId":"35d29bda-096c-44d4-b45e-c2c507f8efbe"},{"index":37116,"token":false,"name":"Fetid Horror","scryfallId":"4be39d50-1e36-4dac-a923-81fc9f229b8d"},{"index":37122,"token":false,"name":"Ghired, Conclave Exile","scryfallId":"90fffd2b-257d-4e64-9fc7-02d68c75ddf5"},{"index":37125,"token":false,"name":"Plow Through Reito","scryfallId":"11e78f75-bf58-4c61-9654-c5d355b5e526"},{"index":37126,"token":false,"name":"Bloodsoaked Altar","scryfallId":"b9169431-a5b1-42ea-bcf4-6c750d2a2dbb"},{"index":37129,"token":false,"name":"Goblin Machinist","scryfallId":"5874e312-1010-43f2-b330-82bc9fcc9f53"},{"index":37131,"token":false,"name":"Weakstone","scryfallId":"46adf48f-99d2-440e-9129-794584c1ea21"},{"index":37134,"token":false,"name":"Voices from the Void","scryfallId":"faf285d7-c414-48ab-ad1f-1f49e586c278"},{"index":37135,"token":false,"name":"Opal Gargoyle","scryfallId":"a8a67943-8f07-445b-a84c-893879dae7ca"},{"index":37136,"token":false,"name":"Ghost Hounds","scryfallId":"d1298b43-0b10-4b7c-9d33-786d4d7bd80e"},{"index":37137,"token":false,"name":"Benefaction of Rhonas","scryfallId":"dc98fcdd-8482-4462-ab71-935cea48e409"},{"index":37138,"token":false,"name":"Cogwork Archivist","scryfallId":"8c024a2d-20fb-478b-a62e-e3590a1e3ac1"},{"index":37140,"token":false,"name":"Helm of the Gods","scryfallId":"1ba006c8-0ffc-4e68-9a55-c7b842d3add9"},{"index":37146,"token":false,"name":"Jhessian Lookout","scryfallId":"f55b1b92-575e-4b6f-9179-21d0bc1acd11"},{"index":37151,"token":false,"name":"Dramatic Reversal","scryfallId":"30de9083-8702-471c-92e7-5cf89936a208"},{"index":37152,"token":false,"name":"Corrosion","scryfallId":"176122b2-f60f-4150-8c0c-757c8f8914d2"},{"index":37154,"token":false,"name":"Sturmgeist","scryfallId":"c409d1d0-fc45-40bf-adac-83b680209a38"},{"index":37165,"token":false,"name":"Blanket of Night","scryfallId":"fe012fd0-9ff0-4436-a890-3ab436e42201"},{"index":37167,"token":false,"name":"Paladin of Atonement","scryfallId":"402711d6-2010-4015-8f06-e1aad02ed556"},{"index":37169,"token":false,"name":"Thorn-Thrash Viashino","scryfallId":"e7987de9-d812-4615-845a-3a90572d9b44"},{"index":37171,"token":false,"name":"Root Elemental","scryfallId":"5161968e-b757-45b8-826f-98415291024d"},{"index":37179,"token":false,"name":"Durkwood Tracker","scryfallId":"b49f5835-c933-4ba7-a3c9-34f4eb01f00d"},{"index":37182,"token":false,"name":"Kazuul, Tyrant of the Cliffs","scryfallId":"09154170-70f5-45ca-8903-027ad04bc98b"},{"index":37184,"token":true,"name":"Zombie Knight Token (B, 2/2)","scryfallId":"0b527bcd-0d37-495a-8457-8123388056b9"},{"index":37188,"token":false,"name":"Cloud Key","scryfallId":"6f880de5-8fc5-4e4e-a4bb-cc3e61a7697b"},{"index":37198,"token":false,"name":"Out of Time","scryfallId":"053d6b3b-72d4-4a55-a79e-0a601aecf108"},{"index":37202,"token":false,"name":"Reaping the Rewards","scryfallId":"379b0495-8795-4b21-9d0a-dc4e10098de2"},{"index":37204,"token":false,"name":"Alabaster Wall","scryfallId":"9cf393a3-831e-4d3a-8404-ee83f60970aa"},{"index":37211,"token":false,"name":"Tormentor's Trident","scryfallId":"9543d454-27d6-42ba-aad8-54811d180cfb"},{"index":37216,"token":false,"name":"Silent Specter","scryfallId":"bfd891ba-cf6a-4b83-a421-3a7c346ada31"},{"index":37218,"token":false,"name":"Wax // Wane","scryfallId":"d9064b95-04cb-4ba8-9db0-f5fd245f09df"},{"index":37225,"token":false,"name":"Resounding Wave","scryfallId":"f3eca679-076d-42f0-9ec0-b8116a94e373"},{"index":37226,"token":false,"name":"Spiteful Shadows","scryfallId":"ea0a94fe-11d6-48a7-9195-2cb5eff4b962"},{"index":37228,"token":false,"name":"Tyrant of Discord","scryfallId":"e8f7c8ea-e9c1-4d78-972c-15c4014915a0"},{"index":37232,"token":true,"name":"Cleric Token (B/W, 1/1)","scryfallId":"9af74e26-69d7-4683-9a71-9b420c03d75f"},{"index":37238,"token":false,"name":"Immortal Coil","scryfallId":"0b79ec57-7c45-4ef9-9051-449d473b65ea"},{"index":37242,"token":true,"name":"Elemental // Elemental Token (R, 1/1)","scryfallId":"72b45263-d4e9-4a53-a78b-be651e18b615"},{"index":37249,"token":false,"name":"Knowledge and Power","scryfallId":"7cd48a18-df3d-4381-a7e7-a3e9ae18d4d7"},{"index":37250,"token":false,"name":"Vision Skeins","scryfallId":"92b8cffe-4466-48b0-836e-51ba5db36696"},{"index":37253,"token":false,"name":"Smothering Tithe","scryfallId":"9fcea5a1-6f62-450a-9351-b7e280c5ae60"},{"index":37265,"token":false,"name":"Satyr Rambler","scryfallId":"fabccddd-c0ea-45a5-bebc-d8f858242a2a"},{"index":37269,"token":false,"name":"Leyline of Punishment","scryfallId":"51a2eec5-f892-4466-b6c6-960626ba5640"},{"index":37272,"token":false,"name":"Deep Reconnaissance","scryfallId":"148ce683-3911-4b77-9e07-3985766a3777"},{"index":37280,"token":false,"name":"Echoing Ruin","scryfallId":"01f842c8-cd6c-4f4d-9aa8-417a92b37867"},{"index":37282,"token":false,"name":"March of the Drowned","scryfallId":"34304279-188f-402f-a2bd-d9682b57e631"},{"index":37287,"token":false,"name":"Ashling, the Extinguisher","scryfallId":"350580d8-45db-4428-a292-cc4802bf1e4d"},{"index":37297,"token":false,"name":"Teferi's Realm","scryfallId":"aba3e4ea-2241-4f1e-a46b-70f512fe729e"},{"index":37298,"token":false,"name":"Gone Missing","scryfallId":"e88ae6bf-9c58-4543-ba66-19ea41d01e9b"},{"index":37300,"token":false,"name":"Final Parting","scryfallId":"de8803f6-9efa-4323-b8c5-29bdd5a48f9a"},{"index":37301,"token":false,"name":"Tainted Remedy","scryfallId":"cbb8edd0-4573-4b52-a3ea-83ed19dbf58d"},{"index":37305,"token":false,"name":"Grasp of Phantoms","scryfallId":"57cf9164-f680-43e0-8158-2c80d5b7c6e8"},{"index":37306,"token":false,"name":"Grenzo, Havoc Raiser","scryfallId":"075cd558-2557-409a-8244-2de65664be53"},{"index":37310,"token":true,"name":"Wizards","scryfallId":"169fe84f-335f-431b-b905-529ca77c6ba1"},{"index":37317,"token":false,"name":"Renewing Dawn","scryfallId":"e56300cb-6b44-47fe-9508-c33ad5670b4b"},{"index":37320,"token":false,"name":"Crypt Creeper","scryfallId":"0382cb94-0836-4e23-99b7-034faa363203"},{"index":37331,"token":false,"name":"Aetherflame Wall","scryfallId":"93b14f08-dd93-4a9f-a616-8f8d0b26b966"},{"index":37333,"token":false,"name":"Opposition Agent","scryfallId":"7b218531-9f5c-4ffb-9d2f-f2ead5b9f221"},{"index":37334,"token":false,"name":"Ravenous Lindwurm","scryfallId":"9961e3fc-167e-4043-8510-cc5cf08d473e"},{"index":37338,"token":false,"name":"Landslide","scryfallId":"c0ddc0dc-8783-4659-bbbd-db6698843b47"},{"index":37342,"token":false,"name":"Kazandu Blademaster","scryfallId":"9642bdbf-c03f-4c48-a5c8-c9201a08b834"},{"index":37344,"token":false,"name":"Anaba Spirit Crafter","scryfallId":"0bb37d02-3e99-433a-ad3a-3c1fce50f0f0"},{"index":37347,"token":false,"name":"Warfire Javelineer","scryfallId":"d2c9ea25-7a5e-4b6d-b071-e929f6b652c4"},{"index":37358,"token":false,"name":"Harsh Judgment","scryfallId":"34c78dee-ab45-4638-b89a-10686145b19a"},{"index":37361,"token":false,"name":"Symmetry Sage","scryfallId":"3e726fc7-36cf-405c-9b7c-d1e41cd6c68f"},{"index":37364,"token":false,"name":"Sanctum Weaver","scryfallId":"4d42e22d-f60e-40c5-b069-5e1708f3bebc"},{"index":37369,"token":false,"name":"Stasis Cell","scryfallId":"49304692-1e8c-46ed-ba51-e5ba3b70e2f4"},{"index":37380,"token":false,"name":"Bloodstoke Howler","scryfallId":"743779d4-fee8-4b8d-a5ac-27f355e006e5"},{"index":37386,"token":false,"name":"Dispense Justice","scryfallId":"7b3330a1-98b6-4b09-9bca-6c7c89447ba2"},{"index":37387,"token":false,"name":"Syphon Sliver","scryfallId":"85cb40e3-c3ed-4b3f-88ad-6f1305297c6f"},{"index":37390,"token":false,"name":"Scrounger of Souls","scryfallId":"23f9e014-7176-4e9c-9b23-1dc7cb70749e"},{"index":37395,"token":false,"name":"Thunderous Orator","scryfallId":"ef3b2961-559f-42b1-be13-ff3d03e62809"},{"index":37396,"token":false,"name":"Containment Breach","scryfallId":"0dcca120-b72e-4007-98e1-cb22e7b9a705"},{"index":37397,"token":false,"name":"Crenellated Wall","scryfallId":"b059ab1d-dfb1-44e7-a236-f6600e454147"},{"index":37399,"token":false,"name":"Molten Influence","scryfallId":"4c2b326b-d177-4a03-a0a3-fe2c2d4af272"},{"index":37406,"token":false,"name":"Mizzium Skin","scryfallId":"d9859344-4efc-4b87-a3fb-147e496cee68"},{"index":37407,"token":false,"name":"Watcher for Tomorrow","scryfallId":"15f01a3c-0a66-48da-a7d2-46260e3b721f"},{"index":37410,"token":false,"name":"Diviner Spirit","scryfallId":"e86df81e-83d6-4522-82ad-2b1f2d8de623"},{"index":37415,"token":false,"name":"Ruin Rat","scryfallId":"91652fe0-2064-4996-b484-a1f88e0023f7"},{"index":37419,"token":false,"name":"Stir the Grave","scryfallId":"7287f68f-f2e2-4e6f-a772-29a629bb9ccd"},{"index":37420,"token":false,"name":"Starlit Sanctum","scryfallId":"ace5e601-2583-4d9c-8bdf-aa33666c717c"},{"index":37424,"token":false,"name":"Credit Voucher","scryfallId":"1ab65242-17ad-4c22-9c70-aac8076d1b4c"},{"index":37428,"token":false,"name":"Heart Warden","scryfallId":"96e42dbe-3eeb-4367-bb6d-0f5c71f5da80"},{"index":37429,"token":false,"name":"Sentinels of Glen Elendra","scryfallId":"f48daf7e-2f8e-4179-a145-a6b36dd11d44"},{"index":37431,"token":false,"name":"Devious Cover-Up","scryfallId":"21ac6b0a-b1a5-439d-b65e-5f04e1826c80"},{"index":37433,"token":false,"name":"Containment Membrane","scryfallId":"b25f317e-ad96-4276-8193-d056748717b9"},{"index":37435,"token":false,"name":"Dragon Hatchling","scryfallId":"83cb9ea2-ce64-437e-afac-5029a34bf10f"},{"index":37439,"token":false,"name":"Explosive Impact","scryfallId":"3a3e2b45-b086-4ffd-aa1a-1d03046e0d61"},{"index":37443,"token":false,"name":"Barreling Attack","scryfallId":"a3a2955e-e714-419e-9e3d-7ae3d7fae041"},{"index":37447,"token":false,"name":"Sanctum Custodian","scryfallId":"27a64b98-9002-48fe-a3e5-4449050c87e1"},{"index":37449,"token":false,"name":"Prismatic Strands","scryfallId":"efd85985-abc1-430a-9210-63109c90a82d"},{"index":37451,"token":false,"name":"Angel of the God-Pharaoh","scryfallId":"ad202785-a91f-4dc8-bcc0-eb1bd49f162e"},{"index":37453,"token":false,"name":"Havoc Festival","scryfallId":"04560623-c768-4273-a40d-7e3f39e832cf"},{"index":37454,"token":false,"name":"Poison the Well","scryfallId":"cb86eeec-d50f-4823-86bd-35437926a6e4"},{"index":37455,"token":false,"name":"Gnarled Effigy","scryfallId":"e6aee954-2a04-425d-8d05-09dad58af656"},{"index":37460,"token":false,"name":"Azor's Elocutors","scryfallId":"61e82934-546b-4734-a715-b22ace4c5a9b"},{"index":37462,"token":false,"name":"Guiding Spirit","scryfallId":"5f96d184-0ef8-40f7-98bc-bd4c53c57072"},{"index":37468,"token":false,"name":"Thousand-Year Elixir","scryfallId":"b2c448f0-776b-4aa9-8b6d-af35b118625f"},{"index":37474,"token":false,"name":"Teeterpeak Ambusher","scryfallId":"ad57c2f3-d9cb-4165-bb39-897b5b12689e"},{"index":37475,"token":false,"name":"Curse of Verbosity","scryfallId":"97d8c559-f32b-4870-963e-8233e7ffa4a0"},{"index":37476,"token":false,"name":"Dregscape Sliver","scryfallId":"4a835b7e-cd63-486d-8b58-2f443f686e32"},{"index":37479,"token":false,"name":"Jace's Triumph","scryfallId":"4924f177-5ee2-4d3f-9603-4b9aef4dac09"},{"index":37480,"token":false,"name":"Kitsune Palliator","scryfallId":"eb981f8b-4f03-4fd2-a255-b10635958bfd"},{"index":37485,"token":false,"name":"Rising Miasma","scryfallId":"4f9a8e87-3b8b-4dbf-9c1e-0a3290a33a0b"},{"index":37487,"token":false,"name":"Brambleweft Behemoth","scryfallId":"1c759e94-e437-4dda-af0f-6578c0a50619"},{"index":37488,"token":false,"name":"Skill Borrower","scryfallId":"ac7ac7c8-8e01-4f80-a3fa-d533cb594d7c"},{"index":37489,"token":false,"name":"Ghost-Lit Nourisher","scryfallId":"f4becdbb-9089-4c54-a681-6510d90cc99e"},{"index":37494,"token":false,"name":"Quandrix Apprentice","scryfallId":"0291c909-bb87-47cb-9b06-5e409e654f15"},{"index":37499,"token":false,"name":"Elspeth's Nightmare","scryfallId":"37ccd974-d2bc-4fcf-94a7-0a868a04cb98"},{"index":37500,"token":false,"name":"Flesh to Dust","scryfallId":"16b2e842-6c92-47b0-bed4-e0e64485f168"},{"index":37501,"token":true,"name":"Hydra Token (G, 0/0)","scryfallId":"ebe2f431-75b6-4c3c-a601-15814752ea6c"},{"index":37504,"token":false,"name":"Unwinding Clock","scryfallId":"495d520b-7560-4ecb-ae62-143eeec5682f"},{"index":37505,"token":false,"name":"Shield Mate","scryfallId":"b49261bb-66b5-4226-9001-02d045fbcbce"},{"index":37508,"token":false,"name":"Fully Grown","scryfallId":"0b683d3f-025c-4b8d-89d7-3513488649d5"},{"index":37509,"token":false,"name":"Urza's Tome","scryfallId":"d6bead8b-a67f-4451-9d44-038f8688093f"},{"index":37514,"token":false,"name":"Kathari Screecher","scryfallId":"150cf865-79e2-4f74-a872-44e1e5bc73c4"},{"index":37515,"token":false,"name":"Sea God's Scorn","scryfallId":"9504dc26-f5d8-4b9d-9eb1-51a12b893beb"},{"index":37520,"token":false,"name":"Trail of Evidence","scryfallId":"4b150797-ee8d-42f8-adcb-2f4b1783c074"},{"index":37522,"token":false,"name":"Champion of the Flame","scryfallId":"460fa161-362f-406d-9149-d412bc51836c"},{"index":37531,"token":false,"name":"Necravolver","scryfallId":"53df0949-a732-4b2d-b81d-a900353869e2"},{"index":37543,"token":false,"name":"Skred","scryfallId":"be71e1a2-ba83-4c07-b7e5-c13dc51be639"},{"index":37544,"token":false,"name":"Mogg Maniac","scryfallId":"df726d89-5246-4ece-89ff-f059e06e4460"},{"index":37545,"token":false,"name":"Vulpine Goliath","scryfallId":"cdacb147-35ce-4751-961e-576b5f958048"},{"index":37546,"token":false,"name":"Nesting Grounds","scryfallId":"cf559d4e-07a7-4ca4-b76a-d0615222cb60"},{"index":37548,"token":false,"name":"Wildwood Geist","scryfallId":"4658b4b2-7043-4ca2-96fd-4f663c20c80f"},{"index":37550,"token":false,"name":"Minotaur Explorer","scryfallId":"55725e38-d60a-41a2-93b0-2eefe6d2cc59"},{"index":37557,"token":false,"name":"Merfolk Seer","scryfallId":"63139890-e860-4791-9bb6-b79bb361ef8b"},{"index":37560,"token":false,"name":"Study Break","scryfallId":"ef7cd813-0781-4fd7-8748-2716e1eeb4b9"},{"index":37561,"token":false,"name":"Disappearing Act","scryfallId":"9a4a6d56-9bed-444c-aae8-383c315779a0"},{"index":37569,"token":false,"name":"Anointer Priest","scryfallId":"c1c4274b-4268-48af-bbf0-38349a317a99"},{"index":37572,"token":false,"name":"Out of Bounds","scryfallId":"8b457672-902b-42c0-9d53-a3c21be2f500"},{"index":37574,"token":false,"name":"Sandsteppe Outcast","scryfallId":"f29943bb-aa89-443b-96b7-8f6f24672a9d"},{"index":37576,"token":false,"name":"Aether Inspector","scryfallId":"f5dcbe97-d582-464e-98e7-dd06d8652606"},{"index":37581,"token":false,"name":"Turn the Tables","scryfallId":"f79b38c5-4be1-4f33-92e8-6fe0476b5299"},{"index":37584,"token":false,"name":"Acolyte of the Inferno","scryfallId":"186581c7-81a6-4c27-b8a9-ff7f7a4b1d40"},{"index":37585,"token":false,"name":"Treetop Rangers","scryfallId":"33f1a343-250b-4a30-a3b5-296282a70446"},{"index":37586,"token":false,"name":"Lavabrink Floodgates","scryfallId":"d2f9a9bf-edd2-4448-bace-8bfba3ba529a"},{"index":37588,"token":false,"name":"Venerable Knight","scryfallId":"0001f1ef-b957-4a55-b47f-14839cdbab6f"},{"index":37589,"token":false,"name":"Squee's Revenge","scryfallId":"2b391ee3-c1cd-47bc-9540-977cbc32913e"},{"index":37591,"token":false,"name":"Devoted Hero","scryfallId":"89fb4bf8-51b6-44a8-92ac-e5aec4e4f2bc"},{"index":37594,"token":false,"name":"Sea Scryer","scryfallId":"124308ac-1bf6-4a79-8aaa-f3be8eeb3e78"},{"index":37595,"token":false,"name":"Tainted Peak","scryfallId":"4dcaaabe-e1d7-4047-9960-79178af3d903"},{"index":37596,"token":false,"name":"Unwilling Recruit","scryfallId":"b1cdd83c-50e2-4c04-a4fe-1fe2f545c7a2"},{"index":37598,"token":false,"name":"Cerulean Drake","scryfallId":"b11f9e7d-3f56-4e28-9908-157735f6dfa9"},{"index":37608,"token":false,"name":"Brallin, Skyshark Rider","scryfallId":"11b49032-1906-44b5-8f89-2082bd6e5734"},{"index":37609,"token":false,"name":"Kavu Glider","scryfallId":"158aa5a8-2769-4a8a-b457-001abc862b35"},{"index":37612,"token":false,"name":"Thunder Brute","scryfallId":"c28fa4f8-4b87-41dc-802d-dfd160ccf1a8"},{"index":37613,"token":false,"name":"Hand of Honor","scryfallId":"ddef832c-b2be-4fa6-8d66-ac0d442f2d7d"},{"index":37619,"token":false,"name":"Flailing Soldier","scryfallId":"fb44b0f6-0608-40d6-9eaa-48e5a834701f"},{"index":37622,"token":false,"name":"Militant Angel","scryfallId":"cb67bd17-b24c-4c6f-917c-6fb4fe4f8a7e"},{"index":37626,"token":true,"name":"Zombie // Zombie Token (Colorless, 2/2)","scryfallId":"4f153ca0-0e55-4f3c-9780-570708844fd3"},{"index":37631,"token":false,"name":"Biogenic Ooze","scryfallId":"6f11029a-b24d-4248-834f-b852b56857f6"},{"index":37632,"token":false,"name":"Gutter Grime","scryfallId":"a9d007a2-163d-4e09-a70b-280a6fa3203b"},{"index":37634,"token":false,"name":"Joraga Visionary","scryfallId":"a1ea2c17-382a-45e4-ac34-88bf8ba47169"},{"index":37635,"token":true,"name":"Raphael Levy Decklist","scryfallId":"9b787cb5-4c62-4dc4-baf8-fe7a2c87e4b8"},{"index":37639,"token":false,"name":"Rishadan Pawnshop","scryfallId":"2c5fc9fc-a0f9-4f56-8368-2d7e1fec5ba0"},{"index":37640,"token":false,"name":"Enthralling Hold","scryfallId":"d3bc7176-abe0-47cf-a242-cf22a1f590be"},{"index":37641,"token":true,"name":"Dinosaurs","scryfallId":"5474b689-e0f0-452b-a9d0-c1a554245f4f"},{"index":37646,"token":false,"name":"Ojutai's Summons","scryfallId":"6769341a-1331-456d-a2bb-cd7fffe7b51d"},{"index":37649,"token":false,"name":"Serra Paladin","scryfallId":"7bd25adf-4d97-4229-abdb-1c060036cfbd"},{"index":37651,"token":false,"name":"Mindreaver","scryfallId":"87912ae7-3edc-4ea2-9b4b-caf2bc149ad1"},{"index":37656,"token":false,"name":"Golden Hind","scryfallId":"1ae883ea-191e-4571-be3d-1e3149e6965e"},{"index":37668,"token":true,"name":"Mowu // Mowu Token (Colorless, 3/3)","scryfallId":"b10441dd-9029-4f95-9566-d3771ebd36bd"},{"index":37674,"token":false,"name":"Akoum Battlesinger","scryfallId":"031950b6-110f-4e20-b31b-afe5ffdd6086"},{"index":37677,"token":false,"name":"Darksteel Myr","scryfallId":"0f5712cf-c6a9-4a2e-90db-8ca17c621724"},{"index":37680,"token":false,"name":"Somberwald Spider","scryfallId":"43003ad7-2f42-4c85-8b00-77cbf3f50a7b"},{"index":37684,"token":false,"name":"Pyroclastic Elemental","scryfallId":"15148b4e-19e2-4e39-8e6f-1dc94ea03463"},{"index":37686,"token":false,"name":"Raging Minotaur","scryfallId":"c52f5e44-4ab6-43d7-aecb-5b95f84d5475"},{"index":37688,"token":false,"name":"Kashi-Tribe Elite","scryfallId":"d12adf2d-ebf9-464e-9957-c8518d364a40"},{"index":37694,"token":false,"name":"Light from Within","scryfallId":"6afda091-ed14-4bc5-8896-bdb7c95a499e"},{"index":37695,"token":false,"name":"Telim'Tor","scryfallId":"33cc89c8-a3ea-469e-b499-f48acec4f538"},{"index":37701,"token":false,"name":"Quillmane Baku","scryfallId":"fe9140fc-9d50-4e63-aae6-1ba2974a25a3"},{"index":37711,"token":false,"name":"Rotfeaster Maggot","scryfallId":"6a438aef-3752-416c-b795-8ce0a39924a9"},{"index":37723,"token":false,"name":"Benevolent Offering","scryfallId":"2a1603aa-bf6f-4a9d-b370-22f2286d0d36"},{"index":37724,"token":false,"name":"Thalakos Sentry","scryfallId":"739a13d6-5f73-4166-b923-9db8ee3f2cf7"},{"index":37733,"token":false,"name":"Usher of the Fallen","scryfallId":"24e58478-c6a8-4f86-854a-a489c99bd777"},{"index":37740,"token":false,"name":"Wall of Torches","scryfallId":"76f69b92-7435-4aa8-9d90-89ea078befb1"},{"index":37741,"token":true,"name":"Brian Selden Bio","scryfallId":"cdbe9dfc-3c91-40ac-9740-167e17746e94"},{"index":37747,"token":false,"name":"Meloku the Clouded Mirror","scryfallId":"60b9db96-a6ab-454b-99a7-910ef77560d7"},{"index":37748,"token":false,"name":"Hopping Automaton","scryfallId":"4717b6c3-9fba-454f-9d02-e8c2869c4450"},{"index":37749,"token":false,"name":"Curator's Ward","scryfallId":"10cc417f-0ea7-47a8-b7d0-aa8d20168faf"},{"index":37761,"token":false,"name":"Fleshwrither","scryfallId":"08e1a646-6925-4a53-a99c-8951af016a7a"},{"index":37763,"token":false,"name":"Yore-Tiller Nephilim","scryfallId":"28dc7541-d47c-4149-ae34-c4ef681fd795"},{"index":37766,"token":false,"name":"Carrion Grub","scryfallId":"31df3d95-bbdb-449d-9601-4fa844c3c640"},{"index":37774,"token":false,"name":"Rites of Reaping","scryfallId":"115d504f-3aec-4374-8cd8-732d56c448f2"},{"index":37781,"token":false,"name":"Malignant Growth","scryfallId":"760b6703-ac92-45f6-8c32-60f760eba866"},{"index":37786,"token":false,"name":"Stone Calendar","scryfallId":"e682d19b-7936-4942-b42c-c836d6741a45"},{"index":37787,"token":false,"name":"Sky Terror","scryfallId":"167ed739-2953-47af-841f-bc1a092b3aa6"},{"index":37788,"token":false,"name":"Leech Bonder","scryfallId":"a86562c6-91bd-4866-a2a9-0062ffdf07ce"},{"index":37789,"token":false,"name":"Bounty of Skemfar","scryfallId":"3185a67e-648c-48a8-9aad-180e1ca0f4ae"},{"index":37794,"token":false,"name":"Late to Dinner","scryfallId":"6633cab9-23f9-474e-96f1-ca7c0c67691c"},{"index":37802,"token":false,"name":"Mistform Dreamer","scryfallId":"ff34e303-c94a-4f5f-b9f6-8d48e6aac383"},{"index":37808,"token":false,"name":"Serra's Hymn","scryfallId":"74b8205a-608e-4274-a32c-802a7ce52d9c"},{"index":37809,"token":false,"name":"Nath's Buffoon","scryfallId":"66f077d2-34ab-45fa-84db-eb408c5a9996"},{"index":37811,"token":false,"name":"Arena Athlete","scryfallId":"bacc2881-26b8-4199-9b7d-e12c75effe6e"},{"index":37812,"token":false,"name":"Whirler Virtuoso","scryfallId":"ae429806-28b5-4bee-b0e1-1bd876f282c2"},{"index":37814,"token":false,"name":"Thelonite Monk","scryfallId":"5400ff25-c70e-4095-a228-190601b86043"},{"index":37817,"token":false,"name":"Coral Atoll","scryfallId":"5d7c4619-e5af-4aa0-bd3f-6bf0e1fdc1fc"},{"index":37819,"token":false,"name":"Izzet Guildmage","scryfallId":"ecce6ade-8741-4567-8ed3-3e03becc6f1b"},{"index":37824,"token":false,"name":"Greatbow Doyen","scryfallId":"a0f64e8a-2775-4f64-8728-36e7d613f54c"},{"index":37825,"token":false,"name":"Oath of Ghouls","scryfallId":"1102f35a-ae62-479d-b61c-31a82978aedd"},{"index":37831,"token":false,"name":"Pit Raptor","scryfallId":"e37cd150-1064-43b7-919b-8922d8a18f21"},{"index":37832,"token":false,"name":"Ojutai Exemplars","scryfallId":"d1205482-2f9d-463e-893f-18998aaf09c6"},{"index":37841,"token":true,"name":"Rainbow","scryfallId":"70f3fcff-a81b-4fe8-9994-fce43aaa2e0b"},{"index":37843,"token":false,"name":"Disembowel","scryfallId":"c1edb79d-0031-4dc6-8881-f6d1fe4acba2"},{"index":37845,"token":false,"name":"Goblin Clearcutter","scryfallId":"e07c0cae-852c-444c-8994-68a6d81b4cd4"},{"index":37849,"token":false,"name":"Pious Wayfarer","scryfallId":"10b1a2b5-5be2-43a2-bc35-95df6eb0984f"},{"index":37850,"token":false,"name":"Shriekdiver","scryfallId":"0a1c3148-7a6f-4963-af0b-18d9a156bf22"},{"index":37852,"token":false,"name":"Master of the Wild Hunt","scryfallId":"2cf3169c-f01c-47f4-ba4b-e199b7ade5fc"},{"index":37857,"token":false,"name":"Vampire Hounds","scryfallId":"59339026-3ec6-4bd9-a1c4-c80951f8c68d"},{"index":37858,"token":false,"name":"Crystal Spray","scryfallId":"8798a4f1-34bb-449d-a8cc-faf8bda8e0ab"},{"index":37859,"token":false,"name":"Valakut, the Molten Pinnacle","scryfallId":"c2d07eea-b165-4976-9088-d283ab7cfe72"},{"index":37863,"token":false,"name":"Transmogrifying Wand","scryfallId":"61c9b8e7-2661-4f7e-b08c-a0f3b8b40b16"},{"index":37869,"token":false,"name":"Disinformation Campaign","scryfallId":"69a79ff3-58ed-4cc2-9ebc-0edbb86cd6fb"},{"index":37874,"token":false,"name":"Nacatl Outlander","scryfallId":"12b5b694-46c8-4cb0-ab6b-4bc67c04cc7f"},{"index":37881,"token":false,"name":"Glint-Nest Crane","scryfallId":"6fa5b030-23a6-4fca-b318-c580e3ea2bad"},{"index":37882,"token":false,"name":"Soramaro, First to Dream","scryfallId":"e56de23d-7281-42f9-afce-7a81438dae5d"},{"index":37885,"token":false,"name":"Endless Horizons","scryfallId":"32385604-dcff-41e4-97a5-fcf230033a87"},{"index":37886,"token":false,"name":"Goldmeadow Dodger","scryfallId":"5305b5c6-2af6-4b5c-9a57-0a2d2628e2f4"},{"index":37889,"token":false,"name":"Noble Steeds","scryfallId":"684bc5b2-c5fb-4340-9c11-73891adb4b93"},{"index":37890,"token":false,"name":"Lys Alana Bowmaster","scryfallId":"fac845bd-becd-4c58-9561-7cdf2adca058"},{"index":37897,"token":false,"name":"Dromar, the Banisher","scryfallId":"cfcc3c72-fff5-454c-814c-eb952fd23ba9"},{"index":37899,"token":false,"name":"Untamed Kavu","scryfallId":"3c4cf84a-2024-45bb-9e24-8a9a6d9ad247"},{"index":37904,"token":false,"name":"Hythonia the Cruel","scryfallId":"a9fbc814-4281-4ac6-a844-68bcd848f229"},{"index":37909,"token":false,"name":"Awe Strike","scryfallId":"a5cd231b-7891-42b5-b5de-5112d1230c37"},{"index":37910,"token":false,"name":"Reverent Silence","scryfallId":"b82d3432-2167-4a65-8221-cb7b338e60d0"},{"index":37911,"token":false,"name":"Soul Parry","scryfallId":"e241ea47-cbbe-4241-94f9-315cc7cfd79b"},{"index":37914,"token":false,"name":"Moor Fiend","scryfallId":"57089dd4-e30d-498d-9341-43c104c6f3f9"},{"index":37920,"token":false,"name":"Avacyn's Collar","scryfallId":"972e9a78-204b-4012-b394-b40fd0edac4c"},{"index":37927,"token":false,"name":"Concerted Defense","scryfallId":"235c108d-3902-4c2e-919c-a5449cd2dc3c"},{"index":37933,"token":false,"name":"Chill Haunting","scryfallId":"e9311553-6381-491c-b6f1-ad4aec828e7b"},{"index":37936,"token":false,"name":"Minion's Return","scryfallId":"ce763778-0a35-41d2-9286-fdf2302554f5"},{"index":37937,"token":false,"name":"Tempest Owl","scryfallId":"d173dda8-de9f-4148-b5be-85d1a4c4faf6"},{"index":37946,"token":false,"name":"Krosan Archer","scryfallId":"e188562f-8219-4fb0-ac2c-5618cfb00bca"},{"index":37947,"token":false,"name":"Shadows of the Past","scryfallId":"35139a18-28c7-4a8f-986a-47e909cc23eb"},{"index":37949,"token":false,"name":"Maga, Traitor to Mortals","scryfallId":"2563fd68-afdd-466f-8137-0769565674bf"},{"index":37951,"token":false,"name":"Lava Flow","scryfallId":"99bb95f4-5dbc-4b69-b848-fc7e1059282a"},{"index":37955,"token":false,"name":"Martyr's Cry","scryfallId":"c9fb6ef0-0a57-4521-9401-92ad6c614af2"},{"index":37959,"token":false,"name":"Needlebite Trap","scryfallId":"8dee4c4e-9505-43e5-88af-db5f9e56a749"},{"index":37963,"token":false,"name":"Auriok Windwalker","scryfallId":"4315d060-9858-405c-a442-c7a278134f00"},{"index":37965,"token":false,"name":"Depths of Desire","scryfallId":"63420437-76a9-40cf-aedc-0ca1e73fcc0b"},{"index":37971,"token":false,"name":"Necratog","scryfallId":"fb19c519-c09a-44a0-8d4b-ab6c15dabdef"},{"index":37972,"token":false,"name":"Ingenious Thief","scryfallId":"be341805-b4de-456e-8b46-4ee5fdbca7e0"},{"index":37981,"token":false,"name":"Duskwalker","scryfallId":"39a4a026-f44e-40e1-9942-a3d8448aca70"},{"index":37989,"token":false,"name":"Nissa's Encouragement","scryfallId":"a489d5c7-ef57-4973-86ac-06234c308c3c"},{"index":37990,"token":false,"name":"Scroll of Griselbrand","scryfallId":"2263ceaf-49d2-40fe-86b8-146271b11e46"},{"index":37994,"token":false,"name":"Blightwidow","scryfallId":"26da4278-ba44-4555-8837-e24627b46533"},{"index":37996,"token":false,"name":"Screeching Bat // Stalking Vampire","scryfallId":"88db324f-11f1-43d3-a897-f4e3caf8d642"},{"index":37997,"token":false,"name":"Spreading Insurrection","scryfallId":"f1c1918b-2f7a-4cab-9547-029ebc589000"},{"index":38001,"token":false,"name":"Stone-Seeder Hierophant","scryfallId":"f4e1b9f9-e58c-4474-9a31-8e5d9f96492e"},{"index":38003,"token":false,"name":"Unseen Walker","scryfallId":"bc03eea5-ff21-4f4d-b4c2-ce9d8f456440"},{"index":38004,"token":false,"name":"Paired Tactician","scryfallId":"67930e10-4de8-4d40-af27-4a38d35ab16f"},{"index":38006,"token":false,"name":"Hearth Charm","scryfallId":"caa9ac66-51b7-4aec-92dc-0f0656b0f7fe"},{"index":38008,"token":false,"name":"Shu Elite Companions","scryfallId":"11ac63f6-cd61-4334-902a-777410311b2d"},{"index":38011,"token":false,"name":"Regal Caracal","scryfallId":"cc05783c-fd85-4fb2-bddc-2eef72513cf0"},{"index":38018,"token":false,"name":"Daysquad Marshal","scryfallId":"17d566bd-f272-49d1-bffb-588f2a42046a"},{"index":38019,"token":false,"name":"Paliano, the High City","scryfallId":"eac8649b-b892-4854-8422-fd117ccac39a"},{"index":38020,"token":false,"name":"Sewer Shambler","scryfallId":"0ae7ba14-c901-4266-ae31-812e001916d3"},{"index":38032,"token":false,"name":"Shiv's Embrace","scryfallId":"2a9b3c25-ed4e-4fff-a7dc-811755408f3e"},{"index":38040,"token":false,"name":"Constable of the Realm","scryfallId":"73b5a0a5-5486-409a-b324-668ae03fc62a"},{"index":38045,"token":false,"name":"Vectis Gloves","scryfallId":"6cc098a4-24fa-492f-91f0-2e8b482c823b"},{"index":38047,"token":false,"name":"Forgeborn Oreads","scryfallId":"b80038ed-4206-4e44-943e-f332e4ce2f14"},{"index":38048,"token":false,"name":"Frontline Medic","scryfallId":"984f0514-e9a9-4f22-9f7d-96fd62338db2"},{"index":38051,"token":false,"name":"Daxos of Meletis","scryfallId":"6bb68644-e99d-4ecb-a804-8d4ad1c3325d"},{"index":38061,"token":false,"name":"Roots of Wisdom","scryfallId":"734afb5b-3163-47fa-856f-8a85b9da22d3"},{"index":38064,"token":false,"name":"Quag Sickness","scryfallId":"21d56d13-b9de-44db-b235-4f7eea60f424"},{"index":38067,"token":false,"name":"Kumano's Pupils","scryfallId":"c62b233e-95fe-4cfd-ad89-86e07656bf8b"},{"index":38068,"token":false,"name":"Excommunicate","scryfallId":"6fe080bc-e642-4fce-b4ee-bbe25d735673"},{"index":38071,"token":false,"name":"Goblin Pyromancer","scryfallId":"bb4815b7-fc20-44a4-ad1c-66d92993557f"},{"index":38076,"token":false,"name":"Diplomatic Escort","scryfallId":"9356bdbb-d647-4f51-a7a3-18ecea898a7f"},{"index":38083,"token":false,"name":"Electropotence","scryfallId":"9830b9e9-950c-4763-9396-8194d08bf8df"},{"index":38086,"token":false,"name":"Wall of Razors","scryfallId":"0bb37bcd-0bbd-4f3f-9623-803885750344"},{"index":38090,"token":false,"name":"Putrefax","scryfallId":"b2b2c3f9-a831-4fd2-80e8-b67b0df3e98b"},{"index":38092,"token":false,"name":"Rat Colony","scryfallId":"4f618e07-f06f-45d2-8512-e6cef88c0434"},{"index":38093,"token":false,"name":"Slagstorm","scryfallId":"9e318b03-2aad-462b-a2a9-8b6bdf0e93d6"},{"index":38096,"token":false,"name":"Terror of Mount Velus","scryfallId":"332dc6c3-7802-4bde-aa4e-0feab70c216f"},{"index":38101,"token":false,"name":"Cabal Interrogator","scryfallId":"256a7a37-6f47-47a3-b149-5692aee8b34a"},{"index":38103,"token":false,"name":"Garza's Assassin","scryfallId":"3407ccbd-788d-4fe3-a039-0497724a94b5"},{"index":38104,"token":false,"name":"Merfolk Traders","scryfallId":"ebacbf23-4b69-481c-aaf7-5de7b4a6db6f"},{"index":38106,"token":false,"name":"Lim-Dûl's Paladin","scryfallId":"44be2d66-359e-4cc1-9670-119cb9c7d5f5"},{"index":38115,"token":false,"name":"Sylvok Lifestaff","scryfallId":"abbc5ae5-8e8b-4106-844f-2d49d2a51ed9"},{"index":38117,"token":false,"name":"Nature's Ruin","scryfallId":"f123d665-b3d2-4edb-9f8d-49da748f8628"},{"index":38119,"token":false,"name":"Farmstead Gleaner","scryfallId":"edafd52f-2dda-4981-baee-404f47ee8969"},{"index":38122,"token":false,"name":"Whetwheel","scryfallId":"dc6040b6-cf02-4f7e-a275-177c3a6415aa"},{"index":38126,"token":false,"name":"Price of Fame","scryfallId":"26125983-e007-4a73-999d-fb2617a80261"},{"index":38143,"token":false,"name":"Daru Spiritualist","scryfallId":"18f26b88-cffc-47ed-a70a-7d704a32c8bb"},{"index":38144,"token":false,"name":"Beyeen Veil // Beyeen Coast","scryfallId":"5f411f08-45dd-4d73-8894-daf51c175150"},{"index":38145,"token":false,"name":"Thought Devourer","scryfallId":"ba7a96ee-e2d1-4d76-a09e-d6868ddd9282"},{"index":38147,"token":false,"name":"Multani's Harmony","scryfallId":"c76352ea-e3d2-4221-8ebe-e953301c35ab"},{"index":38149,"token":false,"name":"Spitting Hydra","scryfallId":"38c25d65-16bd-4628-b6ec-9e5495818277"},{"index":38152,"token":false,"name":"Biomancer's Familiar","scryfallId":"d38c9891-36d1-4565-9c4a-1cd9dbf8c048"},{"index":38154,"token":false,"name":"Twinblade Slasher","scryfallId":"0092d7a0-bd00-45e5-a052-c0a9d970bc2e"},{"index":38159,"token":false,"name":"Avoid Fate","scryfallId":"04c9f48d-2213-4f95-8eac-b23bd2d95e34"},{"index":38164,"token":false,"name":"Ogre Sentry","scryfallId":"bb6e7b24-9430-4ac9-bd62-1770b8749090"},{"index":38172,"token":false,"name":"Hoar Shade","scryfallId":"72242dff-15ca-4da0-b3ae-9984d037b31f"},{"index":38173,"token":false,"name":"Second Harvest","scryfallId":"4f424074-2eb3-4842-97cb-b2794df1a99f"},{"index":38184,"token":false,"name":"Storm Sculptor","scryfallId":"1833a979-2210-42dd-a18f-68a3248fe766"},{"index":38190,"token":false,"name":"Coordinated Charge","scryfallId":"129c404b-2c1e-4f0b-bb4e-7e8e627a69a8"},{"index":38199,"token":false,"name":"Breakneck Berserker","scryfallId":"d6eb23c9-6061-4ad1-a8f3-2c791c49f352"},{"index":38200,"token":false,"name":"Kazuul's Toll Collector","scryfallId":"7377e5a7-b479-48cc-8fbb-01af87c62566"},{"index":38207,"token":false,"name":"Chaos Lord","scryfallId":"ee245922-b380-4b2e-a43f-ab1ba8078943"},{"index":38210,"token":false,"name":"Reconnaissance","scryfallId":"a16012d8-703c-4385-8769-13e3caba3fc6"},{"index":38213,"token":false,"name":"Petradon","scryfallId":"75ac6311-8516-4db2-8c1f-626f0db0d36f"},{"index":38215,"token":false,"name":"Filigree Crawler","scryfallId":"8d8e817c-079e-4e7c-a8ca-54634f30bf36"},{"index":38216,"token":false,"name":"Thraben Foulbloods","scryfallId":"bf0f72e0-1254-4bfb-b405-d64012dc171a"},{"index":38218,"token":false,"name":"Thornmantle Striker","scryfallId":"544b6477-cefa-40e2-a96a-72794c7eb815"},{"index":38221,"token":false,"name":"Kagemaro's Clutch","scryfallId":"4fe4bb8d-bed8-4373-af9d-9332de910e06"},{"index":38226,"token":false,"name":"Simic Ascendancy","scryfallId":"60b659cc-a168-4b09-a0d5-23979fefec2c"},{"index":38231,"token":false,"name":"Waterlogged Grove","scryfallId":"0ab6bfbd-d2e1-4c4c-9f91-6f69c5b8e3bb"},{"index":38236,"token":false,"name":"Faerie Impostor","scryfallId":"7dfddc9d-85f6-4b37-9973-14c69f6818ec"},{"index":38240,"token":false,"name":"Sigil Tracer","scryfallId":"7c9341e6-b899-418d-916f-550775af419f"},{"index":38242,"token":false,"name":"Singe-Mind Ogre","scryfallId":"ab1564d7-43fe-4072-91a6-622713848b7e"},{"index":38245,"token":false,"name":"Soltari Monk","scryfallId":"c0a47eed-c08e-459c-a1f6-991728020bbd"},{"index":38247,"token":false,"name":"Loxodon Gatekeeper","scryfallId":"781476a1-73a9-4f43-9f71-d29c97ecc69a"},{"index":38248,"token":false,"name":"Illusionary Wall","scryfallId":"6430e8e2-fee3-4744-820e-d6e16cb992bd"},{"index":38249,"token":false,"name":"Heartwood Treefolk","scryfallId":"de263f02-8e3e-4785-9c06-9adc168994f3"},{"index":38252,"token":false,"name":"Atzocan Seer","scryfallId":"fe84b3c0-bca2-42d3-a82c-540644e59625"},{"index":38261,"token":false,"name":"Hedonist's Trove","scryfallId":"b2b73bbf-39a8-4358-9af6-8f4f0b57c028"},{"index":38262,"token":false,"name":"Manacles of Decay","scryfallId":"f3da5010-78b6-426f-aeb4-73c21d2af581"},{"index":38266,"token":false,"name":"Creakwood Ghoul","scryfallId":"3d4e94d3-0df5-4d2b-a5d9-178fe1350ceb"},{"index":38272,"token":false,"name":"Heretic's Punishment","scryfallId":"d2c9e963-bb0c-4490-8238-9476b924abf7"},{"index":38275,"token":false,"name":"Wirewood Guardian","scryfallId":"e8676b1f-e37c-4ae1-9dbe-d000369fa422"},{"index":38277,"token":false,"name":"Legion Vanguard","scryfallId":"d0ac1b48-dcfd-48a1-b999-ccc642596d28"},{"index":38278,"token":false,"name":"Sphere of Truth","scryfallId":"7c3de9f5-a05c-4341-a2c2-a1a475d400fd"},{"index":38279,"token":false,"name":"Machinate","scryfallId":"49e815b3-373c-4b2e-beb5-c894a52ffdea"},{"index":38290,"token":false,"name":"Squash","scryfallId":"e0b99299-bf84-4654-a331-e4406768b33c"},{"index":38297,"token":false,"name":"Lost Legion","scryfallId":"2d6139d3-5397-4403-9c1e-312c11a7542b"},{"index":38301,"token":false,"name":"Sage's Reverie","scryfallId":"d20c3b2d-299c-4423-9091-6f8c0c1c0661"},{"index":38303,"token":false,"name":"Stingmoggie","scryfallId":"27e0fdb4-187a-4178-a702-884bef9e029d"},{"index":38304,"token":false,"name":"Pyreheart Wolf","scryfallId":"9722f20c-e0d9-4165-8cd5-4abadc5378eb"},{"index":38308,"token":false,"name":"Heart of Bogardan","scryfallId":"4e30d025-1df9-4a08-b686-037e9cbf23a6"},{"index":38319,"token":false,"name":"Murasa Pyromancer","scryfallId":"60daf59f-ffba-403b-8028-787ff33f2d6c"},{"index":38320,"token":false,"name":"Swashbuckling","scryfallId":"01ed59b1-968b-4297-9e98-42d940f9478c"},{"index":38323,"token":false,"name":"Shield of the Oversoul","scryfallId":"54040bc6-dd7c-4933-bfac-d0d6d2c78157"},{"index":38326,"token":false,"name":"Sacred White Deer","scryfallId":"018e66db-0f79-493f-a8c7-0e005f7c5eba"},{"index":38329,"token":false,"name":"Monstrify","scryfallId":"585b52bc-aff5-4406-b55b-1b7decfd80f9"},{"index":38350,"token":false,"name":"Aven Warhawk","scryfallId":"386a7062-6da8-4663-a218-75d894f7c0e0"},{"index":38352,"token":false,"name":"Spire Owl","scryfallId":"c66b2aa6-e891-4ae5-b6c9-1537b797c3ab"},{"index":38363,"token":false,"name":"Ronom Serpent","scryfallId":"3bf81a39-0a6e-4253-81eb-a24f48253343"},{"index":38367,"token":false,"name":"Gerrard Capashen","scryfallId":"447c8c98-ac0e-4a12-a99e-f75d82b7a51f"},{"index":38373,"token":false,"name":"Blind Phantasm","scryfallId":"6b26ee7b-de1a-4a39-9580-89941c3d0f21"},{"index":38375,"token":false,"name":"Gloomwidow","scryfallId":"99bda306-1e37-4359-a649-fcd8a5a7e2fc"},{"index":38376,"token":false,"name":"Guardian Zendikon","scryfallId":"7448f2db-97f9-49fd-aa8c-bc337177dd77"},{"index":38379,"token":false,"name":"Avatar of Might","scryfallId":"eb29ae78-39ba-4249-a95f-a7c64330bc0a"},{"index":38382,"token":false,"name":"Pilfering Hawk","scryfallId":"76ee3829-8dec-4c0f-a6c2-ad47a1c94cfc"},{"index":38394,"token":false,"name":"Cellar Door","scryfallId":"97bdfb00-7773-4af6-895c-c90088a96b07"},{"index":38395,"token":false,"name":"Lurking Arynx","scryfallId":"7f59bc0b-88de-4580-bfc8-5af911d9ee99"},{"index":38398,"token":false,"name":"Ramosian Sergeant","scryfallId":"ef2b036d-5721-4a6e-bf43-69148b90da10"},{"index":38402,"token":false,"name":"Igneous Golem","scryfallId":"f44c5e24-98f9-4a4d-9ecc-c862363eb66d"},{"index":38406,"token":false,"name":"Taoist Mystic","scryfallId":"023ae64a-7888-4ad2-b879-0649d8e341ac"},{"index":38408,"token":false,"name":"Noble Benefactor","scryfallId":"244bcbc9-1b03-40f6-9690-369a582a886b"},{"index":38414,"token":false,"name":"Mongrel Pack","scryfallId":"56b84315-5287-4401-a4c8-34c192423270"},{"index":38428,"token":false,"name":"Wall of Pine Needles","scryfallId":"5d879923-55fc-46ab-9306-5e1f10441c89"},{"index":38431,"token":false,"name":"Ring of Ma'rûf","scryfallId":"fa740755-244f-4658-a9e2-aa4cf6742808"},{"index":38437,"token":false,"name":"Kitsune Dawnblade","scryfallId":"b09ab22e-aa22-4d6b-87c6-970563486f21"},{"index":38438,"token":false,"name":"Goblin Flotilla","scryfallId":"87024efe-4a74-49fe-a43a-480bed0a650a"},{"index":38444,"token":false,"name":"Trustworthy Scout","scryfallId":"8a65f118-3812-4698-8f43-669ceb6b7982"},{"index":38449,"token":false,"name":"Venser's Sliver","scryfallId":"1e3c5a64-453b-4477-853a-9514ba326f16"},{"index":38450,"token":false,"name":"Chandra, Awakened Inferno","scryfallId":"49d2a680-4f3b-4bfa-b77b-d2dfaced9f23"},{"index":38452,"token":false,"name":"Syr Carah, the Bold","scryfallId":"080a249a-df47-4769-bb63-0d8ab3f2467c"},{"index":38454,"token":false,"name":"Darksteel Gargoyle","scryfallId":"cc3218ae-376e-4f46-ad3b-b71bce0b73b1"},{"index":38460,"token":false,"name":"Sworn Companions","scryfallId":"2ccfa5c1-69f9-4351-aba3-883fe92c9b98"},{"index":38484,"token":false,"name":"Sphinx Sovereign","scryfallId":"d0fc130e-57ed-40a7-a9ba-d689e7dc3698"},{"index":38488,"token":false,"name":"Vanquish the Foul","scryfallId":"8fdcec06-e33c-4737-b81e-b156d6e3fd77"},{"index":38489,"token":false,"name":"Hired Poisoner","scryfallId":"bf97e572-90d6-46fc-81c3-956a7ef88983"},{"index":38490,"token":false,"name":"Seal of the Guildpact","scryfallId":"b5ab06e1-11ab-4fce-969b-6a9a3dccf879"},{"index":38499,"token":true,"name":"City's Blessing // Elemental Token (Colorless, 0/1)","scryfallId":"60ca146d-4e88-4e87-a775-9cfbc9e6b9f2"},{"index":38500,"token":false,"name":"Archon of Emeria","scryfallId":"530ed3d8-d176-44c8-ba54-f2536ceeb497"},{"index":38502,"token":false,"name":"Outbreak","scryfallId":"f43c30d9-23a5-4872-925d-3427f5f57995"},{"index":38508,"token":false,"name":"Doomskar Oracle","scryfallId":"6dae01c8-15bb-44ad-a2c6-9bcf7a9e8c17"},{"index":38511,"token":false,"name":"Thromok the Insatiable","scryfallId":"59d8d22b-d5e7-412e-86e6-b7cd7c71dbb5"},{"index":38516,"token":false,"name":"Eyekite","scryfallId":"49f7bda8-949a-42aa-9254-f39b791cb9a8"},{"index":38517,"token":false,"name":"Hivestone","scryfallId":"685fc2f8-4cad-46a1-b9d7-d94c13990994"},{"index":38523,"token":false,"name":"Impulsive Pilferer","scryfallId":"55ba9bea-5549-45cf-896c-501a1c81fd5a"},{"index":38525,"token":false,"name":"Sandbar Serpent","scryfallId":"b3b430ec-28e1-4b2c-bea8-3bfd3a0e8cf8"},{"index":38526,"token":false,"name":"Maelstrom Colossus","scryfallId":"322491d2-d082-4d38-8d81-8588c011e725"},{"index":38528,"token":false,"name":"Nevermaker","scryfallId":"e1fa77d1-cd61-4ef8-a71f-7c92b1f3b074"},{"index":38530,"token":false,"name":"Hobble","scryfallId":"54c76a22-f9e3-408b-a5bd-403add57e31a"},{"index":38541,"token":true,"name":"Vampires","scryfallId":"e7e01b54-ed83-4a3c-9d34-80322b3ba193"},{"index":38542,"token":false,"name":"Harpoon Sniper","scryfallId":"c10ccaef-2a75-43d6-95f2-c3690ae5c87a"},{"index":38552,"token":false,"name":"Rumbling Sentry","scryfallId":"4f93f3c9-b317-40c1-87f5-0038c09b646d"},{"index":38558,"token":false,"name":"Sphinx of the Guildpact","scryfallId":"3d30399e-2ecb-4de2-b830-673a3f059197"},{"index":38569,"token":false,"name":"Angrath's Fury","scryfallId":"708006ba-d494-4093-b108-8249b110831e"},{"index":38570,"token":false,"name":"Martial Law","scryfallId":"21078b6f-a39d-4ec8-879e-ad10d97c3ff6"},{"index":38577,"token":false,"name":"Invasive Surgery","scryfallId":"6e644e38-39bf-40bd-9be1-5eb80f472e81"},{"index":38578,"token":false,"name":"Barging Sergeant","scryfallId":"9d41f61e-8b0c-4dea-b39b-faf93c4c847f"},{"index":38579,"token":false,"name":"Heckling Fiends","scryfallId":"e9fd8895-9282-44d3-969f-b0529eb3bc07"},{"index":38593,"token":false,"name":"Egon, God of Death // Throne of Death","scryfallId":"9dfdb73d-b001-4a59-b79e-8c8c1baea116"},{"index":38596,"token":false,"name":"Aven Soulgazer","scryfallId":"5189f152-f075-4090-97dd-b7686d813865"},{"index":38597,"token":false,"name":"Marath, Will of the Wild","scryfallId":"57afa796-db46-45ff-91bd-f02922e5f33d"},{"index":38606,"token":false,"name":"Flowstone Wall","scryfallId":"89844c2f-f0a4-41c6-ad8c-d559fcaec85c"},{"index":38607,"token":false,"name":"Fodder Launch","scryfallId":"d000670f-1151-4abf-a7ec-b35a6e587183"},{"index":38609,"token":false,"name":"Caustic Hound","scryfallId":"2a54115f-150a-4ae2-a5c7-20e2ba884dd1"},{"index":38611,"token":false,"name":"Siren of the Silent Song","scryfallId":"990f4438-aa74-4460-8bac-93480d0bb0dc"},{"index":38618,"token":false,"name":"Greener Pastures","scryfallId":"55c3222e-ac18-4f57-9c9e-50deb0a69db3"},{"index":38628,"token":false,"name":"Bane of Bala Ged","scryfallId":"3741e62a-4b86-46ff-a7df-a8ceaf3b9a0c"},{"index":38632,"token":false,"name":"Maze Sentinel","scryfallId":"7a977e2d-a2bc-42d1-be7d-36a822c6a66e"},{"index":38638,"token":false,"name":"Shade's Form","scryfallId":"449baad3-9a4a-4f5f-9e9f-02cc97ab71e6"},{"index":38640,"token":false,"name":"Thresher Lizard","scryfallId":"bff0d9ba-100a-4f4a-b04b-1382ed912eaa"},{"index":38643,"token":false,"name":"Mystic Crusader","scryfallId":"27ce1baf-8a89-4884-b0f7-19311bfc8c4c"},{"index":38646,"token":false,"name":"Court of Bounty","scryfallId":"17c4205a-959d-4da8-b228-791fa1eed07a"},{"index":38650,"token":false,"name":"Nova Cleric","scryfallId":"b2048d84-b5e6-405c-9091-1997a0c4e1a5"},{"index":38652,"token":false,"name":"Grim Guardian","scryfallId":"732b5444-0410-430b-87ca-cf2d9f165bd7"},{"index":38663,"token":false,"name":"Hazoret's Undying Fury","scryfallId":"193a4aad-4c31-42dc-9a6e-c86df8e262a6"},{"index":38667,"token":false,"name":"Sky Tether","scryfallId":"39c47be3-0228-46de-b4b5-911fb86d4596"},{"index":38669,"token":false,"name":"Rin and Seri, Inseparable","scryfallId":"d605c780-a42a-4816-8fb9-63e3114a8246"},{"index":38674,"token":false,"name":"Legions of Lim-Dûl","scryfallId":"75b67eb2-b60e-46b4-9d48-11c284957bec"},{"index":38689,"token":false,"name":"Runes of the Deus","scryfallId":"0a5a84c7-c27f-49a2-8ae8-cb8e34ce0766"},{"index":38690,"token":false,"name":"Cateran Persuader","scryfallId":"a98bdbf1-32a6-4d9b-8e57-5d3aca6b05bc"},{"index":38697,"token":false,"name":"Viashino Racketeer","scryfallId":"bf4c2d22-9c36-42cc-854d-f96410bb5cf1"},{"index":38703,"token":false,"name":"Palace Guard","scryfallId":"ccaa60be-f989-4aa8-a3fb-a95143d32131"},{"index":38704,"token":false,"name":"Disciple of Deceit","scryfallId":"fbfe88fd-9bb9-42af-8134-96fd264b8405"},{"index":38705,"token":false,"name":"Singe","scryfallId":"32323277-db9a-48a7-b9a4-8e6914386e26"},{"index":38722,"token":false,"name":"Aether Charge","scryfallId":"05df2792-4971-49e8-a8f2-17700e247500"},{"index":38743,"token":false,"name":"Vision Charm","scryfallId":"78b384d3-3adf-493a-8b89-bfe68fd1c3e2"},{"index":38745,"token":false,"name":"Moment of Triumph","scryfallId":"08be8c18-eca3-4960-b174-e4a78579ed63"},{"index":38747,"token":false,"name":"Molten Frame","scryfallId":"58356504-e28e-456c-b1d3-e6232f4d78a6"},{"index":38748,"token":false,"name":"Wurmskin Forger","scryfallId":"f14f303e-371b-47dd-bbb8-7f3e44ef9af0"},{"index":38762,"token":false,"name":"Solitary Camel","scryfallId":"8adb8dbf-c83c-4169-b822-8e32aa36cffa"},{"index":38767,"token":false,"name":"Gaea's Balance","scryfallId":"f1ffc5f8-ff1c-4733-b046-8679fa16371b"},{"index":38770,"token":false,"name":"Immobilizer Eldrazi","scryfallId":"95d9c92d-8b1b-4adc-8015-d50e673b6321"},{"index":38775,"token":false,"name":"Boggart Sprite-Chaser","scryfallId":"6341b73b-a035-45a2-908d-879c8eed4bbd"},{"index":38776,"token":false,"name":"Ember-Fist Zubera","scryfallId":"0150e3f0-237e-4669-9401-d2cd08e86387"},{"index":38778,"token":false,"name":"Kolaghan's Command","scryfallId":"5277892b-ed64-4e2f-a267-d31f3599729a"},{"index":38782,"token":false,"name":"Shrine of Piercing Vision","scryfallId":"9b150924-f83c-410e-aaab-ff2d06c9d356"},{"index":38783,"token":false,"name":"Izzet Keyrune","scryfallId":"83e4e83b-cbb8-4efd-b6c4-4459a29177ac"},{"index":38786,"token":false,"name":"Oathsworn Giant","scryfallId":"2c342b0f-a8a5-4991-a0a2-fd75b54e1de2"},{"index":38795,"token":false,"name":"Second Chance","scryfallId":"62d1a0da-40b9-4e79-bace-b93f98ae4695"},{"index":38796,"token":false,"name":"Psychic Purge","scryfallId":"b1103d4d-b50a-4e2c-b18a-a181bc819881"},{"index":38798,"token":false,"name":"Blind Zealot","scryfallId":"9bd04df1-5131-455d-b497-fcce4f9af552"},{"index":38799,"token":false,"name":"Rise of the Hobgoblins","scryfallId":"53c5d47d-0c5c-4932-aaf1-df21b8b8daeb"},{"index":38803,"token":false,"name":"Chandra's Flame Wave","scryfallId":"5f13b6a7-fa62-4d94-a56c-f2e64c8c1666"},{"index":38807,"token":false,"name":"Nosy Goblin","scryfallId":"70ea023e-e66d-4049-b7bc-5e660804f088"},{"index":38812,"token":false,"name":"Sunscour","scryfallId":"44c726db-a30a-4e76-9fbf-ec6d5cd7a1ba"},{"index":38816,"token":false,"name":"Kiku's Shadow","scryfallId":"38700c7d-2f24-47e4-a899-d294daed5549"},{"index":38821,"token":false,"name":"Kjeldoran Escort","scryfallId":"70f54ca5-1f1b-40c7-ad0b-569c54d1b5aa"},{"index":38824,"token":false,"name":"Bonded Horncrest","scryfallId":"a50ad54a-73f8-4b97-b890-2be9a178bc42"},{"index":38828,"token":false,"name":"Wild Beastmaster","scryfallId":"a4d4ef98-949b-49db-b4f9-a070f8b4ff47"},{"index":38829,"token":false,"name":"Bazaar of Baghdad","scryfallId":"917e107b-13d7-4552-b3ed-b2956266c848"},{"index":38834,"token":false,"name":"Cavalry Pegasus","scryfallId":"6ea1e03e-5f6d-4e52-9538-956963c2335c"},{"index":38835,"token":false,"name":"Barbtooth Wurm","scryfallId":"e85fbc25-412a-4367-8209-258ff638dcc6"},{"index":38838,"token":false,"name":"Serene Remembrance","scryfallId":"0f3da4b8-9dd6-455d-b24a-3d0207ae5ee8"},{"index":38839,"token":false,"name":"Shifting Borders","scryfallId":"0cbe44b0-e770-41f2-b91c-c574976e6b53"},{"index":38845,"token":false,"name":"Tine Shrike","scryfallId":"845b665e-8236-4ab9-bee4-414f075461d2"},{"index":38848,"token":false,"name":"Inspiring Vantage","scryfallId":"0a335832-714c-4c38-bd5d-1703cd24f8f1"},{"index":38850,"token":false,"name":"Godhunter Octopus","scryfallId":"da106c23-fd1c-461b-9301-159f93ef489b"},{"index":38852,"token":false,"name":"Gnarled Scarhide","scryfallId":"040af9b9-1e94-4dd1-b347-b54b6b9e0275"},{"index":38855,"token":false,"name":"Wild Leotau","scryfallId":"a47bc387-ac1a-42b4-9427-fc944094b3a1"},{"index":38856,"token":false,"name":"Magosi, the Waterveil","scryfallId":"3c84cf70-4164-47ea-8da1-c0ca1ac132e1"},{"index":38857,"token":false,"name":"Glissa Sunseeker","scryfallId":"670c3106-71fc-464e-8c94-81bf7fafc3e6"},{"index":38861,"token":true,"name":"Human Rogue Token (R/W, 1/2)","scryfallId":"cd3ca6d5-4b2c-46d4-95f3-f0f2fa47f447"},{"index":38865,"token":false,"name":"Mu Yanling","scryfallId":"06918f9a-e0fa-4a3d-aed9-3bee98f7a2b9"},{"index":38866,"token":false,"name":"Court of Cunning","scryfallId":"e60d3606-6f90-43b4-b056-543f7245958f"},{"index":38869,"token":false,"name":"Cabal Executioner","scryfallId":"cd7727a7-0cdf-4fd5-82b4-e6587c10ca80"},{"index":38873,"token":false,"name":"Viridescent Wisps","scryfallId":"6c33871f-0e6a-4616-b484-e79b1945255f"},{"index":38878,"token":false,"name":"Consulate Surveillance","scryfallId":"72c92238-7765-48ee-a799-9e8b68ec118d"},{"index":38880,"token":false,"name":"Curio Vendor","scryfallId":"dadeaf38-901b-49ce-a989-57cbd4216d83"},{"index":38889,"token":false,"name":"Shredding Winds","scryfallId":"33f36143-85b6-412c-8c79-053728b45c25"},{"index":38897,"token":false,"name":"Halana, Kessig Ranger","scryfallId":"6bee6eb2-2708-4596-86ad-40eea88dbb6b"},{"index":38906,"token":false,"name":"Infernal Genesis","scryfallId":"1a63d16e-319d-46f4-a28c-895b36605ee6"},{"index":38915,"token":false,"name":"Ward of Lights","scryfallId":"6d389daf-c7d8-4bd1-b4ea-5082f5d280c0"},{"index":38921,"token":false,"name":"Electrickery","scryfallId":"61710c6a-b3d1-46ae-8aec-e7f8e56b135e"},{"index":38923,"token":false,"name":"Song of the Dryads","scryfallId":"0ccb4579-b090-45f6-a967-cec2c195f565"},{"index":38930,"token":false,"name":"Marsh Boa","scryfallId":"87c99bb6-a483-4beb-b98c-eb641fe3d50a"},{"index":38931,"token":false,"name":"Storm Caller","scryfallId":"1b6d123c-c16d-43fa-b183-8a59c7e1a11e"},{"index":38938,"token":false,"name":"Fault Line","scryfallId":"cab4fd0e-9f84-4628-92a7-858ad8064531"},{"index":38946,"token":false,"name":"General's Kabuto","scryfallId":"1382c339-256f-4ba1-a4cc-6307d0859964"},{"index":38949,"token":false,"name":"Loxodon Restorer","scryfallId":"1ead2166-a7ca-49cb-bf93-2f59c37b4cb9"},{"index":38950,"token":false,"name":"Bloodcrazed Hoplite","scryfallId":"f2a6556b-a4f1-4ff5-8e6e-a47618c8c66e"},{"index":38956,"token":false,"name":"Springmane Cervin","scryfallId":"f5b0eac4-0262-4eed-97d4-0f2e6f06c8e1"},{"index":38961,"token":false,"name":"Priests of Norn","scryfallId":"a978c49d-483a-42fe-971c-858288d07e40"},{"index":38963,"token":false,"name":"Caprichrome","scryfallId":"e8c71a1f-191b-45f6-bb34-fba3e981a711"},{"index":38966,"token":false,"name":"Arrow Storm","scryfallId":"5da95bed-c1e5-4ef3-965b-ed29180f6cc8"},{"index":38967,"token":false,"name":"Hedron Crab","scryfallId":"4d804aad-ccf5-4605-9076-9000f8f9538a"},{"index":38985,"token":false,"name":"Seeker of Insight","scryfallId":"d187686c-08ca-40d4-aaac-e0ba5b11a0ad"},{"index":39001,"token":false,"name":"Assembly-Worker","scryfallId":"f352a6a0-9eb8-4b8c-bedf-0eb75c29ca9e"},{"index":39004,"token":false,"name":"Boon of Erebos","scryfallId":"4371083b-c300-4464-a7ea-6168db4e345c"},{"index":39007,"token":false,"name":"Primoc Escapee","scryfallId":"e6cb3e72-bb64-4b1e-a54b-1fe4fb4ad4c9"},{"index":39010,"token":false,"name":"Simic Ragworm","scryfallId":"fa1f4b84-dd5d-4f5f-808e-26ef9414b38a"},{"index":39011,"token":false,"name":"Tel-Jilad Chosen","scryfallId":"eefea84f-d657-491d-b60d-63e6a61e9eb2"},{"index":39013,"token":false,"name":"Lightbringer","scryfallId":"19451993-7a53-4a50-bfca-ddc9cdfbe168"},{"index":39022,"token":false,"name":"Raptor Hatchling","scryfallId":"8093e88d-fd3c-43d3-a025-9ebb9f02a84f"},{"index":39023,"token":false,"name":"Rush of Battle","scryfallId":"0d47d8aa-59c8-4e2c-bb48-328ae924dbb3"},{"index":39025,"token":false,"name":"Fervent Charge","scryfallId":"d610a9d5-c650-45ad-a9b0-b55113701e05"},{"index":39026,"token":false,"name":"Amoeboid Changeling","scryfallId":"068518d2-f061-4061-b208-158e991156b6"},{"index":39032,"token":false,"name":"Herald of Torment","scryfallId":"6bb7e5ab-57d7-4a86-b7c2-262932ac3344"},{"index":39035,"token":false,"name":"Samite Sanctuary","scryfallId":"022ebeba-b61a-497a-a698-e75b130c468c"},{"index":39036,"token":false,"name":"Perish the Thought","scryfallId":"4e1dd413-6e5a-4e36-b1b0-eca39e132e38"},{"index":39040,"token":false,"name":"Intrusive Packbeast","scryfallId":"54aa25ea-7903-48d7-9c3f-412f54753fce"},{"index":39050,"token":false,"name":"Silverwing Squadron","scryfallId":"4348513e-4a03-4e06-98e0-ac6c0dfb013d"},{"index":39052,"token":false,"name":"Mutilate","scryfallId":"6189cab3-1963-4590-9cbc-7ab4a693d7c6"},{"index":39059,"token":false,"name":"Klothys's Design","scryfallId":"b1b6b7a7-0ac8-470a-949b-4779ded95359"},{"index":39062,"token":false,"name":"Healer of the Pride","scryfallId":"35716e37-1bb2-41e2-bb55-e65126b01ce3"},{"index":39063,"token":false,"name":"Slayer of the Wicked","scryfallId":"1c2cd68e-ff4c-49c7-ba0d-f2299d9c21f4"},{"index":39066,"token":false,"name":"Servant of Nefarox","scryfallId":"e00a2b22-a473-44ae-919f-29bc8be05543"},{"index":39068,"token":false,"name":"Mockery of Nature","scryfallId":"3118737f-2fd9-4fe5-bd0f-43c9ef2166e2"},{"index":39076,"token":false,"name":"Setessan Oathsworn","scryfallId":"e5579755-4718-406a-bba6-27f1f2811e59"},{"index":39080,"token":false,"name":"Secrets of the Golden City","scryfallId":"2a08f978-380c-4443-bbb8-3eb8ad2f513a"},{"index":39083,"token":false,"name":"Rix Maadi Guildmage","scryfallId":"eb737465-5de8-4015-befe-2bf386da2a89"},{"index":39085,"token":false,"name":"Dread Wight","scryfallId":"65d332e2-4b2d-4131-84f7-862cb138c477"},{"index":39091,"token":false,"name":"Llawan, Cephalid Empress","scryfallId":"a9821970-a5da-4045-93d8-f58c9e5797c1"},{"index":39099,"token":false,"name":"Gideon's Triumph","scryfallId":"d6610c6a-717f-406e-a49d-b6e548880946"},{"index":39100,"token":false,"name":"Vastwood Surge","scryfallId":"6974363c-0d0d-4270-a25e-ab84b0c03f4e"},{"index":39113,"token":false,"name":"Call to Serve","scryfallId":"ce4a3e80-6e95-4346-8ab8-eecc1a09ca24"},{"index":39120,"token":false,"name":"Rhythm of the Wild","scryfallId":"84062ce2-fea2-4e06-b83b-7cc597fb2a1b"},{"index":39121,"token":false,"name":"Sarkhan, Dragonsoul","scryfallId":"59715c84-8eed-41ad-aaf9-cfcce4445254"},{"index":39125,"token":false,"name":"Cache Raiders","scryfallId":"bb75ec92-7c8e-47d3-a412-01d0c98321fe"},{"index":39129,"token":false,"name":"Pixie Queen","scryfallId":"b9527c2a-23bb-4d33-9e72-6e0ab3de0e6b"},{"index":39130,"token":false,"name":"Lush Growth","scryfallId":"d62047f2-a41f-44b5-a6bc-28e35fad093b"},{"index":39132,"token":false,"name":"Drelnoch","scryfallId":"954a1e9c-ed2f-4774-b2b7-166052a5c59a"},{"index":39136,"token":false,"name":"Golden Egg","scryfallId":"525142c3-f17c-4e02-a02d-fa385215aa12"},{"index":39148,"token":false,"name":"Terra Eternal","scryfallId":"9bad0759-4132-42b5-9a26-0fcf321a60e0"},{"index":39155,"token":false,"name":"Moment's Peace","scryfallId":"70d1977c-edaf-4085-bc42-0e2b041b9b77"},{"index":39157,"token":false,"name":"Corpse Churn","scryfallId":"6b7e6054-c6b8-4b29-83c5-a2e4e295bdf3"},{"index":39158,"token":false,"name":"Keldon Twilight","scryfallId":"e071665e-bb72-42e0-a42d-0d0ff02abd2b"},{"index":39162,"token":false,"name":"Sea God's Revenge","scryfallId":"5acdf4e4-5933-43dc-bf8b-25f89415db5b"},{"index":39165,"token":false,"name":"Font of Vigor","scryfallId":"d4ef3a8e-ef8b-417a-a3a9-cb0ce88cb0c9"},{"index":39171,"token":false,"name":"Rejuvenation Chamber","scryfallId":"b97f86ce-4758-4ae3-af29-b08a4d771652"},{"index":39172,"token":false,"name":"Encroach","scryfallId":"fbd48dac-0a1a-49c4-8daf-11972b990454"},{"index":39173,"token":false,"name":"Mummy Paramount","scryfallId":"e8b1a3e5-cf77-439d-8e0d-cf6571f6891c"},{"index":39181,"token":false,"name":"Imperial Edict","scryfallId":"c5a7f91d-b4ee-45c1-a229-bb23daf68e6b"},{"index":39184,"token":false,"name":"Pouncing Lynx","scryfallId":"9383956f-90bc-40e4-ae5c-503e98e21832"},{"index":39186,"token":false,"name":"Taigam's Scheming","scryfallId":"87f4b533-7113-4b36-9c7a-e4cf798c88a9"},{"index":39205,"token":false,"name":"Braid of Fire","scryfallId":"41bab8de-6e0f-4ccd-a303-01e9c8c82d3f"},{"index":39208,"token":false,"name":"Historian of Zhalfir","scryfallId":"ae981da0-f32c-49d5-bcb0-2b9255a4e1fe"},{"index":39213,"token":false,"name":"Clip Wings","scryfallId":"de33b639-5a01-44c5-bb80-94f52b8edcf5"},{"index":39215,"token":false,"name":"Mind Harness","scryfallId":"5bf17780-801d-4ab8-91f4-a803ede51395"},{"index":39216,"token":false,"name":"Campaign of Vengeance","scryfallId":"c284997a-cfc3-4ffc-bc25-00c130fb1eb0"},{"index":39217,"token":false,"name":"Dragon Arch","scryfallId":"eec581b8-e509-420c-b142-afaa6dd06cc8"},{"index":39221,"token":false,"name":"Lash of Thorns","scryfallId":"ea45e972-6e4a-4854-9be3-6ffb24e7d7a5"},{"index":39229,"token":false,"name":"Kragma Warcaller","scryfallId":"78791fc6-054f-45eb-b8b0-28f2512d72b6"},{"index":39233,"token":false,"name":"Deluge","scryfallId":"baf37153-ec4c-4c2f-89f7-450f0a157311"},{"index":39235,"token":false,"name":"Moriok Replica","scryfallId":"480311ae-b9af-4fb7-881b-35566598cf07"},{"index":39237,"token":false,"name":"Rebel Informer","scryfallId":"c98a71a8-291f-4d94-ada0-5f50f354cca7"},{"index":39238,"token":true,"name":"Gremlin // Energy Reserve Token (R, 2/2)","scryfallId":"d67c7d80-05c9-4bd3-9a8e-14dfe4c075cd"},{"index":39245,"token":false,"name":"Winter's Rest","scryfallId":"1fdaf6b6-aca7-49e5-a4da-bf8c08b4a055"},{"index":39246,"token":false,"name":"Skeleton Key","scryfallId":"3168317b-b166-483e-9d9a-20cdfcdc255c"},{"index":39247,"token":false,"name":"Disempower","scryfallId":"3a86a2ae-aaf3-4d4d-ae06-ec3d4a539550"},{"index":39249,"token":false,"name":"Grimoire Thief","scryfallId":"59c4dceb-6889-4a79-87c2-98952f3478bb"},{"index":39252,"token":true,"name":"Tom van de Logt Bio (2000)","scryfallId":"4330efa7-a11b-4776-9fb0-1cae8aed67b1"},{"index":39253,"token":false,"name":"Everglove Courier","scryfallId":"13bf5786-e41a-4839-b8a0-5c7a413b23d0"},{"index":39256,"token":false,"name":"Sakiko, Mother of Summer","scryfallId":"774ec405-5127-4475-8c74-b8858bd84379"},{"index":39262,"token":false,"name":"Cliffrunner Behemoth","scryfallId":"764c1a14-143f-4601-92c5-ebeabf3e375d"},{"index":39267,"token":false,"name":"Wind Zendikon","scryfallId":"bbaae63e-6269-4aca-aa45-956f6bf4e112"},{"index":39274,"token":false,"name":"Mindbreak Trap","scryfallId":"4f51140b-6254-431a-8810-94307bfdfbbe"},{"index":39283,"token":false,"name":"Compelling Deterrence","scryfallId":"d89de92b-2890-42f5-a7cf-72c67e3b70c2"},{"index":39287,"token":false,"name":"Orzhov Racketeers","scryfallId":"29b89f68-72ba-493d-95c4-eb37751fbd3d"},{"index":39291,"token":true,"name":"Seismic","scryfallId":"32da965c-6499-41e4-b16d-754e89cc8aa7"},{"index":39293,"token":false,"name":"Corrupted Conscience","scryfallId":"5d8a8278-0791-4ff2-95b8-71b94298e503"},{"index":39298,"token":false,"name":"Mysteries of the Deep","scryfallId":"1907b1e9-ae1e-43fb-9033-3c4322277fff"},{"index":39301,"token":false,"name":"Mistform Mask","scryfallId":"7fbbb075-5795-425f-9e33-70cb922eea16"},{"index":39306,"token":false,"name":"Violent Outburst","scryfallId":"1b58856a-f88e-4625-8636-62b5c717b956"},{"index":39307,"token":false,"name":"Greenside Watcher","scryfallId":"e825cb2d-98d7-423d-9ba1-b4d04027027e"},{"index":39308,"token":false,"name":"Woodland Wanderer","scryfallId":"29f61e3d-613e-4f3e-a032-974942efc1ba"},{"index":39318,"token":false,"name":"Phyrexian Marauder","scryfallId":"29a75dc8-1c24-4063-8944-d7e71b4a5755"},{"index":39321,"token":false,"name":"Witness of Tomorrows","scryfallId":"64cd9d60-826c-4b35-9684-dccb0880399e"},{"index":39325,"token":false,"name":"Mausoleum Turnkey","scryfallId":"cfe2e536-cd2e-443a-95e5-357c9158a208"},{"index":39326,"token":false,"name":"Fresh-Faced Recruit","scryfallId":"a8b19518-7752-4673-a7d8-ae2e0070129c"},{"index":39330,"token":false,"name":"Jace's Ruse","scryfallId":"03e8d2c7-cd6e-48bf-9d54-73f3d6cff0aa"},{"index":39332,"token":false,"name":"Timber Protector","scryfallId":"14b93784-cbe5-437a-8235-f6864e413b41"},{"index":39333,"token":false,"name":"Remove Enchantments","scryfallId":"bf2e3a8a-b386-474d-b8e9-4c2d56a2b742"},{"index":39338,"token":false,"name":"Kongming's Contraptions","scryfallId":"6729eb0b-5655-4191-af14-4f7e4a8dded7"},{"index":39343,"token":false,"name":"Treefolk Umbra","scryfallId":"677166cf-4e1e-43ac-a67b-afaf33c0d14e"},{"index":39346,"token":false,"name":"Ghastly Discovery","scryfallId":"9dbd510a-d71f-4b0c-bc6c-e403f632cbdb"},{"index":39347,"token":false,"name":"Craterize","scryfallId":"e5459409-5103-4a97-a6fb-3e3ab896eb66"},{"index":39351,"token":false,"name":"Corrosive Mentor","scryfallId":"140457ff-ee7d-48ec-8b91-ef5c2cc1ed74"},{"index":39353,"token":false,"name":"Masked Blackguard","scryfallId":"d61b4b71-3cbb-4422-8ce7-657ca3bb6a82"},{"index":39358,"token":false,"name":"Illusionary Informant","scryfallId":"766150d9-c795-4675-a849-a388e8ae148d"},{"index":39363,"token":false,"name":"Early Frost","scryfallId":"5989d4c4-bfa4-4b07-ab64-65a3aee6144e"},{"index":39373,"token":false,"name":"Wall of Glare","scryfallId":"5f159193-fcf8-437c-b14a-06718a446a5c"},{"index":39377,"token":false,"name":"Claws of Wirewood","scryfallId":"0a6f8a21-5946-455b-83ec-ba211c7d19bf"},{"index":39380,"token":false,"name":"Cabal Slaver","scryfallId":"b9c04fd3-021a-4011-be9b-0d268557aa06"},{"index":39384,"token":false,"name":"Synchronized Spellcraft","scryfallId":"d87f4637-1ad3-4d61-98ff-98c0b0be46a1"},{"index":39385,"token":false,"name":"Miscalculation","scryfallId":"4b4956a2-9a39-4152-9c98-70e4b2acfa26"},{"index":39387,"token":false,"name":"Viashino Runner","scryfallId":"15bf72e0-0b0c-4b29-8709-9dcd460508cb"},{"index":39392,"token":false,"name":"Throne of the High City","scryfallId":"22766d81-21ca-429a-b2e2-fdb338a33aa4"},{"index":39399,"token":false,"name":"Frenetic Efreet","scryfallId":"50d4468b-f7de-44fe-898a-4125d26d242f"},{"index":39402,"token":false,"name":"Rushwood Elemental","scryfallId":"52128694-d9f5-4acb-b684-bb02a4e766b8"},{"index":39405,"token":false,"name":"Brawl-Bash Ogre","scryfallId":"38b9f9d7-a00d-4a90-9d7a-88ece10af328"},{"index":39406,"token":false,"name":"Executioner's Swing","scryfallId":"2122586d-9b23-47c2-8b00-e673aa0310f0"},{"index":39411,"token":false,"name":"Slimebind","scryfallId":"b6263410-20c5-43b4-8183-3c02c10d07fb"},{"index":39413,"token":false,"name":"Blitz Hellion","scryfallId":"0b4a16be-ab3b-4020-9f26-631c0ee6730a"},{"index":39414,"token":false,"name":"Rain of Rust","scryfallId":"13a6ecc6-83c8-408b-8600-687cdb383ca9"},{"index":39415,"token":false,"name":"Cover of Winter","scryfallId":"91d9bb89-d8f8-4dff-8b94-3f7b8aa8f299"},{"index":39418,"token":false,"name":"Wellspring","scryfallId":"c69ba095-dd78-4999-87a9-63f7165846e4"},{"index":39422,"token":false,"name":"Stalking Yeti","scryfallId":"4af53d0b-ac60-4519-a6f4-c67899bcfdd6"},{"index":39424,"token":false,"name":"Groundshaker Sliver","scryfallId":"712f0ce4-9189-4c75-9c2b-d370bce89052"},{"index":39426,"token":false,"name":"Azure Fleet Admiral","scryfallId":"c0889e22-deab-48ba-bbd6-f0d49bee5d9c"},{"index":39428,"token":false,"name":"Grim Flowering","scryfallId":"e5f3e2ad-7a04-4735-ba73-576e32249ba3"},{"index":39431,"token":false,"name":"Ramses Overdark","scryfallId":"f079c74e-a39a-40f9-9c7e-9319c0c189c6"},{"index":39433,"token":false,"name":"Sage of the Falls","scryfallId":"274e3aa4-4b46-4daa-a7a8-400a20c59435"},{"index":39440,"token":false,"name":"Calculating Lich","scryfallId":"17b2ed72-d0f0-4d8d-bb5e-dce08d157466"},{"index":39442,"token":false,"name":"Starlit Mantle","scryfallId":"68c53625-6928-494a-af87-7eee2f6643a5"},{"index":39448,"token":false,"name":"Hardened-Scale Armor","scryfallId":"708e7438-b449-490e-820f-9ecd3199541b"},{"index":39450,"token":false,"name":"Strength of Night","scryfallId":"87aab031-4e44-44cd-89a7-6cffc7288cd1"},{"index":39453,"token":false,"name":"Order of Succession","scryfallId":"11f68867-a46c-447f-9061-2bc4dbdde206"},{"index":39454,"token":false,"name":"Mistcutter Hydra","scryfallId":"3c844ed7-8ed2-4a39-9134-e14e476ab0c4"},{"index":39455,"token":false,"name":"Nylea's Presence","scryfallId":"e68f1fd4-1a2f-405b-a592-6c4af6214eae"},{"index":39460,"token":false,"name":"Contract Killing","scryfallId":"d1f20feb-b1ed-4d80-bef9-f3cc44ffb7b0"},{"index":39461,"token":false,"name":"Prava of the Steel Legion","scryfallId":"23c33648-fb0e-4460-aae6-f3793d86e689"},{"index":39462,"token":false,"name":"Koskun Falls","scryfallId":"04292a4e-8910-4911-a76d-4f2c3e15da33"},{"index":39467,"token":false,"name":"Blood Beckoning","scryfallId":"0cb88075-14f8-4ac9-b947-5ca1d30938f1"},{"index":39470,"token":false,"name":"Faerie Formation","scryfallId":"15709316-7382-46b9-9b70-53a5147e7051"},{"index":39473,"token":false,"name":"Slaughter the Strong","scryfallId":"4217ab21-181e-4c32-97c3-d8bd441287e0"},{"index":39476,"token":true,"name":"Beast // Beast Token (G, 3/3)","scryfallId":"610def80-1303-488e-bfd9-4a27f031d20e"},{"index":39481,"token":false,"name":"Crawling Sensation","scryfallId":"7f6d5abe-22b5-4ef1-ad74-af3e75e22a07"},{"index":39482,"token":false,"name":"K'rrik, Son of Yawgmoth","scryfallId":"3592fbe4-8588-486e-99ba-c327b0b6ba24"},{"index":39487,"token":false,"name":"Chart a Course","scryfallId":"98f091ee-70c5-4878-9b11-43df85e1d5de"},{"index":39488,"token":false,"name":"Nature's Chant","scryfallId":"9a17cbf6-3f38-4bc6-8448-881e19cffe06"},{"index":39493,"token":false,"name":"Sacred Nectar","scryfallId":"f298a56d-8a33-46b1-aca0-acb68cdb3e29"},{"index":39498,"token":false,"name":"Heedless One","scryfallId":"16f8f90e-3fd6-40b8-a49d-358221d1a7b7"},{"index":39504,"token":false,"name":"Flint Golem","scryfallId":"0e62aa7e-d9f9-42d4-9eed-5f51f88047c6"},{"index":39512,"token":false,"name":"Profane Transfusion","scryfallId":"c04d8edb-7350-4ab5-b721-390784c66329"},{"index":39518,"token":false,"name":"Hidden Spider","scryfallId":"ab2640cb-7d0b-40e5-9624-02c64b2f9830"},{"index":39520,"token":false,"name":"Hour of Need","scryfallId":"737b859d-d81e-4da3-a8bf-9a8f23c75a50"},{"index":39521,"token":false,"name":"Stormchaser Chimera","scryfallId":"1fd9c037-64d0-4d33-b06f-4d51b1c32b1a"},{"index":39522,"token":false,"name":"Vine Gecko","scryfallId":"7a6f9984-dec7-4a1f-91d6-1e85b5df5e4c"},{"index":39525,"token":false,"name":"Coursers' Accord","scryfallId":"f027ceb0-5d2b-4cf6-87ad-e6b9b1e20634"},{"index":39531,"token":false,"name":"Ardenvale Paladin","scryfallId":"a32fa360-6c41-4146-931b-c19e9a766803"},{"index":39532,"token":false,"name":"Tezzeret's Betrayal","scryfallId":"9d71efa6-5de8-476f-86ce-0790956e574f"},{"index":39533,"token":false,"name":"Knight of Grace","scryfallId":"7bbbddc0-f8b3-4255-bd82-d50f829ca009"},{"index":39534,"token":false,"name":"Batterhorn","scryfallId":"a7b40f74-893f-4bfc-87b2-7f8df4c912d8"},{"index":39537,"token":false,"name":"In Bolas's Clutches","scryfallId":"d72bf6b4-ac70-4be0-86de-cb3c47244dbc"},{"index":39542,"token":false,"name":"Extra Arms","scryfallId":"28efa11c-6aeb-4c22-bbb3-b41f26d65c65"},{"index":39546,"token":false,"name":"Blue Scarab","scryfallId":"b423bb5a-eaac-4c1d-981a-1c635001fc5a"},{"index":39547,"token":false,"name":"Temporal Aperture","scryfallId":"5b5c2555-c707-4814-933a-c275b9ebc0a3"},{"index":39556,"token":false,"name":"Brass Squire","scryfallId":"37928b90-ab31-4c73-99b2-fe31feb2afea"},{"index":39557,"token":false,"name":"Cinder Hellion","scryfallId":"7f111537-e1b1-4408-ae5d-8bc06c408824"},{"index":39558,"token":false,"name":"Eyes Everywhere","scryfallId":"1fdbf073-3ee6-402b-bd40-4781f40a6cae"},{"index":39566,"token":false,"name":"Neurok Invisimancer","scryfallId":"e88f78f4-77d8-4c3e-a5bf-a9dd902aaae1"},{"index":39569,"token":false,"name":"Junkyo Bell","scryfallId":"7bd002c7-21ec-4f77-81be-2788fa267f21"},{"index":39576,"token":false,"name":"Breezekeeper","scryfallId":"beaefa77-6e4a-4724-a443-fa6b45803db5"},{"index":39579,"token":false,"name":"Sigiled Behemoth","scryfallId":"e0195ee6-c5d9-402e-8339-2caa50c4e46b"},{"index":39590,"token":false,"name":"Grave Betrayal","scryfallId":"47b38c68-8e72-4afc-bb5e-0b40880fdda9"},{"index":39593,"token":false,"name":"Devour in Shadow","scryfallId":"98c80584-b7b5-4dcd-8a00-812b9dd9b1b9"},{"index":39601,"token":true,"name":"Jakub Šlemr Decklist (1999)","scryfallId":"071cda12-a2d4-447f-8382-22870b6dc5cf"},{"index":39602,"token":false,"name":"Subterranean Hangar","scryfallId":"edc199d1-970b-489f-b713-8285151f16ae"},{"index":39625,"token":false,"name":"Citadel of Pain","scryfallId":"66585109-77cb-42f1-9c14-3dac1d493b71"},{"index":39629,"token":false,"name":"Slayer's Plate","scryfallId":"c0810651-0301-46d4-b9d7-c2283ef4031a"},{"index":39630,"token":false,"name":"Zodiac Pig","scryfallId":"dde66aab-b087-4cb7-8bc3-c9080cac4ee6"},{"index":39636,"token":true,"name":"Pegasus Token (W, 2/2)","scryfallId":"dee1c2ee-d92e-409a-995a-b4c91620c918"},{"index":39637,"token":false,"name":"Ichneumon Druid","scryfallId":"cf2313bb-6f9b-49d6-b069-9f3b77b6e107"},{"index":39641,"token":false,"name":"Port of Karfell","scryfallId":"bb9465a6-d009-4ecd-9fd1-d046547de902"},{"index":39645,"token":false,"name":"Steelgaze Griffin","scryfallId":"6d361328-8b0a-40a0-b5c0-215398fdfb47"},{"index":39648,"token":false,"name":"Galecaster Colossus","scryfallId":"fcf52748-a7cc-467a-ad7c-a049dd401397"},{"index":39653,"token":false,"name":"Demon of Death's Gate","scryfallId":"57fab4fc-c8de-47ef-a717-3adb58c2f5b6"},{"index":39655,"token":false,"name":"Blazethorn Scarecrow","scryfallId":"44793043-82b4-415b-a9ab-d564fdbcd314"},{"index":39657,"token":false,"name":"Enatu Golem","scryfallId":"74b2e63d-61c6-46e4-9a6f-56653c49b2ea"},{"index":39658,"token":false,"name":"Guardian of the Ages","scryfallId":"c825c138-97de-44b9-8aec-70608ae035b6"},{"index":39659,"token":false,"name":"Caller of the Hunt","scryfallId":"c0e8e1cf-0a47-4ce4-889a-091229d0e466"},{"index":39662,"token":false,"name":"Alter Reality","scryfallId":"64cd68be-6e6a-4577-8465-a892463b6d6c"},{"index":39665,"token":false,"name":"Blur Sliver","scryfallId":"63227937-86cc-45e0-9e9e-8c7ab80cbaef"},{"index":39669,"token":false,"name":"Ebon Praetor","scryfallId":"40451f7a-692a-422d-99d3-d93a4d9315e0"},{"index":39672,"token":false,"name":"Liberate","scryfallId":"96794470-31ea-478f-b11c-dc8342a508e2"},{"index":39674,"token":false,"name":"Mob Justice","scryfallId":"b790d789-bb21-4119-a0e3-43af9bef8acc"},{"index":39676,"token":false,"name":"Dreamstalker Manticore","scryfallId":"ee10eaa0-dbe0-45ee-9a7d-395ec5d27e08"},{"index":39685,"token":false,"name":"Windreaper Falcon","scryfallId":"65285030-0714-43bf-bb91-a79dcba1ccc5"},{"index":39688,"token":false,"name":"Molderhulk","scryfallId":"ba88e031-b194-4621-9e97-2f33ee46f6d0"},{"index":39691,"token":false,"name":"Heron's Grace Champion","scryfallId":"d15d3511-4297-414e-870e-1334ea7fcce0"},{"index":39696,"token":false,"name":"Betrothed of Fire","scryfallId":"5e517aa4-d8ba-4a49-bf9f-172bf029fa52"},{"index":39704,"token":false,"name":"Redeem the Lost","scryfallId":"6a0f1aa1-b5be-43f0-822d-c4fcf33270d9"},{"index":39712,"token":false,"name":"Stinging Lionfish","scryfallId":"0162a0b8-a2d1-4664-a445-331aee6d5175"},{"index":39720,"token":false,"name":"Restless Dreams","scryfallId":"63795680-5310-4c99-92c1-70e453391de9"},{"index":39725,"token":false,"name":"Auriok Bladewarden","scryfallId":"51605471-1198-4296-a9b5-3bee14ac2091"},{"index":39727,"token":false,"name":"Explosive Growth","scryfallId":"eabc1e77-404c-436b-bde1-be1b21d00584"},{"index":39731,"token":false,"name":"Dromoka Captain","scryfallId":"2d11837c-613f-4e36-b5dd-99baf8b38532"},{"index":39734,"token":false,"name":"Feral Contest","scryfallId":"215115fa-50a6-42c0-b3c6-8d18e7f65174"},{"index":39736,"token":false,"name":"Draugr Thought-Thief","scryfallId":"31da60a2-d4d3-4954-be59-c7ff61fa2905"},{"index":39740,"token":false,"name":"Consuming Vortex","scryfallId":"493ee99c-74ca-4d78-ade2-c6a93b0bd4fd"},{"index":39741,"token":false,"name":"Fathom Fleet Boarder","scryfallId":"f447eb83-c805-4ba8-b9f2-0add092f6795"},{"index":39745,"token":false,"name":"Abandon Hope","scryfallId":"942cf220-472c-48f6-8f60-993939ea5ab8"},{"index":39746,"token":false,"name":"Dwynen's Elite","scryfallId":"c203722b-3f16-4b6c-9b2e-18169d3f80c9"},{"index":39749,"token":false,"name":"Tel-Jilad Lifebreather","scryfallId":"ee58a5ef-68ec-48cf-bb7e-73bcbe86cc3c"},{"index":39751,"token":false,"name":"Counterlash","scryfallId":"d3ec2c57-8e67-472d-8f2e-0492d311f130"},{"index":39752,"token":false,"name":"Drakewing Krasis","scryfallId":"016d1d17-ba5c-4168-9a3d-232bdcc98c80"},{"index":39753,"token":false,"name":"Vaporkin","scryfallId":"2c074399-36e9-41f7-918e-5fae267e9da2"},{"index":39759,"token":false,"name":"Turn into a Pumpkin","scryfallId":"f2a37dcb-4a18-4f03-b28c-27188a1a5ec1"},{"index":39763,"token":false,"name":"Nullhide Ferox","scryfallId":"24c30bb0-06ba-432b-a20c-6fa79b0dc68a"},{"index":39768,"token":false,"name":"Enslaved Horror","scryfallId":"dffca723-360d-48de-a0a8-32288627f3df"},{"index":39769,"token":false,"name":"Last Thoughts","scryfallId":"c6033d07-124c-4001-81e1-c6eb99e07fdd"},{"index":39770,"token":false,"name":"Reckless Air Strike","scryfallId":"68391b41-4a17-4450-a8ac-0ce8406fe8c1"},{"index":39773,"token":false,"name":"Queen's Bay Soldier","scryfallId":"ce2ca2e6-f920-4529-88d2-d984bdb7490a"},{"index":39775,"token":false,"name":"Kangee, Aerie Keeper","scryfallId":"3afd7e8e-4fcc-4003-9791-7baf10ef1880"},{"index":39780,"token":false,"name":"Takenuma Bleeder","scryfallId":"bfa3d318-83ff-41db-b33a-e4f5b7cd7a77"},{"index":39790,"token":false,"name":"Carbonize","scryfallId":"d4b4767b-edd1-4e36-b363-52114a9afe5e"},{"index":39791,"token":false,"name":"Treeshaker Chimera","scryfallId":"456627ec-81a4-40db-91dc-d25a59cd2837"},{"index":39793,"token":false,"name":"Revival // Revenge","scryfallId":"50ae0831-f3ba-4535-bfb6-feefbbc15275"},{"index":39798,"token":false,"name":"Eternal Scourge","scryfallId":"13ce52f5-6d49-4d44-a3d7-925340de8406"},{"index":39799,"token":false,"name":"Underworld Rage-Hound","scryfallId":"a04eef82-fd53-41f4-9c7e-28b9ac039032"},{"index":39804,"token":false,"name":"Dogged Hunter","scryfallId":"b50d4337-9b71-429b-b6bc-2d70299a6e76"},{"index":39805,"token":false,"name":"Seasoned Tactician","scryfallId":"f8be4b6b-23a2-42d2-911d-fa14f7f5a95b"},{"index":39809,"token":false,"name":"Havoc Devils","scryfallId":"2f003678-0f17-4f1d-87d5-83613a82044b"},{"index":39811,"token":false,"name":"Tome Anima","scryfallId":"0360d27b-37e1-4e00-9cfc-b574efc38ea0"},{"index":39812,"token":false,"name":"Molten Blast","scryfallId":"bb1beef2-788b-469b-883b-cf1cca04eeff"},{"index":39823,"token":false,"name":"Soul Salvage","scryfallId":"db574719-746a-433e-a5be-06d232a01021"},{"index":39828,"token":false,"name":"Cold-Water Snapper","scryfallId":"cf339549-4325-40c6-adde-0cd31bb738e0"},{"index":39835,"token":false,"name":"Insatiable Appetite","scryfallId":"2357f2db-00c2-41f6-bd04-93f905dea461"},{"index":39845,"token":true,"name":"Nightmare Horror Token (B, */*)","scryfallId":"4d33b752-c806-4932-ae0a-46f00ed937de"},{"index":39847,"token":false,"name":"Unified Will","scryfallId":"6cb50db7-f1d4-4f9d-ac60-564398af79ea"},{"index":39852,"token":false,"name":"Ulvenwald Bear","scryfallId":"9e3837a7-854a-440d-93d7-d36f50149346"},{"index":39859,"token":false,"name":"Crook of Condemnation","scryfallId":"78f6d7c2-ee4f-4cd0-a9a2-d8469ff89291"},{"index":39863,"token":false,"name":"Rot Farm Skeleton","scryfallId":"ef5af2dd-75c7-402c-be9a-3d0d4290520c"},{"index":39876,"token":false,"name":"Elspeth, Undaunted Hero","scryfallId":"bf9867e5-9d69-400c-a84f-3b085a4fd510"},{"index":39880,"token":false,"name":"Frostweb Spider","scryfallId":"48574974-bdbb-40e8-916a-44c54b08b501"},{"index":39881,"token":false,"name":"Soaring Hope","scryfallId":"7f6c24b1-af9d-4a9c-9167-faa8a397a361"},{"index":39889,"token":false,"name":"Exquisite Blood","scryfallId":"b1653811-1c2c-4e6c-bf1c-287d1b496d51"},{"index":39891,"token":false,"name":"Death Wish","scryfallId":"7bf134c9-a50d-4eff-a5a8-7cfe6a010080"},{"index":39893,"token":true,"name":"Inkling Token (B/W, 2/1)","scryfallId":"c9deae5c-80d4-4701-b425-91853b7ee03b"},{"index":39899,"token":false,"name":"Granite Shard","scryfallId":"e197af6a-24ac-4f3b-ab3c-736f4057748b"},{"index":39912,"token":false,"name":"Bargain","scryfallId":"de7f3064-a378-4ca4-99f5-b46518ddc43d"},{"index":39915,"token":false,"name":"Crackling Triton","scryfallId":"8d6bb19c-3610-4609-b23c-21d4d80e4582"},{"index":39916,"token":false,"name":"Sygg, River Guide","scryfallId":"fb1aefaf-1b96-4c08-a73e-98e401655965"},{"index":39917,"token":false,"name":"Novice Dissector","scryfallId":"4c4677bc-736b-4bf2-851e-b158718a4224"},{"index":39922,"token":false,"name":"Skull Collector","scryfallId":"0da4b1bf-eef5-4a86-a861-be448845a743"},{"index":39923,"token":false,"name":"Fan Favorite","scryfallId":"062fe308-f892-446d-8f85-f6e77bb00977"},{"index":39932,"token":false,"name":"Barony Vampire","scryfallId":"b0130d04-05f2-44f5-bd6c-8b11f798b69e"},{"index":39935,"token":false,"name":"Serpentine Kavu","scryfallId":"699f1fe8-02c6-4d95-9231-3f8aefe603da"},{"index":39937,"token":false,"name":"Rakdos Augermage","scryfallId":"b5507ec6-430e-41bf-8ac8-42a79f11012d"},{"index":39939,"token":false,"name":"Crush","scryfallId":"a29d5e01-6f83-4749-8340-774054bd2956"},{"index":39942,"token":false,"name":"Vug Lizard","scryfallId":"39bbb1f6-f3c4-4e11-bb71-91ea31797d1e"},{"index":39958,"token":false,"name":"Gudul Lurker","scryfallId":"c84d5344-2d15-43da-b536-27e0d308606b"},{"index":39959,"token":false,"name":"Agadeem Occultist","scryfallId":"c592ef76-d612-4cfe-b906-0e63c44d36f8"},{"index":39967,"token":false,"name":"Floodhound","scryfallId":"a5b1ac05-bd87-4605-8443-0469276e1e3a"},{"index":39969,"token":false,"name":"Implement of Combustion","scryfallId":"15b1c8da-604a-42f0-8658-82580700dd31"},{"index":39971,"token":false,"name":"Sigiled Paladin","scryfallId":"4b22520d-c495-4528-9b24-4aa19e046a9e"},{"index":39974,"token":false,"name":"Copy Enchantment","scryfallId":"72a5396a-6a87-43b8-a74b-f66fcb566c19"},{"index":39976,"token":false,"name":"Gomazoa","scryfallId":"119d2661-ba22-4901-b89a-a0a8ec25d004"},{"index":39980,"token":false,"name":"Armistice","scryfallId":"1eb4402a-f263-4f82-b4c0-cf0aa58dc946"},{"index":39985,"token":false,"name":"Merfolk Mesmerist","scryfallId":"a2052095-99a5-4db1-b7ef-d13875f4da5d"},{"index":39986,"token":false,"name":"Fanatical Fever","scryfallId":"2abba7f1-5d07-4137-88a2-5967396a3e42"},{"index":39988,"token":false,"name":"Temporal Eddy","scryfallId":"3cab2147-d496-489b-aaf0-b354e31a6b45"},{"index":40001,"token":false,"name":"Sarkhan's Catharsis","scryfallId":"2f4b6f26-c66b-4048-9503-af0a886ef14f"},{"index":40003,"token":false,"name":"Searing Touch","scryfallId":"e9091667-d5a8-4978-9023-032ff65f9642"},{"index":40005,"token":false,"name":"Glacial Plating","scryfallId":"55742f0f-a894-48c3-82b1-dfc3d8390dc3"},{"index":40009,"token":false,"name":"Opportunist","scryfallId":"ae0026c0-8f61-4485-8909-6a44c2ca9169"},{"index":40011,"token":false,"name":"Divergent Growth","scryfallId":"0e609448-7868-4e28-b399-3750556a693c"},{"index":40016,"token":false,"name":"Gather the Pack","scryfallId":"9a4f5b00-ac50-485f-a38a-b9f409307d5c"},{"index":40018,"token":false,"name":"Indentured Djinn","scryfallId":"dae62ce7-852b-42c6-9cbe-4807d8bf5740"},{"index":40019,"token":false,"name":"Maulfist Revolutionary","scryfallId":"a83dcdba-419b-41e1-8c9d-8bca6fe2752b"},{"index":40028,"token":false,"name":"Senate Guildmage","scryfallId":"913b3a2a-e3fd-4095-ab2a-5e356ea179df"},{"index":40038,"token":false,"name":"Last One Standing","scryfallId":"87e2ee71-293d-452b-89a5-b15990186f5b"},{"index":40043,"token":false,"name":"Foriysian Totem","scryfallId":"45cba87d-3c8c-4f38-bdd8-51072ba6365b"},{"index":40044,"token":false,"name":"Rambunctious Mutt","scryfallId":"3f602ecc-c264-4f3e-adeb-d0186668653e"},{"index":40045,"token":false,"name":"Hellhole Flailer","scryfallId":"4984a089-84af-4387-9a0d-819b119b5565"},{"index":40047,"token":false,"name":"Impervious Greatwurm","scryfallId":"f5e6dc5f-fd83-4166-a5da-cd953722642a"},{"index":40050,"token":false,"name":"Terrus Wurm","scryfallId":"1998135c-7b7f-402b-a8a5-4f4af131b1bc"},{"index":40051,"token":false,"name":"Crumbling Colossus","scryfallId":"b09afa3b-c172-4cd7-b605-bacbfbd07c24"},{"index":40057,"token":true,"name":"Dragon Token (G/R, 1/1)","scryfallId":"0bb628da-a02f-4d3e-b919-0c03821dd5f2"},{"index":40061,"token":false,"name":"Rasputin Dreamweaver","scryfallId":"78418809-f048-4611-88cb-369f427d9c44"},{"index":40066,"token":false,"name":"Eidolon of Philosophy","scryfallId":"d2897635-b387-485d-932f-5655244a381f"},{"index":40069,"token":false,"name":"World Breaker","scryfallId":"b59cbc7b-cee5-4dc3-bc9d-ba8bd7a52c2c"},{"index":40070,"token":false,"name":"Emissary of Grudges","scryfallId":"a1ec9200-3006-41d7-9bb8-aba1d880ce57"},{"index":40073,"token":false,"name":"Atemsis, All-Seeing","scryfallId":"d8a49220-adb7-4778-a38f-e11bbf7b5f21"},{"index":40075,"token":false,"name":"Wave of Indifference","scryfallId":"2c88b942-06d5-45d8-a4d8-6ca864f65516"},{"index":40082,"token":false,"name":"Architect of the Untamed","scryfallId":"7bc540f5-96a1-44d8-910d-914b9e61b2a5"},{"index":40091,"token":false,"name":"Goblin Rimerunner","scryfallId":"0254a437-5240-40ca-bf7b-d30b95942bf5"},{"index":40092,"token":false,"name":"Ordered Migration","scryfallId":"04d83a07-6054-45f1-bdf9-07f2006238d2"},{"index":40098,"token":false,"name":"Geist-Fueled Scarecrow","scryfallId":"89c9cafb-4543-409f-a98a-df0e7a0f2749"},{"index":40106,"token":false,"name":"Riptide Survivor","scryfallId":"cedabc94-2ed9-4a1e-a4d3-d004da959380"},{"index":40109,"token":false,"name":"Sanguinary Mage","scryfallId":"ace86fac-769c-4440-9a40-318d7172555b"},{"index":40114,"token":false,"name":"Breach","scryfallId":"eada28cb-92bf-47e0-b09d-4709be32dbe6"},{"index":40119,"token":false,"name":"Rise of Eagles","scryfallId":"c3b5b278-b883-4703-9bfa-bab5a6da4660"},{"index":40135,"token":false,"name":"Cavern Harpy","scryfallId":"adfb0804-50d6-4bca-8733-72e01030a543"},{"index":40139,"token":false,"name":"Firebrand Archer","scryfallId":"d439230e-3920-40b5-afc2-0f725ecce24e"},{"index":40141,"token":false,"name":"Humble the Brute","scryfallId":"7c105686-8b45-494a-b9ef-8aa267bb1b5a"},{"index":40142,"token":false,"name":"False Dawn","scryfallId":"1695e0ba-005a-4652-aea7-e1d1f9ff5d66"},{"index":40144,"token":false,"name":"Nullmage Advocate","scryfallId":"dd5f1917-c36c-472a-84d2-dba9789d3578"},{"index":40148,"token":false,"name":"Wicker Warcrawler","scryfallId":"488e7c73-62bc-4d51-bcb6-8126ec559b41"},{"index":40154,"token":false,"name":"Garruk's Warsteed","scryfallId":"d6099863-8d3d-44bf-8d3b-dc3602119617"},{"index":40156,"token":false,"name":"Rowan, Fearless Sparkmage","scryfallId":"030f4058-54e5-4333-bd6c-2789c334bf12"},{"index":40158,"token":false,"name":"Riverwheel Aerialists","scryfallId":"c210b102-8a94-4b5e-858a-777fa8ad18b9"},{"index":40162,"token":false,"name":"Mycosynth Golem","scryfallId":"c3200fa2-182f-4515-b326-ab4fdb95c8c1"},{"index":40163,"token":false,"name":"Firemantle Mage","scryfallId":"197411bf-3307-4056-a7d4-31db0d4b8f9a"},{"index":40166,"token":false,"name":"Unforge","scryfallId":"d369a3da-3424-4984-a50a-59fd9c3d689e"},{"index":40168,"token":false,"name":"Destructive Force","scryfallId":"1abde258-08e0-4762-8142-38e08a960f9d"},{"index":40174,"token":false,"name":"Valakut Fireboar","scryfallId":"5718b282-d3e9-4c68-8623-9ea8a3c937d0"},{"index":40176,"token":false,"name":"Weaver of Currents","scryfallId":"dac35181-baae-4c50-b397-a10b234833e5"},{"index":40179,"token":false,"name":"Seafloor Debris","scryfallId":"6fb5977c-5009-4d97-82c8-c150a0d41bc3"},{"index":40180,"token":false,"name":"Specter's Shriek","scryfallId":"edae2c29-1418-477c-9efe-e53fa6c7fe93"},{"index":40190,"token":false,"name":"Split Decision","scryfallId":"83ed7ebe-48be-4e6e-a293-b81484f85142"},{"index":40195,"token":false,"name":"Crusher Zendikon","scryfallId":"fbf140fa-a901-41a5-a10f-f97ccef72fcc"},{"index":40199,"token":false,"name":"Power Depot","scryfallId":"032eba04-0a63-4823-85e1-64861330a8d7"},{"index":40210,"token":false,"name":"Ethereal Armor","scryfallId":"76960e65-e5c7-4414-b9a5-37d7b2ded4a0"},{"index":40211,"token":false,"name":"Walking Desecration","scryfallId":"c39f3e91-571a-4990-b1e8-db2a5bac34af"},{"index":40213,"token":false,"name":"Worldpurge","scryfallId":"d6f70fdb-264f-4545-97fa-3702168a66d4"},{"index":40215,"token":false,"name":"Teferi's Care","scryfallId":"031b1cc1-4468-4bc5-85c0-c22dce131225"},{"index":40220,"token":false,"name":"Lumengrid Gargoyle","scryfallId":"c200239c-d28e-4c55-a7bc-64a1d138cc2f"},{"index":40225,"token":false,"name":"Vessel of Ephemera","scryfallId":"f4051020-688c-473a-9a08-b62f0fd75675"},{"index":40233,"token":false,"name":"Windrider Patrol","scryfallId":"4ac7b904-7658-4248-a75c-b3a862bde196"},{"index":40234,"token":false,"name":"Bountiful Promenade","scryfallId":"21865ed6-5edd-41f4-9ae0-f501872d91dc"},{"index":40236,"token":false,"name":"Blighted Steppe","scryfallId":"f43df8ee-d3e4-419e-aed0-1059d95f9cab"},{"index":40245,"token":false,"name":"Devour Flesh","scryfallId":"88c42ebd-114a-430d-b3a4-ff2fb3093bf5"},{"index":40251,"token":false,"name":"Fleeting Aven","scryfallId":"246a2758-0096-43b9-8193-d6ae5b41b6e6"},{"index":40258,"token":false,"name":"Train of Thought","scryfallId":"e98f5890-a494-4609-acae-f9e9bacd991d"},{"index":40263,"token":false,"name":"Dredge the Mire","scryfallId":"f57b4b40-bd46-4859-89f0-fa0bd04cc6e9"},{"index":40267,"token":false,"name":"Snarling Undorak","scryfallId":"05788d63-6210-44f2-9ae4-e55e9507a3a9"},{"index":40269,"token":false,"name":"Dewdrop Spy","scryfallId":"64b14ad2-0ac7-4ae1-8a9e-eb49c8c5cc40"},{"index":40277,"token":false,"name":"Emergent Sequence","scryfallId":"04a81975-5f0e-4593-a2da-b9689f9a985f"},{"index":40283,"token":false,"name":"Nyxborn Shieldmate","scryfallId":"64204816-6e1d-4bf8-acd0-8f83ca7eb8c7"},{"index":40285,"token":false,"name":"Restless Apparition","scryfallId":"dc6480d0-17c5-4ac2-afb2-4d44f089de22"},{"index":40287,"token":false,"name":"Manriki-Gusari","scryfallId":"9bc6542b-7672-4ea1-816c-33bc0c300f3c"},{"index":40292,"token":false,"name":"Demonic Lore","scryfallId":"47733f20-f7b2-4a01-b429-0ec49b230fd9"},{"index":40294,"token":false,"name":"Kraul Warrior","scryfallId":"b180c9dc-b4f3-42f6-9afb-ba4464f5349f"},{"index":40295,"token":false,"name":"Brace for Impact","scryfallId":"8d1f1c57-693f-452b-951f-8c8c23f2ee99"},{"index":40302,"token":false,"name":"Flamebreak","scryfallId":"87e1f06f-7c87-4da8-b339-e571e391cab1"},{"index":40303,"token":false,"name":"Death's Presence","scryfallId":"fa82c57d-4bb9-407c-b973-7abc793b6f47"},{"index":40306,"token":false,"name":"Hit // Run","scryfallId":"b44c30a9-1af4-4287-a809-d2de4e8b4070"},{"index":40308,"token":false,"name":"Storm Strike","scryfallId":"ff3da54f-b4ee-4e9a-929e-619094691434"},{"index":40309,"token":false,"name":"Good-Fortune Unicorn","scryfallId":"49d68905-e13e-4751-b028-90c795c11cd5"},{"index":40310,"token":false,"name":"Voiceless Spirit","scryfallId":"d24d9bd7-5721-4436-a86f-35e376727f46"},{"index":40313,"token":false,"name":"Loam Dweller","scryfallId":"4f635b35-48c8-43e8-9d74-c01d3c0c74e1"},{"index":40317,"token":false,"name":"Bloodcurdler","scryfallId":"dd1452ff-cec6-4df3-8bdc-bfb7869553a1"},{"index":40328,"token":false,"name":"Catapult Squad","scryfallId":"75a71d29-29eb-43c4-b0f3-457435e8f629"},{"index":40337,"token":false,"name":"Zelyon Sword","scryfallId":"4137160b-5248-4fbd-8ae8-25e9afd8fb5c"},{"index":40339,"token":false,"name":"Contentious Plan","scryfallId":"8e30deb6-9e1f-4545-ae30-c30ba6c7b3a0"},{"index":40341,"token":false,"name":"Pelt Collector","scryfallId":"bee125cb-12b9-4f78-8e1d-6018d9c52275"},{"index":40355,"token":false,"name":"Mungha Wurm","scryfallId":"6addc915-2997-4b81-a026-97d4421cf17d"},{"index":40361,"token":false,"name":"Aura Graft","scryfallId":"55552a2b-1861-4235-a60d-ccabb4839d54"},{"index":40366,"token":false,"name":"Sheltered Valley","scryfallId":"049d7a08-1605-4ce2-b8c5-634ce2a261e0"},{"index":40378,"token":false,"name":"Temporal Trespass","scryfallId":"a08b7a1e-b404-41ea-875f-b3468501cb4b"},{"index":40380,"token":false,"name":"Lovisa Coldeyes","scryfallId":"ad4d4662-2c9b-42fc-9c08-162c822f436c"},{"index":40385,"token":false,"name":"Watchful Automaton","scryfallId":"138b5fde-417d-4860-aca9-eae7f78b5768"},{"index":40387,"token":false,"name":"Synapse Sliver","scryfallId":"8bf966ff-0fd0-404d-be91-5b0c21035d73"},{"index":40388,"token":false,"name":"Cave Sense","scryfallId":"2d718421-c742-489c-a243-3adb19f6716a"},{"index":40394,"token":false,"name":"Ruin in Their Wake","scryfallId":"5a0ff591-e4d9-4b62-ac9c-7962fd815226"},{"index":40404,"token":false,"name":"Nihilistic Glee","scryfallId":"f603486d-c8d7-4a02-bdb3-c25d2bc62ba6"},{"index":40407,"token":false,"name":"Gore-House Chainwalker","scryfallId":"56ba132f-95fc-4b99-a1dc-ebe6f622bb41"},{"index":40410,"token":false,"name":"Skycloud Egg","scryfallId":"e588cc41-4b86-4e93-94e8-dd765b27ab63"},{"index":40415,"token":false,"name":"Predict","scryfallId":"349ac7e6-af38-4dc3-abfe-369564c75630"},{"index":40417,"token":false,"name":"Scion of Ugin","scryfallId":"302d62d6-8abf-4693-974c-bef6841b394f"},{"index":40425,"token":false,"name":"Kitesail Scout","scryfallId":"68a07aad-4ed5-47ae-b04c-9b9919000f6c"},{"index":40426,"token":false,"name":"Thrilling Encore","scryfallId":"20b4d2f6-c49c-45d7-b172-2628d336e843"},{"index":40429,"token":false,"name":"Nyxborn Triton","scryfallId":"65371de6-13a2-401f-9334-ae9e19619487"},{"index":40443,"token":false,"name":"Phyrexian Snowcrusher","scryfallId":"9f3cf3d3-101e-4649-9495-8a95507d0283"},{"index":40446,"token":false,"name":"Applied Biomancy","scryfallId":"f91ed618-7b0b-4a70-95ad-d9ed46e28692"},{"index":40451,"token":false,"name":"Mourning Thrull","scryfallId":"1e2a217a-e47b-4874-9861-bb57c7b1f06a"},{"index":40454,"token":false,"name":"Vraska, Scheming Gorgon","scryfallId":"91685732-c118-4f52-ac77-f96866a687a3"},{"index":40455,"token":false,"name":"Eyetwitch","scryfallId":"1f4d1bb6-cb8f-4d01-9879-0b3a0585cbf4"},{"index":40456,"token":false,"name":"Mowu, Loyal Companion","scryfallId":"f41a191c-c42e-42ec-89bd-cc1bc215ffbc"},{"index":40462,"token":false,"name":"Ignoble Soldier","scryfallId":"676a2506-17f8-4b8e-be0c-eacc0fe972f6"},{"index":40465,"token":false,"name":"Heartless Summoning","scryfallId":"14f8f638-b7fc-4e38-8623-ce7d2ebc82e6"},{"index":40466,"token":false,"name":"Reign of the Pit","scryfallId":"6184cdb2-1cf8-4b41-ace1-b3e58c314ee8"},{"index":40468,"token":false,"name":"Sergeant-at-Arms","scryfallId":"8f70b1ee-47b6-4904-850d-8ea8064bd27d"},{"index":40475,"token":false,"name":"Culling Ritual","scryfallId":"1ba72e51-ca69-48d4-96dc-df9519468c01"},{"index":40481,"token":false,"name":"Sire of Insanity","scryfallId":"3665cfb7-51b6-4083-8eae-fbd3fa6c3554"},{"index":40488,"token":false,"name":"Kargan Dragonrider","scryfallId":"34750304-c536-47d4-922d-a3654c37ffbc"},{"index":40489,"token":false,"name":"Frostwalla","scryfallId":"fad4fc18-6f2c-45e4-a2c7-c2068b4f1a92"},{"index":40491,"token":false,"name":"Frenetic Ogre","scryfallId":"0dc939cc-826a-4208-ba5b-a11e1cd47aa2"},{"index":40496,"token":false,"name":"Temple Thief","scryfallId":"fc4a61aa-75d2-46bc-b13f-b863f5f49d32"},{"index":40500,"token":false,"name":"Sigil of the Nayan Gods","scryfallId":"a856dec4-fe4f-477c-9300-e9de86d3cc95"},{"index":40511,"token":false,"name":"Alirios, Enraptured","scryfallId":"26f9ebbe-3791-4d19-88d2-d5de95faff48"},{"index":40512,"token":false,"name":"Spirit Bonds","scryfallId":"aa2a3aaa-e78a-48cc-b7d3-7f65e467054c"},{"index":40515,"token":false,"name":"Knighted Myr","scryfallId":"ee638303-fa02-41b6-8954-156544566b57"},{"index":40516,"token":false,"name":"Al-abara's Carpet","scryfallId":"5d5aae6e-fe20-4363-9589-5a54bcbbb77e"},{"index":40518,"token":false,"name":"Darkwatch Elves","scryfallId":"212a807f-d5d0-4787-b390-3351783a1ae4"},{"index":40528,"token":false,"name":"Venarian Glimmer","scryfallId":"5cfab012-f57a-4018-bfe3-8eac073f6ee8"},{"index":40532,"token":false,"name":"Beast Walkers","scryfallId":"99b42f6c-5c7e-4ba8-b0fb-ac8564aaf825"},{"index":40534,"token":false,"name":"Soul Snuffers","scryfallId":"f3a35951-6bd9-4018-85cc-f8c39c366c7a"},{"index":40537,"token":false,"name":"Vine Snare","scryfallId":"d2241f71-4319-49bf-905a-b6b774ffcb27"},{"index":40539,"token":false,"name":"Enchanted Carriage","scryfallId":"0057c2ae-ea4f-404a-ab95-f3979efd1b3b"},{"index":40546,"token":false,"name":"Honorable Scout","scryfallId":"bd311758-0352-4b7d-a24f-7f3f2b5d7b0f"},{"index":40560,"token":false,"name":"Dinosaur Stampede","scryfallId":"a31bda74-8455-45ab-8142-65fbde2f39c3"},{"index":40564,"token":false,"name":"Yawgmoth, Thran Physician","scryfallId":"8690cbcc-f8fd-41f7-9e28-e61c12b04014"},{"index":40567,"token":false,"name":"Acrobatic Maneuver","scryfallId":"655d23a2-0fdd-4691-84fe-33917f224884"},{"index":40570,"token":false,"name":"Akki Rockspeaker","scryfallId":"9c8b6685-2c74-4026-aef0-73ca7bc43306"},{"index":40571,"token":false,"name":"Mana Severance","scryfallId":"854dc5e6-63f7-4c8b-83e5-a364f41c9a15"},{"index":40572,"token":false,"name":"Pyrophobia","scryfallId":"ff02b3f1-d70f-4e44-bc1c-7fc90ec611dc"},{"index":40581,"token":false,"name":"Walking Atlas","scryfallId":"53515042-e729-4a7c-ac3b-36ef70dbbe8d"},{"index":40582,"token":false,"name":"Waker of the Wilds","scryfallId":"7d46c4db-e12e-4c79-a17f-2166ed78e9bc"},{"index":40583,"token":true,"name":"Fungus Beast Token (G, 4/4)","scryfallId":"bfaa2850-3846-4c6a-8e08-937645db3752"},{"index":40586,"token":false,"name":"Stone Haven Medic","scryfallId":"1dc063ea-15e9-4ac3-b9a3-32aaa8bc4f55"},{"index":40589,"token":false,"name":"Tortured Existence","scryfallId":"1efe6c2f-eb19-4a34-925a-3b90d2dbe680"},{"index":40595,"token":false,"name":"Gideon, the Oathsworn","scryfallId":"43e7331d-98b8-420f-a346-3f3521c3b258"},{"index":40603,"token":false,"name":"Resolute Rider","scryfallId":"853dbf04-7165-4728-b96c-c9e4ff4d3491"},{"index":40607,"token":false,"name":"Fracture","scryfallId":"a11224f8-06ea-4ec3-85e6-d5c8d906840c"},{"index":40608,"token":false,"name":"Returned Pastcaller","scryfallId":"7aa0e762-0fec-4f6b-b3d7-ad8295bf557d"},{"index":40614,"token":false,"name":"Vexing Sphinx","scryfallId":"81cc1248-85c8-428f-ba08-96d188167eaa"},{"index":40617,"token":false,"name":"Sea Snidd","scryfallId":"ca11015e-200b-488c-8bf5-662dcc03cd2d"},{"index":40619,"token":false,"name":"Mortal's Ardor","scryfallId":"9e29f95c-aeed-4cb6-a43b-2748a5dd6138"},{"index":40620,"token":false,"name":"Necromancy","scryfallId":"1d3c7c00-3a27-4926-9cdd-b112dd35218a"},{"index":40624,"token":false,"name":"Witch's Oven","scryfallId":"04ef8493-d986-45f8-a718-617b028f7ad4"},{"index":40627,"token":false,"name":"Jolrael's Favor","scryfallId":"8275ecd7-f119-4cca-bef1-626a3272dd2c"},{"index":40630,"token":false,"name":"Trigon of Mending","scryfallId":"241142e0-3a79-4bce-8535-18ae7e392f5e"},{"index":40632,"token":false,"name":"Hellcarver Demon","scryfallId":"984a037b-63c0-497d-b3b1-15726ef11a60"},{"index":40636,"token":false,"name":"Charnel Troll","scryfallId":"71fec229-e22c-4655-8640-02d0ec472be0"},{"index":40645,"token":false,"name":"Radiant Purge","scryfallId":"c34d94f4-c504-4cf1-9bc7-d318fbee54d7"},{"index":40653,"token":false,"name":"Warmth","scryfallId":"d7dbeea8-06b0-4482-bdae-aa82b9db8856"},{"index":40655,"token":false,"name":"Tattoo Ward","scryfallId":"89920480-9b39-47dd-988a-c040067da7fb"},{"index":40656,"token":false,"name":"Shimmer Dragon","scryfallId":"5beffa4c-4188-48c1-8374-3ac3e8ea1900"},{"index":40657,"token":false,"name":"Kelsien, the Plague","scryfallId":"039d25d4-ce26-4ecf-bbf5-42187cf0230a"},{"index":40660,"token":false,"name":"Lodestone Bauble","scryfallId":"84d88a33-3990-4044-a5fe-4123d5781f18"},{"index":40662,"token":false,"name":"Runeflare Trap","scryfallId":"e2ceff22-0270-4c9d-9ae2-f40a7047335b"},{"index":40663,"token":false,"name":"Bonded Construct","scryfallId":"43361897-f853-4cab-a132-5af48dad3b54"},{"index":40665,"token":false,"name":"Aether Sting","scryfallId":"66a09917-50ce-4b51-a5cf-e28e88a45762"},{"index":40667,"token":false,"name":"Desolation","scryfallId":"3b186460-d2af-4912-ba19-95b2cb5f1639"},{"index":40675,"token":false,"name":"Spikefield Hazard // Spikefield Cave","scryfallId":"a69541db-3f4e-412f-aa8e-dec1e74f74dc"},{"index":40678,"token":false,"name":"Laboratory Maniac","scryfallId":"809205f3-acf5-4244-b360-09ce4ba76795"},{"index":40682,"token":false,"name":"Wilderness Elemental","scryfallId":"25d25e02-a266-4fad-bc8c-aa45487fab90"},{"index":40686,"token":false,"name":"Mammoth Harness","scryfallId":"5be67121-068c-4770-bc42-c081577a442c"},{"index":40687,"token":false,"name":"Cavalry Master","scryfallId":"f7b19194-87bf-432c-8d34-91dd9520cbd2"},{"index":40690,"token":false,"name":"Wall of Tears","scryfallId":"4638d815-fb86-490c-84d6-777a1c6131d6"},{"index":40691,"token":false,"name":"Cabal Shrine","scryfallId":"dd376a52-5dfd-49f3-a520-537cd4527439"},{"index":40694,"token":false,"name":"Lymph Sliver","scryfallId":"48b8b4d4-4400-46cc-bd3c-e8a781cfc6f2"},{"index":40695,"token":false,"name":"Waste Away","scryfallId":"78e859c2-3457-4c4c-9b1c-0db647dcf259"},{"index":40700,"token":false,"name":"Martyr of Bones","scryfallId":"8bba602e-5a81-4da2-99c0-6082f8a981e1"},{"index":40704,"token":false,"name":"Dreamcatcher","scryfallId":"b90ab82e-84d7-462a-b3c2-abaccfb46dd3"},{"index":40706,"token":false,"name":"Pulse of Llanowar","scryfallId":"db09afe5-5f01-4f77-a239-12d7a6e59024"},{"index":40710,"token":false,"name":"Collateral Damage","scryfallId":"fb738362-b0b4-4811-9fbf-5f45c852c822"},{"index":40711,"token":false,"name":"Ronom Hulk","scryfallId":"e5b4b14c-e6fa-4cd2-9be7-fa2a2df05de1"},{"index":40714,"token":false,"name":"Shoreline Raider","scryfallId":"d895b3b8-2acc-4c9f-8341-f651c1255b7c"},{"index":40717,"token":false,"name":"Whirlwind Adept","scryfallId":"9fdbe6b5-7f67-42f1-be8f-637c35417925"},{"index":40719,"token":false,"name":"Teeka's Dragon","scryfallId":"57e8971d-baeb-4e4f-8c4d-0e8109e4505e"},{"index":40720,"token":false,"name":"Arni Slays the Troll","scryfallId":"d18396f9-ae20-4471-84ab-a2148319bc39"},{"index":40725,"token":false,"name":"Rootwater Matriarch","scryfallId":"ec46812d-0721-4e93-b1a7-1d38f477fab6"},{"index":40728,"token":false,"name":"Spellbane Centaur","scryfallId":"72194a6e-481d-4b07-922b-53f919bfa316"},{"index":40729,"token":false,"name":"Shoulder to Shoulder","scryfallId":"49d11865-a1ea-4f2e-b7da-31630c6d0272"},{"index":40738,"token":false,"name":"Turn to Mist","scryfallId":"160d3bf1-5f8b-431c-bb4e-a6874c69817a"},{"index":40739,"token":false,"name":"Sagu Archer","scryfallId":"3a26baca-467e-4d94-873e-f266bebd5fd8"},{"index":40747,"token":false,"name":"Declaration of Naught","scryfallId":"2e67d62f-9629-463b-a445-4181f6fafd0f"},{"index":40757,"token":false,"name":"Dizzy Spell","scryfallId":"6e0db10d-fb6d-44df-9ff2-6f1e0e8f8209"},{"index":40758,"token":false,"name":"Sproutback Trudge","scryfallId":"80615351-a27e-4df7-a49b-8f73d138ac4f"},{"index":40760,"token":false,"name":"Russet Wolves","scryfallId":"b3c7c972-5a11-4709-b3ef-e2acb3b51dd9"},{"index":40762,"token":false,"name":"Sparkcaster","scryfallId":"daf442b3-fa39-4f6a-90a0-22dcd9df649c"},{"index":40773,"token":false,"name":"Defiant Ogre","scryfallId":"9b7da91a-f548-4d94-b79b-04543f87f360"},{"index":40776,"token":false,"name":"Bellowing Saddlebrute","scryfallId":"a1939b5d-e24f-4e4b-b4c5-8bdb232d8926"},{"index":40777,"token":false,"name":"Wildwood Rebirth","scryfallId":"713a93a1-4442-4d5b-ad7a-136b87b5f7ab"},{"index":40787,"token":false,"name":"Vodalian Serpent","scryfallId":"92adcf6c-ab14-414c-a5cb-56feae048c84"},{"index":40791,"token":false,"name":"Blockade Runner","scryfallId":"59e483df-b58a-401e-85bc-0afda4bf7cac"},{"index":40792,"token":false,"name":"Dreamshaper Shaman","scryfallId":"f6b04ec8-68c9-468c-b137-707db994af68"},{"index":40794,"token":false,"name":"Psychic Drain","scryfallId":"d00fd2d8-76ce-4334-b772-a5dc64fc2989"},{"index":40796,"token":false,"name":"Thatcher Revolt","scryfallId":"ea28bd68-47a8-47c6-be16-75ae622daf0a"},{"index":40801,"token":false,"name":"Bifurcate","scryfallId":"dedb483e-b2c6-46c6-b02b-a49599d33521"},{"index":40804,"token":false,"name":"Savage Hunger","scryfallId":"0367fac8-6990-4544-ac7d-ed363b55a9cf"},{"index":40805,"token":false,"name":"Memory Plunder","scryfallId":"9ca6808a-1816-4ac7-bbb2-c7a5a47428d6"},{"index":40830,"token":false,"name":"Sizzling Barrage","scryfallId":"1bf5843a-a01f-4d1c-b8fe-c586d5160f6e"},{"index":40831,"token":false,"name":"Cackling Witch","scryfallId":"cec755ee-b4c0-47fd-9e61-9a3161766de6"},{"index":40835,"token":false,"name":"Trueheart Twins","scryfallId":"ac510911-1a65-4509-b6c9-ddac1950c838"},{"index":40839,"token":false,"name":"Venerable Lammasu","scryfallId":"229919ef-e39f-4bdc-bcc5-46224a3eb7b4"},{"index":40840,"token":false,"name":"Eternal Flame","scryfallId":"d646feea-3c20-4737-8d20-ffad42258ced"},{"index":40841,"token":false,"name":"Steady Progress","scryfallId":"6fe212ed-31cb-4f10-8ba7-e97af1d30d24"},{"index":40846,"token":false,"name":"Altar of Shadows","scryfallId":"ebc3824c-11ee-4fec-9397-823783b682d9"},{"index":40847,"token":false,"name":"Angel's Herald","scryfallId":"36197ed0-4382-4de3-8359-73cb74edc78b"},{"index":40854,"token":false,"name":"Zealots en-Dal","scryfallId":"6a9fb486-1d6a-478e-af6e-fd8539dc646d"},{"index":40861,"token":false,"name":"Season of the Witch","scryfallId":"06900a71-34ca-48c6-94ac-fca744356829"},{"index":40866,"token":false,"name":"Viscerid Armor","scryfallId":"b719f89d-2a2c-460c-95e4-ada21353b340"},{"index":40867,"token":false,"name":"Havoc Jester","scryfallId":"386e5cb2-39c8-453d-a642-c5d9f8495601"},{"index":40873,"token":false,"name":"Cosmic Larva","scryfallId":"deaa0b9b-258e-4daf-8fec-ce64864d6bbf"},{"index":40875,"token":false,"name":"Yukora, the Prisoner","scryfallId":"54aeca31-1175-4d2d-adc3-e3682d7e9e07"},{"index":40878,"token":false,"name":"Almighty Brushwagg","scryfallId":"71f2b7ac-8742-468d-b6a3-87881cb522ff"},{"index":40882,"token":false,"name":"Cliff Threader","scryfallId":"1743b625-e937-4cac-8701-9e2dd709a9a4"},{"index":40885,"token":false,"name":"Catacomb Dragon","scryfallId":"46daebe4-199e-4580-8a52-1aebc8492d8c"},{"index":40887,"token":false,"name":"Everflame Eidolon","scryfallId":"a018d5ea-5229-40ca-b7c5-31d3e8ebb894"},{"index":40888,"token":false,"name":"Kithkin Daggerdare","scryfallId":"90d0d7fd-a580-41af-8e9d-fee74094ec47"},{"index":40889,"token":true,"name":"Jon Finkel Decklist","scryfallId":"b905ddba-8808-45b3-81bf-406592e4c661"},{"index":40890,"token":false,"name":"Sway of Illusion","scryfallId":"ff65e386-9aec-4deb-a4ec-d9a97bd87645"},{"index":40898,"token":false,"name":"Blistering Barrier","scryfallId":"56d000d8-24e1-4cf3-bed9-e68a89c8f569"},{"index":40901,"token":false,"name":"Tranquil Grove","scryfallId":"c4a145f2-b59d-4728-922c-9bc228451432"},{"index":40905,"token":false,"name":"Devastating Dreams","scryfallId":"9fffeed0-a5ea-47ac-a7a4-0cc3bb1d408a"},{"index":40908,"token":false,"name":"Bloodrite Invoker","scryfallId":"5dc36f94-2499-4d94-a506-27d42b9da667"},{"index":40911,"token":false,"name":"Hooded Assassin","scryfallId":"05d4da1d-5b8c-43be-aa30-22df69c0cc23"},{"index":40913,"token":false,"name":"Mirozel","scryfallId":"16417e94-e33f-4ed4-bb3e-52f29f7d441b"},{"index":40914,"token":false,"name":"Thriving Grubs","scryfallId":"bbc3184a-eeda-4f22-92de-257c20cff6e2"},{"index":40917,"token":false,"name":"Cephalid Retainer","scryfallId":"78480527-cfd6-4065-b702-82de4694f9bb"},{"index":40918,"token":false,"name":"Mob Mentality","scryfallId":"e428d56a-9445-4e86-b281-656e2d251e0b"},{"index":40921,"token":false,"name":"Vraska, Regal Gorgon","scryfallId":"4299dbe6-c94d-4ecc-8bfd-741d2649cba1"},{"index":40924,"token":false,"name":"Aegis of Honor","scryfallId":"9561ffdb-f4dd-4b62-a2c2-933498e3a061"},{"index":40927,"token":false,"name":"Oath of Chandra","scryfallId":"1edeec1a-b0aa-48f6-8594-fb4d713771d1"},{"index":40930,"token":false,"name":"Fairgrounds Patrol","scryfallId":"237e07ed-24ef-40f7-91fc-fe212d948ca8"},{"index":40935,"token":false,"name":"Entropic Specter","scryfallId":"bdb04d81-b0ab-4bc7-935d-c31005887240"},{"index":40936,"token":false,"name":"Voidwielder","scryfallId":"23723bc7-a68e-4810-bc87-60df916cbb8a"},{"index":40940,"token":false,"name":"Archery Training","scryfallId":"151232e6-68cc-4cac-a532-9ade8e925961"},{"index":40944,"token":false,"name":"Rix Maadi Reveler","scryfallId":"c40396da-18e2-42ca-a78c-4838a38f68b8"},{"index":40948,"token":false,"name":"Flame Blitz","scryfallId":"a93c6ba8-666b-4c05-8137-8ffa1d5d928b"},{"index":40951,"token":false,"name":"Postmortem Lunge","scryfallId":"d5f8b46e-1ad3-4c6e-aa63-376f2d222d46"},{"index":40955,"token":false,"name":"Command the Dreadhorde","scryfallId":"de7ec307-45e0-4853-85fe-9ce859b188c2"},{"index":40961,"token":false,"name":"Burst of Strength","scryfallId":"d1cbd617-9f2e-4882-b8f0-dfc2fced2281"},{"index":40962,"token":false,"name":"Blood Age General","scryfallId":"f30237cc-27c8-4075-acbd-d75a16588a68"},{"index":40972,"token":false,"name":"Enigma Eidolon","scryfallId":"814a1082-6e2c-46d3-9b45-12dab7006c0f"},{"index":40973,"token":false,"name":"Reign of Chaos","scryfallId":"9285b14a-fc8e-457a-b803-202e05be41e5"},{"index":40979,"token":false,"name":"Emrakul's Hatcher","scryfallId":"1a901c3f-313d-495e-96a0-29f1a33b8225"},{"index":40982,"token":false,"name":"Kraul Harpooner","scryfallId":"f6d3c086-9ce4-41c3-8402-2818f1b27192"},{"index":40988,"token":false,"name":"Zephid","scryfallId":"e0317fff-dbad-4c47-a191-0369d81cdda2"},{"index":40990,"token":false,"name":"Jasmine Seer","scryfallId":"a6641dd2-5b9c-4089-8a71-a3a1a9c29f8b"},{"index":40996,"token":false,"name":"Bear Cub","scryfallId":"a3d36d12-22e4-4889-8f01-5f54de39e379"},{"index":41001,"token":true,"name":"Predatory","scryfallId":"981d2d34-107a-47ec-9a21-88e00de4d3d5"},{"index":41003,"token":false,"name":"Veinwitch Coven","scryfallId":"c13e1d08-8926-4b80-9a48-a1e8c1847b6f"},{"index":41005,"token":false,"name":"Plated Spider","scryfallId":"78ca8e51-9f44-4c44-b6cc-46b07316a1f3"},{"index":41008,"token":false,"name":"Sanguine Sacrament","scryfallId":"d54c850b-d690-4d41-84bc-7f033cdd37d2"},{"index":41014,"token":false,"name":"Wear Away","scryfallId":"3e809799-ce47-4eaf-b2c2-2c8807182532"},{"index":41018,"token":false,"name":"Carnage Gladiator","scryfallId":"20bde6c1-917c-4860-a8d0-a9d7c461f8d2"},{"index":41020,"token":false,"name":"Flame Slash","scryfallId":"15affc1b-2ebb-4934-87a2-10e89eafe894"},{"index":41021,"token":false,"name":"Vengeful Pharaoh","scryfallId":"12e0ca97-bc57-4084-86b4-e2e06152cb1c"},{"index":41026,"token":false,"name":"Reality Acid","scryfallId":"8c6ad9c3-b5dd-46a9-8494-8b395e21aedf"},{"index":41031,"token":false,"name":"Possessed Barbarian","scryfallId":"57e79610-8cfe-4711-bc71-8c25d68036da"},{"index":41034,"token":false,"name":"Grafted Wargear","scryfallId":"1d023d44-482e-4f60-b9b1-eede9bfb732f"},{"index":41040,"token":false,"name":"Athreos, God of Passage","scryfallId":"3380a687-c96b-4e1a-bfd9-3849d085b803"},{"index":41046,"token":false,"name":"Abzan Banner","scryfallId":"7855528a-ede9-49a9-8749-795a004fd927"},{"index":41054,"token":false,"name":"Duskwielder","scryfallId":"5b5490b8-5652-40f5-8678-e1263ef69b5a"},{"index":41058,"token":false,"name":"Tribute to Hunger","scryfallId":"fcfc9bd3-4378-4305-b427-4e3dd4e1fba1"},{"index":41062,"token":false,"name":"Zephyr Sprite","scryfallId":"b256f91a-e797-41d7-82a6-3dcd691bbeed"},{"index":41064,"token":false,"name":"Fathom Fleet Captain","scryfallId":"babb7214-9b88-44f9-9a53-652b7e8a2361"},{"index":41066,"token":false,"name":"Merrow Commerce","scryfallId":"3ad0c3b4-fd24-44ad-8b30-4176f07be3d6"},{"index":41069,"token":false,"name":"Regenerate","scryfallId":"9a1026f4-b11a-48aa-9191-e0bb51c515a6"},{"index":41081,"token":false,"name":"Bone Picker","scryfallId":"00850712-704b-46af-93e6-51d7d79832f9"},{"index":41092,"token":false,"name":"Circuitous Route","scryfallId":"5a970429-6369-4422-a343-00b30267f09d"},{"index":41094,"token":false,"name":"Zombie Boa","scryfallId":"1fb8c277-3154-47c9-835f-327cac297a5e"},{"index":41096,"token":true,"name":"Lands","scryfallId":"e61cf6e6-410a-4e34-aa40-d5089c5952ed"},{"index":41101,"token":false,"name":"Saw It Coming","scryfallId":"877a1bb9-5eae-453a-bec0-a9de20ea6815"},{"index":41107,"token":false,"name":"Mad Dog","scryfallId":"7be2da24-a0cd-4e90-bc29-4da649fa56bf"},{"index":41122,"token":false,"name":"Frost Raptor","scryfallId":"4ab2f81a-fcbe-44d1-8281-04dd78bb9ea3"},{"index":41136,"token":false,"name":"Airdrop Condor","scryfallId":"ec9796ac-11e2-4295-bf00-f684d0111970"},{"index":41146,"token":false,"name":"Ipnu Rivulet","scryfallId":"9efead6b-5c61-479c-8974-c8be99ca95ca"},{"index":41147,"token":false,"name":"Flummoxed Cyclops","scryfallId":"1f70bcef-7ab6-4547-aca4-dd3ba68fd26b"},{"index":41153,"token":false,"name":"Dragonlord's Prerogative","scryfallId":"53f2d2b3-6e48-413e-ad8f-9ce40c7ff167"},{"index":41157,"token":false,"name":"Selfless Cathar","scryfallId":"3366f6c3-3899-4585-b6d2-24406703cf34"},{"index":41162,"token":false,"name":"Titanic Bulvox","scryfallId":"3f42c4d7-b555-449c-a539-119c1ae62232"},{"index":41171,"token":false,"name":"Form of the Dinosaur","scryfallId":"6bd7af95-f5be-48a0-b9f3-b294045cc298"},{"index":41172,"token":false,"name":"Siona, Captain of the Pyleas","scryfallId":"2b1d890f-7ef8-47b9-9ec8-f3884a1d09db"},{"index":41174,"token":false,"name":"Llanowar Dead","scryfallId":"f271969e-1529-42d1-878b-011f80ab0f05"},{"index":41179,"token":false,"name":"Neverending Torment","scryfallId":"3f91f678-9d3a-4502-81a6-3e1676aa447a"},{"index":41191,"token":false,"name":"Lofty Denial","scryfallId":"64832674-beb1-446e-b2f7-8a5e271139a5"},{"index":41198,"token":false,"name":"Ravenform","scryfallId":"2c2cfcd7-b43a-4dad-a033-e661f55ceecd"},{"index":41207,"token":false,"name":"Angelic Field Marshal","scryfallId":"4e8185b9-f559-47e8-ae90-d62396b4aa6b"},{"index":41209,"token":false,"name":"Wormfang Drake","scryfallId":"b6afd312-6448-4bd1-8539-0910cefead0d"},{"index":41217,"token":false,"name":"Mental Journey","scryfallId":"0ec38124-46ae-4a38-aab2-8a73cc22b1ef"},{"index":41223,"token":false,"name":"Sea's Claim","scryfallId":"82e836c8-4371-402f-8f90-81325a9879b8"},{"index":41226,"token":false,"name":"Oblivion's Hunger","scryfallId":"faf65512-8228-48f4-ba7b-d861b66d28c9"},{"index":41228,"token":false,"name":"Lullmage's Domination","scryfallId":"c9944393-348f-4f0e-a0c7-9adcc5a30749"},{"index":41230,"token":false,"name":"Spell Satchel","scryfallId":"7de826a0-6e68-4d40-a51c-8d6e7a4148d1"},{"index":41232,"token":false,"name":"Steam Spitter","scryfallId":"8aa585b7-cf7e-4f04-9490-1e6c53631647"},{"index":41237,"token":true,"name":"Maddened Oread Token (Colorless, 4/2)","scryfallId":"076ad38c-30ec-41a4-be18-c287f65d1d86"},{"index":41240,"token":false,"name":"Dauthi Embrace","scryfallId":"7e84bb94-d654-4d69-89d9-0a398a940125"},{"index":41243,"token":false,"name":"Yellow Scarves Cavalry","scryfallId":"84460666-4f6b-422c-b20e-dc1651c66e15"},{"index":41249,"token":true,"name":"Elemental // Elemental","scryfallId":"72b45263-d4e9-4a53-a78b-be651e18b615"},{"index":41255,"token":false,"name":"Liliana's Scrounger","scryfallId":"5a64625f-937a-449e-b1fc-cd0f25b033f6"},{"index":41256,"token":false,"name":"Aquus Steed","scryfallId":"af643949-7a9b-4195-8ab8-d43b1928b85a"},{"index":41263,"token":false,"name":"Feed the Pack","scryfallId":"9831e3cc-659b-4408-b5d8-a27ae2738680"},{"index":41273,"token":false,"name":"Boarding Party","scryfallId":"186adacf-434b-475b-9b85-749615ae002b"},{"index":41282,"token":false,"name":"Moss-Pit Skeleton","scryfallId":"95a445dc-3aea-4281-a145-0ab3a28ec6c6"},{"index":41283,"token":false,"name":"Masked Vandal","scryfallId":"f0a9c72a-e450-41e3-80e5-06f2f1171245"},{"index":41285,"token":false,"name":"Altar of the Lost","scryfallId":"774e5322-1b41-488d-94b1-7742fbd983d4"},{"index":41293,"token":false,"name":"Noxious Field","scryfallId":"10c84d09-555c-472b-b445-5dd5a44cd555"},{"index":41295,"token":false,"name":"Haunting Wind","scryfallId":"a2f6ef2f-a3a2-4e1f-b7eb-59abc8414114"},{"index":41304,"token":false,"name":"Thassa's Bounty","scryfallId":"3ac987ac-3f81-4704-b42c-651f44670641"},{"index":41306,"token":false,"name":"Zendikar Farguide","scryfallId":"b3aeb7fb-8618-4595-84b4-20881b824b3e"},{"index":41314,"token":false,"name":"Rusted Sentinel","scryfallId":"cba5fc44-4b9a-418b-a4e0-26d2c3a1eca4"},{"index":41316,"token":false,"name":"Hunting Kavu","scryfallId":"8943304a-89c9-48b0-97b4-3e1aa690ca4d"},{"index":41327,"token":false,"name":"Wave Elemental","scryfallId":"111ee762-72cb-43e3-88a1-6f1f0b9ee66e"},{"index":41337,"token":false,"name":"Outflank","scryfallId":"663e0208-81c3-4a76-bcc2-bc59cf8ca649"},{"index":41340,"token":false,"name":"Clinging Darkness","scryfallId":"2a939a4e-5a9e-454f-8716-cee7470f05e2"},{"index":41344,"token":false,"name":"Surging Might","scryfallId":"aa51adee-b343-4a03-8fa0-0d86244db5b7"},{"index":41350,"token":true,"name":"Smashing","scryfallId":"4321f9e4-bddb-4d4f-b82d-fe1150b425e3"},{"index":41351,"token":false,"name":"Soldevi Digger","scryfallId":"473d6e22-1184-4d29-a7d1-f6773666ff29"},{"index":41353,"token":false,"name":"Snow Devil","scryfallId":"2be3a9a5-2ac5-4ea4-915d-8cff35c0e72f"},{"index":41357,"token":false,"name":"Wakestone Gargoyle","scryfallId":"6198d0c3-bf08-445a-8fd7-7d79b745d9a8"},{"index":41358,"token":false,"name":"Mantis Rider","scryfallId":"82d5ce46-7118-4ede-ba1d-c387e7ce16e7"},{"index":41364,"token":false,"name":"Cowed by Wisdom","scryfallId":"0b81b329-4ef5-4b55-9fe7-9ed69477e96b"},{"index":41369,"token":false,"name":"Repopulate","scryfallId":"aac77869-97bc-4976-9ee0-3d60e162b78a"},{"index":41370,"token":false,"name":"Tsabo's Assassin","scryfallId":"44a3a729-f8bd-47e1-b5b7-8931316f7ed2"},{"index":41373,"token":false,"name":"Spark Mage","scryfallId":"cff5902e-2ca1-43bb-b636-c860b3d0b3f2"},{"index":41377,"token":false,"name":"Soul of Magma","scryfallId":"aa0cb483-99b1-4d61-9c55-18d3db099225"},{"index":41381,"token":false,"name":"King Macar, the Gold-Cursed","scryfallId":"ff5987ab-570a-426c-ae4a-a270fac6b346"},{"index":41382,"token":false,"name":"Wayfaring Giant","scryfallId":"57e45de5-0e8b-41d3-979b-ec5a29cac682"},{"index":41385,"token":false,"name":"Ancient Carp","scryfallId":"1fef6e95-e7f1-4646-be5e-130c8b5a3ca6"},{"index":41387,"token":false,"name":"Faerie Harbinger","scryfallId":"f9bdc319-4e06-420b-ba54-6cb994d4e279"},{"index":41392,"token":false,"name":"Pursuit of Knowledge","scryfallId":"2d304b64-cb50-4812-ad7f-fe59ff8aca50"},{"index":41393,"token":false,"name":"Heroes of the Revel","scryfallId":"dfdfb481-3446-42f4-a1c3-a88b69f2189a"},{"index":41394,"token":false,"name":"Death-Mask Duplicant","scryfallId":"01e8d67d-3b49-4158-b2bf-8dd0607de51f"},{"index":41400,"token":false,"name":"Secretkeeper","scryfallId":"03247e03-747a-462a-ad74-49ce02d20f13"},{"index":41409,"token":false,"name":"Lambholt Pacifist // Lambholt Butcher","scryfallId":"23f3fa96-6276-463e-8033-a64c8f06c933"},{"index":41413,"token":false,"name":"Mirror Image","scryfallId":"5b3ffc69-f21b-410e-8993-8c1b4669fc19"},{"index":41416,"token":false,"name":"Jhoira's Timebug","scryfallId":"9ce2c6d7-505b-490b-9c6f-b5166c9ff71d"},{"index":41417,"token":false,"name":"Frostpeak Yeti","scryfallId":"3f406ce3-dce1-42d3-b76c-8e8c4b2770cb"},{"index":41419,"token":false,"name":"Crystal Seer","scryfallId":"549ed5bd-da29-4cd4-893e-9e53e33a8557"},{"index":41423,"token":false,"name":"Reflecting Mirror","scryfallId":"d551ff93-d8da-4c21-bc3c-6451c0dde07e"},{"index":41425,"token":false,"name":"Paperfin Rascal","scryfallId":"a439c0ca-0cb2-4293-825e-1a72159953b9"},{"index":41434,"token":false,"name":"Dark Salvation","scryfallId":"4b5978bd-a696-430e-8c35-729d96eec53e"},{"index":41439,"token":false,"name":"Broodwarden","scryfallId":"d3a1ca42-0fb1-4962-8663-39fc07443aef"},{"index":41444,"token":false,"name":"Aspect of Hydra","scryfallId":"19353629-07be-47e2-a7d5-3a5e5e1120c8"},{"index":41445,"token":false,"name":"Goblin War Wagon","scryfallId":"229e8124-54ed-4c29-8c44-4962bd60f145"},{"index":41458,"token":false,"name":"Way of the Thief","scryfallId":"b249ca81-bd8d-4d3d-81d6-15e8d669c416"},{"index":41460,"token":false,"name":"Seeds of Strength","scryfallId":"bfa1ac13-adbd-439a-90b2-9c506aec0836"},{"index":41465,"token":false,"name":"Vectis Dominator","scryfallId":"1cfb7589-a53e-4580-bd92-641fd4785934"},{"index":41467,"token":false,"name":"Razor Pendulum","scryfallId":"72562860-6097-4c63-9858-ae130805f4d6"},{"index":41468,"token":false,"name":"Chamber Sentry","scryfallId":"15dfd5f2-5298-4cf4-80fe-43db9be24f57"},{"index":41482,"token":false,"name":"Serra's Guardian","scryfallId":"1a1d95b9-aa18-41e2-b972-93fda25e0b11"},{"index":41485,"token":false,"name":"Ghitu War Cry","scryfallId":"7d2ce069-ec5a-4309-b81f-356dd6ebcb03"},{"index":41487,"token":false,"name":"Citanul Woodreaders","scryfallId":"b0cd9af6-3729-4c9c-9669-a2800a693b39"},{"index":41493,"token":false,"name":"Ravenous Leucrocota","scryfallId":"7770a846-5b5c-417f-9957-ada2c1c06a14"},{"index":41497,"token":false,"name":"Security Blockade","scryfallId":"e6250b31-8592-48b2-a877-3637c9ee7d49"},{"index":41499,"token":false,"name":"Stamina","scryfallId":"ed8abca3-6e31-49cd-b9bf-86ad68e1cc83"},{"index":41500,"token":false,"name":"Molting Skin","scryfallId":"f0797186-01ae-4de0-b188-7fc3079b2800"},{"index":41501,"token":false,"name":"Soul of Eternity","scryfallId":"08241f94-8b5e-4f9b-8120-8175e3256e35"},{"index":41502,"token":true,"name":"Wolf Token (B/G, 2/2)","scryfallId":"88452ed7-1065-41c3-94a6-dc41108c45c1"},{"index":41510,"token":false,"name":"Ghosts of the Innocent","scryfallId":"c5b10c5f-261f-4301-b675-d1f52b859360"},{"index":41513,"token":false,"name":"Halls of Mist","scryfallId":"b926a189-90b6-47bb-b5d6-b033e57007b4"},{"index":41514,"token":false,"name":"Deny Existence","scryfallId":"16a14eeb-1c85-4029-a047-39a4efef3f74"},{"index":41515,"token":false,"name":"Valleymaker","scryfallId":"50b4fa59-8315-4a66-b5fb-f78daa92aca7"},{"index":41520,"token":false,"name":"Triton Shorethief","scryfallId":"d8f0fe22-dc89-4ad8-b5f6-6d91b61f1385"},{"index":41529,"token":false,"name":"Blessings of Nature","scryfallId":"d16453f1-c6ca-4288-ab72-315ed9bb0ab0"},{"index":41531,"token":false,"name":"Scarwood Hag","scryfallId":"ac2655e4-3a4d-4f73-820a-02fab675d42e"},{"index":41533,"token":false,"name":"Crooked Scales","scryfallId":"fd7084ba-cca6-4fb9-b21b-b79e7d74c5c0"},{"index":41542,"token":false,"name":"Viashino Firstblade","scryfallId":"1cb0c21c-bdf1-478a-9ad8-6c6bda6ffb0f"},{"index":41544,"token":false,"name":"Silver-Inlaid Dagger","scryfallId":"f8b8162a-68f0-45df-bb25-8fd4487257a4"},{"index":41551,"token":false,"name":"Oko's Hospitality","scryfallId":"81fb103d-f07c-4113-9da7-843cc7dab340"},{"index":41555,"token":false,"name":"Revelation","scryfallId":"d467517a-1e6f-4c1f-adb5-bf60df1284e2"},{"index":41559,"token":false,"name":"Niveous Wisps","scryfallId":"bea1e2c4-1671-4322-b8ba-e4e1a879cf37"},{"index":41562,"token":false,"name":"Rise of the Dark Realms","scryfallId":"073f81e8-8c0c-4430-bd3e-95ed3625340f"},{"index":41565,"token":false,"name":"Dazzling Ramparts","scryfallId":"ce43a2df-4305-4ab1-ae45-96cca597650e"},{"index":41566,"token":false,"name":"Olivia Voldaren","scryfallId":"ed750692-ba6a-4a89-ad6d-92fda7edc2cb"},{"index":41571,"token":false,"name":"Thunderscape Apprentice","scryfallId":"75a0b075-5414-48d3-a2b1-47dc20213e96"},{"index":41578,"token":false,"name":"Bladegriff Prototype","scryfallId":"b3c9b4fb-cfb6-4e5a-b23a-9aad9f69710e"},{"index":41585,"token":true,"name":"Land Mine","scryfallId":"30093c6e-505e-4902-b535-707e364059b4"},{"index":41586,"token":false,"name":"Prismari Pledgemage","scryfallId":"404b4c7b-5d40-4ad1-bd40-3da1d08f5c78"},{"index":41587,"token":false,"name":"Phelddagrif","scryfallId":"493a72f0-2e35-4e06-a1b2-d42d432b9b2c"},{"index":41593,"token":false,"name":"Throwing Knife","scryfallId":"5dfce9be-67a2-4e8a-a71f-e88f64067691"},{"index":41599,"token":false,"name":"Bile Blight","scryfallId":"3ca11057-e50a-4817-924a-5bb504d0780f"},{"index":41605,"token":false,"name":"Stronghold Overseer","scryfallId":"e0722fa2-53df-4217-a592-fcaf239f717a"},{"index":41606,"token":false,"name":"Rack and Ruin","scryfallId":"78ac2f29-88bd-447d-b668-876c7261294d"},{"index":41607,"token":false,"name":"Primeval Protector","scryfallId":"4a492479-07d7-4b17-8f72-b8d2ef6bd1a4"},{"index":41610,"token":false,"name":"Whiptongue Frog","scryfallId":"6fc17186-e786-46a3-9812-4a6e367e78b9"},{"index":41612,"token":false,"name":"Gate to Phyrexia","scryfallId":"4eb41639-b96b-4789-b488-24da503ef1e2"},{"index":41615,"token":false,"name":"Shu Foot Soldiers","scryfallId":"cd4268d5-f27b-44a5-91f6-6c90521825fd"},{"index":41618,"token":false,"name":"Tamiyo's Epiphany","scryfallId":"ce338cf3-46dc-4c87-8df5-af27097c7dd4"},{"index":41620,"token":false,"name":"Crabapple Cohort","scryfallId":"8c17b102-a25d-4fff-8718-3bdd53092552"},{"index":41630,"token":false,"name":"Lux Cannon","scryfallId":"a13b7fee-100b-444e-9f13-45b36fd10295"},{"index":41646,"token":false,"name":"Thriving Rats","scryfallId":"52ba911b-6a52-4430-8f61-63bdae25c16a"},{"index":41648,"token":false,"name":"Blade Instructor","scryfallId":"9b1c7f07-8d39-425b-8ae9-b3ab317cc0fe"},{"index":41654,"token":false,"name":"Wormfang Manta","scryfallId":"bc9bf91d-6f7c-4fb5-bbc6-c012212e62e9"},{"index":41655,"token":false,"name":"Archangel of Strife","scryfallId":"b15514f0-0dd8-4e49-a56e-ed829f4c9623"},{"index":41658,"token":false,"name":"Cartouche of Strength","scryfallId":"d6bb237c-4e39-4879-90b4-2f507a90d3d7"},{"index":41666,"token":false,"name":"Tomebound Lich","scryfallId":"5f305027-dfd2-4b17-a6af-6b0576389623"},{"index":41667,"token":false,"name":"Shining Shoal","scryfallId":"78ca16f8-336a-444b-9f78-e97a3f20a3bc"},{"index":41668,"token":false,"name":"Talons of Wildwood","scryfallId":"9ffa2e83-bc78-4bde-9692-e5165c4ef63b"},{"index":41670,"token":false,"name":"Tooth of Ramos","scryfallId":"9a3b999d-8e63-4647-a921-15e169022096"},{"index":41673,"token":false,"name":"Funeral Longboat","scryfallId":"45c48042-178f-432e-9eee-10bfa1e0795f"},{"index":41674,"token":false,"name":"Dwarven Hammer","scryfallId":"f9cc132f-d4c1-4bc4-9c9e-f63ab5e7d094"},{"index":41675,"token":false,"name":"Luxa River Shrine","scryfallId":"9f43dc6f-910c-42a1-b329-038e20dfb264"},{"index":41680,"token":false,"name":"Azorius First-Wing","scryfallId":"b675c1e6-add5-4959-a5be-f2571ccebcb4"},{"index":41690,"token":false,"name":"Ordeal of Nylea","scryfallId":"e5c48950-c246-47ad-94e1-bf42a62c2fe7"},{"index":41693,"token":true,"name":"Brian Kibler Bio","scryfallId":"3746d381-9c73-4d74-aa7f-79426e163eb7"},{"index":41699,"token":false,"name":"Weird Harvest","scryfallId":"89bd2c25-049a-4df2-bf8f-198d1b41b01e"},{"index":41704,"token":false,"name":"Spiteful Squad","scryfallId":"be88355e-c986-4b69-93b4-0abf04916e86"},{"index":41705,"token":false,"name":"Markov Crusader","scryfallId":"87d8354b-df56-4294-9f8a-b7c92e31b88e"},{"index":41713,"token":false,"name":"Ancient Animus","scryfallId":"5ee76006-5272-400d-b6b2-e1548bca9dbf"},{"index":41717,"token":false,"name":"Hazerider Drake","scryfallId":"68d2ae5c-58b9-4690-8039-d50cca9ef6cf"},{"index":41718,"token":false,"name":"Lim-Dûl's Hex","scryfallId":"af976f42-3d56-4e32-8294-970a276a4bf3"},{"index":41719,"token":false,"name":"Runeboggle","scryfallId":"37b2fb23-f8b5-4f83-9b29-b18507acaa1a"},{"index":41734,"token":false,"name":"Escaped Null","scryfallId":"7364dbe9-ee9a-4dcc-b058-4e669c75f060"},{"index":41736,"token":false,"name":"Mystic Meditation","scryfallId":"d169f469-10d5-4ae8-88fe-12a8e20ab01b"},{"index":41737,"token":false,"name":"Thraben Purebloods","scryfallId":"16db28f4-3d96-42f5-a264-592fdc2d4196"},{"index":41743,"token":false,"name":"Argivian Blacksmith","scryfallId":"f1fb4d0b-fa3f-4794-9285-89ddb9ac21c3"},{"index":41750,"token":false,"name":"An-Havva Inn","scryfallId":"eff4531f-d19d-44af-861a-33087197d21c"},{"index":41754,"token":false,"name":"Sailmonger","scryfallId":"142479d8-8956-44a2-8c54-9dd6dc1774c0"},{"index":41755,"token":false,"name":"To the Slaughter","scryfallId":"5a645c8d-7cfb-466b-9fd0-e1c26bf6f652"},{"index":41756,"token":false,"name":"Fresh Volunteers","scryfallId":"e070ea4a-c417-405f-b788-78fb7ca2eaa5"},{"index":41758,"token":true,"name":"Homunculus Token (U, 2/2)","scryfallId":"f3c6ef29-b879-4813-87b0-0e3ba2b5cb29"},{"index":41759,"token":false,"name":"Prized Amalgam","scryfallId":"634cedb6-8b00-4f4b-8790-541188955295"},{"index":41760,"token":false,"name":"Battlegate Mimic","scryfallId":"dc2a0bc8-d736-45e6-ac20-63c5ca69a8d5"},{"index":41762,"token":false,"name":"Haze of Rage","scryfallId":"846134c0-5a8d-4ccb-8451-db29b70be3f5"},{"index":41764,"token":false,"name":"Morgue Thrull","scryfallId":"270a26ce-3435-4fef-bc34-abbc6f1cf3f4"},{"index":41771,"token":false,"name":"Battleflight Eagle","scryfallId":"4182dbd5-8eae-4f4b-86aa-2bfc24481800"},{"index":41775,"token":false,"name":"Spell Contortion","scryfallId":"4b748d8b-898f-4b55-bc33-f5bbbc823c45"},{"index":41782,"token":false,"name":"Tentative Connection","scryfallId":"5c40fd33-bb95-48f3-a10f-a33eb27c48f1"},{"index":41783,"token":false,"name":"Tuktuk Grunts","scryfallId":"e6f37982-d2ae-4ff1-b5da-3936733f8108"},{"index":41790,"token":false,"name":"Keensight Mentor","scryfallId":"a0583065-9a6c-4ea4-b6dd-2edfbaed1181"},{"index":41793,"token":false,"name":"Sliver Construct","scryfallId":"3129645a-221c-4eb5-88fd-12cc742a1dfe"},{"index":41796,"token":false,"name":"Expendable Troops","scryfallId":"f31d7d1b-a219-4653-be99-a885bc9b2e2f"},{"index":41797,"token":false,"name":"Crystalline Resonance","scryfallId":"93f20664-c3d0-4dbd-93dc-4f69a0cbff46"},{"index":41798,"token":false,"name":"Jorubai Murk Lurker","scryfallId":"7af346ac-32a6-49a8-986d-834b2c8c0478"},{"index":41799,"token":false,"name":"Mistvault Bridge","scryfallId":"9f36a6e2-3e51-4a30-a225-10cfe6650b9d"},{"index":41803,"token":false,"name":"Glademuse","scryfallId":"89a40dc1-3bd8-4c7e-9446-5abc8c1f6995"},{"index":41814,"token":false,"name":"Shieldmage Elder","scryfallId":"efa2d660-7c93-4087-a6e5-49c2ad21eb5a"},{"index":41815,"token":false,"name":"Gravity Sphere","scryfallId":"a2749332-e99a-4a0c-b3a3-5578b552fa11"},{"index":41816,"token":false,"name":"Butcher Orgg","scryfallId":"7f2a29cf-4b2e-44c0-af73-512d6fed0dae"},{"index":41821,"token":false,"name":"Basalt Golem","scryfallId":"5ff538f9-10b4-4327-aea6-a86759daf488"},{"index":41828,"token":false,"name":"Research // Development","scryfallId":"5d48ee48-aaeb-4907-b9dc-32f22e95ae4c"},{"index":41831,"token":false,"name":"Monsoon","scryfallId":"254fcc50-79a5-40cd-b028-e78dde3f8480"},{"index":41832,"token":false,"name":"Lorehold Pledgemage","scryfallId":"79b88b38-6b5a-4a89-80ca-add79c11e8b9"},{"index":41835,"token":false,"name":"Sanctum of Eternity","scryfallId":"a680cc6d-9c31-4f5d-808f-dace92bf4346"},{"index":41839,"token":false,"name":"Ambitious Aetherborn","scryfallId":"80cb628e-fa83-4d7e-92cb-8779ea02193f"},{"index":41840,"token":false,"name":"Valorous Steed","scryfallId":"aa01cb8c-f080-456b-a91a-f1d7943a70b2"},{"index":41848,"token":false,"name":"Vengeful Rebel","scryfallId":"1066815f-74fa-4f0d-90ea-04176b1227ce"},{"index":41849,"token":false,"name":"Entrails Feaster","scryfallId":"cdddab92-3e1f-49dc-afd0-8c84d0d952c2"},{"index":41858,"token":false,"name":"Arcbound Shikari","scryfallId":"8d54c510-19bf-4da4-a51b-1caadf960654"},{"index":41868,"token":false,"name":"Veil of Summer","scryfallId":"802ec16f-efa4-4618-8bbe-3377d8a0c9c4"},{"index":41869,"token":false,"name":"Moon Heron","scryfallId":"a24de601-1d7b-41c4-aba1-fdb6fd8d5251"},{"index":41879,"token":false,"name":"Expel","scryfallId":"be517a58-b7ee-4213-98a5-8c19e1b2def6"},{"index":41887,"token":false,"name":"Collapsing Borders","scryfallId":"cc019633-788e-4095-9610-6c0a432f7656"},{"index":41894,"token":false,"name":"Witching Well","scryfallId":"62d3132f-f897-4a7a-9de4-c6388e83f5ad"},{"index":41896,"token":false,"name":"Explosive Revelation","scryfallId":"d7a38cd0-2cd3-436d-bb44-79778d5808ad"},{"index":41901,"token":false,"name":"Cradle of the Accursed","scryfallId":"41713e82-c3d3-4c2f-b075-f684cbd68ce8"},{"index":41910,"token":false,"name":"Punish Ignorance","scryfallId":"9bc37d01-ffe5-4dfe-b59e-204df82d1d36"},{"index":41913,"token":false,"name":"Showstopper","scryfallId":"2fd1f68b-3f16-484e-95c9-5cfa8da218c9"},{"index":41917,"token":false,"name":"Emrakul's Evangel","scryfallId":"51e02aef-dd9f-4cb6-9d58-04e5855dca14"},{"index":41920,"token":false,"name":"Deglamer","scryfallId":"985b43aa-58f0-42fc-9ef0-a7925727d58f"},{"index":41922,"token":false,"name":"Satyr Nyx-Smith","scryfallId":"3bc2c65e-3cba-4813-9949-87e15f592247"},{"index":41923,"token":false,"name":"Haunter of Nightveil","scryfallId":"438683f5-adfa-42ae-a6fb-c4649a8a30ab"},{"index":41926,"token":false,"name":"Vicious Betrayal","scryfallId":"75ca003f-dc03-4533-a245-fde836aab5eb"},{"index":41935,"token":false,"name":"Pulling Teeth","scryfallId":"6cdce79d-c8a6-4172-8211-7cf2dcb8bf2d"},{"index":41939,"token":false,"name":"Cruel Feeding","scryfallId":"a53624ee-2925-4a56-8706-e278db5d963d"},{"index":41942,"token":false,"name":"Firecannon Blast","scryfallId":"b1f083c3-d7b0-4d3d-8551-af52c7883d83"},{"index":41947,"token":false,"name":"Death Speakers","scryfallId":"dd4e2d4c-7674-416e-9111-e4fbdd9240f6"},{"index":41954,"token":false,"name":"Vizkopa Vampire","scryfallId":"61245466-694f-4a80-b556-4e7f876aedca"},{"index":41960,"token":false,"name":"Skywinder Drake","scryfallId":"628213e9-bde9-43fd-a0d9-8c7fb17be879"},{"index":41962,"token":false,"name":"Persistent Petitioners","scryfallId":"e93f0c57-eb80-4dde-bdb0-326970491621"},{"index":41965,"token":false,"name":"Nearheath Chaplain","scryfallId":"362ec364-39c1-4a4b-8dfa-268fad2effdd"},{"index":41968,"token":false,"name":"Rallying Roar","scryfallId":"d03a5efb-fde9-4bba-be80-d073eba2ad8d"},{"index":41972,"token":false,"name":"Thistledown Liege","scryfallId":"20e34233-0972-4aa7-a5ab-eabed2235148"},{"index":41976,"token":false,"name":"Imperial Aerosaur","scryfallId":"7d08f90b-9b98-4237-9826-578fb812d412"},{"index":41997,"token":false,"name":"Sanctum of Shattered Heights","scryfallId":"482ae7f4-3950-4766-8392-eea753e29426"},{"index":41998,"token":false,"name":"Militant Inquisitor","scryfallId":"68d99f1f-80d6-4b5e-aeae-83fb8ae62cdc"},{"index":42000,"token":false,"name":"Drown in Filth","scryfallId":"eeb8576a-752c-4f11-9f4c-75a6e77a085c"},{"index":42003,"token":false,"name":"Urborg Skeleton","scryfallId":"6e522a62-fbca-4362-9006-d4356c525704"},{"index":42006,"token":false,"name":"Netherborn Phalanx","scryfallId":"b665e905-cb06-48b7-9f50-5916277e237d"},{"index":42014,"token":false,"name":"Indestructibility","scryfallId":"e086a062-d39b-4e2a-bde0-f4d6d1797a5f"},{"index":42018,"token":false,"name":"Crovax the Cursed","scryfallId":"487e843f-b710-452c-93fe-fce3f90a4d1c"},{"index":42026,"token":false,"name":"It That Betrays","scryfallId":"34d790ad-3559-4c32-9057-e2e326740bdc"},{"index":42028,"token":false,"name":"Tajuru Blightblade","scryfallId":"7f3d6020-6767-406c-bf28-6b3e9ae72f50"},{"index":42034,"token":false,"name":"Armament of Nyx","scryfallId":"4203df15-dd44-496b-889a-d7a8fe320330"},{"index":42040,"token":false,"name":"Angel's Tomb","scryfallId":"fffaa737-ce46-4f35-aa8c-bd9bb77ed9f6"},{"index":42046,"token":false,"name":"Mindcrank","scryfallId":"2679a847-7196-4a45-8610-229aa2e124d6"},{"index":42047,"token":false,"name":"Cadaverous Bloom","scryfallId":"c9bef70b-61c7-4df5-b4df-09cd6ab2015c"},{"index":42048,"token":false,"name":"Stratus Dancer","scryfallId":"82fb8b0c-b86e-4915-b72d-9a6b5c1368c7"},{"index":42049,"token":false,"name":"Roots of Life","scryfallId":"26724a51-87dd-4159-b012-71598e4cf5eb"},{"index":42051,"token":false,"name":"Mephitic Vapors","scryfallId":"675640ba-37e7-4231-8524-87e8b87ea46f"},{"index":42058,"token":false,"name":"Karoo","scryfallId":"a0eeca39-6f76-488e-b3c0-99441539705f"},{"index":42060,"token":false,"name":"Risen Reef","scryfallId":"82389aaa-9f32-4169-a71c-1aea5af9e935"},{"index":42062,"token":false,"name":"Suncrusher","scryfallId":"66c22071-959e-4986-aa25-ed883a20796b"},{"index":42063,"token":false,"name":"Armed Response","scryfallId":"7029fac9-ef8a-499f-aa42-c145b6b528ae"},{"index":42064,"token":false,"name":"Nef-Crop Entangler","scryfallId":"c8e41f4a-dc4d-4f00-875d-0f16b0515b99"},{"index":42066,"token":false,"name":"Arcane Adaptation","scryfallId":"bf3edaaf-cf63-4e17-94ae-9d9991d9fb5f"},{"index":42076,"token":false,"name":"Alpha Kavu","scryfallId":"545ed916-59fc-4c60-9260-8c2dc88e67a1"},{"index":42085,"token":false,"name":"Silent Assassin","scryfallId":"ba34034a-1150-41c8-a340-543f529ae07f"},{"index":42088,"token":false,"name":"Orchard Strider","scryfallId":"386da156-59cd-4b96-9276-a7cb2ddd0421"},{"index":42096,"token":false,"name":"Emergence Zone","scryfallId":"ab95f6e7-b806-47fe-a071-6c38b3176d94"},{"index":42100,"token":false,"name":"Rousing of Souls","scryfallId":"1b7a47cc-9311-4f92-b19c-8956db5f2b5f"},{"index":42104,"token":false,"name":"Goblin Wizardry","scryfallId":"d7ac8bdd-851f-449d-a108-70578eabf254"},{"index":42105,"token":false,"name":"Augury Adept","scryfallId":"4ba392e1-f310-4496-9d29-99a8783cc0f3"},{"index":42106,"token":false,"name":"Tower Above","scryfallId":"50cc1e47-3786-4ba9-b837-bf5b43323135"},{"index":42107,"token":false,"name":"Controlled Instincts","scryfallId":"b04e58e8-cb01-49b0-89b7-26536eb44e97"},{"index":42108,"token":false,"name":"Boot Nipper","scryfallId":"cff5a5b8-f823-4429-acd8-c4f34a676cb4"},{"index":42109,"token":false,"name":"Keeper of the Beasts","scryfallId":"cccccf78-8b00-406b-a2b7-0e6ba76703d0"},{"index":42111,"token":false,"name":"Chant of the Skifsang","scryfallId":"6e604b2e-f257-465d-9342-6eb55b2334c5"},{"index":42118,"token":false,"name":"Littjara Mirrorlake","scryfallId":"6bf2bb3e-828f-4d53-9d0a-26bbc5e7f3cc"},{"index":42121,"token":false,"name":"Mistform Warchief","scryfallId":"a633d85b-4be1-44a2-8fd8-1ccec4a95ecb"},{"index":42122,"token":false,"name":"Swift Spinner","scryfallId":"264f78d8-d554-45f3-867e-19dba38e4644"},{"index":42126,"token":false,"name":"Angel of Grace","scryfallId":"80164e61-3e94-4e10-9bd1-518b8dc7fc4c"},{"index":42136,"token":false,"name":"Vastwood Animist","scryfallId":"d5cc40e7-fb31-4540-81a1-d0c0f514c8a8"},{"index":42137,"token":false,"name":"Touch of Moonglove","scryfallId":"bf659f2f-983c-4a62-a969-4176e5fbe193"},{"index":42143,"token":false,"name":"Tenacity","scryfallId":"41fbe149-3e1f-495e-be1b-efc3a6dbcb08"},{"index":42145,"token":false,"name":"Butcher's Cleaver","scryfallId":"e141fe62-515e-4fe4-b032-81f169ec58d6"},{"index":42153,"token":false,"name":"Soratami Savant","scryfallId":"43ea2db8-67c6-4bcd-8ba1-f620b8e8a8c4"},{"index":42158,"token":false,"name":"Icatian Crier","scryfallId":"c5ba6543-ede7-45a5-8e8d-e17d3f545d3f"},{"index":42162,"token":false,"name":"Jungleborn Pioneer","scryfallId":"9f01ae0d-db1e-4912-b8ad-3069f6938e04"},{"index":42163,"token":false,"name":"Fallow Earth","scryfallId":"44b02b12-415c-49f4-9f60-fa53beb4216f"},{"index":42165,"token":false,"name":"Open the Gates","scryfallId":"ff326c57-accb-4b75-9bc9-b5ef1a85f38d"},{"index":42166,"token":false,"name":"Forfend","scryfallId":"a410e333-60f2-4e19-ad0f-5259d4feab37"},{"index":42169,"token":false,"name":"Shu Elite Infantry","scryfallId":"36bcd751-1142-4e72-9d87-7a25c74c038b"},{"index":42176,"token":false,"name":"Pygmy Hippo","scryfallId":"2e3f6220-6ead-46b4-8663-57609ef5a12e"},{"index":42180,"token":false,"name":"Shu Cavalry","scryfallId":"b8761f17-6f6d-45c3-a626-003396093142"},{"index":42183,"token":false,"name":"Keen Glidemaster","scryfallId":"cce6289e-f665-4faa-8285-c843447f3e52"},{"index":42187,"token":false,"name":"Flow of Ideas","scryfallId":"3194d88d-6f2c-47ed-ad9c-d55bb1858e79"},{"index":42195,"token":false,"name":"Shivan Raptor","scryfallId":"0fc45153-3cb1-43bc-b694-06f6a74b3eb7"},{"index":42201,"token":false,"name":"Plague of Vermin","scryfallId":"231613d6-d3b8-4b41-bc93-4d5da3fec5d0"},{"index":42203,"token":false,"name":"Disorient","scryfallId":"17965a3c-92b4-4f01-b076-e40c567eed33"},{"index":42204,"token":true,"name":"Thrull Token (B, 1/1)","scryfallId":"5b9f471a-1822-4981-95a9-8923d83ddcbf"},{"index":42209,"token":false,"name":"Caustic Crawler","scryfallId":"80076580-23f1-4008-ab91-9dad8c806cfa"},{"index":42215,"token":false,"name":"Savor the Moment","scryfallId":"93a0d9ad-31bf-4561-a5b2-f44a12a2c2c2"},{"index":42223,"token":false,"name":"Fight or Flight","scryfallId":"46bde162-3737-4b93-a27a-63b909a4183d"},{"index":42227,"token":false,"name":"Fanatic of Mogis","scryfallId":"9ea86c57-896f-405a-9eed-e567a8646982"},{"index":42237,"token":false,"name":"Phantasmal Form","scryfallId":"f106e515-511a-48c7-b7a7-3ca820950122"},{"index":42241,"token":false,"name":"Mudhole","scryfallId":"993d31bc-7355-4dfc-ac4e-ababaa0dc529"},{"index":42246,"token":false,"name":"Argent Sphinx","scryfallId":"280e75af-7e43-4c15-a8a8-bec7389c6c4e"},{"index":42253,"token":false,"name":"Darkthicket Wolf","scryfallId":"fec37c5a-8223-441c-a8a6-8da1a2dfc3fb"},{"index":42258,"token":false,"name":"Rain of Gore","scryfallId":"9dd62003-e345-48b6-9f93-fc111924c318"},{"index":42259,"token":true,"name":"Angel // Angel","scryfallId":"e2235007-b02e-463b-95e1-a8bea74a0f9d"},{"index":42265,"token":false,"name":"Archmage Ascension","scryfallId":"dbfe803d-88d7-4ad2-b3d8-c41c123d8bf3"},{"index":42276,"token":false,"name":"Dakra Mystic","scryfallId":"8e5f71ca-e7d9-4f9a-adf1-40353693deea"},{"index":42277,"token":false,"name":"Tilonalli's Crown","scryfallId":"f0e941a7-c2c1-4855-b79a-c0dfebb28854"},{"index":42279,"token":false,"name":"Insatiable Harpy","scryfallId":"1439ed8d-ae11-4159-9420-5d98c6cc93b3"},{"index":42280,"token":false,"name":"Serpent's Gift","scryfallId":"0e27503e-059e-4c44-a817-678e67254111"},{"index":42287,"token":false,"name":"Troublesome Spirit","scryfallId":"23d7e856-6852-4b97-ae0e-a4becdfc8166"},{"index":42291,"token":false,"name":"Kenrith, the Returned King","scryfallId":"56c1227e-bea7-47cb-bbec-389a3d585af5"},{"index":42292,"token":false,"name":"Trollhide","scryfallId":"32c8d6ed-4764-433b-9617-363e46e5b250"},{"index":42294,"token":false,"name":"Kithkin Zealot","scryfallId":"76f9a29c-9219-424f-a703-dccffbf23cdc"},{"index":42297,"token":false,"name":"Meltdown","scryfallId":"9e7a967a-35a0-4e5c-a32b-123a9cfdb79e"},{"index":42298,"token":false,"name":"Vithian Renegades","scryfallId":"7459a075-1a5d-4053-ab49-21bb696b6400"},{"index":42312,"token":false,"name":"Force of Savagery","scryfallId":"b344511d-631e-4f1d-9d7d-d7c89a473d1b"},{"index":42316,"token":false,"name":"Spy Network","scryfallId":"8a4bed3f-845c-4822-b8af-8b511dce6fe2"},{"index":42320,"token":false,"name":"Chameleon Blur","scryfallId":"6d506b1c-f329-4e07-8926-a87b4abf16a7"},{"index":42321,"token":false,"name":"Ulamog's Reclaimer","scryfallId":"29a237a6-0e72-47ce-b28d-a0260963f406"},{"index":42326,"token":false,"name":"Fusion Elemental","scryfallId":"c6712dbd-ee54-4fb7-93ab-64f8f07350f1"},{"index":42327,"token":false,"name":"Callous Deceiver","scryfallId":"628d3058-d32e-438c-9a86-3e9c2be73c4a"},{"index":42331,"token":false,"name":"Stromgald Spy","scryfallId":"0cf8cecc-449f-4cc6-ac4d-440722df0ab9"},{"index":42332,"token":false,"name":"Kaervek's Hex","scryfallId":"097910fb-7c48-4535-8ffc-b521d08294b0"},{"index":42333,"token":false,"name":"Viashino Fangtail","scryfallId":"2616dac9-bbcf-453a-9205-8e433a1c62aa"},{"index":42338,"token":false,"name":"Graf Mole","scryfallId":"25a40334-65d8-46d2-9c56-389e9b32107c"},{"index":42341,"token":false,"name":"Memory Leak","scryfallId":"3b45a493-a1c2-430e-a45c-abc1ba554877"},{"index":42348,"token":false,"name":"Scavenger Drake","scryfallId":"4c5249a7-de7f-445f-a24f-9c429f45c779"},{"index":42373,"token":false,"name":"Pyroceratops","scryfallId":"f6599645-dbb5-4174-bd26-8556af6d89c3"},{"index":42377,"token":false,"name":"White Scarab","scryfallId":"c57726b5-dfdd-4e47-bc52-ebf6eedbf3bd"},{"index":42378,"token":false,"name":"Prickly Boggart","scryfallId":"55121b63-22a6-4923-82e9-c55f66742980"},{"index":42384,"token":false,"name":"Goblin War Buggy","scryfallId":"d2d0fc9e-fb6b-4a00-b422-32565f7ce454"},{"index":42389,"token":false,"name":"Goblin Sappers","scryfallId":"de839540-a7b9-4f91-91df-3fd4f5c0bc4e"},{"index":42392,"token":false,"name":"Scion Summoner","scryfallId":"826a882e-c4bd-4132-b797-9e1aa2d0bce4"},{"index":42400,"token":false,"name":"Cooperation","scryfallId":"21a815ed-c8b4-4414-8b27-ea612e2977e2"},{"index":42401,"token":false,"name":"Aetherstream Leopard","scryfallId":"6f3a727a-5eca-44de-aa8f-0d2573db83eb"},{"index":42402,"token":false,"name":"Gorilla Titan","scryfallId":"435d9562-8f2b-43fe-ba21-8f5896378280"},{"index":42405,"token":false,"name":"Rune of Protection: Green","scryfallId":"905712b2-3177-4935-bca1-6990439b8d78"},{"index":42407,"token":false,"name":"Blazing Sunsteel","scryfallId":"69d276fe-5f2b-41aa-80fa-64d3b60fd54f"},{"index":42414,"token":false,"name":"Saprazzan Cove","scryfallId":"52a69122-19c0-47ec-8bea-478511ba88e6"},{"index":42417,"token":false,"name":"Naiad of Hidden Coves","scryfallId":"dc6ae489-658b-4c12-b204-f7b58ce84375"},{"index":42420,"token":false,"name":"Purge the Profane","scryfallId":"937ee156-0105-4291-8c67-d03a59c24679"},{"index":42423,"token":false,"name":"Grisly Survivor","scryfallId":"035ee44d-63ef-45b7-b36b-38ac341a2ca7"},{"index":42424,"token":false,"name":"Thriving Rhino","scryfallId":"5acf10ec-f2dd-4569-909b-ac52a9ed6adf"},{"index":42425,"token":false,"name":"Tilonalli's Knight","scryfallId":"b25c2f33-1707-4ff3-a22e-58f51936b733"},{"index":42435,"token":false,"name":"Flowering Field","scryfallId":"c241fd76-f52d-48fc-864c-57caffa700f6"},{"index":42441,"token":false,"name":"Demotion","scryfallId":"69202217-ef36-4d6c-bbd0-ebbb2ade51f7"},{"index":42442,"token":false,"name":"Spire Garden","scryfallId":"64943615-7543-4acd-a884-22ece8f0ed3e"},{"index":42443,"token":true,"name":"Elemental Token (G, 2/2)","scryfallId":"b7047838-ac9f-4ca1-9827-73d87098124f"},{"index":42446,"token":false,"name":"Circling Vultures","scryfallId":"8dae8e49-c2b6-4965-9249-49f93449d271"},{"index":42453,"token":false,"name":"Kookus","scryfallId":"8fb90922-99d2-4b36-9039-bb806fd01756"},{"index":42462,"token":false,"name":"Striking Sliver","scryfallId":"4ee9254b-3d98-4477-a82e-1450cf3ee96e"},{"index":42465,"token":false,"name":"Coffin Queen","scryfallId":"edf8af70-c26d-4b78-aad6-bd51b5afc590"},{"index":42482,"token":false,"name":"Phyrexian Soulgorger","scryfallId":"1ed11cef-3904-4bc3-8383-14ecdb774066"},{"index":42483,"token":false,"name":"Overrule","scryfallId":"22b83a31-f974-4a49-b9ee-92f7767f11e0"},{"index":42484,"token":false,"name":"Fumble","scryfallId":"64019dd4-b00b-4521-a869-e302f23167da"},{"index":42485,"token":false,"name":"Enduring Victory","scryfallId":"54fef763-7ee2-4341-9c67-546e4b6710b7"},{"index":42486,"token":false,"name":"Tangle Mantis","scryfallId":"c0e4d333-78f7-4710-9b26-36e285c0d9f8"},{"index":42488,"token":false,"name":"Aura Extraction","scryfallId":"55d16883-5e98-4dd2-92dd-0ba92f1099cb"},{"index":42491,"token":true,"name":"Beast Token (G, 5/5)","scryfallId":"44675b6a-ea5a-44f1-9f2c-3725cdfcc814"},{"index":42492,"token":false,"name":"Sight of the Scalelords","scryfallId":"b5921758-4e21-4d34-8cf7-b0205d4b0912"},{"index":42496,"token":false,"name":"Curse of Vengeance","scryfallId":"08d14310-11e6-4041-8807-36467e2dde53"},{"index":42497,"token":false,"name":"Mantle of Webs","scryfallId":"a96285a4-57bf-4ef1-b960-b03601e6d209"},{"index":42508,"token":false,"name":"Bogardan Lancer","scryfallId":"44814464-e5b6-46c6-ac2e-d7234add43f4"},{"index":42512,"token":false,"name":"Veteran's Reflexes","scryfallId":"783f220b-f860-4ebb-a424-22598bdd6fae"},{"index":42517,"token":false,"name":"Rhystic Tutor","scryfallId":"e02c1609-9cac-460f-8504-a84e28c340c1"},{"index":42524,"token":true,"name":"2000 World Championships Ad","scryfallId":"5ee6f44e-f788-46fd-a1d9-d3c7009a0ff2"},{"index":42525,"token":false,"name":"Reverent Hoplite","scryfallId":"54153b9c-483e-4e5c-a1ab-b1c8a7a657d4"},{"index":42528,"token":false,"name":"Avian Changeling","scryfallId":"1fe4fba9-5ff4-4e4b-be28-2849fa3c7003"},{"index":42529,"token":false,"name":"Possessed Portal","scryfallId":"616836e6-caf4-4398-a772-9c67f84c73c5"},{"index":42543,"token":false,"name":"Essence Flux","scryfallId":"639bdbb5-8c2d-439d-bcea-dc54da9686ea"},{"index":42548,"token":false,"name":"Hieromancer's Cage","scryfallId":"197743cd-249c-42ba-ac8d-027c088f8418"},{"index":42552,"token":false,"name":"Gloomhunter","scryfallId":"98db4317-9850-44c1-884b-d8d3abe1afeb"},{"index":42554,"token":false,"name":"Titan Hunter","scryfallId":"eb564473-7416-4cf7-971a-e6dc5eb10445"},{"index":42557,"token":false,"name":"Whispering Shade","scryfallId":"5fbfdc2a-7bf3-4461-bef7-fa499d29d1b8"},{"index":42559,"token":false,"name":"Magus of the Tabernacle","scryfallId":"dd520f8c-93fb-4cf3-8dd5-d05abbd86c74"},{"index":42575,"token":false,"name":"Deadly Visit","scryfallId":"462fe190-5264-42d8-bd27-23c5aa0c641f"},{"index":42582,"token":false,"name":"Fight to the Death","scryfallId":"5552ca9b-0245-4f91-9646-a5b5443863a2"},{"index":42583,"token":false,"name":"Skyshroud Elf","scryfallId":"26877a52-dec3-433d-b7a5-767f6cdf2365"},{"index":42584,"token":false,"name":"Fell the Pheasant","scryfallId":"33d3cc84-7cb6-4de2-9018-4695a3b1e099"},{"index":42591,"token":false,"name":"Chronic Flooding","scryfallId":"1a757425-3cf2-4aca-b415-5ec2d5f753fe"},{"index":42595,"token":false,"name":"Mirror-Mad Phantasm","scryfallId":"b20eea41-9daf-4ac1-8bad-bb4aa211bb53"},{"index":42597,"token":false,"name":"Stampeding Serow","scryfallId":"47c63065-6051-4193-8457-713a8a800393"},{"index":42599,"token":false,"name":"Crypt Lurker","scryfallId":"c0bba170-5176-4fab-a10d-e23d70128875"},{"index":42601,"token":false,"name":"Guardian of the Guildpact","scryfallId":"c8dd004b-01e4-4fe1-a164-9f2ea8d7d88e"},{"index":42608,"token":false,"name":"Parallel Lives","scryfallId":"01033dae-fec1-41f2-b7f2-cc6a43331790"},{"index":42615,"token":false,"name":"Stitched Mangler","scryfallId":"c03c643c-8e4c-4dc9-8756-c253fa057729"},{"index":42618,"token":false,"name":"Stymied Hopes","scryfallId":"5702b757-5be5-4a48-bc73-a87ec4f3193b"},{"index":42624,"token":false,"name":"Barbed Field","scryfallId":"1c76db48-6f05-49c3-a49c-587c0a8a3613"},{"index":42629,"token":false,"name":"Cloud Crusader","scryfallId":"83ce09da-6c1d-46ac-870e-ff58ceaba116"},{"index":42632,"token":false,"name":"Suffocating Fumes","scryfallId":"66b562e4-35df-4aee-848d-ceb4204bbe58"},{"index":42635,"token":false,"name":"Hunted Phantasm","scryfallId":"faec8ab3-80c6-4b8f-a60d-50cc683e66b4"},{"index":42636,"token":false,"name":"Phthisis","scryfallId":"cb65f5ff-1f0a-469c-831f-618254727111"},{"index":42643,"token":false,"name":"Olivia's Bloodsworn","scryfallId":"fdda34e9-f28b-4606-8298-b2d0c15033e6"},{"index":42644,"token":false,"name":"Unwilling Ingredient","scryfallId":"30448144-639a-43c7-a408-bd6ed543c231"},{"index":42650,"token":false,"name":"Academy Researchers","scryfallId":"b62ca800-ec24-476e-b56f-834eef9622a9"},{"index":42656,"token":false,"name":"Baloth Gorger","scryfallId":"504090bb-d183-4833-aea5-d4193b5c57a1"},{"index":42658,"token":false,"name":"Glimpse of Nature","scryfallId":"1ddcd76b-a7a1-4ae6-bf4a-f929c6574bdc"},{"index":42659,"token":false,"name":"Foundry Helix","scryfallId":"9c54b7c6-f94c-4349-8725-319c54240409"},{"index":42663,"token":false,"name":"Ivory Gargoyle","scryfallId":"07d79058-2a78-4237-83b0-4715053e8267"},{"index":42667,"token":false,"name":"Matter Reshaper","scryfallId":"35715dad-98b5-4b15-b94c-395edf4d6665"},{"index":42677,"token":false,"name":"Cliffhaven Kitesail","scryfallId":"eebf8f67-49d0-42de-a5cc-ad13d19d2c55"},{"index":42680,"token":false,"name":"Cliffhaven Sell-Sword","scryfallId":"7f334767-4353-4379-a934-fa67075db439"},{"index":42683,"token":false,"name":"Crimson Kobolds","scryfallId":"889f4908-42c0-46e2-a83f-394d9fcd58ba"},{"index":42684,"token":false,"name":"Mycosynth Fiend","scryfallId":"bdcd1b8e-9f1f-48a3-b7a1-43a32cc03bb1"},{"index":42687,"token":false,"name":"Twinscroll Shaman","scryfallId":"87193af5-4b6b-48d0-9b75-8171bb1d6e53"},{"index":42691,"token":false,"name":"Cazur, Ruthless Stalker","scryfallId":"d5e857aa-06b7-4bce-b56d-6f6be5cfc77b"},{"index":42697,"token":false,"name":"Necrotic Plague","scryfallId":"2e7573a8-be2b-46a5-8862-db0980968088"},{"index":42700,"token":false,"name":"Centaur Veteran","scryfallId":"a83903c1-40fe-47a5-8bcc-2f0877c58225"},{"index":42705,"token":false,"name":"Harmonic Sliver","scryfallId":"c1cfc5db-3fc0-428e-8d4b-f6ea6caea36d"},{"index":42717,"token":false,"name":"Duskwatch Recruiter // Krallenhorde Howler","scryfallId":"e1915d93-c7dd-4bb7-bd5c-63a359a02b97"},{"index":42721,"token":false,"name":"Tezzeret, Agent of Bolas","scryfallId":"0f3c8470-1cc8-4383-8782-c022867d46e8"},{"index":42723,"token":false,"name":"Call the Gatewatch","scryfallId":"4719ac60-2cff-4abb-b9cc-b677d3ac945c"},{"index":42725,"token":false,"name":"Blood Operative","scryfallId":"04d182e5-78c3-45a3-b719-2b3a522de925"},{"index":42734,"token":false,"name":"Battlegrowth","scryfallId":"2b34e76b-86b3-464e-93e7-c3f2074028fb"},{"index":42736,"token":false,"name":"Restless Bones","scryfallId":"4d11a4f2-376e-42ae-9693-9dc754bd2282"},{"index":42740,"token":false,"name":"Satyr Grovedancer","scryfallId":"d46febca-f3c0-4467-aef4-4dfcdf3009fe"},{"index":42747,"token":false,"name":"Gurmag Drowner","scryfallId":"56794d88-9f26-466e-b768-9ea18c8a4bd9"},{"index":42754,"token":false,"name":"Ajani, Adversary of Tyrants","scryfallId":"e2eb3bb2-0ba7-4632-9a74-f03b330c1ee3"},{"index":42755,"token":false,"name":"Rushblade Commander","scryfallId":"f654a0de-50aa-448d-9bad-0870b32a0a49"},{"index":42762,"token":false,"name":"Lose Calm","scryfallId":"732a4912-97d1-4640-976e-ae1ffeb70236"},{"index":42766,"token":false,"name":"Chimeric Coils","scryfallId":"9cbe14e2-89f2-4458-a84f-08ed3c6ae3d7"},{"index":42768,"token":false,"name":"Words of Worship","scryfallId":"0ea5c6e0-8361-4214-997b-32a66b19fae9"},{"index":42774,"token":false,"name":"Deadly Designs","scryfallId":"6fbdf30e-effe-4008-ba9d-2157f6d21f55"},{"index":42775,"token":false,"name":"Daybreak Chimera","scryfallId":"f9c1de31-73d4-4c32-9f99-e15df48638e9"},{"index":42784,"token":false,"name":"Filigree Sages","scryfallId":"08790aaf-0142-4b20-89cf-cdaffeea4582"},{"index":42790,"token":false,"name":"Wirewood Elf","scryfallId":"10a34e31-97f1-40e8-9d91-a8139af7f096"},{"index":42793,"token":false,"name":"Waterfall Aerialist","scryfallId":"7bc6966c-18d9-4675-9594-6f0b2d11c405"},{"index":42796,"token":false,"name":"Deepwood Elder","scryfallId":"d2a1ed74-027e-4c8e-ac7e-e58c5fccff14"},{"index":42801,"token":false,"name":"Lightkeeper of Emeria","scryfallId":"79d0234f-d712-4ac3-bd3b-10f9c530e167"},{"index":42806,"token":false,"name":"Retreat to Valakut","scryfallId":"f7a9ce97-ef6d-468c-b389-8d19c76174c2"},{"index":42807,"token":false,"name":"Ghitu Journeymage","scryfallId":"e4360bc9-76f0-4e82-8968-4c6c62a35ed1"},{"index":42812,"token":false,"name":"Brightstone Ritual","scryfallId":"5b08b0a6-c94e-4407-8a24-c8202497b5f2"},{"index":42813,"token":false,"name":"Graypelt Hunter","scryfallId":"ed04a5a7-f7d0-4dd8-9c23-6a767814316a"},{"index":42820,"token":false,"name":"Galloping Lizrog","scryfallId":"cc2b7cfe-4696-4448-93d2-33be596e32d9"},{"index":42824,"token":false,"name":"Lightning Volley","scryfallId":"b2af8746-033d-4a8a-b62d-ab5addb33d4d"},{"index":42827,"token":false,"name":"Valley Dasher","scryfallId":"8543adbd-0dd1-47d3-ac41-2ec72d6a5d35"},{"index":42831,"token":false,"name":"End Hostilities","scryfallId":"80a53ed7-a7b7-40d8-9239-cf6f205dbc59"},{"index":42837,"token":false,"name":"Smog Elemental","scryfallId":"667871d3-0d1b-496b-afbd-7504989798e4"},{"index":42841,"token":false,"name":"Liquify","scryfallId":"12fadf25-0995-440d-a3e6-7964ed86cff6"},{"index":42848,"token":false,"name":"Wall of Shards","scryfallId":"0964d2a4-54de-406d-9d24-de05e728d27a"},{"index":42851,"token":false,"name":"Primordial Wurm","scryfallId":"39fb52be-0e17-437d-8583-af69cdfff87b"},{"index":42853,"token":false,"name":"Gaze of Adamaro","scryfallId":"44cab92a-54d8-496c-8a97-7f3448f5b1e9"},{"index":42861,"token":false,"name":"Dune-Brood Nephilim","scryfallId":"15b4ee44-28c4-4a39-9c06-aca43787954f"},{"index":42862,"token":false,"name":"Perplexing Test","scryfallId":"31f2cbcc-d5b8-4659-ae51-e567c555a743"},{"index":42866,"token":false,"name":"Hex Parasite","scryfallId":"43502078-5349-4e29-8e7d-277654a9a71e"},{"index":42867,"token":false,"name":"Master Apothecary","scryfallId":"f9ff6624-ed0e-43d0-9519-112979b165f5"},{"index":42870,"token":false,"name":"Sivvi's Valor","scryfallId":"9d15f7b5-5070-4742-a05c-623822d874fb"},{"index":42872,"token":false,"name":"Take into Custody","scryfallId":"b412718a-7bc7-4b16-af60-1b955c820b0f"},{"index":42876,"token":false,"name":"Raving Oni-Slave","scryfallId":"a4d16271-9302-463b-938d-01dad0c3ce29"},{"index":42882,"token":false,"name":"Undead Minotaur","scryfallId":"5e5ae910-ee1d-4958-92d9-0b06872913c6"},{"index":42895,"token":false,"name":"Ilysian Caryatid","scryfallId":"7cdf8ab8-f221-4f7b-9af9-3849cad1f596"},{"index":42896,"token":false,"name":"Leeching Bite","scryfallId":"1c3bdbeb-c376-42bd-af2a-251cd7ac704c"},{"index":42898,"token":false,"name":"Tempt with Immortality","scryfallId":"c87ff489-2d9c-4f04-a169-9eafb046dd7e"},{"index":42901,"token":false,"name":"Hooded Blightfang","scryfallId":"dbb4dd89-6e7f-4b94-9fa4-eeaa4362c099"},{"index":42905,"token":false,"name":"Essence Symbiote","scryfallId":"8d09ddf0-91f0-4e76-809f-c39ca7418ed5"},{"index":42907,"token":false,"name":"Fleshmad Steed","scryfallId":"378c5ba0-bf4f-43d5-b371-0991db5a2e32"},{"index":42914,"token":false,"name":"Nomad Decoy","scryfallId":"9ffef7c6-e05b-4bef-84aa-8df10be110af"},{"index":42917,"token":false,"name":"Tempting Contract","scryfallId":"94ac96b6-5e67-43fb-ba65-fbcccb82bf1c"},{"index":42919,"token":false,"name":"Mobilize","scryfallId":"9712ecaa-4059-44ba-98b7-07bfe7411b5b"},{"index":42921,"token":false,"name":"Mire in Misery","scryfallId":"37b2cc43-307c-429f-a4f7-ac339a97e0bb"},{"index":42925,"token":false,"name":"Stromkirk Patrol","scryfallId":"c53a55ec-0ada-4fc1-9de4-d4daa1ae4546"},{"index":42932,"token":false,"name":"Glaze Fiend","scryfallId":"07f9a946-f961-4e19-a30a-6e1a95683340"},{"index":42933,"token":false,"name":"Moonring Mirror","scryfallId":"8d36357a-97f6-4b2f-abbf-43f84c29609d"},{"index":42936,"token":false,"name":"Reinterpret","scryfallId":"765e64ae-699c-46bd-a8cc-c8c1075d644f"},{"index":42937,"token":false,"name":"Pharagax Giant","scryfallId":"9eef1b9b-58f1-40af-a7c2-06cdaf1ec974"},{"index":42938,"token":false,"name":"Living Totem","scryfallId":"ca21890c-68be-4929-913e-d28ace6b40a7"},{"index":42940,"token":false,"name":"Bitter Ordeal","scryfallId":"2879e7a1-0256-4116-be22-7c9972e4ce0b"},{"index":42944,"token":false,"name":"Snowfall","scryfallId":"788ed793-3993-4a63-b9f9-9ac3947c3108"},{"index":42952,"token":false,"name":"Planeswalker's Fury","scryfallId":"6fa09e3a-bc7e-4292-aa5d-ce97c1b1f79f"},{"index":42957,"token":false,"name":"Chieftain en-Dal","scryfallId":"0c1f49bc-d144-466f-8795-c0dae7afdc10"},{"index":42962,"token":false,"name":"Cryptic Cruiser","scryfallId":"ff2061f7-5e51-4862-9650-0005002d04b6"},{"index":42963,"token":false,"name":"Spurred Wolverine","scryfallId":"46d7aaea-226b-4820-8db2-89dcdcbcc557"},{"index":42966,"token":false,"name":"Jolting Merfolk","scryfallId":"8b4d1c74-8b73-445c-b226-349c57a972f6"},{"index":42981,"token":false,"name":"Cartographer","scryfallId":"8241680d-6453-44ac-ab0f-3e7ebdd31e89"},{"index":42982,"token":false,"name":"Setessan Skirmisher","scryfallId":"46739993-6afe-428d-bf63-b57649e38a65"},{"index":42986,"token":false,"name":"Rhox Charger","scryfallId":"8aaae6a3-ae3c-4b7e-82e8-69147f61ee18"},{"index":42988,"token":false,"name":"Parcel Myr","scryfallId":"0f288ee5-4bf9-476a-a89f-b6b8fa7e87dc"},{"index":42992,"token":false,"name":"Darkest Hour","scryfallId":"aeeb0f91-2084-448a-8226-95d7c87dd6bb"},{"index":43003,"token":false,"name":"Resistance Fighter","scryfallId":"1abf09d8-f972-4b81-80e9-70fb4a33ed56"},{"index":43011,"token":false,"name":"Enthusiastic Study","scryfallId":"543c64ff-2c51-4a63-a940-dc8645717c85"},{"index":43017,"token":false,"name":"Soul of the Rapids","scryfallId":"2a1aed7d-4236-4d44-9366-ee03e15469bc"},{"index":43018,"token":false,"name":"Titan Forge","scryfallId":"7a3bb4ab-6fe7-4926-a929-3e37691f287a"},{"index":43023,"token":false,"name":"Pretender's Claim","scryfallId":"2cc29dab-9211-46bc-a98c-a5dbd5b0980a"},{"index":43025,"token":false,"name":"Mistral Charger","scryfallId":"19db5386-3ef1-4654-8494-6e7949ed7234"},{"index":43030,"token":false,"name":"Djeru's Renunciation","scryfallId":"03f005de-7971-4f22-ad1f-5d0667f68113"},{"index":43040,"token":false,"name":"Favor of the Overbeing","scryfallId":"9bf061f8-3aec-429a-bde7-7c110f872416"},{"index":43043,"token":false,"name":"Stalking Drone","scryfallId":"12bc5b4c-a809-43f0-8848-38812ce865c2"},{"index":43054,"token":false,"name":"Subdue","scryfallId":"123d6097-8021-46cd-a8c3-01013245e347"},{"index":43057,"token":false,"name":"Shadowborn Apostle","scryfallId":"202c2323-6589-457a-af51-5528a98e7b30"},{"index":43058,"token":false,"name":"Bone Shards","scryfallId":"15299d85-ee28-41a3-9952-f50e8e1d40eb"},{"index":43061,"token":false,"name":"Order of Yawgmoth","scryfallId":"555e858d-d8d2-4626-9343-070cf86949ab"},{"index":43064,"token":false,"name":"Make Mischief","scryfallId":"a2049072-5901-4edd-8305-ce55f256bca5"},{"index":43065,"token":false,"name":"Disciple of Phenax","scryfallId":"81c1137c-1cbd-4918-9d1c-a9d2bd88562e"},{"index":43075,"token":false,"name":"Reversal of Fortune","scryfallId":"19cf87c0-369e-4ec2-bb9f-e8e29d63d448"},{"index":43082,"token":false,"name":"Trepanation Blade","scryfallId":"2182be77-9186-4d16-a070-9577d4392999"},{"index":43084,"token":false,"name":"Volcano Hellion","scryfallId":"026b1a54-ab62-431d-a23e-5890d3932c7e"},{"index":43086,"token":false,"name":"Novijen Sages","scryfallId":"04ec467e-5d4a-4941-ac30-801ed681da54"},{"index":43095,"token":false,"name":"Enlightened Maniac","scryfallId":"7f186ffa-b914-45cc-bf25-1306842a2ad5"},{"index":43097,"token":false,"name":"Quilled Slagwurm","scryfallId":"12c597b9-5024-42bd-b500-5ef6a3accda6"},{"index":43100,"token":false,"name":"Street Savvy","scryfallId":"19b5b4fc-e1de-4520-9524-f9c4aa89b252"},{"index":43101,"token":false,"name":"Elfhame Sanctuary","scryfallId":"6ab9a90c-5fd8-4f8c-b692-f98a2974810c"},{"index":43104,"token":false,"name":"Squelch","scryfallId":"29421dd2-70a7-4623-afe0-ca4cb415ec87"},{"index":43111,"token":false,"name":"Resuscitate","scryfallId":"f5707560-fcc6-4aca-adce-d41de45f37e8"},{"index":43113,"token":false,"name":"Angel of Flight Alabaster","scryfallId":"8dfe629f-485c-4619-9713-32d2ae406e63"},{"index":43116,"token":false,"name":"Tezzeret, Cruel Machinist","scryfallId":"277dbeea-103c-4c5b-8981-3f5f7e60c66a"},{"index":43119,"token":false,"name":"Relentless Skaabs","scryfallId":"7cf48c1a-5709-4e24-8a85-8292a4457150"},{"index":43120,"token":false,"name":"Dina, Soul Steeper","scryfallId":"9cd2b567-0cf7-4441-b3ce-e31141dd91c8"},{"index":43122,"token":false,"name":"Aspect of Gorgon","scryfallId":"be8956d0-5502-415d-bead-d8bbddf9871d"},{"index":43126,"token":false,"name":"Arcum's Whistle","scryfallId":"73c07c87-0e44-4a5a-92b7-728350cd02de"},{"index":43129,"token":false,"name":"Mirrorwood Treefolk","scryfallId":"ba9a1c94-2b7f-4df7-8517-a122616d9ae4"},{"index":43130,"token":true,"name":"Bird Soldier Token (W, 1/1)","scryfallId":"b7b55dcf-ae63-4b84-8d39-80b5a6de3c1a"},{"index":43143,"token":false,"name":"Illusion of Choice","scryfallId":"ab54f283-92b6-4738-b2cd-fecb43750a4d"},{"index":43147,"token":false,"name":"Hoofprints of the Stag","scryfallId":"56b90c9f-b717-4a2a-a62d-e878ab7caa81"},{"index":43148,"token":false,"name":"Gargoyle Castle","scryfallId":"9834b4e1-7e9f-4f93-a2aa-13a52e8a11fc"},{"index":43150,"token":false,"name":"Wicked Reward","scryfallId":"e02aeae5-4918-42c6-872d-ffe1517de2ad"},{"index":43154,"token":false,"name":"Elite Javelineer","scryfallId":"ba1839ea-567e-44eb-983f-c1a570ba5c82"},{"index":43157,"token":false,"name":"Niblis of the Breath","scryfallId":"0686843d-6d1e-4488-8c17-7c986a154195"},{"index":43160,"token":false,"name":"Shrouded Serpent","scryfallId":"d3d9035b-b6ec-479f-b697-3e5c3110ef10"},{"index":43161,"token":false,"name":"Aegis of the Heavens","scryfallId":"0503c55d-74bb-4165-9273-127c01bb2214"},{"index":43163,"token":false,"name":"Spell Rupture","scryfallId":"7267fcec-0879-4743-a45f-35057ccb2596"},{"index":43166,"token":false,"name":"Clone Shell","scryfallId":"cc386c6c-c27e-4673-96eb-1d004fd71993"},{"index":43168,"token":false,"name":"Fen Stalker","scryfallId":"8e7d1125-7eb0-4065-bc2c-764689380fa8"},{"index":43170,"token":false,"name":"Battle Frenzy","scryfallId":"a85ae675-56ca-4a00-83d2-ee035f33d6d1"},{"index":43178,"token":false,"name":"Sabertooth Alley Cat","scryfallId":"b9ec817c-c414-4a56-b455-748c6e5cac0d"},{"index":43180,"token":false,"name":"Falkenrath Torturer","scryfallId":"5e81d6ed-2141-4177-9ded-680fff65b39e"},{"index":43181,"token":false,"name":"Shred Memory","scryfallId":"e38192e5-814f-4269-bae8-13867a73e7fa"},{"index":43184,"token":false,"name":"Forced March","scryfallId":"36eae0e1-7100-449d-a259-7abfcd429117"},{"index":43185,"token":false,"name":"Copper Gnomes","scryfallId":"d5e326b7-6f6a-4249-a315-c5f017931c73"},{"index":43190,"token":false,"name":"Demonic Dread","scryfallId":"fb81132e-ab33-435f-ade4-af4416d36044"},{"index":43198,"token":false,"name":"Phyrexian Etchings","scryfallId":"978dbf63-0842-4abd-9950-a33aa080971c"},{"index":43200,"token":false,"name":"Fabled Hero","scryfallId":"642d9a5c-5697-4747-adce-5a71bcf1c086"},{"index":43210,"token":false,"name":"Spiteful Sliver","scryfallId":"6506d58f-9825-4384-9012-1d037543fb59"},{"index":43217,"token":false,"name":"Sapphire Leech","scryfallId":"e6763ffd-9d89-4f26-871a-be24fbdef38d"},{"index":43219,"token":false,"name":"Prismatic Ending","scryfallId":"4eaa24a9-eece-4067-b7e2-6bc8993cea5a"},{"index":43223,"token":false,"name":"Encircling Fissure","scryfallId":"575da7cb-6715-43df-a7b4-a4ca00216a1d"},{"index":43228,"token":false,"name":"Corrupted Grafstone","scryfallId":"1ffa34cc-4042-4d2b-a7a0-eca0b593eeb6"},{"index":43234,"token":false,"name":"Wren's Run Hydra","scryfallId":"5198ac65-118c-4616-8315-d71d41b883ad"},{"index":43238,"token":false,"name":"Seller of Songbirds","scryfallId":"2a41edbe-4c5a-4535-a082-235dc3ffe60a"},{"index":43240,"token":false,"name":"Scribe of the Mindful","scryfallId":"34ffaefe-1b9e-418d-9760-b7d546f03542"},{"index":43241,"token":false,"name":"Minotaur Warrior","scryfallId":"c694f5db-a4ad-4abd-acff-d6b340d2387c"},{"index":43245,"token":false,"name":"Michiko Konda, Truth Seeker","scryfallId":"99c56bf0-ad9f-4419-902c-f3a3880c716c"},{"index":43249,"token":false,"name":"Siren's Ruse","scryfallId":"8f389872-d1f4-4828-a527-e820a6f2ac21"},{"index":43250,"token":false,"name":"Osgir, the Reconstructor","scryfallId":"b4181b80-414e-4bcd-9d92-391cd504afe1"},{"index":43255,"token":false,"name":"Insubordination","scryfallId":"d2544c9d-adc2-4d67-8850-9af38e73ea1e"},{"index":43259,"token":false,"name":"Murderous Spoils","scryfallId":"91ece344-c516-449e-ab7c-2e78d4778f02"},{"index":43281,"token":true,"name":"Kai Budde Bio","scryfallId":"9ed2329f-d055-4a60-955b-384722504278"},{"index":43290,"token":false,"name":"Rotting Fensnake","scryfallId":"c21cbb10-9157-4887-a752-29b9e94fc77a"},{"index":43297,"token":false,"name":"Mercadian Bazaar","scryfallId":"6f787cb6-78cb-4baa-a9cf-cee8b7d8d6b1"},{"index":43298,"token":false,"name":"Knight of the Tusk","scryfallId":"d32d61d2-ffdc-495a-a0b1-1ca7bcaa5fa0"},{"index":43302,"token":false,"name":"Abyssal Nocturnus","scryfallId":"fe094903-45a6-4b11-b80e-aabe915c4b7c"},{"index":43309,"token":false,"name":"Wavesifter","scryfallId":"0a269277-7f4e-40de-a2b4-53aa50cfd665"},{"index":43312,"token":false,"name":"Frenzied Arynx","scryfallId":"bce2eef7-03a4-415f-8bb7-a29d50ce1b0f"},{"index":43322,"token":false,"name":"Bayou Groff","scryfallId":"4a82b032-b1ba-456c-abab-c0f7430b0587"},{"index":43327,"token":false,"name":"Daryl, Hunter of Walkers","scryfallId":"0bffb892-e5dc-413d-924e-b9bda7bf7100"},{"index":43329,"token":false,"name":"Havengul Vampire","scryfallId":"cbc09839-1463-40b8-86bd-fb96797b2633"},{"index":43331,"token":false,"name":"Marsh Goblins","scryfallId":"8aabd80f-a18a-4bc1-9f05-4c3a63de77ce"},{"index":43333,"token":false,"name":"Ronin Cliffrider","scryfallId":"f9f12b75-af29-49ea-a23d-915052db9fef"},{"index":43334,"token":false,"name":"Cemetery Gate","scryfallId":"0c6f0614-06dc-4bd2-b8b9-d951ae27db21"},{"index":43339,"token":false,"name":"Feast on the Fallen","scryfallId":"d96a9227-14ce-4d35-b5e6-0d0c657207c0"},{"index":43347,"token":false,"name":"Warrior Angel","scryfallId":"81d2c6e3-e556-4cc6-94b6-fdbc62d6853e"},{"index":43360,"token":false,"name":"Lu Meng, Wu General","scryfallId":"25621ccf-fa2d-4990-a908-01373fbe587f"},{"index":43362,"token":false,"name":"Forerunner of Slaughter","scryfallId":"195b867e-41ca-48af-bbd2-5e2c97411752"},{"index":43366,"token":false,"name":"Pit Trap","scryfallId":"c588fe7f-945d-4459-904c-67442f88b4e1"},{"index":43371,"token":false,"name":"Basilica Bell-Haunt","scryfallId":"e72f4329-db6f-4284-b63e-55f22a0a0f6e"},{"index":43376,"token":false,"name":"Strangling Spores","scryfallId":"300468ab-fbae-42ae-97bc-b08f795efa5c"},{"index":43377,"token":false,"name":"Goblin Wardriver","scryfallId":"6fb10750-4037-4630-82d3-bb068c335e48"},{"index":43381,"token":false,"name":"Wetland Sambar","scryfallId":"f71a86e0-d15a-4fba-94f6-bfbaade8d837"},{"index":43389,"token":false,"name":"Cloak of Invisibility","scryfallId":"3f6e21e6-fb3e-49c1-b5a0-499faf66d279"},{"index":43394,"token":false,"name":"Strip Bare","scryfallId":"51173fa1-7cd4-4093-982a-db0d46564a8a"},{"index":43395,"token":false,"name":"Nirkana Cutthroat","scryfallId":"341f4ea1-8101-4e2e-b824-4b0e88ea71f1"},{"index":43409,"token":false,"name":"Broodhunter Wurm","scryfallId":"eee6ecdc-fff9-41a1-802a-08615ca6289f"},{"index":43410,"token":false,"name":"Genesis Wave","scryfallId":"5007919b-27d3-46e7-a588-ce796709d565"},{"index":43411,"token":false,"name":"Spark of Creativity","scryfallId":"718bf224-5e1b-439c-a998-ceec5c0a8903"},{"index":43412,"token":false,"name":"Aura Flux","scryfallId":"a6be1542-70b8-4e97-a951-100966dc46ce"},{"index":43418,"token":false,"name":"Kill-Suit Cultist","scryfallId":"b37c96bb-6844-4c73-8b32-099bde7bd9f1"},{"index":43419,"token":false,"name":"Auspicious Ancestor","scryfallId":"7f6f9ec3-6033-4cd4-a52e-31a559559a93"},{"index":43421,"token":false,"name":"Ragefire","scryfallId":"cb13420d-d295-4000-9c38-fa5d10e06ece"},{"index":43423,"token":false,"name":"Prahv, Spires of Order","scryfallId":"2a315f63-96ad-4a5f-8eb4-d81361797348"},{"index":43427,"token":false,"name":"Whipgrass Entangler","scryfallId":"c0b18b09-b1ff-479d-bd1c-cb8620a34fe4"},{"index":43432,"token":false,"name":"Angel of Fury","scryfallId":"f230e857-9d47-4fc4-a6de-7a8c0b6c594a"},{"index":43439,"token":false,"name":"Venser's Diffusion","scryfallId":"fbedfc40-7c2f-4a6e-8157-219cafca3548"},{"index":43442,"token":false,"name":"Illuminated Wings","scryfallId":"7f98e703-a0d3-497f-840a-aa026b02d47f"},{"index":43447,"token":false,"name":"Tempting Licid","scryfallId":"da7f3e0b-0600-4451-b621-e40c902a16cb"},{"index":43451,"token":false,"name":"Equal Treatment","scryfallId":"310cb525-9299-471e-b310-392353b25472"},{"index":43452,"token":false,"name":"Enduring Ideal","scryfallId":"7dc7091e-0c98-434d-9190-dcab813d3e14"},{"index":43459,"token":false,"name":"Impetuous Devils","scryfallId":"1ba7acc0-6ef0-4c34-be23-118e1872271f"},{"index":43466,"token":false,"name":"Morgue Toad","scryfallId":"77d8ae73-70d1-4082-8581-5f74c1aaa63b"},{"index":43467,"token":false,"name":"Mindstatic","scryfallId":"55d3fad5-a12a-4b41-9c7b-c1af5e0b5ca8"},{"index":43471,"token":false,"name":"Parch","scryfallId":"d3ab8065-cecc-4b19-be93-7cf791a93e62"},{"index":43478,"token":false,"name":"Organ Grinder","scryfallId":"6233d4c3-9407-41b0-92a9-5f90dfd6a584"},{"index":43484,"token":false,"name":"Glade Watcher","scryfallId":"02c9c6d9-e715-4b70-a10e-8bc5a4e9e938"},{"index":43486,"token":true,"name":"Jan Tomcani Bio","scryfallId":"006a2cce-dd8f-47d5-aedd-135e51ecfa23"},{"index":43491,"token":false,"name":"Aether Membrane","scryfallId":"7767264f-926f-48eb-a5a1-c56b027e645f"},{"index":43493,"token":false,"name":"Shipwreck Dowser","scryfallId":"59d38ef7-5017-4ea3-b97f-a8fe12d03e98"},{"index":43496,"token":true,"name":"Icy Manalith","scryfallId":"3db39e3b-fad4-4c9b-911f-69883ac7e0e1"},{"index":43502,"token":false,"name":"Witness of the Ages","scryfallId":"763ac4c4-af2d-4b71-9fb3-244c96f93860"},{"index":43506,"token":false,"name":"Rust Tick","scryfallId":"1d638741-1cfe-4496-8d7e-7849a82dcb24"},{"index":43507,"token":false,"name":"Keeper of the Flame","scryfallId":"9bf246ca-9dfc-400f-8883-acc80ac016e1"},{"index":43515,"token":false,"name":"Embermage Goblin","scryfallId":"f50f60a8-e99a-4891-b474-a21abee38970"},{"index":43522,"token":false,"name":"Shape of the Wiitigo","scryfallId":"5436d55d-d2d0-4f22-b399-93f1d48e080f"},{"index":43523,"token":false,"name":"Inquisition","scryfallId":"5f133f06-6398-4db1-8577-66c16fd3e00d"},{"index":43528,"token":false,"name":"Consuming Bonfire","scryfallId":"56a4ec08-5029-4f7b-a93b-a5dad4be5113"},{"index":43529,"token":false,"name":"Darigaaz's Caldera","scryfallId":"752f6f0c-af30-4937-b4a7-48f493e007a0"},{"index":43534,"token":false,"name":"Boon Satyr","scryfallId":"477a30f3-3cbe-42a5-9fae-fe5885a8cf25"},{"index":43536,"token":false,"name":"Hubris","scryfallId":"05f5b473-edad-43a9-b4e7-b6d3fc877cf2"},{"index":43539,"token":false,"name":"Misfortune","scryfallId":"b14cc32a-eb4f-4690-aceb-160780743ebe"},{"index":43540,"token":false,"name":"Akoum Stonewaker","scryfallId":"c92ab7b5-6a29-463e-b294-3cb0efaccddb"},{"index":43542,"token":false,"name":"Gnarlroot Trapper","scryfallId":"e05572ba-3a26-41f5-96c1-960ec9367178"},{"index":43544,"token":false,"name":"Sanctuary Smasher","scryfallId":"cc634c10-42c5-4bdc-bc22-f862ae285492"},{"index":43552,"token":false,"name":"Devoted Retainer","scryfallId":"fc41d6d6-d7e5-4874-b6e2-fa4c72454f15"},{"index":43553,"token":false,"name":"Hindervines","scryfallId":"f6b85a09-6d43-4798-8164-131d35b65836"},{"index":43558,"token":false,"name":"Aspect of Manticore","scryfallId":"f67d0091-1925-44a5-89f3-21c2afd5665c"},{"index":43562,"token":false,"name":"Iceberg Cancrix","scryfallId":"d84b1444-a609-4c23-935d-fa25aef16179"},{"index":43564,"token":false,"name":"Goblin Artillery","scryfallId":"674bd59d-9d6d-434d-974f-3aa1cbd770b5"},{"index":43566,"token":false,"name":"Tangle Angler","scryfallId":"b678bd68-e866-4081-95f9-2bd93a84d400"},{"index":43567,"token":false,"name":"Disruption Aura","scryfallId":"864b6f7e-4e08-465d-b9c7-d1a167850cf9"},{"index":43578,"token":false,"name":"Panglacial Wurm","scryfallId":"c7edde6b-d0e9-497a-bd34-779d34b8f374"},{"index":43580,"token":false,"name":"Cheering Fanatic","scryfallId":"88cf8e2b-482e-4d40-a8d7-1a74cec3d983"},{"index":43581,"token":false,"name":"Wanderwine Prophets","scryfallId":"6cdbb6ff-c945-4dd6-aba6-4fd4b77824c0"},{"index":43589,"token":false,"name":"Dukhara Peafowl","scryfallId":"e5c54795-d555-4972-b72d-b2d2374bed9b"},{"index":43591,"token":false,"name":"Nightscape Apprentice","scryfallId":"7498ca4c-614a-4776-8886-0a6ed58520f6"},{"index":43598,"token":false,"name":"Fyndhorn Bow","scryfallId":"65dd0a41-cc51-4728-b597-fdb2510accd8"},{"index":43602,"token":false,"name":"Breaching Leviathan","scryfallId":"e02e3d91-7723-46b8-a393-855b6e89d877"},{"index":43604,"token":false,"name":"Nimble Birdsticker","scryfallId":"4ff9bcbd-48fe-4a74-aae5-a447c99aa64b"},{"index":43605,"token":false,"name":"Vindictive Lich","scryfallId":"3227d983-e0c5-4dbd-aaff-fb9265199a82"},{"index":43610,"token":false,"name":"Eradicator Valkyrie","scryfallId":"af1459fc-a19f-4106-939d-9b9672cecce7"},{"index":43623,"token":false,"name":"Covetous Urge","scryfallId":"f3b4871d-4d74-411b-88e0-9a9d386cafe1"},{"index":43626,"token":false,"name":"Second Wind","scryfallId":"061d2f8f-1166-4579-9609-d8ba5db79172"},{"index":43631,"token":false,"name":"Shrieking Grotesque","scryfallId":"3c221f01-b094-41c7-bb5f-eef97cbf584e"},{"index":43633,"token":false,"name":"Mana-Charged Dragon","scryfallId":"03245712-18b9-48d2-b95e-24a38367abb9"},{"index":43636,"token":false,"name":"Brain Pry","scryfallId":"ca65692f-fabc-4b56-a0f6-d623ed069cb8"},{"index":43643,"token":false,"name":"Unnatural Aggression","scryfallId":"8293c66d-9a9b-4817-9bc3-ffd57fda290c"},{"index":43644,"token":false,"name":"Salt Road Ambushers","scryfallId":"56c1111a-9680-4d34-8cf7-af16ae508a72"},{"index":43646,"token":false,"name":"Imperious Oligarch","scryfallId":"fd27ba9e-5b9c-468f-9a44-bf2e89138e72"},{"index":43651,"token":true,"name":"Giant Token (R, 4/4)","scryfallId":"0197284c-3c17-438b-a46d-83131d56c768"},{"index":43654,"token":false,"name":"Off Balance","scryfallId":"adafe5c4-8de0-4d38-919f-de96bc70c21b"},{"index":43658,"token":false,"name":"Lazotep Plating","scryfallId":"f03b5405-6016-405b-a504-a454731b9276"},{"index":43663,"token":false,"name":"Bog Naughty","scryfallId":"0cf282fe-83fd-4208-b46f-dae76e3a7f62"},{"index":43666,"token":false,"name":"Sultai Soothsayer","scryfallId":"ae0de2c9-957e-41ee-8899-b93e6f1091dc"},{"index":43671,"token":false,"name":"Remote Farm","scryfallId":"115cab84-60d7-4bf2-9beb-b4ed7b5ceaf4"},{"index":43672,"token":false,"name":"Vector Asp","scryfallId":"7ffe86e1-ad47-4ccb-aa55-119dc681d370"},{"index":43679,"token":false,"name":"Headless Skaab","scryfallId":"ca63f9a2-381e-4c84-b0bb-3acd9445b4db"},{"index":43681,"token":false,"name":"Depart the Realm","scryfallId":"2ce0403d-76ed-4eb0-abdd-74ed28f96137"},{"index":43698,"token":false,"name":"Built to Last","scryfallId":"ef3e09a4-93d0-4ed7-bbee-82108672d5f8"},{"index":43700,"token":false,"name":"Worldspine Wurm","scryfallId":"543d55cb-3a6b-4620-af25-10ae74ed32c4"},{"index":43701,"token":false,"name":"Dwarven Mine","scryfallId":"5c83074d-0c9b-4b58-94ca-d75240485579"},{"index":43709,"token":false,"name":"Magus of the Jar","scryfallId":"31961041-a9e6-4d96-bd4a-5c5f88a79e74"},{"index":43711,"token":false,"name":"Deus of Calamity","scryfallId":"a3b03ce9-a0fb-4b0c-b02d-e4f93ef87445"},{"index":43726,"token":false,"name":"Resilient Wanderer","scryfallId":"5e5a61de-ee4e-4097-b342-b5f2c976e16e"},{"index":43730,"token":false,"name":"Hell-Bent Raider","scryfallId":"7f41ac1c-2603-4234-8963-cd47bb894024"},{"index":43732,"token":false,"name":"Soltari Guerrillas","scryfallId":"2fabd462-15d3-4a08-bad2-edab2a142420"},{"index":43735,"token":false,"name":"Mardu Runemark","scryfallId":"333df10b-7db4-4f8a-a754-e8a630b26cac"},{"index":43749,"token":false,"name":"Serene Steward","scryfallId":"702f5dd4-4dc7-4e2c-a30b-9286499433d8"},{"index":43753,"token":false,"name":"Thran Lens","scryfallId":"200c3666-5ba0-4f0a-adbe-a97af0aa28d1"},{"index":43756,"token":false,"name":"Violet Pall","scryfallId":"bdfd0fa3-37d2-403e-99fe-8c9e57515e9d"},{"index":43763,"token":true,"name":"Angel Token (W, 3/3)","scryfallId":"96f407ef-2b08-45e9-a45e-128cf0a63839"},{"index":43765,"token":false,"name":"Kalonian Behemoth","scryfallId":"fa631a51-604c-4581-af07-3094b8bb0b27"},{"index":43766,"token":false,"name":"Spreading Algae","scryfallId":"3abaf631-ce63-47c8-8883-04f942f2e7ba"},{"index":43768,"token":false,"name":"Bladebrand","scryfallId":"3003857b-d502-4a37-88ff-2165a0555ce8"},{"index":43777,"token":false,"name":"Scour","scryfallId":"a9cac762-7482-471f-b4de-e0cb6da5451c"},{"index":43779,"token":true,"name":"Wurm // Saproling Token (G, 5/5)","scryfallId":"d0c052ed-c761-4f1d-816b-092cdd6cb0fa"},{"index":43780,"token":false,"name":"Wei Scout","scryfallId":"a11d58fb-fb70-4e8f-8f64-232ad2c1f59b"},{"index":43781,"token":false,"name":"Hellhole Rats","scryfallId":"6e1eb937-21d4-44b1-85e7-b95995865f44"},{"index":43789,"token":false,"name":"Zhalfirin Decoy","scryfallId":"b93b824c-414d-4dd5-848f-bff678a289ba"},{"index":43810,"token":false,"name":"Quickening Licid","scryfallId":"e6e91f3d-5a23-4df1-a879-d18a3af92a28"},{"index":43814,"token":false,"name":"Cocoon","scryfallId":"a82c87b1-de37-4423-a1a4-533a1d8108b2"},{"index":43816,"token":false,"name":"Yellow Scarves General","scryfallId":"06e98691-6227-41f2-a3f4-3131b07a3a6f"},{"index":43817,"token":false,"name":"Obelisk of Urd","scryfallId":"c610beb6-6fd5-4230-ae74-240a005d5c8c"},{"index":43819,"token":false,"name":"Lava Hounds","scryfallId":"cf83d5c7-a17c-4350-9432-92a01421b39a"},{"index":43821,"token":false,"name":"Qasali Ambusher","scryfallId":"be4e1284-eea2-4fc4-99e4-ed53176939ba"},{"index":43823,"token":false,"name":"Gloom Pangolin","scryfallId":"3f135dd7-2a4f-4c83-9a90-76bcab3cc33d"},{"index":43825,"token":false,"name":"Omen","scryfallId":"6be1956e-c43e-4a6c-950a-5be6e6ca013f"},{"index":43827,"token":false,"name":"Putrid Cyclops","scryfallId":"14e82edf-8acc-4024-bb88-f727f632b061"},{"index":43831,"token":false,"name":"Sewer Nemesis","scryfallId":"315e4fa6-66e6-40b3-b78f-4d3e75b87213"},{"index":43834,"token":false,"name":"Flamespeaker Adept","scryfallId":"b84b90b6-71e2-429e-9853-50bcbd6538db"},{"index":43836,"token":false,"name":"Topple","scryfallId":"a7c25c67-4214-4318-a718-7d351e713f80"},{"index":43839,"token":false,"name":"Blood Glutton","scryfallId":"28ff52a2-4223-4551-b388-b4dd21cc1437"},{"index":43842,"token":true,"name":"Above the Clouds","scryfallId":"2eb7db6d-5e11-433a-82ba-467093c68234"},{"index":43853,"token":false,"name":"Tendrils of Despair","scryfallId":"b5d73ddb-bd3c-4625-9f75-ba2079553915"},{"index":43876,"token":false,"name":"Liliana's Caress","scryfallId":"0d995382-57a6-40a4-9050-31f57cb8dae3"},{"index":43879,"token":false,"name":"Fang of the Pack","scryfallId":"27bcf935-6e35-41bc-b1eb-6ec92b1647d5"},{"index":43881,"token":false,"name":"Stalking Assassin","scryfallId":"ff8cc71f-3070-497f-908f-35aa13a8a857"},{"index":43885,"token":false,"name":"Hunted Ghoul","scryfallId":"bb443cf7-70bd-4df7-b446-107e099c19e3"},{"index":43887,"token":true,"name":"Goblins","scryfallId":"39f791a4-cfcc-4660-bbaa-7445e07783da"},{"index":43892,"token":false,"name":"Dovescape","scryfallId":"b6e3d6e6-ac17-4d73-acac-089442de4af6"},{"index":43896,"token":false,"name":"Bloodthirsty Blade","scryfallId":"b69c43bc-3dda-4658-8cef-d5f90ba30d0a"},{"index":43897,"token":false,"name":"Slippery Scoundrel","scryfallId":"262f3c10-f29a-494f-88c6-0d44b2cbdc82"},{"index":43902,"token":false,"name":"Foul Renewal","scryfallId":"e319b7ca-d0a4-43ff-8e87-2af6ead089f5"},{"index":43904,"token":false,"name":"Axebane Guardian","scryfallId":"725584fe-9e97-4020-89b1-5e5b45a5beb2"},{"index":43908,"token":false,"name":"Perilous Forays","scryfallId":"4210a148-d16c-42de-b0d6-83c05c553dd4"},{"index":43910,"token":false,"name":"Hidden Ancients","scryfallId":"45f4f257-c04e-489f-8ffd-814bf075e7d1"},{"index":43912,"token":false,"name":"Priest of the Wakening Sun","scryfallId":"228f98d0-dbfa-419d-805c-0c6511abdbbc"},{"index":43914,"token":false,"name":"Grixis Grimblade","scryfallId":"9dbcb812-15ad-4878-9968-cfa65a352703"},{"index":43920,"token":false,"name":"Emry, Lurker of the Loch","scryfallId":"bf4b9a8a-b42a-46fb-b0d0-9cf800f63c8a"},{"index":43932,"token":false,"name":"Corridor Monitor","scryfallId":"df3f6598-18a7-472d-8d05-715203379089"},{"index":43935,"token":false,"name":"Cabal Therapist","scryfallId":"eaa8f485-0f3d-4a0b-bcdf-6c27d1d2bce0"},{"index":43945,"token":false,"name":"Stronghold Confessor","scryfallId":"ab3fcc43-839b-48c1-91e3-7cc80d8c7f9a"},{"index":43946,"token":false,"name":"Restore the Peace","scryfallId":"105902f6-99d0-4bee-9dfd-87a92ac04d91"},{"index":43957,"token":false,"name":"Voidstone Gargoyle","scryfallId":"583741a1-0faf-4fb3-8536-b9b1cc8a3b6f"},{"index":43966,"token":false,"name":"Wizard Mentor","scryfallId":"49805401-9bd9-48a3-9b99-0120a8bb1fb5"},{"index":43972,"token":false,"name":"Recruit the Worthy","scryfallId":"fb025c0c-7fdf-4f71-afd5-ef11cd2804eb"},{"index":43974,"token":false,"name":"Bloodline Necromancer","scryfallId":"42bffd03-3821-4b0f-9535-2eb455154587"},{"index":43975,"token":false,"name":"Gatecreeper Vine","scryfallId":"5dabcc2f-7536-44e3-a495-bbfc526fdc5d"},{"index":43977,"token":false,"name":"Shimian Night Stalker","scryfallId":"4e04a1b9-c561-4e34-86d9-129ea0346631"},{"index":43983,"token":false,"name":"Serpent's Soul-Jar","scryfallId":"08ae371f-ce62-475f-89a2-1f8a17cf950f"},{"index":43985,"token":false,"name":"Forceful Denial","scryfallId":"27c75157-2670-4804-8853-a6867c83c40a"},{"index":43988,"token":false,"name":"March of Souls","scryfallId":"f07dd0f1-b80b-4af0-ae76-907ec55ec7d5"},{"index":43989,"token":false,"name":"Vortex Elemental","scryfallId":"5cb7ca2b-c5de-4c8a-91cb-8dd8ab5387d8"},{"index":43990,"token":false,"name":"Arcane Savant","scryfallId":"0e7466e5-9443-4b38-a7e9-e0d615a35667"},{"index":43995,"token":false,"name":"Personal Tutor","scryfallId":"55c23f66-1a81-45ac-91d9-ee9c661c33cd"},{"index":43997,"token":false,"name":"Kemba's Skyguard","scryfallId":"b9f20a74-7614-4bd9-ac08-0e098f98df0c"},{"index":43999,"token":false,"name":"Shared Discovery","scryfallId":"ec0b99f1-d706-4332-a1c2-86d789919069"},{"index":44000,"token":false,"name":"Ignorant Bliss","scryfallId":"1a2db886-d394-4a8b-8fe0-dc2613500adc"},{"index":44002,"token":false,"name":"Roc Hatchling","scryfallId":"25857884-6bb7-4a8e-a08b-fa610af8a5c3"},{"index":44007,"token":false,"name":"Chain of Smog","scryfallId":"6bfe64f9-8b03-41f6-a47b-fade397ad9d1"},{"index":44008,"token":false,"name":"Lowland Tracker","scryfallId":"f8eaaded-b18a-4614-b5b5-b4bb49a2e1b1"},{"index":44011,"token":false,"name":"Void Mirror","scryfallId":"9f982bda-3153-4ef7-9eab-a658732b5db7"},{"index":44023,"token":false,"name":"Multani, Maro-Sorcerer","scryfallId":"0d6cc98b-b376-40af-8308-198bab00b2b1"},{"index":44027,"token":false,"name":"Origin Spellbomb","scryfallId":"91e7faa4-160e-47d9-a9a1-5928d9d2b5e4"},{"index":44038,"token":false,"name":"Piercing Rays","scryfallId":"eaeb9fd0-c46a-4246-838f-a5b7a8ea8eef"},{"index":44039,"token":false,"name":"Myr Adapter","scryfallId":"0d6ddde9-4427-4a0f-b05c-9cfd886aad2d"},{"index":44044,"token":false,"name":"Bleeding Edge","scryfallId":"ac82422c-8ac8-4fbb-b9b9-d0aa23dded61"},{"index":44045,"token":false,"name":"Vengeful Dead","scryfallId":"7c11c11d-9809-4031-8cbc-21aef07d7f1f"},{"index":44046,"token":false,"name":"Assault Strobe","scryfallId":"9b505c78-5dbd-483d-92bb-5144060e962f"},{"index":44049,"token":false,"name":"Cut the Earthly Bond","scryfallId":"066f185d-5f81-472a-8aff-2c11ba10d18c"},{"index":44059,"token":false,"name":"Raid Bombardment","scryfallId":"ca75d458-4947-4075-89b6-e93936c67370"},{"index":44060,"token":false,"name":"Aerial Maneuver","scryfallId":"c63e9c49-3fa4-41ad-9eed-19801df103c6"},{"index":44068,"token":false,"name":"Folk Medicine","scryfallId":"751bd716-5352-41d7-89fb-d5f100f6646b"},{"index":44076,"token":false,"name":"Reclamation","scryfallId":"ca335f4f-d345-4eb9-9bc6-74595c501078"},{"index":44079,"token":false,"name":"Irresistible Prey","scryfallId":"d1511d4d-3e70-4688-ab88-37e26cb1a46f"},{"index":44082,"token":false,"name":"Minion Reflector","scryfallId":"5d2a48f9-4f14-4d19-b3dc-3bf3fafac32d"},{"index":44084,"token":false,"name":"Kyoki, Sanity's Eclipse","scryfallId":"dc0969e6-f667-4e29-a038-8569022cce32"},{"index":44086,"token":false,"name":"Weathered Runestone","scryfallId":"0fc2478f-e624-46fb-85af-1254564cd4d2"},{"index":44095,"token":false,"name":"Transluminant","scryfallId":"318ce4ef-38bd-4360-895f-457587164197"},{"index":44096,"token":false,"name":"Militia's Pride","scryfallId":"53c8cde1-e447-422e-aed0-2571a77d3d29"},{"index":44100,"token":false,"name":"Scale of Chiss-Goria","scryfallId":"133b367c-b1a1-46f7-a539-a33ee655affb"},{"index":44113,"token":false,"name":"Cerulean Wisps","scryfallId":"0dca4f46-0aad-484f-b4ea-ed61a4fc1a89"},{"index":44115,"token":false,"name":"Call to Mind","scryfallId":"9218f8f4-89fd-46a1-928b-2e0e8e2b4458"},{"index":44119,"token":false,"name":"Tidal Force","scryfallId":"13e2658d-28d7-4e22-ad44-03ab92ff666d"},{"index":44123,"token":false,"name":"Gideon's Battle Cry","scryfallId":"52de8fc6-6d9b-402e-a6c8-4c39b0c92f07"},{"index":44126,"token":false,"name":"Murderer's Axe","scryfallId":"696dcb79-4915-424f-ba8f-5363ae3395a6"},{"index":44128,"token":false,"name":"Graceful Antelope","scryfallId":"948f0d9d-4e05-48b4-8652-1f8f41d35563"},{"index":44142,"token":false,"name":"Surge to Victory","scryfallId":"0f02698f-d954-42e0-b4d6-9daf65f29e36"},{"index":44152,"token":false,"name":"Zilortha, Strength Incarnate","scryfallId":"9a0639a0-c898-4a07-975c-a02bdd53175b"},{"index":44154,"token":false,"name":"Springjaw Trap","scryfallId":"3741de51-ea92-493a-8058-e0f2000e7701"},{"index":44155,"token":false,"name":"Forsaken City","scryfallId":"676703fe-bd80-413c-8704-1da5d3248b7e"},{"index":44158,"token":false,"name":"Scorch Rider","scryfallId":"9ec9d3eb-4729-49a9-8146-7388ff2629df"},{"index":44174,"token":false,"name":"Cleric of the Forward Order","scryfallId":"cfcea783-e9f0-4d44-ac74-5aee9a07aa69"},{"index":44176,"token":false,"name":"Riddlekeeper","scryfallId":"949bcd1d-5987-4819-b2c4-fa80aa65079f"},{"index":44178,"token":true,"name":"Dave Humpherys Bio","scryfallId":"2b490cfc-3a5a-4045-a53f-3395f61bb7a1"},{"index":44184,"token":false,"name":"River's Grasp","scryfallId":"1209bb9d-8aeb-4d7c-85bb-d9e9a24e36ac"},{"index":44192,"token":false,"name":"Spirit en-Dal","scryfallId":"ec0d6477-9c50-4196-a04f-da73b5a07e01"},{"index":44195,"token":false,"name":"Arcum's Astrolabe","scryfallId":"8dcaa85c-c4f1-4a3a-8328-6fcf865299e0"},{"index":44199,"token":false,"name":"Squirrel Sanctuary","scryfallId":"ed6ab503-5e9a-4339-a0e7-a909b2908f41"},{"index":44204,"token":false,"name":"God-Favored General","scryfallId":"984c2db0-5a79-47b8-8a42-5674c6d9d0fd"},{"index":44208,"token":false,"name":"Phantasmagorian","scryfallId":"19bcd780-70a6-4c25-8611-8b750a50aa3d"},{"index":44219,"token":false,"name":"Provoke the Trolls","scryfallId":"2727b05a-0c86-4c59-b7b4-425bdd8e775d"},{"index":44223,"token":false,"name":"Consul's Shieldguard","scryfallId":"52b66d65-1981-4abf-b27f-e9a1b2800110"},{"index":44226,"token":false,"name":"Drudge Beetle","scryfallId":"e4812e81-beca-4afc-b2f2-24d5ab27abff"},{"index":44230,"token":false,"name":"Quarantine Field","scryfallId":"bc57091d-fcb2-4eb7-beeb-028e4a98c92e"},{"index":44242,"token":false,"name":"Ajani, Inspiring Leader","scryfallId":"dba41e5f-66b8-4459-8a07-bbe893216f1e"},{"index":44244,"token":false,"name":"Gridlock","scryfallId":"b4f5c126-3df9-4771-9e74-4ca33161ac08"},{"index":44246,"token":false,"name":"Baneful Omen","scryfallId":"2bff6e03-b6af-4f54-b365-9a6db2dbb595"},{"index":44252,"token":false,"name":"Kozilek's Sentinel","scryfallId":"786c6a0f-3f75-45ff-aae9-5c866be279d0"},{"index":44255,"token":false,"name":"Rebound","scryfallId":"bb6ca66e-1116-4739-8375-87af99e9bba5"},{"index":44263,"token":false,"name":"Kinsbaile Balloonist","scryfallId":"b6053c20-3632-43e2-8560-259d0c12f235"},{"index":44265,"token":false,"name":"Embalmed Brawler","scryfallId":"2e214da0-68c0-4cf6-ba12-e2b2394909c1"},{"index":44269,"token":false,"name":"Empowered Autogenerator","scryfallId":"2c9b8d53-97c9-4e3d-a8c6-6abd78db6390"},{"index":44274,"token":false,"name":"Burning Cloak","scryfallId":"e2b8f443-dba5-45a5-bb2e-f57b4fdd1d01"},{"index":44275,"token":false,"name":"Grovetender Druids","scryfallId":"5c2fd3a4-e09a-4fe5-93eb-2276a65c4911"},{"index":44277,"token":false,"name":"Spirit of the Labyrinth","scryfallId":"f44e5128-e146-4e46-b313-a40d82719d1d"},{"index":44278,"token":false,"name":"Fangren Pathcutter","scryfallId":"dbff1640-a229-4530-a021-f5585f7130f7"},{"index":44284,"token":false,"name":"Ovalchase Daredevil","scryfallId":"ed3ba73e-58aa-417e-bd52-d7f93c80adc6"},{"index":44286,"token":false,"name":"Insist","scryfallId":"48e1f72d-ef5e-4cea-a0ee-645570a36104"},{"index":44294,"token":false,"name":"Galestrike","scryfallId":"6fe6633a-dee9-4840-9a18-ab4a511eb4c4"},{"index":44295,"token":false,"name":"Harmony of Nature","scryfallId":"e3fa08d9-d41b-4696-b81a-42c8eebdeb49"},{"index":44299,"token":false,"name":"Surrakar Marauder","scryfallId":"28a7a1af-14f2-4e22-bd27-9207e837d5fb"},{"index":44305,"token":false,"name":"Treetop Ambusher","scryfallId":"e1722a55-850c-4924-be98-45539f4676a2"},{"index":44321,"token":false,"name":"Border Patrol","scryfallId":"a49a85c8-3516-4dda-b16b-bf1bf890becb"},{"index":44322,"token":false,"name":"Boa Constrictor","scryfallId":"f7369cbf-6986-4a39-b07c-a283b40aee40"},{"index":44323,"token":false,"name":"Nightsquad Commando","scryfallId":"80306d10-0da7-4ee7-b975-ef6c9b535a2a"},{"index":44328,"token":false,"name":"Teroh's Vanguard","scryfallId":"1a39f909-7114-4482-8302-b2a56ca9f556"},{"index":44330,"token":false,"name":"Ubul Sar Gatekeepers","scryfallId":"f5b2e327-adfd-459b-8d18-faa39d88b5de"},{"index":44333,"token":true,"name":"Legion","scryfallId":"dfb8fe98-efb6-48e7-bb08-8c8aa6f52c9d"},{"index":44343,"token":false,"name":"Emissary of Despair","scryfallId":"9fa8ae06-882b-428e-b446-1e750ffcddd1"},{"index":44346,"token":false,"name":"Tranquil Garden","scryfallId":"112b6577-fbd6-46dd-b77d-37df0abe9845"},{"index":44347,"token":false,"name":"Thirst for Meaning","scryfallId":"fb95d4e0-02e6-4159-8cc0-c8da27edf2f9"},{"index":44350,"token":false,"name":"Cloud of Faeries","scryfallId":"4e76d04a-0038-4b5b-a026-3056ee940da9"},{"index":44357,"token":false,"name":"Gemstone Array","scryfallId":"19ef37a3-4538-47b2-8f88-3fa0a4e32329"},{"index":44361,"token":false,"name":"Common Cause","scryfallId":"eae4c25f-2005-4ac0-a5f0-2fc250520995"},{"index":44364,"token":false,"name":"Debt to the Deathless","scryfallId":"610e5a91-857b-4121-8b75-dbbea27aa0aa"},{"index":44365,"token":false,"name":"Niblis of the Urn","scryfallId":"11bf2ff7-0f8d-47ea-adfd-af299e793a37"},{"index":44366,"token":false,"name":"Renegade Firebrand","scryfallId":"4b633884-867c-4b51-bd5b-5f246d0ecd4e"},{"index":44374,"token":false,"name":"Vampiric Spirit","scryfallId":"6e5235e5-deb7-49eb-82a8-858d3ee7c91b"},{"index":44384,"token":false,"name":"Grim Initiate","scryfallId":"29b6ec9d-3861-48bf-a198-dc7efba5d89c"},{"index":44385,"token":false,"name":"Faces of the Past","scryfallId":"0f6dc35b-eb26-498f-ae35-0e860871446e"},{"index":44388,"token":false,"name":"Kasimir the Lone Wolf","scryfallId":"45b1e60d-54dd-41cd-b9a2-00890725a3df"},{"index":44391,"token":false,"name":"Berserkers' Onslaught","scryfallId":"ee571a78-16b2-40ba-92b2-87c1bf4b39bc"},{"index":44394,"token":false,"name":"Eerie Procession","scryfallId":"3af326c1-fcc8-45c3-b75e-ae4dbbd59ced"},{"index":44402,"token":false,"name":"Greenwood Sentinel","scryfallId":"54a50513-8570-47f0-9c57-6a775f0d2cf2"},{"index":44404,"token":false,"name":"Rakdos the Defiler","scryfallId":"d891044d-9e74-4c5d-95e6-83ceb5163ca8"},{"index":44407,"token":false,"name":"Soulgorger Orgg","scryfallId":"8aef55b8-5813-4aff-a35d-4b3cbd4a9ffb"},{"index":44409,"token":false,"name":"Kill Switch","scryfallId":"a94cfd63-7f2b-4c0a-8dcb-f22cf83e1e27"},{"index":44411,"token":true,"name":"Faerie Token (U, 1/1)","scryfallId":"bcd82cb0-ff4b-4f4d-b3d0-3ac53883b099"},{"index":44421,"token":false,"name":"Cartographer's Hawk","scryfallId":"1b1d26c3-ce06-4d46-87fc-7623edae85b2"},{"index":44422,"token":false,"name":"Exile into Darkness","scryfallId":"4d6ac32c-9555-4408-8b18-c3098802b7ad"},{"index":44423,"token":false,"name":"Zof Consumption // Zof Bloodbog","scryfallId":"98496d5b-1519-4f0c-8b46-0a43be643dfb"},{"index":44431,"token":false,"name":"Telim'Tor's Darts","scryfallId":"59733b76-3b44-4543-8bb2-a160232cee27"},{"index":44433,"token":false,"name":"Curse of Misfortunes","scryfallId":"c531d218-ff1c-4333-a19d-446d709b1e28"},{"index":44436,"token":false,"name":"Soul of Migration","scryfallId":"4541217f-5e86-491b-918b-ed7a2eb3e4eb"},{"index":44439,"token":false,"name":"Marauding Knight","scryfallId":"cea2a7de-c67e-4541-be8c-e5ef7b64d94a"},{"index":44442,"token":false,"name":"Caravan Hurda","scryfallId":"ffdf3a3d-292d-40b9-b28c-34ad33a76bb4"},{"index":44443,"token":false,"name":"Trove Tracker","scryfallId":"c3b74135-b8db-4485-a4b1-7aaa3ef28072"},{"index":44444,"token":false,"name":"Damping Matrix","scryfallId":"e2214e75-e469-41ae-8412-df725c097d08"},{"index":44450,"token":false,"name":"Warlord's Fury","scryfallId":"0ebd63cf-7e8c-4c8d-844d-98535d5f3039"},{"index":44456,"token":false,"name":"Summon the School","scryfallId":"13a4c124-216b-44b1-b49a-3db3f033e4cd"},{"index":44462,"token":false,"name":"Warden of the Beyond","scryfallId":"d0a7406c-8c49-4ef6-a349-902833ea8ec5"},{"index":44463,"token":false,"name":"Venomous Vines","scryfallId":"db10359c-1ea8-4453-bc01-f638ad20a5ec"},{"index":44465,"token":false,"name":"Giant's Amulet","scryfallId":"ab8b1ec2-9303-4722-8644-b3bc1a5c387f"},{"index":44467,"token":false,"name":"Catacomb Sifter","scryfallId":"6c3b220b-e699-45b0-8ec1-1022c1f50329"},{"index":44469,"token":false,"name":"Urborg Justice","scryfallId":"39f322ff-0b04-41ce-90cd-9896f941e703"},{"index":44471,"token":false,"name":"Tomb of Urami","scryfallId":"90fedf90-825c-4814-8f0d-170f537db44c"},{"index":44476,"token":false,"name":"Psychic Rebuttal","scryfallId":"67a105f8-0c01-4c09-a3bf-8c912b6dc741"},{"index":44477,"token":false,"name":"Liquid Fire","scryfallId":"8b836d4c-38f3-4661-9dc7-0c9baaa595a5"},{"index":44478,"token":false,"name":"Swelter","scryfallId":"8f667c26-40f5-4ac5-87a4-cb03f70590a2"},{"index":44482,"token":false,"name":"Archangel of Tithes","scryfallId":"1af50bf1-c51e-4592-86bf-4197ec85a45d"},{"index":44492,"token":false,"name":"Agitator Ant","scryfallId":"29d1122e-ac2d-4d95-829b-7b3b54159a4a"},{"index":44500,"token":false,"name":"Psychic Trance","scryfallId":"d5e55695-16cc-4373-8078-959f1ded4c6d"},{"index":44506,"token":true,"name":"Bird Token (W, 3/4)","scryfallId":"4ac57a34-23ad-4780-a464-e2472d277a27"},{"index":44507,"token":false,"name":"Blood Price","scryfallId":"df14d32d-fe53-4370-8298-fab528ff12db"},{"index":44524,"token":false,"name":"Whisper Agent","scryfallId":"f6d318e7-f49e-49f8-98b6-d62c34aa4af2"},{"index":44533,"token":false,"name":"Abattoir Ghoul","scryfallId":"59cf0906-04fa-4b30-a7a6-3d117931154f"},{"index":44534,"token":false,"name":"Bull Aurochs","scryfallId":"2d59bd4a-006b-4dd8-ab33-d931196f3a8a"},{"index":44555,"token":false,"name":"Ursapine","scryfallId":"2fd99428-c96e-4843-ad78-77cc746799a3"},{"index":44560,"token":false,"name":"Pegasus Charger","scryfallId":"0d0dee73-4df3-4b2f-9420-b23e6ced65c0"},{"index":44561,"token":false,"name":"Fungal Bloom","scryfallId":"cf1a2cb2-9a6b-41f7-96f7-ec457c69c16c"},{"index":44566,"token":false,"name":"Prophetic Ravings","scryfallId":"61f19581-cfd2-455d-a7f2-48143d30a724"},{"index":44568,"token":false,"name":"Galvanic Bombardment","scryfallId":"dc6a4367-bbee-43b8-b5dd-28498f8e2ede"},{"index":44572,"token":false,"name":"Pit Fight","scryfallId":"1d17166b-bc91-42df-ad75-d59682b75128"},{"index":44575,"token":false,"name":"Distant Memories","scryfallId":"158da0aa-8317-498b-89ed-2f84317fe256"},{"index":44580,"token":false,"name":"Shabraz, the Skyshark","scryfallId":"4e1c84fa-b7a5-4931-911e-ec97d048e137"},{"index":44586,"token":false,"name":"Natural Obsolescence","scryfallId":"ff693e03-4cc6-4903-8fc4-388d23c2f92f"},{"index":44596,"token":false,"name":"Master the Way","scryfallId":"704743a8-27d6-4db9-8fe1-f65f5f3a955f"},{"index":44609,"token":false,"name":"Burning-Fist Minotaur","scryfallId":"52f191fb-eaf6-432f-a668-37ad48ffabaf"},{"index":44612,"token":false,"name":"Lightning-Rig Crew","scryfallId":"eb4a34ce-94d5-4e4d-97cc-1326cf5241f5"},{"index":44618,"token":false,"name":"Teferi's Curse","scryfallId":"fb813ef5-8441-4024-a585-1ea24145e1bd"},{"index":44628,"token":false,"name":"Leyline of Lightning","scryfallId":"23d09839-b41e-4aab-8913-40d63052dbf3"},{"index":44629,"token":false,"name":"Nesting Dragon","scryfallId":"ed49cc64-34fc-489f-8d9a-fe1333b69c94"},{"index":44632,"token":false,"name":"Wavecrash Triton","scryfallId":"7336ca1e-13ef-4e49-a526-3f285bc339bb"},{"index":44633,"token":false,"name":"Caustic Wasps","scryfallId":"59a46e20-2910-4287-a5e0-bccac8cbabcd"},{"index":44634,"token":false,"name":"Barrin's Unmaking","scryfallId":"4d4cecb0-12b5-4678-b5e7-8cec8fc86cef"},{"index":44640,"token":false,"name":"Orc Sureshot","scryfallId":"292326cd-4b90-40c6-88b1-f8560fde236c"},{"index":44652,"token":false,"name":"Guildpact Informant","scryfallId":"a304200f-86d5-4eed-a775-cc24e72872ac"},{"index":44660,"token":false,"name":"Lightning Visionary","scryfallId":"af648aaf-a8e0-4291-acf9-5f8533728f92"},{"index":44668,"token":false,"name":"Makindi Patrol","scryfallId":"ae03f018-3062-4b1c-99b8-13fcffd70b49"},{"index":44671,"token":false,"name":"River Sneak","scryfallId":"2be32ffc-dc1d-4bb2-926f-51d110392b06"},{"index":44674,"token":false,"name":"Forsaken Drifters","scryfallId":"05445d18-3590-4216-9392-9438d9f9395d"},{"index":44678,"token":false,"name":"Reality Ripple","scryfallId":"c5b94eed-2a45-4a6b-a06b-a2021b174bc5"},{"index":44679,"token":false,"name":"Serum Powder","scryfallId":"8330afd6-f43a-4955-a704-8f2b963cd0c6"},{"index":44681,"token":false,"name":"Dwarven Bloodboiler","scryfallId":"9ac576b2-cda4-4aea-aa5c-933ec0457dda"},{"index":44688,"token":false,"name":"Goblin War Cry","scryfallId":"3822880c-a559-409c-8390-6d57eacc3a7c"},{"index":44690,"token":false,"name":"Red Scarab","scryfallId":"9a734154-5944-42f4-a02e-c426a45847f3"},{"index":44695,"token":false,"name":"Hooded Horror","scryfallId":"15414338-506b-458f-a067-1a2053373594"},{"index":44697,"token":true,"name":"Serf Token (B, 0/1)","scryfallId":"c98dbedd-b1f1-4a9c-af37-8ce2ae07a247"},{"index":44702,"token":false,"name":"Foxfire Oak","scryfallId":"46e23eae-7630-40db-b265-2fa00715878e"},{"index":44710,"token":false,"name":"Splinterfright","scryfallId":"37068a41-bc5c-44b9-a307-5d3919794233"},{"index":44718,"token":false,"name":"Ichthyomorphosis","scryfallId":"e4763b6c-6471-41bd-b3e4-785564bcf06f"},{"index":44722,"token":false,"name":"Forked Bolt","scryfallId":"06127297-fdaa-45bf-a82e-4fc61315e0e2"},{"index":44724,"token":false,"name":"Helica Glider","scryfallId":"8fc88fe0-2424-49a7-9abf-4773a547d010"},{"index":44734,"token":false,"name":"Crookshank Kobolds","scryfallId":"f51d9dde-536b-4314-8de1-2c05a9bf3dbc"},{"index":44738,"token":false,"name":"Ire of Kaminari","scryfallId":"0b927e30-3508-4daf-91ce-8978b04062cb"},{"index":44739,"token":false,"name":"Rising Populace","scryfallId":"edcacc28-aacf-4d40-b8cc-f8c028380340"},{"index":44740,"token":false,"name":"Roil Spout","scryfallId":"ee9fdecc-ba16-4aa2-9c20-7c2942ec143e"},{"index":44742,"token":false,"name":"Expunge","scryfallId":"0576ffe8-a7b9-479b-8ea0-418b430b1aa1"},{"index":44745,"token":false,"name":"Splinter","scryfallId":"1a94528b-a7f3-4eaa-bb6d-103e72cff3ee"},{"index":44747,"token":false,"name":"Stampede Rider","scryfallId":"c32c6192-2f8d-4656-af8b-c488e27a75e1"},{"index":44755,"token":false,"name":"Treasure Nabber","scryfallId":"673d980e-a5eb-4869-beb4-9a03c18d447a"},{"index":44767,"token":false,"name":"Edgewalker","scryfallId":"c8b477c2-2cd5-41f2-8754-d4d5000df58d"},{"index":44768,"token":false,"name":"Ledev Guardian","scryfallId":"cbeb4ae3-2a7a-44e1-923b-20c772fd1b8b"},{"index":44771,"token":false,"name":"Medicine Bag","scryfallId":"399c06d5-af2a-47a1-9239-ff14224a026b"},{"index":44772,"token":false,"name":"Root Spider","scryfallId":"407d67b0-d496-401b-8844-8e3ea2fd2046"},{"index":44776,"token":false,"name":"Guardian's Magemark","scryfallId":"86a688e9-28ec-4604-8705-46549402a6f8"},{"index":44779,"token":false,"name":"Homicidal Seclusion","scryfallId":"022960a1-8223-4b83-aea2-85359c39f3b8"},{"index":44783,"token":false,"name":"Notion Rain","scryfallId":"f4db287e-34c1-459b-882d-3db58f13eade"},{"index":44786,"token":false,"name":"Curse of Fool's Wisdom","scryfallId":"9b77ded4-a8af-4065-8c4a-fd76e7cdcc59"},{"index":44789,"token":false,"name":"Unified Strike","scryfallId":"29906eca-0823-4cd6-890f-e5b93cc50a11"},{"index":44792,"token":false,"name":"Gateway Shade","scryfallId":"aa33fc15-3a4f-48bc-be7c-fdec1cb49c10"},{"index":44800,"token":false,"name":"Blistercoil Weird","scryfallId":"d2a8e716-ea33-4ae2-9ff8-5e78b0e50459"},{"index":44808,"token":false,"name":"Treasonous Ogre","scryfallId":"ae48c31d-6fd9-457f-adb8-37f367724ba1"},{"index":44809,"token":false,"name":"Sootfeather Flock","scryfallId":"216a2ccc-8847-452b-b030-27d8506675bd"},{"index":44812,"token":false,"name":"Chromescale Drake","scryfallId":"d22aa7ef-da34-49c1-9aac-67d129ffa6fe"},{"index":44818,"token":false,"name":"Pinecrest Ridge","scryfallId":"7900552f-6147-49ec-8c02-f253e4896c4d"},{"index":44819,"token":false,"name":"Thelon's Chant","scryfallId":"9d970195-0a09-4cb4-a2c0-c16fcab5c859"},{"index":44823,"token":false,"name":"Desperate Lunge","scryfallId":"69ce134a-25ef-4f8d-a385-7c29fc5707dc"},{"index":44828,"token":false,"name":"Kitesail Cleric","scryfallId":"16626f84-00d3-4ec9-b62c-19fff380cd3a"},{"index":44831,"token":false,"name":"Cephalid Shrine","scryfallId":"137e0ac1-3bf2-4583-b44f-c9fe8d7e8882"},{"index":44832,"token":false,"name":"Nettlevine Blight","scryfallId":"dd6b1240-0bc3-401a-9cc3-3acaea871a3d"},{"index":44833,"token":false,"name":"Qal Sisma Behemoth","scryfallId":"ea70e96a-bebd-4ca4-aa24-e5fd0df38b8a"},{"index":44837,"token":false,"name":"Rotted Hystrix","scryfallId":"7bcae97d-468a-4e16-bfed-d2946f64784c"},{"index":44838,"token":false,"name":"Umbra Mystic","scryfallId":"a55705d3-8640-478e-ace4-f4f900d617c5"},{"index":44840,"token":false,"name":"Haunted Crossroads","scryfallId":"3c065cae-1ed5-445e-ace3-e81cf4c773de"},{"index":44845,"token":false,"name":"Amnesia","scryfallId":"23d6dbd3-652f-4dc3-9453-24299332938d"},{"index":44850,"token":false,"name":"Frontier Warmonger","scryfallId":"233e1a27-c8d6-46de-a128-89791e7f2e9b"},{"index":44856,"token":false,"name":"Renata, Called to the Hunt","scryfallId":"2b27e6b2-13ad-42b2-a121-70935913723d"},{"index":44858,"token":false,"name":"Twinflame","scryfallId":"207128b3-2de3-495a-bf29-eec50c3bd752"},{"index":44862,"token":false,"name":"Pit Spawn","scryfallId":"669ad60b-4053-4f07-9072-52e6ff65b4e3"},{"index":44863,"token":false,"name":"Blightbeetle","scryfallId":"bd43d44b-de27-4139-9cb8-b1f4c04fb87e"},{"index":44864,"token":false,"name":"Phyrexian Juggernaut","scryfallId":"a9f6ed6c-8095-4a81-b428-36b2916eec88"},{"index":44865,"token":false,"name":"Colossodon Yearling","scryfallId":"f2c60e63-0b86-4100-a932-bb9e9b197610"},{"index":44868,"token":false,"name":"Carrion","scryfallId":"9e6c7750-bc3b-4790-bc9d-88e2cf16881e"},{"index":44871,"token":true,"name":"Devilish","scryfallId":"c0e3f41c-0606-4f49-b0bf-a2fb701c9bb1"},{"index":44880,"token":false,"name":"Wakening Sun's Avatar","scryfallId":"1becd3c5-c6cf-42ce-963f-aa91061c66d0"},{"index":44891,"token":false,"name":"Chandra's Revolution","scryfallId":"2fcee99c-72a0-4db1-b4c9-65c878284450"},{"index":44892,"token":false,"name":"Douse","scryfallId":"93a8d857-184d-4339-88f4-261378e5bd3c"},{"index":44893,"token":false,"name":"Dragon Whisperer","scryfallId":"5c75b106-349f-44e1-a737-079955cc91b2"},{"index":44894,"token":false,"name":"Withering Hex","scryfallId":"9ce4be1e-97dd-45ec-89e5-2fb56145c098"},{"index":44896,"token":false,"name":"Berserk Murlodont","scryfallId":"499c4674-dd9f-4848-8447-721f842a0213"},{"index":44897,"token":false,"name":"Feed the Swarm","scryfallId":"f6b2eba7-862a-4efd-9f65-065fb2070855"},{"index":44903,"token":false,"name":"Mortality Spear","scryfallId":"f1f39fe7-dc12-49c9-80ac-4135dc1f8f08"},{"index":44907,"token":false,"name":"Hipparion","scryfallId":"5969875a-f647-4daf-b76c-d1514d45c312"},{"index":44908,"token":false,"name":"Mage il-Vec","scryfallId":"672b4f9a-84e4-4a27-8d03-11a63a701fec"},{"index":44915,"token":false,"name":"Shoal Kraken","scryfallId":"ec538182-efba-48d0-91ad-457461b44748"},{"index":44916,"token":false,"name":"Mystic Zealot","scryfallId":"23afba2e-54cc-4fab-9684-5e27cb5c855c"},{"index":44926,"token":false,"name":"Shaper Apprentice","scryfallId":"02955471-5ffc-4c7b-83fe-a69816415ca1"},{"index":44927,"token":false,"name":"Wielding the Green Dragon","scryfallId":"2b138167-8129-4109-a58b-af26c95577e4"},{"index":44935,"token":false,"name":"Accursed Centaur","scryfallId":"894556d8-6d5c-431b-a45d-26cd37c5f456"},{"index":44944,"token":false,"name":"Animal Magnetism","scryfallId":"c33db646-b30d-4a15-9f8a-63bda74e2d81"},{"index":44951,"token":false,"name":"Resolute Watchdog","scryfallId":"56d86909-b7f3-4a46-9904-e173853b79f1"},{"index":44952,"token":false,"name":"Advance Scout","scryfallId":"d586407a-d260-48c6-8c05-50612d109221"},{"index":44953,"token":false,"name":"Formation","scryfallId":"78446ead-61b0-485f-a5a9-b3e72d8075a7"},{"index":44961,"token":false,"name":"Sequestered Stash","scryfallId":"86a17084-bb96-4e81-bff0-005bd44a1fbd"},{"index":44962,"token":false,"name":"Watertrap Weaver","scryfallId":"0d973568-d7b0-443f-a09d-44f6b02da5d4"},{"index":44963,"token":false,"name":"Spoils of Evil","scryfallId":"fd368eb6-72f0-42d4-afa5-3daa7de949ff"},{"index":44967,"token":false,"name":"Kaldra Compleat","scryfallId":"a5a0ae99-d84a-4f27-bed8-889747c78529"},{"index":44970,"token":false,"name":"Nihilith","scryfallId":"11a431fa-e98c-434a-9138-b4bcc86edde8"},{"index":44973,"token":false,"name":"Din of the Fireherd","scryfallId":"9bde655f-9f49-42f8-a168-9cbca0592bb8"},{"index":44974,"token":false,"name":"Bottomless Vault","scryfallId":"639ae988-d1d1-4ead-b0f8-47fc39eb64a0"},{"index":44975,"token":false,"name":"Hidden Herd","scryfallId":"20f07992-1f81-440a-a80a-164c44d0a471"},{"index":44979,"token":false,"name":"Vanquish","scryfallId":"27bae717-56c0-4028-b1e7-a445d6a57176"},{"index":44980,"token":false,"name":"Confusion in the Ranks","scryfallId":"9d46aca2-4714-4d2c-9466-5f1c043b8726"},{"index":44981,"token":false,"name":"Band Together","scryfallId":"4d1d8aa1-d742-477c-819a-0113912d5011"},{"index":44982,"token":false,"name":"Chambered Nautilus","scryfallId":"860c613d-d031-4c2a-922b-39f4eec04e18"},{"index":44984,"token":false,"name":"Narcissism","scryfallId":"eea658dd-7567-4b93-88a4-08b4ffb3dad7"},{"index":44993,"token":false,"name":"Gideon's Reproach","scryfallId":"7b771f44-ce32-41a2-b219-738924b7f42d"},{"index":44994,"token":false,"name":"Haunted Guardian","scryfallId":"7d97f8b8-bdb0-4d4b-b077-9affe2f9cd91"},{"index":44995,"token":false,"name":"Bramble Creeper","scryfallId":"74148e2e-ac21-414a-9b6c-410988d7fdd0"},{"index":44996,"token":false,"name":"Havoc Demon","scryfallId":"5ad8ecef-bc09-4d30-bff1-4d21c239b2fb"},{"index":45001,"token":false,"name":"Harnessed Lightning","scryfallId":"f9be9b5c-eed4-4a5d-962f-3482da5a6f1d"},{"index":45007,"token":false,"name":"Narset Transcendent","scryfallId":"4816d092-e34b-4397-8599-43d8e85a8f39"},{"index":45010,"token":false,"name":"Ondu Rising","scryfallId":"07cb9f87-7ba4-408c-952d-fc9a7611df42"},{"index":45015,"token":false,"name":"Twinstrike","scryfallId":"0dfc8ebe-58f4-450f-abdc-8d558f6f5551"},{"index":45016,"token":false,"name":"Ride Down","scryfallId":"3bc9a434-9617-4a20-88f0-355b20f2c538"},{"index":45020,"token":false,"name":"Kessig Forgemaster // Flameheart Werewolf","scryfallId":"33e542ce-1106-489d-9563-bd62886b8ed3"},{"index":45024,"token":false,"name":"Emberwilde Captain","scryfallId":"db9b1282-01fd-48a0-929f-356f6d7e201e"},{"index":45029,"token":false,"name":"Grim Contest","scryfallId":"eb7de65d-d4d6-4090-b749-6bd44bd47568"},{"index":45031,"token":false,"name":"Irreverent Revelers","scryfallId":"55405dca-3555-45ff-be1c-e276fe1a0c2e"},{"index":45036,"token":false,"name":"Kjeldoran Warrior","scryfallId":"ce76f38f-566e-49ff-b197-510cfa1cb51c"},{"index":45046,"token":false,"name":"Species Specialist","scryfallId":"bb2cbf12-7f35-4162-b1a0-89a1632728c7"},{"index":45048,"token":false,"name":"Augury Raven","scryfallId":"a9947cfd-91d6-479e-a7f6-2a2050f020f3"},{"index":45051,"token":false,"name":"Meletis Charlatan","scryfallId":"bf22da0c-5bf5-4c81-9422-671ce17c8ffa"},{"index":45055,"token":false,"name":"Deputized Protester","scryfallId":"8afe85a2-1947-4dd5-98f8-d7ff8df088a1"},{"index":45056,"token":true,"name":"Booster Blitz","scryfallId":"52140a7d-853a-4a32-a0fb-18c4a6bf48a7"},{"index":45057,"token":false,"name":"Scalding Devil","scryfallId":"bbe49a97-dac8-4273-b4dc-45cdf8f5a6e0"},{"index":45058,"token":false,"name":"Rienne, Angel of Rebirth","scryfallId":"1fd040a8-b818-465b-a78b-d68402982abc"},{"index":45067,"token":false,"name":"Mana Matrix","scryfallId":"a3eedc11-0b47-430c-8391-577a2d05c2ae"},{"index":45070,"token":false,"name":"Artisan of Forms","scryfallId":"a7f10198-1eef-4577-b375-b900b15060e1"},{"index":45071,"token":false,"name":"Lethargy Trap","scryfallId":"351aa3f2-864a-4921-a01c-8712560087bb"},{"index":45073,"token":false,"name":"Open Fire","scryfallId":"448f9fb5-ffb5-4325-9f81-ce8782e5f9e9"},{"index":45074,"token":false,"name":"Rootwater Diver","scryfallId":"a6315323-cf82-46c0-b164-e6ea1bf809f4"},{"index":45089,"token":false,"name":"Release to the Wind","scryfallId":"11ccbbb2-0631-4fdf-a1ed-06207c98ed85"},{"index":45092,"token":false,"name":"Corpse Harvester","scryfallId":"39cc7fbb-010f-4e7c-b3bf-8853e54bc1b1"},{"index":45094,"token":false,"name":"Consume Strength","scryfallId":"f005fc90-7e81-4bd4-a479-438337110979"},{"index":45099,"token":false,"name":"Shinewend","scryfallId":"85dbd4a4-2a6f-477a-a267-27859ad73369"},{"index":45103,"token":false,"name":"Stonewood Invocation","scryfallId":"1b300e67-04d2-4c69-b516-c5cc0a6ff2e7"},{"index":45112,"token":false,"name":"Ghalma's Warden","scryfallId":"efbf5ff1-6539-4116-ad4f-ce412ae20640"},{"index":45118,"token":false,"name":"Marhault Elsdragon","scryfallId":"67330004-6720-46d9-9de0-c79230110583"},{"index":45121,"token":false,"name":"Rakavolver","scryfallId":"43787e24-0b7d-4005-8db4-68544476bd34"},{"index":45122,"token":false,"name":"Press into Service","scryfallId":"69b9eb4b-3ab8-4506-baa4-3a818e7677a3"},{"index":45124,"token":false,"name":"Coalhauler Swine","scryfallId":"bc001cef-3afd-4128-989f-ac99dc76b243"},{"index":45126,"token":false,"name":"Devouring Strossus","scryfallId":"064f013f-e74f-419d-8d17-7748bd91885e"},{"index":45128,"token":false,"name":"Steadfast Guard","scryfallId":"07631735-2024-4e7a-b8b3-b7743f4e4a86"},{"index":45130,"token":false,"name":"Scorching Winds","scryfallId":"5fec371e-d4ba-439f-b1b8-2aac3f5b36bf"},{"index":45134,"token":false,"name":"Stensia Banquet","scryfallId":"828db19a-ca0d-4b82-a4b6-451125865093"},{"index":45136,"token":false,"name":"Force of Vigor","scryfallId":"ebd30c7a-7a8c-4176-b1e7-91f4c4a55140"},{"index":45141,"token":false,"name":"Aethertow","scryfallId":"c0b34ecd-6dd4-49b0-ab49-3c11f70e0c4a"},{"index":45142,"token":false,"name":"Drawn from Dreams","scryfallId":"64cbe278-90e6-4dd8-84dd-8ca5dd9b4043"},{"index":45146,"token":false,"name":"Strength from the Fallen","scryfallId":"c76b3a8e-3cbb-47c4-9535-dfdeece7ee02"},{"index":45151,"token":false,"name":"Zebra Unicorn","scryfallId":"a663ee9d-78f1-4c89-af9e-c788e165fa91"},{"index":45156,"token":false,"name":"Armored Wolf-Rider","scryfallId":"e43d959f-6055-4578-a69a-0ec93e993e21"},{"index":45157,"token":false,"name":"Treetop Defense","scryfallId":"f5e134b3-e8af-41e9-928d-c217ea7b2b13"},{"index":45167,"token":false,"name":"Dark Supplicant","scryfallId":"eb685932-5df5-4f26-9633-b1daa8925359"},{"index":45171,"token":false,"name":"Jade Idol","scryfallId":"a58f63c5-cdc5-4079-a727-cff45668d546"},{"index":45176,"token":false,"name":"Culling Sun","scryfallId":"5ec5a956-c846-46b6-91bd-37e4db542280"},{"index":45179,"token":false,"name":"Drown in Shapelessness","scryfallId":"04471528-496b-4c67-ae3f-5373ddf7487d"},{"index":45183,"token":false,"name":"Shu General","scryfallId":"c9c3be7a-82a8-411c-bfe2-16749ada1244"},{"index":45184,"token":false,"name":"Curate","scryfallId":"f2a0e716-22b7-4a5e-9b7a-d4a806ee7427"},{"index":45188,"token":false,"name":"Bold Impaler","scryfallId":"45bb2e6d-2ead-4ce3-8e5e-fc6900435583"},{"index":45189,"token":false,"name":"Heraldic Banner","scryfallId":"2e349af5-3f25-46d3-908e-83b2f6028b95"},{"index":45190,"token":false,"name":"Scatter Arc","scryfallId":"32ed969f-2c8e-4421-9448-dc5a2afdc81d"},{"index":45192,"token":false,"name":"Telethopter","scryfallId":"f6dd54ce-8a80-4746-bd1b-bc49c50c987c"},{"index":45198,"token":false,"name":"Brand of Ill Omen","scryfallId":"ceeb7bbc-2d41-4709-95be-1ceb952ed1fb"},{"index":45215,"token":false,"name":"Hidden Guerrillas","scryfallId":"1ab16fbb-1542-4ba6-9a06-30806176572c"},{"index":45216,"token":false,"name":"Jeskai Windscout","scryfallId":"66356e38-38e1-4b09-80c2-be26007ff99c"},{"index":45217,"token":false,"name":"Herald of Anafenza","scryfallId":"e8bf6ed4-48f3-419f-bafd-d1ee4d798482"},{"index":45227,"token":false,"name":"Leaden Myr","scryfallId":"ec221d0f-1a3a-47ab-9bd2-5dc240a29154"},{"index":45231,"token":false,"name":"Eldrazi Conscription","scryfallId":"c3909816-5cc2-4712-bc7d-534ae0b9229c"},{"index":45232,"token":false,"name":"Mistbind Clique","scryfallId":"cfc421e2-0dd4-4bdf-b5f5-a60c4b0df63b"},{"index":45236,"token":false,"name":"Razor Hippogriff","scryfallId":"fc7ac3bf-eed2-417d-8b60-e8c84bfb98ab"},{"index":45238,"token":false,"name":"Tsabo's Web","scryfallId":"7345b088-b89e-45b5-82ce-77985eeff174"},{"index":45242,"token":true,"name":"Teferi","scryfallId":"cf979a25-629e-4e92-8e52-87f6a078c724"},{"index":45255,"token":false,"name":"Gravespawn Sovereign","scryfallId":"e18dc249-a343-4198-bef9-e8092a2bac15"},{"index":45256,"token":false,"name":"Shu Farmer","scryfallId":"fc6d6524-d8bd-4eb9-9222-747443492b8c"},{"index":45261,"token":false,"name":"Distorting Wake","scryfallId":"77e28743-3694-48ef-9f16-0a3a4ff7e934"},{"index":45266,"token":false,"name":"Hana Kami","scryfallId":"a8304b24-4db8-4082-bdb7-7010bf35e416"},{"index":45267,"token":false,"name":"Knight of Malice","scryfallId":"b45266f0-eb4f-4a06-bc64-8c2d774b4cc5"},{"index":45268,"token":false,"name":"Momir Vig, Simic Visionary","scryfallId":"dd62b042-779c-4a74-b64c-4f0481733398"},{"index":45269,"token":false,"name":"Tajuru Archer","scryfallId":"ec46dbeb-f9b3-4e0f-a61f-52a91da6f087"},{"index":45284,"token":false,"name":"Reknit","scryfallId":"10bde9be-0ad8-4f42-a9a9-838bc476c7a6"},{"index":45288,"token":false,"name":"Great Defender","scryfallId":"879a8653-1538-4f78-a3d3-a900a4d9499b"},{"index":45290,"token":false,"name":"Spider Climb","scryfallId":"a1818812-4cb8-4fe1-98c0-b40086b4991c"},{"index":45302,"token":false,"name":"Geralf's Mindcrusher","scryfallId":"68ac8b5f-4d95-43fc-bf23-10247986a746"},{"index":45303,"token":false,"name":"Haunted Cadaver","scryfallId":"a164420c-3619-4f5e-81cf-2aa5a4553bc3"},{"index":45310,"token":false,"name":"Amphin Pathmage","scryfallId":"e2b1115b-a025-4f27-843c-65f5544f805b"},{"index":45311,"token":false,"name":"Consign to the Pit","scryfallId":"09991fad-4282-4a17-bfb1-03eaa13502df"},{"index":45312,"token":false,"name":"Drowned Rusalka","scryfallId":"68864836-799e-467d-97cc-38c89f71afcf"},{"index":45327,"token":false,"name":"Arctic Nishoba","scryfallId":"91202e2c-4353-4a82-9f17-c70001969129"},{"index":45330,"token":false,"name":"Veteran's Armaments","scryfallId":"a6d0beb9-3381-423f-b54e-5490b892630a"},{"index":45345,"token":false,"name":"Glittering Frost","scryfallId":"c60fbc33-6198-4661-967e-cc94f2788e4a"},{"index":45347,"token":false,"name":"Illuminated Folio","scryfallId":"73d473d9-f52e-4357-b25a-e8bdcc833f09"},{"index":45360,"token":false,"name":"Skittering Invasion","scryfallId":"270f0e5b-2c46-4816-a195-cfce16570bde"},{"index":45363,"token":false,"name":"Chimney Imp","scryfallId":"3316e174-5925-40d8-a1a7-78004d3b800e"},{"index":45364,"token":false,"name":"Asmira, Holy Avenger","scryfallId":"a7d64600-84fc-42a5-a6a6-b26f98fac0a4"},{"index":45368,"token":false,"name":"Bounty Hunter","scryfallId":"98319fd3-0aad-4fc3-bb83-3c027d0ed652"},{"index":45369,"token":false,"name":"Tek","scryfallId":"c1f38104-a699-4bb9-930a-699f7bbc338a"},{"index":45374,"token":false,"name":"Bloodscent","scryfallId":"dca1eb7b-e964-4c36-8fc5-e1d2a98e841f"},{"index":45375,"token":false,"name":"Akki Underling","scryfallId":"106382db-56aa-4061-9d1e-17821937f1de"},{"index":45380,"token":false,"name":"Overgrown Armasaur","scryfallId":"cec16eaa-ae9c-4301-a813-3db0328ca270"},{"index":45381,"token":false,"name":"Widespread Panic","scryfallId":"d9e1b37f-8168-4dc0-858f-434ee96ff748"},{"index":45386,"token":false,"name":"Gilt-Blade Prowler","scryfallId":"32a8cf47-cfe4-4a11-a57d-bebeb2fae437"},{"index":45388,"token":false,"name":"Wild Guess","scryfallId":"a4e513b8-25c2-4645-abcc-a6e9d5f51e09"},{"index":45393,"token":false,"name":"Glaciers","scryfallId":"b86e159b-ecf1-4b4a-9041-4e97fdf935e5"},{"index":45397,"token":false,"name":"Sunhome Enforcer","scryfallId":"c4d5a88e-fc8f-4dd6-a1db-8e44b74ee0a1"},{"index":45407,"token":false,"name":"Flamecore Elemental","scryfallId":"940bfe4f-bc18-4506-b6f4-13d339fd3e55"},{"index":45409,"token":false,"name":"Pincer Spider","scryfallId":"23271658-19ae-420d-beeb-4bed4fdbb891"},{"index":45421,"token":false,"name":"Vedalken Ghoul","scryfallId":"01072149-fe5e-4139-b3b2-3810fd220c8e"},{"index":45422,"token":false,"name":"Rite of Undoing","scryfallId":"20afe614-a367-461a-a67b-02d5ed634cc5"},{"index":45431,"token":false,"name":"Weapons Trainer","scryfallId":"16a0c5e4-c0e8-4be4-8d2f-391b7a6c74ff"},{"index":45436,"token":false,"name":"Alabaster Leech","scryfallId":"c86b45d9-aba6-4c09-8605-037754ba7fd4"},{"index":45439,"token":false,"name":"Metropolis Sprite","scryfallId":"fce74849-2e08-4d08-b387-4693f1b9f653"},{"index":45443,"token":false,"name":"Obscuring Aether","scryfallId":"0bff71e3-b309-4659-9d43-7a0d8ada1efc"},{"index":45448,"token":false,"name":"Ash Zealot","scryfallId":"1f61b1a3-4b3b-4490-a9dc-17aac258cbda"},{"index":45453,"token":false,"name":"Avalanche","scryfallId":"d3a925e5-0d0a-42ec-b1c6-9793b8e11625"},{"index":45459,"token":false,"name":"Pramikon, Sky Rampart","scryfallId":"8569ad47-a243-402d-899f-4e6b17ea4e1e"},{"index":45460,"token":false,"name":"War-Name Aspirant","scryfallId":"e8d1714b-ff65-4c5c-ad21-b469f2c72286"},{"index":45464,"token":false,"name":"Guma","scryfallId":"d6246f17-6034-4423-82c5-1aea8d71f94e"},{"index":45468,"token":false,"name":"Martyr of Spores","scryfallId":"375fc47b-9a1b-4540-9c07-09e4e92ab974"},{"index":45470,"token":false,"name":"Deploy to the Front","scryfallId":"10744088-b028-43aa-8a77-cd2a430fbfb6"},{"index":45477,"token":false,"name":"Aether Tide","scryfallId":"9aab7526-5825-4f31-92ff-be25ab5af2f5"},{"index":45483,"token":false,"name":"Revive the Fallen","scryfallId":"8b0aa3c8-9e11-4917-956b-35b77a100761"},{"index":45490,"token":false,"name":"Khenra Charioteer","scryfallId":"a098fc44-3642-4e99-b543-118ebd8e3170"},{"index":45493,"token":false,"name":"Cryptic Gateway","scryfallId":"7f379966-6a0a-434c-8682-1cf528a9a4a1"},{"index":45498,"token":false,"name":"Eye of Nowhere","scryfallId":"b307af89-1890-4fac-a12e-f8a678f1101f"},{"index":45501,"token":false,"name":"Break the Ice","scryfallId":"01ca9568-06b6-4c57-b1f6-8a74ec2a2b91"},{"index":45504,"token":false,"name":"Stand Together","scryfallId":"0d60c590-fb9d-433a-8e5f-2b1aff4efd29"},{"index":45509,"token":false,"name":"Sachi, Daughter of Seshiro","scryfallId":"4c45b36f-b879-417c-b284-0176990fb9f9"},{"index":45513,"token":false,"name":"Looming Hoverguard","scryfallId":"29de2f4c-81a6-42c7-94d1-f9109c3331ff"},{"index":45516,"token":false,"name":"Cogwork Grinder","scryfallId":"807b1ac7-a495-4d67-a6c6-480d1b0522d8"},{"index":45519,"token":false,"name":"Femeref Healer","scryfallId":"90dedd5e-e2ee-46ec-8541-27f1548b2a2a"},{"index":45522,"token":false,"name":"Thraben Doomsayer","scryfallId":"0e0fa5ab-c4d1-4b2d-ad62-feb651e4b11c"},{"index":45523,"token":false,"name":"Scent of Nightshade","scryfallId":"582468a6-0ea9-411e-a694-13977d47c877"},{"index":45525,"token":false,"name":"Firefright Mage","scryfallId":"a6e1f374-d5fc-4f39-ad2a-2c9dad74efd3"},{"index":45528,"token":false,"name":"Hypochondria","scryfallId":"3467c940-dae4-4667-bec8-524dbce13283"},{"index":45535,"token":false,"name":"Geothermal Crevice","scryfallId":"e744b593-13fe-4967-b492-ac02f5815e57"},{"index":45538,"token":false,"name":"Death Bomb","scryfallId":"f8a84715-c5dc-4a19-af6a-796c6ee912c2"},{"index":45542,"token":false,"name":"Illusory Gains","scryfallId":"747dfb21-a00c-46ba-9da3-739f570e1246"},{"index":45546,"token":false,"name":"Winnow","scryfallId":"d61748dd-4010-47da-8717-ca0147877057"},{"index":45550,"token":false,"name":"Solemnity","scryfallId":"04ef71bc-5640-4d34-972d-f9962dbab813"},{"index":45557,"token":false,"name":"Compulsory Rest","scryfallId":"377ddb92-3abe-4d5c-a140-7b69fefd0e96"},{"index":45563,"token":false,"name":"Sludge Crawler","scryfallId":"9782b463-0677-40f4-ab2c-4c3ff19f1168"},{"index":45564,"token":true,"name":"Elemental Token (R, 7/1)","scryfallId":"f9e12780-9c25-4cb0-b1ff-a36ca50b19d8"},{"index":45565,"token":false,"name":"Proper Burial","scryfallId":"ae8a4756-d82b-4c6d-b652-5c3722d3edec"},{"index":45568,"token":false,"name":"Gale Force","scryfallId":"26c5c233-a373-4ac4-9b99-81ed97df1f9b"},{"index":45571,"token":false,"name":"Bronzebeak Moa","scryfallId":"291c0ebc-d489-42c7-8d8a-9216c333412f"},{"index":45572,"token":false,"name":"Drey Keeper","scryfallId":"995529d1-e2b0-4cce-bd40-56c7ef3c33da"},{"index":45583,"token":false,"name":"Legion Guildmage","scryfallId":"b03423b2-faca-4b2e-8328-8b9b7fdb7ce3"},{"index":45586,"token":false,"name":"Lambholt Elder // Silverpelt Werewolf","scryfallId":"932d753d-9584-4ad8-9a5e-a3524184f961"},{"index":45587,"token":false,"name":"Dynacharge","scryfallId":"a9e530cc-21b9-43c2-a6a9-f1d96e06c2cd"},{"index":45588,"token":false,"name":"Spiritual Sanctuary","scryfallId":"654dd1e0-a91d-44ee-af20-c025bf360c3f"},{"index":45589,"token":false,"name":"Wormwood Dryad","scryfallId":"d35ad370-1b7e-4926-9580-7acf919787f2"},{"index":45594,"token":false,"name":"Joraga Invocation","scryfallId":"65c89431-0881-4aa6-ac15-d4c13b075273"},{"index":45599,"token":false,"name":"Felhide Petrifier","scryfallId":"4d6cce01-a0cb-4059-a0ad-fbf7d9b998b8"},{"index":45602,"token":false,"name":"Dawnglow Infusion","scryfallId":"038bec82-24a0-4764-a1a0-671f597ebc35"},{"index":45604,"token":false,"name":"Llanowar Druid","scryfallId":"ffad279c-762a-42cf-ac20-f4e48734c194"},{"index":45605,"token":false,"name":"Bringer of the Red Dawn","scryfallId":"16a58bb1-4c4d-41f2-9c69-d3c3a8a8ab09"},{"index":45607,"token":false,"name":"Gate to the Aether","scryfallId":"c28fd840-e633-46d3-991a-b9fea95a2f28"},{"index":45614,"token":false,"name":"Gyre Engineer","scryfallId":"26dd6a1d-4dcb-4392-9856-c0e4140efbd7"},{"index":45618,"token":false,"name":"Rolling Temblor","scryfallId":"15ebe6be-6d36-4ed4-a23d-770faed22e15"},{"index":45621,"token":false,"name":"Highspire Infusion","scryfallId":"08325c39-0eeb-4bd0-9adc-2892c1c6637e"},{"index":45625,"token":false,"name":"Festival","scryfallId":"e9357990-701a-4336-b545-ac5a24d89cad"},{"index":45627,"token":false,"name":"Mwonvuli Acid-Moss","scryfallId":"6841dbf6-5023-4612-bbd7-182fd35b05c8"},{"index":45630,"token":false,"name":"Meditate","scryfallId":"edb79a97-c1fc-4aa3-bb13-3d24a6dabeea"},{"index":45633,"token":false,"name":"Drowned","scryfallId":"92debe15-70c2-4d91-9fdc-f85c05ceef1d"},{"index":45643,"token":false,"name":"Deathknell Kami","scryfallId":"09535c14-ae50-4528-b9db-7eacee14e3fa"},{"index":45644,"token":false,"name":"Spined Basher","scryfallId":"4d0d666a-8e31-466c-937f-54df910f664e"},{"index":45648,"token":false,"name":"Trained Condor","scryfallId":"6e1eaa5a-3f9d-4166-b418-fd82fff86c73"},{"index":45651,"token":false,"name":"Bury in Books","scryfallId":"ac2a2cf5-80cf-4c06-8b04-bc04a5460de5"},{"index":45652,"token":false,"name":"Defender en-Vec","scryfallId":"e7b224b7-d5f7-4515-beca-523f305ee3b8"},{"index":45654,"token":false,"name":"Strata Scythe","scryfallId":"4d623951-3896-494d-bcc5-6caf3cc74bc6"},{"index":45658,"token":false,"name":"Keldon Battlewagon","scryfallId":"5c810aa1-e367-4102-a5bd-6dc02d3023e8"},{"index":45662,"token":false,"name":"Alibou, Ancient Witness","scryfallId":"fd2fc2d4-c4fb-4dcb-93fa-aaf8c1182f15"},{"index":45665,"token":false,"name":"Elemental Appeal","scryfallId":"3a583f30-a3e0-4c4f-81b3-01452edaf22c"},{"index":45671,"token":true,"name":"Tom van de Logt Decklist (2001)","scryfallId":"9b4e9e76-677c-479a-949e-d7e47372bc58"},{"index":45680,"token":false,"name":"Lu Su, Wu Advisor","scryfallId":"d132e6c8-293f-4f7b-94c9-c97cc01cdda9"},{"index":45681,"token":true,"name":"Svend Geertsen Decklist","scryfallId":"486a8135-c367-49ee-8465-f8fc76906aed"},{"index":45684,"token":false,"name":"Captivating Gyre","scryfallId":"a2bd5c34-fa7e-4fa8-a5b1-c3aa928cc834"},{"index":45695,"token":false,"name":"Haazda Shield Mate","scryfallId":"8940e8c6-1423-4dbf-89c8-9055bf15d4ec"},{"index":45701,"token":false,"name":"Howlpack Resurgence","scryfallId":"a0063470-3728-4d7e-8f77-5e9c9c7d6a6a"},{"index":45704,"token":false,"name":"Bolrac-Clan Crusher","scryfallId":"5080975e-693a-44f5-a718-9ee947dada6d"},{"index":45713,"token":false,"name":"Wort, the Raidmother","scryfallId":"535189ec-572f-44ed-9741-09b9f575fc40"},{"index":45716,"token":false,"name":"Zombie Outlander","scryfallId":"f27c2690-5121-452b-b82a-72acb8be6878"},{"index":45719,"token":false,"name":"Tireless Missionaries","scryfallId":"cc42fe32-5f02-472c-a25e-d03e01546dc6"},{"index":45726,"token":false,"name":"Guildscorn Ward","scryfallId":"89c5c496-0a3e-40e1-84ac-8ad3a9d8352b"},{"index":45732,"token":false,"name":"Pure Reflection","scryfallId":"bbff85a6-a51b-424e-a86b-da52c9b3a9da"},{"index":45737,"token":false,"name":"Hall of Heliod's Generosity","scryfallId":"b5cbd10a-b9a6-4c00-8280-72bb4add4390"},{"index":45741,"token":false,"name":"Gideon's Resolve","scryfallId":"a30b8c40-39ac-423f-b7da-845a16cd1b63"},{"index":45746,"token":true,"name":"Zombie Horror Token (B, */*)","scryfallId":"533c41ab-d9ee-4817-a982-41d4da6fa9ad"},{"index":45748,"token":false,"name":"Phyrexian Devourer","scryfallId":"ca4e27ca-a731-44f5-8e47-701c7a7e6149"},{"index":45750,"token":false,"name":"Isperia's Skywatch","scryfallId":"019ba84d-d236-45c5-a8ad-75def7736d0c"},{"index":45756,"token":false,"name":"Sands of Delirium","scryfallId":"78c9d3bf-c858-42f4-bb61-3292f9a7141b"},{"index":45762,"token":false,"name":"Seashell Cameo","scryfallId":"9efdbcad-e2e4-4f54-ade5-920b1853109e"},{"index":45773,"token":false,"name":"Grim Roustabout","scryfallId":"1a5ae3f5-5466-4058-a2cd-1a036cb38a8e"},{"index":45778,"token":false,"name":"Pyroclast Consul","scryfallId":"17a1c7c8-1acd-4219-a272-69e855517a74"},{"index":45782,"token":false,"name":"Oxidda Scrapmelter","scryfallId":"c64fe85b-e471-489a-8c38-2357da1c7969"},{"index":45783,"token":true,"name":"Spirit // Spirit Token (W, 1/1)","scryfallId":"41fc8b22-f6fe-4853-b80a-64ab70a41f1d"},{"index":45799,"token":false,"name":"Reveille Squad","scryfallId":"8f6385bb-18f9-461b-b541-3c2a5e59189b"},{"index":45802,"token":false,"name":"Battlefield Medic","scryfallId":"9c444503-42a8-4952-819b-bbca89b06abc"},{"index":45803,"token":false,"name":"Charmed Pendant","scryfallId":"701942dd-7777-436f-8076-194584be8285"},{"index":45807,"token":false,"name":"Sunder","scryfallId":"30053742-35e4-4ae0-a90e-d687a5f298d9"},{"index":45808,"token":false,"name":"Skywatcher Adept","scryfallId":"be61e893-4bf5-4550-83f4-42ebe7f1e3b0"},{"index":45812,"token":false,"name":"Shrine of Loyal Legions","scryfallId":"ced53428-391d-4b61-83e8-cce297e28de9"},{"index":45817,"token":false,"name":"Cytospawn Shambler","scryfallId":"17c87c15-742b-47fb-9d4c-0a985cc1e15a"},{"index":45819,"token":false,"name":"Heed the Mists","scryfallId":"eb953ffc-0e73-42a2-a026-e6d3041fd8ec"},{"index":45826,"token":false,"name":"Hallowed Healer","scryfallId":"254d5bf0-f985-4919-a142-d4578ae9a38e"},{"index":45827,"token":false,"name":"Words of War","scryfallId":"2593a6a6-dc21-4742-acb8-f7092931b1ce"},{"index":45832,"token":false,"name":"Decorated Griffin","scryfallId":"7bc2f3a0-444d-4cad-970f-6c4a63b02cce"},{"index":45840,"token":false,"name":"Myojin of Night's Reach","scryfallId":"13a295b0-535e-4c2d-879d-62603d1f2f1b"},{"index":45841,"token":false,"name":"Shipwreck Looter","scryfallId":"61f1ba12-c674-465b-8df3-edf812ea4447"},{"index":45850,"token":false,"name":"Ghoulcaller's Bell","scryfallId":"863e7c2a-698c-4dce-a10b-ca58e4affa57"},{"index":45851,"token":false,"name":"Ovinize","scryfallId":"a985cfb0-6bae-4b1c-902e-d9d7a1aeec61"},{"index":45852,"token":false,"name":"Doubtless One","scryfallId":"0dedef8a-5527-40dc-9ad9-bcee4cf30a76"},{"index":45860,"token":false,"name":"Vivid Revival","scryfallId":"b47ab9dc-7af4-4c2c-907c-d352de8ab67f"},{"index":45861,"token":false,"name":"Viscerid Deepwalker","scryfallId":"cdc9f54e-7fba-4f03-83ca-6d293dffc07a"},{"index":45869,"token":false,"name":"Body Double","scryfallId":"e880b0b5-8aa0-4961-8dc5-61631a37cb26"},{"index":45876,"token":false,"name":"Extortion","scryfallId":"a66742db-4750-49ce-ad05-b825af7222c4"},{"index":45881,"token":false,"name":"Nectar Faerie","scryfallId":"d943b877-805d-4bc8-a3ae-abec00fa51a6"},{"index":45889,"token":false,"name":"Phantom Wurm","scryfallId":"68f48a57-5005-46c7-8b52-97e2f9112b85"},{"index":45891,"token":false,"name":"Marauding Maulhorn","scryfallId":"b7d5e3dc-f307-4f91-a5ee-e7c5d03d8102"},{"index":45897,"token":false,"name":"Rage of Purphoros","scryfallId":"1e249f31-cc67-4d0c-9db5-962d10cf74ca"},{"index":45900,"token":false,"name":"Urza's Guilt","scryfallId":"d429233e-1cf9-4f87-b191-894a73e7a876"},{"index":45909,"token":false,"name":"Accorder Paladin","scryfallId":"df0a4370-729d-40e7-b68b-21902648492d"},{"index":45910,"token":false,"name":"Maulfist Doorbuster","scryfallId":"53681384-b72d-42a6-b134-aa420115ea12"},{"index":45911,"token":false,"name":"Krovikan Rot","scryfallId":"17597c66-0d9f-41af-9160-0d92be88f450"},{"index":45916,"token":false,"name":"Inferno Elemental","scryfallId":"53f05a58-a801-483a-8648-8685a4eaa773"},{"index":45928,"token":false,"name":"Shredded Sails","scryfallId":"8b10219a-aa72-4431-9a6a-984109a605c8"},{"index":45929,"token":false,"name":"Bond of Agony","scryfallId":"832acb3f-4dd4-4bf1-b990-7cc7a68a1d57"},{"index":45930,"token":false,"name":"Recuperate","scryfallId":"a5945397-0906-48dd-80d1-c65bfa2b31a6"},{"index":45938,"token":false,"name":"Siren of the Fanged Coast","scryfallId":"5ba93d9a-94cd-4d90-860a-f567793a5be4"},{"index":45944,"token":false,"name":"Abzan Kin-Guard","scryfallId":"cec0ef55-57fd-404f-b9f6-b5d41e77b58c"},{"index":45950,"token":false,"name":"Matca Rioters","scryfallId":"b32dcf7d-ac19-45c5-8c3a-1155bf25b216"},{"index":45951,"token":false,"name":"Icatian Skirmishers","scryfallId":"15f6d115-c02d-45a3-aa6d-402964df47dd"},{"index":45952,"token":false,"name":"Alert Shu Infantry","scryfallId":"c94a92a9-060e-42d3-a8d1-49425defc08a"},{"index":45956,"token":false,"name":"Stubborn Denial","scryfallId":"6f8626c4-306f-4e9d-8840-2bb73fe87e87"},{"index":45957,"token":false,"name":"Lightning Javelin","scryfallId":"c1ccaeed-9670-4432-8a45-d5c06119fa9f"},{"index":45958,"token":false,"name":"Coercive Recruiter","scryfallId":"8daee74d-aaf9-41bb-96f4-6d967cd4faf7"},{"index":45966,"token":true,"name":"Ragavan Token (R, 2/1)","scryfallId":"1ebc91a9-23e0-4ca1-bc6d-e710ad2efb31"},{"index":45971,"token":false,"name":"Ethereal Whiskergill","scryfallId":"5b9fa774-fb6d-4a2f-96d5-a449a423312e"},{"index":45974,"token":false,"name":"Plague Witch","scryfallId":"ca3614c2-39b4-4f67-adab-373dcb9e4553"},{"index":45979,"token":false,"name":"Oculus","scryfallId":"673bebb4-9c82-40ca-8552-b9030e961005"},{"index":45980,"token":false,"name":"Brood Keeper","scryfallId":"0a640a5b-c638-4ae6-ad02-eb5fe20f4662"},{"index":45981,"token":false,"name":"Burning Anger","scryfallId":"2058a7eb-0f78-46a4-bea5-afdfe920264f"},{"index":45982,"token":false,"name":"Vigean Hydropon","scryfallId":"6373aedc-4385-4608-bfbc-1937d6528d28"},{"index":45986,"token":false,"name":"Hero of Leina Tower","scryfallId":"93f3f0ce-e8f5-4020-b8db-23a6aa7f7cb5"},{"index":45996,"token":false,"name":"Scatter to the Winds","scryfallId":"d73ad49f-fe15-4fe5-9731-fd71d31c1e7f"},{"index":46005,"token":false,"name":"Raven's Run Dragoon","scryfallId":"b868da85-9d19-4407-a0c3-fc3b2b237cda"},{"index":46015,"token":false,"name":"Tezzeret's Simulacrum","scryfallId":"7eacfeec-a341-45bc-bf95-e3df0094505a"},{"index":46019,"token":false,"name":"Disciple of Griselbrand","scryfallId":"30c9c0f0-2668-4163-8158-fada2d953cb3"},{"index":46026,"token":false,"name":"Giant's Grasp","scryfallId":"74c92d48-504a-4320-b9f4-c1d2d06fa223"},{"index":46028,"token":false,"name":"Frostwalk Bastion","scryfallId":"bfb5d83f-2b7c-4c22-ac37-938e7cd1654a"},{"index":46033,"token":false,"name":"Tin-Wing Chimera","scryfallId":"3375dcc6-9399-48eb-9aa4-7b40c3686cc5"},{"index":46040,"token":false,"name":"Joust","scryfallId":"5e725f04-5530-47f1-9f04-4cc13ed9348b"},{"index":46043,"token":false,"name":"Boneshard Slasher","scryfallId":"27201370-32cc-4b90-890d-8c3f5362ad70"},{"index":46055,"token":false,"name":"Righteous Aura","scryfallId":"fed82843-2853-42d3-bcf6-b831032b7a69"},{"index":46063,"token":false,"name":"Refraction Trap","scryfallId":"bcdceb36-fd36-4315-8ebe-9b8fc3777428"},{"index":46065,"token":false,"name":"Kor Celebrant","scryfallId":"87c37e46-a961-4739-8893-f783013e2be6"},{"index":46070,"token":false,"name":"Nested Ghoul","scryfallId":"c035ff58-9df3-4db4-b9d0-97d58080ecfe"},{"index":46071,"token":false,"name":"Primal Boost","scryfallId":"f1b91a5a-9328-4fc6-a2f6-a7879281e145"},{"index":46089,"token":false,"name":"Benalish Infantry","scryfallId":"e8472303-b8ee-402b-a9ea-49abe2e01152"},{"index":46092,"token":false,"name":"Mesmeric Trance","scryfallId":"91129aeb-eed5-4b98-896f-fb3bab48b25d"},{"index":46096,"token":false,"name":"Archon of Falling Stars","scryfallId":"d0dd1e40-a514-42df-8cc1-364998c7700c"},{"index":46098,"token":false,"name":"Binding Agony","scryfallId":"b620a9f4-358d-4436-85b8-b0c16602ff57"},{"index":46100,"token":false,"name":"Rhox Meditant","scryfallId":"b74f4f8d-2191-4743-aac6-cdcb4a68379c"},{"index":46111,"token":false,"name":"Professor of Symbology","scryfallId":"f427cf73-9f5e-4ef5-bc4f-29ffbfda9d57"},{"index":46121,"token":true,"name":"Goblin Construct Token (Colorless, 0/1)","scryfallId":"b24a63e2-c2b3-43f8-a15a-68886bec7d60"},{"index":46132,"token":false,"name":"Jade Bearer","scryfallId":"696bb954-353e-488b-a1e8-0df75da6339b"},{"index":46133,"token":false,"name":"Pilgrim of Justice","scryfallId":"6103a3a7-78ce-4a66-bd82-434e0bd9dea4"},{"index":46140,"token":false,"name":"Nightmare's Thirst","scryfallId":"f12efbc0-ce88-4622-ad07-2808e651ac5a"},{"index":46150,"token":false,"name":"Traveling Plague","scryfallId":"d4b6413d-68d3-4097-9bb3-873df4900e4c"},{"index":46153,"token":false,"name":"Prophecy","scryfallId":"f514eb63-3a4e-4410-ba3d-487cf81f7063"},{"index":46156,"token":false,"name":"Childhood Horror","scryfallId":"10c180ea-2d1e-458e-b5d4-e87975eba968"},{"index":46166,"token":false,"name":"Lorehold Apprentice","scryfallId":"048157c6-4626-4881-ba19-deddd13622dc"},{"index":46167,"token":false,"name":"Iron Tusk Elephant","scryfallId":"d7c8e952-f040-4e5b-88f3-f80ad4b3f2f1"},{"index":46168,"token":false,"name":"Neyith of the Dire Hunt","scryfallId":"0c1eed0f-9692-44c0-b1ad-afa691165d52"},{"index":46173,"token":false,"name":"Skyclave Sentinel","scryfallId":"fac8809a-77cd-4090-8a89-12121a8da676"},{"index":46179,"token":false,"name":"Titania's Boon","scryfallId":"b8d64591-8552-4e94-b932-7a23922513a1"},{"index":46182,"token":false,"name":"Rimebound Dead","scryfallId":"6877469b-f14e-4121-aa5d-6cea92ab7278"},{"index":46183,"token":false,"name":"Anurid Barkripper","scryfallId":"33255dfd-f8a9-4a15-aac5-c53dc0257859"},{"index":46203,"token":false,"name":"Rootwater Commando","scryfallId":"8e86f36d-584d-49b2-8c66-19c262408950"},{"index":46208,"token":false,"name":"Cho-Manno's Blessing","scryfallId":"5c9f33c6-5294-4584-854d-c8c0f847aba8"},{"index":46215,"token":false,"name":"Charisma","scryfallId":"63565b03-28e9-4534-b085-d5803e2623bb"},{"index":46224,"token":false,"name":"Squirming Mass","scryfallId":"e47793a3-9a98-4733-8d6a-2fb1a67b15c9"},{"index":46229,"token":false,"name":"Voracious Hydra","scryfallId":"3267174f-92e8-43ee-836e-5360eb716b4d"},{"index":46230,"token":false,"name":"Mystic Melting","scryfallId":"bf4ff91d-acc1-4be7-a327-58fcb036b452"},{"index":46232,"token":false,"name":"Keep Safe","scryfallId":"febfa682-76ae-4979-a40c-c1eae1121f3c"},{"index":46238,"token":false,"name":"Beamsplitter Mage","scryfallId":"8f1801f2-ea6e-4196-858e-2afc456cf6a0"},{"index":46246,"token":false,"name":"Dispersing Orb","scryfallId":"69db0298-f6d5-450f-add3-a28c0a43f33f"},{"index":46250,"token":false,"name":"Stalwart Shield-Bearers","scryfallId":"868256bb-d4e2-42eb-a43a-360148aec06f"},{"index":46262,"token":false,"name":"Baron Sengir","scryfallId":"51bdddac-02fc-493a-a0ea-689273252d7e"},{"index":46263,"token":false,"name":"Toils of Night and Day","scryfallId":"0881f8bf-5c28-4f54-9080-9612790ffa83"},{"index":46269,"token":false,"name":"Maelstrom Archangel","scryfallId":"6620ead7-4499-4a19-b3b8-edd263067c02"},{"index":46274,"token":false,"name":"Skophos Reaver","scryfallId":"32691e3f-dea9-45ac-96fe-96b34d5116a9"},{"index":46275,"token":false,"name":"Desert Nomads","scryfallId":"e46d0c10-ec09-48ba-9e93-1392dca8111a"},{"index":46281,"token":false,"name":"Malakir Soothsayer","scryfallId":"72cb3c2c-5d5a-4c9b-a381-ab4dd477d84d"},{"index":46285,"token":false,"name":"Falkenrath Exterminator","scryfallId":"40e23909-7e08-4686-ae59-e18e7d4cfd3c"},{"index":46292,"token":false,"name":"Rites of Spring","scryfallId":"1bddb0ef-fdda-491b-a0cf-48cbdd761918"},{"index":46293,"token":true,"name":"Survivor Token (R, 1/1)","scryfallId":"f4478979-19b6-4524-bbbd-519594c38f5a"},{"index":46299,"token":false,"name":"Daghatar the Adamant","scryfallId":"948f595c-4e7a-4109-8e8d-a3a92d125744"},{"index":46307,"token":false,"name":"Vial of Poison","scryfallId":"7769159b-5a6a-45e5-b69b-8db2a6ef5418"},{"index":46316,"token":false,"name":"Renegade Krasis","scryfallId":"23b68921-0c34-4d92-83c3-21542f62c7f6"},{"index":46321,"token":false,"name":"Lockjaw Snapper","scryfallId":"fae1cc40-12c0-4300-b6fa-7af32167a158"},{"index":46324,"token":false,"name":"Gibbering Kami","scryfallId":"9a3e988f-314c-4e83-b279-c2a736933e64"},{"index":46329,"token":false,"name":"Prophet of Distortion","scryfallId":"03ee2d7e-50ee-4f5a-b787-cf9669a892f3"},{"index":46330,"token":false,"name":"Confront the Unknown","scryfallId":"c59557c3-aba2-4f80-8f37-accb7b991cb9"},{"index":46331,"token":false,"name":"Elvish Guidance","scryfallId":"8698c46b-2628-4482-88f9-e37a01ade274"},{"index":46333,"token":false,"name":"Sanctum of Fruitful Harvest","scryfallId":"5ca28cfd-1a1b-4176-8b07-993d3d7b7ae4"},{"index":46335,"token":false,"name":"Song of Blood","scryfallId":"4497a1d7-6604-4f2d-9484-1f1d77a6228f"},{"index":46350,"token":false,"name":"Heartlash Cinder","scryfallId":"f1c38e02-5df3-4655-a18f-a7be2c352b7b"},{"index":46353,"token":false,"name":"Sevinne, the Chronoclasm","scryfallId":"2c209efe-b4dc-44a3-bd45-d647f5680cbe"},{"index":46361,"token":false,"name":"Anodet Lurker","scryfallId":"c97773f5-548a-4107-b29c-56b5428d5ddb"},{"index":46366,"token":false,"name":"Fire Ambush","scryfallId":"4dd8bdbd-99c9-4fa7-936a-acc7f4238507"},{"index":46370,"token":false,"name":"Parallax Inhibitor","scryfallId":"f758617c-f0e4-43d5-8fb4-e33eb2c5b99f"},{"index":46371,"token":false,"name":"Kabira Evangel","scryfallId":"57f05d96-42d5-4e1d-a9c6-229a3f42dda9"},{"index":46374,"token":false,"name":"Kitsune Healer","scryfallId":"11bb6894-b56a-4a63-859a-65a0c2d160fc"},{"index":46378,"token":false,"name":"Thassa's Emissary","scryfallId":"f52b325b-3ea9-4a99-ae99-9d158560e45b"},{"index":46381,"token":false,"name":"Pendrell Drake","scryfallId":"986b6708-5ed4-4085-b9b7-d359b2d5b26f"},{"index":46382,"token":false,"name":"Redcap Raiders","scryfallId":"686cf5c4-6ba3-4fa0-9732-0a350c637c7a"},{"index":46387,"token":false,"name":"Meteoric Mace","scryfallId":"28cb7e94-01df-4e80-9b24-bc303a27ffd6"},{"index":46389,"token":false,"name":"Spiritual Focus","scryfallId":"8521ae08-eb46-45ff-8fc4-62d8b07cfac2"},{"index":46401,"token":false,"name":"Squee's Embrace","scryfallId":"e682a705-9341-4d1e-a9c5-d428e50b9a03"},{"index":46406,"token":false,"name":"Goblin Lookout","scryfallId":"23bbe84a-8857-467a-a4a1-e57086cc9501"},{"index":46414,"token":false,"name":"Embodiment of Fury","scryfallId":"92f385d1-a6c5-40b7-bc90-6f71b6f815e7"},{"index":46416,"token":false,"name":"Fangren Marauder","scryfallId":"f5cf62a2-d03a-495d-924a-bf79524175fa"},{"index":46417,"token":false,"name":"Ore Gorger","scryfallId":"ecc8bbb9-d6a1-474b-8f34-594b5a9d4178"},{"index":46421,"token":false,"name":"Savage Beating","scryfallId":"c3739d37-7865-46bf-abbc-7a5678709508"},{"index":46422,"token":false,"name":"Cabal Paladin","scryfallId":"2cff2cb9-f4e6-4fee-94ef-ad11e24525c1"},{"index":46429,"token":false,"name":"Master of Diversion","scryfallId":"2bec89b3-640e-4093-a6e9-5639610769b9"},{"index":46431,"token":false,"name":"Hierophant's Chalice","scryfallId":"6e8be52c-25ce-49da-8435-58797550f058"},{"index":46433,"token":false,"name":"Lieutenants of the Guard","scryfallId":"71bf4f19-802d-466a-85f1-2062ae3656a1"},{"index":46434,"token":false,"name":"Honey Mammoth","scryfallId":"84b9bee2-b973-4de7-b72d-7f36f8e8153c"},{"index":46443,"token":false,"name":"Wolfwillow Haven","scryfallId":"72b886c3-234c-49ce-9a11-456c1e8f092f"},{"index":46447,"token":false,"name":"Unfriendly Fire","scryfallId":"7a61b274-0499-4cb6-a2e4-f5e18ad7fd2d"},{"index":46449,"token":false,"name":"Wild Evocation","scryfallId":"b39aea56-5c56-4241-81c9-928c3253d7c9"},{"index":46452,"token":false,"name":"Thrasta, Tempest's Roar","scryfallId":"9abf3165-6260-4dcf-8f06-6e808bff0289"},{"index":46457,"token":false,"name":"Sheltering Light","scryfallId":"b0c945c7-6c31-4c4f-9203-3dc2aef50820"},{"index":46461,"token":false,"name":"Goliath Beetle","scryfallId":"f83d8765-f654-4837-9b06-739610188415"},{"index":46462,"token":false,"name":"Cartel Aristocrat","scryfallId":"25bcfbc0-1401-4e5e-8145-c8936c4ff725"},{"index":46463,"token":false,"name":"Pygmy Allosaurus","scryfallId":"88a68767-9822-4f15-895e-32164e2159be"},{"index":46470,"token":false,"name":"Misstep","scryfallId":"8e23f5a1-bf3e-41e0-875f-fc2f8508e69f"},{"index":46472,"token":false,"name":"Infectious Rage","scryfallId":"8569cdf7-e0e9-4733-98b5-56fac216fad3"},{"index":46474,"token":false,"name":"Lavafume Invoker","scryfallId":"8e773b3f-37ef-4e37-8b1e-99b7b6314877"},{"index":46480,"token":false,"name":"Hundred-Talon Strike","scryfallId":"3ed548e0-9196-4bfc-9cfd-149abb945574"},{"index":46483,"token":false,"name":"Hidden Predators","scryfallId":"27f8ee86-a576-4f40-b165-be5b4558507d"},{"index":46484,"token":false,"name":"Revenant Patriarch","scryfallId":"c71b7b73-567a-4291-bf60-f17c1fe55de6"},{"index":46489,"token":false,"name":"Demonic Rising","scryfallId":"a2136a82-b535-47f6-9eee-5b7585ac5cf1"},{"index":46495,"token":false,"name":"Foundry Assembler","scryfallId":"e83a2862-a2d7-4d87-a4b8-def9f441f5fa"},{"index":46502,"token":true,"name":"Spirit Token (U, 1/1)","scryfallId":"44c14591-f807-40cf-9c00-4c94b85fff44"},{"index":46505,"token":false,"name":"Minister of Impediments","scryfallId":"96aada87-a880-4d33-8694-9fbc74211755"},{"index":46509,"token":false,"name":"Sadistic Sacrament","scryfallId":"f3d82fd7-6af1-4a97-9d51-486a41224b35"},{"index":46524,"token":false,"name":"Shepherd of the Cosmos","scryfallId":"ce33c84e-008c-48d8-a8e8-77cd19cc4f1f"},{"index":46527,"token":false,"name":"Gladewalker Ritualist","scryfallId":"8053b888-a680-4318-88c3-0924e596e780"},{"index":46530,"token":false,"name":"Tempt with Glory","scryfallId":"190bcef2-c819-4da7-9b8d-d14b87ab9f66"},{"index":46535,"token":false,"name":"Defend the Campus","scryfallId":"85e4e1b5-77d6-4af4-b22e-6f6b4d129f5d"},{"index":46545,"token":false,"name":"Armor of Faith","scryfallId":"fccbbc47-99c6-4ba9-95c2-992d5d2a67b2"},{"index":46554,"token":false,"name":"Winter's Chill","scryfallId":"a779aca7-ff2c-48d8-9484-6ad04b2c6bcb"},{"index":46558,"token":false,"name":"Sunscape Master","scryfallId":"ebb7203d-529d-45d2-8e03-cd342c153f38"},{"index":46566,"token":false,"name":"Crested Herdcaller","scryfallId":"44c7792e-39e4-486e-827b-b0d01cd15bc3"},{"index":46572,"token":false,"name":"Teach by Example","scryfallId":"aa7fbb9b-50a8-4d18-a667-fe965468ca16"},{"index":46583,"token":false,"name":"Didgeridoo","scryfallId":"8d2ff269-ee43-4684-84a4-ecb4aed3d960"},{"index":46588,"token":true,"name":"Angel // Demon Token (B, 5/5)","scryfallId":"4ac2b852-92b2-4daf-9d1f-f71d3b27c241"},{"index":46589,"token":false,"name":"Leonin Battlemage","scryfallId":"02c14e05-8c50-44de-8cd4-5b3a11ecdb30"},{"index":46590,"token":false,"name":"Galvanic Key","scryfallId":"934936d1-f470-47fa-ac28-344020c9fc76"},{"index":46592,"token":false,"name":"Nacatl Savage","scryfallId":"ad602fba-6a73-4fd0-aff5-802c3be3100e"},{"index":46596,"token":false,"name":"Toil to Renown","scryfallId":"d54fd436-35eb-4207-9439-de652234dd50"},{"index":46601,"token":false,"name":"Izoni, Thousand-Eyed","scryfallId":"003c6e4d-16f4-4ce8-9df2-a59e736b52cd"},{"index":46607,"token":false,"name":"Circle of Despair","scryfallId":"ef9d2c05-0d2f-4d02-aef3-e1078d78e5ff"},{"index":46610,"token":false,"name":"Crushing Disappointment","scryfallId":"7fbe8cf1-11df-4ca4-9a6b-265193c49250"},{"index":46618,"token":false,"name":"Trickery Charm","scryfallId":"32a2ee45-7f1d-40a8-82b4-ab3b705417ea"},{"index":46625,"token":false,"name":"Cry of Contrition","scryfallId":"62016f24-3f40-406b-8e29-30a6545d0fc1"},{"index":46633,"token":false,"name":"Bearscape","scryfallId":"3284b61a-bd95-4846-ad3f-903cd1158867"},{"index":46634,"token":false,"name":"Araumi of the Dead Tide","scryfallId":"48b597dd-f6eb-45da-977d-453e8c1433cc"},{"index":46640,"token":false,"name":"Helium Squirter","scryfallId":"35a9a786-8d15-4186-8030-4151bddcc0f7"},{"index":46646,"token":false,"name":"Momentum Rumbler","scryfallId":"3587f450-c1ba-4074-84bb-47978a2b6116"},{"index":46649,"token":false,"name":"Terminal Agony","scryfallId":"3ddb6d98-3a3a-4332-a64e-97aec71777a4"},{"index":46651,"token":false,"name":"Leyline of Singularity","scryfallId":"d40d7e5c-3b6d-4e42-b495-b3cd7ae0d808"},{"index":46653,"token":false,"name":"Nikara, Lair Scavenger","scryfallId":"00b9ac91-51e4-4653-ac2a-da166a894f2a"},{"index":46658,"token":false,"name":"Invoke the Firemind","scryfallId":"aac72d2c-1a5d-4f7a-9f13-c4d5602f0249"},{"index":46662,"token":false,"name":"Deploy the Gatewatch","scryfallId":"4f9abdab-5c77-4d9d-83d3-c2995f303043"},{"index":46666,"token":false,"name":"Dakmor Bat","scryfallId":"f45994db-776d-420e-9241-99bf3b71fa59"},{"index":46668,"token":false,"name":"Syr Faren, the Hengehammer","scryfallId":"9a8b1fea-3c5d-43d2-b4d2-e8938f3f7b9c"},{"index":46669,"token":false,"name":"Coast Watcher","scryfallId":"6bbbc67d-99d0-4277-a8f2-64509e59ec00"},{"index":46674,"token":false,"name":"Jasmine Boreal","scryfallId":"004af467-815a-47c0-a974-1ae49ca3a1a8"},{"index":46695,"token":false,"name":"Tethered Griffin","scryfallId":"2bed19fa-e497-48de-8459-030e60fdc9a8"},{"index":46702,"token":true,"name":"Elemental Bird Token (U, 4/4)","scryfallId":"a5582cd9-97e7-426f-a084-c05e2113ad13"},{"index":46713,"token":false,"name":"Puncture Bolt","scryfallId":"cb5a0bc1-ab01-4381-8f54-7381a2213cdf"},{"index":46714,"token":false,"name":"Bake into a Pie","scryfallId":"42a4d090-1bb7-4334-ab22-e2527391e79b"},{"index":46716,"token":false,"name":"Mana Chains","scryfallId":"77802038-0d86-4911-97ed-e6bd2ed55e23"},{"index":46720,"token":false,"name":"Feeling of Dread","scryfallId":"846a2f9e-ad4f-4666-b152-fdeab7559d86"},{"index":46724,"token":false,"name":"Hungering Yeti","scryfallId":"02f7c596-5633-41e8-adcd-d4dc6eae5c88"},{"index":46728,"token":false,"name":"Altar's Light","scryfallId":"dd037f62-7cef-4737-b575-942c5959f1ea"},{"index":46732,"token":false,"name":"Steelclaw Lance","scryfallId":"cafcf909-d726-4bc2-adf6-c12ca242f0c1"},{"index":46734,"token":false,"name":"Krosan Avenger","scryfallId":"0afd6911-32b5-410a-afb0-fd3d2996fe59"},{"index":46738,"token":false,"name":"Diplomatic Immunity","scryfallId":"fb1e610e-a4a2-460b-8e4c-13674badbce3"},{"index":46740,"token":false,"name":"Kederekt Leviathan","scryfallId":"97e04b01-ba98-4b69-976e-9ab8be3b5f7a"},{"index":46743,"token":false,"name":"Stitcher Geralf","scryfallId":"156945db-4575-48ae-b9c9-e3b341353cd7"},{"index":46744,"token":false,"name":"Plant Elemental","scryfallId":"8dbd5eeb-6571-4b78-9f4a-32d58a23a4f9"},{"index":46752,"token":false,"name":"Midnight Recovery","scryfallId":"4df40471-1118-4429-83bf-8225ea50b69f"},{"index":46763,"token":false,"name":"Hold at Bay","scryfallId":"ffeb407d-6a42-488a-9869-83da3047e45d"},{"index":46765,"token":false,"name":"Tuknir Deathlock","scryfallId":"5ab10b32-00b6-40b7-ad5e-ff2fd35951ef"},{"index":46768,"token":false,"name":"Ill-Gotten Gains","scryfallId":"cf569836-5ee7-4e5c-9ab7-f1004891ee15"},{"index":46769,"token":false,"name":"Pianna, Nomad Captain","scryfallId":"f1a4a514-a392-4283-9b66-4d24c205d5b3"},{"index":46777,"token":false,"name":"Thriving Moor","scryfallId":"18756fe5-70f0-48d9-a4f1-ea78f77d2084"},{"index":46781,"token":false,"name":"Dauntless Survivor","scryfallId":"52b1b4a2-52a7-4fcd-aa96-f7d9e459657b"},{"index":46788,"token":false,"name":"Whip of Erebos","scryfallId":"9e5ec47c-47a2-4eda-b81a-4a07f04e5989"},{"index":46792,"token":false,"name":"Equestrian Skill","scryfallId":"f9af14d1-a304-4744-9d6f-9ff5fcd92ad3"},{"index":46795,"token":false,"name":"Spectral Rider","scryfallId":"b47e4e56-8bde-480d-b59c-17a017665b19"},{"index":46796,"token":false,"name":"Fatigue","scryfallId":"660fb109-dd65-4410-99b9-a2a14f8ea202"},{"index":46797,"token":false,"name":"Shell of the Last Kappa","scryfallId":"4d80f3e7-c3f0-462f-8ae9-8b27a7c15fcd"},{"index":46798,"token":false,"name":"Discordant Spirit","scryfallId":"be67b950-dfe3-4159-aa53-63df25d2a926"},{"index":46809,"token":false,"name":"Court Cleric","scryfallId":"dc2e1a93-4b5c-4f89-9e11-1693dee64b63"},{"index":46817,"token":false,"name":"Kitsune Loreweaver","scryfallId":"c11d4490-fe4f-4526-befd-f4c9c22c76a6"},{"index":46819,"token":false,"name":"Ensnare","scryfallId":"055b344a-4eb1-4579-ac50-973b18e12fad"},{"index":46827,"token":false,"name":"Serpent of Yawning Depths","scryfallId":"a4ac18ae-0d1e-43f5-9cc9-722fa6e36fe5"},{"index":46828,"token":false,"name":"Field of Dreams","scryfallId":"d3caab9b-5f14-4207-a57d-55e87920479b"},{"index":46831,"token":false,"name":"Magus of the Scroll","scryfallId":"6060cada-52bf-4ef2-8a26-8ba04dded458"},{"index":46843,"token":false,"name":"Gliding Licid","scryfallId":"0148f3ca-4dba-4408-86d0-1190c387ee69"},{"index":46847,"token":false,"name":"Blessing of Leeches","scryfallId":"de0ba1cf-d913-4285-9d8b-38acf78cc45e"},{"index":46849,"token":false,"name":"Limits of Solidarity","scryfallId":"95cb6a18-1222-4e56-8466-0f7bd634ef3d"},{"index":46851,"token":true,"name":"Angel Warrior Token (W, 4/4)","scryfallId":"3bd871a3-3802-4bdc-8033-3ecfd01c0449"},{"index":46854,"token":false,"name":"Firecat Blitz","scryfallId":"d4e1d485-02d5-4a07-bcc6-d2a8d95763e8"},{"index":46859,"token":false,"name":"Spitting Spider","scryfallId":"bfeeb515-7d3d-4678-a480-32485b197afb"},{"index":46860,"token":false,"name":"Leonin Sun Standard","scryfallId":"395f719d-1f55-4f1a-a9fb-a178cd589f70"},{"index":46869,"token":false,"name":"Coerced Confession","scryfallId":"d76102f1-b05f-472b-81cf-eae424c55638"},{"index":46875,"token":false,"name":"Spinehorn Minotaur","scryfallId":"86b9479d-7b6a-40c8-94ea-fdf0ec980b42"},{"index":46886,"token":false,"name":"Urban Utopia","scryfallId":"45d7ab0e-db37-4051-86dd-3ab09c047a2b"},{"index":46897,"token":false,"name":"Akoum Boulderfoot","scryfallId":"88e8f7b6-1214-447b-8665-ff3c85845564"},{"index":46901,"token":false,"name":"Break Ties","scryfallId":"723ec2ef-aa82-449d-88b0-405d06454fc2"},{"index":46904,"token":false,"name":"Hero of Bladehold","scryfallId":"8829efa0-498a-43ca-91aa-f9caeeafe298"},{"index":46906,"token":false,"name":"Bond of Passion","scryfallId":"ae644e9d-9bc4-4ccd-aef4-3d0559948aa6"},{"index":46908,"token":false,"name":"Biovisionary","scryfallId":"2000b4e8-7887-454e-9d52-211516613dd0"},{"index":46911,"token":false,"name":"Stormfist Crusader","scryfallId":"f38fb8e3-7155-468d-8e47-6d9c60490ac4"},{"index":46913,"token":false,"name":"Lucky Clover","scryfallId":"4b5d23a6-3a23-4169-aea1-f10bf5153180"},{"index":46914,"token":false,"name":"Brood Butcher","scryfallId":"2f60fdd6-bc18-4c04-83d8-c204f2b35ff1"},{"index":46915,"token":false,"name":"Warpath Ghoul","scryfallId":"94785274-fa79-47cc-9896-0f5f695abb21"},{"index":46916,"token":false,"name":"Murasa Behemoth","scryfallId":"480ddde1-81d3-4939-b232-cb1ced6cfc4d"},{"index":46921,"token":false,"name":"Crumbling Ashes","scryfallId":"3e73ac3c-bd5a-4993-be65-76396b7d38ad"},{"index":46926,"token":false,"name":"Trench Behemoth","scryfallId":"909dc123-8234-4e81-bb7b-77404d94a87c"},{"index":46928,"token":false,"name":"Paragon of Eternal Wilds","scryfallId":"97c3fcca-480f-4acf-b74f-0f37b46fa799"},{"index":46929,"token":false,"name":"Rejuvenate","scryfallId":"fe3709a3-7a1b-4644-b1d5-e1ffef549f94"},{"index":46930,"token":false,"name":"Sprouting Vines","scryfallId":"3a3246a6-b604-4f9f-adb9-3692e0fa8638"},{"index":46937,"token":true,"name":"Human // Wolf Token (W, 1/1)","scryfallId":"3a98c51f-c55c-4bd9-853b-65b8bad5a29f"},{"index":46938,"token":false,"name":"String of Disappearances","scryfallId":"99ef4f41-211c-4302-b112-1d85ab33952f"},{"index":46940,"token":false,"name":"Toll of the Invasion","scryfallId":"4471c2a5-aa2c-47e2-8238-1eb366c8adc9"},{"index":46943,"token":false,"name":"Woodvine Elemental","scryfallId":"8acdb147-2339-4c55-b4f6-6a79679f2040"},{"index":46947,"token":false,"name":"Fearless Pup","scryfallId":"0eba2250-0e9b-46fd-a4b5-23f30329e063"},{"index":46951,"token":false,"name":"Gearsmith Guardian","scryfallId":"1d532b01-8bf7-4a27-a438-db03bcd00694"},{"index":46954,"token":false,"name":"Lady Evangela","scryfallId":"a01adcbd-0ebd-4f18-9942-4638fa0de358"},{"index":46955,"token":false,"name":"Battering Wurm","scryfallId":"5a0fb683-2e9b-465c-9fb5-2eb334c2739a"},{"index":46966,"token":false,"name":"Frillscare Mentor","scryfallId":"24c7d034-6403-41e2-9e44-4d58ef54cf10"},{"index":46974,"token":false,"name":"Lost in the Woods","scryfallId":"5865603c-0a5e-45c3-84e3-2dc3b4cf0cf7"},{"index":46976,"token":false,"name":"Festive Funeral","scryfallId":"90a90af0-eb40-40da-bf4b-f0af687c6430"},{"index":46994,"token":false,"name":"Dwarven Patrol","scryfallId":"03c08df5-f5e7-4498-ac80-25ccbe304b26"},{"index":47000,"token":false,"name":"Chronatog","scryfallId":"05ada02f-04e9-4269-b04a-97a7eaac2c46"},{"index":47001,"token":false,"name":"Strength of Isolation","scryfallId":"7676e6fb-030d-40aa-a914-27ab6d7d5fc5"},{"index":47005,"token":false,"name":"Cleaving Sliver","scryfallId":"51b657f0-6636-4d8a-9176-81027816e0ec"},{"index":47006,"token":false,"name":"Ingenious Skaab","scryfallId":"19d6ed0b-40ba-407d-94de-05a705e79b95"},{"index":47009,"token":false,"name":"Zenith Seeker","scryfallId":"47b711b5-aeec-47c4-a718-6bf43e561944"},{"index":47013,"token":false,"name":"Shadowstorm Vizier","scryfallId":"5110266b-8fb7-446a-8059-f6bf358bd8aa"},{"index":47018,"token":false,"name":"Recross the Paths","scryfallId":"0bfe1d8e-ae3c-4144-a44b-e13ab33da95c"},{"index":47024,"token":true,"name":"Dave Humpherys Decklist","scryfallId":"4a4158c7-5f24-4b56-bb9e-ddc3e459b555"},{"index":47029,"token":false,"name":"Cryptolith Rite","scryfallId":"bf499af7-663a-4991-8907-ccbcfcff1682"},{"index":47034,"token":false,"name":"Relentless Raptor","scryfallId":"2d0727ba-4180-4908-93be-a8abf29a8958"},{"index":47037,"token":false,"name":"Keening Apparition","scryfallId":"657b242c-46cb-44d1-86fd-fb2485144a5b"},{"index":47040,"token":false,"name":"Azorius Aethermage","scryfallId":"6b640ff8-8baa-4069-b5a9-8a4fb22a056e"},{"index":47042,"token":false,"name":"Cleanfall","scryfallId":"9897707f-9669-4d44-8607-cba569da73e0"},{"index":47044,"token":false,"name":"Tormented Pariah // Rampaging Werewolf","scryfallId":"6151cae7-92a4-4891-a952-21def412d3e4"},{"index":47050,"token":false,"name":"Vessel of Paramnesia","scryfallId":"b4596140-1113-4349-aabe-4e828ea574e8"},{"index":47054,"token":false,"name":"Haunting Apparition","scryfallId":"8ce9c58f-6470-4e0f-8f6b-457fbaac7451"},{"index":47059,"token":false,"name":"Great-Horn Krushok","scryfallId":"422a5e17-7682-4d41-9a4a-c757056de344"},{"index":47060,"token":false,"name":"Fallen Ferromancer","scryfallId":"7b200986-f553-4156-8f5e-37678db09687"},{"index":47064,"token":false,"name":"Hearthcage Giant","scryfallId":"fb0d4d3f-d3ad-4c70-b9af-9bfcdd9efd1f"},{"index":47065,"token":false,"name":"Reach of Shadows","scryfallId":"bbf9a803-473a-4c38-b352-d47c4fd93d5e"},{"index":47066,"token":false,"name":"Tunnel Ignus","scryfallId":"c3016e6b-32b2-4fa7-91c0-ec8fbe345760"},{"index":47069,"token":false,"name":"Ob Nixilis, the Fallen","scryfallId":"e5769888-78e0-4d06-b6b6-b4602f7cd462"},{"index":47079,"token":false,"name":"Martyr of Dusk","scryfallId":"04134be2-5e40-4732-832c-f616009eceff"},{"index":47085,"token":false,"name":"Turf Wound","scryfallId":"91392e9f-f96a-4ac5-b1f1-c73540cf249e"},{"index":47089,"token":false,"name":"Beastcaller Savant","scryfallId":"cca9f5da-986c-43ab-a2ec-efb8b098c17c"},{"index":47091,"token":false,"name":"Faerie Swarm","scryfallId":"90598bb2-d96c-4f74-864b-1947b7d39e58"},{"index":47095,"token":false,"name":"Needle Drop","scryfallId":"d3f89bcf-46f8-4598-a949-7f10134606aa"},{"index":47096,"token":false,"name":"Harvestguard Alseids","scryfallId":"3b9256e2-b59c-4997-91c1-4c565746d53d"},{"index":47099,"token":false,"name":"Spiteful Blow","scryfallId":"fafaa798-e534-4cd0-b369-9e767a02fe3d"},{"index":47105,"token":false,"name":"Ramroller","scryfallId":"07f7ba4d-26bb-4631-a135-f27d94f376d1"},{"index":47106,"token":false,"name":"Stumpsquall Hydra","scryfallId":"8fe8096b-332a-4832-b957-7a35bb350e4e"},{"index":47119,"token":false,"name":"Zurgo Bellstriker","scryfallId":"fdf3f74c-1d3c-423c-8a21-ebf8193c95a0"},{"index":47126,"token":false,"name":"Qarsi High Priest","scryfallId":"58c1bdbc-2bf4-4036-bf83-669c27458c6e"},{"index":47130,"token":false,"name":"Arcbound Hybrid","scryfallId":"a2f33f9d-dffd-4742-92c6-be7fe6463dca"},{"index":47135,"token":false,"name":"Ghost-Lit Warder","scryfallId":"042b7666-8c58-48e5-8ec3-754611700e75"},{"index":47140,"token":false,"name":"Orcish Settlers","scryfallId":"98af8b79-663c-48cc-a0ea-a3b880e75c41"},{"index":47153,"token":false,"name":"Oath of Mages","scryfallId":"ed8708d2-2c73-4da5-b6ff-41c083b59caa"},{"index":47173,"token":false,"name":"Merfolk Raiders","scryfallId":"d0f34166-8946-4bcc-84af-3540c42ac7f7"},{"index":47174,"token":false,"name":"Galerider Sliver","scryfallId":"425f5d1b-9989-4fd1-88e2-6c3108aefa0b"},{"index":47175,"token":false,"name":"Insatiable Souleater","scryfallId":"171d5213-5bb4-4f5b-9ddd-e2a7ac092ec6"},{"index":47180,"token":false,"name":"Reverberation","scryfallId":"a3d1f470-058d-41b7-acaf-4f68431de9ed"},{"index":47195,"token":false,"name":"Yomiji, Who Bars the Way","scryfallId":"f611af49-3c59-4365-a398-93f7e05ff0d0"},{"index":47196,"token":false,"name":"Goldmire Bridge","scryfallId":"dbe2a1fa-196f-497f-a15f-0b3b04da9cbb"},{"index":47202,"token":false,"name":"Ouphe Vandals","scryfallId":"896e08f8-7608-4137-9a58-f6eda8f84313"},{"index":47209,"token":false,"name":"Bladed Sentinel","scryfallId":"69959c54-1350-4c64-8e5a-fc8447bb979c"},{"index":47221,"token":false,"name":"Yannik, Scavenging Sentinel","scryfallId":"11c0e89b-ab29-4739-a88e-1e7966d87d25"},{"index":47226,"token":false,"name":"Curse of Bounty","scryfallId":"f38fd4a3-f098-4dfc-80a3-251e25324ce7"},{"index":47234,"token":false,"name":"Soulsworn Spirit","scryfallId":"32602ed9-c0a7-4498-a333-235eaae628df"},{"index":47235,"token":false,"name":"Knights' Charge","scryfallId":"6b86f7db-ae1d-49fe-a9c5-488bbf3afac7"},{"index":47240,"token":false,"name":"Aether Gust","scryfallId":"783da808-6698-4e55-9fac-430a6effe2b1"},{"index":47244,"token":false,"name":"Snare Tactician","scryfallId":"5f640e0c-298d-4a5f-94d0-d839cf06ca86"},{"index":47245,"token":false,"name":"Gustcloak Cavalier","scryfallId":"c36a5462-3a21-4d64-af92-b541b425cdf5"},{"index":47246,"token":false,"name":"Erstwhile Trooper","scryfallId":"351ee4ba-882d-48c1-837d-e9eccc5bc50d"},{"index":47247,"token":false,"name":"Sinister Concoction","scryfallId":"815ca911-ccc1-4466-8d12-054b8d241992"},{"index":47249,"token":false,"name":"Ajani's Influence","scryfallId":"d38ad178-35a5-44ad-b80a-d746f3e6a45c"},{"index":47252,"token":false,"name":"Call to Glory","scryfallId":"758fcfe4-0347-4ac6-8e29-f945cb1d7295"},{"index":47253,"token":false,"name":"Animist's Awakening","scryfallId":"ff681dc2-bc62-4934-b936-49af1da4af6c"},{"index":47262,"token":false,"name":"Morselhoarder","scryfallId":"589f477e-fd69-4410-b9ba-1d45b25fec31"},{"index":47266,"token":false,"name":"Angel of Jubilation","scryfallId":"16c5dfed-4dee-4e48-a445-89f03d7794e6"},{"index":47267,"token":false,"name":"Cloistered Youth // Unholy Fiend","scryfallId":"f8b8f0b4-71e1-4822-99a1-b1b3c2f10cb2"},{"index":47268,"token":false,"name":"Cyclops Gladiator","scryfallId":"b6f2eddc-b296-40d0-bf59-44899f1570e8"},{"index":47272,"token":false,"name":"Knight of the Mists","scryfallId":"97a57658-46cf-4bb0-a714-ae3ab7b326ef"},{"index":47273,"token":false,"name":"Dimir Cluestone","scryfallId":"0d8ac24f-3309-453a-b2d6-6363df9a1ddd"},{"index":47278,"token":false,"name":"Shadowfeed","scryfallId":"19ccd8c7-7472-47df-9d3e-1b5fb1431118"},{"index":47279,"token":false,"name":"Molten Psyche","scryfallId":"57e2382d-1f27-40d1-b809-c188c19ebc72"},{"index":47283,"token":false,"name":"Wall of Granite","scryfallId":"70c5ac71-bf45-4b99-8184-36ce88dd728a"},{"index":47284,"token":true,"name":"Paul McCabe Decklist","scryfallId":"c2c46b99-4056-428a-ae35-8ba018bb034f"},{"index":47285,"token":false,"name":"Trigon of Thought","scryfallId":"f8da37ba-52e3-417e-8d7b-6c3e060552a4"},{"index":47288,"token":false,"name":"Echo Circlet","scryfallId":"49e661c6-bc3e-45b4-ae1c-5002e381faf3"},{"index":47290,"token":false,"name":"Liberated Dwarf","scryfallId":"e2c07842-9b70-40b1-9b97-9a9279b7ebc4"},{"index":47295,"token":false,"name":"Razaketh's Rite","scryfallId":"dd36987a-48c3-477b-b859-0268e84b7e7b"},{"index":47298,"token":false,"name":"Creepy Doll","scryfallId":"762a598b-8753-47ec-9dd6-2c3d8882fda6"},{"index":47310,"token":false,"name":"Hovermyr","scryfallId":"95e4e445-8333-4cb4-b4fb-80957fae0b97"},{"index":47312,"token":false,"name":"Gingerbrute","scryfallId":"c1195ec5-979b-4c4a-9c04-62bb53c2b011"},{"index":47314,"token":false,"name":"Sure-Footed Infiltrator","scryfallId":"0505053c-8a9c-43ed-b44a-b52c56ba4f77"},{"index":47316,"token":false,"name":"Silumgar Sorcerer","scryfallId":"6a914304-e774-49fd-9ac7-09e36989b1d5"},{"index":47321,"token":false,"name":"Warrior's Oath","scryfallId":"d582861a-ca6e-4b74-adf0-3eb588ea5ed2"},{"index":47343,"token":false,"name":"Kheru Lich Lord","scryfallId":"84434d6d-7649-4562-8427-e9de5af43257"},{"index":47351,"token":false,"name":"Genesis Storm","scryfallId":"066578ed-ffaf-473d-87b8-e614035748b6"},{"index":47357,"token":false,"name":"Flaring Pain","scryfallId":"eeb5c96a-1d16-459d-9968-ced9a8f1c520"},{"index":47363,"token":false,"name":"Succumb to Temptation","scryfallId":"2974e18b-be17-4059-9f29-7afe1d1a51eb"},{"index":47367,"token":false,"name":"Interplanar Beacon","scryfallId":"132d8e2a-e1dd-4867-8e8c-e48b9450b350"},{"index":47368,"token":false,"name":"Lightning Dart","scryfallId":"54d05157-d154-4203-bf3e-add110cb1cee"},{"index":47376,"token":false,"name":"Ogre's Cleaver","scryfallId":"ec319380-bede-49e8-9d0c-473688033601"},{"index":47378,"token":false,"name":"Dense Canopy","scryfallId":"9d1480d4-51f8-4233-874c-94502726fe0d"},{"index":47383,"token":false,"name":"Myr Quadropod","scryfallId":"5576fe4d-cf12-460b-af15-996baeca5065"},{"index":47393,"token":false,"name":"Nightsoil Kami","scryfallId":"5902f863-171e-4bb2-9d48-2c679d41f1a9"},{"index":47398,"token":false,"name":"Into the Maw of Hell","scryfallId":"5d188d9b-7a12-4eaf-855b-af4f0204dc5a"},{"index":47406,"token":false,"name":"Arcus Acolyte","scryfallId":"d8546eaa-1e64-4e70-b6a5-85892bab8c47"},{"index":47415,"token":false,"name":"Flay","scryfallId":"a6fe155f-bfb2-49d8-83f0-ab1047a961d1"},{"index":47431,"token":false,"name":"Tourach's Chant","scryfallId":"06883fd2-eccd-47c6-8c34-10d95e923685"},{"index":47441,"token":false,"name":"Dead Drop","scryfallId":"ff25a19a-8f98-47ef-847c-ba526c82b290"},{"index":47442,"token":false,"name":"Thermal Blast","scryfallId":"623cc141-0f75-4e67-b852-6c144d98e619"},{"index":47444,"token":false,"name":"Hanweir Battlements // Hanweir, the Writhing Township","scryfallId":"a32261f2-164f-4433-bc4c-b5ac591e6a59"},{"index":47452,"token":false,"name":"Orbweaver Kumo","scryfallId":"3d8f0459-a839-4820-8f99-58da5851ff36"},{"index":47455,"token":false,"name":"Schismotivate","scryfallId":"98510af3-a884-417a-8cd9-991890d42919"},{"index":47456,"token":false,"name":"Blood-Cursed Knight","scryfallId":"644bb558-113e-4e49-a395-7e0036c3419c"},{"index":47460,"token":false,"name":"Kor Line-Slinger","scryfallId":"068943d2-c456-42a3-8088-3e4923bf6d74"},{"index":47461,"token":false,"name":"Captivating Unicorn","scryfallId":"13893599-0b87-4fc0-863d-f3e0ae51cc31"},{"index":47471,"token":false,"name":"Haazda Marshal","scryfallId":"5c561d89-b02d-4f1a-b49a-cdf2def3404d"},{"index":47473,"token":false,"name":"Geist Snatch","scryfallId":"b6dac5db-ef96-4bd5-aabc-e5ae2b95c8c3"},{"index":47482,"token":false,"name":"Stallion of Ashmouth","scryfallId":"40e29bfe-0fa9-491d-9752-ee12077f6cb4"},{"index":47484,"token":false,"name":"Wild-Field Scarecrow","scryfallId":"1285b444-1668-4a3d-9fcd-8ce4e95c6d2f"},{"index":47487,"token":false,"name":"Krark-Clan Shaman","scryfallId":"975f9ea8-af2c-456f-acd0-ffa9ea0d98c1"},{"index":47488,"token":false,"name":"Livio, Oathsworn Sentinel","scryfallId":"02bce846-8049-4d5c-b0ad-8abd484e5a27"},{"index":47490,"token":false,"name":"Sky Swallower","scryfallId":"05189964-5ad0-48b7-a3af-67c7f46fe89e"},{"index":47492,"token":false,"name":"Battletide Alchemist","scryfallId":"9a5357e0-ff69-4bb9-9a02-b0372e0ea5e5"},{"index":47493,"token":false,"name":"Arcbound Slasher","scryfallId":"dcafff1a-e220-40ff-8c00-de6037219bc6"},{"index":47522,"token":false,"name":"Shivan Fire","scryfallId":"21b9d339-99ed-4923-8f56-be37f29a0bfa"},{"index":47528,"token":false,"name":"Unholy Grotto","scryfallId":"52f464a9-586c-4cf3-894b-b407c9f4dcb8"},{"index":47530,"token":false,"name":"Zombie Musher","scryfallId":"51cf9ade-1c3d-4104-98fa-3c6a8cccc088"},{"index":47534,"token":false,"name":"Fatestitcher","scryfallId":"7e4becff-8280-4e29-a370-bf82fb6734d5"},{"index":47536,"token":false,"name":"Memory's Journey","scryfallId":"265aaa73-1a1e-4282-a860-f7c422f21db3"},{"index":47541,"token":false,"name":"Skewer the Critics","scryfallId":"97295660-6bea-46ae-9a3b-0fc6abba407f"},{"index":47543,"token":false,"name":"Simic Initiate","scryfallId":"6602c592-3cde-4e73-919c-1d3f3df22092"},{"index":47548,"token":false,"name":"Young Wei Recruits","scryfallId":"11431c4c-b0bb-4747-a34a-4a90238ec9c6"},{"index":47554,"token":false,"name":"Ramosian Lieutenant","scryfallId":"debe840a-ebc9-43c4-9bf7-7eb292b65bf9"},{"index":47565,"token":false,"name":"Drifting Djinn","scryfallId":"971d0eda-91b8-48f2-a988-016bcc7ab35e"},{"index":47566,"token":false,"name":"Psionic Gift","scryfallId":"862fc18f-90d2-430d-aff2-47c1483dee9d"},{"index":47567,"token":false,"name":"Kitsune Blademaster","scryfallId":"fb9d108d-ee19-4b1d-9d4b-b4c4d9b8ad0d"},{"index":47568,"token":false,"name":"Brineborn Cutthroat","scryfallId":"0857765f-afd7-418a-a93b-c0bd1b1f037e"},{"index":47571,"token":false,"name":"Slash Panther","scryfallId":"2f510946-34de-4c12-8998-f61887d1a0e1"},{"index":47578,"token":false,"name":"Voice of Grace","scryfallId":"72e8eb3b-3ebf-426c-8dc8-138ec9b7c671"},{"index":47580,"token":false,"name":"Clear the Stage","scryfallId":"0ac65975-6ff5-4863-b7b7-d7dbea213b50"},{"index":47592,"token":false,"name":"Thistledown Duo","scryfallId":"d57ba0ce-0390-42fd-9473-2436fac53631"},{"index":47594,"token":false,"name":"Codespell Cleric","scryfallId":"1316a74e-da55-4668-87f2-98389a90a2a4"},{"index":47596,"token":false,"name":"Stonewright","scryfallId":"9564d79d-5f4d-4192-94ee-5e5998011266"},{"index":47598,"token":false,"name":"Coral Reef","scryfallId":"42fe2280-a996-4072-b5bf-f4fd56607a51"},{"index":47599,"token":false,"name":"Baku Altar","scryfallId":"81e1dbb8-3df8-4e7e-b74b-baab7d6f97c1"},{"index":47603,"token":false,"name":"Kashi-Tribe Reaver","scryfallId":"3d417f90-10e9-4c41-ac3b-1a861147d69e"},{"index":47617,"token":false,"name":"Plague Fiend","scryfallId":"11f077f5-c0b0-4e94-8599-e2122bc87238"},{"index":47619,"token":false,"name":"Thwart the Enemy","scryfallId":"a7101f35-d8c9-4320-bffc-8bb25000d103"},{"index":47620,"token":false,"name":"Valkyrie Harbinger","scryfallId":"edab83a9-35b5-4312-b8ee-1c042c02aa31"},{"index":47622,"token":false,"name":"Revolutionist","scryfallId":"bb8f3008-a3ba-4f73-afa6-ad81074b3196"},{"index":47638,"token":false,"name":"Desecrated Earth","scryfallId":"3f05e478-8712-41de-94af-ecb90432e562"},{"index":47640,"token":false,"name":"Golgari Findbroker","scryfallId":"e12bd0e5-db96-4340-9b04-6855fd0fd8b9"},{"index":47644,"token":false,"name":"Brimstone Mage","scryfallId":"1f65ebef-e159-4698-8852-650b7b6a08d3"},{"index":47657,"token":false,"name":"Transmogrifying Licid","scryfallId":"1a115563-81da-42f6-95c4-22ae7bb51a0f"},{"index":47667,"token":false,"name":"Rushed Rebirth","scryfallId":"27872add-2335-443a-8480-757b4439055f"},{"index":47679,"token":false,"name":"Crashing Centaur","scryfallId":"e1f3a32a-bfd2-4c31-a349-3e62a84c20e1"},{"index":47682,"token":false,"name":"Howlpack Wolf","scryfallId":"e7379689-8e4f-4c23-9276-3510f70ba7ff"},{"index":47685,"token":false,"name":"Dream Thief","scryfallId":"811026ed-1bae-4464-bdfe-dcec76259152"},{"index":47687,"token":false,"name":"Vraska's Finisher","scryfallId":"f89fa379-7fae-4fbf-8e31-0ef3645353c5"},{"index":47689,"token":false,"name":"Weaselback Redcap","scryfallId":"33a78207-fd76-4112-a257-54a25da6f818"},{"index":47690,"token":false,"name":"Gelid Shackles","scryfallId":"d372bb70-2d2a-4c44-8f69-4abff8ba7c2a"},{"index":47699,"token":false,"name":"Gustcloak Runner","scryfallId":"eb227f65-9189-41ed-94a0-2aa21cad26f5"},{"index":47703,"token":false,"name":"Prince of Thralls","scryfallId":"56d6e8a2-d1b0-4aae-95f5-6ecc5718d454"},{"index":47711,"token":false,"name":"Smogsteed Rider","scryfallId":"04d2b2bf-92bc-4362-b232-8a403b9a7ade"},{"index":47720,"token":false,"name":"Aegis of the Meek","scryfallId":"5d272051-f442-4f6e-8c64-df28b398d2e8"},{"index":47729,"token":true,"name":"Wasp Token (Colorless, 1/1)","scryfallId":"c75b81b5-5c84-45d4-832a-20c038372bc6"},{"index":47733,"token":false,"name":"Healer of the Glade","scryfallId":"cbe262f2-e35b-4c85-938d-3e9e9c764c1b"},{"index":47735,"token":false,"name":"Strongarm Monk","scryfallId":"0f5f5ead-b9e0-44c0-893f-0e3ae01933d3"},{"index":47742,"token":false,"name":"Giant Albatross","scryfallId":"bce05870-74d3-43f1-92d0-dc1744c0138d"},{"index":47743,"token":false,"name":"Squall Drifter","scryfallId":"b3ecb728-4b54-47d0-bbef-d39e5f7d172f"},{"index":47747,"token":false,"name":"Ana Battlemage","scryfallId":"dafbeae0-17e3-4a29-bd02-9f45b549b990"},{"index":47751,"token":false,"name":"Hired Blade","scryfallId":"7624c9aa-2f47-4fcc-a9fe-cc843e8de053"},{"index":47756,"token":false,"name":"Sorin, Solemn Visitor","scryfallId":"da1a9643-34d6-4b4b-b896-2d4626eca40a"},{"index":47759,"token":false,"name":"Biblioplex Assistant","scryfallId":"d74e1117-0196-4268-be97-a1e81b5dc90e"},{"index":47761,"token":false,"name":"Rage Thrower","scryfallId":"f16db004-3e0c-491b-b8b6-0ae046d11761"},{"index":47763,"token":false,"name":"Secure the Wastes","scryfallId":"915d2f5f-b228-4190-ade9-52e2a8056847"},{"index":47767,"token":false,"name":"Acidic Dagger","scryfallId":"6dfdea79-2a7c-489d-8466-e6090c2a0919"},{"index":47770,"token":false,"name":"Boon of Emrakul","scryfallId":"24bb97c6-d2ff-459f-986e-73e30534d865"},{"index":47773,"token":false,"name":"Devouring Greed","scryfallId":"4a72347d-91cd-45a8-a026-a655e5507322"},{"index":47781,"token":false,"name":"Whirlpool Drake","scryfallId":"6e866093-89a3-458d-8ebc-de805ef7885e"},{"index":47787,"token":false,"name":"Elite Arrester","scryfallId":"070f0a21-8e06-46ec-9d84-c65067b23893"},{"index":47789,"token":false,"name":"Drunau Corpse Trawler","scryfallId":"1997e6a0-9e66-486d-921d-d64137c3221d"},{"index":47801,"token":false,"name":"Sentinel's Eyes","scryfallId":"32adc118-b81e-48c2-b7ef-b62e8c3308d6"},{"index":47803,"token":false,"name":"Valiant Changeling","scryfallId":"ad9fadff-a506-4546-b994-71e9e971b44e"},{"index":47805,"token":false,"name":"Rune Snag","scryfallId":"45b6cadf-1974-47c8-98d8-ba413486c3b5"},{"index":47807,"token":false,"name":"Splendor Mare","scryfallId":"535ccc75-b24e-4071-b6a0-fc5267a454e3"},{"index":47810,"token":false,"name":"Esper Sojourners","scryfallId":"896d502a-d9c3-4101-92af-a8c9d945f47b"},{"index":47811,"token":false,"name":"Reward the Faithful","scryfallId":"df6e8844-3736-4fb1-bedb-6a6bfa6ccdc8"},{"index":47812,"token":false,"name":"Trusted Advisor","scryfallId":"ee63cba4-ab12-4adb-8463-d42edbf5794d"},{"index":47817,"token":false,"name":"Jund Hackblade","scryfallId":"61e3b73a-598b-4854-b811-2fd40fbce2d0"},{"index":47818,"token":false,"name":"Sentinel's Mark","scryfallId":"e6f4f661-ee4b-4fa5-99c4-106731d117ce"},{"index":47819,"token":false,"name":"Bishop's Soldier","scryfallId":"d954677c-2de6-440a-90d0-bab2e0c8b4af"},{"index":47828,"token":false,"name":"Juri, Master of the Revue","scryfallId":"aec6b2b7-625a-451d-bc0b-4456f5bf2719"},{"index":47829,"token":false,"name":"Skullmead Cauldron","scryfallId":"1d8567c5-d068-42bb-a593-3849e65e29c0"},{"index":47830,"token":false,"name":"Updraft","scryfallId":"7b4c1316-d6df-4bc4-9bfe-0458ff7c2908"},{"index":47834,"token":false,"name":"Celestial Convergence","scryfallId":"e8e5c9ca-b453-488b-8702-fc74907a8335"},{"index":47838,"token":false,"name":"Wingbeat Warrior","scryfallId":"cd58d164-861d-4c80-ad2f-6283ed82faa1"},{"index":47841,"token":false,"name":"Krovikan Elementalist","scryfallId":"bbedca18-a074-4441-b0a9-7b14fdb07412"},{"index":47854,"token":false,"name":"Jeska, Warrior Adept","scryfallId":"1cf96a59-8b7d-4a5b-adfd-17eeedd95db5"},{"index":47855,"token":false,"name":"Glimpse the Sun God","scryfallId":"f241e5f7-3168-4bd2-b586-185aad3ae9d9"},{"index":47860,"token":false,"name":"Tracker's Instincts","scryfallId":"59960387-3adf-4b9a-b0e6-c441579f7388"},{"index":47865,"token":false,"name":"Ramosian Sky Marshal","scryfallId":"16638976-8a78-4233-8ebc-42ea9bb49e0a"},{"index":47867,"token":false,"name":"Utvara Scalper","scryfallId":"0e0a5aa2-f33a-4976-88b1-f424243016da"},{"index":47868,"token":false,"name":"Tunneling Geopede","scryfallId":"d4071152-5e64-4133-88a2-8fa5cb0eeb6c"},{"index":47871,"token":false,"name":"Rapid Fire","scryfallId":"e26e7c9c-e6de-47f4-8394-7e853408f84c"},{"index":47874,"token":false,"name":"Song of the Worldsoul","scryfallId":"bb73ec0d-f582-4f74-9b5c-180fe3aedcf6"},{"index":47876,"token":false,"name":"Valkyrie's Sword","scryfallId":"97873c66-6bff-4d79-850c-1e2663098ef4"},{"index":47879,"token":false,"name":"One With the Wind","scryfallId":"2c00f8bf-0088-44ad-b40b-26a2951a2428"},{"index":47882,"token":false,"name":"Possessed Nomad","scryfallId":"5d9dfae5-63f6-401a-9dec-afe838190824"},{"index":47893,"token":false,"name":"Rushwood Grove","scryfallId":"c315c72c-3e2f-4aff-b7d7-2f709ccec332"},{"index":47898,"token":false,"name":"Overgrown Arch","scryfallId":"a71dddf5-8f72-4018-9cc8-5f63a17f1ee5"},{"index":47909,"token":false,"name":"Furious Rise","scryfallId":"2ae12125-73a3-488b-98b8-9f982addac56"},{"index":47918,"token":false,"name":"Pearlspear Courier","scryfallId":"a1ea7219-6ab6-471a-afe7-d7da1df434c7"},{"index":47919,"token":false,"name":"Loamdragger Giant","scryfallId":"0a27bbe4-5341-4b2b-9ae8-eb56585a9c3a"},{"index":47920,"token":false,"name":"Nim Replica","scryfallId":"d11a56e7-30a4-44da-a58b-336f4c0c4882"},{"index":47937,"token":false,"name":"Marchesa's Emissary","scryfallId":"567a2444-30c4-49aa-a1f4-b5f4fb98d6fa"},{"index":47941,"token":false,"name":"Saprazzan Legate","scryfallId":"db9adf84-ee7e-472b-bd96-9abf853afa83"},{"index":47943,"token":false,"name":"Voyager Drake","scryfallId":"6f6fb960-58cb-42db-975f-fd9329e852fd"},{"index":47944,"token":false,"name":"Barbed Spike","scryfallId":"c75c8631-e630-402b-a559-f1b1aa49763c"},{"index":47957,"token":false,"name":"Thermokarst","scryfallId":"74e907ed-76f7-476c-b128-bb6bfd892e06"},{"index":47960,"token":false,"name":"Maraleaf Rider","scryfallId":"1b2b198d-493c-4d6c-bfb6-e842728522f6"},{"index":47967,"token":false,"name":"Equilibrium","scryfallId":"460b2ec6-0180-4214-acca-c9eed778ef50"},{"index":47968,"token":true,"name":"Pirate Token (R, 1/1)","scryfallId":"da3002d9-7754-4c7f-a051-382cd7a86e80"},{"index":47981,"token":false,"name":"Defiant Stand","scryfallId":"9cc37fd2-5c34-4522-8113-e6dd2181550b"},{"index":47986,"token":false,"name":"Woodland Druid","scryfallId":"34e501e6-38da-44ad-abe2-53ea7f0eb4ae"},{"index":47989,"token":false,"name":"Obsessive Skinner","scryfallId":"b2cc3b9d-4b32-4b2e-9027-876210ccf18e"},{"index":47993,"token":false,"name":"Heroic Reinforcements","scryfallId":"33c35bf8-ae43-41aa-aae9-4d7513f9058c"},{"index":48001,"token":false,"name":"Pure Intentions","scryfallId":"b231d818-df57-4e2d-9603-babe0c2c4568"},{"index":48005,"token":false,"name":"Possibility Storm","scryfallId":"858aa831-b491-4f1e-bb56-33eeca14771d"},{"index":48011,"token":false,"name":"Mercadia's Downfall","scryfallId":"14507fe6-80a9-4ed4-bf3e-4656f3d377c0"},{"index":48017,"token":false,"name":"Dwarven Berserker","scryfallId":"7bc734e9-fb09-4094-94b6-76c0458649e9"},{"index":48021,"token":false,"name":"Giant's Ire","scryfallId":"046fa2db-4c73-401a-b9a4-b039554be625"},{"index":48023,"token":false,"name":"Volcanic Wind","scryfallId":"3c69dd00-46ce-42b2-a2ed-43b4cf04a975"},{"index":48024,"token":false,"name":"Reap the Past","scryfallId":"c0b7e59a-5302-4a73-816a-b759adff3ee6"},{"index":48037,"token":false,"name":"Moriok Scavenger","scryfallId":"0f27426b-3679-44e4-9249-f57b92baa3f3"},{"index":48044,"token":false,"name":"Witch's Cauldron","scryfallId":"d43a3eb7-3daf-4667-b824-1f5d801c9341"},{"index":48047,"token":false,"name":"Traitor's Clutch","scryfallId":"6313a601-5d26-487b-a70c-2c7184b7cc91"},{"index":48051,"token":true,"name":"Dog Token (W, 1/1)","scryfallId":"4f8107b3-8539-4b9c-8d0d-c512c940838f"},{"index":48061,"token":false,"name":"Omen Machine","scryfallId":"0ff4e35f-2a82-4d3c-86c5-ae05a5abc4d7"},{"index":48062,"token":false,"name":"Gem of Becoming","scryfallId":"0e07bc36-2207-48f4-a151-4ccb0c6d851d"},{"index":48066,"token":false,"name":"Elven Warhounds","scryfallId":"29138c1e-11cb-488f-8e04-f5488e08a81e"},{"index":48070,"token":false,"name":"Artful Dodge","scryfallId":"de6ce6aa-e19f-4299-9807-e68920e63c73"},{"index":48075,"token":false,"name":"Tome of Legends","scryfallId":"040301e8-20c1-4f4c-8766-d05f11415efd"},{"index":48076,"token":false,"name":"Makeshift Battalion","scryfallId":"31a500e6-01f5-4a3a-8839-68b9b515e919"},{"index":48077,"token":false,"name":"Alms","scryfallId":"97382dd8-2754-4ca3-8ba8-d655acaf22ac"},{"index":48081,"token":false,"name":"Sworn Defender","scryfallId":"328e6ceb-30f7-415e-93b4-7075af0fed89"},{"index":48092,"token":false,"name":"Empyrial Archangel","scryfallId":"43b789ea-df50-49a5-bd64-3b74b4042f83"},{"index":48095,"token":false,"name":"Desperate Research","scryfallId":"6a42ac7e-4a27-488c-a2e7-338b18103b02"},{"index":48096,"token":false,"name":"Deep Wood","scryfallId":"cfa04db1-bf4a-4824-9dc9-f5c510ba62bc"},{"index":48099,"token":false,"name":"Rage-Scarred Berserker","scryfallId":"1f76d7c4-a5d6-4144-b5f3-e43b96b695b7"},{"index":48100,"token":false,"name":"Restrain","scryfallId":"f6b5c765-619c-4db9-b509-91892fb65e8f"},{"index":48101,"token":false,"name":"Daring Fiendbonder","scryfallId":"27dd910a-a3ca-46ac-9350-f2a22496f4e6"},{"index":48102,"token":false,"name":"Cry of the Carnarium","scryfallId":"715a14a3-046e-45ca-b943-dd630e5202b7"},{"index":48105,"token":false,"name":"Brightflame","scryfallId":"9a3acf27-5d07-48e6-8e19-a2e6d4cd49d1"},{"index":48109,"token":false,"name":"Borrowed Malevolence","scryfallId":"a71f123e-aad9-4f3e-9f43-1d1be359affb"},{"index":48121,"token":false,"name":"Disciple of the Sun","scryfallId":"ad9723a1-7c5f-49ea-a8c6-24ee572d839f"},{"index":48135,"token":true,"name":"Janosch Kühn Decklist 1997","scryfallId":"2e8d223d-ede3-477b-8dd7-e4c58798b3f3"},{"index":48137,"token":false,"name":"Vulturous Aven","scryfallId":"b2fb0cc9-aebd-4bbf-8735-add3b753c118"},{"index":48138,"token":false,"name":"Riot Gear","scryfallId":"d3be1289-76f9-40b3-9387-b76a8b8d8797"},{"index":48140,"token":false,"name":"Fire at Will","scryfallId":"53617fbc-a6e9-4f06-8c4b-4699325cdcac"},{"index":48145,"token":false,"name":"Strange Augmentation","scryfallId":"8d9b9847-7ef7-4fcc-ba16-8f2859d53fe6"},{"index":48149,"token":false,"name":"Trickbind","scryfallId":"f2e58ff2-dea3-42b3-8c22-3e6202a7d433"},{"index":48150,"token":false,"name":"Tezzeret, Master of Metal","scryfallId":"d7c6614c-cc2b-4e5b-9c0d-ce8e4b2d8ea7"},{"index":48151,"token":false,"name":"Eldrazi Skyspawner","scryfallId":"9c9c1a10-446e-492a-95cc-a459dc6c08a0"},{"index":48155,"token":false,"name":"Memory Theft","scryfallId":"397fd49b-a520-4b0e-9ab9-71675ab5969d"},{"index":48171,"token":false,"name":"Dega Sanctuary","scryfallId":"b7ddfdb5-3981-4954-af5f-2459d22ec575"},{"index":48174,"token":false,"name":"Liliana's Influence","scryfallId":"28cdf48e-e0d4-45ca-b48d-74ada54ba62e"},{"index":48180,"token":false,"name":"Thornscape Familiar","scryfallId":"76c6e426-6165-4f8e-8766-de768ae13452"},{"index":48192,"token":false,"name":"Quietus Spike","scryfallId":"554f2444-78bd-4312-a1d7-00cadcac7559"},{"index":48196,"token":false,"name":"Dread Slaver","scryfallId":"3d8a3abd-a4a2-48e6-b709-1c0240a76c5e"},{"index":48201,"token":false,"name":"Hero of the Winds","scryfallId":"7da95097-dbe7-416a-8571-6ab6d88a531a"},{"index":48206,"token":false,"name":"Wake of Destruction","scryfallId":"0c070f12-0342-48d5-ab0e-4fc4701c3669"},{"index":48210,"token":false,"name":"Mul Daya Channelers","scryfallId":"5d362c3b-f9e1-476b-b5fd-d1292bbc257c"},{"index":48212,"token":false,"name":"Mount Velus Manticore","scryfallId":"667a356c-b10d-42f2-bb2f-c3fd9affa4bd"},{"index":48235,"token":false,"name":"Glacial Floodplain","scryfallId":"9de5fadd-4559-479f-b45d-abe792f0f6e5"},{"index":48237,"token":false,"name":"Yuan Shao's Infantry","scryfallId":"a2623481-cee3-4a9d-933b-235fcde9a27b"},{"index":48243,"token":false,"name":"Guild Feud","scryfallId":"8e622878-0aea-4401-873e-d34bf05ee98d"},{"index":48246,"token":false,"name":"Incendiary Oracle","scryfallId":"eb6b9b5c-35ff-47ac-9b04-71257314b686"},{"index":48252,"token":true,"name":"Sculpture Token (Colorless, */*)","scryfallId":"7711a586-37f9-4560-b25d-4fb339d9cd55"},{"index":48270,"token":false,"name":"Roil's Retribution","scryfallId":"c0de575e-d955-48da-8fc8-05d7398bd261"},{"index":48284,"token":false,"name":"Unexplained Vision","scryfallId":"c1de1d84-e548-409d-b9ec-d2665477b43d"},{"index":48289,"token":false,"name":"Rampaging Rendhorn","scryfallId":"12c1b820-0f06-41f6-804f-5c98f60c1529"},{"index":48293,"token":false,"name":"Valor Made Real","scryfallId":"bb164bd0-6745-4d41-aafe-89673a785f08"},{"index":48302,"token":false,"name":"Wicked Akuba","scryfallId":"c3172965-6057-472f-9712-1dd23d25d1a7"},{"index":48304,"token":false,"name":"Vessel of Nascency","scryfallId":"9d502ecf-b3a5-4657-8718-104e8f0ab9af"},{"index":48308,"token":false,"name":"Jawbone Skulkin","scryfallId":"3a88f807-96ce-432f-aaf5-d0097d234a4b"},{"index":48310,"token":false,"name":"Shiny Impetus","scryfallId":"0aa80931-0501-4712-a11b-563a3cd1e1c9"},{"index":48320,"token":false,"name":"Sparring Construct","scryfallId":"badc7db8-386e-4fb6-aefa-591e99747eb2"},{"index":48321,"token":false,"name":"Bubbling Muck","scryfallId":"6ca76614-78a1-4535-9162-70469d1e8a13"},{"index":48324,"token":false,"name":"Blaring Captain","scryfallId":"3885e78d-b281-4dfa-ae71-de15817a944d"},{"index":48339,"token":false,"name":"Lawbringer","scryfallId":"2d76b7e3-6890-4120-8575-732909c8bdff"},{"index":48347,"token":false,"name":"Sokenzan Renegade","scryfallId":"1e9b3164-3de2-4b25-88d0-2dffee32148a"},{"index":48352,"token":false,"name":"Rock Basilisk","scryfallId":"79949237-dcce-4ac1-bdc6-7c6d8b5f5fde"},{"index":48357,"token":false,"name":"Recurring Insight","scryfallId":"db92d00c-e5eb-4e69-9ebc-fec6d9c0f71e"},{"index":48363,"token":false,"name":"Slavering Nulls","scryfallId":"a8ead2b6-3bf7-4881-a154-06ab2558052b"},{"index":48364,"token":false,"name":"Skyway Sniper","scryfallId":"1776f5b4-1292-460f-9719-e1b603cee46c"},{"index":48365,"token":false,"name":"Steal Strength","scryfallId":"5470b3bb-5061-4beb-9f44-b56c3b2fd816"},{"index":48370,"token":false,"name":"Tivash, Gloom Summoner","scryfallId":"e3b2a152-7bb9-495d-ac84-516097754137"},{"index":48372,"token":false,"name":"Loyal Apprentice","scryfallId":"b5fef5fe-3e59-4fd6-8a88-7c1cee56892f"},{"index":48385,"token":false,"name":"Skyshroud Troopers","scryfallId":"d5197937-023c-412c-bf2c-b8e811ca04e1"},{"index":48389,"token":false,"name":"Dreadwing","scryfallId":"afb997b6-d872-438f-bf8a-db976bc27a2d"},{"index":48391,"token":false,"name":"The First Eruption","scryfallId":"3c3b0d9d-843b-4eae-861e-554b13f6807e"},{"index":48397,"token":false,"name":"Reviving Melody","scryfallId":"49b152cc-d39f-470e-8b62-e4a833db7b88"},{"index":48398,"token":false,"name":"Cram Session","scryfallId":"c59a249f-35ed-447a-845b-32ba5a53124e"},{"index":48401,"token":false,"name":"Glory Bearers","scryfallId":"8a70e1be-f04a-43c1-8fca-205a24e3db38"},{"index":48408,"token":false,"name":"Goblin Psychopath","scryfallId":"52287036-00f1-4b6d-8cd8-b8cbc70c5135"},{"index":48416,"token":true,"name":"Cats","scryfallId":"ef524ce0-b418-458c-b56e-0fbea3aa1142"},{"index":48419,"token":false,"name":"Hindering Light","scryfallId":"98e43870-4bed-4d76-a633-a6326c736d22"},{"index":48420,"token":false,"name":"Marchesa's Decree","scryfallId":"864e7da2-21aa-4de5-be30-8cf1ba8b7822"},{"index":48428,"token":false,"name":"Rustspore Ram","scryfallId":"5d23449c-4439-4425-ad53-84168a94b1ce"},{"index":48436,"token":false,"name":"Constricting Sliver","scryfallId":"ae9b4111-ca9f-435b-81c4-0abf65d1384b"},{"index":48447,"token":false,"name":"Wall of Faith","scryfallId":"05f30f77-75ea-4145-a4a1-106cc547f482"},{"index":48455,"token":false,"name":"Radiant Epicure","scryfallId":"48c99e55-c605-4519-a52a-39dfdbabb44a"},{"index":48463,"token":false,"name":"Dutiful Thrull","scryfallId":"8d586143-fac0-463f-96ec-c6b9fd582194"},{"index":48467,"token":false,"name":"Ardent Electromancer","scryfallId":"e8685c8e-935f-49f2-acf2-8e3c41c5b330"},{"index":48483,"token":false,"name":"Exuberant Firestoker","scryfallId":"c5c08845-d195-447e-9e4d-020dcab5f80f"},{"index":48487,"token":false,"name":"Macabre Mockery","scryfallId":"9c1aee37-dcee-4e58-be9b-81ca57cedb53"},{"index":48489,"token":false,"name":"Adaptive Shimmerer","scryfallId":"d8a2e243-e446-46c6-8a37-e26620951c41"},{"index":48501,"token":false,"name":"Krasis Incubation","scryfallId":"8da986da-e8ee-4b53-8bbd-9285d0f7f3cb"},{"index":48503,"token":false,"name":"Gather Specimens","scryfallId":"bbadf982-f22e-4f4f-b5c9-ac387f25c15f"},{"index":48505,"token":false,"name":"Stinging Licid","scryfallId":"807227d7-2eb2-4d47-bb3c-9d1ec9befeb7"},{"index":48509,"token":false,"name":"Crystallization","scryfallId":"cd0e9e1b-bd37-43a7-abd3-4582315a268d"},{"index":48510,"token":false,"name":"Knights of the Black Rose","scryfallId":"bfb6ba17-6bc0-4626-a604-8b32618a54c5"},{"index":48516,"token":false,"name":"Vital Splicer","scryfallId":"d13cf68c-b54c-46e1-a720-af57aac9e570"},{"index":48518,"token":false,"name":"Order of the Sacred Bell","scryfallId":"5bc9093a-4397-432f-b9e3-3693efcaec20"},{"index":48521,"token":false,"name":"Marble Priest","scryfallId":"459b71d7-34c1-43b9-93ff-364f95aa4789"},{"index":48527,"token":false,"name":"Woebringer Demon","scryfallId":"f0c758c9-3138-49b2-bebf-cdab5dc68a3d"},{"index":48530,"token":false,"name":"Horde Ambusher","scryfallId":"53926b92-adf0-4bb2-873f-103d9a1bdda8"},{"index":48531,"token":false,"name":"Vivien of the Arkbow","scryfallId":"8c185555-acd4-461a-821a-b21b7b0914a5"},{"index":48538,"token":false,"name":"Giant Shark","scryfallId":"53ec4a19-0f2f-4713-a869-58832484648d"},{"index":48540,"token":true,"name":"Vampire // Vampire Token (B, 2/2)","scryfallId":"5d9e999f-7033-4ccd-933a-eac4105b3edc"},{"index":48541,"token":false,"name":"Garrison Cat","scryfallId":"e7ff8345-227c-43b4-bed5-af3a34c0a990"},{"index":48542,"token":false,"name":"Lich Lord of Unx","scryfallId":"df38c422-7830-4f25-b74b-ed90b7047f53"},{"index":48543,"token":false,"name":"Urgent Exorcism","scryfallId":"516a437c-a2ee-43c6-876c-1a63a455c97c"},{"index":48544,"token":true,"name":"Elemental Token (R, */1)","scryfallId":"60466c78-155e-442b-8022-795e1e9de8df"},{"index":48556,"token":false,"name":"Slumbering Dragon","scryfallId":"277cbd0d-c8da-4a37-965c-6a60771df2f7"},{"index":48557,"token":false,"name":"Loxodon Wayfarer","scryfallId":"356c5e6a-c0bd-43f7-bc84-a6ae8718a7a2"},{"index":48571,"token":true,"name":"Tah-Crop Skirmisher Token (W, 2/1)","scryfallId":"6c2e835c-0f39-4fd1-a839-125bee0c9dbc"},{"index":48572,"token":false,"name":"Volcanic Submersion","scryfallId":"0ec1f1fa-41c9-4bc0-9171-902cd456aa73"},{"index":48581,"token":false,"name":"Eldrazi Aggressor","scryfallId":"62f3ec85-552d-4e28-939e-ab2c39e3e9c5"},{"index":48582,"token":false,"name":"Cold Snap","scryfallId":"81b87a58-b20c-4f38-afa3-59d398195740"},{"index":48583,"token":false,"name":"Deathmist Raptor","scryfallId":"1c73f83d-ee8f-48eb-9c3d-170f13062c74"},{"index":48584,"token":true,"name":"Crab Token (U, 0/3)","scryfallId":"7ef7f37a-b7f5-45a1-8f2b-7097089ca2e5"},{"index":48588,"token":false,"name":"Sudden Breakthrough","scryfallId":"b011707a-471b-41c2-bc73-376a55d26bee"},{"index":48590,"token":false,"name":"Protection of the Hekma","scryfallId":"ceadf01f-107f-402c-8f9c-f4997bfc1e54"},{"index":48591,"token":false,"name":"Royal Falcon","scryfallId":"10dfc217-ae94-4ff0-bf30-7131f97aa3c9"},{"index":48593,"token":false,"name":"Cleric of Chill Depths","scryfallId":"b4ea262c-ea32-4aca-b96b-58f556a8dffc"},{"index":48594,"token":false,"name":"Tectonic Break","scryfallId":"9de0ee5d-10f6-4152-8416-1f2b749b439d"},{"index":48603,"token":false,"name":"Wormfang Turtle","scryfallId":"48404362-7579-4896-a71a-8eb40e5ac416"},{"index":48607,"token":false,"name":"Skyfire Phoenix","scryfallId":"605b0d7d-4ece-4ad8-bf59-86ac121ccafe"},{"index":48621,"token":false,"name":"Zektar Shrine Expedition","scryfallId":"f12d2c01-0ef2-40e6-8c7d-8512e2c8c074"},{"index":48625,"token":false,"name":"Leonin Squire","scryfallId":"5a5320ff-1fe6-492a-b27f-86a84a1768ed"},{"index":48626,"token":true,"name":"Wall Token (Colorless, 0/4)","scryfallId":"dbdd5d53-65e7-42c3-a325-791f11335e62"},{"index":48631,"token":false,"name":"Spectral Sailor","scryfallId":"3b591fef-21ca-4a3b-990b-d7897a405511"},{"index":48632,"token":false,"name":"Swift Maneuver","scryfallId":"1f97ef40-9d07-47fa-ad4b-45f26f7351c9"},{"index":48633,"token":false,"name":"Sight Beyond Sight","scryfallId":"def0df83-fe20-497f-b372-1d2e4d7c8df9"},{"index":48635,"token":false,"name":"Slaughter Games","scryfallId":"bf37391d-db35-40a7-908a-abb53895793c"},{"index":48637,"token":false,"name":"Brushwagg","scryfallId":"6c20edc3-5ad0-42c1-a5ec-3e680fb03297"},{"index":48638,"token":false,"name":"Krosan Cloudscraper","scryfallId":"51ef4cda-e55b-45a8-9c02-4e77e5b15a9e"},{"index":48639,"token":false,"name":"Betrayal of Flesh","scryfallId":"cd063fe1-1160-436d-b883-5f2ddefd8dc3"},{"index":48641,"token":false,"name":"Bayou Dragonfly","scryfallId":"93cfcca5-070b-4946-b17b-0c94b1e47fcd"},{"index":48649,"token":false,"name":"Nocturnal Feeder","scryfallId":"487aced8-e018-4c93-8e13-bb68b43096a4"},{"index":48657,"token":false,"name":"Cytoplast Manipulator","scryfallId":"cfb6b06d-b132-44e9-a743-61187afb6152"},{"index":48658,"token":false,"name":"Skulking Fugitive","scryfallId":"175ed19c-9635-45ee-bb2c-32b96270a246"},{"index":48660,"token":false,"name":"Contamination","scryfallId":"86067dfe-65c3-4c96-bccd-b3915d6663f9"},{"index":48661,"token":false,"name":"Archway Angel","scryfallId":"b209d219-b946-4226-a8b4-65a5f3837fac"},{"index":48667,"token":false,"name":"Serrated Scorpion","scryfallId":"bc8f0242-35e1-4409-9321-56e742e8fef4"},{"index":48673,"token":false,"name":"Crazed Goblin","scryfallId":"15fdb57b-7547-4588-9780-15e3bea0bc4c"},{"index":48682,"token":true,"name":"Illusion // Saproling Token (U, 2/2)","scryfallId":"5cf70d25-9de9-4c3a-a52f-be17831e5695"},{"index":48684,"token":false,"name":"Spiteful Bully","scryfallId":"5535d14a-7126-4a94-96a0-e17ad5c72070"},{"index":48689,"token":false,"name":"Wojek Halberdiers","scryfallId":"423f0870-dc1c-4cd8-b92c-6d5f92abbaec"},{"index":48691,"token":false,"name":"Berg Strider","scryfallId":"f3567bdc-450e-4481-9349-a80fe52fe431"},{"index":48696,"token":true,"name":"Saproling // Saproling","scryfallId":"8ce60642-e207-46e6-b198-d803ff3b47f4"},{"index":48699,"token":false,"name":"Whim of Volrath","scryfallId":"e259da60-c8bc-4a77-98ed-e529dc067732"},{"index":48702,"token":false,"name":"Tin Street Market","scryfallId":"1c1f543b-2222-4ef5-b4f7-2c3d2ea27fdc"},{"index":48706,"token":false,"name":"Herald of the Dreadhorde","scryfallId":"d7ae9cb7-a3af-4224-89a5-a72f4d09dacf"},{"index":48712,"token":false,"name":"Restless Dead","scryfallId":"a237cff4-af6f-4745-bda1-e3ed2267fa89"},{"index":48715,"token":true,"name":"Unicorns","scryfallId":"5bf33e8e-04cd-4ffd-83c3-8e41cef4fd40"},{"index":48723,"token":false,"name":"Krosan Constrictor","scryfallId":"f24b3479-18c3-4c43-b8d1-8b4a25d271a7"},{"index":48727,"token":false,"name":"Swallow Whole","scryfallId":"c3b9140b-848f-4886-8c28-eccd3829a607"},{"index":48731,"token":false,"name":"Karstoderm","scryfallId":"028c52f2-c45b-42da-89bd-cdd5cd7850f3"},{"index":48734,"token":false,"name":"Feed the Serpent","scryfallId":"99a1a75b-20cf-4db9-a244-cc54411446c4"},{"index":48735,"token":false,"name":"Tuya Bearclaw","scryfallId":"8cf6b42f-8eb7-4b40-a4e6-8775ee208f7e"},{"index":48740,"token":false,"name":"Stonebinder's Familiar","scryfallId":"21de4a01-98d3-4af3-9c6e-29e16d2c1767"},{"index":48744,"token":false,"name":"Harvester Troll","scryfallId":"0bf92744-0acc-4c7e-819c-51b0696facad"},{"index":48755,"token":false,"name":"Wretched Camel","scryfallId":"cdd729df-8a02-4d5e-8432-bc0d006b0d3d"},{"index":48757,"token":false,"name":"Go for Blood","scryfallId":"67315df9-99a1-45ba-8ade-ddc476368a86"},{"index":48760,"token":false,"name":"Stormscale Anarch","scryfallId":"00dbd0ef-9888-4489-ba4a-65128308fb11"},{"index":48761,"token":true,"name":"Vizier of Many Faces Token (W, 0/0)","scryfallId":"39520c16-1f4b-4f15-aeb4-53c91e8ecfcc"},{"index":48762,"token":false,"name":"Minister of Pain","scryfallId":"3cf4c637-82c3-41fa-b484-31e7dcf475a9"},{"index":48766,"token":false,"name":"Grisly Transformation","scryfallId":"4eb0ce84-560f-4e39-a0ab-7bd710d541cc"},{"index":48769,"token":true,"name":"Ooze Token (G, 1/1)","scryfallId":"24edd312-ef8e-48a0-8532-13e072daa00f"},{"index":48770,"token":false,"name":"Dawning Angel","scryfallId":"4f3d90ef-6f70-4897-85c1-4e1beeb33363"},{"index":48780,"token":false,"name":"Screaming Shield","scryfallId":"ebb42a80-0442-4850-b0e7-41182d5633ff"},{"index":48783,"token":false,"name":"Hydromorph Gull","scryfallId":"06b1c8fc-e09b-479b-ac15-f659acb2f50f"},{"index":48785,"token":false,"name":"Thoughtcutter Agent","scryfallId":"8c9af048-43c2-44ff-9ca0-2a81609a4e91"},{"index":48790,"token":false,"name":"Collective Effort","scryfallId":"d85a6369-c07f-47d5-8448-72d8ec7e7898"},{"index":48793,"token":false,"name":"Mental Vapors","scryfallId":"076e7c58-a6fe-4882-8f8d-698be9a7f22d"},{"index":48806,"token":false,"name":"Pulse of the Fields","scryfallId":"bdedff5d-4c5d-4120-9d9a-4bb5b0b2d2f2"},{"index":48807,"token":false,"name":"Icefall Regent","scryfallId":"e1752991-c7b0-4397-913b-b93a7705bbcb"},{"index":48810,"token":false,"name":"Rune of Flight","scryfallId":"d5c1a271-2107-462a-9d4a-9c7fbcfa8d77"},{"index":48820,"token":false,"name":"Deem Worthy","scryfallId":"99a2ed5f-62b8-4308-a656-f273f62f6ab8"},{"index":48825,"token":false,"name":"Alhammarret's Archive","scryfallId":"810c91b8-6b2f-469f-8fd1-568885178c9b"},{"index":48827,"token":false,"name":"War Chariot","scryfallId":"d0ea0c6c-aa76-4b16-bc99-2ff46dc56d4e"},{"index":48828,"token":false,"name":"One-Eyed Scarecrow","scryfallId":"5d495d85-6458-44d5-b3b4-5e09569057e3"},{"index":48837,"token":false,"name":"Mindshrieker","scryfallId":"ab1e52af-6746-4ec6-afbf-008594c874f8"},{"index":48847,"token":true,"name":"Hydra Token (B/G, */*)","scryfallId":"f2ad0395-190d-4779-81b7-2832dc257828"},{"index":48848,"token":false,"name":"Krosan Colossus","scryfallId":"a804f3c0-5ebf-43ca-b200-09f7c1bbe902"},{"index":48851,"token":false,"name":"Gigantomancer","scryfallId":"af25e35c-d1a4-4c10-8574-82babaaac4fd"},{"index":48854,"token":false,"name":"Caged Zombie","scryfallId":"f8067745-35b6-4abd-9ae9-712159a26c89"},{"index":48855,"token":false,"name":"Defend the Hearth","scryfallId":"c3e4c4c3-db3c-49d4-8080-1c93470f8b4d"},{"index":48859,"token":false,"name":"Michonne, Ruthless Survivor","scryfallId":"5c68c630-c0e1-4e94-8352-b65631cc2caa"},{"index":48867,"token":false,"name":"Hackrobat","scryfallId":"a41335c2-3d11-4f95-8d9f-66b04398c10b"},{"index":48868,"token":false,"name":"Hand of Cruelty","scryfallId":"ee194055-579a-4977-900e-e976259552ab"},{"index":48873,"token":false,"name":"Uncage the Menagerie","scryfallId":"bc4aa918-53b9-4177-a859-f5a8eff09fe5"},{"index":48880,"token":false,"name":"Brilliant Ultimatum","scryfallId":"593409fd-26ef-463e-9101-ec5ad53dfd67"},{"index":48881,"token":false,"name":"Foster","scryfallId":"be54e1d7-1388-4184-ad0d-dde4b0a3d02d"},{"index":48883,"token":false,"name":"Colos Yearling","scryfallId":"1d68eb62-9f86-4c85-8696-46a248c744ff"},{"index":48886,"token":false,"name":"Tilling Treefolk","scryfallId":"8e4a10d0-214d-4e7b-9683-c84034f8f6b7"},{"index":48888,"token":false,"name":"Arc Mage","scryfallId":"62982dab-4c27-45b3-9740-38fec3df7226"},{"index":48894,"token":false,"name":"Marsh Threader","scryfallId":"0b0c439a-25e4-4ff7-8080-b3be59d5dbe6"},{"index":48897,"token":false,"name":"Wand of Vertebrae","scryfallId":"87f208bc-e4dc-4d3a-8906-dccde3cc251b"},{"index":48898,"token":false,"name":"Mindlock Orb","scryfallId":"55c84e9f-ccbb-4fbc-98e1-4072968a1f8a"},{"index":48901,"token":false,"name":"Squee's Toy","scryfallId":"2b524ae7-cb24-41af-b41b-3cb3ee8cf3b0"},{"index":48905,"token":false,"name":"Descent of the Dragons","scryfallId":"5ab919f3-5797-406b-ae1f-7a7c27739b2d"},{"index":48912,"token":false,"name":"Estrid's Invocation","scryfallId":"04c01143-f7fc-4874-87fd-59d1432c2bbb"},{"index":48913,"token":false,"name":"Domineer","scryfallId":"c0010b89-afc4-4dee-bda3-2f34e552cba5"},{"index":48915,"token":false,"name":"Conjurer's Bauble","scryfallId":"2d32960e-d182-455f-8e74-eb11b10050da"},{"index":48916,"token":false,"name":"Soul Barrier","scryfallId":"9ad7fac7-db4d-45b2-aba6-16f4fd1a586f"},{"index":48934,"token":false,"name":"Act of Authority","scryfallId":"e107bd35-eddd-40f7-aea8-3a1eec3363c0"},{"index":48937,"token":false,"name":"Hornswoggle","scryfallId":"b10b8f15-b323-44d8-85a7-ed662a40889d"},{"index":48944,"token":true,"name":"Monk Token (W, 1/1)","scryfallId":"1e498e42-f55c-4afa-b2e2-02345f91cdb5"},{"index":48951,"token":false,"name":"Stern Mentor","scryfallId":"ffe4d34f-68f0-4d79-9aab-58c5304224d9"},{"index":48953,"token":false,"name":"Chandra, Pyrogenius","scryfallId":"5ab8435b-5fe8-4074-8809-46aa6e5504c8"},{"index":48965,"token":false,"name":"Sakashima's Will","scryfallId":"b87d4d43-7a46-4f72-97a9-3958bf253a3a"},{"index":48970,"token":false,"name":"Ensouled Scimitar","scryfallId":"9d2a16e2-ea98-4bf2-9e5c-7612d2dd039b"},{"index":48973,"token":false,"name":"Knight of Dusk","scryfallId":"8aba09c4-9259-4743-9e4a-a63505f1efe6"},{"index":48979,"token":false,"name":"Mana Vapors","scryfallId":"0b6dfe49-9fd6-4fa0-b73e-e6470d8e7ca7"},{"index":48981,"token":false,"name":"Keldon Firebombers","scryfallId":"d3fc78b5-c259-4c67-810c-99655e72c2da"},{"index":48988,"token":false,"name":"Locust Miser","scryfallId":"55bf4dda-0ce8-4e35-88d9-18a22400e6cb"},{"index":49001,"token":false,"name":"Rubblebelt Rioters","scryfallId":"9bf8df62-eca1-4a45-84af-fd7c88245a42"},{"index":49009,"token":false,"name":"Akroan Jailer","scryfallId":"8d96bc2b-2e31-4654-b192-c3f023d9fde6"},{"index":49014,"token":false,"name":"Secrets of the Dead","scryfallId":"c982d679-581d-43e1-acd0-db77eb0987c2"},{"index":49019,"token":false,"name":"Cliffside Lookout","scryfallId":"8c755ae6-badc-4dc8-bfa6-fdebcb00bfba"},{"index":49024,"token":false,"name":"First Day of Class","scryfallId":"091eb13d-9318-4b12-9f94-6276b11981d1"},{"index":49028,"token":false,"name":"Diversionary Tactics","scryfallId":"1e5061e4-a76d-4a7c-b196-96c81f94e0e5"},{"index":49032,"token":false,"name":"Molten Firebird","scryfallId":"dddda66c-2df4-452e-8eca-7e100213fd98"},{"index":49033,"token":false,"name":"Glimmer Bairn","scryfallId":"e0691a6a-bfbd-411b-b147-bf9702e7d149"},{"index":49035,"token":false,"name":"Etrata, the Silencer","scryfallId":"6f4fad58-ef91-4bcc-8a6a-48d033701fd4"},{"index":49042,"token":false,"name":"Biting Tether","scryfallId":"52ed9c9f-37d1-4f33-b62f-11ed2c208763"},{"index":49047,"token":false,"name":"Elsewhere Flask","scryfallId":"9273a17d-114b-4d54-a2a5-1047df8caa9d"},{"index":49048,"token":false,"name":"Dual Casting","scryfallId":"b9e750b1-be87-419a-8fe5-5b0733141dda"},{"index":49057,"token":false,"name":"Vulshok Refugee","scryfallId":"0b1615ec-21b3-4575-8b02-fd2bccb930ba"},{"index":49062,"token":false,"name":"Void Snare","scryfallId":"94efe426-0fb2-4a24-9b50-914e48105b57"},{"index":49067,"token":false,"name":"Spoils of Blood","scryfallId":"d9df391c-eb76-45b1-a58d-8211538a22ac"},{"index":49071,"token":false,"name":"Ghor-Clan Wrecker","scryfallId":"4da3969c-1979-4eee-828a-4a7189121eba"},{"index":49075,"token":false,"name":"Jhovall Queen","scryfallId":"b8eb55cc-ddde-4f15-9262-b9aee28059d3"},{"index":49091,"token":false,"name":"Dulcet Sirens","scryfallId":"045e15fd-6e2b-40a9-89ba-2f4c9e445416"},{"index":49097,"token":false,"name":"Silkbind Faerie","scryfallId":"12d06328-a124-40e4-a9d8-2342a881970e"},{"index":49099,"token":false,"name":"Risky Move","scryfallId":"0b09315c-d6ff-4fdb-8774-c6402b45e959"},{"index":49113,"token":false,"name":"Ribbons of the Reikai","scryfallId":"e7a3b0da-026e-4ea9-8035-38c909e5f9a4"},{"index":49115,"token":false,"name":"Soratami Seer","scryfallId":"462a861d-e5c5-48b1-95c0-3ef04b690eac"},{"index":49118,"token":false,"name":"Zap","scryfallId":"7502ce01-b762-40fe-a064-c7b20b08a722"},{"index":49120,"token":false,"name":"Guilty Conscience","scryfallId":"67b8701c-0f03-4ad0-9097-3caf885abd59"},{"index":49123,"token":false,"name":"Inquisitor's Ox","scryfallId":"fd1401fe-9e88-401b-96f0-5f58808a519f"},{"index":49124,"token":false,"name":"Slaughterhouse Bouncer","scryfallId":"b70e71c1-5d95-44f3-99f1-b3b6eda8b26c"},{"index":49128,"token":false,"name":"Cleansing Ray","scryfallId":"7bf94184-e745-469a-9d55-af0ddacbb9cf"},{"index":49129,"token":false,"name":"Karona, False God","scryfallId":"de53d083-251e-42a4-9e2e-c2978c80615b"},{"index":49134,"token":false,"name":"Flamekin Harbinger","scryfallId":"8251195e-159f-4fd1-a6b7-b01d2407f758"},{"index":49146,"token":false,"name":"Natural Emergence","scryfallId":"c3eb4857-7c66-42e4-913c-97a0306366d5"},{"index":49149,"token":true,"name":"Adorned Pouncer Token (B, 4/4)","scryfallId":"71dc8556-a658-40e1-8a93-6a62af208a28"},{"index":49161,"token":false,"name":"Stern Judge","scryfallId":"436044d7-981c-4273-a0b4-6dd455608c47"},{"index":49172,"token":false,"name":"Stonefare Crocodile","scryfallId":"028b8d50-b858-4c64-8eb9-b7699b2134df"},{"index":49174,"token":false,"name":"Molten Hydra","scryfallId":"95234b29-9ac8-4200-b42d-9653ba51b010"},{"index":49176,"token":false,"name":"Return to the Ranks","scryfallId":"9fccce64-abac-4b90-bbe5-dbba8434b3b4"},{"index":49181,"token":false,"name":"Shatterskull Recruit","scryfallId":"c8add5f2-4ccf-4505-86f6-cc36aff1c3fe"},{"index":49186,"token":false,"name":"Urban Daggertooth","scryfallId":"4ab83a39-d90d-403e-b74d-fe99c8b2aacd"},{"index":49191,"token":false,"name":"Fruition","scryfallId":"e695fcf4-1eef-4671-a11e-da6b1ff8d466"},{"index":49192,"token":false,"name":"Nim Abomination","scryfallId":"1072fef6-3a58-41bb-8d34-0aaedf827aa5"},{"index":49194,"token":false,"name":"Relic Amulet","scryfallId":"0ab97a84-fe8c-4986-afd8-3abdcc029f7f"},{"index":49197,"token":false,"name":"Pop Quiz","scryfallId":"d16892d8-9d10-45de-ab79-0e645c4b5588"},{"index":49201,"token":false,"name":"Argivian Find","scryfallId":"89f23295-ad0a-4e2d-ae04-1a9c065e575d"},{"index":49202,"token":false,"name":"Lifelink","scryfallId":"a8e207d4-9930-4aff-a7c8-b53bd1b5d566"},{"index":49203,"token":false,"name":"Mortus Strider","scryfallId":"d644eb6e-cc49-4834-bc2c-53f6a4ceb451"},{"index":49208,"token":false,"name":"Nettle Swine","scryfallId":"75935f0e-9086-485b-b3e6-1a958fd0f2af"},{"index":49214,"token":false,"name":"Graceful Restoration","scryfallId":"f03d7c3c-02f2-4c42-bcfa-0b83de30f607"},{"index":49219,"token":false,"name":"Raking Canopy","scryfallId":"df529b30-9ac6-4944-9d21-ecf6d64a8845"},{"index":49223,"token":false,"name":"Neurok Prodigy","scryfallId":"fb179448-5e1f-4ef3-858c-ba7a9ea05a78"},{"index":49225,"token":false,"name":"Earthblighter","scryfallId":"830a4048-48ac-4856-9af9-5052ec146518"},{"index":49231,"token":false,"name":"Jaddi Lifestrider","scryfallId":"2dff438a-925c-4fca-a2e3-3e9519b7afed"},{"index":49240,"token":false,"name":"Serra Zealot","scryfallId":"0b311542-599f-4d2f-a871-18d5b0b7bbe5"},{"index":49242,"token":false,"name":"Academic Dispute","scryfallId":"4620cc3b-e401-4096-b310-fed080806344"},{"index":49243,"token":false,"name":"Isao, Enlightened Bushi","scryfallId":"90334b59-73d8-4459-af59-d7a0539e2cc5"},{"index":49244,"token":false,"name":"Skyshroud Sentinel","scryfallId":"a35ab55f-f677-45c8-bd32-56788a776b33"},{"index":49248,"token":false,"name":"Heightened Awareness","scryfallId":"2765be4f-23bf-49c1-9546-11a7916156be"},{"index":49252,"token":false,"name":"Consign to Dream","scryfallId":"5e866d86-5bfa-473d-be17-d8f4aea70ddb"},{"index":49268,"token":false,"name":"Yarok's Fenlurker","scryfallId":"16b122f8-fcd9-4b2a-92f6-f0ed7307ff58"},{"index":49273,"token":false,"name":"Viashivan Dragon","scryfallId":"7172ef0b-ca9e-47cf-8ec6-2d8cb18f2283"},{"index":49277,"token":false,"name":"Surging Aether","scryfallId":"bfba9fc2-8746-4693-bb75-01b5d78f7fee"},{"index":49280,"token":false,"name":"Revel of the Fallen God","scryfallId":"e1d2c774-aab9-4747-af91-da792ed7cfe1"},{"index":49281,"token":false,"name":"Goblin Kites","scryfallId":"a0a27ac3-2273-469a-92ba-3f4a3d55de6f"},{"index":49282,"token":false,"name":"Radical Idea","scryfallId":"c9570734-5e9b-46ff-b606-9759b5195756"},{"index":49286,"token":false,"name":"Counterflux","scryfallId":"94e4b773-40a4-4272-85dd-f728ada22748"},{"index":49288,"token":false,"name":"Colossapede","scryfallId":"7642bfc5-ace8-419e-b57b-2b881bfe023e"},{"index":49296,"token":false,"name":"Keeper of Progenitus","scryfallId":"bcb023a2-e929-47e9-bd58-cbc6f241e7a4"},{"index":49301,"token":false,"name":"Silkenfist Fighter","scryfallId":"3480efc4-1078-4c63-a94c-d00a7507f6b1"},{"index":49304,"token":false,"name":"Gaea's Might","scryfallId":"67e5adce-7735-4fa5-aa14-8dce012e9fcc"},{"index":49310,"token":false,"name":"Nix","scryfallId":"3dab4f64-2a91-409a-b83b-45b22afd22ff"},{"index":49312,"token":false,"name":"Gates of Istfell","scryfallId":"2627acb7-57d9-4429-9bc5-e7dd444d8d48"},{"index":49316,"token":false,"name":"Lighthouse Chronologist","scryfallId":"3087f7e7-9163-45b5-907d-7667c1075a74"},{"index":49325,"token":false,"name":"Fiery Bombardment","scryfallId":"c348d137-4774-41d7-8b4d-d383c816ae2a"},{"index":49326,"token":false,"name":"Multani's Decree","scryfallId":"58b4d5c8-23fc-4fb8-99d6-bb64e66cc4db"},{"index":49328,"token":false,"name":"Duergar Mine-Captain","scryfallId":"e97983b9-6c93-41ce-8deb-ac08811a0834"},{"index":49333,"token":false,"name":"Faerie Trickery","scryfallId":"defb9f0b-195e-4aeb-92c1-8f827ad6724b"},{"index":49337,"token":false,"name":"Venser's Journal","scryfallId":"2763643d-5b53-49d0-bc3d-5626bf00f3f4"},{"index":49339,"token":false,"name":"Soar","scryfallId":"bd3666dd-a90e-43c2-bd78-ea9c1af08a0e"},{"index":49341,"token":false,"name":"False Memories","scryfallId":"3a45ea90-03af-446e-9df3-ef64e9613f2c"},{"index":49345,"token":false,"name":"Proclamation of Rebirth","scryfallId":"8bb24670-698b-46f7-94aa-3901f7d2b7dc"},{"index":49349,"token":false,"name":"Atarka Beastbreaker","scryfallId":"c8ef9a03-3044-4e90-9409-c330972fcafb"},{"index":49368,"token":false,"name":"Goblin Spy","scryfallId":"2a89a099-8805-4b26-babd-5d9f48ee406a"},{"index":49374,"token":false,"name":"Into the Story","scryfallId":"c838f08e-7fb6-46e7-83bb-dce8877d6c87"},{"index":49375,"token":false,"name":"Hapatra's Mark","scryfallId":"199d6a8d-008d-4495-9cbc-b8d680fab13c"},{"index":49381,"token":false,"name":"Lifted by Clouds","scryfallId":"a5f08f3d-82ef-4c3f-af2d-a3c834e22b99"},{"index":49391,"token":false,"name":"Cankerous Thirst","scryfallId":"45840408-33e7-43fa-96ab-d3bd53e3fd6b"},{"index":49395,"token":false,"name":"Sai, Master Thopterist","scryfallId":"35dfaec6-a1b0-43a4-a5cf-ff1f6ee7b3b1"},{"index":49397,"token":false,"name":"Leyline Invocation","scryfallId":"4edfbed0-0c0d-4aa5-bfe0-5268aff0f958"},{"index":49407,"token":false,"name":"Scepter of Empires","scryfallId":"54f1aaef-94cc-45ab-99c9-8ffdcf331a7b"},{"index":49408,"token":false,"name":"Defender of the Order","scryfallId":"236b1c88-20a0-479e-91fb-16bb77f699fe"},{"index":49410,"token":false,"name":"Wu Scout","scryfallId":"8d13330f-6e07-451f-b17a-4e1606a74c3f"},{"index":49415,"token":false,"name":"Sprouting Renewal","scryfallId":"668232ab-5e58-49f3-804a-c938252ff177"},{"index":49422,"token":false,"name":"Suq'Ata Firewalker","scryfallId":"b8a7c22e-fe96-4960-96d4-ee85abec3281"},{"index":49423,"token":false,"name":"Honed Khopesh","scryfallId":"c7d80b98-baa2-48ea-9611-96e64d7cb950"},{"index":49424,"token":false,"name":"Aberrant Researcher // Perfected Form","scryfallId":"b5c9649e-9ae5-4926-bf08-71ba23aa37f1"},{"index":49426,"token":false,"name":"Springsage Ritual","scryfallId":"2e0b23a4-5868-4dd8-ae68-846934e1bd52"},{"index":49427,"token":false,"name":"Armored Skaab","scryfallId":"ce4d00f2-30e6-41d5-b997-c66350fe783c"},{"index":49429,"token":false,"name":"Jabari's Influence","scryfallId":"c9f764d7-4c18-40ef-8373-ef1e2a88007e"},{"index":49430,"token":false,"name":"Golden Demise","scryfallId":"88bb420a-8bf1-4504-b1b5-2d929be978be"},{"index":49437,"token":false,"name":"Battlewise Aven","scryfallId":"ca363409-cba9-43ed-bf88-3519521e1983"},{"index":49439,"token":false,"name":"Vicious Conquistador","scryfallId":"2a4b6ced-e8d3-47e9-bd27-3e0cb644afe4"},{"index":49440,"token":false,"name":"Canopy Claws","scryfallId":"c4530da2-fd04-40d9-ad69-5c2847921509"},{"index":49449,"token":false,"name":"Override","scryfallId":"35964fa6-800d-41d6-9f82-fb9c87deee56"},{"index":49456,"token":false,"name":"Bone Dancer","scryfallId":"207bb4cd-4525-47e0-b412-0d0e29717d44"},{"index":49457,"token":false,"name":"Master of Death","scryfallId":"b2c398de-b96d-4fa6-89c4-3ce8183dc27e"},{"index":49461,"token":false,"name":"Priest of Yawgmoth","scryfallId":"c9fd4054-42fc-4f95-a6f7-369a5da43dd5"},{"index":49462,"token":false,"name":"Skyclave Squid","scryfallId":"581ed049-7b5b-47d9-96af-f737631a221f"},{"index":49465,"token":false,"name":"Submerge","scryfallId":"d2741fe4-37fe-427f-ae85-5107991d4eee"},{"index":49468,"token":false,"name":"Echoing Calm","scryfallId":"060e278c-dc34-4a94-9b15-6e9ffb2a1aee"},{"index":49470,"token":false,"name":"Lesser Masticore","scryfallId":"c4c7cba5-6111-40ce-828a-e811301bb283"},{"index":49477,"token":false,"name":"Auntie's Hovel","scryfallId":"098685c9-cd85-4279-a3b5-b495485bba35"},{"index":49481,"token":false,"name":"Govern the Guildless","scryfallId":"23106341-9200-4eee-93d0-d6173b0b39c4"},{"index":49486,"token":false,"name":"Repel Intruders","scryfallId":"38e64b09-1a58-4669-b7f2-baa3ccc85f2d"},{"index":49490,"token":false,"name":"Portal of Sanctuary","scryfallId":"37c66692-2880-4ea2-abaf-8926c6950826"},{"index":49493,"token":false,"name":"Mourner's Shield","scryfallId":"783fe67f-59f7-46f0-bfa4-fa4a65c9c33c"},{"index":49494,"token":false,"name":"Ramosian Commander","scryfallId":"867f5d82-71c2-455f-ab16-5a32bba46986"},{"index":49496,"token":false,"name":"Custodi Lich","scryfallId":"a7b7d4d0-8576-4d0f-b486-922d9cd31b24"},{"index":49499,"token":false,"name":"Cerebral Vortex","scryfallId":"b062722e-e8bb-4f7c-9635-efb7d1e76beb"},{"index":49500,"token":false,"name":"Madrush Cyclops","scryfallId":"21d4fd58-2052-4f97-b634-f89e2139d980"},{"index":49508,"token":false,"name":"Horizon Seeker","scryfallId":"a17f4b21-6478-407d-b567-2888349f3b66"},{"index":49513,"token":false,"name":"Iona's Blessing","scryfallId":"a30f26f7-5181-4bf1-9084-5563b4996a3c"},{"index":49516,"token":false,"name":"Centaur Rootcaster","scryfallId":"3f10dfd9-9889-4d9e-872a-07623dee6b6b"},{"index":49519,"token":false,"name":"Claim of Erebos","scryfallId":"a51db556-b3e8-4628-9e39-6353023b0696"},{"index":49522,"token":false,"name":"Umezawa's Charm","scryfallId":"afbbb742-0317-4266-bcf5-cfea8d21f108"},{"index":49526,"token":false,"name":"Bellowing Aegisaur","scryfallId":"c3e3b6c5-fd30-4d45-a122-ce60d5707357"},{"index":49552,"token":false,"name":"Regna's Sanction","scryfallId":"3ea0c6c5-f782-40bf-a0c9-ee7e97963146"},{"index":49553,"token":false,"name":"Kusari-Gama","scryfallId":"c6a700bd-6424-4a0c-b055-e8b64cf430ec"},{"index":49554,"token":true,"name":"Goblin // Soldier Token (W, 1/1)","scryfallId":"64f4dc68-060b-4c63-8f43-00f53c52a251"},{"index":49556,"token":false,"name":"Pestilent Souleater","scryfallId":"a069cc07-55eb-4ddb-a548-cbf463d078d3"},{"index":49558,"token":false,"name":"Resounding Scream","scryfallId":"64d27eb7-2d3b-4daf-9cf6-c254fdacceb0"},{"index":49560,"token":false,"name":"Psychic Membrane","scryfallId":"4ffd5a69-05b6-4fc4-8186-503a2e204330"},{"index":49562,"token":false,"name":"Trusty Companion","scryfallId":"0a79eefb-50a4-41c4-93cf-378fa546f539"},{"index":49565,"token":false,"name":"Rimewind Cryomancer","scryfallId":"4433653d-5ba9-4cdb-8a0b-69026301bc6f"},{"index":49570,"token":false,"name":"Deathbellow Raider","scryfallId":"b29fc64e-297e-4e10-8f4e-289dc1c3ebfd"},{"index":49571,"token":false,"name":"Hellkite Courser","scryfallId":"fea7f618-5757-4611-8689-e34690404992"},{"index":49575,"token":false,"name":"Kinsbaile Courier","scryfallId":"56b2b413-e00f-440d-9d27-92eb069b8c71"},{"index":49576,"token":false,"name":"Grip of Desolation","scryfallId":"850b388a-c188-433a-8124-1d51b43a4e51"},{"index":49581,"token":false,"name":"Aurora Champion","scryfallId":"35bb9e4e-3cfb-4794-bd03-04840b5fe1dc"},{"index":49582,"token":false,"name":"Senate Courier","scryfallId":"da8dc5c8-4eb7-4e41-8431-b41251f7814e"},{"index":49585,"token":false,"name":"Seismic Shift","scryfallId":"dad40a04-a026-4285-8c78-088a356652d1"},{"index":49587,"token":false,"name":"Felhide Minotaur","scryfallId":"b4e424de-81be-4f90-a7a2-4102c8ba8989"},{"index":49588,"token":false,"name":"Ashling the Pilgrim","scryfallId":"63056eb9-4257-4530-8ff4-6909a2cedf47"},{"index":49594,"token":false,"name":"Voidwalk","scryfallId":"611d0e10-e767-4e66-b1f1-02f1624fab2b"},{"index":49604,"token":false,"name":"Grenzo's Cutthroat","scryfallId":"9bb46638-eeb2-4bb3-bef2-bedd343722ef"},{"index":49609,"token":false,"name":"Serra the Benevolent","scryfallId":"88bf4af9-4b14-43e7-9d50-0e6a895cece1"},{"index":49624,"token":false,"name":"Militant Monk","scryfallId":"886a3cfd-7f83-480a-bb22-eec67ad35e4f"},{"index":49638,"token":false,"name":"Surly Badgersaur","scryfallId":"7ba507e2-fe5e-4947-aada-20184aa09700"},{"index":49656,"token":false,"name":"Profane Memento","scryfallId":"f2c97632-3cf1-4b79-9d18-d8991654dcca"},{"index":49659,"token":false,"name":"Wild Wurm","scryfallId":"e5a1b213-cba0-4eca-b058-93f4fde717c8"},{"index":49670,"token":false,"name":"Sky Scourer","scryfallId":"eb00fa72-bcda-4081-9048-e13752da8d46"},{"index":49674,"token":false,"name":"Scroll of Origins","scryfallId":"36b39d20-47b5-468b-aaf8-f6b7c7048b33"},{"index":49686,"token":false,"name":"Bramblesnap","scryfallId":"dcddd71f-bb8d-4153-854f-af87189babe7"},{"index":49688,"token":false,"name":"Favorable Destiny","scryfallId":"e5657403-7c86-4eb6-84b0-75eedb04a5a2"},{"index":49703,"token":false,"name":"War Oracle","scryfallId":"3d8827bf-11c3-4f78-b7aa-ae953442c709"},{"index":49715,"token":false,"name":"Knight of Glory","scryfallId":"1646cb67-e0ac-4f2d-af21-618ff3613d69"},{"index":49717,"token":false,"name":"Vodalian War Machine","scryfallId":"cd962ff0-4aa6-453e-931e-bd36fc034273"},{"index":49719,"token":false,"name":"Voracious Null","scryfallId":"74364056-f4ee-46d3-834d-a5157ec312b9"},{"index":49723,"token":false,"name":"Master of Arms","scryfallId":"ac97ff43-c0b6-4f67-ad09-5ba8710c681a"},{"index":49731,"token":false,"name":"Dream Fighter","scryfallId":"aec06bc9-553c-4e01-8b43-a4eeaa511b4d"},{"index":49739,"token":false,"name":"Embraal Bruiser","scryfallId":"fc1af0b2-f7e0-439a-bdb5-2d89546261ce"},{"index":49743,"token":false,"name":"Celestial Enforcer","scryfallId":"46666fba-d4a7-4687-8747-a42e4c6d853e"},{"index":49750,"token":false,"name":"Deconstruct","scryfallId":"53face79-d2bf-43dd-aa4e-d724c2b68c49"},{"index":49753,"token":false,"name":"Tectonic Fiend","scryfallId":"9c8aaf09-312f-4c82-9e0a-bd797e7f26c3"},{"index":49755,"token":false,"name":"Metamorphic Wurm","scryfallId":"f47e020a-ed73-465a-b7eb-a4eeccd096cc"},{"index":49763,"token":false,"name":"Frostwielder","scryfallId":"a54df527-6949-4b74-821b-b051f493f3c5"},{"index":49765,"token":false,"name":"Fall of the Impostor","scryfallId":"d7de696a-49c2-421d-a86c-bcffd68870c6"},{"index":49766,"token":false,"name":"Emissary of Sunrise","scryfallId":"0636cd47-d2a3-4320-97bf-40db805fca51"},{"index":49768,"token":false,"name":"Urban Burgeoning","scryfallId":"393c230f-5bc3-4b71-b5ac-81d5ce227df5"},{"index":49774,"token":false,"name":"Courier Griffin","scryfallId":"4d3afc71-f5db-45c3-96b2-8454b7f33542"},{"index":49777,"token":false,"name":"Saprazzan Outrigger","scryfallId":"b28048f1-4cf5-4389-9e69-9b5e1bc95396"},{"index":49781,"token":false,"name":"Whispering Snitch","scryfallId":"fa4ca97e-b402-4a73-9c70-79ec4565a39c"},{"index":49782,"token":false,"name":"Fire Urchin","scryfallId":"b3a843ff-6bd0-42d5-9348-44b774d438b1"},{"index":49786,"token":false,"name":"Giltspire Avenger","scryfallId":"5f1a67fd-6736-4f2b-8ed3-57a0a6afb98f"},{"index":49798,"token":false,"name":"Bequeathal","scryfallId":"20aae577-9683-4d9b-bfd5-52702b38d3a7"},{"index":49808,"token":false,"name":"Kithkin Healer","scryfallId":"44032574-a5bc-4366-af65-9824fd4302a2"},{"index":49810,"token":false,"name":"Sanctum Plowbeast","scryfallId":"73887514-7644-4b2b-8c67-4b7e64150478"},{"index":49830,"token":false,"name":"Ruin Ghost","scryfallId":"f0b60f10-0997-46ec-8914-f5cdde76cf75"},{"index":49836,"token":false,"name":"Press for Answers","scryfallId":"5ec8b8bf-7b02-4f5e-bbd3-9560f9888192"},{"index":49838,"token":false,"name":"Burning Earth","scryfallId":"1df3a7c9-5c8d-438c-a5ad-3c9754c6ea5d"},{"index":49841,"token":false,"name":"Felhide Spiritbinder","scryfallId":"bbbbe4ce-d6a6-428d-aeee-1c316f358777"},{"index":49847,"token":false,"name":"Volcanic Rambler","scryfallId":"7fc075ee-16e9-4cf5-bbb0-7b3b4b9eb3f4"},{"index":49855,"token":false,"name":"Goblin War Strike","scryfallId":"dce59945-37a2-4f09-8831-9d44b4a59ea7"},{"index":49856,"token":false,"name":"Autumnal Gloom // Ancient of the Equinox","scryfallId":"d41b07c8-f0c8-4654-bcc2-00c785c8c628"},{"index":49866,"token":false,"name":"Sage's Dousing","scryfallId":"75ccd5f6-b363-433f-9e98-f65e10b10bc9"},{"index":49871,"token":false,"name":"Pyromancer's Gauntlet","scryfallId":"9bde6763-2102-4adb-8048-fc9fe921205b"},{"index":49873,"token":false,"name":"Famished Ghoul","scryfallId":"e413b65a-700d-44eb-a880-5a0118d2ebac"},{"index":49877,"token":true,"name":"Goblin Token (R, 2/1)","scryfallId":"72230a1b-90ba-4564-9164-90cffdf34b93"},{"index":49881,"token":false,"name":"Viashino Spearhunter","scryfallId":"232226ab-918c-49b6-9f5b-fa0e0a1ba1d3"},{"index":49882,"token":false,"name":"Gnat Miser","scryfallId":"f1c51ee1-d6f6-42d7-9be6-fe3f982984ba"},{"index":49884,"token":false,"name":"Ageless Guardian","scryfallId":"4a5ff6af-402f-4bf6-a75b-dc1e0e40aff6"},{"index":49887,"token":false,"name":"Weirding Shaman","scryfallId":"fe1d40cc-2871-4a33-bc58-5250fd3d4f0e"},{"index":49888,"token":false,"name":"Violent Impact","scryfallId":"49b8673a-ce93-4881-b712-8db82446d83c"},{"index":49893,"token":false,"name":"Tangle Golem","scryfallId":"e9915977-bd6b-477a-a495-f7ddbbeb82eb"},{"index":49894,"token":false,"name":"Vedalken Outlander","scryfallId":"d75a7314-39f2-4e32-a5b0-ac1761b6d238"},{"index":49896,"token":false,"name":"Reptilian Reflection","scryfallId":"7871b4dd-9085-4a3f-a1ae-9a292f73689b"},{"index":49897,"token":false,"name":"Guided Passage","scryfallId":"e67b9195-1d5a-4cb8-94bf-018f0cf444b0"},{"index":49902,"token":false,"name":"Geth's Grimoire","scryfallId":"0a21d76d-d86c-4348-be45-f65167d2b5a9"},{"index":49904,"token":false,"name":"Reality Strobe","scryfallId":"8e6d881a-f7b1-471f-bc0b-64a79bb491c9"},{"index":49905,"token":false,"name":"Bitterheart Witch","scryfallId":"cf2ff2b4-8f40-42c0-af3c-b55bfa8839be"},{"index":49923,"token":false,"name":"Anvil of Bogardan","scryfallId":"7ff965dd-54b4-4f21-a52f-81c0dd1e691e"},{"index":49928,"token":false,"name":"Ventifact Bottle","scryfallId":"520f4a24-fb1a-4964-887c-2f08a752fae2"},{"index":49935,"token":false,"name":"Curse of Bloodletting","scryfallId":"9dc4ac6f-0005-47f8-bee9-10429cc542e4"},{"index":49941,"token":false,"name":"Pendrell Mists","scryfallId":"b902b972-3a93-4e4e-aa77-02ada81e6b95"},{"index":49952,"token":false,"name":"Walking Dream","scryfallId":"bd2f906d-b127-400a-809b-449f1e7f647b"},{"index":49959,"token":false,"name":"Arcanist's Owl","scryfallId":"b42e1359-c79d-4848-a0f1-3f274e0bf0d9"},{"index":49963,"token":false,"name":"Phyrexian Bloodstock","scryfallId":"785e1a67-af94-48e8-bb37-4999d1fb4c66"},{"index":49968,"token":false,"name":"Graf Rats // Chittering Host","scryfallId":"3dedaff6-bd69-4fe3-a301-f7ea7c2f2861"},{"index":49977,"token":false,"name":"Castaway's Despair","scryfallId":"b3a26ba9-84b8-4f54-918c-f75d4cacad0b"},{"index":49981,"token":false,"name":"Sand Golem","scryfallId":"84e4a955-ce9a-4386-b6ac-c00fd25de882"},{"index":49988,"token":false,"name":"Consul's Lieutenant","scryfallId":"301a1b68-2890-4702-a90e-bad8d309c40d"},{"index":49990,"token":false,"name":"Exultant Skymarcher","scryfallId":"fffe7b2b-22c3-4e6a-9b1b-c6d7b29b9f86"},{"index":50001,"token":false,"name":"Unravel the Aether","scryfallId":"5584c26f-62ac-4d0b-9142-5159f2a05734"},{"index":50007,"token":false,"name":"Ajani's Sunstriker","scryfallId":"3570c4d9-cd42-4aca-9421-ac44e057a785"},{"index":50009,"token":false,"name":"Tazeem Raptor","scryfallId":"299d60b9-0ba7-40ee-b9d0-ee8f1ea288c9"},{"index":50013,"token":false,"name":"Kronch Wrangler","scryfallId":"8f41d22a-ee37-4d69-a9ca-98c91315b9e6"},{"index":50015,"token":false,"name":"Poison Arrow","scryfallId":"6b7b5f34-c250-484e-9bae-94789b2a87fb"},{"index":50027,"token":false,"name":"Spectra Ward","scryfallId":"69c1b7a2-a4ff-485c-9fe5-04c88e5e8886"},{"index":50033,"token":false,"name":"Retributive Wand","scryfallId":"5521cb92-03b0-44ab-a141-40dc0eb5a79f"},{"index":50034,"token":false,"name":"Hagra Diabolist","scryfallId":"c303e7e2-cb22-4dea-889f-d03e2494ed0f"},{"index":50042,"token":false,"name":"Merfolk Trickster","scryfallId":"359b2f2b-7b58-47b6-b00c-8616f981e3a3"},{"index":50046,"token":false,"name":"Tectonic Hellion","scryfallId":"1b86be51-1b0b-49d0-917c-508f12c85c17"},{"index":50048,"token":false,"name":"Wrack with Madness","scryfallId":"4f27ee20-b5c5-4867-b832-9cdade0eda03"},{"index":50051,"token":true,"name":"Cat Soldier Token (W, 1/1)","scryfallId":"921d6192-6b6d-4aa1-be80-bc0b9f503e33"},{"index":50055,"token":false,"name":"Sandstorm Eidolon","scryfallId":"49e61ce3-e2cc-401c-b998-8baf8836e83a"},{"index":50067,"token":false,"name":"Whispergear Sneak","scryfallId":"e36074e7-d173-44a1-bde3-9a89293467b1"},{"index":50079,"token":false,"name":"Dwarven Shrine","scryfallId":"85197997-5e1a-46ce-8f0d-6da5ce297baf"},{"index":50087,"token":false,"name":"Spark Jolt","scryfallId":"6ee479c2-a115-450b-bc2e-b03d23b82f2d"},{"index":50105,"token":false,"name":"Master of the Hunt","scryfallId":"4e6bf56e-2d74-4e4d-a667-885853979377"},{"index":50107,"token":false,"name":"Lullmage Mentor","scryfallId":"e34de3df-3236-4281-a043-7583c76d89cc"},{"index":50109,"token":false,"name":"Ogre Berserker","scryfallId":"b6969d4d-c311-4663-bcd6-77a4d6458335"},{"index":50111,"token":false,"name":"Moonlace","scryfallId":"c781cc80-5f57-4677-a9da-3523191cc7c6"},{"index":50113,"token":false,"name":"Combine Guildmage","scryfallId":"3a6e2816-d50b-41a5-b503-faa58dc7c94a"},{"index":50115,"token":false,"name":"Pale Moon","scryfallId":"aeb282bb-d0b8-4822-8197-ff0523549309"},{"index":50132,"token":true,"name":"Thopter // Thopter Token (U, 1/1)","scryfallId":"2d844ee2-20a0-4071-bc2c-4a58ab1dc07f"},{"index":50139,"token":false,"name":"Enslaved Dwarf","scryfallId":"da5003a6-211e-43d3-9a3c-756496357163"},{"index":50140,"token":false,"name":"Verduran Emissary","scryfallId":"cf0a1951-4482-4ba0-b29e-2091adde0628"},{"index":50148,"token":false,"name":"Pouncing Wurm","scryfallId":"8e48a2f3-9c30-4187-868e-33dbf5e279fc"},{"index":50151,"token":false,"name":"Wine of Blood and Iron","scryfallId":"5f6f80dc-72a4-409b-bc92-69fa3885cd6d"},{"index":50152,"token":false,"name":"Gremlin Mine","scryfallId":"ccde7ebb-90de-4174-a1c5-75fc9384deaa"},{"index":50156,"token":false,"name":"Rakshasa's Secret","scryfallId":"59fbc345-fa8c-459b-97af-66baede950da"},{"index":50167,"token":false,"name":"Final Revels","scryfallId":"99f3744a-71c4-4a54-9e1c-92420526b792"},{"index":50168,"token":false,"name":"Corrosive Ooze","scryfallId":"d13deb9c-5985-4355-8716-ee1c7b54b8e2"},{"index":50174,"token":false,"name":"Edge of the Divinity","scryfallId":"ffd079d8-b191-4f54-bb04-427b3736f745"},{"index":50184,"token":false,"name":"Metathran Aerostat","scryfallId":"59f34850-fb6f-4ac5-8309-4d53d770e28c"},{"index":50185,"token":false,"name":"Akki Drillmaster","scryfallId":"7fb63254-5786-43fb-8ccd-132095a55e64"},{"index":50192,"token":false,"name":"Grasping Thrull","scryfallId":"56f82d97-ce50-490c-ad7f-46d70a73e454"},{"index":50193,"token":false,"name":"Blood Mist","scryfallId":"a6982bde-1fa3-48fa-803d-a45d6acbc2fe"},{"index":50201,"token":false,"name":"Kami of the Hunt","scryfallId":"5ace3c4e-3287-4975-b4d0-91f009c0cf5b"},{"index":50207,"token":false,"name":"Unity of Purpose","scryfallId":"6f87292c-0140-44d7-881e-2e8c9ff737a1"},{"index":50217,"token":false,"name":"Paranoid Parish-Blade","scryfallId":"16bb6c60-1889-49ed-8767-8144cc5a9571"},{"index":50218,"token":false,"name":"Mudbutton Clanger","scryfallId":"bc5e2771-ae35-4aff-a92d-7fc7f3ca915f"},{"index":50228,"token":false,"name":"Soultether Golem","scryfallId":"6efa61f0-c7bd-49e2-9d66-bf15ad0e9d03"},{"index":50232,"token":false,"name":"Setessan Battle Priest","scryfallId":"9c9cfa33-dcec-4b34-9218-c08ad932d27b"},{"index":50237,"token":false,"name":"Vampire Warlord","scryfallId":"7e07929b-450c-45b0-85e6-512ad280a122"},{"index":50243,"token":false,"name":"Sigiled Skink","scryfallId":"37f84b4d-82db-4e3a-a099-2e438c0a6418"},{"index":50245,"token":false,"name":"Benalish Emissary","scryfallId":"6b82d56e-80d7-4be9-ac22-de3257efc458"},{"index":50248,"token":false,"name":"Yavimaya Wurm","scryfallId":"25e6de28-d1f1-4225-a0e3-181992d1a614"},{"index":50249,"token":false,"name":"Spike Tiller","scryfallId":"caf3643a-502f-4736-8063-5b567bdfbcc4"},{"index":50250,"token":false,"name":"Taoist Hermit","scryfallId":"d818c231-8d66-4024-91de-fe29f8622902"},{"index":50252,"token":false,"name":"Oppressive Will","scryfallId":"abcb5e75-c7a1-41de-a952-05aefb115270"},{"index":50258,"token":false,"name":"Pyre Charger","scryfallId":"4998ac4f-b461-4ab8-9680-81c396df371a"},{"index":50259,"token":false,"name":"Ashen Rider","scryfallId":"602e43b1-1b1c-4eb1-be0a-61b673646c6f"},{"index":50260,"token":false,"name":"Heroic Defiance","scryfallId":"0dc1aa36-5d3b-4d25-9d54-937cdabf72a4"},{"index":50261,"token":false,"name":"Morkrut Necropod","scryfallId":"f726f215-d0a5-4e2c-b874-9dc209479993"},{"index":50266,"token":false,"name":"Angelic Exaltation","scryfallId":"ee7b5ae5-0f6b-4f45-8597-4e6212d2ad0e"},{"index":50272,"token":false,"name":"Muxus, Goblin Grandee","scryfallId":"2c716d10-2130-43b7-a939-349d437e1091"},{"index":50274,"token":false,"name":"Backslide","scryfallId":"47c40269-80a5-454f-83dd-dae1c11500c0"},{"index":50281,"token":false,"name":"Ferocious Pup","scryfallId":"2354cb24-5c70-4aaa-8636-46866f0950c1"},{"index":50290,"token":false,"name":"Grappling Sundew","scryfallId":"f74d8d76-8091-424d-ad11-e8a1faae584d"},{"index":50293,"token":false,"name":"Bring to Trial","scryfallId":"63d566fc-0936-4035-96fd-f8b0c4eadbf5"},{"index":50295,"token":false,"name":"Interdict","scryfallId":"3442c919-73b9-4d29-a014-87293f456325"},{"index":50299,"token":false,"name":"Femeref Enchantress","scryfallId":"20ba72c7-7957-4d02-b41e-c0132fe1f2e6"},{"index":50302,"token":false,"name":"Pterodon Knight","scryfallId":"41f00a04-1336-4830-a6c2-514848afefd2"},{"index":50307,"token":false,"name":"Infused Arrows","scryfallId":"f5fd2639-3c95-435d-8e94-cd4e4d069e3e"},{"index":50308,"token":false,"name":"Snow Hound","scryfallId":"084437ba-26d4-4af6-ab00-dcb145dd2cd0"},{"index":50325,"token":false,"name":"Plunder","scryfallId":"79cff220-b1a6-4da6-b765-25a583b33de2"},{"index":50326,"token":false,"name":"Monk Realist","scryfallId":"589d4058-a304-40a4-aa7d-0ebda2877d42"},{"index":50339,"token":false,"name":"Complete Disregard","scryfallId":"7d94e878-6c49-4420-9d34-f9ee64e811ba"},{"index":50349,"token":false,"name":"Phyresis","scryfallId":"0059d21b-0725-4806-8691-2451db36787f"},{"index":50351,"token":false,"name":"Will Kenrith","scryfallId":"be8061c6-21b8-4146-8917-c73a82060ffe"},{"index":50363,"token":false,"name":"Rustmouth Ogre","scryfallId":"3f8bd0c9-6b3a-489e-bf4d-b2062d530b55"},{"index":50364,"token":false,"name":"Skymark Roc","scryfallId":"60601296-2229-4c48-94cc-1903926750ce"},{"index":50366,"token":false,"name":"Trusted Forcemage","scryfallId":"3ee66ef9-10a7-4aab-88f7-84956811cc6c"},{"index":50372,"token":false,"name":"Bant Sojourners","scryfallId":"eff007af-0329-4872-8621-41e90d9f06e6"},{"index":50377,"token":false,"name":"Humbler of Mortals","scryfallId":"f12149b9-b450-4ad6-ab5d-9a0eeb36997e"},{"index":50381,"token":false,"name":"Ravager's Mace","scryfallId":"af484140-57d6-4505-9960-5e7b0306cc9b"},{"index":50385,"token":false,"name":"Time to Reflect","scryfallId":"b60ec4f7-7cf1-4b97-906b-536ab89b12be"},{"index":50387,"token":false,"name":"Pyroconvergence","scryfallId":"6cff95b7-79eb-4796-9a01-31ff355681ab"},{"index":50388,"token":false,"name":"Battle Strain","scryfallId":"ee1be893-1287-40a3-81d6-271df3154b45"},{"index":50389,"token":false,"name":"Rhystic Shield","scryfallId":"49af7b3f-f56a-4102-b398-5c215dd4fa11"},{"index":50403,"token":false,"name":"Woodland Sleuth","scryfallId":"3088a924-58c6-4ab7-baf0-842d6688fcec"},{"index":50404,"token":false,"name":"Dralnu's Crusade","scryfallId":"6a35d227-4489-4a0b-8f81-eb8e5949e1fc"},{"index":50406,"token":false,"name":"Junk Golem","scryfallId":"c9410da0-5693-456f-afa8-cb92ac176847"},{"index":50419,"token":false,"name":"Spawnwrithe","scryfallId":"1acb4d61-f308-423f-8cf6-eb057b994d01"},{"index":50423,"token":false,"name":"Ghost Tactician","scryfallId":"56ab366c-085b-4b13-b5ad-918965c34d22"},{"index":50439,"token":false,"name":"Grow from the Ashes","scryfallId":"51d4d1c2-671c-498c-a232-7d076e3dc3bb"},{"index":50446,"token":false,"name":"Increasing Confusion","scryfallId":"13f5bcdc-70bb-4d67-99e1-282f166ee4bf"},{"index":50449,"token":true,"name":"Weird // Goblin Token (U, 3/3)","scryfallId":"1d34ff67-24e1-4cf5-b032-8be6b83e0819"},{"index":50451,"token":false,"name":"Daring Thief","scryfallId":"c9d9378d-e553-48b5-8a23-59a35329eda2"},{"index":50455,"token":false,"name":"Sedris, the Traitor King","scryfallId":"70206cff-9f54-4e27-982c-b0093a51d358"},{"index":50458,"token":false,"name":"Silverbeak Griffin","scryfallId":"36b4c374-42a4-4912-8a74-a11c3fa0e065"},{"index":50460,"token":false,"name":"Essence Backlash","scryfallId":"a98609dc-ea90-4c7e-a191-5e5d0ba16847"},{"index":50467,"token":false,"name":"Marang River Skeleton","scryfallId":"9497f7e6-2121-44a9-9bd6-258685636b1c"},{"index":50469,"token":false,"name":"Bound in Gold","scryfallId":"074d526a-1eef-4045-bd38-f6d68c4bc4b9"},{"index":50471,"token":false,"name":"Underworld Sentinel","scryfallId":"d8c7aa89-3777-49ec-a6d0-c568150864e8"},{"index":50472,"token":false,"name":"Magus of the Library","scryfallId":"899db99b-df27-4848-a23d-5c645deae450"},{"index":50477,"token":false,"name":"Gaze of Justice","scryfallId":"24d565ec-541d-429e-ab45-58db16c2f41d"},{"index":50481,"token":false,"name":"Thought Courier","scryfallId":"837b6315-d5c6-480b-902e-44107a72b581"},{"index":50485,"token":false,"name":"Chimeric Staff","scryfallId":"9ca0425d-f41c-4ba5-ac06-9ce5bab2a4b9"},{"index":50487,"token":false,"name":"Blaze Commando","scryfallId":"5e179f0d-2965-44e4-8483-67b330a8608c"},{"index":50491,"token":false,"name":"Spear of Heliod","scryfallId":"34ef01da-d311-4d4f-9f7b-328e7bb17db4"},{"index":50496,"token":false,"name":"Tomorrow, Azami's Familiar","scryfallId":"095813f9-d559-40bd-a50f-7c1f6e494e60"},{"index":50498,"token":false,"name":"Echoing Decay","scryfallId":"f8e688e7-8350-4b78-bd49-a6ffdedad556"},{"index":50507,"token":false,"name":"Hidden Gibbons","scryfallId":"8f94da51-b4d9-4d79-9113-39f8f4a1be34"},{"index":50509,"token":false,"name":"Cannibalize","scryfallId":"9cdf1311-1660-4ad0-a383-f3ff508ff574"},{"index":50511,"token":false,"name":"Fated Retribution","scryfallId":"8158b330-2868-4147-907e-4d86e44cfaad"},{"index":50512,"token":false,"name":"Aquatic Incursion","scryfallId":"56cb8fa2-337b-4596-9c31-01f0c0b171b7"},{"index":50516,"token":false,"name":"Glimmerdust Nap","scryfallId":"e05a4ce4-dbd5-4c47-8b40-c145c7f5d06c"},{"index":50518,"token":false,"name":"Forerunner of the Coalition","scryfallId":"b499fc26-26b0-4b0f-9c62-5ed599baf41d"},{"index":50522,"token":false,"name":"Grim Captain's Call","scryfallId":"0055934f-1567-4207-aaad-d32d0fe1cdba"},{"index":50536,"token":false,"name":"Necromancer's Assistant","scryfallId":"8b6a8b3e-2709-4036-838b-56cc82b0d917"},{"index":50537,"token":false,"name":"Savage Smash","scryfallId":"4ca942d7-a3a3-429f-a159-fc2363d9bca6"},{"index":50539,"token":false,"name":"Abyssal Nightstalker","scryfallId":"0b688039-7441-490b-ad06-8a72086c4023"},{"index":50540,"token":false,"name":"Ridge Rannet","scryfallId":"4275a8dd-f777-4160-b773-9a868e743218"},{"index":50541,"token":false,"name":"Behemoth's Herald","scryfallId":"b51e84d7-bf9f-454f-bdcd-a2458b1b5b33"},{"index":50553,"token":false,"name":"War-Wing Siren","scryfallId":"8d88c942-3a69-4975-a08d-80405a549beb"},{"index":50563,"token":false,"name":"Carrion Wurm","scryfallId":"37c2b228-94c0-4e84-ad6d-80b170bb6c0c"},{"index":50564,"token":false,"name":"Sanguine Praetor","scryfallId":"63592f59-60b3-4779-8dbb-12bbffbc100b"},{"index":50565,"token":false,"name":"Silverbluff Bridge","scryfallId":"d80dc025-c2c4-48c2-8354-7d9ddb430eb9"},{"index":50571,"token":false,"name":"Vigilance","scryfallId":"d24dc353-abc9-430a-a7f5-5da3b38cd411"},{"index":50580,"token":false,"name":"Dedicated Martyr","scryfallId":"d1f95b64-858b-4344-84a2-3afa5c7b9ee9"},{"index":50591,"token":false,"name":"Shield of the Avatar","scryfallId":"97c2cc25-f3cd-4bfb-b9cc-53d1f42cd69a"},{"index":50594,"token":false,"name":"Tranquil Path","scryfallId":"2da8c059-3309-49a5-ae97-c048aefc922f"},{"index":50598,"token":false,"name":"Torrent of Stone","scryfallId":"18d00132-6c25-42d3-bfe5-5f893b63a292"},{"index":50599,"token":false,"name":"Greel's Caress","scryfallId":"5b25ce3f-fab3-40f8-8a16-fe580f3d97a5"},{"index":50601,"token":false,"name":"Taunting Challenge","scryfallId":"4620867c-a3a6-4c81-b923-24007367132e"},{"index":50602,"token":false,"name":"Dosan the Falling Leaf","scryfallId":"ffb190db-48fc-4c39-ae9f-5e304eabb4f4"},{"index":50610,"token":false,"name":"Renegade Doppelganger","scryfallId":"f6453040-38a3-4d3a-8e4b-51b72aa80186"},{"index":50626,"token":false,"name":"Scouting Trek","scryfallId":"1b882e68-5c03-4ec6-9982-8c3b09847969"},{"index":50628,"token":false,"name":"Start Your Engines","scryfallId":"bbae1eb8-697d-43e1-b03e-f4246a9f225e"},{"index":50632,"token":false,"name":"Hired Giant","scryfallId":"dc33920a-f05c-46fa-b94b-278af0022b78"},{"index":50642,"token":false,"name":"Decimator Web","scryfallId":"fa1fe29f-cf84-45d3-b8fe-e4de1d2bebbf"},{"index":50643,"token":false,"name":"Worldly Counsel","scryfallId":"8fc66fbf-f411-4607-aece-7c35d9a07c80"},{"index":50650,"token":false,"name":"Giant Turtle","scryfallId":"87e5fc19-3b10-476f-9a73-e8bf4b5fbec0"},{"index":50656,"token":false,"name":"Crystacean","scryfallId":"32afec8a-dbae-446e-919a-3efb556f5cb1"},{"index":50658,"token":false,"name":"Accursed Horde","scryfallId":"709bcbca-7238-4c31-8d9e-ec0d54d0b298"},{"index":50659,"token":false,"name":"Inspiring Cleric","scryfallId":"31b8f1da-c8ea-41d5-b1ad-b714c22d3683"},{"index":50669,"token":false,"name":"Burn from Within","scryfallId":"f8bdc165-4c6f-47e6-8bda-877c0be3613b"},{"index":50671,"token":false,"name":"Fractured Loyalty","scryfallId":"5c7ce5d5-e51a-4dbc-82f2-b79c88769a7b"},{"index":50673,"token":false,"name":"Thunder Totem","scryfallId":"5fc332da-e93f-45b1-912c-06af41b412e9"},{"index":50685,"token":false,"name":"Pestilent Haze","scryfallId":"08b78aa8-a63a-4aa2-bb82-3fbf2595ed7c"},{"index":50689,"token":false,"name":"Hazoret's Monument","scryfallId":"7a0a70f2-f2cb-4a08-a1a7-95c8fc3de6e3"},{"index":50693,"token":false,"name":"Aura Fracture","scryfallId":"de8d3e36-977f-4169-8f2a-a4057b912ccb"},{"index":50699,"token":false,"name":"Exiled Boggart","scryfallId":"5fe41509-02db-415c-964e-971ea1d5485c"},{"index":50701,"token":false,"name":"Flutterfox","scryfallId":"769cddf0-2078-456b-a622-057571464fe7"},{"index":50702,"token":false,"name":"Overgrown Estate","scryfallId":"c1c48c58-3532-4022-9eec-1a870385cbf3"},{"index":50703,"token":false,"name":"Spellgorger Barbarian","scryfallId":"043fcf80-dd20-4cc2-a0d5-4bb22b8b0789"},{"index":50706,"token":false,"name":"Shinechaser","scryfallId":"f6d5314b-4994-4cd0-a680-12e56be7c1e2"},{"index":50709,"token":false,"name":"Urza's Engine","scryfallId":"273b54c3-325b-4f2e-857b-fc1d59b6b3c5"},{"index":50713,"token":false,"name":"Crystalline Nautilus","scryfallId":"88a60d25-b97f-40e7-a5ac-c456cee02aeb"},{"index":50721,"token":false,"name":"Oath of Lim-Dûl","scryfallId":"f16df768-06de-43a0-b548-44fb0887490b"},{"index":50722,"token":false,"name":"On Thin Ice","scryfallId":"b7d4f6b0-ea17-4374-a80c-ba4dd207e9d6"},{"index":50724,"token":false,"name":"Spinal Villain","scryfallId":"44134b59-af94-42a0-9696-2d0181ff7887"},{"index":50730,"token":false,"name":"Whiptongue Hydra","scryfallId":"9c007d0b-1100-404a-beb2-f484aeae2e22"},{"index":50732,"token":false,"name":"Setessan Tactics","scryfallId":"385a1939-15e5-4f13-b01b-7cdc6835da2a"},{"index":50739,"token":false,"name":"Tresserhorn Sinks","scryfallId":"4bd8fe2c-2297-4e19-8a87-01eb99b8c6dc"},{"index":50744,"token":false,"name":"Teller of Tales","scryfallId":"c914db7d-c907-4d25-a180-f68b274a5cb7"},{"index":50754,"token":false,"name":"Timesifter","scryfallId":"561cab0e-8874-4534-bf79-0c1488a9f0a5"},{"index":50778,"token":false,"name":"Might Beyond Reason","scryfallId":"5a274689-82f1-488a-baf8-cd8ef3477b72"},{"index":50789,"token":false,"name":"Quest for Renewal","scryfallId":"41b7ad82-1115-4f80-886a-3f59f568423f"},{"index":50795,"token":false,"name":"Courier Hawk","scryfallId":"d06a2fb5-248d-4d2d-aa06-f325d786e949"},{"index":50804,"token":true,"name":"Golem Token (Colorless, 4/4)","scryfallId":"a7820eb9-6d7f-4bc4-b421-4e4420642fb7"},{"index":50805,"token":false,"name":"Numai Outcast","scryfallId":"b878d1c2-34ce-4cb4-9ea3-8d7cd2028484"},{"index":50811,"token":false,"name":"Luminate Primordial","scryfallId":"b0747b12-c75a-4fdf-a881-f2383a23ccdd"},{"index":50814,"token":false,"name":"School of the Unseen","scryfallId":"1438606d-556d-4b96-9662-fcac051af045"},{"index":50825,"token":true,"name":"Troll Warrior Token (G, 4/4)","scryfallId":"8869a8cc-d196-417f-bba5-5ed31bae6a18"},{"index":50836,"token":false,"name":"Forerunner of the Heralds","scryfallId":"30bc2bd2-adfc-490e-998a-303598e6a942"},{"index":50837,"token":false,"name":"Mirror Sheen","scryfallId":"e26b31ce-416f-4309-b591-798cf12175af"},{"index":50840,"token":false,"name":"Charging War Boar","scryfallId":"02cef5a4-e8fd-4ebd-b121-67059308c772"},{"index":50849,"token":false,"name":"Arc-Slogger","scryfallId":"d3dd67e0-72b4-4c55-b49b-c69950feccb1"},{"index":50854,"token":false,"name":"Senseless Rage","scryfallId":"9c779cb6-3454-4d5a-85a1-bea5cf8005b1"},{"index":50858,"token":false,"name":"Mtenda Herder","scryfallId":"51f30a3d-1421-4706-b17f-39a9ec7a0d8b"},{"index":50872,"token":false,"name":"Crackleburr","scryfallId":"2be19f23-5db4-4d50-a9d7-622e247ff0ab"},{"index":50882,"token":false,"name":"Pemmin's Aura","scryfallId":"9fb3e38b-086e-4fbc-b7b1-8564c18276d7"},{"index":50883,"token":false,"name":"Mire Blight","scryfallId":"1e63238d-a022-4ea1-a83d-0b2260d56a17"},{"index":50884,"token":false,"name":"So Tiny","scryfallId":"421650f2-1b34-4a36-9675-9424997c9d0b"},{"index":50885,"token":false,"name":"Dwarven Nomad","scryfallId":"30b09e65-5e69-48f8-be9b-a1e9706f18bf"},{"index":50890,"token":false,"name":"Mindscour Dragon","scryfallId":"c5708290-60ae-400c-b149-2a63153c2890"},{"index":50901,"token":false,"name":"Cylian Sunsinger","scryfallId":"90665426-118e-4f0b-8222-1b516678a2f5"},{"index":50903,"token":false,"name":"Blood Scrivener","scryfallId":"9ea8179a-d3c9-4cdc-a5b5-68cc73279050"},{"index":50904,"token":false,"name":"Aura Thief","scryfallId":"8ae591d2-b9d3-4bc5-bcec-5d3d79a13b41"},{"index":50905,"token":false,"name":"Capashen Templar","scryfallId":"0976a193-463a-4bcb-a951-ca73347a5572"},{"index":50909,"token":false,"name":"Duergar Cave-Guard","scryfallId":"f48fda3d-5e6f-4f32-8fca-030521f6df98"},{"index":50910,"token":false,"name":"Demonlord of Ashmouth","scryfallId":"785da9a3-09af-45aa-bc04-4ab69cfb2ba4"},{"index":50922,"token":false,"name":"Dark Remedy","scryfallId":"5c926d38-a741-47a9-8961-f5bcf2909939"},{"index":50924,"token":false,"name":"Command of Unsummoning","scryfallId":"e61b97fc-fa42-40a6-918e-e06383bfcae3"},{"index":50926,"token":false,"name":"Torii Watchward","scryfallId":"b8ec0916-f320-4fad-9ec5-99aeecfda0e3"},{"index":50927,"token":false,"name":"Fever Charm","scryfallId":"830d1980-f460-4be2-9379-c3f74c8318f3"},{"index":50940,"token":false,"name":"Lieutenant Kirtar","scryfallId":"e518750f-492d-4575-b4ee-c80c1f8e0a58"},{"index":50942,"token":false,"name":"Blockbuster","scryfallId":"00a28b9d-1bd2-4ca4-a1e1-4138891d6739"},{"index":50948,"token":false,"name":"Capital Punishment","scryfallId":"051830bb-1baa-4c11-9177-efcd908fbcaf"},{"index":50949,"token":false,"name":"Sewerdreg","scryfallId":"b216ad4e-29b4-4e03-8c16-5796277bd05f"},{"index":50951,"token":false,"name":"Devout Harpist","scryfallId":"985b5c60-8a5e-4473-ba43-583aef50f19e"},{"index":50955,"token":false,"name":"Crystal Slipper","scryfallId":"9f738ca6-5254-4dbc-9f59-854e81c8dac2"},{"index":50959,"token":true,"name":"Fish // Kraken Token (U, 3/3)","scryfallId":"8ce300b8-ab50-4c96-ba05-30701a249230"},{"index":50961,"token":false,"name":"Drakestown Forgotten","scryfallId":"b718304a-2cbd-4870-9281-f82cdc08ce20"},{"index":50962,"token":false,"name":"Medicine Runner","scryfallId":"97638795-0771-4862-9afc-dbbbfd39515c"},{"index":50963,"token":false,"name":"Fluxcharger","scryfallId":"7c58f6ed-2544-4b58-8dc0-a0a37b9547e6"},{"index":50967,"token":false,"name":"Rampaging Monument","scryfallId":"b5fbe445-a788-4624-8ecf-8bc06c3ca8f8"},{"index":50986,"token":false,"name":"Parallax Dementia","scryfallId":"154789ac-bbea-467b-9655-76f378a53f40"},{"index":50990,"token":false,"name":"Hell Swarm","scryfallId":"64164d1b-75f4-456e-a717-90ce554dc16c"},{"index":50994,"token":false,"name":"Frightful Delusion","scryfallId":"38c9ba98-90b4-4c28-9eef-a4fe0913b921"},{"index":51001,"token":false,"name":"Gorgon's Head","scryfallId":"d745dd92-9f7a-44a4-a27f-2ff17753db1c"},{"index":51016,"token":false,"name":"Thriving Ibex","scryfallId":"8edc7c57-9298-4fad-a0c2-4b75b944e2ce"},{"index":51034,"token":false,"name":"Unnatural Hunger","scryfallId":"3985f240-4289-4d48-978c-bb2ce2b54c36"},{"index":51038,"token":true,"name":"Boar Token (G, 3/3)","scryfallId":"83dcacd3-8707-4354-a1a5-9863d677d67f"},{"index":51051,"token":false,"name":"Aspiring Aeronaut","scryfallId":"1ae6c87f-003b-44b7-96fd-ab8fca9af6f1"},{"index":51058,"token":false,"name":"Cunning Sparkmage","scryfallId":"699842c1-6507-48ee-b98b-3774d1f07c76"},{"index":51060,"token":false,"name":"Battlewand Oak","scryfallId":"8a128ea6-cd00-4410-8dc4-cf66ce6f0fa1"},{"index":51062,"token":false,"name":"Spectral Lynx","scryfallId":"13099abe-721e-42b4-9666-9e6b5f1d75c9"},{"index":51074,"token":false,"name":"Harrier Griffin","scryfallId":"2781696e-e70c-4c96-b3aa-75be51cdc68e"},{"index":51075,"token":false,"name":"Matsu-Tribe Decoy","scryfallId":"14bf9bec-9a5d-48a6-941b-95e1633b9484"},{"index":51079,"token":false,"name":"Triumph of Gerrard","scryfallId":"3416fae7-46a0-4048-b969-9cf95bac09db"},{"index":51085,"token":false,"name":"Spellweaver Volute","scryfallId":"e1f68dbf-81f2-4c81-af93-92c9a28693eb"},{"index":51089,"token":false,"name":"Illusionist's Bracers","scryfallId":"cc06cf32-5d66-4772-845d-ff7649396092"},{"index":51094,"token":false,"name":"Ward Sliver","scryfallId":"e264369a-ab81-4938-9fa6-7c3e069442f4"},{"index":51099,"token":false,"name":"Shoreline Salvager","scryfallId":"17d87345-9f89-4b65-ae9c-a0f46b1e9f31"},{"index":51110,"token":false,"name":"Spear Spewer","scryfallId":"dbee1daa-b4ba-49ee-bed1-e70fa09942a2"},{"index":51118,"token":false,"name":"Durable Handicraft","scryfallId":"28d5e2ff-dc8a-4ed5-989a-4b4b79591b3f"},{"index":51129,"token":false,"name":"Ghostly Flame","scryfallId":"6314344b-6493-4142-9c76-da9b90b8d3e1"},{"index":51130,"token":false,"name":"Rollick of Abandon","scryfallId":"3f1a80c4-8119-437d-bf5b-549c5679c90a"},{"index":51131,"token":false,"name":"Halimar Wavewatch","scryfallId":"0ff68d2f-6758-45ee-8109-4e8909f49de8"},{"index":51132,"token":false,"name":"Vortex Runner","scryfallId":"bab4a68d-5d26-42d8-bc51-15e3c1f95ebe"},{"index":51138,"token":false,"name":"Abuna's Chant","scryfallId":"b9e0bf63-0399-40d6-9162-4562d7bcdd0e"},{"index":51150,"token":true,"name":"Weird // Goblin Token (G, 1/1)","scryfallId":"1d34ff67-24e1-4cf5-b032-8be6b83e0819"},{"index":51154,"token":false,"name":"Ertai's Meddling","scryfallId":"35c7e7fa-1493-4ef8-9cdb-b02b07a1ad85"},{"index":51156,"token":false,"name":"Ridgetop Raptor","scryfallId":"1013cbc4-09f4-484f-b328-9f7403225149"},{"index":51157,"token":false,"name":"Glinting Creeper","scryfallId":"1bad2438-0b98-4b07-bba9-dff26aa1fc3a"},{"index":51168,"token":false,"name":"Needlethorn Drake","scryfallId":"9c0cf2c4-723e-46c4-b2aa-4c957177209a"},{"index":51173,"token":false,"name":"Dissension in the Ranks","scryfallId":"2c1b563a-7856-40bf-954a-a0110ed4880d"},{"index":51180,"token":false,"name":"Lifecraft Awakening","scryfallId":"63bc60c8-f0a3-4bbf-b570-7d98d0a3e2b0"},{"index":51188,"token":false,"name":"Reprobation","scryfallId":"b1349c3d-39ad-40ba-897e-59e5b76de853"},{"index":51190,"token":false,"name":"Seed the Land","scryfallId":"ec1b0a4e-e52e-4d4e-9b12-24676d8571b1"},{"index":51192,"token":false,"name":"Harvest Pyre","scryfallId":"4d6220b4-a5b8-45c8-9422-fab9eb32322c"},{"index":51197,"token":false,"name":"Razortip Whip","scryfallId":"24619d3f-1051-4d8e-9c8d-70a12621b282"},{"index":51198,"token":false,"name":"Maze Glider","scryfallId":"d1d20281-49c0-4fd0-91f2-390506ac33f6"},{"index":51200,"token":false,"name":"Mark of Eviction","scryfallId":"ae826236-e591-4afb-817b-0017a11010ad"},{"index":51201,"token":false,"name":"Eyes of the Wisent","scryfallId":"c6725b96-7390-4599-9d5f-ba08755605af"},{"index":51202,"token":false,"name":"Mindeye Drake","scryfallId":"947f44b0-91be-4115-b499-57893f0f69a9"},{"index":51205,"token":false,"name":"Medomai's Prophecy","scryfallId":"3d2bd7b4-28de-4d9e-86c5-a46bd608cb02"},{"index":51206,"token":false,"name":"Jace, the Living Guildpact","scryfallId":"99713bb4-186f-42b6-aa66-e94ec8858e6a"},{"index":51217,"token":false,"name":"Aphetto Grifter","scryfallId":"3a7a7bf3-1b0c-415d-9c57-73ac55b1f915"},{"index":51220,"token":false,"name":"Havoc","scryfallId":"d7b032a1-6e43-4e22-9efa-43cfbf211e1c"},{"index":51226,"token":false,"name":"Eyeless Watcher","scryfallId":"4d949d0e-baf7-4573-bb15-7e30e3e9b202"},{"index":51239,"token":false,"name":"Oread of Mountain's Blaze","scryfallId":"0f9bb73a-5b4e-4c9b-b0a6-8e531dc27394"},{"index":51240,"token":true,"name":"Nicolas Labarre Decklist","scryfallId":"a3194e3a-b70c-4171-9e93-4d8cbb67bfe1"},{"index":51241,"token":false,"name":"Kithkin Zephyrnaut","scryfallId":"8671abe8-4333-4b23-a87e-58bcc65deef2"},{"index":51246,"token":false,"name":"Diamond Knight","scryfallId":"eeab4819-dd26-4f5c-8538-50f2caca292d"},{"index":51249,"token":false,"name":"Realmwright","scryfallId":"989c76b2-d130-443d-8534-6525fef404c2"},{"index":51255,"token":false,"name":"Aven Trooper","scryfallId":"79c8f774-6d4f-4fd0-85c0-26ef713e6b89"},{"index":51266,"token":false,"name":"Melesse Spirit","scryfallId":"8292b6e7-92ac-4bbb-906c-1fe47e260a24"},{"index":51267,"token":false,"name":"Benalish Heralds","scryfallId":"13c6e51d-54eb-4e5b-9ec9-54521b16b8d1"},{"index":51275,"token":false,"name":"Kurgadon","scryfallId":"52a1758c-849a-4de3-b674-857c3c9bf399"},{"index":51281,"token":false,"name":"Dromoka's Gift","scryfallId":"a356afb6-19d7-459a-84ca-090924d45387"},{"index":51282,"token":false,"name":"Yisan, the Wanderer Bard","scryfallId":"65cd97cd-6d6e-4512-a050-6851b7527567"},{"index":51285,"token":false,"name":"Geometric Nexus","scryfallId":"3f200a52-ecf6-4890-9307-e9296080ff9a"},{"index":51307,"token":false,"name":"Trigon of Infestation","scryfallId":"be409a80-846c-4883-8aee-c2e3f973fc0f"},{"index":51310,"token":false,"name":"Grifter's Blade","scryfallId":"7de142b9-3f6a-4dc5-8164-b60c73fc576e"},{"index":51318,"token":false,"name":"Highborn Vampire","scryfallId":"24c40082-516e-4381-a4cc-e61c5a9a6cac"},{"index":51322,"token":false,"name":"Ukkima, Stalking Shadow","scryfallId":"c44cfa67-6276-4d23-9f25-a0576bfe1d25"},{"index":51323,"token":false,"name":"Saprazzan Raider","scryfallId":"62493f34-cea8-4d9f-8781-005947b69c9d"},{"index":51333,"token":false,"name":"Balshan Griffin","scryfallId":"529c5440-e31f-40be-9e66-699d17049fb4"},{"index":51336,"token":false,"name":"Wanderbrine Rootcutters","scryfallId":"ab739d64-cdcd-4f07-9854-e067c37c4f41"},{"index":51342,"token":false,"name":"Wandering Graybeard","scryfallId":"ea5c82f9-4bc5-4326-92c0-d2aa4b4838a5"},{"index":51358,"token":false,"name":"Lingering Phantom","scryfallId":"2316239e-8fe6-467f-87e6-a3f4d19b860e"},{"index":51359,"token":false,"name":"Essence Harvest","scryfallId":"7c3fac03-a019-4faa-bc1c-09e3a394fff7"},{"index":51362,"token":false,"name":"Neurok Hoversail","scryfallId":"0fa5790b-5388-4bf9-9caa-44d8cbb64708"},{"index":51363,"token":false,"name":"Saprazzan Bailiff","scryfallId":"a9f50964-1b57-426a-ac46-c90c045c7e40"},{"index":51371,"token":false,"name":"Numbing Dose","scryfallId":"8f28a0f4-43e1-46df-8b6a-d588c5cceb88"},{"index":51380,"token":false,"name":"Mask of Intolerance","scryfallId":"f623ae51-5f15-4153-b2ed-d03b57b7db54"},{"index":51381,"token":false,"name":"Reject","scryfallId":"d77f0731-fb40-4dc2-8530-afcb5ce1f27f"},{"index":51389,"token":false,"name":"Waiting in the Weeds","scryfallId":"5f91ec4e-6818-46f4-94da-f3f8c4489fb2"},{"index":51390,"token":false,"name":"Practical Research","scryfallId":"74edd3e3-b2de-4ba0-a508-0418b0151d87"},{"index":51394,"token":false,"name":"Garbage Fire","scryfallId":"4d76b91e-e79c-4c7e-ae3c-2b27b7e871ef"},{"index":51396,"token":false,"name":"Scarwood Goblins","scryfallId":"5542d236-af43-43b8-b30f-8980d74bbdd0"},{"index":51398,"token":false,"name":"Pearl Shard","scryfallId":"abde295d-af41-4b9c-af48-3067befe9383"},{"index":51403,"token":false,"name":"Rot Wolf","scryfallId":"0b08563c-1a00-4d9d-8e4f-13e4b9b0629f"},{"index":51404,"token":false,"name":"Magnigoth Treefolk","scryfallId":"90c2869b-43cf-4d5e-8a54-9ae200f5bff9"},{"index":51405,"token":false,"name":"Rekindled Flame","scryfallId":"131c6377-4ed4-4a76-a9cb-be7ad17d76fd"},{"index":51406,"token":true,"name":"Merfolk Wizard Token (U, 1/1)","scryfallId":"526da544-23dd-42b8-8c00-c3609eea4489"},{"index":51407,"token":false,"name":"Rith's Grove","scryfallId":"740fa25d-9c1f-44eb-9eb4-0dd514cb315a"},{"index":51408,"token":false,"name":"Braidwood Cup","scryfallId":"c2e783b7-9bd1-4f82-bf20-5d201413f5e8"},{"index":51410,"token":false,"name":"Ashling's Prerogative","scryfallId":"d850d95e-ba27-49cc-aa7a-42508852fe20"},{"index":51411,"token":false,"name":"Fireblade Charger","scryfallId":"ca657846-f352-4ac4-b2b3-d0ced6607163"},{"index":51414,"token":false,"name":"Thornhide Wolves","scryfallId":"89f6b21d-a228-498d-86ef-ed8a1a8e22ed"},{"index":51421,"token":false,"name":"Spoils of War","scryfallId":"b38af8bd-d927-46d0-a1b1-fb437ea9ea66"},{"index":51423,"token":false,"name":"Jackalope Herd","scryfallId":"cb80105c-d2c0-4f8c-9302-5e6152a60f54"},{"index":51424,"token":false,"name":"Mask of Riddles","scryfallId":"8cc0c40f-1d6c-4940-9c0a-566458a8ab04"},{"index":51438,"token":false,"name":"Not Forgotten","scryfallId":"66ecdadf-56f7-4dfb-9c3c-7d240ba19b00"},{"index":51441,"token":false,"name":"Blacksmith's Skill","scryfallId":"37304f74-a925-444c-bff6-7811f7f06966"},{"index":51448,"token":false,"name":"Vile Deacon","scryfallId":"b2641bd5-c845-47a1-8038-bb28b06f896e"},{"index":51451,"token":false,"name":"Torpid Moloch","scryfallId":"7900ff91-0e47-4903-a680-9031f4a23cb4"},{"index":51455,"token":false,"name":"Choking Vines","scryfallId":"6cc4a7ee-f6f0-454a-9074-5988fdee1f34"},{"index":51462,"token":false,"name":"Ooze Flux","scryfallId":"e9554369-7961-4cea-9da0-a1235805a26a"},{"index":51463,"token":false,"name":"Konda's Hatamoto","scryfallId":"83425cf6-f6ad-4302-8f07-099eabdd4b40"},{"index":51477,"token":false,"name":"Thunderous Might","scryfallId":"d361851d-e2d4-4912-ba08-81913f6b6e08"},{"index":51481,"token":false,"name":"Beloved Princess","scryfallId":"4c6ee4eb-70b2-4f99-9d54-5caf2d3713be"},{"index":51486,"token":true,"name":"Vampire // Vampire","scryfallId":"5d9e999f-7033-4ccd-933a-eac4105b3edc"},{"index":51503,"token":false,"name":"Juju Bubble","scryfallId":"a5fa8208-7d65-4f8f-b07e-f5c3a66e1143"},{"index":51511,"token":false,"name":"Screeching Drake","scryfallId":"6c16faac-b093-425b-b1e9-f71602d2f6dd"},{"index":51512,"token":false,"name":"Polis Crusher","scryfallId":"80874006-d057-49b8-981c-1d685ad1474b"},{"index":51514,"token":false,"name":"Rishadan Brigand","scryfallId":"a6efb653-97d8-4bc7-af8f-0b09fda655ff"},{"index":51529,"token":false,"name":"Conclave Guildmage","scryfallId":"279e551d-3ac3-48d5-9822-1d05159c8905"},{"index":51538,"token":false,"name":"Raiding Party","scryfallId":"907a3396-706b-4ca2-9973-bca758986032"},{"index":51540,"token":false,"name":"Apathy","scryfallId":"adf3a6fe-e234-4c3f-96fc-3eb5eb22c0b8"},{"index":51541,"token":false,"name":"Neck Snap","scryfallId":"fc326b79-363e-4c14-86e4-23041f2d6b4f"},{"index":51558,"token":false,"name":"Urborg Shambler","scryfallId":"eaedd5c8-03c6-4bbb-bf83-632551830bd4"},{"index":51563,"token":false,"name":"Twin Bolt","scryfallId":"5bd58ec4-34a9-4fc2-b057-438492e2e06e"},{"index":51571,"token":false,"name":"Nyxborn Courser","scryfallId":"0fd32240-c003-4e18-adf1-e2e992c702b1"},{"index":51574,"token":false,"name":"Spectral Grasp","scryfallId":"16aebed7-3dd8-4f76-94fc-da3c0e5251ba"},{"index":51582,"token":false,"name":"Sunscourge Champion","scryfallId":"f0bb41cc-6edb-4a31-92cb-b17850b49432"},{"index":51585,"token":false,"name":"Peregrination","scryfallId":"03835e3e-9fd1-47c7-86a5-a5481420f2d3"},{"index":51586,"token":false,"name":"Fighting Chance","scryfallId":"ca75f6e9-5eee-4904-88c0-71ec730a0f23"},{"index":51594,"token":false,"name":"Dawnfluke","scryfallId":"f8968bc0-518f-4c41-bf00-2bf295065e33"},{"index":51597,"token":false,"name":"Zephyr Net","scryfallId":"817b8996-388f-4704-a4c8-ef99d4701805"},{"index":51600,"token":false,"name":"Raven Guild Master","scryfallId":"9843f847-6a8f-4042-86b6-f7fe5a47cc57"},{"index":51612,"token":false,"name":"Faith's Shield","scryfallId":"65eb5920-3b03-4300-bc77-0fba5e6abe69"},{"index":51628,"token":false,"name":"Waterwhirl","scryfallId":"9dd58503-d269-4756-a71c-a6a2bfb1658d"},{"index":51636,"token":false,"name":"Mausoleum Harpy","scryfallId":"54b40f3c-d75e-483f-b978-8b3bf30cc7ce"},{"index":51641,"token":false,"name":"Puppet Master","scryfallId":"b401d253-4e51-42db-91cc-ac8cc3d06ae6"},{"index":51647,"token":false,"name":"Caterwauling Boggart","scryfallId":"ee8337bf-9fe8-45a0-974c-8911306b19ea"},{"index":51669,"token":false,"name":"Stinging Shot","scryfallId":"547c4c26-1118-41fa-aec8-1b43a7792e59"},{"index":51671,"token":false,"name":"Flowstone Embrace","scryfallId":"f3969cc7-92b9-45cd-9a4f-d94c2178a04d"},{"index":51672,"token":false,"name":"Gates Ablaze","scryfallId":"2b574b44-01e1-4197-99bd-57e54aebc5ff"},{"index":51677,"token":false,"name":"Treacherous Vampire","scryfallId":"a00562ae-b8b4-4f8f-8ea8-15d20568997d"},{"index":51679,"token":false,"name":"Totem Speaker","scryfallId":"ce12115b-2667-47f7-bd24-17c982a4f79a"},{"index":51680,"token":false,"name":"Sovereign's Bite","scryfallId":"5326d251-bb91-4653-b1fa-44f14c4e0b88"},{"index":51687,"token":false,"name":"Merfolk Spy","scryfallId":"30c89aa2-3375-4681-ad26-b5d5c7d3d842"},{"index":51688,"token":false,"name":"Synod Artificer","scryfallId":"dc895eea-505d-4a12-936b-dcf9895d01a1"},{"index":51694,"token":false,"name":"Tales of the Ancestors","scryfallId":"c286a74c-3714-4190-8322-84b161debe39"},{"index":51696,"token":false,"name":"No Quarter","scryfallId":"7c317ee7-ed92-4e3e-92bb-502099caccf8"},{"index":51705,"token":false,"name":"Burning Shield Askari","scryfallId":"486547cd-d2e7-4c46-9f7b-81c4267d65cc"},{"index":51709,"token":false,"name":"Thoughtbind","scryfallId":"7919cf41-67bb-4dc4-90de-cf3fa2096c2e"},{"index":51721,"token":false,"name":"Release the Dogs","scryfallId":"7df3cd89-02c9-4a1c-9a8a-d17a0b1030c9"},{"index":51731,"token":false,"name":"Mardu Heart-Piercer","scryfallId":"d17b6eee-da22-48aa-ba8a-cbd1a3389bcb"},{"index":51732,"token":false,"name":"Talisman of Impulse","scryfallId":"a00b65f7-70d0-4bbd-ac13-be24cc3374ee"},{"index":51735,"token":false,"name":"Steamclaw","scryfallId":"4f84a9bf-ce64-4301-8f2c-20f1b4acd3ef"},{"index":51745,"token":false,"name":"Burst of Energy","scryfallId":"43d590d2-cfa3-43d1-9e65-bc68b5a2a3ee"},{"index":51747,"token":false,"name":"Skylasher","scryfallId":"4f4c2069-deb1-4e56-8069-170c4f495944"},{"index":51751,"token":false,"name":"Kami of Empty Graves","scryfallId":"30502f07-760c-46d1-8b4a-d4bd4a23201f"},{"index":51754,"token":false,"name":"Fleetfeather Sandals","scryfallId":"2222f499-09f9-45a6-8255-9de79df76f1c"},{"index":51762,"token":false,"name":"Glitterfang","scryfallId":"a1519521-7f53-4f13-a104-daf52e8c7234"},{"index":51766,"token":false,"name":"Predator's Howl","scryfallId":"cae61a9d-39fc-4c25-adec-d578d57c2903"},{"index":51772,"token":false,"name":"Lim-Dûl the Necromancer","scryfallId":"b8a3cdfe-0289-474b-b9c4-07e8c6588ec5"},{"index":51775,"token":false,"name":"Memory Crystal","scryfallId":"c786ea5b-52ad-4d1b-855e-ce6d0b9af67e"},{"index":51776,"token":false,"name":"Kodama of the South Tree","scryfallId":"120c05f1-5ec3-4a0f-8628-6919e393104a"},{"index":51778,"token":false,"name":"Get the Point","scryfallId":"821c4ab5-eb75-445a-bbec-e50af54dba7a"},{"index":51786,"token":false,"name":"Sheltering Ancient","scryfallId":"d16535ae-6e03-4992-9459-d31626a3222e"},{"index":51788,"token":false,"name":"Stronghold Taskmaster","scryfallId":"6171c210-01b5-45a9-9dd3-dbf96a33a750"},{"index":51793,"token":false,"name":"Shattered Dreams","scryfallId":"1eb957bd-99e4-431e-b163-c25e9b7850d9"},{"index":51803,"token":false,"name":"Gilded Assault Cart","scryfallId":"5274c2fa-eb0e-438b-8a48-d0b58829083a"},{"index":51826,"token":false,"name":"Ballyrush Banneret","scryfallId":"a029814e-d84d-43e5-b483-e918871b3333"},{"index":51828,"token":false,"name":"Guildmages' Forum","scryfallId":"cba12bda-d460-4206-8469-4357c967b9b8"},{"index":51832,"token":false,"name":"Mystic Penitent","scryfallId":"fb37f08b-019e-4e6b-8b15-b2971a3b5ebb"},{"index":51837,"token":false,"name":"Rusted Slasher","scryfallId":"f2228ee5-507a-46ba-82ae-72ba3088a568"},{"index":51840,"token":false,"name":"Seshiro the Anointed","scryfallId":"3823e561-5a0a-4020-9322-a2b481499807"},{"index":51843,"token":false,"name":"Terra Ravager","scryfallId":"124dd668-ad84-45b9-9e04-1ea7cd2d7024"},{"index":51846,"token":false,"name":"Spiritual Visit","scryfallId":"c4e4866e-13a8-4130-9895-60e762b7efea"},{"index":51855,"token":false,"name":"Riptide Mangler","scryfallId":"5314a802-85d6-4d7b-ae9a-ca64eec652cf"},{"index":51859,"token":true,"name":"Illusion Token (U, */*)","scryfallId":"2300635e-7771-4676-a5a5-29a9d8f49f1a"},{"index":51868,"token":false,"name":"Cogwork Spy","scryfallId":"661a7927-73ad-4230-a754-ba43b35be149"},{"index":51874,"token":false,"name":"Jeskai Barricade","scryfallId":"3aa2d511-6eec-42dd-9ebe-1260c8527856"},{"index":51875,"token":false,"name":"Arcbound Tracker","scryfallId":"881175c4-fee5-4c39-ad25-145ef73569ce"},{"index":51877,"token":false,"name":"Seize the Spoils","scryfallId":"b3b7a69c-75d2-49a6-ab56-ef608d0b0208"},{"index":51880,"token":false,"name":"Salvaging Station","scryfallId":"f0336e07-8eaf-4b90-af54-4764e5ba50f2"},{"index":51882,"token":false,"name":"Oboro, Palace in the Clouds","scryfallId":"ffc2d68e-6543-43ec-b67a-afff1325a32f"},{"index":51888,"token":false,"name":"Thoughtbound Primoc","scryfallId":"e89156b5-8bdb-41d1-a7aa-63f770a9b070"},{"index":51890,"token":false,"name":"Naya Hushblade","scryfallId":"5eed1b7f-0672-4066-9e21-c5252f6dc482"},{"index":51891,"token":false,"name":"Oversoul of Dusk","scryfallId":"8893842f-aa3f-45f6-8139-ca775d33792b"},{"index":51896,"token":false,"name":"Captured by Lagacs","scryfallId":"7ce1c2a8-688b-4f63-8d58-e325efc6052a"},{"index":51907,"token":false,"name":"Mire's Toll","scryfallId":"a7e80be6-bc3b-4331-a5f2-1407a0a5dfe7"},{"index":51910,"token":false,"name":"Woolly Razorback","scryfallId":"95ed6354-161e-496e-9ac7-74432f9b0818"},{"index":51916,"token":false,"name":"Scepter of Dominance","scryfallId":"888bc7ca-f9fa-4da4-b466-b9dc273d5319"},{"index":51918,"token":false,"name":"Gideon's Avenger","scryfallId":"bb0a0d33-8862-433b-a078-82472e5f9af0"},{"index":51919,"token":false,"name":"Wyleth, Soul of Steel","scryfallId":"7c5ada8c-98f2-4f9c-bcb5-dfa4f804fbe6"},{"index":51927,"token":false,"name":"Battle Cry","scryfallId":"c558a8c4-035c-464e-9ff8-c188c1bb619e"},{"index":51934,"token":false,"name":"Dragon's Approach","scryfallId":"0cb504a0-1dfb-49d0-84c3-7bd318d55481"},{"index":51936,"token":false,"name":"Opal Lake Gatekeepers","scryfallId":"f43ac38f-5cd0-46cf-8623-d82cb8fb719b"},{"index":51937,"token":false,"name":"Leonin Iconoclast","scryfallId":"7dfaa12e-f1d9-4a39-804f-14cdaf382257"},{"index":51939,"token":false,"name":"Barbarian Guides","scryfallId":"fe65a045-dacb-4392-bcb6-843394ef98c9"},{"index":51940,"token":false,"name":"Sidisi's Faithful","scryfallId":"d02daad9-701f-40d4-ad0b-44a3cbd32c3f"},{"index":51943,"token":false,"name":"Aerial Volley","scryfallId":"c5178301-f766-48d3-af07-6bd6f822c725"},{"index":51957,"token":false,"name":"Hunter's Edge","scryfallId":"7c08c80f-f27c-4e3a-b048-143aea740096"},{"index":51958,"token":false,"name":"Glimmerpost","scryfallId":"8b63efb6-249c-4f57-9af1-baffe938520c"},{"index":51959,"token":false,"name":"Devourer of Memory","scryfallId":"514a6206-c2e5-4a0f-8a20-7efd6628dd0a"},{"index":51962,"token":false,"name":"Soltari Crusader","scryfallId":"6cd07471-b216-465c-9946-1eac689db32e"},{"index":51963,"token":false,"name":"Springmantle Cleric","scryfallId":"8d822730-6d81-4dbc-a3c3-ce96d29a1078"},{"index":51969,"token":false,"name":"Nest Robber","scryfallId":"48165add-7fef-456b-a703-be548df3e972"},{"index":51971,"token":false,"name":"Sewn-Eye Drake","scryfallId":"dbf97c08-e074-4353-b9fa-c79793622585"},{"index":51975,"token":false,"name":"Fugitive Druid","scryfallId":"afe165cd-8ef7-408e-ae56-3c6a0cc4e409"},{"index":51980,"token":false,"name":"Opal Champion","scryfallId":"2699cf3b-df54-4c77-ba19-3bc7598ae3fa"},{"index":51982,"token":false,"name":"Domri's Ambush","scryfallId":"b0dcae59-e9be-45a8-8ed8-5b47309bb716"},{"index":51988,"token":false,"name":"Horrifying Revelation","scryfallId":"27ff5fbd-7ce8-4188-8228-0eab0d69a7a1"},{"index":51989,"token":false,"name":"Trigon of Corruption","scryfallId":"26e215e0-836c-4b37-8f9a-9093a535bff1"},{"index":51990,"token":false,"name":"Selesnya Sentry","scryfallId":"9c34c1f5-d509-4c66-ba41-c7958ef5ee44"},{"index":51991,"token":false,"name":"Change of Heart","scryfallId":"afaf277e-b430-4c96-880c-ae654973478c"},{"index":51993,"token":false,"name":"Disarm","scryfallId":"427c6350-af52-45f1-8024-5f31aa62a0d0"},{"index":51995,"token":false,"name":"Diviner's Lockbox","scryfallId":"da55c6a1-1f26-4254-ac62-fdbe94278de5"},{"index":51999,"token":false,"name":"Syr Elenora, the Discerning","scryfallId":"050a0817-2e9c-4d98-974c-2d3e5c37e1a2"},{"index":52000,"token":false,"name":"Exoskeletal Armor","scryfallId":"e111fcab-17f7-4a02-b4eb-606ba18812b3"},{"index":52003,"token":false,"name":"Ardent Plea","scryfallId":"9d521737-ee07-4387-bc07-5ced53db374d"},{"index":52010,"token":false,"name":"Scion of the Swarm","scryfallId":"043926fe-d25f-40b4-b556-181503434e68"},{"index":52016,"token":false,"name":"Illness in the Ranks","scryfallId":"989a68c1-3b76-4c2d-9db3-23c45be3f9ff"},{"index":52026,"token":false,"name":"Breath of Dreams","scryfallId":"e40c9657-fab4-489d-8eb0-960ba2605add"},{"index":52027,"token":false,"name":"Pinnacle of Rage","scryfallId":"b26ff2fa-82de-4831-9341-a446abf9ed03"},{"index":52030,"token":false,"name":"Silent Attendant","scryfallId":"56e90087-3738-40df-929b-d2f880264b55"},{"index":52031,"token":false,"name":"Tormentor Exarch","scryfallId":"4886eb6a-0f6a-4ea7-8e85-4a27d1a6f03b"},{"index":52038,"token":false,"name":"Hydra's Growth","scryfallId":"5112ee2a-a6f3-4280-a915-000a97a9cdef"},{"index":52042,"token":false,"name":"Wrecking Beast","scryfallId":"74e6f7be-4493-4081-ac67-d782ab2b3723"},{"index":52043,"token":false,"name":"Dismiss into Dream","scryfallId":"af4cd7fe-639c-45a5-97af-9529904e3975"},{"index":52050,"token":false,"name":"Ur-Drago","scryfallId":"81a40f34-fc26-4d05-9c52-6ffbf1766a3b"},{"index":52052,"token":false,"name":"Brimaz, King of Oreskos","scryfallId":"f54eb705-6326-4bac-bf0e-68d42db7a270"},{"index":52055,"token":false,"name":"Ruthless Disposal","scryfallId":"fe81c78f-e3e2-4513-9711-896e6a1e6aba"},{"index":52056,"token":false,"name":"Foul-Tongue Shriek","scryfallId":"81d98ee0-6b32-4735-89f1-b37da766761f"},{"index":52065,"token":true,"name":"Human Cleric Token (B/W, 1/1)","scryfallId":"94ed2eca-1579-411d-af6f-c7359c65de30"},{"index":52066,"token":true,"name":"Enhancement Stickers","scryfallId":"b75073d6-bd99-4d70-b335-72df71636617"},{"index":52072,"token":false,"name":"Guardian of Cloverdell","scryfallId":"311c5f1d-7e3b-4397-b05b-f20bde2dc164"},{"index":52080,"token":false,"name":"Honor Troll","scryfallId":"a9c6a6b9-f00c-46a5-8dab-796483e3a262"},{"index":52086,"token":false,"name":"Loch Korrigan","scryfallId":"2964b501-5b7f-4225-9dd3-e7519bf34048"},{"index":52095,"token":false,"name":"Rally the Horde","scryfallId":"b292a8d2-44b1-4c20-8035-0f5912cc09a4"},{"index":52104,"token":false,"name":"Reverent Hunter","scryfallId":"97b4e736-d19a-42ac-8bcb-b8e6b7b7b539"},{"index":52106,"token":false,"name":"Aesi, Tyrant of Gyre Strait","scryfallId":"d607b003-6b48-429c-a7fd-45b8dd1bb4f9"},{"index":52108,"token":false,"name":"Earsplitting Rats","scryfallId":"5dad63b5-ced3-4150-ad84-1ca05a892840"},{"index":52113,"token":false,"name":"Dash Hopes","scryfallId":"814bcfc0-7539-4ed9-8b51-27e6a3ab9d9a"},{"index":52116,"token":false,"name":"Seeds of Innocence","scryfallId":"f9c868f5-0f90-4f7e-bafb-c45d2372fe06"},{"index":52127,"token":false,"name":"Steel-Plume Marshal","scryfallId":"ddbcb165-0a60-493a-8cbb-ba8b36c527da"},{"index":52129,"token":false,"name":"Macetail Hystrodon","scryfallId":"8451ab3f-5d61-4f35-ab70-5a5060caf53d"},{"index":52130,"token":false,"name":"Declare Dominance","scryfallId":"78271f34-f62e-4771-b430-b121097b8fb6"},{"index":52131,"token":false,"name":"Aether Theorist","scryfallId":"882b5580-ee23-4d65-a2b3-82475d6faf8e"},{"index":52132,"token":false,"name":"Corrupt Eunuchs","scryfallId":"5e084664-2faf-4f7a-9068-d58d3f4b8456"},{"index":52137,"token":false,"name":"Arctic Aven","scryfallId":"06f6aab1-c400-4d87-b68e-f36552e7417f"},{"index":52138,"token":true,"name":"Human Token (R, 1/1)","scryfallId":"dbd994fc-f3f0-4c81-86bd-14ca63ec229b"},{"index":52139,"token":false,"name":"Word of Command","scryfallId":"4a7f0dbb-00cb-47d5-8884-9aa397fab559"},{"index":52141,"token":false,"name":"Lunge","scryfallId":"e9e43349-429c-43f7-b808-c4bf37370a9f"},{"index":52142,"token":false,"name":"Chisei, Heart of Oceans","scryfallId":"6c359b1a-d441-4763-96c7-e5c010eae53f"},{"index":52150,"token":false,"name":"Spearpoint Oread","scryfallId":"22d9d241-74b8-4b40-b4b7-b8584012d482"},{"index":52155,"token":false,"name":"Mercurial Transformation","scryfallId":"adcbe115-5482-4e5a-95bb-8ccbb01d3547"},{"index":52156,"token":false,"name":"Custodi Soulcaller","scryfallId":"e29212c9-04e3-4678-be73-f7405a85dadb"},{"index":52160,"token":false,"name":"Bloodtallow Candle","scryfallId":"5f8125b6-911e-4663-962a-d741984c927d"},{"index":52168,"token":false,"name":"Rakdos Cluestone","scryfallId":"9ef43817-1813-4608-8e3d-3c14321ab736"},{"index":52174,"token":false,"name":"Armored Galleon","scryfallId":"484b2978-2da5-41cf-85d4-128e9dae75c0"},{"index":52176,"token":false,"name":"Skyblade's Boon","scryfallId":"e5705397-525b-4106-92ab-fe8ec9f561a2"},{"index":52177,"token":false,"name":"Battle Hymn","scryfallId":"43b5d46e-7054-44f8-9a14-b412f2f0ab86"},{"index":52179,"token":false,"name":"Doubling Chant","scryfallId":"f71dc232-9b7e-4c0e-ac05-8e48b4936aa9"},{"index":52182,"token":false,"name":"Chemister's Trick","scryfallId":"dbfc2748-351f-4b5d-8a7e-bc51851578bb"},{"index":52188,"token":false,"name":"Kite Shield","scryfallId":"1a00d1e1-aaa4-4f4d-a887-1e477820d2c6"},{"index":52196,"token":false,"name":"Crazed Firecat","scryfallId":"5ef809de-ff64-4832-95dd-2ebda5942df8"},{"index":52200,"token":false,"name":"Seed Guardian","scryfallId":"ba4736b3-d6ce-4a16-bcb7-67780caeb78c"},{"index":52205,"token":true,"name":"Cat Beast Token (W, 2/2)","scryfallId":"e2c91781-acf9-4cff-be1a-85148ad2a683"},{"index":52210,"token":false,"name":"Cephalid Aristocrat","scryfallId":"bd9ca63d-7e77-48f3-abdc-2d2f9cb3a0d9"},{"index":52218,"token":false,"name":"Meteor Storm","scryfallId":"36489b24-f8a8-46b6-b879-0a5ce400a6dc"},{"index":52226,"token":false,"name":"Canopy Gorger","scryfallId":"cbc8957d-769c-4630-9544-56cea8c847c2"},{"index":52228,"token":false,"name":"Bright Reprisal","scryfallId":"3340ffb9-9513-4551-ad64-821600596b2e"},{"index":52254,"token":false,"name":"Aven Farseer","scryfallId":"47854e89-4d22-4eb6-a77d-6f04407bd2e5"},{"index":52255,"token":false,"name":"Vivien's Grizzly","scryfallId":"37f2571b-6756-462c-9e71-3121fa458160"},{"index":52263,"token":false,"name":"Kinscaer Harpoonist","scryfallId":"13cfde34-f76b-47ab-b83e-1c188d61a613"},{"index":52271,"token":false,"name":"Sanctified Charge","scryfallId":"6481bf34-192c-4102-8336-4d2d007d9e3c"},{"index":52275,"token":false,"name":"Scrambleverse","scryfallId":"2b61fa9d-3f69-4632-be0e-09924ca88501"},{"index":52276,"token":false,"name":"Luminescent Rain","scryfallId":"5f9903cc-350c-44cf-9c0b-5df7922ed766"},{"index":52285,"token":false,"name":"Flicker","scryfallId":"f55e7ec5-6488-483f-8020-b48e1a951f09"},{"index":52290,"token":false,"name":"Phantom Beast","scryfallId":"572df99b-af44-4128-8b2c-e40b1cea816b"},{"index":52293,"token":false,"name":"Manipulate Fate","scryfallId":"5bb52acb-dedb-4ed6-a6da-8c036f2b2958"},{"index":52296,"token":false,"name":"Worst Fears","scryfallId":"8f4e21ac-4f3e-4a3e-83c0-0a59a1b84020"},{"index":52299,"token":false,"name":"Nip Gwyllion","scryfallId":"019ad92d-8803-4569-98c8-4a7416799cfc"},{"index":52303,"token":false,"name":"Merrow Witsniper","scryfallId":"d5b4e77f-012f-47f4-8b44-930148250b1d"},{"index":52309,"token":false,"name":"Displacement Wave","scryfallId":"ad6fef1f-6cc9-4e24-a1be-fc313774f28d"},{"index":52316,"token":false,"name":"Traveling Philosopher","scryfallId":"edad0276-45d1-45e5-a6b1-1cd2a99b4f2c"},{"index":52324,"token":false,"name":"Chainwhip Cyclops","scryfallId":"d2f18df2-5910-4c5d-8b04-6fe5d04e8150"},{"index":52333,"token":false,"name":"Artificer's Hex","scryfallId":"3a5cd9a1-da2e-44ef-9f2e-352dc9f92c50"},{"index":52334,"token":false,"name":"Infectious Host","scryfallId":"11858b4f-3a90-4990-9984-d888c000ec73"},{"index":52341,"token":false,"name":"Surestrike Trident","scryfallId":"cfcb621d-5831-4b7c-b3e1-c321a6e10392"},{"index":52344,"token":false,"name":"Niblis of the Mist","scryfallId":"08aea6e3-c8a8-4964-b95d-4c639da55de1"},{"index":52359,"token":false,"name":"Volatile Claws","scryfallId":"36cb119b-dd15-40d2-8f75-c92f5d41d1e1"},{"index":52364,"token":false,"name":"Rite of Consumption","scryfallId":"f62d999c-c81e-4bea-aefd-0d12251dcdd1"},{"index":52366,"token":false,"name":"Vedalken Infiltrator","scryfallId":"9ddfc6a8-7880-4810-8c0a-d9ea931138f2"},{"index":52367,"token":false,"name":"Undercity Uprising","scryfallId":"7e1e08bf-a5d6-48bb-9f7f-4711f9ec88d7"},{"index":52369,"token":false,"name":"Furtive Homunculus","scryfallId":"f376ec9b-48ac-4ed7-bfa2-60e9dca32dd7"},{"index":52377,"token":false,"name":"Psychotic Haze","scryfallId":"8d3f6cd2-0138-40e7-a975-3f7c68db0d93"},{"index":52379,"token":true,"name":"Walls","scryfallId":"cef6812d-5f8d-40c8-8935-e5f01a808301"},{"index":52381,"token":false,"name":"Necromancer's Magemark","scryfallId":"3b045121-7742-41ee-be27-591692f42331"},{"index":52393,"token":false,"name":"Krark-Clan Grunt","scryfallId":"ffd9e422-206e-4c25-9964-ed6592c16e12"},{"index":52396,"token":false,"name":"Intimidator Initiate","scryfallId":"c19dd557-dd49-450d-8446-71ce351d4f52"},{"index":52399,"token":false,"name":"Spirit of Resistance","scryfallId":"5fb66439-df73-4a01-a8d4-6f2334297fdf"},{"index":52401,"token":false,"name":"Martyr for the Cause","scryfallId":"acfbc8ca-a574-461e-92ea-c6010daa8230"},{"index":52402,"token":false,"name":"Delif's Cone","scryfallId":"262b8788-c5a0-4c8e-9d58-b769b1b0a2ff"},{"index":52405,"token":false,"name":"Abandoned Outpost","scryfallId":"4945031e-1158-474c-9e50-1ec817acc767"},{"index":52409,"token":false,"name":"Gavony Ironwright","scryfallId":"05d8de75-b169-4426-94a4-b19cdfdffd89"},{"index":52413,"token":false,"name":"Decimator Beetle","scryfallId":"6b75e834-fa46-4833-ae9f-1bc2809ece2f"},{"index":52414,"token":false,"name":"The Binding of the Titans","scryfallId":"46fb94ad-f9be-48b4-b65a-4e736e5ffdbb"},{"index":52417,"token":true,"name":"Knight Ally Token (W, 2/2)","scryfallId":"0419a202-6e32-4f0a-a032-72f6c00cae5e"},{"index":52420,"token":false,"name":"Misthoof Kirin","scryfallId":"ccef8595-96e8-4df3-aa5a-9fc8c5fa9a3d"},{"index":52421,"token":false,"name":"Basri's Aegis","scryfallId":"577657ed-162f-4104-b0af-ee9733e90f20"},{"index":52422,"token":false,"name":"Skirk Outrider","scryfallId":"416de0f4-1540-4286-a1ac-4f57301c54e9"},{"index":52423,"token":false,"name":"Spectral Guardian","scryfallId":"2a0bea61-8fd2-4802-90b4-651bebbe9638"},{"index":52424,"token":false,"name":"Land Cap","scryfallId":"c4806c02-7a4d-42e3-affd-0338084bd3ab"},{"index":52425,"token":false,"name":"Swift Silence","scryfallId":"a1c5f733-e126-4c22-b528-18bdb90b509b"},{"index":52441,"token":false,"name":"Defang","scryfallId":"f12fee0b-c237-4188-a718-1572f72c63ba"},{"index":52442,"token":false,"name":"Furyblade Vampire","scryfallId":"56a957d6-fc14-453a-a250-63fc130e330d"},{"index":52454,"token":false,"name":"Ghost Town","scryfallId":"4218cdda-3a62-43fb-aaf7-7ac836392796"},{"index":52459,"token":true,"name":"Elf Knight Token (G/W, 2/2)","scryfallId":"74506297-41ad-40e5-bb05-175650ff4907"},{"index":52460,"token":false,"name":"Heat Wave","scryfallId":"42dd0810-4528-4a88-add8-923bb2057821"},{"index":52464,"token":false,"name":"Yew Spirit","scryfallId":"b9320432-4f89-4363-91e6-2e740535cc2e"},{"index":52467,"token":false,"name":"Animate Land","scryfallId":"20ff4e7d-fa50-48d2-8ab6-6b86e3a05e86"},{"index":52469,"token":false,"name":"Pentarch Paladin","scryfallId":"ced01039-e19f-466b-bbc6-9bcb8d3ae845"},{"index":52475,"token":false,"name":"Enhanced Surveillance","scryfallId":"971d254e-da25-494b-a16d-3d7d6bb75c73"},{"index":52482,"token":false,"name":"Vengeful Devil","scryfallId":"1265d65e-3f26-46d9-8b8b-e75048a02e95"},{"index":52486,"token":false,"name":"Deadshot","scryfallId":"ad82258b-3856-49ee-9acd-926feb15e070"},{"index":52496,"token":false,"name":"Sun-Collared Raptor","scryfallId":"62fbd1bc-3e57-43d5-ad54-443ca740fcc4"},{"index":52503,"token":false,"name":"Tezzeret, Master of the Bridge","scryfallId":"9ee1eea2-961f-445d-b035-6baed454f289"},{"index":52511,"token":false,"name":"Jungle Patrol","scryfallId":"91c343b8-bbfd-4bc5-b80a-4bc4565cdd40"},{"index":52513,"token":false,"name":"Garenbrig Squire","scryfallId":"74237cce-2ca2-4bfd-a846-c7309621a85f"},{"index":52519,"token":false,"name":"Cloud Manta","scryfallId":"1854f819-d08e-4a23-bedb-4618b79623e9"},{"index":52525,"token":false,"name":"Countermand","scryfallId":"07815e32-0b64-4c2b-84e6-a72336c45cf5"},{"index":52528,"token":false,"name":"Grinning Demon","scryfallId":"72de2f66-0b86-4c21-b4c8-c2d97e3fd095"},{"index":52529,"token":false,"name":"Dark Tutelage","scryfallId":"9ec3dd9f-3969-4fd7-97f7-e9868eb19a64"},{"index":52530,"token":false,"name":"Iname, Death Aspect","scryfallId":"2dd67e11-3dad-4e59-b15d-02911e53fbbf"},{"index":52539,"token":false,"name":"Ironwright's Cleansing","scryfallId":"916d8aa5-158f-46f4-babe-981a391fd88b"},{"index":52547,"token":false,"name":"Thermopod","scryfallId":"c09475e9-d6c1-4d4b-905e-40bc30405725"},{"index":52553,"token":false,"name":"Predator Ooze","scryfallId":"73c71457-f7c9-4ab4-b89d-e235e3f15e16"},{"index":52560,"token":false,"name":"Cornered Market","scryfallId":"0d4f3c1d-d25e-4263-ab2b-19534c852678"},{"index":52562,"token":false,"name":"Awakening","scryfallId":"59612c02-6028-4953-ac4d-aca94b0ce4b9"},{"index":52566,"token":false,"name":"Kami of False Hope","scryfallId":"44e4f5e6-935e-429f-89b4-4571376f442e"},{"index":52573,"token":false,"name":"Angrath's Ambusher","scryfallId":"48181263-11fd-444e-9fef-02ccfe016c8c"},{"index":52582,"token":false,"name":"Viashino Slaughtermaster","scryfallId":"e60c30ee-616b-4b7d-97f9-cab1d6218e3a"},{"index":52585,"token":false,"name":"Cacophodon","scryfallId":"351b213e-b23e-4287-947a-6bd81f1cf751"},{"index":52586,"token":false,"name":"Pyre Zombie","scryfallId":"6c030108-2995-4fb0-9b80-efdfdd0f11e0"},{"index":52587,"token":false,"name":"Wings of Hubris","scryfallId":"e3ef8f96-3e3c-4b1b-8180-3b38c7deaaff"},{"index":52599,"token":true,"name":"Heavily Armored","scryfallId":"c71a8155-8f20-448b-acf2-a536c2554270"},{"index":52612,"token":false,"name":"Resplendent Mentor","scryfallId":"be87e59d-422c-4dd7-8867-423e784830a2"},{"index":52618,"token":false,"name":"Hall of the Bandit Lord","scryfallId":"59fa5bab-8626-4b45-a3a3-621f6d9509ab"},{"index":52619,"token":false,"name":"Briarblade Adept","scryfallId":"9d3fb5f1-baf5-4934-aac7-ffbaa85b2428"},{"index":52623,"token":false,"name":"Battershield Warrior","scryfallId":"fb79dc85-f85a-4846-9ac3-c75c64ea9c0a"},{"index":52632,"token":false,"name":"Hired Muscle // Scarmaker","scryfallId":"28f72260-c8f9-4c44-92b5-23cef6690fdd"},{"index":52644,"token":false,"name":"Geyserfield Stalker","scryfallId":"d4d1e1e1-fa24-4e78-a77c-4d41a58b8aa0"},{"index":52647,"token":false,"name":"Trained Cheetah","scryfallId":"ab242eab-5cab-41a0-bcf8-93a6919e4558"},{"index":52656,"token":false,"name":"Exquisite Huntmaster","scryfallId":"444b75d9-f7c7-4a13-9318-02d7bbd80c9c"},{"index":52657,"token":false,"name":"Altar of the Pantheon","scryfallId":"e1f2a587-443d-4626-a6f6-9a26838a42b1"},{"index":52659,"token":false,"name":"Kitesail Skirmisher","scryfallId":"fcd356b3-29a9-4526-93a0-33375f65744b"},{"index":52663,"token":false,"name":"Carrier Pigeons","scryfallId":"9d68befe-78bc-4d9c-968b-f7e6b3042f27"},{"index":52668,"token":false,"name":"Maw of the Mire","scryfallId":"90b34a03-3270-412c-90ca-03c1b3e61222"},{"index":52677,"token":false,"name":"Obscuring Haze","scryfallId":"c1ae35e6-5401-481a-8104-24f53e3d160f"},{"index":52679,"token":false,"name":"Hydromorph Guardian","scryfallId":"40e4ace0-421d-4e8e-ab85-8f74757e99c7"},{"index":52680,"token":false,"name":"Moorland Haunt","scryfallId":"1d5569e3-278c-4cf3-860e-712010333fe6"},{"index":52684,"token":false,"name":"Camel","scryfallId":"e0078aa8-bfb8-43b0-a6b7-1991596c21e1"},{"index":52685,"token":false,"name":"Ulvenwald Tracker","scryfallId":"46199391-a4f5-4532-b89c-b7691b229bd0"},{"index":52691,"token":false,"name":"Veiled Apparition","scryfallId":"8f9ea09f-5017-423c-84ad-c332329992b3"},{"index":52693,"token":false,"name":"Joraga Auxiliary","scryfallId":"65d920b4-81ab-45be-b763-b6114b879357"},{"index":52696,"token":false,"name":"Rethink","scryfallId":"915ae03f-22f3-4ecc-a875-5226d8dec384"},{"index":52699,"token":false,"name":"Sadistic Obsession","scryfallId":"64080d0d-163b-450d-8919-79a0465f3645"},{"index":52700,"token":false,"name":"Springjack Knight","scryfallId":"75fa0c72-427b-4797-b5b1-15f07fc5fa07"},{"index":52703,"token":false,"name":"Unworthy Dead","scryfallId":"0f42c561-1762-43c4-a539-0cf9a5ce7f4f"},{"index":52705,"token":false,"name":"Melira's Keepers","scryfallId":"d9a935b4-347c-46d9-a7c5-8c5079948959"},{"index":52706,"token":false,"name":"Dimensional Breach","scryfallId":"f18f2832-07c5-47be-8966-b250fb997f78"},{"index":52707,"token":false,"name":"Pygmy Kavu","scryfallId":"b31c69ec-feb5-430a-a3e9-3a6f3fb8ee1c"},{"index":52712,"token":false,"name":"Blade-Tribe Berserkers","scryfallId":"acd124bb-1ed1-469c-8527-d7261ea720b9"},{"index":52714,"token":false,"name":"Challenger Troll","scryfallId":"328d778a-ef16-437f-9a9d-204cf061919b"},{"index":52715,"token":false,"name":"Incite Hysteria","scryfallId":"a31f5060-df9e-4665-bf60-a8e33da55c84"},{"index":52720,"token":true,"name":"Wurm Token (B, 6/6)","scryfallId":"31107acf-5969-42ff-a805-9152f439b7fa"},{"index":52722,"token":false,"name":"Hankyu","scryfallId":"6f22a88a-4f04-4500-9e05-909b54ad43e3"},{"index":52723,"token":false,"name":"Chittering Witch","scryfallId":"8c298940-4277-4145-9f2f-a284fd2e1a9d"},{"index":52724,"token":false,"name":"Phyrexian Ironfoot","scryfallId":"49ff9859-92a4-4732-94bf-6c02b0a57338"},{"index":52733,"token":false,"name":"Corrupted Harvester","scryfallId":"b54625ac-484f-4522-8048-38e01c545ac3"},{"index":52734,"token":false,"name":"Woodland Bellower","scryfallId":"a706d4bb-0b44-4e43-b340-7de799c086b8"},{"index":52751,"token":false,"name":"Replicating Ring","scryfallId":"b079e285-8431-46aa-bb04-70cac586ed0b"},{"index":52752,"token":false,"name":"Seize the Soul","scryfallId":"29bf245f-e8e0-4d32-8cd7-06d832609910"},{"index":52756,"token":false,"name":"Violent Eruption","scryfallId":"419e6697-89ab-49f1-a867-8f86f001c80c"},{"index":52770,"token":false,"name":"Vastwood Fortification // Vastwood Thicket","scryfallId":"3a7fd24e-84d8-405d-86e4-0571a9e23cc2"},{"index":52778,"token":false,"name":"Arcbound Javelineer","scryfallId":"fe4a2cb0-4129-451e-a946-a21ea646cc28"},{"index":52797,"token":false,"name":"Journey to Oblivion","scryfallId":"47120e3c-73aa-468d-96b7-47aead342e31"},{"index":52798,"token":false,"name":"Seedcradle Witch","scryfallId":"a0ae8525-ce10-40bd-8980-a05fb81a0fac"},{"index":52800,"token":true,"name":"Karox Bladewing Token (R, 4/4)","scryfallId":"7c0cdb0d-f720-4ed2-af08-ced9b54f6702"},{"index":52805,"token":false,"name":"Words of Wisdom","scryfallId":"c0199cfb-5e44-40f0-b9cf-71473155eb94"},{"index":52810,"token":false,"name":"Karfell Kennel-Master","scryfallId":"f670c380-6faa-42ec-ab41-6be8137169b2"},{"index":52815,"token":false,"name":"Dueling Grounds","scryfallId":"52760183-bee0-4ce0-96c0-074b88f78980"},{"index":52823,"token":false,"name":"Full Moon's Rise","scryfallId":"02a35eac-b962-466e-a4da-a4010c68ef16"},{"index":52825,"token":false,"name":"Llanowar Augur","scryfallId":"1c8c9473-97f4-4875-8f06-d3a70d4cbe6d"},{"index":52836,"token":false,"name":"Torture Chamber","scryfallId":"5648158d-38d4-4167-8af5-ee5d7d6fd7cb"},{"index":52838,"token":false,"name":"Pyretic Ritual","scryfallId":"ac3f40b1-fcd7-456c-afb9-759df8352e43"},{"index":52840,"token":false,"name":"Glass Golem","scryfallId":"1b87dc27-3cea-4101-aec5-ca0b96978476"},{"index":52847,"token":false,"name":"Slithermuse","scryfallId":"2ec9df4e-2ee7-4c77-91b0-ad6e624340cd"},{"index":52851,"token":false,"name":"Woodland Changeling","scryfallId":"aa41edf8-88a1-46dd-8315-b0afe7e14b7e"},{"index":52857,"token":false,"name":"Spare Supplies","scryfallId":"a53baf25-1782-427b-a9dd-fc9b8dc6444f"},{"index":52860,"token":false,"name":"Lumengrid Drake","scryfallId":"f44e9820-2209-40a2-bc4f-46b440c05e9d"},{"index":52862,"token":false,"name":"Living Destiny","scryfallId":"361399a4-04f3-4eef-8090-2caec7d1bb66"},{"index":52867,"token":false,"name":"Kiku, Night's Flower","scryfallId":"07e18994-d08b-4a8e-abfb-b5531fd6f816"},{"index":52870,"token":false,"name":"Storm Fleet Aerialist","scryfallId":"9de1acd5-bee4-48fe-951d-7936e20f0a71"},{"index":52874,"token":false,"name":"Exclusion Ritual","scryfallId":"9e3b826a-7349-45ae-89bf-675fea7ce8e3"},{"index":52879,"token":false,"name":"Bloodcrazed Goblin","scryfallId":"f4ec6fc4-efbf-4071-860e-ba244e27e2d3"},{"index":52882,"token":false,"name":"Nimbus Champion","scryfallId":"0b247847-25d9-4220-bd7b-1db9df445ec8"},{"index":52885,"token":false,"name":"Spike Cannibal","scryfallId":"64003772-c62f-4728-a00c-48c78991c6ae"},{"index":52905,"token":false,"name":"Tainted Specter","scryfallId":"74feb223-784a-4540-8a8e-6007d10a9505"},{"index":52916,"token":false,"name":"Master of the Veil","scryfallId":"d7ce1755-9f4a-4741-b6e5-288595ec494d"},{"index":52923,"token":false,"name":"Morophon, the Boundless","scryfallId":"9693e59b-032d-4ddc-a7d1-88a0f52dcc6c"},{"index":52928,"token":false,"name":"Awe for the Guilds","scryfallId":"ec644ac3-07a2-43de-8173-9cc18e2ea2d9"},{"index":52932,"token":false,"name":"Coal Golem","scryfallId":"bdc28e20-0e48-4803-a8e2-1c1e8f518d89"},{"index":52940,"token":false,"name":"Adarkar Unicorn","scryfallId":"0ba7526f-dba8-4483-b925-946164fc0ae9"},{"index":52944,"token":false,"name":"Mogg Jailer","scryfallId":"52513235-0e6c-40ea-8ead-a050e6da676e"},{"index":52947,"token":false,"name":"Nagao, Bound by Honor","scryfallId":"a45258f4-c36d-46cc-80e8-cc458351e003"},{"index":52948,"token":false,"name":"Deicide","scryfallId":"6012964c-eb76-4581-82ae-aec2d36f0d56"},{"index":52960,"token":false,"name":"Elven Palisade","scryfallId":"b990ffe5-fd2a-4646-bac3-8e52cdc328aa"},{"index":52963,"token":false,"name":"Consecrated by Blood","scryfallId":"3d896df9-f897-4786-b1a1-d2375e81c9ef"},{"index":52969,"token":false,"name":"Flameborn Viron","scryfallId":"9601ea62-a609-4bc5-a2f0-f7615b4dd5fa"},{"index":52972,"token":false,"name":"Gilt-Leaf Archdruid","scryfallId":"a913f9b3-abbd-424b-8dea-061e15364fb0"},{"index":52983,"token":false,"name":"Lightning Reflexes","scryfallId":"271febe5-98ea-403d-87be-7865cf9f426d"},{"index":52985,"token":false,"name":"Festival of Trokin","scryfallId":"f5bd783b-d4cd-4a53-8fec-a5ead7c14738"},{"index":52991,"token":false,"name":"Sequence Engine","scryfallId":"ae50172c-8896-4ad2-8c83-d349ccca2308"},{"index":52992,"token":false,"name":"Seraph of the Masses","scryfallId":"36c857a8-7df6-4a50-ae58-4aab76d7d58c"},{"index":53001,"token":false,"name":"Zombie Scavengers","scryfallId":"2ec786b1-6097-4e97-99b0-571d6e3e73e7"},{"index":53002,"token":false,"name":"Scrapyard Recombiner","scryfallId":"8945f5e0-c143-47ca-910e-32ad9ac34487"},{"index":53006,"token":false,"name":"Silverquill Apprentice","scryfallId":"42d0770e-9084-4aa7-b543-2b6ba18378dc"},{"index":53014,"token":false,"name":"Distended Mindbender","scryfallId":"e866be54-75fc-4e39-806a-06756aca660c"},{"index":53016,"token":false,"name":"Ambuscade Shaman","scryfallId":"5b9a91f8-5f9f-46a2-bd80-1ca014591de9"},{"index":53031,"token":false,"name":"Complex Automaton","scryfallId":"5fb3c7af-74e1-4072-953b-b3e9ccd8aa03"},{"index":53039,"token":false,"name":"Molten Nursery","scryfallId":"3db8aaf5-e2bf-40ea-bd5d-663017cfd4a6"},{"index":53044,"token":false,"name":"Hundroog","scryfallId":"f525c356-88ca-4e2e-8f06-663be101e34f"},{"index":53073,"token":false,"name":"Ghostflame Sliver","scryfallId":"64eb10d1-22c6-4848-a7f4-c6ccd2c66dae"},{"index":53075,"token":false,"name":"Boonweaver Giant","scryfallId":"85003365-7c5f-4283-995d-e466deef444b"},{"index":53078,"token":false,"name":"Phyrexian Hydra","scryfallId":"cb135aa1-9f46-4d60-a1a4-97aa0e852ced"},{"index":53080,"token":false,"name":"Thirsting Shade","scryfallId":"a920c2e6-4a1f-487c-ad3f-b772443f0633"},{"index":53086,"token":false,"name":"Tyrannize","scryfallId":"69b7428b-8fff-4839-8b59-b268af0699c2"},{"index":53089,"token":false,"name":"Inescapable Brute","scryfallId":"ab4a1d42-eaf8-424a-9649-5f3b4602bf0d"},{"index":53094,"token":false,"name":"Dream Salvage","scryfallId":"cac999cc-c5c0-4309-a255-3eb7399af340"},{"index":53109,"token":false,"name":"Wall of Light","scryfallId":"347db0be-8a88-4110-942a-d3c77cfbca52"},{"index":53113,"token":false,"name":"Aven Mimeomancer","scryfallId":"49876185-e23d-4137-8612-1347da3a1df6"},{"index":53138,"token":false,"name":"Bonus Round","scryfallId":"e21aa266-4264-4e02-9403-02930e641573"},{"index":53139,"token":false,"name":"Courage in Crisis","scryfallId":"67a22083-9ef9-4ff7-8502-3a77e69299df"},{"index":53143,"token":false,"name":"Dwarven Thaumaturgist","scryfallId":"f6cb46bc-5b01-4cd3-ba37-89ba09e57216"},{"index":53146,"token":false,"name":"Shorecrasher Mimic","scryfallId":"24babb9e-edc8-484b-9db4-18abbafdf096"},{"index":53162,"token":false,"name":"Prismatic Boon","scryfallId":"fb774a9b-d29f-4f41-9fb8-a0189205e16f"},{"index":53168,"token":false,"name":"Bonds of Mortality","scryfallId":"ff50de00-115f-41ed-892b-aac9bd13b9b9"},{"index":53173,"token":false,"name":"Pigment Storm","scryfallId":"d285a7a1-bb7e-4a78-a49f-c2add62b829a"},{"index":53187,"token":false,"name":"Ghastbark Twins","scryfallId":"d470e441-3520-4669-aaa5-f0c57829352a"},{"index":53188,"token":false,"name":"Barge In","scryfallId":"9bfe337c-4b8c-42ce-8c43-4c95051d09ac"},{"index":53197,"token":false,"name":"Fylamarid","scryfallId":"8dd4f686-79e3-4067-81f9-7fae0c25dc8f"},{"index":53199,"token":false,"name":"Mist Intruder","scryfallId":"f8c2e662-d8c3-44d4-b666-fe0d4a046271"},{"index":53202,"token":false,"name":"Acid Web Spider","scryfallId":"968a25a5-9ec1-47fa-bf1f-e65eb75fdb00"},{"index":53204,"token":false,"name":"Centaur Safeguard","scryfallId":"647d3e06-93e6-4948-a3ec-6a00bdfc0f99"},{"index":53208,"token":false,"name":"Changeling Sentinel","scryfallId":"fe7e0c9f-000d-494d-86f6-95e8d2b59ac7"},{"index":53210,"token":false,"name":"Illusionary Presence","scryfallId":"aa31efed-4a11-4f59-a623-bac45d20091d"},{"index":53220,"token":false,"name":"No Mercy","scryfallId":"96af17e0-91fa-4b99-8313-9dabea8685ea"},{"index":53226,"token":false,"name":"Uncanny Speed","scryfallId":"1d7b747e-446a-4c25-9834-0be8476dc22d"},{"index":53230,"token":false,"name":"Skyswirl Harrier","scryfallId":"b951bc89-be0b-4330-8a13-e196e084d53c"},{"index":53234,"token":false,"name":"Goblin Archaeologist","scryfallId":"a326a7d0-8e24-4ae4-9014-ca6eb6983644"},{"index":53238,"token":false,"name":"Risen Riptide","scryfallId":"f6455009-030c-4a33-a60b-80863d8f8aaf"},{"index":53241,"token":false,"name":"Menacing Ogre","scryfallId":"5360a871-6932-45b2-bc94-1bd414e38906"},{"index":53242,"token":false,"name":"Eunuchs' Intrigues","scryfallId":"5e7ca92f-770d-4147-8eaf-f1fa69340dc9"},{"index":53254,"token":false,"name":"Howling Fury","scryfallId":"b7107b11-308e-4eb1-b16f-1fe92ecfe903"},{"index":53258,"token":false,"name":"Burn Trail","scryfallId":"7f01f9a0-f1d0-4241-a270-df4ed673d1fd"},{"index":53261,"token":false,"name":"Skizzik Surger","scryfallId":"4b232c36-bff1-4f5e-98a6-ce6a98591aa6"},{"index":53263,"token":false,"name":"Prismari Apprentice","scryfallId":"dca3aa59-c8ac-4930-abf7-0a74d657122a"},{"index":53267,"token":false,"name":"Cover of Darkness","scryfallId":"0d6d7d88-d82b-40f4-bf57-ec5d7c480689"},{"index":53269,"token":false,"name":"Awaken the Ancient","scryfallId":"e4125304-fd68-4051-96d5-625ffa9b0d3c"},{"index":53274,"token":false,"name":"Death's Caress","scryfallId":"0643fb9a-8284-4dfc-836a-c2c69ef09f32"},{"index":53282,"token":false,"name":"Terashi's Cry","scryfallId":"7176139f-8a9a-4ee4-a56d-672fd09390e4"},{"index":53288,"token":false,"name":"Swirling Sandstorm","scryfallId":"4d757ec3-c15f-4d6e-8e18-36ebae985448"},{"index":53289,"token":true,"name":"Brian Hacker Decklist","scryfallId":"0c85b8a5-cf76-4952-9fe0-cb7d2f86fead"},{"index":53290,"token":false,"name":"Jund Battlemage","scryfallId":"ee8c962f-11b0-48f7-bbba-a2212e41990f"},{"index":53303,"token":false,"name":"Abundant Maw","scryfallId":"8a4e7ef7-7958-4d7c-b319-4d3db7955002"},{"index":53307,"token":false,"name":"Channeled Force","scryfallId":"8918d24e-8ae8-4028-9f06-ba6fafcc717e"},{"index":53311,"token":false,"name":"Shallow Grave","scryfallId":"d5c782cc-c951-4c6f-a93f-774ae6c1c214"},{"index":53315,"token":false,"name":"Emblem of the Warmind","scryfallId":"03ab2a41-315b-439c-b02c-f12335fc903a"},{"index":53333,"token":false,"name":"Abominable Treefolk","scryfallId":"1eddb834-ea01-44e2-afca-bd9a4ebbdb94"},{"index":53340,"token":false,"name":"Boros Recruit","scryfallId":"5af01330-05c2-4c5b-9830-2886711b2b5d"},{"index":53343,"token":false,"name":"Rime Dryad","scryfallId":"7a93e6ce-1295-41f8-b454-2dfe321481a6"},{"index":53347,"token":false,"name":"Smash","scryfallId":"40c39852-efd3-4a25-b33b-3c13dad96e7d"},{"index":53350,"token":false,"name":"Exuberant Wolfbear","scryfallId":"8c8ff0da-fbe3-4c95-bc39-c975c55b6aea"},{"index":53352,"token":true,"name":"Beast Token (G/R/W, 8/8)","scryfallId":"a7382e4b-43dc-4b35-8a9e-ab886ea0a981"},{"index":53353,"token":false,"name":"Tome Raider","scryfallId":"e04ad850-5801-4654-a388-f86be20a43bf"},{"index":53358,"token":false,"name":"Elgaud Inquisitor","scryfallId":"c342e1da-7ab9-4e29-96e6-77d820a45ede"},{"index":53362,"token":false,"name":"Book Devourer","scryfallId":"01dfe640-5bd2-4d0b-8977-887b2ed4c2dd"},{"index":53363,"token":false,"name":"Illustrious Historian","scryfallId":"56cc4e7d-3b06-4938-9023-d903912350c0"},{"index":53365,"token":false,"name":"Asphodel Wanderer","scryfallId":"675112db-c477-43f4-b755-54162445fb49"},{"index":53366,"token":false,"name":"Sabertooth Mauler","scryfallId":"fe39e38e-76e5-4883-b530-d3e30e88ccad"},{"index":53370,"token":false,"name":"Aven Liberator","scryfallId":"b2804006-2a60-400c-be0b-8aa042469372"},{"index":53371,"token":false,"name":"Roar of Jukai","scryfallId":"66b70649-12f8-47b9-9959-40323684a777"},{"index":53377,"token":false,"name":"Koth's Courier","scryfallId":"978cc53c-c038-4442-bd46-e0b9e8cdd924"},{"index":53378,"token":false,"name":"Talruum Champion","scryfallId":"33730a07-754c-4606-bfac-d73454af9567"},{"index":53386,"token":false,"name":"Font of Ire","scryfallId":"41509414-9faf-472d-8d38-391d9594cd56"},{"index":53392,"token":true,"name":"Nicolas Labarre Bio","scryfallId":"260e570f-e86f-4c7f-ae69-c601de1405d8"},{"index":53399,"token":false,"name":"Research the Deep","scryfallId":"927bab71-a208-4ff2-b6c9-51b63468db38"},{"index":53402,"token":false,"name":"Battle Brawler","scryfallId":"7c9b5baf-6163-48a9-b58d-195edfeb437d"},{"index":53403,"token":false,"name":"Muzzle","scryfallId":"8b3048ec-bcbf-4a69-b56f-83bbe82b68e5"},{"index":53418,"token":false,"name":"Morsel Theft","scryfallId":"cac48152-81c0-4cdc-8e3c-bfbe7b068b28"},{"index":53433,"token":false,"name":"Ugin's Conjurant","scryfallId":"9957ecca-5ea0-446f-bfd3-46c2aaa42f08"},{"index":53436,"token":false,"name":"Dream Coat","scryfallId":"07edbbf4-c3d6-4ec1-ae9b-4ae202fb6998"},{"index":53437,"token":false,"name":"Predatory Advantage","scryfallId":"595ae3af-cc28-407a-a045-a6d71cd6be60"},{"index":53438,"token":false,"name":"Twisted Experiment","scryfallId":"64e37889-7dc0-476b-8b99-8f06881d352c"},{"index":53439,"token":false,"name":"Timbermaw Larva","scryfallId":"d68fc3bc-eb3b-4504-93a3-8943d07b23f8"},{"index":53442,"token":false,"name":"Littjara Kinseekers","scryfallId":"c119f836-0707-49e2-b6d4-25f849d054a4"},{"index":53447,"token":false,"name":"Rubbleback Rhino","scryfallId":"51daaf9b-d8a8-49a6-94e1-0c8be2c6188b"},{"index":53450,"token":false,"name":"Excavation Mole","scryfallId":"3a1712dc-8f4c-407f-83ea-3a1c59c437d1"},{"index":53464,"token":false,"name":"Swarmborn Giant","scryfallId":"84a3ddf9-b682-4691-bb1d-abd1d3486f59"},{"index":53472,"token":false,"name":"Political Trickery","scryfallId":"05b5c8a2-7713-47c1-b426-c4ced59aeb49"},{"index":53503,"token":false,"name":"Vebulid","scryfallId":"d5623194-0cd9-4f3f-bab1-133d6b1e94fe"},{"index":53505,"token":false,"name":"Forerunner of the Empire","scryfallId":"947644ab-02b3-4ebe-b62a-c087ab205ab0"},{"index":53523,"token":false,"name":"Hallowed Moonlight","scryfallId":"94fd0c0f-4a6a-47cf-9f50-df0bbf19aae4"},{"index":53527,"token":false,"name":"Curse of Death's Hold","scryfallId":"1774d0a8-1cd3-4582-ace0-1caff92af0e7"},{"index":53534,"token":false,"name":"Moonhold","scryfallId":"c72245a8-6f5e-4564-804f-30407c1c4e57"},{"index":53536,"token":false,"name":"Arcbound Lancer","scryfallId":"7ff3241b-49ba-4243-b8fc-fef600836c8c"},{"index":53538,"token":false,"name":"Bone Shaman","scryfallId":"0a5e3d54-4dc4-482b-8ecc-bb819ba03d2c"},{"index":53539,"token":false,"name":"Fatal Lore","scryfallId":"24ba0b83-9671-4ee7-996d-57a3616b9c66"},{"index":53541,"token":false,"name":"Harbinger of Night","scryfallId":"33124133-ed2c-4b86-a135-ac76f4fe4da5"},{"index":53547,"token":false,"name":"Ruthless Deathfang","scryfallId":"93d99f0d-f5d4-4480-ac5e-fe9ff808416e"},{"index":53549,"token":false,"name":"Moorland Drifter","scryfallId":"5839942c-0ad1-4f77-97a0-142b8ef2266c"},{"index":53562,"token":false,"name":"Wingrattle Scarecrow","scryfallId":"61c5d86e-1ce1-4386-b70f-73b24351d6ae"},{"index":53563,"token":true,"name":"Julien Nuijten Decklist","scryfallId":"18eee350-4d70-4124-ae0d-a77f3bd7e948"},{"index":53568,"token":false,"name":"Might Makes Right","scryfallId":"75c63c02-a75b-4880-b9fa-6f4bcf90ede5"},{"index":53570,"token":false,"name":"Mox Amber","scryfallId":"66024e69-ad60-4c9a-a0ca-da138d33ad80"},{"index":53577,"token":false,"name":"Sacred Guide","scryfallId":"7f10c37d-d25a-47d6-83b0-dbe0a9cfc938"},{"index":53585,"token":false,"name":"Suleiman's Legacy","scryfallId":"3a15e970-e605-425a-b4ec-391d9cacde38"},{"index":53586,"token":false,"name":"Vizkopa Confessor","scryfallId":"cac639b9-6c20-45ac-a61f-082bdcebdb83"},{"index":53587,"token":false,"name":"Guild Summit","scryfallId":"d952259f-9e0a-49af-9dfb-3cad1a1bb3a8"},{"index":53588,"token":true,"name":"Pirates","scryfallId":"86e37d8b-916c-49bd-9af6-99f75889d8e3"},{"index":53590,"token":false,"name":"Slaughter Drone","scryfallId":"275b1185-49aa-45ae-8e2d-12aa469a7d77"},{"index":53594,"token":false,"name":"Wand of the Elements","scryfallId":"1131c187-8fc3-4cee-9422-355ef6622de7"},{"index":53599,"token":false,"name":"Kami of the Waning Moon","scryfallId":"23a395a6-b1f5-4b7f-87cc-c77b4d497e9a"},{"index":53616,"token":false,"name":"Noble Quarry","scryfallId":"d5fd4994-afce-496b-8682-0fee208e68ec"},{"index":53620,"token":false,"name":"Shocker","scryfallId":"90954848-af7e-47b3-82e7-9fedde6ad606"},{"index":53631,"token":false,"name":"Ajani's Welcome","scryfallId":"c9045fcb-b633-4c35-8058-6234311551ae"},{"index":53651,"token":false,"name":"Thundering Tanadon","scryfallId":"e2fab443-0f4b-45ea-8a6d-435b93803409"},{"index":53653,"token":false,"name":"Huddle Up","scryfallId":"202e69fd-fdf6-4b40-815b-107049e19edf"},{"index":53654,"token":false,"name":"Rewards of Diversity","scryfallId":"04116b38-8fb1-47c6-b68d-060d0fc4a60d"},{"index":53662,"token":false,"name":"Titanic Ultimatum","scryfallId":"a9b86d97-3cfa-4510-a3da-1a85cd8d2ba9"},{"index":53663,"token":false,"name":"Omnibian","scryfallId":"3eb70bdf-16af-46bf-a78b-bd3bdd9134ae"},{"index":53664,"token":false,"name":"Field of Reality","scryfallId":"2ff7c6fc-324b-4cff-9109-6d817767865f"},{"index":53666,"token":false,"name":"Ghastlord of Fugue","scryfallId":"8b118200-55e0-4d06-9e7e-ecde2814d24e"},{"index":53667,"token":false,"name":"Loyal Gyrfalcon","scryfallId":"547f9f53-0a54-4097-9bb5-8a39732c7016"},{"index":53680,"token":false,"name":"High Alert","scryfallId":"ce124f6e-ef0c-4d01-a876-e34d3e445108"},{"index":53681,"token":false,"name":"Flourishing Strike","scryfallId":"9c4b23a5-d997-4f02-b136-44ee7be51c7b"},{"index":53692,"token":false,"name":"Blessing of the Nephilim","scryfallId":"689b4ba1-5bb5-458d-8900-19a330e0093c"},{"index":53693,"token":false,"name":"Briar Shield","scryfallId":"68100ac2-9677-4eb5-93dc-54e49b15985d"},{"index":53702,"token":false,"name":"Typhoon","scryfallId":"254e0403-67d8-4e73-8d89-c901ebeba49f"},{"index":53704,"token":false,"name":"Shadow Glider","scryfallId":"b4ffaf62-2e12-4b1d-a590-f63aacb4a30b"},{"index":53714,"token":false,"name":"Chilling Apparition","scryfallId":"c20edb71-aa1d-437b-bcfb-953efbe45150"},{"index":53719,"token":false,"name":"Volley Veteran","scryfallId":"b4c8e3b3-c8bb-415d-a19f-45ec679108ee"},{"index":53720,"token":false,"name":"Gemini Engine","scryfallId":"2e03e05b-011b-4695-950b-98dd7643b8a0"},{"index":53731,"token":false,"name":"Shockmaw Dragon","scryfallId":"e4810919-b379-40db-a68b-a769dd3ee32d"},{"index":53742,"token":false,"name":"Resourceful Return","scryfallId":"32f57d0b-ab6a-4074-885d-678659729b8a"},{"index":53747,"token":false,"name":"Rackling","scryfallId":"10f82f2e-a6db-491b-b253-82c34cd6c940"},{"index":53750,"token":false,"name":"Stormsurge Kraken","scryfallId":"ed1c1121-593d-4780-a1d0-5fbd2c09a9f2"},{"index":53752,"token":false,"name":"Quagmire Lamprey","scryfallId":"3c91c44e-6bfc-4595-9cdb-17d73f912c09"},{"index":53757,"token":false,"name":"Bog-Strider Ash","scryfallId":"310a1b54-56d9-496a-b910-90cc55996ad4"},{"index":53759,"token":false,"name":"Kodama of the North Tree","scryfallId":"2d9b5c33-63c4-4ddd-9f04-37bb36970b43"},{"index":53766,"token":false,"name":"Ugin's Nexus","scryfallId":"94002868-a48a-4ea8-bfce-17257078f5db"},{"index":53770,"token":false,"name":"Curse of Oblivion","scryfallId":"c15cbd2f-8bbf-423a-81fe-521fd99bc8bf"},{"index":53774,"token":false,"name":"Reaver Drone","scryfallId":"162f3fb8-75b7-4cd7-9d6c-27dd76197aa5"},{"index":53780,"token":true,"name":"Skeleton Token (B, 1/1)","scryfallId":"6894192e-782b-49ef-b9fc-28b76e2268ab"},{"index":53782,"token":false,"name":"Uktabi Efreet","scryfallId":"3678a224-d314-4108-8a39-de0c1b635b5c"},{"index":53788,"token":false,"name":"Whispersteel Dagger","scryfallId":"2bcf89c2-32cc-4c26-8fe4-8cf54f5a2675"},{"index":53792,"token":false,"name":"Karametra's Favor","scryfallId":"77026cf6-7e89-41a6-8279-de1068569a02"},{"index":53800,"token":false,"name":"Ballynock Trapper","scryfallId":"6b10d37b-2cbc-4061-b25a-ad8ff3944ad3"},{"index":53802,"token":false,"name":"Raging Poltergeist","scryfallId":"78833788-ffb2-43fc-9345-975f1cd46f38"},{"index":53805,"token":false,"name":"Ethereal Usher","scryfallId":"908901b7-fb40-4358-bca5-5e71bdafcbe7"},{"index":53811,"token":false,"name":"Kami of the Tended Garden","scryfallId":"bdedd830-9200-4e8b-84b4-00dc58cace35"},{"index":53817,"token":false,"name":"Paraselene","scryfallId":"406380ab-2695-4084-99a5-f5560304f8cb"},{"index":53820,"token":false,"name":"Pulverize","scryfallId":"afbbc44d-60fb-45fc-a588-14aab0340134"},{"index":53842,"token":false,"name":"Samite Elder","scryfallId":"b3c5dccc-2a48-4dcc-a796-fa6fdc11a14e"},{"index":53844,"token":false,"name":"Llanowar Cavalry","scryfallId":"21d92191-a743-4916-bbe4-5e207e964d9b"},{"index":53845,"token":false,"name":"Rick, Steadfast Leader","scryfallId":"0a8e78b3-3232-4d48-9d6c-540951a0330e"},{"index":53847,"token":false,"name":"Walking Dead","scryfallId":"d7533a72-77d1-40cd-b3a1-7597d566c428"},{"index":53859,"token":false,"name":"Ursine Fylgja","scryfallId":"1ad7c141-2e20-4891-93a8-1cf309d3b979"},{"index":53874,"token":false,"name":"Rouse the Mob","scryfallId":"64a07e7d-e203-4ecd-98bf-f8ef08c38d78"},{"index":53877,"token":false,"name":"Thorn of Amethyst","scryfallId":"e472d4f5-add4-4de3-8718-31a47a35277c"},{"index":53890,"token":false,"name":"Retribution of the Ancients","scryfallId":"0d3ee29d-b374-471d-80c3-bcad7a4226e6"},{"index":53892,"token":false,"name":"Trench Gorger","scryfallId":"b631b71b-78f6-41bc-a26a-c761ee1671a1"},{"index":53895,"token":false,"name":"Chain to Memory","scryfallId":"fa0e1a22-8f27-4c5b-a65c-c35abd2ff05b"},{"index":53900,"token":false,"name":"Mercurial Kite","scryfallId":"a6bc8655-ae27-40be-8d61-e80a5924e955"},{"index":53904,"token":false,"name":"Vital Surge","scryfallId":"ba28f326-67d1-4afb-90fe-e9f036210942"},{"index":53908,"token":false,"name":"Psionic Sliver","scryfallId":"2559ca03-4442-47c5-bd6e-84e71cfa6ca5"},{"index":53914,"token":false,"name":"Final Judgment","scryfallId":"2503e136-031f-498a-b042-4077baebe8f8"},{"index":53915,"token":false,"name":"Drinker of Sorrow","scryfallId":"2bc8758b-68cc-45ab-85d0-b870cef7dd85"},{"index":53924,"token":false,"name":"Goblin Replica","scryfallId":"63282976-e08d-4b8c-bbfc-f6739fdaeaf9"},{"index":53925,"token":false,"name":"Checkpoint Officer","scryfallId":"4a0e12f5-7b15-4a8c-b045-35bcbf1fbb90"},{"index":53929,"token":false,"name":"Mist Dragon","scryfallId":"3b9b4be4-74c8-4fe5-a5e4-de57c11e8ec1"},{"index":53939,"token":false,"name":"Disciple of Kangee","scryfallId":"e268fe16-070b-4b78-9793-59755edb2fd5"},{"index":53943,"token":false,"name":"Melt Terrain","scryfallId":"1d94a1d1-6d24-46e1-9568-42e1a810ad31"},{"index":53946,"token":false,"name":"Seasoned Pyromancer","scryfallId":"2e139ad1-1079-49e9-babd-6399c44ad333"},{"index":53947,"token":false,"name":"Kinetic Augur","scryfallId":"dc5e8221-fc2d-4d90-80f3-729606648c54"},{"index":53951,"token":false,"name":"Unnatural Endurance","scryfallId":"ac497133-a44a-4acc-ba7e-8fc1fae7e226"},{"index":53952,"token":false,"name":"Silk Net","scryfallId":"9498a97a-0e32-4eb8-9cb4-0698ff3a7ded"},{"index":53956,"token":false,"name":"Phyrexian Walker","scryfallId":"9f8a3979-2947-4692-8b2f-d4c07c534777"},{"index":53960,"token":false,"name":"Thermal Navigator","scryfallId":"eb86854f-c933-4b6c-bd0a-67c3615e908f"},{"index":53961,"token":false,"name":"Barbed Wire","scryfallId":"be9e2e59-1527-4c61-9cc9-dcaf1181bd43"},{"index":53964,"token":false,"name":"Storm Fleet Arsonist","scryfallId":"8d8ecb6d-f794-468b-8399-60a50aaa13ac"},{"index":53966,"token":false,"name":"Buoyancy","scryfallId":"b208dad2-a412-45fd-b19a-d370426ef5b8"},{"index":53972,"token":false,"name":"Monomania","scryfallId":"6af53d7f-7f02-4c35-b6f4-7365d121ba54"},{"index":53977,"token":false,"name":"Rakka Mar","scryfallId":"5d569b01-af52-41a6-9ce4-02ed2e057038"},{"index":53978,"token":false,"name":"Manabond","scryfallId":"6f94ab94-5a8f-4422-8927-0b7da85c3119"},{"index":53984,"token":false,"name":"Soul Tithe","scryfallId":"77e546ce-f498-4136-9015-bb262c301716"},{"index":53986,"token":false,"name":"Scalding Cauldron","scryfallId":"710d2782-2b23-441f-9890-6fa9c923b701"},{"index":53991,"token":false,"name":"Torment","scryfallId":"fe74a415-ea8f-4f16-8889-ae649f1483b2"},{"index":53992,"token":false,"name":"Betrayal","scryfallId":"7f9b5c75-882e-4fe4-827f-584080e91485"},{"index":53996,"token":false,"name":"Mishra's Groundbreaker","scryfallId":"74e2dc26-30aa-4e20-84b0-ea4be8894475"},{"index":54000,"token":false,"name":"Phyrexian Crusader","scryfallId":"32aaa8b9-987b-4809-8a54-aa29bdc18805"},{"index":54003,"token":false,"name":"Shauku's Minion","scryfallId":"6e9743dc-031b-4932-80a6-1c8ec1dea069"},{"index":54010,"token":false,"name":"Stone Catapult","scryfallId":"60303bfe-9158-4e25-a905-6522883ab671"},{"index":54026,"token":false,"name":"Midnight Covenant","scryfallId":"5d797e91-3fc7-4f62-8cd8-dbd5f445e69c"},{"index":54032,"token":false,"name":"Sootwalkers","scryfallId":"f36c7932-cc1e-4b1f-ae39-2f04b84bcddb"},{"index":54042,"token":false,"name":"Karn's Temporal Sundering","scryfallId":"7a64c1a4-02ce-49d2-97f2-970b8c33672d"},{"index":54051,"token":false,"name":"Nyxborn Brute","scryfallId":"05bc4236-566f-401b-b9d7-f58126fa228b"},{"index":54054,"token":false,"name":"Solitary Hunter // One of the Pack","scryfallId":"6c200ef1-ea08-48d4-ab50-77940a0e08c3"},{"index":54056,"token":false,"name":"Glintwing Invoker","scryfallId":"16184709-f370-40cc-91f2-849a44ac451a"},{"index":54062,"token":false,"name":"Nightsky Mimic","scryfallId":"70dbda67-3bc4-4c8a-8357-250d84d0d1d8"},{"index":54073,"token":false,"name":"Marble Chalice","scryfallId":"b76e9580-9154-476b-923f-b23bf55db026"},{"index":54077,"token":false,"name":"Boneyard Mycodrax","scryfallId":"f6ac1131-8e96-46be-85e0-55844d0d2935"},{"index":54083,"token":false,"name":"Mythic Proportions","scryfallId":"829069cf-7e63-4443-b679-65ad15d6ca5e"},{"index":54087,"token":false,"name":"Trained Caracal","scryfallId":"797e45d1-d17d-40c0-bfdf-ec533784e676"},{"index":54089,"token":false,"name":"Shaleskin Bruiser","scryfallId":"fc2de8a4-0d84-4f7c-bbe4-3a31172186ab"},{"index":54100,"token":false,"name":"Experimental Overload","scryfallId":"6f1bace4-a327-4eb6-a6ef-8394e76c06b7"},{"index":54104,"token":false,"name":"Expedition Envoy","scryfallId":"41193ef1-1619-4448-9905-26b05079c79a"},{"index":54117,"token":false,"name":"Resculpt","scryfallId":"1bfb1fcb-a411-4c1c-b8fc-496242ae3a9b"},{"index":54122,"token":false,"name":"Knucklebone Witch","scryfallId":"7d66b355-9aff-4cce-ae4a-42b233475dcf"},{"index":54123,"token":false,"name":"Snapping Creeper","scryfallId":"8860c3d5-8b93-4c52-b374-8814fb8546bd"},{"index":54125,"token":false,"name":"Furnace Spirit","scryfallId":"b6a79dc7-ce46-41f7-9375-8d12afe6355a"},{"index":54126,"token":false,"name":"Gods' Hall Guardian","scryfallId":"e8e645c8-90ac-4865-b441-e64251d6c9a8"},{"index":54131,"token":false,"name":"Leaf Dancer","scryfallId":"aebab65c-7d5f-4086-8eb1-7dc445e801e9"},{"index":54132,"token":false,"name":"Greven, Predator Captain","scryfallId":"bda22fc3-31a5-451a-9a8b-372884f7bc61"},{"index":54133,"token":false,"name":"Standardize","scryfallId":"f2c79e64-91bf-4e87-a4fd-3136ea67c5bb"},{"index":54135,"token":false,"name":"Shuko","scryfallId":"a47456b8-cef8-4085-90b1-92788e16fd27"},{"index":54137,"token":false,"name":"Sliver Hive","scryfallId":"91cef7ce-aa9f-4659-ac24-394c5ab9f77c"},{"index":54144,"token":false,"name":"Arms Dealer","scryfallId":"dafea45d-be00-428d-a127-70e6a14efe3f"},{"index":54145,"token":false,"name":"Pilgrim of the Fires","scryfallId":"45a60623-d523-4b43-89b0-8e89568546c7"},{"index":54149,"token":false,"name":"Veil of Birds","scryfallId":"55bd3fac-44b6-4078-a096-8d47b01ea979"},{"index":54153,"token":false,"name":"Gaea's Skyfolk","scryfallId":"8a564432-c2b3-4cf6-b4bc-2e2600b92911"},{"index":54155,"token":false,"name":"Nantuko Tracer","scryfallId":"16b93c93-5944-4289-bc5a-30b6e73b0dfd"},{"index":54158,"token":false,"name":"Ebony Owl Netsuke","scryfallId":"39e0c24f-2312-4b40-9cd1-2b83d501e485"},{"index":54163,"token":false,"name":"Geosurge","scryfallId":"118b7aa3-bb05-4691-978e-51486435bf05"},{"index":54174,"token":false,"name":"Flooded Woodlands","scryfallId":"de89e9e1-485b-42e5-9728-5d6f948999e1"},{"index":54177,"token":false,"name":"Halt Order","scryfallId":"7fed18af-7301-4d03-ba7c-e94f07f078b3"},{"index":54190,"token":false,"name":"Pounce","scryfallId":"2b96cba6-33d7-4e1d-88f7-da3da681540d"},{"index":54201,"token":false,"name":"Disappear","scryfallId":"bdf280f4-74a1-4e6f-aec6-1852f04204e4"},{"index":54202,"token":false,"name":"Duskmantle Guildmage","scryfallId":"9a1509ff-387e-4ccd-bda0-86e8738a98fb"},{"index":54204,"token":false,"name":"Ajani's Presence","scryfallId":"e77e2fd5-5c46-4f6b-ac43-ec23fab57a1a"},{"index":54207,"token":false,"name":"Giant Harbinger","scryfallId":"1f72f461-98d7-45e0-9968-9afb240fbf1e"},{"index":54208,"token":false,"name":"Deity of Scars","scryfallId":"7efc2cc8-2445-4d64-b1c5-26483efbcc30"},{"index":54209,"token":false,"name":"Inner Fire","scryfallId":"b1d886a2-ae83-4d95-9ec0-582c563181e6"},{"index":54215,"token":false,"name":"Gosta Dirk","scryfallId":"92ef316b-dd22-40d1-82e8-8890976684c0"},{"index":54217,"token":false,"name":"Scorch the Fields","scryfallId":"05c4338d-e5c0-46b4-ab16-1f9aa97b4026"},{"index":54225,"token":false,"name":"Five-Alarm Fire","scryfallId":"fb550d0c-2261-4f41-a2b1-d185f0bce86a"},{"index":54230,"token":false,"name":"Tasseled Dromedary","scryfallId":"9cef3bf2-55cf-4f42-9ec0-fa921ef22311"},{"index":54232,"token":false,"name":"Seafarer's Quay","scryfallId":"66641d88-b3f0-4bcd-8d2d-29aa2de69e30"},{"index":54233,"token":false,"name":"Woodland Chasm","scryfallId":"b2dd0b71-5a60-418c-82fc-f13d1b5075d0"},{"index":54236,"token":false,"name":"Saving Grasp","scryfallId":"914837df-c255-4cea-9255-b05f218fd9f8"},{"index":54242,"token":false,"name":"Edgewall Innkeeper","scryfallId":"7c5d0560-f9e6-4c70-8cce-cae61e4e74bc"},{"index":54243,"token":false,"name":"Mental Discipline","scryfallId":"5e9ffd83-b5c9-46b4-bc5a-172ca34ddc79"},{"index":54254,"token":false,"name":"Defy Gravity","scryfallId":"c31e6c69-e5c4-47b0-b226-4e1d84fabfa7"},{"index":54298,"token":false,"name":"Tuktuk Rubblefort","scryfallId":"02eedf9d-e26c-405c-aee5-1b3493dc5e9b"},{"index":54301,"token":false,"name":"Teferi's Time Twist","scryfallId":"c878bdc0-d697-4a2f-bba5-758b27f4247a"},{"index":54308,"token":false,"name":"Ethereal Elk","scryfallId":"3f4d0ed2-3fc5-4cb0-b886-e30b21e76872"},{"index":54317,"token":false,"name":"Stone Kavu","scryfallId":"36a1cdca-d48c-4936-ad6a-4610aeb991ce"},{"index":54320,"token":true,"name":"Soldier Ally Token (W, 1/1)","scryfallId":"05abf2df-833f-4172-af74-6533b022dfa9"},{"index":54326,"token":false,"name":"Preemptive Strike","scryfallId":"c2314bf1-b22d-48c2-860f-e1081f56296b"},{"index":54337,"token":false,"name":"Nimana Skitter-Sneak","scryfallId":"ea080141-6262-4595-8058-b2969b3f016b"},{"index":54340,"token":false,"name":"Siren Reaver","scryfallId":"1e5827a7-8ee3-4a89-b936-00a3283ddad3"},{"index":54353,"token":false,"name":"Goldmeadow Stalwart","scryfallId":"6a7a9110-6aea-460b-91fa-5f8a507160e7"},{"index":54358,"token":false,"name":"Strands of Undeath","scryfallId":"93ced365-f445-4a4a-b33f-986279404fde"},{"index":54360,"token":false,"name":"Crashing Drawbridge","scryfallId":"b7d7108f-635c-423b-988a-bc8fc4c6edef"},{"index":54362,"token":false,"name":"Rites of Refusal","scryfallId":"fa88f595-1b6f-4af0-bc50-bd07c8be431f"},{"index":54367,"token":false,"name":"Reduce in Stature","scryfallId":"8bad1d13-c4f6-4440-9988-e1db40039f02"},{"index":54368,"token":false,"name":"Cyclops Electromancer","scryfallId":"da0966a6-f378-4975-88ae-23b600d578bf"},{"index":54370,"token":true,"name":"Doctor","scryfallId":"bcee10b9-beef-42cf-8042-abc3fb252900"},{"index":54373,"token":false,"name":"Curtains' Call","scryfallId":"dd71fd53-5c84-4d08-a7f5-16657413ac4c"},{"index":54379,"token":false,"name":"Seedtime","scryfallId":"4ffd5c52-f260-400c-b088-8792282509a5"},{"index":54386,"token":false,"name":"Manticore of the Gauntlet","scryfallId":"82b6ece3-1574-4634-b940-829e54c4f78d"},{"index":54388,"token":false,"name":"Vona, Butcher of Magan","scryfallId":"c1fd4101-d531-43aa-9cb6-79e36a8121d8"},{"index":54396,"token":false,"name":"Patron of the Wild","scryfallId":"7f7a0810-3970-454f-8381-700d6c6aefdc"},{"index":54400,"token":false,"name":"Shrieking Affliction","scryfallId":"dfd08894-2534-4114-9365-40809ba95eb2"},{"index":54414,"token":false,"name":"Hatchet Bully","scryfallId":"1d99d1c2-3c24-47b6-97eb-ae1d8726948e"},{"index":54415,"token":false,"name":"Wild Ceratok","scryfallId":"4464e11a-c5b9-40ea-8be0-dab29d14e289"},{"index":54419,"token":false,"name":"Blossoming Defense","scryfallId":"f466278e-1d5f-4af8-9c88-02b156e121bc"},{"index":54424,"token":false,"name":"Mass Appeal","scryfallId":"dfe9ae51-fd2b-45ca-a780-725f51f897b2"},{"index":54429,"token":false,"name":"Verdant Field","scryfallId":"d123da53-9fd3-492b-beb7-76d1c0f5e4f6"},{"index":54444,"token":false,"name":"Rayne, Academy Chancellor","scryfallId":"8ee6480c-7697-47e2-893b-ca88c0ab3376"},{"index":54446,"token":false,"name":"Myr Propagator","scryfallId":"837e4b25-d70b-48d8-aaad-9622ad93e154"},{"index":54448,"token":false,"name":"Fell Shepherd","scryfallId":"afd27b8d-3c1f-401b-aad1-268a7aa79f0f"},{"index":54449,"token":false,"name":"Markov Patrician","scryfallId":"29c3d3f7-5e28-4fec-8422-87856fcd1e8e"},{"index":54454,"token":false,"name":"Riftstone Portal","scryfallId":"92ece630-e484-4221-911f-e32048894f23"},{"index":54457,"token":false,"name":"Moaning Wall","scryfallId":"ef494f81-638a-4e5d-b987-0dde7f2a135c"},{"index":54460,"token":false,"name":"Demonic Taskmaster","scryfallId":"fb5d6266-30a7-4360-84bc-22b52fb782b3"},{"index":54466,"token":true,"name":"Honored Hydra Token (W, 6/6)","scryfallId":"7365ffff-b171-4275-9fdb-e622f8456858"},{"index":54471,"token":false,"name":"Blinding Fog","scryfallId":"bae7d501-72a1-43c2-9f72-d768ac5e9320"},{"index":54484,"token":false,"name":"Kuro's Taken","scryfallId":"1e301a46-f321-4fa6-a8c4-08dd4079a458"},{"index":54496,"token":false,"name":"Woodcloaker","scryfallId":"4aa85e09-a1cd-473d-98cd-c6a7c7aff949"},{"index":54505,"token":false,"name":"Undercity Shade","scryfallId":"6609aa2e-6832-4c20-beda-e5f2506bf9b2"},{"index":54515,"token":false,"name":"Direct Current","scryfallId":"166b0d75-824c-4c04-833b-7f7c69569a18"},{"index":54517,"token":false,"name":"Dross Golem","scryfallId":"1df2f4fd-b96a-4537-93a4-38141b0fa577"},{"index":54526,"token":false,"name":"Xanthic Statue","scryfallId":"8becb285-cd91-4de0-af59-ddaa7d8c5366"},{"index":54546,"token":false,"name":"Scorching Missile","scryfallId":"0672960b-4cb5-4ed6-ba3c-6b97290e0330"},{"index":54547,"token":false,"name":"Tyrant's Scorn","scryfallId":"b7e2708c-2824-4925-b529-d625deb77924"},{"index":54550,"token":false,"name":"Shaper Guildmage","scryfallId":"4a9304e1-f403-404d-9fe9-169da75e0d62"},{"index":54551,"token":false,"name":"Black Poplar Shaman","scryfallId":"11a1fc03-5719-49ed-9d53-d8ea5693373e"},{"index":54553,"token":false,"name":"Wolfir Avenger","scryfallId":"88cc00e5-9683-4ccc-a914-c422b76f6014"},{"index":54554,"token":false,"name":"Kaboom!","scryfallId":"1e81e5fc-0e18-4dd8-a505-aa7dba8521a8"},{"index":54566,"token":false,"name":"Kumano's Blessing","scryfallId":"56f0d9aa-4270-41cd-8993-765354c03d03"},{"index":54571,"token":false,"name":"Warbriar Blessing","scryfallId":"11d64cab-2ed1-46d9-8034-0c2ba3f2e1ed"},{"index":54574,"token":false,"name":"Pious Warrior","scryfallId":"bc20c1f0-9883-484c-88d8-1cab08d0b210"},{"index":54575,"token":false,"name":"Chronatog Totem","scryfallId":"5acd482c-9815-4ff5-99ef-fb1a014251bb"},{"index":54576,"token":false,"name":"Arashin Cleric","scryfallId":"10aeac19-6892-448e-9e5f-302051a089fc"},{"index":54578,"token":false,"name":"Hysterical Blindness","scryfallId":"5aeaa757-e3b0-4606-a689-e8a20a686c3a"},{"index":54586,"token":false,"name":"Sonic Assault","scryfallId":"cc61a398-cf16-415b-b3cf-897217dc7cc9"},{"index":54600,"token":false,"name":"Bala Ged Thief","scryfallId":"0b4598ec-cf36-4a51-9f67-b91c146c3c4f"},{"index":54601,"token":false,"name":"Ignite Memories","scryfallId":"2f7b7831-27a1-4c0a-8ed1-6dddf2754d65"},{"index":54611,"token":false,"name":"Outrage Shaman","scryfallId":"8bf2b2fb-d521-42ea-a6de-f80054b8a4a6"},{"index":54614,"token":false,"name":"Maraleaf Pixie","scryfallId":"e6d7f9c9-dd83-4684-a949-1c22f316138a"},{"index":54619,"token":false,"name":"Vexing Beetle","scryfallId":"d599d35f-1b73-498b-9a21-831c908a95d8"},{"index":54620,"token":false,"name":"Silverskin Armor","scryfallId":"d1dba839-bd1e-4ce8-ab90-005eb1f0102e"},{"index":54624,"token":false,"name":"Wild Colos","scryfallId":"2d39f746-7b82-476a-9774-3375debb47bd"},{"index":54626,"token":false,"name":"Heal the Scars","scryfallId":"b802a7fe-9c8b-4bc3-95d8-4a5dafcf2c75"},{"index":54631,"token":false,"name":"Deliberate","scryfallId":"c41c0dd0-fef2-4f3c-8f3c-9c9c521b5442"},{"index":54635,"token":false,"name":"Coastal Drake","scryfallId":"f87aaa74-26c6-4057-84b9-a007383684a5"},{"index":54639,"token":false,"name":"Elvish Doomsayer","scryfallId":"7b1264d2-c7c8-477f-84f6-c17b422aa45e"},{"index":54650,"token":false,"name":"Fallow Wurm","scryfallId":"1ba02b6f-6010-47a4-8670-406391a52a68"},{"index":54662,"token":false,"name":"Crude Rampart","scryfallId":"af5d1be2-d6ae-4820-aa01-62f261b0f110"},{"index":54667,"token":false,"name":"Waker of Waves","scryfallId":"abb47990-a5a9-4a22-a8bb-d229b17132c6"},{"index":54675,"token":false,"name":"Scion of Vitu-Ghazi","scryfallId":"3cd20865-0a9a-4a72-92f9-77c8d6384b46"},{"index":54678,"token":false,"name":"Pyrostatic Pillar","scryfallId":"5973cd53-f6cd-4edc-b952-f6d3eef97988"},{"index":54680,"token":false,"name":"Voice of Duty","scryfallId":"1c648e59-c872-4e04-b45f-2729b42410af"},{"index":54688,"token":false,"name":"Saddled Rimestag","scryfallId":"a0e8491f-9c51-41c0-994e-d3f0f5f6a411"},{"index":54715,"token":false,"name":"Leashling","scryfallId":"132551d3-ef8e-4ed0-a363-53db4f0621f0"},{"index":54716,"token":false,"name":"Rhox Oracle","scryfallId":"281f04d5-af45-4494-ac11-a605d3a06643"},{"index":54718,"token":false,"name":"Kiri-Onna","scryfallId":"dafb963c-18a5-4770-afb9-0121c614de40"},{"index":54721,"token":false,"name":"Funeral Pyre","scryfallId":"4d8542f6-ee34-42c6-acd5-07b0c7cc2f63"},{"index":54726,"token":false,"name":"Shapesharer","scryfallId":"e148481d-a969-40d9-9335-d0e06ad8245b"},{"index":54730,"token":false,"name":"Sentinel of the Eternal Watch","scryfallId":"0a7b01ce-2729-4b70-ae0a-b9a1007be78f"},{"index":54734,"token":false,"name":"Ophiomancer","scryfallId":"66d80dd1-b944-4cb2-8578-b4dbcabbbc1e"},{"index":54741,"token":false,"name":"Strongarm Tactics","scryfallId":"57dcf434-5c67-440a-8b67-2df7307e92bd"},{"index":54748,"token":false,"name":"Phalanx Formation","scryfallId":"7e9aaba1-e480-4667-b3c9-d5665a3b4806"},{"index":54749,"token":false,"name":"Field Surgeon","scryfallId":"bb830403-0832-47f7-b4b4-4f241f1b9112"},{"index":54753,"token":false,"name":"Desperate Castaways","scryfallId":"b00721f9-1519-4524-92e2-d146b7ed12bb"},{"index":54755,"token":false,"name":"Viashino Bladescout","scryfallId":"41fce1b3-0961-4672-845f-e1c6ce101c1b"},{"index":54761,"token":false,"name":"Elite Instructor","scryfallId":"821cd2dd-aa03-4c55-b9e4-98e0284889d3"},{"index":54776,"token":false,"name":"Twist Allegiance","scryfallId":"24b6607c-0c34-4ffc-b1b7-154417492766"},{"index":54785,"token":false,"name":"Vigilant Baloth","scryfallId":"34ad8e5d-0c26-4588-8161-b22197715d63"},{"index":54787,"token":false,"name":"Cateran Summons","scryfallId":"af3de1f9-9038-4352-b4bf-2e9c5c27495a"},{"index":54788,"token":false,"name":"Kamahl's Sledge","scryfallId":"38c55518-7bdf-4a42-ae30-cd6525557a59"},{"index":54790,"token":false,"name":"Trapped in the Tower","scryfallId":"974e84ce-5b51-4bd7-9a4d-b64d8f8f62d4"},{"index":54798,"token":false,"name":"Chancellor of the Spires","scryfallId":"b1e06e16-96fa-4611-b4a9-512eeeeddd3c"},{"index":54804,"token":false,"name":"Femeref Scouts","scryfallId":"60192ded-689b-4cc5-9293-bff52924089b"},{"index":54805,"token":false,"name":"Skyshroud Blessing","scryfallId":"c0c10b16-97b1-4a36-b2b4-f0c28ead3eb4"},{"index":54810,"token":false,"name":"Skalla Wolf","scryfallId":"f320e9f2-963d-468a-bf7a-726ef11e886d"},{"index":54821,"token":false,"name":"Sacred Armory","scryfallId":"b05fde97-ab24-40c9-a1db-8844c3e62fc3"},{"index":54823,"token":false,"name":"Frost Marsh","scryfallId":"e9320033-d8d7-4a01-80db-60de222040e6"},{"index":54826,"token":false,"name":"Redcap Melee","scryfallId":"6bd1dd34-d480-4dfd-9f82-73c4e24a11fc"},{"index":54829,"token":false,"name":"Tusked Colossodon","scryfallId":"2d511407-0c1e-4342-a578-ca557c6886fd"},{"index":54834,"token":false,"name":"Daybreak Coronet","scryfallId":"21f6f35e-26b4-465d-9026-ffaa869c7722"},{"index":54836,"token":true,"name":"Brian Hacker Bio","scryfallId":"a8d38af0-a960-4a49-9896-1e11f53eab5b"},{"index":54852,"token":false,"name":"Lure of Prey","scryfallId":"7165f1d8-7b31-4a81-aab4-c6cd4ff2e67d"},{"index":54863,"token":false,"name":"Cream of the Crop","scryfallId":"030b0a9d-d0cf-4f3a-97b3-3e1d59226ee6"},{"index":54864,"token":false,"name":"Warcry Phoenix","scryfallId":"ff561f01-8dbc-4988-be00-592d1e417396"},{"index":54873,"token":false,"name":"Archaeomender","scryfallId":"22bb8779-ac19-43d6-b818-86eb8ee2f87d"},{"index":54874,"token":false,"name":"Moonwing Moth","scryfallId":"f646ed53-c323-4f84-b8c9-39e31da1aca8"},{"index":54875,"token":false,"name":"Urborg Stalker","scryfallId":"2d33e3d5-c608-4ba8-8614-0b9d0385af64"},{"index":54877,"token":false,"name":"Daring Buccaneer","scryfallId":"1d413b88-8f5d-415f-bd07-169f6c175e6b"},{"index":54883,"token":false,"name":"Auriok Sunchaser","scryfallId":"e274a8b3-2d92-43d9-a436-d3f6f619ca95"},{"index":54889,"token":false,"name":"Thriss, Nantuko Primus","scryfallId":"ad9e647d-903f-4a77-a56c-cd5c0c2f12cf"},{"index":54899,"token":false,"name":"Firewild Borderpost","scryfallId":"eb37a8bd-6b6c-47f3-b7a0-5a20fa2d507c"},{"index":54900,"token":false,"name":"Wanderwine Hub","scryfallId":"ccec69de-7203-4810-a8ec-8748705ee3a2"},{"index":54902,"token":false,"name":"Light of Hope","scryfallId":"bcb00599-e082-49b0-88f3-ef91b75595e4"},{"index":54919,"token":false,"name":"Illusionary Servant","scryfallId":"b2348f3e-8c08-4250-95a9-fc5ed63cd725"},{"index":54945,"token":false,"name":"Dagger of the Worthy","scryfallId":"abe9d9d7-bc4e-4367-b27c-e8d6e430467e"},{"index":54950,"token":false,"name":"Ray of Erasure","scryfallId":"5a09fc0b-7b9c-4283-8336-f2607f5ffaf5"},{"index":54952,"token":false,"name":"Bogardan Phoenix","scryfallId":"253db28a-3873-4364-80d7-a8164000ea9e"},{"index":54958,"token":false,"name":"Nourishing Shoal","scryfallId":"4a6af212-2a94-4ddf-acdc-d70fafa1c5ee"},{"index":54965,"token":false,"name":"Dross Harvester","scryfallId":"b088832c-6119-4460-98b7-ae25cf70b2c5"},{"index":54968,"token":false,"name":"Gravegouger","scryfallId":"acfcd559-374e-4e6f-9333-2e5c855abff5"},{"index":54974,"token":false,"name":"Broken Concentration","scryfallId":"252eef1f-0a62-420d-aad8-e3d7f1e07c1b"},{"index":54975,"token":false,"name":"Exhilarating Elocution","scryfallId":"8468417d-7ef5-43e0-9190-e88f3eed9e82"},{"index":54978,"token":false,"name":"Environmental Sciences","scryfallId":"46b394fc-a99c-44e7-9226-da0699167541"},{"index":54979,"token":false,"name":"Beloved Chaplain","scryfallId":"decec62b-7ac4-4097-9215-5db18db2dec6"},{"index":54981,"token":false,"name":"Thran Tome","scryfallId":"63db7360-fe6e-430f-bfee-a2f80bcb6fec"},{"index":54984,"token":false,"name":"Stag Beetle","scryfallId":"72cc64b9-f5b9-42d3-9921-564c4c9f2c77"},{"index":54986,"token":false,"name":"Spellweaver Eternal","scryfallId":"10466618-a867-4ec2-8e8c-e7217e06ea62"},{"index":54992,"token":false,"name":"Draugr's Helm","scryfallId":"fd4aade3-b1e3-43d1-b4a8-6b55ecdb4327"},{"index":54999,"token":false,"name":"Warhorn Blast","scryfallId":"3fc98aff-edc0-4f78-ae4f-e08735c9e512"},{"index":55007,"token":false,"name":"Fleshformer","scryfallId":"00c57090-c1fe-4100-a03c-95607074280e"},{"index":55013,"token":false,"name":"Gonti's Machinations","scryfallId":"6c97f5a9-6e04-45c3-aa8d-dcf0fd81d5b9"},{"index":55016,"token":false,"name":"Tainted Strike","scryfallId":"d0f82007-99f6-4c6c-8182-ee631c33531f"},{"index":55028,"token":false,"name":"Okina, Temple to the Grandfathers","scryfallId":"ee8cf7aa-388c-47ec-be59-6ba98f3853cb"},{"index":55031,"token":false,"name":"Jadecraft Artisan","scryfallId":"2b745934-c1fe-49f5-bda4-b0eafa1408e1"},{"index":55036,"token":false,"name":"Aerathi Berserker","scryfallId":"06673800-22a7-4ee3-92fa-7c7cd4865d30"},{"index":55050,"token":false,"name":"Soilshaper","scryfallId":"ae4066c3-bcb0-41c4-a4d3-a22bd186fd13"},{"index":55057,"token":false,"name":"Barren Glory","scryfallId":"12220d53-3356-4541-aa43-a0de6ed3f7d0"},{"index":55059,"token":false,"name":"Slingshot Goblin","scryfallId":"81825aef-bef7-46b7-bf52-29e32c1836b0"},{"index":55061,"token":false,"name":"Ashenmoor Cohort","scryfallId":"ebdef552-17d0-4b48-868e-058af02101be"},{"index":55071,"token":false,"name":"Twisted Reflection","scryfallId":"f1d4d408-df74-45f7-925b-3cbff9a0304c"},{"index":55074,"token":false,"name":"Wand of Denial","scryfallId":"0b1c856f-6d29-4bfc-976e-7875d60abd52"},{"index":55076,"token":false,"name":"Irradiate","scryfallId":"7e0460cf-ff87-4cf8-89b5-a8b9fb7322e0"},{"index":55081,"token":false,"name":"Stormrider Spirit","scryfallId":"9c0fb4be-df73-43a9-bd48-fd47a4190fc1"},{"index":55084,"token":false,"name":"Aether Barrier","scryfallId":"36298f9f-12cc-43bd-adda-ccabd67a9568"},{"index":55096,"token":false,"name":"Graveblade Marauder","scryfallId":"85880be1-65b2-432f-8788-79716e4c8066"},{"index":55101,"token":false,"name":"Amulet of Unmaking","scryfallId":"fdbd94c8-611c-4b20-99ca-dd2d7661d644"},{"index":55114,"token":false,"name":"Clinging Mists","scryfallId":"e0152975-790a-40e4-993e-a970676a2d32"},{"index":55118,"token":false,"name":"Conjured Currency","scryfallId":"a7c2ea6e-7d29-4526-b135-9bbb1eed9d4a"},{"index":55119,"token":false,"name":"Strafe","scryfallId":"ec8b77cf-9c1e-4c8f-b452-295cc1570d0e"},{"index":55125,"token":false,"name":"Implode","scryfallId":"a76ee318-8126-4ebf-884d-8369ae8726ac"},{"index":55126,"token":false,"name":"Captive Audience","scryfallId":"065f63b2-472e-4148-8294-88ed38a5685f"},{"index":55131,"token":false,"name":"Pick the Brain","scryfallId":"53503e59-6b6c-4de1-8528-458ab94f4e9a"},{"index":55140,"token":false,"name":"Revelsong Horn","scryfallId":"10a4801c-fa69-47a0-bdfa-f5f110fd0976"},{"index":55148,"token":false,"name":"Auriok Glaivemaster","scryfallId":"97cce4d4-bff2-4dbb-bc12-1a726ad82dd4"},{"index":55155,"token":false,"name":"Bog Smugglers","scryfallId":"c2103a44-87e5-40cd-a0de-cd19456a8366"},{"index":55162,"token":false,"name":"Mark of the Oni","scryfallId":"632679e5-7368-4660-a765-07be196c3c35"},{"index":55173,"token":false,"name":"Contempt","scryfallId":"c1fa8e60-c32f-4586-b133-224f0aec3355"},{"index":55174,"token":false,"name":"Intervention Pact","scryfallId":"bca127ef-349e-4380-875d-49c14fa03b18"},{"index":55186,"token":false,"name":"Goblin Heelcutter","scryfallId":"5b3bfeb6-95d6-4f00-8981-c6d3c9c93f67"},{"index":55191,"token":false,"name":"Alexi's Cloak","scryfallId":"457a5613-d1d4-4112-8484-f40120079b7b"},{"index":55195,"token":false,"name":"Stabbing Pain","scryfallId":"89c31d9d-fd77-4275-b89c-f9b64073c54b"},{"index":55199,"token":true,"name":"City's Blessing","scryfallId":"ba64ed3e-93c5-406f-a38d-65cc68472122"},{"index":55204,"token":false,"name":"Rhystic Lightning","scryfallId":"21ce365e-3002-42e9-aeb5-1b845408271e"},{"index":55206,"token":false,"name":"Sunseed Nurturer","scryfallId":"9d44447e-09d1-450f-907f-42f79b004fe7"},{"index":55210,"token":false,"name":"Calming Verse","scryfallId":"ec38c856-dc21-450d-9aa6-da16c91a489a"},{"index":55211,"token":false,"name":"Valor of the Worthy","scryfallId":"83632e73-be3f-43fc-932f-45cb1af4f8fb"},{"index":55216,"token":false,"name":"Mad Ratter","scryfallId":"9a4cabcc-fb29-4bf2-b5ba-32b8c96aefd6"},{"index":55217,"token":false,"name":"Drowner of Secrets","scryfallId":"149aa77e-fc10-4b9b-8f38-cc6db5be7b79"},{"index":55219,"token":false,"name":"Dark Inquiry","scryfallId":"42eaa634-0add-4e3d-9eee-5712598dda3f"},{"index":55220,"token":false,"name":"Alpha Tyrranax","scryfallId":"4a2e5279-f28c-4a78-9f8a-16c9f72f8d38"},{"index":55223,"token":false,"name":"Experimental Aviator","scryfallId":"962dc573-612d-434b-82fb-af9c3e3c9aca"},{"index":55224,"token":false,"name":"Spinning Wheel","scryfallId":"070ff479-9d87-4ab6-aaaa-e96b9df0bac4"},{"index":55231,"token":false,"name":"Pillar of Origins","scryfallId":"f888facd-e462-4794-a774-d765d1a1edfd"},{"index":55242,"token":false,"name":"Stern Constable","scryfallId":"4f0f87d4-5fed-415c-918a-c3546697a3da"},{"index":55244,"token":false,"name":"Coastal Breach","scryfallId":"bf8b550a-c86f-4684-a4f6-14e75172324f"},{"index":55247,"token":false,"name":"Oblivion Crown","scryfallId":"0cd5486b-c6f4-4cfc-9590-8ffc78b48b0a"},{"index":55248,"token":true,"name":"Pest Token (B/G, 1/1)","scryfallId":"d0ddbe3e-4a66-494d-9304-7471232549bf"},{"index":55254,"token":false,"name":"Seal Away","scryfallId":"8f8d6588-671d-4eb3-874f-f7139da2e05a"},{"index":55261,"token":false,"name":"Neko-Te","scryfallId":"13884a26-1e30-40d7-ae38-494154a5cf85"},{"index":55264,"token":false,"name":"Dive Bomber","scryfallId":"65162b24-8a3b-4b92-a831-6f23f809c76f"},{"index":55268,"token":false,"name":"Castle Sengir","scryfallId":"16bfba30-4075-4bd6-9e4b-3a37641d43ce"},{"index":55274,"token":false,"name":"Reclaim the Wastes","scryfallId":"805faf2e-97dc-4b77-bc02-a4cae980f041"},{"index":55276,"token":false,"name":"Geth's Verdict","scryfallId":"7a20b5a2-8613-49ed-b5cc-7cae9d0e0850"},{"index":55286,"token":false,"name":"Brine Seer","scryfallId":"2f6e5575-b004-417f-9366-6ba7840a79e7"},{"index":55289,"token":false,"name":"Caverns of Despair","scryfallId":"209f7479-b3a0-4c27-9602-78babb8d2e99"},{"index":55294,"token":false,"name":"Hobgoblin Dragoon","scryfallId":"090223a1-2644-4b81-a9f5-d15ca6df5229"},{"index":55314,"token":false,"name":"Painful Quandary","scryfallId":"fecf3dae-1a0c-4cf3-b9bd-ec2ad6acaa1b"},{"index":55315,"token":false,"name":"Resounding Thunder","scryfallId":"680b7955-d939-4195-aba8-b46a8c925616"},{"index":55327,"token":false,"name":"Golem Foundry","scryfallId":"3cef2e6a-e46b-4425-b507-3213cfd1400c"},{"index":55328,"token":false,"name":"Spitting Sliver","scryfallId":"cd07649e-c7fc-44f7-ab23-0fb935aff8c7"},{"index":55330,"token":false,"name":"Rotcrown Ghoul","scryfallId":"f13b5ba6-0de1-4f5c-867b-57e2c10bde8e"},{"index":55335,"token":false,"name":"Guard Duty","scryfallId":"f77efd36-f9e7-4c34-a6ee-9e1c9b273fb7"},{"index":55337,"token":false,"name":"Flowstone Giant","scryfallId":"46e8240a-d882-4f60-8960-1856284e04a0"},{"index":55338,"token":false,"name":"Shinen of Flight's Wings","scryfallId":"67cdad5d-5979-4bbd-90a4-00173d23707b"},{"index":55340,"token":false,"name":"Bloodletter Quill","scryfallId":"b8fbdf87-2424-4fc2-904e-b1e5fef2a335"},{"index":55341,"token":false,"name":"Stone Idol Trap","scryfallId":"44dee4b3-f3c1-4ef5-8dfa-fa10c860be1e"},{"index":55346,"token":false,"name":"Close Quarters","scryfallId":"1b9131c7-4e46-4c01-80b3-a6b055439346"},{"index":55348,"token":false,"name":"Minamo's Meddling","scryfallId":"502c4aca-98f8-4c7d-89fd-ee42c938fac7"},{"index":55352,"token":false,"name":"Gilded Sentinel","scryfallId":"01cc1a59-76bf-4721-b4a7-ef746f3d3990"},{"index":55354,"token":false,"name":"Trove Warden","scryfallId":"3336593c-c83c-48e7-9173-2c2b74b94d3b"},{"index":55356,"token":false,"name":"Tajic, Blade of the Legion","scryfallId":"be5717c1-338e-446c-aa7e-93e79e4abb72"},{"index":55364,"token":false,"name":"Krovikan Plague","scryfallId":"b258e192-20af-4a45-981f-05181f4cd997"},{"index":55366,"token":false,"name":"Wreath of Geists","scryfallId":"7604e22e-1f29-4a8f-b887-b18f43e3745e"},{"index":55368,"token":false,"name":"Phyrexian Purge","scryfallId":"312bbc1b-4c2a-44c1-8e62-c0f94fd2ba8e"},{"index":55370,"token":false,"name":"Gaea's Avenger","scryfallId":"39d763bd-b0a9-46ba-bcd2-9304063446f2"},{"index":55371,"token":false,"name":"Unholy Heat","scryfallId":"2b73d294-6ab1-4051-9b0f-d8e335d37674"},{"index":55374,"token":false,"name":"Peace and Quiet","scryfallId":"5d73accc-8f19-44d4-8216-c1acdbef3856"},{"index":55376,"token":true,"name":"Plant Token (G, 0/2)","scryfallId":"642d1d93-22d0-43f9-8691-6790876185a0"},{"index":55378,"token":true,"name":"Ben Rubin Bio","scryfallId":"06e4ce71-a557-4a05-a163-9f28b8f6479b"},{"index":55381,"token":false,"name":"Words of Wilding","scryfallId":"fdb9565f-5b09-4127-b169-3146079dab84"},{"index":55382,"token":false,"name":"Rooftop Storm","scryfallId":"ab01d871-ba50-400a-95e7-09af9e34405f"},{"index":55390,"token":false,"name":"Kessig Malcontents","scryfallId":"dce9a30f-a850-4826-a255-ce511d567b60"},{"index":55393,"token":true,"name":"Illusion Token (U, 0/2)","scryfallId":"ccc3d8da-9005-44d9-bb10-18cdac7a32f5"},{"index":55395,"token":false,"name":"Sudden Substitution","scryfallId":"9f7983bf-2a3b-4428-8c01-35285f589da8"},{"index":55397,"token":false,"name":"Devour in Flames","scryfallId":"432dd78b-9520-4c28-8699-d7ff9c477070"},{"index":55403,"token":false,"name":"Sage's Knowledge","scryfallId":"156d7c70-6c6d-4052-9d44-029ba1bb66e4"},{"index":55405,"token":false,"name":"Dargo, the Shipwrecker","scryfallId":"5cd87cf8-4d5d-4aba-8dfa-800b1fb3799b"},{"index":55407,"token":false,"name":"Dire Tactics","scryfallId":"e0e3974e-3753-4f25-8930-6d96b40332ce"},{"index":55412,"token":false,"name":"Littjara Glade-Warden","scryfallId":"a92dde51-310e-4f28-bd3b-d43b639785ec"},{"index":55416,"token":false,"name":"Incursion Specialist","scryfallId":"290e56e0-e699-413a-9d6a-e740bf460b35"},{"index":55421,"token":false,"name":"Cult of the Waxing Moon","scryfallId":"d2a13669-4656-476a-8984-ec3d47960907"},{"index":55422,"token":false,"name":"Giltgrove Stalker","scryfallId":"47963f87-d5c2-4e5b-8dff-b25735182841"},{"index":55428,"token":false,"name":"All That Glitters","scryfallId":"d9713032-2956-4564-b5f5-2dd16245a4e6"},{"index":55439,"token":false,"name":"Daemogoth Woe-Eater","scryfallId":"c965cbe3-50e5-41bb-bdb9-e65d97aab716"},{"index":55445,"token":false,"name":"Lullmage's Familiar","scryfallId":"b31a81e8-df0e-4540-93c1-c30c31ea9be9"},{"index":55451,"token":false,"name":"Turntimber Ranger","scryfallId":"a24bba56-3256-489b-82a2-22748388e110"},{"index":55452,"token":true,"name":"Jan Tomcani Decklist","scryfallId":"e2ffc06e-fed9-4241-9fa5-0d11858765a6"},{"index":55454,"token":false,"name":"Tar Fiend","scryfallId":"fa1903f8-2863-4203-9552-a75759fa8c94"},{"index":55467,"token":false,"name":"Ancient Spring","scryfallId":"004eefa4-947b-45fc-b45c-5263bfd763bc"},{"index":55471,"token":false,"name":"Growth Spasm","scryfallId":"61d6a649-ae48-4cf1-b0e3-ba627b4ac1e1"},{"index":55503,"token":false,"name":"Sakashima the Impostor","scryfallId":"7e56f614-cba4-49d9-b5fc-7566abba4a10"},{"index":55509,"token":false,"name":"Ark of Blight","scryfallId":"f3b09956-cc34-4472-8b9f-ae355522bd5a"},{"index":55516,"token":false,"name":"Howling Gale","scryfallId":"9917cf32-0236-4463-9b1d-e8193754ff97"},{"index":55517,"token":false,"name":"Heliophial","scryfallId":"4d65fa8e-6944-4fe8-b7b4-c77dfbddf605"},{"index":55520,"token":false,"name":"Tangle Hulk","scryfallId":"8ed3c301-8d8e-45fe-902a-af03a79525be"},{"index":55526,"token":false,"name":"Chilling Grasp","scryfallId":"60d85d58-eae3-4f9d-8f54-440fa6ded95b"},{"index":55536,"token":false,"name":"Psychic Strike","scryfallId":"0d87927c-80a6-4146-92a5-58c510ce7958"},{"index":55540,"token":false,"name":"Hypnotic Siren","scryfallId":"3b2f562f-00d1-41da-a6ac-bc019cce7fe7"},{"index":55542,"token":true,"name":"Lizard Token (G, 2/2)","scryfallId":"83790fd3-f371-494c-97a2-3aa469a399f1"},{"index":55550,"token":false,"name":"Centaur Omenreader","scryfallId":"5807814f-7b18-431a-8031-898ff70ad69f"},{"index":55555,"token":false,"name":"Spawning Breath","scryfallId":"90ec1540-e8cb-4edc-a3b3-f71423cb46fc"},{"index":55561,"token":false,"name":"Warped Physique","scryfallId":"30859a76-8ef6-4468-8e7c-fd21837d2a6c"},{"index":55566,"token":false,"name":"Volatile Rig","scryfallId":"5055ed18-b234-4702-92eb-4d483431ff47"},{"index":55571,"token":false,"name":"Goblin Firebug","scryfallId":"2370d319-d1d2-4bca-9275-ff72fb400709"},{"index":55573,"token":false,"name":"Chromatic Armor","scryfallId":"2657e85b-8f77-41fa-9df2-233443efef43"},{"index":55578,"token":false,"name":"Mending Touch","scryfallId":"c042c7ee-0e74-4ca5-bbb9-2898b0576f0a"},{"index":55582,"token":false,"name":"Tenza, Godo's Maul","scryfallId":"e1aa03d7-ac4f-4793-8f8d-5ffd2f8f38b1"},{"index":55584,"token":false,"name":"Wu Admiral","scryfallId":"499ae191-80ac-42bf-b49d-db343803bd56"},{"index":55615,"token":false,"name":"Soaring Thought-Thief","scryfallId":"0d73c9c4-8955-499f-8f87-6500b35b4977"},{"index":55625,"token":false,"name":"Venomspout Brackus","scryfallId":"0774771c-5373-4636-9174-d06e7d635183"},{"index":55627,"token":true,"name":"Homunculus Token (U, 0/1)","scryfallId":"3546df95-926d-421d-a763-e559a1847273"},{"index":55635,"token":false,"name":"Vivien, Nature's Avenger","scryfallId":"f7ead409-3bce-47c8-ace7-498c38522369"},{"index":55640,"token":false,"name":"Geistcatcher's Rig","scryfallId":"cfb8ecf0-8c12-4a14-9a75-4cc5bf9e47f1"},{"index":55642,"token":false,"name":"Lich's Tomb","scryfallId":"ca24a105-e32a-4b2c-99bf-cfd85bae6229"},{"index":55645,"token":false,"name":"Death Charmer","scryfallId":"e58a303a-9f7a-43e7-bcba-c58b378a53ce"},{"index":55661,"token":false,"name":"Necra Disciple","scryfallId":"ae7a771f-bd21-4388-857f-08160b24e26e"},{"index":55662,"token":false,"name":"Varolz, the Scar-Striped","scryfallId":"4c3ae3db-c14a-4ffc-805c-a3a51da9370d"},{"index":55665,"token":false,"name":"Wall of Lava","scryfallId":"b99d6d11-b3f7-4d73-967c-3049af82a9d8"},{"index":55668,"token":false,"name":"Shimmer","scryfallId":"5c892daa-57fe-4712-b64a-6099d531bb26"},{"index":55672,"token":false,"name":"Graveshifter","scryfallId":"128c516b-7eb1-4f81-8b54-428bd0649d92"},{"index":55678,"token":false,"name":"Dogpile","scryfallId":"26316b00-22db-4546-8366-8a624f10c1ba"},{"index":55692,"token":false,"name":"Assault Zeppelid","scryfallId":"12bf6443-c941-418a-a766-05bba088a117"},{"index":55693,"token":false,"name":"Juniper Order Druid","scryfallId":"cb211704-ff8e-498b-b7bb-f8384f198ffd"},{"index":55694,"token":true,"name":"Mask","scryfallId":"b21b5504-c5ef-4dfc-8219-8db90aca7694"},{"index":55703,"token":false,"name":"Labyrinth Champion","scryfallId":"3f86d035-a86d-4c2a-a19d-3b90e0f9ff0f"},{"index":55708,"token":false,"name":"Kheru Bloodsucker","scryfallId":"baf15cd4-13be-48e7-b3f5-a5106eb02c45"},{"index":55711,"token":false,"name":"Vectis Silencers","scryfallId":"c0198220-073f-4479-a1c4-1bd626891e28"},{"index":55720,"token":false,"name":"Devout Witness","scryfallId":"48ca7aeb-09db-4409-9ba2-c5c5500ad72f"},{"index":55721,"token":false,"name":"Moonbow Illusionist","scryfallId":"f4960789-1a45-4273-b2f2-34713f19d697"},{"index":55723,"token":false,"name":"Hero's Resolve","scryfallId":"b4cdcc7c-0d01-4aa2-8934-079dfc00eef2"},{"index":55731,"token":false,"name":"Street Sweeper","scryfallId":"4a62827a-183f-4bef-b6ce-20a4577f6d30"},{"index":55734,"token":false,"name":"Tortoise Formation","scryfallId":"59ff8324-42b8-4eeb-8d0b-ea679c984933"},{"index":55735,"token":false,"name":"Endure","scryfallId":"dd7904ba-0764-4dd3-9c78-35f799e99049"},{"index":55737,"token":false,"name":"Korozda Monitor","scryfallId":"2f319d57-7a54-4b10-86d4-58d7b3994844"},{"index":55739,"token":false,"name":"Gurzigost","scryfallId":"f4e672c6-6ddc-4dd2-b4c7-5083d7566e87"},{"index":55741,"token":false,"name":"Mind Maggots","scryfallId":"c3c92a7f-a250-4497-aa7a-0394e94ef13d"},{"index":55756,"token":false,"name":"Ajani, Wise Counselor","scryfallId":"b4a22ecc-3a5c-44a1-bb52-bbeffa2dbf17"},{"index":55769,"token":false,"name":"Smelt-Ward Minotaur","scryfallId":"f851d74e-90ad-417f-8372-8437d2d68b0d"},{"index":55771,"token":false,"name":"Doomsday Specter","scryfallId":"85206cc1-5484-40c6-b11d-b8d6fad4fc5c"},{"index":55773,"token":false,"name":"Sigil of Distinction","scryfallId":"a4ac2d98-bc5d-4823-9903-b880988ff0f4"},{"index":55775,"token":false,"name":"Concussive Bolt","scryfallId":"41b68e85-a381-441d-aa18-491f9e202a10"},{"index":55780,"token":true,"name":"Dinosaur Beast Token (G, */*)","scryfallId":"9d447365-3aca-4996-9098-efcbe6f28f57"},{"index":55785,"token":false,"name":"Huatli's Raptor","scryfallId":"ba680ad0-6134-46e0-8fcb-532b2052eca7"},{"index":55789,"token":false,"name":"Paupers' Cage","scryfallId":"3411c350-a940-4172-b558-f5dc44b4fb33"},{"index":55791,"token":false,"name":"Glyph of Destruction","scryfallId":"8e9c153c-9224-491b-bc84-8a9f0a83ee5a"},{"index":55793,"token":true,"name":"On an Adventure","scryfallId":"a8d50cf9-03e6-467a-aadf-84a24106ffa9"},{"index":55796,"token":false,"name":"Skittish Kavu","scryfallId":"be806378-50a7-4416-9d99-1ea2c1f2b7cb"},{"index":55800,"token":false,"name":"Scampering Scorcher","scryfallId":"dccbe031-1547-4fa5-ba9a-caa1b1f5eb5d"},{"index":55808,"token":false,"name":"Soul-Guide Lantern","scryfallId":"7c850b94-75c9-4457-8b5e-1193352d6fcb"},{"index":55810,"token":false,"name":"Unnatural Predation","scryfallId":"2798fdff-0b39-41b6-b0ec-c4f449ca3314"},{"index":55811,"token":false,"name":"Grozoth","scryfallId":"96d81c13-93de-4cf6-bb15-d387ed259c50"},{"index":55814,"token":false,"name":"Hunt Down","scryfallId":"cb783652-6450-4789-8ec1-b057b39c6a4b"},{"index":55816,"token":false,"name":"Doomskar Titan","scryfallId":"a4e125e4-103f-4a68-b85f-1382646da71e"},{"index":55818,"token":false,"name":"Task Mage Assembly","scryfallId":"258a9cdd-c626-404e-b82d-01091f11f107"},{"index":55820,"token":false,"name":"Foriysian Interceptor","scryfallId":"833a3622-9f24-47a3-816f-1732c0e077d0"},{"index":55824,"token":false,"name":"Break Through the Line","scryfallId":"81c1cdbe-5ddb-4cc6-975b-42f3f1ee4749"},{"index":55826,"token":true,"name":"Fractal Token (G/U, 0/0)","scryfallId":"910f48ab-b04e-4874-b31d-a86a7bc5af14"},{"index":55827,"token":false,"name":"Spin Engine","scryfallId":"fc820134-ae9a-4c99-a869-cee7f1f6d79b"},{"index":55846,"token":false,"name":"Slow Motion","scryfallId":"2860a20d-e1bf-4e46-8c07-a858f616d5a5"},{"index":55852,"token":false,"name":"Tresserhorn Skyknight","scryfallId":"b852d9f9-069d-419a-b8d1-db30c72aaac6"},{"index":55853,"token":false,"name":"Deface","scryfallId":"43df9f41-944e-4cf3-ac80-524eadac221d"},{"index":55856,"token":false,"name":"Festering March","scryfallId":"2c34e6aa-0414-45ba-b6eb-1ac4255d7de8"},{"index":55878,"token":false,"name":"Tome Shredder","scryfallId":"a7cc9ea8-db4e-4f41-800f-fb0dbcb2c345"},{"index":55886,"token":false,"name":"Tears of Valakut","scryfallId":"db858823-ae8b-4da1-be6f-aee541e008ae"},{"index":55887,"token":false,"name":"Crypt Incursion","scryfallId":"c3b71cc5-0a81-4cab-bae3-49335c04aaaa"},{"index":55895,"token":false,"name":"Starved Rusalka","scryfallId":"25b4aec5-0a7d-4b1c-8819-ea675d415eac"},{"index":55896,"token":false,"name":"Moonlit Wake","scryfallId":"1eba9595-6789-4d7a-9e46-8d1f75993b21"},{"index":55901,"token":false,"name":"Cunning Nightbonder","scryfallId":"adb202e7-f9a4-4785-840d-18aa6aa663b4"},{"index":55907,"token":false,"name":"Mercadian Lift","scryfallId":"395a1a8a-785f-442b-8e95-8b4ca44af2a3"},{"index":55909,"token":false,"name":"Pale Rider of Trostad","scryfallId":"8dad70b8-0dec-4634-a31a-b78438a313a2"},{"index":55921,"token":false,"name":"Erebos's Emissary","scryfallId":"5aa96f63-d5c3-47d3-a54d-a67883406fc5"},{"index":55923,"token":false,"name":"Boreal Griffin","scryfallId":"36638e20-0a1d-4ea3-936c-2ea74add868a"},{"index":55925,"token":false,"name":"Jeskai Student","scryfallId":"9007c528-0107-40fd-a97e-e5576f297eb2"},{"index":55931,"token":false,"name":"Douser of Lights","scryfallId":"7c554be7-6fd4-4642-aaa0-2781d9c388e4"},{"index":55932,"token":false,"name":"Gearshift Ace","scryfallId":"a4de0229-408d-4db8-bf9a-ee6e85416322"},{"index":55938,"token":false,"name":"Otepec Huntmaster","scryfallId":"c334e6f3-1378-4429-b4f1-fa8ed7ab7123"},{"index":55939,"token":false,"name":"Brass Gnat","scryfallId":"386ae7c6-347c-4b29-b7a9-3ca3bb050396"},{"index":55942,"token":false,"name":"Bouncing Beebles","scryfallId":"8656bdd4-0c45-43f9-b2dc-d11a355ff747"},{"index":55943,"token":false,"name":"Prying Questions","scryfallId":"ac9fcf7c-8785-4285-b583-7060edabc3c6"},{"index":55944,"token":true,"name":"Tree-Hugging","scryfallId":"4570eb3b-c91b-41f2-b72c-65b41787f0a6"},{"index":55947,"token":false,"name":"Spiritualize","scryfallId":"f6780ded-86df-419d-b63b-6b67d2960b28"},{"index":55961,"token":false,"name":"Probe","scryfallId":"a2a58d18-3d52-4178-86b2-7590d4164e76"},{"index":55964,"token":false,"name":"Defensive Maneuvers","scryfallId":"58f9eb25-4140-4ecf-bcaa-1b193d884007"},{"index":55965,"token":false,"name":"Rabid Rats","scryfallId":"ed8c028e-6656-47ef-97fb-de99f8833d5f"},{"index":55966,"token":false,"name":"Breathstealer's Crypt","scryfallId":"f87ace53-d77c-4df5-b200-4be2ac2b7fdb"},{"index":55969,"token":false,"name":"Charmed Griffin","scryfallId":"66d36960-3c78-4032-9325-8002b2a48503"},{"index":55970,"token":false,"name":"Siege of Towers","scryfallId":"4db24da9-8901-4e2d-9565-39ce1b7639c9"},{"index":55975,"token":false,"name":"Drana's Silencer","scryfallId":"59224f9a-deb2-4dd4-b2d4-967232c14254"},{"index":55980,"token":false,"name":"Shorecrasher Elemental","scryfallId":"e8890fc6-45e9-443d-ae86-f1acb1ebd0aa"},{"index":55984,"token":false,"name":"Sorin's Guide","scryfallId":"416b000d-77d0-4c83-bbbd-d1107f746dde"},{"index":55985,"token":false,"name":"Touch of Vitae","scryfallId":"48d2cd18-a24d-40e0-a654-777d9e623ae2"},{"index":55987,"token":false,"name":"Leyline of Lifeforce","scryfallId":"f7caffa7-29bd-455c-9770-94a0ad7ef5e3"},{"index":55990,"token":false,"name":"Boneclad Necromancer","scryfallId":"ab9ed2b9-5fb9-4633-8c9a-0594ae7c49c7"},{"index":56001,"token":false,"name":"Skeletal Snake","scryfallId":"42bd4896-4191-4479-be57-070753f8725c"},{"index":56005,"token":false,"name":"Nexus of Fate","scryfallId":"f163cfbf-6df6-4af5-9fe4-23b0d511586a"},{"index":56010,"token":false,"name":"Auriok Steelshaper","scryfallId":"4dd09c01-5a77-4992-96ae-c395a5966a92"},{"index":56012,"token":false,"name":"Oko's Accomplices","scryfallId":"71c52b50-35aa-4858-8c8e-c81dcb29a7fc"},{"index":56019,"token":false,"name":"Abandon Reason","scryfallId":"18c0b3b3-bb62-42c5-9869-386af0540a9b"},{"index":56026,"token":false,"name":"Fuel for the Cause","scryfallId":"4126e0e5-9b23-496f-8a09-7a35499f9a09"},{"index":56039,"token":false,"name":"Flooded Shoreline","scryfallId":"49db9f58-380f-496e-9d3d-6776d30fb564"},{"index":56042,"token":false,"name":"Grid Monitor","scryfallId":"c4ab6c59-cd0f-4c29-8e26-6882dca61fb7"},{"index":56044,"token":false,"name":"Turbulent Dreams","scryfallId":"d879226b-8ee3-4a48-b03a-d183594dc586"},{"index":56047,"token":false,"name":"Grimclaw Bats","scryfallId":"132d6ed5-0bbc-465e-bc30-3174c910b435"},{"index":56050,"token":false,"name":"Bazaar Trader","scryfallId":"9235ef13-a363-4cab-b69d-39093a621a5c"},{"index":56052,"token":true,"name":"Saproling // Saproling Token (G, 1/1)","scryfallId":"8ce60642-e207-46e6-b198-d803ff3b47f4"},{"index":56056,"token":false,"name":"Pillar of Light","scryfallId":"018ff99e-a23d-4440-8c5c-cfb4942f1906"},{"index":56060,"token":false,"name":"Darksteel Pendant","scryfallId":"9c1bac5f-c41a-49f0-94b0-79653b6fa67a"},{"index":56061,"token":false,"name":"Thriving Turtle","scryfallId":"5d6e23d4-3306-40d6-9138-9c189af1ea0e"},{"index":56068,"token":false,"name":"Vampiric Embrace","scryfallId":"889be765-5716-4549-b544-0a49d3962e16"},{"index":56070,"token":false,"name":"Rhystic Cave","scryfallId":"4ae74463-4426-4ad4-b7a2-324694854245"},{"index":56075,"token":false,"name":"Hedron Blade","scryfallId":"87242e1d-babe-4b0d-aa1f-ab62e0bc4ab7"},{"index":56095,"token":false,"name":"Firefiend Elemental","scryfallId":"55051412-8749-4b65-ac76-c20ef57fd2e3"},{"index":56101,"token":false,"name":"Snag","scryfallId":"7401df8b-23e7-4485-9ed4-70118a66feed"},{"index":56108,"token":false,"name":"Druid's Call","scryfallId":"e22318a5-80c8-4fa3-ad05-8d3035caf336"},{"index":56115,"token":false,"name":"Setessan Petitioner","scryfallId":"384495c2-238b-4f8d-89c2-e05b64f9dde0"},{"index":56120,"token":false,"name":"Primal Whisperer","scryfallId":"c777432f-7965-4ad8-8d53-93919ae767d4"},{"index":56121,"token":false,"name":"Whisperer of the Wilds","scryfallId":"2cf17d8a-c7ee-4909-bc80-4138dcfe7e67"},{"index":56139,"token":false,"name":"Oboro Breezecaller","scryfallId":"a382a9b8-0b19-46c2-a547-a22d6e23d0ac"},{"index":56141,"token":false,"name":"Lava Storm","scryfallId":"61fcd58e-e5e2-45f4-9edd-300a871ae5f5"},{"index":56156,"token":false,"name":"War Dance","scryfallId":"392b4acf-4548-47dd-be58-bdf4ca4ece7e"},{"index":56157,"token":false,"name":"Snorting Gahr","scryfallId":"e568503e-a886-4c8b-9d46-8520c2cdda48"},{"index":56158,"token":false,"name":"Invigorating Surge","scryfallId":"531e1fc0-a3aa-4b57-87b2-79a31af5c922"},{"index":56167,"token":false,"name":"Thirsting Bloodlord","scryfallId":"599e8ed3-4341-4373-8871-2768a90d98c1"},{"index":56171,"token":true,"name":"Alex Borteh Bio","scryfallId":"3e1fef54-5665-480d-ad3d-e5490a6853e4"},{"index":56178,"token":false,"name":"Ravaged Highlands","scryfallId":"bb60ffc9-4919-40f2-bdd6-07eee6abf37c"},{"index":56181,"token":false,"name":"Mosscoat Goriak","scryfallId":"c23139d4-0db5-4683-8d49-f4600fbe29e2"},{"index":56197,"token":true,"name":"Citizen Token (B/G/R/U/W, 2/2)","scryfallId":"de7ba875-f77b-404f-8b75-4ba6f81da410"},{"index":56200,"token":false,"name":"Godhead of Awe","scryfallId":"7e34d294-c0ec-4e3c-a731-31b7a29c59b4"},{"index":56204,"token":false,"name":"Sins of the Past","scryfallId":"5c518792-a50f-40b1-b6fb-674432093b6a"},{"index":56206,"token":false,"name":"Profound Journey","scryfallId":"fd2dcfe8-ced4-44f2-8268-68035a4d4d58"},{"index":56212,"token":false,"name":"Riptide Chimera","scryfallId":"e9f88da5-b013-478a-8a0b-da9d1e8eb2c9"},{"index":56217,"token":false,"name":"Veiled Crocodile","scryfallId":"9be15ae1-5262-40ba-937c-217a33d131da"},{"index":56222,"token":false,"name":"Vineweft","scryfallId":"4578f064-e9f8-4e87-8f46-7536af6c144e"},{"index":56225,"token":false,"name":"Sunlit Hoplite","scryfallId":"2f89cf0f-f682-44f8-879c-ed1e22f849b0"},{"index":56234,"token":false,"name":"Crypt Cobra","scryfallId":"4f7bcd36-13e2-4ac7-a449-246cecb3fc0f"},{"index":56236,"token":false,"name":"Teferi, Timeless Voyager","scryfallId":"62d05287-ad7f-4de8-9f68-8f36c62fae72"},{"index":56257,"token":false,"name":"Thalisse, Reverent Medium","scryfallId":"e4899773-c501-45e5-bf1f-8d818788d61f"},{"index":56267,"token":false,"name":"Sphere of Law","scryfallId":"f3451ddf-efec-474b-884c-64288e5552d2"},{"index":56268,"token":false,"name":"Expedition Healer","scryfallId":"11a00a88-de0e-4012-9ad8-ccb187dff7df"},{"index":56281,"token":false,"name":"Perilous Voyage","scryfallId":"c9f6623e-2784-4bc9-9d8c-3eee9c78c350"},{"index":56282,"token":false,"name":"Ideas Unbound","scryfallId":"1b0fe46d-08d6-48c3-be0d-650d8d3d66af"},{"index":56283,"token":false,"name":"Venomous Changeling","scryfallId":"4c5a1d73-d102-469b-82ca-ec18f616375e"},{"index":56284,"token":false,"name":"Lifeblood","scryfallId":"4ecb1362-9a67-4d4c-8d69-9ac2ebf4d0b0"},{"index":56285,"token":false,"name":"Chaplain's Blessing","scryfallId":"f70ea481-1751-4097-af41-2d13fe79e788"},{"index":56290,"token":false,"name":"Rattleblaze Scarecrow","scryfallId":"4b46425f-516c-42f5-8df1-79af17d02a4a"},{"index":56294,"token":false,"name":"Chainweb Aracnir","scryfallId":"874afaad-546a-4cb2-ad01-2b4a4862b219"},{"index":56302,"token":false,"name":"Serene Offering","scryfallId":"6c0b3795-7f30-4c61-b5d8-f238055d6be1"},{"index":56308,"token":false,"name":"Pardic Swordsmith","scryfallId":"44ac622c-db04-41bf-817e-4698843e6346"},{"index":56314,"token":false,"name":"Inniaz, the Gale Force","scryfallId":"b238485f-ef67-4295-892b-a10235368f74"},{"index":56315,"token":false,"name":"Wort, Boggart Auntie","scryfallId":"a08a1377-dede-47c8-8447-c9df125f3b14"},{"index":56318,"token":false,"name":"Catalyst Elemental","scryfallId":"e83a678b-19d4-47a5-aa1c-c2437e5009c0"},{"index":56329,"token":false,"name":"Crackling Club","scryfallId":"0810f7e3-03ff-4c46-a88f-2f8144540780"},{"index":56336,"token":false,"name":"Renounce","scryfallId":"8bb2bfb9-cc4a-4d33-99f9-17db4d9fc718"},{"index":56337,"token":false,"name":"Goblin Barrage","scryfallId":"4849db5d-cd41-49f6-acd5-697cdc8263f6"},{"index":56352,"token":false,"name":"Flame Burst","scryfallId":"64bbd438-7df2-4d7b-88ad-4531ebaf3931"},{"index":56362,"token":false,"name":"Archangel's Light","scryfallId":"f99837b3-b487-43bb-846b-7a0e8afb6eef"},{"index":56364,"token":false,"name":"Whip Silk","scryfallId":"10566804-fd15-4ef0-ad7d-cc979f4cc8c5"},{"index":56367,"token":false,"name":"Millennial Gargoyle","scryfallId":"068e7803-7c9f-43d7-b6dc-8e1390d902d0"},{"index":56376,"token":false,"name":"Unstoppable Ash","scryfallId":"c9de6380-6203-41ae-b134-8633eb5df076"},{"index":56385,"token":false,"name":"Raiders' Wake","scryfallId":"fd81dd41-a982-46d2-a572-432580be73c5"},{"index":56396,"token":false,"name":"Divide by Zero","scryfallId":"1958d96e-ec44-48ab-80b1-5b01a24ac7b8"},{"index":56398,"token":false,"name":"Gravity Well","scryfallId":"1feb13d0-1a62-4acd-9267-3b2df4b6a199"},{"index":56399,"token":false,"name":"Vanishment","scryfallId":"dece40c1-790c-4471-a790-1d356b345603"},{"index":56406,"token":false,"name":"Launch","scryfallId":"58f78667-b3ab-44af-89df-9e9332dc5485"},{"index":56416,"token":true,"name":"Beast Token (G, 4/2)","scryfallId":"29b7ecd1-c70e-467c-a9ea-99c2668c3405"},{"index":56418,"token":false,"name":"Rage Extractor","scryfallId":"d8cebc2c-a46b-4459-b62b-7fce1a744b11"},{"index":56420,"token":false,"name":"Elvish Hexhunter","scryfallId":"c2b7f4d7-278b-45fc-98aa-b7c8b9162bcd"},{"index":56424,"token":false,"name":"Blistering Dieflyn","scryfallId":"5720a5b2-60ca-49f9-83e8-b801471c92ea"},{"index":56425,"token":false,"name":"Rock Slide","scryfallId":"7e01717a-d6ed-42c1-9a9a-f3f4a3d73bca"},{"index":56426,"token":false,"name":"Enshrouding Mist","scryfallId":"b059bd3e-451c-445a-b299-544c82fc0eb9"},{"index":56449,"token":false,"name":"Shadow Rider","scryfallId":"5bfdec24-e689-4cca-a546-a8f5d0929f8d"},{"index":56455,"token":false,"name":"Viashino Pyromancer","scryfallId":"a82fdb2f-b199-44ff-9615-90fc074cb8b0"},{"index":56458,"token":false,"name":"Cabal Archon","scryfallId":"4bdf6e2a-1bf5-4d63-a58b-883cfb1ea0fa"},{"index":56463,"token":false,"name":"Whisper Squad","scryfallId":"097eeb32-cfd5-4adb-ac30-d7762e6ea48f"},{"index":56464,"token":false,"name":"Cleaving Reaper","scryfallId":"b59dadef-74e5-47c7-a3e0-51075ddb82b1"},{"index":56466,"token":false,"name":"Crookclaw Elder","scryfallId":"8ced7275-3935-4bba-877d-81282bd171fd"},{"index":56471,"token":false,"name":"Corpseweft","scryfallId":"25cf24e7-2e6e-46e0-aedd-89e17953811c"},{"index":56479,"token":false,"name":"Learn from the Past","scryfallId":"347c6e76-dba4-4448-a4f4-d9591d4539c7"},{"index":56483,"token":false,"name":"Soulless Revival","scryfallId":"6b36712c-1ccb-4efe-8db8-823b9b80a99f"},{"index":56487,"token":false,"name":"Kitsune Riftwalker","scryfallId":"f545d9d0-52d8-4b90-a8bb-178f4ba3c4b7"},{"index":56490,"token":false,"name":"Zimone, Quandrix Prodigy","scryfallId":"0ca14c17-dc72-4f68-92f2-14a6c4019f4e"},{"index":56502,"token":false,"name":"Great Hall of Starnheim","scryfallId":"a23c757e-5944-47ce-b06f-27b4c403044c"},{"index":56517,"token":false,"name":"Hollowhead Sliver","scryfallId":"7f05b162-90aa-4c95-903f-775a17d20359"},{"index":56518,"token":false,"name":"Tide Skimmer","scryfallId":"dee1d595-a998-4652-931f-a1a72446f3a6"},{"index":56531,"token":false,"name":"Feral Maaka","scryfallId":"3c969aa0-b0e5-42cd-abba-0a3c7266142c"},{"index":56532,"token":false,"name":"Drogskol Reaver","scryfallId":"af2d9e0b-6433-40a2-9847-9fa4e3c008c4"},{"index":56533,"token":false,"name":"Mystic Subdual","scryfallId":"627c2111-b7d7-40bc-aa30-57d72338b32d"},{"index":56537,"token":false,"name":"Cavern Crawler","scryfallId":"bd0a8af9-2e86-4639-a6c9-209f115e95f8"},{"index":56540,"token":false,"name":"Tanglewalker","scryfallId":"23266fca-7bda-47ca-a72e-140ed51e94c0"},{"index":56545,"token":false,"name":"Dramatic Entrance","scryfallId":"4562a300-8777-4a47-8650-8a2bc2678def"},{"index":56557,"token":false,"name":"Roar of the Kha","scryfallId":"dc697a4c-f219-46fd-90f2-63c638cd5ef7"},{"index":56565,"token":false,"name":"Bond Beetle","scryfallId":"f341ed2c-353b-49a3-b200-94ae43cb8e24"},{"index":56568,"token":false,"name":"Kavu Recluse","scryfallId":"6f04ac02-3eff-4a66-8320-ee7b4357522f"},{"index":56572,"token":false,"name":"Tower of Coireall","scryfallId":"64c19977-ac7d-4ce7-925c-33a7503420f5"},{"index":56576,"token":false,"name":"Harvester Druid","scryfallId":"97337e6e-1b3f-43a2-91f2-ca8f6c5dea88"},{"index":56579,"token":false,"name":"Kamahl's Summons","scryfallId":"0edc37c6-b6a8-424f-95dd-928d03c28542"},{"index":56584,"token":false,"name":"Hisoka's Guard","scryfallId":"4d7aec86-7b12-4025-af06-1c1928e56c19"},{"index":56587,"token":false,"name":"Flash Conscription","scryfallId":"52361237-a653-4470-9ed5-c531c040c686"},{"index":56589,"token":false,"name":"Acolyte's Reward","scryfallId":"cd8980af-c3fa-4027-917a-4a3d441c0a75"},{"index":56590,"token":false,"name":"Measure of Wickedness","scryfallId":"34d6776c-f286-4b43-8f5f-d70b5585e635"},{"index":56591,"token":false,"name":"Mogis's Marauder","scryfallId":"9dfd36c5-a484-4973-873c-b6a433da8e7a"},{"index":56600,"token":false,"name":"Nether Horror","scryfallId":"c217b672-c724-4fc2-936c-b3f0feaf6ea0"},{"index":56604,"token":false,"name":"Destroy the Evidence","scryfallId":"bca53097-108d-457e-831c-e3d6cb499a41"},{"index":56619,"token":false,"name":"Rakshasa Debaser","scryfallId":"e31fd23d-e6b2-412b-b2ff-c99812365001"},{"index":56629,"token":true,"name":"Ooze Token (G, 3/3)","scryfallId":"623a7905-3a10-4d23-96fa-4960cac8f4e3"},{"index":56634,"token":false,"name":"Wolfir Silverheart","scryfallId":"8629c598-11c8-4911-acfb-0643e5feffa8"},{"index":56636,"token":false,"name":"Traitorous Greed","scryfallId":"ab7052f1-9736-47b6-9da3-8c5ca925ab54"},{"index":56643,"token":false,"name":"Eladamri's Vineyard","scryfallId":"d8531643-5657-44b6-89d1-9cdf67ed09c4"},{"index":56650,"token":false,"name":"Independent Troops","scryfallId":"ff7a4769-7a64-4016-8db0-b56c6b98aff3"},{"index":56662,"token":false,"name":"Bond of Insight","scryfallId":"648629af-e911-49e1-b564-c98f339b84a1"},{"index":56667,"token":false,"name":"Ivy Seer","scryfallId":"018ad11c-1351-4eff-94ac-3926037d7247"},{"index":56668,"token":false,"name":"Research Assistant","scryfallId":"4ac8a7c0-d935-4a60-ac32-dde73f5c75da"},{"index":56669,"token":false,"name":"Laccolith Warrior","scryfallId":"a13b103f-482b-47d5-84a2-3621ba23bd20"},{"index":56685,"token":false,"name":"Nullstone Gargoyle","scryfallId":"1dc3aa88-2555-4862-a771-e9d5b9eab3ad"},{"index":56690,"token":false,"name":"Stromkirk Mentor","scryfallId":"aa90b7dc-fb90-411e-a762-06a800bae0cf"},{"index":56693,"token":false,"name":"Suicidal Charge","scryfallId":"c9375d8c-b429-4349-bc4d-cb08799bdb58"},{"index":56695,"token":false,"name":"Borborygmos Enraged","scryfallId":"8644c60f-7d06-4026-bcf3-df054701ca0a"},{"index":56699,"token":false,"name":"Ring of Xathrid","scryfallId":"47e2aa59-63dc-4e28-8cdc-2ca868ff8f59"},{"index":56705,"token":false,"name":"Orchard Elemental","scryfallId":"a98ce3fa-d607-4975-89b5-6c7ed9bd1185"},{"index":56715,"token":false,"name":"Akroma's Will","scryfallId":"c281997b-1566-4469-a14c-6645f81ab023"},{"index":56728,"token":false,"name":"Lagonna-Band Elder","scryfallId":"68b9df54-e78e-4a86-a8b1-b735ec08a812"},{"index":56734,"token":false,"name":"Deviant Glee","scryfallId":"e150896e-8745-42ac-894b-8f42a92bd7a7"},{"index":56736,"token":false,"name":"Magma Burst","scryfallId":"d9752bc3-0bdf-4657-8750-73c8cbc8e83f"},{"index":56738,"token":false,"name":"Wall of Corpses","scryfallId":"dde6d3d1-75db-445f-9f17-632ee0292211"},{"index":56739,"token":false,"name":"Mox Tantalite","scryfallId":"dcd05b01-dc73-4dd2-970a-32ec6e153c86"},{"index":56744,"token":false,"name":"Avid Reclaimer","scryfallId":"0468e488-94ce-4ae3-abe4-7782673a7e62"},{"index":56747,"token":false,"name":"Divine Retribution","scryfallId":"75629aa3-426e-4e25-a7ab-71e03436e061"},{"index":56750,"token":false,"name":"Thought Dissector","scryfallId":"eba0e921-b81a-4803-8e1b-f7ae556c1e6f"},{"index":56770,"token":false,"name":"Forced Adaptation","scryfallId":"a6527d61-e9d3-44d0-833e-19c072309270"},{"index":56774,"token":false,"name":"Crocanura","scryfallId":"b459a988-97b0-4370-b89a-2565f8721b60"},{"index":56802,"token":false,"name":"Patrol Signaler","scryfallId":"b3fd4ccb-e632-4fa0-8e36-6103806f020c"},{"index":56812,"token":false,"name":"Archetype of Aggression","scryfallId":"13946413-c76d-41a8-a699-404fd56b2067"},{"index":56816,"token":false,"name":"Battered Golem","scryfallId":"f69add35-c529-4b30-8e64-f09b8308432f"},{"index":56819,"token":false,"name":"Screams of the Damned","scryfallId":"66cc53cf-13eb-4028-944d-a670ad30dbca"},{"index":56828,"token":false,"name":"Need for Speed","scryfallId":"8407b02f-66b3-4cfa-a3c4-105f314fd037"},{"index":56833,"token":false,"name":"Grim Strider","scryfallId":"97ae6769-2b2b-48e3-9503-e9744984743a"},{"index":56837,"token":false,"name":"Twinning Glass","scryfallId":"e0138c42-77ea-45f0-b2ca-cda03f3f50d1"},{"index":56842,"token":false,"name":"Tahngarth's Glare","scryfallId":"442a4331-99ce-405e-b261-19b7f3375ddf"},{"index":56850,"token":false,"name":"Nesting Wurm","scryfallId":"5da697da-7026-4dea-b494-8314d789160f"},{"index":56856,"token":false,"name":"Orzhov Locket","scryfallId":"761e7188-bad1-4775-84a2-15da9a42a57c"},{"index":56866,"token":false,"name":"Aether Burst","scryfallId":"3d09ea4a-0d3a-40b8-be0f-a31693099c4f"},{"index":56879,"token":false,"name":"Invading Manticore","scryfallId":"674e408b-f052-451c-9bf9-ac6f98753a9d"},{"index":56887,"token":false,"name":"Taigam's Strike","scryfallId":"2ef5e279-14c4-4f91-b24d-c7098140efcd"},{"index":56891,"token":false,"name":"Silumgar Monument","scryfallId":"3243e300-1420-4e96-a3d3-610c3723a11f"},{"index":56905,"token":false,"name":"Discordant Piper","scryfallId":"a8cce294-f6ee-4b18-8b65-7d01d0317b00"},{"index":56906,"token":false,"name":"Water Wurm","scryfallId":"e3da4a88-5225-467f-9240-f30bc1eee520"},{"index":56914,"token":false,"name":"Raised by Wolves","scryfallId":"bcfaace7-86e2-427e-97b1-b09dfdd30fee"},{"index":56916,"token":false,"name":"Petrahydrox","scryfallId":"6b876fa0-4018-43a2-8911-e1525f95f09f"},{"index":56930,"token":false,"name":"Quicksilver Fountain","scryfallId":"b4f2bf63-e3cf-4a58-86b7-f3bab3b90712"},{"index":56933,"token":false,"name":"Colossal Heroics","scryfallId":"c6139443-e31c-4eea-a99e-df9498fe18a8"},{"index":56946,"token":false,"name":"Frostwind Invoker","scryfallId":"66ec9a28-3b36-4b6a-b420-7b4266b64f69"},{"index":56951,"token":false,"name":"Mandate of Peace","scryfallId":"d243055f-892e-4042-9694-13d5e99e3550"},{"index":56957,"token":false,"name":"Metallic Mastery","scryfallId":"b939ded0-7033-4fee-864c-9e235d8720bb"},{"index":56961,"token":false,"name":"Prism Ring","scryfallId":"403f99de-493a-4f0f-81e4-fcd29d6e9340"},{"index":56962,"token":false,"name":"Revenge of Ravens","scryfallId":"3474289a-193e-452d-b248-e53ee99e22c0"},{"index":56981,"token":false,"name":"Penumbra Kavu","scryfallId":"ee334211-4109-46ff-8676-856048221a1c"},{"index":56987,"token":true,"name":"Sphinx Token (U, 4/4)","scryfallId":"b74f1983-e9ac-47f0-836d-843a53c054cc"},{"index":56988,"token":false,"name":"Break of Day","scryfallId":"9e39da2a-814a-46bb-a1ca-fc5532ece842"},{"index":56989,"token":false,"name":"Barbary Apes","scryfallId":"df25ffdd-995d-46ae-856b-f6368f9438ed"},{"index":56995,"token":false,"name":"Crazed Armodon","scryfallId":"b83e4b36-57c1-493d-ab79-52075990b2d5"},{"index":57003,"token":false,"name":"Goremand","scryfallId":"c9cd537c-e40e-438f-a751-e0ad8f6e6283"},{"index":57004,"token":false,"name":"Clinging Anemones","scryfallId":"4e183069-096d-4977-8154-e7b60f17a787"},{"index":57008,"token":false,"name":"Irrigation Ditch","scryfallId":"977f1b44-166c-4faf-8a7b-d431707e90ce"},{"index":57015,"token":false,"name":"Skyfire Kirin","scryfallId":"2d425562-3f0f-4aa3-a761-48ba445b8380"},{"index":57017,"token":false,"name":"Brainspoil","scryfallId":"c34fa44f-274e-4914-bbd5-71193f8d2f96"},{"index":57028,"token":false,"name":"Prophetic Flamespeaker","scryfallId":"73326c79-f884-42d5-8546-3db46ce4fe52"},{"index":57031,"token":false,"name":"Piety Charm","scryfallId":"1bc2da43-c0e1-4fbf-b309-a75e105c29c1"},{"index":57045,"token":false,"name":"Vigilante Justice","scryfallId":"10474e9b-213c-4134-ad49-e3d17d7e0a8f"},{"index":57053,"token":false,"name":"Cogwork Librarian","scryfallId":"453de664-0f09-4772-a626-51d58d1173f3"},{"index":57061,"token":false,"name":"Civic Saber","scryfallId":"29c9247e-05f4-44bb-86e3-90a60e880374"},{"index":57070,"token":false,"name":"Reckless Ogre","scryfallId":"90d27b79-a22d-48d9-86b2-7ad02cab8697"},{"index":57075,"token":false,"name":"Scarwood Treefolk","scryfallId":"ed6dece3-058c-4738-a22f-8893345ddd1c"},{"index":57078,"token":false,"name":"Strandwalker","scryfallId":"d0d7ff8f-7733-4323-8575-c50b3e730dbc"},{"index":57087,"token":false,"name":"Pirate's Pillage","scryfallId":"c99c812f-89b1-4741-a50d-8634e003a7c0"},{"index":57090,"token":false,"name":"Divine Sacrament","scryfallId":"f69ecef5-4f1a-4463-8908-7c0ef955b02d"},{"index":57096,"token":false,"name":"Crowd Favorites","scryfallId":"1038436d-aea5-4508-8b37-c2cfa32c2771"},{"index":57098,"token":false,"name":"Talas Explorer","scryfallId":"64f184c9-a716-4ba8-8efa-495358660de5"},{"index":57103,"token":false,"name":"Frostpyre Arcanist","scryfallId":"276f8abd-4d39-4b50-876f-9c6713bc4ab5"},{"index":57114,"token":false,"name":"Wily Bandar","scryfallId":"cac6ece3-9889-47fa-9140-420b4f31dd1b"},{"index":57115,"token":false,"name":"Purity","scryfallId":"154a335d-188d-49c3-af6d-c8e702b4b3ba"},{"index":57117,"token":false,"name":"Ravenous Skirge","scryfallId":"d0b6e655-e05e-44b5-9c7f-9dbbc66e6e28"},{"index":57133,"token":false,"name":"Natural Balance","scryfallId":"b0f7c47c-416e-4f73-89ec-024a29dfb5e9"},{"index":57138,"token":false,"name":"Night Dealings","scryfallId":"58d012ee-9523-469f-8ddb-f4b664093c13"},{"index":57145,"token":false,"name":"Scrapyard Mongrel","scryfallId":"eb00bd3a-833e-4226-a73e-17c9043c0994"},{"index":57148,"token":false,"name":"Spell Shrivel","scryfallId":"efa110cb-f091-48f0-bc62-80f5f18568e8"},{"index":57162,"token":false,"name":"Double Negative","scryfallId":"2c7e3c58-3cda-4891-8b3d-33bb21568cf5"},{"index":57164,"token":false,"name":"Sicken","scryfallId":"aa1beb5d-0ef2-4013-932b-5e4a5d0af559"},{"index":57178,"token":false,"name":"Expanded Anatomy","scryfallId":"c5642b9d-0daa-4e6b-ad48-f88dd37d6574"},{"index":57186,"token":false,"name":"Haazda Snare Squad","scryfallId":"85d3c012-f356-424d-a960-60e95f395134"},{"index":57187,"token":false,"name":"Ruination Rioter","scryfallId":"5a00ac82-a884-40c4-9d09-3190a1099726"},{"index":57198,"token":false,"name":"Wildfield Borderpost","scryfallId":"90a788e7-f3c8-41cc-9f1a-2e9f58aabc0e"},{"index":57199,"token":false,"name":"Embereth Skyblazer","scryfallId":"166ee7fc-a0f7-49af-85bf-d5b36bb2bff4"},{"index":57200,"token":false,"name":"Bloodshed Fever","scryfallId":"73b92320-6f83-4731-93c8-7eb9fd90ee83"},{"index":57206,"token":false,"name":"Abzan Battle Priest","scryfallId":"8f5427b1-f1c2-4bb3-8736-701667ac2256"},{"index":57211,"token":false,"name":"Sweet Oblivion","scryfallId":"51ac77d4-f918-4bbc-b023-8117a8c401ee"},{"index":57217,"token":false,"name":"Brine Giant","scryfallId":"6811a9dc-e521-4c9e-accb-1efb8346c1db"},{"index":57218,"token":false,"name":"Glamer Spinners","scryfallId":"5cfc402e-8e84-4d47-9638-e94b12f3f667"},{"index":57244,"token":false,"name":"Zarichi Tiger","scryfallId":"7bf5efe4-d9a0-4704-b5ba-3213c946df37"},{"index":57254,"token":false,"name":"Smoke Teller","scryfallId":"1916a2d9-4747-4118-b1b2-7a5ce492e3fc"},{"index":57271,"token":false,"name":"Raving Dead","scryfallId":"5d24d153-a014-4524-a496-9fe1c41cbc2b"},{"index":57277,"token":false,"name":"Druids' Repository","scryfallId":"57e6fb62-7ee3-444d-8fd4-c1f44014a05c"},{"index":57290,"token":false,"name":"Bloodborn Scoundrels","scryfallId":"8750abff-ae70-4abe-a51a-b93f71b48ef1"},{"index":57293,"token":false,"name":"Hired Torturer","scryfallId":"62e9f79e-6606-4c9b-838c-eda5d8cc612c"},{"index":57306,"token":false,"name":"Flesh Allergy","scryfallId":"9c729525-b954-42dd-9877-f4360d99b961"},{"index":57332,"token":false,"name":"Allied Assault","scryfallId":"340df0d4-9848-4372-9f45-a73a8e94058a"},{"index":57335,"token":false,"name":"Cloak and Dagger","scryfallId":"38bb3e3c-1a7d-4bc4-b69d-6a8e9f1b3fe7"},{"index":57336,"token":false,"name":"Zerapa Minotaur","scryfallId":"55a8e1ce-e394-48d6-938a-aa76c0273abe"},{"index":57337,"token":false,"name":"Reap the Seagraf","scryfallId":"4defdead-19fa-4535-9f71-8808388b0332"},{"index":57338,"token":false,"name":"Mortis Dogs","scryfallId":"3cae1f40-0e43-41d8-bc5c-aa9873f7d7d5"},{"index":57354,"token":false,"name":"Mutual Destruction","scryfallId":"85ac0b25-80bf-4871-a6f6-5cf4d5b9496e"},{"index":57355,"token":false,"name":"Psychic Surgery","scryfallId":"51ea9a6d-d6ca-48cb-adac-958ad0e7440c"},{"index":57361,"token":false,"name":"Arboretum Elemental","scryfallId":"6f4400bf-134b-4011-985d-eed4e5ba1de8"},{"index":57380,"token":false,"name":"Cruel Finality","scryfallId":"5c22e911-cf40-4ed8-b075-186f2b1393db"},{"index":57385,"token":false,"name":"Elite Headhunter","scryfallId":"aa9d0279-4fe0-4228-a82f-bc3cd91500df"},{"index":57386,"token":false,"name":"Vintara Snapper","scryfallId":"897edf01-fc6f-4835-b025-c137d921ce09"},{"index":57390,"token":false,"name":"Wildslayer Elves","scryfallId":"3323467c-132f-469a-90fc-9d3b0fb004aa"},{"index":57395,"token":false,"name":"Prying Blade","scryfallId":"ad45720e-2870-414d-8119-8e48c5600d3b"},{"index":57406,"token":false,"name":"Accelerated Mutation","scryfallId":"282f808c-0b58-4b98-aeda-f606a10d1a4b"},{"index":57410,"token":false,"name":"Bleak Coven Vampires","scryfallId":"9d3386e4-bbd6-4756-b29d-f55619e98d0d"},{"index":57424,"token":false,"name":"Aven Archer","scryfallId":"4d174892-c192-4667-94fb-9f8dbcc6c5eb"},{"index":57428,"token":false,"name":"Nim Lasher","scryfallId":"7b66c698-02bd-48ef-a866-5251bdc02c16"},{"index":57429,"token":false,"name":"Senate Griffin","scryfallId":"465adbb4-4c64-44eb-8323-61d23282c6b8"},{"index":57433,"token":false,"name":"Instill Furor","scryfallId":"f6164762-c02d-4553-9064-2b99ff6352c9"},{"index":57438,"token":false,"name":"Rhizome Lurcher","scryfallId":"db9ce92b-79cc-4e26-b511-30ae8ea6a2a1"},{"index":57445,"token":false,"name":"Splitting Headache","scryfallId":"168d790f-9163-498c-b96d-fdeb2070bda0"},{"index":57453,"token":false,"name":"Mercenary Knight","scryfallId":"ec9f97a2-b04e-418b-89c7-1c019288f27a"},{"index":57458,"token":false,"name":"Baru, Fist of Krosa","scryfallId":"1a74fcde-7685-402c-9b2a-245aa75d75c1"},{"index":57466,"token":false,"name":"Azorius Locket","scryfallId":"13aed078-9e29-48e7-b145-5252362031a0"},{"index":57470,"token":false,"name":"Trophy Hunter","scryfallId":"f18d1047-9010-437c-94ab-7a8ad3a0250f"},{"index":57476,"token":false,"name":"Atalya, Samite Master","scryfallId":"90500e7a-f76d-453a-bda0-d56d3f7c7534"},{"index":57480,"token":false,"name":"Core Prowler","scryfallId":"05414ba7-0f59-4c73-931c-e599d149d3ba"},{"index":57485,"token":false,"name":"Votary of the Conclave","scryfallId":"9bb6f929-5a19-421b-ae88-9bbb7e64756c"},{"index":57490,"token":false,"name":"Stormcaller's Boon","scryfallId":"15931d65-9b4e-4506-8f1d-714d06f9c2f3"},{"index":57491,"token":false,"name":"Nettletooth Djinn","scryfallId":"7b5aa60d-91aa-4eee-9d13-55a357c8eced"},{"index":57502,"token":false,"name":"Devoted Caretaker","scryfallId":"8d400b63-de3e-4805-a51d-c4c0dfbb7033"},{"index":57504,"token":false,"name":"Candles' Glow","scryfallId":"0758d20f-6f0f-462e-a7ec-2511c146983d"},{"index":57508,"token":false,"name":"Shore Snapper","scryfallId":"157e5763-4892-47e4-8fd5-f576844c0a0d"},{"index":57509,"token":false,"name":"Devouring Hellion","scryfallId":"88205574-bf2b-46e7-aac7-4b8ea217f94c"},{"index":57514,"token":false,"name":"Kaleidoscorch","scryfallId":"a5f07603-fd79-437a-9b12-495fc5a39b68"},{"index":57520,"token":false,"name":"Ajani's Comrade","scryfallId":"5bebef1c-2f03-4e0a-b3ba-861546ebf8a6"},{"index":57523,"token":false,"name":"Mountain Stronghold","scryfallId":"314fd1d7-4bd8-4d95-b7c2-1aa6660ab88a"},{"index":57526,"token":false,"name":"Ferropede","scryfallId":"cdf8248c-ef2c-4b1e-8a0b-05def43ca2af"},{"index":57527,"token":false,"name":"Viashino Lashclaw","scryfallId":"3457e346-a5de-4624-b577-f59d4c186537"},{"index":57534,"token":false,"name":"Nyx Herald","scryfallId":"866dcef0-8d3e-4126-963a-05598d8a9e79"},{"index":57537,"token":true,"name":"Serpent Dancers Token (Colorless, 2/4)","scryfallId":"f4210dae-7248-4a7b-9646-99683c0dce17"},{"index":57539,"token":false,"name":"Sylvan Awakening","scryfallId":"d0651efa-75a5-41d3-a5b9-9c5109d6ce44"},{"index":57540,"token":false,"name":"Disturbed Burial","scryfallId":"06254b6c-eb22-4ec9-9420-74e9ee15e072"},{"index":57542,"token":true,"name":"Elemental Token (R, */*)","scryfallId":"fd0c9fb3-5f4c-47f9-a9b3-369d4936de60"},{"index":57545,"token":false,"name":"Chief of the Scale","scryfallId":"a227b8cc-cbe5-4955-ad1b-a354704a82e8"},{"index":57557,"token":false,"name":"Temple Elder","scryfallId":"db4d4b14-d774-430c-a483-be04a238718d"},{"index":57567,"token":false,"name":"Voracious Vampire","scryfallId":"d66a9f1b-31c8-4557-888b-a927922d37af"},{"index":57569,"token":false,"name":"Ramosian Captain","scryfallId":"0e9d2e2a-c608-4787-bbd9-e1871f681b58"},{"index":57573,"token":false,"name":"Woodlurker Mimic","scryfallId":"d86dd5a9-4793-4ca2-b94d-4333781b1468"},{"index":57574,"token":false,"name":"Jhovall Rider","scryfallId":"7e1f7c51-0011-4ea5-b123-3c26293f5dab"},{"index":57584,"token":false,"name":"Runner's Bane","scryfallId":"4696b5a6-edfd-445e-ac80-64c1be94fbfc"},{"index":57595,"token":false,"name":"Expedition Diviner","scryfallId":"090f6e94-fb5f-4861-a465-f11766303676"},{"index":57598,"token":false,"name":"Overburden","scryfallId":"7e6cf6b6-b4c1-4742-9be4-b3b15fbb0202"},{"index":57603,"token":false,"name":"Aven Augur","scryfallId":"c7599618-cbd9-4013-b0a5-4ba77fd52ab4"},{"index":57610,"token":false,"name":"Frilled Oculus","scryfallId":"d9f3a08f-403e-4d6c-87c7-add8170bde8b"},{"index":57615,"token":false,"name":"Blind Seer","scryfallId":"5c54ec26-c7f1-4258-9cc9-1709987f293c"},{"index":57617,"token":false,"name":"Haru-Onna","scryfallId":"ceaacab4-f13b-4189-ac78-89fc4cdbaa55"},{"index":57628,"token":false,"name":"Tel-Jilad Archers","scryfallId":"3a1fde33-e86a-4146-9c90-4616a5fc0868"},{"index":57633,"token":false,"name":"Command the Storm","scryfallId":"c4144e98-957e-43ac-b107-8ccf450748df"},{"index":57635,"token":false,"name":"Soul's Grace","scryfallId":"3d2e8701-f2c3-4cc1-ac81-ba1987d80fec"},{"index":57636,"token":true,"name":"Chandra","scryfallId":"b6865498-9464-4d01-a293-6220d9bb1c9a"},{"index":57637,"token":false,"name":"Mischief and Mayhem","scryfallId":"9daa44b4-5c30-41d8-b4d6-6219c5729a5f"},{"index":57638,"token":false,"name":"Scaled Behemoth","scryfallId":"5c05a60f-660a-42d3-82b3-06984366afb4"},{"index":57642,"token":false,"name":"Gruul Keyrune","scryfallId":"7cf96f1c-066e-4fde-acb8-4674842fb6c2"},{"index":57681,"token":false,"name":"Hollow Specter","scryfallId":"2db779fd-0e01-417b-aee2-786db2c0b8c8"},{"index":57682,"token":false,"name":"Resolute Survivors","scryfallId":"713f469e-58c3-4db4-aa7a-77126bda13f2"},{"index":57689,"token":false,"name":"Enraged Ceratok","scryfallId":"c44fc50f-8958-422f-933f-fd043d642c97"},{"index":57706,"token":false,"name":"Glyph of Doom","scryfallId":"332bfce9-052d-42e9-a407-4a1dd59e0f2a"},{"index":57707,"token":false,"name":"Excavating Anurid","scryfallId":"d353d315-5790-417d-adf5-270df1ff34b0"},{"index":57711,"token":false,"name":"Fathom Trawl","scryfallId":"cd9c0bd7-f8a9-4d13-9a06-acc8bfb3d68b"},{"index":57721,"token":false,"name":"Terraformer","scryfallId":"a0b9d4f3-4570-4fe0-857f-97f5bd6ead44"},{"index":57728,"token":false,"name":"Swirl the Mists","scryfallId":"2ea50e09-4ab3-439e-83d7-d584f8af8f16"},{"index":57731,"token":false,"name":"Justice Strike","scryfallId":"27619ce9-59df-4f0e-a5db-2d32a530e547"},{"index":57739,"token":false,"name":"Howl of the Horde","scryfallId":"5db4baf3-f0dc-4b27-8323-a76764332590"},{"index":57741,"token":false,"name":"Sensation Gorger","scryfallId":"b2e5eb69-dcd9-4784-bf4c-20b674f4c035"},{"index":57743,"token":false,"name":"Phyrexian Slayer","scryfallId":"5fa8c604-343f-4c94-ac25-439ab1845c19"},{"index":57745,"token":false,"name":"Curse Artifact","scryfallId":"9fc0d070-8a42-4d5e-8f2b-ceb59147de6f"},{"index":57747,"token":false,"name":"Flow of Maggots","scryfallId":"6880a4d3-5cbc-4a01-9190-3565617efcc9"},{"index":57748,"token":false,"name":"Radiate","scryfallId":"2562c25a-999e-4fb5-a595-f376c8abf1ff"},{"index":57750,"token":false,"name":"Colossus of Akros","scryfallId":"3e394ffe-7460-4c59-a403-e9404b0d10c1"},{"index":57754,"token":false,"name":"Silverback Shaman","scryfallId":"4e97e62e-4a77-4512-b5fa-400e01517e23"},{"index":57755,"token":false,"name":"Graceblade Artisan","scryfallId":"9eedcf6c-5796-4843-b6b8-df78e11e72c2"},{"index":57756,"token":true,"name":"Merfolk // Treasure","scryfallId":"2e20d047-0d43-4709-919c-0b0f714e9903"},{"index":57757,"token":false,"name":"Volcano Imp","scryfallId":"a8281cc6-2132-4f76-841e-d1ade9cafb84"},{"index":57758,"token":false,"name":"Tephraderm","scryfallId":"41b65eba-140b-4c1d-b796-8134b7c1ede8"},{"index":57762,"token":false,"name":"Seedguide Ash","scryfallId":"eca605c0-6270-4238-bb77-0bbfd7568807"},{"index":57766,"token":false,"name":"Fallowsage","scryfallId":"d4237352-4e0e-4f40-946b-2a61753674d4"},{"index":57768,"token":false,"name":"Divebomber Griffin","scryfallId":"8aa5a010-6253-4dfb-952e-df05ff08eb9e"},{"index":57775,"token":false,"name":"Wanted Scoundrels","scryfallId":"6704e4c9-3b5e-4ba5-a5bc-6d684e2983e9"},{"index":57777,"token":false,"name":"Absorb Identity","scryfallId":"aa1c6bcc-2d43-4ea9-a93f-019793616869"},{"index":57778,"token":false,"name":"Myr Mindservant","scryfallId":"f98ce711-8f68-4487-b67b-be35796ffcff"},{"index":57781,"token":false,"name":"Grazing Kelpie","scryfallId":"68ccef2d-9a1f-4011-89e1-911bcc109b9d"},{"index":57787,"token":false,"name":"Phyrexian Monitor","scryfallId":"571058b0-7e10-4259-8db9-5c8b78c1e13d"},{"index":57796,"token":false,"name":"Congregation at Dawn","scryfallId":"2f1b950a-b2fe-4afc-bb79-c9f4c272ea36"},{"index":57799,"token":false,"name":"Maddening Wind","scryfallId":"5277656c-70f5-4660-bd58-7d9261d53fb5"},{"index":57803,"token":false,"name":"Reroute","scryfallId":"42794e10-ddcd-4d2d-ab0c-a6b99b6d4662"},{"index":57805,"token":true,"name":"Manuel Bevand Bio","scryfallId":"f127bd8b-64fd-4fde-b520-345ed27a8585"},{"index":57814,"token":false,"name":"Aura of Dominion","scryfallId":"26913c27-5794-42c7-a2a2-af565ce84fd1"},{"index":57816,"token":false,"name":"Elderleaf Mentor","scryfallId":"5e8bded3-46c3-474f-9d09-978df8705ad1"},{"index":57827,"token":false,"name":"Paragon of New Dawns","scryfallId":"361c66c3-b4eb-48aa-a967-255a8db60977"},{"index":57829,"token":false,"name":"Glassblower's Puzzleknot","scryfallId":"7d123031-6702-4d49-a788-42eb6dbc569e"},{"index":57830,"token":false,"name":"Graceful Cat","scryfallId":"b42ba8bf-9fc1-4d57-9c80-42491d18d929"},{"index":57836,"token":false,"name":"Inside Out","scryfallId":"a51180ee-8677-4d5a-9685-3861c67a1d1f"},{"index":57842,"token":false,"name":"Slinking Skirge","scryfallId":"00522c4b-4e64-4403-96b1-df41afbe255f"},{"index":57843,"token":false,"name":"Manor Skeleton","scryfallId":"e7b45197-d5c2-48c8-b72e-00236552e338"},{"index":57845,"token":false,"name":"Archway Commons","scryfallId":"f6f6a2ff-7eb7-4680-af2b-e69ac88a65c9"},{"index":57857,"token":false,"name":"Spiraling Embers","scryfallId":"73503423-30d8-42bc-a697-6d986e4945c8"},{"index":57863,"token":false,"name":"Steely Resolve","scryfallId":"b88c530a-abc3-4cc4-8a48-5b76e1504a3c"},{"index":57872,"token":false,"name":"Priest of the Haunted Edge","scryfallId":"0cde0f4d-5acc-4a25-a3d6-c6b9b734360c"},{"index":57876,"token":false,"name":"Spirit of the Aldergard","scryfallId":"220df551-3820-4910-a206-14501ba02e69"},{"index":57879,"token":false,"name":"Flameborn Hellion","scryfallId":"84e0e5f5-b51a-4386-827b-c0eb8c877efb"},{"index":57881,"token":false,"name":"Rakdos Ringleader","scryfallId":"6b54fbe8-324a-4066-bed1-dda1dca319fc"},{"index":57887,"token":false,"name":"Callous Dismissal","scryfallId":"66cef326-339c-49e5-9905-21a1603a46ae"},{"index":57892,"token":false,"name":"Dovin's Automaton","scryfallId":"0a962509-2e77-4655-b397-9625b2f3407a"},{"index":57894,"token":false,"name":"Grip of the Roil","scryfallId":"6cf33069-013f-43ab-9a31-e67bb6dc996d"},{"index":57903,"token":false,"name":"Vraska's Conquistador","scryfallId":"4d890a17-ffd4-4bda-bef3-2c116f7bf66f"},{"index":57908,"token":true,"name":"Beeble Token (U, 1/1)","scryfallId":"9bbfa4d4-106b-4fec-86ac-b81b71a8f432"},{"index":57910,"token":false,"name":"Azorius Skyguard","scryfallId":"c2fddecd-e660-43de-bccc-52f60a089052"},{"index":57914,"token":false,"name":"Perplex","scryfallId":"0db57459-29f0-4ef6-b256-56955036c0ef"},{"index":57919,"token":false,"name":"Jarl of the Forsaken","scryfallId":"f5b12c6c-c3d6-4b8a-bed4-d61f67f565b9"},{"index":57928,"token":false,"name":"Inspired Sprite","scryfallId":"0960dc0a-907b-4e02-a0b5-dd2613be8e65"},{"index":57929,"token":false,"name":"Gutter Skulk","scryfallId":"830c7c77-20c4-429f-88c7-b85ab7a0e38b"},{"index":57936,"token":false,"name":"Canopy Stalker","scryfallId":"a3f6a13a-ab38-49d1-8712-f9c9135a23c8"},{"index":57937,"token":false,"name":"Droning Bureaucrats","scryfallId":"756eb23a-c6de-439a-b83d-e694cfae7ccb"},{"index":57940,"token":false,"name":"March of the Multitudes","scryfallId":"2cc2b646-0181-4f0a-a141-00ca56069a06"},{"index":57950,"token":false,"name":"Ethereal Guidance","scryfallId":"f47dd220-6193-4e31-a1df-591b6424ad27"},{"index":57951,"token":false,"name":"Honor the Fallen","scryfallId":"70147617-10e0-413d-be0a-a888b9cb6b97"},{"index":57952,"token":false,"name":"Rank Officer","scryfallId":"7a05edf6-ade4-4052-924d-6057faa51693"},{"index":57954,"token":false,"name":"Master of Predicaments","scryfallId":"f0b1720b-ab7a-4b52-a6d0-11c4fc573d17"},{"index":57955,"token":false,"name":"Mind Peel","scryfallId":"92bd531c-fdd1-4a22-816e-258b2975c1a3"},{"index":57958,"token":false,"name":"Magnetic Mine","scryfallId":"5ed2f7dc-3ada-4490-8c1f-1d03bd4840f5"},{"index":57965,"token":false,"name":"Squandered Resources","scryfallId":"fcddbea7-3025-47b1-a597-2d2b2711fb81"},{"index":57968,"token":false,"name":"Bola Warrior","scryfallId":"dc6e1de6-e7e0-4037-896a-f80c54b8ef5c"},{"index":57971,"token":false,"name":"Coral Commando","scryfallId":"889cc2a0-d9a6-4368-92e0-055a7d7bf9d1"},{"index":57984,"token":false,"name":"Sundering Vitae","scryfallId":"a491b58f-3c54-41ea-b93b-c32fdc1e5917"},{"index":57986,"token":false,"name":"Guardian Kirin","scryfallId":"754b4061-3009-46e4-8602-8349c6367cbf"},{"index":57997,"token":false,"name":"Arcane Spyglass","scryfallId":"d10d85c9-859a-4ff5-9a41-bf20622a3ff5"},{"index":57998,"token":false,"name":"Venomous Dragonfly","scryfallId":"479fc902-ce94-4a6b-af87-4645387a46c6"},{"index":58002,"token":false,"name":"Relic Sloth","scryfallId":"c1cb483f-c567-4cfd-9fe8-1503e7b40542"},{"index":58004,"token":false,"name":"Sumala Woodshaper","scryfallId":"8c4e427e-c061-43c5-9e8e-34bf5b447ab1"},{"index":58011,"token":false,"name":"Remedy","scryfallId":"2a0b7162-4422-4dfb-a6ca-8d89fa74e6dc"},{"index":58024,"token":true,"name":"Brian Kibler Decklist","scryfallId":"d938bdec-eb97-4b3e-abdc-6eddd7bcd44e"},{"index":58030,"token":true,"name":"Reckless Minotaur Token (Colorless, 4/1)","scryfallId":"938272b2-8e1c-4196-8557-c597735dd96e"},{"index":58031,"token":false,"name":"Waves of Aggression","scryfallId":"83d52ba7-ffb3-4c24-85d8-8635ef1880d9"},{"index":58032,"token":false,"name":"Misers' Cage","scryfallId":"f4c00691-26b1-4e7a-bdf5-4b15f0eb45ce"},{"index":58038,"token":false,"name":"Burning-Tree Vandal","scryfallId":"c5674753-17e4-4e35-a12c-13e1e077ec70"},{"index":58040,"token":false,"name":"Lifebane Zombie","scryfallId":"98370735-5303-40d4-9e80-cdb40dee18e2"},{"index":58043,"token":false,"name":"Granger Guildmage","scryfallId":"3f495b27-3eed-4962-b69a-b86f9fc6a9a7"},{"index":58048,"token":false,"name":"Glittering Lynx","scryfallId":"a3f26c7e-c525-4191-a542-b81343ae95bb"},{"index":58052,"token":false,"name":"Mist of Stagnation","scryfallId":"76d03121-9515-4101-9d60-e01225533f44"},{"index":58059,"token":false,"name":"Nim Shambler","scryfallId":"e59c09a0-a374-46c1-978f-ec7478dc7ab7"},{"index":58062,"token":false,"name":"Builder's Blessing","scryfallId":"2ad27af1-b482-40d5-9dbb-11201ffa0410"},{"index":58071,"token":false,"name":"Bottomless Pit","scryfallId":"91f05fc3-da6e-45d4-8566-f4e7bdce1fe5"},{"index":58075,"token":false,"name":"Unchained Berserker","scryfallId":"db5879c5-4b0a-42fa-a44f-580e0221a32b"},{"index":58080,"token":false,"name":"Runed Arch","scryfallId":"ca02861b-9639-480d-8e54-e024f0c70158"},{"index":58084,"token":false,"name":"Devotee of Strength","scryfallId":"977698ab-3b64-41f2-a214-ac95e04c9956"},{"index":58089,"token":false,"name":"Private Research","scryfallId":"6f7f9849-a4bd-4501-9473-79345c751701"},{"index":58091,"token":false,"name":"Mirror-Sigil Sergeant","scryfallId":"e94b3eec-7420-45fa-8750-7f01028836d3"},{"index":58097,"token":false,"name":"Burning-Yard Trainer","scryfallId":"17755d1b-3a56-4362-a534-85b35ceb1802"},{"index":58104,"token":false,"name":"Unchecked Growth","scryfallId":"d7791182-fe63-47bc-9fdf-ef346d6ad4b5"},{"index":58116,"token":false,"name":"Detention Sphere","scryfallId":"afee5464-83b7-4d7a-b407-9ee7de21535b"},{"index":58122,"token":false,"name":"War Report","scryfallId":"6d837262-cd5d-4fc9-96dd-39ed04166883"},{"index":58134,"token":false,"name":"Spike-Tailed Ceratops","scryfallId":"41a3b5f2-0b0b-42e0-a15b-4bb2fce05927"},{"index":58138,"token":false,"name":"Cruel Sadist","scryfallId":"a31c94f3-c45b-4ced-b523-15e80ae1a82d"},{"index":58142,"token":false,"name":"Didn't Say Please","scryfallId":"77500b53-0852-4d6a-bfe3-b1e8ef5a12cd"},{"index":58151,"token":false,"name":"Grave Exchange","scryfallId":"14f420c4-801b-48e7-a10b-de44a2417265"},{"index":58155,"token":false,"name":"Scent of Jasmine","scryfallId":"c0dae0cf-9696-498c-8d28-dc8c239faec7"},{"index":58156,"token":false,"name":"Scale the Heights","scryfallId":"e781d6ad-950e-49bf-9645-e2354086ae49"},{"index":58162,"token":false,"name":"Hellkite Punisher","scryfallId":"7bf663d3-850b-4a24-8e4b-08311adf4ed0"},{"index":58165,"token":false,"name":"Banehound","scryfallId":"b9e03567-c95a-40b8-a75a-971076093f57"},{"index":58167,"token":false,"name":"Hobblefiend","scryfallId":"4bfffc18-b36a-4dd5-909e-60ea9f8eb60b"},{"index":58182,"token":false,"name":"Life Matrix","scryfallId":"c99a3abc-e2a3-4eee-8f72-b1b25dcd1d0b"},{"index":58185,"token":false,"name":"Riptide Chronologist","scryfallId":"3767f568-36b1-4064-835e-4dd7576b7b8b"},{"index":58186,"token":false,"name":"Role Reversal","scryfallId":"59b47017-d982-4d4c-94fc-f265a5b7f36a"},{"index":58194,"token":false,"name":"Vitalizing Cascade","scryfallId":"5fe8a5b8-1a87-46f5-920f-fbbb05bfd563"},{"index":58202,"token":false,"name":"Scorchmark","scryfallId":"2a14834f-78ae-4ca5-9ce0-5b928ad3d76c"},{"index":58203,"token":false,"name":"Laccolith Rig","scryfallId":"4fb92039-03fd-4aee-be74-96997be629d6"},{"index":58213,"token":false,"name":"Hallowed Spiritkeeper","scryfallId":"94ebd5bd-99b3-4371-9ca2-e0504db1458e"},{"index":58227,"token":false,"name":"Liliana's Scorn","scryfallId":"b231f941-4acb-46f2-81ae-16e5a28e65af"},{"index":58233,"token":false,"name":"Soul Spike","scryfallId":"4b14b97d-122b-453a-9e5f-129404f96440"},{"index":58239,"token":false,"name":"Quest for the Holy Relic","scryfallId":"00d6b8bb-ec11-4ded-a7fc-fa4ea0bb96cc"},{"index":58247,"token":false,"name":"Horizon Chimera","scryfallId":"73b0e296-d556-4e76-bb2e-5a640e070bb5"},{"index":58249,"token":false,"name":"Uproot","scryfallId":"88357572-0edd-4115-93c3-49f6f5a191b4"},{"index":58254,"token":false,"name":"Kumena's Speaker","scryfallId":"52e96ddf-ac9e-4cc5-8c9a-afee421d99a6"},{"index":58259,"token":false,"name":"Zirilan of the Claw","scryfallId":"a105b7f4-c93b-4b54-acf8-7212907d9cd6"},{"index":58265,"token":false,"name":"Maze Rusher","scryfallId":"864d2eb8-e27f-4f84-9725-d2ae6446e217"},{"index":58266,"token":false,"name":"Orcish Bloodpainter","scryfallId":"746eaf30-3ded-4a9f-a4ec-1925edcc8e94"},{"index":58277,"token":false,"name":"Tattered Drake","scryfallId":"7d28cbc8-4dbb-465b-813d-52b2b2f73b14"},{"index":58278,"token":false,"name":"Triad of Fates","scryfallId":"588a8f90-4344-4882-9671-4c7295186a58"},{"index":58282,"token":false,"name":"Thorn Mammoth","scryfallId":"80138656-b2e2-43bf-9fe6-7a852f53f9e9"},{"index":58293,"token":false,"name":"Scornful Aether-Lich","scryfallId":"75cdb2ff-6e30-4766-9166-9036a0bdb809"},{"index":58295,"token":false,"name":"Jace, Arcane Strategist","scryfallId":"b6a857fb-159f-40c4-8988-da91d8521a60"},{"index":58296,"token":false,"name":"Serpent Assassin","scryfallId":"1018f6ff-5eaa-4fe1-ba20-544df799f5b2"},{"index":58307,"token":false,"name":"Trigon of Rage","scryfallId":"1135f3b7-8c6b-47ff-b895-b7127836b0bf"},{"index":58311,"token":false,"name":"Defensive Stance","scryfallId":"d0670653-d4fe-4fac-b769-d19ca4698c97"},{"index":58314,"token":false,"name":"Common Bond","scryfallId":"59965953-1522-4103-9a6c-5534205d34d9"},{"index":58323,"token":false,"name":"Mardu Banner","scryfallId":"fe10c56d-a8e1-495d-a03a-0b920b44182f"},{"index":58332,"token":false,"name":"Wintermoon Mesa","scryfallId":"f07144a6-6e47-4315-8353-f8958f014f41"},{"index":58337,"token":false,"name":"Rimescale Dragon","scryfallId":"113d0342-0ba2-46b0-bda5-6a9fe4dcad3e"},{"index":58342,"token":false,"name":"Mass Diminish","scryfallId":"762a0e40-af3c-4ef9-a9fc-0414a1758385"},{"index":58354,"token":false,"name":"Urborg Phantom","scryfallId":"397355b9-5b67-4973-972e-3505c500d116"},{"index":58361,"token":false,"name":"Rampant Elephant","scryfallId":"752642d2-3dad-4f58-b154-beb5982141dc"},{"index":58369,"token":false,"name":"Debtors' Transport","scryfallId":"7cd03b99-d62e-428a-9e0d-097f1227a4da"},{"index":58370,"token":false,"name":"Skull Prophet","scryfallId":"2f5ec787-79f6-4922-a0f7-debde8f7a4be"},{"index":58376,"token":false,"name":"Svyelunite Priest","scryfallId":"316d25ae-7ac6-4f5b-93ab-0e0e28ec104b"},{"index":58384,"token":false,"name":"Oakheart Dryads","scryfallId":"d8ef63b9-c021-40fe-910e-93c06d660c20"},{"index":58385,"token":false,"name":"Inordinate Rage","scryfallId":"d0f62bdc-50a0-41a0-ac37-9b0eeb21b6aa"},{"index":58391,"token":false,"name":"Peregrine Mask","scryfallId":"9196f43e-f905-4e83-8e47-9d8fd53a4c9f"},{"index":58393,"token":false,"name":"Improvised Armor","scryfallId":"8d7d5d79-73d8-4f1a-9dda-4de5f41539d9"},{"index":58396,"token":false,"name":"Humble Budoka","scryfallId":"f31bbc89-d5ee-4813-9ebe-ac5b998b076b"},{"index":58406,"token":false,"name":"Vagrant Plowbeasts","scryfallId":"546b0a74-ebef-4596-b730-2190e20b2e66"},{"index":58411,"token":false,"name":"Culling Drone","scryfallId":"1a623415-46c0-45aa-ab75-1e2d9708013a"},{"index":58423,"token":false,"name":"Touch of Darkness","scryfallId":"eda7177f-1354-4008-aaaa-2c8b823ed5e9"},{"index":58437,"token":false,"name":"Battlefield Percher","scryfallId":"f1ebf021-02a1-4a47-b581-c85a7a76cdec"},{"index":58442,"token":false,"name":"Signpost Scarecrow","scryfallId":"e77f544c-1d27-4632-8ca5-7dfb38f42b1c"},{"index":58448,"token":false,"name":"Juntu Stakes","scryfallId":"3ab7cf53-f62d-47e1-af70-ab12be0d22e2"},{"index":58456,"token":false,"name":"Goblin Assault Team","scryfallId":"880047fd-d258-40fb-bcd5-37cb26678dfe"},{"index":58457,"token":false,"name":"Sorcerer of the Fang","scryfallId":"2fe9e325-fbe4-4f43-8d68-8525c4d5ce8b"},{"index":58461,"token":false,"name":"Trapjaw Kelpie","scryfallId":"62615f86-0431-4709-b41c-af43f7793fdb"},{"index":58469,"token":false,"name":"Ignite the Future","scryfallId":"5a9472e0-1a6d-47f7-91eb-9bdb000e1f1b"},{"index":58479,"token":false,"name":"Skophos Warleader","scryfallId":"59c39c70-8360-4c7c-b5fa-61c42828609a"},{"index":58480,"token":false,"name":"Graveyard Shovel","scryfallId":"1a4b8888-a10c-48b1-ba19-c041e5667b29"},{"index":58484,"token":false,"name":"Erdwal Ripper","scryfallId":"769ea5e9-6d05-4bc6-8f14-00eb2532c8b5"},{"index":58485,"token":false,"name":"Eaten by Spiders","scryfallId":"0efea1b1-f212-4b97-98dd-922f85ab191f"},{"index":58490,"token":true,"name":"Spirit Token (Colorless, 2/2)","scryfallId":"243d7514-35a9-446b-be0d-a5b6b4001291"},{"index":58493,"token":false,"name":"Tunnel Vision","scryfallId":"ae3eba31-02eb-449a-8a36-899ada5664bc"},{"index":58499,"token":false,"name":"Thermal Glider","scryfallId":"fd909c26-930d-4af0-b19a-c899847338b4"},{"index":58512,"token":false,"name":"Wandermare","scryfallId":"9a72fb5b-5c55-4ce9-b9d0-98f924d6f338"},{"index":58525,"token":true,"name":"Mogis's Chosen Token (Colorless, 5/4)","scryfallId":"553ae9d2-3807-4ca8-a575-7fa6667ee212"},{"index":58530,"token":false,"name":"Gateway Sneak","scryfallId":"edc0229d-05e6-41b7-b7a9-2a8b2b258add"},{"index":58536,"token":false,"name":"Orazca Relic","scryfallId":"6ed70bc5-8ea9-404e-a8cd-04322c8bc689"},{"index":58537,"token":false,"name":"Loxodon Anchorite","scryfallId":"a55f0113-3ced-49c7-9fa8-f1cc873bdc4c"},{"index":58554,"token":false,"name":"Alms Beast","scryfallId":"ce441759-cd4c-4bcc-925e-08e8b60853c0"},{"index":58555,"token":false,"name":"Nature's Will","scryfallId":"75a291a0-db0d-4ccc-b7ae-240cafa41883"},{"index":58556,"token":false,"name":"Proven Combatant","scryfallId":"d83fd08a-c87b-4e29-bd1d-31dea3732156"},{"index":58559,"token":false,"name":"Return Upon the Tide","scryfallId":"470601b0-9598-487f-bb14-4bfec7ca6d61"},{"index":58574,"token":false,"name":"Goma Fada Vanguard","scryfallId":"ce83962b-445a-4b44-ad8a-fada2c0a15b8"},{"index":58578,"token":false,"name":"Diamond Kaleidoscope","scryfallId":"548ff852-274d-4068-818d-58a883e74a5f"},{"index":58579,"token":false,"name":"Dross Crocodile","scryfallId":"85e61e00-c55b-4384-923b-a777f75cbe79"},{"index":58591,"token":false,"name":"Warden of Geometries","scryfallId":"c7f517b9-ac10-4710-8ef1-ced1253d5ecf"},{"index":58592,"token":false,"name":"Aven Fleetwing","scryfallId":"57626fd2-d101-4e23-946f-8309c9676fe5"},{"index":58594,"token":false,"name":"Rigging Runner","scryfallId":"eb9983ce-8ca6-450a-9cac-5396ba8e1690"},{"index":58595,"token":false,"name":"Smoke Shroud","scryfallId":"e07c876e-ae1c-4b54-8d8a-9f3fd76ca64c"},{"index":58596,"token":false,"name":"Wary Okapi","scryfallId":"54f26697-0d4b-4af4-a644-3d0ae13f1d2e"},{"index":58613,"token":false,"name":"Highland Berserker","scryfallId":"e3c22bf3-2ba6-4d8f-a2b8-a5d5e26f1316"},{"index":58615,"token":false,"name":"Saberclaw Golem","scryfallId":"6656b6d1-1c92-4da4-8afb-36f11610b0b4"},{"index":58639,"token":false,"name":"Alpine Houndmaster","scryfallId":"43224e74-2c51-40bd-bc34-f66e990a3e33"},{"index":58640,"token":false,"name":"Kithkin Spellduster","scryfallId":"71547cb8-b275-4ff2-a7fa-327cb493ce04"},{"index":58645,"token":false,"name":"Fog Patch","scryfallId":"133f9e4f-2b1b-4a24-ad19-285a2c5845b5"},{"index":58646,"token":false,"name":"Final Death","scryfallId":"8e5b8580-9198-4735-83c1-289400c1d814"},{"index":58650,"token":false,"name":"Stormscape Apprentice","scryfallId":"1eb42f39-9187-44e4-aa34-14ab31977199"},{"index":58656,"token":false,"name":"Molting Snakeskin","scryfallId":"b781cbcf-dbba-41c1-be02-2396b824a217"},{"index":58657,"token":false,"name":"Raze","scryfallId":"56d51b3c-24e9-41b6-b7cd-c70329e498ca"},{"index":58678,"token":false,"name":"Karametra's Blessing","scryfallId":"88c8e4dc-5378-48d6-85b2-f5ea9ec7cf36"},{"index":58679,"token":false,"name":"Master Skald","scryfallId":"6b269e27-8e17-4bf2-b28a-a83ecc7d22c0"},{"index":58682,"token":false,"name":"Frostburn Weird","scryfallId":"ba5a68d3-6bc9-4de8-bc06-e1106cf9b3d4"},{"index":58695,"token":false,"name":"Hydroform","scryfallId":"2c4e1f41-4aed-451b-bbaa-6cc6780cd6c9"},{"index":58696,"token":false,"name":"Phyrexian Tribute","scryfallId":"bfc55d48-6d6f-429d-8281-e66a9996d574"},{"index":58713,"token":false,"name":"Unearthly Blizzard","scryfallId":"d034ad87-fd28-4c23-b897-1d6343ce8282"},{"index":58715,"token":false,"name":"Storm Front","scryfallId":"994bb02d-6fef-454b-b1b1-d3d1af8dcd1a"},{"index":58719,"token":false,"name":"Maelstrom Muse","scryfallId":"5516e81e-16ea-411c-9df0-ed3b03670220"},{"index":58722,"token":false,"name":"Leery Fogbeast","scryfallId":"56125660-2307-4270-a947-f1f4ad63841c"},{"index":58723,"token":false,"name":"Aetherling","scryfallId":"9c93313b-cf43-47e9-a911-717b4d14b0b5"},{"index":58725,"token":false,"name":"Eternity Vessel","scryfallId":"a9222e18-41b3-423f-8715-305a0d8fd410"},{"index":58733,"token":false,"name":"Lose Focus","scryfallId":"985bdb0c-ce6c-4506-8163-76f3b2fdf5fb"},{"index":58734,"token":false,"name":"Charging Tuskodon","scryfallId":"8e49960d-4b45-4d3b-9c6e-e7b717b4feaa"},{"index":58740,"token":false,"name":"Herbal Poultice","scryfallId":"b20925a3-dd4f-477c-806a-a3ec0fd2e00d"},{"index":58746,"token":false,"name":"Lotus Guardian","scryfallId":"ddfc6396-5377-4ab3-9c10-8abcdeae2aa1"},{"index":58750,"token":false,"name":"Zagoth Mamba","scryfallId":"ce945f7e-ded9-4819-9313-d50d3aad40fa"},{"index":58757,"token":false,"name":"Drought","scryfallId":"97736696-3de3-416d-94cf-4fac792f23f0"},{"index":58760,"token":false,"name":"Briarbridge Patrol","scryfallId":"f44a017b-40cb-4c15-b9ea-a3ed904e4e49"},{"index":58761,"token":false,"name":"Cabal Pit","scryfallId":"848d686a-e2f7-488d-947f-a555099b74b1"},{"index":58780,"token":false,"name":"Rockshard Elemental","scryfallId":"2d6343c0-3fb5-4bac-bea7-cba36498cd69"},{"index":58782,"token":false,"name":"Nightmare Unmaking","scryfallId":"95c0ff1b-bd97-4115-8486-62a18bab2610"},{"index":58787,"token":false,"name":"Emerald Oryx","scryfallId":"10bf14b5-31d0-42e3-a319-2622b489f7c4"},{"index":58791,"token":false,"name":"Psychic Intrusion","scryfallId":"2b6e1d03-ad24-4bde-ab3c-28f94e776a4e"},{"index":58800,"token":true,"name":"Illusion // Saproling Token (G, 1/1)","scryfallId":"5cf70d25-9de9-4c3a-a52f-be17831e5695"},{"index":58813,"token":false,"name":"Blizzard Brawl","scryfallId":"6318918f-34e4-4bbf-9816-8e88f21ae324"},{"index":58815,"token":false,"name":"Invade the City","scryfallId":"a587eb67-c2df-486c-9c48-dfeac540efe8"},{"index":58824,"token":false,"name":"Rampage of the Valkyries","scryfallId":"1e928b7c-ca30-4e2d-adf7-965f111c8bf1"},{"index":58832,"token":false,"name":"Powerstone Minefield","scryfallId":"b17807b9-8feb-48ac-813a-829577f5b9e8"},{"index":58836,"token":false,"name":"Gleam of Battle","scryfallId":"e5f0feef-1a71-4c8c-9fd1-f5cbe718a988"},{"index":58850,"token":false,"name":"Spawnbroker","scryfallId":"ce1e4aa6-b06d-4b87-9912-a4c403e8d7c6"},{"index":58871,"token":false,"name":"Daru Healer","scryfallId":"0e4f3eff-ac99-41e2-9003-9630cdb3ae23"},{"index":58874,"token":false,"name":"Dermoplasm","scryfallId":"cf2f5dca-e01f-41e3-bb6f-a60162118c6d"},{"index":58875,"token":false,"name":"Cult Guildmage","scryfallId":"0536c2fa-7402-49a1-9016-dcf5633ca9ef"},{"index":58883,"token":false,"name":"Roar of Challenge","scryfallId":"83456f8f-8a1a-403c-816b-25e454ba1edf"},{"index":58893,"token":false,"name":"Undying Flames","scryfallId":"606206c7-1a8a-46f4-b368-cf18e02f3df8"},{"index":58898,"token":false,"name":"Reckless Bushwhacker","scryfallId":"0405b1b9-976a-4aaf-bec6-fa006decea74"},{"index":58901,"token":false,"name":"Riptide","scryfallId":"b0f11ae4-e30e-441d-bb64-439930d9997c"},{"index":58916,"token":false,"name":"Chandra's Embercat","scryfallId":"30f9c266-f32e-4483-9709-f83675331688"},{"index":58918,"token":false,"name":"Mephitic Ooze","scryfallId":"5465de95-1249-4f14-a2e3-2b2861dfe058"},{"index":58923,"token":false,"name":"Rune of Protection: White","scryfallId":"6408417e-aca3-43f3-9eea-fed5a402d8ab"},{"index":58924,"token":false,"name":"Homarid Explorer","scryfallId":"93be7aa6-1897-4657-b3a6-991b05f7ea5e"},{"index":58927,"token":false,"name":"Arboreal Grazer","scryfallId":"c4a5f86f-44a8-4735-909a-770586d33a15"},{"index":58933,"token":false,"name":"Savage Conception","scryfallId":"b88ab58b-918b-478a-8c6b-a213e2bc87ab"},{"index":58940,"token":false,"name":"Jousting Lance","scryfallId":"446579ab-5e36-44e2-84d7-cfa537619146"},{"index":58943,"token":false,"name":"Aradara Express","scryfallId":"5fc0d1f7-c81c-4329-92b7-c4df227cc56c"},{"index":58946,"token":true,"name":"Triskelavite Token (Colorless, 1/1)","scryfallId":"b5ddb67c-82fb-42d6-a4c2-11cd38eb128d"},{"index":58956,"token":false,"name":"Saltwater Stalwart","scryfallId":"ae11adef-57b1-4f39-951b-cd4d5c0a0b80"},{"index":58966,"token":false,"name":"Nylea's Disciple","scryfallId":"365d716a-1435-48ac-b85f-2cceca1056dd"},{"index":58969,"token":true,"name":"Raphael Levy Bio","scryfallId":"9464681a-9478-4f87-b22d-c32b9cbb0832"},{"index":58970,"token":false,"name":"Psychic Impetus","scryfallId":"9440d3f3-f4f4-450b-ab88-0acbaeec972b"},{"index":58982,"token":false,"name":"Ral's Dispersal","scryfallId":"a2660fae-6459-446d-85dc-3c9126c81cb3"},{"index":58983,"token":false,"name":"Cateran Slaver","scryfallId":"2d293c51-714c-45b8-bfa4-fe35e8f3fbc1"},{"index":58984,"token":false,"name":"Kalitas, Bloodchief of Ghet","scryfallId":"859aab70-8192-414c-839b-dd0fbcbd8bf1"},{"index":58989,"token":false,"name":"Simic Guildmage","scryfallId":"d77d4ffb-a829-49ca-9c37-c60ba467852c"},{"index":58992,"token":false,"name":"Flowstone Strike","scryfallId":"a1203053-0829-4f46-a361-62cb9cd17280"},{"index":58993,"token":false,"name":"Dragon Hunter","scryfallId":"ae8a0362-b973-445a-a355-5a2f3dc67f16"},{"index":59005,"token":false,"name":"Sivvi's Ruse","scryfallId":"132112a0-0fb0-4a80-927d-39d34cf10159"},{"index":59009,"token":false,"name":"Thran War Machine","scryfallId":"5908714a-be91-4279-b87e-e2bc09dbaaba"},{"index":59013,"token":false,"name":"Glamerdye","scryfallId":"829a0a1c-761f-4a7f-b59a-c889d995f446"},{"index":59032,"token":false,"name":"Alpine Guide","scryfallId":"e54423c1-ebea-4b5c-b563-1d14c104eb91"},{"index":59034,"token":false,"name":"Self-Inflicted Wound","scryfallId":"f69b1a5d-fb17-43f0-bf29-4ade853e0e6e"},{"index":59046,"token":false,"name":"Glittering Lion","scryfallId":"ab4be296-33a6-46b1-9748-5b0d335f40ee"},{"index":59047,"token":false,"name":"Surtland Flinger","scryfallId":"4a628052-8175-495f-bfab-eeb3a0388e4e"},{"index":59051,"token":false,"name":"Base Camp","scryfallId":"dc85412e-333d-4e7d-8c85-40618cf1b6c2"},{"index":59054,"token":false,"name":"Nimana Sell-Sword","scryfallId":"8c504d12-a3ef-4588-a52d-734c20f6ac58"},{"index":59057,"token":false,"name":"Nissa's Defeat","scryfallId":"86326456-d188-4083-9141-a639b821b291"},{"index":59059,"token":false,"name":"Knight of the Stampede","scryfallId":"e81565a4-cbbe-4820-8473-15ceda42d553"},{"index":59061,"token":false,"name":"Prowler's Helm","scryfallId":"c100a22c-bf34-42b7-9339-4733698c0935"},{"index":59066,"token":false,"name":"Flowstone Charger","scryfallId":"c57abdab-d99c-418c-818d-b06a8722d733"},{"index":59072,"token":false,"name":"Tombstone Stairwell","scryfallId":"f8fe2f99-7ec2-490c-8ec3-aa2fb4680826"},{"index":59077,"token":false,"name":"Fend Off","scryfallId":"a64d7a33-986d-45ad-8662-7bca80d3628d"},{"index":59078,"token":false,"name":"Champion's Drake","scryfallId":"7585316f-ba3d-4472-9a7e-7db6f6dd9d15"},{"index":59082,"token":false,"name":"Scour from Existence","scryfallId":"6e47edb2-e43d-479f-a911-e72b67a06c3b"},{"index":59093,"token":false,"name":"Brood Birthing","scryfallId":"0e44f7ff-1cfa-4bc4-a0f7-9d71ba48a97a"},{"index":59094,"token":false,"name":"Pious Interdiction","scryfallId":"670b9645-ce34-41eb-a527-4af3e13c3a54"},{"index":59095,"token":false,"name":"Headhunter","scryfallId":"3cbd82d5-d64f-4833-b1a9-9652fcfa1578"},{"index":59102,"token":false,"name":"Plague Dogs","scryfallId":"6b9cebd8-aa3f-4e22-8d15-d4b7bad355e4"},{"index":59108,"token":false,"name":"Long-Term Plans","scryfallId":"7e0422d9-9694-45b6-9c2b-2ca31198cebf"},{"index":59112,"token":false,"name":"Traitorous Blood","scryfallId":"8220f18a-f23f-4fe6-bb58-58b6c5f36c79"},{"index":59116,"token":true,"name":"Elemental Token (R, 0/1)","scryfallId":"bd0bf1d7-2e66-41fd-ae9a-ea86b939e7c9"},{"index":59130,"token":true,"name":"Anointer Priest Token (W, 1/3)","scryfallId":"98956e73-04e4-4d7f-bda5-cfa78eb71350"},{"index":59135,"token":false,"name":"Aether Searcher","scryfallId":"94dcff94-9f25-4ca9-a1f1-5d97de4ab9df"},{"index":59145,"token":false,"name":"Companion of the Trials","scryfallId":"637ac220-058f-4212-ba8b-a389bb0528bd"}]

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionToggle__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccordionCollapse__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AccordionContext__ = __webpack_require__(304);










var Accordion = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
  var _useUncontrolled = __WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook___default()(props, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      activeKey = _useUncontrolled.activeKey,
      bsPrefix = _useUncontrolled.bsPrefix,
      children = _useUncontrolled.children,
      className = _useUncontrolled.className,
      onSelect = _useUncontrolled.onSelect,
      controlledProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useUncontrolled, ["as", "activeKey", "bsPrefix", "children", "className", "onSelect"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'accordion');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AccordionContext__["a" /* default */].Provider, {
    value: activeKey
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelectableContext__["a" /* default */].Provider, {
    value: onSelect
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, controlledProps, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }), children)));
});
Accordion.Toggle = __WEBPACK_IMPORTED_MODULE_6__AccordionToggle__["a" /* default */];
Accordion.Collapse = __WEBPACK_IMPORTED_MODULE_8__AccordionCollapse__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectableContext__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionContext__ = __webpack_require__(304);





var AccordionToggle = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      children = _ref.children,
      eventKey = _ref.eventKey,
      _onClick = _ref.onClick,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["as", "children", "eventKey", "onClick"]);

  var contextEventKey = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__AccordionContext__["a" /* default */]);
  var onSelect = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__SelectableContext__["a" /* default */]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    onClick: function onClick(e) {
      /* 
        Compare the event key in context with the given event key.
        If they are the same, then collapse the component.
      */
      var eventKeyPassed = eventKey === contextEventKey ? null : eventKey;
      onSelect(eventKeyPassed, e);
      if (_onClick) _onClick(e);
    }
  }, props), children);
});
/* harmony default export */ __webpack_exports__["a"] = (AccordionToggle);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collapse__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionContext__ = __webpack_require__(304);





var AccordionCollapse = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      eventKey = _ref.eventKey,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["children", "eventKey"]);

  var contextEventKey = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__AccordionContext__["a" /* default */]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    in: contextEventKey === eventKey
  }, props), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children)));
});
/* harmony default export */ __webpack_exports__["a"] = (AccordionCollapse);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_divWithClassName__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Fade__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(84);












var defaultProps = {
  show: true,
  transition: __WEBPACK_IMPORTED_MODULE_9__Fade__["a" /* default */],
  closeLabel: 'Close alert'
};
var controllables = {
  show: 'onClose'
};
var Alert = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (uncontrolledProps, ref) {
  var _useControllable = __WEBPACK_IMPORTED_MODULE_4_uncontrollable_hook___default()(uncontrolledProps, controllables),
      bsPrefix = _useControllable.bsPrefix,
      show = _useControllable.show,
      closeLabel = _useControllable.closeLabel,
      className = _useControllable.className,
      children = _useControllable.children,
      variant = _useControllable.variant,
      onClose = _useControllable.onClose,
      dismissible = _useControllable.dismissible,
      Transition = _useControllable.transition,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useControllable, ["bsPrefix", "show", "closeLabel", "className", "children", "variant", "onClose", "dismissible", "transition"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_8__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'alert');
  var handleClose = Object(__WEBPACK_IMPORTED_MODULE_5__restart_hooks_useEventCallback__["default"])(function (e) {
    onClose(false, e);
  });
  var alert = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "alert"
  }, Transition ? props : undefined, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, variant && prefix + "-" + variant, dismissible && prefix + "-dismissible")
  }), dismissible && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
    onClick: handleClose,
    label: closeLabel
  }), children);
  if (!Transition) return show ? alert : null;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Transition, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    unmountOnExit: true,
    ref: ref
  }, props, {
    in: show
  }), alert);
});
var DivStyledAsH4 = Object(__WEBPACK_IMPORTED_MODULE_7__utils_divWithClassName__["a" /* default */])('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
Alert.Link = Object(__WEBPACK_IMPORTED_MODULE_6__utils_createWithBsPrefix__["a" /* default */])('alert-link', {
  Component: __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */]
});
Alert.Heading = Object(__WEBPACK_IMPORTED_MODULE_6__utils_createWithBsPrefix__["a" /* default */])('alert-heading', {
  Component: DivStyledAsH4
});
/* unused harmony default export */ var _unused_webpack_default_export = (Alert);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var defaultProps = {
  pill: false
};
var Badge = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      pill = _ref.pill,
      className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "variant", "pill", "className"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'badge');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, pill && prefix + "-pill", variant && prefix + "-" + variant)
  }));
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Badge);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__ = __webpack_require__(558);






var defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
var Breadcrumb = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      listProps = _ref.listProps,
      children = _ref.children,
      label = _ref.label,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'nav' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "listProps", "children", "label", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'breadcrumb');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-label": label,
    className: className,
    ref: ref
  }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ol", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, listProps, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefix, listProps.className)
  }), children));
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = defaultProps;
Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Breadcrumb);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var defaultProps = {
  role: 'toolbar'
};
var ButtonToolbar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'btn-toolbar');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix)
  }));
});
ButtonToolbar.displayName = 'ButtonToolbar';
ButtonToolbar.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ButtonToolbar);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_divWithClassName__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardContext__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardImg__ = __webpack_require__(560);









var DivStyledAsH5 = Object(__WEBPACK_IMPORTED_MODULE_6__utils_divWithClassName__["a" /* default */])('h5');
var DivStyledAsH6 = Object(__WEBPACK_IMPORTED_MODULE_6__utils_divWithClassName__["a" /* default */])('h6');
var CardBody = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-body');
var defaultProps = {
  body: false
};
var Card = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      bg = _ref.bg,
      text = _ref.text,
      border = _ref.border,
      body = _ref.body,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "bg", "text", "border", "body", "children", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'card');
  var cardContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return {
      cardHeaderBsPrefix: prefix + "-header"
    };
  }, [prefix]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CardContext__["a" /* default */].Provider, {
    value: cardContext
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, bg && "bg-" + bg, text && "text-" + text, border && "border-" + border)
  }), body ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(CardBody, null, children) : children));
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
Card.Img = __WEBPACK_IMPORTED_MODULE_8__CardImg__["a" /* default */];
Card.Title = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-title', {
  Component: DivStyledAsH5
});
Card.Subtitle = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-subtitle', {
  Component: DivStyledAsH6
});
Card.Body = CardBody;
Card.Link = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-link', {
  Component: 'a'
});
Card.Text = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-text', {
  Component: 'p'
});
Card.Header = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-header');
Card.Footer = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-footer');
Card.ImgOverlay = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('card-img-overlay');
/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('card-columns'));

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('card-deck'));

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('card-group'));

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_transition__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ElementChildren__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_triggerBrowserReflow__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ThemeProvider__ = __webpack_require__(13);















var countChildren = function countChildren(c) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.toArray(c).filter(__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement).length;
}; // TODO: `slide` should be `animate`.


var defaultProps = {
  slide: true,
  fade: false,
  interval: 5000,
  keyboard: true,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  activeIndex: 0,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
    "aria-hidden": "true",
    className: "carousel-control-prev-icon"
  }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
    "aria-hidden": "true",
    className: "carousel-control-next-icon"
  }),
  nextLabel: 'Next'
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    _this.handleSlideEnd = function () {
      var pendingIndex = _this._pendingIndex;
      _this._isSliding = false;
      _this._pendingIndex = null;
      if (pendingIndex != null) _this.to(pendingIndex);else _this.cycle();
    };

    _this.handleMouseOut = function () {
      _this.cycle();
    };

    _this.handleMouseOver = function () {
      if (_this.props.pauseOnHover) _this.pause();
    };

    _this.handleKeyDown = function (event) {
      if (/input|textarea/i.test(event.target.tagName)) return;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();

          _this.handlePrev(event);

          break;

        case 'ArrowRight':
          event.preventDefault();

          _this.handleNext(event);

          break;

        default:
          break;
      }
    };

    _this.handleNextWhenVisible = function () {
      if (!_this.isUnmounted && !document.hidden && __WEBPACK_IMPORTED_MODULE_4_dom_helpers_style___default()(_this.carousel.current, 'visibility') !== 'hidden') {
        _this.handleNext();
      }
    };

    _this.handleNext = function (e) {
      if (_this._isSliding) return;
      var _this$props = _this.props,
          wrap = _this$props.wrap,
          activeIndex = _this$props.activeIndex;
      var index = activeIndex + 1;
      var count = countChildren(_this.props.children);

      if (index > count - 1) {
        if (!wrap) return;
        index = 0;
      }

      _this.select(index, e, 'next');
    };

    _this.handlePrev = function (e) {
      if (_this._isSliding) return;
      var _this$props2 = _this.props,
          wrap = _this$props2.wrap,
          activeIndex = _this$props2.activeIndex;
      var index = activeIndex - 1;

      if (index < 0) {
        if (!wrap) return;
        index = countChildren(_this.props.children) - 1;
      }

      _this.select(index, e, 'prev');
    };

    _this.state = {
      prevClasses: '',
      currentClasses: 'active'
    };
    _this.isUnmounted = false;
    _this.carousel = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.cycle();
  };

  Carousel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var previousActiveIndex = _ref.activeIndex;

    if (nextProps.activeIndex !== previousActiveIndex) {
      var lastPossibleIndex = countChildren(nextProps.children) - 1;
      var nextIndex = Math.max(0, Math.min(nextProps.activeIndex, lastPossibleIndex));
      var direction;

      if (nextIndex === 0 && previousActiveIndex >= lastPossibleIndex || previousActiveIndex <= nextIndex) {
        direction = 'next';
      } else {
        direction = 'prev';
      }

      return {
        direction: direction,
        previousActiveIndex: previousActiveIndex,
        activeIndex: nextIndex
      };
    }

    return null;
  };

  _proto.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var _this2 = this;

    var _this$props3 = this.props,
        bsPrefix = _this$props3.bsPrefix,
        slide = _this$props3.slide,
        onSlideEnd = _this$props3.onSlideEnd;
    if (!slide || this.state.activeIndex === prevState.activeIndex || this._isSliding) return;
    var _this$state = this.state,
        activeIndex = _this$state.activeIndex,
        direction = _this$state.direction;
    var orderClassName, directionalClassName;

    if (direction === 'next') {
      orderClassName = bsPrefix + "-item-next";
      directionalClassName = bsPrefix + "-item-left";
    } else if (direction === 'prev') {
      orderClassName = bsPrefix + "-item-prev";
      directionalClassName = bsPrefix + "-item-right";
    }

    this._isSliding = true;
    this.pause(); // eslint-disable-next-line react/no-did-update-set-state

    this.safeSetState({
      prevClasses: 'active',
      currentClasses: orderClassName
    }, function () {
      var items = _this2.carousel.current.children;
      var nextElement = items[activeIndex];
      Object(__WEBPACK_IMPORTED_MODULE_12__utils_triggerBrowserReflow__["a" /* default */])(nextElement);

      _this2.safeSetState({
        prevClasses: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('active', directionalClassName),
        currentClasses: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(orderClassName, directionalClassName)
      }, function () {
        return __WEBPACK_IMPORTED_MODULE_5_dom_helpers_transition___default.a.end(nextElement, function () {
          _this2.safeSetState({
            prevClasses: '',
            currentClasses: 'active'
          }, _this2.handleSlideEnd);

          if (onSlideEnd) {
            onSlideEnd();
          }
        });
      });
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.safeSetState = function safeSetState(state, cb) {
    var _this3 = this;

    if (this.isUnmounted) return;
    this.setState(state, function () {
      return !_this3.isUnmounted && cb();
    });
  } // This might be a public API.
  ;

  _proto.pause = function pause() {
    this._isPaused = true;
    clearInterval(this._interval);
    this._interval = null;
  };

  _proto.cycle = function cycle() {
    this._isPaused = false;
    clearInterval(this._interval);
    this._interval = null;

    if (this.props.interval && !this._isPaused) {
      this._interval = setInterval(document.visibilityState ? this.handleNextWhenVisible : this.handleNext, this.props.interval);
    }
  };

  _proto.to = function to(index, event) {
    var children = this.props.children;

    if (index < 0 || index > countChildren(children) - 1) {
      return;
    }

    if (this._isSliding) {
      this._pendingIndex = index;
      return;
    }

    this.select(index, event);
  };

  _proto.select = function select(index, event, direction) {
    var _this4 = this;

    clearTimeout(this.selectThrottle);
    if (event && event.persist) event.persist(); // The timeout throttles fast clicks, in order to give any pending state
    // a chance to update and propagate back through props

    this.selectThrottle = setTimeout(function () {
      clearTimeout(_this4.timeout);
      var _this4$props = _this4.props,
          activeIndex = _this4$props.activeIndex,
          onSelect = _this4$props.onSelect;
      if (index === activeIndex || _this4._isSliding || _this4.isUnmounted) return;
      onSelect(index, direction || (index < activeIndex ? 'prev' : 'next'), event);
    }, 50);
  };

  _proto.renderControls = function renderControls(properties) {
    var bsPrefix = this.props.bsPrefix;
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var count = countChildren(children);
    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "prev",
      className: bsPrefix + "-control-prev",
      onClick: this.handlePrev
    }, prevIcon, prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "next",
      className: bsPrefix + "-control-next",
      onClick: this.handleNext
    }, nextIcon, nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex) {
    var _this5 = this;

    var bsPrefix = this.props.bsPrefix;
    var indicators = [];
    Object(__WEBPACK_IMPORTED_MODULE_11__utils_ElementChildren__["a" /* forEach */])(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this5.to(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("ol", {
      className: bsPrefix + "-indicators"
    }, indicators);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        _this$props4$as = _this$props4.as,
        Component = _this$props4$as === void 0 ? 'div' : _this$props4$as,
        bsPrefix = _this$props4.bsPrefix,
        slide = _this$props4.slide,
        fade = _this$props4.fade,
        indicators = _this$props4.indicators,
        controls = _this$props4.controls,
        wrap = _this$props4.wrap,
        prevIcon = _this$props4.prevIcon,
        prevLabel = _this$props4.prevLabel,
        nextIcon = _this$props4.nextIcon,
        nextLabel = _this$props4.nextLabel,
        className = _this$props4.className,
        children = _this$props4.children,
        keyboard = _this$props4.keyboard,
        _5 = _this$props4.activeIndex,
        _4 = _this$props4.pauseOnHover,
        _3 = _this$props4.interval,
        _2 = _this$props4.onSelect,
        _1 = _this$props4.onSlideEnd,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props4, ["as", "bsPrefix", "slide", "fade", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children", "keyboard", "activeIndex", "pauseOnHover", "interval", "onSelect", "onSlideEnd"]);

    var _this$state2 = this.state,
        activeIndex = _this$state2.activeIndex,
        previousActiveIndex = _this$state2.previousActiveIndex,
        prevClasses = _this$state2.prevClasses,
        currentClasses = _this$state2.currentClasses;
    return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, slide && 'slide', fade && bsPrefix + "-fade"),
        onKeyDown: keyboard ? this.handleKeyDown : undefined,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }), indicators && this.renderIndicators(children, activeIndex), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
        className: bsPrefix + "-inner",
        ref: this.carousel
      }, Object(__WEBPACK_IMPORTED_MODULE_11__utils_ElementChildren__["b" /* map */])(children, function (child, index) {
        var current = index === activeIndex;
        var previous = index === previousActiveIndex;
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(child.props.className, bsPrefix + "-item", current && currentClasses, previous && prevClasses)
        });
      })), controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel
      }))
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.defaultProps = defaultProps;
var DecoratedCarousel = Object(__WEBPACK_IMPORTED_MODULE_13__ThemeProvider__["a" /* createBootstrapComponent */])(Object(__WEBPACK_IMPORTED_MODULE_7_uncontrollable__["default"])(Carousel, {
  activeIndex: 'onSelect'
}), 'carousel');
DecoratedCarousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
DecoratedCarousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedCarousel);

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(118));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(234));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('carousel-caption', {
  Component: 'div'
}));

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _matches = _interopRequireDefault(__webpack_require__(1205));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(101));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _uncontrollable = _interopRequireDefault(__webpack_require__(77));

var Popper = _interopRequireWildcard(__webpack_require__(310));

var _DropdownContext = _interopRequireDefault(__webpack_require__(312));

var _DropdownMenu = _interopRequireDefault(__webpack_require__(564));

var _DropdownToggle = _interopRequireDefault(__webpack_require__(570));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  /**
   * A render prop that returns the root dropdown element. The `props`
   * argument should spread through to an element containing _both_ the
   * menu and toggle in order to handle keyboard events for focus management.
   *
   * @type {Function ({
   *   props: {
   *     onKeyDown: (SyntheticEvent) => void,
   *   },
   * }) => React.Element}
   */
  children: _propTypes.default.func.isRequired,

  /**
   * Determines the direction and location of the Menu in relation to it's Toggle.
   */
  drop: _propTypes.default.oneOf(['up', 'left', 'right', 'down']),

  /**
   * Controls the focus behavior for when the Dropdown is opened. Set to
   * `true` to always focus the first menu item, `keyboard` to focus only when
   * navigating via the keyboard, or `false` to disable completely
   *
   * The Default behavior is `false` **unless** the Menu has a `role="menu"`
   * where it will default to `keyboard` to match the recommended [ARIA Authoring practices](https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton).
   */
  focusFirstItemOnShow: _propTypes.default.oneOf([false, true, 'keyboard']),

  /**
   * A css slector string that will return __focusable__ menu items.
   * Selectors should be relative to the menu component:
   * e.g. ` > li:not('.disabled')`
   */
  itemSelector: _propTypes.default.string.isRequired,

  /**
   * Align the menu to the 'end' side of the placement side of the Dropdown toggle. The default placement is `top-start` or `bottom-start`.
   */
  alignEnd: _propTypes.default.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  show: _propTypes.default.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `show` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(
   *   isOpen: boolean,
   *   event: SyntheticEvent,
   * ): void
   * ```
   *
   * @controllable show
   */
  onToggle: _propTypes.default.func
};
var defaultProps = {
  itemSelector: '* > *'
};
/**
 * `Dropdown` is set of structural components for building, accessible dropdown menus with close-on-click,
 * keyboard navigation, and correct focus handling. As with all the react-overlay's
 * components its BYOS (bring your own styles). Dropdown is primarily
 * built from three base components, you should compose to build your Dropdowns.
 *
 * - `Dropdown`, which wraps the menu and toggle, and handles keyboard navigation
 * - `Dropdown.Toggle` generally a button that triggers the menu opening
 * - `Dropdown.Menu` The overlaid, menu, positioned to the toggle with PopperJs
 */

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Dropdown, _React$Component);

  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var drop = _ref.drop,
        alignEnd = _ref.alignEnd,
        show = _ref.show;
    var lastShow = prevState.context.show;
    return {
      lastShow: lastShow,
      context: _extends({}, prevState.context, {
        drop: drop,
        show: show,
        alignEnd: alignEnd
      })
    };
  };

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    _this.handleClick = function (event) {
      _this.toggleOpen(event);
    };

    _this.handleKeyDown = function (event) {
      var key = event.key,
          target = event.target; // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
      // in inscrutability

      var isInput = /input|textarea/i.test(target.tagName);

      if (isInput && (key === ' ' || key !== 'Escape' && _this.menu.contains(target))) {
        return;
      }

      _this._lastSourceEvent = event.type;

      switch (key) {
        case 'ArrowUp':
          {
            var next = _this.getNextFocusedChild(target, -1);

            if (next && next.focus) next.focus();
            event.preventDefault();
            return;
          }

        case 'ArrowDown':
          event.preventDefault();

          if (!_this.props.show) {
            _this.toggleOpen(event);
          } else {
            var _next = _this.getNextFocusedChild(target, 1);

            if (_next && _next.focus) _next.focus();
          }

          return;

        case 'Escape':
        case 'Tab':
          _this.props.onToggle(false, event);

          break;

        default:
      }
    };

    _this._focusInDropdown = false;
    _this.menu = null;
    _this.state = {
      context: {
        close: _this.handleClose,
        toggle: _this.handleClick,
        menuRef: function menuRef(r) {
          _this.menu = r;
        },
        toggleRef: function toggleRef(r) {
          var toggleNode = r && _reactDom.default.findDOMNode(r);

          _this.setState(function (_ref2) {
            var context = _ref2.context;
            return {
              context: _extends({}, context, {
                toggleNode: toggleNode
              })
            };
          });
        }
      }
    };
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var show = this.props.show;
    var prevOpen = prevProps.show;

    if (show && !prevOpen) {
      this.maybeFocusFirst();
    }

    this._lastSourceEvent = null;

    if (!show && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.getNextFocusedChild = function getNextFocusedChild(current, offset) {
    if (!this.menu) return null;
    var itemSelector = this.props.itemSelector;
    var items = (0, _querySelectorAll.default)(this.menu, itemSelector);
    var index = items.indexOf(current) + offset;
    index = Math.max(0, Math.min(index, items.length));
    return items[index];
  };

  _proto.hasMenuRole = function hasMenuRole() {
    return this.menu && (0, _matches.default)(this.menu, '[role=menu]');
  };

  _proto.focus = function focus() {
    var toggleNode = this.state.context.toggleNode;

    if (toggleNode && toggleNode.focus) {
      toggleNode.focus();
    }
  };

  _proto.maybeFocusFirst = function maybeFocusFirst() {
    var type = this._lastSourceEvent;
    var focusFirstItemOnShow = this.props.focusFirstItemOnShow;

    if (focusFirstItemOnShow == null) {
      focusFirstItemOnShow = this.hasMenuRole() ? 'keyboard' : false;
    }

    if (focusFirstItemOnShow === false || focusFirstItemOnShow === 'keyboard' && !/^key.+$/.test(type)) {
      return;
    }

    var itemSelector = this.props.itemSelector;
    var first = (0, _querySelectorAll.default)(this.menu, itemSelector)[0];
    if (first && first.focus) first.focus();
  };

  _proto.toggleOpen = function toggleOpen(event) {
    var show = !this.props.show;
    this.props.onToggle(show, event);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    delete props.onToggle;

    if (this.menu && this.state.lastShow && !this.props.show) {
      this._focusInDropdown = this.menu.contains(document.activeElement);
    }

    return _react.default.createElement(_DropdownContext.default.Provider, {
      value: this.state.context
    }, _react.default.createElement(Popper.Manager, null, children({
      props: {
        onKeyDown: this.handleKeyDown
      }
    })));
  };

  return Dropdown;
}(_react.default.Component);

Dropdown.displayName = 'ReactOverlaysDropdown';
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
var UncontrolledDropdown = (0, _uncontrollable.default)(Dropdown, {
  show: 'onToggle'
});
UncontrolledDropdown.Menu = _DropdownMenu.default;
UncontrolledDropdown.Toggle = _DropdownToggle.default;
var _default = UncontrolledDropdown;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = matches;

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(101));

var matchesCache;

function matches(node, selector) {
  if (!matchesCache && _inDOM.default) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
    matchesCache = nativeMatch ? function (node, selector) {
      return nativeMatch.call(node, selector);
    } : ie8MatchesSelector;
  }

  return matchesCache ? matchesCache(node, selector) : null;
}

function ie8MatchesSelector(node, selector) {
  var matches = (0, _querySelectorAll.default)(node.document || node.ownerDocument, selector),
      i = 0;

  while (matches[i] && matches[i] !== node) {
    i++;
  }

  return !!matches[i];
}

module.exports = exports["default"];

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_popper_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Manager__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(563);









var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* safeInvoke */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_6_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* safeInvoke */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_6_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Manager__["a" /* ManagerContext */].Consumer, null, function (_ref2) {
    var referenceNode = _ref2.referenceNode;
    return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1208);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(526);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1209);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1210);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(563);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["a" /* ManagerContext */].Consumer, null, function (_ref) {
    var setReferenceNode = _ref.setReferenceNode;
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapContextToProps;

var _react = _interopRequireDefault(__webpack_require__(0));

var _forwardRef = _interopRequireDefault(__webpack_require__(569));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getDisplayName = function getDisplayName(Component) {
  var name = typeof Component === 'string' ? Component : Component.name || Component.displayName;
  return name ? "ContextTransform(" + name + ")" : 'ContextTransform';
};

var ensureConsumer = function ensureConsumer(c) {
  return c.Consumer || c;
};

function $mapContextToProps(_ref, Component) {
  var maybeArrayOfConsumers = _ref.consumers,
      mapToProps = _ref.mapToProps,
      displayName = _ref.displayName,
      _ref$forwardRefAs = _ref.forwardRefAs,
      forwardRefAs = _ref$forwardRefAs === void 0 ? 'ref' : _ref$forwardRefAs;
  var consumers = maybeArrayOfConsumers;

  if (!Array.isArray(maybeArrayOfConsumers)) {
    consumers = [maybeArrayOfConsumers];
  }

  var SingleConsumer = ensureConsumer(consumers[0]);

  function singleRender(props, ref) {
    var _extends2;

    var propsWithRef = _extends((_extends2 = {}, _extends2[forwardRefAs] = ref, _extends2), props);

    return _react.default.createElement(SingleConsumer, null, function (value) {
      return _react.default.createElement(Component, _extends({}, propsWithRef, mapToProps(value, props)));
    });
  }

  function multiRender(props, ref) {
    var _extends3;

    var propsWithRef = _extends((_extends3 = {}, _extends3[forwardRefAs] = ref, _extends3), props);

    return consumers.reduceRight(function (inner, Context) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var Consumer = ensureConsumer(Context);
        return _react.default.createElement(Consumer, null, function (value) {
          return inner.apply(void 0, args.concat([value]));
        });
      };
    }, function () {
      for (var _len2 = arguments.length, contexts = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        contexts[_key2] = arguments[_key2];
      }

      return _react.default.createElement(Component, _extends({}, propsWithRef, mapToProps.apply(void 0, contexts.concat([props]))));
    })();
  }

  var contextTransform = consumers.length === 1 ? singleRender : multiRender;
  return (0, _forwardRef.default)(contextTransform, {
    displayName: displayName || getDisplayName(Component)
  });
}

function mapContextToProps(maybeOpts, mapToProps, Component) {
  if (arguments.length === 2) return $mapContextToProps(maybeOpts, mapToProps);
  return $mapContextToProps({
    consumers: maybeOpts,
    mapToProps: mapToProps
  }, Component);
}

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_overlays_DropdownMenu__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_overlays_DropdownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_overlays_DropdownMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavbarContext__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);









var wrapRef = function wrapRef(props) {
  var ref = props.ref;

  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
    return ref(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(r));
  });

  return props;
};

var defaultProps = {
  alignRight: false,
  flip: true
};
var DropdownMenu = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      alignRight = _ref.alignRight,
      rootCloseEvent = _ref.rootCloseEvent,
      flip = _ref.flip,
      popperConfig = _ref.popperConfig,
      showProps = _ref.show,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "alignRight", "rootCloseEvent", "flip", "popperConfig", "show", "as"]);

  var isNavbar = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__NavbarContext__["a" /* default */]);
  var prefix = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'dropdown-menu');
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_overlays_DropdownMenu___default.a, {
    ref: ref // FIXME: the ref situation is out of hand here
    ,
    flip: flip,
    show: showProps,
    alignEnd: alignRight,
    usePopper: !isNavbar,
    popperConfig: popperConfig,
    rootCloseEvent: rootCloseEvent
  }, function (_ref2) {
    var placement = _ref2.placement,
        show = _ref2.show,
        alignEnd = _ref2.alignEnd,
        close = _ref2.close,
        menuProps = _ref2.props;
    wrapRef(menuProps); // For custom components provide additional, non-DOM, props;

    if (typeof Component !== 'string') {
      menuProps.show = show;
      menuProps.close = close;
      menuProps.alignRight = alignEnd;
    }

    var style = props.style;

    if (placement) {
      // we don't need the default popper style,
      // menus are display: none when not shown.
      style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, menuProps.style);
      props['x-placement'] = placement;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, menuProps, {
      style: style,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, show && 'show', alignEnd && prefix + "-right")
    }));
  });
});
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_DropdownToggle__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_DropdownToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_overlays_DropdownToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThemeProvider__ = __webpack_require__(13);











var wrapRef = function wrapRef(props) {
  var ref = props.ref;

  props.ref = ref.__wrapped || (ref.__wrapped = function (r) {
    return ref(Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(r));
  });

  return props;
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        split = _this$props.split,
        className = _this$props.className,
        children = _this$props.children,
        childBsPrefix = _this$props.childBsPrefix,
        Component = _this$props.as,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "split", "className", "children", "childBsPrefix", "as"]);

    if (childBsPrefix !== undefined) {
      props.bsPrefix = childBsPrefix;
    } // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.


    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_overlays_DropdownToggle___default.a, null, function (_ref) {
      var toggle = _ref.toggle,
          toggleProps = _ref.props;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        onClick: toggle,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, split && bsPrefix + "-split")
      }, wrapRef(toggleProps), props), children);
    });
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component); // Needs to be a class FTM, because it needs to accept a ref that can be used with findDOMNode


DropdownToggle.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__ThemeProvider__["a" /* createBootstrapComponent */])(DropdownToggle, 'dropdown-toggle'));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropdown__ = __webpack_require__(204);





var propTypes = {
  /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,

  /** An `href` passed to the Toggle component */
  href: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /** An `onClick` handler passed to the Toggle component */
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /** The content of the non-toggle Button.  */
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,

  /** Disables both Buttons  */
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
  menuRole: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#menu-props) for more details_
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /** @ignore */
  bsPrefix: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /** @ignore */
  variant: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /** @ignore */
  size: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`.
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu related props are passed to the `Dropdown.Menu`
 */

var DropdownButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      rootCloseEvent = _ref.rootCloseEvent,
      variant = _ref.variant,
      size = _ref.size,
      menuRole = _ref.menuRole,
      disabled = _ref.disabled,
      href = _ref.href,
      id = _ref.id,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuRole", "disabled", "href", "id"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Toggle, {
    id: id,
    href: href,
    size: size,
    variant: variant,
    disabled: disabled,
    childBsPrefix: bsPrefix
  }, title), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Menu, {
    role: menuRole,
    rootCloseEvent: rootCloseEvent
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormGroup__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormCheck__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormLabel__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormText__ = __webpack_require__(577);











var defaultProps = {
  inline: false
};
var Form = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      className = _ref.className,
      validated = _ref.validated,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'form' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "inline", "className", "validated", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, validated && 'was-validated', inline && bsPrefix + "-inline")
  }));
});
Form.displayName = 'Form';
Form.defaultProps = defaultProps;
Form.Row = Object(__WEBPACK_IMPORTED_MODULE_4__utils_createWithBsPrefix__["a" /* default */])('form-row');
Form.Group = __WEBPACK_IMPORTED_MODULE_6__FormGroup__["a" /* default */];
Form.Control = __WEBPACK_IMPORTED_MODULE_7__FormControl__["a" /* default */];
Form.Check = __WEBPACK_IMPORTED_MODULE_8__FormCheck__["a" /* default */];
Form.Label = __WEBPACK_IMPORTED_MODULE_9__FormLabel__["a" /* default */];
Form.Text = __WEBPACK_IMPORTED_MODULE_10__FormText__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormContext__ = __webpack_require__(110);






var defaultProps = {
  type: 'checkbox'
};
var FormCheckInput = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      isStatic = _ref.isStatic,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "bsPrefix", "className", "isValid", "isInvalid", "isStatic"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-check-input');

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__FormContext__["a" /* default */]),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    id: id || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !custom && bsPrefix, custom && 'custom-control-input', isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
  }));
});
FormCheckInput.displayName = 'FormCheckInput';
FormCheckInput.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormCheckInput);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormContext__ = __webpack_require__(110);






var defaultProps = {
  type: 'checkbox'
};
var FormCheckLabel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "htmlFor"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'form-check-label');

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__FormContext__["a" /* default */]),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !custom && bsPrefix, custom && 'custom-control-label')
  }));
});
FormCheckLabel.displayName = 'FormCheckLabel';
FormCheckLabel.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormCheckLabel);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);





var defaultProps = {
  fluid: false
};
var Container = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      fluid = _ref.fluid,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "fluid", "as", "className"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'container');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? prefix + "-fluid" : prefix)
  }));
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FigureImage__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FigureCaption__ = __webpack_require__(1222);



var Figure = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('figure', {
  Component: 'figure'
});
Figure.Image = __WEBPACK_IMPORTED_MODULE_1__FigureImage__["a" /* default */];
Figure.Caption = __WEBPACK_IMPORTED_MODULE_2__FigureCaption__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Figure);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Image__ = __webpack_require__(578);






var propTypes = {
  /**
   * @default 'img'
   */
  bsPrefix: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * Sets image as fluid image.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded.
   */
  rounded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Sets image shape as circle.
   */
  roundedCircle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail.
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
var defaultProps = {
  fluid: true
};
var FigureImage = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["className"]);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Image__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'figure-img')
  }));
});
FigureImage.displayName = 'FigureImage';
FigureImage.propTypes = propTypes;
FigureImage.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FigureImage);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__ = __webpack_require__(35);

var FigureCaption = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createWithBsPrefix__["a" /* default */])('figure-caption', {
  Component: 'figcaption'
});
/* harmony default export */ __webpack_exports__["a"] = (FigureCaption);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(13);







/**
 *
 * @property {InputGroupAppend} Append
 * @property {InputGroupPrepend} Prepend
 * @property {InputGroupText} Text
 * @property {InputGroupRadio} Radio
 * @property {InputGroupCheckbox} Checkbox
 */

var InputGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        size = _this$props.size,
        className = _this$props.className,
        _this$props$as = _this$props.as,
        Component = _this$props$as === void 0 ? 'div' : _this$props$as,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "size", "className", "as"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, size && bsPrefix + "-" + size)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

var InputGroupAppend = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('input-group-append');
var InputGroupPrepend = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('input-group-prepend');
var InputGroupText = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createWithBsPrefix__["a" /* default */])('input-group-text', {
  Component: 'span'
});

var InputGroupCheckbox = function InputGroupCheckbox(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(InputGroupText, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox"
  }, props)));
};

var InputGroupRadio = function InputGroupRadio(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(InputGroupText, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "radio"
  }, props)));
};

var DecoratedInputGroup = Object(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a" /* createBootstrapComponent */])(InputGroup, 'input-group');
DecoratedInputGroup.Text = InputGroupText;
DecoratedInputGroup.Radio = InputGroupRadio;
DecoratedInputGroup.Checkbox = InputGroupCheckbox;
DecoratedInputGroup.Append = InputGroupAppend;
DecoratedInputGroup.Prepend = InputGroupPrepend;
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedInputGroup);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var defaultProps = {
  fluid: false
};

var Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _classes;

    var _this$props = this.props,
        _this$props$as = _this$props.as,
        Component = _this$props$as === void 0 ? 'div' : _this$props$as,
        className = _this$props.className,
        fluid = _this$props.fluid,
        bsPrefix = _this$props.bsPrefix,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["as", "className", "fluid", "bsPrefix"]);

    var classes = (_classes = {}, _classes[bsPrefix] = true, _classes[bsPrefix + "-fluid"] = fluid, _classes);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Jumbotron.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Jumbotron, 'jumbotron'));

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AbstractNav__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(580);










var ListGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        bsPrefix = _this$props.bsPrefix,
        variant = _this$props.variant,
        _this$props$as = _this$props.as,
        as = _this$props$as === void 0 ? 'div' : _this$props$as,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "bsPrefix", "variant", "as"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AbstractNav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      as: as,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, variant && bsPrefix + "-" + variant)
    }));
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ListGroup.defaultProps = {
  variant: null
};
var DecoratedListGroup = Object(__WEBPACK_IMPORTED_MODULE_5_uncontrollable__["default"])(Object(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a" /* createBootstrapComponent */])(ListGroup, 'list-group'), {
  activeKey: 'onSelect'
});
DecoratedListGroup.Item = __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedListGroup);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var Media = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'media');
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix)
  }));
});
Media.displayName = 'Media';
Media.Body = Object(__WEBPACK_IMPORTED_MODULE_4__utils_createWithBsPrefix__["a" /* default */])('media-body');
/* unused harmony default export */ var _unused_webpack_default_export = (Media);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_events__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_ownerDocument__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_util_inDOM__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_scrollbarSize__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_Modal__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_overlays_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalBody__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ModalDialog__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalFooter__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ModalHeader__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ModalTitle__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_BootstrapModalManager__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalContext__ = __webpack_require__(591);



















var defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  animation: true,
  dialogAs: __WEBPACK_IMPORTED_MODULE_12__ModalDialog__["a" /* default */],
  manager: new __WEBPACK_IMPORTED_MODULE_16__utils_BootstrapModalManager__["a" /* default */]()
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */], props);
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */], props);
}
/* eslint-enable no-use-before-define */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(_props, context) {
    var _this;

    _this = _React$Component.call(this, _props, context) || this;

    _this.setModalRef = function (ref) {
      _this._modal = ref;
    };

    _this.handleDialogMouseDown = function () {
      _this._waitingForMouseUp = true;
    };

    _this.handleMouseUp = function (e) {
      if (_this._waitingForMouseUp && e.target === _this._modal.dialog) {
        _this._ignoreBackdropClick = true;
      }

      _this._waitingForMouseUp = false;
    };

    _this.handleClick = function (e) {
      if (_this._ignoreBackdropClick || e.target !== e.currentTarget) {
        _this._ignoreBackdropClick = false;
        return;
      }

      _this.props.onHide();
    };

    _this.handleEnter = function (node) {
      var _this$props;

      if (node) {
        node.style.display = 'block';

        _this.updateDialogStyle(node);
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (_this.props.onEnter) (_this$props = _this.props).onEnter.apply(_this$props, [node].concat(args));
    };

    _this.handleEntering = function (node) {
      var _this$props2;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (_this.props.onEntering) (_this$props2 = _this.props).onEntering.apply(_this$props2, [node].concat(args)); // FIXME: This should work even when animation is disabled.

      __WEBPACK_IMPORTED_MODULE_4_dom_helpers_events___default.a.on(window, 'resize', _this.handleWindowResize);
    };

    _this.handleExited = function (node) {
      var _this$props3;

      if (node) node.style.display = ''; // RHL removes it sometimes

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      if (_this.props.onExited) (_this$props3 = _this.props).onExited.apply(_this$props3, args); // FIXME: This should work even when animation is disabled.

      __WEBPACK_IMPORTED_MODULE_4_dom_helpers_events___default.a.off(window, 'resize', _this.handleWindowResize);
    };

    _this.handleWindowResize = function () {
      _this.updateDialogStyle(_this._modal.dialog);
    };

    _this.renderBackdrop = function (props) {
      var _this$props4 = _this.props,
          bsPrefix = _this$props4.bsPrefix,
          backdropClassName = _this$props4.backdropClassName;
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(bsPrefix + "-backdrop", backdropClassName)
      }));
    };

    _this.state = {
      style: {}
    };
    _this.modalContext = {
      onHide: function onHide() {
        return _this.props.onHide();
      }
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    __WEBPACK_IMPORTED_MODULE_4_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  _proto.updateDialogStyle = function updateDialogStyle(node) {
    if (!__WEBPACK_IMPORTED_MODULE_6_dom_helpers_util_inDOM___default.a) return;
    var manager = this.props.manager;
    var containerIsOverflowing = manager.isContainerOverflowing(this._modal);
    var modalIsOverflowing = node.scrollHeight > __WEBPACK_IMPORTED_MODULE_5_dom_helpers_ownerDocument___default()(node).documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: containerIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !containerIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        bsPrefix = _this$props5.bsPrefix,
        className = _this$props5.className,
        style = _this$props5.style,
        dialogClassName = _this$props5.dialogClassName,
        children = _this$props5.children,
        Dialog = _this$props5.dialogAs,
        show = _this$props5.show,
        animation = _this$props5.animation,
        backdrop = _this$props5.backdrop,
        keyboard = _this$props5.keyboard,
        manager = _this$props5.manager,
        onEscapeKeyDown = _this$props5.onEscapeKeyDown,
        onShow = _this$props5.onShow,
        onHide = _this$props5.onHide,
        container = _this$props5.container,
        autoFocus = _this$props5.autoFocus,
        enforceFocus = _this$props5.enforceFocus,
        restoreFocus = _this$props5.restoreFocus,
        onEntered = _this$props5.onEntered,
        onExit = _this$props5.onExit,
        onExiting = _this$props5.onExiting,
        _ = _this$props5.onExited,
        _1 = _this$props5.onEntering,
        _6 = _this$props5.onEnter,
        _4 = _this$props5.onEntering,
        _2 = _this$props5.backdropClassName,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props5, ["bsPrefix", "className", "style", "dialogClassName", "children", "dialogAs", "show", "animation", "backdrop", "keyboard", "manager", "onEscapeKeyDown", "onShow", "onHide", "container", "autoFocus", "enforceFocus", "restoreFocus", "onEntered", "onExit", "onExiting", "onExited", "onEntering", "onEnter", "onEntering", "backdropClassName"]);

    var clickHandler = backdrop === true ? this.handleClick : null;

    var baseModalStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, this.state.style); // Sets `display` always block when `animation` is false


    if (!animation) baseModalStyle.display = 'block';
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ModalContext__["a" /* default */].Provider, {
      value: this.modalContext
    }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_overlays_Modal___default.a, {
      show: show,
      backdrop: backdrop,
      container: container,
      keyboard: keyboard,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      onEscapeKeyDown: onEscapeKeyDown,
      onShow: onShow,
      onHide: onHide,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      manager: manager,
      ref: this.setModalRef,
      style: baseModalStyle,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix),
      containerClassName: bsPrefix + "-open",
      transition: animation ? DialogTransition : undefined,
      backdropTransition: animation ? BackdropTransition : undefined,
      renderBackdrop: this.renderBackdrop,
      onClick: clickHandler,
      onMouseUp: this.handleMouseUp,
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onExited: this.handleExited
    }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Dialog, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onMouseDown: this.handleDialogMouseDown,
      className: dialogClassName
    }), children)));
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Modal.defaultProps = defaultProps;
var DecoratedModal = Object(__WEBPACK_IMPORTED_MODULE_17__ThemeProvider__["a" /* createBootstrapComponent */])(Modal, 'modal');
DecoratedModal.Body = __WEBPACK_IMPORTED_MODULE_11__ModalBody__["a" /* default */];
DecoratedModal.Header = __WEBPACK_IMPORTED_MODULE_14__ModalHeader__["a" /* default */];
DecoratedModal.Title = __WEBPACK_IMPORTED_MODULE_15__ModalTitle__["a" /* default */];
DecoratedModal.Footer = __WEBPACK_IMPORTED_MODULE_13__ModalFooter__["a" /* default */];
DecoratedModal.Dialog = __WEBPACK_IMPORTED_MODULE_12__ModalDialog__["a" /* default */];
DecoratedModal.TRANSITION_DURATION = 300;
DecoratedModal.BACKDROP_TRANSITION_DURATION = 150;
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedModal);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(566));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(567));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1229));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(313));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(205));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(101));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _activeElement = _interopRequireDefault(__webpack_require__(1231));

var _contains = _interopRequireDefault(__webpack_require__(205));

var _inDOM = _interopRequireDefault(__webpack_require__(63));

var _listen = _interopRequireDefault(__webpack_require__(313));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _componentOrElement = _interopRequireDefault(__webpack_require__(207));

var _elementType = _interopRequireDefault(__webpack_require__(582));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _ModalManager = _interopRequireDefault(__webpack_require__(583));

var _Portal = _interopRequireDefault(__webpack_require__(585));

var _getContainer = _interopRequireDefault(__webpack_require__(587));

var _ownerDocument = _interopRequireDefault(__webpack_require__(568));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var modalManager = new _ModalManager.default();

function omitProps(props, propTypes) {
  var keys = Object.keys(props);
  var newProps = {};
  keys.map(function (prop) {
    if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
      newProps[prop] = props[prop];
    }
  });
  return newProps;
}
/**
 * Love them or hate them, `<Modal />` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Modal, _React$Component);

  function Modal() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.state = {
      exited: !_this.props.show
    };

    _this.onPortalRendered = function () {
      if (_this.props.onShow) {
        _this.props.onShow();
      } // autofocus after onShow, to not trigger a focus event for previous
      // modals before this one is shown.


      _this.autoFocus();
    };

    _this.onShow = function () {
      var doc = (0, _ownerDocument.default)(_assertThisInitialized(_assertThisInitialized(_this)));
      var container = (0, _getContainer.default)(_this.props.container, doc.body);

      _this.props.manager.add(_assertThisInitialized(_assertThisInitialized(_this)), container, _this.props.containerClassName);

      _this.removeKeydownListener = (0, _listen.default)(doc, 'keydown', _this.handleDocumentKeyDown);
      _this.removeFocusListener = (0, _listen.default)(doc, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
      // and so steals focus from it
      function () {
        return setTimeout(_this.enforceFocus);
      }, true);
    };

    _this.onHide = function () {
      _this.props.manager.remove(_assertThisInitialized(_assertThisInitialized(_this)));

      _this.removeKeydownListener();

      _this.removeFocusListener();

      if (_this.props.restoreFocus) {
        _this.restoreLastFocus();
      }
    };

    _this.setDialogRef = function (ref) {
      _this.dialog = ref;
    };

    _this.setBackdropRef = function (ref) {
      _this.backdrop = ref && _reactDom.default.findDOMNode(ref);
    };

    _this.handleHidden = function () {
      _this.setState({
        exited: true
      });

      _this.onHide();

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.handleBackdropClick = function (e) {
      if (e.target !== e.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(e);
      }

      if (_this.props.backdrop === true) {
        _this.props.onHide();
      }
    };

    _this.handleDocumentKeyDown = function (e) {
      if (_this.props.keyboard && e.keyCode === 27 && _this.isTopModal()) {
        if (_this.props.onEscapeKeyDown) {
          _this.props.onEscapeKeyDown(e);
        }

        _this.props.onHide();
      }
    };

    _this.enforceFocus = function () {
      if (!_this.props.enforceFocus || !_this._isMounted || !_this.isTopModal()) {
        return;
      }

      var currentActiveElement = (0, _activeElement.default)((0, _ownerDocument.default)(_assertThisInitialized(_assertThisInitialized(_this))));

      if (_this.dialog && !(0, _contains.default)(_this.dialog, currentActiveElement)) {
        _this.dialog.focus();
      }
    };

    _this.renderBackdrop = function () {
      var _this$props2 = _this.props,
          renderBackdrop = _this$props2.renderBackdrop,
          Transition = _this$props2.backdropTransition;
      var backdrop = renderBackdrop({
        ref: _this.setBackdropRef,
        onClick: _this.handleBackdropClick
      });

      if (Transition) {
        backdrop = _react.default.createElement(Transition, {
          appear: true,
          in: _this.props.show
        }, backdrop);
      }

      return backdrop;
    };

    return _this;
  }

  Modal.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    if (nextProps.show) {
      return {
        exited: false
      };
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      return {
        exited: true
      };
    }

    return null;
  };

  var _proto = Modal.prototype;

  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
    if (_inDOM.default && !prevProps.show && this.props.show) {
      this.lastFocus = (0, _activeElement.default)();
    }

    return null;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this.props.show) {
      this.onShow();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;

    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$props3 = this.props,
        show = _this$props3.show,
        transition = _this$props3.transition;
    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  _proto.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) return;
    var currentActiveElement = (0, _activeElement.default)((0, _ownerDocument.default)(this));

    if (this.dialog && !(0, _contains.default)(this.dialog, currentActiveElement)) {
      this.lastFocus = currentActiveElement;
      this.dialog.focus();
    }
  };

  _proto.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  _proto.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        show = _this$props4.show,
        container = _this$props4.container,
        children = _this$props4.children,
        renderDialog = _this$props4.renderDialog,
        _this$props4$role = _this$props4.role,
        role = _this$props4$role === void 0 ? 'dialog' : _this$props4$role,
        Transition = _this$props4.transition,
        backdrop = _this$props4.backdrop,
        className = _this$props4.className,
        style = _this$props4.style,
        onExit = _this$props4.onExit,
        onExiting = _this$props4.onExiting,
        onEnter = _this$props4.onEnter,
        onEntering = _this$props4.onEntering,
        onEntered = _this$props4.onEntered,
        props = _objectWithoutPropertiesLoose(_this$props4, ["show", "container", "children", "renderDialog", "role", "transition", "backdrop", "className", "style", "onExit", "onExiting", "onEnter", "onEntering", "onEntered"]);

    if (!(show || Transition && !this.state.exited)) {
      return null;
    }

    var dialogProps = _extends({
      role: role,
      ref: this.setDialogRef,
      // apparently only works on the dialog role element
      'aria-modal': role === 'dialog' ? true : undefined
    }, omitProps(props, Modal.propTypes), {
      style: style,
      className: className,
      tabIndex: '-1'
    });

    var dialog = renderDialog ? renderDialog(dialogProps) : _react.default.createElement("div", dialogProps, _react.default.cloneElement(children, {
      role: 'document'
    }));

    if (Transition) {
      dialog = _react.default.createElement(Transition, {
        appear: true,
        unmountOnExit: true,
        in: show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: this.handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
      }, dialog);
    }

    return _react.default.createElement(_Portal.default, {
      container: container,
      onRendered: this.onPortalRendered
    }, _react.default.createElement(_react.default.Fragment, null, backdrop && this.renderBackdrop(), dialog));
  };

  return Modal;
}(_react.default.Component);

Modal.propTypes = {
  /**
   * Set the visibility of the Modal
   */
  show: _propTypes.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes.default.oneOfType([_componentOrElement.default, _propTypes.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['static'])]),

  /**
   * A function that returns the dialog component. Useful for custom
   * rendering. **Note:** the component should make sure to apply the provided ref.
   *
   * ```js
   *  renderDialog={props => <MyDialog {...props} />}
   * ```
   */
  renderDialog: _propTypes.default.func,

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes.default.object.isRequired
};
Modal.defaultProps = {
  show: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react.default.createElement("div", props);
  }
};
Modal.Manager = _ModalManager.default;
var _default = Modal;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(143));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(1233));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(1234));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(584));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(584));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(1236));

var _ownerDocument = _interopRequireDefault(__webpack_require__(143));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument.default)(node);
  var win = (0, _isWindow.default)(doc);
  return doc.body.clientWidth < win.innerWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow.default)(container);
  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}

module.exports = exports.default;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, exclude, cb) {
  exclude = [].concat(exclude);
  [].forEach.call(container.children, function (node) {
    if (exclude.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) return;

  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, _ref2) {
  var root = _ref2.root,
      backdrop = _ref2.backdrop;
  siblings(container, [root, backdrop], function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, _ref3) {
  var root = _ref3.root,
      backdrop = _ref3.backdrop;
  siblings(container, [root, backdrop], function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CloseButton__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalContext__ = __webpack_require__(591);








var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var ModalHeader = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      closeLabel = _ref.closeLabel,
      closeButton = _ref.closeButton,
      onHide = _ref.onHide,
      className = _ref.className,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "closeLabel", "closeButton", "onHide", "className", "children"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'modal-header');
  var context = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__ModalContext__["a" /* default */]);
  var handleClick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["default"])(function () {
    if (context) context.onHide();
    if (onHide) onHide();
  });
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }), children, closeButton && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CloseButton__["a" /* default */], {
    label: closeLabel,
    onClick: handleClick
  }));
});
ModalHeader.displayName = 'ModalHeader';
ModalHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BootstrapModalManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dom_helpers_style__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_helpers_util_scrollbarSize__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_overlays_ModalManager__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_overlays_ModalManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_overlays_ModalManager__);





var Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'
};

var BootstrapModalManager =
/*#__PURE__*/
function (_ModalManager) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BootstrapModalManager, _ModalManager);

  function BootstrapModalManager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ModalManager.call.apply(_ModalManager, [this].concat(args)) || this;

    _this.adjustAndStore = function (prop, element, adjust) {
      var actual = element.style[prop];
      element.dataset[prop] = actual;
      __WEBPACK_IMPORTED_MODULE_2_dom_helpers_style___default()(element, prop, parseFloat(__WEBPACK_IMPORTED_MODULE_2_dom_helpers_style___default()(element, prop)) + adjust + "px");
    };

    _this.restore = function (prop, element) {
      var value = element.dataset[prop];

      if (value !== undefined) {
        delete element.dataset[prop];
        __WEBPACK_IMPORTED_MODULE_2_dom_helpers_style___default()(element, prop, value);
      }
    };

    return _this;
  }

  var _proto = BootstrapModalManager.prototype;

  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
    var _this2 = this;

    _ModalManager.prototype.setContainerStyle.call(this, containerState, container);

    if (!containerState.overflowing) return;
    var size = __WEBPACK_IMPORTED_MODULE_3_dom_helpers_util_scrollbarSize___default()();
    __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default()(container, Selector.FIXED_CONTENT).forEach(function (el) {
      return _this2.adjustAndStore('paddingRight', el, size);
    });
    __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default()(container, Selector.STICKY_CONTENT).forEach(function (el) {
      return _this2.adjustAndStore('margingRight', el, -size);
    });
    __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default()(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
      return _this2.adjustAndStore('margingRight', el, size);
    });
  };

  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
    var _this3 = this;

    _ModalManager.prototype.removeContainerStyle.call(this, containerState, container);

    __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default()(container, Selector.FIXED_CONTENT).forEach(function (el) {
      return _this3.restore('paddingRight', el);
    });
    __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default()(container, Selector.STICKY_CONTENT).forEach(function (el) {
      return _this3.restore('margingRight', el);
    });
    __WEBPACK_IMPORTED_MODULE_1_dom_helpers_query_querySelectorAll___default()(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
      return _this3.restore('margingRight', el);
    });
  };

  return BootstrapModalManager;
}(__WEBPACK_IMPORTED_MODULE_4_react_overlays_ModalManager___default.a);



/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_createWithBsPrefix__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavbarBrand__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavbarCollapse__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavbarToggle__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarContext__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectableContext__ = __webpack_require__(67);













var defaultProps = {
  expand: true,
  variant: 'light',
  collapseOnSelect: false
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Navbar, _React$Component);

  function Navbar() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleCollapse = function () {
      var _this$props = _this.props,
          onToggle = _this$props.onToggle,
          expanded = _this$props.expanded,
          collapseOnSelect = _this$props.collapseOnSelect,
          onSelect = _this$props.onSelect;
      if (onSelect) onSelect.apply(void 0, arguments);

      if (collapseOnSelect && expanded) {
        onToggle(false);
      }
    };

    _this.handleToggle = function () {
      var _this$props2 = _this.props,
          onToggle = _this$props2.onToggle,
          expanded = _this$props2.expanded;
      onToggle(!expanded);
    };

    _this.state = {
      navbarContext: {
        onToggle: _this.handleToggle
      }
    };
    return _this;
  }

  Navbar.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var bsPrefix = _ref.bsPrefix,
        expanded = _ref.expanded;
    return {
      navbarContext: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevState.navbarContext, {
        bsPrefix: bsPrefix,
        expanded: expanded
      })
    };
  };

  var _proto = Navbar.prototype;

  _proto.render = function render() {
    var _this$props3 = this.props,
        bsPrefix = _this$props3.bsPrefix,
        expand = _this$props3.expand,
        variant = _this$props3.variant,
        bg = _this$props3.bg,
        fixed = _this$props3.fixed,
        sticky = _this$props3.sticky,
        className = _this$props3.className,
        children = _this$props3.children,
        _this$props3$as = _this$props3.as,
        Component = _this$props3$as === void 0 ? 'nav' : _this$props3$as,
        _1 = _this$props3.expanded,
        _2 = _this$props3.onToggle,
        _3 = _this$props3.onSelect,
        _4 = _this$props3.collapseOnSelect,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props3, ["bsPrefix", "expand", "variant", "bg", "fixed", "sticky", "className", "children", "as", "expanded", "onToggle", "onSelect", "collapseOnSelect"]); // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (props.role === undefined && Component !== 'nav') {
      props.role = 'navigation';
    }

    var expandClass = bsPrefix + "-expand";
    if (typeof expand === 'string') expandClass = expandClass + "-" + expand;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NavbarContext__["a" /* default */].Provider, {
      value: this.state.navbarContext
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SelectableContext__["a" /* default */].Provider, {
      value: this.handleCollapse
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, expand && expandClass, variant && bsPrefix + "-" + variant, bg && "bg-" + bg, sticky && "sticky-" + sticky, fixed && "fixed-" + fixed)
    }), children)));
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Navbar.defaultProps = defaultProps;
var DecoratedNavbar = Object(__WEBPACK_IMPORTED_MODULE_10__ThemeProvider__["a" /* createBootstrapComponent */])(Object(__WEBPACK_IMPORTED_MODULE_5_uncontrollable__["default"])(Navbar, {
  expanded: 'onToggle'
}), 'navbar');
DecoratedNavbar.Brand = __WEBPACK_IMPORTED_MODULE_7__NavbarBrand__["a" /* default */];
DecoratedNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_9__NavbarToggle__["a" /* default */];
DecoratedNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_8__NavbarCollapse__["a" /* default */];
DecoratedNavbar.Text = Object(__WEBPACK_IMPORTED_MODULE_6__utils_createWithBsPrefix__["a" /* default */])('navbar-text', {
  Component: 'span'
});
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedNavbar);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collapse__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavbarContext__ = __webpack_require__(144);






var NavbarCollapse = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["children", "bsPrefix"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'navbar-collapse');
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NavbarContext__["a" /* default */].Consumer, null, function (context) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      in: !!(context && context.expanded)
    }, props), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      ref: ref,
      className: bsPrefix
    }, children));
  });
});
NavbarCollapse.displayName = 'NavbarCollapse';
/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavbarContext__ = __webpack_require__(144);







var defaultProps = {
  label: 'Toggle navigation'
};
var NavbarToggle = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      onClick = _ref.onClick,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "label", "as", "onClick"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["b" /* useBootstrapPrefix */])(bsPrefix, 'navbar-toggler');

  var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__NavbarContext__["a" /* default */]) || {},
      onToggle = _ref2.onToggle,
      expanded = _ref2.expanded;

  var handleClick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["default"])(function (e) {
    if (onClick) onClick(e);
    if (onToggle) onToggle();
  });

  if (Component === 'button') {
    props.type = 'button';
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    onClick: handleClick,
    "aria-label": label,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, !!expanded && 'collapsed')
  }), children || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: bsPrefix + "-icon"
  }));
});
NavbarToggle.displayName = 'NavbarToggle';
NavbarToggle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropdown__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavItem__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavLink__ = __webpack_require__(317);








var NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        title = _this$props.title,
        children = _this$props.children,
        bsPrefix = _this$props.bsPrefix,
        rootCloseEvent = _this$props.rootCloseEvent,
        menuRole = _this$props.menuRole,
        disabled = _this$props.disabled,
        active = _this$props.active,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["id", "title", "children", "bsPrefix", "rootCloseEvent", "menuRole", "disabled", "active"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      as: __WEBPACK_IMPORTED_MODULE_5__NavItem__["a" /* default */]
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Toggle, {
      id: id,
      eventKey: null,
      active: active,
      disabled: disabled,
      childBsPrefix: bsPrefix,
      as: __WEBPACK_IMPORTED_MODULE_6__NavLink__["a" /* default */]
    }, title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Menu, {
      role: menuRole,
      rootCloseEvent: rootCloseEvent
    }, children));
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NavDropdown.Item = __WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Item;
NavDropdown.Divider = __WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Divider;
NavDropdown.Header = __WEBPACK_IMPORTED_MODULE_4__Dropdown__["a" /* default */].Header;
/* unused harmony default export */ var _unused_webpack_default_export = (NavDropdown);

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _elementType = _interopRequireDefault(__webpack_require__(582));

var _componentOrElement = _interopRequireDefault(__webpack_require__(207));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(23));

var _Portal = _interopRequireDefault(__webpack_require__(585));

var _RootCloseWrapper = _interopRequireDefault(__webpack_require__(565));

var _reactPopper = __webpack_require__(310);

var _forwardRef = _interopRequireDefault(__webpack_require__(569));

var _WaitForContainer = _interopRequireDefault(__webpack_require__(586));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is
 * great for custom tooltip overlays.
 */
var Overlay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Overlay, _React$Component);

  function Overlay(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    _this.handleHidden = function () {
      _this.setState({
        exited: true
      });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = {
      exited: !props.show
    };
    _this.onHiddenListener = _this.handleHidden.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._lastTarget = null;
    return _this;
  }

  Overlay.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
    if (nextProps.show) {
      return {
        exited: false
      };
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      return {
        exited: true
      };
    }

    return null;
  };

  var _proto = Overlay.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      target: this.getTarget()
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props === prevProps) return;
    var target = this.getTarget();

    if (target !== this.state.target) {
      this.setState({
        target: target
      });
    }
  };

  _proto.getTarget = function getTarget() {
    var target = this.props.target;
    target = typeof target === 'function' ? target() : target;
    return target && _reactDom.default.findDOMNode(target) || null;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        _0 = _this$props2.target,
        container = _this$props2.container,
        containerPadding = _this$props2.containerPadding,
        placement = _this$props2.placement,
        rootClose = _this$props2.rootClose,
        children = _this$props2.children,
        flip = _this$props2.flip,
        _this$props2$popperCo = _this$props2.popperConfig,
        popperConfig = _this$props2$popperCo === void 0 ? {} : _this$props2$popperCo,
        Transition = _this$props2.transition,
        props = _objectWithoutPropertiesLoose(_this$props2, ["target", "container", "containerPadding", "placement", "rootClose", "children", "flip", "popperConfig", "transition"]);

    var target = this.state.target; // Don't un-render the overlay while it's transitioning out.

    var mountOverlay = props.show || Transition && !this.state.exited;

    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;
    var _popperConfig$modifie = popperConfig.modifiers,
        modifiers = _popperConfig$modifie === void 0 ? {} : _popperConfig$modifie;

    var popperProps = _extends({}, popperConfig, {
      placement: placement,
      referenceElement: target,
      enableEvents: props.show,
      modifiers: _extends({}, modifiers, {
        preventOverflow: _extends({
          padding: containerPadding || 5
        }, modifiers.preventOverflow),
        flip: _extends({
          enabled: !!flip
        }, modifiers.preventOverflow)
      })
    });

    child = _react.default.createElement(_reactPopper.Popper, popperProps, function (_ref) {
      var arrowProps = _ref.arrowProps,
          style = _ref.style,
          ref = _ref.ref,
          popper = _objectWithoutPropertiesLoose(_ref, ["arrowProps", "style", "ref"]);

      _this2.popper = popper;

      var innerChild = _this2.props.children(_extends({}, popper, {
        // popper doesn't set the initial placement
        placement: popper.placement || placement,
        show: props.show,
        arrowProps: arrowProps,
        props: {
          ref: ref,
          style: style
        }
      }));

      if (Transition) {
        var onExit = props.onExit,
            onExiting = props.onExiting,
            onEnter = props.onEnter,
            onEntering = props.onEntering,
            onEntered = props.onEntered;
        innerChild = _react.default.createElement(Transition, {
          in: props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: _this2.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        }, innerChild);
      }

      return innerChild;
    });

    if (rootClose) {
      child = _react.default.createElement(_RootCloseWrapper.default, {
        onRootClose: props.onHide,
        event: props.rootCloseEvent,
        disabled: props.rootCloseDisabled
      }, child);
    }

    return _react.default.createElement(_Portal.default, {
      container: container
    }, child);
  };

  return Overlay;
}(_react.default.Component);

Overlay.propTypes = _extends({}, _Portal.default.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes.default.bool,

  /** Specify where the overlay element is positioned in relation to the target element */
  placement: _propTypes.default.oneOf(_reactPopper.placements),

  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes.default.oneOfType([_componentOrElement.default, _propTypes.default.func]),

  /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */
  flip: _propTypes.default.bool,

  /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   outOfBoundaries: ?boolean,
   *   scheduleUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */
  children: _propTypes.default.func.isRequired,

  /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */
  popperConfig: _propTypes.default.object,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes.default.bool,

  /**
   * Specify event for toggling overlay
   */
  rootCloseEvent: _RootCloseWrapper.default.propTypes.event,

  /**
   * Specify disabled for disable RootCloseWrapper
   */
  rootCloseDisabled: _RootCloseWrapper.default.propTypes.disabled,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes.default.func;

    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(void 0, [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes.default.func
});

var _default = (0, _forwardRef.default)(function (props, ref) {
  return (// eslint-disable-next-line react/prop-types
    _react.default.createElement(_WaitForContainer.default, {
      container: props.container
    }, function (container) {
      return _react.default.createElement(Overlay, _extends({}, props, {
        ref: ref,
        container: container
      }));
    })
  );
}, {
  displayName: 'withContainer(Overlay)'
});

exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_helpers_query_contains__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Overlay__ = __webpack_require__(595);









var RefHolder =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(RefHolder, _React$Component);

  function RefHolder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RefHolder.prototype;

  _proto.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

var normalizeDelay = function normalizeDelay(delay) {
  return delay && typeof delay === 'object' ? delay : {
    show: delay,
    hide: delay
  };
};

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
}; // eslint-disable-next-line react/no-multi-comp

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(OverlayTrigger, _React$Component2);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component2.call(this, props, context) || this;

    _this.getTarget = function () {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this.trigger.current);
    };

    _this.handleShow = function () {
      clearTimeout(_this._timeout);
      _this._hoverState = 'show';
      var delay = normalizeDelay(_this.props.delay);

      if (!delay.show) {
        _this.show();

        return;
      }

      _this._timeout = setTimeout(function () {
        if (_this._hoverState === 'show') _this.show();
      }, delay.show);
    };

    _this.handleHide = function () {
      clearTimeout(_this._timeout);
      _this._hoverState = 'hide';
      var delay = normalizeDelay(_this.props.delay);

      if (!delay.hide) {
        _this.hide();

        return;
      }

      _this._timeout = setTimeout(function () {
        if (_this._hoverState === 'hide') _this.hide();
      }, delay.hide);
    };

    _this.handleFocus = function (e) {
      var _this$getChildProps = _this.getChildProps(),
          onFocus = _this$getChildProps.onFocus;

      _this.handleShow(e);

      if (onFocus) onFocus(e);
    };

    _this.handleBlur = function (e) {
      var _this$getChildProps2 = _this.getChildProps(),
          onBlur = _this$getChildProps2.onBlur;

      _this.handleHide(e);

      if (onBlur) onBlur(e);
    };

    _this.handleClick = function (e) {
      var _this$getChildProps3 = _this.getChildProps(),
          onClick = _this$getChildProps3.onClick;

      if (_this.state.show) _this.hide();else _this.show();
      if (onClick) onClick(e);
    };

    _this.handleMouseOver = function (e) {
      _this.handleMouseOverOut(_this.handleShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleHide, e, 'toElement');
    };

    _this.trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createRef();
    _this.state = {
      show: !!props.defaultShow
    }; // We add aria-describedby in the case where the overlay is a role="tooltip"
    // for other cases describedby isn't appropriate (e.g. a popover with inputs) so we don't add it.

    _this.ariaModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var popper = data.instance.popper;

        var target = _this.getTarget();

        if (!_this.state.show || !target) return data;
        var role = popper.getAttribute('role') || '';

        if (popper.id && role.toLowerCase() === 'tooltip') {
          target.setAttribute('aria-describedby', popper.id);
        }

        return data;
      }
    };
    return _this;
  }

  var _proto2 = OverlayTrigger.prototype;

  _proto2.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this._timeout);
  };

  _proto2.getChildProps = function getChildProps() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(this.props.children).props;
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.
  _proto2.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_3_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  _proto2.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto2.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto2.render = function render() {
    var _this$props = this.props,
        trigger = _this$props.trigger,
        overlay = _this$props.overlay,
        children = _this$props.children,
        _this$props$popperCon = _this$props.popperConfig,
        popperConfig = _this$props$popperCon === void 0 ? {} : _this$props$popperCon,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["trigger", "overlay", "children", "popperConfig"]);

    delete props.delay;
    delete props.defaultShow;
    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var triggerProps = {};
    var triggers = trigger == null ? [] : [].concat(trigger);

    if (triggers.indexOf('click') !== -1) {
      triggerProps.onClick = this.handleClick;
    }

    if (triggers.indexOf('focus') !== -1) {
      triggerProps.onFocus = this.handleShow;
      triggerProps.onBlur = this.handleHide;
    }

    if (triggers.indexOf('hover') !== -1) {
       false ? warning(triggers.length >= 1, '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = this.handleMouseOver;
      triggerProps.onMouseOut = this.handleMouseOut;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(RefHolder, {
      ref: this.trigger
    }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, triggerProps)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Overlay__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      popperConfig: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, popperConfig, {
        modifiers: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, popperConfig.modifiers, {
          ariaModifier: this.ariaModifier
        })
      }),
      show: this.state.show,
      onHide: this.handleHide,
      target: this.getTarget
    }), overlay));
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

OverlayTrigger.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (OverlayTrigger);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PageItem__ = __webpack_require__(596);







/**
 * @property {PageItem} Item
 * @property {PageItem} First
 * @property {PageItem} Prev
 * @property {PageItem} Ellipsis
 * @property {PageItem} Next
 * @property {PageItem} Last
 */

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        className = _this$props.className,
        children = _this$props.children,
        size = _this$props.size,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "className", "children", "size"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, size && bsPrefix + "-" + size)
    }), children);
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

var DecoratedPagination = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Pagination, 'pagination');
DecoratedPagination.First = __WEBPACK_IMPORTED_MODULE_6__PageItem__["b" /* First */];
DecoratedPagination.Prev = __WEBPACK_IMPORTED_MODULE_6__PageItem__["e" /* Prev */];
DecoratedPagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_6__PageItem__["a" /* Ellipsis */];
DecoratedPagination.Item = __WEBPACK_IMPORTED_MODULE_6__PageItem__["f" /* default */];
DecoratedPagination.Next = __WEBPACK_IMPORTED_MODULE_6__PageItem__["d" /* Next */];
DecoratedPagination.Last = __WEBPACK_IMPORTED_MODULE_6__PageItem__["c" /* Last */];
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedPagination);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var defaultProps = {
  placement: 'right'
};

function Popover(_ref) {
  var bsPrefix = _ref.bsPrefix,
      innerRef = _ref.innerRef,
      placement = _ref.placement,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title,
      children = _ref.children,
      arrowProps = _ref.arrowProps,
      _ = _ref.scheduleUpdate,
      _1 = _ref.outOfBoundaries,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "innerRef", "placement", "className", "style", "title", "children", "arrowProps", "scheduleUpdate", "outOfBoundaries"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "tooltip",
    ref: innerRef,
    style: style,
    "x-placement": placement,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, "bs-popover-" + placement)
  }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: "arrow"
  }, arrowProps)), title && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: bsPrefix + "-header h3"
  }, title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: bsPrefix + "-body"
  }, children));
}

Popover.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Popover, 'popover'));

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ElementChildren__ = __webpack_require__(203);







var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(DecoratedProgressBar, null);
    if (child.type === element.type) return;
    var childIdentifier = __WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var defaultProps = {
  min: 0,
  max: 100,
  animated: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _classNames;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        animated = _ref.animated,
        className = _ref.className,
        style = _ref.style,
        variant = _ref.variant,
        bsPrefix = _ref.bsPrefix,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["min", "now", "max", "label", "srOnly", "striped", "animated", "className", "style", "variant", "bsPrefix"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "progressbar",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix + "-bar", (_classNames = {}, _classNames["bg-" + variant] = variant, _classNames[bsPrefix + "-bar-animated"] = animated, _classNames[bsPrefix + "-bar-striped"] = animated || striped, _classNames)),
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isChild = _this$props.isChild,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        animated = props.animated,
        bsPrefix = props.bsPrefix,
        variant = props.variant,
        className = props.className,
        children = props.children,
        wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["min", "now", "max", "label", "srOnly", "striped", "animated", "bsPrefix", "variant", "className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, wrapperProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix)
    }), children ? Object(__WEBPACK_IMPORTED_MODULE_6__utils_ElementChildren__["b" /* map */])(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      animated: animated,
      bsPrefix: bsPrefix,
      variant: variant
    }));
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ProgressBar.defaultProps = defaultProps;
var DecoratedProgressBar = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(ProgressBar, 'progress');
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedProgressBar);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var defaultProps = {
  aspectRatio: '1by1'
};

var ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        className = _this$props.className,
        children = _this$props.children,
        aspectRatio = _this$props.aspectRatio,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "className", "children", "aspectRatio"]);

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(bsPrefix, className, aspectRatio && bsPrefix + "-" + aspectRatio)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(child.props.className, bsPrefix + "-item")
    }));
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ResponsiveEmbed.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(ResponsiveEmbed, 'embed-responsive'));

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);







var Row =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        noGutters = _this$props.noGutters,
        _this$props$as = _this$props.as,
        Component = _this$props$as === void 0 ? 'div' : _this$props$as,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "noGutters", "as", "className"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsPrefix, noGutters && 'no-gutters')
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Row.defaultProps = {
  noGutters: false
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Row, 'row'));

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);







var Spinner =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Spinner, _React$Component);

  function Spinner() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Spinner.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        variant = _this$props.variant,
        animation = _this$props.animation,
        size = _this$props.size,
        children = _this$props.children,
        _this$props$as = _this$props.as,
        Component = _this$props$as === void 0 ? 'div' : _this$props$as,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "variant", "animation", "size", "children", "as", "className"]);

    var bsSpinnerPrefix = bsPrefix + "-" + animation;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
    }), children);
  };

  return Spinner;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Spinner, 'spinner'));

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonGroup__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(204);







/**
 * @inherits Button, Dropdown
 */

var SplitButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        bsPrefix = _this$props.bsPrefix,
        size = _this$props.size,
        variant = _this$props.variant,
        title = _this$props.title,
        toggleLabel = _this$props.toggleLabel,
        children = _this$props.children,
        onClick = _this$props.onClick,
        href = _this$props.href,
        target = _this$props.target,
        menuRole = _this$props.menuRole,
        rootCloseEvent = _this$props.rootCloseEvent,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["id", "bsPrefix", "size", "variant", "title", "toggleLabel", "children", "onClick", "href", "target", "menuRole", "rootCloseEvent"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      as: __WEBPACK_IMPORTED_MODULE_5__ButtonGroup__["a" /* default */]
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */], {
      size: size,
      variant: variant,
      disabled: props.disabled,
      bsPrefix: bsPrefix,
      href: href,
      target: target,
      onClick: onClick
    }, title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Toggle, {
      split: true,
      id: id,
      size: size,
      variant: variant,
      disabled: props.disabled,
      childBsPrefix: bsPrefix
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "sr-only"
    }, toggleLabel)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, {
      role: menuRole,
      rootCloseEvent: rootCloseEvent
    }, children));
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SplitButton.defaultProps = {
  toggleLabel: 'Toggle dropdown'
};
/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContainer__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabContent__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabPane__ = __webpack_require__(320);





/* eslint-disable react/require-render-return, react/no-unused-prop-types */

var Tab =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    throw new Error('ReactBootstrap: The `Tab` component is not meant to be rendered! ' + "It's an abstract component that is only valid as a direct Child of the `Tabs` Component. " + 'For custom tabs components use TabPane and TabsContainer directly');
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Tab.Container = __WEBPACK_IMPORTED_MODULE_2__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_3__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_4__TabPane__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);







var Table =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsPrefix = _this$props.bsPrefix,
        className = _this$props.className,
        striped = _this$props.striped,
        bordered = _this$props.bordered,
        borderless = _this$props.borderless,
        hover = _this$props.hover,
        size = _this$props.size,
        variant = _this$props.variant,
        responsive = _this$props.responsive,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsPrefix", "className", "striped", "bordered", "borderless", "hover", "size", "variant", "responsive"]);

    var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(bsPrefix, className, variant && bsPrefix + "-" + variant, size && bsPrefix + "-" + size, striped && bsPrefix + "-striped", bordered && bsPrefix + "-bordered", borderless && bsPrefix + "-borderless", hover && bsPrefix + "-hover");
    var table = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("table", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      className: classes
    }));

    if (responsive) {
      var responsiveClass = bsPrefix + "-responsive";

      if (typeof responsive === 'string') {
        responsiveClass = responsiveClass + "-" + responsive;
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: responsiveClass
      }, table);
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Table, 'table'));

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavLink__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavItem__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TabContainer__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabContent__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabPane__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ElementChildren__ = __webpack_require__(203);













var TabContainer = __WEBPACK_IMPORTED_MODULE_9__TabContainer__["a" /* default */].ControlledComponent;
var defaultProps = {
  variant: 'tabs',
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  Object(__WEBPACK_IMPORTED_MODULE_12__utils_ElementChildren__["a" /* forEach */])(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NavItem__["a" /* default */], {
      as: __WEBPACK_IMPORTED_MODULE_7__NavLink__["a" /* default */],
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        onSelect = _this$props.onSelect,
        transition = _this$props.transition,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        children = _this$props.children,
        _this$props$activeKey = _this$props.activeKey,
        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["id", "onSelect", "transition", "mountOnEnter", "unmountOnExit", "children", "activeKey"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      transition: transition,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Nav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "tablist",
      as: "nav"
    }), Object(__WEBPACK_IMPORTED_MODULE_12__utils_ElementChildren__["b" /* map */])(children, this.renderTab)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TabContent__["a" /* default */], null, Object(__WEBPACK_IMPORTED_MODULE_12__utils_ElementChildren__["b" /* map */])(children, function (child) {
      var childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props);

      delete childProps.title;
      delete childProps.disabled;
      delete childProps.tabClassName;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TabPane__["a" /* default */], childProps);
    })));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Tabs.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5_uncontrollable__["default"])(Tabs, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_createChainedFunction__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ElementChildren__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonGroup__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ToggleButton__ = __webpack_require__(597);










var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value, event) {
    var _this$props = this.props,
        type = _this$props.type,
        onChange = _this$props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) onChange(value, event);
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }), event);
    } else {
      onChange([].concat(values, [value]), event);
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        name = _this$props2.name,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children", "type", "name"]);

    delete props.onChange;
    delete props.value;
    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_4_invariant___default()(false) : void 0;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ButtonGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      toggle: true
    }), Object(__WEBPACK_IMPORTED_MODULE_7__utils_ElementChildren__["b" /* map */])(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler(e) {
        return _this.handleToggle(value, e);
      };

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: Object(__WEBPACK_IMPORTED_MODULE_6__utils_createChainedFunction__["a" /* default */])(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ToggleButtonGroup.defaultProps = defaultProps;
var UncontrolledToggleButtonGroup = Object(__WEBPACK_IMPORTED_MODULE_5_uncontrollable__["default"])(ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_9__ToggleButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(13);






var defaultProps = {
  placement: 'right'
};

function Tooltip(_ref) {
  var bsPrefix = _ref.bsPrefix,
      innerRef = _ref.innerRef,
      placement = _ref.placement,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      arrowProps = _ref.arrowProps,
      _ = _ref.scheduleUpdate,
      _1 = _ref.outOfBoundaries,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "innerRef", "placement", "className", "style", "children", "arrowProps", "scheduleUpdate", "outOfBoundaries"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef,
    style: style,
    role: "tooltip",
    "x-placement": placement,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, "bs-tooltip-" + placement)
  }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: "arrow"
  }, arrowProps)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: bsPrefix + "-inner"
  }, children));
}

Tooltip.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* createBootstrapComponent */])(Tooltip, 'tooltip'));

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Fade__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToastHeader__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ToastBody__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ToastContext__ = __webpack_require__(599);









var defaultProps = {
  animation: true,
  autohide: false,
  delay: 3000,
  show: true,
  transition: __WEBPACK_IMPORTED_MODULE_4__Fade__["a" /* default */]
};

var Toast = function Toast(_ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      Transition = _ref.transition,
      show = _ref.show,
      animation = _ref.animation,
      delay = _ref.delay,
      autohide = _ref.autohide,
      onClose = _ref.onClose,
      innerRef = _ref.innerRef,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "transition", "show", "animation", "delay", "autohide", "onClose", "innerRef"]);

  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    if (autohide && show) {
      var timer = setTimeout(function () {
        onClose();
      }, delay);
      return function () {
        clearTimeout(timer);
      };
    }

    return function () {
      return null;
    };
  }, [autohide, show]);
  var useAnimation = Transition && animation;
  var toast = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: innerRef,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(bsPrefix, className, !useAnimation && show && 'show'),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }), children);
  var toastContext = {
    onClose: onClose
  };
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ToastContext__["a" /* default */].Provider, {
    value: toastContext
  }, useAnimation ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Transition, {
    in: show
  }, toast) : toast);
};

Toast.defaultProps = defaultProps;
var DecoratedToast = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["a" /* createBootstrapComponent */])(Toast, 'toast');
DecoratedToast.Body = __WEBPACK_IMPORTED_MODULE_6__ToastBody__["a" /* default */];
DecoratedToast.Header = __WEBPACK_IMPORTED_MODULE_5__ToastHeader__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (DecoratedToast);

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BG_Mythic.8e8238bc.png";

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GrnRareLtnt_jpeg__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GrnRareLtnt_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GrnRareLtnt_jpeg__);
var DevPage=function DevPage(){return(// Here, should be:
// - CardDisplay container, containing:
//  - CardImageDisplay
//  - CardStatsDisplay, containing:
//   - CardStat containers
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Jumbotron */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["c" /* Container */],{fluid:true,className:'cardDisplay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__GrnRareLtnt_jpeg___default.a,width:'360px',height:'504px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__["a" /* default */],{bodyText:'Destroyed 23 times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__["a" /* default */],{bodyText:'Destroyed 19 permanents'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__["a" /* default */],{bodyText:'Exiled 34 times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__["a" /* default */],{bodyText:'Exiled 0 permanents'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__["a" /* default */],{bodyText:'Drawn 14 times'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Shared_CardStat_CardStat__["a" /* default */],{bodyText:'Discarded 3 times'})))))));};// }
/* harmony default export */ __webpack_exports__["a"] = (DevPage);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(303);
var CardStat=function CardStat(_ref){var bodyText=_ref.bodyText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Card */].Body,null,bodyText));};/* harmony default export */ __webpack_exports__["a"] = (CardStat);

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GrnRareLtnt.2b33b076.jpeg";

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Games=function Games(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This is the games page.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'It is currently under construction, but when signed in, will display games a user has played in, as well as in-depth stats about those games when navigating to a specific one.'));};/* harmony default export */ __webpack_exports__["a"] = (Games);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Players=function Players(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This is the players page.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'It is currently under construction, but when signed in, will display players a user has played games with, as well as in-depth stats about those players when navigating to a specific one.'));};/* harmony default export */ __webpack_exports__["a"] = (Players);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mtgApiConfig__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardSlider_CardSlider__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LTNTLoading_gif__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LTNTLoading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LTNTLoading_gif__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// import CardRadio from './CardRadio/CardRadio'
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.withCredentials=false;var Card=function Card(_ref){var id=_ref.id;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),loaded=_useState2[0],setLoaded=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState4=_slicedToArray(_useState3,2),cardData=_useState4[0],setCardData=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__mtgApiConfig__["a" /* default */]+id,{headers:{}}).then(function(res){return setCardData(res.data);}).then(function(){return setLoaded(true);}).catch(function(err){return console.log(err);});},[]);// Use pagination from https://material-ui.com/components/pagination/
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Button */],{as:__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],to:'/'},'Back to card search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),loaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CardSlider_CardSlider__["a" /* default */],{cardData:cardData,printsSearchUri:cardData.prints_search_uri})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__LTNTLoading_gif___default.a}));};/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('https://api.scryfall.com/cards/');

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardImage_CardImage__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LTNTLoading_gif__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LTNTLoading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LTNTLoading_gif__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var useStyles=Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["a" /* makeStyles */])({root:{width:250},input:{width:42},container:{maxWidth:'360px',alignItems:'left',marginLeft:0}});var CardSlider=function CardSlider(_ref){var printsSearchUri=_ref.printsSearchUri,cardData=_ref.cardData;var classes=useStyles();var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),loaded=_useState2[0],setLoaded=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState4=_slicedToArray(_useState3,2),printUris=_useState4[0],setPrintUris=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),secondPrintUris=_useState6[0],setSecondPrintUris=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState8=_slicedToArray(_useState7,2),printSets=_useState8[0],setPrintSets=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),printSetNames=_useState10[0],setPrintSetNames=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState12=_slicedToArray(_useState11,2),selectedValue=_useState12[0],setSelectedValue=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),isDouble=_useState14[0],setIsDouble=_useState14[1];__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials=false;var handleSliderChange=function handleSliderChange(event,newValue){setSelectedValue(newValue);};var handleInputChange=function handleInputChange(event){setSelectedValue(event.target.value>printUris.length?printUris.length-1:event.target.value<1?1:Number(event.target.value));};var handleBlur=function handleBlur(){if(selectedValue<1){setSelectedValue(0);}else if(selectedValue>printUris.length){setSelectedValue(printUris.length-1);}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(printsSearchUri).then(function(res){var layoutType=res.data.data[0].layout;var cardData=res.data.data;if(layoutType==='transform'||layoutType==='modal_dfc'||layoutType==='art_series'){setIsDouble(true);setPrintUris(cardData.map(function(item){return item.card_faces[0].image_uris.normal;}));setSecondPrintUris(cardData.map(function(item){return item.card_faces[1].image_uris.normal;}));}else{setPrintUris(cardData.map(function(item){return item.image_uris.normal;}));}setPrintSets(cardData.map(function(item){return item.set;}));setPrintSetNames(cardData.map(function(item){return item.set_name;}));}).then(function(){return setLoaded(true);}).catch(function(err){return console.log(err);});},[]);// Use MaterialUI Slider
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,loaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,isDouble?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CardImage_CardImage__["a" /* default */],{cardUri:printUris[selectedValue-1]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CardImage_CardImage__["a" /* default */],{cardUri:secondPrintUris[selectedValue-1]})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CardImage_CardImage__["a" /* default */],{cardUri:printUris[selectedValue-1]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["a" /* Container */],{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["e" /* Typography */],{id:'input-slider',gutterBottom:true},'Set: ',printSetNames[selectedValue-1],' (',printSets[selectedValue-1].toUpperCase(),')'),printUris.length!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["b" /* Grid */],{container:true,spacing:2,alignItems:'stretch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["b" /* Grid */],{item:true,xs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["d" /* Slider */],{defaultValue:1,min:1,max:printUris.length,value:selectedValue,onChange:handleSliderChange,'aria-labelledby':'input-slider',step:1,marks:printUris.length<=15})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["b" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["c" /* Input */],{className:classes.input,value:selectedValue,margin:'dense',onChange:handleInputChange,onBlur:handleBlur,inputProps:{min:1,max:printUris.length,type:'number','aria-labelledby':'input-slider'}}),'/ ',printUris.length)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__LTNTLoading_gif___default.a}));};/* harmony default export */ __webpack_exports__["a"] = (CardSlider);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPlainObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepmerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);


function isPlainObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(321);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
/* unused harmony default export */ var _unused_webpack_default_export = (elementAcceptingRef);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(321);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export specialProperty */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFunctionName */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case __WEBPACK_IMPORTED_MODULE_1_react_is__["Memo"]:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* unused harmony default export */ var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]);
/* unused harmony default export */ var _unused_webpack_default_export = (refType);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMixins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export light */
/* unused harmony export dark */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPalette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_common__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors_grey__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_indigo__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__colors_pink__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors_red__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colors_orange__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors_blue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors_green__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colorManipulator__ = __webpack_require__(37);













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    default: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][800],
    default: '#303030'
  },
  action: {
    active: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["e" /* lighten */])(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["a" /* darken */])(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A200,
    main: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A400,
    dark: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["d" /* getContrastRatio */])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // A collection of common colors.
    common: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */],
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTypography;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(10);




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ __webpack_exports__["a"] = (shadows);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shape = {
  borderRadius: 4
};
/* harmony default export */ __webpack_exports__["a"] = (shape);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(611);

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["c" /* createUnarySpacing */])({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(209);





function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.css)))), omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends(_extends({}, styleFunction.propTypes), {}, {
    css: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* harmony default export */ __webpack_exports__["a"] = (css);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export displayPrint */
/* unused harmony export displayRaw */
/* unused harmony export overflow */
/* unused harmony export textOverflow */
/* unused harmony export visibility */
/* unused harmony export whiteSpace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(74);


var displayPrint = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'display'
});
var overflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'overflow'
});
var textOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textOverflow'
});
var visibility = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'visibility'
});
var whiteSpace = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'whiteSpace'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(68);

var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* harmony default export */ __webpack_exports__["a"] = (boxShadow);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__ = __webpack_require__(322);


function createMuiStrictModeTheme(options) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__["a" /* default */].apply(void 0, [Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])({
    unstable_strictMode: true
  }, options)].concat(args));
}

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(50);
 // let warnOnce = false;
// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["a" /* createStyles */])(styles);
}

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGenerateClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__ = __webpack_require__(625);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[__WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__["a" /* default */]] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStyles;
function createStyles(styles) {
  return styles;
}

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThemeProps;
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jssPreset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__ = __webpack_require__(1309);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__["a" /* default */])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__["a" /* default */])()]
  };
}

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(94);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["d" /* createRule */])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (functionPlugin);


/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(94);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["a" /* RuleList */](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    options.sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;
    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssGlobal);


/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(155);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssNested);


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(1300);


/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["a"] = (hyphenateStyleName);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(94);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (!value) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === 'number') {
    var unit = options[prop] || units[prop];

    if (unit) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (defaultUnit);


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(94);



/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" /* supportedKeyframes */])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" /* supportedProperty */])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssVendorPrefixer);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1304);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread__ = __webpack_require__(1308);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__ = __webpack_require__(628);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(arr);
}

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__ = __webpack_require__(628);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPropsSort);


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeClasses__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StylesProvider__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indexCounter__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getStylesCreator__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__ = __webpack_require__(631);












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, stylesCreator.options), stylesOptions), {}, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_3_jss__["e" /* getDynamicStyles */])(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__["a" /* default */] : _options$defaultTheme,
      stylesOptions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = Object(__WEBPACK_IMPORTED_MODULE_9__getStylesCreator__["a" /* default */])(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: Object(__WEBPACK_IMPORTED_MODULE_8__indexCounter__["a" /* increment */])(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;

    var stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__StylesProvider__["a" /* StylesContext */])), stylesOptions2);

    var instance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    var shouldUpdate = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(10);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (multiKeyStore);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeContext__ = __webpack_require__(629);


function useTheme() {
  var theme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__ThemeContext__["a" /* default */]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = increment;
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__ = __webpack_require__(1316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__["a"]; });


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStylesCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noopTheme__ = __webpack_require__(631);




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StylesProvider__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__ = __webpack_require__(210);








var ServerStyleSheets = /*#__PURE__*/function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new __WEBPACK_IMPORTED_MODULE_4_jss__["b" /* SheetsRegistry */](); // A new class name generator

      var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__["a" /* default */])();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StylesProvider__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();



/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = styled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__makeStyles__ = __webpack_require__(211);









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_7__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FinalComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: PropTypes.elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTheme__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nested__ = __webpack_require__(625);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme), localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = Object(__WEBPACK_IMPORTED_MODULE_5__useTheme__["a" /* default */])();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[__WEBPACK_IMPORTED_MODULE_6__nested__["a" /* default */]] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__["a" /* default */].Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (ThemeProvider);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__makeStyles__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getThemeProps__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(111);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_6__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Component.defaultProps), props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = Object(__WEBPACK_IMPORTED_MODULE_8__useTheme__["a" /* default */])() || defaultTheme;

        if (name) {
          more = Object(__WEBPACK_IMPORTED_MODULE_7__getThemeProps__["a" /* default */])({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(145);




function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["c" /* makeStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (makeStyles);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cssUtils__ = __webpack_require__(1323);



function responsiveFontSizes(themeInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$breakpoints = options.breakpoints,
      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
      _options$disableAlign = options.disableAlign,
      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
      _options$factor = options.factor,
      factor = _options$factor === void 0 ? 2 : _options$factor,
      _options$variants = options.variants,
      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;

  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, themeInput);

  theme.typography = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography);
  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).

  var convert = Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["b" /* convertLength */])(typography.htmlFontSize);
  var breakpointValues = breakpoints.map(function (x) {
    return theme.breakpoints.values[x];
  });
  variants.forEach(function (variant) {
    var style = typography[variant];
    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));

    if (remFontSize <= 1) {
      return;
    }

    var maxFontSize = remFontSize;
    var minFontSize = 1 + (maxFontSize - 1) / factor;
    var lineHeight = style.lineHeight;

    if (!Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["d" /* isUnitless */])(lineHeight) && !disableAlign) {
      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_utils__["b" /* formatMuiErrorMessage */])(6));
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["d" /* isUnitless */])(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }

    var transform = null;

    if (!disableAlign) {
      transform = function transform(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["a" /* alignProperty */])({
          size: value,
          grid: Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["c" /* fontGrid */])({
            pixels: 4,
            lineHeight: lineHeight,
            htmlFontSize: typography.htmlFontSize
          })
        });
      };
    }

    typography[variant] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["e" /* responsiveProperty */])({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform: transform
    }));
  });
  return theme;
}

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isUnitless;
/* unused harmony export getUnit */
/* unused harmony export toUnitless */
/* harmony export (immutable) */ __webpack_exports__["b"] = convertLength;
/* harmony export (immutable) */ __webpack_exports__["a"] = alignProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = fontGrid;
/* harmony export (immutable) */ __webpack_exports__["e"] = responsiveProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);

function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length

function convertLength(baseFontSize) {
  return function (length, toUnit) {
    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.

    if (fromUnit === toUnit) {
      return length;
    } // Convert input length to pixels.


    var pxLength = toUnitless(length);

    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
        return length;
      }
    } // Convert length in pixels to the output unit


    var outputLength = pxLength;

    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }

    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty(_ref) {
  var size = _ref.size,
      grid = _ref.grid;
  var sizeBelow = size - size % grid;
  var sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid(_ref2) {
  var lineHeight = _ref2.lineHeight,
      pixels = _ref2.pixels,
      htmlFontSize = _ref2.htmlFontSize;
  return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 *
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */

function responsiveProperty(_ref3) {
  var cssProperty = _ref3.cssProperty,
      min = _ref3.min,
      max = _ref3.max,
      _ref3$unit = _ref3.unit,
      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
      _ref3$breakpoints = _ref3.breakpoints,
      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
      _ref3$transform = _ref3.transform,
      transform = _ref3$transform === void 0 ? null : _ref3$transform;

  var output = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, "".concat(min).concat(unit));

  var factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(function (breakpoint) {
    var value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output["@media (min-width:".concat(breakpoint, "px)")] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
  });
  return output;
}

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultTheme__ = __webpack_require__(145);


var withTheme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["h" /* withThemeCreator */])({
  defaultTheme: __WEBPACK_IMPORTED_MODULE_1__defaultTheme__["a" /* default */]
});
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(1326);
/* unused harmony reexport colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(639);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Accordion__ = __webpack_require__(641);
/* unused harmony reexport Accordion */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionActions__ = __webpack_require__(648);
/* unused harmony reexport AccordionActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionDetails__ = __webpack_require__(649);
/* unused harmony reexport AccordionDetails */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionSummary__ = __webpack_require__(650);
/* unused harmony reexport AccordionSummary */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppBar__ = __webpack_require__(651);
/* unused harmony reexport AppBar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Avatar__ = __webpack_require__(652);
/* unused harmony reexport Avatar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Backdrop__ = __webpack_require__(218);
/* unused harmony reexport Backdrop */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Badge__ = __webpack_require__(653);
/* unused harmony reexport Badge */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BottomNavigation__ = __webpack_require__(654);
/* unused harmony reexport BottomNavigation */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BottomNavigationAction__ = __webpack_require__(655);
/* unused harmony reexport BottomNavigationAction */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Box__ = __webpack_require__(656);
/* unused harmony reexport Box */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Breadcrumbs__ = __webpack_require__(657);
/* unused harmony reexport Breadcrumbs */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Button__ = __webpack_require__(330);
/* unused harmony reexport Button */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonBase__ = __webpack_require__(43);
/* unused harmony reexport ButtonBase */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(658);
/* unused harmony reexport ButtonGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Card__ = __webpack_require__(659);
/* unused harmony reexport Card */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CardActionArea__ = __webpack_require__(660);
/* unused harmony reexport CardActionArea */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CardActions__ = __webpack_require__(661);
/* unused harmony reexport CardActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CardContent__ = __webpack_require__(662);
/* unused harmony reexport CardContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CardHeader__ = __webpack_require__(663);
/* unused harmony reexport CardHeader */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CardMedia__ = __webpack_require__(664);
/* unused harmony reexport CardMedia */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Checkbox__ = __webpack_require__(665);
/* unused harmony reexport Checkbox */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Chip__ = __webpack_require__(666);
/* unused harmony reexport Chip */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CircularProgress__ = __webpack_require__(667);
/* unused harmony reexport CircularProgress */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ClickAwayListener__ = __webpack_require__(332);
/* unused harmony reexport ClickAwayListener */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Collapse__ = __webpack_require__(148);
/* unused harmony reexport Collapse */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Container__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_29__Container__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CssBaseline__ = __webpack_require__(669);
/* unused harmony reexport CssBaseline */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Dialog__ = __webpack_require__(670);
/* unused harmony reexport Dialog */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__DialogActions__ = __webpack_require__(673);
/* unused harmony reexport DialogActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__DialogContent__ = __webpack_require__(674);
/* unused harmony reexport DialogContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__DialogContentText__ = __webpack_require__(675);
/* unused harmony reexport DialogContentText */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__DialogTitle__ = __webpack_require__(676);
/* unused harmony reexport DialogTitle */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Divider__ = __webpack_require__(677);
/* unused harmony reexport Divider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Drawer__ = __webpack_require__(678);
/* unused harmony reexport Drawer */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ExpansionPanel__ = __webpack_require__(679);
/* unused harmony reexport ExpansionPanel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ExpansionPanelActions__ = __webpack_require__(681);
/* unused harmony reexport ExpansionPanelActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ExpansionPanelDetails__ = __webpack_require__(682);
/* unused harmony reexport ExpansionPanelDetails */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ExpansionPanelSummary__ = __webpack_require__(683);
/* unused harmony reexport ExpansionPanelSummary */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Fab__ = __webpack_require__(684);
/* unused harmony reexport Fab */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Fade__ = __webpack_require__(219);
/* unused harmony reexport Fade */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__FilledInput__ = __webpack_require__(222);
/* unused harmony reexport FilledInput */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__FormControl__ = __webpack_require__(223);
/* unused harmony reexport FormControl */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__FormControlLabel__ = __webpack_require__(685);
/* unused harmony reexport FormControlLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__FormGroup__ = __webpack_require__(338);
/* unused harmony reexport FormGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__FormHelperText__ = __webpack_require__(339);
/* unused harmony reexport FormHelperText */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__FormLabel__ = __webpack_require__(340);
/* unused harmony reexport FormLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Grid__ = __webpack_require__(686);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_50__Grid__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__GridList__ = __webpack_require__(687);
/* unused harmony reexport GridList */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__GridListTile__ = __webpack_require__(688);
/* unused harmony reexport GridListTile */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__GridListTileBar__ = __webpack_require__(689);
/* unused harmony reexport GridListTileBar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Grow__ = __webpack_require__(151);
/* unused harmony reexport Grow */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Hidden__ = __webpack_require__(690);
/* unused harmony reexport Hidden */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon__ = __webpack_require__(692);
/* unused harmony reexport Icon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__IconButton__ = __webpack_require__(115);
/* unused harmony reexport IconButton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Input__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_58__Input__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__InputAdornment__ = __webpack_require__(693);
/* unused harmony reexport InputAdornment */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__InputBase__ = __webpack_require__(116);
/* unused harmony reexport InputBase */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__InputLabel__ = __webpack_require__(342);
/* unused harmony reexport InputLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__LinearProgress__ = __webpack_require__(343);
/* unused harmony reexport LinearProgress */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Link__ = __webpack_require__(694);
/* unused harmony reexport Link */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__List__ = __webpack_require__(344);
/* unused harmony reexport List */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ListItem__ = __webpack_require__(345);
/* unused harmony reexport ListItem */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ListItemAvatar__ = __webpack_require__(695);
/* unused harmony reexport ListItemAvatar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ListItemIcon__ = __webpack_require__(696);
/* unused harmony reexport ListItemIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ListItemSecondaryAction__ = __webpack_require__(697);
/* unused harmony reexport ListItemSecondaryAction */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ListItemText__ = __webpack_require__(698);
/* unused harmony reexport ListItemText */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__ListSubheader__ = __webpack_require__(699);
/* unused harmony reexport ListSubheader */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Menu__ = __webpack_require__(700);
/* unused harmony reexport Menu */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__MenuItem__ = __webpack_require__(348);
/* unused harmony reexport MenuItem */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__MenuList__ = __webpack_require__(347);
/* unused harmony reexport MenuList */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__MobileStepper__ = __webpack_require__(702);
/* unused harmony reexport MobileStepper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Modal__ = __webpack_require__(150);
/* unused harmony reexport Modal */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__NativeSelect__ = __webpack_require__(703);
/* unused harmony reexport NativeSelect */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__NoSsr__ = __webpack_require__(349);
/* unused harmony reexport NoSsr */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__OutlinedInput__ = __webpack_require__(225);
/* unused harmony reexport OutlinedInput */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Paper__ = __webpack_require__(54);
/* unused harmony reexport Paper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Popover__ = __webpack_require__(346);
/* unused harmony reexport Popover */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Popper__ = __webpack_require__(350);
/* unused harmony reexport Popper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Portal__ = __webpack_require__(221);
/* unused harmony reexport Portal */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Radio__ = __webpack_require__(707);
/* unused harmony reexport Radio */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__RadioGroup__ = __webpack_require__(710);
/* unused harmony reexport RadioGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__RootRef__ = __webpack_require__(711);
/* unused harmony reexport RootRef */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Select__ = __webpack_require__(226);
/* unused harmony reexport Select */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Slide__ = __webpack_require__(335);
/* unused harmony reexport Slide */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__Slider__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_88__Slider__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__Snackbar__ = __webpack_require__(713);
/* unused harmony reexport Snackbar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__SnackbarContent__ = __webpack_require__(351);
/* unused harmony reexport SnackbarContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Step__ = __webpack_require__(714);
/* unused harmony reexport Step */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__StepButton__ = __webpack_require__(715);
/* unused harmony reexport StepButton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__StepConnector__ = __webpack_require__(354);
/* unused harmony reexport StepConnector */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__StepContent__ = __webpack_require__(716);
/* unused harmony reexport StepContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__StepIcon__ = __webpack_require__(353);
/* unused harmony reexport StepIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__StepLabel__ = __webpack_require__(352);
/* unused harmony reexport StepLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Stepper__ = __webpack_require__(717);
/* unused harmony reexport Stepper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__SvgIcon__ = __webpack_require__(213);
/* unused harmony reexport SvgIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__SwipeableDrawer__ = __webpack_require__(718);
/* unused harmony reexport SwipeableDrawer */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Switch__ = __webpack_require__(719);
/* unused harmony reexport Switch */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Tab__ = __webpack_require__(720);
/* unused harmony reexport Tab */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Table__ = __webpack_require__(721);
/* unused harmony reexport Table */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__TableBody__ = __webpack_require__(723);
/* unused harmony reexport TableBody */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__TableCell__ = __webpack_require__(355);
/* unused harmony reexport TableCell */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__TableContainer__ = __webpack_require__(724);
/* unused harmony reexport TableContainer */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__TableFooter__ = __webpack_require__(725);
/* unused harmony reexport TableFooter */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__TableHead__ = __webpack_require__(726);
/* unused harmony reexport TableHead */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__TablePagination__ = __webpack_require__(727);
/* unused harmony reexport TablePagination */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__TableRow__ = __webpack_require__(730);
/* unused harmony reexport TableRow */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__TableSortLabel__ = __webpack_require__(731);
/* unused harmony reexport TableSortLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__Tabs__ = __webpack_require__(732);
/* unused harmony reexport Tabs */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__TabScrollButton__ = __webpack_require__(357);
/* unused harmony reexport TabScrollButton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__TextField__ = __webpack_require__(733);
/* unused harmony reexport TextField */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__TextareaAutosize__ = __webpack_require__(336);
/* unused harmony reexport TextareaAutosize */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__Toolbar__ = __webpack_require__(356);
/* unused harmony reexport Toolbar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__Tooltip__ = __webpack_require__(734);
/* unused harmony reexport Tooltip */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Typography__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_117__Typography__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Unstable_TrapFocus__ = __webpack_require__(333);
/* unused harmony reexport Unstable_TrapFocus */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__useMediaQuery__ = __webpack_require__(341);
/* unused harmony reexport useMediaQuery */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__useScrollTrigger__ = __webpack_require__(735);
/* unused harmony reexport useScrollTrigger */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__withMobileDialog__ = __webpack_require__(736);
/* unused harmony reexport withMobileDialog */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__withWidth__ = __webpack_require__(224);
/* unused harmony reexport withWidth */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Zoom__ = __webpack_require__(737);
/* unused harmony reexport Zoom */
/* unused harmony namespace reexport */
/** @license Material-UI v4.11.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */









































































































































































































































 // eslint-disable-next-line camelcase














/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(603);
/* unused harmony reexport common */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__red__ = __webpack_require__(607);
/* unused harmony reexport red */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pink__ = __webpack_require__(606);
/* unused harmony reexport pink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__purple__ = __webpack_require__(1327);
/* unused harmony reexport purple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deepPurple__ = __webpack_require__(1328);
/* unused harmony reexport deepPurple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indigo__ = __webpack_require__(605);
/* unused harmony reexport indigo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blue__ = __webpack_require__(609);
/* unused harmony reexport blue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lightBlue__ = __webpack_require__(1329);
/* unused harmony reexport lightBlue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cyan__ = __webpack_require__(1330);
/* unused harmony reexport cyan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__teal__ = __webpack_require__(1331);
/* unused harmony reexport teal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__green__ = __webpack_require__(610);
/* unused harmony reexport green */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lightGreen__ = __webpack_require__(1332);
/* unused harmony reexport lightGreen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lime__ = __webpack_require__(1333);
/* unused harmony reexport lime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__yellow__ = __webpack_require__(1334);
/* unused harmony reexport yellow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amber__ = __webpack_require__(1335);
/* unused harmony reexport amber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__orange__ = __webpack_require__(608);
/* unused harmony reexport orange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__deepOrange__ = __webpack_require__(1336);
/* unused harmony reexport deepOrange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__brown__ = __webpack_require__(1337);
/* unused harmony reexport brown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__grey__ = __webpack_require__(604);
/* unused harmony reexport grey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blueGrey__ = __webpack_require__(1338);
/* unused harmony reexport blueGrey */





















/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* unused harmony default export */ var _unused_webpack_default_export = (purple);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
/* unused harmony default export */ var _unused_webpack_default_export = (deepPurple);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lightBlue);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
/* unused harmony default export */ var _unused_webpack_default_export = (cyan);

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
/* unused harmony default export */ var _unused_webpack_default_export = (teal);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lightGreen);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lime);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
/* unused harmony default export */ var _unused_webpack_default_export = (yellow);

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (amber);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (deepOrange);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
/* unused harmony default export */ var _unused_webpack_default_export = (brown);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
/* unused harmony default export */ var _unused_webpack_default_export = (blueGrey);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, titleAccess) : null);
});
 false ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccordionContext__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useControlled__ = __webpack_require__(86);














var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function Accordion(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useControlled__["a" /* default */])({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_4_react__["Children"].toArray(childrenProp),
      _React$Children$toArr2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__["a" /* default */])(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__AccordionContext__["a" /* default */].Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? Accordion.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (isFragment(summary)) {
      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the accordion by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the accordion will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordion'
})(Accordion));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transitions_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(639);












var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? __WEBPACK_IMPORTED_MODULE_8__styles_transitions__["b" /* duration */].standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["a" /* Transition */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_10__styles_useTheme__["a" /* default */])();
  var timer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var wrapperRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var autoTransitionDuration = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* useForkRef */])(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_9__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_9__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minHeight: collapsedHeight
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
 false ? Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the passed `Component`.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCollapse'
})(Collapse));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(645);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" /* default */])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" /* default */])(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["classNames"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["d" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (CSSTransition);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(1345);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!Object(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" /* default */])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    ;
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(646);






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" /* default */], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (ReplaceTransition);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildMapping;
/* unused harmony export mergeChildMappings */
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialChildMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextChildMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(329);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */]:
        component = current;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" /* default */].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* unused harmony default export */ var _unused_webpack_default_export = (SwitchTransition);

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var AccordionActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AccordionActions(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? AccordionActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordionActions'
})(AccordionActions));

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AccordionDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? AccordionDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion details.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordionDetails'
})(AccordionDetails));

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IconButton__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Accordion_AccordionContext__ = __webpack_require__(647);



/* eslint-disable jsx-a11y/aria-role */







var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__Accordion_AccordionContext__["a" /* default */]),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? AccordionSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocusVisible: PropTypes.func
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordionSummary'
})(AccordionSummary));

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useIsFocusVisible__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TouchRipple__ = __webpack_require__(1356);












var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  function getButtonNode() {
    // #StrictMode ready
    return __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](buttonRef.current);
  }

  var rippleRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false);
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(buttonRefProp, ref);
  var handleOwnRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(focusVisibleRef, buttonRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(handleUserRef, handleOwnRef);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__TouchRipple__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
 false ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: refType,

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonBase'
})(ButtonBase));

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DELAY_RIPPLE */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Ripple__ = __webpack_require__(1357);









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["center", "classes", "className"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](0);
  var rippleCallback = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var container = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(oldRipples), [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Ripple__["a" /* default */], {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["b" /* TransitionGroup */], {
    component: null,
    exit: true
  }, ripples));
});
 false ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["memo"](TouchRipple)));

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__ = __webpack_require__(75);




var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"];
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = Object(__WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__["a" /* default */])(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: childClassName
  }));
}

 false ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Ripple);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(21);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))], disabled && classes.disabled, size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(54);








var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0,
      '@media print': {
        // Prevent the app bar to be visible on each printed page.
        position: 'absolute'
      }
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="transparent"`. */
    colorTransparent: {
      backgroundColor: 'transparent',
      color: 'inherit'
    }
  };
};
var AppBar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AppBar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$position = props.position,
      position = _props$position === void 0 ? 'fixed' : _props$position,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "position"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    component: "header",
    elevation: 4,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(position))], classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
 false ? AppBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAppBar'
})(AppBar));

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_Person__ = __webpack_require__(1361);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {},

    /* Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="square"`. */
    square: {
      borderRadius: 0
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover',
      // Hide alt text.
      color: 'transparent',
      // Hide the image broken icon, only works on Chrome.
      textIndent: 10000
    },

    /* Styles applied to the fallback icon */
    fallback: {
      width: '75%',
      height: '75%'
    }
  };
};

function useLoaded(_ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      loaded = _React$useState[0],
      setLoaded = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    var active = true;
    var image = new Image();
    image.src = src;
    image.srcSet = srcSet;

    image.onload = function () {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = function () {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}

var Avatar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Avatar(props, ref) {
  var alt = props.alt,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circle' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);

  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  var loaded = useLoaded({
    src: src,
    srcSet: srcSet
  });
  var hasImg = src || srcSet;
  var hasImgNotFailing = hasImg && loaded !== 'error';

  if (hasImgNotFailing) {
    children = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_Person__["a" /* default */], {
      className: classes.fallback
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
    ref: ref
  }, other), children);
});
 false ? Avatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: PropTypes.string,

  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Attributes applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   */
  imgProps: PropTypes.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: PropTypes.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: PropTypes.string,

  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: PropTypes.string,

  /**
   * The shape of the avatar.
   */
  variant: PropTypes.oneOf(['circle', 'rounded', 'square'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAvatar'
})(Avatar));

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fade__ = __webpack_require__(219);







var styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6__Fade__["a" /* default */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBackdrop'
})(Backdrop));

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(32);










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["a" /* Transition */] : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      flexShrink: 0
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Badge(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _props$anchorOrigin,
      badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
      invisibleProp = props.invisible,
      _props$max = props.max,
      max = _props$max === void 0 ? 99 : _props$max,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? false : _props$showZero,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);

  var invisible = invisibleProp;

  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
    invisible = true;
  }

  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), children, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.badge, classes["".concat(anchorOrigin.horizontal).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(anchorOrigin.vertical)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(anchorOrigin.horizontal)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(overlap))], color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
  }, displayValue));
});
 false ? Badge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The anchor of the badge.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,

  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'error', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the badge will be invisible.
   */
  invisible: PropTypes.bool,

  /**
   * Max count to show.
   */
  max: PropTypes.number,

  /**
   * Wrapped shape the badge should overlap.
   */
  overlap: PropTypes.oneOf(['circle', 'rectangle']),

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dot', 'standard'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBadge'
})(Badge));

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};
var BottomNavigation = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function BottomNavigation(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      onChange = props.onChange,
      _props$showLabels = props.showLabels,
      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, childIndex) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  }));
});
 false ? BottomNavigation.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {any} value We default to the index of the child.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: PropTypes.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation));

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_unsupportedProp__ = __webpack_require__(215);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      padding: '6px 12px 8px',
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Pseudo-class applied to the root element if selected. */
    selected: {},

    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};
var BottomNavigationAction = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function BottomNavigationAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      icon = props.icon,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      showLabel = props.showLabel,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
    focusRipple: true,
    onClick: handleChange
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.wrapper
  }, icon, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
  }, label)));
});
 false ? BottomNavigationAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: PropTypes.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styleFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styled__ = __webpack_require__(638);


var styleFunction = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["d" /* css */])(Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["a" /* borders */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["e" /* display */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["f" /* flexbox */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["g" /* grid */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["i" /* positions */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["h" /* palette */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["j" /* shadows */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["k" /* sizing */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["l" /* spacing */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["m" /* typography */]));
/**
 * @ignore - do not document.
 */

var Box = Object(__WEBPACK_IMPORTED_MODULE_1__styles_styled__["a" /* default */])('div')(styleFunction, {
  name: 'MuiBox'
});
/* unused harmony default export */ var _unused_webpack_default_export = (Box);

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Typography__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BreadcrumbCollapsed__ = __webpack_require__(1370);










var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {
        console.error(['Material-UI: You have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
      }

      return allItems;
    }

    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__BreadcrumbCollapsed__["a" /* default */], {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].toArray(children).filter(function (child) {
    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child);
  }).map(function (child, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? Breadcrumbs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The breadcrumb children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  expandText: PropTypes.string,

  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   */
  itemsAfterCollapse: PropTypes.number,

  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   */
  itemsBeforeCollapse: PropTypes.number,

  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   */
  maxItems: PropTypes.number,

  /**
   * Custom separator node.
   */
  separator: PropTypes.node
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], display !== 'initial' && classes["display".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(display))]),
    ref: ref
  }, other));
});
 false ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTypography'
})(Typography));

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_MoreHoriz__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(43);









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__styles_colorManipulator__["b" /* emphasize */])(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_MoreHoriz__["a" /* default */], {
    className: classes.icon
  }));
}

 false ? BreadcrumbCollapsed.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(21);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.startIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.endIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, endIconProp);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))], classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? Button.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButton'
})(Button));

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(330);









 // Force a side effect so we don't have any override priority issue.
// eslint-disable-next-line no-unused-expressions

__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].styles;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none'
    },

    /* Pseudo-class applied to child elements if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the children. */
    grouped: {
      minWidth: 40
    },

    /* Styles applied to the children if `orientation="horizontal"`. */
    groupedHorizontal: {
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },

    /* Styles applied to the children if `orientation="vertical"`. */
    groupedVertical: {
      '&:not(:first-child)': {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },

    /* Styles applied to the children if `variant="text"`. */
    groupedText: {},

    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
    groupedTextHorizontal: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
    groupedTextVertical: {
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
    groupedTextPrimary: {
      '&:not(:last-child)': {
        borderColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
    groupedTextSecondary: {
      '&:not(:last-child)': {
        borderColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="outlined"`. */
    groupedOutlined: {},

    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
    groupedOutlinedHorizontal: {
      '&:not(:first-child)': {
        marginLeft: -1
      },
      '&:not(:last-child)': {
        borderRightColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
    groupedOutlinedVertical: {
      '&:not(:first-child)': {
        marginTop: -1
      },
      '&:not(:last-child)': {
        borderBottomColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
    groupedOutlinedPrimary: {
      '&:hover': {
        borderColor: theme.palette.primary.main
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
    groupedOutlinedSecondary: {
      '&:hover': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the children if `variant="contained"`. */
    groupedContained: {
      boxShadow: 'none'
    },

    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
    groupedContainedHorizontal: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderRight: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
    groupedContainedVertical: {
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
    groupedContainedPrimary: {
      '&:not(:last-child)': {
        borderColor: theme.palette.primary.dark
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
    groupedContainedSecondary: {
      '&:not(:last-child)': {
        borderColor: theme.palette.secondary.dark
      }
    }
  };
};
var ButtonGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ButtonGroup(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);

  var buttonClassName = Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.grouped, classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(orientation))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(orientation))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant)).concat(color !== 'default' ? Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color) : '')], disabled && classes.disabled);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "group",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(buttonClassName, child.props.className),
      color: child.props.color || color,
      disabled: child.props.disabled || disabled,
      disableElevation: child.props.disableElevation || disableElevation,
      disableFocusRipple: disableFocusRipple,
      disableRipple: disableRipple,
      fullWidth: fullWidth,
      size: child.props.size || size,
      variant: child.props.variant || variant
    });
  }));
});
 false ? ButtonGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button group.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the buttons will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the button keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the button ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the buttons will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The group orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonGroup'
})(ButtonGroup));

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? Card.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCard'
})(Card));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(43);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      textAlign: 'inherit',
      width: '100%',
      '&:hover $focusHighlight': {
        opacity: theme.palette.action.hoverOpacity
      },
      '&$focusVisible $focusHighlight': {
        opacity: 0.12
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    focusHighlight: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit',
      opacity: 0,
      backgroundColor: 'currentcolor',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.short
      })
    }
  };
};
var CardActionArea = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardActionArea(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      focusVisibleClassName = props.focusVisibleClassName,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "focusVisibleClassName"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(focusVisibleClassName, classes.focusVisible),
    ref: ref
  }, other), children, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.focusHighlight
  }));
});
 false ? CardActionArea.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardActionArea'
})(CardActionArea));

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var CardActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? CardActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardActions'
})(CardActions));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
var CardContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? CardContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardContent'
})(CardContent));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(55);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 16
  },

  /* Styles applied to the avatar element. */
  avatar: {
    flex: '0 0 auto',
    marginRight: 16
  },

  /* Styles applied to the action element. */
  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -8,
    marginRight: -8
  },

  /* Styles applied to the content wrapper element. */
  content: {
    flex: '1 1 auto'
  },

  /* Styles applied to the title Typography element. */
  title: {},

  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
var CardHeader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardHeader(props, ref) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);

  var title = titleProp;

  if (title != null && title.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    title = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    subheader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps), subheader);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), avatar && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.avatar
  }, avatar), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.content
  }, title, subheader), action && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.action
  }, action));
});
 false ? CardHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display in the card header.
   */
  action: PropTypes.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: PropTypes.node,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * The content of the component.
   */
  subheader: PropTypes.node,

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: PropTypes.object,

  /**
   * The content of the Card Title.
   */
  title: PropTypes.node,

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardHeader'
})(CardHeader));

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(10);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },

  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: '100%'
  },

  /* Styles applied to the root element if `component="picture or img"`. */
  img: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover'
  }
};
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
var CardMedia = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardMedia(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "image", "src", "style"]);

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
    ref: ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other), children);
});
 false ? CardMedia.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    if (!props.children && !props.image && !props.src && !props.component) {
      return new Error('Material-UI: Either `children`, `image`, `src` or `component` prop must be specified.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: PropTypes.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: PropTypes.string,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardMedia'
})(CardMedia));

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_CheckBoxOutlineBlank__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_CheckBox__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_svg_icons_IndeterminateCheckBox__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_withStyles__ = __webpack_require__(7);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_CheckBox__["a" /* default */], null);
var defaultIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_CheckBoxOutlineBlank__["a" /* default */], null);
var defaultIndeterminateIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__internal_svg_icons_IndeterminateCheckBox__["a" /* default */], null);
var Checkbox = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox",
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_capitalize__["a" /* default */])(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](icon, {
      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref: ref
  }, other));
});
 false ? Checkbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the checkbox will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: PropTypes.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: PropTypes.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the checkbox.
   * `small` is equivalent to the dense checkbox styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCheckbox'
})(Checkbox));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_Cancel__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unsupportedProp__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonBase__ = __webpack_require__(43);












var styles = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? __WEBPACK_IMPORTED_MODULE_11__ButtonBase__["a" /* default */] : 'div');
  var moreProps = Component === __WEBPACK_IMPORTED_MODULE_11__ButtonBase__["a" /* default */] ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))] : classes["deleteIconOutlinedColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](deleteIconProp) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](deleteIconProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_Cancel__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](avatarProp)) {
    avatar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](avatarProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))])
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](iconProp)) {
    icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](iconProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))])
    });
  }

  if (false) {
    if (avatar && icon) {
      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: clickable || onDelete ? 'button' : undefined,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && [classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))], clickable && classes["clickableColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))], onDelete && classes["deletableColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
 false ? Chip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Avatar element.
   */
  avatar: PropTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: PropTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * Icon element.
   */
  icon: PropTypes.element,

  /**
   * The content of the label.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The size of the chip.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['default', 'outlined'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiChip'
})(Chip));

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel'));

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);








var SIZE = 44;

function getRelativeValue(value, min, max) {
  return (Math.min(Math.max(min, value), max) - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(color))], {
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("circle", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.circle, disableShrink && classes.circleDisableShrink, {
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'static'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(10);








function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  var nodeRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  var syntheticEventRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    // #StrictMode ready
    nodeRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useEventCallback__["a" /* default */])(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!mountedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, childrenProps));
}

 false ? ClickAwayListener.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   */
  disableReactTree: PropTypes.bool,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: PropTypes.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;

if (false) {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (ClickAwayListener);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? Container.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   */
  fixed: PropTypes.bool,

  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export html */
/* unused harmony export body */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(10);





var html = {
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box'
};
var body = function body(theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var styles = function styles(theme) {
  return {
    '@global': {
      html: html,
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      classes = props.classes;
  /* eslint-enable no-unused-vars */

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, children);
}

 false ? CssBaseline.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object
} : void 0;

if (false) {
  // eslint-disable-next-line
  CssBaseline['propTypes' + ''] = exactProp(CssBaseline.propTypes);
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline));

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Backdrop__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Paper__ = __webpack_require__(54);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_12__Paper__["a" /* default */] : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_9__Backdrop__["a" /* default */],
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true,
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.container, classes["scroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](PaperComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.paper, classes["paperScroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(scroll))], classes["paperWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? Dialog.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,

  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: PropTypes.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialog'
})(Dialog));

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Portal__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_zIndex__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalManager__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Unstable_TrapFocus__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SimpleBackdrop__ = __webpack_require__(1394);

















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return __WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"](container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new __WEBPACK_IMPORTED_MODULE_13__ModalManager__["b" /* default */]();
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Modal(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["f" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["b" /* getThemeProps */])({
    name: 'MuiModal',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? __WEBPACK_IMPORTED_MODULE_15__SimpleBackdrop__["a" /* default */] : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({});
  var mountNodeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var modalRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils_ownerDocument__["a" /* default */])(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_13__ModalManager__["a" /* ariaHidden */])(modalRef.current, true);
    }
  });
  var handleClose = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    manager.remove(getModal());
  }, [manager]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = styles(theme || {
    zIndex: __WEBPACK_IMPORTED_MODULE_12__styles_zIndex__["a" /* default */]
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(handleEnter, children.props.onEnter);
    childProps.onExited = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Portal__["a" /* default */], {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](BackdropComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Unstable_TrapFocus__["a" /* default */], {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, childProps))));
});
 false ? Modal.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: PropTypes.bool,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire `onClose`.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: PropTypes.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: PropTypes.bool,

  /**
   * @ignore
   */
  manager: PropTypes.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func,

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_setRef__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(32);







function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_setRef__["a" /* default */])(ref, mountNode);
      return function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_setRef__["a" /* default */])(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](children, mountNode) : mountNode;
});
 false ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func
} : void 0;

if (false) {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */






/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var sentinelStart = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var sentinelEnd = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var nodeToRestore = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var rootRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    // #StrictMode ready
    rootRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var prevOpenRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (!open) {
      return;
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {
          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
    ref: handleRef
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? Unstable_TrapFocus.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.node,

  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: PropTypes.func.isRequired,

  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: PropTypes.func.isRequired,

  /**
   * If `true`, focus will be locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;

if (false) {
  // eslint-disable-next-line
  Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Unstable_TrapFocus);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? SimpleBackdrop.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SimpleBackdrop);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? DialogActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogActions'
})(DialogActions));

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "dividers"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
 false ? DialogContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display the top and bottom dividers.
   */
  dividers: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogContent'
})(DialogContent));

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Typography__ = __webpack_require__(55);





var styles = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
};
var DialogContentText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function DialogContentText(props, ref) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: ref
  }, props));
});
 false ? DialogContentText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText));

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(55);







var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '16px 24px',
    flex: '0 0 auto'
  }
};
var DialogTitle = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogTitle(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disableTypography"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), disableTypography ? children : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], {
    component: "h2",
    variant: "h6"
  }, children));
});
 false ? DialogTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle));

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(37);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? Divider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Absolutely position the element.
   */
  absolute: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   */
  flexItem: PropTypes.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: PropTypes.bool,

  /**
   * The divider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDivider'
})(Divider));

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setTranslateValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debounce__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transitions_utils__ = __webpack_require__(114);











 // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["a" /* Transition */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();
  var childrenRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  /**
   * used in cloneElement(children, { ref: handleRef })
   */

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    childrenRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRefIntermediary = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(handleRefIntermediary, ref);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node);
    Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["b" /* reflow */])(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_5__utils_debounce__["a" /* default */])(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: handleRef,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, children.props.style)
    }, childProps));
  });
});
 false ? Slide.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: elementAcceptingRef,

  /**
   * Direction the child node will enter from.
   */
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Slide);

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExpansionPanelContext__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useControlled__ = __webpack_require__(86);














var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanel component was renamed to Accordion to use a more common naming convention.
 *
 * You should use `import { Accordion } from '@material-ui/core'`
 * or `import Accordion from '@material-ui/core/Accordion'`.
 */

var ExpansionPanel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function ExpansionPanel(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanel component was renamed to Accordion to use a more common naming convention.', '', "You should use `import { Accordion } from '@material-ui/core'`", "or `import Accordion from '@material-ui/core/Accordion'`"].join('\n'));
    }
  }

  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useControlled__["a" /* default */])({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'ExpansionPanel',
    state: 'expanded'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_4_react__["Children"].toArray(childrenProp),
      _React$Children$toArr2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__["a" /* default */])(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ExpansionPanelContext__["a" /* default */].Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? ExpansionPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (isFragment(summary)) {
      return new Error("Material-UI: The ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of ExpansionPanel to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the panel.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel));

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.
 *
 * You should use `import { AccordionActions } from '@material-ui/core'`
 * or `import AccordionActions from '@material-ui/core/AccordionActions'`.
 */

var ExpansionPanelActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ExpansionPanelActions(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.', '', "You should use `import { AccordionActions } from '@material-ui/core'`", "or `import AccordionActions from '@material-ui/core/AccordionActions'`"].join('\n'));
    }
  }

  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? ExpansionPanelActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions));

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.
 *
 * You should use `import { AccordionDetails } from '@material-ui/core'`
 * or `import AccordionDetails from '@material-ui/core/AccordionDetails'`.
 */

var ExpansionPanelDetails = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ExpansionPanelDetails(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.', '', "You should use `import { AccordionDetails } from '@material-ui/core'`", "or `import AccordionDetails from '@material-ui/core/AccordionActions'`"].join('\n'));
    }
  }

  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ExpansionPanelDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel details.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails));

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IconButton__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ExpansionPanel_ExpansionPanelContext__ = __webpack_require__(680);



/* eslint-disable jsx-a11y/aria-role */







var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.
 *
 * You should use `import { AccordionSummary } from '@material-ui/core'`
 * or `import AccordionSummary from '@material-ui/core/AccordionSummary'`.
 */

var ExpansionPanelSummary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ExpansionPanelSummary(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.', '', "You should use `import { AccordionSummary } from '@material-ui/core'`", "or `import AccordionSummary from '@material-ui/core/AccordionSummary'`"].join('\n'));
    }
  }

  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__ExpansionPanel_ExpansionPanelContext__["a" /* default */]),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? ExpansionPanelSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary));

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minHeight: 36,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      },
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        },
        textDecoration: 'none'
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    primary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    secondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="extended"`. */
    extended: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minHeight: 'auto',
      minWidth: 48,
      height: 48,
      '&$sizeSmall': {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      },
      '&$sizeMedium': {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="small"``. */
    sizeSmall: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="medium"``. */
    sizeMedium: {
      width: 48,
      height: 48
    }
  };
};
var Fab = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Fab(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'round' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(size))], disabled && classes.disabled, {
      'primary': classes.primary,
      'secondary': classes.secondary,
      'inherit': classes.colorInherit
    }[color]),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? Fab.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['extended', 'round'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFab'
})(Fab));

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFilledInput'
})(FilledInput));

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(337);




/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */











var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_3_react__["useLayoutEffect"];
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className,
      color = props.color,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment,
      error = props.error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      margin = props.margin,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var handleInputRefWarning = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (instance) {
    if (false) {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRef, handleInputRefProp);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* isFilled */])(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        rows: rows,
        rowsMax: rowsMax
      }, inputProps);
      InputComponent = __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__["a" /* default */];
    }
  } else {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
 false ? InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputBase'
})(InputBase));

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(32);







function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var styles = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$rowsMin = props.rowsMin,
      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
      style = props.style,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);

  var rowsMin = rows || rowsMinProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])(ref, inputRef);
  var shadowRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var renders = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](0);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"]({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (rowsMin) {
      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
    }

    if (rowsMax) {
      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (false) {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [rowsMax, rowsMin, props.placeholder]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function () {
    syncHeight();
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: rowsMin,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.shadow, style)
  }));
});
 false ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  placeholder: PropTypes.string,

  /**
   * Use `rowsMin` instead. The prop will be removed in v5.
   *
   * @deprecated
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosize);

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputBase_utils__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlContext__ = __webpack_require__(220);










var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        var input = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Select']) ? child.props.input : child;

        if (input && Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["a" /* isAdornedStart */])(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["b" /* isFilled */])(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    setFilled(true);
  }, []);
  var onEmpty = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__FormControlContext__["a" /* default */].Provider, {
    value: childContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, margin !== 'none' && classes["margin".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
 false ? FormControl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the form control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the component will be displayed in focused state.
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: PropTypes.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormControl'
})(FormControl));

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Typography__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(21);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl__["b" /* useFormControl */])();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](control, controlProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Typography__["a" /* default */], {
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? FormControlLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The text to be used in an enclosing label element.
   */
  label: PropTypes.node,

  /**
   * The position of the label.
   */
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * @ignore
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel));

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "row"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
 false ? FormGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display group of elements in a compact row.
   */
  row: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormGroup'
})(FormGroup));

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
 false ? FormHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText));

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(7);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    "aria-hidden": true,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
 false ? FormLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormLabel'
})(FormLabel));

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requirePropFactory__ = __webpack_require__(640);


// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/





var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="row-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: className,
    ref: ref
  }, other));
});
 false ? Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: PropTypes.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: PropTypes.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: PropTypes.oneOf(SPACINGS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: PropTypes.bool
} : void 0;
var StyledGrid = Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = requirePropFactory('Grid');
  StyledGrid.propTypes = _extends({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

/* harmony default export */ __webpack_exports__["a"] = (StyledGrid);

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var GridList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function GridList(props, ref) {
  var _props$cellHeight = props.cellHeight,
      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      margin: -spacing / 2
    }, style)
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
});
 false ? GridList.propTypes = {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Number of columns.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: PropTypes.number,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridList'
})(GridList));

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(146);









var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      fit(imgEl, classes);
    });
  }
}

var GridListTile = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function GridListTile(props, ref) {
  // cols rows default values are for docs only
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    ensureImageCover(imgRef.current, classes);
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.tile
  }, __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child)) {
      return null;
    }

    if (child.type === 'img' || Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Image'])) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? GridListTile.propTypes = {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Height of the tile in number of grid cells.
   */
  rows: PropTypes.number
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridListTile'
})(GridListTile));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var GridListTileBar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function GridListTileBar(props, ref) {
  var actionIcon = props.actionIcon,
      _props$actionPosition = props.actionPosition,
      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
      classes = props.classes,
      className = props.className,
      subtitle = props.subtitle,
      title = props.title,
      _props$titlePosition = props.titlePosition,
      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);

  var actionPos = actionIcon && actionPosition;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.titleWrap, {
      'left': classes.titleWrapActionPosLeft,
      'right': classes.titleWrapActionPosRight
    }[actionPos])
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.title
  }, title), subtitle ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
  }, actionIcon) : null);
});
 false ? GridListTileBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: PropTypes.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: PropTypes.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: PropTypes.node,

  /**
   * Title to be displayed on tile.
   */
  title: PropTypes.node,

  /**
   * Position of the title bar.
   */
  titlePosition: PropTypes.oneOf(['bottom', 'top'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar));

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(32);










function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["a" /* Transition */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var autoTimeout = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Grow);

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HiddenJs__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HiddenCss__ = __webpack_require__(1423);






/**
 * Responsively hides children based on the selected implementation.
 */

function Hidden(props) {
  var _props$implementation = props.implementation,
      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
      _props$lgDown = props.lgDown,
      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
      _props$lgUp = props.lgUp,
      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
      _props$mdDown = props.mdDown,
      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
      _props$mdUp = props.mdUp,
      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
      _props$smDown = props.smDown,
      smDown = _props$smDown === void 0 ? false : _props$smDown,
      _props$smUp = props.smUp,
      smUp = _props$smUp === void 0 ? false : _props$smUp,
      _props$xlDown = props.xlDown,
      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
      _props$xlUp = props.xlUp,
      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
      _props$xsDown = props.xsDown,
      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
      _props$xsUp = props.xsUp,
      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);

  if (implementation === 'js') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HiddenJs__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__HiddenCss__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}

 false ? Hidden.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Hidden);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withWidth__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_useTheme__ = __webpack_require__(36);




/**
 * @ignore - internal component.
 */

function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var theme = Object(__WEBPACK_IMPORTED_MODULE_3__styles_useTheme__["a" /* default */])();
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
      var _breakpoint = theme.breakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["c" /* isWidthUp */])(_breakpoint, width) || breakpointDown && Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["b" /* isWidthDown */])(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,

  /**
   * @ignore
   */
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

if (false) {
  HiddenJs.propTypes = exactProp(HiddenJs.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["a" /* default */])()(HiddenJs));

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(40);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMediaQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_styles__ = __webpack_require__(50);



function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["f" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["b" /* getThemeProps */])({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (false) {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _props$options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, options),
      _props$options$defaul = _props$options.defaultMatches,
      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
      _props$options$matchM = _props$options.matchMedia,
      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
      _props$options$noSsr = _props$options.noSsr,
      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
      _props$options$ssrMat = _props$options.ssrMatchMedia,
      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](function () {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      query: query,
      match: match
    });
  }

  return match;
}

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(36);








var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return theme.breakpoints.keys.reduce(function (acc, key) {
    acc["only".concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_capitalize__["a" /* default */])(key))] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      only = props.only,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "only"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  if (false) {
    var unknownProps = Object.keys(other).filter(function (propName) {
      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
      });
      return isUndeclaredBreakpoint;
    });

    if (unknownProps.length > 0) {
      console.error("Material-UI: Unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
    }
  }

  var clsx = [];

  if (className) {
    clsx.push(className);
  }

  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
    var breakpoint = theme.breakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      clsx.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      clsx.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      clsx.push(classes["only".concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_capitalize__["a" /* default */])(breakpoint))]);
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: clsx.join(' ')
  }, children);
}

 false ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateHiddenCss'
})(HiddenCss));

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: theme.typography.pxToRem(24),
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(36)
    }
  };
};
var Icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Icon(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "fontSize"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(fontSize))]),
    "aria-hidden": true,
    ref: ref
  }, other));
});
 false ? Icon.propTypes = {
  /**
   * The name of the icon font ligature.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['inherit', 'default', 'small', 'large'])
} : void 0;
Icon.muiName = 'Icon';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIcon'
})(Icon));

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInput'
})(Input));

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Typography__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(220);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (false) {
      if (variantProp === muiFormControl.variant) {
        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, {
      'start': classes.positionStart,
      'end': classes.positionEnd
    }[position], muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Typography__["a" /* default */], {
    color: "textSecondary"
  }, children) : children));
});
 false ? InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: PropTypes.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: PropTypes.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['start', 'end']),

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment));

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormLabel__ = __webpack_require__(340);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
      margin = props.margin,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FormLabel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "data-shrink": shrink,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
 false ? InputLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the `InputLabel`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: PropTypes.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputLabel'
})(InputLabel));

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_useTheme__ = __webpack_require__(36);









var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  var getColor = function getColor(color) {
    return theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["e" /* lighten */])(color, 0.62) : Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* darken */])(color, 0.5);
  };

  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4,
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },

    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: '$buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0 -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0 -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var LinearProgress = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function LinearProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_8__styles_useTheme__["a" /* default */])();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      var transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (false) {
      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        _transform = -_transform;
      }

      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (false) {
      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], className, {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'buffer': classes.buffer,
      'query': classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other), variant === 'buffer' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.dashed, classes["dashedColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))])
  }) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.bar, classes["barColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
      'determinate': classes.bar1Determinate,
      'buffer': classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], classes.bar2Buffer] : classes["barColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))]),
    style: inlineStyles.bar2
  }));
});
 false ? LinearProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress));

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useIsFocusVisible__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Typography__ = __webpack_require__(55);











var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$focusVisible': {
      outline: 'auto'
    }
  },

  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Link(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'a' : _props$component,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      TypographyClasses = props.TypographyClasses,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'hover' : _props$underline,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  var handlerRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(ref, focusVisibleRef);

  var handleBlur = function handleBlur(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["underline".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant: variant
  }, other));
});
 false ? Link.propTypes = {
  /**
   * The content of the link.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the link.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,

  /**
   * Controls when the link should have an underline.
   */
  underline: PropTypes.oneOf(['none', 'hover', 'always']),

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiLink'
})(Link));

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListContext__ = __webpack_require__(153);







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ListContext__["a" /* default */].Provider, {
    value: context
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiList'
})(List));

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List_ListContext__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */]);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(childrenProp);
  var hasSecondaryAction = children.length && Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listItemRef.current = __WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);

  var componentProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName);
    Component = __WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */];
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
      value: childContext
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ContainerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
    value: childContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef
  }, componentProps), children));
});
 false ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItem'
})(ListItem));

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(153);







var styles = {
  /* Styles applied to the root element. */
  root: {
    minWidth: 56,
    flexShrink: 0
  },

  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
  alignItemsFlexStart: {
    marginTop: 8
  }
};
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */

var ListItemAvatar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemAvatar(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemAvatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component – normally `Avatar`.
   */
  children: PropTypes.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar));

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(153);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon));

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */

var ListItemSecondaryAction = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemSecondaryAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ListItemSecondaryAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction));

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List_ListContext__ = __webpack_require__(153);








var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_7__List_ListContext__["a" /* default */]),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    primary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    secondary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
 false ? ListItemText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Alias for the `primary` prop.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: PropTypes.bool,

  /**
   * The main content element.
   */
  primary: PropTypes.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: PropTypes.object,

  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemText'
})(ListItemText));

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: PropTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListSubheader'
})(ListSubheader));

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOffsetTop */
/* unused harmony export getOffsetLeft */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Grow__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Paper__ = __webpack_require__(54);















function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (false) {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (false) {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (false) {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (false) {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    paperRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      setPositioningStyles();
    }
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open) {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(getAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the popover is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: elementTypeAcceptingRef
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPopover'
})(Popover));

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(32);











function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var textCriteriaRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__["a" /* default */])(true), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = Object(__WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__["a" /* default */])(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listRef.current = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__List__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (MenuList);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ListItem__ = __webpack_require__(345);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ListItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      dense: classes.dense
    }, ListItemClasses),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
   */
  ListItemClasses: PropTypes.object,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LinearProgress__ = __webpack_require__(343);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},

    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },

    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px'
    },

    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: '50%'
    }
  };
};
var MobileStepper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function MobileStepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      backButton = props.backButton,
      classes = props.classes,
      className = props.className,
      LinearProgressProps = props.LinearProgressProps,
      nextButton = props.nextButton,
      _props$position = props.position,
      position = _props$position === void 0 ? 'bottom' : _props$position,
      steps = props.steps,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'dots' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(position))], className),
    ref: ref
  }, other), backButton, variant === 'text' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.dots
  }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(new Array(steps)).map(function (_, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      key: index,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.dot, index === activeStep && classes.dotActive)
    });
  })), variant === 'progress' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LinearProgress__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
});
 false ? MobileStepper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: PropTypes.number,

  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `LinearProgress` element.
   */
  LinearProgressProps: PropTypes.object,

  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: PropTypes.node,

  /**
   * Set the positioning type.
   */
  position: PropTypes.oneOf(['bottom', 'static', 'top']),

  /**
   * The total steps.
   */
  steps: PropTypes.number.isRequired,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dots', 'progress', 'text'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMobileStepper'
})(MobileStepper));

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(10);



var useEnhancedEffect = typeof window !== 'undefined' && "production" !== 'test' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */

function NoSsr(props) {
  var children = props.children,
      _props$defer = props.defer,
      defer = _props$defer === void 0 ? false : _props$defer,
      _props$fallback = props.fallback,
      fallback = _props$fallback === void 0 ? null : _props$fallback;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
      mountedState = _React$useState[0],
      setMountedState = _React$useState[1];

  useEnhancedEffect(function () {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, mountedState ? children : fallback);
}

 false ? NoSsr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: PropTypes.bool,

  /**
   * The fallback content to display.
   */
  fallback: PropTypes.node
} : void 0;

if (false) {
  // eslint-disable-next-line
  NoSsr['propTypes' + ''] = exactProp(NoSsr.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (NoSsr);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotchedOutline__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(7);









var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NotchedOutline__["a" /* default */], {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: PropTypes.node,

  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput));

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(21);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function NotchedOutline(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-hidden": true,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", null, label) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "padding".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(align)), 8), style),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
 false ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The label.
   */
  label: PropTypes.node,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline));

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_popper_js__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Portal__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_setRef__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(32);












function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var ownRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(tooltipRef, ref);
  var popperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handlePopperRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(popperRef, popperRefProp);
  var handlePopperRefRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](handlePopperRef);
  useEnhancedEffect(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_styles__["f" /* useTheme */])();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl(anchorEl);

    if (false) {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new __WEBPACK_IMPORTED_MODULE_4_popper_js__["a" /* default */](getAnchorEl(anchorEl), tooltipRef.current, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (node) {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Portal__["a" /* default */], {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
 false ? Popper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: PropTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: PropTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: PropTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(76)))

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RadioGroup_useRadioGroup__ = __webpack_require__(708);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__["a" /* default */], {
  checked: true
});
var defaultIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__["a" /* default */], null);
var Radio = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = Object(__WEBPACK_IMPORTED_MODULE_12__RadioGroup_useRadioGroup__["a" /* default */])();
  var checked = checkedProp;
  var onChange = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    checkedIcon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? Radio.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the radio will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiRadio'
})(Radio));

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_RadioButtonUnchecked__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_RadioButtonChecked__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, checked && classes.checked)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_RadioButtonUnchecked__["a" /* default */], {
    fontSize: fontSize
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_RadioButtonChecked__["a" /* default */], {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: PropTypes.oneOf(['small', 'default'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormGroup__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useControlled__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RadioGroupContext__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unstable_useId__ = __webpack_require__(216);










var RadioGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      nameProp = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: props.defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__["a" /* default */])(ref, rootRef);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  var name = Object(__WEBPACK_IMPORTED_MODULE_9__utils_unstable_useId__["a" /* default */])(nameProp);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__RadioGroupContext__["a" /* default */].Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__FormGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? RadioGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string]),

  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: PropTypes.string,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (RadioGroup);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_setRef__ = __webpack_require__(96);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






/**
 * ⚠️⚠️⚠️
 * If you want the DOM element of a Material-UI component check out
 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
 * first.
 *
 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
 *
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * function MyComponent() {
 *   const domRef = React.useRef();
 *
 *   React.useEffect(() => {
 *     console.log(domRef.current); // DOM node
 *   }, []);
 *
 *   return (
 *     <RootRef rootRef={domRef}>
 *       <SomeChildComponent />
 *     </RootRef>
 *   );
 * }
 * ```
 */

var RootRef = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(RootRef, _React$Component);

  var _super = _createSuper(RootRef);

  function RootRef() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, RootRef);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = __WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"](this);
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = __WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"](this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(prevProps.rootRef, null);
        }

        this.ref = ref;
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return RootRef;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

 false ? RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: PropTypes.element.isRequired,

  /**
   * A ref that points to the first DOM node of the wrapped element.
   */
  rootRef: refType.isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef.propTypes = exactProp(RootRef.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (RootRef);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectInput__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Input__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FilledInput__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OutlinedInput__ = __webpack_require__(225);















var styles = __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__["a" /* styles */];

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Input__["a" /* default */], null);

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__FilledInput__["a" /* default */], null);

var Select = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__SelectInput__["a" /* default */];
  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__OutlinedInput__["a" /* default */], {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_styles__["d" /* mergeClasses */])({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: PropTypes.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select.muiName = 'Select';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSelect'
})(Select));

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Menu_Menu__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InputBase_utils__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useControlled__ = __webpack_require__(86);

















function areEqualValues(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex,
      type = props.type,
      valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" /* default */])(ref, inputRefProp);
  __WEBPACK_IMPORTED_MODULE_5_react__["useImperativeHandle"](handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (displayNode) {
      var label = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__["a" /* default */])(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (Object(__WEBPACK_IMPORTED_MODULE_12__InputBase_utils__["b" /* isFilled */])({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_utils__["b" /* formatMuiErrorMessage */])(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Menu_Menu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, MenuProps.PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,

  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  type: PropTypes.any,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SelectInput);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_useControlled__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ValueLabel__ = __webpack_require__(1455);



















function asc(a, b) {
  return a - b;
}

function clamp(value, min, max) {
  return Math.min(Math.max(min, value), max);
}

function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - value);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }

    return acc;
  }, null),
      closestIndex = _values$reduce.index;

  return closestIndex;
}

function trackFinger(event, touchId) {
  if (touchId.current !== undefined && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  }

  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split('e-');
    var matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToStep(value, step, min) {
  var nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}

function setValueIndex(_ref) {
  var values = _ref.values,
      source = _ref.source,
      newValue = _ref.newValue,
      index = _ref.index;

  // Performance shortcut
  if (values[index] === newValue) {
    return source;
  }

  var output = values.slice();
  output[index] = newValue;
  return output;
}

function focusThumb(_ref2) {
  var sliderRef = _ref2.sliderRef,
      activeIndex = _ref2.activeIndex,
      setActive = _ref2.setActive;

  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
  }

  if (setActive) {
    setActive(activeIndex);
  }
}

var axisProps = {
  horizontal: {
    offset: function offset(percent) {
      return {
        left: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  'horizontal-reverse': {
    offset: function offset(percent) {
      return {
        right: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  vertical: {
    offset: function offset(percent) {
      return {
        bottom: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        height: "".concat(percent, "%")
      };
    }
  }
};

var Identity = function Identity(x) {
  return x;
};

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: '100%',
      boxSizing: 'content-box',
      padding: '13px 0',
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      touchAction: 'none',
      color: theme.palette.primary.main,
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        pointerEvents: 'none',
        cursor: 'default',
        color: theme.palette.grey[400]
      },
      '&$vertical': {
        width: 2,
        height: '100%',
        padding: '0 13px'
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      '@media (pointer: coarse)': {
        // Reach 42px touch target, about ~8mm on screen.
        padding: '20px 0',
        '&$vertical': {
          padding: '0 20px'
        }
      },
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      '&$vertical': {
        marginBottom: 'auto',
        marginRight: 20
      }
    },

    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the rail element. */
    rail: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      opacity: 0.38,
      '$vertical &': {
        height: '100%',
        width: 2
      }
    },

    /* Styles applied to the track element. */
    track: {
      display: 'block',
      position: 'absolute',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      '$vertical &': {
        width: 2
      }
    },

    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      '& $track': {
        display: 'none'
      }
    },

    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      '& $track': {
        backgroundColor: // Same logic as the LinearProgress track color
        theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["e" /* lighten */])(theme.palette.primary.main, 0.62) : Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["a" /* darken */])(theme.palette.primary.main, 0.5)
      },
      '& $rail': {
        opacity: 1
      }
    },

    /* Styles applied to the thumb element. */
    thumb: {
      position: 'absolute',
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: 'border-box',
      borderRadius: '50%',
      outline: 0,
      backgroundColor: 'currentColor',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: theme.transitions.create(['box-shadow'], {
        duration: theme.transitions.duration.shortest
      }),
      '&::after': {
        position: 'absolute',
        content: '""',
        borderRadius: '50%',
        // reach 42px hit target (2 * 15 + thumb diameter)
        left: -15,
        top: -15,
        right: -15,
        bottom: -15
      },
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.16)),
        '@media (hover: none)': {
          boxShadow: 'none'
        }
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.16))
      },
      '&$disabled': {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        '&:hover': {
          boxShadow: 'none'
        }
      },
      '$vertical &': {
        marginLeft: -5,
        marginBottom: -6
      },
      '$vertical &$disabled': {
        marginLeft: -3,
        marginBottom: -4
      }
    },

    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.16))
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.16))
      }
    },

    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},

    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},

    /* Styles applied to the thumb label element. */
    valueLabel: {
      // IE 11 centering bug, to remove from the customization demos once no longer supported
      left: 'calc(-50% - 4px)'
    },

    /* Styles applied to the mark element. */
    mark: {
      position: 'absolute',
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: theme.palette.background.paper,
      opacity: 0.8
    },

    /* Styles applied to the mark label element. */
    markLabel: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      position: 'absolute',
      top: 26,
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap',
      '$vertical &': {
        top: 'auto',
        left: 26,
        transform: 'translateY(50%)'
      },
      '@media (pointer: coarse)': {
        top: 40,
        '$vertical &': {
          left: 31
        }
      }
    }),

    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: theme.palette.text.primary
    }
  };
};
var Slider = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function Slider(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      ariaValuetext = props['aria-valuetext'],
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      getAriaLabel = props.getAriaLabel,
      getAriaValueText = props.getAriaValueText,
      _props$marks = props.marks,
      marksProp = _props$marks === void 0 ? false : _props$marks,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      name = props.name,
      onChange = props.onChange,
      onChangeCommitted = props.onChangeCommitted,
      onMouseDown = props.onMouseDown,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$scale = props.scale,
      scale = _props$scale === void 0 ? Identity : _props$scale,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      _props$ThumbComponent = props.ThumbComponent,
      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
      _props$track = props.track,
      track = _props$track === void 0 ? 'normal' : _props$track,
      valueProp = props.value,
      _props$ValueLabelComp = props.ValueLabelComponent,
      ValueLabelComponent = _props$ValueLabelComp === void 0 ? __WEBPACK_IMPORTED_MODULE_17__ValueLabel__["a" /* default */] : _props$ValueLabelComp,
      _props$valueLabelDisp = props.valueLabelDisplay,
      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
      _props$valueLabelForm = props.valueLabelFormat,
      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();
  var touchId = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](); // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transfered when inversing a range slider.

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](-1),
      active = _React$useState[0],
      setActive = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](-1),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Slider'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      valueDerived = _useControlled2[0],
      setValueState = _useControlled2[1];

  var range = Array.isArray(valueDerived);
  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(function (value) {
    return clamp(value, min, max);
  });
  var marks = marksProp === true && step !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
    return {
      value: min + step * index
    };
  }) : marksProp || [];

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](-1),
      focusVisible = _React$useState3[0],
      setFocusVisible = _React$useState3[1];

  var sliderRef = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(focusVisibleRef, sliderRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(ref, handleFocusRef);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));

    if (isFocusVisible(event)) {
      setFocusVisible(index);
    }

    setOpen(index);
  });
  var handleBlur = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function () {
    if (focusVisible !== -1) {
      setFocusVisible(-1);
      onBlurVisible();
    }

    setOpen(-1);
  });
  var handleMouseOver = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  });
  var handleMouseLeave = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function () {
    setOpen(-1);
  });
  var isRtl = theme.direction === 'rtl';
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;
    var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
    var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';

    switch (event.key) {
      case 'Home':
        newValue = min;
        break;

      case 'End':
        newValue = max;
        break;

      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }

        break;

      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }

        break;

      case increaseKey:
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }

        break;

      case decreaseKey:
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }

        break;

      default:
        return;
    } // Prevent scroll of the page


    event.preventDefault();

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }

    newValue = clamp(newValue, min, max);

    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values,
        source: valueDerived,
        newValue: newValue,
        index: index
      }).sort(asc);
      focusThumb({
        sliderRef: sliderRef,
        activeIndex: newValue.indexOf(previousValue)
      });
    }

    setValueState(newValue);
    setFocusVisible(index);

    if (onChange) {
      onChange(event, newValue);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  });
  var previousIndex = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var axis = orientation;

  if (isRtl && orientation !== "vertical") {
    axis += '-reverse';
  }

  var getFingerNewValue = function getFingerNewValue(_ref3) {
    var finger = _ref3.finger,
        _ref3$move = _ref3.move,
        move = _ref3$move === void 0 ? false : _ref3$move,
        values2 = _ref3.values,
        source = _ref3.source;
    var slider = sliderRef.current;

    var _slider$getBoundingCl = slider.getBoundingClientRect(),
        width = _slider$getBoundingCl.width,
        height = _slider$getBoundingCl.height,
        bottom = _slider$getBoundingCl.bottom,
        left = _slider$getBoundingCl.left;

    var percent;

    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }

    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }

    var newValue;
    newValue = percentToValue(percent, min, max);

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      var marksValues = marks.map(function (mark) {
        return mark.value;
      });
      var closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }

    newValue = clamp(newValue, min, max);
    var activeIndex = 0;

    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      var previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        source: source,
        newValue: newValue,
        index: activeIndex
      }).sort(asc);
      activeIndex = newValue.indexOf(previousValue);
      previousIndex.current = activeIndex;
    }

    return {
      newValue: newValue,
      activeIndex: activeIndex
    };
  };

  var handleTouchMove = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue = getFingerNewValue({
      finger: finger,
      move: true,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue.newValue,
        activeIndex = _getFingerNewValue.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  });
  var handleTouchEnd = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue2 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue2.newValue;

    setActive(-1);

    if (event.type === 'touchend') {
      setOpen(-1);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }

    touchId.current = undefined;
    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  });
  var handleTouchStart = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    // Workaround as Safari has partial support for touchAction: 'none'.
    event.preventDefault();
    var touch = event.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    var finger = trackFinger(event, touchId);

    var _getFingerNewValue3 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue3.newValue,
        activeIndex = _getFingerNewValue3.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove);
    doc.addEventListener('touchend', handleTouchEnd);
  });
  __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
    var slider = sliderRef.current;
    slider.addEventListener('touchstart', handleTouchStart);
    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(slider);
    return function () {
      slider.removeEventListener('touchstart', handleTouchStart);
      doc.removeEventListener('mousemove', handleTouchMove);
      doc.removeEventListener('mouseup', handleTouchEnd);
      doc.removeEventListener('touchmove', handleTouchMove);
      doc.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
  var handleMouseDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    if (onMouseDown) {
      onMouseDown(event);
    }

    event.preventDefault();
    var finger = trackFinger(event, touchId);

    var _getFingerNewValue4 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue4.newValue,
        activeIndex = _getFingerNewValue4.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove);
    doc.addEventListener('mouseup', handleTouchEnd);
  });
  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;

  var trackStyle = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__["a" /* default */])({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_15__utils_capitalize__["a" /* default */])(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
      return mark.label;
    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
    onMouseDown: handleMouseDown
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
    className: classes.rail
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
    className: classes.track,
    style: trackStyle
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("input", {
    value: values.join(','),
    name: name,
    type: "hidden"
  }), marks.map(function (mark, index) {
    var percent = valueToPercent(mark.value, min, max);
    var style = axisProps[axis].offset(percent);
    var markActive;

    if (track === false) {
      markActive = values.indexOf(mark.value) !== -1;
    } else {
      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], {
      key: mark.value
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      style: style,
      "data-index": index,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.mark, markActive && classes.markActive)
    }), mark.label != null ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      "aria-hidden": true,
      "data-index": index,
      style: style,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.markLabel, markActive && classes.markLabelActive)
    }, mark.label) : null);
  }), values.map(function (value, index) {
    var percent = valueToPercent(value, min, max);
    var style = axisProps[axis].offset(percent);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](ValueLabelComponent, {
      key: index,
      valueLabelFormat: valueLabelFormat,
      valueLabelDisplay: valueLabelDisplay,
      className: classes.valueLabel,
      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
      index: index,
      open: open === index || active === index || valueLabelDisplay === 'on',
      disabled: disabled
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](ThumbComponent, {
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.thumb, classes["thumbColor".concat(Object(__WEBPACK_IMPORTED_MODULE_15__utils_capitalize__["a" /* default */])(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
      tabIndex: disabled ? null : 0,
      role: "slider",
      style: style,
      "data-index": index,
      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-orientation": orientation,
      "aria-valuemax": scale(max),
      "aria-valuemin": scale(min),
      "aria-valuenow": scale(value),
      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  }));
});
 false ? Slider.propTypes = {
  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * If `true`, the slider will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   *
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   *
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks will be spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   */
  marks: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   */
  max: PropTypes.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   */
  min: PropTypes.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * The slider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * A transformation function, to change the scale of the slider.
   */
  scale: PropTypes.func,

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   */
  step: PropTypes.number,

  /**
   * The component used to display the value label.
   */
  ThumbComponent: PropTypes.elementType,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   */
  track: PropTypes.oneOf(['normal', false, 'inverted']),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * The value label component.
   */
  ValueLabelComponent: PropTypes.elementType,

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   */
  valueLabelDisplay: PropTypes.oneOf(['on', 'auto', 'off']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSlider'
})(Slider));

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(7);





var styles = function styles(theme) {
  return {
    thumb: {
      '&$open': {
        '& $offset': {
          transform: 'scale(1) translateY(-10px)'
        }
      }
    },
    open: {},
    offset: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      zIndex: 1
    }, theme.typography.body2, {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest
      }),
      top: -34,
      transformOrigin: 'bottom center',
      transform: 'scale(0)',
      position: 'absolute'
    }),
    circle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: 'currentColor',
      transform: 'rotate(-45deg)'
    },
    label: {
      color: theme.palette.primary.contrastText,
      transform: 'rotate(45deg)'
    }
  };
};
/**
 * @ignore - internal component.
 */


function ValueLabel(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      open = props.open,
      value = props.value,
      valueLabelDisplay = props.valueLabelDisplay;

  if (valueLabelDisplay === 'off') {
    return children;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](children, {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.offset, className)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: classes.circle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: classes.label
  }, value))));
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateValueLabel'
})(ValueLabel));

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ClickAwayListener__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Grow__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SnackbarContent__ = __webpack_require__(351);














var styles = function styles(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, right, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      left: 'auto'
    }, top3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, right, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      left: 'auto'
    }, bottom3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, left, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      right: 'auto'
    }, top3, left3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, left, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      right: 'auto'
    }, bottom3, left3)))
  };
};
var Snackbar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Snackbar(props, ref) {
  var action = props.action,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _props$anchorOrigin;

  var vertical = _props$anchorOrigin.vertical,
      horizontal = _props$anchorOrigin.horizontal,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
      children = props.children,
      classes = props.classes,
      className = props.className,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      ContentProps = props.ContentProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      message = props.message,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_12__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].enteringScreen,
    exit: __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var timerAutoHide = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var handleClose = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  var handleResume = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  var handleExited = function handleExited() {
    setExited(true);
  };

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ClickAwayListener__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["anchorOrigin".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(vertical)).concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(handleEnter, onEnter),
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(handleExited, onExited),
    onExiting: onExiting,
    timeout: transitionDuration,
    direction: vertical === 'top' ? 'down' : 'up'
  }, TransitionProps), children || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__SnackbarContent__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    message: message,
    action: action
  }, ContentProps)))));
});
 false ? Snackbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: PropTypes.number,

  /**
   * Replace the `SnackbarContent` component.
   */
  children: PropTypes.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: PropTypes.object,

  /**
   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
   */
  ContentProps: PropTypes.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: PropTypes.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: PropTypes.any,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * If `true`, `Snackbar` is open.
   */
  open: PropTypes.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar));

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(37);









var styles = function styles(theme) {
  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["b" /* emphasize */])(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    })),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SnackbarContent(props, ref) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "classes", "className", "message", "role"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: role,
    square: true,
    elevation: 6,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.message
  }, message), action ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.action
  }, action) : null);
});
 false ? SnackbarContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent));

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: 'relative'
  },

  /* Pseudo-class applied to the root element if `completed={true}`. */
  completed: {}
};
var Step = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Step(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      connectorProp = props.connector,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$expanded = props.expanded,
      expanded = _props$expanded === void 0 ? false : _props$expanded,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);

  var connector = connectorProp ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](connectorProp, {
    orientation: orientation,
    alternativeLabel: alternativeLabel,
    index: index,
    active: active,
    completed: completed,
    disabled: disabled
  }) : null;
  var newChildren = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
    ref: ref
  }, other), connector && alternativeLabel && index !== 0 ? connector : null, __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      expanded: expanded,
      last: last,
      icon: index + 1,
      orientation: orientation
    }, child.props));
  }));

  if (connector && !alternativeLabel && index !== 0) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, connector, newChildren);
  }

  return newChildren;
});
 false ? Step.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Expand the step.
   */
  expanded: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStep'
})(Step));

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepLabel__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(146);









var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box'
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: 'flex-start',
    padding: '8px',
    margin: '-8px'
  },

  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
};
var StepButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepButton(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      expanded = props.expanded,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);

  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children, ['StepLabel']) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, childProps) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__StepLabel__["a" /* default */], childProps, children);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: true,
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className),
    ref: ref
  }, other), child);
});
 false ? StepButton.propTypes = {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   * potentially passed from parent `Step`
   */
  expanded: PropTypes.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepButton'
})(StepButton));

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepIcon__ = __webpack_require__(353);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: 16
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the `icon` container element. */
    iconContainer: {
      flexShrink: 0,
      // Fix IE 11 issue
      display: 'flex',
      paddingRight: 8,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },

    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},

    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: '100%'
    }
  };
};
var StepLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      expanded = props.expanded,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      StepIconComponentProp = props.StepIconComponent,
      StepIconProps = props.StepIconProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);

  var StepIconComponent = StepIconComponentProp;

  if (icon && !StepIconComponent) {
    StepIconComponent = __WEBPACK_IMPORTED_MODULE_7__StepIcon__["a" /* default */];
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
    ref: ref
  }, other), icon || StepIconComponent ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](StepIconComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.labelContainer
  }, children ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], {
    variant: "body2",
    component: "span",
    display: "block",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
  }, children) : null, optional));
});
 false ? StepLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * Override the default label of the step icon.
   */
  icon: PropTypes.node,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * The component to render in place of the [`StepIcon`](/api/step-icon/).
   */
  StepIconComponent: PropTypes.elementType,

  /**
   * Props applied to the [`StepIcon`](/api/step-icon/) element.
   */
  StepIconProps: PropTypes.object
} : void 0;
StepLabel.muiName = 'StepLabel';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepLabel'
})(StepLabel));

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_CheckCircle__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_Warning__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SvgIcon__ = __webpack_require__(213);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: theme.palette.text.disabled,
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {}
  };
};

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

var StepIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function StepIcon(props, ref) {
  var _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      icon = props.icon,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    var className = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, active && classes.active, error && classes.error, completed && classes.completed);

    if (error) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_Warning__["a" /* default */], {
        className: className,
        ref: ref
      });
    }

    if (completed) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_CheckCircle__["a" /* default */], {
        className: className,
        ref: ref
      });
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SvgIcon__["a" /* default */], {
      className: className,
      ref: ref
    }, _ref, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }

  return icon;
});
 false ? StepIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepIcon'
})(StepIcon));

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle'));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning'));

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto'
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: '0 0 8px'
    },

    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(-50% + 20px)',
      right: 'calc(50% + 20px)'
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the line element. */
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};
var StepConnector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepConnector(props, ref) {
  var active = props.active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      index = props.index,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.line, {
      'horizontal': classes.lineHorizontal,
      'vertical': classes.lineVertical
    }[orientation])
  }));
});
 false ? StepConnector.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepConnector'
})(StepConnector));

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },

    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: 'none'
    },

    /* Styles applied to the Transition component. */
    transition: {}
  };
};
var StepContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepContent(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      expanded = props.expanded,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  if (false) {
    if (orientation !== 'vertical') {
      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
    }
  }

  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, last && classes.last),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: active || expanded,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
});
 false ? StepContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Step content.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepContent'
})(StepContent));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Paper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepConnector__ = __webpack_require__(354);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: 24
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column'
  },

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: 'flex-start'
  }
};
var defaultConnector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__StepConnector__["a" /* default */], null);
var Stepper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Stepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$connector = props.connector,
      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
      _props$nonLinear = props.nonLinear,
      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);

  var connector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](connectorProp) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](connectorProp, {
    orientation: orientation
  }) : null;
  var childrenArray = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children);
  var steps = childrenArray.map(function (step, index) {
    var state = {
      index: index,
      active: false,
      completed: false,
      disabled: false
    };

    if (activeStep === index) {
      state.active = true;
    } else if (!nonLinear && activeStep > index) {
      state.completed = true;
    } else if (!nonLinear && activeStep < index) {
      state.disabled = true;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](step, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      alternativeLabel: alternativeLabel,
      connector: connector,
      last: index + 1 === childrenArray.length,
      orientation: orientation
    }, state, step.props));
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
    ref: ref
  }, other), steps);
});
 false ? Stepper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   */
  activeStep: PropTypes.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * An element to be placed between each step.
   */
  connector: PropTypes.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: PropTypes.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepper'
})(Stepper));

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transitions_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NoSsr__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SwipeArea__ = __webpack_require__(1468);














 // This value is closed to what browsers are using internally to
// trigger a native scroll.

var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function reset() {
  nodeThatClaimedTheSwipe = null;
}

function calculateCurrentX(anchor, touches) {
  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}

function calculateCurrentY(anchor, touches) {
  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
}

function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}

function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}

function getDomTreeShapes(element, rootNode) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push(element);
    }

    element = element.parentElement;
  }

  return domTreeShapes;
}

function findNativeHandler(_ref) {
  var domTreeShapes = _ref.domTreeShapes,
      start = _ref.start,
      current = _ref.current,
      anchor = _ref.anchor;
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
  var axisProperties = {
    scrollPosition: {
      x: 'scrollLeft',
      y: 'scrollTop'
    },
    scrollLength: {
      x: 'scrollWidth',
      y: 'scrollHeight'
    },
    clientLength: {
      x: 'clientWidth',
      y: 'clientHeight'
    }
  };
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = current >= start;

    if (anchor === 'top' || anchor === 'left') {
      goingForward = !goingForward;
    }

    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return shape;
    }

    return null;
  });
}

var iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
var transitionDurationDefault = {
  enter: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].leavingScreen
};
var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var SwipeableDrawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SwipeableDrawer(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_11__styles_useTheme__["a" /* default */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_styles__["b" /* getThemeProps */])({
    name: 'MuiSwipeableDrawer',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inProps),
    theme: theme
  });
  var _props$anchor = props.anchor,
      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
      _props$disableBackdro = props.disableBackdropTransition,
      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableDiscove = props.disableDiscovery,
      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
      _props$disableSwipeTo = props.disableSwipeToOpen,
      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? iOS : _props$disableSwipeTo,
      hideBackdrop = props.hideBackdrop,
      _props$hysteresis = props.hysteresis,
      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
      _props$minFlingVeloci = props.minFlingVelocity,
      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropProps = _props$ModalProps.BackdropProps,
      ModalPropsProp = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SwipeAreaProps = props.SwipeAreaProps,
      _props$swipeAreaWidth = props.swipeAreaWidth,
      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      maybeSwiping = _React$useState[0],
      setMaybeSwiping = _React$useState[1];

  var swipeInstance = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    isSwiping: null
  });
  var swipeAreaRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var backdropRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var touchDetected = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false); // Ref for transition duration based on / to match swipe speed

  var calculatedDurationRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // Use a ref so the open value used is always up to date inside useCallback.

  useEnhancedEffect(function () {
    calculatedDurationRef.current = null;
  }, [open]);
  var setPosition = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (translate) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$mode = options.mode,
        mode = _options$mode === void 0 ? null : _options$mode,
        _options$changeTransi = options.changeTransition,
        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
    var drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    var transition = '';

    if (mode) {
      transition = theme.transitions.create('all', Object(__WEBPACK_IMPORTED_MODULE_12__transitions_utils__["a" /* getTransitionProps */])({
        timeout: transitionDuration
      }, {
        mode: mode
      }));
    }

    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }

    if (!disableBackdropTransition && !hideBackdrop) {
      var backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);

      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  var handleBodyTouchEnd = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (event) {
    if (!touchDetected.current) {
      return;
    }

    nodeThatClaimedTheSwipe = null;
    touchDetected.current = false;
    setMaybeSwiping(false); // The swipe wasn't started.

    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }

    swipeInstance.current.isSwiping = null;
    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontal = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var current;

    if (horizontal) {
      current = calculateCurrentX(anchorRtl, event.changedTouches);
    } else {
      current = calculateCurrentY(anchorRtl, event.changedTouches);
    }

    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    var translateRatio = currentTranslate / maxTranslate;

    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      // Calculate transition duration to match swipe speed
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
    }

    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        // Reset the position, the swipe was aborted.
        setPosition(0, {
          mode: 'exit'
        });
      }

      return;
    }

    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      // Reset the position, the swipe was aborted.
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: 'enter'
      });
    }
  });
  var handleBodyTouchMove = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (event) {
    // the ref may be null when a parent component updates while swiping
    if (!paperRef.current || !touchDetected.current) {
      return;
    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer


    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
      return;
    }

    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
      var nativeHandler = findNativeHandler({
        domTreeShapes: domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor: anchor
      });

      if (nativeHandler) {
        nodeThatClaimedTheSwipe = nativeHandler;
        return;
      }

      nodeThatClaimedTheSwipe = swipeInstance.current;
    } // We don't know yet.


    if (swipeInstance.current.isSwiping == null) {
      var dx = Math.abs(currentX - swipeInstance.current.startX);
      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

      if (dx > dy) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }

      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;

        if (!definitelySwiping) {
          handleBodyTouchEnd(event);
          return;
        } // Shift the starting point.


        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= swipeAreaWidth;
          } else {
            swipeInstance.current.startY -= swipeAreaWidth;
          }
        }
      }
    }

    if (!swipeInstance.current.isSwiping) {
      return;
    }

    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;

    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }

    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);

    if (open) {
      if (!swipeInstance.current.paperHit) {
        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;

        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }

    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }

    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.

    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.

    if (event.cancelable) {
      event.preventDefault();
    }

    setPosition(translate);
  });
  var handleBodyTouchStart = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (event) {
    // We are not supposed to handle this touch move.
    // Example of use case: ignore the event if there is a Slider.
    if (event.defaultPrevented) {
      return;
    } // We can only have one node at the time claiming ownership for handling the swipe.


    if (event.muiHandled) {
      return;
    } // At least one element clogs the drawer interaction zone.


    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
      return;
    }

    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (!open) {
      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
        return;
      }

      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }

    event.muiHandled = true;
    nodeThatClaimedTheSwipe = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    setMaybeSwiping(true);

    if (!open && paperRef.current) {
      // The ref may be null when a parent component updates while swiping.
      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
        changeTransition: false
      });
    }

    swipeInstance.current.velocity = 0;
    swipeInstance.current.lastTime = null;
    swipeInstance.current.lastTranslate = null;
    swipeInstance.current.paperHit = false;
    touchDetected.current = true;
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (variant === 'temporary') {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(paperRef.current);
      doc.addEventListener('touchstart', handleBodyTouchStart);
      doc.addEventListener('touchmove', handleBodyTouchMove, {
        passive: false
      });
      doc.addEventListener('touchend', handleBodyTouchEnd);
      return function () {
        doc.removeEventListener('touchstart', handleBodyTouchStart);
        doc.removeEventListener('touchmove', handleBodyTouchMove, {
          passive: false
        });
        doc.removeEventListener('touchend', handleBodyTouchEnd);
      };
    }

    return undefined;
  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      // We need to release the lock.
      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
        nodeThatClaimedTheSwipe = null;
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  var handleBackdropRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    backdropRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: variant === 'temporary' && maybeSwiping ? true : open,
    variant: variant,
    ModalProps: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, BackdropProps, {
        ref: handleBackdropRef
      })
    }, ModalPropsProp),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
      }, PaperProps.style),
      ref: paperRef
    }),
    anchor: anchor,
    transitionDuration: calculatedDurationRef.current || transitionDuration,
    onClose: onClose,
    ref: ref
  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__NoSsr__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__SwipeArea__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    anchor: anchor,
    ref: swipeAreaRef,
    width: swipeAreaWidth
  }, SwipeAreaProps))));
});
 false ? SwipeableDrawer.propTypes = {
  /**
   * @ignore
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: PropTypes.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: PropTypes.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: PropTypes.bool,

  /**
   * @ignore
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Affects how far the drawer must be opened/closed to change his state.
   * Specified as percent (0-1) of the width of the drawer
   */
  hysteresis: PropTypes.number,

  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   */
  minFlingVelocity: PropTypes.number,

  /**
   * @ignore
   */
  ModalProps: PropTypes.shape({
    BackdropProps: PropTypes.shape({
      component: elementTypeAcceptingRef
    })
  }),

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef,
    style: PropTypes.object
  }),

  /**
   * The element is used to intercept the touch events on the edge.
   */
  SwipeAreaProps: PropTypes.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: PropTypes.number,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * @ignore
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (SwipeableDrawer);

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Drawer_Drawer__ = __webpack_require__(334);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: 'auto'
    },
    anchorRight: {
      left: 'auto',
      right: 0
    },
    anchorTop: {
      bottom: 'auto',
      right: 0
    },
    anchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var SwipeArea = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SwipeArea(props, ref) {
  var anchor = props.anchor,
      classes = props.classes,
      className = props.className,
      width = props.width,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "classes", "className", "width"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["anchor".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(anchor))], className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__Drawer_Drawer__["c" /* isHorizontal */])(anchor) ? 'width' : 'height', width)
  }, other));
});
 false ? SwipeArea.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  width: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateSwipeArea'
})(SwipeArea));

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__ = __webpack_require__(331);


// @inheritedComponent IconButton








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(20px)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4,
        '&$checked': {
          transform: 'translateX(16px)'
        }
      }
    },

    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},

    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},

    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: '-100%',
      width: '300%'
    },

    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied to the track element. */
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "edge", "size"]);

  var icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.thumb
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge], size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.switchBase, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.track
  }));
});
 false ? Switch.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['end', 'start', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the switch.
   * `small` is equivalent to the dense switch styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSwitch'
})(Switch));

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unsupportedProp__ = __webpack_require__(215);










var styles = function styles(theme) {
  var _extends2;

  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, (_extends2 = {
      maxWidth: 264,
      minWidth: 72,
      position: 'relative',
      boxSizing: 'border-box',
      minHeight: 48,
      flexShrink: 0,
      padding: '6px 12px'
    }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      padding: '6px 24px'
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "overflow", 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "whiteSpace", 'normal'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "textAlign", 'center'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      minWidth: 160
    }), _extends2)),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      paddingTop: 9,
      '& $wrapper > *:first-child': {
        marginBottom: 6
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: 'none'
    },

    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.5
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    }
  };
};
var Tab = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Tab(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      fullWidth = props.fullWidth,
      icon = props.icon,
      indicator = props.indicator,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      selected = props.selected,
      selectionFollowsFocus = props.selectionFollowsFocus,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$wrapped = props.wrapped,
      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);

  var handleClick = function handleClick(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: !disableFocusRipple,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["textColor".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    tabIndex: selected ? 0 : -1
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    className: classes.wrapper
  }, icon, label), indicator);
});
 false ? Tab.propTypes = {
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  fullWidth: PropTypes.bool,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  selectionFollowsFocus: PropTypes.bool,

  /**
   * @ignore
   */
  textColor: PropTypes.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,

  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   */
  wrapped: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTab'
})(Tab));

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableContext__ = __webpack_require__(722);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent = 'table';
var Table = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'default' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__TableContext__["a" /* default */].Provider, {
    value: table
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: Component === defaultComponent ? null : 'table',
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTable'
})(Table));

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(154);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var defaultComponent = 'tbody';
var TableBody = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableBody'
})(TableBody));

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table_TableContext__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table_Tablelvl2Context__ = __webpack_require__(154);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["e" /* lighten */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.divider, 1), 0.88) : Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* darken */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__Table_TableContext__["a" /* default */]);
  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__Table_Tablelvl2Context__["a" /* default */]);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], padding !== 'default' && classes["padding".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(padding))], size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
 false ? TableCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`default`).
   */
  padding: PropTypes.oneOf(['checkbox', 'default', 'none']),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableCell'
})(TableCell));

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);






var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    overflowX: 'auto'
  }
};
var TableContainer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableContainer(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className)
  }, other));
});
 false ? TableContainer.propTypes = {
  /**
   * The table itself, normally `<Table />`
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableContainer'
})(TableContainer));

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(154);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
var tablelvl2 = {
  variant: 'footer'
};
var defaultComponent = 'tfoot';
var TableFooter = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableFooter(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableFooter.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableFooter'
})(TableFooter));

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(154);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2 = {
  variant: 'head'
};
var defaultComponent = 'thead';
var TableHead = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableHead'
})(TableHead));

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputBase__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MenuItem__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Select__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableCell__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Toolbar__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Typography__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TablePaginationActions__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_unstable_useId__ = __webpack_require__(216);















var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      overflow: 'auto',
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      minHeight: 52,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },
    // TODO v5: `.selectRoot` should be merged with `.input`

    /* Styles applied to the Select component root element. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: 'right',
      textAlignLast: 'right' // Align <select> on Chrome.

    },
    // TODO v5: remove

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {},

    /* Styles applied to the `InputBase` component. */
    input: {
      color: 'inherit',
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};

var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
  var from = _ref.from,
      to = _ref.to,
      count = _ref.count;
  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};

var defaultRowsPerPageOptions = [10, 25, 50, 100];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TablePagination(props, ref) {
  var _props$ActionsCompone = props.ActionsComponent,
      ActionsComponent = _props$ActionsCompone === void 0 ? __WEBPACK_IMPORTED_MODULE_13__TablePaginationActions__["a" /* default */] : _props$ActionsCompone,
      backIconButtonProps = props.backIconButtonProps,
      _props$backIconButton = props.backIconButtonText,
      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
      classes = props.classes,
      className = props.className,
      colSpanProp = props.colSpan,
      _props$component = props.component,
      Component = _props$component === void 0 ? __WEBPACK_IMPORTED_MODULE_10__TableCell__["a" /* default */] : _props$component,
      count = props.count,
      _props$labelDisplayed = props.labelDisplayedRows,
      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
      _props$labelRowsPerPa = props.labelRowsPerPage,
      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
      nextIconButtonProps = props.nextIconButtonProps,
      _props$nextIconButton = props.nextIconButtonText,
      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
      onChangePage = props.onChangePage,
      onChangeRowsPerPage = props.onChangeRowsPerPage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      _props$rowsPerPageOpt = props.rowsPerPageOptions,
      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
      _props$SelectProps = props.SelectProps,
      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);

  var colSpan;

  if (Component === __WEBPACK_IMPORTED_MODULE_10__TableCell__["a" /* default */] || Component === 'td') {
    colSpan = colSpanProp || 1000; // col-span over everything
  }

  var selectId = Object(__WEBPACK_IMPORTED_MODULE_14__utils_unstable_useId__["a" /* default */])();
  var labelId = Object(__WEBPACK_IMPORTED_MODULE_14__utils_unstable_useId__["a" /* default */])();
  var MenuItemComponent = SelectProps.native ? 'option' : __WEBPACK_IMPORTED_MODULE_8__MenuItem__["a" /* default */];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    colSpan: colSpan,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Toolbar__["a" /* default */], {
    className: classes.toolbar
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.spacer
  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption,
    id: labelId
  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: {
      select: classes.select,
      icon: classes.selectIcon
    },
    input: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__InputBase__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, classes.selectRoot)
    }),
    value: rowsPerPage,
    onChange: onChangeRowsPerPage,
    id: selectId,
    labelId: labelId
  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](MenuItemComponent, {
      className: classes.menuItem,
      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelDisplayedRows({
    from: count === 0 ? 0 : page * rowsPerPage + 1,
    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
    count: count === -1 ? -1 : count,
    page: page
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ActionsComponent, {
    className: classes.actions,
    backIconButtonProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      title: backIconButtonText,
      'aria-label': backIconButtonText
    }, backIconButtonProps),
    count: count,
    nextIconButtonProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      title: nextIconButtonText,
      'aria-label': nextIconButtonText
    }, nextIconButtonProps),
    onChangePage: onChangePage,
    page: page,
    rowsPerPage: rowsPerPage
  })));
});
 false ? TablePagination.propTypes = {
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   */
  ActionsComponent: PropTypes.elementType,

  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * Text label for the back arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  backIconButtonText: PropTypes.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  colSpan: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: PropTypes.number.isRequired,

  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelDisplayedRows: PropTypes.func,

  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelRowsPerPage: PropTypes.node,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Text label for the next arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  nextIconButtonText: PropTypes.string,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   */
  onChangeRowsPerPage: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(PropTypes.number.isRequired, function (props) {
    var count = props.count,
        page = props.page,
        rowsPerPage = props.rowsPerPage;

    if (count === -1) {
      return null;
    }

    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    if (page < 0 || page > newLastPage) {
      return new Error('Material-UI: The page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
    }

    return null;
  }),

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: PropTypes.array,

  /**
   * Props applied to the rows per page [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTablePagination'
})(TablePagination));

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiToolbar'
})(Toolbar));

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton__ = __webpack_require__(115);








/**
 * @ignore - internal component.
 */

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var TablePaginationActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TablePaginationActions(props, ref) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      onChangePage = props.onChangePage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleNextButtonClick,
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
});
 false ? TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: PropTypes.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TablePaginationActions);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(37);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent ? null : 'row'
  }, other));
});
 false ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableRow'
})(TableRow));

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(21);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:focus': {
        color: theme.palette.text.secondary
      },
      '&:hover': {
        color: theme.palette.text.secondary,
        '& $icon': {
          opacity: 0.5
        }
      },
      '&$active': {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        '&& $icon': {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the icon component. */
    icon: {
      fontSize: 18,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none'
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

var TableSortLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableSortLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'asc' : _props$direction,
      _props$hideSortIcon = props.hideSortIcon,
      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__["a" /* default */] : _props$IconComponent,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref: ref
  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["iconDirection".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(direction))])
  }));
});
 false ? TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: PropTypes.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The current sort direction.
   */
  direction: PropTypes.oneOf(['asc', 'desc']),

  /**
   * Hide sort icon when active is false.
   */
  hideSortIcon: PropTypes.bool,

  /**
   * Sort icon to use.
   */
  IconComponent: PropTypes.elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel));

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(45);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_debounce__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_animate__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ScrollbarSize__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TabIndicator__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TabScrollButton__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_useTheme__ = __webpack_require__(36);


















var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      display: 'flex'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: 'scroll',
      // Hide dimensionless scrollbar on MacOS
      scrollbarWidth: 'none',
      // Firefox
      '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome

      }
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
    scrollButtonsDesktop: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};
var Tabs = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Tabs(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      action = props.action,
      _props$centered = props.centered,
      centered = _props$centered === void 0 ? false : _props$centered,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$indicatorColor = props.indicatorColor,
      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
      onChange = props.onChange,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$ScrollButtonCo = props.ScrollButtonComponent,
      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? __WEBPACK_IMPORTED_MODULE_15__TabScrollButton__["a" /* default */] : _props$ScrollButtonCo,
      _props$scrollButtons = props.scrollButtons,
      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
      selectionFollowsFocus = props.selectionFollowsFocus,
      _props$TabIndicatorPr = props.TabIndicatorProps,
      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
      TabScrollButtonProps = props.TabScrollButtonProps,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_17__styles_useTheme__["a" /* default */])();
  var scrollable = variant === 'scrollable';
  var isRtl = theme.direction === 'rtl';
  var vertical = orientation === 'vertical';
  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  var start = vertical ? 'top' : 'left';
  var end = vertical ? 'bottom' : 'right';
  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
  var size = vertical ? 'height' : 'width';

  if (false) {
    if (centered && scrollable) {
      console.error('Material-UI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      mounted = _React$useState[0],
      setMounted = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]({}),
      indicatorStyle = _React$useState2[0],
      setIndicatorStyle = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]({
    start: false,
    end: false
  }),
      displayScroll = _React$useState3[0],
      setDisplayScroll = _React$useState3[1];

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]({
    overflow: 'hidden',
    marginBottom: null
  }),
      scrollerStyle = _React$useState4[0],
      setScrollerStyle = _React$useState4[1];

  var valueToIndex = new Map();
  var tabsRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var tabListRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);

  var getTabsMeta = function getTabsMeta() {
    var tabsNode = tabsRef.current;
    var tabsMeta;

    if (tabsNode) {
      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft

      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: Object(__WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__["b" /* getNormalizedScrollLeft */])(tabsNode, theme.direction),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }

    var tabMeta;

    if (tabsNode && value !== false) {
      var _children = tabListRef.current.children;

      if (_children.length > 0) {
        var tab = _children[valueToIndex.get(value)];

        if (false) {
          if (!tab) {
            console.error(["Material-UI: The value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
          }
        }

        tabMeta = tab ? tab.getBoundingClientRect() : null;
      }
    }

    return {
      tabsMeta: tabsMeta,
      tabMeta: tabMeta
    };
  };

  var updateIndicatorState = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__["a" /* default */])(function () {
    var _newIndicatorStyle;

    var _getTabsMeta = getTabsMeta(),
        tabsMeta = _getTabsMeta.tabsMeta,
        tabMeta = _getTabsMeta.tabMeta;

    var startValue = 0;

    if (tabMeta && tabsMeta) {
      if (vertical) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      } else {
        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = tabMeta.left - tabsMeta.left + correction;
      }
    }

    var newIndicatorStyle = (_newIndicatorStyle = {}, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_newIndicatorStyle, start, startValue), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);

    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);

      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });

  var scroll = function scroll(scrollValue) {
    Object(__WEBPACK_IMPORTED_MODULE_11__internal_animate__["a" /* default */])(scrollStart, tabsRef.current, scrollValue);
  };

  var moveTabsScroll = function moveTabsScroll(delta) {
    var scrollValue = tabsRef.current[scrollStart];

    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge

      scrollValue *= isRtl && Object(__WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__["a" /* detectScrollType */])() === 'reverse' ? -1 : 1;
    }

    scroll(scrollValue);
  };

  var handleStartScrollClick = function handleStartScrollClick() {
    moveTabsScroll(-tabsRef.current[clientSize]);
  };

  var handleEndScrollClick = function handleEndScrollClick() {
    moveTabsScroll(tabsRef.current[clientSize]);
  };

  var handleScrollbarSizeChange = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (scrollbarHeight) {
    setScrollerStyle({
      overflow: null,
      marginBottom: -scrollbarHeight
    });
  }, []);

  var getConditionalElements = function getConditionalElements() {
    var conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ScrollbarSize__["a" /* default */], {
      className: classes.scrollable,
      onChange: handleScrollbarSizeChange
    }) : null;
    var scrollButtonsActive = displayScroll.start || displayScroll.end;
    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ScrollButtonComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      disabled: !displayScroll.start,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ScrollButtonComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      disabled: !displayScroll.end,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    return conditionalElements;
  };

  var scrollSelectedIntoView = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__["a" /* default */])(function () {
    var _getTabsMeta2 = getTabsMeta(),
        tabsMeta = _getTabsMeta2.tabsMeta,
        tabMeta = _getTabsMeta2.tabMeta;

    if (!tabMeta || !tabsMeta) {
      return;
    }

    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart);
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);

      scroll(_nextScrollStart);
    }
  });
  var updateScrollButtonState = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__["a" /* default */])(function () {
    if (scrollable && scrollButtons !== 'off') {
      var _tabsRef$current = tabsRef.current,
          scrollTop = _tabsRef$current.scrollTop,
          scrollHeight = _tabsRef$current.scrollHeight,
          clientHeight = _tabsRef$current.clientHeight,
          scrollWidth = _tabsRef$current.scrollWidth,
          clientWidth = _tabsRef$current.clientWidth;
      var showStartScroll;
      var showEndScroll;

      if (vertical) {
        showStartScroll = scrollTop > 1;
        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
      } else {
        var scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__["b" /* getNormalizedScrollLeft */])(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.

        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
      }

      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_8__utils_debounce__["a" /* default */])(function () {
      updateIndicatorState();
      updateScrollButtonState();
    });
    var win = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(tabsRef.current);
    win.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      win.removeEventListener('resize', handleResize);
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var handleTabsScroll = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](Object(__WEBPACK_IMPORTED_MODULE_8__utils_debounce__["a" /* default */])(function () {
    updateScrollButtonState();
  }));
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      handleTabsScroll.clear();
    };
  }, [handleTabsScroll]);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    setMounted(true);
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    updateIndicatorState();
    updateScrollButtonState();
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    scrollSelectedIntoView();
  }, [scrollSelectedIntoView, indicatorStyle]);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](action, function () {
    return {
      updateIndicator: updateIndicatorState,
      updateScrollButtons: updateScrollButtonState
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var indicator = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__TabIndicator__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.indicator,
    orientation: orientation,
    color: indicatorColor
  }, TabIndicatorProps, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, indicatorStyle, TabIndicatorProps.style)
  }));
  var childIndex = 0;
  var children = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(childrenProp, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    var selected = childValue === value;
    childIndex += 1;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected: selected,
      selectionFollowsFocus: selectionFollowsFocus,
      onChange: onChange,
      textColor: textColor,
      value: childValue
    });
  });

  var handleKeyDown = function handleKeyDown(event) {
    var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
    // though we might warn in the future about nested, interactive elements
    // as a a11y violation

    var role = target.getAttribute('role');

    if (role !== 'tab') {
      return;
    }

    var newFocusTarget = null;
    var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
    var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';

    if (orientation !== "vertical" && theme.direction === 'rtl') {
      // swap previousItemKey with nextItemKey
      previousItemKey = 'ArrowRight';
      nextItemKey = 'ArrowLeft';
    }

    switch (event.key) {
      case previousItemKey:
        newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
        break;

      case nextItemKey:
        newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
        break;

      case 'Home':
        newFocusTarget = tabListRef.current.firstChild;
        break;

      case 'End':
        newFocusTarget = tabListRef.current.lastChild;
        break;

      default:
        break;
    }

    if (newFocusTarget !== null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };

  var conditionalElements = getConditionalElements();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className, vertical && classes.vertical),
    ref: ref
  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
    style: scrollerStyle,
    ref: tabsRef,
    onScroll: handleTabsScroll
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
    onKeyDown: handleKeyDown,
    ref: tabListRef,
    role: "tablist"
  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
 false ? Tabs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType,

  /**
   * The label for the Tabs as a string.
   */
  'aria-label': PropTypes.string,

  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: PropTypes.elementType,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `desktop` will only present them on medium and larger viewports.
   * - `on` will always present them.
   * - `off` will never present them.
   */
  scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'off', 'on']),

  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,

  /**
   * Props applied to the tab indicator element.
   */
  TabIndicatorProps: PropTypes.object,

  /**
   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
   */
  TabScrollButtonProps: PropTypes.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: PropTypes.any,

  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   */
  variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_13__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTabs'
})(Tabs));

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectScrollType;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNormalizedScrollLeft;
// Source from https://github.com/alitaheri/normalize-scroll-left
var cachedType;
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assiming scrollWidth=100 and direction is rtl.
 *
 * Browser        | Type          | <- Most Left | Most Right -> | Initial
 * -------------- | ------------- | ------------ | ------------- | -------
 * WebKit         | default       | 0            | 100           | 100
 * Firefox/Opera  | negative      | -100         | 0             | 0
 * IE/Edge        | reverse       | 100          | 0             | 0
 */

function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }

  var dummy = document.createElement('div');
  dummy.appendChild(document.createTextNode('ABCD'));
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';

  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;

    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }

  document.body.removeChild(dummy);
  return cachedType;
} // Based on https://stackoverflow.com/a/24394376

function getNormalizedScrollLeft(element, direction) {
  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior

  if (direction !== 'rtl') {
    return scrollLeft;
  }

  var type = detectScrollType();

  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;

    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;

    default:
      return scrollLeft;
  }
}

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animate;
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(property, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[property];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(95);





var styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

function ScrollbarSize(props) {
  var onChange = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange"]);

  var scrollbarHeight = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var nodeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var setMeasurements = function setMeasurements() {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      var prevHeight = scrollbarHeight.current;
      setMeasurements();

      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    style: styles,
    ref: nodeRef
  }, other));
}
 false ? ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(21);







var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create()
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    vertical: {
      height: '100%',
      width: 2,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var TabIndicator = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TabIndicator(props, ref) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "orientation"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], className, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other));
});
 false ? TabIndicator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: PropTypes.oneOf(['primary', 'secondary']).isRequired,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateTabIndicator'
})(TabIndicator));

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(43);



/* eslint-disable jsx-a11y/aria-role */







var styles = {
  /* Styles applied to the root element. */
  root: {
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    '&$disabled': {
      opacity: 0
    }
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    width: '100%',
    height: 40,
    '& svg': {
      transform: 'rotate(90deg)'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {}
};

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], {
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_KeyboardArrowRight__["a" /* default */], {
  fontSize: "small"
});

var TabScrollButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TabScrollButton(props, ref) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      orientation = props.orientation,
      disabled = props.disabled,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "direction", "orientation", "disabled"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "div",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
    ref: ref,
    role: null,
    tabIndex: null
  }, other), direction === 'left' ? _ref : _ref2);
});
 false ? TabScrollButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Which direction should the button indicate?
   */
  direction: PropTypes.oneOf(['left', 'right']).isRequired,

  /**
   * If `true`, the element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTabScrollButton'
})(TabScrollButton));

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Input__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilledInput__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OutlinedInput__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InputLabel__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControl__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormHelperText__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Select__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_withStyles__ = __webpack_require__(7);














var variantComponent = {
  standard: __WEBPACK_IMPORTED_MODULE_6__Input__["a" /* default */],
  filled: __WEBPACK_IMPORTED_MODULE_7__FilledInput__["a" /* default */],
  outlined: __WEBPACK_IMPORTED_MODULE_8__OutlinedInput__["a" /* default */]
};
var styles = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);

  if (false) {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__FormControl__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__InputLabel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Select__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__FormHelperText__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
 false ? TextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default value of the `input` element.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The helper text content.
   */
  helperText: PropTypes.node,

  /**
   * @ignore
   */
  hiddenLabel: PropTypes.bool,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: PropTypes.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label content.
   */
  label: PropTypes.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: PropTypes.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_13__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTextField'
})(TextField));

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* unused harmony export testReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_withStyles__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_capitalize__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Grow__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popper__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_setRef__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_useIsFocusVisible__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_useControlled__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_useTheme__ = __webpack_require__(36);





















function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  };
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none' // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: 'relative',
      margin: '0'
    },

    /* Styles applied to the arrow element. */
    arrow: {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
function testReset() {
  hystersisOpen = false;
  clearTimeout(hystersisTimer);
}
var Tooltip = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function Tooltip(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
      _props$enterNextDelay = props.enterNextDelay,
      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      idProp = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$PopperComponen = props.PopperComponent,
      PopperComponent = _props$PopperComponen === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Popper__["a" /* default */] : _props$PopperComponen,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_12__Grow__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_19__styles_useTheme__["a" /* default */])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](),
      childNode = _React$useState[0],
      setChildNode = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](null),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var ignoreNonTouchEvents = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](false);
  var closeTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var enterTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var leaveTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var touchTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_18__utils_useControlled__["a" /* default */])({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      openState = _useControlled2[0],
      setOpenState = _useControlled2[1];

  var open = openState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _React$useRef = React.useRef(openProp !== undefined),
        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks


    React.useEffect(function () {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }

  var id = Object(__WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__["a" /* default */])(idProp);
  __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
        childrenProps.onMouseOver(event);
      }

      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_17__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](false),
      childIsFocusVisible = _React$useState3[0],
      setChildIsFocusVisible = _React$useState3[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }

      var childrenProps = children.props;

      if (childrenProps.onFocus && forward) {
        childrenProps.onFocus(event);
      }
    };
  };

  var handleClose = function handleClose(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function () {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'blur') {
        if (childrenProps.onBlur && forward) {
          childrenProps.onBlur(event);
        }

        handleBlur();
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };
  };

  var detectTouchStart = function detectTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  var handleTouchStart = function handleTouchStart(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter()(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(setChildNode, ref);
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (instance) {
    // #StrictMode ready
    Object(__WEBPACK_IMPORTED_MODULE_16__utils_setRef__["a" /* default */])(handleFocusRef, __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](instance));
  }, [handleFocusRef]);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    'aria-describedby': open ? id : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, children.props, {
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });

  var interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }

  if (false) {
    if (children.props.title) {
      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
    }
  }

  var mergedPopperProps = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_utils__["a" /* deepmerge */])({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"](children, childrenProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](PopperComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.tooltip, classes["tooltipPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_capitalize__["a" /* default */])(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
 false ? Tooltip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, adds an arrow to the tooltip.
   */
  arrow: PropTypes.bool,

  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: PropTypes.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: PropTypes.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: PropTypes.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: PropTypes.number,

  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   */
  enterNextDelay: PropTypes.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: PropTypes.number,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: PropTypes.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: PropTypes.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: PropTypes.bool,

  /**
   * Tooltip placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * The component used for the popper.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: PropTypes.object,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTooltip',
  flip: false
})(Tooltip));

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




function defaultTrigger(store, options) {
  var _options$disableHyste = options.disableHysteresis,
      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
      _options$threshold = options.threshold,
      threshold = _options$threshold === void 0 ? 100 : _options$threshold,
      target = options.target;
  var previous = store.current;

  if (target) {
    // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
  }

  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }

  return store.current > threshold;
}

var defaultTarget = typeof window !== 'undefined' ? window : null;
function useScrollTrigger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$getTrigger = options.getTrigger,
      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
      _options$target = options.target,
      target = _options$target === void 0 ? defaultTarget : _options$target,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["getTrigger", "target"]);

  var store = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    return getTrigger(store, other);
  }),
      trigger = _React$useState[0],
      setTrigger = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleScroll = function handleScroll() {
      setTrigger(getTrigger(store, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        target: target
      }, other)));
    };

    handleScroll(); // Re-evaluate trigger when dependencies change

    target.addEventListener('scroll', handleScroll);
    return function () {
      target.removeEventListener('scroll', handleScroll);
    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, getTrigger, JSON.stringify(other)]);
  return trigger;
}

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withWidth__ = __webpack_require__(224);




/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server-side rendering.
 */

var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        fullScreen: Object(__WEBPACK_IMPORTED_MODULE_3__withWidth__["b" /* isWidthDown */])(breakpoint, props.width)
      }, props));
    }

     false ? WithMobileDialog.propTypes = {
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : void 0;
    return Object(__WEBPACK_IMPORTED_MODULE_3__withWidth__["a" /* default */])()(WithMobileDialog);
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (withMobileDialog);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(32);










var styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/components/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Zoom(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["a" /* Transition */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        transform: 'scale(0)',
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Zoom.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Zoom);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CardImage=function CardImage(_ref){var cardUri=_ref.cardUri;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:cardUri,width:'360px',height:'504px'}));};/* harmony default export */ __webpack_exports__["a"] = (CardImage);

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var About=function About(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'About Me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I am a Boston-based web developer with a passion for technology and entertainment. I first started playing Magic when I was young and got my hands on a Mirrodin (I think?) starter deck. I didn\'t know how to play, but I enjoyed looking at the cards and putting them in imaginary situations. Now I play Commander/EDH regularly with my friends. I am a huge fan of green. The decks I currently have are ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/36d4574a-3266-4497-b145-fb25820d8a7f'},'Goreclaw, Terror of Qal Sisma'),'; ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/d85783d6-bbaf-4720-8151-5083de1e9f55'},'Roalesk, Apex Hybrid'),'; ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/623ec8c3-9173-4dc8-bd93-0b22d852fa60'},'Reki, the History of Kamigawa'),'; and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/card/dd1e21f6-2314-469e-b80e-8678c960c09e'},'Gishath, Sun\'s Avatar'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I had been thinking of a quarantine project to sink my teeth into for a while and ended up landing on this idea. I love looking at stats, and knew that this project would take a lot of time and learning. I\'m hoping to run into issues that will make me a more versatile developer, of which there have aleady been a few.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'I hope that you enjoy using my site! I am working as much as I can without going crazy to get this off the ground. If you want to contact me, you can do that through ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://linkedin.com/in/michael-casey-tripp/'},'LinkedIn'),', you can check out other things I am doing on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://github.com/mctripp/'},'GitHub'),', and if you want to learn other things about me for some weird reason, here is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://mctripp.github.io/'},'my portfolio'),'.'));};/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

var e,t=["scroll","wheel","touchstart","touchmove","touchenter","touchend","touchleave","mouseout","mouseleave","mouseup","mousedown","mousemove","mouseenter","mousewheel","mouseover"];if(function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}()){var o=EventTarget.prototype.addEventListener;e=o,EventTarget.prototype.addEventListener=function(o,r,n){var s,a="object"==typeof n&&null!==n,i=a?n.capture:n;(n=a?function(e){var t=Object.getOwnPropertyDescriptor(e,"passive");return t&&!0!==t.writable&&void 0===t.set?Object.assign({},e):e}(n):{}).passive=void 0!==(s=n.passive)?s:-1!==t.indexOf(o)&&!0,n.capture=void 0!==i&&i,e.call(this,o,r,n)},EventTarget.prototype.addEventListener._original=e}
//# sourceMappingURL=index.module.js.map


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.8d0eea48.js